webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1101), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(562);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1103);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1107);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperties = __webpack_require__(1054);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _freeze = __webpack_require__(237);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (strings, raw) {
  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
    raw: {
      value: (0, _freeze2.default)(raw)
    }
  }));
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(184), __webpack_require__(1057)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(105);
var hide = __webpack_require__(87);
var redefine = __webpack_require__(88);
var ctx = __webpack_require__(106);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(110);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(256);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["l" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(980), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../locale-data/index.js (ignored)
var locale_data_ignored_ = __webpack_require__(1035);
var locale_data_ignored__default = /*#__PURE__*/__webpack_require__.n(locale_data_ignored_);

// EXTERNAL MODULE: ./node_modules/intl-messageformat/index.js
var intl_messageformat = __webpack_require__(555);
var intl_messageformat_default = /*#__PURE__*/__webpack_require__.n(intl_messageformat);

// EXTERNAL MODULE: ./node_modules/intl-relativeformat/index.js
var intl_relativeformat = __webpack_require__(1044);
var intl_relativeformat_default = /*#__PURE__*/__webpack_require__.n(intl_relativeformat);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(136);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(57);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/intl-format-cache/lib/index.js
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ var lib = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/react-intl/lib/index.es.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return index_es_IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return index_es_FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return index_es_FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return index_es_FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return index_es_FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return index_es_FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return index_es_FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return index_es_FormattedHTMLMessage; });
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      intl_messageformat_default.a.__addLocaleData(localeData);
      intl_relativeformat_default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(intl_messageformat_default.a.__localeData__[normalizedLocale] && intl_relativeformat_default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = prop_types_default.a.bool;
var number = prop_types_default.a.number;
var string = prop_types_default.a.string;
var func = prop_types_default.a.func;
var object = prop_types_default.a.object;
var oneOf = prop_types_default.a.oneOf;
var shape = prop_types_default.a.shape;
var any = prop_types_default.a.any;
var oneOfType = prop_types_default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function index_es_escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  browser_default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        browser_default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return react_default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(react["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return hoist_non_react_statics_cjs_default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return intl_messageformat_default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return intl_messageformat_default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = intl_relativeformat_default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function index_es_formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function index_es_formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function index_es_formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, intl_relativeformat_default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function index_es_formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function index_es_formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  browser_default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function index_es_formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? index_es_escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var index_es_format = Object.freeze({
	formatDate: index_es_formatDate,
	formatTime: index_es_formatTime,
	formatRelative: index_es_formatRelative,
	formatNumber: index_es_formatNumber,
	formatPlural: index_es_formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: index_es_formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var index_es_IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    browser_default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: lib(Intl.DateTimeFormat),
      getNumberFormat: lib(Intl.NumberFormat),
      getMessageFormat: lib(intl_messageformat_default.a),
      getRelativeFormat: lib(intl_relativeformat_default.a),
      getPluralFormat: lib(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = index_es_format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return react["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(react["Component"]);

index_es_IntlProvider.displayName = 'IntlProvider';
index_es_IntlProvider.contextTypes = {
  intl: intlShape
};
index_es_IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? index_es_IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(react["Component"]);

index_es_FormattedDate.displayName = 'FormattedDate';
index_es_FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(react["Component"]);

index_es_FormattedTime.displayName = 'FormattedTime';
index_es_FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var index_es_FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(react["Component"]);

index_es_FormattedRelative.displayName = 'FormattedRelative';
index_es_FormattedRelative.contextTypes = {
  intl: intlShape
};
index_es_FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? index_es_FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(react["Component"]);

index_es_FormattedNumber.displayName = 'FormattedNumber';
index_es_FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? index_es_FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return react_default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(react["Component"]);

index_es_FormattedPlural.displayName = 'FormattedPlural';
index_es_FormattedPlural.contextTypes = {
  intl: intlShape
};
index_es_FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? index_es_FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: lib(intl_messageformat_default.a) }, descriptor, values);
};

var index_es_FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? index_es_defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(react["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return react["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(react["Component"]);

index_es_FormattedMessage.displayName = 'FormattedMessage';
index_es_FormattedMessage.contextTypes = {
  intl: intlShape
};
index_es_FormattedMessage.defaultProps = {
  values: {}
};
 false ? index_es_FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var index_es_FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return react_default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(react["Component"]);

index_es_FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
index_es_FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
index_es_FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? index_es_FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(locale_data_ignored__default.a);




/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(983);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/chainPropTypes.js
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(255);

// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js


function isPlainObject(item) {
  return item && Object(esm_typeof["a" /* default */])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(esm_extends["a" /* default */])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/elementAcceptingRef.js



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = chainPropTypes(prop_types_default.a.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(prop_types_default.a.element.isRequired, acceptingRef);
/* harmony default export */ var esm_elementAcceptingRef = (elementAcceptingRef);
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/elementTypeAcceptingRef.js



function elementTypeAcceptingRef_isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !elementTypeAcceptingRef_isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* harmony default export */ var esm_elementTypeAcceptingRef = (chainPropTypes(prop_types["elementType"], elementTypeAcceptingRef));
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59);

// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/exactProp.js


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(esm_extends["a" /* default */])({}, propTypes, Object(defineProperty["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(100);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/getDisplayName.js

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(esm_typeof["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case react_is["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case react_is["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/HTMLElementType.js
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/ponyfillGlobal.js
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* harmony default export */ var ponyfillGlobal = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/refType.js

var refType = prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.object]);
/* harmony default export */ var esm_refType = (refType);
// CONCATENATED MODULE: ./node_modules/@material-ui/utils/esm/index.js
/* unused concated harmony import chainPropTypes */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return chainPropTypes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return deepmerge; });
/* unused concated harmony import elementAcceptingRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_elementAcceptingRef; });
/* unused concated harmony import elementTypeAcceptingRef */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_elementTypeAcceptingRef; });
/* unused concated harmony import exactProp */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return exactProp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return formatMuiErrorMessage; });
/* unused concated harmony import getDisplayName */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getDisplayName; });
/* unused concated harmony import HTMLElementType */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return HTMLElementType; });
/* unused concated harmony import ponyfillGlobal */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ponyfillGlobal; });
/* unused concated harmony import refType */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_refType; });
/** @license Material-UI v4.11.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.windowLocation = exports.simpleMDEOptions = undefined;

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

var _trunc = __webpack_require__(998);

var _trunc2 = _interopRequireDefault(_trunc);

exports.checkHttpStatus = checkHttpStatus;
exports.getApiHeaders = getApiHeaders;
exports.getApiHeadersFromToken = getApiHeadersFromToken;
exports.getLoggingToken = getLoggingToken;
exports.getLoggingProjectId = getLoggingProjectId;
exports.getBaseUrl = getBaseUrl;
exports.getApiBaseUrlWithOrg = getApiBaseUrlWithOrg;
exports.getApiBaseUrl = getApiBaseUrl;
exports.isLocalHost = isLocalHost;
exports.isNullOrEmpty = isNullOrEmpty;
exports.getWindowLocationHostname = getWindowLocationHostname;
exports.getImageNameFromUrl = getImageNameFromUrl;
exports.dataUriToBlob = dataUriToBlob;
exports.findPos = findPos;
exports.parseJSON = parseJSON;
exports.getClassNameFromText = getClassNameFromText;
exports.displayNumberRoundedToTenth = displayNumberRoundedToTenth;
exports.displayNumberAsPercentage = displayNumberAsPercentage;
exports.toFormData = toFormData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function getApiHeaders(state) {
  return getApiHeadersFromToken(state.user.token);
}

function getApiHeadersFromToken(token) {
  return {
    Authorization: 'Token token="' + token + '"',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
}

var simpleMDEOptions = exports.simpleMDEOptions = {
  autofocus: true,
  hideIcons: ['fullscreen', 'side-by-side', 'code', 'horizontal-rule', 'quote', 'heading', 'ordered-list'],
  status: false,
  placeholder: 'Type your comment here.'

  /* istanbul ignore next */
};function getLoggingToken() {
  // TODO: base this off config/build
  var token = '5c5285ef844af9d1a54ca7f98b3f644f';

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      token = 'ee64ef89c5c3c2ea8bdd83b72f503e2f';
      break;
    case 'questmaker.questforward.org':
      token = 'ee64ef89c5c3c2ea8bdd83b72f503e2f';
      break;
  }

  return token;
}

/* istanbul ignore next */
function getLoggingProjectId() {
  // TODO: base this off config/build
  var projectId = 1;

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      projectId = 2;
      break;
    case 'questmaker.questforward.org':
      projectId = 2;
      break;
  }

  return projectId;
}

/* istanbul ignore next */
function getBaseUrl() {
  // TODO: base this off config/build
  var baseUrl = 'https://opportunity-quest-test.herokuapp.com';

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      baseUrl = 'https://oefngl.net';
      break;
    case 'questmaker.questforward.org':
      baseUrl = 'https://oefngl.net';
      break;
  }

  return baseUrl;
}

function getApiBaseUrlWithOrg(orgId) {
  return getBaseUrl() + ('/quest_maker/api/organizations/' + orgId);
}

function getApiBaseUrl() {
  return getBaseUrl() + '/quest_maker/api/organizations/';
}

/* istanbul ignore next */
function isLocalHost() {
  var hostname = window.location.hostname;
  return !!(hostname === 'localhost' || hostname === '[::1]' || hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
}

function isNullOrEmpty(val) {
  return !val || val === '';
}

/* istanbul ignore next */
function getWindowLocationHostname() {
  return windowLocation.hostname;
}

var windowLocation = {
  hostname: window.location.hostname
};

exports.windowLocation = windowLocation;
function getImageNameFromUrl(url) {
  return url ? url.split('/').pop() : '';
}

/* istanbul ignore next */
function dataUriToBlob(uri) {
  var hasArrayBufferView = new Blob([new Uint8Array(100)]).size === 100;
  var data = uri.split(',')[1];
  var bytes = typeof atob === 'undefined' ? window.atob(data) : atob(data);
  var buf = new ArrayBuffer(bytes.length);
  var arr = new Uint8Array(buf);
  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }

  if (!hasArrayBufferView) {
    arr = buf;
  }
  var blob = new Blob([arr], { type: uri.split(';')[0].slice(5) });
  blob.slice = blob.slice || blob.webkitSlice;
  return blob;
}

// For finding position of newly added related quest for scroll
/* istanbul ignore next */
function findPos(obj) {
  var curtop = 0;
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop;
    } while (obj === obj.offsetParent);

    return [curtop + obj.scrollHeight * 0.7];
  }
}

/* istanbul ignore next */
function parseJSON(response) {
  // .json() is part of isomorphic-fetch responses
  return response.json();
}

function getClassNameFromText(text) {
  return text.toLowerCase().replace(/ /g, '-').replace(/[()]/g, '');
}

function displayNumberRoundedToTenth(number) {
  return parseFloat(number).toFixed(1);
}

function displayNumberAsPercentage(number) {
  return (0, _trunc2.default)(parseInt(number)) + '%';
}

// based on https://gist.github.com/ghinda/8442a57f22099bdb2e34
function toFormData(obj, form, namespace) {
  var fd = form || new FormData();
  var formKey = void 0;

  for (var property in obj) {
    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (obj[property] instanceof Array) {
        formKey = formKey + '[][value]';
        obj[property].forEach(function (element) {
          fd.append(formKey, element.value);
        });
      } else if ((0, _typeof3.default)(obj[property]) === 'object' && !(obj[property] instanceof File)) {
        toFormData(obj[property], fd, formKey);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.questGoal = exports.positive = exports.neutralModeratelyPostive = exports.neutralSlightlyPositive = exports.neutral = exports.neutralSlightlyNegative = exports.neutralModeratelyNegative = exports.negative = exports.collegeOrUniversityGraduateOrAbove = exports.postsecondaryUndergraduateUniversity = exports.secondaryHighSchool = exports.primaryMiddleSchool = exports.primaryElementarySchool = exports.thisDataIsNotCurrentlyAvailable = exports.averageGradeLevel = exports.specificObjective = exports.targetedFor = exports.targetGradeLevel = exports.newPassword = exports.returnToLogin = exports.clickToHidePassword = exports.clickToShowPassword = exports.ok = exports.longestWait = exports.newest = exports.hoursAbbr = exports.hourAbbr = exports.minutesAbbr = exports.assignedTo = exports.ago = exports.usingThe = exports.afterTheInternalProcessIsComplete = exports.allQuestsAreEvaluated = exports.you = exports.returned = exports.assigned = exports.send = exports.reviewer = exports.approve = exports.questsNeedToBeReviewed = exports.questQualityReviewGuidelines = exports.by = exports.designedBy = exports.quest = exports.yourSearch = exports.matches = exports.match = exports.reviewReturned = exports.inQualityReview = exports.primarySubject = exports.edited = exports.on = exports.lastSaved = exports.externalReviewer = exports.copyEditor = exports.decline = exports.search = exports.published = exports.internalReview = exports.draft = exports.quests = exports.otherQuests = exports.subjectReview = exports.standardsReview = exports.experienceReview = exports.belowToFind = exports.pleaseRead = exports.needsEdits = exports.approved = exports.nameCantBeBlank = exports.internalReviewInProgress = exports.inProgress = exports.submitForReviewAgain = exports.older = undefined;
exports.hidePrevious = exports.reviews = exports.editQuest = exports.submitForReview = exports.beganThisReviewOn = exports.beginReview = exports.oeReview = exports.final = exports.standards = exports.copy = exports.subject = exports.experience = exports.cancelReview = exports.submit = exports.artifactDescription = exports.imagesMessage = exports.questReview = exports.otherInformation = exports.activitiesMessage = exports.basicInformation = exports.uploadAFile = exports.version = exports.incomplete = exports.complete = exports.resolved = exports.show = exports.hide = exports.commentsMessage = exports.commentMessage = exports.addAComment = exports.atLeastTwoActivities = exports.sourceOfTheImage = exports.optional = exports.saved = exports.topicsAndStandards = exports.citation = exports.none = exports.youMayAlsoLike = exports.tags = exports.authors = exports.assessmentQuestions = exports.uploadFileForMentors = exports.notesForMentors = exports.mentors = exports.justFor = exports.addResource = exports.activityResources = exports.requiresArtifact = exports.no = exports.yes = exports.descriptionMessage = exports.activityGoals = exports.title = exports.uploadedFile = exports.saveFile = exports.fileDescription = exports.remove = exports.provideCitation = exports.youreDone = exports.attributionAndNoncommercial = exports.license = exports.copyrightHolder = exports.attributionOutsideOrg = exports.attributionInsideOrg = exports.attribution = exports.videoTypeWarning = exports.resourceFile = exports.urlInvalid = exports.urlMessage = exports.fileMessage = exports.link = exports.formatMessage = exports.resourceTypeMessage = exports.resourceDescriptionMessage = exports.credibleResource = exports.fieldRequired = exports.name = exports.more = exports.supplemental = exports.direct = exports.days = exports.day = exports.needs = exports.need = exports.subtopics = exports.activities = exports.activity = exports.oeReviewer = exports.internalReviewer = exports.publisher = exports.questDesigner = exports.review = exports.passwordsDoNotMatch = exports.photo = exports.cancel = exports.save = exports.forgotYourPassword = exports.signIn = exports.password = exports.email = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// store FormattedMessages here that will be used multiple places
var email = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Email', defaultMessage: 'Email' });
var password = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Password', defaultMessage: 'Password' });
var signIn = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SignIn', defaultMessage: 'Sign In' });
var forgotYourPassword = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ForgotYourPassword',
  defaultMessage: 'Forgot your password?'
});
var save = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Save', defaultMessage: 'Save' });
var cancel = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Cancel', defaultMessage: 'Cancel' });
var photo = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Photo', defaultMessage: 'Photo' });
var passwordsDoNotMatch = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'PasswordsDoNotMatch',
  defaultMessage: 'Passwords do not match.'
});
var review = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Review', defaultMessage: 'Review' });
var questDesigner = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'QuestDesigner', defaultMessage: 'Quest Designer' });
var publisher = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Publisher', defaultMessage: 'Publisher' });
var internalReviewer = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'InternalReviewer',
  defaultMessage: 'Internal Reviewer'
});
var oeReviewer = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'OeReviewer', defaultMessage: 'Publication Reviewer' });
var activity = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Activity', defaultMessage: ' Activity' });
var activities = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Activities', defaultMessage: ' Activities' });
var subtopics = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Subtopics', defaultMessage: 'SUBTOPICS' });
var need = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Need', defaultMessage: 'Need' });
var needs = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Needs', defaultMessage: 'Needs' });
var day = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Day', defaultMessage: 'day' });
var days = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Days', defaultMessage: 'days' });
var direct = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Direct', defaultMessage: 'Direct' });
var supplemental = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Supplemental', defaultMessage: 'Supplemental' });
var more = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'More', defaultMessage: 'more' });
var name = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Name', defaultMessage: 'Name' });
var fieldRequired = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'FieldRequired',
  defaultMessage: 'This field is required.'
});
var credibleResource = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityResource.Credible',
  defaultMessage: 'Is this resource credible and high-quality? For more information on selecting good resources see the '
});
var resourceDescriptionMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityResource.Description',
  defaultMessage: 'Resource Description'
});
var resourceTypeMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityResource.Type',
  defaultMessage: 'Resource Type'
});
var formatMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Format', defaultMessage: 'Format' });
var link = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Link', defaultMessage: 'Link' });
var fileMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'File', defaultMessage: 'File' });
var urlMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'URL', defaultMessage: 'URL' });
var urlInvalid = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'URLInvalid',
  defaultMessage: 'URL is invalid. Please ensure the URL contains either http:// or https://.'
});
var resourceFile = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityResource.ResourceFile',
  defaultMessage: 'Resource File'
});
var videoTypeWarning = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'VideoTypeWarning',
  defaultMessage: 'Videos must be .3gp, .mp4, .mkv, or .webm.'
});
var attribution = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Attribution', defaultMessage: 'Attribution' });
var attributionInsideOrg = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Attribution.InsideOrg',
  defaultMessage: 'I or someone in my organization made this resource.'
});
var attributionOutsideOrg = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Attribution.OutsideOrg',
  defaultMessage: 'Someone outside my organization made this resource.'
});
var copyrightHolder = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'CopyrightHolder',
  defaultMessage: 'Copyright Holder'
});
var license = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'License', defaultMessage: 'License' });
var attributionAndNoncommercial = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'AttributionAndNoncommercial',
  defaultMessage: 'Attribution + Noncommercial'
});
var youreDone = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'YoureDone', defaultMessage: "You're done!" });
var provideCitation = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityResource.ProvideCitation',
  defaultMessage: 'Provide a citation for this resource: '
});
var remove = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Remove', defaultMessage: 'Remove' });
var fileDescription = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'FileDescription',
  defaultMessage: 'File Description'
});
var saveFile = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SaveFile', defaultMessage: 'Save File' });
var uploadedFile = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'UploadedFile', defaultMessage: 'Uploaded File ' });
var title = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Title', defaultMessage: 'Title ' });
var activityGoals = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Activity.Goals', defaultMessage: 'Activity Goals ' });
var descriptionMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Description', defaultMessage: 'Description ' });
var yes = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Yes', defaultMessage: 'Yes' });
var no = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No', defaultMessage: 'No' });
var requiresArtifact = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Activity.RequiresArtifact',
  defaultMessage: 'Requires Artifact?'
});
var activityResources = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Activity.ActivityResources',
  defaultMessage: 'Activity Resources'
});
var addResource = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityEdit.AddResource',
  defaultMessage: 'Add Resource'
});
var justFor = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'JustFor', defaultMessage: 'Just For ' });
var mentors = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Mentors', defaultMessage: 'MENTORS' });
var notesForMentors = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Activity.NotesForMentors',
  defaultMessage: 'Notes for Mentors'
});
var uploadFileForMentors = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityEdit.UploadMentorFile',
  defaultMessage: 'Upload a File For Mentors'
});
var assessmentQuestions = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Activity.AssessmentQuestions',
  defaultMessage: 'Assessment Questions for Mentors'
});
var authors = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Authors', defaultMessage: 'Authors' });
var tags = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Tags', defaultMessage: 'Tags' });
var youMayAlsoLike = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'YouMayAlsoLike',
  defaultMessage: 'You May Also Like...'
});
var none = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'None', defaultMessage: 'None' });
var citation = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Citation', defaultMessage: 'Citation' });
var topicsAndStandards = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'TopicsAndStandards',
  defaultMessage: 'Topics & Standards'
});
var saved = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Saved', defaultMessage: 'Saved' });
var optional = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Optional', defaultMessage: 'Optional' });
var sourceOfTheImage = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SourceOfTheImage',
  defaultMessage: 'source of the image (url)'
});
var atLeastTwoActivities = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Quest.NoActivities.AtLeastTwoActivities',
  defaultMessage: 'At least one activity is required to publish your quest!'
});
var addAComment = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AddAComment', defaultMessage: 'Add A Comment' });
var commentMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Comment', defaultMessage: 'Comment' });
var commentsMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Comments', defaultMessage: 'Comments' });
var hide = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Hide', defaultMessage: 'Hide' });
var show = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Show', defaultMessage: 'Show' });
var resolved = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Resolved', defaultMessage: 'Resolved' });
var complete = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Complete', defaultMessage: 'Complete' });
var incomplete = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Incomplete', defaultMessage: 'Incomplete' });
var version = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Version', defaultMessage: 'Version' });
var uploadAFile = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityEdit.UploadAFile',
  defaultMessage: 'Upload a file '
});
var basicInformation = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'BasicInformation',
  defaultMessage: 'Basic Information'
});
var activitiesMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Activities', defaultMessage: 'Activities' });
var otherInformation = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'OtherInformation',
  defaultMessage: 'Other Information'
});
var questReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'QuestReview', defaultMessage: 'Quest Review' });
var imagesMessage = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Images', defaultMessage: 'Images' });
var artifactDescription = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ActivityEdit.ArtifactDescription',
  defaultMessage: 'Artifact Description'
});
var submit = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Submit', defaultMessage: 'Submit' });
var cancelReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'CancelReview', defaultMessage: 'Cancel Review' });
var experience = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Experience', defaultMessage: 'Experience' });
var subject = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Subject', defaultMessage: 'Subject' });
var copy = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Copy', defaultMessage: 'Copy' });
var standards = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Standards', defaultMessage: 'Standards' });
var final = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Final', defaultMessage: 'Final' });
var oeReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'OEReview', defaultMessage: 'Publication Review' });
var beginReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'BeginReview', defaultMessage: 'Begin Review' });
var beganThisReviewOn = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'BeganThisReviewOn',
  defaultMessage: 'began this review on'
});
var submitForReview = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SubmitForReview',
  defaultMessage: 'Submit for Review'
});
var editQuest = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'EditQuest', defaultMessage: 'Edit Quest' });
var reviews = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Reviews', defaultMessage: 'Reviews' });
var hidePrevious = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'HidePrevous', defaultMessage: 'Hide Previous' });
var older = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Older', defaultMessage: 'older' });
var submitForReviewAgain = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SubmitForReviewAgain',
  defaultMessage: 'Submit for Review Again'
});
var inProgress = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'InProgress', defaultMessage: 'In Progress' });
var internalReviewInProgress = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'InternalReviewInProgress',
  defaultMessage: 'Internal Review in Progress'
});
var nameCantBeBlank = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'NameCantBeBlank',
  defaultMessage: "Name can't be blank"
});
var approved = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Approved', defaultMessage: 'Approved' });
var approve = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Approve', defaultMessage: 'Approve' });
var needsEdits = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NeedsEdits', defaultMessage: 'Needs Edits' });
var pleaseRead = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PleaseReadThe', defaultMessage: 'Please read the ' });
var belowToFind = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'BelowToFind',
  defaultMessage: ' below to find out what this quest needs to move forward.'
});
var experienceReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ExperienceReview', defaultMessage: 'experience' });
var standardsReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'StandardsReview', defaultMessage: 'standards' });
var subjectReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'SubjectReview', defaultMessage: 'subject' });
var otherQuests = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'OtherQuests', defaultMessage: 'Other Quests' });
var quests = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Quests', defaultMessage: 'Quests' });
var draft = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Draft', defaultMessage: 'Draft' });
var internalReview = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'InternalReview', defaultMessage: 'Internal Review' });
var published = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Published', defaultMessage: 'Published' });
var search = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Search', defaultMessage: 'Search' });
var decline = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Policies.Decline', defaultMessage: 'DECLINE' });
var copyEditor = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'CopyEditor', defaultMessage: 'Copy Editor' });
var externalReviewer = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ExternalReviewer', defaultMessage: 'External Reviewer' });
var lastSaved = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'LastSaved', defaultMessage: 'Last saved on' });
var on = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'on', defaultMessage: 'on' });
var edited = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Edited', defaultMessage: '(edited)' });
var primarySubject = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PrimarySubject', defaultMessage: 'Primary Subject' });
var inQualityReview = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'InQualityReview',
  defaultMessage: 'In Publication Review'
});
var reviewReturned = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ReviewReturned', defaultMessage: 'Review Returned' });
var match = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Match', defaultMessage: 'match' });
var matches = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Matches', defaultMessage: 'matches' });
var yourSearch = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'YourSearch', defaultMessage: 'your search' });
var quest = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Quest', defaultMessage: 'quest' });
var designedBy = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'DesignedBy', defaultMessage: 'Designed by' });
var by = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'By', defaultMessage: 'by' });
var questQualityReviewGuidelines = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'QuestQualityReviewGuidelines',
  defaultMessage: 'Quest Publication Review Guidelines'
});
var questsNeedToBeReviewed = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'InternalReview.QuestsNeedToBeReviewed',
  defaultMessage: 'Quests need to be reviewed by members of your organization for experience, subject matter, and quality of copy before they can move forward.'
});
var reviewer = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Reviewer', defaultMessage: 'Reviewer' });
var send = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Send', defaultMessage: 'Send' });
var assigned = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'AssignedThisQuest',
  defaultMessage: 'assigned this quest to'
});
var returned = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ReturnedThisQuest',
  defaultMessage: 'returned this quest to'
});
var you = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'You', defaultMessage: 'You' });
var allQuestsAreEvaluated = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'AllQuestsAreEvaluated',
  defaultMessage: 'All quests are evaluated by the publication review team'
});
var afterTheInternalProcessIsComplete = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'AfterTheInternalProcessIsComplete',
  defaultMessage: 'after the internal process is complete'
});
var usingThe = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'UsingThe', defaultMessage: 'using the' });
var ago = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Ago', defaultMessage: 'ago' });
var assignedTo = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'AssignedTo', defaultMessage: 'Assigned to' });
var minutesAbbr = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'MinutesAbbr', defaultMessage: 'min' });
var hourAbbr = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'HourAbbr', defaultMessage: 'hr' });
var hoursAbbr = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'HoursAbbr', defaultMessage: 'hrs' });
var newest = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Newest', defaultMessage: 'Newest' });
var longestWait = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Queue.LongestWait', defaultMessage: 'Longest Wait' });
var ok = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Ok', defaultMessage: 'OK' });
var clickToShowPassword = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ClickToShowPassword',
  defaultMessage: 'Click to show password'
});
var clickToHidePassword = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ClickToHidePassword',
  defaultMessage: 'Click to hide password'
});
var returnToLogin = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ForgotPassword.ReturnToLogin',
  defaultMessage: 'Return to Login'
});
var newPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'NewPassword', defaultMessage: 'New Password' });
var targetGradeLevel = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TargetGradeLevel', defaultMessage: 'Target Grade' });
var targetedFor = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'TargetedFor', defaultMessage: 'Targeted for' });
var specificObjective = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SpecificObjective',
  defaultMessage: 'Specific Objective'
});
var averageGradeLevel = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'AverageGradeLevel',
  defaultMessage: 'Average Grade Level'
});
var thisDataIsNotCurrentlyAvailable = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ThisDataIsNotCurrentlyAvailable',
  defaultMessage: 'This data is not currently available.'
});
var primaryElementarySchool = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.PrimaryElementarySchool',
  defaultMessage: 'Primary/Elementary School'
});
var primaryMiddleSchool = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.PrimaryMiddleSchool',
  defaultMessage: 'Primary/Middle School'
});
var secondaryHighSchool = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.SecondaryHighSchool',
  defaultMessage: 'Secondary/High School'
});
var postsecondaryUndergraduateUniversity = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.PostsecondaryUndergraduateUniversity',
  defaultMessage: 'Postsecondary/Undergraduate University'
});
var collegeOrUniversityGraduateOrAbove = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.CollegeOrUniversityGraduateOrAbove',
  defaultMessage: 'College or University Graduate or above'
});
var negative = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Readability.Negative', defaultMessage: 'Negative' });
var neutralModeratelyNegative = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.NeutralModeratelyNegative',
  defaultMessage: 'Neutral (Moderately Negative)'
});
var neutralSlightlyNegative = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.NeutralSlightlyNegative',
  defaultMessage: 'Neutral (Slightly Negative)'
});
var neutral = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Readability.Neutral', defaultMessage: 'Neutral' });
var neutralSlightlyPositive = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.NeutralSlightlyPositive',
  defaultMessage: 'Neutral (Slightly Positive)'
});
var neutralModeratelyPostive = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'Readability.NeutralModeratelyPostive',
  defaultMessage: 'Neutral (Moderately Positive)'
});
var positive = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Readability.Positive', defaultMessage: 'Positive' });
var questGoal = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'QuestGoal', defaultMessage: 'Quest Goal' });

exports.email = email;
exports.password = password;
exports.signIn = signIn;
exports.forgotYourPassword = forgotYourPassword;
exports.save = save;
exports.cancel = cancel;
exports.photo = photo;
exports.passwordsDoNotMatch = passwordsDoNotMatch;
exports.review = review;
exports.questDesigner = questDesigner;
exports.publisher = publisher;
exports.internalReviewer = internalReviewer;
exports.oeReviewer = oeReviewer;
exports.activity = activity;
exports.activities = activities;
exports.subtopics = subtopics;
exports.need = need;
exports.needs = needs;
exports.day = day;
exports.days = days;
exports.direct = direct;
exports.supplemental = supplemental;
exports.more = more;
exports.name = name;
exports.fieldRequired = fieldRequired;
exports.credibleResource = credibleResource;
exports.resourceDescriptionMessage = resourceDescriptionMessage;
exports.resourceTypeMessage = resourceTypeMessage;
exports.formatMessage = formatMessage;
exports.link = link;
exports.fileMessage = fileMessage;
exports.urlMessage = urlMessage;
exports.urlInvalid = urlInvalid;
exports.resourceFile = resourceFile;
exports.videoTypeWarning = videoTypeWarning;
exports.attribution = attribution;
exports.attributionInsideOrg = attributionInsideOrg;
exports.attributionOutsideOrg = attributionOutsideOrg;
exports.copyrightHolder = copyrightHolder;
exports.license = license;
exports.attributionAndNoncommercial = attributionAndNoncommercial;
exports.youreDone = youreDone;
exports.provideCitation = provideCitation;
exports.remove = remove;
exports.fileDescription = fileDescription;
exports.saveFile = saveFile;
exports.uploadedFile = uploadedFile;
exports.title = title;
exports.activityGoals = activityGoals;
exports.descriptionMessage = descriptionMessage;
exports.yes = yes;
exports.no = no;
exports.requiresArtifact = requiresArtifact;
exports.activityResources = activityResources;
exports.addResource = addResource;
exports.justFor = justFor;
exports.mentors = mentors;
exports.notesForMentors = notesForMentors;
exports.uploadFileForMentors = uploadFileForMentors;
exports.assessmentQuestions = assessmentQuestions;
exports.authors = authors;
exports.tags = tags;
exports.youMayAlsoLike = youMayAlsoLike;
exports.none = none;
exports.citation = citation;
exports.topicsAndStandards = topicsAndStandards;
exports.saved = saved;
exports.optional = optional;
exports.sourceOfTheImage = sourceOfTheImage;
exports.atLeastTwoActivities = atLeastTwoActivities;
exports.addAComment = addAComment;
exports.commentMessage = commentMessage;
exports.commentsMessage = commentsMessage;
exports.hide = hide;
exports.show = show;
exports.resolved = resolved;
exports.complete = complete;
exports.incomplete = incomplete;
exports.version = version;
exports.uploadAFile = uploadAFile;
exports.basicInformation = basicInformation;
exports.activitiesMessage = activitiesMessage;
exports.otherInformation = otherInformation;
exports.questReview = questReview;
exports.imagesMessage = imagesMessage;
exports.artifactDescription = artifactDescription;
exports.submit = submit;
exports.cancelReview = cancelReview;
exports.experience = experience;
exports.subject = subject;
exports.copy = copy;
exports.standards = standards;
exports.final = final;
exports.oeReview = oeReview;
exports.beginReview = beginReview;
exports.beganThisReviewOn = beganThisReviewOn;
exports.submitForReview = submitForReview;
exports.editQuest = editQuest;
exports.reviews = reviews;
exports.hidePrevious = hidePrevious;
exports.older = older;
exports.submitForReviewAgain = submitForReviewAgain;
exports.inProgress = inProgress;
exports.internalReviewInProgress = internalReviewInProgress;
exports.nameCantBeBlank = nameCantBeBlank;
exports.approved = approved;
exports.needsEdits = needsEdits;
exports.pleaseRead = pleaseRead;
exports.belowToFind = belowToFind;
exports.experienceReview = experienceReview;
exports.standardsReview = standardsReview;
exports.subjectReview = subjectReview;
exports.otherQuests = otherQuests;
exports.quests = quests;
exports.draft = draft;
exports.internalReview = internalReview;
exports.published = published;
exports.search = search;
exports.decline = decline;
exports.copyEditor = copyEditor;
exports.externalReviewer = externalReviewer;
exports.lastSaved = lastSaved;
exports.on = on;
exports.edited = edited;
exports.primarySubject = primarySubject;
exports.inQualityReview = inQualityReview;
exports.reviewReturned = reviewReturned;
exports.match = match;
exports.matches = matches;
exports.yourSearch = yourSearch;
exports.quest = quest;
exports.designedBy = designedBy;
exports.by = by;
exports.questQualityReviewGuidelines = questQualityReviewGuidelines;
exports.questsNeedToBeReviewed = questsNeedToBeReviewed;
exports.approve = approve;
exports.reviewer = reviewer;
exports.send = send;
exports.assigned = assigned;
exports.returned = returned;
exports.you = you;
exports.allQuestsAreEvaluated = allQuestsAreEvaluated;
exports.afterTheInternalProcessIsComplete = afterTheInternalProcessIsComplete;
exports.usingThe = usingThe;
exports.ago = ago;
exports.assignedTo = assignedTo;
exports.minutesAbbr = minutesAbbr;
exports.hourAbbr = hourAbbr;
exports.hoursAbbr = hoursAbbr;
exports.newest = newest;
exports.longestWait = longestWait;
exports.ok = ok;
exports.clickToShowPassword = clickToShowPassword;
exports.clickToHidePassword = clickToHidePassword;
exports.returnToLogin = returnToLogin;
exports.newPassword = newPassword;
exports.targetGradeLevel = targetGradeLevel;
exports.targetedFor = targetedFor;
exports.specificObjective = specificObjective;
exports.averageGradeLevel = averageGradeLevel;
exports.thisDataIsNotCurrentlyAvailable = thisDataIsNotCurrentlyAvailable;
exports.primaryElementarySchool = primaryElementarySchool;
exports.primaryMiddleSchool = primaryMiddleSchool;
exports.secondaryHighSchool = secondaryHighSchool;
exports.postsecondaryUndergraduateUniversity = postsecondaryUndergraduateUniversity;
exports.collegeOrUniversityGraduateOrAbove = collegeOrUniversityGraduateOrAbove;
exports.negative = negative;
exports.neutralModeratelyNegative = neutralModeratelyNegative;
exports.neutralSlightlyNegative = neutralSlightlyNegative;
exports.neutral = neutral;
exports.neutralSlightlyPositive = neutralSlightlyPositive;
exports.neutralModeratelyPostive = neutralModeratelyPostive;
exports.positive = positive;
exports.questGoal = questGoal;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(237);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _freeze2.default)({
  carrot: '#F68832',
  amber: '#FFAE00',
  amberLite: '#FFBE00',
  oeYellow: '#F7BE07',
  citron: '#FFD200',
  turbo: '#FFE600',
  black: '#000',
  charcoal2: '#222',
  charcoal4: '#444',
  dove: '#666',
  fiveam: '#808080',
  aluminum: '#999',
  silver: '#BBB',
  rock: '#ccc',
  ash: '#DEDFE0',
  smoke: '#F5F5F5',
  white: '#FFF',
  cobalt: '#0070E0',
  cobaltLite: '#0085FF',
  cyan: '#0085FF',
  jade: '#00BC80',
  jadeLite: '#2EE09B',
  crimson: '#DC143C',
  crimsonLite: '#E34363',
  sky: '#DAECFF',
  slate: '#4E6C83',
  sunrise: '#ffe7b3',
  victoria: '#243646',
  notificationRed: '#FF5252',
  siteBackground: '#F1F1F1'
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(537);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(538);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(962);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(963);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var CONSTANT = {
  GLOBAL: {
    HIDE: "__react_tooltip_hide_event",
    REBUILD: "__react_tooltip_rebuild_event",
    SHOW: "__react_tooltip_show_event"
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event;

  if (typeof window.CustomEvent === "function") {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = {
        currentTarget: event.detail.target
      };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener("resize", this.onWindowResize);
      window.addEventListener("resize", this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener("resize", this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute("currentItem");
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === "true") {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute("currentItem", "true");
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute("currentItem", "false");
    } else {
      targetArray[i].setAttribute("currentItem", "true");
    }
  }
};

var customListeners = {
  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute("data-event");
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute("data-event") || event;
    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
    dataEvent.split(" ").forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(" ").forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute("data-event");
    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute("data-effect");
    return dataEffect || this.props.effect || "float";
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === "function") {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute("data-tip") || null;
  var forId = e.target.getAttribute("data-for") || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(" ").forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName("body")[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, "data-event");
    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(" ").forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(" ").forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ["top", "bottom", "left", "right"];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === "float") {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === "float") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === "solid") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === "[object String]") {
    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
  }

  for (var key in offset) {
    if (key === "top") {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === "bottom") {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === "left") {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === "right") {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffset_X: extraOffset_X,
    extraOffset_Y: extraOffset_Y
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === "false" || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");

var _class, _class2, _temp;

var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck(this, ReactTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
    _this.state = {
      place: props.place || "top",
      // Direction of tooltip
      desiredPlace: props.place || "top",
      type: "dark",
      // Color theme of tooltip
      effect: "float",
      // float or fixed
      show: false,
      border: false,
      offset: {},
      extraClass: "",
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || "",
      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;

      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(":hover");
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray;

      if (!id) {
        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
      } else {
        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
      } // targetArray is a NodeList, convert it to a real array


      return nodeListToArray(targetArray);
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute("currentItem") === null) {
          target.setAttribute("currentItem", "false");
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);

          if (effect === "float") {
            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute("data-tip");
      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute("data-scroll-hide")) {
        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute("data-type") || self.props.type || "dark",
          effect: effect,
          offset: offset,
          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
          currentTarget: target
        }, function () {
          if (scrollHide) self.addScrollListener(self.state.currentTarget);
          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      }

      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) afterShow(e);
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener();

          if (isVisible && afterHide) afterHide(e);
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener() {
      window.removeEventListener("scroll", this.hideTooltipOnScroll);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + "px";
      node.style.top = result.position.top + "px";
    }
    /**
     * Set style tag in header
     * in this way we can insert default css
     */

    /* setStyleHeader() {
      const head = document.getElementsByTagName("head")[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        const tag = document.createElement("style");
        tag.id = "react-tooltip";
        tag.innerHTML = cssStyle; */

    /* eslint-disable */

    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
            tag.setAttribute('nonce', __webpack_nonce__)
          }*/

    /* eslint-enable */

    /*    head.insertBefore(tag, head.firstChild);
      }
    } */

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable;
      var placeholder = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(placeholder);
      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");

      if (html) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: wrapperClassName,
          id: this.props.id,
          ref: function ref(_ref) {
            return _this8.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: placeholder
          }
        }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: wrapperClassName,
          id: this.props.id
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this8.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), placeholder);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _defineProperty(_class2, "propTypes", {
  children: propTypes.any,
  place: propTypes.string,
  type: propTypes.string,
  effect: propTypes.string,
  offset: propTypes.object,
  multiline: propTypes.bool,
  border: propTypes.bool,
  insecure: propTypes.bool,
  "class": propTypes.string,
  className: propTypes.string,
  id: propTypes.string,
  html: propTypes.bool,
  delayHide: propTypes.number,
  delayUpdate: propTypes.number,
  delayShow: propTypes.number,
  event: propTypes.string,
  eventOff: propTypes.string,
  watchWindow: propTypes.bool,
  isCapture: propTypes.bool,
  globalEventOff: propTypes.string,
  getContent: propTypes.any,
  afterShow: propTypes.func,
  afterHide: propTypes.func,
  overridePosition: propTypes.func,
  disable: propTypes.bool,
  scrollHide: propTypes.bool,
  resizeHide: propTypes.bool,
  wrapper: propTypes.string,
  bodyMode: propTypes.bool,
  possibleCustomEvents: propTypes.string,
  possibleCustomEventsOff: propTypes.string,
  clickable: propTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: "div",
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

/* harmony default export */ __webpack_exports__["default"] = (ReactTooltip);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isViewingReadabilityScoresModal = isViewingReadabilityScoresModal;
exports.isNotViewingReadabilityScoresModal = isNotViewingReadabilityScoresModal;
exports.showModal = showModal;
exports.hideModal = hideModal;
var IS_VIEWING_READABILITY_SCORES_MODAL = exports.IS_VIEWING_READABILITY_SCORES_MODAL = 'IS_VIEWING_READABILITY_SCORES_MODAL';
var IS_NOT_VIEWING_READABILITY_SCORES_MODAL = exports.IS_NOT_VIEWING_READABILITY_SCORES_MODAL = 'IS_NOT_VIEWING_READABILITY_SCORES_MODAL';
var HIDE_MODAL = exports.HIDE_MODAL = 'HIDE_MODAL';
var SHOW_MODAL = exports.SHOW_MODAL = 'SHOW_MODAL';

function isViewingReadabilityScoresModal(section, subsection) {
  return {
    type: IS_VIEWING_READABILITY_SCORES_MODAL,
    payload: {
      section: section,
      subsection: subsection
    }
  };
}

function isNotViewingReadabilityScoresModal() {
  return {
    type: IS_NOT_VIEWING_READABILITY_SCORES_MODAL
  };
}

function showModal(modalType, modalProps) {
  return {
    type: SHOW_MODAL,
    payload: {
      modalType: modalType,
      modalProps: modalProps
    }
  };
}

function hideModal() {
  return {
    type: HIDE_MODAL
  };
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1185);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1188);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(243);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__core__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__core__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react__ = __webpack_require__(1115);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__react__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__react__[key]; }) }(__WEBPACK_IMPORT_KEY__));



/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * array-sort <https://github.com/jonschlinkert/array-sort>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var defaultCompare = __webpack_require__(1138);
var typeOf = __webpack_require__(1140);
var get = __webpack_require__(1141);

/**
 * Sort an array of objects by one or more properties.
 *
 * @param  {Array} `arr` The Array to sort.
 * @param  {String|Array|Function} `props` One or more object paths or comparison functions.
 * @param  {Object} `opts` Pass `{ reverse: true }` to reverse the sort order.
 * @return {Array} Returns a sorted array.
 * @api public
 */

function arraySort(arr, props, opts) {
  if (arr == null) {
    return [];
  }

  if (!Array.isArray(arr)) {
    throw new TypeError('array-sort expects an array.');
  }

  if (arguments.length === 1) {
    return arr.sort();
  }

  var args = flatten([].slice.call(arguments, 1));

  // if the last argument appears to be a plain object,
  // it's not a valid `compare` arg, so it must be options.
  if (typeOf(args[args.length - 1]) === 'object') {
    opts = args.pop();
  }
  return arr.sort(sortBy(args, opts));
}

/**
 * Iterate over each comparison property or function until `1` or `-1`
 * is returned.
 *
 * @param  {String|Array|Function} `props` One or more object paths or comparison functions.
 * @param  {Object} `opts` Pass `{ reverse: true }` to reverse the sort order.
 * @return {Array}
 */

function sortBy(props, opts) {
  opts = opts || {};

  return function compareFn(a, b) {
    var len = props.length, i = -1;
    var result;

    while (++i < len) {
      result = compare(props[i], a, b);
      if (result !== 0) {
        break;
      }
    }
    if (opts.reverse === true) {
      return result * -1;
    }
    return result;
  };
}

/**
 * Compare `a` to `b`. If an object `prop` is passed, then
 * `a[prop]` is compared to `b[prop]`
 */

function compare(prop, a, b) {
  if (typeof prop === 'function') {
    // expose `compare` to custom function
    return prop(a, b, compare.bind(null, null));
  }
  // compare object values
  if (prop && typeof a === 'object' && typeof b === 'object') {
    return compare(null, get(a, prop), get(b, prop));
  }
  return defaultCompare(a, b);
}

/**
 * Flatten the given array.
 */

function flatten(arr) {
  return [].concat.apply([], arr);
}

/**
 * Expose `arraySort`
 */

module.exports = arraySort;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withApiData = function withApiData(Child) {
  return function (props) {
    var apiData = (0, _reactRedux.useSelector)(function (state) {
      return {
        token: state.user.token,
        orgId: state.organization.orgId
      };
    });
    return _react2.default.createElement(Child, (0, _extends3.default)({}, props, { apiData: apiData }));
  };
};

exports.default = withApiData;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(129);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(985), __esModule: true };

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  width: ', ';\n  padding: 0 10px;\n  height: 40px;\n  color: ', ';\n  background: ', ';\n  line-height: 40px;\n  text-align: center;\n  border: 1px solid ', ';\n  border-radius: 20px;\n  cursor:  ', ';\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n  transition: color 0.4s, background-color 0.4s, opacity 0.4s, border 0.4s;\n  outline: none;\n  &:hover {\n    color:  ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n  &:disabled {\n    background: ', ';\n    cursor: not-allowed;\n    border: 1px solid ', '\n    color: ', '\n  }\n  ', '\n'], ['\n  display: inline-block;\n  width: ', ';\n  padding: 0 10px;\n  height: 40px;\n  color: ', ';\n  background: ', ';\n  line-height: 40px;\n  text-align: center;\n  border: 1px solid ', ';\n  border-radius: 20px;\n  cursor:  ', ';\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n  transition: color 0.4s, background-color 0.4s, opacity 0.4s, border 0.4s;\n  outline: none;\n  &:hover {\n    color:  ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n  &:disabled {\n    background: ', ';\n    cursor: not-allowed;\n    border: 1px solid ', '\n    color: ', '\n  }\n  ', '\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonElement = _styledComponents2.default.button.withConfig({
  displayName: 'Button__ButtonElement',
  componentId: 'sc-1933zcq-0'
})(_templateObject, function (props) {
  return props.width || 'auto';
}, _colors2.default.charcoal4, function (props) {
  return props.buttonColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.isDisabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.hoverColor;
}, function (props) {
  return props.hoverBackground;
}, function (props) {
  return props.hoverBackground;
}, _colors2.default.ash, _colors2.default.ash, _colors2.default.white, function (props) {
  return props.small && '\n    height: 30px;\n    line-height: 30px;\n    border-radius: 15px;\n    padding: 0 22px;\n    font-size: 14px;\n  ';
});

var Button = exports.Button = function Button(_ref) {
  var handleClick = _ref.handleClick,
      title = _ref.title,
      width = _ref.width,
      buttonColor = _ref.buttonColor,
      borderColor = _ref.borderColor,
      hoverBackground = _ref.hoverBackground,
      hoverColor = _ref.hoverColor,
      couldSaveData = _ref.couldSaveData,
      shouldShowTooltipAndDisableButton = _ref.shouldShowTooltipAndDisableButton,
      small = _ref.small,
      isMutating = _ref.isMutating;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      ButtonElement,
      {
        width: width,
        onClick: handleClick,
        buttonColor: buttonColor,
        borderColor: borderColor,
        hoverBackground: hoverBackground,
        hoverColor: hoverColor,
        disabled: shouldShowTooltipAndDisableButton && !couldSaveData || isMutating,
        small: small
      },
      title
    )
  );
};

Button.propTypes = {
  handleClick: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.string.isRequired,
  buttonColor: _propTypes2.default.string.isRequired,
  borderColor: _propTypes2.default.string.isRequired,
  hoverBackground: _propTypes2.default.string.isRequired,
  hoverColor: _propTypes2.default.string.isRequired,
  isMutating: _propTypes2.default.bool,
  shouldShowTooltip: _propTypes2.default.bool,
  couldSaveData: _propTypes2.default.bool,
  small: _propTypes2.default.bool
};

exports.default = Button;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(227)('wks');
var uid = __webpack_require__(173);
var Symbol = __webpack_require__(29).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isQuestAuthor = isQuestAuthor;
exports.isInternalReviewer = isInternalReviewer;
exports.isOeReviewer = isOeReviewer;
exports.isQuestDesigner = isQuestDesigner;
exports.isQuestCopyEditor = isQuestCopyEditor;
exports.isExternalReviewer = isExternalReviewer;
exports.isQuestCopyEditorOrQuestAuthor = isQuestCopyEditorOrQuestAuthor;
exports.isQuestManager = isQuestManager;
exports.isMentorAuthor = isMentorAuthor;
exports.getDisplayRole = getDisplayRole;
exports.isQuestAuthorOrInternalReviewer = isQuestAuthorOrInternalReviewer;
exports.isInternalReviewerOrOeReviewer = isInternalReviewerOrOeReviewer;
exports.isQuestDesignerOrIsQuestManager = isQuestDesignerOrIsQuestManager;
exports.isQuestCopyEditorOrQuestAuthorOrQuestManager = isQuestCopyEditorOrQuestAuthorOrQuestManager;
exports.getUserCertificationMarkerTooltipText = getUserCertificationMarkerTooltipText;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _messages = __webpack_require__(21);

var _usercertifications = __webpack_require__(1051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUserInRole(user, role) {
  return user.organization_roles.filter(function (orgRole) {
    return orgRole === role;
  }).length > 0;
}

function isQuestAuthor(user, quest, organization) {
  return user && quest.author_ids.includes(user.id) && organization && organization.orgId === quest.organization.id;
}

function isInternalReviewer(user) {
  return isUserInRole(user, 'qm_internal_review');
}

function isOeReviewer(user) {
  return isUserInRole(user, 'qm_platform_review');
}

function isQuestDesigner(user) {
  return isUserInRole(user, 'qm_editor');
}

function isQuestCopyEditor(user) {
  return isUserInRole(user, 'qm_copy_editor');
}

function isExternalReviewer(user) {
  return isUserInRole(user, 'qm_external_review');
}

function isQuestCopyEditorOrQuestAuthor(user, quest, organization) {
  return isQuestCopyEditor(user) || isQuestAuthor(user, quest, organization);
}

function isQuestManager(user) {
  return isUserInRole(user, 'qm_quest_manager');
}

function isMentorAuthor(user) {
  return isUserInRole(user, 'qm_mentor_author');
}

function getDisplayRole(roles) {
  var displayRole = _messages.questDesigner;

  if (roles.indexOf('qm_publisher') > -1) {
    displayRole = _messages.publisher;
  }

  if (roles.indexOf('qm_internal_review') > -1) {
    displayRole = _messages.internalReviewer;
  }

  if (roles.indexOf('qm_platform_review') > -1) {
    displayRole = _messages.oeReviewer;
  }

  if (roles.indexOf('qm_external_review') > -1) {
    displayRole = _messages.externalReviewer;
  }

  if (roles.indexOf('qm_copy_editor') > -1) {
    displayRole = _messages.copyEditor;
  }

  if (roles.indexOf('qm_quest_manager') > -1) {
    displayRole = 'Quest Manager';
  }

  if (roles.indexOf('qm_mentor_author') > -1) {
    displayRole = 'Mentor Author';
  }

  return displayRole;
}

function isQuestAuthorOrInternalReviewer(user, quest, organization) {
  return isQuestAuthor(user, quest, organization) || isInternalReviewer(user) || isQuestManager(user);
}

function isInternalReviewerOrOeReviewer(user) {
  return isInternalReviewer(user) || isOeReviewer(user);
}

function isQuestDesignerOrIsQuestManager(user) {
  return isQuestDesigner(user) || isQuestManager(user);
}

function isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization) {
  return isQuestCopyEditorOrQuestAuthor(user, quest, organization) || isQuestManager(user);
}

function getUserCertificationMarkerTooltipText(certifications) {
  var text = '';
  _usercertifications.userCertifications.forEach(function (role) {
    var roleCert = certifications.find(function (c) {
      return c.certificate_type === role.value;
    });
    if (roleCert) {
      var provisional = roleCert.level === 'provisional';
      text += '<div style="margin-top: 5px">' + role.text + (provisional ? ' (Provisional)' : '') + '</div>';
    }
  });

  return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: text } });
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(108);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(997);
module.exports = self.fetch.bind(self);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1008), __esModule: true };

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  z-index: 2147483647;\n'], ['\n  z-index: 2147483647;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 110%;\n  background: rgb(36, 54, 70);\n  opacity: 0.9;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 110%;\n  background: rgb(36, 54, 70);\n  opacity: 0.9;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  @include oe-border-radius(10px);\n  animation: fade-in-modal;\n  animation-duration: 0.5s;\n  overflow: hidden;\n  background: transparent;\n'], ['\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  @include oe-border-radius(10px);\n  animation: fade-in-modal;\n  animation-duration: 0.5s;\n  overflow: hidden;\n  background: transparent;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Modal__ModalContainer',
  componentId: 'sc-156wx6m-0'
})(_templateObject);

var ModalOverlay = _styledComponents2.default.div.withConfig({
  displayName: 'Modal__ModalOverlay',
  componentId: 'sc-156wx6m-1'
})(_templateObject2);

var ModalContents = _styledComponents2.default.div.withConfig({
  displayName: 'Modal__ModalContents',
  componentId: 'sc-156wx6m-2'
})(_templateObject3);

// This component is based on the Modal in Quest! Web

var Modal = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.onEscapeBound = _this.onEscape.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.lockBodyScroll) {
        document.body.classList.add('no-scroll');
      }

      document.addEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.lockBodyScroll) {
        document.body.classList.remove('no-scroll');
      }

      document.removeEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'onEscape',
    value: function onEscape(e) {
      // ESC key
      if (e.keyCode === 27 && this.props.allowEscape) {
        this.props.closeCallback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // TODO: change this to accept % height (and probably width too)
      var style = {
        height: !this.props.autoHeight ? this.props.percentHeight ? this.props.percentHeight + '%' : this.props.height + 'px' : 'auto',
        width: this.props.width + 'px',
        transform: 'translate(-50%, -50%)'
      };

      var overlayStyle = {};

      if (this.props.background) {
        overlayStyle.background = this.props.background;
      }

      if (this.props.opacity) {
        overlayStyle.opacity = this.props.opacity;
      }

      if (this.props.allowOverflow) {
        style.overflow = 'visible';
      }

      if (this.props.allowInnerScroll) {
        style.overflowY = 'scroll';
      }

      if (this.props.maxPercentHeight) {
        delete style.height;
        style.maxHeight = this.props.maxPercentHeight + '%';
      }

      if (this.props.top) {
        style.top = this.props.top + '%';
      }

      if (this.props.borderRadius) {
        style.borderRadius = '' + this.props.borderRadius;
      }

      if (this.props.boxShadow) {
        style.boxShadow = '' + this.props.boxShadow;
      }

      return _react2.default.createElement(
        ModalContainer,
        null,
        _react2.default.createElement(ModalOverlay, {
          style: overlayStyle,
          onClick: this.props.allowCloseOnExternalClick ? this.props.closeCallback : null
        }),
        _react2.default.createElement(
          ModalContents,
          {
            onClick: function onClick(e) {
              return e.target.className.includes('ModalContents') && _this2.props.closeCallback();
            },
            style: style },
          this.props.children
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

exports.default = Modal;


Modal.defaultProps = {
  allowEscape: true,
  allowCloseOnExternalClick: true,
  lockBodyScroll: true,
  autoHeight: false,
  allowInnerScroll: false,
  allowOverflow: false
};

Modal.propTypes = {
  top: _propTypes2.default.number,
  percentHeight: _propTypes2.default.number,
  maxPercentHeight: _propTypes2.default.number,
  autoHeight: _propTypes2.default.bool,
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  background: _propTypes2.default.string,
  opacity: _propTypes2.default.string,
  borderRadius: _propTypes2.default.string,
  boxShadow: _propTypes2.default.string,
  children: _propTypes2.default.object,
  closeCallback: _propTypes2.default.func,
  allowEscape: _propTypes2.default.bool,
  lockBodyScroll: _propTypes2.default.bool,
  allowInnerScroll: _propTypes2.default.bool,
  allowCloseOnExternalClick: _propTypes2.default.bool,
  allowOverflow: _propTypes2.default.bool
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(496);
var toPrimitive = __webpack_require__(120);
var dP = Object.defineProperty;

exports.f = __webpack_require__(49) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var DOMProperty = __webpack_require__(209);
var ReactDOMComponentFlags = __webpack_require__(604);

var invariant = __webpack_require__(28);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForkRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(189);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(121);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorAction = getErrorAction;
exports.removeNonQuestMakerRoleOrganizations = removeNonQuestMakerRoleOrganizations;
exports.handlePotentialDefaultOrgRoleIssue = handlePotentialDefaultOrgRoleIssue;
exports.doesUserHaveAppAccess = doesUserHaveAppAccess;
function getErrorAction(type, error, statusText) {
  return {
    type: type,
    payload: {
      status: error.response.status,
      statusText: statusText || error.response.statusText
    }
  };
}

function removeNonQuestMakerRoleOrganizations(user) {
  var validOrganizations = [];

  user.organizations.forEach(function (org) {
    if (org.roles.indexOf('qm_publisher') > -1 || org.roles.indexOf('qm_editor') > -1 || org.roles.indexOf('qm_internal_review') > -1 || org.roles.indexOf('qm_platform_review') > -1 || org.roles.indexOf('qm_copy_editor') > -1 || org.roles.indexOf('qm_external_review') > -1 || org.roles.indexOf('qm_external_review') > -1 || org.roles.indexOf('qm_mentor_author') > -1 || org.roles.indexOf('qm_quest_manager') > -1) {
      validOrganizations.push(org);
    }
  });

  user.organizations = validOrganizations;

  return user;
}

function handlePotentialDefaultOrgRoleIssue(user) {
  // if the default organization doesn't have proper roles, set default org
  //  to be the next one and also pull in the roles from that org as well
  if (!(user.organization_roles.indexOf('qm_publisher') > -1) && !(user.organization_roles.indexOf('qm_editor') > -1) && !(user.organization_roles.indexOf('qm_internal_review') > -1) && !(user.organization_roles.indexOf('qm_platform_review') > -1) && !(user.organization_roles.indexOf('qm_copy_editor') > -1) && !(user.organization_roles.indexOf('qm_external_review') > -1) && !(user.organization_roles.indexOf('qm_mentor_author') > -1) && !(user.organization_roles.indexOf('qm_quest_manager') > -1)) {
    user.org_id = user.organizations[0].id;
    user.org_name = user.organizations[0].name;
    user.organization_roles = user.organizations[0].roles;
  }

  return user;
}

function doesUserHaveAppAccess(user) {
  return user.organizations.length > 0;
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}


//# sourceMappingURL=invariant.esm.js.map


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isServer; });
/* harmony export (immutable) */ __webpack_exports__["l"] = noop;
/* harmony export (immutable) */ __webpack_exports__["c"] = functionalUpdate;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValidTimeout;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureQueryKeyArray;
/* harmony export (immutable) */ __webpack_exports__["a"] = difference;
/* harmony export (immutable) */ __webpack_exports__["r"] = replaceAt;
/* harmony export (immutable) */ __webpack_exports__["w"] = timeUntilStale;
/* harmony export (immutable) */ __webpack_exports__["p"] = parseQueryArgs;
/* harmony export (immutable) */ __webpack_exports__["n"] = parseMutationArgs;
/* harmony export (immutable) */ __webpack_exports__["m"] = parseFilterArgs;
/* harmony export (immutable) */ __webpack_exports__["o"] = parseMutationFilterArgs;
/* unused harmony export mapQueryStatusFilter */
/* harmony export (immutable) */ __webpack_exports__["k"] = matchQuery;
/* harmony export (immutable) */ __webpack_exports__["j"] = matchMutation;
/* harmony export (immutable) */ __webpack_exports__["f"] = hashQueryKeyByOptions;
/* harmony export (immutable) */ __webpack_exports__["e"] = hashQueryKey;
/* unused harmony export stableValueHash */
/* harmony export (immutable) */ __webpack_exports__["q"] = partialMatchKey;
/* unused harmony export partialDeepEqual */
/* harmony export (immutable) */ __webpack_exports__["s"] = replaceEqualDeep;
/* harmony export (immutable) */ __webpack_exports__["u"] = shallowEqualObjects;
/* unused harmony export isPlainObject */
/* unused harmony export isQueryKey */
/* harmony export (immutable) */ __webpack_exports__["g"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = sleep;
/* harmony export (immutable) */ __webpack_exports__["t"] = scheduleMicrotask;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAbortController;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
      mutationFn: arg1
    });
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 24px;\n  font-weight: 500;\n'], ['\n  color: #000000;\n  font-size: 24px;\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H2 = _styledComponents2.default.div.withConfig({
  displayName: 'H2',
  componentId: 'sc-17q10ww-0'
})(_templateObject);

exports.default = H2;

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(256);



function useTheme() {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["k" /* useTheme */])() || __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */];

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _remarkable = __webpack_require__(1397);

var _remarkable2 = _interopRequireDefault(_remarkable);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarkdownLabel = function (_PureComponent) {
  (0, _inherits3.default)(MarkdownLabel, _PureComponent);

  function MarkdownLabel() {
    (0, _classCallCheck3.default)(this, MarkdownLabel);
    return (0, _possibleConstructorReturn3.default)(this, (MarkdownLabel.__proto__ || (0, _getPrototypeOf2.default)(MarkdownLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(MarkdownLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          value = _props.value,
          additionalCssClasses = _props.additionalCssClasses;

      var isMissingValue = !value || value === '';

      if (isMissingValue) {
        return _react2.default.createElement(_NotYetSpecified2.default, null);
      } else {
        return _react2.default.createElement('label', {
          id: id,
          className: 'markdown ' + additionalCssClasses,
          dangerouslySetInnerHTML: this.rawMarkup(value)
        });
      }
    }
  }, {
    key: 'rawMarkup',
    value: function rawMarkup(val) {
      var md = new _remarkable2.default({ linkTarget: '_blank' });
      return { __html: md.render(val) };
    }
  }]);
  return MarkdownLabel;
}(_react.PureComponent);

exports.default = MarkdownLabel;


MarkdownLabel.propTypes = {
  id: _propTypes2.default.string,
  value: _propTypes2.default.string,
  additionalCssClasses: _propTypes2.default.string
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userCanViewInternalReviewInfo = userCanViewInternalReviewInfo;
exports.getReviewStatus = getReviewStatus;
exports.getFriendlyStatus = getFriendlyStatus;
exports.allRequiredFieldsComplete = allRequiredFieldsComplete;
exports.canSubmitForReview = canSubmitForReview;
exports.canSubmitButNotReady = canSubmitButNotReady;
exports.isSomeReviewComplete = isSomeReviewComplete;
exports.getTotalReviewState = getTotalReviewState;
exports.translateReviewState = translateReviewState;
exports.findReview = findReview;
exports.findRejectedReview = findRejectedReview;
exports.getFilteredReviews = getFilteredReviews;
exports.getCompletedReviewInfo = getCompletedReviewInfo;
exports.getReviewApprovalStatus = getReviewApprovalStatus;
exports.checkPreviousReviewsNoCurrent = checkPreviousReviewsNoCurrent;
exports.anyOeReviewsComplete = anyOeReviewsComplete;
exports.isActiveWithThisReviewer = isActiveWithThisReviewer;
exports.questIsInDraftState = questIsInDraftState;
exports.getIntlReviewType = getIntlReviewType;
exports.getIntlReviewTypeWithContext = getIntlReviewTypeWithContext;
exports.getIntlReviewTypeWithContextInSentence = getIntlReviewTypeWithContextInSentence;
exports.questIsInQualityReview = questIsInQualityReview;
exports.questIsInRejectedState = questIsInRejectedState;
exports.questInDraftAfterRejection = questInDraftAfterRejection;
exports.questIsPublished = questIsPublished;
exports.questInDraftAfterPublished = questInDraftAfterPublished;

var _user = __webpack_require__(45);

var _quest = __webpack_require__(103);

var _messages = __webpack_require__(21);

var _label = __webpack_require__(148);

function userCanViewInternalReviewInfo(user, quest) {
  return !(0, _user.isExternalReviewer)(user) && ((0, _user.isQuestDesigner)(user) || (0, _user.isQuestCopyEditor)(user) || (0, _user.isInternalReviewer)(user) || (0, _user.isQuestManager)(user) || (0, _user.isOeReviewer)(user) && questIsInQualityReview(quest) || questIsPublished(quest));
}

function getReviewStatus(quest) {
  return quest.reviewing_compiled_quest ? quest.reviewing_compiled_quest.state : 'draft';
}

function getFriendlyStatus(reviewStatus) {
  var retVal = '';
  switch (reviewStatus) {
    case 'pre-published':
      retVal = 'Pre-Published';
      break;
    case 'internal_review':
      retVal = _messages.internalReviewInProgress;
      break;
    case 'submitted':
      retVal = _messages.inQualityReview;
      break;
    case 'draft':
      retVal = _messages.draft;
      break;
    case 'platform_review':
      retVal = _messages.inQualityReview;
      break;
    case 'in-quality-review':
      retVal = _messages.inQualityReview;
      break;
    case 'in-publication-review':
      retVal = _messages.inQualityReview;
      break;
    case 'publication-review':
      retVal = _messages.inQualityReview;
      break;
    case 'published':
      retVal = _messages.published;
      break;
    case 'rejected':
      retVal = _messages.reviewReturned;
      break;
    case 'review-returned':
      retVal = _messages.reviewReturned;
      break;
    case 'recalled':
      retVal = _messages.draft;
      break;
    case 'all-quests':
      retVal = 'All quests';
      break;
  }
  return retVal;
}

function allRequiredFieldsComplete(quest, activities) {
  return (0, _quest.isBasicInformationComplete)(quest) && (0, _quest.areActivitiesComplete)(activities) && (0, _quest.areImagesComplete)(quest) && (0, _quest.isOtherInformationComplete)(quest);
}

function canSubmitForReview(user, quest, organization, activities) {
  return (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && allRequiredFieldsComplete(quest, activities) && questIsInDraftState(quest);
}

function canSubmitButNotReady(user, quest, organization, activities) {
  return (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && !allRequiredFieldsComplete(quest, activities) && questIsInDraftState(quest);
}

function isSomeReviewComplete(reviews) {
  return reviews.some(function (review) {
    return review.accepted === true || review.accepted === false;
  });
}

function getTotalReviewState(reviews) {
  var filteredReviews = reviews.filter(function (review) {
    return review.criteria === 'standards' || review.criteria === 'final';
  });

  var approvedCount = 0;
  var rejectedCount = 0;
  var reviewState = '';

  filteredReviews.forEach(function (review) {
    if (review.accepted === true) {
      approvedCount += 1;
    } else if (review.accepted === false) {
      rejectedCount += 1;
    }
  });

  if (rejectedCount > 0) {
    reviewState = 'rejected';
  } else if (approvedCount === 1) {
    reviewState = 'someOeApproved';
  } else if (approvedCount === 2) {
    reviewState = 'readyForPublish';
  }

  return reviewState;
}

function translateReviewState(reviewState) {
  var retVal = '';
  switch (reviewState) {
    case 'rejected':
      retVal = 'rejected';
      break;
    case 'allInternalApproved':
      retVal = 'platform_review';
      break;
    case 'someOeApproved':
      retVal = 'platform_review';
      break;
    case 'readyForPublish':
      retVal = 'published';
      break;
  }

  return retVal;
}

function findReview(reviews, reviewType) {
  return reviews.find(function (r) {
    return r.criteria === reviewType;
  });
}

function findRejectedReview(reviews) {
  var rejectedReview = reviews.find(function (review) {
    return review.accepted === false;
  });
  return rejectedReview ? rejectedReview.criteria : '';
}

function getFilteredReviews(reviews, reviewType) {
  var filteredReviews = reviews.filter(function (review) {
    return review.criteria === reviewType;
  });
  return filteredReviews;
}

function getCompletedReviewInfo(review) {
  return review.accepted === true ? _messages.approved : _messages.needsEdits;
}

function getReviewApprovalStatus(review) {
  var approvalStatus = '';

  switch (review.accepted) {
    case true:
      approvalStatus = 'approved';
      break;
    case false:
      approvalStatus = 'rejected';
      break;
    default:
      approvalStatus = '';
  }
  return approvalStatus;
}

function checkPreviousReviewsNoCurrent(previousFilteredReviews, review) {
  return previousFilteredReviews.length > 0 && !review;
}

function anyOeReviewsComplete(currentReviews, previousReviews) {
  var mergedReviews = currentReviews.concat(previousReviews);
  return mergedReviews.filter(function (review) {
    return (review.criteria === 'standards' || review.criteria === 'final') && review.completed_at;
  }).length > 0;
}

function isActiveWithThisReviewer(activeReview, user) {
  return activeReview && user.id === activeReview.reviewer.id;
}

function questIsInDraftState(quest) {
  return !quest.reviewing_compiled_quest || quest.reviewing_compiled_quest.state === 'recalled';
}

function getIntlReviewType(reviewType) {
  var intlReviewType;
  switch (reviewType) {
    case 'experience':
      intlReviewType = _messages.experience;
      break;
    case 'subject':
      intlReviewType = _messages.subject;
      break;
    case 'copy':
      intlReviewType = _messages.copy;
      break;
    case 'standards':
      intlReviewType = _messages.standards;
      break;
    case 'final':
      intlReviewType = _messages.final;
      break;
  }
  return intlReviewType;
}

function getIntlReviewTypeWithContext(reviewType, intl, context) {
  if (context === 'sentence') {
    return getIntlReviewTypeWithContextInSentence(reviewType, intl);
  } else {
    var intlReviewType;
    switch (reviewType) {
      case 'experience':
        intlReviewType = intl.formatMessage(_label.messages.experience);
        break;
      case 'subject':
        intlReviewType = intl.formatMessage(_label.messages.subject);
        break;
      case 'copy':
        intlReviewType = intl.formatMessage(_label.messages.copy);
        break;
      case 'standards':
        intlReviewType = intl.formatMessage(_label.messages.standards);
        break;
      case 'final':
        intlReviewType = intl.formatMessage(_label.messages.final);
        break;
    }
    return intlReviewType;
  }
}

function getIntlReviewTypeWithContextInSentence(reviewType, intl) {
  var intlReviewType;
  switch (reviewType) {
    case 'experience':
      intlReviewType = intl.formatMessage(_label.messages.experienceReview);
      break;
    case 'subject':
      intlReviewType = intl.formatMessage(_label.messages.subjectReview);
      break;
    case 'copy':
      intlReviewType = intl.formatMessage(_label.messages.copy);
      break;
    case 'standards':
      intlReviewType = intl.formatMessage(_label.messages.standardsReview);
      break;
    case 'final':
      intlReviewType = intl.formatMessage(_label.messages.final);
      break;
  }
  return intlReviewType;
}

function questIsInQualityReview(quest) {
  var status = getReviewStatus(quest);
  if (status === 'submitted' || status === 'platform_review') {
    return true;
  } else {
    return false;
  }
}

function questIsInRejectedState(quest) {
  return quest.current_compiled_quest && quest.current_compiled_quest.state === 'rejected' && Boolean(quest.reviewing_compiled_quest);
}

function questInDraftAfterRejection(quest) {
  return quest.current_compiled_quest && quest.current_compiled_quest.state === 'rejected' && !quest.reviewing_compiled_quest;
}

function questIsPublished(quest) {
  return Boolean(quest.reviewing_compiled_quest) && quest.reviewing_compiled_quest.state === 'published';
}

function questInDraftAfterPublished(quest) {
  return Boolean(quest.current_compiled_quest) && quest.current_compiled_quest.state === 'published' && !quest.reviewing_compiled_quest;
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = hexToRgb;
/* harmony export (immutable) */ __webpack_exports__["k"] = rgbToHex;
/* harmony export (immutable) */ __webpack_exports__["h"] = hslToRgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = decomposeColor;
/* harmony export (immutable) */ __webpack_exports__["j"] = recomposeColor;
/* harmony export (immutable) */ __webpack_exports__["e"] = getContrastRatio;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLuminance;
/* harmony export (immutable) */ __webpack_exports__["c"] = emphasize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fade;
/* harmony export (immutable) */ __webpack_exports__["a"] = darken;
/* harmony export (immutable) */ __webpack_exports__["i"] = lighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(19);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS = exports.END_FETCHING_QUEST_DATA = exports.START_FETCHING_QUEST_DATA = exports.FETCH_QUEST_GRADE_LEVELS_SUCCESS = exports.FETCH_QUEST_GRADE_LEVELS_REQUEST = exports.FETCH_QUEST_APPROVALS_SUCCESS = exports.FETCH_QUEST_APPROVALS_REQUEST = exports.FETCH_CURRENT_ASSIGNMENT_SUCCESS = exports.FETCH_CURRENT_ASSIGNMENT_REQUEST = exports.FETCH_IN_USE_COMPILED_QUESTS_SUCCESS = exports.FETCH_IN_USE_COMPILED_QUESTS_REQUEST = exports.FETCH_QUEST_ACTIVITIES_SUCCESS = exports.FETCH_QUEST_ACTIVITIES_REQUEST = exports.CLEAR_QUEST_HISTORY = exports.FETCH_QUEST_HISTORY_SUCCESS = exports.FETCH_QUEST_HISTORY_REQUEST = exports.EDIT_QUEST_DETAILS_REQUEST = exports.FAILED_QUEST_ANALYTICS = exports.RECEIVE_QUEST_ANALYTICS = exports.REQUEST_QUEST_ANALYTICS = exports.EDIT_QUEST_DETAILS_FAILURE = exports.FAILED_QUEST_READABLE_STATS = exports.RECEIVE_QUEST_READABLE_STATS = exports.REQUEST_QUEST_READABLE_STATS = exports.ADD_EDITOR_TO_QUEST = exports.CREATE_QUEST_FAILURE = exports.CREATE_QUEST_REQUEST = exports.CREATE_QUEST_SUCCESS = exports.DELETE_NOTE_REQUEST = exports.CANCEL_EDIT_QUEST = exports.START_EDIT_QUEST = exports.CREATE_MENTOR_NOTE = exports.CREATE_QUEST_MENTOR_NOTE_SUCCESS = exports.DELETE_NOTE_SUCCESS = exports.EDIT_QUEST_MENTOR_NOTE_SUCCESS = exports.EDIT_QUEST_DETAILS_SUCCESS = exports.DELETE_QUEST_SUCCESS = exports.SET_QUEST_SECTION = exports.FAILED_QUEST_NOTES = exports.RECEIVE_QUEST_NOTES = exports.REQUEST_QUEST_NOTES = exports.FETCH_QUEST_FAILURE = exports.RECEIVE_QUEST = exports.REQUEST_QUEST = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.editQuestDetailsRequest = editQuestDetailsRequest;
exports.addEditorToQuest = addEditorToQuest;
exports.createQuestFailure = createQuestFailure;
exports.createQuestRequest = createQuestRequest;
exports.createQuestSuccess = createQuestSuccess;
exports.deleteNoteRequest = deleteNoteRequest;
exports.startEditQuest = startEditQuest;
exports.cancelEditQuest = cancelEditQuest;
exports.createMentorNote = createMentorNote;
exports.deleteNoteAction = deleteNoteAction;
exports.deleteQuestSuccess = deleteQuestSuccess;
exports.requestQuest = requestQuest;
exports.receiveQuest = receiveQuest;
exports.requestQuestNotes = requestQuestNotes;
exports.receiveQuestNotes = receiveQuestNotes;
exports.setQuestSection = setQuestSection;
exports.editQuestDetailsSuccess = editQuestDetailsSuccess;
exports.editQuestMentorNoteSuccess = editQuestMentorNoteSuccess;
exports.createQuestMentorNoteSuccess = createQuestMentorNoteSuccess;
exports.failedQuestNotes = failedQuestNotes;
exports.fetchQuestFailure = fetchQuestFailure;
exports.requestQuestReadableStats = requestQuestReadableStats;
exports.receiveQuestReadableStats = receiveQuestReadableStats;
exports.failedQuestReadableStats = failedQuestReadableStats;
exports.editQuestDetailsFailure = editQuestDetailsFailure;
exports.requestQuestAnalytics = requestQuestAnalytics;
exports.receiveQuestAnalytics = receiveQuestAnalytics;
exports.failedQuestAnalytics = failedQuestAnalytics;
exports.fetchQuestHistoryRequest = fetchQuestHistoryRequest;
exports.fetchQuestHistorySuccess = fetchQuestHistorySuccess;
exports.clearQuestHistory = clearQuestHistory;
exports.fetchQuestActivitiesRequest = fetchQuestActivitiesRequest;
exports.fetchQuestActivitiesSuccess = fetchQuestActivitiesSuccess;
exports.fetchInUseCompiledQuestsRequest = fetchInUseCompiledQuestsRequest;
exports.fetchInUseCompiledQuestsSuccess = fetchInUseCompiledQuestsSuccess;
exports.fetchCurrentAssignmentRequest = fetchCurrentAssignmentRequest;
exports.fetchCurrentAssignmentSuccess = fetchCurrentAssignmentSuccess;
exports.fetchQuestApprovalsRequest = fetchQuestApprovalsRequest;
exports.fetchQuestApprovalsSuccess = fetchQuestApprovalsSuccess;
exports.fetchQuestGradeLevelsRequest = fetchQuestGradeLevelsRequest;
exports.fetchQuestGradeLevelsSuccess = fetchQuestGradeLevelsSuccess;
exports.startFetchingQuestData = startFetchingQuestData;
exports.endFetchingQuestData = endFetchingQuestData;
exports.updateQuestImagePropertiesSuccess = updateQuestImagePropertiesSuccess;
exports.deleteQuest = deleteQuest;
exports.fetchQuestNotes = fetchQuestNotes;
exports.fetchQuest = fetchQuest;
exports.editQuestDetails = editQuestDetails;
exports.editQuestMentorNote = editQuestMentorNote;
exports.createQuestMentorNote = createQuestMentorNote;
exports.deleteNote = deleteNote;
exports.createQuest = createQuest;
exports.fetchQuestReadableStats = fetchQuestReadableStats;
exports.fetchQuestAnalytics = fetchQuestAnalytics;
exports.fetchQuestHistory = fetchQuestHistory;
exports.fetchQuestActivities = fetchQuestActivities;
exports.fetchInUseCompiledQuests = fetchInUseCompiledQuests;
exports.fetchCurrentAssignment = fetchCurrentAssignment;
exports.fetchQuestApprovals = fetchQuestApprovals;
exports.fetchQuestGradeLevels = fetchQuestGradeLevels;
exports.removeIconImage = removeIconImage;
exports.updateQuestImageSource = updateQuestImageSource;
exports.uploadImage = uploadImage;

__webpack_require__(47);

var _reactRouterRedux = __webpack_require__(23);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _alert = __webpack_require__(402);

var _comments = __webpack_require__(303);

var _actions = __webpack_require__(55);

var _review = __webpack_require__(159);

var _topics = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_QUEST = exports.REQUEST_QUEST = 'REQUEST_QUEST';

var RECEIVE_QUEST = exports.RECEIVE_QUEST = 'RECEIVE_QUEST';
var FETCH_QUEST_FAILURE = exports.FETCH_QUEST_FAILURE = 'FETCH_QUEST_FAILURE';
var REQUEST_QUEST_NOTES = exports.REQUEST_QUEST_NOTES = 'REQUEST_QUEST_NOTES';
var RECEIVE_QUEST_NOTES = exports.RECEIVE_QUEST_NOTES = 'RECEIVE_QUEST_NOTES';
var FAILED_QUEST_NOTES = exports.FAILED_QUEST_NOTES = 'FAILED_QUEST_NOTES';
var SET_QUEST_SECTION = exports.SET_QUEST_SECTION = 'SET_QUEST_SECTION';
var DELETE_QUEST_SUCCESS = exports.DELETE_QUEST_SUCCESS = 'DELETE_QUEST_SUCCESS';
var EDIT_QUEST_DETAILS_SUCCESS = exports.EDIT_QUEST_DETAILS_SUCCESS = 'EDIT_QUEST_DETAILS_SUCCESS';
var EDIT_QUEST_MENTOR_NOTE_SUCCESS = exports.EDIT_QUEST_MENTOR_NOTE_SUCCESS = 'EDIT_QUEST_MENTOR_NOTE_SUCCESS';
var DELETE_NOTE_SUCCESS = exports.DELETE_NOTE_SUCCESS = 'DELETE_NOTE_SUCCESS';
var CREATE_QUEST_MENTOR_NOTE_SUCCESS = exports.CREATE_QUEST_MENTOR_NOTE_SUCCESS = 'CREATE_QUEST_MENTOR_NOTE_SUCCESS';
var CREATE_MENTOR_NOTE = exports.CREATE_MENTOR_NOTE = 'CREATE_MENTOR_NOTE';
var START_EDIT_QUEST = exports.START_EDIT_QUEST = 'START_EDIT_QUEST';
var CANCEL_EDIT_QUEST = exports.CANCEL_EDIT_QUEST = 'CANCEL_EDIT_QUEST';
var DELETE_NOTE_REQUEST = exports.DELETE_NOTE_REQUEST = 'DELETE_NOTE_REQUEST';
var CREATE_QUEST_SUCCESS = exports.CREATE_QUEST_SUCCESS = 'CREATE_QUEST_SUCCESS';
var CREATE_QUEST_REQUEST = exports.CREATE_QUEST_REQUEST = 'CREATE_QUEST_REQUEST';
var CREATE_QUEST_FAILURE = exports.CREATE_QUEST_FAILURE = 'CREATE_QUEST_FAILURE';
var ADD_EDITOR_TO_QUEST = exports.ADD_EDITOR_TO_QUEST = 'ADD_EDITOR_TO_QUEST';
var REQUEST_QUEST_READABLE_STATS = exports.REQUEST_QUEST_READABLE_STATS = 'REQUEST_QUEST_READABLE_STATS';
var RECEIVE_QUEST_READABLE_STATS = exports.RECEIVE_QUEST_READABLE_STATS = 'RECEIVE_QUEST_READABLE_STATS';
var FAILED_QUEST_READABLE_STATS = exports.FAILED_QUEST_READABLE_STATS = 'FAILED_QUEST_READABLE_STATS';
var EDIT_QUEST_DETAILS_FAILURE = exports.EDIT_QUEST_DETAILS_FAILURE = 'EDIT_QUEST_DETAILS_FAILURE';
var REQUEST_QUEST_ANALYTICS = exports.REQUEST_QUEST_ANALYTICS = 'REQUEST_QUEST_ANALYTICS';
var RECEIVE_QUEST_ANALYTICS = exports.RECEIVE_QUEST_ANALYTICS = 'RECEIVE_QUEST_ANALYTICS';
var FAILED_QUEST_ANALYTICS = exports.FAILED_QUEST_ANALYTICS = 'FAILED_QUEST_ANALYTICS';
var EDIT_QUEST_DETAILS_REQUEST = exports.EDIT_QUEST_DETAILS_REQUEST = 'EDIT_QUEST_DETAILS_REQUEST';
var FETCH_QUEST_HISTORY_REQUEST = exports.FETCH_QUEST_HISTORY_REQUEST = 'FETCH_QUEST_HISTORY_REQUEST';
var FETCH_QUEST_HISTORY_SUCCESS = exports.FETCH_QUEST_HISTORY_SUCCESS = 'FETCH_QUEST_HISTORY_SUCCESS';
var CLEAR_QUEST_HISTORY = exports.CLEAR_QUEST_HISTORY = 'CLEAR_QUEST_HISTORY';
var FETCH_QUEST_ACTIVITIES_REQUEST = exports.FETCH_QUEST_ACTIVITIES_REQUEST = 'FETCH_QUEST_ACTIVITIES_REQUEST';
var FETCH_QUEST_ACTIVITIES_SUCCESS = exports.FETCH_QUEST_ACTIVITIES_SUCCESS = 'FETCH_QUEST_ACTIVITIES_SUCCESS';
var FETCH_IN_USE_COMPILED_QUESTS_REQUEST = exports.FETCH_IN_USE_COMPILED_QUESTS_REQUEST = 'FETCH_IN_USE_COMPILED_QUESTS_REQUEST';
var FETCH_IN_USE_COMPILED_QUESTS_SUCCESS = exports.FETCH_IN_USE_COMPILED_QUESTS_SUCCESS = 'FETCH_IN_USE_COMPILED_QUESTS_SUCCESS';
var FETCH_CURRENT_ASSIGNMENT_REQUEST = exports.FETCH_CURRENT_ASSIGNMENT_REQUEST = 'FETCH_CURRENT_ASSIGNMENT_REQUEST';
var FETCH_CURRENT_ASSIGNMENT_SUCCESS = exports.FETCH_CURRENT_ASSIGNMENT_SUCCESS = 'FETCH_CURRENT_ASSIGNMENT_SUCCESS';
var FETCH_QUEST_APPROVALS_REQUEST = exports.FETCH_QUEST_APPROVALS_REQUEST = 'FETCH_QUEST_APPROVALS_REQUEST';
var FETCH_QUEST_APPROVALS_SUCCESS = exports.FETCH_QUEST_APPROVALS_SUCCESS = 'FETCH_QUEST_APPROVALS_SUCCESS';
var FETCH_QUEST_GRADE_LEVELS_REQUEST = exports.FETCH_QUEST_GRADE_LEVELS_REQUEST = 'FETCH_QUEST_GRADE_LEVELS_REQUEST';
var FETCH_QUEST_GRADE_LEVELS_SUCCESS = exports.FETCH_QUEST_GRADE_LEVELS_SUCCESS = 'FETCH_QUEST_GRADE_LEVELS_SUCCESS';
var START_FETCHING_QUEST_DATA = exports.START_FETCHING_QUEST_DATA = 'START_FETCHING_QUEST_DATA';
var END_FETCHING_QUEST_DATA = exports.END_FETCHING_QUEST_DATA = 'END_FETCHING_QUEST_DATA';
var UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS = exports.UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS = 'UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS';

function editQuestDetailsRequest() {
  return {
    type: EDIT_QUEST_DETAILS_REQUEST
  };
}

function addEditorToQuest(user) {
  return {
    type: ADD_EDITOR_TO_QUEST,
    payload: {
      user: user
    }
  };
}

function createQuestFailure(error) {
  return (0, _actions.getErrorAction)(CREATE_QUEST_FAILURE, error);
}

function createQuestRequest() {
  return {
    type: CREATE_QUEST_REQUEST
  };
}

function createQuestSuccess(response) {
  return {
    type: CREATE_QUEST_SUCCESS,
    quest: response
  };
}

function deleteNoteRequest() {
  return {
    type: DELETE_NOTE_REQUEST
  };
}

function startEditQuest() {
  return {
    type: START_EDIT_QUEST
  };
}

function cancelEditQuest() {
  return {
    type: CANCEL_EDIT_QUEST
  };
}

function createMentorNote() {
  return {
    type: CREATE_MENTOR_NOTE
  };
}

function deleteNoteAction(noteId) {
  return {
    type: DELETE_NOTE_SUCCESS,
    noteId: noteId
  };
}

function deleteQuestSuccess(questId) {
  return {
    type: DELETE_QUEST_SUCCESS,
    questId: questId
  };
}

function requestQuest(questId) {
  return {
    type: REQUEST_QUEST,
    questId: questId
  };
}

function receiveQuest(response) {
  return {
    type: RECEIVE_QUEST,
    quest: response
  };
}

function requestQuestNotes() {
  return {
    type: REQUEST_QUEST_NOTES
  };
}

function receiveQuestNotes(response) {
  return {
    type: RECEIVE_QUEST_NOTES,
    notes: response.quest_notes
  };
}

function setQuestSection(section, activityId, subsection) {
  return {
    type: SET_QUEST_SECTION,
    section: section,
    subsection: subsection,
    activityId: activityId || null
  };
}

function editQuestDetailsSuccess(response) {
  return {
    type: EDIT_QUEST_DETAILS_SUCCESS,
    quest: response
  };
}

function editQuestMentorNoteSuccess(questId, response) {
  return {
    type: EDIT_QUEST_MENTOR_NOTE_SUCCESS,
    payload: {
      questId: questId,
      note: response
    }
  };
}

function createQuestMentorNoteSuccess(response) {
  return {
    type: CREATE_QUEST_MENTOR_NOTE_SUCCESS,
    note: response
  };
}

function failedQuestNotes(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_NOTES, error);
}

function fetchQuestFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_QUEST_FAILURE, error);
}

function requestQuestReadableStats() {
  return {
    type: REQUEST_QUEST_READABLE_STATS
  };
}

function receiveQuestReadableStats(response) {
  return {
    type: RECEIVE_QUEST_READABLE_STATS,
    payload: {
      stats: response.readable_stats
    }
  };
}

function failedQuestReadableStats(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_READABLE_STATS, error);
}

function editQuestDetailsFailure(error) {
  return {
    type: EDIT_QUEST_DETAILS_FAILURE,
    payload: {
      error: error
    }
  };
}

function requestQuestAnalytics() {
  return {
    type: REQUEST_QUEST_ANALYTICS
  };
}

function receiveQuestAnalytics(response) {
  return {
    type: RECEIVE_QUEST_ANALYTICS,
    payload: {
      quest_analytics: response
    }
  };
}

function failedQuestAnalytics(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_ANALYTICS, error);
}

function fetchQuestHistoryRequest(reload) {
  return {
    type: FETCH_QUEST_HISTORY_REQUEST,
    payload: {
      reload: reload
    }
  };
}

function fetchQuestHistorySuccess(history) {
  return {
    type: FETCH_QUEST_HISTORY_SUCCESS,
    payload: {
      quest_events: history.quest_events,
      page: history.meta.page,
      total: history.meta.total
    }
  };
}

function clearQuestHistory() {
  return {
    type: CLEAR_QUEST_HISTORY
  };
}

function fetchQuestActivitiesRequest() {
  return {
    type: FETCH_QUEST_ACTIVITIES_REQUEST
  };
}

function fetchQuestActivitiesSuccess(response) {
  return {
    type: FETCH_QUEST_ACTIVITIES_SUCCESS,
    payload: {
      activities: response.activities
    }
  };
}

function fetchInUseCompiledQuestsRequest() {
  return {
    type: FETCH_IN_USE_COMPILED_QUESTS_REQUEST
  };
}

function fetchInUseCompiledQuestsSuccess(inUseCompiledQuests) {
  return {
    type: FETCH_IN_USE_COMPILED_QUESTS_SUCCESS,
    payload: {
      inUseCompiledQuests: inUseCompiledQuests
    }
  };
}

function fetchCurrentAssignmentRequest() {
  return {
    type: FETCH_CURRENT_ASSIGNMENT_REQUEST
  };
}

function fetchCurrentAssignmentSuccess(assignment) {
  return {
    type: FETCH_CURRENT_ASSIGNMENT_SUCCESS,
    payload: {
      assignment: assignment
    }
  };
}

function fetchQuestApprovalsRequest() {
  return {
    type: FETCH_QUEST_APPROVALS_REQUEST
  };
}

function fetchQuestApprovalsSuccess(approvals) {
  return {
    type: FETCH_QUEST_APPROVALS_SUCCESS,
    payload: {
      approvals: approvals
    }
  };
}

function fetchQuestGradeLevelsRequest() {
  return {
    type: FETCH_QUEST_GRADE_LEVELS_REQUEST
  };
}

function fetchQuestGradeLevelsSuccess(gradeLevels) {
  return {
    type: FETCH_QUEST_GRADE_LEVELS_SUCCESS,
    payload: {
      gradeLevels: gradeLevels
    }
  };
}

function startFetchingQuestData() {
  return {
    type: START_FETCHING_QUEST_DATA
  };
}

function endFetchingQuestData() {
  return {
    type: END_FETCHING_QUEST_DATA
  };
}

function updateQuestImagePropertiesSuccess(imageProperties) {
  return {
    type: UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS,
    payload: {
      imageProperties: imageProperties
    }
  };
}

function deleteQuest(questId) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId;
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                }
              });

            case 6:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(deleteQuestSuccess(questId));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t2 = _context['catch'](2);

              console.log(_context.t2);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchQuestNotes(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id + '/notes';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestNotes, receiveQuestNotes, failedQuestNotes);
  };
}

function fetchQuest(id) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url, response, quest;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id;

              dispatch(startFetchingQuestData());
              dispatch(requestQuest(id));
              _context2.prev = 4;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 8;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 8:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 12;
              return response.json();

            case 12:
              quest = _context2.sent;
              _context2.next = 15;
              return dispatch(receiveQuest(quest));

            case 15:
              _context2.next = 17;
              return dispatch(fetchQuestActivities());

            case 17:
              _context2.next = 19;
              return dispatch(fetchQuestApprovals());

            case 19:
              _context2.next = 21;
              return dispatch(fetchCurrentAssignment());

            case 21:
              _context2.next = 23;
              return dispatch(fetchQuestGradeLevels());

            case 23:
              _context2.next = 25;
              return dispatch((0, _comments.fetchQuestComments)(id, state));

            case 25:
              _context2.next = 27;
              return dispatch((0, _comments.fetchQuestActivityComments)(id, state));

            case 27:
              _context2.next = 29;
              return dispatch((0, _comments.fetchUserQuestComments)(id, state));

            case 29:
              _context2.next = 31;
              return dispatch((0, _comments.fetchUserActivityComments)(id, state));

            case 31:
              _context2.next = 33;
              return dispatch(fetchQuestNotes(id, state));

            case 33:
              _context2.next = 35;
              return dispatch((0, _topics.fetchQuestTopics)(id, state));

            case 35:
              _context2.next = 37;
              return dispatch(fetchQuestAnalytics(id));

            case 37:
              _context2.next = 39;
              return dispatch(fetchInUseCompiledQuests());

            case 39:
              dispatch(endFetchingQuestData());
              _context2.next = 46;
              break;

            case 42:
              _context2.prev = 42;
              _context2.t2 = _context2['catch'](4);

              dispatch(fetchQuestFailure(_context2.t2));
              if (_context2.t2.response.status === 404) {
                dispatch((0, _reactRouterRedux.push)('/notfound'));
              }

            case 46:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[4, 42]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function editQuestDetails(quest) {
  return function (dispatch, getState) {
    var state = getState();

    // need to trim whitespace from quest name on update request
    quest.name = quest.name.trim();

    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + quest.id;
    var section = '';
    if (state.quest.section === 'basicinformation') {
      section = 'two';
    } else if (state.quest.section === 'otherinformation') {
      section = 'three';
    }
    dispatch(editQuestDetailsRequest());

    return fetch(url, {
      method: 'PUT',
      headers: (0, _utils.getApiHeaders)(state),
      body: (0, _stringify2.default)({
        quest: quest,
        section: section
      })
    }).then(function (response) {
      if (!response.ok) {
        throw response;
      }
      return response.json(); // we only get here if there is no error
    }).then(function (json) {
      dispatch(editQuestDetailsSuccess(json));
      dispatch(addEditorToQuest(state.user.user));
    }).catch(function (err) {
      err.text().then(function (errorMessage) {
        dispatch(editQuestDetailsFailure(errorMessage));
      });
    });
  };
}

function editQuestMentorNote(id, note, noteId) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id + '/notes/' + noteId;
              data = new window.FormData();

              data.append('note[description]', note.description || '');

              _context3.prev = 4;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 8;
              return fetch(url, {
                method: 'PUT',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context3.t1 = _context3.sent;
              response = (0, _context3.t0)(_context3.t1);
              _context3.next = 12;
              return response.json();

            case 12:
              json = _context3.sent;

              dispatch(editQuestMentorNoteSuccess(id, json));
              dispatch(addEditorToQuest(state.user.user));
              _context3.next = 20;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t2 = _context3['catch'](4);

              console.log(_context3.t2);

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 17]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function createQuestMentorNote(questId, note) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/notes';
              data = new FormData();

              data.append('note[attachment]', note.file);
              data.append('note[description]', note.description || '');

              dispatch(createMentorNote());
              _context4.prev = 6;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 10;
              return fetch(url, {
                method: 'POST',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 10:
              _context4.t1 = _context4.sent;
              response = (0, _context4.t0)(_context4.t1);
              _context4.next = 14;
              return response.json();

            case 14:
              json = _context4.sent;

              dispatch(createQuestMentorNoteSuccess(json));
              dispatch(addEditorToQuest(state.user.user));
              _context4.next = 22;
              break;

            case 19:
              _context4.prev = 19;
              _context4.t2 = _context4['catch'](6);

              console.log(_context4.t2);

            case 22:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[6, 19]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function deleteNote(questId, noteId) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/notes/' + noteId;

              dispatch(deleteNoteRequest());
              _context5.prev = 3;
              _context5.t0 = _utils.checkHttpStatus;
              _context5.next = 7;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 7:
              _context5.t1 = _context5.sent;
              (0, _context5.t0)(_context5.t1);

              dispatch(deleteNoteAction(noteId));
              dispatch(addEditorToQuest(state.user.user));
              _context5.next = 16;
              break;

            case 13:
              _context5.prev = 13;
              _context5.t2 = _context5['catch'](3);

              console.log(_context5.t2);

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[3, 13]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function createQuest(questName, intl) {
  var _this6 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests';

              dispatch(createQuestRequest());
              _context6.prev = 3;
              _context6.t0 = _utils.checkHttpStatus;
              _context6.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  name: questName
                })
              });

            case 7:
              _context6.t1 = _context6.sent;
              response = (0, _context6.t0)(_context6.t1);
              _context6.next = 11;
              return response.json();

            case 11:
              json = _context6.sent;

              dispatch(createQuestSuccess(json));
              dispatch(setQuestSection('basicinformation'));
              dispatch((0, _reactRouterRedux.push)('/quest/' + json.id + '/basicinformation'));
              _context6.next = 21;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t2 = _context6['catch'](3);

              dispatch(createQuestFailure(_context6.t2));
              if (_context6.t2.response.status === 422) {
                window.alert(intl.formatMessage(_alert.messages.questTitleTaken));
              } else {
                window.alert('There was an error trying to add this Quest.');
              }

            case 21:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[3, 17]]);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function fetchQuestReadableStats(questId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/readable_stats';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestReadableStats, receiveQuestReadableStats, failedQuestReadableStats);
  };
}

function fetchQuestAnalytics(questId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/analytics';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestAnalytics, receiveQuestAnalytics, failedQuestAnalytics);
  };
}

function fetchQuestHistory(page, reload) {
  var _this7 = this;

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
      var state, questId, url, response, json;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState();
              questId = state.quest.item.id;
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/quest_events?page=' + page;

              dispatch(fetchQuestHistoryRequest(reload));
              _context7.prev = 4;
              _context7.t0 = _utils.checkHttpStatus;
              _context7.next = 8;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 8:
              _context7.t1 = _context7.sent;
              response = (0, _context7.t0)(_context7.t1);
              _context7.next = 12;
              return response.json();

            case 12:
              json = _context7.sent;

              dispatch(fetchQuestHistorySuccess(json));
              _context7.next = 19;
              break;

            case 16:
              _context7.prev = 16;
              _context7.t2 = _context7['catch'](4);

              console.log(_context7.t2);

            case 19:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[4, 16]]);
    }));

    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function fetchQuestActivities() {
  return function (dispatch, getState) {
    var state = getState();
    var questId = state.quest.item.id;
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities';
    return (0, _api.basicGet)(state, dispatch, url, fetchQuestActivitiesRequest, fetchQuestActivitiesSuccess);
  };
}

function fetchInUseCompiledQuests() {
  var _this8 = this;

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
      var state, questId, url, response, json;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state = getState();
              questId = state.quest.item.id;
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/in_use_compiled_quests';

              dispatch(fetchInUseCompiledQuestsRequest());
              _context8.prev = 4;
              _context8.t0 = _utils.checkHttpStatus;
              _context8.next = 8;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 8:
              _context8.t1 = _context8.sent;
              response = (0, _context8.t0)(_context8.t1);
              _context8.next = 12;
              return response.json();

            case 12:
              json = _context8.sent;
              _context8.next = 15;
              return dispatch(fetchInUseCompiledQuestsSuccess(json));

            case 15:
              if (!json.current_compiled_quest) {
                _context8.next = 18;
                break;
              }

              _context8.next = 18;
              return dispatch((0, _review.fetchCurrentCompiledQuest)(questId, json.current_compiled_quest.id));

            case 18:
              _context8.next = 23;
              break;

            case 20:
              _context8.prev = 20;
              _context8.t2 = _context8['catch'](4);

              console.log(_context8.t2);

            case 23:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[4, 20]]);
    }));

    return function (_x15, _x16) {
      return _ref8.apply(this, arguments);
    };
  }();
}

function fetchCurrentAssignment() {
  return function (dispatch, getState) {
    var state = getState();
    var questId = state.quest.item.id;
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/assignments/current_assignment';
    return (0, _api.basicGet)(state, dispatch, url, fetchCurrentAssignmentRequest, fetchCurrentAssignmentSuccess);
  };
}

function fetchQuestApprovals() {
  return function (dispatch, getState) {
    var state = getState();
    var questId = state.quest.item.id;
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/approvals';
    return (0, _api.basicGet)(state, dispatch, url, fetchQuestApprovalsRequest, fetchQuestApprovalsSuccess);
  };
}

function fetchQuestGradeLevels() {
  return function (dispatch, getState) {
    var state = getState();
    var questId = state.quest.item.id;
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/grade_levels';
    return (0, _api.basicGet)(state, dispatch, url, fetchQuestGradeLevelsRequest, fetchQuestGradeLevelsSuccess);
  };
}

function removeIconImage() {
  var _this9 = this;

  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + state.quest.item.id + '/update_icon_image';
              _context9.prev = 2;
              _context9.t0 = _utils.checkHttpStatus;
              _context9.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  quest: {
                    remove_icon_image: true,
                    icon_image_license_id: null,
                    icon_image_license_properties: {}
                  }
                })
              });

            case 6:
              _context9.t1 = _context9.sent;
              response = (0, _context9.t0)(_context9.t1);
              _context9.next = 10;
              return response.json();

            case 10:
              json = _context9.sent;

              dispatch(updateQuestImagePropertiesSuccess(json));
              dispatch(addEditorToQuest(state.user.user));
              _context9.next = 18;
              break;

            case 15:
              _context9.prev = 15;
              _context9.t2 = _context9['catch'](2);

              console.log(_context9.t2);

            case 18:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[2, 15]]);
    }));

    return function (_x17, _x18) {
      return _ref9.apply(this, arguments);
    };
  }();
}

function updateQuestImageSource(iconImageSource) {
  var _this10 = this;

  return function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + state.quest.item.id + '/update_icon_image';

              dispatch(editQuestDetailsRequest());
              _context10.prev = 3;
              _context10.t0 = _utils.checkHttpStatus;
              _context10.next = 7;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  quest: {
                    icon_image_license_properties: {
                      source_url: iconImageSource
                    }
                  }
                })
              });

            case 7:
              _context10.t1 = _context10.sent;
              response = (0, _context10.t0)(_context10.t1);
              _context10.next = 11;
              return response.json();

            case 11:
              json = _context10.sent;

              dispatch(updateQuestImagePropertiesSuccess(json));
              dispatch(addEditorToQuest(state.user.user));
              _context10.next = 19;
              break;

            case 16:
              _context10.prev = 16;
              _context10.t2 = _context10['catch'](3);

              console.log(_context10.t2);

            case 19:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[3, 16]]);
    }));

    return function (_x19, _x20) {
      return _ref10.apply(this, arguments);
    };
  }();
}

function uploadImage(type, dataUri, fileName) {
  var _this11 = this;

  return function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + state.quest.item.id + '/update_icon_image';
              data = new FormData();

              data.append('quest[' + type + '_image]', (0, _utils.dataUriToBlob)(dataUri), fileName);

              _context11.prev = 4;
              _context11.t0 = _utils.checkHttpStatus;
              _context11.next = 8;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context11.t1 = _context11.sent;
              response = (0, _context11.t0)(_context11.t1);
              _context11.next = 12;
              return response.json();

            case 12:
              json = _context11.sent;

              dispatch(updateQuestImagePropertiesSuccess(json));
              dispatch(addEditorToQuest(state.user.user));
              _context11.next = 20;
              break;

            case 17:
              _context11.prev = 17;
              _context11.t2 = _context11['catch'](4);

              console.log(_context11.t2);

            case 20:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11, [[4, 17]]);
    }));

    return function (_x21, _x22) {
      return _ref11.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-size: 13px;\n  font-weight: 300;\n\n  ', '\n'], ['\n  color: #666666;\n  font-size: 13px;\n  font-weight: 300;\n\n  ', '\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption1 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption1',
  componentId: 'sc-1xxxsl3-0'
})(_templateObject, function (_ref) {
  var textTruncate = _ref.textTruncate;
  return textTruncate && '\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ';
});

Caption1.propTypes = {
  textTruncate: _propTypes2.default.bool
};

exports.default = Caption1;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(1192);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(76);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(1193);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(589);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(591);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(1194);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(1195);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(1196);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(1197);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(1198);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(1199);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]);

var instanceId = 1;

var Select = (0, _createReactClass2['default'])({

	displayName: 'Select',

	propTypes: {
		addLabelText: _propTypes2['default'].string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-describedby': _propTypes2['default'].string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2['default'].string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2['default'].string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2['default'].func, // Create drop-down caret element
		autoBlur: _propTypes2['default'].bool, // automatically blur the component when an option is selected
		autofocus: _propTypes2['default'].bool, // autofocus the component on mount
		autosize: _propTypes2['default'].bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2['default'].string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2['default'].string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2['default'].func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2['default'].bool, // should it be possible to reset value
		deleteRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2['default'].string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2['default'].bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2['default'].bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2['default'].func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2['default'].any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _propTypes2['default'].bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2['default'].bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2['default'].object, // custom attributes for the Input
		inputRenderer: _propTypes2['default'].func, // returns a custom input component
		instanceId: _propTypes2['default'].string, // set the components instanceId
		isLoading: _propTypes2['default'].bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2['default'].bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2['default'].string, // path of the label value in option objects
		matchPos: _propTypes2['default'].string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2['default'].string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2['default'].number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2['default'].object, // optional style to apply to the menu container
		menuRenderer: _propTypes2['default'].func, // renders a custom menu with options
		menuStyle: _propTypes2['default'].object, // optional style to apply to the menu
		multi: _propTypes2['default'].bool, // multi-value input
		name: _propTypes2['default'].string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2['default'].func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2['default'].bool, // whether input is cleared on blur
		onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
		onClose: _propTypes2['default'].func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2['default'].bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2['default'].func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2['default'].func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2['default'].func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2['default'].func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2['default'].func, // fires when the menu is opened
		onValueClick: _propTypes2['default'].func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _propTypes2['default'].bool, // boolean to enable opening dropdown when focused
		openOnFocus: _propTypes2['default'].bool, // always open options menu on focus
		optionClassName: _propTypes2['default'].string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2['default'].func, // option component to render in dropdown
		optionRenderer: _propTypes2['default'].func, // optionRenderer: function (option) {}
		options: _propTypes2['default'].array, // array of options
		pageSize: _propTypes2['default'].number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _propTypes2['default'].bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2['default'].any, // value to use when you clear the control
		scrollMenuIntoView: _propTypes2['default'].bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2['default'].bool, // whether to enable searching feature or not
		simpleValue: _propTypes2['default'].bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2['default'].object, // optional style to apply to the control
		tabIndex: _propTypes2['default'].string, // optional tab index of the control
		tabSelectsValue: _propTypes2['default'].bool, // whether to treat tabbing out while focused to be value selection
		value: _propTypes2['default'].any, // initial field value
		valueComponent: _propTypes2['default'].func, // value component to render
		valueKey: _propTypes2['default'].string, // path of the label value in option objects
		valueRenderer: _propTypes2['default'].func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2['default'].object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-describedby': this.props['aria-describedby'],
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			var _ariaOwns = (0, _classnames2['default'])(_defineProperty({}, this._instancePrefix + '-list', isOpen));

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': _ariaOwns,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {

		if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var valueKey = this.props.valueKey;
		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = -1;
			options.some(function (option, index) {
				var isOptionEqual = option[valueKey] === focusedOption[valueKey];
				if (isOptionEqual) {
					focusedOptionIndex = index;
				}
				return isOptionEqual;
			});
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-clearable': this.props.clearable,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(147);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(258);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(146);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/index.js + 12 modules
var react_transition_group_esm = __webpack_require__(213);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/Ripple.js




var useEnhancedEffect = typeof window === 'undefined' ? react["useEffect"] : react["useLayoutEffect"];
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = react["useState"](false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(clsx_m["a" /* default */])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(clsx_m["a" /* default */])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(useEventCallback["a" /* default */])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/react["createElement"]("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/react["createElement"]("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ var ButtonBase_Ripple = (Ripple);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/TouchRipple.js









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple_TouchRipple = /*#__PURE__*/react["forwardRef"](function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["center", "classes", "className"]);

  var _React$useState = react["useState"]([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = react["useRef"](0);
  var rippleCallback = react["useRef"](null);
  react["useEffect"](function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = react["useRef"](false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = react["useRef"](null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = react["useRef"](null);
  var container = react["useRef"](null);
  react["useEffect"](function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = react["useCallback"](function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(toConsumableArray["a" /* default */])(oldRipples), [/*#__PURE__*/react["createElement"](ButtonBase_Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = react["useCallback"](function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = react["useCallback"](function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = react["useCallback"](function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  react["useImperativeHandle"](ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/react["createElement"]("span", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/react["createElement"](react_transition_group_esm["b" /* TransitionGroup */], {
    component: null,
    exit: true
  }, ripples));
});
 false ? TouchRipple_TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var ButtonBase_TouchRipple = (Object(withStyles["a" /* default */])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/react["memo"](TouchRipple_TouchRipple)));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js












var ButtonBase_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase_ButtonBase = /*#__PURE__*/react["forwardRef"](function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = react["useRef"](null);

  function getButtonNode() {
    // #StrictMode ready
    return react_dom["findDOMNode"](buttonRef.current);
  }

  var rippleRef = react["useRef"](null);

  var _React$useState = react["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(useIsFocusVisible["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  react["useImperativeHandle"](action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  react["useEffect"](function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(useEventCallback["a" /* default */])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(useEventCallback["a" /* default */])(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = react["useRef"](false);
  var handleKeyDown = Object(useEventCallback["a" /* default */])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(useEventCallback["a" /* default */])(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(useForkRef["a" /* default */])(buttonRefProp, ref);
  var handleOwnRef = Object(useForkRef["a" /* default */])(focusVisibleRef, buttonRef);
  var handleRef = Object(useForkRef["a" /* default */])(handleUserRef, handleOwnRef);

  var _React$useState2 = react["useState"](false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  react["useEffect"](function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/react["createElement"](ComponentProp, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  react["createElement"](ButtonBase_TouchRipple, Object(esm_extends["a" /* default */])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? ButtonBase_ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
/* harmony default export */ var esm_ButtonBase_ButtonBase = (Object(withStyles["a" /* default */])(ButtonBase_styles, {
  name: 'MuiButtonBase'
})(ButtonBase_ButtonBase));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_ButtonBase_ButtonBase; });


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(81);
var core = __webpack_require__(43);
var ctx = __webpack_require__(192);
var hide = __webpack_require__(169);
var has = __webpack_require__(170);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicGet = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var basicGet = exports.basicGet = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(state, dispatch, url, request, success, failure) {
    var response, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch(request());

            _context.prev = 1;
            _context.t0 = _index.checkHttpStatus;
            _context.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _index.getApiHeaders)(state)
            });

          case 5:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            _context.next = 9;
            return response.json();

          case 9:
            data = _context.sent;

            dispatch(success(data));
            _context.next = 18;
            break;

          case 13:
            _context.prev = 13;
            _context.t2 = _context['catch'](1);

            if (failure) {
              dispatch(failure(_context.t2));
            }

            if (_context.t2.response.status === 404) {
              dispatch((0, _reactRouterRedux.push)('/notfound'));
            }

            if (_context.t2.response.status === 500) {
              dispatch((0, _reactRouterRedux.push)('/error'));
            }

          case 18:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 13]]);
  }));

  return function basicGet(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

exports.checkForPolicyChanges = checkForPolicyChanges;

__webpack_require__(47);

var _reactRouterRedux = __webpack_require__(23);

var _index = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkForPolicyChanges(response) {
  return response.headers.get('X-Policy-Changes');
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_NEEDS_TO_RESET_PASSWORD = exports.USER_IS_LOGGED_IN_DATA_FETCHED = exports.USER_IS_LOGGED_IN_FETCHING_ALL_DATA = exports.GET_USER_DATA_FAILURE = exports.GET_USER_DATA_SUCCESS = exports.GET_USER_DATA_REQUEST = exports.RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_FAILURE = exports.FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_REQUEST = exports.USER_DATA_FAILURE = exports.USER_DATA_SUCCESS = exports.LOGOUT_USER = exports.LOGIN_USER_FAILURE = exports.LOGIN_USER_SUCCESS = exports.LOGIN_USER_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.userNeedsToResetPassword = userNeedsToResetPassword;
exports.loginUserSuccess = loginUserSuccess;
exports.loginUserFailure = loginUserFailure;
exports.loginUserRequest = loginUserRequest;
exports.logout = logout;
exports.userDataSuccess = userDataSuccess;
exports.userDataFailure = userDataFailure;
exports.getUserDataRequest = getUserDataRequest;
exports.getUserDataSuccess = getUserDataSuccess;
exports.getUserDataFailure = getUserDataFailure;
exports.userIsLoggedInFetchingAllData = userIsLoggedInFetchingAllData;
exports.userIsLoggedInDataFetched = userIsLoggedInDataFetched;
exports.requestUserData = requestUserData;
exports.loginUser = loginUser;
exports.logoutAndRedirect = logoutAndRedirect;
exports.redirectAuthenticatedUser = redirectAuthenticatedUser;
exports.getUserData = getUserData;
exports.handleLoginSuccess = handleLoginSuccess;

__webpack_require__(47);

var _reactRouterRedux = __webpack_require__(23);

var _utils = __webpack_require__(20);

var _organization = __webpack_require__(203);

var _policies = __webpack_require__(158);

var _organizations = __webpack_require__(550);

var _combined = __webpack_require__(395);

var _actions = __webpack_require__(55);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN_USER_REQUEST = exports.LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';

var LOGIN_USER_SUCCESS = exports.LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
var LOGIN_USER_FAILURE = exports.LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
var LOGOUT_USER = exports.LOGOUT_USER = 'LOGOUT_USER';
var USER_DATA_SUCCESS = exports.USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
var USER_DATA_FAILURE = exports.USER_DATA_FAILURE = 'USER_DATA_FAILURE';
var FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
var FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
var FORGOT_PASSWORD_FAILURE = exports.FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
var RESET_PASSWORD_REQUEST = exports.RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
var RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
var GET_USER_DATA_REQUEST = exports.GET_USER_DATA_REQUEST = 'GET_USER_DATA_REQUEST';
var GET_USER_DATA_SUCCESS = exports.GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
var GET_USER_DATA_FAILURE = exports.GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';
var USER_IS_LOGGED_IN_FETCHING_ALL_DATA = exports.USER_IS_LOGGED_IN_FETCHING_ALL_DATA = 'USER_IS_LOGGED_IN_FETCHING_ALL_DATA';
var USER_IS_LOGGED_IN_DATA_FETCHED = exports.USER_IS_LOGGED_IN_DATA_FETCHED = 'USER_IS_LOGGED_IN_DATA_FETCHED';
var USER_NEEDS_TO_RESET_PASSWORD = exports.USER_NEEDS_TO_RESET_PASSWORD = 'USER_NEEDS_TO_RESET_PASSWORD';

function userNeedsToResetPassword(reset) {
  return {
    type: USER_NEEDS_TO_RESET_PASSWORD,
    userNeedsToResetPassword: reset
  };
}

function loginUserSuccess(response) {
  sessionStorage.setItem('oef-token', response.token);
  return {
    type: LOGIN_USER_SUCCESS,
    payload: {
      token: response.token,
      name: response.name,
      user: response
    }
  };
}

function loginUserFailure(error) {
  return (0, _actions.getErrorAction)(LOGIN_USER_FAILURE, error);
}

function loginUserRequest() {
  return {
    type: LOGIN_USER_REQUEST
  };
}

function logout() {
  sessionStorage.clear();
  return {
    type: LOGOUT_USER
  };
}

function userDataSuccess(response) {
  return {
    type: USER_DATA_SUCCESS,
    questCounts: response.quest_counts
  };
}

function userDataFailure(error) {
  return (0, _actions.getErrorAction)(USER_DATA_FAILURE, error);
}

function getUserDataRequest() {
  return {
    type: GET_USER_DATA_REQUEST
  };
}

function getUserDataSuccess(response) {
  return {
    type: GET_USER_DATA_SUCCESS,
    payload: {
      stats: response
    }
  };
}

function getUserDataFailure(error) {
  return (0, _actions.getErrorAction)(GET_USER_DATA_FAILURE, error);
}

function userIsLoggedInFetchingAllData() {
  return {
    type: USER_IS_LOGGED_IN_FETCHING_ALL_DATA
  };
}

function userIsLoggedInDataFetched() {
  return {
    type: USER_IS_LOGGED_IN_DATA_FETCHED
  };
}

function requestUserData() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getBaseUrl)() + '/quest_maker/api/user';
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;

              dispatch(userDataSuccess(json));
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t2 = _context['catch'](2);

              dispatch(userDataFailure(_context.t2));

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 14]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function loginUser(email, password) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var url, data, response, user;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = (0, _utils.getBaseUrl)() + '/login';
              data = new window.FormData();

              data.append('session[email]', email);
              data.append('session[password]', password);
              data.append('session[application]', 'QM');
              dispatch(loginUserRequest());

              // requirement to store last attempted login value
              localStorage.setItem('lastLogin', email);
              sessionStorage.setItem('password', password);
              _context2.prev = 8;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 12;
              return fetch(url, {
                method: 'POST',
                body: data
              });

            case 12:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 16;
              return response.json();

            case 16:
              user = _context2.sent;

              user = (0, _actions.removeNonQuestMakerRoleOrganizations)(user);

              if ((0, _actions.doesUserHaveAppAccess)(user)) {
                user = (0, _actions.handlePotentialDefaultOrgRoleIssue)(user);
                dispatch(handleLoginSuccess(user));
              } else {
                dispatch(loginUserFailure({
                  response: {
                    status: 401,
                    statusText: 'There was an error logging in.'
                  }
                }));
              }
              _context2.next = 24;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t2 = _context2['catch'](8);

              dispatch(loginUserFailure(_context2.t2));

            case 24:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[8, 21]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function logoutAndRedirect(reload, redirect) {
  return function (dispatch) {
    // any time we logout, remove session password in case it exists
    sessionStorage.removeItem('password');
    dispatch(logout());

    if (reload) {
      window.location.reload(true);
    } else {
      dispatch((0, _reactRouterRedux.push)(redirect ? '/login?redirect=' + window.location.pathname : '/login'));
    }
  };
}

function redirectAuthenticatedUser() {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, route;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              route = void 0;

              if (state.user.user.organization_roles.some(function (role) {
                return role === 'qm_mentor_author';
              })) {
                route = '/mycourses';
              } else {
                route = '/quests';
              }
              return _context3.abrupt('return', dispatch((0, _reactRouterRedux.push)(route)));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function getUserData() {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/user';
              return _context4.abrupt('return', (0, _api.basicGet)(state, dispatch, url, getUserDataRequest, getUserDataSuccess, getUserDataFailure));

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function handleLoginSuccess(user) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
      var policiesToAccept;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(loginUserSuccess(user));

            case 2:
              _context5.next = 4;
              return dispatch((0, _organizations.fetchOrganizations)());

            case 4:
              _context5.next = 6;
              return dispatch((0, _organization.setCurrentOrganization)(user.org_id, user.organization_roles, false));

            case 6:

              dispatch(userIsLoggedInFetchingAllData());
              _context5.next = 9;
              return (0, _policies.userNeedsToAcceptPolicies)(user.token);

            case 9:
              policiesToAccept = _context5.sent;


              if (policiesToAccept) {
                dispatch((0, _policies.setPoliciesToAccept)(policiesToAccept));
              } else {
                dispatch((0, _combined.fetchDataAndRedirectUser)(user));
              }

            case 11:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }));

    return function (_x9) {
      return _ref5.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(566);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 16px;\n  font-weight: 300;\n'], ['\n  color: #000000;\n  font-size: 16px;\n  font-weight: 300;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var P2 = _styledComponents2.default.div.withConfig({
  displayName: 'P2',
  componentId: 'sc-1efie9q-0'
})(_templateObject);

exports.default = P2;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelButton = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: ', ';\n  color: ', ';\n  border: 1px solid ', ';\n  height: 40px;\n  width: ', ';\n  line-height: 40px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 20px;\n  &:before {\n    content: none;\n  }\n\n  &:hover {\n    color: ', ';\n    border: 1px solid ', ';\n    background: ', ';\n    box-shadow: none;\n  }\n'], ['\n  background: ', ';\n  color: ', ';\n  border: 1px solid ', ';\n  height: 40px;\n  width: ', ';\n  line-height: 40px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 20px;\n  &:before {\n    content: none;\n  }\n\n  &:hover {\n    color: ', ';\n    border: 1px solid ', ';\n    background: ', ';\n    box-shadow: none;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonElement = _styledComponents2.default.button.withConfig({
  displayName: 'CancelButton__ButtonElement',
  componentId: 'sc-1nz2x6a-0'
})(_templateObject, function (props) {
  return props.disabled ? _colors2.default.rock : 'transparent';
}, function (props) {
  return props.disabled ? _colors2.default.white : _colors2.default.charcoal4;
}, _colors2.default.aluminum, function (props) {
  return props.width;
}, _colors2.default.white, _colors2.default.charcoal4, _colors2.default.charcoal4);

var CancelButton = exports.CancelButton = function CancelButton(_ref) {
  var handleClick = _ref.handleClick,
      title = _ref.title,
      width = _ref.width;

  return _react2.default.createElement(
    ButtonElement,
    { width: width, onClick: handleClick },
    title
  );
};

CancelButton.propTypes = {
  handleClick: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.string.isRequired
};

exports.default = CancelButton;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 15px;\n'], ['\n  margin-right: 15px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarginRight15 = _styledComponents2.default.div.withConfig({
  displayName: 'MarginRight15',
  componentId: 'rhfwhr-0'
})(_templateObject);

MarginRight15.propTypes = {
  textTruncate: _propTypes2.default.bool
};

exports.default = MarginRight15;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(325);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref
    }, props), path);
  };

  if (false) {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */].muiName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(Component));
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(484);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(353)('wks');
var uid = __webpack_require__(277);
var Symbol = __webpack_require__(81).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotifyManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notifyManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(60);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* scheduleMicrotask */])(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* scheduleMicrotask */])(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 20px;\n  font-weight: ', ';\n\n  ', '\n'], ['\n  color: #000000;\n  font-size: 20px;\n  font-weight: ', ';\n\n  ', '\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H3 = _styledComponents2.default.div.withConfig({
  displayName: 'H3',
  componentId: 'sc-181vyqb-0'
})(_templateObject, function (props) {
  return props.light ? '300' : '500';
}, function (_ref) {
  var textTruncate = _ref.textTruncate;
  return textTruncate && '\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ';
});

H3.propTypes = {
  light: _propTypes2.default.bool,
  textTruncate: _propTypes2.default.bool
};

exports.default = H3;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Utility functions
 */

function typeOf(obj) {
  return Object.prototype.toString.call(obj);
}

function isString(obj) {
  return typeOf(obj) === '[object String]';
}

var hasOwn = Object.prototype.hasOwnProperty;

function has(object, key) {
  return object
    ? hasOwn.call(object, key)
    : false;
}

// Extend objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = [].slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

////////////////////////////////////////////////////////////////////////////////

var UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}

var NAMED_ENTITY_RE   = /&([a-z#][a-z0-9]{1,31});/gi;
var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;
var entities = __webpack_require__(660);

function replaceEntityPattern(match, name) {
  var code = 0;

  if (has(entities, name)) {
    return entities[name];
  } else if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16)
    :
      parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }
  return match;
}

function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(NAMED_ENTITY_RE, replaceEntityPattern);
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

exports.assign            = assign;
exports.isString          = isString;
exports.has               = has;
exports.unescapeMd        = unescapeMd;
exports.isValidEntityCode = isValidEntityCode;
exports.fromCodePoint     = fromCodePoint;
exports.replaceEntities   = replaceEntities;
exports.escapeHtml        = escapeHtml;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(51);
var createDesc = __webpack_require__(172);
module.exports = __webpack_require__(49) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var hide = __webpack_require__(87);
var has = __webpack_require__(94);
var SRC = __webpack_require__(173)('src');
var $toString = __webpack_require__(743);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(105).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var fails = __webpack_require__(31);
var defined = __webpack_require__(121);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStartTime = parseStartTime;
exports.parseEndTime = parseEndTime;
exports.randomString = randomString;
exports.queryString = queryString;
exports.getSDK = getSDK;
exports.getConfig = getConfig;
exports.omit = omit;
exports.callPlayer = callPlayer;
exports.isObject = isObject;
exports.isEqual = isEqual;
exports.isMediaStream = isMediaStream;

var _react = __webpack_require__(0);

var _loadScript = _interopRequireDefault(__webpack_require__(1175));

var _deepmerge = _interopRequireDefault(__webpack_require__(1176));

var _props = __webpack_require__(308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
var MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
var MATCH_NUMERIC = /^\d+$/; // Parse YouTube URL for a start time param, ie ?t=1h14m30s
// and return the start time in seconds

function parseTimeParam(url, pattern) {
  var match = url.match(pattern);

  if (match) {
    var stamp = match[1];

    if (stamp.match(MATCH_START_STAMP)) {
      return parseTimeString(stamp);
    }

    if (MATCH_NUMERIC.test(stamp)) {
      return parseInt(stamp);
    }
  }

  return undefined;
}

function parseTimeString(stamp) {
  var seconds = 0;
  var array = MATCH_START_STAMP.exec(stamp);

  while (array !== null) {
    var _array = array,
        _array2 = _slicedToArray(_array, 3),
        count = _array2[1],
        period = _array2[2];

    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
    if (period === 'm') seconds += parseInt(count, 10) * 60;
    if (period === 's') seconds += parseInt(count, 10);
    array = MATCH_START_STAMP.exec(stamp);
  }

  return seconds;
}

function parseStartTime(url) {
  return parseTimeParam(url, MATCH_START_QUERY);
}

function parseEndTime(url) {
  return parseTimeParam(url, MATCH_END_QUERY);
} // http://stackoverflow.com/a/38622545


function randomString() {
  return Math.random().toString(36).substr(2, 5);
}

function queryString(object) {
  return Object.keys(object).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  }).join('&');
} // Util function to load an external SDK
// or return the SDK if it is already loaded


var requests = {};

function getSDK(url, sdkGlobal) {
  var sdkReady = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLoaded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return true;
  };
  var fetchScript = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _loadScript["default"];

  if (window[sdkGlobal] && isLoaded(window[sdkGlobal])) {
    return Promise.resolve(window[sdkGlobal]);
  }

  return new Promise(function (resolve, reject) {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({
        resolve: resolve,
        reject: reject
      });
      return;
    }

    requests[url] = [{
      resolve: resolve,
      reject: reject
    }];

    var onLoaded = function onLoaded(sdk) {
      // When loaded, resolve all pending request promises
      requests[url].forEach(function (request) {
        return request.resolve(sdk);
      });
    };

    if (sdkReady) {
      var previousOnReady = window[sdkReady];

      window[sdkReady] = function () {
        if (previousOnReady) previousOnReady();
        onLoaded(window[sdkGlobal]);
      };
    }

    fetchScript(url, function (err) {
      if (err) {
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(function (request) {
          return request.reject(err);
        });
        requests[url] = null;
      } else if (!sdkReady) {
        onLoaded(window[sdkGlobal]);
      }
    });
  });
}

function getConfig(props, defaultProps, showWarning) {
  var config = (0, _deepmerge["default"])(defaultProps.config, props.config);

  var _iterator = _createForOfIteratorHelper(_props.DEPRECATED_CONFIG_PROPS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;

      if (props[p]) {
        var key = p.replace(/Config$/, '');
        config = (0, _deepmerge["default"])(config, _defineProperty({}, key, props[p]));

        if (showWarning) {
          var link = 'https://github.com/CookPete/react-player#config-prop';
          var message = "ReactPlayer: %c".concat(p, " %cis deprecated, please use the config prop instead \u2013 ").concat(link);
          console.warn(message, 'font-weight: bold', '');
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return config;
}

function omit(object) {
  var _ref;

  for (var _len = arguments.length, arrays = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    arrays[_key - 1] = arguments[_key];
  }

  var omitKeys = (_ref = []).concat.apply(_ref, arrays);

  var output = {};
  var keys = Object.keys(object);

  for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
    var key = _keys[_i2];

    if (omitKeys.indexOf(key) === -1) {
      output[key] = object[key];
    }
  }

  return output;
}

function callPlayer(method) {
  var _this$player;

  // Util method for calling a method on this.player
  // but guard against errors and console.warn instead
  if (!this.player || !this.player[method]) {
    var message = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(method, "%c \u2013 ");

    if (!this.player) {
      message += 'The player was not available';
    } else if (!this.player[method]) {
      message += 'The method was not available';
    }

    console.warn(message, 'font-weight: bold', '');
    return null;
  }

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return (_this$player = this.player)[method].apply(_this$player, args);
}

function isObject(val) {
  return val !== null && _typeof(val) === 'object';
} // Deep comparison of two objects, but ignoring functions
// and React elements, for use in shouldComponentUpdate


function isEqual(a, b) {
  if (typeof a === 'function' && typeof b === 'function') {
    return true;
  }

  if ((0, _react.isValidElement)(a) && (0, _react.isValidElement)(b)) {
    return true;
  }

  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false;
    }

    for (var i = 0; i !== a.length; i++) {
      if (!isEqual(a[i], b[i])) {
        return false;
      }
    }

    return true;
  }

  if (isObject(a) && isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (var _i3 = 0, _Object$keys = Object.keys(a); _i3 < _Object$keys.length; _i3++) {
      var key = _Object$keys[_i3];

      if (!isEqual(a[key], b[key])) {
        return false;
      }
    }

    return true;
  }

  return a === b;
}

function isMediaStream(url) {
  return typeof window !== 'undefined' && typeof window.MediaStream !== 'undefined' && url instanceof window.MediaStream;
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ var nested = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createGenerateClassName/createGenerateClassName.js

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createGenerateClassName/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createStyles/createStyles.js
function createStyles(styles) {
  return styles;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createStyles/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/index.js

// CONCATENATED MODULE: ./node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function tiny_warning_esm_warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (tiny_warning_esm_warning);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/is-in-browser/dist/module.js
var module__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : module__typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : module__typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ var module = (isBrowser);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(324);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(438);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(110);

// CONCATENATED MODULE: ./node_modules/jss/dist/jss.esm.js








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var jss_esm_escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var jss_esm_StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(inheritsLoose["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(assertThisInitialized["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + jss_esm_escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(esm_extends["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(createClass["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new jss_esm_StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var jss_esm_ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new jss_esm_RuleList(Object(esm_extends["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new jss_esm_ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var jss_esm_KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : jss_esm_escape(generateId(this, sheet));
    this.rules = new jss_esm_RuleList(Object(esm_extends["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(esm_extends["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var jss_esm_replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var jss_esm_plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new jss_esm_KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) jss_esm_replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) jss_esm_replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var jss_esm_KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(inheritsLoose["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(esm_extends["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new jss_esm_KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, jss_esm_plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var jss_esm_RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(esm_extends["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + jss_esm_escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof jss_esm_StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof jss_esm_KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof jss_esm_StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof jss_esm_KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var jss_esm_StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(esm_extends["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new jss_esm_RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var jss_esm_SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  Object(createClass["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new jss_esm_SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof jss_esm_StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var jss_esm_Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.6.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: module ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(esm_extends["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new jss_esm_StyleSheet(styles, Object(esm_extends["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = Object(esm_extends["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var jss_esm_SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    tiny_warning_esm(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      tiny_warning_esm(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(createClass["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var jss_esm_create = function create(options) {
  return new jss_esm_Jss(options);
};
/**
 * A global Jss instance.
 */

var jss_esm_jss = jss_esm_create();

/* harmony default export */ var jss_esm = (jss_esm_jss);


// CONCATENATED MODULE: ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var jss_plugin_rule_value_function_esm_functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ var jss_plugin_rule_value_function_esm = (jss_plugin_rule_value_function_esm_functionPlugin);

// CONCATENATED MODULE: ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js



var at = '@global';
var atPrefix = '@global ';

var jss_plugin_global_esm_GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new jss_esm_RuleList(Object(esm_extends["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var jss_plugin_global_esm_GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(esm_extends["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(esm_extends["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(esm_extends["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new jss_plugin_global_esm_GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new jss_plugin_global_esm_GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ var jss_plugin_global_esm = (jssGlobal);

// CONCATENATED MODULE: ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js



var jss_plugin_nested_esm_separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var jss_plugin_nested_esm_refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(jss_plugin_nested_esm_separatorRegExp);
    var nestedSelectors = nestedProp.split(jss_plugin_nested_esm_separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(esm_extends["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(esm_extends["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(jss_plugin_nested_esm_refRegExp, replaceRef);
        container.addRule(selector, style[prop], Object(esm_extends["a" /* default */])({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ var jss_plugin_nested_esm = (jssNested);

// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);

// CONCATENATED MODULE: ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js


var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_default_unit_esm = (defaultUnit);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(146);

// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css_vendor_esm_css = '';
var vendor = '';
var browser = '';
var isTouch = module && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (module) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      css_vendor_esm_style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var css_vendor_esm_key in jsCssMap) {
    if (css_vendor_esm_key + testProp in css_vendor_esm_style) {
      js = css_vendor_esm_key;
      css_vendor_esm_css = jsCssMap[css_vendor_esm_key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in css_vendor_esm_style) {
    js = 'ms';
    css_vendor_esm_css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in css_vendor_esm_style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var css_vendor_esm_prefix = {
  js: js,
  css: css_vendor_esm_css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (css_vendor_esm_prefix.js === 'ms') return key;
  return "@" + css_vendor_esm_prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (css_vendor_esm_prefix.js === 'ms') return "-webkit-" + prop;
    return css_vendor_esm_prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (css_vendor_esm_prefix.js === 'Webkit') return css_vendor_esm_prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (css_vendor_esm_prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (css_vendor_esm_prefix.js + pascalize(longhand) in style) {
        return css_vendor_esm_prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (css_vendor_esm_prefix.vendor === 'apple' && !css_vendor_esm_prefix.isTouch) {
      return css_vendor_esm_prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return css_vendor_esm_prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return css_vendor_esm_prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (css_vendor_esm_prefix.js === 'Webkit' || css_vendor_esm_prefix.js === 'ms' && css_vendor_esm_prefix.browser !== 'edge') {
      return css_vendor_esm_prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (css_vendor_esm_prefix.js === 'Moz' || css_vendor_esm_prefix.js === 'ms' || css_vendor_esm_prefix.vendor === 'apple') {
      return css_vendor_esm_prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (css_vendor_esm_prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? css_vendor_esm_prefix.css + "column-" + prop : false;
    }

    if (css_vendor_esm_prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (css_vendor_esm_prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return css_vendor_esm_prefix.js + pascalize(newProp) in style ? css_vendor_esm_prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (css_vendor_esm_prefix.js + pascalized in style) return css_vendor_esm_prefix.css + prop; // Try webkit fallback.

    if (css_vendor_esm_prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (css_vendor_esm_prefix.js === 'ms') {
      return "" + css_vendor_esm_prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (css_vendor_esm_prefix.js === 'ms') {
      return css_vendor_esm_prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return css_vendor_esm_prefix.js + pascalize(newProp) in style ? css_vendor_esm_prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return css_vendor_esm_prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return css_vendor_esm_prefix.js + pascalize(newProp) in style ? css_vendor_esm_prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(css_vendor_esm_prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var css_vendor_esm_plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = css_vendor_esm_plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = css_vendor_esm_plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(toConsumableArray["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var css_vendor_esm_cache = {};

if (module) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) css_vendor_esm_cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete css_vendor_esm_cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && css_vendor_esm_cache[prop] != null) {
    return css_vendor_esm_cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    css_vendor_esm_cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (css_vendor_esm_cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return css_vendor_esm_cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (module) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = css_vendor_esm_prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);

// CONCATENATED MODULE: ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ var jss_plugin_props_sort_esm = (jssPropsSort);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/jssPreset/jssPreset.js






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [jss_plugin_rule_value_function_esm(), jss_plugin_global_esm(), jss_plugin_nested_esm(), jss_plugin_camel_case_esm(), jss_plugin_default_unit_esm(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jss_plugin_vendor_prefixer_esm(), jss_plugin_props_sort_esm()]
  };
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/jssPreset/index.js

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(esm_extends["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/useTheme/ThemeContext.js

var ThemeContext = react_default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

/* harmony default export */ var useTheme_ThemeContext = (ThemeContext);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js


function useTheme() {
  var theme = react_default.a.useContext(useTheme_ThemeContext);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/useTheme/index.js

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js







 // Default JSS instance.

var StylesProvider_jss = jss_esm_create(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var StylesProvider_generateClassName = createGenerateClassName(); // Exported for test purposes

var StylesProvider_sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: StylesProvider_generateClassName,
  jss: StylesProvider_jss,
  sheetsCache: null,
  sheetsManager: StylesProvider_sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react_default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(objectWithoutProperties["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = react_default.a.useContext(StylesContext);

  var context = Object(esm_extends["a" /* default */])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = jss_esm_create({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/react_default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/index.js


// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(255);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme_noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme_noopTheme);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(esm_extends["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(esm["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(esm_extends["a" /* default */])({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(esm_extends["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(esm_extends["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = react_default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = react_default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  react_default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme,
      stylesOptions2 = Object(objectWithoutProperties["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = Object(esm_extends["a" /* default */])({}, react_default.a.useContext(StylesContext), stylesOptions2);

    var instance = react_default.a.useRef();
    var shouldUpdate = react_default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react_default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/index.js

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(439);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ServerStyleSheets/ServerStyleSheets.js








var ServerStyleSheets_ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(classCallCheck["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(createClass["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new jss_esm_SheetsRegistry(); // A new class name generator

      var generateClassName = createGenerateClassName();
      return /*#__PURE__*/react_default.a.createElement(StylesProvider, Object(esm_extends["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return /*#__PURE__*/react_default.a.createElement('style', Object(esm_extends["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();


// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ServerStyleSheets/index.js

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(136);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/styled/styled.js









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(objectWithoutProperties["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(esm_extends["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = makeStyles(stylesOrCreator, Object(esm_extends["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/react_default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(clsx_m["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/react_default.a.cloneElement(children, Object(esm_extends["a" /* default */])({
          className: Object(clsx_m["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(esm_extends["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/react_default.a.createElement(FinalComponent, Object(esm_extends["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes
      /* @typescript-to-proptypes-ignore */
      .elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    hoist_non_react_statics_cjs_default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/styled/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(esm_extends["a" /* default */])({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = useTheme();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = react_default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/react_default.a.createElement(useTheme_ThemeContext.Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withStyles/withStyles.js








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles_withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(objectWithoutProperties["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, Object(esm_extends["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/react_default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(esm_extends["a" /* default */])({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoist_non_react_statics_cjs_default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ var esm_withStyles_withStyles = (withStyles_withStyles);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withStyles/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withTheme/withTheme.js







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = /*#__PURE__*/react_default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(objectWithoutProperties["a" /* default */])(props, ["innerRef"]);

      var theme = useTheme() || defaultTheme;
      return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    hoist_non_react_statics_cjs_default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme_withTheme = withThemeCreator();
/* harmony default export */ var esm_withTheme_withTheme = (withTheme_withTheme);
// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withTheme/index.js


// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return createGenerateClassName; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return createStyles; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return getThemeProps; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return jssPreset; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return makeStyles; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return mergeClasses; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ServerStyleSheets_ServerStyleSheets; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return styled; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return StylesProvider; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return StylesProvider_sheetsManager; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return StylesContext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return ThemeProvider_ThemeProvider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return useTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return esm_withStyles_withStyles; });
/* unused concated harmony import withTheme */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_withTheme_withTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return withThemeCreator; });
/** @license Material-UI v4.11.4
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























/***/ }),
/* 93 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(228);
var defined = __webpack_require__(121);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(229);
var createDesc = __webpack_require__(172);
var toIObject = __webpack_require__(95);
var toPrimitive = __webpack_require__(120);
var has = __webpack_require__(94);
var IE8_DOM_DEFINE = __webpack_require__(496);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(49) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(94);
var toObject = __webpack_require__(54);
var IE_PROTO = __webpack_require__(359)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOrgFlags = exports.cloneCourse = exports.fetchCloneableJourneys = exports.cloneMasterCourse = exports.fetchCloneableMasterCourses = exports.publishJourney = exports.returnPublishedActivityToDraft = exports.publishActivity = exports.editMentorActivityCourse = exports.deleteMentorActivityCourse = exports.createNewCourse = exports.fetchActivityCourseJourneys = exports.fetchAllMentorMasterCourses = exports.fetchMentorMasterCourses = exports.fetchAcademicYears = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _qs = __webpack_require__(551);

var _qs2 = _interopRequireDefault(_qs);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchAcademicYears = exports.fetchAcademicYears = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(orgId, token) {
    var url, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/academic_years';
            _context.prev = 1;
            _context.t0 = _utils.checkHttpStatus;
            _context.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt('return', _context.sent);

          case 12:
            _context.prev = 12;
            _context.t2 = _context['catch'](1);

            console.log('ERROR', _context.t2);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 12]]);
  }));

  return function fetchAcademicYears(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchMentorMasterCourses = exports.fetchMentorMasterCourses = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orgId, token, academicYearId) {
    var params, url, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = _qs2.default.stringify({
              q: {
                academic_year_id_eq: academicYearId
              }
            });
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses?' + params;
            _context2.prev = 2;
            _context2.t0 = _utils.checkHttpStatus;
            _context2.next = 6;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 6:
            _context2.t1 = _context2.sent;
            response = (0, _context2.t0)(_context2.t1);
            _context2.next = 10;
            return response.json();

          case 10:
            return _context2.abrupt('return', _context2.sent);

          case 13:
            _context2.prev = 13;
            _context2.t2 = _context2['catch'](2);

            console.log('ERROR', _context2.t2);

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[2, 13]]);
  }));

  return function fetchMentorMasterCourses(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchAllMentorMasterCourses = exports.fetchAllMentorMasterCourses = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(orgId, token) {
    var url, response;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses';
            _context3.prev = 1;
            _context3.t0 = _utils.checkHttpStatus;
            _context3.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context3.t1 = _context3.sent;
            response = (0, _context3.t0)(_context3.t1);
            _context3.next = 9;
            return response.json();

          case 9:
            return _context3.abrupt('return', _context3.sent);

          case 12:
            _context3.prev = 12;
            _context3.t2 = _context3['catch'](1);

            console.log('ERROR', _context3.t2);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[1, 12]]);
  }));

  return function fetchAllMentorMasterCourses(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchActivityCourseJourneys = exports.fetchActivityCourseJourneys = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(orgId, token, activityCourseId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses/' + activityCourseId + '/courses';
            _context4.prev = 1;
            _context4.t0 = _utils.checkHttpStatus;
            _context4.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context4.t1 = _context4.sent;
            response = (0, _context4.t0)(_context4.t1);
            _context4.next = 9;
            return response.json();

          case 9:
            data = _context4.sent;
            return _context4.abrupt('return', data);

          case 13:
            _context4.prev = 13;
            _context4.t2 = _context4['catch'](1);

            console.log('ERROR', _context4.t2);

          case 16:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[1, 13]]);
  }));

  return function fetchActivityCourseJourneys(_x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var createNewCourse = exports.createNewCourse = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(apiData, selectedCourseLevel, selectedFrameworkSubject, courseName, abbreviation, courseColor, selectedAcademicYearId) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses';
            data = {
              master_course: {
                name: courseName,
                abbreviation: abbreviation,
                grade_level_id: selectedCourseLevel.id,
                framework_subject_id: selectedFrameworkSubject.id,
                academic_year_id: selectedAcademicYearId,
                color: courseColor.replace('#', '')
              }
            };
            _context5.prev = 2;
            _context5.t0 = _utils.checkHttpStatus;
            _context5.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context5.t1 = _context5.sent;
            response = (0, _context5.t0)(_context5.t1);
            _context5.next = 10;
            return response.json();

          case 10:
            return _context5.abrupt('return', _context5.sent);

          case 13:
            _context5.prev = 13;
            _context5.t2 = _context5['catch'](2);

            console.log('ERROR', _context5.t2);

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[2, 13]]);
  }));

  return function createNewCourse(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
    return _ref5.apply(this, arguments);
  };
}();

var deleteMentorActivityCourse = exports.deleteMentorActivityCourse = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(apiData, activityCourseId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId;
            _context6.prev = 1;
            _context6.t0 = _utils.checkHttpStatus;
            _context6.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context6.t1 = _context6.sent;
            response = (0, _context6.t0)(_context6.t1);
            _context6.next = 9;
            return response;

          case 9:
            return _context6.abrupt('return', _context6.sent);

          case 12:
            _context6.prev = 12;
            _context6.t2 = _context6['catch'](1);

            console.log('ERROR', _context6.t2);

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[1, 12]]);
  }));

  return function deleteMentorActivityCourse(_x18, _x19) {
    return _ref6.apply(this, arguments);
  };
}();

var editMentorActivityCourse = exports.editMentorActivityCourse = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(apiData, courseName, abbreviation, courseColor, activityCourse) {
    var url, response;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourse.id;
            _context7.prev = 1;
            _context7.t0 = _utils.checkHttpStatus;
            _context7.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                master_course: {
                  name: courseName,
                  abbreviation: abbreviation,
                  color: courseColor.replace('#', '')
                }
              })
            });

          case 5:
            _context7.t1 = _context7.sent;
            response = (0, _context7.t0)(_context7.t1);
            _context7.next = 9;
            return response.json();

          case 9:
            return _context7.abrupt('return', _context7.sent);

          case 12:
            _context7.prev = 12;
            _context7.t2 = _context7['catch'](1);

            console.log(_context7.t2);

          case 15:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[1, 12]]);
  }));

  return function editMentorActivityCourse(_x20, _x21, _x22, _x23, _x24) {
    return _ref7.apply(this, arguments);
  };
}();

var publishActivity = exports.publishActivity = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(apiData, levelId, activityQuestId) {
    var url;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/publish';
            _context8.prev = 1;
            _context8.t0 = _utils.checkHttpStatus;
            _context8.next = 5;
            return fetch(url, {
              method: 'PUT',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context8.t1 = _context8.sent;
            (0, _context8.t0)(_context8.t1);
            _context8.next = 11;
            break;

          case 9:
            _context8.prev = 9;
            _context8.t2 = _context8['catch'](1);

          case 11:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[1, 9]]);
  }));

  return function publishActivity(_x25, _x26, _x27) {
    return _ref8.apply(this, arguments);
  };
}();

var returnPublishedActivityToDraft = exports.returnPublishedActivityToDraft = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(apiData, levelId, activityQuestId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/return_to_draft';
            _context9.prev = 1;
            _context9.t0 = _utils.checkHttpStatus;
            _context9.next = 5;
            return fetch(url, {
              method: 'PUT',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context9.t1 = _context9.sent;
            response = (0, _context9.t0)(_context9.t1);
            _context9.next = 9;
            return response.json();

          case 9:
            return _context9.abrupt('return', _context9.sent);

          case 12:
            _context9.prev = 12;
            _context9.t2 = _context9['catch'](1);

          case 14:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[1, 12]]);
  }));

  return function returnPublishedActivityToDraft(_x28, _x29, _x30) {
    return _ref9.apply(this, arguments);
  };
}();

var publishJourney = exports.publishJourney = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(apiData, activityCourseId, journeyId) {
    var url;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/publish';
            _context10.prev = 1;
            _context10.t0 = _utils.checkHttpStatus;
            _context10.next = 5;
            return fetch(url, {
              method: 'PUT',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context10.t1 = _context10.sent;
            (0, _context10.t0)(_context10.t1);
            _context10.next = 11;
            break;

          case 9:
            _context10.prev = 9;
            _context10.t2 = _context10['catch'](1);

          case 11:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[1, 9]]);
  }));

  return function publishJourney(_x31, _x32, _x33) {
    return _ref10.apply(this, arguments);
  };
}();

var fetchCloneableMasterCourses = exports.fetchCloneableMasterCourses = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(orgId, token) {
    var url, response, resJSON;
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses_cloner';
            _context11.prev = 1;
            _context11.t0 = _utils.checkHttpStatus;
            _context11.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context11.t1 = _context11.sent;
            response = (0, _context11.t0)(_context11.t1);
            _context11.next = 9;
            return response.json();

          case 9:
            resJSON = _context11.sent;

            if (!(response.status === 403)) {
              _context11.next = 12;
              break;
            }

            throw new Error('ERROR 403!!!!!!!');

          case 12:
            return _context11.abrupt('return', resJSON);

          case 15:
            _context11.prev = 15;
            _context11.t2 = _context11['catch'](1);

            console.log('ERROR', _context11.t2);

          case 18:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, undefined, [[1, 15]]);
  }));

  return function fetchCloneableMasterCourses(_x34, _x35) {
    return _ref11.apply(this, arguments);
  };
}();

var cloneMasterCourse = exports.cloneMasterCourse = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(apiData, masterCourseId, academicYearId, courseName, abbreviation, color, frameworkSubjectId, gradeLevelId) {
    var params, url, response;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            params = _qs2.default.stringify({
              q: {
                academic_year_id_eq: academicYearId,
                name: courseName,
                abbreviation: abbreviation,
                color: color.replace('#', ''),
                framework_subject_id: frameworkSubjectId,
                grade_level_id: gradeLevelId
              }
            });
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + masterCourseId + '/master_courses_cloner?' + params;
            _context12.prev = 2;
            _context12.t0 = _utils.checkHttpStatus;
            _context12.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 6:
            _context12.t1 = _context12.sent;
            response = (0, _context12.t0)(_context12.t1);
            _context12.next = 10;
            return response.json();

          case 10:
            return _context12.abrupt('return', _context12.sent);

          case 13:
            _context12.prev = 13;
            _context12.t2 = _context12['catch'](2);

            console.log(_context12.t2);

          case 16:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, undefined, [[2, 13]]);
  }));

  return function cloneMasterCourse(_x36, _x37, _x38, _x39, _x40, _x41, _x42, _x43) {
    return _ref12.apply(this, arguments);
  };
}();

var fetchCloneableJourneys = exports.fetchCloneableJourneys = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(orgId, token, masterCourseId) {
    var params, url, response;
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            params = _qs2.default.stringify({
              q: {
                master_course_id: masterCourseId
              }
            });
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/courses_cloner?' + params;


            console.log('url', url);
            _context13.prev = 3;
            _context13.t0 = _utils.checkHttpStatus;
            _context13.next = 7;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 7:
            _context13.t1 = _context13.sent;
            response = (0, _context13.t0)(_context13.t1);
            _context13.next = 11;
            return response.json();

          case 11:
            return _context13.abrupt('return', _context13.sent);

          case 14:
            _context13.prev = 14;
            _context13.t2 = _context13['catch'](3);

            console.log('ERROR', _context13.t2);

          case 17:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[3, 14]]);
  }));

  return function fetchCloneableJourneys(_x44, _x45, _x46) {
    return _ref13.apply(this, arguments);
  };
}();

var cloneCourse = exports.cloneCourse = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(apiData, activityCourseId, selectedJourneyId, name, description, color) {
    var params, url, response;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            params = _qs2.default.stringify({
              q: {
                master_course_id: activityCourseId,
                name: name,
                description: description,
                color: color
              }
            });
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/courses/' + selectedJourneyId + '/courses_cloner?' + params;
            _context14.prev = 2;
            _context14.t0 = _utils.checkHttpStatus;
            _context14.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 6:
            _context14.t1 = _context14.sent;
            response = (0, _context14.t0)(_context14.t1);
            _context14.next = 10;
            return response.json();

          case 10:
            return _context14.abrupt('return', _context14.sent);

          case 13:
            _context14.prev = 13;
            _context14.t2 = _context14['catch'](2);

            console.log(_context14.t2);

          case 16:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, undefined, [[2, 13]]);
  }));

  return function cloneCourse(_x47, _x48, _x49, _x50, _x51, _x52) {
    return _ref14.apply(this, arguments);
  };
}();

var fetchOrgFlags = exports.fetchOrgFlags = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(orgId, token) {
    var url, response;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            url = (0, _utils.getBaseUrl)() + '/api/organizations/' + orgId;
            _context15.prev = 1;
            _context15.t0 = _utils.checkHttpStatus;
            _context15.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context15.t1 = _context15.sent;
            response = (0, _context15.t0)(_context15.t1);
            _context15.next = 9;
            return response.json();

          case 9:
            return _context15.abrupt('return', _context15.sent);

          case 12:
            _context15.prev = 12;
            _context15.t2 = _context15['catch'](1);
            throw new Error(_context15.t2);

          case 15:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, undefined, [[1, 12]]);
  }));

  return function fetchOrgFlags(_x53, _x54) {
    return _ref15.apply(this, arguments);
  };
}();

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteLinkedSkill = exports.addLinkedSkill = exports.fetchLinkedSkills = exports.deleteExistingResource = exports.deleteNewResource = exports.fileUploadToResource = exports.clearResourceFile = exports.reorderResources = exports.updateResource = exports.createResource = exports.fetchResource = exports.fetchResources = exports.deleteMentorFile = exports.reorderMentorFile = exports.editMentorFile = exports.uploadMentorFile = exports.fetchMentorFiles = exports.removeActivityIcon = exports.uploadImage = exports.reorderActivities = exports.moveActivityToDifferentLevel = exports.fetchActivityMentorFiles = exports.fetchSingleActivity = exports.editLevelActivity = exports.deleteLevelActivity = exports.createNewLevelActivity = exports.fetchLevelActivities = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchLevelActivities = exports.fetchLevelActivities = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(apiData, levelId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests';
            _context.prev = 1;
            _context.t0 = _utils.checkHttpStatus;
            _context.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            _context.next = 9;
            return response.json();

          case 9:
            data = _context.sent;
            return _context.abrupt('return', data);

          case 13:
            _context.prev = 13;
            _context.t2 = _context['catch'](1);

            console.log(_context.t2);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 13]]);
  }));

  return function fetchLevelActivities(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createNewLevelActivity = exports.createNewLevelActivity = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(apiData, levelId, activityName) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests';
            data = {
              activity_quest: { name: activityName }
            };
            _context2.prev = 2;
            _context2.t0 = _utils.checkHttpStatus;
            _context2.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context2.t1 = _context2.sent;
            response = (0, _context2.t0)(_context2.t1);
            _context2.next = 10;
            return response.json();

          case 10:
            return _context2.abrupt('return', _context2.sent);

          case 13:
            _context2.prev = 13;
            _context2.t2 = _context2['catch'](2);

            console.log(_context2.t2);

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[2, 13]]);
  }));

  return function createNewLevelActivity(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var deleteLevelActivity = exports.deleteLevelActivity = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(apiData, levelId, activityQuestId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId;
            _context3.prev = 1;
            _context3.t0 = _utils.checkHttpStatus;
            _context3.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context3.t1 = _context3.sent;
            response = (0, _context3.t0)(_context3.t1);
            _context3.next = 9;
            return response;

          case 9:
            return _context3.abrupt('return', _context3.sent);

          case 12:
            _context3.prev = 12;
            _context3.t2 = _context3['catch'](1);

            console.log(_context3.t2);

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[1, 12]]);
  }));

  return function deleteLevelActivity(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var editLevelActivity = exports.editLevelActivity = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(apiData, levelId, activity) {
    var url, response;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activity.id;
            _context4.prev = 1;
            _context4.t0 = _utils.checkHttpStatus;
            _context4.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                activity_quest: {
                  name: activity.name,
                  description: activity.description,
                  driving_question: activity.driving_question,
                  goals: activity.goals,
                  mentor_notes: activity.mentor_notes,
                  mentor_assessment_questions: activity.mentor_assessment_questions,
                  artifact_description: activity.artifact_description,
                  artifact_type_id: activity.artifact_type_id,
                  checkpoint: activity.checkpoint,
                  work_product: activity.work_product
                }
              })
            });

          case 5:
            _context4.t1 = _context4.sent;
            response = (0, _context4.t0)(_context4.t1);
            _context4.next = 9;
            return response.json();

          case 9:
            return _context4.abrupt('return', _context4.sent);

          case 12:
            _context4.prev = 12;
            _context4.t2 = _context4['catch'](1);

            console.log(_context4.t2);

          case 15:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[1, 12]]);
  }));

  return function editLevelActivity(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchSingleActivity = exports.fetchSingleActivity = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(apiData, levelId, activityQuestId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId;
            _context5.prev = 1;
            _context5.t0 = _utils.checkHttpStatus;
            _context5.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context5.t1 = _context5.sent;
            response = (0, _context5.t0)(_context5.t1);
            _context5.next = 9;
            return response.json();

          case 9:
            data = _context5.sent;
            return _context5.abrupt('return', data);

          case 13:
            _context5.prev = 13;
            _context5.t2 = _context5['catch'](1);

            console.log(_context5.t2);

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[1, 13]]);
  }));

  return function fetchSingleActivity(_x12, _x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchActivityMentorFiles = exports.fetchActivityMentorFiles = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(apiData, levelId, activityQuestId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files';
            _context6.prev = 1;
            _context6.t0 = _utils.checkHttpStatus;
            _context6.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context6.t1 = _context6.sent;
            response = (0, _context6.t0)(_context6.t1);
            _context6.next = 9;
            return response.json();

          case 9:
            data = _context6.sent;
            return _context6.abrupt('return', data);

          case 13:
            _context6.prev = 13;
            _context6.t2 = _context6['catch'](1);

            console.log(_context6.t2);

          case 16:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[1, 13]]);
  }));

  return function fetchActivityMentorFiles(_x15, _x16, _x17) {
    return _ref6.apply(this, arguments);
  };
}();

var moveActivityToDifferentLevel = exports.moveActivityToDifferentLevel = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(apiData, levelId, activityQuestId, newLevelId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/change_level';
            _context7.prev = 1;
            _context7.t0 = _utils.checkHttpStatus;
            _context7.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                activity_quest: {
                  new_level_id: newLevelId
                }
              })
            });

          case 5:
            _context7.t1 = _context7.sent;
            response = (0, _context7.t0)(_context7.t1);
            _context7.next = 9;
            return response.json();

          case 9:
            return _context7.abrupt('return', _context7.sent);

          case 12:
            _context7.prev = 12;
            _context7.t2 = _context7['catch'](1);

            console.log(_context7.t2);

          case 15:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[1, 12]]);
  }));

  return function moveActivityToDifferentLevel(_x18, _x19, _x20, _x21) {
    return _ref7.apply(this, arguments);
  };
}();

var reorderActivities = exports.reorderActivities = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(apiData, levelId, activityQuestId, sortOrderPosition) {
    var url, response;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/update_position';
            _context8.prev = 1;
            _context8.t0 = _utils.checkHttpStatus;
            _context8.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                activity_quest: {
                  sort_order_position: sortOrderPosition
                }
              })
            });

          case 5:
            _context8.t1 = _context8.sent;
            response = (0, _context8.t0)(_context8.t1);
            _context8.next = 9;
            return response.json();

          case 9:
            return _context8.abrupt('return', _context8.sent);

          case 12:
            _context8.prev = 12;
            _context8.t2 = _context8['catch'](1);

            console.log('ERROR', _context8.t2);

          case 15:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[1, 12]]);
  }));

  return function reorderActivities(_x22, _x23, _x24, _x25) {
    return _ref8.apply(this, arguments);
  };
}();

var uploadImage = exports.uploadImage = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(apiData, levelId, activityQuestId, type, dataUri, fileName) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/update_icon_image';
            data = new FormData();

            data.append('activity_quest[' + type + '_image]', (0, _utils.dataUriToBlob)(dataUri), fileName);

            _context9.prev = 3;
            _context9.t0 = _utils.checkHttpStatus;
            _context9.next = 7;
            return fetch(url, {
              method: 'PATCH',
              headers: {
                Authorization: 'Token token="' + apiData.token + '"',
                Accept: 'application/vnd.oefngl.v3'
              },
              body: data
            });

          case 7:
            _context9.t1 = _context9.sent;
            response = (0, _context9.t0)(_context9.t1);
            _context9.next = 11;
            return response.json();

          case 11:
            return _context9.abrupt('return', _context9.sent);

          case 14:
            _context9.prev = 14;
            _context9.t2 = _context9['catch'](3);

            console.log(_context9.t2);

          case 17:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[3, 14]]);
  }));

  return function uploadImage(_x26, _x27, _x28, _x29, _x30, _x31) {
    return _ref9.apply(this, arguments);
  };
}();

var removeActivityIcon = exports.removeActivityIcon = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(apiData, levelId, activityQuestId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/update_icon_image';
            _context10.prev = 1;
            _context10.t0 = _utils.checkHttpStatus;
            _context10.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                activity_quest: {
                  remove_icon_image: true
                }
              })
            });

          case 5:
            _context10.t1 = _context10.sent;
            response = (0, _context10.t0)(_context10.t1);
            _context10.next = 9;
            return response.json();

          case 9:
            return _context10.abrupt('return', _context10.sent);

          case 12:
            _context10.prev = 12;
            _context10.t2 = _context10['catch'](1);

            console.log('ERROR', _context10.t2);

          case 15:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[1, 12]]);
  }));

  return function removeActivityIcon(_x32, _x33, _x34) {
    return _ref10.apply(this, arguments);
  };
}();

var fetchMentorFiles = exports.fetchMentorFiles = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(apiData, levelId, activityQuestId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files';
            _context11.prev = 1;
            _context11.t0 = _utils.checkHttpStatus;
            _context11.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context11.t1 = _context11.sent;
            response = (0, _context11.t0)(_context11.t1);
            _context11.next = 9;
            return response.json();

          case 9:
            data = _context11.sent;
            return _context11.abrupt('return', data);

          case 13:
            _context11.prev = 13;
            _context11.t2 = _context11['catch'](1);

            console.log(_context11.t2);

          case 16:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, undefined, [[1, 13]]);
  }));

  return function fetchMentorFiles(_x35, _x36, _x37) {
    return _ref11.apply(this, arguments);
  };
}();

var uploadMentorFile = exports.uploadMentorFile = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(apiData, levelId, activityQuestId, file, description) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files';
            data = new FormData();

            data.append('mentor_file[description]', description || '');
            data.append('mentor_file[attachment]', file);
            _context12.prev = 4;
            _context12.t0 = _utils.checkHttpStatus;
            _context12.next = 8;
            return fetch(url, {
              method: 'POST',
              headers: {
                Authorization: 'Token token="' + apiData.token + '"',
                Accept: 'application/vnd.oefngl.v3'
              },
              body: data
            });

          case 8:
            _context12.t1 = _context12.sent;
            response = (0, _context12.t0)(_context12.t1);
            _context12.next = 12;
            return response.json();

          case 12:
            return _context12.abrupt('return', _context12.sent);

          case 15:
            _context12.prev = 15;
            _context12.t2 = _context12['catch'](4);

            console.log(_context12.t2);

          case 18:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, undefined, [[4, 15]]);
  }));

  return function uploadMentorFile(_x38, _x39, _x40, _x41, _x42) {
    return _ref12.apply(this, arguments);
  };
}();

var editMentorFile = exports.editMentorFile = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(apiData, levelId, activityQuestId, description, id) {
    var url, response;
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files/' + id;
            _context13.prev = 1;
            _context13.t0 = _utils.checkHttpStatus;
            _context13.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                mentor_file: { description: description }
              })
            });

          case 5:
            _context13.t1 = _context13.sent;
            response = (0, _context13.t0)(_context13.t1);
            _context13.next = 9;
            return response.json();

          case 9:
            return _context13.abrupt('return', _context13.sent);

          case 12:
            _context13.prev = 12;
            _context13.t2 = _context13['catch'](1);

            console.log(_context13.t2);

          case 15:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[1, 12]]);
  }));

  return function editMentorFile(_x43, _x44, _x45, _x46, _x47) {
    return _ref13.apply(this, arguments);
  };
}();

var reorderMentorFile = exports.reorderMentorFile = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(apiData, levelId, activityQuestId, id, index) {
    var url, response;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files/' + id;
            _context14.prev = 1;
            _context14.t0 = _utils.checkHttpStatus;
            _context14.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                mentor_file: { sort_order_position: index }
              })
            });

          case 5:
            _context14.t1 = _context14.sent;
            response = (0, _context14.t0)(_context14.t1);
            _context14.next = 9;
            return response.json();

          case 9:
            return _context14.abrupt('return', _context14.sent);

          case 12:
            _context14.prev = 12;
            _context14.t2 = _context14['catch'](1);

            console.log(_context14.t2);

          case 15:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, undefined, [[1, 12]]);
  }));

  return function reorderMentorFile(_x48, _x49, _x50, _x51, _x52) {
    return _ref14.apply(this, arguments);
  };
}();

var deleteMentorFile = exports.deleteMentorFile = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(apiData, levelId, activityQuestId, mentorFileId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/mentor_files/' + mentorFileId;
            _context15.prev = 1;
            _context15.t0 = _utils.checkHttpStatus;
            _context15.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context15.t1 = _context15.sent;
            response = (0, _context15.t0)(_context15.t1);
            _context15.next = 9;
            return response.json();

          case 9:
            return _context15.abrupt('return', _context15.sent);

          case 12:
            _context15.prev = 12;
            _context15.t2 = _context15['catch'](1);

            console.log('ERROR', _context15.t2);

          case 15:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, undefined, [[1, 12]]);
  }));

  return function deleteMentorFile(_x53, _x54, _x55, _x56) {
    return _ref15.apply(this, arguments);
  };
}();

var fetchResources = exports.fetchResources = function () {
  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(apiData, levelId, activityQuestId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources';
            _context16.prev = 1;
            _context16.t0 = _utils.checkHttpStatus;
            _context16.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context16.t1 = _context16.sent;
            response = (0, _context16.t0)(_context16.t1);
            _context16.next = 9;
            return response.json();

          case 9:
            data = _context16.sent;
            return _context16.abrupt('return', data);

          case 13:
            _context16.prev = 13;
            _context16.t2 = _context16['catch'](1);

            console.log(_context16.t2);

          case 16:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, undefined, [[1, 13]]);
  }));

  return function fetchResources(_x57, _x58, _x59) {
    return _ref16.apply(this, arguments);
  };
}();

var fetchResource = exports.fetchResource = function () {
  var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(apiData, levelId, activityQuestId, resourceId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId;
            _context17.prev = 1;
            _context17.t0 = _utils.checkHttpStatus;
            _context17.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context17.t1 = _context17.sent;
            response = (0, _context17.t0)(_context17.t1);
            _context17.next = 9;
            return response.json();

          case 9:
            data = _context17.sent;
            return _context17.abrupt('return', data);

          case 13:
            _context17.prev = 13;
            _context17.t2 = _context17['catch'](1);

            console.log(_context17.t2);

          case 16:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, undefined, [[1, 13]]);
  }));

  return function fetchResource(_x60, _x61, _x62, _x63) {
    return _ref17.apply(this, arguments);
  };
}();

var createResource = exports.createResource = function () {
  var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(apiData, levelId, activityQuestId, resourceName) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources';
            data = {
              resource: { name: resourceName }
            };
            _context18.prev = 2;
            _context18.t0 = _utils.checkHttpStatus;
            _context18.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context18.t1 = _context18.sent;
            response = (0, _context18.t0)(_context18.t1);
            _context18.next = 10;
            return response.json();

          case 10:
            return _context18.abrupt('return', _context18.sent);

          case 13:
            _context18.prev = 13;
            _context18.t2 = _context18['catch'](2);

            console.log(_context18.t2);

          case 16:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, undefined, [[2, 13]]);
  }));

  return function createResource(_x64, _x65, _x66, _x67) {
    return _ref18.apply(this, arguments);
  };
}();

var updateResource = exports.updateResource = function () {
  var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(apiData, levelId, activityQuestId, resourceId, resource) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId;
            data = {
              resource: resource
            };
            _context19.prev = 2;
            _context19.t0 = _utils.checkHttpStatus;
            _context19.next = 6;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context19.t1 = _context19.sent;
            response = (0, _context19.t0)(_context19.t1);
            _context19.next = 10;
            return response.json();

          case 10:
            return _context19.abrupt('return', _context19.sent);

          case 13:
            _context19.prev = 13;
            _context19.t2 = _context19['catch'](2);

            console.log(_context19.t2);

          case 16:
          case 'end':
            return _context19.stop();
        }
      }
    }, _callee19, undefined, [[2, 13]]);
  }));

  return function updateResource(_x68, _x69, _x70, _x71, _x72) {
    return _ref19.apply(this, arguments);
  };
}();

var reorderResources = exports.reorderResources = function () {
  var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(apiData, levelId, activityQuestId, resourceId, index) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId;
            data = {
              resource: {
                sort_order_position: index
              }
            };
            _context20.prev = 2;
            _context20.t0 = _utils.checkHttpStatus;
            _context20.next = 6;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context20.t1 = _context20.sent;
            response = (0, _context20.t0)(_context20.t1);
            _context20.next = 10;
            return response.json();

          case 10:
            return _context20.abrupt('return', _context20.sent);

          case 13:
            _context20.prev = 13;
            _context20.t2 = _context20['catch'](2);

            console.log(_context20.t2);

          case 16:
          case 'end':
            return _context20.stop();
        }
      }
    }, _callee20, undefined, [[2, 13]]);
  }));

  return function reorderResources(_x73, _x74, _x75, _x76, _x77) {
    return _ref20.apply(this, arguments);
  };
}();

var clearResourceFile = exports.clearResourceFile = function () {
  var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(apiData, levelId, activityQuestId, resourceId) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId;
            data = {
              resource: {
                clear_resource_file: true
              }
            };
            _context21.prev = 2;
            _context21.t0 = _utils.checkHttpStatus;
            _context21.next = 6;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context21.t1 = _context21.sent;
            response = (0, _context21.t0)(_context21.t1);
            _context21.next = 10;
            return response.json();

          case 10:
            return _context21.abrupt('return', _context21.sent);

          case 13:
            _context21.prev = 13;
            _context21.t2 = _context21['catch'](2);

            console.log(_context21.t2);

          case 16:
          case 'end':
            return _context21.stop();
        }
      }
    }, _callee21, undefined, [[2, 13]]);
  }));

  return function clearResourceFile(_x78, _x79, _x80, _x81) {
    return _ref21.apply(this, arguments);
  };
}();

var fileUploadToResource = exports.fileUploadToResource = function () {
  var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(apiData, levelId, activityQuestId, resourceId, resource) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId + '/file';
            data = {
              resource: resource
            };
            _context22.prev = 2;
            _context22.t0 = _utils.checkHttpStatus;
            _context22.next = 6;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context22.t1 = _context22.sent;
            response = (0, _context22.t0)(_context22.t1);
            _context22.next = 10;
            return response.json();

          case 10:
            return _context22.abrupt('return', _context22.sent);

          case 13:
            _context22.prev = 13;
            _context22.t2 = _context22['catch'](2);

            console.log(_context22.t2);

          case 16:
          case 'end':
            return _context22.stop();
        }
      }
    }, _callee22, undefined, [[2, 13]]);
  }));

  return function fileUploadToResource(_x82, _x83, _x84, _x85, _x86) {
    return _ref22.apply(this, arguments);
  };
}();

var deleteNewResource = exports.deleteNewResource = function () {
  var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(apiData, levelId, activityQuestId, resourceId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourceId;
            _context23.prev = 1;
            _context23.t0 = _utils.checkHttpStatus;
            _context23.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                resource: { new_resource: true }
              })
            });

          case 5:
            _context23.t1 = _context23.sent;
            response = (0, _context23.t0)(_context23.t1);
            _context23.next = 9;
            return response;

          case 9:
            return _context23.abrupt('return', _context23.sent);

          case 12:
            _context23.prev = 12;
            _context23.t2 = _context23['catch'](1);

            console.log('ERROR', _context23.t2);

          case 15:
          case 'end':
            return _context23.stop();
        }
      }
    }, _callee23, undefined, [[1, 12]]);
  }));

  return function deleteNewResource(_x87, _x88, _x89, _x90) {
    return _ref23.apply(this, arguments);
  };
}();

var deleteExistingResource = exports.deleteExistingResource = function () {
  var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(apiData, levelId, activityQuestId, resourcesId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/resources/' + resourcesId;
            _context24.prev = 1;
            _context24.t0 = _utils.checkHttpStatus;
            _context24.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context24.t1 = _context24.sent;
            response = (0, _context24.t0)(_context24.t1);
            _context24.next = 9;
            return response.json();

          case 9:
            return _context24.abrupt('return', _context24.sent);

          case 12:
            _context24.prev = 12;
            _context24.t2 = _context24['catch'](1);

            console.log('ERROR', _context24.t2);

          case 15:
          case 'end':
            return _context24.stop();
        }
      }
    }, _callee24, undefined, [[1, 12]]);
  }));

  return function deleteExistingResource(_x91, _x92, _x93, _x94) {
    return _ref24.apply(this, arguments);
  };
}();

var fetchLinkedSkills = exports.fetchLinkedSkills = function () {
  var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(apiData, levelId, activityQuestId) {
    var url, response, data;
    return _regenerator2.default.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/framework_skills';
            _context25.prev = 1;
            _context25.t0 = _utils.checkHttpStatus;
            _context25.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context25.t1 = _context25.sent;
            response = (0, _context25.t0)(_context25.t1);
            _context25.next = 9;
            return response.json();

          case 9:
            data = _context25.sent;
            return _context25.abrupt('return', data);

          case 13:
            _context25.prev = 13;
            _context25.t2 = _context25['catch'](1);

            console.log(_context25.t2);

          case 16:
          case 'end':
            return _context25.stop();
        }
      }
    }, _callee25, undefined, [[1, 13]]);
  }));

  return function fetchLinkedSkills(_x95, _x96, _x97) {
    return _ref25.apply(this, arguments);
  };
}();

var addLinkedSkill = exports.addLinkedSkill = function () {
  var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(apiData, levelId, activityQuestId, frameworkSkillId) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/framework_skills';
            data = {
              quest_framework_skill: {
                framework_skill_id: frameworkSkillId
              }
            };
            _context26.prev = 2;
            _context26.t0 = _utils.checkHttpStatus;
            _context26.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context26.t1 = _context26.sent;
            response = (0, _context26.t0)(_context26.t1);
            _context26.next = 10;
            return response;

          case 10:
            return _context26.abrupt('return');

          case 13:
            _context26.prev = 13;
            _context26.t2 = _context26['catch'](2);

            console.log(_context26.t2);

          case 16:
          case 'end':
            return _context26.stop();
        }
      }
    }, _callee26, undefined, [[2, 13]]);
  }));

  return function addLinkedSkill(_x98, _x99, _x100, _x101) {
    return _ref26.apply(this, arguments);
  };
}();

var deleteLinkedSkill = exports.deleteLinkedSkill = function () {
  var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(apiData, levelId, activityQuestId, frameworkSkillId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/levels/' + levelId + '/activity_quests/' + activityQuestId + '/framework_skills/' + frameworkSkillId;
            _context27.prev = 1;
            _context27.t0 = _utils.checkHttpStatus;
            _context27.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context27.t1 = _context27.sent;
            response = (0, _context27.t0)(_context27.t1);
            _context27.next = 9;
            return response;

          case 9:
            return _context27.abrupt('return');

          case 12:
            _context27.prev = 12;
            _context27.t2 = _context27['catch'](1);

            console.log(_context27.t2);

          case 15:
          case 'end':
            return _context27.stop();
        }
      }
    }, _callee27, undefined, [[1, 12]]);
  }));

  return function deleteLinkedSkill(_x102, _x103, _x104, _x105) {
    return _ref27.apply(this, arguments);
  };
}();

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1347);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(646);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(437);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(647);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;




function _slicedToArray(arr, i) {
  return Object(arrayWithHoles["a" /* default */])(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || Object(nonIterableRest["a" /* default */])();
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js







var Paper_styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(esm_extends["a" /* default */])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper_Paper = /*#__PURE__*/react["forwardRef"](function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper_Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
/* harmony default export */ var esm_Paper_Paper = (Object(withStyles["a" /* default */])(Paper_styles, {
  name: 'MuiPaper'
})(Paper_Paper));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Paper/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_Paper_Paper; });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthors = undefined;
exports.isBasicInformationComplete = isBasicInformationComplete;
exports.areActivitiesComplete = areActivitiesComplete;
exports.isActivityComplete = isActivityComplete;
exports.areImagesComplete = areImagesComplete;
exports.isOtherInformationComplete = isOtherInformationComplete;
exports.getCommentResourceType = getCommentResourceType;
exports.findQuestMentorNote = findQuestMentorNote;
exports.findActivity = findActivity;
exports.getQuestEditors = getQuestEditors;
exports.checkQuestSection = checkQuestSection;
exports.setActiveMenuItem = setActiveMenuItem;
exports.basicInfoHasJustForMentors = basicInfoHasJustForMentors;
exports.hideQuestComments = hideQuestComments;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(20);

var _resources = __webpack_require__(125);

var _contentwarnings = __webpack_require__(167);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBasicInformationComplete(quest) {
  return !((0, _index.isNullOrEmpty)(quest.name) || (0, _index.isNullOrEmpty)(quest.description) || (0, _index.isNullOrEmpty)(quest.author) || (0, _index.isNullOrEmpty)(quest.driving_question) || (0, _index.isNullOrEmpty)(quest.type.id));
}

function areActivitiesComplete(activities) {
  var activitiesIncomplete = false;

  if (activities.length > 0) {
    if (activities.some(function (activity) {
      return !isActivityComplete(activity);
    })) {
      activitiesIncomplete = true;
    }
  } else {
    activitiesIncomplete = true;
  }

  return !activitiesIncomplete;
}

function isActivityComplete(activity) {
  var incomplete = false;
  if ((0, _index.isNullOrEmpty)(activity.name) || (0, _index.isNullOrEmpty)(activity.description) || (0, _index.isNullOrEmpty)(activity.goals) || Boolean(activity.work_product) && !activity.artifact_type || Boolean(activity.resources) && activity.resources.length > 0 && activity.resources.some(function (r) {
    return (0, _resources.isResourceComplete)(r) === false;
  })) {
    incomplete = true;
  }
  return !incomplete;
}

function areImagesComplete(quest) {
  return !(0, _index.isNullOrEmpty)(quest.icon_image_url);
}

function isOtherInformationComplete(quest) {
  return !(0, _index.isNullOrEmpty)(quest.tags);
}

function getCommentResourceType(comment) {
  return comment.section === 'activities' ? 'Activity' : 'Quest';
}

function findQuestMentorNote(notes) {
  return notes.find(function (note) {
    return note.resource_type === 'Quest';
  });
}

function findActivity(activities, activityId) {
  var activityIndex = activities.findIndex(function (activity) {
    return activity.id === activityId;
  });

  return activities[activityIndex];
}

function getQuestEditors(quest) {
  var editors = quest.editors.filter(function (editor) {
    return quest.author_ids.indexOf(editor.id) === -1;
  });
  return editors;
}

function checkQuestSection(section) {
  if (['basicinformation', 'topicsandstandards', 'activities', 'questreview', 'otherinformation', 'images', 'questhistory', 'skills'].indexOf(section) > -1) {
    return section;
  } else {
    return 'basicinformation';
  }
}

/* istanbul ignore next */
function setActiveMenuItem(activityId) {
  document.querySelectorAll('.quest-menu li').forEach(function (li) {
    li.classList.remove('active');
  });
  var _el = document.getElementById(activityId);
  if (_el && !_el.classList.contains('active')) {
    _el.classList.add('active');
  }
}

function basicInfoHasJustForMentors(quest, questMentorNote) {
  return !(0, _index.isNullOrEmpty)(questMentorNote) || quest.inline_mentor_notes && quest.inline_mentor_notes.length > 0 || !(0, _index.isNullOrEmpty)(quest.mentor_note) || (0, _contentwarnings.questHasContentWarnings)(quest);
}

function hideQuestComments(section, activityId) {
  return section === 'activities' && !activityId || section === 'questhistory';
}

var getAuthors = exports.getAuthors = function getAuthors(_ref) {
  var authors = _ref.authors,
      questId = _ref.questId;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    'By ',
    authors.map(function (author, i) {
      var moreAuthors = authors.length > i + 1;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _UserName2.default,
          {
            activeCertifications: author.active_certifications,
            userId: 'quest-' + questId + '-author-' + author.id
          },
          author.name
        ),
        moreAuthors ? ', ' : ''
      );
    })
  );
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(193)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 105 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(71);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(31);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 110 */,
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H5 = _styledComponents2.default.div.withConfig({
  displayName: 'H5',
  componentId: 'qv3nq1-0'
})(_templateObject, function (props) {
  return props.dove ? _colors2.default.dove : _colors2.default.victoria;
});

exports.default = H5;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(1168)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(579)(module)))

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.CodeMirror = factory());
}(this, (function () { 'use strict';

  // Kludges for bugs and behavior differences that can't be feature
  // detected are enabled based on userAgent etc sniffing.
  var userAgent = navigator.userAgent;
  var platform = navigator.platform;

  var gecko = /gecko\/\d/i.test(userAgent);
  var ie_upto10 = /MSIE \d/.test(userAgent);
  var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
  var edge = /Edge\/(\d+)/.exec(userAgent);
  var ie = ie_upto10 || ie_11up || edge;
  var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
  var webkit = !edge && /WebKit\//.test(userAgent);
  var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
  var chrome = !edge && /Chrome\//.test(userAgent);
  var presto = /Opera\//.test(userAgent);
  var safari = /Apple Computer/.test(navigator.vendor);
  var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
  var phantom = /PhantomJS/.test(userAgent);

  var ios = safari && (/Mobile\/\w+/.test(userAgent) || navigator.maxTouchPoints > 2);
  var android = /Android/.test(userAgent);
  // This is woefully incomplete. Suggestions for alternative methods welcome.
  var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
  var mac = ios || /Mac/.test(platform);
  var chromeOS = /\bCrOS\b/.test(userAgent);
  var windows = /win/i.test(platform);

  var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
  if (presto_version) { presto_version = Number(presto_version[1]); }
  if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
  // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
  var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
  var captureRightClick = gecko || (ie && ie_version >= 9);

  function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

  var rmClass = function(node, cls) {
    var current = node.className;
    var match = classTest(cls).exec(current);
    if (match) {
      var after = current.slice(match.index + match[0].length);
      node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
    }
  };

  function removeChildren(e) {
    for (var count = e.childNodes.length; count > 0; --count)
      { e.removeChild(e.firstChild); }
    return e
  }

  function removeChildrenAndAdd(parent, e) {
    return removeChildren(parent).appendChild(e)
  }

  function elt(tag, content, className, style) {
    var e = document.createElement(tag);
    if (className) { e.className = className; }
    if (style) { e.style.cssText = style; }
    if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
    else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
    return e
  }
  // wrapper for elt, which removes the elt from the accessibility tree
  function eltP(tag, content, className, style) {
    var e = elt(tag, content, className, style);
    e.setAttribute("role", "presentation");
    return e
  }

  var range;
  if (document.createRange) { range = function(node, start, end, endNode) {
    var r = document.createRange();
    r.setEnd(endNode || node, end);
    r.setStart(node, start);
    return r
  }; }
  else { range = function(node, start, end) {
    var r = document.body.createTextRange();
    try { r.moveToElementText(node.parentNode); }
    catch(e) { return r }
    r.collapse(true);
    r.moveEnd("character", end);
    r.moveStart("character", start);
    return r
  }; }

  function contains(parent, child) {
    if (child.nodeType == 3) // Android browser always returns false when child is a textnode
      { child = child.parentNode; }
    if (parent.contains)
      { return parent.contains(child) }
    do {
      if (child.nodeType == 11) { child = child.host; }
      if (child == parent) { return true }
    } while (child = child.parentNode)
  }

  function activeElt() {
    // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
    // IE < 10 will throw when accessed while the page is loading or in an iframe.
    // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
    var activeElement;
    try {
      activeElement = document.activeElement;
    } catch(e) {
      activeElement = document.body || null;
    }
    while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
      { activeElement = activeElement.shadowRoot.activeElement; }
    return activeElement
  }

  function addClass(node, cls) {
    var current = node.className;
    if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
  }
  function joinClasses(a, b) {
    var as = a.split(" ");
    for (var i = 0; i < as.length; i++)
      { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
    return b
  }

  var selectInput = function(node) { node.select(); };
  if (ios) // Mobile Safari apparently has a bug where select() is broken.
    { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
  else if (ie) // Suppress mysterious IE10 errors
    { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

  function bind(f) {
    var args = Array.prototype.slice.call(arguments, 1);
    return function(){return f.apply(null, args)}
  }

  function copyObj(obj, target, overwrite) {
    if (!target) { target = {}; }
    for (var prop in obj)
      { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
        { target[prop] = obj[prop]; } }
    return target
  }

  // Counts the column offset in a string, taking tabs into account.
  // Used mostly to find indentation.
  function countColumn(string, end, tabSize, startIndex, startValue) {
    if (end == null) {
      end = string.search(/[^\s\u00a0]/);
      if (end == -1) { end = string.length; }
    }
    for (var i = startIndex || 0, n = startValue || 0;;) {
      var nextTab = string.indexOf("\t", i);
      if (nextTab < 0 || nextTab >= end)
        { return n + (end - i) }
      n += nextTab - i;
      n += tabSize - (n % tabSize);
      i = nextTab + 1;
    }
  }

  var Delayed = function() {
    this.id = null;
    this.f = null;
    this.time = 0;
    this.handler = bind(this.onTimeout, this);
  };
  Delayed.prototype.onTimeout = function (self) {
    self.id = 0;
    if (self.time <= +new Date) {
      self.f();
    } else {
      setTimeout(self.handler, self.time - +new Date);
    }
  };
  Delayed.prototype.set = function (ms, f) {
    this.f = f;
    var time = +new Date + ms;
    if (!this.id || time < this.time) {
      clearTimeout(this.id);
      this.id = setTimeout(this.handler, ms);
      this.time = time;
    }
  };

  function indexOf(array, elt) {
    for (var i = 0; i < array.length; ++i)
      { if (array[i] == elt) { return i } }
    return -1
  }

  // Number of pixels added to scroller and sizer to hide scrollbar
  var scrollerGap = 50;

  // Returned or thrown by various protocols to signal 'I'm not
  // handling this'.
  var Pass = {toString: function(){return "CodeMirror.Pass"}};

  // Reused option objects for setSelection & friends
  var sel_dontScroll = {scroll: false}, sel_mouse = {origin: "*mouse"}, sel_move = {origin: "+move"};

  // The inverse of countColumn -- find the offset that corresponds to
  // a particular column.
  function findColumn(string, goal, tabSize) {
    for (var pos = 0, col = 0;;) {
      var nextTab = string.indexOf("\t", pos);
      if (nextTab == -1) { nextTab = string.length; }
      var skipped = nextTab - pos;
      if (nextTab == string.length || col + skipped >= goal)
        { return pos + Math.min(skipped, goal - col) }
      col += nextTab - pos;
      col += tabSize - (col % tabSize);
      pos = nextTab + 1;
      if (col >= goal) { return pos }
    }
  }

  var spaceStrs = [""];
  function spaceStr(n) {
    while (spaceStrs.length <= n)
      { spaceStrs.push(lst(spaceStrs) + " "); }
    return spaceStrs[n]
  }

  function lst(arr) { return arr[arr.length-1] }

  function map(array, f) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
    return out
  }

  function insertSorted(array, value, score) {
    var pos = 0, priority = score(value);
    while (pos < array.length && score(array[pos]) <= priority) { pos++; }
    array.splice(pos, 0, value);
  }

  function nothing() {}

  function createObj(base, props) {
    var inst;
    if (Object.create) {
      inst = Object.create(base);
    } else {
      nothing.prototype = base;
      inst = new nothing();
    }
    if (props) { copyObj(props, inst); }
    return inst
  }

  var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  function isWordCharBasic(ch) {
    return /\w/.test(ch) || ch > "\x80" &&
      (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
  }
  function isWordChar(ch, helper) {
    if (!helper) { return isWordCharBasic(ch) }
    if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
    return helper.test(ch)
  }

  function isEmpty(obj) {
    for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
    return true
  }

  // Extending unicode characters. A series of a non-extending char +
  // any number of extending chars is treated as a single unit as far
  // as editing and measuring is concerned. This is not fully correct,
  // since some scripts/fonts/browsers also treat other configurations
  // of code points as a group.
  var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
  function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

  // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
  function skipExtendingChars(str, pos, dir) {
    while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
    return pos
  }

  // Returns the value from the range [`from`; `to`] that satisfies
  // `pred` and is closest to `from`. Assumes that at least `to`
  // satisfies `pred`. Supports `from` being greater than `to`.
  function findFirst(pred, from, to) {
    // At any point we are certain `to` satisfies `pred`, don't know
    // whether `from` does.
    var dir = from > to ? -1 : 1;
    for (;;) {
      if (from == to) { return from }
      var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
      if (mid == from) { return pred(mid) ? from : to }
      if (pred(mid)) { to = mid; }
      else { from = mid + dir; }
    }
  }

  // BIDI HELPERS

  function iterateBidiSections(order, from, to, f) {
    if (!order) { return f(from, to, "ltr", 0) }
    var found = false;
    for (var i = 0; i < order.length; ++i) {
      var part = order[i];
      if (part.from < to && part.to > from || from == to && part.to == from) {
        f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
        found = true;
      }
    }
    if (!found) { f(from, to, "ltr"); }
  }

  var bidiOther = null;
  function getBidiPartAt(order, ch, sticky) {
    var found;
    bidiOther = null;
    for (var i = 0; i < order.length; ++i) {
      var cur = order[i];
      if (cur.from < ch && cur.to > ch) { return i }
      if (cur.to == ch) {
        if (cur.from != cur.to && sticky == "before") { found = i; }
        else { bidiOther = i; }
      }
      if (cur.from == ch) {
        if (cur.from != cur.to && sticky != "before") { found = i; }
        else { bidiOther = i; }
      }
    }
    return found != null ? found : bidiOther
  }

  // Bidirectional ordering algorithm
  // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
  // that this (partially) implements.

  // One-char codes used for character types:
  // L (L):   Left-to-Right
  // R (R):   Right-to-Left
  // r (AL):  Right-to-Left Arabic
  // 1 (EN):  European Number
  // + (ES):  European Number Separator
  // % (ET):  European Number Terminator
  // n (AN):  Arabic Number
  // , (CS):  Common Number Separator
  // m (NSM): Non-Spacing Mark
  // b (BN):  Boundary Neutral
  // s (B):   Paragraph Separator
  // t (S):   Segment Separator
  // w (WS):  Whitespace
  // N (ON):  Other Neutrals

  // Returns null if characters are ordered as they appear
  // (left-to-right), or an array of sections ({from, to, level}
  // objects) in the order in which they occur visually.
  var bidiOrdering = (function() {
    // Character types for codepoints 0 to 0xff
    var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
    // Character types for codepoints 0x600 to 0x6f9
    var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
    function charType(code) {
      if (code <= 0xf7) { return lowTypes.charAt(code) }
      else if (0x590 <= code && code <= 0x5f4) { return "R" }
      else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
      else if (0x6ee <= code && code <= 0x8ac) { return "r" }
      else if (0x2000 <= code && code <= 0x200b) { return "w" }
      else if (code == 0x200c) { return "b" }
      else { return "L" }
    }

    var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

    function BidiSpan(level, from, to) {
      this.level = level;
      this.from = from; this.to = to;
    }

    return function(str, direction) {
      var outerType = direction == "ltr" ? "L" : "R";

      if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
      var len = str.length, types = [];
      for (var i = 0; i < len; ++i)
        { types.push(charType(str.charCodeAt(i))); }

      // W1. Examine each non-spacing mark (NSM) in the level run, and
      // change the type of the NSM to the type of the previous
      // character. If the NSM is at the start of the level run, it will
      // get the type of sor.
      for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
        var type = types[i$1];
        if (type == "m") { types[i$1] = prev; }
        else { prev = type; }
      }

      // W2. Search backwards from each instance of a European number
      // until the first strong type (R, L, AL, or sor) is found. If an
      // AL is found, change the type of the European number to Arabic
      // number.
      // W3. Change all ALs to R.
      for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
        var type$1 = types[i$2];
        if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
        else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
      }

      // W4. A single European separator between two European numbers
      // changes to a European number. A single common separator between
      // two numbers of the same type changes to that type.
      for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
        var type$2 = types[i$3];
        if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
        else if (type$2 == "," && prev$1 == types[i$3+1] &&
                 (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
        prev$1 = type$2;
      }

      // W5. A sequence of European terminators adjacent to European
      // numbers changes to all European numbers.
      // W6. Otherwise, separators and terminators change to Other
      // Neutral.
      for (var i$4 = 0; i$4 < len; ++i$4) {
        var type$3 = types[i$4];
        if (type$3 == ",") { types[i$4] = "N"; }
        else if (type$3 == "%") {
          var end = (void 0);
          for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
          var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
          for (var j = i$4; j < end; ++j) { types[j] = replace; }
          i$4 = end - 1;
        }
      }

      // W7. Search backwards from each instance of a European number
      // until the first strong type (R, L, or sor) is found. If an L is
      // found, then change the type of the European number to L.
      for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
        var type$4 = types[i$5];
        if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
        else if (isStrong.test(type$4)) { cur$1 = type$4; }
      }

      // N1. A sequence of neutrals takes the direction of the
      // surrounding strong text if the text on both sides has the same
      // direction. European and Arabic numbers act as if they were R in
      // terms of their influence on neutrals. Start-of-level-run (sor)
      // and end-of-level-run (eor) are used at level run boundaries.
      // N2. Any remaining neutrals take the embedding direction.
      for (var i$6 = 0; i$6 < len; ++i$6) {
        if (isNeutral.test(types[i$6])) {
          var end$1 = (void 0);
          for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
          var before = (i$6 ? types[i$6-1] : outerType) == "L";
          var after = (end$1 < len ? types[end$1] : outerType) == "L";
          var replace$1 = before == after ? (before ? "L" : "R") : outerType;
          for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
          i$6 = end$1 - 1;
        }
      }

      // Here we depart from the documented algorithm, in order to avoid
      // building up an actual levels array. Since there are only three
      // levels (0, 1, 2) in an implementation that doesn't take
      // explicit embedding into account, we can build up the order on
      // the fly, without following the level-based algorithm.
      var order = [], m;
      for (var i$7 = 0; i$7 < len;) {
        if (countsAsLeft.test(types[i$7])) {
          var start = i$7;
          for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
          order.push(new BidiSpan(0, start, i$7));
        } else {
          var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
          for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
          for (var j$2 = pos; j$2 < i$7;) {
            if (countsAsNum.test(types[j$2])) {
              if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); at += isRTL; }
              var nstart = j$2;
              for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
              order.splice(at, 0, new BidiSpan(2, nstart, j$2));
              at += isRTL;
              pos = j$2;
            } else { ++j$2; }
          }
          if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
        }
      }
      if (direction == "ltr") {
        if (order[0].level == 1 && (m = str.match(/^\s+/))) {
          order[0].from = m[0].length;
          order.unshift(new BidiSpan(0, 0, m[0].length));
        }
        if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
          lst(order).to -= m[0].length;
          order.push(new BidiSpan(0, len - m[0].length, len));
        }
      }

      return direction == "rtl" ? order.reverse() : order
    }
  })();

  // Get the bidi ordering for the given line (and cache it). Returns
  // false for lines that are fully left-to-right, and an array of
  // BidiSpan objects otherwise.
  function getOrder(line, direction) {
    var order = line.order;
    if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
    return order
  }

  // EVENT HANDLING

  // Lightweight event framework. on/off also work on DOM nodes,
  // registering native DOM handlers.

  var noHandlers = [];

  var on = function(emitter, type, f) {
    if (emitter.addEventListener) {
      emitter.addEventListener(type, f, false);
    } else if (emitter.attachEvent) {
      emitter.attachEvent("on" + type, f);
    } else {
      var map = emitter._handlers || (emitter._handlers = {});
      map[type] = (map[type] || noHandlers).concat(f);
    }
  };

  function getHandlers(emitter, type) {
    return emitter._handlers && emitter._handlers[type] || noHandlers
  }

  function off(emitter, type, f) {
    if (emitter.removeEventListener) {
      emitter.removeEventListener(type, f, false);
    } else if (emitter.detachEvent) {
      emitter.detachEvent("on" + type, f);
    } else {
      var map = emitter._handlers, arr = map && map[type];
      if (arr) {
        var index = indexOf(arr, f);
        if (index > -1)
          { map[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
      }
    }
  }

  function signal(emitter, type /*, values...*/) {
    var handlers = getHandlers(emitter, type);
    if (!handlers.length) { return }
    var args = Array.prototype.slice.call(arguments, 2);
    for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
  }

  // The DOM events that CodeMirror handles can be overridden by
  // registering a (non-DOM) handler on the editor for the event name,
  // and preventDefault-ing the event in that handler.
  function signalDOMEvent(cm, e, override) {
    if (typeof e == "string")
      { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
    signal(cm, override || e.type, cm, e);
    return e_defaultPrevented(e) || e.codemirrorIgnore
  }

  function signalCursorActivity(cm) {
    var arr = cm._handlers && cm._handlers.cursorActivity;
    if (!arr) { return }
    var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
    for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
      { set.push(arr[i]); } }
  }

  function hasHandler(emitter, type) {
    return getHandlers(emitter, type).length > 0
  }

  // Add on and off methods to a constructor's prototype, to make
  // registering events on such objects more convenient.
  function eventMixin(ctor) {
    ctor.prototype.on = function(type, f) {on(this, type, f);};
    ctor.prototype.off = function(type, f) {off(this, type, f);};
  }

  // Due to the fact that we still support jurassic IE versions, some
  // compatibility wrappers are needed.

  function e_preventDefault(e) {
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
  }
  function e_stopPropagation(e) {
    if (e.stopPropagation) { e.stopPropagation(); }
    else { e.cancelBubble = true; }
  }
  function e_defaultPrevented(e) {
    return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
  }
  function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

  function e_target(e) {return e.target || e.srcElement}
  function e_button(e) {
    var b = e.which;
    if (b == null) {
      if (e.button & 1) { b = 1; }
      else if (e.button & 2) { b = 3; }
      else if (e.button & 4) { b = 2; }
    }
    if (mac && e.ctrlKey && b == 1) { b = 3; }
    return b
  }

  // Detect drag-and-drop
  var dragAndDrop = function() {
    // There is *some* kind of drag-and-drop support in IE6-8, but I
    // couldn't get it to work yet.
    if (ie && ie_version < 9) { return false }
    var div = elt('div');
    return "draggable" in div || "dragDrop" in div
  }();

  var zwspSupported;
  function zeroWidthElement(measure) {
    if (zwspSupported == null) {
      var test = elt("span", "\u200b");
      removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
      if (measure.firstChild.offsetHeight != 0)
        { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
    }
    var node = zwspSupported ? elt("span", "\u200b") :
      elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
    node.setAttribute("cm-text", "");
    return node
  }

  // Feature-detect IE's crummy client rect reporting for bidi text
  var badBidiRects;
  function hasBadBidiRects(measure) {
    if (badBidiRects != null) { return badBidiRects }
    var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
    var r0 = range(txt, 0, 1).getBoundingClientRect();
    var r1 = range(txt, 1, 2).getBoundingClientRect();
    removeChildren(measure);
    if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
    return badBidiRects = (r1.right - r0.right < 3)
  }

  // See if "".split is the broken IE version, if so, provide an
  // alternative way to split lines.
  var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
    var pos = 0, result = [], l = string.length;
    while (pos <= l) {
      var nl = string.indexOf("\n", pos);
      if (nl == -1) { nl = string.length; }
      var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
      var rt = line.indexOf("\r");
      if (rt != -1) {
        result.push(line.slice(0, rt));
        pos += rt + 1;
      } else {
        result.push(line);
        pos = nl + 1;
      }
    }
    return result
  } : function (string) { return string.split(/\r\n?|\n/); };

  var hasSelection = window.getSelection ? function (te) {
    try { return te.selectionStart != te.selectionEnd }
    catch(e) { return false }
  } : function (te) {
    var range;
    try {range = te.ownerDocument.selection.createRange();}
    catch(e) {}
    if (!range || range.parentElement() != te) { return false }
    return range.compareEndPoints("StartToEnd", range) != 0
  };

  var hasCopyEvent = (function () {
    var e = elt("div");
    if ("oncopy" in e) { return true }
    e.setAttribute("oncopy", "return;");
    return typeof e.oncopy == "function"
  })();

  var badZoomedRects = null;
  function hasBadZoomedRects(measure) {
    if (badZoomedRects != null) { return badZoomedRects }
    var node = removeChildrenAndAdd(measure, elt("span", "x"));
    var normal = node.getBoundingClientRect();
    var fromRange = range(node, 0, 1).getBoundingClientRect();
    return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
  }

  // Known modes, by name and by MIME
  var modes = {}, mimeModes = {};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  function defineMode(name, mode) {
    if (arguments.length > 2)
      { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
    modes[name] = mode;
  }

  function defineMIME(mime, spec) {
    mimeModes[mime] = spec;
  }

  // Given a MIME type, a {name, ...options} config object, or a name
  // string, return a mode config object.
  function resolveMode(spec) {
    if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
      spec = mimeModes[spec];
    } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
      var found = mimeModes[spec.name];
      if (typeof found == "string") { found = {name: found}; }
      spec = createObj(found, spec);
      spec.name = found.name;
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
      return resolveMode("application/xml")
    } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
      return resolveMode("application/json")
    }
    if (typeof spec == "string") { return {name: spec} }
    else { return spec || {name: "null"} }
  }

  // Given a mode spec (anything that resolveMode accepts), find and
  // initialize an actual mode object.
  function getMode(options, spec) {
    spec = resolveMode(spec);
    var mfactory = modes[spec.name];
    if (!mfactory) { return getMode(options, "text/plain") }
    var modeObj = mfactory(options, spec);
    if (modeExtensions.hasOwnProperty(spec.name)) {
      var exts = modeExtensions[spec.name];
      for (var prop in exts) {
        if (!exts.hasOwnProperty(prop)) { continue }
        if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
        modeObj[prop] = exts[prop];
      }
    }
    modeObj.name = spec.name;
    if (spec.helperType) { modeObj.helperType = spec.helperType; }
    if (spec.modeProps) { for (var prop$1 in spec.modeProps)
      { modeObj[prop$1] = spec.modeProps[prop$1]; } }

    return modeObj
  }

  // This can be used to attach properties to mode objects from
  // outside the actual mode definition.
  var modeExtensions = {};
  function extendMode(mode, properties) {
    var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
    copyObj(properties, exts);
  }

  function copyState(mode, state) {
    if (state === true) { return state }
    if (mode.copyState) { return mode.copyState(state) }
    var nstate = {};
    for (var n in state) {
      var val = state[n];
      if (val instanceof Array) { val = val.concat([]); }
      nstate[n] = val;
    }
    return nstate
  }

  // Given a mode and a state (for that mode), find the inner mode and
  // state at the position that the state refers to.
  function innerMode(mode, state) {
    var info;
    while (mode.innerMode) {
      info = mode.innerMode(state);
      if (!info || info.mode == mode) { break }
      state = info.state;
      mode = info.mode;
    }
    return info || {mode: mode, state: state}
  }

  function startState(mode, a1, a2) {
    return mode.startState ? mode.startState(a1, a2) : true
  }

  // STRING STREAM

  // Fed to the mode parsers, provides helper functions to make
  // parsers more succinct.

  var StringStream = function(string, tabSize, lineOracle) {
    this.pos = this.start = 0;
    this.string = string;
    this.tabSize = tabSize || 8;
    this.lastColumnPos = this.lastColumnValue = 0;
    this.lineStart = 0;
    this.lineOracle = lineOracle;
  };

  StringStream.prototype.eol = function () {return this.pos >= this.string.length};
  StringStream.prototype.sol = function () {return this.pos == this.lineStart};
  StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
  StringStream.prototype.next = function () {
    if (this.pos < this.string.length)
      { return this.string.charAt(this.pos++) }
  };
  StringStream.prototype.eat = function (match) {
    var ch = this.string.charAt(this.pos);
    var ok;
    if (typeof match == "string") { ok = ch == match; }
    else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
    if (ok) {++this.pos; return ch}
  };
  StringStream.prototype.eatWhile = function (match) {
    var start = this.pos;
    while (this.eat(match)){}
    return this.pos > start
  };
  StringStream.prototype.eatSpace = function () {
    var start = this.pos;
    while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this.pos; }
    return this.pos > start
  };
  StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
  StringStream.prototype.skipTo = function (ch) {
    var found = this.string.indexOf(ch, this.pos);
    if (found > -1) {this.pos = found; return true}
  };
  StringStream.prototype.backUp = function (n) {this.pos -= n;};
  StringStream.prototype.column = function () {
    if (this.lastColumnPos < this.start) {
      this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
      this.lastColumnPos = this.start;
    }
    return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.indentation = function () {
    return countColumn(this.string, null, this.tabSize) -
      (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
  };
  StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
    if (typeof pattern == "string") {
      var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
      var substr = this.string.substr(this.pos, pattern.length);
      if (cased(substr) == cased(pattern)) {
        if (consume !== false) { this.pos += pattern.length; }
        return true
      }
    } else {
      var match = this.string.slice(this.pos).match(pattern);
      if (match && match.index > 0) { return null }
      if (match && consume !== false) { this.pos += match[0].length; }
      return match
    }
  };
  StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
  StringStream.prototype.hideFirstChars = function (n, inner) {
    this.lineStart += n;
    try { return inner() }
    finally { this.lineStart -= n; }
  };
  StringStream.prototype.lookAhead = function (n) {
    var oracle = this.lineOracle;
    return oracle && oracle.lookAhead(n)
  };
  StringStream.prototype.baseToken = function () {
    var oracle = this.lineOracle;
    return oracle && oracle.baseToken(this.pos)
  };

  // Find the line object corresponding to the given line number.
  function getLine(doc, n) {
    n -= doc.first;
    if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
    var chunk = doc;
    while (!chunk.lines) {
      for (var i = 0;; ++i) {
        var child = chunk.children[i], sz = child.chunkSize();
        if (n < sz) { chunk = child; break }
        n -= sz;
      }
    }
    return chunk.lines[n]
  }

  // Get the part of a document between two positions, as an array of
  // strings.
  function getBetween(doc, start, end) {
    var out = [], n = start.line;
    doc.iter(start.line, end.line + 1, function (line) {
      var text = line.text;
      if (n == end.line) { text = text.slice(0, end.ch); }
      if (n == start.line) { text = text.slice(start.ch); }
      out.push(text);
      ++n;
    });
    return out
  }
  // Get the lines between from and to, as array of strings.
  function getLines(doc, from, to) {
    var out = [];
    doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
    return out
  }

  // Update the height of a line, propagating the height change
  // upwards to parent nodes.
  function updateLineHeight(line, height) {
    var diff = height - line.height;
    if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
  }

  // Given a line object, find its line number by walking up through
  // its parent links.
  function lineNo(line) {
    if (line.parent == null) { return null }
    var cur = line.parent, no = indexOf(cur.lines, line);
    for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
      for (var i = 0;; ++i) {
        if (chunk.children[i] == cur) { break }
        no += chunk.children[i].chunkSize();
      }
    }
    return no + cur.first
  }

  // Find the line at the given vertical position, using the height
  // information in the document tree.
  function lineAtHeight(chunk, h) {
    var n = chunk.first;
    outer: do {
      for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
        var child = chunk.children[i$1], ch = child.height;
        if (h < ch) { chunk = child; continue outer }
        h -= ch;
        n += child.chunkSize();
      }
      return n
    } while (!chunk.lines)
    var i = 0;
    for (; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i], lh = line.height;
      if (h < lh) { break }
      h -= lh;
    }
    return n + i
  }

  function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

  function lineNumberFor(options, i) {
    return String(options.lineNumberFormatter(i + options.firstLineNumber))
  }

  // A Pos instance represents a position within the text.
  function Pos(line, ch, sticky) {
    if ( sticky === void 0 ) sticky = null;

    if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
    this.line = line;
    this.ch = ch;
    this.sticky = sticky;
  }

  // Compare two positions, return 0 if they are the same, a negative
  // number when a is less, and a positive number otherwise.
  function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

  function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

  function copyPos(x) {return Pos(x.line, x.ch)}
  function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
  function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

  // Most of the external API clips given positions to make sure they
  // actually exist within the document.
  function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
  function clipPos(doc, pos) {
    if (pos.line < doc.first) { return Pos(doc.first, 0) }
    var last = doc.first + doc.size - 1;
    if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
    return clipToLen(pos, getLine(doc, pos.line).text.length)
  }
  function clipToLen(pos, linelen) {
    var ch = pos.ch;
    if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
    else if (ch < 0) { return Pos(pos.line, 0) }
    else { return pos }
  }
  function clipPosArray(doc, array) {
    var out = [];
    for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
    return out
  }

  var SavedContext = function(state, lookAhead) {
    this.state = state;
    this.lookAhead = lookAhead;
  };

  var Context = function(doc, state, line, lookAhead) {
    this.state = state;
    this.doc = doc;
    this.line = line;
    this.maxLookAhead = lookAhead || 0;
    this.baseTokens = null;
    this.baseTokenPos = 1;
  };

  Context.prototype.lookAhead = function (n) {
    var line = this.doc.getLine(this.line + n);
    if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
    return line
  };

  Context.prototype.baseToken = function (n) {
    if (!this.baseTokens) { return null }
    while (this.baseTokens[this.baseTokenPos] <= n)
      { this.baseTokenPos += 2; }
    var type = this.baseTokens[this.baseTokenPos + 1];
    return {type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n}
  };

  Context.prototype.nextLine = function () {
    this.line++;
    if (this.maxLookAhead > 0) { this.maxLookAhead--; }
  };

  Context.fromSaved = function (doc, saved, line) {
    if (saved instanceof SavedContext)
      { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
    else
      { return new Context(doc, copyState(doc.mode, saved), line) }
  };

  Context.prototype.save = function (copy) {
    var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
    return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
  };


  // Compute a style array (an array starting with a mode generation
  // -- for invalidation -- followed by pairs of end positions and
  // style strings), which is used to highlight the tokens on the
  // line.
  function highlightLine(cm, line, context, forceToEnd) {
    // A styles array always starts with a number identifying the
    // mode/overlays that it is based on (for easy invalidation).
    var st = [cm.state.modeGen], lineClasses = {};
    // Compute the base array of styles
    runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
            lineClasses, forceToEnd);
    var state = context.state;

    // Run overlays, adjust style array.
    var loop = function ( o ) {
      context.baseTokens = st;
      var overlay = cm.state.overlays[o], i = 1, at = 0;
      context.state = true;
      runMode(cm, line.text, overlay.mode, context, function (end, style) {
        var start = i;
        // Ensure there's a token end at the current position, and that i points at it
        while (at < end) {
          var i_end = st[i];
          if (i_end > end)
            { st.splice(i, 1, end, st[i+1], i_end); }
          i += 2;
          at = Math.min(end, i_end);
        }
        if (!style) { return }
        if (overlay.opaque) {
          st.splice(start, i - start, end, "overlay " + style);
          i = start + 2;
        } else {
          for (; start < i; start += 2) {
            var cur = st[start+1];
            st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
          }
        }
      }, lineClasses);
      context.state = state;
      context.baseTokens = null;
      context.baseTokenPos = 1;
    };

    for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

    return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
  }

  function getLineStyles(cm, line, updateFrontier) {
    if (!line.styles || line.styles[0] != cm.state.modeGen) {
      var context = getContextBefore(cm, lineNo(line));
      var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
      var result = highlightLine(cm, line, context);
      if (resetState) { context.state = resetState; }
      line.stateAfter = context.save(!resetState);
      line.styles = result.styles;
      if (result.classes) { line.styleClasses = result.classes; }
      else if (line.styleClasses) { line.styleClasses = null; }
      if (updateFrontier === cm.doc.highlightFrontier)
        { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
    }
    return line.styles
  }

  function getContextBefore(cm, n, precise) {
    var doc = cm.doc, display = cm.display;
    if (!doc.mode.startState) { return new Context(doc, true, n) }
    var start = findStartLine(cm, n, precise);
    var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
    var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

    doc.iter(start, n, function (line) {
      processLine(cm, line.text, context);
      var pos = context.line;
      line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
      context.nextLine();
    });
    if (precise) { doc.modeFrontier = context.line; }
    return context
  }

  // Lightweight form of highlight -- proceed over this line and
  // update state, but don't save a style array. Used for lines that
  // aren't currently visible.
  function processLine(cm, text, context, startAt) {
    var mode = cm.doc.mode;
    var stream = new StringStream(text, cm.options.tabSize, context);
    stream.start = stream.pos = startAt || 0;
    if (text == "") { callBlankLine(mode, context.state); }
    while (!stream.eol()) {
      readToken(mode, stream, context.state);
      stream.start = stream.pos;
    }
  }

  function callBlankLine(mode, state) {
    if (mode.blankLine) { return mode.blankLine(state) }
    if (!mode.innerMode) { return }
    var inner = innerMode(mode, state);
    if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
  }

  function readToken(mode, stream, state, inner) {
    for (var i = 0; i < 10; i++) {
      if (inner) { inner[0] = innerMode(mode, state).mode; }
      var style = mode.token(stream, state);
      if (stream.pos > stream.start) { return style }
    }
    throw new Error("Mode " + mode.name + " failed to advance stream.")
  }

  var Token = function(stream, type, state) {
    this.start = stream.start; this.end = stream.pos;
    this.string = stream.current();
    this.type = type || null;
    this.state = state;
  };

  // Utility for getTokenAt and getLineTokens
  function takeToken(cm, pos, precise, asArray) {
    var doc = cm.doc, mode = doc.mode, style;
    pos = clipPos(doc, pos);
    var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
    var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
    if (asArray) { tokens = []; }
    while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
      stream.start = stream.pos;
      style = readToken(mode, stream, context.state);
      if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
    }
    return asArray ? tokens : new Token(stream, style, context.state)
  }

  function extractLineClasses(type, output) {
    if (type) { for (;;) {
      var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
      if (!lineClass) { break }
      type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
      var prop = lineClass[1] ? "bgClass" : "textClass";
      if (output[prop] == null)
        { output[prop] = lineClass[2]; }
      else if (!(new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)")).test(output[prop]))
        { output[prop] += " " + lineClass[2]; }
    } }
    return type
  }

  // Run the given mode's parser over a line, calling f for each token.
  function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
    var flattenSpans = mode.flattenSpans;
    if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
    var curStart = 0, curStyle = null;
    var stream = new StringStream(text, cm.options.tabSize, context), style;
    var inner = cm.options.addModeClass && [null];
    if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
    while (!stream.eol()) {
      if (stream.pos > cm.options.maxHighlightLength) {
        flattenSpans = false;
        if (forceToEnd) { processLine(cm, text, context, stream.pos); }
        stream.pos = text.length;
        style = null;
      } else {
        style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
      }
      if (inner) {
        var mName = inner[0].name;
        if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
      }
      if (!flattenSpans || curStyle != style) {
        while (curStart < stream.start) {
          curStart = Math.min(stream.start, curStart + 5000);
          f(curStart, curStyle);
        }
        curStyle = style;
      }
      stream.start = stream.pos;
    }
    while (curStart < stream.pos) {
      // Webkit seems to refuse to render text nodes longer than 57444
      // characters, and returns inaccurate measurements in nodes
      // starting around 5000 chars.
      var pos = Math.min(stream.pos, curStart + 5000);
      f(pos, curStyle);
      curStart = pos;
    }
  }

  // Finds the line to start with when starting a parse. Tries to
  // find a line with a stateAfter, so that it can start with a
  // valid state. If that fails, it returns the line with the
  // smallest indentation, which tends to need the least context to
  // parse correctly.
  function findStartLine(cm, n, precise) {
    var minindent, minline, doc = cm.doc;
    var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
    for (var search = n; search > lim; --search) {
      if (search <= doc.first) { return doc.first }
      var line = getLine(doc, search - 1), after = line.stateAfter;
      if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
        { return search }
      var indented = countColumn(line.text, null, cm.options.tabSize);
      if (minline == null || minindent > indented) {
        minline = search - 1;
        minindent = indented;
      }
    }
    return minline
  }

  function retreatFrontier(doc, n) {
    doc.modeFrontier = Math.min(doc.modeFrontier, n);
    if (doc.highlightFrontier < n - 10) { return }
    var start = doc.first;
    for (var line = n - 1; line > start; line--) {
      var saved = getLine(doc, line).stateAfter;
      // change is on 3
      // state on line 1 looked ahead 2 -- so saw 3
      // test 1 + 2 < 3 should cover this
      if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
        start = line + 1;
        break
      }
    }
    doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
  }

  // Optimize some code when these features are not used.
  var sawReadOnlySpans = false, sawCollapsedSpans = false;

  function seeReadOnlySpans() {
    sawReadOnlySpans = true;
  }

  function seeCollapsedSpans() {
    sawCollapsedSpans = true;
  }

  // TEXTMARKER SPANS

  function MarkedSpan(marker, from, to) {
    this.marker = marker;
    this.from = from; this.to = to;
  }

  // Search an array of spans for a span matching the given marker.
  function getMarkedSpanFor(spans, marker) {
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.marker == marker) { return span }
    } }
  }

  // Remove a span from an array, returning undefined if no spans are
  // left (we don't store arrays for lines without spans).
  function removeMarkedSpan(spans, span) {
    var r;
    for (var i = 0; i < spans.length; ++i)
      { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
    return r
  }

  // Add a span to a line.
  function addMarkedSpan(line, span, op) {
    var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = new WeakSet));
    if (inThisOp && inThisOp.has(line.markedSpans)) {
      line.markedSpans.push(span);
    } else {
      line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
      if (inThisOp) { inThisOp.add(line.markedSpans); }
    }
    span.marker.attachLine(line);
  }

  // Used for the algorithm that adjusts markers for a change in the
  // document. These functions cut an array of spans at a given
  // character position, returning an array of remaining chunks (or
  // undefined if nothing remains).
  function markedSpansBefore(old, startCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
      if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
        var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
      }
    } }
    return nw
  }
  function markedSpansAfter(old, endCh, isInsert) {
    var nw;
    if (old) { for (var i = 0; i < old.length; ++i) {
      var span = old[i], marker = span.marker;
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
      if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
        var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh)
        ;(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                              span.to == null ? null : span.to - endCh));
      }
    } }
    return nw
  }

  // Given a change object, compute the new set of marker spans that
  // cover the line in which the change took place. Removes spans
  // entirely within the change, reconnects spans belonging to the
  // same marker that appear on both sides of the change, and cuts off
  // spans partially within the change. Returns an array of span
  // arrays with one element for each line in (after) the change.
  function stretchSpansOverChange(doc, change) {
    if (change.full) { return null }
    var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
    var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
    if (!oldFirst && !oldLast) { return null }

    var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
    // Get the spans that 'stick out' on both sides
    var first = markedSpansBefore(oldFirst, startCh, isInsert);
    var last = markedSpansAfter(oldLast, endCh, isInsert);

    // Next, merge those two ends
    var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
    if (first) {
      // Fix up .to properties of first
      for (var i = 0; i < first.length; ++i) {
        var span = first[i];
        if (span.to == null) {
          var found = getMarkedSpanFor(last, span.marker);
          if (!found) { span.to = startCh; }
          else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
        }
      }
    }
    if (last) {
      // Fix up .from in last (or move them into first in case of sameLine)
      for (var i$1 = 0; i$1 < last.length; ++i$1) {
        var span$1 = last[i$1];
        if (span$1.to != null) { span$1.to += offset; }
        if (span$1.from == null) {
          var found$1 = getMarkedSpanFor(first, span$1.marker);
          if (!found$1) {
            span$1.from = offset;
            if (sameLine) { (first || (first = [])).push(span$1); }
          }
        } else {
          span$1.from += offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      }
    }
    // Make sure we didn't create any zero-length spans
    if (first) { first = clearEmptySpans(first); }
    if (last && last != first) { last = clearEmptySpans(last); }

    var newMarkers = [first];
    if (!sameLine) {
      // Fill gap with whole-line-spans
      var gap = change.text.length - 2, gapMarkers;
      if (gap > 0 && first)
        { for (var i$2 = 0; i$2 < first.length; ++i$2)
          { if (first[i$2].to == null)
            { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
      for (var i$3 = 0; i$3 < gap; ++i$3)
        { newMarkers.push(gapMarkers); }
      newMarkers.push(last);
    }
    return newMarkers
  }

  // Remove spans that are empty and don't have a clearWhenEmpty
  // option of false.
  function clearEmptySpans(spans) {
    for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
        { spans.splice(i--, 1); }
    }
    if (!spans.length) { return null }
    return spans
  }

  // Used to 'clip' out readOnly ranges when making a change.
  function removeReadOnlyRanges(doc, from, to) {
    var markers = null;
    doc.iter(from.line, to.line + 1, function (line) {
      if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
        var mark = line.markedSpans[i].marker;
        if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
          { (markers || (markers = [])).push(mark); }
      } }
    });
    if (!markers) { return null }
    var parts = [{from: from, to: to}];
    for (var i = 0; i < markers.length; ++i) {
      var mk = markers[i], m = mk.find(0);
      for (var j = 0; j < parts.length; ++j) {
        var p = parts[j];
        if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
        var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
        if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
          { newParts.push({from: p.from, to: m.from}); }
        if (dto > 0 || !mk.inclusiveRight && !dto)
          { newParts.push({from: m.to, to: p.to}); }
        parts.splice.apply(parts, newParts);
        j += newParts.length - 3;
      }
    }
    return parts
  }

  // Connect or disconnect spans from a line.
  function detachMarkedSpans(line) {
    var spans = line.markedSpans;
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.detachLine(line); }
    line.markedSpans = null;
  }
  function attachMarkedSpans(line, spans) {
    if (!spans) { return }
    for (var i = 0; i < spans.length; ++i)
      { spans[i].marker.attachLine(line); }
    line.markedSpans = spans;
  }

  // Helpers used when computing which overlapping collapsed span
  // counts as the larger one.
  function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
  function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

  // Returns a number indicating which of two overlapping collapsed
  // spans is larger (and thus includes the other). Falls back to
  // comparing ids when the spans cover exactly the same range.
  function compareCollapsedMarkers(a, b) {
    var lenDiff = a.lines.length - b.lines.length;
    if (lenDiff != 0) { return lenDiff }
    var aPos = a.find(), bPos = b.find();
    var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
    if (fromCmp) { return -fromCmp }
    var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
    if (toCmp) { return toCmp }
    return b.id - a.id
  }

  // Find out whether a line ends or starts in a collapsed span. If
  // so, return the marker for that span.
  function collapsedSpanAtSide(line, start) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0))
        { found = sp.marker; }
    } }
    return found
  }
  function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
  function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

  function collapsedSpanAround(line, ch) {
    var sps = sawCollapsedSpans && line.markedSpans, found;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) &&
          (!found || compareCollapsedMarkers(found, sp.marker) < 0)) { found = sp.marker; }
    } }
    return found
  }

  // Test whether there exists a collapsed span that partially
  // overlaps (covers the start or end, but not both) of a new span.
  // Such overlap is not allowed.
  function conflictingCollapsedRange(doc, lineNo, from, to, marker) {
    var line = getLine(doc, lineNo);
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var i = 0; i < sps.length; ++i) {
      var sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      var found = sp.marker.find(0);
      var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
      var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
      if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
      if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
          fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
        { return true }
    } }
  }

  // A visual line is a line as drawn on the screen. Folding, for
  // example, can cause multiple logical lines to appear on the same
  // visual line. This finds the start of the visual line that the
  // given line is part of (usually that is the line itself).
  function visualLine(line) {
    var merged;
    while (merged = collapsedSpanAtStart(line))
      { line = merged.find(-1, true).line; }
    return line
  }

  function visualLineEnd(line) {
    var merged;
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return line
  }

  // Returns an array of logical lines that continue the visual line
  // started by the argument, or undefined if there are no such lines.
  function visualLineContinued(line) {
    var merged, lines;
    while (merged = collapsedSpanAtEnd(line)) {
      line = merged.find(1, true).line
      ;(lines || (lines = [])).push(line);
    }
    return lines
  }

  // Get the line number of the start of the visual line that the
  // given line number is part of.
  function visualLineNo(doc, lineN) {
    var line = getLine(doc, lineN), vis = visualLine(line);
    if (line == vis) { return lineN }
    return lineNo(vis)
  }

  // Get the line number of the start of the next visual line after
  // the given line.
  function visualLineEndNo(doc, lineN) {
    if (lineN > doc.lastLine()) { return lineN }
    var line = getLine(doc, lineN), merged;
    if (!lineIsHidden(doc, line)) { return lineN }
    while (merged = collapsedSpanAtEnd(line))
      { line = merged.find(1, true).line; }
    return lineNo(line) + 1
  }

  // Compute whether a line is hidden. Lines count as hidden when they
  // are part of a visual line that starts with another line, or when
  // they are entirely covered by collapsed, non-widget span.
  function lineIsHidden(doc, line) {
    var sps = sawCollapsedSpans && line.markedSpans;
    if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
      sp = sps[i];
      if (!sp.marker.collapsed) { continue }
      if (sp.from == null) { return true }
      if (sp.marker.widgetNode) { continue }
      if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
        { return true }
    } }
  }
  function lineIsHiddenInner(doc, line, span) {
    if (span.to == null) {
      var end = span.marker.find(1, true);
      return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
    }
    if (span.marker.inclusiveRight && span.to == line.text.length)
      { return true }
    for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
      sp = line.markedSpans[i];
      if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
          (sp.to == null || sp.to != span.from) &&
          (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
          lineIsHiddenInner(doc, line, sp)) { return true }
    }
  }

  // Find the height above the given line.
  function heightAtLine(lineObj) {
    lineObj = visualLine(lineObj);

    var h = 0, chunk = lineObj.parent;
    for (var i = 0; i < chunk.lines.length; ++i) {
      var line = chunk.lines[i];
      if (line == lineObj) { break }
      else { h += line.height; }
    }
    for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
      for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
        var cur = p.children[i$1];
        if (cur == chunk) { break }
        else { h += cur.height; }
      }
    }
    return h
  }

  // Compute the character length of a line, taking into account
  // collapsed ranges (see markText) that might hide parts, and join
  // other lines onto it.
  function lineLength(line) {
    if (line.height == 0) { return 0 }
    var len = line.text.length, merged, cur = line;
    while (merged = collapsedSpanAtStart(cur)) {
      var found = merged.find(0, true);
      cur = found.from.line;
      len += found.from.ch - found.to.ch;
    }
    cur = line;
    while (merged = collapsedSpanAtEnd(cur)) {
      var found$1 = merged.find(0, true);
      len -= cur.text.length - found$1.from.ch;
      cur = found$1.to.line;
      len += cur.text.length - found$1.to.ch;
    }
    return len
  }

  // Find the longest line in the document.
  function findMaxLine(cm) {
    var d = cm.display, doc = cm.doc;
    d.maxLine = getLine(doc, doc.first);
    d.maxLineLength = lineLength(d.maxLine);
    d.maxLineChanged = true;
    doc.iter(function (line) {
      var len = lineLength(line);
      if (len > d.maxLineLength) {
        d.maxLineLength = len;
        d.maxLine = line;
      }
    });
  }

  // LINE DATA STRUCTURE

  // Line objects. These hold state related to a line, including
  // highlighting info (the styles array).
  var Line = function(text, markedSpans, estimateHeight) {
    this.text = text;
    attachMarkedSpans(this, markedSpans);
    this.height = estimateHeight ? estimateHeight(this) : 1;
  };

  Line.prototype.lineNo = function () { return lineNo(this) };
  eventMixin(Line);

  // Change the content (text, markers) of a line. Automatically
  // invalidates cached information and tries to re-estimate the
  // line's height.
  function updateLine(line, text, markedSpans, estimateHeight) {
    line.text = text;
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
    if (line.order != null) { line.order = null; }
    detachMarkedSpans(line);
    attachMarkedSpans(line, markedSpans);
    var estHeight = estimateHeight ? estimateHeight(line) : 1;
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  }

  // Detach a line from the document tree and its markers.
  function cleanUpLine(line) {
    line.parent = null;
    detachMarkedSpans(line);
  }

  // Convert a style as returned by a mode (either null, or a string
  // containing one or more styles) to a CSS style. This is cached,
  // and also looks for line-wide styles.
  var styleToClassCache = {}, styleToClassCacheWithMode = {};
  function interpretTokenStyle(style, options) {
    if (!style || /^\s*$/.test(style)) { return null }
    var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
    return cache[style] ||
      (cache[style] = style.replace(/\S+/g, "cm-$&"))
  }

  // Render the DOM representation of the text of a line. Also builds
  // up a 'line map', which points at the DOM nodes that represent
  // specific stretches of text, and is used by the measuring code.
  // The returned object contains the DOM node, this map, and
  // information about line-wide styles that were set by the mode.
  function buildLineContent(cm, lineView) {
    // The padding-right forces the element to have a 'border', which
    // is needed on Webkit to be able to get line-level bounding
    // rectangles for it (in measureChar).
    var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
    var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                   col: 0, pos: 0, cm: cm,
                   trailingSpace: false,
                   splitSpaces: cm.getOption("lineWrapping")};
    lineView.measure = {};

    // Iterate over the logical lines that make up this visual line.
    for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
      var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
      builder.pos = 0;
      builder.addToken = buildToken;
      // Optionally wire in some hacks into the token-rendering
      // algorithm, to deal with browser quirks.
      if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
        { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
      builder.map = [];
      var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
      insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
      if (line.styleClasses) {
        if (line.styleClasses.bgClass)
          { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
        if (line.styleClasses.textClass)
          { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
      }

      // Ensure at least a single node is present, for measuring.
      if (builder.map.length == 0)
        { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

      // Store the map and a cache object for the current logical line
      if (i == 0) {
        lineView.measure.map = builder.map;
        lineView.measure.cache = {};
      } else {
  (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
        ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
      }
    }

    // See issue #2901
    if (webkit) {
      var last = builder.content.lastChild;
      if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
        { builder.content.className = "cm-tab-wrap-hack"; }
    }

    signal(cm, "renderLine", cm, lineView.line, builder.pre);
    if (builder.pre.className)
      { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

    return builder
  }

  function defaultSpecialCharPlaceholder(ch) {
    var token = elt("span", "\u2022", "cm-invalidchar");
    token.title = "\\u" + ch.charCodeAt(0).toString(16);
    token.setAttribute("aria-label", token.title);
    return token
  }

  // Build up the DOM representation for a single token, and add it to
  // the line map. Takes care to render special characters separately.
  function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
    if (!text) { return }
    var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
    var special = builder.cm.state.specialChars, mustWrap = false;
    var content;
    if (!special.test(text)) {
      builder.col += text.length;
      content = document.createTextNode(displayText);
      builder.map.push(builder.pos, builder.pos + text.length, content);
      if (ie && ie_version < 9) { mustWrap = true; }
      builder.pos += text.length;
    } else {
      content = document.createDocumentFragment();
      var pos = 0;
      while (true) {
        special.lastIndex = pos;
        var m = special.exec(text);
        var skipped = m ? m.index - pos : text.length - pos;
        if (skipped) {
          var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
          else { content.appendChild(txt); }
          builder.map.push(builder.pos, builder.pos + skipped, txt);
          builder.col += skipped;
          builder.pos += skipped;
        }
        if (!m) { break }
        pos += skipped + 1;
        var txt$1 = (void 0);
        if (m[0] == "\t") {
          var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
          txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
          txt$1.setAttribute("role", "presentation");
          txt$1.setAttribute("cm-text", "\t");
          builder.col += tabWidth;
        } else if (m[0] == "\r" || m[0] == "\n") {
          txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
          txt$1.setAttribute("cm-text", m[0]);
          builder.col += 1;
        } else {
          txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
          txt$1.setAttribute("cm-text", m[0]);
          if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
          else { content.appendChild(txt$1); }
          builder.col += 1;
        }
        builder.map.push(builder.pos, builder.pos + 1, txt$1);
        builder.pos++;
      }
    }
    builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
    if (style || startStyle || endStyle || mustWrap || css || attributes) {
      var fullStyle = style || "";
      if (startStyle) { fullStyle += startStyle; }
      if (endStyle) { fullStyle += endStyle; }
      var token = elt("span", [content], fullStyle, css);
      if (attributes) {
        for (var attr in attributes) { if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class")
          { token.setAttribute(attr, attributes[attr]); } }
      }
      return builder.content.appendChild(token)
    }
    builder.content.appendChild(content);
  }

  // Change some spaces to NBSP to prevent the browser from collapsing
  // trailing spaces at the end of a line when rendering text (issue #1362).
  function splitSpaces(text, trailingBefore) {
    if (text.length > 1 && !/  /.test(text)) { return text }
    var spaceBefore = trailingBefore, result = "";
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
        { ch = "\u00a0"; }
      result += ch;
      spaceBefore = ch == " ";
    }
    return result
  }

  // Work around nonsense dimensions being reported for stretches of
  // right-to-left text.
  function buildTokenBadBidi(inner, order) {
    return function (builder, text, style, startStyle, endStyle, css, attributes) {
      style = style ? style + " cm-force-border" : "cm-force-border";
      var start = builder.pos, end = start + text.length;
      for (;;) {
        // Find the part that overlaps with the start of this text
        var part = (void 0);
        for (var i = 0; i < order.length; i++) {
          part = order[i];
          if (part.to > start && part.from <= start) { break }
        }
        if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, css, attributes) }
        inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
        startStyle = null;
        text = text.slice(part.to - start);
        start = part.to;
      }
    }
  }

  function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
    var widget = !ignoreWidget && marker.widgetNode;
    if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
    if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
      if (!widget)
        { widget = builder.content.appendChild(document.createElement("span")); }
      widget.setAttribute("cm-marker", marker.id);
    }
    if (widget) {
      builder.cm.display.input.setUneditable(widget);
      builder.content.appendChild(widget);
    }
    builder.pos += size;
    builder.trailingSpace = false;
  }

  // Outputs a number of spans to make up a line, taking highlighting
  // and marked text into account.
  function insertLineContent(line, builder, styles) {
    var spans = line.markedSpans, allText = line.text, at = 0;
    if (!spans) {
      for (var i$1 = 1; i$1 < styles.length; i$1+=2)
        { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
      return
    }

    var len = allText.length, pos = 0, i = 1, text = "", style, css;
    var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
    for (;;) {
      if (nextChange == pos) { // Update current marker set
        spanStyle = spanEndStyle = spanStartStyle = css = "";
        attributes = null;
        collapsed = null; nextChange = Infinity;
        var foundBookmarks = [], endStyles = (void 0);
        for (var j = 0; j < spans.length; ++j) {
          var sp = spans[j], m = sp.marker;
          if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
            foundBookmarks.push(m);
          } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
            if (sp.to != null && sp.to != pos && nextChange > sp.to) {
              nextChange = sp.to;
              spanEndStyle = "";
            }
            if (m.className) { spanStyle += " " + m.className; }
            if (m.css) { css = (css ? css + ";" : "") + m.css; }
            if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
            if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
            // support for the old title property
            // https://github.com/codemirror/CodeMirror/pull/5673
            if (m.title) { (attributes || (attributes = {})).title = m.title; }
            if (m.attributes) {
              for (var attr in m.attributes)
                { (attributes || (attributes = {}))[attr] = m.attributes[attr]; }
            }
            if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
              { collapsed = sp; }
          } else if (sp.from > pos && nextChange > sp.from) {
            nextChange = sp.from;
          }
        }
        if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
          { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

        if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
          { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
        if (collapsed && (collapsed.from || 0) == pos) {
          buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                             collapsed.marker, collapsed.from == null);
          if (collapsed.to == null) { return }
          if (collapsed.to == pos) { collapsed = false; }
        }
      }
      if (pos >= len) { break }

      var upto = Math.min(len, nextChange);
      while (true) {
        if (text) {
          var end = pos + text.length;
          if (!collapsed) {
            var tokenText = end > upto ? text.slice(0, upto - pos) : text;
            builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                             spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
          }
          if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
          pos = end;
          spanStartStyle = "";
        }
        text = allText.slice(at, at = styles[i++]);
        style = interpretTokenStyle(styles[i++], builder.cm.options);
      }
    }
  }


  // These objects are used to represent the visible (currently drawn)
  // part of the document. A LineView may correspond to multiple
  // logical lines, if those are connected by collapsed ranges.
  function LineView(doc, line, lineN) {
    // The starting line
    this.line = line;
    // Continuing lines, if any
    this.rest = visualLineContinued(line);
    // Number of logical lines in this visual line
    this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
    this.node = this.text = null;
    this.hidden = lineIsHidden(doc, line);
  }

  // Create a range of LineView objects for the given lines.
  function buildViewArray(cm, from, to) {
    var array = [], nextPos;
    for (var pos = from; pos < to; pos = nextPos) {
      var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
      nextPos = pos + view.size;
      array.push(view);
    }
    return array
  }

  var operationGroup = null;

  function pushOperation(op) {
    if (operationGroup) {
      operationGroup.ops.push(op);
    } else {
      op.ownsGroup = operationGroup = {
        ops: [op],
        delayedCallbacks: []
      };
    }
  }

  function fireCallbacksForOps(group) {
    // Calls delayed callbacks and cursorActivity handlers until no
    // new ones appear
    var callbacks = group.delayedCallbacks, i = 0;
    do {
      for (; i < callbacks.length; i++)
        { callbacks[i].call(null); }
      for (var j = 0; j < group.ops.length; j++) {
        var op = group.ops[j];
        if (op.cursorActivityHandlers)
          { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
            { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
      }
    } while (i < callbacks.length)
  }

  function finishOperation(op, endCb) {
    var group = op.ownsGroup;
    if (!group) { return }

    try { fireCallbacksForOps(group); }
    finally {
      operationGroup = null;
      endCb(group);
    }
  }

  var orphanDelayedCallbacks = null;

  // Often, we want to signal events at a point where we are in the
  // middle of some work, but don't want the handler to start calling
  // other methods on the editor, which might be in an inconsistent
  // state or simply not expect any other events to happen.
  // signalLater looks whether there are any handlers, and schedules
  // them to be executed when the last operation ends, or, if no
  // operation is active, when a timeout fires.
  function signalLater(emitter, type /*, values...*/) {
    var arr = getHandlers(emitter, type);
    if (!arr.length) { return }
    var args = Array.prototype.slice.call(arguments, 2), list;
    if (operationGroup) {
      list = operationGroup.delayedCallbacks;
    } else if (orphanDelayedCallbacks) {
      list = orphanDelayedCallbacks;
    } else {
      list = orphanDelayedCallbacks = [];
      setTimeout(fireOrphanDelayed, 0);
    }
    var loop = function ( i ) {
      list.push(function () { return arr[i].apply(null, args); });
    };

    for (var i = 0; i < arr.length; ++i)
      loop( i );
  }

  function fireOrphanDelayed() {
    var delayed = orphanDelayedCallbacks;
    orphanDelayedCallbacks = null;
    for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
  }

  // When an aspect of a line changes, a string is added to
  // lineView.changes. This updates the relevant part of the line's
  // DOM structure.
  function updateLineForChanges(cm, lineView, lineN, dims) {
    for (var j = 0; j < lineView.changes.length; j++) {
      var type = lineView.changes[j];
      if (type == "text") { updateLineText(cm, lineView); }
      else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
      else if (type == "class") { updateLineClasses(cm, lineView); }
      else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
    }
    lineView.changes = null;
  }

  // Lines with gutter elements, widgets or a background class need to
  // be wrapped, and have the extra elements added to the wrapper div
  function ensureLineWrapped(lineView) {
    if (lineView.node == lineView.text) {
      lineView.node = elt("div", null, null, "position: relative");
      if (lineView.text.parentNode)
        { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
      lineView.node.appendChild(lineView.text);
      if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
    }
    return lineView.node
  }

  function updateLineBackground(cm, lineView) {
    var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
    if (cls) { cls += " CodeMirror-linebackground"; }
    if (lineView.background) {
      if (cls) { lineView.background.className = cls; }
      else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
    } else if (cls) {
      var wrap = ensureLineWrapped(lineView);
      lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
      cm.display.input.setUneditable(lineView.background);
    }
  }

  // Wrapper around buildLineContent which will reuse the structure
  // in display.externalMeasured when possible.
  function getLineContent(cm, lineView) {
    var ext = cm.display.externalMeasured;
    if (ext && ext.line == lineView.line) {
      cm.display.externalMeasured = null;
      lineView.measure = ext.measure;
      return ext.built
    }
    return buildLineContent(cm, lineView)
  }

  // Redraw the line's text. Interacts with the background and text
  // classes because the mode may output tokens that influence these
  // classes.
  function updateLineText(cm, lineView) {
    var cls = lineView.text.className;
    var built = getLineContent(cm, lineView);
    if (lineView.text == lineView.node) { lineView.node = built.pre; }
    lineView.text.parentNode.replaceChild(built.pre, lineView.text);
    lineView.text = built.pre;
    if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
      lineView.bgClass = built.bgClass;
      lineView.textClass = built.textClass;
      updateLineClasses(cm, lineView);
    } else if (cls) {
      lineView.text.className = cls;
    }
  }

  function updateLineClasses(cm, lineView) {
    updateLineBackground(cm, lineView);
    if (lineView.line.wrapClass)
      { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
    else if (lineView.node != lineView.text)
      { lineView.node.className = ""; }
    var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
    lineView.text.className = textClass || "";
  }

  function updateLineGutter(cm, lineView, lineN, dims) {
    if (lineView.gutter) {
      lineView.node.removeChild(lineView.gutter);
      lineView.gutter = null;
    }
    if (lineView.gutterBackground) {
      lineView.node.removeChild(lineView.gutterBackground);
      lineView.gutterBackground = null;
    }
    if (lineView.line.gutterClass) {
      var wrap = ensureLineWrapped(lineView);
      lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                      ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
      cm.display.input.setUneditable(lineView.gutterBackground);
      wrap.insertBefore(lineView.gutterBackground, lineView.text);
    }
    var markers = lineView.line.gutterMarkers;
    if (cm.options.lineNumbers || markers) {
      var wrap$1 = ensureLineWrapped(lineView);
      var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
      gutterWrap.setAttribute("aria-hidden", "true");
      cm.display.input.setUneditable(gutterWrap);
      wrap$1.insertBefore(gutterWrap, lineView.text);
      if (lineView.line.gutterClass)
        { gutterWrap.className += " " + lineView.line.gutterClass; }
      if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
        { lineView.lineNumber = gutterWrap.appendChild(
          elt("div", lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
      if (markers) { for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
        var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
        if (found)
          { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                     ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
      } }
    }
  }

  function updateLineWidgets(cm, lineView, dims) {
    if (lineView.alignable) { lineView.alignable = null; }
    var isWidget = classTest("CodeMirror-linewidget");
    for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
      next = node.nextSibling;
      if (isWidget.test(node.className)) { lineView.node.removeChild(node); }
    }
    insertLineWidgets(cm, lineView, dims);
  }

  // Build a line's DOM representation from scratch
  function buildLineElement(cm, lineView, lineN, dims) {
    var built = getLineContent(cm, lineView);
    lineView.text = lineView.node = built.pre;
    if (built.bgClass) { lineView.bgClass = built.bgClass; }
    if (built.textClass) { lineView.textClass = built.textClass; }

    updateLineClasses(cm, lineView);
    updateLineGutter(cm, lineView, lineN, dims);
    insertLineWidgets(cm, lineView, dims);
    return lineView.node
  }

  // A lineView may contain multiple logical lines (when merged by
  // collapsed spans). The widgets for all of them need to be drawn.
  function insertLineWidgets(cm, lineView, dims) {
    insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
  }

  function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
    if (!line.widgets) { return }
    var wrap = ensureLineWrapped(lineView);
    for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
      var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
      if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
      positionLineWidget(widget, node, lineView, dims);
      cm.display.input.setUneditable(node);
      if (allowAbove && widget.above)
        { wrap.insertBefore(node, lineView.gutter || lineView.text); }
      else
        { wrap.appendChild(node); }
      signalLater(widget, "redraw");
    }
  }

  function positionLineWidget(widget, node, lineView, dims) {
    if (widget.noHScroll) {
  (lineView.alignable || (lineView.alignable = [])).push(node);
      var width = dims.wrapperWidth;
      node.style.left = dims.fixedPos + "px";
      if (!widget.coverGutter) {
        width -= dims.gutterTotalWidth;
        node.style.paddingLeft = dims.gutterTotalWidth + "px";
      }
      node.style.width = width + "px";
    }
    if (widget.coverGutter) {
      node.style.zIndex = 5;
      node.style.position = "relative";
      if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
    }
  }

  function widgetHeight(widget) {
    if (widget.height != null) { return widget.height }
    var cm = widget.doc.cm;
    if (!cm) { return 0 }
    if (!contains(document.body, widget.node)) {
      var parentStyle = "position: relative;";
      if (widget.coverGutter)
        { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
      if (widget.noHScroll)
        { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
      removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
    }
    return widget.height = widget.node.parentNode.offsetHeight
  }

  // Return true when the given mouse event happened in a widget
  function eventInWidget(display, e) {
    for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
      if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
          (n.parentNode == display.sizer && n != display.mover))
        { return true }
    }
  }

  // POSITION MEASUREMENT

  function paddingTop(display) {return display.lineSpace.offsetTop}
  function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
  function paddingH(display) {
    if (display.cachedPaddingH) { return display.cachedPaddingH }
    var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
    var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
    var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
    if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
    return data
  }

  function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
  function displayWidth(cm) {
    return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
  }
  function displayHeight(cm) {
    return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
  }

  // Ensure the lineView.wrapping.heights array is populated. This is
  // an array of bottom offsets for the lines that make up a drawn
  // line. When lineWrapping is on, there might be more than one
  // height.
  function ensureLineHeights(cm, lineView, rect) {
    var wrapping = cm.options.lineWrapping;
    var curWidth = wrapping && displayWidth(cm);
    if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
      var heights = lineView.measure.heights = [];
      if (wrapping) {
        lineView.measure.width = curWidth;
        var rects = lineView.text.firstChild.getClientRects();
        for (var i = 0; i < rects.length - 1; i++) {
          var cur = rects[i], next = rects[i + 1];
          if (Math.abs(cur.bottom - next.bottom) > 2)
            { heights.push((cur.bottom + next.top) / 2 - rect.top); }
        }
      }
      heights.push(rect.bottom - rect.top);
    }
  }

  // Find a line map (mapping character offsets to text nodes) and a
  // measurement cache for the given line number. (A line view might
  // contain multiple lines when collapsed ranges are present.)
  function mapFromLineView(lineView, line, lineN) {
    if (lineView.line == line)
      { return {map: lineView.measure.map, cache: lineView.measure.cache} }
    for (var i = 0; i < lineView.rest.length; i++)
      { if (lineView.rest[i] == line)
        { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
    for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
      { if (lineNo(lineView.rest[i$1]) > lineN)
        { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
  }

  // Render a line into the hidden node display.externalMeasured. Used
  // when measurement is needed for a line that's not in the viewport.
  function updateExternalMeasurement(cm, line) {
    line = visualLine(line);
    var lineN = lineNo(line);
    var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
    view.lineN = lineN;
    var built = view.built = buildLineContent(cm, view);
    view.text = built.pre;
    removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
    return view
  }

  // Get a {top, bottom, left, right} box (in line-local coordinates)
  // for a given character.
  function measureChar(cm, line, ch, bias) {
    return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
  }

  // Find a line view that corresponds to the given line number.
  function findViewForLine(cm, lineN) {
    if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
      { return cm.display.view[findViewIndex(cm, lineN)] }
    var ext = cm.display.externalMeasured;
    if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
      { return ext }
  }

  // Measurement can be split in two steps, the set-up work that
  // applies to the whole line, and the measurement of the actual
  // character. Functions like coordsChar, that need to do a lot of
  // measurements in a row, can thus ensure that the set-up work is
  // only done once.
  function prepareMeasureForLine(cm, line) {
    var lineN = lineNo(line);
    var view = findViewForLine(cm, lineN);
    if (view && !view.text) {
      view = null;
    } else if (view && view.changes) {
      updateLineForChanges(cm, view, lineN, getDimensions(cm));
      cm.curOp.forceUpdate = true;
    }
    if (!view)
      { view = updateExternalMeasurement(cm, line); }

    var info = mapFromLineView(view, line, lineN);
    return {
      line: line, view: view, rect: null,
      map: info.map, cache: info.cache, before: info.before,
      hasHeights: false
    }
  }

  // Given a prepared measurement object, measures the position of an
  // actual character (or fetches it from the cache).
  function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
    if (prepared.before) { ch = -1; }
    var key = ch + (bias || ""), found;
    if (prepared.cache.hasOwnProperty(key)) {
      found = prepared.cache[key];
    } else {
      if (!prepared.rect)
        { prepared.rect = prepared.view.text.getBoundingClientRect(); }
      if (!prepared.hasHeights) {
        ensureLineHeights(cm, prepared.view, prepared.rect);
        prepared.hasHeights = true;
      }
      found = measureCharInner(cm, prepared, ch, bias);
      if (!found.bogus) { prepared.cache[key] = found; }
    }
    return {left: found.left, right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom}
  }

  var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

  function nodeAndOffsetInLineMap(map, ch, bias) {
    var node, start, end, collapse, mStart, mEnd;
    // First, search the line map for the text node corresponding to,
    // or closest to, the target character.
    for (var i = 0; i < map.length; i += 3) {
      mStart = map[i];
      mEnd = map[i + 1];
      if (ch < mStart) {
        start = 0; end = 1;
        collapse = "left";
      } else if (ch < mEnd) {
        start = ch - mStart;
        end = start + 1;
      } else if (i == map.length - 3 || ch == mEnd && map[i + 3] > ch) {
        end = mEnd - mStart;
        start = end - 1;
        if (ch >= mEnd) { collapse = "right"; }
      }
      if (start != null) {
        node = map[i + 2];
        if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
          { collapse = bias; }
        if (bias == "left" && start == 0)
          { while (i && map[i - 2] == map[i - 3] && map[i - 1].insertLeft) {
            node = map[(i -= 3) + 2];
            collapse = "left";
          } }
        if (bias == "right" && start == mEnd - mStart)
          { while (i < map.length - 3 && map[i + 3] == map[i + 4] && !map[i + 5].insertLeft) {
            node = map[(i += 3) + 2];
            collapse = "right";
          } }
        break
      }
    }
    return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
  }

  function getUsefulRect(rects, bias) {
    var rect = nullRect;
    if (bias == "left") { for (var i = 0; i < rects.length; i++) {
      if ((rect = rects[i]).left != rect.right) { break }
    } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
      if ((rect = rects[i$1]).left != rect.right) { break }
    } }
    return rect
  }

  function measureCharInner(cm, prepared, ch, bias) {
    var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
    var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

    var rect;
    if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
      for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
        while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
        while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
        if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
          { rect = node.parentNode.getBoundingClientRect(); }
        else
          { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
        if (rect.left || rect.right || start == 0) { break }
        end = start;
        start = start - 1;
        collapse = "right";
      }
      if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
    } else { // If it is a widget, simply get the box for the whole widget.
      if (start > 0) { collapse = bias = "right"; }
      var rects;
      if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
        { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
      else
        { rect = node.getBoundingClientRect(); }
    }
    if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
      var rSpan = node.parentNode.getClientRects()[0];
      if (rSpan)
        { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
      else
        { rect = nullRect; }
    }

    var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
    var mid = (rtop + rbot) / 2;
    var heights = prepared.view.measure.heights;
    var i = 0;
    for (; i < heights.length - 1; i++)
      { if (mid < heights[i]) { break } }
    var top = i ? heights[i - 1] : 0, bot = heights[i];
    var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                  right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                  top: top, bottom: bot};
    if (!rect.left && !rect.right) { result.bogus = true; }
    if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

    return result
  }

  // Work around problem with bounding client rects on ranges being
  // returned incorrectly when zoomed on IE10 and below.
  function maybeUpdateRectForZooming(measure, rect) {
    if (!window.screen || screen.logicalXDPI == null ||
        screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
      { return rect }
    var scaleX = screen.logicalXDPI / screen.deviceXDPI;
    var scaleY = screen.logicalYDPI / screen.deviceYDPI;
    return {left: rect.left * scaleX, right: rect.right * scaleX,
            top: rect.top * scaleY, bottom: rect.bottom * scaleY}
  }

  function clearLineMeasurementCacheFor(lineView) {
    if (lineView.measure) {
      lineView.measure.cache = {};
      lineView.measure.heights = null;
      if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
        { lineView.measure.caches[i] = {}; } }
    }
  }

  function clearLineMeasurementCache(cm) {
    cm.display.externalMeasure = null;
    removeChildren(cm.display.lineMeasure);
    for (var i = 0; i < cm.display.view.length; i++)
      { clearLineMeasurementCacheFor(cm.display.view[i]); }
  }

  function clearCaches(cm) {
    clearLineMeasurementCache(cm);
    cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
    if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
    cm.display.lineNumChars = null;
  }

  function pageScrollX() {
    // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
    // which causes page_Offset and bounding client rects to use
    // different reference viewports and invalidate our calculations.
    if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
    return window.pageXOffset || (document.documentElement || document.body).scrollLeft
  }
  function pageScrollY() {
    if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
    return window.pageYOffset || (document.documentElement || document.body).scrollTop
  }

  function widgetTopHeight(lineObj) {
    var height = 0;
    if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
      { height += widgetHeight(lineObj.widgets[i]); } } }
    return height
  }

  // Converts a {top, bottom, left, right} box from line-local
  // coordinates into another coordinate system. Context may be one of
  // "line", "div" (display.lineDiv), "local"./null (editor), "window",
  // or "page".
  function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
    if (!includeWidgets) {
      var height = widgetTopHeight(lineObj);
      rect.top += height; rect.bottom += height;
    }
    if (context == "line") { return rect }
    if (!context) { context = "local"; }
    var yOff = heightAtLine(lineObj);
    if (context == "local") { yOff += paddingTop(cm.display); }
    else { yOff -= cm.display.viewOffset; }
    if (context == "page" || context == "window") {
      var lOff = cm.display.lineSpace.getBoundingClientRect();
      yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
      var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
      rect.left += xOff; rect.right += xOff;
    }
    rect.top += yOff; rect.bottom += yOff;
    return rect
  }

  // Coverts a box from "div" coords to another coordinate system.
  // Context may be "window", "page", "div", or "local"./null.
  function fromCoordSystem(cm, coords, context) {
    if (context == "div") { return coords }
    var left = coords.left, top = coords.top;
    // First move into "page" coordinate system
    if (context == "page") {
      left -= pageScrollX();
      top -= pageScrollY();
    } else if (context == "local" || !context) {
      var localBox = cm.display.sizer.getBoundingClientRect();
      left += localBox.left;
      top += localBox.top;
    }

    var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
    return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
  }

  function charCoords(cm, pos, context, lineObj, bias) {
    if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
    return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
  }

  // Returns a box for a given cursor position, which may have an
  // 'other' property containing the position of the secondary cursor
  // on a bidi boundary.
  // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
  // and after `char - 1` in writing order of `char - 1`
  // A cursor Pos(line, char, "after") is on the same visual line as `char`
  // and before `char` in writing order of `char`
  // Examples (upper-case letters are RTL, lower-case are LTR):
  //     Pos(0, 1, ...)
  //     before   after
  // ab     a|b     a|b
  // aB     a|B     aB|
  // Ab     |Ab     A|b
  // AB     B|A     B|A
  // Every position after the last character on a line is considered to stick
  // to the last character on the line.
  function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
    lineObj = lineObj || getLine(cm.doc, pos.line);
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    function get(ch, right) {
      var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
      if (right) { m.left = m.right; } else { m.right = m.left; }
      return intoCoordSystem(cm, lineObj, m, context)
    }
    var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
    if (ch >= lineObj.text.length) {
      ch = lineObj.text.length;
      sticky = "before";
    } else if (ch <= 0) {
      ch = 0;
      sticky = "after";
    }
    if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

    function getBidi(ch, partPos, invert) {
      var part = order[partPos], right = part.level == 1;
      return get(invert ? ch - 1 : ch, right != invert)
    }
    var partPos = getBidiPartAt(order, ch, sticky);
    var other = bidiOther;
    var val = getBidi(ch, partPos, sticky == "before");
    if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
    return val
  }

  // Used to cheaply estimate the coordinates for a position. Used for
  // intermediate scroll updates.
  function estimateCoords(cm, pos) {
    var left = 0;
    pos = clipPos(cm.doc, pos);
    if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
    var lineObj = getLine(cm.doc, pos.line);
    var top = heightAtLine(lineObj) + paddingTop(cm.display);
    return {left: left, right: left, top: top, bottom: top + lineObj.height}
  }

  // Positions returned by coordsChar contain some extra information.
  // xRel is the relative x position of the input coordinates compared
  // to the found position (so xRel > 0 means the coordinates are to
  // the right of the character position, for example). When outside
  // is true, that means the coordinates lie outside the line's
  // vertical range.
  function PosWithInfo(line, ch, sticky, outside, xRel) {
    var pos = Pos(line, ch, sticky);
    pos.xRel = xRel;
    if (outside) { pos.outside = outside; }
    return pos
  }

  // Compute the character position closest to the given coordinates.
  // Input must be lineSpace-local ("div" coordinate system).
  function coordsChar(cm, x, y) {
    var doc = cm.doc;
    y += cm.display.viewOffset;
    if (y < 0) { return PosWithInfo(doc.first, 0, null, -1, -1) }
    var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
    if (lineN > last)
      { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1) }
    if (x < 0) { x = 0; }

    var lineObj = getLine(doc, lineN);
    for (;;) {
      var found = coordsCharInner(cm, lineObj, lineN, x, y);
      var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
      if (!collapsed) { return found }
      var rangeEnd = collapsed.find(1);
      if (rangeEnd.line == lineN) { return rangeEnd }
      lineObj = getLine(doc, lineN = rangeEnd.line);
    }
  }

  function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
    y -= widgetTopHeight(lineObj);
    var end = lineObj.text.length;
    var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
    end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
    return {begin: begin, end: end}
  }

  function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
    if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
    var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
    return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
  }

  // Returns true if the given side of a box is after the given
  // coordinates, in top-to-bottom, left-to-right order.
  function boxIsAfter(box, x, y, left) {
    return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
  }

  function coordsCharInner(cm, lineObj, lineNo, x, y) {
    // Move y into line-local coordinate space
    y -= heightAtLine(lineObj);
    var preparedMeasure = prepareMeasureForLine(cm, lineObj);
    // When directly calling `measureCharPrepared`, we have to adjust
    // for the widgets at this line.
    var widgetHeight = widgetTopHeight(lineObj);
    var begin = 0, end = lineObj.text.length, ltr = true;

    var order = getOrder(lineObj, cm.doc.direction);
    // If the line isn't plain left-to-right text, first figure out
    // which bidi section the coordinates fall into.
    if (order) {
      var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                   (cm, lineObj, lineNo, preparedMeasure, order, x, y);
      ltr = part.level != 1;
      // The awkward -1 offsets are needed because findFirst (called
      // on these below) will treat its first bound as inclusive,
      // second as exclusive, but we want to actually address the
      // characters in the part's range
      begin = ltr ? part.from : part.to - 1;
      end = ltr ? part.to : part.from - 1;
    }

    // A binary search to find the first character whose bounding box
    // starts after the coordinates. If we run across any whose box wrap
    // the coordinates, store that.
    var chAround = null, boxAround = null;
    var ch = findFirst(function (ch) {
      var box = measureCharPrepared(cm, preparedMeasure, ch);
      box.top += widgetHeight; box.bottom += widgetHeight;
      if (!boxIsAfter(box, x, y, false)) { return false }
      if (box.top <= y && box.left <= x) {
        chAround = ch;
        boxAround = box;
      }
      return true
    }, begin, end);

    var baseX, sticky, outside = false;
    // If a box around the coordinates was found, use that
    if (boxAround) {
      // Distinguish coordinates nearer to the left or right side of the box
      var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
      ch = chAround + (atStart ? 0 : 1);
      sticky = atStart ? "after" : "before";
      baseX = atLeft ? boxAround.left : boxAround.right;
    } else {
      // (Adjust for extended bound, if necessary.)
      if (!ltr && (ch == end || ch == begin)) { ch++; }
      // To determine which side to associate with, get the box to the
      // left of the character and compare it's vertical position to the
      // coordinates
      sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
        (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight <= y) == ltr ?
        "after" : "before";
      // Now get accurate coordinates for this place, in order to get a
      // base X position
      var coords = cursorCoords(cm, Pos(lineNo, ch, sticky), "line", lineObj, preparedMeasure);
      baseX = coords.left;
      outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
    }

    ch = skipExtendingChars(lineObj.text, ch, 1);
    return PosWithInfo(lineNo, ch, sticky, outside, x - baseX)
  }

  function coordsBidiPart(cm, lineObj, lineNo, preparedMeasure, order, x, y) {
    // Bidi parts are sorted left-to-right, and in a non-line-wrapping
    // situation, we can take this ordering to correspond to the visual
    // ordering. This finds the first part whose end is after the given
    // coordinates.
    var index = findFirst(function (i) {
      var part = order[i], ltr = part.level != 1;
      return boxIsAfter(cursorCoords(cm, Pos(lineNo, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                     "line", lineObj, preparedMeasure), x, y, true)
    }, 0, order.length - 1);
    var part = order[index];
    // If this isn't the first part, the part's start is also after
    // the coordinates, and the coordinates aren't on the same line as
    // that start, move one part back.
    if (index > 0) {
      var ltr = part.level != 1;
      var start = cursorCoords(cm, Pos(lineNo, ltr ? part.from : part.to, ltr ? "after" : "before"),
                               "line", lineObj, preparedMeasure);
      if (boxIsAfter(start, x, y, true) && start.top > y)
        { part = order[index - 1]; }
    }
    return part
  }

  function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
    // In a wrapped line, rtl text on wrapping boundaries can do things
    // that don't correspond to the ordering in our `order` array at
    // all, so a binary search doesn't work, and we want to return a
    // part that only spans one line so that the binary search in
    // coordsCharInner is safe. As such, we first find the extent of the
    // wrapped line, and then do a flat search in which we discard any
    // spans that aren't on the line.
    var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
    var begin = ref.begin;
    var end = ref.end;
    if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
    var part = null, closestDist = null;
    for (var i = 0; i < order.length; i++) {
      var p = order[i];
      if (p.from >= end || p.to <= begin) { continue }
      var ltr = p.level != 1;
      var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
      // Weigh against spans ending before this, so that they are only
      // picked if nothing ends after
      var dist = endX < x ? x - endX + 1e9 : endX - x;
      if (!part || closestDist > dist) {
        part = p;
        closestDist = dist;
      }
    }
    if (!part) { part = order[order.length - 1]; }
    // Clip the part to the wrapped line.
    if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
    if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
    return part
  }

  var measureText;
  // Compute the default text height.
  function textHeight(display) {
    if (display.cachedTextHeight != null) { return display.cachedTextHeight }
    if (measureText == null) {
      measureText = elt("pre", null, "CodeMirror-line-like");
      // Measure a bunch of lines, for browsers that compute
      // fractional heights.
      for (var i = 0; i < 49; ++i) {
        measureText.appendChild(document.createTextNode("x"));
        measureText.appendChild(elt("br"));
      }
      measureText.appendChild(document.createTextNode("x"));
    }
    removeChildrenAndAdd(display.measure, measureText);
    var height = measureText.offsetHeight / 50;
    if (height > 3) { display.cachedTextHeight = height; }
    removeChildren(display.measure);
    return height || 1
  }

  // Compute the default character width.
  function charWidth(display) {
    if (display.cachedCharWidth != null) { return display.cachedCharWidth }
    var anchor = elt("span", "xxxxxxxxxx");
    var pre = elt("pre", [anchor], "CodeMirror-line-like");
    removeChildrenAndAdd(display.measure, pre);
    var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
    if (width > 2) { display.cachedCharWidth = width; }
    return width || 10
  }

  // Do a bulk-read of the DOM positions and sizes needed to draw the
  // view, so that we don't interleave reading and writing to the DOM.
  function getDimensions(cm) {
    var d = cm.display, left = {}, width = {};
    var gutterLeft = d.gutters.clientLeft;
    for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
      var id = cm.display.gutterSpecs[i].className;
      left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
      width[id] = n.clientWidth;
    }
    return {fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth}
  }

  // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
  // but using getBoundingClientRect to get a sub-pixel-accurate
  // result.
  function compensateForHScroll(display) {
    return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
  }

  // Returns a function that estimates the height of a line, to use as
  // first approximation until the line becomes visible (and is thus
  // properly measurable).
  function estimateHeight(cm) {
    var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
    var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
    return function (line) {
      if (lineIsHidden(cm.doc, line)) { return 0 }

      var widgetsHeight = 0;
      if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
        if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
      } }

      if (wrapping)
        { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
      else
        { return widgetsHeight + th }
    }
  }

  function estimateLineHeights(cm) {
    var doc = cm.doc, est = estimateHeight(cm);
    doc.iter(function (line) {
      var estHeight = est(line);
      if (estHeight != line.height) { updateLineHeight(line, estHeight); }
    });
  }

  // Given a mouse event, find the corresponding position. If liberal
  // is false, it checks whether a gutter or scrollbar was clicked,
  // and returns null if it was. forRect is used by rectangular
  // selections, and tries to estimate a character position even for
  // coordinates beyond the right of the text.
  function posFromMouse(cm, e, liberal, forRect) {
    var display = cm.display;
    if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

    var x, y, space = display.lineSpace.getBoundingClientRect();
    // Fails unpredictably on IE[67] when mouse is dragged around quickly.
    try { x = e.clientX - space.left; y = e.clientY - space.top; }
    catch (e$1) { return null }
    var coords = coordsChar(cm, x, y), line;
    if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
      var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
      coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
    }
    return coords
  }

  // Find the view element corresponding to a given line. Return null
  // when the line isn't visible.
  function findViewIndex(cm, n) {
    if (n >= cm.display.viewTo) { return null }
    n -= cm.display.viewFrom;
    if (n < 0) { return null }
    var view = cm.display.view;
    for (var i = 0; i < view.length; i++) {
      n -= view[i].size;
      if (n < 0) { return i }
    }
  }

  // Updates the display.view data structure for a given change to the
  // document. From and to are in pre-change coordinates. Lendiff is
  // the amount of lines added or subtracted by the change. This is
  // used for changes that span multiple lines, or change the way
  // lines are divided into visual lines. regLineChange (below)
  // registers single-line changes.
  function regChange(cm, from, to, lendiff) {
    if (from == null) { from = cm.doc.first; }
    if (to == null) { to = cm.doc.first + cm.doc.size; }
    if (!lendiff) { lendiff = 0; }

    var display = cm.display;
    if (lendiff && to < display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers > from))
      { display.updateLineNumbers = from; }

    cm.curOp.viewChanged = true;

    if (from >= display.viewTo) { // Change after
      if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
        { resetView(cm); }
    } else if (to <= display.viewFrom) { // Change before
      if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
        resetView(cm);
      } else {
        display.viewFrom += lendiff;
        display.viewTo += lendiff;
      }
    } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
      resetView(cm);
    } else if (from <= display.viewFrom) { // Top overlap
      var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cut) {
        display.view = display.view.slice(cut.index);
        display.viewFrom = cut.lineN;
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    } else if (to >= display.viewTo) { // Bottom overlap
      var cut$1 = viewCuttingPoint(cm, from, from, -1);
      if (cut$1) {
        display.view = display.view.slice(0, cut$1.index);
        display.viewTo = cut$1.lineN;
      } else {
        resetView(cm);
      }
    } else { // Gap in the middle
      var cutTop = viewCuttingPoint(cm, from, from, -1);
      var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
      if (cutTop && cutBot) {
        display.view = display.view.slice(0, cutTop.index)
          .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
          .concat(display.view.slice(cutBot.index));
        display.viewTo += lendiff;
      } else {
        resetView(cm);
      }
    }

    var ext = display.externalMeasured;
    if (ext) {
      if (to < ext.lineN)
        { ext.lineN += lendiff; }
      else if (from < ext.lineN + ext.size)
        { display.externalMeasured = null; }
    }
  }

  // Register a change to a single line. Type must be one of "text",
  // "gutter", "class", "widget"
  function regLineChange(cm, line, type) {
    cm.curOp.viewChanged = true;
    var display = cm.display, ext = cm.display.externalMeasured;
    if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
      { display.externalMeasured = null; }

    if (line < display.viewFrom || line >= display.viewTo) { return }
    var lineView = display.view[findViewIndex(cm, line)];
    if (lineView.node == null) { return }
    var arr = lineView.changes || (lineView.changes = []);
    if (indexOf(arr, type) == -1) { arr.push(type); }
  }

  // Clear the view.
  function resetView(cm) {
    cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
    cm.display.view = [];
    cm.display.viewOffset = 0;
  }

  function viewCuttingPoint(cm, oldN, newN, dir) {
    var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
    if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
      { return {index: index, lineN: newN} }
    var n = cm.display.viewFrom;
    for (var i = 0; i < index; i++)
      { n += view[i].size; }
    if (n != oldN) {
      if (dir > 0) {
        if (index == view.length - 1) { return null }
        diff = (n + view[index].size) - oldN;
        index++;
      } else {
        diff = n - oldN;
      }
      oldN += diff; newN += diff;
    }
    while (visualLineNo(cm.doc, newN) != newN) {
      if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
      newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
      index += dir;
    }
    return {index: index, lineN: newN}
  }

  // Force the view to cover a given range, adding empty view element
  // or clipping off existing ones as needed.
  function adjustView(cm, from, to) {
    var display = cm.display, view = display.view;
    if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
      display.view = buildViewArray(cm, from, to);
      display.viewFrom = from;
    } else {
      if (display.viewFrom > from)
        { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
      else if (display.viewFrom < from)
        { display.view = display.view.slice(findViewIndex(cm, from)); }
      display.viewFrom = from;
      if (display.viewTo < to)
        { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
      else if (display.viewTo > to)
        { display.view = display.view.slice(0, findViewIndex(cm, to)); }
    }
    display.viewTo = to;
  }

  // Count the number of lines in the view whose DOM representation is
  // out of date (or nonexistent).
  function countDirtyView(cm) {
    var view = cm.display.view, dirty = 0;
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
    }
    return dirty
  }

  function updateSelection(cm) {
    cm.display.input.showSelection(cm.display.input.prepareSelection());
  }

  function prepareSelection(cm, primary) {
    if ( primary === void 0 ) primary = true;

    var doc = cm.doc, result = {};
    var curFragment = result.cursors = document.createDocumentFragment();
    var selFragment = result.selection = document.createDocumentFragment();

    for (var i = 0; i < doc.sel.ranges.length; i++) {
      if (!primary && i == doc.sel.primIndex) { continue }
      var range = doc.sel.ranges[i];
      if (range.from().line >= cm.display.viewTo || range.to().line < cm.display.viewFrom) { continue }
      var collapsed = range.empty();
      if (collapsed || cm.options.showCursorWhenSelecting)
        { drawSelectionCursor(cm, range.head, curFragment); }
      if (!collapsed)
        { drawSelectionRange(cm, range, selFragment); }
    }
    return result
  }

  // Draws a cursor for the given range
  function drawSelectionCursor(cm, head, output) {
    var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

    var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
    cursor.style.left = pos.left + "px";
    cursor.style.top = pos.top + "px";
    cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

    if (pos.other) {
      // Secondary cursor, shown when on a 'jump' in bi-directional text
      var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
      otherCursor.style.display = "";
      otherCursor.style.left = pos.other.left + "px";
      otherCursor.style.top = pos.other.top + "px";
      otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
    }
  }

  function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

  // Draws the given range as a highlighted selection
  function drawSelectionRange(cm, range, output) {
    var display = cm.display, doc = cm.doc;
    var fragment = document.createDocumentFragment();
    var padding = paddingH(cm.display), leftSide = padding.left;
    var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
    var docLTR = doc.direction == "ltr";

    function add(left, top, width, bottom) {
      if (top < 0) { top = 0; }
      top = Math.round(top);
      bottom = Math.round(bottom);
      fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
    }

    function drawForLine(line, fromArg, toArg) {
      var lineObj = getLine(doc, line);
      var lineLen = lineObj.text.length;
      var start, end;
      function coords(ch, bias) {
        return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
      }

      function wrapX(pos, dir, side) {
        var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
        var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
        var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
        return coords(ch, prop)[prop]
      }

      var order = getOrder(lineObj, doc.direction);
      iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
        var ltr = dir == "ltr";
        var fromPos = coords(from, ltr ? "left" : "right");
        var toPos = coords(to - 1, ltr ? "right" : "left");

        var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
        var first = i == 0, last = !order || i == order.length - 1;
        if (toPos.top - fromPos.top <= 3) { // Single line
          var openLeft = (docLTR ? openStart : openEnd) && first;
          var openRight = (docLTR ? openEnd : openStart) && last;
          var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
          var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
          add(left, fromPos.top, right - left, fromPos.bottom);
        } else { // Multiple lines
          var topLeft, topRight, botLeft, botRight;
          if (ltr) {
            topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
            topRight = docLTR ? rightSide : wrapX(from, dir, "before");
            botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
            botRight = docLTR && openEnd && last ? rightSide : toPos.right;
          } else {
            topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
            topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
            botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
            botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
          }
          add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
          if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
          add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
        }

        if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
        if (cmpCoords(toPos, start) < 0) { start = toPos; }
        if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
        if (cmpCoords(toPos, end) < 0) { end = toPos; }
      });
      return {start: start, end: end}
    }

    var sFrom = range.from(), sTo = range.to();
    if (sFrom.line == sTo.line) {
      drawForLine(sFrom.line, sFrom.ch, sTo.ch);
    } else {
      var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
      var singleVLine = visualLine(fromLine) == visualLine(toLine);
      var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
      var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
      if (singleVLine) {
        if (leftEnd.top < rightStart.top - 2) {
          add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
          add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
        } else {
          add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
        }
      }
      if (leftEnd.bottom < rightStart.top)
        { add(leftSide, leftEnd.bottom, null, rightStart.top); }
    }

    output.appendChild(fragment);
  }

  // Cursor-blinking
  function restartBlink(cm) {
    if (!cm.state.focused) { return }
    var display = cm.display;
    clearInterval(display.blinker);
    var on = true;
    display.cursorDiv.style.visibility = "";
    if (cm.options.cursorBlinkRate > 0)
      { display.blinker = setInterval(function () {
        if (!cm.hasFocus()) { onBlur(cm); }
        display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
      }, cm.options.cursorBlinkRate); }
    else if (cm.options.cursorBlinkRate < 0)
      { display.cursorDiv.style.visibility = "hidden"; }
  }

  function ensureFocus(cm) {
    if (!cm.hasFocus()) {
      cm.display.input.focus();
      if (!cm.state.focused) { onFocus(cm); }
    }
  }

  function delayBlurEvent(cm) {
    cm.state.delayingBlurEvent = true;
    setTimeout(function () { if (cm.state.delayingBlurEvent) {
      cm.state.delayingBlurEvent = false;
      if (cm.state.focused) { onBlur(cm); }
    } }, 100);
  }

  function onFocus(cm, e) {
    if (cm.state.delayingBlurEvent && !cm.state.draggingText) { cm.state.delayingBlurEvent = false; }

    if (cm.options.readOnly == "nocursor") { return }
    if (!cm.state.focused) {
      signal(cm, "focus", cm, e);
      cm.state.focused = true;
      addClass(cm.display.wrapper, "CodeMirror-focused");
      // This test prevents this from firing when a context
      // menu is closed (since the input reset would kill the
      // select-all detection hack)
      if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
        cm.display.input.reset();
        if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
      }
      cm.display.input.receivedFocus();
    }
    restartBlink(cm);
  }
  function onBlur(cm, e) {
    if (cm.state.delayingBlurEvent) { return }

    if (cm.state.focused) {
      signal(cm, "blur", cm, e);
      cm.state.focused = false;
      rmClass(cm.display.wrapper, "CodeMirror-focused");
    }
    clearInterval(cm.display.blinker);
    setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
  }

  // Read the actual heights of the rendered lines, and update their
  // stored heights to match.
  function updateHeightsInViewport(cm) {
    var display = cm.display;
    var prevBottom = display.lineDiv.offsetTop;
    for (var i = 0; i < display.view.length; i++) {
      var cur = display.view[i], wrapping = cm.options.lineWrapping;
      var height = (void 0), width = 0;
      if (cur.hidden) { continue }
      if (ie && ie_version < 8) {
        var bot = cur.node.offsetTop + cur.node.offsetHeight;
        height = bot - prevBottom;
        prevBottom = bot;
      } else {
        var box = cur.node.getBoundingClientRect();
        height = box.bottom - box.top;
        // Check that lines don't extend past the right of the current
        // editor width
        if (!wrapping && cur.text.firstChild)
          { width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1; }
      }
      var diff = cur.line.height - height;
      if (diff > .005 || diff < -.005) {
        updateLineHeight(cur.line, height);
        updateWidgetHeight(cur.line);
        if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
          { updateWidgetHeight(cur.rest[j]); } }
      }
      if (width > cm.display.sizerWidth) {
        var chWidth = Math.ceil(width / charWidth(cm.display));
        if (chWidth > cm.display.maxLineLength) {
          cm.display.maxLineLength = chWidth;
          cm.display.maxLine = cur.line;
          cm.display.maxLineChanged = true;
        }
      }
    }
  }

  // Read and store the height of line widgets associated with the
  // given line.
  function updateWidgetHeight(line) {
    if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
      var w = line.widgets[i], parent = w.node.parentNode;
      if (parent) { w.height = parent.offsetHeight; }
    } }
  }

  // Compute the lines that are visible in a given viewport (defaults
  // the the current scroll position). viewport may contain top,
  // height, and ensure (see op.scrollToPos) properties.
  function visibleLines(display, doc, viewport) {
    var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
    top = Math.floor(top - paddingTop(display));
    var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

    var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
    // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
    // forces those lines into the viewport (if possible).
    if (viewport && viewport.ensure) {
      var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
      if (ensureFrom < from) {
        from = ensureFrom;
        to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
      } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
        from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
        to = ensureTo;
      }
    }
    return {from: from, to: Math.max(to, from + 1)}
  }

  // SCROLLING THINGS INTO VIEW

  // If an editor sits on the top or bottom of the window, partially
  // scrolled out of view, this ensures that the cursor is visible.
  function maybeScrollWindow(cm, rect) {
    if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

    var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
    if (rect.top + box.top < 0) { doScroll = true; }
    else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
    if (doScroll != null && !phantom) {
      var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
      cm.display.lineSpace.appendChild(scrollNode);
      scrollNode.scrollIntoView(doScroll);
      cm.display.lineSpace.removeChild(scrollNode);
    }
  }

  // Scroll a given position into view (immediately), verifying that
  // it actually became visible (as line heights are accurately
  // measured, the position of something may 'drift' during drawing).
  function scrollPosIntoView(cm, pos, end, margin) {
    if (margin == null) { margin = 0; }
    var rect;
    if (!cm.options.lineWrapping && pos == end) {
      // Set pos and end to the cursor positions around the character pos sticks to
      // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
      // If pos == Pos(_, 0, "before"), pos and end are unchanged
      end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
      pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    }
    for (var limit = 0; limit < 5; limit++) {
      var changed = false;
      var coords = cursorCoords(cm, pos);
      var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
      rect = {left: Math.min(coords.left, endCoords.left),
              top: Math.min(coords.top, endCoords.top) - margin,
              right: Math.max(coords.left, endCoords.left),
              bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
      var scrollPos = calculateScrollPos(cm, rect);
      var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
        if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
        if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
      }
      if (!changed) { break }
    }
    return rect
  }

  // Scroll a given set of coordinates into view (immediately).
  function scrollIntoView(cm, rect) {
    var scrollPos = calculateScrollPos(cm, rect);
    if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
    if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
  }

  // Calculate a new scroll position needed to scroll the given
  // rectangle into view. Returns an object with scrollTop and
  // scrollLeft properties. When these are undefined, the
  // vertical/horizontal position does not need to be adjusted.
  function calculateScrollPos(cm, rect) {
    var display = cm.display, snapMargin = textHeight(cm.display);
    if (rect.top < 0) { rect.top = 0; }
    var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
    var screen = displayHeight(cm), result = {};
    if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
    var docBottom = cm.doc.height + paddingVert(display);
    var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
    if (rect.top < screentop) {
      result.scrollTop = atTop ? 0 : rect.top;
    } else if (rect.bottom > screentop + screen) {
      var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
      if (newTop != screentop) { result.scrollTop = newTop; }
    }

    var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
    var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
    var screenw = displayWidth(cm) - display.gutters.offsetWidth;
    var tooWide = rect.right - rect.left > screenw;
    if (tooWide) { rect.right = rect.left + screenw; }
    if (rect.left < 10)
      { result.scrollLeft = 0; }
    else if (rect.left < screenleft)
      { result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10)); }
    else if (rect.right > screenw + screenleft - 3)
      { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
    return result
  }

  // Store a relative adjustment to the scroll position in the current
  // operation (to be applied when the operation finishes).
  function addToScrollTop(cm, top) {
    if (top == null) { return }
    resolveScrollToPos(cm);
    cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
  }

  // Make sure that at the end of the operation the current cursor is
  // shown.
  function ensureCursorVisible(cm) {
    resolveScrollToPos(cm);
    var cur = cm.getCursor();
    cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
  }

  function scrollToCoords(cm, x, y) {
    if (x != null || y != null) { resolveScrollToPos(cm); }
    if (x != null) { cm.curOp.scrollLeft = x; }
    if (y != null) { cm.curOp.scrollTop = y; }
  }

  function scrollToRange(cm, range) {
    resolveScrollToPos(cm);
    cm.curOp.scrollToPos = range;
  }

  // When an operation has its scrollToPos property set, and another
  // scroll action is applied before the end of the operation, this
  // 'simulates' scrolling that position into view in a cheap way, so
  // that the effect of intermediate scroll commands is not ignored.
  function resolveScrollToPos(cm) {
    var range = cm.curOp.scrollToPos;
    if (range) {
      cm.curOp.scrollToPos = null;
      var from = estimateCoords(cm, range.from), to = estimateCoords(cm, range.to);
      scrollToCoordsRange(cm, from, to, range.margin);
    }
  }

  function scrollToCoordsRange(cm, from, to, margin) {
    var sPos = calculateScrollPos(cm, {
      left: Math.min(from.left, to.left),
      top: Math.min(from.top, to.top) - margin,
      right: Math.max(from.right, to.right),
      bottom: Math.max(from.bottom, to.bottom) + margin
    });
    scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
  }

  // Sync the scrollable area and scrollbars, ensure the viewport
  // covers the visible area.
  function updateScrollTop(cm, val) {
    if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
    if (!gecko) { updateDisplaySimple(cm, {top: val}); }
    setScrollTop(cm, val, true);
    if (gecko) { updateDisplaySimple(cm); }
    startWorker(cm, 100);
  }

  function setScrollTop(cm, val, forceScroll) {
    val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
    if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
    cm.doc.scrollTop = val;
    cm.display.scrollbars.setScrollTop(val);
    if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
  }

  // Sync scroller and scrollbar, ensure the gutter elements are
  // aligned.
  function setScrollLeft(cm, val, isScroller, forceScroll) {
    val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
    if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
    cm.doc.scrollLeft = val;
    alignHorizontally(cm);
    if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
    cm.display.scrollbars.setScrollLeft(val);
  }

  // SCROLLBARS

  // Prepare DOM reads needed to update the scrollbars. Done in one
  // shot to minimize update/measure roundtrips.
  function measureForScrollbars(cm) {
    var d = cm.display, gutterW = d.gutters.offsetWidth;
    var docH = Math.round(cm.doc.height + paddingVert(cm.display));
    return {
      clientHeight: d.scroller.clientHeight,
      viewHeight: d.wrapper.clientHeight,
      scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
      viewWidth: d.wrapper.clientWidth,
      barLeft: cm.options.fixedGutter ? gutterW : 0,
      docHeight: docH,
      scrollHeight: docH + scrollGap(cm) + d.barHeight,
      nativeBarWidth: d.nativeBarWidth,
      gutterWidth: gutterW
    }
  }

  var NativeScrollbars = function(place, scroll, cm) {
    this.cm = cm;
    var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
    var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
    vert.tabIndex = horiz.tabIndex = -1;
    place(vert); place(horiz);

    on(vert, "scroll", function () {
      if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
    });
    on(horiz, "scroll", function () {
      if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
    });

    this.checkedZeroWidth = false;
    // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
    if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
  };

  NativeScrollbars.prototype.update = function (measure) {
    var needsH = measure.scrollWidth > measure.clientWidth + 1;
    var needsV = measure.scrollHeight > measure.clientHeight + 1;
    var sWidth = measure.nativeBarWidth;

    if (needsV) {
      this.vert.style.display = "block";
      this.vert.style.bottom = needsH ? sWidth + "px" : "0";
      var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
      // A bug in IE8 can cause this value to be negative, so guard it.
      this.vert.firstChild.style.height =
        Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
    } else {
      this.vert.style.display = "";
      this.vert.firstChild.style.height = "0";
    }

    if (needsH) {
      this.horiz.style.display = "block";
      this.horiz.style.right = needsV ? sWidth + "px" : "0";
      this.horiz.style.left = measure.barLeft + "px";
      var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
      this.horiz.firstChild.style.width =
        Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
    } else {
      this.horiz.style.display = "";
      this.horiz.firstChild.style.width = "0";
    }

    if (!this.checkedZeroWidth && measure.clientHeight > 0) {
      if (sWidth == 0) { this.zeroWidthHack(); }
      this.checkedZeroWidth = true;
    }

    return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
  };

  NativeScrollbars.prototype.setScrollLeft = function (pos) {
    if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
    if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
  };

  NativeScrollbars.prototype.setScrollTop = function (pos) {
    if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
    if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
  };

  NativeScrollbars.prototype.zeroWidthHack = function () {
    var w = mac && !mac_geMountainLion ? "12px" : "18px";
    this.horiz.style.height = this.vert.style.width = w;
    this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
    this.disableHoriz = new Delayed;
    this.disableVert = new Delayed;
  };

  NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
    bar.style.pointerEvents = "auto";
    function maybeDisable() {
      // To find out whether the scrollbar is still visible, we
      // check whether the element under the pixel in the bottom
      // right corner of the scrollbar box is the scrollbar box
      // itself (when the bar is still visible) or its filler child
      // (when the bar is hidden). If it is still visible, we keep
      // it enabled, if it's hidden, we disable pointer events.
      var box = bar.getBoundingClientRect();
      var elt = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
          : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
      if (elt != bar) { bar.style.pointerEvents = "none"; }
      else { delay.set(1000, maybeDisable); }
    }
    delay.set(1000, maybeDisable);
  };

  NativeScrollbars.prototype.clear = function () {
    var parent = this.horiz.parentNode;
    parent.removeChild(this.horiz);
    parent.removeChild(this.vert);
  };

  var NullScrollbars = function () {};

  NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
  NullScrollbars.prototype.setScrollLeft = function () {};
  NullScrollbars.prototype.setScrollTop = function () {};
  NullScrollbars.prototype.clear = function () {};

  function updateScrollbars(cm, measure) {
    if (!measure) { measure = measureForScrollbars(cm); }
    var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
    updateScrollbarsInner(cm, measure);
    for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
      if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
        { updateHeightsInViewport(cm); }
      updateScrollbarsInner(cm, measureForScrollbars(cm));
      startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
    }
  }

  // Re-synchronize the fake scrollbars with the actual size of the
  // content.
  function updateScrollbarsInner(cm, measure) {
    var d = cm.display;
    var sizes = d.scrollbars.update(measure);

    d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
    d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
    d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

    if (sizes.right && sizes.bottom) {
      d.scrollbarFiller.style.display = "block";
      d.scrollbarFiller.style.height = sizes.bottom + "px";
      d.scrollbarFiller.style.width = sizes.right + "px";
    } else { d.scrollbarFiller.style.display = ""; }
    if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
      d.gutterFiller.style.display = "block";
      d.gutterFiller.style.height = sizes.bottom + "px";
      d.gutterFiller.style.width = measure.gutterWidth + "px";
    } else { d.gutterFiller.style.display = ""; }
  }

  var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

  function initScrollbars(cm) {
    if (cm.display.scrollbars) {
      cm.display.scrollbars.clear();
      if (cm.display.scrollbars.addClass)
        { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
    }

    cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
      cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
      // Prevent clicks in the scrollbars from killing focus
      on(node, "mousedown", function () {
        if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
      });
      node.setAttribute("cm-not-content", "true");
    }, function (pos, axis) {
      if (axis == "horizontal") { setScrollLeft(cm, pos); }
      else { updateScrollTop(cm, pos); }
    }, cm);
    if (cm.display.scrollbars.addClass)
      { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  // Operations are used to wrap a series of changes to the editor
  // state in such a way that each change won't have to update the
  // cursor and display (which would be awkward, slow, and
  // error-prone). Instead, display updates are batched and then all
  // combined and executed at once.

  var nextOpId = 0;
  // Start a new operation.
  function startOperation(cm) {
    cm.curOp = {
      cm: cm,
      viewChanged: false,      // Flag that indicates that lines might need to be redrawn
      startHeight: cm.doc.height, // Used to detect need to update scrollbar
      forceUpdate: false,      // Used to force a redraw
      updateInput: 0,       // Whether to reset the input textarea
      typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
      changeObjs: null,        // Accumulated changes, for firing change events
      cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
      cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
      selectionChanged: false, // Whether the selection needs to be redrawn
      updateMaxLine: false,    // Set when the widest line needs to be determined anew
      scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
      scrollToPos: null,       // Used to scroll to a specific position
      focus: false,
      id: ++nextOpId,          // Unique ID
      markArrays: null         // Used by addMarkedSpan
    };
    pushOperation(cm.curOp);
  }

  // Finish an operation, updating the display and signalling delayed events
  function endOperation(cm) {
    var op = cm.curOp;
    if (op) { finishOperation(op, function (group) {
      for (var i = 0; i < group.ops.length; i++)
        { group.ops[i].cm.curOp = null; }
      endOperations(group);
    }); }
  }

  // The DOM updates done when an operation finishes are batched so
  // that the minimum number of relayouts are required.
  function endOperations(group) {
    var ops = group.ops;
    for (var i = 0; i < ops.length; i++) // Read DOM
      { endOperation_R1(ops[i]); }
    for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
      { endOperation_W1(ops[i$1]); }
    for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
      { endOperation_R2(ops[i$2]); }
    for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
      { endOperation_W2(ops[i$3]); }
    for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
      { endOperation_finish(ops[i$4]); }
  }

  function endOperation_R1(op) {
    var cm = op.cm, display = cm.display;
    maybeClipScrollbars(cm);
    if (op.updateMaxLine) { findMaxLine(cm); }

    op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
      op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                         op.scrollToPos.to.line >= display.viewTo) ||
      display.maxLineChanged && cm.options.lineWrapping;
    op.update = op.mustUpdate &&
      new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
  }

  function endOperation_W1(op) {
    op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
  }

  function endOperation_R2(op) {
    var cm = op.cm, display = cm.display;
    if (op.updatedDisplay) { updateHeightsInViewport(cm); }

    op.barMeasure = measureForScrollbars(cm);

    // If the max line changed since it was last measured, measure it,
    // and ensure the document's width matches it.
    // updateDisplay_W2 will use these properties to do the actual resizing
    if (display.maxLineChanged && !cm.options.lineWrapping) {
      op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
      cm.display.sizerWidth = op.adjustWidthTo;
      op.barMeasure.scrollWidth =
        Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
      op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
    }

    if (op.updatedDisplay || op.selectionChanged)
      { op.preparedSelection = display.input.prepareSelection(); }
  }

  function endOperation_W2(op) {
    var cm = op.cm;

    if (op.adjustWidthTo != null) {
      cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
      if (op.maxScrollLeft < cm.doc.scrollLeft)
        { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
      cm.display.maxLineChanged = false;
    }

    var takeFocus = op.focus && op.focus == activeElt();
    if (op.preparedSelection)
      { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
    if (op.updatedDisplay || op.startHeight != cm.doc.height)
      { updateScrollbars(cm, op.barMeasure); }
    if (op.updatedDisplay)
      { setDocumentHeight(cm, op.barMeasure); }

    if (op.selectionChanged) { restartBlink(cm); }

    if (cm.state.focused && op.updateInput)
      { cm.display.input.reset(op.typing); }
    if (takeFocus) { ensureFocus(op.cm); }
  }

  function endOperation_finish(op) {
    var cm = op.cm, display = cm.display, doc = cm.doc;

    if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

    // Abort mouse wheel delta measurement, when scrolling explicitly
    if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
      { display.wheelStartX = display.wheelStartY = null; }

    // Propagate the scroll position to the actual DOM scroller
    if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

    if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
    // If we need to scroll a specific position into view, do so.
    if (op.scrollToPos) {
      var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                   clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
      maybeScrollWindow(cm, rect);
    }

    // Fire events for markers that are hidden/unidden by editing or
    // undoing
    var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
    if (hidden) { for (var i = 0; i < hidden.length; ++i)
      { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
    if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
      { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

    if (display.wrapper.offsetHeight)
      { doc.scrollTop = cm.display.scroller.scrollTop; }

    // Fire change events, and delayed event handlers
    if (op.changeObjs)
      { signal(cm, "changes", cm, op.changeObjs); }
    if (op.update)
      { op.update.finish(); }
  }

  // Run the given function in an operation
  function runInOp(cm, f) {
    if (cm.curOp) { return f() }
    startOperation(cm);
    try { return f() }
    finally { endOperation(cm); }
  }
  // Wraps a function in an operation. Returns the wrapped function.
  function operation(cm, f) {
    return function() {
      if (cm.curOp) { return f.apply(cm, arguments) }
      startOperation(cm);
      try { return f.apply(cm, arguments) }
      finally { endOperation(cm); }
    }
  }
  // Used to add methods to editor and doc instances, wrapping them in
  // operations.
  function methodOp(f) {
    return function() {
      if (this.curOp) { return f.apply(this, arguments) }
      startOperation(this);
      try { return f.apply(this, arguments) }
      finally { endOperation(this); }
    }
  }
  function docMethodOp(f) {
    return function() {
      var cm = this.cm;
      if (!cm || cm.curOp) { return f.apply(this, arguments) }
      startOperation(cm);
      try { return f.apply(this, arguments) }
      finally { endOperation(cm); }
    }
  }

  // HIGHLIGHT WORKER

  function startWorker(cm, time) {
    if (cm.doc.highlightFrontier < cm.display.viewTo)
      { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
  }

  function highlightWorker(cm) {
    var doc = cm.doc;
    if (doc.highlightFrontier >= cm.display.viewTo) { return }
    var end = +new Date + cm.options.workTime;
    var context = getContextBefore(cm, doc.highlightFrontier);
    var changedLines = [];

    doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
      if (context.line >= cm.display.viewFrom) { // Visible
        var oldStyles = line.styles;
        var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
        var highlighted = highlightLine(cm, line, context, true);
        if (resetState) { context.state = resetState; }
        line.styles = highlighted.styles;
        var oldCls = line.styleClasses, newCls = highlighted.classes;
        if (newCls) { line.styleClasses = newCls; }
        else if (oldCls) { line.styleClasses = null; }
        var ischange = !oldStyles || oldStyles.length != line.styles.length ||
          oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
        for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
        if (ischange) { changedLines.push(context.line); }
        line.stateAfter = context.save();
        context.nextLine();
      } else {
        if (line.text.length <= cm.options.maxHighlightLength)
          { processLine(cm, line.text, context); }
        line.stateAfter = context.line % 5 == 0 ? context.save() : null;
        context.nextLine();
      }
      if (+new Date > end) {
        startWorker(cm, cm.options.workDelay);
        return true
      }
    });
    doc.highlightFrontier = context.line;
    doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
    if (changedLines.length) { runInOp(cm, function () {
      for (var i = 0; i < changedLines.length; i++)
        { regLineChange(cm, changedLines[i], "text"); }
    }); }
  }

  // DISPLAY DRAWING

  var DisplayUpdate = function(cm, viewport, force) {
    var display = cm.display;

    this.viewport = viewport;
    // Store some values that we'll need later (but don't want to force a relayout for)
    this.visible = visibleLines(display, cm.doc, viewport);
    this.editorIsHidden = !display.wrapper.offsetWidth;
    this.wrapperHeight = display.wrapper.clientHeight;
    this.wrapperWidth = display.wrapper.clientWidth;
    this.oldDisplayWidth = displayWidth(cm);
    this.force = force;
    this.dims = getDimensions(cm);
    this.events = [];
  };

  DisplayUpdate.prototype.signal = function (emitter, type) {
    if (hasHandler(emitter, type))
      { this.events.push(arguments); }
  };
  DisplayUpdate.prototype.finish = function () {
    for (var i = 0; i < this.events.length; i++)
      { signal.apply(null, this.events[i]); }
  };

  function maybeClipScrollbars(cm) {
    var display = cm.display;
    if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
      display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
      display.heightForcer.style.height = scrollGap(cm) + "px";
      display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
      display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
      display.scrollbarsClipped = true;
    }
  }

  function selectionSnapshot(cm) {
    if (cm.hasFocus()) { return null }
    var active = activeElt();
    if (!active || !contains(cm.display.lineDiv, active)) { return null }
    var result = {activeElt: active};
    if (window.getSelection) {
      var sel = window.getSelection();
      if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
        result.anchorNode = sel.anchorNode;
        result.anchorOffset = sel.anchorOffset;
        result.focusNode = sel.focusNode;
        result.focusOffset = sel.focusOffset;
      }
    }
    return result
  }

  function restoreSelection(snapshot) {
    if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
    snapshot.activeElt.focus();
    if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) &&
        snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
      var sel = window.getSelection(), range = document.createRange();
      range.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
      sel.extend(snapshot.focusNode, snapshot.focusOffset);
    }
  }

  // Does the actual updating of the line display. Bails out
  // (returning false) when there is nothing to be done and forced is
  // false.
  function updateDisplayIfNeeded(cm, update) {
    var display = cm.display, doc = cm.doc;

    if (update.editorIsHidden) {
      resetView(cm);
      return false
    }

    // Bail out if the visible area is already rendered and nothing changed.
    if (!update.force &&
        update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
        display.renderedView == display.view && countDirtyView(cm) == 0)
      { return false }

    if (maybeUpdateLineNumberWidth(cm)) {
      resetView(cm);
      update.dims = getDimensions(cm);
    }

    // Compute a suitable new viewport (from & to)
    var end = doc.first + doc.size;
    var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
    var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
    if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
    if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
    if (sawCollapsedSpans) {
      from = visualLineNo(cm.doc, from);
      to = visualLineEndNo(cm.doc, to);
    }

    var different = from != display.viewFrom || to != display.viewTo ||
      display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
    adjustView(cm, from, to);

    display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
    // Position the mover div to align with the current scroll position
    cm.display.mover.style.top = display.viewOffset + "px";

    var toUpdate = countDirtyView(cm);
    if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
        (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
      { return false }

    // For big changes, we hide the enclosing element during the
    // update, since that speeds up the operations on most browsers.
    var selSnapshot = selectionSnapshot(cm);
    if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
    patchDisplay(cm, display.updateLineNumbers, update.dims);
    if (toUpdate > 4) { display.lineDiv.style.display = ""; }
    display.renderedView = display.view;
    // There might have been a widget with a focused element that got
    // hidden or updated, if so re-focus it.
    restoreSelection(selSnapshot);

    // Prevent selection and cursors from interfering with the scroll
    // width and height.
    removeChildren(display.cursorDiv);
    removeChildren(display.selectionDiv);
    display.gutters.style.height = display.sizer.style.minHeight = 0;

    if (different) {
      display.lastWrapHeight = update.wrapperHeight;
      display.lastWrapWidth = update.wrapperWidth;
      startWorker(cm, 400);
    }

    display.updateLineNumbers = null;

    return true
  }

  function postUpdateDisplay(cm, update) {
    var viewport = update.viewport;

    for (var first = true;; first = false) {
      if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
        // Clip forced viewport to actual scrollable area.
        if (viewport && viewport.top != null)
          { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
        // Updated line heights might result in the drawn area not
        // actually covering the viewport. Keep looping until it does.
        update.visible = visibleLines(cm.display, cm.doc, viewport);
        if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
          { break }
      } else if (first) {
        update.visible = visibleLines(cm.display, cm.doc, viewport);
      }
      if (!updateDisplayIfNeeded(cm, update)) { break }
      updateHeightsInViewport(cm);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.force = false;
    }

    update.signal(cm, "update", cm);
    if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
      update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
      cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
    }
  }

  function updateDisplaySimple(cm, viewport) {
    var update = new DisplayUpdate(cm, viewport);
    if (updateDisplayIfNeeded(cm, update)) {
      updateHeightsInViewport(cm);
      postUpdateDisplay(cm, update);
      var barMeasure = measureForScrollbars(cm);
      updateSelection(cm);
      updateScrollbars(cm, barMeasure);
      setDocumentHeight(cm, barMeasure);
      update.finish();
    }
  }

  // Sync the actual display DOM structure with display.view, removing
  // nodes for lines that are no longer in view, and creating the ones
  // that are not there yet, and updating the ones that are out of
  // date.
  function patchDisplay(cm, updateNumbersFrom, dims) {
    var display = cm.display, lineNumbers = cm.options.lineNumbers;
    var container = display.lineDiv, cur = container.firstChild;

    function rm(node) {
      var next = node.nextSibling;
      // Works around a throw-scroll bug in OS X Webkit
      if (webkit && mac && cm.display.currentWheelTarget == node)
        { node.style.display = "none"; }
      else
        { node.parentNode.removeChild(node); }
      return next
    }

    var view = display.view, lineN = display.viewFrom;
    // Loop over the elements in the view, syncing cur (the DOM nodes
    // in display.lineDiv) with the view as we go.
    for (var i = 0; i < view.length; i++) {
      var lineView = view[i];
      if (lineView.hidden) ; else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
        var node = buildLineElement(cm, lineView, lineN, dims);
        container.insertBefore(node, cur);
      } else { // Already drawn
        while (cur != lineView.node) { cur = rm(cur); }
        var updateNumber = lineNumbers && updateNumbersFrom != null &&
          updateNumbersFrom <= lineN && lineView.lineNumber;
        if (lineView.changes) {
          if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
          updateLineForChanges(cm, lineView, lineN, dims);
        }
        if (updateNumber) {
          removeChildren(lineView.lineNumber);
          lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
        }
        cur = lineView.node.nextSibling;
      }
      lineN += lineView.size;
    }
    while (cur) { cur = rm(cur); }
  }

  function updateGutterSpace(display) {
    var width = display.gutters.offsetWidth;
    display.sizer.style.marginLeft = width + "px";
    // Send an event to consumers responding to changes in gutter width.
    signalLater(display, "gutterChanged", display);
  }

  function setDocumentHeight(cm, measure) {
    cm.display.sizer.style.minHeight = measure.docHeight + "px";
    cm.display.heightForcer.style.top = measure.docHeight + "px";
    cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
  }

  // Re-align line numbers and gutter marks to compensate for
  // horizontal scrolling.
  function alignHorizontally(cm) {
    var display = cm.display, view = display.view;
    if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
    var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
    var gutterW = display.gutters.offsetWidth, left = comp + "px";
    for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
      if (cm.options.fixedGutter) {
        if (view[i].gutter)
          { view[i].gutter.style.left = left; }
        if (view[i].gutterBackground)
          { view[i].gutterBackground.style.left = left; }
      }
      var align = view[i].alignable;
      if (align) { for (var j = 0; j < align.length; j++)
        { align[j].style.left = left; } }
    } }
    if (cm.options.fixedGutter)
      { display.gutters.style.left = (comp + gutterW) + "px"; }
  }

  // Used to ensure that the line number gutter is still the right
  // size for the current document size. Returns true when an update
  // is needed.
  function maybeUpdateLineNumberWidth(cm) {
    if (!cm.options.lineNumbers) { return false }
    var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
    if (last.length != display.lineNumChars) {
      var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                                 "CodeMirror-linenumber CodeMirror-gutter-elt"));
      var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
      display.lineGutter.style.width = "";
      display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
      display.lineNumWidth = display.lineNumInnerWidth + padding;
      display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
      display.lineGutter.style.width = display.lineNumWidth + "px";
      updateGutterSpace(cm.display);
      return true
    }
    return false
  }

  function getGutters(gutters, lineNumbers) {
    var result = [], sawLineNumbers = false;
    for (var i = 0; i < gutters.length; i++) {
      var name = gutters[i], style = null;
      if (typeof name != "string") { style = name.style; name = name.className; }
      if (name == "CodeMirror-linenumbers") {
        if (!lineNumbers) { continue }
        else { sawLineNumbers = true; }
      }
      result.push({className: name, style: style});
    }
    if (lineNumbers && !sawLineNumbers) { result.push({className: "CodeMirror-linenumbers", style: null}); }
    return result
  }

  // Rebuild the gutter elements, ensure the margin to the left of the
  // code matches their width.
  function renderGutters(display) {
    var gutters = display.gutters, specs = display.gutterSpecs;
    removeChildren(gutters);
    display.lineGutter = null;
    for (var i = 0; i < specs.length; ++i) {
      var ref = specs[i];
      var className = ref.className;
      var style = ref.style;
      var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
      if (style) { gElt.style.cssText = style; }
      if (className == "CodeMirror-linenumbers") {
        display.lineGutter = gElt;
        gElt.style.width = (display.lineNumWidth || 1) + "px";
      }
    }
    gutters.style.display = specs.length ? "" : "none";
    updateGutterSpace(display);
  }

  function updateGutters(cm) {
    renderGutters(cm.display);
    regChange(cm);
    alignHorizontally(cm);
  }

  // The display handles the DOM integration, both for input reading
  // and content drawing. It holds references to DOM nodes and
  // display-related state.

  function Display(place, doc, input, options) {
    var d = this;
    this.input = input;

    // Covers bottom-right square when both scrollbars are present.
    d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
    d.scrollbarFiller.setAttribute("cm-not-content", "true");
    // Covers bottom of gutter when coverGutterNextToScrollbar is on
    // and h scrollbar is present.
    d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
    d.gutterFiller.setAttribute("cm-not-content", "true");
    // Will contain the actual code, positioned to cover the viewport.
    d.lineDiv = eltP("div", null, "CodeMirror-code");
    // Elements are added to these to represent selection and cursors.
    d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
    d.cursorDiv = elt("div", null, "CodeMirror-cursors");
    // A visibility: hidden element used to find the size of things.
    d.measure = elt("div", null, "CodeMirror-measure");
    // When lines outside of the viewport are measured, they are drawn in this.
    d.lineMeasure = elt("div", null, "CodeMirror-measure");
    // Wraps everything that needs to exist inside the vertically-padded coordinate system
    d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                      null, "position: relative; outline: none");
    var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
    // Moved around its parent to cover visible view.
    d.mover = elt("div", [lines], null, "position: relative");
    // Set to the height of the document, allowing scrolling.
    d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
    d.sizerWidth = null;
    // Behavior of elts with overflow: auto and padding is
    // inconsistent across browsers. This is used to ensure the
    // scrollable area is big enough.
    d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
    // Will contain the gutters, if any.
    d.gutters = elt("div", null, "CodeMirror-gutters");
    d.lineGutter = null;
    // Actual scrollable element.
    d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
    d.scroller.setAttribute("tabIndex", "-1");
    // The element in which the editor lives.
    d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

    // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
    if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
    if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

    if (place) {
      if (place.appendChild) { place.appendChild(d.wrapper); }
      else { place(d.wrapper); }
    }

    // Current rendered range (may be bigger than the view window).
    d.viewFrom = d.viewTo = doc.first;
    d.reportedViewFrom = d.reportedViewTo = doc.first;
    // Information about the rendered lines.
    d.view = [];
    d.renderedView = null;
    // Holds info about a single rendered line when it was rendered
    // for measurement, while not in view.
    d.externalMeasured = null;
    // Empty space (in pixels) above the view
    d.viewOffset = 0;
    d.lastWrapHeight = d.lastWrapWidth = 0;
    d.updateLineNumbers = null;

    d.nativeBarWidth = d.barHeight = d.barWidth = 0;
    d.scrollbarsClipped = false;

    // Used to only resize the line number gutter when necessary (when
    // the amount of lines crosses a boundary that makes its width change)
    d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
    // Set to true when a non-horizontal-scrolling line widget is
    // added. As an optimization, line widget aligning is skipped when
    // this is false.
    d.alignWidgets = false;

    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

    // Tracks the maximum line length so that the horizontal scrollbar
    // can be kept static when scrolling.
    d.maxLine = null;
    d.maxLineLength = 0;
    d.maxLineChanged = false;

    // Used for measuring wheel scrolling granularity
    d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

    // True when shift is held down.
    d.shift = false;

    // Used to track whether anything happened since the context menu
    // was opened.
    d.selForContextMenu = null;

    d.activeTouch = null;

    d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
    renderGutters(d);

    input.init(d);
  }

  // Since the delta values reported on mouse wheel events are
  // unstandardized between browsers and even browser versions, and
  // generally horribly unpredictable, this code starts by measuring
  // the scroll effect that the first few mouse wheel events have,
  // and, from that, detects the way it can convert deltas to pixel
  // offsets afterwards.
  //
  // The reason we want to know the amount a wheel event will scroll
  // is that it gives us a chance to update the display before the
  // actual scrolling happens, reducing flickering.

  var wheelSamples = 0, wheelPixelsPerUnit = null;
  // Fill in a browser-detected starting value on browsers where we
  // know one. These don't have to be accurate -- the result of them
  // being wrong would just be a slight flicker on the first wheel
  // scroll (if it is large enough).
  if (ie) { wheelPixelsPerUnit = -.53; }
  else if (gecko) { wheelPixelsPerUnit = 15; }
  else if (chrome) { wheelPixelsPerUnit = -.7; }
  else if (safari) { wheelPixelsPerUnit = -1/3; }

  function wheelEventDelta(e) {
    var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
    if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
    if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
    else if (dy == null) { dy = e.wheelDelta; }
    return {x: dx, y: dy}
  }
  function wheelEventPixels(e) {
    var delta = wheelEventDelta(e);
    delta.x *= wheelPixelsPerUnit;
    delta.y *= wheelPixelsPerUnit;
    return delta
  }

  function onScrollWheel(cm, e) {
    var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

    var display = cm.display, scroll = display.scroller;
    // Quit if there's nothing to scroll here
    var canScrollX = scroll.scrollWidth > scroll.clientWidth;
    var canScrollY = scroll.scrollHeight > scroll.clientHeight;
    if (!(dx && canScrollX || dy && canScrollY)) { return }

    // Webkit browsers on OS X abort momentum scrolls when the target
    // of the scroll event is removed from the scrollable element.
    // This hack (see related code in patchDisplay) makes sure the
    // element is kept around.
    if (dy && mac && webkit) {
      outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
        for (var i = 0; i < view.length; i++) {
          if (view[i].node == cur) {
            cm.display.currentWheelTarget = cur;
            break outer
          }
        }
      }
    }

    // On some browsers, horizontal scrolling will cause redraws to
    // happen before the gutter has been realigned, causing it to
    // wriggle around in a most unseemly way. When we have an
    // estimated pixels/delta value, we just handle horizontal
    // scrolling entirely here. It'll be slightly off from native, but
    // better than glitching out.
    if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
      if (dy && canScrollY)
        { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
      setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
      // Only prevent default scrolling if vertical scrolling is
      // actually possible. Otherwise, it causes vertical scroll
      // jitter on OSX trackpads when deltaX is small and deltaY
      // is large (issue #3579)
      if (!dy || (dy && canScrollY))
        { e_preventDefault(e); }
      display.wheelStartX = null; // Abort measurement, if in progress
      return
    }

    // 'Project' the visible viewport to cover the area that is being
    // scrolled into view (if we know enough to estimate it).
    if (dy && wheelPixelsPerUnit != null) {
      var pixels = dy * wheelPixelsPerUnit;
      var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
      if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
      else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
      updateDisplaySimple(cm, {top: top, bottom: bot});
    }

    if (wheelSamples < 20) {
      if (display.wheelStartX == null) {
        display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
        display.wheelDX = dx; display.wheelDY = dy;
        setTimeout(function () {
          if (display.wheelStartX == null) { return }
          var movedX = scroll.scrollLeft - display.wheelStartX;
          var movedY = scroll.scrollTop - display.wheelStartY;
          var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
            (movedX && display.wheelDX && movedX / display.wheelDX);
          display.wheelStartX = display.wheelStartY = null;
          if (!sample) { return }
          wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
          ++wheelSamples;
        }, 200);
      } else {
        display.wheelDX += dx; display.wheelDY += dy;
      }
    }
  }

  // Selection objects are immutable. A new one is created every time
  // the selection changes. A selection is one or more non-overlapping
  // (and non-touching) ranges, sorted, and an integer that indicates
  // which one is the primary selection (the one that's scrolled into
  // view, that getCursor returns, etc).
  var Selection = function(ranges, primIndex) {
    this.ranges = ranges;
    this.primIndex = primIndex;
  };

  Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

  Selection.prototype.equals = function (other) {
    if (other == this) { return true }
    if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
    for (var i = 0; i < this.ranges.length; i++) {
      var here = this.ranges[i], there = other.ranges[i];
      if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
    }
    return true
  };

  Selection.prototype.deepCopy = function () {
    var out = [];
    for (var i = 0; i < this.ranges.length; i++)
      { out[i] = new Range(copyPos(this.ranges[i].anchor), copyPos(this.ranges[i].head)); }
    return new Selection(out, this.primIndex)
  };

  Selection.prototype.somethingSelected = function () {
    for (var i = 0; i < this.ranges.length; i++)
      { if (!this.ranges[i].empty()) { return true } }
    return false
  };

  Selection.prototype.contains = function (pos, end) {
    if (!end) { end = pos; }
    for (var i = 0; i < this.ranges.length; i++) {
      var range = this.ranges[i];
      if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
        { return i }
    }
    return -1
  };

  var Range = function(anchor, head) {
    this.anchor = anchor; this.head = head;
  };

  Range.prototype.from = function () { return minPos(this.anchor, this.head) };
  Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
  Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

  // Take an unsorted, potentially overlapping set of ranges, and
  // build a selection out of it. 'Consumes' ranges array (modifying
  // it).
  function normalizeSelection(cm, ranges, primIndex) {
    var mayTouch = cm && cm.options.selectionsMayTouch;
    var prim = ranges[primIndex];
    ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
    primIndex = indexOf(ranges, prim);
    for (var i = 1; i < ranges.length; i++) {
      var cur = ranges[i], prev = ranges[i - 1];
      var diff = cmp(prev.to(), cur.from());
      if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
        var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
        var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
        if (i <= primIndex) { --primIndex; }
        ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
      }
    }
    return new Selection(ranges, primIndex)
  }

  function simpleSelection(anchor, head) {
    return new Selection([new Range(anchor, head || anchor)], 0)
  }

  // Compute the position of the end of a change (its 'to' property
  // refers to the pre-change end).
  function changeEnd(change) {
    if (!change.text) { return change.to }
    return Pos(change.from.line + change.text.length - 1,
               lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
  }

  // Adjust a position to refer to the post-change position of the
  // same text, or the end of the change if the change covers it.
  function adjustForChange(pos, change) {
    if (cmp(pos, change.from) < 0) { return pos }
    if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

    var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
    if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
    return Pos(line, ch)
  }

  function computeSelAfterChange(doc, change) {
    var out = [];
    for (var i = 0; i < doc.sel.ranges.length; i++) {
      var range = doc.sel.ranges[i];
      out.push(new Range(adjustForChange(range.anchor, change),
                         adjustForChange(range.head, change)));
    }
    return normalizeSelection(doc.cm, out, doc.sel.primIndex)
  }

  function offsetPos(pos, old, nw) {
    if (pos.line == old.line)
      { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
    else
      { return Pos(nw.line + (pos.line - old.line), pos.ch) }
  }

  // Used by replaceSelections to allow moving the selection to the
  // start or around the replaced test. Hint may be "start" or "around".
  function computeReplacedSel(doc, changes, hint) {
    var out = [];
    var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var from = offsetPos(change.from, oldPrev, newPrev);
      var to = offsetPos(changeEnd(change), oldPrev, newPrev);
      oldPrev = change.to;
      newPrev = to;
      if (hint == "around") {
        var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
        out[i] = new Range(inv ? to : from, inv ? from : to);
      } else {
        out[i] = new Range(from, from);
      }
    }
    return new Selection(out, doc.sel.primIndex)
  }

  // Used to get the editor into a consistent state again when options change.

  function loadMode(cm) {
    cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
    resetModeState(cm);
  }

  function resetModeState(cm) {
    cm.doc.iter(function (line) {
      if (line.stateAfter) { line.stateAfter = null; }
      if (line.styles) { line.styles = null; }
    });
    cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
    startWorker(cm, 100);
    cm.state.modeGen++;
    if (cm.curOp) { regChange(cm); }
  }

  // DOCUMENT DATA STRUCTURE

  // By default, updates that start and end at the beginning of a line
  // are treated specially, in order to make the association of line
  // widgets and marker elements with the text behave more intuitive.
  function isWholeLineUpdate(doc, change) {
    return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
      (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
  }

  // Perform a change on the document data structure.
  function updateDoc(doc, change, markedSpans, estimateHeight) {
    function spansFor(n) {return markedSpans ? markedSpans[n] : null}
    function update(line, text, spans) {
      updateLine(line, text, spans, estimateHeight);
      signalLater(line, "change", line, change);
    }
    function linesFor(start, end) {
      var result = [];
      for (var i = start; i < end; ++i)
        { result.push(new Line(text[i], spansFor(i), estimateHeight)); }
      return result
    }

    var from = change.from, to = change.to, text = change.text;
    var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
    var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

    // Adjust the line structure
    if (change.full) {
      doc.insert(0, linesFor(0, text.length));
      doc.remove(text.length, doc.size - text.length);
    } else if (isWholeLineUpdate(doc, change)) {
      // This is a whole-line replace. Treated specially to make
      // sure line objects move the way they are supposed to.
      var added = linesFor(0, text.length - 1);
      update(lastLine, lastLine.text, lastSpans);
      if (nlines) { doc.remove(from.line, nlines); }
      if (added.length) { doc.insert(from.line, added); }
    } else if (firstLine == lastLine) {
      if (text.length == 1) {
        update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
      } else {
        var added$1 = linesFor(1, text.length - 1);
        added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight));
        update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        doc.insert(from.line + 1, added$1);
      }
    } else if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
      doc.remove(from.line + 1, nlines);
    } else {
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
      var added$2 = linesFor(1, text.length - 1);
      if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
      doc.insert(from.line + 1, added$2);
    }

    signalLater(doc, "change", doc, change);
  }

  // Call f for all linked documents.
  function linkedDocs(doc, f, sharedHistOnly) {
    function propagate(doc, skip, sharedHist) {
      if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
        var rel = doc.linked[i];
        if (rel.doc == skip) { continue }
        var shared = sharedHist && rel.sharedHist;
        if (sharedHistOnly && !shared) { continue }
        f(rel.doc, shared);
        propagate(rel.doc, doc, shared);
      } }
    }
    propagate(doc, null, true);
  }

  // Attach a document to an editor.
  function attachDoc(cm, doc) {
    if (doc.cm) { throw new Error("This document is already in use.") }
    cm.doc = doc;
    doc.cm = cm;
    estimateLineHeights(cm);
    loadMode(cm);
    setDirectionClass(cm);
    cm.options.direction = doc.direction;
    if (!cm.options.lineWrapping) { findMaxLine(cm); }
    cm.options.mode = doc.modeOption;
    regChange(cm);
  }

  function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
  }

  function directionChanged(cm) {
    runInOp(cm, function () {
      setDirectionClass(cm);
      regChange(cm);
    });
  }

  function History(prev) {
    // Arrays of change events and selections. Doing something adds an
    // event to done and clears undo. Undoing moves events from done
    // to undone, redoing moves them in the other direction.
    this.done = []; this.undone = [];
    this.undoDepth = prev ? prev.undoDepth : Infinity;
    // Used to track when changes can be merged into a single undo
    // event
    this.lastModTime = this.lastSelTime = 0;
    this.lastOp = this.lastSelOp = null;
    this.lastOrigin = this.lastSelOrigin = null;
    // Used by the isClean() method
    this.generation = this.maxGeneration = prev ? prev.maxGeneration : 1;
  }

  // Create a history change event from an updateDoc-style change
  // object.
  function historyChangeFromChange(doc, change) {
    var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
    attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
    linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
    return histChange
  }

  // Pop all selection events off the end of a history array. Stop at
  // a change event.
  function clearSelectionEvents(array) {
    while (array.length) {
      var last = lst(array);
      if (last.ranges) { array.pop(); }
      else { break }
    }
  }

  // Find the top change event in the history. Pop off selection
  // events that are in the way.
  function lastChangeEvent(hist, force) {
    if (force) {
      clearSelectionEvents(hist.done);
      return lst(hist.done)
    } else if (hist.done.length && !lst(hist.done).ranges) {
      return lst(hist.done)
    } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
      hist.done.pop();
      return lst(hist.done)
    }
  }

  // Register a change in the history. Merges changes that are within
  // a single operation, or are close together with an origin that
  // allows merging (starting with "+") into a single event.
  function addChangeToHistory(doc, change, selAfter, opId) {
    var hist = doc.history;
    hist.undone.length = 0;
    var time = +new Date, cur;
    var last;

    if ((hist.lastOp == opId ||
         hist.lastOrigin == change.origin && change.origin &&
         ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
          change.origin.charAt(0) == "*")) &&
        (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
      // Merge this change into the last event
      last = lst(cur.changes);
      if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
        // Optimized case for simple insertion -- don't want to add
        // new changesets for every character typed
        last.to = changeEnd(change);
      } else {
        // Add new sub-event
        cur.changes.push(historyChangeFromChange(doc, change));
      }
    } else {
      // Can not be merged, start a new event.
      var before = lst(hist.done);
      if (!before || !before.ranges)
        { pushSelectionToHistory(doc.sel, hist.done); }
      cur = {changes: [historyChangeFromChange(doc, change)],
             generation: hist.generation};
      hist.done.push(cur);
      while (hist.done.length > hist.undoDepth) {
        hist.done.shift();
        if (!hist.done[0].ranges) { hist.done.shift(); }
      }
    }
    hist.done.push(selAfter);
    hist.generation = ++hist.maxGeneration;
    hist.lastModTime = hist.lastSelTime = time;
    hist.lastOp = hist.lastSelOp = opId;
    hist.lastOrigin = hist.lastSelOrigin = change.origin;

    if (!last) { signal(doc, "historyAdded"); }
  }

  function selectionEventCanBeMerged(doc, origin, prev, sel) {
    var ch = origin.charAt(0);
    return ch == "*" ||
      ch == "+" &&
      prev.ranges.length == sel.ranges.length &&
      prev.somethingSelected() == sel.somethingSelected() &&
      new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
  }

  // Called whenever the selection changes, sets the new selection as
  // the pending selection in the history, and pushes the old pending
  // selection into the 'done' array when it was significantly
  // different (in number of selected ranges, emptiness, or time).
  function addSelectionToHistory(doc, sel, opId, options) {
    var hist = doc.history, origin = options && options.origin;

    // A new event is started when the previous origin does not match
    // the current, or the origins don't allow matching. Origins
    // starting with * are always merged, those starting with + are
    // merged when similar and close together in time.
    if (opId == hist.lastSelOp ||
        (origin && hist.lastSelOrigin == origin &&
         (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
          selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
      { hist.done[hist.done.length - 1] = sel; }
    else
      { pushSelectionToHistory(sel, hist.done); }

    hist.lastSelTime = +new Date;
    hist.lastSelOrigin = origin;
    hist.lastSelOp = opId;
    if (options && options.clearRedo !== false)
      { clearSelectionEvents(hist.undone); }
  }

  function pushSelectionToHistory(sel, dest) {
    var top = lst(dest);
    if (!(top && top.ranges && top.equals(sel)))
      { dest.push(sel); }
  }

  // Used to store marked span information in the history.
  function attachLocalSpans(doc, change, from, to) {
    var existing = change["spans_" + doc.id], n = 0;
    doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
      if (line.markedSpans)
        { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
      ++n;
    });
  }

  // When un/re-doing restores text containing marked spans, those
  // that have been explicitly cleared should not be restored.
  function removeClearedSpans(spans) {
    if (!spans) { return null }
    var out;
    for (var i = 0; i < spans.length; ++i) {
      if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
      else if (out) { out.push(spans[i]); }
    }
    return !out ? spans : out.length ? out : null
  }

  // Retrieve and filter the old marked spans stored in a change event.
  function getOldSpans(doc, change) {
    var found = change["spans_" + doc.id];
    if (!found) { return null }
    var nw = [];
    for (var i = 0; i < change.text.length; ++i)
      { nw.push(removeClearedSpans(found[i])); }
    return nw
  }

  // Used for un/re-doing changes from the history. Combines the
  // result of computing the existing spans with the set of spans that
  // existed in the history (so that deleting around a span and then
  // undoing brings back the span).
  function mergeOldSpans(doc, change) {
    var old = getOldSpans(doc, change);
    var stretched = stretchSpansOverChange(doc, change);
    if (!old) { return stretched }
    if (!stretched) { return old }

    for (var i = 0; i < old.length; ++i) {
      var oldCur = old[i], stretchCur = stretched[i];
      if (oldCur && stretchCur) {
        spans: for (var j = 0; j < stretchCur.length; ++j) {
          var span = stretchCur[j];
          for (var k = 0; k < oldCur.length; ++k)
            { if (oldCur[k].marker == span.marker) { continue spans } }
          oldCur.push(span);
        }
      } else if (stretchCur) {
        old[i] = stretchCur;
      }
    }
    return old
  }

  // Used both to provide a JSON-safe object in .getHistory, and, when
  // detaching a document, to split the history in two
  function copyHistoryArray(events, newGroup, instantiateSel) {
    var copy = [];
    for (var i = 0; i < events.length; ++i) {
      var event = events[i];
      if (event.ranges) {
        copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
        continue
      }
      var changes = event.changes, newChanges = [];
      copy.push({changes: newChanges});
      for (var j = 0; j < changes.length; ++j) {
        var change = changes[j], m = (void 0);
        newChanges.push({from: change.from, to: change.to, text: change.text});
        if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
          if (indexOf(newGroup, Number(m[1])) > -1) {
            lst(newChanges)[prop] = change[prop];
            delete change[prop];
          }
        } } }
      }
    }
    return copy
  }

  // The 'scroll' parameter given to many of these indicated whether
  // the new cursor position should be scrolled into view after
  // modifying the selection.

  // If shift is held or the extend flag is set, extends a range to
  // include a given position (and optionally a second position).
  // Otherwise, simply returns the range between the given positions.
  // Used for cursor motion and such.
  function extendRange(range, head, other, extend) {
    if (extend) {
      var anchor = range.anchor;
      if (other) {
        var posBefore = cmp(head, anchor) < 0;
        if (posBefore != (cmp(other, anchor) < 0)) {
          anchor = head;
          head = other;
        } else if (posBefore != (cmp(head, other) < 0)) {
          head = other;
        }
      }
      return new Range(anchor, head)
    } else {
      return new Range(other || head, head)
    }
  }

  // Extend the primary selection range, discard the rest.
  function extendSelection(doc, head, other, options, extend) {
    if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
    setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
  }

  // Extend all selections (pos is an array of selections with length
  // equal the number of selections)
  function extendSelections(doc, heads, options) {
    var out = [];
    var extend = doc.cm && (doc.cm.display.shift || doc.extend);
    for (var i = 0; i < doc.sel.ranges.length; i++)
      { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
    var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
    setSelection(doc, newSel, options);
  }

  // Updates a single range in the selection.
  function replaceOneSelection(doc, i, range, options) {
    var ranges = doc.sel.ranges.slice(0);
    ranges[i] = range;
    setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
  }

  // Reset the selection to a single range.
  function setSimpleSelection(doc, anchor, head, options) {
    setSelection(doc, simpleSelection(anchor, head), options);
  }

  // Give beforeSelectionChange handlers a change to influence a
  // selection update.
  function filterSelectionChange(doc, sel, options) {
    var obj = {
      ranges: sel.ranges,
      update: function(ranges) {
        this.ranges = [];
        for (var i = 0; i < ranges.length; i++)
          { this.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                     clipPos(doc, ranges[i].head)); }
      },
      origin: options && options.origin
    };
    signal(doc, "beforeSelectionChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
    if (obj.ranges != sel.ranges) { return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1) }
    else { return sel }
  }

  function setSelectionReplaceHistory(doc, sel, options) {
    var done = doc.history.done, last = lst(done);
    if (last && last.ranges) {
      done[done.length - 1] = sel;
      setSelectionNoUndo(doc, sel, options);
    } else {
      setSelection(doc, sel, options);
    }
  }

  // Set a new selection.
  function setSelection(doc, sel, options) {
    setSelectionNoUndo(doc, sel, options);
    addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
  }

  function setSelectionNoUndo(doc, sel, options) {
    if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
      { sel = filterSelectionChange(doc, sel, options); }

    var bias = options && options.bias ||
      (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
    setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

    if (!(options && options.scroll === false) && doc.cm && doc.cm.getOption("readOnly") != "nocursor")
      { ensureCursorVisible(doc.cm); }
  }

  function setSelectionInner(doc, sel) {
    if (sel.equals(doc.sel)) { return }

    doc.sel = sel;

    if (doc.cm) {
      doc.cm.curOp.updateInput = 1;
      doc.cm.curOp.selectionChanged = true;
      signalCursorActivity(doc.cm);
    }
    signalLater(doc, "cursorActivity", doc);
  }

  // Verify that the selection does not partially select any atomic
  // marked ranges.
  function reCheckSelection(doc) {
    setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
  }

  // Return a selection that does not partially select any atomic
  // ranges.
  function skipAtomicInSelection(doc, sel, bias, mayClear) {
    var out;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range = sel.ranges[i];
      var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
      var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
      var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
      if (out || newAnchor != range.anchor || newHead != range.head) {
        if (!out) { out = sel.ranges.slice(0, i); }
        out[i] = new Range(newAnchor, newHead);
      }
    }
    return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel
  }

  function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
    var line = getLine(doc, pos.line);
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var sp = line.markedSpans[i], m = sp.marker;

      // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
      // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
      // is with selectLeft/Right
      var preventCursorLeft = ("selectLeft" in m) ? !m.selectLeft : m.inclusiveLeft;
      var preventCursorRight = ("selectRight" in m) ? !m.selectRight : m.inclusiveRight;

      if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
          (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
        if (mayClear) {
          signal(m, "beforeCursorEnter");
          if (m.explicitlyCleared) {
            if (!line.markedSpans) { break }
            else {--i; continue}
          }
        }
        if (!m.atomic) { continue }

        if (oldPos) {
          var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
          if (dir < 0 ? preventCursorRight : preventCursorLeft)
            { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
          if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
            { return skipAtomicInner(doc, near, pos, dir, mayClear) }
        }

        var far = m.find(dir < 0 ? -1 : 1);
        if (dir < 0 ? preventCursorLeft : preventCursorRight)
          { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
        return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
      }
    } }
    return pos
  }

  // Ensure a given position is not inside an atomic range.
  function skipAtomic(doc, pos, oldPos, bias, mayClear) {
    var dir = bias || 1;
    var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
        skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
        (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
    if (!found) {
      doc.cantEdit = true;
      return Pos(doc.first, 0)
    }
    return found
  }

  function movePos(doc, pos, dir, line) {
    if (dir < 0 && pos.ch == 0) {
      if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
      else { return null }
    } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
      if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
      else { return null }
    } else {
      return new Pos(pos.line, pos.ch + dir)
    }
  }

  function selectAll(cm) {
    cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
  }

  // UPDATING

  // Allow "beforeChange" event handlers to influence a change
  function filterChange(doc, change, update) {
    var obj = {
      canceled: false,
      from: change.from,
      to: change.to,
      text: change.text,
      origin: change.origin,
      cancel: function () { return obj.canceled = true; }
    };
    if (update) { obj.update = function (from, to, text, origin) {
      if (from) { obj.from = clipPos(doc, from); }
      if (to) { obj.to = clipPos(doc, to); }
      if (text) { obj.text = text; }
      if (origin !== undefined) { obj.origin = origin; }
    }; }
    signal(doc, "beforeChange", doc, obj);
    if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

    if (obj.canceled) {
      if (doc.cm) { doc.cm.curOp.updateInput = 2; }
      return null
    }
    return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
  }

  // Apply a change to a document, and add it to the document's
  // history, and propagating it to all linked documents.
  function makeChange(doc, change, ignoreReadOnly) {
    if (doc.cm) {
      if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
      if (doc.cm.state.suppressEdits) { return }
    }

    if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
      change = filterChange(doc, change, true);
      if (!change) { return }
    }

    // Possibly split or suppress the update based on the presence
    // of read-only spans in its range.
    var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
    if (split) {
      for (var i = split.length - 1; i >= 0; --i)
        { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
    } else {
      makeChangeInner(doc, change);
    }
  }

  function makeChangeInner(doc, change) {
    if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
    var selAfter = computeSelAfterChange(doc, change);
    addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

    makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
    var rebased = [];

    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
    });
  }

  // Revert a change stored in a document's history.
  function makeChangeFromHistory(doc, type, allowSelectionOnly) {
    var suppress = doc.cm && doc.cm.state.suppressEdits;
    if (suppress && !allowSelectionOnly) { return }

    var hist = doc.history, event, selAfter = doc.sel;
    var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

    // Verify that there is a useable event (so that ctrl-z won't
    // needlessly clear selection events)
    var i = 0;
    for (; i < source.length; i++) {
      event = source[i];
      if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
        { break }
    }
    if (i == source.length) { return }
    hist.lastOrigin = hist.lastSelOrigin = null;

    for (;;) {
      event = source.pop();
      if (event.ranges) {
        pushSelectionToHistory(event, dest);
        if (allowSelectionOnly && !event.equals(doc.sel)) {
          setSelection(doc, event, {clearRedo: false});
          return
        }
        selAfter = event;
      } else if (suppress) {
        source.push(event);
        return
      } else { break }
    }

    // Build up a reverse change object to add to the opposite history
    // stack (redo when undoing, and vice versa).
    var antiChanges = [];
    pushSelectionToHistory(selAfter, dest);
    dest.push({changes: antiChanges, generation: hist.generation});
    hist.generation = event.generation || ++hist.maxGeneration;

    var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

    var loop = function ( i ) {
      var change = event.changes[i];
      change.origin = type;
      if (filter && !filterChange(doc, change, false)) {
        source.length = 0;
        return {}
      }

      antiChanges.push(historyChangeFromChange(doc, change));

      var after = i ? computeSelAfterChange(doc, change) : lst(source);
      makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
      if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
      var rebased = [];

      // Propagate to the linked documents
      linkedDocs(doc, function (doc, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc.history) == -1) {
          rebaseHist(doc.history, change);
          rebased.push(doc.history);
        }
        makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
      });
    };

    for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
      var returned = loop( i$1 );

      if ( returned ) return returned.v;
    }
  }

  // Sub-views need their line numbers shifted when text is added
  // above or below them in the parent document.
  function shiftDoc(doc, distance) {
    if (distance == 0) { return }
    doc.first += distance;
    doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
      Pos(range.anchor.line + distance, range.anchor.ch),
      Pos(range.head.line + distance, range.head.ch)
    ); }), doc.sel.primIndex);
    if (doc.cm) {
      regChange(doc.cm, doc.first, doc.first - distance, distance);
      for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
        { regLineChange(doc.cm, l, "gutter"); }
    }
  }

  // More lower-level change function, handling only a single document
  // (not linked ones).
  function makeChangeSingleDoc(doc, change, selAfter, spans) {
    if (doc.cm && !doc.cm.curOp)
      { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

    if (change.to.line < doc.first) {
      shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
      return
    }
    if (change.from.line > doc.lastLine()) { return }

    // Clip the change to the size of this doc
    if (change.from.line < doc.first) {
      var shift = change.text.length - 1 - (doc.first - change.from.line);
      shiftDoc(doc, shift);
      change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
                text: [lst(change.text)], origin: change.origin};
    }
    var last = doc.lastLine();
    if (change.to.line > last) {
      change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
                text: [change.text[0]], origin: change.origin};
    }

    change.removed = getBetween(doc, change.from, change.to);

    if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
    if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
    else { updateDoc(doc, change, spans); }
    setSelectionNoUndo(doc, selAfter, sel_dontScroll);

    if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0)))
      { doc.cantEdit = false; }
  }

  // Handle the interaction of a change to a document with the editor
  // that this document is part of.
  function makeChangeSingleDocInEditor(cm, change, spans) {
    var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

    var recomputeMaxLength = false, checkWidthStart = from.line;
    if (!cm.options.lineWrapping) {
      checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
      doc.iter(checkWidthStart, to.line + 1, function (line) {
        if (line == display.maxLine) {
          recomputeMaxLength = true;
          return true
        }
      });
    }

    if (doc.sel.contains(change.from, change.to) > -1)
      { signalCursorActivity(cm); }

    updateDoc(doc, change, spans, estimateHeight(cm));

    if (!cm.options.lineWrapping) {
      doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
        var len = lineLength(line);
        if (len > display.maxLineLength) {
          display.maxLine = line;
          display.maxLineLength = len;
          display.maxLineChanged = true;
          recomputeMaxLength = false;
        }
      });
      if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
    }

    retreatFrontier(doc, from.line);
    startWorker(cm, 400);

    var lendiff = change.text.length - (to.line - from.line) - 1;
    // Remember that these lines changed, for updating the display
    if (change.full)
      { regChange(cm); }
    else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
      { regLineChange(cm, from.line, "text"); }
    else
      { regChange(cm, from.line, to.line + 1, lendiff); }

    var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
    if (changeHandler || changesHandler) {
      var obj = {
        from: from, to: to,
        text: change.text,
        removed: change.removed,
        origin: change.origin
      };
      if (changeHandler) { signalLater(cm, "change", cm, obj); }
      if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
    }
    cm.display.selForContextMenu = null;
  }

  function replaceRange(doc, code, from, to, origin) {
    var assign;

    if (!to) { to = from; }
    if (cmp(to, from) < 0) { (assign = [to, from], from = assign[0], to = assign[1]); }
    if (typeof code == "string") { code = doc.splitLines(code); }
    makeChange(doc, {from: from, to: to, text: code, origin: origin});
  }

  // Rebasing/resetting history to deal with externally-sourced changes

  function rebaseHistSelSingle(pos, from, to, diff) {
    if (to < pos.line) {
      pos.line += diff;
    } else if (from < pos.line) {
      pos.line = from;
      pos.ch = 0;
    }
  }

  // Tries to rebase an array of history events given a change in the
  // document. If the change touches the same lines as the event, the
  // event, and everything 'behind' it, is discarded. If the change is
  // before the event, the event's positions are updated. Uses a
  // copy-on-write scheme for the positions, to avoid having to
  // reallocate them all on every rebase, but also avoid problems with
  // shared position objects being unsafely updated.
  function rebaseHistArray(array, from, to, diff) {
    for (var i = 0; i < array.length; ++i) {
      var sub = array[i], ok = true;
      if (sub.ranges) {
        if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
        for (var j = 0; j < sub.ranges.length; j++) {
          rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
          rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
        }
        continue
      }
      for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
        var cur = sub.changes[j$1];
        if (to < cur.from.line) {
          cur.from = Pos(cur.from.line + diff, cur.from.ch);
          cur.to = Pos(cur.to.line + diff, cur.to.ch);
        } else if (from <= cur.to.line) {
          ok = false;
          break
        }
      }
      if (!ok) {
        array.splice(0, i + 1);
        i = 0;
      }
    }
  }

  function rebaseHist(hist, change) {
    var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
    rebaseHistArray(hist.done, from, to, diff);
    rebaseHistArray(hist.undone, from, to, diff);
  }

  // Utility for applying a change to a line by handle or number,
  // returning the number and optionally registering the line as
  // changed.
  function changeLine(doc, handle, changeType, op) {
    var no = handle, line = handle;
    if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
    else { no = lineNo(handle); }
    if (no == null) { return null }
    if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
    return line
  }

  // The document is represented as a BTree consisting of leaves, with
  // chunk of lines in them, and branches, with up to ten leaves or
  // other branch nodes below them. The top node is always a branch
  // node, and is the document object itself (meaning it has
  // additional methods and properties).
  //
  // All nodes have parent links. The tree is used both to go from
  // line numbers to line objects, and to go from objects to numbers.
  // It also indexes by height, and is used to convert between height
  // and line object, and to find the total height of the document.
  //
  // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

  function LeafChunk(lines) {
    this.lines = lines;
    this.parent = null;
    var height = 0;
    for (var i = 0; i < lines.length; ++i) {
      lines[i].parent = this;
      height += lines[i].height;
    }
    this.height = height;
  }

  LeafChunk.prototype = {
    chunkSize: function() { return this.lines.length },

    // Remove the n lines at offset 'at'.
    removeInner: function(at, n) {
      for (var i = at, e = at + n; i < e; ++i) {
        var line = this.lines[i];
        this.height -= line.height;
        cleanUpLine(line);
        signalLater(line, "delete");
      }
      this.lines.splice(at, n);
    },

    // Helper used to collapse a small branch into a single leaf.
    collapse: function(lines) {
      lines.push.apply(lines, this.lines);
    },

    // Insert the given array of lines at offset 'at', count them as
    // having the given height.
    insertInner: function(at, lines, height) {
      this.height += height;
      this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
      for (var i = 0; i < lines.length; ++i) { lines[i].parent = this; }
    },

    // Used to iterate over a part of the tree.
    iterN: function(at, n, op) {
      for (var e = at + n; at < e; ++at)
        { if (op(this.lines[at])) { return true } }
    }
  };

  function BranchChunk(children) {
    this.children = children;
    var size = 0, height = 0;
    for (var i = 0; i < children.length; ++i) {
      var ch = children[i];
      size += ch.chunkSize(); height += ch.height;
      ch.parent = this;
    }
    this.size = size;
    this.height = height;
    this.parent = null;
  }

  BranchChunk.prototype = {
    chunkSize: function() { return this.size },

    removeInner: function(at, n) {
      this.size -= n;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var rm = Math.min(n, sz - at), oldHeight = child.height;
          child.removeInner(at, rm);
          this.height -= oldHeight - child.height;
          if (sz == rm) { this.children.splice(i--, 1); child.parent = null; }
          if ((n -= rm) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
      // If the result is smaller than 25 lines, ensure that it is a
      // single leaf node.
      if (this.size - n < 25 &&
          (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
        var lines = [];
        this.collapse(lines);
        this.children = [new LeafChunk(lines)];
        this.children[0].parent = this;
      }
    },

    collapse: function(lines) {
      for (var i = 0; i < this.children.length; ++i) { this.children[i].collapse(lines); }
    },

    insertInner: function(at, lines, height) {
      this.size += lines.length;
      this.height += height;
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at <= sz) {
          child.insertInner(at, lines, height);
          if (child.lines && child.lines.length > 50) {
            // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
            // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
            var remaining = child.lines.length % 25 + 25;
            for (var pos = remaining; pos < child.lines.length;) {
              var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
              child.height -= leaf.height;
              this.children.splice(++i, 0, leaf);
              leaf.parent = this;
            }
            child.lines = child.lines.slice(0, remaining);
            this.maybeSpill();
          }
          break
        }
        at -= sz;
      }
    },

    // When a node has grown, check whether it should be split.
    maybeSpill: function() {
      if (this.children.length <= 10) { return }
      var me = this;
      do {
        var spilled = me.children.splice(me.children.length - 5, 5);
        var sibling = new BranchChunk(spilled);
        if (!me.parent) { // Become the parent node
          var copy = new BranchChunk(me.children);
          copy.parent = me;
          me.children = [copy, sibling];
          me = copy;
       } else {
          me.size -= sibling.size;
          me.height -= sibling.height;
          var myIndex = indexOf(me.parent.children, me);
          me.parent.children.splice(myIndex + 1, 0, sibling);
        }
        sibling.parent = me.parent;
      } while (me.children.length > 10)
      me.parent.maybeSpill();
    },

    iterN: function(at, n, op) {
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i], sz = child.chunkSize();
        if (at < sz) {
          var used = Math.min(n, sz - at);
          if (child.iterN(at, used, op)) { return true }
          if ((n -= used) == 0) { break }
          at = 0;
        } else { at -= sz; }
      }
    }
  };

  // Line widgets are block elements displayed above or below a line.

  var LineWidget = function(doc, node, options) {
    if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
      { this[opt] = options[opt]; } } }
    this.doc = doc;
    this.node = node;
  };

  LineWidget.prototype.clear = function () {
    var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
    if (no == null || !ws) { return }
    for (var i = 0; i < ws.length; ++i) { if (ws[i] == this) { ws.splice(i--, 1); } }
    if (!ws.length) { line.widgets = null; }
    var height = widgetHeight(this);
    updateLineHeight(line, Math.max(0, line.height - height));
    if (cm) {
      runInOp(cm, function () {
        adjustScrollWhenAboveVisible(cm, line, -height);
        regLineChange(cm, no, "widget");
      });
      signalLater(cm, "lineWidgetCleared", cm, this, no);
    }
  };

  LineWidget.prototype.changed = function () {
      var this$1 = this;

    var oldH = this.height, cm = this.doc.cm, line = this.line;
    this.height = null;
    var diff = widgetHeight(this) - oldH;
    if (!diff) { return }
    if (!lineIsHidden(this.doc, line)) { updateLineHeight(line, line.height + diff); }
    if (cm) {
      runInOp(cm, function () {
        cm.curOp.forceUpdate = true;
        adjustScrollWhenAboveVisible(cm, line, diff);
        signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
      });
    }
  };
  eventMixin(LineWidget);

  function adjustScrollWhenAboveVisible(cm, line, diff) {
    if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
      { addToScrollTop(cm, diff); }
  }

  function addLineWidget(doc, handle, node, options) {
    var widget = new LineWidget(doc, node, options);
    var cm = doc.cm;
    if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
    changeLine(doc, handle, "widget", function (line) {
      var widgets = line.widgets || (line.widgets = []);
      if (widget.insertAt == null) { widgets.push(widget); }
      else { widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget); }
      widget.line = line;
      if (cm && !lineIsHidden(doc, line)) {
        var aboveVisible = heightAtLine(line) < doc.scrollTop;
        updateLineHeight(line, line.height + widgetHeight(widget));
        if (aboveVisible) { addToScrollTop(cm, widget.height); }
        cm.curOp.forceUpdate = true;
      }
      return true
    });
    if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
    return widget
  }

  // TEXTMARKERS

  // Created with markText and setBookmark methods. A TextMarker is a
  // handle that can be used to clear or find a marked position in the
  // document. Line objects hold arrays (markedSpans) containing
  // {from, to, marker} object pointing to such marker objects, and
  // indicating that such a marker is present on that line. Multiple
  // lines may point to the same marker when it spans across lines.
  // The spans will have null for their from/to properties when the
  // marker continues beyond the start/end of the line. Markers have
  // links back to the lines they currently touch.

  // Collapsed markers have unique ids, in order to be able to order
  // them, which is needed for uniquely determining an outer marker
  // when they overlap (they may nest, but not partially overlap).
  var nextMarkerId = 0;

  var TextMarker = function(doc, type) {
    this.lines = [];
    this.type = type;
    this.doc = doc;
    this.id = ++nextMarkerId;
  };

  // Clear the marker.
  TextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    var cm = this.doc.cm, withOp = cm && !cm.curOp;
    if (withOp) { startOperation(cm); }
    if (hasHandler(this, "clear")) {
      var found = this.find();
      if (found) { signalLater(this, "clear", found.from, found.to); }
    }
    var min = null, max = null;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (cm && !this.collapsed) { regLineChange(cm, lineNo(line), "text"); }
      else if (cm) {
        if (span.to != null) { max = lineNo(line); }
        if (span.from != null) { min = lineNo(line); }
      }
      line.markedSpans = removeMarkedSpan(line.markedSpans, span);
      if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm)
        { updateLineHeight(line, textHeight(cm.display)); }
    }
    if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
      var visual = visualLine(this.lines[i$1]), len = lineLength(visual);
      if (len > cm.display.maxLineLength) {
        cm.display.maxLine = visual;
        cm.display.maxLineLength = len;
        cm.display.maxLineChanged = true;
      }
    } }

    if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
    this.lines.length = 0;
    this.explicitlyCleared = true;
    if (this.atomic && this.doc.cantEdit) {
      this.doc.cantEdit = false;
      if (cm) { reCheckSelection(cm.doc); }
    }
    if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
    if (withOp) { endOperation(cm); }
    if (this.parent) { this.parent.clear(); }
  };

  // Find the position of the marker in the document. Returns a {from,
  // to} object by default. Side can be passed to get a specific side
  // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
  // Pos objects returned contain a line object, rather than a line
  // number (used to prevent looking up the same line twice).
  TextMarker.prototype.find = function (side, lineObj) {
    if (side == null && this.type == "bookmark") { side = 1; }
    var from, to;
    for (var i = 0; i < this.lines.length; ++i) {
      var line = this.lines[i];
      var span = getMarkedSpanFor(line.markedSpans, this);
      if (span.from != null) {
        from = Pos(lineObj ? line : lineNo(line), span.from);
        if (side == -1) { return from }
      }
      if (span.to != null) {
        to = Pos(lineObj ? line : lineNo(line), span.to);
        if (side == 1) { return to }
      }
    }
    return from && {from: from, to: to}
  };

  // Signals that the marker's widget changed, and surrounding layout
  // should be recomputed.
  TextMarker.prototype.changed = function () {
      var this$1 = this;

    var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
    if (!pos || !cm) { return }
    runInOp(cm, function () {
      var line = pos.line, lineN = lineNo(pos.line);
      var view = findViewForLine(cm, lineN);
      if (view) {
        clearLineMeasurementCacheFor(view);
        cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
      }
      cm.curOp.updateMaxLine = true;
      if (!lineIsHidden(widget.doc, line) && widget.height != null) {
        var oldHeight = widget.height;
        widget.height = null;
        var dHeight = widgetHeight(widget) - oldHeight;
        if (dHeight)
          { updateLineHeight(line, line.height + dHeight); }
      }
      signalLater(cm, "markerChanged", cm, this$1);
    });
  };

  TextMarker.prototype.attachLine = function (line) {
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp;
      if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
        { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
    }
    this.lines.push(line);
  };

  TextMarker.prototype.detachLine = function (line) {
    this.lines.splice(indexOf(this.lines, line), 1);
    if (!this.lines.length && this.doc.cm) {
      var op = this.doc.cm.curOp
      ;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
    }
  };
  eventMixin(TextMarker);

  // Create a marker, wire it up to the right lines, and
  function markText(doc, from, to, options, type) {
    // Shared markers (across linked documents) are handled separately
    // (markTextShared will call out to this again, once per
    // document).
    if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
    // Ensure we are in an operation.
    if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

    var marker = new TextMarker(doc, type), diff = cmp(from, to);
    if (options) { copyObj(options, marker, false); }
    // Don't connect empty markers unless clearWhenEmpty is false
    if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
      { return marker }
    if (marker.replacedWith) {
      // Showing up as a widget implies collapsed (widget replaces text)
      marker.collapsed = true;
      marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
      if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
      if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
    }
    if (marker.collapsed) {
      if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
          from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
        { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
      seeCollapsedSpans();
    }

    if (marker.addToHistory)
      { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

    var curLine = from.line, cm = doc.cm, updateMaxLine;
    doc.iter(curLine, to.line + 1, function (line) {
      if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
        { updateMaxLine = true; }
      if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
      addMarkedSpan(line, new MarkedSpan(marker,
                                         curLine == from.line ? from.ch : null,
                                         curLine == to.line ? to.ch : null), doc.cm && doc.cm.curOp);
      ++curLine;
    });
    // lineIsHidden depends on the presence of the spans, so needs a second pass
    if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
      if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
    }); }

    if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

    if (marker.readOnly) {
      seeReadOnlySpans();
      if (doc.history.done.length || doc.history.undone.length)
        { doc.clearHistory(); }
    }
    if (marker.collapsed) {
      marker.id = ++nextMarkerId;
      marker.atomic = true;
    }
    if (cm) {
      // Sync editor state
      if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
      if (marker.collapsed)
        { regChange(cm, from.line, to.line + 1); }
      else if (marker.className || marker.startStyle || marker.endStyle || marker.css ||
               marker.attributes || marker.title)
        { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
      if (marker.atomic) { reCheckSelection(cm.doc); }
      signalLater(cm, "markerAdded", cm, marker);
    }
    return marker
  }

  // SHARED TEXTMARKERS

  // A shared marker spans multiple linked documents. It is
  // implemented as a meta-marker-object controlling multiple normal
  // markers.
  var SharedTextMarker = function(markers, primary) {
    this.markers = markers;
    this.primary = primary;
    for (var i = 0; i < markers.length; ++i)
      { markers[i].parent = this; }
  };

  SharedTextMarker.prototype.clear = function () {
    if (this.explicitlyCleared) { return }
    this.explicitlyCleared = true;
    for (var i = 0; i < this.markers.length; ++i)
      { this.markers[i].clear(); }
    signalLater(this, "clear");
  };

  SharedTextMarker.prototype.find = function (side, lineObj) {
    return this.primary.find(side, lineObj)
  };
  eventMixin(SharedTextMarker);

  function markTextShared(doc, from, to, options, type) {
    options = copyObj(options);
    options.shared = false;
    var markers = [markText(doc, from, to, options, type)], primary = markers[0];
    var widget = options.widgetNode;
    linkedDocs(doc, function (doc) {
      if (widget) { options.widgetNode = widget.cloneNode(true); }
      markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
      for (var i = 0; i < doc.linked.length; ++i)
        { if (doc.linked[i].isParent) { return } }
      primary = lst(markers);
    });
    return new SharedTextMarker(markers, primary)
  }

  function findSharedMarkers(doc) {
    return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
  }

  function copySharedMarkers(doc, markers) {
    for (var i = 0; i < markers.length; i++) {
      var marker = markers[i], pos = marker.find();
      var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
      if (cmp(mFrom, mTo)) {
        var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
        marker.markers.push(subMark);
        subMark.parent = marker;
      }
    }
  }

  function detachSharedMarkers(markers) {
    var loop = function ( i ) {
      var marker = markers[i], linked = [marker.primary.doc];
      linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
      for (var j = 0; j < marker.markers.length; j++) {
        var subMarker = marker.markers[j];
        if (indexOf(linked, subMarker.doc) == -1) {
          subMarker.parent = null;
          marker.markers.splice(j--, 1);
        }
      }
    };

    for (var i = 0; i < markers.length; i++) loop( i );
  }

  var nextDocId = 0;
  var Doc = function(text, mode, firstLine, lineSep, direction) {
    if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
    if (firstLine == null) { firstLine = 0; }

    BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
    this.first = firstLine;
    this.scrollTop = this.scrollLeft = 0;
    this.cantEdit = false;
    this.cleanGeneration = 1;
    this.modeFrontier = this.highlightFrontier = firstLine;
    var start = Pos(firstLine, 0);
    this.sel = simpleSelection(start);
    this.history = new History(null);
    this.id = ++nextDocId;
    this.modeOption = mode;
    this.lineSep = lineSep;
    this.direction = (direction == "rtl") ? "rtl" : "ltr";
    this.extend = false;

    if (typeof text == "string") { text = this.splitLines(text); }
    updateDoc(this, {from: start, to: start, text: text});
    setSelection(this, simpleSelection(start), sel_dontScroll);
  };

  Doc.prototype = createObj(BranchChunk.prototype, {
    constructor: Doc,
    // Iterate over the document. Supports two forms -- with only one
    // argument, it calls that for each line in the document. With
    // three, it iterates over the range given by the first two (with
    // the second being non-inclusive).
    iter: function(from, to, op) {
      if (op) { this.iterN(from - this.first, to - from, op); }
      else { this.iterN(this.first, this.first + this.size, from); }
    },

    // Non-public interface for adding and removing lines.
    insert: function(at, lines) {
      var height = 0;
      for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
      this.insertInner(at - this.first, lines, height);
    },
    remove: function(at, n) { this.removeInner(at - this.first, n); },

    // From here, the methods are part of the public interface. Most
    // are also available from CodeMirror (editor) instances.

    getValue: function(lineSep) {
      var lines = getLines(this, this.first, this.first + this.size);
      if (lineSep === false) { return lines }
      return lines.join(lineSep || this.lineSeparator())
    },
    setValue: docMethodOp(function(code) {
      var top = Pos(this.first, 0), last = this.first + this.size - 1;
      makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                        text: this.splitLines(code), origin: "setValue", full: true}, true);
      if (this.cm) { scrollToCoords(this.cm, 0, 0); }
      setSelection(this, simpleSelection(top), sel_dontScroll);
    }),
    replaceRange: function(code, from, to, origin) {
      from = clipPos(this, from);
      to = to ? clipPos(this, to) : from;
      replaceRange(this, code, from, to, origin);
    },
    getRange: function(from, to, lineSep) {
      var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
      if (lineSep === false) { return lines }
      if (lineSep === '') { return lines.join('') }
      return lines.join(lineSep || this.lineSeparator())
    },

    getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

    getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
    getLineNumber: function(line) {return lineNo(line)},

    getLineHandleVisualStart: function(line) {
      if (typeof line == "number") { line = getLine(this, line); }
      return visualLine(line)
    },

    lineCount: function() {return this.size},
    firstLine: function() {return this.first},
    lastLine: function() {return this.first + this.size - 1},

    clipPos: function(pos) {return clipPos(this, pos)},

    getCursor: function(start) {
      var range = this.sel.primary(), pos;
      if (start == null || start == "head") { pos = range.head; }
      else if (start == "anchor") { pos = range.anchor; }
      else if (start == "end" || start == "to" || start === false) { pos = range.to(); }
      else { pos = range.from(); }
      return pos
    },
    listSelections: function() { return this.sel.ranges },
    somethingSelected: function() {return this.sel.somethingSelected()},

    setCursor: docMethodOp(function(line, ch, options) {
      setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
    }),
    setSelection: docMethodOp(function(anchor, head, options) {
      setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
    }),
    extendSelection: docMethodOp(function(head, other, options) {
      extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
    }),
    extendSelections: docMethodOp(function(heads, options) {
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    extendSelectionsBy: docMethodOp(function(f, options) {
      var heads = map(this.sel.ranges, f);
      extendSelections(this, clipPosArray(this, heads), options);
    }),
    setSelections: docMethodOp(function(ranges, primary, options) {
      if (!ranges.length) { return }
      var out = [];
      for (var i = 0; i < ranges.length; i++)
        { out[i] = new Range(clipPos(this, ranges[i].anchor),
                           clipPos(this, ranges[i].head || ranges[i].anchor)); }
      if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
      setSelection(this, normalizeSelection(this.cm, out, primary), options);
    }),
    addSelection: docMethodOp(function(anchor, head, options) {
      var ranges = this.sel.ranges.slice(0);
      ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
      setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
    }),

    getSelection: function(lineSep) {
      var ranges = this.sel.ranges, lines;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        lines = lines ? lines.concat(sel) : sel;
      }
      if (lineSep === false) { return lines }
      else { return lines.join(lineSep || this.lineSeparator()) }
    },
    getSelections: function(lineSep) {
      var parts = [], ranges = this.sel.ranges;
      for (var i = 0; i < ranges.length; i++) {
        var sel = getBetween(this, ranges[i].from(), ranges[i].to());
        if (lineSep !== false) { sel = sel.join(lineSep || this.lineSeparator()); }
        parts[i] = sel;
      }
      return parts
    },
    replaceSelection: function(code, collapse, origin) {
      var dup = [];
      for (var i = 0; i < this.sel.ranges.length; i++)
        { dup[i] = code; }
      this.replaceSelections(dup, collapse, origin || "+input");
    },
    replaceSelections: docMethodOp(function(code, collapse, origin) {
      var changes = [], sel = this.sel;
      for (var i = 0; i < sel.ranges.length; i++) {
        var range = sel.ranges[i];
        changes[i] = {from: range.from(), to: range.to(), text: this.splitLines(code[i]), origin: origin};
      }
      var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
      for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
        { makeChange(this, changes[i$1]); }
      if (newSel) { setSelectionReplaceHistory(this, newSel); }
      else if (this.cm) { ensureCursorVisible(this.cm); }
    }),
    undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
    redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
    undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
    redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

    setExtending: function(val) {this.extend = val;},
    getExtending: function() {return this.extend},

    historySize: function() {
      var hist = this.history, done = 0, undone = 0;
      for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
      for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
      return {undo: done, redo: undone}
    },
    clearHistory: function() {
      var this$1 = this;

      this.history = new History(this.history);
      linkedDocs(this, function (doc) { return doc.history = this$1.history; }, true);
    },

    markClean: function() {
      this.cleanGeneration = this.changeGeneration(true);
    },
    changeGeneration: function(forceSplit) {
      if (forceSplit)
        { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
      return this.history.generation
    },
    isClean: function (gen) {
      return this.history.generation == (gen || this.cleanGeneration)
    },

    getHistory: function() {
      return {done: copyHistoryArray(this.history.done),
              undone: copyHistoryArray(this.history.undone)}
    },
    setHistory: function(histData) {
      var hist = this.history = new History(this.history);
      hist.done = copyHistoryArray(histData.done.slice(0), null, true);
      hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
    },

    setGutterMarker: docMethodOp(function(line, gutterID, value) {
      return changeLine(this, line, "gutter", function (line) {
        var markers = line.gutterMarkers || (line.gutterMarkers = {});
        markers[gutterID] = value;
        if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
        return true
      })
    }),

    clearGutter: docMethodOp(function(gutterID) {
      var this$1 = this;

      this.iter(function (line) {
        if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
          changeLine(this$1, line, "gutter", function () {
            line.gutterMarkers[gutterID] = null;
            if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
            return true
          });
        }
      });
    }),

    lineInfo: function(line) {
      var n;
      if (typeof line == "number") {
        if (!isLine(this, line)) { return null }
        n = line;
        line = getLine(this, line);
        if (!line) { return null }
      } else {
        n = lineNo(line);
        if (n == null) { return null }
      }
      return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
              textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
              widgets: line.widgets}
    },

    addLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        if (!line[prop]) { line[prop] = cls; }
        else if (classTest(cls).test(line[prop])) { return false }
        else { line[prop] += " " + cls; }
        return true
      })
    }),
    removeLineClass: docMethodOp(function(handle, where, cls) {
      return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
        var prop = where == "text" ? "textClass"
                 : where == "background" ? "bgClass"
                 : where == "gutter" ? "gutterClass" : "wrapClass";
        var cur = line[prop];
        if (!cur) { return false }
        else if (cls == null) { line[prop] = null; }
        else {
          var found = cur.match(classTest(cls));
          if (!found) { return false }
          var end = found.index + found[0].length;
          line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
        }
        return true
      })
    }),

    addLineWidget: docMethodOp(function(handle, node, options) {
      return addLineWidget(this, handle, node, options)
    }),
    removeLineWidget: function(widget) { widget.clear(); },

    markText: function(from, to, options) {
      return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
    },
    setBookmark: function(pos, options) {
      var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                      insertLeft: options && options.insertLeft,
                      clearWhenEmpty: false, shared: options && options.shared,
                      handleMouseEvents: options && options.handleMouseEvents};
      pos = clipPos(this, pos);
      return markText(this, pos, pos, realOpts, "bookmark")
    },
    findMarksAt: function(pos) {
      pos = clipPos(this, pos);
      var markers = [], spans = getLine(this, pos.line).markedSpans;
      if (spans) { for (var i = 0; i < spans.length; ++i) {
        var span = spans[i];
        if ((span.from == null || span.from <= pos.ch) &&
            (span.to == null || span.to >= pos.ch))
          { markers.push(span.marker.parent || span.marker); }
      } }
      return markers
    },
    findMarks: function(from, to, filter) {
      from = clipPos(this, from); to = clipPos(this, to);
      var found = [], lineNo = from.line;
      this.iter(from.line, to.line + 1, function (line) {
        var spans = line.markedSpans;
        if (spans) { for (var i = 0; i < spans.length; i++) {
          var span = spans[i];
          if (!(span.to != null && lineNo == from.line && from.ch >= span.to ||
                span.from == null && lineNo != from.line ||
                span.from != null && lineNo == to.line && span.from >= to.ch) &&
              (!filter || filter(span.marker)))
            { found.push(span.marker.parent || span.marker); }
        } }
        ++lineNo;
      });
      return found
    },
    getAllMarks: function() {
      var markers = [];
      this.iter(function (line) {
        var sps = line.markedSpans;
        if (sps) { for (var i = 0; i < sps.length; ++i)
          { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
      });
      return markers
    },

    posFromIndex: function(off) {
      var ch, lineNo = this.first, sepSize = this.lineSeparator().length;
      this.iter(function (line) {
        var sz = line.text.length + sepSize;
        if (sz > off) { ch = off; return true }
        off -= sz;
        ++lineNo;
      });
      return clipPos(this, Pos(lineNo, ch))
    },
    indexFromPos: function (coords) {
      coords = clipPos(this, coords);
      var index = coords.ch;
      if (coords.line < this.first || coords.ch < 0) { return 0 }
      var sepSize = this.lineSeparator().length;
      this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
        index += line.text.length + sepSize;
      });
      return index
    },

    copy: function(copyHistory) {
      var doc = new Doc(getLines(this, this.first, this.first + this.size),
                        this.modeOption, this.first, this.lineSep, this.direction);
      doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
      doc.sel = this.sel;
      doc.extend = false;
      if (copyHistory) {
        doc.history.undoDepth = this.history.undoDepth;
        doc.setHistory(this.getHistory());
      }
      return doc
    },

    linkedDoc: function(options) {
      if (!options) { options = {}; }
      var from = this.first, to = this.first + this.size;
      if (options.from != null && options.from > from) { from = options.from; }
      if (options.to != null && options.to < to) { to = options.to; }
      var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
      if (options.sharedHist) { copy.history = this.history
      ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
      copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
      copySharedMarkers(copy, findSharedMarkers(this));
      return copy
    },
    unlinkDoc: function(other) {
      if (other instanceof CodeMirror) { other = other.doc; }
      if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
        var link = this.linked[i];
        if (link.doc != other) { continue }
        this.linked.splice(i, 1);
        other.unlinkDoc(this);
        detachSharedMarkers(findSharedMarkers(this));
        break
      } }
      // If the histories were shared, split them again
      if (other.history == this.history) {
        var splitIds = [other.id];
        linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
        other.history = new History(null);
        other.history.done = copyHistoryArray(this.history.done, splitIds);
        other.history.undone = copyHistoryArray(this.history.undone, splitIds);
      }
    },
    iterLinkedDocs: function(f) {linkedDocs(this, f);},

    getMode: function() {return this.mode},
    getEditor: function() {return this.cm},

    splitLines: function(str) {
      if (this.lineSep) { return str.split(this.lineSep) }
      return splitLinesAuto(str)
    },
    lineSeparator: function() { return this.lineSep || "\n" },

    setDirection: docMethodOp(function (dir) {
      if (dir != "rtl") { dir = "ltr"; }
      if (dir == this.direction) { return }
      this.direction = dir;
      this.iter(function (line) { return line.order = null; });
      if (this.cm) { directionChanged(this.cm); }
    })
  });

  // Public alias.
  Doc.prototype.eachLine = Doc.prototype.iter;

  // Kludge to work around strange IE behavior where it'll sometimes
  // re-fire a series of drag-related events right after the drop (#1551)
  var lastDrop = 0;

  function onDrop(e) {
    var cm = this;
    clearDragCursor(cm);
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
      { return }
    e_preventDefault(e);
    if (ie) { lastDrop = +new Date; }
    var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
    if (!pos || cm.isReadOnly()) { return }
    // Might be a file drop, in which case we simply extract the text
    // and insert it.
    if (files && files.length && window.FileReader && window.File) {
      var n = files.length, text = Array(n), read = 0;
      var markAsReadAndPasteIfAllFilesAreRead = function () {
        if (++read == n) {
          operation(cm, function () {
            pos = clipPos(cm.doc, pos);
            var change = {from: pos, to: pos,
                          text: cm.doc.splitLines(
                              text.filter(function (t) { return t != null; }).join(cm.doc.lineSeparator())),
                          origin: "paste"};
            makeChange(cm.doc, change);
            setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change))));
          })();
        }
      };
      var readTextFromFile = function (file, i) {
        if (cm.options.allowDropFileTypes &&
            indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
          markAsReadAndPasteIfAllFilesAreRead();
          return
        }
        var reader = new FileReader;
        reader.onerror = function () { return markAsReadAndPasteIfAllFilesAreRead(); };
        reader.onload = function () {
          var content = reader.result;
          if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
            markAsReadAndPasteIfAllFilesAreRead();
            return
          }
          text[i] = content;
          markAsReadAndPasteIfAllFilesAreRead();
        };
        reader.readAsText(file);
      };
      for (var i = 0; i < files.length; i++) { readTextFromFile(files[i], i); }
    } else { // Normal drop
      // Don't do a replace if the drop happened inside of the selected text.
      if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
        cm.state.draggingText(e);
        // Ensure the editor is re-focused
        setTimeout(function () { return cm.display.input.focus(); }, 20);
        return
      }
      try {
        var text$1 = e.dataTransfer.getData("Text");
        if (text$1) {
          var selected;
          if (cm.state.draggingText && !cm.state.draggingText.copy)
            { selected = cm.listSelections(); }
          setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
          if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
            { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
          cm.replaceSelection(text$1, "around", "paste");
          cm.display.input.focus();
        }
      }
      catch(e$1){}
    }
  }

  function onDragStart(cm, e) {
    if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
    if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

    e.dataTransfer.setData("Text", cm.getSelection());
    e.dataTransfer.effectAllowed = "copyMove";

    // Use dummy image instead of default browsers image.
    // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
    if (e.dataTransfer.setDragImage && !safari) {
      var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
      img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
      if (presto) {
        img.width = img.height = 1;
        cm.display.wrapper.appendChild(img);
        // Force a relayout, or Opera won't use our image for some obscure reason
        img._top = img.offsetTop;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      if (presto) { img.parentNode.removeChild(img); }
    }
  }

  function onDragOver(cm, e) {
    var pos = posFromMouse(cm, e);
    if (!pos) { return }
    var frag = document.createDocumentFragment();
    drawSelectionCursor(cm, pos, frag);
    if (!cm.display.dragCursor) {
      cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
      cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
    }
    removeChildrenAndAdd(cm.display.dragCursor, frag);
  }

  function clearDragCursor(cm) {
    if (cm.display.dragCursor) {
      cm.display.lineSpace.removeChild(cm.display.dragCursor);
      cm.display.dragCursor = null;
    }
  }

  // These must be handled carefully, because naively registering a
  // handler for each editor will cause the editors to never be
  // garbage collected.

  function forEachCodeMirror(f) {
    if (!document.getElementsByClassName) { return }
    var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
    for (var i = 0; i < byClass.length; i++) {
      var cm = byClass[i].CodeMirror;
      if (cm) { editors.push(cm); }
    }
    if (editors.length) { editors[0].operation(function () {
      for (var i = 0; i < editors.length; i++) { f(editors[i]); }
    }); }
  }

  var globalsRegistered = false;
  function ensureGlobalHandlers() {
    if (globalsRegistered) { return }
    registerGlobalHandlers();
    globalsRegistered = true;
  }
  function registerGlobalHandlers() {
    // When the window resizes, we need to refresh active editors.
    var resizeTimer;
    on(window, "resize", function () {
      if (resizeTimer == null) { resizeTimer = setTimeout(function () {
        resizeTimer = null;
        forEachCodeMirror(onResize);
      }, 100); }
    });
    // When the window loses focus, we want to show the editor as blurred
    on(window, "blur", function () { return forEachCodeMirror(onBlur); });
  }
  // Called when the window resizes
  function onResize(cm) {
    var d = cm.display;
    // Might be a text scaling operation, clear size caches.
    d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
    d.scrollbarsClipped = false;
    cm.setSize();
  }

  var keyNames = {
    3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
    19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
    36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
    46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
    106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 145: "ScrollLock",
    173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
    221: "]", 222: "'", 224: "Mod", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
    63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
  };

  // Number keys
  for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
  // Alphabetic keys
  for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
  // Function keys
  for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

  var keyMap = {};

  keyMap.basic = {
    "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
    "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
    "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
    "Tab": "defaultTab", "Shift-Tab": "indentAuto",
    "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
    "Esc": "singleSelection"
  };
  // Note that the save and find-related commands aren't defined by
  // default. User code or addons can define them. Unknown commands
  // are simply ignored.
  keyMap.pcDefault = {
    "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
    "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
    "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
    "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
    "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
    "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
    "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
    "fallthrough": "basic"
  };
  // Very basic readline/emacs-style bindings, which are standard on Mac.
  keyMap.emacsy = {
    "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
    "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd", "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp",
    "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine",
    "Ctrl-T": "transposeChars", "Ctrl-O": "openLine"
  };
  keyMap.macDefault = {
    "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
    "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
    "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
    "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
    "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
    "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
    "fallthrough": ["basic", "emacsy"]
  };
  keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

  // KEYMAP DISPATCH

  function normalizeKeyName(name) {
    var parts = name.split(/-(?!$)/);
    name = parts[parts.length - 1];
    var alt, ctrl, shift, cmd;
    for (var i = 0; i < parts.length - 1; i++) {
      var mod = parts[i];
      if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
      else if (/^a(lt)?$/i.test(mod)) { alt = true; }
      else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
      else if (/^s(hift)?$/i.test(mod)) { shift = true; }
      else { throw new Error("Unrecognized modifier name: " + mod) }
    }
    if (alt) { name = "Alt-" + name; }
    if (ctrl) { name = "Ctrl-" + name; }
    if (cmd) { name = "Cmd-" + name; }
    if (shift) { name = "Shift-" + name; }
    return name
  }

  // This is a kludge to keep keymaps mostly working as raw objects
  // (backwards compatibility) while at the same time support features
  // like normalization and multi-stroke key bindings. It compiles a
  // new normalized keymap, and then updates the old object to reflect
  // this.
  function normalizeKeyMap(keymap) {
    var copy = {};
    for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
      var value = keymap[keyname];
      if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
      if (value == "...") { delete keymap[keyname]; continue }

      var keys = map(keyname.split(" "), normalizeKeyName);
      for (var i = 0; i < keys.length; i++) {
        var val = (void 0), name = (void 0);
        if (i == keys.length - 1) {
          name = keys.join(" ");
          val = value;
        } else {
          name = keys.slice(0, i + 1).join(" ");
          val = "...";
        }
        var prev = copy[name];
        if (!prev) { copy[name] = val; }
        else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
      }
      delete keymap[keyname];
    } }
    for (var prop in copy) { keymap[prop] = copy[prop]; }
    return keymap
  }

  function lookupKey(key, map, handle, context) {
    map = getKeyMap(map);
    var found = map.call ? map.call(key, context) : map[key];
    if (found === false) { return "nothing" }
    if (found === "...") { return "multi" }
    if (found != null && handle(found)) { return "handled" }

    if (map.fallthrough) {
      if (Object.prototype.toString.call(map.fallthrough) != "[object Array]")
        { return lookupKey(key, map.fallthrough, handle, context) }
      for (var i = 0; i < map.fallthrough.length; i++) {
        var result = lookupKey(key, map.fallthrough[i], handle, context);
        if (result) { return result }
      }
    }
  }

  // Modifier key presses don't count as 'real' key presses for the
  // purpose of keymap fallthrough.
  function isModifierKey(value) {
    var name = typeof value == "string" ? value : keyNames[value.keyCode];
    return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
  }

  function addModifierNames(name, event, noShift) {
    var base = name;
    if (event.altKey && base != "Alt") { name = "Alt-" + name; }
    if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
    if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") { name = "Cmd-" + name; }
    if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
    return name
  }

  // Look up the name of a key as indicated by an event object.
  function keyName(event, noShift) {
    if (presto && event.keyCode == 34 && event["char"]) { return false }
    var name = keyNames[event.keyCode];
    if (name == null || event.altGraphKey) { return false }
    // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
    // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
    if (event.keyCode == 3 && event.code) { name = event.code; }
    return addModifierNames(name, event, noShift)
  }

  function getKeyMap(val) {
    return typeof val == "string" ? keyMap[val] : val
  }

  // Helper for deleting text near the selection(s), used to implement
  // backspace, delete, and similar functionality.
  function deleteNearSelection(cm, compute) {
    var ranges = cm.doc.sel.ranges, kill = [];
    // Build up a set of ranges to kill first, merging overlapping
    // ranges.
    for (var i = 0; i < ranges.length; i++) {
      var toKill = compute(ranges[i]);
      while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
        var replaced = kill.pop();
        if (cmp(replaced.from, toKill.from) < 0) {
          toKill.from = replaced.from;
          break
        }
      }
      kill.push(toKill);
    }
    // Next, remove those actual ranges.
    runInOp(cm, function () {
      for (var i = kill.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
      ensureCursorVisible(cm);
    });
  }

  function moveCharLogically(line, ch, dir) {
    var target = skipExtendingChars(line.text, ch + dir, dir);
    return target < 0 || target > line.text.length ? null : target
  }

  function moveLogically(line, start, dir) {
    var ch = moveCharLogically(line, start.ch, dir);
    return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
  }

  function endOfLine(visually, cm, lineObj, lineNo, dir) {
    if (visually) {
      if (cm.doc.direction == "rtl") { dir = -dir; }
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = dir < 0 ? lst(order) : order[0];
        var moveInStorageOrder = (dir < 0) == (part.level == 1);
        var sticky = moveInStorageOrder ? "after" : "before";
        var ch;
        // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
        // it could be that the last bidi part is not on the last visual line,
        // since visual lines contain content order-consecutive chunks.
        // Thus, in rtl, we are looking for the first (content-order) character
        // in the rtl chunk that is on the last line (that is, the same line
        // as the last (content-order) character).
        if (part.level > 0 || cm.doc.direction == "rtl") {
          var prep = prepareMeasureForLine(cm, lineObj);
          ch = dir < 0 ? lineObj.text.length - 1 : 0;
          var targetTop = measureCharPrepared(cm, prep, ch).top;
          ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
          if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
        } else { ch = dir < 0 ? part.to : part.from; }
        return new Pos(lineNo, ch, sticky)
      }
    }
    return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
  }

  function moveVisually(cm, line, start, dir) {
    var bidi = getOrder(line, cm.doc.direction);
    if (!bidi) { return moveLogically(line, start, dir) }
    if (start.ch >= line.text.length) {
      start.ch = line.text.length;
      start.sticky = "before";
    } else if (start.ch <= 0) {
      start.ch = 0;
      start.sticky = "after";
    }
    var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
    if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
      // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
      // nothing interesting happens.
      return moveLogically(line, start, dir)
    }

    var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
    var prep;
    var getWrappedLineExtent = function (ch) {
      if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
      prep = prep || prepareMeasureForLine(cm, line);
      return wrappedLineExtentChar(cm, line, prep, ch)
    };
    var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

    if (cm.doc.direction == "rtl" || part.level == 1) {
      var moveInStorageOrder = (part.level == 1) == (dir < 0);
      var ch = mv(start, moveInStorageOrder ? 1 : -1);
      if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
        // Case 2: We move within an rtl part or in an rtl editor on the same visual line
        var sticky = moveInStorageOrder ? "before" : "after";
        return new Pos(start.line, ch, sticky)
      }
    }

    // Case 3: Could not move within this bidi part in this visual line, so leave
    // the current bidi part

    var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
      var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
        ? new Pos(start.line, mv(ch, 1), "before")
        : new Pos(start.line, ch, "after"); };

      for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
        var part = bidi[partPos];
        var moveInStorageOrder = (dir > 0) == (part.level != 1);
        var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
        if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
        ch = moveInStorageOrder ? part.from : mv(part.to, -1);
        if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
      }
    };

    // Case 3a: Look for other bidi parts on the same visual line
    var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
    if (res) { return res }

    // Case 3b: Look for other bidi parts on the next visual line
    var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
    if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
      res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
      if (res) { return res }
    }

    // Case 4: Nowhere to move
    return null
  }

  // Commands are parameter-less actions that can be performed on an
  // editor, mostly used for keybindings.
  var commands = {
    selectAll: selectAll,
    singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
    killLine: function (cm) { return deleteNearSelection(cm, function (range) {
      if (range.empty()) {
        var len = getLine(cm.doc, range.head.line).text.length;
        if (range.head.ch == len && range.head.line < cm.lastLine())
          { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
        else
          { return {from: range.head, to: Pos(range.head.line, len)} }
      } else {
        return {from: range.from(), to: range.to()}
      }
    }); },
    deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0),
      to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
    }); }); },
    delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
      from: Pos(range.from().line, 0), to: range.from()
    }); }); },
    delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var leftPos = cm.coordsChar({left: 0, top: top}, "div");
      return {from: leftPos, to: range.from()}
    }); },
    delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
      var top = cm.charCoords(range.head, "div").top + 5;
      var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
      return {from: range.from(), to: rightPos }
    }); },
    undo: function (cm) { return cm.undo(); },
    redo: function (cm) { return cm.redo(); },
    undoSelection: function (cm) { return cm.undoSelection(); },
    redoSelection: function (cm) { return cm.redoSelection(); },
    goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
    goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
    goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
      {origin: "+move", bias: 1}
    ); },
    goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
      {origin: "+move", bias: 1}
    ); },
    goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
      {origin: "+move", bias: -1}
    ); },
    goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
    }, sel_move); },
    goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      return cm.coordsChar({left: 0, top: top}, "div")
    }, sel_move); },
    goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
      var top = cm.cursorCoords(range.head, "div").top + 5;
      var pos = cm.coordsChar({left: 0, top: top}, "div");
      if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
      return pos
    }, sel_move); },
    goLineUp: function (cm) { return cm.moveV(-1, "line"); },
    goLineDown: function (cm) { return cm.moveV(1, "line"); },
    goPageUp: function (cm) { return cm.moveV(-1, "page"); },
    goPageDown: function (cm) { return cm.moveV(1, "page"); },
    goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
    goCharRight: function (cm) { return cm.moveH(1, "char"); },
    goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
    goColumnRight: function (cm) { return cm.moveH(1, "column"); },
    goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
    goGroupRight: function (cm) { return cm.moveH(1, "group"); },
    goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
    goWordRight: function (cm) { return cm.moveH(1, "word"); },
    delCharBefore: function (cm) { return cm.deleteH(-1, "codepoint"); },
    delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
    delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
    delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
    delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
    delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
    indentAuto: function (cm) { return cm.indentSelection("smart"); },
    indentMore: function (cm) { return cm.indentSelection("add"); },
    indentLess: function (cm) { return cm.indentSelection("subtract"); },
    insertTab: function (cm) { return cm.replaceSelection("\t"); },
    insertSoftTab: function (cm) {
      var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
      for (var i = 0; i < ranges.length; i++) {
        var pos = ranges[i].from();
        var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
        spaces.push(spaceStr(tabSize - col % tabSize));
      }
      cm.replaceSelections(spaces);
    },
    defaultTab: function (cm) {
      if (cm.somethingSelected()) { cm.indentSelection("add"); }
      else { cm.execCommand("insertTab"); }
    },
    // Swap the two chars left and right of each selection's head.
    // Move cursor behind the two swapped characters afterwards.
    //
    // Doesn't consider line feeds a character.
    // Doesn't scan more than one line above to find a character.
    // Doesn't do anything on an empty line.
    // Doesn't do anything with non-empty selections.
    transposeChars: function (cm) { return runInOp(cm, function () {
      var ranges = cm.listSelections(), newSel = [];
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty()) { continue }
        var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
        if (line) {
          if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
          if (cur.ch > 0) {
            cur = new Pos(cur.line, cur.ch + 1);
            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                            Pos(cur.line, cur.ch - 2), cur, "+transpose");
          } else if (cur.line > cm.doc.first) {
            var prev = getLine(cm.doc, cur.line - 1).text;
            if (prev) {
              cur = new Pos(cur.line, 1);
              cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                              prev.charAt(prev.length - 1),
                              Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
            }
          }
        }
        newSel.push(new Range(cur, cur));
      }
      cm.setSelections(newSel);
    }); },
    newlineAndIndent: function (cm) { return runInOp(cm, function () {
      var sels = cm.listSelections();
      for (var i = sels.length - 1; i >= 0; i--)
        { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
      sels = cm.listSelections();
      for (var i$1 = 0; i$1 < sels.length; i$1++)
        { cm.indentLine(sels[i$1].from().line, null, true); }
      ensureCursorVisible(cm);
    }); },
    openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
    toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
  };


  function lineStart(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLine(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, visual, lineN, 1)
  }
  function lineEnd(cm, lineN) {
    var line = getLine(cm.doc, lineN);
    var visual = visualLineEnd(line);
    if (visual != line) { lineN = lineNo(visual); }
    return endOfLine(true, cm, line, lineN, -1)
  }
  function lineStartSmart(cm, pos) {
    var start = lineStart(cm, pos.line);
    var line = getLine(cm.doc, start.line);
    var order = getOrder(line, cm.doc.direction);
    if (!order || order[0].level == 0) {
      var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
      var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
      return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
    }
    return start
  }

  // Run a handler that was bound to a key.
  function doHandleBinding(cm, bound, dropShift) {
    if (typeof bound == "string") {
      bound = commands[bound];
      if (!bound) { return false }
    }
    // Ensure previous input has been read, so that the handler sees a
    // consistent view of the document
    cm.display.input.ensurePolled();
    var prevShift = cm.display.shift, done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      if (dropShift) { cm.display.shift = false; }
      done = bound(cm) != Pass;
    } finally {
      cm.display.shift = prevShift;
      cm.state.suppressEdits = false;
    }
    return done
  }

  function lookupKeyForEditor(cm, name, handle) {
    for (var i = 0; i < cm.state.keyMaps.length; i++) {
      var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
      if (result) { return result }
    }
    return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
      || lookupKey(name, cm.options.keyMap, handle, cm)
  }

  // Note that, despite the name, this function is also used to check
  // for bound mouse clicks.

  var stopSeq = new Delayed;

  function dispatchKey(cm, name, e, handle) {
    var seq = cm.state.keySeq;
    if (seq) {
      if (isModifierKey(name)) { return "handled" }
      if (/\'$/.test(name))
        { cm.state.keySeq = null; }
      else
        { stopSeq.set(50, function () {
          if (cm.state.keySeq == seq) {
            cm.state.keySeq = null;
            cm.display.input.reset();
          }
        }); }
      if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
    }
    return dispatchKeyInner(cm, name, e, handle)
  }

  function dispatchKeyInner(cm, name, e, handle) {
    var result = lookupKeyForEditor(cm, name, handle);

    if (result == "multi")
      { cm.state.keySeq = name; }
    if (result == "handled")
      { signalLater(cm, "keyHandled", cm, name, e); }

    if (result == "handled" || result == "multi") {
      e_preventDefault(e);
      restartBlink(cm);
    }

    return !!result
  }

  // Handle a key from the keydown event.
  function handleKeyBinding(cm, e) {
    var name = keyName(e, true);
    if (!name) { return false }

    if (e.shiftKey && !cm.state.keySeq) {
      // First try to resolve full name (including 'Shift-'). Failing
      // that, see if there is a cursor-motion command (starting with
      // 'go') bound to the keyname without 'Shift-'.
      return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
          || dispatchKey(cm, name, e, function (b) {
               if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
                 { return doHandleBinding(cm, b) }
             })
    } else {
      return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
    }
  }

  // Handle a key from the keypress event
  function handleCharBinding(cm, e, ch) {
    return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
  }

  var lastStoppedKey = null;
  function onKeyDown(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    cm.curOp.focus = activeElt();
    if (signalDOMEvent(cm, e)) { return }
    // IE does strange things with escape.
    if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
    var code = e.keyCode;
    cm.display.shift = code == 16 || e.shiftKey;
    var handled = handleKeyBinding(cm, e);
    if (presto) {
      lastStoppedKey = handled ? code : null;
      // Opera has no cut event... we try to at least catch the key combo
      if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
        { cm.replaceSelection("", null, "cut"); }
    }
    if (gecko && !mac && !handled && code == 46 && e.shiftKey && !e.ctrlKey && document.execCommand)
      { document.execCommand("cut"); }

    // Turn mouse into crosshair when Alt is held on Mac.
    if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
      { showCrossHair(cm); }
  }

  function showCrossHair(cm) {
    var lineDiv = cm.display.lineDiv;
    addClass(lineDiv, "CodeMirror-crosshair");

    function up(e) {
      if (e.keyCode == 18 || !e.altKey) {
        rmClass(lineDiv, "CodeMirror-crosshair");
        off(document, "keyup", up);
        off(document, "mouseover", up);
      }
    }
    on(document, "keyup", up);
    on(document, "mouseover", up);
  }

  function onKeyUp(e) {
    if (e.keyCode == 16) { this.doc.sel.shift = false; }
    signalDOMEvent(this, e);
  }

  function onKeyPress(e) {
    var cm = this;
    if (e.target && e.target != cm.display.input.getField()) { return }
    if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
    var keyCode = e.keyCode, charCode = e.charCode;
    if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
    if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
    var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
    // Some browsers fire keypress events for backspace
    if (ch == "\x08") { return }
    if (handleCharBinding(cm, e, ch)) { return }
    cm.display.input.onKeyPress(e);
  }

  var DOUBLECLICK_DELAY = 400;

  var PastClick = function(time, pos, button) {
    this.time = time;
    this.pos = pos;
    this.button = button;
  };

  PastClick.prototype.compare = function (time, pos, button) {
    return this.time + DOUBLECLICK_DELAY > time &&
      cmp(pos, this.pos) == 0 && button == this.button
  };

  var lastClick, lastDoubleClick;
  function clickRepeat(pos, button) {
    var now = +new Date;
    if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
      lastClick = lastDoubleClick = null;
      return "triple"
    } else if (lastClick && lastClick.compare(now, pos, button)) {
      lastDoubleClick = new PastClick(now, pos, button);
      lastClick = null;
      return "double"
    } else {
      lastClick = new PastClick(now, pos, button);
      lastDoubleClick = null;
      return "single"
    }
  }

  // A mouse down can be a single click, double click, triple click,
  // start of selection drag, start of text drag, new cursor
  // (ctrl-click), rectangle drag (alt-drag), or xwin
  // middle-click-paste. Or it might be a click on something we should
  // not interfere with, such as a scrollbar or widget.
  function onMouseDown(e) {
    var cm = this, display = cm.display;
    if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
    display.input.ensurePolled();
    display.shift = e.shiftKey;

    if (eventInWidget(display, e)) {
      if (!webkit) {
        // Briefly turn off draggability, to allow widgets to do
        // normal dragging things.
        display.scroller.draggable = false;
        setTimeout(function () { return display.scroller.draggable = true; }, 100);
      }
      return
    }
    if (clickInGutter(cm, e)) { return }
    var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
    window.focus();

    // #3261: make sure, that we're not starting a second selection
    if (button == 1 && cm.state.selectingText)
      { cm.state.selectingText(e); }

    if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

    if (button == 1) {
      if (pos) { leftButtonDown(cm, pos, repeat, e); }
      else if (e_target(e) == display.scroller) { e_preventDefault(e); }
    } else if (button == 2) {
      if (pos) { extendSelection(cm.doc, pos); }
      setTimeout(function () { return display.input.focus(); }, 20);
    } else if (button == 3) {
      if (captureRightClick) { cm.display.input.onContextMenu(e); }
      else { delayBlurEvent(cm); }
    }
  }

  function handleMappedButton(cm, button, pos, repeat, event) {
    var name = "Click";
    if (repeat == "double") { name = "Double" + name; }
    else if (repeat == "triple") { name = "Triple" + name; }
    name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

    return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
      if (typeof bound == "string") { bound = commands[bound]; }
      if (!bound) { return false }
      var done = false;
      try {
        if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
        done = bound(cm, pos) != Pass;
      } finally {
        cm.state.suppressEdits = false;
      }
      return done
    })
  }

  function configureMouse(cm, repeat, event) {
    var option = cm.getOption("configureMouse");
    var value = option ? option(cm, repeat, event) : {};
    if (value.unit == null) {
      var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
      value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
    }
    if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
    if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
    if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
    return value
  }

  function leftButtonDown(cm, pos, repeat, event) {
    if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
    else { cm.curOp.focus = activeElt(); }

    var behavior = configureMouse(cm, repeat, event);

    var sel = cm.doc.sel, contained;
    if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
        repeat == "single" && (contained = sel.contains(pos)) > -1 &&
        (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
        (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
      { leftButtonStartDrag(cm, event, pos, behavior); }
    else
      { leftButtonSelect(cm, event, pos, behavior); }
  }

  // Start a text drag. When it ends, see if any dragging actually
  // happen, and treat as a click if it didn't.
  function leftButtonStartDrag(cm, event, pos, behavior) {
    var display = cm.display, moved = false;
    var dragEnd = operation(cm, function (e) {
      if (webkit) { display.scroller.draggable = false; }
      cm.state.draggingText = false;
      if (cm.state.delayingBlurEvent) {
        if (cm.hasFocus()) { cm.state.delayingBlurEvent = false; }
        else { delayBlurEvent(cm); }
      }
      off(display.wrapper.ownerDocument, "mouseup", dragEnd);
      off(display.wrapper.ownerDocument, "mousemove", mouseMove);
      off(display.scroller, "dragstart", dragStart);
      off(display.scroller, "drop", dragEnd);
      if (!moved) {
        e_preventDefault(e);
        if (!behavior.addNew)
          { extendSelection(cm.doc, pos, null, null, behavior.extend); }
        // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
        if ((webkit && !safari) || ie && ie_version == 9)
          { setTimeout(function () {display.wrapper.ownerDocument.body.focus({preventScroll: true}); display.input.focus();}, 20); }
        else
          { display.input.focus(); }
      }
    });
    var mouseMove = function(e2) {
      moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
    };
    var dragStart = function () { return moved = true; };
    // Let the drag handler handle this.
    if (webkit) { display.scroller.draggable = true; }
    cm.state.draggingText = dragEnd;
    dragEnd.copy = !behavior.moveOnDrag;
    on(display.wrapper.ownerDocument, "mouseup", dragEnd);
    on(display.wrapper.ownerDocument, "mousemove", mouseMove);
    on(display.scroller, "dragstart", dragStart);
    on(display.scroller, "drop", dragEnd);

    cm.state.delayingBlurEvent = true;
    setTimeout(function () { return display.input.focus(); }, 20);
    // IE's approach to draggable
    if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  }

  function rangeForUnit(cm, pos, unit) {
    if (unit == "char") { return new Range(pos, pos) }
    if (unit == "word") { return cm.findWordAt(pos) }
    if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
    var result = unit(cm, pos);
    return new Range(result.from, result.to)
  }

  // Normal selection, as opposed to text dragging.
  function leftButtonSelect(cm, event, start, behavior) {
    if (ie) { delayBlurEvent(cm); }
    var display = cm.display, doc = cm.doc;
    e_preventDefault(event);

    var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
    if (behavior.addNew && !behavior.extend) {
      ourIndex = doc.sel.contains(start);
      if (ourIndex > -1)
        { ourRange = ranges[ourIndex]; }
      else
        { ourRange = new Range(start, start); }
    } else {
      ourRange = doc.sel.primary();
      ourIndex = doc.sel.primIndex;
    }

    if (behavior.unit == "rectangle") {
      if (!behavior.addNew) { ourRange = new Range(start, start); }
      start = posFromMouse(cm, event, true, true);
      ourIndex = -1;
    } else {
      var range = rangeForUnit(cm, start, behavior.unit);
      if (behavior.extend)
        { ourRange = extendRange(ourRange, range.anchor, range.head, behavior.extend); }
      else
        { ourRange = range; }
    }

    if (!behavior.addNew) {
      ourIndex = 0;
      setSelection(doc, new Selection([ourRange], 0), sel_mouse);
      startSel = doc.sel;
    } else if (ourIndex == -1) {
      ourIndex = ranges.length;
      setSelection(doc, normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
                   {scroll: false, origin: "*mouse"});
    } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
      setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                   {scroll: false, origin: "*mouse"});
      startSel = doc.sel;
    } else {
      replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
    }

    var lastPos = start;
    function extendTo(pos) {
      if (cmp(lastPos, pos) == 0) { return }
      lastPos = pos;

      if (behavior.unit == "rectangle") {
        var ranges = [], tabSize = cm.options.tabSize;
        var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
        var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
        var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
        for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
             line <= end; line++) {
          var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
          if (left == right)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
          else if (text.length > leftPos)
            { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
        }
        if (!ranges.length) { ranges.push(new Range(start, start)); }
        setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                     {origin: "*mouse", scroll: false});
        cm.scrollIntoView(pos);
      } else {
        var oldRange = ourRange;
        var range = rangeForUnit(cm, pos, behavior.unit);
        var anchor = oldRange.anchor, head;
        if (cmp(range.anchor, anchor) > 0) {
          head = range.head;
          anchor = minPos(oldRange.from(), range.anchor);
        } else {
          head = range.anchor;
          anchor = maxPos(oldRange.to(), range.head);
        }
        var ranges$1 = startSel.ranges.slice(0);
        ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
        setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
      }
    }

    var editorSize = display.wrapper.getBoundingClientRect();
    // Used to ensure timeout re-tries don't fire when another extend
    // happened in the meantime (clearTimeout isn't reliable -- at
    // least on Chrome, the timeouts still happen even when cleared,
    // if the clear happens after their scheduled firing time).
    var counter = 0;

    function extend(e) {
      var curCount = ++counter;
      var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
      if (!cur) { return }
      if (cmp(cur, lastPos) != 0) {
        cm.curOp.focus = activeElt();
        extendTo(cur);
        var visible = visibleLines(display, doc);
        if (cur.line >= visible.to || cur.line < visible.from)
          { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
      } else {
        var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
        if (outside) { setTimeout(operation(cm, function () {
          if (counter != curCount) { return }
          display.scroller.scrollTop += outside;
          extend(e);
        }), 50); }
      }
    }

    function done(e) {
      cm.state.selectingText = false;
      counter = Infinity;
      // If e is null or undefined we interpret this as someone trying
      // to explicitly cancel the selection rather than the user
      // letting go of the mouse button.
      if (e) {
        e_preventDefault(e);
        display.input.focus();
      }
      off(display.wrapper.ownerDocument, "mousemove", move);
      off(display.wrapper.ownerDocument, "mouseup", up);
      doc.history.lastSelOrigin = null;
    }

    var move = operation(cm, function (e) {
      if (e.buttons === 0 || !e_button(e)) { done(e); }
      else { extend(e); }
    });
    var up = operation(cm, done);
    cm.state.selectingText = up;
    on(display.wrapper.ownerDocument, "mousemove", move);
    on(display.wrapper.ownerDocument, "mouseup", up);
  }

  // Used when mouse-selecting to adjust the anchor to the proper side
  // of a bidi jump depending on the visual position of the head.
  function bidiSimplify(cm, range) {
    var anchor = range.anchor;
    var head = range.head;
    var anchorLine = getLine(cm.doc, anchor.line);
    if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range }
    var order = getOrder(anchorLine);
    if (!order) { return range }
    var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
    if (part.from != anchor.ch && part.to != anchor.ch) { return range }
    var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
    if (boundary == 0 || boundary == order.length) { return range }

    // Compute the relative visual position of the head compared to the
    // anchor (<0 is to the left, >0 to the right)
    var leftSide;
    if (head.line != anchor.line) {
      leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
    } else {
      var headIndex = getBidiPartAt(order, head.ch, head.sticky);
      var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
      if (headIndex == boundary - 1 || headIndex == boundary)
        { leftSide = dir < 0; }
      else
        { leftSide = dir > 0; }
    }

    var usePart = order[boundary + (leftSide ? -1 : 0)];
    var from = leftSide == (usePart.level == 1);
    var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
    return anchor.ch == ch && anchor.sticky == sticky ? range : new Range(new Pos(anchor.line, ch, sticky), head)
  }


  // Determines whether an event happened in the gutter, and fires the
  // handlers for the corresponding event.
  function gutterEvent(cm, e, type, prevent) {
    var mX, mY;
    if (e.touches) {
      mX = e.touches[0].clientX;
      mY = e.touches[0].clientY;
    } else {
      try { mX = e.clientX; mY = e.clientY; }
      catch(e$1) { return false }
    }
    if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
    if (prevent) { e_preventDefault(e); }

    var display = cm.display;
    var lineBox = display.lineDiv.getBoundingClientRect();

    if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
    mY -= lineBox.top - display.viewOffset;

    for (var i = 0; i < cm.display.gutterSpecs.length; ++i) {
      var g = display.gutters.childNodes[i];
      if (g && g.getBoundingClientRect().right >= mX) {
        var line = lineAtHeight(cm.doc, mY);
        var gutter = cm.display.gutterSpecs[i];
        signal(cm, type, cm, line, gutter.className, e);
        return e_defaultPrevented(e)
      }
    }
  }

  function clickInGutter(cm, e) {
    return gutterEvent(cm, e, "gutterClick", true)
  }

  // CONTEXT MENU HANDLING

  // To make the context menu work, we need to briefly unhide the
  // textarea (making it as unobtrusive as possible) to let the
  // right-click take effect on it.
  function onContextMenu(cm, e) {
    if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
    if (signalDOMEvent(cm, e, "contextmenu")) { return }
    if (!captureRightClick) { cm.display.input.onContextMenu(e); }
  }

  function contextMenuInGutter(cm, e) {
    if (!hasHandler(cm, "gutterContextMenu")) { return false }
    return gutterEvent(cm, e, "gutterContextMenu", false)
  }

  function themeChanged(cm) {
    cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
      cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
    clearCaches(cm);
  }

  var Init = {toString: function(){return "CodeMirror.Init"}};

  var defaults = {};
  var optionHandlers = {};

  function defineOptions(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    function option(name, deflt, handle, notOnInit) {
      CodeMirror.defaults[name] = deflt;
      if (handle) { optionHandlers[name] =
        notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
    }

    CodeMirror.defineOption = option;

    // Passed to option handlers when there is no old value.
    CodeMirror.Init = Init;

    // These two are, on init, called from the constructor because they
    // have to be initialized before the editor can start at all.
    option("value", "", function (cm, val) { return cm.setValue(val); }, true);
    option("mode", null, function (cm, val) {
      cm.doc.modeOption = val;
      loadMode(cm);
    }, true);

    option("indentUnit", 2, loadMode, true);
    option("indentWithTabs", false);
    option("smartIndent", true);
    option("tabSize", 4, function (cm) {
      resetModeState(cm);
      clearCaches(cm);
      regChange(cm);
    }, true);

    option("lineSeparator", null, function (cm, val) {
      cm.doc.lineSep = val;
      if (!val) { return }
      var newBreaks = [], lineNo = cm.doc.first;
      cm.doc.iter(function (line) {
        for (var pos = 0;;) {
          var found = line.text.indexOf(val, pos);
          if (found == -1) { break }
          pos = found + val.length;
          newBreaks.push(Pos(lineNo, found));
        }
        lineNo++;
      });
      for (var i = newBreaks.length - 1; i >= 0; i--)
        { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
    });
    option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (cm, val, old) {
      cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
      if (old != Init) { cm.refresh(); }
    });
    option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
    option("electricChars", true);
    option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
      throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
    }, true);
    option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
    option("autocorrect", false, function (cm, val) { return cm.getInputField().autocorrect = val; }, true);
    option("autocapitalize", false, function (cm, val) { return cm.getInputField().autocapitalize = val; }, true);
    option("rtlMoveVisually", !windows);
    option("wholeLineUpdateBefore", true);

    option("theme", "default", function (cm) {
      themeChanged(cm);
      updateGutters(cm);
    }, true);
    option("keyMap", "default", function (cm, val, old) {
      var next = getKeyMap(val);
      var prev = old != Init && getKeyMap(old);
      if (prev && prev.detach) { prev.detach(cm, next); }
      if (next.attach) { next.attach(cm, prev || null); }
    });
    option("extraKeys", null);
    option("configureMouse", null);

    option("lineWrapping", false, wrappingChanged, true);
    option("gutters", [], function (cm, val) {
      cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
      updateGutters(cm);
    }, true);
    option("fixedGutter", true, function (cm, val) {
      cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
      cm.refresh();
    }, true);
    option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
    option("scrollbarStyle", "native", function (cm) {
      initScrollbars(cm);
      updateScrollbars(cm);
      cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
      cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
    }, true);
    option("lineNumbers", false, function (cm, val) {
      cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
      updateGutters(cm);
    }, true);
    option("firstLineNumber", 1, updateGutters, true);
    option("lineNumberFormatter", function (integer) { return integer; }, updateGutters, true);
    option("showCursorWhenSelecting", false, updateSelection, true);

    option("resetSelectionOnContextMenu", true);
    option("lineWiseCopyCut", true);
    option("pasteLinesPerSelection", true);
    option("selectionsMayTouch", false);

    option("readOnly", false, function (cm, val) {
      if (val == "nocursor") {
        onBlur(cm);
        cm.display.input.blur();
      }
      cm.display.input.readOnlyChanged(val);
    });

    option("screenReaderLabel", null, function (cm, val) {
      val = (val === '') ? null : val;
      cm.display.input.screenReaderLabelChanged(val);
    });

    option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
    option("dragDrop", true, dragDropChanged);
    option("allowDropFileTypes", null);

    option("cursorBlinkRate", 530);
    option("cursorScrollMargin", 0);
    option("cursorHeight", 1, updateSelection, true);
    option("singleCursorHeightPerLine", true, updateSelection, true);
    option("workTime", 100);
    option("workDelay", 100);
    option("flattenSpans", true, resetModeState, true);
    option("addModeClass", false, resetModeState, true);
    option("pollInterval", 100);
    option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
    option("historyEventDelay", 1250);
    option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
    option("maxHighlightLength", 10000, resetModeState, true);
    option("moveInputWithCursor", true, function (cm, val) {
      if (!val) { cm.display.input.resetPosition(); }
    });

    option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
    option("autofocus", null);
    option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
    option("phrases", null);
  }

  function dragDropChanged(cm, value, old) {
    var wasOn = old && old != Init;
    if (!value != !wasOn) {
      var funcs = cm.display.dragFunctions;
      var toggle = value ? on : off;
      toggle(cm.display.scroller, "dragstart", funcs.start);
      toggle(cm.display.scroller, "dragenter", funcs.enter);
      toggle(cm.display.scroller, "dragover", funcs.over);
      toggle(cm.display.scroller, "dragleave", funcs.leave);
      toggle(cm.display.scroller, "drop", funcs.drop);
    }
  }

  function wrappingChanged(cm) {
    if (cm.options.lineWrapping) {
      addClass(cm.display.wrapper, "CodeMirror-wrap");
      cm.display.sizer.style.minWidth = "";
      cm.display.sizerWidth = null;
    } else {
      rmClass(cm.display.wrapper, "CodeMirror-wrap");
      findMaxLine(cm);
    }
    estimateLineHeights(cm);
    regChange(cm);
    clearCaches(cm);
    setTimeout(function () { return updateScrollbars(cm); }, 100);
  }

  // A CodeMirror instance represents an editor. This is the object
  // that user code is usually dealing with.

  function CodeMirror(place, options) {
    var this$1 = this;

    if (!(this instanceof CodeMirror)) { return new CodeMirror(place, options) }

    this.options = options = options ? copyObj(options) : {};
    // Determine effective options based on given values and defaults.
    copyObj(defaults, options, false);

    var doc = options.value;
    if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
    else if (options.mode) { doc.modeOption = options.mode; }
    this.doc = doc;

    var input = new CodeMirror.inputStyles[options.inputStyle](this);
    var display = this.display = new Display(place, doc, input, options);
    display.wrapper.CodeMirror = this;
    themeChanged(this);
    if (options.lineWrapping)
      { this.display.wrapper.className += " CodeMirror-wrap"; }
    initScrollbars(this);

    this.state = {
      keyMaps: [],  // stores maps added by addKeyMap
      overlays: [], // highlighting overlays, as added by addOverlay
      modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
      overwrite: false,
      delayingBlurEvent: false,
      focused: false,
      suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
      pasteIncoming: -1, cutIncoming: -1, // help recognize paste/cut edits in input.poll
      selectingText: false,
      draggingText: false,
      highlight: new Delayed(), // stores highlight worker timeout
      keySeq: null,  // Unfinished key sequence
      specialChars: null
    };

    if (options.autofocus && !mobile) { display.input.focus(); }

    // Override magic textarea content restore that IE sometimes does
    // on our hidden textarea on reload
    if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

    registerEventHandlers(this);
    ensureGlobalHandlers();

    startOperation(this);
    this.curOp.forceUpdate = true;
    attachDoc(this, doc);

    if ((options.autofocus && !mobile) || this.hasFocus())
      { setTimeout(function () {
        if (this$1.hasFocus() && !this$1.state.focused) { onFocus(this$1); }
      }, 20); }
    else
      { onBlur(this); }

    for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
      { optionHandlers[opt](this, options[opt], Init); } }
    maybeUpdateLineNumberWidth(this);
    if (options.finishInit) { options.finishInit(this); }
    for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this); }
    endOperation(this);
    // Suppress optimizelegibility in Webkit, since it breaks text
    // measuring on line wrapping boundaries.
    if (webkit && options.lineWrapping &&
        getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
      { display.lineDiv.style.textRendering = "auto"; }
  }

  // The default configuration options.
  CodeMirror.defaults = defaults;
  // Functions to run when options are changed.
  CodeMirror.optionHandlers = optionHandlers;

  // Attach the necessary event handlers when initializing the editor
  function registerEventHandlers(cm) {
    var d = cm.display;
    on(d.scroller, "mousedown", operation(cm, onMouseDown));
    // Older IE's will not fire a second mousedown for a double click
    if (ie && ie_version < 11)
      { on(d.scroller, "dblclick", operation(cm, function (e) {
        if (signalDOMEvent(cm, e)) { return }
        var pos = posFromMouse(cm, e);
        if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
        e_preventDefault(e);
        var word = cm.findWordAt(pos);
        extendSelection(cm.doc, word.anchor, word.head);
      })); }
    else
      { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
    // Some browsers fire contextmenu *after* opening the menu, at
    // which point we can't mess with it anymore. Context menu is
    // handled in onMouseDown for these browsers.
    on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); });
    on(d.input.getField(), "contextmenu", function (e) {
      if (!d.scroller.contains(e.target)) { onContextMenu(cm, e); }
    });

    // Used to suppress mouse event handling when a touch happens
    var touchFinished, prevTouch = {end: 0};
    function finishTouch() {
      if (d.activeTouch) {
        touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
        prevTouch = d.activeTouch;
        prevTouch.end = +new Date;
      }
    }
    function isMouseLikeTouchEvent(e) {
      if (e.touches.length != 1) { return false }
      var touch = e.touches[0];
      return touch.radiusX <= 1 && touch.radiusY <= 1
    }
    function farAway(touch, other) {
      if (other.left == null) { return true }
      var dx = other.left - touch.left, dy = other.top - touch.top;
      return dx * dx + dy * dy > 20 * 20
    }
    on(d.scroller, "touchstart", function (e) {
      if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
        d.input.ensurePolled();
        clearTimeout(touchFinished);
        var now = +new Date;
        d.activeTouch = {start: now, moved: false,
                         prev: now - prevTouch.end <= 300 ? prevTouch : null};
        if (e.touches.length == 1) {
          d.activeTouch.left = e.touches[0].pageX;
          d.activeTouch.top = e.touches[0].pageY;
        }
      }
    });
    on(d.scroller, "touchmove", function () {
      if (d.activeTouch) { d.activeTouch.moved = true; }
    });
    on(d.scroller, "touchend", function (e) {
      var touch = d.activeTouch;
      if (touch && !eventInWidget(d, e) && touch.left != null &&
          !touch.moved && new Date - touch.start < 300) {
        var pos = cm.coordsChar(d.activeTouch, "page"), range;
        if (!touch.prev || farAway(touch, touch.prev)) // Single tap
          { range = new Range(pos, pos); }
        else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
          { range = cm.findWordAt(pos); }
        else // Triple tap
          { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
        cm.setSelection(range.anchor, range.head);
        cm.focus();
        e_preventDefault(e);
      }
      finishTouch();
    });
    on(d.scroller, "touchcancel", finishTouch);

    // Sync scrolling between fake scrollbars and real scrollable
    // area, ensure viewport is updated when scrolling.
    on(d.scroller, "scroll", function () {
      if (d.scroller.clientHeight) {
        updateScrollTop(cm, d.scroller.scrollTop);
        setScrollLeft(cm, d.scroller.scrollLeft, true);
        signal(cm, "scroll", cm);
      }
    });

    // Listen to wheel events in order to try and update the viewport on time.
    on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
    on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

    // Prevent wrapper from ever scrolling
    on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

    d.dragFunctions = {
      enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
      over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
      start: function (e) { return onDragStart(cm, e); },
      drop: operation(cm, onDrop),
      leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
    };

    var inp = d.input.getField();
    on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
    on(inp, "keydown", operation(cm, onKeyDown));
    on(inp, "keypress", operation(cm, onKeyPress));
    on(inp, "focus", function (e) { return onFocus(cm, e); });
    on(inp, "blur", function (e) { return onBlur(cm, e); });
  }

  var initHooks = [];
  CodeMirror.defineInitHook = function (f) { return initHooks.push(f); };

  // Indent the given line. The how parameter can be "smart",
  // "add"/null, "subtract", or "prev". When aggressive is false
  // (typically set to true for forced single-line indents), empty
  // lines are not indented, and places where the mode returns Pass
  // are left alone.
  function indentLine(cm, n, how, aggressive) {
    var doc = cm.doc, state;
    if (how == null) { how = "add"; }
    if (how == "smart") {
      // Fall back to "prev" when the mode doesn't have an indentation
      // method.
      if (!doc.mode.indent) { how = "prev"; }
      else { state = getContextBefore(cm, n).state; }
    }

    var tabSize = cm.options.tabSize;
    var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
    if (line.stateAfter) { line.stateAfter = null; }
    var curSpaceString = line.text.match(/^\s*/)[0], indentation;
    if (!aggressive && !/\S/.test(line.text)) {
      indentation = 0;
      how = "not";
    } else if (how == "smart") {
      indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
      if (indentation == Pass || indentation > 150) {
        if (!aggressive) { return }
        how = "prev";
      }
    }
    if (how == "prev") {
      if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
      else { indentation = 0; }
    } else if (how == "add") {
      indentation = curSpace + cm.options.indentUnit;
    } else if (how == "subtract") {
      indentation = curSpace - cm.options.indentUnit;
    } else if (typeof how == "number") {
      indentation = curSpace + how;
    }
    indentation = Math.max(0, indentation);

    var indentString = "", pos = 0;
    if (cm.options.indentWithTabs)
      { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
    if (pos < indentation) { indentString += spaceStr(indentation - pos); }

    if (indentString != curSpaceString) {
      replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
      line.stateAfter = null;
      return true
    } else {
      // Ensure that, if the cursor was in the whitespace at the start
      // of the line, it is moved to the end of that space.
      for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
        var range = doc.sel.ranges[i$1];
        if (range.head.line == n && range.head.ch < curSpaceString.length) {
          var pos$1 = Pos(n, curSpaceString.length);
          replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
          break
        }
      }
    }
  }

  // This will be set to a {lineWise: bool, text: [string]} object, so
  // that, when pasting, we know what kind of selections the copied
  // text was made out of.
  var lastCopied = null;

  function setLastCopied(newLastCopied) {
    lastCopied = newLastCopied;
  }

  function applyTextInput(cm, inserted, deleted, sel, origin) {
    var doc = cm.doc;
    cm.display.shift = false;
    if (!sel) { sel = doc.sel; }

    var recent = +new Date - 200;
    var paste = origin == "paste" || cm.state.pasteIncoming > recent;
    var textLines = splitLinesAuto(inserted), multiPaste = null;
    // When pasting N lines into N selections, insert one line per selection
    if (paste && sel.ranges.length > 1) {
      if (lastCopied && lastCopied.text.join("\n") == inserted) {
        if (sel.ranges.length % lastCopied.text.length == 0) {
          multiPaste = [];
          for (var i = 0; i < lastCopied.text.length; i++)
            { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
        }
      } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
        multiPaste = map(textLines, function (l) { return [l]; });
      }
    }

    var updateInput = cm.curOp.updateInput;
    // Normal behavior is to insert the new text into every selection
    for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
      var range = sel.ranges[i$1];
      var from = range.from(), to = range.to();
      if (range.empty()) {
        if (deleted && deleted > 0) // Handle deletion
          { from = Pos(from.line, from.ch - deleted); }
        else if (cm.state.overwrite && !paste) // Handle overwrite
          { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
        else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n"))
          { from = to = Pos(from.line, 0); }
      }
      var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                         origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")};
      makeChange(cm.doc, changeEvent);
      signalLater(cm, "inputRead", cm, changeEvent);
    }
    if (inserted && !paste)
      { triggerElectric(cm, inserted); }

    ensureCursorVisible(cm);
    if (cm.curOp.updateInput < 2) { cm.curOp.updateInput = updateInput; }
    cm.curOp.typing = true;
    cm.state.pasteIncoming = cm.state.cutIncoming = -1;
  }

  function handlePaste(e, cm) {
    var pasted = e.clipboardData && e.clipboardData.getData("Text");
    if (pasted) {
      e.preventDefault();
      if (!cm.isReadOnly() && !cm.options.disableInput)
        { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
      return true
    }
  }

  function triggerElectric(cm, inserted) {
    // When an 'electric' character is inserted, immediately trigger a reindent
    if (!cm.options.electricChars || !cm.options.smartIndent) { return }
    var sel = cm.doc.sel;

    for (var i = sel.ranges.length - 1; i >= 0; i--) {
      var range = sel.ranges[i];
      if (range.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range.head.line)) { continue }
      var mode = cm.getModeAt(range.head);
      var indented = false;
      if (mode.electricChars) {
        for (var j = 0; j < mode.electricChars.length; j++)
          { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
            indented = indentLine(cm, range.head.line, "smart");
            break
          } }
      } else if (mode.electricInput) {
        if (mode.electricInput.test(getLine(cm.doc, range.head.line).text.slice(0, range.head.ch)))
          { indented = indentLine(cm, range.head.line, "smart"); }
      }
      if (indented) { signalLater(cm, "electricInput", cm, range.head.line); }
    }
  }

  function copyableRanges(cm) {
    var text = [], ranges = [];
    for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
      var line = cm.doc.sel.ranges[i].head.line;
      var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
      ranges.push(lineRange);
      text.push(cm.getRange(lineRange.anchor, lineRange.head));
    }
    return {text: text, ranges: ranges}
  }

  function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
    field.setAttribute("autocorrect", autocorrect ? "" : "off");
    field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
    field.setAttribute("spellcheck", !!spellcheck);
  }

  function hiddenTextarea() {
    var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
    var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
    // The textarea is kept positioned near the cursor to prevent the
    // fact that it'll be scrolled into view on input from scrolling
    // our fake cursor out of view. On webkit, when wrap=off, paste is
    // very slow. So make the area wide instead.
    if (webkit) { te.style.width = "1000px"; }
    else { te.setAttribute("wrap", "off"); }
    // If border: 0; -- iOS fails to open keyboard (issue #1287)
    if (ios) { te.style.border = "1px solid black"; }
    disableBrowserMagic(te);
    return div
  }

  // The publicly visible API. Note that methodOp(f) means
  // 'wrap f in an operation, performed on its `this` parameter'.

  // This is not the complete set of editor methods. Most of the
  // methods defined on the Doc type are also injected into
  // CodeMirror.prototype, for backwards compatibility and
  // convenience.

  function addEditorMethods(CodeMirror) {
    var optionHandlers = CodeMirror.optionHandlers;

    var helpers = CodeMirror.helpers = {};

    CodeMirror.prototype = {
      constructor: CodeMirror,
      focus: function(){window.focus(); this.display.input.focus();},

      setOption: function(option, value) {
        var options = this.options, old = options[option];
        if (options[option] == value && option != "mode") { return }
        options[option] = value;
        if (optionHandlers.hasOwnProperty(option))
          { operation(this, optionHandlers[option])(this, value, old); }
        signal(this, "optionChange", this, option);
      },

      getOption: function(option) {return this.options[option]},
      getDoc: function() {return this.doc},

      addKeyMap: function(map, bottom) {
        this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map));
      },
      removeKeyMap: function(map) {
        var maps = this.state.keyMaps;
        for (var i = 0; i < maps.length; ++i)
          { if (maps[i] == map || maps[i].name == map) {
            maps.splice(i, 1);
            return true
          } }
      },

      addOverlay: methodOp(function(spec, options) {
        var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
        if (mode.startState) { throw new Error("Overlays may not be stateful.") }
        insertSorted(this.state.overlays,
                     {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                      priority: (options && options.priority) || 0},
                     function (overlay) { return overlay.priority; });
        this.state.modeGen++;
        regChange(this);
      }),
      removeOverlay: methodOp(function(spec) {
        var overlays = this.state.overlays;
        for (var i = 0; i < overlays.length; ++i) {
          var cur = overlays[i].modeSpec;
          if (cur == spec || typeof spec == "string" && cur.name == spec) {
            overlays.splice(i, 1);
            this.state.modeGen++;
            regChange(this);
            return
          }
        }
      }),

      indentLine: methodOp(function(n, dir, aggressive) {
        if (typeof dir != "string" && typeof dir != "number") {
          if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
          else { dir = dir ? "add" : "subtract"; }
        }
        if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
      }),
      indentSelection: methodOp(function(how) {
        var ranges = this.doc.sel.ranges, end = -1;
        for (var i = 0; i < ranges.length; i++) {
          var range = ranges[i];
          if (!range.empty()) {
            var from = range.from(), to = range.to();
            var start = Math.max(end, from.line);
            end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
            for (var j = start; j < end; ++j)
              { indentLine(this, j, how); }
            var newRanges = this.doc.sel.ranges;
            if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
              { replaceOneSelection(this.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
          } else if (range.head.line > end) {
            indentLine(this, range.head.line, how, true);
            end = range.head.line;
            if (i == this.doc.sel.primIndex) { ensureCursorVisible(this); }
          }
        }
      }),

      // Fetch the parser token for a given character. Useful for hacks
      // that want to inspect the mode state (say, for completion).
      getTokenAt: function(pos, precise) {
        return takeToken(this, pos, precise)
      },

      getLineTokens: function(line, precise) {
        return takeToken(this, Pos(line), precise, true)
      },

      getTokenTypeAt: function(pos) {
        pos = clipPos(this.doc, pos);
        var styles = getLineStyles(this, getLine(this.doc, pos.line));
        var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
        var type;
        if (ch == 0) { type = styles[2]; }
        else { for (;;) {
          var mid = (before + after) >> 1;
          if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
          else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
          else { type = styles[mid * 2 + 2]; break }
        } }
        var cut = type ? type.indexOf("overlay ") : -1;
        return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
      },

      getModeAt: function(pos) {
        var mode = this.doc.mode;
        if (!mode.innerMode) { return mode }
        return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
      },

      getHelper: function(pos, type) {
        return this.getHelpers(pos, type)[0]
      },

      getHelpers: function(pos, type) {
        var found = [];
        if (!helpers.hasOwnProperty(type)) { return found }
        var help = helpers[type], mode = this.getModeAt(pos);
        if (typeof mode[type] == "string") {
          if (help[mode[type]]) { found.push(help[mode[type]]); }
        } else if (mode[type]) {
          for (var i = 0; i < mode[type].length; i++) {
            var val = help[mode[type][i]];
            if (val) { found.push(val); }
          }
        } else if (mode.helperType && help[mode.helperType]) {
          found.push(help[mode.helperType]);
        } else if (help[mode.name]) {
          found.push(help[mode.name]);
        }
        for (var i$1 = 0; i$1 < help._global.length; i$1++) {
          var cur = help._global[i$1];
          if (cur.pred(mode, this) && indexOf(found, cur.val) == -1)
            { found.push(cur.val); }
        }
        return found
      },

      getStateAfter: function(line, precise) {
        var doc = this.doc;
        line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
        return getContextBefore(this, line + 1, precise).state
      },

      cursorCoords: function(start, mode) {
        var pos, range = this.doc.sel.primary();
        if (start == null) { pos = range.head; }
        else if (typeof start == "object") { pos = clipPos(this.doc, start); }
        else { pos = start ? range.from() : range.to(); }
        return cursorCoords(this, pos, mode || "page")
      },

      charCoords: function(pos, mode) {
        return charCoords(this, clipPos(this.doc, pos), mode || "page")
      },

      coordsChar: function(coords, mode) {
        coords = fromCoordSystem(this, coords, mode || "page");
        return coordsChar(this, coords.left, coords.top)
      },

      lineAtHeight: function(height, mode) {
        height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
        return lineAtHeight(this.doc, height + this.display.viewOffset)
      },
      heightAtLine: function(line, mode, includeWidgets) {
        var end = false, lineObj;
        if (typeof line == "number") {
          var last = this.doc.first + this.doc.size - 1;
          if (line < this.doc.first) { line = this.doc.first; }
          else if (line > last) { line = last; end = true; }
          lineObj = getLine(this.doc, line);
        } else {
          lineObj = line;
        }
        return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
          (end ? this.doc.height - heightAtLine(lineObj) : 0)
      },

      defaultTextHeight: function() { return textHeight(this.display) },
      defaultCharWidth: function() { return charWidth(this.display) },

      getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

      addWidget: function(pos, node, scroll, vert, horiz) {
        var display = this.display;
        pos = cursorCoords(this, clipPos(this.doc, pos));
        var top = pos.bottom, left = pos.left;
        node.style.position = "absolute";
        node.setAttribute("cm-ignore-events", "true");
        this.display.input.setUneditable(node);
        display.sizer.appendChild(node);
        if (vert == "over") {
          top = pos.top;
        } else if (vert == "above" || vert == "near") {
          var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
          hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
          // Default to positioning above (if specified and possible); otherwise default to positioning below
          if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
            { top = pos.top - node.offsetHeight; }
          else if (pos.bottom + node.offsetHeight <= vspace)
            { top = pos.bottom; }
          if (left + node.offsetWidth > hspace)
            { left = hspace - node.offsetWidth; }
        }
        node.style.top = top + "px";
        node.style.left = node.style.right = "";
        if (horiz == "right") {
          left = display.sizer.clientWidth - node.offsetWidth;
          node.style.right = "0px";
        } else {
          if (horiz == "left") { left = 0; }
          else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
          node.style.left = left + "px";
        }
        if (scroll)
          { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
      },

      triggerOnKeyDown: methodOp(onKeyDown),
      triggerOnKeyPress: methodOp(onKeyPress),
      triggerOnKeyUp: onKeyUp,
      triggerOnMouseDown: methodOp(onMouseDown),

      execCommand: function(cmd) {
        if (commands.hasOwnProperty(cmd))
          { return commands[cmd].call(null, this) }
      },

      triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

      findPosH: function(from, amount, unit, visually) {
        var dir = 1;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          cur = findPosH(this.doc, cur, dir, unit, visually);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveH: methodOp(function(dir, unit) {
        var this$1 = this;

        this.extendSelectionsBy(function (range) {
          if (this$1.display.shift || this$1.doc.extend || range.empty())
            { return findPosH(this$1.doc, range.head, dir, unit, this$1.options.rtlMoveVisually) }
          else
            { return dir < 0 ? range.from() : range.to() }
        }, sel_move);
      }),

      deleteH: methodOp(function(dir, unit) {
        var sel = this.doc.sel, doc = this.doc;
        if (sel.somethingSelected())
          { doc.replaceSelection("", null, "+delete"); }
        else
          { deleteNearSelection(this, function (range) {
            var other = findPosH(doc, range.head, dir, unit, false);
            return dir < 0 ? {from: other, to: range.head} : {from: range.head, to: other}
          }); }
      }),

      findPosV: function(from, amount, unit, goalColumn) {
        var dir = 1, x = goalColumn;
        if (amount < 0) { dir = -1; amount = -amount; }
        var cur = clipPos(this.doc, from);
        for (var i = 0; i < amount; ++i) {
          var coords = cursorCoords(this, cur, "div");
          if (x == null) { x = coords.left; }
          else { coords.left = x; }
          cur = findPosV(this, coords, dir, unit);
          if (cur.hitSide) { break }
        }
        return cur
      },

      moveV: methodOp(function(dir, unit) {
        var this$1 = this;

        var doc = this.doc, goals = [];
        var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
        doc.extendSelectionsBy(function (range) {
          if (collapse)
            { return dir < 0 ? range.from() : range.to() }
          var headPos = cursorCoords(this$1, range.head, "div");
          if (range.goalColumn != null) { headPos.left = range.goalColumn; }
          goals.push(headPos.left);
          var pos = findPosV(this$1, headPos, dir, unit);
          if (unit == "page" && range == doc.sel.primary())
            { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
          return pos
        }, sel_move);
        if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
          { doc.sel.ranges[i].goalColumn = goals[i]; } }
      }),

      // Find the word at the given position (as returned by coordsChar).
      findWordAt: function(pos) {
        var doc = this.doc, line = getLine(doc, pos.line).text;
        var start = pos.ch, end = pos.ch;
        if (line) {
          var helper = this.getHelper(pos, "wordChars");
          if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
          var startChar = line.charAt(start);
          var check = isWordChar(startChar, helper)
            ? function (ch) { return isWordChar(ch, helper); }
            : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
            : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
          while (start > 0 && check(line.charAt(start - 1))) { --start; }
          while (end < line.length && check(line.charAt(end))) { ++end; }
        }
        return new Range(Pos(pos.line, start), Pos(pos.line, end))
      },

      toggleOverwrite: function(value) {
        if (value != null && value == this.state.overwrite) { return }
        if (this.state.overwrite = !this.state.overwrite)
          { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
        else
          { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

        signal(this, "overwriteToggle", this, this.state.overwrite);
      },
      hasFocus: function() { return this.display.input.getField() == activeElt() },
      isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

      scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
      getScrollInfo: function() {
        var scroller = this.display.scroller;
        return {left: scroller.scrollLeft, top: scroller.scrollTop,
                height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
      },

      scrollIntoView: methodOp(function(range, margin) {
        if (range == null) {
          range = {from: this.doc.sel.primary().head, to: null};
          if (margin == null) { margin = this.options.cursorScrollMargin; }
        } else if (typeof range == "number") {
          range = {from: Pos(range, 0), to: null};
        } else if (range.from == null) {
          range = {from: range, to: null};
        }
        if (!range.to) { range.to = range.from; }
        range.margin = margin || 0;

        if (range.from.line != null) {
          scrollToRange(this, range);
        } else {
          scrollToCoordsRange(this, range.from, range.to, range.margin);
        }
      }),

      setSize: methodOp(function(width, height) {
        var this$1 = this;

        var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
        if (width != null) { this.display.wrapper.style.width = interpret(width); }
        if (height != null) { this.display.wrapper.style.height = interpret(height); }
        if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
        var lineNo = this.display.viewFrom;
        this.doc.iter(lineNo, this.display.viewTo, function (line) {
          if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
            { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo, "widget"); break } } }
          ++lineNo;
        });
        this.curOp.forceUpdate = true;
        signal(this, "refresh", this);
      }),

      operation: function(f){return runInOp(this, f)},
      startOperation: function(){return startOperation(this)},
      endOperation: function(){return endOperation(this)},

      refresh: methodOp(function() {
        var oldHeight = this.display.cachedTextHeight;
        regChange(this);
        this.curOp.forceUpdate = true;
        clearCaches(this);
        scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
        updateGutterSpace(this.display);
        if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5 || this.options.lineWrapping)
          { estimateLineHeights(this); }
        signal(this, "refresh", this);
      }),

      swapDoc: methodOp(function(doc) {
        var old = this.doc;
        old.cm = null;
        // Cancel the current text selection if any (#5821)
        if (this.state.selectingText) { this.state.selectingText(); }
        attachDoc(this, doc);
        clearCaches(this);
        this.display.input.reset();
        scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
        this.curOp.forceScroll = true;
        signalLater(this, "swapDoc", this, old);
        return old
      }),

      phrase: function(phraseText) {
        var phrases = this.options.phrases;
        return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText
      },

      getInputField: function(){return this.display.input.getField()},
      getWrapperElement: function(){return this.display.wrapper},
      getScrollerElement: function(){return this.display.scroller},
      getGutterElement: function(){return this.display.gutters}
    };
    eventMixin(CodeMirror);

    CodeMirror.registerHelper = function(type, name, value) {
      if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
      helpers[type][name] = value;
    };
    CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
      CodeMirror.registerHelper(type, name, value);
      helpers[type]._global.push({pred: predicate, val: value});
    };
  }

  // Used for horizontal relative motion. Dir is -1 or 1 (left or
  // right), unit can be "codepoint", "char", "column" (like char, but
  // doesn't cross line boundaries), "word" (across next word), or
  // "group" (to the start of next group of word or
  // non-word-non-whitespace chars). The visually param controls
  // whether, in right-to-left text, direction 1 means to move towards
  // the next index in the string, or towards the character to the right
  // of the current position. The resulting position will have a
  // hitSide=true property if it reached the end of the document.
  function findPosH(doc, pos, dir, unit, visually) {
    var oldPos = pos;
    var origDir = dir;
    var lineObj = getLine(doc, pos.line);
    var lineDir = visually && doc.direction == "rtl" ? -dir : dir;
    function findNextLine() {
      var l = pos.line + lineDir;
      if (l < doc.first || l >= doc.first + doc.size) { return false }
      pos = new Pos(l, pos.ch, pos.sticky);
      return lineObj = getLine(doc, l)
    }
    function moveOnce(boundToLine) {
      var next;
      if (unit == "codepoint") {
        var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
        if (isNaN(ch)) {
          next = null;
        } else {
          var astral = dir > 0 ? ch >= 0xD800 && ch < 0xDC00 : ch >= 0xDC00 && ch < 0xDFFF;
          next = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
        }
      } else if (visually) {
        next = moveVisually(doc.cm, lineObj, pos, dir);
      } else {
        next = moveLogically(lineObj, pos, dir);
      }
      if (next == null) {
        if (!boundToLine && findNextLine())
          { pos = endOfLine(visually, doc.cm, lineObj, pos.line, lineDir); }
        else
          { return false }
      } else {
        pos = next;
      }
      return true
    }

    if (unit == "char" || unit == "codepoint") {
      moveOnce();
    } else if (unit == "column") {
      moveOnce(true);
    } else if (unit == "word" || unit == "group") {
      var sawType = null, group = unit == "group";
      var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
      for (var first = true;; first = false) {
        if (dir < 0 && !moveOnce(!first)) { break }
        var cur = lineObj.text.charAt(pos.ch) || "\n";
        var type = isWordChar(cur, helper) ? "w"
          : group && cur == "\n" ? "n"
          : !group || /\s/.test(cur) ? null
          : "p";
        if (group && !first && !type) { type = "s"; }
        if (sawType && sawType != type) {
          if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
          break
        }

        if (type) { sawType = type; }
        if (dir > 0 && !moveOnce(!first)) { break }
      }
    }
    var result = skipAtomic(doc, pos, oldPos, origDir, true);
    if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
    return result
  }

  // For relative vertical movement. Dir may be -1 or 1. Unit can be
  // "page" or "line". The resulting position will have a hitSide=true
  // property if it reached the end of the document.
  function findPosV(cm, pos, dir, unit) {
    var doc = cm.doc, x = pos.left, y;
    if (unit == "page") {
      var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
      var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
      y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

    } else if (unit == "line") {
      y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
    }
    var target;
    for (;;) {
      target = coordsChar(cm, x, y);
      if (!target.outside) { break }
      if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
      y += dir * 5;
    }
    return target
  }

  // CONTENTEDITABLE INPUT STYLE

  var ContentEditableInput = function(cm) {
    this.cm = cm;
    this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
    this.polling = new Delayed();
    this.composing = null;
    this.gracePeriod = false;
    this.readDOMTimeout = null;
  };

  ContentEditableInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = input.cm;
    var div = input.div = display.lineDiv;
    div.contentEditable = true;
    disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);

    function belongsToInput(e) {
      for (var t = e.target; t; t = t.parentNode) {
        if (t == div) { return true }
        if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) { break }
      }
      return false
    }

    on(div, "paste", function (e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
      // IE doesn't fire input events, so we schedule a read for the pasted content in this way
      if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
    });

    on(div, "compositionstart", function (e) {
      this$1.composing = {data: e.data, done: false};
    });
    on(div, "compositionupdate", function (e) {
      if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
    });
    on(div, "compositionend", function (e) {
      if (this$1.composing) {
        if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
        this$1.composing.done = true;
      }
    });

    on(div, "touchstart", function () { return input.forceCompositionEnd(); });

    on(div, "input", function () {
      if (!this$1.composing) { this$1.readFromDOMSoon(); }
    });

    function onCopyCut(e) {
      if (!belongsToInput(e) || signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
        if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.operation(function () {
            cm.setSelections(ranges.ranges, 0, sel_dontScroll);
            cm.replaceSelection("", null, "cut");
          });
        }
      }
      if (e.clipboardData) {
        e.clipboardData.clearData();
        var content = lastCopied.text.join("\n");
        // iOS exposes the clipboard API, but seems to discard content inserted into it
        e.clipboardData.setData("Text", content);
        if (e.clipboardData.getData("Text") == content) {
          e.preventDefault();
          return
        }
      }
      // Old-fashioned briefly-focus-a-textarea hack
      var kludge = hiddenTextarea(), te = kludge.firstChild;
      cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
      te.value = lastCopied.text.join("\n");
      var hadFocus = activeElt();
      selectInput(te);
      setTimeout(function () {
        cm.display.lineSpace.removeChild(kludge);
        hadFocus.focus();
        if (hadFocus == div) { input.showPrimarySelection(); }
      }, 50);
    }
    on(div, "copy", onCopyCut);
    on(div, "cut", onCopyCut);
  };

  ContentEditableInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.div.setAttribute('aria-label', label);
    } else {
      this.div.removeAttribute('aria-label');
    }
  };

  ContentEditableInput.prototype.prepareSelection = function () {
    var result = prepareSelection(this.cm, false);
    result.focus = activeElt() == this.div;
    return result
  };

  ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
    if (!info || !this.cm.display.view.length) { return }
    if (info.focus || takeFocus) { this.showPrimarySelection(); }
    this.showMultipleSelections(info);
  };

  ContentEditableInput.prototype.getSelection = function () {
    return this.cm.display.wrapper.ownerDocument.getSelection()
  };

  ContentEditableInput.prototype.showPrimarySelection = function () {
    var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
    var from = prim.from(), to = prim.to();

    if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
      sel.removeAllRanges();
      return
    }

    var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
        cmp(minPos(curAnchor, curFocus), from) == 0 &&
        cmp(maxPos(curAnchor, curFocus), to) == 0)
      { return }

    var view = cm.display.view;
    var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
        {node: view[0].measure.map[2], offset: 0};
    var end = to.line < cm.display.viewTo && posToDOM(cm, to);
    if (!end) {
      var measure = view[view.length - 1].measure;
      var map = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
      end = {node: map[map.length - 1], offset: map[map.length - 2] - map[map.length - 3]};
    }

    if (!start || !end) {
      sel.removeAllRanges();
      return
    }

    var old = sel.rangeCount && sel.getRangeAt(0), rng;
    try { rng = range(start.node, start.offset, end.offset, end.node); }
    catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
    if (rng) {
      if (!gecko && cm.state.focused) {
        sel.collapse(start.node, start.offset);
        if (!rng.collapsed) {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
      } else {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
      if (old && sel.anchorNode == null) { sel.addRange(old); }
      else if (gecko) { this.startGracePeriod(); }
    }
    this.rememberSelection();
  };

  ContentEditableInput.prototype.startGracePeriod = function () {
      var this$1 = this;

    clearTimeout(this.gracePeriod);
    this.gracePeriod = setTimeout(function () {
      this$1.gracePeriod = false;
      if (this$1.selectionChanged())
        { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
    }, 20);
  };

  ContentEditableInput.prototype.showMultipleSelections = function (info) {
    removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
    removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
  };

  ContentEditableInput.prototype.rememberSelection = function () {
    var sel = this.getSelection();
    this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
    this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
  };

  ContentEditableInput.prototype.selectionInEditor = function () {
    var sel = this.getSelection();
    if (!sel.rangeCount) { return false }
    var node = sel.getRangeAt(0).commonAncestorContainer;
    return contains(this.div, node)
  };

  ContentEditableInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor") {
      if (!this.selectionInEditor() || activeElt() != this.div)
        { this.showSelection(this.prepareSelection(), true); }
      this.div.focus();
    }
  };
  ContentEditableInput.prototype.blur = function () { this.div.blur(); };
  ContentEditableInput.prototype.getField = function () { return this.div };

  ContentEditableInput.prototype.supportsTouch = function () { return true };

  ContentEditableInput.prototype.receivedFocus = function () {
    var input = this;
    if (this.selectionInEditor())
      { this.pollSelection(); }
    else
      { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

    function poll() {
      if (input.cm.state.focused) {
        input.pollSelection();
        input.polling.set(input.cm.options.pollInterval, poll);
      }
    }
    this.polling.set(this.cm.options.pollInterval, poll);
  };

  ContentEditableInput.prototype.selectionChanged = function () {
    var sel = this.getSelection();
    return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
      sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
  };

  ContentEditableInput.prototype.pollSelection = function () {
    if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
    var sel = this.getSelection(), cm = this.cm;
    // On Android Chrome (version 56, at least), backspacing into an
    // uneditable block element will put the cursor in that element,
    // and then, because it's not editable, hide the virtual keyboard.
    // Because Android doesn't allow us to actually detect backspace
    // presses in a sane way, this code checks for when that happens
    // and simulates a backspace press in this case.
    if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
      this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
      this.blur();
      this.focus();
      return
    }
    if (this.composing) { return }
    this.rememberSelection();
    var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
    var head = domToPos(cm, sel.focusNode, sel.focusOffset);
    if (anchor && head) { runInOp(cm, function () {
      setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
      if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
    }); }
  };

  ContentEditableInput.prototype.pollContent = function () {
    if (this.readDOMTimeout != null) {
      clearTimeout(this.readDOMTimeout);
      this.readDOMTimeout = null;
    }

    var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
    var from = sel.from(), to = sel.to();
    if (from.ch == 0 && from.line > cm.firstLine())
      { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
    if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
      { to = Pos(to.line + 1, 0); }
    if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

    var fromIndex, fromLine, fromNode;
    if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
      fromLine = lineNo(display.view[0].line);
      fromNode = display.view[0].node;
    } else {
      fromLine = lineNo(display.view[fromIndex].line);
      fromNode = display.view[fromIndex - 1].node.nextSibling;
    }
    var toIndex = findViewIndex(cm, to.line);
    var toLine, toNode;
    if (toIndex == display.view.length - 1) {
      toLine = display.viewTo - 1;
      toNode = display.lineDiv.lastChild;
    } else {
      toLine = lineNo(display.view[toIndex + 1].line) - 1;
      toNode = display.view[toIndex + 1].node.previousSibling;
    }

    if (!fromNode) { return false }
    var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
    var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
    while (newText.length > 1 && oldText.length > 1) {
      if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
      else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
      else { break }
    }

    var cutFront = 0, cutEnd = 0;
    var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
    while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
      { ++cutFront; }
    var newBot = lst(newText), oldBot = lst(oldText);
    var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                             oldBot.length - (oldText.length == 1 ? cutFront : 0));
    while (cutEnd < maxCutEnd &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
      { ++cutEnd; }
    // Try to move start of change to start of selection if ambiguous
    if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
      while (cutFront && cutFront > from.ch &&
             newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        cutFront--;
        cutEnd++;
      }
    }

    newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
    newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

    var chFrom = Pos(fromLine, cutFront);
    var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
    if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
      replaceRange(cm.doc, newText, chFrom, chTo, "+input");
      return true
    }
  };

  ContentEditableInput.prototype.ensurePolled = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.reset = function () {
    this.forceCompositionEnd();
  };
  ContentEditableInput.prototype.forceCompositionEnd = function () {
    if (!this.composing) { return }
    clearTimeout(this.readDOMTimeout);
    this.composing = null;
    this.updateFromDOM();
    this.div.blur();
    this.div.focus();
  };
  ContentEditableInput.prototype.readFromDOMSoon = function () {
      var this$1 = this;

    if (this.readDOMTimeout != null) { return }
    this.readDOMTimeout = setTimeout(function () {
      this$1.readDOMTimeout = null;
      if (this$1.composing) {
        if (this$1.composing.done) { this$1.composing = null; }
        else { return }
      }
      this$1.updateFromDOM();
    }, 80);
  };

  ContentEditableInput.prototype.updateFromDOM = function () {
      var this$1 = this;

    if (this.cm.isReadOnly() || !this.pollContent())
      { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
  };

  ContentEditableInput.prototype.setUneditable = function (node) {
    node.contentEditable = "false";
  };

  ContentEditableInput.prototype.onKeyPress = function (e) {
    if (e.charCode == 0 || this.composing) { return }
    e.preventDefault();
    if (!this.cm.isReadOnly())
      { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
  };

  ContentEditableInput.prototype.readOnlyChanged = function (val) {
    this.div.contentEditable = String(val != "nocursor");
  };

  ContentEditableInput.prototype.onContextMenu = function () {};
  ContentEditableInput.prototype.resetPosition = function () {};

  ContentEditableInput.prototype.needsContentAttribute = true;

  function posToDOM(cm, pos) {
    var view = findViewForLine(cm, pos.line);
    if (!view || view.hidden) { return null }
    var line = getLine(cm.doc, pos.line);
    var info = mapFromLineView(view, line, pos.line);

    var order = getOrder(line, cm.doc.direction), side = "left";
    if (order) {
      var partPos = getBidiPartAt(order, pos.ch);
      side = partPos % 2 ? "right" : "left";
    }
    var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
    result.offset = result.collapse == "right" ? result.end : result.start;
    return result
  }

  function isInGutter(node) {
    for (var scan = node; scan; scan = scan.parentNode)
      { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
    return false
  }

  function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

  function domTextBetween(cm, from, to, fromLine, toLine) {
    var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
    function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
    function close() {
      if (closing) {
        text += lineSep;
        if (extraLinebreak) { text += lineSep; }
        closing = extraLinebreak = false;
      }
    }
    function addText(str) {
      if (str) {
        close();
        text += str;
      }
    }
    function walk(node) {
      if (node.nodeType == 1) {
        var cmText = node.getAttribute("cm-text");
        if (cmText) {
          addText(cmText);
          return
        }
        var markerID = node.getAttribute("cm-marker"), range;
        if (markerID) {
          var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
          if (found.length && (range = found[0].find(0)))
            { addText(getBetween(cm.doc, range.from, range.to).join(lineSep)); }
          return
        }
        if (node.getAttribute("contenteditable") == "false") { return }
        var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
        if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) { return }

        if (isBlock) { close(); }
        for (var i = 0; i < node.childNodes.length; i++)
          { walk(node.childNodes[i]); }

        if (/^(pre|p)$/i.test(node.nodeName)) { extraLinebreak = true; }
        if (isBlock) { closing = true; }
      } else if (node.nodeType == 3) {
        addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
      }
    }
    for (;;) {
      walk(from);
      if (from == to) { break }
      from = from.nextSibling;
      extraLinebreak = false;
    }
    return text
  }

  function domToPos(cm, node, offset) {
    var lineNode;
    if (node == cm.display.lineDiv) {
      lineNode = cm.display.lineDiv.childNodes[offset];
      if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
      node = null; offset = 0;
    } else {
      for (lineNode = node;; lineNode = lineNode.parentNode) {
        if (!lineNode || lineNode == cm.display.lineDiv) { return null }
        if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
      }
    }
    for (var i = 0; i < cm.display.view.length; i++) {
      var lineView = cm.display.view[i];
      if (lineView.node == lineNode)
        { return locateNodeInLineView(lineView, node, offset) }
    }
  }

  function locateNodeInLineView(lineView, node, offset) {
    var wrapper = lineView.text.firstChild, bad = false;
    if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
    if (node == wrapper) {
      bad = true;
      node = wrapper.childNodes[offset];
      offset = 0;
      if (!node) {
        var line = lineView.rest ? lst(lineView.rest) : lineView.line;
        return badPos(Pos(lineNo(line), line.text.length), bad)
      }
    }

    var textNode = node.nodeType == 3 ? node : null, topNode = node;
    if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
      textNode = node.firstChild;
      if (offset) { offset = textNode.nodeValue.length; }
    }
    while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
    var measure = lineView.measure, maps = measure.maps;

    function find(textNode, topNode, offset) {
      for (var i = -1; i < (maps ? maps.length : 0); i++) {
        var map = i < 0 ? measure.map : maps[i];
        for (var j = 0; j < map.length; j += 3) {
          var curNode = map[j + 2];
          if (curNode == textNode || curNode == topNode) {
            var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
            var ch = map[j] + offset;
            if (offset < 0 || curNode != textNode) { ch = map[j + (offset ? 1 : 0)]; }
            return Pos(line, ch)
          }
        }
      }
    }
    var found = find(textNode, topNode, offset);
    if (found) { return badPos(found, bad) }

    // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
    for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
      found = find(after, after.firstChild, 0);
      if (found)
        { return badPos(Pos(found.line, found.ch - dist), bad) }
      else
        { dist += after.textContent.length; }
    }
    for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
      found = find(before, before.firstChild, -1);
      if (found)
        { return badPos(Pos(found.line, found.ch + dist$1), bad) }
      else
        { dist$1 += before.textContent.length; }
    }
  }

  // TEXTAREA INPUT STYLE

  var TextareaInput = function(cm) {
    this.cm = cm;
    // See input.poll and input.reset
    this.prevInput = "";

    // Flag that indicates whether we expect input to appear real soon
    // now (after some event like 'keypress' or 'input') and are
    // polling intensively.
    this.pollingFast = false;
    // Self-resetting timeout for the poller
    this.polling = new Delayed();
    // Used to work around IE issue with selection being forgotten when focus moves away from textarea
    this.hasSelection = false;
    this.composing = null;
  };

  TextareaInput.prototype.init = function (display) {
      var this$1 = this;

    var input = this, cm = this.cm;
    this.createField(display);
    var te = this.textarea;

    display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

    // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
    if (ios) { te.style.width = "0px"; }

    on(te, "input", function () {
      if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
      input.poll();
    });

    on(te, "paste", function (e) {
      if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

      cm.state.pasteIncoming = +new Date;
      input.fastPoll();
    });

    function prepareCopyCut(e) {
      if (signalDOMEvent(cm, e)) { return }
      if (cm.somethingSelected()) {
        setLastCopied({lineWise: false, text: cm.getSelections()});
      } else if (!cm.options.lineWiseCopyCut) {
        return
      } else {
        var ranges = copyableRanges(cm);
        setLastCopied({lineWise: true, text: ranges.text});
        if (e.type == "cut") {
          cm.setSelections(ranges.ranges, null, sel_dontScroll);
        } else {
          input.prevInput = "";
          te.value = ranges.text.join("\n");
          selectInput(te);
        }
      }
      if (e.type == "cut") { cm.state.cutIncoming = +new Date; }
    }
    on(te, "cut", prepareCopyCut);
    on(te, "copy", prepareCopyCut);

    on(display.scroller, "paste", function (e) {
      if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
      if (!te.dispatchEvent) {
        cm.state.pasteIncoming = +new Date;
        input.focus();
        return
      }

      // Pass the `paste` event to the textarea so it's handled by its event listener.
      var event = new Event("paste");
      event.clipboardData = e.clipboardData;
      te.dispatchEvent(event);
    });

    // Prevent normal selection in the editor (we handle our own)
    on(display.lineSpace, "selectstart", function (e) {
      if (!eventInWidget(display, e)) { e_preventDefault(e); }
    });

    on(te, "compositionstart", function () {
      var start = cm.getCursor("from");
      if (input.composing) { input.composing.range.clear(); }
      input.composing = {
        start: start,
        range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
      };
    });
    on(te, "compositionend", function () {
      if (input.composing) {
        input.poll();
        input.composing.range.clear();
        input.composing = null;
      }
    });
  };

  TextareaInput.prototype.createField = function (_display) {
    // Wraps and hides input textarea
    this.wrapper = hiddenTextarea();
    // The semihidden textarea that is focused when the editor is
    // focused, and receives input.
    this.textarea = this.wrapper.firstChild;
  };

  TextareaInput.prototype.screenReaderLabelChanged = function (label) {
    // Label for screenreaders, accessibility
    if(label) {
      this.textarea.setAttribute('aria-label', label);
    } else {
      this.textarea.removeAttribute('aria-label');
    }
  };

  TextareaInput.prototype.prepareSelection = function () {
    // Redraw the selection and/or cursor
    var cm = this.cm, display = cm.display, doc = cm.doc;
    var result = prepareSelection(cm);

    // Move the hidden textarea near the cursor to prevent scrolling artifacts
    if (cm.options.moveInputWithCursor) {
      var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
      var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
      result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                          headPos.top + lineOff.top - wrapOff.top));
      result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                           headPos.left + lineOff.left - wrapOff.left));
    }

    return result
  };

  TextareaInput.prototype.showSelection = function (drawn) {
    var cm = this.cm, display = cm.display;
    removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
    removeChildrenAndAdd(display.selectionDiv, drawn.selection);
    if (drawn.teTop != null) {
      this.wrapper.style.top = drawn.teTop + "px";
      this.wrapper.style.left = drawn.teLeft + "px";
    }
  };

  // Reset the input to correspond to the selection (or to be empty,
  // when not typing and nothing is selected)
  TextareaInput.prototype.reset = function (typing) {
    if (this.contextMenuPending || this.composing) { return }
    var cm = this.cm;
    if (cm.somethingSelected()) {
      this.prevInput = "";
      var content = cm.getSelection();
      this.textarea.value = content;
      if (cm.state.focused) { selectInput(this.textarea); }
      if (ie && ie_version >= 9) { this.hasSelection = content; }
    } else if (!typing) {
      this.prevInput = this.textarea.value = "";
      if (ie && ie_version >= 9) { this.hasSelection = null; }
    }
  };

  TextareaInput.prototype.getField = function () { return this.textarea };

  TextareaInput.prototype.supportsTouch = function () { return false };

  TextareaInput.prototype.focus = function () {
    if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
      try { this.textarea.focus(); }
      catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    }
  };

  TextareaInput.prototype.blur = function () { this.textarea.blur(); };

  TextareaInput.prototype.resetPosition = function () {
    this.wrapper.style.top = this.wrapper.style.left = 0;
  };

  TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

  // Poll for input changes, using the normal rate of polling. This
  // runs as long as the editor is focused.
  TextareaInput.prototype.slowPoll = function () {
      var this$1 = this;

    if (this.pollingFast) { return }
    this.polling.set(this.cm.options.pollInterval, function () {
      this$1.poll();
      if (this$1.cm.state.focused) { this$1.slowPoll(); }
    });
  };

  // When an event has just come in that is likely to add or change
  // something in the input textarea, we poll faster, to ensure that
  // the change appears on the screen quickly.
  TextareaInput.prototype.fastPoll = function () {
    var missed = false, input = this;
    input.pollingFast = true;
    function p() {
      var changed = input.poll();
      if (!changed && !missed) {missed = true; input.polling.set(60, p);}
      else {input.pollingFast = false; input.slowPoll();}
    }
    input.polling.set(20, p);
  };

  // Read input from the textarea, and update the document to match.
  // When something is selected, it is present in the textarea, and
  // selected (unless it is huge, in which case a placeholder is
  // used). When nothing is selected, the cursor sits after previously
  // seen text (can be empty), which is stored in prevInput (we must
  // not reset the textarea when typing, because that breaks IME).
  TextareaInput.prototype.poll = function () {
      var this$1 = this;

    var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
    // Since this is called a *lot*, try to bail out as cheaply as
    // possible when it is clear that nothing happened. hasSelection
    // will be the case when there is a lot of text in the textarea,
    // in which case reading its value would be expensive.
    if (this.contextMenuPending || !cm.state.focused ||
        (hasSelection(input) && !prevInput && !this.composing) ||
        cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
      { return false }

    var text = input.value;
    // If nothing changed, bail.
    if (text == prevInput && !cm.somethingSelected()) { return false }
    // Work around nonsensical selection resetting in IE9/10, and
    // inexplicable appearance of private area unicode characters on
    // some key combos in Mac (#2689).
    if (ie && ie_version >= 9 && this.hasSelection === text ||
        mac && /[\uf700-\uf7ff]/.test(text)) {
      cm.display.input.reset();
      return false
    }

    if (cm.doc.sel == cm.display.selForContextMenu) {
      var first = text.charCodeAt(0);
      if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
      if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
    }
    // Find the part of the input that is actually new
    var same = 0, l = Math.min(prevInput.length, text.length);
    while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

    runInOp(cm, function () {
      applyTextInput(cm, text.slice(same), prevInput.length - same,
                     null, this$1.composing ? "*compose" : null);

      // Don't leave long text in the textarea, since it makes further polling slow
      if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
      else { this$1.prevInput = text; }

      if (this$1.composing) {
        this$1.composing.range.clear();
        this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                           {className: "CodeMirror-composing"});
      }
    });
    return true
  };

  TextareaInput.prototype.ensurePolled = function () {
    if (this.pollingFast && this.poll()) { this.pollingFast = false; }
  };

  TextareaInput.prototype.onKeyPress = function () {
    if (ie && ie_version >= 9) { this.hasSelection = null; }
    this.fastPoll();
  };

  TextareaInput.prototype.onContextMenu = function (e) {
    var input = this, cm = input.cm, display = cm.display, te = input.textarea;
    if (input.contextMenuPending) { input.contextMenuPending(); }
    var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
    if (!pos || presto) { return } // Opera is difficult.

    // Reset the current text selection only if the click is done outside of the selection
    // and 'resetSelectionOnContextMenu' option is true.
    var reset = cm.options.resetSelectionOnContextMenu;
    if (reset && cm.doc.sel.contains(pos) == -1)
      { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

    var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
    var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
    input.wrapper.style.cssText = "position: static";
    te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
    var oldScrollY;
    if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
    display.input.focus();
    if (webkit) { window.scrollTo(null, oldScrollY); }
    display.input.reset();
    // Adds "Select all" to context menu in FF
    if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
    input.contextMenuPending = rehide;
    display.selForContextMenu = cm.doc.sel;
    clearTimeout(display.detectingSelectAll);

    // Select-all will be greyed out if there's nothing to select, so
    // this adds a zero-width space so that we can later check whether
    // it got selected.
    function prepareSelectAllHack() {
      if (te.selectionStart != null) {
        var selected = cm.somethingSelected();
        var extval = "\u200b" + (selected ? te.value : "");
        te.value = "\u21da"; // Used to catch context-menu undo
        te.value = extval;
        input.prevInput = selected ? "" : "\u200b";
        te.selectionStart = 1; te.selectionEnd = extval.length;
        // Re-set this, in case some other handler touched the
        // selection in the meantime.
        display.selForContextMenu = cm.doc.sel;
      }
    }
    function rehide() {
      if (input.contextMenuPending != rehide) { return }
      input.contextMenuPending = false;
      input.wrapper.style.cssText = oldWrapperCSS;
      te.style.cssText = oldCSS;
      if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

      // Try to detect the user choosing select-all
      if (te.selectionStart != null) {
        if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
        var i = 0, poll = function () {
          if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
              te.selectionEnd > 0 && input.prevInput == "\u200b") {
            operation(cm, selectAll)(cm);
          } else if (i++ < 10) {
            display.detectingSelectAll = setTimeout(poll, 500);
          } else {
            display.selForContextMenu = null;
            display.input.reset();
          }
        };
        display.detectingSelectAll = setTimeout(poll, 200);
      }
    }

    if (ie && ie_version >= 9) { prepareSelectAllHack(); }
    if (captureRightClick) {
      e_stop(e);
      var mouseup = function () {
        off(window, "mouseup", mouseup);
        setTimeout(rehide, 20);
      };
      on(window, "mouseup", mouseup);
    } else {
      setTimeout(rehide, 50);
    }
  };

  TextareaInput.prototype.readOnlyChanged = function (val) {
    if (!val) { this.reset(); }
    this.textarea.disabled = val == "nocursor";
    this.textarea.readOnly = !!val;
  };

  TextareaInput.prototype.setUneditable = function () {};

  TextareaInput.prototype.needsContentAttribute = false;

  function fromTextArea(textarea, options) {
    options = options ? copyObj(options) : {};
    options.value = textarea.value;
    if (!options.tabindex && textarea.tabIndex)
      { options.tabindex = textarea.tabIndex; }
    if (!options.placeholder && textarea.placeholder)
      { options.placeholder = textarea.placeholder; }
    // Set autofocus to true if this textarea is focused, or if it has
    // autofocus and no other element is focused.
    if (options.autofocus == null) {
      var hasFocus = activeElt();
      options.autofocus = hasFocus == textarea ||
        textarea.getAttribute("autofocus") != null && hasFocus == document.body;
    }

    function save() {textarea.value = cm.getValue();}

    var realSubmit;
    if (textarea.form) {
      on(textarea.form, "submit", save);
      // Deplorable hack to make the submit method do the right thing.
      if (!options.leaveSubmitMethodAlone) {
        var form = textarea.form;
        realSubmit = form.submit;
        try {
          var wrappedSubmit = form.submit = function () {
            save();
            form.submit = realSubmit;
            form.submit();
            form.submit = wrappedSubmit;
          };
        } catch(e) {}
      }
    }

    options.finishInit = function (cm) {
      cm.save = save;
      cm.getTextArea = function () { return textarea; };
      cm.toTextArea = function () {
        cm.toTextArea = isNaN; // Prevent this from being ran twice
        save();
        textarea.parentNode.removeChild(cm.getWrapperElement());
        textarea.style.display = "";
        if (textarea.form) {
          off(textarea.form, "submit", save);
          if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function")
            { textarea.form.submit = realSubmit; }
        }
      };
    };

    textarea.style.display = "none";
    var cm = CodeMirror(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
      options);
    return cm
  }

  function addLegacyProps(CodeMirror) {
    CodeMirror.off = off;
    CodeMirror.on = on;
    CodeMirror.wheelEventPixels = wheelEventPixels;
    CodeMirror.Doc = Doc;
    CodeMirror.splitLines = splitLinesAuto;
    CodeMirror.countColumn = countColumn;
    CodeMirror.findColumn = findColumn;
    CodeMirror.isWordChar = isWordCharBasic;
    CodeMirror.Pass = Pass;
    CodeMirror.signal = signal;
    CodeMirror.Line = Line;
    CodeMirror.changeEnd = changeEnd;
    CodeMirror.scrollbarModel = scrollbarModel;
    CodeMirror.Pos = Pos;
    CodeMirror.cmpPos = cmp;
    CodeMirror.modes = modes;
    CodeMirror.mimeModes = mimeModes;
    CodeMirror.resolveMode = resolveMode;
    CodeMirror.getMode = getMode;
    CodeMirror.modeExtensions = modeExtensions;
    CodeMirror.extendMode = extendMode;
    CodeMirror.copyState = copyState;
    CodeMirror.startState = startState;
    CodeMirror.innerMode = innerMode;
    CodeMirror.commands = commands;
    CodeMirror.keyMap = keyMap;
    CodeMirror.keyName = keyName;
    CodeMirror.isModifierKey = isModifierKey;
    CodeMirror.lookupKey = lookupKey;
    CodeMirror.normalizeKeyMap = normalizeKeyMap;
    CodeMirror.StringStream = StringStream;
    CodeMirror.SharedTextMarker = SharedTextMarker;
    CodeMirror.TextMarker = TextMarker;
    CodeMirror.LineWidget = LineWidget;
    CodeMirror.e_preventDefault = e_preventDefault;
    CodeMirror.e_stopPropagation = e_stopPropagation;
    CodeMirror.e_stop = e_stop;
    CodeMirror.addClass = addClass;
    CodeMirror.contains = contains;
    CodeMirror.rmClass = rmClass;
    CodeMirror.keyNames = keyNames;
  }

  // EDITOR CONSTRUCTOR

  defineOptions(CodeMirror);

  addEditorMethods(CodeMirror);

  // Set up methods on CodeMirror's prototype to redirect to the editor's document.
  var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
  for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
    { CodeMirror.prototype[prop] = (function(method) {
      return function() {return method.apply(this.doc, arguments)}
    })(Doc.prototype[prop]); } }

  eventMixin(Doc);
  CodeMirror.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

  // Extra arguments are stored as the mode's dependencies, which is
  // used by (legacy) mechanisms like loadmode.js to automatically
  // load a mode. (Preferred mechanism is the require/define calls.)
  CodeMirror.defineMode = function(name/*, mode, …*/) {
    if (!CodeMirror.defaults.mode && name != "null") { CodeMirror.defaults.mode = name; }
    defineMode.apply(this, arguments);
  };

  CodeMirror.defineMIME = defineMIME;

  // Minimal default mode.
  CodeMirror.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
  CodeMirror.defineMIME("text/plain", "null");

  // EXTENSIONS

  CodeMirror.defineExtension = function (name, func) {
    CodeMirror.prototype[name] = func;
  };
  CodeMirror.defineDocExtension = function (name, func) {
    Doc.prototype[name] = func;
  };

  CodeMirror.fromTextArea = fromTextArea;

  addLegacyProps(CodeMirror);

  CodeMirror.version = "5.62.0";

  return CodeMirror;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cleanHexCode = exports.cleanHexCode = function cleanHexCode(hexCode) {
  return hexCode.indexOf('#') === 0 ? hexCode : '#' + hexCode;
};

var cleanColor = exports.cleanColor = function cleanColor(color) {
  return color.indexOf('#') === 0 ? color.substring(1).toUpperCase() : color.toUpperCase();
};

var getTooltipMessage = exports.getTooltipMessage = function getTooltipMessage(orgFlags, isJourney) {
  if (isJourney) {
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_course_cloning_from_organization') !== -1) {
      return 'No journeys exist within your organization.';
    }
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_course_cloning_from_user') !== -1) {
      return 'You have no existing journeys to copy.';
    }
    return null;
  } else {
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_master_course_cloning_from_organization') !== -1) {
      return 'No courses currently exist within your organization.';
    }
    if (orgFlags.quest_maker_flags.indexOf('qm_enable_master_course_cloning_from_user') !== -1) {
      return 'You have no existing courses to copy.';
    }
    return null;
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _components = __webpack_require__(1389);
var _utils = __webpack_require__(1395);

module.exports = {
  OEComponents: _components,
  OEUtils: _utils
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modalFactory = __webpack_require__(1464);

var _modalFactory2 = _interopRequireDefault(_modalFactory);

var _insertKeyframesRule = __webpack_require__(1468);

var _insertKeyframesRule2 = _interopRequireDefault(_insertKeyframesRule);

var _appendVendorPrefix = __webpack_require__(672);

var _appendVendorPrefix2 = _interopRequireDefault(_appendVendorPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animation = {
  show: {
    animationDuration: '0.4s',
    animationTimingFunction: 'cubic-bezier(0.7,0,0.3,1)'
  },
  hide: {
    animationDuration: '0.4s',
    animationTimingFunction: 'cubic-bezier(0.7,0,0.3,1)'
  },
  showModalAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 0,
      transform: 'translate(-50%, -300px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translate(-50%, -50%)'
    }
  }),
  hideModalAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 1,
      transform: 'translate(-50%, -50%)'
    },
    '100%': {
      opacity: 0,
      transform: 'translate(-50%, 100px)'
    }
  }),
  showBackdropAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 0.9
    }
  }),
  hideBackdropAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 0.9
    },
    '100%': {
      opacity: 0
    }
  }),
  showContentAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 0,
      transform: 'translate(0, -20px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translate(0, 0)'
    }
  }),
  hideContentAnimation: (0, _insertKeyframesRule2.default)({
    '0%': {
      opacity: 1,
      transform: 'translate(0, 0)'
    },
    '100%': {
      opacity: 0,
      transform: 'translate(0, 50px)'
    }
  })
};

var showAnimation = animation.show;
var hideAnimation = animation.hide;
var showModalAnimation = animation.showModalAnimation;
var hideModalAnimation = animation.hideModalAnimation;
var showBackdropAnimation = animation.showBackdropAnimation;
var hideBackdropAnimation = animation.hideBackdropAnimation;
var showContentAnimation = animation.showContentAnimation;
var hideContentAnimation = animation.hideContentAnimation;

exports.default = (0, _modalFactory2.default)({
  getRef: function getRef(willHidden) {
    return 'modal';
  },
  getModalStyle: function getModalStyle(willHidden) {
    return (0, _appendVendorPrefix2.default)({
      position: 'fixed',
      width: '500px',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      backgroundColor: 'white',
      zIndex: 1050,
      animationDuration: (willHidden ? hideAnimation : showAnimation).animationDuration,
      animationFillMode: 'forwards',
      animationName: willHidden ? hideModalAnimation : showModalAnimation,
      animationTimingFunction: (willHidden ? hideAnimation : showAnimation).animationTimingFunction
    });
  },
  getBackdropStyle: function getBackdropStyle(willHidden) {
    return (0, _appendVendorPrefix2.default)({
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1040,
      backgroundColor: '#373A47',
      animationDuration: (willHidden ? hideAnimation : showAnimation).animationDuration,
      animationFillMode: 'forwards',
      animationName: willHidden ? hideBackdropAnimation : showBackdropAnimation,
      animationTimingFunction: (willHidden ? hideAnimation : showAnimation).animationTimingFunction
    });
  },
  getContentStyle: function getContentStyle(willHidden) {
    return (0, _appendVendorPrefix2.default)({
      margin: 0,
      opacity: 0,
      animationDuration: (willHidden ? hideAnimation : showAnimation).animationDuration,
      animationFillMode: 'forwards',
      animationDelay: '0.25s',
      animationName: showContentAnimation,
      animationTimingFunction: (willHidden ? hideAnimation : showAnimation).animationTimingFunction
    });
  }
});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(33);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(10);
var core = __webpack_require__(105);
var fails = __webpack_require__(31);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(106);
var IObject = __webpack_require__(228);
var toObject = __webpack_require__(54);
var toLength = __webpack_require__(46);
var asc = __webpack_require__(375);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.getTruncatedString = getTruncatedString;
exports.capitalizeWord = capitalizeWord;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTruncatedString(options) {
  var val = options.val,
      len = options.len,
      appendClosingQuote = options.appendClosingQuote;
  // enforce valid inputs

  if (typeof val === 'number' || (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' || typeof val === 'function' || typeof len !== 'number') {
    return '';
  }

  var truncatedString = val || '';
  return truncatedString.length < len + 1 ? truncatedString : appendClosingQuote ? truncatedString.substring(0, len - 1) + ' ..."' : truncatedString.substring(0, len - 1) + ' ...';
}

function capitalizeWord(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resourceHasQMSpecificInfo = exports.getViewResourceIcon = exports.getYoutubeTimeValueForEndpoint = exports.preventUnwantedNumberKeys = exports.validateSecondsInput = exports.convertMinutesAndSecondsToSeconds = exports.isYoutubeLink = exports.ResourceIncomplete = undefined;

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.isResourceComplete = isResourceComplete;
exports.mapResources = mapResources;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(20);

var _ErrorText = __webpack_require__(304);

var _ErrorText2 = _interopRequireDefault(_ErrorText);

var _Styled = __webpack_require__(1064);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isResourceComplete(resource) {
  var incomplete = false;
  if ((0, _index.isNullOrEmpty)(resource.name) || !resource.url && !resource.file_name && !resource.file) {
    incomplete = true;
  }

  if (resource.file_name && resource.file_name.length > 0 && !resource.license_citation && !resource.license_id) {
    incomplete = true;
  }

  return !incomplete;
}

function mapResources(resources) {
  return resources.map(function (r) {
    return (0, _assign2.default)({}, r, {
      isResourceIncomplete: !isResourceComplete(r)
    });
  });
}

var ResourceIncomplete = exports.ResourceIncomplete = function ResourceIncomplete() {
  return _react2.default.createElement(
    _ErrorText2.default,
    { style: { marginTop: '10px' } },
    '\u25CB \xA0Resource Incomplete'
  );
};

var isYoutubeLink = exports.isYoutubeLink = function isYoutubeLink(link, type) {
  return type === 'video' && Boolean(link) && link.length > 0 && (link.includes('.youtube.') || link.includes('youtu.be'));
};

var convertMinutesAndSecondsToSeconds = exports.convertMinutesAndSecondsToSeconds = function convertMinutesAndSecondsToSeconds(minutes, seconds) {
  return (parseInt(minutes) || 0) * 60 + (parseInt(seconds) || 0);
};

var validateSecondsInput = exports.validateSecondsInput = function validateSecondsInput(e) {
  if (e.target.value.length > e.target.max.length) {
    // If the value has more digits than the max, only use the first two digits
    e.target.value = e.target.value.slice(0, 2);
  } else if (parseInt(e.target.value) > parseInt(e.target.max)) {
    // if the value is greater than the max, only use the first digit ie prevent more digits
    e.target.value = e.target.value.slice(0, 1);
  }
};

var preventUnwantedNumberKeys = exports.preventUnwantedNumberKeys = function preventUnwantedNumberKeys(e) {
  // prevent alpha/non-numeric keys
  if (!parseInt(e.key) && (
  // allow 0, but don't allow ")"
  e.keyCode !== 48 || e.key === ')') &&
  // allow backspace
  e.keyCode !== 8 &&
  // allow tab
  e.keyCode !== 9 &&
  // allow arrow left
  e.keyCode !== 37 &&
  // allow arrow right
  e.keyCode !== 39 &&
  // allow 0 on numpad
  e.keyCode !== 96) {
    e.preventDefault();
  }
};

var getYoutubeTimeValueForEndpoint = exports.getYoutubeTimeValueForEndpoint = function getYoutubeTimeValueForEndpoint(minutes, seconds, url, type) {
  if (isYoutubeLink(url, type) && !((0, _index.isNullOrEmpty)(minutes) && (0, _index.isNullOrEmpty)(seconds))) {
    return convertMinutesAndSecondsToSeconds(minutes, seconds);
  }
  return null;
};

var getViewResourceIcon = exports.getViewResourceIcon = function getViewResourceIcon(type) {
  var retVal = null;
  switch (type) {
    case 'web':
      {
        retVal = _react2.default.createElement(_Styled.WebIcon, null);
        break;
      }
    case 'video':
      {
        retVal = _react2.default.createElement(_Styled.VideoIcon, null);
        break;
      }
    case 'audio':
      {
        retVal = _react2.default.createElement(_Styled.AudioIcon, null);
        break;
      }
    case 'image':
      {
        retVal = _react2.default.createElement(_Styled.ImageIcon, null);
        break;
      }
    case 'game_app':
      {
        retVal = _react2.default.createElement(_Styled.AppIcon, null);
        break;
      }
    case 'document':
      {
        retVal = _react2.default.createElement(_Styled.DocumentIcon, null);
        break;
      }
    case 'presentation':
      {
        retVal = _react2.default.createElement(_Styled.PresentationIcon, null);
        break;
      }
    case 'simulation':
      {
        retVal = _react2.default.createElement(_Styled.SimulationIcon, null);
      }
  }
  return retVal;
};

var resourceHasQMSpecificInfo = exports.resourceHasQMSpecificInfo = function resourceHasQMSpecificInfo(resource) {
  return Boolean(resource.start_time || resource.end_time || resource.copyright_holder || resource.file_name && resource.license_citation || resource.content_warnings && (0, _keys2.default)(resource.content_warnings).length > 0);
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSinglePlayer;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(308);

var _utils = __webpack_require__(91);

var _Player = _interopRequireDefault(__webpack_require__(411));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);

function createSinglePlayer(activePlayer) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SinglePlayer, _Component);

    var _super = _createSuper(SinglePlayer);

    function SinglePlayer() {
      var _this;

      _classCallCheck(this, SinglePlayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

      _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
        if (!_this.player) return null;
        return _this.player.getDuration();
      });

      _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
        if (!_this.player) return null;
        return _this.player.getCurrentTime();
      });

      _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
        if (!_this.player) return null;
        return _this.player.getSecondsLoaded();
      });

      _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
        if (!_this.player) return null;
        return _this.player.getInternalPlayer(key);
      });

      _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
        if (!_this.player) return null;

        _this.player.seekTo(fraction, type);
      });

      _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
        _this.player = player;
      });

      return _this;
    }

    _createClass(SinglePlayer, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _utils.isEqual)(this.props, nextProps);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$config$file = this.config.file,
            forceVideo = _this$config$file.forceVideo,
            forceAudio = _this$config$file.forceAudio,
            forceHLS = _this$config$file.forceHLS,
            forceDASH = _this$config$file.forceDASH;
        var skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;

        if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
          return null;
        }

        var _this$props = this.props,
            style = _this$props.style,
            width = _this$props.width,
            height = _this$props.height,
            Wrapper = _this$props.wrapper;
        var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
        return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
          style: _objectSpread({}, style, {
            width: width,
            height: height
          })
        }, otherProps), /*#__PURE__*/_react["default"].createElement(_Player["default"], _extends({}, this.props, {
          ref: this.ref,
          activePlayer: activePlayer,
          config: this.config
        })));
      }
    }]);

    return SinglePlayer;
  }(_react.Component), _defineProperty(_class, "displayName", "".concat(activePlayer.displayName, "Player")), _defineProperty(_class, "propTypes", _props.propTypes), _defineProperty(_class, "defaultProps", _props.defaultProps), _defineProperty(_class, "canPlay", activePlayer.canPlay), _temp;
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputComponent = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  position: relative;\n'], ['\n  width: 100%;\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  padding-left: 3px;\n'], ['\n  color: ', ';\n  padding-left: 3px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n width: 98% !important;\n height: 42px !important;\n padding: 0 0 0 10px !important;\n color: ', ';\n'], ['\n width: 98% !important;\n height: 42px !important;\n padding: 0 0 0 10px !important;\n color: ', ';\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  margin: -108px 15px 0 15px;\n  color: ', ';\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 19px;\n'], ['\n  position: absolute;\n  margin: -108px 15px 0 15px;\n  color: ', ';\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 19px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-weight: 500;\n  margin-right: 5px;\n'], ['\n  color: ', ';\n  font-weight: 500;\n  margin-right: 5px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _InputHint = __webpack_require__(595);

var _InputHint2 = _interopRequireDefault(_InputHint);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TextInputComponent__InputContainer',
  componentId: 'kaug1l-0'
})(_templateObject);

var AsteriskSymbol = _styledComponents2.default.span.withConfig({
  displayName: 'TextInputComponent__AsteriskSymbol',
  componentId: 'kaug1l-1'
})(_templateObject2, _colors2.default.crimson);

var Input = _styledComponents2.default.input.withConfig({
  displayName: 'TextInputComponent__Input',
  componentId: 'kaug1l-2'
})(_templateObject3, function (props) {
  return props.textColor ? props.textColor : _colors2.default.black;
});

var Placeholder = _styledComponents2.default.p.withConfig({
  displayName: 'TextInputComponent__Placeholder',
  componentId: 'kaug1l-3'
})(_templateObject4, _colors2.default.black);

var ErrorHintSpan = _styledComponents2.default.span.withConfig({
  displayName: 'TextInputComponent__ErrorHintSpan',
  componentId: 'kaug1l-4'
})(_templateObject5, _colors2.default.crimson);

var TextInputComponent = exports.TextInputComponent = function TextInputComponent(_ref) {
  var title = _ref.title,
      placeholder = _ref.placeholder,
      hintText = _ref.hintText,
      handleEnteredTextValue = _ref.handleEnteredTextValue,
      value = _ref.value,
      shouldDisplayAsteriskSymbol = _ref.shouldDisplayAsteriskSymbol,
      shouldBeTextarea = _ref.shouldBeTextarea,
      handleStartEnteringTextValue = _ref.handleStartEnteringTextValue,
      textColor = _ref.textColor,
      isError = _ref.isError,
      errorMessage = _ref.errorMessage,
      options = _ref.options;


  return _react2.default.createElement(
    InputContainer,
    null,
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      title,
      shouldDisplayAsteriskSymbol && _react2.default.createElement(
        AsteriskSymbol,
        null,
        '*'
      )
    ),
    shouldBeTextarea ? _react2.default.createElement(
      'div',
      {
        className: 'course-builder-input-component',
        onClick: handleStartEnteringTextValue,
        style: { borderRadius: '5px' }
      },
      _react2.default.createElement(_reactSimplemdeEditor2.default, {
        value: value,
        options: options,
        onChange: handleEnteredTextValue
      })
    ) : _react2.default.createElement(Input, {
      placeholder: placeholder,
      type: 'text',
      name: title,
      onChange: handleEnteredTextValue,
      value: value,
      textColor: textColor
    }),
    _react2.default.createElement(
      _InputHint2.default,
      null,
      isError && _react2.default.createElement(
        ErrorHintSpan,
        null,
        errorMessage
      ),
      hintText
    )
  );
};

TextInputComponent.propTypes = {
  handleClick: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.string,
  shouldDisplayAsteriskSymbol: _propTypes2.default.bool.isRequired,
  isError: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string,
  options: _propTypes2.default.object
};

exports.default = TextInputComponent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var noop = function noop() {};

var _id = 0;

var generateId = function generateId() {
  return "simplemde-editor-".concat(++_id);
};

var SimpleMDEEditor =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SimpleMDEEditor, _React$PureComponent);

  function SimpleMDEEditor(props) {
    var _this;

    _classCallCheck(this, SimpleMDEEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleMDEEditor).call(this, props));
    _this.state = {
      keyChange: false,
      value: _this.props.value || ""
    };
    _this.id = _this.props.id ? _this.props.id : generateId();
    _this.simpleMde = null;
    _this.editorEl = null;
    _this.editorToolbarEl = null;

    _this.createEditor = function () {
      var SimpleMDE = __webpack_require__(1200);

      var initialOptions = {
        element: document.getElementById(_this.id),
        initialValue: _this.props.value
      };
      var allOptions = Object.assign({}, initialOptions, _this.props.options);
      _this.simpleMde = new SimpleMDE(allOptions);
    };

    _this.eventWrapper = function () {
      _this.setState({
        keyChange: true,
        value: _this.simpleMde.value()
      });

      _this.props.onChange(_this.simpleMde.value());
    };

    _this.removeEvents = function () {
      _this.editorEl.removeEventListener("keyup", _this.eventWrapper);

      _this.editorEl.removeEventListener("paste", _this.eventWrapper);

      _this.editorToolbarEl && _this.editorToolbarEl.removeEventListener("click", _this.eventWrapper);
    };

    _this.addEvents = function () {
      var wrapperId = "".concat(_this.id, "-wrapper");
      var wrapperEl = document.getElementById("".concat(wrapperId));
      _this.editorEl = wrapperEl.getElementsByClassName("CodeMirror")[0];
      _this.editorToolbarEl = wrapperEl.getElementsByClassName("editor-toolbar")[0];

      _this.editorEl.addEventListener("keyup", _this.eventWrapper);

      _this.editorEl.addEventListener("paste", _this.eventWrapper);

      _this.editorToolbarEl && _this.editorToolbarEl.addEventListener("click", _this.eventWrapper);

      _this.simpleMde.codemirror.on("cursorActivity", _this.getCursor);

      var events = _this.props.events; // Handle custom events

      events && Object.entries(events).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            eventName = _ref2[0],
            callback = _ref2[1];

        if (eventName && callback) {
          _this.simpleMde.codemirror.on(eventName, callback);
        }
      });
    };

    _this.getCursor = function () {
      // https://codemirror.net/doc/manual.html#api_selection
      if (_this.props.getLineAndCursor) {
        _this.props.getLineAndCursor(_this.simpleMde.codemirror.getCursor());
      }
    };

    _this.getMdeInstance = function () {
      if (_this.props.getMdeInstance) {
        _this.props.getMdeInstance(_this.simpleMde);
      }
    };

    _this.addExtraKeys = function () {
      // https://codemirror.net/doc/manual.html#option_extraKeys
      if (_this.props.extraKeys) {
        _this.simpleMde.codemirror.setOption("extraKeys", _this.props.extraKeys);
      }
    };

    return _this;
  }

  _createClass(SimpleMDEEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof window !== undefined) {
        this.createEditor();
        this.addEvents();
        this.addExtraKeys();
        this.getCursor();
        this.getMdeInstance();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.state.keyChange && this.props.value !== this.state.value && // This is somehow fixes moving cursor for controlled case
      this.props.value !== prevProps.value // This one fixes no value change for uncontrolled input. If it's uncontrolled prevProps will be the same
      ) {
          this.simpleMde.value(this.props.value || "");
        }

      this.setState({
        keyChange: false
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          events = _this$props.events,
          value = _this$props.value,
          options = _this$props.options,
          children = _this$props.children,
          extraKeys = _this$props.extraKeys,
          getLineAndCursor = _this$props.getLineAndCursor,
          getMdeInstance = _this$props.getMdeInstance,
          label = _this$props.label,
          onChange = _this$props.onChange,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["events", "value", "options", "children", "extraKeys", "getLineAndCursor", "getMdeInstance", "label", "onChange", "id"]);

      return React.createElement("div", Object.assign({
        id: "".concat(this.id, "-wrapper")
      }, rest), label && React.createElement("label", {
        htmlFor: this.id
      }, " ", label, " "), React.createElement("textarea", {
        id: this.id
      }));
    }
  }]);

  return SimpleMDEEditor;
}(React.PureComponent);

exports.default = SimpleMDEEditor;
SimpleMDEEditor.defaultProps = {
  events: {},
  onChange: noop,
  options: {}
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var CallbackQueue = __webpack_require__(608);
var PooledClass = __webpack_require__(187);
var ReactFeatureFlags = __webpack_require__(609);
var ReactReconciler = __webpack_require__(210);
var Transaction = __webpack_require__(316);

var invariant = __webpack_require__(28);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return easing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(11);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(119);
var IE8_DOM_DEFINE = __webpack_require__(486);
var toPrimitive = __webpack_require__(349);
var dP = Object.defineProperty;

exports.f = __webpack_require__(104) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(49)) {
  var LIBRARY = __webpack_require__(151);
  var global = __webpack_require__(29);
  var fails = __webpack_require__(31);
  var $export = __webpack_require__(10);
  var $typed = __webpack_require__(289);
  var $buffer = __webpack_require__(383);
  var ctx = __webpack_require__(106);
  var anInstance = __webpack_require__(179);
  var propertyDesc = __webpack_require__(172);
  var hide = __webpack_require__(87);
  var redefineAll = __webpack_require__(181);
  var toInteger = __webpack_require__(108);
  var toLength = __webpack_require__(46);
  var toIndex = __webpack_require__(524);
  var toAbsoluteIndex = __webpack_require__(175);
  var toPrimitive = __webpack_require__(120);
  var has = __webpack_require__(94);
  var classof = __webpack_require__(198);
  var isObject = __webpack_require__(33);
  var toObject = __webpack_require__(54);
  var isArrayIter = __webpack_require__(372);
  var create = __webpack_require__(176);
  var getPrototypeOf = __webpack_require__(97);
  var gOPN = __webpack_require__(177).f;
  var getIterFn = __webpack_require__(374);
  var uid = __webpack_require__(173);
  var wks = __webpack_require__(44);
  var createArrayMethod = __webpack_require__(123);
  var createArrayIncludes = __webpack_require__(279);
  var speciesConstructor = __webpack_require__(231);
  var ArrayIterators = __webpack_require__(377);
  var Iterators = __webpack_require__(200);
  var $iterDetect = __webpack_require__(284);
  var setSpecies = __webpack_require__(178);
  var arrayFill = __webpack_require__(376);
  var arrayCopyWithin = __webpack_require__(513);
  var $DP = __webpack_require__(51);
  var $GOPD = __webpack_require__(96);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(519);
var $export = __webpack_require__(10);
var shared = __webpack_require__(227)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(522))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_LOGGING_FAILURE = exports.POST_LOGGING_SUCCESS = exports.POST_LOGGING_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.postLoggingRequest = postLoggingRequest;
exports.postLoggingSuccess = postLoggingSuccess;
exports.postLoggingFailure = postLoggingFailure;
exports.postLoggingInfo = postLoggingInfo;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POST_LOGGING_REQUEST = exports.POST_LOGGING_REQUEST = 'POST_LOGGING_REQUEST';

var POST_LOGGING_SUCCESS = exports.POST_LOGGING_SUCCESS = 'POST_LOGGING_SUCCESS';
var POST_LOGGING_FAILURE = exports.POST_LOGGING_FAILURE = 'POST_LOGGING_FAILURE';

function postLoggingRequest() {
  return {
    type: POST_LOGGING_REQUEST
  };
}

function postLoggingSuccess() {
  return {
    type: POST_LOGGING_SUCCESS
  };
}

function postLoggingFailure(error) {
  return (0, _actions.getErrorAction)(POST_LOGGING_FAILURE, error);
}

function postLoggingInfo(collection, data) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, currentOrg, body;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              currentOrg = state.user.user.organizations.find(function (org) {
                return org.id === state.organization.orgId;
              });
              body = {
                application: 'QM',
                user: {
                  id: state.user.user.id,
                  roles: state.user.user.organization_roles,
                  name: state.user.user.name
                },
                organization: {
                  id: state.organization.orgId,
                  name: currentOrg ? currentOrg.name : null
                }
              };

              dispatch(postLoggingRequest());

              _context.prev = 4;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 8;
              return fetch('https://oe-log-service.herokuapp.com/api/projects/' + (0, _utils.getLoggingProjectId)() + '/events/' + collection, {
                method: 'POST',
                headers: {
                  Authorization: (0, _utils.getLoggingToken)(),
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify2.default)((0, _assign2.default)(body, data))
              });

            case 8:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(postLoggingSuccess());
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t2 = _context['catch'](4);

              dispatch(postLoggingFailure(_context.t2));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.questIsAssignedToUser = questIsAssignedToUser;
exports.questIsAssignedByUser = questIsAssignedByUser;
exports.userCanViewAssignmentMessage = userCanViewAssignmentMessage;
exports.questHasAssignment = questHasAssignment;

var _user = __webpack_require__(45);

function questIsAssignedToUser(quest, user) {
  return Boolean(quest.assigned_to) && quest.assigned_to.id === user.id;
}

function questIsAssignedByUser(quest, user) {
  return Boolean(quest.assigned_by) && quest.assigned_by.id === user.id;
}

function userCanViewAssignmentMessage(user, quest, organization) {
  return (0, _user.isQuestCopyEditorOrQuestAuthor)(user, quest, organization) || questIsAssignedToUser(quest, user) || questIsAssignedByUser(quest, user);
}

function questHasAssignment(quest) {
  return Boolean(quest.assigned_by);
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAvatar = function (_PureComponent) {
  (0, _inherits3.default)(UserAvatar, _PureComponent);

  function UserAvatar() {
    (0, _classCallCheck3.default)(this, UserAvatar);
    return (0, _possibleConstructorReturn3.default)(this, (UserAvatar.__proto__ || (0, _getPrototypeOf2.default)(UserAvatar)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          photoUrl = _props.photoUrl,
          wrapperClass = _props.wrapperClass,
          clickHandler = _props.clickHandler,
          name = _props.name;


      return _react2.default.createElement(
        'div',
        { className: wrapperClass || 'avatar' },
        _react2.default.createElement(
          'div',
          { className: 'user-photo-wrapper', onClick: clickHandler || undefined },
          _react2.default.createElement('img', { src: photoUrl, alt: name })
        )
      );
    }
  }]);
  return UserAvatar;
}(_react.PureComponent);

exports.default = UserAvatar;


UserAvatar.propTypes = {
  photoUrl: _propTypes2.default.string,
  wrapperClass: _propTypes2.default.string,
  clickHandler: _propTypes2.default.func,
  name: _propTypes2.default.string
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 5px !important;\n  width: 15px !important;\n  height: 15px !important;\n  position: relative !important;\n  top: 2px !important;\n'], ['\n  margin-left: 5px !important;\n  width: 15px !important;\n  height: 15px !important;\n  position: relative !important;\n  top: 2px !important;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon_certification_provisional = __webpack_require__(1129);

var _icon_certification_provisional2 = _interopRequireDefault(_icon_certification_provisional);

var _icon_certification_standard = __webpack_require__(1130);

var _icon_certification_standard2 = _interopRequireDefault(_icon_certification_standard);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProvisionalCertification = _styledComponents2.default.img.attrs({
  src: _icon_certification_provisional2.default
}).withConfig({
  displayName: 'UserName__ProvisionalCertification',
  componentId: 'sc-1ta79e1-0'
})(_templateObject);

var StandardCertification = _styledComponents2.default.img.attrs({
  src: _icon_certification_standard2.default
}).withConfig({
  displayName: 'UserName__StandardCertification',
  componentId: 'sc-1ta79e1-1'
})(_templateObject);

var UserName = function (_React$Component) {
  (0, _inherits3.default)(UserName, _React$Component);

  function UserName() {
    (0, _classCallCheck3.default)(this, UserName);
    return (0, _possibleConstructorReturn3.default)(this, (UserName.__proto__ || (0, _getPrototypeOf2.default)(UserName)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserName, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.rebuild && _reactTooltip2.default.rebuild();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeCertifications = _props.activeCertifications,
          children = _props.children,
          userId = _props.userId;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        children,
        activeCertifications.length > 0 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _reactTooltip2.default,
            {
              className: 'user-certification',
              id: userId + '-cert-tooltip',
              effect: 'solid'
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Certified'
              )
            ),
            (0, _user.getUserCertificationMarkerTooltipText)(activeCertifications)
          ),
          activeCertifications.some(function (c) {
            return c.level === 'standard';
          }) ? _react2.default.createElement(StandardCertification, {
            'data-for': userId + '-cert-tooltip',
            'data-tip': 'tip'
          }) : _react2.default.createElement(ProvisionalCertification, {
            'data-for': userId + '-cert-tooltip',
            'data-tip': 'tip'
          })
        )
      );
    }
  }]);
  return UserName;
}(_react2.default.Component);

UserName.propTypes = {
  children: _propTypes2.default.object.isRequired,
  activeCertifications: _propTypes2.default.array.isRequired,
  userId: _propTypes2.default.string.isRequired,
  rebuild: _propTypes2.default.bool
};

exports.default = UserName;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexAlignCenter = _styledComponents2.default.div.withConfig({
  displayName: 'FlexAlignCenter',
  componentId: 'z9mhq-0'
})(_templateObject);

exports.default = FlexAlignCenter;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var simpleMDEOptions = {
  autofocus: true,
  hideIcons: ['fullscreen', 'side-by-side', 'code', 'horizontal-rule', 'quote', 'heading', 'ordered-list'],
  status: false,
  placeholder: 'Type your comment here.'
};

var italicsOnlyMDEOptions = {
  hideIcons: ['fullscreen', 'side-by-side', 'code', 'horizontal-rule', 'quote', 'heading', 'ordered-list', 'bold', 'unordered-list', 'link', 'image'],
  status: false
};

var italicsAndBoldOnlyMDEOptions = {
  hideIcons: ['fullscreen', 'side-by-side', 'code', 'horizontal-rule', 'quote', 'heading', 'ordered-list', 'unordered-list', 'link', 'image', 'guide'],
  status: false
};

var excludeImageMDEOptions = {
  hideIcons: ['fullscreen', 'side-by-side', 'code', 'horizontal-rule', 'image'],
  status: false
};

exports.simpleMDEOptions = simpleMDEOptions;
exports.italicsOnlyMDEOptions = italicsOnlyMDEOptions;
exports.italicsAndBoldOnlyMDEOptions = italicsAndBoldOnlyMDEOptions;
exports.excludeImageMDEOptions = excludeImageMDEOptions;

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/types/monitors.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/types/options.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/types/connectors.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/types/index.js



// EXTERNAL MODULE: ./node_modules/react-dnd/dist/esm/core/DndContext.js
var DndContext = __webpack_require__(597);

// EXTERNAL MODULE: ./node_modules/react-dnd/dist/esm/core/DndProvider.js
var DndProvider = __webpack_require__(1223);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/core/DragPreviewImage.js

/**
 * A utility for rendering a drag preview image
 */

var DragPreviewImage_DragPreviewImage = Object(react["memo"])(function DragPreviewImage(_ref) {
  var connect = _ref.connect,
      src = _ref.src;
  Object(react["useEffect"])(function () {
    if (typeof Image === 'undefined') return;
    var connected = false;
    var img = new Image();
    img.src = src;

    img.onload = function () {
      connect(img);
      connected = true;
    };

    return function () {
      if (connected) {
        connect(null);
      }
    };
  });
  return null;
});
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/core/index.js



// EXTERNAL MODULE: ./node_modules/@react-dnd/invariant/dist/invariant.esm.js
var invariant_esm = __webpack_require__(56);

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/DragSourceMonitorImpl.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl_DragSourceMonitorImpl = /*#__PURE__*/function () {
  function DragSourceMonitorImpl(manager) {
    _classCallCheck(this, DragSourceMonitorImpl);

    _defineProperty(this, "internalMonitor", void 0);

    _defineProperty(this, "sourceId", null);

    this.internalMonitor = manager.getMonitor();
  }

  _createClass(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      Object(invariant_esm["a" /* invariant */])(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      Object(invariant_esm["a" /* invariant */])(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/DropTargetMonitorImpl.js
function DropTargetMonitorImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DropTargetMonitorImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DropTargetMonitorImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) DropTargetMonitorImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) DropTargetMonitorImpl__defineProperties(Constructor, staticProps); return Constructor; }

function DropTargetMonitorImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var isCallingCanDrop = false;
var DropTargetMonitorImpl_DropTargetMonitorImpl = /*#__PURE__*/function () {
  function DropTargetMonitorImpl(manager) {
    DropTargetMonitorImpl__classCallCheck(this, DropTargetMonitorImpl);

    DropTargetMonitorImpl__defineProperty(this, "internalMonitor", void 0);

    DropTargetMonitorImpl__defineProperty(this, "targetId", null);

    this.internalMonitor = manager.getMonitor();
  }

  DropTargetMonitorImpl__createClass(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      Object(invariant_esm["a" /* invariant */])(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/wrapConnectorHooks.js



function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!Object(react["isValidElement"])(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return cloneWithRef(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

function setRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  Object(invariant_esm["a" /* invariant */])(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return Object(react["cloneElement"])(element, {
      ref: newRef
    });
  } else {
    return Object(react["cloneElement"])(element, {
      ref: function ref(node) {
        setRef(previousRef, node);
        setRef(newRef, node);
      }
    });
  }
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/isRef.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current')
  );
}
// CONCATENATED MODULE: ./node_modules/@react-dnd/shallowequal/dist/shallowequal.esm.js
function shallowEqual(objA, objB, compare, compareContext) {
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (compareResult !== void 0) {
    return !!compareResult;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
}


//# sourceMappingURL=shallowequal.esm.js.map

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/SourceConnector.js
function SourceConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SourceConnector__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function SourceConnector__createClass(Constructor, protoProps, staticProps) { if (protoProps) SourceConnector__defineProperties(Constructor.prototype, protoProps); if (staticProps) SourceConnector__defineProperties(Constructor, staticProps); return Constructor; }

function SourceConnector__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var SourceConnector_SourceConnector = /*#__PURE__*/function () {
  // The drop target may either be attached via ref or connect function
  // The drag preview may either be attached via ref or connect function
  function SourceConnector(backend) {
    var _this = this;

    SourceConnector__classCallCheck(this, SourceConnector);

    SourceConnector__defineProperty(this, "hooks", wrapConnectorHooks({
      dragSource: function dragSource(node, options) {
        _this.clearDragSource();

        _this.dragSourceOptions = options || null;

        if (isRef(node)) {
          _this.dragSourceRef = node;
        } else {
          _this.dragSourceNode = node;
        }

        _this.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this.clearDragPreview();

        _this.dragPreviewOptions = options || null;

        if (isRef(node)) {
          _this.dragPreviewRef = node;
        } else {
          _this.dragPreviewNode = node;
        }

        _this.reconnectDragPreview();
      }
    }));

    SourceConnector__defineProperty(this, "handlerId", null);

    SourceConnector__defineProperty(this, "dragSourceRef", null);

    SourceConnector__defineProperty(this, "dragSourceNode", void 0);

    SourceConnector__defineProperty(this, "dragSourceOptionsInternal", null);

    SourceConnector__defineProperty(this, "dragSourceUnsubscribe", void 0);

    SourceConnector__defineProperty(this, "dragPreviewRef", null);

    SourceConnector__defineProperty(this, "dragPreviewNode", void 0);

    SourceConnector__defineProperty(this, "dragPreviewOptionsInternal", null);

    SourceConnector__defineProperty(this, "dragPreviewUnsubscribe", void 0);

    SourceConnector__defineProperty(this, "lastConnectedHandlerId", null);

    SourceConnector__defineProperty(this, "lastConnectedDragSource", null);

    SourceConnector__defineProperty(this, "lastConnectedDragSourceOptions", null);

    SourceConnector__defineProperty(this, "lastConnectedDragPreview", null);

    SourceConnector__defineProperty(this, "lastConnectedDragPreviewOptions", null);

    SourceConnector__defineProperty(this, "backend", void 0);

    this.backend = backend;
  }

  SourceConnector__createClass(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (didChange) {
        this.disconnectDragPreview();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragPreview) {
        this.lastConnectedDragPreview = dragPreview;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }, {
    key: "clearDragSource",
    value: function clearDragSource() {
      this.dragSourceNode = null;
      this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function clearDragPreview() {
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }]);

  return SourceConnector;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/TargetConnector.js
function TargetConnector__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TargetConnector__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function TargetConnector__createClass(Constructor, protoProps, staticProps) { if (protoProps) TargetConnector__defineProperties(Constructor.prototype, protoProps); if (staticProps) TargetConnector__defineProperties(Constructor, staticProps); return Constructor; }

function TargetConnector__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TargetConnector_TargetConnector = /*#__PURE__*/function () {
  // The drop target may either be attached via ref or connect function
  function TargetConnector(backend) {
    var _this = this;

    TargetConnector__classCallCheck(this, TargetConnector);

    TargetConnector__defineProperty(this, "hooks", wrapConnectorHooks({
      dropTarget: function dropTarget(node, options) {
        _this.clearDropTarget();

        _this.dropTargetOptions = options;

        if (isRef(node)) {
          _this.dropTargetRef = node;
        } else {
          _this.dropTargetNode = node;
        }

        _this.reconnect();
      }
    }));

    TargetConnector__defineProperty(this, "handlerId", null);

    TargetConnector__defineProperty(this, "dropTargetRef", null);

    TargetConnector__defineProperty(this, "dropTargetNode", void 0);

    TargetConnector__defineProperty(this, "dropTargetOptionsInternal", null);

    TargetConnector__defineProperty(this, "unsubscribeDropTarget", void 0);

    TargetConnector__defineProperty(this, "lastConnectedHandlerId", null);

    TargetConnector__defineProperty(this, "lastConnectedDropTarget", null);

    TargetConnector__defineProperty(this, "lastConnectedDropTargetOptions", null);

    TargetConnector__defineProperty(this, "backend", void 0);

    this.backend = backend;
  }

  TargetConnector__createClass(TargetConnector, [{
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }, {
    key: "clearDropTarget",
    value: function clearDropTarget() {
      this.dropTargetRef = null;
      this.dropTargetNode = null;
    }
  }]);

  return TargetConnector;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/registration.js
function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/internals/index.js





// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/utils.js
function utils__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { utils__typeof = function _typeof(obj) { return typeof obj; }; } else { utils__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return utils__typeof(obj); }

function getDecoratedComponent(instanceRef) {
  var currentRef = instanceRef.current;

  if (currentRef == null) {
    return null;
  } else if (currentRef.decoratedRef) {
    // go through the private field in decorateHandler to avoid the invariant hit
    return currentRef.decoratedRef.current;
  } else {
    return currentRef;
  }
}
function isClassComponent(Component) {
  return Component && Component.prototype && typeof Component.prototype.render === 'function';
}
function isRefForwardingComponent(C) {
  var _item$$$typeof;

  var item = C;
  return (item === null || item === void 0 ? void 0 : (_item$$$typeof = item.$$typeof) === null || _item$$$typeof === void 0 ? void 0 : _item$$$typeof.toString()) === 'Symbol(react.forward_ref)';
}
function isRefable(C) {
  return isClassComponent(C) || isRefForwardingComponent(C);
}
function checkDecoratorArguments(functionName, signature) {
  if (false) {
    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i++) {
      var arg = i + 2 < 2 || arguments.length <= i + 2 ? undefined : arguments[i + 2];

      if (arg && arg.prototype && arg.prototype.render) {
        // eslint-disable-next-line no-console
        console.error('You seem to be applying the arguments in the wrong order. ' + "It should be ".concat(functionName, "(").concat(signature, ")(Component), not the other way around. ") + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
        return;
      }
    }
  }
}
function isFunction(input) {
  return typeof input === 'function';
}
function noop() {// noop
}

function isObjectLike(input) {
  return utils__typeof(input) === 'object' && input !== null;
}

function utils_isPlainObject(input) {
  if (!isObjectLike(input)) {
    return false;
  }

  if (Object.getPrototypeOf(input) === null) {
    return true;
  }

  var proto = input;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(input) === proto;
}
function isValidType(type, allowArray) {
  return typeof type === 'string' || utils__typeof(type) === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
    return isValidType(t, false);
  });
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(415);
var jsx_runtime_default = /*#__PURE__*/__webpack_require__.n(jsx_runtime);

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/disposables.js
function disposables__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function disposables__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function disposables__createClass(Constructor, protoProps, staticProps) { if (protoProps) disposables__defineProperties(Constructor.prototype, protoProps); if (staticProps) disposables__defineProperties(Constructor, staticProps); return Constructor; }

function disposables__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Provides a set of static methods for creating Disposables.
 * @param {Function} action Action to run during the first call to dispose.
 * The action is guaranteed to be run at most once.
 */

var disposables_Disposable = /*#__PURE__*/function () {
  function Disposable(action) {
    disposables__classCallCheck(this, Disposable);

    disposables__defineProperty(this, "isDisposed", false);

    disposables__defineProperty(this, "action", void 0);

    this.action = isFunction(action) ? action : noop;
  }
  /** Performs the task of cleaning up resources. */


  disposables__createClass(Disposable, [{
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.action();
        this.isDisposed = true;
      }
    }
  }], [{
    key: "isDisposable",
    value:
    /**
     * Gets the disposable that does nothing when disposed.
     */

    /**
     * Validates whether the given object is a disposable
     * @param {Object} Object to test whether it has a dispose method
     * @returns {Boolean} true if a disposable object, else false.
     */
    function isDisposable(d) {
      return Boolean(d && isFunction(d.dispose));
    }
  }, {
    key: "_fixup",
    value: function _fixup(result) {
      return Disposable.isDisposable(result) ? result : Disposable.empty;
    }
    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose.
     * The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */

  }, {
    key: "create",
    value: function create(action) {
      return new Disposable(action);
    }
  }]);

  return Disposable;
}();
/**
 * Represents a group of disposable resources that are disposed together.
 * @constructor
 */

disposables__defineProperty(disposables_Disposable, "empty", {
  dispose: noop
});

var CompositeDisposable = /*#__PURE__*/function () {
  function CompositeDisposable() {
    disposables__classCallCheck(this, CompositeDisposable);

    disposables__defineProperty(this, "isDisposed", false);

    disposables__defineProperty(this, "disposables", void 0);

    for (var _len = arguments.length, disposables = new Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    this.disposables = disposables;
  }
  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Any} item Disposable to add.
   */


  disposables__createClass(CompositeDisposable, [{
    key: "add",
    value: function add(item) {
      if (this.isDisposed) {
        item.dispose();
      } else {
        this.disposables.push(item);
      }
    }
    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Any} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */

  }, {
    key: "remove",
    value: function remove(item) {
      var shouldDispose = false;

      if (!this.isDisposed) {
        var idx = this.disposables.indexOf(item);

        if (idx !== -1) {
          shouldDispose = true;
          this.disposables.splice(idx, 1);
          item.dispose();
        }
      }

      return shouldDispose;
    }
    /**
     *  Disposes all disposables in the group and removes them from the group but
     *  does not dispose the CompositeDisposable.
     */

  }, {
    key: "clear",
    value: function clear() {
      if (!this.isDisposed) {
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var _i = 0; _i < len; _i++) {
          currentDisposables[_i].dispose();
        }
      }
    }
    /**
     *  Disposes all disposables in the group and removes them from the group.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var len = this.disposables.length;
        var currentDisposables = new Array(len);

        for (var i = 0; i < len; i++) {
          currentDisposables[i] = this.disposables[i];
        }

        this.disposables = [];

        for (var _i2 = 0; _i2 < len; _i2++) {
          currentDisposables[_i2].dispose();
        }
      }
    }
  }]);

  return CompositeDisposable;
}();
/**
 * Represents a disposable resource whose underlying disposable resource can
 * be replaced by another disposable resource, causing automatic disposal of
 * the previous underlying disposable resource.
 */

var SerialDisposable = /*#__PURE__*/function () {
  function SerialDisposable() {
    disposables__classCallCheck(this, SerialDisposable);

    disposables__defineProperty(this, "isDisposed", false);

    disposables__defineProperty(this, "current", void 0);
  }

  disposables__createClass(SerialDisposable, [{
    key: "getDisposable",
    value:
    /**
     * Gets the underlying disposable.
     * @returns {Any} the underlying disposable.
     */
    function getDisposable() {
      return this.current;
    }
  }, {
    key: "setDisposable",
    value: function setDisposable(value) {
      var shouldDispose = this.isDisposed;

      if (!shouldDispose) {
        var old = this.current;
        this.current = value;

        if (old) {
          old.dispose();
        }
      }

      if (shouldDispose && value) {
        value.dispose();
      }
    }
    /** Performs the task of cleaning up resources. */

  }, {
    key: "dispose",
    value: function dispose() {
      if (!this.isDisposed) {
        this.isDisposed = true;
        var old = this.current;
        this.current = undefined;

        if (old) {
          old.dispose();
        }
      }
    }
  }]);

  return SerialDisposable;
}();
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(136);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/decorateHandler.js
function decorateHandler__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { decorateHandler__typeof = function _typeof(obj) { return typeof obj; }; } else { decorateHandler__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return decorateHandler__typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function decorateHandler__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function decorateHandler__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function decorateHandler__createClass(Constructor, protoProps, staticProps) { if (protoProps) decorateHandler__defineProperties(Constructor.prototype, protoProps); if (staticProps) decorateHandler__defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (decorateHandler__typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function decorateHandler__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function decorateHandler(_ref) {
  var DecoratedComponent = _ref.DecoratedComponent,
      createHandler = _ref.createHandler,
      createMonitor = _ref.createMonitor,
      createConnector = _ref.createConnector,
      registerHandler = _ref.registerHandler,
      containerDisplayName = _ref.containerDisplayName,
      getType = _ref.getType,
      collect = _ref.collect,
      options = _ref.options;
  var _options$arePropsEqua = options.arePropsEqual,
      arePropsEqual = _options$arePropsEqua === void 0 ? shallowEqual : _options$arePropsEqua;
  var Decorated = DecoratedComponent;
  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

  var DragDropContainer = /*#__PURE__*/function (_Component) {
    _inherits(DragDropContainer, _Component);

    var _super = _createSuper(DragDropContainer);

    function DragDropContainer(props) {
      var _this;

      decorateHandler__classCallCheck(this, DragDropContainer);

      _this = _super.call(this, props);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "decoratedRef", Object(react["createRef"])());

      decorateHandler__defineProperty(_assertThisInitialized(_this), "handlerId", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "manager", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "handlerMonitor", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "handlerConnector", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "handler", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "disposable", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "currentType", void 0);

      decorateHandler__defineProperty(_assertThisInitialized(_this), "handleChange", function () {
        var nextState = _this.getCurrentState();

        if (!shallowEqual(nextState, _this.state)) {
          _this.setState(nextState);
        }
      });

      _this.disposable = new SerialDisposable();

      _this.receiveProps(props);

      _this.dispose();

      return _this;
    }

    decorateHandler__createClass(DragDropContainer, [{
      key: "getHandlerId",
      value: function getHandlerId() {
        return this.handlerId;
      }
    }, {
      key: "getDecoratedComponentInstance",
      value: function getDecoratedComponentInstance() {
        Object(invariant_esm["a" /* invariant */])(this.decoratedRef.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
        return this.decoratedRef.current;
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps, nextState) {
        return !arePropsEqual(nextProps, this.props) || !shallowEqual(nextState, this.state);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.disposable = new SerialDisposable();
        this.currentType = undefined;
        this.receiveProps(this.props);
        this.handleChange();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (!arePropsEqual(this.props, prevProps)) {
          this.receiveProps(this.props);
          this.handleChange();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.dispose();
      }
    }, {
      key: "receiveProps",
      value: function receiveProps(props) {
        if (!this.handler) {
          return;
        }

        this.handler.receiveProps(props);
        this.receiveType(getType(props));
      }
    }, {
      key: "receiveType",
      value: function receiveType(type) {
        if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
          return;
        }

        if (type === this.currentType) {
          return;
        }

        this.currentType = type;

        var _registerHandler = registerHandler(type, this.handler, this.manager),
            _registerHandler2 = _slicedToArray(_registerHandler, 2),
            handlerId = _registerHandler2[0],
            unregister = _registerHandler2[1];

        this.handlerId = handlerId;
        this.handlerMonitor.receiveHandlerId(handlerId);
        this.handlerConnector.receiveHandlerId(handlerId);
        var globalMonitor = this.manager.getMonitor();
        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
          handlerIds: [handlerId]
        });
        this.disposable.setDisposable(new CompositeDisposable(new disposables_Disposable(unsubscribe), new disposables_Disposable(unregister)));
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.disposable.dispose();

        if (this.handlerConnector) {
          this.handlerConnector.receiveHandlerId(null);
        }
      }
    }, {
      key: "getCurrentState",
      value: function getCurrentState() {
        if (!this.handlerConnector) {
          return {};
        }

        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);

        if (false) {
          invariant(isPlainObject(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
        }

        return nextState;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return Object(jsx_runtime["jsx"])(DndContext["a" /* DndContext */].Consumer, {
          children: function children(_ref2) {
            var dragDropManager = _ref2.dragDropManager;

            _this2.receiveDragDropManager(dragDropManager);

            if (typeof requestAnimationFrame !== 'undefined') {
              requestAnimationFrame(function () {
                var _this2$handlerConnect;

                return (_this2$handlerConnect = _this2.handlerConnector) === null || _this2$handlerConnect === void 0 ? void 0 : _this2$handlerConnect.reconnect();
              });
            }

            return Object(jsx_runtime["jsx"])(Decorated, Object.assign({}, _this2.props, _this2.getCurrentState(), {
              // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
              ref: isRefable(Decorated) ? _this2.decoratedRef : null
            }), void 0);
          }
        }, void 0);
      }
    }, {
      key: "receiveDragDropManager",
      value: function receiveDragDropManager(dragDropManager) {
        if (this.manager !== undefined) {
          return;
        }

        Object(invariant_esm["a" /* invariant */])(dragDropManager !== undefined, 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

        if (dragDropManager === undefined) {
          return;
        }

        this.manager = dragDropManager;
        this.handlerMonitor = createMonitor(dragDropManager);
        this.handlerConnector = createConnector(dragDropManager.getBackend());
        this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
      }
    }]);

    return DragDropContainer;
  }(react["Component"]);

  decorateHandler__defineProperty(DragDropContainer, "DecoratedComponent", DecoratedComponent);

  decorateHandler__defineProperty(DragDropContainer, "displayName", "".concat(containerDisplayName, "(").concat(displayName, ")"));

  return hoist_non_react_statics_cjs_default()(DragDropContainer, DecoratedComponent);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/createSourceFactory.js
function createSourceFactory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createSourceFactory__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function createSourceFactory__createClass(Constructor, protoProps, staticProps) { if (protoProps) createSourceFactory__defineProperties(Constructor.prototype, protoProps); if (staticProps) createSourceFactory__defineProperties(Constructor, staticProps); return Constructor; }

function createSourceFactory__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

var createSourceFactory_SourceImpl = /*#__PURE__*/function () {
  function SourceImpl(spec, monitor, ref) {
    var _this = this;

    createSourceFactory__classCallCheck(this, SourceImpl);

    createSourceFactory__defineProperty(this, "props", null);

    createSourceFactory__defineProperty(this, "spec", void 0);

    createSourceFactory__defineProperty(this, "monitor", void 0);

    createSourceFactory__defineProperty(this, "ref", void 0);

    createSourceFactory__defineProperty(this, "beginDrag", function () {
      if (!_this.props) {
        return;
      }

      var item = _this.spec.beginDrag(_this.props, _this.monitor, _this.ref.current);

      if (false) {
        invariant(isPlainObject(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', item);
      }

      return item;
    });

    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
  }

  createSourceFactory__createClass(SourceImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      if (!this.props) {
        return false;
      }

      if (!this.spec.canDrag) {
        return true;
      }

      return this.spec.canDrag(this.props, this.monitor);
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, sourceId) {
      if (!this.props) {
        return false;
      }

      if (!this.spec.isDragging) {
        return sourceId === globalMonitor.getSourceId();
      }

      return this.spec.isDragging(this.props, this.monitor);
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      if (!this.props) {
        return;
      }

      if (!this.spec.endDrag) {
        return;
      }

      this.spec.endDrag(this.props, this.monitor, getDecoratedComponent(this.ref));
    }
  }]);

  return SourceImpl;
}();

function createSourceFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    Object(invariant_esm["a" /* invariant */])(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', ALLOWED_SPEC_METHODS.join(', '), key);
    Object(invariant_esm["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  REQUIRED_SPEC_METHODS.forEach(function (key) {
    Object(invariant_esm["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
  });
  return function createSource(monitor, ref) {
    return new createSourceFactory_SourceImpl(spec, monitor, ref);
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/DragSource.js





/**
 * Decorates a component as a dragsource
 * @param type The dragsource type
 * @param spec The drag source specification
 * @param collect The props collector function
 * @param options DnD options
 */

function DragSource(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  checkDecoratorArguments('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    Object(invariant_esm["a" /* invariant */])(isValidType(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);

    getType = function getType() {
      return type;
    };
  }

  Object(invariant_esm["a" /* invariant */])(utils_isPlainObject(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
  var createSource = createSourceFactory(spec);
  Object(invariant_esm["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  Object(invariant_esm["a" /* invariant */])(utils_isPlainObject(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
  return function decorateSource(DecoratedComponent) {
    return decorateHandler({
      containerDisplayName: 'DragSource',
      createHandler: createSource,
      registerHandler: registerSource,
      createConnector: function createConnector(backend) {
        return new SourceConnector_SourceConnector(backend);
      },
      createMonitor: function createMonitor(manager) {
        return new DragSourceMonitorImpl_DragSourceMonitorImpl(manager);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/createTargetFactory.js
function createTargetFactory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createTargetFactory__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function createTargetFactory__createClass(Constructor, protoProps, staticProps) { if (protoProps) createTargetFactory__defineProperties(Constructor.prototype, protoProps); if (staticProps) createTargetFactory__defineProperties(Constructor, staticProps); return Constructor; }

function createTargetFactory__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var createTargetFactory_ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

var createTargetFactory_TargetImpl = /*#__PURE__*/function () {
  function TargetImpl(spec, monitor, ref) {
    createTargetFactory__classCallCheck(this, TargetImpl);

    createTargetFactory__defineProperty(this, "props", null);

    createTargetFactory__defineProperty(this, "spec", void 0);

    createTargetFactory__defineProperty(this, "monitor", void 0);

    createTargetFactory__defineProperty(this, "ref", void 0);

    this.spec = spec;
    this.monitor = monitor;
    this.ref = ref;
  }

  createTargetFactory__createClass(TargetImpl, [{
    key: "receiveProps",
    value: function receiveProps(props) {
      this.props = props;
    }
  }, {
    key: "receiveMonitor",
    value: function receiveMonitor(monitor) {
      this.monitor = monitor;
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      if (!this.spec.canDrop) {
        return true;
      }

      return this.spec.canDrop(this.props, this.monitor);
    }
  }, {
    key: "hover",
    value: function hover() {
      if (!this.spec.hover || !this.props) {
        return;
      }

      this.spec.hover(this.props, this.monitor, getDecoratedComponent(this.ref));
    }
  }, {
    key: "drop",
    value: function drop() {
      if (!this.spec.drop) {
        return undefined;
      }

      var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);

      if (false) {
        invariant(typeof dropResult === 'undefined' || isPlainObject(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
      }

      return dropResult;
    }
  }]);

  return TargetImpl;
}();

function createTargetFactory(spec) {
  Object.keys(spec).forEach(function (key) {
    Object(invariant_esm["a" /* invariant */])(createTargetFactory_ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', createTargetFactory_ALLOWED_SPEC_METHODS.join(', '), key);
    Object(invariant_esm["a" /* invariant */])(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
  });
  return function createTarget(monitor, ref) {
    return new createTargetFactory_TargetImpl(spec, monitor, ref);
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/DropTarget.js






/**
 * @param type The accepted target type
 * @param spec The DropTarget specification
 * @param collect The props collector function
 * @param options Options
 */

function DropTarget(type, spec, collect) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  checkDecoratorArguments('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
  var getType = type;

  if (typeof type !== 'function') {
    Object(invariant_esm["a" /* invariant */])(isValidType(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);

    getType = function getType() {
      return type;
    };
  }

  Object(invariant_esm["a" /* invariant */])(utils_isPlainObject(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
  var createTarget = createTargetFactory(spec);
  Object(invariant_esm["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  Object(invariant_esm["a" /* invariant */])(utils_isPlainObject(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
  return function decorateTarget(DecoratedComponent) {
    return decorateHandler({
      containerDisplayName: 'DropTarget',
      createHandler: createTarget,
      registerHandler: registerTarget,
      createMonitor: function createMonitor(manager) {
        return new DropTargetMonitorImpl_DropTargetMonitorImpl(manager);
      },
      createConnector: function createConnector(backend) {
        return new TargetConnector_TargetConnector(backend);
      },
      DecoratedComponent: DecoratedComponent,
      getType: getType,
      collect: collect,
      options: options
    });
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/DragLayer.js
function DragLayer__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DragLayer__typeof = function _typeof(obj) { return typeof obj; }; } else { DragLayer__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DragLayer__typeof(obj); }

function DragLayer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DragLayer__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DragLayer__createClass(Constructor, protoProps, staticProps) { if (protoProps) DragLayer__defineProperties(Constructor.prototype, protoProps); if (staticProps) DragLayer__defineProperties(Constructor, staticProps); return Constructor; }

function DragLayer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) DragLayer__setPrototypeOf(subClass, superClass); }

function DragLayer__setPrototypeOf(o, p) { DragLayer__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return DragLayer__setPrototypeOf(o, p); }

function DragLayer__createSuper(Derived) { var hasNativeReflectConstruct = DragLayer__isNativeReflectConstruct(); return function _createSuperInternal() { var Super = DragLayer__getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = DragLayer__getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return DragLayer__possibleConstructorReturn(this, result); }; }

function DragLayer__possibleConstructorReturn(self, call) { if (call && (DragLayer__typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return DragLayer__assertThisInitialized(self); }

function DragLayer__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function DragLayer__isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function DragLayer__getPrototypeOf(o) { DragLayer__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return DragLayer__getPrototypeOf(o); }

function DragLayer__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/**
 * @param collect The props collector function
 * @param options The DnD options
 */

function DragLayer(collect) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  checkDecoratorArguments('DragLayer', 'collect[, options]', collect, options);
  Object(invariant_esm["a" /* invariant */])(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', collect);
  Object(invariant_esm["a" /* invariant */])(utils_isPlainObject(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
  return function decorateLayer(DecoratedComponent) {
    var Decorated = DecoratedComponent;
    var _options$arePropsEqua = options.arePropsEqual,
        arePropsEqual = _options$arePropsEqua === void 0 ? shallowEqual : _options$arePropsEqua;
    var displayName = Decorated.displayName || Decorated.name || 'Component';

    var DragLayerContainer = /*#__PURE__*/function (_Component) {
      DragLayer__inherits(DragLayerContainer, _Component);

      var _super = DragLayer__createSuper(DragLayerContainer);

      function DragLayerContainer() {
        var _this;

        DragLayer__classCallCheck(this, DragLayerContainer);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "manager", void 0);

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "isCurrentlyMounted", false);

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "unsubscribeFromOffsetChange", void 0);

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "unsubscribeFromStateChange", void 0);

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "ref", Object(react["createRef"])());

        DragLayer__defineProperty(DragLayer__assertThisInitialized(_this), "handleChange", function () {
          if (!_this.isCurrentlyMounted) {
            return;
          }

          var nextState = _this.getCurrentState();

          if (!shallowEqual(nextState, _this.state)) {
            _this.setState(nextState);
          }
        });

        return _this;
      }

      DragLayer__createClass(DragLayerContainer, [{
        key: "getDecoratedComponentInstance",
        value: function getDecoratedComponentInstance() {
          Object(invariant_esm["a" /* invariant */])(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
          return this.ref.current;
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !arePropsEqual(nextProps, this.props) || !shallowEqual(nextState, this.state);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.isCurrentlyMounted = true;
          this.handleChange();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isCurrentlyMounted = false;

          if (this.unsubscribeFromOffsetChange) {
            this.unsubscribeFromOffsetChange();
            this.unsubscribeFromOffsetChange = undefined;
          }

          if (this.unsubscribeFromStateChange) {
            this.unsubscribeFromStateChange();
            this.unsubscribeFromStateChange = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          return Object(jsx_runtime["jsx"])(DndContext["a" /* DndContext */].Consumer, {
            children: function children(_ref) {
              var dragDropManager = _ref.dragDropManager;

              if (dragDropManager === undefined) {
                return null;
              }

              _this2.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state


              if (!_this2.isCurrentlyMounted) {
                return null;
              }

              return Object(jsx_runtime["jsx"])(Decorated, Object.assign({}, _this2.props, _this2.state, {
                ref: isRefable(Decorated) ? _this2.ref : null
              }), void 0);
            }
          }, void 0);
        }
      }, {
        key: "receiveDragDropManager",
        value: function receiveDragDropManager(dragDropManager) {
          if (this.manager !== undefined) {
            return;
          }

          this.manager = dragDropManager;
          Object(invariant_esm["a" /* invariant */])(DragLayer__typeof(dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
          var monitor = this.manager.getMonitor();
          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
        }
      }, {
        key: "getCurrentState",
        value: function getCurrentState() {
          if (!this.manager) {
            return {};
          }

          var monitor = this.manager.getMonitor();
          return collect(monitor, this.props);
        }
      }]);

      return DragLayerContainer;
    }(react["Component"]);

    DragLayer__defineProperty(DragLayerContainer, "displayName", "DragLayer(".concat(displayName, ")"));

    DragLayer__defineProperty(DragLayerContainer, "DecoratedComponent", DecoratedComponent);

    return hoist_non_react_statics_cjs_default()(DragLayerContainer, DecoratedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/types.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/decorators/index.js




// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useIsomorphicLayoutEffect.js
 // suppress the useLayoutEffect warning on server side.

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/DragSourceImpl.js
function DragSourceImpl__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { DragSourceImpl__typeof = function _typeof(obj) { return typeof obj; }; } else { DragSourceImpl__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return DragSourceImpl__typeof(obj); }

function DragSourceImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DragSourceImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DragSourceImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) DragSourceImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) DragSourceImpl__defineProperties(Constructor, staticProps); return Constructor; }

function DragSourceImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DragSourceImpl = /*#__PURE__*/function () {
  function DragSourceImpl(spec, monitor, connector) {
    DragSourceImpl__classCallCheck(this, DragSourceImpl);

    DragSourceImpl__defineProperty(this, "spec", void 0);

    DragSourceImpl__defineProperty(this, "monitor", void 0);

    DragSourceImpl__defineProperty(this, "connector", void 0);

    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }

  DragSourceImpl__createClass(DragSourceImpl, [{
    key: "beginDrag",
    value: function beginDrag() {
      var _result;

      var spec = this.spec;
      var monitor = this.monitor;
      var result = null;

      if (DragSourceImpl__typeof(spec.item) === 'object') {
        result = spec.item;
      } else if (typeof spec.item === 'function') {
        result = spec.item(monitor);
      } else {
        result = {};
      }

      return (_result = result) !== null && _result !== void 0 ? _result : null;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (typeof spec.canDrag === 'boolean') {
        return spec.canDrag;
      } else if (typeof spec.canDrag === 'function') {
        return spec.canDrag(monitor);
      } else {
        return true;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, target) {
      var spec = this.spec;
      var monitor = this.monitor;
      var isDragging = spec.isDragging;
      return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var connector = this.connector;
      var end = spec.end;

      if (end) {
        end(monitor.getItem(), monitor);
      }

      connector.reconnect();
    }
  }]);

  return DragSourceImpl;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSource.js


function useDragSource(spec, monitor, connector) {
  var handler = Object(react["useMemo"])(function () {
    return new DragSourceImpl(spec, monitor, connector);
  }, [monitor, connector]);
  Object(react["useEffect"])(function () {
    handler.spec = spec;
  }, [spec]);
  return handler;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDragDropManager.js



/**
 * A hook to retrieve the DragDropManager from Context
 */

function useDragDropManager() {
  var _useContext = Object(react["useContext"])(DndContext["a" /* DndContext */]),
      dragDropManager = _useContext.dragDropManager;

  Object(invariant_esm["a" /* invariant */])(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useDragType.js


function useDragType(spec) {
  return Object(react["useMemo"])(function () {
    var result = spec.type;
    Object(invariant_esm["a" /* invariant */])(result != null, 'spec.type must be defined');
    return result;
  }, [spec]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useRegisteredDragSource.js
function useRegisteredDragSource__slicedToArray(arr, i) { return useRegisteredDragSource__arrayWithHoles(arr) || useRegisteredDragSource__iterableToArrayLimit(arr, i) || useRegisteredDragSource__unsupportedIterableToArray(arr, i) || useRegisteredDragSource__nonIterableRest(); }

function useRegisteredDragSource__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useRegisteredDragSource__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useRegisteredDragSource__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRegisteredDragSource__arrayLikeToArray(o, minLen); }

function useRegisteredDragSource__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useRegisteredDragSource__iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useRegisteredDragSource__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






function useRegisteredDragSource(spec, monitor, connector) {
  var manager = useDragDropManager();
  var handler = useDragSource(spec, monitor, connector);
  var itemType = useDragType(spec);
  useIsomorphicLayoutEffect(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = registerSource(itemType, handler, manager),
          _registerSource2 = useRegisteredDragSource__slicedToArray(_registerSource, 2),
          handlerId = _registerSource2[0],
          unregister = _registerSource2[1];

      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
  }, [manager, monitor, connector, handler, itemType]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useOptionalFactory.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || useOptionalFactory__unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useOptionalFactory__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useOptionalFactory__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useOptionalFactory__arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return useOptionalFactory__arrayLikeToArray(arr); }

function useOptionalFactory__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


function useOptionalFactory(arg, deps) {
  var memoDeps = _toConsumableArray(deps || []);

  if (deps == null && typeof arg !== 'function') {
    memoDeps.push(arg);
  }

  return Object(react["useMemo"])(function () {
    return typeof arg === 'function' ? arg() : arg;
  }, memoDeps);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSourceMonitor.js



function useDragSourceMonitor() {
  var manager = useDragDropManager();
  return Object(react["useMemo"])(function () {
    return new DragSourceMonitorImpl_DragSourceMonitorImpl(manager);
  }, [manager]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useDragSourceConnector.js




function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
  var manager = useDragDropManager();
  var connector = Object(react["useMemo"])(function () {
    return new SourceConnector_SourceConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect(function () {
    connector.dragSourceOptions = dragSourceOptions || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDragSource();
    };
  }, [connector, dragSourceOptions]);
  useIsomorphicLayoutEffect(function () {
    connector.dragPreviewOptions = dragPreviewOptions || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDragPreview();
    };
  }, [connector, dragPreviewOptions]);
  return connector;
}
// EXTERNAL MODULE: ./node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(1227);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useCollector.js
function useCollector__slicedToArray(arr, i) { return useCollector__arrayWithHoles(arr) || useCollector__iterableToArrayLimit(arr, i) || useCollector__unsupportedIterableToArray(arr, i) || useCollector__nonIterableRest(); }

function useCollector__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useCollector__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useCollector__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useCollector__arrayLikeToArray(o, minLen); }

function useCollector__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useCollector__iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useCollector__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

function useCollector(monitor, collect, onUpdate) {
  var _useState = Object(react["useState"])(function () {
    return collect(monitor);
  }),
      _useState2 = useCollector__slicedToArray(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = Object(react["useCallback"])(function () {
    var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
    // include XYCoord objects that may be equivalent, but do not have instance equality.

    if (!fast_deep_equal_default()(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]); // update the collected properties after react renders.
  // Note that the "Dustbin Stress Test" fails if this is not
  // done when the component updates

  useIsomorphicLayoutEffect(updateCollected);
  return [collected, updateCollected];
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useMonitorOutput.js
function useMonitorOutput__slicedToArray(arr, i) { return useMonitorOutput__arrayWithHoles(arr) || useMonitorOutput__iterableToArrayLimit(arr, i) || useMonitorOutput__unsupportedIterableToArray(arr, i) || useMonitorOutput__nonIterableRest(); }

function useMonitorOutput__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useMonitorOutput__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useMonitorOutput__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useMonitorOutput__arrayLikeToArray(o, minLen); }

function useMonitorOutput__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useMonitorOutput__iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useMonitorOutput__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = useCollector(monitor, collect, onCollect),
      _useCollector2 = useMonitorOutput__slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();

    if (handlerId == null) {
      return;
    }

    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useCollectedProps.js

function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/connectors.js

function useConnectDragSource(connector) {
  return Object(react["useMemo"])(function () {
    return connector.hooks.dragSource();
  }, [connector]);
}
function useConnectDragPreview(connector) {
  return Object(react["useMemo"])(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/useDrag.js







/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrag(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  Object(invariant_esm["a" /* invariant */])(!spec.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  var monitor = useDragSourceMonitor();
  var connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDragSource(connector), useConnectDragPreview(connector)];
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrag/index.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useAccept.js


/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */

function useAccept(spec) {
  var accept = spec.accept;
  return Object(react["useMemo"])(function () {
    Object(invariant_esm["a" /* invariant */])(spec.accept != null, 'accept must be defined');
    return Array.isArray(accept) ? accept : [accept];
  }, [accept]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/DropTargetImpl.js
function DropTargetImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DropTargetImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DropTargetImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) DropTargetImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) DropTargetImpl__defineProperties(Constructor, staticProps); return Constructor; }

function DropTargetImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DropTargetImpl = /*#__PURE__*/function () {
  function DropTargetImpl(spec, monitor) {
    DropTargetImpl__classCallCheck(this, DropTargetImpl);

    DropTargetImpl__defineProperty(this, "spec", void 0);

    DropTargetImpl__defineProperty(this, "monitor", void 0);

    this.spec = spec;
    this.monitor = monitor;
  }

  DropTargetImpl__createClass(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }
    }
  }]);

  return DropTargetImpl;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTarget.js


function useDropTarget(spec, monitor) {
  var dropTarget = Object(react["useMemo"])(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  Object(react["useEffect"])(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useRegisteredDropTarget.js
function useRegisteredDropTarget__slicedToArray(arr, i) { return useRegisteredDropTarget__arrayWithHoles(arr) || useRegisteredDropTarget__iterableToArrayLimit(arr, i) || useRegisteredDropTarget__unsupportedIterableToArray(arr, i) || useRegisteredDropTarget__nonIterableRest(); }

function useRegisteredDropTarget__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useRegisteredDropTarget__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useRegisteredDropTarget__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useRegisteredDropTarget__arrayLikeToArray(o, minLen); }

function useRegisteredDropTarget__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useRegisteredDropTarget__iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useRegisteredDropTarget__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = useDragDropManager();
  var dropTarget = useDropTarget(spec, monitor);
  var accept = useAccept(spec);
  useIsomorphicLayoutEffect(function registerDropTarget() {
    var _registerTarget = registerTarget(accept, dropTarget, manager),
        _registerTarget2 = useRegisteredDropTarget__slicedToArray(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, accept.map(function (a) {
    return a.toString();
  }).join('|')]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTargetMonitor.js



function useDropTargetMonitor() {
  var manager = useDragDropManager();
  return Object(react["useMemo"])(function () {
    return new DropTargetMonitorImpl_DropTargetMonitorImpl(manager);
  }, [manager]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useDropTargetConnector.js




function useDropTargetConnector(options) {
  var manager = useDragDropManager();
  var connector = Object(react["useMemo"])(function () {
    return new TargetConnector_TargetConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect(function () {
    connector.dropTargetOptions = options || null;
    connector.reconnect();
    return function () {
      return connector.disconnectDropTarget();
    };
  }, [options]);
  return connector;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/connectors.js

function useConnectDropTarget(connector) {
  return Object(react["useMemo"])(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/useDrop.js






/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrop(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  var monitor = useDropTargetMonitor();
  var connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDropTarget(connector)];
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDrop/index.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/useDragLayer.js
function useDragLayer__slicedToArray(arr, i) { return useDragLayer__arrayWithHoles(arr) || useDragLayer__iterableToArrayLimit(arr, i) || useDragLayer__unsupportedIterableToArray(arr, i) || useDragLayer__nonIterableRest(); }

function useDragLayer__nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function useDragLayer__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return useDragLayer__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useDragLayer__arrayLikeToArray(o, minLen); }

function useDragLayer__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function useDragLayer__iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function useDragLayer__arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




/**
 * useDragLayer Hook
 * @param collector The property collector
 */

function useDragLayer(collect) {
  var dragDropManager = useDragDropManager();
  var monitor = dragDropManager.getMonitor();

  var _useCollector = useCollector(monitor, collect),
      _useCollector2 = useDragLayer__slicedToArray(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  Object(react["useEffect"])(function () {
    return monitor.subscribeToOffsetChange(updateCollected);
  });
  Object(react["useEffect"])(function () {
    return monitor.subscribeToStateChange(updateCollected);
  });
  return collected;
}
// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/types.js

// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/hooks/index.js





// CONCATENATED MODULE: ./node_modules/react-dnd/dist/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DndContext", function() { return DndContext["a" /* DndContext */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DndProvider", function() { return DndProvider["a" /* DndProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DragPreviewImage", function() { return DragPreviewImage_DragPreviewImage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DragSource", function() { return DragSource; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DropTarget", function() { return DropTarget; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DragLayer", function() { return DragLayer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useDragLayer", function() { return useDragLayer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useDragDropManager", function() { return useDragDropManager; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useDrag", function() { return useDrag; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useDrop", function() { return useDrop; });





/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var PooledClass = __webpack_require__(187);

var emptyFunction = __webpack_require__(129);
var warning = __webpack_require__(40);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(644);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(645);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(437);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || Object(iterableToArray["a" /* default */])(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = undefined;

var _reactIntl = __webpack_require__(16);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  basicInfo: {
    'id': 'Label.BasicInfo',
    'defaultMessage': 'Basic Information'
  },
  topicsAndStandards: {
    'id': 'Label.TopicsAndStandards',
    'defaultMessage': 'Topics & Standards'
  },
  images: {
    'id': 'Label.Images',
    'defaultMessage': 'Images'
  },
  otherInfo: {
    'id': 'Label.OtherInfo',
    'defaultMessage': 'Other Information'
  },
  questReview: {
    'id': 'Label.QuestReview',
    'defaultMessage': 'Quest Review'
  },
  standards: {
    'id': 'Label.Standards',
    'defaultMessage': 'Standards'
  },
  final: {
    'id': 'Label.Final',
    'defaultMessage': 'Final'
  },
  experience: {
    'id': 'Label.Experience',
    'defaultMessage': 'Experience'
  },
  subject: {
    'id': 'Label.Subject',
    'defaultMessage': 'Subject'
  },
  copy: {
    'id': 'Label.Copy',
    'defaultMessage': 'Copy'
  },
  experienceReview: {
    'id': 'Label.ExperienceReview',
    'defaultMessage': 'Experience'
  },
  standardsReview: {
    'id': 'Label.StandardsReview',
    'defaultMessage': 'Standards'
  },
  subjectReview: {
    'id': 'Label.SubjectReview',
    'defaultMessage': 'Subject'
  },
  review: {
    'id': 'Label.Review',
    'defaultMessage': 'review'
  },
  blankReview: {
    'id': 'Label.BlankReview',
    'defaultMessage': '{reviewType} {review}'
  },
  author: {
    'id': 'Label.Author',
    'defaultMessage': 'Author'
  },
  authorOrganization: {
    'id': 'Label.AuthorOrganization',
    'defaultMessage': 'Author Organization'
  },
  tags: {
    'id': 'Label.Tags',
    'defaultMessage': 'Tags'
  },
  primarySubject: {
    'id': 'Label.PrimarySubject',
    'defaultMessage': 'Primary Subject'
  },
  assignedTo: {
    'id': 'Label.AssignedTo',
    'defaultMessage': 'Assigned To'
  },
  status: {
    'id': 'Label.Status',
    'defaultMessage': 'Status'
  },
  targetGradeLevel: {
    'id': 'Label.TargetGradeLevel',
    'defaultMessage': 'Target Grade'
  }
});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserDisplayName = getUserDisplayName;
function getUserDisplayName(user) {
  return user.display_name ? user.display_name : user.name;
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = undefined;

var _reactIntl = __webpack_require__(16);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  typeYourCitation: {
    'id': 'Placeholder.TypeYourCitation',
    'defaultMessage': 'Type your citation here.'
  },
  writeABriefDescriptionOfFile: {
    'id': 'Placeholder.writeABriefDescriptionOfFile',
    'defaultMessage': 'Write a brief description of this file (optional)'
  },
  searchForTheQuest: {
    'id': 'Placeholder.SearchForTheQuest',
    'defaultMessage': 'Search for the quest by name here'
  },
  http: {
    'id': 'Placeholder.Http',
    'defaultMessage': 'http://'
  },
  selectTags: {
    'id': 'Placeholder.SelectTags',
    'defaultMessage': 'Select tags'
  },
  giveMentorsBackgroundInfo: {
    'id': 'Placeholder.GiveMentorsBackgroundInfo',
    'defaultMessage': 'Give mentors some background information or tips for this quest'
  },
  selectAuthors: {
    'id': 'Placeholder.SelectAuthors',
    'defaultMessage': 'Select authors'
  },
  typeYourComment: {
    'id': 'Placeholder.TypeYourComment',
    'defaultMessage': 'Type your comment here.'
  },
  artifactDescription: {
    'id': 'Placeholder.ArtifactDescription',
    'defaultMessage': 'Describe what learners will do and why and which skills and knowledge should be demonstrated.'
  },
  enterTitle: {
    'id': 'Placeholder.EnterTitle',
    'defaultMessage': 'Enter all or part of a quest title'
  },
  selectSubject: {
    'id': 'Placeholder.SelectSubject',
    'defaultMessage': 'Select subjects'
  },
  selectColleagues: {
    'id': 'Placeholder.SelectColleagues',
    'defaultMessage': 'Select colleagues'
  },
  selectAPeer: {
    'id': 'Placeholder.SelectAPeer',
    'defaultMessage': 'Select a peer...'
  },
  writeThemAMessage: {
    'id': 'Placeholder.WriteThemAMessage',
    'defaultMessage': 'Write them a message...'
  },
  selectGrades: {
    'id': 'Placeholder.SelectGrades',
    'defaultMessage': 'Select grades'
  }
});

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(173)('meta');
var isObject = __webpack_require__(33);
var has = __webpack_require__(94);
var setDesc = __webpack_require__(51).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(31)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(44)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(87)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(986), __esModule: true };

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILED_MANIFEST = exports.RECEIVE_MANIFEST = exports.REQUEST_MANIFEST = undefined;
exports.receiveManifest = receiveManifest;
exports.requestManifest = requestManifest;
exports.failedManifest = failedManifest;
exports.fetchManifest = fetchManifest;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var REQUEST_MANIFEST = exports.REQUEST_MANIFEST = 'REQUEST_MANIFEST';
var RECEIVE_MANIFEST = exports.RECEIVE_MANIFEST = 'RECEIVE_MANIFEST';
var FAILED_MANIFEST = exports.FAILED_MANIFEST = 'FAILED_MANIFEST';

function receiveManifest(response) {
  return {
    type: RECEIVE_MANIFEST,
    payload: {
      manifest: response.manifest
    }
  };
}

function requestManifest() {
  return {
    type: REQUEST_MANIFEST
  };
}

function failedManifest(error) {
  return (0, _actions.getErrorAction)(FAILED_MANIFEST, error);
}

function fetchManifest() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getBaseUrl)() + '/quest_maker/api/manifest';
    return (0, _api.basicGet)(state, dispatch, url, requestManifest, receiveManifest, failedManifest);
  };
}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userNeedsToAcceptPolicies = exports.SET_ACCEPTED_POLICIES_TO_USER = exports.FAILED_POLICIES = exports.USER_IS_NOT_CONSIDERING_DECLINING_POLICIES = exports.USER_IS_CONSIDERING_DECLINING_POLICIES = exports.HIDE_ACCEPT_POLICIES_MODAL_REQUEST = exports.SHOW_ACCEPT_POLICIES_MODAL_REQUEST = exports.RECEIVE_POLICIES = exports.REQUEST_POLICIES = exports.UNSET_POLICIES_TO_ACCEPT = exports.SET_POLICIES_TO_ACCEPT = undefined;

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var userNeedsToAcceptPolicies = exports.userNeedsToAcceptPolicies = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(token) {
    var response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch((0, _utils.getBaseUrl)() + '/quest_maker/api/status', {
              method: 'GET',
              headers: {
                Authorization: 'Token token="' + token + '"',
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt('return', (0, _api.checkForPolicyChanges)(response));

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function userNeedsToAcceptPolicies(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.requestPolicies = requestPolicies;
exports.receivePolicies = receivePolicies;
exports.failedPolicies = failedPolicies;
exports.showAcceptPoliciesModal = showAcceptPoliciesModal;
exports.hideAcceptPoliciesModal = hideAcceptPoliciesModal;
exports.userIsConsideringDecliningPolicies = userIsConsideringDecliningPolicies;
exports.userIsNotConsideringDecliningPolicies = userIsNotConsideringDecliningPolicies;
exports.setPoliciesToAcceptAction = setPoliciesToAcceptAction;
exports.unsetPoliciesToAcceptAction = unsetPoliciesToAcceptAction;
exports.setPoliciesToAccept = setPoliciesToAccept;
exports.setAcceptedPoliciesToUser = setAcceptedPoliciesToUser;
exports.acceptPolicies = acceptPolicies;
exports.fetchPolicies = fetchPolicies;
exports.fetchPoliciesIfNeeded = fetchPoliciesIfNeeded;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _users = __webpack_require__(299);

var _actions = __webpack_require__(55);

var _api = __webpack_require__(72);

var _policies = __webpack_require__(1016);

var _user = __webpack_require__(73);

var _combined = __webpack_require__(395);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_POLICIES_TO_ACCEPT = exports.SET_POLICIES_TO_ACCEPT = 'SET_POLICIES_TO_ACCEPT';
var UNSET_POLICIES_TO_ACCEPT = exports.UNSET_POLICIES_TO_ACCEPT = 'UNSET_POLICIES_TO_ACCEPT';
var REQUEST_POLICIES = exports.REQUEST_POLICIES = 'REQUEST_POLICIES';
var RECEIVE_POLICIES = exports.RECEIVE_POLICIES = 'RECEIVE_POLICIES';
var SHOW_ACCEPT_POLICIES_MODAL_REQUEST = exports.SHOW_ACCEPT_POLICIES_MODAL_REQUEST = 'SHOW_ACCEPT_POLICIES_MODAL_REQUEST';
var HIDE_ACCEPT_POLICIES_MODAL_REQUEST = exports.HIDE_ACCEPT_POLICIES_MODAL_REQUEST = 'HIDE_ACCEPT_POLICIES_MODAL_REQUEST';
var USER_IS_CONSIDERING_DECLINING_POLICIES = exports.USER_IS_CONSIDERING_DECLINING_POLICIES = 'USER_IS_CONSIDERING_DECLINING_POLICIES';
var USER_IS_NOT_CONSIDERING_DECLINING_POLICIES = exports.USER_IS_NOT_CONSIDERING_DECLINING_POLICIES = 'USER_IS_NOT_CONSIDERING_DECLINING_POLICIES';
var FAILED_POLICIES = exports.FAILED_POLICIES = 'FAILED_POLICIES';
var SET_ACCEPTED_POLICIES_TO_USER = exports.SET_ACCEPTED_POLICIES_TO_USER = 'SET_ACCEPTED_POLICIES_TO_USER';

function requestPolicies() {
  return {
    type: REQUEST_POLICIES
  };
}

function receivePolicies(json) {
  return {
    type: RECEIVE_POLICIES,
    policies: json.policies,
    receivedAt: Date.now()
  };
}

function failedPolicies(error) {
  return (0, _actions.getErrorAction)(FAILED_POLICIES, error);
}

function showAcceptPoliciesModal() {
  return {
    type: SHOW_ACCEPT_POLICIES_MODAL_REQUEST,
    showAcceptPoliciesModal: true
  };
}

function hideAcceptPoliciesModal() {
  return {
    type: HIDE_ACCEPT_POLICIES_MODAL_REQUEST,
    showAcceptPoliciesModal: false
  };
}

function userIsConsideringDecliningPolicies() {
  return {
    type: USER_IS_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: true
  };
}

function userIsNotConsideringDecliningPolicies() {
  return {
    type: USER_IS_NOT_CONSIDERING_DECLINING_POLICIES,
    userIsConsideringDecliningPolicies: false
  };
}

function setPoliciesToAcceptAction(policies) {
  return {
    type: SET_POLICIES_TO_ACCEPT,
    policiesToAccept: policies
  };
}

function unsetPoliciesToAcceptAction() {
  return {
    type: UNSET_POLICIES_TO_ACCEPT
  };
}

function setPoliciesToAccept(policies) {
  return function (dispatch) {
    dispatch(setPoliciesToAcceptAction(policies));
    dispatch(showAcceptPoliciesModal());
  };
}

function setAcceptedPoliciesToUser(policies) {
  return {
    type: SET_ACCEPTED_POLICIES_TO_USER,
    payload: {
      policies: policies
    }
  };
}

function acceptPolicies() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, newState;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              _context.prev = 1;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 5;
              return fetch((0, _utils.getBaseUrl)() + '/policies/' + state.policies.policiesToAccept + '/accept', {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 5:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              _context.next = 9;
              return dispatch(setAcceptedPoliciesToUser(state.policies.policiesToAccept));

            case 9:
              dispatch(unsetPoliciesToAcceptAction());
              dispatch(hideAcceptPoliciesModal());

              _context.next = 13;
              return getState();

            case 13:
              newState = _context.sent;

              dispatch((0, _combined.fetchDataAndRedirectUser)(newState.user.user));
              // TODO: I don't love this but org users aren't fetched otherwise
              dispatch((0, _users.getUsers)());
              dispatch((0, _user.userIsLoggedInDataFetched)());
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t2 = _context['catch'](1);

              window.alert('There was an error accepting the policies.');

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 19]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchPolicies() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getBaseUrl)() + '/policies.json';
    return (0, _api.basicGet)(state, dispatch, url, requestPolicies, receivePolicies, failedPolicies);
  };
}

function fetchPoliciesIfNeeded() {
  return function (dispatch, getState) {
    if ((0, _policies.shouldFetchPolicies)(getState())) {
      return dispatch(fetchPolicies());
    } else {
      // lame af, but without this, this function returns without a promise
      return dispatch(function () {
        return _promise2.default.resolve();
      });
    }
  };
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECEIVE_CURRENT_COMPILED_QUEST_FAILURE = exports.RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS = exports.REQUEST_CURRENT_COMPILED_QUEST = exports.REVERT_QUEST_TO_DRAFT_SUCCESS = exports.STOP_REVIEW_SUCCESS = exports.EDIT_REVIEW_SUCCESS = exports.COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS = exports.DELETE_COMPILED_QUEST_REVIEW_SUCCESS = exports.CREATE_COMPILED_QUEST_REVIEW_SUCCESS = exports.CREATE_COMPILED_QUEST_SUCCESS = exports.CREATE_COMPILED_QUEST_REQUEST = exports.CLOSE_TO_QUALITY_REVIEW_MODAL = exports.OPEN_TO_QUALITY_REVIEW_MODAL = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.requestCurrentCompiledQuest = requestCurrentCompiledQuest;
exports.openToQualityReviewModal = openToQualityReviewModal;
exports.closeToQualityReviewModal = closeToQualityReviewModal;
exports.stopReviewSuccess = stopReviewSuccess;
exports.createCompiledQuestReviewSuccess = createCompiledQuestReviewSuccess;
exports.deleteCompiledQuestReviewSuccess = deleteCompiledQuestReviewSuccess;
exports.editReviewSuccess = editReviewSuccess;
exports.completeCompiledQuestReviewSuccess = completeCompiledQuestReviewSuccess;
exports.createCompiledQuestSuccess = createCompiledQuestSuccess;
exports.createCompiledQuestRequest = createCompiledQuestRequest;
exports.receiveCurrentCompiledQuestSuccess = receiveCurrentCompiledQuestSuccess;
exports.receiveCurrentCompiledQuestFailure = receiveCurrentCompiledQuestFailure;
exports.revertQuestToDraftSuccess = revertQuestToDraftSuccess;
exports.stopReview = stopReview;
exports.revertQuestToDraft = revertQuestToDraft;
exports.completeCompiledQuestReview = completeCompiledQuestReview;
exports.editReviewComment = editReviewComment;
exports.nullifyReviewCriterionApproval = nullifyReviewCriterionApproval;
exports.rejectReviewCriterion = rejectReviewCriterion;
exports.approveReviewCriterion = approveReviewCriterion;
exports.deleteCompiledQuestReview = deleteCompiledQuestReview;
exports.createCompiledQuestReview = createCompiledQuestReview;
exports.fetchCurrentCompiledQuest = fetchCurrentCompiledQuest;
exports.createCompiledQuest = createCompiledQuest;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _quest = __webpack_require__(66);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var _assignment = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_TO_QUALITY_REVIEW_MODAL = exports.OPEN_TO_QUALITY_REVIEW_MODAL = 'OPEN_TO_QUALITY_REVIEW_MODAL';
var CLOSE_TO_QUALITY_REVIEW_MODAL = exports.CLOSE_TO_QUALITY_REVIEW_MODAL = 'CLOSE_TO_QUALITY_REVIEW_MODAL';
var CREATE_COMPILED_QUEST_REQUEST = exports.CREATE_COMPILED_QUEST_REQUEST = 'CREATE_COMPILED_QUEST_REQUEST';
var CREATE_COMPILED_QUEST_SUCCESS = exports.CREATE_COMPILED_QUEST_SUCCESS = 'CREATE_COMPILED_QUEST_SUCCESS';
var CREATE_COMPILED_QUEST_REVIEW_SUCCESS = exports.CREATE_COMPILED_QUEST_REVIEW_SUCCESS = 'CREATE_COMPILED_QUEST_REVIEW_SUCCESS';
var DELETE_COMPILED_QUEST_REVIEW_SUCCESS = exports.DELETE_COMPILED_QUEST_REVIEW_SUCCESS = 'DELETE_COMPILED_QUEST_REVIEW_SUCCESS';
var COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS = exports.COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS = 'COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS';
var EDIT_REVIEW_SUCCESS = exports.EDIT_REVIEW_SUCCESS = 'EDIT_REVIEW_SUCCESS';
var STOP_REVIEW_SUCCESS = exports.STOP_REVIEW_SUCCESS = 'STOP_REVIEW_SUCCESS';
var REVERT_QUEST_TO_DRAFT_SUCCESS = exports.REVERT_QUEST_TO_DRAFT_SUCCESS = 'REVERT_QUEST_TO_DRAFT_SUCCESS';
var REQUEST_CURRENT_COMPILED_QUEST = exports.REQUEST_CURRENT_COMPILED_QUEST = 'REQUEST_CURRENT_COMPILED_QUEST';
var RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS = exports.RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS = 'RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS';
var RECEIVE_CURRENT_COMPILED_QUEST_FAILURE = exports.RECEIVE_CURRENT_COMPILED_QUEST_FAILURE = 'RECEIVE_CURRENT_COMPILED_QUEST_FAILURE';

function requestCurrentCompiledQuest() {
  return {
    type: REQUEST_CURRENT_COMPILED_QUEST
  };
}

function openToQualityReviewModal() {
  return {
    type: OPEN_TO_QUALITY_REVIEW_MODAL
  };
}

function closeToQualityReviewModal() {
  return {
    type: CLOSE_TO_QUALITY_REVIEW_MODAL
  };
}

function stopReviewSuccess(questId) {
  return {
    type: STOP_REVIEW_SUCCESS,
    questId: questId
  };
}

function createCompiledQuestReviewSuccess(response) {
  return {
    type: CREATE_COMPILED_QUEST_REVIEW_SUCCESS,
    review: response
  };
}

function deleteCompiledQuestReviewSuccess(reviewId) {
  return {
    type: DELETE_COMPILED_QUEST_REVIEW_SUCCESS,
    reviewId: reviewId
  };
}

function editReviewSuccess(response) {
  return {
    type: EDIT_REVIEW_SUCCESS,
    review: response
  };
}

function completeCompiledQuestReviewSuccess(response, reviewState, questId) {
  return {
    type: COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS,
    payload: {
      review: response,
      reviewState: reviewState,
      questId: questId
    }
  };
}

function createCompiledQuestSuccess(response, questId, userIsAssignedQuest) {
  return {
    type: CREATE_COMPILED_QUEST_SUCCESS,
    payload: {
      compiled_quest: response,
      questId: questId,
      userIsAssignedQuest: userIsAssignedQuest
    }
  };
}

function createCompiledQuestRequest() {
  return {
    type: CREATE_COMPILED_QUEST_REQUEST
  };
}

function receiveCurrentCompiledQuestSuccess(response) {
  return {
    type: RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS,
    compiledQuest: response
  };
}

function receiveCurrentCompiledQuestFailure(error) {
  return (0, _actions.getErrorAction)(RECEIVE_CURRENT_COMPILED_QUEST_FAILURE, error);
}

function revertQuestToDraftSuccess(published, quest) {
  return {
    type: REVERT_QUEST_TO_DRAFT_SUCCESS,
    payload: {
      published: published,
      quest: quest
    }
  };
}

function stopReview(questId, compiledQuestId) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/recall';
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                }
              });

            case 6:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(stopReviewSuccess(questId));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t2 = _context['catch'](2);

              console.log(_context.t2);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function revertQuestToDraft(questId, published) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId;
              _context2.prev = 2;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify2.default)({
                  quest: {
                    clear_review: true
                  }
                })
              });

            case 6:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 10;
              return response.json();

            case 10:
              json = _context2.sent;

              dispatch(revertQuestToDraftSuccess(published, json));
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t2 = _context2['catch'](2);

              console.log(_context2.t2);

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 14]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function completeCompiledQuestReview(questId, compiledQuestId, reviewId, nextState) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context3.prev = 2;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    completed: true
                  }
                })
              });

            case 6:
              _context3.t1 = _context3.sent;
              response = (0, _context3.t0)(_context3.t1);
              _context3.next = 10;
              return response.json();

            case 10:
              json = _context3.sent;

              dispatch(completeCompiledQuestReviewSuccess(json, nextState, questId));
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t2 = _context3['catch'](2);

              console.log(_context3.t2);

            case 17:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 14]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function editReviewComment(questId, compiledQuestId, reviewId, comment) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context4.prev = 2;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    comment: comment
                  }
                })
              });

            case 6:
              _context4.t1 = _context4.sent;
              response = (0, _context4.t0)(_context4.t1);
              _context4.next = 10;
              return response.json();

            case 10:
              json = _context4.sent;

              dispatch(editReviewSuccess(json));
              _context4.next = 17;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t2 = _context4['catch'](2);

              console.log(_context4.t2);

            case 17:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[2, 14]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function nullifyReviewCriterionApproval(questId, compiledQuestId, reviewId) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context5.prev = 2;
              _context5.t0 = _utils.checkHttpStatus;
              _context5.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    accepted: null
                  }
                })
              });

            case 6:
              _context5.t1 = _context5.sent;
              response = (0, _context5.t0)(_context5.t1);
              _context5.next = 10;
              return response.json();

            case 10:
              json = _context5.sent;

              dispatch(editReviewSuccess(json));
              _context5.next = 17;
              break;

            case 14:
              _context5.prev = 14;
              _context5.t2 = _context5['catch'](2);

              console.log(_context5.t2);

            case 17:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[2, 14]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function rejectReviewCriterion(questId, compiledQuestId, reviewId) {
  var _this6 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context6.prev = 2;
              _context6.t0 = _utils.checkHttpStatus;
              _context6.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    accepted: false
                  }
                })
              });

            case 6:
              _context6.t1 = _context6.sent;
              response = (0, _context6.t0)(_context6.t1);
              _context6.next = 10;
              return response.json();

            case 10:
              json = _context6.sent;

              dispatch(editReviewSuccess(json));
              _context6.next = 17;
              break;

            case 14:
              _context6.prev = 14;
              _context6.t2 = _context6['catch'](2);

              console.log(_context6.t2);

            case 17:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[2, 14]]);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function approveReviewCriterion(questId, compiledQuestId, reviewId) {
  var _this7 = this;

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context7.prev = 2;
              _context7.t0 = _utils.checkHttpStatus;
              _context7.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    accepted: true
                  }
                })
              });

            case 6:
              _context7.t1 = _context7.sent;
              response = (0, _context7.t0)(_context7.t1);
              _context7.next = 10;
              return response.json();

            case 10:
              json = _context7.sent;

              dispatch(editReviewSuccess(json));
              _context7.next = 17;
              break;

            case 14:
              _context7.prev = 14;
              _context7.t2 = _context7['catch'](2);

              console.log(_context7.t2);

            case 17:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[2, 14]]);
    }));

    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function deleteCompiledQuestReview(questId, compiledQuestId, reviewId) {
  var _this8 = this;

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews/' + reviewId;
              _context8.prev = 2;
              _context8.t0 = _utils.checkHttpStatus;
              _context8.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context8.t1 = _context8.sent;
              (0, _context8.t0)(_context8.t1);

              dispatch(deleteCompiledQuestReviewSuccess(reviewId));
              _context8.next = 14;
              break;

            case 11:
              _context8.prev = 11;
              _context8.t2 = _context8['catch'](2);

              console.log(_context8.t2);

            case 14:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[2, 11]]);
    }));

    return function (_x15, _x16) {
      return _ref8.apply(this, arguments);
    };
  }();
}

function createCompiledQuestReview(questId, compiledQuestId, reviewType) {
  var _this9 = this;

  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId + '/reviews';
              _context9.prev = 2;
              _context9.t0 = _utils.checkHttpStatus;
              _context9.next = 6;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  compiled_quest_review: {
                    criteria: reviewType
                  }
                })
              });

            case 6:
              _context9.t1 = _context9.sent;
              response = (0, _context9.t0)(_context9.t1);
              _context9.next = 10;
              return response.json();

            case 10:
              json = _context9.sent;

              dispatch(createCompiledQuestReviewSuccess(json));
              _context9.next = 17;
              break;

            case 14:
              _context9.prev = 14;
              _context9.t2 = _context9['catch'](2);

              console.log(_context9.t2);

            case 17:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9, [[2, 14]]);
    }));

    return function (_x17, _x18) {
      return _ref9.apply(this, arguments);
    };
  }();
}

function fetchCurrentCompiledQuest(questId, compiledQuestId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/compiled_quests/' + compiledQuestId;
    return (0, _api.basicGet)(state, dispatch, url, requestCurrentCompiledQuest, receiveCurrentCompiledQuestSuccess, receiveCurrentCompiledQuestFailure);
  };
}

function createCompiledQuest(id) {
  var _this10 = this;

  return function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch, getState) {
      var state, userIsAssignedQuest, url, response, json;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              state = getState();

              dispatch(createCompiledQuestRequest());
              userIsAssignedQuest = (0, _assignment.questIsAssignedToUser)(state.quest.item, state.user.user);
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id + '/compiled_quests';
              _context10.prev = 4;
              _context10.t0 = _utils.checkHttpStatus;
              _context10.next = 8;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 8:
              _context10.t1 = _context10.sent;
              response = (0, _context10.t0)(_context10.t1);
              _context10.next = 12;
              return response.json();

            case 12:
              json = _context10.sent;
              _context10.next = 15;
              return dispatch(createCompiledQuestSuccess(json, id, userIsAssignedQuest));

            case 15:
              dispatch(closeToQualityReviewModal());
              _context10.next = 21;
              break;

            case 18:
              _context10.prev = 18;
              _context10.t2 = _context10['catch'](4);

              console.log(_context10.t2);

            case 21:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10, [[4, 18]]);
    }));

    return function (_x19, _x20) {
      return _ref10.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n\n  ', '\n'], ['\n  color: #666666;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n\n  ', '\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption4 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption4',
  componentId: 'sc-18b4wl8-0'
})(_templateObject, function (_ref) {
  var textTruncate = _ref.textTruncate;
  return textTruncate && '\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ';
});

Caption4.propTypes = {
  textTruncate: _propTypes2.default.bool
};

exports.default = Caption4;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fancyTimeFormat = exports.getRemainingSecondsFromTotalTime = exports.getMinutesFromSeconds = undefined;
exports.getDifferenceInMinutesToNow = getDifferenceInMinutesToNow;
exports.getDateDisplay = getDateDisplay;
exports.getDaysAgoFromMinutes = getDaysAgoFromMinutes;
exports.getCurrentYear = getCurrentYear;
exports.isUnixTimestamp = isUnixTimestamp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDifferenceInMinutesToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asMinutes()) === 0 ? 1 : Math.floor(duration.asMinutes());
}

function getDateDisplay(timestamp, assignment) {
  var minutesAgo = getDifferenceInMinutesToNow(timestamp);
  var daysAgo = getDaysAgoFromMinutes(minutesAgo);

  if (minutesAgo < 60) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'MinuteDateDisplay',
      defaultMessage: '{val} {minute}',
      values: {
        val: minutesAgo,
        minute: _messages.minutesAbbr
      }
    });
  } else if (minutesAgo >= 60 && minutesAgo < 1440) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'HourDateDisplay',
      defaultMessage: '{val} {hour}',
      values: {
        val: Math.floor(minutesAgo / 60),
        hour: Math.floor(minutesAgo / 60) > 1 ? _messages.hoursAbbr : _messages.hourAbbr
      }
    });
  } else if (daysAgo <= 7 || !assignment) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'DayDateDisplay',
      defaultMessage: '{val} {day}',
      values: {
        val: daysAgo,
        day: daysAgo > 1 ? _messages.days : _messages.day
      }
    });
  } else {
    return _moment2.default.unix(timestamp).format('DD MMMM YYYY').toString();
  }
}

function getDaysAgoFromMinutes(minutesAgo) {
  return Math.floor(minutesAgo / 1440);
}

function getCurrentYear() {
  return new Date().getFullYear();
}

function isUnixTimestamp(datetime) {
  return !/[a-z]/i.test(datetime);
}

var getMinutesFromSeconds = exports.getMinutesFromSeconds = function getMinutesFromSeconds(seconds) {
  return Math.floor(seconds / 60);
};

var getRemainingSecondsFromTotalTime = exports.getRemainingSecondsFromTotalTime = function getRemainingSecondsFromTotalTime(totalTime) {
  return totalTime % 60;
};

var fancyTimeFormat = exports.fancyTimeFormat = function fancyTimeFormat(seconds) {
  // Hours, minutes and seconds
  var hrs = ~~(seconds / 3600);
  var mins = ~~(seconds % 3600 / 60);
  var secs = ~~seconds % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  var ret = '';

  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
  }

  ret += '' + mins + ':' + (secs < 10 ? '0' : '');
  ret += '' + secs;
  return ret;
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n'], ['\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: ', ';\n  background-image: ', ';\n  height: ', 'px;\n  width: ', 'px;\n  border-radius: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  border: 1px solid #dedfe0;\n  display: ', ';\n'], ['\n  background: ', ';\n  background-image: ', ';\n  height: ', 'px;\n  width: ', 'px;\n  border-radius: 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n  border: 1px solid #dedfe0;\n  display: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestTypeIcon = __webpack_require__(586);

var _QuestTypeIcon2 = _interopRequireDefault(_QuestTypeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestTypeIconWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'QuestIcon__QuestTypeIconWrapper',
  componentId: 'sc-1etjdeg-0'
})(_templateObject);

var QuestIconComponent = _styledComponents2.default.div.withConfig({
  displayName: 'QuestIcon__QuestIconComponent',
  componentId: 'sc-1etjdeg-1'
})(_templateObject2, function (props) {
  return props.icon_image_url ? '' : '#333333';
}, function (props) {
  return props.icon_image_url ? 'url(' + props.icon_image_url + ')' : '';
}, function (props) {
  return props.heightWidth;
}, function (props) {
  return props.heightWidth;
}, function (props) {
  return props.display;
});

var QuestIcon = function QuestIcon(props) {
  return _react2.default.createElement(
    'div',
    { style: { position: 'relative', display: 'flex' } },
    _react2.default.createElement(QuestIconComponent, (0, _extends3.default)({
      className: 'quest-icon'
    }, props, {
      onClick: props.handleClick,
      'data-id': props.dataId
    })),
    props.showTypeIcon && _react2.default.createElement(
      QuestTypeIconWrapper,
      { className: 'quest-type-icon-wrapper' },
      _react2.default.createElement(_QuestTypeIcon2.default, { id: props.questTypeId, size: props.questTypeIconSize })
    )
  );
};

QuestIcon.propTypes = {
  icon_image_url: _propTypes2.default.string,
  heightWidth: _propTypes2.default.number,
  display: _propTypes2.default.string,
  handleClick: _propTypes2.default.func,
  dataId: _propTypes2.default.string,
  showTypeIcon: _propTypes2.default.bool,
  questTypeIconSize: _propTypes2.default.number,
  questTypeId: _propTypes2.default.number
};

QuestIcon.defaultProps = {
  heightWidth: 50,
  display: 'inline-block'
};

exports.default = QuestIcon;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', '\n  font-size: 11px;\n  line-height: 16px;\n  margin-top: 20px;\n  font-weight: 500;\n'], ['\n  color: ', '\n  font-size: 11px;\n  line-height: 16px;\n  margin-top: 20px;\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputLabel = _styledComponents2.default.div.withConfig({
  displayName: 'InputLabel',
  componentId: 'sc-1iabmwz-0'
})(_templateObject, _colors2.default.dove);

exports.default = InputLabel;

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useControlled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(65);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/index.js + 3 modules
var ButtonBase = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(27);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js










var IconButton_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton_IconButton = /*#__PURE__*/react["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(capitalize["a" /* default */])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(capitalize["a" /* default */])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? IconButton_IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ var esm_IconButton_IconButton = (Object(withStyles["a" /* default */])(IconButton_styles, {
  name: 'MuiIconButton'
})(IconButton_IconButton));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/IconButton/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return esm_IconButton_IconButton; });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotYetSpecified = function NotYetSpecified(props) {
  return _react2.default.createElement(
    'div',
    { className: 'not-yet-specified' },
    _react2.default.createElement('div', {
      className: 'icon-circle-incomplete-light ' + (props.hideCircleIcon ? 'hidden' : '')
    }),
    _react2.default.createElement(
      'div',
      { className: props.textClass || 'text' },
      'Not Yet Specified'
    )
  );
};

NotYetSpecified.propTypes = {
  hideCircleIcon: _propTypes2.default.bool,
  textClass: _propTypes2.default.string
};

exports.default = NotYetSpecified;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.mapContentWarnings = mapContentWarnings;
exports.activityHasContentWarnings = activityHasContentWarnings;
exports.questHasContentWarnings = questHasContentWarnings;
exports.contentWarningsSelectedButNoValues = contentWarningsSelectedButNoValues;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapContentWarnings(contentWarnings) {
  var contentWarningsArray = [];
  (0, _keys2.default)(contentWarnings).forEach(function (cw) {
    if (Array.isArray(contentWarnings[cw])) {
      // sometimes, like risky_behaviors, key is an array
      contentWarnings[cw].forEach(function (i) {
        contentWarningsArray.push(i);
      });
    } else {
      contentWarningsArray.push(contentWarnings[cw]);
    }
  });

  return contentWarningsArray;
}

function activityHasContentWarnings(activity) {
  return activity.resources && activity.resources.some(function (r) {
    return (0, _keys2.default)(r.content_warnings).length > 0;
  });
}

function questHasContentWarnings(quest) {
  return quest.content_warnings && (0, _keys2.default)(quest.content_warnings).length > 0;
}

function contentWarningsSelectedButNoValues(contentWarnings) {
  return document.getElementById('content-warnings-true') && document.getElementById('content-warnings-true').checked === true && contentWarnings && ((0, _keys2.default)(contentWarnings).length === 0 || (0, _keys2.default)(contentWarnings).every(function (cw) {
    return contentWarnings[cw] === '' || !contentWarnings[cw] || contentWarnings[cw].length === 0;
  }));
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(132);
var createDesc = __webpack_require__(225);
module.exports = __webpack_require__(104) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(490);
var defined = __webpack_require__(347);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(498);
var enumBugKeys = __webpack_require__(360);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(108);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(24);
var dPs = __webpack_require__(499);
var enumBugKeys = __webpack_require__(360);
var IE_PROTO = __webpack_require__(359)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(357)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(361).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(498);
var hiddenKeys = __webpack_require__(360).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var dP = __webpack_require__(51);
var DESCRIPTORS = __webpack_require__(49);
var SPECIES = __webpack_require__(44)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(106);
var call = __webpack_require__(511);
var isArrayIter = __webpack_require__(372);
var anObject = __webpack_require__(24);
var toLength = __webpack_require__(46);
var getIterFn = __webpack_require__(374);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(88);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(965);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(970);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscribable; });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useQueryClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryClientProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var defaultContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(getQueryClientContext(__WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: client
  }, children));
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRef;
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalComponent = function (_Component) {
  (0, _inherits3.default)(ModalComponent, _Component);

  function ModalComponent() {
    (0, _classCallCheck3.default)(this, ModalComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalComponent.__proto__ || (0, _getPrototypeOf2.default)(ModalComponent)).call(this));

    _this.onHideBound = _this.onHide.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ModalComponent, [{
    key: 'render',
    value: function render() {
      var quest = this.props.quest;

      var modalStyle = {
        width: '402px',
        background: '#fff',
        borderRadius: '5px'
      };
      var contentStyle = {
        outline: 'none'
      };

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: this.props.klass,
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          onHide: this.onHideBound
        },
        _react2.default.createElement(
          'div',
          { id: this.props.modalId },
          _react2.default.createElement(
            'div',
            { className: this.props.headingKlass },
            quest && this.props.questLogo && _react2.default.createElement(_QuestIcon2.default, {
              heightWidth: 54,
              icon_image_url: quest.icon_image_url
            }),
            !this.props.questLogo && _react2.default.createElement('div', { className: this.props.logoKlass }),
            _react2.default.createElement(
              'div',
              { className: 'heading-text h3' },
              this.props.headingText
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-body' },
            this.props.setRawHtmlInBody ? _react2.default.createElement('div', {
              className: 'modal-body-text',
              dangerouslySetInnerHTML: { __html: this.props.bodyText }
            }) : _react2.default.createElement(
              'div',
              { className: 'modal-body-text' },
              this.props.bodyText
            ),
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement(
                'div',
                {
                  className: 'button modal-cancel',
                  onClick: this.props.secondaryButtonAction
                },
                this.props.secondaryButtonText
              ),
              _react2.default.createElement(
                'div',
                {
                  className: this.getPrimaryButtonClass(),
                  onClick: this.props.primaryButtonAction
                },
                this.props.primaryButtonText
              )
            )
          )
        )
      );
    }
  }, {
    key: 'getPrimaryButtonClass',
    value: function getPrimaryButtonClass() {
      var retVal = 'button modal-confirm';
      if (this.props.primaryButtonDestructiveClass) {
        retVal += ' btn-destructive-dark';
      }
      return retVal;
    }
  }, {
    key: 'onHide',
    value: function onHide(e) {
      if (this.props.handleNonButtonCancelAction && (e === 'keyboard' || e === 'backdrop')) {
        this.props.handleNonButtonCancelAction();
      }
    }
  }]);
  return ModalComponent;
}(_react.Component);

exports.default = ModalComponent;


ModalComponent.propTypes = {
  quest: _propTypes2.default.object,
  klass: _propTypes2.default.string,
  modalId: _propTypes2.default.string,
  headingKlass: _propTypes2.default.string,
  logoKlass: _propTypes2.default.string,
  headingText: _propTypes2.default.string,
  bodyText: _propTypes2.default.any,
  secondaryButtonAction: _propTypes2.default.func,
  secondaryButtonText: _propTypes2.default.string,
  primaryButtonAction: _propTypes2.default.func,
  primaryButtonText: _propTypes2.default.string,
  questLogo: _propTypes2.default.bool,
  primaryButtonDestructiveClass: _propTypes2.default.bool,
  setRawHtmlInBody: _propTypes2.default.bool,
  handleNonButtonCancelAction: _propTypes2.default.func
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(276);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(489);
var enumBugKeys = __webpack_require__(354);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(347);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(51).f;
var has = __webpack_require__(94);
var TAG = __webpack_require__(44)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(107);
var TAG = __webpack_require__(44)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var defined = __webpack_require__(121);
var fails = __webpack_require__(31);
var spaces = __webpack_require__(363);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_NOT_CHANGING_CURRENT_ORGANIZATION = exports.IS_CHANGING_CURRENT_ORGANIZATION = exports.SET_CURRENT_ORGANIZATION_ROLES = exports.SET_CURRENT_ORGANIZATION = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.setCurrentOrganizationAction = setCurrentOrganizationAction;
exports.setCurrentOrganizationRoles = setCurrentOrganizationRoles;
exports.isChangingCurrentOrganization = isChangingCurrentOrganization;
exports.isNotChangingCurrentOrganization = isNotChangingCurrentOrganization;
exports.setCurrentOrganization = setCurrentOrganization;

var _reactRouterRedux = __webpack_require__(23);

var _user = __webpack_require__(73);

var _users = __webpack_require__(299);

var _manifest = __webpack_require__(157);

var _questsfilters = __webpack_require__(301);

var _reviewqueuefilters = __webpack_require__(302);

var _queuefilters = __webpack_require__(396);

var _productionstatusfilters = __webpack_require__(397);

var _myquests = __webpack_require__(298);

var _tags = __webpack_require__(300);

var _logging = __webpack_require__(137);

var _routes = __webpack_require__(235);

var _mockcourses = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_CURRENT_ORGANIZATION = exports.SET_CURRENT_ORGANIZATION = 'SET_CURRENT_ORGANIZATION';

var SET_CURRENT_ORGANIZATION_ROLES = exports.SET_CURRENT_ORGANIZATION_ROLES = 'SET_CURRENT_ORGANIZATION_ROLES';
var IS_CHANGING_CURRENT_ORGANIZATION = exports.IS_CHANGING_CURRENT_ORGANIZATION = 'IS_CHANGING_CURRENT_ORGANIZATION';
var IS_NOT_CHANGING_CURRENT_ORGANIZATION = exports.IS_NOT_CHANGING_CURRENT_ORGANIZATION = 'IS_NOT_CHANGING_CURRENT_ORGANIZATION';

function setCurrentOrganizationAction(orgId) {
  return {
    type: SET_CURRENT_ORGANIZATION,
    orgId: orgId
  };
}

function setCurrentOrganizationRoles(roles) {
  return {
    type: SET_CURRENT_ORGANIZATION_ROLES,
    roles: roles
  };
}

function isChangingCurrentOrganization() {
  return {
    type: IS_CHANGING_CURRENT_ORGANIZATION
  };
}

function isNotChangingCurrentOrganization() {
  return {
    type: IS_NOT_CHANGING_CURRENT_ORGANIZATION
  };
}

function setCurrentOrganization(orgId, roles, refreshData) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var route;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!refreshData) {
                _context.next = 38;
                break;
              }

              _context.next = 3;
              return dispatch(isChangingCurrentOrganization());

            case 3:
              _context.next = 5;
              return dispatch((0, _questsfilters.clearSearchFilters)());

            case 5:
              _context.next = 7;
              return dispatch((0, _reviewqueuefilters.clearReviewQueueFilters)());

            case 7:
              _context.next = 9;
              return dispatch((0, _queuefilters.clearQueueFilters)());

            case 9:
              _context.next = 11;
              return dispatch((0, _productionstatusfilters.clearProductionStatusFilters)());

            case 11:
              _context.next = 13;
              return dispatch((0, _myquests.setDefaultMyQuestsFilters)());

            case 13:
              _context.next = 15;
              return dispatch(setCurrentOrganizationAction(orgId));

            case 15:
              _context.next = 17;
              return dispatch(setCurrentOrganizationRoles(roles));

            case 17:
              _context.next = 19;
              return dispatch((0, _users.getUsers)());

            case 19:
              _context.next = 21;
              return dispatch((0, _user.getUserData)());

            case 21:
              _context.next = 23;
              return dispatch((0, _manifest.fetchManifest)());

            case 23:
              _context.next = 25;
              return dispatch((0, _tags.fetchTags)());

            case 25:
              _context.next = 27;
              return dispatch((0, _mockcourses.fetchMockCourses)());

            case 27:
              _context.next = 29;
              return dispatch((0, _logging.postLoggingInfo)('user', {
                action: 'org_switch'
              }));

            case 29:
              _context.next = 31;
              return (0, _routes.getDefaultRoute)(roles);

            case 31:
              route = _context.sent;
              _context.next = 34;
              return dispatch((0, _reactRouterRedux.push)(route));

            case 34:
              _context.next = 36;
              return dispatch(isNotChangingCurrentOrganization());

            case 36:
              _context.next = 42;
              break;

            case 38:
              _context.next = 40;
              return dispatch(setCurrentOrganizationAction(orgId));

            case 40:
              _context.next = 42;
              return dispatch((0, _logging.postLoggingInfo)('user', {
                action: 'org_switch'
              }));

            case 42:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(562);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_PREFIX", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REHYDRATE", function() { return REHYDRATE; });
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isCancelable;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelledError; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isCancelledError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Retryer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__focusManager__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__onlineManager__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(60);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      Object(__WEBPACK_IMPORTED_MODULE_2__utils__["v" /* sleep */])(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!__WEBPACK_IMPORTED_MODULE_0__focusManager__["a" /* focusManager */].isFocused() || !__WEBPACK_IMPORTED_MODULE_1__onlineManager__["a" /* onlineManager */].isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var ReactBaseClasses = __webpack_require__(599);
var ReactChildren = __webpack_require__(1234);
var ReactDOMFactories = __webpack_require__(1239);
var ReactElement = __webpack_require__(208);
var ReactPropTypes = __webpack_require__(1240);
var ReactVersion = __webpack_require__(1245);

var createReactClass = __webpack_require__(1246);
var onlyChild = __webpack_require__(1247);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var ReactCurrentOwner = __webpack_require__(144);

var warning = __webpack_require__(40);
var canDefineProperty = __webpack_require__(601);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(602);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(1257);
var ReactInstrumentation = __webpack_require__(115);

var warning = __webpack_require__(40);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(424);
var setInnerHTML = __webpack_require__(318);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);
var setTextContent = __webpack_require__(613);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(110);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/PropTypes.js

var PropTypes_timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var PropTypes_classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react_default.a.createContext(null));
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition_Transition = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom_default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom_default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom_default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react_default.a.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react_default.a.cloneElement(react_default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(react_default.a.Component);

Transition_Transition.contextType = TransitionGroupContext;
Transition_Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition_Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition_Transition.UNMOUNTED = UNMOUNTED;
Transition_Transition.EXITED = EXITED;
Transition_Transition.ENTERING = ENTERING;
Transition_Transition.ENTERED = ENTERED;
Transition_Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition_Transition);
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var CSSTransition_removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition_CSSTransition = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      CSSTransition_removeClass(node, baseClassName);
    }

    if (activeClassName) {
      CSSTransition_removeClass(node, activeClassName);
    }

    if (doneClassName) {
      CSSTransition_removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/react_default.a.createElement(esm_Transition, Object(esm_extends["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react_default.a.Component);

CSSTransition_CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition_CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition_CSSTransition);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(438);

// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(react["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(react["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(react["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(react["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(react["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(react["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(react["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(react["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup_TransitionGroup = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(assertThisInitialized["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(esm_extends["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react_default.a.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react_default.a.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/react_default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react_default.a.Component);

TransitionGroup_TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup_TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup_TransitionGroup);
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/ReplaceTransition.js






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition_ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = react_default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : react_dom_default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = react_default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/react_default.a.createElement(esm_TransitionGroup, props, inProp ? react_default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : react_default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(react_default.a.Component);

ReplaceTransition_ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* harmony default export */ var esm_ReplaceTransition = (ReplaceTransition_ReplaceTransition);
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (react_default.a.isValidElement(oldChildren) && react_default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return react_default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, react_default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return react_default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, react_default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [react_default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, react_default.a.cloneElement(children, {
        in: true
      }));
    })
  }), react_default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition_SwitchTransition = /*#__PURE__*/function (_React$Component) {
  Object(inheritsLoose["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }

    return {
      current: react_default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;

      case EXITING:
        component = leaveRenders[mode](data);
        break;

      case ENTERED:
        component = current;
    }

    return /*#__PURE__*/react_default.a.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(react_default.a.Component);

SwitchTransition_SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition_SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ var esm_SwitchTransition = (SwitchTransition_SwitchTransition);
// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/index.js
/* unused concated harmony import CSSTransition */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_CSSTransition; });
/* unused concated harmony import ReplaceTransition */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_ReplaceTransition; });
/* unused concated harmony import SwitchTransition */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_SwitchTransition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return esm_TransitionGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_Transition; });
/* unused concated harmony import config */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return config; });







/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var PropTypes = __webpack_require__(1)

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = __webpack_require__(1376);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _DOMPositionUtils = __webpack_require__(1388);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import ImmutablePropTypes from 'react-immutable-proptypes';

var ReduxInfiniteScroll = function (_React$Component) {
  _inherits(ReduxInfiniteScroll, _React$Component);

  function ReduxInfiniteScroll(props) {
    _classCallCheck(this, ReduxInfiniteScroll);

    var _this = _possibleConstructorReturn(this, (ReduxInfiniteScroll.__proto__ || Object.getPrototypeOf(ReduxInfiniteScroll)).call(this, props));

    _this.scrollFunction = _this.scrollListener.bind(_this);
    return _this;
  }

  _createClass(ReduxInfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.attachScrollListener();
    }
  }, {
    key: '_findElement',
    value: function _findElement() {
      return this.props.elementIsScrollable ? _reactDom2.default.findDOMNode(this) : window;
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      if (!this.props.hasMore || this.props.loadingMore) return;
      var el = this._findElement();
      el.addEventListener('scroll', this.scrollFunction, true);
      el.addEventListener('resize', this.scrollFunction, true);
      this.scrollListener();
    }
  }, {
    key: '_elScrollListener',
    value: function _elScrollListener() {
      var el = _reactDom2.default.findDOMNode(this);

      if (this.props.horizontal) {
        var leftScrollPos = el.scrollLeft;
        var totalContainerWidth = el.scrollWidth;
        var containerFixedWidth = el.offsetWidth;
        var rightScrollPos = leftScrollPos + containerFixedWidth;

        return totalContainerWidth - rightScrollPos;
      }

      var topScrollPos = el.scrollTop;
      var totalContainerHeight = el.scrollHeight;
      var containerFixedHeight = el.offsetHeight;
      var bottomScrollPos = topScrollPos + containerFixedHeight;

      return totalContainerHeight - bottomScrollPos;
    }
  }, {
    key: '_windowScrollListener',
    value: function _windowScrollListener() {
      var el = _reactDom2.default.findDOMNode(this);

      if (this.props.horizontal) {
        var windowScrollLeft = window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
        var elTotalWidth = (0, _DOMPositionUtils.leftPosition)(el) + el.offsetWidth;
        var currentRightPosition = elTotalWidth - windowScrollLeft - window.innerWidth;

        return currentRightPosition;
      }

      var windowScrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var elTotalHeight = (0, _DOMPositionUtils.topPosition)(el) + el.offsetHeight;
      var currentBottomPosition = elTotalHeight - windowScrollTop - window.innerHeight;

      return currentBottomPosition;
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      // This is to prevent the upcoming logic from toggling a load more before
      // any data has been passed to the component
      if (this._totalItemsSize() <= 0) return;

      var bottomPosition = this.props.elementIsScrollable ? this._elScrollListener() : this._windowScrollListener();

      if (bottomPosition < Number(this.props.threshold)) {
        this.detachScrollListener();
        this.props.loadMore();
      }
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var el = this._findElement();
      el.removeEventListener('scroll', this.scrollFunction, true);
      el.removeEventListener('resize', this.scrollFunction, true);
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var allItems = this.props.children.concat(this.props.items);

      return allItems;
    }
  }, {
    key: '_totalItemsSize',
    value: function _totalItemsSize() {
      var totalSize = void 0;
      totalSize += this.props.children.size ? this.props.children.size : this.props.children.length;
      totalSize += this.props.items.size ? this.props.items.size : this.props.items.length;
      return totalSize;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return this.props.loadingMore && this.props.showLoader ? this.props.loader : undefined;
    }
  }, {
    key: '_assignHolderClass',
    value: function _assignHolderClass() {
      var additionalClass = void 0;
      additionalClass = typeof this.props.className === 'function' ? this.props.className() : this.props.className;

      return 'redux-infinite-scroll ' + additionalClass;
    }
  }, {
    key: '_renderWithTransitions',
    value: function _renderWithTransitions() {
      var allItems = this.props.children.concat(this.props.items);

      console.log('animating with tran');
      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: this.props.transitionName,
          transitionEnter: this.props.transitionEnter,
          transitionEnterTimeout: this.props.transitionEnterTimeout,
          transitionLeave: this.props.transitionLeave,
          transitionLeaveTimeout: this.props.transitionLeaveTimeout,
          transitionAppear: this.props.transitionAppear,
          transitionAppearTimeout: this.props.transitionAppearTimeout
        },
        allItems
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var Holder = this.props.holderType;

      return _react2.default.createElement(
        Holder,
        { className: this._assignHolderClass(), style: { height: this.props.containerHeight, overflow: 'scroll' } },
        this.props.animateItems ? this._renderWithTransitions() : this._renderOptions(),
        this.renderLoader()
      );
    }
  }]);

  return ReduxInfiniteScroll;
}(_react2.default.Component);

exports.default = ReduxInfiniteScroll;


ReduxInfiniteScroll.propTypes = {
  elementIsScrollable: PropTypes.bool,
  containerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  threshold: PropTypes.number,
  horizontal: PropTypes.bool,
  hasMore: PropTypes.bool,
  loadingMore: PropTypes.bool,
  loader: PropTypes.any,
  showLoader: PropTypes.bool,
  loadMore: PropTypes.func.isRequired,
  items: PropTypes.oneOfType([
  //ImmutablePropTypes.list,
  PropTypes.array]),
  children: PropTypes.oneOfType([
  //ImmutablePropTypes.list,
  PropTypes.array]),
  holderType: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  animateItems: PropTypes.bool,
  transitionName: PropTypes.string,
  transitionEnter: PropTypes.bool,
  transitionEnterTimeout: PropTypes.number,
  transitionLeave: PropTypes.bool,
  transitionLeaveTimeout: PropTypes.number,
  transitionAppear: PropTypes.bool,
  transitionAppearTimeout: PropTypes.number
};

ReduxInfiniteScroll.defaultProps = {
  className: '',
  elementIsScrollable: true,
  containerHeight: '100%',
  threshold: 100,
  horizontal: false,
  hasMore: true,
  loadingMore: false,
  loader: _react2.default.createElement(
    'div',
    { style: { textAlign: 'center' } },
    'Loading...'
  ),
  showLoader: true,
  holderType: 'div',
  children: [],
  items: [],
  animateItems: false,
  transitionName: 'redux-infinite-scroll',
  transitionEnter: true,
  transitionEnterTimeout: 2000,
  transitionLeave: true,
  transitionLeaveTimeout: 1000,
  transitionAppear: true,
  transitionAppearTimeout: 2000
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchArea = function (_Component) {
  (0, _inherits3.default)(SearchArea, _Component);

  function SearchArea(props) {
    (0, _classCallCheck3.default)(this, SearchArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchArea.__proto__ || (0, _getPrototypeOf2.default)(SearchArea)).call(this, props));

    _this.state = {
      selectedValues: props.values,
      active: props.values ? props.values.length > 0 : false
    };

    _this.handleSelectChangeBound = _this.handleSelectChange.bind(_this);
    _this.onClickBound = _this.onClick.bind(_this);
    _this.onBlurBound = _this.onBlur.bind(_this);
    _this[props.area] = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(SearchArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Hacky-css way to not display the clickable 'x' next to the sole author while editing
      if (this.props.authorEdit && this.props.values.length === 1) {
        document.getElementsByClassName('Select-value-icon')[0].style.display = 'none';
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Hacky-css way to test if down to one author while editing, and remove the clickable 'x'
      // and also to re-add the clickable 'x' if editing to more than 1 author
      if (this.props.authorEdit) {
        var nodeList = [].concat((0, _toConsumableArray3.default)(document.getElementsByClassName('Select-value-icon')));
        if (prevState.selectedValues.length > 1 && this.state.selectedValues.length === 1) {
          nodeList.forEach(function (e) {
            e.style.display = 'none';
          });
        } else if (prevState.selectedValues.length === 1 && this.state.selectedValues.length > 1) {
          nodeList.forEach(function (e) {
            e.style.display = 'unset';
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          area = _props.area,
          options = _props.options,
          placeholder = _props.placeholder,
          headerClass = _props.headerClass;


      return _react2.default.createElement(
        'div',
        {
          className: 'area ' + area + '-wrapper ' + (this.state.active ? 'active' : ''),
          onMouseDown: this.onClickBound,
          onBlur: this.onBlurBound
        },
        label && _react2.default.createElement(
          'label',
          { className: 'header ' + headerClass },
          label
        ),
        this.props.tagEdit && _react2.default.createElement(_reactSelect2.default.Creatable, {
          multi: true,
          options: options,
          value: this.state.selectedValues,
          onChange: this.handleSelectChangeBound,
          placeholder: placeholder
        }),
        !this.props.tagEdit && _react2.default.createElement(_reactSelect2.default, {
          ref: this[area],
          multi: !this.props.single,
          options: options,
          value: this.state.selectedValues,
          onChange: this.handleSelectChangeBound,
          placeholder: placeholder,
          clearable: !this.props.authorEdit,
          backspaceRemoves: this.props.authorEdit && this.state.selectedValues.length < 2 ? false : true,
          isLoading: this.props.loading
        })
      );
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(value) {
      this.setState({ selectedValues: value });
      if (this.props.filterAction) {
        if (this.props.single) {
          this.props.filterAction(value ? value.value : null);
        } else {
          this.props.dispatch(this.props.filterAction(value.map(function (v) {
            return v.value;
          })));
        }
        this.props.dispatch(this.props.fetchAction(1, true));
      } else {
        this.props.handleChange(value);
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _this2 = this;

      this.setState(function () {
        return {
          active: true
        };
      });
      if (!this.state.active) {
        setTimeout(function () {
          _this2[_this2.props.area].current.focus();
        }, 100);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (!this.state.selectedValues || this.state.selectedValues.length === 0) {
        this.setState(function () {
          return {
            active: false
          };
        });
      }
    }
  }]);
  return SearchArea;
}(_react.Component);

exports.default = SearchArea;


SearchArea.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  label: _propTypes2.default.string,
  area: _propTypes2.default.string.isRequired,
  filterAction: _propTypes2.default.func,
  values: _propTypes2.default.array,
  placeholder: _propTypes2.default.string,
  authorEdit: _propTypes2.default.bool,
  tagEdit: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  headerClass: _propTypes2.default.string,
  single: _propTypes2.default.bool,
  handleChange: _propTypes2.default.func,
  fetchAction: _propTypes2.default.func
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveQdUsers = exports.questManagers = exports.assignedUsers = exports.assignableUsers = exports.getqdUsers = undefined;

var _reselect = __webpack_require__(168);

var _getqdUsers = function _getqdUsers(state) {
  return state.users.items.filter(function (user) {
    return user.roles.includes('qm_editor') || user.roles.includes('qm_quest_manager') || user.roles.includes('qm_mentor_author');
  });
};

var _getActiveQdUsers = function _getActiveQdUsers(state) {
  return state.users.items.filter(function (user) {
    if (user.active) {
      return user.roles.includes('qm_editor') || user.roles.includes('qm_quest_manager') || user.roles.includes('qm_mentor_author');
    }
  });
};

var _assignableUsers = function _assignableUsers(state) {
  return state.users.items.filter(function (user) {
    if (user.active) {
      return user.roles.some(function (role) {
        return ['qm_editor', 'qm_copy_editor', 'qm_internal_review', 'qm_quest_manager', 'qm_mentor_author'].indexOf(role) > -1;
      });
    }
  });
};

var _assignedUsers = function _assignedUsers(state) {
  return state.users.items.filter(function (user) {
    return user.roles.some(function (role) {
      return ['qm_editor', 'qm_copy_editor', 'qm_internal_review', 'qm_quest_manager', 'qm_mentor_author'].indexOf(role) > -1;
    });
  });
};

var _getQuestManagers = function _getQuestManagers(state) {
  return state.users.items.filter(function (user) {
    if (user.active) {
      return user.roles.includes('qm_quest_manager');
    }
  });
};

var getqdUsers = exports.getqdUsers = (0, _reselect.createSelector)([_getqdUsers], function (users) {
  return users;
});

var assignableUsers = exports.assignableUsers = (0, _reselect.createSelector)([_assignableUsers], function (users) {
  return users;
});

var assignedUsers = exports.assignedUsers = (0, _reselect.createSelector)([_assignedUsers], function (users) {
  return users;
});

var questManagers = exports.questManagers = (0, _reselect.createSelector)([_getQuestManagers], function (users) {
  return users;
});

var getActiveQdUsers = exports.getActiveQdUsers = (0, _reselect.createSelector)([_getActiveQdUsers], function (users) {
  return users;
});

/***/ }),
/* 218 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1477)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(233);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.getDisplayAverageGradeLevelLabel = getDisplayAverageGradeLevelLabel;
exports.getDisplaySentimentLabel = getDisplaySentimentLabel;
exports.getReadabilityScoresState = getReadabilityScoresState;
exports.hasReadabilityStats = hasReadabilityStats;
exports.getSectionScores = getSectionScores;
exports.formatReadingTime = formatReadingTime;
exports.parseLongestSentenceWordCount = parseLongestSentenceWordCount;
exports.formatGradeLevelLabels = formatGradeLevelLabels;
exports.isMaxOrMinGradeLevel = isMaxOrMinGradeLevel;

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDisplayAverageGradeLevelLabel(gradeLevelLabel) {
  var displayLabel = void 0;

  if (gradeLevelLabel === 'elementary_school') {
    displayLabel = _messages.primaryElementarySchool;
  }

  if (gradeLevelLabel === 'middle_school') {
    displayLabel = _messages.primaryMiddleSchool;
  }

  if (gradeLevelLabel === 'high_school') {
    displayLabel = _messages.secondaryHighSchool;
  }

  if (gradeLevelLabel === 'undergraduate') {
    displayLabel = _messages.postsecondaryUndergraduateUniversity;
  }

  if (gradeLevelLabel === 'university_or_above') {
    displayLabel = _messages.collegeOrUniversityGraduateOrAbove;
  }

  return displayLabel;
}

function getDisplaySentimentLabel(sentiment) {
  var displayLabel = void 0;

  if (sentiment === 'Negative') {
    displayLabel = _messages.negative;
  }

  if (sentiment === 'Neutral (Moderately Negative)') {
    displayLabel = _messages.neutralModeratelyNegative;
  }

  if (sentiment === 'Neutral (Slightly Negative)') {
    displayLabel = _messages.neutralSlightlyNegative;
  }

  if (sentiment === 'Neutral') {
    displayLabel = _messages.neutral;
  }

  if (sentiment === 'Neutral (Slightly Positive)') {
    displayLabel = _messages.neutralSlightlyPositive;
  }

  if (sentiment === 'Neutral (Moderately Positive)') {
    displayLabel = _messages.neutralModeratelyPostive;
  }

  if (sentiment === 'Positive') {
    displayLabel = _messages.positive;
  }

  return displayLabel;
}

function getReadabilityScoresState(scores) {
  var state = '';
  if ((0, _keys2.default)(scores.stats).length === 0) {
    state = 'updating';
  } else if (!scores.stats.average_grade_level || scores.stats.average_grade_level.length === 0) {
    state = 'no-average-grade-level';
  } else {
    state = 'has-average-grade-level';
  }

  return state;
}

function hasReadabilityStats(quest, attributeName) {
  return Boolean(quest.readable_stats) && quest.readable_stats.length > 0 && quest.readable_stats.some(function (stat) {
    return stat.attribute_name === attributeName;
  });
}

function getSectionScores(quest, subsection) {
  return quest.readable_stats.find(function (score) {
    return score.attribute_name === subsection;
  });
}

function formatReadingTime(time) {
  return time.replace(/:/g, 'm ').concat('s');
}

function parseLongestSentenceWordCount(longestSentence) {
  var retVal = {
    wordCount: '',
    longestSentence: ''

    // TODO: Is there a nicer way to to do this????
  };retVal.wordCount = longestSentence.split(/\s(.+)/)[0];
  retVal.longestSentence = longestSentence.split(/\s(.+)/)[1].slice(2, -2);
  retVal.longestSentence = '"' + (retVal.longestSentence[0].toUpperCase() + retVal.longestSentence.slice(1)) + '"';
  retVal.longestSentence = retVal.longestSentence.replace(/(\s|^)\"([^\"]+)\"/g, '$1\u201C$2\u201D');
  return retVal;
}

function formatGradeLevelLabels(label) {
  var formattedLabel = '';
  switch (label) {
    case 'flesch_kincaid_grade_level':
      {
        formattedLabel = 'Flesch-Kincaid Grade Level';
        break;
      }
    case 'gunning_fog_score':
      {
        formattedLabel = 'Gunning-Fog Score';
        break;
      }
    case 'coleman_liau_index':
      {
        formattedLabel = 'Coleman-Liau Index';
        break;
      }
    case 'smog_index':
      {
        formattedLabel = 'SMOG Index';
        break;
      }
    case 'automated_readability_index':
      {
        formattedLabel = 'Automated Readability Index';
        break;
      }
    default:
      {
        formattedLabel = 'Unknown';
      }
  }

  return formattedLabel;
}

function isMaxOrMinGradeLevel(val, arr) {
  var valuesArray = arr.map(function (e) {
    return JSON.parse((0, _values2.default)(e)[0]);
  });
  return JSON.parse(val) === Math.min.apply(Math, (0, _toConsumableArray3.default)(valuesArray)) || JSON.parse(val) === Math.max.apply(Math, (0, _toConsumableArray3.default)(valuesArray));
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(734)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(485)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(105);
var global = __webpack_require__(29);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(151) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(107);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(24);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(24);
var aFunction = __webpack_require__(71);
var SPECIES = __webpack_require__(44)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 232 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1006), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSelectedAcademicYearGlobally = setSelectedAcademicYearGlobally;
exports.setCourseIsExpanded = setCourseIsExpanded;
exports.setLevelIsExpanded = setLevelIsExpanded;
exports.clearExpandedLevels = clearExpandedLevels;
var SET_SELECTED_ACADEMIC_YEAR_GLOBALLY = exports.SET_SELECTED_ACADEMIC_YEAR_GLOBALLY = 'SET_SELECTED_ACADEMIC_YEAR_GLOBALLY';
var SET_COURSE_IS_EXPANDED = exports.SET_COURSE_IS_EXPANDED = 'SET_COURSE_IS_EXPANDED';
var SET_LEVEL_IS_EXPANDED = exports.SET_LEVEL_IS_EXPANDED = 'SET_JOURNEY_IS_EXPANDED';
var CLEAR_EXPANDED_LEVELS = exports.CLEAR_EXPANDED_LEVELS = 'CLEAR_EXPANDED_JOURNEYS';

function setSelectedAcademicYearGlobally(academicYear) {
  return {
    type: SET_SELECTED_ACADEMIC_YEAR_GLOBALLY,
    payload: {
      academicYear: academicYear
    }
  };
}

function setCourseIsExpanded(id, isExpanded) {
  return {
    type: SET_COURSE_IS_EXPANDED,
    payload: {
      id: id,
      isExpanded: isExpanded
    }
  };
}

function setLevelIsExpanded(id, isExpanded) {
  return {
    type: SET_LEVEL_IS_EXPANDED,
    payload: {
      id: id,
      isExpanded: isExpanded
    }
  };
}

function clearExpandedLevels() {
  return {
    type: CLEAR_EXPANDED_LEVELS
  };
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAuthenticatedRoute = isAuthenticatedRoute;
exports.isFullWidthRoute = isFullWidthRoute;
exports.allowAccessToRoute = allowAccessToRoute;
exports.getDefaultRoute = getDefaultRoute;
function isAuthenticatedRoute(pathname) {
  var isLoginRoute = void 0,
      isResetPasswordRoute = void 0,
      isForgotPasswordRoute = void 0,
      isChangePasswordRoute = void 0,
      isUpdateAccountRoute = void 0;

  isLoginRoute = pathname.indexOf('/login') > -1;
  isResetPasswordRoute = pathname.indexOf('/resetpassword') > -1;
  isForgotPasswordRoute = pathname.indexOf('/forgotpassword') > -1;
  isChangePasswordRoute = pathname.indexOf('/changepassword') > -1;
  isUpdateAccountRoute = pathname.indexOf('/unlockaccount') > -1;

  return !isResetPasswordRoute && !isForgotPasswordRoute && !isLoginRoute && !isChangePasswordRoute && !isUpdateAccountRoute;
}

function isFullWidthRoute(pathname) {
  return pathname.indexOf('/mycourses') > -1;
}

function allowAccessToRoute(user, route) {
  if (route === 'mycourses') {
    return user.organization_roles.some(function (role) {
      return role === 'qm_mentor_author';
    });
  }

  if (route === 'myquests' || route === 'quests/add') {
    return user.organization_roles.some(function (role) {
      return role === 'qm_editor' || role === 'qm_quest_manager';
    });
  }

  if (route === 'queue') {
    return user.organization_roles.some(function (role) {
      return role === 'qm_internal_review' || role === 'qm_copy_editor' || role === 'qm_quest_manager';
    });
  }

  if (route === 'reviewqueue') {
    return user.organization_roles.some(function (role) {
      return role === 'qm_platform_review';
    });
  }

  if (route === 'quests' || route === 'productionstatus' || route === 'topicclouds') {
    return !user.organization_roles.some(function (role) {
      return role === 'qm_mentor_author';
    });
  }

  return false;
}

function getDefaultRoute(orgRoles) {
  var route = '';
  if (orgRoles.indexOf('qm_editor') > -1) {
    route = '/myquests';
  } else if (orgRoles.indexOf('qm_platform_review') > -1) {
    route = '/reviewqueue';
  } else if (orgRoles.indexOf('qm_internal_review') > -1 || orgRoles.indexOf('qm_copy_editor') > -1 || orgRoles.indexOf('qm_quest_manager') > -1) {
    route = '/queue';
  } else if (orgRoles.indexOf('qm_mentor_author') > -1) {
    route = '/mycourses';
  } else {
    route = '/quests';
  }

  return route;
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAllQuestsStatusFiltersFromClickedStatus = exports.setAllQuestsFiltersFromProductionStatusFilters = exports.logLevelsExpandClick = exports.postViewInfoToLogging = exports.setAllQuestsFiltersAndNavigate = exports.fetchProductionStatusCounts = exports.fetchProductionStatusCountsSuccess = exports.fetchProductionStatusCountsRequest = exports.SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS = exports.FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS = exports.FETCH_PRODUCTION_STATUS_COUNTS_REQUEST = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

__webpack_require__(47);

var _qs = __webpack_require__(551);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouterRedux = __webpack_require__(23);

var _questsfilters = __webpack_require__(301);

var _logging = __webpack_require__(137);

var _utils = __webpack_require__(20);

var _productionstatus = __webpack_require__(401);

var _string = __webpack_require__(124);

var _reviewtracking = __webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_PRODUCTION_STATUS_COUNTS_REQUEST = exports.FETCH_PRODUCTION_STATUS_COUNTS_REQUEST = 'FETCH_PRODUCTION_STATUS_COUNTS_REQUEST';
var FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS = exports.FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS = 'FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS';
var SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS = exports.SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS = 'SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS';

var fetchProductionStatusCountsRequest = function fetchProductionStatusCountsRequest() {
  return {
    type: FETCH_PRODUCTION_STATUS_COUNTS_REQUEST
  };
};

var fetchProductionStatusCountsSuccess = function fetchProductionStatusCountsSuccess(counts) {
  return {
    type: FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS,
    payload: {
      items: counts,
      totalCounts: (0, _productionstatus.getTotalCounts)(counts)
    }
  };
};

var setAllQuestsFiltersFromProductionStatusFilters = function setAllQuestsFiltersFromProductionStatusFilters(filterState) {
  return {
    type: SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS,
    payload: {
      filterState: filterState
    }
  };
};

var fetchProductionStatusCounts = function fetchProductionStatusCounts() {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, orgId, query, params, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              orgId = state.organization.orgId;
              query = (0, _productionstatus.getFilterQuery)(state.productionstatusfilters);
              params = _qs2.default.stringify({
                q: query
              }, { arrayFormat: 'brackets', encode: false });
              url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mock_levels/analytics?' + params;

              dispatch(fetchProductionStatusCountsRequest());
              _context.prev = 6;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 10;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 10:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 14;
              return response.json();

            case 14:
              json = _context.sent;

              dispatch(fetchProductionStatusCountsSuccess(json));
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t2 = _context['catch'](6);

              console.log(_context.t2);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[6, 18]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var setAllQuestsFiltersAndNavigate = function setAllQuestsFiltersAndNavigate(options) {
  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, loggingBody;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              _context2.next = 3;
              return dispatch((0, _questsfilters.clearSearchFilters)());

            case 3:
              _context2.next = 5;
              return dispatch(setAllQuestsFiltersFromProductionStatusFilters(state.productionstatusfilters));

            case 5:
              loggingBody = {};

              if (!options.status) {
                _context2.next = 10;
                break;
              }

              loggingBody.quest_status = options.status;
              _context2.next = 10;
              return dispatch(setAllQuestsStatusFiltersFromClickedStatus(options.status));

            case 10:
              if (!options.course) {
                _context2.next = 17;
                break;
              }

              loggingBody.intended_course = {
                id: options.course.course_id,
                name: options.course.course_name
              };
              _context2.next = 14;
              return dispatch((0, _questsfilters.setCourseFilter)({
                id: options.course.course_id,
                value: options.course.course_id,
                label: (0, _string.getTruncatedString)({
                  val: options.course.course_name,
                  len: 99999
                }),
                className: 'courseselect-option',
                style: {
                  color: '#' + options.course.color
                }
              }));

            case 14:
              if (!(state.productionstatusfilters.mock_level_id_in.length > 0)) {
                _context2.next = 17;
                break;
              }

              _context2.next = 17;
              return dispatch((0, _questsfilters.setLevelFilter)(state.productionstatusfilters.mock_level_id_in));

            case 17:
              if (!options.level) {
                _context2.next = 21;
                break;
              }

              loggingBody.intended_level = {
                id: options.level.mock_level_id,
                name: options.level.name,
                number: options.level.number
              };
              _context2.next = 21;
              return dispatch((0, _questsfilters.setLevelFilter)([options.level.mock_level_id]));

            case 21:
              dispatch((0, _reactRouterRedux.push)('/quests'));
              dispatch((0, _logging.postLoggingInfo)('quest_production_status', (0, _assign2.default)({
                action: 'count_click'
              }, loggingBody)));

            case 23:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var setAllQuestsStatusFiltersFromClickedStatus = function setAllQuestsStatusFiltersFromClickedStatus(selectedStatus) {
  return function (dispatch) {
    if (selectedStatus === 'draft') {
      dispatch((0, _questsfilters.setDraftFilter)(1));
      dispatch((0, _questsfilters.setStatusFilter)([]));
    } else if (selectedStatus === 'review returned') {
      dispatch((0, _questsfilters.setStatusFilter)([2]));
    } else if (selectedStatus === 'quality review') {
      dispatch((0, _questsfilters.setStatusFilter)([0, 4]));
    } else if (selectedStatus === 'copy edit') {
      dispatch((0, _questsfilters.setDraftFilter)(1));
      dispatch((0, _questsfilters.setStatusFilter)([]));
      dispatch((0, _questsfilters.setReviewTrackingStatus)(_reviewtracking.reviewTracking.find(function (rt) {
        return rt.backend_value === 'in_copy_edit';
      })));
    } else if (selectedStatus === 'exp/sub') {
      dispatch((0, _questsfilters.setDraftFilter)(1));
      dispatch((0, _questsfilters.setStatusFilter)([]));
      dispatch((0, _questsfilters.setReviewTrackingStatus)(_reviewtracking.reviewTracking.find(function (rt) {
        return rt.backend_value === 'in_internal_review';
      })));
    } else {
      dispatch((0, _questsfilters.setStatusFilter)([5]));
    }
  };
};

var postViewInfoToLogging = function postViewInfoToLogging() {
  return function (dispatch) {
    dispatch((0, _logging.postLoggingInfo)('quest_production_status', {
      action: 'view_all'
    }));
  };
};

var logLevelsExpandClick = function logLevelsExpandClick(course) {
  return function (dispatch) {
    dispatch((0, _logging.postLoggingInfo)('quest_production_status', {
      action: 'level_view',
      intended_course: {
        id: course.course_id,
        name: course.course_name
      }
    }));
  };
};

exports.fetchProductionStatusCountsRequest = fetchProductionStatusCountsRequest;
exports.fetchProductionStatusCountsSuccess = fetchProductionStatusCountsSuccess;
exports.fetchProductionStatusCounts = fetchProductionStatusCounts;
exports.setAllQuestsFiltersAndNavigate = setAllQuestsFiltersAndNavigate;
exports.postViewInfoToLogging = postViewInfoToLogging;
exports.logLevelsExpandClick = logLevelsExpandClick;
exports.setAllQuestsFiltersFromProductionStatusFilters = setAllQuestsFiltersFromProductionStatusFilters;
exports.setAllQuestsStatusFiltersFromClickedStatus = setAllQuestsStatusFiltersFromClickedStatus;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1052), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILED_QUEST_TOPICS = exports.RECEIVE_QUEST_TOPICS = exports.REQUEST_QUEST_TOPICS = exports.ADD_TOPIC_SUCCESS = exports.EDIT_TOPIC_CONTEXT_SUCCESS = exports.DELETE_TOPIC_SUCCESS = exports.SEARCH_TOPICS_FAILURE = exports.SEARCH_TOPICS_REQUEST = exports.SEARCH_TOPICS_SUCCESS = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.searchTopicsRequest = searchTopicsRequest;
exports.searchTopicsSuccess = searchTopicsSuccess;
exports.searchTopicsFailure = searchTopicsFailure;
exports.addTopicSuccess = addTopicSuccess;
exports.editTopicContextSuccess = editTopicContextSuccess;
exports.deleteTopicSuccess = deleteTopicSuccess;
exports.requestQuestTopics = requestQuestTopics;
exports.receiveQuestTopics = receiveQuestTopics;
exports.failedQuestTopics = failedQuestTopics;
exports.searchTopics = searchTopics;
exports.fetchQuestTopics = fetchQuestTopics;
exports.deleteTopic = deleteTopic;
exports.changeTopicContext = changeTopicContext;
exports.addTopic = addTopic;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_TOPICS_SUCCESS = exports.SEARCH_TOPICS_SUCCESS = 'SEARCH_TOPICS_SUCCESS';
var SEARCH_TOPICS_REQUEST = exports.SEARCH_TOPICS_REQUEST = 'SEARCH_TOPICS_REQUEST';
var SEARCH_TOPICS_FAILURE = exports.SEARCH_TOPICS_FAILURE = 'SEARCH_TOPICS_FAILURE';
var DELETE_TOPIC_SUCCESS = exports.DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS';
var EDIT_TOPIC_CONTEXT_SUCCESS = exports.EDIT_TOPIC_CONTEXT_SUCCESS = 'EDIT_TOPIC_CONTEXT_SUCCESS';
var ADD_TOPIC_SUCCESS = exports.ADD_TOPIC_SUCCESS = 'ADD_TOPIC_SUCCESS';
var REQUEST_QUEST_TOPICS = exports.REQUEST_QUEST_TOPICS = 'REQUEST_QUEST_TOPICS';
var RECEIVE_QUEST_TOPICS = exports.RECEIVE_QUEST_TOPICS = 'RECEIVE_QUEST_TOPICS';
var FAILED_QUEST_TOPICS = exports.FAILED_QUEST_TOPICS = 'FAILED_QUEST_TOPICS';

function searchTopicsRequest() {
  return {
    type: SEARCH_TOPICS_REQUEST
  };
}

function searchTopicsSuccess(response) {
  return {
    type: SEARCH_TOPICS_SUCCESS,
    topics: response.topics
  };
}

function searchTopicsFailure(error) {
  return (0, _actions.getErrorAction)(SEARCH_TOPICS_FAILURE, error);
}

function addTopicSuccess(response) {
  return {
    type: ADD_TOPIC_SUCCESS,
    topic: response
  };
}

function editTopicContextSuccess(response) {
  return {
    type: EDIT_TOPIC_CONTEXT_SUCCESS,
    topic: response
  };
}

function deleteTopicSuccess(topicId) {
  return {
    type: DELETE_TOPIC_SUCCESS,
    topicId: topicId
  };
}

function requestQuestTopics() {
  return {
    type: REQUEST_QUEST_TOPICS
  };
}

function receiveQuestTopics(response) {
  return {
    type: RECEIVE_QUEST_TOPICS,
    topics: response.topics
  };
}

function failedQuestTopics(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_TOPICS, error);
}

function searchTopics(query) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();

              dispatch(searchTopicsRequest());
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch((0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/topics/search', {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  q: {
                    name_or_description_cont: query
                  }
                })
              });

            case 6:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;

              dispatch(searchTopicsSuccess(json));
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t2 = _context['catch'](2);

              dispatch(searchTopicsFailure(_context.t2));

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 14]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchQuestTopics(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id + '/topics';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestTopics, receiveQuestTopics, failedQuestTopics);
  };
}

function deleteTopic(questId, topicId) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/topics/' + topicId;
              _context2.prev = 2;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);

              dispatch(deleteTopicSuccess(topicId));
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t2 = _context2['catch'](2);

              console.log(_context2.t2);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 11]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function changeTopicContext(questId, topicId, context) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/topics/' + topicId;
              data = new FormData();

              data.append('topic_quest[context]', context);
              _context3.prev = 4;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 8;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context3.t1 = _context3.sent;
              response = (0, _context3.t0)(_context3.t1);
              _context3.next = 12;
              return response.json();

            case 12:
              json = _context3.sent;

              dispatch(editTopicContextSuccess(json));
              _context3.next = 19;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t2 = _context3['catch'](4);

              console.log(_context3.t2);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 16]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function addTopic(questId, topicId, context) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/topics';
              data = new FormData();

              data.append('topic_quest[topic_id]', topicId.toString());
              data.append('topic_quest[context]', context);
              _context4.prev = 5;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 9;
              return fetch(url, {
                method: 'POST',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 9:
              _context4.t1 = _context4.sent;
              response = (0, _context4.t0)(_context4.t1);
              _context4.next = 13;
              return response.json();

            case 13:
              json = _context4.sent;

              dispatch(addTopicSuccess(json));
              _context4.next = 20;
              break;

            case 17:
              _context4.prev = 17;
              _context4.t2 = _context4['catch'](5);

              console.log(_context4.t2);

            case 20:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[5, 17]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_CURRENT_TOPIC_CLOUD = exports.FETCH_TOPIC_FAILURE = exports.FETCH_TOPIC_SUCCESS = exports.FETCH_TOPIC_REQUEST = exports.FETCH_TOPIC_CLOUD_FAILURE = exports.FETCH_TOPIC_CLOUD_SUCCESS = exports.FETCH_TOPIC_CLOUD_REQUEST = exports.FETCH_TOPIC_CLOUDS_FAILURE = exports.FETCH_TOPIC_CLOUDS_SUCCESS = exports.FETCH_TOPIC_CLOUDS_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchTopicCloudsRequest = fetchTopicCloudsRequest;
exports.fetchTopicCloudsSuccess = fetchTopicCloudsSuccess;
exports.fetchTopicCloudsFailure = fetchTopicCloudsFailure;
exports.fetchTopicCloudRequest = fetchTopicCloudRequest;
exports.fetchTopicCloudSuccess = fetchTopicCloudSuccess;
exports.fetchTopicCloudFailure = fetchTopicCloudFailure;
exports.fetchTopicRequest = fetchTopicRequest;
exports.fetchTopicSuccess = fetchTopicSuccess;
exports.fetchTopicFailure = fetchTopicFailure;
exports.clearCurrentTopicCloud = clearCurrentTopicCloud;
exports.fetchTopicClouds = fetchTopicClouds;
exports.fetchTopicCloud = fetchTopicCloud;
exports.fetchTopic = fetchTopic;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_TOPIC_CLOUDS_REQUEST = exports.FETCH_TOPIC_CLOUDS_REQUEST = 'FETCH_TOPIC_CLOUDS_REQUEST';
var FETCH_TOPIC_CLOUDS_SUCCESS = exports.FETCH_TOPIC_CLOUDS_SUCCESS = 'FETCH_TOPIC_CLOUDS_SUCCESS';
var FETCH_TOPIC_CLOUDS_FAILURE = exports.FETCH_TOPIC_CLOUDS_FAILURE = 'FETCH_TOPIC_CLOUDS_FAILURE';
var FETCH_TOPIC_CLOUD_REQUEST = exports.FETCH_TOPIC_CLOUD_REQUEST = 'FETCH_TOPIC_CLOUD_REQUEST';
var FETCH_TOPIC_CLOUD_SUCCESS = exports.FETCH_TOPIC_CLOUD_SUCCESS = 'FETCH_TOPIC_CLOUD_SUCCESS';
var FETCH_TOPIC_CLOUD_FAILURE = exports.FETCH_TOPIC_CLOUD_FAILURE = 'FETCH_TOPIC_CLOUD_FAILURE';
var FETCH_TOPIC_REQUEST = exports.FETCH_TOPIC_REQUEST = 'FETCH_TOPIC_REQUEST';
var FETCH_TOPIC_SUCCESS = exports.FETCH_TOPIC_SUCCESS = 'FETCH_TOPIC_SUCCESS';
var FETCH_TOPIC_FAILURE = exports.FETCH_TOPIC_FAILURE = 'FETCH_TOPIC_FAILURE';
var CLEAR_CURRENT_TOPIC_CLOUD = exports.CLEAR_CURRENT_TOPIC_CLOUD = 'CLEAR_CURRENT_TOPIC_CLOUD';

function fetchTopicCloudsRequest() {
  return {
    type: FETCH_TOPIC_CLOUDS_REQUEST
  };
}

function fetchTopicCloudsSuccess(response) {
  return {
    type: FETCH_TOPIC_CLOUDS_SUCCESS,
    topicclouds: response.topic_clouds
  };
}

function fetchTopicCloudsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_TOPIC_CLOUDS_FAILURE, error);
}

function fetchTopicCloudRequest() {
  return {
    type: FETCH_TOPIC_CLOUD_REQUEST
  };
}

function fetchTopicCloudSuccess(response) {
  return {
    type: FETCH_TOPIC_CLOUD_SUCCESS,
    topiccloud: response.topic_cloud
  };
}

function fetchTopicCloudFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_TOPIC_CLOUD_FAILURE, error);
}

function fetchTopicRequest() {
  return {
    type: FETCH_TOPIC_REQUEST
  };
}

function fetchTopicSuccess(response) {
  return {
    type: FETCH_TOPIC_SUCCESS,
    topic: response.topic
  };
}

function fetchTopicFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_TOPIC_FAILURE, error);
}

function clearCurrentTopicCloud() {
  return {
    type: CLEAR_CURRENT_TOPIC_CLOUD
  };
}

function fetchTopicClouds() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();

              dispatch(fetchTopicCloudsRequest());
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch((0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/topic_clouds', {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;

              dispatch(fetchTopicCloudsSuccess(json));
              // on load of the Topic Clouds route, we need to auto fetch the first topic cloud
              dispatch(fetchTopicCloud(json.topic_clouds[0].id));
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t2 = _context['catch'](2);

              dispatch(fetchTopicCloudsFailure(_context.t2));

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 15]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchTopicCloud(topicCloudId) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/topic_clouds/' + topicCloudId;


              dispatch(fetchTopicCloudRequest());

              _context2.prev = 3;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 7;
              return fetch(url, {
                method: 'GET',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 7:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 11;
              return response.json();

            case 11:
              json = _context2.sent;

              dispatch(fetchTopicCloudSuccess(json));
              // we need to auto fetch the first topic if there isn't one in state
              if (json.topic_cloud.topics.length > 0) {
                dispatch(fetchTopic(json.topic_cloud.topics[0].id));
              }
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t2 = _context2['catch'](3);

              dispatch(fetchTopicCloudFailure(_context2.t2));

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 16]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function fetchTopic(topicId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/topic_clouds/' + state.topicclouds.currentTopicCloud.id + '/topics/' + topicId;
    return (0, _api.basicGet)(state, dispatch, url, fetchTopicRequest, fetchTopicSuccess, fetchTopicFailure);
  };
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS = exports.FAILED_ACTIVITY_READABLE_STATS = exports.RECEIVE_ACTIVITY_READABLE_STATS = exports.REQUEST_ACTIVITY_READABLE_STATS = exports.EDIT_ACTIVITY_DETAILS_FAILURE = exports.EDIT_ACTIVITY_DETAILS_REQUEST = exports.EDIT_ACTIVITY_POSITION_SUCCESS = exports.CREATE_ACTIVITY_FAILURE = exports.CREATE_ACTIVITY_REQUEST = exports.CREATE_ACTIVITY_SUCCESS = exports.EDIT_QUEST_ACTIVITY_NOTE_FAILURE = exports.EDIT_QUEST_ACTIVITY_NOTE_SUCCESS = exports.EDIT_QUEST_ACTIVITY_NOTE_REQUEST = exports.CREATE_QUEST_ACTIVITY_NOTE_SUCCESS = exports.DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS = exports.EDIT_ACTIVITY_DETAILS_SUCCESS = exports.DELETE_ACTIVITY_SUCCESS = exports.FAILED_QUEST_ACTIVITY_NOTES = exports.RECEIVE_QUEST_ACTIVITY_NOTES = exports.REQUEST_QUEST_ACTIVITY_NOTES = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.requestQuestActivityNotes = requestQuestActivityNotes;
exports.receiveQuestActivityNotes = receiveQuestActivityNotes;
exports.editActivityDetailsFailure = editActivityDetailsFailure;
exports.editActivityDetailsRequest = editActivityDetailsRequest;
exports.editActivityPositionSuccess = editActivityPositionSuccess;
exports.createActivityFailure = createActivityFailure;
exports.createActivityRequest = createActivityRequest;
exports.createActivitySuccess = createActivitySuccess;
exports.editQuestActivityNotePositionSuccess = editQuestActivityNotePositionSuccess;
exports.editQuestActivityNoteFailure = editQuestActivityNoteFailure;
exports.editQuestActivityNoteSuccess = editQuestActivityNoteSuccess;
exports.editQuestActivityNoteRequest = editQuestActivityNoteRequest;
exports.createQuestActivityNoteSuccess = createQuestActivityNoteSuccess;
exports.deleteActivityMentorNoteSuccess = deleteActivityMentorNoteSuccess;
exports.editActivityDetailsSuccess = editActivityDetailsSuccess;
exports.deleteActivitySuccess = deleteActivitySuccess;
exports.failedQuestActivityNotes = failedQuestActivityNotes;
exports.requestActivityReadableStats = requestActivityReadableStats;
exports.receiveActivityReadableStats = receiveActivityReadableStats;
exports.fetchQuestActivityNotes = fetchQuestActivityNotes;
exports.deleteActivity = deleteActivity;
exports.editActivityDetails = editActivityDetails;
exports.deleteActivityMentorNote = deleteActivityMentorNote;
exports.createQuestActivityNote = createQuestActivityNote;
exports.editQuestActivityNote = editQuestActivityNote;
exports.editQuestActivityNotePosition = editQuestActivityNotePosition;
exports.createActivity = createActivity;
exports.editActivityPosition = editActivityPosition;
exports.fetchActivityReadableStats = fetchActivityReadableStats;

__webpack_require__(47);

var _reactRouterRedux = __webpack_require__(23);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _quest = __webpack_require__(66);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_QUEST_ACTIVITY_NOTES = exports.REQUEST_QUEST_ACTIVITY_NOTES = 'REQUEST_QUEST_ACTIVITY_NOTES';
var RECEIVE_QUEST_ACTIVITY_NOTES = exports.RECEIVE_QUEST_ACTIVITY_NOTES = 'RECEIVE_QUEST_ACTIVITY_NOTES';
var FAILED_QUEST_ACTIVITY_NOTES = exports.FAILED_QUEST_ACTIVITY_NOTES = 'FAILED_QUEST_ACTIVITY_NOTES';
var DELETE_ACTIVITY_SUCCESS = exports.DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
var EDIT_ACTIVITY_DETAILS_SUCCESS = exports.EDIT_ACTIVITY_DETAILS_SUCCESS = 'EDIT_ACTIVITY_DETAILS_SUCCESS';
var DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS = exports.DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS = 'DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS';
var CREATE_QUEST_ACTIVITY_NOTE_SUCCESS = exports.CREATE_QUEST_ACTIVITY_NOTE_SUCCESS = 'CREATE_QUEST_ACTIVITY_NOTE_SUCCESS';
var EDIT_QUEST_ACTIVITY_NOTE_REQUEST = exports.EDIT_QUEST_ACTIVITY_NOTE_REQUEST = 'EDIT_QUEST_ACTIVITY_NOTE_REQUEST';
var EDIT_QUEST_ACTIVITY_NOTE_SUCCESS = exports.EDIT_QUEST_ACTIVITY_NOTE_SUCCESS = 'EDIT_QUEST_ACTIVITY_NOTE_SUCCESS';
var EDIT_QUEST_ACTIVITY_NOTE_FAILURE = exports.EDIT_QUEST_ACTIVITY_NOTE_FAILURE = 'EDIT_QUEST_ACTIVITY_NOTE_FAILURE';
var CREATE_ACTIVITY_SUCCESS = exports.CREATE_ACTIVITY_SUCCESS = 'CREATE_ACTIVITY_SUCCESS';
var CREATE_ACTIVITY_REQUEST = exports.CREATE_ACTIVITY_REQUEST = 'CREATE_ACTIVITY_REQUEST';
var CREATE_ACTIVITY_FAILURE = exports.CREATE_ACTIVITY_FAILURE = 'CREATE_ACTIVITY_FAILURE';
var EDIT_ACTIVITY_POSITION_SUCCESS = exports.EDIT_ACTIVITY_POSITION_SUCCESS = 'EDIT_ACTIVITY_POSITION_SUCCESS';
var EDIT_ACTIVITY_DETAILS_REQUEST = exports.EDIT_ACTIVITY_DETAILS_REQUEST = 'EDIT_ACTIVITY_DETAILS_REQUEST';
var EDIT_ACTIVITY_DETAILS_FAILURE = exports.EDIT_ACTIVITY_DETAILS_FAILURE = 'EDIT_ACTIVITY_DETAILS_FAILURE';
var REQUEST_ACTIVITY_READABLE_STATS = exports.REQUEST_ACTIVITY_READABLE_STATS = 'REQUEST_ACTIVITY_READABLE_STATS';
var RECEIVE_ACTIVITY_READABLE_STATS = exports.RECEIVE_ACTIVITY_READABLE_STATS = 'RECEIVE_ACTIVITY_READABLE_STATS';
var FAILED_ACTIVITY_READABLE_STATS = exports.FAILED_ACTIVITY_READABLE_STATS = 'FAILED_ACTIVITY_READABLE_STATS';
var EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS = exports.EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS = 'EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS';

function requestQuestActivityNotes() {
  return {
    type: REQUEST_QUEST_ACTIVITY_NOTES
  };
}

function receiveQuestActivityNotes(response) {
  return {
    type: RECEIVE_QUEST_ACTIVITY_NOTES,
    notes: response.activity_notes
  };
}

function editActivityDetailsFailure(error) {
  return (0, _actions.getErrorAction)(EDIT_ACTIVITY_DETAILS_FAILURE, error);
}

function editActivityDetailsRequest() {
  return {
    type: EDIT_ACTIVITY_DETAILS_REQUEST
  };
}

function editActivityPositionSuccess(activityId, newIndex) {
  return {
    type: EDIT_ACTIVITY_POSITION_SUCCESS,
    payload: {
      activityId: activityId,
      newIndex: newIndex
    }
  };
}

function createActivityFailure(error) {
  return (0, _actions.getErrorAction)(CREATE_ACTIVITY_FAILURE, error);
}

function createActivityRequest() {
  return {
    type: CREATE_ACTIVITY_REQUEST
  };
}

function createActivitySuccess(response) {
  return {
    type: CREATE_ACTIVITY_SUCCESS,
    activity: response
  };
}

function editQuestActivityNotePositionSuccess(response, newIndex) {
  return {
    type: EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS,
    note: response,
    newIndex: newIndex
  };
}

function editQuestActivityNoteFailure(error) {
  return (0, _actions.getErrorAction)(EDIT_QUEST_ACTIVITY_NOTE_FAILURE, error);
}

function editQuestActivityNoteSuccess(response) {
  return {
    type: EDIT_QUEST_ACTIVITY_NOTE_SUCCESS,
    note: response
  };
}

function editQuestActivityNoteRequest() {
  return {
    type: EDIT_QUEST_ACTIVITY_NOTE_REQUEST
  };
}

function createQuestActivityNoteSuccess(response) {
  return {
    type: CREATE_QUEST_ACTIVITY_NOTE_SUCCESS,
    note: response
  };
}

function deleteActivityMentorNoteSuccess(noteId) {
  return {
    type: DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS,
    noteId: noteId
  };
}

function editActivityDetailsSuccess(activityId, activity) {
  return {
    type: EDIT_ACTIVITY_DETAILS_SUCCESS,
    activityId: activityId,
    activity: activity
  };
}

function deleteActivitySuccess(activityId) {
  return {
    type: DELETE_ACTIVITY_SUCCESS,
    activityId: activityId
  };
}

function failedQuestActivityNotes(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_ACTIVITY_NOTES, error);
}

function requestActivityReadableStats() {
  return {
    type: REQUEST_ACTIVITY_READABLE_STATS
  };
}

function receiveActivityReadableStats(response) {
  return {
    type: RECEIVE_ACTIVITY_READABLE_STATS,
    payload: {
      stats: response
    }
  };
}

function fetchQuestActivityNotes(id) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + id + '/activities/' + state.quest.activityId + '/notes';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestActivityNotes, receiveQuestActivityNotes, failedQuestActivityNotes);
  };
}

function deleteActivity(questId, activityId) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url, newState;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId;
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              _context.next = 10;
              return dispatch(deleteActivitySuccess(activityId));

            case 10:
              newState = getState();

              if (!newState.quest.activityId) {
                dispatch((0, _reactRouterRedux.push)('/quest/' + questId + '/activities'));
              } else {
                dispatch((0, _reactRouterRedux.push)('/quest/' + questId + '/activities/' + newState.quest.activityId));
              }
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t2 = _context['catch'](2);

              console.log(_context.t2);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 14]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function editActivityDetails(questId, activityId, activity) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(editActivityDetailsRequest());
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId;
              _context2.prev = 3;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 7;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  activity: activity
                })
              });

            case 7:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);

              dispatch(editActivityDetailsSuccess(activityId, activity));
              dispatch((0, _reactRouterRedux.push)('/quest/' + questId + '/activities/' + activityId));
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t2 = _context2['catch'](3);

              dispatch(editActivityDetailsFailure(_context2.t2));

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 13]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function deleteActivityMentorNote(questId, activityId, noteId) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/notes/' + noteId;
              _context3.prev = 2;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)(_context3.t1);

              dispatch(deleteActivityMentorNoteSuccess(noteId));
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t2 = _context3['catch'](2);

              console.log(_context3.t2);

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 11]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function createQuestActivityNote(questId, activityId, note) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/notes';

              dispatch((0, _quest.createMentorNote)());
              data = new FormData();

              data.append('note[description]', note.description || '');
              data.append('note[attachment]', note.file);
              _context4.prev = 6;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 10;
              return fetch(url, {
                method: 'POST',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 10:
              _context4.t1 = _context4.sent;
              response = (0, _context4.t0)(_context4.t1);
              _context4.next = 14;
              return response.json();

            case 14:
              json = _context4.sent;

              dispatch(createQuestActivityNoteSuccess(json));
              _context4.next = 21;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t2 = _context4['catch'](6);

              console.log(_context4.t2);

            case 21:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[6, 18]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function editQuestActivityNote(questId, activityId, noteId, description) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/notes/' + noteId;

              dispatch(editQuestActivityNoteRequest());
              data = new FormData();

              data.append('note[description]', description);
              _context5.prev = 5;
              _context5.t0 = _utils.checkHttpStatus;
              _context5.next = 9;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 9:
              _context5.t1 = _context5.sent;
              response = (0, _context5.t0)(_context5.t1);
              _context5.next = 13;
              return response.json();

            case 13:
              json = _context5.sent;

              dispatch(editQuestActivityNoteSuccess(json));
              _context5.next = 20;
              break;

            case 17:
              _context5.prev = 17;
              _context5.t2 = _context5['catch'](5);

              dispatch(editQuestActivityNoteFailure(_context5.t2));

            case 20:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[5, 17]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function editQuestActivityNotePosition(questId, activityId, noteId, newIndex) {
  var _this6 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/notes/' + noteId;
              data = new FormData();

              data.append('note[sort_order_position]', newIndex.toString());
              _context6.prev = 4;
              _context6.t0 = _utils.checkHttpStatus;
              _context6.next = 8;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context6.t1 = _context6.sent;
              response = (0, _context6.t0)(_context6.t1);
              _context6.next = 12;
              return response.json();

            case 12:
              json = _context6.sent;

              dispatch(editQuestActivityNotePositionSuccess(json, newIndex));
              _context6.next = 19;
              break;

            case 16:
              _context6.prev = 16;
              _context6.t2 = _context6['catch'](4);

              console.log(_context6.t2);

            case 19:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[4, 16]]);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
}

function createActivity(questId, activityName) {
  var _this7 = this;

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities';

              dispatch(createActivityRequest());
              _context7.prev = 3;
              _context7.t0 = _utils.checkHttpStatus;
              _context7.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  name: activityName,
                  quest_id: questId
                })
              });

            case 7:
              _context7.t1 = _context7.sent;
              response = (0, _context7.t0)(_context7.t1);
              _context7.next = 11;
              return response.json();

            case 11:
              json = _context7.sent;

              dispatch(createActivitySuccess(json));
              dispatch((0, _quest.setQuestSection)('activities', json.id));
              dispatch((0, _reactRouterRedux.push)('/quest/' + questId + '/activities/' + json.id + '/edit'));
              _context7.next = 21;
              break;

            case 17:
              _context7.prev = 17;
              _context7.t2 = _context7['catch'](3);

              dispatch(createActivityFailure(_context7.t2));
              window.alert('There was a problem creating the activity.');

            case 21:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7, [[3, 17]]);
    }));

    return function (_x13, _x14) {
      return _ref7.apply(this, arguments);
    };
  }();
}

function editActivityPosition(questId, activityId, newIndex) {
  var _this8 = this;

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch, getState) {
      var state, url, data;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId;
              data = new FormData();

              data.append('activity[activity_order_position]', newIndex.toString());
              _context8.prev = 4;
              _context8.t0 = _utils.checkHttpStatus;
              _context8.next = 8;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context8.t1 = _context8.sent;
              (0, _context8.t0)(_context8.t1);

              dispatch(editActivityPositionSuccess(activityId, newIndex));
              _context8.next = 16;
              break;

            case 13:
              _context8.prev = 13;
              _context8.t2 = _context8['catch'](4);

              console.log(_context8.t2);

            case 16:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8, [[4, 13]]);
    }));

    return function (_x15, _x16) {
      return _ref8.apply(this, arguments);
    };
  }();
}

function fetchActivityReadableStats(questId, activityId) {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/readable_stats';
    return (0, _api.basicGet)(state, dispatch, url, requestActivityReadableStats, receiveActivityReadableStats);
  };
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNASSIGN_QUEST_FROM_USER_SUCCESS = exports.IS_NOT_UNASSIGNING = exports.IS_UNASSIGNING = exports.ASSIGN_QUEST_TO_USER_FAILURE = exports.ASSIGN_QUEST_TO_USER_SUCCESS = exports.ASSIGN_QUEST_TO_USER_REQUEST = exports.IS_NOT_ASSIGNING = exports.IS_ASSIGNING = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.assignmentClick = assignmentClick;
exports.assignmentCancelClick = assignmentCancelClick;
exports.unassignmentClick = unassignmentClick;
exports.unassignmentCancelClick = unassignmentCancelClick;
exports.assignQuestToUserRequest = assignQuestToUserRequest;
exports.assignQuestToUserSuccess = assignQuestToUserSuccess;
exports.assignQuestToUserFailure = assignQuestToUserFailure;
exports.unassignQuestFromUserSuccess = unassignQuestFromUserSuccess;
exports.assignQuestToUser = assignQuestToUser;
exports.unassignQuestFromUser = unassignQuestFromUser;

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_ASSIGNING = exports.IS_ASSIGNING = 'IS_ASSIGNING';
var IS_NOT_ASSIGNING = exports.IS_NOT_ASSIGNING = 'IS_NOT_ASSIGNING';
var ASSIGN_QUEST_TO_USER_REQUEST = exports.ASSIGN_QUEST_TO_USER_REQUEST = 'ASSIGN_QUEST_TO_USER_REQUEST';
var ASSIGN_QUEST_TO_USER_SUCCESS = exports.ASSIGN_QUEST_TO_USER_SUCCESS = 'ASSIGN_QUEST_TO_USER_SUCCESS';
var ASSIGN_QUEST_TO_USER_FAILURE = exports.ASSIGN_QUEST_TO_USER_FAILURE = 'ASSIGN_QUEST_TO_USER_FAILURE';
var IS_UNASSIGNING = exports.IS_UNASSIGNING = 'IS_UNASSIGNING';
var IS_NOT_UNASSIGNING = exports.IS_NOT_UNASSIGNING = 'IS_NOT_UNASSIGNING';
var UNASSIGN_QUEST_FROM_USER_SUCCESS = exports.UNASSIGN_QUEST_FROM_USER_SUCCESS = 'UNASSIGN_QUEST_FROM_USER_SUCCESS';

function assignmentClick() {
  return {
    type: IS_ASSIGNING
  };
}

function assignmentCancelClick() {
  return {
    type: IS_NOT_ASSIGNING
  };
}

function unassignmentClick() {
  return {
    type: IS_UNASSIGNING
  };
}

function unassignmentCancelClick() {
  return {
    type: IS_NOT_UNASSIGNING
  };
}

function assignQuestToUserRequest() {
  return {
    type: ASSIGN_QUEST_TO_USER_REQUEST
  };
}

function assignQuestToUserSuccess(response, questId, currentUser) {
  return {
    type: ASSIGN_QUEST_TO_USER_SUCCESS,
    payload: {
      assignment: response,
      questId: questId,
      currentUser: currentUser
    }
  };
}

function assignQuestToUserFailure(error) {
  return (0, _actions.getErrorAction)(ASSIGN_QUEST_TO_USER_FAILURE, error);
}

function unassignQuestFromUserSuccess(assignedToCurrentUser) {
  return {
    type: UNASSIGN_QUEST_FROM_USER_SUCCESS,
    assignedToCurrentUser: assignedToCurrentUser
  };
}

function assignQuestToUser(assignedToId, assignmentMessage, questId, currentUser) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(assignQuestToUserRequest());

              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/assignments';
              _context.prev = 3;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify2.default)({
                  assignment: {
                    assigned_to_id: assignedToId,
                    message: assignmentMessage
                  }
                })
              });

            case 7:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 11;
              return response.json();

            case 11:
              json = _context.sent;

              dispatch(assignQuestToUserSuccess(json, questId, currentUser));
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t2 = _context['catch'](3);

              dispatch(assignQuestToUserFailure(_context.t2));

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 15]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function unassignQuestFromUser(questId, assignedToCurrentUser, assignmentId) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/assignments/' + assignmentId;
              _context2.prev = 2;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1'
                }
              });

            case 6:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);


              dispatch(unassignQuestFromUserSuccess(assignedToCurrentUser));
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t2 = _context2['catch'](2);

              console.log(_context2.t2);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 11]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.questsSearchFiltersAreDirty = undefined;

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.filterQuestsForExternalReviewer = filterQuestsForExternalReviewer;
exports.getQuestFilterQuery = getQuestFilterQuery;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterQuestsForExternalReviewer(quests) {
  return quests.filter(function (quest) {
    return quest.visible_for_external_review;
  });
}

function getQuestFilterQuery(filterState, orgId, user) {
  var query = {};

  query.organization_id_eq = orgId;

  if (filterState.reviewing_compiled_quest_state_null) {
    query.reviewing_compiled_quest_state_null = filterState.reviewing_compiled_quest_state_null;
  }

  if (filterState.authors_id_in && filterState.authors_id_in.length > 0) {
    query.authors_id_in = filterState.authors_id_in;
  }

  if (filterState.questtags_id_in && filterState.questtags_id_in.length > 0) {
    query.questtags_id_in = filterState.questtags_id_in;
  }

  if (filterState.reviewing_compiled_quest_state_in && filterState.reviewing_compiled_quest_state_in.length > 0) {
    query.reviewing_compiled_quest_state_in = filterState.reviewing_compiled_quest_state_in;
  }

  if (filterState.name_or_description_cont && filterState.name_or_description_cont.trim() !== '') {
    query.name_or_description_cont = filterState.name_or_description_cont;
  }

  if (user.organization_roles && user.organization_roles.indexOf('qm_external_review') > -1) {
    query.visible_for_external_review_true = true;
  }

  if (filterState.quest_subject_id_in && filterState.quest_subject_id_in.length > 0) {
    query.quest_subject_id_in = filterState.quest_subject_id_in;
  }

  if (filterState.assigned_to_id_in && filterState.assigned_to_id_in.length > 0) {
    query.assigned_to_id_in = filterState.assigned_to_id_in;
  }

  if (filterState.grade_levels_id_in && filterState.grade_levels_id_in.length > 0) {
    query.grade_levels_id_in = filterState.grade_levels_id_in;
  }

  if (filterState.state_in && filterState.state_in.length > 0) {
    query.state_in = filterState.state_in;
  }

  // storing object in redux, sending array of one id to BE
  if (filterState.mock_course_id_in) {
    query.mock_course_id_in = [filterState.mock_course_id_in.id];
  }

  if (filterState.mock_level_id_in && filterState.mock_level_id_in.length > 0) {
    query.mock_level_id_in = filterState.mock_level_id_in;
  }

  if (filterState.need_final_review) {
    query.need_final_review = filterState.need_final_review;
  }

  if (filterState.need_standards_review) {
    query.need_standards_review = filterState.need_standards_review;
  }

  if (filterState.reviewTrackingStatus && filterState.reviewTrackingStatus !== null) {
    query.in_internal_review = filterState.reviewTrackingStatus.in_internal_review;
    query.in_copy_edit = filterState.reviewTrackingStatus.in_copy_edit;
  }

  if (filterState.reviewTrackingStatus && filterState.reviewTrackingStatus === null) {
    query.in_internal_review = false;
    query.in_copy_edit = false;
  }

  return query;
}

var questsSearchFiltersAreDirty = exports.questsSearchFiltersAreDirty = function questsSearchFiltersAreDirty(filtersState) {
  return !!(filtersState.assignedToFilters && filtersState.assignedToFilters.length > 0 || filtersState.authorFilters && filtersState.authorFilters.length > 0 || filtersState.courseFilter && (0, _keys2.default)(filtersState.courseFilter).length > 0 || filtersState.hasOwnProperty('allStatusChecked') && !filtersState.allStatusChecked || filtersState.gradeFilters && filtersState.gradeFilters.length > 0 || filtersState.keywordFilter && filtersState.keywordFilter.length > 0 || filtersState.levelFilters && filtersState.levelFilters.length > 0 || filtersState.primarySubjectFilters && filtersState.primarySubjectFilters.length > 0 || filtersState.reviewTrackingStatus && (0, _keys2.default)(filtersState.reviewTrackingStatus).length > 0 || filtersState.statusFilters && filtersState.statusFilters.length > 0 || filtersState.tagFilters && filtersState.tagFilters.length > 0);
};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retryer__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CancelledError", function() { return __WEBPACK_IMPORTED_MODULE_0__retryer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queryCache__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryCache", function() { return __WEBPACK_IMPORTED_MODULE_1__queryCache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryClient__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryClient", function() { return __WEBPACK_IMPORTED_MODULE_2__queryClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryObserver__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryObserver", function() { return __WEBPACK_IMPORTED_MODULE_3__queryObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__queriesObserver__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueriesObserver", function() { return __WEBPACK_IMPORTED_MODULE_4__queriesObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infiniteQueryObserver__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteQueryObserver", function() { return __WEBPACK_IMPORTED_MODULE_5__infiniteQueryObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutationCache__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MutationCache", function() { return __WEBPACK_IMPORTED_MODULE_6__mutationCache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutationObserver__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MutationObserver", function() { return __WEBPACK_IMPORTED_MODULE_7__mutationObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logger__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setLogger", function() { return __WEBPACK_IMPORTED_MODULE_8__logger__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notifyManager__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "notifyManager", function() { return __WEBPACK_IMPORTED_MODULE_9__notifyManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__focusManager__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "focusManager", function() { return __WEBPACK_IMPORTED_MODULE_10__focusManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__onlineManager__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "onlineManager", function() { return __WEBPACK_IMPORTED_MODULE_11__onlineManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashQueryKey", function() { return __WEBPACK_IMPORTED_MODULE_12__utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isError", function() { return __WEBPACK_IMPORTED_MODULE_12__utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isCancelledError", function() { return __WEBPACK_IMPORTED_MODULE_0__retryer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hydration__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "dehydrate", function() { return __WEBPACK_IMPORTED_MODULE_13__hydration__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return __WEBPACK_IMPORTED_MODULE_13__hydration__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__types__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_14__types__) if(["CancelledError","QueryCache","QueryClient","QueryObserver","QueriesObserver","InfiniteQueryObserver","MutationCache","MutationObserver","setLogger","notifyManager","focusManager","onlineManager","hashQueryKey","isError","isCancelledError","dehydrate","hydrate","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_14__types__[key]; }) }(__WEBPACK_IMPORT_KEY__));














 // Types



/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  height: ', ';\n  min-width: ', ';\n  border-radius: 20px;\n  background: ', ';\n  background-size: 100%;\n  color: ', ';\n  font-weight: 500;\n  padding: ', ';\n  cursor: ', ';\n  pointer-events: ', ';\n  transition: all 0.4s;\n  outline: none;\n  z-index: 1;\n  font-size: ', ';\n  line-height: ', ';\n\n  &:before {\n    border-radius: inherit;\n    background-image: linear-gradient(#444, #444);\n    content: \'\';\n    display: block;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    width: 100%;\n    z-index: -100;\n    transition: opacity 0.4s;\n  }\n\n  &:hover {\n    color: #ffffff;\n    box-shadow: 0px 4px 2.85px 0.15px rgba(0, 0, 0, 0.1);\n\n    &:before {\n      opacity: 1;\n    }\n  }\n'], ['\n  position: relative;\n  height: ', ';\n  min-width: ', ';\n  border-radius: 20px;\n  background: ', ';\n  background-size: 100%;\n  color: ', ';\n  font-weight: 500;\n  padding: ', ';\n  cursor: ', ';\n  pointer-events: ', ';\n  transition: all 0.4s;\n  outline: none;\n  z-index: 1;\n  font-size: ', ';\n  line-height: ', ';\n\n  &:before {\n    border-radius: inherit;\n    background-image: linear-gradient(#444, #444);\n    content: \'\';\n    display: block;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    width: 100%;\n    z-index: -100;\n    transition: opacity 0.4s;\n  }\n\n  &:hover {\n    color: #ffffff;\n    box-shadow: 0px 4px 2.85px 0.15px rgba(0, 0, 0, 0.1);\n\n    &:before {\n      opacity: 1;\n    }\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonA = _styledComponents2.default.button.withConfig({
  displayName: 'ButtonA',
  componentId: 'sc-1d5p0lx-0'
})(_templateObject, function (props) {
  return props.small ? '30px' : '40px';
}, function (props) {
  return props.small ? '100px' : '80px';
}, function (props) {
  return props.disabled ? '#cccccc' : '#F7BE07';
}, function (props) {
  return props.disabled ? '#ffffff' : '#000000';
}, function (props) {
  return props.small ? '0 22px' : '0 30px';
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : 'auto';
}, function (props) {
  return props.small ? '14px' : '16px';
}, function (props) {
  return props.small ? '14px' : '16px';
});

exports.default = ButtonA;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectorComponent = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  padding-left: 3px;\n'], ['\n  color: ', ';\n  padding-left: 3px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _DefaultSelectComponent = __webpack_require__(1191);

var _DefaultSelectComponent2 = _interopRequireDefault(_DefaultSelectComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SelectorComponent__SelectorContainer',
  componentId: 'sc-1ismgrj-0'
})(_templateObject);
var AsteriskSymbol = _styledComponents2.default.span.withConfig({
  displayName: 'SelectorComponent__AsteriskSymbol',
  componentId: 'sc-1ismgrj-1'
})(_templateObject2, _colors2.default.crimson);

var SelectorComponent = exports.SelectorComponent = function SelectorComponent(_ref) {
  var placeholder = _ref.placeholder,
      handleSelectedValueChange = _ref.handleSelectedValueChange,
      selectedValue = _ref.selectedValue,
      options = _ref.options,
      shouldDisplayAsterisk = _ref.shouldDisplayAsterisk;

  return _react2.default.createElement(
    SelectorContainer,
    null,
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      placeholder,
      shouldDisplayAsterisk && _react2.default.createElement(
        AsteriskSymbol,
        null,
        '*'
      )
    ),
    _react2.default.createElement(_DefaultSelectComponent2.default, {
      placeholder: placeholder,
      handleSelectedValueChange: handleSelectedValueChange,
      selectedValue: selectedValue,
      options: options
    })
  );
};

SelectorComponent.propTypes = {
  handleSelectedValueChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string.isRequired,
  selectedValue: _propTypes2.default.object.isRequired,
  options: _propTypes2.default.array.isRequired,
  shouldDisplayAsterisk: _propTypes2.default.bool.isRequired
};

exports.default = SelectorComponent;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reorderActivityCourseJourney = exports.editActivityCourseJourney = exports.deleteActivityCourseJourney = exports.createNewCourseJourney = exports.fetchActivityCourseJourney = exports.fetchActivityCourse = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchActivityCourse = exports.fetchActivityCourse = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(orgId, token, activityCourseId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses/' + activityCourseId;
            _context.prev = 1;
            _context.t0 = _utils.checkHttpStatus;
            _context.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt('return', _context.sent);

          case 12:
            _context.prev = 12;
            _context.t2 = _context['catch'](1);

            console.log('ERROR', _context.t2);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 12]]);
  }));

  return function fetchActivityCourse(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var fetchActivityCourseJourney = exports.fetchActivityCourseJourney = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(orgId, token, activityCourseId, journeyId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId;
            _context2.prev = 1;
            _context2.t0 = _utils.checkHttpStatus;
            _context2.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 5:
            _context2.t1 = _context2.sent;
            response = (0, _context2.t0)(_context2.t1);
            _context2.next = 9;
            return response.json();

          case 9:
            return _context2.abrupt('return', _context2.sent);

          case 12:
            _context2.prev = 12;
            _context2.t2 = _context2['catch'](1);

            console.log('ERROR', _context2.t2);

          case 15:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[1, 12]]);
  }));

  return function fetchActivityCourseJourney(_x4, _x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var createNewCourseJourney = exports.createNewCourseJourney = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(apiData, courseId, journeyName, journeyDescription) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + courseId + '/courses';
            data = {
              course: { name: journeyName, description: journeyDescription }
            };
            _context3.prev = 2;
            _context3.t0 = _utils.checkHttpStatus;
            _context3.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context3.t1 = _context3.sent;
            response = (0, _context3.t0)(_context3.t1);
            _context3.next = 10;
            return response.json();

          case 10:
            return _context3.abrupt('return', _context3.sent);

          case 13:
            _context3.prev = 13;
            _context3.t2 = _context3['catch'](2);

            console.log('ERROR', _context3.t2);

          case 16:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[2, 13]]);
  }));

  return function createNewCourseJourney(_x8, _x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

var deleteActivityCourseJourney = exports.deleteActivityCourseJourney = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(apiData, activityCourseId, journeyId) {
    var url;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId;
            _context4.prev = 1;
            _context4.t0 = _utils.checkHttpStatus;
            _context4.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context4.t1 = _context4.sent;
            (0, _context4.t0)(_context4.t1);
            _context4.next = 12;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t2 = _context4['catch'](1);

            console.log('ERROR', _context4.t2);

          case 12:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[1, 9]]);
  }));

  return function deleteActivityCourseJourney(_x12, _x13, _x14) {
    return _ref4.apply(this, arguments);
  };
}();

var editActivityCourseJourney = exports.editActivityCourseJourney = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(apiData, activityCourseId, journeyId, journeyName, journeyDescription) {
    var url, response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId;
            _context5.prev = 1;
            _context5.t0 = _utils.checkHttpStatus;
            _context5.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                course: {
                  name: journeyName,
                  description: journeyDescription
                }
              })
            });

          case 5:
            _context5.t1 = _context5.sent;
            response = (0, _context5.t0)(_context5.t1);
            _context5.next = 9;
            return response.json();

          case 9:
            return _context5.abrupt('return', _context5.sent);

          case 12:
            _context5.prev = 12;
            _context5.t2 = _context5['catch'](1);

            console.log(_context5.t2);

          case 15:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[1, 12]]);
  }));

  return function editActivityCourseJourney(_x15, _x16, _x17, _x18, _x19) {
    return _ref5.apply(this, arguments);
  };
}();

var reorderActivityCourseJourney = exports.reorderActivityCourseJourney = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(apiData, activityCourseId, journeyId, index) {
    var url, response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/update_position';
            _context6.prev = 1;
            _context6.t0 = _utils.checkHttpStatus;
            _context6.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                course: {
                  sort_order_position: index
                }
              })
            });

          case 5:
            _context6.t1 = _context6.sent;
            response = (0, _context6.t0)(_context6.t1);
            _context6.next = 9;
            return response.json();

          case 9:
            return _context6.abrupt('return', _context6.sent);

          case 12:
            _context6.prev = 12;
            _context6.t2 = _context6['catch'](1);

            console.log('ERROR', _context6.t2);

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[1, 12]]);
  }));

  return function reorderActivityCourseJourney(_x20, _x21, _x22, _x23) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reorderJourneyLevels = exports.fetchJourneyLevel = exports.editJourneyLevel = exports.deleteJourneyLevel = exports.createNewJourneyLevel = exports.fetchJourneyLevels = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchJourneyLevels = exports.fetchJourneyLevels = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(apiData, activityCourseId, journeyId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/levels';
            _context.prev = 1;
            _context.t0 = _utils.checkHttpStatus;
            _context.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt('return', _context.sent);

          case 12:
            _context.prev = 12;
            _context.t2 = _context['catch'](1);

            console.log(_context.t2);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 12]]);
  }));

  return function fetchJourneyLevels(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var createNewJourneyLevel = exports.createNewJourneyLevel = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(apiData, activityCourseId, journeyId, levelName, levelDescription, levelMastery) {
    var url, data, response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/levels';
            data = {
              level: {
                name: levelName,
                description: levelDescription,
                mastery: levelMastery
              }
            };
            _context2.prev = 2;
            _context2.t0 = _utils.checkHttpStatus;
            _context2.next = 6;
            return fetch(url, {
              method: 'POST',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)(data)
            });

          case 6:
            _context2.t1 = _context2.sent;
            response = (0, _context2.t0)(_context2.t1);
            _context2.next = 10;
            return response.json();

          case 10:
            return _context2.abrupt('return', _context2.sent);

          case 13:
            _context2.prev = 13;
            _context2.t2 = _context2['catch'](2);

            console.log(_context2.t2);

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[2, 13]]);
  }));

  return function createNewJourneyLevel(_x4, _x5, _x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

var deleteJourneyLevel = exports.deleteJourneyLevel = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(apiData, activityCourseId, journeyId, levelId) {
    var url;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/levels/' + levelId;
            _context3.prev = 1;
            _context3.t0 = _utils.checkHttpStatus;
            _context3.next = 5;
            return fetch(url, {
              method: 'DELETE',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context3.t1 = _context3.sent;
            (0, _context3.t0)(_context3.t1);
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t2 = _context3['catch'](1);

            console.log(_context3.t2);

          case 12:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[1, 9]]);
  }));

  return function deleteJourneyLevel(_x10, _x11, _x12, _x13) {
    return _ref3.apply(this, arguments);
  };
}();

var editJourneyLevel = exports.editJourneyLevel = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(apiData, activityCourseId, journeyId, levelId, levelName, levelDescription, levelMastery) {
    var url, response;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/levels/' + levelId;
            _context4.prev = 1;
            _context4.t0 = _utils.checkHttpStatus;
            _context4.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                level: {
                  name: levelName,
                  description: levelDescription,
                  mastery: levelMastery
                }
              })
            });

          case 5:
            _context4.t1 = _context4.sent;
            response = (0, _context4.t0)(_context4.t1);
            _context4.next = 9;
            return response.json();

          case 9:
            return _context4.abrupt('return', _context4.sent);

          case 12:
            _context4.prev = 12;
            _context4.t2 = _context4['catch'](1);

            console.log(_context4.t2);

          case 15:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[1, 12]]);
  }));

  return function editJourneyLevel(_x14, _x15, _x16, _x17, _x18, _x19, _x20) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchJourneyLevel = exports.fetchJourneyLevel = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(apiData, activityCourseId, journeyId, levelId) {
    var url, response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/levels/' + levelId;
            _context5.prev = 1;
            _context5.t0 = _utils.checkHttpStatus;
            _context5.next = 5;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token)
            });

          case 5:
            _context5.t1 = _context5.sent;
            response = (0, _context5.t0)(_context5.t1);
            _context5.next = 9;
            return response.json();

          case 9:
            return _context5.abrupt('return', _context5.sent);

          case 12:
            _context5.prev = 12;
            _context5.t2 = _context5['catch'](1);

            console.log(_context5.t2);

          case 15:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[1, 12]]);
  }));

  return function fetchJourneyLevel(_x21, _x22, _x23, _x24) {
    return _ref5.apply(this, arguments);
  };
}();

var reorderJourneyLevels = exports.reorderJourneyLevels = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(apiData, activityCourseId, journeyId, levels) {
    var url, response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(apiData.orgId) + '/mentor/master_courses/' + activityCourseId + '/courses/' + journeyId + '/reorder_levels';
            _context6.prev = 1;
            _context6.t0 = _utils.checkHttpStatus;
            _context6.next = 5;
            return fetch(url, {
              method: 'PATCH',
              headers: (0, _utils.getApiHeadersFromToken)(apiData.token),
              body: (0, _stringify2.default)({
                course: {
                  levels_order: levels
                }
              })
            });

          case 5:
            _context6.t1 = _context6.sent;
            response = (0, _context6.t0)(_context6.t1);
            _context6.next = 9;
            return response.json();

          case 9:
            return _context6.abrupt('return', _context6.sent);

          case 12:
            _context6.prev = 12;
            _context6.t2 = _context6['catch'](1);

            console.log('ERROR', _context6.t2);

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[1, 12]]);
  }));

  return function reorderJourneyLevels(_x25, _x26, _x27, _x28) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemTypes = undefined;

var _freeze = __webpack_require__(237);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTypes = exports.ItemTypes = (0, _freeze2.default)({
  JOURNEY_ROW: 'journeyRow',
  LEVEL_ROW: 'levelRow',
  ACTIVITY_ROW: 'activityRow',
  MENTOR_FILE_ROW: 'mentorFileRow',
  RESOURCE_ROW: 'resourceRow'
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSIjQkJCIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjxwYXRoIGQ9Ik0xLjQzNiAyLjg5NWgxNy44MTJNMS40MzYgN2gxNy44MTIiLz48L2c+PC9zdmc+"

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(252);
var EventPluginUtils = __webpack_require__(418);

var accumulateInto = __webpack_require__(605);
var forEachAccumulated = __webpack_require__(606);
var warning = __webpack_require__(40);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var EventPluginRegistry = __webpack_require__(417);
var EventPluginUtils = __webpack_require__(418);
var ReactErrorUtils = __webpack_require__(419);

var accumulateInto = __webpack_require__(605);
var forEachAccumulated = __webpack_require__(606);
var invariant = __webpack_require__(28);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

var getEventTarget = __webpack_require__(420);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMuiTheme__ = __webpack_require__(436);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createMuiTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMuiElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export teardown */
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFocusVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/index.js + 45 modules
var esm = __webpack_require__(92);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var utils_esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/index.js + 1 modules
var Portal = __webpack_require__(329);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(212);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(147);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(648);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(439);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(324);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(146);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(650);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(326);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/ModalManager.js





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(ownerDocument["a" /* default */])(container);

  if (doc.body === container) {
    return Object(ownerWindow["a" /* default */])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(toConsumableArray["a" /* default */])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = Object(getScrollbarSize["a" /* default */])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(ownerDocument["a" /* default */])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager_ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    Object(classCallCheck["a" /* default */])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(createClass["a" /* default */])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/index.js + 1 modules
var Unstable_TrapFocus = __webpack_require__(441);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/SimpleBackdrop.js




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop_SimpleBackdrop = /*#__PURE__*/react["forwardRef"](function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(esm_extends["a" /* default */])({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop_SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ var Modal_SimpleBackdrop = (SimpleBackdrop_SimpleBackdrop);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js

















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return react_dom["findDOMNode"](container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new ModalManager_ModalManager();
var Modal_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal_Modal = /*#__PURE__*/react["forwardRef"](function Modal(inProps, ref) {
  var theme = Object(esm["k" /* useTheme */])();
  var props = Object(esm["f" /* getThemeProps */])({
    name: 'MuiModal',
    props: Object(esm_extends["a" /* default */])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? Modal_SimpleBackdrop : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = react["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = react["useRef"]({});
  var mountNodeRef = react["useRef"](null);
  var modalRef = react["useRef"](null);
  var handleRef = Object(useForkRef["a" /* default */])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(ownerDocument["a" /* default */])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(useEventCallback["a" /* default */])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = react["useCallback"](function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(useEventCallback["a" /* default */])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  var handleClose = react["useCallback"](function () {
    manager.remove(getModal());
  }, [manager]);
  react["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  react["useEffect"](function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = Modal_styles(theme || {
    zIndex: zIndex["a" /* default */]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(createChainedFunction["a" /* default */])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(createChainedFunction["a" /* default */])(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/react["createElement"](Portal["a" /* default */], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(esm_extends["a" /* default */])({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/react["createElement"](BackdropComponent, Object(esm_extends["a" /* default */])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/react["createElement"](Unstable_TrapFocus["a" /* default */], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/react["cloneElement"](children, childProps))));
});
 false ? Modal_Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func,

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ var esm_Modal_Modal = (Modal_Modal);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Modal/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return esm_Modal_Modal; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return ModalManager_ModalManager; });



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(101);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/index.js + 12 modules
var esm = __webpack_require__(213);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(62);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/transitions/utils.js
var utils = __webpack_require__(214);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow_Grow = /*#__PURE__*/react["forwardRef"](function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm["a" /* Transition */] : _props$TransitionComp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = react["useRef"]();
  var autoTimeout = react["useRef"]();
  var theme = Object(useTheme["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react["useRef"](null);
  var foreignRef = Object(useForkRef["a" /* default */])(children.ref, ref);
  var handleRef = Object(useForkRef["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(utils["b" /* reflow */])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = Object(utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  react["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react["cloneElement"](children, Object(esm_extends["a" /* default */])({
      style: Object(esm_extends["a" /* default */])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow_Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow_Grow.muiSupportAuto = true;
/* harmony default export */ var esm_Grow_Grow = (Grow_Grow);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Grow/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_Grow_Grow; });


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var ListContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ListContext.displayName = 'ListContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ListContext);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(443);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js








var MenuItem_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.body1, Object(defineProperty["a" /* default */])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: Object(esm_extends["a" /* default */])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem_MenuItem = /*#__PURE__*/react["forwardRef"](function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/react["createElement"](ListItem["a" /* default */], Object(esm_extends["a" /* default */])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: Object(esm_extends["a" /* default */])({
      dense: classes.dense
    }, ListItemClasses),
    className: Object(clsx_m["a" /* default */])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem_MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: PropTypes.object,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
} : void 0;
/* harmony default export */ var esm_MenuItem_MenuItem = (Object(withStyles["a" /* default */])(MenuItem_styles, {
  name: 'MuiMenuItem'
})(MenuItem_MenuItem));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuItem/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return esm_MenuItem_MenuItem; });


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQwPusherApiKey = exports.getPusherApiKey = undefined;

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.unsubscribeFromAllChannelsWithPrefix = unsubscribeFromAllChannelsWithPrefix;
exports.hasNeededPusherConnection = hasNeededPusherConnection;

var _index = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
function unsubscribeFromAllChannelsWithPrefix(connection, prefix) {
  (0, _keys2.default)(connection.channels.channels).forEach(function (c) {
    if (c.indexOf(prefix) > -1) {
      connection.unsubscribe(c);
    }
  });
}

/* istanbul ignore next */
var getPusherApiKey = exports.getPusherApiKey = function getPusherApiKey() {
  // TODO: base this off config/build
  var key = '602419600735c6d08968';

  switch ((0, _index.getWindowLocationHostname)()) {
    case 'questmaker.questforward.org':
      key = '5cfd179ce9fb5571d06b';
      break;
  }

  return key;
};

var getQwPusherApiKey = exports.getQwPusherApiKey = function getQwPusherApiKey() {
  // TODO: base this off config/build
  var key = '71f27384a152ea6e8247';

  switch ((0, _index.getWindowLocationHostname)()) {
    case 'questmaker.questforward.org':
      key = '86a3eebe83cbf2cfd44c';
      break;
  }

  return key;
};

function hasNeededPusherConnection(pusher) {
  return pusher && pusher.connection && pusher.connection.state === 'connected';
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(653);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuthBackground = __webpack_require__(1357);

var _AuthBackground2 = _interopRequireDefault(_AuthBackground);

var _AuthContainer = __webpack_require__(1358);

var _AuthContainer2 = _interopRequireDefault(_AuthContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthWrapper = function AuthWrapper(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children']);
  return _react2.default.createElement(
    _AuthBackground2.default,
    null,
    _react2.default.createElement(
      _AuthContainer2.default,
      props,
      children
    )
  );
};

AuthWrapper.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
};

exports.default = AuthWrapper;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  text-align: center;\n'], ['\n  text-align: center;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JustifyCenter = _styledComponents2.default.div.withConfig({
  displayName: 'JustifyCenter',
  componentId: 'sc-1kfkrea-0'
})(_templateObject);
exports.default = JustifyCenter;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #0070e0;\n  font-size: ', ';\n  font-weight: 500;\n  line-height: ', ';\n  cursor: pointer;\n  margin: 0 auto;\n  display: inline-block;\n  outline: none;\n  transition: all 0.4s;\n\n  &:hover {\n    color: #000000;\n  }\n'], ['\n  color: #0070e0;\n  font-size: ', ';\n  font-weight: 500;\n  line-height: ', ';\n  cursor: pointer;\n  margin: 0 auto;\n  display: inline-block;\n  outline: none;\n  transition: all 0.4s;\n\n  &:hover {\n    color: #000000;\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextButton = _styledComponents2.default.div.withConfig({
  displayName: 'TextButton',
  componentId: 'sc-1qiap9f-0'
})(_templateObject, function (props) {
  return props.fontSize ? props.fontSize : '16px';
}, function (props) {
  return props.fontSize ? props.fontSize : '19px';
});

TextButton.propTypes = {
  fontSize: _propTypes2.default.string
};

exports.default = TextButton;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormat = getFormat;
exports.getAverageWaitTime = getAverageWaitTime;
exports.getDifferenceInDaysToNow = getDifferenceInDaysToNow;
exports.getDifferenceInHoursToNow = getDifferenceInHoursToNow;
exports.getDifferenceInMinutesToNow = getDifferenceInMinutesToNow;
exports.getDifferenceInMinutes = getDifferenceInMinutes;

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFormat(abbreviateMonth, includeTime, timeOnly) {
  return !timeOnly ? 'D MMM' + (abbreviateMonth ? '' : 'M') + ' YYYY' + (includeTime ? ', h:mm a' : '') : 'h:mm a';
}

function getAverageWaitTime(val) {
  var retval = '--';
  if (val) {
    if (val < 60 && val !== 0) {
      retval = val > 1 ? val + ' mins' : val + ' min';
    }

    if (val > 60 && val < 1440) {
      var hrs = Math.round(val / 60);
      retval = hrs > 1 ? hrs + ' hours' : hrs + ' hour';
    }

    if (val >= 1440) {
      var days = Math.floor(val / 1440);
      retval = days > 1 ? days + ' days' : days + ' day';
    }
  }
  return retval;
}

function getDifferenceInDaysToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asDays());
}

function getDifferenceInHoursToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asHours());
}

function getDifferenceInMinutesToNow(startTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(Date.now());
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asMinutes());
}

function getDifferenceInMinutes(startTime, endTime) {
  var start = (0, _moment2.default)(_moment2.default.unix(startTime));
  var end = (0, _moment2.default)(_moment2.default.unix(endTime));
  var duration = _moment2.default.duration(end.diff(start));
  return Math.floor(duration.asMinutes() > 1 ? duration.asMinutes() : 1);
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _string = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseSelect = function (_Component) {
  (0, _inherits3.default)(CourseSelect, _Component);

  function CourseSelect(props) {
    (0, _classCallCheck3.default)(this, CourseSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CourseSelect.__proto__ || (0, _getPrototypeOf2.default)(CourseSelect)).call(this, props));

    _this.state = {
      selectedValue: props.course
    };
    _this.handleSelectChangeBound = _this.handleSelectChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CourseSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          courses = _props.courses,
          disabled = _props.disabled;


      return _react2.default.createElement(
        'div',
        { className: 'course-select' },
        disabled && _react2.default.createElement(_reactTooltip2.default, { id: 'courseSelectTooltip' }),
        _react2.default.createElement(
          'div',
          {
            'data-for': 'courseSelectTooltip',
            'data-tip': 'No journeys are available.'
          },
          _react2.default.createElement(_reactSelect2.default, {
            ref: this.props.courseFilterRef,
            searchable: true,
            clearable: true,
            options: this.mapList(courses),
            value: this.state.selectedValue,
            onChange: this.handleSelectChangeBound,
            placeholder: this.props.placeholder || '',
            disabled: disabled,
            matchProp: 'label'
          })
        )
      );
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(value) {
      this.setState(function () {
        return {
          selectedValue: value
        };
      });
      this.props.onCourseChange(value);
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      var labelTruncationLength = this.props.labelTruncationLength;

      var values = arr.map(function (course) {
        return {
          id: course.id,
          value: course.id,
          label: (0, _string.getTruncatedString)({
            val: course.name,
            len: labelTruncationLength
          }),
          className: 'courseselect-option',
          style: {
            color: '#' + course.color
          }
        };
      });
      return (0, _arraySort2.default)(values, ['label']);
    }
  }]);
  return CourseSelect;
}(_react.Component);

exports.default = CourseSelect;


CourseSelect.propTypes = {
  course: _propTypes2.default.object,
  courses: _propTypes2.default.array.isRequired,
  onCourseChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool,
  courseFilterRef: _propTypes2.default.object,
  labelTruncationLength: _propTypes2.default.number.isRequired,
  placeholder: _propTypes2.default.string
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapLevels = undefined;

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _string = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapLevels = function mapLevels(arr, truncatedLength) {
  var values = arr.map(function (level) {
    var labelString = (level.mastery ? 'Mastery Level' : level.number) + ': ' + level.name;
    return {
      id: level.id,
      value: level.id,
      label: (0, _string.getTruncatedString)({
        val: labelString,
        len: truncatedLength
      }),
      sort: level.sort_order
    };
  });
  return (0, _arraySort2.default)(values, ['sort']);
};

exports.mapLevels = mapLevels;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(446)["default"];

var assertThisInitialized = __webpack_require__(271);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 271 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 272 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1474);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.message = exports.accessor = exports.disabled = exports.dateFormat = exports.numberFormat = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _elementType = _interopRequireDefault(__webpack_require__(1617));

exports.elementType = _elementType.default;

var _createChainableTypeChecker = _interopRequireDefault(__webpack_require__(707));

var _localizers = __webpack_require__(1620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberFormat = (0, _createChainableTypeChecker.default)(function () {
  return _localizers.number.propType.apply(_localizers.number, arguments);
});
exports.numberFormat = numberFormat;
var dateFormat = (0, _createChainableTypeChecker.default)(function () {
  return _localizers.date.propType.apply(_localizers.date, arguments);
});
exports.dateFormat = dateFormat;
var disabled = (0, _createChainableTypeChecker.default)(function () {
  return _propTypes.default.bool.apply(_propTypes.default, arguments);
});
exports.disabled = disabled;
disabled.acceptsArray = _propTypes.default.oneOfType([disabled, _propTypes.default.array]);

var accessor = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]);

exports.accessor = accessor;

var message = _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string, _propTypes.default.func]);

exports.message = message;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.dataIndexOf = dataIndexOf;
exports.valueMatcher = valueMatcher;
exports.dataItem = dataItem;
exports.dataText = exports.dataValue = void 0;

var _ = __webpack_require__(478);

var dataValue = function dataValue(data, field) {
  var value = data;
  if (typeof field === 'function') value = field(data);else if (data == null) value = data;else if (typeof field === 'string' && typeof data === 'object' && field in data) value = data[field];
  return value;
};

exports.dataValue = dataValue;

var dataText = function dataText(item, textField) {
  var value = dataValue(item, textField);
  return value == null ? '' : value + '';
};

exports.dataText = dataText;

function dataIndexOf(data, item, valueField) {
  var idx = -1;

  var isValueEqual = function isValueEqual(datum) {
    return valueMatcher(item, datum, valueField);
  };

  while (++idx < data.length) {
    var datum = data[idx];
    if (datum === item || isValueEqual(datum)) return idx;
  }

  return -1;
}
/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */


function valueMatcher(a, b, valueField) {
  return (0, _.isShallowEqual)(dataValue(a, valueField), dataValue(b, valueField));
}

function dataItem(data, item, valueField) {
  var idx = dataIndexOf(data, item, valueField);
  return idx !== -1 ? data[idx] : item;
}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(132).f;
var has = __webpack_require__(170);
var TAG = __webpack_require__(82)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(95);
var toLength = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(175);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(107);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(108);
var defined = __webpack_require__(121);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(33);
var cof = __webpack_require__(107);
var MATCH = __webpack_require__(44)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(44)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(198);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(515);
var redefine = __webpack_require__(88);
var hide = __webpack_require__(87);
var fails = __webpack_require__(31);
var defined = __webpack_require__(121);
var wks = __webpack_require__(44);
var regexpExec = __webpack_require__(378);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(88);
var redefineAll = __webpack_require__(181);
var meta = __webpack_require__(152);
var forOf = __webpack_require__(180);
var anInstance = __webpack_require__(179);
var isObject = __webpack_require__(33);
var fails = __webpack_require__(31);
var $iterDetect = __webpack_require__(284);
var setToStringTag = __webpack_require__(197);
var inheritIfRequired = __webpack_require__(364);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var hide = __webpack_require__(87);
var uid = __webpack_require__(173);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(151) || !__webpack_require__(31)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(29)[K];
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(10);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(10);
var aFunction = __webpack_require__(71);
var ctx = __webpack_require__(106);
var forOf = __webpack_require__(180);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(967);
var global = __webpack_require__(81);
var hide = __webpack_require__(169);
var Iterators = __webpack_require__(194);
var TO_STRING_TAG = __webpack_require__(82)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_NOT_EDITING_ACCOUNT = exports.IS_EDITING_ACCOUNT = exports.UPDATE_ACCOUNT_FAILURE = exports.UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_REQUEST = exports.CHANGE_PASSWORD_FAILURE = exports.CHANGE_PASSWORD_SUCCESS = exports.CHANGE_PASSWORD_RESET = exports.CHANGE_PASSWORD_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.isEditingAccount = isEditingAccount;
exports.isNotEditingAccount = isNotEditingAccount;
exports.changePasswordSuccess = changePasswordSuccess;
exports.changePasswordFailure = changePasswordFailure;
exports.changePasswordRequest = changePasswordRequest;
exports.changePasswordReset = changePasswordReset;
exports.updateAccountSuccess = updateAccountSuccess;
exports.updateAccountFailure = updateAccountFailure;
exports.updateAccountRequest = updateAccountRequest;
exports.changePassword = changePassword;
exports.updateAccount = updateAccount;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_PASSWORD_REQUEST = exports.CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

var CHANGE_PASSWORD_RESET = exports.CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET';
var CHANGE_PASSWORD_SUCCESS = exports.CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
var CHANGE_PASSWORD_FAILURE = exports.CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

var UPDATE_ACCOUNT_REQUEST = exports.UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST';
var UPDATE_ACCOUNT_SUCCESS = exports.UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS';
var UPDATE_ACCOUNT_FAILURE = exports.UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE';

var IS_EDITING_ACCOUNT = exports.IS_EDITING_ACCOUNT = 'IS_EDITING_ACCOUNT';
var IS_NOT_EDITING_ACCOUNT = exports.IS_NOT_EDITING_ACCOUNT = 'IS_NOT_EDITING_ACCOUNT';

function isEditingAccount() {
  return {
    type: IS_EDITING_ACCOUNT
  };
}

function isNotEditingAccount() {
  return {
    type: IS_NOT_EDITING_ACCOUNT
  };
}

function changePasswordSuccess() {
  return {
    type: CHANGE_PASSWORD_SUCCESS
  };
}

function changePasswordFailure() {
  return {
    type: CHANGE_PASSWORD_FAILURE
  };
}

function changePasswordRequest() {
  return {
    type: CHANGE_PASSWORD_REQUEST
  };
}

function changePasswordReset() {
  return {
    type: CHANGE_PASSWORD_RESET
  };
}

function updateAccountSuccess(userId, url, about) {
  return {
    type: UPDATE_ACCOUNT_SUCCESS,
    userId: userId,
    file: url,
    about: about
  };
}

function updateAccountFailure(error) {
  return (0, _actions.getErrorAction)(UPDATE_ACCOUNT_FAILURE, error, 'There was an issue uploading your photo. Please try again.');
}

function updateAccountRequest() {
  return {
    type: UPDATE_ACCOUNT_REQUEST
  };
}

function changePassword(currentPassword, newPassword) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getBaseUrl)() + '/api/user/update_password';

              dispatch(changePasswordRequest());
              _context.prev = 3;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 7;
              return fetch(url, {
                method: 'PUT',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v4',
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify2.default)({
                  user: {
                    current_password: currentPassword,
                    new_password: newPassword
                  }
                })
              });

            case 7:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);


              // change password success; remove password
              sessionStorage.removeItem('password');
              dispatch(changePasswordSuccess());
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t2 = _context['catch'](3);

              dispatch(changePasswordFailure(_context.t2));

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function updateAccount(file, about) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url, data, _response, json;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();

              dispatch(updateAccountRequest());
              dispatch(isEditingAccount());

              url = (0, _utils.getBaseUrl)() + '/api/user';
              data = new window.FormData();

              if (file) {
                data.append('user[photo]', file);
              }
              data.append('user[about]', about || '');
              _context2.prev = 7;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 11;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v4'
                },
                body: data
              });

            case 11:
              _context2.t1 = _context2.sent;
              _response = (0, _context2.t0)(_context2.t1);
              _context2.next = 15;
              return _response.json();

            case 15:
              json = _context2.sent;

              dispatch(updateAccountSuccess(state.user.user.id, json.photo_url, json.about));
              dispatch(isNotEditingAccount());
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t2 = _context2['catch'](7);

              dispatch(updateAccountFailure(_context2.t2));

            case 23:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 20]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_MY_QUESTS = exports.FETCH_MY_QUESTS_FAILURE = exports.FETCH_MY_QUESTS_SUCCESS = exports.FETCH_MY_QUESTS_REQUEST = exports.SET_MY_QUESTS_SORT = exports.SET_MY_QUESTS_FILTER = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchMyQuestsRequest = fetchMyQuestsRequest;
exports.fetchMyQuestsSuccess = fetchMyQuestsSuccess;
exports.fetchMyQuestsFailure = fetchMyQuestsFailure;
exports.setMyQuestsFilter = setMyQuestsFilter;
exports.setMyQuestsSort = setMyQuestsSort;
exports.clearQuests = clearQuests;
exports.setDefaultMyQuestsFilters = setDefaultMyQuestsFilters;
exports.fetchMyQuests = fetchMyQuests;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

var _myquests = __webpack_require__(1015);

var _myquestsfilters = __webpack_require__(394);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_MY_QUESTS_FILTER = exports.SET_MY_QUESTS_FILTER = 'SET_MY_QUESTS_FILTER';
var SET_MY_QUESTS_SORT = exports.SET_MY_QUESTS_SORT = 'SET_MY_QUESTS_SORT';
var FETCH_MY_QUESTS_REQUEST = exports.FETCH_MY_QUESTS_REQUEST = 'FETCH_MY_QUESTS_REQUEST';
var FETCH_MY_QUESTS_SUCCESS = exports.FETCH_MY_QUESTS_SUCCESS = 'FETCH_MY_QUESTS_SUCCESS';
var FETCH_MY_QUESTS_FAILURE = exports.FETCH_MY_QUESTS_FAILURE = 'FETCH_MY_QUESTS_FAILURE';
var CLEAR_MY_QUESTS = exports.CLEAR_MY_QUESTS = 'CLEAR_MY_QUESTS';

function fetchMyQuestsRequest() {
  return {
    type: FETCH_MY_QUESTS_REQUEST
  };
}

function fetchMyQuestsSuccess(response, loadMore) {
  return {
    type: FETCH_MY_QUESTS_SUCCESS,
    payload: {
      quests: response.quests,
      page: response.meta.page,
      total: response.meta.total
    }
  };
}

function fetchMyQuestsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_MY_QUESTS_FAILURE, error);
}

function setMyQuestsFilter(filter) {
  return {
    type: SET_MY_QUESTS_FILTER,
    filter: filter
  };
}

function setMyQuestsSort(sort) {
  return {
    type: SET_MY_QUESTS_SORT,
    sort: sort
  };
}

function clearQuests() {
  return {
    type: CLEAR_MY_QUESTS
  };
}

function setDefaultMyQuestsFilters() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              _context.next = 3;
              return dispatch((0, _myquestsfilters.setDraftFilter)([2]));

            case 3:
              _context.next = 5;
              return dispatch((0, _myquestsfilters.setStatusFilter)([]));

            case 5:
              _context.next = 7;
              return dispatch((0, _myquestsfilters.setAuthorFilter)([state.user.user.id]));

            case 7:
              _context.next = 9;
              return dispatch((0, _myquestsfilters.setAssignedToFilter)([]));

            case 9:
              _context.next = 11;
              return dispatch((0, _myquestsfilters.setKeywordFilter)(''));

            case 11:
              _context.next = 13;
              return dispatch(setMyQuestsFilter('drafts'));

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchMyQuests(page, clearQuestsInState) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, query, url, response, json;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              query = (0, _myquests.getMyQuestsFilterQuery)(state, state.organization.orgId);
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/search';


              if (clearQuestsInState) {
                dispatch(clearQuests());
              }

              dispatch(fetchMyQuestsRequest());
              _context2.prev = 5;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 9;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  page: page,
                  q: query,
                  order: state.myquests.sort
                })
              });

            case 9:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 13;
              return response.json();

            case 13:
              json = _context2.sent;

              dispatch(fetchMyQuestsSuccess(json));
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t2 = _context2['catch'](5);

              dispatch(fetchMyQuestsFailure(_context2.t2));

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[5, 17]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_USERS_FAILURE = exports.GET_USERS_SUCCESS = exports.GET_USERS_REQUEST = undefined;
exports.getUsersRequest = getUsersRequest;
exports.getUsersSuccess = getUsersSuccess;
exports.getUsersFailure = getUsersFailure;
exports.getUsers = getUsers;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var GET_USERS_REQUEST = exports.GET_USERS_REQUEST = 'GET_USERS_REQUEST';
var GET_USERS_SUCCESS = exports.GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
var GET_USERS_FAILURE = exports.GET_USERS_FAILURE = 'GET_USERS_FAILURE';

function getUsersRequest() {
  return {
    type: GET_USERS_REQUEST
  };
}

function getUsersSuccess(response) {
  return {
    type: GET_USERS_SUCCESS,
    users: response.users
  };
}

function getUsersFailure(error) {
  return (0, _actions.getErrorAction)(GET_USERS_FAILURE, error);
}

function getUsers() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/users';
    return (0, _api.basicGet)(state, dispatch, url, getUsersRequest, getUsersSuccess, getUsersFailure);
  };
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_TAGS_FAILURE = exports.FETCH_TAGS_SUCCESS = exports.FETCH_TAGS_REQUEST = undefined;
exports.fetchTagsRequest = fetchTagsRequest;
exports.fetchTagsSuccess = fetchTagsSuccess;
exports.fetchTagsFailure = fetchTagsFailure;
exports.fetchTags = fetchTags;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var FETCH_TAGS_REQUEST = exports.FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST';
var FETCH_TAGS_SUCCESS = exports.FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
var FETCH_TAGS_FAILURE = exports.FETCH_TAGS_FAILURE = 'FETCH_TAGS_FAILURE';

function fetchTagsRequest() {
  return {
    type: FETCH_TAGS_REQUEST
  };
}

function fetchTagsSuccess(response) {
  return {
    type: FETCH_TAGS_SUCCESS,
    tags: response
  };
}

function fetchTagsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_TAGS_FAILURE, error);
}

function fetchTags() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getBaseUrl)() + '/tags';
    return (0, _api.basicGet)(state, dispatch, url, fetchTagsRequest, fetchTagsSuccess, fetchTagsFailure);
  };
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthorFilters = setAuthorFilters;
exports.setTagFilters = setTagFilters;
exports.setKeywordFilter = setKeywordFilter;
exports.setDraftFilter = setDraftFilter;
exports.setStatusFilter = setStatusFilter;
exports.setPrimarySubjectFilter = setPrimarySubjectFilter;
exports.clearSearchFilters = clearSearchFilters;
exports.setAssignedToFilters = setAssignedToFilters;
exports.setTargetGradeLevelFilter = setTargetGradeLevelFilter;
exports.setCourseFilter = setCourseFilter;
exports.setLevelFilter = setLevelFilter;
exports.setReviewTrackingStatus = setReviewTrackingStatus;
var SET_QUESTS_AUTHOR_FILTERS = exports.SET_QUESTS_AUTHOR_FILTERS = 'SET_QUESTS_AUTHOR_FILTERS';

var SET_QUESTS_TAG_FILTERS = exports.SET_QUESTS_TAG_FILTERS = 'SET_QUESTS_TAG_FILTERS';
var SET_QUESTS_KEYWORD_FILTER = exports.SET_QUESTS_KEYWORD_FILTER = 'SET_QUESTS_KEYWORD_FILTER';
var SET_QUESTS_DRAFT_FILTER = exports.SET_QUESTS_DRAFT_FILTER = 'SET_QUESTS_DRAFT_FILTER';
var SET_QUESTS_STATUS_FILTER = exports.SET_QUESTS_STATUS_FILTER = 'SET_QUESTS_STATUS_FILTER';
var SET_QUESTS_PRIMARY_SUBJECT_FILTER = exports.SET_QUESTS_PRIMARY_SUBJECT_FILTER = 'SET_QUESTS_PRIMARY_SUBJECT_FILTER';
var SET_QUESTS_ASSIGNED_TO_FILTERS = exports.SET_QUESTS_ASSIGNED_TO_FILTERS = 'SET_QUESTS_ASSIGNED_TO_FILTERS';
var CLEAR_QUESTS_FILTERS = exports.CLEAR_QUESTS_FILTERS = 'CLEAR_QUESTS_FILTERS';
var SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS = exports.SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS = 'SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS';
var SET_QUESTS_COURSE_FILTER = exports.SET_QUESTS_COURSE_FILTER = 'SET_QUESTS_COURSE_FILTER';
var SET_QUESTS_LEVELS_FILTER = exports.SET_QUESTS_LEVELS_FILTER = 'SET_QUESTS_LEVELS_FILTER';
var SET_QUESTS_REVIEW_TRACKING_STATUS = exports.SET_QUESTS_REVIEW_TRACKING_STATUS = 'SET_QUESTS_REVIEW_TRACKING_STATUS';

function setAuthorFilters(authorIds) {
  return {
    type: SET_QUESTS_AUTHOR_FILTERS,
    authors_id_in: authorIds
  };
}

function setTagFilters(tagIds) {
  return {
    type: SET_QUESTS_TAG_FILTERS,
    questtags_id_in: tagIds
  };
}

function setKeywordFilter(keyword) {
  return {
    type: SET_QUESTS_KEYWORD_FILTER,
    name_or_description_cont: keyword
  };
}

function setDraftFilter(val) {
  return {
    type: SET_QUESTS_DRAFT_FILTER,
    reviewing_compiled_quest_state_null: val
  };
}

function setStatusFilter(statuses) {
  return {
    type: SET_QUESTS_STATUS_FILTER,
    reviewing_compiled_quest_state_in: statuses
  };
}

function setPrimarySubjectFilter(subjects) {
  return {
    type: SET_QUESTS_PRIMARY_SUBJECT_FILTER,
    quest_subject_id_in: subjects
  };
}

function clearSearchFilters() {
  return {
    type: CLEAR_QUESTS_FILTERS
  };
}

function setAssignedToFilters(assignedToIds) {
  return {
    type: SET_QUESTS_ASSIGNED_TO_FILTERS,
    assigned_to_id_in: assignedToIds
  };
}

function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  };
}

function setCourseFilter(courseId) {
  return {
    type: SET_QUESTS_COURSE_FILTER,
    mock_course_id_in: courseId
  };
}

function setLevelFilter(levels) {
  return {
    type: SET_QUESTS_LEVELS_FILTER,
    mock_level_id_in: levels
  };
}

function setReviewTrackingStatus(status) {
  return {
    type: SET_QUESTS_REVIEW_TRACKING_STATUS,
    status: status
  };
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthorsFilter = setAuthorsFilter;
exports.setKeywordFilter = setKeywordFilter;
exports.setCourseFilter = setCourseFilter;
exports.setLevelFilter = setLevelFilter;
exports.setReviewQueueSortType = setReviewQueueSortType;
exports.setReviewQueueSortOrder = setReviewQueueSortOrder;
exports.setNeedStandardsFilter = setNeedStandardsFilter;
exports.setNeedFinalFilter = setNeedFinalFilter;
exports.setAllReviewsFilter = setAllReviewsFilter;
exports.clearReviewQueueFilters = clearReviewQueueFilters;
exports.setTargetGradeLevelFilter = setTargetGradeLevelFilter;
var SET_REVIEW_QUEUE_AUTHOR_FILTERS = exports.SET_REVIEW_QUEUE_AUTHOR_FILTERS = 'SET_REVIEW_QUEUE_AUTHOR_FILTERS';
var SET_REVIEW_QUEUE_KEYWORD_FILTER = exports.SET_REVIEW_QUEUE_KEYWORD_FILTER = 'SET_REVIEW_QUEUE_KEYWORD_FILTER';
var SET_REVIEW_QUEUE_DRAFT_FILTER = exports.SET_REVIEW_QUEUE_DRAFT_FILTER = 'SET_REVIEW_QUEUE_DRAFT_FILTER';
var SET_REVIEW_QUEUE_COURSE_FILTER = exports.SET_REVIEW_QUEUE_COURSE_FILTER = 'SET_REVIEW_QUEUE_COURSE_FILTER';
var SET_REVIEW_QUEUE_LEVELS_FILTER = exports.SET_REVIEW_QUEUE_LEVELS_FILTER = 'SET_REVIEW_QUEUE_LEVELS_FILTER';
var SET_REVIEW_QUEUE_SORT_TYPE = exports.SET_REVIEW_QUEUE_SORT_TYPE = 'SET_REVIEW_QUEUE_SORT_TYPE';
var SET_REVIEW_QUEUE_SORT_ORDER = exports.SET_REVIEW_QUEUE_SORT_ORDER = 'SET_REVIEW_QUEUE_SORT_ORDER';
var SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW = exports.SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW = 'SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW';
var SET_REVIEW_QUEUE_NEED_FINAL_REVIEW = exports.SET_REVIEW_QUEUE_NEED_FINAL_REVIEW = 'SET_REVIEW_QUEUE_NEED_FINAL_REVIEW';
var SET_REVIEW_QUEUE_ALL_REVIEWS = exports.SET_REVIEW_QUEUE_ALL_REVIEWS = 'SET_REVIEW_QUEUE_ALL_REVIEWS';
var CLEAR_REVIEW_QUEUE_FILTERS = exports.CLEAR_REVIEW_QUEUE_FILTERS = 'CLEAR_REVIEW_QUEUE_FILTERS';
var SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS = exports.SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS = 'SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS';

function setAuthorsFilter(authorIds) {
  return {
    type: SET_REVIEW_QUEUE_AUTHOR_FILTERS,
    authors_id_in: authorIds
  };
}

function setKeywordFilter(keyword) {
  return {
    type: SET_REVIEW_QUEUE_KEYWORD_FILTER,
    name_or_description_cont: keyword
  };
}

function setCourseFilter(courseId) {
  return {
    type: SET_REVIEW_QUEUE_COURSE_FILTER,
    mock_course_id_in: courseId
  };
}

function setLevelFilter(levels) {
  return {
    type: SET_REVIEW_QUEUE_LEVELS_FILTER,
    mock_level_id_in: levels
  };
}

function setReviewQueueSortType(sort) {
  return {
    type: SET_REVIEW_QUEUE_SORT_TYPE,
    sort: sort
  };
}

function setReviewQueueSortOrder(order) {
  return {
    type: SET_REVIEW_QUEUE_SORT_ORDER,
    order: order
  };
}

function setNeedStandardsFilter() {
  return {
    type: SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW
  };
}

function setNeedFinalFilter() {
  return {
    type: SET_REVIEW_QUEUE_NEED_FINAL_REVIEW
  };
}

function setAllReviewsFilter() {
  return {
    type: SET_REVIEW_QUEUE_ALL_REVIEWS
  };
}

function clearReviewQueueFilters() {
  return {
    type: CLEAR_REVIEW_QUEUE_FILTERS
  };
}

function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  };
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_NOT_EDITING_COMMENT = exports.IS_EDITING_COMMENT = exports.DELETE_DRAFT_ACTIVITY_COMMENT = exports.DELETE_DRAFT_QUEST_COMMENT = exports.DELETE_ACTIVITY_COMMENT = exports.DELETE_QUEST_COMMENT = exports.EDIT_ACTIVITY_COMMENT = exports.EDIT_QUEST_COMMENT = exports.EDIT_DRAFT_ACTIVITY_COMMENT = exports.EDIT_DRAFT_QUEST_COMMENT = exports.PUBLISH_DRAFT_ACTIVITY_COMMENT = exports.PUBLISH_DRAFT_QUEST_COMMENT = exports.POST_USER_ACTIVITY_COMMENT = exports.POST_USER_QUEST_COMMENT = exports.POST_ACTIVITY_COMMENT = exports.FETCH_USER_ACTIVITY_COMMENTS_FAILURE = exports.FETCH_USER_ACTIVITY_COMMENTS_SUCCESS = exports.FETCH_USER_ACTIVITY_COMMENTS_REQUEST = exports.FETCH_USER_QUEST_COMMENTS_FAILURE = exports.FETCH_USER_QUEST_COMMENTS_SUCCESS = exports.FETCH_USER_QUEST_COMMENTS_REQUEST = exports.EDIT_DRAFT_COMMENT_SUCCESS = exports.EDIT_DRAFT_QUEST_COMMENT_REQUEST = exports.FAILED_QUEST_ACTIVITY_COMMENTS = exports.RECEIVE_QUEST_ACTIVITY_COMMENTS = exports.REQUEST_QUEST_ACTIVITY_COMMENTS = exports.OPEN_QUEST_COMMENT = exports.RESOLVE_QUEST_COMMENT = exports.POST_QUEST_COMMENT = exports.FAILED_QUEST_COMMENTS = exports.RECEIVE_QUEST_COMMENTS = exports.REQUEST_QUEST_COMMENTS = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.isEditingComment = isEditingComment;
exports.isNotEditingComment = isNotEditingComment;
exports.deleteCommentAction = deleteCommentAction;
exports.editCommentAction = editCommentAction;
exports.postCommentAction = postCommentAction;
exports.resolveCommentAction = resolveCommentAction;
exports.openCommentAction = openCommentAction;
exports.requestQuestComments = requestQuestComments;
exports.receiveQuestComments = receiveQuestComments;
exports.failedQuestComments = failedQuestComments;
exports.requestQuestActivityComments = requestQuestActivityComments;
exports.receiveQuestActivityComments = receiveQuestActivityComments;
exports.failedQuestActivityComments = failedQuestActivityComments;
exports.fetchUserQuestCommentsRequest = fetchUserQuestCommentsRequest;
exports.fetchUserQuestCommentsSuccess = fetchUserQuestCommentsSuccess;
exports.fetchUserQuestCommentsFailure = fetchUserQuestCommentsFailure;
exports.fetchUserActivityCommentsRequest = fetchUserActivityCommentsRequest;
exports.fetchUserActivityCommentsSuccess = fetchUserActivityCommentsSuccess;
exports.fetchUserActivityCommentsFailure = fetchUserActivityCommentsFailure;
exports.fetchQuestComments = fetchQuestComments;
exports.fetchQuestActivityComments = fetchQuestActivityComments;
exports.fetchUserQuestComments = fetchUserQuestComments;
exports.fetchUserActivityComments = fetchUserActivityComments;
exports.openComment = openComment;
exports.deleteComment = deleteComment;
exports.editComment = editComment;
exports.resolveComment = resolveComment;
exports.postComment = postComment;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_QUEST_COMMENTS = exports.REQUEST_QUEST_COMMENTS = 'REQUEST_QUEST_COMMENTS';
var RECEIVE_QUEST_COMMENTS = exports.RECEIVE_QUEST_COMMENTS = 'RECEIVE_QUEST_COMMENTS';
var FAILED_QUEST_COMMENTS = exports.FAILED_QUEST_COMMENTS = 'FAILED_QUEST_COMMENTS';
var POST_QUEST_COMMENT = exports.POST_QUEST_COMMENT = 'POST_QUEST_COMMENT';
var RESOLVE_QUEST_COMMENT = exports.RESOLVE_QUEST_COMMENT = 'RESOLVE_QUEST_COMMENT';
var OPEN_QUEST_COMMENT = exports.OPEN_QUEST_COMMENT = 'OPEN_QUEST_COMMENT';
var REQUEST_QUEST_ACTIVITY_COMMENTS = exports.REQUEST_QUEST_ACTIVITY_COMMENTS = 'REQUEST_QUEST_ACTIVITY_COMMENTS';
var RECEIVE_QUEST_ACTIVITY_COMMENTS = exports.RECEIVE_QUEST_ACTIVITY_COMMENTS = 'RECEIVE_QUEST_ACTIVITY_COMMENTS';
var FAILED_QUEST_ACTIVITY_COMMENTS = exports.FAILED_QUEST_ACTIVITY_COMMENTS = 'FAILED_QUEST_ACTIVITY_COMMENTS';
var EDIT_DRAFT_QUEST_COMMENT_REQUEST = exports.EDIT_DRAFT_QUEST_COMMENT_REQUEST = 'EDIT_DRAFT_QUEST_COMMENT_REQUEST';
var EDIT_DRAFT_COMMENT_SUCCESS = exports.EDIT_DRAFT_COMMENT_SUCCESS = 'EDIT_DRAFT_COMMENT_SUCCESS';
var FETCH_USER_QUEST_COMMENTS_REQUEST = exports.FETCH_USER_QUEST_COMMENTS_REQUEST = 'FETCH_USER_QUEST_COMMENTS_REQUEST';
var FETCH_USER_QUEST_COMMENTS_SUCCESS = exports.FETCH_USER_QUEST_COMMENTS_SUCCESS = 'FETCH_USER_QUEST_COMMENTS_SUCCESS';
var FETCH_USER_QUEST_COMMENTS_FAILURE = exports.FETCH_USER_QUEST_COMMENTS_FAILURE = 'FETCH_USER_QUEST_COMMENTS_FAILURE';
var FETCH_USER_ACTIVITY_COMMENTS_REQUEST = exports.FETCH_USER_ACTIVITY_COMMENTS_REQUEST = 'FETCH_USER_ACTIVITY_COMMENTS_REQUEST';
var FETCH_USER_ACTIVITY_COMMENTS_SUCCESS = exports.FETCH_USER_ACTIVITY_COMMENTS_SUCCESS = 'FETCH_USER_ACTIVITY_COMMENTS_SUCCESS';
var FETCH_USER_ACTIVITY_COMMENTS_FAILURE = exports.FETCH_USER_ACTIVITY_COMMENTS_FAILURE = 'FETCH_USER_ACTIVITY_COMMENTS_FAILURE';
var POST_ACTIVITY_COMMENT = exports.POST_ACTIVITY_COMMENT = 'POST_ACTIVITY_COMMENT';
var POST_USER_QUEST_COMMENT = exports.POST_USER_QUEST_COMMENT = 'POST_USER_QUEST_COMMENT';
var POST_USER_ACTIVITY_COMMENT = exports.POST_USER_ACTIVITY_COMMENT = 'POST_USER_ACTIVITY_COMMENT';
var PUBLISH_DRAFT_QUEST_COMMENT = exports.PUBLISH_DRAFT_QUEST_COMMENT = 'PUBLISH_DRAFT_QUEST_COMMENT';
var PUBLISH_DRAFT_ACTIVITY_COMMENT = exports.PUBLISH_DRAFT_ACTIVITY_COMMENT = 'PUBLISH_DRAFT_ACTIVITY_COMMENT';
var EDIT_DRAFT_QUEST_COMMENT = exports.EDIT_DRAFT_QUEST_COMMENT = 'EDIT_DRAFT_QUEST_COMMENT';
var EDIT_DRAFT_ACTIVITY_COMMENT = exports.EDIT_DRAFT_ACTIVITY_COMMENT = 'EDIT_DRAFT_ACTIVITY_COMMENT';
var EDIT_QUEST_COMMENT = exports.EDIT_QUEST_COMMENT = 'EDIT_QUEST_COMMENT';
var EDIT_ACTIVITY_COMMENT = exports.EDIT_ACTIVITY_COMMENT = 'EDIT_ACTIVITY_COMMENT';
var DELETE_QUEST_COMMENT = exports.DELETE_QUEST_COMMENT = 'DELETE_QUEST_COMMENT';
var DELETE_ACTIVITY_COMMENT = exports.DELETE_ACTIVITY_COMMENT = 'DELETE_ACTIVITY_COMMENT';
var DELETE_DRAFT_QUEST_COMMENT = exports.DELETE_DRAFT_QUEST_COMMENT = 'DELETE_DRAFT_QUEST_COMMENT';
var DELETE_DRAFT_ACTIVITY_COMMENT = exports.DELETE_DRAFT_ACTIVITY_COMMENT = 'DELETE_DRAFT_ACTIVITY_COMMENT';
var IS_EDITING_COMMENT = exports.IS_EDITING_COMMENT = 'IS_EDITING_COMMENT';
var IS_NOT_EDITING_COMMENT = exports.IS_NOT_EDITING_COMMENT = 'IS_NOT_EDITING_COMMENT';

function isEditingComment() {
  return {
    type: IS_EDITING_COMMENT
  };
}

function isNotEditingComment() {
  return {
    type: IS_NOT_EDITING_COMMENT
  };
}

function deleteCommentAction(resourceType, commentId, commentType) {
  var type = commentType === 'draft' ? resourceType === 'Quest' ? DELETE_DRAFT_QUEST_COMMENT : DELETE_DRAFT_ACTIVITY_COMMENT : resourceType === 'Quest' ? DELETE_QUEST_COMMENT : DELETE_ACTIVITY_COMMENT;

  return {
    type: type,
    commentId: commentId
  };
}

function editCommentAction(resourceType, commentId, comment, publish, commentType) {
  var type = commentType === 'draft' ? publish ? resourceType === 'Quest' ? PUBLISH_DRAFT_QUEST_COMMENT : PUBLISH_DRAFT_ACTIVITY_COMMENT : resourceType === 'Quest' ? EDIT_DRAFT_QUEST_COMMENT : EDIT_DRAFT_ACTIVITY_COMMENT : resourceType === 'Quest' ? EDIT_QUEST_COMMENT : EDIT_ACTIVITY_COMMENT;

  return {
    type: type,
    comment: comment,
    commentId: commentId
  };
}

function postCommentAction(resourceType, comment, publish) {
  var type = publish ? resourceType === 'Quest' ? POST_QUEST_COMMENT : POST_ACTIVITY_COMMENT : resourceType === 'Quest' ? POST_USER_QUEST_COMMENT : POST_USER_ACTIVITY_COMMENT;

  return {
    type: type,
    comment: comment
  };
}

function resolveCommentAction(resourceType, commentId) {
  return {
    type: RESOLVE_QUEST_COMMENT,
    resourceType: resourceType,
    commentId: commentId
  };
}

function openCommentAction(resourceType, commentId) {
  return {
    type: OPEN_QUEST_COMMENT,
    resourceType: resourceType,
    commentId: commentId
  };
}

function requestQuestComments() {
  return {
    type: REQUEST_QUEST_COMMENTS
  };
}

function receiveQuestComments(response) {
  return {
    type: RECEIVE_QUEST_COMMENTS,
    comments: response.comments
  };
}

function failedQuestComments(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_COMMENTS, error);
}

function requestQuestActivityComments() {
  return {
    type: REQUEST_QUEST_ACTIVITY_COMMENTS
  };
}

function receiveQuestActivityComments(response) {
  return {
    type: RECEIVE_QUEST_ACTIVITY_COMMENTS,
    comments: response.comments
  };
}

function failedQuestActivityComments(error) {
  return (0, _actions.getErrorAction)(FAILED_QUEST_ACTIVITY_COMMENTS, error);
}

function fetchUserQuestCommentsRequest() {
  return {
    type: FETCH_USER_QUEST_COMMENTS_REQUEST
  };
}

function fetchUserQuestCommentsSuccess(response) {
  return {
    type: FETCH_USER_QUEST_COMMENTS_SUCCESS,
    payload: {
      comments: response.comments
    }
  };
}

function fetchUserQuestCommentsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_USER_QUEST_COMMENTS_FAILURE, error);
}

function fetchUserActivityCommentsRequest() {
  return {
    type: FETCH_USER_ACTIVITY_COMMENTS_REQUEST
  };
}

function fetchUserActivityCommentsSuccess(response) {
  return {
    type: FETCH_USER_ACTIVITY_COMMENTS_SUCCESS,
    payload: {
      comments: response.comments
    }
  };
}

function fetchUserActivityCommentsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_USER_ACTIVITY_COMMENTS_FAILURE, error);
}

function fetchQuestComments(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/Quest/' + id;
    return (0, _api.basicGet)(state, dispatch, url, requestQuestComments, receiveQuestComments, failedQuestComments);
  };
}

function fetchQuestActivityComments(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/Quest/' + id + '/a/activities';
    return (0, _api.basicGet)(state, dispatch, url, requestQuestActivityComments, receiveQuestActivityComments, failedQuestActivityComments);
  };
}

function fetchUserQuestComments(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/user/comments/Quest/' + id + '?q[state_in][]=0';
    return (0, _api.basicGet)(state, dispatch, url, fetchUserQuestCommentsRequest, fetchUserQuestCommentsSuccess, fetchUserQuestCommentsFailure);
  };
}

function fetchUserActivityComments(id, state) {
  return function (dispatch) {
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/user/comments/Quest/' + id + '/a/activities?q[state_in][]=0';
    return (0, _api.basicGet)(state, dispatch, url, fetchUserActivityCommentsRequest, fetchUserActivityCommentsSuccess, fetchUserActivityCommentsFailure);
  };
}

function openComment(resourceId, resourceType, commentId) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/' + resourceType + '/' + resourceId + '/' + commentId + '/open';
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(openCommentAction(resourceType, commentId));
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t2 = _context['catch'](2);

              console.log(_context.t2);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function deleteComment(resourceId, resourceType, commentId, commentType) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/' + resourceType + '/' + resourceId + '/' + commentId;
              _context2.prev = 2;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);

              dispatch(deleteCommentAction(resourceType, commentId, commentType));
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t2 = _context2['catch'](2);

              console.log(_context2.t2);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 11]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function editComment(resourceId, resourceType, commentId, body, label, commentType, publish) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/' + resourceType + '/' + resourceId + '/' + commentId;
              _context3.prev = 2;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 6;
              return fetch(url, {
                method: 'PUT',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  comment: {
                    body: body,
                    label: label,
                    publish: publish
                  }
                })
              });

            case 6:
              _context3.t1 = _context3.sent;
              response = (0, _context3.t0)(_context3.t1);
              _context3.next = 10;
              return response.json();

            case 10:
              json = _context3.sent;

              dispatch(editCommentAction(resourceType, commentId, json, publish, commentType));
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t2 = _context3['catch'](2);

              console.log(_context3.t2);

            case 17:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 14]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function resolveComment(resourceId, resourceType, commentId) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/' + resourceType + '/' + resourceId + '/' + commentId + '/resolve';
              _context4.prev = 2;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 6:
              _context4.t1 = _context4.sent;
              (0, _context4.t0)(_context4.t1);

              dispatch(resolveCommentAction(resourceType, commentId));
              _context4.next = 14;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t2 = _context4['catch'](2);

              console.log(_context4.t2);

            case 14:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[2, 11]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function postComment(resourceId, section, label, body, publish) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var state, resourceType, url, response, json;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState();
              resourceType = section === 'activities' ? 'Activity' : 'Quest';
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/comments/' + resourceType + '/' + resourceId;
              _context5.prev = 3;
              _context5.t0 = _utils.checkHttpStatus;
              _context5.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  comment: {
                    label: label,
                    body: body,
                    resource_type: resourceType,
                    resource_id: resourceId,
                    section: section,
                    publish: publish
                  }
                })
              });

            case 7:
              _context5.t1 = _context5.sent;
              response = (0, _context5.t0)(_context5.t1);
              _context5.next = 11;
              return response.json();

            case 11:
              json = _context5.sent;

              dispatch(postCommentAction(resourceType, json, publish));
              _context5.next = 18;
              break;

            case 15:
              _context5.prev = 15;
              _context5.t2 = _context5['catch'](3);

              console.log(_context5.t2);

            case 18:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[3, 15]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #dc143c;\n  font-size: 13px;\n  font-weight: 500;\n'], ['\n  color: #dc143c;\n  font-size: 13px;\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorText = _styledComponents2.default.div.withConfig({
  displayName: 'ErrorText',
  componentId: 'sc-1m8zpua-0'
})(_templateObject);

exports.default = ErrorText;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_QUEST_SKILL_SUCCESS = exports.ADD_QUEST_SKILL_SUCCESS = exports.FETCH_QUEST_SKILLS_SUCCESS = exports.FETCH_QUEST_SKILLS_REQUEST = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchQuestSkillsRequest = fetchQuestSkillsRequest;
exports.fetchQuestSkillsSuccess = fetchQuestSkillsSuccess;
exports.addQuestSkillSuccess = addQuestSkillSuccess;
exports.deleteQuestSkillSuccess = deleteQuestSkillSuccess;
exports.fetchQuestSkills = fetchQuestSkills;
exports.addQuestSkill = addQuestSkill;
exports.deleteQuestSkill = deleteQuestSkill;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_QUEST_SKILLS_REQUEST = exports.FETCH_QUEST_SKILLS_REQUEST = 'FETCH_QUEST_SKILLS_REQUEST';
var FETCH_QUEST_SKILLS_SUCCESS = exports.FETCH_QUEST_SKILLS_SUCCESS = 'FETCH_QUEST_SKILLS_SUCCESS';
var ADD_QUEST_SKILL_SUCCESS = exports.ADD_QUEST_SKILL_SUCCESS = 'ADD_QUEST_SKILL_SUCCESS';
var DELETE_QUEST_SKILL_SUCCESS = exports.DELETE_QUEST_SKILL_SUCCESS = 'DELETE_QUEST_SKILL_SUCCESS';

function fetchQuestSkillsRequest() {
  return {
    type: FETCH_QUEST_SKILLS_REQUEST
  };
}

function fetchQuestSkillsSuccess(skills) {
  return {
    type: FETCH_QUEST_SKILLS_SUCCESS,
    payload: {
      skills: skills
    }
  };
}

function addQuestSkillSuccess(skill) {
  return {
    type: ADD_QUEST_SKILL_SUCCESS,
    payload: {
      skill: skill
    }
  };
}

function deleteQuestSkillSuccess(skillId) {
  return {
    type: DELETE_QUEST_SKILL_SUCCESS,
    payload: {
      skillId: skillId
    }
  };
}

function fetchQuestSkills() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, orgId, questId, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              orgId = state.organization.orgId;
              questId = state.quest.item.id;
              url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/quests/' + questId + '/framework_skills';
              return _context.abrupt('return', (0, _api.basicGet)(state, dispatch, url, fetchQuestSkillsRequest, fetchQuestSkillsSuccess));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function addQuestSkill(skillId) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, questId, url, response, json;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              questId = state.quest.item.id;
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/framework_skills';
              _context2.prev = 3;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  quest_framework_skill: {
                    framework_skill_id: skillId
                  }
                })
              });

            case 7:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 11;
              return response.json();

            case 11:
              json = _context2.sent;

              dispatch(addQuestSkillSuccess(json));
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t2 = _context2['catch'](3);

              console.log(_context2.t2);

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 15]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function deleteQuestSkill(skillId) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, questId, url;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              questId = state.quest.item.id;
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/framework_skills/' + skillId;
              _context3.prev = 3;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 7;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 7:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)(_context3.t1);

              dispatch(deleteQuestSkillSuccess(skillId));
              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t2 = _context3['catch'](3);

              console.log(_context3.t2);

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[3, 12]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FocusManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribable__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(60);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isServer */] && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(__WEBPACK_IMPORTED_MODULE_1__subscribable__["a" /* Subscribable */]);
var focusManager = new FocusManager();

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLogger;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLogger;
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPRECATED_CONFIG_PROPS = exports.defaultProps = exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var string = _propTypes["default"].string,
    bool = _propTypes["default"].bool,
    number = _propTypes["default"].number,
    array = _propTypes["default"].array,
    oneOfType = _propTypes["default"].oneOfType,
    shape = _propTypes["default"].shape,
    object = _propTypes["default"].object,
    func = _propTypes["default"].func,
    node = _propTypes["default"].node;
var propTypes = {
  url: oneOfType([string, array, object]),
  playing: bool,
  loop: bool,
  controls: bool,
  volume: number,
  muted: bool,
  playbackRate: number,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  style: object,
  progressInterval: number,
  playsinline: bool,
  pip: bool,
  light: oneOfType([bool, string]),
  playIcon: node,
  wrapper: oneOfType([string, func, shape({
    render: func.isRequired
  })]),
  config: shape({
    soundcloud: shape({
      options: object,
      preload: bool
    }),
    youtube: shape({
      playerVars: object,
      embedOptions: object,
      preload: bool
    }),
    facebook: shape({
      appId: string,
      version: string,
      playerId: string
    }),
    dailymotion: shape({
      params: object,
      preload: bool
    }),
    vimeo: shape({
      playerOptions: object,
      preload: bool
    }),
    file: shape({
      attributes: object,
      tracks: array,
      forceVideo: bool,
      forceAudio: bool,
      forceHLS: bool,
      forceDASH: bool,
      hlsOptions: object,
      hlsVersion: string,
      dashVersion: string
    }),
    wistia: shape({
      options: object
    }),
    mixcloud: shape({
      options: object
    }),
    twitch: shape({
      options: object,
      playerId: string
    })
  }),
  onReady: func,
  onStart: func,
  onPlay: func,
  onPause: func,
  onBuffer: func,
  onBufferEnd: func,
  onEnded: func,
  onError: func,
  onDuration: func,
  onSeek: func,
  onProgress: func,
  onEnablePIP: func,
  onDisablePIP: func
};
exports.propTypes = propTypes;
var defaultProps = {
  playing: false,
  loop: false,
  controls: false,
  volume: null,
  muted: false,
  playbackRate: 1,
  width: '640px',
  height: '360px',
  style: {},
  progressInterval: 1000,
  playsinline: false,
  pip: false,
  light: false,
  wrapper: 'div',
  config: {
    soundcloud: {
      options: {
        visual: true,
        // Undocumented, but makes player fill container and look better
        buying: false,
        liking: false,
        download: false,
        sharing: false,
        show_comments: false,
        show_playcount: false
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      preload: false
    },
    facebook: {
      appId: '1309697205772819',
      version: 'v3.3',
      playerId: null
    },
    dailymotion: {
      params: {
        api: 1,
        'endscreen-enable': false
      },
      preload: false
    },
    vimeo: {
      playerOptions: {
        autopause: false,
        byline: false,
        portrait: false,
        title: false
      },
      preload: false
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: false,
      forceAudio: false,
      forceHLS: false,
      forceDASH: false,
      hlsOptions: {},
      hlsVersion: '0.13.1',
      dashVersion: '2.9.2'
    },
    wistia: {
      options: {}
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    }
  },
  onReady: function onReady() {},
  onStart: function onStart() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onBuffer: function onBuffer() {},
  onBufferEnd: function onBufferEnd() {},
  onEnded: function onEnded() {},
  onError: function onError() {},
  onDuration: function onDuration() {},
  onSeek: function onSeek() {},
  onProgress: function onProgress() {},
  onEnablePIP: function onEnablePIP() {},
  onDisablePIP: function onDisablePIP() {}
};
exports.defaultProps = defaultProps;
var DEPRECATED_CONFIG_PROPS = ['soundcloudConfig', 'youtubeConfig', 'facebookConfig', 'dailymotionConfig', 'vimeoConfig', 'fileConfig', 'wistiaConfig'];
exports.DEPRECATED_CONFIG_PROPS = DEPRECATED_CONFIG_PROPS;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  font-size: 21px;\n  font-weight: bold;\n'], ['\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  font-size: 21px;\n  font-weight: bold;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 16px;\n  width: 16px;\n  min-width: 16px;\n  font-size: 11.15px;\n  font-weight: bold;\n'], ['\n  height: 16px;\n  width: 16px;\n  min-width: 16px;\n  font-size: 11.15px;\n  font-weight: bold;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  height: 21px;\n  width: 21px;\n  min-width: 21px;\n  color: ', ';\n  font-family: Roboto;\n  letter-spacing: 0;\n  text-align: center;\n  border: ', ' solid ', ';\n  border-radius: 3px;\n\n  ', '\n  ', '\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  height: 21px;\n  width: 21px;\n  min-width: 21px;\n  color: ', ';\n  font-family: Roboto;\n  letter-spacing: 0;\n  text-align: center;\n  border: ', ' solid ', ';\n  border-radius: 3px;\n\n  ', '\n  ', '\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(160);

var _Caption2 = _interopRequireDefault(_Caption);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var large = (0, _styledComponents.css)(_templateObject);

var small = (0, _styledComponents.css)(_templateObject2);

var GradeElementStyled = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'GradeElement__GradeElementStyled',
  componentId: 'sc-17hwr0f-0'
})(_templateObject3, _colors2.default.dove, function (props) {
  return props.large ? '1.5px' : '0.85px';
}, _colors2.default.dove, function (props) {
  return props.large && large;
}, function (props) {
  return props.small && small;
});

var GradeElement = function GradeElement(_ref) {
  var name = _ref.name,
      abbreviation = _ref.abbreviation,
      large = _ref.large,
      small = _ref.small,
      style = _ref.style;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_reactTooltip2.default, {
      id: 'gradeLevelNameTooltip',
      place: 'top',
      effect: 'solid',
      className: 'gradeLevelTooltip'
    }),
    _react2.default.createElement(
      GradeElementStyled,
      {
        'data-tip': name,
        'data-for': 'gradeLevelNameTooltip',
        large: large,
        small: small,
        style: style
      },
      abbreviation
    )
  );
};

GradeElement.propTypes = {
  name: _propTypes2.default.string.isRequired,
  abbreviation: _propTypes2.default.string.isRequired,
  large: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

exports.default = GradeElement;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertToRomanNumerals = exports.convertToRomanNumerals = function convertToRomanNumerals(number) {
  var lookup = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 };
  var roman = '';
  var i = 0;

  for (i in lookup) {
    while (number >= lookup[i]) {
      roman += i;
      number -= lookup[i];
    }
  }
  return roman;
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  line-height: 19px;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  line-height: 19px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = _styledComponents2.default.div.withConfig({
  displayName: 'Input',
  componentId: 'sc-1eis8l6-0'
})(_templateObject, _colors2.default.victoria);

exports.default = Input;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjggMy42bDIuNyAyLjdMNC4xIDE2LjcgMCAxOGwxLjQtNEwxMS44IDMuNnptNS42LTNjLjguNy44IDIgMCAyLjZMMTYgNC42IDEzLjQgMiAxNSAuNmMuNy0uOCAxLjktLjggMi41IDB6IiBmaWxsPSIjMjQzNjQ2IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */
    return typeof obj === 'object' && !('toString' in obj) ?
        Object.prototype.toString.call(obj).slice(8, -1) :
        obj;
}
var isProduction = typeof process === 'object' && "production" === 'production';
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */
        if (isProduction) {
            throw new Error('Invariant failed');
        }
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
                "not contain an array except as the value of $set, $push, $unshift, " +
                "$splice or any custom command allowing an array value."; });
        }
        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
            "every included key path must be plain objects containing one of the " +
            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
        "Did you forget to wrap your parameter in an array?"; });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
        "Did you forget to wrap your parameters in an array?"; });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var NativeTypes_namespaceObject = {};
__webpack_require__.d(NativeTypes_namespaceObject, "FILE", function() { return FILE; });
__webpack_require__.d(NativeTypes_namespaceObject, "URL", function() { return URL; });
__webpack_require__.d(NativeTypes_namespaceObject, "TEXT", function() { return TEXT; });
__webpack_require__.d(NativeTypes_namespaceObject, "HTML", function() { return HTML; });

// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/utils/js_utils.js
// cheap lodash replacements
function memoize(fn) {
  var result = null;

  var memoized = function memoized() {
    if (result == null) {
      result = fn();
    }

    return result;
  };

  return memoized;
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = new Set();

  var insertItem = function insertItem(item) {
    return set.add(item);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  set.forEach(function (key) {
    return result.push(key);
  });
  return result;
}
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/EnterLeaveCounter.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EnterLeaveCounter_EnterLeaveCounter = /*#__PURE__*/function () {
  function EnterLeaveCounter(isNodeInDocument) {
    _classCallCheck(this, EnterLeaveCounter);

    _defineProperty(this, "entered", []);

    _defineProperty(this, "isNodeInDocument", void 0);

    this.isNodeInDocument = isNodeInDocument;
  }

  _createClass(EnterLeaveCounter, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this;

      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = union(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;
      this.entered = without(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/BrowserDetector.js

var isFirefox = memoize(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = memoize(function () {
  return Boolean(window.safari);
});
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/MonotonicInterpolant.js
function MonotonicInterpolant__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MonotonicInterpolant__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function MonotonicInterpolant__createClass(Constructor, protoProps, staticProps) { if (protoProps) MonotonicInterpolant__defineProperties(Constructor.prototype, protoProps); if (staticProps) MonotonicInterpolant__defineProperties(Constructor, staticProps); return Constructor; }

function MonotonicInterpolant__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MonotonicInterpolant = /*#__PURE__*/function () {
  function MonotonicInterpolant(xs, ys) {
    MonotonicInterpolant__classCallCheck(this, MonotonicInterpolant);

    MonotonicInterpolant__defineProperty(this, "xs", void 0);

    MonotonicInterpolant__defineProperty(this, "ys", void 0);

    MonotonicInterpolant__defineProperty(this, "c1s", void 0);

    MonotonicInterpolant__defineProperty(this, "c2s", void 0);

    MonotonicInterpolant__defineProperty(this, "c3s", void 0);

    var length = xs.length; // Rearrange xs and ys so that xs is sorted

    var indexes = [];

    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }

    indexes.sort(function (a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    }); // Get consecutive differences and slopes

    var dys = [];
    var dxs = [];
    var ms = [];
    var dx;
    var dy;

    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      dys.push(dy);
      ms.push(dy / dx);
    } // Get degree-1 coefficients


    var c1s = [ms[0]];

    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var m2 = ms[_i2];
      var mNext = ms[_i2 + 1];

      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }

    c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients

    var c2s = [];
    var c3s = [];
    var m;

    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];

      var _common = c1 + c1s[_i3 + 1] - m - m;

      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }

    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }

  MonotonicInterpolant__createClass(MonotonicInterpolant, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs,
          ys = this.ys,
          c1s = this.c1s,
          c2s = this.c2s,
          c3s = this.c3s; // The rightmost point in the dataset should give an exact result

      var i = xs.length - 1;

      if (x === xs[i]) {
        return ys[i];
      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs


      var low = 0;
      var high = c3s.length - 1;
      var mid;

      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];

        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }

      i = Math.max(0, high); // Interpolate

      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);

  return MonotonicInterpolant;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/OffsetUtils.js


var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

function isImageNode(node) {
  var _document$documentEle;

  return node.nodeName === 'IMG' && (isFirefox() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers

  if (isSafari() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }

  return {
    dragPreviewWidth: dragPreviewWidth,
    dragPreviewHeight: dragPreviewHeight
  };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  // The browsers will use the image intrinsic size under different conditions.
  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
  var isImage = isImageNode(dragPreview);
  var dragPreviewNode = isImage ? sourceNode : dragPreview;
  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  var sourceWidth = sourceNode.offsetWidth,
      sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX,
      anchorY = anchorPoint.anchorY;

  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
      dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
      dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

  var calculateYOffset = function calculateYOffset() {
    var interpolantY = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the top
    offsetFromDragPreview.y, // Align at the center
    offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
    offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
    var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug

    if (isSafari() && isImage) {
      // We'll have to wait for @3x to see if this is entirely correct
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }

    return y;
  };

  var calculateXOffset = function calculateXOffset() {
    // Interpolate coordinates depending on anchor point
    // If you know a simpler way to do this, let me know
    var interpolantX = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the left
    offsetFromDragPreview.x, // Align at the center
    offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
    offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
    return interpolantX.interpolate(anchorX);
  }; // Force offsets if specified in the options.


  var offsetX = offsetPoint.offsetX,
      offsetY = offsetPoint.offsetY;
  var isManualOffsetX = offsetX === 0 || offsetX;
  var isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/NativeTypes.js
var FILE = '__NATIVE_FILE__';
var URL = '__NATIVE_URL__';
var TEXT = '__NATIVE_TEXT__';
var HTML = '__NATIVE_HTML__';
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/getDataFromDataTransfer.js
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/nativeTypesConfig.js
var _nativeTypesConfig;

function nativeTypesConfig__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var nativeTypesConfig = (_nativeTypesConfig = {}, nativeTypesConfig__defineProperty(_nativeTypesConfig, FILE, {
  exposeProperties: {
    files: function files(dataTransfer) {
      return Array.prototype.slice.call(dataTransfer.files);
    },
    items: function items(dataTransfer) {
      return dataTransfer.items;
    },
    dataTransfer: function dataTransfer(_dataTransfer) {
      return _dataTransfer;
    }
  },
  matchesTypes: ['Files']
}), nativeTypesConfig__defineProperty(_nativeTypesConfig, HTML, {
  exposeProperties: {
    html: function html(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    },
    dataTransfer: function dataTransfer(_dataTransfer2) {
      return _dataTransfer2;
    }
  },
  matchesTypes: ['Html', 'text/html']
}), nativeTypesConfig__defineProperty(_nativeTypesConfig, URL, {
  exposeProperties: {
    urls: function urls(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    },
    dataTransfer: function dataTransfer(_dataTransfer3) {
      return _dataTransfer3;
    }
  },
  matchesTypes: ['Url', 'text/uri-list']
}), nativeTypesConfig__defineProperty(_nativeTypesConfig, TEXT, {
  exposeProperties: {
    text: function text(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    },
    dataTransfer: function dataTransfer(_dataTransfer4) {
      return _dataTransfer4;
    }
  },
  matchesTypes: ['Text', 'text/plain']
}), _nativeTypesConfig);
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/NativeDragSource.js
function NativeDragSource__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NativeDragSource__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function NativeDragSource__createClass(Constructor, protoProps, staticProps) { if (protoProps) NativeDragSource__defineProperties(Constructor.prototype, protoProps); if (staticProps) NativeDragSource__defineProperties(Constructor, staticProps); return Constructor; }

function NativeDragSource__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NativeDragSource = /*#__PURE__*/function () {
  function NativeDragSource(config) {
    NativeDragSource__classCallCheck(this, NativeDragSource);

    NativeDragSource__defineProperty(this, "item", void 0);

    NativeDragSource__defineProperty(this, "config", void 0);

    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }

  NativeDragSource__createClass(NativeDragSource, [{
    key: "initializeExposedProperties",
    value: function initializeExposedProperties() {
      var _this = this;

      Object.keys(this.config.exposeProperties).forEach(function (property) {
        Object.defineProperty(_this.item, property, {
          configurable: true,
          enumerable: true,
          get: function get() {
            // eslint-disable-next-line no-console
            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
            return null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function loadDataTransfer(dataTransfer) {
      var _this2 = this;

      if (dataTransfer) {
        var newProperties = {};
        Object.keys(this.config.exposeProperties).forEach(function (property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        });
        Object.defineProperties(this.item, newProperties);
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {// empty
    }
  }]);

  return NativeDragSource;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/index.js


function createNativeDragSource(type, dataTransfer) {
  var result = new NativeDragSource(nativeTypesConfig[type]);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  if (!dataTransfer) {
    return null;
  }

  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
    return matchesTypes.some(function (t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/OptionsReader.js
function OptionsReader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OptionsReader__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function OptionsReader__createClass(Constructor, protoProps, staticProps) { if (protoProps) OptionsReader__defineProperties(Constructor.prototype, protoProps); if (staticProps) OptionsReader__defineProperties(Constructor, staticProps); return Constructor; }

function OptionsReader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionsReader = /*#__PURE__*/function () {
  function OptionsReader(globalContext, options) {
    OptionsReader__classCallCheck(this, OptionsReader);

    OptionsReader__defineProperty(this, "ownerDocument", null);

    OptionsReader__defineProperty(this, "globalContext", void 0);

    OptionsReader__defineProperty(this, "optionsArgs", void 0);

    this.globalContext = globalContext;
    this.optionsArgs = options;
  }

  OptionsReader__createClass(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      var _this$globalContext;

      if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) {
        return this.globalContext.document;
      } else if (this.window) {
        return this.window.document;
      } else {
        return undefined;
      }
    }
  }, {
    key: "rootElement",
    get: function get() {
      var _this$optionsArgs;

      return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
    }
  }]);

  return OptionsReader;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/HTML5BackendImpl.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { HTML5BackendImpl__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function HTML5BackendImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HTML5BackendImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HTML5BackendImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) HTML5BackendImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) HTML5BackendImpl__defineProperties(Constructor, staticProps); return Constructor; }

function HTML5BackendImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var HTML5BackendImpl_HTML5BackendImpl = /*#__PURE__*/function () {
  // React-Dnd Components
  // Internal State
  function HTML5BackendImpl(manager, globalContext, options) {
    var _this = this;

    HTML5BackendImpl__classCallCheck(this, HTML5BackendImpl);

    HTML5BackendImpl__defineProperty(this, "options", void 0);

    HTML5BackendImpl__defineProperty(this, "actions", void 0);

    HTML5BackendImpl__defineProperty(this, "monitor", void 0);

    HTML5BackendImpl__defineProperty(this, "registry", void 0);

    HTML5BackendImpl__defineProperty(this, "enterLeaveCounter", void 0);

    HTML5BackendImpl__defineProperty(this, "sourcePreviewNodes", new Map());

    HTML5BackendImpl__defineProperty(this, "sourcePreviewNodeOptions", new Map());

    HTML5BackendImpl__defineProperty(this, "sourceNodes", new Map());

    HTML5BackendImpl__defineProperty(this, "sourceNodeOptions", new Map());

    HTML5BackendImpl__defineProperty(this, "dragStartSourceIds", null);

    HTML5BackendImpl__defineProperty(this, "dropTargetIds", []);

    HTML5BackendImpl__defineProperty(this, "dragEnterTargetIds", []);

    HTML5BackendImpl__defineProperty(this, "currentNativeSource", null);

    HTML5BackendImpl__defineProperty(this, "currentNativeHandle", null);

    HTML5BackendImpl__defineProperty(this, "currentDragSourceNode", null);

    HTML5BackendImpl__defineProperty(this, "altKeyPressed", false);

    HTML5BackendImpl__defineProperty(this, "mouseMoveTimeoutTimer", null);

    HTML5BackendImpl__defineProperty(this, "asyncEndDragFrameId", null);

    HTML5BackendImpl__defineProperty(this, "dragOverTargetIds", null);

    HTML5BackendImpl__defineProperty(this, "lastClientOffset", null);

    HTML5BackendImpl__defineProperty(this, "hoverRafId", null);

    HTML5BackendImpl__defineProperty(this, "getSourceClientOffset", function (sourceId) {
      var source = _this.sourceNodes.get(sourceId);

      return source && getNodeClientOffset(source) || null;
    });

    HTML5BackendImpl__defineProperty(this, "endDragNativeItem", function () {
      if (!_this.isDraggingNativeItem()) {
        return;
      }

      _this.actions.endDrag();

      if (_this.currentNativeHandle) {
        _this.registry.removeSource(_this.currentNativeHandle);
      }

      _this.currentNativeHandle = null;
      _this.currentNativeSource = null;
    });

    HTML5BackendImpl__defineProperty(this, "isNodeInDocument", function (node) {
      // Check the node either in the main document or in the current context
      return Boolean(node && _this.document && _this.document.body && _this.document.body.contains(node));
    });

    HTML5BackendImpl__defineProperty(this, "endDragIfSourceWasRemovedFromDOM", function () {
      var node = _this.currentDragSourceNode;

      if (node == null || _this.isNodeInDocument(node)) {
        return;
      }

      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragStartCapture", function () {
      _this.clearCurrentDragSourceNode();

      _this.dragStartSourceIds = [];
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragStart", function (e) {
      if (e.defaultPrevented) {
        return;
      }

      var dragStartSourceIds = _this.dragStartSourceIds;
      _this.dragStartSourceIds = null;
      var clientOffset = getEventClientOffset(e); // Avoid crashing if we missed a drop event or our previous drag died

      if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      } // Don't publish the source just yet (see why below)


      _this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: _this.getSourceClientOffset,
        clientOffset: clientOffset
      });

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (_this.monitor.isDragging()) {
        if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
          // Use custom drag image if user specifies it.
          // If child drag source refuses drag but parent agrees,
          // use parent's node as drag image. Neither works in IE though.
          var sourceId = _this.monitor.getSourceId();

          var sourceNode = _this.sourceNodes.get(sourceId);

          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;

          if (dragPreview) {
            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(),
                anchorX = _this$getCurrentSourc.anchorX,
                anchorY = _this$getCurrentSourc.anchorY,
                offsetX = _this$getCurrentSourc.offsetX,
                offsetY = _this$getCurrentSourc.offsetY;

            var anchorPoint = {
              anchorX: anchorX,
              anchorY: anchorY
            };
            var offsetPoint = {
              offsetX: offsetX,
              offsetY: offsetY
            };
            var dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }

        try {
          // Firefox won't drag without setting data
          dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
        } catch (err) {// IE doesn't support MIME types in setData
        } // Store drag source node so we can check whether
        // it is removed from DOM and trigger endDrag manually.


        _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?


        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(),
            captureDraggingState = _this$getCurrentSourc2.captureDraggingState;

        if (!captureDraggingState) {
          // Usually we want to publish it in the next tick so that browser
          // is able to screenshot the current (not yet dragging) state.
          //
          // It also neatly avoids a situation where render() returns null
          // in the same tick for the source element, and browser freaks out.
          setTimeout(function () {
            return _this.actions.publishDragSource();
          }, 0);
        } else {
          // In some cases the user may want to override this behavior, e.g.
          // to work around IE not supporting custom drag previews.
          //
          // When using a custom drag layer, the only way to prevent
          // the default drag preview from drawing in IE is to screenshot
          // the dragging state in which the node itself has zero opacity
          // and height. In this case, though, returning null from render()
          // will abruptly end the dragging, which is not obvious.
          //
          // This is the reason such behavior is strictly opt-in.
          _this.actions.publishDragSource();
        }
      } else if (nativeType) {
        // A native item (such as URL) dragged from inside the document
        _this.beginDragNativeItem(nativeType);
      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
        // Just let it drag. It's a native type (URL or text) and will be picked up in
        // dragenter handler.
        return;
      } else {
        // If by this time no drag source reacted, tell browser not to drag.
        e.preventDefault();
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragEndCapture", function () {
      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        // Firefox can dispatch this event in an infinite loop
        // if dragend handler does something like showing an alert.
        // Only proceed if we have not handled it already.
        _this.actions.endDrag();
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragEnterCapture", function (e) {
      _this.dragEnterTargetIds = [];

      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);

      if (!isFirstEnter || _this.monitor.isDragging()) {
        return;
      }

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (nativeType) {
        // A native item (such as file or URL) dragged from outside the document
        _this.beginDragNativeItem(nativeType, dataTransfer);
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragEnter", function (e) {
      var dragEnterTargetIds = _this.dragEnterTargetIds;
      _this.dragEnterTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        return;
      }

      _this.altKeyPressed = e.altKey; // If the target changes position as the result of `dragenter`, `dragover` might still
      // get dispatched despite target being no longer there. The easy solution is to check
      // whether there actually is a target before firing `hover`.

      if (dragEnterTargetIds.length > 0) {
        _this.actions.hover(dragEnterTargetIds, {
          clientOffset: getEventClientOffset(e)
        });
      }

      var canDrop = dragEnterTargetIds.some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // IE requires this to fire dragover events
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragOverCapture", function () {
      _this.dragOverTargetIds = [];
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragOver", function (e) {
      var dragOverTargetIds = _this.dragOverTargetIds;
      _this.dragOverTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        // Prevent default "drop and blow away the whole document" action.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }

        return;
      }

      _this.altKeyPressed = e.altKey;
      _this.lastClientOffset = getEventClientOffset(e);

      if (_this.hoverRafId === null && typeof requestAnimationFrame !== 'undefined') {
        _this.hoverRafId = requestAnimationFrame(function () {
          if (_this.monitor.isDragging()) {
            _this.actions.hover(dragOverTargetIds || [], {
              clientOffset: _this.lastClientOffset
            });
          }

          _this.hoverRafId = null;
        });
      }

      var canDrop = (dragOverTargetIds || []).some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // Show user-specified drop effect.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      } else if (_this.isDraggingNativeItem()) {
        // Don't show a nice cursor but still prevent default
        // "drop and blow away the whole document" action.
        e.preventDefault();
      } else {
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDragLeaveCapture", function (e) {
      if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      }

      var isLastLeave = _this.enterLeaveCounter.leave(e.target);

      if (!isLastLeave) {
        return;
      }

      if (_this.isDraggingNativeItem()) {
        setTimeout(function () {
          return _this.endDragNativeItem();
        }, 0);
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDropCapture", function (e) {
      _this.dropTargetIds = [];

      if (_this.isDraggingNativeItem()) {
        var _this$currentNativeSo;

        e.preventDefault();
        (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 ? void 0 : _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
      } else if (matchNativeItemType(e.dataTransfer)) {
        // Dragging some elements, like <a> and <img> may still behave like a native drag event,
        // even if the current drag event matches a user-defined type.
        // Stop the default behavior when we're not expecting a native item to be dropped.
        e.preventDefault();
      }

      _this.enterLeaveCounter.reset();
    });

    HTML5BackendImpl__defineProperty(this, "handleTopDrop", function (e) {
      var dropTargetIds = _this.dropTargetIds;
      _this.dropTargetIds = [];

      _this.actions.hover(dropTargetIds, {
        clientOffset: getEventClientOffset(e)
      });

      _this.actions.drop({
        dropEffect: _this.getCurrentDropEffect()
      });

      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      } else if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    });

    HTML5BackendImpl__defineProperty(this, "handleSelectStart", function (e) {
      var target = e.target; // Only IE requires us to explicitly say
      // we want drag drop operation to start

      if (typeof target.dragDrop !== 'function') {
        return;
      } // Inputs and textareas should be selectable


      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      } // For other targets, ask IE
      // to enable drag and drop


      e.preventDefault();
      target.dragDrop();
    });

    this.options = new OptionsReader(globalContext, options);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new EnterLeaveCounter_EnterLeaveCounter(this.isNodeInDocument);
  }
  /**
   * Generate profiling statistics for the HTML5Backend.
   */


  HTML5BackendImpl__createClass(HTML5BackendImpl, [{
    key: "profile",
    value: function profile() {
      var _this$dragStartSource, _this$dragOverTargetI;

      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodeOptions: this.sourceNodeOptions.size,
        sourceNodes: this.sourceNodes.size,
        dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
        dropTargetIds: this.dropTargetIds.length,
        dragEnterTargetIds: this.dragEnterTargetIds.length,
        dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
      };
    } // public for test

  }, {
    key: "window",
    get: function get() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function get() {
      return this.options.document;
    }
    /**
     * Get the root element to use for event subscriptions
     */

  }, {
    key: "rootElement",
    get: function get() {
      return this.options.rootElement;
    }
  }, {
    key: "setup",
    value: function setup() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      if (root.__isReactDndBackendSetUp) {
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }

      root.__isReactDndBackendSetUp = true;
      this.addEventListeners(root);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      root.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.rootElement);
      this.clearCurrentDragSourceNode();

      if (this.asyncEndDragFrameId) {
        var _this$window;

        (_this$window = this.window) === null || _this$window === void 0 ? void 0 : _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;

      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function () {
        _this2.sourcePreviewNodes.delete(sourceId);

        _this2.sourcePreviewNodeOptions.delete(sourceId);
      };
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node, options) {
      var _this3 = this;

      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);

      var handleDragStart = function handleDragStart(e) {
        return _this3.handleDragStart(e, sourceId);
      };

      var handleSelectStart = function handleSelectStart(e) {
        return _this3.handleSelectStart(e);
      };

      node.setAttribute('draggable', 'true');
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);
      return function () {
        _this3.sourceNodes.delete(sourceId);

        _this3.sourceNodeOptions.delete(sourceId);

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', 'false');
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this4.handleDragEnter(e, targetId);
      };

      var handleDragOver = function handleDragOver(e) {
        return _this4.handleDragOver(e, targetId);
      };

      var handleDrop = function handleDrop(e) {
        return _this4.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);
      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.addEventListener) {
        return;
      }

      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.removeEventListener) {
        return;
      }

      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return _objectSpread({
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      }, sourceNodeOptions || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return _objectSpread({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      }, sourcePreviewNodeOptions || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes_namespaceObject).some(function (key) {
        return NativeTypes_namespaceObject[key] === itemType;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function beginDragNativeItem(type, dataTransfer) {
      this.clearCurrentDragSourceNode();
      this.currentNativeSource = createNativeDragSource(type, dataTransfer);
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function setCurrentDragSourceNode(node) {
      var _this5 = this;

      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869

      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      //
      // We need to wait before we start listening for mousemove events.
      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
      // immediately in some browsers.
      //
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869
      //

      this.mouseMoveTimeoutTimer = setTimeout(function () {
        var _this5$rootElement;

        return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;

        if (this.rootElement) {
          var _this$window2;

          (_this$window2 = this.window) === null || _this$window2 === void 0 ? void 0 : _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
          this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }

        this.mouseMoveTimeoutTimer = null;
        return true;
      }

      return false;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e, sourceId) {
      if (e.defaultPrevented) {
        return;
      }

      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }

      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }

      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }]);

  return HTML5BackendImpl;
}();
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/getEmptyImage.js
var emptyImage;
function getEmptyImage() {
  if (!emptyImage) {
    emptyImage = new Image();
    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  }

  return emptyImage;
}
// CONCATENATED MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTML5Backend", function() { return HTML5Backend; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getEmptyImage", function() { return getEmptyImage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NativeTypes", function() { return NativeTypes_namespaceObject; });




var HTML5Backend = function createBackend(manager, context, options) {
  return new HTML5BackendImpl_HTML5BackendImpl(manager, context, options);
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #222222;\n  font-size: 18px;\n'], ['\n  color: #222222;\n  font-size: 18px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var P1 = _styledComponents2.default.div.withConfig({
  displayName: 'P1',
  componentId: 'm551c4-0'
})(_templateObject);

exports.default = P1;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(253);
var ViewportMetrics = __webpack_require__(612);

var getEventModifierState = __webpack_require__(422);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);
var DOMNamespaces = __webpack_require__(424);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var EventPluginRegistry = __webpack_require__(417);
var ReactEventEmitterMixin = __webpack_require__(1276);
var ViewportMetrics = __webpack_require__(612);

var getVendorPrefixedEventName = __webpack_require__(1277);
var isEventSupported = __webpack_require__(421);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * There are cases where important information is at the end of the string and truncating the end isn't helpful.
 * This function solves that.
 *
 * @param  {string} str         String to be truncated
 * @param  {number} frontLen    Number of characters to be remained in front.
 * @param  {number} backLen     Number of characters to be remained at the back.
 * @param  {string} truncateStr String that is replaced the truncated portion
 * @return {string}             Truncated string. Defaults to '&hellip;' if unspecified.
 */
module.exports = function (str, frontLen, backLen, truncateStr) {
  if (str === null) {
    return ''
  }
  var strLen = str.length
  // Setting default values
  frontLen = ~~frontLen // will cast to integer
  backLen = ~~backLen
  truncateStr = truncateStr || '&hellip;'
  if (frontLen === 0 && backLen === 0 || frontLen >= strLen || backLen >= strLen || (frontLen + backLen) >= strLen) {
    return str
  } else if (backLen === 0) {
    return str.slice(0, frontLen) + truncateStr
  } else {
    return str.slice(0, frontLen) + truncateStr + str.slice(strLen - backLen)
  }
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: ', 'px;\n  width: ', 'px;\n  margin-right: 15px;\n'], ['\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: ', 'px;\n  width: ', 'px;\n  margin-right: 15px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  background-size: contain;\n'], ['\n  background-image: url(', ');\n  background-size: contain;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iconAudioY = __webpack_require__(1332);

var _iconAudioY2 = _interopRequireDefault(_iconAudioY);

var _iconDocumentY = __webpack_require__(1333);

var _iconDocumentY2 = _interopRequireDefault(_iconDocumentY);

var _iconAppY = __webpack_require__(1334);

var _iconAppY2 = _interopRequireDefault(_iconAppY);

var _iconImageY = __webpack_require__(1335);

var _iconImageY2 = _interopRequireDefault(_iconImageY);

var _iconPresentationY = __webpack_require__(1336);

var _iconPresentationY2 = _interopRequireDefault(_iconPresentationY);

var _iconVideoY = __webpack_require__(1337);

var _iconVideoY2 = _interopRequireDefault(_iconVideoY);

var _iconWebY = __webpack_require__(1338);

var _iconWebY2 = _interopRequireDefault(_iconWebY);

var _iconSimulationY = __webpack_require__(1339);

var _iconSimulationY2 = _interopRequireDefault(_iconSimulationY);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeIcon = _styledComponents2.default.div.withConfig({
  displayName: 'FileTypeIcon__TypeIcon',
  componentId: 'sc-1kv1nng-0'
})(_templateObject, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

var AudioTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__AudioTypeIcon',
  componentId: 'sc-1kv1nng-1'
})(_templateObject2, _iconAudioY2.default);

var DocumentTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__DocumentTypeIcon',
  componentId: 'sc-1kv1nng-2'
})(_templateObject2, _iconDocumentY2.default);

var GameAppTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__GameAppTypeIcon',
  componentId: 'sc-1kv1nng-3'
})(_templateObject2, _iconAppY2.default);

var ImageTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__ImageTypeIcon',
  componentId: 'sc-1kv1nng-4'
})(_templateObject2, _iconImageY2.default);

var PresentationTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__PresentationTypeIcon',
  componentId: 'sc-1kv1nng-5'
})(_templateObject2, _iconPresentationY2.default);

var VideoTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__VideoTypeIcon',
  componentId: 'sc-1kv1nng-6'
})(_templateObject2, _iconVideoY2.default);

var WebTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__WebTypeIcon',
  componentId: 'sc-1kv1nng-7'
})(_templateObject2, _iconWebY2.default);

var SimulationTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'FileTypeIcon__SimulationTypeIcon',
  componentId: 'sc-1kv1nng-8'
})(_templateObject2, _iconSimulationY2.default);

var FileTypeIcon = function FileTypeIcon(_ref) {
  var type = _ref.type,
      size = _ref.size;

  var icon = null;
  switch (type) {
    case 'audio':
      {
        icon = _react2.default.createElement(AudioTypeIcon, { size: size });
        break;
      }
    case 'document':
      {
        icon = _react2.default.createElement(DocumentTypeIcon, { size: size });
        break;
      }
    case 'game_app':
      {
        icon = _react2.default.createElement(GameAppTypeIcon, { size: size });
        break;
      }
    case 'image':
      {
        icon = _react2.default.createElement(ImageTypeIcon, { size: size });
        break;
      }
    case 'presentation':
      {
        icon = _react2.default.createElement(PresentationTypeIcon, { size: size });
        break;
      }
    case 'video':
      {
        icon = _react2.default.createElement(VideoTypeIcon, { size: size });
        break;
      }
    case 'web':
      {
        icon = _react2.default.createElement(WebTypeIcon, { size: size });
        break;
      }
    case 'simulation':
      {
        icon = _react2.default.createElement(SimulationTypeIcon, { size: size });
        break;
      }
  }
  return _react2.default.createElement(
    'span',
    { className: 'quest-type-icon' },
    icon
  );
};

FileTypeIcon.defaultProps = {
  size: 25
};

FileTypeIcon.propTypes = {
  type: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.number
};

exports.default = FileTypeIcon;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectorComponent = exports.DraftSpan = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  box-shadow: none;\n  height: 44px;\n  cursor: pointer;\n  border: 0.5px solid #BBBBBB;\n  border-radius: ', ';\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n'], ['\n  box-shadow: none;\n  height: 44px;\n  cursor: pointer;\n  border: 0.5px solid #BBBBBB;\n  border-radius: ', ';\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 15px;\n  font-size: 1rem;\n  font-weight: ', ';\n  color: ', ';\n'], ['\n  padding: 0 15px;\n  font-size: 1rem;\n  font-weight: ', ';\n  color: ', ';\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  box-sizing: border-box;\n  margin-right: 15px;\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2px;\n  height: 0;\n  width: 0;\n  position: relative;\n\n  &:hover {\n    border-color: #666 transparent transparent;\n  }\n'], ['\n  display: inline-block;\n  box-sizing: border-box;\n  margin-right: 15px;\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2px;\n  height: 0;\n  width: 0;\n  position: relative;\n\n  &:hover {\n    border-color: #666 transparent transparent;\n  }\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-weight: 300;\n  margin-left: 13px;\n'], ['\n  color: #666666;\n  font-weight: 300;\n  margin-left: 13px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = __webpack_require__(633);

var _CourseDropdown = __webpack_require__(1349);

var _CourseDropdown2 = _interopRequireDefault(_CourseDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CoursesSelector__SelectorContainer',
  componentId: 'sc-1x0yxx1-0'
})(_templateObject);
var SelectControl = _styledComponents2.default.div.withConfig({
  displayName: 'CoursesSelector__SelectControl',
  componentId: 'sc-1x0yxx1-1'
})(_templateObject2, function (props) {
  return props.open ? '5px 5px 0 0' : '5px';
});

var SelectPlaceholder = _styledComponents2.default.div.withConfig({
  displayName: 'CoursesSelector__SelectPlaceholder',
  componentId: 'sc-1x0yxx1-2'
})(_templateObject3, function (props) {
  return props.color ? 500 : 300;
}, function (props) {
  return props.color ? '#' + props.color : '#999999';
});

var SelectArrow = _styledComponents2.default.span.withConfig({
  displayName: 'CoursesSelector__SelectArrow',
  componentId: 'sc-1x0yxx1-3'
})(_templateObject4);
var DraftSpan = exports.DraftSpan = _styledComponents2.default.span.withConfig({
  displayName: 'CoursesSelector__DraftSpan',
  componentId: 'sc-1x0yxx1-4'
})(_templateObject5);

var SelectorComponent = exports.SelectorComponent = function SelectorComponent(_ref) {
  var courses = _ref.courses,
      onSelectCourse = _ref.onSelectCourse,
      initialSelectedCourse = _ref.initialSelectedCourse;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(initialSelectedCourse),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedCourse = _useState4[0],
      setSelectedCourse = _useState4[1];

  var toggle = function toggle() {
    setDropdownOpen(!dropdownOpen);
  };
  var handleSelectedCourse = function handleSelectedCourse(course) {
    setSelectedCourse(course);
    onSelectCourse(course);
  };
  return _react2.default.createElement(
    _core.ClickAwayListener,
    { onClickAway: function onClickAway() {
        return setDropdownOpen(false);
      } },
    _react2.default.createElement(
      SelectorContainer,
      null,
      _react2.default.createElement(
        SelectControl,
        { open: dropdownOpen, onClick: toggle },
        selectedCourse === null && _react2.default.createElement(
          SelectPlaceholder,
          null,
          'Select a course.'
        ),
        selectedCourse && _react2.default.createElement(
          SelectPlaceholder,
          {
            color: selectedCourse.color },
          selectedCourse.grade_level_abbreviation + '/ ' + selectedCourse.name,
          _react2.default.createElement(
            DraftSpan,
            null,
            selectedCourse.enrollment_ready_courses_count === 0 || selectedCourse.enrollment_ready_courses_count !== selectedCourse.courses_count ? '(Draft)' : ''
          )
        ),
        _react2.default.createElement(SelectArrow, { onClick: toggle })
      ),
      dropdownOpen && _react2.default.createElement(_CourseDropdown2.default, { courses: courses, onSelectCourse: handleSelectedCourse, selectedCourse: selectedCourse, toggle: toggle })
    )
  );
};

SelectorComponent.propTypes = {
  courses: _propTypes2.default.array
};

exports.default = SelectorComponent;

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(27);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon_SvgIcon = /*#__PURE__*/react["forwardRef"](function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(capitalize["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(capitalize["a" /* default */])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/react["createElement"]("title", null, titleAccess) : null);
});
 false ? SvgIcon_SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon_SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ var esm_SvgIcon_SvgIcon = (Object(withStyles["a" /* default */])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon_SvgIcon));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_SvgIcon_SvgIcon; });


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(116);

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc.defaultView || window;
}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsupportedProp;
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(189);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js







function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return react_dom["findDOMNode"](container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal_Portal = /*#__PURE__*/react["forwardRef"](function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = react["useState"](null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(useForkRef["a" /* default */])( /*#__PURE__*/react["isValidElement"](children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(setRef["a" /* default */])(ref, mountNode);
      return function () {
        Object(setRef["a" /* default */])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/react["isValidElement"](children)) {
      return /*#__PURE__*/react["cloneElement"](children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/react_dom["createPortal"](children, mountNode) : mountNode;
});
 false ? Portal_Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal_Portal['propTypes' + ''] = exactProp(Portal_Portal.propTypes);
}

/* harmony default export */ var esm_Portal_Portal = (Portal_Portal);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Portal/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_Portal_Portal; });


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
module.exports = (function() {

    function identity(v){return v;}

    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

    function makeCompareFunction(f, opt){
        opt = typeof(opt)==="object" ? opt : {direction:opt};
        
        if(typeof(f)!="function"){
            var prop = f;
            // make unary function
            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
        }
        if(f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase?ignoreCase:identity;
            var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
            f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
        }
        const descTokens = {"-1":'', desc:''};
        if(opt.direction in descTokens) return function(v1,v2){return -f(v1,v2)};
        return f;
    }

    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */
    function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */
        var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
                        return x(a,b) || y(a,b);
                    }
                  : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
})();


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.React, global.propTypes);
    global.TextTruncate = mod.exports;
  }
})(this, function (module, exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextTruncate = function (_Component) {
    _inherits(TextTruncate, _Component);

    function TextTruncate() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TextTruncate);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextTruncate.__proto__ || Object.getPrototypeOf(TextTruncate)).call.apply(_ref, [this].concat(args))), _this), _this.onResize = function () {
        if (_this.rafId) {
          window.cancelAnimationFrame(_this.rafId);
        }
        _this.rafId = window.requestAnimationFrame(_this.update.bind(_this));
      }, _this.onTruncated = function () {
        typeof _this.props.onTruncated === 'function' && setTimeout(function () {
          return _this.props.onTruncated();
        }, 0);
      }, _this.onCalculated = function () {
        typeof _this.props.onCalculated === 'function' && setTimeout(function () {
          return _this.props.onCalculated();
        }, 0);
      }, _this.update = function () {
        var style = window.getComputedStyle(_this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
        _this.canvas.font = font;
        _this.forceUpdate();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextTruncate, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var canvas = document.createElement('canvas');
        var docFragment = document.createDocumentFragment();
        var style = window.getComputedStyle(this.scope);
        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');

        docFragment.appendChild(canvas);
        this.canvas = canvas.getContext('2d');
        this.canvas.font = font;
        this.forceUpdate();
        window.addEventListener('resize', this.onResize);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        if (this.rafId) {
          window.cancelAnimationFrame(this.rafId);
        }
      }
    }, {
      key: 'measureWidth',
      value: function measureWidth(text) {
        return this.canvas.measureText(text).width;
      }
    }, {
      key: 'getRenderText',
      value: function getRenderText() {
        var _props = this.props,
            containerClassName = _props.containerClassName,
            element = _props.element,
            line = _props.line,
            onCalculated = _props.onCalculated,
            onTruncated = _props.onTruncated,
            text = _props.text,
            textElement = _props.textElement,
            textTruncateChild = _props.textTruncateChild,
            truncateText = _props.truncateText,
            props = _objectWithoutProperties(_props, ['containerClassName', 'element', 'line', 'onCalculated', 'onTruncated', 'text', 'textElement', 'textTruncateChild', 'truncateText']);

        var scopeWidth = this.scope.getBoundingClientRect().width;

        // return if display:none
        if (scopeWidth === 0) {
          return null;
        }

        // return if all of text can be displayed
        if (scopeWidth >= this.measureWidth(text)) {
          return (0, _react.createElement)(textElement, props, text);
        }

        var childText = '';
        if (textTruncateChild && typeof textTruncateChild.type === 'string') {
          var type = textTruncateChild.type;
          if (type.indexOf('span') >= 0 || type.indexOf('a') >= 0) {
            childText = textTruncateChild.props.children;
          }
        }

        var currentPos = 1;
        var maxTextLength = text.length;
        var truncatedText = '';
        var splitPos = 0;
        var startPos = 0;
        var displayLine = line;
        var width = 0;
        var lastIsEng = false;
        var isPrevLineWithoutSpace = false;
        var lastPos = 0;
        var lastSpaceIndex = -1;

        while (displayLine-- > 0) {
          var ext = displayLine ? '' : truncateText + ' ' + childText;
          while (currentPos <= maxTextLength) {
            truncatedText = text.substr(startPos, currentPos);
            width = this.measureWidth(truncatedText + ext);
            if (width < scopeWidth) {
              splitPos = text.indexOf(' ', currentPos + 1);
              if (splitPos === -1) {
                currentPos += 1;
                lastIsEng = false;
              } else {
                lastIsEng = true;
                currentPos = splitPos;
              }
            } else {
              do {
                currentPos--;
                truncatedText = text.substr(startPos, currentPos);
                if (truncatedText[truncatedText.length - 1] === ' ') {
                  truncatedText = text.substr(startPos, currentPos - 1);
                }
                if (lastIsEng) {
                  lastSpaceIndex = truncatedText.lastIndexOf(' ');
                  if (lastSpaceIndex > -1) {
                    currentPos = lastSpaceIndex - 1;
                    truncatedText = text.substr(startPos, currentPos);
                  }
                }
                width = this.measureWidth(truncatedText + ext);
              } while (width >= scopeWidth && truncatedText.length > 0);
              startPos += currentPos;
              break;
            }
          }

          if (currentPos >= maxTextLength) {
            startPos = maxTextLength;
            break;
          }

          if (lastIsEng && !isPrevLineWithoutSpace && text.substr(lastPos, currentPos).indexOf(' ') === -1) {
            isPrevLineWithoutSpace = text.substr(lastPos, currentPos).indexOf(' ') === -1;
            displayLine--;
          }
          lastPos = currentPos + 1;
        }

        if (startPos === maxTextLength) {
          return (0, _react.createElement)(textElement, props, text);
        }

        this.onTruncated();
        return _react2.default.createElement(
          'div',
          props,
          (0, _react.createElement)(textElement, props, text.substr(0, startPos) + truncateText + ' '),
          textTruncateChild
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            element = _props2.element,
            text = _props2.text,
            _props2$style = _props2.style,
            style = _props2$style === undefined ? {} : _props2$style,
            containerClassName = _props2.containerClassName,
            line = _props2.line,
            onCalculated = _props2.onCalculated,
            onTruncated = _props2.onTruncated,
            textElement = _props2.textElement,
            textTruncateChild = _props2.textTruncateChild,
            truncateText = _props2.truncateText,
            props = _objectWithoutProperties(_props2, ['element', 'text', 'style', 'containerClassName', 'line', 'onCalculated', 'onTruncated', 'textElement', 'textTruncateChild', 'truncateText']);

        var fontWeight = style.fontWeight,
            fontStyle = style.fontStyle,
            fontSize = style.fontSize,
            fontFamily = style.fontFamily;


        var renderText = this.scope ? this.getRenderText() : (0, _react.createElement)(textElement, props, text);;
        var rootProps = {
          ref: function ref(el) {
            _this2.scope = el;
          },
          className: containerClassName,
          style: { overflow: 'hidden', fontWeight: fontWeight, fontStyle: fontStyle, fontSize: fontSize, fontFamily: fontFamily }
        };

        this.scope && this.onCalculated();
        return (0, _react.createElement)(element, rootProps, renderText);
      }
    }]);

    return TextTruncate;
  }(_react.Component);

  TextTruncate.propTypes = {
    containerClassName: _propTypes2.default.string,
    element: _propTypes2.default.string,
    line: _propTypes2.default.number,
    onCalculated: _propTypes2.default.func,
    onTruncated: _propTypes2.default.func,
    text: _propTypes2.default.string,
    textElement: _propTypes2.default.node,
    textTruncateChild: _propTypes2.default.node,
    truncateText: _propTypes2.default.string
  };
  TextTruncate.defaultProps = {
    element: 'div',
    line: 1,
    text: '',
    textElement: 'div',
    truncateText: '…'
  };
  exports.default = TextTruncate;
  ;
  module.exports = exports['default'];
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Ruler is a helper class for building responsibility chains from
 * parse rules. It allows:
 *
 *   - easy stack rules chains
 *   - getting main chain and named chains content (as arrays of functions)
 *
 * Helper methods, should not be used directly.
 * @api private
 */

function Ruler() {
  // List of added rules. Each element is:
  //
  // { name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ] }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - digital anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

/**
 * Find the index of a rule by `name`.
 *
 * @param  {String} `name`
 * @return {Number} Index of the given `name`
 * @api private
 */

Ruler.prototype.__find__ = function (name) {
  var len = this.__rules__.length;
  var i = -1;

  while (len--) {
    if (this.__rules__[++i].name === name) {
      return i;
    }
  }
  return -1;
};

/**
 * Build the rules lookup cache
 *
 * @api private
 */

Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) {
      return;
    }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) {
        return;
      }

      if (chain && rule.alt.indexOf(chain) < 0) {
        return;
      }
      self.__cache__[chain].push(rule.fn);
    });
  });
};

/**
 * Ruler public methods
 * ------------------------------------------------
 */

/**
 * Replace rule function
 *
 * @param  {String} `name` Rule name
 * @param  {Function `fn`
 * @param  {Object} `options`
 * @api private
 */

Ruler.prototype.at = function (name, fn, options) {
  var idx = this.__find__(name);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + name);
  }

  this.__rules__[idx].fn = fn;
  this.__rules__[idx].alt = opt.alt || [];
  this.__cache__ = null;
};

/**
 * Add a rule to the chain before given the `ruleName`.
 *
 * @param  {String}   `beforeName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var idx = this.__find__(beforeName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + beforeName);
  }

  this.__rules__.splice(idx, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the chain after the given `ruleName`.
 *
 * @param  {String}   `afterName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var idx = this.__find__(afterName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + afterName);
  }

  this.__rules__.splice(idx + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the end of chain.
 *
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @return {String}
 */

Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Enable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to enable
 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
 * @api private
 */

Ruler.prototype.enable = function (list, strict) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // In strict mode disable all existing rules first
  if (strict) {
    this.__rules__.forEach(function (rule) {
      rule.enabled = false;
    });
  }

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
  }, this);

  this.__cache__ = null;
};


/**
 * Disable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to disable
 * @api private
 */

Ruler.prototype.disable = function (list) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
  }, this);

  this.__cache__ = null;
};

/**
 * Get a rules list as an array of functions.
 *
 * @param  {String} `chainName`
 * @return {Object}
 * @api private
 */

Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }
  return this.__cache__[chainName] || [];
};

/**
 * Expose `Ruler`
 */

module.exports = Ruler;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Parse link labels
 *
 * This function assumes that first character (`[`) already matches;
 * returns the end of the label.
 *
 * @param  {Object} state
 * @param  {Number} start
 * @api private
 */

module.exports = function parseLinkLabel(state, start) {
  var level, found, marker,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos,
      oldFlag = state.isInLabel;

  if (state.isInLabel) { return -1; }

  if (state.labelUnmatchedScopes) {
    state.labelUnmatchedScopes--;
    return -1;
  }

  state.pos = start + 1;
  state.isInLabel = true;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5B /* [ */) {
      level++;
    } else if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    state.parser.skipToken(state);
  }

  if (found) {
    labelEnd = state.pos;
    state.labelUnmatchedScopes = 0;
  } else {
    state.labelUnmatchedScopes = level - 1;
  }

  // restore old state
  state.pos = oldPos;
  state.isInLabel = oldFlag;

  return labelEnd;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedSearchFilter = function (_React$Component) {
  (0, _inherits3.default)(WrappedSearchFilter, _React$Component);

  function WrappedSearchFilter(props) {
    (0, _classCallCheck3.default)(this, WrappedSearchFilter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WrappedSearchFilter.__proto__ || (0, _getPrototypeOf2.default)(WrappedSearchFilter)).call(this, props));

    _this.state = {
      active: props.active
    };
    _this.onClickBound = _this.onClick.bind(_this);
    _this.onBlurBound = _this.onBlur.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(WrappedSearchFilter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          area = _props.area;

      return _react2.default.createElement(
        'div',
        {
          className: 'area ' + area + '-wrapper ' + (this.state.active ? 'active' : '') + ' ' + (disabled ? 'disabled' : ''),
          onMouseDown: this.onClickBound,
          onBlur: this.onBlurBound,
          'data-for': area + '-filter-tooltip',
          'data-tip': this.props.disabledText
        },
        disabled && _react2.default.createElement(_reactTooltip2.default, { id: area + '-filter-tooltip' }),
        _react2.default.createElement(
          'label',
          { className: 'header h5' },
          this.props.label
        ),
        disabled ? null : this.props.children
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _this2 = this;

      this.setState(function () {
        return {
          active: true
        };
      });
      if (!this.state.active) {
        setTimeout(function () {
          _this2.props.wrappedRef.current.focus();
        }, 100);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var _this3 = this;

      this.setState(function () {
        return {
          active: _this3.props.active
        };
      });
    }
  }]);
  return WrappedSearchFilter;
}(_react2.default.Component);

exports.default = WrappedSearchFilter;


WrappedSearchFilter.propTypes = {
  area: _propTypes2.default.string.isRequired,
  active: _propTypes2.default.bool.isRequired,
  label: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.object,
  wrappedRef: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  disabledText: _propTypes2.default.string
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.courseLevels = undefined;

var _reselect = __webpack_require__(168);

var _getCourseLevels = function _getCourseLevels(state, selectedCourse) {
  if (!selectedCourse) {
    return [];
  } else {
    return state.mockcourses.items.find(function (mc) {
      return mc.id === selectedCourse.id;
    }).mock_levels;
  }
};

var courseLevels = exports.courseLevels = (0, _reselect.createSelector)([_getCourseLevels], function (levels) {
  return levels;
});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTextTruncate = __webpack_require__(332);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderLockup = function HeaderLockup(props) {
  return _react2.default.createElement(
    'div',
    { className: 'header-lockup' },
    props.avatarComponent,
    _react2.default.createElement(
      'div',
      { className: 'org-name-section-container' },
      _react2.default.createElement(
        'div',
        { className: 'h1' },
        props.section
      ),
      _react2.default.createElement(
        'div',
        { className: 'org-name' },
        _react2.default.createElement(_reactTextTruncate2.default, {
          line: 3,
          truncateText: '...',
          text: props.organization.name
        })
      )
    )
  );
};

HeaderLockup.propTypes = {
  organization: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string.isRequired,
  avatarComponent: _propTypes2.default.element.isRequired
};

exports.default = HeaderLockup;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentOrg = undefined;

var _reselect = __webpack_require__(168);

var _getCurrentOrg = function _getCurrentOrg(state) {
  return state.organizations.items.find(function (org) {
    return org.id === parseInt(state.organization.orgId);
  });
};

var currentOrg = exports.currentOrg = (0, _reselect.createSelector)([_getCurrentOrg], function (org) {
  return org;
});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWarningIcon = function (_Component) {
  (0, _inherits3.default)(ContentWarningIcon, _Component);

  function ContentWarningIcon() {
    (0, _classCallCheck3.default)(this, ContentWarningIcon);
    return (0, _possibleConstructorReturn3.default)(this, (ContentWarningIcon.__proto__ || (0, _getPrototypeOf2.default)(ContentWarningIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContentWarningIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          abbrev = _props.abbrev,
          showTooltip = _props.showTooltip,
          text = _props.text;


      var tooltipId = value + abbrev + '-' + Math.random();

      return _react2.default.createElement(
        'div',
        {
          className: 'content-warning-icon',
          'data-for': tooltipId,
          'data-tip': text
        },
        showTooltip && _react2.default.createElement(_reactTooltip2.default, { id: tooltipId, effect: 'solid' }),
        _react2.default.createElement(
          'span',
          { className: 'abrev' },
          this.props.abbrev
        )
      );
    }
  }]);
  return ContentWarningIcon;
}(_react.Component);

exports.default = ContentWarningIcon;


ContentWarningIcon.propTypes = {
  value: _propTypes2.default.string.isRequired,
  showTooltip: _propTypes2.default.bool,
  abbrev: _propTypes2.default.string,
  text: _propTypes2.default.string
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.filterCurrentUserFromMembers = filterCurrentUserFromMembers;
exports.mapChannelMembers = mapChannelMembers;
exports.formatModalWarningMessageProp = formatModalWarningMessageProp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(679);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterCurrentUserFromMembers(members, userId) {
  var filteredMembers = members.members;
  delete filteredMembers[userId];
  return filteredMembers;
}

function mapChannelMembers(members) {
  var retVal = [];
  (0, _keys2.default)(members).forEach(function (m) {
    retVal.push({
      id: m,
      name: members[m].name
    });
  });
  return retVal;
}

function formatModalWarningMessageProp(members, userId) {
  var filteredMappedMembers = mapChannelMembers(filterCurrentUserFromMembers(members, userId));
  var membersMessage = {};
  filteredMappedMembers.length === 1 ? membersMessage = _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'strong',
      null,
      filteredMappedMembers[0].name
    ),
    ' is',
    ' '
  ) : membersMessage = filteredMappedMembers.map(function (m, i) {
    var length = filteredMappedMembers.length;
    if (length > 2 && i < length - 1) {
      return _react2.default.createElement(
        'span',
        { key: 2 },
        _react2.default.createElement(
          'strong',
          null,
          m.name
        ),
        ',',
        ' '
      );
    } else if (length === 2 && i < length - 1) {
      return _react2.default.createElement(
        'span',
        { key: 2 },
        _react2.default.createElement(
          'strong',
          null,
          m.name
        ),
        ' '
      );
    } else {
      return _react2.default.createElement(
        'span',
        { key: 3 },
        'and ',
        _react2.default.createElement(
          'strong',
          null,
          m.name
        ),
        ' are',
        ' '
      );
    }
  });

  return (0, _server.renderToString)(_react2.default.createElement(
    'span',
    { key: 1 },
    membersMessage,
    ' currently editing this page. Contact them to let them know you\u2019d like to edit. If you edit this page, your changes or their changes could be lost.'
  ));
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandedHistoryEventContainer = exports.ActivitiesSortedIcon = exports.ActivityAddIcon = exports.DeleteIcon = exports.ReviewCommentIcon = exports.InQualityReviewLabelIcon = exports.PublishedLabelIcon = exports.DraftLabelIcon = exports.ReviewReturnedLabelIcon = exports.IconWrapper = exports.CreateQuestIcon = exports.UnassignedIcon = exports.AssignedIcon = exports.QualityRejectedIcon = exports.QualityApprovedIcon = exports.InternalRemovedIcon = exports.InternalApprovedIcon = exports.EditIcon = exports.CommentPostedIcon = exports.CommentEditedIcon = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 13px;\n  width: 15px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 13px;\n  width: 15px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 135px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 135px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 157px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 157px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 91px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 91px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 60px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 26px;\n  width: 60px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 20px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 20px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 20px;\n'], ['\n  background: url(', ') no-repeat;\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 20px;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 19px;\n  width: 22px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 19px;\n  width: 22px;\n']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 12px;\n  width: 12px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 12px;\n  width: 12px;\n']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 19px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 20px;\n  width: 19px;\n']),
    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 19px;\n  width: 19px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 19px;\n  width: 19px;\n']),
    _templateObject12 = (0, _taggedTemplateLiteral3.default)(['\n  width: 22px;\n  margin-right: 34px;\n  display: flex;\n  justify-content: center;\n'], ['\n  width: 22px;\n  margin-right: 34px;\n  display: flex;\n  justify-content: center;\n']),
    _templateObject13 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 16px;\n  width: 14px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 16px;\n  width: 14px;\n']),
    _templateObject14 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 12px;\n  width: 11px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 12px;\n  width: 11px;\n']),
    _templateObject15 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 13px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 13px;\n']),
    _templateObject16 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  border-top: 1px solid #dedfe0;\n\n  li {\n    background: inherit !important;\n  }\n\n  * {\n    cursor: pointer;\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    left: 100%;\n    width: 0;\n    height: 0;\n    border-style: solid;\n  }\n\n  &:after {\n    left: ', ';\n    top: -20px;\n    border-color: ', ';\n    border-width: 10px;\n  }\n\n  &:before {\n    left: ', ';\n    top: -22px;\n    border-color: transparent transparent #dedfe0 transparent;\n    border-width: 11px;\n  }\n'], ['\n  position: relative;\n  border-top: 1px solid #dedfe0;\n\n  li {\n    background: inherit !important;\n  }\n\n  * {\n    cursor: pointer;\n  }\n\n  &:before,\n  &:after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    left: 100%;\n    width: 0;\n    height: 0;\n    border-style: solid;\n  }\n\n  &:after {\n    left: ', ';\n    top: -20px;\n    border-color: ', ';\n    border-width: 10px;\n  }\n\n  &:before {\n    left: ', ';\n    top: -22px;\n    border-color: transparent transparent #dedfe0 transparent;\n    border-width: 11px;\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _assigned = __webpack_require__(1515);

var _assigned2 = _interopRequireDefault(_assigned);

var _unassigned = __webpack_require__(1516);

var _unassigned2 = _interopRequireDefault(_unassigned);

var _comment_edited = __webpack_require__(1517);

var _comment_edited2 = _interopRequireDefault(_comment_edited);

var _comment_posted = __webpack_require__(1518);

var _comment_posted2 = _interopRequireDefault(_comment_posted);

var _edit = __webpack_require__(1519);

var _edit2 = _interopRequireDefault(_edit);

var _internal_approved = __webpack_require__(1520);

var _internal_approved2 = _interopRequireDefault(_internal_approved);

var _internal_removed = __webpack_require__(1521);

var _internal_removed2 = _interopRequireDefault(_internal_removed);

var _quality_approved = __webpack_require__(1522);

var _quality_approved2 = _interopRequireDefault(_quality_approved);

var _quality_rejected = __webpack_require__(1523);

var _quality_rejected2 = _interopRequireDefault(_quality_rejected);

var _icon_create_quest = __webpack_require__(1524);

var _icon_create_quest2 = _interopRequireDefault(_icon_create_quest);

var _draft_status_label = __webpack_require__(1525);

var _draft_status_label2 = _interopRequireDefault(_draft_status_label);

var _published_status_label = __webpack_require__(1526);

var _published_status_label2 = _interopRequireDefault(_published_status_label);

var _review_returned_status_label = __webpack_require__(1527);

var _review_returned_status_label2 = _interopRequireDefault(_review_returned_status_label);

var _in_publication_review_status_label = __webpack_require__(1528);

var _in_publication_review_status_label2 = _interopRequireDefault(_in_publication_review_status_label);

var _review_comment = __webpack_require__(1529);

var _review_comment2 = _interopRequireDefault(_review_comment);

var _icon_deleted = __webpack_require__(1530);

var _icon_deleted2 = _interopRequireDefault(_icon_deleted);

var _icon_activity_added = __webpack_require__(1531);

var _icon_activity_added2 = _interopRequireDefault(_icon_activity_added);

var _icon_activities_sorted = __webpack_require__(1532);

var _icon_activities_sorted2 = _interopRequireDefault(_icon_activities_sorted);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewCommentIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__ReviewCommentIcon',
  componentId: 'sc-9q5zl8-0'
})(_templateObject, _review_comment2.default);

var ReviewReturnedLabelIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__ReviewReturnedLabelIcon',
  componentId: 'sc-9q5zl8-1'
})(_templateObject2, _review_returned_status_label2.default);

var InQualityReviewLabelIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__InQualityReviewLabelIcon',
  componentId: 'sc-9q5zl8-2'
})(_templateObject3, _in_publication_review_status_label2.default);

var PublishedLabelIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__PublishedLabelIcon',
  componentId: 'sc-9q5zl8-3'
})(_templateObject4, _published_status_label2.default);

var DraftLabelIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__DraftLabelIcon',
  componentId: 'sc-9q5zl8-4'
})(_templateObject5, _draft_status_label2.default);

var AssignedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__AssignedIcon',
  componentId: 'sc-9q5zl8-5'
})(_templateObject6, _assigned2.default);

var CreateQuestIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__CreateQuestIcon',
  componentId: 'sc-9q5zl8-6'
})(_templateObject7, _icon_create_quest2.default);

var UnassignedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__UnassignedIcon',
  componentId: 'sc-9q5zl8-7'
})(_templateObject6, _unassigned2.default);

var CommentEditedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__CommentEditedIcon',
  componentId: 'sc-9q5zl8-8'
})(_templateObject8, _comment_edited2.default);

var CommentPostedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__CommentPostedIcon',
  componentId: 'sc-9q5zl8-9'
})(_templateObject8, _comment_posted2.default);

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__EditIcon',
  componentId: 'sc-9q5zl8-10'
})(_templateObject9, _edit2.default);

var InternalApprovedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__InternalApprovedIcon',
  componentId: 'sc-9q5zl8-11'
})(_templateObject10, _internal_approved2.default);

var InternalRemovedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__InternalRemovedIcon',
  componentId: 'sc-9q5zl8-12'
})(_templateObject11, _internal_removed2.default);

var QualityApprovedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__QualityApprovedIcon',
  componentId: 'sc-9q5zl8-13'
})(_templateObject11, _quality_approved2.default);

var QualityRejectedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__QualityRejectedIcon',
  componentId: 'sc-9q5zl8-14'
})(_templateObject11, _quality_rejected2.default);

var IconWrapper = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__IconWrapper',
  componentId: 'sc-9q5zl8-15'
})(_templateObject12);

var DeleteIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__DeleteIcon',
  componentId: 'sc-9q5zl8-16'
})(_templateObject13, _icon_deleted2.default);

var ActivityAddIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__ActivityAddIcon',
  componentId: 'sc-9q5zl8-17'
})(_templateObject14, _icon_activity_added2.default);

var ActivitiesSortedIcon = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__ActivitiesSortedIcon',
  componentId: 'sc-9q5zl8-18'
})(_templateObject15, _icon_activities_sorted2.default);

var ExpandedHistoryEventContainer = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__ExpandedHistoryEventContainer',
  componentId: 'sc-9q5zl8-19'
})(_templateObject16, function (props) {
  return props.comment ? '77px' : '24px';
}, function (props) {
  return 'transparent transparent ' + props.bg + ' transparent';
}, function (props) {
  return props.comment ? '76px' : '23px';
});

exports.CommentEditedIcon = CommentEditedIcon;
exports.CommentPostedIcon = CommentPostedIcon;
exports.EditIcon = EditIcon;
exports.InternalApprovedIcon = InternalApprovedIcon;
exports.InternalRemovedIcon = InternalRemovedIcon;
exports.QualityApprovedIcon = QualityApprovedIcon;
exports.QualityRejectedIcon = QualityRejectedIcon;
exports.AssignedIcon = AssignedIcon;
exports.UnassignedIcon = UnassignedIcon;
exports.CreateQuestIcon = CreateQuestIcon;
exports.IconWrapper = IconWrapper;
exports.ReviewReturnedLabelIcon = ReviewReturnedLabelIcon;
exports.DraftLabelIcon = DraftLabelIcon;
exports.PublishedLabelIcon = PublishedLabelIcon;
exports.InQualityReviewLabelIcon = InQualityReviewLabelIcon;
exports.ReviewCommentIcon = ReviewCommentIcon;
exports.DeleteIcon = DeleteIcon;
exports.ActivityAddIcon = ActivityAddIcon;
exports.ActivitiesSortedIcon = ActivitiesSortedIcon;
exports.ExpandedHistoryEventContainer = ExpandedHistoryEventContainer;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports) {

var LIFECYCLE_HOOKS = {
  componentWillMount: true,
  componentDidMount: true,
  componentWillReceiveProps: true,
  getSnapshotBeforeUpdate: true,
  shouldComponentUpdate: true,
  componentWillUpdate: true,
  componentDidUpdate: true,
  componentWillUnmount: true,
}

var STATIC_HOOKS = {
  getDerivedStateFromProps: true,
}

function wrap(base, method, isStatic) {
  var before = true

  if (Array.isArray(method)) {
    before = method[0] !== 'after'
    method = method[1]
  }

  if (!base) return method

  return function wrappedLifecyclehook() {
    var ctx = isStatic ? null : this
    before && method.apply(ctx, arguments)
    base.apply(ctx, arguments)
    !before && method.apply(ctx, arguments)
  }
}

module.exports = function spyOnComponent(component, hooks) {
  var originals = Object.create(null)

  for (var key in hooks)
    if (STATIC_HOOKS[key])
      component.constructor[key] = wrap(
        (originals[key] = component.constructor[key]),
        hooks[key],
        true
      )

  for (var key in hooks)
    if (LIFECYCLE_HOOKS[key])
      component[key] = wrap((originals[key] = component[key]), hooks[key])

  return function reset(key) {
    var subject = STATIC_HOOKS[key] ? component.constructor : component

    if (key && key in originals) subject[key] = originals[key]
    else for (key in originals) subject[key] = originals[key]
  }
}

module.exports.mixin = function mixinIntoComponent(componentClass, hooks) {
  spyOnComponent(componentClass.prototype, hooks)
  return componentClass
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 347 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133);
var document = __webpack_require__(81).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(133);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(119);
var dPs = __webpack_require__(488);
var enumBugKeys = __webpack_require__(354);
var IE_PROTO = __webpack_require__(352)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(348)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(491).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(346);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(353)('keys');
var uid = __webpack_require__(277);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(43);
var global = __webpack_require__(81);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(224) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(356);
var ITERATOR = __webpack_require__(82)('iterator');
var Iterators = __webpack_require__(194);
module.exports = __webpack_require__(43).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(226);
var TAG = __webpack_require__(82)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var document = __webpack_require__(29).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var core = __webpack_require__(105);
var LIBRARY = __webpack_require__(151);
var wksExt = __webpack_require__(497);
var defineProperty = __webpack_require__(51).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(227)('keys');
var uid = __webpack_require__(173);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(29).document;
module.exports = document && document.documentElement;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(24);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(106)(Function.call, __webpack_require__(96).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var setPrototypeOf = __webpack_require__(362).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(108);
var defined = __webpack_require__(121);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 366 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(151);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(88);
var hide = __webpack_require__(87);
var Iterators = __webpack_require__(200);
var $iterCreate = __webpack_require__(369);
var setToStringTag = __webpack_require__(197);
var getPrototypeOf = __webpack_require__(97);
var ITERATOR = __webpack_require__(44)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(176);
var descriptor = __webpack_require__(172);
var setToStringTag = __webpack_require__(197);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(87)(IteratorPrototype, __webpack_require__(44)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(283);
var defined = __webpack_require__(121);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(44)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(200);
var ITERATOR = __webpack_require__(44)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(51);
var createDesc = __webpack_require__(172);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(198);
var ITERATOR = __webpack_require__(44)('iterator');
var Iterators = __webpack_require__(200);
module.exports = __webpack_require__(105).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(832);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(54);
var toAbsoluteIndex = __webpack_require__(175);
var toLength = __webpack_require__(46);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(153);
var step = __webpack_require__(514);
var Iterators = __webpack_require__(200);
var toIObject = __webpack_require__(95);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(368)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(230);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(282)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(106);
var invoke = __webpack_require__(504);
var html = __webpack_require__(361);
var cel = __webpack_require__(357);
var global = __webpack_require__(29);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(107)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var macrotask = __webpack_require__(380).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(107)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(71);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var DESCRIPTORS = __webpack_require__(49);
var LIBRARY = __webpack_require__(151);
var $typed = __webpack_require__(289);
var hide = __webpack_require__(87);
var redefineAll = __webpack_require__(181);
var fails = __webpack_require__(31);
var anInstance = __webpack_require__(179);
var toInteger = __webpack_require__(108);
var toLength = __webpack_require__(46);
var toIndex = __webpack_require__(524);
var gOPN = __webpack_require__(177).f;
var dP = __webpack_require__(51).f;
var arrayFill = __webpack_require__(376);
var setToStringTag = __webpack_require__(197);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(82);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(81);
var core = __webpack_require__(43);
var LIBRARY = __webpack_require__(224);
var wksExt = __webpack_require__(388);
var defineProperty = __webpack_require__(132).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(276);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(70);
var core = __webpack_require__(43);
var fails = __webpack_require__(193);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_MOCK_COURSES_SUCCESS = exports.FETCH_MOCK_COURSES_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchMockCoursesRequest = fetchMockCoursesRequest;
exports.fetchMockCoursesSuccess = fetchMockCoursesSuccess;
exports.fetchMockCourses = fetchMockCourses;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_MOCK_COURSES_REQUEST = exports.FETCH_MOCK_COURSES_REQUEST = 'FETCH_MOCK_COURSES_REQUEST';
var FETCH_MOCK_COURSES_SUCCESS = exports.FETCH_MOCK_COURSES_SUCCESS = 'FETCH_MOCK_COURSES_SUCCESS';

function fetchMockCoursesRequest() {
  return {
    type: FETCH_MOCK_COURSES_REQUEST
  };
}

function fetchMockCoursesSuccess(response) {
  return {
    type: FETCH_MOCK_COURSES_SUCCESS,
    payload: {
      courses: response
    }
  };
}

function fetchMockCourses() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/mock_courses';
              return _context.abrupt('return', (0, _api.basicGet)(state, dispatch, url, fetchMockCoursesRequest, fetchMockCoursesSuccess));

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthorFilter = setAuthorFilter;
exports.setKeywordFilter = setKeywordFilter;
exports.setDraftFilter = setDraftFilter;
exports.setStatusFilter = setStatusFilter;
exports.setAssignedToFilter = setAssignedToFilter;
var SET_MY_QUESTS_AUTHOR_FILTER = exports.SET_MY_QUESTS_AUTHOR_FILTER = 'SET_MY_QUESTS_AUTHOR_FILTER';
var SET_MY_QUESTS_ASSIGNED_TO_FILTER = exports.SET_MY_QUESTS_ASSIGNED_TO_FILTER = 'SET_MY_QUESTS_ASSIGNED_TO_FILTER';
var SET_MY_QUESTS_KEYWORD_FILTER = exports.SET_MY_QUESTS_KEYWORD_FILTER = 'SET_MY_QUESTS_KEYWORD_FILTER';
var SET_MY_QUESTS_DRAFT_FILTER = exports.SET_MY_QUESTS_DRAFT_FILTER = 'SET_MY_QUESTS_DRAFT_FILTER';
var SET_MY_QUESTS_STATUS_FILTER = exports.SET_MY_QUESTS_STATUS_FILTER = 'SET_MY_QUESTS_STATUS_FILTER';

function setAuthorFilter(authorIds) {
  return {
    type: SET_MY_QUESTS_AUTHOR_FILTER,
    authors_id_in: authorIds
  };
}

function setKeywordFilter(keyword) {
  return {
    type: SET_MY_QUESTS_KEYWORD_FILTER,
    name_or_description_cont: keyword
  };
}

function setDraftFilter(val) {
  return {
    type: SET_MY_QUESTS_DRAFT_FILTER,
    quest_draft_or_state_in: val
  };
}

function setStatusFilter(statuses) {
  return {
    type: SET_MY_QUESTS_STATUS_FILTER,
    reviewing_compiled_quest_state_in: statuses
  };
}

function setAssignedToFilter(assignedToIds) {
  return {
    type: SET_MY_QUESTS_ASSIGNED_TO_FILTER,
    assigned_to_id_in: assignedToIds
  };
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchDataAndRedirectUser = fetchDataAndRedirectUser;

var _reactRouterRedux = __webpack_require__(23);

var _user = __webpack_require__(73);

var _manifest = __webpack_require__(157);

var _policies = __webpack_require__(158);

var _users = __webpack_require__(299);

var _tags = __webpack_require__(300);

var _myquests = __webpack_require__(298);

var _routes = __webpack_require__(235);

var _mockcourses = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchDataAndRedirectUser(user) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var acceptedPoliciesCount, urlParams, redirect, state, route;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              acceptedPoliciesCount = (0, _keys2.default)(user.policies_acceptance).length;
              urlParams = new URLSearchParams(window.location.search);
              redirect = urlParams.get('redirect');

              if (user.require_password_change_on_next_login) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return _promise2.default.all([
              // password change not required, no need to keep password
              sessionStorage.removeItem('password'), dispatch((0, _policies.fetchPoliciesIfNeeded)()), dispatch((0, _users.getUsers)()), dispatch((0, _user.getUserData)()), dispatch((0, _manifest.fetchManifest)()), dispatch((0, _tags.fetchTags)()), dispatch((0, _mockcourses.fetchMockCourses)()), dispatch((0, _myquests.setDefaultMyQuestsFilters)())]);

            case 6:
              if (acceptedPoliciesCount !== 0) {
                state = getState();
                route = (0, _routes.getDefaultRoute)(state.user.user.organization_roles);

                dispatch((0, _user.userIsLoggedInDataFetched)());
                dispatch((0, _reactRouterRedux.push)(redirect || route));
              }
              _context.next = 12;
              break;

            case 9:
              _context.next = 11;
              return dispatch((0, _user.userNeedsToResetPassword)(true));

            case 11:
              dispatch((0, _reactRouterRedux.push)('/changepassword'));

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthorsFilter = setAuthorsFilter;
exports.setKeywordFilter = setKeywordFilter;
exports.setDraftFilter = setDraftFilter;
exports.setStatusFilter = setStatusFilter;
exports.setCourseFilter = setCourseFilter;
exports.setLevelFilter = setLevelFilter;
exports.clearQueueFilters = clearQueueFilters;
exports.setTargetGradeLevelFilter = setTargetGradeLevelFilter;
var SET_QUEUE_AUTHORS_FILTER = exports.SET_QUEUE_AUTHORS_FILTER = 'SET_QUEUE_AUTHORS_FILTER';
var SET_QUEUE_KEYWORD_FILTER = exports.SET_QUEUE_KEYWORD_FILTER = 'SET_QUEUE_KEYWORD_FILTER';
var SET_QUEUE_DRAFT_FILTER = exports.SET_QUEUE_DRAFT_FILTER = 'SET_QUEUE_DRAFT_FILTER';
var SET_QUEUE_STATUS_FILTER = exports.SET_QUEUE_STATUS_FILTER = 'SET_QUEUE_STATUS_FILTER';
var SET_QUEUE_COURSE_FILTER = exports.SET_QUEUE_COURSE_FILTER = 'SET_QUEUE_COURSE_FILTER';
var SET_QUEUE_LEVELS_FILTER = exports.SET_QUEUE_LEVELS_FILTER = 'SET_REVIEW_QUEUE_LEVELS_FILTER';
var CLEAR_QUEUE_FILTERS = exports.CLEAR_QUEUE_FILTERS = 'CLEAR_QUEUE_FILTERS';
var SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS = exports.SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS = 'SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS';

function setAuthorsFilter(authorIds) {
  return {
    type: SET_QUEUE_AUTHORS_FILTER,
    payload: {
      authors_id_in: authorIds
    }
  };
}

function setKeywordFilter(keyword) {
  return {
    type: SET_QUEUE_KEYWORD_FILTER,
    payload: {
      name_or_description_cont: keyword
    }
  };
}

function setDraftFilter(val) {
  return {
    type: SET_QUEUE_DRAFT_FILTER,
    payload: {
      reviewing_compiled_quest_state_null: val
    }
  };
}

function setStatusFilter(statuses) {
  return {
    type: SET_QUEUE_STATUS_FILTER,
    payload: {
      reviewing_compiled_quest_state_in: statuses
    }
  };
}

function setCourseFilter(courseId) {
  return {
    type: SET_QUEUE_COURSE_FILTER,
    mock_course_id_in: courseId
  };
}

function setLevelFilter(levels) {
  return {
    type: SET_QUEUE_LEVELS_FILTER,
    mock_level_id_in: levels
  };
}

function clearQueueFilters() {
  return {
    type: CLEAR_QUEUE_FILTERS
  };
}

function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  };
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthorsFilter = setAuthorsFilter;
exports.setCourseFilter = setCourseFilter;
exports.setLevelFilter = setLevelFilter;
exports.clearProductionStatusFilters = clearProductionStatusFilters;
exports.setTagFilters = setTagFilters;
exports.setPrimarySubjectFilter = setPrimarySubjectFilter;
exports.setAssignedToFilters = setAssignedToFilters;
exports.setTargetGradeLevelFilter = setTargetGradeLevelFilter;
var SET_PRODUCTION_STATUS_AUTHORS_FILTER = exports.SET_PRODUCTION_STATUS_AUTHORS_FILTER = 'SET_PRODUCTION_STATUS_AUTHORS_FILTER';
var SET_PRODUCTION_STATUS_COURSE_FILTER = exports.SET_PRODUCTION_STATUS_COURSE_FILTER = 'SET_PRODUCTION_STATUS_COURSE_FILTER';
var SET_PRODUCTION_STATUS_LEVELS_FILTER = exports.SET_PRODUCTION_STATUS_LEVELS_FILTER = 'SET_PRODUCTION_STATUS_LEVELS_FILTER';
var SET_PRODUCTION_STATUS_TAG_FILTERS = exports.SET_PRODUCTION_STATUS_TAG_FILTERS = 'SET_PRODUCTION_STATUS_TAG_FILTERS';
var SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER = exports.SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER = 'SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER';
var SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS = exports.SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS = 'SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS';
var SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS = exports.SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS = 'SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS';
var CLEAR_PRODUCTION_STATUS_FILTERS = exports.CLEAR_PRODUCTION_STATUS_FILTERS = 'CLEAR_PRODUCTION_STATUS_FILTERS';

function setAuthorsFilter(authorIds) {
  return {
    type: SET_PRODUCTION_STATUS_AUTHORS_FILTER,
    authors_id_in: authorIds
  };
}

function setCourseFilter(courseId) {
  return {
    type: SET_PRODUCTION_STATUS_COURSE_FILTER,
    mock_course_id_in: courseId
  };
}

function setLevelFilter(levels) {
  return {
    type: SET_PRODUCTION_STATUS_LEVELS_FILTER,
    mock_level_id_in: levels
  };
}

function clearProductionStatusFilters() {
  return {
    type: CLEAR_PRODUCTION_STATUS_FILTERS
  };
}

function setTagFilters(tagIds) {
  return {
    type: SET_PRODUCTION_STATUS_TAG_FILTERS,
    questtags_id_in: tagIds
  };
}

function setPrimarySubjectFilter(subjects) {
  return {
    type: SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER,
    quest_subject_id_in: subjects
  };
}

function setAssignedToFilters(assignedToIds) {
  return {
    type: SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS,
    assigned_to_id_in: assignedToIds
  };
}

function setTargetGradeLevelFilter(gradeLevels) {
  return {
    type: SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS,
    grade_levels_id_in: gradeLevels
  };
}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(1025)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(399);
var hasOwn = __webpack_require__(1028);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1027);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTotalCounts = function getTotalCounts(counts) {
  var totalTotal = 0;
  var draftTotal = 0;
  var publishedTotal = 0;
  var qualityReviewTotal = 0;
  var rejectedTotal = 0;
  var copyEditTotal = 0;
  var internalReviewTotal = 0;

  counts.forEach(function (o) {
    totalTotal = totalTotal + o.total_count;
  });
  counts.forEach(function (o) {
    draftTotal = draftTotal + o.draft_count;
  });
  counts.forEach(function (o) {
    publishedTotal = publishedTotal + o.published_count;
  });
  counts.forEach(function (o) {
    qualityReviewTotal = qualityReviewTotal + o.quality_review_count;
  });
  counts.forEach(function (o) {
    copyEditTotal = copyEditTotal + o.copy_edit_count;
  });
  counts.forEach(function (o) {
    internalReviewTotal = internalReviewTotal + o.internal_review_count;
  });
  counts.forEach(function (o) {
    rejectedTotal = rejectedTotal + o.rejected_count;
  });

  return {
    totalTotal: totalTotal,
    draftTotal: draftTotal,
    publishedTotal: publishedTotal,
    qualityReviewTotal: qualityReviewTotal,
    rejectedTotal: rejectedTotal,
    copyEditTotal: copyEditTotal,
    internalReviewTotal: internalReviewTotal
  };
};

var getAttrCount = function getAttrCount(attr) {
  return function (acc, obj) {
    return acc + obj[attr];
  };
};

var getFilterQuery = function getFilterQuery(filterState) {
  var query = {};

  if (filterState.reviewing_compiled_quest_state_null) {
    query.reviewing_compiled_quest_state_null = filterState.reviewing_compiled_quest_state_null;
  }

  if (filterState.authors_id_in && filterState.authors_id_in.length > 0) {
    query.authors_id_in = filterState.authors_id_in;
  }

  if (filterState.questtags_id_in && filterState.questtags_id_in.length > 0) {
    query.questtags_id_in = filterState.questtags_id_in;
  }

  if (filterState.reviewing_compiled_quest_state_in && filterState.reviewing_compiled_quest_state_in.length > 0) {
    query.reviewing_compiled_quest_state_in = filterState.reviewing_compiled_quest_state_in;
  }

  if (filterState.name_or_description_cont && filterState.name_or_description_cont.trim() !== '') {
    query.name_or_description_cont = filterState.name_or_description_cont;
  }

  if (filterState.quest_subject_id_in && filterState.quest_subject_id_in.length > 0) {
    query.quest_subject_id_in = filterState.quest_subject_id_in;
  }

  if (filterState.assigned_to_id_in && filterState.assigned_to_id_in.length > 0) {
    query.assigned_to_id_in = filterState.assigned_to_id_in;
  }

  if (filterState.grade_levels_id_in && filterState.grade_levels_id_in.length > 0) {
    query.grade_levels_id_in = filterState.grade_levels_id_in;
  }

  if (filterState.state_in && filterState.state_in.length > 0) {
    query.state_in = filterState.state_in;
  }

  // storing object in redux, sending array of one id to BE
  if (filterState.mock_course_id_in) {
    query.mock_course_id_in = [filterState.mock_course_id_in.id];
  }

  if (filterState.mock_level_id_in && filterState.mock_level_id_in.length > 0) {
    query.mock_level_id_in = filterState.mock_level_id_in;
  }

  if (filterState.need_final_review) {
    query.need_final_review = filterState.need_final_review;
  }

  if (filterState.need_standards_review) {
    query.need_standards_review = filterState.need_standards_review;
  }

  return query;
};

var hasNoQuests = function hasNoQuests(states) {
  return states.every(function (state) {
    return state.total_count === 0;
  });
};

exports.getTotalCounts = getTotalCounts;
exports.getAttrCount = getAttrCount;
exports.getFilterQuery = getFilterQuery;
exports.hasNoQuests = hasNoQuests;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = undefined;

var _reactIntl = __webpack_require__(16);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  nameCantBeBlank: {
    'id': 'Alert.NameCantBeBlank',
    'defaultMessage': 'Name can\'t be blank.'
  },
  stronglyRecommendArtifact: {
    'id': 'Alert.StronglyRecommendArtifact',
    'defaultMessage': 'We strongly recommend an Artifact activity also be a Check-in to ensure Learners get good feedback.'
  },
  unusualMaterialsLimit: {
    'id': 'Alert.UnusualMaterialsLimit',
    'defaultMessage': 'Unusual Materials cannot exceed 1000 characters.'
  },
  questTitleTaken: {
    'id': 'Alert.QuestTitleTaken',
    'defaultMessage': 'Quest title has already been taken.'
  }
});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_QUESTS_FAILURE = exports.FETCH_QUESTS_SUCCESS = exports.FETCH_QUESTS_REQUEST = exports.CLEAR_QUESTS = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.clearQuests = clearQuests;
exports.fetchQuestsRequest = fetchQuestsRequest;
exports.fetchQuestsSuccess = fetchQuestsSuccess;
exports.fetchQuestsFailure = fetchQuestsFailure;
exports.fetchQuests = fetchQuests;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

var _quests = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_QUESTS = exports.CLEAR_QUESTS = 'CLEAR_QUESTS';
var FETCH_QUESTS_REQUEST = exports.FETCH_QUESTS_REQUEST = 'FETCH_QUESTS_REQUEST';
var FETCH_QUESTS_SUCCESS = exports.FETCH_QUESTS_SUCCESS = 'FETCH_QUESTS_SUCCESS';
var FETCH_QUESTS_FAILURE = exports.FETCH_QUESTS_FAILURE = 'FETCH_QUESTS_FAILURE';

function clearQuests() {
  return {
    type: CLEAR_QUESTS
  };
}

function fetchQuestsRequest() {
  return {
    type: FETCH_QUESTS_REQUEST
  };
}

function fetchQuestsSuccess(response) {
  return {
    type: FETCH_QUESTS_SUCCESS,
    quests: response.quests,
    page: response.meta.page,
    total: response.meta.total
  };
}

function fetchQuestsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_QUESTS_FAILURE, error);
}

function fetchQuests(page, clearQuestsInState) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, query, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              query = (0, _quests.getQuestFilterQuery)(state.questsfilters, state.organization.orgId, state.user.user);
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/search';


              if (clearQuestsInState) {
                dispatch(clearQuests());
              }

              dispatch(fetchQuestsRequest());

              _context.prev = 5;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 9;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  page: page,
                  q: query
                })
              });

            case 9:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              dispatch(fetchQuestsSuccess(json));
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t2 = _context['catch'](5);

              dispatch(fetchQuestsFailure(_context.t2));

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 17]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_QUESTS = exports.SET_SORT = exports.RECEIVE_USER_QUEUE_FAILURE = exports.RECEIVE_USER_QUEUE_SUCCESS = exports.RECEIVE_USER_QUEUE_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.receiveUserQueueRequest = receiveUserQueueRequest;
exports.receiveUserQueueSuccess = receiveUserQueueSuccess;
exports.receiveUserQueueFailure = receiveUserQueueFailure;
exports.setSort = setSort;
exports.clearQuests = clearQuests;
exports.fetchUserAssignments = fetchUserAssignments;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _quests = __webpack_require__(242);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEIVE_USER_QUEUE_REQUEST = exports.RECEIVE_USER_QUEUE_REQUEST = 'RECEIVE_USER_QUEUE_REQUEST';
var RECEIVE_USER_QUEUE_SUCCESS = exports.RECEIVE_USER_QUEUE_SUCCESS = 'RECEIVE_USER_QUEUE_SUCCESS';
var RECEIVE_USER_QUEUE_FAILURE = exports.RECEIVE_USER_QUEUE_FAILURE = 'RECEIVE_USER_QUEUE_FAILURE';
var SET_SORT = exports.SET_SORT = 'SET_SORT';
var CLEAR_QUESTS = exports.CLEAR_QUESTS = 'CLEAR_QUESTS';

function receiveUserQueueRequest() {
  return {
    type: RECEIVE_USER_QUEUE_REQUEST
  };
}

function receiveUserQueueSuccess(response) {
  return {
    type: RECEIVE_USER_QUEUE_SUCCESS,
    payload: {
      quests: response.quests,
      page: response.meta.page,
      total: response.meta.total
    }
  };
}

function receiveUserQueueFailure(error) {
  return (0, _actions.getErrorAction)(RECEIVE_USER_QUEUE_FAILURE, error);
}

function setSort(sort) {
  return {
    type: SET_SORT,
    payload: {
      sort: sort
    }
  };
}

function clearQuests() {
  return {
    type: CLEAR_QUESTS
  };
}

function fetchUserAssignments(page, clearQuestsInState) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, orgId, url, query, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              orgId = state.organization.orgId;
              url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/quests/search';


              if (clearQuestsInState) {
                dispatch(clearQuests());
              }

              query = (0, _quests.getQuestFilterQuery)(state.queuefilters, orgId, state.user.user);

              dispatch(receiveUserQueueRequest());

              _context.prev = 6;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 10;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  page: page,
                  q: query,
                  order: state.queue.sort
                })
              });

            case 10:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 14;
              return response.json();

            case 14:
              json = _context.sent;

              dispatch(receiveUserQueueSuccess(json));
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t2 = _context['catch'](6);

              dispatch(receiveUserQueueFailure(_context.t2));

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 18]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_REVIEW_QUEUE_QUESTS = exports.FETCH_REVIEW_QUEUE_COUNTS_SUCCESS = exports.FETCH_REVIEW_QUEUE_COUNTS_REQUEST = exports.FETCH_REVIEW_QUEUE_FAILURE = exports.FETCH_REVIEW_QUEUE_SUCCESS = exports.FETCH_REVIEW_QUEUE_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.fetchReviewQueueRequest = fetchReviewQueueRequest;
exports.fetchReviewQueueSuccess = fetchReviewQueueSuccess;
exports.fetchReviewQueueFailure = fetchReviewQueueFailure;
exports.fetchReviewQueueCountsRequest = fetchReviewQueueCountsRequest;
exports.fetchReviewQueueCountsSuccess = fetchReviewQueueCountsSuccess;
exports.clearQuests = clearQuests;
exports.fetchReviewQueue = fetchReviewQueue;
exports.fetchReviewQueueCounts = fetchReviewQueueCounts;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var _quests = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_REVIEW_QUEUE_REQUEST = exports.FETCH_REVIEW_QUEUE_REQUEST = 'FETCH_REVIEW_QUEUE_REQUEST';

var FETCH_REVIEW_QUEUE_SUCCESS = exports.FETCH_REVIEW_QUEUE_SUCCESS = 'FETCH_REVIEW_QUEUE_SUCCESS';
var FETCH_REVIEW_QUEUE_FAILURE = exports.FETCH_REVIEW_QUEUE_FAILURE = 'FETCH_REVIEW_QUEUE_FAILURE';
var FETCH_REVIEW_QUEUE_COUNTS_REQUEST = exports.FETCH_REVIEW_QUEUE_COUNTS_REQUEST = 'FETCH_REVIEW_QUEUE_COUNTS_REQUEST';
var FETCH_REVIEW_QUEUE_COUNTS_SUCCESS = exports.FETCH_REVIEW_QUEUE_COUNTS_SUCCESS = 'FETCH_REVIEW_QUEUE_COUNTS_SUCCESS';
var CLEAR_REVIEW_QUEUE_QUESTS = exports.CLEAR_REVIEW_QUEUE_QUESTS = 'CLEAR_REVIEW_QUEUE_QUESTS';

function fetchReviewQueueRequest() {
  return {
    type: FETCH_REVIEW_QUEUE_REQUEST
  };
}

function fetchReviewQueueSuccess(response) {
  return {
    type: FETCH_REVIEW_QUEUE_SUCCESS,
    quests: response.compiled_quests,
    meta: response.meta
  };
}

function fetchReviewQueueFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_REVIEW_QUEUE_FAILURE, error);
}

function fetchReviewQueueCountsRequest() {
  return {
    type: FETCH_REVIEW_QUEUE_COUNTS_REQUEST
  };
}

function fetchReviewQueueCountsSuccess(counts) {
  return {
    type: FETCH_REVIEW_QUEUE_COUNTS_SUCCESS,
    payload: {
      counts: counts
    }
  };
}

function clearQuests() {
  return {
    type: CLEAR_REVIEW_QUEUE_QUESTS
  };
}

function fetchReviewQueue(page, clearQuestsInState) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, orgId, query, url, sortOrder, waitTimeSortOrder, orderParam, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              orgId = state.organization.orgId;
              query = (0, _quests.getQuestFilterQuery)(state.reviewqueuefilters, orgId, state.user.user);
              // needed for author certifications

              query.include_quest_authors = true;

              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/compiled_quests/search';
              sortOrder = state.reviewqueuefilters.sort_order;
              // need to use the 'opposite' ordering for created_at since I'm showing the list in reverse order (by wait time, not recency)

              waitTimeSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
              orderParam = state.reviewqueuefilters.sort_type === 'created_at' ? ['created_at ' + waitTimeSortOrder, 'quest_priority ' + sortOrder] : ['quest_priority ' + sortOrder, 'created_at ' + waitTimeSortOrder];


              dispatch(fetchReviewQueueRequest());

              if (clearQuestsInState) {
                dispatch(clearQuests());
              }

              _context.prev = 10;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 14;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  page: page,
                  q: query,
                  order: orderParam
                })
              });

            case 14:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 18;
              return response.json();

            case 18:
              json = _context.sent;

              dispatch(fetchReviewQueueSuccess(json));
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t2 = _context['catch'](10);

              dispatch(fetchReviewQueueFailure(_context.t2));

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[10, 22]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchReviewQueueCounts() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/compiled_quests/analytics';
    return (0, _api.basicGet)(state, dispatch, url, fetchReviewQueueCountsRequest, fetchReviewQueueCountsSuccess);
  };
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__ = __webpack_require__(565);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OnlineManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onlineManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribable__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(60);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isServer */] && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(__WEBPACK_IMPORTED_MODULE_1__subscribable__["a" /* Subscribable */]);
var onlineManager = new OnlineManager();

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focusManager__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscribable__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__retryer__ = __webpack_require__(206);








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.previousSelectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return _shouldFetchOnReconnect(this.currentQuery, this.options);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return _shouldFetchOnWindowFocus(this.currentQuery, this.options);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(__WEBPACK_IMPORTED_MODULE_2__utils__["l" /* noop */]);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isServer */] || this.currentResult.isStale || !Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* isValidTimeout */])(this.options.staleTime)) {
      return;
    }

    var time = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["w" /* timeUntilStale */])(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* isServer */] || this.options.enabled === false || !Object(__WEBPACK_IMPORTED_MODULE_2__utils__["i" /* isValidTimeout */])(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || __WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        var _this$previousSelect;

        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === ((_this$previousSelect = this.previousSelect) == null ? void 0 : _this$previousSelect.fn) && !this.previousSelectError) {
          data = this.previousSelect.result;
        } else {
          try {
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* replaceEqualDeep */])(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.previousSelect = {
              fn: options.select,
              result: data
            };
            this.previousSelectError = null;
          } catch (selectError) {
            Object(__WEBPACK_IMPORTED_MODULE_6__logger__["a" /* getLogger */])().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["s" /* replaceEqualDeep */])(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.previousSelectError = null;
          } catch (selectError) {
            Object(__WEBPACK_IMPORTED_MODULE_6__logger__["a" /* getLogger */])().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["u" /* shallowEqualObjects */])(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !Object(__WEBPACK_IMPORTED_MODULE_7__retryer__["d" /* isCancelledError */])(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(__WEBPACK_IMPORTED_MODULE_5__subscribable__["a" /* Subscribable */]);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldRefetchOnMount(query, options) {
  return options.enabled !== false && query.state.dataUpdatedAt > 0 && (options.refetchOnMount === 'always' || options.refetchOnMount !== false && isStale(query, options));
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || shouldRefetchOnMount(query, options);
}

function _shouldFetchOnReconnect(query, options) {
  return options.enabled !== false && (options.refetchOnReconnect === 'always' || options.refetchOnReconnect !== false && isStale(query, options));
}

function _shouldFetchOnWindowFocus(query, options) {
  return options.enabled !== false && (options.refetchOnWindowFocus === 'always' || options.refetchOnWindowFocus !== false && isStale(query, options));
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _organization = __webpack_require__(578);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrgAvatar = function OrgAvatar(props) {
  return _react2.default.createElement(
    'div',
    { className: 'org-avatar' },
    props.organization.photo && _react2.default.createElement('img', { src: props.organization.photo }),
    !props.organization.photo && _react2.default.createElement(
      'div',
      { className: 'placeholder' },
      (0, _organization.getOrgInitials)(props.organization)
    )
  );
};

OrgAvatar.propTypes = {
  organization: _propTypes2.default.object.isRequired
};

exports.default = OrgAvatar;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.YouTube = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SDK_URL = 'https://www.youtube.com/iframe_api';
var SDK_GLOBAL = 'YT';
var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
var MATCH_URL = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/;
var MATCH_PLAYLIST = /list=([a-zA-Z0-9_-]+)/;

function parsePlaylist(url) {
  if (MATCH_PLAYLIST.test(url)) {
    var _url$match = url.match(MATCH_PLAYLIST),
        _url$match2 = _slicedToArray(_url$match, 2),
        playlistId = _url$match2[1];

    return {
      listType: 'playlist',
      list: playlistId
    };
  }

  return {};
}

var YouTube = /*#__PURE__*/function (_Component) {
  _inherits(YouTube, _Component);

  var _super = _createSuper(YouTube);

  function YouTube() {
    var _this;

    _classCallCheck(this, YouTube);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (_ref) {
      var data = _ref.data;
      var _this$props = _this.props,
          onPlay = _this$props.onPlay,
          onPause = _this$props.onPause,
          onBuffer = _this$props.onBuffer,
          onBufferEnd = _this$props.onBufferEnd,
          onEnded = _this$props.onEnded,
          onReady = _this$props.onReady,
          loop = _this$props.loop;
      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState,
          PLAYING = _window$SDK_GLOBAL$Pl.PLAYING,
          PAUSED = _window$SDK_GLOBAL$Pl.PAUSED,
          BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING,
          ENDED = _window$SDK_GLOBAL$Pl.ENDED,
          CUED = _window$SDK_GLOBAL$Pl.CUED;

      if (data === PLAYING) {
        onPlay();
        onBufferEnd();
      }

      if (data === PAUSED) onPause();
      if (data === BUFFERING) onBuffer();

      if (data === ENDED) {
        var isPlaylist = !!_this.callPlayer('getPlaylist');

        if (loop && !isPlaylist) {
          _this.play(); // Only loop manually if not playing a playlist

        }

        onEnded();
      }

      if (data === CUED) onReady();
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unMute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(YouTube, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props2 = this.props,
          playing = _this$props2.playing,
          muted = _this$props2.muted,
          playsinline = _this$props2.playsinline,
          controls = _this$props2.controls,
          loop = _this$props2.loop,
          config = _this$props2.config,
          _onError = _this$props2.onError;
      var _config$youtube = config.youtube,
          playerVars = _config$youtube.playerVars,
          embedOptions = _config$youtube.embedOptions;
      var id = url && url.match(MATCH_URL)[1];

      if (isReady) {
        if (MATCH_PLAYLIST.test(url)) {
          this.player.loadPlaylist(parsePlaylist(url));
          return;
        }

        this.player.cueVideoById({
          videoId: id,
          startSeconds: (0, _utils.parseStartTime)(url) || playerVars.start,
          endSeconds: (0, _utils.parseEndTime)(url) || playerVars.end
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (YT) {
        return YT.loaded;
      }).then(function (YT) {
        if (!_this2.container) return;
        _this2.player = new YT.Player(_this2.container, _objectSpread({
          width: '100%',
          height: '100%',
          videoId: id,
          playerVars: _objectSpread({
            autoplay: playing ? 1 : 0,
            mute: muted ? 1 : 0,
            controls: controls ? 1 : 0,
            start: (0, _utils.parseStartTime)(url),
            end: (0, _utils.parseEndTime)(url),
            origin: window.location.origin,
            playsinline: playsinline
          }, parsePlaylist(url), {}, playerVars),
          events: {
            onReady: function onReady() {
              if (loop) {
                _this2.player.setLoop(true); // Enable playlist looping

              }

              _this2.props.onReady();
            },
            onStateChange: _this2.onStateChange,
            onError: function onError(event) {
              return _onError(event.data);
            }
          }
        }, embedOptions));
      }, _onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('playVideo');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pauseVideo');
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!document.body.contains(this.callPlayer('getIframe'))) return;
      this.callPlayer('stopVideo');
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount) {
      this.callPlayer('seekTo', amount);

      if (!this.props.playing) {
        this.pause();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.callPlayer('getVideoLoadedFraction') * this.getDuration();
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return YouTube;
}(_react.Component);

exports.YouTube = YouTube;

_defineProperty(YouTube, "displayName", 'YouTube');

_defineProperty(YouTube, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(YouTube);

exports["default"] = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(308);

var _utils = __webpack_require__(91);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEEK_ON_PLAY_EXPIRY = 5000;

var Player = /*#__PURE__*/function (_Component) {
  _inherits(Player, _Component);

  var _super = _createSuper(Player);

  function Player() {
    var _this;

    _classCallCheck(this, Player);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "isReady", false);

    _defineProperty(_assertThisInitialized(_this), "isPlaying", false);

    _defineProperty(_assertThisInitialized(_this), "isLoading", true);

    _defineProperty(_assertThisInitialized(_this), "loadOnReady", null);

    _defineProperty(_assertThisInitialized(_this), "startOnPlay", true);

    _defineProperty(_assertThisInitialized(_this), "seekOnPlay", null);

    _defineProperty(_assertThisInitialized(_this), "onDurationCalled", false);

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function (key) {
      if (!_this.player) return null;
      return _this.player[key];
    });

    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.isReady) {
        var playedSeconds = _this.getCurrentTime() || 0;

        var loadedSeconds = _this.getSecondsLoaded();

        var duration = _this.getDuration();

        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: playedSeconds / duration
          };

          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          } // Only call onProgress if values have changed


          if (progress.playedSeconds !== _this.prevPlayed || progress.loadedSeconds !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }

          _this.prevPlayed = progress.playedSeconds;
          _this.prevLoaded = progress.loadedSeconds;
        }
      }

      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency || _this.props.progressInterval);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      if (!_this.mounted) return;
      _this.isReady = true;
      _this.isLoading = false;
      var _this$props = _this.props,
          onReady = _this$props.onReady,
          playing = _this$props.playing,
          volume = _this$props.volume,
          muted = _this$props.muted;
      onReady();

      if (!muted && volume !== null) {
        _this.player.setVolume(volume);
      }

      if (_this.loadOnReady) {
        _this.player.load(_this.loadOnReady, true);

        _this.loadOnReady = null;
      } else if (playing) {
        _this.player.play();
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      _this.isPlaying = true;
      _this.isLoading = false;
      var _this$props2 = _this.props,
          onStart = _this$props2.onStart,
          onPlay = _this$props2.onPlay,
          playbackRate = _this$props2.playbackRate;

      if (_this.startOnPlay) {
        if (_this.player.setPlaybackRate && playbackRate !== 1) {
          _this.player.setPlaybackRate(playbackRate);
        }

        onStart();
        _this.startOnPlay = false;
      }

      onPlay();

      if (_this.seekOnPlay) {
        _this.seekTo(_this.seekOnPlay);

        _this.seekOnPlay = null;
      }

      _this.handleDurationCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (e) {
      _this.isPlaying = false;

      if (!_this.isLoading) {
        _this.props.onPause(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      var _this$props3 = _this.props,
          activePlayer = _this$props3.activePlayer,
          loop = _this$props3.loop,
          onEnded = _this$props3.onEnded;

      if (activePlayer.loopOnEnded && loop) {
        _this.seekTo(0);
      }

      if (!loop) {
        _this.isPlaying = false;
        onEnded();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var _this$props4;

      _this.isLoading = false;

      (_this$props4 = _this.props).onError.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDurationCheck", function () {
      clearTimeout(_this.durationCheckTimeout);

      var duration = _this.getDuration();

      if (duration) {
        if (!_this.onDurationCalled) {
          _this.props.onDuration(duration);

          _this.onDurationCalled = true;
        }
      } else {
        _this.durationCheckTimeout = setTimeout(_this.handleDurationCheck, 100);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoaded", function () {
      // Sometimes we know loading has stopped but onReady/onPlay are never called
      // so this provides a way for players to avoid getting stuck
      _this.isLoading = false;
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (player) {
        _this.player = player;
      }
    });

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.player.load(this.props.url);
      this.progress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
      clearTimeout(this.durationCheckTimeout);

      if (this.isReady) {
        this.player.stop();
      }

      if (this.player.disablePIP) {
        this.player.disablePIP();
      }

      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // Invoke player methods based on changed props
      var _this$props5 = this.props,
          url = _this$props5.url,
          playing = _this$props5.playing,
          volume = _this$props5.volume,
          muted = _this$props5.muted,
          playbackRate = _this$props5.playbackRate,
          pip = _this$props5.pip,
          loop = _this$props5.loop,
          activePlayer = _this$props5.activePlayer;

      if (!(0, _utils.isEqual)(prevProps.url, url)) {
        if (this.isLoading && !activePlayer.forceLoad) {
          console.warn("ReactPlayer: the attempt to load ".concat(url, " is being deferred until the player has loaded"));
          this.loadOnReady = url;
          return;
        }

        this.isLoading = true;
        this.startOnPlay = true;
        this.onDurationCalled = false;
        this.player.load(url, this.isReady);
      }

      if (!prevProps.playing && playing && !this.isPlaying) {
        this.player.play();
      }

      if (prevProps.playing && !playing && this.isPlaying) {
        this.player.pause();
      }

      if (!prevProps.pip && pip && this.player.enablePIP) {
        this.player.enablePIP();
      }

      if (prevProps.pip && !pip && this.player.disablePIP) {
        this.player.disablePIP();
      }

      if (prevProps.volume !== volume && volume !== null) {
        this.player.setVolume(volume);
      }

      if (prevProps.muted !== muted) {
        if (muted) {
          this.player.mute();
        } else {
          this.player.unmute();

          if (volume !== null) {
            // Set volume next tick to fix a bug with DailyMotion
            setTimeout(function () {
              return _this2.player.setVolume(volume);
            });
          }
        }
      }

      if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) {
        this.player.setPlaybackRate(playbackRate);
      }

      if (prevProps.loop !== loop && this.player.setLoop) {
        this.player.setLoop(loop);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.isReady) return null;
      return this.player.getDuration();
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.isReady) return null;
      return this.player.getCurrentTime();
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.isReady) return null;
      return this.player.getSecondsLoaded();
    }
  }, {
    key: "seekTo",
    value: function seekTo(amount, type) {
      var _this3 = this;

      // When seeking before player is ready, store value and seek later
      if (!this.isReady && amount !== 0) {
        this.seekOnPlay = amount;
        setTimeout(function () {
          _this3.seekOnPlay = null;
        }, SEEK_ON_PLAY_EXPIRY);
        return;
      }

      var isFraction = !type ? amount > 0 && amount < 1 : type === 'fraction';

      if (isFraction) {
        // Convert fraction to seconds based on duration
        var duration = this.player.getDuration();

        if (!duration) {
          console.warn('ReactPlayer: could not seek using fraction – duration not yet available');
          return;
        }

        this.player.seekTo(duration * amount);
        return;
      }

      this.player.seekTo(amount);
    }
  }, {
    key: "render",
    value: function render() {
      var Player = this.props.activePlayer;

      if (!Player) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, this.props, {
        ref: this.ref,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      }));
    }
  }]);

  return Player;
}(_react.Component);

exports["default"] = Player;

_defineProperty(Player, "displayName", 'Player');

_defineProperty(Player, "propTypes", _props.propTypes);

_defineProperty(Player, "defaultProps", _props.defaultProps);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SoundCloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://w.soundcloud.com/player/api.js';
var SDK_GLOBAL = 'SC';
var MATCH_URL = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;

var SoundCloud = /*#__PURE__*/function (_Component) {
  _inherits(SoundCloud, _Component);

  var _super = _createSuper(SoundCloud);

  function SoundCloud() {
    var _this;

    _classCallCheck(this, SoundCloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "fractionLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(SoundCloud, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (SC) {
        if (!_this2.iframe) return;
        var _SC$Widget$Events = SC.Widget.Events,
            PLAY = _SC$Widget$Events.PLAY,
            PLAY_PROGRESS = _SC$Widget$Events.PLAY_PROGRESS,
            PAUSE = _SC$Widget$Events.PAUSE,
            FINISH = _SC$Widget$Events.FINISH,
            ERROR = _SC$Widget$Events.ERROR;

        if (!isReady) {
          _this2.player = SC.Widget(_this2.iframe);

          _this2.player.bind(PLAY, _this2.props.onPlay);

          _this2.player.bind(PAUSE, _this2.props.onPause);

          _this2.player.bind(PLAY_PROGRESS, function (e) {
            _this2.currentTime = e.currentPosition / 1000;
            _this2.fractionLoaded = e.loadedProgress;
          });

          _this2.player.bind(FINISH, function () {
            return _this2.props.onEnded();
          });

          _this2.player.bind(ERROR, function (e) {
            return _this2.props.onError(e);
          });
        }

        _this2.player.load(url, _objectSpread({}, _this2.props.config.soundcloud.options, {
          callback: function callback() {
            _this2.player.getDuration(function (duration) {
              _this2.duration = duration / 1000;

              _this2.props.onReady();
            });
          }
        }));
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seekTo', seconds * 1000);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.fractionLoaded * this.duration;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
        style: style,
        frameBorder: 0,
        allow: "autoplay"
      });
    }
  }]);

  return SoundCloud;
}(_react.Component);

exports.SoundCloud = SoundCloud;

_defineProperty(SoundCloud, "displayName", 'SoundCloud');

_defineProperty(SoundCloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(SoundCloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(SoundCloud);

exports["default"] = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Vimeo = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.vimeo.com/api/player.js';
var SDK_GLOBAL = 'Vimeo';
var MATCH_URL = /vimeo\.com\/.+/;
var MATCH_FILE_URL = /vimeo\.com\/external\/[0-9]+\..+/;

var Vimeo = /*#__PURE__*/function (_Component) {
  _inherits(Vimeo, _Component);

  var _super = _createSuper(Vimeo);

  function Vimeo() {
    var _this;

    _classCallCheck(this, Vimeo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.setVolume(0);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      if (_this.props.volume !== null) {
        _this.setVolume(_this.props.volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(Vimeo, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      this.duration = null;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Vimeo) {
        if (!_this2.container) return;
        _this2.player = new Vimeo.Player(_this2.container, _objectSpread({
          url: url,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          loop: _this2.props.loop,
          playsinline: _this2.props.playsinline,
          controls: _this2.props.controls
        }, _this2.props.config.vimeo.playerOptions));

        _this2.player.ready().then(function () {
          var iframe = _this2.container.querySelector('iframe');

          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })["catch"](_this2.props.onError);

        _this2.player.on('loaded', function () {
          _this2.props.onReady();

          _this2.refreshDuration();
        });

        _this2.player.on('play', function () {
          _this2.props.onPlay();

          _this2.refreshDuration();
        });

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', function (e) {
          return _this2.props.onSeek(e.seconds);
        });

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var seconds = _ref.seconds;
          _this2.currentTime = seconds;
        });

        _this2.player.on('progress', function (_ref2) {
          var seconds = _ref2.seconds;
          _this2.secondsLoaded = seconds;
        });
      }, this.props.onError);
    }
  }, {
    key: "refreshDuration",
    value: function refreshDuration() {
      var _this3 = this;

      this.player.getDuration().then(function (duration) {
        _this3.duration = duration;
      });
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.callPlayer('play');

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('unload');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('setPlaybackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: this.props.url,
        ref: this.ref,
        style: style
      });
    }
  }]);

  return Vimeo;
}(_react.Component);

exports.Vimeo = Vimeo;

_defineProperty(Vimeo, "displayName", 'Vimeo');

_defineProperty(Vimeo, "forceLoad", true);

_defineProperty(Vimeo, "canPlay", function (url) {
  if (MATCH_FILE_URL.test(url)) {
    return false;
  }

  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Vimeo);

exports["default"] = _default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DailyMotion = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://api.dmcdn.net/all.js';
var SDK_GLOBAL = 'DM';
var SDK_GLOBAL_READY = 'dmAsyncInit';
var MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;

var DailyMotion = /*#__PURE__*/function (_Component) {
  _inherits(DailyMotion, _Component);

  var _super = _createSuper(DailyMotion);

  function DailyMotion() {
    var _this;

    _classCallCheck(this, DailyMotion);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onDurationChange", function () {
      var duration = _this.getDuration();

      _this.props.onDuration(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (container) {
      _this.container = container;
    });

    return _this;
  }

  _createClass(DailyMotion, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props = this.props,
          controls = _this$props.controls,
          config = _this$props.config,
          onError = _this$props.onError,
          playing = _this$props.playing;

      var _url$match = url.match(MATCH_URL),
          _url$match2 = _slicedToArray(_url$match, 2),
          id = _url$match2[1];

      if (this.player) {
        this.player.load(id, {
          start: (0, _utils.parseStartTime)(url),
          autoplay: playing
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY, function (DM) {
        return DM.player;
      }).then(function (DM) {
        if (!_this2.container) return;
        var Player = DM.player;
        _this2.player = new Player(_this2.container, {
          width: '100%',
          height: '100%',
          video: id,
          params: _objectSpread({
            controls: controls,
            autoplay: _this2.props.playing,
            mute: _this2.props.muted,
            start: (0, _utils.parseStartTime)(url),
            origin: window.location.origin
          }, config.dailymotion.params),
          events: {
            apiready: _this2.props.onReady,
            seeked: function seeked() {
              return _this2.props.onSeek(_this2.player.currentTime);
            },
            video_end: _this2.props.onEnded,
            durationchange: _this2.onDurationChange,
            pause: _this2.props.onPause,
            playing: _this2.props.onPlay,
            waiting: _this2.props.onBuffer,
            error: function error(event) {
              return onError(event);
            }
          }
        });
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.player.duration || null;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.player.bufferedTime;
    }
  }, {
    key: "render",
    value: function render() {
      var display = this.props.display;
      var style = {
        width: '100%',
        height: '100%',
        display: display
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref
      }));
    }
  }]);

  return DailyMotion;
}(_react.Component);

exports.DailyMotion = DailyMotion;

_defineProperty(DailyMotion, "displayName", 'DailyMotion');

_defineProperty(DailyMotion, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(DailyMotion, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(DailyMotion);

exports["default"] = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1224);
} else {
  module.exports = require('./cjs/react-jsx-runtime.development.js');
}


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactErrorUtils = __webpack_require__(419);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(211);
var Danger = __webpack_require__(1263);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(115);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(425);
var setInnerHTML = __webpack_require__(318);
var setTextContent = __webpack_require__(613);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactPropTypesSecret = __webpack_require__(1279);
var propTypesFactory = __webpack_require__(603);

var React = __webpack_require__(207);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactCurrentOwner = __webpack_require__(144);
var ReactInstanceMap = __webpack_require__(254);
var ReactInstrumentation = __webpack_require__(115);
var ReactUpdates = __webpack_require__(130);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var emptyFunction = __webpack_require__(129);
var warning = __webpack_require__(40);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.isValidLink = isValidLink;
exports.isMissingLinkData = isMissingLinkData;
exports.isMissingFileData = isMissingFileData;
exports.isMissingCitation = isMissingCitation;
exports.isMissingContentWarnings = isMissingContentWarnings;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidLink(url) {
  return (/(http(s?))\:\/\//gi.test(url)
  );
}

function isMissingLinkData(resource) {
  return resource.format === 'url' && (!resource.url || !isValidLink(resource.url));
}

function isMissingFileData(resource) {
  return resource.format === 'file' && (isMissingCitation(resource) || !resource.attributionSelection || !resource.fileName);
}

function isMissingCitation(resource) {
  return resource.attributionSelection === 'outsideorg' && !resource.citation;
}

function isMissingContentWarnings(resource) {
  return resource.hasContentWarnings && (!resource.content_warnings || (0, _keys2.default)(resource.content_warnings).every(function (cw) {
    return resource.content_warnings[cw] === '' || !resource.content_warnings[cw] || resource.content_warnings[cw].length === 0;
  }));
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(1326);

var _entries2 = _interopRequireDefault(_entries);

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n   &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n'], ['\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n   &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _truncateMiddle = __webpack_require__(321);

var _truncateMiddle2 = _interopRequireDefault(_truncateMiddle);

var _FileUploadProgressBar = __webpack_require__(1329);

var _FileUploadProgressBar2 = _interopRequireDefault(_FileUploadProgressBar);

var _file = __webpack_require__(1330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'S3Uploader__FlexContainer',
  componentId: 'nnzbaa-0'
})(_templateObject);

var Label = _styledComponents2.default.label.withConfig({
  displayName: 'S3Uploader__Label',
  componentId: 'nnzbaa-1'
})(_templateObject2, _colors2.default.aluminum, _colors2.default.white, _colors2.default.black, _colors2.default.white, _colors2.default.charcoal2, _colors2.default.charcoal2);

var S3Uploader = function (_React$Component) {
  (0, _inherits3.default)(S3Uploader, _React$Component);

  function S3Uploader() {
    (0, _classCallCheck3.default)(this, S3Uploader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (S3Uploader.__proto__ || (0, _getPrototypeOf2.default)(S3Uploader)).call(this));

    _this.defaultState = {
      failure: null,
      isUploading: false,
      progress: 0,
      fileSizeExceeded: false,
      fileName: '',
      xhr: null
    };
    _this.state = (0, _assign2.default)({}, _this.defaultState);

    _this.onUpload = _this.onUpload.bind(_this);
    _this.updateProgress = _this.updateProgress.bind(_this);
    _this.abortRequest = _this.abortRequest.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(S3Uploader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resourceType = this.props.resourceType;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        !this.state.isUploading ? _react2.default.createElement(
          'div',
          null,
          this.props.isActivityCourse ? _react2.default.createElement(
            FlexContainer,
            null,
            _react2.default.createElement(
              Label,
              { htmlFor: 'file-input-s3' },
              'Choose File'
            ),
            _react2.default.createElement(
              'p',
              { style: { marginLeft: '10px' } },
              'No file chosen'
            ),
            _react2.default.createElement('input', {
              id: 'file-input-s3',
              type: 'file',
              onChange: this.onUpload,
              style: { display: 'none' }
            })
          ) : _react2.default.createElement('input', { type: 'file', onChange: this.onUpload }),
          _react2.default.createElement(
            'label',
            { className: 'hint-text' },
            resourceType === 'video' && 'Videos must be under 1 GB and a .3gp, .mp4, .mkv, or .webm file type.',
            resourceType !== 'video' && 'File size limit is 1 GB. ',
            this.state.fileSizeExceeded && _react2.default.createElement(
              'span',
              { className: 'error-text', style: { display: 'block' } },
              'File size limit is 1 GB.'
            ),
            this.state.failure && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'label',
                { className: 'error-text' },
                this.state.failure.type === 'expired' ? 'File upload session expired. Please refresh your browser and try again.' : 'File upload failed. Please try again.'
              )
            )
          )
        ) : _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { style: { marginBottom: '8px' } },
            (0, _truncateMiddle2.default)(this.state.fileName, 50, 50, '...')
          ),
          _react2.default.createElement(_FileUploadProgressBar2.default, { progress: this.state.progress }),
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between'
              }
            },
            _react2.default.createElement(
              'label',
              {
                style: {
                  marginTop: '7px'
                },
                className: 'hint-text'
              },
              'Please, keep this page open until upload is complete to save this resource.'
            ),
            _react2.default.createElement(
              'span',
              {
                onClick: function onClick() {
                  return _this2.abortRequest();
                },
                style: {
                  color: '#0070E0',
                  fontSize: '13px',
                  fontWeight: 500,
                  cursor: 'pointer'
                }
              },
              'Cancel'
            )
          )
        )
      );
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(event) {
      if (event.lengthComputable) {
        var progress = parseInt(event.loaded / event.total * 100);
        this.setState(function () {
          return {
            progress: progress
          };
        });
      }
    }
  }, {
    key: 'onUpload',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _this3 = this;

        var _props, presignedUrl, resourceId, uniqueFilename, file, objSon, url, fileName, startTime, self, xhr, fd, checksumPromise, uploadPromise;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, presignedUrl = _props.presignedUrl, resourceId = _props.resourceId, uniqueFilename = _props.uniqueFilename;
                file = e.target.files[0];
                objSon = presignedUrl;
                url = objSon.url;
                fileName = uniqueFilename + '.' + /[^.]+$/.exec(file.name)[0];
                startTime = performance.now();
                self = this;

                // validate file size. return and setState if too big

                if ((0, _file.validateFileSize)(e.target.files[0], (0, _file.gbInBytes)(1))) {
                  _context.next = 10;
                  break;
                }

                this.setState(function () {
                  return {
                    fileSizeExceeded: true
                  };
                });
                return _context.abrupt('return');

              case 10:

                objSon.url_fields.key = 'uploads/resource/resource_file/' + resourceId + '/' + fileName;
                xhr = new XMLHttpRequest();
                fd = new FormData();


                xhr.upload.addEventListener('progress', this.updateProgress, false);

                checksumPromise = (0, _file.getMD5Checksum)(file);
                uploadPromise = new _promise2.default(function (resolve) {
                  return _this3.setState(function () {
                    return {
                      isUploading: true,
                      failure: null,
                      fileName: file.name,
                      fileSizeExceeded: false,
                      xhr: xhr
                    };
                  }, resolve);
                })
                // send analytics data/callback to parent
                .then(function () {
                  return _this3.props.uploadStartHandler({
                    name: file.name,
                    size: file.size
                  });
                }).then(function () {
                  return new _promise2.default(function (resolve, reject) {
                    xhr.open('POST', url, true);

                    (0, _entries2.default)(objSon.url_fields).forEach(function (_ref2) {
                      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
                          key = _ref3[0],
                          value = _ref3[1];

                      fd.append(key, value);
                    });
                    fd.append('Content-Type', file.type);
                    fd.append('file', file);

                    xhr.onload = function () {
                      if (xhr.status === 201) {
                        var endTime = performance.now();
                        var elapsedTime = Math.floor((endTime - startTime) / 1000);
                        resolve(elapsedTime);
                      } else if (xhr.status === 403) {
                        reject('expired');
                      } else {
                        reject('generic');
                      }
                    };

                    xhr.onerror = function () {
                      return reject('generic');
                    };

                    xhr.send(fd);
                    xhr.file = file;
                    xhr.fileName = fileName;
                  });
                });


                _promise2.default.all([checksumPromise, uploadPromise]).then(function (values) {
                  var _values = (0, _slicedToArray3.default)(values, 2),
                      checksum = _values[0],
                      elapsedTime = _values[1];

                  _this3.props.uploadCompleteHandler({
                    file: {
                      name: xhr.file.name,
                      size: file.size
                    },
                    elapsedTime: elapsedTime
                  });
                  return _this3.props.patchFileUploadInfo({
                    name: xhr.fileName,
                    size: xhr.file.size,
                    type: xhr.file.type,
                    original_file_name: xhr.file.name,
                    file_checksum: checksum
                  });
                }).then(function () {
                  return new _promise2.default(function (resolve) {
                    return _this3.setState(function () {
                      return (0, _assign2.default)({}, _this3.defaultState);
                    }, resolve);
                  });
                }).catch(function (err) {
                  return new _promise2.default(function (resolve) {
                    return _this3.setState(function () {
                      return (0, _assign2.default)({}, _this3.defaultState, {
                        failure: { type: err === 'expired' ? err : 'generic' }
                      });
                    }, resolve);
                  });
                }).then(function () {
                  return _this3.props.uploadEndHandler();
                });

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onUpload(_x) {
        return _ref.apply(this, arguments);
      }

      return onUpload;
    }()
  }, {
    key: 'abortRequest',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(source) {
        var _this4 = this;

        var file, confirmation;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file = this.state.xhr.file;

                if (!source) {
                  _context2.next = 8;
                  break;
                }

                this.props.uploadAbortHandler({
                  file: {
                    name: file.name,
                    size: file.size
                  },
                  source: source
                });
                _context2.next = 5;
                return this.state.xhr.abort();

              case 5:
                this.setState(function () {
                  return (0, _assign2.default)({}, _this4.defaultState);
                });
                _context2.next = 14;
                break;

              case 8:
                confirmation = window.confirm('Are you sure you want to cancel this upload?');

                if (!confirmation) {
                  _context2.next = 14;
                  break;
                }

                this.props.uploadAbortHandler({
                  file: {
                    name: file.name,
                    size: file.size
                  },
                  source: 'bar cancel'
                });
                _context2.next = 13;
                return this.state.xhr.abort();

              case 13:
                this.setState(function () {
                  return (0, _assign2.default)({}, _this4.defaultState);
                });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function abortRequest(_x2) {
        return _ref4.apply(this, arguments);
      }

      return abortRequest;
    }()
  }]);
  return S3Uploader;
}(_react2.default.Component);

S3Uploader.propTypes = {
  presignedUrl: _propTypes2.default.object.isRequired,
  patchFileUploadInfo: _propTypes2.default.func.isRequired,
  resourceType: _propTypes2.default.string.isRequired,
  resourceId: _propTypes2.default.number.isRequired,
  uploadStartHandler: _propTypes2.default.func.isRequired,
  uploadEndHandler: _propTypes2.default.func.isRequired,
  uploadAbortHandler: _propTypes2.default.func.isRequired,
  uploadCompleteHandler: _propTypes2.default.func.isRequired,
  uniqueFilename: _propTypes2.default.string.isRequired,
  isActivityCourse: _propTypes2.default.bool.isRequired
};

exports.default = S3Uploader;

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js
var createBreakpoints = __webpack_require__(642);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(esm_extends["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return Object(esm_extends["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(defineProperty["a" /* default */])({}, breakpoints.up('sm'), Object(esm_extends["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(defineProperty["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(defineProperty["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = __webpack_require__(634);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = __webpack_require__(641);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = __webpack_require__(637);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = __webpack_require__(636);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(635);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = __webpack_require__(640);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(638);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(639);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(65);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common["a" /* default */].white,
    default: grey["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: common["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(colorManipulator["i" /* lighten */])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(colorManipulator["a" /* darken */])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo["a" /* default */][300],
    main: indigo["a" /* default */][500],
    dark: indigo["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink["a" /* default */].A200,
    main: pink["a" /* default */].A400,
    dark: pink["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red["a" /* default */][300],
    main: red["a" /* default */][500],
    dark: red["a" /* default */][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange["a" /* default */][300],
    main: orange["a" /* default */][500],
    dark: orange["a" /* default */][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue["a" /* default */][300],
    main: blue["a" /* default */][500],
    dark: blue["a" /* default */][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green["a" /* default */][300],
    main: green["a" /* default */][500],
    dark: green["a" /* default */][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(objectWithoutProperties["a" /* default */])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(colorManipulator["e" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(esm_extends["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(esm["b" /* formatMuiErrorMessage */])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(esm["b" /* formatMuiErrorMessage */])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(esm["a" /* deepmerge */])(Object(esm_extends["a" /* default */])({
    // A collection of common colors.
    common: common["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTypography.js




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(objectWithoutProperties["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(esm_extends["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(esm["a" /* deepmerge */])(Object(esm_extends["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/index.js + 17 modules
var system_esm = __webpack_require__(643);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(system_esm["c" /* createUnarySpacing */])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(131);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(648);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMuiTheme.js













function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(objectWithoutProperties["a" /* default */])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = Object(createBreakpoints["a" /* default */])(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = Object(esm["a" /* deepmerge */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: styles_shape,
    transitions: transitions["a" /* default */],
    zIndex: zIndex["a" /* default */]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(esm["a" /* deepmerge */])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

/* harmony default export */ var styles_createMuiTheme = __webpack_exports__["a"] = (createMuiTheme);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(644);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(27);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(212);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(79);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(188);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(257);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(326);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
var requirePropFactory = __webpack_require__(649);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(189);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
var unsupportedProp = __webpack_require__(327);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(164);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(147);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(328);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(258);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return createChainedFunction["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createSvgIcon", function() { return createSvgIcon["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "deprecatedPropType", function() { return deprecatedPropType; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMuiElement", function() { return isMuiElement["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ownerDocument", function() { return ownerDocument["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ownerWindow", function() { return ownerWindow["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "requirePropFactory", function() { return requirePropFactory["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setRef", function() { return setRef["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unsupportedProp", function() { return unsupportedProp["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useControlled", function() { return useControlled["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useEventCallback", function() { return useEventCallback["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useForkRef", function() { return useForkRef["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unstable_useId", function() { return unstable_useId["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useIsFocusVisible", function() { return useIsFocusVisible["a" /* default */]; });













 // eslint-disable-next-line camelcase




/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/Unstable_TrapFocus.js
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = react["useRef"]();
  var sentinelStart = react["useRef"](null);
  var sentinelEnd = react["useRef"](null);
  var nodeToRestore = react["useRef"]();
  var rootRef = react["useRef"](null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    rootRef.current = react_dom["findDOMNode"](instance);
  }, []);
  var handleRef = Object(useForkRef["a" /* default */])(children.ref, handleOwnRef);
  var prevOpenRef = react["useRef"]();
  react["useEffect"](function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  react["useEffect"](function () {
    if (!open) {
      return;
    }

    var doc = Object(ownerDocument["a" /* default */])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/react["cloneElement"](children, {
    ref: handleRef
  }), /*#__PURE__*/react["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.node,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, focus will be locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;

if (false) {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

/* harmony default export */ var Unstable_TrapFocus_Unstable_TrapFocus = (Unstable_TrapFocus);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return Unstable_TrapFocus_Unstable_TrapFocus; });


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(261);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/List/List.js







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List_List = /*#__PURE__*/react["forwardRef"](function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = react["useMemo"](function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/react["createElement"](ListContext["a" /* default */].Provider, {
    value: context
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List_List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
/* harmony default export */ var esm_List_List = (Object(withStyles["a" /* default */])(styles, {
  name: 'MuiList'
})(List_List));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/List/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_List_List; });


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/index.js + 3 modules
var ButtonBase = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var utils_isMuiElement = __webpack_require__(257);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(261);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? react["useEffect"] : react["useLayoutEffect"];
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem_ListItem = /*#__PURE__*/react["forwardRef"](function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(objectWithoutProperties["a" /* default */])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = react["useContext"](ListContext["a" /* default */]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = react["useRef"](null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = react["Children"].toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(utils_isMuiElement["a" /* default */])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    listItemRef.current = react_dom["findDOMNode"](instance);
  }, []);
  var handleRef = Object(useForkRef["a" /* default */])(handleOwnRef, ref);

  var componentProps = Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(clsx_m["a" /* default */])(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase["a" /* default */];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/react["createElement"](ListContext["a" /* default */].Provider, {
      value: childContext
    }, /*#__PURE__*/react["createElement"](ContainerComponent, Object(esm_extends["a" /* default */])({
      className: Object(clsx_m["a" /* default */])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/react["createElement"](Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/react["createElement"](ListContext["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem_ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_ListItem_ListItem = (Object(withStyles["a" /* default */])(styles, {
  name: 'MuiListItem'
})(ListItem_ListItem));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItem/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_ListItem_ListItem; });


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(188);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(326);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(212);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/index.js + 3 modules
var Modal = __webpack_require__(259);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/index.js + 1 modules
var Grow = __webpack_require__(260);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/index.js + 1 modules
var Paper = __webpack_require__(102);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover_Popover = /*#__PURE__*/react["forwardRef"](function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = react["useRef"](); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = react["useCallback"](function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Object(ownerDocument["a" /* default */])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = react["useCallback"](function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = react["useCallback"](function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = react["useCallback"](function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(ownerWindow["a" /* default */])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = react["useCallback"](function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    paperRef.current = react_dom["findDOMNode"](instance);
  }, []);
  react["useEffect"](function () {
    if (open) {
      setPositioningStyles();
    }
  });
  react["useImperativeHandle"](action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  react["useEffect"](function () {
    if (!open) {
      return undefined;
    }

    var handleResize = Object(debounce["a" /* default */])(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(ownerDocument["a" /* default */])(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/react["createElement"](Modal["b" /* default */], Object(esm_extends["a" /* default */])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(clsx_m["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(createChainedFunction["a" /* default */])(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(clsx_m["a" /* default */])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover_Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Popover_Popover = (Object(withStyles["a" /* default */])(styles, {
  name: 'MuiPopover'
})(Popover_Popover));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Popover/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_Popover_Popover; });


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(100);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/index.js + 1 modules
var List = __webpack_require__(442);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/getScrollbarSize.js
var getScrollbarSize = __webpack_require__(650);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuList/MenuList.js











function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? react["useEffect"] : react["useLayoutEffect"];
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList_MenuList = /*#__PURE__*/react["forwardRef"](function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = react["useRef"](null);
  var textCriteriaRef = react["useRef"]({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  react["useImperativeHandle"](actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(getScrollbarSize["a" /* default */])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Object(ownerDocument["a" /* default */])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    listRef.current = react_dom["findDOMNode"](instance);
  }, []);
  var handleRef = Object(useForkRef["a" /* default */])(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  react["Children"].forEach(children, function (child, index) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = react["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/react["cloneElement"](child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/react["createElement"](List["a" /* default */], Object(esm_extends["a" /* default */])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList_MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ var esm_MenuList_MenuList = (MenuList_MenuList);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MenuList/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_MenuList_MenuList; });


/***/ }),
/* 446 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 0;\n  color: #dc143c;\n  font-size: 11px;\n  position: relative;\n'], ['\n  height: 0;\n  color: #dc143c;\n  font-size: 11px;\n  position: relative;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineErrorMessage = _styledComponents2.default.div.withConfig({
  displayName: 'InlineErrorMessage',
  componentId: 'sc-7pye8-0'
})(_templateObject);

exports.default = InlineErrorMessage;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: contain;\n  position: absolute;\n  right: 9px;\n  bottom: 14px;\n  height: 14px;\n  width: 18px;\n  cursor: pointer;\n\n  &:hover {\n    background: url(', ')\n      no-repeat;\n  }\n'], ['\n  background: url(', ') no-repeat;\n  background-size: contain;\n  position: absolute;\n  right: 9px;\n  bottom: 14px;\n  height: 14px;\n  width: 18px;\n  cursor: pointer;\n\n  &:hover {\n    background: url(', ')\n      no-repeat;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _TextField = __webpack_require__(449);

var _TextField2 = _interopRequireDefault(_TextField);

var _icon_hidden = __webpack_require__(1363);

var _icon_hidden2 = _interopRequireDefault(_icon_hidden);

var _icon_hidden_hover = __webpack_require__(1364);

var _icon_hidden_hover2 = _interopRequireDefault(_icon_hidden_hover);

var _icon_shown = __webpack_require__(1365);

var _icon_shown2 = _interopRequireDefault(_icon_shown);

var _icon_shown_hover = __webpack_require__(1366);

var _icon_shown_hover2 = _interopRequireDefault(_icon_shown_hover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HideShowPasswordIcon = _styledComponents2.default.div.withConfig({
  displayName: 'PasswordField__HideShowPasswordIcon',
  componentId: 'sc-1sypdrc-0'
})(_templateObject, function (props) {
  return !props.showPassword ? _icon_shown2.default : _icon_hidden2.default;
}, function (props) {
  return !props.showPassword ? _icon_shown_hover2.default : _icon_hidden_hover2.default;
});

var PasswordField = function (_Component) {
  (0, _inherits3.default)(PasswordField, _Component);

  function PasswordField() {
    (0, _classCallCheck3.default)(this, PasswordField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordField.__proto__ || (0, _getPrototypeOf2.default)(PasswordField)).call(this));

    _this.state = {
      showPassword: false
    };
    _this.onShowHidePasswordClick = _this.onShowHidePasswordClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PasswordField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' } },
        _react2.default.createElement(_reactTooltip2.default, {
          className: 'tooltip',
          id: this.props.tooltipId,
          effect: 'solid',
          getContent: [function () {
            return _this2.state.showPassword ? 'Click to hide password.' : 'Click to show password.';
          }]
        }),
        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, this.props, {
          style: this.props.style,
          type: this.state.showPassword ? 'text' : 'password'
        })),
        this.state.showPassword ? _react2.default.createElement(HideShowPasswordIcon, {
          showPassword: this.state.showPassword,
          onClick: this.onShowHidePasswordClick,
          'data-for': this.props.tooltipId,
          'data-tip': 'Click to hide password.'
        }) : _react2.default.createElement(HideShowPasswordIcon, {
          showPassword: this.state.showPassword,
          onClick: this.onShowHidePasswordClick,
          'data-for': this.props.tooltipId,
          'data-tip': 'Click to show password.'
        })
      );
    }
  }, {
    key: 'onShowHidePasswordClick',
    value: function onShowHidePasswordClick(e) {
      e.preventDefault();
      this.setState(function (state) {
        return {
          showPassword: !state.showPassword
        };
      });
    }
  }]);
  return PasswordField;
}(_react.Component);

exports.default = PasswordField;


PasswordField.propTypes = {
  tooltipId: _propTypes2.default.string,
  style: _propTypes2.default.object,
  placeholder: _propTypes2.default.string
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: block;\n  height: 42px;\n  width: 100%;\n  padding: 0 10px;\n  margin-bottom: 25px;\n  border: 0.5px solid #bbbbbb;\n  border-radius: 5px;\n  box-sizing: border-box;\n\n  &::placeholder {\n    font-weight: 300;\n    color: #999999;\n  }\n'], ['\n  display: block;\n  height: 42px;\n  width: 100%;\n  padding: 0 10px;\n  margin-bottom: 25px;\n  border: 0.5px solid #bbbbbb;\n  border-radius: 5px;\n  box-sizing: border-box;\n\n  &::placeholder {\n    font-weight: 300;\n    color: #999999;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-size: 11px;\n'], ['\n  color: #666666;\n  font-size: 11px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledInput = _styledComponents2.default.input.withConfig({
  displayName: 'TextField__StyledInput',
  componentId: 'rfxkrl-0'
})(_templateObject);

var StyledLabel = _styledComponents2.default.label.withConfig({
  displayName: 'TextField__StyledLabel',
  componentId: 'rfxkrl-1'
})(_templateObject2);

var TextField = function TextField(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      StyledLabel,
      null,
      props.label
    ),
    _react2.default.createElement(StyledInput, {
      placeholder: props.placeholder,
      type: props.type,
      value: props.value,
      onChange: props.onChange,
      style: props.style,
      defaultValue: props.defaultValue
    })
  );
};

TextField.propTypes = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  type: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  style: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string
};

exports.default = TextField;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestListItem = __webpack_require__(451);

var _QuestListItem2 = _interopRequireDefault(_QuestListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quests = function (_Component) {
  (0, _inherits3.default)(Quests, _Component);

  function Quests() {
    (0, _classCallCheck3.default)(this, Quests);
    return (0, _possibleConstructorReturn3.default)(this, (Quests.__proto__ || (0, _getPrototypeOf2.default)(Quests)).apply(this, arguments));
  }

  (0, _createClass3.default)(Quests, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          user = _props.user;

      var quests = this.props.quests.map(function (quest, index) {
        return _react2.default.createElement(_QuestListItem2.default, {
          quest: quest,
          key: index,
          dispatch: dispatch,
          user: user,
          navToSection: _this2.props.navToSection,
          iconHeightWidth: _this2.props.iconHeightWidth
        });
      });

      return _react2.default.createElement(
        'ul',
        null,
        quests
      );
    }
  }]);
  return Quests;
}(_react.Component);

exports.default = Quests;


Quests.propTypes = {
  quests: _propTypes2.default.array,
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object.isRequired,
  navToSection: _propTypes2.default.string,
  iconHeightWidth: _propTypes2.default.number.isRequired
};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _reactTextTruncate = __webpack_require__(332);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _oeWebCommon = __webpack_require__(117);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _IntendedCourseLevel = __webpack_require__(665);

var _IntendedCourseLevel2 = _interopRequireDefault(_IntendedCourseLevel);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _QuestStatus = __webpack_require__(453);

var _QuestStatus2 = _interopRequireDefault(_QuestStatus);

var _QuestListItemAssignment = __webpack_require__(1449);

var _QuestListItemAssignment2 = _interopRequireDefault(_QuestListItemAssignment);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _PriorityIndicator = __webpack_require__(454);

var _PriorityIndicator2 = _interopRequireDefault(_PriorityIndicator);

var _quest = __webpack_require__(66);

var _assignment = __webpack_require__(138);

var _name = __webpack_require__(149);

var _review = __webpack_require__(64);

var _quest2 = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestListItem = function (_Component) {
  (0, _inherits3.default)(QuestListItem, _Component);

  function QuestListItem(props) {
    (0, _classCallCheck3.default)(this, QuestListItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestListItem.__proto__ || (0, _getPrototypeOf2.default)(QuestListItem)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          clickHandler = _props.clickHandler,
          user = _props.user;

      var reviewStatus = (0, _review.getReviewStatus)(quest);

      // some places tags are a string, others they are an array
      // gotcha - sometimes tags are null, especially when in review queue
      var tags = quest.tags && (0, _typeof3.default)(quest.tags) === 'object' ? quest.tags.join(', ') : quest.tags;

      return _react2.default.createElement(
        'li',
        {
          className: 'quest-list-item',
          onClick: clickHandler || this.onClickBound
        },
        _react2.default.createElement(
          'div',
          { className: 'quest-list-item-quest-data' },
          _react2.default.createElement(_reactTooltip2.default, {
            id: 'tagsTooltip',
            effect: 'solid',
            offset: { bottom: 10 }
          }),
          _react2.default.createElement(_reactTooltip2.default, {
            id: 'subjectTooltip',
            effect: 'solid',
            offset: { bottom: 10 }
          }),
          _react2.default.createElement(_reactTooltip2.default, {
            id: 'targetGradeLevelTooltip',
            effect: 'solid',
            offset: { bottom: 10 }
          }),
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(_QuestIcon2.default, {
              heightWidth: this.props.iconHeightWidth,
              icon_image_url: quest.icon_image_url,
              showTypeIcon: quest.type && Boolean(quest.type.id),
              questTypeId: quest.type ? quest.type.id : null,
              questTypeIconSize: 28
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'middle' },
            quest.mock_course && _react2.default.createElement(_IntendedCourseLevel2.default, { quest: quest }),
            _react2.default.createElement(
              'div',
              { className: 'h1 name' },
              _react2.default.createElement(_reactTextTruncate2.default, { line: 2, truncateText: '...', text: quest.name })
            ),
            _react2.default.createElement(
              'div',
              { className: 'p1 authors' },
              (0, _quest2.getAuthors)({
                authors: quest.authors,
                questId: quest.id
              })
            ),
            quest.description && quest.description.length > 0 && _react2.default.createElement(_MarkdownLabel2.default, {
              id: 'view-description',
              value: quest.description,
              additionalCssClasses: 'description'
            }),
            quest.driving_question && quest.driving_question.length > 0 && _react2.default.createElement(
              'div',
              { className: 'p2 driving-question' },
              _react2.default.createElement(_MarkdownLabel2.default, { value: quest.driving_question })
            ),
            _react2.default.createElement(
              'div',
              { className: 'caption1 metadata' },
              _react2.default.createElement(
                'div',
                { className: 'primary-subject-tags-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'primary-subject-wrapper' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'icon-wrapper',
                      'data-for': 'subjectTooltip',
                      'data-tip': 'Primary Subject'
                    },
                    _react2.default.createElement('div', { className: 'primary-subject' })
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    quest.subject && quest.subject.name ? quest.subject.name : _react2.default.createElement(_NotYetSpecified2.default, { hideCircleIcon: true, textClass: 'caption1' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'tags-wrapper' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'icon-wrapper',
                      'data-for': 'tagsTooltip',
                      'data-tip': 'Tags'
                    },
                    _react2.default.createElement('div', { className: 'tags' })
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    tags && tags.length > 0 ? tags : _react2.default.createElement(_NotYetSpecified2.default, { hideCircleIcon: true, textClass: 'caption1' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'target-grade-level-wrapper' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'icon-wrapper',
                    'data-for': 'targetGradeLevelTooltip',
                    'data-tip': 'Target Grade'
                  },
                  _react2.default.createElement('div', { className: 'target-grade-level' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  quest.grade_levels && quest.grade_levels.length > 0 ? this.formatGradeLevels() : _react2.default.createElement(_NotYetSpecified2.default, { hideCircleIcon: true, textClass: 'caption1' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(_QuestStatus2.default, { status: reviewStatus }),
              quest.priority !== 'normal' && _react2.default.createElement(
                'div',
                {
                  style: {
                    marginLeft: '15px',
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                    marginTop: '3px'
                  }
                },
                _react2.default.createElement(_PriorityIndicator2.default, {
                  priority: quest.priority,
                  questId: quest.id
                })
              )
            ),
            _react2.default.createElement(
              _Caption2.default,
              {
                style: {
                  color: '#000000',
                  marginTop: '8px'
                }
              },
              'ID: ' + quest.id + '\xA0\xA0Version: ' + quest.current_version
            ),
            _react2.default.createElement(
              'div',
              { className: 'last-saved-by-container' },
              (0, _review.questIsPublished)(quest) ? _react2.default.createElement(
                'div',
                { className: 'caption1 published-date' },
                _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
                  date: quest.reviewing_compiled_quest.published_at,
                  includeTime: false
                })
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'caption1 last-saved' },
                  'Last saved ',
                  _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
                    date: quest.updated_at,
                    includeTime: false
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'caption1 updated-by' },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 1,
                    truncateText: '...',
                    text: 'by ' + (quest.last_updated_by ? (0, _name.getUserDisplayName)(quest.last_updated_by) : 'Unknown')
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'caption1 current-version',
              style: {
                position: 'absolute',
                right: '0',
                bottom: '0',
                padding: 'inherit'
              }
            },
            'v' + quest.current_version
          )
        ),
        quest.assigned_to && !(0, _review.questIsPublished)(quest) && _react2.default.createElement(_QuestListItemAssignment2.default, {
          assignedTo: quest.assigned_to,
          assignedBy: quest.assigned_by,
          message: quest.assignment_message,
          updatedAt: quest.assignment_updated_at,
          clickHandler: this.onQuestClickBound,
          questIsAssignedToUser: (0, _assignment.questIsAssignedToUser)(quest, user),
          questIsAssignedByUser: (0, _assignment.questIsAssignedByUser)(quest, user),
          assignmentType: quest.assignment_type
        })
      );
    }
  }, {
    key: 'formatGradeLevels',
    value: function formatGradeLevels() {
      return _react2.default.createElement(
        'span',
        null,
        this.props.quest.grade_levels.map(function (gradeLevel) {
          return gradeLevel.name;
        }).join(', ')
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest,
          isCompiledQuest = _props2.isCompiledQuest,
          navToSection = _props2.navToSection;

      var section = navToSection ? navToSection : 'basicinformation';
      dispatch((0, _quest.setQuestSection)(section));
      dispatch((0, _reactRouterRedux.push)('/quest/' + (!isCompiledQuest ? quest.id : quest.quest_id) + '/' + section));
    }
  }]);
  return QuestListItem;
}(_react.Component);

exports.default = QuestListItem;


QuestListItem.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  isCompiledQuest: _propTypes2.default.bool,
  clickHandler: _propTypes2.default.func,
  user: _propTypes2.default.object,
  navToSection: _propTypes2.default.string,
  iconHeightWidth: _propTypes2.default.number.isRequired
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Inline parser state



function StateInline(src, parserInline, options, env, outTokens) {
  this.src = src;
  this.env = env;
  this.options = options;
  this.parser = parserInline;
  this.tokens = outTokens;
  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  this.cache = [];        // Stores { start: end } pairs. Useful for backtrack
                          // optimization of pairs parse (emphasis, strikes).

  // Link parser state vars

  this.isInLabel = false; // Set true when seek link label - we should disable
                          // "paired" rules (emphasis, strikes) to not skip
                          // tailing `]`

  this.linkLevel = 0;     // Increment for each nesting link. Used to prevent
                          // nesting in definitions

  this.linkContent = '';  // Temporary storage for link url

  this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
                                 // (backtrack optimization)
}

// Flush pending text
//
StateInline.prototype.pushPending = function () {
  this.tokens.push({
    type: 'text',
    content: this.pending,
    level: this.pendingLevel
  });
  this.pending = '';
};

// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (token) {
  if (this.pending) {
    this.pushPending();
  }

  this.tokens.push(token);
  this.pendingLevel = this.level;
};

// Store value to cache.
// !!! Implementation has parser-specific optimizations
// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
//
StateInline.prototype.cacheSet = function (key, val) {
  for (var i = this.cache.length; i <= key; i++) {
    this.cache.push(0);
  }

  this.cache[key] = val;
};

// Get cache value
//
StateInline.prototype.cacheGet = function (key) {
  return key < this.cache.length ? this.cache[key] : 0;
};

module.exports = StateInline;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _review = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestStatus = function QuestStatus(props) {
  return _react2.default.createElement(
    'div',
    { className: 'quest-status ' + props.status },
    _react2.default.createElement(
      'div',
      { className: 'quest-status-text ' + props.status },
      (0, _review.getFriendlyStatus)(props.status)
    )
  );
};

QuestStatus.propTypes = {
  status: _propTypes2.default.string.isRequired
};

exports.default = QuestStatus;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: ', '\n    no-repeat;\n  width: ', ';\n  height: ', ';\n  background-size: 100%;\n'], ['\n  background: ', '\n    no-repeat;\n  width: ', ';\n  height: ', ';\n  background-size: 100%;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _highPriority = __webpack_require__(1450);

var _highPriority2 = _interopRequireDefault(_highPriority);

var _mediumPriority = __webpack_require__(1451);

var _mediumPriority2 = _interopRequireDefault(_mediumPriority);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = _styledComponents2.default.div.withConfig({
  displayName: 'PriorityIndicator__Icon',
  componentId: 'sc-1mfxoru-0'
})(_templateObject, function (props) {
  return props.priority === 'high' ? 'url(' + _highPriority2.default + ')' : 'url(' + _mediumPriority2.default + ')';
}, function (props) {
  return props.small ? '8px' : '11px';
}, function (props) {
  return props.small ? '14px' : '19px';
});

var PriorityIndicator = function PriorityIndicator(props) {
  var tooltipId = 'quest-' + props.questId + '-priority';
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_reactTooltip2.default, { id: tooltipId, effect: 'solid' }),
    _react2.default.createElement(Icon, {
      small: props.small,
      priority: props.priority,
      'data-tip': (props.priority === 'high' ? 'High' : 'Medium') + ' Priority',
      'data-for': tooltipId
    })
  );
};

PriorityIndicator.propTypes = {
  priority: _propTypes2.default.string.isRequired,
  questId: _propTypes2.default.number.isRequired,
  small: _propTypes2.default.bool
};

exports.default = PriorityIndicator;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeywordSearch = function KeywordSearch(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'caption1 search-caption' },
      'Search'
    ),
    _react2.default.createElement(
      'div',
      { className: 'area keyword-wrapper' },
      props.keywordFilter.length === 0 && _react2.default.createElement(_reactTooltip2.default, { id: 'keywordFilterTooltip' }),
      _react2.default.createElement('input', {
        ref: props.keywordSearchRef,
        'data-for': 'keywordFilterTooltip',
        'data-tip': 'Search in Title and Description',
        type: 'text',
        id: 'searchInput',
        value: props.keywordFilter,
        onKeyPress: props.onKeywordKeyPress,
        onChange: props.onKeywordFilterChange,
        placeholder: 'Search with keywords'
      }),
      props.keywordSearched && _react2.default.createElement('span', {
        className: 'clear-keyword-search-icon',
        onClick: props.onClearKeywordSearchClick
      }),
      _react2.default.createElement('span', {
        className: 'search-icon ' + (props.keywordFilter.length > 0 ? 'active' : ''),
        onClick: props.onKeywordSearchClick
      })
    )
  );
};

KeywordSearch.propTypes = {
  keywordFilter: _propTypes2.default.string.isRequired,
  keywordSearchRef: _propTypes2.default.object,
  onKeywordKeyPress: _propTypes2.default.func.isRequired,
  onKeywordFilterChange: _propTypes2.default.func.isRequired,
  keywordSearched: _propTypes2.default.bool.isRequired,
  onClearKeywordSearchClick: _propTypes2.default.func.isRequired,
  onKeywordSearchClick: _propTypes2.default.func.isRequired
};

exports.default = KeywordSearch;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestsSearchResultsCount = function (_Component) {
  (0, _inherits3.default)(QuestsSearchResultsCount, _Component);

  function QuestsSearchResultsCount() {
    (0, _classCallCheck3.default)(this, QuestsSearchResultsCount);
    return (0, _possibleConstructorReturn3.default)(this, (QuestsSearchResultsCount.__proto__ || (0, _getPrototypeOf2.default)(QuestsSearchResultsCount)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestsSearchResultsCount, [{
    key: 'render',
    value: function render() {
      var totalQuests = this.props.totalQuests;


      return _react2.default.createElement(
        'div',
        { className: 'quests-search-results-count' },
        _react2.default.createElement(
          'div',
          { className: 'results-found' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Quests.QuestsFound',
            defaultMessage: '{totalQuests} {quests} {match} {yourSearch}.',
            values: {
              totalQuests: totalQuests,
              quests: _react2.default.createElement(_reactIntl.FormattedPlural, {
                value: totalQuests,
                one: _messages.quest,
                other: _messages.quests
              }),
              match: _react2.default.createElement(_reactIntl.FormattedPlural, {
                value: totalQuests,
                one: _messages.matches,
                other: _messages.match
              }),
              yourSearch: _messages.yourSearch
            }
          })
        )
      );
    }
  }]);
  return QuestsSearchResultsCount;
}(_react.Component);

exports.default = QuestsSearchResultsCount;


QuestsSearchResultsCount.propTypes = {
  totalQuests: _propTypes2.default.number.isRequired
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesignANewQuest = function DesignANewQuest(props) {
  return _react2.default.createElement(
    'div',
    { className: 'design-a-new-quest', onClick: props.addQuest },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'Quests.DesignANewQuest',
      defaultMessage: 'Design a New Quest'
    }),
    _react2.default.createElement(
      'div',
      { id: 'addQuestIconContainer' },
      _react2.default.createElement(
        'span',
        { id: 'addQuestIcon' },
        '+'
      )
    )
  );
};

DesignANewQuest.propTypes = {
  addQuest: _propTypes2.default.func.isRequired
};

exports.default = DesignANewQuest;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoQuestsMatchYourSearch = function NoQuestsMatchYourSearch(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'no-quests-match-container' },
    _react2.default.createElement('div', { className: 'no-quests-icon' }),
    _react2.default.createElement(
      'div',
      { className: 'no-quests-text' },
      text
    )
  );
};

NoQuestsMatchYourSearch.propTypes = {
  text: _propTypes2.default.string.isRequired
};

exports.default = NoQuestsMatchYourSearch;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContentWarningIcon = __webpack_require__(340);

var _ContentWarningIcon2 = _interopRequireDefault(_ContentWarningIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWarningsEditor = function ContentWarningsEditor(_ref) {
  var contentWarnings = _ref.contentWarnings,
      handleContentWarningClick = _ref.handleContentWarningClick;
  return _react2.default.createElement(
    'div',
    { className: 'content-warnings-container-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'content-warnings-container' },
      _react2.default.createElement(
        'div',
        { className: 'content-warning-row' },
        _react2.default.createElement(
          'div',
          { className: 'content-warning-type' },
          'Graphic Content'
        ),
        _react2.default.createElement('input', {
          id: 'graphicContent',
          type: 'checkbox',
          checked: contentWarnings && contentWarnings.graphic_content && contentWarnings.graphic_content !== null && contentWarnings.graphic_content.value === 'graphic_content',
          value: 'graphic_content',
          name: 'graphic_content',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'graphicContent' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'GC' }),
          'Graphic Content'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'content-warning-row' },
        _react2.default.createElement(
          'div',
          { className: 'content-warning-type' },
          'Language'
        ),
        _react2.default.createElement('input', {
          id: 'languageModerate',
          type: 'radio',
          checked: contentWarnings && contentWarnings.language && contentWarnings.language !== null && contentWarnings.language.value === 'moderate',
          value: 'moderate',
          name: 'language',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'languageModerate' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'L' }),
          'Moderate'
        ),
        _react2.default.createElement('input', {
          id: 'languageExplicit',
          type: 'radio',
          checked: contentWarnings && contentWarnings.language && contentWarnings.language !== null && contentWarnings.language.value === 'explicit',
          value: 'explicit',
          name: 'language',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'languageExplicit' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'xL' }),
          'Explicit'
        ),
        _react2.default.createElement('input', {
          id: 'languageNone',
          type: 'radio',
          checked: contentWarnings && contentWarnings.language === null,
          value: '',
          name: 'language',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'languageNone' },
          'None'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'content-warning-row' },
        _react2.default.createElement(
          'div',
          { className: 'content-warning-type' },
          'Violence'
        ),
        _react2.default.createElement('input', {
          id: 'violenceModerate',
          type: 'radio',
          checked: contentWarnings && contentWarnings.violence && contentWarnings.violence !== null && contentWarnings.violence.value === 'moderate',
          value: 'moderate',
          name: 'violence',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'violenceModerate' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'V' }),
          'Moderate'
        ),
        _react2.default.createElement('input', {
          id: 'violenceExplicit',
          type: 'radio',
          checked: contentWarnings && contentWarnings.violence && contentWarnings.violence !== null && contentWarnings.violence.value === 'explicit',
          value: 'explicit',
          name: 'violence',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'violenceExplicit' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'xV' }),
          'Explicit'
        ),
        _react2.default.createElement('input', {
          id: 'violenceNone',
          type: 'radio',
          checked: contentWarnings && contentWarnings.violence === null,
          value: '',
          name: 'violence',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'violenceNone' },
          'None'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'content-warning-row' },
        _react2.default.createElement(
          'div',
          { className: 'content-warning-type' },
          'Sexual Themes'
        ),
        _react2.default.createElement('input', {
          id: 'sexual_themesModerate',
          type: 'radio',
          checked: contentWarnings && contentWarnings.sexual_themes && contentWarnings.sexual_themes !== null && contentWarnings.sexual_themes.value === 'moderate',
          value: 'moderate',
          name: 'sexual_themes',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'sexual_themesModerate' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'S' }),
          'Moderate'
        ),
        _react2.default.createElement('input', {
          id: 'sexual_themesExplicit',
          type: 'radio',
          checked: contentWarnings && contentWarnings.sexual_themes && contentWarnings.sexual_themes !== null && contentWarnings.sexual_themes.value === 'explicit',
          value: 'explicit',
          name: 'sexual_themes',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'sexual_themesExplicit' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'xS' }),
          'Explicit'
        ),
        _react2.default.createElement('input', {
          id: 'sexual_themesNone',
          type: 'radio',
          checked: contentWarnings && contentWarnings.sexual_themes === null,
          value: '',
          name: 'sexual_themes',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'sexual_themesNone' },
          'None'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'content-warning-row' },
        _react2.default.createElement(
          'div',
          { className: 'content-warning-type' },
          'Risky Behavior'
        ),
        _react2.default.createElement('input', {
          id: 'smoking',
          type: 'checkbox',
          checked: contentWarnings && contentWarnings.risky_behaviors && contentWarnings.risky_behaviors.some(function (e) {
            return e.value === 'smoking';
          }),
          value: 'smoking',
          name: 'risky_behaviors',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'smoking' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'Sm' }),
          'Smoking'
        ),
        _react2.default.createElement('input', {
          id: 'drugUse',
          type: 'checkbox',
          checked: contentWarnings && contentWarnings.risky_behaviors && contentWarnings.risky_behaviors.some(function (e) {
            return e.value === 'drug_use';
          }),
          value: 'drug_use',
          name: 'risky_behaviors',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'drugUse' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'D' }),
          'Drug Use'
        ),
        _react2.default.createElement('input', {
          id: 'alcohol',
          type: 'checkbox',
          checked: contentWarnings && contentWarnings.risky_behaviors && contentWarnings.risky_behaviors.some(function (e) {
            return e.value === 'alcohol';
          }),
          value: 'alcohol',
          name: 'risky_behaviors',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'alcohol' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'A' }),
          'Alcohol'
        ),
        _react2.default.createElement('input', {
          id: 'other',
          type: 'checkbox',
          checked: contentWarnings && contentWarnings.risky_behaviors && contentWarnings.risky_behaviors.some(function (e) {
            return e.value === 'other';
          }),
          value: 'other',
          name: 'risky_behaviors',
          onClick: handleContentWarningClick
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'other' },
          _react2.default.createElement(_ContentWarningIcon2.default, { abbrev: 'O' }),
          'Other'
        )
      )
    )
  );
};

ContentWarningsEditor.propTypes = {
  contentWarnings: _propTypes2.default.object,
  handleContentWarningClick: _propTypes2.default.func.isRequired
};

exports.default = ContentWarningsEditor;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

exports.parseErrors = parseErrors;
exports.hasExpectedError = hasExpectedError;
exports.getErrorCount = getErrorCount;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseErrors(error) {
  return JSON.parse(error).errors;
}

function hasExpectedError(error, field, msg) {
  return (0, _keys2.default)(error).includes(field) && error[field].includes(msg);
}

function getErrorCount(error) {
  if (error) {
    return (0, _keys2.default)(error).length;
  }
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortActivitityEditAttributes = exports.eventExpandable = exports.isActivitiesSort = exports.shouldHideHistoryEvent = exports.getLabelIcon = exports.translateSectionToReadable = exports.getHistoryEventText = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: black;\n'], ['\n  color: black;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _truncateMiddle = __webpack_require__(321);

var _truncateMiddle2 = _interopRequireDefault(_truncateMiddle);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(160);

var _Caption4 = _interopRequireDefault(_Caption3);

var _comments = __webpack_require__(685);

var _string = __webpack_require__(124);

var _Styled = __webpack_require__(342);

var _activity = __webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventName = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'questhistory__EventName',
  componentId: 'sc-8vj19s-0'
})(_templateObject);

var FlexWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'questhistory__FlexWrapper',
  componentId: 'sc-8vj19s-1'
})(_templateObject2);

var getHistoryEventText = function getHistoryEventText(event) {
  var retVal = null;
  switch (event.action) {
    case 'resource':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.EditIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Activity ',
            event.metadata.activity.number
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0Resource\xA0'
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            (0, _truncateMiddle2.default)('\xA0"' + event.metadata.resource.name + '"\xA0', 20, 20, '...')
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0' + getActivityEventElements(event.metadata).text + '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.editor.name,
              len: 45
            })
          )
        );
        break;
      }
    case 'activity_note':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.EditIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Activity ',
            event.metadata.activity.number
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0Mentor File\xA0'
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            (0, _truncateMiddle2.default)('\xA0"' + event.metadata.note.file_name + '"\xA0', 20, 20, '...')
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0' + getActivityEventElements(event.metadata).text + '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.editor.name,
              len: 45
            })
          )
        );
        break;
      }
    case 'activity':
      {
        isActivitiesSort(event.metadata) ? retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.ActivitiesSortedIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Activities sorted by\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.editor.name,
              len: 45
            })
          )
        ) : retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            getActivityEventElements(event.metadata).icon
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Activity ',
            event.metadata.activity.number
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0' + getActivityEventElements(event.metadata).text + '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.editor.name,
              len: 45
            })
          )
        );
        break;
      }
    case 'edit':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.EditIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            translateSectionToReadable(event.metadata.section)
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0edited by\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.editor.name,
              len: 45
            })
          )
        );
        break;
      }

    case 'unassignment':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.UnassignedIcon, null)
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.unassigned_by.name,
              len: 36
            })
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0unassigned this quest to\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.assigned_to.name,
              len: 36
            })
          )
        );
        break;
      }

    case 'assignment':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.AssignedIcon, null)
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.assigned_by.name,
              len: 36
            })
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0assigned this quest to\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.assigned_to.name,
              len: 36
            })
          )
        );
        break;
      }

    case 'internal_review':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            event.metadata.approved ? _react2.default.createElement(_Styled.InternalApprovedIcon, null) : _react2.default.createElement(_Styled.InternalRemovedIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Internal Review [' + (0, _string.capitalizeWord)(event.metadata.criteria) + ']'
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0' + (event.metadata.approved ? 'approved by' : 'approval removed by') + '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.reviewer.name,
              len: 45
            })
          )
        );
        break;
      }

    case 'platform_review':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            event.metadata.approved ? _react2.default.createElement(_Styled.QualityApprovedIcon, null) : _react2.default.createElement(_Styled.QualityRejectedIcon, null)
          ),
          event.comment ? _react2.default.createElement(
            'div',
            { style: { marginRight: '8px' } },
            _react2.default.createElement(_Styled.ReviewCommentIcon, null)
          ) : null,
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Publication Review [' + (0, _string.capitalizeWord)(event.metadata.criteria) + ']'
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0' + (event.metadata.approved ? 'approved by' : 'not approved by') + '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.reviewer.name,
              len: 45
            })
          )
        );
        break;
      }

    case 'state_change':
      {
        var labelIcon = getLabelIcon(event.metadata.to_state);
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            'div',
            { style: { marginRight: '19px' } },
            labelIcon
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            'Quest state changed by',
            '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.user.name,
              len: 45
            })
          )
        );
        break;
      }

    case 'creation':
      {
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            _react2.default.createElement(_Styled.CreateQuestIcon, null)
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            'Quest created by',
            '\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.author.name,
              len: 45
            })
          )
        );
        break;
      }

    case 'comment':
      {
        var action = '';
        if (event.metadata.new_post) {
          action = 'posted';
        } else if (event.metadata.deleted) {
          action = 'deleted';
        } else {
          action = 'edited';
        }
        retVal = _react2.default.createElement(
          FlexWrapper,
          null,
          _react2.default.createElement(
            _Styled.IconWrapper,
            null,
            event.metadata.new_post ? _react2.default.createElement(_Styled.CommentPostedIcon, null) : _react2.default.createElement(_Styled.CommentEditedIcon, null)
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            (0, _comments.getFriendlyCommentSectionLabel)(event.metadata)
          ),
          _react2.default.createElement(
            _Caption2.default,
            null,
            '\xA0comment ' + action + ' by\xA0'
          ),
          _react2.default.createElement(
            EventName,
            null,
            (0, _string.getTruncatedString)({
              val: event.metadata.user.name,
              len: 45
            })
          )
        );
        break;
      }
  }

  return retVal;
};

var translateSectionToReadable = function translateSectionToReadable(section) {
  var retVal = '';
  switch (section) {
    case 'basic_info':
      {
        retVal = 'Basic Information';
        break;
      }
    case 'other_information':
      {
        retVal = 'Other Information';
        break;
      }
    case 'images':
      {
        retVal = 'Images';
        break;
      }
    case 'topics_and_standards':
      {
        retVal = 'Topics & Standards';
        break;
      }
    case 'activities':
      {
        retVal = 'Activities';
        break;
      }
    case 'questhistory':
      {
        retVal = 'Quest History';
        break;
      }
    case 'quest_skills':
      {
        retVal = 'Quest Skills';
        break;
      }
    default:
      {
        retVal = 'Unknown';
      }
  }
  return retVal;
};

var getLabelIcon = function getLabelIcon(reviewStatus) {
  var retVal = null;
  switch (reviewStatus) {
    case 'submitted':
      retVal = _react2.default.createElement(_Styled.InQualityReviewLabelIcon, null);
      break;
    case 'draft':
      retVal = _react2.default.createElement(_Styled.DraftLabelIcon, null);
      break;
    case 'platform_review':
      retVal = _react2.default.createElement(_Styled.InQualityReviewLabelIcon, null);
      break;
    case 'published':
      retVal = _react2.default.createElement(_Styled.PublishedLabelIcon, null);
      break;
    case 'rejected':
      retVal = _react2.default.createElement(_Styled.ReviewReturnedLabelIcon, null);
      break;
    case 'recalled':
      retVal = _react2.default.createElement(_Styled.DraftLabelIcon, null);
      break;
  }
  return retVal;
};

var shouldHideHistoryEvent = function shouldHideHistoryEvent(event) {
  return !getHistoryEventText(event) || event.action === 'state_change' && event.metadata.to_state === 'platform_review';
};

var getActivityEventElements = function getActivityEventElements(data) {
  var text = '';
  var icon = null;
  switch (data.action) {
    case 'create':
      {
        text = data.note || data.resource ? 'added by' : 'created by';
        icon = _react2.default.createElement(_Styled.ActivityAddIcon, null);
        break;
      }
    case 'update':
      {
        text = 'edited by';
        icon = _react2.default.createElement(_Styled.EditIcon, null);
        break;
      }
    case 'destroy':
      {
        text = 'deleted by';
        icon = _react2.default.createElement(_Styled.DeleteIcon, null);
      }
  }
  return { text: text, icon: icon };
};

var isActivitiesSort = function isActivitiesSort(data) {
  return data.action === 'update' && data.changed_attributes.includes('activity_order');
};

var eventExpandable = function eventExpandable(event) {
  var retVal = null;
  // is platform review with a comment to see
  if (event.action === 'platform_review' && Boolean(event.comment)) {
    retVal = {
      type: 'review',
      text: 'Review'
    };
  } else if (event.action === 'activity' && event.metadata.action === 'update' && !isActivitiesSort(event.metadata)) {
    retVal = {
      type: 'activity',
      text: 'Details'
    };
  }
  return retVal;
};

var sortActivitityEditAttributes = function sortActivitityEditAttributes(attributes) {
  return attributes.sort(function (a, b) {
    return _activity.activityEditFields[a].index - _activity.activityEditFields[b].index;
  });
};

exports.getHistoryEventText = getHistoryEventText;
exports.translateSectionToReadable = translateSectionToReadable;
exports.getLabelIcon = getLabelIcon;
exports.shouldHideHistoryEvent = shouldHideHistoryEvent;
exports.isActivitiesSort = isActivitiesSort;
exports.eventExpandable = eventExpandable;
exports.sortActivitityEditAttributes = sortActivitityEditAttributes;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonMessages = exports.bodyMessages = exports.headingMessages = undefined;

var _reactIntl = __webpack_require__(16);

var headingMessages = (0, _reactIntl.defineMessages)({
  wait: {
    'id': 'Modal.Heading.Wait',
    'defaultMessage': 'Wait! You\'re about to lose some work.'
  },
  cancelReview: {
    'id': 'Modal.Heading.CancelReview',
    'defaultMessage': 'Cancel your review?'
  },
  almostDone: {
    'id': 'Modal.Heading.AlmostDone',
    'defaultMessage': 'Almost Done!'
  },
  returningToQuestDesigner: {
    'id': 'Modal.Heading.ReturningToQuestDesigner',
    'defaultMessage': 'Returning to Quest Designer'
  },
  readyForPublish: {
    'id': 'Modal.Heading.ReadyForPublish',
    'defaultMessage': 'Ready for Publishing'
  },
  reviewInProgress: {
    'id': 'Modal.Heading.ReviewInProgress',
    'defaultMessage': 'Review in Progress'
  },
  thisQuestIsPublished: {
    'id': 'Modal.Heading.ThisQuestIsPublished',
    'defaultMessage': 'This quest is published'
  }
});

var bodyMessages = (0, _reactIntl.defineMessages)({
  youreLeaving: {
    'id': 'Modal.Body.YoureLeaving',
    'defaultMessage': 'You\'re leaving an area that you were editing. Are you sure you want to leave? If so, your unsaved work will be lost.'
  },
  questOneStepCloser: {
    'id': 'Modal.Body.questOneStepCloser',
    'defaultMessage': 'Thanks! Your quest is one step closer to eager learners. It will now be reviewed by members of your organization for experience, subject, and copy.'
  },
  ifYouCancel: {
    'id': 'Modal.Body.IfYouCancel',
    'defaultMessage': 'If you cancel now, your review will be deleted, so another reviewer can have a fresh start. However, any comments you left throughout the quest will remain. Are you sure you want to cancel?'
  },
  thanksForYourReviewOE: {
    'id': 'Modal.Body.ThanksForYourReviewOE',
    'defaultMessage': 'Thanks for your review! This quest will now return to the Publication Review queue so it can move into the final phase of review.'
  },
  internalReviewsDone: {
    'id': 'Modal.Body.InternalReviewsDone',
    'defaultMessage': 'Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.'
  },
  questNeedsEdits: {
    'id': 'Modal.Body.QuestNeedsEdits',
    'defaultMessage': 'Thanks for your review! This quest needs edits, so it will be returned to the quest designer now.'
  },
  passedAllReviews1: {
    'id': 'Modal.Body.PassedAllReviews1',
    'defaultMessage': 'This quest has passed all the necessary reviews. Tap'
  },
  passedAllReviews2: {
    'id': 'Modal.Body.PassedAllReviews2',
    'defaultMessage': 'Publish'
  },
  passedAllReviews3: {
    'id': 'Modal.Body.PassedAllReviews3',
    'defaultMessage': 'below to make it available to learners and mentors in Quest!.'
  },
  ifYouStop1: {
    'id': 'Modal.Body.IfYouStop1',
    'defaultMessage': 'If you stop this review, this quest will be revoked from the reviewer and returned to the'
  },
  ifYouStop2: {
    'id': 'Modal.Body.IfYouStop2',
    'defaultMessage': 'Draft'
  },
  ifYouStop3: {
    'id': 'Modal.Body.IfYouStop3',
    'defaultMessage': 'state. When it\'s submitted for review again, you will have to start the review process from the beginning.'
  },
  toEditThisQuest: {
    'id': 'Modal.Body.ToEditThisQuest',
    'defaultMessage': 'To edit this quest, a new draft version of the quest will be created for you to work on. The published version of the quest will remain in use by students and mentors. (If you need to remove the published version from circulation, please contact the Quest Forward team at,'
  }
});

var buttonMessages = (0, _reactIntl.defineMessages)({
  leaveAnyway: {
    'id': 'Modal.Button.LeaveAnyway',
    'defaultMessage': 'Leave anyway'
  },
  cancel: {
    'id': 'Modal.Button.Cancel',
    'defaultMessage': 'Cancel'
  },
  ok: {
    'id': 'Modal.Button.OK',
    'defaultMessage': 'OK'
  },
  yes: {
    'id': 'Modal.Button.Yes',
    'defaultMessage': 'Yes'
  },
  no: {
    'id': 'Modal.Button.No',
    'defaultMessage': 'No'
  },
  publish: {
    'id': 'Modal.Button.Publish',
    'defaultMessage': 'Publish'
  }
});

exports.headingMessages = headingMessages;
exports.bodyMessages = bodyMessages;
exports.buttonMessages = buttonMessages;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxOCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTUgMTgiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiMwMDcwRTA7fTwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTTEyIDNoM2MwLTEuMS0uOS0yLTItMmgtMi4zMzNsLS4zNy0uNTU1Yy0uMTg2LS4yNzgtLjQ5OC0uNDQ1LS44MzItLjQ0NWgtMy45M2MtLjMzNCAwLS42NDcuMTY3LS44MzIuNDQ1bC0uMzcuNTU1aC0yLjMzM2MtMS4xIDAtMiAuOS0yIDJoMTJ6TTEgMTV2MWMwIDEuMS45IDIgMiAyaDljMS4xIDAgMi0uOSAyLTJ2LTEyaC0xM3YxMXptMS0xMGgxMXYxMWMwIC41NTItLjQ0OCAxLTEgMWgtOWMtLjU1MiAwLTEtLjQ0OC0xLTF2LTExek0xMCA3LjVjMC0uMjc1LjIyNS0uNS41LS41cy41LjIyNS41LjV2N2MwIC4yNzUtLjIyNS41LS41LjVzLS41LS4yMjUtLjUtLjV2LTd6TTcgNy41YzAtLjI3NS4yMjUtLjUuNS0uNXMuNS4yMjUuNS41djdjMCAuMjc1LS4yMjUuNS0uNS41cy0uNS0uMjI1LS41LS41di03ek00IDcuNWMwLS4yNzUuMjI1LS41LjUtLjVzLjUuMjI1LjUuNXY3YzAgLjI3NS0uMjI1LjUtLjUuNXMtLjUtLjIyNS0uNS0uNXYtN3oiLz48L3N2Zz4="

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var descriptions = exports.descriptions = {
  average_learner_rating: 'Star Ratings',
  average_learner_effort: 'Effort Ratings',
  percent_quests_recommended: 'Recommendations',
  quests_in_progress_by_learners_count: 'Active Quests',
  quests_completed_by_learners_count: 'Completed Quests'
};

var tooltipText = exports.tooltipText = {
  average_learner_rating: 'Average student rating of your quests (1-5)',
  average_learner_effort: 'Average student effort rating of your quests (1-3)',
  percent_quests_recommended: '% of students that recommend your quests',
  quests_in_progress_by_learners_count: 'Students working on your quests right now',
  quests_completed_by_learners_count: 'Your quests completed by students'
};

var hasCompletedQuests = exports.hasCompletedQuests = function hasCompletedQuests(stats) {
  // handles userstats for MyQuests and learnerstats for Quest Detail
  return Boolean(stats.quests_completed_by_learners_count) || Boolean(stats.quests_completed_count);
};

var formatQuestCountDisplay = exports.formatQuestCountDisplay = function formatQuestCountDisplay(value) {
  var retVal = value.toString();

  if (retVal > 9999 && retVal < 1000000) {
    retVal = Math.floor(retVal / 1000).toFixed(0).toString() + 'k';
  } else if (retVal >= 1000000 && retVal < 99999999) {
    retVal = parseFloat((retVal / 1000000).toFixed(1)).toString() + 'm';
  } else if (retVal >= 99999999) {
    retVal = '99.9m';
  }

  return retVal;
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _spyOnComponent = _interopRequireDefault(__webpack_require__(344));

exports.spyOnComponent = _spyOnComponent.default;

var _autoFocus = _interopRequireDefault(__webpack_require__(1596));

exports.autoFocus = _autoFocus.default;

var _focusManager = _interopRequireDefault(__webpack_require__(1597));

exports.focusManager = _focusManager.default;

var _mountManager = _interopRequireDefault(__webpack_require__(475));

exports.mountManager = _mountManager.default;

var _timeoutManager = _interopRequireDefault(__webpack_require__(698));

exports.timeoutManager = _timeoutManager.default;

var _mixin = _interopRequireDefault(__webpack_require__(1598));

exports.mixin = _mixin.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = spyOnMount;

var _spyOnComponent = _interopRequireDefault(__webpack_require__(344));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function spyOnMount(componentInstance) {
  var mounted = true;
  (0, _spyOnComponent.default)(componentInstance, {
    componentWillUnmount: function componentWillUnmount() {
      mounted = false;
    }
  });
  return function () {
    return mounted;
  };
}

module.exports = exports["default"];

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = height;

var _offset = _interopRequireDefault(__webpack_require__(706));

var _isWindow = _interopRequireDefault(__webpack_require__(345));

function height(node, client) {
  var win = (0, _isWindow.default)(node);
  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
}

module.exports = exports["default"];

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isShallowEqual = isShallowEqual;
exports.chunk = chunk;
exports.groupBySortedKeys = groupBySortedKeys;
exports.has = exports.makeArray = void 0;

var _warning = _interopRequireDefault(__webpack_require__(1621));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeArray = function makeArray(obj) {
  return obj == null ? [] : [].concat(obj);
};

exports.makeArray = makeArray;

var has = function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
};

exports.has = has;

function isShallowEqual(a, b) {
  if (a === b) return true;
  if (a instanceof Date && b instanceof Date) return +a === +b;
  if (typeof a !== 'object' && typeof b !== 'object') return a === b;
  if (typeof a !== typeof b) return false;
  if (a == null || b == null) return false; // if they were both null we wouldn't be here

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!has(b, keysA[i]) || a[keysA[i]] !== b[keysA[i]]) return false;
  }

  return true;
}

function chunk(array, chunkSize) {
  var index = 0,
      length = array ? array.length : 0;
  var result = [];
  chunkSize = Math.max(+chunkSize || 1, 1);

  while (index < length) {
    result.push(array.slice(index, index += chunkSize));
  }

  return result;
}

function groupBySortedKeys(groupBy, data, keys) {
  var iter = typeof groupBy === 'function' ? groupBy : function (item) {
    return item[groupBy];
  }; // the keys array ensures that groups are rendered in the order they came in
  // which means that if you sort the data array it will render sorted,
  // so long as you also sorted by group

  keys = keys || [];
   false ? (0, _warning.default)(typeof groupBy !== 'string' || !data.length || has(data[0], groupBy), "[React Widgets] You seem to be trying to group this list by a " + ("property `" + groupBy + "` that doesn't exist in the dataset items, this may be a typo")) : void 0;
  return data.reduce(function (grps, item) {
    var group = iter(item);

    if (has(grps, group)) {
      grps[group].push(item);
    } else {
      keys.push(group);
      grps[group] = [item];
    }

    return grps;
  }, {});
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.pick = pick;
exports.pickElementProps = pickElementProps;
exports.omitOwn = omitOwn;
var whitelist = ['style', 'className', 'role', 'id', 'autocomplete', 'size', 'tabIndex', 'maxLength', 'name'];
var whitelistRegex = [/^aria-/, /^data-/, /^on[A-Z]\w+/];

function pick(props, componentClass) {
  var keys = Object.keys(componentClass.propTypes);
  var result = {};
  Object.keys(props).forEach(function (key) {
    if (keys.indexOf(key) === -1) return;
    result[key] = props[key];
  });
  return result;
}

function pickElementProps(component) {
  for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  var props = omitOwn.apply(void 0, [component].concat(others));
  var result = {};
  Object.keys(props).forEach(function (key) {
    if (whitelist.indexOf(key) !== -1 || whitelistRegex.some(function (r) {
      return !!key.match(r);
    })) result[key] = props[key];
  });
  return result;
}

function omitOwn(component) {
  var initial = Object.keys(component.constructor.propTypes);

  for (var _len2 = arguments.length, others = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    others[_key2 - 1] = arguments[_key2];
  }

  var keys = others.reduce(function (arr, compClass) {
    return arr.concat(Object.keys(compClass.propTypes));
  }, initial);
  var result = {};
  Object.keys(component.props).forEach(function (key) {
    if (keys.indexOf(key) !== -1) return;
    result[key] = component.props[key];
  });
  return result;
}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.notify = notify;
exports.instanceId = instanceId;
exports.isFirstFocusedRender = isFirstFocusedRender;
var idCount = 0;

function uniqueId(prefix) {
  return '' + ((prefix == null ? '' : prefix) + ++idCount);
}

function notify(handler, args) {
  handler && handler.apply(null, [].concat(args));
}

function instanceId(component, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }

  component.__id || (component.__id = uniqueId('rw_'));
  return (component.props.id || component.__id) + suffix;
}
/**
 * Allows for defering popup rendering untill the widget is focused,
 * or has been opened (in order to not remove it suddenly on close)
 */


function isFirstFocusedRender(component) {
  return component._firstFocus || (component.state.focused || !!component.props.open) && (component._firstFocus = true);
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: ', ';\n  width: ', ';\n  display: flex;\n  border-radius: 100px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background: #DEDFE0;\n  border: ', '\n  box-sizing: border-box;\n'], ['\n  height: ', ';\n  width: ', ';\n  display: flex;\n  border-radius: 100px;\n  margin-bottom: 20px;\n  overflow: hidden;\n  background: #DEDFE0;\n  border: ', '\n  box-sizing: border-box;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: #999999;\n  height: inherit;\n  width: ', ';\n'], ['\n  background: #999999;\n  height: inherit;\n  width: ', ';\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: repeating-linear-gradient(\n      45deg,\n      #999999,\n      #999999 5px,\n      black 6px,\n      black 6px\n    )\n    #999999;\n  height: inherit;\n  width: ', ';\n'], ['\n  background: repeating-linear-gradient(\n      45deg,\n      #999999,\n      #999999 5px,\n      black 6px,\n      black 6px\n    )\n    #999999;\n  height: inherit;\n  width: ', ';\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  background: #000000;\n  height: inherit;\n  width: ', ';\n'], ['\n  background: #000000;\n  height: inherit;\n  width: ', ';\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  background: #00bc80;\n  height: inherit;\n  width: ', ';\n'], ['\n  background: #00bc80;\n  height: inherit;\n  width: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalsGradientContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StatusCountBar__TotalsGradientContainer',
  componentId: 'lgnsqp-0'
})(_templateObject, function (props) {
  return props.height.toString() + 'px';
}, function (props) {
  return props.width.toString() + 'px';
}, function (props) {
  return props.totalCount === 0 ? 'border: 1px solid #CCCCCC' : 'none';
});

var DraftBar = _styledComponents2.default.div.withConfig({
  displayName: 'StatusCountBar__DraftBar',
  componentId: 'lgnsqp-1'
})(_templateObject2, function (props) {
  return props.draftCount / props.totalCount * props.width + 'px';
});

var RejectedBar = _styledComponents2.default.div.withConfig({
  displayName: 'StatusCountBar__RejectedBar',
  componentId: 'lgnsqp-2'
})(_templateObject3, function (props) {
  return props.rejectedCount / props.totalCount * props.width + 'px';
});

var QualityReviewBar = _styledComponents2.default.div.withConfig({
  displayName: 'StatusCountBar__QualityReviewBar',
  componentId: 'lgnsqp-3'
})(_templateObject4, function (props) {
  return props.qualityReviewCount / props.totalCount * props.width + 'px';
});

var PublishedBar = _styledComponents2.default.div.withConfig({
  displayName: 'StatusCountBar__PublishedBar',
  componentId: 'lgnsqp-4'
})(_templateObject5, function (props) {
  return props.publishedCount / props.totalCount * props.width + 'px';
});

var StatusCountBar = function StatusCountBar(props) {
  return _react2.default.createElement(
    TotalsGradientContainer,
    props,
    _react2.default.createElement(DraftBar, props),
    _react2.default.createElement(RejectedBar, props),
    _react2.default.createElement(QualityReviewBar, props),
    _react2.default.createElement(PublishedBar, props)
  );
};

StatusCountBar.propTypes = {
  draftCount: _propTypes2.default.number.isRequired,
  rejectedCount: _propTypes2.default.number.isRequired,
  qualityReviewCount: _propTypes2.default.number.isRequired,
  publishedCount: _propTypes2.default.number.isRequired,
  totalCount: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired
};

StatusCountBar.defaultProps = {
  height: 8
};

exports.default = StatusCountBar;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// there are issues with this; formatting for million removes decimal point
// anything over 100 million doesn't have special handling - probably not a real world problem
// also, this should be called formatNumberForFourDigits

var formatNumberForThreeDigits = exports.formatNumberForThreeDigits = function formatNumberForThreeDigits(number) {
  var retVal = number.toString();
  if (retVal > 9999 && retVal < 100000) {
    retVal = Math.floor(retVal / 1000).toFixed(0).toString() + 'k+';
  } else if (retVal >= 100000 && retVal < 1000000) {
    retVal = Math.floor(retVal / 1000).toFixed(0).toString() + 'k';
  } else if (retVal >= 1000000 && retVal < 10000000) {
    retVal = Math.floor(retVal / 1000000).toFixed(1).toString() + 'm';
  } else if (retVal >= 10000000 && retVal < 100000000) {
    retVal = Math.floor(retVal / 1000000).toFixed(0).toString() + 'm+';
  } else if (retVal >= 100000000) {
    retVal = Math.floor(retVal / 1000000).toFixed(0).toString() + 'm';
  }

  return retVal;
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButton = __webpack_require__(165).default;
var Menu = __webpack_require__(330).default;
var MenuItem = __webpack_require__(262).default;
var MoreVertIcon = __webpack_require__(722).default;

var ITEM_HEIGHT = 48;

var EditOrDeleteMenuButton = function EditOrDeleteMenuButton(_ref) {
  var options = _ref.options,
      handleChosenOption = _ref.handleChosenOption;

  var _React$useState = _react2.default.useState(null),
      _React$useState2 = (0, _slicedToArray3.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose(option) {
    handleChosenOption(option);
    setAnchorEl(null);
  };

  return _react2.default.createElement(
    'div',
    { className: 'edit-or-delete-menu-button' },
    _react2.default.createElement(
      IconButton,
      {
        'aria-label': 'more',
        'aria-controls': 'long-menu',
        'aria-haspopup': 'true',
        onClick: handleClick,
        style: { width: '48px' }
      },
      _react2.default.createElement(MoreVertIcon, null)
    ),
    _react2.default.createElement(
      Menu,
      {
        id: 'long-menu',
        anchorEl: anchorEl,
        keepMounted: true,
        open: open,
        onClose: handleClose,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }
      },
      options.map(function (option) {
        return _react2.default.createElement(
          MenuItem,
          {
            key: option,
            onClick: function onClick() {
              return handleClose(option);
            }
          },
          option
        );
      })
    )
  );
};

EditOrDeleteMenuButton.propTypes = {
  options: _propTypes2.default.array.isRequired,
  handleChosenOption: _propTypes2.default.func.isRequired
};

exports.default = EditOrDeleteMenuButton;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(733), __esModule: true };

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(224);
var $export = __webpack_require__(70);
var redefine = __webpack_require__(487);
var hide = __webpack_require__(169);
var Iterators = __webpack_require__(194);
var $iterCreate = __webpack_require__(735);
var setToStringTag = __webpack_require__(278);
var getPrototypeOf = __webpack_require__(492);
var ITERATOR = __webpack_require__(82)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(104) && !__webpack_require__(193)(function () {
  return Object.defineProperty(__webpack_require__(348)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(169);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(132);
var anObject = __webpack_require__(119);
var getKeys = __webpack_require__(195);

module.exports = __webpack_require__(104) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(170);
var toIObject = __webpack_require__(171);
var arrayIndexOf = __webpack_require__(736)(false);
var IE_PROTO = __webpack_require__(352)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(226);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(81).document;
module.exports = document && document.documentElement;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(170);
var toObject = __webpack_require__(196);
var IE_PROTO = __webpack_require__(352)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(119);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(194);
var ITERATOR = __webpack_require__(82)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(82)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(49) && !__webpack_require__(31)(function () {
  return Object.defineProperty(__webpack_require__(357)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(44);


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(94);
var toIObject = __webpack_require__(95);
var arrayIndexOf = __webpack_require__(279)(false);
var IE_PROTO = __webpack_require__(359)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(51);
var anObject = __webpack_require__(24);
var getKeys = __webpack_require__(174);

module.exports = __webpack_require__(49) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(95);
var gOPN = __webpack_require__(177).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(49);
var getKeys = __webpack_require__(174);
var gOPS = __webpack_require__(280);
var pIE = __webpack_require__(229);
var toObject = __webpack_require__(54);
var IObject = __webpack_require__(228);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(31)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(71);
var isObject = __webpack_require__(33);
var invoke = __webpack_require__(504);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(29).parseInt;
var $trim = __webpack_require__(199).trim;
var ws = __webpack_require__(363);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(29).parseFloat;
var $trim = __webpack_require__(199).trim;

module.exports = 1 / $parseFloat(__webpack_require__(363) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(107);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(33);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 509 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(366);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(24);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(71);
var toObject = __webpack_require__(54);
var IObject = __webpack_require__(228);
var toLength = __webpack_require__(46);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(54);
var toAbsoluteIndex = __webpack_require__(175);
var toLength = __webpack_require__(46);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(378);
__webpack_require__(10)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(49) && /./g.flags != 'g') __webpack_require__(51).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(230)
});


/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var isObject = __webpack_require__(33);
var newPromiseCapability = __webpack_require__(382);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(520);
var validate = __webpack_require__(182);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(288)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(51).f;
var create = __webpack_require__(176);
var redefineAll = __webpack_require__(181);
var ctx = __webpack_require__(106);
var anInstance = __webpack_require__(179);
var forOf = __webpack_require__(180);
var $iterDefine = __webpack_require__(368);
var step = __webpack_require__(514);
var setSpecies = __webpack_require__(178);
var DESCRIPTORS = __webpack_require__(49);
var fastKey = __webpack_require__(152).fastKey;
var validate = __webpack_require__(182);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(520);
var validate = __webpack_require__(182);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(288)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var each = __webpack_require__(123)(0);
var redefine = __webpack_require__(88);
var meta = __webpack_require__(152);
var assign = __webpack_require__(501);
var weak = __webpack_require__(523);
var isObject = __webpack_require__(33);
var validate = __webpack_require__(182);
var NATIVE_WEAK_MAP = __webpack_require__(182);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(288)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(181);
var getWeak = __webpack_require__(152).getWeak;
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(33);
var anInstance = __webpack_require__(179);
var forOf = __webpack_require__(180);
var createArrayMethod = __webpack_require__(123);
var $has = __webpack_require__(94);
var validate = __webpack_require__(182);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(108);
var toLength = __webpack_require__(46);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(177);
var gOPS = __webpack_require__(280);
var anObject = __webpack_require__(24);
var Reflect = __webpack_require__(29).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(281);
var isObject = __webpack_require__(33);
var toLength = __webpack_require__(46);
var ctx = __webpack_require__(106);
var IS_CONCAT_SPREADABLE = __webpack_require__(44)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(46);
var repeat = __webpack_require__(365);
var defined = __webpack_require__(121);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(49);
var getKeys = __webpack_require__(174);
var toIObject = __webpack_require__(95);
var isEnum = __webpack_require__(229).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(198);
var from = __webpack_require__(530);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(180);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 531 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(277)('meta');
var isObject = __webpack_require__(133);
var has = __webpack_require__(170);
var setDesc = __webpack_require__(132).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(193)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(489);
var hiddenKeys = __webpack_require__(354).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(232);
var createDesc = __webpack_require__(225);
var toIObject = __webpack_require__(171);
var toPrimitive = __webpack_require__(349);
var has = __webpack_require__(170);
var IE8_DOM_DEFINE = __webpack_require__(486);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(104) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 542 */
/***/ (function(module, exports) {



/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(119);
var aFunction = __webpack_require__(276);
var SPECIES = __webpack_require__(82)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(192);
var invoke = __webpack_require__(990);
var html = __webpack_require__(491);
var cel = __webpack_require__(348);
var global = __webpack_require__(81);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(226)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(119);
var isObject = __webpack_require__(133);
var newPromiseCapability = __webpack_require__(391);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUserNeedsAppUpdate = setUserNeedsAppUpdate;
var APP_UPDATE_AVAILABLE = exports.APP_UPDATE_AVAILABLE = 'APP_UPDATE_AVAILABLE';

function setUserNeedsAppUpdate() {
  return {
    type: APP_UPDATE_AVAILABLE
  };
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.forgotPasswordSuccess = forgotPasswordSuccess;
exports.forgotPasswordRequest = forgotPasswordRequest;
exports.forgotPassword = forgotPassword;

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FORGOT_PASSWORD_REQUEST = exports.FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
var FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

function forgotPasswordSuccess() {
  return {
    type: FORGOT_PASSWORD_SUCCESS
  };
}

function forgotPasswordRequest() {
  return {
    type: FORGOT_PASSWORD_REQUEST
  };
}

function forgotPassword(email) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getBaseUrl)() + '/quest_maker/api/password_resets';

              dispatch(forgotPasswordRequest());
              localStorage.setItem('lastLogin', email);
              _context.prev = 4;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 8;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  email: email
                })
              });

            case 8:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(forgotPasswordSuccess());
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t2 = _context['catch'](4);

              console.log(_context.t2);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(104);
var getKeys = __webpack_require__(195);
var toIObject = __webpack_require__(171);
var isEnum = __webpack_require__(232).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ORGANIZATIONS_FAILURE = exports.FETCH_ORGANIZATIONS_SUCCESS = exports.FETCH_ORGANIZATIONS_REQUEST = undefined;
exports.fetchOrganizationsRequest = fetchOrganizationsRequest;
exports.fetchOrganizationsSuccess = fetchOrganizationsSuccess;
exports.fetchOrganizationsFailure = fetchOrganizationsFailure;
exports.fetchOrganizations = fetchOrganizations;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _api = __webpack_require__(72);

var _actions = __webpack_require__(55);

var FETCH_ORGANIZATIONS_REQUEST = exports.FETCH_ORGANIZATIONS_REQUEST = 'FETCH_ORGANIZATIONS_REQUEST';
var FETCH_ORGANIZATIONS_SUCCESS = exports.FETCH_ORGANIZATIONS_SUCCESS = 'FETCH_ORGANIZATIONS_SUCCESS';
var FETCH_ORGANIZATIONS_FAILURE = exports.FETCH_ORGANIZATIONS_FAILURE = 'FETCH_ORGANIZATIONS_FAILURE';

function fetchOrganizationsRequest() {
  return {
    type: FETCH_ORGANIZATIONS_REQUEST
  };
}

function fetchOrganizationsSuccess(response) {
  return {
    type: FETCH_ORGANIZATIONS_SUCCESS,
    organizations: response.organizations
  };
}

function fetchOrganizationsFailure(error) {
  return (0, _actions.getErrorAction)(FETCH_ORGANIZATIONS_FAILURE, error);
}

function fetchOrganizations() {
  return function (dispatch, getState) {
    var state = getState();
    var url = (0, _utils.getApiBaseUrl)();
    return (0, _api.basicGet)(state, dispatch, url, fetchOrganizationsRequest, fetchOrganizationsSuccess, fetchOrganizationsFailure);
  };
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1023);
var parse = __webpack_require__(1033);
var formats = __webpack_require__(400);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(400);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var reviewTracking = exports.reviewTracking = [{
  id: 1,
  backend_value: 'in_internal_review',
  name: 'Experience/Subject *',
  description: '* Quests considered to be in Experience/Subject are those currently assigned to a quest manager with Experience and/or Subject not checked as complete.',
  sort: 0,
  in_internal_review: true,
  in_copy_edit: false,
  value: 1,
  label: 'Experience/Subject *'
}, {
  id: 2,
  backend_value: 'in_copy_edit',
  name: 'Copy Edit *',
  description: '* Quests considered to be in Copy Edit are those that have Experience and Subject checked as complete with only Copy Edit remaining.',
  sort: 1,
  in_internal_review: false,
  in_copy_edit: true,
  value: 2,
  label: 'Copy Edit *'
}];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.productionstatusfilters = productionstatusfilters;

var _productionstatusfilters = __webpack_require__(397);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  authors_id_in: [],
  questtags_id_in: [],
  quest_subject_id_in: [],
  assigned_to_id_in: [],
  grade_levels_id_in: [],
  mock_course_id_in: null,
  mock_level_id_in: []
};

function productionstatusfilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _productionstatusfilters.SET_PRODUCTION_STATUS_AUTHORS_FILTER:
      return (0, _assign2.default)({}, state, {
        authors_id_in: action.authors_id_in
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_COURSE_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_LEVELS_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_level_id_in: action.mock_level_id_in
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_TAG_FILTERS:
      return (0, _assign2.default)({}, state, {
        questtags_id_in: action.questtags_id_in
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_PRIMARY_SUBJECT_FILTER:
      return (0, _assign2.default)({}, state, {
        quest_subject_id_in: action.quest_subject_id_in
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_ASSIGNED_TO_FILTERS:
      return (0, _assign2.default)({}, state, {
        assigned_to_id_in: action.assigned_to_id_in
      });
    case _productionstatusfilters.SET_PRODUCTION_STATUS_TARGET_GRADE_LEVEL_FILTERS:
      return (0, _assign2.default)({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      });
    case _productionstatusfilters.CLEAR_PRODUCTION_STATUS_FILTERS:
      return (0, _assign2.default)({}, state, initialState);
    default:
      return state;
  }
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1036)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1043);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS = exports.EDIT_ACTIVITY_RESOURCE_FAILURE = exports.EDIT_ACTIVITY_RESOURCE_REQUEST = exports.EDIT_ACTIVITY_RESOURCE_SUCCESS = exports.DELETE_ACTIVITY_RESOURCE_SUCCESS = exports.EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS = exports.PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS = exports.CREATE_ACTIVITY_RESOURCE_FAILURE = exports.CREATE_ACTIVITY_RESOURCE_SUCCESS = exports.CREATE_ACTIVITY_RESOURCE_REQUEST = undefined;

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.createActivityResourceFailure = createActivityResourceFailure;
exports.createActivityResourceSuccess = createActivityResourceSuccess;
exports.createActivityResourceRequest = createActivityResourceRequest;
exports.patchActivityResourceFileInfoSuccess = patchActivityResourceFileInfoSuccess;
exports.editActivityResourceFailure = editActivityResourceFailure;
exports.editActivityResourceRequest = editActivityResourceRequest;
exports.editActivityResourceSuccess = editActivityResourceSuccess;
exports.deleteActivityResourceSuccess = deleteActivityResourceSuccess;
exports.editActivityResourcePositionSuccess = editActivityResourcePositionSuccess;
exports.removeActivityResourceFileSuccess = removeActivityResourceFileSuccess;
exports.patchActivityResourceFileInfo = patchActivityResourceFileInfo;
exports.createActivityResource = createActivityResource;
exports.editActivityResourcePosition = editActivityResourcePosition;
exports.deleteActivityResource = deleteActivityResource;
exports.editActivityResource = editActivityResource;
exports.removeActivityResourceFile = removeActivityResourceFile;

var _utils = __webpack_require__(20);

var _actions = __webpack_require__(55);

var _resources = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_ACTIVITY_RESOURCE_REQUEST = exports.CREATE_ACTIVITY_RESOURCE_REQUEST = 'CREATE_ACTIVITY_RESOURCE_REQUEST';
var CREATE_ACTIVITY_RESOURCE_SUCCESS = exports.CREATE_ACTIVITY_RESOURCE_SUCCESS = 'CREATE_ACTIVITY_RESOURCE_SUCCESS';
var CREATE_ACTIVITY_RESOURCE_FAILURE = exports.CREATE_ACTIVITY_RESOURCE_FAILURE = 'CREATE_ACTIVITY_RESOURCE_FAILURE';
var PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS = exports.PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS = 'PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS';
var EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS = exports.EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS = 'EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS';
var DELETE_ACTIVITY_RESOURCE_SUCCESS = exports.DELETE_ACTIVITY_RESOURCE_SUCCESS = 'DELETE_ACTIVITY_RESOURCE_SUCCESS';
var EDIT_ACTIVITY_RESOURCE_SUCCESS = exports.EDIT_ACTIVITY_RESOURCE_SUCCESS = 'EDIT_ACTIVITY_RESOURCE_SUCCESS';
var EDIT_ACTIVITY_RESOURCE_REQUEST = exports.EDIT_ACTIVITY_RESOURCE_REQUEST = 'EDIT_ACTIVITY_RESOURCE_REQUEST';
var EDIT_ACTIVITY_RESOURCE_FAILURE = exports.EDIT_ACTIVITY_RESOURCE_FAILURE = 'EDIT_ACTIVITY_RESOURCE_FAILURE';
var REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS = exports.REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS = 'REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS';

function createActivityResourceFailure(error) {
  return (0, _actions.getErrorAction)(CREATE_ACTIVITY_RESOURCE_FAILURE, error);
}

function createActivityResourceSuccess(response) {
  return {
    type: CREATE_ACTIVITY_RESOURCE_SUCCESS,
    resource: response
  };
}

function createActivityResourceRequest() {
  return {
    type: CREATE_ACTIVITY_RESOURCE_REQUEST
  };
}

function patchActivityResourceFileInfoSuccess(resource) {
  return {
    type: PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS,
    payload: {
      resource: resource
    }
  };
}

function editActivityResourceFailure(error) {
  return (0, _actions.getErrorAction)(EDIT_ACTIVITY_RESOURCE_FAILURE, error);
}

function editActivityResourceRequest() {
  return {
    type: EDIT_ACTIVITY_RESOURCE_REQUEST
  };
}

function editActivityResourceSuccess(response) {
  return {
    type: EDIT_ACTIVITY_RESOURCE_SUCCESS,
    resource: response
  };
}

function deleteActivityResourceSuccess(activityId, resourceId) {
  return {
    type: DELETE_ACTIVITY_RESOURCE_SUCCESS,
    activityId: activityId,
    resourceId: resourceId
  };
}

function editActivityResourcePositionSuccess(response, newIndex) {
  return {
    type: EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS,
    resource: response,
    newIndex: newIndex
  };
}

function removeActivityResourceFileSuccess(response) {
  return {
    type: REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS,
    resource: response
  };
}

function patchActivityResourceFileInfo(questId, activityId, resourceId, fileProps) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resourceId + '/file';
              _context.prev = 2;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 6;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  resource: {
                    resource_file: fileProps.name,
                    file_size: fileProps.size,
                    content_type: fileProps.type,
                    url: null,
                    original_file_name: fileProps.original_file_name,
                    file_checksum: fileProps.file_checksum
                  }
                })
              });

            case 6:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;

              dispatch(patchActivityResourceFileInfoSuccess(json));
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t2 = _context['catch'](2);
              throw new Error('patch failed');

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 14]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function createActivityResource(questId, activity, resourceName) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activity.id + '/resources';

              dispatch(createActivityResourceRequest());
              _context2.prev = 3;
              _context2.t0 = _utils.checkHttpStatus;
              _context2.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  resource: {
                    name: resourceName
                  }
                })
              });

            case 7:
              _context2.t1 = _context2.sent;
              response = (0, _context2.t0)(_context2.t1);
              _context2.next = 11;
              return response.json();

            case 11:
              json = _context2.sent;

              dispatch(createActivityResourceSuccess(json));
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t2 = _context2['catch'](3);

              dispatch(createActivityResourceFailure(_context2.t2));

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[3, 15]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function editActivityResourcePosition(questId, activityId, resourceId, newIndex) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resourceId;
              data = new FormData();

              data.append('resource[sort_order_position]', newIndex.toString());
              _context3.prev = 4;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 8;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 8:
              _context3.t1 = _context3.sent;
              response = (0, _context3.t0)(_context3.t1);
              _context3.next = 12;
              return response.json();

            case 12:
              json = _context3.sent;

              dispatch(editActivityResourcePositionSuccess(json, newIndex));
              _context3.next = 19;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t2 = _context3['catch'](4);

              console.log(_context3.t2);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 16]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function deleteActivityResource(questId, activityId, resourceId, isNewResource) {
  var _this4 = this;

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resourceId;
              _context4.prev = 2;
              _context4.t0 = _utils.checkHttpStatus;
              _context4.next = 6;
              return fetch(url, {
                method: 'DELETE',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  resource: {
                    new_resource: isNewResource
                  }
                })
              });

            case 6:
              _context4.t1 = _context4.sent;
              (0, _context4.t0)(_context4.t1);

              dispatch(deleteActivityResourceSuccess(activityId, resourceId));
              _context4.next = 14;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t2 = _context4['catch'](2);

              console.log(_context4.t2);

            case 14:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[2, 11]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
}

function editActivityResource(questId, activityId, resource, isNewResource) {
  var _this5 = this;

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch, getState) {
      var state, url, body, data, response, json;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resource.id;
              body = void 0;

              dispatch(editActivityResourceRequest());
              if (resource.format === 'file') {
                data = { resource: {} };

                data.resource.url = null;
                data.resource.name = resource.resourceName;
                data.resource.description = resource.resourceDescription || null;
                data.resource.resource_type = resource.resourceType;
                data.resource.start_time = null;
                data.resource.end_time = null;
                data.resource.new_resource = isNewResource;

                if ((0, _keys2.default)(resource.content_warnings).length === 0) {
                  data.resource.clear_content_warnings = true;
                } else {
                  data.resource.content_warnings = resource.content_warnings;
                }

                if (resource.attributionSelection === 'outsideorg') {
                  data.resource.license_citation = resource.citation;
                  data.resource.license_owned_by_organization = false;
                } else {
                  data.resource.license_citation = null;
                  data.resource.license_owned_by_organization = true;
                }
                body = (0, _stringify2.default)(data);
              } else if (resource.format === 'url') {
                body = (0, _stringify2.default)({
                  resource: {
                    description: resource.resourceDescription,
                    name: resource.resourceName,
                    resource_type: resource.resourceType,
                    url: resource.url,
                    clear_resource_file: true,
                    license_citation: null,
                    license_owned_by_organization: resource.attributionSelection === 'myorg' ? true : null,
                    content_warnings: resource.content_warnings,
                    start_time: (0, _resources.getYoutubeTimeValueForEndpoint)(resource.startMinutes, resource.startSeconds, resource.url, resource.resourceType),
                    end_time: (0, _resources.getYoutubeTimeValueForEndpoint)(resource.endMinutes, resource.endSeconds, resource.url, resource.resourceType),
                    new_resource: isNewResource
                  }
                });
              }
              _context5.prev = 5;
              _context5.t0 = _utils.checkHttpStatus;
              _context5.next = 9;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: body
              });

            case 9:
              _context5.t1 = _context5.sent;
              response = (0, _context5.t0)(_context5.t1);
              _context5.next = 13;
              return response.json();

            case 13:
              json = _context5.sent;

              dispatch(editActivityResourceSuccess(json));
              _context5.next = 20;
              break;

            case 17:
              _context5.prev = 17;
              _context5.t2 = _context5['catch'](5);

              dispatch(editActivityResourceFailure(_context5.t2));

            case 20:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5, [[5, 17]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
}

function removeActivityResourceFile(questId, activityId, resource) {
  var _this6 = this;

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch, getState) {
      var state, url, data, response, json;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resource.id;
              data = new FormData();

              data.append('resource[clear_resource_file]', 'true');
              data.append('resource[license_citation]', '');
              _context6.prev = 5;
              _context6.t0 = _utils.checkHttpStatus;
              _context6.next = 9;
              return fetch(url, {
                method: 'PATCH',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/vnd.oefngl.v3'
                },
                body: data
              });

            case 9:
              _context6.t1 = _context6.sent;
              response = (0, _context6.t0)(_context6.t1);
              _context6.next = 13;
              return response.json();

            case 13:
              json = _context6.sent;

              dispatch(removeActivityResourceFileSuccess(json));
              _context6.next = 20;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t2 = _context6['catch'](5);

              console.log(_context6.t2);

            case 20:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[5, 17]]);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1058);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_SETTING_LAST_APPROVAL = exports.IS_EDITING_APPROVAL = exports.DELETE_APPROVED_SUCCESS = exports.SET_APPROVED_SUCCESS = undefined;

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.setApprovedSuccess = setApprovedSuccess;
exports.deleteApprovedSuccess = deleteApprovedSuccess;
exports.isEditingApproval = isEditingApproval;
exports.isSettingLastApproval = isSettingLastApproval;
exports.setApproved = setApproved;
exports.setLastApproval = setLastApproval;
exports.deleteApproval = deleteApproval;

__webpack_require__(47);

var _utils = __webpack_require__(20);

var _review = __webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_APPROVED_SUCCESS = exports.SET_APPROVED_SUCCESS = 'SET_APPROVED_SUCCESS';
var DELETE_APPROVED_SUCCESS = exports.DELETE_APPROVED_SUCCESS = 'DELETE_APPROVED_SUCCESS';
var IS_EDITING_APPROVAL = exports.IS_EDITING_APPROVAL = 'IS_EDITING_APPROVAL';
var IS_SETTING_LAST_APPROVAL = exports.IS_SETTING_LAST_APPROVAL = 'IS_SETTING_LAST_APPROVAL';

function setApprovedSuccess(response) {
  return {
    type: SET_APPROVED_SUCCESS,
    payload: {
      approval: response
    }
  };
}

function deleteApprovedSuccess(approvalId) {
  return {
    type: DELETE_APPROVED_SUCCESS,
    payload: {
      approvalId: approvalId
    }
  };
}

function isEditingApproval() {
  return {
    type: IS_EDITING_APPROVAL
  };
}

function isSettingLastApproval() {
  return {
    type: IS_SETTING_LAST_APPROVAL
  };
}

function setApproved(questId, criteria) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url, response, json;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/approvals';

              dispatch(isEditingApproval());

              _context.prev = 3;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 7;
              return fetch(url, {
                method: 'POST',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                },
                body: (0, _stringify2.default)({
                  approval: {
                    criteria: criteria
                  }
                })
              });

            case 7:
              _context.t1 = _context.sent;
              response = (0, _context.t0)(_context.t1);
              _context.next = 11;
              return response.json();

            case 11:
              json = _context.sent;
              _context.next = 14;
              return dispatch(setApprovedSuccess(json));

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t2 = _context['catch'](3);

              console.log(_context.t2);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 16]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function setLastApproval(questId, criteria) {
  var _this2 = this;

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _promise2.default.all([dispatch(isSettingLastApproval()), dispatch(setApproved(questId, criteria)), dispatch((0, _review.createCompiledQuest)(questId))]).then(function () {
                return dispatch((0, _review.closeToQualityReviewModal)());
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function deleteApproval(questId, approvalId) {
  var _this3 = this;

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              url = (0, _utils.getApiBaseUrlWithOrg)(state.organization.orgId) + '/quests/' + questId + '/approvals/' + approvalId;

              dispatch(isEditingApproval());

              _context3.prev = 3;
              _context3.t0 = _utils.checkHttpStatus;
              _context3.next = 7;
              return fetch(url, {
                method: 'DELETE',
                headers: {
                  Authorization: 'Token token="' + state.user.token + '"',
                  Accept: 'application/json, application/vnd.oefngl.v1',
                  'Content-Type': 'application/json'
                }
              });

            case 7:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)(_context3.t1);

              dispatch(deleteApprovedSuccess(approvalId));
              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t2 = _context3['catch'](3);

              console.log(_context3.t2);

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[3, 12]]);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRY_AGAIN = exports.RESET_PASSWORD_REQUEST = exports.RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_SUCCESS = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.resetPasswordSuccess = resetPasswordSuccess;
exports.resetPasswordFailure = resetPasswordFailure;
exports.resetPasswordRequest = resetPasswordRequest;
exports.resetPassword = resetPassword;

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
var RESET_PASSWORD_REQUEST = exports.RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
var TRY_AGAIN = exports.TRY_AGAIN = 'TRY_AGAIN';

function resetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS
  };
}

function resetPasswordFailure() {
  return {
    type: RESET_PASSWORD_FAILURE
  };
}

function resetPasswordRequest() {
  return {
    type: RESET_PASSWORD_REQUEST
  };
}

function resetPassword(token, password) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getBaseUrl)() + '/quest_maker/api/password_resets/' + token;

              dispatch(resetPasswordRequest());
              _context.prev = 3;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 7;
              return fetch(url, {
                method: 'PATCH',
                headers: (0, _utils.getApiHeaders)(state),
                body: (0, _stringify2.default)({
                  user: {
                    password: password
                  }
                })
              });

            case 7:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

              dispatch(resetPasswordSuccess());
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t2 = _context['catch'](3);

              dispatch(resetPasswordFailure(_context.t2));

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 12]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNLOCK_ACCOUNT_FAILURE = exports.UNLOCK_ACCOUNT_SUCCESS = exports.UNLOCK_ACCOUNT_REQUEST = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.unlockAccountSuccess = unlockAccountSuccess;
exports.unlockAccountFailure = unlockAccountFailure;
exports.unlockAccountRequest = unlockAccountRequest;
exports.unlockAccount = unlockAccount;

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNLOCK_ACCOUNT_REQUEST = exports.UNLOCK_ACCOUNT_REQUEST = 'UNLOCK_ACCOUNT_REQUEST';
var UNLOCK_ACCOUNT_SUCCESS = exports.UNLOCK_ACCOUNT_SUCCESS = 'UNLOCK_ACCOUNT_SUCCESS';
var UNLOCK_ACCOUNT_FAILURE = exports.UNLOCK_ACCOUNT_FAILURE = 'UNLOCK_ACCOUNT_FAILURE';

function unlockAccountSuccess() {
  return {
    type: UNLOCK_ACCOUNT_SUCCESS
  };
}

function unlockAccountFailure() {
  return {
    type: UNLOCK_ACCOUNT_FAILURE
  };
}

function unlockAccountRequest() {
  return {
    type: UNLOCK_ACCOUNT_REQUEST
  };
}

function unlockAccount(token) {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, url;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              url = (0, _utils.getBaseUrl)() + '/quest_maker/api/unlock_accounts/' + token;

              dispatch(unlockAccountRequest());
              _context.prev = 3;
              _context.t0 = _utils.checkHttpStatus;
              _context.next = 7;
              return fetch(url, {
                method: 'PUT',
                headers: (0, _utils.getApiHeaders)(state)
              });

            case 7:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);


              dispatch(unlockAccountSuccess());
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t2 = _context['catch'](3);

              dispatch(unlockAccountFailure(_context.t2));

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 12]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1086), __esModule: true };

/***/ }),
/* 563 */,
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var repeat = exports.repeat = function repeat(str, times) {
  return new Array(times + 1).join(str);
};

var pad = exports.pad = function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num;
};

var formatTime = exports.formatTime = function formatTime(time) {
  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
};

// Use performance API if it's available in order to get better precision
var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(60);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(83);

// EXTERNAL MODULE: ./node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(307);

// EXTERNAL MODULE: ./node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(206);

// CONCATENATED MODULE: ./node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var query_Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = Object(esm_extends["a" /* default */])({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if (Object(utils["i" /* isValidTimeout */])(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = Object(utils["c" /* functionalUpdate */])(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = Object(utils["s" /* replaceEqualDeep */])(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils["l" /* noop */]).catch(utils["l" /* noop */]) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !Object(utils["w" /* timeUntilStale */])(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = Object(utils["b" /* ensureQueryKeyArray */])(this.queryKey);
    var abortController = Object(utils["d" /* getAbortController */])(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer["b" /* Retryer */]({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(Object(retryer["d" /* isCancelledError */])(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!Object(retryer["d" /* isCancelledError */])(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          Object(logger["a" /* getLogger */])().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager["a" /* notifyManager */].batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return Object(esm_extends["a" /* default */])({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return Object(esm_extends["a" /* default */])({}, state, {
          isPaused: true
        });

      case 'continue':
        return Object(esm_extends["a" /* default */])({}, state, {
          isPaused: false
        });

      case 'fetch':
        return Object(esm_extends["a" /* default */])({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return Object(esm_extends["a" /* default */])({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (Object(retryer["d" /* isCancelledError */])(error) && error.revert && this.revertState) {
          return Object(esm_extends["a" /* default */])({}, this.revertState);
        }

        return Object(esm_extends["a" /* default */])({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return Object(esm_extends["a" /* default */])({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return Object(esm_extends["a" /* default */])({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ./node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(185);

// CONCATENATED MODULE: ./node_modules/react-query/es/core/queryCache.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryCache_QueryCache; });





// CLASS
var queryCache_QueryCache = /*#__PURE__*/function (_Subscribable) {
  Object(inheritsLoose["a" /* default */])(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : Object(utils["f" /* hashQueryKeyByOptions */])(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new query_Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager["a" /* notifyManager */].batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = Object(utils["m" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return Object(utils["k" /* matchQuery */])(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = Object(utils["m" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return Object(utils["k" /* matchQuery */])(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager["a" /* notifyManager */].batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager["a" /* notifyManager */].batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager["a" /* notifyManager */].batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable["a" /* Subscribable */]);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(185);




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new __WEBPACK_IMPORTED_MODULE_2__mutation__["a" /* Mutation */]({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["j" /* matchMutation */])(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["j" /* matchMutation */])(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return __WEBPACK_IMPORTED_MODULE_1__notifyManager__["a" /* notifyManager */].batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(__WEBPACK_IMPORTED_MODULE_3__utils__["l" /* noop */]);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mutation; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaultState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__retryer__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(60);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_4__utils__["l" /* noop */]);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      Object(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* getLogger */])().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new __WEBPACK_IMPORTED_MODULE_3__retryer__["b" /* Retryer */]({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        isPaused: true
      });

    case 'continue':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        isPaused: false
      });

    case 'loading':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = infiniteQueryBehavior;
/* unused harmony export getNextPageParam */
/* unused harmony export getPreviousPageParam */
/* harmony export (immutable) */ __webpack_exports__["a"] = hasNextPage;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasPreviousPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retryer__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(60);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getAbortController */])();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if (Object(__WEBPACK_IMPORTED_MODULE_0__retryer__["c" /* isCancelable */])(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if (Object(__WEBPACK_IMPORTED_MODULE_0__retryer__["c" /* isCancelable */])(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueriesObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queryObserver__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(185);





var QueriesObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(QueriesObserver, _Subscribable);

  function QueriesObserver(client, queries) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.queries = [];
    _this.result = [];
    _this.observers = [];
    _this.observersMap = {};

    if (queries) {
      _this.setQueries(queries);
    }

    return _this;
  }

  var _proto = QueriesObserver.prototype;

  _proto.onSubscribe = function onSubscribe() {
    var _this2 = this;

    if (this.listeners.length === 1) {
      this.observers.forEach(function (observer) {
        observer.subscribe(function (result) {
          _this2.onUpdate(observer, result);
        });
      });
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.observers.forEach(function (observer) {
      observer.destroy();
    });
  };

  _proto.setQueries = function setQueries(queries, notifyOptions) {
    this.queries = queries;
    this.updateObservers(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.result;
  };

  _proto.getOptimisticResult = function getOptimisticResult(queries) {
    return this.findMatchingObservers(queries).map(function (match) {
      return match.observer.getOptimisticResult(match.defaultedQueryOptions);
    });
  };

  _proto.findMatchingObservers = function findMatchingObservers(queries) {
    var _this3 = this;

    var prevObservers = this.observers;
    var defaultedQueryOptions = queries.map(function (options) {
      return _this3.client.defaultQueryObserverOptions(options);
    });
    var matchingObservers = defaultedQueryOptions.flatMap(function (defaultedOptions) {
      var match = prevObservers.find(function (observer) {
        return observer.options.queryHash === defaultedOptions.queryHash;
      });

      if (match != null) {
        return [{
          defaultedQueryOptions: defaultedOptions,
          observer: match
        }];
      }

      return [];
    });
    var matchedQueryHashes = matchingObservers.map(function (match) {
      return match.defaultedQueryOptions.queryHash;
    });
    var unmatchedQueries = defaultedQueryOptions.filter(function (defaultedOptions) {
      return !matchedQueryHashes.includes(defaultedOptions.queryHash);
    });
    var unmatchedObservers = prevObservers.filter(function (prevObserver) {
      return !matchingObservers.some(function (match) {
        return match.observer === prevObserver;
      });
    });
    var newOrReusedObservers = unmatchedQueries.map(function (options, index) {
      if (options.keepPreviousData) {
        // return previous data from one of the observers that no longer match
        var previouslyUsedObserver = unmatchedObservers[index];

        if (previouslyUsedObserver !== undefined) {
          return {
            defaultedQueryOptions: options,
            observer: previouslyUsedObserver
          };
        }
      }

      return {
        defaultedQueryOptions: options,
        observer: _this3.getObserver(options)
      };
    });

    var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
      return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
    };

    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
  };

  _proto.getObserver = function getObserver(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var currentObserver = this.observersMap[defaultedOptions.queryHash];
    return currentObserver != null ? currentObserver : new __WEBPACK_IMPORTED_MODULE_3__queryObserver__["a" /* QueryObserver */](this.client, defaultedOptions);
  };

  _proto.updateObservers = function updateObservers(notifyOptions) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      var prevObservers = _this4.observers;

      var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes


      newObserverMatches.forEach(function (match) {
        return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
      });
      var newObservers = newObserverMatches.map(function (match) {
        return match.observer;
      });
      var newObserversMap = Object.fromEntries(newObservers.map(function (observer) {
        return [observer.options.queryHash, observer];
      }));
      var newResult = newObservers.map(function (observer) {
        return observer.getCurrentResult();
      });
      var hasIndexChange = newObservers.some(function (observer, index) {
        return observer !== prevObservers[index];
      });

      if (prevObservers.length === newObservers.length && !hasIndexChange) {
        return;
      }

      _this4.observers = newObservers;
      _this4.observersMap = newObserversMap;
      _this4.result = newResult;

      if (!_this4.hasListeners()) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* difference */])(prevObservers, newObservers).forEach(function (observer) {
        observer.destroy();
      });
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* difference */])(newObservers, prevObservers).forEach(function (observer) {
        observer.subscribe(function (result) {
          _this4.onUpdate(observer, result);
        });
      });

      _this4.notify();
    });
  };

  _proto.onUpdate = function onUpdate(observer, result) {
    var index = this.observers.indexOf(observer);

    if (index !== -1) {
      this.result = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["r" /* replaceAt */])(this.result, index, result);
      this.notify();
    }
  };

  _proto.notify = function notify() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_2__notifyManager__["a" /* notifyManager */].batch(function () {
      _this5.listeners.forEach(function (listener) {
        listener(_this5.result);
      });
    });
  };

  return QueriesObserver;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteQueryObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryObserver__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__ = __webpack_require__(570);




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      behavior: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["a" /* hasNextPage */])(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: Object(__WEBPACK_IMPORTED_MODULE_3__infiniteQueryBehavior__["b" /* hasPreviousPage */])(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(__WEBPACK_IMPORTED_MODULE_2__queryObserver__["a" /* QueryObserver */]);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MutationObserver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribable__ = __webpack_require__(185);





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : Object(__WEBPACK_IMPORTED_MODULE_2__mutation__["b" /* getDefaultState */])();

    var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__notifyManager__["a" /* notifyManager */].batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(__WEBPACK_IMPORTED_MODULE_4__subscribable__["a" /* Subscribable */]);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useQueryErrorResetBoundary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryErrorResetBoundary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldThrowError;
function shouldThrowError(suspense, _useErrorBoundary, error) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(error);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBaseQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryErrorResetBoundary__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(575);





function useBaseQuery(options, Observer) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();
  var errorResetBoundary = Object(__WEBPACK_IMPORTED_MODULE_2__QueryErrorResetBoundary__["b" /* useQueryErrorResetBoundary */])();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* shouldThrowError */])(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, result.error)) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePassword = validatePassword;
exports.validateEmail = validateEmail;
function validatePassword(entry) {
  return Boolean(entry) && entry.length >= 8;
}

function validateEmail(email) {
  return new RegExp('.+@.+').test(email);
}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrgInitials = getOrgInitials;
function getOrgInitials(organization) {
  var orgInitials = organization.name.match(/\b(\w)/g).join('');
  orgInitials = orgInitials.length > 2 ? orgInitials.substr(0, 2) : orgInitials;
  return orgInitials;
}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Facebook = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
var SDK_GLOBAL = 'FB';
var SDK_GLOBAL_READY = 'fbAsyncInit';
var MATCH_URL = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
var PLAYER_ID_PREFIX = 'facebook-player-';

var Facebook = /*#__PURE__*/function (_Component) {
  _inherits(Facebook, _Component);

  var _super = _createSuper(Facebook);

  function Facebook() {
    var _this;

    _classCallCheck(this, Facebook);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.facebook.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Facebook, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      if (isReady) {
        (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
          return FB.XFBML.parse();
        });
        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL, SDK_GLOBAL_READY).then(function (FB) {
        FB.init({
          appId: _this2.props.config.facebook.appId,
          xfbml: true,
          version: _this2.props.config.facebook.version
        });
        FB.Event.subscribe('xfbml.render', function (msg) {
          // Here we know the SDK has loaded, even if onReady/onPlay
          // is not called due to a video that cannot be embedded
          _this2.props.onLoaded();
        });
        FB.Event.subscribe('xfbml.ready', function (msg) {
          if (msg.type === 'video' && msg.id === _this2.playerID) {
            _this2.player = msg.instance;

            _this2.player.subscribe('startedPlaying', _this2.props.onPlay);

            _this2.player.subscribe('paused', _this2.props.onPause);

            _this2.player.subscribe('finishedPlaying', _this2.props.onEnded);

            _this2.player.subscribe('startedBuffering', _this2.props.onBuffer);

            _this2.player.subscribe('finishedBuffering', _this2.props.onBufferEnd);

            _this2.player.subscribe('error', _this2.props.onError);

            if (!_this2.props.muted) {
              // Player is muted by default
              _this2.callPlayer('unmute');
            }

            _this2.props.onReady(); // For some reason Facebook have added `visibility: hidden`
            // to the iframe when autoplay fails, so here we set it back


            document.getElementById(_this2.playerID).querySelector('iframe').style.visibility = 'visible';
          }
        });
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentPosition');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID,
        className: "fb-video",
        "data-href": this.props.url,
        "data-autoplay": this.props.playing ? 'true' : 'false',
        "data-allowfullscreen": "true",
        "data-controls": this.props.controls ? 'true' : 'false'
      });
    }
  }]);

  return Facebook;
}(_react.Component);

exports.Facebook = Facebook;

_defineProperty(Facebook, "displayName", 'Facebook');

_defineProperty(Facebook, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Facebook, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Facebook);

exports["default"] = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Streamable = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://cdn.embed.ly/player-0.1.0.min.js';
var SDK_GLOBAL = 'playerjs';
var MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;

var Streamable = /*#__PURE__*/function (_Component) {
  _inherits(Streamable, _Component);

  var _super = _createSuper(Streamable);

  function Streamable() {
    var _this;

    _classCallCheck(this, Streamable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Streamable, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (playerjs) {
        if (!_this2.iframe) return;
        _this2.player = new playerjs.Player(_this2.iframe);

        _this2.player.setLoop(_this2.props.loop);

        _this2.player.on('ready', _this2.props.onReady);

        _this2.player.on('play', _this2.props.onPlay);

        _this2.player.on('pause', _this2.props.onPause);

        _this2.player.on('seeked', _this2.props.onSeek);

        _this2.player.on('ended', _this2.props.onEnded);

        _this2.player.on('error', _this2.props.onError);

        _this2.player.on('timeupdate', function (_ref) {
          var duration = _ref.duration,
              seconds = _ref.seconds;
          _this2.duration = duration;
          _this2.currentTime = seconds;
        });

        _this2.player.on('buffered', function (_ref2) {
          var percent = _ref2.percent;

          if (_this2.duration) {
            _this2.secondsLoaded = _this2.duration * percent;
          }
        });

        if (_this2.props.muted) {
          _this2.player.mute();
        }
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('setCurrentTime', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction * 100);
    }
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      this.callPlayer('setLoop', loop);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return this.secondsLoaded;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("iframe", {
        ref: this.ref,
        src: "https://streamable.com/o/".concat(id),
        frameBorder: "0",
        scrolling: "no",
        style: style,
        allowFullScreen: true
      });
    }
  }]);

  return Streamable;
}(_react.Component);

exports.Streamable = Streamable;

_defineProperty(Streamable, "displayName", 'Streamable');

_defineProperty(Streamable, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

var _default = (0, _singlePlayer["default"])(Streamable);

exports["default"] = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Wistia = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
var SDK_GLOBAL = 'Wistia';
var MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia() {
    var _this;

    _classCallCheck(this, Wistia);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props;

      return (_this$props = _this.props).onPlay.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPause.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onSeek.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onEnded.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('mute');
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('unmute');
    });

    return _this;
  }

  _createClass(Wistia, [{
    key: "getID",
    value: function getID(url) {
      return url && url.match(MATCH_URL)[1];
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props5 = this.props,
          playing = _this$props5.playing,
          muted = _this$props5.muted,
          controls = _this$props5.controls,
          _onReady = _this$props5.onReady,
          config = _this$props5.config,
          onError = _this$props5.onError;
      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function () {
        window._wq = window._wq || [];

        window._wq.push({
          id: _this2.getID(url),
          options: _objectSpread({
            autoPlay: playing,
            silentAutoPlay: 'allow',
            muted: muted,
            controlsVisibleOnLoad: controls
          }, config.wistia.options),
          onReady: function onReady(player) {
            _this2.player = player;

            _this2.unbind();

            _this2.player.bind('play', _this2.onPlay);

            _this2.player.bind('pause', _this2.onPause);

            _this2.player.bind('seek', _this2.onSeek);

            _this2.player.bind('end', _this2.onEnded);

            _onReady();
          }
        });
      }, onError);
    }
  }, {
    key: "unbind",
    value: function unbind() {
      this.player.unbind('play', this.onPlay);
      this.player.unbind('pause', this.onPause);
      this.player.unbind('seek', this.onSeek);
      this.player.unbind('end', this.onEnded);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unbind();
      this.callPlayer('remove');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('time', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('volume', fraction);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.callPlayer('playbackRate', rate);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('duration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('time');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.getID(this.props.url);
      var className = "wistia_embed wistia_async_".concat(id);
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        className: className,
        style: style
      });
    }
  }]);

  return Wistia;
}(_react.Component);

exports.Wistia = Wistia;

_defineProperty(Wistia, "displayName", 'Wistia');

_defineProperty(Wistia, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Wistia, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Wistia);

exports["default"] = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Twitch = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://player.twitch.tv/js/embed/v1.js';
var SDK_GLOBAL = 'Twitch';
var MATCH_VIDEO_URL = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
var MATCH_CHANNEL_URL = /(?:www\.|go\.)?twitch\.tv\/([a-z0-9_]+)($|\?)/;
var PLAYER_ID_PREFIX = 'twitch-player-';

var Twitch = /*#__PURE__*/function (_Component) {
  _inherits(Twitch, _Component);

  var _super = _createSuper(Twitch);

  function Twitch() {
    var _this;

    _classCallCheck(this, Twitch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "playerID", _this.props.config.twitch.playerId || "".concat(PLAYER_ID_PREFIX).concat((0, _utils.randomString)()));

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.callPlayer('setMuted', true);
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.callPlayer('setMuted', false);
    });

    return _this;
  }

  _createClass(Twitch, [{
    key: "load",
    value: function load(url, isReady) {
      var _this2 = this;

      var _this$props = this.props,
          playsinline = _this$props.playsinline,
          onError = _this$props.onError,
          config = _this$props.config,
          controls = _this$props.controls;
      var isChannel = MATCH_CHANNEL_URL.test(url);
      var id = isChannel ? url.match(MATCH_CHANNEL_URL)[1] : url.match(MATCH_VIDEO_URL)[1];

      if (isReady) {
        if (isChannel) {
          this.player.setChannel(id);
        } else {
          this.player.setVideo('v' + id);
        }

        return;
      }

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Twitch) {
        _this2.player = new Twitch.Player(_this2.playerID, _objectSpread({
          video: isChannel ? '' : id,
          channel: isChannel ? id : '',
          height: '100%',
          width: '100%',
          playsinline: playsinline,
          autoplay: _this2.props.playing,
          muted: _this2.props.muted,
          // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
          controls: isChannel ? true : controls
        }, config.twitch.options));
        var _Twitch$Player = Twitch.Player,
            READY = _Twitch$Player.READY,
            PLAYING = _Twitch$Player.PLAYING,
            PAUSE = _Twitch$Player.PAUSE,
            ENDED = _Twitch$Player.ENDED,
            ONLINE = _Twitch$Player.ONLINE,
            OFFLINE = _Twitch$Player.OFFLINE;

        _this2.player.addEventListener(READY, _this2.props.onReady);

        _this2.player.addEventListener(PLAYING, _this2.props.onPlay);

        _this2.player.addEventListener(PAUSE, _this2.props.onPause);

        _this2.player.addEventListener(ENDED, _this2.props.onEnded); // Prevent weird isLoading behaviour when streams are offline


        _this2.player.addEventListener(ONLINE, _this2.props.onLoaded);

        _this2.player.addEventListener(OFFLINE, _this2.props.onLoaded);
      }, onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {
      this.callPlayer('pause');
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.callPlayer('setVolume', fraction);
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.callPlayer('getDuration');
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.callPlayer('getCurrentTime');
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var style = {
        width: '100%',
        height: '100%'
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        id: this.playerID
      });
    }
  }]);

  return Twitch;
}(_react.Component);

exports.Twitch = Twitch;

_defineProperty(Twitch, "displayName", 'Twitch');

_defineProperty(Twitch, "canPlay", function (url) {
  return MATCH_VIDEO_URL.test(url) || MATCH_CHANNEL_URL.test(url);
});

_defineProperty(Twitch, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Twitch);

exports["default"] = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Mixcloud = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
var SDK_GLOBAL = 'Mixcloud';
var MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;

var Mixcloud = /*#__PURE__*/function (_Component) {
  _inherits(Mixcloud, _Component);

  var _super = _createSuper(Mixcloud);

  function Mixcloud() {
    var _this;

    _classCallCheck(this, Mixcloud);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "callPlayer", _utils.callPlayer);

    _defineProperty(_assertThisInitialized(_this), "duration", null);

    _defineProperty(_assertThisInitialized(_this), "currentTime", null);

    _defineProperty(_assertThisInitialized(_this), "secondsLoaded", null);

    _defineProperty(_assertThisInitialized(_this), "mute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {// No volume support
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (iframe) {
      _this.iframe = iframe;
    });

    return _this;
  }

  _createClass(Mixcloud, [{
    key: "load",
    value: function load(url) {
      var _this2 = this;

      (0, _utils.getSDK)(SDK_URL, SDK_GLOBAL).then(function (Mixcloud) {
        _this2.player = Mixcloud.PlayerWidget(_this2.iframe);

        _this2.player.ready.then(function () {
          _this2.player.events.play.on(_this2.props.onPlay);

          _this2.player.events.pause.on(_this2.props.onPause);

          _this2.player.events.ended.on(_this2.props.onEnded);

          _this2.player.events.error.on(_this2.props.error);

          _this2.player.events.progress.on(function (seconds, duration) {
            _this2.currentTime = seconds;
            _this2.duration = duration;
          });

          _this2.props.onReady();
        });
      }, this.props.onError);
    }
  }, {
    key: "play",
    value: function play() {
      this.callPlayer('play');
    }
  }, {
    key: "pause",
    value: function pause() {
      this.callPlayer('pause');
    }
  }, {
    key: "stop",
    value: function stop() {// Nothing to do
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.callPlayer('seek', seconds);
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {// No volume support
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          config = _this$props.config;
      var id = url.match(MATCH_URL)[1];
      var style = {
        width: '100%',
        height: '100%'
      };
      var query = (0, _utils.queryString)(_objectSpread({}, config.mixcloud.options, {
        feed: "/".concat(id, "/")
      })); // We have to give the iframe a key here to prevent a
      // weird dialog appearing when loading a new track

      return /*#__PURE__*/_react["default"].createElement("iframe", {
        key: id,
        ref: this.ref,
        style: style,
        src: "https://www.mixcloud.com/widget/iframe/?".concat(query),
        frameBorder: "0"
      });
    }
  }]);

  return Mixcloud;
}(_react.Component);

exports.Mixcloud = Mixcloud;

_defineProperty(Mixcloud, "displayName", 'Mixcloud');

_defineProperty(Mixcloud, "canPlay", function (url) {
  return MATCH_URL.test(url);
});

_defineProperty(Mixcloud, "loopOnEnded", true);

var _default = (0, _singlePlayer["default"])(Mixcloud);

exports["default"] = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FilePlayer = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _utils = __webpack_require__(91);

var _singlePlayer = _interopRequireDefault(__webpack_require__(126));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var IOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var AUDIO_EXTENSIONS = /\.(m4a|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
var VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)($|\?)/i;
var HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
var HLS_SDK_URL = 'https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js';
var HLS_GLOBAL = 'Hls';
var DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
var DASH_SDK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js';
var DASH_GLOBAL = 'dashjs';
var MATCH_DROPBOX_URL = /www\.dropbox\.com\/.+/;

function canPlay(url) {
  if (url instanceof Array) {
    var _iterator = _createForOfIteratorHelper(url),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (typeof item === 'string' && canPlay(item)) {
          return true;
        }

        if (canPlay(item.src)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  }

  if ((0, _utils.isMediaStream)(url)) {
    return true;
  }

  return AUDIO_EXTENSIONS.test(url) || VIDEO_EXTENSIONS.test(url) || HLS_EXTENSIONS.test(url) || DASH_EXTENSIONS.test(url);
}

function supportsWebKitPresentationMode(video) {
  if (!video) video = document.createElement('video'); // Check if Safari supports PiP, and is not on mobile (other than iPad)
  // iPhone safari appears to "support" PiP through the check, however PiP does not function

  return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === 'function' && !/iPhone|iPod/.test(navigator.userAgent);
}

function canEnablePIP(url) {
  return canPlay(url) && (!!document.pictureInPictureEnabled || supportsWebKitPresentationMode()) && !AUDIO_EXTENSIONS.test(url);
}

var FilePlayer = /*#__PURE__*/function (_Component) {
  _inherits(FilePlayer, _Component);

  var _super = _createSuper(FilePlayer);

  function FilePlayer() {
    var _this;

    _classCallCheck(this, FilePlayer);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "onReady", function () {
      var _this$props;

      return (_this$props = _this.props).onReady.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlay", function () {
      var _this$props2;

      return (_this$props2 = _this.props).onPlay.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBuffer", function () {
      var _this$props3;

      return (_this$props3 = _this.props).onBuffer.apply(_this$props3, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onBufferEnd", function () {
      var _this$props4;

      return (_this$props4 = _this.props).onBufferEnd.apply(_this$props4, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onPause", function () {
      var _this$props5;

      return (_this$props5 = _this.props).onPause.apply(_this$props5, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnded", function () {
      var _this$props6;

      return (_this$props6 = _this.props).onEnded.apply(_this$props6, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      var _this$props7;

      return (_this$props7 = _this.props).onError.apply(_this$props7, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnablePIP", function () {
      var _this$props8;

      return (_this$props8 = _this.props).onEnablePIP.apply(_this$props8, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "onDisablePIP", function (e) {
      var _this$props9 = _this.props,
          onDisablePIP = _this$props9.onDisablePIP,
          playing = _this$props9.playing;
      onDisablePIP(e);

      if (playing) {
        _this.play();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPresentationModeChange", function (e) {
      if (_this.player && supportsWebKitPresentationMode(_this.player)) {
        var webkitPresentationMode = _this.player.webkitPresentationMode;

        if (webkitPresentationMode === 'picture-in-picture') {
          _this.onEnablePIP(e);
        } else if (webkitPresentationMode === 'inline') {
          _this.onDisablePIP(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSeek", function (e) {
      _this.props.onSeek(e.target.currentTime);
    });

    _defineProperty(_assertThisInitialized(_this), "mute", function () {
      _this.player.muted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "unmute", function () {
      _this.player.muted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSourceElement", function (source, index) {
      if (typeof source === 'string') {
        return /*#__PURE__*/_react["default"].createElement("source", {
          key: index,
          src: source
        });
      }

      return /*#__PURE__*/_react["default"].createElement("source", _extends({
        key: index
      }, source));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrack", function (track, index) {
      return /*#__PURE__*/_react["default"].createElement("track", _extends({
        key: index
      }, track));
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (player) {
      if (_this.player) {
        // Store previous player to be used by removeListeners()
        _this.prevPlayer = _this.player;
      }

      _this.player = player;
    });

    return _this;
  }

  _createClass(FilePlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addListeners(this.player);

      if (IOS) {
        this.player.load();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUseAudio(this.props) !== this.shouldUseAudio(prevProps)) {
        this.removeListeners(this.prevPlayer);
        this.addListeners(this.player);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners(this.player);

      if (this.hls) {
        this.hls.destroy();
      }
    }
  }, {
    key: "addListeners",
    value: function addListeners(player) {
      var playsinline = this.props.playsinline;
      player.addEventListener('canplay', this.onReady);
      player.addEventListener('play', this.onPlay);
      player.addEventListener('waiting', this.onBuffer);
      player.addEventListener('playing', this.onBufferEnd);
      player.addEventListener('pause', this.onPause);
      player.addEventListener('seeked', this.onSeek);
      player.addEventListener('ended', this.onEnded);
      player.addEventListener('error', this.onError);
      player.addEventListener('enterpictureinpicture', this.onEnablePIP);
      player.addEventListener('leavepictureinpicture', this.onDisablePIP);
      player.addEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);

      if (playsinline) {
        player.setAttribute('playsinline', '');
        player.setAttribute('webkit-playsinline', '');
        player.setAttribute('x5-playsinline', '');
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners(player) {
      player.removeEventListener('canplay', this.onReady);
      player.removeEventListener('play', this.onPlay);
      player.removeEventListener('waiting', this.onBuffer);
      player.removeEventListener('playing', this.onBufferEnd);
      player.removeEventListener('pause', this.onPause);
      player.removeEventListener('seeked', this.onSeek);
      player.removeEventListener('ended', this.onEnded);
      player.removeEventListener('error', this.onError);
      player.removeEventListener('enterpictureinpicture', this.onEnablePIP);
      player.removeEventListener('leavepictureinpicture', this.onDisablePIP);
      player.removeEventListener('webkitpresentationmodechanged', this.onPresentationModeChange);
    } // Proxy methods to prevent listener leaks

  }, {
    key: "shouldUseAudio",
    value: function shouldUseAudio(props) {
      if (props.config.file.forceVideo) {
        return false;
      }

      if (props.config.file.attributes.poster) {
        return false; // Use <video> so that poster is shown
      }

      return AUDIO_EXTENSIONS.test(props.url) || props.config.file.forceAudio;
    }
  }, {
    key: "shouldUseHLS",
    value: function shouldUseHLS(url) {
      return HLS_EXTENSIONS.test(url) && !IOS || this.props.config.file.forceHLS;
    }
  }, {
    key: "shouldUseDASH",
    value: function shouldUseDASH(url) {
      return DASH_EXTENSIONS.test(url) || this.props.config.file.forceDASH;
    }
  }, {
    key: "load",
    value: function load(url) {
      var _this2 = this;

      var _this$props$config$fi = this.props.config.file,
          hlsVersion = _this$props$config$fi.hlsVersion,
          dashVersion = _this$props$config$fi.dashVersion;

      if (this.shouldUseHLS(url)) {
        (0, _utils.getSDK)(HLS_SDK_URL.replace('VERSION', hlsVersion), HLS_GLOBAL).then(function (Hls) {
          _this2.hls = new Hls(_this2.props.config.file.hlsOptions);

          _this2.hls.on(Hls.Events.ERROR, function (e, data) {
            _this2.props.onError(e, data, _this2.hls, Hls);
          });

          _this2.hls.loadSource(url);

          _this2.hls.attachMedia(_this2.player);
        });
      }

      if (this.shouldUseDASH(url)) {
        (0, _utils.getSDK)(DASH_SDK_URL.replace('VERSION', dashVersion), DASH_GLOBAL).then(function (dashjs) {
          _this2.dash = dashjs.MediaPlayer().create();

          _this2.dash.initialize(_this2.player, url, _this2.props.playing);

          _this2.dash.on('error', _this2.props.onError);

          _this2.dash.getDebug().setLogToBrowserConsole(false);
        });
      }

      if (url instanceof Array) {
        // When setting new urls (<source>) on an already loaded video,
        // HTMLMediaElement.load() is needed to reset the media element
        // and restart the media resource. Just replacing children source
        // dom nodes is not enough
        this.player.load();
      } else if ((0, _utils.isMediaStream)(url)) {
        try {
          this.player.srcObject = url;
        } catch (e) {
          this.player.src = window.URL.createObjectURL(url);
        }
      }
    }
  }, {
    key: "play",
    value: function play() {
      var promise = this.player.play();

      if (promise) {
        promise["catch"](this.props.onError);
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.player.removeAttribute('src');

      if (this.dash) {
        this.dash.reset();
      }
    }
  }, {
    key: "seekTo",
    value: function seekTo(seconds) {
      this.player.currentTime = seconds;
    }
  }, {
    key: "setVolume",
    value: function setVolume(fraction) {
      this.player.volume = fraction;
    }
  }, {
    key: "enablePIP",
    value: function enablePIP() {
      if (this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player) {
        this.player.requestPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'picture-in-picture') {
        this.player.webkitSetPresentationMode('picture-in-picture');
      }
    }
  }, {
    key: "disablePIP",
    value: function disablePIP() {
      if (document.exitPictureInPicture && document.pictureInPictureElement === this.player) {
        document.exitPictureInPicture();
      } else if (supportsWebKitPresentationMode(this.player) && this.player.webkitPresentationMode !== 'inline') {
        this.player.webkitSetPresentationMode('inline');
      }
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(rate) {
      this.player.playbackRate = rate;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      if (!this.player) return null;
      var _this$player = this.player,
          duration = _this$player.duration,
          seekable = _this$player.seekable; // on iOS, live streams return Infinity for the duration
      // so instead we use the end of the seekable timerange

      if (duration === Infinity && seekable.length > 0) {
        return seekable.end(seekable.length - 1);
      }

      return duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      if (!this.player) return null;
      return this.player.currentTime;
    }
  }, {
    key: "getSecondsLoaded",
    value: function getSecondsLoaded() {
      if (!this.player) return null;
      var buffered = this.player.buffered;

      if (buffered.length === 0) {
        return 0;
      }

      var end = buffered.end(buffered.length - 1);
      var duration = this.getDuration();

      if (end > duration) {
        return duration;
      }

      return end;
    }
  }, {
    key: "getSource",
    value: function getSource(url) {
      var useHLS = this.shouldUseHLS(url);
      var useDASH = this.shouldUseDASH(url);

      if (url instanceof Array || (0, _utils.isMediaStream)(url) || useHLS || useDASH) {
        return undefined;
      }

      if (MATCH_DROPBOX_URL.test(url)) {
        return url.replace('www.dropbox.com', 'dl.dropboxusercontent.com');
      }

      return url;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          url = _this$props10.url,
          playing = _this$props10.playing,
          loop = _this$props10.loop,
          controls = _this$props10.controls,
          muted = _this$props10.muted,
          config = _this$props10.config,
          width = _this$props10.width,
          height = _this$props10.height;
      var useAudio = this.shouldUseAudio(this.props);
      var Element = useAudio ? 'audio' : 'video';
      var style = {
        width: width === 'auto' ? width : '100%',
        height: height === 'auto' ? height : '100%'
      };
      return /*#__PURE__*/_react["default"].createElement(Element, _extends({
        ref: this.ref,
        src: this.getSource(url),
        style: style,
        preload: "auto",
        autoPlay: playing || undefined,
        controls: controls,
        muted: muted,
        loop: loop
      }, config.file.attributes), url instanceof Array && url.map(this.renderSourceElement), config.file.tracks.map(this.renderTrack));
    }
  }]);

  return FilePlayer;
}(_react.Component);

exports.FilePlayer = FilePlayer;

_defineProperty(FilePlayer, "displayName", 'FilePlayer');

_defineProperty(FilePlayer, "canPlay", canPlay);

_defineProperty(FilePlayer, "canEnablePIP", canEnablePIP);

var _default = (0, _singlePlayer["default"])(FilePlayer);

exports["default"] = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: ', 'px;\n  width: ', 'px;\n'], ['\n  background-repeat: no-repeat;\n  background-size: 100%;\n  height: ', 'px;\n  width: ', 'px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n'], ['\n  background-image: url(', ');\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon_design = __webpack_require__(1180);

var _icon_design2 = _interopRequireDefault(_icon_design);

var _icon_discovery = __webpack_require__(1181);

var _icon_discovery2 = _interopRequireDefault(_icon_discovery);

var _icon_practice = __webpack_require__(1182);

var _icon_practice2 = _interopRequireDefault(_icon_practice);

var _icon_reflection = __webpack_require__(1183);

var _icon_reflection2 = _interopRequireDefault(_icon_reflection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeIcon = _styledComponents2.default.div.withConfig({
  displayName: 'QuestTypeIcon__TypeIcon',
  componentId: 'tm9qxu-0'
})(_templateObject, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

var DesignTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'QuestTypeIcon__DesignTypeIcon',
  componentId: 'tm9qxu-1'
})(_templateObject2, _icon_design2.default);

var DiscoveryTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'QuestTypeIcon__DiscoveryTypeIcon',
  componentId: 'tm9qxu-2'
})(_templateObject2, _icon_discovery2.default);

var PracticeTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'QuestTypeIcon__PracticeTypeIcon',
  componentId: 'tm9qxu-3'
})(_templateObject2, _icon_practice2.default);

var ReflectionTypeIcon = (0, _styledComponents2.default)(TypeIcon).withConfig({
  displayName: 'QuestTypeIcon__ReflectionTypeIcon',
  componentId: 'tm9qxu-4'
})(_templateObject2, _icon_reflection2.default);

var QuestTypeIcon = function QuestTypeIcon(props) {
  var icon = null;
  switch (props.id) {
    case 1:
      {
        icon = _react2.default.createElement(DiscoveryTypeIcon, props);
        break;
      }
    case 2:
      {
        icon = _react2.default.createElement(PracticeTypeIcon, props);
        break;
      }
    case 3:
      {
        icon = _react2.default.createElement(DesignTypeIcon, props);
        break;
      }
    case 4:
      {
        icon = _react2.default.createElement(ReflectionTypeIcon, props);
        break;
      }
  }
  return _react2.default.createElement(
    'span',
    { className: 'quest-type-icon' },
    icon
  );
};

QuestTypeIcon.defaultProps = {
  size: 25
};

QuestTypeIcon.propTypes = {
  id: _propTypes2.default.number.isRequired,
  size: _propTypes2.default.number
};

exports.default = QuestTypeIcon;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(590);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(76);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113), __webpack_require__(593), __webpack_require__(1204));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror", "../xml/xml", "../meta"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("markdown", function(cmCfg, modeCfg) {

  var htmlMode = CodeMirror.getMode(cmCfg, "text/html");
  var htmlModeMissing = htmlMode.name == "null"

  function getMode(name) {
    if (CodeMirror.findModeByName) {
      var found = CodeMirror.findModeByName(name);
      if (found) name = found.mime || found.mimes[0];
    }
    var mode = CodeMirror.getMode(cmCfg, name);
    return mode.name == "null" ? null : mode;
  }

  // Should characters that affect highlighting be highlighted separate?
  // Does not include characters that will be output (such as `1.` and `-` for lists)
  if (modeCfg.highlightFormatting === undefined)
    modeCfg.highlightFormatting = false;

  // Maximum number of nested blockquotes. Set to 0 for infinite nesting.
  // Excess `>` will emit `error` token.
  if (modeCfg.maxBlockquoteDepth === undefined)
    modeCfg.maxBlockquoteDepth = 0;

  // Turn on task lists? ("- [ ] " and "- [x] ")
  if (modeCfg.taskLists === undefined) modeCfg.taskLists = false;

  // Turn on strikethrough syntax
  if (modeCfg.strikethrough === undefined)
    modeCfg.strikethrough = false;

  if (modeCfg.emoji === undefined)
    modeCfg.emoji = false;

  if (modeCfg.fencedCodeBlockHighlighting === undefined)
    modeCfg.fencedCodeBlockHighlighting = true;

  if (modeCfg.fencedCodeBlockDefaultMode === undefined)
    modeCfg.fencedCodeBlockDefaultMode = 'text/plain';

  if (modeCfg.xml === undefined)
    modeCfg.xml = true;

  // Allow token types to be overridden by user-provided token types.
  if (modeCfg.tokenTypeOverrides === undefined)
    modeCfg.tokenTypeOverrides = {};

  var tokenTypes = {
    header: "header",
    code: "comment",
    quote: "quote",
    list1: "variable-2",
    list2: "variable-3",
    list3: "keyword",
    hr: "hr",
    image: "image",
    imageAltText: "image-alt-text",
    imageMarker: "image-marker",
    formatting: "formatting",
    linkInline: "link",
    linkEmail: "link",
    linkText: "link",
    linkHref: "string",
    em: "em",
    strong: "strong",
    strikethrough: "strikethrough",
    emoji: "builtin"
  };

  for (var tokenType in tokenTypes) {
    if (tokenTypes.hasOwnProperty(tokenType) && modeCfg.tokenTypeOverrides[tokenType]) {
      tokenTypes[tokenType] = modeCfg.tokenTypeOverrides[tokenType];
    }
  }

  var hrRE = /^([*\-_])(?:\s*\1){2,}\s*$/
  ,   listRE = /^(?:[*\-+]|^[0-9]+([.)]))\s+/
  ,   taskListRE = /^\[(x| )\](?=\s)/i // Must follow listRE
  ,   atxHeaderRE = modeCfg.allowAtxHeaderWithoutSpace ? /^(#+)/ : /^(#+)(?: |$)/
  ,   setextHeaderRE = /^ {0,3}(?:\={1,}|-{2,})\s*$/
  ,   textRE = /^[^#!\[\]*_\\<>` "'(~:]+/
  ,   fencedCodeRE = /^(~~~+|```+)[ \t]*([\w\/+#-]*)[^\n`]*$/
  ,   linkDefRE = /^\s*\[[^\]]+?\]:.*$/ // naive link-definition
  ,   punctuation = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E42\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDF3C-\uDF3E]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]/
  ,   expandedTab = "    " // CommonMark specifies tab as 4 spaces

  function switchInline(stream, state, f) {
    state.f = state.inline = f;
    return f(stream, state);
  }

  function switchBlock(stream, state, f) {
    state.f = state.block = f;
    return f(stream, state);
  }

  function lineIsEmpty(line) {
    return !line || !/\S/.test(line.string)
  }

  // Blocks

  function blankLine(state) {
    // Reset linkTitle state
    state.linkTitle = false;
    state.linkHref = false;
    state.linkText = false;
    // Reset EM state
    state.em = false;
    // Reset STRONG state
    state.strong = false;
    // Reset strikethrough state
    state.strikethrough = false;
    // Reset state.quote
    state.quote = 0;
    // Reset state.indentedCode
    state.indentedCode = false;
    if (state.f == htmlBlock) {
      var exit = htmlModeMissing
      if (!exit) {
        var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
        exit = inner.mode.name == "xml" && inner.state.tagStart === null &&
          (!inner.state.context && inner.state.tokenize.isInText)
      }
      if (exit) {
        state.f = inlineNormal;
        state.block = blockNormal;
        state.htmlState = null;
      }
    }
    // Reset state.trailingSpace
    state.trailingSpace = 0;
    state.trailingSpaceNewLine = false;
    // Mark this line as blank
    state.prevLine = state.thisLine
    state.thisLine = {stream: null}
    return null;
  }

  function blockNormal(stream, state) {
    var firstTokenOnLine = stream.column() === state.indentation;
    var prevLineLineIsEmpty = lineIsEmpty(state.prevLine.stream);
    var prevLineIsIndentedCode = state.indentedCode;
    var prevLineIsHr = state.prevLine.hr;
    var prevLineIsList = state.list !== false;
    var maxNonCodeIndentation = (state.listStack[state.listStack.length - 1] || 0) + 3;

    state.indentedCode = false;

    var lineIndentation = state.indentation;
    // compute once per line (on first token)
    if (state.indentationDiff === null) {
      state.indentationDiff = state.indentation;
      if (prevLineIsList) {
        state.list = null;
        // While this list item's marker's indentation is less than the deepest
        //  list item's content's indentation,pop the deepest list item
        //  indentation off the stack, and update block indentation state
        while (lineIndentation < state.listStack[state.listStack.length - 1]) {
          state.listStack.pop();
          if (state.listStack.length) {
            state.indentation = state.listStack[state.listStack.length - 1];
          // less than the first list's indent -> the line is no longer a list
          } else {
            state.list = false;
          }
        }
        if (state.list !== false) {
          state.indentationDiff = lineIndentation - state.listStack[state.listStack.length - 1]
        }
      }
    }

    // not comprehensive (currently only for setext detection purposes)
    var allowsInlineContinuation = (
        !prevLineLineIsEmpty && !prevLineIsHr && !state.prevLine.header &&
        (!prevLineIsList || !prevLineIsIndentedCode) &&
        !state.prevLine.fencedCodeEnd
    );

    var isHr = (state.list === false || prevLineIsHr || prevLineLineIsEmpty) &&
      state.indentation <= maxNonCodeIndentation && stream.match(hrRE);

    var match = null;
    if (state.indentationDiff >= 4 && (prevLineIsIndentedCode || state.prevLine.fencedCodeEnd ||
         state.prevLine.header || prevLineLineIsEmpty)) {
      stream.skipToEnd();
      state.indentedCode = true;
      return tokenTypes.code;
    } else if (stream.eatSpace()) {
      return null;
    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(atxHeaderRE)) && match[1].length <= 6) {
      state.quote = 0;
      state.header = match[1].length;
      state.thisLine.header = true;
      if (modeCfg.highlightFormatting) state.formatting = "header";
      state.f = state.inline;
      return getType(state);
    } else if (state.indentation <= maxNonCodeIndentation && stream.eat('>')) {
      state.quote = firstTokenOnLine ? 1 : state.quote + 1;
      if (modeCfg.highlightFormatting) state.formatting = "quote";
      stream.eatSpace();
      return getType(state);
    } else if (!isHr && !state.setext && firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(listRE))) {
      var listType = match[1] ? "ol" : "ul";

      state.indentation = lineIndentation + stream.current().length;
      state.list = true;
      state.quote = 0;

      // Add this list item's content's indentation to the stack
      state.listStack.push(state.indentation);
      // Reset inline styles which shouldn't propagate across list items
      state.em = false;
      state.strong = false;
      state.code = false;
      state.strikethrough = false;

      if (modeCfg.taskLists && stream.match(taskListRE, false)) {
        state.taskList = true;
      }
      state.f = state.inline;
      if (modeCfg.highlightFormatting) state.formatting = ["list", "list-" + listType];
      return getType(state);
    } else if (firstTokenOnLine && state.indentation <= maxNonCodeIndentation && (match = stream.match(fencedCodeRE, true))) {
      state.quote = 0;
      state.fencedEndRE = new RegExp(match[1] + "+ *$");
      // try switching mode
      state.localMode = modeCfg.fencedCodeBlockHighlighting && getMode(match[2] || modeCfg.fencedCodeBlockDefaultMode );
      if (state.localMode) state.localState = CodeMirror.startState(state.localMode);
      state.f = state.block = local;
      if (modeCfg.highlightFormatting) state.formatting = "code-block";
      state.code = -1
      return getType(state);
    // SETEXT has lowest block-scope precedence after HR, so check it after
    //  the others (code, blockquote, list...)
    } else if (
      // if setext set, indicates line after ---/===
      state.setext || (
        // line before ---/===
        (!allowsInlineContinuation || !prevLineIsList) && !state.quote && state.list === false &&
        !state.code && !isHr && !linkDefRE.test(stream.string) &&
        (match = stream.lookAhead(1)) && (match = match.match(setextHeaderRE))
      )
    ) {
      if ( !state.setext ) {
        state.header = match[0].charAt(0) == '=' ? 1 : 2;
        state.setext = state.header;
      } else {
        state.header = state.setext;
        // has no effect on type so we can reset it now
        state.setext = 0;
        stream.skipToEnd();
        if (modeCfg.highlightFormatting) state.formatting = "header";
      }
      state.thisLine.header = true;
      state.f = state.inline;
      return getType(state);
    } else if (isHr) {
      stream.skipToEnd();
      state.hr = true;
      state.thisLine.hr = true;
      return tokenTypes.hr;
    } else if (stream.peek() === '[') {
      return switchInline(stream, state, footnoteLink);
    }

    return switchInline(stream, state, state.inline);
  }

  function htmlBlock(stream, state) {
    var style = htmlMode.token(stream, state.htmlState);
    if (!htmlModeMissing) {
      var inner = CodeMirror.innerMode(htmlMode, state.htmlState)
      if ((inner.mode.name == "xml" && inner.state.tagStart === null &&
           (!inner.state.context && inner.state.tokenize.isInText)) ||
          (state.md_inside && stream.current().indexOf(">") > -1)) {
        state.f = inlineNormal;
        state.block = blockNormal;
        state.htmlState = null;
      }
    }
    return style;
  }

  function local(stream, state) {
    var currListInd = state.listStack[state.listStack.length - 1] || 0;
    var hasExitedList = state.indentation < currListInd;
    var maxFencedEndInd = currListInd + 3;
    if (state.fencedEndRE && state.indentation <= maxFencedEndInd && (hasExitedList || stream.match(state.fencedEndRE))) {
      if (modeCfg.highlightFormatting) state.formatting = "code-block";
      var returnType;
      if (!hasExitedList) returnType = getType(state)
      state.localMode = state.localState = null;
      state.block = blockNormal;
      state.f = inlineNormal;
      state.fencedEndRE = null;
      state.code = 0
      state.thisLine.fencedCodeEnd = true;
      if (hasExitedList) return switchBlock(stream, state, state.block);
      return returnType;
    } else if (state.localMode) {
      return state.localMode.token(stream, state.localState);
    } else {
      stream.skipToEnd();
      return tokenTypes.code;
    }
  }

  // Inline
  function getType(state) {
    var styles = [];

    if (state.formatting) {
      styles.push(tokenTypes.formatting);

      if (typeof state.formatting === "string") state.formatting = [state.formatting];

      for (var i = 0; i < state.formatting.length; i++) {
        styles.push(tokenTypes.formatting + "-" + state.formatting[i]);

        if (state.formatting[i] === "header") {
          styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.header);
        }

        // Add `formatting-quote` and `formatting-quote-#` for blockquotes
        // Add `error` instead if the maximum blockquote nesting depth is passed
        if (state.formatting[i] === "quote") {
          if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
            styles.push(tokenTypes.formatting + "-" + state.formatting[i] + "-" + state.quote);
          } else {
            styles.push("error");
          }
        }
      }
    }

    if (state.taskOpen) {
      styles.push("meta");
      return styles.length ? styles.join(' ') : null;
    }
    if (state.taskClosed) {
      styles.push("property");
      return styles.length ? styles.join(' ') : null;
    }

    if (state.linkHref) {
      styles.push(tokenTypes.linkHref, "url");
    } else { // Only apply inline styles to non-url text
      if (state.strong) { styles.push(tokenTypes.strong); }
      if (state.em) { styles.push(tokenTypes.em); }
      if (state.strikethrough) { styles.push(tokenTypes.strikethrough); }
      if (state.emoji) { styles.push(tokenTypes.emoji); }
      if (state.linkText) { styles.push(tokenTypes.linkText); }
      if (state.code) { styles.push(tokenTypes.code); }
      if (state.image) { styles.push(tokenTypes.image); }
      if (state.imageAltText) { styles.push(tokenTypes.imageAltText, "link"); }
      if (state.imageMarker) { styles.push(tokenTypes.imageMarker); }
    }

    if (state.header) { styles.push(tokenTypes.header, tokenTypes.header + "-" + state.header); }

    if (state.quote) {
      styles.push(tokenTypes.quote);

      // Add `quote-#` where the maximum for `#` is modeCfg.maxBlockquoteDepth
      if (!modeCfg.maxBlockquoteDepth || modeCfg.maxBlockquoteDepth >= state.quote) {
        styles.push(tokenTypes.quote + "-" + state.quote);
      } else {
        styles.push(tokenTypes.quote + "-" + modeCfg.maxBlockquoteDepth);
      }
    }

    if (state.list !== false) {
      var listMod = (state.listStack.length - 1) % 3;
      if (!listMod) {
        styles.push(tokenTypes.list1);
      } else if (listMod === 1) {
        styles.push(tokenTypes.list2);
      } else {
        styles.push(tokenTypes.list3);
      }
    }

    if (state.trailingSpaceNewLine) {
      styles.push("trailing-space-new-line");
    } else if (state.trailingSpace) {
      styles.push("trailing-space-" + (state.trailingSpace % 2 ? "a" : "b"));
    }

    return styles.length ? styles.join(' ') : null;
  }

  function handleText(stream, state) {
    if (stream.match(textRE, true)) {
      return getType(state);
    }
    return undefined;
  }

  function inlineNormal(stream, state) {
    var style = state.text(stream, state);
    if (typeof style !== 'undefined')
      return style;

    if (state.list) { // List marker (*, +, -, 1., etc)
      state.list = null;
      return getType(state);
    }

    if (state.taskList) {
      var taskOpen = stream.match(taskListRE, true)[1] === " ";
      if (taskOpen) state.taskOpen = true;
      else state.taskClosed = true;
      if (modeCfg.highlightFormatting) state.formatting = "task";
      state.taskList = false;
      return getType(state);
    }

    state.taskOpen = false;
    state.taskClosed = false;

    if (state.header && stream.match(/^#+$/, true)) {
      if (modeCfg.highlightFormatting) state.formatting = "header";
      return getType(state);
    }

    var ch = stream.next();

    // Matches link titles present on next line
    if (state.linkTitle) {
      state.linkTitle = false;
      var matchCh = ch;
      if (ch === '(') {
        matchCh = ')';
      }
      matchCh = (matchCh+'').replace(/([.?*+^\[\]\\(){}|-])/g, "\\$1");
      var regex = '^\\s*(?:[^' + matchCh + '\\\\]+|\\\\\\\\|\\\\.)' + matchCh;
      if (stream.match(new RegExp(regex), true)) {
        return tokenTypes.linkHref;
      }
    }

    // If this block is changed, it may need to be updated in GFM mode
    if (ch === '`') {
      var previousFormatting = state.formatting;
      if (modeCfg.highlightFormatting) state.formatting = "code";
      stream.eatWhile('`');
      var count = stream.current().length
      if (state.code == 0 && (!state.quote || count == 1)) {
        state.code = count
        return getType(state)
      } else if (count == state.code) { // Must be exact
        var t = getType(state)
        state.code = 0
        return t
      } else {
        state.formatting = previousFormatting
        return getType(state)
      }
    } else if (state.code) {
      return getType(state);
    }

    if (ch === '\\') {
      stream.next();
      if (modeCfg.highlightFormatting) {
        var type = getType(state);
        var formattingEscape = tokenTypes.formatting + "-escape";
        return type ? type + " " + formattingEscape : formattingEscape;
      }
    }

    if (ch === '!' && stream.match(/\[[^\]]*\] ?(?:\(|\[)/, false)) {
      state.imageMarker = true;
      state.image = true;
      if (modeCfg.highlightFormatting) state.formatting = "image";
      return getType(state);
    }

    if (ch === '[' && state.imageMarker && stream.match(/[^\]]*\](\(.*?\)| ?\[.*?\])/, false)) {
      state.imageMarker = false;
      state.imageAltText = true
      if (modeCfg.highlightFormatting) state.formatting = "image";
      return getType(state);
    }

    if (ch === ']' && state.imageAltText) {
      if (modeCfg.highlightFormatting) state.formatting = "image";
      var type = getType(state);
      state.imageAltText = false;
      state.image = false;
      state.inline = state.f = linkHref;
      return type;
    }

    if (ch === '[' && !state.image) {
      if (state.linkText && stream.match(/^.*?\]/)) return getType(state)
      state.linkText = true;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      return getType(state);
    }

    if (ch === ']' && state.linkText) {
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      state.linkText = false;
      state.inline = state.f = stream.match(/\(.*?\)| ?\[.*?\]/, false) ? linkHref : inlineNormal
      return type;
    }

    if (ch === '<' && stream.match(/^(https?|ftps?):\/\/(?:[^\\>]|\\.)+>/, false)) {
      state.f = state.inline = linkInline;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkInline;
    }

    if (ch === '<' && stream.match(/^[^> \\]+@(?:[^\\>]|\\.)+>/, false)) {
      state.f = state.inline = linkInline;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkEmail;
    }

    if (modeCfg.xml && ch === '<' && stream.match(/^(!--|\?|!\[CDATA\[|[a-z][a-z0-9-]*(?:\s+[a-z_:.\-]+(?:\s*=\s*[^>]+)?)*\s*(?:>|$))/i, false)) {
      var end = stream.string.indexOf(">", stream.pos);
      if (end != -1) {
        var atts = stream.string.substring(stream.start, end);
        if (/markdown\s*=\s*('|"){0,1}1('|"){0,1}/.test(atts)) state.md_inside = true;
      }
      stream.backUp(1);
      state.htmlState = CodeMirror.startState(htmlMode);
      return switchBlock(stream, state, htmlBlock);
    }

    if (modeCfg.xml && ch === '<' && stream.match(/^\/\w*?>/)) {
      state.md_inside = false;
      return "tag";
    } else if (ch === "*" || ch === "_") {
      var len = 1, before = stream.pos == 1 ? " " : stream.string.charAt(stream.pos - 2)
      while (len < 3 && stream.eat(ch)) len++
      var after = stream.peek() || " "
      // See http://spec.commonmark.org/0.27/#emphasis-and-strong-emphasis
      var leftFlanking = !/\s/.test(after) && (!punctuation.test(after) || /\s/.test(before) || punctuation.test(before))
      var rightFlanking = !/\s/.test(before) && (!punctuation.test(before) || /\s/.test(after) || punctuation.test(after))
      var setEm = null, setStrong = null
      if (len % 2) { // Em
        if (!state.em && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
          setEm = true
        else if (state.em == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
          setEm = false
      }
      if (len > 1) { // Strong
        if (!state.strong && leftFlanking && (ch === "*" || !rightFlanking || punctuation.test(before)))
          setStrong = true
        else if (state.strong == ch && rightFlanking && (ch === "*" || !leftFlanking || punctuation.test(after)))
          setStrong = false
      }
      if (setStrong != null || setEm != null) {
        if (modeCfg.highlightFormatting) state.formatting = setEm == null ? "strong" : setStrong == null ? "em" : "strong em"
        if (setEm === true) state.em = ch
        if (setStrong === true) state.strong = ch
        var t = getType(state)
        if (setEm === false) state.em = false
        if (setStrong === false) state.strong = false
        return t
      }
    } else if (ch === ' ') {
      if (stream.eat('*') || stream.eat('_')) { // Probably surrounded by spaces
        if (stream.peek() === ' ') { // Surrounded by spaces, ignore
          return getType(state);
        } else { // Not surrounded by spaces, back up pointer
          stream.backUp(1);
        }
      }
    }

    if (modeCfg.strikethrough) {
      if (ch === '~' && stream.eatWhile(ch)) {
        if (state.strikethrough) {// Remove strikethrough
          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
          var t = getType(state);
          state.strikethrough = false;
          return t;
        } else if (stream.match(/^[^\s]/, false)) {// Add strikethrough
          state.strikethrough = true;
          if (modeCfg.highlightFormatting) state.formatting = "strikethrough";
          return getType(state);
        }
      } else if (ch === ' ') {
        if (stream.match('~~', true)) { // Probably surrounded by space
          if (stream.peek() === ' ') { // Surrounded by spaces, ignore
            return getType(state);
          } else { // Not surrounded by spaces, back up pointer
            stream.backUp(2);
          }
        }
      }
    }

    if (modeCfg.emoji && ch === ":" && stream.match(/^(?:[a-z_\d+][a-z_\d+-]*|\-[a-z_\d+][a-z_\d+-]*):/)) {
      state.emoji = true;
      if (modeCfg.highlightFormatting) state.formatting = "emoji";
      var retType = getType(state);
      state.emoji = false;
      return retType;
    }

    if (ch === ' ') {
      if (stream.match(/^ +$/, false)) {
        state.trailingSpace++;
      } else if (state.trailingSpace) {
        state.trailingSpaceNewLine = true;
      }
    }

    return getType(state);
  }

  function linkInline(stream, state) {
    var ch = stream.next();

    if (ch === ">") {
      state.f = state.inline = inlineNormal;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var type = getType(state);
      if (type){
        type += " ";
      } else {
        type = "";
      }
      return type + tokenTypes.linkInline;
    }

    stream.match(/^[^>]+/, true);

    return tokenTypes.linkInline;
  }

  function linkHref(stream, state) {
    // Check if space, and return NULL if so (to avoid marking the space)
    if(stream.eatSpace()){
      return null;
    }
    var ch = stream.next();
    if (ch === '(' || ch === '[') {
      state.f = state.inline = getLinkHrefInside(ch === "(" ? ")" : "]");
      if (modeCfg.highlightFormatting) state.formatting = "link-string";
      state.linkHref = true;
      return getType(state);
    }
    return 'error';
  }

  var linkRE = {
    ")": /^(?:[^\\\(\)]|\\.|\((?:[^\\\(\)]|\\.)*\))*?(?=\))/,
    "]": /^(?:[^\\\[\]]|\\.|\[(?:[^\\\[\]]|\\.)*\])*?(?=\])/
  }

  function getLinkHrefInside(endChar) {
    return function(stream, state) {
      var ch = stream.next();

      if (ch === endChar) {
        state.f = state.inline = inlineNormal;
        if (modeCfg.highlightFormatting) state.formatting = "link-string";
        var returnState = getType(state);
        state.linkHref = false;
        return returnState;
      }

      stream.match(linkRE[endChar])
      state.linkHref = true;
      return getType(state);
    };
  }

  function footnoteLink(stream, state) {
    if (stream.match(/^([^\]\\]|\\.)*\]:/, false)) {
      state.f = footnoteLinkInside;
      stream.next(); // Consume [
      if (modeCfg.highlightFormatting) state.formatting = "link";
      state.linkText = true;
      return getType(state);
    }
    return switchInline(stream, state, inlineNormal);
  }

  function footnoteLinkInside(stream, state) {
    if (stream.match(']:', true)) {
      state.f = state.inline = footnoteUrl;
      if (modeCfg.highlightFormatting) state.formatting = "link";
      var returnType = getType(state);
      state.linkText = false;
      return returnType;
    }

    stream.match(/^([^\]\\]|\\.)+/, true);

    return tokenTypes.linkText;
  }

  function footnoteUrl(stream, state) {
    // Check if space, and return NULL if so (to avoid marking the space)
    if(stream.eatSpace()){
      return null;
    }
    // Match URL
    stream.match(/^[^\s]+/, true);
    // Check for link title
    if (stream.peek() === undefined) { // End of line, set flag to check next line
      state.linkTitle = true;
    } else { // More content on line, check if link title
      stream.match(/^(?:\s+(?:"(?:[^"\\]|\\.)+"|'(?:[^'\\]|\\.)+'|\((?:[^)\\]|\\.)+\)))?/, true);
    }
    state.f = state.inline = inlineNormal;
    return tokenTypes.linkHref + " url";
  }

  var mode = {
    startState: function() {
      return {
        f: blockNormal,

        prevLine: {stream: null},
        thisLine: {stream: null},

        block: blockNormal,
        htmlState: null,
        indentation: 0,

        inline: inlineNormal,
        text: handleText,

        formatting: false,
        linkText: false,
        linkHref: false,
        linkTitle: false,
        code: 0,
        em: false,
        strong: false,
        header: 0,
        setext: 0,
        hr: false,
        taskList: false,
        list: false,
        listStack: [],
        quote: 0,
        trailingSpace: 0,
        trailingSpaceNewLine: false,
        strikethrough: false,
        emoji: false,
        fencedEndRE: null
      };
    },

    copyState: function(s) {
      return {
        f: s.f,

        prevLine: s.prevLine,
        thisLine: s.thisLine,

        block: s.block,
        htmlState: s.htmlState && CodeMirror.copyState(htmlMode, s.htmlState),
        indentation: s.indentation,

        localMode: s.localMode,
        localState: s.localMode ? CodeMirror.copyState(s.localMode, s.localState) : null,

        inline: s.inline,
        text: s.text,
        formatting: false,
        linkText: s.linkText,
        linkTitle: s.linkTitle,
        linkHref: s.linkHref,
        code: s.code,
        em: s.em,
        strong: s.strong,
        strikethrough: s.strikethrough,
        emoji: s.emoji,
        header: s.header,
        setext: s.setext,
        hr: s.hr,
        taskList: s.taskList,
        list: s.list,
        listStack: s.listStack.slice(0),
        quote: s.quote,
        indentedCode: s.indentedCode,
        trailingSpace: s.trailingSpace,
        trailingSpaceNewLine: s.trailingSpaceNewLine,
        md_inside: s.md_inside,
        fencedEndRE: s.fencedEndRE
      };
    },

    token: function(stream, state) {

      // Reset state.formatting
      state.formatting = false;

      if (stream != state.thisLine.stream) {
        state.header = 0;
        state.hr = false;

        if (stream.match(/^\s*$/, true)) {
          blankLine(state);
          return null;
        }

        state.prevLine = state.thisLine
        state.thisLine = {stream: stream}

        // Reset state.taskList
        state.taskList = false;

        // Reset state.trailingSpace
        state.trailingSpace = 0;
        state.trailingSpaceNewLine = false;

        if (!state.localState) {
          state.f = state.block;
          if (state.f != htmlBlock) {
            var indentation = stream.match(/^\s*/, true)[0].replace(/\t/g, expandedTab).length;
            state.indentation = indentation;
            state.indentationDiff = null;
            if (indentation > 0) return null;
          }
        }
      }
      return state.f(stream, state);
    },

    innerMode: function(state) {
      if (state.block == htmlBlock) return {state: state.htmlState, mode: htmlMode};
      if (state.localState) return {state: state.localState, mode: state.localMode};
      return {state: state, mode: mode};
    },

    indent: function(state, textAfter, line) {
      if (state.block == htmlBlock && htmlMode.indent) return htmlMode.indent(state.htmlState, textAfter, line)
      if (state.localState && state.localMode.indent) return state.localMode.indent(state.localState, textAfter, line)
      return CodeMirror.Pass
    },

    blankLine: blankLine,

    getType: getType,

    blockCommentStart: "<!--",
    blockCommentEnd: "-->",
    closeBrackets: "()[]{}''\"\"``",
    fold: "markdown"
  };
  return mode;
}, "xml");

CodeMirror.defineMIME("text/markdown", "markdown");

CodeMirror.defineMIME("text/x-markdown", "markdown");

});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

var htmlConfig = {
  autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
                    'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
                    'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
                    'track': true, 'wbr': true, 'menuitem': true},
  implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
                     'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
                     'th': true, 'tr': true},
  contextGrabbers: {
    'dd': {'dd': true, 'dt': true},
    'dt': {'dd': true, 'dt': true},
    'li': {'li': true},
    'option': {'option': true, 'optgroup': true},
    'optgroup': {'optgroup': true},
    'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
          'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
          'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
          'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
          'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
    'rp': {'rp': true, 'rt': true},
    'rt': {'rp': true, 'rt': true},
    'tbody': {'tbody': true, 'tfoot': true},
    'td': {'td': true, 'th': true},
    'tfoot': {'tbody': true},
    'th': {'td': true, 'th': true},
    'thead': {'tbody': true, 'tfoot': true},
    'tr': {'tr': true}
  },
  doNotIndent: {"pre": true},
  allowUnquoted: true,
  allowMissing: true,
  caseFold: true
}

var xmlConfig = {
  autoSelfClosers: {},
  implicitlyClosed: {},
  contextGrabbers: {},
  doNotIndent: {},
  allowUnquoted: false,
  allowMissing: false,
  allowMissingTagName: false,
  caseFold: false
}

CodeMirror.defineMode("xml", function(editorConf, config_) {
  var indentUnit = editorConf.indentUnit
  var config = {}
  var defaults = config_.htmlMode ? htmlConfig : xmlConfig
  for (var prop in defaults) config[prop] = defaults[prop]
  for (var prop in config_) config[prop] = config_[prop]

  // Return variables for tokenizers
  var type, setStyle;

  function inText(stream, state) {
    function chain(parser) {
      state.tokenize = parser;
      return parser(stream, state);
    }

    var ch = stream.next();
    if (ch == "<") {
      if (stream.eat("!")) {
        if (stream.eat("[")) {
          if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
          else return null;
        } else if (stream.match("--")) {
          return chain(inBlock("comment", "-->"));
        } else if (stream.match("DOCTYPE", true, true)) {
          stream.eatWhile(/[\w\._\-]/);
          return chain(doctype(1));
        } else {
          return null;
        }
      } else if (stream.eat("?")) {
        stream.eatWhile(/[\w\._\-]/);
        state.tokenize = inBlock("meta", "?>");
        return "meta";
      } else {
        type = stream.eat("/") ? "closeTag" : "openTag";
        state.tokenize = inTag;
        return "tag bracket";
      }
    } else if (ch == "&") {
      var ok;
      if (stream.eat("#")) {
        if (stream.eat("x")) {
          ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
        } else {
          ok = stream.eatWhile(/[\d]/) && stream.eat(";");
        }
      } else {
        ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
      }
      return ok ? "atom" : "error";
    } else {
      stream.eatWhile(/[^&<]/);
      return null;
    }
  }
  inText.isInText = true;

  function inTag(stream, state) {
    var ch = stream.next();
    if (ch == ">" || (ch == "/" && stream.eat(">"))) {
      state.tokenize = inText;
      type = ch == ">" ? "endTag" : "selfcloseTag";
      return "tag bracket";
    } else if (ch == "=") {
      type = "equals";
      return null;
    } else if (ch == "<") {
      state.tokenize = inText;
      state.state = baseState;
      state.tagName = state.tagStart = null;
      var next = state.tokenize(stream, state);
      return next ? next + " tag error" : "tag error";
    } else if (/[\'\"]/.test(ch)) {
      state.tokenize = inAttribute(ch);
      state.stringStartCol = stream.column();
      return state.tokenize(stream, state);
    } else {
      stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
      return "word";
    }
  }

  function inAttribute(quote) {
    var closure = function(stream, state) {
      while (!stream.eol()) {
        if (stream.next() == quote) {
          state.tokenize = inTag;
          break;
        }
      }
      return "string";
    };
    closure.isInAttribute = true;
    return closure;
  }

  function inBlock(style, terminator) {
    return function(stream, state) {
      while (!stream.eol()) {
        if (stream.match(terminator)) {
          state.tokenize = inText;
          break;
        }
        stream.next();
      }
      return style;
    }
  }

  function doctype(depth) {
    return function(stream, state) {
      var ch;
      while ((ch = stream.next()) != null) {
        if (ch == "<") {
          state.tokenize = doctype(depth + 1);
          return state.tokenize(stream, state);
        } else if (ch == ">") {
          if (depth == 1) {
            state.tokenize = inText;
            break;
          } else {
            state.tokenize = doctype(depth - 1);
            return state.tokenize(stream, state);
          }
        }
      }
      return "meta";
    };
  }

  function Context(state, tagName, startOfLine) {
    this.prev = state.context;
    this.tagName = tagName || "";
    this.indent = state.indented;
    this.startOfLine = startOfLine;
    if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
      this.noIndent = true;
  }
  function popContext(state) {
    if (state.context) state.context = state.context.prev;
  }
  function maybePopContext(state, nextTagName) {
    var parentTagName;
    while (true) {
      if (!state.context) {
        return;
      }
      parentTagName = state.context.tagName;
      if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
          !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
        return;
      }
      popContext(state);
    }
  }

  function baseState(type, stream, state) {
    if (type == "openTag") {
      state.tagStart = stream.column();
      return tagNameState;
    } else if (type == "closeTag") {
      return closeTagNameState;
    } else {
      return baseState;
    }
  }
  function tagNameState(type, stream, state) {
    if (type == "word") {
      state.tagName = stream.current();
      setStyle = "tag";
      return attrState;
    } else if (config.allowMissingTagName && type == "endTag") {
      setStyle = "tag bracket";
      return attrState(type, stream, state);
    } else {
      setStyle = "error";
      return tagNameState;
    }
  }
  function closeTagNameState(type, stream, state) {
    if (type == "word") {
      var tagName = stream.current();
      if (state.context && state.context.tagName != tagName &&
          config.implicitlyClosed.hasOwnProperty(state.context.tagName))
        popContext(state);
      if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
        setStyle = "tag";
        return closeState;
      } else {
        setStyle = "tag error";
        return closeStateErr;
      }
    } else if (config.allowMissingTagName && type == "endTag") {
      setStyle = "tag bracket";
      return closeState(type, stream, state);
    } else {
      setStyle = "error";
      return closeStateErr;
    }
  }

  function closeState(type, _stream, state) {
    if (type != "endTag") {
      setStyle = "error";
      return closeState;
    }
    popContext(state);
    return baseState;
  }
  function closeStateErr(type, stream, state) {
    setStyle = "error";
    return closeState(type, stream, state);
  }

  function attrState(type, _stream, state) {
    if (type == "word") {
      setStyle = "attribute";
      return attrEqState;
    } else if (type == "endTag" || type == "selfcloseTag") {
      var tagName = state.tagName, tagStart = state.tagStart;
      state.tagName = state.tagStart = null;
      if (type == "selfcloseTag" ||
          config.autoSelfClosers.hasOwnProperty(tagName)) {
        maybePopContext(state, tagName);
      } else {
        maybePopContext(state, tagName);
        state.context = new Context(state, tagName, tagStart == state.indented);
      }
      return baseState;
    }
    setStyle = "error";
    return attrState;
  }
  function attrEqState(type, stream, state) {
    if (type == "equals") return attrValueState;
    if (!config.allowMissing) setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrValueState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
    setStyle = "error";
    return attrState(type, stream, state);
  }
  function attrContinuedState(type, stream, state) {
    if (type == "string") return attrContinuedState;
    return attrState(type, stream, state);
  }

  return {
    startState: function(baseIndent) {
      var state = {tokenize: inText,
                   state: baseState,
                   indented: baseIndent || 0,
                   tagName: null, tagStart: null,
                   context: null}
      if (baseIndent != null) state.baseIndent = baseIndent
      return state
    },

    token: function(stream, state) {
      if (!state.tagName && stream.sol())
        state.indented = stream.indentation();

      if (stream.eatSpace()) return null;
      type = null;
      var style = state.tokenize(stream, state);
      if ((style || type) && style != "comment") {
        setStyle = null;
        state.state = state.state(type || style, stream, state);
        if (setStyle)
          style = setStyle == "error" ? style + " error" : setStyle;
      }
      return style;
    },

    indent: function(state, textAfter, fullLine) {
      var context = state.context;
      // Indent multi-line strings (e.g. css).
      if (state.tokenize.isInAttribute) {
        if (state.tagStart == state.indented)
          return state.stringStartCol + 1;
        else
          return state.indented + indentUnit;
      }
      if (context && context.noIndent) return CodeMirror.Pass;
      if (state.tokenize != inTag && state.tokenize != inText)
        return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
      // Indent the starts of attribute names.
      if (state.tagName) {
        if (config.multilineTagIndentPastTag !== false)
          return state.tagStart + state.tagName.length + 2;
        else
          return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
      }
      if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
      var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
      if (tagAfter && tagAfter[1]) { // Closing tag spotted
        while (context) {
          if (context.tagName == tagAfter[2]) {
            context = context.prev;
            break;
          } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
            context = context.prev;
          } else {
            break;
          }
        }
      } else if (tagAfter) { // Opening tag spotted
        while (context) {
          var grabbers = config.contextGrabbers[context.tagName];
          if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
            context = context.prev;
          else
            break;
        }
      }
      while (context && context.prev && !context.startOfLine)
        context = context.prev;
      if (context) return context.indent + indentUnit;
      else return state.baseIndent || 0;
    },

    electricInput: /<\/[\s\w:]+>$/,
    blockCommentStart: "<!--",
    blockCommentEnd: "-->",

    configuration: config.htmlMode ? "html" : "xml",
    helperType: config.htmlMode ? "html" : "xml",

    skipAttribute: function(state) {
      if (state.state == attrValueState)
        state.state = attrState
    },

    xmlCurrentTag: function(state) {
      return state.tagName ? {name: state.tagName, close: state.type == "closeTag"} : null
    },

    xmlCurrentContext: function(state) {
      var context = []
      for (var cx = state.context; cx; cx = cx.prev)
        context.push(cx.tagName)
      return context.reverse()
    }
  };
});

CodeMirror.defineMIME("text/xml", "xml");
CodeMirror.defineMIME("application/xml", "xml");
if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
  CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});

});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// Utility function that allows modes to be combined. The mode given
// as the base argument takes care of most of the normal mode
// functionality, but a second (typically simple) mode is used, which
// can override the style of text. Both modes get to parse all of the
// text, but when both assign a non-null style to a piece of code, the
// overlay wins, unless the combine argument was true and not overridden,
// or state.overlay.combineTokens was true, in which case the styles are
// combined.

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.overlayMode = function(base, overlay, combine) {
  return {
    startState: function() {
      return {
        base: CodeMirror.startState(base),
        overlay: CodeMirror.startState(overlay),
        basePos: 0, baseCur: null,
        overlayPos: 0, overlayCur: null,
        streamSeen: null
      };
    },
    copyState: function(state) {
      return {
        base: CodeMirror.copyState(base, state.base),
        overlay: CodeMirror.copyState(overlay, state.overlay),
        basePos: state.basePos, baseCur: null,
        overlayPos: state.overlayPos, overlayCur: null
      };
    },

    token: function(stream, state) {
      if (stream != state.streamSeen ||
          Math.min(state.basePos, state.overlayPos) < stream.start) {
        state.streamSeen = stream;
        state.basePos = state.overlayPos = stream.start;
      }

      if (stream.start == state.basePos) {
        state.baseCur = base.token(stream, state.base);
        state.basePos = stream.pos;
      }
      if (stream.start == state.overlayPos) {
        stream.pos = stream.start;
        state.overlayCur = overlay.token(stream, state.overlay);
        state.overlayPos = stream.pos;
      }
      stream.pos = Math.min(state.basePos, state.overlayPos);

      // state.overlay.combineTokens always takes precedence over combine,
      // unless set to null
      if (state.overlayCur == null) return state.baseCur;
      else if (state.baseCur != null &&
               state.overlay.combineTokens ||
               combine && state.overlay.combineTokens == null)
        return state.baseCur + " " + state.overlayCur;
      else return state.overlayCur;
    },

    indent: base.indent && function(state, textAfter, line) {
      return base.indent(state.base, textAfter, line);
    },
    electricChars: base.electricChars,

    innerMode: function(state) { return {state: state.base, mode: base}; },

    blankLine: function(state) {
      var baseToken, overlayToken;
      if (base.blankLine) baseToken = base.blankLine(state.base);
      if (overlay.blankLine) overlayToken = overlay.blankLine(state.overlay);

      return overlayToken == null ?
        baseToken :
        (combine && baseToken != null ? baseToken + " " + overlayToken : overlayToken);
    }
  };
};

});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 300;\n  white-space: pre-line;\n'], ['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 300;\n  white-space: pre-line;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputHint = _styledComponents2.default.div.withConfig({
  displayName: 'InputHint',
  componentId: 'e6uaff-0'
})(_templateObject, _colors2.default.dove);
exports.default = InputHint;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverPicker = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactColorful = __webpack_require__(1212);

var _useClickOutside = __webpack_require__(1213);

var _useClickOutside2 = _interopRequireDefault(_useClickOutside);

var _PopoverPickerStyle = __webpack_require__(1214);

var _PopoverPickerStyle2 = _interopRequireDefault(_PopoverPickerStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverPicker = exports.PopoverPicker = function PopoverPicker(_ref) {
  var color = _ref.color,
      onChange = _ref.onChange;

  var popover = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isOpen = _useState2[0],
      toggle = _useState2[1];

  var close = (0, _react.useCallback)(function () {
    return toggle(false);
  }, []);
  (0, _useClickOutside2.default)(popover, close);

  var onClickSwatch = function onClickSwatch() {
    toggle(true);
    onChange('#1f6498');
  };

  return _react2.default.createElement(
    _PopoverPickerStyle2.default,
    { pointerColor: color },
    _react2.default.createElement('div', {
      className: 'swatch',
      style: { backgroundColor: color },
      onClick: onClickSwatch
    }),
    isOpen && _react2.default.createElement(
      'div',
      { className: 'popover', ref: popover },
      _react2.default.createElement(_reactColorful.HexColorPicker, { color: color, onChange: onChange })
    )
  );
};

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DndContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Create the React Context
 */

var DndContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({
  dragDropManager: undefined
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if('value'in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _react=__webpack_require__(1232);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(1248);var _reactDom2=_interopRequireDefault(_reactDom);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call==='object'||typeof call==='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!=='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var isTouchDevice=!!(typeof window!=='undefined'&&typeof navigator!=='undefined'&&('ontouchstart'in window||navigator.msMaxTouchPoints>0));var draggableEvents={touch:{react:{down:'onTouchStart',mouseDown:'onMouseDown',drag:'onTouchMove',drop:'onTouchEnd',move:'onTouchMove',mouseMove:'onMouseMove',up:'onTouchEnd',mouseUp:'onMouseUp'},native:{down:'touchstart',mouseDown:'mousedown',drag:'touchmove',drop:'touchend',move:'touchmove',mouseMove:'mousemove',up:'touchend',mouseUp:'mouseup'}},desktop:{react:{down:'onMouseDown',drag:'onDragOver',drop:'onDrop',move:'onMouseMove',up:'onMouseUp'},native:{down:'mousedown',drag:'dragStart',drop:'drop',move:'mousemove',up:'mouseup'}}};var deviceEvents=isTouchDevice?draggableEvents.touch:draggableEvents.desktop;var drawRoundedRect=function drawRoundedRect(context,x,y,width,height,borderRadius){if(borderRadius===0){context.rect(x,y,width,height)}else{var widthMinusRad=width-borderRadius;var heightMinusRad=height-borderRadius;context.translate(x,y);context.arc(borderRadius,borderRadius,borderRadius,Math.PI,Math.PI*1.5);context.lineTo(widthMinusRad,0);context.arc(widthMinusRad,borderRadius,borderRadius,Math.PI*1.5,Math.PI*2);context.lineTo(width,heightMinusRad);context.arc(widthMinusRad,heightMinusRad,borderRadius,Math.PI*2,Math.PI*0.5);context.lineTo(borderRadius,height);context.arc(borderRadius,heightMinusRad,borderRadius,Math.PI*0.5,Math.PI);context.translate(-x,-y)}};var AvatarEditor=function(_React$Component){_inherits(AvatarEditor,_React$Component);function AvatarEditor(props){_classCallCheck(this,AvatarEditor);var _this=_possibleConstructorReturn(this,(AvatarEditor.__proto__||Object.getPrototypeOf(AvatarEditor)).call(this,props));_this.state={drag:false,my:null,mx:null,image:{x:0.5,y:0.5}};_this.setCanvas=_this.setCanvas.bind(_this);_this.handleMouseMove=_this.handleMouseMove.bind(_this);_this.handleMouseDown=_this.handleMouseDown.bind(_this);_this.handleMouseUp=_this.handleMouseUp.bind(_this);_this.handleDragOver=_this.handleDragOver.bind(_this);_this.handleDrop=_this.handleDrop.bind(_this);return _this}_createClass(AvatarEditor,[{key:'isVertical',value:function isVertical(){return this.props.rotate%180!==0}},{key:'getDimensions',value:function getDimensions(){var _props=this.props,width=_props.width,height=_props.height,rotate=_props.rotate,border=_props.border;var canvas={};var canvasWidth=width+border*2;var canvasHeight=height+border*2;if(this.isVertical()){canvas.width=canvasHeight;canvas.height=canvasWidth}else{canvas.width=canvasWidth;canvas.height=canvasHeight}return{canvas:canvas,rotate:rotate,width:width,height:height,border:border}}},{key:'getImage',value:function getImage(){var cropRect=this.getCroppingRect();var image=this.state.image;cropRect.x*=image.resource.width;cropRect.y*=image.resource.height;cropRect.width*=image.resource.width;cropRect.height*=image.resource.height;var canvas=document.createElement('canvas');if(this.isVertical()){canvas.width=cropRect.height;canvas.height=cropRect.width}else{canvas.width=cropRect.width;canvas.height=cropRect.height}var context=canvas.getContext('2d');context.translate(canvas.width/2,canvas.height/2);context.rotate(this.props.rotate*Math.PI/180);context.translate(-(canvas.width/2),-(canvas.height/2));if(this.isVertical()){context.translate((canvas.width-canvas.height)/2,(canvas.height-canvas.width)/2)}context.drawImage(image.resource,-cropRect.x,-cropRect.y);return canvas}},{key:'getImageScaledToCanvas',value:function getImageScaledToCanvas(){var _getDimensions=this.getDimensions(),width=_getDimensions.width,height=_getDimensions.height;var canvas=document.createElement('canvas');if(this.isVertical()){canvas.width=height;canvas.height=width}else{canvas.width=width;canvas.height=height}this.paintImage(canvas.getContext('2d'),this.state.image,0);return canvas}},{key:'getXScale',value:function getXScale(){var canvasAspect=this.props.width/this.props.height;var imageAspect=this.state.image.width/this.state.image.height;return Math.min(1,canvasAspect/imageAspect)}},{key:'getYScale',value:function getYScale(){var canvasAspect=this.props.height/this.props.width;var imageAspect=this.state.image.height/this.state.image.width;return Math.min(1,canvasAspect/imageAspect)}},{key:'getCroppingRect',value:function getCroppingRect(){var position=this.props.position||{x:this.state.image.x,y:this.state.image.y},width=1/this.props.scale*this.getXScale(),height=1/this.props.scale*this.getYScale();var croppingRect={x:position.x-width/2,y:position.y-height/2,width:width,height:height};var xMin=0,xMax=1-croppingRect.width,yMin=0,yMax=1-croppingRect.height;var isLargerThanImage=width>1||height>1;if(isLargerThanImage){xMin=-croppingRect.width;xMax=1;yMin=-croppingRect.height;yMax=1}return _extends({},croppingRect,{x:Math.max(xMin,Math.min(croppingRect.x,xMax)),y:Math.max(yMin,Math.min(croppingRect.y,yMax))})}},{key:'isDataURL',value:function isDataURL(str){if(str===null){return false}var regex=/^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+=[a-z\-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@\/?%\s]*\s*$/i;return!!str.match(regex)}},{key:'loadImage',value:function loadImage(imageURL){var imageObj=new Image;imageObj.onload=this.handleImageReady.bind(this,imageObj);imageObj.onerror=this.props.onLoadFailure;if(!this.isDataURL(imageURL)&&this.props.crossOrigin)imageObj.crossOrigin=this.props.crossOrigin;imageObj.src=imageURL}},{key:'componentDidMount',value:function componentDidMount(){var context=_reactDom2.default.findDOMNode(this.canvas).getContext('2d');if(this.props.image){this.loadImage(this.props.image)}this.paint(context);if(document){var nativeEvents=deviceEvents.native;document.addEventListener(nativeEvents.move,this.handleMouseMove,false);document.addEventListener(nativeEvents.up,this.handleMouseUp,false);if(isTouchDevice){document.addEventListener(nativeEvents.mouseMove,this.handleMouseMove,false);document.addEventListener(nativeEvents.mouseUp,this.handleMouseUp,false)}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(document){var nativeEvents=deviceEvents.native;document.removeEventListener(nativeEvents.move,this.handleMouseMove,false);document.removeEventListener(nativeEvents.up,this.handleMouseUp,false);if(isTouchDevice){document.removeEventListener(nativeEvents.mouseMove,this.handleMouseMove,false);document.removeEventListener(nativeEvents.mouseUp,this.handleMouseUp,false)}}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var context=_reactDom2.default.findDOMNode(this.canvas).getContext('2d');context.clearRect(0,0,this.getDimensions().canvas.width,this.getDimensions().canvas.height);this.paint(context);this.paintImage(context,this.state.image,this.props.border);if(prevProps.image!==this.props.image||prevProps.width!==this.props.width||prevProps.height!==this.props.height||prevProps.position!==this.props.position||prevProps.scale!==this.props.scale||prevProps.rotate!==this.props.rotate||prevState.my!==this.state.my||prevState.mx!==this.state.mx||prevState.image.x!==this.state.image.x||prevState.image.y!==this.state.image.y){this.props.onImageChange()}}},{key:'handleImageReady',value:function handleImageReady(image){var imageState=this.getInitialSize(image.width,image.height);imageState.resource=image;imageState.x=0.5;imageState.y=0.5;this.setState({drag:false,image:imageState},this.props.onImageReady);this.props.onLoadSuccess(imageState)}},{key:'getInitialSize',value:function getInitialSize(width,height){var newHeight=void 0;var newWidth=void 0;var dimensions=this.getDimensions();var canvasRatio=dimensions.height/dimensions.width;var imageRatio=height/width;if(canvasRatio>imageRatio){newHeight=this.getDimensions().height;newWidth=width*(newHeight/height)}else{newWidth=this.getDimensions().width;newHeight=height*(newWidth/width)}return{height:newHeight,width:newWidth}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){if(newProps.image&&this.props.image!==newProps.image||this.props.width!==newProps.width||this.props.height!==newProps.height){this.loadImage(newProps.image)}}},{key:'paintImage',value:function paintImage(context,image,border){if(image.resource){var position=this.calculatePosition(image,border);context.save();context.translate(context.canvas.width/2,context.canvas.height/2);context.rotate(this.props.rotate*Math.PI/180);context.translate(-(context.canvas.width/2),-(context.canvas.height/2));if(this.isVertical()){context.translate((context.canvas.width-context.canvas.height)/2,(context.canvas.height-context.canvas.width)/2)}context.globalCompositeOperation='destination-over';context.drawImage(image.resource,position.x,position.y,position.width,position.height);context.restore()}}},{key:'calculatePosition',value:function calculatePosition(image,border){image=image||this.state.image;var croppingRect=this.getCroppingRect();var width=image.width*this.props.scale;var height=image.height*this.props.scale;var x=border-croppingRect.x*width;var y=border-croppingRect.y*height;return{x:x,y:y,height:height,width:width}}},{key:'paint',value:function paint(context){context.save();context.translate(0,0);context.fillStyle='rgba('+this.props.color.slice(0,4).join(',')+')';var borderRadius=this.props.borderRadius;var dimensions=this.getDimensions();var borderSize=dimensions.border;var height=dimensions.canvas.height;var width=dimensions.canvas.width;borderRadius=Math.max(borderRadius,0);borderRadius=Math.min(borderRadius,width/2-borderSize,height/2-borderSize);context.beginPath();drawRoundedRect(context,borderSize,borderSize,width-borderSize*2,height-borderSize*2,borderRadius);context.rect(width,0,-width,height);context.fill('evenodd');context.restore()}},{key:'handleMouseDown',value:function handleMouseDown(e){e=e||window.event;e.preventDefault();this.setState({drag:true,mx:null,my:null})}},{key:'handleMouseUp',value:function handleMouseUp(){if(this.state.drag){this.setState({drag:false});this.props.onMouseUp()}}},{key:'handleMouseMove',value:function handleMouseMove(e){e=e||window.event;if(this.state.drag===false){return}var mousePositionX=e.targetTouches?e.targetTouches[0].pageX:e.clientX;var mousePositionY=e.targetTouches?e.targetTouches[0].pageY:e.clientY;var newState={mx:mousePositionX,my:mousePositionY};var rotate=this.props.rotate;rotate%=360;rotate=rotate<0?rotate+360:rotate;rotate-=rotate%90;if(this.state.mx&&this.state.my){var mx=this.state.mx-mousePositionX;var my=this.state.my-mousePositionY;var width=this.state.image.width*this.props.scale;var height=this.state.image.height*this.props.scale;var _getCroppingRect=this.getCroppingRect(),lastX=_getCroppingRect.x,lastY=_getCroppingRect.y;lastX*=width;lastY*=height;var xDiff=rotate===0||rotate===180?mx:my;var yDiff=rotate===0||rotate===180?my:mx;var y=void 0;var x=void 0;if(rotate===0){y=lastY+yDiff;x=lastX+xDiff}if(rotate===90){y=lastY-yDiff;x=lastX+xDiff}if(rotate===180){y=lastY-yDiff;x=lastX-xDiff}if(rotate===270){y=lastY+yDiff;x=lastX-xDiff}var relativeWidth=1/this.props.scale*this.getXScale();var relativeHeight=1/this.props.scale*this.getYScale();var position={x:x/width+relativeWidth/2,y:y/height+relativeHeight/2};this.props.onPositionChange(position);newState.image=_extends({},this.state.image,position)}this.setState(newState);this.props.onMouseMove()}},{key:'handleDragOver',value:function handleDragOver(e){e=e||window.event;e.preventDefault()}},{key:'handleDrop',value:function handleDrop(e){var _this2=this;e=e||window.event;e.stopPropagation();e.preventDefault();if(e.dataTransfer&&e.dataTransfer.files.length){this.props.onDropFile(e);var reader=new FileReader;var file=e.dataTransfer.files[0];reader.onload=function(e){return _this2.loadImage(e.target.result)};reader.readAsDataURL(file)}}},{key:'setCanvas',value:function setCanvas(canvas){this.canvas=canvas}},{key:'render',value:function render(){var defaultStyle={cursor:this.state.drag?'grabbing':'grab'};var attributes={width:this.getDimensions().canvas.width,height:this.getDimensions().canvas.height,style:_extends({},defaultStyle,this.props.style)};attributes[deviceEvents.react.down]=this.handleMouseDown;attributes[deviceEvents.react.drag]=this.handleDragOver;attributes[deviceEvents.react.drop]=this.handleDrop;if(isTouchDevice)attributes[deviceEvents.react.mouseDown]=this.handleMouseDown;return _react2.default.createElement('canvas',_extends({ref:this.setCanvas},attributes))}}]);return AvatarEditor}(_react2.default.Component);AvatarEditor.propTypes={scale:_react2.default.PropTypes.number,rotate:_react2.default.PropTypes.number,image:_react2.default.PropTypes.string,border:_react2.default.PropTypes.number,borderRadius:_react2.default.PropTypes.number,width:_react2.default.PropTypes.number,height:_react2.default.PropTypes.number,position:_react2.default.PropTypes.shape({x:_react2.default.PropTypes.number,y:_react2.default.PropTypes.number}),color:_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number),style:_react2.default.PropTypes.object,crossOrigin:_react2.default.PropTypes.oneOf(['','anonymous','use-credentials']),onDropFile:_react2.default.PropTypes.func,onLoadFailure:_react2.default.PropTypes.func,onLoadSuccess:_react2.default.PropTypes.func,onImageReady:_react2.default.PropTypes.func,onImageChange:_react2.default.PropTypes.func,onMouseUp:_react2.default.PropTypes.func,onMouseMove:_react2.default.PropTypes.func,onPositionChange:_react2.default.PropTypes.func};AvatarEditor.defaultProps={scale:1,rotate:0,border:25,borderRadius:0,width:200,height:200,color:[0,0,0,0.5],style:{},crossOrigin:'anonymous',onDropFile:function onDropFile(){},onLoadFailure:function onLoadFailure(){},onLoadSuccess:function onLoadSuccess(){},onImageReady:function onImageReady(){},onImageChange:function onImageChange(){},onMouseUp:function onMouseUp(){},onMouseMove:function onMouseMove(){},onPositionChange:function onPositionChange(){}};exports.default=AvatarEditor;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(250),
    _assign = __webpack_require__(37);

var ReactNoopUpdateQueue = __webpack_require__(600);

var canDefineProperty = __webpack_require__(601);
var emptyObject = __webpack_require__(416);
var invariant = __webpack_require__(28);
var lowPriorityWarning = __webpack_require__(1233);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(40);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1241);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(187);

var invariant = __webpack_require__(28);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(52);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);
var escapeTextContentForBrowser = __webpack_require__(319);
var setInnerHTML = __webpack_require__(318);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(209);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactInstrumentation = __webpack_require__(115);

var quoteAttributeValueForBrowser = __webpack_require__(1275);
var warning = __webpack_require__(40);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var LinkedValueUtils = __webpack_require__(426);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactUpdates = __webpack_require__(130);

var warning = __webpack_require__(40);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var ReactCompositeComponent = __webpack_require__(1284);
var ReactEmptyComponent = __webpack_require__(620);
var ReactHostComponent = __webpack_require__(621);

var getNextDebugID = __webpack_require__(1285);
var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var React = __webpack_require__(207);

var invariant = __webpack_require__(28);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactCurrentOwner = __webpack_require__(144);
var REACT_ELEMENT_TYPE = __webpack_require__(1286);

var getIteratorFn = __webpack_require__(1287);
var invariant = __webpack_require__(28);
var KeyEscapeUtils = __webpack_require__(430);
var warning = __webpack_require__(40);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(250);

var ReactCurrentOwner = __webpack_require__(144);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(129);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(1299);

var containsNode = __webpack_require__(1301);
var focusNode = __webpack_require__(614);
var getActiveElement = __webpack_require__(626);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var DOMLazyTree = __webpack_require__(211);
var DOMProperty = __webpack_require__(209);
var React = __webpack_require__(207);
var ReactBrowserEventEmitter = __webpack_require__(320);
var ReactCurrentOwner = __webpack_require__(144);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactDOMContainerInfo = __webpack_require__(1316);
var ReactDOMFeatureFlags = __webpack_require__(1317);
var ReactFeatureFlags = __webpack_require__(609);
var ReactInstanceMap = __webpack_require__(254);
var ReactInstrumentation = __webpack_require__(115);
var ReactMarkupChecksum = __webpack_require__(1318);
var ReactReconciler = __webpack_require__(210);
var ReactUpdateQueue = __webpack_require__(431);
var ReactUpdates = __webpack_require__(130);

var emptyObject = __webpack_require__(416);
var instantiateReactComponent = __webpack_require__(618);
var invariant = __webpack_require__(28);
var setInnerHTML = __webpack_require__(318);
var shouldUpdateReactComponent = __webpack_require__(429);
var warning = __webpack_require__(40);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(619);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjgyOSAzLjZsMi43IDIuN0w0LjExNCAxNi43MTQgMCAxOGwxLjQxNC0zLjk4NkwxMS44MyAzLjZ6TTE3LjQyLjU3OWMuNzcyLjc3MS43NzIgMS45MjggMCAyLjU3MWwtMS40MTQgMS40MTQtMi41NzEtMi41NzFMMTQuODUuNTc5Yy43NzEtLjc3MiAxLjkyOS0uNzcyIDIuNTcxIDB6IiBmaWxsPSIjMDA3MEUwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxOCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTUgMTgiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiNEQzE0M0M7fTwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTTEyIDNoM2MwLTEuMS0uOS0yLTItMmgtMi4zMzNsLS4zNy0uNTU1Yy0uMTg2LS4yNzgtLjQ5OC0uNDQ1LS44MzItLjQ0NWgtMy45M2MtLjMzNCAwLS42NDcuMTY3LS44MzIuNDQ1bC0uMzcuNTU1aC0yLjMzM2MtMS4xIDAtMiAuOS0yIDJoMTJ6TTEgMTV2MWMwIDEuMS45IDIgMiAyaDljMS4xIDAgMi0uOSAyLTJ2LTEyaC0xM3YxMXptMS0xMGgxMXYxMWMwIC41NTItLjQ0OCAxLTEgMWgtOWMtLjU1MiAwLTEtLjQ0OC0xLTF2LTExek0xMCA3LjVjMC0uMjc1LjIyNS0uNS41LS41cy41LjIyNS41LjV2N2MwIC4yNzUtLjIyNS41LS41LjVzLS41LS4yMjUtLjUtLjV2LTd6TTcgNy41YzAtLjI3NS4yMjUtLjUuNS0uNXMuNS4yMjUuNS41djdjMCAuMjc1LS4yMjUuNS0uNS41cy0uNS0uMjI1LS41LS41di03ek00IDcuNWMwLS4yNzUuMjI1LS41LjUtLjVzLjUuMjI1LjUuNXY3YzAgLjI3NS0uMjI1LjUtLjUuNXMtLjUtLjIyNS0uNS0uNXYtN3oiLz48L3N2Zz4="

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: ', ';\n  top: ', ';\n  left: ', ';\n  width: 60px;\n  height: ', ';\n  ', '\n  background: ', ';\n  z-index: ', ';\n\n  &.small {\n    min-height: 60px;\n  }\n\n  @keyframes rotate-loader {\n    0% {\n      -webkit-transform: rotate(0deg) scale(0.8);\n      -moz-transform: rotate(0deg) scale(0.8);\n    }\n    50% {\n      -webkit-transform: rotate(360deg) scale(1.2);\n      -moz-transform: rotate(360deg) scale(1.2);\n    }\n    100% {\n      -webkit-transform: rotate(720deg) scale(0.8);\n      -moz-transform: rotate(720deg) scale(0.8);\n    }\n  }\n\n  @keyframes ball1 {\n    0% {\n      box-shadow: 30px 0 0 ', ';\n    }\n    50% {\n      box-shadow: 0 0 0 ', ';\n      margin-bottom: 0;\n      -webkit-transform: translate(15px, 15px);\n      -moz-transform: translate(15px, 15px);\n    }\n    100% {\n      box-shadow: 30px 0 0 ', ';\n      margin-bottom: 10px;\n    }\n  }\n\n  @keyframes ball2 {\n    0% {\n      box-shadow: 30px 0 0 ', ';\n    }\n    50% {\n      box-shadow: 0 0 0 ', ';\n      margin-top: -20px;\n      -webkit-transform: translate(15px, 15px);\n      -moz-transform: translate(15px, 15px);\n    }\n    100% {\n      box-shadow: 30px 0 0 ', ';\n      margin-top: 0;\n    }\n  }\n\n  span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -25px 0 0 -25px;\n    animation: rotate-loader 1.75s infinite;\n    height: 50px;\n    width: 50px;\n\n    &:before,\n    &:after {\n      border-radius: 50%;\n      content: \'\';\n      display: block;\n      height: 20px;\n      width: 20px;\n    }\n\n    &:before {\n      animation: ball1 1.75s infinite;\n      background-color: ', ';\n      box-shadow: 30px 0 0 ', ';\n      margin-bottom: 10px;\n    }\n\n    &:after {\n      animation: ball2 1.75s infinite;\n      background-color: ', ';\n      box-shadow: 30px 0 0 ', ';\n    }\n  }\n'], ['\n  position: ', ';\n  top: ', ';\n  left: ', ';\n  width: 60px;\n  height: ', ';\n  ', '\n  background: ', ';\n  z-index: ', ';\n\n  &.small {\n    min-height: 60px;\n  }\n\n  @keyframes rotate-loader {\n    0% {\n      -webkit-transform: rotate(0deg) scale(0.8);\n      -moz-transform: rotate(0deg) scale(0.8);\n    }\n    50% {\n      -webkit-transform: rotate(360deg) scale(1.2);\n      -moz-transform: rotate(360deg) scale(1.2);\n    }\n    100% {\n      -webkit-transform: rotate(720deg) scale(0.8);\n      -moz-transform: rotate(720deg) scale(0.8);\n    }\n  }\n\n  @keyframes ball1 {\n    0% {\n      box-shadow: 30px 0 0 ', ';\n    }\n    50% {\n      box-shadow: 0 0 0 ', ';\n      margin-bottom: 0;\n      -webkit-transform: translate(15px, 15px);\n      -moz-transform: translate(15px, 15px);\n    }\n    100% {\n      box-shadow: 30px 0 0 ', ';\n      margin-bottom: 10px;\n    }\n  }\n\n  @keyframes ball2 {\n    0% {\n      box-shadow: 30px 0 0 ', ';\n    }\n    50% {\n      box-shadow: 0 0 0 ', ';\n      margin-top: -20px;\n      -webkit-transform: translate(15px, 15px);\n      -moz-transform: translate(15px, 15px);\n    }\n    100% {\n      box-shadow: 30px 0 0 ', ';\n      margin-top: 0;\n    }\n  }\n\n  span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -25px 0 0 -25px;\n    animation: rotate-loader 1.75s infinite;\n    height: 50px;\n    width: 50px;\n\n    &:before,\n    &:after {\n      border-radius: 50%;\n      content: \'\';\n      display: block;\n      height: 20px;\n      width: 20px;\n    }\n\n    &:before {\n      animation: ball1 1.75s infinite;\n      background-color: ', ';\n      box-shadow: 30px 0 0 ', ';\n      margin-bottom: 10px;\n    }\n\n    &:after {\n      animation: ball2 1.75s infinite;\n      background-color: ', ';\n      box-shadow: 30px 0 0 ', ';\n    }\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingContainerDiv = _styledComponents2.default.div.withConfig({
  displayName: 'LoadingSpinner__LoadingContainerDiv',
  componentId: 'sc-7q8e3p-0'
})(_templateObject, function (props) {
  return props.isFixed ? 'fixed' : 'relative';
}, function (props) {
  return props.isFixed ? '0' : 'unset';
}, function (props) {
  return props.isFixed ? '0' : 'unset';
}, function (props) {
  return props.isFullScreen ? '100%' : '';
}, function (props) {
  return props.isFullScreen ? 'min-height: 400px' : '';
}, function (props) {
  return props.hasBackground ? 'rgb(36 54 70 / 0.45)' : '';
}, function (props) {
  return props.hasBackground ? '1000' : 'unset';
}, _colors2.default.oeYellow, _colors2.default.amber, _colors2.default.amberLite, _colors2.default.oeYellow, _colors2.default.amberLite, _colors2.default.oeYellow, _colors2.default.amber, _colors2.default.amber, _colors2.default.oeYellow, _colors2.default.oeYellow);

var LoadingSpinner = function LoadingSpinner(_ref) {
  var isSmall = _ref.isSmall,
      isFixed = _ref.isFixed,
      isFullScreen = _ref.isFullScreen,
      hasBackground = _ref.hasBackground;
  return _react2.default.createElement(
    LoadingContainerDiv,
    {
      isFixed: isFixed,
      isFullScreen: isFullScreen,
      hasBackground: hasBackground,
      className: isSmall ? ' small' : ''
    },
    _react2.default.createElement('span', null)
  );
};

LoadingSpinner.defaultProps = {
  isSmall: true,
  isFixed: false,
  isFullScreen: false,
  hasBackground: false
};

LoadingSpinner.propTypes = {
  isSmall: _propTypes2.default.bool,
  isFixed: _propTypes2.default.bool,
  isFullScreen: _propTypes2.default.bool,
  hasBackground: _propTypes2.default.bool
};

exports.default = LoadingSpinner;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInputComponent = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n  max-width: fit-content;\n'], ['\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n  max-width: fit-content;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 1rem;\n'], ['\n  margin-right: 1rem;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _RadioLabel = __webpack_require__(1346);

var _RadioLabel2 = _interopRequireDefault(_RadioLabel);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _util = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputContainer = _styledComponents2.default.form.withConfig({
  displayName: 'RadioInputComponent__InputContainer',
  componentId: 'sc-1uf3o4k-0'
})(_templateObject);
var InputOption = _styledComponents2.default.div.withConfig({
  displayName: 'RadioInputComponent__InputOption',
  componentId: 'sc-1uf3o4k-1'
})(_templateObject2);
var Input = _styledComponents2.default.input.withConfig({
  displayName: 'RadioInputComponent__Input',
  componentId: 'sc-1uf3o4k-2'
})(_templateObject3);

var RadioInputComponent = exports.RadioInputComponent = function RadioInputComponent(_ref) {
  var onChange = _ref.onChange,
      journey = _ref.journey,
      disableCloning = _ref.disableCloning,
      orgFlags = _ref.orgFlags;

  var _useState = (0, _react.useState)('new'),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1];

  var handleChangeSelectedValue = function handleChangeSelectedValue(e) {
    setSelectedValue(e.target.value);
    onChange(e.target.value);
  };

  var message = (0, _util.getTooltipMessage)(orgFlags, journey);

  return _react2.default.createElement(
    InputContainer,
    { onChange: handleChangeSelectedValue },
    _react2.default.createElement(
      InputOption,
      null,
      _react2.default.createElement(Input, { type: 'radio', id: 'new', name: 'new', value: 'new', onChange: handleChangeSelectedValue, checked: selectedValue === 'new' }),
      _react2.default.createElement(
        _RadioLabel2.default,
        { htmlFor: 'new' },
        'Create a new ',
        journey ? 'journey' : 'course',
        ' from scratch.'
      )
    ),
    _react2.default.createElement(
      InputOption,
      { 'data-for': 'no-course-tooltip', 'data-tip': message },
      _react2.default.createElement(Input, { disabled: disableCloning, type: 'radio', id: 'existing', name: 'existing', value: 'existing', onChange: handleChangeSelectedValue, checked: selectedValue === 'existing' }),
      _react2.default.createElement(
        _RadioLabel2.default,
        { disabled: disableCloning, htmlFor: 'existing' },
        'Start with an existing ',
        journey ? 'journey' : 'course',
        '.'
      )
    ),
    disableCloning && _react2.default.createElement(_reactTooltip2.default, {
      id: 'no-course-tooltip',
      place: 'top',
      effect: 'solid',
      className: 'activityCourseTooltip'
    })
  );
};

RadioInputComponent.defaultProps = {
  onChange: function onChange() {},
  journey: false
};

RadioInputComponent.propTypes = {
  onChange: _propTypes2.default.func
};

exports.default = RadioInputComponent;

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var colors_namespaceObject = {};
__webpack_require__.d(colors_namespaceObject, "common", function() { return common["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "red", function() { return red["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "pink", function() { return pink["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "purple", function() { return colors_purple; });
__webpack_require__.d(colors_namespaceObject, "deepPurple", function() { return colors_deepPurple; });
__webpack_require__.d(colors_namespaceObject, "indigo", function() { return indigo["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "blue", function() { return blue["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "lightBlue", function() { return colors_lightBlue; });
__webpack_require__.d(colors_namespaceObject, "cyan", function() { return colors_cyan; });
__webpack_require__.d(colors_namespaceObject, "teal", function() { return colors_teal; });
__webpack_require__.d(colors_namespaceObject, "green", function() { return green["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "lightGreen", function() { return colors_lightGreen; });
__webpack_require__.d(colors_namespaceObject, "lime", function() { return colors_lime; });
__webpack_require__.d(colors_namespaceObject, "yellow", function() { return colors_yellow; });
__webpack_require__.d(colors_namespaceObject, "amber", function() { return colors_amber; });
__webpack_require__.d(colors_namespaceObject, "orange", function() { return orange["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "deepOrange", function() { return colors_deepOrange; });
__webpack_require__.d(colors_namespaceObject, "brown", function() { return colors_brown; });
__webpack_require__.d(colors_namespaceObject, "grey", function() { return grey["a" /* default */]; });
__webpack_require__.d(colors_namespaceObject, "blueGrey", function() { return colors_blueGrey; });

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = __webpack_require__(634);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(635);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = __webpack_require__(636);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/purple.js
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ var colors_purple = (purple);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/deepPurple.js
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
/* harmony default export */ var colors_deepPurple = (deepPurple);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = __webpack_require__(637);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(638);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/lightBlue.js
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ var colors_lightBlue = (lightBlue);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/cyan.js
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
/* harmony default export */ var colors_cyan = (cyan);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/teal.js
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
/* harmony default export */ var colors_teal = (teal);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(639);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/lightGreen.js
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
/* harmony default export */ var colors_lightGreen = (lightGreen);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/lime.js
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
/* harmony default export */ var colors_lime = (lime);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/yellow.js
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
/* harmony default export */ var colors_yellow = (yellow);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/amber.js
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
/* harmony default export */ var colors_amber = (amber);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = __webpack_require__(640);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/deepOrange.js
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
/* harmony default export */ var colors_deepOrange = (deepOrange);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/brown.js
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
/* harmony default export */ var colors_brown = (brown);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = __webpack_require__(641);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/blueGrey.js
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
/* harmony default export */ var colors_blueGrey = (blueGrey);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/index.js




















// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(65);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createMuiTheme.js + 6 modules
var createMuiTheme = __webpack_require__(436);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMuiStrictModeTheme.js


function createMuiStrictModeTheme(options) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return createMuiTheme["a" /* default */].apply(void 0, [Object(esm["a" /* deepmerge */])({
    unstable_strictMode: true
  }, options)].concat(args));
}
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/index.js + 45 modules
var styles_esm = __webpack_require__(92);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js
 // let warnOnce = false;
// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return Object(styles_esm["e" /* createStyles */])(styles);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(256);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(styles_esm["h" /* makeStyles */])(stylesOrCreator, Object(esm_extends["a" /* default */])({
    defaultTheme: defaultTheme["a" /* default */]
  }, options));
}

/* harmony default export */ var styles_makeStyles = (makeStyles);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/cssUtils.js

function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return function (length, toUnit) {
    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    var pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
        return length;
      }
    } // Convert length in pixels to the output unit


    var outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty(_ref) {
  var size = _ref.size,
      grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight,
      pixels = _ref2.pixels,
      htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 *
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty,
      min = _ref3.min,
      max = _ref3.max,
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
      _ref3$breakpoints = _ref3.breakpoints,
      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? null : _ref3$transform;

  var output = Object(defineProperty["a" /* default */])({}, cssProperty, "".concat(min).concat(unit));

  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function (breakpoint) {
    var value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output["@media (min-width:".concat(breakpoint, "px)")] = Object(defineProperty["a" /* default */])({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
  });
  return output;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/responsiveFontSizes.js



function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints,
      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
      _options$disableAlign = options.disableAlign,
      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
      _options$factor = options.factor,
      factor = _options$factor === void 0 ? 2 : _options$factor,
      _options$variants = options.variants,
      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;

  var theme = Object(esm_extends["a" /* default */])({}, themeInput);

  theme.typography = Object(esm_extends["a" /* default */])({}, theme.typography);
  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  var convert = convertLength(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function (x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function (variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;

    if (!isUnitless(lineHeight) && !disableAlign) {
      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : Object(esm["b" /* formatMuiErrorMessage */])(6));
    }

    if (!isUnitless(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    var transform = null;

    if (!disableAlign) {
      transform = function transform(value) {
        return alignProperty({
          size: value,
          grid: fontGrid({
            pixels: 4,
            lineHeight: lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }

    typography[variant] = Object(esm_extends["a" /* default */])({}, style, responsiveProperty({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform: transform
    }));
  });
  return theme;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js




var styled_styled = function styled(Component) {
  var componentCreator = Object(styles_esm["j" /* styled */])(Component);
  return function (style, options) {
    return componentCreator(style, Object(esm_extends["a" /* default */])({
      defaultTheme: defaultTheme["a" /* default */]
    }, options));
  };
};

/* harmony default export */ var styles_styled = (styled_styled);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(131);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(62);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(12);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/withTheme.js


var withTheme = Object(styles_esm["m" /* withThemeCreator */])({
  defaultTheme: defaultTheme["a" /* default */]
});
/* harmony default export */ var styles_withTheme = (withTheme);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/index.js

 // eslint-disable-next-line camelcase











// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/index.js + 1 modules
var utils = __webpack_require__(440);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(646);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(645);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(437);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(647);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return Object(arrayWithHoles["a" /* default */])(arr) || Object(iterableToArray["a" /* default */])(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || Object(nonIterableRest["a" /* default */])();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(101);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(100);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(13);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/index.js + 12 modules
var react_transition_group_esm = __webpack_require__(213);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/transitions/utils.js
var transitions_utils = __webpack_require__(214);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Collapse/Collapse.js












var Collapse_styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse_Collapse = /*#__PURE__*/react["forwardRef"](function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? transitions["b" /* duration */].standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group_esm["a" /* Transition */] : _props$TransitionComp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(useTheme["a" /* default */])();
  var timer = react["useRef"]();
  var wrapperRef = react["useRef"](null);
  var autoTransitionDuration = react["useRef"]();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  react["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react["useRef"](null);
  var handleRef = Object(utils["useForkRef"])(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
      className: Object(clsx_m["a" /* default */])(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: Object(esm_extends["a" /* default */])({
        minHeight: collapsedHeight
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/react["createElement"]("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/react["createElement"]("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? Collapse_Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse_Collapse.muiSupportAuto = true;
/* harmony default export */ var esm_Collapse_Collapse = (Object(withStyles["a" /* default */])(Collapse_styles, {
  name: 'MuiCollapse'
})(Collapse_Collapse));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Collapse/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/index.js + 1 modules
var Paper = __webpack_require__(102);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Accordion/AccordionContext.js

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = react["createContext"]({});

if (false) {
  AccordionContext.displayName = 'AccordionContext';
}

/* harmony default export */ var Accordion_AccordionContext = (AccordionContext);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(164);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js














var Accordion_styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion_Accordion = /*#__PURE__*/react["forwardRef"](function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Collapse_Collapse : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = react["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = react["Children"].toArray(childrenProp),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = react["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/react["createElement"](Accordion_AccordionContext.Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/react["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? Accordion_Accordion.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the accordion by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the accordion will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Accordion_Accordion = (Object(withStyles["a" /* default */])(Accordion_styles, {
  name: 'MuiAccordion'
})(Accordion_Accordion));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Accordion/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionActions/AccordionActions.js






var AccordionActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var AccordionActions_AccordionActions = /*#__PURE__*/react["forwardRef"](function AccordionActions(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? AccordionActions_AccordionActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_AccordionActions_AccordionActions = (Object(withStyles["a" /* default */])(AccordionActions_styles, {
  name: 'MuiAccordionActions'
})(AccordionActions_AccordionActions));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionActions/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js






var AccordionDetails_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails_AccordionDetails = /*#__PURE__*/react["forwardRef"](function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? AccordionDetails_AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var esm_AccordionDetails_AccordionDetails = (Object(withStyles["a" /* default */])(AccordionDetails_styles, {
  name: 'MuiAccordionDetails'
})(AccordionDetails_AccordionDetails));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/index.js + 3 modules
var ButtonBase = __webpack_require__(69);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/index.js + 1 modules
var IconButton = __webpack_require__(165);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js



/* eslint-disable jsx-a11y/aria-role */







var AccordionSummary_styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary_AccordionSummary = /*#__PURE__*/react["forwardRef"](function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = react["useState"](false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = react["useContext"](Accordion_AccordionContext),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(clsx_m["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/react["createElement"](IconButton["default"], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? AccordionSummary_AccordionSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* harmony default export */ var esm_AccordionSummary_AccordionSummary = (Object(withStyles["a" /* default */])(AccordionSummary_styles, {
  name: 'MuiAccordionSummary'
})(AccordionSummary_AccordionSummary));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(27);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js








var AppBar_styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="transparent"`. */
    colorTransparent: {
      backgroundColor: 'transparent',
      color: 'inherit'
    }
  };
};
var AppBar_AppBar = /*#__PURE__*/react["forwardRef"](function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "position"]);

  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    square: true,
    component: "header",
    elevation: 4,
    className: Object(clsx_m["a" /* default */])(classes.root, classes["position".concat(Object(capitalize["a" /* default */])(position))], classes["color".concat(Object(capitalize["a" /* default */])(color))], className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
 false ? AppBar_AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
/* harmony default export */ var esm_AppBar_AppBar = (Object(withStyles["a" /* default */])(AppBar_styles, {
  name: 'MuiAppBar'
})(AppBar_AppBar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/AppBar/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(79);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/Person.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js







var Avatar_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},

    /* Styles applied to the root element if `variant="circular"`. */
    circular: {},

    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover',
      // Hide alt text.
      color: 'transparent',
      // Hide the image broken icon, only works on Chrome.
      textIndent: 10000
    },

    /* Styles applied to the fallback icon */
    fallback: {
      width: '75%',
      height: '75%'
    }
  };
};

function useLoaded(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet;

  var _React$useState = react["useState"](false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  react["useEffect"](function () {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;

    image.onload = function () {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = function () {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

var Avatar_Avatar = /*#__PURE__*/react["forwardRef"](function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circle' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  var loaded = useLoaded({
    src: src,
    srcSet: srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== 'error';

  if (hasImgNotFailing) {
    children = /*#__PURE__*/react["createElement"]("img", Object(esm_extends["a" /* default */])({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/react["createElement"](Person, {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? Avatar_Avatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: PropTypes.string,

  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Attributes applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   */
  imgProps: PropTypes.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: PropTypes.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string,

  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: PropTypes.string,

  /**
   * The shape of the avatar.
   */
  variant: PropTypes.oneOf(['circle', 'circular', 'rounded', 'square'])
} : void 0;
/* harmony default export */ var esm_Avatar_Avatar = (Object(withStyles["a" /* default */])(Avatar_styles, {
  name: 'MuiAvatar'
})(Avatar_Avatar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Avatar/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(53);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js










var Fade_styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade_Fade = /*#__PURE__*/react["forwardRef"](function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group_esm["a" /* Transition */] : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = Object(useTheme["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react["useRef"](null);
  var foreignRef = Object(useForkRef["a" /* default */])(children.ref, ref);
  var handleRef = Object(useForkRef["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(transitions_utils["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react["cloneElement"](children, Object(esm_extends["a" /* default */])({
      style: Object(esm_extends["a" /* default */])({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, Fade_styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Fade_Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ var esm_Fade_Fade = (Fade_Fade);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Fade/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js







var Backdrop_styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop_Backdrop = /*#__PURE__*/react["forwardRef"](function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Fade_Fade : _props$TransitionComp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? Backdrop_Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ var esm_Backdrop_Backdrop = (Object(withStyles["a" /* default */])(Backdrop_styles, {
  name: 'MuiBackdrop'
})(Backdrop_Backdrop));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Backdrop/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js







var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var Badge_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge_Badge = /*#__PURE__*/react["forwardRef"](function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return /*#__PURE__*/react["createElement"](ComponentProp, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), children, /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(Object(capitalize["a" /* default */])(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(Object(capitalize["a" /* default */])(anchorOrigin.vertical)).concat(Object(capitalize["a" /* default */])(anchorOrigin.horizontal)).concat(Object(capitalize["a" /* default */])(overlap))], color !== 'default' && classes["color".concat(Object(capitalize["a" /* default */])(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
  }, displayValue));
});
 false ? Badge_Badge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'error', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: PropTypes.bool,

  /**
   * Max count to show.
   */
  max: PropTypes.number,

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap: PropTypes.oneOf(['circle', 'rectangle']),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dot', 'standard'])
} : void 0;
/* harmony default export */ var esm_Badge_Badge = (Object(withStyles["a" /* default */])(Badge_styles, {
  name: 'MuiBadge'
})(Badge_Badge));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Badge/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/BottomNavigation/BottomNavigation.js







var BottomNavigation_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};
var BottomNavigation_BottomNavigation = /*#__PURE__*/react["forwardRef"](function BottomNavigation(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      onChange = props.onChange,
      _props$showLabels = props.showLabels,
      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
      value = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), react["Children"].map(children, function (child, childIndex) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return /*#__PURE__*/react["cloneElement"](child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  }));
});
 false ? BottomNavigation_BottomNavigation.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value We default to the index of the child.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: PropTypes.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_BottomNavigation_BottomNavigation = (Object(withStyles["a" /* default */])(BottomNavigation_styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation_BottomNavigation));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/BottomNavigation/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
var utils_unsupportedProp = __webpack_require__(327);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/BottomNavigationAction/BottomNavigationAction.js








var BottomNavigationAction_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      padding: '6px 12px 8px',
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Pseudo-class applied to the root element if selected. */
    selected: {},

    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};
var BottomNavigationAction_BottomNavigationAction = /*#__PURE__*/react["forwardRef"](function BottomNavigationAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      icon = props.icon,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      showLabel = props.showLabel,
      value = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    ref: ref,
    className: Object(clsx_m["a" /* default */])(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
    focusRipple: true,
    onClick: handleChange
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.wrapper
  }, icon, /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
  }, label)));
});
 false ? BottomNavigationAction_BottomNavigationAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: PropTypes.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_BottomNavigationAction_BottomNavigationAction = (Object(withStyles["a" /* default */])(BottomNavigationAction_styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction_BottomNavigationAction));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/BottomNavigationAction/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/index.js + 17 modules
var system_esm = __webpack_require__(643);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js


var styleFunction = Object(system_esm["d" /* css */])(Object(system_esm["b" /* compose */])(system_esm["a" /* borders */], system_esm["e" /* display */], system_esm["f" /* flexbox */], system_esm["g" /* grid */], system_esm["i" /* positions */], system_esm["h" /* palette */], system_esm["j" /* shadows */], system_esm["k" /* sizing */], system_esm["l" /* spacing */], system_esm["m" /* typography */]));
/**
 * @ignore - do not document.
 */

var Box = styles_styled('div')(styleFunction, {
  name: 'MuiBox'
});
/* harmony default export */ var Box_Box = (Box);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Box/index.js

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(146);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js







var Typography_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography_Typography = /*#__PURE__*/react["forwardRef"](function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(capitalize["a" /* default */])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(capitalize["a" /* default */])(align))], display !== 'initial' && classes["display".concat(Object(capitalize["a" /* default */])(display))]),
    ref: ref
  }, other));
});
 false ? Typography_Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Typography_Typography = (Object(withStyles["a" /* default */])(Typography_styles, {
  name: 'MuiTypography'
})(Typography_Typography));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Typography/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var BreadcrumbCollapsed_styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react["createElement"](MoreHoriz, {
    className: classes.icon
  }));
}

 false ? BreadcrumbCollapsed.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (Object(withStyles["a" /* default */])(BreadcrumbCollapsed_styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react["createElement"]("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs_Breadcrumbs = /*#__PURE__*/react["forwardRef"](function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react["useState"](false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {
        console.error(['Material-UI: You have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
      }

      return allItems;
    }

    return [].concat(Object(toConsumableArray["a" /* default */])(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react["createElement"](Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], Object(toConsumableArray["a" /* default */])(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react["Children"].toArray(children).filter(function (child) {
    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/react["isValidElement"](child);
  }).map(function (child, index) {
    return /*#__PURE__*/react["createElement"]("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: Object(clsx_m["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/react["createElement"]("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? Breadcrumbs_Breadcrumbs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The breadcrumb children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  expandText: PropTypes.string,

  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   */
  itemsAfterCollapse: PropTypes.number,

  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   */
  itemsBeforeCollapse: PropTypes.number,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   */
  maxItems: PropTypes.number,

  /**
   * Custom separator node.
   */
  separator: PropTypes.node
} : void 0;
/* harmony default export */ var esm_Breadcrumbs_Breadcrumbs = (Object(withStyles["a" /* default */])(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs_Breadcrumbs));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js









var Button_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button_Button = /*#__PURE__*/react["forwardRef"](function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.startIcon, classes["iconSize".concat(Object(capitalize["a" /* default */])(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.endIcon, classes["iconSize".concat(Object(capitalize["a" /* default */])(size))])
  }, endIconProp);
  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(Object(capitalize["a" /* default */])(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(Object(capitalize["a" /* default */])(size))], classes["size".concat(Object(capitalize["a" /* default */])(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(clsx_m["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? Button_Button.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* harmony default export */ var esm_Button_Button = (Object(withStyles["a" /* default */])(Button_styles, {
  name: 'MuiButton'
})(Button_Button));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Button/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonGroup/ButtonGroup.js









 // Force a side effect so we don't have any override priority issue.
// eslint-disable-next-line no-unused-expressions

esm_Button_Button.styles;
var ButtonGroup_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none'
    },

    /* Pseudo-class applied to child elements if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the children. */
    grouped: {
      minWidth: 40
    },

    /* Styles applied to the children if `orientation="horizontal"`. */
    groupedHorizontal: {
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    /* Styles applied to the children if `orientation="vertical"`. */
    groupedVertical: {
      '&:not(:first-child)': {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },

    /* Styles applied to the children if `variant="text"`. */
    groupedText: {},

    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
    groupedTextHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
    groupedTextVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {
      '&:not(:last-child)': {
        borderColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {
      '&:not(:last-child)': {
        borderColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {},

    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
    groupedOutlinedHorizontal: {
      '&:not(:first-child)': {
        marginLeft: -1
      },
      '&:not(:last-child)': {
        borderRightColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
    groupedOutlinedVertical: {
      '&:not(:first-child)': {
        marginTop: -1
      },
      '&:not(:last-child)': {
        borderBottomColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {
      '&:hover': {
        borderColor: theme.palette.primary.main
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {
      '&:hover': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the children if `variant="contained"`. */
    groupedContained: {
      boxShadow: 'none'
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
    groupedContainedHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderRight: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
    groupedContainedVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.primary.dark
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.secondary.dark
      }
    }
  };
};
var ButtonGroup_ButtonGroup = /*#__PURE__*/react["forwardRef"](function ButtonGroup(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);

  var buttonClassName = Object(clsx_m["a" /* default */])(classes.grouped, classes["grouped".concat(Object(capitalize["a" /* default */])(orientation))], classes["grouped".concat(Object(capitalize["a" /* default */])(variant))], classes["grouped".concat(Object(capitalize["a" /* default */])(variant)).concat(Object(capitalize["a" /* default */])(orientation))], classes["grouped".concat(Object(capitalize["a" /* default */])(variant)).concat(color !== 'default' ? Object(capitalize["a" /* default */])(color) : '')], disabled && classes.disabled);
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    role: "group",
    className: Object(clsx_m["a" /* default */])(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other), react["Children"].map(children, function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/react["cloneElement"](child, {
      className: Object(clsx_m["a" /* default */])(buttonClassName, child.props.className),
      color: child.props.color || color,
      disabled: child.props.disabled || disabled,
      disableElevation: child.props.disableElevation || disableElevation,
      disableFocusRipple: disableFocusRipple,
      disableRipple: disableRipple,
      fullWidth: fullWidth,
      size: child.props.size || size,
      variant: child.props.variant || variant
    });
  }));
});
 false ? ButtonGroup_ButtonGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button group.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the buttons will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the button keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the button ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the buttons will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The group orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* harmony default export */ var esm_ButtonGroup_ButtonGroup = (Object(withStyles["a" /* default */])(ButtonGroup_styles, {
  name: 'MuiButtonGroup'
})(ButtonGroup_ButtonGroup));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ButtonGroup/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js







var Card_styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card_Card = /*#__PURE__*/react["forwardRef"](function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? Card_Card.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_Card_Card = (Object(withStyles["a" /* default */])(Card_styles, {
  name: 'MuiCard'
})(Card_Card));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Card/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardActionArea/CardActionArea.js







var CardActionArea_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      textAlign: 'inherit',
      width: '100%',
      '&:hover $focusHighlight': {
        opacity: theme.palette.action.hoverOpacity
      },
      '&$focusVisible $focusHighlight': {
        opacity: 0.12
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit',
      opacity: 0,
      backgroundColor: 'currentcolor',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    }
  };
};
var CardActionArea_CardActionArea = /*#__PURE__*/react["forwardRef"](function CardActionArea(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "focusVisibleClassName"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    focusVisibleClassName: Object(clsx_m["a" /* default */])(focusVisibleClassName, classes.focusVisible),
    ref: ref
  }, other), children, /*#__PURE__*/react["createElement"]("span", {
    className: classes.focusHighlight
  }));
});
 false ? CardActionArea_CardActionArea.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string
} : void 0;
/* harmony default export */ var esm_CardActionArea_CardActionArea = (Object(withStyles["a" /* default */])(CardActionArea_styles, {
  name: 'MuiCardActionArea'
})(CardActionArea_CardActionArea));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardActionArea/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardActions/CardActions.js






var CardActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var CardActions_CardActions = /*#__PURE__*/react["forwardRef"](function CardActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? CardActions_CardActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_CardActions_CardActions = (Object(withStyles["a" /* default */])(CardActions_styles, {
  name: 'MuiCardActions'
})(CardActions_CardActions));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardActions/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js






var CardContent_styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent_CardContent = /*#__PURE__*/react["forwardRef"](function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? CardContent_CardContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ var esm_CardContent_CardContent = (Object(withStyles["a" /* default */])(CardContent_styles, {
  name: 'MuiCardContent'
})(CardContent_CardContent));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardContent/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardHeader/CardHeader.js







var CardHeader_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader_CardHeader = /*#__PURE__*/react["forwardRef"](function CardHeader(props, ref) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);

  var title = titleProp;

  if (title != null && title.type !== esm_Typography_Typography && !disableTypography) {
    title = /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== esm_Typography_Typography && !disableTypography) {
    subheader = /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), avatar && /*#__PURE__*/react["createElement"]("div", {
    className: classes.avatar
  }, avatar), /*#__PURE__*/react["createElement"]("div", {
    className: classes.content
  }, title, subheader), action && /*#__PURE__*/react["createElement"]("div", {
    className: classes.action
  }, action));
});
 false ? CardHeader_CardHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: PropTypes.node,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * The content of the component.
   */
  subheader: PropTypes.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: PropTypes.object,

  /**
   * The content of the Card Title.
   */
  title: PropTypes.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_CardHeader_CardHeader = (Object(withStyles["a" /* default */])(CardHeader_styles, {
  name: 'MuiCardHeader'
})(CardHeader_CardHeader));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardHeader/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardMedia/CardMedia.js







var CardMedia_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  },

  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover'
  }
};
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
var CardMedia_CardMedia = /*#__PURE__*/react["forwardRef"](function CardMedia(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "image", "src", "style"]);

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? Object(esm_extends["a" /* default */])({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other), children);
});
 false ? CardMedia_CardMedia.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    if (!props.children && !props.image && !props.src && !props.component) {
      return new Error('Material-UI: Either `children`, `image`, `src` or `component` prop must be specified.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ var esm_CardMedia_CardMedia = (Object(withStyles["a" /* default */])(CardMedia_styles, {
  name: 'MuiCardMedia'
})(CardMedia_CardMedia));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CardMedia/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControlContext.js

/**
 * @ignore - internal component.
 */

var FormControlContext = react["createContext"]();

if (false) {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return react["useContext"](FormControlContext);
}
/* harmony default export */ var FormControl_FormControlContext = (FormControlContext);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControl/useFormControl.js


function useFormControl_useFormControl() {
  return react["useContext"](FormControl_FormControlContext);
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js











var SwitchBase_styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase_SwitchBase = /*#__PURE__*/react["forwardRef"](function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = useFormControl_useFormControl();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/react["createElement"](IconButton["default"], Object(esm_extends["a" /* default */])({
    component: "span",
    className: Object(clsx_m["a" /* default */])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("input", Object(esm_extends["a" /* default */])({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? SwitchBase_SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /*
   * @ignore
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var internal_SwitchBase = (Object(withStyles["a" /* default */])(SwitchBase_styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase_SwitchBase));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBoxOutlineBlank.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBoxOutlineBlank = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBox.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBox = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/IndeterminateCheckBox.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var IndeterminateCheckBox = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js













var Checkbox_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react["createElement"](CheckBox, null);
var defaultIcon = /*#__PURE__*/react["createElement"](CheckBoxOutlineBlank, null);
var defaultIndeterminateIcon = /*#__PURE__*/react["createElement"](IndeterminateCheckBox, null);
var Checkbox_Checkbox = /*#__PURE__*/react["forwardRef"](function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/react["createElement"](internal_SwitchBase, Object(esm_extends["a" /* default */])({
    type: "checkbox",
    classes: {
      root: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: Object(esm_extends["a" /* default */])({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react["cloneElement"](icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/react["cloneElement"](indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
 false ? Checkbox_Checkbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: PropTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: PropTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the checkbox.
   * `small` is equivalent to the dense checkbox styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_Checkbox_Checkbox = (Object(withStyles["a" /* default */])(Checkbox_styles, {
  name: 'MuiCheckbox'
})(Checkbox_Checkbox));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Checkbox/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/Cancel.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var Cancel = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Chip/Chip.js












var Chip_styles = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = Object(colorManipulator["d" /* fade */])(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: Object(colorManipulator["c" /* emphasize */])(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: Object(colorManipulator["d" /* fade */])(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: Object(colorManipulator["d" /* fade */])(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip_Chip = /*#__PURE__*/react["forwardRef"](function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = react["useRef"](null);
  var handleRef = Object(useForkRef["a" /* default */])(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? ButtonBase["a" /* default */] : 'div');
  var moreProps = Component === ButtonBase["a" /* default */] ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = Object(clsx_m["a" /* default */])(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(Object(capitalize["a" /* default */])(color))] : classes["deleteIconOutlinedColor".concat(Object(capitalize["a" /* default */])(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/react["isValidElement"](deleteIconProp) ? /*#__PURE__*/react["cloneElement"](deleteIconProp, {
      className: Object(clsx_m["a" /* default */])(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/react["createElement"](Cancel, {
      className: Object(clsx_m["a" /* default */])(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/react["isValidElement"](avatarProp)) {
    avatar = /*#__PURE__*/react["cloneElement"](avatarProp, {
      className: Object(clsx_m["a" /* default */])(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(Object(capitalize["a" /* default */])(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/react["isValidElement"](iconProp)) {
    icon = /*#__PURE__*/react["cloneElement"](iconProp, {
      className: Object(clsx_m["a" /* default */])(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(Object(capitalize["a" /* default */])(color))])
    });
  }

  if (false) {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    role: clickable || onDelete ? 'button' : undefined,
    className: Object(clsx_m["a" /* default */])(classes.root, className, color !== 'default' && [classes["color".concat(Object(capitalize["a" /* default */])(color))], clickable && classes["clickableColor".concat(Object(capitalize["a" /* default */])(color))], onDelete && classes["deletableColor".concat(Object(capitalize["a" /* default */])(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? Chip_Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Avatar element.
   */
  avatar: PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Icon element.
   */
  icon: PropTypes.element,

  /**
   * The content of the label.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The size of the chip.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['default', 'outlined'])
} : void 0;
/* harmony default export */ var esm_Chip_Chip = (Object(withStyles["a" /* default */])(Chip_styles, {
  name: 'MuiChip'
})(Chip_Chip));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Chip/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js








var SIZE = 44;
var CircularProgress_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress_CircularProgress = /*#__PURE__*/react["forwardRef"](function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(capitalize["a" /* default */])(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: Object(esm_extends["a" /* default */])({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/react["createElement"]("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/react["createElement"]("circle", {
    className: Object(clsx_m["a" /* default */])(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? CircularProgress_CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
/* harmony default export */ var esm_CircularProgress_CircularProgress = (Object(withStyles["a" /* default */])(CircularProgress_styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress_CircularProgress));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/index.js

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(116);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(147);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js








function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = react["useRef"](false);
  var nodeRef = react["useRef"](null);
  var activatedRef = react["useRef"](false);
  var syntheticEventRef = react["useRef"](false);
  react["useEffect"](function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    nodeRef.current = react_dom["findDOMNode"](instance);
  }, []);
  var handleRef = Object(useForkRef["a" /* default */])(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = Object(useEventCallback["a" /* default */])(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = Object(ownerDocument["a" /* default */])(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  react["useEffect"](function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = Object(ownerDocument["a" /* default */])(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  react["useEffect"](function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = Object(ownerDocument["a" /* default */])(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["cloneElement"](children, childrenProps));
}

 false ? ClickAwayListener.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   */
  disableReactTree: PropTypes.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: PropTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (false) {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

/* harmony default export */ var ClickAwayListener_ClickAwayListener = (ClickAwayListener);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js








var Container_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(defineProperty["a" /* default */])({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container_Container = /*#__PURE__*/react["forwardRef"](function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat(Object(capitalize["a" /* default */])(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? Container_Container.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: PropTypes.bool,

  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false])
} : void 0;
/* harmony default export */ var esm_Container_Container = (Object(withStyles["a" /* default */])(Container_styles, {
  name: 'MuiContainer'
})(Container_Container));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Container/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CssBaseline/CssBaseline.js





var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var CssBaseline_body = function body(theme) {
  return Object(esm_extends["a" /* default */])({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var CssBaseline_styles = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: Object(esm_extends["a" /* default */])({
        margin: 0
      }, CssBaseline_body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      classes = props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/react["createElement"](react["Fragment"], null, children);
}

 false ? CssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;

if (false) {
  // eslint-disable-next-line
  CssBaseline['propTypes' + ''] = exactProp(CssBaseline.propTypes);
}

/* harmony default export */ var CssBaseline_CssBaseline = (Object(withStyles["a" /* default */])(CssBaseline_styles, {
  name: 'MuiCssBaseline'
})(CssBaseline));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/CssBaseline/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/index.js + 3 modules
var Modal = __webpack_require__(259);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js













var Dialog_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog_Dialog = /*#__PURE__*/react["forwardRef"](function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper["a" /* default */] : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Fade_Fade : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = Object(objectWithoutProperties["a" /* default */])(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = react["useRef"]();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/react["createElement"](Modal["b" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    BackdropComponent: esm_Backdrop_Backdrop,
    BackdropProps: Object(esm_extends["a" /* default */])({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.container, classes["scroll".concat(Object(capitalize["a" /* default */])(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/react["createElement"](PaperComponent, Object(esm_extends["a" /* default */])({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: Object(clsx_m["a" /* default */])(classes.paper, classes["paperScroll".concat(Object(capitalize["a" /* default */])(scroll))], classes["paperWidth".concat(Object(capitalize["a" /* default */])(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? Dialog_Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Dialog_Dialog = (Object(withStyles["a" /* default */])(Dialog_styles, {
  name: 'MuiDialog'
})(Dialog_Dialog));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Dialog/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogActions/DialogActions.js






var DialogActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions_DialogActions = /*#__PURE__*/react["forwardRef"](function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? DialogActions_DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_DialogActions_DialogActions = (Object(withStyles["a" /* default */])(DialogActions_styles, {
  name: 'MuiDialogActions'
})(DialogActions_DialogActions));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogActions/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js






var DialogContent_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent_DialogContent = /*#__PURE__*/react["forwardRef"](function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
 false ? DialogContent_DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_DialogContent_DialogContent = (Object(withStyles["a" /* default */])(DialogContent_styles, {
  name: 'MuiDialogContent'
})(DialogContent_DialogContent));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogContent/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogContentText/DialogContentText.js





var DialogContentText_styles = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText_DialogContentText = /*#__PURE__*/react["forwardRef"](function DialogContentText(props, ref) {
  return /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
 false ? DialogContentText_DialogContentText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;
/* harmony default export */ var esm_DialogContentText_DialogContentText = (Object(withStyles["a" /* default */])(DialogContentText_styles, {
  name: 'MuiDialogContentText'
})(DialogContentText_DialogContentText));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogContentText/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js







var DialogTitle_styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle_DialogTitle = /*#__PURE__*/react["forwardRef"](function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "disableTypography"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? DialogTitle_DialogTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_DialogTitle_DialogTitle = (Object(withStyles["a" /* default */])(DialogTitle_styles, {
  name: 'MuiDialogTitle'
})(DialogTitle_DialogTitle));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/DialogTitle/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js







var Divider_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider_Divider = /*#__PURE__*/react["forwardRef"](function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? Divider_Divider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Absolutely position the element.
   */
  absolute: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   */
  flexItem: PropTypes.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: PropTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
/* harmony default export */ var esm_Divider_Divider = (Object(withStyles["a" /* default */])(Divider_styles, {
  name: 'MuiDivider'
})(Divider_Divider));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Divider/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(188);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Slide/Slide.js











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var Slide_defaultTimeout = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide_Slide = /*#__PURE__*/react["forwardRef"](function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? Slide_defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group_esm["a" /* Transition */] : _props$TransitionComp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(useTheme["a" /* default */])();
  var childrenRef = react["useRef"](null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    childrenRef.current = react_dom["findDOMNode"](instance);
  }, []);
  var handleRefIntermediary = Object(useForkRef["a" /* default */])(children.ref, handleOwnRef);
  var handleRef = Object(useForkRef["a" /* default */])(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    Object(transitions_utils["b" /* reflow */])(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(esm_extends["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', Object(esm_extends["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(esm_extends["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', Object(esm_extends["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = react["useCallback"](function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  react["useEffect"](function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = Object(debounce["a" /* default */])(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  react["useEffect"](function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react["cloneElement"](children, Object(esm_extends["a" /* default */])({
      ref: handleRef,
      style: Object(esm_extends["a" /* default */])({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? Slide_Slide.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: elementAcceptingRef,

  /**
   * Direction the child node will enter from.
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ var esm_Slide_Slide = (Slide_Slide);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Slide/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js













var Drawer_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var Drawer_defaultTransitionDuration = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

var Drawer_Drawer = /*#__PURE__*/react["forwardRef"](function Drawer(props, ref) {
  var _props$anchor = props.anchor,
      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
      BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropPropsProp = _props$ModalProps.BackdropProps,
      ModalProps = Object(objectWithoutProperties["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SlideProps = props.SlideProps,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Slide_Slide : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? Drawer_defaultTransitionDuration : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);

  var theme = Object(useTheme["a" /* default */])(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  var mounted = react["useRef"](false);
  react["useEffect"](function () {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: Object(clsx_m["a" /* default */])(classes.paper, classes["paperAnchor".concat(Object(capitalize["a" /* default */])(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat(Object(capitalize["a" /* default */])(anchor))])
  }), children);

  if (variant === 'permanent') {
    return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
      className: Object(clsx_m["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }

  var slidingDrawer = /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);

  if (variant === 'persistent') {
    return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
      className: Object(clsx_m["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  } // variant === temporary


  return /*#__PURE__*/react["createElement"](Modal["b" /* default */], Object(esm_extends["a" /* default */])({
    BackdropProps: Object(esm_extends["a" /* default */])({}, BackdropProps, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    BackdropComponent: esm_Backdrop_Backdrop,
    className: Object(clsx_m["a" /* default */])(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
 false ? Drawer_Drawer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Side from which the drawer will appear.
   */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * The contents of the drawer.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The elevation of the drawer.
   */
  elevation: PropTypes.number,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* harmony default export */ var esm_Drawer_Drawer = (Object(withStyles["a" /* default */])(Drawer_styles, {
  name: 'MuiDrawer',
  flip: false
})(Drawer_Drawer));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Drawer/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanel/ExpansionPanelContext.js

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = react["createContext"]({});

if (false) {
  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
}

/* harmony default export */ var ExpansionPanel_ExpansionPanelContext = (ExpansionPanelContext);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanel/ExpansionPanel.js














var ExpansionPanel_styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
 *
 * You should use `import { Accordion } from '@material-ui/core'`
 * or `import Accordion from '@material-ui/core/Accordion'`.
 */

var ExpansionPanel_ExpansionPanel = /*#__PURE__*/react["forwardRef"](function ExpansionPanel(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanel component was renamed to Accordion to use a more common naming convention.', '', "You should use `import { Accordion } from '@material-ui/core'`", "or `import Accordion from '@material-ui/core/Accordion'`"].join('\n'));
    }
  }

  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Collapse_Collapse : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'ExpansionPanel',
    state: 'expanded'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = react["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = react["Children"].toArray(childrenProp),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = react["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/react["createElement"](ExpansionPanel_ExpansionPanelContext.Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/react["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? ExpansionPanel_ExpansionPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of ExpansionPanel to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the panel.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_ExpansionPanel_ExpansionPanel = (Object(withStyles["a" /* default */])(ExpansionPanel_styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel_ExpansionPanel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanel/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelActions/ExpansionPanelActions.js






var ExpansionPanelActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var ExpansionPanelActions_warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.
 *
 * You should use `import { AccordionActions } from '@material-ui/core'`
 * or `import AccordionActions from '@material-ui/core/AccordionActions'`.
 */

var ExpansionPanelActions_ExpansionPanelActions = /*#__PURE__*/react["forwardRef"](function ExpansionPanelActions(props, ref) {
  if (false) {
    if (!ExpansionPanelActions_warnedOnce) {
      ExpansionPanelActions_warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.', '', "You should use `import { AccordionActions } from '@material-ui/core'`", "or `import AccordionActions from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? ExpansionPanelActions_ExpansionPanelActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_ExpansionPanelActions_ExpansionPanelActions = (Object(withStyles["a" /* default */])(ExpansionPanelActions_styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions_ExpansionPanelActions));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelActions/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelDetails/ExpansionPanelDetails.js






var ExpansionPanelDetails_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var ExpansionPanelDetails_warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.
 *
 * You should use `import { AccordionDetails } from '@material-ui/core'`
 * or `import AccordionDetails from '@material-ui/core/AccordionDetails'`.
 */

var ExpansionPanelDetails_ExpansionPanelDetails = /*#__PURE__*/react["forwardRef"](function ExpansionPanelDetails(props, ref) {
  if (false) {
    if (!ExpansionPanelDetails_warnedOnce) {
      ExpansionPanelDetails_warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.', '', "You should use `import { AccordionDetails } from '@material-ui/core'`", "or `import AccordionDetails from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ExpansionPanelDetails_ExpansionPanelDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var esm_ExpansionPanelDetails_ExpansionPanelDetails = (Object(withStyles["a" /* default */])(ExpansionPanelDetails_styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails_ExpansionPanelDetails));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelDetails/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelSummary/ExpansionPanelSummary.js



/* eslint-disable jsx-a11y/aria-role */







var ExpansionPanelSummary_styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var ExpansionPanelSummary_warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.
 *
 * You should use `import { AccordionSummary } from '@material-ui/core'`
 * or `import AccordionSummary from '@material-ui/core/AccordionSummary'`.
 */

var ExpansionPanelSummary_ExpansionPanelSummary = /*#__PURE__*/react["forwardRef"](function ExpansionPanelSummary(props, ref) {
  if (false) {
    if (!ExpansionPanelSummary_warnedOnce) {
      ExpansionPanelSummary_warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.', '', "You should use `import { AccordionSummary } from '@material-ui/core'`", "or `import AccordionSummary from '@material-ui/core/AccordionSummary'`"].join('\n'));
    }
  }

  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = react["useState"](false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = react["useContext"](ExpansionPanel_ExpansionPanelContext),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(clsx_m["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/react["createElement"](IconButton["default"], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? ExpansionPanelSummary_ExpansionPanelSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* harmony default export */ var esm_ExpansionPanelSummary_ExpansionPanelSummary = (Object(withStyles["a" /* default */])(ExpansionPanelSummary_styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary_ExpansionPanelSummary));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ExpansionPanelSummary/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Fab/Fab.js








var Fab_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minHeight: 36,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: 'none'
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minHeight: 'auto',
      minWidth: 48,
      height: 48,
      '&$sizeSmall': {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      '&$sizeMedium': {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};
var Fab_Fab = /*#__PURE__*/react["forwardRef"](function Fab(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'round' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat(Object(capitalize["a" /* default */])(size))], disabled && classes.disabled, {
      'primary': classes.primary,
      'secondary': classes.secondary,
      'inherit': classes.colorInherit
    }[color]),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(clsx_m["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? Fab_Fab.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['extended', 'round'])
} : void 0;
/* harmony default export */ var esm_Fab_Fab = (Object(withStyles["a" /* default */])(Fab_styles, {
  name: 'MuiFab'
})(Fab_Fab));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Fab/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControl/formControlState.js
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TextareaAutosize/TextareaAutosize.js







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
var TextareaAutosize_styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize_TextareaAutosize = /*#__PURE__*/react["forwardRef"](function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$rowsMin = props.rowsMin,
      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
      style = props.style,
      value = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);

  var rowsMin = rows || rowsMinProp;

  var _React$useRef = react["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = react["useRef"](null);
  var handleRef = Object(useForkRef["a" /* default */])(ref, inputRef);
  var shadowRef = react["useRef"](null);
  var renders = react["useRef"](0);

  var _React$useState = react["useState"]({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = react["useCallback"](function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (rowsMin) {
      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
    }

    if (rowsMax) {
      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (false) {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [rowsMax, rowsMin, props.placeholder]);
  react["useEffect"](function () {
    var handleResize = Object(debounce["a" /* default */])(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });
  react["useEffect"](function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"]("textarea", Object(esm_extends["a" /* default */])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: rowsMin,
    style: Object(esm_extends["a" /* default */])({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/react["createElement"]("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(esm_extends["a" /* default */])({}, TextareaAutosize_styles.shadow, style)
  }));
});
 false ? TextareaAutosize_TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Use `rowsMin` instead. The prop will be removed in v5.
   *
   * @deprecated
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
/* harmony default export */ var esm_TextareaAutosize_TextareaAutosize = (TextareaAutosize_TextareaAutosize);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TextareaAutosize/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputBase/utils.js
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js




/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */











var InputBase_styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var InputBase_useEnhancedEffect = typeof window === 'undefined' ? react["useEffect"] : react["useLayoutEffect"];
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase_InputBase = /*#__PURE__*/react["forwardRef"](function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = react["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = react["useRef"]();
  var handleInputRefWarning = react["useCallback"](function (instance) {
    if (false) {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(useForkRef["a" /* default */])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(useForkRef["a" /* default */])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(useForkRef["a" /* default */])(inputRef, handleInputRefProp);

  var _React$useState = react["useState"](false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = useFormControl();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  react["useEffect"](function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = react["useCallback"](function (obj) {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  InputBase_useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : Object(esm["b" /* formatMuiErrorMessage */])(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  react["useEffect"](function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(esm_extends["a" /* default */])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(esm_extends["a" /* default */])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(esm_extends["a" /* default */])({
        rows: rows,
        rowsMax: rowsMax
      }, inputProps);
      InputComponent = esm_TextareaAutosize_TextareaAutosize;
    }
  } else {
    inputProps = Object(esm_extends["a" /* default */])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  react["useEffect"](function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/react["createElement"](FormControl_FormControlContext.Provider, {
    value: null
  }, /*#__PURE__*/react["createElement"](InputComponent, Object(esm_extends["a" /* default */])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(clsx_m["a" /* default */])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(esm_extends["a" /* default */])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase_InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_InputBase_InputBase = (Object(withStyles["a" /* default */])(InputBase_styles, {
  name: 'MuiInputBase'
})(InputBase_InputBase));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputBase/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FilledInput/FilledInput.js








var FilledInput_styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput_FilledInput = /*#__PURE__*/react["forwardRef"](function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/react["createElement"](esm_InputBase_InputBase, Object(esm_extends["a" /* default */])({
    classes: Object(esm_extends["a" /* default */])({}, classes, {
      root: Object(clsx_m["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput_FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput_FilledInput.muiName = 'Input';
/* harmony default export */ var esm_FilledInput_FilledInput = (Object(withStyles["a" /* default */])(FilledInput_styles, {
  name: 'MuiFilledInput'
})(FilledInput_FilledInput));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FilledInput/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(257);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js










var FormControl_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl_FormControl = /*#__PURE__*/react["forwardRef"](function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = react["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      react["Children"].forEach(children, function (child) {
        if (!Object(isMuiElement["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        var input = Object(isMuiElement["a" /* default */])(child, ['Select']) ? child.props.input : child;

        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = react["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      react["Children"].forEach(children, function (child) {
        if (!Object(isMuiElement["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        if (isFilled(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = react["useState"](false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = react["useCallback"](function () {
    setFilled(true);
  }, []);
  var onEmpty = react["useCallback"](function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/react["createElement"](FormControl_FormControlContext.Provider, {
    value: childContext
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, margin !== 'none' && classes["margin".concat(Object(capitalize["a" /* default */])(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
 false ? FormControl_FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the form control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ var esm_FormControl_FormControl = (Object(withStyles["a" /* default */])(FormControl_styles, {
  name: 'MuiFormControl'
})(FormControl_FormControl));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControl/index.js


// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js










var FormControlLabel_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel_FormControlLabel = /*#__PURE__*/react["forwardRef"](function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = useFormControl_useFormControl();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/react["createElement"]("label", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(Object(capitalize["a" /* default */])(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/react["cloneElement"](control, controlProps), /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    component: "span",
    className: Object(clsx_m["a" /* default */])(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? FormControlLabel_FormControlLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: PropTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_FormControlLabel_FormControlLabel = (Object(withStyles["a" /* default */])(FormControlLabel_styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel_FormControlLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js






var FormGroup_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup_FormGroup = /*#__PURE__*/react["forwardRef"](function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "row"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? FormGroup_FormGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display group of elements in a compact row.
   */
  row: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_FormGroup_FormGroup = (Object(withStyles["a" /* default */])(FormGroup_styles, {
  name: 'MuiFormGroup'
})(FormGroup_FormGroup));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormGroup/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js








var FormHelperText_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText_FormHelperText = /*#__PURE__*/react["forwardRef"](function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = useFormControl_useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  react["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
 false ? FormHelperText_FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ var esm_FormHelperText_FormHelperText = (Object(withStyles["a" /* default */])(FormHelperText_styles, {
  name: 'MuiFormHelperText'
})(FormHelperText_FormHelperText));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormLabel/FormLabel.js









var FormLabel_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel_FormLabel = /*#__PURE__*/react["forwardRef"](function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = useFormControl_useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/react["createElement"]("span", {
    "aria-hidden": true,
    className: Object(clsx_m["a" /* default */])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
 false ? FormLabel_FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_FormLabel_FormLabel = (Object(withStyles["a" /* default */])(FormLabel_styles, {
  name: 'MuiFormLabel'
})(FormLabel_FormLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/FormLabel/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
var utils_requirePropFactory = __webpack_require__(649);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/





var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object(esm_extends["a" /* default */])(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var Grid_styles = function styles(theme) {
  return Object(esm_extends["a" /* default */])({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid_Grid = /*#__PURE__*/react["forwardRef"](function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = Object(clsx_m["a" /* default */])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: className,
    ref: ref
  }, other));
});
 false ? Grid_Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = Object(withStyles["a" /* default */])(Grid_styles, {
  name: 'MuiGrid'
})(Grid_Grid);

if (false) {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

/* harmony default export */ var esm_Grid_Grid = (StyledGrid);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Grid/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridList/GridList.js







var GridList_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var GridList_GridList = /*#__PURE__*/react["forwardRef"](function GridList(props, ref) {
  var _props$cellHeight = props.cellHeight,
      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
      style = props.style,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref,
    style: Object(esm_extends["a" /* default */])({
      margin: -spacing / 2
    }, style)
  }, other), react["Children"].map(children, function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/react["cloneElement"](child, {
      style: Object(esm_extends["a" /* default */])({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? GridList_GridList.propTypes = {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Number of columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: PropTypes.number,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ var esm_GridList_GridList = (Object(withStyles["a" /* default */])(GridList_styles, {
  name: 'MuiGridList'
})(GridList_GridList));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridList/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridListTile/GridListTile.js









var GridListTile_styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var GridListTile_fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, Object(toConsumableArray["a" /* default */])(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, Object(toConsumableArray["a" /* default */])(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, Object(toConsumableArray["a" /* default */])(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, Object(toConsumableArray["a" /* default */])(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    GridListTile_fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      GridListTile_fit(imgEl, classes);
    });
  }
}

var GridListTile_GridListTile = /*#__PURE__*/react["forwardRef"](function GridListTile(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = react["useRef"](null);
  react["useEffect"](function () {
    ensureImageCover(imgRef.current, classes);
  });
  react["useEffect"](function () {
    var handleResize = Object(debounce["a" /* default */])(function () {
      GridListTile_fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: classes.tile
  }, react["Children"].map(children, function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (child.type === 'img' || Object(isMuiElement["a" /* default */])(child, ['Image'])) {
      return /*#__PURE__*/react["cloneElement"](child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? GridListTile_GridListTile.propTypes = {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Height of the tile in number of grid cells.
   */
  rows: PropTypes.number
} : void 0;
/* harmony default export */ var esm_GridListTile_GridListTile = (Object(withStyles["a" /* default */])(GridListTile_styles, {
  name: 'MuiGridListTile'
})(GridListTile_GridListTile));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridListTile/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridListTileBar/GridListTileBar.js






var GridListTileBar_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var GridListTileBar_GridListTileBar = /*#__PURE__*/react["forwardRef"](function GridListTileBar(props, ref) {
  var actionIcon = props.actionIcon,
      _props$actionPosition = props.actionPosition,
      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
      classes = props.classes,
      className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _props$titlePosition = props.titlePosition,
      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);

  var actionPos = actionIcon && actionPosition;
  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.titleWrap, {
      'left': classes.titleWrapActionPosLeft,
      'right': classes.titleWrapActionPosRight
    }[actionPos])
  }, /*#__PURE__*/react["createElement"]("div", {
    className: classes.title
  }, title), subtitle ? /*#__PURE__*/react["createElement"]("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? GridListTileBar_GridListTileBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: PropTypes.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: PropTypes.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: PropTypes.node,

  /**
   * Title to be displayed on tile.
   */
  title: PropTypes.node,

  /**
   * Position of the title bar.
   */
  titlePosition: PropTypes.oneOf(['bottom', 'top'])
} : void 0;
/* harmony default export */ var esm_GridListTileBar_GridListTileBar = (Object(withStyles["a" /* default */])(GridListTileBar_styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar_GridListTileBar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/GridListTileBar/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/index.js + 1 modules
var Grow = __webpack_require__(260);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(136);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js
var createBreakpoints = __webpack_require__(642);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = Object(styles_esm["k" /* useTheme */])();
  var props = Object(styles_esm["f" /* getThemeProps */])({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = Object(esm_extends["a" /* default */])({}, props, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$matchM = _props$options.matchMedia,
      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = react["useState"](function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  react["useEffect"](function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query: query,
      match: match
    });
  }

  return match;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/withWidth/withWidth.js









 // By default, returns true if screen width is the same or greater than the given breakpoint.

var withWidth_isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return createBreakpoints["b" /* keys */].indexOf(breakpoint) <= createBreakpoints["b" /* keys */].indexOf(width);
  }

  return createBreakpoints["b" /* keys */].indexOf(breakpoint) < createBreakpoints["b" /* keys */].indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

var withWidth_isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return createBreakpoints["b" /* keys */].indexOf(width) <= createBreakpoints["b" /* keys */].indexOf(breakpoint);
  }

  return createBreakpoints["b" /* keys */].indexOf(width) < createBreakpoints["b" /* keys */].indexOf(breakpoint);
};
var withWidth_useEnhancedEffect = typeof window === 'undefined' ? react["useEffect"] : react["useLayoutEffect"];

var withWidth_withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth;

    function WithWidth(props) {
      var contextTheme = Object(useTheme["a" /* default */])();
      var theme = props.theme || contextTheme;

      var _getThemeProps = Object(styles_esm["f" /* getThemeProps */])({
        theme: theme,
        name: 'MuiWithWidth',
        props: Object(esm_extends["a" /* default */])({}, props)
      }),
          initialWidth = _getThemeProps.initialWidth,
          width = _getThemeProps.width,
          other = Object(objectWithoutProperties["a" /* default */])(_getThemeProps, ["initialWidth", "width"]);

      var _React$useState = react["useState"](false),
          mountedState = _React$useState[0],
          setMountedState = _React$useState[1];

      withWidth_useEnhancedEffect(function () {
        setMountedState(true);
      }, []);
      /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */

      var keys = theme.breakpoints.keys.slice().reverse();
      var widthComputed = keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);

      var more = Object(esm_extends["a" /* default */])({
        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme: theme
      } : {}, other); // When rendering the component on the server,
      // we have no idea about the client browser screen width.
      // In order to prevent blinks and help the reconciliation of the React tree
      // we are not rendering the child component.
      //
      // An alternative is to use the `initialWidth` property.


      if (more.width === undefined) {
        return null;
      }

      return /*#__PURE__*/react["createElement"](Component, more);
    }

     false ? WithWidth.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: PropTypes.object,

      /**
       * Bypass the width calculation logic.
       */
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat(getDisplayName(Component), ")");
    }

    hoist_non_react_statics_cjs_default()(WithWidth, Component);
    return WithWidth;
  };
};

/* harmony default export */ var esm_withWidth_withWidth = (withWidth_withWidth);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/withWidth/index.js


// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Hidden/HiddenJs.js




/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var theme = Object(useTheme["a" /* default */])();
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && withWidth_isWidthUp(_breakpoint, width) || breakpointDown && withWidth_isWidthDown(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: prop_types_default.a.node,

  /**
   * @ignore
   */
  className: prop_types_default.a.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: prop_types_default.a.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: prop_types_default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: prop_types_default.a.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: prop_types_default.a.oneOfType([prop_types_default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), prop_types_default.a.arrayOf(prop_types_default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: prop_types_default.a.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: prop_types_default.a.string.isRequired,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: prop_types_default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: prop_types_default.a.bool
};

if (false) {
  HiddenJs.propTypes = exactProp(HiddenJs.propTypes);
}

/* harmony default export */ var Hidden_HiddenJs = (esm_withWidth_withWidth()(HiddenJs));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Hidden/HiddenCss.js








var HiddenCss_styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return theme.breakpoints.keys.reduce(function (acc, key) {
    acc["only".concat(Object(capitalize["a" /* default */])(key))] = Object(defineProperty["a" /* default */])({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = Object(defineProperty["a" /* default */])({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = Object(defineProperty["a" /* default */])({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      only = props.only,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "only"]);

  var theme = Object(useTheme["a" /* default */])();

  if (false) {
    var unknownProps = Object.keys(other).filter(function (propName) {
      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
      });
      return isUndeclaredBreakpoint;
    });

    if (unknownProps.length > 0) {
      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
    }
  }

  var clsx = [];

  if (className) {
    clsx.push(className);
  }

  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      clsx.push(classes["only".concat(Object(capitalize["a" /* default */])(breakpoint))]);
    });
  }

  return /*#__PURE__*/react["createElement"]("div", {
    className: clsx.join(' ')
  }, children);
}

 false ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* harmony default export */ var Hidden_HiddenCss = (Object(withStyles["a" /* default */])(HiddenCss_styles, {
  name: 'PrivateHiddenCss'
})(HiddenCss));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js






/**
 * Responsively hides children based on the selected implementation.
 */

function Hidden(props) {
  var _props$implementation = props.implementation,
      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
      _props$lgDown = props.lgDown,
      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
      _props$lgUp = props.lgUp,
      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
      _props$mdDown = props.mdDown,
      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
      _props$mdUp = props.mdUp,
      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
      _props$smDown = props.smDown,
      smDown = _props$smDown === void 0 ? false : _props$smDown,
      _props$smUp = props.smUp,
      smUp = _props$smUp === void 0 ? false : _props$smUp,
      _props$xlDown = props.xlDown,
      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
      _props$xlUp = props.xlUp,
      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
      _props$xsDown = props.xsDown,
      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
      _props$xsUp = props.xsUp,
      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);

  if (implementation === 'js') {
    return /*#__PURE__*/react["createElement"](Hidden_HiddenJs, Object(esm_extends["a" /* default */])({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }

  return /*#__PURE__*/react["createElement"](Hidden_HiddenCss, Object(esm_extends["a" /* default */])({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}

 false ? Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* harmony default export */ var Hidden_Hidden = (Hidden);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Hidden/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js







var Icon_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: theme.typography.pxToRem(24),
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(36)
    }
  };
};
var Icon_Icon = /*#__PURE__*/react["forwardRef"](function Icon(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "component", "fontSize"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat(Object(capitalize["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(capitalize["a" /* default */])(fontSize))]),
    "aria-hidden": true,
    ref: ref
  }, other));
});
 false ? Icon_Icon.propTypes = {
  /**
   * The name of the icon font ligature.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large'])
} : void 0;
Icon_Icon.muiName = 'Icon';
/* harmony default export */ var esm_Icon_Icon = (Object(withStyles["a" /* default */])(Icon_styles, {
  name: 'MuiIcon'
})(Icon_Icon));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Icon/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js








var Input_styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input_Input = /*#__PURE__*/react["forwardRef"](function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/react["createElement"](esm_InputBase_InputBase, Object(esm_extends["a" /* default */])({
    classes: Object(esm_extends["a" /* default */])({}, classes, {
      root: Object(clsx_m["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input_Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input_Input.muiName = 'Input';
/* harmony default export */ var esm_Input_Input = (Object(withStyles["a" /* default */])(Input_styles, {
  name: 'MuiInput'
})(Input_Input));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Input/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js








var InputAdornment_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment_InputAdornment = /*#__PURE__*/react["forwardRef"](function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = useFormControl() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/react["createElement"](FormControl_FormControlContext.Provider, {
    value: null
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
      'start': classes.positionStart,
      'end': classes.positionEnd
    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    color: "textSecondary"
  }, children) : children));
});
 false ? InputAdornment_InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['start', 'end']),

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ var esm_InputAdornment_InputAdornment = (Object(withStyles["a" /* default */])(InputAdornment_styles, {
  name: 'MuiInputAdornment'
})(InputAdornment_InputAdornment));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js









var InputLabel_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel_InputLabel = /*#__PURE__*/react["forwardRef"](function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = useFormControl_useFormControl();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/react["createElement"](esm_FormLabel_FormLabel, Object(esm_extends["a" /* default */])({
    "data-shrink": shrink,
    className: Object(clsx_m["a" /* default */])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
 false ? InputLabel_InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the `InputLabel`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ var esm_InputLabel_InputLabel = (Object(withStyles["a" /* default */])(InputLabel_styles, {
  name: 'MuiInputLabel'
})(InputLabel_InputLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/InputLabel/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js









var TRANSITION_DURATION = 4; // seconds

var LinearProgress_styles = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? Object(colorManipulator["i" /* lighten */])(color, 0.62) : Object(colorManipulator["a" /* darken */])(color, 0.5);
  };

  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4,
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },

    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0 -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0 -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var LinearProgress_LinearProgress = /*#__PURE__*/react["forwardRef"](function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);

  var theme = Object(useTheme["a" /* default */])();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }

      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(color))], className, {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'buffer': classes.buffer,
      'query': classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.dashed, classes["dashedColor".concat(Object(capitalize["a" /* default */])(color))])
  }) : null, /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.bar, classes["barColor".concat(Object(capitalize["a" /* default */])(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      'determinate': classes.bar1Determinate,
      'buffer': classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(Object(capitalize["a" /* default */])(color))], classes.bar2Buffer] : classes["barColor".concat(Object(capitalize["a" /* default */])(color))]),
    style: inlineStyles.bar2
  }));
});
 false ? LinearProgress_LinearProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
/* harmony default export */ var esm_LinearProgress_LinearProgress = (Object(withStyles["a" /* default */])(LinearProgress_styles, {
  name: 'MuiLinearProgress'
})(LinearProgress_LinearProgress));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(258);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js











var Link_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link_Link = /*#__PURE__*/react["forwardRef"](function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = Object(useIsFocusVisible["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = react["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = Object(useForkRef["a" /* default */])(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["underline".concat(Object(capitalize["a" /* default */])(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? Link_Link.propTypes = {
  /**
   * The content of the link.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the link.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,

  /**
   * Controls when the link should have an underline.
   */
  underline: PropTypes.oneOf(['none', 'hover', 'always']),

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.string
} : void 0;
/* harmony default export */ var esm_Link_Link = (Object(withStyles["a" /* default */])(Link_styles, {
  name: 'MuiLink'
})(Link_Link));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Link/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/index.js + 1 modules
var List = __webpack_require__(442);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/index.js + 1 modules
var ListItem = __webpack_require__(443);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(261);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemAvatar/ListItemAvatar.js







var ListItemAvatar_styles = {
  /* Styles applied to the root element. */
  root: {
    minWidth: 56,
    flexShrink: 0
  },

  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    marginTop: 8
  }
};
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */

var ListItemAvatar_ListItemAvatar = /*#__PURE__*/react["forwardRef"](function ListItemAvatar(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className"]);

  var context = react["useContext"](ListContext["a" /* default */]);
  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemAvatar_ListItemAvatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component – normally `Avatar`.
   */
  children: PropTypes.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var esm_ListItemAvatar_ListItemAvatar = (Object(withStyles["a" /* default */])(ListItemAvatar_styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar_ListItemAvatar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemAvatar/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js







var ListItemIcon_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon_ListItemIcon = /*#__PURE__*/react["forwardRef"](function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className"]);

  var context = react["useContext"](ListContext["a" /* default */]);
  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemIcon_ListItemIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var esm_ListItemIcon_ListItemIcon = (Object(withStyles["a" /* default */])(ListItemIcon_styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon_ListItemIcon));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemIcon/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/ListItemSecondaryAction.js






var ListItemSecondaryAction_styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

var ListItemSecondaryAction_ListItemSecondaryAction = /*#__PURE__*/react["forwardRef"](function ListItemSecondaryAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ListItemSecondaryAction_ListItemSecondaryAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
ListItemSecondaryAction_ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* harmony default export */ var esm_ListItemSecondaryAction_ListItemSecondaryAction = (Object(withStyles["a" /* default */])(ListItemSecondaryAction_styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction_ListItemSecondaryAction));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js








var ListItemText_styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText_ListItemText = /*#__PURE__*/react["forwardRef"](function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = react["useContext"](ListContext["a" /* default */]),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== esm_Typography_Typography && !disableTypography) {
    primary = /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== esm_Typography_Typography && !disableTypography) {
    secondary = /*#__PURE__*/react["createElement"](esm_Typography_Typography, Object(esm_extends["a" /* default */])({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? ListItemText_ListItemText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: PropTypes.bool,

  /**
   * The main content element.
   */
  primary: PropTypes.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: PropTypes.object,

  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_ListItemText_ListItemText = (Object(withStyles["a" /* default */])(ListItemText_styles, {
  name: 'MuiListItemText'
})(ListItemText_ListItemText));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListItemText/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js







var ListSubheader_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader_ListSubheader = /*#__PURE__*/react["forwardRef"](function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(capitalize["a" /* default */])(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? ListSubheader_ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_ListSubheader_ListSubheader = (Object(withStyles["a" /* default */])(ListSubheader_styles, {
  name: 'MuiListSubheader'
})(ListSubheader_ListSubheader));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/ListSubheader/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/index.js
var Menu = __webpack_require__(330);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/index.js + 1 modules
var MenuItem = __webpack_require__(262);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuList/index.js + 1 modules
var MenuList = __webpack_require__(445);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MobileStepper/MobileStepper.js










var MobileStepper_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};
var MobileStepper_MobileStepper = /*#__PURE__*/react["forwardRef"](function MobileStepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      backButton = props.backButton,
      classes = props.classes,
      className = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      steps = props.steps,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'dots' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);

  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(clsx_m["a" /* default */])(classes.root, classes["position".concat(Object(capitalize["a" /* default */])(position))], className),
    ref: ref
  }, other), backButton, variant === 'text' && /*#__PURE__*/react["createElement"](react["Fragment"], null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/react["createElement"]("div", {
    className: classes.dots
  }, Object(toConsumableArray["a" /* default */])(new Array(steps)).map(function (_, index) {
    return /*#__PURE__*/react["createElement"]("div", {
      key: index,
      className: Object(clsx_m["a" /* default */])(classes.dot, index === activeStep && classes.dotActive)
    });
  })), variant === 'progress' && /*#__PURE__*/react["createElement"](esm_LinearProgress_LinearProgress, Object(esm_extends["a" /* default */])({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
});
 false ? MobileStepper_MobileStepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: PropTypes.number,

  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: PropTypes.object,

  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: PropTypes.node,

  /**
   * Set the positioning type.
   */
  position: PropTypes.oneOf(['bottom', 'static', 'top']),

  /**
   * The total steps.
   */
  steps: PropTypes.number.isRequired,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dots', 'progress', 'text'])
} : void 0;
/* harmony default export */ var esm_MobileStepper_MobileStepper = (Object(withStyles["a" /* default */])(MobileStepper_styles, {
  name: 'MuiMobileStepper'
})(MobileStepper_MobileStepper));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/MobileStepper/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelectInput.js







/**
 * @ignore - internal component.
 */

var NativeSelectInput_NativeSelectInput = /*#__PURE__*/react["forwardRef"](function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"]("select", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/react["createElement"](IconComponent, {
    className: Object(clsx_m["a" /* default */])(classes.icon, classes["icon".concat(Object(capitalize["a" /* default */])(variant))], disabled && classes.disabled)
  }));
});
 false ? NativeSelectInput_NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ var NativeSelect_NativeSelectInput = (NativeSelectInput_NativeSelectInput);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/ArrowDropDown.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var ArrowDropDown = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js










var NativeSelect_styles = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/react["createElement"](esm_Input_Input, null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect_NativeSelect = /*#__PURE__*/react["forwardRef"](function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDown : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = useFormControl_useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/react["cloneElement"](input, Object(esm_extends["a" /* default */])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: NativeSelect_NativeSelectInput,
    inputProps: Object(esm_extends["a" /* default */])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect_NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect_NativeSelect.muiName = 'Select';
/* harmony default export */ var esm_NativeSelect_NativeSelect = (Object(withStyles["a" /* default */])(NativeSelect_styles, {
  name: 'MuiNativeSelect'
})(NativeSelect_NativeSelect));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js



var NoSsr_useEnhancedEffect = typeof window !== 'undefined' && "production" !== 'test' ? react["useLayoutEffect"] : react["useEffect"];
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _React$useState = react["useState"](false),
      mountedState = _React$useState[0],
      setMountedState = _React$useState[1];

  NoSsr_useEnhancedEffect(function () {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  react["useEffect"](function () {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return /*#__PURE__*/react["createElement"](react["Fragment"], null, mountedState ? children : fallback);
}

 false ? NoSsr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: PropTypes.bool,

  /**
   * The fallback content to display.
   */
  fallback: PropTypes.node
} : void 0;

if (false) {
  // eslint-disable-next-line
  NoSsr['propTypes' + ''] = exactProp(NoSsr.propTypes);
}

/* harmony default export */ var NoSsr_NoSsr = (NoSsr);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/NoSsr/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/NotchedOutline.js









var NotchedOutline_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline_NotchedOutline = /*#__PURE__*/react["forwardRef"](function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = Object(useTheme["a" /* default */])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/react["createElement"]("fieldset", Object(esm_extends["a" /* default */])({
      "aria-hidden": true,
      className: Object(clsx_m["a" /* default */])(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/react["createElement"]("legend", {
      className: Object(clsx_m["a" /* default */])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/react["createElement"]("span", null, label) : /*#__PURE__*/react["createElement"]("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/react["createElement"]("fieldset", Object(esm_extends["a" /* default */])({
    "aria-hidden": true,
    style: Object(esm_extends["a" /* default */])(Object(defineProperty["a" /* default */])({}, "padding".concat(Object(capitalize["a" /* default */])(align)), 8), style),
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/react["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline_NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The label.
   */
  label: PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ var OutlinedInput_NotchedOutline = (Object(withStyles["a" /* default */])(NotchedOutline_styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline_NotchedOutline));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js









var OutlinedInput_styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput_OutlinedInput = /*#__PURE__*/react["forwardRef"](function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/react["createElement"](esm_InputBase_InputBase, Object(esm_extends["a" /* default */])({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/react["createElement"](OutlinedInput_NotchedOutline, {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(esm_extends["a" /* default */])({}, classes, {
      root: Object(clsx_m["a" /* default */])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput_OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput_OutlinedInput.muiName = 'Input';
/* harmony default export */ var esm_OutlinedInput_OutlinedInput = (Object(withStyles["a" /* default */])(OutlinedInput_styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput_OutlinedInput));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/index.js + 1 modules
var Popover = __webpack_require__(444);

// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var esm_popper = __webpack_require__(1348);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/index.js + 1 modules
var Portal = __webpack_require__(329);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(212);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(189);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Popper/Popper.js












function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var Popper_useEnhancedEffect = typeof window !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper_Popper = /*#__PURE__*/react["forwardRef"](function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = react["useRef"](null);
  var ownRef = Object(useForkRef["a" /* default */])(tooltipRef, ref);
  var popperRef = react["useRef"](null);
  var handlePopperRef = Object(useForkRef["a" /* default */])(popperRef, popperRefProp);
  var handlePopperRefRef = react["useRef"](handlePopperRef);
  Popper_useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  react["useImperativeHandle"](popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = react["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = Object(styles_esm["k" /* useTheme */])();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = react["useState"](rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  react["useEffect"](function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = react["useCallback"](function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (false) {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new esm_popper["a" /* default */](getAnchorEl(anchorEl), tooltipRef.current, Object(esm_extends["a" /* default */])({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: Object(esm_extends["a" /* default */])({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: Object(createChainedFunction["a" /* default */])(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: Object(createChainedFunction["a" /* default */])(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = react["useCallback"](function (node) {
    Object(setRef["a" /* default */])(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  react["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, []);
  react["useEffect"](function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/react["createElement"](Portal["a" /* default */], {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: Object(esm_extends["a" /* default */])({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
 false ? Popper_Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_Popper_Popper = (Popper_Popper);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Popper/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var RadioButtonIcon_styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.root, checked && classes.checked)
  }, /*#__PURE__*/react["createElement"](RadioButtonUnchecked, {
    fontSize: fontSize
  }), /*#__PURE__*/react["createElement"](RadioButtonChecked, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes.oneOf(['small', 'default'])
} : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = (Object(withStyles["a" /* default */])(RadioButtonIcon_styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js

/**
 * @ignore - internal component.
 */

var RadioGroupContext = react["createContext"]();

if (false) {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

/* harmony default export */ var RadioGroup_RadioGroupContext = (RadioGroupContext);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return react["useContext"](RadioGroup_RadioGroupContext);
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var Radio_defaultCheckedIcon = /*#__PURE__*/react["createElement"](Radio_RadioButtonIcon, {
  checked: true
});
var Radio_defaultIcon = /*#__PURE__*/react["createElement"](Radio_RadioButtonIcon, null);
var Radio_Radio = /*#__PURE__*/react["forwardRef"](function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = Object(createChainedFunction["a" /* default */])(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/react["createElement"](internal_SwitchBase, Object(esm_extends["a" /* default */])({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/react["cloneElement"](Radio_defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    checkedIcon: /*#__PURE__*/react["cloneElement"](Radio_defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    classes: {
      root: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? Radio_Radio.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the radio will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_Radio_Radio = (Object(withStyles["a" /* default */])(Radio_styles, {
  name: 'MuiRadio'
})(Radio_Radio));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(328);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js










var RadioGroup_RadioGroup = /*#__PURE__*/react["forwardRef"](function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = react["useRef"](null);

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  react["useImperativeHandle"](actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = Object(useForkRef["a" /* default */])(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = Object(unstable_useId["a" /* default */])(nameProp);
  return /*#__PURE__*/react["createElement"](RadioGroup_RadioGroupContext.Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/react["createElement"](esm_FormGroup_FormGroup, Object(esm_extends["a" /* default */])({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? RadioGroup_RadioGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string]),

  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: PropTypes.string,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_RadioGroup_RadioGroup = (RadioGroup_RadioGroup);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/index.js


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(439);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(324);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(566);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(setPrototypeOf["a" /* default */])(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(446);
var helpers_typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(438);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (helpers_typeof_default()(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(assertThisInitialized["a" /* default */])(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RootRef/RootRef.js






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






/**
 * ⚠️⚠️⚠️
 * If you want the DOM element of a Material-UI component check out
 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
 * first.
 *
 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
 *
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * function MyComponent() {
 *   const domRef = React.useRef();
 *
 *   React.useEffect(() => {
 *     console.log(domRef.current); // DOM node
 *   }, []);
 *
 *   return (
 *     <RootRef rootRef={domRef}>
 *       <SomeChildComponent />
 *     </RootRef>
 *   );
 * }
 * ```
 */

var RootRef_RootRef = /*#__PURE__*/function (_React$Component) {
  _inherits(RootRef, _React$Component);

  var _super = _createSuper(RootRef);

  function RootRef() {
    Object(classCallCheck["a" /* default */])(this, RootRef);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = react_dom["findDOMNode"](this);
      Object(setRef["a" /* default */])(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = react_dom["findDOMNode"](this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          Object(setRef["a" /* default */])(prevProps.rootRef, null);
        }

        this.ref = ref;
        Object(setRef["a" /* default */])(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      Object(setRef["a" /* default */])(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootRef;
}(react["Component"]);

 false ? RootRef_RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: PropTypes.element.isRequired,

  /**
   * A ref that points to the first DOM node of the wrapped element.
   */
  rootRef: refType.isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef_RootRef.propTypes = exactProp(RootRef_RootRef.propTypes) : void 0;
}

/* harmony default export */ var esm_RootRef_RootRef = (RootRef_RootRef);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RootRef/index.js

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(255);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu_Menu = __webpack_require__(651);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Select/SelectInput.js

















function areEqualValues(a, b) {
  if (Object(esm_typeof["a" /* default */])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput_SelectInput = /*#__PURE__*/react["forwardRef"](function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = react["useRef"](null);

  var _React$useState = react["useState"](null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = react["useRef"](openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = react["useState"](),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = react["useState"](false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = Object(useForkRef["a" /* default */])(ref, inputRefProp);
  react["useImperativeHandle"](handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  react["useEffect"](function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  react["useEffect"](function () {
    if (displayNode) {
      var label = Object(ownerDocument["a" /* default */])(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = react["Children"].toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (isFilled({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : Object(esm["b" /* formatMuiErrorMessage */])(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/react["cloneElement"](child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  react["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/react["createElement"]("input", Object(esm_extends["a" /* default */])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/react["createElement"](IconComponent, {
    className: Object(clsx_m["a" /* default */])(classes.icon, classes["icon".concat(Object(capitalize["a" /* default */])(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/react["createElement"](Menu_Menu["a" /* default */], Object(esm_extends["a" /* default */])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(esm_extends["a" /* default */])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(esm_extends["a" /* default */])({}, MenuProps.PaperProps, {
      style: Object(esm_extends["a" /* default */])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput_SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ var Select_SelectInput = (SelectInput_SelectInput);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js















var Select_styles = NativeSelect_styles;

var Select__ref = /*#__PURE__*/react["createElement"](esm_Input_Input, null);

var Select__ref2 = /*#__PURE__*/react["createElement"](esm_FilledInput_FilledInput, null);

var Select_Select = /*#__PURE__*/react["forwardRef"](function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDown : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? NativeSelect_NativeSelectInput : Select_SelectInput;
  var muiFormControl = useFormControl_useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: Select__ref,
    outlined: /*#__PURE__*/react["createElement"](esm_OutlinedInput_OutlinedInput, {
      label: label,
      labelWidth: labelWidth
    }),
    filled: Select__ref2
  }[variant];
  return /*#__PURE__*/react["cloneElement"](InputComponent, Object(esm_extends["a" /* default */])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: Object(esm_extends["a" /* default */])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(esm_extends["a" /* default */])({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? Object(styles_esm["i" /* mergeClasses */])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select_Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select_Select.muiName = 'Select';
/* harmony default export */ var esm_Select_Select = (Object(withStyles["a" /* default */])(Select_styles, {
  name: 'MuiSelect'
})(Select_Select));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Select/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Slider/ValueLabel.js





var ValueLabel_styles = function styles(theme) {
  return {
    thumb: {
      '&$open': {
        '& $offset': {
          transform: 'scale(1) translateY(-10px)'
        }
      }
    },
    open: {},
    offset: Object(esm_extends["a" /* default */])({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: 'bottom center',
      transform: 'scale(0)',
      position: 'absolute'
    }),
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: 'currentColor',
      transform: 'rotate(-45deg)'
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: 'rotate(45deg)'
    }
  };
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      open = props.open,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay;

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return /*#__PURE__*/react["cloneElement"](children, {
    className: Object(clsx_m["a" /* default */])(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
  }, /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.offset, className)
  }, /*#__PURE__*/react["createElement"]("span", {
    className: classes.circle
  }, /*#__PURE__*/react["createElement"]("span", {
    className: classes.label
  }, value))));
}

/* harmony default export */ var Slider_ValueLabel = (Object(withStyles["a" /* default */])(ValueLabel_styles, {
  name: 'PrivateValueLabel'
})(ValueLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js



















function asc(a, b) {
  return a - b;
}

function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
}

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step, min) {
  var nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex(_ref) {
  var values = _ref.values,
      source = _ref.source,
      newValue = _ref.newValue,
      index = _ref.index;

  // Performance shortcut
  if (values[index] === newValue) {
    return source;
  }

  var output = values.slice();
  output[index] = newValue;
  return output;
}

function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef,
      activeIndex = _ref2.activeIndex,
      setActive = _ref2.setActive;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  'horizontal-reverse': {
    offset: function offset(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};

var Identity = function Identity(x) {
  return x;
};

var Slider_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: '100%',
      boxSizing: 'content-box',
      padding: '13px 0',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      touchAction: 'none',
      color: theme.palette.primary.main,
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        pointerEvents: 'none',
        cursor: 'default',
        color: theme.palette.grey[400]
      },
      '&$vertical': {
        width: 2,
        height: '100%',
        padding: '0 13px'
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      '@media (pointer: coarse)': {
        // Reach 42px touch target, about ~8mm on screen.
        padding: '20px 0',
        '&$vertical': {
          padding: '0 20px'
        }
      },
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      '&$vertical': {
        marginBottom: 'auto',
        marginRight: 20
      }
    },

    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the rail element. */
    rail: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      opacity: 0.38,
      '$vertical &': {
        height: '100%',
        width: 2
      }
    },

    /* Styles applied to the track element. */
    track: {
      display: 'block',
      position: 'absolute',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      '$vertical &': {
        width: 2
      }
    },

    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      '& $track': {
        display: 'none'
      }
    },

    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      '& $track': {
        backgroundColor: // Same logic as the LinearProgress track color
        theme.palette.type === 'light' ? Object(colorManipulator["i" /* lighten */])(theme.palette.primary.main, 0.62) : Object(colorManipulator["a" /* darken */])(theme.palette.primary.main, 0.5)
      },
      '& $rail': {
        opacity: 1
      }
    },

    /* Styles applied to the thumb element. */
    thumb: {
      position: 'absolute',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      backgroundColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
      '&::after': {
        position: 'absolute',
        content: '""',
        borderRadius: '50%',
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, 0.16)),
        '@media (hover: none)': {
          boxShadow: 'none'
        }
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, 0.16))
      },
      '&$disabled': {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        '&:hover': {
          boxShadow: 'none'
        }
      },
      '$vertical &': {
        marginLeft: -5,
        marginBottom: -6
      },
      '$vertical &$disabled': {
        marginLeft: -3,
        marginBottom: -4
      }
    },

    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, 0.16))
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, 0.16))
      }
    },

    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},

    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},

    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: 'calc(-50% - 4px)'
    },

    /* Styles applied to the mark element. */
    mark: {
      position: 'absolute',
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },

    /* Styles applied to the mark label element. */
    markLabel: Object(esm_extends["a" /* default */])({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: 'absolute',
      top: 26,
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
      '$vertical &': {
        top: 'auto',
        left: 26,
        transform: 'translateY(50%)'
      },
      '@media (pointer: coarse)': {
        top: 40,
        '$vertical &': {
          left: 31
        }
      }
    }),

    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider_Slider = /*#__PURE__*/react["forwardRef"](function Slider(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      ariaValuetext = props['aria-valuetext'],
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      getAriaLabel = props.getAriaLabel,
      getAriaValueText = props.getAriaValueText,
      _props$marks = props.marks,
      marksProp = _props$marks === void 0 ? false : _props$marks,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted,
      onMouseDown = props.onMouseDown,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? Identity : _props$scale,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      _props$ThumbComponent = props.ThumbComponent,
      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
      _props$track = props.track,
      track = _props$track === void 0 ? 'normal' : _props$track,
      valueProp = props.value,
      _props$ValueLabelComp = props.ValueLabelComponent,
      ValueLabelComponent = _props$ValueLabelComp === void 0 ? Slider_ValueLabel : _props$ValueLabelComp,
      _props$valueLabelDisp = props.valueLabelDisplay,
      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
      _props$valueLabelForm = props.valueLabelFormat,
      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);

  var theme = Object(useTheme["a" /* default */])();
  var touchId = react["useRef"](); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transfered when inversing a range slider.

  var _React$useState = react["useState"](-1),
      active = _React$useState[0],
      setActive = _React$useState[1];

  var _React$useState2 = react["useState"](-1),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Slider'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var range = Array.isArray(valueDerived);
  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(function (value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? Object(toConsumableArray["a" /* default */])(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp || [];

  var _useIsFocusVisible = Object(useIsFocusVisible["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = react["useState"](-1),
      focusVisible = _React$useState3[0],
      setFocusVisible = _React$useState3[1];

  var sliderRef = react["useRef"]();
  var handleFocusRef = Object(useForkRef["a" /* default */])(focusVisibleRef, sliderRef);
  var handleRef = Object(useForkRef["a" /* default */])(ref, handleFocusRef);
  var handleFocus = Object(useEventCallback["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));

    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }

    setOpen(index);
  });
  var handleBlur = Object(useEventCallback["a" /* default */])(function () {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }

    setOpen(-1);
  });
  var handleMouseOver = Object(useEventCallback["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  });
  var handleMouseLeave = Object(useEventCallback["a" /* default */])(function () {
    setOpen(-1);
  });
  var isRtl = theme.direction === 'rtl';
  var handleKeyDown = Object(useEventCallback["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';

    switch (event.key) {
      case 'Home':
        newValue = min;
        break;

      case 'End':
        newValue = max;
        break;

      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }

        break;

      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }

        break;

      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }

        break;

      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }

        break;

      default:
        return;
    } // Prevent scroll of the page


    event.preventDefault();

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }

    newValue = clamp(newValue, min, max);

    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      focusThumb({
        sliderRef: sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }

    setValueState(newValue);
    setFocusVisible(index);

    if (onChange) {
      onChange(event, newValue);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = react["useRef"]();
  var axis = orientation;

  if (isRtl && orientation !== "vertical") {
    axis += '-reverse';
  }

  var getFingerNewValue = function getFingerNewValue(_ref3) {
    var finger = _ref3.finger,
        _ref3$move = _ref3.move,
        move = _ref3$move === void 0 ? false : _ref3$move,
        values2 = _ref3.values,
        source = _ref3.source;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        height = _slider$getBoundingCl.height,
        bottom = _slider$getBoundingCl.bottom,
        left = _slider$getBoundingCl.left;

    var percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    var newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      var marksValues = marks.map(function (mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp(newValue, min, max);
    var activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source: source,
        newValue: newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }

    return {
      newValue: newValue,
      activeIndex: activeIndex
    };
  };

  var handleTouchMove = Object(useEventCallback["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue = getFingerNewValue({
      finger: finger,
      move: true,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue.newValue,
        activeIndex = _getFingerNewValue.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = Object(useEventCallback["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue2.newValue;

    setActive(-1);

    if (event.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }

    touchId.current = undefined;
    var doc = Object(ownerDocument["a" /* default */])(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  });
  var handleTouchStart = Object(useEventCallback["a" /* default */])(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue3.newValue,
        activeIndex = _getFingerNewValue3.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(ownerDocument["a" /* default */])(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove);
    doc.addEventListener('touchend', handleTouchEnd);
  });
  react["useEffect"](function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    var doc = Object(ownerDocument["a" /* default */])(slider);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      doc.removeEventListener('mousemove', handleTouchMove);
      doc.removeEventListener('mouseup', handleTouchEnd);
      doc.removeEventListener('touchmove', handleTouchMove);
      doc.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = Object(useEventCallback["a" /* default */])(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    var finger = trackFinger(event, touchId);

    var _getFingerNewValue4 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue4.newValue,
        activeIndex = _getFingerNewValue4.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(ownerDocument["a" /* default */])(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove);
    doc.addEventListener('mouseup', handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  var trackStyle = Object(esm_extends["a" /* default */])({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    ref: handleRef,
    className: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
    onMouseDown: handleMouseDown
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.rail
  }), /*#__PURE__*/react["createElement"]("span", {
    className: classes.track,
    style: trackStyle
  }), /*#__PURE__*/react["createElement"]("input", {
    value: values.join(','),
    name: name,
    type: "hidden"
  }), marks.map(function (mark, index) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;

    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
    }

    return /*#__PURE__*/react["createElement"](react["Fragment"], {
      key: mark.value
    }, /*#__PURE__*/react["createElement"]("span", {
      style: style,
      "data-index": index,
      className: Object(clsx_m["a" /* default */])(classes.mark, markActive && classes.markActive)
    }), mark.label != null ? /*#__PURE__*/react["createElement"]("span", {
      "aria-hidden": true,
      "data-index": index,
      style: style,
      className: Object(clsx_m["a" /* default */])(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label) : null);
  }), values.map(function (value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return /*#__PURE__*/react["createElement"](ValueLabelComponent, {
      key: index,
      valueLabelFormat: valueLabelFormat,
      valueLabelDisplay: valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
      index: index,
      open: open === index || active === index || valueLabelDisplay === 'on',
      disabled: disabled
    }, /*#__PURE__*/react["createElement"](ThumbComponent, {
      className: Object(clsx_m["a" /* default */])(classes.thumb, classes["thumbColor".concat(Object(capitalize["a" /* default */])(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style: style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": scale(max),
      "aria-valuemin": scale(min),
      "aria-valuenow": scale(value),
      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
 false ? Slider_Slider.propTypes = {
  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * If `true`, the slider will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */
  marks: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */
  max: PropTypes.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */
  min: PropTypes.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The slider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   */
  scale: PropTypes.func,

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */
  step: PropTypes.number,

  /**
   * The component used to display the value label.
   */
  ThumbComponent: PropTypes.elementType,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */
  track: PropTypes.oneOf(['normal', false, 'inverted']),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * The value label component.
   */
  ValueLabelComponent: PropTypes.elementType,

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : void 0;
/* harmony default export */ var esm_Slider_Slider = (Object(withStyles["a" /* default */])(Slider_styles, {
  name: 'MuiSlider'
})(Slider_Slider));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Slider/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SnackbarContent/SnackbarContent.js









var SnackbarContent_styles = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = Object(colorManipulator["c" /* emphasize */])(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.body2, Object(defineProperty["a" /* default */])({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    })),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent_SnackbarContent = /*#__PURE__*/react["forwardRef"](function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["action", "classes", "className", "message", "role"]);

  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    role: role,
    square: true,
    elevation: 6,
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("div", {
    className: classes.message
  }, message), action ? /*#__PURE__*/react["createElement"]("div", {
    className: classes.action
  }, action) : null);
});
 false ? SnackbarContent_SnackbarContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string
} : void 0;
/* harmony default export */ var esm_SnackbarContent_SnackbarContent = (Object(withStyles["a" /* default */])(SnackbarContent_styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent_SnackbarContent));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SnackbarContent/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Snackbar/Snackbar.js














var Snackbar_styles = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: Object(esm_extends["a" /* default */])({}, top1, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({}, top3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: Object(esm_extends["a" /* default */])({}, bottom1, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({}, bottom3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: Object(esm_extends["a" /* default */])({}, top1, right, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({
      left: 'auto'
    }, top3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: Object(esm_extends["a" /* default */])({}, bottom1, right, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({
      left: 'auto'
    }, bottom3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: Object(esm_extends["a" /* default */])({}, top1, left, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({
      right: 'auto'
    }, top3, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: Object(esm_extends["a" /* default */])({}, bottom1, left, Object(defineProperty["a" /* default */])({}, theme.breakpoints.up('sm'), Object(esm_extends["a" /* default */])({
      right: 'auto'
    }, bottom3, left3)))
  };
};
var Snackbar_Snackbar = /*#__PURE__*/react["forwardRef"](function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: transitions["b" /* duration */].enteringScreen,
    exit: transitions["b" /* duration */].leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = react["useRef"]();

  var _React$useState = react["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var handleClose = Object(useEventCallback["a" /* default */])(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = Object(useEventCallback["a" /* default */])(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  react["useEffect"](function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = react["useCallback"](function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  react["useEffect"](function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/react["createElement"](ClickAwayListener_ClickAwayListener, Object(esm_extends["a" /* default */])({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["anchorOrigin".concat(Object(capitalize["a" /* default */])(vertical)).concat(Object(capitalize["a" /* default */])(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: open,
    onEnter: Object(createChainedFunction["a" /* default */])(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: Object(createChainedFunction["a" /* default */])(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || /*#__PURE__*/react["createElement"](esm_SnackbarContent_SnackbarContent, Object(esm_extends["a" /* default */])({
    message: message,
    action: action
  }, ContentProps)))));
});
 false ? Snackbar_Snackbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,

  /**
   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: PropTypes.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: PropTypes.any,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * If `true`, `Snackbar` is open.
   */
  open: PropTypes.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Snackbar_Snackbar = (Object(withStyles["a" /* default */])(Snackbar_styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar_Snackbar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Snackbar/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Step/Step.js







var Step_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Pseudo-class applied to the root element if `completed={true}`. */
  completed: {}
};
var Step_Step = /*#__PURE__*/react["forwardRef"](function Step(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      connectorProp = props.connector,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$expanded = props.expanded,
      expanded = _props$expanded === void 0 ? false : _props$expanded,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);

  var connector = connectorProp ? /*#__PURE__*/react["cloneElement"](connectorProp, {
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    index: index,
    active: active,
    completed: completed,
    disabled: disabled
  }) : null;
  var newChildren = /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
    ref: ref
  }, other), connector && alternativeLabel && index !== 0 ? connector : null, react["Children"].map(children, function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/react["cloneElement"](child, Object(esm_extends["a" /* default */])({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      expanded: expanded,
      last: last,
      icon: index + 1,
      orientation: orientation
    }, child.props));
  }));

  if (connector && !alternativeLabel && index !== 0) {
    return /*#__PURE__*/react["createElement"](react["Fragment"], null, connector, newChildren);
  }

  return newChildren;
});
 false ? Step_Step.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Expand the step.
   */
  expanded: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_Step_Step = (Object(withStyles["a" /* default */])(Step_styles, {
  name: 'MuiStep'
})(Step_Step));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Step/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckCircle.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckCircle = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/Warning.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var Warning = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/index.js + 1 modules
var SvgIcon = __webpack_require__(325);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepIcon/StepIcon.js







var StepIcon_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {}
  };
};

var StepIcon__ref = /*#__PURE__*/react["createElement"]("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

var StepIcon_StepIcon = /*#__PURE__*/react["forwardRef"](function StepIcon(props, ref) {
  var _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      icon = props.icon,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    var className = Object(clsx_m["a" /* default */])(classes.root, active && classes.active, error && classes.error, completed && classes.completed);

    if (error) {
      return /*#__PURE__*/react["createElement"](Warning, {
        className: className,
        ref: ref
      });
    }

    if (completed) {
      return /*#__PURE__*/react["createElement"](CheckCircle, {
        className: className,
        ref: ref
      });
    }

    return /*#__PURE__*/react["createElement"](SvgIcon["a" /* default */], {
      className: className,
      ref: ref
    }, StepIcon__ref, /*#__PURE__*/react["createElement"]("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
});
 false ? StepIcon_StepIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
} : void 0;
/* harmony default export */ var esm_StepIcon_StepIcon = (Object(withStyles["a" /* default */])(StepIcon_styles, {
  name: 'MuiStepIcon'
})(StepIcon_StepIcon));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepIcon/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepLabel/StepLabel.js








var StepLabel_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: 'flex',
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};
var StepLabel_StepLabel = /*#__PURE__*/react["forwardRef"](function StepLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      StepIconComponentProp = props.StepIconComponent,
      StepIconProps = props.StepIconProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);

  var StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = esm_StepIcon_StepIcon;
  }

  return /*#__PURE__*/react["createElement"]("span", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
    ref: ref
  }, other), icon || StepIconComponent ? /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
  }, /*#__PURE__*/react["createElement"](StepIconComponent, Object(esm_extends["a" /* default */])({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))) : null, /*#__PURE__*/react["createElement"]("span", {
    className: classes.labelContainer
  }, children ? /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    variant: "body2",
    component: "span",
    display: "block",
    className: Object(clsx_m["a" /* default */])(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
  }, children) : null, optional));
});
 false ? StepLabel_StepLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * The component to render in place of the [`StepIcon`](/api/step-icon/).
   */
  StepIconComponent: PropTypes.elementType,

  /**
   * Props applied to the [`StepIcon`](/api/step-icon/) element.
   */
  StepIconProps: PropTypes.object
} : void 0;
StepLabel_StepLabel.muiName = 'StepLabel';
/* harmony default export */ var esm_StepLabel_StepLabel = (Object(withStyles["a" /* default */])(StepLabel_styles, {
  name: 'MuiStepLabel'
})(StepLabel_StepLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepLabel/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepButton/StepButton.js









var StepButton_styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start',
    padding: '8px',
    margin: '-8px'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
var StepButton_StepButton = /*#__PURE__*/react["forwardRef"](function StepButton(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);

  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = Object(isMuiElement["a" /* default */])(children, ['StepLabel']) ? /*#__PURE__*/react["cloneElement"](children, childProps) : /*#__PURE__*/react["createElement"](esm_StepLabel_StepLabel, childProps, children);
  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    focusRipple: true,
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: Object(clsx_m["a" /* default */])(classes.root, classes[orientation], className),
    ref: ref
  }, other), child);
});
 false ? StepButton_StepButton.propTypes = {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   * potentially passed from parent `Step`
   */
  expanded: PropTypes.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* harmony default export */ var esm_StepButton_StepButton = (Object(withStyles["a" /* default */])(StepButton_styles, {
  name: 'MuiStepButton'
})(StepButton_StepButton));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepButton/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepConnector/StepConnector.js






var StepConnector_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};
var StepConnector_StepConnector = /*#__PURE__*/react["forwardRef"](function StepConnector(props, ref) {
  var active = props.active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      index = props.index,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.line, {
      'horizontal': classes.lineHorizontal,
      'vertical': classes.lineVertical
    }[orientation])
  }));
});
 false ? StepConnector_StepConnector.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ var esm_StepConnector_StepConnector = (Object(withStyles["a" /* default */])(StepConnector_styles, {
  name: 'MuiStepConnector'
})(StepConnector_StepConnector));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepConnector/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepContent/StepContent.js







var StepContent_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};
var StepContent_StepContent = /*#__PURE__*/react["forwardRef"](function StepContent(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      expanded = props.expanded,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? esm_Collapse_Collapse : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  if (false) {
    if (orientation !== 'vertical') {
      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
    }
  }

  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, last && classes.last),
    ref: ref
  }, other), /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    in: active || expanded,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
});
 false ? StepContent_StepContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Step content.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_StepContent_StepContent = (Object(withStyles["a" /* default */])(StepContent_styles, {
  name: 'MuiStepContent'
})(StepContent_StepContent));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/StepContent/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Stepper/Stepper.js








var Stepper_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
var defaultConnector = /*#__PURE__*/react["createElement"](esm_StepConnector_StepConnector, null);
var Stepper_Stepper = /*#__PURE__*/react["forwardRef"](function Stepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$connector = props.connector,
      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
      _props$nonLinear = props.nonLinear,
      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);

  var connector = /*#__PURE__*/react["isValidElement"](connectorProp) ? /*#__PURE__*/react["cloneElement"](connectorProp, {
    orientation: orientation
  }) : null;
  var childrenArray = react["Children"].toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var state = {
      index: index,
      active: false,
      completed: false,
      disabled: false
    };

    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }

    return /*#__PURE__*/react["cloneElement"](step, Object(esm_extends["a" /* default */])({
      alternativeLabel: alternativeLabel,
      connector: connector,
      last: index + 1 === childrenArray.length,
      orientation: orientation
    }, state, step.props));
  });
  return /*#__PURE__*/react["createElement"](Paper["a" /* default */], Object(esm_extends["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(clsx_m["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
    ref: ref
  }, other), steps);
});
 false ? Stepper_Stepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   */
  activeStep: PropTypes.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * An element to be placed between each step.
   */
  connector: PropTypes.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: PropTypes.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* harmony default export */ var esm_Stepper_Stepper = (Object(withStyles["a" /* default */])(Stepper_styles, {
  name: 'MuiStepper'
})(Stepper_Stepper));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Stepper/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SwipeableDrawer/SwipeArea.js









var SwipeArea_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var SwipeArea_SwipeArea = /*#__PURE__*/react["forwardRef"](function SwipeArea(props, ref) {
  var anchor = props.anchor,
      classes = props.classes,
      className = props.className,
      width = props.width,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["anchor", "classes", "className", "width"]);

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["anchor".concat(Object(capitalize["a" /* default */])(anchor))], className),
    ref: ref,
    style: Object(defineProperty["a" /* default */])({}, isHorizontal(anchor) ? 'width' : 'height', width)
  }, other));
});
 false ? SwipeArea_SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ var SwipeableDrawer_SwipeArea = (Object(withStyles["a" /* default */])(SwipeArea_styles, {
  name: 'PrivateSwipeArea'
})(SwipeArea_SwipeArea));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SwipeableDrawer/SwipeableDrawer.js














 // This value is closed to what browsers are using internally to
// trigger a native scroll.

var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function SwipeableDrawer_reset() {
  nodeThatClaimedTheSwipe = null;
}

function calculateCurrentX(anchor, touches) {
  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}

function calculateCurrentY(anchor, touches) {
  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
}

function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}

function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}

function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }

    element = element.parentElement;
  }

  return domTreeShapes;
}

function findNativeHandler(_ref) {
  var domTreeShapes = _ref.domTreeShapes,
      start = _ref.start,
      current = _ref.current,
      anchor = _ref.anchor;
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  var axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = current >= start;

    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }

    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return shape;
    }

    return null;
  });
}

var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
var transitionDurationDefault = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
var SwipeableDrawer_useEnhancedEffect = typeof window !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];
var SwipeableDrawer_SwipeableDrawer = /*#__PURE__*/react["forwardRef"](function SwipeableDrawer(inProps, ref) {
  var theme = Object(useTheme["a" /* default */])();
  var props = Object(styles_esm["f" /* getThemeProps */])({
    name: 'MuiSwipeableDrawer',
    props: Object(esm_extends["a" /* default */])({}, inProps),
    theme: theme
  });
  var _props$anchor = props.anchor,
      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
      _props$disableBackdro = props.disableBackdropTransition,
      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableDiscove = props.disableDiscovery,
      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
      _props$disableSwipeTo = props.disableSwipeToOpen,
      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo,
      hideBackdrop = props.hideBackdrop,
      _props$hysteresis = props.hysteresis,
      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
      _props$minFlingVeloci = props.minFlingVelocity,
      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropProps = _props$ModalProps.BackdropProps,
      ModalPropsProp = Object(objectWithoutProperties["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SwipeAreaProps = props.SwipeAreaProps,
      _props$swipeAreaWidth = props.swipeAreaWidth,
      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);

  var _React$useState = react["useState"](false),
      maybeSwiping = _React$useState[0],
      setMaybeSwiping = _React$useState[1];

  var swipeInstance = react["useRef"]({
    isSwiping: null
  });
  var swipeAreaRef = react["useRef"]();
  var backdropRef = react["useRef"]();
  var paperRef = react["useRef"]();
  var touchDetected = react["useRef"](false); // Ref for transition duration based on / to match swipe speed

  var calculatedDurationRef = react["useRef"](); // Use a ref so the open value used is always up to date inside useCallback.

  SwipeableDrawer_useEnhancedEffect(function () {
    calculatedDurationRef.current = null;
  }, [open]);
  var setPosition = react["useCallback"](function (translate) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode = options.mode,
        mode = _options$mode === void 0 ? null : _options$mode,
        _options$changeTransi = options.changeTransition,
        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
    var anchorRtl = getAnchor(theme, anchor);
    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    var horizontalSwipe = isHorizontal(anchor);
    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
    var drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    var transition = '';

    if (mode) {
      transition = theme.transitions.create('all', Object(transitions_utils["a" /* getTransitionProps */])({
        timeout: transitionDuration
      }, {
        mode: mode
      }));
    }

    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }

    if (!disableBackdropTransition && !hideBackdrop) {
      var backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);

      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  var handleBodyTouchEnd = Object(useEventCallback["a" /* default */])(function (event) {
    if (!touchDetected.current) {
      return;
    }

    nodeThatClaimedTheSwipe = null;
    touchDetected.current = false;
    setMaybeSwiping(false); // The swipe wasn't started.

    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }

    swipeInstance.current.isSwiping = null;
    var anchorRtl = getAnchor(theme, anchor);
    var horizontal = isHorizontal(anchor);
    var current;

    if (horizontal) {
      current = calculateCurrentX(anchorRtl, event.changedTouches);
    } else {
      current = calculateCurrentY(anchorRtl, event.changedTouches);
    }

    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    var translateRatio = currentTranslate / maxTranslate;

    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }

    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }

      return;
    }

    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  var handleBodyTouchMove = Object(useEventCallback["a" /* default */])(function (event) {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer


    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
      return;
    }

    var anchorRtl = getAnchor(theme, anchor);
    var horizontalSwipe = isHorizontal(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
      var nativeHandler = findNativeHandler({
        domTreeShapes: domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor: anchor
      });

      if (nativeHandler) {
        nodeThatClaimedTheSwipe = nativeHandler;
        return;
      }

      nodeThatClaimedTheSwipe = swipeInstance.current;
    } // We don't know yet.


    if (swipeInstance.current.isSwiping == null) {
      var dx = Math.abs(currentX - swipeInstance.current.startX);
      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

      if (dx > dy) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }

      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;

        if (!definitelySwiping) {
          handleBodyTouchEnd(event);
          return;
        } // Shift the starting point.


        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= swipeAreaWidth;
          } else {
            swipeInstance.current.startY -= swipeAreaWidth;
          }
        }
      }
    }

    if (!swipeInstance.current.isSwiping) {
      return;
    }

    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;

    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }

    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);

    if (open) {
      if (!swipeInstance.current.paperHit) {
        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;

        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }

    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }

    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.

    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

    if (event.cancelable) {
      event.preventDefault();
    }

    setPosition(translate);
  });
  var handleBodyTouchStart = Object(useEventCallback["a" /* default */])(function (event) {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (event.defaultPrevented) {
      return;
    } // We can only have one node at the time claiming ownership for handling the swipe.


    if (event.muiHandled) {
      return;
    } // At least one element clogs the drawer interaction zone.


    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
      return;
    }

    var anchorRtl = getAnchor(theme, anchor);
    var horizontalSwipe = isHorizontal(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (!open) {
      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
        return;
      }

      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }

    event.muiHandled = true;
    nodeThatClaimedTheSwipe = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);

    if (!open && paperRef.current) {
      // The ref may be null when a parent component updates while swiping.
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
        changeTransition: false
      });
    }

    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  react["useEffect"](function () {
    if (variant === 'temporary') {
      var doc = Object(ownerDocument["a" /* default */])(paperRef.current);
      doc.addEventListener('touchstart', handleBodyTouchStart);
      doc.addEventListener('touchmove', handleBodyTouchMove, {
        passive: false
      });
      doc.addEventListener('touchend', handleBodyTouchEnd);
      return function () {
        doc.removeEventListener('touchstart', handleBodyTouchStart);
        doc.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: false
        });
        doc.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }

    return undefined;
  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  react["useEffect"](function () {
    return function () {
      // We need to release the lock.
      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
        nodeThatClaimedTheSwipe = null;
      }
    };
  }, []);
  react["useEffect"](function () {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  var handleBackdropRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    backdropRef.current = react_dom["findDOMNode"](instance);
  }, []);
  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["createElement"](esm_Drawer_Drawer, Object(esm_extends["a" /* default */])({
    open: variant === 'temporary' && maybeSwiping ? true : open,
    variant: variant,
    ModalProps: Object(esm_extends["a" /* default */])({
      BackdropProps: Object(esm_extends["a" /* default */])({}, BackdropProps, {
        ref: handleBackdropRef
      })
    }, ModalPropsProp),
    PaperProps: Object(esm_extends["a" /* default */])({}, PaperProps, {
      style: Object(esm_extends["a" /* default */])({
        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
      }, PaperProps.style),
      ref: paperRef
    }),
    anchor: anchor,
    transitionDuration: calculatedDurationRef.current || transitionDuration,
    onClose: onClose,
    ref: ref
  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/react["createElement"](NoSsr_NoSsr, null, /*#__PURE__*/react["createElement"](SwipeableDrawer_SwipeArea, Object(esm_extends["a" /* default */])({
    anchor: anchor,
    ref: swipeAreaRef,
    width: swipeAreaWidth
  }, SwipeAreaProps))));
});
 false ? SwipeableDrawer_SwipeableDrawer.propTypes = {
  /**
   * @ignore
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: PropTypes.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: PropTypes.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: PropTypes.bool,

  /**
   * @ignore
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Affects how far the drawer must be opened/closed to change his state.
   * Specified as percent (0-1) of the width of the drawer
   */
  hysteresis: PropTypes.number,

  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   */
  minFlingVelocity: PropTypes.number,

  /**
   * @ignore
   */
  ModalProps: PropTypes.shape({
    BackdropProps: PropTypes.shape({
      component: elementTypeAcceptingRef
    })
  }),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef,
    style: PropTypes.object
  }),

  /**
   * The element is used to intercept the touch events on the edge.
   */
  SwipeAreaProps: PropTypes.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: PropTypes.number,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * @ignore
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* harmony default export */ var esm_SwipeableDrawer_SwipeableDrawer = (SwipeableDrawer_SwipeableDrawer);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/SwipeableDrawer/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Switch/Switch.js


// @inheritedComponent IconButton








var Switch_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch_Switch = /*#__PURE__*/react["forwardRef"](function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "edge", "size"]);

  var icon = /*#__PURE__*/react["createElement"]("span", {
    className: classes.thumb
  });
  return /*#__PURE__*/react["createElement"]("span", {
    className: Object(clsx_m["a" /* default */])(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat(Object(capitalize["a" /* default */])(size))])
  }, /*#__PURE__*/react["createElement"](internal_SwitchBase, Object(esm_extends["a" /* default */])({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: Object(clsx_m["a" /* default */])(classes.switchBase, classes["color".concat(Object(capitalize["a" /* default */])(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), /*#__PURE__*/react["createElement"]("span", {
    className: classes.track
  }));
});
 false ? Switch_Switch.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the switch.
   * `small` is equivalent to the dense switch styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ var esm_Switch_Switch = (Object(withStyles["a" /* default */])(Switch_styles, {
  name: 'MuiSwitch'
})(Switch_Switch));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Switch/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js










var Tab_styles = function styles(theme) {
  var _extends2;

  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.button, (_extends2 = {
      maxWidth: 264,
      minWidth: 72,
      position: 'relative',
      boxSizing: 'border-box',
      minHeight: 48,
      flexShrink: 0,
      padding: '6px 12px'
    }, Object(defineProperty["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      padding: '6px 24px'
    }), Object(defineProperty["a" /* default */])(_extends2, "overflow", 'hidden'), Object(defineProperty["a" /* default */])(_extends2, "whiteSpace", 'normal'), Object(defineProperty["a" /* default */])(_extends2, "textAlign", 'center'), Object(defineProperty["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      minWidth: 160
    }), _extends2)),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      '& $wrapper > *:first-child': {
        marginBottom: 6
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: 'none'
    },

    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    }
  };
};
var Tab_Tab = /*#__PURE__*/react["forwardRef"](function Tab(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      fullWidth = props.fullWidth,
      icon = props.icon,
      indicator = props.indicator,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      selected = props.selected,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$wrapped = props.wrapped,
      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);

  var handleClick = function handleClick(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    focusRipple: !disableFocusRipple,
    className: Object(clsx_m["a" /* default */])(classes.root, classes["textColor".concat(Object(capitalize["a" /* default */])(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    tabIndex: selected ? 0 : -1
  }, other), /*#__PURE__*/react["createElement"]("span", {
    className: classes.wrapper
  }, icon, label), indicator);
});
 false ? Tab_Tab.propTypes = {
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  fullWidth: PropTypes.bool,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * @ignore
   */
  textColor: PropTypes.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,

  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   */
  wrapped: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_Tab_Tab = (Object(withStyles["a" /* default */])(Tab_styles, {
  name: 'MuiTab'
})(Tab_Tab));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tab/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/TableContext.js

/**
 * @ignore - internal component.
 */

var TableContext = react["createContext"]();

if (false) {
  TableContext.displayName = 'TableContext';
}

/* harmony default export */ var Table_TableContext = (TableContext);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js







var Table_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(esm_extends["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table_Table = /*#__PURE__*/react["forwardRef"](function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'default' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = react["useMemo"](function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/react["createElement"](Table_TableContext.Provider, {
    value: table
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: Object(clsx_m["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table_Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_Table_Table = (Object(withStyles["a" /* default */])(Table_styles, {
  name: 'MuiTable'
})(Table_Table));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Table/Tablelvl2Context.js

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = react["createContext"]();

if (false) {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

/* harmony default export */ var Table_Tablelvl2Context = (Tablelvl2Context);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js







var TableBody_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var TableBody_tablelvl2 = {
  variant: 'body'
};
var TableBody_defaultComponent = 'tbody';
var TableBody_TableBody = /*#__PURE__*/react["forwardRef"](function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableBody_defaultComponent : _props$component,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react["createElement"](Table_Tablelvl2Context.Provider, {
    value: TableBody_tablelvl2
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === TableBody_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableBody_TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ var esm_TableBody_TableBody = (Object(withStyles["a" /* default */])(TableBody_styles, {
  name: 'MuiTableBody'
})(TableBody_TableBody));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableBody/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js










var TableCell_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(esm_extends["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(colorManipulator["i" /* lighten */])(Object(colorManipulator["d" /* fade */])(theme.palette.divider, 1), 0.88) : Object(colorManipulator["a" /* darken */])(Object(colorManipulator["d" /* fade */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell_TableCell = /*#__PURE__*/react["forwardRef"](function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = react["useContext"](Table_TableContext);
  var tablelvl2 = react["useContext"](Table_Tablelvl2Context);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    ref: ref,
    className: Object(clsx_m["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(capitalize["a" /* default */])(align))], padding !== 'default' && classes["padding".concat(Object(capitalize["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(capitalize["a" /* default */])(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? TableCell_TableCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: PropTypes.oneOf(['checkbox', 'default', 'none']),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
/* harmony default export */ var esm_TableCell_TableCell = (Object(withStyles["a" /* default */])(TableCell_styles, {
  name: 'MuiTableCell'
})(TableCell_TableCell));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableCell/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js






var TableContainer_styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    overflowX: 'auto'
  }
};
var TableContainer_TableContainer = /*#__PURE__*/react["forwardRef"](function TableContainer(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    ref: ref,
    className: Object(clsx_m["a" /* default */])(classes.root, className)
  }, other));
});
 false ? TableContainer_TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ var esm_TableContainer_TableContainer = (Object(withStyles["a" /* default */])(TableContainer_styles, {
  name: 'MuiTableContainer'
})(TableContainer_TableContainer));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableContainer/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableFooter/TableFooter.js







var TableFooter_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var TableFooter_tablelvl2 = {
  variant: 'footer'
};
var TableFooter_defaultComponent = 'tfoot';
var TableFooter_TableFooter = /*#__PURE__*/react["forwardRef"](function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableFooter_defaultComponent : _props$component,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react["createElement"](Table_Tablelvl2Context.Provider, {
    value: TableFooter_tablelvl2
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === TableFooter_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableFooter_TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ var esm_TableFooter_TableFooter = (Object(withStyles["a" /* default */])(TableFooter_styles, {
  name: 'MuiTableFooter'
})(TableFooter_TableFooter));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableFooter/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableHead/TableHead.js







var TableHead_styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var TableHead_tablelvl2 = {
  variant: 'head'
};
var TableHead_defaultComponent = 'thead';
var TableHead_TableHead = /*#__PURE__*/react["forwardRef"](function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableHead_defaultComponent : _props$component,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/react["createElement"](Table_Tablelvl2Context.Provider, {
    value: TableHead_tablelvl2
  }, /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === TableHead_defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableHead_TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* harmony default export */ var esm_TableHead_TableHead = (Object(withStyles["a" /* default */])(TableHead_styles, {
  name: 'MuiTableHead'
})(TableHead_TableHead));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableHead/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js







var Toolbar_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Object(defineProperty["a" /* default */])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar_Toolbar = /*#__PURE__*/react["forwardRef"](function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar_Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
/* harmony default export */ var esm_Toolbar_Toolbar = (Object(withStyles["a" /* default */])(Toolbar_styles, {
  name: 'MuiToolbar'
})(Toolbar_Toolbar));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Toolbar/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/KeyboardArrowLeft.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var KeyboardArrowLeft = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/KeyboardArrowRight.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var KeyboardArrowRight = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TablePagination/TablePaginationActions.js








/**
 * @ignore - internal component.
 */

var TablePaginationActions__ref = /*#__PURE__*/react["createElement"](KeyboardArrowRight, null);

var TablePaginationActions__ref2 = /*#__PURE__*/react["createElement"](KeyboardArrowLeft, null);

var TablePaginationActions__ref3 = /*#__PURE__*/react["createElement"](KeyboardArrowLeft, null);

var _ref4 = /*#__PURE__*/react["createElement"](KeyboardArrowRight, null);

var TablePaginationActions_TablePaginationActions = /*#__PURE__*/react["forwardRef"](function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);

  var theme = Object(useTheme["a" /* default */])();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    ref: ref
  }, other), /*#__PURE__*/react["createElement"](IconButton["default"], Object(esm_extends["a" /* default */])({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? TablePaginationActions__ref : TablePaginationActions__ref2), /*#__PURE__*/react["createElement"](IconButton["default"], Object(esm_extends["a" /* default */])({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? TablePaginationActions__ref3 : _ref4));
});
 false ? TablePaginationActions_TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ var TablePagination_TablePaginationActions = (TablePaginationActions_TablePaginationActions);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TablePagination/TablePagination.js















var TablePagination_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      overflow: 'auto',
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },
    // TODO v5: `.selectRoot` should be merged with `.input`

    /* Styles applied to the Select component root element. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: 'right',
      textAlignLast: 'right' // Align <select> on Chrome.

    },
    // TODO v5: remove

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {},

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};

var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
  var from = _ref.from,
      to = _ref.to,
      count = _ref.count;
  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};

var defaultRowsPerPageOptions = [10, 25, 50, 100];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination_TablePagination = /*#__PURE__*/react["forwardRef"](function TablePagination(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent,
      ActionsComponent = _props$ActionsCompone === void 0 ? TablePagination_TablePaginationActions : _props$ActionsCompone,
      backIconButtonProps = props.backIconButtonProps,
      _props$backIconButton = props.backIconButtonText,
      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
      classes = props.classes,
      className = props.className,
      colSpanProp = props.colSpan,
      _props$component = props.component,
      Component = _props$component === void 0 ? esm_TableCell_TableCell : _props$component,
      count = props.count,
      _props$labelDisplayed = props.labelDisplayedRows,
      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$nextIconButton = props.nextIconButtonText,
      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
      onChangePage = props.onChangePage,
      onChangeRowsPerPage = props.onChangeRowsPerPage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
      _props$SelectProps = props.SelectProps,
      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);

  var colSpan;

  if (Component === esm_TableCell_TableCell || Component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }

  var selectId = Object(unstable_useId["a" /* default */])();
  var labelId = Object(unstable_useId["a" /* default */])();
  var MenuItemComponent = SelectProps.native ? 'option' : MenuItem["default"];
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    colSpan: colSpan,
    ref: ref
  }, other), /*#__PURE__*/react["createElement"](esm_Toolbar_Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/react["createElement"]("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    color: "inherit",
    variant: "body2",
    className: classes.caption,
    id: labelId
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/react["createElement"](esm_Select_Select, Object(esm_extends["a" /* default */])({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: /*#__PURE__*/react["createElement"](esm_InputBase_InputBase, {
      className: Object(clsx_m["a" /* default */])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    id: selectId,
    labelId: labelId
  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
    return /*#__PURE__*/react["createElement"](MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), /*#__PURE__*/react["createElement"](esm_Typography_Typography, {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
    count: count === -1 ? -1 : count,
    page: page
  })), /*#__PURE__*/react["createElement"](ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: Object(esm_extends["a" /* default */])({
      title: backIconButtonText,
      'aria-label': backIconButtonText
    }, backIconButtonProps),
    count: count,
    nextIconButtonProps: Object(esm_extends["a" /* default */])({
      title: nextIconButtonText,
      'aria-label': nextIconButtonText
    }, nextIconButtonProps),
    onChangePage: onChangePage,
    page: page,
    rowsPerPage: rowsPerPage
  })));
});
 false ? TablePagination_TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   */
  ActionsComponent: PropTypes.elementType,

  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * Text label for the back arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  backIconButtonText: PropTypes.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colSpan: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: PropTypes.number.isRequired,

  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelDisplayedRows: PropTypes.func,

  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelRowsPerPage: PropTypes.node,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Text label for the next arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  nextIconButtonText: PropTypes.string,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   */
  onChangeRowsPerPage: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(PropTypes.number.isRequired, function (props) {
    var count = props.count,
        page = props.page,
        rowsPerPage = props.rowsPerPage;

    if (count === -1) {
      return null;
    }

    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    if (page < 0 || page > newLastPage) {
      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
    }

    return null;
  }),

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: PropTypes.array,

  /**
   * Props applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_TablePagination_TablePagination = (Object(withStyles["a" /* default */])(TablePagination_styles, {
  name: 'MuiTablePagination'
})(TablePagination_TablePagination));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TablePagination/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js








var TableRow_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var TableRow_defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow_TableRow = /*#__PURE__*/react["forwardRef"](function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? TableRow_defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = react["useContext"](Table_Tablelvl2Context);
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    ref: ref,
    className: Object(clsx_m["a" /* default */])(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === TableRow_defaultComponent ? null : 'row'
  }, other));
});
 false ? TableRow_TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ var esm_TableRow_TableRow = (Object(withStyles["a" /* default */])(TableRow_styles, {
  name: 'MuiTableRow'
})(TableRow_TableRow));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableRow/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/ArrowDownward.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var ArrowDownward = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableSortLabel/TableSortLabel.js









var TableSortLabel_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 0.5
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel_TableSortLabel = /*#__PURE__*/react["forwardRef"](function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'asc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDownward : _props$IconComponent,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/react["createElement"](IconComponent, {
    className: Object(clsx_m["a" /* default */])(classes.icon, classes["iconDirection".concat(Object(capitalize["a" /* default */])(direction))])
  }));
});
 false ? TableSortLabel_TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: PropTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The current sort direction.
   */
  direction: PropTypes.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: PropTypes.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: PropTypes.elementType
} : void 0;
/* harmony default export */ var esm_TableSortLabel_TableSortLabel = (Object(withStyles["a" /* default */])(TableSortLabel_styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel_TableSortLabel));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TableSortLabel/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(326);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/scrollLeft.js
// Source from https://github.com/alitaheri/normalize-scroll-left
var cachedType;
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE 11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */

function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }

  var dummy = document.createElement('div');
  var container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';

  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;

    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }

  document.body.removeChild(dummy);
  return cachedType;
} // Based on https://stackoverflow.com/a/24394376

function getNormalizedScrollLeft(element, direction) {
  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior

  if (direction !== 'rtl') {
    return scrollLeft;
  }

  var type = detectScrollType();

  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;

    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;

    default:
      return scrollLeft;
  }
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/animate.js
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(property, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[property];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tabs/ScrollbarSize.js





var ScrollbarSize_styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

function ScrollbarSize(props) {
  var onChange = props.onChange,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["onChange"]);

  var scrollbarHeight = react["useRef"]();
  var nodeRef = react["useRef"](null);

  var setMeasurements = function setMeasurements() {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };

  react["useEffect"](function () {
    var handleResize = Object(debounce["a" /* default */])(function () {
      var prevHeight = scrollbarHeight.current;
      setMeasurements();

      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  react["useEffect"](function () {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/react["createElement"]("div", Object(esm_extends["a" /* default */])({
    style: ScrollbarSize_styles,
    ref: nodeRef
  }, other));
}
 false ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tabs/TabIndicator.js







var TabIndicator_styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var TabIndicator_TabIndicator = /*#__PURE__*/react["forwardRef"](function TabIndicator(props, ref) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      orientation = props.orientation,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "color", "orientation"]);

  return /*#__PURE__*/react["createElement"]("span", Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, classes["color".concat(Object(capitalize["a" /* default */])(color))], className, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other));
});
 false ? TabIndicator_TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: PropTypes.oneOf(['primary', 'secondary']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ var Tabs_TabIndicator = (Object(withStyles["a" /* default */])(TabIndicator_styles, {
  name: 'PrivateTabIndicator'
})(TabIndicator_TabIndicator));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TabScrollButton/TabScrollButton.js



/* eslint-disable jsx-a11y/aria-role */







var TabScrollButton_styles = {
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    '&$disabled': {
      opacity: 0
    }
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: '100%',
    height: 40,
    '& svg': {
      transform: 'rotate(90deg)'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {}
};

var TabScrollButton__ref = /*#__PURE__*/react["createElement"](KeyboardArrowLeft, {
  fontSize: "small"
});

var TabScrollButton__ref2 = /*#__PURE__*/react["createElement"](KeyboardArrowRight, {
  fontSize: "small"
});

var TabScrollButton_TabScrollButton = /*#__PURE__*/react["forwardRef"](function TabScrollButton(props, ref) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      orientation = props.orientation,
      disabled = props.disabled,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["classes", "className", "direction", "orientation", "disabled"]);

  return /*#__PURE__*/react["createElement"](ButtonBase["a" /* default */], Object(esm_extends["a" /* default */])({
    component: "div",
    className: Object(clsx_m["a" /* default */])(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
    ref: ref,
    role: null,
    tabIndex: null
  }, other), direction === 'left' ? TabScrollButton__ref : TabScrollButton__ref2);
});
 false ? TabScrollButton_TabScrollButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Which direction should the button indicate?
   */
  direction: PropTypes.oneOf(['left', 'right']).isRequired,

  /**
   * If `true`, the element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ var esm_TabScrollButton_TabScrollButton = (Object(withStyles["a" /* default */])(TabScrollButton_styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton_TabScrollButton));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TabScrollButton/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js


















var Tabs_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      display: 'flex'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: 'scroll',
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: 'none',
      // Firefox
      '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome

      }
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: Object(defineProperty["a" /* default */])({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};
var Tabs_Tabs = /*#__PURE__*/react["forwardRef"](function Tabs(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      action = props.action,
      _props$centered = props.centered,
      centered = _props$centered === void 0 ? false : _props$centered,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$indicatorColor = props.indicatorColor,
      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
      onChange = props.onChange,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$ScrollButtonCo = props.ScrollButtonComponent,
      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? esm_TabScrollButton_TabScrollButton : _props$ScrollButtonCo,
      _props$scrollButtons = props.scrollButtons,
      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$TabIndicatorPr = props.TabIndicatorProps,
      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
      TabScrollButtonProps = props.TabScrollButtonProps,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);

  var theme = Object(useTheme["a" /* default */])();
  var scrollable = variant === 'scrollable';
  var isRtl = theme.direction === 'rtl';
  var vertical = orientation === 'vertical';
  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  var start = vertical ? 'top' : 'left';
  var end = vertical ? 'bottom' : 'right';
  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
  var size = vertical ? 'height' : 'width';

  if (false) {
    if (centered && scrollable) {
      console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }

  var _React$useState = react["useState"](false),
      mounted = _React$useState[0],
      setMounted = _React$useState[1];

  var _React$useState2 = react["useState"]({}),
      indicatorStyle = _React$useState2[0],
      setIndicatorStyle = _React$useState2[1];

  var _React$useState3 = react["useState"]({
    start: false,
    end: false
  }),
      displayScroll = _React$useState3[0],
      setDisplayScroll = _React$useState3[1];

  var _React$useState4 = react["useState"]({
    overflow: 'hidden',
    marginBottom: null
  }),
      scrollerStyle = _React$useState4[0],
      setScrollerStyle = _React$useState4[1];

  var valueToIndex = new Map();
  var tabsRef = react["useRef"](null);
  var tabListRef = react["useRef"](null);

  var getTabsMeta = function getTabsMeta() {
    var tabsNode = tabsRef.current;
    var tabsMeta;

    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: getNormalizedScrollLeft(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }

    var tabMeta;

    if (tabsNode && value !== false) {
      var _children = tabListRef.current.children;

      if (_children.length > 0) {
        var tab = _children[valueToIndex.get(value)];

        if (false) {
          if (!tab) {
            console.error(["Material-UI: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
          }
        }

        tabMeta = tab ? tab.getBoundingClientRect() : null;
      }
    }

    return {
      tabsMeta: tabsMeta,
      tabMeta: tabMeta
    };
  };

  var updateIndicatorState = Object(useEventCallback["a" /* default */])(function () {
    var _newIndicatorStyle;

    var _getTabsMeta = getTabsMeta(),
        tabsMeta = _getTabsMeta.tabsMeta,
        tabMeta = _getTabsMeta.tabMeta;

    var startValue = 0;

    if (tabMeta && tabsMeta) {
      if (vertical) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      } else {
        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = tabMeta.left - tabsMeta.left + correction;
      }
    }

    var newIndicatorStyle = (_newIndicatorStyle = {}, Object(defineProperty["a" /* default */])(_newIndicatorStyle, start, startValue), Object(defineProperty["a" /* default */])(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);

    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);

      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });

  var scroll = function scroll(scrollValue) {
    animate(scrollStart, tabsRef.current, scrollValue);
  };

  var moveTabsScroll = function moveTabsScroll(delta) {
    var scrollValue = tabsRef.current[scrollStart];

    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge

      scrollValue *= isRtl && detectScrollType() === 'reverse' ? -1 : 1;
    }

    scroll(scrollValue);
  };

  var handleStartScrollClick = function handleStartScrollClick() {
    moveTabsScroll(-tabsRef.current[clientSize]);
  };

  var handleEndScrollClick = function handleEndScrollClick() {
    moveTabsScroll(tabsRef.current[clientSize]);
  };

  var handleScrollbarSizeChange = react["useCallback"](function (scrollbarHeight) {
    setScrollerStyle({
      overflow: null,
      marginBottom: -scrollbarHeight
    });
  }, []);

  var getConditionalElements = function getConditionalElements() {
    var conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/react["createElement"](ScrollbarSize, {
      className: classes.scrollable,
      onChange: handleScrollbarSizeChange
    }) : null;
    var scrollButtonsActive = displayScroll.start || displayScroll.end;
    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/react["createElement"](ScrollButtonComponent, Object(esm_extends["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayScroll.start,
      className: Object(clsx_m["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/react["createElement"](ScrollButtonComponent, Object(esm_extends["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayScroll.end,
      className: Object(clsx_m["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    return conditionalElements;
  };

  var scrollSelectedIntoView = Object(useEventCallback["a" /* default */])(function () {
    var _getTabsMeta2 = getTabsMeta(),
        tabsMeta = _getTabsMeta2.tabsMeta,
        tabMeta = _getTabsMeta2.tabMeta;

    if (!tabMeta || !tabsMeta) {
      return;
    }

    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart);
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);

      scroll(_nextScrollStart);
    }
  });
  var updateScrollButtonState = Object(useEventCallback["a" /* default */])(function () {
    if (scrollable && scrollButtons !== 'off') {
      var _tabsRef$current = tabsRef.current,
          scrollTop = _tabsRef$current.scrollTop,
          scrollHeight = _tabsRef$current.scrollHeight,
          clientHeight = _tabsRef$current.clientHeight,
          scrollWidth = _tabsRef$current.scrollWidth,
          clientWidth = _tabsRef$current.clientWidth;
      var showStartScroll;
      var showEndScroll;

      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        var scrollLeft = getNormalizedScrollLeft(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.

        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  react["useEffect"](function () {
    var handleResize = Object(debounce["a" /* default */])(function () {
      updateIndicatorState();
      updateScrollButtonState();
    });
    var win = Object(ownerWindow["a" /* default */])(tabsRef.current);
    win.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var handleTabsScroll = react["useCallback"](Object(debounce["a" /* default */])(function () {
    updateScrollButtonState();
  }));
  react["useEffect"](function () {
    return function () {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  react["useEffect"](function () {
    setMounted(true);
  }, []);
  react["useEffect"](function () {
    updateIndicatorState();
    updateScrollButtonState();
  });
  react["useEffect"](function () {
    scrollSelectedIntoView();
  }, [scrollSelectedIntoView, indicatorStyle]);
  react["useImperativeHandle"](action, function () {
    return {
      updateIndicator: updateIndicatorState,
      updateScrollButtons: updateScrollButtonState
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var indicator = /*#__PURE__*/react["createElement"](Tabs_TabIndicator, Object(esm_extends["a" /* default */])({
    className: classes.indicator,
    orientation: orientation,
    color: indicatorColor
  }, TabIndicatorProps, {
    style: Object(esm_extends["a" /* default */])({}, indicatorStyle, TabIndicatorProps.style)
  }));
  var childIndex = 0;
  var children = react["Children"].map(childrenProp, function (child) {
    if (! /*#__PURE__*/react["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    var selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/react["cloneElement"](child, {
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected: selected,
      selectionFollowsFocus: selectionFollowsFocus,
      onChange: onChange,
      textColor: textColor,
      value: childValue
    });
  });

  var handleKeyDown = function handleKeyDown(event) {
    var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation

    var role = target.getAttribute('role');

    if (role !== 'tab') {
      return;
    }

    var newFocusTarget = null;
    var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
    var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';

    if (orientation !== "vertical" && theme.direction === 'rtl') {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }

    switch (event.key) {
      case previousItemKey:
        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
        break;

      case nextItemKey:
        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
        break;

      case 'Home':
        newFocusTarget = tabListRef.current.firstChild;
        break;

      case 'End':
        newFocusTarget = tabListRef.current.lastChild;
        break;

      default:
        break;
    }

    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };

  var conditionalElements = getConditionalElements();
  return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className, vertical && classes.vertical),
    ref: ref
  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/react["createElement"]("div", {
    className: Object(clsx_m["a" /* default */])(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
    style: scrollerStyle,
    ref: tabsRef,
    onScroll: handleTabsScroll
  }, /*#__PURE__*/react["createElement"]("div", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: Object(clsx_m["a" /* default */])(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
    onKeyDown: handleKeyDown,
    ref: tabListRef,
    role: "tablist"
  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
 false ? Tabs_Tabs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,

  /**
   * The label for the Tabs as a string.
   */
  'aria-label': PropTypes.string,

  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: PropTypes.elementType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `desktop` will only present them on medium and larger viewports.
   * - `on` will always present them.
   * - `off` will never present them.
   */
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'off', 'on']),

  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * Props applied to the tab indicator element.
   */
  TabIndicatorProps: PropTypes.object,

  /**
   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
   */
  TabScrollButtonProps: PropTypes.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: PropTypes.any,

  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard'])
} : void 0;
/* harmony default export */ var esm_Tabs_Tabs = (Object(withStyles["a" /* default */])(Tabs_styles, {
  name: 'MuiTabs'
})(Tabs_Tabs));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tabs/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js














var variantComponent = {
  standard: esm_Input_Input,
  filled: esm_FilledInput_FilledInput,
  outlined: esm_OutlinedInput_OutlinedInput
};
var TextField_styles = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField_TextField = /*#__PURE__*/react["forwardRef"](function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);

  if (false) {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/react["createElement"](react["Fragment"], null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/react["createElement"](InputComponent, Object(esm_extends["a" /* default */])({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/react["createElement"](esm_FormControl_FormControl, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/react["createElement"](esm_InputLabel_InputLabel, Object(esm_extends["a" /* default */])({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/react["createElement"](esm_Select_Select, Object(esm_extends["a" /* default */])({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/react["createElement"](esm_FormHelperText_FormHelperText, Object(esm_extends["a" /* default */])({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? TextField_TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label content.
   */
  label: PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ var esm_TextField_TextField = (Object(withStyles["a" /* default */])(TextField_styles, {
  name: 'MuiTextField'
})(TextField_TextField));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/TextField/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js





















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var Tooltip_styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: Object(colorManipulator["d" /* fade */])(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: Object(colorManipulator["d" /* fade */])(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: Object(defineProperty["a" /* default */])({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: Object(defineProperty["a" /* default */])({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: Object(defineProperty["a" /* default */])({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: Object(defineProperty["a" /* default */])({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
function testReset() {
  hystersisOpen = false;
  clearTimeout(hystersisTimer);
}
var Tooltip_Tooltip = /*#__PURE__*/react["forwardRef"](function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? esm_Popper_Popper : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = Object(useTheme["a" /* default */])();

  var _React$useState = react["useState"](),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = react["useState"](null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = react["useRef"](false);
  var closeTimer = react["useRef"]();
  var enterTimer = react["useRef"]();
  var leaveTimer = react["useRef"]();
  var touchTimer = react["useRef"]();

  var _useControlled = Object(useControlled["a" /* default */])({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = Object(slicedToArray["a" /* default */])(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _React$useRef = React.useRef(openProp !== undefined),
        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks


    React.useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  var id = Object(unstable_useId["a" /* default */])(idProp);
  react["useEffect"](function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = Object(useIsFocusVisible["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = react["useState"](false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = Object(useForkRef["a" /* default */])(setChildNode, ref);
  var handleFocusRef = Object(useForkRef["a" /* default */])(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react["useCallback"](function (instance) {
    // #StrictMode ready
    Object(setRef["a" /* default */])(handleFocusRef, react_dom["findDOMNode"](instance));
  }, [handleFocusRef]);
  var handleRef = Object(useForkRef["a" /* default */])(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = Object(esm_extends["a" /* default */])({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: Object(clsx_m["a" /* default */])(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  if (false) {
    if (children.props.title) {
      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  var mergedPopperProps = react["useMemo"](function () {
    return Object(esm["a" /* deepmerge */])({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/react["createElement"](react["Fragment"], null, /*#__PURE__*/react["cloneElement"](children, childrenProps), /*#__PURE__*/react["createElement"](PopperComponent, Object(esm_extends["a" /* default */])({
    className: Object(clsx_m["a" /* default */])(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/react["createElement"]("div", {
      className: Object(clsx_m["a" /* default */])(classes.tooltip, classes["tooltipPlacement".concat(Object(capitalize["a" /* default */])(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/react["createElement"]("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
 false ? Tooltip_Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: PropTypes.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: PropTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: PropTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: PropTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: PropTypes.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   */
  enterNextDelay: PropTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: PropTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: PropTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: PropTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: PropTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: PropTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ var esm_Tooltip_Tooltip = (Object(withStyles["a" /* default */])(Tooltip_styles, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip_Tooltip));
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Tooltip/index.js

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/index.js + 1 modules
var Unstable_TrapFocus = __webpack_require__(441);

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/useScrollTrigger/useScrollTrigger.js




function defaultTrigger(store, options) {
  var _options$disableHyste = options.disableHysteresis,
      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
      _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
      target = options.target;
  var previous = store.current;

  if (target) {
    // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

var defaultTarget = typeof window !== 'undefined' ? window : null;
function useScrollTrigger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$getTrigger = options.getTrigger,
      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
      _options$target = options.target,
      target = _options$target === void 0 ? defaultTarget : _options$target,
      other = Object(objectWithoutProperties["a" /* default */])(options, ["getTrigger", "target"]);

  var store = react["useRef"]();

  var _React$useState = react["useState"](function () {
    return getTrigger(store, other);
  }),
      trigger = _React$useState[0],
      setTrigger = _React$useState[1];

  react["useEffect"](function () {
    var handleScroll = function handleScroll() {
      setTrigger(getTrigger(store, Object(esm_extends["a" /* default */])({
        target: target
      }, other)));
    };

    handleScroll(); // Re-evaluate trigger when dependencies change

    target.addEventListener('scroll', handleScroll);
    return function () {
      target.removeEventListener('scroll', handleScroll);
    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/useScrollTrigger/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/withMobileDialog/withMobileDialog.js




/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server-side rendering.
 */

var withMobileDialog_withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return /*#__PURE__*/react["createElement"](Component, Object(esm_extends["a" /* default */])({
        fullScreen: withWidth_isWidthDown(breakpoint, props.width)
      }, props));
    }

     false ? WithMobileDialog.propTypes = {
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : void 0;
    return esm_withWidth_withWidth()(WithMobileDialog);
  };
};

/* harmony default export */ var esm_withMobileDialog_withMobileDialog = (withMobileDialog_withMobileDialog);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/withMobileDialog/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Zoom/Zoom.js










var Zoom_styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};
var Zoom_defaultTimeout = {
  enter: transitions["b" /* duration */].enteringScreen,
  exit: transitions["b" /* duration */].leavingScreen
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/components/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom_Zoom = /*#__PURE__*/react["forwardRef"](function Zoom(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? Zoom_defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group_esm["a" /* Transition */] : _props$TransitionComp,
      other = Object(objectWithoutProperties["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(useTheme["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react["useRef"](null);
  var foreignRef = Object(useForkRef["a" /* default */])(children.ref, ref);
  var handleRef = Object(useForkRef["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(transitions_utils["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(transitions_utils["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/react["createElement"](TransitionComponent, Object(esm_extends["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react["cloneElement"](children, Object(esm_extends["a" /* default */])({
      style: Object(esm_extends["a" /* default */])({
        transform: 'scale(0)',
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, Zoom_styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Zoom_Zoom.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ var esm_Zoom_Zoom = (Zoom_Zoom);
// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Zoom/index.js

// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "colors", function() { return colors_namespaceObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "hexToRgb", function() { return colorManipulator["g" /* hexToRgb */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rgbToHex", function() { return colorManipulator["k" /* rgbToHex */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "hslToRgb", function() { return colorManipulator["h" /* hslToRgb */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "decomposeColor", function() { return colorManipulator["b" /* decomposeColor */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "recomposeColor", function() { return colorManipulator["j" /* recomposeColor */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getContrastRatio", function() { return colorManipulator["e" /* getContrastRatio */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getLuminance", function() { return colorManipulator["f" /* getLuminance */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "emphasize", function() { return colorManipulator["c" /* emphasize */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "fade", function() { return colorManipulator["d" /* fade */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "darken", function() { return colorManipulator["a" /* darken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lighten", function() { return colorManipulator["i" /* lighten */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createMuiTheme", function() { return createMuiTheme["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unstable_createMuiStrictModeTheme", function() { return createMuiStrictModeTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStyles", function() { return createStyles; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "makeStyles", function() { return styles_makeStyles; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "responsiveFontSizes", function() { return responsiveFontSizes; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "styled", function() { return styles_styled; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useTheme", function() { return useTheme["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withStyles", function() { return withStyles["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withTheme", function() { return styles_withTheme; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createGenerateClassName", function() { return styles_esm["d" /* createGenerateClassName */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "jssPreset", function() { return styles_esm["g" /* jssPreset */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ServerStyleSheets", function() { return styles_esm["a" /* ServerStyleSheets */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StylesProvider", function() { return styles_esm["b" /* StylesProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MuiThemeProvider", function() { return styles_esm["c" /* ThemeProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return styles_esm["c" /* ThemeProvider */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "easing", function() { return transitions["c" /* easing */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "duration", function() { return transitions["b" /* duration */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "capitalize", function() { return utils["capitalize"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return utils["createChainedFunction"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createSvgIcon", function() { return utils["createSvgIcon"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return utils["debounce"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "deprecatedPropType", function() { return utils["deprecatedPropType"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMuiElement", function() { return utils["isMuiElement"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ownerDocument", function() { return utils["ownerDocument"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ownerWindow", function() { return utils["ownerWindow"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "requirePropFactory", function() { return utils["requirePropFactory"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setRef", function() { return utils["setRef"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unsupportedProp", function() { return utils["unsupportedProp"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useControlled", function() { return utils["useControlled"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useEventCallback", function() { return utils["useEventCallback"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useForkRef", function() { return utils["useForkRef"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unstable_useId", function() { return utils["unstable_useId"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useIsFocusVisible", function() { return utils["useIsFocusVisible"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Accordion", function() { return esm_Accordion_Accordion; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AccordionActions", function() { return esm_AccordionActions_AccordionActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AccordionDetails", function() { return esm_AccordionDetails_AccordionDetails; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AccordionSummary", function() { return esm_AccordionSummary_AccordionSummary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "AppBar", function() { return esm_AppBar_AppBar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Avatar", function() { return esm_Avatar_Avatar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Backdrop", function() { return esm_Backdrop_Backdrop; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Badge", function() { return esm_Badge_Badge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BottomNavigation", function() { return esm_BottomNavigation_BottomNavigation; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BottomNavigationAction", function() { return esm_BottomNavigationAction_BottomNavigationAction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Box", function() { return Box_Box; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "styleFunction", function() { return styleFunction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return esm_Breadcrumbs_Breadcrumbs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Button", function() { return esm_Button_Button; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonBase", function() { return ButtonBase["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return esm_ButtonGroup_ButtonGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Card", function() { return esm_Card_Card; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CardActionArea", function() { return esm_CardActionArea_CardActionArea; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CardActions", function() { return esm_CardActions_CardActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CardContent", function() { return esm_CardContent_CardContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CardHeader", function() { return esm_CardHeader_CardHeader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CardMedia", function() { return esm_CardMedia_CardMedia; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Checkbox", function() { return esm_Checkbox_Checkbox; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Chip", function() { return esm_Chip_Chip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CircularProgress", function() { return esm_CircularProgress_CircularProgress; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ClickAwayListener", function() { return ClickAwayListener_ClickAwayListener; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Collapse", function() { return esm_Collapse_Collapse; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Container", function() { return esm_Container_Container; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "CssBaseline", function() { return CssBaseline_CssBaseline; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Dialog", function() { return esm_Dialog_Dialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DialogActions", function() { return esm_DialogActions_DialogActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DialogContent", function() { return esm_DialogContent_DialogContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DialogContentText", function() { return esm_DialogContentText_DialogContentText; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DialogTitle", function() { return esm_DialogTitle_DialogTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Divider", function() { return esm_Divider_Divider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Drawer", function() { return esm_Drawer_Drawer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ExpansionPanel", function() { return esm_ExpansionPanel_ExpansionPanel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ExpansionPanelActions", function() { return esm_ExpansionPanelActions_ExpansionPanelActions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ExpansionPanelDetails", function() { return esm_ExpansionPanelDetails_ExpansionPanelDetails; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ExpansionPanelSummary", function() { return esm_ExpansionPanelSummary_ExpansionPanelSummary; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Fab", function() { return esm_Fab_Fab; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Fade", function() { return esm_Fade_Fade; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FilledInput", function() { return esm_FilledInput_FilledInput; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormControl", function() { return esm_FormControl_FormControl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useFormControl", function() { return useFormControl_useFormControl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormControlLabel", function() { return esm_FormControlLabel_FormControlLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormGroup", function() { return esm_FormGroup_FormGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormHelperText", function() { return esm_FormHelperText_FormHelperText; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "FormLabel", function() { return esm_FormLabel_FormLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grid", function() { return esm_Grid_Grid; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GridList", function() { return esm_GridList_GridList; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GridListTile", function() { return esm_GridListTile_GridListTile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "GridListTileBar", function() { return esm_GridListTileBar_GridListTileBar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Grow", function() { return Grow["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Hidden", function() { return Hidden_Hidden; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Icon", function() { return esm_Icon_Icon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "IconButton", function() { return IconButton["default"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Input", function() { return esm_Input_Input; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InputAdornment", function() { return esm_InputAdornment_InputAdornment; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InputBase", function() { return esm_InputBase_InputBase; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "InputLabel", function() { return esm_InputLabel_InputLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "LinearProgress", function() { return esm_LinearProgress_LinearProgress; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return esm_Link_Link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "List", function() { return List["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItem", function() { return ListItem["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItemAvatar", function() { return esm_ListItemAvatar_ListItemAvatar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItemIcon", function() { return esm_ListItemIcon_ListItemIcon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItemSecondaryAction", function() { return esm_ListItemSecondaryAction_ListItemSecondaryAction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListItemText", function() { return esm_ListItemText_ListItemText; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ListSubheader", function() { return esm_ListSubheader_ListSubheader; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Menu", function() { return Menu["default"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuItem", function() { return MenuItem["default"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MenuList", function() { return MenuList["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MobileStepper", function() { return esm_MobileStepper_MobileStepper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Modal", function() { return Modal["b" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ModalManager", function() { return Modal["a" /* ModalManager */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NativeSelect", function() { return esm_NativeSelect_NativeSelect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NoSsr", function() { return NoSsr_NoSsr; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "OutlinedInput", function() { return esm_OutlinedInput_OutlinedInput; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Paper", function() { return Paper["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Popover", function() { return Popover["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Popper", function() { return esm_Popper_Popper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Portal", function() { return Portal["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Radio", function() { return esm_Radio_Radio; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return esm_RadioGroup_RadioGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useRadioGroup", function() { return useRadioGroup; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "RootRef", function() { return esm_RootRef_RootRef; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Select", function() { return esm_Select_Select; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Slide", function() { return esm_Slide_Slide; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Slider", function() { return esm_Slider_Slider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Snackbar", function() { return esm_Snackbar_Snackbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SnackbarContent", function() { return esm_SnackbarContent_SnackbarContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Step", function() { return esm_Step_Step; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StepButton", function() { return esm_StepButton_StepButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StepConnector", function() { return esm_StepConnector_StepConnector; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StepContent", function() { return esm_StepContent_StepContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StepIcon", function() { return esm_StepIcon_StepIcon; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StepLabel", function() { return esm_StepLabel_StepLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Stepper", function() { return esm_Stepper_Stepper; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SvgIcon", function() { return SvgIcon["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SwipeableDrawer", function() { return esm_SwipeableDrawer_SwipeableDrawer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Switch", function() { return esm_Switch_Switch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tab", function() { return esm_Tab_Tab; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Table", function() { return esm_Table_Table; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableBody", function() { return esm_TableBody_TableBody; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableCell", function() { return esm_TableCell_TableCell; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableContainer", function() { return esm_TableContainer_TableContainer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableFooter", function() { return esm_TableFooter_TableFooter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableHead", function() { return esm_TableHead_TableHead; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TablePagination", function() { return esm_TablePagination_TablePagination; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableRow", function() { return esm_TableRow_TableRow; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TableSortLabel", function() { return esm_TableSortLabel_TableSortLabel; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabs", function() { return esm_Tabs_Tabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TabScrollButton", function() { return esm_TabScrollButton_TabScrollButton; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TextField", function() { return esm_TextField_TextField; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "TextareaAutosize", function() { return esm_TextareaAutosize_TextareaAutosize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Toolbar", function() { return esm_Toolbar_Toolbar; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return esm_Tooltip_Tooltip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Typography", function() { return esm_Typography_Typography; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Unstable_TrapFocus", function() { return Unstable_TrapFocus["a" /* default */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useMediaQuery", function() { return useMediaQuery; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useScrollTrigger", function() { return useScrollTrigger; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withMobileDialog", function() { return esm_withMobileDialog_withMobileDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withWidth", function() { return esm_withWidth_withWidth; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWidthUp", function() { return withWidth_isWidthUp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWidthDown", function() { return withWidth_isWidthDown; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Zoom", function() { return esm_Zoom_Zoom; });
/** @license Material-UI v4.11.4
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */









































































































































































































































 // eslint-disable-next-line camelcase














/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["a"] = (blue);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["a"] = (green);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["a"] = (orange);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(11);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/responsivePropType.js

var responsivePropType_responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* harmony default export */ var esm_responsivePropType = (responsivePropType_responsivePropType);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(146);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(255);

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/index.js + 10 modules
var esm = __webpack_require__(19);

// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/merge.js


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(esm["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ var esm_merge = (merge);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(esm_typeof["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(esm_extends["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return esm_merge(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(toConsumableArray["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* harmony default export */ var esm_breakpoints = (breakpoints);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/style.js




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style_style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(defineProperty["a" /* default */])({}, cssProperty, value);
    };

    return handleBreakpoints(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ var esm_style = (style_style);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/compose.js



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return esm_merge(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ var esm_compose = (compose);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/borders.js



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = esm_style({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = esm_style({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = esm_style({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = esm_style({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = esm_style({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = esm_style({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = esm_style({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* harmony default export */ var esm_borders = (borders);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/css.js





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(esm_extends["a" /* default */])({}, esm_merge(output, styleFunction(Object(esm_extends["a" /* default */])({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(Object(toConsumableArray["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* harmony default export */ var esm_css = (css);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/display.js


var displayPrint = esm_style({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = esm_style({
  prop: 'display'
});
var overflow = esm_style({
  prop: 'overflow'
});
var textOverflow = esm_style({
  prop: 'textOverflow'
});
var visibility = esm_style({
  prop: 'visibility'
});
var whiteSpace = esm_style({
  prop: 'whiteSpace'
});
/* harmony default export */ var display = (esm_compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/flexbox.js


var flexBasis = esm_style({
  prop: 'flexBasis'
});
var flexDirection = esm_style({
  prop: 'flexDirection'
});
var flexWrap = esm_style({
  prop: 'flexWrap'
});
var justifyContent = esm_style({
  prop: 'justifyContent'
});
var alignItems = esm_style({
  prop: 'alignItems'
});
var alignContent = esm_style({
  prop: 'alignContent'
});
var order = esm_style({
  prop: 'order'
});
var flex = esm_style({
  prop: 'flex'
});
var flexGrow = esm_style({
  prop: 'flexGrow'
});
var flexShrink = esm_style({
  prop: 'flexShrink'
});
var alignSelf = esm_style({
  prop: 'alignSelf'
});
var justifyItems = esm_style({
  prop: 'justifyItems'
});
var justifySelf = esm_style({
  prop: 'justifySelf'
});
var flexbox = esm_compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ var esm_flexbox = (flexbox);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/grid.js


var gridGap = esm_style({
  prop: 'gridGap'
});
var gridColumnGap = esm_style({
  prop: 'gridColumnGap'
});
var gridRowGap = esm_style({
  prop: 'gridRowGap'
});
var gridColumn = esm_style({
  prop: 'gridColumn'
});
var gridRow = esm_style({
  prop: 'gridRow'
});
var gridAutoFlow = esm_style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = esm_style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = esm_style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = esm_style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = esm_style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = esm_style({
  prop: 'gridTemplateAreas'
});
var gridArea = esm_style({
  prop: 'gridArea'
});
var grid = esm_compose(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var esm_grid = (grid);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/palette.js


var color = esm_style({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = esm_style({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = esm_compose(color, bgcolor);
/* harmony default export */ var esm_palette = (palette);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/positions.js


var position = esm_style({
  prop: 'position'
});
var zIndex = esm_style({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var positions_top = esm_style({
  prop: 'top'
});
var right = esm_style({
  prop: 'right'
});
var bottom = esm_style({
  prop: 'bottom'
});
var left = esm_style({
  prop: 'left'
});
/* harmony default export */ var positions = (esm_compose(position, zIndex, positions_top, right, bottom, left));
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/shadows.js

var boxShadow = esm_style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* harmony default export */ var shadows = (boxShadow);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/sizing.js



function sizing_transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = esm_style({
  prop: 'width',
  transform: sizing_transform
});
var maxWidth = esm_style({
  prop: 'maxWidth',
  transform: sizing_transform
});
var minWidth = esm_style({
  prop: 'minWidth',
  transform: sizing_transform
});
var height = esm_style({
  prop: 'height',
  transform: sizing_transform
});
var maxHeight = esm_style({
  prop: 'maxHeight',
  transform: sizing_transform
});
var minHeight = esm_style({
  prop: 'minHeight',
  transform: sizing_transform
});
var sizeWidth = esm_style({
  prop: 'size',
  cssProperty: 'width',
  transform: sizing_transform
});
var sizeHeight = esm_style({
  prop: 'size',
  cssProperty: 'height',
  transform: sizing_transform
});
var boxSizing = esm_style({
  prop: 'boxSizing'
});
var sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = (sizing);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(101);

// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(slicedToArray["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }).reduce(esm_merge, {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/typography.js


var fontFamily = esm_style({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = esm_style({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = esm_style({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = esm_style({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = esm_style({
  prop: 'letterSpacing'
});
var lineHeight = esm_style({
  prop: 'lineHeight'
});
var textAlign = esm_style({
  prop: 'textAlign'
});
var typography = esm_compose(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* harmony default export */ var esm_typography = (typography);
// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return esm_borders; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return border; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderTop; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderRight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderBottom; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderLeft; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderColor; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return borderRadius; });
/* unused concated harmony import breakpoints */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_breakpoints; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return esm_compose; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return esm_css; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return display; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return esm_flexbox; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flexBasis; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flexDirection; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flexWrap; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return justifyContent; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return alignItems; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return alignContent; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return order; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flex; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flexGrow; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return flexShrink; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return alignSelf; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return justifyItems; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return justifySelf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return esm_grid; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridGap; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridColumnGap; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridRowGap; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridColumn; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridRow; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridAutoFlow; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridAutoColumns; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridAutoRows; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridTemplateColumns; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridTemplateRows; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridTemplateAreas; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return gridArea; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return esm_palette; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return color; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return bgcolor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return positions; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return position; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return zIndex; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return positions_top; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return right; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return bottom; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return left; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return shadows; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return esm_sizing; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return width; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return maxWidth; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return minWidth; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return height; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return maxHeight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return minHeight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return sizeWidth; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return sizeHeight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return boxSizing; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return esm_spacing; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return createUnarySpacing; });
/* unused concated harmony import style */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return esm_style; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return esm_typography; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fontFamily; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fontSize; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fontStyle; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return fontWeight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return letterSpacing; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return lineHeight; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return textAlign; });
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */























/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requirePropFactory;
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuList__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_setRef__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(62);













var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEntering = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"](instance);
          Object(__WEBPACK_IMPORTED_MODULE_11__utils_setRef__["a" /* default */])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    onEntering: handleEntering,
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__MenuList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenu'
})(Menu));

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeJourneyData = exports.mergeData = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeData = exports.mergeData = function mergeData(academicYears, cloneableMasterCourses, gradeLevels) {
  academicYears.map(function (year) {
    year.courses = [];
    cloneableMasterCourses.map(function (course) {
      if (course.academic_year_id === year.id) {
        gradeLevels.map(function (gl) {
          if (gl.id === course.grade_level_id) {
            year.courses.push((0, _assign2.default)({}, course, { grade_level_abbreviation: gl.abbreviation }));
          }
        });
      }
    });
  });
  return academicYears;
};

var mergeJourneyData = exports.mergeJourneyData = function mergeJourneyData(academicYears, cloneableJourneys, gradeLevels) {
  console.log('gradeLevels in mergeJourneyData', gradeLevels);
  academicYears.map(function (year) {
    console.log('year', year);
    year.courses = [];
    cloneableJourneys.map(function (journey) {
      console.log('journey', journey);
      if (journey.master_course.academic_year_id === year.id) {
        gradeLevels.map(function (gl) {
          console.log('gl', gl);
          if (gl.id === journey.master_course.grade_level_id) {
            year.courses.push((0, _assign2.default)({}, journey, { grade_level_abbreviation: gl.abbreviation }));
          }
        });
      }
    });
  });
  console.log('academicYears in mergeJourneyData', academicYears);
  return academicYears;
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #bbbbbb;\n  font-size: 11px;\n  height: 0;\n  position: relative;\n'], ['\n  color: #bbbbbb;\n  font-size: 11px;\n  height: 0;\n  position: relative;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputHint = _styledComponents2.default.div.withConfig({
  displayName: 'InputHint',
  componentId: 'sc-1vu0huj-0'
})(_templateObject);
exports.default = InputHint;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _Policy = __webpack_require__(1373);

var _Policy2 = _interopRequireDefault(_Policy);

var _policies = __webpack_require__(158);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Policies = function (_Component) {
  (0, _inherits3.default)(Policies, _Component);

  function Policies(props) {
    (0, _classCallCheck3.default)(this, Policies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Policies.__proto__ || (0, _getPrototypeOf2.default)(Policies)).call(this, props));

    _this.onAgreeClickBound = _this.onAgreeClick.bind(_this);
    _this.onDeclineClickBound = _this.onDeclineClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Policies, [{
    key: 'render',
    value: function render() {
      var policies = this.props.policies.map(function (policy, index) {
        return _react2.default.createElement(_Policy2.default, { key: policy.id, policy: policy, show: index === 0 });
      });

      var policyTabHeaders = this.props.policies.map(function (policy, index) {
        return _react2.default.createElement(
          'li',
          {
            key: index,
            'data-slug': policy.slug,
            onClick: this.onTabHeaderClick,
            className: index === 0 ? 'active' : ''
          },
          policy.name
        );
      }, this);

      return _react2.default.createElement(
        'div',
        { id: 'viewOurPoliciesWrapper' },
        _react2.default.createElement(
          'h2',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Policies.OurPolicies',
            defaultMessage: 'Our Policies'
          })
        ),
        !this.props.displayActions && _react2.default.createElement(
          'div',
          null,
          '\xA0'
        ),
        this.props.displayActions && _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Policies.ThankYouForYourInterest',
            defaultMessage: 'Thank you for your interest in our products and services. To use our apps, you must agree to the terms below. Please read them carefully and click "Agree to OE Policies" to confirm your agreement to these terms.'
          })
        ),
        _react2.default.createElement(
          'ul',
          { id: 'policyTabsHeader' },
          policyTabHeaders
        ),
        _react2.default.createElement(
          'ul',
          { id: 'policyTabs' },
          policies
        ),
        this.props.displayActions && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { id: 'ourPoliciesFooter' }),
          _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              {
                className: 'agree button active',
                onClick: this.onAgreeClickBound
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Policies.Agree',
                defaultMessage: 'AGREE TO OE POLICIES'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'decline', onClick: this.onDeclineClickBound },
              _messages.decline
            )
          )
        )
      );
    }
  }, {
    key: 'onAgreeClick',
    value: function onAgreeClick() {
      this.props.dispatch((0, _policies.acceptPolicies)());
    }
  }, {
    key: 'onDeclineClick',
    value: function onDeclineClick() {
      this.props.dispatch((0, _policies.userIsConsideringDecliningPolicies)());
      this.props.dispatch((0, _policies.showAcceptPoliciesModal)());
    }
  }, {
    key: 'onTabHeaderClick',
    value: function onTabHeaderClick(e) {
      var clickedEl = e.currentTarget;
      var slug = clickedEl.getAttribute('data-slug');
      var headerTabEls = document.querySelectorAll('#policyTabsHeader li');
      var tabEls = document.querySelectorAll('#policyTabs li');
      var el = document.querySelector('#policyTabs li#' + slug);

      // remove all active items from tab headers
      for (var i = 0; i < headerTabEls.length; i++) {
        headerTabEls[i].classList.remove('active');
      }
      // remove all active items from tabs
      for (var x = 0; x < tabEls.length; x++) {
        tabEls[x].classList.remove('active');
      }

      el.className += ' active';
      clickedEl.className += 'active';
    }
  }]);
  return Policies;
}(_react.Component);

exports.default = Policies;


Policies.propTypes = {
  dispatch: _propTypes2.default.func,
  policies: _propTypes2.default.array.isRequired,
  displayActions: _propTypes2.default.bool
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _time = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateFormatter = function (_Component) {
  (0, _inherits3.default)(DateFormatter, _Component);

  function DateFormatter() {
    (0, _classCallCheck3.default)(this, DateFormatter);
    return (0, _possibleConstructorReturn3.default)(this, (DateFormatter.__proto__ || (0, _getPrototypeOf2.default)(DateFormatter)).apply(this, arguments));
  }

  (0, _createClass3.default)(DateFormatter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cssClass = _props.cssClass,
          date = _props.date,
          abbreviateMonth = _props.abbreviateMonth,
          includeTime = _props.includeTime,
          timeOnly = _props.timeOnly;


      return _react2.default.createElement(
        'div',
        { className: 'oe-date ' + (cssClass || '') },
        _moment2.default.unix(date).format((0, _time.getFormat)(abbreviateMonth, includeTime, timeOnly))
      );
    }
  }]);
  return DateFormatter;
}(_react.Component);

exports.default = DateFormatter;


DateFormatter.defaultProps = {
  abbreviateMonth: false,
  includeTime: true
};

DateFormatter.propTypes = {
  abbreviateMonth: _propTypes2.default.bool,
  cssClass: _propTypes2.default.string,
  date: _propTypes2.default.number,
  includeTime: _propTypes2.default.bool,
  timeOnly: _propTypes2.default.bool
};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function checkForPolicyChanges(response) {
  return response.headers.get('X-Policy-Changes');
}

function parseJSON(response) {
  // .json() is part of isomorphic-fetch responses
  return response.json();
}

module.exports = {
  checkHttpStatus: checkHttpStatus,
  checkForPolicyChanges: checkForPolicyChanges,
  parseJSON: parseJSON
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// List of valid entities
//
// Generate with ./support/entities.js script
//


/*eslint quotes:0*/
module.exports = {
  "Aacute":"\u00C1",
  "aacute":"\u00E1",
  "Abreve":"\u0102",
  "abreve":"\u0103",
  "ac":"\u223E",
  "acd":"\u223F",
  "acE":"\u223E\u0333",
  "Acirc":"\u00C2",
  "acirc":"\u00E2",
  "acute":"\u00B4",
  "Acy":"\u0410",
  "acy":"\u0430",
  "AElig":"\u00C6",
  "aelig":"\u00E6",
  "af":"\u2061",
  "Afr":"\uD835\uDD04",
  "afr":"\uD835\uDD1E",
  "Agrave":"\u00C0",
  "agrave":"\u00E0",
  "alefsym":"\u2135",
  "aleph":"\u2135",
  "Alpha":"\u0391",
  "alpha":"\u03B1",
  "Amacr":"\u0100",
  "amacr":"\u0101",
  "amalg":"\u2A3F",
  "AMP":"\u0026",
  "amp":"\u0026",
  "And":"\u2A53",
  "and":"\u2227",
  "andand":"\u2A55",
  "andd":"\u2A5C",
  "andslope":"\u2A58",
  "andv":"\u2A5A",
  "ang":"\u2220",
  "ange":"\u29A4",
  "angle":"\u2220",
  "angmsd":"\u2221",
  "angmsdaa":"\u29A8",
  "angmsdab":"\u29A9",
  "angmsdac":"\u29AA",
  "angmsdad":"\u29AB",
  "angmsdae":"\u29AC",
  "angmsdaf":"\u29AD",
  "angmsdag":"\u29AE",
  "angmsdah":"\u29AF",
  "angrt":"\u221F",
  "angrtvb":"\u22BE",
  "angrtvbd":"\u299D",
  "angsph":"\u2222",
  "angst":"\u00C5",
  "angzarr":"\u237C",
  "Aogon":"\u0104",
  "aogon":"\u0105",
  "Aopf":"\uD835\uDD38",
  "aopf":"\uD835\uDD52",
  "ap":"\u2248",
  "apacir":"\u2A6F",
  "apE":"\u2A70",
  "ape":"\u224A",
  "apid":"\u224B",
  "apos":"\u0027",
  "ApplyFunction":"\u2061",
  "approx":"\u2248",
  "approxeq":"\u224A",
  "Aring":"\u00C5",
  "aring":"\u00E5",
  "Ascr":"\uD835\uDC9C",
  "ascr":"\uD835\uDCB6",
  "Assign":"\u2254",
  "ast":"\u002A",
  "asymp":"\u2248",
  "asympeq":"\u224D",
  "Atilde":"\u00C3",
  "atilde":"\u00E3",
  "Auml":"\u00C4",
  "auml":"\u00E4",
  "awconint":"\u2233",
  "awint":"\u2A11",
  "backcong":"\u224C",
  "backepsilon":"\u03F6",
  "backprime":"\u2035",
  "backsim":"\u223D",
  "backsimeq":"\u22CD",
  "Backslash":"\u2216",
  "Barv":"\u2AE7",
  "barvee":"\u22BD",
  "Barwed":"\u2306",
  "barwed":"\u2305",
  "barwedge":"\u2305",
  "bbrk":"\u23B5",
  "bbrktbrk":"\u23B6",
  "bcong":"\u224C",
  "Bcy":"\u0411",
  "bcy":"\u0431",
  "bdquo":"\u201E",
  "becaus":"\u2235",
  "Because":"\u2235",
  "because":"\u2235",
  "bemptyv":"\u29B0",
  "bepsi":"\u03F6",
  "bernou":"\u212C",
  "Bernoullis":"\u212C",
  "Beta":"\u0392",
  "beta":"\u03B2",
  "beth":"\u2136",
  "between":"\u226C",
  "Bfr":"\uD835\uDD05",
  "bfr":"\uD835\uDD1F",
  "bigcap":"\u22C2",
  "bigcirc":"\u25EF",
  "bigcup":"\u22C3",
  "bigodot":"\u2A00",
  "bigoplus":"\u2A01",
  "bigotimes":"\u2A02",
  "bigsqcup":"\u2A06",
  "bigstar":"\u2605",
  "bigtriangledown":"\u25BD",
  "bigtriangleup":"\u25B3",
  "biguplus":"\u2A04",
  "bigvee":"\u22C1",
  "bigwedge":"\u22C0",
  "bkarow":"\u290D",
  "blacklozenge":"\u29EB",
  "blacksquare":"\u25AA",
  "blacktriangle":"\u25B4",
  "blacktriangledown":"\u25BE",
  "blacktriangleleft":"\u25C2",
  "blacktriangleright":"\u25B8",
  "blank":"\u2423",
  "blk12":"\u2592",
  "blk14":"\u2591",
  "blk34":"\u2593",
  "block":"\u2588",
  "bne":"\u003D\u20E5",
  "bnequiv":"\u2261\u20E5",
  "bNot":"\u2AED",
  "bnot":"\u2310",
  "Bopf":"\uD835\uDD39",
  "bopf":"\uD835\uDD53",
  "bot":"\u22A5",
  "bottom":"\u22A5",
  "bowtie":"\u22C8",
  "boxbox":"\u29C9",
  "boxDL":"\u2557",
  "boxDl":"\u2556",
  "boxdL":"\u2555",
  "boxdl":"\u2510",
  "boxDR":"\u2554",
  "boxDr":"\u2553",
  "boxdR":"\u2552",
  "boxdr":"\u250C",
  "boxH":"\u2550",
  "boxh":"\u2500",
  "boxHD":"\u2566",
  "boxHd":"\u2564",
  "boxhD":"\u2565",
  "boxhd":"\u252C",
  "boxHU":"\u2569",
  "boxHu":"\u2567",
  "boxhU":"\u2568",
  "boxhu":"\u2534",
  "boxminus":"\u229F",
  "boxplus":"\u229E",
  "boxtimes":"\u22A0",
  "boxUL":"\u255D",
  "boxUl":"\u255C",
  "boxuL":"\u255B",
  "boxul":"\u2518",
  "boxUR":"\u255A",
  "boxUr":"\u2559",
  "boxuR":"\u2558",
  "boxur":"\u2514",
  "boxV":"\u2551",
  "boxv":"\u2502",
  "boxVH":"\u256C",
  "boxVh":"\u256B",
  "boxvH":"\u256A",
  "boxvh":"\u253C",
  "boxVL":"\u2563",
  "boxVl":"\u2562",
  "boxvL":"\u2561",
  "boxvl":"\u2524",
  "boxVR":"\u2560",
  "boxVr":"\u255F",
  "boxvR":"\u255E",
  "boxvr":"\u251C",
  "bprime":"\u2035",
  "Breve":"\u02D8",
  "breve":"\u02D8",
  "brvbar":"\u00A6",
  "Bscr":"\u212C",
  "bscr":"\uD835\uDCB7",
  "bsemi":"\u204F",
  "bsim":"\u223D",
  "bsime":"\u22CD",
  "bsol":"\u005C",
  "bsolb":"\u29C5",
  "bsolhsub":"\u27C8",
  "bull":"\u2022",
  "bullet":"\u2022",
  "bump":"\u224E",
  "bumpE":"\u2AAE",
  "bumpe":"\u224F",
  "Bumpeq":"\u224E",
  "bumpeq":"\u224F",
  "Cacute":"\u0106",
  "cacute":"\u0107",
  "Cap":"\u22D2",
  "cap":"\u2229",
  "capand":"\u2A44",
  "capbrcup":"\u2A49",
  "capcap":"\u2A4B",
  "capcup":"\u2A47",
  "capdot":"\u2A40",
  "CapitalDifferentialD":"\u2145",
  "caps":"\u2229\uFE00",
  "caret":"\u2041",
  "caron":"\u02C7",
  "Cayleys":"\u212D",
  "ccaps":"\u2A4D",
  "Ccaron":"\u010C",
  "ccaron":"\u010D",
  "Ccedil":"\u00C7",
  "ccedil":"\u00E7",
  "Ccirc":"\u0108",
  "ccirc":"\u0109",
  "Cconint":"\u2230",
  "ccups":"\u2A4C",
  "ccupssm":"\u2A50",
  "Cdot":"\u010A",
  "cdot":"\u010B",
  "cedil":"\u00B8",
  "Cedilla":"\u00B8",
  "cemptyv":"\u29B2",
  "cent":"\u00A2",
  "CenterDot":"\u00B7",
  "centerdot":"\u00B7",
  "Cfr":"\u212D",
  "cfr":"\uD835\uDD20",
  "CHcy":"\u0427",
  "chcy":"\u0447",
  "check":"\u2713",
  "checkmark":"\u2713",
  "Chi":"\u03A7",
  "chi":"\u03C7",
  "cir":"\u25CB",
  "circ":"\u02C6",
  "circeq":"\u2257",
  "circlearrowleft":"\u21BA",
  "circlearrowright":"\u21BB",
  "circledast":"\u229B",
  "circledcirc":"\u229A",
  "circleddash":"\u229D",
  "CircleDot":"\u2299",
  "circledR":"\u00AE",
  "circledS":"\u24C8",
  "CircleMinus":"\u2296",
  "CirclePlus":"\u2295",
  "CircleTimes":"\u2297",
  "cirE":"\u29C3",
  "cire":"\u2257",
  "cirfnint":"\u2A10",
  "cirmid":"\u2AEF",
  "cirscir":"\u29C2",
  "ClockwiseContourIntegral":"\u2232",
  "CloseCurlyDoubleQuote":"\u201D",
  "CloseCurlyQuote":"\u2019",
  "clubs":"\u2663",
  "clubsuit":"\u2663",
  "Colon":"\u2237",
  "colon":"\u003A",
  "Colone":"\u2A74",
  "colone":"\u2254",
  "coloneq":"\u2254",
  "comma":"\u002C",
  "commat":"\u0040",
  "comp":"\u2201",
  "compfn":"\u2218",
  "complement":"\u2201",
  "complexes":"\u2102",
  "cong":"\u2245",
  "congdot":"\u2A6D",
  "Congruent":"\u2261",
  "Conint":"\u222F",
  "conint":"\u222E",
  "ContourIntegral":"\u222E",
  "Copf":"\u2102",
  "copf":"\uD835\uDD54",
  "coprod":"\u2210",
  "Coproduct":"\u2210",
  "COPY":"\u00A9",
  "copy":"\u00A9",
  "copysr":"\u2117",
  "CounterClockwiseContourIntegral":"\u2233",
  "crarr":"\u21B5",
  "Cross":"\u2A2F",
  "cross":"\u2717",
  "Cscr":"\uD835\uDC9E",
  "cscr":"\uD835\uDCB8",
  "csub":"\u2ACF",
  "csube":"\u2AD1",
  "csup":"\u2AD0",
  "csupe":"\u2AD2",
  "ctdot":"\u22EF",
  "cudarrl":"\u2938",
  "cudarrr":"\u2935",
  "cuepr":"\u22DE",
  "cuesc":"\u22DF",
  "cularr":"\u21B6",
  "cularrp":"\u293D",
  "Cup":"\u22D3",
  "cup":"\u222A",
  "cupbrcap":"\u2A48",
  "CupCap":"\u224D",
  "cupcap":"\u2A46",
  "cupcup":"\u2A4A",
  "cupdot":"\u228D",
  "cupor":"\u2A45",
  "cups":"\u222A\uFE00",
  "curarr":"\u21B7",
  "curarrm":"\u293C",
  "curlyeqprec":"\u22DE",
  "curlyeqsucc":"\u22DF",
  "curlyvee":"\u22CE",
  "curlywedge":"\u22CF",
  "curren":"\u00A4",
  "curvearrowleft":"\u21B6",
  "curvearrowright":"\u21B7",
  "cuvee":"\u22CE",
  "cuwed":"\u22CF",
  "cwconint":"\u2232",
  "cwint":"\u2231",
  "cylcty":"\u232D",
  "Dagger":"\u2021",
  "dagger":"\u2020",
  "daleth":"\u2138",
  "Darr":"\u21A1",
  "dArr":"\u21D3",
  "darr":"\u2193",
  "dash":"\u2010",
  "Dashv":"\u2AE4",
  "dashv":"\u22A3",
  "dbkarow":"\u290F",
  "dblac":"\u02DD",
  "Dcaron":"\u010E",
  "dcaron":"\u010F",
  "Dcy":"\u0414",
  "dcy":"\u0434",
  "DD":"\u2145",
  "dd":"\u2146",
  "ddagger":"\u2021",
  "ddarr":"\u21CA",
  "DDotrahd":"\u2911",
  "ddotseq":"\u2A77",
  "deg":"\u00B0",
  "Del":"\u2207",
  "Delta":"\u0394",
  "delta":"\u03B4",
  "demptyv":"\u29B1",
  "dfisht":"\u297F",
  "Dfr":"\uD835\uDD07",
  "dfr":"\uD835\uDD21",
  "dHar":"\u2965",
  "dharl":"\u21C3",
  "dharr":"\u21C2",
  "DiacriticalAcute":"\u00B4",
  "DiacriticalDot":"\u02D9",
  "DiacriticalDoubleAcute":"\u02DD",
  "DiacriticalGrave":"\u0060",
  "DiacriticalTilde":"\u02DC",
  "diam":"\u22C4",
  "Diamond":"\u22C4",
  "diamond":"\u22C4",
  "diamondsuit":"\u2666",
  "diams":"\u2666",
  "die":"\u00A8",
  "DifferentialD":"\u2146",
  "digamma":"\u03DD",
  "disin":"\u22F2",
  "div":"\u00F7",
  "divide":"\u00F7",
  "divideontimes":"\u22C7",
  "divonx":"\u22C7",
  "DJcy":"\u0402",
  "djcy":"\u0452",
  "dlcorn":"\u231E",
  "dlcrop":"\u230D",
  "dollar":"\u0024",
  "Dopf":"\uD835\uDD3B",
  "dopf":"\uD835\uDD55",
  "Dot":"\u00A8",
  "dot":"\u02D9",
  "DotDot":"\u20DC",
  "doteq":"\u2250",
  "doteqdot":"\u2251",
  "DotEqual":"\u2250",
  "dotminus":"\u2238",
  "dotplus":"\u2214",
  "dotsquare":"\u22A1",
  "doublebarwedge":"\u2306",
  "DoubleContourIntegral":"\u222F",
  "DoubleDot":"\u00A8",
  "DoubleDownArrow":"\u21D3",
  "DoubleLeftArrow":"\u21D0",
  "DoubleLeftRightArrow":"\u21D4",
  "DoubleLeftTee":"\u2AE4",
  "DoubleLongLeftArrow":"\u27F8",
  "DoubleLongLeftRightArrow":"\u27FA",
  "DoubleLongRightArrow":"\u27F9",
  "DoubleRightArrow":"\u21D2",
  "DoubleRightTee":"\u22A8",
  "DoubleUpArrow":"\u21D1",
  "DoubleUpDownArrow":"\u21D5",
  "DoubleVerticalBar":"\u2225",
  "DownArrow":"\u2193",
  "Downarrow":"\u21D3",
  "downarrow":"\u2193",
  "DownArrowBar":"\u2913",
  "DownArrowUpArrow":"\u21F5",
  "DownBreve":"\u0311",
  "downdownarrows":"\u21CA",
  "downharpoonleft":"\u21C3",
  "downharpoonright":"\u21C2",
  "DownLeftRightVector":"\u2950",
  "DownLeftTeeVector":"\u295E",
  "DownLeftVector":"\u21BD",
  "DownLeftVectorBar":"\u2956",
  "DownRightTeeVector":"\u295F",
  "DownRightVector":"\u21C1",
  "DownRightVectorBar":"\u2957",
  "DownTee":"\u22A4",
  "DownTeeArrow":"\u21A7",
  "drbkarow":"\u2910",
  "drcorn":"\u231F",
  "drcrop":"\u230C",
  "Dscr":"\uD835\uDC9F",
  "dscr":"\uD835\uDCB9",
  "DScy":"\u0405",
  "dscy":"\u0455",
  "dsol":"\u29F6",
  "Dstrok":"\u0110",
  "dstrok":"\u0111",
  "dtdot":"\u22F1",
  "dtri":"\u25BF",
  "dtrif":"\u25BE",
  "duarr":"\u21F5",
  "duhar":"\u296F",
  "dwangle":"\u29A6",
  "DZcy":"\u040F",
  "dzcy":"\u045F",
  "dzigrarr":"\u27FF",
  "Eacute":"\u00C9",
  "eacute":"\u00E9",
  "easter":"\u2A6E",
  "Ecaron":"\u011A",
  "ecaron":"\u011B",
  "ecir":"\u2256",
  "Ecirc":"\u00CA",
  "ecirc":"\u00EA",
  "ecolon":"\u2255",
  "Ecy":"\u042D",
  "ecy":"\u044D",
  "eDDot":"\u2A77",
  "Edot":"\u0116",
  "eDot":"\u2251",
  "edot":"\u0117",
  "ee":"\u2147",
  "efDot":"\u2252",
  "Efr":"\uD835\uDD08",
  "efr":"\uD835\uDD22",
  "eg":"\u2A9A",
  "Egrave":"\u00C8",
  "egrave":"\u00E8",
  "egs":"\u2A96",
  "egsdot":"\u2A98",
  "el":"\u2A99",
  "Element":"\u2208",
  "elinters":"\u23E7",
  "ell":"\u2113",
  "els":"\u2A95",
  "elsdot":"\u2A97",
  "Emacr":"\u0112",
  "emacr":"\u0113",
  "empty":"\u2205",
  "emptyset":"\u2205",
  "EmptySmallSquare":"\u25FB",
  "emptyv":"\u2205",
  "EmptyVerySmallSquare":"\u25AB",
  "emsp":"\u2003",
  "emsp13":"\u2004",
  "emsp14":"\u2005",
  "ENG":"\u014A",
  "eng":"\u014B",
  "ensp":"\u2002",
  "Eogon":"\u0118",
  "eogon":"\u0119",
  "Eopf":"\uD835\uDD3C",
  "eopf":"\uD835\uDD56",
  "epar":"\u22D5",
  "eparsl":"\u29E3",
  "eplus":"\u2A71",
  "epsi":"\u03B5",
  "Epsilon":"\u0395",
  "epsilon":"\u03B5",
  "epsiv":"\u03F5",
  "eqcirc":"\u2256",
  "eqcolon":"\u2255",
  "eqsim":"\u2242",
  "eqslantgtr":"\u2A96",
  "eqslantless":"\u2A95",
  "Equal":"\u2A75",
  "equals":"\u003D",
  "EqualTilde":"\u2242",
  "equest":"\u225F",
  "Equilibrium":"\u21CC",
  "equiv":"\u2261",
  "equivDD":"\u2A78",
  "eqvparsl":"\u29E5",
  "erarr":"\u2971",
  "erDot":"\u2253",
  "Escr":"\u2130",
  "escr":"\u212F",
  "esdot":"\u2250",
  "Esim":"\u2A73",
  "esim":"\u2242",
  "Eta":"\u0397",
  "eta":"\u03B7",
  "ETH":"\u00D0",
  "eth":"\u00F0",
  "Euml":"\u00CB",
  "euml":"\u00EB",
  "euro":"\u20AC",
  "excl":"\u0021",
  "exist":"\u2203",
  "Exists":"\u2203",
  "expectation":"\u2130",
  "ExponentialE":"\u2147",
  "exponentiale":"\u2147",
  "fallingdotseq":"\u2252",
  "Fcy":"\u0424",
  "fcy":"\u0444",
  "female":"\u2640",
  "ffilig":"\uFB03",
  "fflig":"\uFB00",
  "ffllig":"\uFB04",
  "Ffr":"\uD835\uDD09",
  "ffr":"\uD835\uDD23",
  "filig":"\uFB01",
  "FilledSmallSquare":"\u25FC",
  "FilledVerySmallSquare":"\u25AA",
  "fjlig":"\u0066\u006A",
  "flat":"\u266D",
  "fllig":"\uFB02",
  "fltns":"\u25B1",
  "fnof":"\u0192",
  "Fopf":"\uD835\uDD3D",
  "fopf":"\uD835\uDD57",
  "ForAll":"\u2200",
  "forall":"\u2200",
  "fork":"\u22D4",
  "forkv":"\u2AD9",
  "Fouriertrf":"\u2131",
  "fpartint":"\u2A0D",
  "frac12":"\u00BD",
  "frac13":"\u2153",
  "frac14":"\u00BC",
  "frac15":"\u2155",
  "frac16":"\u2159",
  "frac18":"\u215B",
  "frac23":"\u2154",
  "frac25":"\u2156",
  "frac34":"\u00BE",
  "frac35":"\u2157",
  "frac38":"\u215C",
  "frac45":"\u2158",
  "frac56":"\u215A",
  "frac58":"\u215D",
  "frac78":"\u215E",
  "frasl":"\u2044",
  "frown":"\u2322",
  "Fscr":"\u2131",
  "fscr":"\uD835\uDCBB",
  "gacute":"\u01F5",
  "Gamma":"\u0393",
  "gamma":"\u03B3",
  "Gammad":"\u03DC",
  "gammad":"\u03DD",
  "gap":"\u2A86",
  "Gbreve":"\u011E",
  "gbreve":"\u011F",
  "Gcedil":"\u0122",
  "Gcirc":"\u011C",
  "gcirc":"\u011D",
  "Gcy":"\u0413",
  "gcy":"\u0433",
  "Gdot":"\u0120",
  "gdot":"\u0121",
  "gE":"\u2267",
  "ge":"\u2265",
  "gEl":"\u2A8C",
  "gel":"\u22DB",
  "geq":"\u2265",
  "geqq":"\u2267",
  "geqslant":"\u2A7E",
  "ges":"\u2A7E",
  "gescc":"\u2AA9",
  "gesdot":"\u2A80",
  "gesdoto":"\u2A82",
  "gesdotol":"\u2A84",
  "gesl":"\u22DB\uFE00",
  "gesles":"\u2A94",
  "Gfr":"\uD835\uDD0A",
  "gfr":"\uD835\uDD24",
  "Gg":"\u22D9",
  "gg":"\u226B",
  "ggg":"\u22D9",
  "gimel":"\u2137",
  "GJcy":"\u0403",
  "gjcy":"\u0453",
  "gl":"\u2277",
  "gla":"\u2AA5",
  "glE":"\u2A92",
  "glj":"\u2AA4",
  "gnap":"\u2A8A",
  "gnapprox":"\u2A8A",
  "gnE":"\u2269",
  "gne":"\u2A88",
  "gneq":"\u2A88",
  "gneqq":"\u2269",
  "gnsim":"\u22E7",
  "Gopf":"\uD835\uDD3E",
  "gopf":"\uD835\uDD58",
  "grave":"\u0060",
  "GreaterEqual":"\u2265",
  "GreaterEqualLess":"\u22DB",
  "GreaterFullEqual":"\u2267",
  "GreaterGreater":"\u2AA2",
  "GreaterLess":"\u2277",
  "GreaterSlantEqual":"\u2A7E",
  "GreaterTilde":"\u2273",
  "Gscr":"\uD835\uDCA2",
  "gscr":"\u210A",
  "gsim":"\u2273",
  "gsime":"\u2A8E",
  "gsiml":"\u2A90",
  "GT":"\u003E",
  "Gt":"\u226B",
  "gt":"\u003E",
  "gtcc":"\u2AA7",
  "gtcir":"\u2A7A",
  "gtdot":"\u22D7",
  "gtlPar":"\u2995",
  "gtquest":"\u2A7C",
  "gtrapprox":"\u2A86",
  "gtrarr":"\u2978",
  "gtrdot":"\u22D7",
  "gtreqless":"\u22DB",
  "gtreqqless":"\u2A8C",
  "gtrless":"\u2277",
  "gtrsim":"\u2273",
  "gvertneqq":"\u2269\uFE00",
  "gvnE":"\u2269\uFE00",
  "Hacek":"\u02C7",
  "hairsp":"\u200A",
  "half":"\u00BD",
  "hamilt":"\u210B",
  "HARDcy":"\u042A",
  "hardcy":"\u044A",
  "hArr":"\u21D4",
  "harr":"\u2194",
  "harrcir":"\u2948",
  "harrw":"\u21AD",
  "Hat":"\u005E",
  "hbar":"\u210F",
  "Hcirc":"\u0124",
  "hcirc":"\u0125",
  "hearts":"\u2665",
  "heartsuit":"\u2665",
  "hellip":"\u2026",
  "hercon":"\u22B9",
  "Hfr":"\u210C",
  "hfr":"\uD835\uDD25",
  "HilbertSpace":"\u210B",
  "hksearow":"\u2925",
  "hkswarow":"\u2926",
  "hoarr":"\u21FF",
  "homtht":"\u223B",
  "hookleftarrow":"\u21A9",
  "hookrightarrow":"\u21AA",
  "Hopf":"\u210D",
  "hopf":"\uD835\uDD59",
  "horbar":"\u2015",
  "HorizontalLine":"\u2500",
  "Hscr":"\u210B",
  "hscr":"\uD835\uDCBD",
  "hslash":"\u210F",
  "Hstrok":"\u0126",
  "hstrok":"\u0127",
  "HumpDownHump":"\u224E",
  "HumpEqual":"\u224F",
  "hybull":"\u2043",
  "hyphen":"\u2010",
  "Iacute":"\u00CD",
  "iacute":"\u00ED",
  "ic":"\u2063",
  "Icirc":"\u00CE",
  "icirc":"\u00EE",
  "Icy":"\u0418",
  "icy":"\u0438",
  "Idot":"\u0130",
  "IEcy":"\u0415",
  "iecy":"\u0435",
  "iexcl":"\u00A1",
  "iff":"\u21D4",
  "Ifr":"\u2111",
  "ifr":"\uD835\uDD26",
  "Igrave":"\u00CC",
  "igrave":"\u00EC",
  "ii":"\u2148",
  "iiiint":"\u2A0C",
  "iiint":"\u222D",
  "iinfin":"\u29DC",
  "iiota":"\u2129",
  "IJlig":"\u0132",
  "ijlig":"\u0133",
  "Im":"\u2111",
  "Imacr":"\u012A",
  "imacr":"\u012B",
  "image":"\u2111",
  "ImaginaryI":"\u2148",
  "imagline":"\u2110",
  "imagpart":"\u2111",
  "imath":"\u0131",
  "imof":"\u22B7",
  "imped":"\u01B5",
  "Implies":"\u21D2",
  "in":"\u2208",
  "incare":"\u2105",
  "infin":"\u221E",
  "infintie":"\u29DD",
  "inodot":"\u0131",
  "Int":"\u222C",
  "int":"\u222B",
  "intcal":"\u22BA",
  "integers":"\u2124",
  "Integral":"\u222B",
  "intercal":"\u22BA",
  "Intersection":"\u22C2",
  "intlarhk":"\u2A17",
  "intprod":"\u2A3C",
  "InvisibleComma":"\u2063",
  "InvisibleTimes":"\u2062",
  "IOcy":"\u0401",
  "iocy":"\u0451",
  "Iogon":"\u012E",
  "iogon":"\u012F",
  "Iopf":"\uD835\uDD40",
  "iopf":"\uD835\uDD5A",
  "Iota":"\u0399",
  "iota":"\u03B9",
  "iprod":"\u2A3C",
  "iquest":"\u00BF",
  "Iscr":"\u2110",
  "iscr":"\uD835\uDCBE",
  "isin":"\u2208",
  "isindot":"\u22F5",
  "isinE":"\u22F9",
  "isins":"\u22F4",
  "isinsv":"\u22F3",
  "isinv":"\u2208",
  "it":"\u2062",
  "Itilde":"\u0128",
  "itilde":"\u0129",
  "Iukcy":"\u0406",
  "iukcy":"\u0456",
  "Iuml":"\u00CF",
  "iuml":"\u00EF",
  "Jcirc":"\u0134",
  "jcirc":"\u0135",
  "Jcy":"\u0419",
  "jcy":"\u0439",
  "Jfr":"\uD835\uDD0D",
  "jfr":"\uD835\uDD27",
  "jmath":"\u0237",
  "Jopf":"\uD835\uDD41",
  "jopf":"\uD835\uDD5B",
  "Jscr":"\uD835\uDCA5",
  "jscr":"\uD835\uDCBF",
  "Jsercy":"\u0408",
  "jsercy":"\u0458",
  "Jukcy":"\u0404",
  "jukcy":"\u0454",
  "Kappa":"\u039A",
  "kappa":"\u03BA",
  "kappav":"\u03F0",
  "Kcedil":"\u0136",
  "kcedil":"\u0137",
  "Kcy":"\u041A",
  "kcy":"\u043A",
  "Kfr":"\uD835\uDD0E",
  "kfr":"\uD835\uDD28",
  "kgreen":"\u0138",
  "KHcy":"\u0425",
  "khcy":"\u0445",
  "KJcy":"\u040C",
  "kjcy":"\u045C",
  "Kopf":"\uD835\uDD42",
  "kopf":"\uD835\uDD5C",
  "Kscr":"\uD835\uDCA6",
  "kscr":"\uD835\uDCC0",
  "lAarr":"\u21DA",
  "Lacute":"\u0139",
  "lacute":"\u013A",
  "laemptyv":"\u29B4",
  "lagran":"\u2112",
  "Lambda":"\u039B",
  "lambda":"\u03BB",
  "Lang":"\u27EA",
  "lang":"\u27E8",
  "langd":"\u2991",
  "langle":"\u27E8",
  "lap":"\u2A85",
  "Laplacetrf":"\u2112",
  "laquo":"\u00AB",
  "Larr":"\u219E",
  "lArr":"\u21D0",
  "larr":"\u2190",
  "larrb":"\u21E4",
  "larrbfs":"\u291F",
  "larrfs":"\u291D",
  "larrhk":"\u21A9",
  "larrlp":"\u21AB",
  "larrpl":"\u2939",
  "larrsim":"\u2973",
  "larrtl":"\u21A2",
  "lat":"\u2AAB",
  "lAtail":"\u291B",
  "latail":"\u2919",
  "late":"\u2AAD",
  "lates":"\u2AAD\uFE00",
  "lBarr":"\u290E",
  "lbarr":"\u290C",
  "lbbrk":"\u2772",
  "lbrace":"\u007B",
  "lbrack":"\u005B",
  "lbrke":"\u298B",
  "lbrksld":"\u298F",
  "lbrkslu":"\u298D",
  "Lcaron":"\u013D",
  "lcaron":"\u013E",
  "Lcedil":"\u013B",
  "lcedil":"\u013C",
  "lceil":"\u2308",
  "lcub":"\u007B",
  "Lcy":"\u041B",
  "lcy":"\u043B",
  "ldca":"\u2936",
  "ldquo":"\u201C",
  "ldquor":"\u201E",
  "ldrdhar":"\u2967",
  "ldrushar":"\u294B",
  "ldsh":"\u21B2",
  "lE":"\u2266",
  "le":"\u2264",
  "LeftAngleBracket":"\u27E8",
  "LeftArrow":"\u2190",
  "Leftarrow":"\u21D0",
  "leftarrow":"\u2190",
  "LeftArrowBar":"\u21E4",
  "LeftArrowRightArrow":"\u21C6",
  "leftarrowtail":"\u21A2",
  "LeftCeiling":"\u2308",
  "LeftDoubleBracket":"\u27E6",
  "LeftDownTeeVector":"\u2961",
  "LeftDownVector":"\u21C3",
  "LeftDownVectorBar":"\u2959",
  "LeftFloor":"\u230A",
  "leftharpoondown":"\u21BD",
  "leftharpoonup":"\u21BC",
  "leftleftarrows":"\u21C7",
  "LeftRightArrow":"\u2194",
  "Leftrightarrow":"\u21D4",
  "leftrightarrow":"\u2194",
  "leftrightarrows":"\u21C6",
  "leftrightharpoons":"\u21CB",
  "leftrightsquigarrow":"\u21AD",
  "LeftRightVector":"\u294E",
  "LeftTee":"\u22A3",
  "LeftTeeArrow":"\u21A4",
  "LeftTeeVector":"\u295A",
  "leftthreetimes":"\u22CB",
  "LeftTriangle":"\u22B2",
  "LeftTriangleBar":"\u29CF",
  "LeftTriangleEqual":"\u22B4",
  "LeftUpDownVector":"\u2951",
  "LeftUpTeeVector":"\u2960",
  "LeftUpVector":"\u21BF",
  "LeftUpVectorBar":"\u2958",
  "LeftVector":"\u21BC",
  "LeftVectorBar":"\u2952",
  "lEg":"\u2A8B",
  "leg":"\u22DA",
  "leq":"\u2264",
  "leqq":"\u2266",
  "leqslant":"\u2A7D",
  "les":"\u2A7D",
  "lescc":"\u2AA8",
  "lesdot":"\u2A7F",
  "lesdoto":"\u2A81",
  "lesdotor":"\u2A83",
  "lesg":"\u22DA\uFE00",
  "lesges":"\u2A93",
  "lessapprox":"\u2A85",
  "lessdot":"\u22D6",
  "lesseqgtr":"\u22DA",
  "lesseqqgtr":"\u2A8B",
  "LessEqualGreater":"\u22DA",
  "LessFullEqual":"\u2266",
  "LessGreater":"\u2276",
  "lessgtr":"\u2276",
  "LessLess":"\u2AA1",
  "lesssim":"\u2272",
  "LessSlantEqual":"\u2A7D",
  "LessTilde":"\u2272",
  "lfisht":"\u297C",
  "lfloor":"\u230A",
  "Lfr":"\uD835\uDD0F",
  "lfr":"\uD835\uDD29",
  "lg":"\u2276",
  "lgE":"\u2A91",
  "lHar":"\u2962",
  "lhard":"\u21BD",
  "lharu":"\u21BC",
  "lharul":"\u296A",
  "lhblk":"\u2584",
  "LJcy":"\u0409",
  "ljcy":"\u0459",
  "Ll":"\u22D8",
  "ll":"\u226A",
  "llarr":"\u21C7",
  "llcorner":"\u231E",
  "Lleftarrow":"\u21DA",
  "llhard":"\u296B",
  "lltri":"\u25FA",
  "Lmidot":"\u013F",
  "lmidot":"\u0140",
  "lmoust":"\u23B0",
  "lmoustache":"\u23B0",
  "lnap":"\u2A89",
  "lnapprox":"\u2A89",
  "lnE":"\u2268",
  "lne":"\u2A87",
  "lneq":"\u2A87",
  "lneqq":"\u2268",
  "lnsim":"\u22E6",
  "loang":"\u27EC",
  "loarr":"\u21FD",
  "lobrk":"\u27E6",
  "LongLeftArrow":"\u27F5",
  "Longleftarrow":"\u27F8",
  "longleftarrow":"\u27F5",
  "LongLeftRightArrow":"\u27F7",
  "Longleftrightarrow":"\u27FA",
  "longleftrightarrow":"\u27F7",
  "longmapsto":"\u27FC",
  "LongRightArrow":"\u27F6",
  "Longrightarrow":"\u27F9",
  "longrightarrow":"\u27F6",
  "looparrowleft":"\u21AB",
  "looparrowright":"\u21AC",
  "lopar":"\u2985",
  "Lopf":"\uD835\uDD43",
  "lopf":"\uD835\uDD5D",
  "loplus":"\u2A2D",
  "lotimes":"\u2A34",
  "lowast":"\u2217",
  "lowbar":"\u005F",
  "LowerLeftArrow":"\u2199",
  "LowerRightArrow":"\u2198",
  "loz":"\u25CA",
  "lozenge":"\u25CA",
  "lozf":"\u29EB",
  "lpar":"\u0028",
  "lparlt":"\u2993",
  "lrarr":"\u21C6",
  "lrcorner":"\u231F",
  "lrhar":"\u21CB",
  "lrhard":"\u296D",
  "lrm":"\u200E",
  "lrtri":"\u22BF",
  "lsaquo":"\u2039",
  "Lscr":"\u2112",
  "lscr":"\uD835\uDCC1",
  "Lsh":"\u21B0",
  "lsh":"\u21B0",
  "lsim":"\u2272",
  "lsime":"\u2A8D",
  "lsimg":"\u2A8F",
  "lsqb":"\u005B",
  "lsquo":"\u2018",
  "lsquor":"\u201A",
  "Lstrok":"\u0141",
  "lstrok":"\u0142",
  "LT":"\u003C",
  "Lt":"\u226A",
  "lt":"\u003C",
  "ltcc":"\u2AA6",
  "ltcir":"\u2A79",
  "ltdot":"\u22D6",
  "lthree":"\u22CB",
  "ltimes":"\u22C9",
  "ltlarr":"\u2976",
  "ltquest":"\u2A7B",
  "ltri":"\u25C3",
  "ltrie":"\u22B4",
  "ltrif":"\u25C2",
  "ltrPar":"\u2996",
  "lurdshar":"\u294A",
  "luruhar":"\u2966",
  "lvertneqq":"\u2268\uFE00",
  "lvnE":"\u2268\uFE00",
  "macr":"\u00AF",
  "male":"\u2642",
  "malt":"\u2720",
  "maltese":"\u2720",
  "Map":"\u2905",
  "map":"\u21A6",
  "mapsto":"\u21A6",
  "mapstodown":"\u21A7",
  "mapstoleft":"\u21A4",
  "mapstoup":"\u21A5",
  "marker":"\u25AE",
  "mcomma":"\u2A29",
  "Mcy":"\u041C",
  "mcy":"\u043C",
  "mdash":"\u2014",
  "mDDot":"\u223A",
  "measuredangle":"\u2221",
  "MediumSpace":"\u205F",
  "Mellintrf":"\u2133",
  "Mfr":"\uD835\uDD10",
  "mfr":"\uD835\uDD2A",
  "mho":"\u2127",
  "micro":"\u00B5",
  "mid":"\u2223",
  "midast":"\u002A",
  "midcir":"\u2AF0",
  "middot":"\u00B7",
  "minus":"\u2212",
  "minusb":"\u229F",
  "minusd":"\u2238",
  "minusdu":"\u2A2A",
  "MinusPlus":"\u2213",
  "mlcp":"\u2ADB",
  "mldr":"\u2026",
  "mnplus":"\u2213",
  "models":"\u22A7",
  "Mopf":"\uD835\uDD44",
  "mopf":"\uD835\uDD5E",
  "mp":"\u2213",
  "Mscr":"\u2133",
  "mscr":"\uD835\uDCC2",
  "mstpos":"\u223E",
  "Mu":"\u039C",
  "mu":"\u03BC",
  "multimap":"\u22B8",
  "mumap":"\u22B8",
  "nabla":"\u2207",
  "Nacute":"\u0143",
  "nacute":"\u0144",
  "nang":"\u2220\u20D2",
  "nap":"\u2249",
  "napE":"\u2A70\u0338",
  "napid":"\u224B\u0338",
  "napos":"\u0149",
  "napprox":"\u2249",
  "natur":"\u266E",
  "natural":"\u266E",
  "naturals":"\u2115",
  "nbsp":"\u00A0",
  "nbump":"\u224E\u0338",
  "nbumpe":"\u224F\u0338",
  "ncap":"\u2A43",
  "Ncaron":"\u0147",
  "ncaron":"\u0148",
  "Ncedil":"\u0145",
  "ncedil":"\u0146",
  "ncong":"\u2247",
  "ncongdot":"\u2A6D\u0338",
  "ncup":"\u2A42",
  "Ncy":"\u041D",
  "ncy":"\u043D",
  "ndash":"\u2013",
  "ne":"\u2260",
  "nearhk":"\u2924",
  "neArr":"\u21D7",
  "nearr":"\u2197",
  "nearrow":"\u2197",
  "nedot":"\u2250\u0338",
  "NegativeMediumSpace":"\u200B",
  "NegativeThickSpace":"\u200B",
  "NegativeThinSpace":"\u200B",
  "NegativeVeryThinSpace":"\u200B",
  "nequiv":"\u2262",
  "nesear":"\u2928",
  "nesim":"\u2242\u0338",
  "NestedGreaterGreater":"\u226B",
  "NestedLessLess":"\u226A",
  "NewLine":"\u000A",
  "nexist":"\u2204",
  "nexists":"\u2204",
  "Nfr":"\uD835\uDD11",
  "nfr":"\uD835\uDD2B",
  "ngE":"\u2267\u0338",
  "nge":"\u2271",
  "ngeq":"\u2271",
  "ngeqq":"\u2267\u0338",
  "ngeqslant":"\u2A7E\u0338",
  "nges":"\u2A7E\u0338",
  "nGg":"\u22D9\u0338",
  "ngsim":"\u2275",
  "nGt":"\u226B\u20D2",
  "ngt":"\u226F",
  "ngtr":"\u226F",
  "nGtv":"\u226B\u0338",
  "nhArr":"\u21CE",
  "nharr":"\u21AE",
  "nhpar":"\u2AF2",
  "ni":"\u220B",
  "nis":"\u22FC",
  "nisd":"\u22FA",
  "niv":"\u220B",
  "NJcy":"\u040A",
  "njcy":"\u045A",
  "nlArr":"\u21CD",
  "nlarr":"\u219A",
  "nldr":"\u2025",
  "nlE":"\u2266\u0338",
  "nle":"\u2270",
  "nLeftarrow":"\u21CD",
  "nleftarrow":"\u219A",
  "nLeftrightarrow":"\u21CE",
  "nleftrightarrow":"\u21AE",
  "nleq":"\u2270",
  "nleqq":"\u2266\u0338",
  "nleqslant":"\u2A7D\u0338",
  "nles":"\u2A7D\u0338",
  "nless":"\u226E",
  "nLl":"\u22D8\u0338",
  "nlsim":"\u2274",
  "nLt":"\u226A\u20D2",
  "nlt":"\u226E",
  "nltri":"\u22EA",
  "nltrie":"\u22EC",
  "nLtv":"\u226A\u0338",
  "nmid":"\u2224",
  "NoBreak":"\u2060",
  "NonBreakingSpace":"\u00A0",
  "Nopf":"\u2115",
  "nopf":"\uD835\uDD5F",
  "Not":"\u2AEC",
  "not":"\u00AC",
  "NotCongruent":"\u2262",
  "NotCupCap":"\u226D",
  "NotDoubleVerticalBar":"\u2226",
  "NotElement":"\u2209",
  "NotEqual":"\u2260",
  "NotEqualTilde":"\u2242\u0338",
  "NotExists":"\u2204",
  "NotGreater":"\u226F",
  "NotGreaterEqual":"\u2271",
  "NotGreaterFullEqual":"\u2267\u0338",
  "NotGreaterGreater":"\u226B\u0338",
  "NotGreaterLess":"\u2279",
  "NotGreaterSlantEqual":"\u2A7E\u0338",
  "NotGreaterTilde":"\u2275",
  "NotHumpDownHump":"\u224E\u0338",
  "NotHumpEqual":"\u224F\u0338",
  "notin":"\u2209",
  "notindot":"\u22F5\u0338",
  "notinE":"\u22F9\u0338",
  "notinva":"\u2209",
  "notinvb":"\u22F7",
  "notinvc":"\u22F6",
  "NotLeftTriangle":"\u22EA",
  "NotLeftTriangleBar":"\u29CF\u0338",
  "NotLeftTriangleEqual":"\u22EC",
  "NotLess":"\u226E",
  "NotLessEqual":"\u2270",
  "NotLessGreater":"\u2278",
  "NotLessLess":"\u226A\u0338",
  "NotLessSlantEqual":"\u2A7D\u0338",
  "NotLessTilde":"\u2274",
  "NotNestedGreaterGreater":"\u2AA2\u0338",
  "NotNestedLessLess":"\u2AA1\u0338",
  "notni":"\u220C",
  "notniva":"\u220C",
  "notnivb":"\u22FE",
  "notnivc":"\u22FD",
  "NotPrecedes":"\u2280",
  "NotPrecedesEqual":"\u2AAF\u0338",
  "NotPrecedesSlantEqual":"\u22E0",
  "NotReverseElement":"\u220C",
  "NotRightTriangle":"\u22EB",
  "NotRightTriangleBar":"\u29D0\u0338",
  "NotRightTriangleEqual":"\u22ED",
  "NotSquareSubset":"\u228F\u0338",
  "NotSquareSubsetEqual":"\u22E2",
  "NotSquareSuperset":"\u2290\u0338",
  "NotSquareSupersetEqual":"\u22E3",
  "NotSubset":"\u2282\u20D2",
  "NotSubsetEqual":"\u2288",
  "NotSucceeds":"\u2281",
  "NotSucceedsEqual":"\u2AB0\u0338",
  "NotSucceedsSlantEqual":"\u22E1",
  "NotSucceedsTilde":"\u227F\u0338",
  "NotSuperset":"\u2283\u20D2",
  "NotSupersetEqual":"\u2289",
  "NotTilde":"\u2241",
  "NotTildeEqual":"\u2244",
  "NotTildeFullEqual":"\u2247",
  "NotTildeTilde":"\u2249",
  "NotVerticalBar":"\u2224",
  "npar":"\u2226",
  "nparallel":"\u2226",
  "nparsl":"\u2AFD\u20E5",
  "npart":"\u2202\u0338",
  "npolint":"\u2A14",
  "npr":"\u2280",
  "nprcue":"\u22E0",
  "npre":"\u2AAF\u0338",
  "nprec":"\u2280",
  "npreceq":"\u2AAF\u0338",
  "nrArr":"\u21CF",
  "nrarr":"\u219B",
  "nrarrc":"\u2933\u0338",
  "nrarrw":"\u219D\u0338",
  "nRightarrow":"\u21CF",
  "nrightarrow":"\u219B",
  "nrtri":"\u22EB",
  "nrtrie":"\u22ED",
  "nsc":"\u2281",
  "nsccue":"\u22E1",
  "nsce":"\u2AB0\u0338",
  "Nscr":"\uD835\uDCA9",
  "nscr":"\uD835\uDCC3",
  "nshortmid":"\u2224",
  "nshortparallel":"\u2226",
  "nsim":"\u2241",
  "nsime":"\u2244",
  "nsimeq":"\u2244",
  "nsmid":"\u2224",
  "nspar":"\u2226",
  "nsqsube":"\u22E2",
  "nsqsupe":"\u22E3",
  "nsub":"\u2284",
  "nsubE":"\u2AC5\u0338",
  "nsube":"\u2288",
  "nsubset":"\u2282\u20D2",
  "nsubseteq":"\u2288",
  "nsubseteqq":"\u2AC5\u0338",
  "nsucc":"\u2281",
  "nsucceq":"\u2AB0\u0338",
  "nsup":"\u2285",
  "nsupE":"\u2AC6\u0338",
  "nsupe":"\u2289",
  "nsupset":"\u2283\u20D2",
  "nsupseteq":"\u2289",
  "nsupseteqq":"\u2AC6\u0338",
  "ntgl":"\u2279",
  "Ntilde":"\u00D1",
  "ntilde":"\u00F1",
  "ntlg":"\u2278",
  "ntriangleleft":"\u22EA",
  "ntrianglelefteq":"\u22EC",
  "ntriangleright":"\u22EB",
  "ntrianglerighteq":"\u22ED",
  "Nu":"\u039D",
  "nu":"\u03BD",
  "num":"\u0023",
  "numero":"\u2116",
  "numsp":"\u2007",
  "nvap":"\u224D\u20D2",
  "nVDash":"\u22AF",
  "nVdash":"\u22AE",
  "nvDash":"\u22AD",
  "nvdash":"\u22AC",
  "nvge":"\u2265\u20D2",
  "nvgt":"\u003E\u20D2",
  "nvHarr":"\u2904",
  "nvinfin":"\u29DE",
  "nvlArr":"\u2902",
  "nvle":"\u2264\u20D2",
  "nvlt":"\u003C\u20D2",
  "nvltrie":"\u22B4\u20D2",
  "nvrArr":"\u2903",
  "nvrtrie":"\u22B5\u20D2",
  "nvsim":"\u223C\u20D2",
  "nwarhk":"\u2923",
  "nwArr":"\u21D6",
  "nwarr":"\u2196",
  "nwarrow":"\u2196",
  "nwnear":"\u2927",
  "Oacute":"\u00D3",
  "oacute":"\u00F3",
  "oast":"\u229B",
  "ocir":"\u229A",
  "Ocirc":"\u00D4",
  "ocirc":"\u00F4",
  "Ocy":"\u041E",
  "ocy":"\u043E",
  "odash":"\u229D",
  "Odblac":"\u0150",
  "odblac":"\u0151",
  "odiv":"\u2A38",
  "odot":"\u2299",
  "odsold":"\u29BC",
  "OElig":"\u0152",
  "oelig":"\u0153",
  "ofcir":"\u29BF",
  "Ofr":"\uD835\uDD12",
  "ofr":"\uD835\uDD2C",
  "ogon":"\u02DB",
  "Ograve":"\u00D2",
  "ograve":"\u00F2",
  "ogt":"\u29C1",
  "ohbar":"\u29B5",
  "ohm":"\u03A9",
  "oint":"\u222E",
  "olarr":"\u21BA",
  "olcir":"\u29BE",
  "olcross":"\u29BB",
  "oline":"\u203E",
  "olt":"\u29C0",
  "Omacr":"\u014C",
  "omacr":"\u014D",
  "Omega":"\u03A9",
  "omega":"\u03C9",
  "Omicron":"\u039F",
  "omicron":"\u03BF",
  "omid":"\u29B6",
  "ominus":"\u2296",
  "Oopf":"\uD835\uDD46",
  "oopf":"\uD835\uDD60",
  "opar":"\u29B7",
  "OpenCurlyDoubleQuote":"\u201C",
  "OpenCurlyQuote":"\u2018",
  "operp":"\u29B9",
  "oplus":"\u2295",
  "Or":"\u2A54",
  "or":"\u2228",
  "orarr":"\u21BB",
  "ord":"\u2A5D",
  "order":"\u2134",
  "orderof":"\u2134",
  "ordf":"\u00AA",
  "ordm":"\u00BA",
  "origof":"\u22B6",
  "oror":"\u2A56",
  "orslope":"\u2A57",
  "orv":"\u2A5B",
  "oS":"\u24C8",
  "Oscr":"\uD835\uDCAA",
  "oscr":"\u2134",
  "Oslash":"\u00D8",
  "oslash":"\u00F8",
  "osol":"\u2298",
  "Otilde":"\u00D5",
  "otilde":"\u00F5",
  "Otimes":"\u2A37",
  "otimes":"\u2297",
  "otimesas":"\u2A36",
  "Ouml":"\u00D6",
  "ouml":"\u00F6",
  "ovbar":"\u233D",
  "OverBar":"\u203E",
  "OverBrace":"\u23DE",
  "OverBracket":"\u23B4",
  "OverParenthesis":"\u23DC",
  "par":"\u2225",
  "para":"\u00B6",
  "parallel":"\u2225",
  "parsim":"\u2AF3",
  "parsl":"\u2AFD",
  "part":"\u2202",
  "PartialD":"\u2202",
  "Pcy":"\u041F",
  "pcy":"\u043F",
  "percnt":"\u0025",
  "period":"\u002E",
  "permil":"\u2030",
  "perp":"\u22A5",
  "pertenk":"\u2031",
  "Pfr":"\uD835\uDD13",
  "pfr":"\uD835\uDD2D",
  "Phi":"\u03A6",
  "phi":"\u03C6",
  "phiv":"\u03D5",
  "phmmat":"\u2133",
  "phone":"\u260E",
  "Pi":"\u03A0",
  "pi":"\u03C0",
  "pitchfork":"\u22D4",
  "piv":"\u03D6",
  "planck":"\u210F",
  "planckh":"\u210E",
  "plankv":"\u210F",
  "plus":"\u002B",
  "plusacir":"\u2A23",
  "plusb":"\u229E",
  "pluscir":"\u2A22",
  "plusdo":"\u2214",
  "plusdu":"\u2A25",
  "pluse":"\u2A72",
  "PlusMinus":"\u00B1",
  "plusmn":"\u00B1",
  "plussim":"\u2A26",
  "plustwo":"\u2A27",
  "pm":"\u00B1",
  "Poincareplane":"\u210C",
  "pointint":"\u2A15",
  "Popf":"\u2119",
  "popf":"\uD835\uDD61",
  "pound":"\u00A3",
  "Pr":"\u2ABB",
  "pr":"\u227A",
  "prap":"\u2AB7",
  "prcue":"\u227C",
  "prE":"\u2AB3",
  "pre":"\u2AAF",
  "prec":"\u227A",
  "precapprox":"\u2AB7",
  "preccurlyeq":"\u227C",
  "Precedes":"\u227A",
  "PrecedesEqual":"\u2AAF",
  "PrecedesSlantEqual":"\u227C",
  "PrecedesTilde":"\u227E",
  "preceq":"\u2AAF",
  "precnapprox":"\u2AB9",
  "precneqq":"\u2AB5",
  "precnsim":"\u22E8",
  "precsim":"\u227E",
  "Prime":"\u2033",
  "prime":"\u2032",
  "primes":"\u2119",
  "prnap":"\u2AB9",
  "prnE":"\u2AB5",
  "prnsim":"\u22E8",
  "prod":"\u220F",
  "Product":"\u220F",
  "profalar":"\u232E",
  "profline":"\u2312",
  "profsurf":"\u2313",
  "prop":"\u221D",
  "Proportion":"\u2237",
  "Proportional":"\u221D",
  "propto":"\u221D",
  "prsim":"\u227E",
  "prurel":"\u22B0",
  "Pscr":"\uD835\uDCAB",
  "pscr":"\uD835\uDCC5",
  "Psi":"\u03A8",
  "psi":"\u03C8",
  "puncsp":"\u2008",
  "Qfr":"\uD835\uDD14",
  "qfr":"\uD835\uDD2E",
  "qint":"\u2A0C",
  "Qopf":"\u211A",
  "qopf":"\uD835\uDD62",
  "qprime":"\u2057",
  "Qscr":"\uD835\uDCAC",
  "qscr":"\uD835\uDCC6",
  "quaternions":"\u210D",
  "quatint":"\u2A16",
  "quest":"\u003F",
  "questeq":"\u225F",
  "QUOT":"\u0022",
  "quot":"\u0022",
  "rAarr":"\u21DB",
  "race":"\u223D\u0331",
  "Racute":"\u0154",
  "racute":"\u0155",
  "radic":"\u221A",
  "raemptyv":"\u29B3",
  "Rang":"\u27EB",
  "rang":"\u27E9",
  "rangd":"\u2992",
  "range":"\u29A5",
  "rangle":"\u27E9",
  "raquo":"\u00BB",
  "Rarr":"\u21A0",
  "rArr":"\u21D2",
  "rarr":"\u2192",
  "rarrap":"\u2975",
  "rarrb":"\u21E5",
  "rarrbfs":"\u2920",
  "rarrc":"\u2933",
  "rarrfs":"\u291E",
  "rarrhk":"\u21AA",
  "rarrlp":"\u21AC",
  "rarrpl":"\u2945",
  "rarrsim":"\u2974",
  "Rarrtl":"\u2916",
  "rarrtl":"\u21A3",
  "rarrw":"\u219D",
  "rAtail":"\u291C",
  "ratail":"\u291A",
  "ratio":"\u2236",
  "rationals":"\u211A",
  "RBarr":"\u2910",
  "rBarr":"\u290F",
  "rbarr":"\u290D",
  "rbbrk":"\u2773",
  "rbrace":"\u007D",
  "rbrack":"\u005D",
  "rbrke":"\u298C",
  "rbrksld":"\u298E",
  "rbrkslu":"\u2990",
  "Rcaron":"\u0158",
  "rcaron":"\u0159",
  "Rcedil":"\u0156",
  "rcedil":"\u0157",
  "rceil":"\u2309",
  "rcub":"\u007D",
  "Rcy":"\u0420",
  "rcy":"\u0440",
  "rdca":"\u2937",
  "rdldhar":"\u2969",
  "rdquo":"\u201D",
  "rdquor":"\u201D",
  "rdsh":"\u21B3",
  "Re":"\u211C",
  "real":"\u211C",
  "realine":"\u211B",
  "realpart":"\u211C",
  "reals":"\u211D",
  "rect":"\u25AD",
  "REG":"\u00AE",
  "reg":"\u00AE",
  "ReverseElement":"\u220B",
  "ReverseEquilibrium":"\u21CB",
  "ReverseUpEquilibrium":"\u296F",
  "rfisht":"\u297D",
  "rfloor":"\u230B",
  "Rfr":"\u211C",
  "rfr":"\uD835\uDD2F",
  "rHar":"\u2964",
  "rhard":"\u21C1",
  "rharu":"\u21C0",
  "rharul":"\u296C",
  "Rho":"\u03A1",
  "rho":"\u03C1",
  "rhov":"\u03F1",
  "RightAngleBracket":"\u27E9",
  "RightArrow":"\u2192",
  "Rightarrow":"\u21D2",
  "rightarrow":"\u2192",
  "RightArrowBar":"\u21E5",
  "RightArrowLeftArrow":"\u21C4",
  "rightarrowtail":"\u21A3",
  "RightCeiling":"\u2309",
  "RightDoubleBracket":"\u27E7",
  "RightDownTeeVector":"\u295D",
  "RightDownVector":"\u21C2",
  "RightDownVectorBar":"\u2955",
  "RightFloor":"\u230B",
  "rightharpoondown":"\u21C1",
  "rightharpoonup":"\u21C0",
  "rightleftarrows":"\u21C4",
  "rightleftharpoons":"\u21CC",
  "rightrightarrows":"\u21C9",
  "rightsquigarrow":"\u219D",
  "RightTee":"\u22A2",
  "RightTeeArrow":"\u21A6",
  "RightTeeVector":"\u295B",
  "rightthreetimes":"\u22CC",
  "RightTriangle":"\u22B3",
  "RightTriangleBar":"\u29D0",
  "RightTriangleEqual":"\u22B5",
  "RightUpDownVector":"\u294F",
  "RightUpTeeVector":"\u295C",
  "RightUpVector":"\u21BE",
  "RightUpVectorBar":"\u2954",
  "RightVector":"\u21C0",
  "RightVectorBar":"\u2953",
  "ring":"\u02DA",
  "risingdotseq":"\u2253",
  "rlarr":"\u21C4",
  "rlhar":"\u21CC",
  "rlm":"\u200F",
  "rmoust":"\u23B1",
  "rmoustache":"\u23B1",
  "rnmid":"\u2AEE",
  "roang":"\u27ED",
  "roarr":"\u21FE",
  "robrk":"\u27E7",
  "ropar":"\u2986",
  "Ropf":"\u211D",
  "ropf":"\uD835\uDD63",
  "roplus":"\u2A2E",
  "rotimes":"\u2A35",
  "RoundImplies":"\u2970",
  "rpar":"\u0029",
  "rpargt":"\u2994",
  "rppolint":"\u2A12",
  "rrarr":"\u21C9",
  "Rrightarrow":"\u21DB",
  "rsaquo":"\u203A",
  "Rscr":"\u211B",
  "rscr":"\uD835\uDCC7",
  "Rsh":"\u21B1",
  "rsh":"\u21B1",
  "rsqb":"\u005D",
  "rsquo":"\u2019",
  "rsquor":"\u2019",
  "rthree":"\u22CC",
  "rtimes":"\u22CA",
  "rtri":"\u25B9",
  "rtrie":"\u22B5",
  "rtrif":"\u25B8",
  "rtriltri":"\u29CE",
  "RuleDelayed":"\u29F4",
  "ruluhar":"\u2968",
  "rx":"\u211E",
  "Sacute":"\u015A",
  "sacute":"\u015B",
  "sbquo":"\u201A",
  "Sc":"\u2ABC",
  "sc":"\u227B",
  "scap":"\u2AB8",
  "Scaron":"\u0160",
  "scaron":"\u0161",
  "sccue":"\u227D",
  "scE":"\u2AB4",
  "sce":"\u2AB0",
  "Scedil":"\u015E",
  "scedil":"\u015F",
  "Scirc":"\u015C",
  "scirc":"\u015D",
  "scnap":"\u2ABA",
  "scnE":"\u2AB6",
  "scnsim":"\u22E9",
  "scpolint":"\u2A13",
  "scsim":"\u227F",
  "Scy":"\u0421",
  "scy":"\u0441",
  "sdot":"\u22C5",
  "sdotb":"\u22A1",
  "sdote":"\u2A66",
  "searhk":"\u2925",
  "seArr":"\u21D8",
  "searr":"\u2198",
  "searrow":"\u2198",
  "sect":"\u00A7",
  "semi":"\u003B",
  "seswar":"\u2929",
  "setminus":"\u2216",
  "setmn":"\u2216",
  "sext":"\u2736",
  "Sfr":"\uD835\uDD16",
  "sfr":"\uD835\uDD30",
  "sfrown":"\u2322",
  "sharp":"\u266F",
  "SHCHcy":"\u0429",
  "shchcy":"\u0449",
  "SHcy":"\u0428",
  "shcy":"\u0448",
  "ShortDownArrow":"\u2193",
  "ShortLeftArrow":"\u2190",
  "shortmid":"\u2223",
  "shortparallel":"\u2225",
  "ShortRightArrow":"\u2192",
  "ShortUpArrow":"\u2191",
  "shy":"\u00AD",
  "Sigma":"\u03A3",
  "sigma":"\u03C3",
  "sigmaf":"\u03C2",
  "sigmav":"\u03C2",
  "sim":"\u223C",
  "simdot":"\u2A6A",
  "sime":"\u2243",
  "simeq":"\u2243",
  "simg":"\u2A9E",
  "simgE":"\u2AA0",
  "siml":"\u2A9D",
  "simlE":"\u2A9F",
  "simne":"\u2246",
  "simplus":"\u2A24",
  "simrarr":"\u2972",
  "slarr":"\u2190",
  "SmallCircle":"\u2218",
  "smallsetminus":"\u2216",
  "smashp":"\u2A33",
  "smeparsl":"\u29E4",
  "smid":"\u2223",
  "smile":"\u2323",
  "smt":"\u2AAA",
  "smte":"\u2AAC",
  "smtes":"\u2AAC\uFE00",
  "SOFTcy":"\u042C",
  "softcy":"\u044C",
  "sol":"\u002F",
  "solb":"\u29C4",
  "solbar":"\u233F",
  "Sopf":"\uD835\uDD4A",
  "sopf":"\uD835\uDD64",
  "spades":"\u2660",
  "spadesuit":"\u2660",
  "spar":"\u2225",
  "sqcap":"\u2293",
  "sqcaps":"\u2293\uFE00",
  "sqcup":"\u2294",
  "sqcups":"\u2294\uFE00",
  "Sqrt":"\u221A",
  "sqsub":"\u228F",
  "sqsube":"\u2291",
  "sqsubset":"\u228F",
  "sqsubseteq":"\u2291",
  "sqsup":"\u2290",
  "sqsupe":"\u2292",
  "sqsupset":"\u2290",
  "sqsupseteq":"\u2292",
  "squ":"\u25A1",
  "Square":"\u25A1",
  "square":"\u25A1",
  "SquareIntersection":"\u2293",
  "SquareSubset":"\u228F",
  "SquareSubsetEqual":"\u2291",
  "SquareSuperset":"\u2290",
  "SquareSupersetEqual":"\u2292",
  "SquareUnion":"\u2294",
  "squarf":"\u25AA",
  "squf":"\u25AA",
  "srarr":"\u2192",
  "Sscr":"\uD835\uDCAE",
  "sscr":"\uD835\uDCC8",
  "ssetmn":"\u2216",
  "ssmile":"\u2323",
  "sstarf":"\u22C6",
  "Star":"\u22C6",
  "star":"\u2606",
  "starf":"\u2605",
  "straightepsilon":"\u03F5",
  "straightphi":"\u03D5",
  "strns":"\u00AF",
  "Sub":"\u22D0",
  "sub":"\u2282",
  "subdot":"\u2ABD",
  "subE":"\u2AC5",
  "sube":"\u2286",
  "subedot":"\u2AC3",
  "submult":"\u2AC1",
  "subnE":"\u2ACB",
  "subne":"\u228A",
  "subplus":"\u2ABF",
  "subrarr":"\u2979",
  "Subset":"\u22D0",
  "subset":"\u2282",
  "subseteq":"\u2286",
  "subseteqq":"\u2AC5",
  "SubsetEqual":"\u2286",
  "subsetneq":"\u228A",
  "subsetneqq":"\u2ACB",
  "subsim":"\u2AC7",
  "subsub":"\u2AD5",
  "subsup":"\u2AD3",
  "succ":"\u227B",
  "succapprox":"\u2AB8",
  "succcurlyeq":"\u227D",
  "Succeeds":"\u227B",
  "SucceedsEqual":"\u2AB0",
  "SucceedsSlantEqual":"\u227D",
  "SucceedsTilde":"\u227F",
  "succeq":"\u2AB0",
  "succnapprox":"\u2ABA",
  "succneqq":"\u2AB6",
  "succnsim":"\u22E9",
  "succsim":"\u227F",
  "SuchThat":"\u220B",
  "Sum":"\u2211",
  "sum":"\u2211",
  "sung":"\u266A",
  "Sup":"\u22D1",
  "sup":"\u2283",
  "sup1":"\u00B9",
  "sup2":"\u00B2",
  "sup3":"\u00B3",
  "supdot":"\u2ABE",
  "supdsub":"\u2AD8",
  "supE":"\u2AC6",
  "supe":"\u2287",
  "supedot":"\u2AC4",
  "Superset":"\u2283",
  "SupersetEqual":"\u2287",
  "suphsol":"\u27C9",
  "suphsub":"\u2AD7",
  "suplarr":"\u297B",
  "supmult":"\u2AC2",
  "supnE":"\u2ACC",
  "supne":"\u228B",
  "supplus":"\u2AC0",
  "Supset":"\u22D1",
  "supset":"\u2283",
  "supseteq":"\u2287",
  "supseteqq":"\u2AC6",
  "supsetneq":"\u228B",
  "supsetneqq":"\u2ACC",
  "supsim":"\u2AC8",
  "supsub":"\u2AD4",
  "supsup":"\u2AD6",
  "swarhk":"\u2926",
  "swArr":"\u21D9",
  "swarr":"\u2199",
  "swarrow":"\u2199",
  "swnwar":"\u292A",
  "szlig":"\u00DF",
  "Tab":"\u0009",
  "target":"\u2316",
  "Tau":"\u03A4",
  "tau":"\u03C4",
  "tbrk":"\u23B4",
  "Tcaron":"\u0164",
  "tcaron":"\u0165",
  "Tcedil":"\u0162",
  "tcedil":"\u0163",
  "Tcy":"\u0422",
  "tcy":"\u0442",
  "tdot":"\u20DB",
  "telrec":"\u2315",
  "Tfr":"\uD835\uDD17",
  "tfr":"\uD835\uDD31",
  "there4":"\u2234",
  "Therefore":"\u2234",
  "therefore":"\u2234",
  "Theta":"\u0398",
  "theta":"\u03B8",
  "thetasym":"\u03D1",
  "thetav":"\u03D1",
  "thickapprox":"\u2248",
  "thicksim":"\u223C",
  "ThickSpace":"\u205F\u200A",
  "thinsp":"\u2009",
  "ThinSpace":"\u2009",
  "thkap":"\u2248",
  "thksim":"\u223C",
  "THORN":"\u00DE",
  "thorn":"\u00FE",
  "Tilde":"\u223C",
  "tilde":"\u02DC",
  "TildeEqual":"\u2243",
  "TildeFullEqual":"\u2245",
  "TildeTilde":"\u2248",
  "times":"\u00D7",
  "timesb":"\u22A0",
  "timesbar":"\u2A31",
  "timesd":"\u2A30",
  "tint":"\u222D",
  "toea":"\u2928",
  "top":"\u22A4",
  "topbot":"\u2336",
  "topcir":"\u2AF1",
  "Topf":"\uD835\uDD4B",
  "topf":"\uD835\uDD65",
  "topfork":"\u2ADA",
  "tosa":"\u2929",
  "tprime":"\u2034",
  "TRADE":"\u2122",
  "trade":"\u2122",
  "triangle":"\u25B5",
  "triangledown":"\u25BF",
  "triangleleft":"\u25C3",
  "trianglelefteq":"\u22B4",
  "triangleq":"\u225C",
  "triangleright":"\u25B9",
  "trianglerighteq":"\u22B5",
  "tridot":"\u25EC",
  "trie":"\u225C",
  "triminus":"\u2A3A",
  "TripleDot":"\u20DB",
  "triplus":"\u2A39",
  "trisb":"\u29CD",
  "tritime":"\u2A3B",
  "trpezium":"\u23E2",
  "Tscr":"\uD835\uDCAF",
  "tscr":"\uD835\uDCC9",
  "TScy":"\u0426",
  "tscy":"\u0446",
  "TSHcy":"\u040B",
  "tshcy":"\u045B",
  "Tstrok":"\u0166",
  "tstrok":"\u0167",
  "twixt":"\u226C",
  "twoheadleftarrow":"\u219E",
  "twoheadrightarrow":"\u21A0",
  "Uacute":"\u00DA",
  "uacute":"\u00FA",
  "Uarr":"\u219F",
  "uArr":"\u21D1",
  "uarr":"\u2191",
  "Uarrocir":"\u2949",
  "Ubrcy":"\u040E",
  "ubrcy":"\u045E",
  "Ubreve":"\u016C",
  "ubreve":"\u016D",
  "Ucirc":"\u00DB",
  "ucirc":"\u00FB",
  "Ucy":"\u0423",
  "ucy":"\u0443",
  "udarr":"\u21C5",
  "Udblac":"\u0170",
  "udblac":"\u0171",
  "udhar":"\u296E",
  "ufisht":"\u297E",
  "Ufr":"\uD835\uDD18",
  "ufr":"\uD835\uDD32",
  "Ugrave":"\u00D9",
  "ugrave":"\u00F9",
  "uHar":"\u2963",
  "uharl":"\u21BF",
  "uharr":"\u21BE",
  "uhblk":"\u2580",
  "ulcorn":"\u231C",
  "ulcorner":"\u231C",
  "ulcrop":"\u230F",
  "ultri":"\u25F8",
  "Umacr":"\u016A",
  "umacr":"\u016B",
  "uml":"\u00A8",
  "UnderBar":"\u005F",
  "UnderBrace":"\u23DF",
  "UnderBracket":"\u23B5",
  "UnderParenthesis":"\u23DD",
  "Union":"\u22C3",
  "UnionPlus":"\u228E",
  "Uogon":"\u0172",
  "uogon":"\u0173",
  "Uopf":"\uD835\uDD4C",
  "uopf":"\uD835\uDD66",
  "UpArrow":"\u2191",
  "Uparrow":"\u21D1",
  "uparrow":"\u2191",
  "UpArrowBar":"\u2912",
  "UpArrowDownArrow":"\u21C5",
  "UpDownArrow":"\u2195",
  "Updownarrow":"\u21D5",
  "updownarrow":"\u2195",
  "UpEquilibrium":"\u296E",
  "upharpoonleft":"\u21BF",
  "upharpoonright":"\u21BE",
  "uplus":"\u228E",
  "UpperLeftArrow":"\u2196",
  "UpperRightArrow":"\u2197",
  "Upsi":"\u03D2",
  "upsi":"\u03C5",
  "upsih":"\u03D2",
  "Upsilon":"\u03A5",
  "upsilon":"\u03C5",
  "UpTee":"\u22A5",
  "UpTeeArrow":"\u21A5",
  "upuparrows":"\u21C8",
  "urcorn":"\u231D",
  "urcorner":"\u231D",
  "urcrop":"\u230E",
  "Uring":"\u016E",
  "uring":"\u016F",
  "urtri":"\u25F9",
  "Uscr":"\uD835\uDCB0",
  "uscr":"\uD835\uDCCA",
  "utdot":"\u22F0",
  "Utilde":"\u0168",
  "utilde":"\u0169",
  "utri":"\u25B5",
  "utrif":"\u25B4",
  "uuarr":"\u21C8",
  "Uuml":"\u00DC",
  "uuml":"\u00FC",
  "uwangle":"\u29A7",
  "vangrt":"\u299C",
  "varepsilon":"\u03F5",
  "varkappa":"\u03F0",
  "varnothing":"\u2205",
  "varphi":"\u03D5",
  "varpi":"\u03D6",
  "varpropto":"\u221D",
  "vArr":"\u21D5",
  "varr":"\u2195",
  "varrho":"\u03F1",
  "varsigma":"\u03C2",
  "varsubsetneq":"\u228A\uFE00",
  "varsubsetneqq":"\u2ACB\uFE00",
  "varsupsetneq":"\u228B\uFE00",
  "varsupsetneqq":"\u2ACC\uFE00",
  "vartheta":"\u03D1",
  "vartriangleleft":"\u22B2",
  "vartriangleright":"\u22B3",
  "Vbar":"\u2AEB",
  "vBar":"\u2AE8",
  "vBarv":"\u2AE9",
  "Vcy":"\u0412",
  "vcy":"\u0432",
  "VDash":"\u22AB",
  "Vdash":"\u22A9",
  "vDash":"\u22A8",
  "vdash":"\u22A2",
  "Vdashl":"\u2AE6",
  "Vee":"\u22C1",
  "vee":"\u2228",
  "veebar":"\u22BB",
  "veeeq":"\u225A",
  "vellip":"\u22EE",
  "Verbar":"\u2016",
  "verbar":"\u007C",
  "Vert":"\u2016",
  "vert":"\u007C",
  "VerticalBar":"\u2223",
  "VerticalLine":"\u007C",
  "VerticalSeparator":"\u2758",
  "VerticalTilde":"\u2240",
  "VeryThinSpace":"\u200A",
  "Vfr":"\uD835\uDD19",
  "vfr":"\uD835\uDD33",
  "vltri":"\u22B2",
  "vnsub":"\u2282\u20D2",
  "vnsup":"\u2283\u20D2",
  "Vopf":"\uD835\uDD4D",
  "vopf":"\uD835\uDD67",
  "vprop":"\u221D",
  "vrtri":"\u22B3",
  "Vscr":"\uD835\uDCB1",
  "vscr":"\uD835\uDCCB",
  "vsubnE":"\u2ACB\uFE00",
  "vsubne":"\u228A\uFE00",
  "vsupnE":"\u2ACC\uFE00",
  "vsupne":"\u228B\uFE00",
  "Vvdash":"\u22AA",
  "vzigzag":"\u299A",
  "Wcirc":"\u0174",
  "wcirc":"\u0175",
  "wedbar":"\u2A5F",
  "Wedge":"\u22C0",
  "wedge":"\u2227",
  "wedgeq":"\u2259",
  "weierp":"\u2118",
  "Wfr":"\uD835\uDD1A",
  "wfr":"\uD835\uDD34",
  "Wopf":"\uD835\uDD4E",
  "wopf":"\uD835\uDD68",
  "wp":"\u2118",
  "wr":"\u2240",
  "wreath":"\u2240",
  "Wscr":"\uD835\uDCB2",
  "wscr":"\uD835\uDCCC",
  "xcap":"\u22C2",
  "xcirc":"\u25EF",
  "xcup":"\u22C3",
  "xdtri":"\u25BD",
  "Xfr":"\uD835\uDD1B",
  "xfr":"\uD835\uDD35",
  "xhArr":"\u27FA",
  "xharr":"\u27F7",
  "Xi":"\u039E",
  "xi":"\u03BE",
  "xlArr":"\u27F8",
  "xlarr":"\u27F5",
  "xmap":"\u27FC",
  "xnis":"\u22FB",
  "xodot":"\u2A00",
  "Xopf":"\uD835\uDD4F",
  "xopf":"\uD835\uDD69",
  "xoplus":"\u2A01",
  "xotime":"\u2A02",
  "xrArr":"\u27F9",
  "xrarr":"\u27F6",
  "Xscr":"\uD835\uDCB3",
  "xscr":"\uD835\uDCCD",
  "xsqcup":"\u2A06",
  "xuplus":"\u2A04",
  "xutri":"\u25B3",
  "xvee":"\u22C1",
  "xwedge":"\u22C0",
  "Yacute":"\u00DD",
  "yacute":"\u00FD",
  "YAcy":"\u042F",
  "yacy":"\u044F",
  "Ycirc":"\u0176",
  "ycirc":"\u0177",
  "Ycy":"\u042B",
  "ycy":"\u044B",
  "yen":"\u00A5",
  "Yfr":"\uD835\uDD1C",
  "yfr":"\uD835\uDD36",
  "YIcy":"\u0407",
  "yicy":"\u0457",
  "Yopf":"\uD835\uDD50",
  "yopf":"\uD835\uDD6A",
  "Yscr":"\uD835\uDCB4",
  "yscr":"\uD835\uDCCE",
  "YUcy":"\u042E",
  "yucy":"\u044E",
  "Yuml":"\u0178",
  "yuml":"\u00FF",
  "Zacute":"\u0179",
  "zacute":"\u017A",
  "Zcaron":"\u017D",
  "zcaron":"\u017E",
  "Zcy":"\u0417",
  "zcy":"\u0437",
  "Zdot":"\u017B",
  "zdot":"\u017C",
  "zeetrf":"\u2128",
  "ZeroWidthSpace":"\u200B",
  "Zeta":"\u0396",
  "zeta":"\u03B6",
  "Zfr":"\u2128",
  "zfr":"\uD835\uDD37",
  "ZHcy":"\u0416",
  "zhcy":"\u0436",
  "zigrarr":"\u21DD",
  "Zopf":"\u2124",
  "zopf":"\uD835\uDD6B",
  "Zscr":"\uD835\uDCB5",
  "zscr":"\uD835\uDCCF",
  "zwj":"\u200D",
  "zwnj":"\u200C"
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var normalizeLink = __webpack_require__(662);
var unescapeMd    = __webpack_require__(86).unescapeMd;

/**
 * Parse link destination
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

module.exports = function parseLinkDestination(state, pos) {
  var code, level, link,
      start = pos,
      max = state.posMax;

  if (state.src.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = state.src.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return false; }
      if (code === 0x3E /* > */) {
        link = normalizeLink(unescapeMd(state.src.slice(start + 1, pos)));
        if (!state.parser.validateLink(link)) { return false; }
        state.pos = pos + 1;
        state.linkContent = link;
        return true;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return false;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = state.src.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control chars
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 1) { break; }
    }

    if (code === 0x29 /* ) */) {
      level--;
      if (level < 0) { break; }
    }

    pos++;
  }

  if (start === pos) { return false; }

  link = unescapeMd(state.src.slice(start, pos));
  if (!state.parser.validateLink(link)) { return false; }

  state.linkContent = link;
  state.pos = pos;
  return true;
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replaceEntities = __webpack_require__(86).replaceEntities;

module.exports = function normalizeLink(url) {
  var normalized = replaceEntities(url);
  // We shouldn't care about the result of malformed URIs,
  // and should not throw an exception.
  try {
    normalized = decodeURI(normalized);
  } catch (err) {}
  return encodeURI(normalized);
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var unescapeMd = __webpack_require__(86).unescapeMd;

/**
 * Parse link title
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

module.exports = function parseLinkTitle(state, pos) {
  var code,
      start = pos,
      max = state.posMax,
      marker = state.src.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return false; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = state.src.charCodeAt(pos);
    if (code === marker) {
      state.pos = pos + 1;
      state.linkContent = unescapeMd(state.src.slice(start + 1, pos));
      return true;
    }
    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    pos++;
  }

  return false;
};


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _string = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntendedCourseLevel = function (_Component) {
  (0, _inherits3.default)(IntendedCourseLevel, _Component);

  function IntendedCourseLevel() {
    (0, _classCallCheck3.default)(this, IntendedCourseLevel);
    return (0, _possibleConstructorReturn3.default)(this, (IntendedCourseLevel.__proto__ || (0, _getPrototypeOf2.default)(IntendedCourseLevel)).apply(this, arguments));
  }

  (0, _createClass3.default)(IntendedCourseLevel, [{
    key: 'render',
    value: function render() {
      var quest = this.props.quest;


      return _react2.default.createElement(
        'div',
        { className: 'intended-course-level-container' },
        _react2.default.createElement(_reactTooltip2.default, {
          key: quest.mock_level ? 'level-' + quest.id : 'no-level-' + quest.id,
          id: 'levelTooltip',
          effect: 'solid',
          offset: { bottom: 5 }
        }),
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'intendedTooltip',
          effect: 'solid',
          offset: { bottom: 5 }
        }),
        _react2.default.createElement(
          'div',
          { className: 'course-container' },
          _react2.default.createElement(
            'div',
            {
              className: 'course',
              style: { color: '#' + quest.mock_course.color }
            },
            quest.mock_course.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'level-container' },
          quest.mock_level ? _react2.default.createElement(
            'div',
            { className: 'level' },
            quest.mock_level.mastery ? _react2.default.createElement(
              'div',
              {
                'data-for': 'levelTooltip',
                'data-tip': (0, _string.getTruncatedString)({
                  val: 'Mastery Level: ' + quest.mock_level.name,
                  len: 107
                })
              },
              'Mastery Level'
            ) : _react2.default.createElement(
              'div',
              {
                'data-for': 'levelTooltip',
                'data-tip': (0, _string.getTruncatedString)({
                  val: 'Level ' + quest.mock_level.number + ': ' + quest.mock_level.name,
                  len: 107
                })
              },
              'Level ',
              quest.mock_level.number
            )
          ) : _react2.default.createElement(
            'div',
            {
              className: 'level',
              'data-for': 'levelTooltip',
              'data-tip': 'No Intended Level has been added.'
            },
            'Level: Not Yet Specified'
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'level intended',
              'data-for': 'intendedTooltip',
              'data-tip': 'This is the intended Journey and Level for this quest.'
            },
            '(Intended)'
          )
        )
      );
    }
  }]);
  return IntendedCourseLevel;
}(_react.Component);

exports.default = IntendedCourseLevel;


IntendedCourseLevel.propTypes = {
  quest: _propTypes2.default.object.isRequired
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignmentAvatars = function (_PureComponent) {
  (0, _inherits3.default)(AssignmentAvatars, _PureComponent);

  function AssignmentAvatars() {
    (0, _classCallCheck3.default)(this, AssignmentAvatars);
    return (0, _possibleConstructorReturn3.default)(this, (AssignmentAvatars.__proto__ || (0, _getPrototypeOf2.default)(AssignmentAvatars)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssignmentAvatars, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fromPhotoUrl = _props.fromPhotoUrl,
          toPhotoUrl = _props.toPhotoUrl;


      return _react2.default.createElement(
        'div',
        { className: 'assignment-avatars' },
        _react2.default.createElement(_UserAvatar2.default, { photoUrl: fromPhotoUrl }),
        _react2.default.createElement('div', { className: 'arrow' }),
        _react2.default.createElement(_UserAvatar2.default, { photoUrl: toPhotoUrl })
      );
    }
  }]);
  return AssignmentAvatars;
}(_react.PureComponent);

exports.default = AssignmentAvatars;


AssignmentAvatars.propTypes = {
  fromPhotoUrl: _propTypes2.default.string,
  toPhotoUrl: _propTypes2.default.string
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #0070e0;\n  font-size: 13px;\n  cursor: pointer;\n\n  &:hover {\n    color: #0085ff;\n  }\n'], ['\n  color: #0070e0;\n  font-size: 13px;\n  cursor: pointer;\n\n  &:hover {\n    color: #0085ff;\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CobaltHyperlink = _styledComponents2.default.div.withConfig({
  displayName: 'CobaltHyperlink',
  componentId: 'sc-1bgbq0f-0'
})(_templateObject);

exports.default = CobaltHyperlink;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestStatusSelect = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _values = __webpack_require__(233);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _QuestStatusSelectOption = __webpack_require__(1453);

var _QuestStatusSelectOption2 = _interopRequireDefault(_QuestStatusSelectOption);

var _QuestStatusSelectValue = __webpack_require__(1454);

var _QuestStatusSelectValue2 = _interopRequireDefault(_QuestStatusSelectValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestStatusSelect = exports.QuestStatusSelect = function (_Component) {
  (0, _inherits3.default)(QuestStatusSelect, _Component);

  function QuestStatusSelect(props) {
    (0, _classCallCheck3.default)(this, QuestStatusSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestStatusSelect.__proto__ || (0, _getPrototypeOf2.default)(QuestStatusSelect)).call(this, props));

    _this.handleSelectChangeBound = _this.handleSelectChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestStatusSelect, [{
    key: 'render',
    value: function render() {
      var dropdownValues = this.props.dropdownValues;

      var dropdownValuesMessages = {
        allQuests: {
          text: 'All quests',
          value: []
        },
        draft: {
          text: 'Draft',
          value: [1]
        },
        inPublicationReview: {
          text: 'In Publication Review',
          value: [0, 4]
        },
        reviewReturned: {
          text: 'Review Returned',
          value: [2]
        },
        published: {
          text: 'Published',
          value: [5]
        }

        // if dropdownValues props included, need to filter out the ones not specified
      };if (dropdownValues) {
        (0, _keys2.default)(dropdownValuesMessages).forEach(function (dvm) {
          if (!dropdownValues.includes(dvm)) {
            delete dropdownValuesMessages[dvm];
          }
        });
      }

      var statusValues = (0, _values2.default)(dropdownValuesMessages).map(function (status) {
        return {
          value: status.value,
          label: status.text,
          className: '' + status.text.toLowerCase().replace(/ /g, '-')
        };
      });

      return _react2.default.createElement(_reactSelect2.default, {
        ref: this.props.statusFilterRef,
        options: statusValues,
        value: this.getValue(statusValues),
        onChange: this.handleSelectChangeBound,
        deleteRemoves: false,
        clearable: false,
        searchable: false,
        optionComponent: _QuestStatusSelectOption2.default,
        valueComponent: _QuestStatusSelectValue2.default
      });
    }
  }, {
    key: 'getValue',
    value: function getValue(statusValues) {
      var _props = this.props,
          draftFilterSelected = _props.draftFilterSelected,
          statusFilters = _props.statusFilters,
          allStatusChecked = _props.allStatusChecked;


      if (allStatusChecked) {
        return statusValues[0];
      } else if (draftFilterSelected) {
        return statusValues[1];
      } else {
        return statusValues.find(function (status) {
          return (0, _stringify2.default)(status.value) === (0, _stringify2.default)(statusFilters);
        });
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(value) {
      this.props.setStatusFilter(value);
    }
  }]);
  return QuestStatusSelect;
}(_react.Component);

QuestStatusSelect.propTypes = {
  setStatusFilter: _propTypes2.default.func.isRequired,
  draftFilterSelected: _propTypes2.default.bool.isRequired,
  statusFilters: _propTypes2.default.array.isRequired,
  allStatusChecked: _propTypes2.default.bool.isRequired,
  intl: _propTypes2.default.object.isRequired,
  dropdownValues: _propTypes2.default.array,
  statusFilterRef: _propTypes2.default.object
};

exports.default = QuestStatusSelect;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentCountIndicator = function (_Component) {
  (0, _inherits3.default)(CommentCountIndicator, _Component);

  function CommentCountIndicator() {
    (0, _classCallCheck3.default)(this, CommentCountIndicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommentCountIndicator.__proto__ || (0, _getPrototypeOf2.default)(CommentCountIndicator)).call(this));

    _this.state = {
      id: Math.random()
    };
    return _this;
  }

  (0, _createClass3.default)(CommentCountIndicator, [{
    key: 'render',
    value: function render() {
      var commentCount = this.props.commentCount;

      return _react2.default.createElement(
        'div',
        {
          className: 'comment-count',
          'data-for': 'commentCountTooltip-' + this.state.id,
          'data-tip': commentCount > 1 ? 'Posted Comments' : 'Posted Comment'
        },
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'commentCountTooltip-' + this.state.id,
          effect: 'solid',
          offset: { top: -2 }
        }),
        this.props.commentCount
      );
    }
  }]);
  return CommentCountIndicator;
}(_react.Component);

exports.default = CommentCountIndicator;


CommentCountIndicator.propTypes = {
  commentCount: _propTypes2.default.number.isRequired
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftCommentIndicator = function (_Component) {
  (0, _inherits3.default)(DraftCommentIndicator, _Component);

  function DraftCommentIndicator() {
    (0, _classCallCheck3.default)(this, DraftCommentIndicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DraftCommentIndicator.__proto__ || (0, _getPrototypeOf2.default)(DraftCommentIndicator)).call(this));

    _this.state = {
      id: Math.random()
    };
    return _this;
  }

  (0, _createClass3.default)(DraftCommentIndicator, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'draft-comment-indicator',
          'data-for': 'draftCommentTooltip-' + this.state.id,
          'data-tip': 'Draft Comment'
        },
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'draftCommentTooltip-' + this.state.id,
          effect: 'solid',
          offset: { top: -2 }
        }),
        _react2.default.createElement('div', { className: 'draft-comment-indicator-icon' })
      );
    }
  }]);
  return DraftCommentIndicator;
}(_react.Component);

exports.default = DraftCommentIndicator;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCssClasses = getCssClasses;
exports.isRequiredSection = isRequiredSection;
exports.getSectionCommentCount = getSectionCommentCount;
exports.hasSectionDraftComments = hasSectionDraftComments;
exports.hasActivityDraftComments = hasActivityDraftComments;
exports.getActivityCommentCount = getActivityCommentCount;
function getCssClasses(section, layout, reviewStatus) {
  var cssClasses = '';

  if (section === layout) {
    cssClasses += 'active';
  }
  if (layout === 'questreview') {
    cssClasses += ' ' + reviewStatus;
  }
  if (layout === 'questhistory') {
    cssClasses += ' questhistory';
  }
  return cssClasses;
}

function isRequiredSection(layout) {
  return ['basicinformation', 'activities', 'images', 'otherinformation'].includes(layout);
}

function getSectionCommentCount(comments, layout) {
  return comments.filter(function (comment) {
    // status 0 means it is not marked resolved
    return comment.section === layout && comment.status === 0;
  }).length;
}

function hasSectionDraftComments(comments, layout) {
  return comments.filter(function (comment) {
    return comment.section === layout;
  }).length > 0;
}

function hasActivityDraftComments(comments, activity) {
  return comments.filter(function (comment) {
    return comment.resource_id === activity.id;
  }).length > 0;
}

function getActivityCommentCount(comments, activity) {
  return comments.filter(function (comment) {
    // status 0 means it is not marked resolved
    return comment.resource_id === activity.id && comment.status === 0;
  }).length;
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getVendorPropertyName = __webpack_require__(1466);

module.exports = function(target, sources) {
  var to = Object(target);
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
    var nextSource = arguments[nextIndex];
    if (nextSource == null) {
      continue;
    }

    var from = Object(nextSource);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
  }

  var prefixed = {};
  for (var key in to) {
    prefixed[getVendorPropertyName(key)] = to[key]
  }

  return prefixed
}


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDraggableList = __webpack_require__(1472);

var _reactDraggableList2 = _interopRequireDefault(_reactDraggableList);

var _DraggableItem = __webpack_require__(1489);

var _DraggableItem2 = _interopRequireDefault(_DraggableItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraggableListComponent = function (_Component) {
  (0, _inherits3.default)(DraggableListComponent, _Component);

  function DraggableListComponent(props) {
    (0, _classCallCheck3.default)(this, DraggableListComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DraggableListComponent.__proto__ || (0, _getPrototypeOf2.default)(DraggableListComponent)).call(this, props));

    _this.state = {
      list: props.list
    };
    return _this;
  }

  (0, _createClass3.default)(DraggableListComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps !== this.props) {
        this.setState(function () {
          return {
            list: nextProps.list
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return _react2.default.createElement(
        'ul',
        { className: 'draggable-list ' + props.itemType },
        _react2.default.createElement(_reactDraggableList2.default, {
          itemKey: 'id',
          template: _DraggableItem2.default,
          list: this.state.list,
          onMoveEnd: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
            return _this2.onMoveEnd(newList, movedItem, oldIndex, newIndex);
          },
          container: function container() {
            return document.body;
          },
          draggable: true,
          commonProps: props
        })
      );
    }
  }, {
    key: 'onMoveEnd',
    value: function onMoveEnd(newList, movedItem, oldIndex, newIndex) {
      this.setState({ list: newList });
      if (oldIndex !== newIndex) {
        this.props.editListItemPosition(movedItem.id, newIndex);
      }
    }
  }]);
  return DraggableListComponent;
}(_react.Component);

exports.default = DraggableListComponent;


DraggableListComponent.propTypes = {
  list: _propTypes2.default.array.isRequired,
  deleteItem: _propTypes2.default.func,
  handleEditClick: _propTypes2.default.func,
  editListItemPosition: _propTypes2.default.func.isRequired,
  itemType: _propTypes2.default.string.isRequired,
  hideEdit: _propTypes2.default.bool,
  hideDescription: _propTypes2.default.bool,
  hideDelete: _propTypes2.default.bool
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(446)["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _activity = __webpack_require__(240);

var _logging = __webpack_require__(137);

var _modal = __webpack_require__(26);

var _quest = __webpack_require__(66);

var _readability = __webpack_require__(222);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Indicator = function (_Component) {
  (0, _inherits3.default)(Indicator, _Component);

  function Indicator() {
    (0, _classCallCheck3.default)(this, Indicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Indicator.__proto__ || (0, _getPrototypeOf2.default)(Indicator)).call(this));

    _this.state = { hover: false };
    _this.onUpdateScoresClickBound = _this.onUpdateScoresClick.bind(_this);
    _this.onOpenReadabilityScoresClickBound = _this.onOpenReadabilityScoresClick.bind(_this);
    _this.onIndicatorHoverBound = _this.onIndicatorHover.bind(_this);
    _this.onIndicatorLeaveBound = _this.onIndicatorLeave.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Indicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          subsection = _props.subsection,
          scores = _props.scores,
          readableStatsObject = _props.readableStatsObject;

      var scoresState = (0, _readability.getReadabilityScoresState)(scores);
      var tooltipContent = this.getTooltipText(scores);
      var klass = (0, _utils.isNullOrEmpty)(readableStatsObject[subsection]) ? '' : 'active';

      return _react2.default.createElement(
        'span',
        { className: 'readability-indicator ' + klass },
        scoresState === 'updating' && _react2.default.createElement(
          'span',
          {
            className: 'updating ' + (this.state.hover ? 'hover' : ''),
            onClick: this.onUpdateScoresClickBound,
            onMouseEnter: this.onIndicatorHoverBound,
            onMouseLeave: this.onIndicatorLeaveBound
          },
          _react2.default.createElement('span', { className: 'updating-icon' }),
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Readability.Indicator.Updating',
            defaultMessage: 'Update Scores'
          })
        ),
        scoresState !== 'updating' && _react2.default.createElement(
          'span',
          {
            className: scoresState + ' ' + (this.state.hover ? 'hover' : ''),
            'data-for': 'averageGradeLevelTooltip',
            'data-tip': tooltipContent,
            onMouseEnter: this.onIndicatorHoverBound,
            onMouseLeave: this.onIndicatorLeaveBound,
            onClick: this.onOpenReadabilityScoresClickBound
          },
          _react2.default.createElement(_reactTooltip2.default, {
            id: 'averageGradeLevelTooltip',
            effect: 'solid',
            offset: { right: 20, bottom: 15 }
          }),
          _react2.default.createElement('span', { className: 'book-icon' }),
          _react2.default.createElement(
            'span',
            { className: 'average-grade-level-score' },
            scoresState === 'has-average-grade-level' ? scores.stats.average_grade_level : '-'
          )
        )
      );
    }
  }, {
    key: 'onUpdateScoresClick',
    value: function onUpdateScoresClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest,
          readableStatsObject = _props2.readableStatsObject,
          section = _props2.section;

      if (section === 'activity') {
        dispatch((0, _activity.fetchActivityReadableStats)(quest.id, readableStatsObject.id));
      } else {
        dispatch((0, _quest.fetchQuestReadableStats)(quest.id));
      }
    }
  }, {
    key: 'onOpenReadabilityScoresClick',
    value: function onOpenReadabilityScoresClick() {
      var _props3 = this.props,
          quest = _props3.quest,
          readableStatsObject = _props3.readableStatsObject,
          section = _props3.section,
          subsection = _props3.subsection,
          dispatch = _props3.dispatch;


      var data = {
        readability: {
          source_page: section,
          source_field: subsection
        },
        quest: {
          id: quest.id,
          name: quest.name
        }
      };

      if (section === 'activity') {
        data.activity = {
          id: readableStatsObject.id,
          name: readableStatsObject.name
        };
      }

      dispatch((0, _logging.postLoggingInfo)('readability_view', data));

      dispatch((0, _modal.isViewingReadabilityScoresModal)(section, subsection));
    }
  }, {
    key: 'getTooltipText',
    value: function getTooltipText(scores) {
      var retVal = void 0;
      if (scores.stats.average_grade_level) {
        retVal = 'Grade Level: ' + scores.stats.average_grade_level;
      } else {
        retVal = 'Grade level is not currently available';
      }

      return retVal;
    }
  }, {
    key: 'onIndicatorHover',
    value: function onIndicatorHover() {
      this.setState({ hover: true });
    }
  }, {
    key: 'onIndicatorLeave',
    value: function onIndicatorLeave() {
      this.setState({ hover: false });
    }
  }]);
  return Indicator;
}(_react.Component);

exports.default = Indicator;


Indicator.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string.isRequired,
  subsection: _propTypes2.default.string.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  scores: _propTypes2.default.object.isRequired,
  readableStatsObject: _propTypes2.default.object.isRequired
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityGoalOrgLabel = activityGoalOrgLabel;

var _messages = __webpack_require__(21);

function activityGoalOrgLabel(org) {
  if (org.id === 7) {
    return _messages.specificObjective;
  } else {
    return _messages.activityGoals;
  }
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = undefined;

var _reactIntl = __webpack_require__(16);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  deleteMentorNote: {
    'id': 'ActivityEdit.DeleteMentorNote',
    'defaultMessage': 'Delete this mentor note?'
  },
  deleteResource: {
    'id': 'ActivityEdit.DeleteResource',
    'defaultMessage': 'Delete this resource?'
  },
  deleteActivity: {
    'id': 'Quest.Activity.DeleteActivity',
    'defaultMessage': 'Are you sure you want to delete this activity?'
  }
});

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1492);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flashDraggableItem = flashDraggableItem;
// this classList manipulation should be done in componentWillUpdate
// currently, the DOM manipulation will occur regardless of success/timing of API response
function flashDraggableItem(_el) {
  setTimeout(function () {
    _el.classList.add('flash');
    setTimeout(function () {
      _el.classList.remove('flash');
    }, 500);
  }, 500);
}

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 15px;\n  font-weight: 300;\n'], ['\n  color: #000000;\n  font-size: 15px;\n  font-weight: 300;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var P3 = _styledComponents2.default.div.withConfig({
  displayName: 'P3',
  componentId: 'sc-113uxs6-0'
})(_templateObject);

exports.default = P3;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonErrorText = exports.HelperText = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-top: 4px;\n'], ['\n  margin-top: 4px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  left: 0;\n  bottom: 0;\n'], ['\n  position: absolute;\n  left: 0;\n  bottom: 0;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _ErrorText = __webpack_require__(304);

var _ErrorText2 = _interopRequireDefault(_ErrorText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelperText = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: '_Styled__HelperText',
  componentId: 'sc-1d9s4r0-0'
})(_templateObject);

var ButtonErrorText = (0, _styledComponents2.default)(_ErrorText2.default).withConfig({
  displayName: '_Styled__ButtonErrorText',
  componentId: 'sc-1d9s4r0-1'
})(_templateObject2);

exports.HelperText = HelperText;
exports.ButtonErrorText = ButtonErrorText;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentLabelDropdown = function CommentLabelDropdown(_ref) {
  var labels = _ref.labels,
      selectedValue = _ref.selectedValue,
      onChange = _ref.onChange,
      type = _ref.type;

  var commentLabels = labels.map(function (label, index) {
    return _react2.default.createElement(
      'option',
      { value: label, key: index },
      label
    );
  });

  return _react2.default.createElement(
    'select',
    {
      className: 'aDropdown',
      id: 'commentLabel' + type,
      defaultValue: selectedValue,
      onChange: onChange
    },
    commentLabels
  );
};

CommentLabelDropdown.propTypes = {
  labels: _propTypes2.default.array,
  selectedValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  type: _propTypes2.default.string
};

exports.default = CommentLabelDropdown;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var labels = {
  basicinformation: ['All of Basic Information', 'Title', 'Authors', 'Quest Manager', 'Driving Question', 'Quest Goal', 'Description', 'Intended Journey/Level', 'Primary Subject', 'Target Grade', 'Group Quest', 'Just for Mentors'],
  topicsandstandards: ['Topics & Standards'],
  activities: ['All of Activity', 'Title', 'Activity Goals', 'Description', 'Artifact', 'Resources', 'Notes for Mentors', 'Assessment Questions for Mentors', 'File for Mentors'],
  images: ['Quest Icon'],
  otherinformation: ['All of Other Information', 'Unusual Materials', 'Tags', 'Inspiration'],
  questreview: ['All of Quest Review', 'Internal Review - Experience', 'Internal Review - Subject', 'Internal Review - Copy', 'Publication Review - Standards', 'Publication Review - Final'],
  skills: ['Skills']
};

exports.default = labels;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredComments = getFilteredComments;
exports.getResolvedComments = getResolvedComments;
exports.getTotalCommentCount = getTotalCommentCount;
exports.getUnresolvedCommentCount = getUnresolvedCommentCount;
exports.getFriendlyCommentSectionLabel = getFriendlyCommentSectionLabel;
function getFilteredComments(comments, section, activityId, showingResolvedComments) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return showingResolvedComments ? comment.section === section && comment.resource_id === activityId : comment.section === section && comment.status === 0 && comment.resource_id === activityId;
    } else {
      return showingResolvedComments ? comment.section === section : comment.section === section && comment.status === 0;
    }
  }, this);
}

function getResolvedComments(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return comment.section === section && comment.status === 1 && comment.resource_id === activityId;
    } else {
      return comment.section === section && comment.status === 1;
    }
  });
}

function getTotalCommentCount(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return comment.section === section && comment.resource_id === activityId;
    } else {
      return comment.section === section;
    }
  }).length;
}

function getUnresolvedCommentCount(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return comment.section === section && comment.status === 0 && comment.resource_id === activityId;
    } else {
      return comment.section === section && comment.status === 0;
    }
  }).length;
}

function getFriendlyCommentSectionLabel(data) {
  var retVal = '';
  switch (data.section) {
    case 'basicinformation':
      {
        retVal = 'Basic Information';
        break;
      }
    case 'otherinformation':
      {
        retVal = 'Other Information';
        break;
      }
    case 'images':
      {
        retVal = 'Images';
        break;
      }
    case 'topicsandstandards':
      {
        retVal = 'Topics & Standards';
        break;
      }
    case 'activities':
      {
        data.activity ? retVal = 'Activity ' + data.activity.number : retVal = 'Activities';
        break;
      }
    case 'questhistory':
      {
        retVal = 'Quest History';
        break;
      }
    case 'questreview':
      {
        retVal = 'Quest Review';
        break;
      }
    case 'skills':
      {
        retVal = 'Skills';
        break;
      }
    default:
      {
        retVal = 'Unknown';
      }
  }
  return retVal;
}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _oeWebCommon = __webpack_require__(117);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimestampVersion = function TimestampVersion(_ref) {
  var event = _ref.event;
  return _react2.default.createElement(
    _Caption2.default,
    { style: { display: 'flex' } },
    _react2.default.createElement(_oeWebCommon.OEComponents.ElapsedTimeFormatter, { time: event.created_at }),
    '\xA0\u2022 v' + event.version
  );
};

TimestampVersion.propTypes = {
  event: _propTypes2.default.object.isRequired
};

exports.default = TimestampVersion;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityEditFields = undefined;

var _freeze = __webpack_require__(237);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activityEditFields = exports.activityEditFields = (0, _freeze2.default)({
  name: {
    index: 0,
    label: 'Activity Title'
  },
  goals: {
    index: 1,
    label: 'Activity Goals'
  },
  description: {
    index: 2,
    label: 'Activity Description'
  },
  checkpoint: {
    index: 3,
    label: 'Check-In?'
  },
  work_product: {
    index: 4,
    label: 'Requires Artifact?'
  },
  artifact_type_id: {
    index: 5,
    label: 'Artifact Type'
  },
  artifact_description: {
    index: 6,
    label: 'Artifact Description'
  },
  inline_notes: {
    index: 7,
    label: 'Notes for Mentors'
  },
  mentor_assessment_questions: {
    index: 8,
    label: 'Assessment Questions for Mentors'
  }
});

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestEventLoggingData = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _review = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getQuestEventLoggingData = function getQuestEventLoggingData(quest) {
  return (0, _assign2.default)({
    quest: {
      id: quest.id,
      name: quest.name
    },
    quest_status: (0, _review.getReviewStatus)(quest)
  }, Boolean(quest.type) && {
    quest_type: {
      id: quest.type.id,
      name: quest.type.name
    }
  }, quest.managers.length > 0 && {
    manager: {
      id: quest.managers[0].id,
      name: quest.managers[0].name
    }
  });
};

exports.getQuestEventLoggingData = getQuestEventLoggingData;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__(1553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentReviewsFilteredForQuestState = undefined;

var _reselect = __webpack_require__(168);

var _review = __webpack_require__(64);

var _currentReviewsFilteredForQuestState = function _currentReviewsFilteredForQuestState(state) {
  if ((0, _review.questInDraftAfterPublished)(state.quest.item)) {
    return [];
  } else {
    return state.quest.currentReviews;
  }
};

var currentReviewsFilteredForQuestState = exports.currentReviewsFilteredForQuestState = (0, _reselect.createSelector)([_currentReviewsFilteredForQuestState], function (reviews) {
  return reviews;
});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 30px;\n  font-weight: 300;\n'], ['\n  color: #000000;\n  font-size: 30px;\n  font-weight: 300;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Display = _styledComponents2.default.div.withConfig({
  displayName: 'Display',
  componentId: 'sc-1aijzcl-0'
})(_templateObject);

exports.default = Display;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #808080;\n  font-size: 22px;\n  font-weight: 300;\n'], ['\n  color: #808080;\n  font-size: 22px;\n  font-weight: 300;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intro5am = _styledComponents2.default.div.withConfig({
  displayName: 'Intro5am',
  componentId: 'sc-1icc57a-0'
})(_templateObject);

exports.default = Intro5am;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

exports.flashNewItem = flashNewItem;

var _index = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function flashNewItem(_ref) {
  var itemId = _ref.itemId,
      classToAdd = _ref.classToAdd,
      autoscroll = _ref.autoscroll;

  // Scroll to and flash the item node
  var _el = document.getElementById(typeof itemId === 'string' ? itemId : (0, _stringify2.default)(itemId));
  if (autoscroll) {
    window.scroll(0, (0, _index.findPos)(_el));
  }
  _el.className += ' flash';
  if (classToAdd) {
    setTimeout(function () {
      _el.className = classToAdd;
    }, 500);
  }

  // remove the flash class
  setTimeout(function () {
    _el.className = _el.className.replace(' flash', '');
  }, 500);
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _multipleeditors = __webpack_require__(341);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultipleEditors = function (_Component) {
  (0, _inherits3.default)(MultipleEditors, _Component);

  function MultipleEditors(props) {
    (0, _classCallCheck3.default)(this, MultipleEditors);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MultipleEditors.__proto__ || (0, _getPrototypeOf2.default)(MultipleEditors)).call(this, props));

    _this.state = {
      editors: (0, _multipleeditors.mapChannelMembers)(props.channel.members.members)
    };
    return _this;
  }

  (0, _createClass3.default)(MultipleEditors, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.newEditors !== this.props.newEditors) {
        var newEditorsState = this.state.editors.concat(nextProps.newEditors);
        newEditorsState = newEditorsState.filter(function (editor, index, self) {
          return index === self.findIndex(function (e) {
            return e.id === editor.id;
          });
        });
        this.setState(function (prevState) {
          return {
            editors: newEditorsState
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'multiple-editors-info' },
        _react2.default.createElement('div', { className: 'edit-warning-icon' }),
        _react2.default.createElement(
          'div',
          { className: 'multiple-editors-message' },
          this.state.editors.length === 1 ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              this.state.editors[0].name
            ),
            ' is',
            ' '
          ) : _react2.default.createElement(
            'span',
            null,
            this.state.editors.map(function (m, i) {
              var length = _this2.state.editors.length;
              if (length > 2 && i < length - 1) {
                return _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    m.name
                  ),
                  ',',
                  ' '
                );
              } else if (length === 2 && i < length - 1) {
                return _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    m.name
                  ),
                  ' '
                );
              } else {
                return _react2.default.createElement(
                  'span',
                  null,
                  'and ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    m.name
                  ),
                  ' are',
                  ' '
                );
              }
            })
          ),
          _react2.default.createElement(
            'span',
            null,
            'currently editing this page. Your changes or their changes could be lost. Tap \u201CCancel\u201D to stop editing.'
          )
        )
      );
    }
  }]);
  return MultipleEditors;
}(_react.Component);

exports.default = MultipleEditors;


MultipleEditors.propTypes = {
  channel: _propTypes2.default.object.isRequired,
  newEditors: _propTypes2.default.array.isRequired
};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignToButton = function (_Component) {
  (0, _inherits3.default)(AssignToButton, _Component);

  function AssignToButton() {
    (0, _classCallCheck3.default)(this, AssignToButton);
    return (0, _possibleConstructorReturn3.default)(this, (AssignToButton.__proto__ || (0, _getPrototypeOf2.default)(AssignToButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssignToButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'assign-this-quest-to button btn-secondary-small',
          onClick: this.props.handleClick
        },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'Quest.Review.AssignmentArea.AssignThisQuestTo',
          defaultMessage: 'Assign this quest to...'
        })
      );
    }
  }]);
  return AssignToButton;
}(_react.Component);

exports.default = AssignToButton;


AssignToButton.propTypes = {
  handleClick: _propTypes2.default.func.isRequired
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createTimeoutManager;

var _spyOnComponent = _interopRequireDefault(__webpack_require__(344));

var _mountManager = _interopRequireDefault(__webpack_require__(475));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTimeoutManager(componentInstance) {
  var isMounted = (0, _mountManager.default)(componentInstance);
  var timers = Object.create(null);
  var manager;
  (0, _spyOnComponent.default)(componentInstance, {
    componentWillUnmount: function componentWillUnmount() {
      for (var k in timers) {
        clearTimeout(timers[k]);
      }

      timers = null;
    }
  });
  return manager = {
    clear: function clear(key) {
      clearTimeout(timers[key]);
    },
    set: function set(key, fn, ms) {
      if (!isMounted()) return;
      manager.clear(key);
      timers[key] = setTimeout(fn, ms);
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(704));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1610));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1612));

var _removeStyle = _interopRequireDefault(__webpack_require__(1613));

var _properties = __webpack_require__(705);

var _isTransform = _interopRequireDefault(__webpack_require__(1614));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1609));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(701));

var _isWindow = _interopRequireDefault(__webpack_require__(345));

var _ownerDocument = _interopRequireDefault(__webpack_require__(697));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultGetDataState = defaultGetDataState;
exports.getCommonListProps = getCommonListProps;
exports.default = reduceToListState;

var _Filter = __webpack_require__(709);

var _ = __webpack_require__(478);

var _dataHelpers = __webpack_require__(275);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EMPTY_VALUE = {};

var returnFalse = function returnFalse() {
  return false;
};

function defaultGetDataState(data, _ref, lastState) {
  var groupBy = _ref.groupBy;

  if (lastState === void 0) {
    lastState = {};
  }

  if (lastState.data !== data || lastState.groupBy !== groupBy) {
    if (!groupBy) return {};
    var keys = [];
    var groups = (0, _.groupBySortedKeys)(groupBy, data, keys);
    return {
      data: data,
      groupBy: groupBy,
      groups: groups,
      sortedKeys: keys,
      sequentialData: Object.keys(groups).reduce(function (flat, grp) {
        return flat.concat(groups[grp]);
      }, [])
    };
  }

  return lastState;
}

var getStateGetterFromList = function getStateGetterFromList(_ref2) {
  var l = _ref2.listComponent;
  return l && l.getDataState;
};

var getIsDisabled = function getIsDisabled(disabledProp, valueField) {
  return !Array.isArray(disabledProp) ? returnFalse : function (item) {
    return disabledProp.some(function (i) {
      return (0, _dataHelpers.dataValue)(item, valueField) === (0, _dataHelpers.dataValue)(i, valueField);
    });
  };
};

function getCommonListProps(list, accessors, _ref3) {
  var groupBy = _ref3.groupBy,
      optionComponent = _ref3.optionComponent,
      itemComponent = _ref3.itemComponent,
      groupComponent = _ref3.groupComponent,
      searchTerm = _ref3.searchTerm,
      listProps = _ref3.listProps;
  return _extends({
    searchTerm: searchTerm,
    groupBy: groupBy,
    groupComponent: groupComponent,
    itemComponent: itemComponent,
    optionComponent: optionComponent
  }, listProps, {
    data: list.data,
    dataState: list.state,
    textAccessor: accessors.text,
    valueAccessor: accessors.value
  });
}

function reduceToListState(nextListData, prevList, _temp) {
  var _ref4 = _temp === void 0 ? {} : _temp,
      nextProps = _ref4.nextProps,
      getDataState = _ref4.getDataState;

  var disabled = nextProps.disabled,
      valueField = nextProps.valueField,
      textField = nextProps.textField;
  getDataState = getDataState || getStateGetterFromList(nextProps) || defaultGetDataState;
  var dataState = getDataState(nextListData, nextProps, prevList && prevList.dataState);
  var data = dataState && dataState.sequentialData || nextListData;
  var isDisabled = getIsDisabled(disabled, valueField);

  var moveNext = function moveNext(item, word) {
    return isDisabled(item) || word && !_Filter.presets.startsWith((0, _dataHelpers.dataText)(item, textField).toLowerCase(), word.toLowerCase());
  };

  var list = {
    dataState: dataState,
    isDisabled: isDisabled,
    first: function first() {
      return list.next(EMPTY_VALUE);
    },
    last: function last() {
      return list.prevEnabled(data[data.length - 1]);
    },
    prev: function prev(item, word) {
      var nextIdx = Math.max(0, data.indexOf(item)) - 1;

      while (nextIdx > -1 && moveNext(data[nextIdx], word)) {
        nextIdx--;
      }

      if (nextIdx >= 0) return data[nextIdx];
      return isDisabled(item) ? null : item;
    },
    next: function next(item, word) {
      var nextIdx = data.indexOf(item) + 1;

      while (nextIdx < data.length && moveNext(data[nextIdx], word)) {
        nextIdx++;
      }

      if (nextIdx < data.length) return data[nextIdx];
      return isDisabled(item) ? null : item;
    },
    prevEnabled: function prevEnabled(item) {
      return isDisabled(item) ? list.prev(item) : item;
    },
    nextEnabled: function nextEnabled(item) {
      return isDisabled(item) ? list.next(item) : item;
    }
  };
  return list;
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.indexOf = indexOf;
exports.filter = filter;
exports.suggest = suggest;
exports.propTypes = exports.presets = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var CustomPropTypes = _interopRequireWildcard(__webpack_require__(274));

var _dataHelpers = __webpack_require__(275);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var presets = {
  eq: function eq(a, b) {
    return a === b;
  },
  neq: function neq(a, b) {
    return a !== b;
  },
  gt: function gt(a, b) {
    return a > b;
  },
  gte: function gte(a, b) {
    return a >= b;
  },
  lt: function lt(a, b) {
    return a < b;
  },
  lte: function lte(a, b) {
    return a <= b;
  },
  contains: function contains(a, b) {
    return a.indexOf(b) !== -1;
  },
  startsWith: function startsWith(a, b) {
    return a.lastIndexOf(b, 0) === 0;
  },
  endsWith: function endsWith(a, b) {
    var pos = a.length - b.length;
    var lastIndex = a.indexOf(b, pos);
    return lastIndex !== -1 && lastIndex === pos;
  }
};
exports.presets = presets;

function normalizeFilterType(type) {
  if (type === false) return null;
  if (type === true) return 'startsWith';
  return type || 'eq';
}

function normalizeFilter(_ref) {
  var filter = _ref.filter,
      _ref$caseSensitive = _ref.caseSensitive,
      caseSensitive = _ref$caseSensitive === void 0 ? false : _ref$caseSensitive,
      textField = _ref.textField;
  filter = normalizeFilterType(filter);

  if (typeof filter === 'function' || !filter) {
    return filter;
  }

  filter = presets[filter];
  return function (item, searchTerm) {
    var textValue = (0, _dataHelpers.dataText)(item, textField);

    if (!caseSensitive) {
      textValue = textValue.toLowerCase();
      searchTerm = searchTerm.toLowerCase();
    }

    return filter(textValue, searchTerm);
  };
}

function normalizeOptions(nextOptions) {
  var options = _extends({}, nextOptions);

  options.minLengh = options.minLengh || 0;
  options.filter = normalizeFilter(options);
  return options;
}

var propTypes = {
  textField: CustomPropTypes.accessor,
  caseSensitive: _propTypes.default.bool,
  minLength: _propTypes.default.number,
  filter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool, _propTypes.default.oneOf(Object.keys(presets))])
};
exports.propTypes = propTypes;

function indexOf(data, _ref2) {
  var _ref2$searchTerm = _ref2.searchTerm,
      searchTerm = _ref2$searchTerm === void 0 ? '' : _ref2$searchTerm,
      options = _objectWithoutProperties(_ref2, ["searchTerm"]);

  var _normalizeOptions = normalizeOptions(options),
      filter = _normalizeOptions.filter,
      minLength = _normalizeOptions.minLength;

  if (!filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return -1;

  for (var idx = 0; idx < data.length; idx++) {
    if (filter(data[idx], searchTerm, idx)) return idx;
  }

  return -1;
}

function filter(data, _ref3) {
  var _ref3$searchTerm = _ref3.searchTerm,
      searchTerm = _ref3$searchTerm === void 0 ? '' : _ref3$searchTerm,
      options = _objectWithoutProperties(_ref3, ["searchTerm"]);

  var _normalizeOptions2 = normalizeOptions(options),
      filter = _normalizeOptions2.filter,
      minLength = _normalizeOptions2.minLength;

  if (!filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return data;
  return data.filter(function (item, idx) {
    return filter(item, searchTerm, idx);
  });
}

function suggest(data, _ref4) {
  var _ref4$searchTerm = _ref4.searchTerm,
      searchTerm = _ref4$searchTerm === void 0 ? '' : _ref4$searchTerm,
      options = _objectWithoutProperties(_ref4, ["searchTerm"]);

  var _normalizeOptions3 = normalizeOptions(options),
      filter = _normalizeOptions3.filter,
      minLength = _normalizeOptions3.minLength;

  if (!filter || !searchTerm || !searchTerm.trim() || searchTerm.length < minLength) return searchTerm;

  for (var idx = 0; idx < data.length; idx++) {
    if (filter(data[idx], searchTerm, idx)) return data[idx];
  }

  return searchTerm;
}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _widgetHelpers = __webpack_require__(480);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes.default.string,
  role: _propTypes.default.string,
  nodeRef: _propTypes.default.func,
  emptyListMessage: _propTypes.default.node
};

var Listbox =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Listbox, _React$Component);

  function Listbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Listbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        role = _this$props.role,
        children = _this$props.children,
        emptyListMessage = _this$props.emptyListMessage,
        nodeRef = _this$props.nodeRef,
        props = _objectWithoutProperties(_this$props, ["className", "role", "children", "emptyListMessage", "nodeRef"]);

    var id = (0, _widgetHelpers.instanceId)(this);
    return _react.default.createElement("ul", _extends({
      id: id,
      tabIndex: "-1",
      ref: nodeRef,
      className: (0, _classnames.default)(className, 'rw-list'),
      role: role === undefined ? 'listbox' : role
    }, props), _react.default.Children.count(children) ? children : _react.default.createElement("li", {
      className: "rw-list-empty"
    }, emptyListMessage));
  };

  return Listbox;
}(_react.default.Component);

Listbox.propTypes = propTypes;
var _default = Listbox;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var Props = _interopRequireWildcard(__webpack_require__(479));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ListOption =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ListOption, _React$Component);

  function ListOption() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (event) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          disabled = _this$props.disabled,
          dataItem = _this$props.dataItem;
      if (onSelect && !disabled) onSelect(dataItem, event);
    };

    return _this;
  }

  var _proto = ListOption.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children,
        focused = _this$props2.focused,
        selected = _this$props2.selected,
        disabled = _this$props2.disabled,
        activeId = _this$props2.activeId;
    var Tag = this.props.component || 'li';
    var props = Props.omitOwn(this);
    var classes = {
      'rw-state-focus': focused,
      'rw-state-selected': selected,
      'rw-state-disabled': disabled
    };
    var id = focused ? activeId : undefined;
    return _react.default.createElement(Tag, _extends({
      id: id,
      role: "option",
      tabIndex: !disabled ? '-1' : undefined,
      "aria-selected": !!selected,
      className: (0, _classnames.default)('rw-list-option', className, classes),
      onClick: this.handleSelect
    }, props), children);
  };

  return ListOption;
}(_react.default.Component);

ListOption.propTypes = {
  activeId: _propTypes.default.string,
  dataItem: _propTypes.default.any,
  index: _propTypes.default.number,
  focused: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onSelect: _propTypes.default.func,
  component: _propTypes.default.string
};
var _default = ListOption;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getMessages = getMessages;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = {
  moveBack: 'Navigate back',
  moveForward: 'Navigate forward',
  dateButton: 'Select date',
  timeButton: 'Select time',
  openCombobox: 'open combobox',
  openDropdown: 'open dropdown',
  placeholder: '',
  filterPlaceholder: '',
  emptyList: 'There are no items in this list',
  emptyFilter: 'The filter returned no results',
  createOption: function createOption(_ref) {
    var searchTerm = _ref.searchTerm;
    return [' Create option', searchTerm && ' ', searchTerm && _react.default.createElement("strong", {
      key: "_"
    }, "\"" + searchTerm + "\"")];
  },
  tagsLabel: 'Selected items',
  removeLabel: 'Remove selected item',
  noneSelected: 'no selected items',
  selectedItems: function selectedItems(labels) {
    return "Selected items: " + labels.join(', ');
  },
  // number
  increment: 'Increment value',
  decrement: 'Decrement value'
};

function getMessages(defaults) {
  if (defaults === void 0) {
    defaults = {};
  }

  var processed = {};
  Object.keys(messages).forEach(function (message) {
    var value = defaults[message];
    if (value == null) value = messages[message];
    processed[message] = typeof value === 'function' ? value : function () {
      return value;
    };
  });
  return processed;
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.widgetEditable = exports.widgetEnabled = exports.isInDisabledFieldset = void 0;

var _reactDom = __webpack_require__(32);

var _matches = _interopRequireDefault(__webpack_require__(1627));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isInDisabledFieldset = function isInDisabledFieldset(inst) {
  var node;

  try {
    node = (0, _reactDom.findDOMNode)(inst);
  } catch (err) {
    /* ignore */
  }

  return !!node && (0, _matches.default)(node, 'fieldset[disabled] *');
};

exports.isInDisabledFieldset = isInDisabledFieldset;
var widgetEnabled = interactionDecorator(true);
exports.widgetEnabled = widgetEnabled;
var widgetEditable = interactionDecorator(false);
exports.widgetEditable = widgetEditable;

function interactionDecorator(disabledOnly) {
  function wrap(method) {
    return function decoratedMethod() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;
      disabled = isInDisabledFieldset(this) || disabled == true || !disabledOnly && readOnly === true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!disabled) return method.apply(this, args);
    };
  }

  return function decorate(target, key, desc) {
    if (desc.initializer) {
      var init = desc.initializer;

      desc.initializer = function () {
        return wrap(init.call(this)).bind(this);
      };
    } else desc.value = wrap(desc.value);

    return desc;
  };
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfirmation = exports.confirmable = undefined;

var _confirmable = __webpack_require__(1644);

var _confirmable2 = _interopRequireDefault(_confirmable);

var _createConfirmation = __webpack_require__(1645);

var _createConfirmation2 = _interopRequireDefault(_createConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.confirmable = _confirmable2.default;
exports.createConfirmation = _createConfirmation2.default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #dc143c;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n'], ['\n  color: #dc143c;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorMessage = _styledComponents2.default.div.withConfig({
  displayName: 'ErrorMessage',
  componentId: 'ugqrk2-0'
})(_templateObject);
exports.default = ErrorMessage;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n'], ['\n  color: #000000;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption3 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption3',
  componentId: 'sc-4ksph-0'
})(_templateObject);

exports.default = Caption3;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-top: 15px;\n  margin-bottom: 17px;\n\n  > * {\n    display: inline;\n  }\n'], ['\n  margin-top: 15px;\n  margin-bottom: 17px;\n\n  > * {\n    display: inline;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  margin-bottom: 26px;\n\n  input[type=\'number\']::-webkit-inner-spin-button,\n  input[type=\'number\']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n'], ['\n  margin-bottom: 26px;\n\n  input[type=\'number\']::-webkit-inner-spin-button,\n  input[type=\'number\']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 13px;\n'], ['\n  margin-right: 13px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  height: 20px;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin: 0 5px;\n'], ['\n  height: 20px;\n  color: #000000;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin: 0 5px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  height: 34px;\n  width: 62px;\n  border: 0.5px solid #bbbbbb;\n  border-radius: 5px;\n  background-color: #ffffff;\n  text-align: center;\n'], ['\n  height: 34px;\n  width: 62px;\n  border: 0.5px solid #bbbbbb;\n  border-radius: 5px;\n  background-color: #ffffff;\n  text-align: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(160);

var _Caption4 = _interopRequireDefault(_Caption3);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _resources = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextContainer = _styledComponents2.default.div.withConfig({
  displayName: 'YoutubeTrimmer__TextContainer',
  componentId: 'wherc9-0'
})(_templateObject);

var StartEndTimesContainer = (0, _styledComponents2.default)(_FlexAlignCenter2.default).withConfig({
  displayName: 'YoutubeTrimmer__StartEndTimesContainer',
  componentId: 'wherc9-1'
})(_templateObject2);

var StartEndTimeLabel = (0, _styledComponents2.default)(_P2.default).withConfig({
  displayName: 'YoutubeTrimmer__StartEndTimeLabel',
  componentId: 'wherc9-2'
})(_templateObject3);

var Colon = _styledComponents2.default.div.withConfig({
  displayName: 'YoutubeTrimmer__Colon',
  componentId: 'wherc9-3'
})(_templateObject4);

var TimeInput = _styledComponents2.default.input.withConfig({
  displayName: 'YoutubeTrimmer__TimeInput',
  componentId: 'wherc9-4'
})(_templateObject5);

var YoutubeTrimmer = function YoutubeTrimmer(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      TextContainer,
      null,
      _react2.default.createElement(
        _Caption4.default,
        null,
        'YouTube Links:\xA0'
      ),
      _react2.default.createElement(
        _Caption2.default,
        null,
        'Add a start and/or end time to limit play time within Quest! Web\u2019s in-app video player.',
        _react2.default.createElement('br', null),
        'Both fields are not required. The video will play from its original beginning or end if not specified.'
      )
    ),
    _react2.default.createElement(
      StartEndTimesContainer,
      null,
      _react2.default.createElement(
        StartEndTimeLabel,
        null,
        'Start Time'
      ),
      _react2.default.createElement(TimeInput, {
        type: 'number',
        min: '0',
        onChange: function onChange(event) {
          return props.setStartTimeMinutes(event.target.value);
        },
        placeholder: 'Min',
        defaultValue: props.startTimeMinutes,
        onKeyDown: function onKeyDown(e) {
          return (0, _resources.preventUnwantedNumberKeys)(e);
        }
      }),
      _react2.default.createElement(
        Colon,
        null,
        ':'
      ),
      _react2.default.createElement(TimeInput, {
        type: 'number',
        min: '0',
        max: '59',
        onChange: function onChange(event) {
          return props.setStartTimeSeconds(event.target.value);
        },
        style: { marginRight: '98px' },
        onInput: function onInput(e) {
          return (0, _resources.validateSecondsInput)(e);
        },
        placeholder: 'Sec',
        defaultValue: props.startTimeSeconds,
        onKeyDown: function onKeyDown(e) {
          return (0, _resources.preventUnwantedNumberKeys)(e);
        }
      }),
      _react2.default.createElement(
        StartEndTimeLabel,
        null,
        'End Time'
      ),
      _react2.default.createElement(TimeInput, {
        type: 'number',
        min: '0',
        onChange: function onChange(event) {
          return props.setEndTimeMinutes(event.target.value);
        },
        placeholder: 'Min',
        defaultValue: props.endTimeMinutes,
        onKeyDown: function onKeyDown(e) {
          return (0, _resources.preventUnwantedNumberKeys)(e);
        }
      }),
      _react2.default.createElement(
        Colon,
        null,
        ':'
      ),
      _react2.default.createElement(TimeInput, {
        type: 'number',
        min: '0',
        max: '59',
        onChange: function onChange(event) {
          return props.setEndTimeSeconds(event.target.value);
        },
        onInput: function onInput(e) {
          return (0, _resources.validateSecondsInput)(e);
        },
        placeholder: 'Sec',
        defaultValue: props.endTimeSeconds,
        onKeyDown: function onKeyDown(e) {
          return (0, _resources.preventUnwantedNumberKeys)(e);
        }
      })
    )
  );
};

YoutubeTrimmer.propTypes = {
  startTimeMinutes: _propTypes2.default.number,
  startTimeSeconds: _propTypes2.default.number,
  endTimeMinutes: _propTypes2.default.number,
  endTimeSeconds: _propTypes2.default.number,
  setStartTimeMinutes: _propTypes2.default.func.isRequired,
  setStartTimeSeconds: _propTypes2.default.func.isRequired,
  setEndTimeMinutes: _propTypes2.default.func.isRequired,
  setEndTimeSeconds: _propTypes2.default.func.isRequired
};

exports.default = YoutubeTrimmer;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActivityResource = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchActivityResource = exports.fetchActivityResource = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(orgId, questId, activityId, resourceId, token) {
    var url, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = (0, _utils.getApiBaseUrlWithOrg)(orgId) + '/quests/' + questId + '/activities/' + activityId + '/resources/' + resourceId;
            _context.t0 = _utils.checkHttpStatus;
            _context.next = 4;
            return fetch(url, {
              method: 'GET',
              headers: (0, _utils.getApiHeadersFromToken)(token)
            });

          case 4:
            _context.t1 = _context.sent;
            response = (0, _context.t0)(_context.t1);
            return _context.abrupt('return', response.json());

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchActivityResource(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoQuestsAssignedToYou = function NoQuestsAssignedToYou() {
  return _react2.default.createElement(
    'div',
    { className: 'no-assignments' },
    _react2.default.createElement('div', { className: 'assignment-flag' }),
    _react2.default.createElement(
      'div',
      { className: 'top' },
      _react2.default.createElement('div', { className: 'arrow' }),
      _react2.default.createElement('div', { className: 'smiley' }),
      _react2.default.createElement(
        'h3',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'NoAssignments',
          defaultMessage: 'No quests are assigned to you right now.'
        })
      )
    )
  );
};

exports.default = NoQuestsAssignedToYou;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sort = function Sort(props) {
  return _react2.default.createElement(
    'div',
    { className: 'sort' },
    props.sort === props.desc ? _react2.default.createElement(
      'div',
      {
        className: 'newest-at-top',
        onClick: props.onClick,
        'data-ref': props.asc
      },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'MyQuests.NewestAtTop',
        defaultMessage: 'NEWEST AT TOP'
      }),
      _react2.default.createElement('div', { className: 'caret caret-up' })
    ) : _react2.default.createElement(
      'div',
      {
        className: 'oldest-at-top',
        onClick: props.onClick,
        'data-ref': props.desc
      },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'MyQuests.OldestAtTop',
        defaultMessage: 'OLDEST AT TOP'
      }),
      _react2.default.createElement('div', { className: 'caret caret-down' })
    )
  );
};

Sort.propTypes = {
  sort: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  asc: _propTypes2.default.string.isRequired,
  desc: _propTypes2.default.string.isRequired
};

exports.default = Sort;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalContainer = exports.NameContainer = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n  display: flex;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n'], ['\n  height: 100%;\n  display: flex;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n  width: 70px;\n  margin-right: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 70px;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n'], ['\n  height: 100%;\n  width: 70px;\n  margin-right: 68px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 70px;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameContainer = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__NameContainer',
  componentId: 'ruzcbu-0'
})(_templateObject);

var TotalContainer = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__TotalContainer',
  componentId: 'ruzcbu-1'
})(_templateObject2);

exports.NameContainer = NameContainer;
exports.TotalContainer = TotalContainer;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

var _interopRequireWildcard = __webpack_require__(674);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(1710));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');

exports.default = _default;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 8px;\n  width: ', ';\n  border-radius: 5px;\n  background-color: ', ';\n  overflow: hidden;\n  position: relative;\n  margin: 0 22px;\n'], ['\n  height: 8px;\n  width: ', ';\n  border-radius: 5px;\n  background-color: ', ';\n  overflow: hidden;\n  position: relative;\n  margin: 0 22px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: inherit;\n  width: ', '%;\n  background: ', ';\n'], ['\n  height: inherit;\n  width: ', '%;\n  background: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyBar = _styledComponents2.default.div.withConfig({
  displayName: 'ProgressBar__EmptyBar',
  componentId: 'sc-1r62u9d-0'
})(_templateObject, function (props) {
  return props.progressBarWidth ? props.progressBarWidth : '88px';
}, _colors2.default.ash);

var ProgressBarContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ProgressBar__ProgressBarContainer',
  componentId: 'sc-1r62u9d-1'
})(_templateObject2, function (props) {
  return props.progress.length < 1 ? '1px' : props.progress;
}, _colors2.default.jade);

var ProgressBar = exports.ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
      progressBarWidth = _ref.progressBarWidth;

  return _react2.default.createElement(
    EmptyBar,
    { progressBarWidth: progressBarWidth },
    _react2.default.createElement(ProgressBarContainer, { progress: progress })
  );
};

ProgressBar.propTypes = {
  progress: _propTypes2.default.number.isRequired,
  progressBarWidth: _propTypes2.default.string
};

exports.default = ProgressBar;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublishLabel = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n background: ', ';\n color: ', ';\n border-radius: 4px;\n padding: 5px 12px;\n width: min-content;\n'], ['\n background: ', ';\n color: ', ';\n border-radius: 4px;\n padding: 5px 12px;\n width: min-content;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PublishLabel__LabelContainer',
  componentId: 'xze8k5-0'
})(_templateObject, function (props) {
  return props.isPublished ? 'none' : _colors2.default.aluminum;
}, function (props) {
  return props.isPublished ? _colors2.default.jade : _colors2.default.white;
});

var PublishLabel = exports.PublishLabel = function PublishLabel(_ref) {
  var isPublished = _ref.isPublished;

  return _react2.default.createElement(
    LabelContainer,
    { isPublished: isPublished },
    isPublished !== null && isPublished ? 'Published' : 'Draft'
  );
};

PublishLabel.propTypes = {
  isPublished: _propTypes2.default.bool.isRequired
};

exports.default = PublishLabel;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  display: flex;\n  justify-content: ', ';\n  margin-right: ', ';\n'], ['\n  width: ', ';\n  display: flex;\n  justify-content: ', ';\n  margin-right: ', ';\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixedAlignmentBox = _styledComponents2.default.div.withConfig({
  displayName: 'FixedAlignmentBox',
  componentId: 'sc-1ltyzl-0'
})(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.justify || 'flex-start';
}, function (props) {
  return props.marginRight || 'none';
});

FixedAlignmentBox.propTypes = {
  width: _propTypes2.default.string.isRequired,
  justify: _propTypes2.default.string,
  marginRight: _propTypes2.default.string
};

exports.default = FixedAlignmentBox;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsLevelExpanded = exports.useIsCourseExpanded = undefined;

var _reactRedux = __webpack_require__(14);

var useIsCourseExpanded = exports.useIsCourseExpanded = function useIsCourseExpanded(activityCourse) {
  return (0, _reactRedux.useSelector)(function (state) {
    return state.mycourses.expandedCourses.includes(activityCourse.id);
  });
};

var useIsLevelExpanded = exports.useIsLevelExpanded = function useIsLevelExpanded(level) {
  return (0, _reactRedux.useSelector)(function (state) {
    return state.mycourses.expandedLevels.includes(level.id);
  });
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 88%;\n  max-width: 1200px;\n  margin: auto;\n'], ['\n  width: 88%;\n  max-width: 1200px;\n  margin: auto;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponsiveContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ResponsiveContainer',
  componentId: 'sc-14i8ilr-0'
})(_templateObject);

exports.default = ResponsiveContainer;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 13px;\n  width: 16px;\n  margin-right: 11px;\n'], ['\n  background-image: url(', ');\n  height: 13px;\n  width: 16px;\n  margin-right: 11px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 20px;\n  left: 100px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: #444444;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 500;\n\n  &:hover ', ' {\n    background-image: url(', ');\n  }\n'], ['\n  position: absolute;\n  top: 20px;\n  left: 100px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: #444444;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 500;\n\n  &:hover ', ' {\n    background-image: url(', ');\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BackButton = __webpack_require__(1722);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _BackButtonHover = __webpack_require__(1723);

var _BackButtonHover2 = _interopRequireDefault(_BackButtonHover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackIcon = _styledComponents2.default.div.withConfig({
  displayName: 'BackButton__BackIcon',
  componentId: 'sc-1gcekqh-0'
})(_templateObject, _BackButton2.default);

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'BackButton__Wrapper',
  componentId: 'sc-1gcekqh-1'
})(_templateObject2, BackIcon, _BackButtonHover2.default);

var BackButton = function BackButton(_ref) {
  var backToWhere = _ref.backToWhere,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    Wrapper,
    { onClick: onClick },
    _react2.default.createElement(BackIcon, null),
    'Back to ',
    backToWhere
  );
};

BackButton.propTypes = {
  backToWhere: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = BackButton;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTheActivityType = exports.getTheActivityType = function getTheActivityType(activity) {
  var type = {};
  if (activity.checkpoint === true && activity.work_product === true) {
    type = { id: 1, name: 'Artifact Required / Check-in', label: 'Artifact Required / Check-in', sort_order: 0 };
  } else if (activity.checkpoint === true) {
    type = { id: 2, name: 'Check-in Only', label: 'Check-in Only', sort_order: 1 };
  } else if (!activity.checkpoint && !activity.work_product) {
    type = { id: 3, name: 'No Check-in', label: 'No Check-in', sort_order: 2 };
  }
  return type;
};

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTQgMTQiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiMwMDcwRTA7fTwvc3R5bGU+PHBhdGggaWQ9IkxheWVyXzEtMiIgY2xhc3M9InN0MCIgZD0iTTAgMTRsMS4xLTMuMSA4LjEtOC4xLjUuNSAxLjYgMS42LTguMSA4LjEtMy4yIDF6Ii8+PHBhdGggY2xhc3M9InN0MCIgZD0iTTEyLjQ1IDMuNTVsLTItMiAxLjEtMS4xYy42LS42IDEuNS0uNiAyIDAgLjYuNi42IDEuNSAwIDJsLTEuMSAxLjF6Ii8+PC9zdmc+"

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(732);


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

__webpack_require__(740);

__webpack_require__(942);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactRouter = __webpack_require__(201);

var _reactRouterRedux = __webpack_require__(23);

var _configureStore = __webpack_require__(964);

var _configureStore2 = _interopRequireDefault(_configureStore);

__webpack_require__(1099);

var _Root = __webpack_require__(1100);

var _Root2 = _interopRequireDefault(_Root);

var _reactIntl = __webpack_require__(16);

var _en = __webpack_require__(1746);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(1747);

var _es2 = _interopRequireDefault(_es);

var _en3 = __webpack_require__(1748);

var _en4 = _interopRequireDefault(_en3);

var _es3 = __webpack_require__(1749);

var _es4 = _interopRequireDefault(_es3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Our translated strings
(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray3.default)(_en2.default), (0, _toConsumableArray3.default)(_es2.default)));

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them


// Internationalization
var language = navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;

// Split locales with a region code
var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

// Try full locale, try locale without region code, fallback to 'en'
var messages = languageWithoutRegionCode === 'en' || language === 'en' ? _en4.default : _es4.default;

var store = (0, _configureStore2.default)();
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
var MOUNT_NODE = document.getElementById('root');

var render = function render() {
  (0, _reactDom.render)(_react2.default.createElement(
    _reactIntl.IntlProvider,
    { locale: navigator.language, messages: messages },
    _react2.default.createElement(_Root2.default, { store: store, history: history })
  ), MOUNT_NODE);
};

// Development Tools
// ------------------------------------
if (false) {
  // why-did-you-update perf monitoring
  // let createClass = React.createClass
  // Object.defineProperty(React, 'createClass', {
  //   set: (nextCreateClass) => {
  //     createClass = nextCreateClass
  //   }
  // })
  // console.log('wrapping with whyDidYouUpdate')
  // const { whyDidYouUpdate } = require('why-did-you-update')
  // whyDidYouUpdate(React, { exclude: /^Connect/ })

  if (module.hot) {
    var renderApp = render;
    var renderError = function renderError(error) {
      var RedBox = require('redbox-react').default;

      (0, _reactDom.render)(_react2.default.createElement(RedBox, { error: error }), MOUNT_NODE);
    };

    render = function render() {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    if (module.hot) {
      module.hot.accept();
    }
  }
}

// Let's Go!
// ------------------------------------
if (!"production" !== 'test') render();

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(223);
__webpack_require__(738);
module.exports = __webpack_require__(43).Array.from;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(346);
var defined = __webpack_require__(347);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(350);
var descriptor = __webpack_require__(225);
var setToStringTag = __webpack_require__(278);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(169)(IteratorPrototype, __webpack_require__(82)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(171);
var toLength = __webpack_require__(351);
var toAbsoluteIndex = __webpack_require__(737);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(346);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(192);
var $export = __webpack_require__(70);
var toObject = __webpack_require__(196);
var call = __webpack_require__(493);
var isArrayIter = __webpack_require__(494);
var toLength = __webpack_require__(351);
var createProperty = __webpack_require__(739);
var getIterFn = __webpack_require__(355);

$export($export.S + $export.F * !__webpack_require__(495)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(132);
var createDesc = __webpack_require__(225);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(741);

__webpack_require__(938);

__webpack_require__(939);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(742);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(377);
__webpack_require__(846);
__webpack_require__(515);
__webpack_require__(847);
__webpack_require__(516);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(519);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
module.exports = __webpack_require__(105);


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(29);
var has = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(49);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(88);
var META = __webpack_require__(152).KEY;
var $fails = __webpack_require__(31);
var shared = __webpack_require__(227);
var setToStringTag = __webpack_require__(197);
var uid = __webpack_require__(173);
var wks = __webpack_require__(44);
var wksExt = __webpack_require__(497);
var wksDefine = __webpack_require__(358);
var enumKeys = __webpack_require__(744);
var isArray = __webpack_require__(281);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(33);
var toObject = __webpack_require__(54);
var toIObject = __webpack_require__(95);
var toPrimitive = __webpack_require__(120);
var createDesc = __webpack_require__(172);
var _create = __webpack_require__(176);
var gOPNExt = __webpack_require__(500);
var $GOPD = __webpack_require__(96);
var $GOPS = __webpack_require__(280);
var $DP = __webpack_require__(51);
var $keys = __webpack_require__(174);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(177).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(229).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(151)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(87)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(227)('native-function-to-string', Function.toString);


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(174);
var gOPS = __webpack_require__(280);
var pIE = __webpack_require__(229);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(176) });


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(49), 'Object', { defineProperty: __webpack_require__(51).f });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(49), 'Object', { defineProperties: __webpack_require__(499) });


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(95);
var $getOwnPropertyDescriptor = __webpack_require__(96).f;

__webpack_require__(122)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(54);
var $getPrototypeOf = __webpack_require__(97);

__webpack_require__(122)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(54);
var $keys = __webpack_require__(174);

__webpack_require__(122)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(122)('getOwnPropertyNames', function () {
  return __webpack_require__(500).f;
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(152).onFreeze;

__webpack_require__(122)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(152).onFreeze;

__webpack_require__(122)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(152).onFreeze;

__webpack_require__(122)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(33);

__webpack_require__(122)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(33);

__webpack_require__(122)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(33);

__webpack_require__(122)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(10);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(501) });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { is: __webpack_require__(502) });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(362).set });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(198);
var test = {};
test[__webpack_require__(44)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(88)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(10);

$export($export.P, 'Function', { bind: __webpack_require__(503) });


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(51).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(49) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(33);
var getPrototypeOf = __webpack_require__(97);
var HAS_INSTANCE = __webpack_require__(44)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(51).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(505);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(506);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(29);
var has = __webpack_require__(94);
var cof = __webpack_require__(107);
var inheritIfRequired = __webpack_require__(364);
var toPrimitive = __webpack_require__(120);
var fails = __webpack_require__(31);
var gOPN = __webpack_require__(177).f;
var gOPD = __webpack_require__(96).f;
var dP = __webpack_require__(51).f;
var $trim = __webpack_require__(199).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(176)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(49) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(88)(global, NUMBER, $Number);
}


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toInteger = __webpack_require__(108);
var aNumberValue = __webpack_require__(507);
var repeat = __webpack_require__(365);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(31)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $fails = __webpack_require__(31);
var aNumberValue = __webpack_require__(507);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(10);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(10);
var _isFinite = __webpack_require__(29).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', { isInteger: __webpack_require__(508) });


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(10);
var isInteger = __webpack_require__(508);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(506);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(505);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(10);
var log1p = __webpack_require__(509);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(10);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(10);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(10);
var sign = __webpack_require__(366);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(10);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(10);
var $expm1 = __webpack_require__(367);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { fround: __webpack_require__(510) });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(10);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(10);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(31)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { log1p: __webpack_require__(509) });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { sign: __webpack_require__(366) });


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(367);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(31)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(367);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(175);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(95);
var toLength = __webpack_require__(46);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(199)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(282)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(368)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $at = __webpack_require__(282)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(46);
var context = __webpack_require__(370);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(371)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(10);
var context = __webpack_require__(370);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(371)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(365)
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(46);
var context = __webpack_require__(370);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(371)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(89)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(89)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(89)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(89)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(89)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(89)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(89)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(89)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(89)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(89)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(89)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(89)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(89)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(10);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var toPrimitive = __webpack_require__(120);

$export($export.P + $export.F * __webpack_require__(31)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(10);
var toISOString = __webpack_require__(821);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(31);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(88)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(44)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(87)(proto, TO_PRIMITIVE, __webpack_require__(824));


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(120);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(10);

$export($export.S, 'Array', { isArray: __webpack_require__(281) });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(106);
var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var call = __webpack_require__(511);
var isArrayIter = __webpack_require__(372);
var toLength = __webpack_require__(46);
var createProperty = __webpack_require__(373);
var getIterFn = __webpack_require__(374);

$export($export.S + $export.F * !__webpack_require__(284)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var createProperty = __webpack_require__(373);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(31)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(10);
var toIObject = __webpack_require__(95);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(228) != Object || !__webpack_require__(109)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var html = __webpack_require__(361);
var cof = __webpack_require__(107);
var toAbsoluteIndex = __webpack_require__(175);
var toLength = __webpack_require__(46);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(31)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var aFunction = __webpack_require__(71);
var toObject = __webpack_require__(54);
var fails = __webpack_require__(31);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(109)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $forEach = __webpack_require__(123)(0);
var STRICT = __webpack_require__(109)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var isArray = __webpack_require__(281);
var SPECIES = __webpack_require__(44)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $map = __webpack_require__(123)(1);

$export($export.P + $export.F * !__webpack_require__(109)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $filter = __webpack_require__(123)(2);

$export($export.P + $export.F * !__webpack_require__(109)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $some = __webpack_require__(123)(3);

$export($export.P + $export.F * !__webpack_require__(109)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $every = __webpack_require__(123)(4);

$export($export.P + $export.F * !__webpack_require__(109)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(512);

$export($export.P + $export.F * !__webpack_require__(109)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(512);

$export($export.P + $export.F * !__webpack_require__(109)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $indexOf = __webpack_require__(279)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(109)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(95);
var toInteger = __webpack_require__(108);
var toLength = __webpack_require__(46);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(109)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { copyWithin: __webpack_require__(513) });

__webpack_require__(153)('copyWithin');


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { fill: __webpack_require__(376) });

__webpack_require__(153)('fill');


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(123)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(153)(KEY);


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(123)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(153)(KEY);


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178)('Array');


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(29);
var inheritIfRequired = __webpack_require__(364);
var dP = __webpack_require__(51).f;
var gOPN = __webpack_require__(177).f;
var isRegExp = __webpack_require__(283);
var $flags = __webpack_require__(230);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(49) && (!CORRECT_NEW || __webpack_require__(31)(function () {
  re2[__webpack_require__(44)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(88)(global, 'RegExp', $RegExp);
}

__webpack_require__(178)('RegExp');


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(516);
var anObject = __webpack_require__(24);
var $flags = __webpack_require__(230);
var DESCRIPTORS = __webpack_require__(49);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(88)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(31)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(24);
var toLength = __webpack_require__(46);
var advanceStringIndex = __webpack_require__(379);
var regExpExec = __webpack_require__(285);

// @@match logic
__webpack_require__(286)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(24);
var toObject = __webpack_require__(54);
var toLength = __webpack_require__(46);
var toInteger = __webpack_require__(108);
var advanceStringIndex = __webpack_require__(379);
var regExpExec = __webpack_require__(285);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(286)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(24);
var sameValue = __webpack_require__(502);
var regExpExec = __webpack_require__(285);

// @@search logic
__webpack_require__(286)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(283);
var anObject = __webpack_require__(24);
var speciesConstructor = __webpack_require__(231);
var advanceStringIndex = __webpack_require__(379);
var toLength = __webpack_require__(46);
var callRegExpExec = __webpack_require__(285);
var regexpExec = __webpack_require__(378);
var fails = __webpack_require__(31);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(286)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(151);
var global = __webpack_require__(29);
var ctx = __webpack_require__(106);
var classof = __webpack_require__(198);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(33);
var aFunction = __webpack_require__(71);
var anInstance = __webpack_require__(179);
var forOf = __webpack_require__(180);
var speciesConstructor = __webpack_require__(231);
var task = __webpack_require__(380).set;
var microtask = __webpack_require__(381)();
var newPromiseCapabilityModule = __webpack_require__(382);
var perform = __webpack_require__(517);
var userAgent = __webpack_require__(287);
var promiseResolve = __webpack_require__(518);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(44)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(181)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(197)($Promise, PROMISE);
__webpack_require__(178)(PROMISE);
Wrapper = __webpack_require__(105)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(284)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(523);
var validate = __webpack_require__(182);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(288)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $typed = __webpack_require__(289);
var buffer = __webpack_require__(383);
var anObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(175);
var toLength = __webpack_require__(46);
var isObject = __webpack_require__(33);
var ArrayBuffer = __webpack_require__(29).ArrayBuffer;
var speciesConstructor = __webpack_require__(231);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(31)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(178)(ARRAY_BUFFER);


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
$export($export.G + $export.W + $export.F * !__webpack_require__(289).ABV, {
  DataView: __webpack_require__(383).DataView
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(10);
var aFunction = __webpack_require__(71);
var anObject = __webpack_require__(24);
var rApply = (__webpack_require__(29).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(31)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(10);
var create = __webpack_require__(176);
var aFunction = __webpack_require__(71);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(33);
var fails = __webpack_require__(31);
var bind = __webpack_require__(503);
var rConstruct = (__webpack_require__(29).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(51);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(120);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(31)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(10);
var gOPD = __webpack_require__(96).f;
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(24);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(369)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(97);
var has = __webpack_require__(94);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(24);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(96);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(10);
var getProto = __webpack_require__(97);
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(24);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(525) });


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(24);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(51);
var gOPD = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(97);
var has = __webpack_require__(94);
var $export = __webpack_require__(10);
var createDesc = __webpack_require__(172);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(33);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(10);
var setProto = __webpack_require__(362);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(10);
var $includes = __webpack_require__(279)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(153)('includes');


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(526);
var toObject = __webpack_require__(54);
var toLength = __webpack_require__(46);
var aFunction = __webpack_require__(71);
var arraySpeciesCreate = __webpack_require__(375);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(153)('flatMap');


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(526);
var toObject = __webpack_require__(54);
var toLength = __webpack_require__(46);
var toInteger = __webpack_require__(108);
var arraySpeciesCreate = __webpack_require__(375);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(153)('flatten');


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(10);
var $at = __webpack_require__(282)(true);
var $fails = __webpack_require__(31);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(10);
var $pad = __webpack_require__(527);
var userAgent = __webpack_require__(287);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(10);
var $pad = __webpack_require__(527);
var userAgent = __webpack_require__(287);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(199)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(199)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(10);
var defined = __webpack_require__(121);
var toLength = __webpack_require__(46);
var isRegExp = __webpack_require__(283);
var getFlags = __webpack_require__(230);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(369)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(358)('asyncIterator');


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(358)('observable');


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(10);
var ownKeys = __webpack_require__(525);
var toIObject = __webpack_require__(95);
var gOPD = __webpack_require__(96);
var createProperty = __webpack_require__(373);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $values = __webpack_require__(528)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $entries = __webpack_require__(528)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var aFunction = __webpack_require__(71);
var $defineProperty = __webpack_require__(51);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(49) && $export($export.P + __webpack_require__(290), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var aFunction = __webpack_require__(71);
var $defineProperty = __webpack_require__(51);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(49) && $export($export.P + __webpack_require__(290), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var toPrimitive = __webpack_require__(120);
var getPrototypeOf = __webpack_require__(97);
var getOwnPropertyDescriptor = __webpack_require__(96).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(49) && $export($export.P + __webpack_require__(290), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(54);
var toPrimitive = __webpack_require__(120);
var getPrototypeOf = __webpack_require__(97);
var getOwnPropertyDescriptor = __webpack_require__(96).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(49) && $export($export.P + __webpack_require__(290), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(10);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(529)('Map') });


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(10);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(529)('Set') });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(291)('Map');


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(291)('Set');


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(291)('WeakMap');


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(291)('WeakSet');


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(292)('Map');


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(292)('Set');


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(292)('WeakMap');


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(292)('WeakSet');


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(10);

$export($export.G, { global: __webpack_require__(29) });


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(10);

$export($export.S, 'System', { global: __webpack_require__(29) });


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(10);
var cof = __webpack_require__(107);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var scale = __webpack_require__(531);
var fround = __webpack_require__(510);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(10);

$export($export.S, 'Math', { scale: __webpack_require__(531) });


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(10);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(10);
var core = __webpack_require__(105);
var global = __webpack_require__(29);
var speciesConstructor = __webpack_require__(231);
var promiseResolve = __webpack_require__(518);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(382);
var perform = __webpack_require__(517);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(97);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(521);
var from = __webpack_require__(530);
var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(97);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(97);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(135);
var anObject = __webpack_require__(24);
var aFunction = __webpack_require__(71);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(10);
var microtask = __webpack_require__(381)();
var process = __webpack_require__(29).process;
var isNode = __webpack_require__(107)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(10);
var global = __webpack_require__(29);
var core = __webpack_require__(105);
var microtask = __webpack_require__(381)();
var OBSERVABLE = __webpack_require__(44)('observable');
var aFunction = __webpack_require__(71);
var anObject = __webpack_require__(24);
var anInstance = __webpack_require__(179);
var redefineAll = __webpack_require__(181);
var hide = __webpack_require__(87);
var forOf = __webpack_require__(180);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(178)('Observable');


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(29);
var $export = __webpack_require__(10);
var userAgent = __webpack_require__(287);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $task = __webpack_require__(380);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(377);
var getKeys = __webpack_require__(174);
var redefine = __webpack_require__(88);
var global = __webpack_require__(29);
var hide = __webpack_require__(87);
var Iterators = __webpack_require__(200);
var wks = __webpack_require__(44);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(940);
module.exports = __webpack_require__(105).RegExp.escape;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(10);
var $re = __webpack_require__(941)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(943);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(944);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 944 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(537);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(538);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = configureStore;

var _reducers = __webpack_require__(978);

var _reducers2 = _interopRequireDefault(_reducers);

var _reduxThunk = __webpack_require__(563);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = __webpack_require__(296);

var _reactRouter = __webpack_require__(201);

var _reactRouterRedux = __webpack_require__(23);

var _reduxLogger = __webpack_require__(1089);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxPersist = __webpack_require__(1094);

var _storages = __webpack_require__(1097);

var _constants = __webpack_require__(205);

var _reduxActionBuffer = __webpack_require__(1098);

var _reduxActionBuffer2 = _interopRequireDefault(_reduxActionBuffer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore(initialState) {
  var createStoreWithMiddleware = void 0;
  var logger = (0, _reduxLogger2.default)();
  var browserMiddleware = (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory);
  var middleware = void 0;
  if (false) {
    middleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, logger, browserMiddleware, (0, _reduxActionBuffer2.default)(_constants.REHYDRATE));
  } else {
    middleware = (0, _redux.applyMiddleware)(_reduxThunk2.default, browserMiddleware, (0, _reduxActionBuffer2.default)(_constants.REHYDRATE));
  }

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle, indent */
  var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // TODO Try to remove when `react-router-redux` is out of beta, LOCATION_CHANGE should not be fired more than once after hot reloading
    // Prevent recomputing reducers for `replaceReducer`
    shouldHotReload: false
  }) : _redux.compose;
  /* eslint-enable */

  createStoreWithMiddleware = composeEnhancers((0, _reduxPersist.autoRehydrate)(), middleware);

  var store = createStoreWithMiddleware(_redux.createStore)(_reducers2.default, initialState);

  (0, _reduxPersist.persistStore)(store, { storage: _storages.asyncSessionStorage, blacklist: ['routing'] });

  return store;
}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(966), __esModule: true };

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(223);
__webpack_require__(295);
module.exports = __webpack_require__(388).f('iterator');


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(968);
var step = __webpack_require__(969);
var Iterators = __webpack_require__(194);
var toIObject = __webpack_require__(171);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(485)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(971), __esModule: true };

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(972);
__webpack_require__(542);
__webpack_require__(976);
__webpack_require__(977);
module.exports = __webpack_require__(43).Symbol;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(81);
var has = __webpack_require__(170);
var DESCRIPTORS = __webpack_require__(104);
var $export = __webpack_require__(70);
var redefine = __webpack_require__(487);
var META = __webpack_require__(539).KEY;
var $fails = __webpack_require__(193);
var shared = __webpack_require__(353);
var setToStringTag = __webpack_require__(278);
var uid = __webpack_require__(277);
var wks = __webpack_require__(82);
var wksExt = __webpack_require__(388);
var wksDefine = __webpack_require__(389);
var enumKeys = __webpack_require__(973);
var isArray = __webpack_require__(974);
var anObject = __webpack_require__(119);
var isObject = __webpack_require__(133);
var toObject = __webpack_require__(196);
var toIObject = __webpack_require__(171);
var toPrimitive = __webpack_require__(349);
var createDesc = __webpack_require__(225);
var _create = __webpack_require__(350);
var gOPNExt = __webpack_require__(975);
var $GOPD = __webpack_require__(541);
var $GOPS = __webpack_require__(390);
var $DP = __webpack_require__(132);
var $keys = __webpack_require__(195);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(540).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(232).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(224)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(169)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(195);
var gOPS = __webpack_require__(390);
var pIE = __webpack_require__(232);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(226);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(171);
var gOPN = __webpack_require__(540).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(389)('asyncIterator');


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(389)('observable');


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(296);

var _reactRouterRedux = __webpack_require__(23);

var _account = __webpack_require__(979);

var _appupdate = __webpack_require__(1001);

var _artifacttypes = __webpack_require__(1002);

var _forgotpassword = __webpack_require__(1003);

var _frameworkskills = __webpack_require__(1004);

var _frameworksubjects = __webpack_require__(1005);

var _gradelevels = __webpack_require__(1010);

var _modal = __webpack_require__(1011);

var _mockcourses = __webpack_require__(1012);

var _mycourses = __webpack_require__(1013);

var _myquests = __webpack_require__(1014);

var _myquestsfilters = __webpack_require__(1017);

var _navigation = __webpack_require__(1018);

var _organization = __webpack_require__(1019);

var _organizations = __webpack_require__(1020);

var _policies = __webpack_require__(1021);

var _productionstatus = __webpack_require__(1022);

var _productionstatusfilters = __webpack_require__(554);

var _quest = __webpack_require__(1034);

var _quests = __webpack_require__(1072);

var _questsfilters = __webpack_require__(1073);

var _questtypes = __webpack_require__(1074);

var _queue = __webpack_require__(1075);

var _queuefilters = __webpack_require__(1076);

var _resetpassword = __webpack_require__(1077);

var _unlockaccount = __webpack_require__(1078);

var _reviewqueue = __webpack_require__(1079);

var _reviewqueuefilters = __webpack_require__(1080);

var _subjects = __webpack_require__(1081);

var _tags = __webpack_require__(1082);

var _topicclouds = __webpack_require__(1083);

var _topics = __webpack_require__(1084);

var _user = __webpack_require__(1085);

var _users = __webpack_require__(1088);

var appReducer = (0, _redux.combineReducers)({
  account: _account.account,
  appupdate: _appupdate.appupdate,
  artifacttypes: _artifacttypes.artifacttypes,
  forgotpassword: _forgotpassword.forgotpassword,
  frameworkskills: _frameworkskills.frameworkskills,
  frameworksubjects: _frameworksubjects.frameworksubjects,
  gradelevels: _gradelevels.gradelevels,
  mockcourses: _mockcourses.mockcourses,
  modal: _modal.modal,
  myquests: _myquests.myquests,
  mycourses: _mycourses.mycourses,
  myquestsfilters: _myquestsfilters.myquestsfilters,
  navigation: _navigation.navigation,
  organization: _organization.organization,
  organizations: _organizations.organizations,
  policies: _policies.policies,
  productionstatus: _productionstatus.productionstatus,
  productionstatusfilters: _productionstatusfilters.productionstatusfilters,
  quest: _quest.quest,
  quests: _quests.quests,
  questsfilters: _questsfilters.questsfilters,
  questtypes: _questtypes.questtypes,
  queue: _queue.queue,
  queuefilters: _queuefilters.queuefilters,
  resetpassword: _resetpassword.resetpassword,
  unlockaccount: _unlockaccount.unlockaccount,
  reviewqueue: _reviewqueue.reviewqueue,
  reviewqueuefilters: _reviewqueuefilters.reviewqueuefilters,
  subjects: _subjects.subjects,
  tags: _tags.tags,
  topicclouds: _topicclouds.topicclouds,
  topics: _topics.topics,
  user: _user.user,
  users: _users.users,
  routing: _reactRouterRedux.routerReducer
});

exports.default = function (state, action) {
  // super important, otherwise we got in weird states where
  // users see last logged-in users' stuff
  if (action.type === 'LOGOUT_USER') {
    state = undefined;
  }

  return appReducer(state, action);
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.account = account;

var _account = __webpack_require__(297);

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isChangingPassword: false,
  passwordChangeSuccess: false,
  passwordChangeFailure: false
};

function account() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _account.CHANGE_PASSWORD_RESET:
      return (0, _assign2.default)({}, state, initialState);
    case _account.CHANGE_PASSWORD_REQUEST:
      return (0, _assign2.default)({}, state, {
        isChangingPassword: true,
        passwordChangeSuccess: false,
        passwordChangeFailure: false
      });
    case _account.CHANGE_PASSWORD_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isChangingPassword: false,
        passwordChangeSuccess: true,
        passwordChangeFailure: false
      });
    case _account.CHANGE_PASSWORD_FAILURE:
      return (0, _assign2.default)({}, state, {
        isChangingPassword: false,
        passwordChangeSuccess: false,
        passwordChangeFailure: true
      });
    case _reactRouterRedux.LOCATION_CHANGE:
      return (0, _assign2.default)({}, state, initialState);
    default:
      return state;
  }
}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(981);
module.exports = __webpack_require__(43).Object.assign;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(70);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(982) });


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(104);
var getKeys = __webpack_require__(195);
var gOPS = __webpack_require__(390);
var pIE = __webpack_require__(232);
var toObject = __webpack_require__(196);
var IObject = __webpack_require__(490);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(193)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(984);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 984 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(43);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(542);
__webpack_require__(223);
__webpack_require__(295);
__webpack_require__(987);
__webpack_require__(995);
__webpack_require__(996);
module.exports = __webpack_require__(43).Promise;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(224);
var global = __webpack_require__(81);
var ctx = __webpack_require__(192);
var classof = __webpack_require__(356);
var $export = __webpack_require__(70);
var isObject = __webpack_require__(133);
var aFunction = __webpack_require__(276);
var anInstance = __webpack_require__(988);
var forOf = __webpack_require__(989);
var speciesConstructor = __webpack_require__(543);
var task = __webpack_require__(544).set;
var microtask = __webpack_require__(991)();
var newPromiseCapabilityModule = __webpack_require__(391);
var perform = __webpack_require__(545);
var userAgent = __webpack_require__(992);
var promiseResolve = __webpack_require__(546);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(82)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(993)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(278)($Promise, PROMISE);
__webpack_require__(994)(PROMISE);
Wrapper = __webpack_require__(43)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(495)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(192);
var call = __webpack_require__(493);
var isArrayIter = __webpack_require__(494);
var anObject = __webpack_require__(119);
var toLength = __webpack_require__(351);
var getIterFn = __webpack_require__(355);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(81);
var macrotask = __webpack_require__(544).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(226)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(81);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(169);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(81);
var core = __webpack_require__(43);
var dP = __webpack_require__(132);
var DESCRIPTORS = __webpack_require__(104);
var SPECIES = __webpack_require__(82)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(70);
var core = __webpack_require__(43);
var global = __webpack_require__(81);
var speciesConstructor = __webpack_require__(543);
var promiseResolve = __webpack_require__(546);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(70);
var newPromiseCapability = __webpack_require__(391);
var perform = __webpack_require__(545);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 997 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)

    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var list = this.map[name]
    if (!list) {
      list = []
      this.map[name] = list
    }
    list.push(value)
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    var values = this.map[normalizeName(name)]
    return values ? values[0] : null
  }

  Headers.prototype.getAll = function(name) {
    return this.map[normalizeName(name)] || []
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = [normalizeValue(value)]
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    Object.getOwnPropertyNames(this.map).forEach(function(name) {
      this.map[name].forEach(function(value) {
        callback.call(thisArg, value, name, this)
      }, this)
    }, this)
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (typeof input === 'string') {
      this.url = input
    } else {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split('\r\n').forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(999), __esModule: true };

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1000);
module.exports = __webpack_require__(43).Math.trunc;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(70);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.appupdate = appupdate;

var _appupdate = __webpack_require__(547);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  appUpdateAvailable: false
};

function appupdate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _appupdate.APP_UPDATE_AVAILABLE:
      return (0, _assign2.default)({}, state, {
        appUpdateAvailable: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.artifacttypes = artifacttypes;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function artifacttypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var artifactTypesArray = [];
        action.payload.manifest.artifact_types.forEach(function (at) {
          artifactTypesArray.push(at);
        });

        return (0, _assign2.default)({}, state, {
          items: artifactTypesArray,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.forgotpassword = forgotpassword;

var _reactRouterRedux = __webpack_require__(23);

var _forgotpassword = __webpack_require__(548);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isSendingRequest: false,
  hasSentRequest: false
};

function forgotpassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _forgotpassword.FORGOT_PASSWORD_REQUEST:
      return (0, _assign2.default)({}, state, {
        isSendingRequest: true
      });
    case _forgotpassword.FORGOT_PASSWORD_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isSendingRequest: false,
        hasSentRequest: true
      });
    case _reactRouterRedux.LOCATION_CHANGE:
      return (0, _assign2.default)({}, state, {
        isSendingRequest: false,
        hasSentRequest: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.frameworkskills = frameworkskills;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: [],
  skillGroups: []
};

function frameworkskills() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: [],
          skillGroups: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var frameworkSkillsArray = [].concat((0, _toConsumableArray3.default)(action.payload.manifest.framework_skills));
        var frameworkSkillGroups = [].concat((0, _toConsumableArray3.default)(action.payload.manifest.framework_skill_groups));

        return (0, _assign2.default)({}, state, {
          items: frameworkSkillsArray,
          skillGroups: frameworkSkillGroups,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: [],
          skillGroups: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(233);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.frameworksubjects = frameworksubjects;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function frameworksubjects() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var frameworkSubjects = (0, _assign2.default)({}, action.payload.manifest.framework_subjects);
        var frameworkSubjectsArray = [];
        for (var i = 0; i < (0, _keys2.default)(frameworkSubjects).length; i++) {
          frameworkSubjectsArray.push({
            id: (0, _values2.default)(frameworkSubjects)[i].id,
            name: (0, _values2.default)(frameworkSubjects)[i].name,
            framework_type: (0, _values2.default)(frameworkSubjects)[i].framework_type
          });
        }

        return (0, _assign2.default)({}, state, {
          items: frameworkSubjectsArray,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1007);
module.exports = __webpack_require__(43).Object.values;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(70);
var $values = __webpack_require__(549)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1009);
module.exports = __webpack_require__(43).Object.keys;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(196);
var $keys = __webpack_require__(195);

__webpack_require__(392)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(233);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.gradelevels = gradelevels;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function gradelevels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var gradeLevels = (0, _assign2.default)({}, action.payload.manifest.grade_levels);
        var gradeLevelsArray = [];
        for (var i = 0; i < (0, _keys2.default)(gradeLevels).length; i++) {
          gradeLevelsArray.push({
            id: parseInt((0, _keys2.default)(gradeLevels)[i]),
            name: (0, _values2.default)(gradeLevels)[i].name,
            sort: (0, _values2.default)(gradeLevels)[i].sort_order,
            available_for_activity_courses: (0, _values2.default)(gradeLevels)[i].available_for_activity_courses,
            abbreviation: (0, _values2.default)(gradeLevels)[i].abbreviation
          });
        }
        return (0, _assign2.default)({}, state, {
          items: gradeLevelsArray,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.modal = modal;

var _modal = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isViewingReadabilityScoresModal: false,
  modalType: null,
  modalProps: {}
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _modal.IS_VIEWING_READABILITY_SCORES_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          isViewingReadabilityScoresModal: true
        });
      }

    case _modal.IS_NOT_VIEWING_READABILITY_SCORES_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          isViewingReadabilityScoresModal: false
        });
      }

    case _modal.SHOW_MODAL:
      return {
        modalType: action.payload.modalType,
        modalProps: action.payload.modalProps
      };

    case _modal.HIDE_MODAL:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.mockcourses = mockcourses;

var _mockcourses = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function mockcourses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _mockcourses.FETCH_MOCK_COURSES_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _mockcourses.FETCH_MOCK_COURSES_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: action.payload.courses
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.mycourses = mycourses;

var _mycourses = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  selectedAcademicYearGlobally: null,
  expandedCourses: [],
  expandedLevels: []
};

var updateExpandedList = function updateExpandedList(expanded, payload) {
  var newList = void 0;
  if (payload.isExpanded) {
    newList = [].concat((0, _toConsumableArray3.default)(expanded));
    if (!newList.includes(payload.id)) newList.push(payload.id);
  } else {
    newList = expanded.filter(function (i) {
      return i != payload.id;
    });
  }
  return newList;
};

function mycourses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _mycourses.SET_SELECTED_ACADEMIC_YEAR_GLOBALLY:
      return (0, _assign2.default)({}, state, {
        selectedAcademicYearGlobally: action.payload.academicYear
      });
    case _mycourses.SET_COURSE_IS_EXPANDED:
      var ec = updateExpandedList(state.expandedCourses, action.payload);
      return (0, _assign2.default)({}, state, {
        expandedCourses: ec
      });
    case _mycourses.SET_LEVEL_IS_EXPANDED:
      var el = updateExpandedList(state.expandedLevels, action.payload);
      return (0, _assign2.default)({}, state, {
        expandedLevels: el
      });
    case _mycourses.CLEAR_EXPANDED_LEVELS:
      return (0, _assign2.default)({}, state, {
        expandedLevels: []
      });
    default:
      return state;
  }
}

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.myquests = myquests;

var _myquests = __webpack_require__(298);

var _organization = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  filter: 'drafts',
  sort: 'updated_at desc',
  quests: [],
  isFetchingQuests: false,
  page: null,
  total: null
};

function myquests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _myquests.SET_MY_QUESTS_FILTER:
      {
        return (0, _assign2.default)({}, state, {
          filter: action.filter
        });
      }

    case _myquests.SET_MY_QUESTS_SORT:
      {
        return (0, _assign2.default)({}, state, {
          sort: action.sort
        });
      }

    case _myquests.FETCH_MY_QUESTS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingQuests: true
        });
      }

    case _myquests.FETCH_MY_QUESTS_SUCCESS:
      {
        var quests = [];
        (0, _assign2.default)(quests, state.quests);

        action.payload.quests.forEach(function (item) {
          quests.push(item);
        });

        var idPositions = quests.map(function (item) {
          return item.id;
        });
        var newPayload = quests.filter(function (item, pos, arr) {
          return idPositions.indexOf(item.id) === pos;
        });

        return (0, _assign2.default)({}, state, {
          isFetchingQuests: false,
          quests: newPayload,
          page: action.payload.page,
          total: action.payload.total
        });
      }

    case _myquests.FETCH_MY_QUESTS_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingQuests: false,
          quests: [],
          page: null,
          total: null
        });
      }

    case _myquests.CLEAR_MY_QUESTS:
      {
        return (0, _assign2.default)({}, state, {
          quests: [],
          page: null,
          total: null
        });
      }

    case _organization.SET_CURRENT_ORGANIZATION:
      {
        return (0, _assign2.default)({}, state, {
          quests: [],
          page: null,
          total: null
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMyQuestsFilterQuery = getMyQuestsFilterQuery;
function getMyQuestsFilterQuery(state, orgId) {
  var query = {};

  query.organization_id_eq = orgId;

  if (state.myquestsfilters.authors_id_in.length > 0) {
    query.authors_id_in = state.myquestsfilters.authors_id_in;
  }

  if (state.myquestsfilters.reviewing_compiled_quest_state_in.length > 0) {
    query.reviewing_compiled_quest_state_in = state.myquestsfilters.reviewing_compiled_quest_state_in;
  }

  if (state.myquestsfilters.name_or_description_cont.trim() !== '') {
    query.name_or_description_cont = state.myquestsfilters.name_or_description_cont;
  }

  if (state.myquestsfilters.assigned_to_id_in.length > 0) {
    query.assigned_to_id_in = state.myquestsfilters.assigned_to_id_in;
  }

  if (state.myquestsfilters.quest_draft_or_state_in.length > 0) {
    query.quest_draft_or_state_in = state.myquestsfilters.quest_draft_or_state_in;
  }

  return query;
}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldFetchPolicies = shouldFetchPolicies;
function shouldFetchPolicies(state) {
  var policies = state.policies;
  if (policies.items.length === 0) {
    return true;
  }

  if (state.policies.isFetching) {
    return false;
  }

  return false;
}

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.myquestsfilters = myquestsfilters;

var _myquestsfilters = __webpack_require__(394);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  authors_id_in: [],
  quest_draft_or_state_in: [],
  reviewing_compiled_quest_state_in: [],
  name_or_description_cont: '',
  quest_subject_id_in: [],
  assigned_to_id_in: []
};

function myquestsfilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _myquestsfilters.SET_MY_QUESTS_AUTHOR_FILTER:
      return (0, _assign2.default)({}, state, {
        authors_id_in: action.authors_id_in
      });
    case _myquestsfilters.SET_MY_QUESTS_KEYWORD_FILTER:
      return (0, _assign2.default)({}, state, {
        name_or_description_cont: action.name_or_description_cont
      });
    case _myquestsfilters.SET_MY_QUESTS_DRAFT_FILTER:
      return (0, _assign2.default)({}, state, {
        quest_draft_or_state_in: action.quest_draft_or_state_in
      });
    case _myquestsfilters.SET_MY_QUESTS_STATUS_FILTER:
      return (0, _assign2.default)({}, state, {
        reviewing_compiled_quest_state_in: action.reviewing_compiled_quest_state_in
      });
    case _myquestsfilters.SET_MY_QUESTS_ASSIGNED_TO_FILTER:
      return (0, _assign2.default)({}, state, {
        assigned_to_id_in: action.assigned_to_id_in
      });
    default:
      return state;
  }
}

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.navigation = navigation;

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  currentPath: null
};

function navigation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reactRouterRedux.LOCATION_CHANGE:
      return (0, _assign2.default)({}, state, {
        currentPath: action.payload.pathname
      });
    default:
      return state;
  }
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.organization = organization;

var _organization = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  orgId: null,
  isChangingCurrentOrganization: false
};

function organization() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _organization.SET_CURRENT_ORGANIZATION:
      return (0, _assign2.default)({}, state, {
        orgId: action.orgId
      });
    case _organization.IS_CHANGING_CURRENT_ORGANIZATION:
      return (0, _assign2.default)({}, state, {
        isChangingCurrentOrganization: true
      });

    case _organization.IS_NOT_CHANGING_CURRENT_ORGANIZATION:
      return (0, _assign2.default)({}, state, {
        isChangingCurrentOrganization: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.organizations = organizations;

var _organizations = __webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function organizations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _organizations.FETCH_ORGANIZATIONS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _organizations.FETCH_ORGANIZATIONS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: action.organizations
      });
    case _organizations.FETCH_ORGANIZATIONS_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: []
      });
    default:
      return state;
  }
}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.policies = policies;

var _policies = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: [],
  policiesToAccept: [],
  showAcceptPoliciesModal: false,
  userIsConsideringDecliningPolicies: false
};

function policies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _policies.REQUEST_POLICIES:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _policies.RECEIVE_POLICIES:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: action.policies
      });
    case _policies.SET_POLICIES_TO_ACCEPT:
      return (0, _assign2.default)({}, state, {
        policiesToAccept: action.policiesToAccept
      });
    case _policies.UNSET_POLICIES_TO_ACCEPT:
      return (0, _assign2.default)({}, state, {
        policiesToAccept: []
      });
    case _policies.SHOW_ACCEPT_POLICIES_MODAL_REQUEST:
      return (0, _assign2.default)({}, state, {
        showAcceptPoliciesModal: true
      });
    case _policies.HIDE_ACCEPT_POLICIES_MODAL_REQUEST:
      return (0, _assign2.default)({}, state, {
        showAcceptPoliciesModal: false
      });
    case _policies.USER_IS_CONSIDERING_DECLINING_POLICIES:
      return (0, _assign2.default)({}, state, {
        userIsConsideringDecliningPolicies: true
      });
    case _policies.USER_IS_NOT_CONSIDERING_DECLINING_POLICIES:
      return (0, _assign2.default)({}, state, {
        userIsConsideringDecliningPolicies: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.productionstatus = productionstatus;

var _productionstatus = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetchingCounts: false,
  items: [],
  totalCounts: null
};

function productionstatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _productionstatus.FETCH_PRODUCTION_STATUS_COUNTS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetchingCounts: true,
        items: [],
        totalCounts: null
      });
    case _productionstatus.FETCH_PRODUCTION_STATUS_COUNTS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetchingCounts: false,
        items: action.payload.items,
        totalCounts: action.payload.totalCounts
      });
    default:
      return state;
  }
}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(1024);
var utils = __webpack_require__(552);
var formats = __webpack_require__(400);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    if (sideChannel.has(object)) {
        throw new RangeError('Cyclic object value');
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(398);
var callBound = __webpack_require__(1029);
var inspect = __webpack_require__(1031);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(1026);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(399);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(398);

var callBind = __webpack_require__(1030);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(399);
var GetIntrinsic = __webpack_require__(398);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = __webpack_require__(1032).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean') {
        throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(552);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(484);

var _from2 = _interopRequireDefault(_from);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.quest = quest;

var _comments = __webpack_require__(303);

var _quest2 = __webpack_require__(66);

var _topicclouds = __webpack_require__(239);

var _activity = __webpack_require__(240);

var _resource = __webpack_require__(557);

var _assignment = __webpack_require__(241);

var _approval = __webpack_require__(559);

var _review = __webpack_require__(159);

var _modal = __webpack_require__(26);

var _topics = __webpack_require__(238);

var _questskills = __webpack_require__(305);

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  item: null,
  activities: [],
  section: null,
  subsection: null,
  activityId: null,
  notes: [],
  activityComments: [],
  comments: [],
  userComments: [],
  userActivityComments: [],
  topics: [],
  activityNotes: [],
  currentReviews: [],
  previousReviews: [],
  activeReview: null,
  isFetchingCompiledQuest: false,
  isUploadingNote: false,
  isEditingQuest: false,
  isDeletingNote: false,
  isAssigning: false,
  approvals: [],
  isEditingApproval: false,
  toQualityReviewModalIsOpen: false,
  viewingReadableScoresSection: '',
  viewingReadableScoresSubsection: '',
  error: null,
  analytics: null,
  isFetchingAnalytics: false,
  isUnassigning: false,
  isEditingComment: false,
  isSavingQuest: false,
  quest_events: [],
  isFetchingQuestHistory: false,
  historyPage: 0,
  historyTotal: 0,
  skills: [],
  isFetchingQuestSkills: false,
  isCreatingActivityResource: false,
  isSettingLastApproval: false,
  isFetchingQuestData: false
};

function quest() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _quest2.START_FETCHING_QUEST_DATA:
      {
        return (0, _assign2.default)({}, initialState, {
          isFetchingQuestData: true
        });
      }

    case _quest2.END_FETCHING_QUEST_DATA:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingQuestData: false
        });
      }

    case _quest2.REQUEST_QUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          item: { id: action.questId },
          currentReviews: [],
          previousReviews: [],
          activeReview: null,
          isEditingQuest: false,
          approvals: [],
          toQualityReviewModalIsOpen: false,
          error: null,
          quest_events: [],
          historyPage: null,
          historyTotal: null,
          isSettingLastApproval: false,
          isEditingApproval: false,
          activities: []
        });
      }

    case _review.REQUEST_CURRENT_COMPILED_QUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingCompiledQuest: true,
          currentReviews: [],
          previousReviews: [],
          activeReview: null
        });
      }

    case _quest2.RECEIVE_QUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        item: action.quest,
        approvals: action.quest.quest_approvals
      });

    case _comments.REQUEST_QUEST_ACTIVITY_COMMENTS:
      return (0, _assign2.default)({}, state, {
        activityComments: []
      });

    case _comments.RECEIVE_QUEST_ACTIVITY_COMMENTS:
      {
        return (0, _assign2.default)({}, state, {
          activityComments: action.comments
        });
      }

    case _comments.REQUEST_QUEST_COMMENTS:
      {
        return (0, _assign2.default)({}, state, {
          comments: []
        });
      }

    case _comments.RECEIVE_QUEST_COMMENTS:
      {
        return (0, _assign2.default)({}, state, {
          comments: action.comments
        });
      }

    case _comments.FETCH_USER_ACTIVITY_COMMENTS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          userActivityComments: []
        });
      }

    case _comments.FETCH_USER_ACTIVITY_COMMENTS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          userActivityComments: action.payload.comments
        });
      }

    case _comments.FETCH_USER_QUEST_COMMENTS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          userComments: []
        });
      }

    case _comments.FETCH_USER_QUEST_COMMENTS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          userComments: action.payload.comments
        });
      }

    case _quest2.REQUEST_QUEST_NOTES:
      {
        return (0, _assign2.default)({}, state, {
          notes: []
        });
      }

    case _quest2.RECEIVE_QUEST_NOTES:
      {
        return (0, _assign2.default)({}, state, {
          notes: action.notes
        });
      }

    case _topics.REQUEST_QUEST_TOPICS:
      {
        return (0, _assign2.default)({}, state, {
          topics: []
        });
      }

    case _topics.RECEIVE_QUEST_TOPICS:
      {
        return (0, _assign2.default)({}, state, {
          topics: action.topics
        });
      }

    case _quest2.SET_QUEST_SECTION:
      return (0, _assign2.default)({}, state, {
        section: action.section,
        subsection: action.subsection || null,
        activityId: action.activityId,
        isEditingQuest: false,
        isEditingComment: false,
        error: null
      });
    case _review.RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS:
      var activeReview = action.compiledQuest.reviews.find(function (review) {
        return review.completed_at === null;
      });
      return (0, _assign2.default)({}, state, {
        isFetchingCompiledQuest: false,
        activeReview: activeReview || null,
        currentReviews: action.compiledQuest.reviews,
        previousReviews: action.compiledQuest.previous_reviews
      });
    case _review.CREATE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviews = [];
      (0, _assign2.default)(reviews, state.currentReviews);
      reviews.push(action.review);

      return (0, _assign2.default)({}, state, {
        currentReviews: reviews,
        activeReview: action.review
      });
    case _comments.POST_QUEST_COMMENT:
      var postQuestComments = [];
      (0, _assign2.default)(postQuestComments, state.comments);
      postQuestComments.unshift(action.comment);

      return (0, _assign2.default)({}, state, {
        comments: postQuestComments,
        isEditingComment: false
      });
    case _comments.POST_ACTIVITY_COMMENT:
      var postActivityComments = [];
      (0, _assign2.default)(postActivityComments, state.activityComments);
      postActivityComments.unshift(action.comment);

      return (0, _assign2.default)({}, state, {
        activityComments: postActivityComments,
        isEditingComment: false
      });
    case _comments.POST_USER_QUEST_COMMENT:
      var postUserQuestComments = [];
      (0, _assign2.default)(postUserQuestComments, state.userComments);
      postUserQuestComments.unshift(action.comment);

      return (0, _assign2.default)({}, state, {
        userComments: postUserQuestComments,
        isEditingComment: false
      });
    case _comments.POST_USER_ACTIVITY_COMMENT:
      var postUserActivityComments = [];
      (0, _assign2.default)(postUserActivityComments, state.userActivityComments);
      postUserActivityComments.unshift(action.comment);

      return (0, _assign2.default)({}, state, {
        userActivityComments: postUserActivityComments,
        isEditingComment: false
      });
    case _comments.RESOLVE_QUEST_COMMENT:
      var comments = [];
      (0, _assign2.default)(comments, action.resourceType === 'Quest' ? state.comments : state.activityComments);
      comments.forEach(function (c) {
        if (c.id === action.commentId) {
          c.status = 1;
        }
      });

      var newCommentsState = action.resourceType === 'Quest' ? {
        comments: comments
      } : {
        activityComments: comments
      };

      return (0, _assign2.default)({}, state, newCommentsState);
    case _comments.OPEN_QUEST_COMMENT:
      var commentz = [];
      (0, _assign2.default)(commentz, action.resourceType === 'Quest' ? state.comments : state.activityComments);
      commentz.forEach(function (c) {
        if (c.id === action.commentId) {
          c.status = 0;
        }
      });

      var newCommentzState = action.resourceType === 'Quest' ? {
        comments: commentz
      } : {
        activityComments: commentz
      };

      return (0, _assign2.default)({}, state, newCommentzState);
    case _comments.EDIT_QUEST_COMMENT:
      var commentsEdit = [];
      (0, _assign2.default)(commentsEdit, state.comments);
      var editCommentIndex = commentsEdit.findIndex(function (thecomment) {
        return thecomment.id === action.commentId;
      });
      commentsEdit.splice(editCommentIndex, 1, action.comment);

      return (0, _assign2.default)({}, state, {
        comments: commentsEdit
      });

    case _comments.EDIT_ACTIVITY_COMMENT:
      var commentssEdit = [];
      (0, _assign2.default)(commentssEdit, state.activityComments);
      var editCommentIndexx = commentssEdit.findIndex(function (thecomment) {
        return thecomment.id === action.commentId;
      });
      commentssEdit.splice(editCommentIndexx, 1, action.comment);

      return (0, _assign2.default)({}, state, {
        activityComments: commentssEdit
      });

    case _comments.EDIT_DRAFT_QUEST_COMMENT:
      var draftCommentsEdit = [];
      (0, _assign2.default)(draftCommentsEdit, state.userComments);
      var editDraftCommentIndex = draftCommentsEdit.findIndex(function (thecomment) {
        return thecomment.id === action.commentId;
      });
      draftCommentsEdit.splice(editDraftCommentIndex, 1, action.comment);

      return (0, _assign2.default)({}, state, {
        userComments: draftCommentsEdit,
        isEditingComment: false
      });

    case _comments.EDIT_DRAFT_ACTIVITY_COMMENT:
      var draftCommentsEditt = [];
      (0, _assign2.default)(draftCommentsEditt, state.userActivityComments);
      var editDraftCommentIndexx = draftCommentsEditt.findIndex(function (thecomment) {
        return thecomment.id === action.commentId;
      });
      draftCommentsEditt.splice(editDraftCommentIndexx, 1, action.comment);

      return (0, _assign2.default)({}, state, {
        userActivityComments: draftCommentsEditt,
        isEditingComment: false
      });

    case _comments.PUBLISH_DRAFT_QUEST_COMMENT:
      var draftQuestCommentsEdit = [];
      var questComments = [];
      (0, _assign2.default)(draftQuestCommentsEdit, state.userComments);
      (0, _assign2.default)(questComments, state.comments);
      questComments.unshift(action.comment);
      var newQuestCommentsState = {
        userComments: draftQuestCommentsEdit.filter(function (c) {
          return c.id !== action.commentId;
        }),
        comments: questComments,
        isEditingComment: false
      };

      return (0, _assign2.default)({}, state, newQuestCommentsState);

    case _comments.PUBLISH_DRAFT_ACTIVITY_COMMENT:
      var draftActivityCommentsEdit = [];
      var activityComments = [];
      (0, _assign2.default)(draftActivityCommentsEdit, state.userActivityComments);
      (0, _assign2.default)(activityComments, state.activityComments);
      activityComments.unshift(action.comment);

      var newActivityCommentsState = {
        userActivityComments: draftActivityCommentsEdit.filter(function (c) {
          return c.id !== action.commentId;
        }),
        activityComments: activityComments,
        isEditingComment: false
      };

      return (0, _assign2.default)({}, state, newActivityCommentsState);

    case _comments.DELETE_QUEST_COMMENT:
      var questCommentss = [];
      (0, _assign2.default)(questCommentss, state.comments);

      var newQuestCommentssState = {
        comments: questCommentss.filter(function (c) {
          return c.id !== action.commentId;
        })
      };

      return (0, _assign2.default)({}, state, newQuestCommentssState);

    case _comments.DELETE_ACTIVITY_COMMENT:
      var activityCommentss = [];
      (0, _assign2.default)(activityCommentss, state.activityComments);

      var newActivityCommentssState = {
        activityComments: activityCommentss.filter(function (c) {
          return c.id !== action.commentId;
        })
      };

      return (0, _assign2.default)({}, state, newActivityCommentssState);

    case _comments.DELETE_DRAFT_QUEST_COMMENT:
      var draftQuestCommentss = [];
      (0, _assign2.default)(draftQuestCommentss, state.userComments);

      var newDraftQuestCommentssState = {
        userComments: draftQuestCommentss.filter(function (c) {
          return c.id !== action.commentId;
        }),
        isEditingComment: false
      };

      return (0, _assign2.default)({}, state, newDraftQuestCommentssState);

    case _comments.DELETE_DRAFT_ACTIVITY_COMMENT:
      var draftActivityCommentss = [];
      (0, _assign2.default)(draftActivityCommentss, state.userActivityComments);

      var newDraftActivityCommentssState = {
        userActivityComments: draftActivityCommentss.filter(function (c) {
          return c.id !== action.commentId;
        }),
        isEditingComment: false
      };

      return (0, _assign2.default)({}, state, newDraftActivityCommentssState);

    case _comments.IS_EDITING_COMMENT:
      return (0, _assign2.default)({}, state, {
        isEditingComment: true
      });

    case _comments.IS_NOT_EDITING_COMMENT:
      return (0, _assign2.default)({}, state, {
        isEditingComment: false
      });

    case _activity.REQUEST_QUEST_ACTIVITY_NOTES:
      return (0, _assign2.default)({}, state, {
        activityNotes: []
      });
    case _activity.RECEIVE_QUEST_ACTIVITY_NOTES:
      return (0, _assign2.default)({}, state, {
        activityNotes: action.notes
      });
    case _review.CREATE_COMPILED_QUEST_SUCCESS:
      var previousReviews = [];
      (0, _assign2.default)(previousReviews, state.previousReviews);

      // Need to remove any current reviews that weren't completed due to recall
      // They will not be returned with the new compiled quest, when created
      var filteredCurrentReviews = [];
      filteredCurrentReviews = state.currentReviews.filter(function (review) {
        return review.completed_at;
      });
      var newPreviousReviews = previousReviews.concat(filteredCurrentReviews);
      // If it's the first compiled quest created from a published quest, need to remove previous reviews
      if (state.item.published_compiled_quest && state.item.current_compiled_quest && state.item.current_compiled_quest.state === 'published') {
        newPreviousReviews = [];
      }

      var quest = {};
      (0, _assign2.default)(quest, state.item);
      quest.reviewing_compiled_quest = action.payload.compiled_quest;
      quest.current_compiled_quest = action.payload.compiled_quest;

      return (0, _assign2.default)({}, state, {
        item: quest,
        currentReviews: [],
        previousReviews: newPreviousReviews,
        activeReview: null,
        isSettingLastApproval: false
      });
    case _review.DELETE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviewz = [];
      (0, _assign2.default)(reviewz, state.currentReviews);

      var newReviewzState = {
        currentReviews: reviewz.filter(function (r) {
          return r.id !== action.reviewId;
        }),
        activeReview: null
      };

      return (0, _assign2.default)({}, state, newReviewzState);
    case _review.EDIT_REVIEW_SUCCESS:
      var reviewsEdit = [];
      (0, _assign2.default)(reviewsEdit, state.currentReviews);

      var editReviewIndex = reviewsEdit.findIndex(function (thereview) {
        return thereview.id === action.review.id;
      });
      reviewsEdit[editReviewIndex] = action.review;

      return (0, _assign2.default)({}, state, {
        currentReviews: reviewsEdit,
        activeReview: action.review
      });
    case _review.COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS:
      var reviewsssEdittt = [];
      (0, _assign2.default)(reviewsssEdittt, state.currentReviews);
      var editReviewIndexxxxx = reviewsssEdittt.findIndex(function (thereview) {
        return thereview.id === action.payload.review.id;
      });
      reviewsssEdittt[editReviewIndexxxxx] = action.payload.review;

      var questttt = {};
      (0, _assign2.default)(questttt, state.item);
      var reviewState = action.payload.reviewState;
      questttt.reviewing_compiled_quest.state = reviewState;
      questttt.current_compiled_quest.state = reviewState;
      if (reviewState === 'published') {
        var dateTime = +new Date();
        var timestamp = Math.floor(dateTime / 1000);
        questttt.published_compiled_quest = {
          state: 'published',
          published_at: timestamp
        };
      }

      var newReviewsssEditttState = {
        currentReviews: reviewsssEdittt,
        activeReview: null,
        item: questttt
      };

      return (0, _assign2.default)({}, state, newReviewsssEditttState);
    case _review.REVERT_QUEST_TO_DRAFT_SUCCESS:
      {
        var questtt = {};
        (0, _assign2.default)(questtt, state.item);
        questtt.reviewing_compiled_quest = null;
        questtt.current_compiled_quest.state = 'draft';

        var currentReviewsss = [];
        (0, _assign2.default)(currentReviewsss, state.currentReviews);
        var previousReviewsss = [];
        (0, _assign2.default)(previousReviewsss, state.previousReviews);

        if (action.payload.published) {
          currentReviewsss = [];
          previousReviewsss = [];
        }

        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, questtt, action.payload.quest),
          currentReviews: currentReviewsss,
          previousReviews: previousReviewsss,
          approvals: []
        });
      }
    case _review.STOP_REVIEW_SUCCESS:
      {
        var questt = {};
        (0, _assign2.default)(questt, state.item);
        questt.reviewing_compiled_quest = null;
        questt.current_compiled_quest.state = 'recalled';

        return (0, _assign2.default)({}, state, {
          item: questt,
          approvals: []
        });
      }
    case _quest2.DELETE_QUEST_SUCCESS:
      {
        return (0, _assign2.default)({}, state, initialState);
      }
    case _quest2.EDIT_QUEST_DETAILS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isSavingQuest: true
        });
      }
    case _quest2.EDIT_QUEST_DETAILS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, action.quest),
          isEditingQuest: false,
          error: null,
          isSavingQuest: false
        });
      }
    case _quest2.EDIT_QUEST_DETAILS_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          error: action.payload.error,
          isSavingQuest: false
        });
      }
    case _quest2.CREATE_QUEST_MENTOR_NOTE_SUCCESS:
      {
        var newNotes = [];
        (0, _assign2.default)(newNotes, state.notes);
        newNotes.push(action.note);

        return (0, _assign2.default)({}, state, {
          notes: newNotes,
          isUploadingNote: false
        });
      }
    case _quest2.EDIT_QUEST_MENTOR_NOTE_SUCCESS:
      {
        var _newNotes = [];
        (0, _assign2.default)(_newNotes, state.notes);
        var editNoteIndex = _newNotes.findIndex(function (note) {
          return note.id === action.payload.note.id;
        });
        _newNotes[editNoteIndex] = action.payload.note;

        return (0, _assign2.default)({}, state, {
          notes: _newNotes,
          isUploadingNote: false
        });
      }
    case _quest2.DELETE_NOTE_SUCCESS:
      {
        var _newNotes2 = [];
        (0, _assign2.default)(_newNotes2, state.notes);
        var newNotesState = _newNotes2.filter(function (n) {
          return n.id !== action.noteId;
        });

        return (0, _assign2.default)({}, state, {
          notes: newNotesState,
          isDeletingNote: false
        });
      }
    case _quest2.CREATE_MENTOR_NOTE:
      {
        return (0, _assign2.default)({}, state, {
          isUploadingNote: true
        });
      }
    case _quest2.START_EDIT_QUEST:
      {
        return (0, _assign2.default)({}, state, {
          isEditingQuest: true
        });
      }
    case _quest2.CANCEL_EDIT_QUEST:
      {
        return (0, _assign2.default)({}, state, {
          isEditingQuest: false,
          isSavingQuest: false,
          error: null
        });
      }
    case _quest2.DELETE_NOTE_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isDeletingNote: true
        });
      }
    case _activity.DELETE_ACTIVITY_SUCCESS:
      {
        var activities = [];
        (0, _assign2.default)(activities, state.activities);

        var deletedActivityIndex = activities.findIndex(function (a) {
          return a.id === action.activityId;
        });

        var newActivitiesState = activities.filter(function (a) {
          return a.id !== action.activityId;
        });

        var newActivityId = '';
        if (activities[deletedActivityIndex + 1]) {
          newActivityId = activities[deletedActivityIndex + 1].id;
        } else if (activities[deletedActivityIndex - 1]) {
          newActivityId = activities[deletedActivityIndex - 1].id;
        } else {
          newActivityId = null;
        }

        return (0, _assign2.default)({}, state, {
          activities: newActivitiesState,
          activityId: newActivityId
        });
      }

    case _activity.EDIT_ACTIVITY_DETAILS_SUCCESS:
      {
        var _activities = [];
        (0, _assign2.default)(_activities, state.activities);

        var editActivityIndex = _activities.findIndex(function (a) {
          return a.id === action.activityId;
        });

        (0, _keys2.default)(action.activity).forEach(function (k) {
          _activities[editActivityIndex][k] = action.activity[k];
        });

        return (0, _assign2.default)({}, state, {
          activities: _activities,
          isFetching: false
        });
      }
    case _activity.DELETE_ACTIVITY_MENTOR_NOTE_SUCCESS:
      {
        var activityNotes = [];
        (0, _assign2.default)(activityNotes, state.activityNotes);
        var newActivityNotesState = activityNotes.filter(function (n) {
          return n.id !== action.noteId;
        });
        return (0, _assign2.default)({}, state, {
          activityNotes: newActivityNotesState
        });
      }
    case _activity.CREATE_QUEST_ACTIVITY_NOTE_SUCCESS:
      {
        var activityNotess = [];
        (0, _assign2.default)(activityNotess, state.activityNotes);
        activityNotess.push(action.note);
        return (0, _assign2.default)({}, state, {
          activityNotes: activityNotess,
          isUploadingNote: false
        });
      }
    case _activity.EDIT_QUEST_ACTIVITY_NOTE_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isUploadingNote: true
        });
      }
    case _activity.EDIT_QUEST_ACTIVITY_NOTE_SUCCESS:
      {
        var activityNotesss = [];
        (0, _assign2.default)(activityNotesss, state.activityNotes);

        var editActivityNoteIndex = activityNotesss.findIndex(function (n) {
          return n.id === action.note.id;
        });
        activityNotesss[editActivityNoteIndex] = action.note;

        return (0, _assign2.default)({}, state, {
          activityNotes: activityNotesss,
          isUploadingNote: false
        });
      }
    case _activity.EDIT_QUEST_ACTIVITY_NOTE_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isUploadingNote: false,
          statusText: action.payload.statusText
        });
      }
    case _topics.DELETE_TOPIC_SUCCESS:
      {
        var topics = [];
        (0, _assign2.default)(topics, state.topics);
        var newTopicsState = topics.filter(function (t) {
          return t.topic_id !== action.topicId;
        });

        return (0, _assign2.default)({}, state, {
          topics: newTopicsState
        });
      }
    case _topics.EDIT_TOPIC_CONTEXT_SUCCESS:
      {
        var topicss = [];
        (0, _assign2.default)(topicss, state.topics);

        var editTopicIndex = topicss.findIndex(function (t) {
          return t.topic_id === action.topic.topic_id;
        });
        topicss[editTopicIndex] = action.topic;

        return (0, _assign2.default)({}, state, {
          topics: topicss
        });
      }
    case _topics.ADD_TOPIC_SUCCESS:
      {
        var topicsss = [];
        (0, _assign2.default)(topicsss, state.topics);
        topicsss.push(action.topic);
        return (0, _assign2.default)({}, state, {
          topics: topicsss
        });
      }
    case _activity.EDIT_QUEST_ACTIVITY_NOTE_POSITION_SUCCESS:
      {
        var _activityNotes = [];
        (0, _assign2.default)(_activityNotes, state.activityNotes);
        var oldNoteIndex = _activityNotes.findIndex(function (n) {
          return n.id === action.note.id;
        });
        // replace the note in the array
        _activityNotes[oldNoteIndex] = action.note;
        // reorder the array
        _activityNotes.splice(action.newIndex, 0, _activityNotes.splice(oldNoteIndex, 1)[0]);
        return (0, _assign2.default)({}, state, {
          activityNotes: _activityNotes
        });
      }

    case _resource.DELETE_ACTIVITY_RESOURCE_SUCCESS:
      {
        var _activities2 = [];
        (0, _assign2.default)(_activities2, state.activities);
        var editActivityIndexx = _activities2.findIndex(function (a) {
          return a.id === action.activityId;
        });
        var activityResourceEdit = _activities2[editActivityIndexx].resources.filter(function (r) {
          return r.id !== action.resourceId;
        });
        _activities2[editActivityIndexx].resources = activityResourceEdit;
        return (0, _assign2.default)({}, state, {
          activities: _activities2
        });
      }

    case _resource.EDIT_ACTIVITY_RESOURCE_POSITION_SUCCESS:
      {
        // TODO: refactor this mess; the resource is so deeply nested
        var _activities3 = [];
        (0, _assign2.default)(_activities3, state.activities);
        // Find the right activity
        var editActivityIndexxx = _activities3.findIndex(function (a) {
          return a.id === action.resource.activity_id;
        });
        // Find the resource within the activity
        var oldResourceIndex = _activities3[editActivityIndexxx].resources.findIndex(function (r) {
          return r.id === action.resource.id;
        });
        // replace the resource in the array
        _activities3[editActivityIndexxx].resources[oldResourceIndex] = action.resource;
        // reorder the array of resources
        _activities3[editActivityIndexxx].resources.splice(action.newIndex, 0, _activities3[editActivityIndexxx].resources.splice(oldResourceIndex, 1)[0]);
        return (0, _assign2.default)({}, state, {
          activities: _activities3
        });
      }

    case _resource.CREATE_ACTIVITY_RESOURCE_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isCreatingActivityResource: true
        });
      }

    case _resource.CREATE_ACTIVITY_RESOURCE_SUCCESS:
      {
        var _activities4 = [];
        (0, _assign2.default)(_activities4, state.activities);
        // Find the activity
        var editActivityIndexxxx = _activities4.findIndex(function (a) {
          return a.id === action.resource.activity_id;
        });
        _activities4[editActivityIndexxxx].resources.unshift(action.resource);
        return (0, _assign2.default)({}, state, {
          activities: _activities4,
          isCreatingActivityResource: false
        });
      }

    case _resource.CREATE_ACTIVITY_RESOURCE_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isCreatingActivityResource: false
        });
      }

    case _resource.EDIT_ACTIVITY_RESOURCE_SUCCESS:
      {
        // TODO: refactor this mess; the resource is so deeply nested
        var _activities5 = [];
        (0, _assign2.default)(_activities5, state.activities);
        // Find the right activity
        var editActivityIndexxxxx = _activities5.findIndex(function (a) {
          return a.id === action.resource.activity_id;
        });
        // Find the resource within the activity
        var oldResourceIndexx = _activities5[editActivityIndexxxxx].resources.findIndex(function (r) {
          return r.id === action.resource.id;
        });
        // replace the resource in the array
        _activities5[editActivityIndexxxxx].resources[oldResourceIndexx] = action.resource;
        return (0, _assign2.default)({}, state, {
          activities: _activities5,
          isUploadingNote: false
        });
      }

    case _resource.EDIT_ACTIVITY_RESOURCE_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isUploadingNote: true
        });
      }

    case _resource.EDIT_ACTIVITY_RESOURCE_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isUploadingNote: false
        });
      }

    case _activity.CREATE_ACTIVITY_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true
        });
      }

    case _activity.CREATE_ACTIVITY_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false
        });
      }

    case _activity.CREATE_ACTIVITY_SUCCESS:
      {
        var _quest = {};
        (0, _assign2.default)(_quest, state.item);

        var _activities6 = [];
        (0, _assign2.default)(_activities6, state.activities);

        // Need to add properties as they are not included in the response
        var formattedActivity = (0, _assign2.default)({}, action.activity, {
          resources: [],
          quest_icon_url: state.item.icon_image_url,
          quest_name: state.item.name
        });

        _quest.activity_count += 1;
        _activities6.push(formattedActivity);

        return (0, _assign2.default)({}, state, {
          activities: _activities6,
          isFetching: false,
          item: _quest,
          activityId: action.activity.id,
          activityNotes: [],
          activityComments: []
        });
      }

    case _activity.EDIT_ACTIVITY_POSITION_SUCCESS:
      {
        var _activities7 = [];
        (0, _assign2.default)(_activities7, state.activities);

        // Find the right activity
        var editActivityPositionIndex = _activities7.findIndex(function (a) {
          return a.id === action.payload.activityId;
        });

        // reorder the array of activities
        _activities7.splice(action.payload.newIndex, 0, _activities7.splice(editActivityPositionIndex, 1)[0]);

        return (0, _assign2.default)({}, state, {
          activities: _activities7
        });
      }

    case _activity.EDIT_ACTIVITY_DETAILS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true
        });
      }

    case _activity.EDIT_ACTIVITY_DETAILS_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false
        });
      }

    case _quest2.CREATE_QUEST_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true
        });
      }

    case _quest2.CREATE_QUEST_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false
        });
      }

    case _quest2.CREATE_QUEST_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          item: (0, _assign2.default)({}, action.quest, {
            grade_levels: []
          })
        });
      }

    case _quest2.ADD_EDITOR_TO_QUEST:
      {
        var questtttttt = {};
        (0, _assign2.default)(questtttttt, state.item);
        var editor = questtttttt.editors.find(function (editor) {
          return editor.id === action.payload.user.id;
        });
        if (!editor) {
          questtttttt.editors.push(action.payload.user);
        }
        return (0, _assign2.default)({}, state, {
          item: questtttttt
        });
      }

    case _topicclouds.FETCH_TOPIC_CLOUD_REQUEST:
      {
        return (0, _assign2.default)({}, state, (0, _assign2.default)({}, initialState));
      }

    case _assignment.IS_ASSIGNING:
      {
        return (0, _assign2.default)({}, state, {
          isAssigning: true
        });
      }

    case _assignment.IS_NOT_ASSIGNING:
      {
        return (0, _assign2.default)({}, state, {
          isAssigning: false
        });
      }

    case _assignment.ASSIGN_QUEST_TO_USER_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            assigned_by: {
              id: action.payload.currentUser.id,
              photo_url: action.payload.currentUser.photo.url,
              name: action.payload.currentUser.name,
              display_name: action.payload.currentUser.display_name
            },
            assigned_to: action.payload.assignment.assigned_to,
            assignment_updated_at: action.payload.assignment.created_at,
            assignment_message: action.payload.assignment.message,
            current_quest_assignment_id: action.payload.assignment.id
          })
        });
      }

    case _approval.IS_EDITING_APPROVAL:
      {
        return (0, _assign2.default)({}, state, {
          isEditingApproval: true
        });
      }

    case _approval.SET_APPROVED_SUCCESS:
      {
        var approvals = [];
        (0, _assign2.default)(approvals, state.approvals);
        approvals.push(action.payload.approval);

        return (0, _assign2.default)({}, state, {
          approvals: approvals,
          isEditingApproval: false
        });
      }

    case _approval.DELETE_APPROVED_SUCCESS:
      {
        var approvalss = state.approvals.filter(function (approval) {
          return approval.id !== action.payload.approvalId;
        });
        return (0, _assign2.default)({}, state, {
          approvals: approvalss,
          isEditingApproval: false
        });
      }

    case _review.OPEN_TO_QUALITY_REVIEW_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          toQualityReviewModalIsOpen: true
        });
      }

    case _review.CLOSE_TO_QUALITY_REVIEW_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          toQualityReviewModalIsOpen: false,
          isEditingApproval: false,
          isSettingLastApproval: false
        });
      }

    case _modal.IS_VIEWING_READABILITY_SCORES_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          viewingReadableScoresSection: action.payload.section,
          viewingReadableScoresSubsection: action.payload.subsection
        });
      }

    case _modal.IS_NOT_VIEWING_READABILITY_SCORES_MODAL:
      {
        return (0, _assign2.default)({}, state, {
          viewingReadableScoresSection: '',
          viewingReadableScoresSubsection: ''
        });
      }

    case _quest2.RECEIVE_QUEST_READABLE_STATS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            readable_stats: action.payload.stats
          })
        });
      }

    case _quest2.REQUEST_QUEST_ANALYTICS:
      {
        return (0, _assign2.default)({}, state, {
          analytics: null,
          isFetchingAnalytics: true
        });
      }

    case _quest2.FAILED_QUEST_ANALYTICS:
      {
        return (0, _assign2.default)({}, state, {
          analytics: null,
          isFetchingAnalytics: false
        });
      }

    case _quest2.RECEIVE_QUEST_ANALYTICS:
      {
        return (0, _assign2.default)({}, state, {
          analytics: action.payload.quest_analytics,
          isFetchingAnalytics: false
        });
      }

    case _activity.RECEIVE_ACTIVITY_READABLE_STATS:
      {
        var _activities8 = [];
        (0, _assign2.default)(_activities8, state.activities);

        _activities8 = _activities8.map(function (a) {
          if (a.id === state.activityId) {
            return (0, _assign2.default)({}, a, {
              readable_stats: action.payload.stats
            });
          } else {
            return a;
          }
        });

        return (0, _assign2.default)({}, state, {
          activities: _activities8
        });
      }

    case _assignment.IS_UNASSIGNING:
      {
        return (0, _assign2.default)({}, state, {
          isUnassigning: true
        });
      }

    case _assignment.IS_NOT_UNASSIGNING:
      {
        return (0, _assign2.default)({}, state, {
          isUnassigning: false
        });
      }

    case _assignment.UNASSIGN_QUEST_FROM_USER_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            assigned_by: null,
            assigned_to: null,
            assignment_updated_at: null,
            assignment_message: null
          })
        });
      }

    case _resource.REMOVE_ACTIVITY_RESOURCE_FILE_SUCCESS:
      {
        // TODO: refactor this mess; the resource is so deeply nested
        var _activities9 = [];
        (0, _assign2.default)(_activities9, state.activities);

        // Find the right activity
        var _editActivityIndex = _activities9.findIndex(function (a) {
          return a.id === action.resource.activity_id;
        });

        // Find the resource within the activity
        var oldResourceIndexxx = _activities9[_editActivityIndex].resources.findIndex(function (r) {
          return r.id === action.resource.id;
        });

        // replace the resource in the array
        _activities9[_editActivityIndex].resources[oldResourceIndexxx] = (0, _assign2.default)({}, action.resource, {
          file: null,
          file_name: null,
          file_url: null,
          format: 'file',
          fileRemoved: true
        });

        return (0, _assign2.default)({}, state, {
          activities: _activities9
        });
      }

    case _quest2.FETCH_QUEST_HISTORY_REQUEST:
      {
        var questEvents = (0, _from2.default)(state.quest_events);
        if (action.payload.reload) {
          questEvents = [];
        }
        return (0, _assign2.default)({}, state, {
          isFetchingQuestHistory: true,
          quest_events: questEvents
        });
      }

    case _quest2.FETCH_QUEST_HISTORY_SUCCESS:
      {
        var events = [];
        (0, _assign2.default)(events, state.quest_events);

        action.payload.quest_events.forEach(function (item) {
          events.push(item);
        });

        var idPositions = events.map(function (item) {
          return item.id;
        });
        var newPayload = events.filter(function (item, pos, arr) {
          return idPositions.indexOf(item.id) === pos;
        });

        return (0, _assign2.default)({}, state, {
          isFetchingQuestHistory: false,
          quest_events: newPayload,
          historyPage: action.payload.page,
          historyTotal: action.payload.total
        });
      }

    case _quest2.CLEAR_QUEST_HISTORY:
      {
        return (0, _assign2.default)({}, state, {
          quest_events: [],
          historyPage: 0,
          historyTotal: 0
        });
      }

    case _questskills.FETCH_QUEST_SKILLS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingQuestSkills: true
        });
      }

    case _questskills.FETCH_QUEST_SKILLS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          isFetchingQuestSkills: false,
          skills: action.payload.skills
        });
      }

    case _questskills.ADD_QUEST_SKILL_SUCCESS:
      {
        var skills = [];
        (0, _assign2.default)(skills, state.skills);
        skills.unshift(action.payload.skill);

        return (0, _assign2.default)({}, state, {
          skills: skills
        });
      }

    case _questskills.DELETE_QUEST_SKILL_SUCCESS:
      {
        var _skills = [];
        (0, _assign2.default)(_skills, state.skills);
        var newSkillsState = _skills.filter(function (skill) {
          return skill.framework_skill_id !== action.payload.skillId;
        });

        return (0, _assign2.default)({}, state, {
          skills: newSkillsState
        });
      }

    case _resource.PATCH_ACTIVITY_RESOURCE_FILE_INFO_SUCCESS:
      {
        // TODO: refactor this mess; the resource is so deeply nested
        var _activities10 = [];
        (0, _assign2.default)(_activities10, state.activities);

        // add prop to resource for updating the component appropriately
        var patchedResource = (0, _assign2.default)({}, action.payload.resource);

        // Find the right activity
        var _editActivityIndex2 = _activities10.findIndex(function (a) {
          return a.id === patchedResource.activity_id;
        });

        // Find the resource within the activity
        var _oldResourceIndex = _activities10[_editActivityIndex2].resources.findIndex(function (r) {
          return r.id === patchedResource.id;
        });

        // replace the resource in the array
        _activities10[_editActivityIndex2].resources[_oldResourceIndex] = patchedResource;

        return (0, _assign2.default)({}, state, {
          activities: _activities10
        });
      }

    case _approval.IS_SETTING_LAST_APPROVAL:
      {
        return (0, _assign2.default)({}, state, {
          isSettingLastApproval: true
        });
      }

    // make sure to clear error in case a user navigates away before canceling/saving
    case _reactRouterRedux.LOCATION_CHANGE:
      {
        return (0, _assign2.default)({}, state, {
          error: null
        });
      }

    case _quest2.FETCH_QUEST_ACTIVITIES_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          activities: action.payload.activities
        });
      }

    case _quest2.FETCH_IN_USE_COMPILED_QUESTS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            reviewing_compiled_quest: action.payload.inUseCompiledQuests.reviewing_compiled_quest,
            published_compiled_quest: action.payload.inUseCompiledQuests.published_compiled_quest,
            current_compiled_quest: action.payload.inUseCompiledQuests.current_compiled_quest
          })
        });
      }

    case _quest2.FETCH_CURRENT_ASSIGNMENT_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            assigned_by: action.payload.assignment.assigned_by,
            assigned_to: action.payload.assignment.assigned_to,
            assignment_type: action.payload.assignment.assignment_type,
            assignment_message: action.payload.assignment.message,
            assignment_updated_at: action.payload.assignment.updated_at,
            current_quest_assignment_id: action.payload.assignment.id
          })
        });
      }

    case _quest2.FETCH_QUEST_APPROVALS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          approvals: action.payload.approvals
        });
      }

    case _quest2.FETCH_QUEST_GRADE_LEVELS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          item: (0, _assign2.default)({}, state.item, {
            grade_levels: action.payload.gradeLevels
          })
        });
      }

    case _quest2.UPDATE_QUEST_IMAGE_PROPERTIES_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          isSavingQuest: false,
          item: (0, _assign2.default)({}, state.item, {
            color: action.payload.imageProperties.color,
            icon_image_url: action.payload.imageProperties.icon_image_url,
            icon_image_license_properties: action.payload.imageProperties.icon_image_license_properties,
            icon_image_original_file_name: action.payload.imageProperties.icon_image_original_file_name
          })
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1037), src$en$$ = __webpack_require__(1042);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(556), src$es5$$ = __webpack_require__(1038), src$compiler$$ = __webpack_require__(1039), intl$messageformat$parser$$ = __webpack_require__(1040);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(556);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1041)['default'];
exports['default'] = exports;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1045)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1050);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1046);
var en_1 = __webpack_require__(1049);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(555);
var diff_1 = __webpack_require__(1047);
var es5_1 = __webpack_require__(1048);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userCertifications = undefined;

var _freeze = __webpack_require__(237);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userCertifications = exports.userCertifications = (0, _freeze2.default)([{
  value: 'quest_designer',
  text: 'Quest Designer'
}, {
  value: 'internal_reviewer',
  text: 'Internal Reviewer'
}, {
  value: 'publication_reviewer',
  text: 'Publication Reviewer'
}]);

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1053);
module.exports = __webpack_require__(43).Object.freeze;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(133);
var meta = __webpack_require__(539).onFreeze;

__webpack_require__(392)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1055), __esModule: true };

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1056);
var $Object = __webpack_require__(43).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(70);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(104), 'Object', { defineProperties: __webpack_require__(488) });


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1063);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebIcon = exports.SimulationIcon = exports.PresentationIcon = exports.DocumentIcon = exports.ImageIcon = exports.AudioIcon = exports.VideoIcon = exports.AppIcon = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: #fff;\n'], ['\n  background: #fff;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 39px;\n  width: 40px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 39px;\n  width: 40px;\n  mask: url(', ') no-repeat;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 36px;\n  width: 40px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 36px;\n  width: 40px;\n  mask: url(', ') no-repeat;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  height: 37px;\n  width: 38px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 37px;\n  width: 38px;\n  mask: url(', ') no-repeat;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  height: 38px;\n  width: 34px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 38px;\n  width: 34px;\n  mask: url(', ') no-repeat;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  height: 34px;\n  width: 39px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 34px;\n  width: 39px;\n  mask: url(', ') no-repeat;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  height: 38px;\n  width: 38px;\n  mask: url(', ') no-repeat;\n'], ['\n  height: 38px;\n  width: 38px;\n  mask: url(', ') no-repeat;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iconWebsite = __webpack_require__(1065);

var _iconWebsite2 = _interopRequireDefault(_iconWebsite);

var _iconVideo = __webpack_require__(1066);

var _iconVideo2 = _interopRequireDefault(_iconVideo);

var _iconAudio = __webpack_require__(1067);

var _iconAudio2 = _interopRequireDefault(_iconAudio);

var _iconImage = __webpack_require__(1068);

var _iconImage2 = _interopRequireDefault(_iconImage);

var _iconDocument = __webpack_require__(1069);

var _iconDocument2 = _interopRequireDefault(_iconDocument);

var _iconPresentation = __webpack_require__(1070);

var _iconPresentation2 = _interopRequireDefault(_iconPresentation);

var _iconSimulation = __webpack_require__(1071);

var _iconSimulation2 = _interopRequireDefault(_iconSimulation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconComponent = _styledComponents2.default.div.withConfig({
  displayName: '_Styled__IconComponent',
  componentId: 'x6eoia-0'
})(_templateObject);

var AppIcon = exports.AppIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__AppIcon',
  componentId: 'x6eoia-1'
})(_templateObject2, _iconWebsite2.default);

var VideoIcon = exports.VideoIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__VideoIcon',
  componentId: 'x6eoia-2'
})(_templateObject3, _iconVideo2.default);

var AudioIcon = exports.AudioIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__AudioIcon',
  componentId: 'x6eoia-3'
})(_templateObject4, _iconAudio2.default);

var ImageIcon = exports.ImageIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__ImageIcon',
  componentId: 'x6eoia-4'
})(_templateObject4, _iconImage2.default);

var DocumentIcon = exports.DocumentIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__DocumentIcon',
  componentId: 'x6eoia-5'
})(_templateObject5, _iconDocument2.default);

var PresentationIcon = exports.PresentationIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__PresentationIcon',
  componentId: 'x6eoia-6'
})(_templateObject6, _iconPresentation2.default);

var SimulationIcon = exports.SimulationIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__SimulationIcon',
  componentId: 'x6eoia-7'
})(_templateObject7, _iconSimulation2.default);

var WebIcon = exports.WebIcon = (0, _styledComponents2.default)(IconComponent).withConfig({
  displayName: '_Styled__WebIcon',
  componentId: 'x6eoia-8'
})(_templateObject2, _iconWebsite2.default);

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMC40OSAyOS40MSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnNpbHZlcjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24td2Vic2l0ZV88L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMSwyOS40MUgyMi4xMWExLDEsMCwwLDAsMS0xVjE4LjQ5aDYuMzFhMSwxLDAsMCwwLDEtMVYxYTEsMSwwLDAsMC0xLTFIOC45M2ExLDEsMCwwLDAtMSwxdjkuNTlIMWExLDEsMCwwLDAtMSwxVjI4LjM4QTEsMSwwLDAsMCwxLDI5LjQxWm05LjQxLTI0LjNIMjcuOTNWMTZIMjMuMTRWMTEuNzhBMS4xNCwxLjE0LDAsMCwwLDIyLDEwLjY0SDEwLjQ0Wk0yLjU4LDE1Ljc1SDIwLjUxVjI3LjI0SDIuNThaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS43NyAyOC41NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnNpbHZlcjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tdmlkZW9fPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjY4LDBIOC4wOUE4LjExLDguMTEsMCwwLDAsMCw4LjA5djEyLjRhOC4xMSw4LjExLDAsMCwwLDguMDksOC4wOUgyMy42OGE4LjExLDguMTEsMCwwLDAsOC4wOS04LjA5VjguMDlBOC4xMSw4LjExLDAsMCwwLDIzLjY4LDBabS0uMjMsMTUuNjYtMTAuNyw2LjE1QTEuNTksMS41OSwwLDAsMSwxMiwyMmExLjU5LDEuNTksMCwwLDEtMS41OC0xLjU4VjguMTRhMS41OCwxLjU4LDAsMCwxLDIuMzctMS4zN2wxMC43LDYuMTVhMS41OCwxLjU4LDAsMCwxLDAsMi43NFoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS45IDI5LjAxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6c2lsdmVyO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aWNvbi1hdWRpb188L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTguMTgsMjcuNzNBMS4yOCwxLjI4LDAsMCwwLDE5LjQ1LDI5YTEuMzEsMS4zMSwwLDAsMCwuNDItLjA3LDE0LjQxLDE0LjQxLDAsMCwwLDYuNjctNC43OSwxNC44NywxNC44NywwLDAsMCwzLjM2LTkuNjQsMTQuODcsMTQuODcsMCwwLDAtMy4zNi05LjY0QTE0LjQ1LDE0LjQ1LDAsMCwwLDE5Ljg4LjA3YTEuMjgsMS4yOCwwLDAsMC0xLjcsMS4yMXYuNjRBMS4yOCwxLjI4LDAsMCwwLDE5LDMuMTFhMTIuMDgsMTIuMDgsMCwwLDEsNy43NCwxMS40QTEyLjA3LDEyLjA3LDAsMCwxLDE5LDI1LjlhMS4yOCwxLjI4LDAsMCwwLS44MiwxLjE5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjQ1LDE5Ljk0YTEuMjcsMS4yNywwLDAsMCwuOTUtLjQyLDcuMTQsNy4xNCwwLDAsMCwxLjc0LTUsNy4xNyw3LjE3LDAsMCwwLTEuNzQtNSwxLjI4LDEuMjgsMCwwLDAtMi4yMy44NXY4LjMxQTEuMjcsMS4yNywwLDAsMCwxOSwxOS44NSwxLjI1LDEuMjUsMCwwLDAsMTkuNDUsMTkuOTRaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTEuOTMsNC4yOSw2LjExLDEwLjExSDFhMSwxLDAsMCwwLTEsMXY2Ljg4YTEsMSwwLDAsMCwxLDFINi4xMWw1LjgxLDUuODFhMSwxLDAsMCwwLC42OC4yOC45NC45NCwwLDAsMCwuMzctLjA3LDEsMSwwLDAsMCwuNTktLjg5VjVBMSwxLDAsMCwwLDEzLDQuMDksMSwxLDAsMCwwLDExLjkzLDQuMjlaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC42OCAyNy42MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnNpbHZlcjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24taW1hZ2VfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjAuMTMiIGN5PSI4LjEiIHI9IjIuMjgiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yNy4wOCwwSDEuNkExLjYsMS42LDAsMCwwLDAsMS42VjI2YTEuNiwxLjYsMCwwLDAsMS42LDEuNkgyNy4wOGExLjYsMS42LDAsMCwwLDEuNi0xLjZWMS42QTEuNiwxLjYsMCwwLDAsMjcuMDgsMFpNMjUuOTQsMi43NlYyMi40MmwtLjQ3LS43NmMtLjctMS4xNi0xLjM3LTIuMjUtMi4xNy0zLjM0YTEsMSwwLDAsMC0uNjQtLjM5LDEsMSwwLDAsMC0uNzIuMTlsLTMuODQsM0w5Ljg2LDExLjE3QTEsMSwwLDAsMCw5LDEwLjgzYTEsMSwwLDAsMC0uNzUuNTNMMi43NCwyMi41NFYyLjc2WiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS42MyAzMi44MyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnNpbHZlcjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tZG9jdW1lbnRfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3Ljc0LDBINi4xMkE1Ljk0LDUuOTQsMCwwLDAsMS44NSwxLjc5LDUuOTIsNS45MiwwLDAsMCwuMDcsNkwwLDI2Ljc5YTUuODcsNS44NywwLDAsMCwxLjg2LDQuMzEsNiw2LDAsMCwwLDQuMjUsMS43NGgxNy40YTYsNiwwLDAsMCw0LjI1LTEuNzQsNS44Niw1Ljg2LDAsMCwwLDEuODYtNC4zMVYxMS44OWEzLjE5LDMuMTksMCwwLDAtLjk0LTIuMjZMMjAsLjk0QTMuMTksMy4xOSwwLDAsMCwxNy43NCwwWm04LDEyLjg0YTEuNiwxLjYsMCwwLDEtMS40NywxaC03YTEuNiwxLjYsMCwwLDEtMS42LTEuNnYtN2ExLjYsMS42LDAsMCwxLDIuNzItMS4xM2w3LDdBMS42LDEuNiwwLDAsMSwyNS42OSwxMi44NFoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNS4yNiAzMS4wOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7fS5jbHMtMntmaWxsOnNpbHZlcjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tcHJlc2VudGF0aW9uXzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yLjU1LDI4LjNhLjIyLjIyLDAsMCwwLC4yMi4yMkgzMi40OGEuMjIuMjIsMCwwLDAsLjIyLS4yMlY2LjU1SDIuNTVaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMzIuNDgsMEgyLjc4QTIuNzgsMi43OCwwLDAsMCwwLDIuNzhWMjguM2EyLjc4LDIuNzgsMCwwLDAsMi43OCwyLjc4SDMyLjQ4YTIuNzgsMi43OCwwLDAsMCwyLjc4LTIuNzhWMi43OEEyLjc4LDIuNzgsMCwwLDAsMzIuNDgsMFptLjIyLDI4LjNhLjIyLjIyLDAsMCwxLS4yMi4yMkgyLjc4YS4yMi4yMiwwLDAsMS0uMjItLjIyVjYuNTVIMzIuN1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMy40NywxMi45NUgyOC4yYTEsMSwwLDEsMSwwLDEuOTFIMjMuNDdhMSwxLDAsMCwxLDAtMS45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMy40NywxNi41OEgyOC4yYTEsMSwwLDEsMSwwLDEuOTFIMjMuNDdhMSwxLDAsMCwxLDAtMS45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMy40NywyMC4yMUgyOC4yYTEsMSwwLDAsMSwwLDEuOTFIMjMuNDdhMSwxLDAsMCwxLDAtMS45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMy40NywxNC44NkgyOC4yYTEsMSwwLDEsMCwwLTEuOTFIMjMuNDdhMSwxLDAsMCwwLDAsMS45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yMy40NywxOC41SDI4LjJhMSwxLDAsMSwwLDAtMS45MUgyMy40N2ExLDEsMCwwLDAsMCwxLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIzLjQ3LDIyLjEzSDI4LjJhMSwxLDAsMCwwLDAtMS45MUgyMy40N2ExLDEsMCwwLDAsMCwxLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTEzLjM4LDI0LjgyQTcuMjgsNy4yOCwwLDEsMCw2LjEsMTcuNTQsNy4yOCw3LjI4LDAsMCwwLDEzLjM4LDI0LjgyWm0wLTEyLjlBNS42Miw1LjYyLDAsMCwxLDE5LDE3LjU0SDEzLjM4WiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMi4yIDMyLjIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpzaWx2ZXI7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLXNpbXVsYXRpb25fPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjEsMjMuMjJoLTZhMS42LDEuNiwwLDAsMC0xLjQzLDEuMTIsMi40NywyLjQ3LDAsMCwwLC4xNiwyLjEybDMsNC45NWExLjQyLDEuNDIsMCwwLDAsMi41NCwwbDMtNC45NWEyLjQ3LDIuNDcsMCwwLDAsLjE2LTIuMTJBMS42LDEuNiwwLDAsMCwxOS4xLDIzLjIyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LjM3Ljc5YTEuNDIsMS40MiwwLDAsMC0yLjU0LDBsLTMsNC45NWEyLjQ3LDIuNDcsMCwwLDAtLjE2LDIuMTJBMS42LDEuNiwwLDAsMCwxMy4xLDloNmExLjYsMS42LDAsMCwwLDEuNDMtMS4xMiwyLjQ3LDIuNDcsMCwwLDAtLjE2LTIuMTJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNy44NiwxMS42N2EyLjQ3LDIuNDcsMCwwLDAtMi4xMi4xNmwtNC45NSwzYTEuNDIsMS40MiwwLDAsMCwwLDIuNTRsNC45NSwzYTIuNDcsMi40NywwLDAsMCwyLjEyLjE2QTEuNiwxLjYsMCwwLDAsOSwxOS4xdi02QTEuNiwxLjYsMCwwLDAsNy44NiwxMS42N1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zMS40MSwxNC44M2wtNC45NS0zYTIuNDcsMi40NywwLDAsMC0yLjEyLS4xNiwxLjYsMS42LDAsMCwwLTEuMTIsMS40M3Y2YTEuNiwxLjYsMCwwLDAsMS4xMiwxLjQzLDIuNDcsMi40NywwLDAsMCwyLjEyLS4xNmw0Ljk1LTNhMS40MiwxLjQyLDAsMCwwLDAtMi41NFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE2LjEiIGN5PSIxNi4xIiByPSI0LjQ5Ii8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.quests = quests;

var _quests2 = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: [],
  page: 1,
  total: 0
};

function quests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _quests2.CLEAR_QUESTS:
      return (0, _assign2.default)({}, state, {
        items: [],
        page: 1
      });
    case _quests2.FETCH_QUESTS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _quests2.FETCH_QUESTS_SUCCESS:
      var _quests = [];
      (0, _assign2.default)(_quests, state.items);

      action.quests.forEach(function (item) {
        _quests.push(item);
      });

      var idPositions = _quests.map(function (item) {
        return item.id;
      });
      var newPayload = _quests.filter(function (item, pos, arr) {
        return idPositions.indexOf(item.id) === pos;
      });

      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: newPayload,
        page: action.page,
        total: action.total
      });
    case _quests2.FETCH_QUESTS_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: [],
        total: 0
      });
    default:
      return state;
  }
}

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.questsfilters = questsfilters;

var _questsfilters = __webpack_require__(301);

var _productionstatus = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  authors_id_in: [],
  questtags_id_in: [],
  reviewing_compiled_quest_state_null: null,
  reviewing_compiled_quest_state_in: [],
  name_or_description_cont: '',
  quest_subject_id_in: [],
  assigned_to_id_in: [],
  grade_levels_id_in: [],
  mock_course_id_in: null,
  mock_level_id_in: [],
  reviewTrackingStatus: null
};

function questsfilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _questsfilters.SET_QUESTS_AUTHOR_FILTERS:
      return (0, _assign2.default)({}, state, {
        authors_id_in: action.authors_id_in
      });
    case _questsfilters.SET_QUESTS_TAG_FILTERS:
      return (0, _assign2.default)({}, state, {
        questtags_id_in: action.questtags_id_in
      });
    case _questsfilters.SET_QUESTS_KEYWORD_FILTER:
      return (0, _assign2.default)({}, state, {
        name_or_description_cont: action.name_or_description_cont
      });
    case _questsfilters.SET_QUESTS_DRAFT_FILTER:
      return (0, _assign2.default)({}, state, {
        reviewing_compiled_quest_state_null: action.reviewing_compiled_quest_state_null
      });
    case _questsfilters.SET_QUESTS_STATUS_FILTER:
      return (0, _assign2.default)({}, state, {
        reviewing_compiled_quest_state_in: action.reviewing_compiled_quest_state_in
      });
    case _questsfilters.SET_QUESTS_PRIMARY_SUBJECT_FILTER:
      return (0, _assign2.default)({}, state, {
        quest_subject_id_in: action.quest_subject_id_in
      });
    case _questsfilters.SET_QUESTS_ASSIGNED_TO_FILTERS:
      return (0, _assign2.default)({}, state, {
        assigned_to_id_in: action.assigned_to_id_in
      });
    case _questsfilters.CLEAR_QUESTS_FILTERS:
      return (0, _assign2.default)({}, state, initialState);
    case _questsfilters.SET_QUESTS_TARGET_GRADE_LEVEL_FILTERS:
      return (0, _assign2.default)({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      });
    case _questsfilters.SET_QUESTS_COURSE_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      });
    case _questsfilters.SET_QUESTS_LEVELS_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_level_id_in: action.mock_level_id_in
      });
    case _productionstatus.SET_ALL_QUESTS_FILTERS_FROM_PRODUCTION_STATUS_FILTERS:
      {
        return (0, _assign2.default)({}, state, action.payload.filterState);
      }
    case _questsfilters.SET_QUESTS_REVIEW_TRACKING_STATUS:
      {
        return (0, _assign2.default)({}, state, {
          reviewTrackingStatus: action.status
        });
      }
    default:
      return state;
  }
}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.questtypes = questtypes;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function questtypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var questTypesArray = [];
        action.payload.manifest.quest_types.forEach(function (qt) {
          questTypesArray.push(qt);
        });

        return (0, _assign2.default)({}, state, {
          items: questTypesArray,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.queue = queue;

var _queue = __webpack_require__(404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: [],
  page: 1,
  total: 0,
  sort: 'assignment_updated_at desc'
};

function queue() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _queue.RECEIVE_USER_QUEUE_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true
        });
      }
    case _queue.RECEIVE_USER_QUEUE_SUCCESS:
      {
        var quests = [];
        (0, _assign2.default)(quests, state.items);

        action.payload.quests.forEach(function (item) {
          quests.push(item);
        });

        var idPositions = quests.map(function (item) {
          return item.id;
        });
        var newPayload = quests.filter(function (item, pos, arr) {
          return idPositions.indexOf(item.id) === pos;
        });

        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: newPayload,
          page: action.payload.page,
          total: action.payload.total
        });
      }
    case _queue.RECEIVE_USER_QUEUE_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: [],
          total: 0
        });
      }
    case _queue.SET_SORT:
      {
        return (0, _assign2.default)({}, state, {
          sort: action.payload.sort,
          items: []
        });
      }
    case _queue.CLEAR_QUESTS:
      {
        return (0, _assign2.default)({}, state, {
          items: [],
          page: 1,
          total: 0
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.queuefilters = queuefilters;

var _queuefilters = __webpack_require__(396);

var _user = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  assigned_to_id_in: [],
  authors_id_in: [],
  reviewing_compiled_quest_state_null: null,
  reviewing_compiled_quest_state_in: [],
  name_or_description_cont: '',
  mock_course_id_in: null,
  mock_level_id_in: [],
  grade_levels_id_in: []
};

function queuefilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _user.LOGIN_USER_SUCCESS:
      return (0, _assign2.default)({}, state, {
        assigned_to_id_in: [action.payload.user.id]
      });
    case _queuefilters.SET_QUEUE_AUTHORS_FILTER:
      return (0, _assign2.default)({}, state, {
        authors_id_in: action.payload.authors_id_in
      });
    case _queuefilters.SET_QUEUE_KEYWORD_FILTER:
      return (0, _assign2.default)({}, state, {
        name_or_description_cont: action.payload.name_or_description_cont
      });
    case _queuefilters.SET_QUEUE_DRAFT_FILTER:
      return (0, _assign2.default)({}, state, {
        reviewing_compiled_quest_state_null: action.payload.reviewing_compiled_quest_state_null
      });
    case _queuefilters.SET_QUEUE_STATUS_FILTER:
      return (0, _assign2.default)({}, state, {
        reviewing_compiled_quest_state_in: action.payload.reviewing_compiled_quest_state_in
      });
    case _queuefilters.SET_QUEUE_COURSE_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      });
    case _queuefilters.SET_QUEUE_LEVELS_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_level_id_in: action.mock_level_id_in
      });
    case _queuefilters.CLEAR_QUEUE_FILTERS:
      return (0, _assign2.default)({}, state, (0, _assign2.default)({}, state, {
        authors_id_in: [],
        reviewing_compiled_quest_state_null: null,
        reviewing_compiled_quest_state_in: [],
        name_or_description_cont: '',
        mock_course_id_in: null,
        mock_level_id_in: [],
        grade_levels_id_in: []
      }));
    case _queuefilters.SET_QUEUE_TARGET_GRADE_LEVEL_FILTERS:
      return (0, _assign2.default)({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      });
    default:
      return state;
  }
}

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.resetpassword = resetpassword;

var _resetpassword = __webpack_require__(560);

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isLoading: false,
  failure: false,
  success: false
};

function resetpassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _resetpassword.RESET_PASSWORD_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isLoading: true,
          failure: false
        });
      }

    case _resetpassword.RESET_PASSWORD_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          isLoading: false,
          success: true
        });
      }

    case _resetpassword.RESET_PASSWORD_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          isLoading: false,
          failure: true
        });
      }

    case _reactRouterRedux.LOCATION_CHANGE:
      {
        return (0, _assign2.default)({}, state, {
          isLoading: false,
          failure: false,
          success: false
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.unlockaccount = unlockaccount;

var _unlockaccount = __webpack_require__(561);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  unlockErrorStatusText: null,
  success: false,
  failure: false
};

function unlockaccount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _unlockaccount.UNLOCK_ACCOUNT_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          unlockErrorStatusText: null,
          failure: false
        });
      }

    case _unlockaccount.UNLOCK_ACCOUNT_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          unlockErrorStatusText: null,
          success: true
        });
      }

    case _unlockaccount.UNLOCK_ACCOUNT_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          unlockErrorStatusText: 'This page is no longer available.',
          failure: true
        });
      }

    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.reviewqueue = reviewqueue;

var _reviewqueue = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: [],
  page: null,
  total: null,
  needStandardsCount: '',
  needFinalCount: '',
  totalCount: null
};

function reviewqueue() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reviewqueue.FETCH_REVIEW_QUEUE_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _reviewqueue.FETCH_REVIEW_QUEUE_SUCCESS:
      var quests = [];
      (0, _assign2.default)(quests, state.items);

      action.quests.forEach(function (item) {
        quests.push(item);
      });

      var idPositions = quests.map(function (item) {
        return item.id;
      });
      var newPayload = quests.filter(function (item, pos, arr) {
        return idPositions.indexOf(item.id) === pos;
      });

      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: newPayload,
        page: action.meta.page,
        total: action.meta.total
      });
    case _reviewqueue.FETCH_REVIEW_QUEUE_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetching: false
      });
    case _reviewqueue.FETCH_REVIEW_QUEUE_COUNTS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        needStandardsCount: action.payload.counts.need_standards_review_count,
        needFinalCount: action.payload.counts.need_final_review_count,
        totalCount: action.payload.counts.total_in_quality_review_count
      });
    case _reviewqueue.CLEAR_REVIEW_QUEUE_QUESTS:
      return (0, _assign2.default)({}, state, {
        items: [],
        page: null
      });
    default:
      return state;
  }
}

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.reviewqueuefilters = reviewqueuefilters;

var _reviewqueuefilters = __webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  state_in: [0, 4],
  authors_id_in: [],
  name_or_description_cont: '',
  mock_course_id_in: null,
  mock_level_id_in: [],
  sort_type: 'quest_priority',
  sort_order: 'desc',
  need_standards_review: false,
  need_final_review: false,
  grade_levels_id_in: []
};

function reviewqueuefilters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reviewqueuefilters.SET_REVIEW_QUEUE_AUTHOR_FILTERS:
      return (0, _assign2.default)({}, state, {
        authors_id_in: action.authors_id_in
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_KEYWORD_FILTER:
      return (0, _assign2.default)({}, state, {
        name_or_description_cont: action.name_or_description_cont
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_COURSE_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_course_id_in: action.mock_course_id_in,
        mock_level_id_in: []
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_LEVELS_FILTER:
      return (0, _assign2.default)({}, state, {
        mock_level_id_in: action.mock_level_id_in
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_SORT_TYPE:
      return (0, _assign2.default)({}, state, {
        sort_type: action.sort
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_SORT_ORDER:
      return (0, _assign2.default)({}, state, {
        sort_order: action.order
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_NEED_STANDARDS_REVIEW:
      return (0, _assign2.default)({}, state, {
        need_standards_review: true,
        need_final_review: false
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_NEED_FINAL_REVIEW:
      return (0, _assign2.default)({}, state, {
        need_standards_review: false,
        need_final_review: true
      });
    case _reviewqueuefilters.SET_REVIEW_QUEUE_ALL_REVIEWS:
      return (0, _assign2.default)({}, state, {
        need_standards_review: false,
        need_final_review: false
      });
    case _reviewqueuefilters.CLEAR_REVIEW_QUEUE_FILTERS:
      return (0, _assign2.default)({}, state, initialState);
    case _reviewqueuefilters.SET_REVIEW_QUEUE_TARGET_GRADE_LEVEL_FILTERS:
      return (0, _assign2.default)({}, state, {
        grade_levels_id_in: action.grade_levels_id_in
      });
    default:
      return state;
  }
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(233);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.subjects = subjects;

var _manifest = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function subjects() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _manifest.REQUEST_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: true,
          items: []
        });
      }
    case _manifest.RECEIVE_MANIFEST:
      {
        var _subjects = (0, _assign2.default)({}, action.payload.manifest.subjects);
        var subjectsArray = [];
        for (var i = 0; i < (0, _keys2.default)(_subjects).length; i++) {
          subjectsArray.push({
            id: parseInt((0, _keys2.default)(_subjects)[i]),
            name: (0, _values2.default)(_subjects)[i]
          });
        }
        return (0, _assign2.default)({}, state, {
          items: subjectsArray,
          isFetching: false
        });
      }
    case _manifest.FAILED_MANIFEST:
      {
        return (0, _assign2.default)({}, state, {
          isFetching: false,
          items: []
        });
      }
    default:
      {
        return state;
      }
  }
}

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.tags = tags;

var _tags = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function tags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _tags.FETCH_TAGS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _tags.FETCH_TAGS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: action.tags
      });
    case _tags.FETCH_TAGS_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: []
      });
    default:
      return state;
  }
}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.topicclouds = topicclouds;

var _topicclouds = __webpack_require__(239);

var _organization = __webpack_require__(203);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  items: [],
  isFetchingTopicClouds: false,
  isFetchingTopic: false,
  isFetchingTopicCloud: false,
  currentTopicCloud: null,
  currentTopic: null
};

function topicclouds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _topicclouds.FETCH_TOPIC_CLOUDS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicClouds: true,
        currentTopicCloud: null,
        currentTopic: null
      });
    case _topicclouds.FETCH_TOPIC_CLOUDS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicClouds: false,
        items: action.topicclouds
      });
    case _topicclouds.FETCH_TOPIC_CLOUDS_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicClouds: false,
        items: []
      });
    case _topicclouds.FETCH_TOPIC_CLOUD_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicCloud: true,
        currentTopic: null
      });
    case _topicclouds.FETCH_TOPIC_CLOUD_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicCloud: false,
        currentTopicCloud: action.topiccloud
      });
    case _topicclouds.FETCH_TOPIC_CLOUD_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetchingTopicCloud: false,
        currentTopicCloud: null
      });
    case _topicclouds.FETCH_TOPIC_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetchingTopic: true
      });
    case _topicclouds.FETCH_TOPIC_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetchingTopic: false,
        currentTopic: action.topic
      });
    case _topicclouds.FETCH_TOPIC_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetchingTopic: false,
        currentTopic: null
      });
    case _topicclouds.CLEAR_CURRENT_TOPIC_CLOUD:
      return (0, _assign2.default)({}, state, {
        currentTopicCloud: null,
        currentTopic: null
      });
    case _organization.SET_CURRENT_ORGANIZATION:
      return (0, _assign2.default)({}, state, {
        items: [],
        isFetchingTopicClouds: false,
        isFetchingTopic: false,
        isFetchingTopicCloud: false,
        currentTopicCloud: null,
        currentTopic: null
      });
    default:
      return state;
  }
}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.topics = topics;

var _topics = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  topicSearchResults: [],
  isSearching: false
};

function topics() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _topics.SEARCH_TOPICS_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          topicSearchResults: [],
          isSearching: true
        });
      }
    case _topics.SEARCH_TOPICS_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          topicSearchResults: action.topics,
          isSearching: false
        });
      }
    case _topics.SEARCH_TOPICS_FAILURE:
      {
        return (0, _assign2.default)({}, state, {
          topicSearchResults: [],
          isSearching: false
        });
      }
    default:
      return state;
  }
}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.user = user;

var _user = __webpack_require__(73);

var _organization = __webpack_require__(203);

var _account = __webpack_require__(297);

var _assignment = __webpack_require__(241);

var _policies = __webpack_require__(158);

var _review = __webpack_require__(159);

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  token: null,
  userName: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  questCounts: null,
  isEditingAccount: false,
  isUpdatingAccount: false,
  stats: null,
  isLoading: false,
  userNeedsToResetPassword: false,
  user: null
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _user.LOGIN_USER_REQUEST:
      return (0, _assign2.default)({}, state, {
        isAuthenticating: true,
        statusText: null,
        stats: null
      });
    case _user.LOGIN_USER_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isAuthenticating: false,
        isAuthenticated: true,
        token: action.payload.token,
        userName: action.payload.name,
        user: action.payload.user
      });
    case _user.LOGIN_USER_FAILURE:
      return (0, _assign2.default)({}, state, {
        isAuthenticating: false,
        isAuthenticated: false,
        token: null,
        userName: null,
        statusText: action.payload.statusText
      });
    case _user.LOGOUT_USER:
      return (0, _assign2.default)({}, state, {
        isAuthenticated: false,
        isAuthenticating: false,
        token: null,
        userName: null,
        user: null,
        statusText: null,
        questCounts: null,
        stats: null
      });
    case _user.USER_DATA_SUCCESS:
      return (0, _assign2.default)({}, state, {
        questCounts: action.questCounts
      });
    case _user.USER_DATA_FAILURE:
      return (0, _assign2.default)({}, state, {
        statusText: action.payload.statusText
      });
    case _organization.SET_CURRENT_ORGANIZATION_ROLES:
      var user = {};
      (0, _assign2.default)(user, state.user);
      user.organization_roles = action.roles;
      return (0, _assign2.default)({}, state, {
        user: user
      });
    case _account.UPDATE_ACCOUNT_REQUEST:
      return (0, _assign2.default)({}, state, {
        isUpdatingAccount: true
      });
    case _account.UPDATE_ACCOUNT_SUCCESS:
      var newUser = {};
      (0, _assign2.default)(newUser, state.user);
      newUser.photo.url = action.file;
      newUser.about = action.about;
      return (0, _assign2.default)({}, state, {
        isUpdatingAccount: false,
        user: newUser
      });
    case _account.UPDATE_ACCOUNT_FAILURE:
      return (0, _assign2.default)({}, state, {
        isUpdatingAccount: false
      });
    case _account.IS_EDITING_ACCOUNT:
      return (0, _assign2.default)({}, state, {
        isEditingAccount: true
      });
    case _account.IS_NOT_EDITING_ACCOUNT:
      return (0, _assign2.default)({}, state, {
        isEditingAccount: false
      });
    case _user.GET_USER_DATA_REQUEST:
      {
        return (0, _assign2.default)({}, state, {
          isLoading: true
        });
      }
    case _user.GET_USER_DATA_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          stats: action.payload.stats,
          isLoading: false
        });
      }
    case _assignment.ASSIGN_QUEST_TO_USER_SUCCESS:
      {
        return (0, _assign2.default)({}, state, {
          stats: (0, _assign2.default)({}, state.stats, {
            assigned_quests_count: action.payload.assignment.assigned_quests_count
          })
        });
      }
    case _review.CREATE_COMPILED_QUEST_SUCCESS:
      {
        var assignmentCount = state.stats.assigned_quests_count;
        if (action.payload.userIsAssignedQuest) {
          assignmentCount = parseInt(assignmentCount) - 1;
        }
        return (0, _assign2.default)({}, state, {
          stats: (0, _assign2.default)({}, state.stats, {
            assigned_quests_count: assignmentCount
          })
        });
      }
    case _reactRouterRedux.LOCATION_CHANGE:
      {
        return (0, _assign2.default)({}, state, {
          statusText: ''
        });
      }
    case _assignment.UNASSIGN_QUEST_FROM_USER_SUCCESS:
      {
        var newAssignedQuestsCount = state.stats.assigned_quests_count;
        if (action.assignedToCurrentUser) {
          newAssignedQuestsCount -= 1;
        }
        return (0, _assign2.default)({}, state, {
          stats: (0, _assign2.default)({}, state.stats, {
            assigned_quests_count: newAssignedQuestsCount
          })
        });
      }
    case _user.USER_NEEDS_TO_RESET_PASSWORD:
      {
        if (action.userNeedsToResetPassword) {
          return (0, _assign2.default)({}, state, {
            userNeedsToResetPassword: true,
            isLoading: false
          });
        } else {
          var u = {};
          (0, _assign2.default)(u, state.user);
          u.require_password_change_on_next_login = false;
          return (0, _assign2.default)({}, state, {
            userNeedsToResetPassword: false,
            user: u
          });
        }
      }
    case _user.USER_IS_LOGGED_IN_FETCHING_ALL_DATA:
      {
        return (0, _assign2.default)({}, state, {
          userIsLoggedInFetchingAllData: true
        });
      }
    case _user.USER_IS_LOGGED_IN_DATA_FETCHED:
      {
        return (0, _assign2.default)({}, state, {
          userIsLoggedInFetchingAllData: false
        });
      }
    case _policies.SET_ACCEPTED_POLICIES_TO_USER:
      {
        var policies = action.payload.policies.split(',');
        var formattedPolicies = policies.reduce(function (o, value, currentIndex) {
          return (0, _assign2.default)({}, o, (0, _defineProperty3.default)({}, currentIndex, value));
        }, {});
        return (0, _assign2.default)({}, state, {
          user: (0, _assign2.default)({}, state.user, {
            policies_acceptance: formattedPolicies
          })
        });
      }
    default:
      return state;
  }
}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1087);
var $Object = __webpack_require__(43).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(70);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(104), 'Object', { defineProperty: __webpack_require__(132).f });


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.users = users;

var _users = __webpack_require__(299);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  items: []
};

function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _users.GET_USERS_REQUEST:
      return (0, _assign2.default)({}, state, {
        isFetching: true
      });
    case _users.GET_USERS_SUCCESS:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: action.users
      });
    case _users.GET_USERS_FAILURE:
      return (0, _assign2.default)({}, state, {
        isFetching: false,
        items: []
      });
    default:
      return state;
  }
}

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = exports.defaults = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(1090);

var _helpers = __webpack_require__(564);

var _defaults = __webpack_require__(1093);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates logger with following options
 *
 * @namespace
 * @param {object} options - options for logger
 * @param {string | function | object} options.level - console[level]
 * @param {boolean} options.duration - print duration of each action?
 * @param {boolean} options.timestamp - print timestamp with each action?
 * @param {object} options.colors - custom colors
 * @param {object} options.logger - implementation of the `console` API
 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
 * @param {boolean} options.collapsed - is group collapsed?
 * @param {boolean} options.predicate - condition which resolves logger behavior
 * @param {function} options.stateTransformer - transform state before print
 * @param {function} options.actionTransformer - transform action before print
 * @param {function} options.errorTransformer - transform error before print
 *
 * @returns {function} logger middleware
 */
function createLogger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var loggerOptions = _extends({}, _defaults2.default, options);

  var logger = loggerOptions.logger,
      transformer = loggerOptions.transformer,
      stateTransformer = loggerOptions.stateTransformer,
      errorTransformer = loggerOptions.errorTransformer,
      predicate = loggerOptions.predicate,
      logErrors = loggerOptions.logErrors,
      diffPredicate = loggerOptions.diffPredicate;

  // Return if 'console' object is not defined

  if (typeof logger === 'undefined') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  if (transformer) {
    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
  }

  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
  if (options.getState && options.dispatch) {
    // eslint-disable-next-line no-console
    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');

    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var logBuffer = [];

  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        // Exit early if predicate function returns 'false'
        if (typeof predicate === 'function' && !predicate(getState, action)) {
          return next(action);
        }

        var logEntry = {};
        logBuffer.push(logEntry);

        logEntry.started = _helpers.timer.now();
        logEntry.startedTime = new Date();
        logEntry.prevState = stateTransformer(getState());
        logEntry.action = action;

        var returnedValue = void 0;
        if (logErrors) {
          try {
            returnedValue = next(action);
          } catch (e) {
            logEntry.error = errorTransformer(e);
          }
        } else {
          returnedValue = next(action);
        }

        logEntry.took = _helpers.timer.now() - logEntry.started;
        logEntry.nextState = stateTransformer(getState());

        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;

        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
        logBuffer.length = 0;

        if (logEntry.error) throw logEntry.error;
        return returnedValue;
      };
    };
  };
}

var defaultLogger = createLogger();

exports.defaults = _defaults2.default;
exports.logger = defaultLogger;
exports.default = createLogger;
module.exports = exports['default'];


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.printBuffer = printBuffer;

var _helpers = __webpack_require__(564);

var _diff = __webpack_require__(1091);

var _diff2 = _interopRequireDefault(_diff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Get log level string based on supplied params
 *
 * @param {string | function | object} level - console[level]
 * @param {object} action - selected action
 * @param {array} payload - selected payload
 * @param {string} type - log entry type
 *
 * @returns {string} level
 */
function getLogLevel(level, action, payload, type) {
  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
    case 'object':
      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
    case 'function':
      return level(action);
    default:
      return level;
  }
}

function defaultTitleFormatter(options) {
  var timestamp = options.timestamp,
      duration = options.duration;


  return function (action, time, took) {
    var parts = ['action'];

    parts.push('%c' + String(action.type));
    if (timestamp) parts.push('%c@ ' + time);
    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');

    return parts.join(' ');
  };
}

function printBuffer(buffer, options) {
  var logger = options.logger,
      actionTransformer = options.actionTransformer,
      _options$titleFormatt = options.titleFormatter,
      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
      collapsed = options.collapsed,
      colors = options.colors,
      level = options.level,
      diff = options.diff;


  buffer.forEach(function (logEntry, key) {
    var started = logEntry.started,
        startedTime = logEntry.startedTime,
        action = logEntry.action,
        prevState = logEntry.prevState,
        error = logEntry.error;
    var took = logEntry.took,
        nextState = logEntry.nextState;

    var nextEntry = buffer[key + 1];

    if (nextEntry) {
      nextState = nextEntry.prevState;
      took = nextEntry.started - started;
    }

    // Message
    var formattedAction = actionTransformer(action);
    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
      return nextState;
    }, action, logEntry) : collapsed;

    var formattedTime = (0, _helpers.formatTime)(startedTime);
    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
    var headerCSS = ['color: gray; font-weight: lighter;'];
    headerCSS.push(titleCSS);
    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
    var title = titleFormatter(formattedAction, formattedTime, took);

    // Render
    try {
      if (isCollapsed) {
        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
      } else {
        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
      }
    } catch (e) {
      logger.log(title);
    }

    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');

    if (prevStateLevel) {
      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
    }

    if (actionLevel) {
      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
    }

    if (error && errorLevel) {
      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
    }

    if (nextStateLevel) {
      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
    }

    if (diff) {
      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
    }

    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('\u2014\u2014 log end \u2014\u2014');
    }
  });
}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diffLogger;

var _deepDiff = __webpack_require__(1092);

var _deepDiff2 = _interopRequireDefault(_deepDiff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// https://github.com/flitbit/diff#differences
var dictionary = {
  'E': {
    color: '#2196F3',
    text: 'CHANGED:'
  },
  'N': {
    color: '#4CAF50',
    text: 'ADDED:'
  },
  'D': {
    color: '#F44336',
    text: 'DELETED:'
  },
  'A': {
    color: '#2196F3',
    text: 'ARRAY:'
  }
};

function style(kind) {
  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
}

function render(diff) {
  var kind = diff.kind,
      path = diff.path,
      lhs = diff.lhs,
      rhs = diff.rhs,
      index = diff.index,
      item = diff.item;


  switch (kind) {
    case 'E':
      return [path.join('.'), lhs, '\u2192', rhs];
    case 'N':
      return [path.join('.'), rhs];
    case 'D':
      return [path.join('.')];
    case 'A':
      return [path.join('.') + '[' + index + ']', item];
    default:
      return [];
  }
}

function diffLogger(prevState, newState, logger, isCollapsed) {
  var diff = (0, _deepDiff2.default)(prevState, newState);

  try {
    if (isCollapsed) {
      logger.groupCollapsed('diff');
    } else {
      logger.group('diff');
    }
  } catch (e) {
    logger.log('diff');
  }

  if (diff) {
    diff.forEach(function (elem) {
      var kind = elem.kind;

      var output = render(elem);

      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
    });
  } else {
    logger.log('\u2014\u2014 no diff \u2014\u2014');
  }

  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
  }
}
module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * deep-diff.
 * Licensed under the MIT License.
 */
;(function(root, factory) {
  'use strict';
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.DeepDiff = factory();
  }
}(this, function(undefined) {
  'use strict';

  var $scope, conflict, conflictResolution = [];
  if (typeof global === 'object' && global) {
    $scope = global;
  } else if (typeof window !== 'undefined') {
    $scope = window;
  } else {
    $scope = {};
  }
  conflict = $scope.DeepDiff;
  if (conflict) {
    conflictResolution.push(
      function() {
        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
          $scope.DeepDiff = conflict;
          conflict = undefined;
        }
      });
  }

  // nodejs compatible on server side and in the browser.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }

  function Diff(kind, path) {
    Object.defineProperty(this, 'kind', {
      value: kind,
      enumerable: true
    });
    if (path && path.length) {
      Object.defineProperty(this, 'path', {
        value: path,
        enumerable: true
      });
    }
  }

  function DiffEdit(path, origin, value) {
    DiffEdit.super_.call(this, 'E', path);
    Object.defineProperty(this, 'lhs', {
      value: origin,
      enumerable: true
    });
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffEdit, Diff);

  function DiffNew(path, value) {
    DiffNew.super_.call(this, 'N', path);
    Object.defineProperty(this, 'rhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffNew, Diff);

  function DiffDeleted(path, value) {
    DiffDeleted.super_.call(this, 'D', path);
    Object.defineProperty(this, 'lhs', {
      value: value,
      enumerable: true
    });
  }
  inherits(DiffDeleted, Diff);

  function DiffArray(path, index, item) {
    DiffArray.super_.call(this, 'A', path);
    Object.defineProperty(this, 'index', {
      value: index,
      enumerable: true
    });
    Object.defineProperty(this, 'item', {
      value: item,
      enumerable: true
    });
  }
  inherits(DiffArray, Diff);

  function arrayRemove(arr, from, to) {
    var rest = arr.slice((to || from) + 1 || arr.length);
    arr.length = from < 0 ? arr.length + from : from;
    arr.push.apply(arr, rest);
    return arr;
  }

  function realTypeOf(subject) {
    var type = typeof subject;
    if (type !== 'object') {
      return type;
    }

    if (subject === Math) {
      return 'math';
    } else if (subject === null) {
      return 'null';
    } else if (Array.isArray(subject)) {
      return 'array';
    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
      return 'date';
    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
      return 'regexp';
    }
    return 'object';
  }

  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
    path = path || [];
    var currentPath = path.slice(0);
    if (typeof key !== 'undefined') {
      if (prefilter) {
        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
        else if (typeof(prefilter) === 'object') {
          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
          if (prefilter.normalize) {
            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
            if (alt) {
              lhs = alt[0];
              rhs = alt[1];
            }
          }
        }
      }
      currentPath.push(key);
    }

    // Use string comparison for regexes
    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
      lhs = lhs.toString();
      rhs = rhs.toString();
    }

    var ltype = typeof lhs;
    var rtype = typeof rhs;
    if (ltype === 'undefined') {
      if (rtype !== 'undefined') {
        changes(new DiffNew(currentPath, rhs));
      }
    } else if (rtype === 'undefined') {
      changes(new DiffDeleted(currentPath, lhs));
    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
      stack = stack || [];
      if (stack.indexOf(lhs) < 0) {
        stack.push(lhs);
        if (Array.isArray(lhs)) {
          var i, len = lhs.length;
          for (i = 0; i < lhs.length; i++) {
            if (i >= rhs.length) {
              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
            } else {
              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
            }
          }
          while (i < rhs.length) {
            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
          }
        } else {
          var akeys = Object.keys(lhs);
          var pkeys = Object.keys(rhs);
          akeys.forEach(function(k, i) {
            var other = pkeys.indexOf(k);
            if (other >= 0) {
              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
              pkeys = arrayRemove(pkeys, other);
            } else {
              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
            }
          });
          pkeys.forEach(function(k) {
            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
          });
        }
        stack.length = stack.length - 1;
      }
    } else if (lhs !== rhs) {
      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
        changes(new DiffEdit(currentPath, lhs, rhs));
      }
    }
  }

  function accumulateDiff(lhs, rhs, prefilter, accum) {
    accum = accum || [];
    deepDiff(lhs, rhs,
      function(diff) {
        if (diff) {
          accum.push(diff);
        }
      },
      prefilter);
    return (accum.length) ? accum : undefined;
  }

  function applyArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    } else {
      switch (change.kind) {
        case 'A':
          applyArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr = arrayRemove(arr, index);
          break;
        case 'E':
        case 'N':
          arr[index] = change.rhs;
          break;
      }
    }
    return arr;
  }

  function applyChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i = -1,
          last = change.path ? change.path.length - 1 : 0;
      while (++i < last) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
          break;
        case 'D':
          delete it[change.path[i]];
          break;
        case 'E':
        case 'N':
          it[change.path[i]] = change.rhs;
          break;
      }
    }
  }

  function revertArrayChange(arr, index, change) {
    if (change.path && change.path.length) {
      // the structure of the object at the index has changed...
      var it = arr[index],
          i, u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          delete it[change.path[i]];
          break;
      }
    } else {
      // the array item is different...
      switch (change.kind) {
        case 'A':
          revertArrayChange(arr[index], change.index, change.item);
          break;
        case 'D':
          arr[index] = change.lhs;
          break;
        case 'E':
          arr[index] = change.lhs;
          break;
        case 'N':
          arr = arrayRemove(arr, index);
          break;
      }
    }
    return arr;
  }

  function revertChange(target, source, change) {
    if (target && source && change && change.kind) {
      var it = target,
          i, u;
      u = change.path.length - 1;
      for (i = 0; i < u; i++) {
        if (typeof it[change.path[i]] === 'undefined') {
          it[change.path[i]] = {};
        }
        it = it[change.path[i]];
      }
      switch (change.kind) {
        case 'A':
          // Array was modified...
          // it will be an array...
          revertArrayChange(it[change.path[i]], change.index, change.item);
          break;
        case 'D':
          // Item was deleted...
          it[change.path[i]] = change.lhs;
          break;
        case 'E':
          // Item was edited...
          it[change.path[i]] = change.lhs;
          break;
        case 'N':
          // Item is new...
          delete it[change.path[i]];
          break;
      }
    }
  }

  function applyDiff(target, source, filter) {
    if (target && source) {
      var onChange = function(change) {
        if (!filter || filter(target, source, change)) {
          applyChange(target, source, change);
        }
      };
      deepDiff(target, source, onChange);
    }
  }

  Object.defineProperties(accumulateDiff, {

    diff: {
      value: accumulateDiff,
      enumerable: true
    },
    observableDiff: {
      value: deepDiff,
      enumerable: true
    },
    applyDiff: {
      value: applyDiff,
      enumerable: true
    },
    applyChange: {
      value: applyChange,
      enumerable: true
    },
    revertChange: {
      value: revertChange,
      enumerable: true
    },
    isConflict: {
      value: function() {
        return 'undefined' !== typeof conflict;
      },
      enumerable: true
    },
    noConflict: {
      value: function() {
        if (conflictResolution) {
          conflictResolution.forEach(function(it) {
            it();
          });
          conflictResolution = null;
        }
        return accumulateDiff;
      },
      enumerable: true
    }
  });

  return accumulateDiff;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  level: "log",
  logger: console,
  logErrors: true,
  collapsed: undefined,
  predicate: undefined,
  duration: false,
  timestamp: true,
  stateTransformer: function stateTransformer(state) {
    return state;
  },
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  errorTransformer: function errorTransformer(error) {
    return error;
  },
  colors: {
    title: function title() {
      return "inherit";
    },
    prevState: function prevState() {
      return "#9E9E9E";
    },
    action: function action() {
      return "#03A9F4";
    },
    nextState: function nextState() {
      return "#4CAF50";
    },
    error: function error() {
      return "#F20404";
    }
  },
  diff: false,
  diffPredicate: undefined,

  // Deprecated options
  transformer: undefined
};
module.exports = exports["default"];

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux-persist/es/constants.js
var constants = __webpack_require__(205);

// EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(1095);

// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/utils/isStatePlainEnough.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!lodash_es_isPlainObject(a)) return false;
  return true;
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/autoRehydrate.js
var autoRehydrate__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== constants["REHYDRATE"]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (autoRehydrate__typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (isStatePlainEnough(inboundState[key]) && isStatePlainEnough(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}
// EXTERNAL MODULE: ./node_modules/redux-persist/es/defaults/asyncLocalStorage.js
var asyncLocalStorage = __webpack_require__(406);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/purgeStoredState.js


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}
// EXTERNAL MODULE: ./node_modules/json-stringify-safe/stringify.js
var stringify = __webpack_require__(1096);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/createPersistor.js





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || Object(asyncLocalStorage["a" /* default */])('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return purgeStoredState({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return stringify_default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: constants["REHYDRATE"],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/createTransform.js
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ var es_createTransform = (createTransform);
// CONCATENATED MODULE: ./node_modules/redux-persist/es/getStoredState.js
var getStoredState__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || Object(asyncLocalStorage["a" /* default */])('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : getStoredState_defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : constants["KEY_PREFIX"];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = getStoredState__extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function getStoredState_defaultDeserializer(serial) {
  return JSON.parse(serial);
}
// EXTERNAL MODULE: ./node_modules/redux-persist/es/utils/setImmediate.js
var setImmediate = __webpack_require__(565);

// CONCATENATED MODULE: ./node_modules/redux-persist/es/persistStore.js
var persistStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = createPersistor(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(setImmediate["a" /* default */])(function () {
      getStoredState(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(persistStore_rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(setImmediate["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return persistStore__extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function persistStore_rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: constants["REHYDRATE"],
    payload: payload,
    error: error
  };
}
// CONCATENATED MODULE: ./node_modules/redux-persist/es/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return autoRehydrate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createPersistor", function() { return createPersistor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createTransform", function() { return es_createTransform; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getStoredState", function() { return getStoredState; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "persistStore", function() { return persistStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return purgeStoredState; });







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};



/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asyncLocalStorage", function() { return asyncLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asyncSessionStorage", function() { return asyncSessionStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_asyncLocalStorage__ = __webpack_require__(406);


var asyncLocalStorage = Object(__WEBPACK_IMPORTED_MODULE_0__defaults_asyncLocalStorage__["a" /* default */])('local');
var asyncSessionStorage = Object(__WEBPACK_IMPORTED_MODULE_0__defaults_asyncLocalStorage__["a" /* default */])('session');

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var BUFFERED_ACTION_RETURN = 'redux-action-buffer: buffered action'

var setImmediate = typeof global !== 'undefined' &&
  typeof global.setImmediate !== 'undefined'
  ? global.setImmediate
  : setTimeout

module.exports = function bufferActions(options, cb) {
  var active = true
  var queue = []
  var passthrough = (options && options.passthrough) || []
  var breaker = typeof options === 'object' ? options.breaker : options

  var breakerType = typeof breaker

  if (breakerType === 'string' || breakerType === 'symbol') {
    var actionType = breaker
    breaker = function(action) {
      if (action.type === actionType) return true
      else return false
    }
  }

  return function(store) {
    return function(next) {
      return function(action) {
        // console.log("next", next, action);
        if (!active || passthrough.includes(action.type)) return next(action)
        if (breaker(action)) {
          active = false
          var result = next(action)
          setImmediate(function() {
            var queueResults = []
            queue.forEach(function(queuedAction) {
              var queuedActionResult = next(queuedAction)
              queueResults.push(queuedActionResult)
            })
            cb &&
              cb(null, {
                results: queueResults,
                queue: queue
              })
          })
          return result
        } else {
          queue.push(action)
          // @TODO consider returning a dummy action, or maybe null for cleanliness
          return BUFFERED_ACTION_RETURN
        }
      }
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(93)))

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* istanbul ignore next */
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (callback, thisArg) {
    var T, k;

    if (this === null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {
      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

/* istanbul ignore next */
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(201);

var _reactQuery = __webpack_require__(34);

var _index = __webpack_require__(1126);

var _index2 = _interopRequireDefault(_index);

__webpack_require__(1745);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryClient = new _reactQuery.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true
    }
  }
});

var Root = function (_Component) {
  (0, _inherits3.default)(Root, _Component);

  function Root() {
    (0, _classCallCheck3.default)(this, Root);
    return (0, _possibleConstructorReturn3.default)(this, (Root.__proto__ || (0, _getPrototypeOf2.default)(Root)).apply(this, arguments));
  }

  (0, _createClass3.default)(Root, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var i = localStorage.length;
      while (i-- > 0) {
        var key = localStorage.key(i);
        if (key.includes('reduxPersist')) {
          localStorage.removeItem(key);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history;


      return _react2.default.createElement(
        _reactQuery.QueryClientProvider,
        { client: queryClient },
        _react2.default.createElement(
          _reactRedux.Provider,
          { store: store },
          _react2.default.createElement(_reactRouter.Router, { history: history, routes: _index2.default })
        )
      );
    }
  }]);
  return Root;
}(_react.Component);

exports.default = Root;


Root.propTypes = {
  store: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1102);
module.exports = __webpack_require__(43).Object.getPrototypeOf;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(196);
var $getPrototypeOf = __webpack_require__(492);

__webpack_require__(392)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1104), __esModule: true };

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1105);
module.exports = __webpack_require__(43).Object.setPrototypeOf;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(70);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1106).set });


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(133);
var anObject = __webpack_require__(119);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(192)(Function.call, __webpack_require__(541).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1108), __esModule: true };

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1109);
var $Object = __webpack_require__(43).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(70);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(350) });


/***/ }),
/* 1110 */,
/* 1111 */,
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueryClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queryCache__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutationCache__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__focusManager__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onlineManager__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__infiniteQueryBehavior__ = __webpack_require__(570);








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new __WEBPACK_IMPORTED_MODULE_2__queryCache__["a" /* QueryCache */]();
    this.mutationCache = config.mutationCache || new __WEBPACK_IMPORTED_MODULE_3__mutationCache__["a" /* MutationCache */]();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = __WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].subscribe(function () {
      if (__WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused() && __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].subscribe(function () {
      if (__WEBPACK_IMPORTED_MODULE_4__focusManager__["a" /* focusManager */].isFocused() && __WEBPACK_IMPORTED_MODULE_5__onlineManager__["a" /* onlineManager */].isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* parseQueryArgs */])(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      active: true
    });

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["m" /* parseFilterArgs */])(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* parseQueryArgs */])(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["p" /* parseQueryArgs */])(arg1, arg2, arg3);
    parsedOptions.behavior = Object(__WEBPACK_IMPORTED_MODULE_7__infiniteQueryBehavior__["c" /* infiniteQueryBehavior */])();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = __WEBPACK_IMPORTED_MODULE_6__notifyManager__["a" /* notifyManager */].batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]).catch(__WEBPACK_IMPORTED_MODULE_1__utils__["l" /* noop */]);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(queryKey) === Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* partialMatchKey */])(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(mutationKey) === Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* hashQueryKey */])(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["q" /* partialMatchKey */])(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* hashQueryKeyByOptions */])(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dehydrate;
/* harmony export (immutable) */ __webpack_exports__["b"] = hydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


// TYPES
// FUNCTIONS
function dehydrateMutation(mutation) {
  return {
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.


function dehydrateQuery(query) {
  return {
    state: query.state,
    queryKey: query.queryKey,
    queryHash: query.queryHash
  };
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === 'success';
}

function dehydrate(client, options) {
  var _options, _options2;

  options = options || {};
  var mutations = [];
  var queries = [];

  if (((_options = options) == null ? void 0 : _options.dehydrateMutations) !== false) {
    var shouldDehydrateMutation = options.shouldDehydrateMutation || defaultShouldDehydrateMutation;
    client.getMutationCache().getAll().forEach(function (mutation) {
      if (shouldDehydrateMutation(mutation)) {
        mutations.push(dehydrateMutation(mutation));
      }
    });
  }

  if (((_options2 = options) == null ? void 0 : _options2.dehydrateQueries) !== false) {
    var shouldDehydrateQuery = options.shouldDehydrateQuery || defaultShouldDehydrateQuery;
    client.getQueryCache().getAll().forEach(function (query) {
      if (shouldDehydrateQuery(query)) {
        queries.push(dehydrateQuery(query));
      }
    });
  }

  return {
    mutations: mutations,
    queries: queries
  };
}
function hydrate(client, dehydratedState, options) {
  if (typeof dehydratedState !== 'object' || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (dehydratedMutation) {
    var _options$defaultOptio;

    mutationCache.build(client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations, {
      mutationKey: dehydratedMutation.mutationKey
    }), dehydratedMutation.state);
  });
  queries.forEach(function (dehydratedQuery) {
    var _options$defaultOptio2;

    var query = queryCache.get(dehydratedQuery.queryHash); // Do not hydrate if an existing query exists with newer data

    if (query) {
      if (query.state.dataUpdatedAt < dehydratedQuery.state.dataUpdatedAt) {
        query.setState(dehydratedQuery.state);
      }

      return;
    } // Restore query


    queryCache.build(client, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries, {
      queryKey: dehydratedQuery.queryKey,
      queryHash: dehydratedQuery.queryHash
    }), dehydratedQuery.state);
  });
}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {



/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setBatchUpdatesFn__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setLogger__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryClientProvider", function() { return __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQueryClient", function() { return __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryErrorResetBoundary__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "QueryErrorResetBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__QueryErrorResetBoundary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQueryErrorResetBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__QueryErrorResetBoundary__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useIsFetching__ = __webpack_require__(1118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useIsFetching", function() { return __WEBPACK_IMPORTED_MODULE_4__useIsFetching__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useIsMutating__ = __webpack_require__(1119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useIsMutating", function() { return __WEBPACK_IMPORTED_MODULE_5__useIsMutating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useMutation__ = __webpack_require__(1120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useMutation", function() { return __WEBPACK_IMPORTED_MODULE_6__useMutation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__useQuery__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQuery", function() { return __WEBPACK_IMPORTED_MODULE_7__useQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useQueries__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useQueries", function() { return __WEBPACK_IMPORTED_MODULE_8__useQueries__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__useInfiniteQuery__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useInfiniteQuery", function() { return __WEBPACK_IMPORTED_MODULE_9__useInfiniteQuery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Hydrate__ = __webpack_require__(1124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useHydrate", function() { return __WEBPACK_IMPORTED_MODULE_10__Hydrate__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hydrate", function() { return __WEBPACK_IMPORTED_MODULE_10__Hydrate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__types__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_11__types__) if(["QueryClientProvider","useQueryClient","QueryErrorResetBoundary","useQueryErrorResetBoundary","useIsFetching","useIsMutating","useMutation","useQuery","useQueries","useInfiniteQuery","useHydrate","Hydrate","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_11__types__[key]; }) }(__WEBPACK_IMPORT_KEY__));
// Side effects










 // Types



/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react-query/es/core/index.js
var core = __webpack_require__(243);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(32);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// CONCATENATED MODULE: ./node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom_default.a.unstable_batchedUpdates;
// CONCATENATED MODULE: ./node_modules/react-query/es/react/setBatchUpdatesFn.js


core["notifyManager"].setBatchNotifyFunction(unstable_batchedUpdates);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react-query/es/core/index.js
var core = __webpack_require__(243);

// CONCATENATED MODULE: ./node_modules/react-query/es/react/logger.js
var logger = console;
// CONCATENATED MODULE: ./node_modules/react-query/es/react/setLogger.js


Object(core["setLogger"])(logger);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFetching;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(186);




function useIsFetching(arg1, arg2) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();

  var _parseFilterArgs = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils__["m" /* parseFilterArgs */])(arg1, arg2),
      filters = _parseFilterArgs[0];

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(queryClient.isFetching(filters)),
      isFetching = _React$useState[0],
      setIsFetching = _React$useState[1];

  var filtersRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(filters);
  filtersRef.current = filters;
  var isFetchingRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(isFetching);
  isFetchingRef.current = isFetching;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = queryClient.getQueryCache().subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        var newIsFetching = queryClient.isFetching(filtersRef.current);

        if (isFetchingRef.current !== newIsFetching) {
          setIsFetching(newIsFetching);
        }
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient]);
  return isFetching;
}

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsMutating;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(186);




function useIsMutating(arg1, arg2) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var filters = Object(__WEBPACK_IMPORTED_MODULE_2__core_utils__["o" /* parseMutationFilterArgs */])(arg1, arg2);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(queryClient.isMutating(filters)),
      isMutating = _React$useState[0],
      setIsMutating = _React$useState[1];

  var filtersRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(filters);
  filtersRef.current = filters;
  var isMutatingRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(isMutating);
  isMutatingRef.current = isMutating;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = queryClient.getMutationCache().subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        var newIsMutating = queryClient.isMutating(filtersRef.current);

        if (isMutatingRef.current !== newIsMutating) {
          setIsMutating(newIsMutating);
        }
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [queryClient]);
  return isMutating;
}

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMutation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mutationObserver__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QueryClientProvider__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(575);






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var options = Object(__WEBPACK_IMPORTED_MODULE_3__core_utils__["n" /* parseMutationArgs */])(arg1, arg2, arg3);
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_5__QueryClientProvider__["b" /* useQueryClient */])();
  var obsRef = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef();

  if (!obsRef.current) {
    obsRef.current = new __WEBPACK_IMPORTED_MODULE_4__core_mutationObserver__["a" /* MutationObserver */](queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(__WEBPACK_IMPORTED_MODULE_2__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(__WEBPACK_IMPORTED_MODULE_3__core_utils__["l" /* noop */]);
  }, []);

  if (currentResult.error && Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* shouldThrowError */])(undefined, obsRef.current.options.useErrorBoundary, currentResult.error)) {
    throw currentResult.error;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useBaseQuery__ = __webpack_require__(576);


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils__["p" /* parseQueryArgs */])(arg1, arg2, arg3);
  return Object(__WEBPACK_IMPORTED_MODULE_2__useBaseQuery__["a" /* useBaseQuery */])(parsedOptions, __WEBPACK_IMPORTED_MODULE_0__core__["QueryObserver"]);
}

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useQueries;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_notifyManager__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_queriesObserver__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__ = __webpack_require__(186);




function useQueries(queries) {
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_3__QueryClientProvider__["b" /* useQueryClient */])();
  var defaultedQueries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return queries.map(function (options) {
      var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options

      defaultedOptions.optimisticResults = true;
      return defaultedOptions;
    });
  }, [queries, queryClient]);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(function () {
    return new __WEBPACK_IMPORTED_MODULE_2__core_queriesObserver__["a" /* QueriesObserver */](queryClient, defaultedQueries);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedQueries);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = observer.subscribe(__WEBPACK_IMPORTED_MODULE_1__core_notifyManager__["a" /* notifyManager */].batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [observer]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setQueries(defaultedQueries, {
      listeners: false
    });
  }, [defaultedQueries, observer]);
  return result;
}

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useInfiniteQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_infiniteQueryObserver__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useBaseQuery__ = __webpack_require__(576);


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = Object(__WEBPACK_IMPORTED_MODULE_1__core_utils__["p" /* parseQueryArgs */])(arg1, arg2, arg3);
  return Object(__WEBPACK_IMPORTED_MODULE_2__useBaseQuery__["a" /* useBaseQuery */])(options, __WEBPACK_IMPORTED_MODULE_0__core_infiniteQueryObserver__["a" /* InfiniteQueryObserver */]);
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useHydrate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hydrate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__ = __webpack_require__(186);



function useHydrate(state, options) {
  var queryClient = Object(__WEBPACK_IMPORTED_MODULE_2__QueryClientProvider__["b" /* useQueryClient */])();
  var optionsRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(options);
  optionsRef.current = options; // Running hydrate again with the same queries is safe,
  // it wont overwrite or initialize existing queries,
  // relying on useMemo here is only a performance optimization.
  // hydrate can and should be run *during* render here for SSR to work properly

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    if (state) {
      Object(__WEBPACK_IMPORTED_MODULE_1__core__["hydrate"])(queryClient, state, optionsRef.current);
    }
  }, [queryClient, state]);
}
var Hydrate = function Hydrate(_ref) {
  var children = _ref.children,
      options = _ref.options,
      state = _ref.state;
  useHydrate(state, options);
  return children;
};

/***/ }),
/* 1125 */
/***/ (function(module, exports) {



/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(201);

var _Account = __webpack_require__(1127);

var _Account2 = _interopRequireDefault(_Account);

var _App = __webpack_require__(1131);

var _App2 = _interopRequireDefault(_App);

var _ChangePassword = __webpack_require__(1356);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _ForgotPassword = __webpack_require__(1368);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _Login = __webpack_require__(1370);

var _Login2 = _interopRequireDefault(_Login);

var _OurPolicies = __webpack_require__(1372);

var _OurPolicies2 = _interopRequireDefault(_OurPolicies);

var _Policies = __webpack_require__(1374);

var _Policies2 = _interopRequireDefault(_Policies);

var _Quests = __webpack_require__(1375);

var _Quests2 = _interopRequireDefault(_Quests);

var _Quest = __webpack_require__(1456);

var _Quest2 = _interopRequireDefault(_Quest);

var _ResetPassword = __webpack_require__(1648);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _UnlockAccount = __webpack_require__(1649);

var _UnlockAccount2 = _interopRequireDefault(_UnlockAccount);

var _ReviewQueue = __webpack_require__(1650);

var _ReviewQueue2 = _interopRequireDefault(_ReviewQueue);

var _TopicClouds = __webpack_require__(1660);

var _TopicClouds2 = _interopRequireDefault(_TopicClouds);

var _ActivityEdit = __webpack_require__(1667);

var _ActivityEdit2 = _interopRequireDefault(_ActivityEdit);

var _ActivityAdd = __webpack_require__(1673);

var _ActivityAdd2 = _interopRequireDefault(_ActivityAdd);

var _QuestsAdd = __webpack_require__(1674);

var _QuestsAdd2 = _interopRequireDefault(_QuestsAdd);

var _NotFound = __webpack_require__(1675);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Error = __webpack_require__(1676);

var _Error2 = _interopRequireDefault(_Error);

var _Queue = __webpack_require__(1677);

var _Queue2 = _interopRequireDefault(_Queue);

var _MyQuests = __webpack_require__(1679);

var _MyQuests2 = _interopRequireDefault(_MyQuests);

var _ProductionStatus = __webpack_require__(1686);

var _ProductionStatus2 = _interopRequireDefault(_ProductionStatus);

var _MyCourses = __webpack_require__(1701);

var _MyCourses2 = _interopRequireDefault(_MyCourses);

var _AuthenticatedComponent = __webpack_require__(1713);

var _UnauthenticatedComponent = __webpack_require__(1714);

var _RestrictAccess = __webpack_require__(1715);

var _RoleRequiredComponent = __webpack_require__(1716);

var _JourneyDetails = __webpack_require__(1717);

var _JourneyDetails2 = _interopRequireDefault(_JourneyDetails);

var _ActivityDetails = __webpack_require__(1724);

var _ActivityDetails2 = _interopRequireDefault(_ActivityDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { path: '/', component: _App2.default },
  _react2.default.createElement(_reactRouter.Route, { path: 'account', component: (0, _AuthenticatedComponent.requireAuthentication)(_Account2.default) }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'changepassword',
    component: (0, _UnauthenticatedComponent.wrapUnauthenticatedComponent)(_ChangePassword2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'myquests',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_MyQuests2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, { path: 'login', component: (0, _UnauthenticatedComponent.wrapUnauthenticatedComponent)(_Login2.default) }),
  _react2.default.createElement(_reactRouter.Route, { path: 'ourpolicies', component: (0, _AuthenticatedComponent.requireAuthentication)(_OurPolicies2.default) }),
  _react2.default.createElement(_reactRouter.Route, { path: 'policies', component: _Policies2.default }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'productionstatus',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_ProductionStatus2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'quests',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_Quests2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'mycourses',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_MyCourses2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'mycourses/:courseId/journey/:journeyId',
    component: (0, _AuthenticatedComponent.requireAuthentication)(_JourneyDetails2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'mycourses/:courseId/journey/:journeyId/level/:levelId/activityQuest/:activityQuestId',
    component: (0, _AuthenticatedComponent.requireAuthentication)(_ActivityDetails2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'mycourses/:courseId/journey/:journeyId/level/:levelId/activityQuest/:activityQuestId/edit',
    component: (0, _AuthenticatedComponent.requireAuthentication)(_ActivityDetails2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'quest/:id/activities/add',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RoleRequiredComponent.restrictRole)(_ActivityAdd2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'quest/:id(/:section)(/:activityId)',
    component: (0, _AuthenticatedComponent.requireAuthentication)(_Quest2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'resetpassword/:token',
    component: (0, _UnauthenticatedComponent.wrapUnauthenticatedComponent)(_ResetPassword2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'unlockaccount/:token',
    component: (0, _UnauthenticatedComponent.wrapUnauthenticatedComponent)(_UnlockAccount2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'reviewqueue',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_ReviewQueue2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'queue',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_Queue2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'topicclouds',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_TopicClouds2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'quest/:id/activities/:activityId/edit',
    component: (0, _AuthenticatedComponent.requireAuthentication)(_ActivityEdit2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'quests/add',
    component: (0, _AuthenticatedComponent.requireAuthentication)((0, _RestrictAccess.restrictAccess)(_QuestsAdd2.default))
  }),
  _react2.default.createElement(_reactRouter.Route, {
    path: 'forgotpassword',
    component: (0, _UnauthenticatedComponent.wrapUnauthenticatedComponent)(_ForgotPassword2.default)
  }),
  _react2.default.createElement(_reactRouter.Route, { path: 'error', component: (0, _AuthenticatedComponent.requireAuthentication)(_Error2.default) }),
  _react2.default.createElement(_reactRouter.Route, { path: '*', component: (0, _AuthenticatedComponent.requireAuthentication)(_NotFound2.default) })
);

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = __webpack_require__(1128);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactRedux = __webpack_require__(14);

var _reactIntl = __webpack_require__(16);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _account = __webpack_require__(297);

var _messages = __webpack_require__(21);

var _validation = __webpack_require__(577);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Account = function (_Component) {
  (0, _inherits3.default)(Account, _Component);

  function Account(props) {
    (0, _classCallCheck3.default)(this, Account);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Account.__proto__ || (0, _getPrototypeOf2.default)(Account)).call(this, props));

    _this.state = {
      currentPassword: '',
      newPassword: '',
      files: [],
      showPasswords: false
    };

    _this.onImageSelectBound = _this.onImageSelect.bind(_this);
    _this.uploadPhotoBound = _this.uploadPhoto.bind(_this);
    _this.handleCurrentPasswordChangeBound = _this.handleCurrentPasswordChange.bind(_this);
    _this.handleNewPasswordChangeBound = _this.handleNewPasswordChange.bind(_this);
    _this.changePasswordBound = _this.changePassword.bind(_this);
    _this.resetFilesBound = _this.resetFiles.bind(_this);
    _this.toggleShowPasswordsBound = _this.toggleShowPasswords.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Account, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _account.changePasswordReset)());
      window.scrollTo(0, 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.passwordChangeSuccess || nextProps.passwordChangeFailure) {
        document.querySelectorAll('.password').forEach(function (el) {
          el.value = '';
        });

        this.setState({
          currentPassword: '',
          newPassword: '',
          showPasswords: false
        });
      }
    }
  }, {
    key: 'getStatusTextClass',
    value: function getStatusTextClass() {
      var _props = this.props,
          passwordChangeSuccess = _props.passwordChangeSuccess,
          passwordChangeFailure = _props.passwordChangeFailure;

      var klass = ['status-text'];
      if (passwordChangeSuccess) {
        klass.push('success');
      } else if (passwordChangeFailure) {
        klass.push('failure');
      }
      return klass.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          user = _props2.user,
          passwordChangeSuccess = _props2.passwordChangeSuccess,
          passwordChangeFailure = _props2.passwordChangeFailure,
          isChangingPassword = _props2.isChangingPassword;
      var showPasswords = this.state.showPasswords;


      var statusTextClass = this.getStatusTextClass();

      return _react2.default.createElement(
        'div',
        { className: 'account' },
        _react2.default.createElement(
          'form',
          { role: 'form', id: 'frmChangePassword' },
          user && _react2.default.createElement(
            'div',
            { className: 'user-details' },
            _react2.default.createElement(_UserAvatar2.default, { photoUrl: user.photo.url, name: user.name }),
            _react2.default.createElement(
              _UserName2.default,
              {
                activeCertifications: user.active_certifications,
                userId: 'account-' + user.id,
                rebuild: true
              },
              _react2.default.createElement(
                'h3',
                null,
                user.name
              )
            )
          ),
          user && _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement(
                'label',
                null,
                _messages.email
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'email' },
              user.email
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'failure-text' },
            passwordChangeFailure && _react2.default.createElement(
              'div',
              { className: statusTextClass },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Account.CurrentPasswordIsIncorrect',
                defaultMessage: 'Current password is incorrect.'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'currentPasswordTooltip',
              getContent: [function () {
                return !showPasswords ? _messages.clickToShowPassword : _messages.clickToHidePassword;
              }]
            }),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'newPasswordTooltip',
              getContent: [function () {
                return !showPasswords ? _messages.clickToShowPassword : _messages.clickToHidePassword;
              }]
            }),
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'currentPassword' },
                'Current ',
                _messages.password
              )
            ),
            _react2.default.createElement('input', {
              id: 'currentPassword',
              type: showPasswords ? 'text' : 'password',
              className: 'password',
              placeholder: 'Current Password',
              onChange: this.handleCurrentPasswordChangeBound
            }),
            !showPasswords ? _react2.default.createElement(
              'div',
              {
                'data-for': 'currentPasswordTooltip',
                'data-tip': _messages.clickToShowPassword
              },
              _react2.default.createElement('div', {
                className: 'hideshow hidden-icon',
                onClick: this.toggleShowPasswordsBound
              })
            ) : _react2.default.createElement(
              'div',
              {
                'data-for': 'currentPasswordTooltip',
                'data-tip': _messages.clickToHidePassword
              },
              _react2.default.createElement('div', {
                className: 'hideshow shown-icon',
                onClick: this.toggleShowPasswordsBound
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'newPassword' },
                'New ',
                _messages.password
              )
            ),
            _react2.default.createElement('input', {
              id: 'newPassword',
              type: showPasswords ? 'text' : 'password',
              className: 'password',
              placeholder: 'New Password',
              onChange: this.handleNewPasswordChangeBound
            }),
            !showPasswords ? _react2.default.createElement(
              'div',
              { 'data-for': 'newPasswordTooltip', 'data-tip': _messages.clickToShowPassword },
              _react2.default.createElement('div', {
                className: 'hideshow hidden-icon',
                onClick: this.toggleShowPasswordsBound
              })
            ) : _react2.default.createElement(
              'div',
              { 'data-for': 'newPasswordTooltip', 'data-tip': _messages.clickToHidePassword },
              _react2.default.createElement('div', {
                className: 'hideshow shown-icon',
                onClick: this.toggleShowPasswordsBound
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'password-reqs' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Account.Minimum8Characters',
                defaultMessage: 'Minimum 8 characters'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement('label', null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'button-wrapper' },
              isChangingPassword && _react2.default.createElement('div', { className: 'loading small' }),
              !isChangingPassword && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  {
                    type: 'submit',
                    className: 'submit button btn-primary-lite ' + (this.shouldAllowSubmit() ? 'active' : 'disabled'),
                    onClick: this.changePasswordBound
                  },
                  _messages.save
                ),
                _react2.default.createElement(
                  'div',
                  { className: statusTextClass },
                  passwordChangeSuccess && _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'Account.YouUpdatedYourPassword',
                    defaultMessage: 'You updated your password.'
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement(
                'label',
                null,
                _messages.photo
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'image-upload-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'image-wrapper' },
                this.state.files.length > 0 && _react2.default.createElement(
                  'div',
                  { className: 'selected-file' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('img', { src: this.state.files[0].preview }),
                    _react2.default.createElement(
                      'div',
                      { className: 'image-info' },
                      _react2.default.createElement(
                        'div',
                        null,
                        this.state.files[0].name
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        this.state.files[0].size,
                        ' bytes'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactDropzone2.default,
                  {
                    onDrop: this.onImageSelectBound,
                    className: 'image-selection-helper',
                    activeClassName: 'image-selection-helper active'
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Drag an image here, or ',
                    _react2.default.createElement(
                      'span',
                      null,
                      'choose a file'
                    ),
                    ' from your computer.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement(
                'label',
                null,
                '\xA0'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'instructions' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ForBestViewing',
                defaultMessage: 'For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'form-group' },
            _react2.default.createElement(
              'div',
              { className: 'label-wrapper' },
              _react2.default.createElement('label', null)
            ),
            _react2.default.createElement(
              'div',
              { className: 'button-wrapper' },
              this.props.isUploadingPhoto && _react2.default.createElement('div', { className: 'loading' }),
              !this.props.isUploadingPhoto && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  {
                    type: 'submit',
                    className: 'button upload btn-primary-lite ' + (this.state.files.length > 0 ? 'active' : 'disabled'),
                    disabled: this.state.files.length === 0,
                    onClick: this.uploadPhotoBound
                  },
                  _messages.save
                ),
                this.state.files.length > 0 && _react2.default.createElement(
                  'div',
                  {
                    className: 'button cancel',
                    onClick: this.resetFilesBound
                  },
                  _messages.cancel
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'changePassword',
    value: function changePassword(e) {
      e.preventDefault();
      this.shouldAllowSubmit() ? this.props.dispatch((0, _account.changePassword)(this.state.currentPassword, this.state.newPassword)) : null;
    }
  }, {
    key: 'handleCurrentPasswordChange',
    value: function handleCurrentPasswordChange(e) {
      this.setState({ currentPassword: e.target.value });
    }
  }, {
    key: 'handleNewPasswordChange',
    value: function handleNewPasswordChange(e) {
      this.setState({ newPassword: e.target.value });
    }
  }, {
    key: 'onImageSelect',
    value: function onImageSelect(files) {
      this.setState({
        files: files
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      this.setState({ files: [] });
    }
  }, {
    key: 'shouldAllowSubmit',
    value: function shouldAllowSubmit() {
      return (0, _validation.validatePassword)(this.state.newPassword) && this.state.currentPassword.length > 0;
    }
  }, {
    key: 'uploadPhoto',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                this.props.dispatch((0, _account.updateAccount)(this.state.files[0], undefined)).then(this.resetFilesBound);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadPhoto(_x) {
        return _ref.apply(this, arguments);
      }

      return uploadPhoto;
    }()
  }, {
    key: 'toggleShowPasswords',
    value: function toggleShowPasswords() {
      this.setState(function (state) {
        return { showPasswords: !state.showPasswords };
      });
    }
  }]);
  return Account;
}(_react.Component);

Account.propTypes = {
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  isChangingPassword: _propTypes2.default.bool.isRequired,
  isUploadingPhoto: _propTypes2.default.bool.isRequired,
  passwordChangeSuccess: _propTypes2.default.bool.isRequired,
  passwordChangeFailure: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user,
    isChangingPassword: state.account.isChangingPassword,
    isUploadingPhoto: state.user.isUpdatingAccount,
    passwordChangeSuccess: state.account.passwordChangeSuccess,
    passwordChangeFailure: state.account.passwordChangeFailure
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Account);
exports.AccountDisconnected = Account; // pure component - used in tests

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	
	        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
	        // this is so react can handle state changes in the onClick prop above above
	        // see: https://github.com/okonet/react-dropzone/issues/450
	        setTimeout(this.open.bind(this), 0);
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _pusherJs = __webpack_require__(1132);

var _pusherJs2 = _interopRequireDefault(_pusherJs);

var _headroom = __webpack_require__(1133);

var _headroom2 = _interopRequireDefault(_headroom);

var _RefreshApp = __webpack_require__(1134);

var _RefreshApp2 = _interopRequireDefault(_RefreshApp);

var _Nav = __webpack_require__(1135);

var _Nav2 = _interopRequireDefault(_Nav);

var _Footer = __webpack_require__(1166);

var _Footer2 = _interopRequireDefault(_Footer);

var _AcceptPolicyModal = __webpack_require__(1171);

var _AcceptPolicyModal2 = _interopRequireDefault(_AcceptPolicyModal);

var _ModalContainer = __webpack_require__(1172);

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _rollbar = __webpack_require__(1354);

var _appupdate = __webpack_require__(547);

var _utils = __webpack_require__(20);

var _pusher = __webpack_require__(263);

var _routes = __webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined' && window.location && window.location.protocol === 'http:' && !(0, _utils.isLocalHost)()) {
        window.location.href = window.location.href.replace(/^http(?!s)/, 'https');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.children === null) {
        this.props.dispatch((0, _reactRouterRedux.push)('/login'));
      }

      var headroom = new _headroom2.default(document.querySelector('body'));
      headroom.init();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.user && !this.props.user) {
        _rollbar.rollbar.configure({
          payload: {
            person: {
              id: nextProps.user.id,
              username: nextProps.user.userName,
              email: nextProps.user.email
            }
          }
        });

        window.oeQwPusherInstance = new _pusherJs2.default((0, _pusher.getQwPusherApiKey)(), {
          cluster: 'mt1'
        });

        if (!this.props.token && nextProps.token) {
          window.oeQMQuestPusherInstance = new _pusherJs2.default((0, _pusher.getPusherApiKey)(), {
            authEndpoint: (0, _utils.getBaseUrl)() + '/quest_maker/pusher/auth',
            auth: {
              headers: {
                Authorization: 'Token token=' + nextProps.token
              }
            }
          });

          var channel = window.oeQMQuestPusherInstance.subscribe('questmaker');
          var action = _appupdate.setUserNeedsAppUpdate;
          channel.bind('update', function () {
            this.props.dispatch(action());
          }, this);
        }
      }

      if (nextProps.userNeedsToResetPassword && nextProps.location.pathname !== '/changepassword' && sessionStorage.getItem('password')) {
        this.props.dispatch((0, _reactRouterRedux.push)('/changepassword'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      document.querySelector('body').classList.remove('login-route');

      var _props = this.props,
          children = _props.children,
          showAcceptPoliciesModal = _props.showAcceptPoliciesModal,
          appUpdateAvailable = _props.appUpdateAvailable;


      var userInAuthenticatedRoute = void 0,
          isPoliciesRoute = void 0,
          fullWidthContainer = void 0;
      if (children && children.props.location) {
        userInAuthenticatedRoute = (0, _routes.isAuthenticatedRoute)(children.props.location.pathname);
        isPoliciesRoute = children.props.location.pathname.indexOf('/policies') > -1;
        fullWidthContainer = (0, _routes.isFullWidthRoute)(children.props.location.pathname);
      }

      return _react2.default.createElement(
        'div',
        { id: 'rootContainer' },
        _react2.default.createElement(_ModalContainer2.default, null),
        this.displayNavAndFooter() && !isPoliciesRoute && _react2.default.createElement(_Nav2.default, null),
        appUpdateAvailable && _react2.default.createElement(_RefreshApp2.default, null),
        this.props.isChangingOrganization ? _react2.default.createElement(
          'div',
          { style: { height: '100vh' } },
          _react2.default.createElement('div', { className: 'loading' })
        ) : _react2.default.createElement(
          'div',
          {
            id: '' + (userInAuthenticatedRoute ? 'content' : ''),
            className: 'container ' + (!userInAuthenticatedRoute ? 'unauth' : '') + ' ' + (fullWidthContainer ? 'full-width' : '')
          },
          children
        ),
        this.displayNavAndFooter() && _react2.default.createElement(_Footer2.default, null),
        showAcceptPoliciesModal && _react2.default.createElement(_AcceptPolicyModal2.default, null)
      );
    }
  }, {
    key: 'displayNavAndFooter',
    value: function displayNavAndFooter() {
      var _props2 = this.props,
          children = _props2.children,
          showAcceptPoliciesModal = _props2.showAcceptPoliciesModal;


      var userInAuthenticatedRoute = void 0;
      if (children && children.props.location) {
        userInAuthenticatedRoute = (0, _routes.isAuthenticatedRoute)(children.props.location.pathname);
      }

      return !showAcceptPoliciesModal && userInAuthenticatedRoute;
    }
  }]);
  return App;
}(_react.Component);

App.propTypes = {
  actions: _propTypes2.default.object,
  children: _propTypes2.default.element.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  history: _propTypes2.default.object.isRequired,
  showAcceptPoliciesModal: _propTypes2.default.bool,
  appUpdateAvailable: _propTypes2.default.bool,
  user: _propTypes2.default.object,
  userNeedsToResetPassword: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  isChangingOrganization: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    appUpdateAvailable: state.appupdate.appUpdateAvailable,
    showAcceptPoliciesModal: state.policies.showAcceptPoliciesModal,
    user: state.user.user,
    userNeedsToResetPassword: state.user.userNeedsToResetPassword,
    token: state.user.token,
    isChangingOrganization: state.organization.isChangingCurrentOrganization
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);
exports.AppDisconnected = App; // pure component - used in tests

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pusher JavaScript Library v7.0.6
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Pusher"] = factory();
	else
		root["Pusher"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package base64 implements Base64 encoding and decoding.
 */
// Invalid character used in decoding to indicate
// that the character to decode is out of range of
// alphabet and cannot be decoded.
var INVALID_BYTE = 256;
/**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */
var Coder = /** @class */ (function () {
    // TODO(dchest): methods to encode chunk-by-chunk.
    function Coder(_paddingCharacter) {
        if (_paddingCharacter === void 0) { _paddingCharacter = "="; }
        this._paddingCharacter = _paddingCharacter;
    }
    Coder.prototype.encodedLength = function (length) {
        if (!this._paddingCharacter) {
            return (length * 8 + 5) / 6 | 0;
        }
        return (length + 2) / 3 * 4 | 0;
    };
    Coder.prototype.encode = function (data) {
        var out = "";
        var i = 0;
        for (; i < data.length - 2; i += 3) {
            var c = (data[i] << 16) | (data[i + 1] << 8) | (data[i + 2]);
            out += this._encodeByte((c >>> 3 * 6) & 63);
            out += this._encodeByte((c >>> 2 * 6) & 63);
            out += this._encodeByte((c >>> 1 * 6) & 63);
            out += this._encodeByte((c >>> 0 * 6) & 63);
        }
        var left = data.length - i;
        if (left > 0) {
            var c = (data[i] << 16) | (left === 2 ? data[i + 1] << 8 : 0);
            out += this._encodeByte((c >>> 3 * 6) & 63);
            out += this._encodeByte((c >>> 2 * 6) & 63);
            if (left === 2) {
                out += this._encodeByte((c >>> 1 * 6) & 63);
            }
            else {
                out += this._paddingCharacter || "";
            }
            out += this._paddingCharacter || "";
        }
        return out;
    };
    Coder.prototype.maxDecodedLength = function (length) {
        if (!this._paddingCharacter) {
            return (length * 6 + 7) / 8 | 0;
        }
        return length / 4 * 3 | 0;
    };
    Coder.prototype.decodedLength = function (s) {
        return this.maxDecodedLength(s.length - this._getPaddingLength(s));
    };
    Coder.prototype.decode = function (s) {
        if (s.length === 0) {
            return new Uint8Array(0);
        }
        var paddingLength = this._getPaddingLength(s);
        var length = s.length - paddingLength;
        var out = new Uint8Array(this.maxDecodedLength(length));
        var op = 0;
        var i = 0;
        var haveBad = 0;
        var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
        for (; i < length - 4; i += 4) {
            v0 = this._decodeChar(s.charCodeAt(i + 0));
            v1 = this._decodeChar(s.charCodeAt(i + 1));
            v2 = this._decodeChar(s.charCodeAt(i + 2));
            v3 = this._decodeChar(s.charCodeAt(i + 3));
            out[op++] = (v0 << 2) | (v1 >>> 4);
            out[op++] = (v1 << 4) | (v2 >>> 2);
            out[op++] = (v2 << 6) | v3;
            haveBad |= v0 & INVALID_BYTE;
            haveBad |= v1 & INVALID_BYTE;
            haveBad |= v2 & INVALID_BYTE;
            haveBad |= v3 & INVALID_BYTE;
        }
        if (i < length - 1) {
            v0 = this._decodeChar(s.charCodeAt(i));
            v1 = this._decodeChar(s.charCodeAt(i + 1));
            out[op++] = (v0 << 2) | (v1 >>> 4);
            haveBad |= v0 & INVALID_BYTE;
            haveBad |= v1 & INVALID_BYTE;
        }
        if (i < length - 2) {
            v2 = this._decodeChar(s.charCodeAt(i + 2));
            out[op++] = (v1 << 4) | (v2 >>> 2);
            haveBad |= v2 & INVALID_BYTE;
        }
        if (i < length - 3) {
            v3 = this._decodeChar(s.charCodeAt(i + 3));
            out[op++] = (v2 << 6) | v3;
            haveBad |= v3 & INVALID_BYTE;
        }
        if (haveBad !== 0) {
            throw new Error("Base64Coder: incorrect characters for decoding");
        }
        return out;
    };
    // Standard encoding have the following encoded/decoded ranges,
    // which we need to convert between.
    //
    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
    // Index:   0 - 25                    26 - 51              52 - 61   62  63
    // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
    //
    // Encode 6 bits in b into a new character.
    Coder.prototype._encodeByte = function (b) {
        // Encoding uses constant time operations as follows:
        //
        // 1. Define comparison of A with B using (A - B) >>> 8:
        //          if A > B, then result is positive integer
        //          if A <= B, then result is 0
        //
        // 2. Define selection of C or 0 using bitwise AND: X & C:
        //          if X == 0, then result is 0
        //          if X != 0, then result is C
        //
        // 3. Start with the smallest comparison (b >= 0), which is always
        //    true, so set the result to the starting ASCII value (65).
        //
        // 4. Continue comparing b to higher ASCII values, and selecting
        //    zero if comparison isn't true, otherwise selecting a value
        //    to add to result, which:
        //
        //          a) undoes the previous addition
        //          b) provides new value to add
        //
        var result = b;
        // b >= 0
        result += 65;
        // b > 25
        result += ((25 - b) >>> 8) & ((0 - 65) - 26 + 97);
        // b > 51
        result += ((51 - b) >>> 8) & ((26 - 97) - 52 + 48);
        // b > 61
        result += ((61 - b) >>> 8) & ((52 - 48) - 62 + 43);
        // b > 62
        result += ((62 - b) >>> 8) & ((62 - 43) - 63 + 47);
        return String.fromCharCode(result);
    };
    // Decode a character code into a byte.
    // Must return 256 if character is out of alphabet range.
    Coder.prototype._decodeChar = function (c) {
        // Decoding works similar to encoding: using the same comparison
        // function, but now it works on ranges: result is always incremented
        // by value, but this value becomes zero if the range is not
        // satisfied.
        //
        // Decoding starts with invalid value, 256, which is then
        // subtracted when the range is satisfied. If none of the ranges
        // apply, the function returns 256, which is then checked by
        // the caller to throw error.
        var result = INVALID_BYTE; // start with invalid character
        // c == 43 (c > 42 and c < 44)
        result += (((42 - c) & (c - 44)) >>> 8) & (-INVALID_BYTE + c - 43 + 62);
        // c == 47 (c > 46 and c < 48)
        result += (((46 - c) & (c - 48)) >>> 8) & (-INVALID_BYTE + c - 47 + 63);
        // c > 47 and c < 58
        result += (((47 - c) & (c - 58)) >>> 8) & (-INVALID_BYTE + c - 48 + 52);
        // c > 64 and c < 91
        result += (((64 - c) & (c - 91)) >>> 8) & (-INVALID_BYTE + c - 65 + 0);
        // c > 96 and c < 123
        result += (((96 - c) & (c - 123)) >>> 8) & (-INVALID_BYTE + c - 97 + 26);
        return result;
    };
    Coder.prototype._getPaddingLength = function (s) {
        var paddingLength = 0;
        if (this._paddingCharacter) {
            for (var i = s.length - 1; i >= 0; i--) {
                if (s[i] !== this._paddingCharacter) {
                    break;
                }
                paddingLength++;
            }
            if (s.length < 4 || paddingLength > 2) {
                throw new Error("Base64Coder: incorrect padding");
            }
        }
        return paddingLength;
    };
    return Coder;
}());
exports.Coder = Coder;
var stdCoder = new Coder();
function encode(data) {
    return stdCoder.encode(data);
}
exports.encode = encode;
function decode(s) {
    return stdCoder.decode(s);
}
exports.decode = decode;
/**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */
var URLSafeCoder = /** @class */ (function (_super) {
    __extends(URLSafeCoder, _super);
    function URLSafeCoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // URL-safe encoding have the following encoded/decoded ranges:
    //
    // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
    // Index:   0 - 25                    26 - 51              52 - 61   62  63
    // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
    //
    URLSafeCoder.prototype._encodeByte = function (b) {
        var result = b;
        // b >= 0
        result += 65;
        // b > 25
        result += ((25 - b) >>> 8) & ((0 - 65) - 26 + 97);
        // b > 51
        result += ((51 - b) >>> 8) & ((26 - 97) - 52 + 48);
        // b > 61
        result += ((61 - b) >>> 8) & ((52 - 48) - 62 + 45);
        // b > 62
        result += ((62 - b) >>> 8) & ((62 - 45) - 63 + 95);
        return String.fromCharCode(result);
    };
    URLSafeCoder.prototype._decodeChar = function (c) {
        var result = INVALID_BYTE;
        // c == 45 (c > 44 and c < 46)
        result += (((44 - c) & (c - 46)) >>> 8) & (-INVALID_BYTE + c - 45 + 62);
        // c == 95 (c > 94 and c < 96)
        result += (((94 - c) & (c - 96)) >>> 8) & (-INVALID_BYTE + c - 95 + 63);
        // c > 47 and c < 58
        result += (((47 - c) & (c - 58)) >>> 8) & (-INVALID_BYTE + c - 48 + 52);
        // c > 64 and c < 91
        result += (((64 - c) & (c - 91)) >>> 8) & (-INVALID_BYTE + c - 65 + 0);
        // c > 96 and c < 123
        result += (((96 - c) & (c - 123)) >>> 8) & (-INVALID_BYTE + c - 97 + 26);
        return result;
    };
    return URLSafeCoder;
}(Coder));
exports.URLSafeCoder = URLSafeCoder;
var urlSafeCoder = new URLSafeCoder();
function encodeURLSafe(data) {
    return urlSafeCoder.encode(data);
}
exports.encodeURLSafe = encodeURLSafe;
function decodeURLSafe(s) {
    return urlSafeCoder.decode(s);
}
exports.decodeURLSafe = decodeURLSafe;
exports.encodedLength = function (length) {
    return stdCoder.encodedLength(length);
};
exports.maxDecodedLength = function (length) {
    return stdCoder.maxDecodedLength(length);
};
exports.decodedLength = function (s) {
    return stdCoder.decodedLength(s);
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package utf8 implements UTF-8 encoding and decoding.
 */
var INVALID_UTF16 = "utf8: invalid string";
var INVALID_UTF8 = "utf8: invalid source encoding";
/**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */
function encode(s) {
    // Calculate result length and allocate output array.
    // encodedLength() also validates string and throws errors,
    // so we don't need repeat validation here.
    var arr = new Uint8Array(encodedLength(s));
    var pos = 0;
    for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            arr[pos++] = c;
        }
        else if (c < 0x800) {
            arr[pos++] = 0xc0 | c >> 6;
            arr[pos++] = 0x80 | c & 0x3f;
        }
        else if (c < 0xd800) {
            arr[pos++] = 0xe0 | c >> 12;
            arr[pos++] = 0x80 | (c >> 6) & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        }
        else {
            i++; // get one more character
            c = (c & 0x3ff) << 10;
            c |= s.charCodeAt(i) & 0x3ff;
            c += 0x10000;
            arr[pos++] = 0xf0 | c >> 18;
            arr[pos++] = 0x80 | (c >> 12) & 0x3f;
            arr[pos++] = 0x80 | (c >> 6) & 0x3f;
            arr[pos++] = 0x80 | c & 0x3f;
        }
    }
    return arr;
}
exports.encode = encode;
/**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */
function encodedLength(s) {
    var result = 0;
    for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            result += 1;
        }
        else if (c < 0x800) {
            result += 2;
        }
        else if (c < 0xd800) {
            result += 3;
        }
        else if (c <= 0xdfff) {
            if (i >= s.length - 1) {
                throw new Error(INVALID_UTF16);
            }
            i++; // "eat" next character
            result += 4;
        }
        else {
            throw new Error(INVALID_UTF16);
        }
    }
    return result;
}
exports.encodedLength = encodedLength;
/**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */
function decode(arr) {
    var chars = [];
    for (var i = 0; i < arr.length; i++) {
        var b = arr[i];
        if (b & 0x80) {
            var min = void 0;
            if (b < 0xe0) {
                // Need 1 more byte.
                if (i >= arr.length) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                if ((n1 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x1f) << 6 | (n1 & 0x3f);
                min = 0x80;
            }
            else if (b < 0xf0) {
                // Need 2 more bytes.
                if (i >= arr.length - 1) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                var n2 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | (n2 & 0x3f);
                min = 0x800;
            }
            else if (b < 0xf8) {
                // Need 3 more bytes.
                if (i >= arr.length - 2) {
                    throw new Error(INVALID_UTF8);
                }
                var n1 = arr[++i];
                var n2 = arr[++i];
                var n3 = arr[++i];
                if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) {
                    throw new Error(INVALID_UTF8);
                }
                b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | (n3 & 0x3f);
                min = 0x10000;
            }
            else {
                throw new Error(INVALID_UTF8);
            }
            if (b < min || (b >= 0xd800 && b <= 0xdfff)) {
                throw new Error(INVALID_UTF8);
            }
            if (b >= 0x10000) {
                // Surrogate pair.
                if (b > 0x10ffff) {
                    throw new Error(INVALID_UTF8);
                }
                b -= 0x10000;
                chars.push(String.fromCharCode(0xd800 | (b >> 10)));
                b = 0xdc00 | (b & 0x3ff);
            }
        }
        chars.push(String.fromCharCode(b));
    }
    return chars.join("");
}
exports.decode = decode;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// required so we don't have to do require('pusher').default etc.
module.exports = __webpack_require__(3).default;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
var ScriptReceiverFactory = (function () {
    function ScriptReceiverFactory(prefix, name) {
        this.lastId = 0;
        this.prefix = prefix;
        this.name = name;
    }
    ScriptReceiverFactory.prototype.create = function (callback) {
        this.lastId++;
        var number = this.lastId;
        var id = this.prefix + number;
        var name = this.name + '[' + number + ']';
        var called = false;
        var callbackWrapper = function () {
            if (!called) {
                callback.apply(null, arguments);
                called = true;
            }
        };
        this[number] = callbackWrapper;
        return { number: number, id: id, name: name, callback: callbackWrapper };
    };
    ScriptReceiverFactory.prototype.remove = function (receiver) {
        delete this[receiver.number];
    };
    return ScriptReceiverFactory;
}());

var ScriptReceivers = new ScriptReceiverFactory('_pusher_script_', 'Pusher.ScriptReceivers');

// CONCATENATED MODULE: ./src/core/defaults.ts
var Defaults = {
    VERSION: "7.0.6",
    PROTOCOL: 7,
    wsPort: 80,
    wssPort: 443,
    wsPath: '',
    httpHost: 'sockjs.pusher.com',
    httpPort: 80,
    httpsPort: 443,
    httpPath: '/pusher',
    stats_host: 'stats.pusher.com',
    authEndpoint: '/pusher/auth',
    authTransport: 'ajax',
    activityTimeout: 120000,
    pongTimeout: 30000,
    unavailableTimeout: 10000,
    cluster: 'mt1',
    cdn_http: "http://js.pusher.com",
    cdn_https: "https://js.pusher.com",
    dependency_suffix: ""
};
/* harmony default export */ var defaults = (Defaults);

// CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts


var dependency_loader_DependencyLoader = (function () {
    function DependencyLoader(options) {
        this.options = options;
        this.receivers = options.receivers || ScriptReceivers;
        this.loading = {};
    }
    DependencyLoader.prototype.load = function (name, options, callback) {
        var self = this;
        if (self.loading[name] && self.loading[name].length > 0) {
            self.loading[name].push(callback);
        }
        else {
            self.loading[name] = [callback];
            var request = runtime.createScriptRequest(self.getPath(name, options));
            var receiver = self.receivers.create(function (error) {
                self.receivers.remove(receiver);
                if (self.loading[name]) {
                    var callbacks = self.loading[name];
                    delete self.loading[name];
                    var successCallback = function (wasSuccessful) {
                        if (!wasSuccessful) {
                            request.cleanup();
                        }
                    };
                    for (var i = 0; i < callbacks.length; i++) {
                        callbacks[i](error, successCallback);
                    }
                }
            });
            request.send(receiver);
        }
    };
    DependencyLoader.prototype.getRoot = function (options) {
        var cdn;
        var protocol = runtime.getDocument().location.protocol;
        if ((options && options.useTLS) || protocol === 'https:') {
            cdn = this.options.cdn_https;
        }
        else {
            cdn = this.options.cdn_http;
        }
        return cdn.replace(/\/*$/, '') + '/' + this.options.version;
    };
    DependencyLoader.prototype.getPath = function (name, options) {
        return this.getRoot(options) + '/' + name + this.options.suffix + '.js';
    };
    return DependencyLoader;
}());
/* harmony default export */ var dependency_loader = (dependency_loader_DependencyLoader);

// CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts



var DependenciesReceivers = new ScriptReceiverFactory('_pusher_dependencies', 'Pusher.DependenciesReceivers');
var Dependencies = new dependency_loader({
    cdn_http: defaults.cdn_http,
    cdn_https: defaults.cdn_https,
    version: defaults.VERSION,
    suffix: defaults.dependency_suffix,
    receivers: DependenciesReceivers
});

// CONCATENATED MODULE: ./src/core/utils/url_store.ts
var urlStore = {
    baseUrl: 'https://pusher.com',
    urls: {
        authenticationEndpoint: {
            path: '/docs/authenticating_users'
        },
        javascriptQuickStart: {
            path: '/docs/javascript_quick_start'
        },
        triggeringClientEvents: {
            path: '/docs/client_api_guide/client_events#trigger-events'
        },
        encryptedChannelSupport: {
            fullUrl: 'https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support'
        }
    }
};
var buildLogSuffix = function (key) {
    var urlPrefix = 'See:';
    var urlObj = urlStore.urls[key];
    if (!urlObj)
        return '';
    var url;
    if (urlObj.fullUrl) {
        url = urlObj.fullUrl;
    }
    else if (urlObj.path) {
        url = urlStore.baseUrl + urlObj.path;
    }
    if (!url)
        return '';
    return urlPrefix + " " + url;
};
/* harmony default export */ var url_store = ({ buildLogSuffix: buildLogSuffix });

// CONCATENATED MODULE: ./src/core/errors.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var BadEventName = (function (_super) {
    __extends(BadEventName, _super);
    function BadEventName(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return BadEventName;
}(Error));

var RequestTimedOut = (function (_super) {
    __extends(RequestTimedOut, _super);
    function RequestTimedOut(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return RequestTimedOut;
}(Error));

var TransportPriorityTooLow = (function (_super) {
    __extends(TransportPriorityTooLow, _super);
    function TransportPriorityTooLow(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TransportPriorityTooLow;
}(Error));

var TransportClosed = (function (_super) {
    __extends(TransportClosed, _super);
    function TransportClosed(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TransportClosed;
}(Error));

var UnsupportedFeature = (function (_super) {
    __extends(UnsupportedFeature, _super);
    function UnsupportedFeature(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return UnsupportedFeature;
}(Error));

var UnsupportedTransport = (function (_super) {
    __extends(UnsupportedTransport, _super);
    function UnsupportedTransport(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return UnsupportedTransport;
}(Error));

var UnsupportedStrategy = (function (_super) {
    __extends(UnsupportedStrategy, _super);
    function UnsupportedStrategy(msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return UnsupportedStrategy;
}(Error));

var HTTPAuthError = (function (_super) {
    __extends(HTTPAuthError, _super);
    function HTTPAuthError(status, msg) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, msg) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return HTTPAuthError;
}(Error));


// CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts



var ajax = function (context, socketId, callback) {
    var self = this, xhr;
    xhr = runtime.createXHR();
    xhr.open('POST', self.options.authEndpoint, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    for (var headerName in this.authOptions.headers) {
        xhr.setRequestHeader(headerName, this.authOptions.headers[headerName]);
    }
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var data = void 0;
                var parsed = false;
                try {
                    data = JSON.parse(xhr.responseText);
                    parsed = true;
                }
                catch (e) {
                    callback(new HTTPAuthError(200, 'JSON returned from auth endpoint was invalid, yet status code was 200. Data was: ' +
                        xhr.responseText), { auth: '' });
                }
                if (parsed) {
                    callback(null, data);
                }
            }
            else {
                var suffix = url_store.buildLogSuffix('authenticationEndpoint');
                callback(new HTTPAuthError(xhr.status, 'Unable to retrieve auth string from auth endpoint - ' +
                    ("received status: " + xhr.status + " from " + self.options.authEndpoint + ". ") +
                    ("Clients must be authenticated to join private or presence channels. " + suffix)), { auth: '' });
            }
        }
    };
    xhr.send(this.composeQuery(socketId));
    return xhr;
};
/* harmony default export */ var xhr_auth = (ajax);

// CONCATENATED MODULE: ./src/core/base64.ts
function encode(s) {
    return btoa(utob(s));
}
var fromCharCode = String.fromCharCode;
var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var b64tab = {};
for (var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++) {
    b64tab[b64chars.charAt(base64_i)] = base64_i;
}
var cb_utob = function (c) {
    var cc = c.charCodeAt(0);
    return cc < 0x80
        ? c
        : cc < 0x800
            ? fromCharCode(0xc0 | (cc >>> 6)) + fromCharCode(0x80 | (cc & 0x3f))
            : fromCharCode(0xe0 | ((cc >>> 12) & 0x0f)) +
                fromCharCode(0x80 | ((cc >>> 6) & 0x3f)) +
                fromCharCode(0x80 | (cc & 0x3f));
};
var utob = function (u) {
    return u.replace(/[^\x00-\x7F]/g, cb_utob);
};
var cb_encode = function (ccc) {
    var padlen = [0, 2, 1][ccc.length % 3];
    var ord = (ccc.charCodeAt(0) << 16) |
        ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8) |
        (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
    var chars = [
        b64chars.charAt(ord >>> 18),
        b64chars.charAt((ord >>> 12) & 63),
        padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
        padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
    ];
    return chars.join('');
};
var btoa = window.btoa ||
    function (b) {
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };

// CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
var Timer = (function () {
    function Timer(set, clear, delay, callback) {
        var _this = this;
        this.clear = clear;
        this.timer = set(function () {
            if (_this.timer) {
                _this.timer = callback(_this.timer);
            }
        }, delay);
    }
    Timer.prototype.isRunning = function () {
        return this.timer !== null;
    };
    Timer.prototype.ensureAborted = function () {
        if (this.timer) {
            this.clear(this.timer);
            this.timer = null;
        }
    };
    return Timer;
}());
/* harmony default export */ var abstract_timer = (Timer);

// CONCATENATED MODULE: ./src/core/utils/timers/index.ts
var timers_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

function timers_clearTimeout(timer) {
    window.clearTimeout(timer);
}
function timers_clearInterval(timer) {
    window.clearInterval(timer);
}
var OneOffTimer = (function (_super) {
    timers_extends(OneOffTimer, _super);
    function OneOffTimer(delay, callback) {
        return _super.call(this, setTimeout, timers_clearTimeout, delay, function (timer) {
            callback();
            return null;
        }) || this;
    }
    return OneOffTimer;
}(abstract_timer));

var PeriodicTimer = (function (_super) {
    timers_extends(PeriodicTimer, _super);
    function PeriodicTimer(delay, callback) {
        return _super.call(this, setInterval, timers_clearInterval, delay, function (timer) {
            callback();
            return timer;
        }) || this;
    }
    return PeriodicTimer;
}(abstract_timer));


// CONCATENATED MODULE: ./src/core/util.ts

var Util = {
    now: function () {
        if (Date.now) {
            return Date.now();
        }
        else {
            return new Date().valueOf();
        }
    },
    defer: function (callback) {
        return new OneOffTimer(0, callback);
    },
    method: function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var boundArguments = Array.prototype.slice.call(arguments, 1);
        return function (object) {
            return object[name].apply(object, boundArguments.concat(arguments));
        };
    }
};
/* harmony default export */ var util = (Util);

// CONCATENATED MODULE: ./src/core/utils/collections.ts


function extend(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < sources.length; i++) {
        var extensions = sources[i];
        for (var property in extensions) {
            if (extensions[property] &&
                extensions[property].constructor &&
                extensions[property].constructor === Object) {
                target[property] = extend(target[property] || {}, extensions[property]);
            }
            else {
                target[property] = extensions[property];
            }
        }
    }
    return target;
}
function stringify() {
    var m = ['Pusher'];
    for (var i = 0; i < arguments.length; i++) {
        if (typeof arguments[i] === 'string') {
            m.push(arguments[i]);
        }
        else {
            m.push(safeJSONStringify(arguments[i]));
        }
    }
    return m.join(' : ');
}
function arrayIndexOf(array, item) {
    var nativeIndexOf = Array.prototype.indexOf;
    if (array === null) {
        return -1;
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) {
        return array.indexOf(item);
    }
    for (var i = 0, l = array.length; i < l; i++) {
        if (array[i] === item) {
            return i;
        }
    }
    return -1;
}
function objectApply(object, f) {
    for (var key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            f(object[key], key, object);
        }
    }
}
function keys(object) {
    var keys = [];
    objectApply(object, function (_, key) {
        keys.push(key);
    });
    return keys;
}
function values(object) {
    var values = [];
    objectApply(object, function (value) {
        values.push(value);
    });
    return values;
}
function apply(array, f, context) {
    for (var i = 0; i < array.length; i++) {
        f.call(context || window, array[i], i, array);
    }
}
function map(array, f) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        result.push(f(array[i], i, array, result));
    }
    return result;
}
function mapObject(object, f) {
    var result = {};
    objectApply(object, function (value, key) {
        result[key] = f(value);
    });
    return result;
}
function filter(array, test) {
    test =
        test ||
            function (value) {
                return !!value;
            };
    var result = [];
    for (var i = 0; i < array.length; i++) {
        if (test(array[i], i, array, result)) {
            result.push(array[i]);
        }
    }
    return result;
}
function filterObject(object, test) {
    var result = {};
    objectApply(object, function (value, key) {
        if ((test && test(value, key, object, result)) || Boolean(value)) {
            result[key] = value;
        }
    });
    return result;
}
function flatten(object) {
    var result = [];
    objectApply(object, function (value, key) {
        result.push([key, value]);
    });
    return result;
}
function any(array, test) {
    for (var i = 0; i < array.length; i++) {
        if (test(array[i], i, array)) {
            return true;
        }
    }
    return false;
}
function collections_all(array, test) {
    for (var i = 0; i < array.length; i++) {
        if (!test(array[i], i, array)) {
            return false;
        }
    }
    return true;
}
function encodeParamsObject(data) {
    return mapObject(data, function (value) {
        if (typeof value === 'object') {
            value = safeJSONStringify(value);
        }
        return encodeURIComponent(encode(value.toString()));
    });
}
function buildQueryString(data) {
    var params = filterObject(data, function (value) {
        return value !== undefined;
    });
    var query = map(flatten(encodeParamsObject(params)), util.method('join', '=')).join('&');
    return query;
}
function decycleObject(object) {
    var objects = [], paths = [];
    return (function derez(value, path) {
        var i, name, nu;
        switch (typeof value) {
            case 'object':
                if (!value) {
                    return null;
                }
                for (i = 0; i < objects.length; i += 1) {
                    if (objects[i] === value) {
                        return { $ref: paths[i] };
                    }
                }
                objects.push(value);
                paths.push(path);
                if (Object.prototype.toString.apply(value) === '[object Array]') {
                    nu = [];
                    for (i = 0; i < value.length; i += 1) {
                        nu[i] = derez(value[i], path + '[' + i + ']');
                    }
                }
                else {
                    nu = {};
                    for (name in value) {
                        if (Object.prototype.hasOwnProperty.call(value, name)) {
                            nu[name] = derez(value[name], path + '[' + JSON.stringify(name) + ']');
                        }
                    }
                }
                return nu;
            case 'number':
            case 'string':
            case 'boolean':
                return value;
        }
    })(object, '$');
}
function safeJSONStringify(source) {
    try {
        return JSON.stringify(source);
    }
    catch (e) {
        return JSON.stringify(decycleObject(source));
    }
}

// CONCATENATED MODULE: ./src/core/logger.ts


var logger_Logger = (function () {
    function Logger() {
        this.globalLog = function (message) {
            if (window.console && window.console.log) {
                window.console.log(message);
            }
        };
    }
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(this.globalLog, args);
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(this.globalLogWarn, args);
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log(this.globalLogError, args);
    };
    Logger.prototype.globalLogWarn = function (message) {
        if (window.console && window.console.warn) {
            window.console.warn(message);
        }
        else {
            this.globalLog(message);
        }
    };
    Logger.prototype.globalLogError = function (message) {
        if (window.console && window.console.error) {
            window.console.error(message);
        }
        else {
            this.globalLogWarn(message);
        }
    };
    Logger.prototype.log = function (defaultLoggingFunction) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var message = stringify.apply(this, arguments);
        if (core_pusher.log) {
            core_pusher.log(message);
        }
        else if (core_pusher.logToConsole) {
            var log = defaultLoggingFunction.bind(this);
            log(message);
        }
    };
    return Logger;
}());
/* harmony default export */ var logger = (new logger_Logger());

// CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts

var jsonp = function (context, socketId, callback) {
    if (this.authOptions.headers !== undefined) {
        logger.warn('To send headers with the auth request, you must use AJAX, rather than JSONP.');
    }
    var callbackName = context.nextAuthCallbackID.toString();
    context.nextAuthCallbackID++;
    var document = context.getDocument();
    var script = document.createElement('script');
    context.auth_callbacks[callbackName] = function (data) {
        callback(null, data);
    };
    var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
    script.src =
        this.options.authEndpoint +
            '?callback=' +
            encodeURIComponent(callback_name) +
            '&' +
            this.composeQuery(socketId);
    var head = document.getElementsByTagName('head')[0] || document.documentElement;
    head.insertBefore(script, head.firstChild);
};
/* harmony default export */ var jsonp_auth = (jsonp);

// CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
var ScriptRequest = (function () {
    function ScriptRequest(src) {
        this.src = src;
    }
    ScriptRequest.prototype.send = function (receiver) {
        var self = this;
        var errorString = 'Error loading ' + self.src;
        self.script = document.createElement('script');
        self.script.id = receiver.id;
        self.script.src = self.src;
        self.script.type = 'text/javascript';
        self.script.charset = 'UTF-8';
        if (self.script.addEventListener) {
            self.script.onerror = function () {
                receiver.callback(errorString);
            };
            self.script.onload = function () {
                receiver.callback(null);
            };
        }
        else {
            self.script.onreadystatechange = function () {
                if (self.script.readyState === 'loaded' ||
                    self.script.readyState === 'complete') {
                    receiver.callback(null);
                }
            };
        }
        if (self.script.async === undefined &&
            document.attachEvent &&
            /opera/i.test(navigator.userAgent)) {
            self.errorScript = document.createElement('script');
            self.errorScript.id = receiver.id + '_error';
            self.errorScript.text = receiver.name + "('" + errorString + "');";
            self.script.async = self.errorScript.async = false;
        }
        else {
            self.script.async = true;
        }
        var head = document.getElementsByTagName('head')[0];
        head.insertBefore(self.script, head.firstChild);
        if (self.errorScript) {
            head.insertBefore(self.errorScript, self.script.nextSibling);
        }
    };
    ScriptRequest.prototype.cleanup = function () {
        if (this.script) {
            this.script.onload = this.script.onerror = null;
            this.script.onreadystatechange = null;
        }
        if (this.script && this.script.parentNode) {
            this.script.parentNode.removeChild(this.script);
        }
        if (this.errorScript && this.errorScript.parentNode) {
            this.errorScript.parentNode.removeChild(this.errorScript);
        }
        this.script = null;
        this.errorScript = null;
    };
    return ScriptRequest;
}());
/* harmony default export */ var script_request = (ScriptRequest);

// CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts


var jsonp_request_JSONPRequest = (function () {
    function JSONPRequest(url, data) {
        this.url = url;
        this.data = data;
    }
    JSONPRequest.prototype.send = function (receiver) {
        if (this.request) {
            return;
        }
        var query = buildQueryString(this.data);
        var url = this.url + '/' + receiver.number + '?' + query;
        this.request = runtime.createScriptRequest(url);
        this.request.send(receiver);
    };
    JSONPRequest.prototype.cleanup = function () {
        if (this.request) {
            this.request.cleanup();
        }
    };
    return JSONPRequest;
}());
/* harmony default export */ var jsonp_request = (jsonp_request_JSONPRequest);

// CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts


var getAgent = function (sender, useTLS) {
    return function (data, callback) {
        var scheme = 'http' + (useTLS ? 's' : '') + '://';
        var url = scheme + (sender.host || sender.options.host) + sender.options.path;
        var request = runtime.createJSONPRequest(url, data);
        var receiver = runtime.ScriptReceivers.create(function (error, result) {
            ScriptReceivers.remove(receiver);
            request.cleanup();
            if (result && result.host) {
                sender.host = result.host;
            }
            if (callback) {
                callback(error, result);
            }
        });
        request.send(receiver);
    };
};
var jsonp_timeline_jsonp = {
    name: 'jsonp',
    getAgent: getAgent
};
/* harmony default export */ var jsonp_timeline = (jsonp_timeline_jsonp);

// CONCATENATED MODULE: ./src/core/transports/url_schemes.ts

function getGenericURL(baseScheme, params, path) {
    var scheme = baseScheme + (params.useTLS ? 's' : '');
    var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
    return scheme + '://' + host + path;
}
function getGenericPath(key, queryString) {
    var path = '/app/' + key;
    var query = '?protocol=' +
        defaults.PROTOCOL +
        '&client=js' +
        '&version=' +
        defaults.VERSION +
        (queryString ? '&' + queryString : '');
    return path + query;
}
var ws = {
    getInitial: function (key, params) {
        var path = (params.httpPath || '') + getGenericPath(key, 'flash=false');
        return getGenericURL('ws', params, path);
    }
};
var http = {
    getInitial: function (key, params) {
        var path = (params.httpPath || '/pusher') + getGenericPath(key);
        return getGenericURL('http', params, path);
    }
};
var sockjs = {
    getInitial: function (key, params) {
        return getGenericURL('http', params, params.httpPath || '/pusher');
    },
    getPath: function (key, params) {
        return getGenericPath(key);
    }
};

// CONCATENATED MODULE: ./src/core/events/callback_registry.ts

var callback_registry_CallbackRegistry = (function () {
    function CallbackRegistry() {
        this._callbacks = {};
    }
    CallbackRegistry.prototype.get = function (name) {
        return this._callbacks[prefix(name)];
    };
    CallbackRegistry.prototype.add = function (name, callback, context) {
        var prefixedEventName = prefix(name);
        this._callbacks[prefixedEventName] =
            this._callbacks[prefixedEventName] || [];
        this._callbacks[prefixedEventName].push({
            fn: callback,
            context: context
        });
    };
    CallbackRegistry.prototype.remove = function (name, callback, context) {
        if (!name && !callback && !context) {
            this._callbacks = {};
            return;
        }
        var names = name ? [prefix(name)] : keys(this._callbacks);
        if (callback || context) {
            this.removeCallback(names, callback, context);
        }
        else {
            this.removeAllCallbacks(names);
        }
    };
    CallbackRegistry.prototype.removeCallback = function (names, callback, context) {
        apply(names, function (name) {
            this._callbacks[name] = filter(this._callbacks[name] || [], function (binding) {
                return ((callback && callback !== binding.fn) ||
                    (context && context !== binding.context));
            });
            if (this._callbacks[name].length === 0) {
                delete this._callbacks[name];
            }
        }, this);
    };
    CallbackRegistry.prototype.removeAllCallbacks = function (names) {
        apply(names, function (name) {
            delete this._callbacks[name];
        }, this);
    };
    return CallbackRegistry;
}());
/* harmony default export */ var callback_registry = (callback_registry_CallbackRegistry);
function prefix(name) {
    return '_' + name;
}

// CONCATENATED MODULE: ./src/core/events/dispatcher.ts


var dispatcher_Dispatcher = (function () {
    function Dispatcher(failThrough) {
        this.callbacks = new callback_registry();
        this.global_callbacks = [];
        this.failThrough = failThrough;
    }
    Dispatcher.prototype.bind = function (eventName, callback, context) {
        this.callbacks.add(eventName, callback, context);
        return this;
    };
    Dispatcher.prototype.bind_global = function (callback) {
        this.global_callbacks.push(callback);
        return this;
    };
    Dispatcher.prototype.unbind = function (eventName, callback, context) {
        this.callbacks.remove(eventName, callback, context);
        return this;
    };
    Dispatcher.prototype.unbind_global = function (callback) {
        if (!callback) {
            this.global_callbacks = [];
            return this;
        }
        this.global_callbacks = filter(this.global_callbacks || [], function (c) { return c !== callback; });
        return this;
    };
    Dispatcher.prototype.unbind_all = function () {
        this.unbind();
        this.unbind_global();
        return this;
    };
    Dispatcher.prototype.emit = function (eventName, data, metadata) {
        for (var i = 0; i < this.global_callbacks.length; i++) {
            this.global_callbacks[i](eventName, data);
        }
        var callbacks = this.callbacks.get(eventName);
        var args = [];
        if (metadata) {
            args.push(data, metadata);
        }
        else if (data) {
            args.push(data);
        }
        if (callbacks && callbacks.length > 0) {
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i].fn.apply(callbacks[i].context || window, args);
            }
        }
        else if (this.failThrough) {
            this.failThrough(eventName, data);
        }
        return this;
    };
    return Dispatcher;
}());
/* harmony default export */ var dispatcher = (dispatcher_Dispatcher);

// CONCATENATED MODULE: ./src/core/transports/transport_connection.ts
var transport_connection_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var transport_connection_TransportConnection = (function (_super) {
    transport_connection_extends(TransportConnection, _super);
    function TransportConnection(hooks, name, priority, key, options) {
        var _this = _super.call(this) || this;
        _this.initialize = runtime.transportConnectionInitializer;
        _this.hooks = hooks;
        _this.name = name;
        _this.priority = priority;
        _this.key = key;
        _this.options = options;
        _this.state = 'new';
        _this.timeline = options.timeline;
        _this.activityTimeout = options.activityTimeout;
        _this.id = _this.timeline.generateUniqueID();
        return _this;
    }
    TransportConnection.prototype.handlesActivityChecks = function () {
        return Boolean(this.hooks.handlesActivityChecks);
    };
    TransportConnection.prototype.supportsPing = function () {
        return Boolean(this.hooks.supportsPing);
    };
    TransportConnection.prototype.connect = function () {
        var _this = this;
        if (this.socket || this.state !== 'initialized') {
            return false;
        }
        var url = this.hooks.urls.getInitial(this.key, this.options);
        try {
            this.socket = this.hooks.getSocket(url, this.options);
        }
        catch (e) {
            util.defer(function () {
                _this.onError(e);
                _this.changeState('closed');
            });
            return false;
        }
        this.bindListeners();
        logger.debug('Connecting', { transport: this.name, url: url });
        this.changeState('connecting');
        return true;
    };
    TransportConnection.prototype.close = function () {
        if (this.socket) {
            this.socket.close();
            return true;
        }
        else {
            return false;
        }
    };
    TransportConnection.prototype.send = function (data) {
        var _this = this;
        if (this.state === 'open') {
            util.defer(function () {
                if (_this.socket) {
                    _this.socket.send(data);
                }
            });
            return true;
        }
        else {
            return false;
        }
    };
    TransportConnection.prototype.ping = function () {
        if (this.state === 'open' && this.supportsPing()) {
            this.socket.ping();
        }
    };
    TransportConnection.prototype.onOpen = function () {
        if (this.hooks.beforeOpen) {
            this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
        }
        this.changeState('open');
        this.socket.onopen = undefined;
    };
    TransportConnection.prototype.onError = function (error) {
        this.emit('error', { type: 'WebSocketError', error: error });
        this.timeline.error(this.buildTimelineMessage({ error: error.toString() }));
    };
    TransportConnection.prototype.onClose = function (closeEvent) {
        if (closeEvent) {
            this.changeState('closed', {
                code: closeEvent.code,
                reason: closeEvent.reason,
                wasClean: closeEvent.wasClean
            });
        }
        else {
            this.changeState('closed');
        }
        this.unbindListeners();
        this.socket = undefined;
    };
    TransportConnection.prototype.onMessage = function (message) {
        this.emit('message', message);
    };
    TransportConnection.prototype.onActivity = function () {
        this.emit('activity');
    };
    TransportConnection.prototype.bindListeners = function () {
        var _this = this;
        this.socket.onopen = function () {
            _this.onOpen();
        };
        this.socket.onerror = function (error) {
            _this.onError(error);
        };
        this.socket.onclose = function (closeEvent) {
            _this.onClose(closeEvent);
        };
        this.socket.onmessage = function (message) {
            _this.onMessage(message);
        };
        if (this.supportsPing()) {
            this.socket.onactivity = function () {
                _this.onActivity();
            };
        }
    };
    TransportConnection.prototype.unbindListeners = function () {
        if (this.socket) {
            this.socket.onopen = undefined;
            this.socket.onerror = undefined;
            this.socket.onclose = undefined;
            this.socket.onmessage = undefined;
            if (this.supportsPing()) {
                this.socket.onactivity = undefined;
            }
        }
    };
    TransportConnection.prototype.changeState = function (state, params) {
        this.state = state;
        this.timeline.info(this.buildTimelineMessage({
            state: state,
            params: params
        }));
        this.emit(state, params);
    };
    TransportConnection.prototype.buildTimelineMessage = function (message) {
        return extend({ cid: this.id }, message);
    };
    return TransportConnection;
}(dispatcher));
/* harmony default export */ var transport_connection = (transport_connection_TransportConnection);

// CONCATENATED MODULE: ./src/core/transports/transport.ts

var transport_Transport = (function () {
    function Transport(hooks) {
        this.hooks = hooks;
    }
    Transport.prototype.isSupported = function (environment) {
        return this.hooks.isSupported(environment);
    };
    Transport.prototype.createConnection = function (name, priority, key, options) {
        return new transport_connection(this.hooks, name, priority, key, options);
    };
    return Transport;
}());
/* harmony default export */ var transports_transport = (transport_Transport);

// CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts




var WSTransport = new transports_transport({
    urls: ws,
    handlesActivityChecks: false,
    supportsPing: false,
    isInitialized: function () {
        return Boolean(runtime.getWebSocketAPI());
    },
    isSupported: function () {
        return Boolean(runtime.getWebSocketAPI());
    },
    getSocket: function (url) {
        return runtime.createWebSocket(url);
    }
});
var httpConfiguration = {
    urls: http,
    handlesActivityChecks: false,
    supportsPing: true,
    isInitialized: function () {
        return true;
    }
};
var streamingConfiguration = extend({
    getSocket: function (url) {
        return runtime.HTTPFactory.createStreamingSocket(url);
    }
}, httpConfiguration);
var pollingConfiguration = extend({
    getSocket: function (url) {
        return runtime.HTTPFactory.createPollingSocket(url);
    }
}, httpConfiguration);
var xhrConfiguration = {
    isSupported: function () {
        return runtime.isXHRSupported();
    }
};
var XHRStreamingTransport = new transports_transport((extend({}, streamingConfiguration, xhrConfiguration)));
var XHRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xhrConfiguration));
var Transports = {
    ws: WSTransport,
    xhr_streaming: XHRStreamingTransport,
    xhr_polling: XHRPollingTransport
};
/* harmony default export */ var transports = (Transports);

// CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts






var SockJSTransport = new transports_transport({
    file: 'sockjs',
    urls: sockjs,
    handlesActivityChecks: true,
    supportsPing: false,
    isSupported: function () {
        return true;
    },
    isInitialized: function () {
        return window.SockJS !== undefined;
    },
    getSocket: function (url, options) {
        return new window.SockJS(url, null, {
            js_path: Dependencies.getPath('sockjs', {
                useTLS: options.useTLS
            }),
            ignore_null_origin: options.ignoreNullOrigin
        });
    },
    beforeOpen: function (socket, path) {
        socket.send(JSON.stringify({
            path: path
        }));
    }
});
var xdrConfiguration = {
    isSupported: function (environment) {
        var yes = runtime.isXDRSupported(environment.useTLS);
        return yes;
    }
};
var XDRStreamingTransport = new transports_transport((extend({}, streamingConfiguration, xdrConfiguration)));
var XDRPollingTransport = new transports_transport(extend({}, pollingConfiguration, xdrConfiguration));
transports.xdr_streaming = XDRStreamingTransport;
transports.xdr_polling = XDRPollingTransport;
transports.sockjs = SockJSTransport;
/* harmony default export */ var transports_transports = (transports);

// CONCATENATED MODULE: ./src/runtimes/web/net_info.ts
var net_info_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NetInfo = (function (_super) {
    net_info_extends(NetInfo, _super);
    function NetInfo() {
        var _this = _super.call(this) || this;
        var self = _this;
        if (window.addEventListener !== undefined) {
            window.addEventListener('online', function () {
                self.emit('online');
            }, false);
            window.addEventListener('offline', function () {
                self.emit('offline');
            }, false);
        }
        return _this;
    }
    NetInfo.prototype.isOnline = function () {
        if (window.navigator.onLine === undefined) {
            return true;
        }
        else {
            return window.navigator.onLine;
        }
    };
    return NetInfo;
}(dispatcher));

var net_info_Network = new NetInfo();

// CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts


var assistant_to_the_transport_manager_AssistantToTheTransportManager = (function () {
    function AssistantToTheTransportManager(manager, transport, options) {
        this.manager = manager;
        this.transport = transport;
        this.minPingDelay = options.minPingDelay;
        this.maxPingDelay = options.maxPingDelay;
        this.pingDelay = undefined;
    }
    AssistantToTheTransportManager.prototype.createConnection = function (name, priority, key, options) {
        var _this = this;
        options = extend({}, options, {
            activityTimeout: this.pingDelay
        });
        var connection = this.transport.createConnection(name, priority, key, options);
        var openTimestamp = null;
        var onOpen = function () {
            connection.unbind('open', onOpen);
            connection.bind('closed', onClosed);
            openTimestamp = util.now();
        };
        var onClosed = function (closeEvent) {
            connection.unbind('closed', onClosed);
            if (closeEvent.code === 1002 || closeEvent.code === 1003) {
                _this.manager.reportDeath();
            }
            else if (!closeEvent.wasClean && openTimestamp) {
                var lifespan = util.now() - openTimestamp;
                if (lifespan < 2 * _this.maxPingDelay) {
                    _this.manager.reportDeath();
                    _this.pingDelay = Math.max(lifespan / 2, _this.minPingDelay);
                }
            }
        };
        connection.bind('open', onOpen);
        return connection;
    };
    AssistantToTheTransportManager.prototype.isSupported = function (environment) {
        return this.manager.isAlive() && this.transport.isSupported(environment);
    };
    return AssistantToTheTransportManager;
}());
/* harmony default export */ var assistant_to_the_transport_manager = (assistant_to_the_transport_manager_AssistantToTheTransportManager);

// CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
var Protocol = {
    decodeMessage: function (messageEvent) {
        try {
            var messageData = JSON.parse(messageEvent.data);
            var pusherEventData = messageData.data;
            if (typeof pusherEventData === 'string') {
                try {
                    pusherEventData = JSON.parse(messageData.data);
                }
                catch (e) { }
            }
            var pusherEvent = {
                event: messageData.event,
                channel: messageData.channel,
                data: pusherEventData
            };
            if (messageData.user_id) {
                pusherEvent.user_id = messageData.user_id;
            }
            return pusherEvent;
        }
        catch (e) {
            throw { type: 'MessageParseError', error: e, data: messageEvent.data };
        }
    },
    encodeMessage: function (event) {
        return JSON.stringify(event);
    },
    processHandshake: function (messageEvent) {
        var message = Protocol.decodeMessage(messageEvent);
        if (message.event === 'pusher:connection_established') {
            if (!message.data.activity_timeout) {
                throw 'No activity timeout specified in handshake';
            }
            return {
                action: 'connected',
                id: message.data.socket_id,
                activityTimeout: message.data.activity_timeout * 1000
            };
        }
        else if (message.event === 'pusher:error') {
            return {
                action: this.getCloseAction(message.data),
                error: this.getCloseError(message.data)
            };
        }
        else {
            throw 'Invalid handshake';
        }
    },
    getCloseAction: function (closeEvent) {
        if (closeEvent.code < 4000) {
            if (closeEvent.code >= 1002 && closeEvent.code <= 1004) {
                return 'backoff';
            }
            else {
                return null;
            }
        }
        else if (closeEvent.code === 4000) {
            return 'tls_only';
        }
        else if (closeEvent.code < 4100) {
            return 'refused';
        }
        else if (closeEvent.code < 4200) {
            return 'backoff';
        }
        else if (closeEvent.code < 4300) {
            return 'retry';
        }
        else {
            return 'refused';
        }
    },
    getCloseError: function (closeEvent) {
        if (closeEvent.code !== 1000 && closeEvent.code !== 1001) {
            return {
                type: 'PusherError',
                data: {
                    code: closeEvent.code,
                    message: closeEvent.reason || closeEvent.message
                }
            };
        }
        else {
            return null;
        }
    }
};
/* harmony default export */ var protocol_protocol = (Protocol);

// CONCATENATED MODULE: ./src/core/connection/connection.ts
var connection_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var connection_Connection = (function (_super) {
    connection_extends(Connection, _super);
    function Connection(id, transport) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.transport = transport;
        _this.activityTimeout = transport.activityTimeout;
        _this.bindListeners();
        return _this;
    }
    Connection.prototype.handlesActivityChecks = function () {
        return this.transport.handlesActivityChecks();
    };
    Connection.prototype.send = function (data) {
        return this.transport.send(data);
    };
    Connection.prototype.send_event = function (name, data, channel) {
        var event = { event: name, data: data };
        if (channel) {
            event.channel = channel;
        }
        logger.debug('Event sent', event);
        return this.send(protocol_protocol.encodeMessage(event));
    };
    Connection.prototype.ping = function () {
        if (this.transport.supportsPing()) {
            this.transport.ping();
        }
        else {
            this.send_event('pusher:ping', {});
        }
    };
    Connection.prototype.close = function () {
        this.transport.close();
    };
    Connection.prototype.bindListeners = function () {
        var _this = this;
        var listeners = {
            message: function (messageEvent) {
                var pusherEvent;
                try {
                    pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                }
                catch (e) {
                    _this.emit('error', {
                        type: 'MessageParseError',
                        error: e,
                        data: messageEvent.data
                    });
                }
                if (pusherEvent !== undefined) {
                    logger.debug('Event recd', pusherEvent);
                    switch (pusherEvent.event) {
                        case 'pusher:error':
                            _this.emit('error', {
                                type: 'PusherError',
                                data: pusherEvent.data
                            });
                            break;
                        case 'pusher:ping':
                            _this.emit('ping');
                            break;
                        case 'pusher:pong':
                            _this.emit('pong');
                            break;
                    }
                    _this.emit('message', pusherEvent);
                }
            },
            activity: function () {
                _this.emit('activity');
            },
            error: function (error) {
                _this.emit('error', error);
            },
            closed: function (closeEvent) {
                unbindListeners();
                if (closeEvent && closeEvent.code) {
                    _this.handleCloseEvent(closeEvent);
                }
                _this.transport = null;
                _this.emit('closed');
            }
        };
        var unbindListeners = function () {
            objectApply(listeners, function (listener, event) {
                _this.transport.unbind(event, listener);
            });
        };
        objectApply(listeners, function (listener, event) {
            _this.transport.bind(event, listener);
        });
    };
    Connection.prototype.handleCloseEvent = function (closeEvent) {
        var action = protocol_protocol.getCloseAction(closeEvent);
        var error = protocol_protocol.getCloseError(closeEvent);
        if (error) {
            this.emit('error', error);
        }
        if (action) {
            this.emit(action, { action: action, error: error });
        }
    };
    return Connection;
}(dispatcher));
/* harmony default export */ var connection_connection = (connection_Connection);

// CONCATENATED MODULE: ./src/core/connection/handshake/index.ts



var handshake_Handshake = (function () {
    function Handshake(transport, callback) {
        this.transport = transport;
        this.callback = callback;
        this.bindListeners();
    }
    Handshake.prototype.close = function () {
        this.unbindListeners();
        this.transport.close();
    };
    Handshake.prototype.bindListeners = function () {
        var _this = this;
        this.onMessage = function (m) {
            _this.unbindListeners();
            var result;
            try {
                result = protocol_protocol.processHandshake(m);
            }
            catch (e) {
                _this.finish('error', { error: e });
                _this.transport.close();
                return;
            }
            if (result.action === 'connected') {
                _this.finish('connected', {
                    connection: new connection_connection(result.id, _this.transport),
                    activityTimeout: result.activityTimeout
                });
            }
            else {
                _this.finish(result.action, { error: result.error });
                _this.transport.close();
            }
        };
        this.onClosed = function (closeEvent) {
            _this.unbindListeners();
            var action = protocol_protocol.getCloseAction(closeEvent) || 'backoff';
            var error = protocol_protocol.getCloseError(closeEvent);
            _this.finish(action, { error: error });
        };
        this.transport.bind('message', this.onMessage);
        this.transport.bind('closed', this.onClosed);
    };
    Handshake.prototype.unbindListeners = function () {
        this.transport.unbind('message', this.onMessage);
        this.transport.unbind('closed', this.onClosed);
    };
    Handshake.prototype.finish = function (action, params) {
        this.callback(extend({ transport: this.transport, action: action }, params));
    };
    return Handshake;
}());
/* harmony default export */ var connection_handshake = (handshake_Handshake);

// CONCATENATED MODULE: ./src/core/auth/pusher_authorizer.ts

var pusher_authorizer_PusherAuthorizer = (function () {
    function PusherAuthorizer(channel, options) {
        this.channel = channel;
        var authTransport = options.authTransport;
        if (typeof runtime.getAuthorizers()[authTransport] === 'undefined') {
            throw "'" + authTransport + "' is not a recognized auth transport";
        }
        this.type = authTransport;
        this.options = options;
        this.authOptions = options.auth || {};
    }
    PusherAuthorizer.prototype.composeQuery = function (socketId) {
        var query = 'socket_id=' +
            encodeURIComponent(socketId) +
            '&channel_name=' +
            encodeURIComponent(this.channel.name);
        for (var i in this.authOptions.params) {
            query +=
                '&' +
                    encodeURIComponent(i) +
                    '=' +
                    encodeURIComponent(this.authOptions.params[i]);
        }
        return query;
    };
    PusherAuthorizer.prototype.authorize = function (socketId, callback) {
        PusherAuthorizer.authorizers =
            PusherAuthorizer.authorizers || runtime.getAuthorizers();
        PusherAuthorizer.authorizers[this.type].call(this, runtime, socketId, callback);
    };
    return PusherAuthorizer;
}());
/* harmony default export */ var pusher_authorizer = (pusher_authorizer_PusherAuthorizer);

// CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts

var timeline_sender_TimelineSender = (function () {
    function TimelineSender(timeline, options) {
        this.timeline = timeline;
        this.options = options || {};
    }
    TimelineSender.prototype.send = function (useTLS, callback) {
        if (this.timeline.isEmpty()) {
            return;
        }
        this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
    };
    return TimelineSender;
}());
/* harmony default export */ var timeline_sender = (timeline_sender_TimelineSender);

// CONCATENATED MODULE: ./src/core/channels/channel.ts
var channel_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var channel_Channel = (function (_super) {
    channel_extends(Channel, _super);
    function Channel(name, pusher) {
        var _this = _super.call(this, function (event, data) {
            logger.debug('No callbacks on ' + name + ' for ' + event);
        }) || this;
        _this.name = name;
        _this.pusher = pusher;
        _this.subscribed = false;
        _this.subscriptionPending = false;
        _this.subscriptionCancelled = false;
        return _this;
    }
    Channel.prototype.authorize = function (socketId, callback) {
        return callback(null, { auth: '' });
    };
    Channel.prototype.trigger = function (event, data) {
        if (event.indexOf('client-') !== 0) {
            throw new BadEventName("Event '" + event + "' does not start with 'client-'");
        }
        if (!this.subscribed) {
            var suffix = url_store.buildLogSuffix('triggeringClientEvents');
            logger.warn("Client event triggered before channel 'subscription_succeeded' event . " + suffix);
        }
        return this.pusher.send_event(event, data, this.name);
    };
    Channel.prototype.disconnect = function () {
        this.subscribed = false;
        this.subscriptionPending = false;
    };
    Channel.prototype.handleEvent = function (event) {
        var eventName = event.event;
        var data = event.data;
        if (eventName === 'pusher_internal:subscription_succeeded') {
            this.handleSubscriptionSucceededEvent(event);
        }
        else if (eventName.indexOf('pusher_internal:') !== 0) {
            var metadata = {};
            this.emit(eventName, data, metadata);
        }
    };
    Channel.prototype.handleSubscriptionSucceededEvent = function (event) {
        this.subscriptionPending = false;
        this.subscribed = true;
        if (this.subscriptionCancelled) {
            this.pusher.unsubscribe(this.name);
        }
        else {
            this.emit('pusher:subscription_succeeded', event.data);
        }
    };
    Channel.prototype.subscribe = function () {
        var _this = this;
        if (this.subscribed) {
            return;
        }
        this.subscriptionPending = true;
        this.subscriptionCancelled = false;
        this.authorize(this.pusher.connection.socket_id, function (error, data) {
            if (error) {
                _this.subscriptionPending = false;
                logger.error(error.toString());
                _this.emit('pusher:subscription_error', Object.assign({}, {
                    type: 'AuthError',
                    error: error.message
                }, error instanceof HTTPAuthError ? { status: error.status } : {}));
            }
            else {
                _this.pusher.send_event('pusher:subscribe', {
                    auth: data.auth,
                    channel_data: data.channel_data,
                    channel: _this.name
                });
            }
        });
    };
    Channel.prototype.unsubscribe = function () {
        this.subscribed = false;
        this.pusher.send_event('pusher:unsubscribe', {
            channel: this.name
        });
    };
    Channel.prototype.cancelSubscription = function () {
        this.subscriptionCancelled = true;
    };
    Channel.prototype.reinstateSubscription = function () {
        this.subscriptionCancelled = false;
    };
    return Channel;
}(dispatcher));
/* harmony default export */ var channels_channel = (channel_Channel);

// CONCATENATED MODULE: ./src/core/channels/private_channel.ts
var private_channel_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var private_channel_PrivateChannel = (function (_super) {
    private_channel_extends(PrivateChannel, _super);
    function PrivateChannel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivateChannel.prototype.authorize = function (socketId, callback) {
        var authorizer = factory.createAuthorizer(this, this.pusher.config);
        return authorizer.authorize(socketId, callback);
    };
    return PrivateChannel;
}(channels_channel));
/* harmony default export */ var private_channel = (private_channel_PrivateChannel);

// CONCATENATED MODULE: ./src/core/channels/members.ts

var members_Members = (function () {
    function Members() {
        this.reset();
    }
    Members.prototype.get = function (id) {
        if (Object.prototype.hasOwnProperty.call(this.members, id)) {
            return {
                id: id,
                info: this.members[id]
            };
        }
        else {
            return null;
        }
    };
    Members.prototype.each = function (callback) {
        var _this = this;
        objectApply(this.members, function (member, id) {
            callback(_this.get(id));
        });
    };
    Members.prototype.setMyID = function (id) {
        this.myID = id;
    };
    Members.prototype.onSubscription = function (subscriptionData) {
        this.members = subscriptionData.presence.hash;
        this.count = subscriptionData.presence.count;
        this.me = this.get(this.myID);
    };
    Members.prototype.addMember = function (memberData) {
        if (this.get(memberData.user_id) === null) {
            this.count++;
        }
        this.members[memberData.user_id] = memberData.user_info;
        return this.get(memberData.user_id);
    };
    Members.prototype.removeMember = function (memberData) {
        var member = this.get(memberData.user_id);
        if (member) {
            delete this.members[memberData.user_id];
            this.count--;
        }
        return member;
    };
    Members.prototype.reset = function () {
        this.members = {};
        this.count = 0;
        this.myID = null;
        this.me = null;
    };
    return Members;
}());
/* harmony default export */ var members = (members_Members);

// CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
var presence_channel_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var presence_channel_PresenceChannel = (function (_super) {
    presence_channel_extends(PresenceChannel, _super);
    function PresenceChannel(name, pusher) {
        var _this = _super.call(this, name, pusher) || this;
        _this.members = new members();
        return _this;
    }
    PresenceChannel.prototype.authorize = function (socketId, callback) {
        var _this = this;
        _super.prototype.authorize.call(this, socketId, function (error, authData) {
            if (!error) {
                authData = authData;
                if (authData.channel_data === undefined) {
                    var suffix = url_store.buildLogSuffix('authenticationEndpoint');
                    logger.error("Invalid auth response for channel '" + _this.name + "'," +
                        ("expected 'channel_data' field. " + suffix));
                    callback('Invalid auth response');
                    return;
                }
                var channelData = JSON.parse(authData.channel_data);
                _this.members.setMyID(channelData.user_id);
            }
            callback(error, authData);
        });
    };
    PresenceChannel.prototype.handleEvent = function (event) {
        var eventName = event.event;
        if (eventName.indexOf('pusher_internal:') === 0) {
            this.handleInternalEvent(event);
        }
        else {
            var data = event.data;
            var metadata = {};
            if (event.user_id) {
                metadata.user_id = event.user_id;
            }
            this.emit(eventName, data, metadata);
        }
    };
    PresenceChannel.prototype.handleInternalEvent = function (event) {
        var eventName = event.event;
        var data = event.data;
        switch (eventName) {
            case 'pusher_internal:subscription_succeeded':
                this.handleSubscriptionSucceededEvent(event);
                break;
            case 'pusher_internal:member_added':
                var addedMember = this.members.addMember(data);
                this.emit('pusher:member_added', addedMember);
                break;
            case 'pusher_internal:member_removed':
                var removedMember = this.members.removeMember(data);
                if (removedMember) {
                    this.emit('pusher:member_removed', removedMember);
                }
                break;
        }
    };
    PresenceChannel.prototype.handleSubscriptionSucceededEvent = function (event) {
        this.subscriptionPending = false;
        this.subscribed = true;
        if (this.subscriptionCancelled) {
            this.pusher.unsubscribe(this.name);
        }
        else {
            this.members.onSubscription(event.data);
            this.emit('pusher:subscription_succeeded', this.members);
        }
    };
    PresenceChannel.prototype.disconnect = function () {
        this.members.reset();
        _super.prototype.disconnect.call(this);
    };
    return PresenceChannel;
}(private_channel));
/* harmony default export */ var presence_channel = (presence_channel_PresenceChannel);

// EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
var utf8 = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
var base64 = __webpack_require__(0);

// CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts
var encrypted_channel_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var encrypted_channel_EncryptedChannel = (function (_super) {
    encrypted_channel_extends(EncryptedChannel, _super);
    function EncryptedChannel(name, pusher, nacl) {
        var _this = _super.call(this, name, pusher) || this;
        _this.key = null;
        _this.nacl = nacl;
        return _this;
    }
    EncryptedChannel.prototype.authorize = function (socketId, callback) {
        var _this = this;
        _super.prototype.authorize.call(this, socketId, function (error, authData) {
            if (error) {
                callback(error, authData);
                return;
            }
            var sharedSecret = authData['shared_secret'];
            if (!sharedSecret) {
                callback(new Error("No shared_secret key in auth payload for encrypted channel: " + _this.name), null);
                return;
            }
            _this.key = Object(base64["decode"])(sharedSecret);
            delete authData['shared_secret'];
            callback(null, authData);
        });
    };
    EncryptedChannel.prototype.trigger = function (event, data) {
        throw new UnsupportedFeature('Client events are not currently supported for encrypted channels');
    };
    EncryptedChannel.prototype.handleEvent = function (event) {
        var eventName = event.event;
        var data = event.data;
        if (eventName.indexOf('pusher_internal:') === 0 ||
            eventName.indexOf('pusher:') === 0) {
            _super.prototype.handleEvent.call(this, event);
            return;
        }
        this.handleEncryptedEvent(eventName, data);
    };
    EncryptedChannel.prototype.handleEncryptedEvent = function (event, data) {
        var _this = this;
        if (!this.key) {
            logger.debug('Received encrypted event before key has been retrieved from the authEndpoint');
            return;
        }
        if (!data.ciphertext || !data.nonce) {
            logger.error('Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: ' +
                data);
            return;
        }
        var cipherText = Object(base64["decode"])(data.ciphertext);
        if (cipherText.length < this.nacl.secretbox.overheadLength) {
            logger.error("Expected encrypted event ciphertext length to be " + this.nacl.secretbox.overheadLength + ", got: " + cipherText.length);
            return;
        }
        var nonce = Object(base64["decode"])(data.nonce);
        if (nonce.length < this.nacl.secretbox.nonceLength) {
            logger.error("Expected encrypted event nonce length to be " + this.nacl.secretbox.nonceLength + ", got: " + nonce.length);
            return;
        }
        var bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
        if (bytes === null) {
            logger.debug('Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...');
            this.authorize(this.pusher.connection.socket_id, function (error, authData) {
                if (error) {
                    logger.error("Failed to make a request to the authEndpoint: " + authData + ". Unable to fetch new key, so dropping encrypted event");
                    return;
                }
                bytes = _this.nacl.secretbox.open(cipherText, nonce, _this.key);
                if (bytes === null) {
                    logger.error("Failed to decrypt event with new key. Dropping encrypted event");
                    return;
                }
                _this.emit(event, _this.getDataToEmit(bytes));
                return;
            });
            return;
        }
        this.emit(event, this.getDataToEmit(bytes));
    };
    EncryptedChannel.prototype.getDataToEmit = function (bytes) {
        var raw = Object(utf8["decode"])(bytes);
        try {
            return JSON.parse(raw);
        }
        catch (_a) {
            return raw;
        }
    };
    return EncryptedChannel;
}(private_channel));
/* harmony default export */ var encrypted_channel = (encrypted_channel_EncryptedChannel);

// CONCATENATED MODULE: ./src/core/connection/connection_manager.ts
var connection_manager_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var connection_manager_ConnectionManager = (function (_super) {
    connection_manager_extends(ConnectionManager, _super);
    function ConnectionManager(key, options) {
        var _this = _super.call(this) || this;
        _this.state = 'initialized';
        _this.connection = null;
        _this.key = key;
        _this.options = options;
        _this.timeline = _this.options.timeline;
        _this.usingTLS = _this.options.useTLS;
        _this.errorCallbacks = _this.buildErrorCallbacks();
        _this.connectionCallbacks = _this.buildConnectionCallbacks(_this.errorCallbacks);
        _this.handshakeCallbacks = _this.buildHandshakeCallbacks(_this.errorCallbacks);
        var Network = runtime.getNetwork();
        Network.bind('online', function () {
            _this.timeline.info({ netinfo: 'online' });
            if (_this.state === 'connecting' || _this.state === 'unavailable') {
                _this.retryIn(0);
            }
        });
        Network.bind('offline', function () {
            _this.timeline.info({ netinfo: 'offline' });
            if (_this.connection) {
                _this.sendActivityCheck();
            }
        });
        _this.updateStrategy();
        return _this;
    }
    ConnectionManager.prototype.connect = function () {
        if (this.connection || this.runner) {
            return;
        }
        if (!this.strategy.isSupported()) {
            this.updateState('failed');
            return;
        }
        this.updateState('connecting');
        this.startConnecting();
        this.setUnavailableTimer();
    };
    ConnectionManager.prototype.send = function (data) {
        if (this.connection) {
            return this.connection.send(data);
        }
        else {
            return false;
        }
    };
    ConnectionManager.prototype.send_event = function (name, data, channel) {
        if (this.connection) {
            return this.connection.send_event(name, data, channel);
        }
        else {
            return false;
        }
    };
    ConnectionManager.prototype.disconnect = function () {
        this.disconnectInternally();
        this.updateState('disconnected');
    };
    ConnectionManager.prototype.isUsingTLS = function () {
        return this.usingTLS;
    };
    ConnectionManager.prototype.startConnecting = function () {
        var _this = this;
        var callback = function (error, handshake) {
            if (error) {
                _this.runner = _this.strategy.connect(0, callback);
            }
            else {
                if (handshake.action === 'error') {
                    _this.emit('error', {
                        type: 'HandshakeError',
                        error: handshake.error
                    });
                    _this.timeline.error({ handshakeError: handshake.error });
                }
                else {
                    _this.abortConnecting();
                    _this.handshakeCallbacks[handshake.action](handshake);
                }
            }
        };
        this.runner = this.strategy.connect(0, callback);
    };
    ConnectionManager.prototype.abortConnecting = function () {
        if (this.runner) {
            this.runner.abort();
            this.runner = null;
        }
    };
    ConnectionManager.prototype.disconnectInternally = function () {
        this.abortConnecting();
        this.clearRetryTimer();
        this.clearUnavailableTimer();
        if (this.connection) {
            var connection = this.abandonConnection();
            connection.close();
        }
    };
    ConnectionManager.prototype.updateStrategy = function () {
        this.strategy = this.options.getStrategy({
            key: this.key,
            timeline: this.timeline,
            useTLS: this.usingTLS
        });
    };
    ConnectionManager.prototype.retryIn = function (delay) {
        var _this = this;
        this.timeline.info({ action: 'retry', delay: delay });
        if (delay > 0) {
            this.emit('connecting_in', Math.round(delay / 1000));
        }
        this.retryTimer = new OneOffTimer(delay || 0, function () {
            _this.disconnectInternally();
            _this.connect();
        });
    };
    ConnectionManager.prototype.clearRetryTimer = function () {
        if (this.retryTimer) {
            this.retryTimer.ensureAborted();
            this.retryTimer = null;
        }
    };
    ConnectionManager.prototype.setUnavailableTimer = function () {
        var _this = this;
        this.unavailableTimer = new OneOffTimer(this.options.unavailableTimeout, function () {
            _this.updateState('unavailable');
        });
    };
    ConnectionManager.prototype.clearUnavailableTimer = function () {
        if (this.unavailableTimer) {
            this.unavailableTimer.ensureAborted();
        }
    };
    ConnectionManager.prototype.sendActivityCheck = function () {
        var _this = this;
        this.stopActivityCheck();
        this.connection.ping();
        this.activityTimer = new OneOffTimer(this.options.pongTimeout, function () {
            _this.timeline.error({ pong_timed_out: _this.options.pongTimeout });
            _this.retryIn(0);
        });
    };
    ConnectionManager.prototype.resetActivityCheck = function () {
        var _this = this;
        this.stopActivityCheck();
        if (this.connection && !this.connection.handlesActivityChecks()) {
            this.activityTimer = new OneOffTimer(this.activityTimeout, function () {
                _this.sendActivityCheck();
            });
        }
    };
    ConnectionManager.prototype.stopActivityCheck = function () {
        if (this.activityTimer) {
            this.activityTimer.ensureAborted();
        }
    };
    ConnectionManager.prototype.buildConnectionCallbacks = function (errorCallbacks) {
        var _this = this;
        return extend({}, errorCallbacks, {
            message: function (message) {
                _this.resetActivityCheck();
                _this.emit('message', message);
            },
            ping: function () {
                _this.send_event('pusher:pong', {});
            },
            activity: function () {
                _this.resetActivityCheck();
            },
            error: function (error) {
                _this.emit('error', error);
            },
            closed: function () {
                _this.abandonConnection();
                if (_this.shouldRetry()) {
                    _this.retryIn(1000);
                }
            }
        });
    };
    ConnectionManager.prototype.buildHandshakeCallbacks = function (errorCallbacks) {
        var _this = this;
        return extend({}, errorCallbacks, {
            connected: function (handshake) {
                _this.activityTimeout = Math.min(_this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                _this.clearUnavailableTimer();
                _this.setConnection(handshake.connection);
                _this.socket_id = _this.connection.id;
                _this.updateState('connected', { socket_id: _this.socket_id });
            }
        });
    };
    ConnectionManager.prototype.buildErrorCallbacks = function () {
        var _this = this;
        var withErrorEmitted = function (callback) {
            return function (result) {
                if (result.error) {
                    _this.emit('error', { type: 'WebSocketError', error: result.error });
                }
                callback(result);
            };
        };
        return {
            tls_only: withErrorEmitted(function () {
                _this.usingTLS = true;
                _this.updateStrategy();
                _this.retryIn(0);
            }),
            refused: withErrorEmitted(function () {
                _this.disconnect();
            }),
            backoff: withErrorEmitted(function () {
                _this.retryIn(1000);
            }),
            retry: withErrorEmitted(function () {
                _this.retryIn(0);
            })
        };
    };
    ConnectionManager.prototype.setConnection = function (connection) {
        this.connection = connection;
        for (var event in this.connectionCallbacks) {
            this.connection.bind(event, this.connectionCallbacks[event]);
        }
        this.resetActivityCheck();
    };
    ConnectionManager.prototype.abandonConnection = function () {
        if (!this.connection) {
            return;
        }
        this.stopActivityCheck();
        for (var event in this.connectionCallbacks) {
            this.connection.unbind(event, this.connectionCallbacks[event]);
        }
        var connection = this.connection;
        this.connection = null;
        return connection;
    };
    ConnectionManager.prototype.updateState = function (newState, data) {
        var previousState = this.state;
        this.state = newState;
        if (previousState !== newState) {
            var newStateDescription = newState;
            if (newStateDescription === 'connected') {
                newStateDescription += ' with new socket ID ' + data.socket_id;
            }
            logger.debug('State changed', previousState + ' -> ' + newStateDescription);
            this.timeline.info({ state: newState, params: data });
            this.emit('state_change', { previous: previousState, current: newState });
            this.emit(newState, data);
        }
    };
    ConnectionManager.prototype.shouldRetry = function () {
        return this.state === 'connecting' || this.state === 'connected';
    };
    return ConnectionManager;
}(dispatcher));
/* harmony default export */ var connection_manager = (connection_manager_ConnectionManager);

// CONCATENATED MODULE: ./src/core/channels/channels.ts




var channels_Channels = (function () {
    function Channels() {
        this.channels = {};
    }
    Channels.prototype.add = function (name, pusher) {
        if (!this.channels[name]) {
            this.channels[name] = createChannel(name, pusher);
        }
        return this.channels[name];
    };
    Channels.prototype.all = function () {
        return values(this.channels);
    };
    Channels.prototype.find = function (name) {
        return this.channels[name];
    };
    Channels.prototype.remove = function (name) {
        var channel = this.channels[name];
        delete this.channels[name];
        return channel;
    };
    Channels.prototype.disconnect = function () {
        objectApply(this.channels, function (channel) {
            channel.disconnect();
        });
    };
    return Channels;
}());
/* harmony default export */ var channels = (channels_Channels);
function createChannel(name, pusher) {
    if (name.indexOf('private-encrypted-') === 0) {
        if (pusher.config.nacl) {
            return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
        }
        var errMsg = 'Tried to subscribe to a private-encrypted- channel but no nacl implementation available';
        var suffix = url_store.buildLogSuffix('encryptedChannelSupport');
        throw new UnsupportedFeature(errMsg + ". " + suffix);
    }
    else if (name.indexOf('private-') === 0) {
        return factory.createPrivateChannel(name, pusher);
    }
    else if (name.indexOf('presence-') === 0) {
        return factory.createPresenceChannel(name, pusher);
    }
    else {
        return factory.createChannel(name, pusher);
    }
}

// CONCATENATED MODULE: ./src/core/utils/factory.ts










var Factory = {
    createChannels: function () {
        return new channels();
    },
    createConnectionManager: function (key, options) {
        return new connection_manager(key, options);
    },
    createChannel: function (name, pusher) {
        return new channels_channel(name, pusher);
    },
    createPrivateChannel: function (name, pusher) {
        return new private_channel(name, pusher);
    },
    createPresenceChannel: function (name, pusher) {
        return new presence_channel(name, pusher);
    },
    createEncryptedChannel: function (name, pusher, nacl) {
        return new encrypted_channel(name, pusher, nacl);
    },
    createTimelineSender: function (timeline, options) {
        return new timeline_sender(timeline, options);
    },
    createAuthorizer: function (channel, options) {
        if (options.authorizer) {
            return options.authorizer(channel, options);
        }
        return new pusher_authorizer(channel, options);
    },
    createHandshake: function (transport, callback) {
        return new connection_handshake(transport, callback);
    },
    createAssistantToTheTransportManager: function (manager, transport, options) {
        return new assistant_to_the_transport_manager(manager, transport, options);
    }
};
/* harmony default export */ var factory = (Factory);

// CONCATENATED MODULE: ./src/core/transports/transport_manager.ts

var transport_manager_TransportManager = (function () {
    function TransportManager(options) {
        this.options = options || {};
        this.livesLeft = this.options.lives || Infinity;
    }
    TransportManager.prototype.getAssistant = function (transport) {
        return factory.createAssistantToTheTransportManager(this, transport, {
            minPingDelay: this.options.minPingDelay,
            maxPingDelay: this.options.maxPingDelay
        });
    };
    TransportManager.prototype.isAlive = function () {
        return this.livesLeft > 0;
    };
    TransportManager.prototype.reportDeath = function () {
        this.livesLeft -= 1;
    };
    return TransportManager;
}());
/* harmony default export */ var transport_manager = (transport_manager_TransportManager);

// CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts



var sequential_strategy_SequentialStrategy = (function () {
    function SequentialStrategy(strategies, options) {
        this.strategies = strategies;
        this.loop = Boolean(options.loop);
        this.failFast = Boolean(options.failFast);
        this.timeout = options.timeout;
        this.timeoutLimit = options.timeoutLimit;
    }
    SequentialStrategy.prototype.isSupported = function () {
        return any(this.strategies, util.method('isSupported'));
    };
    SequentialStrategy.prototype.connect = function (minPriority, callback) {
        var _this = this;
        var strategies = this.strategies;
        var current = 0;
        var timeout = this.timeout;
        var runner = null;
        var tryNextStrategy = function (error, handshake) {
            if (handshake) {
                callback(null, handshake);
            }
            else {
                current = current + 1;
                if (_this.loop) {
                    current = current % strategies.length;
                }
                if (current < strategies.length) {
                    if (timeout) {
                        timeout = timeout * 2;
                        if (_this.timeoutLimit) {
                            timeout = Math.min(timeout, _this.timeoutLimit);
                        }
                    }
                    runner = _this.tryStrategy(strategies[current], minPriority, { timeout: timeout, failFast: _this.failFast }, tryNextStrategy);
                }
                else {
                    callback(true);
                }
            }
        };
        runner = this.tryStrategy(strategies[current], minPriority, { timeout: timeout, failFast: this.failFast }, tryNextStrategy);
        return {
            abort: function () {
                runner.abort();
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    };
    SequentialStrategy.prototype.tryStrategy = function (strategy, minPriority, options, callback) {
        var timer = null;
        var runner = null;
        if (options.timeout > 0) {
            timer = new OneOffTimer(options.timeout, function () {
                runner.abort();
                callback(true);
            });
        }
        runner = strategy.connect(minPriority, function (error, handshake) {
            if (error && timer && timer.isRunning() && !options.failFast) {
                return;
            }
            if (timer) {
                timer.ensureAborted();
            }
            callback(error, handshake);
        });
        return {
            abort: function () {
                if (timer) {
                    timer.ensureAborted();
                }
                runner.abort();
            },
            forceMinPriority: function (p) {
                runner.forceMinPriority(p);
            }
        };
    };
    return SequentialStrategy;
}());
/* harmony default export */ var sequential_strategy = (sequential_strategy_SequentialStrategy);

// CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts


var best_connected_ever_strategy_BestConnectedEverStrategy = (function () {
    function BestConnectedEverStrategy(strategies) {
        this.strategies = strategies;
    }
    BestConnectedEverStrategy.prototype.isSupported = function () {
        return any(this.strategies, util.method('isSupported'));
    };
    BestConnectedEverStrategy.prototype.connect = function (minPriority, callback) {
        return connect(this.strategies, minPriority, function (i, runners) {
            return function (error, handshake) {
                runners[i].error = error;
                if (error) {
                    if (allRunnersFailed(runners)) {
                        callback(true);
                    }
                    return;
                }
                apply(runners, function (runner) {
                    runner.forceMinPriority(handshake.transport.priority);
                });
                callback(null, handshake);
            };
        });
    };
    return BestConnectedEverStrategy;
}());
/* harmony default export */ var best_connected_ever_strategy = (best_connected_ever_strategy_BestConnectedEverStrategy);
function connect(strategies, minPriority, callbackBuilder) {
    var runners = map(strategies, function (strategy, i, _, rs) {
        return strategy.connect(minPriority, callbackBuilder(i, rs));
    });
    return {
        abort: function () {
            apply(runners, abortRunner);
        },
        forceMinPriority: function (p) {
            apply(runners, function (runner) {
                runner.forceMinPriority(p);
            });
        }
    };
}
function allRunnersFailed(runners) {
    return collections_all(runners, function (runner) {
        return Boolean(runner.error);
    });
}
function abortRunner(runner) {
    if (!runner.error && !runner.aborted) {
        runner.abort();
        runner.aborted = true;
    }
}

// CONCATENATED MODULE: ./src/core/strategies/cached_strategy.ts




var cached_strategy_CachedStrategy = (function () {
    function CachedStrategy(strategy, transports, options) {
        this.strategy = strategy;
        this.transports = transports;
        this.ttl = options.ttl || 1800 * 1000;
        this.usingTLS = options.useTLS;
        this.timeline = options.timeline;
    }
    CachedStrategy.prototype.isSupported = function () {
        return this.strategy.isSupported();
    };
    CachedStrategy.prototype.connect = function (minPriority, callback) {
        var usingTLS = this.usingTLS;
        var info = fetchTransportCache(usingTLS);
        var strategies = [this.strategy];
        if (info && info.timestamp + this.ttl >= util.now()) {
            var transport = this.transports[info.transport];
            if (transport) {
                this.timeline.info({
                    cached: true,
                    transport: info.transport,
                    latency: info.latency
                });
                strategies.push(new sequential_strategy([transport], {
                    timeout: info.latency * 2 + 1000,
                    failFast: true
                }));
            }
        }
        var startTimestamp = util.now();
        var runner = strategies
            .pop()
            .connect(minPriority, function cb(error, handshake) {
            if (error) {
                flushTransportCache(usingTLS);
                if (strategies.length > 0) {
                    startTimestamp = util.now();
                    runner = strategies.pop().connect(minPriority, cb);
                }
                else {
                    callback(error);
                }
            }
            else {
                storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp);
                callback(null, handshake);
            }
        });
        return {
            abort: function () {
                runner.abort();
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    };
    return CachedStrategy;
}());
/* harmony default export */ var cached_strategy = (cached_strategy_CachedStrategy);
function getTransportCacheKey(usingTLS) {
    return 'pusherTransport' + (usingTLS ? 'TLS' : 'NonTLS');
}
function fetchTransportCache(usingTLS) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            var serializedCache = storage[getTransportCacheKey(usingTLS)];
            if (serializedCache) {
                return JSON.parse(serializedCache);
            }
        }
        catch (e) {
            flushTransportCache(usingTLS);
        }
    }
    return null;
}
function storeTransportCache(usingTLS, transport, latency) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                timestamp: util.now(),
                transport: transport,
                latency: latency
            });
        }
        catch (e) {
        }
    }
}
function flushTransportCache(usingTLS) {
    var storage = runtime.getLocalStorage();
    if (storage) {
        try {
            delete storage[getTransportCacheKey(usingTLS)];
        }
        catch (e) {
        }
    }
}

// CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts

var delayed_strategy_DelayedStrategy = (function () {
    function DelayedStrategy(strategy, _a) {
        var number = _a.delay;
        this.strategy = strategy;
        this.options = { delay: number };
    }
    DelayedStrategy.prototype.isSupported = function () {
        return this.strategy.isSupported();
    };
    DelayedStrategy.prototype.connect = function (minPriority, callback) {
        var strategy = this.strategy;
        var runner;
        var timer = new OneOffTimer(this.options.delay, function () {
            runner = strategy.connect(minPriority, callback);
        });
        return {
            abort: function () {
                timer.ensureAborted();
                if (runner) {
                    runner.abort();
                }
            },
            forceMinPriority: function (p) {
                minPriority = p;
                if (runner) {
                    runner.forceMinPriority(p);
                }
            }
        };
    };
    return DelayedStrategy;
}());
/* harmony default export */ var delayed_strategy = (delayed_strategy_DelayedStrategy);

// CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
var IfStrategy = (function () {
    function IfStrategy(test, trueBranch, falseBranch) {
        this.test = test;
        this.trueBranch = trueBranch;
        this.falseBranch = falseBranch;
    }
    IfStrategy.prototype.isSupported = function () {
        var branch = this.test() ? this.trueBranch : this.falseBranch;
        return branch.isSupported();
    };
    IfStrategy.prototype.connect = function (minPriority, callback) {
        var branch = this.test() ? this.trueBranch : this.falseBranch;
        return branch.connect(minPriority, callback);
    };
    return IfStrategy;
}());
/* harmony default export */ var if_strategy = (IfStrategy);

// CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
var FirstConnectedStrategy = (function () {
    function FirstConnectedStrategy(strategy) {
        this.strategy = strategy;
    }
    FirstConnectedStrategy.prototype.isSupported = function () {
        return this.strategy.isSupported();
    };
    FirstConnectedStrategy.prototype.connect = function (minPriority, callback) {
        var runner = this.strategy.connect(minPriority, function (error, handshake) {
            if (handshake) {
                runner.abort();
            }
            callback(error, handshake);
        });
        return runner;
    };
    return FirstConnectedStrategy;
}());
/* harmony default export */ var first_connected_strategy = (FirstConnectedStrategy);

// CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts







function testSupportsStrategy(strategy) {
    return function () {
        return strategy.isSupported();
    };
}
var getDefaultStrategy = function (config, baseOptions, defineTransport) {
    var definedTransports = {};
    function defineTransportStrategy(name, type, priority, options, manager) {
        var transport = defineTransport(config, name, type, priority, options, manager);
        definedTransports[name] = transport;
        return transport;
    }
    var ws_options = Object.assign({}, baseOptions, {
        hostNonTLS: config.wsHost + ':' + config.wsPort,
        hostTLS: config.wsHost + ':' + config.wssPort,
        httpPath: config.wsPath
    });
    var wss_options = Object.assign({}, ws_options, {
        useTLS: true
    });
    var sockjs_options = Object.assign({}, baseOptions, {
        hostNonTLS: config.httpHost + ':' + config.httpPort,
        hostTLS: config.httpHost + ':' + config.httpsPort,
        httpPath: config.httpPath
    });
    var timeouts = {
        loop: true,
        timeout: 15000,
        timeoutLimit: 60000
    };
    var ws_manager = new transport_manager({
        lives: 2,
        minPingDelay: 10000,
        maxPingDelay: config.activityTimeout
    });
    var streaming_manager = new transport_manager({
        lives: 2,
        minPingDelay: 10000,
        maxPingDelay: config.activityTimeout
    });
    var ws_transport = defineTransportStrategy('ws', 'ws', 3, ws_options, ws_manager);
    var wss_transport = defineTransportStrategy('wss', 'ws', 3, wss_options, ws_manager);
    var sockjs_transport = defineTransportStrategy('sockjs', 'sockjs', 1, sockjs_options);
    var xhr_streaming_transport = defineTransportStrategy('xhr_streaming', 'xhr_streaming', 1, sockjs_options, streaming_manager);
    var xdr_streaming_transport = defineTransportStrategy('xdr_streaming', 'xdr_streaming', 1, sockjs_options, streaming_manager);
    var xhr_polling_transport = defineTransportStrategy('xhr_polling', 'xhr_polling', 1, sockjs_options);
    var xdr_polling_transport = defineTransportStrategy('xdr_polling', 'xdr_polling', 1, sockjs_options);
    var ws_loop = new sequential_strategy([ws_transport], timeouts);
    var wss_loop = new sequential_strategy([wss_transport], timeouts);
    var sockjs_loop = new sequential_strategy([sockjs_transport], timeouts);
    var streaming_loop = new sequential_strategy([
        new if_strategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
    ], timeouts);
    var polling_loop = new sequential_strategy([
        new if_strategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
    ], timeouts);
    var http_loop = new sequential_strategy([
        new if_strategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy([
            streaming_loop,
            new delayed_strategy(polling_loop, { delay: 4000 })
        ]), polling_loop)
    ], timeouts);
    var http_fallback_loop = new if_strategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
    var wsStrategy;
    if (baseOptions.useTLS) {
        wsStrategy = new best_connected_ever_strategy([
            ws_loop,
            new delayed_strategy(http_fallback_loop, { delay: 2000 })
        ]);
    }
    else {
        wsStrategy = new best_connected_ever_strategy([
            ws_loop,
            new delayed_strategy(wss_loop, { delay: 2000 }),
            new delayed_strategy(http_fallback_loop, { delay: 5000 })
        ]);
    }
    return new cached_strategy(new first_connected_strategy(new if_strategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
        ttl: 1800000,
        timeline: baseOptions.timeline,
        useTLS: baseOptions.useTLS
    });
};
/* harmony default export */ var default_strategy = (getDefaultStrategy);

// CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts

/* harmony default export */ var transport_connection_initializer = (function () {
    var self = this;
    self.timeline.info(self.buildTimelineMessage({
        transport: self.name + (self.options.useTLS ? 's' : '')
    }));
    if (self.hooks.isInitialized()) {
        self.changeState('initialized');
    }
    else if (self.hooks.file) {
        self.changeState('initializing');
        Dependencies.load(self.hooks.file, { useTLS: self.options.useTLS }, function (error, callback) {
            if (self.hooks.isInitialized()) {
                self.changeState('initialized');
                callback(true);
            }
            else {
                if (error) {
                    self.onError(error);
                }
                self.onClose();
                callback(false);
            }
        });
    }
    else {
        self.onClose();
    }
});

// CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts

var http_xdomain_request_hooks = {
    getRequest: function (socket) {
        var xdr = new window.XDomainRequest();
        xdr.ontimeout = function () {
            socket.emit('error', new RequestTimedOut());
            socket.close();
        };
        xdr.onerror = function (e) {
            socket.emit('error', e);
            socket.close();
        };
        xdr.onprogress = function () {
            if (xdr.responseText && xdr.responseText.length > 0) {
                socket.onChunk(200, xdr.responseText);
            }
        };
        xdr.onload = function () {
            if (xdr.responseText && xdr.responseText.length > 0) {
                socket.onChunk(200, xdr.responseText);
            }
            socket.emit('finished', 200);
            socket.close();
        };
        return xdr;
    },
    abortRequest: function (xdr) {
        xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
        xdr.abort();
    }
};
/* harmony default export */ var http_xdomain_request = (http_xdomain_request_hooks);

// CONCATENATED MODULE: ./src/core/http/http_request.ts
var http_request_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var MAX_BUFFER_LENGTH = 256 * 1024;
var http_request_HTTPRequest = (function (_super) {
    http_request_extends(HTTPRequest, _super);
    function HTTPRequest(hooks, method, url) {
        var _this = _super.call(this) || this;
        _this.hooks = hooks;
        _this.method = method;
        _this.url = url;
        return _this;
    }
    HTTPRequest.prototype.start = function (payload) {
        var _this = this;
        this.position = 0;
        this.xhr = this.hooks.getRequest(this);
        this.unloader = function () {
            _this.close();
        };
        runtime.addUnloadListener(this.unloader);
        this.xhr.open(this.method, this.url, true);
        if (this.xhr.setRequestHeader) {
            this.xhr.setRequestHeader('Content-Type', 'application/json');
        }
        this.xhr.send(payload);
    };
    HTTPRequest.prototype.close = function () {
        if (this.unloader) {
            runtime.removeUnloadListener(this.unloader);
            this.unloader = null;
        }
        if (this.xhr) {
            this.hooks.abortRequest(this.xhr);
            this.xhr = null;
        }
    };
    HTTPRequest.prototype.onChunk = function (status, data) {
        while (true) {
            var chunk = this.advanceBuffer(data);
            if (chunk) {
                this.emit('chunk', { status: status, data: chunk });
            }
            else {
                break;
            }
        }
        if (this.isBufferTooLong(data)) {
            this.emit('buffer_too_long');
        }
    };
    HTTPRequest.prototype.advanceBuffer = function (buffer) {
        var unreadData = buffer.slice(this.position);
        var endOfLinePosition = unreadData.indexOf('\n');
        if (endOfLinePosition !== -1) {
            this.position += endOfLinePosition + 1;
            return unreadData.slice(0, endOfLinePosition);
        }
        else {
            return null;
        }
    };
    HTTPRequest.prototype.isBufferTooLong = function (buffer) {
        return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
    };
    return HTTPRequest;
}(dispatcher));
/* harmony default export */ var http_request = (http_request_HTTPRequest);

// CONCATENATED MODULE: ./src/core/http/state.ts
var State;
(function (State) {
    State[State["CONNECTING"] = 0] = "CONNECTING";
    State[State["OPEN"] = 1] = "OPEN";
    State[State["CLOSED"] = 3] = "CLOSED";
})(State || (State = {}));
/* harmony default export */ var state = (State);

// CONCATENATED MODULE: ./src/core/http/http_socket.ts



var autoIncrement = 1;
var http_socket_HTTPSocket = (function () {
    function HTTPSocket(hooks, url) {
        this.hooks = hooks;
        this.session = randomNumber(1000) + '/' + randomString(8);
        this.location = getLocation(url);
        this.readyState = state.CONNECTING;
        this.openStream();
    }
    HTTPSocket.prototype.send = function (payload) {
        return this.sendRaw(JSON.stringify([payload]));
    };
    HTTPSocket.prototype.ping = function () {
        this.hooks.sendHeartbeat(this);
    };
    HTTPSocket.prototype.close = function (code, reason) {
        this.onClose(code, reason, true);
    };
    HTTPSocket.prototype.sendRaw = function (payload) {
        if (this.readyState === state.OPEN) {
            try {
                runtime.createSocketRequest('POST', getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                return true;
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    };
    HTTPSocket.prototype.reconnect = function () {
        this.closeStream();
        this.openStream();
    };
    HTTPSocket.prototype.onClose = function (code, reason, wasClean) {
        this.closeStream();
        this.readyState = state.CLOSED;
        if (this.onclose) {
            this.onclose({
                code: code,
                reason: reason,
                wasClean: wasClean
            });
        }
    };
    HTTPSocket.prototype.onChunk = function (chunk) {
        if (chunk.status !== 200) {
            return;
        }
        if (this.readyState === state.OPEN) {
            this.onActivity();
        }
        var payload;
        var type = chunk.data.slice(0, 1);
        switch (type) {
            case 'o':
                payload = JSON.parse(chunk.data.slice(1) || '{}');
                this.onOpen(payload);
                break;
            case 'a':
                payload = JSON.parse(chunk.data.slice(1) || '[]');
                for (var i = 0; i < payload.length; i++) {
                    this.onEvent(payload[i]);
                }
                break;
            case 'm':
                payload = JSON.parse(chunk.data.slice(1) || 'null');
                this.onEvent(payload);
                break;
            case 'h':
                this.hooks.onHeartbeat(this);
                break;
            case 'c':
                payload = JSON.parse(chunk.data.slice(1) || '[]');
                this.onClose(payload[0], payload[1], true);
                break;
        }
    };
    HTTPSocket.prototype.onOpen = function (options) {
        if (this.readyState === state.CONNECTING) {
            if (options && options.hostname) {
                this.location.base = replaceHost(this.location.base, options.hostname);
            }
            this.readyState = state.OPEN;
            if (this.onopen) {
                this.onopen();
            }
        }
        else {
            this.onClose(1006, 'Server lost session', true);
        }
    };
    HTTPSocket.prototype.onEvent = function (event) {
        if (this.readyState === state.OPEN && this.onmessage) {
            this.onmessage({ data: event });
        }
    };
    HTTPSocket.prototype.onActivity = function () {
        if (this.onactivity) {
            this.onactivity();
        }
    };
    HTTPSocket.prototype.onError = function (error) {
        if (this.onerror) {
            this.onerror(error);
        }
    };
    HTTPSocket.prototype.openStream = function () {
        var _this = this;
        this.stream = runtime.createSocketRequest('POST', getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
        this.stream.bind('chunk', function (chunk) {
            _this.onChunk(chunk);
        });
        this.stream.bind('finished', function (status) {
            _this.hooks.onFinished(_this, status);
        });
        this.stream.bind('buffer_too_long', function () {
            _this.reconnect();
        });
        try {
            this.stream.start();
        }
        catch (error) {
            util.defer(function () {
                _this.onError(error);
                _this.onClose(1006, 'Could not start streaming', false);
            });
        }
    };
    HTTPSocket.prototype.closeStream = function () {
        if (this.stream) {
            this.stream.unbind_all();
            this.stream.close();
            this.stream = null;
        }
    };
    return HTTPSocket;
}());
function getLocation(url) {
    var parts = /([^\?]*)\/*(\??.*)/.exec(url);
    return {
        base: parts[1],
        queryString: parts[2]
    };
}
function getSendURL(url, session) {
    return url.base + '/' + session + '/xhr_send';
}
function getUniqueURL(url) {
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    return url + separator + 't=' + +new Date() + '&n=' + autoIncrement++;
}
function replaceHost(url, hostname) {
    var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
    return urlParts[1] + hostname + urlParts[3];
}
function randomNumber(max) {
    return Math.floor(Math.random() * max);
}
function randomString(length) {
    var result = [];
    for (var i = 0; i < length; i++) {
        result.push(randomNumber(32).toString(32));
    }
    return result.join('');
}
/* harmony default export */ var http_socket = (http_socket_HTTPSocket);

// CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
var http_streaming_socket_hooks = {
    getReceiveURL: function (url, session) {
        return url.base + '/' + session + '/xhr_streaming' + url.queryString;
    },
    onHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    sendHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    onFinished: function (socket, status) {
        socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
    }
};
/* harmony default export */ var http_streaming_socket = (http_streaming_socket_hooks);

// CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
var http_polling_socket_hooks = {
    getReceiveURL: function (url, session) {
        return url.base + '/' + session + '/xhr' + url.queryString;
    },
    onHeartbeat: function () {
    },
    sendHeartbeat: function (socket) {
        socket.sendRaw('[]');
    },
    onFinished: function (socket, status) {
        if (status === 200) {
            socket.reconnect();
        }
        else {
            socket.onClose(1006, 'Connection interrupted (' + status + ')', false);
        }
    }
};
/* harmony default export */ var http_polling_socket = (http_polling_socket_hooks);

// CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts

var http_xhr_request_hooks = {
    getRequest: function (socket) {
        var Constructor = runtime.getXHRAPI();
        var xhr = new Constructor();
        xhr.onreadystatechange = xhr.onprogress = function () {
            switch (xhr.readyState) {
                case 3:
                    if (xhr.responseText && xhr.responseText.length > 0) {
                        socket.onChunk(xhr.status, xhr.responseText);
                    }
                    break;
                case 4:
                    if (xhr.responseText && xhr.responseText.length > 0) {
                        socket.onChunk(xhr.status, xhr.responseText);
                    }
                    socket.emit('finished', xhr.status);
                    socket.close();
                    break;
            }
        };
        return xhr;
    },
    abortRequest: function (xhr) {
        xhr.onreadystatechange = null;
        xhr.abort();
    }
};
/* harmony default export */ var http_xhr_request = (http_xhr_request_hooks);

// CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts





var HTTP = {
    createStreamingSocket: function (url) {
        return this.createSocket(http_streaming_socket, url);
    },
    createPollingSocket: function (url) {
        return this.createSocket(http_polling_socket, url);
    },
    createSocket: function (hooks, url) {
        return new http_socket(hooks, url);
    },
    createXHR: function (method, url) {
        return this.createRequest(http_xhr_request, method, url);
    },
    createRequest: function (hooks, method, url) {
        return new http_request(hooks, method, url);
    }
};
/* harmony default export */ var http_http = (HTTP);

// CONCATENATED MODULE: ./src/runtimes/web/http/http.ts


http_http.createXDR = function (method, url) {
    return this.createRequest(http_xdomain_request, method, url);
};
/* harmony default export */ var web_http_http = (http_http);

// CONCATENATED MODULE: ./src/runtimes/web/runtime.ts












var Runtime = {
    nextAuthCallbackID: 1,
    auth_callbacks: {},
    ScriptReceivers: ScriptReceivers,
    DependenciesReceivers: DependenciesReceivers,
    getDefaultStrategy: default_strategy,
    Transports: transports_transports,
    transportConnectionInitializer: transport_connection_initializer,
    HTTPFactory: web_http_http,
    TimelineTransport: jsonp_timeline,
    getXHRAPI: function () {
        return window.XMLHttpRequest;
    },
    getWebSocketAPI: function () {
        return window.WebSocket || window.MozWebSocket;
    },
    setup: function (PusherClass) {
        var _this = this;
        window.Pusher = PusherClass;
        var initializeOnDocumentBody = function () {
            _this.onDocumentBody(PusherClass.ready);
        };
        if (!window.JSON) {
            Dependencies.load('json2', {}, initializeOnDocumentBody);
        }
        else {
            initializeOnDocumentBody();
        }
    },
    getDocument: function () {
        return document;
    },
    getProtocol: function () {
        return this.getDocument().location.protocol;
    },
    getAuthorizers: function () {
        return { ajax: xhr_auth, jsonp: jsonp_auth };
    },
    onDocumentBody: function (callback) {
        var _this = this;
        if (document.body) {
            callback();
        }
        else {
            setTimeout(function () {
                _this.onDocumentBody(callback);
            }, 0);
        }
    },
    createJSONPRequest: function (url, data) {
        return new jsonp_request(url, data);
    },
    createScriptRequest: function (src) {
        return new script_request(src);
    },
    getLocalStorage: function () {
        try {
            return window.localStorage;
        }
        catch (e) {
            return undefined;
        }
    },
    createXHR: function () {
        if (this.getXHRAPI()) {
            return this.createXMLHttpRequest();
        }
        else {
            return this.createMicrosoftXHR();
        }
    },
    createXMLHttpRequest: function () {
        var Constructor = this.getXHRAPI();
        return new Constructor();
    },
    createMicrosoftXHR: function () {
        return new ActiveXObject('Microsoft.XMLHTTP');
    },
    getNetwork: function () {
        return net_info_Network;
    },
    createWebSocket: function (url) {
        var Constructor = this.getWebSocketAPI();
        return new Constructor(url);
    },
    createSocketRequest: function (method, url) {
        if (this.isXHRSupported()) {
            return this.HTTPFactory.createXHR(method, url);
        }
        else if (this.isXDRSupported(url.indexOf('https:') === 0)) {
            return this.HTTPFactory.createXDR(method, url);
        }
        else {
            throw 'Cross-origin HTTP requests are not supported';
        }
    },
    isXHRSupported: function () {
        var Constructor = this.getXHRAPI();
        return (Boolean(Constructor) && new Constructor().withCredentials !== undefined);
    },
    isXDRSupported: function (useTLS) {
        var protocol = useTLS ? 'https:' : 'http:';
        var documentProtocol = this.getProtocol();
        return (Boolean(window['XDomainRequest']) && documentProtocol === protocol);
    },
    addUnloadListener: function (listener) {
        if (window.addEventListener !== undefined) {
            window.addEventListener('unload', listener, false);
        }
        else if (window.attachEvent !== undefined) {
            window.attachEvent('onunload', listener);
        }
    },
    removeUnloadListener: function (listener) {
        if (window.addEventListener !== undefined) {
            window.removeEventListener('unload', listener, false);
        }
        else if (window.detachEvent !== undefined) {
            window.detachEvent('onunload', listener);
        }
    }
};
/* harmony default export */ var runtime = (Runtime);

// CONCATENATED MODULE: ./src/core/timeline/level.ts
var TimelineLevel;
(function (TimelineLevel) {
    TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
    TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
    TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
})(TimelineLevel || (TimelineLevel = {}));
/* harmony default export */ var timeline_level = (TimelineLevel);

// CONCATENATED MODULE: ./src/core/timeline/timeline.ts



var timeline_Timeline = (function () {
    function Timeline(key, session, options) {
        this.key = key;
        this.session = session;
        this.events = [];
        this.options = options || {};
        this.sent = 0;
        this.uniqueID = 0;
    }
    Timeline.prototype.log = function (level, event) {
        if (level <= this.options.level) {
            this.events.push(extend({}, event, { timestamp: util.now() }));
            if (this.options.limit && this.events.length > this.options.limit) {
                this.events.shift();
            }
        }
    };
    Timeline.prototype.error = function (event) {
        this.log(timeline_level.ERROR, event);
    };
    Timeline.prototype.info = function (event) {
        this.log(timeline_level.INFO, event);
    };
    Timeline.prototype.debug = function (event) {
        this.log(timeline_level.DEBUG, event);
    };
    Timeline.prototype.isEmpty = function () {
        return this.events.length === 0;
    };
    Timeline.prototype.send = function (sendfn, callback) {
        var _this = this;
        var data = extend({
            session: this.session,
            bundle: this.sent + 1,
            key: this.key,
            lib: 'js',
            version: this.options.version,
            cluster: this.options.cluster,
            features: this.options.features,
            timeline: this.events
        }, this.options.params);
        this.events = [];
        sendfn(data, function (error, result) {
            if (!error) {
                _this.sent++;
            }
            if (callback) {
                callback(error, result);
            }
        });
        return true;
    };
    Timeline.prototype.generateUniqueID = function () {
        this.uniqueID++;
        return this.uniqueID;
    };
    return Timeline;
}());
/* harmony default export */ var timeline_timeline = (timeline_Timeline);

// CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts




var transport_strategy_TransportStrategy = (function () {
    function TransportStrategy(name, priority, transport, options) {
        this.name = name;
        this.priority = priority;
        this.transport = transport;
        this.options = options || {};
    }
    TransportStrategy.prototype.isSupported = function () {
        return this.transport.isSupported({
            useTLS: this.options.useTLS
        });
    };
    TransportStrategy.prototype.connect = function (minPriority, callback) {
        var _this = this;
        if (!this.isSupported()) {
            return failAttempt(new UnsupportedStrategy(), callback);
        }
        else if (this.priority < minPriority) {
            return failAttempt(new TransportPriorityTooLow(), callback);
        }
        var connected = false;
        var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
        var handshake = null;
        var onInitialized = function () {
            transport.unbind('initialized', onInitialized);
            transport.connect();
        };
        var onOpen = function () {
            handshake = factory.createHandshake(transport, function (result) {
                connected = true;
                unbindListeners();
                callback(null, result);
            });
        };
        var onError = function (error) {
            unbindListeners();
            callback(error);
        };
        var onClosed = function () {
            unbindListeners();
            var serializedTransport;
            serializedTransport = safeJSONStringify(transport);
            callback(new TransportClosed(serializedTransport));
        };
        var unbindListeners = function () {
            transport.unbind('initialized', onInitialized);
            transport.unbind('open', onOpen);
            transport.unbind('error', onError);
            transport.unbind('closed', onClosed);
        };
        transport.bind('initialized', onInitialized);
        transport.bind('open', onOpen);
        transport.bind('error', onError);
        transport.bind('closed', onClosed);
        transport.initialize();
        return {
            abort: function () {
                if (connected) {
                    return;
                }
                unbindListeners();
                if (handshake) {
                    handshake.close();
                }
                else {
                    transport.close();
                }
            },
            forceMinPriority: function (p) {
                if (connected) {
                    return;
                }
                if (_this.priority < p) {
                    if (handshake) {
                        handshake.close();
                    }
                    else {
                        transport.close();
                    }
                }
            }
        };
    };
    return TransportStrategy;
}());
/* harmony default export */ var transport_strategy = (transport_strategy_TransportStrategy);
function failAttempt(error, callback) {
    util.defer(function () {
        callback(error);
    });
    return {
        abort: function () { },
        forceMinPriority: function () { }
    };
}

// CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts





var strategy_builder_Transports = runtime.Transports;
var strategy_builder_defineTransport = function (config, name, type, priority, options, manager) {
    var transportClass = strategy_builder_Transports[type];
    if (!transportClass) {
        throw new UnsupportedTransport(type);
    }
    var enabled = (!config.enabledTransports ||
        arrayIndexOf(config.enabledTransports, name) !== -1) &&
        (!config.disabledTransports ||
            arrayIndexOf(config.disabledTransports, name) === -1);
    var transport;
    if (enabled) {
        options = Object.assign({ ignoreNullOrigin: config.ignoreNullOrigin }, options);
        transport = new transport_strategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
    }
    else {
        transport = strategy_builder_UnsupportedStrategy;
    }
    return transport;
};
var strategy_builder_UnsupportedStrategy = {
    isSupported: function () {
        return false;
    },
    connect: function (_, callback) {
        var deferred = util.defer(function () {
            callback(new UnsupportedStrategy());
        });
        return {
            abort: function () {
                deferred.ensureAborted();
            },
            forceMinPriority: function () { }
        };
    }
};

// CONCATENATED MODULE: ./src/core/config.ts


function getConfig(opts) {
    var config = {
        activityTimeout: opts.activityTimeout || defaults.activityTimeout,
        authEndpoint: opts.authEndpoint || defaults.authEndpoint,
        authTransport: opts.authTransport || defaults.authTransport,
        cluster: opts.cluster || defaults.cluster,
        httpPath: opts.httpPath || defaults.httpPath,
        httpPort: opts.httpPort || defaults.httpPort,
        httpsPort: opts.httpsPort || defaults.httpsPort,
        pongTimeout: opts.pongTimeout || defaults.pongTimeout,
        statsHost: opts.statsHost || defaults.stats_host,
        unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
        wsPath: opts.wsPath || defaults.wsPath,
        wsPort: opts.wsPort || defaults.wsPort,
        wssPort: opts.wssPort || defaults.wssPort,
        enableStats: getEnableStatsConfig(opts),
        httpHost: getHttpHost(opts),
        useTLS: shouldUseTLS(opts),
        wsHost: getWebsocketHost(opts)
    };
    if ('auth' in opts)
        config.auth = opts.auth;
    if ('authorizer' in opts)
        config.authorizer = opts.authorizer;
    if ('disabledTransports' in opts)
        config.disabledTransports = opts.disabledTransports;
    if ('enabledTransports' in opts)
        config.enabledTransports = opts.enabledTransports;
    if ('ignoreNullOrigin' in opts)
        config.ignoreNullOrigin = opts.ignoreNullOrigin;
    if ('timelineParams' in opts)
        config.timelineParams = opts.timelineParams;
    if ('nacl' in opts) {
        config.nacl = opts.nacl;
    }
    return config;
}
function getHttpHost(opts) {
    if (opts.httpHost) {
        return opts.httpHost;
    }
    if (opts.cluster) {
        return "sockjs-" + opts.cluster + ".pusher.com";
    }
    return defaults.httpHost;
}
function getWebsocketHost(opts) {
    if (opts.wsHost) {
        return opts.wsHost;
    }
    if (opts.cluster) {
        return getWebsocketHostFromCluster(opts.cluster);
    }
    return getWebsocketHostFromCluster(defaults.cluster);
}
function getWebsocketHostFromCluster(cluster) {
    return "ws-" + cluster + ".pusher.com";
}
function shouldUseTLS(opts) {
    if (runtime.getProtocol() === 'https:') {
        return true;
    }
    else if (opts.forceTLS === false) {
        return false;
    }
    return true;
}
function getEnableStatsConfig(opts) {
    if ('enableStats' in opts) {
        return opts.enableStats;
    }
    if ('disableStats' in opts) {
        return !opts.disableStats;
    }
    return false;
}

// CONCATENATED MODULE: ./src/core/pusher.ts












var pusher_Pusher = (function () {
    function Pusher(app_key, options) {
        var _this = this;
        checkAppKey(app_key);
        options = options || {};
        if (!options.cluster && !(options.wsHost || options.httpHost)) {
            var suffix = url_store.buildLogSuffix('javascriptQuickStart');
            logger.warn("You should always specify a cluster when connecting. " + suffix);
        }
        if ('disableStats' in options) {
            logger.warn('The disableStats option is deprecated in favor of enableStats');
        }
        this.key = app_key;
        this.config = getConfig(options);
        this.channels = factory.createChannels();
        this.global_emitter = new dispatcher();
        this.sessionID = Math.floor(Math.random() * 1000000000);
        this.timeline = new timeline_timeline(this.key, this.sessionID, {
            cluster: this.config.cluster,
            features: Pusher.getClientFeatures(),
            params: this.config.timelineParams || {},
            limit: 50,
            level: timeline_level.INFO,
            version: defaults.VERSION
        });
        if (this.config.enableStats) {
            this.timelineSender = factory.createTimelineSender(this.timeline, {
                host: this.config.statsHost,
                path: '/timeline/v2/' + runtime.TimelineTransport.name
            });
        }
        var getStrategy = function (options) {
            return runtime.getDefaultStrategy(_this.config, options, strategy_builder_defineTransport);
        };
        this.connection = factory.createConnectionManager(this.key, {
            getStrategy: getStrategy,
            timeline: this.timeline,
            activityTimeout: this.config.activityTimeout,
            pongTimeout: this.config.pongTimeout,
            unavailableTimeout: this.config.unavailableTimeout,
            useTLS: Boolean(this.config.useTLS)
        });
        this.connection.bind('connected', function () {
            _this.subscribeAll();
            if (_this.timelineSender) {
                _this.timelineSender.send(_this.connection.isUsingTLS());
            }
        });
        this.connection.bind('message', function (event) {
            var eventName = event.event;
            var internal = eventName.indexOf('pusher_internal:') === 0;
            if (event.channel) {
                var channel = _this.channel(event.channel);
                if (channel) {
                    channel.handleEvent(event);
                }
            }
            if (!internal) {
                _this.global_emitter.emit(event.event, event.data);
            }
        });
        this.connection.bind('connecting', function () {
            _this.channels.disconnect();
        });
        this.connection.bind('disconnected', function () {
            _this.channels.disconnect();
        });
        this.connection.bind('error', function (err) {
            logger.warn(err);
        });
        Pusher.instances.push(this);
        this.timeline.info({ instances: Pusher.instances.length });
        if (Pusher.isReady) {
            this.connect();
        }
    }
    Pusher.ready = function () {
        Pusher.isReady = true;
        for (var i = 0, l = Pusher.instances.length; i < l; i++) {
            Pusher.instances[i].connect();
        }
    };
    Pusher.getClientFeatures = function () {
        return keys(filterObject({ ws: runtime.Transports.ws }, function (t) {
            return t.isSupported({});
        }));
    };
    Pusher.prototype.channel = function (name) {
        return this.channels.find(name);
    };
    Pusher.prototype.allChannels = function () {
        return this.channels.all();
    };
    Pusher.prototype.connect = function () {
        this.connection.connect();
        if (this.timelineSender) {
            if (!this.timelineSenderTimer) {
                var usingTLS = this.connection.isUsingTLS();
                var timelineSender = this.timelineSender;
                this.timelineSenderTimer = new PeriodicTimer(60000, function () {
                    timelineSender.send(usingTLS);
                });
            }
        }
    };
    Pusher.prototype.disconnect = function () {
        this.connection.disconnect();
        if (this.timelineSenderTimer) {
            this.timelineSenderTimer.ensureAborted();
            this.timelineSenderTimer = null;
        }
    };
    Pusher.prototype.bind = function (event_name, callback, context) {
        this.global_emitter.bind(event_name, callback, context);
        return this;
    };
    Pusher.prototype.unbind = function (event_name, callback, context) {
        this.global_emitter.unbind(event_name, callback, context);
        return this;
    };
    Pusher.prototype.bind_global = function (callback) {
        this.global_emitter.bind_global(callback);
        return this;
    };
    Pusher.prototype.unbind_global = function (callback) {
        this.global_emitter.unbind_global(callback);
        return this;
    };
    Pusher.prototype.unbind_all = function (callback) {
        this.global_emitter.unbind_all();
        return this;
    };
    Pusher.prototype.subscribeAll = function () {
        var channelName;
        for (channelName in this.channels.channels) {
            if (this.channels.channels.hasOwnProperty(channelName)) {
                this.subscribe(channelName);
            }
        }
    };
    Pusher.prototype.subscribe = function (channel_name) {
        var channel = this.channels.add(channel_name, this);
        if (channel.subscriptionPending && channel.subscriptionCancelled) {
            channel.reinstateSubscription();
        }
        else if (!channel.subscriptionPending &&
            this.connection.state === 'connected') {
            channel.subscribe();
        }
        return channel;
    };
    Pusher.prototype.unsubscribe = function (channel_name) {
        var channel = this.channels.find(channel_name);
        if (channel && channel.subscriptionPending) {
            channel.cancelSubscription();
        }
        else {
            channel = this.channels.remove(channel_name);
            if (channel && channel.subscribed) {
                channel.unsubscribe();
            }
        }
    };
    Pusher.prototype.send_event = function (event_name, data, channel) {
        return this.connection.send_event(event_name, data, channel);
    };
    Pusher.prototype.shouldUseTLS = function () {
        return this.config.useTLS;
    };
    Pusher.instances = [];
    Pusher.isReady = false;
    Pusher.logToConsole = false;
    Pusher.Runtime = runtime;
    Pusher.ScriptReceivers = runtime.ScriptReceivers;
    Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
    Pusher.auth_callbacks = runtime.auth_callbacks;
    return Pusher;
}());
/* harmony default export */ var core_pusher = __webpack_exports__["default"] = (pusher_Pusher);
function checkAppKey(key) {
    if (key === null || key === undefined) {
        throw 'You must pass your app key when you instantiate Pusher.';
    }
}
runtime.setup(pusher_Pusher);


/***/ })
/******/ ]);
});
//# sourceMappingURL=pusher.js.map

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

(function(root, factory) {
  'use strict';

  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  else if (typeof exports === 'object') {
    // COMMONJS
    module.exports = factory();
  }
  else {
    // BROWSER
    root.Headroom = factory();
  }
}(this, function() {
  'use strict';

  /* exported features */
  
  var features = {
    bind : !!(function(){}.bind),
    classList : 'classList' in document.documentElement,
    rAF : !!(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame)
  };
  window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  
  /**
   * Handles debouncing of events via requestAnimationFrame
   * @see http://www.html5rocks.com/en/tutorials/speed/animations/
   * @param {Function} callback The callback to handle whichever event
   */
  function Debouncer (callback) {
    this.callback = callback;
    this.ticking = false;
  }
  Debouncer.prototype = {
    constructor : Debouncer,
  
    /**
     * dispatches the event to the supplied callback
     * @private
     */
    update : function() {
      this.callback && this.callback();
      this.ticking = false;
    },
  
    /**
     * ensures events don't get stacked
     * @private
     */
    requestTick : function() {
      if(!this.ticking) {
        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
        this.ticking = true;
      }
    },
  
    /**
     * Attach this as the event listeners
     */
    handleEvent : function() {
      this.requestTick();
    }
  };
  /**
   * Check if object is part of the DOM
   * @constructor
   * @param {Object} obj element to check
   */
  function isDOMElement(obj) {
    return obj && typeof window !== 'undefined' && (obj === window || obj.nodeType);
  }
  
  /**
   * Helper function for extending objects
   */
  function extend (object /*, objectN ... */) {
    if(arguments.length <= 0) {
      throw new Error('Missing arguments in extend function');
    }
  
    var result = object || {},
        key,
        i;
  
    for (i = 1; i < arguments.length; i++) {
      var replacement = arguments[i] || {};
  
      for (key in replacement) {
        // Recurse into object except if the object is a DOM element
        if(typeof result[key] === 'object' && ! isDOMElement(result[key])) {
          result[key] = extend(result[key], replacement[key]);
        }
        else {
          result[key] = result[key] || replacement[key];
        }
      }
    }
  
    return result;
  }
  
  /**
   * Helper function for normalizing tolerance option to object format
   */
  function normalizeTolerance (t) {
    return t === Object(t) ? t : { down : t, up : t };
  }
  
  /**
   * UI enhancement for fixed headers.
   * Hides header when scrolling down
   * Shows header when scrolling up
   * @constructor
   * @param {DOMElement} elem the header element
   * @param {Object} options options for the widget
   */
  function Headroom (elem, options) {
    options = extend(options, Headroom.options);
  
    this.lastKnownScrollY = 0;
    this.elem             = elem;
    this.tolerance        = normalizeTolerance(options.tolerance);
    this.classes          = options.classes;
    this.offset           = options.offset;
    this.scroller         = options.scroller;
    this.initialised      = false;
    this.onPin            = options.onPin;
    this.onUnpin          = options.onUnpin;
    this.onTop            = options.onTop;
    this.onNotTop         = options.onNotTop;
    this.onBottom         = options.onBottom;
    this.onNotBottom      = options.onNotBottom;
  }
  Headroom.prototype = {
    constructor : Headroom,
  
    /**
     * Initialises the widget
     */
    init : function() {
      if(!Headroom.cutsTheMustard) {
        return;
      }
  
      this.debouncer = new Debouncer(this.update.bind(this));
      this.elem.classList.add(this.classes.initial);
  
      // defer event registration to handle browser
      // potentially restoring previous scroll position
      setTimeout(this.attachEvent.bind(this), 100);
  
      return this;
    },
  
    /**
     * Unattaches events and removes any classes that were added
     */
    destroy : function() {
      var classes = this.classes;
  
      this.initialised = false;
  
      for (var key in classes) {
        if(classes.hasOwnProperty(key)) {
          this.elem.classList.remove(classes[key]);
        }
      }
  
      this.scroller.removeEventListener('scroll', this.debouncer, false);
    },
  
    /**
     * Attaches the scroll event
     * @private
     */
    attachEvent : function() {
      if(!this.initialised){
        this.lastKnownScrollY = this.getScrollY();
        this.initialised = true;
        this.scroller.addEventListener('scroll', this.debouncer, false);
  
        this.debouncer.handleEvent();
      }
    },
  
    /**
     * Unpins the header if it's currently pinned
     */
    unpin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.pinned) || !classList.contains(classes.unpinned)) {
        classList.add(classes.unpinned);
        classList.remove(classes.pinned);
        this.onUnpin && this.onUnpin.call(this);
      }
    },
  
    /**
     * Pins the header if it's currently unpinned
     */
    pin : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(classList.contains(classes.unpinned)) {
        classList.remove(classes.unpinned);
        classList.add(classes.pinned);
        this.onPin && this.onPin.call(this);
      }
    },
  
    /**
     * Handles the top states
     */
    top : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.top)) {
        classList.add(classes.top);
        classList.remove(classes.notTop);
        this.onTop && this.onTop.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notTop : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notTop)) {
        classList.add(classes.notTop);
        classList.remove(classes.top);
        this.onNotTop && this.onNotTop.call(this);
      }
    },
  
    bottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.bottom)) {
        classList.add(classes.bottom);
        classList.remove(classes.notBottom);
        this.onBottom && this.onBottom.call(this);
      }
    },
  
    /**
     * Handles the not top state
     */
    notBottom : function() {
      var classList = this.elem.classList,
        classes = this.classes;
  
      if(!classList.contains(classes.notBottom)) {
        classList.add(classes.notBottom);
        classList.remove(classes.bottom);
        this.onNotBottom && this.onNotBottom.call(this);
      }
    },
  
    /**
     * Gets the Y scroll position
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
     * @return {Number} pixels the page has scrolled along the Y-axis
     */
    getScrollY : function() {
      return (this.scroller.pageYOffset !== undefined)
        ? this.scroller.pageYOffset
        : (this.scroller.scrollTop !== undefined)
          ? this.scroller.scrollTop
          : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    },
  
    /**
     * Gets the height of the viewport
     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
     * @return {int} the height of the viewport in pixels
     */
    getViewportHeight : function () {
      return window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
  
    /**
     * Gets the physical height of the DOM element
     * @param  {Object}  elm the element to calculate the physical height of which
     * @return {int}     the physical height of the element in pixels
     */
    getElementPhysicalHeight : function (elm) {
      return Math.max(
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the physical height of the scroller element
     * @return {int} the physical height of the scroller element in pixels
     */
    getScrollerPhysicalHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getViewportHeight()
        : this.getElementPhysicalHeight(this.scroller);
    },
  
    /**
     * Gets the height of the document
     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
     * @return {int} the height of the document in pixels
     */
    getDocumentHeight : function () {
      var body = document.body,
        documentElement = document.documentElement;
  
      return Math.max(
        body.scrollHeight, documentElement.scrollHeight,
        body.offsetHeight, documentElement.offsetHeight,
        body.clientHeight, documentElement.clientHeight
      );
    },
  
    /**
     * Gets the height of the DOM element
     * @param  {Object}  elm the element to calculate the height of which
     * @return {int}     the height of the element in pixels
     */
    getElementHeight : function (elm) {
      return Math.max(
        elm.scrollHeight,
        elm.offsetHeight,
        elm.clientHeight
      );
    },
  
    /**
     * Gets the height of the scroller element
     * @return {int} the height of the scroller element in pixels
     */
    getScrollerHeight : function () {
      return (this.scroller === window || this.scroller === document.body)
        ? this.getDocumentHeight()
        : this.getElementHeight(this.scroller);
    },
  
    /**
     * determines if the scroll position is outside of document boundaries
     * @param  {int}  currentScrollY the current y scroll position
     * @return {bool} true if out of bounds, false otherwise
     */
    isOutOfBounds : function (currentScrollY) {
      var pastTop  = currentScrollY < 0,
        pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();
  
      return pastTop || pastBottom;
    },
  
    /**
     * determines if the tolerance has been exceeded
     * @param  {int} currentScrollY the current scroll y position
     * @return {bool} true if tolerance exceeded, false otherwise
     */
    toleranceExceeded : function (currentScrollY, direction) {
      return Math.abs(currentScrollY-this.lastKnownScrollY) >= this.tolerance[direction];
    },
  
    /**
     * determine if it is appropriate to unpin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should unpin, false otherwise
     */
    shouldUnpin : function (currentScrollY, toleranceExceeded) {
      var scrollingDown = currentScrollY > this.lastKnownScrollY,
        pastOffset = currentScrollY >= this.offset;
  
      return scrollingDown && pastOffset && toleranceExceeded;
    },
  
    /**
     * determine if it is appropriate to pin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should pin, false otherwise
     */
    shouldPin : function (currentScrollY, toleranceExceeded) {
      var scrollingUp  = currentScrollY < this.lastKnownScrollY,
        pastOffset = currentScrollY <= this.offset;
  
      return (scrollingUp && toleranceExceeded) || pastOffset;
    },
  
    /**
     * Handles updating the state of the widget
     */
    update : function() {
      var currentScrollY  = this.getScrollY(),
        scrollDirection = currentScrollY > this.lastKnownScrollY ? 'down' : 'up',
        toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
  
      if(this.isOutOfBounds(currentScrollY)) { // Ignore bouncy scrolling in OSX
        return;
      }
  
      if (currentScrollY <= this.offset ) {
        this.top();
      } else {
        this.notTop();
      }
  
      if(currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
        this.bottom();
      }
      else {
        this.notBottom();
      }
  
      if(this.shouldUnpin(currentScrollY, toleranceExceeded)) {
        this.unpin();
      }
      else if(this.shouldPin(currentScrollY, toleranceExceeded)) {
        this.pin();
      }
  
      this.lastKnownScrollY = currentScrollY;
    }
  };
  /**
   * Default options
   * @type {Object}
   */
  Headroom.options = {
    tolerance : {
      up : 0,
      down : 0
    },
    offset : 0,
    scroller: window,
    classes : {
      pinned : 'headroom--pinned',
      unpinned : 'headroom--unpinned',
      top : 'headroom--top',
      notTop : 'headroom--not-top',
      bottom : 'headroom--bottom',
      notBottom : 'headroom--not-bottom',
      initial : 'headroom'
    }
  };
  Headroom.cutsTheMustard = typeof features !== 'undefined' && features.rAF && features.bind && features.classList;

  return Headroom;
}));

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefreshAppDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _user = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefreshApp = function (_Component) {
  (0, _inherits3.default)(RefreshApp, _Component);

  function RefreshApp() {
    (0, _classCallCheck3.default)(this, RefreshApp);
    return (0, _possibleConstructorReturn3.default)(this, (RefreshApp.__proto__ || (0, _getPrototypeOf2.default)(RefreshApp)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefreshApp, [{
    key: 'render',
    value: function render() {
      var onClickBound = this.onClick.bind(this);
      return _react2.default.createElement(
        'div',
        { id: 'refreshAppWrapper' },
        _react2.default.createElement(
          'div',
          { id: 'refreshApp' },
          'Some changes to QuestMaker are available. Please save your work and update ASAP.',
          _react2.default.createElement(
            'div',
            { className: 'button', onClick: onClickBound },
            'Update QuestMaker'
          )
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.props.dispatch((0, _user.logoutAndRedirect)(true));
    }
  }]);
  return RefreshApp;
}(_react.Component);

RefreshApp.propTypes = {
  dispatch: _propTypes2.default.func.isRequired

  // purely to gain access to dispatch; could pass in from parent instead?
};var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RefreshApp);
// pure component for testing

exports.RefreshAppDisconnected = RefreshApp;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavContainerDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n  height: 100%;\n  width: 72px;\n  top: 0;\n  left: 0;\n  padding: 0;\n  background-color: #4e6c84;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  z-index: 99;\n  display: flex;\n  flex-direction: row;\n  flex-direction: column;\n  align-items: center;\n\n  .user-org-menu-nav .user-photo-wrapper {\n    height: 38px;\n    width: 38px;\n  }\n\n  &.hidden {\n    display: none;\n  }\n'], ['\n  position: fixed;\n  height: 100%;\n  width: 72px;\n  top: 0;\n  left: 0;\n  padding: 0;\n  background-color: #4e6c84;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  z-index: 99;\n  display: flex;\n  flex-direction: row;\n  flex-direction: column;\n  align-items: center;\n\n  .user-org-menu-nav .user-photo-wrapper {\n    height: 38px;\n    width: 38px;\n  }\n\n  &.hidden {\n    display: none;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 105px;\n  width: 72px;\n  text-align: center;\n  top: 20px;\n  display: inline-block;\n  z-index: 1;\n  background-size: contain;\n  flex-shrink: 0;\n  padding-bottom: 10px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 105px;\n  width: 72px;\n  text-align: center;\n  top: 20px;\n  display: inline-block;\n  z-index: 1;\n  background-size: contain;\n  flex-shrink: 0;\n  padding-bottom: 10px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: auto;\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: auto;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #151f28;\n  opacity: 0.33;\n  width: 100%;\n'], ['\n  border-top: 1px solid #151f28;\n  opacity: 0.33;\n  width: 100%;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  margin-bottom: 50px;\n  position: relative;\n'], ['\n  margin-bottom: 50px;\n  position: relative;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  height: 15px;\n  border-radius: 8px;\n  background-color: #263746;\n  color: #ffffff;\n  font-size: 9px;\n  text-align: center;\n  right: -19px;\n  top: -11px;\n  padding: 0 5px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n'], ['\n  height: 15px;\n  border-radius: 8px;\n  background-color: #263746;\n  color: #ffffff;\n  font-size: 9px;\n  text-align: center;\n  right: -19px;\n  top: -11px;\n  padding: 0 5px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _qm_logo_nav = __webpack_require__(1136);

var _qm_logo_nav2 = _interopRequireDefault(_qm_logo_nav);

var _UserOrgMenu = __webpack_require__(1137);

var _UserOrgMenu2 = _interopRequireDefault(_UserOrgMenu);

var _NavItem = __webpack_require__(1146);

var _NavItem2 = _interopRequireDefault(_NavItem);

var _all_quests_active = __webpack_require__(1147);

var _all_quests_active2 = _interopRequireDefault(_all_quests_active);

var _all_quests_inactive = __webpack_require__(1148);

var _all_quests_inactive2 = _interopRequireDefault(_all_quests_inactive);

var _all_quests_hover = __webpack_require__(1149);

var _all_quests_hover2 = _interopRequireDefault(_all_quests_hover);

var _my_quests_active = __webpack_require__(1150);

var _my_quests_active2 = _interopRequireDefault(_my_quests_active);

var _my_quests_inactive = __webpack_require__(1151);

var _my_quests_inactive2 = _interopRequireDefault(_my_quests_inactive);

var _my_quests_hover = __webpack_require__(1152);

var _my_quests_hover2 = _interopRequireDefault(_my_quests_hover);

var _production_status_active = __webpack_require__(1153);

var _production_status_active2 = _interopRequireDefault(_production_status_active);

var _production_status_inactive = __webpack_require__(1154);

var _production_status_inactive2 = _interopRequireDefault(_production_status_inactive);

var _production_status_hover = __webpack_require__(1155);

var _production_status_hover2 = _interopRequireDefault(_production_status_hover);

var _queue_active = __webpack_require__(1156);

var _queue_active2 = _interopRequireDefault(_queue_active);

var _queue_inactive = __webpack_require__(1157);

var _queue_inactive2 = _interopRequireDefault(_queue_inactive);

var _queue_hover = __webpack_require__(1158);

var _queue_hover2 = _interopRequireDefault(_queue_hover);

var _topics_active = __webpack_require__(1159);

var _topics_active2 = _interopRequireDefault(_topics_active);

var _topics_inactive = __webpack_require__(1160);

var _topics_inactive2 = _interopRequireDefault(_topics_inactive);

var _topics_hover = __webpack_require__(1161);

var _topics_hover2 = _interopRequireDefault(_topics_hover);

var _reviews_active = __webpack_require__(1162);

var _reviews_active2 = _interopRequireDefault(_reviews_active);

var _reviews_inactive = __webpack_require__(1163);

var _reviews_inactive2 = _interopRequireDefault(_reviews_inactive);

var _reviews_hover = __webpack_require__(1164);

var _reviews_hover2 = _interopRequireDefault(_reviews_hover);

var _navigation = __webpack_require__(1165);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = _styledComponents2.default.div.withConfig({
  displayName: 'Nav',
  componentId: 'xokcrk-0'
})(_templateObject);

var QMLogoStyled = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__QMLogoStyled',
  componentId: 'xokcrk-1'
})(_templateObject2, _qm_logo_nav2.default);

var UserMenuContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__UserMenuContainer',
  componentId: 'xokcrk-2'
})(_templateObject3);

var DividerLine = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__DividerLine',
  componentId: 'xokcrk-3'
})(_templateObject4);

var NavItemContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__NavItemContainer',
  componentId: 'xokcrk-4'
})(_templateObject5);

var QueueCount = _styledComponents2.default.div.withConfig({
  displayName: 'Nav__QueueCount',
  componentId: 'xokcrk-5'
})(_templateObject6);

var NavContainer = function (_React$Component) {
  (0, _inherits3.default)(NavContainer, _React$Component);

  function NavContainer() {
    (0, _classCallCheck3.default)(this, NavContainer);
    return (0, _possibleConstructorReturn3.default)(this, (NavContainer.__proto__ || (0, _getPrototypeOf2.default)(NavContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(NavContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          path = _props.path,
          stats = _props.stats,
          organizationId = _props.organizationId,
          dispatch = _props.dispatch,
          courses = _props.courses;


      if (!user) {
        return null;
      }

      var org = user.organizations.find(function (o) {
        return o.id === organizationId;
      });

      var formattedAssignedQuestsCount = stats.assigned_quests_count > 999 ? '999+' : stats.assigned_quests_count;

      return _react2.default.createElement(
        Nav,
        { id: 'side-nav' },
        _react2.default.createElement(QMLogoStyled, null),
        (0, _user.isMentorAuthor)(user) ? '' : _react2.default.createElement(
          _react2.default.Fragment,
          null,
          (0, _navigation.userCanSeeQueue)(user) && _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'Queue',
              activeIcon: _queue_active2.default,
              inactiveIcon: _queue_inactive2.default,
              hoverIcon: _queue_hover2.default,
              height: '19px',
              width: '28px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/queue'));
              },
              isActive: (0, _navigation.isOnQueueRoute)(path)
            }),
            _react2.default.createElement(
              QueueCount,
              null,
              formattedAssignedQuestsCount
            )
          ),
          (0, _navigation.userCanSeeProductionStatus)(user, courses) && _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'Production Status',
              activeIcon: _production_status_active2.default,
              inactiveIcon: _production_status_inactive2.default,
              hoverIcon: _production_status_hover2.default,
              height: '22px',
              width: '25px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/productionstatus'));
              },
              isActive: (0, _navigation.isOnNavRoute)(path, 'productionstatus')
            })
          ),
          (0, _navigation.userCanSeeMyQuests)(user) && _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'My Quests',
              activeIcon: _my_quests_active2.default,
              inactiveIcon: _my_quests_inactive2.default,
              hoverIcon: _my_quests_hover2.default,
              height: '24px',
              width: '25px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/myquests'));
              },
              isActive: (0, _navigation.isOnNavRoute)(path, 'myquests')
            })
          ),
          _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'All Quests',
              activeIcon: _all_quests_active2.default,
              inactiveIcon: _all_quests_inactive2.default,
              hoverIcon: _all_quests_hover2.default,
              height: '19px',
              width: '26px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/quests'));
              },
              isActive: (0, _navigation.isOnAllQuestsRoute)(path)
            })
          ),
          _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'Topics',
              activeIcon: _topics_active2.default,
              inactiveIcon: _topics_inactive2.default,
              hoverIcon: _topics_hover2.default,
              height: '25px',
              width: '21px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/topicclouds'));
              },
              isActive: (0, _navigation.isOnNavRoute)(path, 'topicclouds')
            })
          ),
          (0, _navigation.userCanSeeReviewQueue)(user) && _react2.default.createElement(
            NavItemContainer,
            null,
            _react2.default.createElement(_NavItem2.default, {
              label: 'Reviews',
              activeIcon: _reviews_active2.default,
              inactiveIcon: _reviews_inactive2.default,
              hoverIcon: _reviews_hover2.default,
              height: '18px',
              width: '27px',
              handleClick: function handleClick() {
                return dispatch((0, _reactRouterRedux.push)('/reviewqueue'));
              },
              isActive: (0, _navigation.isOnNavRoute)(path, 'reviewqueue')
            })
          )
        ),
        _react2.default.createElement(
          UserMenuContainer,
          null,
          _react2.default.createElement(_UserOrgMenu2.default, { user: user, organization: org, dispatch: dispatch })
        )
      );
    }
  }]);
  return NavContainer;
}(_react2.default.Component);

NavContainer.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  path: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired,
  courses: _propTypes2.default.array.isRequired,
  stats: _propTypes2.default.object,
  organizationId: _propTypes2.default.number
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    path: window.location.pathname,
    user: state.user.user,
    courses: state.mockcourses.items,
    stats: state.user.stats,
    organizationId: state.organization.orgId
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(NavContainer);
exports.NavContainerDisconnected = NavContainer;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/qm_logo_nav.svg";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  visibility: ', ';\n  position: absolute;\n  width: 360px;\n  bottom: 15px;\n  left: 67px;\n  background: white;\n  color: black;\n  z-index: 2;\n  border-radius: 10px;\n  opacity: ', ';\n  transition: visibility 0.15s, opacity 0.15s linear;\n  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.15);\n'], ['\n  visibility: ', ';\n  position: absolute;\n  width: 360px;\n  bottom: 15px;\n  left: 67px;\n  background: white;\n  color: black;\n  z-index: 2;\n  border-radius: 10px;\n  opacity: ', ';\n  transition: visibility 0.15s, opacity 0.15s linear;\n  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.15);\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  min-height: 101px;\n  display: flex;\n  align-items: center;\n  padding: 0 17px;\n\n  .user-photo-wrapper {\n    cursor: default;\n  }\n'], ['\n  position: relative;\n  min-height: 101px;\n  display: flex;\n  align-items: center;\n  padding: 0 17px;\n\n  .user-photo-wrapper {\n    cursor: default;\n  }\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 70px;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n'], ['\n  height: 70px;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  width: 19px;\n  height: 19px;\n  margin-left: 6px;\n  cursor: pointer;\n  background: url(', ');\n'], ['\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  width: 19px;\n  height: 19px;\n  margin-left: 6px;\n  cursor: pointer;\n  background: url(', ');\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _Organizations = __webpack_require__(1142);

var _Organizations2 = _interopRequireDefault(_Organizations);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _ButtonC = __webpack_require__(1144);

var _ButtonC2 = _interopRequireDefault(_ButtonC);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(160);

var _Caption4 = _interopRequireDefault(_Caption3);

var _icon_gearmenu_off = __webpack_require__(1145);

var _icon_gearmenu_off2 = _interopRequireDefault(_icon_gearmenu_off);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _user = __webpack_require__(73);

var _user2 = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverFlowMenu = _styledComponents2.default.div.withConfig({
  displayName: 'UserOrgMenu__OverFlowMenu',
  componentId: 'sc-9lnkr0-0'
})(_templateObject, function (props) {
  return props.active ? 'visible' : 'hidden';
}, function (props) {
  return props.active ? '1' : '0';
});

var CurrentOrgContainer = _styledComponents2.default.div.withConfig({
  displayName: 'UserOrgMenu__CurrentOrgContainer',
  componentId: 'sc-9lnkr0-1'
})(_templateObject2);

var SignOutContainer = _styledComponents2.default.div.withConfig({
  displayName: 'UserOrgMenu__SignOutContainer',
  componentId: 'sc-9lnkr0-2'
})(_templateObject3);

var Gear = _styledComponents2.default.div.withConfig({
  displayName: 'UserOrgMenu__Gear',
  componentId: 'sc-9lnkr0-3'
})(_templateObject4, _icon_gearmenu_off2.default);

var UserOrgMenu = function (_React$Component) {
  (0, _inherits3.default)(UserOrgMenu, _React$Component);

  function UserOrgMenu(props) {
    (0, _classCallCheck3.default)(this, UserOrgMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserOrgMenu.__proto__ || (0, _getPrototypeOf2.default)(UserOrgMenu)).call(this, props));

    _this.state = {
      menuActive: false
    };
    _this.logoutBound = _this.logout.bind(_this);
    _this.onOverflowMouseOutBound = _this.onOverflowMouseOut.bind(_this);
    _this.onOverflowMouseOverBound = _this.onOverflowMouseOver.bind(_this);
    _this.onAccountClickBound = _this.onAccountClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserOrgMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          organization = _props.organization,
          dispatch = _props.dispatch;

      var userOrgs = this.getUserOrganizations(user, organization.id);

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          {
            onFocus: this.onOverflowMouseOverBound,
            onBlur: this.onOverflowMouseOutBound,
            onMouseOver: this.onOverflowMouseOverBound,
            onMouseOut: this.onOverflowMouseOutBound,
            style: { padding: '17px 0' }
          },
          _react2.default.createElement(_UserAvatar2.default, {
            wrapperClass: 'user-org-menu-nav',
            photoUrl: user.photo.url,
            name: user.name
          })
        ),
        _react2.default.createElement(
          OverFlowMenu,
          {
            active: this.state.menuActive,
            onMouseOver: this.onOverflowMouseOverBound,
            onMouseOut: this.onOverflowMouseOutBound,
            onFocus: this.onOverflowMouseOverBound,
            onBlur: this.onOverflowMouseOutBound
          },
          _react2.default.createElement(
            CurrentOrgContainer,
            null,
            _react2.default.createElement(_UserAvatar2.default, { photoUrl: user.photo.url, name: user.name }),
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: '12px' } },
              _react2.default.createElement(
                _FlexAlignCenter2.default,
                null,
                _react2.default.createElement(
                  _UserName2.default,
                  {
                    activeCertifications: user.active_certifications,
                    userId: 'user-org-menu-' + user.id,
                    rebuild: true
                  },
                  _react2.default.createElement(
                    _H2.default,
                    null,
                    user.name
                  )
                )
              ),
              _react2.default.createElement(
                _Caption4.default,
                null,
                organization.name
              ),
              _react2.default.createElement(
                _Caption2.default,
                null,
                (0, _user2.getDisplayRole)(organization.roles)
              )
            ),
            _react2.default.createElement(Gear, { onClick: this.onAccountClickBound })
          ),
          user.organizations.length > 1 && _react2.default.createElement(
            'div',
            { className: 'organizations-wrapper' },
            _react2.default.createElement(_Organizations2.default, {
              dispatch: dispatch,
              organizations: (0, _arraySort2.default)(userOrgs, ['name']),
              user: user
            })
          ),
          _react2.default.createElement(
            SignOutContainer,
            null,
            _react2.default.createElement(
              _ButtonC2.default,
              { onClick: this.logoutBound },
              'Sign Out'
            )
          )
        )
      );
    }
  }, {
    key: 'onAccountClick',
    value: function onAccountClick(e) {
      e.stopPropagation(); // prevent this from bubbling up to route to profile
      this.props.dispatch((0, _reactRouterRedux.push)('/account'));
    }
  }, {
    key: 'getUserOrganizations',
    value: function getUserOrganizations(user, currentOrgId) {
      return user.organizations.filter(function (org) {
        return org.id !== currentOrgId;
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.props.dispatch((0, _user.logoutAndRedirect)());
    }
  }, {
    key: 'onOverflowMouseOver',
    value: function onOverflowMouseOver() {
      this.setState(function () {
        return {
          menuActive: true
        };
      });
    }
  }, {
    key: 'onOverflowMouseOut',
    value: function onOverflowMouseOut() {
      this.setState(function () {
        return {
          menuActive: false
        };
      });
    }
  }]);
  return UserOrgMenu;
}(_react2.default.Component);

UserOrgMenu.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired
};

exports.default = UserOrgMenu;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var typeOf = __webpack_require__(1139);

/**
 * Basic sort algorithm that has similar behavior to `Array.prototype.sort`
 * for null and undefined, but also allows sorting by an object property.
 *
 * @param {Mixed} `a` First value to compare.
 * @param {Mixed} `b` Second value to compare.
 * @param {String} `prop` Optional property to use when comparing objects. If specified must be a string.
 * @return {Number} Returns 1 when `a` should come after `b`, -1 when `a` should come before `b`, and 0 when `a` and `b` are equal.
 * @api public
 */

module.exports = function defaultCompare(a, b, prop) {
  if (prop != null && typeOf(prop) !== 'string') {
    throw new TypeError('expected "prop" to be undefined or a string');
  }

  var typeA = typeOf(a);
  var typeB = typeOf(b);

  if (prop) {
    if (typeA === 'object') {
      a = a[prop];
      typeA = typeOf(a);
    }
    if (typeB === 'object') {
      b = b[prop];
      typeB = typeOf(b);
    }
  }

  if (typeA === 'null') {
    return typeB === 'null' ? 0 : (typeB === 'undefined' ? -1 : 1);
  } else if (typeA === 'undefined') {
    return typeB === 'null' ? 1 : (typeB === 'undefined' ? 0 : 1);
  } else if (typeB === 'null' || typeB === 'undefined') {
    return -1;
  } else {
    return a < b ? -1 : (a > b ? 1 : 0);
  }
};


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

module.exports = function kindOf(val) {
  var type = typeof val;

  // primitivies
  if (type === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (type === 'string' || val instanceof String) {
    return 'string';
  }
  if (type === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (type === 'function' || val instanceof Function) {
    if (typeof val.constructor.name !== 'undefined' && val.constructor.name.slice(0, 9) === 'Generator') {
      return 'generatorfunction';
    }
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  type = toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }
  if (type === '[object Promise]') {
    return 'promise';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }
  
  if (type === '[object Map Iterator]') {
    return 'mapiterator';
  }
  if (type === '[object Set Iterator]') {
    return 'setiterator';
  }
  if (type === '[object String Iterator]') {
    return 'stringiterator';
  }
  if (type === '[object Array Iterator]') {
    return 'arrayiterator';
  }
  
  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  return val.constructor
    && typeof val.constructor.isBuffer === 'function'
    && val.constructor.isBuffer(val);
}


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

var toString = Object.prototype.toString;

/**
 * Get the native `typeof` a value.
 *
 * @param  {*} `val`
 * @return {*} Native javascript type
 */

module.exports = function kindOf(val) {
  var type = typeof val;

  // primitivies
  if (type === 'undefined') {
    return 'undefined';
  }
  if (val === null) {
    return 'null';
  }
  if (val === true || val === false || val instanceof Boolean) {
    return 'boolean';
  }
  if (type === 'string' || val instanceof String) {
    return 'string';
  }
  if (type === 'number' || val instanceof Number) {
    return 'number';
  }

  // functions
  if (type === 'function' || val instanceof Function) {
    if (typeof val.constructor.name !== 'undefined' && val.constructor.name.slice(0, 9) === 'Generator') {
      return 'generatorfunction';
    }
    return 'function';
  }

  // array
  if (typeof Array.isArray !== 'undefined' && Array.isArray(val)) {
    return 'array';
  }

  // check for instances of RegExp and Date before calling `toString`
  if (val instanceof RegExp) {
    return 'regexp';
  }
  if (val instanceof Date) {
    return 'date';
  }

  // other objects
  type = toString.call(val);

  if (type === '[object RegExp]') {
    return 'regexp';
  }
  if (type === '[object Date]') {
    return 'date';
  }
  if (type === '[object Arguments]') {
    return 'arguments';
  }
  if (type === '[object Error]') {
    return 'error';
  }
  if (type === '[object Promise]') {
    return 'promise';
  }

  // buffer
  if (isBuffer(val)) {
    return 'buffer';
  }

  // es6: Map, WeakMap, Set, WeakSet
  if (type === '[object Set]') {
    return 'set';
  }
  if (type === '[object WeakSet]') {
    return 'weakset';
  }
  if (type === '[object Map]') {
    return 'map';
  }
  if (type === '[object WeakMap]') {
    return 'weakmap';
  }
  if (type === '[object Symbol]') {
    return 'symbol';
  }
  
  if (type === '[object Map Iterator]') {
    return 'mapiterator';
  }
  if (type === '[object Set Iterator]') {
    return 'setiterator';
  }
  if (type === '[object String Iterator]') {
    return 'stringiterator';
  }
  if (type === '[object Array Iterator]') {
    return 'arrayiterator';
  }
  
  // typed arrays
  if (type === '[object Int8Array]') {
    return 'int8array';
  }
  if (type === '[object Uint8Array]') {
    return 'uint8array';
  }
  if (type === '[object Uint8ClampedArray]') {
    return 'uint8clampedarray';
  }
  if (type === '[object Int16Array]') {
    return 'int16array';
  }
  if (type === '[object Uint16Array]') {
    return 'uint16array';
  }
  if (type === '[object Int32Array]') {
    return 'int32array';
  }
  if (type === '[object Uint32Array]') {
    return 'uint32array';
  }
  if (type === '[object Float32Array]') {
    return 'float32array';
  }
  if (type === '[object Float64Array]') {
    return 'float64array';
  }

  // must be a plain object
  return 'object';
};

/**
 * If you need to support Safari 5-7 (8-10 yr-old browser),
 * take a look at https://github.com/feross/is-buffer
 */

function isBuffer(val) {
  return val.constructor
    && typeof val.constructor.isBuffer === 'function'
    && val.constructor.isBuffer(val);
}


/***/ }),
/* 1141 */
/***/ (function(module, exports) {

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

module.exports = function(obj, prop, a, b, c) {
  if (!isObject(obj) || !prop) {
    return obj;
  }

  prop = toString(prop);

  // allowing for multiple properties to be passed as
  // a string or array, but much faster (3-4x) than doing
  // `[].slice.call(arguments)`
  if (a) prop += '.' + toString(a);
  if (b) prop += '.' + toString(b);
  if (c) prop += '.' + toString(c);

  if (prop in obj) {
    return obj[prop];
  }

  var segs = prop.split('.');
  var len = segs.length;
  var i = -1;

  while (obj && (++i < len)) {
    var key = segs[i];
    while (key[key.length - 1] === '\\') {
      key = key.slice(0, -1) + '.' + segs[++i];
    }
    obj = obj[key];
  }
  return obj;
};

function isObject(val) {
  return val !== null && (typeof val === 'object' || typeof val === 'function');
}

function toString(val) {
  if (!val) return '';
  if (Array.isArray(val)) {
    return val.join('.');
  }
  return val;
}


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  max-height: 300px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n'], ['\n  max-height: 300px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Organization = __webpack_require__(1143);

var _Organization2 = _interopRequireDefault(_Organization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrganizationsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Organizations__OrganizationsWrapper',
  componentId: 'vmqjg8-0'
})(_templateObject);

var Organizations = function Organizations(_ref) {
  var organizations = _ref.organizations,
      dispatch = _ref.dispatch,
      user = _ref.user;
  return _react2.default.createElement(
    OrganizationsWrapper,
    null,
    organizations.map(function (organization) {
      return _react2.default.createElement(_Organization2.default, {
        key: 'user-org-' + organization.id,
        dispatch: dispatch,
        organization: organization,
        user: user
      });
    })
  );
};

Organizations.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  organizations: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object.isRequired
};

exports.default = Organizations;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid rgb(151, 151, 151, 0.21);\n  margin: 0 5px;\n  height: 75px;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  border-top: 1px solid rgb(151, 151, 151, 0.21);\n  margin: 0 5px;\n  height: 75px;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _OrgAvatar = __webpack_require__(409);

var _OrgAvatar2 = _interopRequireDefault(_OrgAvatar);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _user = __webpack_require__(45);

var _organization = __webpack_require__(203);

var _organization2 = __webpack_require__(578);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrgWrapper = _styledComponents2.default.li.withConfig({
  displayName: 'Organization__OrgWrapper',
  componentId: 'la010i-0'
})(_templateObject);

var Organization = function (_React$Component) {
  (0, _inherits3.default)(Organization, _React$Component);

  function Organization() {
    (0, _classCallCheck3.default)(this, Organization);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Organization.__proto__ || (0, _getPrototypeOf2.default)(Organization)).call(this));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Organization, [{
    key: 'render',
    value: function render() {
      var organization = this.props.organization;

      var roles = this.getOrganizationRoles();
      return _react2.default.createElement(
        OrgWrapper,
        { onClick: this.onClickBound },
        _react2.default.createElement(_OrgAvatar2.default, {
          organization: organization,
          style: { height: '38px', width: '38px' },
          orgInitials: (0, _organization2.getOrgInitials)(organization)
        }),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: '15px' } },
          _react2.default.createElement(
            _P2.default,
            null,
            organization.name
          ),
          _react2.default.createElement(
            _Caption2.default,
            { className: 'role' },
            (0, _user.getDisplayRole)(roles)
          )
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          dispatch = _props.dispatch,
          organization = _props.organization;

      dispatch((0, _organization.setCurrentOrganization)(organization.id, organization.roles, true));
    }
  }, {
    key: 'getOrganizationRoles',
    value: function getOrganizationRoles() {
      var _props2 = this.props,
          organization = _props2.organization,
          user = _props2.user;

      var org = user.organizations.find(function (org) {
        return org.id === organization.id;
      });

      return org.roles;
    }
  }]);
  return Organization;
}(_react2.default.Component);

exports.default = Organization;


Organization.propTypes = {
  dispatch: _propTypes2.default.func,
  organization: _propTypes2.default.object,
  user: _propTypes2.default.object
};

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: ', ';\n  color: ', ';\n  border: 2px solid #cccccc;\n\n  &:before {\n    content: none;\n  }\n\n  &:hover {\n    border: 2px solid #cccccc;\n    background: #cccccc;\n    box-shadow: none;\n  }\n'], ['\n  background: ', ';\n  color: ', ';\n  border: 2px solid #cccccc;\n\n  &:before {\n    content: none;\n  }\n\n  &:hover {\n    border: 2px solid #cccccc;\n    background: #cccccc;\n    box-shadow: none;\n  }\n']);

var _ButtonA = __webpack_require__(244);

var _ButtonA2 = _interopRequireDefault(_ButtonA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonC = _ButtonA2.default.extend(_templateObject, function (props) {
  return props.disabled ? '#cccccc' : 'transparent';
}, function (props) {
  return props.disabled ? '#ffffff' : '#444444';
});

exports.default = ButtonC;

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOSAxOSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTkgMTkiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM5OTk5OTk7fTwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE3LjU3MyA3LjVoLTEuNjg0Yy0uMjcxIDAtLjQ5NC0uMTQ5LS41OTctLjM5OS0uMTA0LS4yNS0uMDUxLS41MTMuMTQtLjcwNWwxLjE5MS0xLjE5Yy4xNzUtLjE3NS4yNzEtLjQwOC4yNzEtLjY1NSAwLS4yNDgtLjA5Ni0uNDgtLjI3MS0uNjU2bC0xLjUxOC0xLjUxOGMtLjM1LS4zNS0uOTYtLjM1MS0xLjMxMSAwbC0xLjE5IDEuMTljLS4xOTEuMTkxLS40NTUuMjQ0LS43MDUuMTQtLjI1LS4xMDQtLjM5OS0uMzI3LS4zOTktLjU5N3YtMS42ODRjMC0uNTExLS40MTYtLjkyNy0uOTI3LS45MjdoLTIuMTQ3Yy0uNTExIDAtLjkyNy40MTYtLjkyNy45Mjd2MS42ODRjMCAuMjcxLS4xNDkuNDk0LS4zOTkuNTk3LS4yNDkuMTA0LS41MTMuMDUxLS43MDUtLjE0bC0xLjE5LTEuMTljLS4zNTEtLjM1MS0uOTYxLS4zNS0xLjMxMSAwbC0xLjUxOCAxLjUxOGMtLjE3NS4xNzUtLjI3MS40MDgtLjI3MS42NTYgMCAuMjQ3LjA5Ni40OC4yNzEuNjU1bDEuMTkxIDEuMTljLjE5MS4xOTEuMjQzLjQ1NS4xNC43MDVzLS4zMjcuMzk5LS41OTcuMzk5aC0xLjY4NGMtLjUxMSAwLS45MjcuNDE2LS45MjcuOTI3djIuMTQ2YzAgLjUxMS40MTYuOTI3LjkyNy45MjdoMS42ODRjLjI3MSAwIC40OTQuMTQ5LjU5Ny4zOTkuMTA0LjI1LjA1MS41MTMtLjE0LjcwNWwtMS4xOTEgMS4xOWMtLjE3NS4xNzUtLjI3MS40MDgtLjI3MS42NTUgMCAuMjQ4LjA5Ni40OC4yNzEuNjU2bDEuNTE4IDEuNTE4Yy4zNS4zNS45Ni4zNTEgMS4zMTEgMGwxLjE5LTEuMTkxYy4xOTEtLjE5MS40NTQtLjI0NC43MDUtLjE0LjI1LjEwNC4zOTkuMzI3LjM5OS41OTd2MS42ODRjMCAuNTExLjQxNi45MjcuOTI3LjkyN2gyLjE0NmMuNTExIDAgLjkyNy0uNDE2LjkyNy0uOTI3di0xLjY4NGMwLS4yNzEuMTQ5LS40OTQuMzk5LS41OTcuMjUtLjEwNC41MTMtLjA1MS43MDUuMTRsMS4xOSAxLjE5MWMuMzUxLjM1MS45NjEuMzUgMS4zMTEgMGwxLjUxOC0xLjUxOGMuMTc1LS4xNzUuMjcxLS40MDguMjcxLS42NTYgMC0uMjQ3LS4wOTYtLjQ4LS4yNzEtLjY1NWwtMS4xOTEtMS4xOWMtLjE5MS0uMTkxLS4yNDMtLjQ1NS0uMTQtLjcwNXMuMzI3LS4zOTkuNTk4LS4zOTloMS42ODRjLjUxMSAwIC45MjctLjQxNi45MjctLjkyN3YtMi4xNDdjMC0uNTExLS40MTYtLjkyNy0uOTI3LS45Mjd6bS04LjA3MyA1Yy0xLjY1NyAwLTMtMS4zNDMtMy0zczEuMzQzLTMgMy0zIDMgMS4zNDMgMyAzLTEuMzQzIDMtMyAzeiIvPjwvc3ZnPg=="

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: ', '\n    no-repeat;\n  background-size: 100%;\n  cursor: pointer;\n  transition: 0.2s all;\n  height: ', ';\n  width: ', ';\n  -webkit-filter: blur(0px);\n\n  &:hover {\n    background: ', ' no-repeat;\n    background-size: 100%;\n  }\n'], ['\n  background: ', '\n    no-repeat;\n  background-size: 100%;\n  cursor: pointer;\n  transition: 0.2s all;\n  height: ', ';\n  width: ', ';\n  -webkit-filter: blur(0px);\n\n  &:hover {\n    background: ', ' no-repeat;\n    background-size: 100%;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: table;\n  position: absolute;\n  top: 50%;\n  left: ', 'px;\n  transform: translateY(-50%);\n  padding: 10px 15px;\n  border-radius: 5px;\n  background-color: #263746;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  color: #ffffff;\n  line-height: 18px;\n  opacity: ', ';\n  transition: all 0.5s ease-out;\n  pointer-events: none;\n  white-space: nowrap;\n'], ['\n  display: table;\n  position: absolute;\n  top: 50%;\n  left: ', 'px;\n  transform: translateY(-50%);\n  padding: 10px 15px;\n  border-radius: 5px;\n  background-color: #263746;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  color: #ffffff;\n  line-height: 18px;\n  opacity: ', ';\n  transition: all 0.5s ease-out;\n  pointer-events: none;\n  white-space: nowrap;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = _styledComponents2.default.div.withConfig({
  displayName: 'NavItem__Icon',
  componentId: 'sc-1aga5tn-0'
})(_templateObject, function (props) {
  return 'url(' + (props.isActive ? props.activeIcon : props.inactiveIcon) + ')';
}, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return 'url(' + props.hoverIcon + ')';
});

var NavLabel = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'NavItem__NavLabel',
  componentId: 'sc-1aga5tn-1'
})(_templateObject2, function (props) {
  return props.show ? 40 : 30;
}, function (props) {
  return props.show ? 1 : 0;
});

var NavItem = function (_React$Component) {
  (0, _inherits3.default)(NavItem, _React$Component);

  function NavItem() {
    (0, _classCallCheck3.default)(this, NavItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NavItem.__proto__ || (0, _getPrototypeOf2.default)(NavItem)).call(this));

    _this.onIconClickBound = _this.onIconClick.bind(_this);
    _this.onHoverBound = _this.onHover.bind(_this);
    _this.onLeaveHoverBound = _this.onLeaveHover.bind(_this);
    _this.state = {
      showLabel: false
    };
    return _this;
  }

  (0, _createClass3.default)(NavItem, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' } },
        _react2.default.createElement(Icon, (0, _extends3.default)({
          onClick: this.onIconClickBound,
          onMouseOver: this.onHoverBound,
          onFocus: this.onHoverBound,
          onMouseLeave: this.onLeaveHoverBound
        }, this.props)),
        _react2.default.createElement(
          NavLabel,
          { show: this.state.showLabel },
          this.props.label
        )
      );
    }
  }, {
    key: 'onIconClick',
    value: function onIconClick() {
      this.props.handleClick();
    }
  }, {
    key: 'onHover',
    value: function onHover() {
      this.setState(function () {
        return {
          showLabel: true
        };
      });
    }
  }, {
    key: 'onLeaveHover',
    value: function onLeaveHover() {
      this.setState(function () {
        return {
          showLabel: false
        };
      });
    }
  }]);
  return NavItem;
}(_react2.default.Component);

NavItem.propTypes = {
  label: _propTypes2.default.string.isRequired,
  activeIcon: _propTypes2.default.string.isRequired,
  inactiveIcon: _propTypes2.default.string.isRequired,
  hoverIcon: _propTypes2.default.string,
  isActive: _propTypes2.default.bool.isRequired,
  handleClick: _propTypes2.default.func.isRequired
};

exports.default = NavItem;

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjYgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+RjY1OEQ2RUItREQwMS00MEZDLUE5NzUtRjNDRkMwRjYxMjA4PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJRTS0wMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1TaWRlLU5hdi0tLU15LVF1ZXN0cy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTc2LjAwMDAwMCwgLTExOTcuMDAwMDAwKSIgZmlsbD0iI0ZGQUUwMCI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xODAsMTIwNSBDMTc3Ljc5MDg2MSwxMjA1IDE3NiwxMjAzLjIwOTE0IDE3NiwxMjAxIEMxNzYsMTE5OC43OTA4NiAxNzcuNzkwODYxLDExOTcgMTgwLDExOTcgQzE4Mi4yMDkxMzksMTE5NyAxODQsMTE5OC43OTA4NiAxODQsMTIwMSBDMTg0LDEyMDMuMjA5MTQgMTgyLjIwOTEzOSwxMjA1IDE4MCwxMjA1IFogTTE4MCwxMjE1LjUgQzE3Ny43OTA4NjEsMTIxNS41IDE3NiwxMjEzLjcwOTE0IDE3NiwxMjExLjUgQzE3NiwxMjA5LjI5MDg2IDE3Ny43OTA4NjEsMTIwNy41IDE4MCwxMjA3LjUgQzE4Mi4yMDkxMzksMTIwNy41IDE4NCwxMjA5LjI5MDg2IDE4NCwxMjExLjUgQzE4NCwxMjEzLjcwOTE0IDE4Mi4yMDkxMzksMTIxNS41IDE4MCwxMjE1LjUgWiBNMTg4LjUsMTIwMCBMMjAwLjUsMTIwMCBDMjAxLjMyODQyNywxMjAwIDIwMiwxMjAwLjY3MTU3IDIwMiwxMjAxLjUgQzIwMiwxMjAyLjMyODQzIDIwMS4zMjg0MjcsMTIwMyAyMDAuNSwxMjAzIEwxODguNSwxMjAzIEMxODcuNjcxNTczLDEyMDMgMTg3LDEyMDIuMzI4NDMgMTg3LDEyMDEuNSBDMTg3LDEyMDAuNjcxNTcgMTg3LjY3MTU3MywxMjAwIDE4OC41LDEyMDAgWiBNMTg4LjUsMTIxMCBMMjAwLjUsMTIxMCBDMjAxLjMyODQyNywxMjEwIDIwMiwxMjEwLjY3MTU3IDIwMiwxMjExLjUgQzIwMiwxMjEyLjMyODQzIDIwMS4zMjg0MjcsMTIxMyAyMDAuNSwxMjEzIEwxODguNSwxMjEzIEMxODcuNjcxNTczLDEyMTMgMTg3LDEyMTIuMzI4NDMgMTg3LDEyMTEuNSBDMTg3LDEyMTAuNjcxNTcgMTg3LjY3MTU3MywxMjEwIDE4OC41LDEyMTAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlLUNvcHktNyI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjYgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+QTI3RDdCOTctRkRDNi00MDczLTg0NjctRjA2QzQ1MDk4NUJCPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJRTS0wMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1TaWRlLU5hdi0tLU15LVF1ZXN0cy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzguMDAwMDAwLCAtMTE5Ny4wMDAwMDApIiBmaWxsPSIjREJFMUU2Ij4KICAgICAgICAgICAgPHBhdGggZD0iTTgyLDEyMDUgQzc5Ljc5MDg2MSwxMjA1IDc4LDEyMDMuMjA5MTQgNzgsMTIwMSBDNzgsMTE5OC43OTA4NiA3OS43OTA4NjEsMTE5NyA4MiwxMTk3IEM4NC4yMDkxMzksMTE5NyA4NiwxMTk4Ljc5MDg2IDg2LDEyMDEgQzg2LDEyMDMuMjA5MTQgODQuMjA5MTM5LDEyMDUgODIsMTIwNSBaIE04MiwxMjE1LjUgQzc5Ljc5MDg2MSwxMjE1LjUgNzgsMTIxMy43MDkxNCA3OCwxMjExLjUgQzc4LDEyMDkuMjkwODYgNzkuNzkwODYxLDEyMDcuNSA4MiwxMjA3LjUgQzg0LjIwOTEzOSwxMjA3LjUgODYsMTIwOS4yOTA4NiA4NiwxMjExLjUgQzg2LDEyMTMuNzA5MTQgODQuMjA5MTM5LDEyMTUuNSA4MiwxMjE1LjUgWiBNOTAuNSwxMjAwIEwxMDIuNSwxMjAwIEMxMDMuMzI4NDI3LDEyMDAgMTA0LDEyMDAuNjcxNTcgMTA0LDEyMDEuNSBDMTA0LDEyMDIuMzI4NDMgMTAzLjMyODQyNywxMjAzIDEwMi41LDEyMDMgTDkwLjUsMTIwMyBDODkuNjcxNTcyOSwxMjAzIDg5LDEyMDIuMzI4NDMgODksMTIwMS41IEM4OSwxMjAwLjY3MTU3IDg5LjY3MTU3MjksMTIwMCA5MC41LDEyMDAgWiBNOTAuNSwxMjEwIEwxMDIuNSwxMjEwIEMxMDMuMzI4NDI3LDEyMTAgMTA0LDEyMTAuNjcxNTcgMTA0LDEyMTEuNSBDMTA0LDEyMTIuMzI4NDMgMTAzLjMyODQyNywxMjEzIDEwMi41LDEyMTMgTDkwLjUsMTIxMyBDODkuNjcxNTcyOSwxMjEzIDg5LDEyMTIuMzI4NDMgODksMTIxMS41IEM4OSwxMjEwLjY3MTU3IDg5LjY3MTU3MjksMTIxMCA5MC41LDEyMTAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlLUNvcHkiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjYgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NS4xICg3ODEzNikgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+NURGMTJBMUUtMERBRC00NjI5LUIxRUUtRDc0OTk5MUZDNzBEPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJRTS0wMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1TaWRlLU5hdi0tLU15LVF1ZXN0cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3Ni4wMDAwMDAsIC0xMTk3LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTgwLDEyMDUgQzE3Ny43OTA4NjEsMTIwNSAxNzYsMTIwMy4yMDkxNCAxNzYsMTIwMSBDMTc2LDExOTguNzkwODYgMTc3Ljc5MDg2MSwxMTk3IDE4MCwxMTk3IEMxODIuMjA5MTM5LDExOTcgMTg0LDExOTguNzkwODYgMTg0LDEyMDEgQzE4NCwxMjAzLjIwOTE0IDE4Mi4yMDkxMzksMTIwNSAxODAsMTIwNSBaIE0xODAsMTIxNS41IEMxNzcuNzkwODYxLDEyMTUuNSAxNzYsMTIxMy43MDkxNCAxNzYsMTIxMS41IEMxNzYsMTIwOS4yOTA4NiAxNzcuNzkwODYxLDEyMDcuNSAxODAsMTIwNy41IEMxODIuMjA5MTM5LDEyMDcuNSAxODQsMTIwOS4yOTA4NiAxODQsMTIxMS41IEMxODQsMTIxMy43MDkxNCAxODIuMjA5MTM5LDEyMTUuNSAxODAsMTIxNS41IFogTTE4OC41LDEyMDAgTDIwMC41LDEyMDAgQzIwMS4zMjg0MjcsMTIwMCAyMDIsMTIwMC42NzE1NyAyMDIsMTIwMS41IEMyMDIsMTIwMi4zMjg0MyAyMDEuMzI4NDI3LDEyMDMgMjAwLjUsMTIwMyBMMTg4LjUsMTIwMyBDMTg3LjY3MTU3MywxMjAzIDE4NywxMjAyLjMyODQzIDE4NywxMjAxLjUgQzE4NywxMjAwLjY3MTU3IDE4Ny42NzE1NzMsMTIwMCAxODguNSwxMjAwIFogTTE4OC41LDEyMTAgTDIwMC41LDEyMTAgQzIwMS4zMjg0MjcsMTIxMCAyMDIsMTIxMC42NzE1NyAyMDIsMTIxMS41IEMyMDIsMTIxMi4zMjg0MyAyMDEuMzI4NDI3LDEyMTMgMjAwLjUsMTIxMyBMMTg4LjUsMTIxMyBDMTg3LjY3MTU3MywxMjEzIDE4NywxMjEyLjMyODQzIDE4NywxMjExLjUgQzE4NywxMjEwLjY3MTU3IDE4Ny42NzE1NzMsMTIxMCAxODguNSwxMjEwIFoiIGlkPSJBbGwtUXVlc3RzLS0tSG92ZXIiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjggMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+RkQxRDEyRTUtQzhFNy00RUFELUFCRjktNzNDREIwODFFMkFCPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJRTS0wMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1TaWRlLU5hdi0tLU15LVF1ZXN0cy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcwLjAwMDAwMCwgLTk4MS4wMDAwMDApIiBmaWxsPSIjRkZBRTAwIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE3OSw5OTMuOTE0NzQ0IEwxODAuODMzODIzLDk5Mi4wOTg2NjggQzE4MS40ODQ0OTIsOTkxLjQ1MjY1NyAxODEuNjc5MjM5LDk5MC40Nzk4NTUgMTgxLjMyNjA2LDk4OS42MzUyMyBDMTgxLjIxMzYyNyw5ODkuMzY0NTQ3IDE4MS4wNDY3ODcsOTg5LjExNTgwMSAxODAuODM2NTE1LDk4OC45MDY0NTEgTDE3OSw5ODcuMDg3MTg2IEwxNzksOTg0IEMxNzksOTgyLjM0MzE0NiAxODAuMzQzMTQ2LDk4MSAxODIsOTgxIEwxOTUsOTgxIEMxOTYuNjU2ODU0LDk4MSAxOTgsOTgyLjM0MzE0NiAxOTgsOTg0IEwxOTgsOTk3IEMxOTgsOTk4LjY1Njg1NCAxOTYuNjU2ODU0LDEwMDAgMTk1LDEwMDAgTDE4MiwxMDAwIEMxODAuMzQzMTQ2LDEwMDAgMTc5LDk5OC42NTY4NTQgMTc5LDk5NyBMMTc5LDk5My45MTQ3NDQgWiBNMTkyLjM4Njk5OCw5OTIuMjQ2NTE4IEMxOTIuNDgxMTQ0LDk5MS44MDUwNzcgMTkyLjEwNDU2Miw5OTEuMzYzNjM2IDE5MS42MzM4MzQsOTkxLjM2MzYzNiBMMTg0Ljk0OTUwNSw5OTEuMzYzNjM2IEMxODQuNDc4Nzc4LDk5MS4zNjM2MzYgMTg0LjEwMjE5Niw5OTEuODA1MDc3IDE4NC4xOTYzNDEsOTkyLjI0NjUxOCBDMTg0LjY2NzA2OSw5OTQuMDEyMjgxIDE4Ni4zNjE2ODcsOTk1LjMzNjYwNCAxODguMzM4NzQyLDk5NS4zMzY2MDQgQzE5MC4zMTU3OTgsOTk1LjMzNjYwNCAxOTEuOTE2MjcxLDk5NC4wMTIyODEgMTkyLjM4Njk5OCw5OTIuMjQ2NTE4IFogTTE5Mi42ODQ1OTEsOTg5LjE1OTAyNiBDMTkzLjU2NDc1Nyw5ODkuMTU5MDI2IDE5NC4yNzgyNzMsOTg4LjQ5MjU1NiAxOTQuMjc4MjczLDk4Ny42NzA0MjIgQzE5NC4yNzgyNzMsOTg2Ljg0ODI4OSAxOTMuNTY0NzU3LDk4Ni4xODE4MTggMTkyLjY4NDU5MSw5ODYuMTgxODE4IEMxOTEuODA0NDI1LDk4Ni4xODE4MTggMTkxLjA5MDkwOSw5ODYuODQ4Mjg5IDE5MS4wOTA5MDksOTg3LjY3MDQyMiBDMTkxLjA5MDkwOSw5ODguNDkyNTU2IDE5MS44MDQ0MjUsOTg5LjE1OTAyNiAxOTIuNjg0NTkxLDk4OS4xNTkwMjYgWiBNMTg0LjA0ODIyNyw5ODkuMTU5MDI2IEMxODQuOTI4Mzk0LDk4OS4xNTkwMjYgMTg1LjY0MTkwOSw5ODguNDkyNTU2IDE4NS42NDE5MDksOTg3LjY3MDQyMiBDMTg1LjY0MTkwOSw5ODYuODQ4Mjg5IDE4NC45MjgzOTQsOTg2LjE4MTgxOCAxODQuMDQ4MjI3LDk4Ni4xODE4MTggQzE4My4xNjgwNjEsOTg2LjE4MTgxOCAxODIuNDU0NTQ1LDk4Ni44NDgyODkgMTgyLjQ1NDU0NSw5ODcuNjcwNDIyIEMxODIuNDU0NTQ1LDk4OC40OTI1NTYgMTgzLjE2ODA2MSw5ODkuMTU5MDI2IDE4NC4wNDgyMjcsOTg5LjE1OTAyNiBaIE0xNzcuNDI3NjA4LDk5MS4zNzkwMiBMMTcwLjc4ODM3OCw5OTEuMzc5MDIgQzE3MC4zNTMzNTEsOTkxLjM3OTAyIDE3MC4wMDA1MzgsOTkxLjAyNjY1MyAxNzAsOTkwLjU4NjEzOSBDMTcwLjAwMjQ4NSw5OTAuMTU0MzIyIDE3MC4zNTQ1NTYsOTg5LjgwNjI3OSAxNzAuNzg2MzczLDk4OS44MDg3NjMgTDE3Ni4yNDk0ODksOTg5Ljg0MDE5NiBMMTc3LjQ0Mzc5MSw5ODkuODQzNTAyIEwxNzQuOTA4MTcyLDk4Ny4yNzIyNzMgQzE3NC42MjM5NzYsOTg2Ljk4MDc4NiAxNzQuNjIzOTc2LDk4Ni41MTg3IDE3NC45MDgxNzIsOTg2LjIyNzIxMyBDMTc1LjE5OTQ4Nyw5ODUuOTI4NDExIDE3NS42ODAxNDgsOTg1LjkyMDEyNSAxNzUuOTgxNzg0LDk4Ni4yMDg3MDMgTDE3OS43NzgxNzYsOTg5Ljk2OTQyOSBDMTc5Ljg0ODUxMyw5OTAuMDM5NDU4IDE3OS45MDQyMTMsOTkwLjEyMjUzMyAxNzkuOTQyMTYzLDk5MC4yMTM4OTIgQzE4MC4wNTk1NjksOTkwLjQ5NDY3IDE3OS45OTQ4ODIsOTkwLjgxNzg0MyAxNzkuNzc4MTc2LDk5MS4wMzI5OTkgTDE3NS45ODE3NCw5OTQuNzkzNzI1IEMxNzUuNjg5NzEzLDk5NS4wNjUzOCAxNzUuMjM0ODU2LDk5NS4wNjU1NTYgMTc0Ljk0MjYwNyw5OTQuNzk0MDc3IEMxNzQuNjM2Njk5LDk5NC41MDk5NSAxNzQuNjIxMjYyLDk5NC4wMzM5MzggMTc0LjkwODEyOCw5OTMuNzMwOTQ4IEwxNzcuNDI3NjA4LDk5MS4zNzkwMiBaIiBpZD0iQ29tYmluZWQtU2hhcGUtQ29weS05Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMjcgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+QTczMUREMjgtQzg4NS00NDA3LUIxNjctQTlFMDVCQjhDMUMwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJRTS0wMyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1TaWRlLU5hdi0tLU15LVF1ZXN0cy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzguMDAwMDAwLCAtMTM0Ni4wMDAwMDApIiBmaWxsPSIjREJFMUU2IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNODkuODk4MjY2MSwxMzYwLjc3MDk5IEM4OS44OTM4MTY5LDEzNjAuNTc1MzggODkuODY1NjUsMTM2MC4zNzgzIDg5LjgxMjUwMTksMTM2MC4xODM4NiBDODkuOTc0MzU4MiwxMzU5LjU5Mjg2IDg5LjkxMDY0MzQsMTM1OC45NjczIDg5LjYxMjU1OCwxMzU4LjM5NDAxIEM4OS4xOTAwNjU3LDEzNTcuNTgxNTggODguNDExNDUyNCwxMzU3LjEyOTgzIDg3LjUwODc3NTUsMTM1Ny4xMzYzOSBDODcuMjc4ODUsMTM1Ny4xMzgwNCA4Ny4wNzE2ODgxLDEzNTcuMTM4OTEgODYuODE2NDM0OCwxMzU3LjEzOTE3IEM4Ni44MTQ4OTI0LDEzNTYuNzM1MjggODYuNzU2MTk0NCwxMzU2LjMzMTg2IDg2LjYzNjA0MSwxMzU1LjkzMDU1IEM4Ni4zNjA1MjkyLDEzNTUuMDEwMjUgODUuNzY0ODI0NCwxMzU0LjMxMjk5IDg0Ljg2Nzg3NzcsMTM1NC4wMzQ5OSBMODQuODY3ODc3NywxMzQ5LjE0NTAyIEM4NC44Njc4Nzc3LDEzNDcuNDY5MjEgODYuMTkyNjkxMiwxMzQ2LjEwNzYxIDg3LjgyMzIzMDgsMTM0Ni4xMDc2MSBDODcuODIzMjMwOCwxMzQ2LjEwNzYxIDEwMS45ODE5NjksMTM0Ni4xMDc2MSAxMDEuOTgxOTY5LDEzNDYuMTA3NjEgQzEwMy42MTI1MDksMTM0Ni4xMDc2MSAxMDQuOTM3MzIyLDEzNDcuNDY5MjEgMTA0LjkzNzMyMiwxMzQ5LjE0NTAyIEwxMDQuOTM3MzIyLDEzNTcuNzMzNTggQzEwNC45MzczMjIsMTM1OS40MDkzOSAxMDMuNjEyNTA5LDEzNjAuNzcwOTkgMTAxLjk4MTk2OSwxMzYwLjc3MDk5IEwxMDEuMjY4NjA4LDEzNjAuNzcwOTkgQzEwMC45NjI4ODIsMTM2MC43NzA5OSAxMDAuNzU5MDY0LDEzNjAuOTgwNDcgMTAwLjc1OTA2NCwxMzYxLjI5NDY4IEMxMDAuNjU3MTU2LDEzNjIuMzQyMDcgMTAwLjg2MDk3MywxMzYzLjM4OTQ1IDEwMS4yNjg2MDgsMTM2NC4yMjczNiBDMTAwLjA0NTcwMywxMzYzLjcwMzY3IDk4LjMxMzI1NDksMTM2Mi43NjEwMiA5Ny4xOTIyNTg5LDEzNjAuOTgwNDcgQzk3LjA5MDM1MDIsMTM2MC44NzU3MyA5Ni45ODg0NDE1LDEzNjAuNzcwOTkgOTYuNzg0NjI0LDEzNjAuNzcwOTkgTDg5Ljg5ODI2NjEsMTM2MC43NzA5OSBaIE05MCwxMzUyLjM4MDA4IEwxMDAuMTE1MTksMTM1Mi4zODAwOCBDMTAwLjYzMjk1NywxMzUyLjM4MDA4IDEwMS4wNTI2OSwxMzUxLjk2MDM0IDEwMS4wNTI2OSwxMzUxLjQ0MjU4IEMxMDEuMDUyNjksMTM1MC45MjQ4MSAxMDAuNjMyOTU3LDEzNTAuNTA1MDggMTAwLjExNTE5LDEzNTAuNTA1MDggTDkwLDEzNTAuNTA1MDggQzg5LjQ4MjIzMywxMzUwLjUwNTA4IDg5LjA2MjUsMTM1MC45MjQ4MSA4OS4wNjI1LDEzNTEuNDQyNTggQzg5LjA2MjUsMTM1MS45NjAzNCA4OS40ODIyMzMsMTM1Mi4zODAwOCA5MCwxMzUyLjM4MDA4IFogTTkwLDEzNTYuMjQ1NjIgTDEwMC4xMTUxOSwxMzU2LjI0NTYyIEMxMDAuNjMyOTU3LDEzNTYuMjQ1NjIgMTAxLjA1MjY5LDEzNTUuODI1ODkgMTAxLjA1MjY5LDEzNTUuMzA4MTIgQzEwMS4wNTI2OSwxMzU0Ljc5MDM2IDEwMC42MzI5NTcsMTM1NC4zNzA2MiAxMDAuMTE1MTksMTM1NC4zNzA2MiBMOTAsMTM1NC4zNzA2MiBDODkuNDgyMjMzLDEzNTQuMzcwNjIgODkuMDYyNSwxMzU0Ljc5MDM2IDg5LjA2MjUsMTM1NS4zMDgxMiBDODkuMDYyNSwxMzU1LjgyNTg5IDg5LjQ4MjIzMywxMzU2LjI0NTYyIDkwLDEzNTYuMjQ1NjIgWiBNODcuMTM1NjIyNiwxMzYzLjYwMzA1IEM4Ny4wNTk5Njk0LDEzNjQuMDE2NCA4Ni43MzI2NTc0LDEzNjQuMjk0NjIgODYuMzIwMTkwMSwxMzY0LjI5OTQyIEM4NS40OTI3MzksMTM2NC4zMDkwMiA4NC42NjM4MzEzLDEzNjQuMzMyNTcgODMuODM3OTAzMywxMzY0LjI5NDU4IEM4My4wMjM3NjE5LDEzNjQuMjU3MTEgODIuMjQxOTAxNSwxMzY0LjAyMTU4IDgxLjQ4NDMwOTcsMTM2My43MTAyNCBDODEuNDQwMTQyOCwxMzYzLjY5MjExIDgxLjM5MzM2MDMsMTM2My42MDk1IDgxLjM5MzE5NDgsMTM2My41NTY3IEM4MS4zODgxNjIyLDEzNjIuMTUyNTMgODEuMzg3NjMyNSwxMzYwLjc0ODMyIDgxLjM5NDI4NzMsMTM1OS4zNDQxOSBDODEuMzk0NTUyMiwxMzU5LjI4NDQ0IDgxLjQ1ODEyMDgsMTM1OS4yMDE5NyA4MS41MTM0NDUzLDEzNTkuMTY5NjUgQzgxLjc0ODg4MDgsMTM1OS4wMzIyMyA4MS45OTUwMTA0LDEzNTguOTE0OTEgODIuMjMyMywxMzU4Ljc4MDc0IEM4Mi44NzM5Nzg1LDEzNTguNDE4MDIgODMuMTc0MzA2OSwxMzU3LjgwMjYzIDgzLjM0MTczNzIsMTM1Ny4xMDE0NiBDODMuNDM0NzM5NCwxMzU2LjcxMTk4IDgzLjUwMDU1OTQsMTM1Ni4zMTUxMyA4My41NzAwNTQ0LDEzNTUuOTE5OTQgQzgzLjYzMTQwNDcsMTM1NS41NzExNyA4My45MDczMzIxLDEzNTUuMzcwMzUgODQuMjQ0MDgsMTM1NS40MjU4MSBDODQuNzY4NjUzMiwxMzU1LjUxMjI1IDg1LjA1MjI5NDksMTM1NS44NzA1MiA4NS4xOTkwNjU1LDEzNTYuMzYwNzkgQzg1LjQwNjcyMjgsMTM1Ny4wNTQzNiA4NS4zMjMzODg0LDEzNTcuNzM0OTggODUuMDU5MTQ4NCwxMzU4LjM5Nzg1IEM4NS4wMzI1MjksMTM1OC40NjQ3MSA4NS4wMDc0MzI3LDEzNTguNTMyMjMgODQuOTY3MDA3LDEzNTguNjM3NTYgTDg1LjE4NTkyMTMsMTM1OC42Mzc1NiBDODUuOTYzODc0OSwxMzU4LjYzNzc3IDg2Ljc0MTc5NTQsMTM1OC42NDE5NSA4Ny41MTk2ODI4LDEzNTguNjM2MzUgQzg3Ljg2MTYyODgsMTM1OC42MzM4NiA4OC4xMjA5MDI1LDEzNTguNzc2NzcgODguMjgxNzExMSwxMzU5LjA4NiBDODguNDQ5NzcwNiwxMzU5LjQwOTIyIDg4LjQzNTUwMDcsMTM1OS43NDEzOCA4OC4yNTE1NDkyLDEzNjAuMDU0MyBDODguMTk0NzM0OCwxMzYwLjE1MDk3IDg4LjE4NTU5NjgsMTM2MC4yMTA3MSA4OC4yNDgxMzksMTM2MC4zMTE5NCBDODguNTY1OTE1NywxMzYwLjgyNjQ4IDg4LjM2MjMzMDcsMTM2MS40NTkyNyA4Ny44MDk4NDY5LDEzNjEuNjc5NCBDODcuNjkxNDUwNCwxMzYxLjcyNjU3IDg3LjczNDk4ODIsMTM2MS43OTYxOSA4Ny43NTI3Njc2LDEzNjEuODcwNTEgQzg3Ljg0NjEzMzksMTM2Mi4yNjA1MiA4Ny42OTUwNTkyLDEzNjIuNjg1MzcgODcuMzg1NzI1MywxMzYyLjg4MTUzIEM4Ny4zMDIwOTI4LDEzNjIuOTM0NjIgODcuMjA3MzY5LDEzNjIuOTY4NzQgODcuMTQxMzgzNSwxMzYzLjAwMDIzIEM4Ny4xNDEzODM1LDEzNjMuMjE4NyA4Ny4xNjk2NTgzLDEzNjMuNDE3MDcgODcuMTM1NjIyNiwxMzYzLjYwMzA1IFogTTc4LjAwMDM4NTcsMTM2MS41OTk1NiBDNzguMDAwNDE5MywxMzYwLjc4NTggNzcuOTk5OTgyNCwxMzU5Ljk3MjA1IDc4LjAwMDYyMDksMTM1OS4xNTgzMyBDNzguMDAwODU2MSwxMzU4Ljg1MjkxIDc4LjA4MTE2NiwxMzU4Ljc1NjAyIDc4LjMzODQ5MzYsMTM1OC43NTUxMiBDNzguODMwOTcxMiwxMzU4Ljc1MzM4IDc5LjMyMzQ4MjQsMTM1OC43NTMxNSA3OS44MTU5MjY1LDEzNTguNzU1MDggQzgwLjA3MjI3OTYsMTM1OC43NTYwNiA4MC4xNTYwMTY5LDEzNTguODU1MjggODAuMTU2MTg1LDEzNTkuMTU3NzggQzgwLjE1NzAyNSwxMzYwLjc5MTgzIDgwLjE1NzEyNTgsMTM2Mi40MjU4OCA4MC4xNTYyNTIyLDEzNjQuMDU5OTQgQzgwLjE1NjA4NDEsMTM2NC4zMzgwMSA4MC4wNzAwMjgzLDEzNjQuNDQwNjEgNzkuODMzMzY2MSwxMzY0LjQ0MTgzIEM3OS4zMjQxMjA5LDEzNjQuNDQ0NDQgNzguODE0ODQyLDEzNjQuNDQ0NjMgNzguMzA1NTk2OCwxMzY0LjQ0MTU2IEM3OC4wODkwMjg5LDEzNjQuNDQwMjIgNzguMDAxNTk1MywxMzY0LjMzNTg0IDc4LjAwMTAyNDEsMTM2NC4wODAxNSBDNzcuOTk5MjA5NiwxMzYzLjI1MzI3IDc4LjAwMDM1MiwxMzYyLjQyNjQgNzguMDAwMzg1NywxMzYxLjU5OTU2IFoiIGlkPSJDb21iaW5lZC1TaGFwZS1Db3B5LTUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userCanSeeProductionStatus = exports.userCanSeeReviewQueue = exports.userCanSeeMyQuests = exports.userCanSeeQueue = exports.isOnNavRoute = exports.isOnQueueRoute = exports.isOnAllQuestsRoute = undefined;

var _user = __webpack_require__(45);

var isOnQueueRoute = function isOnQueueRoute(currentPath) {
  return currentPath.indexOf('queue') > -1 && currentPath.indexOf('reviewqueue') && currentPath.indexOf('reviewqueue') < 0;
};

var isOnAllQuestsRoute = function isOnAllQuestsRoute(currentPath) {
  return currentPath.indexOf('quests') > -1 && currentPath.indexOf('/myquests') < 0;
};

var isOnNavRoute = function isOnNavRoute(currentPath, navRoute) {
  return currentPath.indexOf(navRoute) > -1;
};

var userCanSeeQueue = function userCanSeeQueue(user) {
  return ((0, _user.isInternalReviewer)(user) || (0, _user.isQuestCopyEditor)(user) || (0, _user.isQuestManager)(user)) && !(0, _user.isQuestDesigner)(user);
};

var userCanSeeMyQuests = function userCanSeeMyQuests(user) {
  return (0, _user.isQuestDesignerOrIsQuestManager)(user);
};

var userCanSeeReviewQueue = function userCanSeeReviewQueue(user) {
  return (0, _user.isOeReviewer)(user);
};

var userCanSeeProductionStatus = function userCanSeeProductionStatus(user, courses) {
  return courses.length > 0 && courses.some(function (c) {
    return c.mock_levels.length > 0;
  }) && ((0, _user.isOeReviewer)(user) || (0, _user.isQuestManager)(user));
};

exports.isOnAllQuestsRoute = isOnAllQuestsRoute;
exports.isOnQueueRoute = isOnQueueRoute;
exports.isOnNavRoute = isOnNavRoute;
exports.userCanSeeQueue = userCanSeeQueue;
exports.userCanSeeMyQuests = userCanSeeMyQuests;
exports.userCanSeeReviewQueue = userCanSeeReviewQueue;
exports.userCanSeeProductionStatus = userCanSeeProductionStatus;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _AuthenticatedFooter = __webpack_require__(1167);

var _AuthenticatedFooter2 = _interopRequireDefault(_AuthenticatedFooter);

var _UnauthenticatedFooter = __webpack_require__(1170);

var _UnauthenticatedFooter2 = _interopRequireDefault(_UnauthenticatedFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          dispatch = _props.dispatch;

      return _react2.default.createElement(
        'footer',
        {
          className: user.isAuthenticated ? 'auth' : 'unauth footer navbar navbar-bottom navbar-inverse'
        },
        user.isAuthenticated ? _react2.default.createElement(_AuthenticatedFooter2.default, { dispatch: dispatch }) : _react2.default.createElement(_UnauthenticatedFooter2.default, null)
      );
    }
  }]);
  return Footer;
}(_react.Component);

Footer.propTypes = {
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Footer);
exports.FooterDisconnected = Footer; // pure component - used in tests

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _time = __webpack_require__(161);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthenticatedFooter = function (_PureComponent) {
  (0, _inherits3.default)(AuthenticatedFooter, _PureComponent);

  function AuthenticatedFooter(props) {
    (0, _classCallCheck3.default)(this, AuthenticatedFooter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AuthenticatedFooter.__proto__ || (0, _getPrototypeOf2.default)(AuthenticatedFooter)).call(this, props));

    _this.onPoliciesClickBound = _this.onPoliciesClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AuthenticatedFooter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement('div', {
          className: 'logo',
          onClick: function onClick() {
            return window.open('https://www.opportunityeducation.org/');
          }
        }),
        _react2.default.createElement(
          'div',
          { className: 'copyright-policies-container' },
          _react2.default.createElement(
            'div',
            { className: 'caption1' },
            _react2.default.createElement(
              'div',
              null,
              '\xA9 2012-' + (0, _time.getCurrentYear)() + ' Opportunity Education Foundation, Inc.'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              'Quest Forward Learning\u2122 | All rights reserved. |',
              _react2.default.createElement(
                'div',
                { className: 'ourpolicies', onClick: this.onPoliciesClickBound },
                '\xA0\xA0Our Policies'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'onPoliciesClick',
    value: function onPoliciesClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/ourpolicies'));
    }
  }]);
  return AuthenticatedFooter;
}(_react.PureComponent);

exports.default = AuthenticatedFooter;


AuthenticatedFooter.propTypes = {
  dispatch: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./es": 1169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1168;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(112)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _time = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnauthenticatedFooter = function (_PureComponent) {
  (0, _inherits3.default)(UnauthenticatedFooter, _PureComponent);

  function UnauthenticatedFooter() {
    (0, _classCallCheck3.default)(this, UnauthenticatedFooter);
    return (0, _possibleConstructorReturn3.default)(this, (UnauthenticatedFooter.__proto__ || (0, _getPrototypeOf2.default)(UnauthenticatedFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(UnauthenticatedFooter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement('div', {
          className: 'logo',
          onClick: function onClick() {
            return window.open('https://www.opportunityeducation.org/');
          }
        }),
        _react2.default.createElement(
          'div',
          { className: 'copyright' },
          '\xA9\xA0',
          (0, _time.getCurrentYear)() + ' Opportunity Education. All rights reserved.'
        )
      );
    }
  }]);
  return UnauthenticatedFooter;
}(_react.PureComponent);

exports.default = UnauthenticatedFooter;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AcceptPolicyModalDisconnected = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.mapStateToProps = mapStateToProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _user = __webpack_require__(73);

var _policies = __webpack_require__(158);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AcceptPolicyModal = function (_Component) {
  (0, _inherits3.default)(AcceptPolicyModal, _Component);

  function AcceptPolicyModal(props) {
    (0, _classCallCheck3.default)(this, AcceptPolicyModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AcceptPolicyModal.__proto__ || (0, _getPrototypeOf2.default)(AcceptPolicyModal)).call(this, props));

    _this.onViewOurPoliciesClickBound = _this.onViewOurPoliciesClick.bind(_this);
    _this.onAgreeClickBound = _this.onAgreeClick.bind(_this);
    _this.onDeclineClickBound = _this.onDeclineClick.bind(_this);
    _this.onYesIAmDecliningClickBound = _this.onYesIAmDecliningClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AcceptPolicyModal, [{
    key: 'render',
    value: function render() {
      var userIsConsideringDecliningPolicies = this.props.userIsConsideringDecliningPolicies;

      return _react2.default.createElement(
        'div',
        { id: 'policyAcceptanceModal' },
        _react2.default.createElement(
          'div',
          { className: 'policy-acceptance-modal-container' },
          !userIsConsideringDecliningPolicies && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'AcceptPolcicyModal.ByUsing',
                defaultMessage: 'By using the OE QuestMaker app, you agree to our policies, including the End User Agreement, Privacy Policy, and the Terms and Conditions.'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'view-our-policies',
                onClick: this.onViewOurPoliciesClickBound
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'AcceptPolicyModal.ViewOurPolicies',
                defaultMessage: 'View our policies'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement(
                'div',
                {
                  className: 'agree button active',
                  onClick: this.onAgreeClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'AcceptPolicyModal.Agree',
                  defaultMessage: 'AGREE'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'decline', onClick: this.onDeclineClickBound },
                _messages.decline
              )
            )
          ),
          userIsConsideringDecliningPolicies && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'AcceptPolicyModal.AreYouSure',
                defaultMessage: 'Are you sure you want to decline?'
              })
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'AcceptPolicyModal.ToUse',
                defaultMessage: 'To use the OE QuestMaker app, you must agree to these terms. Close this window to review the terms again, or click "Agree to OE Policies" to accept all of the terms now.'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement(
                'div',
                {
                  className: 'agree button active',
                  onClick: this.onAgreeClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'AcceptPolicyModal.AgreeToOe',
                  defaultMessage: 'AGREE TO OE POLICIES'
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'decline',
                  onClick: this.onYesIAmDecliningClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'AcceptPolicyModal.YesIAmDeclining',
                  defaultMessage: 'YES, I AM DECLINING'
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'onViewOurPoliciesClick',
    value: function onViewOurPoliciesClick() {
      this.props.dispatch((0, _policies.hideAcceptPoliciesModal)());
      this.props.dispatch((0, _policies.userIsNotConsideringDecliningPolicies)());
      this.props.dispatch((0, _reactRouterRedux.push)('/policies'));
    }
  }, {
    key: 'onAgreeClick',
    value: function onAgreeClick() {
      this.props.dispatch((0, _policies.acceptPolicies)());
    }
  }, {
    key: 'onDeclineClick',
    value: function onDeclineClick() {
      this.props.dispatch((0, _policies.userIsConsideringDecliningPolicies)());
    }
  }, {
    key: 'onYesIAmDecliningClick',
    value: function onYesIAmDecliningClick() {
      this.props.dispatch((0, _user.logoutAndRedirect)());
      this.props.dispatch((0, _policies.hideAcceptPoliciesModal)());
      this.props.dispatch((0, _policies.userIsNotConsideringDecliningPolicies)());
    }
  }]);
  return AcceptPolicyModal;
}(_react.Component);

AcceptPolicyModal.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  userIsConsideringDecliningPolicies: _propTypes2.default.bool
};

function mapStateToProps(state) {
  return {
    userIsConsideringDecliningPolicies: state.policies.userIsConsideringDecliningPolicies
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AcceptPolicyModal);
exports.AcceptPolicyModalDisconnected = AcceptPolicyModal; // pure component - used in tests

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _VideoViewer = __webpack_require__(1173);

var _VideoViewer2 = _interopRequireDefault(_VideoViewer);

var _CreateNewCourseModal = __webpack_require__(1184);

var _CreateNewCourseModal2 = _interopRequireDefault(_CreateNewCourseModal);

var _InformativeModal = __webpack_require__(1215);

var _InformativeModal2 = _interopRequireDefault(_InformativeModal);

var _CloseModal = __webpack_require__(1216);

var _CloseModal2 = _interopRequireDefault(_CloseModal);

var _EditCourseModal = __webpack_require__(1217);

var _EditCourseModal2 = _interopRequireDefault(_EditCourseModal);

var _CreateJourneyModal = __webpack_require__(1219);

var _CreateJourneyModal2 = _interopRequireDefault(_CreateJourneyModal);

var _EditJourneyModal = __webpack_require__(1220);

var _EditJourneyModal2 = _interopRequireDefault(_EditJourneyModal);

var _CreateOrEditLevelModal = __webpack_require__(1221);

var _CreateOrEditLevelModal2 = _interopRequireDefault(_CreateOrEditLevelModal);

var _SortLevelOrderModal = __webpack_require__(1222);

var _SortLevelOrderModal2 = _interopRequireDefault(_SortLevelOrderModal);

var _CreateActivityModal = __webpack_require__(1229);

var _CreateActivityModal2 = _interopRequireDefault(_CreateActivityModal);

var _ChangeLevelForActivityModal = __webpack_require__(1230);

var _ChangeLevelForActivityModal2 = _interopRequireDefault(_ChangeLevelForActivityModal);

var _AddOrRemoveActivityIconModal = __webpack_require__(1231);

var _AddOrRemoveActivityIconModal2 = _interopRequireDefault(_AddOrRemoveActivityIconModal);

var _AddOrEditMentorFile = __webpack_require__(1323);

var _AddOrEditMentorFile2 = _interopRequireDefault(_AddOrEditMentorFile);

var _GeneralErrorModal = __webpack_require__(1324);

var _GeneralErrorModal2 = _interopRequireDefault(_GeneralErrorModal);

var _AddResourceModal = __webpack_require__(1325);

var _AddResourceModal2 = _interopRequireDefault(_AddResourceModal);

var _EditResourceModal = __webpack_require__(1340);

var _EditResourceModal2 = _interopRequireDefault(_EditResourceModal);

var _DeleteResourceModal = __webpack_require__(1341);

var _DeleteResourceModal2 = _interopRequireDefault(_DeleteResourceModal);

var _PublishActivityModal = __webpack_require__(1342);

var _PublishActivityModal2 = _interopRequireDefault(_PublishActivityModal);

var _EditPublishedActivityModal = __webpack_require__(1343);

var _EditPublishedActivityModal2 = _interopRequireDefault(_EditPublishedActivityModal);

var _PublishJourneyModal = __webpack_require__(1344);

var _PublishJourneyModal2 = _interopRequireDefault(_PublishJourneyModal);

var _StarterCourseModal = __webpack_require__(1345);

var _StarterCourseModal2 = _interopRequireDefault(_StarterCourseModal);

var _StarterJourneyModal = __webpack_require__(1351);

var _StarterJourneyModal2 = _interopRequireDefault(_StarterJourneyModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_COMPONENTS = {
  GENERAL_ERROR_MODAL: _GeneralErrorModal2.default,
  VIDEO_VIEWER: _VideoViewer2.default,
  STARTER_COURSE_MODAL: _StarterCourseModal2.default,
  CREATE_NEW_COURSE_MODAL: _CreateNewCourseModal2.default,
  INFORMATIVE_MODAL: _InformativeModal2.default,
  CLOSE_MODAL: _CloseModal2.default,
  EDIT_COURSE_MODAL: _EditCourseModal2.default,
  STARTER_JOURNEY_MODAL: _StarterJourneyModal2.default,
  CREATE_JOURNEY_MODAL: _CreateJourneyModal2.default,
  EDIT_JOURNEY_MODAL: _EditJourneyModal2.default,
  CREATE_OR_EDIT_LEVEL_MODAL: _CreateOrEditLevelModal2.default,
  SORT_LEVEL_ORDER_MODAL: _SortLevelOrderModal2.default,
  CREATE_ACTIVITY_MODAL: _CreateActivityModal2.default,
  CHANGE_LEVEL_FOR_ACTIVITY_MODAL: _ChangeLevelForActivityModal2.default,
  ADD_OR_REMOVE_ACTIVITY_ICON_MODAL: _AddOrRemoveActivityIconModal2.default,
  ADD_OR_EDIT_MENTOR_FILE: _AddOrEditMentorFile2.default,
  ADD_RESOURCE_MODAL: _AddResourceModal2.default,
  EDIT_RESOURCE_MODAL: _EditResourceModal2.default,
  DELETE_RESOURCE_MODAL: _DeleteResourceModal2.default,
  PUBLISH_ACTIVITY_MODAL: _PublishActivityModal2.default,
  EDIT_PUBLISHED_ACTIVITY_MODAL: _EditPublishedActivityModal2.default,
  PUBLISH_JOURNEY_MODAL: _PublishJourneyModal2.default

};

var ModalContainer = function ModalContainer(_ref) {
  var modalType = _ref.modalType,
      modalProps = _ref.modalProps;

  if (!modalType) {
    return null;
  }

  var SpecificModal = MODAL_COMPONENTS[modalType];
  return _react2.default.createElement(SpecificModal, modalProps);
};

ModalContainer.propTypes = {
  modalType: _propTypes2.default.string,
  modalProps: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return state.modal;
})(ModalContainer);

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoViewerDisconnected = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  margin: 0 auto;\n  width: 1024px;\n  height: auto;\n  padding: 25px 0;\n'], ['\n  position: relative;\n  margin: 0 auto;\n  width: 1024px;\n  height: auto;\n  padding: 25px 0;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-align: left;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-align: left;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin: 0 auto;\n  width: 1024px;\n  height: auto;\n  padding: 25px 0 50px;\n  text-align: left;\n'], ['\n  margin: 0 auto;\n  width: 1024px;\n  height: auto;\n  padding: 25px 0 50px;\n  text-align: left;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  right: 0;\n  top: 50%;\n  height: 18px;\n  width: 18px;\n  background: no-repeat url(', ');\n  background-size: contain;\n  cursor: pointer;\n  transform: translateY(-50%);\n  transition: 0.4s all;\n\n  &:hover {\n    background: no-repeat url(', ');\n    background-size: contain;\n  }\n'], ['\n  position: absolute;\n  right: 0;\n  top: 50%;\n  height: 18px;\n  width: 18px;\n  background: no-repeat url(', ');\n  background-size: contain;\n  cursor: pointer;\n  transform: translateY(-50%);\n  transition: 0.4s all;\n\n  &:hover {\n    background: no-repeat url(', ');\n    background-size: contain;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactPlayer = __webpack_require__(1174);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _H3 = __webpack_require__(111);

var _H4 = _interopRequireDefault(_H3);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _close = __webpack_require__(587);

var _close2 = _interopRequireDefault(_close);

var _close_hover = __webpack_require__(588);

var _close_hover2 = _interopRequireDefault(_close_hover);

var _modal = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopContainer = _styledComponents2.default.div.withConfig({
  displayName: 'VideoViewer__TopContainer',
  componentId: 'edv398-0'
})(_templateObject);

var InfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'VideoViewer__InfoContainer',
  componentId: 'edv398-1'
})(_templateObject2);

var ResourceInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'VideoViewer__ResourceInfoContainer',
  componentId: 'edv398-2'
})(_templateObject3);

var Close = _styledComponents2.default.div.withConfig({
  displayName: 'VideoViewer__Close',
  componentId: 'edv398-3'
})(_templateObject4, _close2.default, _close_hover2.default);

var VideoViewer = function (_Component) {
  (0, _inherits3.default)(VideoViewer, _Component);

  function VideoViewer() {
    (0, _classCallCheck3.default)(this, VideoViewer);
    return (0, _possibleConstructorReturn3.default)(this, (VideoViewer.__proto__ || (0, _getPrototypeOf2.default)(VideoViewer)).apply(this, arguments));
  }

  (0, _createClass3.default)(VideoViewer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          resource = _props.resource,
          activity = _props.activity,
          quest = _props.quest,
          dispatch = _props.dispatch;


      return _react2.default.createElement(
        _Modal2.default,
        {
          width: 1400,
          percentHeight: 100,
          background: '#243646',
          opacity: '.9',
          allowInnerScroll: true,
          closeCallback: function closeCallback() {
            return dispatch((0, _modal.hideModal)('VIDEO_VIEWER'));
          }
        },
        _react2.default.createElement(
          'div',
          { style: { height: 'auto' } },
          _react2.default.createElement(
            TopContainer,
            null,
            _react2.default.createElement(
              InfoContainer,
              null,
              _react2.default.createElement(_QuestIcon2.default, {
                heightWidth: 40,
                icon_image_url: quest.icon_image_url,
                showTypeIcon: quest.type && Boolean(quest.type.id),
                questTypeId: quest.type ? quest.type.id : null,
                questTypeIconSize: 14
              }),
              _react2.default.createElement(
                'div',
                { style: { width: '850px', marginLeft: '15px' } },
                _react2.default.createElement(
                  _H4.default,
                  { className: 'text-truncate', style: { color: '#ffffff' } },
                  quest.name
                ),
                _react2.default.createElement(
                  _P2.default,
                  { className: 'text-truncate', style: { color: '#ffffff' } },
                  'Activity ',
                  this.getActivityNumber(),
                  ': ',
                  activity.name
                )
              ),
              _react2.default.createElement(Close, { onClick: function onClick() {
                  return dispatch((0, _modal.hideModal)('VIDEO_VIEWER'));
                } })
            )
          ),
          _react2.default.createElement(_reactPlayer2.default, {
            url: resource.url,
            playing: true,
            controls: true,
            playsinline: true,
            width: 1024,
            height: 624,
            style: {
              margin: '0 auto'
            },
            config: {
              youtube: this.getYouTubeConfig()
            }
          }),
          _react2.default.createElement(
            ResourceInfoContainer,
            null,
            _react2.default.createElement(
              _H2.default,
              { style: { color: '#ffffff' } },
              resource.name
            ),
            _react2.default.createElement(
              _P2.default,
              { style: { marginTop: '20px', color: '#ffffff' } },
              resource.description
            )
          )
        )
      );
    }
  }, {
    key: 'getActivityNumber',
    value: function getActivityNumber() {
      var _props2 = this.props,
          activities = _props2.activities,
          activity = _props2.activity;

      var index = activities.findIndex(function (a) {
        return a.id === activity.id;
      }) + 1;
      // depending on where this component is implemented
      return index > 0 ? index : activities.findIndex(function (a) {
        return a.id === activity.id;
      }) + 1;
    }
  }, {
    key: 'getYouTubeConfig',
    value: function getYouTubeConfig() {
      var resource = this.props.resource;

      var config = {
        playerVars: {
          rel: 0,
          iv_load_policy: 3,
          showinfo: 0
        }
      };

      if (resource.start_time) {
        config.playerVars.start = resource.start_time;
      }

      if (resource.end_time) {
        config.playerVars.end = resource.end_time;
      }

      return config;
    }
  }]);
  return VideoViewer;
}(_react.Component);

VideoViewer.propTypes = {
  closeCallback: _propTypes2.default.func,
  activity: _propTypes2.default.object,
  resource: _propTypes2.default.object,
  quest: _propTypes2.default.object,
  dispatch: _propTypes2.default.func,
  activities: _propTypes2.default.array
};

exports.default = (0, _reactRedux.connect)()(VideoViewer);
exports.VideoViewerDisconnected = VideoViewer;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FilePlayer", {
  enumerable: true,
  get: function get() {
    return _FilePlayer["default"];
  }
});
Object.defineProperty(exports, "YouTube", {
  enumerable: true,
  get: function get() {
    return _YouTube["default"];
  }
});
Object.defineProperty(exports, "SoundCloud", {
  enumerable: true,
  get: function get() {
    return _SoundCloud["default"];
  }
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _Vimeo["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "Streamable", {
  enumerable: true,
  get: function get() {
    return _Streamable["default"];
  }
});
Object.defineProperty(exports, "Wistia", {
  enumerable: true,
  get: function get() {
    return _Wistia["default"];
  }
});
Object.defineProperty(exports, "Twitch", {
  enumerable: true,
  get: function get() {
    return _Twitch["default"];
  }
});
Object.defineProperty(exports, "DailyMotion", {
  enumerable: true,
  get: function get() {
    return _DailyMotion["default"];
  }
});
Object.defineProperty(exports, "Mixcloud", {
  enumerable: true,
  get: function get() {
    return _Mixcloud["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _props = __webpack_require__(308);

var _utils = __webpack_require__(91);

var _players = _interopRequireDefault(__webpack_require__(1177));

var _Player4 = _interopRequireDefault(__webpack_require__(411));

var _Preview = _interopRequireDefault(__webpack_require__(1178));

var _FilePlayer = _interopRequireWildcard(__webpack_require__(585));

var _preload = _interopRequireDefault(__webpack_require__(1179));

var _YouTube = _interopRequireDefault(__webpack_require__(410));

var _SoundCloud = _interopRequireDefault(__webpack_require__(412));

var _Vimeo = _interopRequireDefault(__webpack_require__(413));

var _Facebook = _interopRequireDefault(__webpack_require__(580));

var _Streamable = _interopRequireDefault(__webpack_require__(581));

var _Wistia = _interopRequireDefault(__webpack_require__(582));

var _Twitch = _interopRequireDefault(__webpack_require__(583));

var _DailyMotion = _interopRequireDefault(__webpack_require__(414));

var _Mixcloud = _interopRequireDefault(__webpack_require__(584));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SUPPORTED_PROPS = Object.keys(_props.propTypes);
var customPlayers = [];

var ReactPlayer = /*#__PURE__*/function (_Component) {
  _inherits(ReactPlayer, _Component);

  var _super = _createSuper(ReactPlayer);

  function ReactPlayer() {
    var _this;

    _classCallCheck(this, ReactPlayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPreview: !!_this.props.light
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickPreview", function () {
      _this.setState({
        showPreview: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showPreview", function () {
      _this.setState({
        showPreview: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    });

    _defineProperty(_assertThisInitialized(_this), "getSecondsLoaded", function () {
      if (!_this.player) return null;
      return _this.player.getSecondsLoaded();
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'player';
      if (!_this.player) return null;
      return _this.player.getInternalPlayer(key);
    });

    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction, type) {
      if (!_this.player) return null;

      _this.player.seekTo(fraction, type);
    });

    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      _this.props.onReady(_assertThisInitialized(_this));
    });

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
      _this.wrapper = wrapper;
    });

    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
      _this.player = player;
    });

    return _this;
  }

  _createClass(ReactPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.progressFrequency) {
        var message = 'ReactPlayer: %cprogressFrequency%c is deprecated, please use %cprogressInterval%c instead';
        console.warn(message, 'font-weight: bold', '', 'font-weight: bold', '');
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utils.isEqual)(this.props, nextProps) || !(0, _utils.isEqual)(this.state, nextState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var light = this.props.light;
      this.config = (0, _utils.getConfig)(this.props, _props.defaultProps);

      if (!prevProps.light && light) {
        this.setState({
          showPreview: true
        });
      }

      if (prevProps.light && !light) {
        this.setState({
          showPreview: false
        });
      }
    }
  }, {
    key: "getActivePlayer",
    value: function getActivePlayer(url) {
      for (var _i = 0, _arr = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i < _arr.length; _i++) {
        var _Player = _arr[_i];

        if (_Player.canPlay(url)) {
          return _Player;
        }
      } // Fall back to FilePlayer if nothing else can play the URL


      return _FilePlayer.FilePlayer;
    }
  }, {
    key: "renderActivePlayer",
    value: function renderActivePlayer(url, activePlayer) {
      if (!url) return null;
      return /*#__PURE__*/_react["default"].createElement(_Player4["default"], _extends({}, this.props, {
        key: activePlayer.displayName,
        ref: this.activePlayerRef,
        config: this.config,
        activePlayer: activePlayer,
        onReady: this.handleReady
      }));
    }
  }, {
    key: "sortPlayers",
    value: function sortPlayers(a, b) {
      // Retain player order to prevent weird iframe behaviour when switching players
      if (a && b) {
        return a.key < b.key ? -1 : 1;
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          controls = _this$props.controls,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height,
          light = _this$props.light,
          playIcon = _this$props.playIcon,
          Wrapper = _this$props.wrapper;
      var showPreview = this.state.showPreview && url;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.getActivePlayer(url);
      var renderedActivePlayer = this.renderActivePlayer(url, activePlayer);
      var preloadPlayers = (0, _preload["default"])(url, controls, this.config);
      var players = [renderedActivePlayer].concat(_toConsumableArray(preloadPlayers)).sort(this.sortPlayers);

      var preview = /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
        url: url,
        light: light,
        playIcon: playIcon,
        onClick: this.handleClickPreview
      });

      return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
        ref: this.wrapperRef,
        style: _objectSpread({}, style, {
          width: width,
          height: height
        })
      }, otherProps), showPreview ? preview : players);
    }
  }]);

  return ReactPlayer;
}(_react.Component);

exports["default"] = ReactPlayer;

_defineProperty(ReactPlayer, "addCustomPlayer", function (player) {
  customPlayers.push(player);
});

_defineProperty(ReactPlayer, "removeCustomPlayers", function () {
  customPlayers = [];
});

_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');

_defineProperty(ReactPlayer, "propTypes", _props.propTypes);

_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);

_defineProperty(ReactPlayer, "canPlay", function (url) {
  for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i2 < _arr2.length; _i2++) {
    var _Player2 = _arr2[_i2];

    if (_Player2.canPlay(url)) {
      return true;
    }
  }

  return false;
});

_defineProperty(ReactPlayer, "canEnablePIP", function (url) {
  for (var _i3 = 0, _arr3 = [].concat(_toConsumableArray(customPlayers), _toConsumableArray(_players["default"])); _i3 < _arr3.length; _i3++) {
    var _Player3 = _arr3[_i3];

    if (_Player3.canEnablePIP && _Player3.canEnablePIP(url)) {
      return true;
    }
  }

  return false;
});

/***/ }),
/* 1175 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _YouTube = __webpack_require__(410);

var _SoundCloud = __webpack_require__(412);

var _Vimeo = __webpack_require__(413);

var _Facebook = __webpack_require__(580);

var _Streamable = __webpack_require__(581);

var _Wistia = __webpack_require__(582);

var _Twitch = __webpack_require__(583);

var _DailyMotion = __webpack_require__(414);

var _Mixcloud = __webpack_require__(584);

var _FilePlayer = __webpack_require__(585);

var _default = [_YouTube.YouTube, _SoundCloud.SoundCloud, _Vimeo.Vimeo, _Facebook.Facebook, _Streamable.Streamable, _Wistia.Wistia, _Twitch.Twitch, _DailyMotion.DailyMotion, _Mixcloud.Mixcloud, _FilePlayer.FilePlayer];
exports["default"] = _default;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ICON_SIZE = '64px';

var Preview = /*#__PURE__*/function (_Component) {
  _inherits(Preview, _Component);

  var _super = _createSuper(Preview);

  function Preview() {
    var _this;

    _classCallCheck(this, Preview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      image: null
    });

    return _this;
  }

  _createClass(Preview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchImage(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          url = _this$props.url,
          light = _this$props.light;

      if (prevProps.url !== url || prevProps.light !== light) {
        this.fetchImage(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "fetchImage",
    value: function fetchImage(_ref) {
      var _this2 = this;

      var url = _ref.url,
          light = _ref.light;

      if (typeof light === 'string') {
        this.setState({
          image: light
        });
        return;
      }

      this.setState({
        image: null
      });
      return window.fetch("https://noembed.com/embed?url=".concat(url)).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.thumbnail_url && _this2.mounted) {
          var image = data.thumbnail_url.replace('height=100', 'height=480');

          _this2.setState({
            image: image
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          playIcon = _this$props2.playIcon;
      var image = this.state.image;
      var flexCenter = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
      var styles = {
        preview: _objectSpread({
          width: '100%',
          height: '100%',
          backgroundImage: image ? "url(".concat(image, ")") : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          cursor: 'pointer'
        }, flexCenter),
        shadow: _objectSpread({
          background: 'radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)',
          borderRadius: ICON_SIZE,
          width: ICON_SIZE,
          height: ICON_SIZE
        }, flexCenter),
        playIcon: {
          borderStyle: 'solid',
          borderWidth: '16px 0 16px 26px',
          borderColor: 'transparent transparent transparent white',
          marginLeft: '7px'
        }
      };

      var defaultPlayIcon = /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.shadow,
        className: "react-player__shadow"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.playIcon,
        className: "react-player__play-icon"
      }));

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.preview,
        className: "react-player__preview",
        onClick: onClick
      }, playIcon || defaultPlayIcon);
    }
  }]);

  return Preview;
}(_react.Component);

exports["default"] = Preview;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = renderPreloadPlayers;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Player = _interopRequireDefault(__webpack_require__(411));

var _YouTube = __webpack_require__(410);

var _SoundCloud = __webpack_require__(412);

var _Vimeo = __webpack_require__(413);

var _DailyMotion = __webpack_require__(414);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var PRELOAD_PLAYERS = [{
  Player: _YouTube.YouTube,
  configKey: 'youtube',
  url: 'https://www.youtube.com/watch?v=GlCmAC4MHek'
}, {
  Player: _SoundCloud.SoundCloud,
  configKey: 'soundcloud',
  url: 'https://soundcloud.com/seucheu/john-cage-433-8-bit-version'
}, {
  Player: _Vimeo.Vimeo,
  configKey: 'vimeo',
  url: 'https://vimeo.com/300970506'
}, {
  Player: _DailyMotion.DailyMotion,
  configKey: 'dailymotion',
  url: 'http://www.dailymotion.com/video/xqdpyk'
}];

function renderPreloadPlayers(url, controls, config) {
  var players = [];

  var _iterator = _createForOfIteratorHelper(PRELOAD_PLAYERS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var player = _step.value;

      if (!player.Player.canPlay(url) && config[player.configKey].preload) {
        players.push( /*#__PURE__*/_react["default"].createElement(_Player["default"], {
          key: player.Player.displayName,
          activePlayer: player.Player,
          url: player.url,
          controls: controls,
          playing: true,
          muted: true,
          display: "none"
        }));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return players;
}

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1MC4yICg1NTA0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+M0JBNURBNUQtRTE3Qi00RTc2LUIxQjItMTE0QTIwMjkwRjYwPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJbUU1dLVF1ZXN0LVR5cGUtSWNvbnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLjAtUXVlc3QtVHlwZS1TZWxlY3Rpb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDUuMDAwMDAwLCAtODA2LjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX3ByYWN0aWNlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDYuMDAwMDAwLCA4MDcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJQYXRoIiBzdHJva2U9IiNGRkZGRkYiIGZpbGw9IiNCQkJCQkIiIGN4PSIxMiIgY3k9IjEyIiByPSIxMiI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiNGRkZGRkYiIHg9IjEzIiB5PSIxMyIgd2lkdGg9IjciIGhlaWdodD0iNCIgcng9IjAuNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRkZGRkZGIiB4PSI0IiB5PSIxMyIgd2lkdGg9IjciIGhlaWdodD0iNCIgcng9IjAuNiI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRkZGRkZGIiB4PSI4IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSI0IiByeD0iMC42Ij48L3JlY3Q+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _SelectorComponent = __webpack_require__(245);

var _SelectorComponent2 = _interopRequireDefault(_SelectorComponent);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _API = __webpack_require__(98);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _util = __webpack_require__(114);

var _PopoverPicker = __webpack_require__(596);

var _reactRouterRedux = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateNewCourseModal__ModalContainer',
  componentId: 'sc-77eltp-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateNewCourseModal__HeaderContainer',
  componentId: 'sc-77eltp-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateNewCourseModal__MainContainer',
  componentId: 'sc-77eltp-2'
})(_templateObject3);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateNewCourseModal__FlexContainer',
  componentId: 'sc-77eltp-3'
})(_templateObject4);

var CreateNewCourseModal = function CreateNewCourseModal(_ref) {
  var apiData = _ref.apiData,
      frameworkSubjects = _ref.frameworkSubjects,
      gradeLevels = _ref.gradeLevels,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      selectedCourse = _ref.selectedCourse;


  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isMutating = _useState2[0],
      setIsMutating = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      isError = _useState4[0],
      setIsError = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      selectedCourseLevel = _useState6[0],
      setSelectedCourseLevel = _useState6[1];

  var handleSelectedCourseLevel = function handleSelectedCourseLevel(e) {
    setSelectedCourseLevel(e);
  };

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      selectedFrameworkSubject = _useState8[0],
      setSelectedFrameworkSubject = _useState8[1];

  var handleSelectedFrameworkSubject = function handleSelectedFrameworkSubject(e) {
    setSelectedFrameworkSubject(e);
  };

  var _useState9 = (0, _react.useState)(''),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      courseName = _useState10[0],
      setCourseName = _useState10[1];

  var handleCourseName = function handleCourseName(e) {
    setCourseName(e.target.value);
  };

  var _useState11 = (0, _react.useState)(''),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      abbreviation = _useState12[0],
      setAbbreviation = _useState12[1];

  var handleAbbreviation = function handleAbbreviation(e) {
    setAbbreviation(e.target.value);
  };

  var _useState13 = (0, _react.useState)(''),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      courseColor = _useState14[0],
      setCourseColor = _useState14[1];

  (0, _react.useEffect)(function () {
    // Prefill with the copied course if user chose to create a course from an existing one (only carrying over 'Course name' preceded with 'copy of' and 'Abbreviation'
    if (selectedCourse) {
      // const currentCourseLevel = gradeLevels.filter((level) => level.id === selectedCourse.grade_level_id)
      // setSelectedCourseLevel(currentCourseLevel[0])
      //
      // const currentFrameworkSubject = frameworkSubjects.filter(
      //   (subject) => subject.id === selectedCourse.framework_subject_id
      // )
      // setSelectedFrameworkSubject(currentFrameworkSubject[0])

      setCourseName('Copy of ' + selectedCourse.name);

      setAbbreviation(selectedCourse.abbreviation);

      // setCourseColor('#' + selectedCourse.color)
    }
  }, []);

  var isValidColor = function isValidColor(colorName) {
    return colorName.match(/^#[a-f0-9]{6}$/i) !== null;
  };

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var couldSaveData = selectedCourseLevel !== null && selectedFrameworkSubject !== null && courseName.length > 0 && abbreviation.length > 0 && abbreviation.length <= 3 && isValidColor(courseColor === '' ? '#4E6C83' : courseColor);

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var selectedCourseLevel = _ref2.selectedCourseLevel,
        selectedFrameworkSubject = _ref2.selectedFrameworkSubject,
        courseName = _ref2.courseName,
        abbreviation = _ref2.abbreviation,
        courseColor = _ref2.courseColor,
        selectedAcademicYearId = _ref2.selectedAcademicYearId;
    return (0, _API.createNewCourse)(apiData, selectedCourseLevel, selectedFrameworkSubject, courseName, abbreviation, courseColor ? (0, _util.cleanColor)(courseColor) : '4E6C84', selectedAcademicYearId);
  });
  var cloneMutation = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        masterCourseId = _ref3.masterCourseId;
    return (0, _API.cloneMasterCourse)(apiData, masterCourseId, selectedAcademicYearId, courseName, abbreviation, courseColor ? (0, _util.cleanColor)(courseColor) : '4E6C84', selectedFrameworkSubject.id, selectedCourseLevel.id);
  });
  var editMutation = (0, _reactQuery.useMutation)(function (_ref4) {
    var courseName = _ref4.courseName,
        abbreviation = _ref4.abbreviation,
        courseColor = _ref4.courseColor,
        selectedAcademicYearId = _ref4.selectedAcademicYearId,
        activityCourse = _ref4.activityCourse;
    return (0, _API.editMentorActivityCourse)(apiData, courseName, abbreviation, courseColor, activityCourse, selectedAcademicYearId);
  });
  var handleSaveCourse = function handleSaveCourse() {
    if (couldSaveData && selectedCourse) {
      setIsError(null);
      setIsMutating(true);
      cloneMutation.mutate({
        apiData: apiData,
        masterCourseId: selectedCourse.id,
        academicYearId: selectedAcademicYearId,
        courseName: courseName,
        abbreviation: abbreviation ? abbreviation : selectedCourse.abbreviation,
        color: courseColor === '' ? '4E6C84' : (0, _util.cleanColor)(courseColor),
        frameworkSubjectId: selectedFrameworkSubject ? selectedFrameworkSubject.id : selectedCourse.framework_subject_id,
        gradeLevelId: selectedCourseLevel ? selectedCourseLevel.id : selectedCourse.grade_level_id
      }, {
        onSuccess: function onSuccess(data) {
          editMutation.mutate({
            courseName: courseName,
            abbreviation: abbreviation,
            courseColor: courseColor === '' ? '4E6C84' : (0, _util.cleanColor)(courseColor),
            selectedAcademicYearId: selectedAcademicYearId,
            activityCourse: data
          }, {
            onSuccess: function onSuccess() {
              queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
              setTimeout(function () {
                setIsMutating(false);
                handleCloseModal();
              }, 300);
            }
          });
          setIsMutating(false);
          dispatch((0, _modal.hideModal)());
          queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
        },
        onError: function onError(error) {
          setIsMutating(false);
          setIsError(error);
          console.log(error);
          dispatch((0, _modal.hideModal)());
          dispatch((0, _reactRouterRedux.push)('/error'));
        }
      });
    } else if (couldSaveData && !selectedCourse) {
      setIsMutating(true);
      setIsError(null);
      createMutation.mutate({
        selectedCourseLevel: selectedCourseLevel,
        selectedFrameworkSubject: selectedFrameworkSubject,
        courseName: courseName,
        abbreviation: abbreviation,
        courseColor: courseColor === '' ? '4E6C84' : (0, _util.cleanColor)(courseColor),
        selectedAcademicYearId: selectedAcademicYearId
      }, {
        onSuccess: function onSuccess(data) {
          if (data.academic_year_id === selectedAcademicYearId) {
            queryClient.setQueryData(['mentor-master-courses-' + selectedAcademicYearId], function (courses) {
              var newCourses = [].concat((0, _toConsumableArray3.default)(courses));
              newCourses.push((0, _assign2.default)({}, data, { just_created: true }));
              return newCourses;
            });
          }

          setTimeout(function () {
            setIsMutating(false);
            handleCloseModal();
          }, 300);
        },
        onError: function onError(error) {
          setIsMutating(false);
          setIsError(error);
          console.log(error);
          dispatch((0, _modal.hideModal)());
          dispatch((0, _reactRouterRedux.push)('/error'));
        }
      });
    }
  };
  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          '+ Create Course'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: handleCloseModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'createCourseTooltip',
              'data-tip': 'Please enter all required fields prior to creating this course.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Create',
              handleClick: handleSaveCourse,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              isMutating: isMutating,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'createCourseTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_SelectorComponent2.default, {
          placeholder: 'Course Level',
          handleSelectedValueChange: handleSelectedCourseLevel,
          selectedValue: selectedCourseLevel,
          options: gradeLevels.filter(function (gl) {
            return gl.available_for_activity_courses === true;
          }),
          shouldDisplayAsterisk: true
        }),
        _react2.default.createElement(_SelectorComponent2.default, {
          placeholder: 'Framework Subject',
          handleSelectedValueChange: handleSelectedFrameworkSubject,
          selectedValue: selectedFrameworkSubject,
          options: frameworkSubjects.filter(function (fS) {
            return fS.framework_type === 'activity_courses';
          }),
          shouldDisplayAsterisk: true
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Course Name',
          placeholder: 'Course Name',
          hintText: 'Example: Spanish 2, Art 1, Psychology',
          handleEnteredTextValue: handleCourseName,
          value: courseName,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Abbreviation',
          placeholder: 'Abbreviation',
          hintText: 'Must be no more than 3 letters. Example: Sp1, Psy, Ar1',
          handleEnteredTextValue: handleAbbreviation,
          value: abbreviation,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Course Color Hex Code',
            placeholder: 'Course Color Hex Code',
            hintText: 'If left empty, #4e6c84 will be applied.'
            // cannot choose a hex code to respect color accessibility.
            // handleEnteredTextValue={handleCourseColor}
            , value: courseColor,
            shouldDisplayAsteriskSymbol: false
          }),
          _react2.default.createElement(_PopoverPicker.PopoverPicker, { color: courseColor === '' ? '#4e6c84' : (0, _util.cleanHexCode)(courseColor), onChange: setCourseColor })
        )
      )
    )
  );
};

CreateNewCourseModal.propTypes = {
  closeCallback: _propTypes2.default.func,
  activity: _propTypes2.default.object,
  resource: _propTypes2.default.object,
  quest: _propTypes2.default.object,
  activities: _propTypes2.default.array,
  selectedAcademicYearId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(CreateNewCourseModal);

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1186), __esModule: true };

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
__webpack_require__(223);
module.exports = __webpack_require__(1187);


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(356);
var ITERATOR = __webpack_require__(82)('iterator');
var Iterators = __webpack_require__(194);
module.exports = __webpack_require__(43).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1189), __esModule: true };

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
__webpack_require__(223);
module.exports = __webpack_require__(1190);


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(119);
var get = __webpack_require__(355);
module.exports = __webpack_require__(43).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultSelectComponent = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultSelectComponent = exports.DefaultSelectComponent = function DefaultSelectComponent(_ref) {
  var options = _ref.options,
      handleSelectedValueChange = _ref.handleSelectedValueChange,
      selectedValue = _ref.selectedValue,
      placeholder = _ref.placeholder;

  var mapList = function mapList(AY) {
    var options = (0, _arraySort2.default)(AY.map(function (ay) {
      return {
        label: ay.name,
        name: ay.name,
        id: ay.id,
        sort_order: ay.sort_order
      };
    }));
    return options.filter(function (el) {
      return el !== false;
    });
  };

  var mappedOptions = options !== undefined && mapList(options);

  return _react2.default.createElement(
    'div',
    { style: { marginBottom: '20px' } },
    _react2.default.createElement(_reactSelect2.default, {
      className: 'course-builder-select',
      options: mappedOptions,
      onChange: handleSelectedValueChange,
      value: selectedValue !== null && mappedOptions.find(function (st) {
        return st.id === selectedValue.id;
      }),
      clearable: false,
      placeholder: placeholder,
      searchable: false
    })
  );
};

DefaultSelectComponent.propTypes = {
  options: _propTypes2.default.array.isRequired,
  handleSelectedValueChange: _propTypes2.default.func.isRequired,
  selectedValue: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

exports.default = DefaultSelectComponent;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);
var createClass = __webpack_require__(58);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputRef: PropTypes.func, // ref callback for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
		if (typeof this.props.inputRef === 'function') {
			this.props.inputRef(el);
		}
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (!this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		delete inputProps.inputRef;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('style', { dangerouslySetInnerHTML: {
					__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
				} }),
			React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(68);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(590);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _propTypes2['default'].bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2['default'].any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2['default'].func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2['default'].bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2['default'].bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _propTypes2['default'].oneOfType([// replaces the placeholder while options are loading
	_propTypes2['default'].string, _propTypes2['default'].node]),
	loadOptions: _propTypes2['default'].func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	multi: _propTypes2['default'].bool, // multi-value input
	options: _propTypes2['default'].array.isRequired, // array of options
	placeholder: _propTypes2['default'].oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2['default'].string, _propTypes2['default'].node]),
	noResultsText: _propTypes2['default'].oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
	searchPromptText: _propTypes2['default'].oneOfType([// label to prompt for search input
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onInputChange: _propTypes2['default'].func, // optional for keeping track of what is being typed
	value: _propTypes2['default'].any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
}
module.exports = exports['default'];

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Select = __webpack_require__(68);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = (0, _createReactClass2['default'])({
	displayName: 'AsyncCreatableSelect',

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								_this.select = ref;
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(68);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(589);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(591);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = (0, _createReactClass2['default'])({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2['default'].func,

		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2['default'].any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2['default'].func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2['default'].func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2['default'].any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2['default'].func,

		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2['default'].func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2['default'].func,

		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2['default'].func,

		// See Select.propTypes.options
		options: _propTypes2['default'].array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2['default'].func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2['default'].func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(76);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = (0, _createReactClass2['default'])({
	propTypes: {
		children: _propTypes2['default'].node,
		className: _propTypes2['default'].string, // className (based on mouse position)
		instancePrefix: _propTypes2['default'].string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2['default'].bool, // the option is disabled
		isFocused: _propTypes2['default'].bool, // the option is focused
		isSelected: _propTypes2['default'].bool, // the option is selected
		onFocus: _propTypes2['default'].func, // method to handle mouseEnter on option element
		onSelect: _propTypes2['default'].func, // method to handle click on option element
		onUnfocus: _propTypes2['default'].func, // method to handle mouseLeave on option element
		option: _propTypes2['default'].object.isRequired, // object that is base for that option
		optionIndex: _propTypes2['default'].number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(76);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = (0, _createReactClass2['default'])({

	displayName: 'Value',

	propTypes: {
		children: _propTypes2['default'].node,
		disabled: _propTypes2['default'].bool, // disabled prop passed to ReactSelect
		id: _propTypes2['default'].string, // Unique id for the value - used for aria
		onClick: _propTypes2['default'].func, // method to handle click on value label
		onRemove: _propTypes2['default'].func, // method to handle removal of the value
		value: _propTypes2['default'].object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*global require,module*/

var CodeMirror = __webpack_require__(113);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(592);
__webpack_require__(594);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(593);
var CodeMirrorSpellChecker = __webpack_require__(1208);
var marked = __webpack_require__(1211);


// Some variables
var isMac = /Mac/.test(navigator.platform);

// Mapping of actions that can be bound to keyboard shortcuts or toolbar buttons
var bindings = {
	"toggleBold": toggleBold,
	"toggleItalic": toggleItalic,
	"drawLink": drawLink,
	"toggleHeadingSmaller": toggleHeadingSmaller,
	"toggleHeadingBigger": toggleHeadingBigger,
	"drawImage": drawImage,
	"toggleBlockquote": toggleBlockquote,
	"toggleOrderedList": toggleOrderedList,
	"toggleUnorderedList": toggleUnorderedList,
	"toggleCodeBlock": toggleCodeBlock,
	"togglePreview": togglePreview,
	"toggleStrikethrough": toggleStrikethrough,
	"toggleHeading1": toggleHeading1,
	"toggleHeading2": toggleHeading2,
	"toggleHeading3": toggleHeading3,
	"cleanBlock": cleanBlock,
	"drawTable": drawTable,
	"drawHorizontalRule": drawHorizontalRule,
	"undo": undo,
	"redo": redo,
	"toggleSideBySide": toggleSideBySide,
	"toggleFullScreen": toggleFullScreen
};

var shortcuts = {
	"toggleBold": "Cmd-B",
	"toggleItalic": "Cmd-I",
	"drawLink": "Cmd-K",
	"toggleHeadingSmaller": "Cmd-H",
	"toggleHeadingBigger": "Shift-Cmd-H",
	"cleanBlock": "Cmd-E",
	"drawImage": "Cmd-Alt-I",
	"toggleBlockquote": "Cmd-'",
	"toggleOrderedList": "Cmd-Alt-L",
	"toggleUnorderedList": "Cmd-L",
	"toggleCodeBlock": "Cmd-Alt-C",
	"togglePreview": "Cmd-P",
	"toggleSideBySide": "F9",
	"toggleFullScreen": "F11"
};

var getBindingName = function(f) {
	for(var key in bindings) {
		if(bindings[key] === f) {
			return key;
		}
	}
	return null;
};

var isMobile = function() {
	var check = false;
	(function(a) {
		if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};


/**
 * Fix shortcut. Mac use Command, others use Ctrl.
 */
function fixShortcut(name) {
	if(isMac) {
		name = name.replace("Ctrl", "Cmd");
	} else {
		name = name.replace("Cmd", "Ctrl");
	}
	return name;
}


/**
 * Create icon element for toolbar.
 */
function createIcon(options, enableTooltips, shortcuts) {
	options = options || {};
	var el = document.createElement("a");
	enableTooltips = (enableTooltips == undefined) ? true : enableTooltips;

	if(options.title && enableTooltips) {
		el.title = createTootlip(options.title, options.action, shortcuts);

		if(isMac) {
			el.title = el.title.replace("Ctrl", "⌘");
			el.title = el.title.replace("Alt", "⌥");
		}
	}

	el.tabIndex = -1;
	el.className = options.className;
	return el;
}

function createSep() {
	var el = document.createElement("i");
	el.className = "separator";
	el.innerHTML = "|";
	return el;
}

function createTootlip(title, action, shortcuts) {
	var actionName;
	var tooltip = title;

	if(action) {
		actionName = getBindingName(action);
		if(shortcuts[actionName]) {
			tooltip += " (" + fixShortcut(shortcuts[actionName]) + ")";
		}
	}

	return tooltip;
}

/**
 * The state of CodeMirror at the given position.
 */
function getState(cm, pos) {
	pos = pos || cm.getCursor("start");
	var stat = cm.getTokenAt(pos);
	if(!stat.type) return {};

	var types = stat.type.split(" ");

	var ret = {},
		data, text;
	for(var i = 0; i < types.length; i++) {
		data = types[i];
		if(data === "strong") {
			ret.bold = true;
		} else if(data === "variable-2") {
			text = cm.getLine(pos.line);
			if(/^\s*\d+\.\s/.test(text)) {
				ret["ordered-list"] = true;
			} else {
				ret["unordered-list"] = true;
			}
		} else if(data === "atom") {
			ret.quote = true;
		} else if(data === "em") {
			ret.italic = true;
		} else if(data === "quote") {
			ret.quote = true;
		} else if(data === "strikethrough") {
			ret.strikethrough = true;
		} else if(data === "comment") {
			ret.code = true;
		} else if(data === "link") {
			ret.link = true;
		} else if(data === "tag") {
			ret.image = true;
		} else if(data.match(/^header(\-[1-6])?$/)) {
			ret[data.replace("header", "heading")] = true;
		}
	}
	return ret;
}


// Saved overflow setting
var saved_overflow = "";

/**
 * Toggle full screen of the editor.
 */
function toggleFullScreen(editor) {
	// Set fullscreen
	var cm = editor.codemirror;
	cm.setOption("fullScreen", !cm.getOption("fullScreen"));


	// Prevent scrolling on body during fullscreen active
	if(cm.getOption("fullScreen")) {
		saved_overflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";
	} else {
		document.body.style.overflow = saved_overflow;
	}


	// Update toolbar class
	var wrap = cm.getWrapperElement();

	if(!/fullscreen/.test(wrap.previousSibling.className)) {
		wrap.previousSibling.className += " fullscreen";
	} else {
		wrap.previousSibling.className = wrap.previousSibling.className.replace(/\s*fullscreen\b/, "");
	}


	// Update toolbar button
	var toolbarButton = editor.toolbarElements.fullscreen;

	if(!/active/.test(toolbarButton.className)) {
		toolbarButton.className += " active";
	} else {
		toolbarButton.className = toolbarButton.className.replace(/\s*active\s*/g, "");
	}


	// Hide side by side if needed
	var sidebyside = cm.getWrapperElement().nextSibling;
	if(/editor-preview-active-side/.test(sidebyside.className))
		toggleSideBySide(editor);
}


/**
 * Action for toggling bold.
 */
function toggleBold(editor) {
	_toggleBlock(editor, "bold", editor.options.blockStyles.bold);
}


/**
 * Action for toggling italic.
 */
function toggleItalic(editor) {
	_toggleBlock(editor, "italic", editor.options.blockStyles.italic);
}


/**
 * Action for toggling strikethrough.
 */
function toggleStrikethrough(editor) {
	_toggleBlock(editor, "strikethrough", "~~");
}

/**
 * Action for toggling code block.
 */
function toggleCodeBlock(editor) {
	var fenceCharsToInsert = editor.options.blockStyles.code;

	function fencing_line(line) {
		/* return true, if this is a ``` or ~~~ line */
		if(typeof line !== "object") {
			throw "fencing_line() takes a 'line' object (not a line number, or line text).  Got: " + typeof line + ": " + line;
		}
		return line.styles && line.styles[2] && line.styles[2].indexOf("formatting-code-block") !== -1;
	}

	function token_state(token) {
		// base goes an extra level deep when mode backdrops are used, e.g. spellchecker on
		return token.state.base.base || token.state.base;
	}

	function code_type(cm, line_num, line, firstTok, lastTok) {
		/*
		 * Return "single", "indented", "fenced" or false
		 *
		 * cm and line_num are required.  Others are optional for efficiency
		 *   To check in the middle of a line, pass in firstTok yourself.
		 */
		line = line || cm.getLineHandle(line_num);
		firstTok = firstTok || cm.getTokenAt({
			line: line_num,
			ch: 1
		});
		lastTok = lastTok || (!!line.text && cm.getTokenAt({
			line: line_num,
			ch: line.text.length - 1
		}));
		var types = firstTok.type ? firstTok.type.split(" ") : [];
		if(lastTok && token_state(lastTok).indentedCode) {
			// have to check last char, since first chars of first line aren"t marked as indented
			return "indented";
		} else if(types.indexOf("comment") === -1) {
			// has to be after "indented" check, since first chars of first indented line aren"t marked as such
			return false;
		} else if(token_state(firstTok).fencedChars || token_state(lastTok).fencedChars || fencing_line(line)) {
			return "fenced";
		} else {
			return "single";
		}
	}

	function insertFencingAtSelection(cm, cur_start, cur_end, fenceCharsToInsert) {
		var start_line_sel = cur_start.line + 1,
			end_line_sel = cur_end.line + 1,
			sel_multi = cur_start.line !== cur_end.line,
			repl_start = fenceCharsToInsert + "\n",
			repl_end = "\n" + fenceCharsToInsert;
		if(sel_multi) {
			end_line_sel++;
		}
		// handle last char including \n or not
		if(sel_multi && cur_end.ch === 0) {
			repl_end = fenceCharsToInsert + "\n";
			end_line_sel--;
		}
		_replaceSelection(cm, false, [repl_start, repl_end]);
		cm.setSelection({
			line: start_line_sel,
			ch: 0
		}, {
			line: end_line_sel,
			ch: 0
		});
	}

	var cm = editor.codemirror,
		cur_start = cm.getCursor("start"),
		cur_end = cm.getCursor("end"),
		tok = cm.getTokenAt({
			line: cur_start.line,
			ch: cur_start.ch || 1
		}), // avoid ch 0 which is a cursor pos but not token
		line = cm.getLineHandle(cur_start.line),
		is_code = code_type(cm, cur_start.line, line, tok);
	var block_start, block_end, lineCount;

	if(is_code === "single") {
		// similar to some SimpleMDE _toggleBlock logic
		var start = line.text.slice(0, cur_start.ch).replace("`", ""),
			end = line.text.slice(cur_start.ch).replace("`", "");
		cm.replaceRange(start + end, {
			line: cur_start.line,
			ch: 0
		}, {
			line: cur_start.line,
			ch: 99999999999999
		});
		cur_start.ch--;
		if(cur_start !== cur_end) {
			cur_end.ch--;
		}
		cm.setSelection(cur_start, cur_end);
		cm.focus();
	} else if(is_code === "fenced") {
		if(cur_start.line !== cur_end.line || cur_start.ch !== cur_end.ch) {
			// use selection

			// find the fenced line so we know what type it is (tilde, backticks, number of them)
			for(block_start = cur_start.line; block_start >= 0; block_start--) {
				line = cm.getLineHandle(block_start);
				if(fencing_line(line)) {
					break;
				}
			}
			var fencedTok = cm.getTokenAt({
				line: block_start,
				ch: 1
			});
			var fence_chars = token_state(fencedTok).fencedChars;
			var start_text, start_line;
			var end_text, end_line;
			// check for selection going up against fenced lines, in which case we don't want to add more fencing
			if(fencing_line(cm.getLineHandle(cur_start.line))) {
				start_text = "";
				start_line = cur_start.line;
			} else if(fencing_line(cm.getLineHandle(cur_start.line - 1))) {
				start_text = "";
				start_line = cur_start.line - 1;
			} else {
				start_text = fence_chars + "\n";
				start_line = cur_start.line;
			}
			if(fencing_line(cm.getLineHandle(cur_end.line))) {
				end_text = "";
				end_line = cur_end.line;
				if(cur_end.ch === 0) {
					end_line += 1;
				}
			} else if(cur_end.ch !== 0 && fencing_line(cm.getLineHandle(cur_end.line + 1))) {
				end_text = "";
				end_line = cur_end.line + 1;
			} else {
				end_text = fence_chars + "\n";
				end_line = cur_end.line + 1;
			}
			if(cur_end.ch === 0) {
				// full last line selected, putting cursor at beginning of next
				end_line -= 1;
			}
			cm.operation(function() {
				// end line first, so that line numbers don't change
				cm.replaceRange(end_text, {
					line: end_line,
					ch: 0
				}, {
					line: end_line + (end_text ? 0 : 1),
					ch: 0
				});
				cm.replaceRange(start_text, {
					line: start_line,
					ch: 0
				}, {
					line: start_line + (start_text ? 0 : 1),
					ch: 0
				});
			});
			cm.setSelection({
				line: start_line + (start_text ? 1 : 0),
				ch: 0
			}, {
				line: end_line + (start_text ? 1 : -1),
				ch: 0
			});
			cm.focus();
		} else {
			// no selection, search for ends of this fenced block
			var search_from = cur_start.line;
			if(fencing_line(cm.getLineHandle(cur_start.line))) { // gets a little tricky if cursor is right on a fenced line
				if(code_type(cm, cur_start.line + 1) === "fenced") {
					block_start = cur_start.line;
					search_from = cur_start.line + 1; // for searching for "end"
				} else {
					block_end = cur_start.line;
					search_from = cur_start.line - 1; // for searching for "start"
				}
			}
			if(block_start === undefined) {
				for(block_start = search_from; block_start >= 0; block_start--) {
					line = cm.getLineHandle(block_start);
					if(fencing_line(line)) {
						break;
					}
				}
			}
			if(block_end === undefined) {
				lineCount = cm.lineCount();
				for(block_end = search_from; block_end < lineCount; block_end++) {
					line = cm.getLineHandle(block_end);
					if(fencing_line(line)) {
						break;
					}
				}
			}
			cm.operation(function() {
				cm.replaceRange("", {
					line: block_start,
					ch: 0
				}, {
					line: block_start + 1,
					ch: 0
				});
				cm.replaceRange("", {
					line: block_end - 1,
					ch: 0
				}, {
					line: block_end,
					ch: 0
				});
			});
			cm.focus();
		}
	} else if(is_code === "indented") {
		if(cur_start.line !== cur_end.line || cur_start.ch !== cur_end.ch) {
			// use selection
			block_start = cur_start.line;
			block_end = cur_end.line;
			if(cur_end.ch === 0) {
				block_end--;
			}
		} else {
			// no selection, search for ends of this indented block
			for(block_start = cur_start.line; block_start >= 0; block_start--) {
				line = cm.getLineHandle(block_start);
				if(line.text.match(/^\s*$/)) {
					// empty or all whitespace - keep going
					continue;
				} else {
					if(code_type(cm, block_start, line) !== "indented") {
						block_start += 1;
						break;
					}
				}
			}
			lineCount = cm.lineCount();
			for(block_end = cur_start.line; block_end < lineCount; block_end++) {
				line = cm.getLineHandle(block_end);
				if(line.text.match(/^\s*$/)) {
					// empty or all whitespace - keep going
					continue;
				} else {
					if(code_type(cm, block_end, line) !== "indented") {
						block_end -= 1;
						break;
					}
				}
			}
		}
		// if we are going to un-indent based on a selected set of lines, and the next line is indented too, we need to
		// insert a blank line so that the next line(s) continue to be indented code
		var next_line = cm.getLineHandle(block_end + 1),
			next_line_last_tok = next_line && cm.getTokenAt({
				line: block_end + 1,
				ch: next_line.text.length - 1
			}),
			next_line_indented = next_line_last_tok && token_state(next_line_last_tok).indentedCode;
		if(next_line_indented) {
			cm.replaceRange("\n", {
				line: block_end + 1,
				ch: 0
			});
		}

		for(var i = block_start; i <= block_end; i++) {
			cm.indentLine(i, "subtract"); // TODO: this doesn't get tracked in the history, so can't be undone :(
		}
		cm.focus();
	} else {
		// insert code formatting
		var no_sel_and_starting_of_line = (cur_start.line === cur_end.line && cur_start.ch === cur_end.ch && cur_start.ch === 0);
		var sel_multi = cur_start.line !== cur_end.line;
		if(no_sel_and_starting_of_line || sel_multi) {
			insertFencingAtSelection(cm, cur_start, cur_end, fenceCharsToInsert);
		} else {
			_replaceSelection(cm, false, ["`", "`"]);
		}
	}
}

/**
 * Action for toggling blockquote.
 */
function toggleBlockquote(editor) {
	var cm = editor.codemirror;
	_toggleLine(cm, "quote");
}

/**
 * Action for toggling heading size: normal -> h1 -> h2 -> h3 -> h4 -> h5 -> h6 -> normal
 */
function toggleHeadingSmaller(editor) {
	var cm = editor.codemirror;
	_toggleHeading(cm, "smaller");
}

/**
 * Action for toggling heading size: normal -> h6 -> h5 -> h4 -> h3 -> h2 -> h1 -> normal
 */
function toggleHeadingBigger(editor) {
	var cm = editor.codemirror;
	_toggleHeading(cm, "bigger");
}

/**
 * Action for toggling heading size 1
 */
function toggleHeading1(editor) {
	var cm = editor.codemirror;
	_toggleHeading(cm, undefined, 1);
}

/**
 * Action for toggling heading size 2
 */
function toggleHeading2(editor) {
	var cm = editor.codemirror;
	_toggleHeading(cm, undefined, 2);
}

/**
 * Action for toggling heading size 3
 */
function toggleHeading3(editor) {
	var cm = editor.codemirror;
	_toggleHeading(cm, undefined, 3);
}


/**
 * Action for toggling ul.
 */
function toggleUnorderedList(editor) {
	var cm = editor.codemirror;
	_toggleLine(cm, "unordered-list");
}


/**
 * Action for toggling ol.
 */
function toggleOrderedList(editor) {
	var cm = editor.codemirror;
	_toggleLine(cm, "ordered-list");
}

/**
 * Action for clean block (remove headline, list, blockquote code, markers)
 */
function cleanBlock(editor) {
	var cm = editor.codemirror;
	_cleanBlock(cm);
}

/**
 * Action for drawing a link.
 */
function drawLink(editor) {
	var cm = editor.codemirror;
	var stat = getState(cm);
	var options = editor.options;
	var url = "http://";
	if(options.promptURLs) {
		url = prompt(options.promptTexts.link);
		if(!url) {
			return false;
		}
	}
	_replaceSelection(cm, stat.link, options.insertTexts.link, url);
}

/**
 * Action for drawing an img.
 */
function drawImage(editor) {
	var cm = editor.codemirror;
	var stat = getState(cm);
	var options = editor.options;
	var url = "http://";
	if(options.promptURLs) {
		url = prompt(options.promptTexts.image);
		if(!url) {
			return false;
		}
	}
	_replaceSelection(cm, stat.image, options.insertTexts.image, url);
}

/**
 * Action for drawing a table.
 */
function drawTable(editor) {
	var cm = editor.codemirror;
	var stat = getState(cm);
	var options = editor.options;
	_replaceSelection(cm, stat.table, options.insertTexts.table);
}

/**
 * Action for drawing a horizontal rule.
 */
function drawHorizontalRule(editor) {
	var cm = editor.codemirror;
	var stat = getState(cm);
	var options = editor.options;
	_replaceSelection(cm, stat.image, options.insertTexts.horizontalRule);
}


/**
 * Undo action.
 */
function undo(editor) {
	var cm = editor.codemirror;
	cm.undo();
	cm.focus();
}


/**
 * Redo action.
 */
function redo(editor) {
	var cm = editor.codemirror;
	cm.redo();
	cm.focus();
}


/**
 * Toggle side by side preview
 */
function toggleSideBySide(editor) {
	var cm = editor.codemirror;
	var wrapper = cm.getWrapperElement();
	var preview = wrapper.nextSibling;
	var toolbarButton = editor.toolbarElements["side-by-side"];
	var useSideBySideListener = false;
	if(/editor-preview-active-side/.test(preview.className)) {
		preview.className = preview.className.replace(
			/\s*editor-preview-active-side\s*/g, ""
		);
		toolbarButton.className = toolbarButton.className.replace(/\s*active\s*/g, "");
		wrapper.className = wrapper.className.replace(/\s*CodeMirror-sided\s*/g, " ");
	} else {
		// When the preview button is clicked for the first time,
		// give some time for the transition from editor.css to fire and the view to slide from right to left,
		// instead of just appearing.
		setTimeout(function() {
			if(!cm.getOption("fullScreen"))
				toggleFullScreen(editor);
			preview.className += " editor-preview-active-side";
		}, 1);
		toolbarButton.className += " active";
		wrapper.className += " CodeMirror-sided";
		useSideBySideListener = true;
	}

	// Hide normal preview if active
	var previewNormal = wrapper.lastChild;
	if(/editor-preview-active/.test(previewNormal.className)) {
		previewNormal.className = previewNormal.className.replace(
			/\s*editor-preview-active\s*/g, ""
		);
		var toolbar = editor.toolbarElements.preview;
		var toolbar_div = wrapper.previousSibling;
		toolbar.className = toolbar.className.replace(/\s*active\s*/g, "");
		toolbar_div.className = toolbar_div.className.replace(/\s*disabled-for-preview*/g, "");
	}

	var sideBySideRenderingFunction = function() {
		preview.innerHTML = editor.options.previewRender(editor.value(), preview);
	};

	if(!cm.sideBySideRenderingFunction) {
		cm.sideBySideRenderingFunction = sideBySideRenderingFunction;
	}

	if(useSideBySideListener) {
		preview.innerHTML = editor.options.previewRender(editor.value(), preview);
		cm.on("update", cm.sideBySideRenderingFunction);
	} else {
		cm.off("update", cm.sideBySideRenderingFunction);
	}

	// Refresh to fix selection being off (#309)
	cm.refresh();
}


/**
 * Preview action.
 */
function togglePreview(editor) {
	var cm = editor.codemirror;
	var wrapper = cm.getWrapperElement();
	var toolbar_div = wrapper.previousSibling;
	var toolbar = editor.options.toolbar ? editor.toolbarElements.preview : false;
	var preview = wrapper.lastChild;
	if(!preview || !/editor-preview/.test(preview.className)) {
		preview = document.createElement("div");
		preview.className = "editor-preview";
		wrapper.appendChild(preview);
	}
	if(/editor-preview-active/.test(preview.className)) {
		preview.className = preview.className.replace(
			/\s*editor-preview-active\s*/g, ""
		);
		if(toolbar) {
			toolbar.className = toolbar.className.replace(/\s*active\s*/g, "");
			toolbar_div.className = toolbar_div.className.replace(/\s*disabled-for-preview*/g, "");
		}
	} else {
		// When the preview button is clicked for the first time,
		// give some time for the transition from editor.css to fire and the view to slide from right to left,
		// instead of just appearing.
		setTimeout(function() {
			preview.className += " editor-preview-active";
		}, 1);
		if(toolbar) {
			toolbar.className += " active";
			toolbar_div.className += " disabled-for-preview";
		}
	}
	preview.innerHTML = editor.options.previewRender(editor.value(), preview);

	// Turn off side by side if needed
	var sidebyside = cm.getWrapperElement().nextSibling;
	if(/editor-preview-active-side/.test(sidebyside.className))
		toggleSideBySide(editor);
}

function _replaceSelection(cm, active, startEnd, url) {
	if(/editor-preview-active/.test(cm.getWrapperElement().lastChild.className))
		return;

	var text;
	var start = startEnd[0];
	var end = startEnd[1];
	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");
	if(url) {
		end = end.replace("#url#", url);
	}
	if(active) {
		text = cm.getLine(startPoint.line);
		start = text.slice(0, startPoint.ch);
		end = text.slice(startPoint.ch);
		cm.replaceRange(start + end, {
			line: startPoint.line,
			ch: 0
		});
	} else {
		text = cm.getSelection();
		cm.replaceSelection(start + text + end);

		startPoint.ch += start.length;
		if(startPoint !== endPoint) {
			endPoint.ch += start.length;
		}
	}
	cm.setSelection(startPoint, endPoint);
	cm.focus();
}


function _toggleHeading(cm, direction, size) {
	if(/editor-preview-active/.test(cm.getWrapperElement().lastChild.className))
		return;

	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");
	for(var i = startPoint.line; i <= endPoint.line; i++) {
		(function(i) {
			var text = cm.getLine(i);
			var currHeadingLevel = text.search(/[^#]/);

			if(direction !== undefined) {
				if(currHeadingLevel <= 0) {
					if(direction == "bigger") {
						text = "###### " + text;
					} else {
						text = "# " + text;
					}
				} else if(currHeadingLevel == 6 && direction == "smaller") {
					text = text.substr(7);
				} else if(currHeadingLevel == 1 && direction == "bigger") {
					text = text.substr(2);
				} else {
					if(direction == "bigger") {
						text = text.substr(1);
					} else {
						text = "#" + text;
					}
				}
			} else {
				if(size == 1) {
					if(currHeadingLevel <= 0) {
						text = "# " + text;
					} else if(currHeadingLevel == size) {
						text = text.substr(currHeadingLevel + 1);
					} else {
						text = "# " + text.substr(currHeadingLevel + 1);
					}
				} else if(size == 2) {
					if(currHeadingLevel <= 0) {
						text = "## " + text;
					} else if(currHeadingLevel == size) {
						text = text.substr(currHeadingLevel + 1);
					} else {
						text = "## " + text.substr(currHeadingLevel + 1);
					}
				} else {
					if(currHeadingLevel <= 0) {
						text = "### " + text;
					} else if(currHeadingLevel == size) {
						text = text.substr(currHeadingLevel + 1);
					} else {
						text = "### " + text.substr(currHeadingLevel + 1);
					}
				}
			}

			cm.replaceRange(text, {
				line: i,
				ch: 0
			}, {
				line: i,
				ch: 99999999999999
			});
		})(i);
	}
	cm.focus();
}


function _toggleLine(cm, name) {
	if(/editor-preview-active/.test(cm.getWrapperElement().lastChild.className))
		return;

	var stat = getState(cm);
	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");
	var repl = {
		"quote": /^(\s*)\>\s+/,
		"unordered-list": /^(\s*)(\*|\-|\+)\s+/,
		"ordered-list": /^(\s*)\d+\.\s+/
	};
	var map = {
		"quote": "> ",
		"unordered-list": "* ",
		"ordered-list": "1. "
	};
	for(var i = startPoint.line; i <= endPoint.line; i++) {
		(function(i) {
			var text = cm.getLine(i);
			if(stat[name]) {
				text = text.replace(repl[name], "$1");
			} else {
				text = map[name] + text;
			}
			cm.replaceRange(text, {
				line: i,
				ch: 0
			}, {
				line: i,
				ch: 99999999999999
			});
		})(i);
	}
	cm.focus();
}

function _toggleBlock(editor, type, start_chars, end_chars) {
	if(/editor-preview-active/.test(editor.codemirror.getWrapperElement().lastChild.className))
		return;

	end_chars = (typeof end_chars === "undefined") ? start_chars : end_chars;
	var cm = editor.codemirror;
	var stat = getState(cm);

	var text;
	var start = start_chars;
	var end = end_chars;

	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");

	if(stat[type]) {
		text = cm.getLine(startPoint.line);
		start = text.slice(0, startPoint.ch);
		end = text.slice(startPoint.ch);
		if(type == "bold") {
			start = start.replace(/(\*\*|__)(?![\s\S]*(\*\*|__))/, "");
			end = end.replace(/(\*\*|__)/, "");
		} else if(type == "italic") {
			start = start.replace(/(\*|_)(?![\s\S]*(\*|_))/, "");
			end = end.replace(/(\*|_)/, "");
		} else if(type == "strikethrough") {
			start = start.replace(/(\*\*|~~)(?![\s\S]*(\*\*|~~))/, "");
			end = end.replace(/(\*\*|~~)/, "");
		}
		cm.replaceRange(start + end, {
			line: startPoint.line,
			ch: 0
		}, {
			line: startPoint.line,
			ch: 99999999999999
		});

		if(type == "bold" || type == "strikethrough") {
			startPoint.ch -= 2;
			if(startPoint !== endPoint) {
				endPoint.ch -= 2;
			}
		} else if(type == "italic") {
			startPoint.ch -= 1;
			if(startPoint !== endPoint) {
				endPoint.ch -= 1;
			}
		}
	} else {
		text = cm.getSelection();
		if(type == "bold") {
			text = text.split("**").join("");
			text = text.split("__").join("");
		} else if(type == "italic") {
			text = text.split("*").join("");
			text = text.split("_").join("");
		} else if(type == "strikethrough") {
			text = text.split("~~").join("");
		}
		cm.replaceSelection(start + text + end);

		startPoint.ch += start_chars.length;
		endPoint.ch = startPoint.ch + text.length;
	}

	cm.setSelection(startPoint, endPoint);
	cm.focus();
}

function _cleanBlock(cm) {
	if(/editor-preview-active/.test(cm.getWrapperElement().lastChild.className))
		return;

	var startPoint = cm.getCursor("start");
	var endPoint = cm.getCursor("end");
	var text;

	for(var line = startPoint.line; line <= endPoint.line; line++) {
		text = cm.getLine(line);
		text = text.replace(/^[ ]*([# ]+|\*|\-|[> ]+|[0-9]+(.|\)))[ ]*/, "");

		cm.replaceRange(text, {
			line: line,
			ch: 0
		}, {
			line: line,
			ch: 99999999999999
		});
	}
}

// Merge the properties of one object into another.
function _mergeProperties(target, source) {
	for(var property in source) {
		if(source.hasOwnProperty(property)) {
			if(source[property] instanceof Array) {
				target[property] = source[property].concat(target[property] instanceof Array ? target[property] : []);
			} else if(
				source[property] !== null &&
				typeof source[property] === "object" &&
				source[property].constructor === Object
			) {
				target[property] = _mergeProperties(target[property] || {}, source[property]);
			} else {
				target[property] = source[property];
			}
		}
	}

	return target;
}

// Merge an arbitrary number of objects into one.
function extend(target) {
	for(var i = 1; i < arguments.length; i++) {
		target = _mergeProperties(target, arguments[i]);
	}

	return target;
}

/* The right word count in respect for CJK. */
function wordCount(data) {
	var pattern = /[a-zA-Z0-9_\u0392-\u03c9\u0410-\u04F9]+|[\u4E00-\u9FFF\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\uac00-\ud7af]+/g;
	var m = data.match(pattern);
	var count = 0;
	if(m === null) return count;
	for(var i = 0; i < m.length; i++) {
		if(m[i].charCodeAt(0) >= 0x4E00) {
			count += m[i].length;
		} else {
			count += 1;
		}
	}
	return count;
}

var toolbarBuiltInButtons = {
	"bold": {
		name: "bold",
		action: toggleBold,
		className: "fa fa-bold",
		title: "Bold",
		default: true
	},
	"italic": {
		name: "italic",
		action: toggleItalic,
		className: "fa fa-italic",
		title: "Italic",
		default: true
	},
	"strikethrough": {
		name: "strikethrough",
		action: toggleStrikethrough,
		className: "fa fa-strikethrough",
		title: "Strikethrough"
	},
	"heading": {
		name: "heading",
		action: toggleHeadingSmaller,
		className: "fa fa-header",
		title: "Heading",
		default: true
	},
	"heading-smaller": {
		name: "heading-smaller",
		action: toggleHeadingSmaller,
		className: "fa fa-header fa-header-x fa-header-smaller",
		title: "Smaller Heading"
	},
	"heading-bigger": {
		name: "heading-bigger",
		action: toggleHeadingBigger,
		className: "fa fa-header fa-header-x fa-header-bigger",
		title: "Bigger Heading"
	},
	"heading-1": {
		name: "heading-1",
		action: toggleHeading1,
		className: "fa fa-header fa-header-x fa-header-1",
		title: "Big Heading"
	},
	"heading-2": {
		name: "heading-2",
		action: toggleHeading2,
		className: "fa fa-header fa-header-x fa-header-2",
		title: "Medium Heading"
	},
	"heading-3": {
		name: "heading-3",
		action: toggleHeading3,
		className: "fa fa-header fa-header-x fa-header-3",
		title: "Small Heading"
	},
	"separator-1": {
		name: "separator-1"
	},
	"code": {
		name: "code",
		action: toggleCodeBlock,
		className: "fa fa-code",
		title: "Code"
	},
	"quote": {
		name: "quote",
		action: toggleBlockquote,
		className: "fa fa-quote-left",
		title: "Quote",
		default: true
	},
	"unordered-list": {
		name: "unordered-list",
		action: toggleUnorderedList,
		className: "fa fa-list-ul",
		title: "Generic List",
		default: true
	},
	"ordered-list": {
		name: "ordered-list",
		action: toggleOrderedList,
		className: "fa fa-list-ol",
		title: "Numbered List",
		default: true
	},
	"clean-block": {
		name: "clean-block",
		action: cleanBlock,
		className: "fa fa-eraser fa-clean-block",
		title: "Clean block"
	},
	"separator-2": {
		name: "separator-2"
	},
	"link": {
		name: "link",
		action: drawLink,
		className: "fa fa-link",
		title: "Create Link",
		default: true
	},
	"image": {
		name: "image",
		action: drawImage,
		className: "fa fa-picture-o",
		title: "Insert Image",
		default: true
	},
	"table": {
		name: "table",
		action: drawTable,
		className: "fa fa-table",
		title: "Insert Table"
	},
	"horizontal-rule": {
		name: "horizontal-rule",
		action: drawHorizontalRule,
		className: "fa fa-minus",
		title: "Insert Horizontal Line"
	},
	"separator-3": {
		name: "separator-3"
	},
	"preview": {
		name: "preview",
		action: togglePreview,
		className: "fa fa-eye no-disable",
		title: "Toggle Preview",
		default: true
	},
	"side-by-side": {
		name: "side-by-side",
		action: toggleSideBySide,
		className: "fa fa-columns no-disable no-mobile",
		title: "Toggle Side by Side",
		default: true
	},
	"fullscreen": {
		name: "fullscreen",
		action: toggleFullScreen,
		className: "fa fa-arrows-alt no-disable no-mobile",
		title: "Toggle Fullscreen",
		default: true
	},
	"separator-4": {
		name: "separator-4"
	},
	"guide": {
		name: "guide",
		action: "https://simplemde.com/markdown-guide",
		className: "fa fa-question-circle",
		title: "Markdown Guide",
		default: true
	},
	"separator-5": {
		name: "separator-5"
	},
	"undo": {
		name: "undo",
		action: undo,
		className: "fa fa-undo no-disable",
		title: "Undo"
	},
	"redo": {
		name: "redo",
		action: redo,
		className: "fa fa-repeat no-disable",
		title: "Redo"
	}
};

var insertTexts = {
	link: ["[", "](#url#)"],
	image: ["![](", "#url#)"],
	table: ["", "\n\n| Column 1 | Column 2 | Column 3 |\n| -------- | -------- | -------- |\n| Text     | Text     | Text     |\n\n"],
	horizontalRule: ["", "\n\n-----\n\n"]
};

var promptTexts = {
	link: "URL for the link:",
	image: "URL of the image:"
};

var blockStyles = {
	"bold": "**",
	"code": "```",
	"italic": "*"
};

/**
 * Interface of SimpleMDE.
 */
function SimpleMDE(options) {
	// Handle options parameter
	options = options || {};


	// Used later to refer to it"s parent
	options.parent = this;


	// Check if Font Awesome needs to be auto downloaded
	var autoDownloadFA = true;

	if(options.autoDownloadFontAwesome === false) {
		autoDownloadFA = false;
	}

	if(options.autoDownloadFontAwesome !== true) {
		var styleSheets = document.styleSheets;
		for(var i = 0; i < styleSheets.length; i++) {
			if(!styleSheets[i].href)
				continue;

			if(styleSheets[i].href.indexOf("//maxcdn.bootstrapcdn.com/font-awesome/") > -1) {
				autoDownloadFA = false;
			}
		}
	}

	if(autoDownloadFA) {
		var link = document.createElement("link");
		link.rel = "stylesheet";
		link.href = "https://maxcdn.bootstrapcdn.com/font-awesome/latest/css/font-awesome.min.css";
		document.getElementsByTagName("head")[0].appendChild(link);
	}


	// Find the textarea to use
	if(options.element) {
		this.element = options.element;
	} else if(options.element === null) {
		// This means that the element option was specified, but no element was found
		console.log("SimpleMDE: Error. No element was found.");
		return;
	}


	// Handle toolbar
	if(options.toolbar === undefined) {
		// Initialize
		options.toolbar = [];


		// Loop over the built in buttons, to get the preferred order
		for(var key in toolbarBuiltInButtons) {
			if(toolbarBuiltInButtons.hasOwnProperty(key)) {
				if(key.indexOf("separator-") != -1) {
					options.toolbar.push("|");
				}

				if(toolbarBuiltInButtons[key].default === true || (options.showIcons && options.showIcons.constructor === Array && options.showIcons.indexOf(key) != -1)) {
					options.toolbar.push(key);
				}
			}
		}
	}


	// Handle status bar
	if(!options.hasOwnProperty("status")) {
		options.status = ["autosave", "lines", "words", "cursor"];
	}


	// Add default preview rendering function
	if(!options.previewRender) {
		options.previewRender = function(plainText) {
			// Note: "this" refers to the options object
			return this.parent.markdown(plainText);
		};
	}


	// Set default options for parsing config
	options.parsingConfig = extend({
		highlightFormatting: true // needed for toggleCodeBlock to detect types of code
	}, options.parsingConfig || {});


	// Merging the insertTexts, with the given options
	options.insertTexts = extend({}, insertTexts, options.insertTexts || {});


	// Merging the promptTexts, with the given options
	options.promptTexts = promptTexts;


	// Merging the blockStyles, with the given options
	options.blockStyles = extend({}, blockStyles, options.blockStyles || {});


	// Merging the shortcuts, with the given options
	options.shortcuts = extend({}, shortcuts, options.shortcuts || {});


	// Change unique_id to uniqueId for backwards compatibility
	if(options.autosave != undefined && options.autosave.unique_id != undefined && options.autosave.unique_id != "")
		options.autosave.uniqueId = options.autosave.unique_id;


	// Update this options
	this.options = options;


	// Auto render
	this.render();


	// The codemirror component is only available after rendering
	// so, the setter for the initialValue can only run after
	// the element has been rendered
	if(options.initialValue && (!this.options.autosave || this.options.autosave.foundSavedValue !== true)) {
		this.value(options.initialValue);
	}
}

/**
 * Default markdown render.
 */
SimpleMDE.prototype.markdown = function(text) {
	if(marked) {
		// Initialize
		var markedOptions = {};


		// Update options
		if(this.options && this.options.renderingConfig && this.options.renderingConfig.singleLineBreaks === false) {
			markedOptions.breaks = false;
		} else {
			markedOptions.breaks = true;
		}

		if(this.options && this.options.renderingConfig && this.options.renderingConfig.codeSyntaxHighlighting === true && window.hljs) {
			markedOptions.highlight = function(code) {
				return window.hljs.highlightAuto(code).value;
			};
		}


		// Set options
		marked.setOptions(markedOptions);


		// Return
		return marked(text);
	}
};

/**
 * Render editor to the given element.
 */
SimpleMDE.prototype.render = function(el) {
	if(!el) {
		el = this.element || document.getElementsByTagName("textarea")[0];
	}

	if(this._rendered && this._rendered === el) {
		// Already rendered.
		return;
	}

	this.element = el;
	var options = this.options;

	var self = this;
	var keyMaps = {};

	for(var key in options.shortcuts) {
		// null stands for "do not bind this command"
		if(options.shortcuts[key] !== null && bindings[key] !== null) {
			(function(key) {
				keyMaps[fixShortcut(options.shortcuts[key])] = function() {
					bindings[key](self);
				};
			})(key);
		}
	}

	keyMaps["Enter"] = "newlineAndIndentContinueMarkdownList";
	keyMaps["Tab"] = "tabAndIndentMarkdownList";
	keyMaps["Shift-Tab"] = "shiftTabAndUnindentMarkdownList";
	keyMaps["Esc"] = function(cm) {
		if(cm.getOption("fullScreen")) toggleFullScreen(self);
	};

	document.addEventListener("keydown", function(e) {
		e = e || window.event;

		if(e.keyCode == 27) {
			if(self.codemirror.getOption("fullScreen")) toggleFullScreen(self);
		}
	}, false);

	var mode, backdrop;
	if(options.spellChecker !== false) {
		mode = "spell-checker";
		backdrop = options.parsingConfig;
		backdrop.name = "gfm";
		backdrop.gitHubSpice = false;

		CodeMirrorSpellChecker({
			codeMirrorInstance: CodeMirror
		});
	} else {
		mode = options.parsingConfig;
		mode.name = "gfm";
		mode.gitHubSpice = false;
	}

	this.codemirror = CodeMirror.fromTextArea(el, {
		mode: mode,
		backdrop: backdrop,
		theme: "paper",
		tabSize: (options.tabSize != undefined) ? options.tabSize : 2,
		indentUnit: (options.tabSize != undefined) ? options.tabSize : 2,
		indentWithTabs: (options.indentWithTabs === false) ? false : true,
		lineNumbers: false,
		autofocus: (options.autofocus === true) ? true : false,
		extraKeys: keyMaps,
		lineWrapping: (options.lineWrapping === false) ? false : true,
		allowDropFileTypes: ["text/plain"],
		placeholder: options.placeholder || el.getAttribute("placeholder") || "",
		styleSelectedText: (options.styleSelectedText != undefined) ? options.styleSelectedText : true
	});

	if(options.forceSync === true) {
		var cm = this.codemirror;
		cm.on("change", function() {
			cm.save();
		});
	}

	this.gui = {};

	if(options.toolbar !== false) {
		this.gui.toolbar = this.createToolbar();
	}
	if(options.status !== false) {
		this.gui.statusbar = this.createStatusbar();
	}
	if(options.autosave != undefined && options.autosave.enabled === true) {
		this.autosave();
	}

	this.gui.sideBySide = this.createSideBySide();

	this._rendered = this.element;


	// Fixes CodeMirror bug (#344)
	var temp_cm = this.codemirror;
	setTimeout(function() {
		temp_cm.refresh();
	}.bind(temp_cm), 0);
};

// Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem throw QuotaExceededError. We're going to detect this and set a variable accordingly.
function isLocalStorageAvailable() {
	if(typeof localStorage === "object") {
		try {
			localStorage.setItem("smde_localStorage", 1);
			localStorage.removeItem("smde_localStorage");
		} catch(e) {
			return false;
		}
	} else {
		return false;
	}

	return true;
}

SimpleMDE.prototype.autosave = function() {
	if(isLocalStorageAvailable()) {
		var simplemde = this;

		if(this.options.autosave.uniqueId == undefined || this.options.autosave.uniqueId == "") {
			console.log("SimpleMDE: You must set a uniqueId to use the autosave feature");
			return;
		}

		if(simplemde.element.form != null && simplemde.element.form != undefined) {
			simplemde.element.form.addEventListener("submit", function() {
				localStorage.removeItem("smde_" + simplemde.options.autosave.uniqueId);
			});
		}

		if(this.options.autosave.loaded !== true) {
			if(typeof localStorage.getItem("smde_" + this.options.autosave.uniqueId) == "string" && localStorage.getItem("smde_" + this.options.autosave.uniqueId) != "") {
				this.codemirror.setValue(localStorage.getItem("smde_" + this.options.autosave.uniqueId));
				this.options.autosave.foundSavedValue = true;
			}

			this.options.autosave.loaded = true;
		}

		localStorage.setItem("smde_" + this.options.autosave.uniqueId, simplemde.value());

		var el = document.getElementById("autosaved");
		if(el != null && el != undefined && el != "") {
			var d = new Date();
			var hh = d.getHours();
			var m = d.getMinutes();
			var dd = "am";
			var h = hh;
			if(h >= 12) {
				h = hh - 12;
				dd = "pm";
			}
			if(h == 0) {
				h = 12;
			}
			m = m < 10 ? "0" + m : m;

			el.innerHTML = "Autosaved: " + h + ":" + m + " " + dd;
		}

		this.autosaveTimeoutId = setTimeout(function() {
			simplemde.autosave();
		}, this.options.autosave.delay || 10000);
	} else {
		console.log("SimpleMDE: localStorage not available, cannot autosave");
	}
};

SimpleMDE.prototype.clearAutosavedValue = function() {
	if(isLocalStorageAvailable()) {
		if(this.options.autosave == undefined || this.options.autosave.uniqueId == undefined || this.options.autosave.uniqueId == "") {
			console.log("SimpleMDE: You must set a uniqueId to clear the autosave value");
			return;
		}

		localStorage.removeItem("smde_" + this.options.autosave.uniqueId);
	} else {
		console.log("SimpleMDE: localStorage not available, cannot autosave");
	}
};

SimpleMDE.prototype.createSideBySide = function() {
	var cm = this.codemirror;
	var wrapper = cm.getWrapperElement();
	var preview = wrapper.nextSibling;

	if(!preview || !/editor-preview-side/.test(preview.className)) {
		preview = document.createElement("div");
		preview.className = "editor-preview-side";
		wrapper.parentNode.insertBefore(preview, wrapper.nextSibling);
	}

	// Syncs scroll  editor -> preview
	var cScroll = false;
	var pScroll = false;
	cm.on("scroll", function(v) {
		if(cScroll) {
			cScroll = false;
			return;
		}
		pScroll = true;
		var height = v.getScrollInfo().height - v.getScrollInfo().clientHeight;
		var ratio = parseFloat(v.getScrollInfo().top) / height;
		var move = (preview.scrollHeight - preview.clientHeight) * ratio;
		preview.scrollTop = move;
	});

	// Syncs scroll  preview -> editor
	preview.onscroll = function() {
		if(pScroll) {
			pScroll = false;
			return;
		}
		cScroll = true;
		var height = preview.scrollHeight - preview.clientHeight;
		var ratio = parseFloat(preview.scrollTop) / height;
		var move = (cm.getScrollInfo().height - cm.getScrollInfo().clientHeight) * ratio;
		cm.scrollTo(0, move);
	};
	return preview;
};

SimpleMDE.prototype.createToolbar = function(items) {
	items = items || this.options.toolbar;

	if(!items || items.length === 0) {
		return;
	}
	var i;
	for(i = 0; i < items.length; i++) {
		if(toolbarBuiltInButtons[items[i]] != undefined) {
			items[i] = toolbarBuiltInButtons[items[i]];
		}
	}

	var bar = document.createElement("div");
	bar.className = "editor-toolbar";

	var self = this;

	var toolbarData = {};
	self.toolbar = items;

	for(i = 0; i < items.length; i++) {
		if(items[i].name == "guide" && self.options.toolbarGuideIcon === false)
			continue;

		if(self.options.hideIcons && self.options.hideIcons.indexOf(items[i].name) != -1)
			continue;

		// Fullscreen does not work well on mobile devices (even tablets)
		// In the future, hopefully this can be resolved
		if((items[i].name == "fullscreen" || items[i].name == "side-by-side") && isMobile())
			continue;


		// Don't include trailing separators
		if(items[i] === "|") {
			var nonSeparatorIconsFollow = false;

			for(var x = (i + 1); x < items.length; x++) {
				if(items[x] !== "|" && (!self.options.hideIcons || self.options.hideIcons.indexOf(items[x].name) == -1)) {
					nonSeparatorIconsFollow = true;
				}
			}

			if(!nonSeparatorIconsFollow)
				continue;
		}


		// Create the icon and append to the toolbar
		(function(item) {
			var el;
			if(item === "|") {
				el = createSep();
			} else {
				el = createIcon(item, self.options.toolbarTips, self.options.shortcuts);
			}

			// bind events, special for info
			if(item.action) {
				if(typeof item.action === "function") {
					el.onclick = function(e) {
						e.preventDefault();
						item.action(self);
					};
				} else if(typeof item.action === "string") {
					el.href = item.action;
					el.target = "_blank";
				}
			}

			toolbarData[item.name || item] = el;
			bar.appendChild(el);
		})(items[i]);
	}

	self.toolbarElements = toolbarData;

	var cm = this.codemirror;
	cm.on("cursorActivity", function() {
		var stat = getState(cm);

		for(var key in toolbarData) {
			(function(key) {
				var el = toolbarData[key];
				if(stat[key]) {
					el.className += " active";
				} else if(key != "fullscreen" && key != "side-by-side") {
					el.className = el.className.replace(/\s*active\s*/g, "");
				}
			})(key);
		}
	});

	var cmWrapper = cm.getWrapperElement();
	cmWrapper.parentNode.insertBefore(bar, cmWrapper);
	return bar;
};

SimpleMDE.prototype.createStatusbar = function(status) {
	// Initialize
	status = status || this.options.status;
	var options = this.options;
	var cm = this.codemirror;


	// Make sure the status variable is valid
	if(!status || status.length === 0)
		return;


	// Set up the built-in items
	var items = [];
	var i, onUpdate, defaultValue;

	for(i = 0; i < status.length; i++) {
		// Reset some values
		onUpdate = undefined;
		defaultValue = undefined;


		// Handle if custom or not
		if(typeof status[i] === "object") {
			items.push({
				className: status[i].className,
				defaultValue: status[i].defaultValue,
				onUpdate: status[i].onUpdate
			});
		} else {
			var name = status[i];

			if(name === "words") {
				defaultValue = function(el) {
					el.innerHTML = wordCount(cm.getValue());
				};
				onUpdate = function(el) {
					el.innerHTML = wordCount(cm.getValue());
				};
			} else if(name === "lines") {
				defaultValue = function(el) {
					el.innerHTML = cm.lineCount();
				};
				onUpdate = function(el) {
					el.innerHTML = cm.lineCount();
				};
			} else if(name === "cursor") {
				defaultValue = function(el) {
					el.innerHTML = "0:0";
				};
				onUpdate = function(el) {
					var pos = cm.getCursor();
					el.innerHTML = pos.line + ":" + pos.ch;
				};
			} else if(name === "autosave") {
				defaultValue = function(el) {
					if(options.autosave != undefined && options.autosave.enabled === true) {
						el.setAttribute("id", "autosaved");
					}
				};
			}

			items.push({
				className: name,
				defaultValue: defaultValue,
				onUpdate: onUpdate
			});
		}
	}


	// Create element for the status bar
	var bar = document.createElement("div");
	bar.className = "editor-statusbar";


	// Create a new span for each item
	for(i = 0; i < items.length; i++) {
		// Store in temporary variable
		var item = items[i];


		// Create span element
		var el = document.createElement("span");
		el.className = item.className;


		// Ensure the defaultValue is a function
		if(typeof item.defaultValue === "function") {
			item.defaultValue(el);
		}


		// Ensure the onUpdate is a function
		if(typeof item.onUpdate === "function") {
			// Create a closure around the span of the current action, then execute the onUpdate handler
			this.codemirror.on("update", (function(el, item) {
				return function() {
					item.onUpdate(el);
				};
			}(el, item)));
		}


		// Append the item to the status bar
		bar.appendChild(el);
	}


	// Insert the status bar into the DOM
	var cmWrapper = this.codemirror.getWrapperElement();
	cmWrapper.parentNode.insertBefore(bar, cmWrapper.nextSibling);
	return bar;
};

/**
 * Get or set the text content.
 */
SimpleMDE.prototype.value = function(val) {
	if(val === undefined) {
		return this.codemirror.getValue();
	} else {
		this.codemirror.getDoc().setValue(val);
		return this;
	}
};


/**
 * Bind static methods for exports.
 */
SimpleMDE.toggleBold = toggleBold;
SimpleMDE.toggleItalic = toggleItalic;
SimpleMDE.toggleStrikethrough = toggleStrikethrough;
SimpleMDE.toggleBlockquote = toggleBlockquote;
SimpleMDE.toggleHeadingSmaller = toggleHeadingSmaller;
SimpleMDE.toggleHeadingBigger = toggleHeadingBigger;
SimpleMDE.toggleHeading1 = toggleHeading1;
SimpleMDE.toggleHeading2 = toggleHeading2;
SimpleMDE.toggleHeading3 = toggleHeading3;
SimpleMDE.toggleCodeBlock = toggleCodeBlock;
SimpleMDE.toggleUnorderedList = toggleUnorderedList;
SimpleMDE.toggleOrderedList = toggleOrderedList;
SimpleMDE.cleanBlock = cleanBlock;
SimpleMDE.drawLink = drawLink;
SimpleMDE.drawImage = drawImage;
SimpleMDE.drawTable = drawTable;
SimpleMDE.drawHorizontalRule = drawHorizontalRule;
SimpleMDE.undo = undo;
SimpleMDE.redo = redo;
SimpleMDE.togglePreview = togglePreview;
SimpleMDE.toggleSideBySide = toggleSideBySide;
SimpleMDE.toggleFullScreen = toggleFullScreen;

/**
 * Bind instance methods for exports.
 */
SimpleMDE.prototype.toggleBold = function() {
	toggleBold(this);
};
SimpleMDE.prototype.toggleItalic = function() {
	toggleItalic(this);
};
SimpleMDE.prototype.toggleStrikethrough = function() {
	toggleStrikethrough(this);
};
SimpleMDE.prototype.toggleBlockquote = function() {
	toggleBlockquote(this);
};
SimpleMDE.prototype.toggleHeadingSmaller = function() {
	toggleHeadingSmaller(this);
};
SimpleMDE.prototype.toggleHeadingBigger = function() {
	toggleHeadingBigger(this);
};
SimpleMDE.prototype.toggleHeading1 = function() {
	toggleHeading1(this);
};
SimpleMDE.prototype.toggleHeading2 = function() {
	toggleHeading2(this);
};
SimpleMDE.prototype.toggleHeading3 = function() {
	toggleHeading3(this);
};
SimpleMDE.prototype.toggleCodeBlock = function() {
	toggleCodeBlock(this);
};
SimpleMDE.prototype.toggleUnorderedList = function() {
	toggleUnorderedList(this);
};
SimpleMDE.prototype.toggleOrderedList = function() {
	toggleOrderedList(this);
};
SimpleMDE.prototype.cleanBlock = function() {
	cleanBlock(this);
};
SimpleMDE.prototype.drawLink = function() {
	drawLink(this);
};
SimpleMDE.prototype.drawImage = function() {
	drawImage(this);
};
SimpleMDE.prototype.drawTable = function() {
	drawTable(this);
};
SimpleMDE.prototype.drawHorizontalRule = function() {
	drawHorizontalRule(this);
};
SimpleMDE.prototype.undo = function() {
	undo(this);
};
SimpleMDE.prototype.redo = function() {
	redo(this);
};
SimpleMDE.prototype.togglePreview = function() {
	togglePreview(this);
};
SimpleMDE.prototype.toggleSideBySide = function() {
	toggleSideBySide(this);
};
SimpleMDE.prototype.toggleFullScreen = function() {
	toggleFullScreen(this);
};

SimpleMDE.prototype.isPreviewActive = function() {
	var cm = this.codemirror;
	var wrapper = cm.getWrapperElement();
	var preview = wrapper.lastChild;

	return /editor-preview-active/.test(preview.className);
};

SimpleMDE.prototype.isSideBySideActive = function() {
	var cm = this.codemirror;
	var wrapper = cm.getWrapperElement();
	var preview = wrapper.nextSibling;

	return /editor-preview-active-side/.test(preview.className);
};

SimpleMDE.prototype.isFullscreenActive = function() {
	var cm = this.codemirror;

	return cm.getOption("fullScreen");
};

SimpleMDE.prototype.getState = function() {
	var cm = this.codemirror;

	return getState(cm);
};

SimpleMDE.prototype.toTextArea = function() {
	var cm = this.codemirror;
	var wrapper = cm.getWrapperElement();

	if(wrapper.parentNode) {
		if(this.gui.toolbar) {
			wrapper.parentNode.removeChild(this.gui.toolbar);
		}
		if(this.gui.statusbar) {
			wrapper.parentNode.removeChild(this.gui.statusbar);
		}
		if(this.gui.sideBySide) {
			wrapper.parentNode.removeChild(this.gui.sideBySide);
		}
	}

	cm.toTextArea();

	if(this.autosaveTimeoutId) {
		clearTimeout(this.autosaveTimeoutId);
		this.autosaveTimeoutId = undefined;
		this.clearAutosavedValue();
	}
};

module.exports = SimpleMDE;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  var listRE = /^(\s*)(>[> ]*|[*+-] \[[x ]\]\s|[*+-]\s|(\d+)([.)]))(\s*)/,
      emptyListRE = /^(\s*)(>[> ]*|[*+-] \[[x ]\]|[*+-]|(\d+)[.)])(\s*)$/,
      unorderedListRE = /[*+-]\s/;

  CodeMirror.commands.newlineAndIndentContinueMarkdownList = function(cm) {
    if (cm.getOption("disableInput")) return CodeMirror.Pass;
    var ranges = cm.listSelections(), replacements = [];
    for (var i = 0; i < ranges.length; i++) {
      var pos = ranges[i].head;

      // If we're not in Markdown mode, fall back to normal newlineAndIndent
      var eolState = cm.getStateAfter(pos.line);
      var inner = CodeMirror.innerMode(cm.getMode(), eolState);
      if (inner.mode.name !== "markdown") {
        cm.execCommand("newlineAndIndent");
        return;
      } else {
        eolState = inner.state;
      }

      var inList = eolState.list !== false;
      var inQuote = eolState.quote !== 0;

      var line = cm.getLine(pos.line), match = listRE.exec(line);
      var cursorBeforeBullet = /^\s*$/.test(line.slice(0, pos.ch));
      if (!ranges[i].empty() || (!inList && !inQuote) || !match || cursorBeforeBullet) {
        cm.execCommand("newlineAndIndent");
        return;
      }
      if (emptyListRE.test(line)) {
        var endOfQuote = inQuote && />\s*$/.test(line)
        var endOfList = !/>\s*$/.test(line)
        if (endOfQuote || endOfList) cm.replaceRange("", {
          line: pos.line, ch: 0
        }, {
          line: pos.line, ch: pos.ch + 1
        });
        replacements[i] = "\n";
      } else {
        var indent = match[1], after = match[5];
        var numbered = !(unorderedListRE.test(match[2]) || match[2].indexOf(">") >= 0);
        var bullet = numbered ? (parseInt(match[3], 10) + 1) + match[4] : match[2].replace("x", " ");
        replacements[i] = "\n" + indent + bullet + after;

        if (numbered) incrementRemainingMarkdownListNumbers(cm, pos);
      }
    }

    cm.replaceSelections(replacements);
  };

  // Auto-updating Markdown list numbers when a new item is added to the
  // middle of a list
  function incrementRemainingMarkdownListNumbers(cm, pos) {
    var startLine = pos.line, lookAhead = 0, skipCount = 0;
    var startItem = listRE.exec(cm.getLine(startLine)), startIndent = startItem[1];

    do {
      lookAhead += 1;
      var nextLineNumber = startLine + lookAhead;
      var nextLine = cm.getLine(nextLineNumber), nextItem = listRE.exec(nextLine);

      if (nextItem) {
        var nextIndent = nextItem[1];
        var newNumber = (parseInt(startItem[3], 10) + lookAhead - skipCount);
        var nextNumber = (parseInt(nextItem[3], 10)), itemNumber = nextNumber;

        if (startIndent === nextIndent && !isNaN(nextNumber)) {
          if (newNumber === nextNumber) itemNumber = nextNumber + 1;
          if (newNumber > nextNumber) itemNumber = newNumber + 1;
          cm.replaceRange(
            nextLine.replace(listRE, nextIndent + itemNumber + nextItem[4] + nextItem[5]),
          {
            line: nextLineNumber, ch: 0
          }, {
            line: nextLineNumber, ch: nextLine.length
          });
        } else {
          if (startIndent.length > nextIndent.length) return;
          // This doesn't run if the next line immediately indents, as it is
          // not clear of the users intention (new indented item or same level)
          if ((startIndent.length < nextIndent.length) && (lookAhead === 1)) return;
          skipCount += 1;
        }
      }
    } while (nextItem);
  }
});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

var CodeMirror = __webpack_require__(113);

CodeMirror.commands.tabAndIndentMarkdownList = function (cm) {
	var ranges = cm.listSelections();
	var pos = ranges[0].head;
	var eolState = cm.getStateAfter(pos.line);
	var inList = eolState.list !== false;

	if (inList) {
		cm.execCommand("indentMore");
		return;
	}

	if (cm.options.indentWithTabs) {
		cm.execCommand("insertTab");
	}
	else {
		var spaces = Array(cm.options.tabSize + 1).join(" ");
		cm.replaceSelection(spaces);
	}
};

CodeMirror.commands.shiftTabAndUnindentMarkdownList = function (cm) {
	var ranges = cm.listSelections();
	var pos = ranges[0].head;
	var eolState = cm.getStateAfter(pos.line);
	var inList = eolState.list !== false;

	if (inList) {
		cm.execCommand("indentLess");
		return;
	}

	if (cm.options.indentWithTabs) {
		cm.execCommand("insertTab");
	}
	else {
		var spaces = Array(cm.options.tabSize + 1).join(" ");
		cm.replaceSelection(spaces);
	}
};


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  CodeMirror.defineOption("fullScreen", false, function(cm, val, old) {
    if (old == CodeMirror.Init) old = false;
    if (!old == !val) return;
    if (val) setFullscreen(cm);
    else setNormal(cm);
  });

  function setFullscreen(cm) {
    var wrap = cm.getWrapperElement();
    cm.state.fullScreenRestore = {scrollTop: window.pageYOffset, scrollLeft: window.pageXOffset,
                                  width: wrap.style.width, height: wrap.style.height};
    wrap.style.width = "";
    wrap.style.height = "auto";
    wrap.className += " CodeMirror-fullscreen";
    document.documentElement.style.overflow = "hidden";
    cm.refresh();
  }

  function setNormal(cm) {
    var wrap = cm.getWrapperElement();
    wrap.className = wrap.className.replace(/\s*CodeMirror-fullscreen\b/, "");
    document.documentElement.style.overflow = "";
    var info = cm.state.fullScreenRestore;
    wrap.style.width = info.width; wrap.style.height = info.height;
    window.scrollTo(info.scrollLeft, info.scrollTop);
    cm.refresh();
  }
});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  CodeMirror.modeInfo = [
    {name: "APL", mime: "text/apl", mode: "apl", ext: ["dyalog", "apl"]},
    {name: "PGP", mimes: ["application/pgp", "application/pgp-encrypted", "application/pgp-keys", "application/pgp-signature"], mode: "asciiarmor", ext: ["asc", "pgp", "sig"]},
    {name: "ASN.1", mime: "text/x-ttcn-asn", mode: "asn.1", ext: ["asn", "asn1"]},
    {name: "Asterisk", mime: "text/x-asterisk", mode: "asterisk", file: /^extensions\.conf$/i},
    {name: "Brainfuck", mime: "text/x-brainfuck", mode: "brainfuck", ext: ["b", "bf"]},
    {name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h", "ino"]},
    {name: "C++", mime: "text/x-c++src", mode: "clike", ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"], alias: ["cpp"]},
    {name: "Cobol", mime: "text/x-cobol", mode: "cobol", ext: ["cob", "cpy"]},
    {name: "C#", mime: "text/x-csharp", mode: "clike", ext: ["cs"], alias: ["csharp", "cs"]},
    {name: "Clojure", mime: "text/x-clojure", mode: "clojure", ext: ["clj", "cljc", "cljx"]},
    {name: "ClojureScript", mime: "text/x-clojurescript", mode: "clojure", ext: ["cljs"]},
    {name: "Closure Stylesheets (GSS)", mime: "text/x-gss", mode: "css", ext: ["gss"]},
    {name: "CMake", mime: "text/x-cmake", mode: "cmake", ext: ["cmake", "cmake.in"], file: /^CMakeLists\.txt$/},
    {name: "CoffeeScript", mimes: ["application/vnd.coffeescript", "text/coffeescript", "text/x-coffeescript"], mode: "coffeescript", ext: ["coffee"], alias: ["coffee", "coffee-script"]},
    {name: "Common Lisp", mime: "text/x-common-lisp", mode: "commonlisp", ext: ["cl", "lisp", "el"], alias: ["lisp"]},
    {name: "Cypher", mime: "application/x-cypher-query", mode: "cypher", ext: ["cyp", "cypher"]},
    {name: "Cython", mime: "text/x-cython", mode: "python", ext: ["pyx", "pxd", "pxi"]},
    {name: "Crystal", mime: "text/x-crystal", mode: "crystal", ext: ["cr"]},
    {name: "CSS", mime: "text/css", mode: "css", ext: ["css"]},
    {name: "CQL", mime: "text/x-cassandra", mode: "sql", ext: ["cql"]},
    {name: "D", mime: "text/x-d", mode: "d", ext: ["d"]},
    {name: "Dart", mimes: ["application/dart", "text/x-dart"], mode: "dart", ext: ["dart"]},
    {name: "diff", mime: "text/x-diff", mode: "diff", ext: ["diff", "patch"]},
    {name: "Django", mime: "text/x-django", mode: "django"},
    {name: "Dockerfile", mime: "text/x-dockerfile", mode: "dockerfile", file: /^Dockerfile$/},
    {name: "DTD", mime: "application/xml-dtd", mode: "dtd", ext: ["dtd"]},
    {name: "Dylan", mime: "text/x-dylan", mode: "dylan", ext: ["dylan", "dyl", "intr"]},
    {name: "EBNF", mime: "text/x-ebnf", mode: "ebnf"},
    {name: "ECL", mime: "text/x-ecl", mode: "ecl", ext: ["ecl"]},
    {name: "edn", mime: "application/edn", mode: "clojure", ext: ["edn"]},
    {name: "Eiffel", mime: "text/x-eiffel", mode: "eiffel", ext: ["e"]},
    {name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"]},
    {name: "Embedded JavaScript", mime: "application/x-ejs", mode: "htmlembedded", ext: ["ejs"]},
    {name: "Embedded Ruby", mime: "application/x-erb", mode: "htmlembedded", ext: ["erb"]},
    {name: "Erlang", mime: "text/x-erlang", mode: "erlang", ext: ["erl"]},
    {name: "Esper", mime: "text/x-esper", mode: "sql"},
    {name: "Factor", mime: "text/x-factor", mode: "factor", ext: ["factor"]},
    {name: "FCL", mime: "text/x-fcl", mode: "fcl"},
    {name: "Forth", mime: "text/x-forth", mode: "forth", ext: ["forth", "fth", "4th"]},
    {name: "Fortran", mime: "text/x-fortran", mode: "fortran", ext: ["f", "for", "f77", "f90", "f95"]},
    {name: "F#", mime: "text/x-fsharp", mode: "mllike", ext: ["fs"], alias: ["fsharp"]},
    {name: "Gas", mime: "text/x-gas", mode: "gas", ext: ["s"]},
    {name: "Gherkin", mime: "text/x-feature", mode: "gherkin", ext: ["feature"]},
    {name: "GitHub Flavored Markdown", mime: "text/x-gfm", mode: "gfm", file: /^(readme|contributing|history)\.md$/i},
    {name: "Go", mime: "text/x-go", mode: "go", ext: ["go"]},
    {name: "Groovy", mime: "text/x-groovy", mode: "groovy", ext: ["groovy", "gradle"], file: /^Jenkinsfile$/},
    {name: "HAML", mime: "text/x-haml", mode: "haml", ext: ["haml"]},
    {name: "Haskell", mime: "text/x-haskell", mode: "haskell", ext: ["hs"]},
    {name: "Haskell (Literate)", mime: "text/x-literate-haskell", mode: "haskell-literate", ext: ["lhs"]},
    {name: "Haxe", mime: "text/x-haxe", mode: "haxe", ext: ["hx"]},
    {name: "HXML", mime: "text/x-hxml", mode: "haxe", ext: ["hxml"]},
    {name: "ASP.NET", mime: "application/x-aspx", mode: "htmlembedded", ext: ["aspx"], alias: ["asp", "aspx"]},
    {name: "HTML", mime: "text/html", mode: "htmlmixed", ext: ["html", "htm", "handlebars", "hbs"], alias: ["xhtml"]},
    {name: "HTTP", mime: "message/http", mode: "http"},
    {name: "IDL", mime: "text/x-idl", mode: "idl", ext: ["pro"]},
    {name: "Pug", mime: "text/x-pug", mode: "pug", ext: ["jade", "pug"], alias: ["jade"]},
    {name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"]},
    {name: "Java Server Pages", mime: "application/x-jsp", mode: "htmlembedded", ext: ["jsp"], alias: ["jsp"]},
    {name: "JavaScript", mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
     mode: "javascript", ext: ["js"], alias: ["ecmascript", "js", "node"]},
    {name: "JSON", mimes: ["application/json", "application/x-json"], mode: "javascript", ext: ["json", "map"], alias: ["json5"]},
    {name: "JSON-LD", mime: "application/ld+json", mode: "javascript", ext: ["jsonld"], alias: ["jsonld"]},
    {name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"]},
    {name: "Jinja2", mime: "text/jinja2", mode: "jinja2", ext: ["j2", "jinja", "jinja2"]},
    {name: "Julia", mime: "text/x-julia", mode: "julia", ext: ["jl"], alias: ["jl"]},
    {name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"]},
    {name: "LESS", mime: "text/x-less", mode: "css", ext: ["less"]},
    {name: "LiveScript", mime: "text/x-livescript", mode: "livescript", ext: ["ls"], alias: ["ls"]},
    {name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"]},
    {name: "Markdown", mime: "text/x-markdown", mode: "markdown", ext: ["markdown", "md", "mkd"]},
    {name: "mIRC", mime: "text/mirc", mode: "mirc"},
    {name: "MariaDB SQL", mime: "text/x-mariadb", mode: "sql"},
    {name: "Mathematica", mime: "text/x-mathematica", mode: "mathematica", ext: ["m", "nb", "wl", "wls"]},
    {name: "Modelica", mime: "text/x-modelica", mode: "modelica", ext: ["mo"]},
    {name: "MUMPS", mime: "text/x-mumps", mode: "mumps", ext: ["mps"]},
    {name: "MS SQL", mime: "text/x-mssql", mode: "sql"},
    {name: "mbox", mime: "application/mbox", mode: "mbox", ext: ["mbox"]},
    {name: "MySQL", mime: "text/x-mysql", mode: "sql"},
    {name: "Nginx", mime: "text/x-nginx-conf", mode: "nginx", file: /nginx.*\.conf$/i},
    {name: "NSIS", mime: "text/x-nsis", mode: "nsis", ext: ["nsh", "nsi"]},
    {name: "NTriples", mimes: ["application/n-triples", "application/n-quads", "text/n-triples"],
     mode: "ntriples", ext: ["nt", "nq"]},
    {name: "Objective-C", mime: "text/x-objectivec", mode: "clike", ext: ["m"], alias: ["objective-c", "objc"]},
    {name: "Objective-C++", mime: "text/x-objectivec++", mode: "clike", ext: ["mm"], alias: ["objective-c++", "objc++"]},
    {name: "OCaml", mime: "text/x-ocaml", mode: "mllike", ext: ["ml", "mli", "mll", "mly"]},
    {name: "Octave", mime: "text/x-octave", mode: "octave", ext: ["m"]},
    {name: "Oz", mime: "text/x-oz", mode: "oz", ext: ["oz"]},
    {name: "Pascal", mime: "text/x-pascal", mode: "pascal", ext: ["p", "pas"]},
    {name: "PEG.js", mime: "null", mode: "pegjs", ext: ["jsonld"]},
    {name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"]},
    {name: "PHP", mimes: ["text/x-php", "application/x-httpd-php", "application/x-httpd-php-open"], mode: "php", ext: ["php", "php3", "php4", "php5", "php7", "phtml"]},
    {name: "Pig", mime: "text/x-pig", mode: "pig", ext: ["pig"]},
    {name: "Plain Text", mime: "text/plain", mode: "null", ext: ["txt", "text", "conf", "def", "list", "log"]},
    {name: "PLSQL", mime: "text/x-plsql", mode: "sql", ext: ["pls"]},
    {name: "PostgreSQL", mime: "text/x-pgsql", mode: "sql"},
    {name: "PowerShell", mime: "application/x-powershell", mode: "powershell", ext: ["ps1", "psd1", "psm1"]},
    {name: "Properties files", mime: "text/x-properties", mode: "properties", ext: ["properties", "ini", "in"], alias: ["ini", "properties"]},
    {name: "ProtoBuf", mime: "text/x-protobuf", mode: "protobuf", ext: ["proto"]},
    {name: "Python", mime: "text/x-python", mode: "python", ext: ["BUILD", "bzl", "py", "pyw"], file: /^(BUCK|BUILD)$/},
    {name: "Puppet", mime: "text/x-puppet", mode: "puppet", ext: ["pp"]},
    {name: "Q", mime: "text/x-q", mode: "q", ext: ["q"]},
    {name: "R", mime: "text/x-rsrc", mode: "r", ext: ["r", "R"], alias: ["rscript"]},
    {name: "reStructuredText", mime: "text/x-rst", mode: "rst", ext: ["rst"], alias: ["rst"]},
    {name: "RPM Changes", mime: "text/x-rpm-changes", mode: "rpm"},
    {name: "RPM Spec", mime: "text/x-rpm-spec", mode: "rpm", ext: ["spec"]},
    {name: "Ruby", mime: "text/x-ruby", mode: "ruby", ext: ["rb"], alias: ["jruby", "macruby", "rake", "rb", "rbx"]},
    {name: "Rust", mime: "text/x-rustsrc", mode: "rust", ext: ["rs"]},
    {name: "SAS", mime: "text/x-sas", mode: "sas", ext: ["sas"]},
    {name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"]},
    {name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"]},
    {name: "Scheme", mime: "text/x-scheme", mode: "scheme", ext: ["scm", "ss"]},
    {name: "SCSS", mime: "text/x-scss", mode: "css", ext: ["scss"]},
    {name: "Shell", mimes: ["text/x-sh", "application/x-sh"], mode: "shell", ext: ["sh", "ksh", "bash"], alias: ["bash", "sh", "zsh"], file: /^PKGBUILD$/},
    {name: "Sieve", mime: "application/sieve", mode: "sieve", ext: ["siv", "sieve"]},
    {name: "Slim", mimes: ["text/x-slim", "application/x-slim"], mode: "slim", ext: ["slim"]},
    {name: "Smalltalk", mime: "text/x-stsrc", mode: "smalltalk", ext: ["st"]},
    {name: "Smarty", mime: "text/x-smarty", mode: "smarty", ext: ["tpl"]},
    {name: "Solr", mime: "text/x-solr", mode: "solr"},
    {name: "SML", mime: "text/x-sml", mode: "mllike", ext: ["sml", "sig", "fun", "smackspec"]},
    {name: "Soy", mime: "text/x-soy", mode: "soy", ext: ["soy"], alias: ["closure template"]},
    {name: "SPARQL", mime: "application/sparql-query", mode: "sparql", ext: ["rq", "sparql"], alias: ["sparul"]},
    {name: "Spreadsheet", mime: "text/x-spreadsheet", mode: "spreadsheet", alias: ["excel", "formula"]},
    {name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"]},
    {name: "SQLite", mime: "text/x-sqlite", mode: "sql"},
    {name: "Squirrel", mime: "text/x-squirrel", mode: "clike", ext: ["nut"]},
    {name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"]},
    {name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"]},
    {name: "sTeX", mime: "text/x-stex", mode: "stex"},
    {name: "LaTeX", mime: "text/x-latex", mode: "stex", ext: ["text", "ltx", "tex"], alias: ["tex"]},
    {name: "SystemVerilog", mime: "text/x-systemverilog", mode: "verilog", ext: ["v", "sv", "svh"]},
    {name: "Tcl", mime: "text/x-tcl", mode: "tcl", ext: ["tcl"]},
    {name: "Textile", mime: "text/x-textile", mode: "textile", ext: ["textile"]},
    {name: "TiddlyWiki", mime: "text/x-tiddlywiki", mode: "tiddlywiki"},
    {name: "Tiki wiki", mime: "text/tiki", mode: "tiki"},
    {name: "TOML", mime: "text/x-toml", mode: "toml", ext: ["toml"]},
    {name: "Tornado", mime: "text/x-tornado", mode: "tornado"},
    {name: "troff", mime: "text/troff", mode: "troff", ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]},
    {name: "TTCN", mime: "text/x-ttcn", mode: "ttcn", ext: ["ttcn", "ttcn3", "ttcnpp"]},
    {name: "TTCN_CFG", mime: "text/x-ttcn-cfg", mode: "ttcn-cfg", ext: ["cfg"]},
    {name: "Turtle", mime: "text/turtle", mode: "turtle", ext: ["ttl"]},
    {name: "TypeScript", mime: "application/typescript", mode: "javascript", ext: ["ts"], alias: ["ts"]},
    {name: "TypeScript-JSX", mime: "text/typescript-jsx", mode: "jsx", ext: ["tsx"], alias: ["tsx"]},
    {name: "Twig", mime: "text/x-twig", mode: "twig"},
    {name: "Web IDL", mime: "text/x-webidl", mode: "webidl", ext: ["webidl"]},
    {name: "VB.NET", mime: "text/x-vb", mode: "vb", ext: ["vb"]},
    {name: "VBScript", mime: "text/vbscript", mode: "vbscript", ext: ["vbs"]},
    {name: "Velocity", mime: "text/velocity", mode: "velocity", ext: ["vtl"]},
    {name: "Verilog", mime: "text/x-verilog", mode: "verilog", ext: ["v"]},
    {name: "VHDL", mime: "text/x-vhdl", mode: "vhdl", ext: ["vhd", "vhdl"]},
    {name: "Vue.js Component", mimes: ["script/x-vue", "text/x-vue"], mode: "vue", ext: ["vue"]},
    {name: "XML", mimes: ["application/xml", "text/xml"], mode: "xml", ext: ["xml", "xsl", "xsd", "svg"], alias: ["rss", "wsdl", "xsd"]},
    {name: "XQuery", mime: "application/xquery", mode: "xquery", ext: ["xy", "xquery"]},
    {name: "Yacas", mime: "text/x-yacas", mode: "yacas", ext: ["ys"]},
    {name: "YAML", mimes: ["text/x-yaml", "text/yaml"], mode: "yaml", ext: ["yaml", "yml"], alias: ["yml"]},
    {name: "Z80", mime: "text/x-z80", mode: "z80", ext: ["z80"]},
    {name: "mscgen", mime: "text/x-mscgen", mode: "mscgen", ext: ["mscgen", "mscin", "msc"]},
    {name: "xu", mime: "text/x-xu", mode: "mscgen", ext: ["xu"]},
    {name: "msgenny", mime: "text/x-msgenny", mode: "mscgen", ext: ["msgenny"]},
    {name: "WebAssembly", mime: "text/webassembly", mode: "wast", ext: ["wat", "wast"]},
  ];
  // Ensure all modes have a mime property for backwards compatibility
  for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
    var info = CodeMirror.modeInfo[i];
    if (info.mimes) info.mime = info.mimes[0];
  }

  CodeMirror.findModeByMIME = function(mime) {
    mime = mime.toLowerCase();
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.mime == mime) return info;
      if (info.mimes) for (var j = 0; j < info.mimes.length; j++)
        if (info.mimes[j] == mime) return info;
    }
    if (/\+xml$/.test(mime)) return CodeMirror.findModeByMIME("application/xml")
    if (/\+json$/.test(mime)) return CodeMirror.findModeByMIME("application/json")
  };

  CodeMirror.findModeByExtension = function(ext) {
    ext = ext.toLowerCase();
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.ext) for (var j = 0; j < info.ext.length; j++)
        if (info.ext[j] == ext) return info;
    }
  };

  CodeMirror.findModeByFileName = function(filename) {
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.file && info.file.test(filename)) return info;
    }
    var dot = filename.lastIndexOf(".");
    var ext = dot > -1 && filename.substring(dot + 1, filename.length);
    if (ext) return CodeMirror.findModeByExtension(ext);
  };

  CodeMirror.findModeByName = function(name) {
    name = name.toLowerCase();
    for (var i = 0; i < CodeMirror.modeInfo.length; i++) {
      var info = CodeMirror.modeInfo[i];
      if (info.name.toLowerCase() == name) return info;
      if (info.alias) for (var j = 0; j < info.alias.length; j++)
        if (info.alias[j].toLowerCase() == name) return info;
    }
  };
});


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  CodeMirror.defineOption("placeholder", "", function(cm, val, old) {
    var prev = old && old != CodeMirror.Init;
    if (val && !prev) {
      cm.on("blur", onBlur);
      cm.on("change", onChange);
      cm.on("swapDoc", onChange);
      CodeMirror.on(cm.getInputField(), "compositionupdate", cm.state.placeholderCompose = function() { onComposition(cm) })
      onChange(cm);
    } else if (!val && prev) {
      cm.off("blur", onBlur);
      cm.off("change", onChange);
      cm.off("swapDoc", onChange);
      CodeMirror.off(cm.getInputField(), "compositionupdate", cm.state.placeholderCompose)
      clearPlaceholder(cm);
      var wrapper = cm.getWrapperElement();
      wrapper.className = wrapper.className.replace(" CodeMirror-empty", "");
    }

    if (val && !cm.hasFocus()) onBlur(cm);
  });

  function clearPlaceholder(cm) {
    if (cm.state.placeholder) {
      cm.state.placeholder.parentNode.removeChild(cm.state.placeholder);
      cm.state.placeholder = null;
    }
  }
  function setPlaceholder(cm) {
    clearPlaceholder(cm);
    var elt = cm.state.placeholder = document.createElement("pre");
    elt.style.cssText = "height: 0; overflow: visible";
    elt.style.direction = cm.getOption("direction");
    elt.className = "CodeMirror-placeholder CodeMirror-line-like";
    var placeHolder = cm.getOption("placeholder")
    if (typeof placeHolder == "string") placeHolder = document.createTextNode(placeHolder)
    elt.appendChild(placeHolder)
    cm.display.lineSpace.insertBefore(elt, cm.display.lineSpace.firstChild);
  }

  function onComposition(cm) {
    setTimeout(function() {
      var empty = false
      if (cm.lineCount() == 1) {
        var input = cm.getInputField()
        empty = input.nodeName == "TEXTAREA" ? !cm.getLine(0).length
          : !/[^\u200b]/.test(input.querySelector(".CodeMirror-line").textContent)
      }
      if (empty) setPlaceholder(cm)
      else clearPlaceholder(cm)
    }, 20)
  }

  function onBlur(cm) {
    if (isEmpty(cm)) setPlaceholder(cm);
  }
  function onChange(cm) {
    var wrapper = cm.getWrapperElement(), empty = isEmpty(cm);
    wrapper.className = wrapper.className.replace(" CodeMirror-empty", "") + (empty ? " CodeMirror-empty" : "");

    if (empty) setPlaceholder(cm);
    else clearPlaceholder(cm);
  }

  function isEmpty(cm) {
    return (cm.lineCount() === 1) && (cm.getLine(0) === "");
  }
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

// Because sometimes you need to mark the selected *text*.
//
// Adds an option 'styleSelectedText' which, when enabled, gives
// selected text the CSS class given as option value, or
// "CodeMirror-selectedtext" when the value is not a string.

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  CodeMirror.defineOption("styleSelectedText", false, function(cm, val, old) {
    var prev = old && old != CodeMirror.Init;
    if (val && !prev) {
      cm.state.markedSelection = [];
      cm.state.markedSelectionStyle = typeof val == "string" ? val : "CodeMirror-selectedtext";
      reset(cm);
      cm.on("cursorActivity", onCursorActivity);
      cm.on("change", onChange);
    } else if (!val && prev) {
      cm.off("cursorActivity", onCursorActivity);
      cm.off("change", onChange);
      clear(cm);
      cm.state.markedSelection = cm.state.markedSelectionStyle = null;
    }
  });

  function onCursorActivity(cm) {
    if (cm.state.markedSelection)
      cm.operation(function() { update(cm); });
  }

  function onChange(cm) {
    if (cm.state.markedSelection && cm.state.markedSelection.length)
      cm.operation(function() { clear(cm); });
  }

  var CHUNK_SIZE = 8;
  var Pos = CodeMirror.Pos;
  var cmp = CodeMirror.cmpPos;

  function coverRange(cm, from, to, addAt) {
    if (cmp(from, to) == 0) return;
    var array = cm.state.markedSelection;
    var cls = cm.state.markedSelectionStyle;
    for (var line = from.line;;) {
      var start = line == from.line ? from : Pos(line, 0);
      var endLine = line + CHUNK_SIZE, atEnd = endLine >= to.line;
      var end = atEnd ? to : Pos(endLine, 0);
      var mark = cm.markText(start, end, {className: cls});
      if (addAt == null) array.push(mark);
      else array.splice(addAt++, 0, mark);
      if (atEnd) break;
      line = endLine;
    }
  }

  function clear(cm) {
    var array = cm.state.markedSelection;
    for (var i = 0; i < array.length; ++i) array[i].clear();
    array.length = 0;
  }

  function reset(cm) {
    clear(cm);
    var ranges = cm.listSelections();
    for (var i = 0; i < ranges.length; i++)
      coverRange(cm, ranges[i].from(), ranges[i].to());
  }

  function update(cm) {
    if (!cm.somethingSelected()) return clear(cm);
    if (cm.listSelections().length > 1) return reset(cm);

    var from = cm.getCursor("start"), to = cm.getCursor("end");

    var array = cm.state.markedSelection;
    if (!array.length) return coverRange(cm, from, to);

    var coverStart = array[0].find(), coverEnd = array[array.length - 1].find();
    if (!coverStart || !coverEnd || to.line - from.line <= CHUNK_SIZE ||
        cmp(from, coverEnd.to) >= 0 || cmp(to, coverStart.from) <= 0)
      return reset(cm);

    while (cmp(from, coverStart.from) > 0) {
      array.shift().clear();
      coverStart = array[0].find();
    }
    if (cmp(from, coverStart.from) < 0) {
      if (coverStart.to.line - from.line < CHUNK_SIZE) {
        array.shift().clear();
        coverRange(cm, from, coverStart.to, 0);
      } else {
        coverRange(cm, from, coverStart.from, 0);
      }
    }

    while (cmp(to, coverEnd.to) < 0) {
      array.pop().clear();
      coverEnd = array[array.length - 1].find();
    }
    if (cmp(to, coverEnd.to) > 0) {
      if (to.line - coverEnd.from.line < CHUNK_SIZE) {
        array.pop().clear();
        coverRange(cm, coverEnd.from, to);
      } else {
        coverRange(cm, coverEnd.to, to);
      }
    }
  }
});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(113), __webpack_require__(592), __webpack_require__(594));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror", "../markdown/markdown", "../../addon/mode/overlay"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

var urlRE = /^((?:(?:aaas?|about|acap|adiumxtra|af[ps]|aim|apt|attachment|aw|beshare|bitcoin|bolo|callto|cap|chrome(?:-extension)?|cid|coap|com-eventbrite-attendee|content|crid|cvs|data|dav|dict|dlna-(?:playcontainer|playsingle)|dns|doi|dtn|dvb|ed2k|facetime|feed|file|finger|fish|ftp|geo|gg|git|gizmoproject|go|gopher|gtalk|h323|hcp|https?|iax|icap|icon|im|imap|info|ipn|ipp|irc[6s]?|iris(?:\.beep|\.lwz|\.xpc|\.xpcs)?|itms|jar|javascript|jms|keyparc|lastfm|ldaps?|magnet|mailto|maps|market|message|mid|mms|ms-help|msnim|msrps?|mtqp|mumble|mupdate|mvn|news|nfs|nih?|nntp|notes|oid|opaquelocktoken|palm|paparazzi|platform|pop|pres|proxy|psyc|query|res(?:ource)?|rmi|rsync|rtmp|rtsp|secondlife|service|session|sftp|sgn|shttp|sieve|sips?|skype|sm[bs]|snmp|soap\.beeps?|soldat|spotify|ssh|steam|svn|tag|teamspeak|tel(?:net)?|tftp|things|thismessage|tip|tn3270|tv|udp|unreal|urn|ut2004|vemmi|ventrilo|view-source|webcal|wss?|wtai|wyciwyg|xcon(?:-userid)?|xfire|xmlrpc\.beeps?|xmpp|xri|ymsgr|z39\.50[rs]?):(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]|\([^\s()<>]*\))+(?:\([^\s()<>]*\)|[^\s`*!()\[\]{};:'".,<>?«»“”‘’]))/i

CodeMirror.defineMode("gfm", function(config, modeConfig) {
  var codeDepth = 0;
  function blankLine(state) {
    state.code = false;
    return null;
  }
  var gfmOverlay = {
    startState: function() {
      return {
        code: false,
        codeBlock: false,
        ateSpace: false
      };
    },
    copyState: function(s) {
      return {
        code: s.code,
        codeBlock: s.codeBlock,
        ateSpace: s.ateSpace
      };
    },
    token: function(stream, state) {
      state.combineTokens = null;

      // Hack to prevent formatting override inside code blocks (block and inline)
      if (state.codeBlock) {
        if (stream.match(/^```+/)) {
          state.codeBlock = false;
          return null;
        }
        stream.skipToEnd();
        return null;
      }
      if (stream.sol()) {
        state.code = false;
      }
      if (stream.sol() && stream.match(/^```+/)) {
        stream.skipToEnd();
        state.codeBlock = true;
        return null;
      }
      // If this block is changed, it may need to be updated in Markdown mode
      if (stream.peek() === '`') {
        stream.next();
        var before = stream.pos;
        stream.eatWhile('`');
        var difference = 1 + stream.pos - before;
        if (!state.code) {
          codeDepth = difference;
          state.code = true;
        } else {
          if (difference === codeDepth) { // Must be exact
            state.code = false;
          }
        }
        return null;
      } else if (state.code) {
        stream.next();
        return null;
      }
      // Check if space. If so, links can be formatted later on
      if (stream.eatSpace()) {
        state.ateSpace = true;
        return null;
      }
      if (stream.sol() || state.ateSpace) {
        state.ateSpace = false;
        if (modeConfig.gitHubSpice !== false) {
          if(stream.match(/^(?:[a-zA-Z0-9\-_]+\/)?(?:[a-zA-Z0-9\-_]+@)?(?=.{0,6}\d)(?:[a-f0-9]{7,40}\b)/)) {
            // User/Project@SHA
            // User@SHA
            // SHA
            state.combineTokens = true;
            return "link";
          } else if (stream.match(/^(?:[a-zA-Z0-9\-_]+\/)?(?:[a-zA-Z0-9\-_]+)?#[0-9]+\b/)) {
            // User/Project#Num
            // User#Num
            // #Num
            state.combineTokens = true;
            return "link";
          }
        }
      }
      if (stream.match(urlRE) &&
          stream.string.slice(stream.start - 2, stream.start) != "](" &&
          (stream.start == 0 || /\W/.test(stream.string.charAt(stream.start - 1)))) {
        // URLs
        // Taken from http://daringfireball.net/2010/07/improved_regex_for_matching_urls
        // And then (issue #1160) simplified to make it not crash the Chrome Regexp engine
        // And then limited url schemes to the CommonMark list, so foo:bar isn't matched as a URL
        state.combineTokens = true;
        return "link";
      }
      stream.next();
      return null;
    },
    blankLine: blankLine
  };

  var markdownConfig = {
    taskLists: true,
    strikethrough: true,
    emoji: true
  };
  for (var attr in modeConfig) {
    markdownConfig[attr] = modeConfig[attr];
  }
  markdownConfig.name = "markdown";
  return CodeMirror.overlayMode(CodeMirror.getMode(config, markdownConfig), gfmOverlay);

}, "markdown");

  CodeMirror.defineMIME("text/x-gfm", "gfm");
});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Use strict mode (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Strict_mode)



// Requires
var Typo = __webpack_require__(1209);


// Create function
function CodeMirrorSpellChecker(options) {
	// Initialize
	options = options || {};


	// Verify
	if(typeof options.codeMirrorInstance !== "function" || typeof options.codeMirrorInstance.defineMode !== "function") {
		console.log("CodeMirror Spell Checker: You must provide an instance of CodeMirror via the option `codeMirrorInstance`");
		return;
	}


	// Because some browsers don't support this functionality yet
	if(!String.prototype.includes) {
		String.prototype.includes = function() {
			"use strict";
			return String.prototype.indexOf.apply(this, arguments) !== -1;
		};
	}


	// Define the new mode
	options.codeMirrorInstance.defineMode("spell-checker", function(config) {
		// Load AFF/DIC data
		if(!CodeMirrorSpellChecker.aff_loading) {
			CodeMirrorSpellChecker.aff_loading = true;
			var xhr_aff = new XMLHttpRequest();
			xhr_aff.open("GET", "https://cdn.jsdelivr.net/codemirror.spell-checker/latest/en_US.aff", true);
			xhr_aff.onload = function() {
				if(xhr_aff.readyState === 4 && xhr_aff.status === 200) {
					CodeMirrorSpellChecker.aff_data = xhr_aff.responseText;
					CodeMirrorSpellChecker.num_loaded++;

					if(CodeMirrorSpellChecker.num_loaded == 2) {
						CodeMirrorSpellChecker.typo = new Typo("en_US", CodeMirrorSpellChecker.aff_data, CodeMirrorSpellChecker.dic_data, {
							platform: "any"
						});
					}
				}
			};
			xhr_aff.send(null);
		}

		if(!CodeMirrorSpellChecker.dic_loading) {
			CodeMirrorSpellChecker.dic_loading = true;
			var xhr_dic = new XMLHttpRequest();
			xhr_dic.open("GET", "https://cdn.jsdelivr.net/codemirror.spell-checker/latest/en_US.dic", true);
			xhr_dic.onload = function() {
				if(xhr_dic.readyState === 4 && xhr_dic.status === 200) {
					CodeMirrorSpellChecker.dic_data = xhr_dic.responseText;
					CodeMirrorSpellChecker.num_loaded++;

					if(CodeMirrorSpellChecker.num_loaded == 2) {
						CodeMirrorSpellChecker.typo = new Typo("en_US", CodeMirrorSpellChecker.aff_data, CodeMirrorSpellChecker.dic_data, {
							platform: "any"
						});
					}
				}
			};
			xhr_dic.send(null);
		}


		// Define what separates a word
		var rx_word = "!\"#$%&()*+,-./:;<=>?@[\\]^_`{|}~ ";


		// Create the overlay and such
		var overlay = {
			token: function(stream) {
				var ch = stream.peek();
				var word = "";

				if(rx_word.includes(ch)) {
					stream.next();
					return null;
				}

				while((ch = stream.peek()) != null && !rx_word.includes(ch)) {
					word += ch;
					stream.next();
				}

				if(CodeMirrorSpellChecker.typo && !CodeMirrorSpellChecker.typo.check(word))
					return "spell-error"; // CSS class: cm-spell-error

				return null;
			}
		};

		var mode = options.codeMirrorInstance.getMode(
			config, config.backdrop || "text/plain"
		);

		return options.codeMirrorInstance.overlayMode(mode, overlay, true);
	});
}


// Initialize data globally to reduce memory consumption
CodeMirrorSpellChecker.num_loaded = 0;
CodeMirrorSpellChecker.aff_loading = false;
CodeMirrorSpellChecker.dic_loading = false;
CodeMirrorSpellChecker.aff_data = "";
CodeMirrorSpellChecker.dic_data = "";
CodeMirrorSpellChecker.typo;


// Export
module.exports = CodeMirrorSpellChecker;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {/* globals chrome: false */
/* globals __dirname: false */
/* globals require: false */
/* globals Buffer: false */
/* globals module: false */

/**
 * Typo is a JavaScript implementation of a spellchecker using hunspell-style 
 * dictionaries.
 */

var Typo;

(function () {
"use strict";

/**
 * Typo constructor.
 *
 * @param {String} [dictionary] The locale code of the dictionary being used. e.g.,
 *                              "en_US". This is only used to auto-load dictionaries.
 * @param {String} [affData]    The data from the dictionary's .aff file. If omitted
 *                              and Typo.js is being used in a Chrome extension, the .aff
 *                              file will be loaded automatically from
 *                              lib/typo/dictionaries/[dictionary]/[dictionary].aff
 *                              In other environments, it will be loaded from
 *                              [settings.dictionaryPath]/dictionaries/[dictionary]/[dictionary].aff
 * @param {String} [wordsData]  The data from the dictionary's .dic file. If omitted
 *                              and Typo.js is being used in a Chrome extension, the .dic
 *                              file will be loaded automatically from
 *                              lib/typo/dictionaries/[dictionary]/[dictionary].dic
 *                              In other environments, it will be loaded from
 *                              [settings.dictionaryPath]/dictionaries/[dictionary]/[dictionary].dic
 * @param {Object} [settings]   Constructor settings. Available properties are:
 *                              {String} [dictionaryPath]: path to load dictionary from in non-chrome
 *                              environment.
 *                              {Object} [flags]: flag information.
 *                              {Boolean} [asyncLoad]: If true, affData and wordsData will be loaded
 *                              asynchronously.
 *                              {Function} [loadedCallback]: Called when both affData and wordsData
 *                              have been loaded. Only used if asyncLoad is set to true. The parameter
 *                              is the instantiated Typo object.
 *
 * @returns {Typo} A Typo object.
 */

Typo = function (dictionary, affData, wordsData, settings) {
	settings = settings || {};

	this.dictionary = null;
	
	this.rules = {};
	this.dictionaryTable = {};
	
	this.compoundRules = [];
	this.compoundRuleCodes = {};
	
	this.replacementTable = [];
	
	this.flags = settings.flags || {}; 
	
	this.memoized = {};

	this.loaded = false;
	
	var self = this;
	
	var path;
	
	// Loop-control variables.
	var i, j, _len, _jlen;
	
	if (dictionary) {
		self.dictionary = dictionary;
		
		// If the data is preloaded, just setup the Typo object.
		if (affData && wordsData) {
			setup();
		}
		// Loading data for Chrome extentions.
		else if (typeof window !== 'undefined' && 'chrome' in window && 'extension' in window.chrome && 'getURL' in window.chrome.extension) {
			if (settings.dictionaryPath) {
				path = settings.dictionaryPath;
			}
			else {
				path = "typo/dictionaries";
			}
			
			if (!affData) readDataFile(chrome.extension.getURL(path + "/" + dictionary + "/" + dictionary + ".aff"), setAffData);
			if (!wordsData) readDataFile(chrome.extension.getURL(path + "/" + dictionary + "/" + dictionary + ".dic"), setWordsData);
		}
		else {
			if (settings.dictionaryPath) {
				path = settings.dictionaryPath;
			}
			else if (true) {
				path = __dirname + '/dictionaries';
			}
			else {
				path = './dictionaries';
			}
			
			if (!affData) readDataFile(path + "/" + dictionary + "/" + dictionary + ".aff", setAffData);
			if (!wordsData) readDataFile(path + "/" + dictionary + "/" + dictionary + ".dic", setWordsData);
		}
	}
	
	function readDataFile(url, setFunc) {
		var response = self._readFile(url, null, settings.asyncLoad);
		
		if (settings.asyncLoad) {
			response.then(function(data) {
				setFunc(data);
			});
		}
		else {
			setFunc(response);
		}
	}

	function setAffData(data) {
		affData = data;

		if (wordsData) {
			setup();
		}
	}

	function setWordsData(data) {
		wordsData = data;

		if (affData) {
			setup();
		}
	}

	function setup() {
		self.rules = self._parseAFF(affData);
		
		// Save the rule codes that are used in compound rules.
		self.compoundRuleCodes = {};
		
		for (i = 0, _len = self.compoundRules.length; i < _len; i++) {
			var rule = self.compoundRules[i];
			
			for (j = 0, _jlen = rule.length; j < _jlen; j++) {
				self.compoundRuleCodes[rule[j]] = [];
			}
		}
		
		// If we add this ONLYINCOMPOUND flag to self.compoundRuleCodes, then _parseDIC
		// will do the work of saving the list of words that are compound-only.
		if ("ONLYINCOMPOUND" in self.flags) {
			self.compoundRuleCodes[self.flags.ONLYINCOMPOUND] = [];
		}
		
		self.dictionaryTable = self._parseDIC(wordsData);
		
		// Get rid of any codes from the compound rule codes that are never used 
		// (or that were special regex characters).  Not especially necessary... 
		for (i in self.compoundRuleCodes) {
			if (self.compoundRuleCodes[i].length === 0) {
				delete self.compoundRuleCodes[i];
			}
		}
		
		// Build the full regular expressions for each compound rule.
		// I have a feeling (but no confirmation yet) that this method of 
		// testing for compound words is probably slow.
		for (i = 0, _len = self.compoundRules.length; i < _len; i++) {
			var ruleText = self.compoundRules[i];
			
			var expressionText = "";
			
			for (j = 0, _jlen = ruleText.length; j < _jlen; j++) {
				var character = ruleText[j];
				
				if (character in self.compoundRuleCodes) {
					expressionText += "(" + self.compoundRuleCodes[character].join("|") + ")";
				}
				else {
					expressionText += character;
				}
			}
			
			self.compoundRules[i] = new RegExp(expressionText, "i");
		}
		
		self.loaded = true;
		
		if (settings.asyncLoad && settings.loadedCallback) {
			settings.loadedCallback(self);
		}
	}
	
	return this;
};

Typo.prototype = {
	/**
	 * Loads a Typo instance from a hash of all of the Typo properties.
	 *
	 * @param object obj A hash of Typo properties, probably gotten from a JSON.parse(JSON.stringify(typo_instance)).
	 */
	
	load : function (obj) {
		for (var i in obj) {
			if (obj.hasOwnProperty(i)) {
				this[i] = obj[i];
			}
		}
		
		return this;
	},
	
	/**
	 * Read the contents of a file.
	 * 
	 * @param {String} path The path (relative) to the file.
	 * @param {String} [charset="ISO8859-1"] The expected charset of the file
	 * @param {Boolean} async If true, the file will be read asynchronously. For node.js this does nothing, all
	 *        files are read synchronously.
	 * @returns {String} The file data if async is false, otherwise a promise object. If running node.js, the data is
	 *          always returned.
	 */
	
	_readFile : function (path, charset, async) {
		charset = charset || "utf8";
		
		if (typeof XMLHttpRequest !== 'undefined') {
			var promise;
			var req = new XMLHttpRequest();
			req.open("GET", path, async);
			
			if (async) {
				promise = new Promise(function(resolve, reject) {
					req.onload = function() {
						if (req.status === 200) {
							resolve(req.responseText);
						}
						else {
							reject(req.statusText);
						}
					};
					
					req.onerror = function() {
						reject(req.statusText);
					}
				});
			}
		
			if (req.overrideMimeType)
				req.overrideMimeType("text/plain; charset=" + charset);
		
			req.send(null);
			
			return async ? promise : req.responseText;
		}
		else if (true) {
			// Node.js
			var fs = __webpack_require__(1210);
			
			try {
				if (fs.existsSync(path)) {
					return fs.readFileSync(path, charset);
				}
				else {
					console.log("Path " + path + " does not exist.");
				}
			} catch (e) {
				console.log(e);
				return '';
			}
		}
	},
	
	/**
	 * Parse the rules out from a .aff file.
	 *
	 * @param {String} data The contents of the affix file.
	 * @returns object The rules from the file.
	 */
	
	_parseAFF : function (data) {
		var rules = {};
		
		var line, subline, numEntries, lineParts;
		var i, j, _len, _jlen;
		
		// Remove comment lines
		data = this._removeAffixComments(data);
		
		var lines = data.split(/\r?\n/);
		
		for (i = 0, _len = lines.length; i < _len; i++) {
			line = lines[i];
			
			var definitionParts = line.split(/\s+/);
			
			var ruleType = definitionParts[0];
			
			if (ruleType == "PFX" || ruleType == "SFX") {
				var ruleCode = definitionParts[1];
				var combineable = definitionParts[2];
				numEntries = parseInt(definitionParts[3], 10);
				
				var entries = [];
				
				for (j = i + 1, _jlen = i + 1 + numEntries; j < _jlen; j++) {
					subline = lines[j];
					
					lineParts = subline.split(/\s+/);
					var charactersToRemove = lineParts[2];
					
					var additionParts = lineParts[3].split("/");
					
					var charactersToAdd = additionParts[0];
					if (charactersToAdd === "0") charactersToAdd = "";
					
					var continuationClasses = this.parseRuleCodes(additionParts[1]);
					
					var regexToMatch = lineParts[4];
					
					var entry = {};
					entry.add = charactersToAdd;
					
					if (continuationClasses.length > 0) entry.continuationClasses = continuationClasses;
					
					if (regexToMatch !== ".") {
						if (ruleType === "SFX") {
							entry.match = new RegExp(regexToMatch + "$");
						}
						else {
							entry.match = new RegExp("^" + regexToMatch);
						}
					}
					
					if (charactersToRemove != "0") {
						if (ruleType === "SFX") {
							entry.remove = new RegExp(charactersToRemove  + "$");
						}
						else {
							entry.remove = charactersToRemove;
						}
					}
					
					entries.push(entry);
				}
				
				rules[ruleCode] = { "type" : ruleType, "combineable" : (combineable == "Y"), "entries" : entries };
				
				i += numEntries;
			}
			else if (ruleType === "COMPOUNDRULE") {
				numEntries = parseInt(definitionParts[1], 10);
				
				for (j = i + 1, _jlen = i + 1 + numEntries; j < _jlen; j++) {
					line = lines[j];
					
					lineParts = line.split(/\s+/);
					this.compoundRules.push(lineParts[1]);
				}
				
				i += numEntries;
			}
			else if (ruleType === "REP") {
				lineParts = line.split(/\s+/);
				
				if (lineParts.length === 3) {
					this.replacementTable.push([ lineParts[1], lineParts[2] ]);
				}
			}
			else {
				// ONLYINCOMPOUND
				// COMPOUNDMIN
				// FLAG
				// KEEPCASE
				// NEEDAFFIX
				
				this.flags[ruleType] = definitionParts[1];
			}
		}
		
		return rules;
	},
	
	/**
	 * Removes comment lines and then cleans up blank lines and trailing whitespace.
	 *
	 * @param {String} data The data from an affix file.
	 * @return {String} The cleaned-up data.
	 */
	
	_removeAffixComments : function (data) {
		// Remove comments
		// This used to remove any string starting with '#' up to the end of the line,
		// but some COMPOUNDRULE definitions include '#' as part of the rule.
		// I haven't seen any affix files that use comments on the same line as real data,
		// so I don't think this will break anything.
		data = data.replace(/^\s*#.*$/mg, "");
		
		// Trim each line
		data = data.replace(/^\s\s*/m, '').replace(/\s\s*$/m, '');
		
		// Remove blank lines.
		data = data.replace(/\n{2,}/g, "\n");
		
		// Trim the entire string
		data = data.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
		
		return data;
	},
	
	/**
	 * Parses the words out from the .dic file.
	 *
	 * @param {String} data The data from the dictionary file.
	 * @returns object The lookup table containing all of the words and
	 *                 word forms from the dictionary.
	 */
	
	_parseDIC : function (data) {
		data = this._removeDicComments(data);
		
		var lines = data.split(/\r?\n/);
		var dictionaryTable = {};
		
		function addWord(word, rules) {
			// Some dictionaries will list the same word multiple times with different rule sets.
			if (!dictionaryTable.hasOwnProperty(word)) {
				dictionaryTable[word] = null;
			}
			
			if (rules.length > 0) {
				if (dictionaryTable[word] === null) {
					dictionaryTable[word] = [];
				}

				dictionaryTable[word].push(rules);
			}
		}
		
		// The first line is the number of words in the dictionary.
		for (var i = 1, _len = lines.length; i < _len; i++) {
			var line = lines[i];
			
			if (!line) {
				// Ignore empty lines.
				continue;
			}

			var parts = line.split("/", 2);
			
			var word = parts[0];

			// Now for each affix rule, generate that form of the word.
			if (parts.length > 1) {
				var ruleCodesArray = this.parseRuleCodes(parts[1]);
				
				// Save the ruleCodes for compound word situations.
				if (!("NEEDAFFIX" in this.flags) || ruleCodesArray.indexOf(this.flags.NEEDAFFIX) == -1) {
					addWord(word, ruleCodesArray);
				}
				
				for (var j = 0, _jlen = ruleCodesArray.length; j < _jlen; j++) {
					var code = ruleCodesArray[j];
					
					var rule = this.rules[code];
					
					if (rule) {
						var newWords = this._applyRule(word, rule);
						
						for (var ii = 0, _iilen = newWords.length; ii < _iilen; ii++) {
							var newWord = newWords[ii];
							
							addWord(newWord, []);
							
							if (rule.combineable) {
								for (var k = j + 1; k < _jlen; k++) {
									var combineCode = ruleCodesArray[k];
									
									var combineRule = this.rules[combineCode];
									
									if (combineRule) {
										if (combineRule.combineable && (rule.type != combineRule.type)) {
											var otherNewWords = this._applyRule(newWord, combineRule);
											
											for (var iii = 0, _iiilen = otherNewWords.length; iii < _iiilen; iii++) {
												var otherNewWord = otherNewWords[iii];
												addWord(otherNewWord, []);
											}
										}
									}
								}
							}
						}
					}
					
					if (code in this.compoundRuleCodes) {
						this.compoundRuleCodes[code].push(word);
					}
				}
			}
			else {
				addWord(word.trim(), []);
			}
		}
		
		return dictionaryTable;
	},
	
	
	/**
	 * Removes comment lines and then cleans up blank lines and trailing whitespace.
	 *
	 * @param {String} data The data from a .dic file.
	 * @return {String} The cleaned-up data.
	 */
	
	_removeDicComments : function (data) {
		// I can't find any official documentation on it, but at least the de_DE
		// dictionary uses tab-indented lines as comments.
		
		// Remove comments
		data = data.replace(/^\t.*$/mg, "");
		
		return data;
	},
	
	parseRuleCodes : function (textCodes) {
		if (!textCodes) {
			return [];
		}
		else if (!("FLAG" in this.flags)) {
			return textCodes.split("");
		}
		else if (this.flags.FLAG === "long") {
			var flags = [];
			
			for (var i = 0, _len = textCodes.length; i < _len; i += 2) {
				flags.push(textCodes.substr(i, 2));
			}
			
			return flags;
		}
		else if (this.flags.FLAG === "num") {
			return textCodes.split(",");
		}
	},
	
	/**
	 * Applies an affix rule to a word.
	 *
	 * @param {String} word The base word.
	 * @param {Object} rule The affix rule.
	 * @returns {String[]} The new words generated by the rule.
	 */
	
	_applyRule : function (word, rule) {
		var entries = rule.entries;
		var newWords = [];
		
		for (var i = 0, _len = entries.length; i < _len; i++) {
			var entry = entries[i];
			
			if (!entry.match || word.match(entry.match)) {
				var newWord = word;
				
				if (entry.remove) {
					newWord = newWord.replace(entry.remove, "");
				}
				
				if (rule.type === "SFX") {
					newWord = newWord + entry.add;
				}
				else {
					newWord = entry.add + newWord;
				}
				
				newWords.push(newWord);
				
				if ("continuationClasses" in entry) {
					for (var j = 0, _jlen = entry.continuationClasses.length; j < _jlen; j++) {
						var continuationRule = this.rules[entry.continuationClasses[j]];
						
						if (continuationRule) {
							newWords = newWords.concat(this._applyRule(newWord, continuationRule));
						}
						/*
						else {
							// This shouldn't happen, but it does, at least in the de_DE dictionary.
							// I think the author mistakenly supplied lower-case rule codes instead 
							// of upper-case.
						}
						*/
					}
				}
			}
		}
		
		return newWords;
	},
	
	/**
	 * Checks whether a word or a capitalization variant exists in the current dictionary.
	 * The word is trimmed and several variations of capitalizations are checked.
	 * If you want to check a word without any changes made to it, call checkExact()
	 *
	 * @see http://blog.stevenlevithan.com/archives/faster-trim-javascript re:trimming function
	 *
	 * @param {String} aWord The word to check.
	 * @returns {Boolean}
	 */
	
	check : function (aWord) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}
		
		// Remove leading and trailing whitespace
		var trimmedWord = aWord.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
		
		if (this.checkExact(trimmedWord)) {
			return true;
		}
		
		// The exact word is not in the dictionary.
		if (trimmedWord.toUpperCase() === trimmedWord) {
			// The word was supplied in all uppercase.
			// Check for a capitalized form of the word.
			var capitalizedWord = trimmedWord[0] + trimmedWord.substring(1).toLowerCase();
			
			if (this.hasFlag(capitalizedWord, "KEEPCASE")) {
				// Capitalization variants are not allowed for this word.
				return false;
			}
			
			if (this.checkExact(capitalizedWord)) {
				// The all-caps word is a capitalized word spelled correctly.
				return true;
			}

			if (this.checkExact(trimmedWord.toLowerCase())) {
				// The all-caps is a lowercase word spelled correctly.
				return true;
			}
		}
		
		var uncapitalizedWord = trimmedWord[0].toLowerCase() + trimmedWord.substring(1);
		
		if (uncapitalizedWord !== trimmedWord) {
			if (this.hasFlag(uncapitalizedWord, "KEEPCASE")) {
				// Capitalization variants are not allowed for this word.
				return false;
			}
			
			// Check for an uncapitalized form
			if (this.checkExact(uncapitalizedWord)) {
				// The word is spelled correctly but with the first letter capitalized.
				return true;
			}
		}
		
		return false;
	},
	
	/**
	 * Checks whether a word exists in the current dictionary.
	 *
	 * @param {String} word The word to check.
	 * @returns {Boolean}
	 */
	
	checkExact : function (word) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		var ruleCodes = this.dictionaryTable[word];
		
		var i, _len;
		
		if (typeof ruleCodes === 'undefined') {
			// Check if this might be a compound word.
			if ("COMPOUNDMIN" in this.flags && word.length >= this.flags.COMPOUNDMIN) {
				for (i = 0, _len = this.compoundRules.length; i < _len; i++) {
					if (word.match(this.compoundRules[i])) {
						return true;
					}
				}
			}
		}
		else if (ruleCodes === null) {
			// a null (but not undefined) value for an entry in the dictionary table
			// means that the word is in the dictionary but has no flags.
			return true;
		}
		else if (typeof ruleCodes === 'object') { // this.dictionary['hasOwnProperty'] will be a function.
			for (i = 0, _len = ruleCodes.length; i < _len; i++) {
				if (!this.hasFlag(word, "ONLYINCOMPOUND", ruleCodes[i])) {
					return true;
				}
			}
		}

		return false;
	},
	
	/**
	 * Looks up whether a given word is flagged with a given flag.
	 *
	 * @param {String} word The word in question.
	 * @param {String} flag The flag in question.
	 * @return {Boolean}
	 */
	 
	hasFlag : function (word, flag, wordFlags) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		if (flag in this.flags) {
			if (typeof wordFlags === 'undefined') {
				wordFlags = Array.prototype.concat.apply([], this.dictionaryTable[word]);
			}
			
			if (wordFlags && wordFlags.indexOf(this.flags[flag]) !== -1) {
				return true;
			}
		}
		
		return false;
	},
	
	/**
	 * Returns a list of suggestions for a misspelled word.
	 *
	 * @see http://www.norvig.com/spell-correct.html for the basis of this suggestor.
	 * This suggestor is primitive, but it works.
	 *
	 * @param {String} word The misspelling.
	 * @param {Number} [limit=5] The maximum number of suggestions to return.
	 * @returns {String[]} The array of suggestions.
	 */
	
	alphabet : "",
	
	suggest : function (word, limit) {
		if (!this.loaded) {
			throw "Dictionary not loaded.";
		}

		limit = limit || 5;

		if (this.memoized.hasOwnProperty(word)) {
			var memoizedLimit = this.memoized[word]['limit'];

			// Only return the cached list if it's big enough or if there weren't enough suggestions
			// to fill a smaller limit.
			if (limit <= memoizedLimit || this.memoized[word]['suggestions'].length < memoizedLimit) {
				return this.memoized[word]['suggestions'].slice(0, limit);
			}
		}
		
		if (this.check(word)) return [];
		
		// Check the replacement table.
		for (var i = 0, _len = this.replacementTable.length; i < _len; i++) {
			var replacementEntry = this.replacementTable[i];
			
			if (word.indexOf(replacementEntry[0]) !== -1) {
				var correctedWord = word.replace(replacementEntry[0], replacementEntry[1]);
				
				if (this.check(correctedWord)) {
					return [ correctedWord ];
				}
			}
		}
		
		var self = this;
		self.alphabet = "abcdefghijklmnopqrstuvwxyz";
		
		/*
		if (!self.alphabet) {
			// Use the alphabet as implicitly defined by the words in the dictionary.
			var alphaHash = {};
			
			for (var i in self.dictionaryTable) {
				for (var j = 0, _len = i.length; j < _len; j++) {
					alphaHash[i[j]] = true;
				}
			}
			
			for (var i in alphaHash) {
				self.alphabet += i;
			}
			
			var alphaArray = self.alphabet.split("");
			alphaArray.sort();
			self.alphabet = alphaArray.join("");
		}
		*/
		
		/**
		 * Returns a hash keyed by all of the strings that can be made by making a single edit to the word (or words in) `words`
		 * The value of each entry is the number of unique ways that the resulting word can be made.
		 *
		 * @arg mixed words Either a hash keyed by words or a string word to operate on.
		 * @arg bool known_only Whether this function should ignore strings that are not in the dictionary.
		 */
		function edits1(words, known_only) {
			var rv = {};
			
			var i, j, _iilen, _len, _jlen, _edit;

			var alphabetLength = self.alphabet.length;
			
			if (typeof words == 'string') {
				var word = words;
				words = {};
				words[word] = true;
			}

			for (var word in words) {
				for (i = 0, _len = word.length + 1; i < _len; i++) {
					var s = [ word.substring(0, i), word.substring(i) ];
				
					// Remove a letter.
					if (s[1]) {
						_edit = s[0] + s[1].substring(1);

						if (!known_only || self.check(_edit)) {
							if (!(_edit in rv)) {
								rv[_edit] = 1;
							}
							else {
								rv[_edit] += 1;
							}
						}
					}
					
					// Transpose letters
					// Eliminate transpositions of identical letters
					if (s[1].length > 1 && s[1][1] !== s[1][0]) {
						_edit = s[0] + s[1][1] + s[1][0] + s[1].substring(2);

						if (!known_only || self.check(_edit)) {
							if (!(_edit in rv)) {
								rv[_edit] = 1;
							}
							else {
								rv[_edit] += 1;
							}
						}
					}

					if (s[1]) {
						// Replace a letter with another letter.

						var lettercase = (s[1].substring(0,1).toUpperCase() === s[1].substring(0,1)) ? 'uppercase' : 'lowercase';

						for (j = 0; j < alphabetLength; j++) {
							var replacementLetter = self.alphabet[j];

							// Set the case of the replacement letter to the same as the letter being replaced.
							if ( 'uppercase' === lettercase ) {
								replacementLetter = replacementLetter.toUpperCase();
							}

							// Eliminate replacement of a letter by itself
							if (replacementLetter != s[1].substring(0,1)){
								_edit = s[0] + replacementLetter + s[1].substring(1);

								if (!known_only || self.check(_edit)) {
									if (!(_edit in rv)) {
										rv[_edit] = 1;
									}
									else {
										rv[_edit] += 1;
									}
								}
							}
						}
					}

					if (s[1]) {
						// Add a letter between each letter.
						for (j = 0; j < alphabetLength; j++) {
							// If the letters on each side are capitalized, capitalize the replacement.
							var lettercase = (s[0].substring(-1).toUpperCase() === s[0].substring(-1) && s[1].substring(0,1).toUpperCase() === s[1].substring(0,1)) ? 'uppercase' : 'lowercase';

							var replacementLetter = self.alphabet[j];

							if ( 'uppercase' === lettercase ) {
								replacementLetter = replacementLetter.toUpperCase();
							}

							_edit = s[0] + replacementLetter + s[1];

							if (!known_only || self.check(_edit)) {
								if (!(_edit in rv)) {
									rv[_edit] = 1;
								}
								else {
									rv[_edit] += 1;
								}
							}
						}
					}
				}
			}
			
			return rv;
		}

		function correct(word) {
			// Get the edit-distance-1 and edit-distance-2 forms of this word.
			var ed1 = edits1(word);
			var ed2 = edits1(ed1, true);
			
			// Sort the edits based on how many different ways they were created.
			var weighted_corrections = ed2;
			
			for (var ed1word in ed1) {
				if (!self.check(ed1word)) {
					continue;
				}

				if (ed1word in weighted_corrections) {
					weighted_corrections[ed1word] += ed1[ed1word];
				}
				else {
					weighted_corrections[ed1word] = ed1[ed1word];
				}
			}
			
			var i, _len;

			var sorted_corrections = [];
			
			for (i in weighted_corrections) {
				if (weighted_corrections.hasOwnProperty(i)) {
					sorted_corrections.push([ i, weighted_corrections[i] ]);
				}
			}

			function sorter(a, b) {
				var a_val = a[1];
				var b_val = b[1];
				if (a_val < b_val) {
					return -1;
				} else if (a_val > b_val) {
					return 1;
				}
				// @todo If a and b are equally weighted, add our own weight based on something like the key locations on this language's default keyboard.
				return b[0].localeCompare(a[0]);
			}
			
			sorted_corrections.sort(sorter).reverse();

			var rv = [];

			var capitalization_scheme = "lowercase";
			
			if (word.toUpperCase() === word) {
				capitalization_scheme = "uppercase";
			}
			else if (word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase() === word) {
				capitalization_scheme = "capitalized";
			}
			
			var working_limit = limit;

			for (i = 0; i < Math.min(working_limit, sorted_corrections.length); i++) {
				if ("uppercase" === capitalization_scheme) {
					sorted_corrections[i][0] = sorted_corrections[i][0].toUpperCase();
				}
				else if ("capitalized" === capitalization_scheme) {
					sorted_corrections[i][0] = sorted_corrections[i][0].substr(0, 1).toUpperCase() + sorted_corrections[i][0].substr(1);
				}
				
				if (!self.hasFlag(sorted_corrections[i][0], "NOSUGGEST") && rv.indexOf(sorted_corrections[i][0]) == -1) {
					rv.push(sorted_corrections[i][0]);
				}
				else {
					// If one of the corrections is not eligible as a suggestion , make sure we still return the right number of suggestions.
					working_limit++;
				}
			}

			return rv;
		}
		
		this.memoized[word] = {
			'suggestions': correct(word),
			'limit': limit
		};

		return this.memoized[word]['suggestions'];
	}
};
})();

// Support for use as a node.js module.
if (true) {
	module.exports = Typo;
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * marked - a markdown parser
 * Copyright (c) 2011-2021, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.marked = factory());
}(this, (function () { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);

    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var defaults$5 = {exports: {}};

  function getDefaults$1() {
    return {
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartLists: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }

  function changeDefaults$1(newDefaults) {
    defaults$5.exports.defaults = newDefaults;
  }

  defaults$5.exports = {
    defaults: getDefaults$1(),
    getDefaults: getDefaults$1,
    changeDefaults: changeDefaults$1
  };

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = /[&<>"']/g;
  var escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
  var escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };

  function escape$2(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }

    return html;
  }

  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  function unescape$1(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';

      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }

      return '';
    });
  }

  var caret = /(^|[^\[])\^/g;

  function edit$1(regex, opt) {
    regex = regex.source || regex;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }

  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  function cleanUrl$1(sanitize, base, href) {
    if (sanitize) {
      var prot;

      try {
        prot = decodeURIComponent(unescape$1(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }

      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }

    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }

    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }

    return href;
  }

  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim$1(base, '/', true);
      }
    }

    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;

    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }

      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }

      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }

  var noopTest$1 = {
    exec: function noopTest() {}
  };

  function merge$2(obj) {
    var i = 1,
        target,
        key;

    for (; i < arguments.length; i++) {
      target = arguments[i];

      for (key in target) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
          obj[key] = target[key];
        }
      }
    }

    return obj;
  }

  function splitCells$1(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
      var escaped = false,
          curr = offset;

      while (--curr >= 0 && str[curr] === '\\') {
        escaped = !escaped;
      }

      if (escaped) {
        // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
      } else {
        // add space before unescaped |
        return ' |';
      }
    }),
        cells = row.split(/ \|/);
    var i = 0;

    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }

    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }

    return cells;
  } // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
  // /c*$/ is vulnerable to REDOS.
  // invert: Remove suffix of non-c chars instead. Default falsey.


  function rtrim$1(str, c, invert) {
    var l = str.length;

    if (l === 0) {
      return '';
    } // Length of suffix matching the invert condition.


    var suffLen = 0; // Step left until we fail to match the invert condition.

    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);

      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }

    return str.substr(0, l - suffLen);
  }

  function findClosingBracket$1(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }

    var l = str.length;
    var level = 0,
        i = 0;

    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;

        if (level < 0) {
          return i;
        }
      }
    }

    return -1;
  }

  function checkSanitizeDeprecation$1(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  } // copied from https://stackoverflow.com/a/5450113/806777


  function repeatString$1(pattern, count) {
    if (count < 1) {
      return '';
    }

    var result = '';

    while (count > 1) {
      if (count & 1) {
        result += pattern;
      }

      count >>= 1;
      pattern += pattern;
    }

    return result + pattern;
  }

  var helpers = {
    escape: escape$2,
    unescape: unescape$1,
    edit: edit$1,
    cleanUrl: cleanUrl$1,
    resolveUrl: resolveUrl,
    noopTest: noopTest$1,
    merge: merge$2,
    splitCells: splitCells$1,
    rtrim: rtrim$1,
    findClosingBracket: findClosingBracket$1,
    checkSanitizeDeprecation: checkSanitizeDeprecation$1,
    repeatString: repeatString$1
  };

  var defaults$4 = defaults$5.exports.defaults;
  var rtrim = helpers.rtrim,
      splitCells = helpers.splitCells,
      _escape = helpers.escape,
      findClosingBracket = helpers.findClosingBracket;

  function outputLink(cap, link, raw) {
    var href = link.href;
    var title = link.title ? _escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');

    if (cap[0].charAt(0) !== '!') {
      return {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text
      };
    } else {
      return {
        type: 'image',
        raw: raw,
        href: href,
        title: title,
        text: _escape(text)
      };
    }
  }

  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);

    if (matchIndentToCode === null) {
      return text;
    }

    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);

      if (matchIndentInNode === null) {
        return node;
      }

      var indentInNode = matchIndentInNode[0];

      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }

      return node;
    }).join('\n');
  }
  /**
   * Tokenizer
   */


  var Tokenizer_1 = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || defaults$4;
    }

    var _proto = Tokenizer.prototype;

    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);

      if (cap) {
        if (cap[0].length > 1) {
          return {
            type: 'space',
            raw: cap[0]
          };
        }

        return {
          raw: '\n'
        };
      }
    };

    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);

      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };

    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);

      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim() : cap[2],
          text: text
        };
      }
    };

    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);

      if (cap) {
        var text = cap[2].trim(); // remove trailing #s

        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');

          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }

        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text
        };
      }
    };

    _proto.nptable = function nptable(src) {
      var cap = this.rules.block.nptable.exec(src);

      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : [],
          raw: cap[0]
        };

        if (item.header.length === item.align.length) {
          var l = item.align.length;
          var i;

          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }

          l = item.cells.length;

          for (i = 0; i < l; i++) {
            item.cells[i] = splitCells(item.cells[i], item.header.length);
          }

          return item;
        }
      }
    };

    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);

      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };

    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);

      if (cap) {
        var text = cap[0].replace(/^ *> ?/gm, '');
        return {
          type: 'blockquote',
          raw: cap[0],
          text: text
        };
      }
    };

    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);

      if (cap) {
        var raw = cap[0];
        var bull = cap[2];
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: raw,
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        }; // Get each top-level item.

        var itemMatch = cap[0].match(this.rules.block.item);
        var next = false,
            item,
            space,
            bcurr,
            bnext,
            addBack,
            loose,
            istask,
            ischecked,
            endMatch;
        var l = itemMatch.length;
        bcurr = this.rules.block.listItemStart.exec(itemMatch[0]);

        for (var i = 0; i < l; i++) {
          item = itemMatch[i];
          raw = item;

          if (!this.options.pedantic) {
            // Determine if current item contains the end of the list
            endMatch = item.match(new RegExp('\\n\\s*\\n {0,' + (bcurr[0].length - 1) + '}\\S'));

            if (endMatch) {
              addBack = item.length - endMatch.index + itemMatch.slice(i + 1).join('\n').length;
              list.raw = list.raw.substring(0, list.raw.length - addBack);
              item = item.substring(0, endMatch.index);
              raw = item;
              l = i + 1;
            }
          } // Determine whether the next list item belongs here.
          // Backpedal if it does not belong in this list.


          if (i !== l - 1) {
            bnext = this.rules.block.listItemStart.exec(itemMatch[i + 1]);

            if (!this.options.pedantic ? bnext[1].length >= bcurr[0].length || bnext[1].length > 3 : bnext[1].length > bcurr[1].length) {
              // nested list or continuation
              itemMatch.splice(i, 2, itemMatch[i] + (!this.options.pedantic && bnext[1].length < bcurr[0].length && !itemMatch[i].match(/\n$/) ? '' : '\n') + itemMatch[i + 1]);
              i--;
              l--;
              continue;
            } else if ( // different bullet style
            !this.options.pedantic || this.options.smartLists ? bnext[2][bnext[2].length - 1] !== bull[bull.length - 1] : isordered === (bnext[2].length === 1)) {
              addBack = itemMatch.slice(i + 1).join('\n').length;
              list.raw = list.raw.substring(0, list.raw.length - addBack);
              i = l - 1;
            }

            bcurr = bnext;
          } // Remove the list item's bullet
          // so it is seen as the next token.


          space = item.length;
          item = item.replace(/^ *([*+-]|\d+[.)]) ?/, ''); // Outdent whatever the
          // list item contains. Hacky.

          if (~item.indexOf('\n ')) {
            space -= item.length;
            item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
          } // trim item newlines at end


          item = rtrim(item, '\n');

          if (i !== l - 1) {
            raw = raw + '\n';
          } // Determine whether item is loose or not.
          // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
          // for discount behavior.


          loose = next || /\n\n(?!\s*$)/.test(raw);

          if (i !== l - 1) {
            next = raw.slice(-2) === '\n\n';
            if (!loose) loose = next;
          }

          if (loose) {
            list.loose = true;
          } // Check for task list items


          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.test(item);
            ischecked = undefined;

            if (istask) {
              ischecked = item[1] !== ' ';
              item = item.replace(/^\[[ xX]\] +/, '');
            }
          }

          list.items.push({
            type: 'list_item',
            raw: raw,
            task: istask,
            checked: ischecked,
            loose: loose,
            text: item
          });
        }

        return list;
      }
    };

    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);

      if (cap) {
        return {
          type: this.options.sanitize ? 'paragraph' : 'html',
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
        };
      }
    };

    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);

      if (cap) {
        if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: cap[2],
          title: cap[3]
        };
      }
    };

    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);

      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
        };

        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i;

          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }

          l = item.cells.length;

          for (i = 0; i < l; i++) {
            item.cells[i] = splitCells(item.cells[i].replace(/^ *\| *| *\| *$/g, ''), item.header.length);
          }

          return item;
        }
      }
    };

    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);

      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1]
        };
      }
    };

    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);

      if (cap) {
        return {
          type: 'paragraph',
          raw: cap[0],
          text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
        };
      }
    };

    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);

      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0]
        };
      }
    };

    _proto.escape = function escape(src) {
      var cap = this.rules.inline.escape.exec(src);

      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: _escape(cap[1])
        };
      }
    };

    _proto.tag = function tag(src, inLink, inRawBlock) {
      var cap = this.rules.inline.tag.exec(src);

      if (cap) {
        if (!inLink && /^<a /i.test(cap[0])) {
          inLink = true;
        } else if (inLink && /^<\/a>/i.test(cap[0])) {
          inLink = false;
        }

        if (!inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          inRawBlock = true;
        } else if (inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          inRawBlock = false;
        }

        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: inLink,
          inRawBlock: inRawBlock,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0]
        };
      }
    };

    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);

      if (cap) {
        var trimmedUrl = cap[2].trim();

        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          } // ending angle bracket cannot be escaped


          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');

          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');

          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }

        var href = cap[2];
        var title = '';

        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }

        href = href.trim();

        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }

        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0]);
      }
    };

    _proto.reflink = function reflink(src, links) {
      var cap;

      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];

        if (!link || !link.href) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }

        return outputLink(cap, link, cap[0]);
      }
    };

    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }

      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return; // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well

      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
      var nextChar = match[1] || match[2] || '';

      if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
        var lLength = match[0].length - 1;
        var rDelim,
            rLength,
            delimTotal = lLength,
            midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0; // Clip maskedSrc to same section of string as src (move to lexer?)

        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);

        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;

          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters
          // Remove extra characters. *a*** -> *a*

          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal); // Create `em` if smallest delimiter has odd char count. *a***

          if (Math.min(lLength, rLength) % 2) {
            return {
              type: 'em',
              raw: src.slice(0, lLength + match.index + rLength + 1),
              text: src.slice(1, lLength + match.index + rLength)
            };
          } // Create 'strong' if smallest delimiter has even char count. **a***


          return {
            type: 'strong',
            raw: src.slice(0, lLength + match.index + rLength + 1),
            text: src.slice(2, lLength + match.index + rLength - 1)
          };
        }
      }
    };

    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);

      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);

        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }

        text = _escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };

    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);

      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };

    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);

      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2]
        };
      }
    };

    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);

      if (cap) {
        var text, href;

        if (cap[2] === '@') {
          text = _escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = _escape(cap[1]);
          href = text;
        }

        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };

    _proto.url = function url(src, mangle) {
      var cap;

      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;

        if (cap[2] === '@') {
          text = _escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;

          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);

          text = _escape(cap[0]);

          if (cap[1] === 'www.') {
            href = 'http://' + text;
          } else {
            href = text;
          }
        }

        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };

    _proto.inlineText = function inlineText(src, inRawBlock, smartypants) {
      var cap = this.rules.inline.text.exec(src);

      if (cap) {
        var text;

        if (inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : _escape(cap[0]) : cap[0];
        } else {
          text = _escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }

        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };

    return Tokenizer;
  }();

  var noopTest = helpers.noopTest,
      edit = helpers.edit,
      merge$1 = helpers.merge;
  /**
   * Block-Level Grammar
   */

  var block$1 = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
    hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?! {0,3}bull )\n*|\s*$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
    nptable: noopTest,
    table: noopTest,
    lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block$1._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
  block$1._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block$1.def = edit(block$1.def).replace('label', block$1._label).replace('title', block$1._title).getRegex();
  block$1.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block$1.item = /^( *)(bull) ?[^\n]*(?:\n(?! *bull ?)[^\n]*)*/;
  block$1.item = edit(block$1.item, 'gm').replace(/bull/g, block$1.bullet).getRegex();
  block$1.listItemStart = edit(/^( *)(bull) */).replace('bull', block$1.bullet).getRegex();
  block$1.list = edit(block$1.list).replace(/bull/g, block$1.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block$1.def.source + ')').getRegex();
  block$1._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block$1._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block$1.html = edit(block$1.html, 'i').replace('comment', block$1._comment).replace('tag', block$1._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block$1.paragraph = edit(block$1._paragraph).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)').replace('tag', block$1._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block$1.blockquote = edit(block$1.blockquote).replace('paragraph', block$1.paragraph).getRegex();
  /**
   * Normal Block Grammar
   */

  block$1.normal = merge$1({}, block$1);
  /**
   * GFM Block Grammar
   */

  block$1.gfm = merge$1({}, block$1.normal, {
    nptable: '^ *([^|\\n ].*\\|.*)\\n' // Header
    + ' {0,3}([-:]+ *\\|[-| :]*)' // Align
    + '(?:\\n((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)',
    // Cells
    table: '^ *\\|(.+)\\n' // Header
    + ' {0,3}\\|?( *[-:]+[-| :]*)' // Align
    + '(?:\\n *((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells

  });
  block$1.gfm.nptable = edit(block$1.gfm.nptable).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)').replace('tag', block$1._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block$1.gfm.table = edit(block$1.gfm.table).replace('hr', block$1.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)').replace('tag', block$1._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block$1.pedantic = merge$1({}, block$1.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block$1._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    paragraph: edit(block$1.normal._paragraph).replace('hr', block$1.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block$1.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });
  /**
   * Inline-Level Grammar
   */

  var inline$1 = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
    nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
      //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //        () Skip other delimiter (1) #***                   (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
      rDelimAst: /\_\_[^_*]*?\*[^_*]*?\_\_|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
      rDelimUnd: /\*\*[^_*]*?\_[^_*]*?\*\*|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _

    },
    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^([\spunctuation])/
  }; // list of punctuation marks from CommonMark spec
  // without * and _ to handle the different emphasis markers * and _

  inline$1._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
  inline$1.punctuation = edit(inline$1.punctuation).replace(/punctuation/g, inline$1._punctuation).getRegex(); // sequences em should skip over [title](link), `code`, <html>

  inline$1.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
  inline$1.escapedEmSt = /\\\*|\\_/g;
  inline$1._comment = edit(block$1._comment).replace('(?:-->|$)', '-->').getRegex();
  inline$1.emStrong.lDelim = edit(inline$1.emStrong.lDelim).replace(/punct/g, inline$1._punctuation).getRegex();
  inline$1.emStrong.rDelimAst = edit(inline$1.emStrong.rDelimAst, 'g').replace(/punct/g, inline$1._punctuation).getRegex();
  inline$1.emStrong.rDelimUnd = edit(inline$1.emStrong.rDelimUnd, 'g').replace(/punct/g, inline$1._punctuation).getRegex();
  inline$1._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
  inline$1._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline$1._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline$1.autolink = edit(inline$1.autolink).replace('scheme', inline$1._scheme).replace('email', inline$1._email).getRegex();
  inline$1._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline$1.tag = edit(inline$1.tag).replace('comment', inline$1._comment).replace('attribute', inline$1._attribute).getRegex();
  inline$1._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline$1._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline$1._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline$1.link = edit(inline$1.link).replace('label', inline$1._label).replace('href', inline$1._href).replace('title', inline$1._title).getRegex();
  inline$1.reflink = edit(inline$1.reflink).replace('label', inline$1._label).getRegex();
  inline$1.reflinkSearch = edit(inline$1.reflinkSearch, 'g').replace('reflink', inline$1.reflink).replace('nolink', inline$1.nolink).getRegex();
  /**
   * Normal Inline Grammar
   */

  inline$1.normal = merge$1({}, inline$1);
  /**
   * Pedantic Inline Grammar
   */

  inline$1.pedantic = merge$1({}, inline$1.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline$1._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline$1._label).getRegex()
  });
  /**
   * GFM Inline Grammar
   */

  inline$1.gfm = merge$1({}, inline$1.normal, {
    escape: edit(inline$1.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline$1.gfm.url = edit(inline$1.gfm.url, 'i').replace('email', inline$1.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline$1.breaks = merge$1({}, inline$1.gfm, {
    br: edit(inline$1.br).replace('{2,}', '*').getRegex(),
    text: edit(inline$1.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });
  var rules = {
    block: block$1,
    inline: inline$1
  };

  var Tokenizer$1 = Tokenizer_1;
  var defaults$3 = defaults$5.exports.defaults;
  var block = rules.block,
      inline = rules.inline;
  var repeatString = helpers.repeatString;
  /**
   * smartypants text replacement
   */

  function smartypants(text) {
    return text // em-dashes
    .replace(/---/g, "\u2014") // en-dashes
    .replace(/--/g, "\u2013") // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018") // closing singles & apostrophes
    .replace(/'/g, "\u2019") // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C") // closing doubles
    .replace(/"/g, "\u201D") // ellipses
    .replace(/\.{3}/g, "\u2026");
  }
  /**
   * mangle email addresses
   */


  function mangle(text) {
    var out = '',
        i,
        ch;
    var l = text.length;

    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);

      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }

      out += '&#' + ch + ';';
    }

    return out;
  }
  /**
   * Block Lexer
   */


  var Lexer_1 = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || defaults$3;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer$1();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      var rules = {
        block: block.normal,
        inline: inline.normal
      };

      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;

        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }

      this.tokenizer.rules = rules;
    }
    /**
     * Expose Rules
     */


    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }
    /**
     * Static Lex Inline Method
     */
    ;

    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }
    /**
     * Preprocessing
     */
    ;

    var _proto = Lexer.prototype;

    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ');
      this.blockTokens(src, this.tokens, true);
      this.inline(this.tokens);
      return this.tokens;
    }
    /**
     * Lexing
     */
    ;

    _proto.blockTokens = function blockTokens(src, tokens, top) {
      var _this = this;

      if (tokens === void 0) {
        tokens = [];
      }

      if (top === void 0) {
        top = true;
      }

      if (this.options.pedantic) {
        src = src.replace(/^ +$/gm, '');
      }

      var token, i, l, lastToken, cutSrc, lastParagraphClipped;

      while (src) {
        if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call(_this, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }

          return false;
        })) {
          continue;
        } // newline


        if (token = this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);

          if (token.type) {
            tokens.push(token);
          }

          continue;
        } // code


        if (token = this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1]; // An indented code block cannot interrupt a paragraph.

          if (lastToken && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
          } else {
            tokens.push(token);
          }

          continue;
        } // fences


        if (token = this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // heading


        if (token = this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // table no leading pipe (gfm)


        if (token = this.tokenizer.nptable(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // hr


        if (token = this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // blockquote


        if (token = this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          token.tokens = this.blockTokens(token.text, [], top);
          tokens.push(token);
          continue;
        } // list


        if (token = this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          l = token.items.length;

          for (i = 0; i < l; i++) {
            token.items[i].tokens = this.blockTokens(token.items[i].text, [], false);
          }

          tokens.push(token);
          continue;
        } // html


        if (token = this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // def


        if (top && (token = this.tokenizer.def(src))) {
          src = src.substring(token.raw.length);

          if (!this.tokens.links[token.tag]) {
            this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }

          continue;
        } // table (gfm)


        if (token = this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // lheading


        if (token = this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start


        cutSrc = src;

        if (this.options.extensions && this.options.extensions.startBlock) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;

            _this.options.extensions.startBlock.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call(this, tempSrc);

              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });

            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }

        if (top && (token = this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];

          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
          } else {
            tokens.push(token);
          }

          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          continue;
        } // text


        if (token = this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];

          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
          } else {
            tokens.push(token);
          }

          continue;
        }

        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);

          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }

      return tokens;
    };

    _proto.inline = function inline(tokens) {
      var i, j, k, l2, row, token;
      var l = tokens.length;

      for (i = 0; i < l; i++) {
        token = tokens[i];

        switch (token.type) {
          case 'paragraph':
          case 'text':
          case 'heading':
            {
              token.tokens = [];
              this.inlineTokens(token.text, token.tokens);
              break;
            }

          case 'table':
            {
              token.tokens = {
                header: [],
                cells: []
              }; // header

              l2 = token.header.length;

              for (j = 0; j < l2; j++) {
                token.tokens.header[j] = [];
                this.inlineTokens(token.header[j], token.tokens.header[j]);
              } // cells


              l2 = token.cells.length;

              for (j = 0; j < l2; j++) {
                row = token.cells[j];
                token.tokens.cells[j] = [];

                for (k = 0; k < row.length; k++) {
                  token.tokens.cells[j][k] = [];
                  this.inlineTokens(row[k], token.tokens.cells[j][k]);
                }
              }

              break;
            }

          case 'blockquote':
            {
              this.inline(token.tokens);
              break;
            }

          case 'list':
            {
              l2 = token.items.length;

              for (j = 0; j < l2; j++) {
                this.inline(token.items[j].tokens);
              }

              break;
            }
        }
      }

      return tokens;
    }
    /**
     * Lexing/Compiling
     */
    ;

    _proto.inlineTokens = function inlineTokens(src, tokens, inLink, inRawBlock) {
      var _this2 = this;

      if (tokens === void 0) {
        tokens = [];
      }

      if (inLink === void 0) {
        inLink = false;
      }

      if (inRawBlock === void 0) {
        inRawBlock = false;
      }

      var token, lastToken, cutSrc; // String with links masked to avoid interference with em and strong

      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar; // Mask out reflinks

      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);

        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      } // Mask out other blocks


      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      } // Mask out escaped em & strong delimiters


      while ((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
      }

      while (src) {
        if (!keepPrevChar) {
          prevChar = '';
        }

        keepPrevChar = false; // extensions

        if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call(_this2, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }

          return false;
        })) {
          continue;
        } // escape


        if (token = this.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // tag


        if (token = this.tokenizer.tag(src, inLink, inRawBlock)) {
          src = src.substring(token.raw.length);
          inLink = token.inLink;
          inRawBlock = token.inRawBlock;
          lastToken = tokens[tokens.length - 1];

          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }

          continue;
        } // link


        if (token = this.tokenizer.link(src)) {
          src = src.substring(token.raw.length);

          if (token.type === 'link') {
            token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
          }

          tokens.push(token);
          continue;
        } // reflink, nolink


        if (token = this.tokenizer.reflink(src, this.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];

          if (token.type === 'link') {
            token.tokens = this.inlineTokens(token.text, [], true, inRawBlock);
            tokens.push(token);
          } else if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }

          continue;
        } // em & strong


        if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
          tokens.push(token);
          continue;
        } // code


        if (token = this.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // br


        if (token = this.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // del (gfm)


        if (token = this.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          token.tokens = this.inlineTokens(token.text, [], inLink, inRawBlock);
          tokens.push(token);
          continue;
        } // autolink


        if (token = this.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // url (gfm)


        if (!inLink && (token = this.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          continue;
        } // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start


        cutSrc = src;

        if (this.options.extensions && this.options.extensions.startInline) {
          (function () {
            var startIndex = Infinity;
            var tempSrc = src.slice(1);
            var tempStart = void 0;

            _this2.options.extensions.startInline.forEach(function (getStartIndex) {
              tempStart = getStartIndex.call(this, tempSrc);

              if (typeof tempStart === 'number' && tempStart >= 0) {
                startIndex = Math.min(startIndex, tempStart);
              }
            });

            if (startIndex < Infinity && startIndex >= 0) {
              cutSrc = src.substring(0, startIndex + 1);
            }
          })();
        }

        if (token = this.tokenizer.inlineText(cutSrc, inRawBlock, smartypants)) {
          src = src.substring(token.raw.length);

          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }

          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];

          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }

          continue;
        }

        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);

          if (this.options.silent) {
            console.error(errMsg);
            break;
          } else {
            throw new Error(errMsg);
          }
        }
      }

      return tokens;
    };

    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);

    return Lexer;
  }();

  var defaults$2 = defaults$5.exports.defaults;
  var cleanUrl = helpers.cleanUrl,
      escape$1 = helpers.escape;
  /**
   * Renderer
   */

  var Renderer_1 = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || defaults$2;
    }

    var _proto = Renderer.prototype;

    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];

      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);

        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }

      _code = _code.replace(/\n$/, '') + '\n';

      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape$1(_code, true)) + '</code></pre>\n';
      }

      return '<pre><code class="' + this.options.langPrefix + escape$1(lang, true) + '">' + (escaped ? _code : escape$1(_code, true)) + '</code></pre>\n';
    };

    _proto.blockquote = function blockquote(quote) {
      return '<blockquote>\n' + quote + '</blockquote>\n';
    };

    _proto.html = function html(_html) {
      return _html;
    };

    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        return '<h' + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + '</h' + level + '>\n';
      } // ignore IDs


      return '<h' + level + '>' + text + '</h' + level + '>\n';
    };

    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };

    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
          startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    };

    _proto.listitem = function listitem(text) {
      return '<li>' + text + '</li>\n';
    };

    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    };

    _proto.paragraph = function paragraph(text) {
      return '<p>' + text + '</p>\n';
    };

    _proto.table = function table(header, body) {
      if (body) body = '<tbody>' + body + '</tbody>';
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    };

    _proto.tablerow = function tablerow(content) {
      return '<tr>\n' + content + '</tr>\n';
    };

    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? '<' + type + ' align="' + flags.align + '">' : '<' + type + '>';
      return tag + content + '</' + type + '>\n';
    } // span level renderer
    ;

    _proto.strong = function strong(text) {
      return '<strong>' + text + '</strong>';
    };

    _proto.em = function em(text) {
      return '<em>' + text + '</em>';
    };

    _proto.codespan = function codespan(text) {
      return '<code>' + text + '</code>';
    };

    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    };

    _proto.del = function del(text) {
      return '<del>' + text + '</del>';
    };

    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);

      if (href === null) {
        return text;
      }

      var out = '<a href="' + escape$1(href) + '"';

      if (title) {
        out += ' title="' + title + '"';
      }

      out += '>' + text + '</a>';
      return out;
    };

    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);

      if (href === null) {
        return text;
      }

      var out = '<img src="' + href + '" alt="' + text + '"';

      if (title) {
        out += ' title="' + title + '"';
      }

      out += this.options.xhtml ? '/>' : '>';
      return out;
    };

    _proto.text = function text(_text) {
      return _text;
    };

    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */

  var TextRenderer_1 = /*#__PURE__*/function () {
    function TextRenderer() {}

    var _proto = TextRenderer.prototype;

    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };

    _proto.em = function em(text) {
      return text;
    };

    _proto.codespan = function codespan(text) {
      return text;
    };

    _proto.del = function del(text) {
      return text;
    };

    _proto.html = function html(text) {
      return text;
    };

    _proto.text = function text(_text) {
      return _text;
    };

    _proto.link = function link(href, title, text) {
      return '' + text;
    };

    _proto.image = function image(href, title, text) {
      return '' + text;
    };

    _proto.br = function br() {
      return '';
    };

    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */

  var Slugger_1 = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    var _proto = Slugger.prototype;

    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim() // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '') // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }
    /**
     * Finds the next safe (unique) slug to use
     */
    ;

    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;

      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];

        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }

      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }

      return slug;
    }
    /**
     * Convert string to unique id
     * @param {object} options
     * @param {boolean} options.dryrun Generates the next unique slug without updating the internal accumulator.
     */
    ;

    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }

      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };

    return Slugger;
  }();

  var Renderer$1 = Renderer_1;
  var TextRenderer$1 = TextRenderer_1;
  var Slugger$1 = Slugger_1;
  var defaults$1 = defaults$5.exports.defaults;
  var unescape = helpers.unescape;
  /**
   * Parsing & Compiling
   */

  var Parser_1 = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || defaults$1;
      this.options.renderer = this.options.renderer || new Renderer$1();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer$1();
      this.slugger = new Slugger$1();
    }
    /**
     * Static Parse Method
     */


    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }
    /**
     * Static Parse Inline Method
     */
    ;

    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }
    /**
     * Parse Loop
     */
    ;

    var _proto = Parser.prototype;

    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }

      var out = '',
          i,
          j,
          k,
          l2,
          l3,
          row,
          cell,
          header,
          body,
          token,
          ordered,
          start,
          loose,
          itemBody,
          item,
          checked,
          task,
          checkbox,
          ret;
      var l = tokens.length;

      for (i = 0; i < l; i++) {
        token = tokens[i]; // Run any renderer extensions

        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call(this, token);

          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }

        switch (token.type) {
          case 'space':
            {
              continue;
            }

          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }

          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }

          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }

          case 'table':
            {
              header = ''; // header

              cell = '';
              l2 = token.header.length;

              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.tokens.header[j]), {
                  header: true,
                  align: token.align[j]
                });
              }

              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.cells.length;

              for (j = 0; j < l2; j++) {
                row = token.tokens.cells[j];
                cell = '';
                l3 = row.length;

                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k]), {
                    header: false,
                    align: token.align[k]
                  });
                }

                body += this.renderer.tablerow(cell);
              }

              out += this.renderer.table(header, body);
              continue;
            }

          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }

          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';

              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';

                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);

                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'text') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;

                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }

                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }

              out += this.renderer.list(body, ordered, start);
              continue;
            }

          case 'html':
            {
              // TODO parse inline content if parameter markdown=1
              out += this.renderer.html(token.text);
              continue;
            }

          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }

          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;

              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }

              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }

          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';

              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }

      return out;
    }
    /**
     * Parse Inline Tokens
     */
    ;

    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
          i,
          token,
          ret;
      var l = tokens.length;

      for (i = 0; i < l; i++) {
        token = tokens[i]; // Run any renderer extensions

        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call(this, token);

          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }

        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }

          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }

          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }

          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }

          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }

          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }

          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }

          case 'br':
            {
              out += renderer.br();
              break;
            }

          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }

          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }

          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';

              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }

      return out;
    };

    return Parser;
  }();

  var Lexer = Lexer_1;
  var Parser = Parser_1;
  var Tokenizer = Tokenizer_1;
  var Renderer = Renderer_1;
  var TextRenderer = TextRenderer_1;
  var Slugger = Slugger_1;
  var merge = helpers.merge,
      checkSanitizeDeprecation = helpers.checkSanitizeDeprecation,
      escape = helpers.escape;
  var getDefaults = defaults$5.exports.getDefaults,
      changeDefaults = defaults$5.exports.changeDefaults,
      defaults = defaults$5.exports.defaults;
  /**
   * Marked
   */

  function marked(src, opt, callback) {
    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      throw new Error('marked(): input parameter is undefined or null');
    }

    if (typeof src !== 'string') {
      throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
    }

    if (typeof opt === 'function') {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});
    checkSanitizeDeprecation(opt);

    if (callback) {
      var highlight = opt.highlight;
      var tokens;

      try {
        tokens = Lexer.lex(src, opt);
      } catch (e) {
        return callback(e);
      }

      var done = function done(err) {
        var out;

        if (!err) {
          try {
            if (opt.walkTokens) {
              marked.walkTokens(tokens, opt.walkTokens);
            }

            out = Parser.parse(tokens, opt);
          } catch (e) {
            err = e;
          }
        }

        opt.highlight = highlight;
        return err ? callback(err) : callback(null, out);
      };

      if (!highlight || highlight.length < 3) {
        return done();
      }

      delete opt.highlight;
      if (!tokens.length) return done();
      var pending = 0;
      marked.walkTokens(tokens, function (token) {
        if (token.type === 'code') {
          pending++;
          setTimeout(function () {
            highlight(token.text, token.lang, function (err, code) {
              if (err) {
                return done(err);
              }

              if (code != null && code !== token.text) {
                token.text = code;
                token.escaped = true;
              }

              pending--;

              if (pending === 0) {
                done();
              }
            });
          }, 0);
        }
      });

      if (pending === 0) {
        done();
      }

      return;
    }

    try {
      var _tokens = Lexer.lex(src, opt);

      if (opt.walkTokens) {
        marked.walkTokens(_tokens, opt.walkTokens);
      }

      return Parser.parse(_tokens, opt);
    } catch (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';

      if (opt.silent) {
        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
      }

      throw e;
    }
  }
  /**
   * Options
   */


  marked.options = marked.setOptions = function (opt) {
    merge(marked.defaults, opt);
    changeDefaults(marked.defaults);
    return marked;
  };

  marked.getDefaults = getDefaults;
  marked.defaults = defaults;
  /**
   * Use Extension
   */

  marked.use = function () {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var opts = merge.apply(void 0, [{}].concat(args));
    var extensions = marked.defaults.extensions || {
      renderers: {},
      childTokens: {}
    };
    var hasExtensions;
    args.forEach(function (pack) {
      // ==-- Parse "addon" extensions --== //
      if (pack.extensions) {
        hasExtensions = true;
        pack.extensions.forEach(function (ext) {
          if (!ext.name) {
            throw new Error('extension name required');
          }

          if (ext.renderer) {
            // Renderer extensions
            var prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;

            if (prevRenderer) {
              // Replace extension with func to run new extension but fall back if false
              extensions.renderers[ext.name] = function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }

                var ret = ext.renderer.apply(this, args);

                if (ret === false) {
                  ret = prevRenderer.apply(this, args);
                }

                return ret;
              };
            } else {
              extensions.renderers[ext.name] = ext.renderer;
            }
          }

          if (ext.tokenizer) {
            // Tokenizer Extensions
            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
              throw new Error("extension level must be 'block' or 'inline'");
            }

            if (extensions[ext.level]) {
              extensions[ext.level].unshift(ext.tokenizer);
            } else {
              extensions[ext.level] = [ext.tokenizer];
            }

            if (ext.start) {
              // Function to check for start of token
              if (ext.level === 'block') {
                if (extensions.startBlock) {
                  extensions.startBlock.push(ext.start);
                } else {
                  extensions.startBlock = [ext.start];
                }
              } else if (ext.level === 'inline') {
                if (extensions.startInline) {
                  extensions.startInline.push(ext.start);
                } else {
                  extensions.startInline = [ext.start];
                }
              }
            }
          }

          if (ext.childTokens) {
            // Child tokens to be visited by walkTokens
            extensions.childTokens[ext.name] = ext.childTokens;
          }
        });
      } // ==-- Parse "overwrite" extensions --== //


      if (pack.renderer) {
        (function () {
          var renderer = marked.defaults.renderer || new Renderer();

          var _loop = function _loop(prop) {
            var prevRenderer = renderer[prop]; // Replace renderer with func to run extension, but fall back if false

            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }

              var ret = pack.renderer[prop].apply(renderer, args);

              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }

              return ret;
            };
          };

          for (var prop in pack.renderer) {
            _loop(prop);
          }

          opts.renderer = renderer;
        })();
      }

      if (pack.tokenizer) {
        (function () {
          var tokenizer = marked.defaults.tokenizer || new Tokenizer();

          var _loop2 = function _loop2(prop) {
            var prevTokenizer = tokenizer[prop]; // Replace tokenizer with func to run extension, but fall back if false

            tokenizer[prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }

              var ret = pack.tokenizer[prop].apply(tokenizer, args);

              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }

              return ret;
            };
          };

          for (var prop in pack.tokenizer) {
            _loop2(prop);
          }

          opts.tokenizer = tokenizer;
        })();
      } // ==-- Parse WalkTokens extensions --== //


      if (pack.walkTokens) {
        var walkTokens = marked.defaults.walkTokens;

        opts.walkTokens = function (token) {
          pack.walkTokens.call(_this, token);

          if (walkTokens) {
            walkTokens(token);
          }
        };
      }

      if (hasExtensions) {
        opts.extensions = extensions;
      }

      marked.setOptions(opts);
    });
  };
  /**
   * Run callback for every token
   */


  marked.walkTokens = function (tokens, callback) {
    var _loop3 = function _loop3() {
      var token = _step.value;
      callback(token);

      switch (token.type) {
        case 'table':
          {
            for (var _iterator2 = _createForOfIteratorHelperLoose(token.tokens.header), _step2; !(_step2 = _iterator2()).done;) {
              var cell = _step2.value;
              marked.walkTokens(cell, callback);
            }

            for (var _iterator3 = _createForOfIteratorHelperLoose(token.tokens.cells), _step3; !(_step3 = _iterator3()).done;) {
              var row = _step3.value;

              for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                var _cell = _step4.value;
                marked.walkTokens(_cell, callback);
              }
            }

            break;
          }

        case 'list':
          {
            marked.walkTokens(token.items, callback);
            break;
          }

        default:
          {
            if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) {
              // Walk any extensions
              marked.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                marked.walkTokens(token[childTokens], callback);
              });
            } else if (token.tokens) {
              marked.walkTokens(token.tokens, callback);
            }
          }
      }
    };

    for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
      _loop3();
    }
  };
  /**
   * Parse Inline
   */


  marked.parseInline = function (src, opt) {
    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      throw new Error('marked.parseInline(): input parameter is undefined or null');
    }

    if (typeof src !== 'string') {
      throw new Error('marked.parseInline(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
    }

    opt = merge({}, marked.defaults, opt || {});
    checkSanitizeDeprecation(opt);

    try {
      var tokens = Lexer.lexInline(src, opt);

      if (opt.walkTokens) {
        marked.walkTokens(tokens, opt.walkTokens);
      }

      return Parser.parseInline(tokens, opt);
    } catch (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';

      if (opt.silent) {
        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
      }

      throw e;
    }
  };
  /**
   * Expose
   */


  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.parse = marked;
  var marked_1 = marked;

  return marked_1;

})));


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HexAlphaColorPicker", function() { return ne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HexColorInput", function() { return Oe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HexColorPicker", function() { return Z; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HslColorPicker", function() { return ie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HslStringColorPicker", function() { return fe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HslaColorPicker", function() { return ae; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HslaStringColorPicker", function() { return ue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HsvColorPicker", function() { return pe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HsvStringColorPicker", function() { return _e; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HsvaColorPicker", function() { return de; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HsvaStringColorPicker", function() { return me; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RgbColorPicker", function() { return Ne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RgbStringColorPicker", function() { return ye; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RgbaColorPicker", function() { return Ce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RgbaStringColorPicker", function() { return He; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNonce", function() { return G; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function u(){return(u=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e}).apply(this,arguments)}function c(e,r){if(null==e)return{};var t,n,o={},a=Object.keys(e);for(n=0;n<a.length;n++)r.indexOf(t=a[n])>=0||(o[t]=e[t]);return o}function i(e){var t=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(e),n=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(function(e){t.current&&t.current(e)});return t.current=e,n.current}var s=function(e,r,t){return void 0===r&&(r=0),void 0===t&&(t=1),e>t?t:e<r?r:e},f=function(e){return"touches"in e},v=function(e){return e&&e.ownerDocument.defaultView||self},d=function(e,r,t){var n=e.getBoundingClientRect(),o=f(r)?function(e,r){for(var t=0;t<e.length;t++)if(e[t].identifier===r)return e[t];return e[0]}(r.touches,t):r;return{left:s((o.pageX-(n.left+v(e).pageXOffset))/n.width),top:s((o.pageY-(n.top+v(e).pageYOffset))/n.height)}},h=function(e){!f(e)&&e.preventDefault()},m=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(o){var a=o.onMove,l=o.onKey,s=c(o,["onMove","onKey"]),m=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),g=i(a),p=i(l),b=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),_=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!1),x=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var e=function(e){h(e),(f(e)?e.touches.length>0:e.buttons>0)&&m.current?g(d(m.current,e,b.current)):t(!1)},r=function(){return t(!1)};function t(t){var n=_.current,o=v(m.current),a=t?o.addEventListener:o.removeEventListener;a(n?"touchmove":"mousemove",e),a(n?"touchend":"mouseup",r)}return[function(e){var r=e.nativeEvent,n=m.current;if(n&&(h(r),!function(e,r){return r&&!f(e)}(r,_.current)&&n)){if(f(r)){_.current=!0;var o=r.changedTouches||[];o.length&&(b.current=o[0].identifier)}n.focus(),g(d(n,r,b.current)),t(!0)}},function(e){var r=e.which||e.keyCode;r<37||r>40||(e.preventDefault(),p({left:39===r?.05:37===r?-.05:0,top:40===r?.05:38===r?-.05:0}))},t]},[p,g]),C=x[0],E=x[1],H=x[2];return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return H},[H]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",u({},s,{onTouchStart:C,onMouseDown:C,className:"react-colorful__interactive",ref:m,onKeyDown:E,tabIndex:0,role:"slider"}))}),g=function(e){return e.filter(Boolean).join(" ")},p=function(r){var t=r.color,n=r.left,o=r.top,a=void 0===o?.5:o,l=g(["react-colorful__pointer",r.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:l,style:{top:100*a+"%",left:100*n+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__pointer-fill",style:{backgroundColor:t}}))},b=function(e,r,t){return void 0===r&&(r=0),void 0===t&&(t=Math.pow(10,r)),Math.round(t*e)/t},_={grad:.9,turn:360,rad:360/(2*Math.PI)},x=function(e){return L(C(e))},C=function(e){return"#"===e[0]&&(e=e.substring(1)),e.length<6?{r:parseInt(e[0]+e[0],16),g:parseInt(e[1]+e[1],16),b:parseInt(e[2]+e[2],16),a:4===e.length?b(parseInt(e[3]+e[3],16)/255,2):1}:{r:parseInt(e.substring(0,2),16),g:parseInt(e.substring(2,4),16),b:parseInt(e.substring(4,6),16),a:8===e.length?b(parseInt(e.substring(6,8),16)/255,2):1}},E=function(e,r){return void 0===r&&(r="deg"),Number(e)*(_[r]||1)},H=function(e){var r=/hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?N({h:E(r[1],r[2]),s:Number(r[3]),l:Number(r[4]),a:void 0===r[5]?1:Number(r[5])/(r[6]?100:1)}):{h:0,s:0,v:0,a:1}},M=H,N=function(e){var r=e.s,t=e.l;return{h:e.h,s:(r*=(t<50?t:100-t)/100)>0?2*r/(t+r)*100:0,v:t+r,a:e.a}},w=function(e){return K(I(e))},y=function(e){var r=e.s,t=e.v,n=e.a,o=(200-r)*t/100;return{h:b(e.h),s:b(o>0&&o<200?r*t/100/(o<=100?o:200-o)*100:0),l:b(o/2),a:b(n,2)}},q=function(e){var r=y(e);return"hsl("+r.h+", "+r.s+"%, "+r.l+"%)"},k=function(e){var r=y(e);return"hsla("+r.h+", "+r.s+"%, "+r.l+"%, "+r.a+")"},I=function(e){var r=e.h,t=e.s,n=e.v,o=e.a;r=r/360*6,t/=100,n/=100;var a=Math.floor(r),l=n*(1-t),u=n*(1-(r-a)*t),c=n*(1-(1-r+a)*t),i=a%6;return{r:b(255*[n,u,l,l,c,n][i]),g:b(255*[c,n,n,u,l,l][i]),b:b(255*[l,l,c,n,n,u][i]),a:b(o,2)}},O=function(e){var r=/hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?A({h:E(r[1],r[2]),s:Number(r[3]),v:Number(r[4]),a:void 0===r[5]?1:Number(r[5])/(r[6]?100:1)}):{h:0,s:0,v:0,a:1}},j=O,z=function(e){var r=/rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);return r?L({r:Number(r[1])/(r[2]?100/255:1),g:Number(r[3])/(r[4]?100/255:1),b:Number(r[5])/(r[6]?100/255:1),a:void 0===r[7]?1:Number(r[7])/(r[8]?100:1)}):{h:0,s:0,v:0,a:1}},B=z,D=function(e){var r=e.toString(16);return r.length<2?"0"+r:r},K=function(e){var r=e.r,t=e.g,n=e.b,o=e.a,a=o<1?D(b(255*o)):"";return"#"+D(r)+D(t)+D(n)+a},L=function(e){var r=e.r,t=e.g,n=e.b,o=e.a,a=Math.max(r,t,n),l=a-Math.min(r,t,n),u=l?a===r?(t-n)/l:a===t?2+(n-r)/l:4+(r-t)/l:0;return{h:b(60*(u<0?u+6:u)),s:b(a?l/a*100:0),v:b(a/255*100),a:o}},A=function(e){return{h:b(e.h),s:b(e.s),v:b(e.v),a:b(e.a,2)}},S=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(r){var t=r.hue,n=r.onChange,o=g(["react-colorful__hue",r.className]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){n({h:360*e.left})},onKey:function(e){n({h:s(t+360*e.left,0,360)})},"aria-label":"Hue","aria-valuenow":b(t),"aria-valuemax":"360","aria-valuemin":"0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__hue-pointer",left:t/360,color:q({h:t,s:100,v:100,a:1})})))}),T=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(r){var t=r.hsva,n=r.onChange,o={backgroundColor:q({h:t.h,s:100,v:100,a:1})};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__saturation",style:o},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){n({s:100*e.left,v:100-100*e.top})},onKey:function(e){n({s:s(t.s+100*e.left,0,100),v:s(t.v-100*e.top,0,100)})},"aria-label":"Color","aria-valuetext":"Saturation "+b(t.s)+"%, Brightness "+b(t.v)+"%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__saturation-pointer",top:1-t.v/100,left:t.s/100,color:q(t)})))}),F=function(e,r){if(e===r)return!0;for(var t in e)if(e[t]!==r[t])return!1;return!0},P=function(e,r){return e.replace(/\s/g,"")===r.replace(/\s/g,"")},X=function(e,r){return e.toLowerCase()===r.toLowerCase()||F(C(e),C(r))};function Y(e,t,l){var u=i(l),c=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return e.toHsva(t)}),s=c[0],f=c[1],v=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({color:t,hsva:s});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!e.equal(t,v.current.color)){var r=e.toHsva(t);v.current={hsva:r,color:t},f(r)}},[t,e]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var r;F(s,v.current.hsva)||e.equal(r=e.fromHsva(s),v.current.color)||(v.current={hsva:s,color:r},u(r))},[s,e,u]);var d=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){f(function(r){return Object.assign({},r,e)})},[]);return[s,d]}var R,V="undefined"!=typeof window?__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"]:__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"],$=function(){return R||( true?__webpack_require__.nc:void 0)},G=function(e){R=e},J=new Map,Q=function(e){V(function(){var r=e.current?e.current.ownerDocument:document;if(void 0!==r&&!J.has(r)){var t=r.createElement("style");t.innerHTML='.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}',J.set(r,t);var n=$();n&&t.setAttribute("nonce",n),r.head.appendChild(t)}},[])},U=function(t){var n=t.className,o=t.colorModel,a=t.color,l=void 0===a?o.defaultColor:a,i=t.onChange,s=c(t,["className","colorModel","color","onChange"]),f=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Q(f);var v=Y(o,l,i),d=v[0],h=v[1],m=g(["react-colorful",n]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",u({},s,{ref:f,className:m}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(T,{hsva:d,onChange:h}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(S,{hue:d.h,onChange:h,className:"react-colorful__last-control"}))},W={defaultColor:"000",toHsva:x,fromHsva:function(e){return w({h:e.h,s:e.s,v:e.v,a:1})},equal:X},Z=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:W}))},ee=function(r){var t=r.className,n=r.hsva,o=r.onChange,a={backgroundImage:"linear-gradient(90deg, "+k(Object.assign({},n,{a:0}))+", "+k(Object.assign({},n,{a:1}))+")"},l=g(["react-colorful__alpha",t]),u=b(100*n.a);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:l},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"react-colorful__alpha-gradient",style:a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(m,{onMove:function(e){o({a:e.left})},onKey:function(e){o({a:s(n.a+e.left)})},"aria-label":"Alpha","aria-valuetext":u+"%","aria-valuenow":u,"aria-valuemin":"0","aria-valuemax":"100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,{className:"react-colorful__alpha-pointer",left:n.a,color:k(n)})))},re=function(t){var n=t.className,o=t.colorModel,a=t.color,l=void 0===a?o.defaultColor:a,i=t.onChange,s=c(t,["className","colorModel","color","onChange"]),f=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Q(f);var v=Y(o,l,i),d=v[0],h=v[1],m=g(["react-colorful",n]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",u({},s,{ref:f,className:m}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(T,{hsva:d,onChange:h}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(S,{hue:d.h,onChange:h}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ee,{hsva:d,onChange:h,className:"react-colorful__last-control"}))},te={defaultColor:"0001",toHsva:x,fromHsva:w,equal:X},ne=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:te}))},oe={defaultColor:{h:0,s:0,l:0,a:1},toHsva:N,fromHsva:y,equal:F},ae=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:oe}))},le={defaultColor:"hsla(0, 0%, 0%, 1)",toHsva:H,fromHsva:k,equal:P},ue=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:le}))},ce={defaultColor:{h:0,s:0,l:0},toHsva:function(e){return N({h:e.h,s:e.s,l:e.l,a:1})},fromHsva:function(e){return{h:(r=y(e)).h,s:r.s,l:r.l};var r},equal:F},ie=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:ce}))},se={defaultColor:"hsl(0, 0%, 0%)",toHsva:M,fromHsva:q,equal:P},fe=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:se}))},ve={defaultColor:{h:0,s:0,v:0,a:1},toHsva:function(e){return e},fromHsva:A,equal:F},de=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:ve}))},he={defaultColor:"hsva(0, 0%, 0%, 1)",toHsva:O,fromHsva:function(e){var r=A(e);return"hsva("+r.h+", "+r.s+"%, "+r.v+"%, "+r.a+")"},equal:P},me=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:he}))},ge={defaultColor:{h:0,s:0,v:0},toHsva:function(e){return{h:e.h,s:e.s,v:e.v,a:1}},fromHsva:function(e){var r=A(e);return{h:r.h,s:r.s,v:r.v}},equal:F},pe=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:ge}))},be={defaultColor:"hsv(0, 0%, 0%)",toHsva:j,fromHsva:function(e){var r=A(e);return"hsv("+r.h+", "+r.s+"%, "+r.v+"%)"},equal:P},_e=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:be}))},xe={defaultColor:{r:0,g:0,b:0,a:1},toHsva:L,fromHsva:I,equal:F},Ce=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:xe}))},Ee={defaultColor:"rgba(0, 0, 0, 1)",toHsva:z,fromHsva:function(e){var r=I(e);return"rgba("+r.r+", "+r.g+", "+r.b+", "+r.a+")"},equal:P},He=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(re,u({},r,{colorModel:Ee}))},Me={defaultColor:{r:0,g:0,b:0},toHsva:function(e){return L({r:e.r,g:e.g,b:e.b,a:1})},fromHsva:function(e){return{r:(r=I(e)).r,g:r.g,b:r.b};var r},equal:F},Ne=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:Me}))},we={defaultColor:"rgb(0, 0, 0)",toHsva:B,fromHsva:function(e){var r=I(e);return"rgb("+r.r+", "+r.g+", "+r.b+")"},equal:P},ye=function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(U,u({},r,{colorModel:we}))},qe=/^#?([0-9A-F]{3,8})$/i,ke=function(r){var t=r.color,l=void 0===t?"":t,s=r.onChange,f=r.onBlur,v=r.escape,d=r.validate,h=r.format,m=r.process,g=c(r,["color","onChange","onBlur","escape","validate","format","process"]),p=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return v(l)}),b=p[0],_=p[1],x=i(s),C=i(f),E=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){var r=v(e.target.value);_(r),d(r)&&x(m?m(r):r)},[v,m,d,x]),H=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){d(e.target.value)||_(v(l)),C(e)},[l,v,d,C]);return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){_(v(l))},[l,v]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",u({},g,{value:h?h(b):b,spellCheck:"false",onChange:E,onBlur:H}))},Ie=function(e){return"#"+e},Oe=function(r){var t=r.prefixed,n=r.alpha,o=c(r,["prefixed","alpha"]),l=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){return e.replace(/([^0-9A-F]+)/gi,"").substring(0,n?8:6)},[n]),i=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(e){return function(e,r){var t=qe.exec(e),n=t?t[1].length:0;return 3===n||6===n||!!r&&4===n||!!r&&8===n}(e,n)},[n]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ke,u({},o,{escape:l,format:t?Ie:void 0,process:Ie,validate:i}))};
//# sourceMappingURL=index.module.js.map


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

// Improved version of https://usehooks.com/useOnClickOutside/
var useClickOutside = function useClickOutside(ref, handler) {
  (0, _react.useEffect)(function () {
    var startedInside = false;
    var startedWhenMounted = false;

    var listener = function listener(event) {
      // Do nothing if `mousedown` or `touchstart` started inside ref element
      if (startedInside || !startedWhenMounted) return;
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) return;

      handler(event);
    };

    var validateEventStart = function validateEventStart(event) {
      startedWhenMounted = ref.current;
      startedInside = ref.current && ref.current.contains(event.target);
    };

    document.addEventListener('mousedown', validateEventStart);
    document.addEventListener('touchstart', validateEventStart);
    document.addEventListener('click', listener);

    return function () {
      document.removeEventListener('mousedown', validateEventStart);
      document.removeEventListener('touchstart', validateEventStart);
      document.removeEventListener('click', listener);
    };
  }, [ref, handler]);
};

exports.default = useClickOutside;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  margin-left: 30px;\n  margin-top: 7%;\n  .swatch {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    border: 3px solid #fff;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n  }\n  .popover {\n    position: absolute;\n    top: calc(80% + 6px);\n    right: 0;\n    border-radius: 9px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  .react-colorful {\n    height: auto !important;\n    border-radius: 6px !important;\n  }\n  .react-colorful__saturation {\n    display: none;\n  }\n  .react-colorful__hue {\n    border-radius: 6px !important;\n    background: linear-gradient(\n      90deg,\n      #8d1c1f,\n      #8f8c2a,\n      #228d34,\n      #218e87,\n      #2c228b,\n      #8d2186,\n      #8e1b1f\n    ) !important;\n  }\n  .react-colorful__pointer-fill {\n    background-color: ', ' !important;\n    &[style] {\n      background-color: ', ' !important;\n    }\n  }\n'], ['\n  position: relative;\n  margin-left: 30px;\n  margin-top: 7%;\n  .swatch {\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    border: 3px solid #fff;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n  }\n  .popover {\n    position: absolute;\n    top: calc(80% + 6px);\n    right: 0;\n    border-radius: 9px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  }\n  .react-colorful {\n    height: auto !important;\n    border-radius: 6px !important;\n  }\n  .react-colorful__saturation {\n    display: none;\n  }\n  .react-colorful__hue {\n    border-radius: 6px !important;\n    background: linear-gradient(\n      90deg,\n      #8d1c1f,\n      #8f8c2a,\n      #228d34,\n      #218e87,\n      #2c228b,\n      #8d2186,\n      #8e1b1f\n    ) !important;\n  }\n  .react-colorful__pointer-fill {\n    background-color: ', ' !important;\n    &[style] {\n      background-color: ', ' !important;\n    }\n  }\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverPickerStyle = _styledComponents2.default.div.withConfig({
  displayName: 'PopoverPickerStyle',
  componentId: 'sc-2tj73j-0'
})(_templateObject, function (props) {
  return props.pointerColor;
}, function (props) {
  return props.pointerColor;
});

exports.default = PopoverPickerStyle;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n'], ['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 23px;\n'], ['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 23px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: -15px;\n'], ['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: -15px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  padding: 10px 23px;\n  border-bottom: 1px solid ', ';\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n'], ['\n  display: flex;\n  padding: 10px 23px;\n  border-bottom: 1px solid ', ';\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 43px;\n'], ['\n  width: 419px;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 43px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #eeeeee;\n'], ['\n  border-top: 1px solid #eeeeee;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _Caption = __webpack_require__(160);

var _Caption2 = _interopRequireDefault(_Caption);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _util = __webpack_require__(114);

var _GradeElement = __webpack_require__(309);

var _GradeElement2 = _interopRequireDefault(_GradeElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'InformativeModal__ModalContainer',
  componentId: 'sc-1wttmey-0'
})(_templateObject, _colors2.default.white);

var Header = _styledComponents2.default.div.withConfig({
  displayName: 'InformativeModal__Header',
  componentId: 'sc-1wttmey-1'
})(_templateObject2);

var CourseName = _styledComponents2.default.h3.withConfig({
  displayName: 'InformativeModal__CourseName',
  componentId: 'sc-1wttmey-2'
})(_templateObject3, function (props) {
  return props.color;
});

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'InformativeModal__MainContainer',
  componentId: 'sc-1wttmey-3'
})(_templateObject4, _colors2.default.ash, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'InformativeModal__DescriptionText',
  componentId: 'sc-1wttmey-4'
})(_templateObject5);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'InformativeModal__ButtonBlock',
  componentId: 'sc-1wttmey-5'
})(_templateObject6);

var InformativeModal = function InformativeModal(_ref) {
  var activityCourse = _ref.activityCourse,
      description = _ref.description,
      gradeLevel = _ref.gradeLevel,
      supportiveText = _ref.supportiveText;

  var dispatch = (0, _reactRedux.useDispatch)();

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      !!gradeLevel && !!activityCourse && _react2.default.createElement(
        Header,
        null,
        _react2.default.createElement(_GradeElement2.default, {
          name: gradeLevel.name,
          abbreviation: gradeLevel.abbreviation,
          style: { marginRight: '28px' }
        }),
        _react2.default.createElement(
          CourseName,
          { color: (0, _util.cleanHexCode)(activityCourse.color) },
          activityCourse.name
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(
          DescriptionText,
          null,
          description
        )
      ),
      supportiveText && _react2.default.createElement(
        _P2.default,
        {
          style: {
            textAlign: 'center',
            marginTop: '-30px',
            paddingBottom: '20px'
          }
        },
        supportiveText
      ),
      _react2.default.createElement(
        ButtonBlock,
        null,
        _react2.default.createElement(
          'div',
          {
            style: {
              marginLeft: '40%',
              paddingTop: '23px',
              paddingBottom: '30px'
            }
          },
          _react2.default.createElement(_Button2.default, {
            buttonColor: _colors2.default.white,
            width: '95px',
            borderColor: _colors2.default.aluminum,
            title: 'OK',
            handleClick: function handleClick() {
              return closeTheModal();
            },
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white
          })
        )
      )
    )
  );
};

InformativeModal.propTypes = {
  activityCourse: _propTypes2.default.object,
  gradeLevel: _propTypes2.default.object,
  description: _propTypes2.default.string.isRequired,
  supportiveText: _propTypes2.default.string
};

exports.default = InformativeModal;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n'], ['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 23px;\n'], ['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 23px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: 8px;\n'], ['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: 8px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding-bottom: 43px;\n  border-bottom: 1px solid ', ';\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  text-align: center;\n'], ['\n  padding-bottom: 43px;\n  border-bottom: 1px solid ', ';\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  text-align: center;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  color: ', ';\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 12px;\n'], ['\n  width: 419px;\n  color: ', ';\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 12px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid ', ';\n'], ['\n  border-top: 1px solid ', ';\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 20px 25px;\n  border-top: 1px solid ', ';\n  display: flex;\n  align-items: center;\n  align-content: center;\n  \n  input, div {\n    cursor: pointer;\n  }\n'], ['\n  padding: 20px 25px;\n  border-top: 1px solid ', ';\n  display: flex;\n  align-items: center;\n  align-content: center;\n  \n  input, div {\n    cursor: pointer;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _close = __webpack_require__(587);

var _close2 = _interopRequireDefault(_close);

var _close_hover = __webpack_require__(588);

var _close_hover2 = _interopRequireDefault(_close_hover);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _convertToRomanNumerals = __webpack_require__(310);

var _util = __webpack_require__(114);

var _GradeElement = __webpack_require__(309);

var _GradeElement2 = _interopRequireDefault(_GradeElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CloseModal__ModalContainer',
  componentId: 'ly6fn7-0'
})(_templateObject, _colors2.default.white);

var Header = _styledComponents2.default.div.withConfig({
  displayName: 'CloseModal__Header',
  componentId: 'ly6fn7-1'
})(_templateObject2);

var CourseName = _styledComponents2.default.h3.withConfig({
  displayName: 'CloseModal__CourseName',
  componentId: 'ly6fn7-2'
})(_templateObject3, function (props) {
  return props.color;
});

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CloseModal__MainContainer',
  componentId: 'ly6fn7-3'
})(_templateObject4, _colors2.default.ash, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'CloseModal__DescriptionText',
  componentId: 'ly6fn7-4'
})(_templateObject5, _colors2.default.black);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'CloseModal__ButtonBlock',
  componentId: 'ly6fn7-5'
})(_templateObject6, _colors2.default.rock);

var OptionalBlock = _styledComponents2.default.div.withConfig({
  displayName: 'CloseModal__OptionalBlock',
  componentId: 'ly6fn7-6'
})(_templateObject7, _colors2.default.rock);

var CloseModal = function CloseModal(_ref) {
  var activityCourse = _ref.activityCourse,
      gradeLevel = _ref.gradeLevel,
      description = _ref.description,
      supportiveText = _ref.supportiveText,
      isOptionalTextExist = _ref.isOptionalTextExist,
      optionalText = _ref.optionalText,
      deleteFunction = _ref.deleteFunction;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isCheckboxChecked = _useState2[0],
      setIsCheckboxChecked = _useState2[1];

  var handleCheckboxChecked = function handleCheckboxChecked() {
    setIsCheckboxChecked(true);
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var deleteAndCloseTheModal = function deleteAndCloseTheModal() {
    deleteFunction();
    closeTheModal();
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      { closeCallback: closeTheModal },
      gradeLevel && activityCourse && _react2.default.createElement(
        Header,
        null,
        _react2.default.createElement(_GradeElement2.default, { small: true,
          'data-for': 'gradeLevelNameTooltip',
          name: gradeLevel.name,
          abbreviation: gradeLevel.abbreviation
        }),
        _react2.default.createElement(
          CourseName,
          { color: (0, _util.cleanHexCode)(activityCourse.color) },
          isOptionalTextExist ? activityCourse.abbreviation + ': ' + (0, _convertToRomanNumerals.convertToRomanNumerals)(activityCourse.journeyIndex) + ' ' + activityCourse.journeyName : activityCourse.name
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(
          DescriptionText,
          null,
          description
        ),
        _react2.default.createElement(
          'p',
          { className: 'p2', style: { marginBottom: '0' } },
          supportiveText
        )
      ),
      isOptionalTextExist && _react2.default.createElement(
        OptionalBlock,
        null,
        _react2.default.createElement('input', {
          type: 'checkbox',
          id: 'optional-text',
          name: 'optionalText',
          value: 'optionalText',
          style: { marginRight: '15px' },
          checked: isCheckboxChecked,
          onClick: handleCheckboxChecked
        }),
        _react2.default.createElement(
          _P2.default,
          { onClick: handleCheckboxChecked },
          optionalText
        )
      ),
      _react2.default.createElement(
        ButtonBlock,
        null,
        _react2.default.createElement(
          'div',
          {
            style: {
              marginLeft: '46%',
              padding: '23px 23px 30px 0',
              display: 'flex'
            }
          },
          _react2.default.createElement(
            'span',
            { style: { marginRight: '20px' } },
            _react2.default.createElement(_Button2.default, {
              buttonColor: _colors2.default.white,
              width: '104px',
              borderColor: _colors2.default.aluminum,
              title: 'Cancel',
              handleClick: closeTheModal,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white
            })
          ),
          _react2.default.createElement(_Button2.default, {
            buttonColor: _colors2.default.white,
            width: '129px',
            borderColor: '#D23A3D',
            title: 'Delete',
            handleClick: deleteAndCloseTheModal,
            hoverBackground: '#D23A3D',
            hoverColor: _colors2.default.white,
            shouldShowTooltipAndDisableButton: isOptionalTextExist && !isCheckboxChecked
          })
        )
      )
    )
  );
};

CloseModal.propTypes = {
  activityCourse: _propTypes2.default.object,
  gradeLevel: _propTypes2.default.object,
  description: _propTypes2.default.string.isRequired,
  supportiveText: _propTypes2.default.string,
  isOptionalTextExist: _propTypes2.default.bool,
  optionalText: _propTypes2.default.string
};

exports.default = CloseModal;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 30px;\n  margin-top: 7.2%;\n'], ['\n  margin-left: 30px;\n  margin-top: 7.2%;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _API = __webpack_require__(98);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _StaticInputValue = __webpack_require__(1218);

var _StaticInputValue2 = _interopRequireDefault(_StaticInputValue);

var _icon_edit_course = __webpack_require__(312);

var _icon_edit_course2 = _interopRequireDefault(_icon_edit_course);

var _util = __webpack_require__(114);

var _PopoverPicker = __webpack_require__(596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditCourseModal__ModalContainer',
  componentId: 'sc-1lojm4o-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditCourseModal__HeaderContainer',
  componentId: 'sc-1lojm4o-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditCourseModal__MainContainer',
  componentId: 'sc-1lojm4o-2'
})(_templateObject3);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditCourseModal__FlexContainer',
  componentId: 'sc-1lojm4o-3'
})(_templateObject4);

var ColorPicker = _styledComponents2.default.input.withConfig({
  displayName: 'EditCourseModal__ColorPicker',
  componentId: 'sc-1lojm4o-4'
})(_templateObject5);

var EditCourseModal = function EditCourseModal(_ref) {
  var apiData = _ref.apiData,
      activityCourse = _ref.activityCourse,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isMutating = _useState2[0],
      setIsMutating = _useState2[1];

  var academicYearName = academicYears.find(function (ay) {
    return ay.id === activityCourse.academic_year_id;
  }).name;

  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });
  var gradeLevelName = gradeLevels.find(function (gl) {
    return gl.id === activityCourse.grade_level_id;
  }).name;

  var frameworkSubjects = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworksubjects.items;
  });
  var frameworkSubjectName = frameworkSubjects.find(function (fs) {
    return fs.id === activityCourse.framework_subject_id;
  }).name;

  var _useState3 = (0, _react.useState)(activityCourse.name),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      courseName = _useState4[0],
      setCourseName = _useState4[1];

  var handleCourseName = function handleCourseName(e) {
    setCourseName(e.target.value);
  };

  var _useState5 = (0, _react.useState)(activityCourse.abbreviation),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      abbreviation = _useState6[0],
      setAbbreviation = _useState6[1];

  var handleAbbreviation = function handleAbbreviation(e) {
    setAbbreviation(e.target.value);
  };

  var _useState7 = (0, _react.useState)((0, _util.cleanHexCode)(activityCourse.color)),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      courseColor = _useState8[0],
      setCourseColor = _useState8[1];

  var handleCourseColor = function handleCourseColor(e) {
    setCourseColor(e.target.value);
  };

  var isValidColor = function isValidColor(str) {
    return str.match(/^#[a-f0-9]{6}$/i) !== null;
  };

  var couldSaveData = courseName.length > 0 && abbreviation.length > 0 && abbreviation.length <= 3 && isValidColor(courseColor === '' ? '#4E6C83' : courseColor);

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var mutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var courseName = _ref2.courseName,
        abbreviation = _ref2.abbreviation,
        courseColor = _ref2.courseColor,
        selectedAcademicYearId = _ref2.selectedAcademicYearId;
    return (0, _API.editMentorActivityCourse)(apiData, courseName, abbreviation, courseColor, activityCourse, selectedAcademicYearId);
  });

  var handleSaveEditedCourse = function handleSaveEditedCourse() {
    if (couldSaveData) {
      setIsMutating(true);
      mutation.mutate({
        courseName: courseName,
        abbreviation: abbreviation,
        courseColor: courseColor === '' ? '#4E6C83' : courseColor,
        selectedAcademicYearId: selectedAcademicYearId
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
          setTimeout(function () {
            setIsMutating(false);
            handleCloseModal();
          }, 300);
        }
      });
    }
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          _react2.default.createElement(
            'span',
            { style: { marginRight: '12px' } },
            _react2.default.createElement('img', { src: _icon_edit_course2.default })
          ),
          'Edit Course'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: handleCloseModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'editCourseTooltip',
              'data-tip': 'Please enter all required fields prior to creating this course.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Save',
              handleClick: handleSaveEditedCourse,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              isMutating: isMutating,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'editCourseTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_StaticInputValue2.default, {
          placeholder: 'Academic Year',
          textValue: academicYearName
        }),
        _react2.default.createElement(_StaticInputValue2.default, { placeholder: 'Phase', textValue: gradeLevelName }),
        _react2.default.createElement(_StaticInputValue2.default, {
          placeholder: 'Framework Subject',
          textValue: frameworkSubjectName
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Course Name',
          hintText: 'Example: Spanish 2, Art 1, Psychology',
          handleEnteredTextValue: handleCourseName,
          value: courseName,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Abbreviation',
          hintText: 'Must be no more than 3 letters. Example: Sp1, Psy, Ar1',
          handleEnteredTextValue: handleAbbreviation,
          value: abbreviation,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Course Color Hex Code',
            placeholder: 'Course Color Hex Code',
            hintText: 'If left empty, #4e6c84 will be applied.'
            // cannot choose a hex code to respect color accessibility.
            // handleEnteredTextValue={handleCourseColor}
            , value: courseColor,
            shouldDisplayAsteriskSymbol: false
          }),
          _react2.default.createElement(_PopoverPicker.PopoverPicker, { color: courseColor === '' ? '#4e6c84' : (0, _util.cleanHexCode)(courseColor), onChange: setCourseColor })
        )
      )
    )
  );
};

EditCourseModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  academicYears: _propTypes2.default.array.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(EditCourseModal);

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticInputValue = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  font-family: Roboto;\n  letter-spacing: 0;\n'], ['\n  font-family: Roboto;\n  letter-spacing: 0;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _Input = __webpack_require__(311);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StaticInputValue__SelectorContainer',
  componentId: 'qhecxk-0'
})(_templateObject);
var Text = (0, _styledComponents2.default)(_Input2.default).withConfig({
  displayName: 'StaticInputValue__Text',
  componentId: 'qhecxk-1'
})(_templateObject2);

var StaticInputValue = exports.StaticInputValue = function StaticInputValue(_ref) {
  var placeholder = _ref.placeholder,
      textValue = _ref.textValue;

  return _react2.default.createElement(
    SelectorContainer,
    null,
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      placeholder
    ),
    _react2.default.createElement(
      Text,
      null,
      textValue
    )
  );
};

StaticInputValue.propTypes = {
  placeholder: _propTypes2.default.string.isRequired,
  textValue: _propTypes2.default.string.isRequired
};

exports.default = StaticInputValue;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactQuery = __webpack_require__(34);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _API = __webpack_require__(246);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _markdowneditor = __webpack_require__(142);

var _API2 = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateJourneyModal__ModalContainer',
  componentId: 'keha6e-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateJourneyModal__FlexContainer',
  componentId: 'keha6e-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateJourneyModal__HeaderContainer',
  componentId: 'keha6e-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateJourneyModal__MainContainer',
  componentId: 'keha6e-3'
})(_templateObject4);

var CreateJourneyModal = function CreateJourneyModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      handleDisplayJourneysListOnCreation = _ref.handleDisplayJourneysListOnCreation,
      selectedJourney = _ref.selectedJourney,
      color = _ref.color;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isMutating = _useState2[0],
      setIsMutating = _useState2[1];

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var _useState3 = (0, _react.useState)(selectedJourney ? 'Copy of ' + selectedJourney.name : ''),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      journeyName = _useState4[0],
      setJourneyName = _useState4[1];

  var handleJourneyName = function handleJourneyName(e) {
    setJourneyName(e.target.value);
  };

  var _useState5 = (0, _react.useState)(selectedJourney ? selectedJourney.description : ''),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      journeyDescription = _useState6[0],
      setJourneyDescription = _useState6[1];

  var handleJourneyDescription = function handleJourneyDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'journey-description';
    event.target.value = e;

    setJourneyDescription(event.target.value);
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var activityCourseId = _ref2.activityCourseId,
        journeyName = _ref2.journeyName,
        journeyDescription = _ref2.journeyDescription;
    return (0, _API.createNewCourseJourney)(apiData, activityCourseId, journeyName, journeyDescription);
  });
  var cloneMutation = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        activityCourseId = _ref3.activityCourseId,
        selectedJourneyId = _ref3.selectedJourneyId,
        journeyName = _ref3.journeyName,
        journeyDescription = _ref3.journeyDescription,
        color = _ref3.color;
    return (0, _API2.cloneCourse)(apiData, activityCourseId, selectedJourneyId, journeyName, journeyDescription, color);
  });
  var couldSaveData = journeyName.length > 0;

  var handleSaveJourney = function handleSaveJourney() {
    if (couldSaveData) {
      if (selectedJourney) {
        setIsMutating(true);
        cloneMutation.mutate({
          apiData: apiData,
          activityCourseId: activityCourseId,
          selectedJourneyId: selectedJourney.id,
          journeyName: journeyName,
          journeyDescription: journeyDescription,
          color: color
        }, {
          onSuccess: function onSuccess() {
            queryClient.invalidateQueries('activity-course-journeys-' + activityCourseId);
            queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
            setTimeout(function () {
              closeTheModal();
              setIsMutating(false);
            }, 300);
          }
        });
      } else {
        setIsMutating(true);
        createMutation.mutate({
          apiData: apiData,
          activityCourseId: activityCourseId,
          journeyName: journeyName,
          journeyDescription: journeyDescription
        }, {
          onSuccess: function onSuccess() {
            queryClient.invalidateQueries('activity-course-journeys-' + activityCourseId);
            queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
            setTimeout(function () {
              closeTheModal();
              setIsMutating(false);
            }, 300);
          }
        });
      }
      handleDisplayJourneysListOnCreation();
    }
  };

  var journeyDescriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsAndBoldOnlyMDEOptions);
  journeyDescriptionOptions.initialValue = journeyDescription;
  journeyDescriptionOptions.placeholder = 'Journey Description';
  journeyDescriptionOptions.autofocus = false;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          '+ New Journey'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: closeTheModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'createCourseTooltip',
              'data-tip': 'Please enter all required fields prior to creating this course.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Create',
              handleClick: handleSaveJourney,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true,
              isMutating: isMutating
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'createCourseTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Journey Name',
          placeholder: 'Journey Name',
          handleEnteredTextValue: handleJourneyName,
          value: journeyName,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          className: 'journey-description',
          title: 'Journey Description',
          placeholder: 'Journey Description',
          handleEnteredTextValue: handleJourneyDescription,
          hintText: 'A basic overview (2-5 sentences) of the journey, including its overarching theme and intended outcomes (both skill and content).',
          value: journeyDescription,
          shouldDisplayAsteriskSymbol: false,
          shouldBeTextarea: true,
          options: journeyDescriptionOptions
        })
      )
    )
  );
};

CreateJourneyModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.number.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  handleDisplayJourneysListOnJourneyCreation: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(CreateJourneyModal);

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _API = __webpack_require__(246);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _icon_edit_course = __webpack_require__(312);

var _icon_edit_course2 = _interopRequireDefault(_icon_edit_course);

var _markdowneditor = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditJourneyModal__ModalContainer',
  componentId: 'eeepxo-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditJourneyModal__HeaderContainer',
  componentId: 'eeepxo-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditJourneyModal__MainContainer',
  componentId: 'eeepxo-2'
})(_templateObject3);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditJourneyModal__FlexContainer',
  componentId: 'eeepxo-3'
})(_templateObject4);

var EditJourneyModal = function EditJourneyModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isMutating = _useState2[0],
      setIsMutating = _useState2[1];

  var journey = (0, _reactQuery.useQuery)(['activity-course-journey-' + journeyId], function () {
    return (0, _API.fetchActivityCourseJourney)(apiData.orgId, apiData.token, activityCourseId, journeyId);
  }, {
    refetchOnWindowFocus: false
  });

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      journeyName = _useState4[0],
      setJourneyName = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      journeyDescription = _useState6[0],
      setJourneyDescription = _useState6[1];

  (0, _react.useEffect)(function () {
    if (!journey.isLoading) {
      setJourneyName(journey.data.name);
      setJourneyDescription(journey.data.description);
    }
  }, [journey.isLoading]);

  var handleJourneyName = function handleJourneyName(e) {
    setJourneyName(e.target.value);
  };

  var handleJourneyDescription = function handleJourneyDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'journey-description';
    event.target.value = e;

    setJourneyDescription(event.target.value);
  };

  var couldSaveData = journeyName.length > 0;

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var mutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var journeyName = _ref2.journeyName,
        journeyDescription = _ref2.journeyDescription;
    return (0, _API.editActivityCourseJourney)(apiData, activityCourseId, journeyId, journeyName, journeyDescription);
  });

  var handleSaveEditedCourse = function handleSaveEditedCourse() {
    if (couldSaveData) {
      setIsMutating(true);
      mutation.mutate({
        journeyName: journeyName,
        journeyDescription: journeyDescription
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('activity-course-journeys-' + activityCourseId);
          queryClient.invalidateQueries('activity-course-journey-' + journeyId);
          setTimeout(function () {
            setIsMutating(false);
            handleCloseModal();
          }, 300);
        }
      });
    }
  };

  var journeyDescriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsAndBoldOnlyMDEOptions);
  journeyDescriptionOptions.initialValue = journeyDescription;
  journeyDescriptionOptions.placeholder = 'Journey Description';
  journeyDescriptionOptions.autofocus = false;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          _react2.default.createElement(
            'span',
            { style: { marginRight: '12px' } },
            _react2.default.createElement('img', { src: _icon_edit_course2.default })
          ),
          'Edit Journey'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: handleCloseModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'editCourseTooltip',
              'data-tip': 'Please enter all required fields prior to update this Journey.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Save',
              handleClick: handleSaveEditedCourse,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              isMutating: isMutating,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'editCourseTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Journey  Name ',
          handleEnteredTextValue: handleJourneyName,
          value: journeyName,
          shouldDisplayAsteriskSymbol: true
        }),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Journey Description',
          placeholder: 'A basic overview (2-5 sentences) of the journey, including its overarching theme and intended outcomes (both skill and content). ',
          handleEnteredTextValue: handleJourneyDescription,
          hintText: 'A basic overview (2-5 sentences) of the journey, including its overarching theme and intended outcomes (both skill and content).',
          value: journeyDescription,
          shouldDisplayAsteriskSymbol: false,
          shouldBeTextarea: true,
          options: journeyDescriptionOptions
        })
      )
    )
  );
};

EditJourneyModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.number.isRequired,
  journeyId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(EditJourneyModal);

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  padding-top: 20px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  input, div {\n    cursor: pointer;\n  }\n'], ['\n  padding-top: 20px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  input, div {\n    cursor: pointer;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactQuery = __webpack_require__(34);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _API = __webpack_require__(247);

var _icon_edit_course = __webpack_require__(312);

var _icon_edit_course2 = _interopRequireDefault(_icon_edit_course);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _markdowneditor = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateOrEditLevelModal__ModalContainer',
  componentId: 'pq1yza-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateOrEditLevelModal__FlexContainer',
  componentId: 'pq1yza-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateOrEditLevelModal__HeaderContainer',
  componentId: 'pq1yza-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateOrEditLevelModal__MainContainer',
  componentId: 'pq1yza-3'
})(_templateObject4);

var MasteryBlock = _styledComponents2.default.div.withConfig({
  displayName: 'CreateOrEditLevelModal__MasteryBlock',
  componentId: 'pq1yza-4'
})(_templateObject5);

var CreateOrEditLevelModal = function CreateOrEditLevelModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId,
      isCreateLevel = _ref.isCreateLevel,
      level = _ref.level,
      description = _ref.description;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var _useState = (0, _react.useState)(isCreateLevel ? '' : level.name),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      levelName = _useState2[0],
      setLevelName = _useState2[1];

  var handleLevelName = function handleLevelName(e) {
    setLevelName(e.target.value);
  };

  var _useState3 = (0, _react.useState)(isCreateLevel ? '' : description),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      levelDescription = _useState4[0],
      setLevelDescription = _useState4[1];

  var handleLevelDescription = function handleLevelDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'journey-description';
    event.target.value = e;

    setLevelDescription(event.target.value);
  };

  var _useState5 = (0, _react.useState)(isCreateLevel ? false : level.mastery),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      levelMastery = _useState6[0],
      setLevelMastery = _useState6[1];

  var handleLevelMastery = function handleLevelMastery(e) {
    var master = levelMastery;
    setLevelMastery(!master);
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var levelName = _ref2.levelName,
        levelDescription = _ref2.levelDescription,
        levelMastery = _ref2.levelMastery;
    return (0, _API.createNewJourneyLevel)(apiData, activityCourseId, journeyId, levelName, levelDescription, levelMastery);
  });

  var editLevelMutation = (0, _reactQuery.useMutation)(function (_ref3) {
    var levelId = _ref3.levelId,
        levelName = _ref3.levelName,
        levelDescription = _ref3.levelDescription,
        levelMastery = _ref3.levelMastery;
    return (0, _API.editJourneyLevel)(apiData, activityCourseId, journeyId, levelId, levelName, levelDescription, levelMastery);
  });

  var couldSaveData = levelName.length > 0 && levelDescription.length > 0;

  var handleSaveNewLevel = function handleSaveNewLevel() {
    if (couldSaveData) {
      isCreateLevel ? createMutation.mutate({
        apiData: apiData,
        activityCourseId: activityCourseId,
        journeyId: journeyId,
        levelName: levelName,
        levelDescription: levelDescription,
        levelMastery: levelMastery
      }, {
        onSuccess: function onSuccess(data) {
          queryClient.setQueryData(['journey-levels-' + journeyId], function (levels) {
            var newLevels = [].concat((0, _toConsumableArray3.default)(levels));
            newLevels.push((0, _assign2.default)({}, data, { just_created: true }));
            return newLevels;
          });

          setTimeout(function () {
            closeTheModal();
          }, 300);
        }
      }) : editLevelMutation.mutate({
        apiData: apiData,
        activityCourseId: activityCourseId,
        journeyId: journeyId,
        levelId: level.id,
        levelName: levelName,
        levelDescription: levelDescription,
        levelMastery: levelMastery
      }, {
        onSuccess: function () {
          var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return queryClient.refetchQueries(['journey-levels-' + journeyId]);

                  case 2:
                    _context.next = 4;
                    return queryClient.refetchQueries(['journey-level-' + level.id]);

                  case 4:
                    setTimeout(function () {
                      closeTheModal();
                    }, 300);

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, undefined);
          }));

          function onSuccess() {
            return _ref4.apply(this, arguments);
          }

          return onSuccess;
        }()
      });
    }
  };

  var levelDescriptionOptions = (0, _assign2.default)({}, _markdowneditor.excludeImageMDEOptions);
  levelDescriptionOptions.initialValue = levelDescription;
  levelDescriptionOptions.placeholder = 'Level Description';
  levelDescriptionOptions.autofocus = false;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        isCreateLevel ? _react2.default.createElement(
          _H2.default,
          null,
          '+ New Level'
        ) : _react2.default.createElement(
          _H2.default,
          null,
          _react2.default.createElement(
            'span',
            { style: { marginRight: '12px' } },
            _react2.default.createElement('img', { src: _icon_edit_course2.default })
          ),
          'Edit Level'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: closeTheModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'createLevelTooltip',
              'data-tip': 'Please enter all required fields prior to creating this level.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: isCreateLevel ? 'Create' : 'Save',
              handleClick: handleSaveNewLevel,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'createLevelTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Level Name',
          placeholder: 'Level Name',
          handleEnteredTextValue: handleLevelName,
          value: levelName,
          shouldDisplayAsteriskSymbol: true,
          shouldBeTextarea: false
        }),
        _react2.default.createElement(
          MasteryBlock,
          null,
          _react2.default.createElement('input', {
            type: 'checkbox',
            id: 'mastery-level',
            name: 'masteryLevel',
            style: { marginRight: '15px' },
            checked: levelMastery,
            onChange: handleLevelMastery
          }),
          _react2.default.createElement(
            _P2.default,
            { onClick: handleLevelMastery },
            'Mastery Level'
          )
        ),
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Level Description',
          placeholder: 'Level Description',
          handleEnteredTextValue: handleLevelDescription,
          hintText: '1-2 sentence summary of the level and what students will learn and do.',
          value: levelDescription,
          shouldDisplayAsteriskSymbol: true,
          shouldBeTextarea: true,
          options: levelDescriptionOptions
        })
      )
    )
  );
};

CreateOrEditLevelModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.string.isRequired,
  journeyId: _propTypes2.default.string.isRequired,
  isCreateLevel: _propTypes2.default.bool.isRequired,
  level: _propTypes2.default.object,
  description: _propTypes2.default.string
};

exports.default = (0, _withApiData2.default)(CreateOrEditLevelModal);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 30px 30px 32px 30px;\n'], ['\n  padding: 30px 30px 32px 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _immutabilityHelper = __webpack_require__(313);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactDnd = __webpack_require__(143);

var _reactDndHtml5Backend = __webpack_require__(314);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _API = __webpack_require__(247);

var _DraggableLevelItem = __webpack_require__(1228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SortLevelOrderModal__ModalContainer',
  componentId: 'sc-1svjh31-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SortLevelOrderModal__HeaderContainer',
  componentId: 'sc-1svjh31-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SortLevelOrderModal__MainContainer',
  componentId: 'sc-1svjh31-2'
})(_templateObject3);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SortLevelOrderModal__FlexContainer',
  componentId: 'sc-1svjh31-3'
})(_templateObject4);

var SortLevelOrderModal = function SortLevelOrderModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId,
      levels = _ref.levels;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var _useState = (0, _react.useState)(levels),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      levelsState = _useState2[0],
      setLevelsState = _useState2[1];

  (0, _react.useEffect)(function () {
    if (levelsState !== levels) {
      setLevelsState((0, _arraySort2.default)(levels, 'sort_order'));
    }
  }, [levels]);

  var moveCard = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
    var levelsCopy = [].concat((0, _toConsumableArray3.default)(levelsState));
    var dragCard = levelsCopy[dragIndex];
    setLevelsState((0, _immutabilityHelper2.default)(levelsCopy, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
    }));
  }, [levelsState]);

  var reorderLevels = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        activityCourseId = _ref2.activityCourseId,
        journeyId = _ref2.journeyId,
        levelsIdsAndSortOrder = _ref2.levelsIdsAndSortOrder;
    return (0, _API.reorderJourneyLevels)(apiData, activityCourseId, journeyId, levelsIdsAndSortOrder);
  });

  var handleSaveEditedCourse = function handleSaveEditedCourse() {
    var levelsIdsAndSortOrder = [];
    levelsState.map(function (l, index) {
      return levelsIdsAndSortOrder.push({ level_id: l.id, sort_order_position: index });
    });

    reorderLevels.mutate({
      apiData: apiData,
      activityCourseId: activityCourseId,
      journeyId: journeyId,
      levelsIdsAndSortOrder: levelsIdsAndSortOrder
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('journey-levels-' + journeyId);
        setTimeout(function () {
          return handleCloseModal();
        }, 300);
      }
    });
  };

  var listOfLevels = levelsState.map(function (level, index) {
    return _react2.default.createElement(_DraggableLevelItem.DraggableLevelItem, {
      key: level.id,
      level: level,
      id: level.id,
      index: index,
      moveCard: moveCard,
      activityCourseId: activityCourseId,
      journeyId: journeyId,
      levels: levelsState
    });
  });

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          'Level Sort Order'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: handleCloseModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'editCourseTooltip',
              'data-tip': 'Please enter all required fields prior to creating this course.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Save',
              handleClick: handleSaveEditedCourse,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              shouldShowTooltipAndDisableButton: false
            })
          )
        )
      ),
      _react2.default.createElement(
        _reactDnd.DndProvider,
        { backend: _reactDndHtml5Backend.HTML5Backend },
        _react2.default.createElement(
          MainContainer,
          null,
          listOfLevels
        )
      )
    )
  );
};

SortLevelOrderModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.number.isRequired,
  journeyId: _propTypes2.default.number.isRequired,
  levels: _propTypes2.default.array.isRequired
};

exports.default = (0, _withApiData2.default)(SortLevelOrderModal);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DndProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_jsx_runtime__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_jsx_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_jsx_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dnd_core__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DndContext__ = __webpack_require__(597);
var _excluded = ["children"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var refCount = 0;
var INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
/**
 * A React component that provides the React-DnD context
 */

var DndProvider = Object(__WEBPACK_IMPORTED_MODULE_1_react__["memo"])(function DndProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getDndContextValue = getDndContextValue(props),
      _getDndContextValue2 = _slicedToArray(_getDndContextValue, 2),
      manager = _getDndContextValue2[0],
      isGlobalInstance = _getDndContextValue2[1]; // memoized from props

  /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */


  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (isGlobalInstance) {
      var context = getGlobalContext();
      ++refCount;
      return function () {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
  }, []);
  return Object(__WEBPACK_IMPORTED_MODULE_0_react_jsx_runtime__["jsx"])(__WEBPACK_IMPORTED_MODULE_3__DndContext__["a" /* DndContext */].Provider, Object.assign({
    value: manager
  }, {
    children: children
  }), void 0);
});

function getDndContextValue(props) {
  if ('manager' in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }

  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = context;

  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: Object(__WEBPACK_IMPORTED_MODULE_2_dnd_core__["a" /* createDragDropManager */])(backend, context, options, debugMode)
    };
  }

  return ctx[INSTANCE_SYM];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(37);var f=__webpack_require__(0),g=60103;exports.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");exports.Fragment=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/interfaces.js
var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));
// EXTERNAL MODULE: ./node_modules/@react-dnd/invariant/dist/invariant.esm.js
var invariant_esm = __webpack_require__(56);

// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/types.js
var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/local/setClientOffset.js

function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/js_utils.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// cheap lodash replacements

/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */
function get(obj, path, defaultValue) {
  return path.split('.').reduce(function (a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isString(input) {
  return typeof input === 'string';
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isObject(input) {
  return _typeof(input) === 'object';
}
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */

function xor(itemsA, itemsB) {
  var map = new Map();

  var insertItem = function insertItem(item) {
    map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map.forEach(function (count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */

function intersection(itemsA, itemsB) {
  return itemsA.filter(function (t) {
    return itemsB.indexOf(t) > -1;
  });
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/beginDrag.js




var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource,
        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
        clientOffset = options.clientOffset,
        getSourceClientOffset = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

    var sourceId = getDraggableSource(sourceIds, monitor);

    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    } // Get the source client offset


    var sourceClientOffset = null;

    if (clientOffset) {
      if (!getSourceClientOffset) {
        throw new Error('getSourceClientOffset must be defined');
      }

      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
      sourceClientOffset = getSourceClientOffset(sourceId);
    } // Initialize the full coordinates


    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId); // If source.beginDrag returns null, this is an indicator to cancel the drag

    if (item == null) {
      return undefined;
    }

    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}

function verifyInvariants(sourceIds, monitor, registry) {
  Object(invariant_esm["a" /* invariant */])(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
  sourceIds.forEach(function (sourceId) {
    Object(invariant_esm["a" /* invariant */])(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
  });
}

function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
  Object(invariant_esm["a" /* invariant */])(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}

function verifyItemIsObject(item) {
  Object(invariant_esm["a" /* invariant */])(isObject(item), 'Item must be an object.');
}

function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;

  for (var i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }

  return sourceId;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/publishDragSource.js

function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/matchesType.js
function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/hover.js



function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        clientOffset = _ref.clientOffset;

    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds: targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}

function verifyTargetIdsIsArray(targetIdsArg) {
  Object(invariant_esm["a" /* invariant */])(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}

function checkInvariants(targetIds, monitor, registry) {
  Object(invariant_esm["a" /* invariant */])(monitor.isDragging(), 'Cannot call hover while not dragging.');
  Object(invariant_esm["a" /* invariant */])(!monitor.didDrop(), 'Cannot call hover after drop.');

  for (var i = 0; i < targetIds.length; i++) {
    var targetId = targetIds[i];
    Object(invariant_esm["a" /* invariant */])(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
    var target = registry.getTarget(targetId);
    Object(invariant_esm["a" /* invariant */])(target, 'Expected targetIds to be registered.');
  }
}

function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  // Remove those targetIds that don't match the targetType.  This
  // fixes shallow isOver which would only be non-shallow because of
  // non-matching targets.
  for (var i = targetIds.length - 1; i >= 0; i--) {
    var targetId = targetIds[i];
    var targetType = registry.getTargetType(targetId);

    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}

function hoverAllTargets(targetIds, monitor, registry) {
  // Finally call hover on all matching targets.
  targetIds.forEach(function (targetId) {
    var target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/drop.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    drop_verifyInvariants(monitor);
    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

    targetIds.forEach(function (targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread(_objectSpread({}, options), dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}

function drop_verifyInvariants(monitor) {
  Object(invariant_esm["a" /* invariant */])(monitor.isDragging(), 'Cannot call drop while not dragging.');
  Object(invariant_esm["a" /* invariant */])(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}

function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : undefined;
  verifyDropResultType(dropResult);

  if (typeof dropResult === 'undefined') {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }

  return dropResult;
}

function verifyDropResultType(dropResult) {
  Object(invariant_esm["a" /* invariant */])(typeof dropResult === 'undefined' || isObject(dropResult), 'Drop result must either be an object or undefined.');
}

function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/endDrag.js


function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();

    if (sourceId != null) {
      var source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
    }

    return {
      type: END_DRAG
    };
  };
}

function verifyIsDragging(monitor) {
  Object(invariant_esm["a" /* invariant */])(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/dragDrop/index.js






function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/classes/DragDropManagerImpl.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function DragDropManagerImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var DragDropManagerImpl_DragDropManagerImpl = /*#__PURE__*/function () {
  function DragDropManagerImpl(store, monitor) {
    var _this = this;

    _classCallCheck(this, DragDropManagerImpl);

    DragDropManagerImpl__defineProperty(this, "store", void 0);

    DragDropManagerImpl__defineProperty(this, "monitor", void 0);

    DragDropManagerImpl__defineProperty(this, "backend", void 0);

    DragDropManagerImpl__defineProperty(this, "isSetUp", false);

    DragDropManagerImpl__defineProperty(this, "handleRefCountChange", function () {
      var shouldSetUp = _this.store.getState().refCount > 0;

      if (_this.backend) {
        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();

          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();

          _this.isSetUp = false;
        }
      }
    });

    this.store = store;
    this.monitor = monitor;
    store.subscribe(this.handleRefCountChange);
  }

  _createClass(DragDropManagerImpl, [{
    key: "receiveBackend",
    value: function receiveBackend(backend) {
      this.backend = backend;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = createDragDropActions(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);

  return DragDropManagerImpl;
}();
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(296);

// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/equality.js
var strictEquality = function strictEquality(a, b) {
  return a === b;
};
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */

function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */

function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;

  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }

  return true;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/dragOffset.js
function dragOffset_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function dragOffset__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dragOffset_ownKeys(Object(source), true).forEach(function (key) { dragOffset__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dragOffset_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function dragOffset__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };

    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }

      return dragOffset__objectSpread(dragOffset__objectSpread({}, state), {}, {
        clientOffset: payload.clientOffset
      });

    case END_DRAG:
    case DROP:
      return initialState;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/actions/registry.js
var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function registry_addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function registry_addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: targetId
    }
  };
}
function registry_removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function registry_removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: targetId
    }
  };
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/dragOperation.js
function dragOperation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function dragOperation__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { dragOperation_ownKeys(Object(source), true).forEach(function (key) { dragOperation__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { dragOperation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function dragOperation__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var dragOperation_initialState = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function dragOperation_reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dragOperation_initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case BEGIN_DRAG:
      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });

    case PUBLISH_DRAG_SOURCE:
      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        isSourcePublic: true
      });

    case HOVER:
      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        targetIds: payload.targetIds
      });

    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }

      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        targetIds: without(state.targetIds, payload.targetId)
      });

    case DROP:
      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });

    case END_DRAG:
      return dragOperation__objectSpread(dragOperation__objectSpread({}, state), {}, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/refCount.js

function refCount_reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;

    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;

    default:
      return state;
  }
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/dirtiness.js

var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */

function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }

  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
    return true;
  }

  var commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/dirtyHandlerIds.js





function dirtyHandlerIds_reduce() {
  var _state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;

  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case HOVER:
      break;

    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;

    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }

  var _action$payload = action.payload,
      _action$payload$targe = _action$payload.targetIds,
      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
      _action$payload$prevT = _action$payload.prevTargetIds,
      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);

  if (!didChange) {
    return NONE;
  } // Check the target ids at the innermost position. If they are valid, add them
  // to the result


  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];

  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }

    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }

  return result;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/stateId.js
function stateId_reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/reducers/index.js
function reducers_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function reducers__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { reducers_ownKeys(Object(source), true).forEach(function (key) { reducers__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { reducers_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function reducers__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function reducers_reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: dirtyHandlerIds_reduce(state.dirtyHandlerIds, {
      type: action.type,
      payload: reducers__objectSpread(reducers__objectSpread({}, action.payload), {}, {
        prevTargetIds: get(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: reduce(state.dragOffset, action),
    refCount: refCount_reduce(state.refCount, action),
    dragOperation: dragOperation_reduce(state.dragOperation, action),
    stateId: stateId_reduce(state.stateId)
  };
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/coords.js
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */

function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */

function coords_getSourceClientOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset,
      initialSourceClientOffset = state.initialSourceClientOffset;

  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }

  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */

function coords_getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset;

  if (!clientOffset || !initialClientOffset) {
    return null;
  }

  return subtract(clientOffset, initialClientOffset);
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/classes/DragDropMonitorImpl.js
function DragDropMonitorImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function DragDropMonitorImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function DragDropMonitorImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) DragDropMonitorImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) DragDropMonitorImpl__defineProperties(Constructor, staticProps); return Constructor; }

function DragDropMonitorImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var DragDropMonitorImpl_DragDropMonitorImpl = /*#__PURE__*/function () {
  function DragDropMonitorImpl(store, registry) {
    DragDropMonitorImpl__classCallCheck(this, DragDropMonitorImpl);

    DragDropMonitorImpl__defineProperty(this, "store", void 0);

    DragDropMonitorImpl__defineProperty(this, "registry", void 0);

    this.store = store;
    this.registry = registry;
  }

  DragDropMonitorImpl__createClass(DragDropMonitorImpl, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        handlerIds: undefined
      };
      var handlerIds = options.handlerIds;
      Object(invariant_esm["a" /* invariant */])(typeof listener === 'function', 'listener must be a function.');
      Object(invariant_esm["a" /* invariant */])(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this2 = this;

      Object(invariant_esm["a" /* invariant */])(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this2.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId);
      Object(invariant_esm["a" /* invariant */])(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var target = this.registry.getTarget(targetId);
      Object(invariant_esm["a" /* invariant */])(target, "Expected to find a valid target. targetId=".concat(targetId));

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      // undefined on initial render
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId, true);
      Object(invariant_esm["a" /* invariant */])(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };

      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !matchesType(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return coords_getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return coords_getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]);

  return DragDropMonitorImpl;
}();
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/utils/getNextUniqueId.js
var nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/contracts.js
function contracts__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { contracts__typeof = function _typeof(obj) { return typeof obj; }; } else { contracts__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return contracts__typeof(obj); }


function validateSourceContract(source) {
  Object(invariant_esm["a" /* invariant */])(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  Object(invariant_esm["a" /* invariant */])(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  Object(invariant_esm["a" /* invariant */])(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
  Object(invariant_esm["a" /* invariant */])(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  Object(invariant_esm["a" /* invariant */])(typeof target.hover === 'function', 'Expected hover to be a function.');
  Object(invariant_esm["a" /* invariant */])(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function (t) {
      return validateType(t, false);
    });
    return;
  }

  Object(invariant_esm["a" /* invariant */])(typeof type === 'string' || contracts__typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}
// EXTERNAL MODULE: ./node_modules/@react-dnd/asap/dist/esm/browser/raw.js
var raw = __webpack_require__(1226);

// CONCATENATED MODULE: ./node_modules/@react-dnd/asap/dist/esm/browser/asap.js
 // rawAsap provides everything we need except exception management.
// RawTasks are recycled to reduce GC churn.

var freeTasks = []; // We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.

var pendingErrors = [];
var requestErrorThrow = raw["a" /* rawAsap */].makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
  if (pendingErrors.length) {
    throw pendingErrors.shift();
  }
}
/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */


function asap(task) {
  var rawTask;

  if (freeTasks.length) {
    rawTask = freeTasks.pop();
  } else {
    rawTask = new RawTask();
  }

  rawTask.task = task;
  Object(raw["a" /* rawAsap */])(rawTask);
} // We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.

var RawTask =
/** @class */
function () {
  function RawTask() {}

  RawTask.prototype.call = function () {
    try {
      this.task.call();
    } catch (error) {
      if (asap.onerror) {
        // This hook exists purely for testing purposes.
        // Its name will be periodically randomized to break any code that
        // depends on its existence.
        asap.onerror(error);
      } else {
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        pendingErrors.push(error);
        requestErrorThrow();
      }
    } finally {
      this.task = null;
      freeTasks[freeTasks.length] = this;
    }
  };

  return RawTask;
}();
// CONCATENATED MODULE: ./node_modules/@react-dnd/asap/dist/esm/browser/index.js

// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/classes/HandlerRegistryImpl.js
function HandlerRegistryImpl__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HandlerRegistryImpl__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function HandlerRegistryImpl__createClass(Constructor, protoProps, staticProps) { if (protoProps) HandlerRegistryImpl__defineProperties(Constructor.prototype, protoProps); if (staticProps) HandlerRegistryImpl__defineProperties(Constructor, staticProps); return Constructor; }

function HandlerRegistryImpl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








function getNextHandlerId(role) {
  var id = getNextUniqueId().toString();

  switch (role) {
    case HandlerRole.SOURCE:
      return "S".concat(id);

    case HandlerRole.TARGET:
      return "T".concat(id);

    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}

function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case 'S':
      return HandlerRole.SOURCE;

    case 'T':
      return HandlerRole.TARGET;

    default:
      Object(invariant_esm["a" /* invariant */])(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}

function mapContainsValue(map, searchValue) {
  var entries = map.entries();
  var isDone = false;

  do {
    var _entries$next = entries.next(),
        done = _entries$next.done,
        _entries$next$value = _slicedToArray(_entries$next.value, 2),
        value = _entries$next$value[1];

    if (value === searchValue) {
      return true;
    }

    isDone = !!done;
  } while (!isDone);

  return false;
}

var HandlerRegistryImpl_HandlerRegistryImpl = /*#__PURE__*/function () {
  function HandlerRegistryImpl(store) {
    HandlerRegistryImpl__classCallCheck(this, HandlerRegistryImpl);

    HandlerRegistryImpl__defineProperty(this, "types", new Map());

    HandlerRegistryImpl__defineProperty(this, "dragSources", new Map());

    HandlerRegistryImpl__defineProperty(this, "dropTargets", new Map());

    HandlerRegistryImpl__defineProperty(this, "pinnedSourceId", null);

    HandlerRegistryImpl__defineProperty(this, "pinnedSource", null);

    HandlerRegistryImpl__defineProperty(this, "store", void 0);

    this.store = store;
  }

  HandlerRegistryImpl__createClass(HandlerRegistryImpl, [{
    key: "addSource",
    value: function addSource(type, source) {
      validateType(type);
      validateSourceContract(source);
      var sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
      this.store.dispatch(registry_addSource(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget(type, target) {
      validateType(type, true);
      validateTargetContract(target);
      var targetId = this.addHandler(HandlerRole.TARGET, type, target);
      this.store.dispatch(registry_addTarget(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      Object(invariant_esm["a" /* invariant */])(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      Object(invariant_esm["a" /* invariant */])(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      Object(invariant_esm["a" /* invariant */])(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      Object(invariant_esm["a" /* invariant */])(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource(sourceId) {
      var _this = this;

      Object(invariant_esm["a" /* invariant */])(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(registry_removeSource(sourceId));
      asap(function () {
        _this.dragSources.delete(sourceId);

        _this.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget(targetId) {
      Object(invariant_esm["a" /* invariant */])(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(registry_removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      Object(invariant_esm["a" /* invariant */])(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      Object(invariant_esm["a" /* invariant */])(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    }
  }]);

  return HandlerRegistryImpl;
}();
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/createDragDropManager.js





function createDragDropManager(backendFactory) {
  var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var store = makeStoreInstance(debugMode);
  var monitor = new DragDropMonitorImpl_DragDropMonitorImpl(store, new HandlerRegistryImpl_HandlerRegistryImpl(store));
  var manager = new DragDropManagerImpl_DragDropManagerImpl(store, monitor);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}

function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return Object(redux["createStore"])(reducers_reduce, debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}
// CONCATENATED MODULE: ./node_modules/dnd-core/dist/esm/index.js
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return HandlerRole; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return createDragDropManager; });



/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = rawAsap;
// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
function rawAsap(task) {
  if (!queue.length) {
    requestFlush();
    flushing = true;
  } // Equivalent to push, but avoids a function call.


  queue[queue.length] = task;
}
var queue = []; // Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
// @ts-ignore

var flushing = false; // `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.

var requestFlush; // The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.

var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.

var capacity = 1024; // The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.

function flush() {
  while (index < queue.length) {
    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
    // begin flushing on the next task the task throws an error.

    index = index + 1;
    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
    // If we call `asap` within tasks scheduled by `asap`, the queue will
    // grow, but to avoid an O(n) walk for every task we execute, we don't
    // shift tasks off the queue after they have been executed.
    // Instead, we periodically shift 1024 tasks off the queue.

    if (index > capacity) {
      // Manually shift all values starting at the index back to the
      // beginning of the queue.
      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
        queue[scan] = queue[scan + index];
      }

      queue.length -= index;
      index = 0;
    }
  }

  queue.length = 0;
  index = 0;
  flushing = false;
} // `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */


var scope = typeof global !== 'undefined' ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver; // MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7

if (typeof BrowserMutationObserver === 'function') {
  requestFlush = makeRequestCallFromMutationObserver(flush); // MessageChannels are desirable because they give direct access to the HTML
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
} else {
  requestFlush = makeRequestCallFromTimer(flush);
} // `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.


rawAsap.requestFlush = requestFlush; // To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".

function makeRequestCallFromMutationObserver(callback) {
  var toggle = 1;
  var observer = new BrowserMutationObserver(callback);
  var node = document.createTextNode('');
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.


function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    // We dispatch a timeout with a specified delay of 0 for engines that
    // can reliably accommodate that request. This will usually be snapped
    // to a 4 milisecond delay, but once we're flushing, there's no delay
    // between events.
    var timeoutHandle = setTimeout(handleTimer, 0); // However, since this timer gets frequently dropped in Firefox
    // workers, we enlist an interval handle that will try to fire
    // an event 20 times per second until it succeeds.

    var intervalHandle = setInterval(handleTimer, 50);

    function handleTimer() {
      // Whichever timer succeeds will cancel both timers and
      // execute the callback.
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
} // This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.


rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer; // ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableLevelItem = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  border-radius: 5px;\n  background-color: ', ';\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  margin-bottom: 12px;\n  padding: 10px 17px;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  border-radius: 5px;\n  background-color: ', ';\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  margin-bottom: 12px;\n  padding: 10px 17px;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n'], ['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(143);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _ItemTypes = __webpack_require__(248);

var _SortOrder = __webpack_require__(249);

var _SortOrder2 = _interopRequireDefault(_SortOrder);

var _P = __webpack_require__(315);

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelFlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'DraggableLevelItem__LevelFlexContainer',
  componentId: 'sc-2ewmiu-0'
})(_templateObject, _colors2.default.white);

var SortIcon = _styledComponents2.default.img.attrs({
  src: _SortOrder2.default
}).withConfig({
  displayName: 'DraggableLevelItem__SortIcon',
  componentId: 'sc-2ewmiu-1'
})(_templateObject2);

var DraggableLevelItem = exports.DraggableLevelItem = function DraggableLevelItem(_ref) {
  var level = _ref.level,
      id = _ref.id,
      index = _ref.index,
      moveCard = _ref.moveCard;

  var ref = (0, _react.useRef)(null);

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: _ItemTypes.ItemTypes.LEVEL_ROW,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover: function hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      var dragIndex = item.index;
      var hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      var hoverBoundingRect = ref.current.getBoundingClientRect();
      // Get vertical middle
      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      var clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      var hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    }
  }),
      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
      handlerId = _useDrop2[0].handlerId,
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: _ItemTypes.ItemTypes.LEVEL_ROW,
    item: function item() {
      return { id: id, index: index };
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return _react2.default.createElement(
    'div',
    { ref: ref },
    _react2.default.createElement(
      LevelFlexContainer
      // onMouseEnter={() => setShow(true)}
      // onMouseLeave={() => setShow(false)}
      ,
      null,
      _react2.default.createElement(SortIcon, null),
      _react2.default.createElement(
        _P2.default,
        null,
        level.name
      )
    )
  );
};

DraggableLevelItem.propTypes = {
  level: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  id: _propTypes2.default.number.isRequired
};

exports.default = DraggableLevelItem;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 30px 30px;\n'], ['\n  padding: 0 30px 30px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactQuery = __webpack_require__(34);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _API = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateActivityModal__ModalContainer',
  componentId: 'sc-1vaik4i-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateActivityModal__FlexContainer',
  componentId: 'sc-1vaik4i-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateActivityModal__HeaderContainer',
  componentId: 'sc-1vaik4i-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CreateActivityModal__MainContainer',
  componentId: 'sc-1vaik4i-3'
})(_templateObject4);

var CreateActivityModal = function CreateActivityModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId,
      levelId = _ref.levelId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      activityName = _useState2[0],
      setActivityName = _useState2[1];

  var handleActivityName = function handleActivityName(e) {
    setActivityName(e.target.value);
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var levelId = _ref2.levelId,
        activityName = _ref2.activityName;
    return (0, _API.createNewLevelActivity)(apiData, levelId, activityName);
  });
  var couldSaveData = activityName.length > 0;

  var handleSaveNewActivity = function handleSaveNewActivity() {
    if (couldSaveData) {
      createMutation.mutate({
        apiData: apiData,
        levelId: levelId,
        activityName: activityName
      }, {
        onSuccess: function onSuccess(data) {
          queryClient.invalidateQueries('level-activities-' + levelId);
          setTimeout(function () {
            closeTheModal();
            dispatch((0, _reactRouterRedux.push)('/mycourses/' + activityCourseId + '/journey/' + journeyId + '/level/' + levelId + '/activityQuest/' + data.id + '/edit'));
          }, 300);
        }
      });
    }
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          '+ New Activity'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: closeTheModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(
            'div',
            {
              'data-for': 'createCourseTooltip',
              'data-tip': 'Please enter all required fields prior to creating this course.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Create',
              handleClick: handleSaveNewActivity,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              couldSaveData: couldSaveData,
              shouldShowTooltipAndDisableButton: true
            }),
            !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
              id: 'createCourseTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Activity Name',
          placeholder: 'Activity Name',
          handleEnteredTextValue: handleActivityName,
          value: activityName,
          shouldDisplayAsteriskSymbol: true
        })
      )
    )
  );
};

CreateActivityModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.number.isRequired,
  journeyId: _propTypes2.default.number.isRequired,
  levelId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(CreateActivityModal);

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _SelectorComponent = __webpack_require__(245);

var _SelectorComponent2 = _interopRequireDefault(_SelectorComponent);

var _API = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChangeLevelForActivityModal__ModalContainer',
  componentId: 'sc-99zdtz-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChangeLevelForActivityModal__HeaderContainer',
  componentId: 'sc-99zdtz-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChangeLevelForActivityModal__MainContainer',
  componentId: 'sc-99zdtz-2'
})(_templateObject3);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChangeLevelForActivityModal__FlexContainer',
  componentId: 'sc-99zdtz-3'
})(_templateObject4);

var ChangeLevelForActivityModal = function ChangeLevelForActivityModal(_ref) {
  var apiData = _ref.apiData,
      levels = _ref.levels,
      currentLevelId = _ref.currentLevelId,
      activityQuestId = _ref.activityQuestId,
      activityQuestName = _ref.activityQuestName,
      handleShouldExpandLevel = _ref.handleShouldExpandLevel,
      journeyId = _ref.journeyId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(levels.find(function (l) {
    return l.id === currentLevelId;
  })),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      selectedLevel = _useState2[0],
      setSelectedLevel = _useState2[1];

  var handleSelectedLevel = function handleSelectedLevel(e) {
    setSelectedLevel(e);
  };

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        currentLevelId = _ref2.currentLevelId,
        activityQuestId = _ref2.activityQuestId,
        selectedLevel = _ref2.selectedLevel;
    return (0, _API.moveActivityToDifferentLevel)(apiData, currentLevelId, activityQuestId, selectedLevel);
  });

  var handleChangeLevel = function handleChangeLevel() {
    createMutation.mutate({
      apiData: apiData,
      currentLevelId: currentLevelId,
      activityQuestId: activityQuestId,
      selectedLevel: selectedLevel.id
    }, {
      onSuccess: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
          var el;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  queryClient.setQueryData(['journey-levels-' + journeyId], function (ls) {
                    return [].concat((0, _toConsumableArray3.default)(ls)).map(function (nl) {
                      if (nl.id === selectedLevel.id || nl.id === currentLevelId) {
                        return (0, _assign2.default)({}, nl, { just_created: true });
                      } else {
                        return nl;
                      }
                    });
                  });
                  _context.next = 3;
                  return queryClient.refetchQueries(['journey-levels-' + journeyId]);

                case 3:
                  _context.next = 5;
                  return queryClient.refetchQueries(['journey-level-' + currentLevelId]);

                case 5:
                  _context.next = 7;
                  return queryClient.refetchQueries(['journey-level-' + selectedLevel.id]);

                case 7:
                  _context.next = 9;
                  return queryClient.refetchQueries(['level-activities-' + currentLevelId]);

                case 9:
                  _context.next = 11;
                  return queryClient.refetchQueries(['level-activities-' + selectedLevel.id]);

                case 11:

                  handleCloseModal();

                  el = document.getElementById('level-id-' + selectedLevel.id);

                  if (el) {
                    el.scrollIntoView({
                      behavior: 'smooth'
                    });
                  }

                case 14:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        function onSuccess() {
          return _ref3.apply(this, arguments);
        }

        return onSuccess;
      }()
    });
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          activityQuestName
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _MarginRight2.default,
            null,
            _react2.default.createElement(_CancelButton2.default, {
              handleClick: handleCloseModal,
              title: 'Cancel',
              width: '104px'
            })
          ),
          _react2.default.createElement(_Button2.default, {
            width: '104px',
            title: 'Save',
            handleClick: handleChangeLevel,
            buttonColor: _colors2.default.oeYellow,
            borderColor: _colors2.default.oeYellow,
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white,
            shouldShowTooltipAndDisableButton: false
          })
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_SelectorComponent2.default, {
          placeholder: 'Level',
          handleSelectedValueChange: handleSelectedLevel,
          selectedValue: selectedLevel,
          options: levels,
          shouldDisplayAsterisk: false
        })
      )
    )
  );
};

ChangeLevelForActivityModal.propTypes = {
  closeCallback: _propTypes2.default.func,
  apiData: _propTypes2.default.object.isRequired,
  levels: _propTypes2.default.array.isRequired,
  currentLevelId: _propTypes2.default.number.isRequired,
  activityQuestId: _propTypes2.default.number.isRequired,
  activityQuestName: _propTypes2.default.string.isRequired,
  handleShouldExpandLevel: _propTypes2.default.func.isRequired,
  journeyId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(ChangeLevelForActivityModal);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 16px;\n'], ['\n  color: ', ';\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 16px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n'], ['\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _reactAvatarEditor = __webpack_require__(598);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _API = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__ModalContainer',
  componentId: 'bbyeyu-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__FlexContainer',
  componentId: 'bbyeyu-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__HeaderContainer',
  componentId: 'bbyeyu-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__MainContainer',
  componentId: 'bbyeyu-3'
})(_templateObject4);

var HintText = _styledComponents2.default.p.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__HintText',
  componentId: 'bbyeyu-4'
})(_templateObject5, _colors2.default.aluminum);

var Label = _styledComponents2.default.label.withConfig({
  displayName: 'AddOrRemoveActivityIconModal__Label',
  componentId: 'bbyeyu-5'
})(_templateObject6, _colors2.default.aluminum, _colors2.default.white, _colors2.default.black, _colors2.default.white, _colors2.default.charcoal2, _colors2.default.charcoal2);

var AddOrRemoveActivityIconModal = function AddOrRemoveActivityIconModal(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      activity = _ref.activity;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(activity.icon_image_url !== null ? activity.icon_image_url : null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      fileUrl = _useState2[0],
      setFileUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(activity.icon_image_original_file_name !== null ? activity.icon_image_original_file_name : null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      fileName = _useState4[0],
      setFileName = _useState4[1];

  var _useState5 = (0, _react.useState)(1),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      scale = _useState6[0],
      setScale = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      editorState = _useState8[0],
      setEditorState = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      isHovered = _useState10[0],
      setIsHovered = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      fileSize = _useState12[0],
      setFileSize = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      isLoading = _useState14[0],
      setIsLoading = _useState14[1];

  var inputRef = (0, _react.useRef)(null);

  var setEditorRef = function setEditorRef(editor) {
    if (editor) {
      setEditorState(editor);
    }
  };

  var onFileLoad = function onFileLoad(e) {
    var reader = new FileReader();
    if (e.target.files[0].size < 500000) {
      var _fileName = e.target.value.replace(/^.*[\\\/]/, '');
      reader.onload = function (e) {
        setFileName(_fileName);
        setFileUrl(e.target.result);
      };
      setFileSize(e.target.files[0].size);

      reader.readAsDataURL(e.target.files[0]);
    } else {
      setFileName(null);
      setFileUrl(null);
      setFileSize(e.target.files[0].size);
      document.getElementById('file-input').value = '';
    }
  };

  var onZoom = function onZoom(e) {
    setScale(e.target.value);
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        type = _ref2.type,
        fileUrl = _ref2.fileUrl,
        fileName = _ref2.fileName;
    return (0, _API.uploadImage)(apiData, levelId, activityQuestId, type, fileUrl, fileName);
  });
  var couldSaveData = fileUrl !== null && fileSize < 500000;

  var handleSaveActivityIcon = function handleSaveActivityIcon() {
    var canvasScaled = editorState.getImageScaledToCanvas();
    var fileURL = canvasScaled.toDataURL();
    if (couldSaveData) {
      setIsLoading(true);
      createMutation.mutate({
        apiData: apiData,
        levelId: levelId,
        activityQuestId: activityQuestId,
        type: 'icon',
        fileUrl: fileURL,
        fileName: fileName
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('activity-' + activityQuestId);
          setIsLoading(false);
          setTimeout(function () {
            closeTheModal();
          }, 300);
        }
      });
    }
  };

  var createMutationOnDeleteActivityIcon = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        levelId = _ref3.levelId,
        activityQuestId = _ref3.activityQuestId,
        mentorFileId = _ref3.mentorFileId;
    return (0, _API.removeActivityIcon)(apiData, levelId, activityQuestId, mentorFileId);
  });

  var handleDeleteActivityIcon = function handleDeleteActivityIcon() {
    createMutationOnDeleteActivityIcon.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('activity-' + activityQuestId);
        activity.icon_image_url = null;
        setFileName(null);
      }
    });
  };

  var displayAvatarCropper = function displayAvatarCropper() {
    var iconComponent = void 0;
    if (activity.icon_image_url === null && fileName !== null) {
      iconComponent = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactAvatarEditor2.default, {
          ref: setEditorRef,
          image: fileUrl,
          width: 200,
          height: 200,
          borderRadius: 75,
          border: 0,
          scale: scale
        }),
        _react2.default.createElement('input', {
          className: 'zoom-slider',
          type: 'range',
          step: '0.01',
          min: '1',
          max: '2',
          name: 'scale',
          defaultValue: '1',
          onChange: onZoom,
          style: { width: '200px' }
        })
      );
    } else if (activity.icon_image_original_file_name !== null && fileName === null || activity.icon_image_url === null && fileName === null || fileSize > 50000) {
      iconComponent = _react2.default.createElement('div', null);
    } else if (activity.icon_image_url !== null) {
      iconComponent = _react2.default.createElement('img', {
        src: activity.icon_image_url,
        style: { width: '200px', height: '200px' }
      });
    }
    return iconComponent;
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      isLoading ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          HeaderContainer,
          null,
          _react2.default.createElement(
            _H2.default,
            null,
            'Activity Icon'
          ),
          _react2.default.createElement(
            FlexContainer,
            null,
            _react2.default.createElement(
              _MarginRight2.default,
              null,
              _react2.default.createElement(_CancelButton2.default, {
                handleClick: closeTheModal,
                title: 'Cancel',
                width: '104px'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                'data-for': 'createCourseTooltip',
                'data-tip': 'File size limit is 500 KB'
              },
              _react2.default.createElement(_Button2.default, {
                width: '104px',
                title: 'Create',
                handleClick: handleSaveActivityIcon,
                buttonColor: _colors2.default.oeYellow,
                borderColor: _colors2.default.oeYellow,
                hoverBackground: _colors2.default.charcoal4,
                hoverColor: _colors2.default.white,
                couldSaveData: couldSaveData,
                shouldShowTooltipAndDisableButton: true
              }),
              !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
                id: 'createCourseTooltip',
                place: 'bottom',
                effect: 'solid',
                className: 'activityCourseTooltip'
              })
            )
          )
        ),
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(
            'div',
            null,
            activity.icon_image_url === null ? _react2.default.createElement(
              FlexContainer,
              {
                style: {
                  justifyContent: 'flex-start',
                  alignItems: 'center'
                }
              },
              _react2.default.createElement(
                Label,
                { htmlFor: 'file-input' },
                'Choose File'
              ),
              _react2.default.createElement(
                'p',
                { style: { marginLeft: '10px' } },
                fileName !== null ? fileName : 'No file chosen'
              ),
              _react2.default.createElement('input', {
                id: 'file-input',
                className: 'activity-icon-input',
                type: 'file',
                onChange: onFileLoad,
                ref: inputRef,
                style: { display: 'none' }
              })
            ) : _react2.default.createElement(
              'div',
              { style: { margin: '20px 0' } },
              activity.icon_image_original_file_name,
              _react2.default.createElement(
                'span',
                {
                  style: {
                    marginLeft: '15px',
                    marginTop: '4px',
                    cursor: 'pointer'
                  },
                  onMouseEnter: function onMouseEnter() {
                    return setIsHovered(true);
                  },
                  onMouseLeave: function onMouseLeave() {
                    return setIsHovered(false);
                  },
                  onClick: handleDeleteActivityIcon
                },
                _react2.default.createElement(
                  'svg',
                  {
                    xmlns: 'http://www.w3.org/2000/svg',
                    width: '12',
                    height: '12',
                    viewBox: '0 0 25 24'
                  },
                  _react2.default.createElement(
                    'g',
                    {
                      fill: 'none',
                      fillRule: 'evenodd',
                      stroke: isHovered ? _colors2.default.crimsonLite : _colors2.default.dove,
                      strokeWidth: '3',
                      transform: 'translate(2 1)'
                    },
                    _react2.default.createElement('path', { d: 'M0 0L22 22M22 0L0 22' })
                  )
                )
              )
            ),
            displayAvatarCropper()
          ),
          _react2.default.createElement(
            HintText,
            null,
            fileSize > 500000 && _react2.default.createElement(
              'span',
              { style: { color: _colors2.default.crimson } },
              'File size limit is 500 KB.'
            ),
            ' ',
            'For best viewing, please use a square png or jpeg image.'
          )
        )
      )
    )
  );
};

AddOrRemoveActivityIconModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.string.isRequired,
  activityQuestId: _propTypes2.default.string.isRequired,
  activity: _propTypes2.default.object.isRequired
};

exports.default = (0, _withApiData2.default)(AddOrRemoveActivityIconModal);

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(207);


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1235);
var ReactElement = __webpack_require__(208);

var emptyFunction = __webpack_require__(129);
var traverseAllChildren = __webpack_require__(1236);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(250);

var invariant = __webpack_require__(28);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(250);

var ReactCurrentOwner = __webpack_require__(144);
var REACT_ELEMENT_TYPE = __webpack_require__(602);

var getIteratorFn = __webpack_require__(1237);
var invariant = __webpack_require__(28);
var KeyEscapeUtils = __webpack_require__(1238);
var warning = __webpack_require__(40);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(208);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(208),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(603);

module.exports = factory(isValidElement);

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(1242);
var assign = __webpack_require__(37);

var ReactPropTypesSecret = __webpack_require__(533);
var checkPropTypes = __webpack_require__(1244);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1243);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(599),
    Component = _require.Component;

var _require2 = __webpack_require__(208),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(600);
var factory = __webpack_require__(532);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(250);

var ReactElement = __webpack_require__(208);

var invariant = __webpack_require__(28);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1249);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(52);
var ReactDefaultInjection = __webpack_require__(1250);
var ReactMount = __webpack_require__(627);
var ReactReconciler = __webpack_require__(210);
var ReactUpdates = __webpack_require__(130);
var ReactVersion = __webpack_require__(1320);

var findDOMNode = __webpack_require__(1321);
var getHostComponentFromComposite = __webpack_require__(628);
var renderSubtreeIntoContainer = __webpack_require__(1322);
var warning = __webpack_require__(40);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1251);
var BeforeInputEventPlugin = __webpack_require__(1252);
var ChangeEventPlugin = __webpack_require__(1256);
var DefaultEventPluginOrder = __webpack_require__(1259);
var EnterLeaveEventPlugin = __webpack_require__(1260);
var HTMLDOMPropertyConfig = __webpack_require__(1261);
var ReactComponentBrowserEnvironment = __webpack_require__(1262);
var ReactDOMComponent = __webpack_require__(1268);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactDOMEmptyComponent = __webpack_require__(1291);
var ReactDOMTreeTraversal = __webpack_require__(1292);
var ReactDOMTextComponent = __webpack_require__(1293);
var ReactDefaultBatchingStrategy = __webpack_require__(1294);
var ReactEventListener = __webpack_require__(1295);
var ReactInjection = __webpack_require__(1297);
var ReactReconcileTransaction = __webpack_require__(1298);
var SVGDOMPropertyConfig = __webpack_require__(1304);
var SelectEventPlugin = __webpack_require__(1305);
var SimpleEventPlugin = __webpack_require__(1306);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(251);
var ExecutionEnvironment = __webpack_require__(84);
var FallbackCompositionState = __webpack_require__(1253);
var SyntheticCompositionEvent = __webpack_require__(1254);
var SyntheticInputEvent = __webpack_require__(1255);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var PooledClass = __webpack_require__(187);

var getTextContentAccessor = __webpack_require__(607);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(252);
var EventPropagators = __webpack_require__(251);
var ExecutionEnvironment = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactUpdates = __webpack_require__(130);
var SyntheticEvent = __webpack_require__(145);

var inputValueTracking = __webpack_require__(610);
var getEventTarget = __webpack_require__(420);
var isEventSupported = __webpack_require__(421);
var isTextInputElement = __webpack_require__(611);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(1258);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(251);
var ReactDOMComponentTree = __webpack_require__(52);
var SyntheticMouseEvent = __webpack_require__(317);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(209);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(423);
var ReactDOMIDOperations = __webpack_require__(1267);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var DOMLazyTree = __webpack_require__(211);
var ExecutionEnvironment = __webpack_require__(84);

var createNodesFromMarkup = __webpack_require__(1264);
var emptyFunction = __webpack_require__(129);
var invariant = __webpack_require__(28);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(84);

var createArrayFromMixed = __webpack_require__(1265);
var getMarkupWrap = __webpack_require__(1266);
var invariant = __webpack_require__(28);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(28);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(84);

var invariant = __webpack_require__(28);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(423);
var ReactDOMComponentTree = __webpack_require__(52);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var AutoFocusUtils = __webpack_require__(1269);
var CSSPropertyOperations = __webpack_require__(1270);
var DOMLazyTree = __webpack_require__(211);
var DOMNamespaces = __webpack_require__(424);
var DOMProperty = __webpack_require__(209);
var DOMPropertyOperations = __webpack_require__(616);
var EventPluginHub = __webpack_require__(252);
var EventPluginRegistry = __webpack_require__(417);
var ReactBrowserEventEmitter = __webpack_require__(320);
var ReactDOMComponentFlags = __webpack_require__(604);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactDOMInput = __webpack_require__(1278);
var ReactDOMOption = __webpack_require__(1280);
var ReactDOMSelect = __webpack_require__(617);
var ReactDOMTextarea = __webpack_require__(1281);
var ReactInstrumentation = __webpack_require__(115);
var ReactMultiChild = __webpack_require__(1282);
var ReactServerRenderingTransaction = __webpack_require__(1289);

var emptyFunction = __webpack_require__(129);
var escapeTextContentForBrowser = __webpack_require__(319);
var invariant = __webpack_require__(28);
var isEventSupported = __webpack_require__(421);
var shallowEqual = __webpack_require__(428);
var inputValueTracking = __webpack_require__(610);
var validateDOMNesting = __webpack_require__(432);
var warning = __webpack_require__(40);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(52);

var focusNode = __webpack_require__(614);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(615);
var ExecutionEnvironment = __webpack_require__(84);
var ReactInstrumentation = __webpack_require__(115);

var camelizeStyleName = __webpack_require__(1271);
var dangerousStyleValue = __webpack_require__(1273);
var hyphenateStyleName = __webpack_require__(558);
var memoizeStringOnly = __webpack_require__(1274);
var warning = __webpack_require__(40);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1272);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(615);
var warning = __webpack_require__(40);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(319);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(252);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var DOMPropertyOperations = __webpack_require__(616);
var LinkedValueUtils = __webpack_require__(426);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactUpdates = __webpack_require__(130);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var React = __webpack_require__(207);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactDOMSelect = __webpack_require__(617);

var warning = __webpack_require__(40);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var LinkedValueUtils = __webpack_require__(426);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactUpdates = __webpack_require__(130);

var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactComponentEnvironment = __webpack_require__(427);
var ReactInstanceMap = __webpack_require__(254);
var ReactInstrumentation = __webpack_require__(115);

var ReactCurrentOwner = __webpack_require__(144);
var ReactReconciler = __webpack_require__(210);
var ReactChildReconciler = __webpack_require__(1283);

var emptyFunction = __webpack_require__(129);
var flattenChildren = __webpack_require__(1288);
var invariant = __webpack_require__(28);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(210);

var instantiateReactComponent = __webpack_require__(618);
var KeyEscapeUtils = __webpack_require__(430);
var shouldUpdateReactComponent = __webpack_require__(429);
var traverseAllChildren = __webpack_require__(622);
var warning = __webpack_require__(40);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(623);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var React = __webpack_require__(207);
var ReactComponentEnvironment = __webpack_require__(427);
var ReactCurrentOwner = __webpack_require__(144);
var ReactErrorUtils = __webpack_require__(419);
var ReactInstanceMap = __webpack_require__(254);
var ReactInstrumentation = __webpack_require__(115);
var ReactNodeTypes = __webpack_require__(619);
var ReactReconciler = __webpack_require__(210);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(416);
var invariant = __webpack_require__(28);
var shallowEqual = __webpack_require__(428);
var shouldUpdateReactComponent = __webpack_require__(429);
var warning = __webpack_require__(40);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(430);
var traverseAllChildren = __webpack_require__(622);
var warning = __webpack_require__(40);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(623);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var PooledClass = __webpack_require__(187);
var Transaction = __webpack_require__(316);
var ReactInstrumentation = __webpack_require__(115);
var ReactServerUpdateQueue = __webpack_require__(1290);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(431);

var warning = __webpack_require__(40);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var DOMLazyTree = __webpack_require__(211);
var ReactDOMComponentTree = __webpack_require__(52);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var invariant = __webpack_require__(28);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35),
    _assign = __webpack_require__(37);

var DOMChildrenOperations = __webpack_require__(423);
var DOMLazyTree = __webpack_require__(211);
var ReactDOMComponentTree = __webpack_require__(52);

var escapeTextContentForBrowser = __webpack_require__(319);
var invariant = __webpack_require__(28);
var validateDOMNesting = __webpack_require__(432);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var ReactUpdates = __webpack_require__(130);
var Transaction = __webpack_require__(316);

var emptyFunction = __webpack_require__(129);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var EventListener = __webpack_require__(624);
var ExecutionEnvironment = __webpack_require__(84);
var PooledClass = __webpack_require__(187);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactUpdates = __webpack_require__(130);

var getEventTarget = __webpack_require__(420);
var getUnboundedScrollPosition = __webpack_require__(1296);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(209);
var EventPluginHub = __webpack_require__(252);
var EventPluginUtils = __webpack_require__(418);
var ReactComponentEnvironment = __webpack_require__(427);
var ReactEmptyComponent = __webpack_require__(620);
var ReactBrowserEventEmitter = __webpack_require__(320);
var ReactHostComponent = __webpack_require__(621);
var ReactUpdates = __webpack_require__(130);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(37);

var CallbackQueue = __webpack_require__(608);
var PooledClass = __webpack_require__(187);
var ReactBrowserEventEmitter = __webpack_require__(320);
var ReactInputSelection = __webpack_require__(625);
var ReactInstrumentation = __webpack_require__(115);
var Transaction = __webpack_require__(316);
var ReactUpdateQueue = __webpack_require__(431);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(84);

var getNodeForCharacterOffset = __webpack_require__(1300);
var getTextContentAccessor = __webpack_require__(607);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1302);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1303);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(251);
var ExecutionEnvironment = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactInputSelection = __webpack_require__(625);
var SyntheticEvent = __webpack_require__(145);

var getActiveElement = __webpack_require__(626);
var isTextInputElement = __webpack_require__(611);
var shallowEqual = __webpack_require__(428);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(35);

var EventListener = __webpack_require__(624);
var EventPropagators = __webpack_require__(251);
var ReactDOMComponentTree = __webpack_require__(52);
var SyntheticAnimationEvent = __webpack_require__(1307);
var SyntheticClipboardEvent = __webpack_require__(1308);
var SyntheticEvent = __webpack_require__(145);
var SyntheticFocusEvent = __webpack_require__(1309);
var SyntheticKeyboardEvent = __webpack_require__(1310);
var SyntheticMouseEvent = __webpack_require__(317);
var SyntheticDragEvent = __webpack_require__(1312);
var SyntheticTouchEvent = __webpack_require__(1313);
var SyntheticTransitionEvent = __webpack_require__(1314);
var SyntheticUIEvent = __webpack_require__(253);
var SyntheticWheelEvent = __webpack_require__(1315);

var emptyFunction = __webpack_require__(129);
var getEventCharCode = __webpack_require__(433);
var invariant = __webpack_require__(28);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(253);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(253);

var getEventCharCode = __webpack_require__(433);
var getEventKey = __webpack_require__(1311);
var getEventModifierState = __webpack_require__(422);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(433);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(317);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(253);

var getEventModifierState = __webpack_require__(422);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(145);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(317);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(432);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(1319);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(35);

var ReactCurrentOwner = __webpack_require__(144);
var ReactDOMComponentTree = __webpack_require__(52);
var ReactInstanceMap = __webpack_require__(254);

var getHostComponentFromComposite = __webpack_require__(628);
var invariant = __webpack_require__(28);
var warning = __webpack_require__(40);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(627);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 180px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 30px 30px;\n'], ['\n  padding: 10px 30px 30px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 18px;\n  width: 18px;\n  margin-right: 11px;\n  background-repeat: no-repeat;\n'], ['\n  background-image: url(', ');\n  height: 18px;\n  width: 18px;\n  margin-right: 11px;\n  background-repeat: no-repeat;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  min-width: 75px;\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n'], ['\n  min-width: 75px;\n  display: inline-block;\n  border: 1px solid ', ';\n  background: ', ';\n  color: ', ';\n  border-radius: 100px;\n  padding: 12px 22px;\n  margin-bottom: 10px;\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: 1px solid ', ';\n  }\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 20px;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 20px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _API = __webpack_require__(99);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _Edit = __webpack_require__(629);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrEditMentorFile__ModalContainer',
  componentId: 'sc-4oobe3-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrEditMentorFile__FlexContainer',
  componentId: 'sc-4oobe3-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrEditMentorFile__HeaderContainer',
  componentId: 'sc-4oobe3-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrEditMentorFile__MainContainer',
  componentId: 'sc-4oobe3-3'
})(_templateObject4);

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: 'AddOrEditMentorFile__EditIcon',
  componentId: 'sc-4oobe3-4'
})(_templateObject5, _Edit2.default);

var Label = _styledComponents2.default.label.withConfig({
  displayName: 'AddOrEditMentorFile__Label',
  componentId: 'sc-4oobe3-5'
})(_templateObject6, _colors2.default.aluminum, _colors2.default.white, _colors2.default.black, _colors2.default.white, _colors2.default.charcoal2, _colors2.default.charcoal2);

var FileName = _styledComponents2.default.p.withConfig({
  displayName: 'AddOrEditMentorFile__FileName',
  componentId: 'sc-4oobe3-6'
})(_templateObject7, _colors2.default.black);

var AddOrEditMentorFile = function AddOrEditMentorFile(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      mentorFile = _ref.mentorFile,
      isEditing = _ref.isEditing;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(isEditing ? mentorFile.original_file_name : null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var _useState3 = (0, _react.useState)(isEditing ? mentorFile.description : null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      description = _useState4[0],
      setDescription = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      isUploadingNote = _useState6[0],
      setIsUploadingNote = _useState6[1];

  var handleDescriptionChange = function handleDescriptionChange(e) {
    setDescription(e.target.value);
  };

  var handleCancel = function handleCancel() {
    setFile('');
    setDescription('');
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    });
  };

  var handleFileUpload = function handleFileUpload(e) {
    setFile(e.target.files[0]);
  };

  var createMutationUploadNewFile = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        file = _ref2.file,
        description = _ref2.description;
    return (0, _API.uploadMentorFile)(apiData, levelId, activityQuestId, file, description);
  });

  var createMutationOnEditDescription = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        levelId = _ref3.levelId,
        activityQuestId = _ref3.activityQuestId,
        description = _ref3.description,
        mentorFileId = _ref3.mentorFileId;
    return (0, _API.editMentorFile)(apiData, levelId, activityQuestId, description, mentorFileId);
  });
  var mentorFileId = isEditing && mentorFile.id;
  var handleSaveMentorFile = function handleSaveMentorFile() {
    setIsUploadingNote(true);
    if (isEditing) {
      createMutationOnEditDescription.mutate({
        apiData: apiData,
        levelId: levelId,
        activityQuestId: activityQuestId,
        description: description,
        mentorFileId: mentorFileId
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('activity-' + activityQuestId);
          queryClient.invalidateQueries('mentorFiles-' + activityQuestId);
          setIsUploadingNote(false);
          setTimeout(function () {
            dispatch((0, _modal.hideModal)());
          }, 300);
        }
      });
    } else {
      createMutationUploadNewFile.mutate({
        apiData: apiData,
        levelId: levelId,
        activityQuestId: activityQuestId,
        file: file,
        description: description
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('activity-' + activityQuestId);
          queryClient.invalidateQueries('mentorFiles-' + activityQuestId);
          setTimeout(function () {
            dispatch((0, _modal.hideModal)());
          }, 300);
        }
      });
    }
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      isUploadingNote ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          HeaderContainer,
          null,
          isEditing ? _react2.default.createElement(
            _FlexAlignCenter2.default,
            null,
            _react2.default.createElement(EditIcon, null),
            _react2.default.createElement(
              _H2.default,
              { style: { color: _colors2.default.victoria } },
              'Edit Mentor File'
            )
          ) : _react2.default.createElement(
            _H2.default,
            { style: { color: _colors2.default.victoria } },
            '+ Add Mentor File'
          ),
          _react2.default.createElement(
            FlexContainer,
            null,
            _react2.default.createElement(
              _MarginRight2.default,
              null,
              _react2.default.createElement(_CancelButton2.default, {
                handleClick: handleCancel,
                title: 'Cancel',
                width: '104px'
              })
            ),
            _react2.default.createElement(_Button2.default, {
              width: '104px',
              title: 'Save',
              handleClick: handleSaveMentorFile,
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              couldSaveData: file !== '',
              shouldShowTooltipAndDisableButton: file !== ''
            })
          )
        ),
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'left' } },
            _react2.default.createElement(
              'div',
              { style: { paddingTop: '15px' } },
              isEditing ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  FileName,
                  null,
                  file
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'file' },
                _react2.default.createElement(
                  FlexContainer,
                  {
                    style: {
                      justifyContent: 'flex-start',
                      alignItems: 'center'
                    }
                  },
                  _react2.default.createElement(
                    Label,
                    { htmlFor: 'mentorNoteFileInput' },
                    'Choose File'
                  ),
                  _react2.default.createElement(
                    'p',
                    { style: { marginLeft: '10px' } },
                    file !== null ? file.name : 'No file chosen'
                  ),
                  _react2.default.createElement('input', {
                    id: 'mentorNoteFileInput',
                    className: 'activity-icon-input',
                    type: 'file',
                    onChange: handleFileUpload,
                    style: { display: 'none' }
                  })
                )
              ),
              _react2.default.createElement(_TextInputComponent2.default, {
                title: 'File Description',
                placeholder: 'File Description',
                handleEnteredTextValue: handleDescriptionChange,
                value: description,
                shouldDisplayAsteriskSymbol: false,
                shouldBeTextarea: false
              })
            )
          )
        )
      )
    )
  );
};

AddOrEditMentorFile.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.number.isRequired,
  activityQuestId: _propTypes2.default.number.isRequired,
  mentorFile: _propTypes2.default.object.isRequired,
  isEditing: _propTypes2.default.bool.isRequired
};

exports.default = (0, _withApiData2.default)(AddOrEditMentorFile);

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: auto;\n  border-radius: 20px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n'], ['\n  width: 519px;\n  height: auto;\n  border-radius: 20px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 23px;\n  position: relative;\n  margin-bottom: 23px;\n'], ['\n  padding: 0 23px;\n  position: relative;\n  margin-bottom: 23px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n'], ['\n  color: ', ';\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  padding: 10px 23px;\n  border-bottom: 1px solid ', ';\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n'], ['\n  display: flex;\n  padding: 10px 23px;\n  border-bottom: 1px solid ', ';\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 43px;\n'], ['\n  width: 419px;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 43px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #eeeeee;\n'], ['\n  border-top: 1px solid #eeeeee;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'GeneralErrorModal__ModalContainer',
  componentId: 'sc-1yxusci-0'
})(_templateObject, _colors2.default.white);

var Header = _styledComponents2.default.div.withConfig({
  displayName: 'GeneralErrorModal__Header',
  componentId: 'sc-1yxusci-1'
})(_templateObject2);

var ErrorHeader = _styledComponents2.default.h3.withConfig({
  displayName: 'GeneralErrorModal__ErrorHeader',
  componentId: 'sc-1yxusci-2'
})(_templateObject3, _colors2.default.black);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'GeneralErrorModal__MainContainer',
  componentId: 'sc-1yxusci-3'
})(_templateObject4, _colors2.default.ash, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'GeneralErrorModal__DescriptionText',
  componentId: 'sc-1yxusci-4'
})(_templateObject5);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'GeneralErrorModal__ButtonBlock',
  componentId: 'sc-1yxusci-5'
})(_templateObject6);

var GeneralErrorModal = function GeneralErrorModal() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        Header,
        null,
        _react2.default.createElement(
          ErrorHeader,
          null,
          'Error'
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(
          DescriptionText,
          null,
          'Oops! Something went wrong. Please try again.',
          _react2.default.createElement('br', null),
          'Contact support if this error persists.'
        )
      ),
      _react2.default.createElement(
        ButtonBlock,
        null,
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '40%', paddingTop: '23px', paddingBottom: '30px' } },
          _react2.default.createElement(_Button2.default, {
            buttonColor: _colors2.default.white,
            width: '95px',
            borderColor: _colors2.default.aluminum,
            title: 'OK',
            handleClick: function handleClick() {
              return closeTheModal();
            },
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white
          })
        )
      )
    )
  );
};

exports.default = GeneralErrorModal;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 75px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 75px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 30px 30px;\n'], ['\n  padding: 0 30px 30px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  padding-left: 3px;\n'], ['\n  color: ', ';\n  padding-left: 3px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _API = __webpack_require__(99);

var _SelectorComponent = __webpack_require__(245);

var _SelectorComponent2 = _interopRequireDefault(_SelectorComponent);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _activityedit = __webpack_require__(434);

var _messages = __webpack_require__(21);

var _markdowneditor = __webpack_require__(142);

var _S3Uploader = __webpack_require__(435);

var _S3Uploader2 = _interopRequireDefault(_S3Uploader);

var _FileTypeIcon = __webpack_require__(322);

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddResourceModal__ModalContainer',
  componentId: 'urahy6-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddResourceModal__FlexContainer',
  componentId: 'urahy6-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddResourceModal__HeaderContainer',
  componentId: 'urahy6-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'AddResourceModal__MainContainer',
  componentId: 'urahy6-3'
})(_templateObject4);

var AsteriskSymbol = _styledComponents2.default.span.withConfig({
  displayName: 'AddResourceModal__AsteriskSymbol',
  componentId: 'urahy6-4'
})(_templateObject5, _colors2.default.crimson);

var AddResourceModal = function AddResourceModal(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      resource = _ref.resource,
      resourceId = _ref.resourceId,
      resourceName = _ref.resourceName;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      originalFileName = _useState2[0],
      setOriginalFileName = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      isHovered = _useState4[0],
      setIsHovered = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      isUploadingFile = _useState8[0],
      setIsUploadingFile = _useState8[1];

  var S3UploaderRef = (0, _react.useRef)(null);

  var _useState9 = (0, _react.useState)(true),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      isLinkChecked = _useState10[0],
      setIsLinkChecked = _useState10[1];

  var handleIsLinkChecked = function handleIsLinkChecked(e) {
    if (e === false) {
      setUrlResource(null);
    } else {
      handleClearFile();
    }
    setIsLinkChecked(e);
  };

  var _useState11 = (0, _react.useState)(resourceName),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      resourceNameState = _useState12[0],
      setResourceNameState = _useState12[1];

  var handleResourceName = function handleResourceName(e) {
    setResourceNameState(e.target.value);
  };

  var _useState13 = (0, _react.useState)(null),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      resourceDescription = _useState14[0],
      setResourceDescription = _useState14[1];

  var handleResourceDescription = function handleResourceDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'resource-description';
    event.target.value = e;

    setResourceDescription(event.target.value);
  };

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray3.default)(_useState15, 2),
      urlResource = _useState16[0],
      setUrlResource = _useState16[1];

  var handleUrlResource = function handleUrlResource(e) {
    setUrlResource(e.target.value);
  };

  var _useState17 = (0, _react.useState)(null),
      _useState18 = (0, _slicedToArray3.default)(_useState17, 2),
      selectedResourceType = _useState18[0],
      setSelectedResourceType = _useState18[1];

  var handleSelectedResourceType = function handleSelectedResourceType(e) {
    setSelectedResourceType(e);
  };

  var deleteMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        resourceId = _ref2.resourceId;
    return (0, _API.deleteNewResource)(apiData, levelId, activityQuestId, resourceId);
  });
  var closeTheModal = function closeTheModal() {
    handleClearFile();
    deleteMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resourceId
    }, {
      onSuccess: function onSuccess() {
        dispatch((0, _modal.hideModal)());
      }
    });
  };

  var createMutationSaveUrlResource = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        levelId = _ref3.levelId,
        activityQuestId = _ref3.activityQuestId,
        resourceId = _ref3.resourceId,
        resource = _ref3.resource;
    return (0, _API.updateResource)(apiData, levelId, activityQuestId, resourceId, resource);
  });

  var handleSaveUrlResource = function handleSaveUrlResource() {
    var resource = {
      name: resourceNameState,
      description: resourceDescription === null || resourceDescription.length === 0 ? null : resourceDescription,
      url: urlResource !== null ? urlResource : null,
      resource_type: selectedResourceType !== null && selectedResourceType.label !== 'App' ? selectedResourceType.label.toLowerCase() : 'game_app',
      new_resource: true
    };

    createMutationSaveUrlResource.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resourceId,
      resource: resource
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('resources-' + activityQuestId);
        setTimeout(function () {
          dispatch((0, _modal.hideModal)());
        }, 300);
      }
    });
  };

  var clearFileMutation = (0, _reactQuery.useMutation)(function (_ref4) {
    var apiData = _ref4.apiData,
        levelId = _ref4.levelId,
        activityQuestId = _ref4.activityQuestId,
        resourceId = _ref4.resourceId;
    return (0, _API.clearResourceFile)(apiData, levelId, activityQuestId, resourceId);
  });

  var handleClearFile = function handleClearFile() {
    clearFileMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resourceId,
      resource: resource
    }, {
      onSuccess: function onSuccess() {
        setOriginalFileName(null);
      }
    });
  };

  var couldSaveData = (urlResource !== null && urlResource.length !== 0 || originalFileName !== null) && selectedResourceType !== null;

  var resourceTypeOptions = [{ id: 1, name: 'Audio', label: 'Audio', sort_order: 0 }, { id: 2, name: 'Document', label: 'Document', sort_order: 1 }, { id: 3, name: 'App', label: 'App', sort_order: 2 }, { id: 4, name: 'Image', label: 'Image', sort_order: 3 }, { id: 5, name: 'Presentation', label: 'Presentation', sort_order: 4 }, { id: 6, name: 'Video', label: 'Video', sort_order: 5 }, { id: 7, name: 'Web', label: 'Web', sort_order: 6 }, { id: 8, name: 'Simulation', label: 'Simulation', sort_order: 7 }];

  var onUploadFileStart = function onUploadFileStart() {
    setIsUploadingFile(true);
  };

  var onUploadFileEnd = function onUploadFileEnd() {
    setIsUploadingFile(false);
  };

  var onUploadAbort = function onUploadAbort() {
    setIsUploadingFile(false);
  };

  var onUploadComplete = function onUploadComplete() {
    setIsUploadingFile(false);
  };

  var fileUploadMutation = (0, _reactQuery.useMutation)(function (_ref5) {
    var apiData = _ref5.apiData,
        levelId = _ref5.levelId,
        activityQuestId = _ref5.activityQuestId,
        resourceId = _ref5.resourceId,
        file = _ref5.file;
    return (0, _API.fileUploadToResource)(apiData, levelId, activityQuestId, resourceId, file);
  });

  var patchFileUploadInfo = function patchFileUploadInfo(uploadedFile) {
    var file = {
      resource_file: uploadedFile.name,
      original_file_name: uploadedFile.original_file_name,
      file_size: uploadedFile.size,
      content_type: uploadedFile.type,
      file_checksum: uploadedFile.file_checksum
    };

    setOriginalFileName(uploadedFile.original_file_name);

    fileUploadMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resourceId,
      file: file
    });
  };

  var resourceDescriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
  resourceDescriptionOptions.initialValue = resourceDescription;
  resourceDescriptionOptions.placeholder = 'Resource Description';
  resourceDescriptionOptions.autofocus = false;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      isLoading ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          HeaderContainer,
          null,
          _react2.default.createElement(
            _H2.default,
            null,
            '+ Add Resource'
          ),
          _react2.default.createElement(
            FlexContainer,
            { style: { marginBottom: '0px' } },
            _react2.default.createElement(
              _MarginRight2.default,
              null,
              _react2.default.createElement(_CancelButton2.default, {
                handleClick: closeTheModal,
                title: 'Cancel',
                width: '104px'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                'data-for': 'createCourseTooltip',
                'data-tip': 'Please enter all required fields prior to saving this resource.'
              },
              _react2.default.createElement(_Button2.default, {
                width: isUploadingFile ? '165px' : '104px',
                title: isUploadingFile ? 'Upload In Progress' : 'Save',
                handleClick: handleSaveUrlResource,
                buttonColor: _colors2.default.oeYellow,
                borderColor: _colors2.default.oeYellow,
                hoverBackground: _colors2.default.charcoal4,
                hoverColor: _colors2.default.white,
                couldSaveData: isLinkChecked ? (0, _activityedit.isValidLink)(urlResource) && couldSaveData : !isUploadingFile && couldSaveData,
                shouldShowTooltipAndDisableButton: true
              }),
              !couldSaveData && _react2.default.createElement(_reactTooltip2.default, {
                id: 'createCourseTooltip',
                place: 'bottom',
                effect: 'solid',
                className: 'activityCourseTooltip'
              })
            )
          )
        ),
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Resource Name',
            placeholder: 'Resource Name',
            handleEnteredTextValue: handleResourceName,
            value: resourceNameState,
            shouldDisplayAsteriskSymbol: true,
            shouldBeTextarea: false
          }),
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Resource Description',
            placeholder: 'Resource Description',
            handleEnteredTextValue: handleResourceDescription,
            value: resourceDescription,
            shouldDisplayAsteriskSymbol: false,
            shouldBeTextarea: true,
            options: resourceDescriptionOptions
          }),
          _react2.default.createElement(_SelectorComponent2.default, {
            placeholder: 'Resource Type',
            handleSelectedValueChange: handleSelectedResourceType,
            selectedValue: selectedResourceType,
            options: resourceTypeOptions,
            shouldDisplayAsterisk: true
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _InputLabel2.default,
              null,
              'Format'
            ),
            _react2.default.createElement(
              FlexContainer,
              null,
              _react2.default.createElement(
                'div',
                { style: { marginRight: '30px' } },
                _react2.default.createElement('input', {
                  type: 'radio',
                  id: 'Link',
                  name: 'Link',
                  value: 'Link',
                  style: { marginRight: '10px' },
                  checked: isLinkChecked,
                  onChange: function onChange() {
                    return handleIsLinkChecked(true);
                  }
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'Link' },
                  'Link'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                  type: 'radio',
                  id: 'File',
                  name: 'File',
                  value: 'File',
                  style: { marginRight: '10px' },
                  checked: !isLinkChecked,
                  onChange: function onChange() {
                    return handleIsLinkChecked(false);
                  }
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'File' },
                  'File'
                )
              )
            )
          ),
          isLinkChecked ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_TextInputComponent2.default, {
              title: 'URL',
              placeholder: 'URL',
              handleEnteredTextValue: handleUrlResource,
              value: urlResource,
              shouldDisplayAsteriskSymbol: true,
              shouldBeTextarea: false,
              isError: urlResource !== null && urlResource.length !== 0 && !(0, _activityedit.isValidLink)(urlResource),
              errorMessage: _messages.urlInvalid
            })
          ) : _react2.default.createElement(
            'div',
            { style: { marginBottom: '20px' } },
            _react2.default.createElement(
              _InputLabel2.default,
              { style: { marginTop: '0px' } },
              'Resource File',
              _react2.default.createElement(
                AsteriskSymbol,
                null,
                '*'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              originalFileName !== null ? _react2.default.createElement(
                FlexContainer,
                { style: { marginTop: '20px' } },
                _react2.default.createElement(_FileTypeIcon2.default, {
                  type: selectedResourceType === null ? 'document' : selectedResourceType.label !== 'App' ? selectedResourceType.label.toLowerCase() : 'game_app'
                }),
                _react2.default.createElement(
                  'div',
                  null,
                  originalFileName
                ),
                _react2.default.createElement(
                  'span',
                  {
                    style: {
                      marginLeft: '15px',
                      marginTop: '4px',
                      cursor: 'pointer'
                    },
                    onMouseEnter: function onMouseEnter() {
                      return setIsHovered(true);
                    },
                    onMouseLeave: function onMouseLeave() {
                      return setIsHovered(false);
                    },
                    onClick: handleClearFile
                  },
                  _react2.default.createElement(
                    'svg',
                    {
                      xmlns: 'http://www.w3.org/2000/svg',
                      width: '12',
                      height: '12',
                      viewBox: '0 0 25 24'
                    },
                    _react2.default.createElement(
                      'g',
                      {
                        fill: 'none',
                        fillRule: 'evenodd',
                        stroke: isHovered ? _colors2.default.crimsonLite : _colors2.default.dove,
                        strokeWidth: '3',
                        transform: 'translate(2 1)'
                      },
                      _react2.default.createElement('path', { d: 'M0 0L22 22M22 0L0 22' })
                    )
                  )
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_S3Uploader2.default, {
                  ref: S3UploaderRef,
                  presignedUrl: resource.presigned_url,
                  uniqueFilename: resource.unique_upload_file_name,
                  patchFileUploadInfo: patchFileUploadInfo,
                  resourceType: selectedResourceType !== null && selectedResourceType.label.toLowerCase(),
                  resourceId: resourceId,
                  uploadStartHandler: onUploadFileStart,
                  uploadEndHandler: onUploadFileEnd,
                  uploadAbortHandler: onUploadAbort,
                  uploadCompleteHandler: onUploadComplete,
                  isActivityCourse: true
                })
              )
            )
          )
        )
      )
    )
  );
};

AddResourceModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.string.isRequired,
  activityQuestId: _propTypes2.default.string.isRequired,
  resource: _propTypes2.default.object.isRequired,
  resourceId: _propTypes2.default.number.isRequired,
  resourceName: _propTypes2.default.string.isRequired
};

exports.default = (0, _withApiData2.default)(AddResourceModal);

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1327), __esModule: true };

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1328);
module.exports = __webpack_require__(43).Object.entries;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(70);
var $entries = __webpack_require__(549)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 28px;\n  width: 100%;\n  border-radius: 5px;\n  background-color: #cccccc;\n  overflow: hidden;\n  position: relative;\n'], ['\n  height: 28px;\n  width: 100%;\n  border-radius: 5px;\n  background-color: #cccccc;\n  overflow: hidden;\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: inherit;\n  width: ', '%;\n  background: repeating-linear-gradient(\n    50deg,\n    #5b7990,\n    #5b7990 24px,\n    #4e6c84 24px,\n    #4e6c84 46px\n  );\n  background-size: 60px 100%;\n  transition: width 0.3s ease;\n  animation: shift 2s linear infinite;\n\n  @keyframes shift {\n    to {\n      background-position: 60px 100%;\n    }\n  }\n'], ['\n  height: inherit;\n  width: ', '%;\n  background: repeating-linear-gradient(\n    50deg,\n    #5b7990,\n    #5b7990 24px,\n    #4e6c84 24px,\n    #4e6c84 46px\n  );\n  background-size: 60px 100%;\n  transition: width 0.3s ease;\n  animation: shift 2s linear infinite;\n\n  @keyframes shift {\n    to {\n      background-position: 60px 100%;\n    }\n  }\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 12px;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n'], ['\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 12px;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyBar = _styledComponents2.default.div.withConfig({
  displayName: 'FileUploadProgressBar__EmptyBar',
  componentId: 'sc-16x3zlm-0'
})(_templateObject);

var ProgressBar = _styledComponents2.default.div.withConfig({
  displayName: 'FileUploadProgressBar__ProgressBar',
  componentId: 'sc-16x3zlm-1'
})(_templateObject2, function (props) {
  return props.progress.length < 1 ? '1px' : props.progress;
});

var ProgressText = _styledComponents2.default.div.withConfig({
  displayName: 'FileUploadProgressBar__ProgressText',
  componentId: 'sc-16x3zlm-2'
})(_templateObject3);

var FileUploadProgressBar = function FileUploadProgressBar(_ref) {
  var progress = _ref.progress;
  return _react2.default.createElement(
    EmptyBar,
    null,
    _react2.default.createElement(
      ProgressText,
      null,
      'Uploading ',
      progress,
      '%'
    ),
    _react2.default.createElement(ProgressBar, { progress: progress })
  );
};

FileUploadProgressBar.propTypes = {
  progress: _propTypes2.default.number.isRequired
};

exports.default = FileUploadProgressBar;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

exports.gbInBytes = gbInBytes;
exports.validateFileSize = validateFileSize;
exports.getMD5Checksum = getMD5Checksum;

var _sparkMd = __webpack_require__(1331);

var _sparkMd2 = _interopRequireDefault(_sparkMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function gbInBytes(gb) {
  return gb * 1024 * 1024 * 1024;
}

function validateFileSize(file, limit) {
  return file.size <= limit;
}

function getMD5Checksum(file) {
  return new _promise2.default(function (resolve, reject) {
    var chunkSize = 2097152; // 2MiB
    var nChunks = Math.ceil(file.size / chunkSize);
    var chunkIndex = 0;

    var spark = new _sparkMd2.default.ArrayBuffer();
    var reader = new FileReader();

    var readNextChunk = function readNextChunk() {
      var start = chunkIndex * chunkSize;
      var end = Math.min(file.size, start + chunkSize);
      var blob = file.slice(start, end);
      reader.readAsArrayBuffer(blob);
      chunkIndex++;
    };

    reader.onload = function (e) {
      spark.append(e.target.result);

      if (chunkIndex < nChunks) {
        readNextChunk();
      } else {
        resolve(spark.end());
      }
    };

    reader.onerror = function (e) {
      return reject(e);
    };

    readNextChunk();
  });
}

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
    if (true) {
        // Node/CommonJS
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define(factory);
    } else {
        // Browser globals (with support for web workers)
        var glob;

        try {
            glob = window;
        } catch (e) {
            glob = self;
        }

        glob.SparkMD5 = factory();
    }
}(function (undefined) {

    'use strict';

    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */

    /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */
    var add32 = function (a, b) {
        return (a + b) & 0xFFFFFFFF;
    },
        hex_chr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];


    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
    }

    function md5cycle(x, k) {
        var a = x[0],
            b = x[1],
            c = x[2],
            d = x[3];

        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;

        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;

        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;

        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b  = (b << 21 | b >>> 11) + c | 0;

        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }

    function md5blk(s) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    }

    function md5blk_array(a) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        }
        return md5blks;
    }

    function md51(s) {
        var n = s.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        length = s.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        }
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);
        return state;
    }

    function md51_array(a) {
        var n = a.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        }

        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = (i - 64) < n ? a.subarray(i - 64) : new Uint8Array(0);

        length = a.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= a[i] << ((i % 4) << 3);
        }

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);

        return state;
    }

    function rhex(n) {
        var s = '',
            j;
        for (j = 0; j < 4; j += 1) {
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
        }
        return s;
    }

    function hex(x) {
        var i;
        for (i = 0; i < x.length; i += 1) {
            x[i] = rhex(x[i]);
        }
        return x.join('');
    }

    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') {
        add32 = function (x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        };
    }

    // ---------------------------------------------------

    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */

    if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) {
        (function () {
            function clamp(val, length) {
                val = (val | 0) || 0;

                if (val < 0) {
                    return Math.max(val + length, 0);
                }

                return Math.min(val, length);
            }

            ArrayBuffer.prototype.slice = function (from, to) {
                var length = this.byteLength,
                    begin = clamp(from, length),
                    end = length,
                    num,
                    target,
                    targetArray,
                    sourceArray;

                if (to !== undefined) {
                    end = clamp(to, length);
                }

                if (begin > end) {
                    return new ArrayBuffer(0);
                }

                num = end - begin;
                target = new ArrayBuffer(num);
                targetArray = new Uint8Array(target);

                sourceArray = new Uint8Array(this, begin, num);
                targetArray.set(sourceArray);

                return target;
            };
        })();
    }

    // ---------------------------------------------------

    /**
     * Helpers.
     */

    function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) {
            str = unescape(encodeURIComponent(str));
        }

        return str;
    }

    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length,
           buff = new ArrayBuffer(length),
           arr = new Uint8Array(buff),
           i;

        for (i = 0; i < length; i += 1) {
            arr[i] = str.charCodeAt(i);
        }

        return returnUInt8Array ? arr : buff;
    }

    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }

    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);

        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);

        return returnUInt8Array ? result : result.buffer;
    }

    function hexToBinaryString(hex) {
        var bytes = [],
            length = hex.length,
            x;

        for (x = 0; x < length - 1; x += 2) {
            bytes.push(parseInt(hex.substr(x, 2), 16));
        }

        return String.fromCharCode.apply(String, bytes);
    }

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */

    function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }

    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.append = function (str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));

        return this;
    };

    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.appendBinary = function (contents) {
        this._buff += contents;
        this._length += contents.length;

        var length = this._buff.length,
            i;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        }

        this._buff = this._buff.substring(i - 64);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            i,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff.charCodeAt(i) << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = hex(this._hash);

        if (raw) {
            ret = hexToBinaryString(ret);
        }

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.reset = function () {
        this._buff = '';
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.prototype.getState = function () {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.setState = function (state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;

        return this;
    };

    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */
    SparkMD5.prototype.destroy = function () {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };

    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */
    SparkMD5.prototype._finish = function (tail, length) {
        var i = length,
            tmp,
            lo,
            hi;

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };

    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.hash = function (str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };

    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.hashBinary = function (content, raw) {
        var hash = md51(content),
            ret = hex(hash);

        return raw ? hexToBinaryString(ret) : ret;
    };

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */
    SparkMD5.ArrayBuffer = function () {
        // call reset to init the instance
        this.reset();
    };

    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.append = function (arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
            length = buff.length,
            i;

        this._length += arr.byteLength;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        }

        this._buff = (i - 64) < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.ArrayBuffer.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            i,
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff[i] << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = hex(this._hash);

        if (raw) {
            ret = hexToBinaryString(ret);
        }

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.reset = function () {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.ArrayBuffer.prototype.getState = function () {
        var state = SparkMD5.prototype.getState.call(this);

        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);

        return state;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.setState = function (state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);

        return SparkMD5.prototype.setState.call(this, state);
    };

    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;

    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;

    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */
    SparkMD5.ArrayBuffer.hash = function (arr, raw) {
        var hash = md51_array(new Uint8Array(arr)),
            ret = hex(hash);

        return raw ? hexToBinaryString(ret) : ret;
    };

    return SparkMD5;
}));


/***/ }),
/* 1332 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS45IDI5LjAxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y1YmUxNzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljb24tYXVkaW8teV88L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTguMTgsMjcuNzNBMS4yOCwxLjI4LDAsMCwwLDE5LjQ1LDI5YTEuMzEsMS4zMSwwLDAsMCwuNDItLjA3LDE0LjQxLDE0LjQxLDAsMCwwLDYuNjctNC43OSwxNC44NywxNC44NywwLDAsMCwzLjM2LTkuNjQsMTQuODcsMTQuODcsMCwwLDAtMy4zNi05LjY0QTE0LjQ1LDE0LjQ1LDAsMCwwLDE5Ljg4LjA3YTEuMjgsMS4yOCwwLDAsMC0xLjcsMS4yMXYuNjRBMS4yOCwxLjI4LDAsMCwwLDE5LDMuMTFhMTIuMDgsMTIuMDgsMCwwLDEsNy43NCwxMS40QTEyLjA3LDEyLjA3LDAsMCwxLDE5LDI1LjlhMS4yOCwxLjI4LDAsMCwwLS44MiwxLjE5WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjQ1LDE5Ljk0YTEuMjcsMS4yNywwLDAsMCwuOTUtLjQyLDcuMTQsNy4xNCwwLDAsMCwxLjc0LTUsNy4xNyw3LjE3LDAsMCwwLTEuNzQtNSwxLjI4LDEuMjgsMCwwLDAtMi4yMy44NXY4LjMxQTEuMjcsMS4yNywwLDAsMCwxOSwxOS44NSwxLjI1LDEuMjUsMCwwLDAsMTkuNDUsMTkuOTRaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTEuOTMsNC4yOSw2LjExLDEwLjExSDFhMSwxLDAsMCwwLTEsMXY2Ljg4YTEsMSwwLDAsMCwxLDFINi4xMWw1LjgxLDUuODFhMSwxLDAsMCwwLC42OC4yOC45NC45NCwwLDAsMCwuMzctLjA3LDEsMSwwLDAsMCwuNTktLjg5VjVBMSwxLDAsMCwwLDEzLDQuMDksMSwxLDAsMCwwLDExLjkzLDQuMjlaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS42MyAzMi44MyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLWRvY3VtZW50LXlfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3Ljc0LDBINi4xMkE1Ljk0LDUuOTQsMCwwLDAsMS44NSwxLjc5LDUuOTIsNS45MiwwLDAsMCwuMDcsNkwwLDI2Ljc5YTUuODcsNS44NywwLDAsMCwxLjg2LDQuMzEsNiw2LDAsMCwwLDQuMjUsMS43NGgxNy40YTYsNiwwLDAsMCw0LjI1LTEuNzQsNS44Niw1Ljg2LDAsMCwwLDEuODYtNC4zMVYxMS44OWEzLjE5LDMuMTksMCwwLDAtLjk0LTIuMjZMMjAsLjk0QTMuMTksMy4xOSwwLDAsMCwxNy43NCwwWm04LDEyLjg0YTEuNiwxLjYsMCwwLDEtMS40NywxaC03YTEuNiwxLjYsMCwwLDEtMS42LTEuNnYtN2ExLjYsMS42LDAsMCwxLDIuNzItMS4xM2w3LDdBMS42LDEuNiwwLDAsMSwyNS42OSwxMi44NFoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS43NyAzMS43NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLWFwcC15XzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik04LjA5LDMxLjc3SDIzLjY4YTguMTEsOC4xMSwwLDAsMCw4LjA5LTguMDlWOC4wOUE4LjExLDguMTEsMCwwLDAsMjMuNjgsMEg4LjA5QTguMTEsOC4xMSwwLDAsMCwwLDguMDlWMjMuNjhBOC4xMSw4LjExLDAsMCwwLDguMDksMzEuNzdaTTUsMTIuNjZBMS4zLDEuMywwLDAsMSw2LDExLjc3bDYtLjg3LDIuNjktNS40NWExLjMsMS4zLDAsMCwxLDIuMzMsMGwyLjY5LDUuNDUsNiwuODdBMS4zLDEuMywwLDAsMSwyNi40NywxNGwtNC4zNSw0LjI0LDEsNmExLjMsMS4zLDAsMCwxLTEuODksMS4zN2wtNS4zNy0yLjgyLTUuMzcsMi44MmExLjI5LDEuMjksMCwwLDEtLjYxLjE1LDEuMzIsMS4zMiwwLDAsMS0uNzctLjI1LDEuMzEsMS4zMSwwLDAsMS0uNTItMS4yOGwxLTZMNS4zLDE0QTEuMzEsMS4zMSwwLDAsMSw1LDEyLjY2WiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC42OCAyNy42MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLWltYWdlLXlfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMjAuMTMiIGN5PSI4LjEiIHI9IjIuMjgiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yNy4wOCwwSDEuNkExLjYsMS42LDAsMCwwLDAsMS42VjI2YTEuNiwxLjYsMCwwLDAsMS42LDEuNkgyNy4wOGExLjYsMS42LDAsMCwwLDEuNi0xLjZWMS42QTEuNiwxLjYsMCwwLDAsMjcuMDgsMFpNMjUuOTQsMi43NlYyMi40MmwtLjQ3LS43NmMtLjctMS4xNi0xLjM3LTIuMjUtMi4xNy0zLjM0YTEsMSwwLDAsMC0uNjQtLjM5LDEsMSwwLDAsMC0uNzIuMTlsLTMuODQsM0w5Ljg2LDExLjE3QTEsMSwwLDAsMCw5LDEwLjgzYTEsMSwwLDAsMC0uNzUuNTNMMi43NCwyMi41NFYyLjc2WiIvPjwvZz48L2c+PC9zdmc+"

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNS4yNiAzMS4wOCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLXByZXNlbnRhdGlvbi15XzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zMi40OCwwSDIuNzhBMi43OCwyLjc4LDAsMCwwLDAsMi43OFYyOC4zYTIuNzgsMi43OCwwLDAsMCwyLjc4LDIuNzhIMzIuNDhhMi43OCwyLjc4LDAsMCwwLDIuNzgtMi43OFYyLjc4QTIuNzgsMi43OCwwLDAsMCwzMi40OCwwWm0uMjIsMjguM2EuMjIuMjIsMCwwLDEtLjIyLjIySDIuNzhhLjIyLjIyLDAsMCwxLS4yMi0uMjJWNi41NUgzMi43WiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjQ3LDEyLjk1SDI4LjJhMSwxLDAsMCwxLDAsMS45MUgyMy40N2ExLDEsMCwwLDEsMC0xLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjQ3LDE2LjU4SDI4LjJhMSwxLDAsMSwxLDAsMS45MUgyMy40N2ExLDEsMCwwLDEsMC0xLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjQ3LDIwLjIxSDI4LjJhMSwxLDAsMSwxLDAsMS45MUgyMy40N2ExLDEsMCwxLDEsMC0xLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjQ3LDE0Ljg2SDI4LjJhMSwxLDAsMCwwLDAtMS45MUgyMy40N2ExLDEsMCwwLDAsMCwxLjkxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjQ3LDE4LjVIMjguMmExLDEsMCwxLDAsMC0xLjkxSDIzLjQ3YTEsMSwwLDAsMCwwLDEuOTFaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjMuNDcsMjIuMTNIMjguMmExLDEsMCwxLDAsMC0xLjkxSDIzLjQ3YTEsMSwwLDEsMCwwLDEuOTFaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMzgsMjQuODJBNy4yOCw3LjI4LDAsMSwwLDYuMSwxNy41NCw3LjI4LDcuMjgsMCwwLDAsMTMuMzgsMjQuODJabTAtMTIuOUE1LjYyLDUuNjIsMCwwLDEsMTksMTcuNTRIMTMuMzhaIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS43NyAyOC41NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLXZpZGVvLXlfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTIzLjY4LDBIOC4wOUE4LjExLDguMTEsMCwwLDAsMCw4LjA5djEyLjRhOC4xMSw4LjExLDAsMCwwLDguMDksOC4wOUgyMy42OGE4LjExLDguMTEsMCwwLDAsOC4wOS04LjA5VjguMDlBOC4xMSw4LjExLDAsMCwwLDIzLjY4LDBabS0uMjMsMTUuNjYtMTAuNyw2LjE1QTEuNTksMS41OSwwLDAsMSwxMiwyMmExLjU5LDEuNTksMCwwLDEtMS41OC0xLjU4VjguMTRhMS41OCwxLjU4LDAsMCwxLDIuMzctMS4zN2wxMC43LDYuMTVhMS41OCwxLjU4LDAsMCwxLDAsMi43NFoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMC40OSAyOS40MSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmNWJlMTc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5pY29uLXdlYi15XzwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xLDI5LjQxSDIyLjExYTEsMSwwLDAsMCwxLTFWMTguNDloNi4zMWExLDEsMCwwLDAsMS0xVjFhMSwxLDAsMCwwLTEtMUg4LjkzYTEsMSwwLDAsMC0xLDF2OS41OUgxYTEsMSwwLDAsMC0xLDFWMjguMzhBMSwxLDAsMCwwLDEsMjkuNDFabTkuNDEtMjQuM0gyNy45M1YxNkgyMy4xNFYxMS43OEExLjE0LDEuMTQsMCwwLDAsMjIsMTAuNjRIMTAuNDRaTTIuNTgsMTUuNzVIMjAuNTFWMjcuMjRIMi41OFoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMi4yIDMyLjIiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZjViZTE3O308L3N0eWxlPjwvZGVmcz48dGl0bGU+aWNvbi1zaW11bGF0aW9uLXlfPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE5LjEsMjMuMjJoLTZhMS42LDEuNiwwLDAsMC0xLjQzLDEuMTIsMi40NywyLjQ3LDAsMCwwLC4xNiwyLjEybDMsNC45NWExLjQyLDEuNDIsMCwwLDAsMi41NCwwbDMtNC45NWEyLjQ3LDIuNDcsMCwwLDAsLjE2LTIuMTJBMS42LDEuNiwwLDAsMCwxOS4xLDIzLjIyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE3LjM3Ljc5YTEuNDIsMS40MiwwLDAsMC0yLjU0LDBsLTMsNC45NWEyLjQ3LDIuNDcsMCwwLDAtLjE2LDIuMTJBMS42LDEuNiwwLDAsMCwxMy4xLDloNmExLjYsMS42LDAsMCwwLDEuNDMtMS4xMiwyLjQ3LDIuNDcsMCwwLDAtLjE2LTIuMTJaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNy44NiwxMS42N2EyLjQ3LDIuNDcsMCwwLDAtMi4xMi4xNmwtNC45NSwzYTEuNDIsMS40MiwwLDAsMCwwLDIuNTRsNC45NSwzYTIuNDcsMi40NywwLDAsMCwyLjEyLjE2QTEuNiwxLjYsMCwwLDAsOSwxOS4xdi02QTEuNiwxLjYsMCwwLDAsNy44NiwxMS42N1oiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zMS40MSwxNC44M2wtNC45NS0zYTIuNDcsMi40NywwLDAsMC0yLjEyLS4xNiwxLjYsMS42LDAsMCwwLTEuMTIsMS40M3Y2YTEuNiwxLjYsMCwwLDAsMS4xMiwxLjQzLDIuNDcsMi40NywwLDAsMCwyLjEyLS4xNmw0Ljk1LTNhMS40MiwxLjQyLDAsMCwwLDAtMi41NFoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjE2LjEiIGN5PSIxNi4xIiByPSI0LjQ5Ii8+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 75px auto;\n'], ['\n  width: 660px;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background-color: ', ';\n  margin: 75px auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0px;\n'], ['\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 30px 30px;\n'], ['\n  padding: 0 30px 30px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  color: ', ';\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  overflow: hidden;\n'], ['\n  width: 100%;\n  color: ', ';\n  font-size: 16px;\n  letter-spacing: 0;\n  line-height: 20px;\n  overflow: hidden;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _API = __webpack_require__(99);

var _SelectorComponent = __webpack_require__(245);

var _SelectorComponent2 = _interopRequireDefault(_SelectorComponent);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _icon_edit_course = __webpack_require__(312);

var _icon_edit_course2 = _interopRequireDefault(_icon_edit_course);

var _markdowneditor = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resourceTypeOptions = [{ id: 1, name: 'Audio', label: 'Audio', sort_order: 0 }, { id: 2, name: 'Document', label: 'Document', sort_order: 1 }, { id: 3, name: 'App', label: 'game_app', sort_order: 2 }, { id: 4, name: 'Image', label: 'Image', sort_order: 3 }, { id: 5, name: 'Presentation', label: 'Presentation', sort_order: 4 }, { id: 6, name: 'Video', label: 'Video', sort_order: 5 }, { id: 7, name: 'Web', label: 'Web', sort_order: 6 }, { id: 8, name: 'Simulation', label: 'Simulation', sort_order: 7 }];

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditResourceModal__ModalContainer',
  componentId: 'sc-6gioj3-0'
})(_templateObject, _colors2.default.smoke);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditResourceModal__FlexContainer',
  componentId: 'sc-6gioj3-1'
})(_templateObject2);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditResourceModal__HeaderContainer',
  componentId: 'sc-6gioj3-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditResourceModal__MainContainer',
  componentId: 'sc-6gioj3-3'
})(_templateObject4);

var Text = _styledComponents2.default.p.withConfig({
  displayName: 'EditResourceModal__Text',
  componentId: 'sc-6gioj3-4'
})(_templateObject5, _colors2.default.victoria);

var AddResourceModal = function AddResourceModal(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      resourceId = _ref.resourceId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useQuery = (0, _reactQuery.useQuery)(['resource-' + resourceId], function () {
    return (0, _API.fetchResource)(apiData, levelId, activityQuestId, resourceId);
  }, {
    refetchOnWindowFocus: false
  }),
      isResourceLoading = _useQuery.isLoading,
      resource = _useQuery.data;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      resourceName = _useState2[0],
      setResourceName = _useState2[1];

  var handleResourceName = function handleResourceName(e) {
    setResourceName(e.target.value);
  };

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      resourceDescription = _useState4[0],
      setResourceDescription = _useState4[1];

  var handleResourceDescription = function handleResourceDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'resource-description';
    event.target.value = e;
    if (event.target.value.length === 0) {
      setResourceDescription(null);
    } else {
      setResourceDescription(event.target.value);
    }
  };

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      selectedResourceType = _useState6[0],
      setSelectedResourceType = _useState6[1];

  var handleSelectedResourceType = function handleSelectedResourceType(e) {
    setSelectedResourceType(e);
  };

  (0, _react.useEffect)(function () {
    if (resource !== undefined) {
      setResourceName(resource.name);
      setResourceDescription(resource.description === null ? null : resource.description);
      setSelectedResourceType(resource.resource_type !== null && resourceTypeOptions.find(function (option) {
        return option.label.toLowerCase() === resource.resource_type;
      }));
    }
  }, [resource]);

  var closeTheModal = function closeTheModal() {
    dispatch((0, _modal.hideModal)());
  };

  var createMutationUpdateResource = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        resourceId = _ref2.resourceId,
        resource = _ref2.resource;
    return (0, _API.updateResource)(apiData, levelId, activityQuestId, resourceId, resource);
  });

  var handleUpdateResource = function handleUpdateResource() {
    var resource = {
      name: resourceName,
      description: resourceDescription,
      resource_type: selectedResourceType.label !== 'App' ? selectedResourceType.label.toLowerCase() : 'game_app'
    };
    createMutationUpdateResource.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resourceId,
      resource: resource
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('resources-' + activityQuestId);
        setTimeout(function () {
          dispatch((0, _modal.hideModal)());
        }, 300);
      }
    });
  };

  var resourceDescriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
  resourceDescriptionOptions.initialValue = resourceDescription;
  resourceDescriptionOptions.placeholder = 'Resource Description';
  resourceDescriptionOptions.autofocus = false;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      isResourceLoading ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          HeaderContainer,
          null,
          _react2.default.createElement(
            _H2.default,
            null,
            _react2.default.createElement(
              'span',
              { style: { marginRight: '12px' } },
              _react2.default.createElement('img', { src: _icon_edit_course2.default })
            ),
            'Edit Resource'
          ),
          _react2.default.createElement(
            FlexContainer,
            null,
            _react2.default.createElement(
              _MarginRight2.default,
              null,
              _react2.default.createElement(_CancelButton2.default, {
                handleClick: closeTheModal,
                title: 'Cancel',
                width: '104px'
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_Button2.default, {
                width: '104px',
                title: 'Save',
                handleClick: handleUpdateResource,
                buttonColor: _colors2.default.oeYellow,
                borderColor: _colors2.default.oeYellow,
                hoverBackground: _colors2.default.charcoal4,
                hoverColor: _colors2.default.white,
                shouldShowTooltipAndDisableButton: false
              })
            )
          )
        ),
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Resource Name',
            placeholder: 'Resource Name',
            handleEnteredTextValue: handleResourceName,
            value: resourceName,
            shouldDisplayAsteriskSymbol: true,
            shouldBeTextarea: false
          }),
          _react2.default.createElement(_TextInputComponent2.default, {
            title: 'Resource Description',
            placeholder: 'Resource Description',
            handleEnteredTextValue: handleResourceDescription,
            value: resourceDescription,
            shouldDisplayAsteriskSymbol: false,
            shouldBeTextarea: true,
            options: resourceDescriptionOptions
          }),
          _react2.default.createElement(_SelectorComponent2.default, {
            placeholder: 'Resource Type',
            handleSelectedValueChange: handleSelectedResourceType,
            selectedValue: selectedResourceType,
            options: resourceTypeOptions,
            shouldDisplayAsterisk: true
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _InputLabel2.default,
              null,
              'Format'
            ),
            _react2.default.createElement(
              Text,
              null,
              resource !== undefined && resource.file_name === null ? 'Link' : 'File'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _InputLabel2.default,
              null,
              resource !== undefined && resource.file_name !== null ? 'Resource File' : 'URL'
            ),
            _react2.default.createElement(
              Text,
              null,
              resource !== undefined && resource.file_name !== null ? resource.file_name : resource.url
            )
          )
        )
      )
    )
  );
};

AddResourceModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.string.isRequired,
  activityQuestId: _propTypes2.default.string.isRequired,
  activity: _propTypes2.default.object.isRequired
};

exports.default = (0, _withApiData2.default)(AddResourceModal);

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n'], ['\n  width: 519px;\n  height: auto;\n  border-radius: 10px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  padding-top: 40px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 13px;\n'], ['\n  padding: 0 23px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-bottom: 13px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 35px;\n  width: 29px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 35px;\n  width: 29px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding-bottom: 43px;\n  border-bottom: 1px solid ', ';\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  text-align: center;\n'], ['\n  padding-bottom: 43px;\n  border-bottom: 1px solid ', ';\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  text-align: center;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  color: ', ';\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 12px;\n'], ['\n  width: 419px;\n  color: ', ';\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n  margin: 0 auto;\n  padding-bottom: 12px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid ', ';\n'], ['\n  border-top: 1px solid ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon_delete_redhover = __webpack_require__(630);

var _icon_delete_redhover2 = _interopRequireDefault(_icon_delete_redhover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'DeleteResourceModal__ModalContainer',
  componentId: 'sc-1h7reeq-0'
})(_templateObject, _colors2.default.white);

var Header = _styledComponents2.default.div.withConfig({
  displayName: 'DeleteResourceModal__Header',
  componentId: 'sc-1h7reeq-1'
})(_templateObject2);

var DeleteIcon = _styledComponents2.default.div.withConfig({
  displayName: 'DeleteResourceModal__DeleteIcon',
  componentId: 'sc-1h7reeq-2'
})(_templateObject3, _icon_delete_redhover2.default);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'DeleteResourceModal__MainContainer',
  componentId: 'sc-1h7reeq-3'
})(_templateObject4, _colors2.default.ash, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'DeleteResourceModal__DescriptionText',
  componentId: 'sc-1h7reeq-4'
})(_templateObject5, _colors2.default.black);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'DeleteResourceModal__ButtonBlock',
  componentId: 'sc-1h7reeq-5'
})(_templateObject6, _colors2.default.rock);

var DeleteResourceModal = function DeleteResourceModal(_ref) {
  var handleDeleteResource = _ref.handleDeleteResource;

  var dispatch = (0, _reactRedux.useDispatch)();

  var handleDelete = function handleDelete() {
    handleDeleteResource();

    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      { closeCallback: closeTheModal },
      _react2.default.createElement(
        Header,
        null,
        _react2.default.createElement(DeleteIcon, null)
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(
          DescriptionText,
          null,
          'Are you sure you want to delete this resource?'
        ),
        _react2.default.createElement(
          'p',
          { className: 'p2', style: { marginBottom: '0' } },
          'Once deleted, this cannot be undone.'
        )
      ),
      _react2.default.createElement(
        ButtonBlock,
        null,
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '46%', padding: '23px 23px 30px 0', display: 'flex' } },
          _react2.default.createElement(
            'span',
            { style: { marginRight: '20px' } },
            _react2.default.createElement(_Button2.default, {
              buttonColor: _colors2.default.white,
              width: '104px',
              borderColor: _colors2.default.white,
              title: 'Cancel',
              handleClick: closeTheModal,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white
            })
          ),
          _react2.default.createElement(_Button2.default, {
            buttonColor: _colors2.default.white,
            width: '129px',
            borderColor: '#D23A3D',
            title: 'Delete',
            handleClick: handleDelete,
            hoverBackground: '#D23A3D',
            hoverColor: _colors2.default.white
          })
        )
      )
    )
  );
};

DeleteResourceModal.propTypes = {
  handleDeleteResource: _propTypes2.default.func.isRequired
};

exports.default = DeleteResourceModal;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: 167px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n'], ['\n  width: 519px;\n  height: 167px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n'], ['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  margin: 0 auto;\n  padding: 30px 0;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n'], ['\n  width: 419px;\n  margin: 0 auto;\n  padding: 30px 0;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #eeeeee;\n'], ['\n  border-top: 1px solid #eeeeee;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _LoadingSpinner = __webpack_require__(631);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _API = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PublishActivityModal__ModalContainer',
  componentId: 'i5b1su-0'
})(_templateObject, _colors2.default.white);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PublishActivityModal__MainContainer',
  componentId: 'i5b1su-1'
})(_templateObject2, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'PublishActivityModal__DescriptionText',
  componentId: 'i5b1su-2'
})(_templateObject3);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'PublishActivityModal__ButtonBlock',
  componentId: 'i5b1su-3'
})(_templateObject4);

var PublishActivityModal = function PublishActivityModal(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      onPublish = _ref.onPublish;

  var dispatch = (0, _reactRedux.useDispatch)();
  var orgId = (0, _reactRedux.useSelector)(function (state) {
    return state.organization.orgId;
  });
  var userId = (0, _reactRedux.useSelector)(function (state) {
    return state.user.user.id;
  });
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isPublishKickedOff = _useState2[0],
      setIsPublishKickedOff = _useState2[1];

  var publishActivityMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId;
    return (0, _API.publishActivity)(apiData, levelId, activityQuestId);
  });

  var onPublishActivityClick = function onPublishActivityClick() {
    publishActivityMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId
    }, {
      onSuccess: function onSuccess() {
        setIsPublishKickedOff(true);
      }
    });
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  (0, _react.useEffect)(function () {
    var publishChannel = window.oeQwPusherInstance.subscribe('questmaker.organizations.' + orgId + '.users');

    publishChannel.bind('activity_quest_publishing_completed', function (data) {
      if (data.user_ids.includes(userId)) {
        queryClient.setQueryData(['activity-' + activityQuestId], function (a) {
          return (0, _assign2.default)({}, a, {
            in_draft: false,
            last_published_at: data.quest.last_published_at
          });
        });

        setTimeout(function () {
          onPublish();
          dispatch((0, _modal.hideModal)());
        }, 300);
      }
    });

    return function () {
      publishChannel.unbind('activity_quest_publishing_completed');
    };
  }, []);

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      !isPublishKickedOff ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(
            DescriptionText,
            null,
            'Ready to publish this activity?'
          )
        ),
        _react2.default.createElement(
          ButtonBlock,
          null,
          _react2.default.createElement(
            _FlexAlignCenter2.default,
            {
              style: {
                justifyContent: 'flex-end',
                padding: '18px 15px 23px 0'
              }
            },
            _react2.default.createElement(_Button2.default, {
              buttonColor: _colors2.default.white,
              width: '95px',
              borderColor: _colors2.default.aluminum,
              title: 'Cancel',
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: closeTheModal
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '17px' } },
              '\xA0'
            ),
            _react2.default.createElement(_Button2.default, {
              width: '157x',
              title: 'Publish Activity',
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: onPublishActivityClick
            })
          )
        )
      ) : _react2.default.createElement(
        _FlexAlignCenter2.default,
        {
          style: {
            height: '100%',
            justifyContent: 'center',
            padding: '0 130px'
          }
        },
        _react2.default.createElement(_LoadingSpinner2.default, null),
        _react2.default.createElement(
          _H2.default,
          { style: { marginLeft: '15px' } },
          'Publishing activity...'
        )
      )
    )
  );
};

PublishActivityModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.number.isRequired,
  activityQuestId: _propTypes2.default.number.isRequired,
  onPublish: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(PublishActivityModal);

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n'], ['\n  width: 519px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 10px 0 0;\n  text-align: center;\n'], ['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 10px 0 0;\n  text-align: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  margin: 0 auto;\n  padding: 15px 0;\n  text-align: center;\n'], ['\n  width: 419px;\n  margin: 0 auto;\n  padding: 15px 0;\n  text-align: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #eeeeee;\n'], ['\n  border-top: 1px solid #eeeeee;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _API = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditPublishedActivityModal__ModalContainer',
  componentId: 'sc-1vlia9e-0'
})(_templateObject, _colors2.default.white);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'EditPublishedActivityModal__MainContainer',
  componentId: 'sc-1vlia9e-1'
})(_templateObject2, _colors2.default.white);

var DescriptionText = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'EditPublishedActivityModal__DescriptionText',
  componentId: 'sc-1vlia9e-2'
})(_templateObject3);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'EditPublishedActivityModal__ButtonBlock',
  componentId: 'sc-1vlia9e-3'
})(_templateObject4);

var EditPublishedActivityModal = function EditPublishedActivityModal(_ref) {
  var apiData = _ref.apiData,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId,
      onReturnToDraft = _ref.onReturnToDraft;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var editActivityMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId;
    return (0, _API.returnPublishedActivityToDraft)(apiData, levelId, activityQuestId);
  });

  var onEditActivityClick = function onEditActivityClick() {
    editActivityMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId
    }, {
      onSuccess: function onSuccess(_ref3) {
        var in_draft = _ref3.in_draft,
            last_published_at = _ref3.last_published_at;

        setTimeout(function () {
          dispatch((0, _modal.hideModal)());
          queryClient.setQueryData(['activity-' + activityQuestId], function (a) {
            return (0, _assign2.default)({}, a, {
              in_draft: in_draft,
              last_published_at: last_published_at
            });
          });
          onReturnToDraft();
        }, 300);
      }
    });
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(
            DescriptionText,
            null,
            'This activity is published.'
          )
        ),
        _react2.default.createElement(
          _P2.default,
          { style: {
              color: '#444444',
              textAlign: 'center',
              padding: '15px 25px 30px 25px'
            } },
          'To edit this activity, a new draft version will be created for you to work on. The published version will remain available to students until the new version is published.',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          'A student will not see the new version if they have already began this activity prior to the new version being published.'
        ),
        _react2.default.createElement(
          ButtonBlock,
          null,
          _react2.default.createElement(
            _FlexAlignCenter2.default,
            {
              style: {
                justifyContent: 'flex-end',
                padding: '18px 15px 23px 0'
              }
            },
            _react2.default.createElement(_Button2.default, {
              buttonColor: _colors2.default.white,
              width: '95px',
              borderColor: _colors2.default.aluminum,
              title: 'Cancel',
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: closeTheModal
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '17px' } },
              '\xA0'
            ),
            _react2.default.createElement(_Button2.default, {
              width: '157x',
              title: 'Edit Activity',
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: onEditActivityClick
            })
          )
        )
      )
    )
  );
};

EditPublishedActivityModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.number.isRequired,
  activityQuestId: _propTypes2.default.number.isRequired,
  onReturnToDraft: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(EditPublishedActivityModal);

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 519px;\n  height: 235px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n'], ['\n  width: 519px;\n  height: 235px;\n  border-radius: 8px;\n  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);\n  background: ', ';\n  margin: 180px auto;\n  overflow: hidden;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n'], ['\n  display: flex;\n  align-items: center;\n  align-content: center;\n  background-color: ', ';\n  border: none;\n  margin: 0 auto;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 419px;\n  margin: 0 auto;\n  padding: 30px 0;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n'], ['\n  width: 419px;\n  margin: 0 auto;\n  padding: 30px 0;\n  color: #000000;\n  font-family: Roboto;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #eeeeee;\n'], ['\n  border-top: 1px solid #eeeeee;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _LoadingSpinner = __webpack_require__(631);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _API = __webpack_require__(98);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PublishJourneyModal__ModalContainer',
  componentId: 'sc-1g03aho-0'
})(_templateObject, _colors2.default.white);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PublishJourneyModal__MainContainer',
  componentId: 'sc-1g03aho-1'
})(_templateObject2, _colors2.default.white);

var DescriptionText = _styledComponents2.default.h3.withConfig({
  displayName: 'PublishJourneyModal__DescriptionText',
  componentId: 'sc-1g03aho-2'
})(_templateObject3);

var ButtonBlock = _styledComponents2.default.div.withConfig({
  displayName: 'PublishJourneyModal__ButtonBlock',
  componentId: 'sc-1g03aho-3'
})(_templateObject4);

var PublishJourneyModal = function PublishJourneyModal(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var orgId = (0, _reactRedux.useSelector)(function (state) {
    return state.organization.orgId;
  });
  var userId = (0, _reactRedux.useSelector)(function (state) {
    return state.user.user.id;
  });
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isPublishKickedOff = _useState2[0],
      setIsPublishKickedOff = _useState2[1];

  var publishJourneyMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        activityCourseId = _ref2.activityCourseId,
        journeyId = _ref2.journeyId;
    return (0, _API.publishJourney)(apiData, activityCourseId, journeyId);
  });

  var onPublishJourneyClick = function onPublishJourneyClick() {
    publishJourneyMutation.mutate({
      apiData: apiData,
      activityCourseId: activityCourseId,
      journeyId: journeyId
    }, {
      onSuccess: function onSuccess() {
        setIsPublishKickedOff(true);
      }
    });
  };

  var closeTheModal = function closeTheModal() {
    setTimeout(function () {
      dispatch((0, _modal.hideModal)());
    }, 300);
  };

  (0, _react.useEffect)(function () {
    var publishChannel = window.oeQwPusherInstance.subscribe('questmaker.organizations.' + orgId + '.users');

    publishChannel.bind('mentor_custom_course_publishing_completed', function (data) {
      if (data.user_ids.includes(userId)) {
        queryClient.setQueryData(['activity-course-journey-' + journeyId], function (a) {
          return (0, _assign2.default)({}, a, {
            marked_ready_for_enrollment_at: data.course.marked_ready_for_enrollment_at
          });
        });

        setTimeout(function () {
          dispatch((0, _modal.hideModal)());
        }, 300);
      }
    });

    return function () {
      publishChannel.unbind('mentor_custom_course_publishing_completed');
    };
  }, []);

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      lockBodyScroll: false,
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    _react2.default.createElement(
      ModalContainer,
      null,
      !isPublishKickedOff ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          MainContainer,
          null,
          _react2.default.createElement(
            DescriptionText,
            null,
            'Are you ready to publish this journey?'
          )
        ),
        _react2.default.createElement(
          _P2.default,
          { style: { textAlign: 'center', padding: '0 20px 20px' } },
          'Once published, the journey structure will be locked and you will no longer be able to add or remove levels or activities.'
        ),
        _react2.default.createElement(
          ButtonBlock,
          null,
          _react2.default.createElement(
            _FlexAlignCenter2.default,
            {
              style: {
                justifyContent: 'flex-end',
                padding: '18px 15px 23px 0'
              }
            },
            _react2.default.createElement(_Button2.default, {
              buttonColor: _colors2.default.white,
              width: '95px',
              borderColor: _colors2.default.aluminum,
              title: 'Cancel',
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: closeTheModal
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '17px' } },
              '\xA0'
            ),
            _react2.default.createElement(_Button2.default, {
              width: '157x',
              title: 'Publish Journey',
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              handleClick: onPublishJourneyClick
            })
          )
        )
      ) : _react2.default.createElement(
        _FlexAlignCenter2.default,
        {
          style: {
            height: '100%',
            justifyContent: 'center',
            padding: '0 130px'
          }
        },
        _react2.default.createElement(_LoadingSpinner2.default, null),
        _react2.default.createElement(
          _H2.default,
          { style: { marginLeft: '15px' } },
          'Publishing journey...'
        )
      )
    )
  );
};

PublishJourneyModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.number.isRequired,
  journeyId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(PublishJourneyModal);

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 0 0 10px 10px;\n  background-color: ', ';\n  border-top: 1px solid ', ';\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 0 0 10px 10px;\n  background-color: ', ';\n  border-top: 1px solid ', ';\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 30px 30px 10px;\n'], ['\n  padding: 30px 30px 10px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _H3 = __webpack_require__(85);

var _H4 = _interopRequireDefault(_H3);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _RadioInputComponent = __webpack_require__(632);

var _RadioInputComponent2 = _interopRequireDefault(_RadioInputComponent);

var _CoursesSelector = __webpack_require__(323);

var _CoursesSelector2 = _interopRequireDefault(_CoursesSelector);

var _mycourses = __webpack_require__(652);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _reactQuery = __webpack_require__(34);

var _API = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterCourseModal__ModalContainer',
  componentId: 'gn3cot-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterCourseModal__HeaderContainer',
  componentId: 'gn3cot-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);
var FooterContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterCourseModal__FooterContainer',
  componentId: 'gn3cot-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterCourseModal__MainContainer',
  componentId: 'gn3cot-3'
})(_templateObject4);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterCourseModal__FlexContainer',
  componentId: 'gn3cot-4'
})(_templateObject5);

var StarterCourseModal = function StarterCourseModal(_ref) {
  var academicYears = _ref.academicYears,
      academicTerm = _ref.academicTerm,
      user = _ref.user,
      organization = _ref.organization,
      frameworkSubjects = _ref.frameworkSubjects,
      gradeLevels = _ref.gradeLevels,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      orgFlags = _ref.orgFlags;

  console.log('organization', organization);
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      mergedData = _useState2[0],
      setMergedData = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedCourse = _useState4[0],
      setSelectedCourse = _useState4[1];

  var _useQuery = (0, _reactQuery.useQuery)(['cloneable-master-courses'], function () {
    return (0, _API.fetchCloneableMasterCourses)(organization.orgId, user.token);
  }, {
    refetchOnWindowFocus: false,
    enabled: !!selectedAcademicYearId,
    cacheTime: 0
  }),
      isLoadingCloneableMasterCourses = _useQuery.isLoading,
      cloneableMasterCourses = _useQuery.data;

  if (!isLoadingCloneableMasterCourses && !cloneableMasterCourses) {
    console.log('not allowed to copy');
  }

  if (cloneableMasterCourses && cloneableMasterCourses.length === 0) {
    console.log('allowed to copy but no courses');
  }

  (0, _react.useEffect)(function () {
    console.log('cloneableMasterCourses in useEffect', cloneableMasterCourses);
    if (!isLoadingCloneableMasterCourses && cloneableMasterCourses === undefined) {
      handleNext();
    }
    if (cloneableMasterCourses && cloneableMasterCourses.length > 0) {
      setMergedData((0, _mycourses.mergeData)(academicYears, cloneableMasterCourses, gradeLevels));
    }
  }, [cloneableMasterCourses, !isLoadingCloneableMasterCourses]);

  if (_mycourses.mergeData.length > 0) console.log('mergedData', mergedData);

  var _useState5 = (0, _react.useState)('new'),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      selectedNewOrExisting = _useState6[0],
      setSelectedNewOrExisting = _useState6[1];

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var handleSelectedNewOrExisting = function handleSelectedNewOrExisting(value) {
    setSelectedNewOrExisting(value);
  };

  var handleSelectedCourse = function handleSelectedCourse(course) {
    setSelectedCourse(course);
  };

  var handleNext = function handleNext() {
    dispatch((0, _modal.hideModal)());
    dispatch((0, _modal.showModal)('CREATE_NEW_COURSE_MODAL', {
      user: user,
      organization: organization,
      academicYears: academicYears,
      frameworkSubjects: frameworkSubjects,
      gradeLevels: gradeLevels,
      selectedAcademicYearId: selectedAcademicYearId,
      selectedCourse: selectedCourse
    }));
  };

  var couldSaveData = selectedNewOrExisting === 'new' || selectedNewOrExisting === 'existing' && selectedCourse !== null;

  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    cloneableMasterCourses && _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          { blue: true },
          '+ Create Course'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _H4.default,
            { light: true, blue: true },
            academicTerm
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_RadioInputComponent2.default, {
          onChange: handleSelectedNewOrExisting,
          disableCloning: !mergedData || mergedData.length < 1,
          orgFlags: orgFlags
        }),
        !isLoadingCloneableMasterCourses && selectedNewOrExisting === 'existing' && _mycourses.mergeData && _react2.default.createElement(_CoursesSelector2.default, {
          courses: mergedData,
          onSelectCourse: handleSelectedCourse,
          initialSelectedCourse: selectedCourse,
          gradeLevels: gradeLevels
        })
      ),
      _react2.default.createElement(
        FooterContainer,
        null,
        _react2.default.createElement(
          _MarginRight2.default,
          null,
          _react2.default.createElement(_CancelButton2.default, { handleClick: handleCloseModal, title: 'Cancel', width: '104px' })
        ),
        _react2.default.createElement(
          'div',
          {
            'data-for': 'createCourseTooltip',
            'data-tip': 'Please select an existing course.'
          },
          _react2.default.createElement(_Button2.default, {
            width: '104px',
            title: 'Next',
            handleClick: handleNext,
            buttonColor: _colors2.default.oeYellow,
            borderColor: _colors2.default.oeYellow,
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white,
            couldSaveData: couldSaveData,
            shouldShowTooltipAndDisableButton: true
          }),
          selectedNewOrExisting === 'existing' && !selectedCourse && _react2.default.createElement(_reactTooltip2.default, {
            id: 'createCourseTooltip',
            place: 'bottom',
            effect: 'solid',
            className: 'activityCourseTooltip'
          })
        )
      )
    ),
    !cloneableMasterCourses && ''
  );
};

StarterCourseModal.propTypes = {
  closeCallback: _propTypes2.default.func,
  activity: _propTypes2.default.object,
  resource: _propTypes2.default.object,
  quest: _propTypes2.default.object,
  activities: _propTypes2.default.array,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  academicTerm: _propTypes2.default.string
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    academicTerm: state.mycourses.selectedAcademicYearGlobally.name,
    academicYears: ownProps.academicYears,
    user: state.user,
    organization: state.organization
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withApiData2.default)(StarterCourseModal));

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', '\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  opacity: ', ';\n'], ['\n  color: ', '\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  opacity: ', ';\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioLabel = _styledComponents2.default.label.withConfig({
  displayName: 'RadioLabel',
  componentId: 'sc-9x4530-0'
})(_templateObject, _colors2.default.victoria, function (props) {
  return props.disabled ? 0.5 : 1;
});

exports.default = RadioLabel;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(93)))

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  max-height: 250px;\n  width: 555px;\n  overflow: scroll;\n  padding: 0 22px 16px;\n  border-width: 0 0.5px 0.5px;\n  border-style: solid;\n  border-color: #BBBBBB;\n  border-radius: 0 0 5px 5px;\n  background-color: white;\n  ul {\n    padding-top: 18px;\n    font-size: 11px;\n    line-height: 13px;\n    color: #666666\n  }\n  li {\n    padding: 8px 22px;\n    font-size: 14px;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 0 -22px;\n    &:hover {\n      background-color: rgba(222, 235, 255, 0.5);\n    }\n  }\n'], ['\n  position: absolute;\n  max-height: 250px;\n  width: 555px;\n  overflow: scroll;\n  padding: 0 22px 16px;\n  border-width: 0 0.5px 0.5px;\n  border-style: solid;\n  border-color: #BBBBBB;\n  border-radius: 0 0 5px 5px;\n  background-color: white;\n  ul {\n    padding-top: 18px;\n    font-size: 11px;\n    line-height: 13px;\n    color: #666666\n  }\n  li {\n    padding: 8px 22px;\n    font-size: 14px;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 0 -22px;\n    &:hover {\n      background-color: rgba(222, 235, 255, 0.5);\n    }\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _sorter = __webpack_require__(1350);

var _CoursesSelector = __webpack_require__(323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseDropdownStyle = _styledComponents2.default.div.withConfig({
  displayName: 'CourseDropdown__CourseDropdownStyle',
  componentId: 'a9rccb-0'
})(_templateObject);

var CourseDropdown = function CourseDropdown(_ref) {
  var courses = _ref.courses,
      onSelectCourse = _ref.onSelectCourse,
      selectedCourse = _ref.selectedCourse,
      toggle = _ref.toggle;

  // const [selectedCourse, setSelectedCourse] = useState({})

  var handleSelectCourse = function handleSelectCourse(course) {
    // setSelectedCourse(course)
    onSelectCourse(course);
    toggle();
  };
  console.log(selectedCourse);
  return _react2.default.createElement(
    CourseDropdownStyle,
    null,
    courses.map(function (academicYear) {
      if (academicYear.courses.length > 0) {
        return _react2.default.createElement(
          'ul',
          { key: academicYear.id },
          _react2.default.createElement(
            'p',
            null,
            academicYear.name
          ),
          (0, _sorter.sortStarterCourses)(academicYear.courses).map(function (course) {
            return _react2.default.createElement(
              'li',
              {
                key: course.id,
                style: { color: '#' + course.color, backgroundColor: selectedCourse && course.id === selectedCourse.id ? 'rgba(222, 235, 255, 0.75)' : '' },
                onClick: function onClick() {
                  return handleSelectCourse(course);
                } },
              course.grade_level_abbreviation + '/ ' + course.name,
              _react2.default.createElement(
                _CoursesSelector.DraftSpan,
                null,
                course.enrollment_ready_courses_count === 0 || course.enrollment_ready_courses_count !== course.courses_count ? '(Draft)' : ''
              )
            );
          })
        );
      }
    })
  );
};

CourseDropdown.propTypes = {
  courses: _propTypes2.default.array.isRequired
};

exports.default = CourseDropdown;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortStarterCourses = undefined;

var _thenby = __webpack_require__(331);

var sortStarterCourses = exports.sortStarterCourses = function sortStarterCourses(arr) {
  return arr.sort((0, _thenby.firstBy)('grade_level_id').thenBy('name'));
};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n'], ['\n  width: 660px;\n  margin: 100px auto;\n  border-radius: 10px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  background-color: ', ';\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 10px 10px 0 0;\n  background-color: ', ';\n  border-bottom: 1px solid ', ';\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  height: 80px;\n  width: auto;\n  border-radius: 0 0 10px 10px;\n  background-color: ', ';\n  border-top: 1px solid ', ';\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 0 30px;\n'], ['\n  height: 80px;\n  width: auto;\n  border-radius: 0 0 10px 10px;\n  background-color: ', ';\n  border-top: 1px solid ', ';\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding: 0 30px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 30px 30px 10px;\n'], ['\n  padding: 30px 30px 10px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _modal = __webpack_require__(26);

var _Modal = __webpack_require__(50);

var _Modal2 = _interopRequireDefault(_Modal);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _H3 = __webpack_require__(85);

var _H4 = _interopRequireDefault(_H3);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _RadioInputComponent = __webpack_require__(632);

var _RadioInputComponent2 = _interopRequireDefault(_RadioInputComponent);

var _mycourses = __webpack_require__(652);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _reactQuery = __webpack_require__(34);

var _API = __webpack_require__(98);

var _JourneySelector = __webpack_require__(1352);

var _JourneySelector2 = _interopRequireDefault(_JourneySelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterJourneyModal__ModalContainer',
  componentId: 'sc-1vj7lkq-0'
})(_templateObject, _colors2.default.smoke);

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterJourneyModal__HeaderContainer',
  componentId: 'sc-1vj7lkq-1'
})(_templateObject2, _colors2.default.white, _colors2.default.rock);
var FooterContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterJourneyModal__FooterContainer',
  componentId: 'sc-1vj7lkq-2'
})(_templateObject3, _colors2.default.white, _colors2.default.rock);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterJourneyModal__MainContainer',
  componentId: 'sc-1vj7lkq-3'
})(_templateObject4);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StarterJourneyModal__FlexContainer',
  componentId: 'sc-1vj7lkq-4'
})(_templateObject5);

var StarterJourneyModal = function StarterJourneyModal(_ref) {
  var apiData = _ref.apiData,
      academicTerm = _ref.academicTerm,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      activityCourse = _ref.activityCourse,
      handleDisplayJourneysListOnCreation = _ref.handleDisplayJourneysListOnCreation,
      gradeLevels = _ref.gradeLevels,
      orgFlags = _ref.orgFlags;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      selectedJourney = _useState2[0],
      setSelectedJourney = _useState2[1];

  var _useState3 = (0, _react.useState)('new'),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedNewOrExisting = _useState4[0],
      setSelectedNewOrExisting = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      mergedData = _useState6[0],
      setMergedData = _useState6[1];

  var _useQuery = (0, _reactQuery.useQuery)(['cloneable-journeys-' + selectedAcademicYearId], function () {
    return (0, _API.fetchCloneableJourneys)(apiData.orgId, apiData.token, activityCourse.id);
  }, {
    enabled: !!selectedAcademicYearId && !!apiData.orgId && !!apiData.token && !!activityCourse.id,
    cacheTime: 0
  }),
      isLoadingCloneableJourneys = _useQuery.isLoading,
      cloneableJourneys = _useQuery.data;

  (0, _react.useEffect)(function () {
    if (!isLoadingCloneableJourneys && !cloneableJourneys) {
      handleNext();
    }
    if (cloneableJourneys && cloneableJourneys.length > 0) {
      setMergedData((0, _mycourses.mergeJourneyData)(academicYears, cloneableJourneys, gradeLevels));
    }
  }, [cloneableJourneys, academicYears, gradeLevels, isLoadingCloneableJourneys]);

  (0, _react.useEffect)(function () {}, []);

  var handleCloseModal = function handleCloseModal() {
    dispatch((0, _modal.hideModal)());
  };

  var handleSelectedNewOrExisting = function handleSelectedNewOrExisting(value) {
    setSelectedNewOrExisting(value);
  };

  var handleSelectedJourney = function handleSelectedJourney(journey) {
    setSelectedJourney(journey);
  };

  var handleNext = function handleNext() {
    dispatch((0, _modal.hideModal)());
    dispatch((0, _modal.showModal)('CREATE_JOURNEY_MODAL', {
      activityCourseId: activityCourse.id,
      selectedAcademicYearId: selectedAcademicYearId,
      handleDisplayJourneysListOnCreation: handleDisplayJourneysListOnCreation,
      selectedJourney: selectedJourney,
      color: activityCourse.color
    }));
  };

  var couldSaveData = selectedNewOrExisting === 'new' || selectedNewOrExisting === 'existing' && selectedJourney !== null;
  return _react2.default.createElement(
    _Modal2.default,
    {
      width: 1400,
      percentHeight: 100,
      background: 'rgba(36,54,70,0.48)',
      opacity: '.9',
      allowInnerScroll: true,
      allowCloseOnExternalClick: false
    },
    cloneableJourneys && _react2.default.createElement(
      ModalContainer,
      null,
      _react2.default.createElement(
        HeaderContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          { blue: true },
          '+ Add Journey'
        ),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            _H4.default,
            { light: true, blue: true },
            academicTerm
          )
        )
      ),
      _react2.default.createElement(
        MainContainer,
        null,
        _react2.default.createElement(_RadioInputComponent2.default, { onChange: handleSelectedNewOrExisting, disableCloning: !mergedData || mergedData.length < 1, journey: true, orgFlags: orgFlags }),
        selectedNewOrExisting === 'existing' && !isLoadingCloneableJourneys && _react2.default.createElement(_JourneySelector2.default, {
          journeys: mergedData,
          onSelectJourney: handleSelectedJourney,
          initialSelectedJourney: selectedJourney
        })
      ),
      _react2.default.createElement(
        FooterContainer,
        null,
        _react2.default.createElement(
          _MarginRight2.default,
          null,
          _react2.default.createElement(_CancelButton2.default, { handleClick: handleCloseModal, title: 'Cancel', width: '104px' })
        ),
        _react2.default.createElement(
          'div',
          {
            'data-for': 'createCourseJourneyTooltip',
            'data-tip': 'Please select an existing journey.'
          },
          _react2.default.createElement(_Button2.default, {
            width: '104px',
            title: 'Next',
            handleClick: handleNext,
            buttonColor: _colors2.default.oeYellow,
            borderColor: _colors2.default.oeYellow,
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white,
            couldSaveData: couldSaveData,
            shouldShowTooltipAndDisableButton: true
          }),
          selectedNewOrExisting === 'existing' && !selectedJourney && _react2.default.createElement(_reactTooltip2.default, {
            id: 'createCourseJourneyTooltip',
            place: 'bottom',
            effect: 'solid',
            className: 'activityCourseTooltip'
          })
        )
      )
    ),
    !cloneableJourneys && ''
  );
};

StarterJourneyModal.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  handleDisplayJourneysListOnJourneyCreation: _propTypes2.default.func.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    organization: state.organization,
    academicTerm: state.mycourses.selectedAcademicYearGlobally.name
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withApiData2.default)(StarterJourneyModal));

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JourneySelector = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  box-shadow: none;\n  height: 44px;\n  cursor: pointer;\n  border: 0.5px solid #BBBBBB;\n  border-radius: ', ';\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n'], ['\n  box-shadow: none;\n  height: 44px;\n  cursor: pointer;\n  border: 0.5px solid #BBBBBB;\n  border-radius: ', ';\n  background-color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0 15px;\n  font-size: 1rem;\n  font-weight: ', ';\n  color: ', ';\n'], ['\n  padding: 0 15px;\n  font-size: 1rem;\n  font-weight: ', ';\n  color: ', ';\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  box-sizing: border-box;\n  margin-right: 15px;\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2px;\n  height: 0;\n  width: 0;\n  position: relative;\n\n  &:hover {\n    border-color: #666 transparent transparent;\n  }\n'], ['\n  display: inline-block;\n  box-sizing: border-box;\n  margin-right: 15px;\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2px;\n  height: 0;\n  width: 0;\n  position: relative;\n\n  &:hover {\n    border-color: #666 transparent transparent;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = __webpack_require__(633);

var _JourneyDropdown = __webpack_require__(1353);

var _JourneyDropdown2 = _interopRequireDefault(_JourneyDropdown);

var _CoursesSelector = __webpack_require__(323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'JourneySelector__SelectorContainer',
  componentId: 'ji6be7-0'
})(_templateObject);
var SelectControl = _styledComponents2.default.div.withConfig({
  displayName: 'JourneySelector__SelectControl',
  componentId: 'ji6be7-1'
})(_templateObject2, function (props) {
  return props.open ? '5px 5px 0 0' : '5px';
});

var SelectPlaceholder = _styledComponents2.default.div.withConfig({
  displayName: 'JourneySelector__SelectPlaceholder',
  componentId: 'ji6be7-2'
})(_templateObject3, function (props) {
  return props.color ? 500 : 300;
}, function (props) {
  return props.color ? '#' + props.color : '#999999';
});

var SelectArrow = _styledComponents2.default.span.withConfig({
  displayName: 'JourneySelector__SelectArrow',
  componentId: 'ji6be7-3'
})(_templateObject4);

var JourneySelector = exports.JourneySelector = function JourneySelector(_ref) {
  var journeys = _ref.journeys,
      onSelectJourney = _ref.onSelectJourney,
      initialSelectedJourney = _ref.initialSelectedJourney;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(initialSelectedJourney),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedJourney = _useState4[0],
      setSelectedJourney = _useState4[1];

  var toggle = function toggle() {
    setDropdownOpen(!dropdownOpen);
  };
  var handleSelectedJourney = function handleSelectedJourney(journey) {
    setSelectedJourney(journey);
    onSelectJourney(journey);
  };
  return _react2.default.createElement(
    _core.ClickAwayListener,
    { onClickAway: function onClickAway() {
        return setDropdownOpen(false);
      } },
    _react2.default.createElement(
      SelectorContainer,
      null,
      _react2.default.createElement(
        SelectControl,
        { open: dropdownOpen, onClick: toggle },
        selectedJourney === null && _react2.default.createElement(
          SelectPlaceholder,
          null,
          'Select a journey.'
        ),
        selectedJourney && _react2.default.createElement(
          SelectPlaceholder,
          { color: selectedJourney.master_course.color },
          selectedJourney.name,
          _react2.default.createElement(
            _CoursesSelector.DraftSpan,
            null,
            !selectedJourney.marked_ready_for_enrollment_at ? '(Draft)' : ''
          )
        ),
        _react2.default.createElement(SelectArrow, { onClick: toggle })
      ),
      dropdownOpen && _react2.default.createElement(_JourneyDropdown2.default, { journeys: journeys, onSelectJourney: handleSelectedJourney, selectedJourney: selectedJourney, toggle: toggle })
    )
  );
};

JourneySelector.propTypes = {
  courses: _propTypes2.default.array
};

exports.default = JourneySelector;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  max-height: 250px;\n  width: 555px;\n  overflow: scroll;\n  padding: 0 22px 16px;\n  border-width: 0 0.5px 0.5px;\n  border-style: solid;\n  border-color: #BBBBBB;\n  border-radius: 0 0 5px 5px;\n  background-color: white;\n  ul {\n    padding-top: 18px;\n    font-size: 11px;\n    line-height: 13px;\n    color: #666666\n  }\n  li {\n    padding: 8px 22px;\n    font-size: 14px;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 0 -22px;\n    &:hover {\n      background-color: rgba(222, 235, 255, 0.5);\n    }\n'], ['\n  position: absolute;\n  max-height: 250px;\n  width: 555px;\n  overflow: scroll;\n  padding: 0 22px 16px;\n  border-width: 0 0.5px 0.5px;\n  border-style: solid;\n  border-color: #BBBBBB;\n  border-radius: 0 0 5px 5px;\n  background-color: white;\n  ul {\n    padding-top: 18px;\n    font-size: 11px;\n    line-height: 13px;\n    color: #666666\n  }\n  li {\n    padding: 8px 22px;\n    font-size: 14px;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 0 -22px;\n    &:hover {\n      background-color: rgba(222, 235, 255, 0.5);\n    }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _util = __webpack_require__(114);

var _CoursesSelector = __webpack_require__(323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectDropdown = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyDropdown__SelectDropdown',
  componentId: 'o4c3kv-0'
})(_templateObject);

var JourneyDropdown = function JourneyDropdown(_ref) {
  var journeys = _ref.journeys,
      onSelectJourney = _ref.onSelectJourney,
      selectedJourney = _ref.selectedJourney,
      toggle = _ref.toggle;

  var handleSelectCourse = function handleSelectCourse(journey) {
    onSelectJourney(journey);
    toggle();
  };
  console.log('journeys in dropdown', journeys);
  return _react2.default.createElement(
    SelectDropdown,
    null,
    journeys.map(function (academicYear) {
      if (academicYear.courses.length > 0) {
        return _react2.default.createElement(
          'ul',
          { key: academicYear.id },
          _react2.default.createElement(
            'p',
            null,
            academicYear.name
          ),
          academicYear.courses.map(function (journey) {
            return _react2.default.createElement(
              'li',
              { key: journey.id, style: { color: (0, _util.cleanHexCode)(journey.master_course.color), backgroundColor: selectedJourney && journey.id === selectedJourney.id ? 'rgba(222, 235, 255, 0.75)' : '' }, onClick: function onClick() {
                  return handleSelectCourse(journey);
                } },
              journey.grade_level_abbreviation,
              '/ ',
              journey.name,
              _react2.default.createElement(
                _CoursesSelector.DraftSpan,
                null,
                !journey.marked_ready_for_enrollment_at ? '(Draft)' : ''
              )
            );
          })
        );
      }
    })
  )
  // <SelectDropdown>
  //   {journeys.map((journey) => {
  //     return (
  //       <ul key={journey.id}>
  //           <li key={journey.id} onClick={() => handleSelectCourse(journey)}>
  //             {journey.name}
  //           </li>
  //       </ul>
  //     )
  //   })}
  // </SelectDropdown>
  ;
};

JourneyDropdown.propTypes = {
  journeys: _propTypes2.default.array.isRequired
};

exports.default = JourneyDropdown;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var env;
if (window.location.href.includes('localhost')) {
  env = 'development';
} else if (window.location.href.includes('staging')) {
  env = 'staging';
} else {
  env = 'production';
}

var accessToken;
if (env === 'staging') {
  accessToken = '188c134366684c6095032121c272e58c';
} else if (env === 'production') {
  accessToken = '4e1ee80cebdd494aa04a2cfaba7e28f5';
} else {
  accessToken = '0dd5ff186f824f57a161d94e7e09af4d';
}

var rollbarConfig = {
  accessToken: accessToken,
  captureUncaught: true,
  autoInstrument: true,
  payload: {
    environment: env,
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true
      }
    }
  }
};

var Rollbar = __webpack_require__(1355);
var rollbar = exports.rollbar = new Rollbar(rollbarConfig);

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(183);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
/* eslint-disable */

!function (t, e) {
  if ('object' == ( false ? 'undefined' : (0, _typeof3.default)(exports)) && 'object' == ( false ? 'undefined' : (0, _typeof3.default)(module))) module.exports = e();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var r = e();
    for (var n in r) {
      ('object' == (typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) ? exports : t)[n] = r[n];
    }
  }
}(undefined, function () {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = { exports: {}, id: n, loaded: !1 };
      return t[n].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }
    var r = {};
    return e.m = t, e.c = r, e.p = '', e(0);
  }([function (t, e, r) {
    t.exports = r(1);
  }, function (t, e, r) {
    'use strict';

    var n = r(2),
        o = window && window._rollbarConfig,
        i = o && o.globalAlias || 'Rollbar',
        a = window && window[i] && 'function' == typeof window[i].shimId && void 0 !== window[i].shimId();
    if (window && !window._rollbarStartTime && (window._rollbarStartTime = new Date().getTime()), !a && o) {
      var s = new n(o);
      window[i] = s;
    } else window.rollbar = n, window._rollbarDidLoad = !0;
    t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n(t, e) {
      this.options = c.extend(!0, _, t);
      var r = new l(this.options, h, d);this.client = e || new u(this.options, r, p, 'browser'), i(this.client.notifier), a(this.client.queue), (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (f.captureUncaughtExceptions(window, this), f.wrapGlobals(window, this)), (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && f.captureUnhandledRejections(window, this), this.instrumenter = new b(this.options, this.client.telemeter, this, window, document), this.instrumenter.instrument();
    }
    function o(t) {
      var e = 'Rollbar is not initialized';
      p.error(e), t && t(new Error(e));
    }
    function i(t) {
      t.addTransform(m.handleItemWithError).addTransform(m.ensureItemHasSomethingToSay).addTransform(m.addBaseInfo).addTransform(m.addRequestInfo(window)).addTransform(m.addClientInfo(window)).addTransform(m.addPluginInfo(window)).addTransform(m.addBody).addTransform(g.addMessageWithError).addTransform(g.addTelemetryData).addTransform(m.scrubPayload).addTransform(m.userTransform).addTransform(g.itemToPayload);
    }
    function a(t) {
      t.addPredicate(v.checkIgnore).addPredicate(v.userCheckIgnore).addPredicate(v.urlIsWhitelisted).addPredicate(v.messageIsIgnored);
    }
    function s(t) {
      for (var e = 0, r = t.length; e < r; ++e) {
        if (c.isFunction(t[e])) return t[e];
      }
    }
    var u = r(3),
        c = r(6),
        l = r(11),
        p = r(13),
        f = r(16),
        h = r(17),
        d = r(18),
        m = r(19),
        g = r(23),
        v = r(24),
        y = r(20),
        b = r(25),
        w = null;n.init = function (t, e) {
      return w ? w.global(t).configure(t) : w = new n(t, e);
    }, n.prototype.global = function (t) {
      return this.client.global(t), this;
    }, n.global = function (t) {
      return w ? w.global(t) : void o();
    }, n.prototype.configure = function (t, e) {
      var r = this.options,
          n = {};
      return e && (n = { payload: e }), this.options = c.extend(!0, {}, r, t, n), this.client.configure(t, e), this;
    }, n.configure = function (t, e) {
      return w ? w.configure(t, e) : void o();
    }, n.prototype.lastError = function () {
      return this.client.lastError;
    }, n.lastError = function () {
      return w ? w.lastError() : void o();
    }, n.prototype.log = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.log(t), { uuid: e };
    }, n.log = function () {
      if (w) return w.log.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.debug = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.debug(t), { uuid: e };
    }, n.debug = function () {
      if (w) return w.debug.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.info = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.info(t), { uuid: e };
    }, n.info = function () {
      if (w) return w.info.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.warn = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.warn(t), { uuid: e };
    }, n.warn = function () {
      if (w) return w.warn.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.warning = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.warning(t), { uuid: e };
    }, n.warning = function () {
      if (w) return w.warning.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.error = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.error(t), { uuid: e };
    }, n.error = function () {
      if (w) return w.error.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.critical = function () {
      var t = this._createItem(arguments),
          e = t.uuid;
      return this.client.critical(t), { uuid: e };
    }, n.critical = function () {
      if (w) return w.critical.apply(w, arguments);
      var t = s(arguments);
      o(t);
    }, n.prototype.handleUncaughtException = function (t, e, r, n, o, i) {
      var a,
          s = c.makeUnhandledStackInfo(t, e, r, n, o, 'onerror', 'uncaught exception', y);
      c.isError(o) ? (a = this._createItem([t, o, i]), a._unhandledStackInfo = s) : c.isError(e) ? (a = this._createItem([t, e, i]), a._unhandledStackInfo = s) : (a = this._createItem([t, i]), a.stackInfo = s), a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
    }, n.prototype.handleUnhandledRejection = function (t, e) {
      var r = 'unhandled rejection was null or undefined!';
      r = t ? t.message || String(t) : r;
      var n,
          o = t && t._rollbarContext || e && e._rollbarContext;
      c.isError(t) ? n = this._createItem([r, t, o]) : (n = this._createItem([r, t, o]), n.stackInfo = c.makeUnhandledStackInfo(r, '', 0, 0, null, 'unhandledrejection', '', y)), n.level = this.options.uncaughtErrorLevel, n._isUncaught = !0, n._originalArgs = n._originalArgs || [], n._originalArgs.push(e), this.client.log(n);
    }, n.prototype.wrap = function (t, e, r) {
      try {
        var n;
        if (n = c.isFunction(e) ? e : function () {
          return e || {};
        }, !c.isFunction(t)) return t;
        if (t._isWrap) return t;
        if (!t._rollbar_wrapped && (t._rollbar_wrapped = function () {
          r && c.isFunction(r) && r.apply(this, arguments);
          try {
            return t.apply(this, arguments);
          } catch (r) {
            var e = r;
            throw c.isType(e, 'string') && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e, e;
          }
        }, t._rollbar_wrapped._isWrap = !0, t.hasOwnProperty)) for (var o in t) {
          t.hasOwnProperty(o) && (t._rollbar_wrapped[o] = t[o]);
        }return t._rollbar_wrapped;
      } catch (e) {
        return t;
      }
    }, n.wrap = function (t, e) {
      return w ? w.wrap(t, e) : void o();
    }, n.prototype.captureEvent = function (t, e) {
      return this.client.captureEvent(t, e);
    }, n.captureEvent = function (t, e) {
      return w ? w.captureEvent(t, e) : void o();
    }, n.prototype.captureDomContentLoaded = function (t, e) {
      return e || (e = new Date()), this.client.captureDomContentLoaded(e);
    }, n.prototype.captureLoad = function (t, e) {
      return e || (e = new Date()), this.client.captureLoad(e);
    }, n.prototype._createItem = function (t) {
      return c.createItem(t, p, this);
    };
    var _ = {
      version: '2.2.3',
      scrubFields: ['pw', 'pass', 'passwd', 'password', 'secret', 'confirm_password', 'confirmPassword', 'password_confirmation', 'passwordConfirmation', 'access_token', 'accessToken', 'secret_key', 'secretKey', 'secretToken'],
      logLevel: 'debug',
      reportLevel: 'debug',
      uncaughtErrorLevel: 'error',
      endpoint: 'api.rollbar.com/api/1/',
      verbose: !1,
      enabled: !0
    };
    t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r, o) {
      ;this.options = u.extend(!0, {}, t), this.logger = r, n.rateLimiter.setPlatformOptions(o, this.options), this.queue = new i(n.rateLimiter, e, r, this.options), this.notifier = new a(this.queue, this.options), this.telemeter = new s(this.options), this.lastError = null;
    }
    var o = r(4),
        i = r(5),
        a = r(9),
        s = r(10),
        u = r(6),
        c = { maxItems: 0, itemsPerMinute: 60 };n.rateLimiter = new o(c), n.prototype.global = function (t) {
      return n.rateLimiter.configureGlobal(t), this;
    }, n.prototype.configure = function (t, e) {
      this.notifier && this.notifier.configure(t);
      var r = this.options,
          n = {};
      return e && (n = { payload: e }), this.options = u.extend(!0, {}, r, t, n), this;
    }, n.prototype.log = function (t) {
      var e = this._defaultLogLevel();
      return this._log(e, t);
    }, n.prototype.debug = function (t) {
      this._log('debug', t);
    }, n.prototype.info = function (t) {
      this._log('info', t);
    }, n.prototype.warn = function (t) {
      this._log('warning', t);
    }, n.prototype.warning = function (t) {
      this._log('warning', t);
    }, n.prototype.error = function (t) {
      this._log('error', t);
    }, n.prototype.critical = function (t) {
      this._log('critical', t);
    }, n.prototype.wait = function (t) {
      this.queue.wait(t);
    }, n.prototype.captureEvent = function (t, e) {
      return this.telemeter.captureEvent(t, e);
    }, n.prototype.captureDomContentLoaded = function (t) {
      return this.telemeter.captureDomContentLoaded(t);
    }, n.prototype.captureLoad = function (t) {
      return this.telemeter.captureLoad(t);
    }, n.prototype._log = function (t, e) {
      if (!this._sameAsLastError(e)) try {
        var r = null;
        e.callback && (r = e.callback, delete e.callback), e.level = e.level || t, e.telemetryEvents = this.telemeter.copyEvents(), this.telemeter._captureRollbarItem(e), this.notifier.log(e, r);
      } catch (t) {
        this.logger.error(t);
      }
    }, n.prototype._defaultLogLevel = function () {
      return this.options.logLevel || 'debug';
    }, n.prototype._sameAsLastError = function (t) {
      return !(!this.lastError || this.lastError !== t.err) || (this.lastError = t.err, !1);
    }, t.exports = n;
  }, function (t, e) {
    'use strict';

    function r(t) {
      ;this.startTime = new Date().getTime(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(t);
    }
    function n(t, e, r) {
      return !t.ignoreRateLimit && e >= 1 && r >= e;
    }
    function o(t, e, r, n, o) {
      var a = null;
      return r && (r = new Error(r)), r || n || (a = i(t, e, o)), { error: r, shouldSend: n, payload: a };
    }
    function i(t, e, r) {
      var n = e.environment || e.payload && e.payload.environment,
          o = {
        body: {
          message: {
            body: 'maxItems has been hit. Ignoring errors until reset.',
            extra: { maxItems: r }
          }
        },
        language: 'javascript',
        environment: n,
        notifier: {
          version: e.notifier && e.notifier.version || e.version
        }
      };
      return 'browser' === t ? (o.platform = 'browser', o.framework = 'browser-js', o.notifier.name = 'rollbar-browser-js') : 'server' === t && (o.framework = e.framework || 'node-js', o.notifier.name = e.notifier.name), o;
    }
    ;r.globalSettings = {
      startTime: new Date().getTime(),
      maxItems: void 0,
      itemsPerMinute: void 0
    }, r.prototype.configureGlobal = function (t) {
      void 0 !== t.startTime && (r.globalSettings.startTime = t.startTime), void 0 !== t.maxItems && (r.globalSettings.maxItems = t.maxItems), void 0 !== t.itemsPerMinute && (r.globalSettings.itemsPerMinute = t.itemsPerMinute);
    }, r.prototype.shouldSend = function (t, e) {
      ;e = e || new Date().getTime(), e - this.startTime >= 6e4 && (this.startTime = e, this.perMinCounter = 0);
      var i = r.globalSettings.maxItems,
          a = r.globalSettings.itemsPerMinute;
      if (n(t, i, this.counter)) return o(this.platform, this.platformOptions, i + ' max items reached', !1);
      if (n(t, a, this.perMinCounter)) return o(this.platform, this.platformOptions, a + ' items per minute reached', !1);
      this.counter++, this.perMinCounter++;
      var s = !n(t, i, this.counter);
      return o(this.platform, this.platformOptions, null, s, i);
    }, r.prototype.setPlatformOptions = function (t, e) {
      ;this.platform = t, this.platformOptions = e;
    }, t.exports = r;
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r, n) {
      ;this.rateLimiter = t, this.api = e, this.logger = r, this.options = n, this.predicates = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
    }
    var o = r(6);n.prototype.configure = function (t) {
      this.api && this.api.configure(t);
      var e = this.options;
      return this.options = o.extend(!0, {}, e, t), this;
    }, n.prototype.addPredicate = function (t) {
      return o.isFunction(t) && this.predicates.push(t), this;
    }, n.prototype.addItem = function (t, e, r) {
      ;e && o.isFunction(e) || (e = function e() {});
      var n = this._applyPredicates(t);
      if (n.stop) return void e(n.err);
      if (this.waitCallback) return void e();
      this._maybeLog(t, r), this.pendingRequests.push(t);
      try {
        this._makeApiRequest(t, function (r, n) {
          this._dequeuePendingRequest(t), e(r, n);
        }.bind(this));
      } catch (r) {
        this._dequeuePendingRequest(t), e(r);
      }
    }, n.prototype.wait = function (t) {
      o.isFunction(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval(function () {
        this._maybeCallWait();
      }.bind(this), 500)));
    }, n.prototype._applyPredicates = function (t) {
      for (var e = null, r = 0, n = this.predicates.length; r < n; r++) {
        if (e = this.predicates[r](t, this.options), !e || void 0 !== e.err) return { stop: !0, err: e.err };
      }return { stop: !1, err: null };
    }, n.prototype._makeApiRequest = function (t, e) {
      var r = this.rateLimiter.shouldSend(t);
      r.shouldSend ? this.api.postItem(t, function (r, n) {
        r ? this._maybeRetry(r, t, e) : e(r, n);
      }.bind(this)) : r.error ? e(r.error) : this.api.postItem(r.payload, e);
    };
    var i = ['ECONNRESET', 'ENOTFOUND', 'ESOCKETTIMEDOUT', 'ETIMEDOUT', 'ECONNREFUSED', 'EHOSTUNREACH', 'EPIPE', 'EAI_AGAIN'];n.prototype._maybeRetry = function (t, e, r) {
      var n = !1;
      if (this.options.retryInterval) for (var o = 0, a = i.length; o < a; o++) {
        if (t.code === i[o]) {
          n = !0;
          break;
        }
      }n ? this._retryApiRequest(e, r) : r(t);
    }, n.prototype._retryApiRequest = function (t, e) {
      this.retryQueue.push({ item: t, callback: e }), this.retryHandle || (this.retryHandle = setInterval(function () {
        for (; this.retryQueue.length;) {
          var t = this.retryQueue.shift();
          this._makeApiRequest(t.item, t.callback);
        }
      }.bind(this), this.options.retryInterval));
    }, n.prototype._dequeuePendingRequest = function (t) {
      for (var e = this.pendingRequests.length; e >= 0; e--) {
        if (this.pendingRequests[e] == t) return this.pendingRequests.splice(e, 1), void this._maybeCallWait();
      }
    }, n.prototype._maybeLog = function (t, e) {
      if (this.logger && this.options.verbose) {
        var r = e;
        if (r = r || o.get(t, 'body.trace.exception.message'), r = r || o.get(t, 'body.trace_chain.0.exception.message')) return void this.logger.error(r);r = o.get(t, 'body.message.body'), r && this.logger.log(r);
      }
    }, n.prototype._maybeCallWait = function () {
      return !(!o.isFunction(this.waitCallback) || 0 !== this.pendingRequests.length) && (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), !0);
    }, t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n() {
      if (!C && (C = !0, s(JSON) && (a(_stringify2.default) && (L.stringify = _stringify2.default), a(JSON.parse) && (L.parse = JSON.parse)), !a(L.stringify) || !a(L.parse))) {
        var t = r(8);
        t(L);
      }
    }
    function o(t, e) {
      return e === i(t);
    }
    function i(t) {
      var e = typeof t === 'undefined' ? 'undefined' : (0, _typeof3.default)(t);
      return 'object' !== e ? e : t ? t instanceof Error ? 'error' : {}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : 'null';
    }
    function a(t) {
      return o(t, 'function');
    }
    function s(t) {
      return !o(t, 'undefined');
    }
    function u(t) {
      var e = i(t);
      return 'object' === e || 'array' === e;
    }
    function c(t) {
      return o(t, 'error');
    }
    function l(t, e, r) {
      var n,
          i,
          a,
          s = o(t, 'object'),
          u = o(t, 'array'),
          c = [];
      if (s && r.indexOf(t) !== -1) return t;
      if (r.push(t), s) for (n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && c.push(n);
      } else if (u) for (a = 0; a < t.length; ++a) {
        c.push(a);
      }for (a = 0; a < c.length; ++a) {
        n = c[a], i = t[n], t[n] = e(n, i, r);
      }return t;
    }
    function p() {
      return '********';
    }
    function f() {
      var t = O(),
          e = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (e) {
        var r = (t + 16 * Math.random()) % 16 | 0;
        return t = Math.floor(t / 16), ('x' === e ? r : 7 & r | 8).toString(16);
      });
      return e;
    }
    function h(t) {
      var e = d(t);
      return '' === e.anchor && (e.source = e.source.replace('#', '')), t = e.source.replace('?' + e.query, '');
    }
    function d(t) {
      if (!o(t, 'string')) throw new Error('received invalid input');
      for (var e = A, r = e.parser[e.strictMode ? 'strict' : 'loose'].exec(t), n = {}, i = e.key.length; i--;) {
        n[e.key[i]] = r[i] || '';
      }return n[e.q.name] = {}, n[e.key[12]].replace(e.q.parser, function (t, r, o) {
        r && (n[e.q.name][r] = o);
      }), n;
    }
    function m(t, e, r) {
      ;r = r || {}, r.access_token = t;
      var n,
          o = [];
      for (n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && o.push([n, r[n]].join('='));
      }var i = '?' + o.sort().join('&');e = e || {}, e.path = e.path || '';
      var a,
          s = e.path.indexOf('?'),
          u = e.path.indexOf('#');
      s !== -1 && (u === -1 || u > s) ? (a = e.path, e.path = a.substring(0, s) + i + '&' + a.substring(s + 1)) : u !== -1 ? (a = e.path, e.path = a.substring(0, u) + i + a.substring(u)) : e.path = e.path + i;
    }
    function g(t, e) {
      if (e = e || t.protocol, !e && t.port && (80 === t.port ? e = 'http:' : 443 === t.port && (e = 'https:')), e = e || 'https:', !t.hostname) return null;
      var r = e + '//' + t.hostname;
      return t.port && (r = r + ':' + t.port), t.path && (r += t.path), r;
    }
    function v(t, e) {
      var r, n;
      try {
        r = L.stringify(t);
      } catch (o) {
        if (e && a(e)) try {
          r = e(t);
        } catch (t) {
          n = t;
        } else n = o;
      }
      return { error: n, value: r };
    }
    function y(t) {
      var e, r;
      try {
        e = L.parse(t);
      } catch (t) {
        r = t;
      }
      return { error: r, value: e };
    }
    function b(t, e, r, n, o, i, a, s) {
      var u = { url: e || '', line: r, column: n };u.func = s.guessFunctionName(u.url, u.line), u.context = s.gatherContext(u.url, u.line);
      var c = document && document.location && document.location.href,
          l = window && window.navigator && window.navigator.userAgent;
      return {
        mode: i,
        message: o ? String(o) : t || a,
        url: c,
        stack: [u],
        useragent: l
      };
    }
    function w(t, e) {
      return function (r, n) {
        try {
          e(r, n);
        } catch (e) {
          t.error(e);
        }
      };
    }
    function _(t, e, r, n) {
      for (var o, a, s, u, c, l, p = [], h = 0, d = t.length; h < d; ++h) {
        l = t[h];
        var m = i(l);
        switch (m) {
          case 'undefined':
            break;
          case 'string':
            o ? p.push(l) : o = l;
            break;
          case 'function':
            u = w(e, l);
            break;
          case 'date':
            p.push(l);
            break;
          case 'error':
          case 'domexception':
            a ? p.push(l) : a = l;
            break;
          case 'object':
          case 'array':
            if (l instanceof Error || 'undefined' != typeof DOMException && l instanceof DOMException) {
              a ? p.push(l) : a = l;
              break;
            }
            if (n && 'object' === m && !c) {
              for (var g = 0, v = n.length; g < v; ++g) {
                if (void 0 !== l[n[g]]) {
                  c = l;
                  break;
                }
              }if (c) break;
            }
            s ? p.push(l) : s = l;
            break;
          default:
            if (l instanceof Error || 'undefined' != typeof DOMException && l instanceof DOMException) {
              a ? p.push(l) : a = l;
              break;
            }
            p.push(l);
        }
      }
      p.length > 0 && (s = N(!0, {}, s), s.extraArgs = p);
      var y = {
        message: o,
        err: a,
        custom: s,
        timestamp: O(),
        callback: u,
        uuid: f()
      };
      return s && void 0 !== s.level && (y.level = s.level, delete s.level), n && c && (y.request = c), y._originalArgs = t, y;
    }
    function x(t, e) {
      if (t) {
        var r = e.split('.'),
            n = t;
        try {
          for (var o = 0, i = r.length; o < i; ++o) {
            n = n[r[o]];
          }
        } catch (t) {
          n = void 0;
        }
        return n;
      }
    }
    function k(t, e, r) {
      if (t) {
        var n = e.split('.'),
            o = n.length;
        if (!(o < 1)) {
          if (1 === o) return void (t[n[0]] = r);
          try {
            for (var i = t[n[0]] || {}, a = i, s = 1; s < o - 1; s++) {
              i[n[s]] = i[n[s]] || {}, i = i[n[s]];
            }i[n[o - 1]] = r, t[n[0]] = a;
          } catch (t) {
            return;
          }
        }
      }
    }
    function E(t, e) {
      function r(t, e, r, n, o, i) {
        return e + p(i);
      }
      function n(t) {
        var e;
        if (o(t, 'string')) for (e = 0; e < u.length; ++e) {
          t = t.replace(u[e], r);
        }return t;
      }
      function i(t, e) {
        var r;
        for (r = 0; r < s.length; ++r) {
          if (s[r].test(t)) {
            e = p(e);
            break;
          }
        }return e;
      }
      function a(t, e, r) {
        var s = i(t, e);
        return s === e ? o(e, 'object') || o(e, 'array') ? l(e, a, r) : n(s) : s;
      }
      e = e || [];
      var s = I(e),
          u = T(e);
      return l(t, a, []), t;
    }
    function I(t) {
      for (var e, r = [], n = 0; n < t.length; ++n) {
        e = '\\[?(%5[bB])?' + t[n] + '\\[?(%5[bB])?\\]?(%5[dD])?', r.push(new RegExp(e, 'i'));
      }return r;
    }
    function T(t) {
      for (var e, r = [], n = 0; n < t.length; ++n) {
        e = '\\[?(%5[bB])?' + t[n] + '\\[?(%5[bB])?\\]?(%5[dD])?', r.push(new RegExp('(' + e + '=)([^&\\n]+)', 'igm'));
      }return r;
    }
    function S(t) {
      var e,
          r,
          n,
          o = [];
      for (e = 0, r = t.length; e < r; e++) {
        n = t[e], 'object' == (typeof n === 'undefined' ? 'undefined' : (0, _typeof3.default)(n)) ? (n = v(n), n = n.error || n.value, n.length > 500 && (n = n.substr(0, 500) + '...')) : 'undefined' == typeof n && (n = 'undefined'), o.push(n);
      }return o.join(' ');
    }
    function O() {
      return Date.now ? Date.now() : +new Date();
    }
    var N = r(7),
        L = {},
        C = !1;
    n();
    var j = { debug: 0, info: 1, warning: 2, error: 3, critical: 4 },
        A = {
      strictMode: !1,
      key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
      q: { name: 'queryKey', parser: /(?:^|&)([^&=]*)=?([^&]*)/g },
      parser: {
        strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
        loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
      }
    };
    t.exports = {
      isType: o,
      typeName: i,
      isFunction: a,
      isIterable: u,
      isError: c,
      extend: N,
      traverse: l,
      redact: p,
      uuid4: f,
      LEVELS: j,
      sanitizeUrl: h,
      addParamsAndAccessTokenToPath: m,
      formatUrl: g,
      stringify: v,
      jsonParse: y,
      makeUnhandledStackInfo: b,
      createItem: _,
      get: x,
      set: k,
      scrub: E,
      formatArgsAsString: S,
      now: O
    };
  }, function (t, e) {
    'use strict';

    var r = Object.prototype.hasOwnProperty,
        n = Object.prototype.toString,
        o = function o(t) {
      return 'function' == typeof Array.isArray ? Array.isArray(t) : '[object Array]' === n.call(t);
    },
        i = function i(t) {
      if (!t || '[object Object]' !== n.call(t)) return !1;
      var e = r.call(t, 'constructor'),
          o = t.constructor && t.constructor.prototype && r.call(t.constructor.prototype, 'isPrototypeOf');
      if (t.constructor && !e && !o) return !1;
      var i;
      for (i in t) {}
      return 'undefined' == typeof i || r.call(t, i);
    };
    t.exports = function t() {
      var e,
          r,
          n,
          a,
          s,
          u,
          c = arguments[0],
          l = 1,
          p = arguments.length,
          f = !1;
      for ('boolean' == typeof c ? (f = c, c = arguments[1] || {}, l = 2) : ('object' != (typeof c === 'undefined' ? 'undefined' : (0, _typeof3.default)(c)) && 'function' != typeof c || null == c) && (c = {}); l < p; ++l) {
        if (e = arguments[l], null != e) for (r in e) {
          n = c[r], a = e[r], c !== a && (f && a && (i(a) || (s = o(a))) ? (s ? (s = !1, u = n && o(n) ? n : []) : u = n && i(n) ? n : {}, c[r] = t(f, u, a)) : 'undefined' != typeof a && (c[r] = a));
        }
      }return c;
    };
  }, function (t, e) {
    var r = function r(t) {
      function e(t) {
        return t < 10 ? '0' + t : t;
      }
      function r() {
        return this.valueOf();
      }
      function n(t) {
        return i.lastIndex = 0, i.test(t) ? '"' + t.replace(i, function (t) {
          var e = u[t];
          return 'string' == typeof e ? e : '\\u' + ('0000' + t.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + t + '"';
      }
      function o(t, e) {
        var r,
            i,
            u,
            l,
            p,
            f = a,
            h = e[t];
        switch (h && 'object' == (typeof h === 'undefined' ? 'undefined' : (0, _typeof3.default)(h)) && 'function' == typeof h.toJSON && (h = h.toJSON(t)), 'function' == typeof c && (h = c.call(e, t, h)), typeof h === 'undefined' ? 'undefined' : (0, _typeof3.default)(h)) {
          case 'string':
            return n(h);
          case 'number':
            return isFinite(h) ? String(h) : 'null';
          case 'boolean':
          case 'null':
            return String(h);
          case 'object':
            if (!h) return 'null';
            if (a += s, p = [], '[object Array]' === Object.prototype.toString.apply(h)) {
              for (l = h.length, r = 0; r < l; r += 1) {
                p[r] = o(r, h) || 'null';
              }return u = 0 === p.length ? '[]' : a ? '[\n' + a + p.join(',\n' + a) + '\n' + f + ']' : '[' + p.join(',') + ']', a = f, u;
            }
            if (c && 'object' == (typeof c === 'undefined' ? 'undefined' : (0, _typeof3.default)(c))) for (l = c.length, r = 0; r < l; r += 1) {
              'string' == typeof c[r] && (i = c[r], u = o(i, h), u && p.push(n(i) + (a ? ': ' : ':') + u));
            } else for (i in h) {
              Object.prototype.hasOwnProperty.call(h, i) && (u = o(i, h), u && p.push(n(i) + (a ? ': ' : ':') + u));
            }return u = 0 === p.length ? '{}' : a ? '{\n' + a + p.join(',\n' + a) + '\n' + f + '}' : '{' + p.join(',') + '}', a = f, u;
        }
      }
      var i = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
      'function' != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + '-' + e(this.getUTCMonth() + 1) + '-' + e(this.getUTCDate()) + 'T' + e(this.getUTCHours()) + ':' + e(this.getUTCMinutes()) + ':' + e(this.getUTCSeconds()) + 'Z' : null;
      }, Boolean.prototype.toJSON = r, Number.prototype.toJSON = r, String.prototype.toJSON = r);
      var a, s, u, c;
      'function' != typeof t.stringify && (u = {
        '\b': '\\b',
        '\t': '\\t',
        '\n': '\\n',
        '\f': '\\f',
        '\r': '\\r',
        '"': '\\"',
        '\\': '\\\\'
      }, t.stringify = function (t, e, r) {
        var n;
        if (a = '', s = '', 'number' == typeof r) for (n = 0; n < r; n += 1) {
          s += ' ';
        } else 'string' == typeof r && (s = r);
        if (c = e, e && 'function' != typeof e && ('object' != (typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e)) || 'number' != typeof e.length)) throw new Error('JSON.stringify');
        return o('', { '': t });
      }), 'function' != typeof t.parse && (t.parse = function () {
        function t(t) {
          return t.replace(/\\(?:u(.{4})|([^u]))/g, function (t, e, r) {
            return e ? String.fromCharCode(parseInt(e, 16)) : a[r];
          });
        }
        var e,
            r,
            n,
            o,
            i,
            a = {
          '\\': '\\',
          '"': '"',
          '/': '/',
          t: '\t',
          n: '\n',
          r: '\r',
          f: '\f',
          b: '\b'
        },
            s = {
          go: function go() {
            e = 'ok';
          },
          firstokey: function firstokey() {
            ;o = i, e = 'colon';
          },
          okey: function okey() {
            ;o = i, e = 'colon';
          },
          ovalue: function ovalue() {
            e = 'ocomma';
          },
          firstavalue: function firstavalue() {
            e = 'acomma';
          },
          avalue: function avalue() {
            e = 'acomma';
          }
        },
            u = {
          go: function go() {
            e = 'ok';
          },
          ovalue: function ovalue() {
            e = 'ocomma';
          },
          firstavalue: function firstavalue() {
            e = 'acomma';
          },
          avalue: function avalue() {
            e = 'acomma';
          }
        },
            c = {
          '{': {
            go: function go() {
              r.push({ state: 'ok' }), n = {}, e = 'firstokey';
            },
            ovalue: function ovalue() {
              r.push({ container: n, state: 'ocomma', key: o }), n = {}, e = 'firstokey';
            },
            firstavalue: function firstavalue() {
              r.push({ container: n, state: 'acomma' }), n = {}, e = 'firstokey';
            },
            avalue: function avalue() {
              r.push({ container: n, state: 'acomma' }), n = {}, e = 'firstokey';
            }
          },
          '}': {
            firstokey: function firstokey() {
              var t = r.pop();i = n, n = t.container, o = t.key, e = t.state;
            },
            ocomma: function ocomma() {
              var t = r.pop();n[o] = i, i = n, n = t.container, o = t.key, e = t.state;
            }
          },
          '[': {
            go: function go() {
              r.push({ state: 'ok' }), n = [], e = 'firstavalue';
            },
            ovalue: function ovalue() {
              r.push({ container: n, state: 'ocomma', key: o }), n = [], e = 'firstavalue';
            },
            firstavalue: function firstavalue() {
              r.push({ container: n, state: 'acomma' }), n = [], e = 'firstavalue';
            },
            avalue: function avalue() {
              r.push({ container: n, state: 'acomma' }), n = [], e = 'firstavalue';
            }
          },
          ']': {
            firstavalue: function firstavalue() {
              var t = r.pop();i = n, n = t.container, o = t.key, e = t.state;
            },
            acomma: function acomma() {
              var t = r.pop();
              n.push(i), i = n, n = t.container, o = t.key, e = t.state;
            }
          },
          ':': {
            colon: function colon() {
              if (Object.hasOwnProperty.call(n, o)) throw new SyntaxError("Duplicate key '" + o + '"');
              e = 'ovalue';
            }
          },
          ',': {
            ocomma: function ocomma() {
              ;n[o] = i, e = 'okey';
            },
            acomma: function acomma() {
              n.push(i), e = 'avalue';
            }
          },
          true: {
            go: function go() {
              ;i = !0, e = 'ok';
            },
            ovalue: function ovalue() {
              ;i = !0, e = 'ocomma';
            },
            firstavalue: function firstavalue() {
              ;i = !0, e = 'acomma';
            },
            avalue: function avalue() {
              ;i = !0, e = 'acomma';
            }
          },
          false: {
            go: function go() {
              ;i = !1, e = 'ok';
            },
            ovalue: function ovalue() {
              ;i = !1, e = 'ocomma';
            },
            firstavalue: function firstavalue() {
              ;i = !1, e = 'acomma';
            },
            avalue: function avalue() {
              ;i = !1, e = 'acomma';
            }
          },
          null: {
            go: function go() {
              ;i = null, e = 'ok';
            },
            ovalue: function ovalue() {
              ;i = null, e = 'ocomma';
            },
            firstavalue: function firstavalue() {
              ;i = null, e = 'acomma';
            },
            avalue: function avalue() {
              ;i = null, e = 'acomma';
            }
          }
        };
        return function (n, o) {
          var a,
              l = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;e = 'go', r = [];
          try {
            for (;;) {
              if (a = l.exec(n), !a) break;
              a[1] ? c[a[1]][e]() : a[2] ? (i = +a[2], u[e]()) : (i = t(a[3]), s[e]()), n = n.slice(a[0].length);
            }
          } catch (t) {
            e = t;
          }
          if ('ok' !== e || /[^\u0020\t\n\r]/.test(n)) throw e instanceof SyntaxError ? e : new SyntaxError('JSON');
          return 'function' == typeof o ? function t(e, r) {
            var n,
                a,
                s = e[r];
            if (s && 'object' == (typeof s === 'undefined' ? 'undefined' : (0, _typeof3.default)(s))) for (n in i) {
              Object.prototype.hasOwnProperty.call(s, n) && (a = t(s, n), void 0 !== a ? s[n] = a : delete s[n]);
            }return o.call(e, r, s);
          }({ '': i }, '') : i;
        };
      }());
    };
    t.exports = r;
  }, function (t, e, r) {
    'use strict';

    function n(t, e) {
      ;this.queue = t, this.options = e, this.transforms = [];
    }
    var o = r(6);n.prototype.configure = function (t) {
      this.queue && this.queue.configure(t);
      var e = this.options;
      return this.options = o.extend(!0, {}, e, t), this;
    }, n.prototype.addTransform = function (t) {
      return o.isFunction(t) && this.transforms.push(t), this;
    }, n.prototype.log = function (t, e) {
      if (e && o.isFunction(e) || (e = function e() {}), !this.options.enabled) return e(new Error('Rollbar is not enabled'));
      var r = t.err;
      this._applyTransforms(t, function (t, n) {
        return t ? e(t, null) : void this.queue.addItem(n, e, r);
      }.bind(this));
    }, n.prototype._applyTransforms = function (t, e) {
      var r = -1,
          n = this.transforms.length,
          o = this.transforms,
          i = this.options,
          a = function a(t, s) {
        return t ? void e(t, null) : (r++, r === n ? void e(null, s) : void o[r](s, i, a));
      };
      a(null, t);
    }, t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n(t) {
      ;this.queue = [], this.options = i.extend(!0, {}, t);
      var e = this.options.maxTelemetryEvents || a;
      this.maxQueueSize = Math.max(0, Math.min(e, a));
    }
    function o(t, e) {
      if (e) return e;
      var r = { error: 'error', manual: 'info' };
      return r[t] || 'info';
    }
    var i = r(6),
        a = 100;n.prototype.copyEvents = function () {
      return Array.prototype.slice.call(this.queue, 0);
    }, n.prototype.capture = function (t, e, r, n, a) {
      var s = {
        level: o(t, r),
        type: t,
        timestamp_ms: a || i.now(),
        body: e,
        source: 'client'
      };
      return n && (s.uuid = n), this.push(s), s;
    }, n.prototype.captureEvent = function (t, e, r) {
      return this.capture('manual', t, e, r);
    }, n.prototype.captureError = function (t, e, r, n) {
      var o = { message: t.message || String(t) };
      return t.stack && (o.stack = t.stack), this.capture('error', o, e, r, n);
    }, n.prototype.captureLog = function (t, e, r, n) {
      return this.capture('log', { message: t }, e, r, n);
    }, n.prototype.captureNetwork = function (t, e, r) {
      ;e = e || 'xhr', t.subtype = t.subtype || e;
      var n = this.levelFromStatus(t.status_code);
      return this.capture('network', t, n, r);
    }, n.prototype.levelFromStatus = function (t) {
      return t >= 200 && t < 400 ? 'info' : 0 === t || t >= 400 ? 'error' : 'info';
    }, n.prototype.captureDom = function (t, e, r, n, o) {
      var i = { subtype: t, element: e };
      return void 0 !== r && (i.value = r), void 0 !== n && (i.checked = n), this.capture('dom', i, 'info', o);
    }, n.prototype.captureNavigation = function (t, e, r) {
      return this.capture('navigation', { from: t, to: e }, 'info', r);
    }, n.prototype.captureDomContentLoaded = function (t) {
      return this.capture('navigation', { subtype: 'DOMContentLoaded' }, 'info', void 0, t && t.getTime());
    }, n.prototype.captureLoad = function (t) {
      return this.capture('navigation', { subtype: 'load' }, 'info', void 0, t && t.getTime());
    }, n.prototype.captureConnectivityChange = function (t, e) {
      return this.captureNetwork({ change: t }, 'connectivity', e);
    }, n.prototype._captureRollbarItem = function (t) {
      return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture('log', t.custom, t.level, t.uuid, t.timestamp) : void 0;
    }, n.prototype.push = function (t) {
      this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
    }, t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r, n) {
      ;this.options = t, this.transport = e, this.url = r, this.jsonBackup = n, this.accessToken = t.accessToken, this.transportOptions = o(t, r);
    }
    function o(t, e) {
      return a.getTransportFromOptions(t, s, e);
    }
    var i = r(6),
        a = r(12),
        s = {
      hostname: 'api.rollbar.com',
      path: '/api/1',
      search: null,
      version: '1',
      protocol: 'https:',
      port: 443
    };n.prototype.postItem = function (t, e) {
      var r = a.transportOptions(this.transportOptions, '/item/', 'POST'),
          n = a.buildPayload(this.accessToken, t, this.jsonBackup);
      this.transport.post(this.accessToken, r, n, e);
    }, n.prototype.configure = function (t) {
      var e = this.oldOptions;
      return this.options = i.extend(!0, {}, e, t), this.transportOptions = o(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
    }, t.exports = n;
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r) {
      if (s.isType(e.context, 'object')) {
        var n = s.stringify(e.context, r);
        n.error ? e.context = "Error: could not serialize 'context'" : e.context = n.value || '', e.context.length > 255 && (e.context = e.context.substr(0, 255));
      }
      return { access_token: t, data: e };
    }
    function o(t, e, r) {
      var n = e.hostname,
          o = e.protocol,
          i = e.port,
          a = e.path,
          s = e.search,
          u = t.proxy;
      if (t.endpoint) {
        var c = r.parse(t.endpoint);n = c.hostname, o = c.protocol, i = c.port, a = c.pathname, s = c.search;
      }
      return {
        hostname: n,
        protocol: o,
        port: i,
        path: a,
        search: s,
        proxy: u
      };
    }
    function i(t, e, r) {
      var n = t.protocol || 'https:',
          o = t.port || ('http:' === n ? 80 : 'https:' === n ? 443 : void 0),
          i = t.hostname;
      return e = a(t.path, e), t.search && (e += t.search), t.proxy && (e = n + '//' + i + e, i = t.proxy.host || t.proxy.hostname, o = t.proxy.port, n = t.proxy.protocol || n), { protocol: n, hostname: i, path: e, port: o, method: r };
    }
    function a(t, e) {
      var r = /\/$/.test(t),
          n = /^\//.test(e);
      return r && n ? e = e.substring(1) : r || n || (e = '/' + e), t + e;
    }
    var s = r(6);
    t.exports = {
      buildPayload: n,
      getTransportFromOptions: o,
      transportOptions: i,
      appendPathToPath: a
    };
  }, function (t, e, r) {
    'use strict';

    function n() {
      var t = Array.prototype.slice.call(arguments, 0);
      t.unshift('Rollbar:'), a.ieVersion() <= 8 ? console.error(s.formatArgsAsString(t)) : console.error.apply(console, t);
    }
    function o() {
      var t = Array.prototype.slice.call(arguments, 0);
      t.unshift('Rollbar:'), a.ieVersion() <= 8 ? console.info(s.formatArgsAsString(t)) : console.info.apply(console, t);
    }
    function i() {
      var t = Array.prototype.slice.call(arguments, 0);
      t.unshift('Rollbar:'), a.ieVersion() <= 8 ? console.log(s.formatArgsAsString(t)) : console.log.apply(console, t);
    }
    r(14);
    var a = r(15),
        s = r(6);
    t.exports = { error: n, info: o, log: i };
  }, function (t, e) {
    !function (t) {
      'use strict';

      t.console || (t.console = {});
      for (var e, r, n = t.console, o = function o() {}, i = ['memory'], a = 'assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn'.split(','); e = i.pop();) {
        n[e] || (n[e] = {});
      }for (; r = a.pop();) {
        n[r] || (n[r] = o);
      }
    }('undefined' == typeof window ? this : window);
  }, function (t, e) {
    'use strict';

    function r() {
      var t;
      if (!document) return t;
      for (var e = 3, r = document.createElement('div'), n = r.getElementsByTagName('i'); r.innerHTML = '<!--[if gt IE ' + ++e + ']><i></i><![endif]-->', n[0];) {}
      return e > 4 ? e : t;
    }
    var n = { ieVersion: r };
    t.exports = n;
  }, function (t, e) {
    'use strict';

    function r(t, e, r) {
      if (t) {
        var o;
        'function' == typeof e._rollbarOldOnError ? o = e._rollbarOldOnError : t.onerror && !t.onerror.belongsToShim && (o = t.onerror, e._rollbarOldOnError = o);
        var i = function i() {
          var r = Array.prototype.slice.call(arguments, 0);
          n(t, e, o, r);
        };i.belongsToShim = r, t.onerror = i;
      }
    }
    function n(t, e, r, n) {
      t._rollbarWrappedError && (n[4] || (n[4] = t._rollbarWrappedError), n[5] || (n[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null), e.handleUncaughtException.apply(e, n), r && r.apply(t, n);
    }
    function o(t, e, r) {
      if (t) {
        'function' == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener('unhandledrejection', t._rollbarURH);
        var n = function n(t) {
          var r = t.reason,
              n = t.promise,
              o = t.detail;
          !r && o && (r = o.reason, n = o.promise), e && e.handleUnhandledRejection && e.handleUnhandledRejection(r, n);
        };n.belongsToShim = r, t._rollbarURH = n, t.addEventListener('unhandledrejection', n);
      }
    }
    function i(t, e, r) {
      if (t) {
        var n,
            o,
            i = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
        for (n = 0; n < i.length; ++n) {
          o = i[n], t[o] && t[o].prototype && a(e, t[o].prototype, r);
        }
      }
    }
    function a(t, e, r) {
      if (e.hasOwnProperty && e.hasOwnProperty('addEventListener')) {
        for (var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;) {
          n = n._rollbarOldAdd;
        }var o = function o(e, r, _o) {
          n.call(this, e, t.wrap(r), _o);
        };o._rollbarOldAdd = n, o.belongsToShim = r, e.addEventListener = o;
        for (var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;) {
          i = i._rollbarOldRemove;
        }var a = function a(t, e, r) {
          i.call(this, t, e && e._rollbar_wrapped || e, r);
        };a._rollbarOldRemove = i, a.belongsToShim = r, e.removeEventListener = a;
      }
    }
    t.exports = {
      captureUncaughtExceptions: r,
      captureUnhandledRejections: o,
      wrapGlobals: i
    };
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r, n, o) {
      ;n && l.isFunction(n) || (n = function n() {}), l.addParamsAndAccessTokenToPath(t, e, r);
      var a = 'GET',
          s = l.formatUrl(e);
      i(t, s, a, null, n, o);
    }
    function o(t, e, r, n, o) {
      if (n && l.isFunction(n) || (n = function n() {}), !r) return n(new Error('Cannot send empty request'));
      var a = l.stringify(r);
      if (a.error) return n(a.error);
      var s = a.value,
          u = 'POST',
          c = l.formatUrl(e);
      i(t, c, u, s, n, o);
    }
    function i(t, e, r, n, o, i) {
      var f;
      if (f = i ? i() : a(), !f) return o(new Error('No way to send a request'));
      try {
        try {
          var _h = function h() {
            try {
              if (_h && 4 === f.readyState) {
                _h = void 0;
                var t = l.jsonParse(f.responseText);
                if (s(f)) return void o(t.error, t.value);
                if (u(f)) {
                  if (403 === f.status) {
                    var e = t.value && t.value.message;
                    p.error(e);
                  }
                  o(new Error(String(f.status)));
                } else {
                  var r = 'XHR response had no status code (likely connection failure)';
                  o(c(r));
                }
              }
            } catch (t) {
              var n;n = t && t.stack ? t : new Error(t), o(n);
            }
          };
          f.open(r, e, !0), f.setRequestHeader && (f.setRequestHeader('Content-Type', 'application/json'), f.setRequestHeader('X-Rollbar-Access-Token', t)), f.onreadystatechange = _h, f.send(n);
        } catch (t) {
          if ('undefined' != typeof XDomainRequest) {
            if (!window || !window.location) return o(new Error('No window available during request, unknown environment'));
            'http:' === window.location.href.substring(0, 5) && 'https' === e.substring(0, 5) && (e = 'http' + e.substring(5));
            var d = new XDomainRequest();d.onprogress = function () {}, d.ontimeout = function () {
              var t = 'Request timed out',
                  e = 'ETIMEDOUT';
              o(c(t, e));
            }, d.onerror = function () {
              o(new Error('Error during request'));
            }, d.onload = function () {
              var t = l.jsonParse(d.responseText);
              o(t.error, t.value);
            }, d.open(r, e, !0), d.send(n);
          } else o(new Error('Cannot find a method to transport a request'));
        }
      } catch (t) {
        o(t);
      }
    }
    function a() {
      var t,
          e,
          r = [function () {
        return new XMLHttpRequest();
      }, function () {
        return new ActiveXObject('Msxml2.XMLHTTP');
      }, function () {
        return new ActiveXObject('Msxml3.XMLHTTP');
      }, function () {
        return new ActiveXObject('Microsoft.XMLHTTP');
      }],
          n = r.length;
      for (e = 0; e < n; e++) {
        try {
          t = r[e]();
          break;
        } catch (t) {}
      }return t;
    }
    function s(t) {
      return t && t.status && 200 === t.status;
    }
    function u(t) {
      return t && l.isType(t.status, 'number') && t.status >= 400 && t.status < 600;
    }
    function c(t, e) {
      var r = new Error(t);
      return r.code = e || 'ENOTFOUND', r;
    }
    var l = r(6),
        p = r(13);
    t.exports = { get: n, post: o };
  }, function (t, e) {
    'use strict';

    function r(t) {
      var e,
          r,
          n = {
        protocol: null,
        auth: null,
        host: null,
        path: null,
        hash: null,
        href: t,
        hostname: null,
        port: null,
        pathname: null,
        search: null,
        query: null
      };
      if (e = t.indexOf('//'), e !== -1 ? (n.protocol = t.substring(0, e), r = e + 2) : r = 0, e = t.indexOf('@', r), e !== -1 && (n.auth = t.substring(r, e), r = e + 1), e = t.indexOf('/', r), e === -1) {
        if (e = t.indexOf('?', r), e === -1) return e = t.indexOf('#', r), e === -1 ? n.host = t.substring(r) : (n.host = t.substring(r, e), n.hash = t.substring(e)), n.hostname = n.host.split(':')[0], n.port = n.host.split(':')[1], n.port && (n.port = parseInt(n.port, 10)), n;n.host = t.substring(r, e), n.hostname = n.host.split(':')[0], n.port = n.host.split(':')[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
      } else n.host = t.substring(r, e), n.hostname = n.host.split(':')[0], n.port = n.host.split(':')[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
      if (e = t.indexOf('#', r), e === -1 ? n.path = t.substring(r) : (n.path = t.substring(r, e), n.hash = t.substring(e)), n.path) {
        var o = n.path.split('?');n.pathname = o[0], n.query = o[1], n.search = n.query ? '?' + n.query : null;
      }
      return n;
    }
    t.exports = { parse: r };
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r) {
      if (t.data = t.data || {}, t.err) try {
        t.stackInfo = t.err._savedStackTrace || m.parse(t.err);
      } catch (e) {
        g.error('Error while parsing the error object.', e), t.message = t.err.message || t.err.description || t.message || String(t.err), delete t.err;
      }
      r(null, t);
    }
    function o(t, e, r) {
      t.message || t.stackInfo || t.custom || r(new Error('No message, stack info, or custom data'), null), r(null, t);
    }
    function i(t, e, r) {
      var n = e.payload && e.payload.environment || e.environment;t.data = d.extend(!0, {}, t.data, {
        environment: n,
        level: t.level,
        endpoint: e.endpoint,
        platform: 'browser',
        framework: 'browser-js',
        language: 'javascript',
        server: {},
        uuid: t.uuid,
        notifier: { name: 'rollbar-browser-js', version: e.version }
      }), r(null, t);
    }
    function a(t) {
      return function (e, r, n) {
        return t && t.location ? (d.set(e, 'data.request', {
          url: t.location.href,
          query_string: t.location.search,
          user_ip: '$remote_ip'
        }), void n(null, e)) : n(null, e);
      };
    }
    function s(t) {
      return function (e, r, n) {
        return t ? (d.set(e, 'data.client', {
          runtime_ms: e.timestamp - t._rollbarStartTime,
          timestamp: Math.round(e.timestamp / 1e3),
          javascript: {
            browser: t.navigator.userAgent,
            language: t.navigator.language,
            cookie_enabled: t.navigator.cookieEnabled,
            screen: { width: t.screen.width, height: t.screen.height }
          }
        }), void n(null, e)) : n(null, e);
      };
    }
    function u(t) {
      return function (e, r, n) {
        if (!t || !t.navigator) return n(null, e);
        for (var o, i = [], a = t.navigator.plugins || [], s = 0, u = a.length; s < u; ++s) {
          o = a[s], i.push({ name: o.name, description: o.description });
        }d.set(e, 'data.client.javascript.plugins', i), n(null, e);
      };
    }
    function c(t, e, r) {
      t.stackInfo ? p(t, e, r) : l(t, e, r);
    }
    function l(t, e, r) {
      var n = t.message,
          o = t.custom;
      if (!n) if (o) {
        var i = e.scrubFields,
            a = d.stringify(d.scrub(o, i));
        n = a.error || a.value || '';
      } else n = '';
      var s = { body: n };
      o && (s.extra = d.extend(!0, {}, o)), d.set(t, 'data.body', { message: s }), r(null, t);
    }
    function p(t, e, r) {
      var n = t.data.description,
          o = t.stackInfo,
          i = t.custom,
          a = m.guessErrorClass(o.message),
          s = o.name || a[0],
          u = a[1],
          c = { exception: { class: s, message: u } };
      n && (c.exception.description = n);
      var p = o.stack;
      if (p && 0 === p.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (p = t._unhandledStackInfo.stack), p) {
        var f, h, g, v, y, b, w, _;
        for (c.frames = [], w = 0; w < p.length; ++w) {
          f = p[w], h = {
            filename: f.url ? d.sanitizeUrl(f.url) : '(unknown)',
            lineno: f.line || null,
            method: f.func && '?' !== f.func ? f.func : '[anonymous]',
            colno: f.column
          }, h.method && h.method.endsWith && h.method.endsWith('._rollbar_wrapped') || (g = v = y = null, b = f.context ? f.context.length : 0, b && (_ = Math.floor(b / 2), v = f.context.slice(0, _), g = f.context[_], y = f.context.slice(_)), g && (h.code = g), (v || y) && (h.context = {}, v && v.length && (h.context.pre = v), y && y.length && (h.context.post = y)), f.args && (h.args = f.args), c.frames.push(h));
        }c.frames.reverse(), i && (c.extra = d.extend(!0, {}, i)), d.set(t, 'data.body', { trace: c }), r(null, t);
      } else t.message = s + ': ' + u, l(t, e, r);
    }
    function f(t, e, r) {
      var n = e.scrubFields;
      d.scrub(t.data, n), r(null, t);
    }
    function h(t, e, r) {
      var n = d.extend(!0, {}, t);
      try {
        d.isFunction(e.transform) && e.transform(n.data);
      } catch (n) {
        return e.transform = null, g.error('Error while calling custom transform() function. Removing custom transform().', n), void r(null, t);
      }
      r(null, n);
    }
    var d = r(6),
        m = r(20),
        g = r(13);
    t.exports = {
      handleItemWithError: n,
      ensureItemHasSomethingToSay: o,
      addBaseInfo: i,
      addRequestInfo: a,
      addClientInfo: s,
      addPluginInfo: u,
      addBody: c,
      scrubPayload: f,
      userTransform: h
    };
  }, function (t, e, r) {
    'use strict';

    function n() {
      return l;
    }
    function o() {
      return null;
    }
    function i(t) {
      var e = {};
      return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = o(e.url, e.line), e;
    }
    function a(t) {
      function e() {
        var e = [];
        try {
          e = c.parse(t);
        } catch (t) {
          e = [];
        }
        for (var r = [], n = 0; n < e.length; n++) {
          r.push(new i(e[n]));
        }return r;
      }
      return { stack: e(), message: t.message, name: t.name };
    }
    function s(t) {
      return new a(t);
    }
    function u(t) {
      if (!t) return ['Unknown error. There was no error message to display.', ''];
      var e = t.match(p),
          r = '(unknown)';
      return e && (r = e[e.length - 1], t = t.replace((e[e.length - 2] || '') + r + ':', ''), t = t.replace(/(^[\s]+|[\s]+$)/g, '')), [r, t];
    }
    var c = r(21),
        l = '?',
        p = new RegExp('^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ');
    t.exports = {
      guessFunctionName: n,
      guessErrorClass: u,
      gatherContext: o,
      parse: s,
      Stack: a,
      Frame: i
    };
  }, function (t, e, r) {
    var n, o, i;
    !function (a, s) {
      'use strict';
      o = [r(22)], n = s, i = 'function' == typeof n ? n.apply(e, o) : n, !(void 0 !== i && (t.exports = i));
    }(this, function (t) {
      'use strict';

      function e(t, e, r) {
        if ('function' == typeof Array.prototype.map) return t.map(e, r);
        for (var n = new Array(t.length), o = 0; o < t.length; o++) {
          n[o] = e.call(r, t[o]);
        }return n;
      }
      function r(t, e, r) {
        if ('function' == typeof Array.prototype.filter) return t.filter(e, r);
        for (var n = [], o = 0; o < t.length; o++) {
          e.call(r, t[o]) && n.push(t[o]);
        }return n;
      }
      var n = /(^|@)\S+\:\d+/,
          o = /^\s*at .*(\S+\:\d+|\(native\))/m,
          i = /^(eval@)?(\[native code\])?$/;
      return {
        parse: function parse(t) {
          if ('undefined' != typeof t.stacktrace || 'undefined' != typeof t['opera#sourceloc']) return this.parseOpera(t);
          if (t.stack && t.stack.match(o)) return this.parseV8OrIE(t);
          if (t.stack) return this.parseFFOrSafari(t);
          throw new Error('Cannot parse given Error object');
        },
        extractLocation: function extractLocation(t) {
          if (t.indexOf(':') === -1) return [t];
          var e = t.replace(/[\(\)\s]/g, '').split(':'),
              r = e.pop(),
              n = e[e.length - 1];
          if (!isNaN(parseFloat(n)) && isFinite(n)) {
            var o = e.pop();
            return [e.join(':'), o, r];
          }
          return [e.join(':'), r, void 0];
        },
        parseV8OrIE: function parseV8OrIE(n) {
          var i = r(n.stack.split('\n'), function (t) {
            return !!t.match(o);
          }, this);
          return e(i, function (e) {
            e.indexOf('(eval ') > -1 && (e = e.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, ''));
            var r = e.replace(/^\s+/, '').replace(/\(eval code/g, '(').split(/\s+/).slice(1),
                n = this.extractLocation(r.pop()),
                o = r.join(' ') || void 0,
                i = 'eval' === n[0] ? void 0 : n[0];
            return new t(o, void 0, i, n[1], n[2], e);
          }, this);
        },
        parseFFOrSafari: function parseFFOrSafari(n) {
          var o = r(n.stack.split('\n'), function (t) {
            return !t.match(i);
          }, this);
          return e(o, function (e) {
            if (e.indexOf(' > eval') > -1 && (e = e.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1')), e.indexOf('@') === -1 && e.indexOf(':') === -1) return new t(e);
            var r = e.split('@'),
                n = this.extractLocation(r.pop()),
                o = r.shift() || void 0;
            return new t(o, void 0, n[0], n[1], n[2], e);
          }, this);
        },
        parseOpera: function parseOpera(t) {
          return !t.stacktrace || t.message.indexOf('\n') > -1 && t.message.split('\n').length > t.stacktrace.split('\n').length ? this.parseOpera9(t) : t.stack ? this.parseOpera11(t) : this.parseOpera10(t);
        },
        parseOpera9: function parseOpera9(e) {
          for (var r = /Line (\d+).*script (?:in )?(\S+)/i, n = e.message.split('\n'), o = [], i = 2, a = n.length; i < a; i += 2) {
            var s = r.exec(n[i]);
            s && o.push(new t(void 0, void 0, s[2], s[1], void 0, n[i]));
          }
          return o;
        },
        parseOpera10: function parseOpera10(e) {
          for (var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = e.stacktrace.split('\n'), o = [], i = 0, a = n.length; i < a; i += 2) {
            var s = r.exec(n[i]);
            s && o.push(new t(s[3] || void 0, void 0, s[2], s[1], void 0, n[i]));
          }
          return o;
        },
        parseOpera11: function parseOpera11(o) {
          var i = r(o.stack.split('\n'), function (t) {
            return !!t.match(n) && !t.match(/^Error created at/);
          }, this);
          return e(i, function (e) {
            var r,
                n = e.split('@'),
                o = this.extractLocation(n.pop()),
                i = n.shift() || '',
                a = i.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || void 0;
            i.match(/\(([^\)]*)\)/) && (r = i.replace(/^[^\(]+\(([^\)]*)\)$/, '$1'));
            var s = void 0 === r || '[arguments not available]' === r ? void 0 : r.split(',');
            return new t(a, s, o[0], o[1], o[2], e);
          }, this);
        }
      };
    });
  }, function (t, e, r) {
    var n, o, i;
    !function (r, a) {
      'use strict';
      o = [], n = a, i = 'function' == typeof n ? n.apply(e, o) : n, !(void 0 !== i && (t.exports = i));
    }(this, function () {
      'use strict';

      function t(t) {
        return !isNaN(parseFloat(t)) && isFinite(t);
      }
      function e(t, e, r, n, o, i) {
        void 0 !== t && this.setFunctionName(t), void 0 !== e && this.setArgs(e), void 0 !== r && this.setFileName(r), void 0 !== n && this.setLineNumber(n), void 0 !== o && this.setColumnNumber(o), void 0 !== i && this.setSource(i);
      }
      return e.prototype = {
        getFunctionName: function getFunctionName() {
          return this.functionName;
        },
        setFunctionName: function setFunctionName(t) {
          this.functionName = String(t);
        },
        getArgs: function getArgs() {
          return this.args;
        },
        setArgs: function setArgs(t) {
          if ('[object Array]' !== Object.prototype.toString.call(t)) throw new TypeError('Args must be an Array');
          this.args = t;
        },
        getFileName: function getFileName() {
          return this.fileName;
        },
        setFileName: function setFileName(t) {
          this.fileName = String(t);
        },
        getLineNumber: function getLineNumber() {
          return this.lineNumber;
        },
        setLineNumber: function setLineNumber(e) {
          if (!t(e)) throw new TypeError('Line Number must be a Number');
          this.lineNumber = Number(e);
        },
        getColumnNumber: function getColumnNumber() {
          return this.columnNumber;
        },
        setColumnNumber: function setColumnNumber(e) {
          if (!t(e)) throw new TypeError('Column Number must be a Number');
          this.columnNumber = Number(e);
        },
        getSource: function getSource() {
          return this.source;
        },
        setSource: function setSource(t) {
          this.source = String(t);
        },
        toString: function toString() {
          var e = this.getFunctionName() || '{anonymous}',
              r = '(' + (this.getArgs() || []).join(',') + ')',
              n = this.getFileName() ? '@' + this.getFileName() : '',
              o = t(this.getLineNumber()) ? ':' + this.getLineNumber() : '',
              i = t(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
          return e + r + n + o + i;
        }
      }, e;
    });
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r) {
      var n = e.payload || {};
      n.body && delete n.body;
      var o = a.extend(!0, {}, t.data, n);
      t._isUncaught && (o._isUncaught = !0), r(null, o);
    }
    function o(t, e, r) {
      t.telemetryEvents && a.set(t, 'data.body.telemetry', t.telemetryEvents), r(null, t);
    }
    function i(t, e, r) {
      if (!t.message) return void r(null, t);
      var n = 'data.body.trace_chain.0',
          o = a.get(t, n);
      if (o || (n = 'data.body.trace', o = a.get(t, n)), o) {
        if (!o.exception || !o.exception.description) return a.set(t, n + '.exception.description', t.message), void r(null, t);
        var i = a.get(t, n + '.extra') || {},
            s = a.extend(!0, {}, i, { message: t.message });
        a.set(t, n + '.extra', s);
      }
      r(null, t);
    }
    var a = r(6);
    t.exports = {
      itemToPayload: n,
      addTelemetryData: o,
      addMessageWithError: i
    };
  }, function (t, e, r) {
    'use strict';

    function n(t, e) {
      var r = t.level,
          n = c.LEVELS[r] || 0,
          o = c.LEVELS[e.reportLevel] || 0;
      return !(n < o) && (!c.get(e, 'plugins.jquery.ignoreAjaxErrors') || !c.get(t, 'body.message.extra.isAjax'));
    }
    function o(t, e) {
      var r = !!t._isUncaught;
      delete t._isUncaught;
      var n = t._originalArgs;
      delete t._originalArgs;
      try {
        if (c.isFunction(e.checkIgnore) && e.checkIgnore(r, n, t)) return !1;
      } catch (t) {
        ;e.checkIgnore = null, l.error('Error while calling custom checkIgnore(), removing', t);
      }
      return !0;
    }
    function i(t, e) {
      return s(t, e, 'blacklist');
    }
    function a(t, e) {
      return s(t, e, 'whitelist');
    }
    function s(t, e, r) {
      var n = !1;
      'blacklist' === r && (n = !0);
      var o, i, a, s, u, p, f, h, d, m;
      try {
        if (o = n ? e.hostBlackList : e.hostWhiteList, f = o && o.length, i = c.get(t, 'body.trace'), !o || 0 === f) return !0;
        if (!i || !i.frames) return !0;
        for (u = i.frames.length, d = 0; d < u; d++) {
          if (a = i.frames[d], s = a.filename, !c.isType(s, 'string')) return !0;
          for (m = 0; m < f; m++) {
            if (p = o[m], h = new RegExp(p), h.test(s)) return !n;
          }
        }
      } catch (t) {
        n ? e.hostBlackList = null : e.hostWhiteList = null;
        var g = n ? 'hostBlackList' : 'hostWhiteList';
        return l.error("Error while reading your configuration's " + g + ' option. Removing custom ' + g + '.', t), !0;
      }
      return n;
    }
    function u(t, e) {
      var r, n, o, i, a, s, u, p, f;
      try {
        if (a = !1, o = e.ignoredMessages, !o || 0 === o.length) return !0;
        if (u = t.body, p = c.get(u, 'trace.exception.message'), f = c.get(u, 'message.body'), r = p || f, !r) return !0;
        for (i = o.length, n = 0; n < i && (s = new RegExp(o[n], 'gi'), !(a = s.test(r))); n++) {}
      } catch (t) {
        ;e.ignoredMessages = null, l.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
      }
      return !a;
    }
    var c = r(6),
        l = r(13);
    t.exports = {
      checkIgnore: n,
      userCheckIgnore: o,
      urlIsBlacklisted: i,
      urlIsWhitelisted: a,
      messageIsIgnored: u
    };
  }, function (t, e, r) {
    'use strict';

    function n(t, e, r, n) {
      var o = t[e];t[e] = r(o), n && n.push([t, e, o]);
    }
    function o(t) {
      for (var e; t.length;) {
        e = t.shift(), e[0][e[1]] = e[2];
      }
    }
    function i(t, e, r, n, o) {
      var i = t.autoInstrument;
      return i === !1 ? void (this.autoInstrument = {}) : (h.isType(i, 'object') || (i = m), this.autoInstrument = h.extend(!0, {}, m, i), this.telemeter = e, this.rollbar = r, this._window = n || {}, this._document = o || {}, this.replacements = [], this._location = this._window.location, void (this._lastHref = this._location && this._location.href));
    }
    function a(t) {
      return (t.getAttribute('type') || '').toLowerCase();
    }
    function s(t, e, r) {
      if (t.tagName.toLowerCase() !== e.toLowerCase()) return !1;
      if (!r) return !0;
      t = a(t);
      for (var n = 0; n < r.length; n++) {
        if (r[n] === t) return !0;
      }return !1;
    }
    function u(t, e) {
      return t.target ? t.target : e && e.elementFromPoint ? e.elementFromPoint(t.clientX, t.clientY) : void 0;
    }
    function c(t) {
      for (var e, r = 5, n = [], o = 0; t && o < r && (e = f(t), 'html' !== e.tagName); o++) {
        n.push(e), t = t.parentNode;
      }return n.reverse();
    }
    function l(t) {
      for (var e, r, n = 80, o = ' > ', i = o.length, a = [], s = 0, u = 0; u < t.length && (e = p(t[u]), r = s + a.length * i + e.length, !(u > 0 && r >= n)); u++) {
        a.push(e), s += e.length;
      }return a.join(o);
    }
    function p(t) {
      if (!t || !t.tagName) return '';
      var e = [t.tagName];
      t.id && e.push('#' + t.id), t.classes && e.push('.' + t.classes.join('.'));
      for (var r = 0; r < t.attributes.length; r++) {
        e.push('[' + t.attributes[r].key + '="' + t.attributes[r].value + '"]');
      }return e.join('');
    }
    function f(t) {
      if (!t || !t.tagName) return null;
      var e,
          r,
          n,
          o,
          i = {};i.tagName = t.tagName.toLowerCase(), t.id && (i.id = t.id), e = t.className, e && h.isType(e, 'string') && (i.classes = e.split(/\s+/));
      var a = ['type', 'name', 'title', 'alt'];
      for (i.attributes = [], o = 0; o < a.length; o++) {
        r = a[o], n = t.getAttribute(r), n && i.attributes.push({ key: r, value: n });
      }return i;
    }
    var h = r(6),
        d = r(18),
        m = { network: !0, log: !0, dom: !0, navigation: !0, connectivity: !0 };i.prototype.instrument = function () {
      this.autoInstrument.network && this.instrumentNetwork(), this.autoInstrument.log && this.instrumentConsole(), this.autoInstrument.dom && this.instrumentDom(), this.autoInstrument.navigation && this.instrumentNavigation(), this.autoInstrument.connectivity && this.instrumentConnectivity();
    }, i.prototype.instrumentNetwork = function () {
      function t(t, r) {
        t in r && h.isFunction(r[t]) && n(r, t, function (t) {
          return e.rollbar.wrap(t);
        }, e.replacements);
      }
      var e = this;
      if ('XMLHttpRequest' in this._window) {
        var r = this._window.XMLHttpRequest.prototype;
        n(r, 'open', function (t) {
          return function (e, r) {
            return h.isType(r, 'string') && (this.__rollbar_xhr = {
              method: e,
              url: r,
              status_code: null,
              start_time_ms: h.now(),
              end_time_ms: null
            }), t.apply(this, arguments);
          };
        }, this.replacements), n(r, 'send', function (r) {
          return function (o) {
            function i() {
              if (a.__rollbar_xhr && (1 === a.readyState || 4 === a.readyState)) {
                null === a.__rollbar_xhr.status_code && (a.__rollbar_xhr.status_code = 0, a.__rollbar_event = e.telemeter.captureNetwork(a.__rollbar_xhr, 'xhr')), 1 === a.readyState ? a.__rollbar_xhr.start_time_ms = h.now() : a.__rollbar_xhr.end_time_ms = h.now();
                try {
                  var t = a.status;t = 1223 === t ? 204 : t, a.__rollbar_xhr.status_code = t, a.__rollbar_event.level = e.telemeter.levelFromStatus(t);
                } catch (t) {}
              }
            }
            var a = this;
            return t('onload', a), t('onerror', a), t('onprogress', a), 'onreadystatechange' in a && h.isFunction(a.onreadystatechange) ? n(a, 'onreadystatechange', function (t) {
              return e.rollbar.wrap(t, void 0, i);
            }) : a.onreadystatechange = i, r.apply(this, arguments);
          };
        }, this.replacements);
      }
      'fetch' in this._window && n(this._window, 'fetch', function (t) {
        return function (r, n) {
          for (var o = new Array(arguments.length), i = 0, a = o.length; i < a; i++) {
            o[i] = arguments[i];
          }var s,
              u = o[0],
              c = 'GET';
          h.isType(u, 'string') ? s = u : (s = u.url, u.method && (c = u.method)), o[1] && o[1].method && (c = o[1].method);
          var l = {
            method: c,
            url: s,
            status_code: null,
            start_time_ms: h.now(),
            end_time_ms: null
          };
          return e.telemeter.captureNetwork(l, 'fetch'), t.apply(this, o).then(function (t) {
            return l.end_time_ms = h.now(), l.status_code = t.status, t;
          });
        };
      }, this.replacements);
    }, i.prototype.instrumentConsole = function () {
      function t(t) {
        var n = r[t],
            o = r,
            i = 'warn' === t ? 'warning' : t;
        r[t] = function () {
          var t = Array.prototype.slice.call(arguments),
              r = h.formatArgsAsString(t);
          e.telemeter.captureLog(r, i), n && Function.prototype.apply.call(n, o, t);
        };
      }
      if ('console' in this._window && this._window.console.log) for (var e = this, r = this._window.console, n = ['debug', 'info', 'warn', 'error', 'log'], o = 0, i = n.length; o < i; o++) {
        t(n[o]);
      }
    }, i.prototype.instrumentDom = function () {
      if ('addEventListener' in this._window || 'attachEvent' in this._window) {
        var t = this.handleClick.bind(this),
            e = this.handleBlur.bind(this);
        this._window.addEventListener ? (this._window.addEventListener('click', t, !0), this._window.addEventListener('blur', e, !0)) : (this._window.attachEvent('click', t), this._window.attachEvent('onfocusout', e));
      }
    }, i.prototype.handleClick = function (t) {
      try {
        var e = u(t, this._document),
            r = e && e.tagName,
            n = s(e, 'a') || s(e, 'button');
        r && (n || s(e, 'input', ['button', 'submit'])) ? this.captureDomEvent('click', e) : s(e, 'input', ['checkbox', 'radio']) && this.captureDomEvent('input', e, e.value, e.checked);
      } catch (t) {}
    }, i.prototype.handleBlur = function (t) {
      try {
        var e = u(t, this._document);
        e && e.tagName && (s(e, 'textarea') ? this.captureDomEvent('input', e, e.value) : s(e, 'select') && e.options && e.options.length ? this.handleSelectInputChanged(e) : s(e, 'input') && !s(e, 'input', ['button', 'submit', 'hidden', 'checkbox', 'radio']) && this.captureDomEvent('input', e, e.value));
      } catch (t) {}
    }, i.prototype.handleSelectInputChanged = function (t) {
      if (t.multiple) for (var e = 0; e < t.options.length; e++) {
        t.options[e].selected && this.captureDomEvent('input', t, t.options[e].value);
      } else t.selectedIndex >= 0 && t.options[t.selectedIndex] && this.captureDomEvent('input', t, t.options[t.selectedIndex].value);
    }, i.prototype.captureDomEvent = function (t, e, r, n) {
      'password' === a(e) && (r = void 0);
      var o = l(c(e));
      this.telemeter.captureDom(t, o, r, n);
    }, i.prototype.instrumentNavigation = function () {
      var t = this._window.chrome,
          e = t && t.app && t.app.runtime,
          r = !e && this._window.history && this._window.history.pushState;
      if (r) {
        var o = this,
            i = this._window.onpopstate;this._window.onpopstate = function () {
          var t = o._location.href;
          o.handleUrlChange(o._lastHref, t), i && i.apply(this, arguments);
        }, n(this._window.history, 'pushState', function (t) {
          return function () {
            var e = arguments.length > 2 ? arguments[2] : void 0;
            return e && o.handleUrlChange(o._lastHref, e + ''), t.apply(this, arguments);
          };
        }, this.replacements);
      }
    }, i.prototype.handleUrlChange = function (t, e) {
      var r = d.parse(this._location.href),
          n = d.parse(e),
          o = d.parse(t);this._lastHref = e, r.protocol === n.protocol && r.host === n.host && (e = n.path + (n.hash || '')), r.protocol === o.protocol && r.host === o.host && (t = o.path + (o.hash || '')), this.telemeter.captureNavigation(t, e);
    }, i.prototype.instrumentConnectivity = function () {
      ;('addEventListener' in this._window || 'body' in this._document) && (this._window.addEventListener ? (this._window.addEventListener('online', function () {
        this.telemeter.captureConnectivityChange('online');
      }.bind(this), !0), this._window.addEventListener('offline', function () {
        this.telemeter.captureConnectivityChange('offline');
      }.bind(this), !0)) : (this._document.body.ononline = function () {
        this.telemeter.captureConnectivityChange('online');
      }.bind(this), this._document.body.onoffline = function () {
        this.telemeter.captureConnectivityChange('offline');
      }.bind(this)));
    }, i.prototype.restore = function () {
      o(this.replacements), this.replacements = [];
    }, t.exports = i;
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(579)(module)))

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePasswordDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _InlineErrorMessage = __webpack_require__(447);

var _InlineErrorMessage2 = _interopRequireDefault(_InlineErrorMessage);

var _ButtonA = __webpack_require__(244);

var _ButtonA2 = _interopRequireDefault(_ButtonA);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _AuthWrapper = __webpack_require__(264);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _InputHint = __webpack_require__(654);

var _InputHint2 = _interopRequireDefault(_InputHint);

var _JustifyCenter = __webpack_require__(265);

var _JustifyCenter2 = _interopRequireDefault(_JustifyCenter);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _PasswordField = __webpack_require__(448);

var _PasswordField2 = _interopRequireDefault(_PasswordField);

var _TextButton = __webpack_require__(266);

var _TextButton2 = _interopRequireDefault(_TextButton);

var _icon_checkmark = __webpack_require__(1367);

var _icon_checkmark2 = _interopRequireDefault(_icon_checkmark);

var _account = __webpack_require__(297);

var _combined = __webpack_require__(395);

var _user = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePassword = function (_Component) {
  (0, _inherits3.default)(ChangePassword, _Component);

  function ChangePassword(props) {
    (0, _classCallCheck3.default)(this, ChangePassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChangePassword.__proto__ || (0, _getPrototypeOf2.default)(ChangePassword)).call(this, props));

    _this.state = {
      currentPassword: '',
      newPassword: '',
      error: null
    };

    _this.handleCurrentPasswordChangeBound = _this.handleCurrentPasswordChange.bind(_this);
    _this.handleNewPasswordChangeBound = _this.handleNewPasswordChange.bind(_this);
    _this.shouldButtonBeDisabledBound = _this.shouldButtonBeDisabled.bind(_this);
    _this.onReturnToLoginClickBound = _this.onReturnToLoginClick.bind(_this);
    _this.checkForSubmitBound = _this.checkForSubmit.bind(_this);
    _this.onChangePasswordClickBound = _this.onChangePasswordClick.bind(_this);
    _this.onContinueClickBound = _this.onContinueClick.bind(_this);
    _this.handleFormSubmitBound = _this.handleFormSubmit.bind(_this);

    window.scrollTo(0, 0);
    return _this;
  }

  (0, _createClass3.default)(ChangePassword, [{
    key: 'render',
    value: function render() {
      var error = this.state.error;
      var _props = this.props,
          isChangingPassword = _props.isChangingPassword,
          user = _props.user,
          success = _props.success,
          failure = _props.failure;

      return _react2.default.createElement(
        _AuthWrapper2.default,
        { hideIcon: true },
        !isChangingPassword && !success && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            _react2.default.createElement(_UserAvatar2.default, {
              wrapperClass: 'change-password-user-avatar',
              style: { marginBottom: '20px', height: '39px', width: '39px' },
              photoUrl: user ? user.photo.url : null
            }),
            _react2.default.createElement(
              _H2.default,
              { style: { marginBottom: '10px' } },
              'Before you continue, please change your password.'
            ),
            _react2.default.createElement(
              _Caption2.default,
              { style: { marginBottom: '30px' } },
              'Use something unique and memorable.'
            )
          ),
          _react2.default.createElement(
            'form',
            { style: { textAlign: 'left' } },
            _react2.default.createElement(_PasswordField2.default, {
              label: 'Current Password',
              onChange: this.handleCurrentPasswordChangeBound,
              onKeyPress: this.checkForSubmitBound,
              tooltipId: 'currentPassword'
            }),
            (error || failure) && _react2.default.createElement(
              _InlineErrorMessage2.default,
              { style: { bottom: '22px', left: '10px' } },
              error ? 'Current password is incorrect.' : 'There was a problem changing your password. Please try again later.'
            ),
            _react2.default.createElement(_PasswordField2.default, {
              label: 'New Password',
              onChange: this.handleNewPasswordChangeBound,
              onKeyPress: this.checkForSubmitBound,
              tooltipId: 'newPassword',
              style: { marginBottom: '38px' }
            }),
            _react2.default.createElement(
              _InputHint2.default,
              {
                style: {
                  position: 'relative',
                  bottom: '32px',
                  left: '13px'
                }
              },
              'Minimum 8 characters'
            ),
            _react2.default.createElement(
              _JustifyCenter2.default,
              null,
              _react2.default.createElement(
                _ButtonA2.default,
                {
                  type: 'submit',
                  onClick: this.onChangePasswordClickBound,
                  disabled: this.shouldButtonBeDisabledBound(),
                  style: { marginBottom: '22px', width: 'unset' }
                },
                'Change Password'
              )
            )
          ),
          _react2.default.createElement(
            _TextButton2.default,
            {
              style: { marginTop: 'auto' },
              onClick: this.onReturnToLoginClickBound
            },
            'Return to Login'
          )
        ),
        !isChangingPassword && success && _react2.default.createElement(
          _JustifyCenter2.default,
          null,
          _react2.default.createElement('div', {
            id: 'changePasswordCheckmark',
            style: {
              background: 'url(' + _icon_checkmark2.default + ') no-repeat',
              display: 'inline-block',
              height: '50px',
              width: '50px',
              marginBottom: '28px'
            }
          }),
          _react2.default.createElement(
            _H2.default,
            { style: { marginBottom: '16px' } },
            'Password Changed!'
          ),
          _react2.default.createElement(
            _P2.default,
            { style: { marginBottom: '33px' } },
            'Remember to use your new password the next time you log in.'
          ),
          _react2.default.createElement(
            _ButtonA2.default,
            { onClick: this.onContinueClickBound },
            'Continue'
          )
        ),
        isChangingPassword && _react2.default.createElement('div', { className: 'loading', style: { minHeight: '445px' } })
      );
    }
  }, {
    key: 'checkForSubmit',
    value: function checkForSubmit(e) {
      if (!this.shouldButtonBeDisabled() && (e.which === 13 || e.keyCode === 13)) {
        this.onChangePasswordClick(e);
      }
    }
  }, {
    key: 'handleCurrentPasswordChange',
    value: function handleCurrentPasswordChange(e) {
      this.setState({ currentPassword: e.target.value.trim() });
    }
  }, {
    key: 'handleNewPasswordChange',
    value: function handleNewPasswordChange(e) {
      this.setState({ newPassword: e.target.value.trim() });
    }
  }, {
    key: 'shouldButtonBeDisabled',
    value: function shouldButtonBeDisabled() {
      return this.state.currentPassword.trim().length < 1 || this.state.newPassword.trim().length < 8;
    }
  }, {
    key: 'onReturnToLoginClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var dispatch;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = this.props.dispatch;
                _context.next = 3;
                return dispatch((0, _user.userNeedsToResetPassword)(false));

              case 3:
                this.props.dispatch((0, _user.logoutAndRedirect)());

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onReturnToLoginClick() {
        return _ref.apply(this, arguments);
      }

      return onReturnToLoginClick;
    }()
  }, {
    key: 'onChangePasswordClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var _state, currentPassword, newPassword, passwordValidation;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _state = this.state, currentPassword = _state.currentPassword, newPassword = _state.newPassword;
                passwordValidation = this.props.passwordValidation;

                if (passwordValidation === currentPassword) {
                  if (!this.shouldButtonBeDisabled()) {
                    this.props.dispatch((0, _account.changePassword)(currentPassword, newPassword));
                  }
                } else {
                  this.setState(function () {
                    return {
                      error: 'Current password is incorrect.'
                    };
                  });
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onChangePasswordClick(_x) {
        return _ref2.apply(this, arguments);
      }

      return onChangePasswordClick;
    }()
  }, {
    key: 'onContinueClick',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.dispatch((0, _user.userNeedsToResetPassword)(false));

              case 2:
                this.props.dispatch((0, _combined.fetchDataAndRedirectUser)(this.props.user));

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onContinueClick() {
        return _ref3.apply(this, arguments);
      }

      return onContinueClick;
    }()
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      return false;
    }
  }]);
  return ChangePassword;
}(_react.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isChangingPassword: state.account.isChangingPassword,
    failure: state.account.passwordChangeFailure,
    success: state.account.passwordChangeSuccess,
    user: state.user.user,
    passwordValidation: sessionStorage.getItem('password'),
    userNeedsToResetPassword: state.user.userNeedsToResetPassword
  };
};

ChangePassword.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.object,
  isChangingPassword: _propTypes2.default.bool.isRequired,
  failure: _propTypes2.default.bool.isRequired,
  success: _propTypes2.default.bool.isRequired,
  user: _propTypes2.default.object.isRequired,
  passwordValidation: _propTypes2.default.string.isRequired,
  userNeedsToResetPassword: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ChangePassword);
exports.ChangePasswordDisconnected = ChangePassword; // pure component - used in tests

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-size: cover;\n  height: 100vh;\n  position: relative;\n  overflow: auto;\n'], ['\n  background-size: cover;\n  height: 100vh;\n  position: relative;\n  overflow: auto;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthBackground = _styledComponents2.default.div.withConfig({
  displayName: 'AuthBackground',
  componentId: 'sc-10garxz-0'
})(_templateObject);

exports.default = AuthBackground;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(653);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border: 1px solid #ececec;\n  border-radius: 16px;\n  background-color: #ffffff;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);\n  padding: ', ' 48px 40px 50px;\n'], ['\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border: 1px solid #ececec;\n  border-radius: 16px;\n  background-color: #ffffff;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);\n  padding: ', ' 48px 40px 50px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 78px;\n  width: 78px;\n  background-size: 100%;\n  position: relative;\n  right: 50%;\n  z-index: 1;\n  bottom: 36px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 78px;\n  width: 78px;\n  background-size: 100%;\n  position: relative;\n  right: 50%;\n  z-index: 1;\n  bottom: 36px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 470px;\n  margin: 0 auto;\n  position: relative;\n  top: 120px;\n'], ['\n  width: 470px;\n  margin: 0 auto;\n  position: relative;\n  top: 120px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CopyrightOE = __webpack_require__(1359);

var _CopyrightOE2 = _interopRequireDefault(_CopyrightOE);

var _qm_logo = __webpack_require__(1362);

var _qm_logo2 = _interopRequireDefault(_qm_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'AuthContainer__Container',
  componentId: 'sc-1pcm8d-0'
})(_templateObject, function (props) {
  return props.hideIcon ? '34px' : '65px';
});

var QMLogoStyled = _styledComponents2.default.div.withConfig({
  displayName: 'AuthContainer__QMLogoStyled',
  componentId: 'sc-1pcm8d-1'
})(_templateObject2, _qm_logo2.default);

var Outer = _styledComponents2.default.div.withConfig({
  displayName: 'AuthContainer__Outer',
  componentId: 'sc-1pcm8d-2'
})(_templateObject3);

var AuthContainer = function AuthContainer(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['children']);
  return _react2.default.createElement(
    Outer,
    null,
    !props.hideIcon && _react2.default.createElement(
      'div',
      { style: { position: 'absolute', left: '50%' } },
      _react2.default.createElement(QMLogoStyled, null)
    ),
    _react2.default.createElement(
      Container,
      { hideIcon: props.hideIcon },
      children
    ),
    _react2.default.createElement(_CopyrightOE2.default, null)
  );
};

AuthContainer.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  hideIcon: _propTypes2.default.bool
};

exports.default = AuthContainer;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 18px;\n  text-align: center;\n  margin: 57px 0 35px;\n'], ['\n  color: ', ';\n  font-size: 15px;\n  font-weight: 300;\n  line-height: 18px;\n  text-align: center;\n  margin: 57px 0 35px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  background: ', '\n    no-repeat;\n  height: 37px;\n  width: 246px;\n  margin-bottom: 20px;\n  cursor: pointer;\n'], ['\n  display: inline-block;\n  background: ', '\n    no-repeat;\n  height: 37px;\n  width: 246px;\n  margin-bottom: 20px;\n  cursor: pointer;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _time = __webpack_require__(161);

var _oe_logo_dark_bg = __webpack_require__(1360);

var _oe_logo_dark_bg2 = _interopRequireDefault(_oe_logo_dark_bg);

var _oe_logo_lite_bg = __webpack_require__(1361);

var _oe_logo_lite_bg2 = _interopRequireDefault(_oe_logo_lite_bg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyrightOEContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CopyrightOE__CopyrightOEContainer',
  componentId: 'sc-1xmgmj5-0'
})(_templateObject, function (props) {
  return props.liteBG ? '#000000' : '#ffffff';
});

var OELogo = _styledComponents2.default.div.withConfig({
  displayName: 'CopyrightOE__OELogo',
  componentId: 'sc-1xmgmj5-1'
})(_templateObject2, function (props) {
  return props.liteBG ? 'url(' + _oe_logo_lite_bg2.default + ')' : 'url(' + _oe_logo_dark_bg2.default + ')';
});

var CopyrightOE = function CopyrightOE(props) {
  return _react2.default.createElement(
    CopyrightOEContainer,
    props,
    _react2.default.createElement(OELogo, (0, _extends3.default)({}, props, {
      onClick: function onClick() {
        return window.open('https://www.opportunityeducation.org/');
      }
    })),
    _react2.default.createElement(
      'div',
      null,
      '\xA9 2012-' + (0, _time.getCurrentYear)() + ' Opportunity Education Foundation, Inc.'
    ),
    _react2.default.createElement(
      'div',
      null,
      'Quest Forward Learning\u2122 | All rights reserved.'
    )
  );
};

CopyrightOE.propTypes = {
  liteBG: _propTypes2.default.bool
};

exports.default = CopyrightOE;

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/qm_logo.svg";

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTggMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uX3Nob3duX2hvdmVyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlJlc2V0LVVubWFza2VkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA1Ny4wMDAwMDAsIC0yNjAuMDAwMDAwKSIgZmlsbD0iIzk5OTk5OSI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uX3Nob3duX2hvdmVyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDU3LjAwMDAwMCwgMjYwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTguOTU3NSwzLjc4OSBDNy44MTI1LDMuNzg5IDYuODg0NSw0Ljc0NiA2Ljg4NDUsNS45MjcgQzYuODg0NSw3LjEwNyA3LjgxMjUsOC4wNjQgOC45NTc1LDguMDY0IEMxMC4xMDI1LDguMDY0IDExLjAzMDUsNy4xMDcgMTEuMDMwNSw1LjkyNyBDMTEuMDMwNSw0Ljc0NiAxMC4xMDI1LDMuNzg5IDguOTU3NSwzLjc4OSBNOC45ODg1LDEwLjI0NyBDNi43MTM1LDEwLjI0NyA0Ljg2OTUsOC4zNDYgNC44Njk1LDUuOTk5IEM0Ljg2OTUsMy42NTQgNi43MTM1LDEuNzUyIDguOTg4NSwxLjc1MiBDMTEuMjY0NSwxLjc1MiAxMy4xMDc1LDMuNjU0IDEzLjEwNzUsNS45OTkgQzEzLjEwNzUsOC4zNDYgMTEuMjY0NSwxMC4yNDcgOC45ODg1LDEwLjI0NyBNMTcuODU3NSw1LjY0MyBDMTYuODg0NSw0LjM1MSAxMy4yODI1LDAgOC45ODg1LDAgQzQuNjk0NSwwIDEuMDkzNSw0LjM1MSAwLjExOTUsNS42NDMgQy0wLjAzOTUsNS44NTIgLTAuMDM5NSw2LjE0NiAwLjExOTUsNi4zNTYgQzEuMDkzNSw3LjY0NyA0LjY5NDUsMTEuOTk5IDguOTg4NSwxMS45OTkgQzEzLjI4MjUsMTEuOTk5IDE2Ljg4NDUsNy42NDcgMTcuODU3NSw2LjM1NiBDMTguMDE3NSw2LjE0NiAxOC4wMTc1LDUuODUyIDE3Ljg1NzUsNS42NDMiIGlkPSJGaWxsLTEiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForgotPasswordDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _AuthWrapper = __webpack_require__(264);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _InlineErrorMessage = __webpack_require__(447);

var _InlineErrorMessage2 = _interopRequireDefault(_InlineErrorMessage);

var _TextButton = __webpack_require__(266);

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Bold = __webpack_require__(1369);

var _Bold2 = _interopRequireDefault(_Bold);

var _ButtonA = __webpack_require__(244);

var _ButtonA2 = _interopRequireDefault(_ButtonA);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _JustifyCenter = __webpack_require__(265);

var _JustifyCenter2 = _interopRequireDefault(_JustifyCenter);

var _TextField = __webpack_require__(449);

var _TextField2 = _interopRequireDefault(_TextField);

var _forgotpassword = __webpack_require__(548);

var _validation = __webpack_require__(577);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgotPassword = function (_Component) {
  (0, _inherits3.default)(ForgotPassword, _Component);

  function ForgotPassword(props) {
    (0, _classCallCheck3.default)(this, ForgotPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ForgotPassword.__proto__ || (0, _getPrototypeOf2.default)(ForgotPassword)).call(this, props));

    _this.state = {
      email: '',
      emailErrorExists: false,
      displayErrorMessage: false
    };

    _this.handleEmailChangeBound = _this.handleEmailChange.bind(_this);
    _this.handleEmailPasswordLinkClickBound = _this.handleEmailPasswordLinkClick.bind(_this);
    _this.shouldButtonBeDisabledBound = _this.shouldButtonBeDisabled.bind(_this);
    _this.onReturnToLoginClickBound = _this.onReturnToLoginClick.bind(_this);
    _this.checkForSubmitBound = _this.checkForSubmit.bind(_this);

    window.scrollTo(0, 0);
    return _this;
  }

  (0, _createClass3.default)(ForgotPassword, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          hasSentRequest = _props.hasSentRequest;

      return _react2.default.createElement(
        _AuthWrapper2.default,
        null,
        isLoading && _react2.default.createElement('div', { className: 'loading', style: { minHeight: '282px' } }),
        !isLoading && !hasSentRequest && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            _react2.default.createElement(
              _H2.default,
              { style: { marginBottom: '15px' } },
              'Forgot Password'
            ),
            _react2.default.createElement(
              _P2.default,
              { style: { marginBottom: '24px' } },
              'Don\u2019t worry, it happens to the best of us. Enter your email to receive a reset password link.'
            )
          ),
          _react2.default.createElement(
            'form',
            { style: { textAlign: 'left' } },
            _react2.default.createElement(_TextField2.default, {
              id: 'email-input',
              label: 'Email',
              type: 'email',
              margin: 'normal',
              value: this.state.email,
              onChange: this.handleEmailChangeBound,
              onKeyPress: this.checkForSubmitBound,
              style: { marginBottom: '38px' }
            }),
            this.state.displayErrorMessage && _react2.default.createElement(
              _InlineErrorMessage2.default,
              { style: { bottom: '25px', left: '10px' } },
              'Please enter a valid email address.'
            ),
            _react2.default.createElement(
              _JustifyCenter2.default,
              null,
              _react2.default.createElement(
                _ButtonA2.default,
                {
                  type: 'submit',
                  disabled: this.shouldButtonBeDisabledBound(),
                  onClick: this.handleEmailPasswordLinkClickBound,
                  style: { marginBottom: '29px', width: 'unset' }
                },
                'Email Password Link'
              )
            )
          )
        ),
        !isLoading && hasSentRequest && _react2.default.createElement(
          _JustifyCenter2.default,
          null,
          _react2.default.createElement(
            _H2.default,
            { style: { marginBottom: '37px' } },
            'Please check your email!'
          ),
          _react2.default.createElement(
            _P2.default,
            { style: { marginBottom: '25px' } },
            'We sent you a secret link to reset your password.'
          ),
          _react2.default.createElement(
            _P2.default,
            { style: { marginBottom: '89px' } },
            'If the email does not arrive soon, check your spam folder. It was sent from ',
            _react2.default.createElement(
              _Bold2.default,
              null,
              'help@questforward.org'
            )
          )
        ),
        _react2.default.createElement(
          _TextButton2.default,
          {
            style: { marginTop: 'auto' },
            onClick: this.onReturnToLoginClickBound,
            fontSize: '13px'
          },
          'Return to Login'
        )
      );
    }
  }, {
    key: 'checkForSubmit',
    value: function checkForSubmit(e) {
      if (e.which === 13 || e.keyCode === 13) {
        this.handleEmailPasswordLinkClick(e);
      }
    }
  }, {
    key: 'shouldButtonBeDisabled',
    value: function shouldButtonBeDisabled() {
      return !this.state.email || this.state.emailErrorExists;
    }
  }, {
    key: 'handleEmailPasswordLinkClick',
    value: function handleEmailPasswordLinkClick(e) {
      e.preventDefault();
      var email = this.state.email;


      if (!(0, _validation.validateEmail)(email)) {
        this.setState(function () {
          return {
            emailErrorExists: true,
            displayErrorMessage: true
          };
        });
      } else {
        this.props.dispatch((0, _forgotpassword.forgotPassword)(email));
      }
    }
  }, {
    key: 'handleEmailChange',
    value: function handleEmailChange(e) {
      var email = e.target.value;
      this.setState(function () {
        return {
          email: email,
          emailErrorExists: false
        };
      });
    }
  }, {
    key: 'onReturnToLoginClick',
    value: function onReturnToLoginClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/login'));
    }
  }]);
  return ForgotPassword;
}(_react.Component);

ForgotPassword.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  hasSentRequest: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.forgotpassword.isSendingRequest,
    hasSentRequest: state.forgotpassword.hasSentRequest
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ForgotPassword);
exports.ForgotPasswordDisconnected = ForgotPassword; // pure component - used in tests

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-weight: 500;\n'], ['\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bold = _styledComponents2.default.span.withConfig({
  displayName: 'Bold',
  componentId: 'sc-12x0e9d-0'
})(_templateObject);
exports.default = Bold;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  max-width: 270px;\n  display: inline-block;\n  background-size: 100%;\n  margin: 8px auto 20px;\n  height: 31px;\n  width: 227px;\n'], ['\n  background: url(', ') no-repeat;\n  max-width: 270px;\n  display: inline-block;\n  background-size: 100%;\n  margin: 8px auto 20px;\n  height: 31px;\n  width: 227px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background-color: #f5f5f5;\n  color: #666666;\n  margin-right: -48px;\n  margin-left: -50px;\n  margin-bottom: 15px;\n  padding: 10px 65px;\n  line-height: 16px;\n'], ['\n  background-color: #f5f5f5;\n  color: #666666;\n  margin-right: -48px;\n  margin-left: -50px;\n  margin-bottom: 15px;\n  padding: 10px 65px;\n  line-height: 16px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _ButtonA = __webpack_require__(244);

var _ButtonA2 = _interopRequireDefault(_ButtonA);

var _TextField = __webpack_require__(449);

var _TextField2 = _interopRequireDefault(_TextField);

var _PasswordField = __webpack_require__(448);

var _PasswordField2 = _interopRequireDefault(_PasswordField);

var _JustifyCenter = __webpack_require__(265);

var _JustifyCenter2 = _interopRequireDefault(_JustifyCenter);

var _AuthWrapper = __webpack_require__(264);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _InlineErrorMessage = __webpack_require__(447);

var _InlineErrorMessage2 = _interopRequireDefault(_InlineErrorMessage);

var _TextButton = __webpack_require__(266);

var _TextButton2 = _interopRequireDefault(_TextButton);

var _user = __webpack_require__(73);

var _questmaker_tm_logo = __webpack_require__(1371);

var _questmaker_tm_logo2 = _interopRequireDefault(_questmaker_tm_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestForwardQuestCommunityIcon = _styledComponents2.default.div.withConfig({
  displayName: 'Login__QuestForwardQuestCommunityIcon',
  componentId: 'sc-1cqhefa-0'
})(_templateObject, _questmaker_tm_logo2.default);

var LockedAccountMessage = _styledComponents2.default.div.withConfig({
  displayName: 'Login__LockedAccountMessage',
  componentId: 'sc-1cqhefa-1'
})(_templateObject2);

var Login = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this.state = {
      email: localStorage.getItem('lastLogin') || '',
      password: ''
    };

    _this.handleEmailChangeBound = _this.handleEmailChange.bind(_this);
    _this.handlePasswordChangeBound = _this.handlePasswordChange.bind(_this);
    _this.loginBound = _this.login.bind(_this);
    _this.shouldButtonBeDisabledBound = _this.shouldButtonBeDisabled.bind(_this);
    _this.checkForSubmitBound = _this.checkForSubmit.bind(_this);
    _this.onForgotPasswordClickBound = _this.onForgotPasswordClick.bind(_this);

    window.scrollTo(0, 0);
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _AuthWrapper2.default,
        null,
        _react2.default.createElement(QuestForwardQuestCommunityIcon, null),
        this.props.statusText === 'Locked' && _react2.default.createElement(
          LockedAccountMessage,
          null,
          'Your account ',
          this.state.email,
          ' has been temporarily locked due to multiple failed login attempts. Check your email to unlock or tap forgot password below.'
        ),
        _react2.default.createElement(
          'form',
          { style: { textAlign: 'left' } },
          _react2.default.createElement(_TextField2.default, {
            id: 'email-input',
            label: 'Email',
            type: 'email',
            margin: 'normal',
            defaultValue: this.state.email,
            onKeyPress: this.checkForSubmitBound,
            onChange: this.handleEmailChangeBound,
            autoFocus: !localStorage.getItem('lastLogin'),
            placeholder: 'Username or Email',
            style: { marginBottom: '10px' }
          }),
          _react2.default.createElement(_PasswordField2.default, {
            label: 'Password',
            value: this.state.password,
            onChange: this.handlePasswordChangeBound,
            autoFocus: localStorage.getItem('lastLogin') !== null,
            onKeyPress: this.checkForSubmitBound,
            placeholder: 'Password',
            style: { marginBottom: '35px' }
          }),
          this.props.statusText && _react2.default.createElement(
            _InlineErrorMessage2.default,
            { style: { bottom: '25px' } },
            'Oops! Your username or password was incorrect.'
          ),
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            this.props.isAuthenticating || this.props.isAuthenticated ? _react2.default.createElement('div', {
              className: 'loading submit',
              style: { minHeight: '50px', width: '50px', margin: 'auto' }
            }) : _react2.default.createElement(
              _ButtonA2.default,
              {
                style: { width: 'unset', marginBottom: '27px' },
                type: 'submit',
                onClick: this.loginBound,
                disabled: this.shouldButtonBeDisabledBound()
              },
              'Sign In'
            )
          )
        ),
        _react2.default.createElement(
          _TextButton2.default,
          {
            onClick: this.onForgotPasswordClickBound,
            style: { marginTop: 'auto' },
            fontSize: '13px'
          },
          'Forgot your password?'
        )
      );
    }
  }, {
    key: 'checkForSubmit',
    value: function checkForSubmit(e) {
      if (e.which === 13 || e.keyCode === 13) {
        this.login(e);
      }
    }
  }, {
    key: 'handleEmailChange',
    value: function handleEmailChange(e) {
      this.setState({ email: e.target.value });
    }
  }, {
    key: 'handlePasswordChange',
    value: function handlePasswordChange(e) {
      this.setState({ password: e.target.value });
    }
  }, {
    key: 'login',
    value: function login(e) {
      e.preventDefault();
      this.props.dispatch((0, _user.loginUser)(this.state.email, this.state.password));
    }
  }, {
    key: 'shouldButtonBeDisabled',
    value: function shouldButtonBeDisabled() {
      return this.props.isAuthenticating || !this.state.email || !this.state.password;
    }
  }, {
    key: 'onForgotPasswordClick',
    value: function onForgotPasswordClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/forgotpassword'));
    }
  }]);
  return Login;
}(_react.Component);

Login.propTypes = {
  isAuthenticating: _propTypes2.default.bool.isRequired,
  statusText: _propTypes2.default.string,
  isAuthenticated: _propTypes2.default.bool.isRequired,
  dispatch: _propTypes2.default.func.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticating: state.user.isAuthenticating,
    statusText: state.user.statusText || '',
    isAuthenticated: state.user.isAuthenticated
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Login);
exports.LoginDisconnected = Login; // pure component - used in tests

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OurPoliciesDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _policies = __webpack_require__(158);

var _Policies = __webpack_require__(655);

var _Policies2 = _interopRequireDefault(_Policies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OurPoliciesContainer = function (_Component) {
  (0, _inherits3.default)(OurPoliciesContainer, _Component);

  function OurPoliciesContainer() {
    (0, _classCallCheck3.default)(this, OurPoliciesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (OurPoliciesContainer.__proto__ || (0, _getPrototypeOf2.default)(OurPoliciesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(OurPoliciesContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _policies.fetchPoliciesIfNeeded)());
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          policies = _props.policies,
          isFetchingPolicies = _props.isFetchingPolicies;


      return _react2.default.createElement(
        'div',
        { className: 'policies-container accepted' },
        isFetchingPolicies && _react2.default.createElement('div', { className: 'loading' }),
        !isFetchingPolicies && _react2.default.createElement(
          'div',
          { className: 'policies-list-wrapper' },
          _react2.default.createElement(_Policies2.default, { policies: policies, displayActions: false })
        )
      );
    }
  }]);
  return OurPoliciesContainer;
}(_react.Component);

OurPoliciesContainer.propTypes = {
  dispatch: _propTypes2.default.func,
  policies: _propTypes2.default.array.isRequired,
  isFetchingPolicies: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    policies: state.policies.items,
    isFetchingPolicies: state.policies.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(OurPoliciesContainer);
exports.OurPoliciesDisconnected = OurPoliciesContainer; // pure component - used in tests

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Policy = function (_Component) {
  (0, _inherits3.default)(Policy, _Component);

  function Policy() {
    (0, _classCallCheck3.default)(this, Policy);
    return (0, _possibleConstructorReturn3.default)(this, (Policy.__proto__ || (0, _getPrototypeOf2.default)(Policy)).apply(this, arguments));
  }

  (0, _createClass3.default)(Policy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          policy = _props.policy,
          show = _props.show;

      return _react2.default.createElement(
        'li',
        {
          id: policy.slug,
          className: show ? 'policy-list-item active' : 'policy-list-item'
        },
        _react2.default.createElement('div', {
          className: 'policy-content',
          dangerouslySetInnerHTML: this.createHtmlElement(policy.content_html)
        })
      );
    }
  }, {
    key: 'createHtmlElement',
    value: function createHtmlElement(html) {
      return { __html: html };
    }
  }]);
  return Policy;
}(_react.Component);

exports.default = Policy;


Policy.propTypes = {
  show: _propTypes2.default.bool,
  policy: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoliciesDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _Policies = __webpack_require__(655);

var _Policies2 = _interopRequireDefault(_Policies);

var _policies = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PoliciesContainer = function (_Component) {
  (0, _inherits3.default)(PoliciesContainer, _Component);

  function PoliciesContainer() {
    (0, _classCallCheck3.default)(this, PoliciesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (PoliciesContainer.__proto__ || (0, _getPrototypeOf2.default)(PoliciesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(PoliciesContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      dispatch((0, _policies.fetchPoliciesIfNeeded)());
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          policies = _props.policies,
          isFetchingPolicies = _props.isFetchingPolicies,
          dispatch = _props.dispatch;


      return _react2.default.createElement(
        'div',
        { className: 'policies-container' },
        isFetchingPolicies && _react2.default.createElement('div', { className: 'loading' }),
        !isFetchingPolicies && _react2.default.createElement(
          'div',
          { className: 'policies-list-wrapper' },
          _react2.default.createElement(_Policies2.default, {
            policies: policies,
            displayActions: true,
            dispatch: dispatch
          })
        )
      );
    }
  }]);
  return PoliciesContainer;
}(_react.Component);

PoliciesContainer.propTypes = {
  dispatch: _propTypes2.default.func,
  policies: _propTypes2.default.array.isRequired,
  isFetchingPolicies: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    policies: state.policies.items,
    isFetchingPolicies: state.policies.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PoliciesContainer);
exports.PoliciesDisconnected = PoliciesContainer; // pure component - used in tests

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestsDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _Quests = __webpack_require__(450);

var _Quests2 = _interopRequireDefault(_Quests);

var _QuestsSearch = __webpack_require__(1452);

var _QuestsSearch2 = _interopRequireDefault(_QuestsSearch);

var _QuestsSearchResultsCount = __webpack_require__(456);

var _QuestsSearchResultsCount2 = _interopRequireDefault(_QuestsSearchResultsCount);

var _DesignANewQuest = __webpack_require__(457);

var _DesignANewQuest2 = _interopRequireDefault(_DesignANewQuest);

var _HeaderLockup = __webpack_require__(337);

var _HeaderLockup2 = _interopRequireDefault(_HeaderLockup);

var _OrgAvatar = __webpack_require__(409);

var _OrgAvatar2 = _interopRequireDefault(_OrgAvatar);

var _NoQuestsMatchYourSearch = __webpack_require__(458);

var _NoQuestsMatchYourSearch2 = _interopRequireDefault(_NoQuestsMatchYourSearch);

var _user = __webpack_require__(73);

var _quests = __webpack_require__(403);

var _organization = __webpack_require__(338);

var _user2 = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestsContainer = function (_Component) {
  (0, _inherits3.default)(QuestsContainer, _Component);

  function QuestsContainer(props) {
    (0, _classCallCheck3.default)(this, QuestsContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestsContainer.__proto__ || (0, _getPrototypeOf2.default)(QuestsContainer)).call(this, props));

    _this.loadMoreQuestsBound = _this.loadMoreQuests.bind(_this);
    _this.addQuestBound = _this.addQuest.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _quests.fetchQuests)(1, true));
      this.props.dispatch((0, _user.requestUserData)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.currentOrg !== this.props.currentOrg) {
        this.props.dispatch((0, _quests.fetchQuests)(1, true));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quests = _props.quests,
          isFetchingQuests = _props.isFetchingQuests,
          totalQuests = _props.totalQuests,
          currentOrg = _props.currentOrg,
          user = _props.user,
          dispatch = _props.dispatch;


      return _react2.default.createElement(
        'div',
        { className: 'quests-container' },
        _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(_HeaderLockup2.default, {
            avatarComponent: _react2.default.createElement(_OrgAvatar2.default, { organization: currentOrg }),
            organization: currentOrg,
            section: 'All Quests'
          }),
          (0, _user2.isQuestDesignerOrIsQuestManager)(user) && _react2.default.createElement(_DesignANewQuest2.default, { addQuest: this.addQuestBound })
        ),
        _react2.default.createElement(
          'div',
          { className: 'quests-search-quests-list-container' },
          _react2.default.createElement(_QuestsSearch2.default, null),
          _react2.default.createElement(
            'div',
            { className: 'count-and-list-container' },
            !isFetchingQuests && totalQuests > 0 && _react2.default.createElement(_QuestsSearchResultsCount2.default, { totalQuests: totalQuests }),
            !isFetchingQuests && totalQuests === 0 && _react2.default.createElement(_NoQuestsMatchYourSearch2.default, { text: 'No quests match your search.' }),
            isFetchingQuests && _react2.default.createElement('div', { className: 'loading' }),
            quests && quests.length > 0 && _react2.default.createElement(
              'div',
              { id: 'quest-list' },
              _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
                items: _react2.default.createElement(_Quests2.default, {
                  quests: quests,
                  dispatch: dispatch,
                  user: user,
                  iconHeightWidth: 82
                }),
                loadMore: this.loadMoreQuestsBound,
                loadingMore: isFetchingQuests,
                elementIsScrollable: false,
                showLoader: false
              })
            )
          )
        )
      );
    }
  }, {
    key: 'loadMoreQuests',
    value: function loadMoreQuests() {
      // Only load more quests if the size of the quest list is less than the totalquest count from the search call
      if (this.props.quests.length < this.props.totalQuests) {
        this.props.dispatch((0, _quests.fetchQuests)(this.props.page + 1, false));
      }
    }
  }, {
    key: 'addQuest',
    value: function addQuest() {
      this.props.dispatch((0, _reactRouterRedux.push)('/quests/add'));
    }
  }]);
  return QuestsContainer;
}(_react.Component);

QuestsContainer.propTypes = {
  quests: _propTypes2.default.array,
  page: _propTypes2.default.number,
  isFetchingQuests: _propTypes2.default.bool,
  currentOrg: _propTypes2.default.object,
  totalQuests: _propTypes2.default.number,
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    quests: state.quests.items,
    page: state.quests.page,
    isFetchingQuests: state.quests.isFetching,
    currentOrg: (0, _organization.currentOrg)(state),
    totalQuests: state.quests.total,
    user: state.user.user
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuestsContainer);
exports.QuestsDisconnected = QuestsContainer;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1377);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1378);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1382);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(657);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1379);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(1380);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1381);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1379 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(1383);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1385);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1386);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1387);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(32);

var _PropTypes = __webpack_require__(657);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1384));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(656));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(656));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topPosition = topPosition;
exports.leftPosition = leftPosition;
function topPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetTop + topPosition(domElt.offsetParent);
}

function leftPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetLeft + leftPosition(domElt.offsetParent);
}

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DateFormatter = __webpack_require__(658);

var _DateFormatter2 = _interopRequireDefault(_DateFormatter);

var _DateSwitcher = __webpack_require__(1390);

var _DateSwitcher2 = _interopRequireDefault(_DateSwitcher);

var _ElapsedTimeFormatter = __webpack_require__(1391);

var _ElapsedTimeFormatter2 = _interopRequireDefault(_ElapsedTimeFormatter);

var _Modal = __webpack_require__(1392);

var _Modal2 = _interopRequireDefault(_Modal);

var _UserAvatar = __webpack_require__(1393);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _Time = __webpack_require__(1394);

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  DateFormatter: _DateFormatter2.default,
  DateSwitcher: _DateSwitcher2.default,
  ElapsedTimeFormatter: _ElapsedTimeFormatter2.default,
  Modal: _Modal2.default,
  UserAvatar: _UserAvatar2.default,
  Time: _Time2.default
};

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateFormatter = __webpack_require__(658);

var _DateFormatter2 = _interopRequireDefault(_DateFormatter);

var _time = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateSwitcher = function (_Component) {
  (0, _inherits3.default)(DateSwitcher, _Component);

  function DateSwitcher(props) {
    (0, _classCallCheck3.default)(this, DateSwitcher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DateSwitcher.__proto__ || (0, _getPrototypeOf2.default)(DateSwitcher)).call(this, props));

    _this.state = {
      showCreatedAt: false
    };

    _this.toggleWaitTimeBound = _this.toggleWaitTime.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DateSwitcher, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'oe-date-switcher', onClick: this.toggleWaitTimeBound },
        this.state.showCreatedAt ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_DateFormatter2.default, { abbreviateMonth: true, date: this.props.date })
        ) : _react2.default.createElement(
          'span',
          null,
          this.props.extraText,
          ' ',
          (0, _time.getAverageWaitTime)((0, _time.getDifferenceInMinutesToNow)(this.props.date))
        )
      );
    }
  }, {
    key: 'toggleWaitTime',
    value: function toggleWaitTime(e) {
      e.stopPropagation();
      this.setState({
        showCreatedAt: !this.state.showCreatedAt
      });
    }
  }]);
  return DateSwitcher;
}(_react.Component);

exports.default = DateSwitcher;


DateSwitcher.propTypes = {
  date: _propTypes2.default.number,
  extraText: _propTypes2.default.string
};

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _time = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElapsedTimeFormatter = function (_Component) {
  (0, _inherits3.default)(ElapsedTimeFormatter, _Component);

  function ElapsedTimeFormatter() {
    (0, _classCallCheck3.default)(this, ElapsedTimeFormatter);
    return (0, _possibleConstructorReturn3.default)(this, (ElapsedTimeFormatter.__proto__ || (0, _getPrototypeOf2.default)(ElapsedTimeFormatter)).apply(this, arguments));
  }

  (0, _createClass3.default)(ElapsedTimeFormatter, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'oe-elapsed-time ' + (this.props.cssClass || '') },
        this.getElapsedTimeText()
      );
    }
  }, {
    key: 'getElapsedTimeText',
    value: function getElapsedTimeText() {
      var _props = this.props,
          time = _props.time,
          textBefore = _props.textBefore,
          abbreviateMonth = _props.abbreviateMonth,
          includeTime = _props.includeTime;

      var minutesAgo = (0, _time.getDifferenceInMinutesToNow)(time);
      var hoursAgo = (0, _time.getDifferenceInHoursToNow)(time);
      var s = textBefore ? textBefore + ' ' : '';
      var daysAgo = Math.floor(minutesAgo / 1440);
      daysAgo = daysAgo !== 0 ? daysAgo : 1;

      if (minutesAgo < 1) {
        s = s + 'Just Now';
      } else if (minutesAgo > 0 && minutesAgo < 60) {
        s = s + (minutesAgo + ' min ago');
      } else if (hoursAgo >= 1 && hoursAgo < 24) {
        s = s + (hoursAgo + ' hour' + (hoursAgo > 1 ? 's' : '') + ' ago');
      } else if (hoursAgo >= 24 && daysAgo < 7) {
        s = s + (daysAgo + ' day' + (daysAgo > 1 ? 's' : '') + ' ago');
      } else {
        s = s + _moment2.default.unix(time).format((0, _time.getFormat)(abbreviateMonth || false, includeTime, false));
      }

      return s;
    }
  }]);
  return ElapsedTimeFormatter;
}(_react.Component);

exports.default = ElapsedTimeFormatter;


ElapsedTimeFormatter.propTypes = {
  cssClass: _propTypes2.default.string,
  textBefore: _propTypes2.default.string,
  time: _propTypes2.default.number,
  abbreviateMonth: _propTypes2.default.bool,
  includeTime: _propTypes2.default.bool
};

ElapsedTimeFormatter.defaultProps = {
  includeTime: false
};

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.onEscapeBound = _this.onEscape.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.classList.add('no-scroll');
      document.addEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.classList.remove('no-scroll');
      document.removeEventListener('keyup', this.onEscapeBound);
    }
  }, {
    key: 'onEscape',
    value: function onEscape(e) {
      // ESC key
      if (e.keyCode === 27) {
        this.props.closeCallback();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        height: this.props.height + 'px',
        width: this.props.width + 'px',
        marginTop: '-' + this.props.height / 2 + 'px',
        marginLeft: '-' + this.props.width / 2 + 'px',
        background: '#fff'
      };

      return _react2.default.createElement(
        'div',
        { className: 'oe-modal' },
        _react2.default.createElement('div', { className: 'modal-overlay', onClick: this.props.closeCallback }),
        _react2.default.createElement(
          'div',
          { className: 'modal-contents', style: style },
          this.props.children
        )
      );
    }
  }]);
  return Modal;
}(_react.Component);

exports.default = Modal;


Modal.propTypes = {
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  children: _propTypes2.default.object,
  closeCallback: _propTypes2.default.func
};

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAvatar = function (_Component) {
  (0, _inherits3.default)(UserAvatar, _Component);

  function UserAvatar(props) {
    (0, _classCallCheck3.default)(this, UserAvatar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserAvatar.__proto__ || (0, _getPrototypeOf2.default)(UserAvatar)).call(this, props));

    _this.hideOverlayBound = _this.hideOverlay.bind(_this);
    _this.showOverlayBound = _this.showOverlay.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          borderRadius = _props.borderRadius,
          photoUrl = _props.photoUrl,
          isMentor = _props.isMentor,
          clickHandler = _props.clickHandler,
          _props$displayTooltip = _props.displayTooltip,
          displayTooltip = _props$displayTooltip === undefined ? true : _props$displayTooltip;


      var tooltipId = Math.floor(Math.random() * 1000000) + 1;
      var style = {
        width: (size || 0) + 'px',
        height: (size || 0) + 'px',
        borderRadius: (borderRadius || 0) + 'px'
      };

      return _react2.default.createElement(
        'div',
        { className: 'avatar' },
        _react2.default.createElement(
          'div',
          {
            className: 'user-photo-wrapper',
            style: style,
            onClick: clickHandler || undefined,
            onMouseOver: this.showOverlayBound,
            onMouseOut: this.hideOverlayBound,
            'data-tip': 'Mentor',
            'data-for': '' + tooltipId },
          _react2.default.createElement('img', { src: photoUrl, style: style }),
          _react2.default.createElement(
            'div',
            { className: 'overlay', style: style },
            '\xA0'
          ),
          isMentor && _react2.default.createElement('div', {
            className: 'mentor',
            style: { borderWidth: '0 0 ' + size / 3 + 'px ' + size / 3 + 'px' } })
        ),
        isMentor && displayTooltip && _react2.default.createElement(_reactTooltip2.default, { id: '' + tooltipId, effect: 'solid' })
      );
    }
  }, {
    key: 'showOverlay',
    value: function showOverlay(e) {
      e.currentTarget.classList.add('avatar-hovered');
    }
  }, {
    key: 'hideOverlay',
    value: function hideOverlay(e) {
      e.currentTarget.classList.remove('avatar-hovered');
    }
  }]);
  return UserAvatar;
}(_react.Component);

exports.default = UserAvatar;


UserAvatar.propTypes = {
  size: _propTypes2.default.number,
  borderRadius: _propTypes2.default.number,
  photoUrl: _propTypes2.default.string,
  clickHandler: _propTypes2.default.func,
  isMentor: _propTypes2.default.bool,
  displayTooltip: _propTypes2.default.bool
};

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _time = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Time = function (_Component) {
  (0, _inherits3.default)(Time, _Component);

  function Time() {
    (0, _classCallCheck3.default)(this, Time);
    return (0, _possibleConstructorReturn3.default)(this, (Time.__proto__ || (0, _getPrototypeOf2.default)(Time)).apply(this, arguments));
  }

  (0, _createClass3.default)(Time, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cssClass = _props.cssClass,
          time = _props.time;


      return _react2.default.createElement(
        'div',
        { className: 'oe-date ' + (cssClass || '') },
        _moment2.default.unix(time).format('h:mm a')
      );
    }
  }]);
  return Time;
}(_react.Component);

exports.default = Time;


Time.propTypes = {
  cssClass: _propTypes2.default.string,
  time: _propTypes2.default.number.isRequired
};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _logger = __webpack_require__(1396);

var Logger = _interopRequireWildcard(_logger);

var _network = __webpack_require__(659);

var Network = _interopRequireWildcard(_network);

var _time = __webpack_require__(267);

var Time = _interopRequireWildcard(_time);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

module.exports = {
  Logger: Logger,
  Network: Network,
  Time: Time
};

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetch = __webpack_require__(47);
var network = __webpack_require__(659);

var POST_LOGGING_REQUEST = 'POST_LOGGING_REQUEST';
var POST_LOGGING_SUCCESS = 'POST_LOGGING_SUCCESS';
var POST_LOGGING_FAILURE = 'POST_LOGGING_FAILURE';

function postLoggingRequest() {
  return {
    type: POST_LOGGING_REQUEST
  };
}

function postLoggingSuccess() {
  return {
    type: POST_LOGGING_SUCCESS
  };
}

function postLoggingFailure(error) {
  return {
    type: POST_LOGGING_FAILURE,
    payload: {
      status: error.response.status,
      statusText: 'There was an error logging analytics information.'
    }
  };
}

function postLoggingInfo(token, loggingId, collection, data) {
  return function (dispatch) {
    dispatch(postLoggingRequest());
    return fetch('https://oe-log-service.herokuapp.com/api/projects/' + loggingId + '/events/' + collection, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: data
    }).then(network.checkHttpStatus).then(function () {
      return dispatch(postLoggingSuccess());
    }).catch(function (error) {
      dispatch(postLoggingFailure(error));
    });
  };
}

module.exports = {
  POST_LOGGING_REQUEST: POST_LOGGING_REQUEST,
  POST_LOGGING_SUCCESS: POST_LOGGING_SUCCESS,
  POST_LOGGING_FAILURE: POST_LOGGING_FAILURE,
  postLoggingInfo: postLoggingInfo
};

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1398);


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var assign       = __webpack_require__(86).assign;
var Renderer     = __webpack_require__(1399);
var ParserCore   = __webpack_require__(1401);
var ParserBlock  = __webpack_require__(1412);
var ParserInline = __webpack_require__(1427);
var Ruler        = __webpack_require__(333);

/**
 * Preset configs
 */

var config = {
  'default':    __webpack_require__(1446),
  'full':       __webpack_require__(1447),
  'commonmark': __webpack_require__(1448)
};

/**
 * The `StateCore` class manages state.
 *
 * @param {Object} `instance` Remarkable instance
 * @param {String} `str` Markdown string
 * @param {Object} `env`
 */

function StateCore(instance, str, env) {
  this.src = str;
  this.env = env;
  this.options = instance.options;
  this.tokens = [];
  this.inlineMode = false;

  this.inline = instance.inline;
  this.block = instance.block;
  this.renderer = instance.renderer;
  this.typographer = instance.typographer;
}

/**
 * The main `Remarkable` class. Create an instance of
 * `Remarkable` with a `preset` and/or `options`.
 *
 * @param {String} `preset` If no preset is given, `default` is used.
 * @param {Object} `options`
 */

function Remarkable(preset, options) {
  if (typeof preset !== 'string') {
    options = preset;
    preset = 'default';
  }

  this.inline   = new ParserInline();
  this.block    = new ParserBlock();
  this.core     = new ParserCore();
  this.renderer = new Renderer();
  this.ruler    = new Ruler();

  this.options  = {};
  this.configure(config[preset]);
  this.set(options || {});
}

/**
 * Set options as an alternative to passing them
 * to the constructor.
 *
 * ```js
 * md.set({typographer: true});
 * ```
 * @param {Object} `options`
 * @api public
 */

Remarkable.prototype.set = function (options) {
  assign(this.options, options);
};

/**
 * Batch loader for components rules states, and options
 *
 * @param  {Object} `presets`
 */

Remarkable.prototype.configure = function (presets) {
  var self = this;

  if (!presets) { throw new Error('Wrong `remarkable` preset, check name/content'); }
  if (presets.options) { self.set(presets.options); }
  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enable(presets.components[name].rules, true);
      }
    });
  }
};

/**
 * Use a plugin.
 *
 * ```js
 * var md = new Remarkable();
 *
 * md.use(plugin1)
 *   .use(plugin2, opts)
 *   .use(plugin3);
 * ```
 *
 * @param  {Function} `plugin`
 * @param  {Object} `options`
 * @return {Object} `Remarkable` for chaining
 */

Remarkable.prototype.use = function (plugin, options) {
  plugin(this, options);
  return this;
};


/**
 * Parse the input `string` and return a tokens array.
 * Modifies `env` with definitions data.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parse = function (str, env) {
  var state = new StateCore(this, str, env);
  this.core.process(state);
  return state.tokens;
};

/**
 * The main `.render()` method that does all the magic :)
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {String} Rendered HTML.
 */

Remarkable.prototype.render = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parse(str, env), this.options, env);
};

/**
 * Parse the given content `string` as a single string.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parseInline = function (str, env) {
  var state = new StateCore(this, str, env);
  state.inlineMode = true;
  this.core.process(state);
  return state.tokens;
};

/**
 * Render a single content `string`, without wrapping it
 * to paragraphs
 *
 * @param  {String} `str`
 * @param  {Object} `env`
 * @return {String}
 */

Remarkable.prototype.renderInline = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parseInline(str, env), this.options, env);
};

/**
 * Expose `Remarkable`
 */

module.exports = Remarkable;

/**
 * Expose `utils`, Useful helper functions for custom
 * rendering.
 */

module.exports.utils = __webpack_require__(86);


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var utils = __webpack_require__(86);
var rules = __webpack_require__(1400);

/**
 * Expose `Renderer`
 */

module.exports = Renderer;

/**
 * Renderer class. Renders HTML and exposes `rules` to allow
 * local modifications.
 */

function Renderer() {
  this.rules = utils.assign({}, rules);

  // exported helper, for custom rules only
  this.getBreak = rules.getBreak;
}

/**
 * Render a string of inline HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.renderInline = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = 0;
  var result = '';

  while (len--) {
    result += _rules[tokens[i].type](tokens, i++, options, env, this);
  }

  return result;
};

/**
 * Render a string of HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.render = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = -1;
  var result = '';

  while (++i < len) {
    if (tokens[i].type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else {
      result += _rules[tokens[i].type](tokens, i, options, env, this);
    }
  }
  return result;
};


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var has             = __webpack_require__(86).has;
var unescapeMd      = __webpack_require__(86).unescapeMd;
var replaceEntities = __webpack_require__(86).replaceEntities;
var escapeHtml      = __webpack_require__(86).escapeHtml;

/**
 * Renderer rules cache
 */

var rules = {};

/**
 * Blockquotes
 */

rules.blockquote_open = function(/* tokens, idx, options, env */) {
  return '<blockquote>\n';
};

rules.blockquote_close = function(tokens, idx /*, options, env */) {
  return '</blockquote>' + getBreak(tokens, idx);
};

/**
 * Code
 */

rules.code = function(tokens, idx /*, options, env */) {
  if (tokens[idx].block) {
    return '<pre><code>' + escapeHtml(tokens[idx].content) + '</code></pre>' + getBreak(tokens, idx);
  }
  return '<code>' + escapeHtml(tokens[idx].content) + '</code>';
};

/**
 * Fenced code blocks
 */

rules.fence = function(tokens, idx, options, env, instance) {
  var token = tokens[idx];
  var langClass = '';
  var langPrefix = options.langPrefix;
  var langName = '', fences, fenceName;
  var highlighted;

  if (token.params) {

    //
    // ```foo bar
    //
    // Try custom renderer "foo" first. That will simplify overwrite
    // for diagrams, latex, and any other fenced block with custom look
    //

    fences = token.params.split(/\s+/g);
    fenceName = fences.join(' ');

    if (has(instance.rules.fence_custom, fences[0])) {
      return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
    }

    langName = escapeHtml(replaceEntities(unescapeMd(fenceName)));
    langClass = ' class="' + langPrefix + langName + '"';
  }

  if (options.highlight) {
    highlighted = options.highlight.apply(options.highlight, [ token.content ].concat(fences))
      || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  return '<pre><code' + langClass + '>'
        + highlighted
        + '</code></pre>'
        + getBreak(tokens, idx);
};

rules.fence_custom = {};

/**
 * Headings
 */

rules.heading_open = function(tokens, idx /*, options, env */) {
  return '<h' + tokens[idx].hLevel + '>';
};
rules.heading_close = function(tokens, idx /*, options, env */) {
  return '</h' + tokens[idx].hLevel + '>\n';
};

/**
 * Horizontal rules
 */

rules.hr = function(tokens, idx, options /*, env */) {
  return (options.xhtmlOut ? '<hr />' : '<hr>') + getBreak(tokens, idx);
};

/**
 * Bullets
 */

rules.bullet_list_open = function(/* tokens, idx, options, env */) {
  return '<ul>\n';
};
rules.bullet_list_close = function(tokens, idx /*, options, env */) {
  return '</ul>' + getBreak(tokens, idx);
};

/**
 * List items
 */

rules.list_item_open = function(/* tokens, idx, options, env */) {
  return '<li>';
};
rules.list_item_close = function(/* tokens, idx, options, env */) {
  return '</li>\n';
};

/**
 * Ordered list items
 */

rules.ordered_list_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  var order = token.order > 1 ? ' start="' + token.order + '"' : '';
  return '<ol' + order + '>\n';
};
rules.ordered_list_close = function(tokens, idx /*, options, env */) {
  return '</ol>' + getBreak(tokens, idx);
};

/**
 * Paragraphs
 */

rules.paragraph_open = function(tokens, idx /*, options, env */) {
  return tokens[idx].tight ? '' : '<p>';
};
rules.paragraph_close = function(tokens, idx /*, options, env */) {
  var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === 'inline' && !tokens[idx - 1].content);
  return (tokens[idx].tight ? '' : '</p>') + (addBreak ? getBreak(tokens, idx) : '');
};

/**
 * Links
 */

rules.link_open = function(tokens, idx, options /* env */) {
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var target = options.linkTarget ? (' target="' + options.linkTarget + '"') : '';
  return '<a href="' + escapeHtml(tokens[idx].href) + '"' + title + target + '>';
};
rules.link_close = function(/* tokens, idx, options, env */) {
  return '</a>';
};

/**
 * Images
 */

rules.image = function(tokens, idx, options /*, env */) {
  var src = ' src="' + escapeHtml(tokens[idx].src) + '"';
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var alt = ' alt="' + (tokens[idx].alt ? escapeHtml(replaceEntities(unescapeMd(tokens[idx].alt))) : '') + '"';
  var suffix = options.xhtmlOut ? ' /' : '';
  return '<img' + src + alt + title + suffix + '>';
};

/**
 * Tables
 */

rules.table_open = function(/* tokens, idx, options, env */) {
  return '<table>\n';
};
rules.table_close = function(/* tokens, idx, options, env */) {
  return '</table>\n';
};
rules.thead_open = function(/* tokens, idx, options, env */) {
  return '<thead>\n';
};
rules.thead_close = function(/* tokens, idx, options, env */) {
  return '</thead>\n';
};
rules.tbody_open = function(/* tokens, idx, options, env */) {
  return '<tbody>\n';
};
rules.tbody_close = function(/* tokens, idx, options, env */) {
  return '</tbody>\n';
};
rules.tr_open = function(/* tokens, idx, options, env */) {
  return '<tr>';
};
rules.tr_close = function(/* tokens, idx, options, env */) {
  return '</tr>\n';
};
rules.th_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<th'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.th_close = function(/* tokens, idx, options, env */) {
  return '</th>';
};
rules.td_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<td'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.td_close = function(/* tokens, idx, options, env */) {
  return '</td>';
};

/**
 * Bold
 */

rules.strong_open = function(/* tokens, idx, options, env */) {
  return '<strong>';
};
rules.strong_close = function(/* tokens, idx, options, env */) {
  return '</strong>';
};

/**
 * Italicize
 */

rules.em_open = function(/* tokens, idx, options, env */) {
  return '<em>';
};
rules.em_close = function(/* tokens, idx, options, env */) {
  return '</em>';
};

/**
 * Strikethrough
 */

rules.del_open = function(/* tokens, idx, options, env */) {
  return '<del>';
};
rules.del_close = function(/* tokens, idx, options, env */) {
  return '</del>';
};

/**
 * Insert
 */

rules.ins_open = function(/* tokens, idx, options, env */) {
  return '<ins>';
};
rules.ins_close = function(/* tokens, idx, options, env */) {
  return '</ins>';
};

/**
 * Highlight
 */

rules.mark_open = function(/* tokens, idx, options, env */) {
  return '<mark>';
};
rules.mark_close = function(/* tokens, idx, options, env */) {
  return '</mark>';
};

/**
 * Super- and sub-script
 */

rules.sub = function(tokens, idx /*, options, env */) {
  return '<sub>' + escapeHtml(tokens[idx].content) + '</sub>';
};
rules.sup = function(tokens, idx /*, options, env */) {
  return '<sup>' + escapeHtml(tokens[idx].content) + '</sup>';
};

/**
 * Breaks
 */

rules.hardbreak = function(tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
rules.softbreak = function(tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};

/**
 * Text
 */

rules.text = function(tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};

/**
 * Content
 */

rules.htmlblock = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
rules.htmltag = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/**
 * Abbreviations, initialism
 */

rules.abbr_open = function(tokens, idx /*, options, env */) {
  return '<abbr title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '">';
};
rules.abbr_close = function(/* tokens, idx, options, env */) {
  return '</abbr>';
};

/**
 * Footnotes
 */

rules.footnote_ref = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + ']</a></sup>';
};
rules.footnote_block_open = function(tokens, idx, options) {
  var hr = options.xhtmlOut
    ? '<hr class="footnotes-sep" />\n'
    : '<hr class="footnotes-sep">\n';
  return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
rules.footnote_block_close = function() {
  return '</ol>\n</section>\n';
};
rules.footnote_open = function(tokens, idx) {
  var id = Number(tokens[idx].id + 1).toString();
  return '<li id="fn' + id + '"  class="footnote-item">';
};
rules.footnote_close = function() {
  return '</li>\n';
};
rules.footnote_anchor = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return ' <a href="#' + id + '" class="footnote-backref">↩</a>';
};

/**
 * Definition lists
 */

rules.dl_open = function() {
  return '<dl>\n';
};
rules.dt_open = function() {
  return '<dt>';
};
rules.dd_open = function() {
  return '<dd>';
};
rules.dl_close = function() {
  return '</dl>\n';
};
rules.dt_close = function() {
  return '</dt>\n';
};
rules.dd_close = function() {
  return '</dd>\n';
};

/**
 * Helper functions
 */

function nextToken(tokens, idx) {
  if (++idx >= tokens.length - 2) {
    return idx;
  }
  if ((tokens[idx].type === 'paragraph_open' && tokens[idx].tight) &&
      (tokens[idx + 1].type === 'inline' && tokens[idx + 1].content.length === 0) &&
      (tokens[idx + 2].type === 'paragraph_close' && tokens[idx + 2].tight)) {
    return nextToken(tokens, idx + 2);
  }
  return idx;
}

/**
 * Check to see if `\n` is needed before the next token.
 *
 * @param  {Array} `tokens`
 * @param  {Number} `idx`
 * @return {String} Empty string or newline
 * @api private
 */

var getBreak = rules.getBreak = function getBreak(tokens, idx) {
  idx = nextToken(tokens, idx);
  if (idx < tokens.length && tokens[idx].type === 'list_item_close') {
    return '';
  }
  return '\n';
};

/**
 * Expose `rules`
 */

module.exports = rules;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var Ruler = __webpack_require__(333);

/**
 * Core parser `rules`
 */

var _rules = [
  [ 'block',          __webpack_require__(1402)          ],
  [ 'abbr',           __webpack_require__(1403)           ],
  [ 'references',     __webpack_require__(1404)     ],
  [ 'inline',         __webpack_require__(1405)         ],
  [ 'footnote_tail',  __webpack_require__(1406)  ],
  [ 'abbr2',          __webpack_require__(1407)          ],
  [ 'replacements',   __webpack_require__(1408)   ],
  [ 'smartquotes',    __webpack_require__(1409)    ],
  [ 'linkify',        __webpack_require__(1410)        ]
];

/**
 * Class for top level (`core`) parser rules
 *
 * @api private
 */

function Core() {
  this.options = {};
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}

/**
 * Process rules with the given `state`
 *
 * @param  {Object} `state`
 * @api private
 */

Core.prototype.process = function (state) {
  var i, l, rules;
  rules = this.ruler.getRules('');
  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

/**
 * Expose `Core`
 */

module.exports = Core;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function block(state) {

  if (state.inlineMode) {
    state.tokens.push({
      type: 'inline',
      content: state.src.replace(/\n/g, ' ').trim(),
      level: 0,
      lines: [ 0, 1 ],
      children: []
    });

  } else {
    state.block.parse(state.src, state.options, state.env, state.tokens);
  }
};


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse abbreviation definitions, i.e. `*[abbr]: description`
//




var StateInline    = __webpack_require__(452);
var parseLinkLabel = __webpack_require__(334);


function parseAbbr(str, parserInline, options, env) {
  var state, labelEnd, pos, max, label, title;

  if (str.charCodeAt(0) !== 0x2A/* * */) { return -1; }
  if (str.charCodeAt(1) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parserInline, options, env, []);
  labelEnd = parseLinkLabel(state, 1);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // abbr title is always one line, so looking for ending "\n" here
  for (pos = labelEnd + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x0A) { break; }
  }

  label = str.slice(2, labelEnd);
  title = str.slice(labelEnd + 2, pos).trim();
  if (title.length === 0) { return -1; }
  if (!env.abbreviations) { env.abbreviations = {}; }
  // prepend ':' to avoid conflict with Object.prototype members
  if (typeof env.abbreviations[':' + label] === 'undefined') {
    env.abbreviations[':' + label] = title;
  }

  return pos;
}

module.exports = function abbr(state) {
  var tokens = state.tokens, i, l, content, pos;

  if (state.inlineMode) {
    return;
  }

  // Parse inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i - 1].type === 'paragraph_open' &&
        tokens[i].type === 'inline' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseAbbr(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
};


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var StateInline          = __webpack_require__(452);
var parseLinkLabel       = __webpack_require__(334);
var parseLinkDestination = __webpack_require__(661);
var parseLinkTitle       = __webpack_require__(663);
var normalizeReference   = __webpack_require__(664);


function parseReference(str, parser, options, env) {
  var state, labelEnd, pos, max, code, start, href, title, label;

  if (str.charCodeAt(0) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parser, options, env, []);
  labelEnd = parseLinkLabel(state, 0);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  if (!parseLinkDestination(state, pos)) { return -1; }
  href = state.linkContent;
  pos = state.pos;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (pos = pos + 1; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
    title = state.linkContent;
    pos = state.pos;
  } else {
    title = '';
    pos = start;
  }

  // ensure that the end of the line is empty
  while (pos < max && state.src.charCodeAt(pos) === 0x20/* space */) { pos++; }
  if (pos < max && state.src.charCodeAt(pos) !== 0x0A) { return -1; }

  label = normalizeReference(str.slice(1, labelEnd));
  if (typeof env.references[label] === 'undefined') {
    env.references[label] = { title: title, href: href };
  }

  return pos;
}


module.exports = function references(state) {
  var tokens = state.tokens, i, l, content, pos;

  state.env.references = state.env.references || {};

  if (state.inlineMode) {
    return;
  }

  // Scan definitions in paragraph inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i].type === 'inline' &&
        tokens[i - 1].type === 'paragraph_open' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseReference(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
};


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.inline.parse(tok.content, state.options, state.env, tok.children);
    }
  }
};


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function footnote_block(state) {
  var i, l, j, t, lastParagraph, list, tokens, current, currentLabel,
      level = 0,
      insideRef = false,
      refTokens = {};

  if (!state.env.footnotes) { return; }

  state.tokens = state.tokens.filter(function(tok) {
    if (tok.type === 'footnote_reference_open') {
      insideRef = true;
      current = [];
      currentLabel = tok.label;
      return false;
    }
    if (tok.type === 'footnote_reference_close') {
      insideRef = false;
      // prepend ':' to avoid conflict with Object.prototype members
      refTokens[':' + currentLabel] = current;
      return false;
    }
    if (insideRef) { current.push(tok); }
    return !insideRef;
  });

  if (!state.env.footnotes.list) { return; }
  list = state.env.footnotes.list;

  state.tokens.push({
    type: 'footnote_block_open',
    level: level++
  });
  for (i = 0, l = list.length; i < l; i++) {
    state.tokens.push({
      type: 'footnote_open',
      id: i,
      level: level++
    });

    if (list[i].tokens) {
      tokens = [];
      tokens.push({
        type: 'paragraph_open',
        tight: false,
        level: level++
      });
      tokens.push({
        type: 'inline',
        content: '',
        level: level,
        children: list[i].tokens
      });
      tokens.push({
        type: 'paragraph_close',
        tight: false,
        level: --level
      });
    } else if (list[i].label) {
      tokens = refTokens[':' + list[i].label];
    }

    state.tokens = state.tokens.concat(tokens);
    if (state.tokens[state.tokens.length - 1].type === 'paragraph_close') {
      lastParagraph = state.tokens.pop();
    } else {
      lastParagraph = null;
    }

    t = list[i].count > 0 ? list[i].count : 1;
    for (j = 0; j < t; j++) {
      state.tokens.push({
        type: 'footnote_anchor',
        id: i,
        subId: j,
        level: level
      });
    }

    if (lastParagraph) {
      state.tokens.push(lastParagraph);
    }

    state.tokens.push({
      type: 'footnote_close',
      level: --level
    });
  }
  state.tokens.push({
    type: 'footnote_block_close',
    level: --level
  });
};


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Enclose abbreviations in <abbr> tags
//



var PUNCT_CHARS = ' \n()[]\'".,!?-';


// from Google closure library
// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
function regEscape(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1');
}


module.exports = function abbr2(state) {
  var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText,
      blockTokens = state.tokens;

  if (!state.env.abbreviations) { return; }
  if (!state.env.abbrRegExp) {
    regText = '(^|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])'
            + '(' + Object.keys(state.env.abbreviations).map(function (x) {
                      return x.substr(1);
                    }).sort(function (a, b) {
                      return b.length - a.length;
                    }).map(regEscape).join('|') + ')'
            + '($|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])';
    state.env.abbrRegExp = new RegExp(regText, 'g');
  }
  reg = state.env.abbrRegExp;

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') { continue; }
    tokens = blockTokens[j].children;

    // We scan from the end, to keep position when new tags added.
    for (i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token.type !== 'text') { continue; }

      pos = 0;
      text = token.content;
      reg.lastIndex = 0;
      level = token.level;
      nodes = [];

      while ((m = reg.exec(text))) {
        if (reg.lastIndex > pos) {
          nodes.push({
            type: 'text',
            content: text.slice(pos, m.index + m[1].length),
            level: level
          });
        }

        nodes.push({
          type: 'abbr_open',
          title: state.env.abbreviations[':' + m[2]],
          level: level++
        });
        nodes.push({
          type: 'text',
          content: m[2],
          level: level
        });
        nodes.push({
          type: 'abbr_close',
          level: --level
        });
        pos = reg.lastIndex - m[3].length;
      }

      if (!nodes.length) { continue; }

      if (pos < text.length) {
        nodes.push({
          type: 'text',
          content: text.slice(pos),
          level: level
        });
      }

      // replace current node
      blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
    }
  }
};


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Simple typographical replacements
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  'c': '©',
  'r': '®',
  'p': '§',
  'tm': '™'
};

function replaceScopedAbbr(str) {
  if (str.indexOf('(') < 0) { return str; }

  return str.replace(SCOPED_ABBR_RE, function(match, name) {
    return SCOPED_ABBR[name.toLowerCase()];
  });
}


module.exports = function replace(state) {
  var i, token, text, inlineTokens, blkIdx;

  if (!state.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    inlineTokens = state.tokens[blkIdx].children;

    for (i = inlineTokens.length - 1; i >= 0; i--) {
      token = inlineTokens[i];
      if (token.type === 'text') {
        text = token.content;

        text = replaceScopedAbbr(text);

        if (RARE_RE.test(text)) {
          text = text
            .replace(/\+-/g, '±')
            // .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
            .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
            // em-dash
            .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
            // en-dash
            .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2')
            .replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
        }

        token.content = text;
      }
    }
  }
};


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert straight quotation marks to typographic ones
//



var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var PUNCT_RE = /[-\s()\[\]]/;
var APOSTROPHE = '’';

// This function returns true if the character at `pos`
// could be inside a word.
function isLetter(str, pos) {
  if (pos < 0 || pos >= str.length) { return false; }
  return !PUNCT_RE.test(str[pos]);
}


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}


module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item,
      canOpen, canClose, j, isSingle, blkIdx, tokens,
      stack;

  if (!state.options.typographer) { return; }

  stack = [];

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    tokens = state.tokens[blkIdx].children;
    stack.length = 0;

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];

      if (token.type !== 'text' || QUOTE_TEST_RE.test(token.text)) { continue; }

      thisLevel = tokens[i].level;

      for (j = stack.length - 1; j >= 0; j--) {
        if (stack[j].level <= thisLevel) { break; }
      }
      stack.length = j + 1;

      text = token.content;
      pos = 0;
      max = text.length;

      /*eslint no-labels:0,block-scoped-var:0*/
      OUTER:
      while (pos < max) {
        QUOTE_RE.lastIndex = pos;
        t = QUOTE_RE.exec(text);
        if (!t) { break; }

        lastSpace = !isLetter(text, t.index - 1);
        pos = t.index + 1;
        isSingle = (t[0] === "'");
        nextSpace = !isLetter(text, pos);

        if (!nextSpace && !lastSpace) {
          // middle of word
          if (isSingle) {
            token.content = replaceAt(token.content, t.index, APOSTROPHE);
          }
          continue;
        }

        canOpen = !nextSpace;
        canClose = !lastSpace;

        if (canClose) {
          // this could be a closing quote, rewind the stack to get a match
          for (j = stack.length - 1; j >= 0; j--) {
            item = stack[j];
            if (stack[j].level < thisLevel) { break; }
            if (item.single === isSingle && stack[j].level === thisLevel) {
              item = stack[j];
              if (isSingle) {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[3]);
              } else {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[1]);
              }
              stack.length = j;
              continue OUTER;
            }
          }
        }

        if (canOpen) {
          stack.push({
            token: i,
            pos: t.index,
            single: isSingle,
            level: thisLevel
          });
        } else if (canClose && isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
      }
    }
  }
};


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `inline.validateLink()` to http/https/ftp
//



var Autolinker = __webpack_require__(1411);


var LINK_SCAN_RE = /www|@|\:\/\//;


function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}

// Stupid fabric to avoid singletons, for thread safety.
// Required for engines like Nashorn.
//
function createLinkifier() {
  var links = [];
  var autolinker = new Autolinker({
    stripPrefix: false,
    url: true,
    email: true,
    twitter: false,
    replaceFn: function (linker, match) {
      // Only collect matched strings but don't change anything.
      switch (match.getType()) {
        /*eslint default-case:0*/
        case 'url':
          links.push({
            text: match.matchedText,
            url: match.getUrl()
          });
          break;
        case 'email':
          links.push({
            text: match.matchedText,
            // normalize email protocol
            url: 'mailto:' + match.getEmail().replace(/^mailto:/i, '')
          });
          break;
      }
      return false;
    }
  });

  return {
    links: links,
    autolinker: autolinker
  };
}


module.exports = function linkify(state) {
  var i, j, l, tokens, token, text, nodes, ln, pos, level, htmlLinkLevel,
      blockTokens = state.tokens,
      linkifier = null, links, autolinker;

  if (!state.options.linkify) { return; }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') { continue; }
    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];

      // Skip content of markdown links
      if (token.type === 'link_close') {
        i--;
        while (tokens[i].level !== token.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (token.type === 'htmltag') {
        if (isLinkOpen(token.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(token.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) { continue; }

      if (token.type === 'text' && LINK_SCAN_RE.test(token.content)) {

        // Init linkifier in lazy manner, only if required.
        if (!linkifier) {
          linkifier = createLinkifier();
          links = linkifier.links;
          autolinker = linkifier.autolinker;
        }

        text = token.content;
        links.length = 0;
        autolinker.link(text);

        if (!links.length) { continue; }

        // Now split string to nodes
        nodes = [];
        level = token.level;

        for (ln = 0; ln < links.length; ln++) {

          if (!state.inline.validateLink(links[ln].url)) { continue; }

          pos = text.indexOf(links[ln].text);

          if (pos) {
            level = level;
            nodes.push({
              type: 'text',
              content: text.slice(0, pos),
              level: level
            });
          }
          nodes.push({
            type: 'link_open',
            href: links[ln].url,
            title: '',
            level: level++
          });
          nodes.push({
            type: 'text',
            content: links[ln].text,
            level: level
          });
          nodes.push({
            type: 'link_close',
            level: --level
          });
          text = text.slice(pos + links[ln].text.length);
        }
        if (text.length) {
          nodes.push({
            type: 'text',
            content: text,
            level: level
          });
        }

        // replace current node
        blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
      }
    }
  }
};


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Autolinker.js
 * 0.28.1
 *
 * Copyright(c) 2016 Gregory Jacobs <greg@greg-jacobs.com>
 * MIT License
 *
 * https://github.com/gregjacobs/Autolinker.js
 */
;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Autolinker = factory();
  }
}(this, function() {
/**
 * @class Autolinker
 * @extends Object
 *
 * Utility class used to process a given string of text, and wrap the matches in
 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
 *
 * Any of the configuration options may be provided in an Object (map) provided
 * to the Autolinker constructor, which will configure how the {@link #link link()}
 * method will process the links.
 *
 * For example:
 *
 *     var autolinker = new Autolinker( {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *
 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * The {@link #static-link static link()} method may also be used to inline
 * options into a single call, which may be more convenient for one-off uses.
 * For example:
 *
 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * ## Custom Replacements of Links
 *
 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
 * may be provided to fully customize the output of Autolinker. This function is
 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
 * encountered.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
 *                         tag.setAttr( 'rel', 'nofollow' );
 *                         tag.addClass( 'external-link' );
 *
 *                         return tag;
 *
 *                     } else {
 *                         return true;  // let Autolinker perform its normal anchor tag replacement
 *                     }
 *
 *                 case 'email' :
 *                     var email = match.getEmail();
 *                     console.log( "email: ", email );
 *
 *                     if( email === "my@own.address" ) {
 *                         return false;  // don't auto-link this particular email address; leave as-is
 *                     } else {
 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
 *                     }
 *
 *                 case 'phone' :
 *                     var phoneNumber = match.getPhoneNumber();
 *                     console.log( phoneNumber );
 *
 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
 *
 *                 case 'twitter' :
 *                     var twitterHandle = match.getTwitterHandle();
 *                     console.log( twitterHandle );
 *
 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
 *
 *                 case 'hashtag' :
 *                     var hashtag = match.getHashtag();
 *                     console.log( hashtag );
 *
 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
 *             }
 *         }
 *     } );
 *
 *
 * The function may return the following values:
 *
 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
 *   would.
 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
 * - Any String: If a string is returned from the function, the string will be
 *   used directly as the replacement HTML for the match.
 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
 *   an HTML tag before writing out its HTML text.
 *
 * @constructor
 * @param {Object} [cfg] The configuration options for the Autolinker instance,
 *   specified in an Object (map).
 */
var Autolinker = function( cfg ) {
	cfg = cfg || {};

	this.version = Autolinker.version;

	this.urls = this.normalizeUrlsCfg( cfg.urls );
	this.email = typeof cfg.email === 'boolean' ? cfg.email : true;
	this.twitter = typeof cfg.twitter === 'boolean' ? cfg.twitter : true;
	this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : true;
	this.hashtag = cfg.hashtag || false;
	this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : true;
	this.stripPrefix = typeof cfg.stripPrefix === 'boolean' ? cfg.stripPrefix : true;

	// Validate the value of the `hashtag` cfg.
	var hashtag = this.hashtag;
	if( hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram' ) {
		throw new Error( "invalid `hashtag` cfg - see docs" );
	}

	this.truncate = this.normalizeTruncateCfg( cfg.truncate );
	this.className = cfg.className || '';
	this.replaceFn = cfg.replaceFn || null;

	this.htmlParser = null;
	this.matchers = null;
	this.tagBuilder = null;
};



/**
 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
 * and Hashtags found in the given chunk of HTML. Does not link URLs found
 * within HTML tags.
 *
 * For instance, if given the text: `You should go to http://www.yahoo.com`,
 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
 *
 * Example:
 *
 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
 *
 * @static
 * @param {String} textOrHtml The HTML or text to find matches within (depending
 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
 *   and {@link #hashtag} options are enabled).
 * @param {Object} [options] Any of the configuration options for the Autolinker
 *   class, specified in an Object (map). See the class description for an
 *   example call.
 * @return {String} The HTML text, with matches automatically linked.
 */
Autolinker.link = function( textOrHtml, options ) {
	var autolinker = new Autolinker( options );
	return autolinker.link( textOrHtml );
};


/**
 * @static
 * @property {String} version (readonly)
 *
 * The Autolinker version number in the form major.minor.patch
 *
 * Ex: 0.25.1
 */
Autolinker.version = '0.28.1';


Autolinker.prototype = {
	constructor : Autolinker,  // fix constructor property

	/**
	 * @cfg {Boolean/Object} [urls=true]
	 *
	 * `true` if URLs should be automatically linked, `false` if they should not
	 * be.
	 *
	 * This option also accepts an Object form with 3 properties, to allow for
	 * more customization of what exactly gets linked. All default to `true`:
	 *
	 * @param {Boolean} schemeMatches `true` to match URLs found prefixed with a
	 *   scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
	 *   `false` to prevent these types of matches.
	 * @param {Boolean} wwwMatches `true` to match urls found prefixed with
	 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
	 *   matches. Note that if the URL had a prefixed scheme, and
	 *   `schemeMatches` is true, it will still be linked.
	 * @param {Boolean} tldMatches `true` to match URLs with known top level
	 *   domains (.com, .net, etc.) that are not prefixed with a scheme or
	 *   `'www.'`. This option attempts to match anything that looks like a URL
	 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
	 *   to prevent these types of matches.
	 */

	/**
	 * @cfg {Boolean} [email=true]
	 *
	 * `true` if email addresses should be automatically linked, `false` if they
	 * should not be.
	 */

	/**
	 * @cfg {Boolean} [twitter=true]
	 *
	 * `true` if Twitter handles ("@example") should be automatically linked,
	 * `false` if they should not be.
	 */

	/**
	 * @cfg {Boolean} [phone=true]
	 *
	 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
	 * `false` if they should not be.
	 */

	/**
	 * @cfg {Boolean/String} [hashtag=false]
	 *
	 * A string for the service name to have hashtags (ex: "#myHashtag")
	 * auto-linked to. The currently-supported values are:
	 *
	 * - 'twitter'
	 * - 'facebook'
	 * - 'instagram'
	 *
	 * Pass `false` to skip auto-linking of hashtags.
	 */

	/**
	 * @cfg {Boolean} [newWindow=true]
	 *
	 * `true` if the links should open in a new window, `false` otherwise.
	 */

	/**
	 * @cfg {Boolean} [stripPrefix=true]
	 *
	 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
	 * from the beginning of URL links' text, `false` otherwise.
	 */

	/**
	 * @cfg {Number/Object} [truncate=0]
	 *
	 * ## Number Form
	 *
	 * A number for how many characters matched text should be truncated to
	 * inside the text of a link. If the matched text is over this number of
	 * characters, it will be truncated to this length by adding a two period
	 * ellipsis ('..') to the end of the string.
	 *
	 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
	 * truncated to 25 characters might look something like this:
	 * 'yahoo.com/some/long/pat..'
	 *
	 * Example Usage:
	 *
	 *     truncate: 25
	 *
	 *
	 *  Defaults to `0` for "no truncation."
	 *
	 *
	 * ## Object Form
	 *
	 * An Object may also be provided with two properties: `length` (Number) and
	 * `location` (String). `location` may be one of the following: 'end'
	 * (default), 'middle', or 'smart'.
	 *
	 * Example Usage:
	 *
	 *     truncate: { length: 25, location: 'middle' }
	 *
	 * @cfg {Number} [truncate.length=0] How many characters to allow before
	 *   truncation will occur. Defaults to `0` for "no truncation."
	 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
	 *
	 * - 'end' (default): will truncate up to the number of characters, and then
	 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
	 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
	 *   'yahoo.com/s..th/to/a/file'
	 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
	 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
	 *   attempting to make the URL human-readable before looking for a good
	 *   point to insert the ellipsis if it is still too long. Ex:
	 *   'yahoo.com/some..to/a/file'. For more details, see
	 *   {@link Autolinker.truncate.TruncateSmart}.
	 */

	/**
	 * @cfg {String} className
	 *
	 * A CSS class name to add to the generated links. This class will be added
	 * to all links, as well as this class plus match suffixes for styling
	 * url/email/phone/twitter/hashtag links differently.
	 *
	 * For example, if this config is provided as "myLink", then:
	 *
	 * - URL links will have the CSS classes: "myLink myLink-url"
	 * - Email links will have the CSS classes: "myLink myLink-email", and
	 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
	 * - Phone links will have the CSS classes: "myLink myLink-phone"
	 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
	 */

	/**
	 * @cfg {Function} replaceFn
	 *
	 * A function to individually process each match found in the input string.
	 *
	 * See the class's description for usage.
	 *
	 * This function is called with the following parameters:
	 *
	 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may
	 *   be used to retrieve child objects from (such as the instance's
	 *   {@link #getTagBuilder tag builder}).
	 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
	 *   can be used to retrieve information about the match that the `replaceFn`
	 *   is currently processing. See {@link Autolinker.match.Match} subclasses
	 *   for details.
	 */


	/**
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */

	/**
	 * @private
	 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
	 *
	 * The HtmlParser instance used to skip over HTML tags, while finding text
	 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
	 * method.
	 */

	/**
	 * @private
	 * @property {Autolinker.matcher.Matcher[]} matchers
	 *
	 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
	 * instance.
	 *
	 * This is lazily created in {@link #getMatchers}.
	 */

	/**
	 * @private
	 * @property {Autolinker.AnchorTagBuilder} tagBuilder
	 *
	 * The AnchorTagBuilder instance used to build match replacement anchor tags.
	 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
	 */


	/**
	 * Normalizes the {@link #urls} config into an Object with 3 properties:
	 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
	 *
	 * See {@link #urls} config for details.
	 *
	 * @private
	 * @param {Boolean/Object} urls
	 * @return {Object}
	 */
	normalizeUrlsCfg : function( urls ) {
		if( urls == null ) urls = true;  // default to `true`

		if( typeof urls === 'boolean' ) {
			return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };

		} else {  // object form
			return {
				schemeMatches : typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
				wwwMatches    : typeof urls.wwwMatches === 'boolean'    ? urls.wwwMatches    : true,
				tldMatches    : typeof urls.tldMatches === 'boolean'    ? urls.tldMatches    : true
			};
		}
	},


	/**
	 * Normalizes the {@link #truncate} config into an Object with 2 properties:
	 * `length` (Number), and `location` (String).
	 *
	 * See {@link #truncate} config for details.
	 *
	 * @private
	 * @param {Number/Object} truncate
	 * @return {Object}
	 */
	normalizeTruncateCfg : function( truncate ) {
		if( typeof truncate === 'number' ) {
			return { length: truncate, location: 'end' };

		} else {  // object, or undefined/null
			return Autolinker.Util.defaults( truncate || {}, {
				length   : Number.POSITIVE_INFINITY,
				location : 'end'
			} );
		}
	},


	/**
	 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method is used by the {@link #link} method, but can also be used to
	 * simply do parsing of the input in order to discover what kinds of links
	 * there are and how many.
	 *
	 * @param {String} textOrHtml The HTML or text to find matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `textOrHtml`.
	 */
	parse : function( textOrHtml ) {
		var htmlParser = this.getHtmlParser(),
		    htmlNodes = htmlParser.parse( textOrHtml ),
		    anchorTagStackCount = 0,  // used to only process text around anchor tags, and any inner text/html they may have;
		    matches = [];

		// Find all matches within the `textOrHtml` (but not matches that are
		// already nested within <a> tags)
		for( var i = 0, len = htmlNodes.length; i < len; i++ ) {
			var node = htmlNodes[ i ],
			    nodeType = node.getType();

			if( nodeType === 'element' && node.getTagName() === 'a' ) {  // Process HTML anchor element nodes in the input `textOrHtml` to find out when we're within an <a> tag
				if( !node.isClosing() ) {  // it's the start <a> tag
					anchorTagStackCount++;
				} else {  // it's the end </a> tag
					anchorTagStackCount = Math.max( anchorTagStackCount - 1, 0 );  // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
				}

			} else if( nodeType === 'text' && anchorTagStackCount === 0 ) {  // Process text nodes that are not within an <a> tag
				var textNodeMatches = this.parseText( node.getText(), node.getOffset() );

				matches.push.apply( matches, textNodeMatches );
			}
		}


		// After we have found all matches, remove subsequent matches that
		// overlap with a previous match. This can happen for instance with URLs,
		// where the url 'google.com/#link' would match '#link' as a hashtag.
		matches = this.compactMatches( matches );

		// And finally, remove matches for match types that have been turned
		// off. We needed to have all match types turned on initially so that
		// things like hashtags could be filtered out if they were really just
		// part of a URL match (for instance, as a named anchor).
		matches = this.removeUnwantedMatches( matches );

		return matches;
	},


	/**
	 * After we have found all matches, we need to remove subsequent matches
	 * that overlap with a previous match. This can happen for instance with
	 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches
	 * @return {Autolinker.match.Match[]}
	 */
	compactMatches : function( matches ) {
		// First, the matches need to be sorted in order of offset
		matches.sort( function( a, b ) { return a.getOffset() - b.getOffset(); } );

		for( var i = 0; i < matches.length - 1; i++ ) {
			var match = matches[ i ],
			    endIdx = match.getOffset() + match.getMatchedText().length;

			// Remove subsequent matches that overlap with the current match
			while( i + 1 < matches.length && matches[ i + 1 ].getOffset() <= endIdx ) {
				matches.splice( i + 1, 1 );
			}
		}

		return matches;
	},


	/**
	 * Removes matches for matchers that were turned off in the options. For
	 * example, if {@link #hashtag hashtags} were not to be matched, we'll
	 * remove them from the `matches` array here.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches The array of matches to remove
	 *   the unwanted matches from. Note: this array is mutated for the
	 *   removals.
	 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
	 */
	removeUnwantedMatches : function( matches ) {
		var remove = Autolinker.Util.remove;

		if( !this.hashtag ) remove( matches, function( match ) { return match.getType() === 'hashtag'; } );
		if( !this.email )   remove( matches, function( match ) { return match.getType() === 'email'; } );
		if( !this.phone )   remove( matches, function( match ) { return match.getType() === 'phone'; } );
		if( !this.twitter ) remove( matches, function( match ) { return match.getType() === 'twitter'; } );
		if( !this.urls.schemeMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'scheme'; } );
		}
		if( !this.urls.wwwMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; } );
		}
		if( !this.urls.tldMatches ) {
			remove( matches, function( m ) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; } );
		}

		return matches;
	},


	/**
	 * Parses the input `text` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method processes a **non-HTML string**, and is used to parse and
	 * match within the text nodes of an HTML string. This method is used
	 * internally by {@link #parse}.
	 *
	 * @private
	 * @param {String} text The text to find matches within (depending on if the
	 *   {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter}, and
	 *   {@link #hashtag} options are enabled). This must be a non-HTML string.
	 * @param {Number} [offset=0] The offset of the text node within the
	 *   original string. This is used when parsing with the {@link #parse}
	 *   method to generate correct offsets within the {@link Autolinker.match.Match}
	 *   instances, but may be omitted if calling this method publicly.
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `text`.
	 */
	parseText : function( text, offset ) {
		offset = offset || 0;
		var matchers = this.getMatchers(),
		    matches = [];

		for( var i = 0, numMatchers = matchers.length; i < numMatchers; i++ ) {
			var textMatches = matchers[ i ].parseMatches( text );

			// Correct the offset of each of the matches. They are originally
			// the offset of the match within the provided text node, but we
			// need to correct them to be relative to the original HTML input
			// string (i.e. the one provided to #parse).
			for( var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++ ) {
				textMatches[ j ].setOffset( offset + textMatches[ j ].getOffset() );
			}

			matches.push.apply( matches, textMatches );
		}
		return matches;
	},


	/**
	 * Automatically links URLs, Email addresses, Phone numbers, Twitter
	 * handles, and Hashtags found in the given chunk of HTML. Does not link
	 * URLs found within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to
	 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * This method finds the text around any HTML elements in the input
	 * `textOrHtml`, which will be the text that is processed. Any original HTML
	 * elements will be left as-is, as well as the text that is already wrapped
	 * in anchor (&lt;a&gt;) tags.
	 *
	 * @param {String} textOrHtml The HTML or text to autolink matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {String} The HTML, with matches automatically linked.
	 */
	link : function( textOrHtml ) {
		if( !textOrHtml ) { return ""; }  // handle `null` and `undefined`

		var matches = this.parse( textOrHtml ),
			newHtml = [],
			lastIndex = 0;

		for( var i = 0, len = matches.length; i < len; i++ ) {
			var match = matches[ i ];

			newHtml.push( textOrHtml.substring( lastIndex, match.getOffset() ) );
			newHtml.push( this.createMatchReturnVal( match ) );

			lastIndex = match.getOffset() + match.getMatchedText().length;
		}
		newHtml.push( textOrHtml.substring( lastIndex ) );  // handle the text after the last match

		return newHtml.join( '' );
	},


	/**
	 * Creates the return string value for a given match in the input string.
	 *
	 * This method handles the {@link #replaceFn}, if one was provided.
	 *
	 * @private
	 * @param {Autolinker.match.Match} match The Match object that represents
	 *   the match.
	 * @return {String} The string that the `match` should be replaced with.
	 *   This is usually the anchor tag string, but may be the `matchStr` itself
	 *   if the match is not to be replaced.
	 */
	createMatchReturnVal : function( match ) {
		// Handle a custom `replaceFn` being provided
		var replaceFnResult;
		if( this.replaceFn ) {
			replaceFnResult = this.replaceFn.call( this, this, match );  // Autolinker instance is the context, and the first arg
		}

		if( typeof replaceFnResult === 'string' ) {
			return replaceFnResult;  // `replaceFn` returned a string, use that

		} else if( replaceFnResult === false ) {
			return match.getMatchedText();  // no replacement for the match

		} else if( replaceFnResult instanceof Autolinker.HtmlTag ) {
			return replaceFnResult.toAnchorString();

		} else {  // replaceFnResult === true, or no/unknown return value from function
			// Perform Autolinker's default anchor tag generation
			var anchorTag = match.buildTag();  // returns an Autolinker.HtmlTag instance

			return anchorTag.toAnchorString();
		}
	},


	/**
	 * Lazily instantiates and returns the {@link #htmlParser} instance for this
	 * Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.htmlParser.HtmlParser}
	 */
	getHtmlParser : function() {
		var htmlParser = this.htmlParser;

		if( !htmlParser ) {
			htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
		}

		return htmlParser;
	},


	/**
	 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
	 * instances for this Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.matcher.Matcher[]}
	 */
	getMatchers : function() {
		if( !this.matchers ) {
			var matchersNs = Autolinker.matcher,
			    tagBuilder = this.getTagBuilder();

			var matchers = [
				new matchersNs.Hashtag( { tagBuilder: tagBuilder, serviceName: this.hashtag } ),
				new matchersNs.Email( { tagBuilder: tagBuilder } ),
				new matchersNs.Phone( { tagBuilder: tagBuilder } ),
				new matchersNs.Twitter( { tagBuilder: tagBuilder } ),
				new matchersNs.Url( { tagBuilder: tagBuilder, stripPrefix: this.stripPrefix } )
			];

			return ( this.matchers = matchers );

		} else {
			return this.matchers;
		}
	},


	/**
	 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
	 * if it does not yet exist.
	 *
	 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
	 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 * @return {Autolinker.AnchorTagBuilder}
	 */
	getTagBuilder : function() {
		var tagBuilder = this.tagBuilder;

		if( !tagBuilder ) {
			tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder( {
				newWindow   : this.newWindow,
				truncate    : this.truncate,
				className   : this.className
			} );
		}

		return tagBuilder;
	}

};


// Autolinker Namespaces

Autolinker.match = {};
Autolinker.matcher = {};
Autolinker.htmlParser = {};
Autolinker.truncate = {};

/*global Autolinker */
/*jshint eqnull:true, boss:true */
/**
 * @class Autolinker.Util
 * @singleton
 *
 * A few utility methods for Autolinker.
 */
Autolinker.Util = {

	/**
	 * @property {Function} abstractMethod
	 *
	 * A function object which represents an abstract method.
	 */
	abstractMethod : function() { throw "abstract"; },


	/**
	 * @private
	 * @property {RegExp} trimRegex
	 *
	 * The regular expression used to trim the leading and trailing whitespace
	 * from a string.
	 */
	trimRegex : /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,


	/**
	 * Assigns (shallow copies) the properties of `src` onto `dest`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */
	assign : function( dest, src ) {
		for( var prop in src ) {
			if( src.hasOwnProperty( prop ) ) {
				dest[ prop ] = src[ prop ];
			}
		}

		return dest;
	},


	/**
	 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
	 * corresponding property on `dest` === `undefined`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */
	defaults : function( dest, src ) {
		for( var prop in src ) {
			if( src.hasOwnProperty( prop ) && dest[ prop ] === undefined ) {
				dest[ prop ] = src[ prop ];
			}
		}

		return dest;
	},


	/**
	 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
	 *
	 * @param {Function} superclass The constructor function for the superclass.
	 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
	 *   special property `constructor`, which will be used as the new subclass's constructor function.
	 * @return {Function} The new subclass function.
	 */
	extend : function( superclass, protoProps ) {
		var superclassProto = superclass.prototype;

		var F = function() {};
		F.prototype = superclassProto;

		var subclass;
		if( protoProps.hasOwnProperty( 'constructor' ) ) {
			subclass = protoProps.constructor;
		} else {
			subclass = function() { superclassProto.constructor.apply( this, arguments ); };
		}

		var subclassProto = subclass.prototype = new F();  // set up prototype chain
		subclassProto.constructor = subclass;  // fix constructor property
		subclassProto.superclass = superclassProto;

		delete protoProps.constructor;  // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
		Autolinker.Util.assign( subclassProto, protoProps );

		return subclass;
	},


	/**
	 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
	 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
	 * `len`, the string will be returned unchanged.
	 *
	 * @param {String} str The string to truncate and add an ellipsis to.
	 * @param {Number} truncateLen The length to truncate the string at.
	 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
	 *   when truncated. Defaults to '..'
	 */
	ellipsis : function( str, truncateLen, ellipsisChars ) {
		if( str.length > truncateLen ) {
			ellipsisChars = ( ellipsisChars == null ) ? '..' : ellipsisChars;
			str = str.substring( 0, truncateLen - ellipsisChars.length ) + ellipsisChars;
		}
		return str;
	},


	/**
	 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
	 *
	 * @param {Array} arr The array to find an element of.
	 * @param {*} element The element to find in the array, and return the index of.
	 * @return {Number} The index of the `element`, or -1 if it was not found.
	 */
	indexOf : function( arr, element ) {
		if( Array.prototype.indexOf ) {
			return arr.indexOf( element );

		} else {
			for( var i = 0, len = arr.length; i < len; i++ ) {
				if( arr[ i ] === element ) return i;
			}
			return -1;
		}
	},


	/**
	 * Removes array elements based on a filtering function. Mutates the input
	 * array.
	 *
	 * Using this instead of the ES5 Array.prototype.filter() function, to allow
	 * Autolinker compatibility with IE8, and also to prevent creating many new
	 * arrays in memory for filtering.
	 *
	 * @param {Array} arr The array to remove elements from. This array is
	 *   mutated.
	 * @param {Function} fn A function which should return `true` to
	 *   remove an element.
	 * @return {Array} The mutated input `arr`.
	 */
	remove : function( arr, fn ) {
		for( var i = arr.length - 1; i >= 0; i-- ) {
			if( fn( arr[ i ] ) === true ) {
				arr.splice( i, 1 );
			}
		}
	},


	/**
	 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
	 * with a regular expression that contains capturing parenthesis.
	 *
	 * For example:
	 *
	 *     // Modern browsers:
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
	 *
	 *     // Old IE (including IE8):
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
	 *
	 * This method emulates the functionality of modern browsers for the old IE case.
	 *
	 * @param {String} str The string to split.
	 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
	 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
	 *   description of this method.
	 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
	 *   Note #2: for simplicity's sake, the regular expression does not need
	 *   to contain capturing parenthesis - it will be assumed that any match has them.
	 * @return {String[]} The split array of strings, with the splitting character(s) included.
	 */
	splitAndCapture : function( str, splitRegex ) {
		if( !splitRegex.global ) throw new Error( "`splitRegex` must have the 'g' flag set" );

		var result = [],
		    lastIdx = 0,
		    match;

		while( match = splitRegex.exec( str ) ) {
			result.push( str.substring( lastIdx, match.index ) );
			result.push( match[ 0 ] );  // push the splitting char(s)

			lastIdx = match.index + match[ 0 ].length;
		}
		result.push( str.substring( lastIdx ) );

		return result;
	},


	/**
	 * Trims the leading and trailing whitespace from a string.
	 *
	 * @param {String} str The string to trim.
	 * @return {String}
	 */
	trim : function( str ) {
		return str.replace( this.trimRegex, '' );
	}

};
/*global Autolinker */
/*jshint boss:true */
/**
 * @class Autolinker.HtmlTag
 * @extends Object
 *
 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
 *
 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
 *
 * ## Examples
 *
 * Example instantiation:
 *
 *     var tag = new Autolinker.HtmlTag( {
 *         tagName : 'a',
 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
 *         innerHtml : 'Google'
 *     } );
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *     // Individual accessor methods
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *
 * Using mutator methods (which may be used in combination with instantiation config properties):
 *
 *     var tag = new Autolinker.HtmlTag();
 *     tag.setTagName( 'a' );
 *     tag.setAttr( 'href', 'http://google.com' );
 *     tag.addClass( 'external-link' );
 *     tag.setInnerHtml( 'Google' );
 *
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *
 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 *
 *
 * ## Example use with a new tag for the replacement
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = new Autolinker.HtmlTag( {
 *                 tagName : 'button',
 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
 *             } );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
 */
Autolinker.HtmlTag = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {String} tagName
	 *
	 * The tag name. Ex: 'a', 'button', etc.
	 *
	 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
	 * is executed.
	 */

	/**
	 * @cfg {Object.<String, String>} attrs
	 *
	 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
	 * values are the attribute values.
	 */

	/**
	 * @cfg {String} innerHtml
	 *
	 * The inner HTML for the tag.
	 *
	 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
	 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
	 * if you prefer, but this one is recommended.
	 */

	/**
	 * @cfg {String} innerHTML
	 *
	 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
	 * for acronym names.
	 */


	/**
	 * @protected
	 * @property {RegExp} whitespaceRegex
	 *
	 * Regular expression used to match whitespace in a string of CSS classes.
	 */
	whitespaceRegex : /\s+/,


	/**
	 * @constructor
	 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
	 */
	constructor : function( cfg ) {
		Autolinker.Util.assign( this, cfg );

		this.innerHtml = this.innerHtml || this.innerHTML;  // accept either the camelCased form or the fully capitalized acronym
	},


	/**
	 * Sets the tag name that will be used to generate the tag with.
	 *
	 * @param {String} tagName
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setTagName : function( tagName ) {
		this.tagName = tagName;
		return this;
	},


	/**
	 * Retrieves the tag name.
	 *
	 * @return {String}
	 */
	getTagName : function() {
		return this.tagName || "";
	},


	/**
	 * Sets an attribute on the HtmlTag.
	 *
	 * @param {String} attrName The attribute name to set.
	 * @param {String} attrValue The attribute value to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setAttr : function( attrName, attrValue ) {
		var tagAttrs = this.getAttrs();
		tagAttrs[ attrName ] = attrValue;

		return this;
	},


	/**
	 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
	 *
	 * @param {String} attrName The attribute name to retrieve.
	 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
	 */
	getAttr : function( attrName ) {
		return this.getAttrs()[ attrName ];
	},


	/**
	 * Sets one or more attributes on the HtmlTag.
	 *
	 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setAttrs : function( attrs ) {
		var tagAttrs = this.getAttrs();
		Autolinker.Util.assign( tagAttrs, attrs );

		return this;
	},


	/**
	 * Retrieves the attributes Object (map) for the HtmlTag.
	 *
	 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
	 */
	getAttrs : function() {
		return this.attrs || ( this.attrs = {} );
	},


	/**
	 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setClass : function( cssClass ) {
		return this.setAttr( 'class', cssClass );
	},


	/**
	 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to add.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	addClass : function( cssClass ) {
		var classAttr = this.getClass(),
		    whitespaceRegex = this.whitespaceRegex,
		    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
		    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
		    newClasses = cssClass.split( whitespaceRegex ),
		    newClass;

		while( newClass = newClasses.shift() ) {
			if( indexOf( classes, newClass ) === -1 ) {
				classes.push( newClass );
			}
		}

		this.getAttrs()[ 'class' ] = classes.join( " " );
		return this;
	},


	/**
	 * Convenience method to remove one or more CSS classes from the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to remove.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	removeClass : function( cssClass ) {
		var classAttr = this.getClass(),
		    whitespaceRegex = this.whitespaceRegex,
		    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
		    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
		    removeClasses = cssClass.split( whitespaceRegex ),
		    removeClass;

		while( classes.length && ( removeClass = removeClasses.shift() ) ) {
			var idx = indexOf( classes, removeClass );
			if( idx !== -1 ) {
				classes.splice( idx, 1 );
			}
		}

		this.getAttrs()[ 'class' ] = classes.join( " " );
		return this;
	},


	/**
	 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
	 * there are multiple.
	 *
	 * @return {String}
	 */
	getClass : function() {
		return this.getAttrs()[ 'class' ] || "";
	},


	/**
	 * Convenience method to check if the tag has a CSS class or not.
	 *
	 * @param {String} cssClass The CSS class to check for.
	 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
	 */
	hasClass : function( cssClass ) {
		return ( ' ' + this.getClass() + ' ' ).indexOf( ' ' + cssClass + ' ' ) !== -1;
	},


	/**
	 * Sets the inner HTML for the tag.
	 *
	 * @param {String} html The inner HTML to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */
	setInnerHtml : function( html ) {
		this.innerHtml = html;

		return this;
	},


	/**
	 * Retrieves the inner HTML for the tag.
	 *
	 * @return {String}
	 */
	getInnerHtml : function() {
		return this.innerHtml || "";
	},


	/**
	 * Override of superclass method used to generate the HTML string for the tag.
	 *
	 * @return {String}
	 */
	toAnchorString : function() {
		var tagName = this.getTagName(),
		    attrsStr = this.buildAttrsStr();

		attrsStr = ( attrsStr ) ? ' ' + attrsStr : '';  // prepend a space if there are actually attributes

		return [ '<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>' ].join( "" );
	},


	/**
	 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
	 * the stringified HtmlTag.
	 *
	 * @protected
	 * @return {String} Example return: `attr1="value1" attr2="value2"`
	 */
	buildAttrsStr : function() {
		if( !this.attrs ) return "";  // no `attrs` Object (map) has been set, return empty string

		var attrs = this.getAttrs(),
		    attrsArr = [];

		for( var prop in attrs ) {
			if( attrs.hasOwnProperty( prop ) ) {
				attrsArr.push( prop + '="' + attrs[ prop ] + '"' );
			}
		}
		return attrsArr.join( " " );
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.RegexLib
 * @singleton
 *
 * Builds and stores a library of the common regular expressions used by the
 * Autolinker utility.
 *
 * Other regular expressions may exist ad-hoc, but these are generally the
 * regular expressions that are shared between source files.
 */
Autolinker.RegexLib = (function() {

	/**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars in the unicode character set when placed in a
	 * RegExp character class (`[]`). This includes all international alphabetic
	 * characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}`
	 * escape ("all letters").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */
	var alphaCharsStr = 'A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';

	/**
	 * The string form of a regular expression that would match all of the
	 * decimal number chars in the unicode character set when placed in a RegExp
	 * character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{Nd}`
	 * escape ("all decimal numbers")
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */
	var decimalNumbersStr = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';


	// See documentation below
	var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;


	// See documentation below
	var domainNameRegex = new RegExp( '[' + alphaNumericCharsStr + '.\\-]*[' + alphaNumericCharsStr + '\\-]' );


	// See documentation below
	var tldRegex = /(?:travelersinsurance|sandvikcoromant|kerryproperties|cancerresearch|weatherchannel|kerrylogistics|spreadbetting|international|wolterskluwer|lifeinsurance|construction|pamperedchef|scholarships|versicherung|bridgestone|creditunion|kerryhotels|investments|productions|blackfriday|enterprises|lamborghini|photography|motorcycles|williamhill|playstation|contractors|barclaycard|accountants|redumbrella|engineering|management|telefonica|protection|consulting|tatamotors|creditcard|vlaanderen|schaeffler|associates|properties|foundation|republican|bnpparibas|boehringer|eurovision|extraspace|industries|immobilien|university|technology|volkswagen|healthcare|restaurant|cuisinella|vistaprint|apartments|accountant|travelers|homedepot|institute|vacations|furniture|fresenius|insurance|christmas|bloomberg|solutions|barcelona|firestone|financial|kuokgroup|fairwinds|community|passagens|goldpoint|equipment|lifestyle|yodobashi|aquarelle|marketing|analytics|education|amsterdam|statefarm|melbourne|allfinanz|directory|microsoft|stockholm|montblanc|accenture|lancaster|landrover|everbank|istanbul|graphics|grainger|ipiranga|softbank|attorney|pharmacy|saarland|catering|airforce|yokohama|mortgage|frontier|mutuelle|stcgroup|memorial|pictures|football|symantec|cipriani|ventures|telecity|cityeats|verisign|flsmidth|boutique|cleaning|firmdale|clinique|clothing|redstone|infiniti|deloitte|feedback|services|broadway|plumbing|commbank|training|barclays|exchange|computer|brussels|software|delivery|barefoot|builders|business|bargains|engineer|holdings|download|security|helsinki|lighting|movistar|discount|hdfcbank|supplies|marriott|property|diamonds|capetown|partners|democrat|jpmorgan|bradesco|budapest|rexroth|zuerich|shriram|academy|science|support|youtube|singles|surgery|alibaba|statoil|dentist|schwarz|android|cruises|cricket|digital|markets|starhub|systems|courses|coupons|netbank|country|domains|corsica|network|neustar|realtor|lincoln|limited|schmidt|yamaxun|cooking|contact|auction|spiegel|liaison|leclerc|latrobe|lasalle|abogado|compare|lanxess|exposed|express|company|cologne|college|avianca|lacaixa|fashion|recipes|ferrero|komatsu|storage|wanggou|clubmed|sandvik|fishing|fitness|bauhaus|kitchen|flights|florist|flowers|watches|weather|temasek|samsung|bentley|forsale|channel|theater|frogans|theatre|okinawa|website|tickets|jewelry|gallery|tiffany|iselect|shiksha|brother|organic|wedding|genting|toshiba|origins|philips|hyundai|hotmail|hoteles|hosting|rentals|windows|cartier|bugatti|holiday|careers|whoswho|hitachi|panerai|caravan|reviews|guitars|capital|trading|hamburg|hangout|finance|stream|family|abbott|health|review|travel|report|hermes|hiphop|gratis|career|toyota|hockey|dating|repair|google|social|soccer|reisen|global|otsuka|giving|unicom|casino|photos|center|broker|rocher|orange|bostik|garden|insure|ryukyu|bharti|safety|physio|sakura|oracle|online|jaguar|gallup|piaget|tienda|futbol|pictet|joburg|webcam|berlin|office|juegos|kaufen|chanel|chrome|xihuan|church|tennis|circle|kinder|flickr|bayern|claims|clinic|viajes|nowruz|xperia|norton|yachts|studio|coffee|camera|sanofi|nissan|author|expert|events|comsec|lawyer|tattoo|viking|estate|villas|condos|realty|yandex|energy|emerck|virgin|vision|durban|living|school|coupon|london|taobao|natura|taipei|nagoya|luxury|walter|aramco|sydney|madrid|credit|maison|makeup|schule|market|anquan|direct|design|swatch|suzuki|alsace|vuelos|dental|alipay|voyage|shouji|voting|airtel|mutual|degree|supply|agency|museum|mobily|dealer|monash|select|mormon|active|moscow|racing|datsun|quebec|nissay|rodeo|email|gifts|works|photo|chloe|edeka|cheap|earth|vista|tushu|koeln|glass|shoes|globo|tunes|gmail|nokia|space|kyoto|black|ricoh|seven|lamer|sener|epson|cisco|praxi|trust|citic|crown|shell|lease|green|legal|lexus|ninja|tatar|gripe|nikon|group|video|wales|autos|gucci|party|nexus|guide|linde|adult|parts|amica|lixil|boats|azure|loans|locus|cymru|lotte|lotto|stada|click|poker|quest|dabur|lupin|nadex|paris|faith|dance|canon|place|gives|trade|skype|rocks|mango|cloud|boots|smile|final|swiss|homes|honda|media|horse|cards|deals|watch|bosch|house|pizza|miami|osaka|tours|total|xerox|coach|sucks|style|delta|toray|iinet|tools|money|codes|beats|tokyo|salon|archi|movie|baidu|study|actor|yahoo|store|apple|world|forex|today|bible|tmall|tirol|irish|tires|forum|reise|vegas|vodka|sharp|omega|weber|jetzt|audio|promo|build|bingo|chase|gallo|drive|dubai|rehab|press|solar|sale|beer|bbva|bank|band|auto|sapo|sarl|saxo|audi|asia|arte|arpa|army|yoga|ally|zara|scor|scot|sexy|seat|zero|seek|aero|adac|zone|aarp|maif|meet|meme|menu|surf|mini|mobi|mtpc|porn|desi|star|ltda|name|talk|navy|love|loan|live|link|news|limo|like|spot|life|nico|lidl|lgbt|land|taxi|team|tech|kred|kpmg|sony|song|kiwi|kddi|jprs|jobs|sohu|java|itau|tips|info|immo|icbc|hsbc|town|host|page|toys|here|help|pars|haus|guru|guge|tube|goog|golf|gold|sncf|gmbh|gift|ggee|gent|gbiz|game|vana|pics|fund|ford|ping|pink|fish|film|fast|farm|play|fans|fail|plus|skin|pohl|fage|moda|post|erni|dvag|prod|doha|prof|docs|viva|diet|luxe|site|dell|sina|dclk|show|qpon|date|vote|cyou|voto|read|coop|cool|wang|club|city|chat|cern|cash|reit|rent|casa|cars|care|camp|rest|call|cafe|weir|wien|rich|wiki|buzz|wine|book|bond|room|work|rsvp|shia|ruhr|blue|bing|shaw|bike|safe|xbox|best|pwc|mtn|lds|aig|boo|fyi|nra|nrw|ntt|car|gal|obi|zip|aeg|vin|how|one|ong|onl|dad|ooo|bet|esq|org|htc|bar|uol|ibm|ovh|gdn|ice|icu|uno|gea|ifm|bot|top|wtf|lol|day|pet|eus|wtc|ubs|tvs|aco|ing|ltd|ink|tab|abb|afl|cat|int|pid|pin|bid|cba|gle|com|cbn|ads|man|wed|ceb|gmo|sky|ist|gmx|tui|mba|fan|ski|iwc|app|pro|med|ceo|jcb|jcp|goo|dev|men|aaa|meo|pub|jlc|bom|jll|gop|jmp|mil|got|gov|win|jot|mma|joy|trv|red|cfa|cfd|bio|moe|moi|mom|ren|biz|aws|xin|bbc|dnp|buy|kfh|mov|thd|xyz|fit|kia|rio|rip|kim|dog|vet|nyc|bcg|mtr|bcn|bms|bmw|run|bzh|rwe|tel|stc|axa|kpn|fly|krd|cab|bnl|foo|crs|eat|tci|sap|srl|nec|sas|net|cal|sbs|sfr|sca|scb|csc|edu|new|xxx|hiv|fox|wme|ngo|nhk|vip|sex|frl|lat|yun|law|you|tax|soy|sew|om|ac|hu|se|sc|sg|sh|sb|sa|rw|ru|rs|ro|re|qa|py|si|pw|pt|ps|sj|sk|pr|pn|pm|pl|sl|sm|pk|sn|ph|so|pg|pf|pe|pa|zw|nz|nu|nr|np|no|nl|ni|ng|nf|sr|ne|st|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|su|mn|mm|ml|mk|mh|mg|me|sv|md|mc|sx|sy|ma|ly|lv|sz|lu|lt|ls|lr|lk|li|lc|lb|la|tc|kz|td|ky|kw|kr|kp|kn|km|ki|kh|tf|tg|th|kg|ke|jp|jo|jm|je|it|is|ir|tj|tk|tl|tm|iq|tn|to|io|in|im|il|ie|ad|sd|ht|hr|hn|hm|tr|hk|gy|gw|gu|gt|gs|gr|gq|tt|gp|gn|gm|gl|tv|gi|tw|tz|ua|gh|ug|uk|gg|gf|ge|gd|us|uy|uz|va|gb|ga|vc|ve|fr|fo|fm|fk|fj|vg|vi|fi|eu|et|es|er|eg|ee|ec|dz|do|dm|dk|vn|dj|de|cz|cy|cx|cw|vu|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|wf|bz|by|bw|bv|bt|bs|br|bo|bn|bm|bj|bi|ws|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ye|ar|aq|ao|am|al|yt|ai|za|ag|af|ae|zm|id)\b/;


	return {

		/**
		 * The string form of a regular expression that would match all of the
		 * letters and decimal number chars in the unicode character set when placed
		 * in a RegExp character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
		 * escape ("all letters and decimal numbers")
		 *
		 * @property {String} alphaNumericCharsStr
		 */
		alphaNumericCharsStr : alphaNumericCharsStr,

		/**
		 * A regular expression to match domain names of a URL or email address.
		 * Ex: 'google', 'yahoo', 'some-other-company', etc.
		 *
		 * @property {RegExp} domainNameRegex
		 */
		domainNameRegex : domainNameRegex,

		/**
		 * A regular expression to match top level domains (TLDs) for a URL or
		 * email address. Ex: 'com', 'org', 'net', etc.
		 *
		 * @property {RegExp} tldRegex
		 */
		tldRegex : tldRegex

	};


}() );
/*global Autolinker */
/*jshint sub:true */
/**
 * @protected
 * @class Autolinker.AnchorTagBuilder
 * @extends Object
 *
 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
 * found.
 *
 * Normally this class is instantiated, configured, and used internally by an
 * {@link Autolinker} instance, but may actually be retrieved in a {@link Autolinker#replaceFn replaceFn}
 * to create {@link Autolinker.HtmlTag HtmlTag} instances which may be modified
 * before returning from the {@link Autolinker#replaceFn replaceFn}. For
 * example:
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 */
Autolinker.AnchorTagBuilder = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Boolean} newWindow
	 * @inheritdoc Autolinker#newWindow
	 */

	/**
	 * @cfg {Object} truncate
	 * @inheritdoc Autolinker#truncate
	 */

	/**
	 * @cfg {String} className
	 * @inheritdoc Autolinker#className
	 */


	/**
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.Util.assign( this, cfg );
	},


	/**
	 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
	 * matched text, via its `match` object.
	 *
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
	 */
	build : function( match ) {
		return new Autolinker.HtmlTag( {
			tagName   : 'a',
			attrs     : this.createAttrs( match.getType(), match.getAnchorHref() ),
			innerHtml : this.processAnchorText( match.getAnchorText() )
		} );
	},


	/**
	 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
	 *   tag being generated.
	 *
	 * @protected
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @param {String} anchorHref The href for the anchor tag.
	 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
	 */
	createAttrs : function( matchType, anchorHref ) {
		var attrs = {
			'href' : anchorHref  // we'll always have the `href` attribute
		};

		var cssClass = this.createCssClass( matchType );
		if( cssClass ) {
			attrs[ 'class' ] = cssClass;
		}
		if( this.newWindow ) {
			attrs[ 'target' ] = "_blank";
			attrs[ 'rel' ] = "noopener noreferrer";
		}

		return attrs;
	},


	/**
	 * Creates the CSS class that will be used for a given anchor tag, based on
	 * the `matchType` and the {@link #className} config.
	 *
	 * @private
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @return {String} The CSS class string for the link. Example return:
	 *   "myLink myLink-url". If no {@link #className} was configured, returns
	 *   an empty string.
	 */
	createCssClass : function( matchType ) {
		var className = this.className;

		if( !className )
			return "";
		else
			return className + " " + className + "-" + matchType;  // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
	},


	/**
	 * Processes the `anchorText` by truncating the text according to the
	 * {@link #truncate} config.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The processed `anchorText`.
	 */
	processAnchorText : function( anchorText ) {
		anchorText = this.doTruncate( anchorText );

		return anchorText;
	},


	/**
	 * Performs the truncation of the `anchorText` based on the {@link #truncate}
	 * option. If the `anchorText` is longer than the length specified by the
	 * {@link #truncate} option, the truncation is performed based on the
	 * `location` property. See {@link #truncate} for details.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The truncated anchor text.
	 */
	doTruncate : function( anchorText ) {
		var truncate = this.truncate;
		if( !truncate || !truncate.length ) return anchorText;

		var truncateLength = truncate.length,
			truncateLocation = truncate.location;

		if( truncateLocation === 'smart' ) {
			return Autolinker.truncate.TruncateSmart( anchorText, truncateLength, '..' );

		} else if( truncateLocation === 'middle' ) {
			return Autolinker.truncate.TruncateMiddle( anchorText, truncateLength, '..' );

		} else {
			return Autolinker.truncate.TruncateEnd( anchorText, truncateLength, '..' );
		}
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.htmlParser.HtmlParser
 * @extends Object
 *
 * An HTML parser implementation which simply walks an HTML string and returns an array of
 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
 *
 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
 * around" HTML tags.
 */
Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend( Object, {

	/**
	 * @private
	 * @property {RegExp} htmlRegex
	 *
	 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
	 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
	 *
	 * Capturing groups:
	 *
	 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
	 * 2. If it is an end tag, this group will have the '/'.
	 * 3. If it is a comment tag, this group will hold the comment text (i.e.
	 *    the text inside the `&lt;!--` and `--&gt;`.
	 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
	 */
	htmlRegex : (function() {
		var commentTagRegex = /!--([\s\S]+?)--/,
		    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
		    attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/,   // the unicode range accounts for excluding control chars, and the delete char
		    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, // double quoted, single quoted, or unquoted attribute values
		    nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?';  // optional '=[value]'

		return new RegExp( [
			// for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
			'(?:',
				'<(!DOCTYPE)',  // *** Capturing Group 1 - If it's a doctype tag

					// Zero or more attributes following the tag name
					'(?:',
						'\\s+',  // one or more whitespace chars before an attribute

						// Either:
						// A. attr="value", or
						// B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
						'(?:', nameEqualsValueRegex, '|', attrValueRegex.source + ')',
					')*',
				'>',
			')',

			'|',

			// All other HTML tags (i.e. tags that are not <!DOCTYPE>)
			'(?:',
				'<(/)?',  // Beginning of a tag or comment. Either '<' for a start tag, or '</' for an end tag.
				          // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.

					'(?:',
						commentTagRegex.source,  // *** Capturing Group 3 - A Comment Tag's Text

						'|',

						'(?:',

							// *** Capturing Group 4 - The tag name
							'(' + tagNameRegex.source + ')',

							// Zero or more attributes following the tag name
							'(?:',
								'(?:\\s+|\\b)',        // any number of whitespace chars before an attribute. NOTE: Using \s* here throws Chrome into an infinite loop for some reason, so using \s+|\b instead
								nameEqualsValueRegex,  // attr="value" (with optional ="value" part)
							')*',

							'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'

						')',
					')',
				'>',
			')'
		].join( "" ), 'gi' );
	} )(),

	/**
	 * @private
	 * @property {RegExp} htmlCharacterEntitiesRegex
	 *
	 * The regular expression that matches common HTML character entities.
	 *
	 * Ignoring &amp; as it could be part of a query string -- handling it separately.
	 */
	htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,


	/**
	 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
	 * to represent the HTML structure of the input string.
	 *
	 * @param {String} html The HTML to parse.
	 * @return {Autolinker.htmlParser.HtmlNode[]}
	 */
	parse : function( html ) {
		var htmlRegex = this.htmlRegex,
		    currentResult,
		    lastIndex = 0,
		    textAndEntityNodes,
		    nodes = [];  // will be the result of the method

		while( ( currentResult = htmlRegex.exec( html ) ) !== null ) {
			var tagText = currentResult[ 0 ],
			    commentText = currentResult[ 3 ], // if we've matched a comment
			    tagName = currentResult[ 1 ] || currentResult[ 4 ],  // The <!DOCTYPE> tag (ex: "!DOCTYPE"), or another tag (ex: "a" or "img")
			    isClosingTag = !!currentResult[ 2 ],
			    offset = currentResult.index,
			    inBetweenTagsText = html.substring( lastIndex, offset );

			// Push TextNodes and EntityNodes for any text found between tags
			if( inBetweenTagsText ) {
				textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, inBetweenTagsText );
				nodes.push.apply( nodes, textAndEntityNodes );
			}

			// Push the CommentNode or ElementNode
			if( commentText ) {
				nodes.push( this.createCommentNode( offset, tagText, commentText ) );
			} else {
				nodes.push( this.createElementNode( offset, tagText, tagName, isClosingTag ) );
			}

			lastIndex = offset + tagText.length;
		}

		// Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
		if( lastIndex < html.length ) {
			var text = html.substring( lastIndex );

			// Push TextNodes and EntityNodes for any text found between tags
			if( text ) {
				textAndEntityNodes = this.parseTextAndEntityNodes( lastIndex, text );
				nodes.push.apply( nodes, textAndEntityNodes );
			}
		}

		return nodes;
	},


	/**
	 * Parses text and HTML entity nodes from a given string. The input string
	 * should not have any HTML tags (elements) within it.
	 *
	 * @private
	 * @param {Number} offset The offset of the text node match within the
	 *   original HTML string.
	 * @param {String} text The string of text to parse. This is from an HTML
	 *   text node.
	 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
	 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
	 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
	 */
	parseTextAndEntityNodes : function( offset, text ) {
		var nodes = [],
		    textAndEntityTokens = Autolinker.Util.splitAndCapture( text, this.htmlCharacterEntitiesRegex );  // split at HTML entities, but include the HTML entities in the results array

		// Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
		// For example: an input `text` of "Test &quot;this&quot; today" would turn into the
		//   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
		for( var i = 0, len = textAndEntityTokens.length; i < len; i += 2 ) {
			var textToken = textAndEntityTokens[ i ],
			    entityToken = textAndEntityTokens[ i + 1 ];

			if( textToken ) {
				nodes.push( this.createTextNode( offset, textToken ) );
				offset += textToken.length;
			}
			if( entityToken ) {
				nodes.push( this.createEntityNode( offset, entityToken ) );
				offset += entityToken.length;
			}
		}
		return nodes;
	},


	/**
	 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (comment) that was
	 *   matched, including its &lt;!-- and --&gt;.
	 * @param {String} commentText The full text of the comment that was matched.
	 */
	createCommentNode : function( offset, tagText, commentText ) {
		return new Autolinker.htmlParser.CommentNode( {
			offset : offset,
			text   : tagText,
			comment: Autolinker.Util.trim( commentText )
		} );
	},


	/**
	 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (element) that was
	 *   matched, including its attributes.
	 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
	 *   be passed to this method as "img".
	 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
	 *   otherwise.
	 * @return {Autolinker.htmlParser.ElementNode}
	 */
	createElementNode : function( offset, tagText, tagName, isClosingTag ) {
		return new Autolinker.htmlParser.ElementNode( {
			offset  : offset,
			text    : tagText,
			tagName : tagName.toLowerCase(),
			closing : isClosingTag
		} );
	},


	/**
	 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched for the HTML entity (such
	 *   as '&amp;nbsp;').
	 * @return {Autolinker.htmlParser.EntityNode}
	 */
	createEntityNode : function( offset, text ) {
		return new Autolinker.htmlParser.EntityNode( { offset: offset, text: text } );
	},


	/**
	 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched.
	 * @return {Autolinker.htmlParser.TextNode}
	 */
	createTextNode : function( offset, text ) {
		return new Autolinker.htmlParser.TextNode( { offset: offset, text: text } );
	}

} );
/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML node found in an input string. An HTML node is one of the
 * following:
 *
 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
 *    HTML tags.
 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
 *    HTML comments.
 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
 *    outside or within HTML tags.
 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
 *    one of the known HTML entities that Autolinker looks for. This includes
 *    common ones such as &amp;quot; and &amp;nbsp;
 */
Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of the HTML node in the original text that was parsed.
	 */
	offset : undefined,

	/**
	 * @cfg {String} text (required)
	 *
	 * The text that was matched for the HtmlNode.
	 *
	 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
	 *   this will be the tag's text.
	 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
	 *   this will be the comment's text.
	 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
	 *   will be the text itself.
	 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
	 *   this will be the text of the HTML entity.
	 */
	text : undefined,


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 * specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.Util.assign( this, cfg );

		if( this.offset == null ) throw new Error( '`offset` cfg required' );
		if( this.text == null ) throw new Error( '`text` cfg required' );
	},


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */
	getType : Autolinker.Util.abstractMethod,


	/**
	 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
	 * HTML node in the original string that was parsed.
	 *
	 * @return {Number}
	 */
	getOffset : function() {
		return this.offset;
	},


	/**
	 * Retrieves the {@link #text} for the HtmlNode.
	 *
	 * @return {String}
	 */
	getText : function() {
		return this.text;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.CommentNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML comment node that has been parsed by the
 * {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.CommentNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * @cfg {String} comment (required)
	 *
	 * The text inside the comment tag. This text is stripped of any leading or
	 * trailing whitespace.
	 */
	comment : '',


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'comment';
	},


	/**
	 * Returns the comment inside the comment tag.
	 *
	 * @return {String}
	 */
	getComment : function() {
		return this.comment;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.ElementNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.ElementNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * @cfg {String} tagName (required)
	 *
	 * The name of the tag that was matched.
	 */
	tagName : '',

	/**
	 * @cfg {Boolean} closing (required)
	 *
	 * `true` if the element (tag) is a closing tag, `false` if its an opening
	 * tag.
	 */
	closing : false,


	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'element';
	},


	/**
	 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
	 * returns "img".
	 *
	 * @return {String}
	 */
	getTagName : function() {
		return this.tagName;
	},


	/**
	 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
	 * returns `false`, while &lt;/div&gt; returns `true`.
	 *
	 * @return {Boolean}
	 */
	isClosing : function() {
		return this.closing;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.EntityNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
 * method.
 *
 * Note that this class will only be returned from the HtmlParser for the set of
 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.EntityNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'entity';
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.htmlParser.TextNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
Autolinker.htmlParser.TextNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {

	/**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'text';
	}

} );
/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.match.Match
 *
 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                 case 'email' :
 *                     console.log( "email: ", match.getEmail() );
 *
 *                 case 'twitter' :
 *                     console.log( "twitter: ", match.getTwitterHandle() );
 *             }
 *         }
 *     } );
 *
 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
 */
Autolinker.match.Match = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate an anchor
	 * tag for the Match.
	 */

	/**
	 * @cfg {String} matchedText (required)
	 *
	 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
	 */

	/**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of where the match was made in the input string.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		if( cfg.tagBuilder == null ) throw new Error( '`tagBuilder` cfg required' );
		if( cfg.matchedText == null ) throw new Error( '`matchedText` cfg required' );
		if( cfg.offset == null ) throw new Error( '`offset` cfg required' );

		this.tagBuilder = cfg.tagBuilder;
		this.matchedText = cfg.matchedText;
		this.offset = cfg.offset;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */
	getType : Autolinker.Util.abstractMethod,


	/**
	 * Returns the original text that was matched.
	 *
	 * @return {String}
	 */
	getMatchedText : function() {
		return this.matchedText;
	},


	/**
	 * Sets the {@link #offset} of where the match was made in the input string.
	 *
	 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
	 * and will therefore set an original offset that is relative to the HTML
	 * text node itself. However, we want this offset to be relative to the full
	 * HTML input string, and thus if using {@link Autolinker#parse} (rather
	 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
	 * offset is corrected after the Matcher itself has done its job.
	 *
	 * @param {Number} offset
	 */
	setOffset : function( offset ) {
		this.offset = offset;
	},


	/**
	 * Returns the offset of where the match was made in the input string. This
	 * is the 0-based index of the match.
	 *
	 * @return {Number}
	 */
	getOffset : function() {
		return this.offset;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */
	getAnchorHref : Autolinker.Util.abstractMethod,


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */
	getAnchorText : Autolinker.Util.abstractMethod,


	/**
	 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
	 * Match.
	 *
	 * This can be used to easily generate anchor tags from matches, and either
	 * return their HTML string, or modify them before doing so.
	 *
	 * Example Usage:
	 *
	 *     var tag = match.buildTag();
	 *     tag.addClass( 'cordova-link' );
	 *     tag.setAttr( 'target', '_system' );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
	 */
	buildTag : function() {
		return this.tagBuilder.build( this );
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.match.Email
 * @extends Autolinker.match.Match
 *
 * Represents a Email match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Email = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} email (required)
	 *
	 * The email address that was matched.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.email ) throw new Error( '`email` cfg required' );

		this.email = cfg.email;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'email';
	},


	/**
	 * Returns the email address that was matched.
	 *
	 * @return {String}
	 */
	getEmail : function() {
		return this.email;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		return 'mailto:' + this.email;
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return this.email;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.match.Hashtag
 * @extends Autolinker.match.Match
 *
 * Represents a Hashtag match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */
Autolinker.match.Hashtag = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */

	/**
	 * @cfg {String} hashtag (required)
	 *
	 * The Hashtag that was matched, without the '#'.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		// TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
		if( !cfg.hashtag ) throw new Error( '`hashtag` cfg required' );

		this.serviceName = cfg.serviceName;
		this.hashtag = cfg.hashtag;
	},


	/**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'hashtag';
	},


	/**
	 * Returns the configured {@link #serviceName} to point the Hashtag to.
	 * Ex: 'facebook', 'twitter'.
	 *
	 * @return {String}
	 */
	getServiceName : function() {
		return this.serviceName;
	},


	/**
	 * Returns the matched hashtag, without the '#' character.
	 *
	 * @return {String}
	 */
	getHashtag : function() {
		return this.hashtag;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		var serviceName = this.serviceName,
		    hashtag = this.hashtag;

		switch( serviceName ) {
			case 'twitter' :
				return 'https://twitter.com/hashtag/' + hashtag;
			case 'facebook' :
				return 'https://www.facebook.com/hashtag/' + hashtag;
			case 'instagram' :
				return 'https://instagram.com/explore/tags/' + hashtag;

			default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
				throw new Error( 'Unknown service name to point hashtag to: ', serviceName );
		}
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return '#' + this.hashtag;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Phone
 * @extends Autolinker.match.Match
 *
 * Represents a Phone number match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */
Autolinker.match.Phone = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @protected
	 * @property {String} number (required)
	 *
	 * The phone number that was matched, without any delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 */

	/**
	 * @protected
	 * @property  {Boolean} plusSign (required)
	 *
	 * `true` if the matched phone number started with a '+' sign. We'll include
	 * it in the `tel:` URL if so, as this is needed for international numbers.
	 *
	 * Ex: '+1 (123) 456 7879'
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.number ) throw new Error( '`number` cfg required' );
		if( cfg.plusSign == null ) throw new Error( '`plusSign` cfg required' );

		this.number = cfg.number;
		this.plusSign = cfg.plusSign;
	},


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'phone';
	},


	/**
	 * Returns the phone number that was matched as a string, without any
	 * delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 *
	 * @return {String}
	 */
	getNumber: function() {
		return this.number;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		return 'tel:' + ( this.plusSign ? '+' : '' ) + this.number;
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return this.matchedText;
	}

} );

/*global Autolinker */
/**
 * @class Autolinker.match.Twitter
 * @extends Autolinker.match.Match
 *
 * Represents a Twitter match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Twitter = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} twitterHandle (required)
	 *
	 * The Twitter handle that was matched, without the '@' character.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( !cfg.twitterHandle ) throw new Error( '`twitterHandle` cfg required' );

		this.twitterHandle = cfg.twitterHandle;
	},


	/**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'twitter';
	},


	/**
	 * Returns the twitter handle, without the '@' character.
	 *
	 * @return {String}
	 */
	getTwitterHandle : function() {
		return this.twitterHandle;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		return 'https://twitter.com/' + this.twitterHandle;
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		return '@' + this.twitterHandle;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.match.Url
 * @extends Autolinker.match.Match
 *
 * Represents a Url match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */
Autolinker.match.Url = Autolinker.Util.extend( Autolinker.match.Match, {

	/**
	 * @cfg {String} url (required)
	 *
	 * The url that was matched.
	 */

	/**
	 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
	 *
	 * The type of URL match that this class represents. This helps to determine
	 * if the match was made in the original text with a prefixed scheme (ex:
	 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
	 * was matched by a known top-level domain (ex: 'google.com').
	 */

	/**
	 * @cfg {Boolean} protocolUrlMatch (required)
	 *
	 * `true` if the URL is a match which already has a protocol (i.e.
	 * 'http://'), `false` if the match was from a 'www' or known TLD match.
	 */

	/**
	 * @cfg {Boolean} protocolRelativeMatch (required)
	 *
	 * `true` if the URL is a protocol-relative match. A protocol-relative match
	 * is a URL that starts with '//', and will be either http:// or https://
	 * based on the protocol that the site is loaded under.
	 */

	/**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#cfg-stripPrefix
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.match.Match.prototype.constructor.call( this, cfg );

		if( cfg.urlMatchType !== 'scheme' && cfg.urlMatchType !== 'www' && cfg.urlMatchType !== 'tld' ) throw new Error( '`urlMatchType` cfg must be one of: "scheme", "www", or "tld"' );
		if( !cfg.url ) throw new Error( '`url` cfg required' );
		if( cfg.protocolUrlMatch == null ) throw new Error( '`protocolUrlMatch` cfg required' );
		if( cfg.protocolRelativeMatch == null ) throw new Error( '`protocolRelativeMatch` cfg required' );
		if( cfg.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );

		this.urlMatchType = cfg.urlMatchType;
		this.url = cfg.url;
		this.protocolUrlMatch = cfg.protocolUrlMatch;
		this.protocolRelativeMatch = cfg.protocolRelativeMatch;
		this.stripPrefix = cfg.stripPrefix;
	},


	/**
	 * @private
	 * @property {RegExp} urlPrefixRegex
	 *
	 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
	 */
	urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,

	/**
	 * @private
	 * @property {RegExp} protocolRelativeRegex
	 *
	 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
	 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
	 */
	protocolRelativeRegex : /^\/\//,

	/**
	 * @private
	 * @property {Boolean} protocolPrepended
	 *
	 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
	 * {@link #url} did not have a protocol)
	 */
	protocolPrepended : false,


	/**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */
	getType : function() {
		return 'url';
	},


	/**
	 * Returns a string name for the type of URL match that this class
	 * represents.
	 *
	 * This helps to determine if the match was made in the original text with a
	 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
	 * 'www.google.com'), or was matched by a known top-level domain (ex:
	 * 'google.com').
	 *
	 * @return {"scheme"/"www"/"tld"}
	 */
	getUrlMatchType : function() {
		return this.urlMatchType;
	},


	/**
	 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
	 * match was missing a protocol.
	 *
	 * @return {String}
	 */
	getUrl : function() {
		var url = this.url;

		// if the url string doesn't begin with a protocol, assume 'http://'
		if( !this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended ) {
			url = this.url = 'http://' + url;

			this.protocolPrepended = true;
		}

		return url;
	},


	/**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorHref : function() {
		var url = this.getUrl();

		return url.replace( /&amp;/g, '&' );  // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
	},


	/**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */
	getAnchorText : function() {
		var anchorText = this.getMatchedText();

		if( this.protocolRelativeMatch ) {
			// Strip off any protocol-relative '//' from the anchor text
			anchorText = this.stripProtocolRelativePrefix( anchorText );
		}
		if( this.stripPrefix ) {
			anchorText = this.stripUrlPrefix( anchorText );
		}
		anchorText = this.removeTrailingSlash( anchorText );  // remove trailing slash, if there is one

		return anchorText;
	},


	// ---------------------------------------

	// Utility Functionality

	/**
	 * Strips the URL prefix (such as "http://" or "https://") from the given text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   url prefix (such as stripping off "http://")
	 * @return {String} The `anchorText`, with the prefix stripped.
	 */
	stripUrlPrefix : function( text ) {
		return text.replace( this.urlPrefixRegex, '' );
	},


	/**
	 * Strips any protocol-relative '//' from the anchor text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   protocol-relative prefix (such as stripping off "//")
	 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
	 */
	stripProtocolRelativePrefix : function( text ) {
		return text.replace( this.protocolRelativeRegex, '' );
	},


	/**
	 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
	 *
	 * @private
	 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
	 *   slash ('/') that may exist.
	 * @return {String} The `anchorText`, with the trailing slash removed.
	 */
	removeTrailingSlash : function( anchorText ) {
		if( anchorText.charAt( anchorText.length - 1 ) === '/' ) {
			anchorText = anchorText.slice( 0, -1 );
		}
		return anchorText;
	}

} );
/*global Autolinker */
/**
 * @abstract
 * @class Autolinker.matcher.Matcher
 *
 * An abstract class and interface for individual matchers to find matches in
 * an input string with linkified versions of them.
 *
 * Note that Matchers do not take HTML into account - they must be fed the text
 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
 */
Autolinker.matcher.Matcher = Autolinker.Util.extend( Object, {

	/**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
	 * for {@link Autolinker.match.Match Matches}.
	 */


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Matcher
	 *   instance, specified in an Object (map).
	 */
	constructor : function( cfg ) {
		if( !cfg.tagBuilder ) throw new Error( '`tagBuilder` cfg required' );

		this.tagBuilder = cfg.tagBuilder;
	},


	/**
	 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
	 * for the matcher.
	 *
	 * @abstract
	 * @param {String} text The text to scan and replace matches in.
	 * @return {Autolinker.match.Match[]}
	 */
	parseMatches : Autolinker.Util.abstractMethod

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Email
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find email matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */
Autolinker.matcher.Email = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * The regular expression to match email addresses. Example match:
	 *
	 *     person@place.com
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : (function() {
		var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr,
		    emailRegex = new RegExp( '[' + alphaNumericChars + '\\-_\';:&=+$.,]+@' ),  // something@ for email addresses (a.k.a. local-part)
			domainNameRegex = Autolinker.RegexLib.domainNameRegex,
			tldRegex = Autolinker.RegexLib.tldRegex;  // match our known top level domains (TLDs)

		return new RegExp( [
			emailRegex.source,
			domainNameRegex.source,
			'\\.', tldRegex.source   // '.com', '.net', etc
		].join( "" ), 'gi' );
	} )(),


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var matchedText = match[ 0 ];

			matches.push( new Autolinker.match.Email( {
				tagBuilder  : tagBuilder,
				matchedText : matchedText,
				offset      : match.index,
				email       : matchedText
			} ) );
		}

		return matches;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Hashtag
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Hashtag matches in an input string.
 */
Autolinker.matcher.Hashtag = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */


	/**
	 * The regular expression to match Hashtags. Example match:
	 *
	 *     #asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : new RegExp( '#[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,139}', 'g' ),

	/**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */
	nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );

		this.serviceName = cfg.serviceName;
	},


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    nonWordCharRegex = this.nonWordCharRegex,
		    serviceName = this.serviceName,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var offset = match.index,
			    prevChar = text.charAt( offset - 1 );

			// If we found the match at the beginning of the string, or we found the match
			// and there is a whitespace char in front of it (meaning it is not a '#' char
			// in the middle of a word), then it is a hashtag match.
			if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
				var matchedText = match[ 0 ],
				    hashtag = match[ 0 ].slice( 1 );  // strip off the '#' character at the beginning

				matches.push( new Autolinker.match.Hashtag( {
					tagBuilder  : tagBuilder,
					matchedText : matchedText,
					offset      : offset,
					serviceName : serviceName,
					hashtag     : hashtag
				} ) );
			}
		}

		return matches;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Phone
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Phone number matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
 * details.
 */
Autolinker.matcher.Phone = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * The regular expression to match Phone numbers. Example match:
	 *
	 *     (123) 456-7890
	 *
	 * This regular expression has the following capturing groups:
	 *
	 * 1. The prefixed '+' sign, if there is one.
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : /(?:(\+)?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/g,  // ex: (123) 456-7890, 123 456 7890, 123-456-7890, etc.

	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			// Remove non-numeric values from phone number string
			var matchedText = match[ 0 ],
			    cleanNumber = matchedText.replace( /\D/g, '' ),  // strip out non-digit characters
			    plusSign = !!match[ 1 ];  // match[ 1 ] is the prefixed plus sign, if there is one

			matches.push( new Autolinker.match.Phone( {
				tagBuilder  : tagBuilder,
				matchedText : matchedText,
				offset      : match.index,
				number      : cleanNumber,
				plusSign    : plusSign
			} ) );
		}

		return matches;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Twitter
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find/replace username matches in an input string.
 */
Autolinker.matcher.Twitter = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * The regular expression to match username handles. Example match:
	 *
	 *     @asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */
	matcherRegex : new RegExp( '@[_' + Autolinker.RegexLib.alphaNumericCharsStr + ']{1,20}', 'g' ),

	/**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */
	nonWordCharRegex : new RegExp( '[^' + Autolinker.RegexLib.alphaNumericCharsStr + ']' ),


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    nonWordCharRegex = this.nonWordCharRegex,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var offset = match.index,
			    prevChar = text.charAt( offset - 1 );

			// If we found the match at the beginning of the string, or we found the match
			// and there is a whitespace char in front of it (meaning it is not an email
			// address), then it is a username match.
			if( offset === 0 || nonWordCharRegex.test( prevChar ) ) {
				var matchedText = match[ 0 ],
				    twitterHandle = match[ 0 ].slice( 1 );  // strip off the '@' character at the beginning

				matches.push( new Autolinker.match.Twitter( {
					tagBuilder    : tagBuilder,
					matchedText   : matchedText,
					offset        : offset,
					twitterHandle : twitterHandle
				} ) );
			}
		}

		return matches;
	}

} );
/*global Autolinker */
/**
 * @class Autolinker.matcher.Url
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find URL matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */
Autolinker.matcher.Url = Autolinker.Util.extend( Autolinker.matcher.Matcher, {

	/**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#stripPrefix
	 */


	/**
	 * @private
	 * @property {RegExp} matcherRegex
	 *
	 * The regular expression to match URLs with an optional scheme, port
	 * number, path, query string, and hash anchor.
	 *
	 * Example matches:
	 *
	 *     http://google.com
	 *     www.google.com
	 *     google.com/path/to/file?q1=1&q2=2#myAnchor
	 *
	 *
	 * This regular expression will have the following capturing groups:
	 *
	 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
	 *     This is used to match scheme URLs with just a single word, such as
	 *     'http://localhost', where we won't double check that the domain name
	 *     has at least one dot ('.') in it.
	 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
	 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
	 *     'http://', 'ftp:', etc.)
	 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     We need to know the character before the '//' in order to determine
	 *     if it is a valid match or the // was in a string we don't want to
	 *     auto-link.
	 * 4.  Group that matches a known TLD (top level domain), when a scheme
	 *     or 'www.'-prefixed domain is not matched.
	 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     See #3 for more info.
	 */
	matcherRegex : (function() {
		var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/,  // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
		    wwwRegex = /(?:www\.)/,                  // starting with 'www.'
		    domainNameRegex = Autolinker.RegexLib.domainNameRegex,
		    tldRegex = Autolinker.RegexLib.tldRegex,  // match our known top level domains (TLDs)
		    alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr,

		    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
		    // http://blog.codinghorror.com/the-problem-with-urls/
		    urlSuffixRegex = new RegExp( '[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]?!:,.;]*[' + alphaNumericCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]]' );

		return new RegExp( [
			'(?:', // parens to cover match for scheme (optional), and domain
				'(',  // *** Capturing group $1, for a scheme-prefixed url (ex: http://google.com)
					schemeRegex.source,
					domainNameRegex.source,
				')',

				'|',

				'(',  // *** Capturing group $2, for a 'www.' prefixed url (ex: www.google.com)
					'(//)?',  // *** Capturing group $3 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
					wwwRegex.source,
					domainNameRegex.source,
				')',

				'|',

				'(',  // *** Capturing group $4, for known a TLD url (ex: google.com)
					'(//)?',  // *** Capturing group $5 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character (handled later)
					domainNameRegex.source + '\\.',
					tldRegex.source,
				')',
			')',

			'(?:' + urlSuffixRegex.source + ')?'  // match for path, query string, and/or hash anchor - optional
		].join( "" ), 'gi' );
	} )(),


	/**
	 * A regular expression to use to check the character before a protocol-relative
	 * URL match. We don't want to match a protocol-relative URL if it is part
	 * of another word.
	 *
	 * For example, we want to match something like "Go to: //google.com",
	 * but we don't want to match something like "abc//google.com"
	 *
	 * This regular expression is used to test the character before the '//'.
	 *
	 * @private
	 * @type {RegExp} wordCharRegExp
	 */
	wordCharRegExp : /\w/,


	/**
	 * The regular expression to match opening parenthesis in a URL match.
	 *
	 * This is to determine if we have unbalanced parenthesis in the URL, and to
	 * drop the final parenthesis that was matched if so.
	 *
	 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
	 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
	 * part, so if we find that we have unbalanced parenthesis, we will drop the
	 * last one for the match.
	 *
	 * @private
	 * @property {RegExp}
	 */
	openParensRe : /\(/g,

	/**
	 * The regular expression to match closing parenthesis in a URL match. See
	 * {@link #openParensRe} for more information.
	 *
	 * @private
	 * @property {RegExp}
	 */
	closeParensRe : /\)/g,


	/**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */
	constructor : function( cfg ) {
		Autolinker.matcher.Matcher.prototype.constructor.call( this, cfg );

		this.stripPrefix = cfg.stripPrefix;

		if( this.stripPrefix == null ) throw new Error( '`stripPrefix` cfg required' );
	},


	/**
	 * @inheritdoc
	 */
	parseMatches : function( text ) {
		var matcherRegex = this.matcherRegex,
		    stripPrefix = this.stripPrefix,
		    tagBuilder = this.tagBuilder,
		    matches = [],
		    match;

		while( ( match = matcherRegex.exec( text ) ) !== null ) {
			var matchStr = match[ 0 ],
			    schemeUrlMatch = match[ 1 ],
			    wwwUrlMatch = match[ 2 ],
			    wwwProtocolRelativeMatch = match[ 3 ],
			    //tldUrlMatch = match[ 4 ],  -- not needed at the moment
			    tldProtocolRelativeMatch = match[ 5 ],
			    offset = match.index,
			    protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
				prevChar = text.charAt( offset - 1 );

			if( !Autolinker.matcher.UrlMatchValidator.isValid( matchStr, schemeUrlMatch ) ) {
				continue;
			}

			// If the match is preceded by an '@' character, then it is either
			// an email address or a username. Skip these types of matches.
			if( offset > 0 && prevChar === '@' ) {
				continue;
			}

			// If it's a protocol-relative '//' match, but the character before the '//'
			// was a word character (i.e. a letter/number), then we found the '//' in the
			// middle of another word (such as "asdf//asdf.com"). In this case, skip the
			// match.
			if( offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test( prevChar ) ) {
				continue;
			}

			// Handle a closing parenthesis at the end of the match, and exclude
			// it if there is not a matching open parenthesis in the match
			// itself.
			if( this.matchHasUnbalancedClosingParen( matchStr ) ) {
				matchStr = matchStr.substr( 0, matchStr.length - 1 );  // remove the trailing ")"
			} else {
				// Handle an invalid character after the TLD
				var pos = this.matchHasInvalidCharAfterTld( matchStr, schemeUrlMatch );
				if( pos > -1 ) {
					matchStr = matchStr.substr( 0, pos ); // remove the trailing invalid chars
				}
			}

			var urlMatchType = schemeUrlMatch ? 'scheme' : ( wwwUrlMatch ? 'www' : 'tld' ),
			    protocolUrlMatch = !!schemeUrlMatch;

			matches.push( new Autolinker.match.Url( {
				tagBuilder            : tagBuilder,
				matchedText           : matchStr,
				offset                : offset,
				urlMatchType          : urlMatchType,
				url                   : matchStr,
				protocolUrlMatch      : protocolUrlMatch,
				protocolRelativeMatch : !!protocolRelativeMatch,
				stripPrefix           : stripPrefix
			} ) );
		}

		return matches;
	},


	/**
	 * Determines if a match found has an unmatched closing parenthesis. If so,
	 * this parenthesis will be removed from the match itself, and appended
	 * after the generated anchor tag.
	 *
	 * A match may have an extra closing parenthesis at the end of the match
	 * because the regular expression must include parenthesis for URLs such as
	 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
	 *
	 * However, an extra parenthesis *will* be included when the URL itself is
	 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
	 * In this case, the last closing parenthesis should *not* be part of the
	 * URL itself, and this method will return `true`.
	 *
	 * @private
	 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
	 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
	 *   the end of the `matchStr`, `false` otherwise.
	 */
	matchHasUnbalancedClosingParen : function( matchStr ) {
		var lastChar = matchStr.charAt( matchStr.length - 1 );

		if( lastChar === ')' ) {
			var openParensMatch = matchStr.match( this.openParensRe ),
			    closeParensMatch = matchStr.match( this.closeParensRe ),
			    numOpenParens = ( openParensMatch && openParensMatch.length ) || 0,
			    numCloseParens = ( closeParensMatch && closeParensMatch.length ) || 0;

			if( numOpenParens < numCloseParens ) {
				return true;
			}
		}

		return false;
	},


	/**
	 * Determine if there's an invalid character after the TLD in a URL. Valid
	 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
	 * check.
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} schemeUrlMatch The match URL string for a scheme
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Number} the position where the invalid character was found. If
	 *   no such character was found, returns -1
	 */
	matchHasInvalidCharAfterTld : function( urlMatch, schemeUrlMatch ) {
		if( !urlMatch ) {
			return -1;
		}

		var offset = 0;
		if ( schemeUrlMatch ) {
			offset = urlMatch.indexOf(':');
			urlMatch = urlMatch.slice(offset);
		}

		var re = /^((.?\/\/)?[A-Za-z0-9\u00C0-\u017F\.\-]*[A-Za-z0-9\u00C0-\u017F\-]\.[A-Za-z]+)/;
		var res = re.exec( urlMatch );
		if ( res === null ) {
			return -1;
		}

		offset += res[1].length;
		urlMatch = urlMatch.slice(res[1].length);
		if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) {
			return offset;
		}

		return -1;
	}

} );
/*global Autolinker */
/*jshint scripturl:true */
/**
 * @private
 * @class Autolinker.matcher.UrlMatchValidator
 * @singleton
 *
 * Used by Autolinker to filter out false URL positives from the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 *
 * Due to the limitations of regular expressions (including the missing feature
 * of look-behinds in JS regular expressions), we cannot always determine the
 * validity of a given match. This class applies a bit of additional logic to
 * filter out any false positives that have been matched by the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 */
Autolinker.matcher.UrlMatchValidator = {

	/**
	 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
	 *
	 * @private
	 * @property {RegExp} hasFullProtocolRegex
	 */
	hasFullProtocolRegex : /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,

	/**
	 * Regex to find the URI scheme, such as 'mailto:'.
	 *
	 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
	 *
	 * @private
	 * @property {RegExp} uriSchemeRegex
	 */
	uriSchemeRegex : /^[A-Za-z][-.+A-Za-z0-9]*:/,

	/**
	 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
	 *
	 * @private
	 * @property {RegExp} hasWordCharAfterProtocolRegex
	 */
	hasWordCharAfterProtocolRegex : /:[^\s]*?[A-Za-z\u00C0-\u017F]/,

	/**
	 * Regex to determine if the string is a valid IP address
	 *
	 * @private
	 * @property {RegExp} ipRegex
	 */
	ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,

	/**
	 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
	 * is valid. Will return `false` for:
	 *
	 * 1) URL matches which do not have at least have one period ('.') in the
	 *    domain name (effectively skipping over matches like "abc:def").
	 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
	 * 2) URL matches which do not have at least one word character in the
	 *    domain name (effectively skipping over matches like "git:1.0").
	 * 3) A protocol-relative url match (a URL beginning with '//') whose
	 *    previous character is a word character (effectively skipping over
	 *    strings like "abc//google.com")
	 *
	 * Otherwise, returns `true`.
	 *
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the match given is valid and should be
	 *   processed, or `false` if the match is invalid and/or should just not be
	 *   processed.
	 */
	isValid : function( urlMatch, protocolUrlMatch ) {
		if(
			( protocolUrlMatch && !this.isValidUriScheme( protocolUrlMatch ) ) ||
			this.urlMatchDoesNotHaveProtocolOrDot( urlMatch, protocolUrlMatch ) ||    // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
			(this.urlMatchDoesNotHaveAtLeastOneWordChar( urlMatch, protocolUrlMatch ) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
			 !this.isValidIpAddress( urlMatch ) // Except if it's an IP address
			)
		) {
			return false;
		}

		return true;
	},


	isValidIpAddress : function ( uriSchemeMatch ) {
		var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
		var uriScheme = uriSchemeMatch.match( newRegex );

		return uriScheme !== null;
	},

	/**
	 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
	 * `false` if the scheme is 'javascript:' or 'vbscript:'
	 *
	 * @private
	 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
	 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
	 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
	 */
	isValidUriScheme : function( uriSchemeMatch ) {
		var uriScheme = uriSchemeMatch.match( this.uriSchemeRegex )[ 0 ].toLowerCase();

		return ( uriScheme !== 'javascript:' && uriScheme !== 'vbscript:' );
	},


	/**
	 * Determines if a URL match does not have either:
	 *
	 * a) a full protocol (i.e. 'http://'), or
	 * b) at least one dot ('.') in the domain name (for a non-full-protocol
	 *    match).
	 *
	 * Either situation is considered an invalid URL (ex: 'git:d' does not have
	 * either the '://' part, or at least one dot in the domain name. If the
	 * match was 'git:abc.com', we would consider this valid.)
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the URL match does not have a full protocol,
	 *   or at least one dot ('.') in a non-full-protocol match.
	 */
	urlMatchDoesNotHaveProtocolOrDot : function( urlMatch, protocolUrlMatch ) {
		return ( !!urlMatch && ( !protocolUrlMatch || !this.hasFullProtocolRegex.test( protocolUrlMatch ) ) && urlMatch.indexOf( '.' ) === -1 );
	},


	/**
	 * Determines if a URL match does not have at least one word character after
	 * the protocol (i.e. in the domain name).
	 *
	 * At least one letter character must exist in the domain name after a
	 * protocol match. Ex: skip over something like "git:1.0"
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
	 *   have a protocol in the URL string, in order to check for a word
	 *   character after the protocol separator (':').
	 * @return {Boolean} `true` if the URL match does not have at least one word
	 *   character in it after the protocol, `false` otherwise.
	 */
	urlMatchDoesNotHaveAtLeastOneWordChar : function( urlMatch, protocolUrlMatch ) {
		if( urlMatch && protocolUrlMatch ) {
			return !this.hasWordCharAfterProtocolRegex.test( urlMatch );
		} else {
			return false;
		}
	}

};
/*global Autolinker */
/**
 * A truncation feature where the ellipsis will be placed at the end of the URL.
 *
 * @param {String} anchorText
 * @param {Number} truncateLen The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars){
	return Autolinker.Util.ellipsis( anchorText, truncateLen, ellipsisChars );
};

/*global Autolinker */
/**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
 *
 * @param {String} url             A URL.
 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars){
  if (url.length <= truncateLen) {
    return url;
  }
  var availableLength = truncateLen - ellipsisChars.length;
  var end = "";
  if (availableLength > 0) {
    end = url.substr((-1)*Math.floor(availableLength/2));
  }
  return (url.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
};

/*global Autolinker */
/**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed at a section within
 * the URL making it still somewhat human readable.
 *
 * @param {String} url						 A URL.
 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */
Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars){
	var parse_url = function(url){ // Functionality inspired by PHP function of same name
		var urlObj = {};
		var urlSub = url;
		var match = urlSub.match(/^([a-z]+):\/\//i);
		if (match) {
			urlObj.scheme = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
		if (match) {
			urlObj.host = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
		if (match) {
			urlObj.path = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
		if (match) {
			urlObj.query = match[1];
			urlSub = urlSub.substr(match[0].length);
		}
		match = urlSub.match(/^#(.*?)$/i);
		if (match) {
			urlObj.fragment = match[1];
			//urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
		}
		return urlObj;
	};

	var buildUrl = function(urlObj){
		var url = "";
		if (urlObj.scheme && urlObj.host) {
			url += urlObj.scheme + "://";
		}
		if (urlObj.host) {
			url += urlObj.host;
		}
		if (urlObj.path) {
			url += "/" + urlObj.path;
		}
		if (urlObj.query) {
			url += "?" + urlObj.query;
		}
		if (urlObj.fragment) {
			url += "#" + urlObj.fragment;
		}
		return url;
	};

	var buildSegment = function(segment, remainingAvailableLength){
		var remainingAvailableLengthHalf = remainingAvailableLength/ 2,
				startOffset = Math.ceil(remainingAvailableLengthHalf),
				endOffset = (-1)*Math.floor(remainingAvailableLengthHalf),
				end = "";
		if (endOffset < 0) {
			end = segment.substr(endOffset);
		}
		return segment.substr(0, startOffset) + ellipsisChars + end;
	};
	if (url.length <= truncateLen) {
		return url;
	}
	var availableLength = truncateLen - ellipsisChars.length;
	var urlObj = parse_url(url);
	// Clean up the URL
	if (urlObj.query) {
		var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
		if (matchQuery) {
			// Malformed URL; two or more "?". Removed any content behind the 2nd.
			urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
			url = buildUrl(urlObj);
		}
	}
	if (url.length <= truncateLen) {
		return url;
	}
	if (urlObj.host) {
		urlObj.host = urlObj.host.replace(/^www\./, "");
		url = buildUrl(urlObj);
	}
	if (url.length <= truncateLen) {
		return url;
	}
	// Process and build the URL
	var str = "";
	if (urlObj.host) {
		str += urlObj.host;
	}
	if (str.length >= availableLength) {
		if (urlObj.host.length == truncateLen) {
			return (urlObj.host.substr(0, (truncateLen - ellipsisChars.length)) + ellipsisChars).substr(0, truncateLen);
		}
		return buildSegment(str, availableLength).substr(0, truncateLen);
	}
	var pathAndQuery = "";
	if (urlObj.path) {
		pathAndQuery += "/" + urlObj.path;
	}
	if (urlObj.query) {
		pathAndQuery += "?" + urlObj.query;
	}
	if (pathAndQuery) {
		if ((str+pathAndQuery).length >= availableLength) {
			if ((str+pathAndQuery).length == truncateLen) {
				return (str + pathAndQuery).substr(0, truncateLen);
			}
			var remainingAvailableLength = availableLength - str.length;
			return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, truncateLen);
		} else {
			str += pathAndQuery;
		}
	}
	if (urlObj.fragment) {
		var fragment = "#"+urlObj.fragment;
		if ((str+fragment).length >= availableLength) {
			if ((str+fragment).length == truncateLen) {
				return (str + fragment).substr(0, truncateLen);
			}
			var remainingAvailableLength2 = availableLength - str.length;
			return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, truncateLen);
		} else {
			str += fragment;
		}
	}
	if (urlObj.scheme && urlObj.host) {
		var scheme = urlObj.scheme + "://";
		if ((str+scheme).length < availableLength) {
			return (scheme + str).substr(0, truncateLen);
		}
	}
	if (str.length <= truncateLen) {
		return str;
	}
	var end = "";
	if (availableLength > 0) {
		end = str.substr((-1)*Math.floor(availableLength/2));
	}
	return (str.substr(0, Math.ceil(availableLength/2)) + ellipsisChars + end).substr(0, truncateLen);
};

return Autolinker;
}));


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var Ruler      = __webpack_require__(333);
var StateBlock = __webpack_require__(1413);

/**
 * Parser rules
 */

var _rules = [
  [ 'code',       __webpack_require__(1414) ],
  [ 'fences',     __webpack_require__(1415),     [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'blockquote', __webpack_require__(1416), [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'hr',         __webpack_require__(1417),         [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'list',       __webpack_require__(1418),       [ 'paragraph', 'blockquote' ] ],
  [ 'footnote',   __webpack_require__(1419),   [ 'paragraph' ] ],
  [ 'heading',    __webpack_require__(1420),    [ 'paragraph', 'blockquote' ] ],
  [ 'lheading',   __webpack_require__(1421) ],
  [ 'htmlblock',  __webpack_require__(1422),  [ 'paragraph', 'blockquote' ] ],
  [ 'table',      __webpack_require__(1424),      [ 'paragraph' ] ],
  [ 'deflist',    __webpack_require__(1425),    [ 'paragraph' ] ],
  [ 'paragraph',  __webpack_require__(1426) ]
];

/**
 * Block Parser class
 *
 * @api private
 */

function ParserBlock() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], {
      alt: (_rules[i][2] || []).slice()
    });
  }
}

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
 * @param  {Number} `startLine`
 * @param  {Number} `endLine`
 * @api private
 */

ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var line = startLine;
  var hasEmptyLines = false;
  var ok, i;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) {
      break;
    }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.tShift[line] < state.blkIndent) {
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        break;
      }
    }

    // set state.tight iff we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;

      // two empty lines should stop the parser in list mode
      if (line < endLine && state.parentType === 'list' && state.isEmpty(line)) { break; }
      state.line = line;
    }
  }
};

var TABS_SCAN_RE = /[\n\t]/g;
var NEWLINES_RE  = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
var SPACES_RE    = /\u00a0/g;

/**
 * Tokenize the given `str`.
 *
 * @param  {String} `str` Source string
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserBlock.prototype.parse = function (str, options, env, outTokens) {
  var state, lineStart = 0, lastTabPos = 0;
  if (!str) { return []; }

  // Normalize spaces
  str = str.replace(SPACES_RE, ' ');

  // Normalize newlines
  str = str.replace(NEWLINES_RE, '\n');

  // Replace tabs with proper number of spaces (1..4)
  if (str.indexOf('\t') >= 0) {
    str = str.replace(TABS_SCAN_RE, function (match, offset) {
      var result;
      if (str.charCodeAt(offset) === 0x0A) {
        lineStart = offset + 1;
        lastTabPos = 0;
        return match;
      }
      result = '    '.slice((offset - lineStart - lastTabPos) % 4);
      lastTabPos = offset - lineStart + 1;
      return result;
    });
  }

  state = new StateBlock(str, this, options, env, outTokens);
  this.tokenize(state, state.line, state.lineMax);
};

/**
 * Expose `ParserBlock`
 */

module.exports = ParserBlock;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parser state class




function StateBlock(src, parser, options, env, tokens) {
  var ch, s, start, pos, len, indent, indent_found;

  this.src = src;

  // Shortcuts to simplify nested calls
  this.parser = parser;

  this.options = options;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // indent for each line

  // block parser variables
  this.blkIndent  = 0; // required block content indent
                       // (for example, if we are in list)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.parentType = 'root'; // if `list`, block parser stops on two newlines
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent = 0;
  indent_found = false;

  for (start = pos = indent = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (ch === 0x20/* space */) {
        indent++;
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);

      indent_found = false;
      indent = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== 0x20/* space */) { break; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, first, last, queue, shift,
      line = begin;

  if (begin >= end) {
    return '';
  }

  // Opt: don't use push queue for single line;
  if (line + 1 === end) {
    first = this.bMarks[line] + Math.min(this.tShift[line], indent);
    last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
    return this.src.slice(first, last);
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    shift = this.tShift[line];
    if (shift > indent) { shift = indent; }
    if (shift < 0) { shift = 0; }

    first = this.bMarks[line] + shift;

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    queue[i] = this.src.slice(first, last);
  }

  return queue.join('');
};


module.exports = StateBlock;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Code block (4 spaces padded)




module.exports = function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last;

  if (state.tShift[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }
    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'code',
    content: state.getLines(startLine, last, 4 + state.blkIndent, true),
    block: true,
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
};


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// fences (``` lang, ~~~ lang)




module.exports = function fences(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  params = state.src.slice(pos, max).trim();

  if (params.indexOf('`') >= 0) { return false; }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.tShift[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.tShift[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);
  state.tokens.push({
    type: 'fence',
    params: params,
    content: state.getLines(startLine + 1, nextLine, len, true),
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
};


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Block quotes




module.exports = function blockquote(state, startLine, endLine, silent) {
  var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines,
      terminatorRules,
      i, l, terminate,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos > max) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20) { pos++; }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  // check if we have an empty blockquote
  pos = pos < max ? state.skipSpaces(pos) : pos;
  lastLineEmpty = pos >= max;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.parser.ruler.getRules('blockquote');

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */) {
      // This line is inside the blockquote.

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20) { pos++; }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      pos = pos < max ? state.skipSpaces(pos) : pos;
      lastLineEmpty = pos >= max;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    oldBMarks.push(state.bMarks[nextLine]);
    oldTShift.push(state.tShift[nextLine]);

    // A negative number means that this is a paragraph continuation;
    //
    // Any negative number will do the job here, but it's better for it
    // to be large enough to make any bugs obvious.
    state.tShift[nextLine] = -1337;
  }

  oldParentType = state.parentType;
  state.parentType = 'blockquote';
  state.tokens.push({
    type: 'blockquote_open',
    lines: lines = [ startLine, 0 ],
    level: state.level++
  });
  state.parser.tokenize(state, startLine, nextLine);
  state.tokens.push({
    type: 'blockquote_close',
    level: --state.level
  });
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
  }
  state.blkIndent = oldIndent;

  return true;
};


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Horizontal rule




module.exports = function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine];

  pos += state.tShift[startLine];

  if (pos > max) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 one

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && ch !== 0x20/* space */) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;
  state.tokens.push({
    type: 'hr',
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
};


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Lists




// Search `[-+*][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  if (pos >= max) { return -1; }

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max && state.src.charCodeAt(pos) !== 0x20) {
    // " 1.test " - is not a list item
    return -1;
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {
      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max && state.src.charCodeAt(pos) !== 0x20/* space */) {
    // " 1.test " - is not a list item
    return -1;
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}


module.exports = function list(state, startLine, endLine, silent) {
  var nextLine,
      indent,
      oldTShift,
      oldIndent,
      oldTight,
      oldParentType,
      start,
      posAfterMarker,
      max,
      indentAfterMarker,
      markerValue,
      markerCharCode,
      isOrdered,
      contentStart,
      listTokIdx,
      prevEmptyEnd,
      listLines,
      itemLines,
      tight = true,
      terminatorRules,
      i, l, terminate;

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;
  } else {
    return false;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

    state.tokens.push({
      type: 'ordered_list_open',
      order: markerValue,
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });

  } else {
    state.tokens.push({
      type: 'bullet_list_open',
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });
  }

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.parser.ruler.getRules('list');

  while (nextLine < endLine) {
    contentStart = state.skipSpaces(posAfterMarker);
    max = state.eMarks[nextLine];

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = contentStart - posAfterMarker;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // If indent is less than 1, assume that it's one, example:
    //  "-\n  test"
    if (indentAfterMarker < 1) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = (posAfterMarker - state.bMarks[nextLine]) + indentAfterMarker;

    // Run subparser & write tokens
    state.tokens.push({
      type: 'list_item_open',
      lines: itemLines = [ startLine, 0 ],
      level: state.level++
    });

    oldIndent = state.blkIndent;
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldParentType = state.parentType;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.blkIndent = indent;
    state.tight = true;
    state.parentType = 'list';

    state.parser.tokenize(state, startLine, endLine, true);

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = oldIndent;
    state.tShift[startLine] = oldTShift;
    state.tight = oldTight;
    state.parentType = oldParentType;

    state.tokens.push({
      type: 'list_item_close',
      level: --state.level
    });

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    if (state.isEmpty(nextLine)) {
      break;
    }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finilize list
  state.tokens.push({
    type: isOrdered ? 'ordered_list_close' : 'bullet_list_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process footnote reference list




module.exports = function footnote(state, startLine, endLine, silent) {
  var oldBMark, oldTShift, oldParentType, pos, label,
      start = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // line should be at least 5 chars - "[^x]:"
  if (start + 4 > max) { return false; }

  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */) { return false; }
  if (silent) { return true; }
  pos++;

  if (!state.env.footnotes) { state.env.footnotes = {}; }
  if (!state.env.footnotes.refs) { state.env.footnotes.refs = {}; }
  label = state.src.slice(start + 2, pos - 2);
  state.env.footnotes.refs[':' + label] = -1;

  state.tokens.push({
    type: 'footnote_reference_open',
    label: label,
    level: state.level++
  });

  oldBMark = state.bMarks[startLine];
  oldTShift = state.tShift[startLine];
  oldParentType = state.parentType;
  state.tShift[startLine] = state.skipSpaces(pos) - pos;
  state.bMarks[startLine] = pos;
  state.blkIndent += 4;
  state.parentType = 'footnote';

  if (state.tShift[startLine] < state.blkIndent) {
    state.tShift[startLine] += state.blkIndent;
    state.bMarks[startLine] -= state.blkIndent;
  }

  state.parser.tokenize(state, startLine, endLine, true);

  state.parentType = oldParentType;
  state.blkIndent -= 4;
  state.tShift[startLine] = oldTShift;
  state.bMarks[startLine] = oldBMark;

  state.tokens.push({
    type: 'footnote_reference_close',
    level: --state.level
  });

  return true;
};


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// heading (#, ##, ...)




module.exports = function heading(state, startLine, endLine, silent) {
  var ch, level, tmp,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos >= max) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && ch !== 0x20/* space */)) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipCharsBack(max, 0x20, pos); // space
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20/* space */) {
    max = tmp;
  }

  state.line = startLine + 1;

  state.tokens.push({ type: 'heading_open',
    hLevel: level,
    lines: [ startLine, state.line ],
    level: state.level
  });

  // only if header is not empty
  if (pos < max) {
    state.tokens.push({
      type: 'inline',
      content: state.src.slice(pos, max).trim(),
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
  }
  state.tokens.push({ type: 'heading_close', hLevel: level, level: state.level });

  return true;
};


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// lheading (---, ===)




module.exports = function lheading(state, startLine, endLine/*, silent*/) {
  var marker, pos, max,
      next = startLine + 1;

  if (next >= endLine) { return false; }
  if (state.tShift[next] < state.blkIndent) { return false; }

  // Scan next line

  if (state.tShift[next] - state.blkIndent > 3) { return false; }

  pos = state.bMarks[next] + state.tShift[next];
  max = state.eMarks[next];

  if (pos >= max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x2D/* - */ && marker !== 0x3D/* = */) { return false; }

  pos = state.skipChars(pos, marker);

  pos = state.skipSpaces(pos);

  if (pos < max) { return false; }

  pos = state.bMarks[startLine] + state.tShift[startLine];

  state.line = next + 1;
  state.tokens.push({
    type: 'heading_open',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    lines: [ startLine, state.line ],
    level: state.level
  });
  state.tokens.push({
    type: 'inline',
    content: state.src.slice(pos, state.eMarks[startLine]).trim(),
    level: state.level + 1,
    lines: [ startLine, state.line - 1 ],
    children: []
  });
  state.tokens.push({
    type: 'heading_close',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    level: state.level
  });

  return true;
};


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// HTML block




var block_names = __webpack_require__(1423);


var HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
var HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;

function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}

module.exports = function htmlblock(state, startLine, endLine, silent) {
  var ch, match, nextLine,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine],
      shift = state.tShift[startLine];

  pos += shift;

  if (!state.options.html) { return false; }

  if (shift > 3 || pos + 2 >= max) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  ch = state.src.charCodeAt(pos + 1);

  if (ch === 0x21/* ! */ || ch === 0x3F/* ? */) {
    // Directive start / comment start / processing instruction start
    if (silent) { return true; }

  } else if (ch === 0x2F/* / */ || isLetter(ch)) {

    // Probably start or end of tag
    if (ch === 0x2F/* \ */) {
      // closing tag
      match = state.src.slice(pos, max).match(HTML_TAG_CLOSE_RE);
      if (!match) { return false; }
    } else {
      // opening tag
      match = state.src.slice(pos, max).match(HTML_TAG_OPEN_RE);
      if (!match) { return false; }
    }
    // Make sure tag name is valid
    if (block_names[match[1].toLowerCase()] !== true) { return false; }
    if (silent) { return true; }

  } else {
    return false;
  }

  // If we are here - we detected HTML block.
  // Let's roll down till empty line (block end).
  nextLine = startLine + 1;
  while (nextLine < state.lineMax && !state.isEmpty(nextLine)) {
    nextLine++;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'htmlblock',
    level: state.level,
    lines: [ startLine, state.line ],
    content: state.getLines(startLine, nextLine, 0, true)
  });

  return true;
};


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks



var html_blocks = {};

[
  'article',
  'aside',
  'button',
  'blockquote',
  'body',
  'canvas',
  'caption',
  'col',
  'colgroup',
  'dd',
  'div',
  'dl',
  'dt',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'iframe',
  'li',
  'map',
  'object',
  'ol',
  'output',
  'p',
  'pre',
  'progress',
  'script',
  'section',
  'style',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'tr',
  'thead',
  'ul',
  'video'
].forEach(function (name) { html_blocks[name] = true; });


module.exports = html_blocks;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GFM table, non-standard




function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, rows, cell,
      aligns, t, tableLines, tbodyLines;

  // should have at least three lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.tShift[nextLine] < state.blkIndent) { return false; }

  // first character of the second line should be '|' or '-'

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  ch = state.src.charCodeAt(pos);
  if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */) { return false; }

  lineText = getLine(state, startLine + 1);
  if (!/^[-:| ]+$/.test(lineText)) { return false; }

  rows = lineText.split('|');
  if (rows <= 2) { return false; }
  aligns = [];
  for (i = 0; i < rows.length; i++) {
    t = rows[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === rows.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  rows = lineText.replace(/^\||\|$/g, '').split('|');
  if (aligns.length !== rows.length) { return false; }
  if (silent) { return true; }

  state.tokens.push({
    type: 'table_open',
    lines: tableLines = [ startLine, 0 ],
    level: state.level++
  });
  state.tokens.push({
    type: 'thead_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });

  state.tokens.push({
    type: 'tr_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });
  for (i = 0; i < rows.length; i++) {
    state.tokens.push({
      type: 'th_open',
      align: aligns[i],
      lines: [ startLine, startLine + 1 ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: rows[i].trim(),
      lines: [ startLine, startLine + 1 ],
      level: state.level,
      children: []
    });
    state.tokens.push({ type: 'th_close', level: --state.level });
  }
  state.tokens.push({ type: 'tr_close', level: --state.level });
  state.tokens.push({ type: 'thead_close', level: --state.level });

  state.tokens.push({
    type: 'tbody_open',
    lines: tbodyLines = [ startLine + 2, 0 ],
    level: state.level++
  });

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) { break; }
    rows = lineText.replace(/^\||\|$/g, '').split('|');

    state.tokens.push({ type: 'tr_open', level: state.level++ });
    for (i = 0; i < rows.length; i++) {
      state.tokens.push({ type: 'td_open', align: aligns[i], level: state.level++ });
      // 0x7c === '|'
      cell = rows[i].substring(
          rows[i].charCodeAt(0) === 0x7c ? 1 : 0,
          rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length
      ).trim();
      state.tokens.push({
        type: 'inline',
        content: cell,
        level: state.level,
        children: []
      });
      state.tokens.push({ type: 'td_close', level: --state.level });
    }
    state.tokens.push({ type: 'tr_close', level: --state.level });
  }
  state.tokens.push({ type: 'tbody_close', level: --state.level });
  state.tokens.push({ type: 'table_close', level: --state.level });

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
};


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Definition lists




// Search `[:~][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipMarker(state, line) {
  var pos, marker,
      start = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  if (start >= max) { return -1; }

  // Check bullet
  marker = state.src.charCodeAt(start++);
  if (marker !== 0x7E/* ~ */ && marker !== 0x3A/* : */) { return -1; }

  pos = state.skipSpaces(start);

  // require space after ":"
  if (start === pos) { return -1; }

  // no empty definitions, e.g. "  : "
  if (pos >= max) { return -1; }

  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}

module.exports = function deflist(state, startLine, endLine, silent) {
  var contentStart,
      ddLine,
      dtLine,
      itemLines,
      listLines,
      listTokIdx,
      nextLine,
      oldIndent,
      oldDDIndent,
      oldParentType,
      oldTShift,
      oldTight,
      prevEmptyEnd,
      tight;

  if (silent) {
    // quirk: validation mode validates a dd block only, not a whole deflist
    if (state.ddIndent < 0) { return false; }
    return skipMarker(state, startLine) >= 0;
  }

  nextLine = startLine + 1;
  if (state.isEmpty(nextLine)) {
    if (++nextLine > endLine) { return false; }
  }

  if (state.tShift[nextLine] < state.blkIndent) { return false; }
  contentStart = skipMarker(state, nextLine);
  if (contentStart < 0) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // Start list
  listTokIdx = state.tokens.length;

  state.tokens.push({
    type: 'dl_open',
    lines: listLines = [ startLine, 0 ],
    level: state.level++
  });

  //
  // Iterate list items
  //

  dtLine = startLine;
  ddLine = nextLine;

  // One definition list can contain multiple DTs,
  // and one DT can be followed by multiple DDs.
  //
  // Thus, there is two loops here, and label is
  // needed to break out of the second one
  //
  /*eslint no-labels:0,block-scoped-var:0*/
  OUTER:
  for (;;) {
    tight = true;
    prevEmptyEnd = false;

    state.tokens.push({
      type: 'dt_open',
      lines: [ dtLine, dtLine ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
      level: state.level + 1,
      lines: [ dtLine, dtLine ],
      children: []
    });
    state.tokens.push({
      type: 'dt_close',
      level: --state.level
    });

    for (;;) {
      state.tokens.push({
        type: 'dd_open',
        lines: itemLines = [ nextLine, 0 ],
        level: state.level++
      });

      oldTight = state.tight;
      oldDDIndent = state.ddIndent;
      oldIndent = state.blkIndent;
      oldTShift = state.tShift[ddLine];
      oldParentType = state.parentType;
      state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
      state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
      state.tight = true;
      state.parentType = 'deflist';

      state.parser.tokenize(state, ddLine, endLine, true);

      // If any of list item is tight, mark list as tight
      if (!state.tight || prevEmptyEnd) {
        tight = false;
      }
      // Item become loose if finish with empty line,
      // but we should filter last element, because it means list finish
      prevEmptyEnd = (state.line - ddLine) > 1 && state.isEmpty(state.line - 1);

      state.tShift[ddLine] = oldTShift;
      state.tight = oldTight;
      state.parentType = oldParentType;
      state.blkIndent = oldIndent;
      state.ddIndent = oldDDIndent;

      state.tokens.push({
        type: 'dd_close',
        level: --state.level
      });

      itemLines[1] = nextLine = state.line;

      if (nextLine >= endLine) { break OUTER; }

      if (state.tShift[nextLine] < state.blkIndent) { break OUTER; }
      contentStart = skipMarker(state, nextLine);
      if (contentStart < 0) { break; }

      ddLine = nextLine;

      // go to the next loop iteration:
      // insert DD tag and repeat checking
    }

    if (nextLine >= endLine) { break; }
    dtLine = nextLine;

    if (state.isEmpty(dtLine)) { break; }
    if (state.tShift[dtLine] < state.blkIndent) { break; }

    ddLine = dtLine + 1;
    if (ddLine >= endLine) { break; }
    if (state.isEmpty(ddLine)) { ddLine++; }
    if (ddLine >= endLine) { break; }

    if (state.tShift[ddLine] < state.blkIndent) { break; }
    contentStart = skipMarker(state, ddLine);
    if (contentStart < 0) { break; }

    // go to the next loop iteration:
    // insert DT and DD tags and repeat checking
  }

  // Finilize list
  state.tokens.push({
    type: 'dl_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Paragraph




module.exports = function paragraph(state, startLine/*, endLine*/) {
  var endLine, content, terminate, i, l,
      nextLine = startLine + 1,
      terminatorRules;

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  if (nextLine < endLine && !state.isEmpty(nextLine)) {
    terminatorRules = state.parser.ruler.getRules('paragraph');

    for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
      // this would be a code block normally, but after paragraph
      // it's considered a lazy continuation regardless of what's there
      if (state.tShift[nextLine] - state.blkIndent > 3) { continue; }

      // Some tags can terminate paragraph without empty line.
      terminate = false;
      for (i = 0, l = terminatorRules.length; i < l; i++) {
        if (terminatorRules[i](state, nextLine, endLine, true)) {
          terminate = true;
          break;
        }
      }
      if (terminate) { break; }
    }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;
  if (content.length) {
    state.tokens.push({
      type: 'paragraph_open',
      tight: false,
      lines: [ startLine, state.line ],
      level: state.level
    });
    state.tokens.push({
      type: 'inline',
      content: content,
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
    state.tokens.push({
      type: 'paragraph_close',
      tight: false,
      level: state.level
    });
  }

  return true;
};


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Local dependencies
 */

var Ruler       = __webpack_require__(333);
var StateInline = __webpack_require__(452);
var utils       = __webpack_require__(86);

/**
 * Inline Parser `rules`
 */

var _rules = [
  [ 'text',            __webpack_require__(1428) ],
  [ 'newline',         __webpack_require__(1429) ],
  [ 'escape',          __webpack_require__(1430) ],
  [ 'backticks',       __webpack_require__(1431) ],
  [ 'del',             __webpack_require__(1432) ],
  [ 'ins',             __webpack_require__(1433) ],
  [ 'mark',            __webpack_require__(1434) ],
  [ 'emphasis',        __webpack_require__(1435) ],
  [ 'sub',             __webpack_require__(1436) ],
  [ 'sup',             __webpack_require__(1437) ],
  [ 'links',           __webpack_require__(1438) ],
  [ 'footnote_inline', __webpack_require__(1439) ],
  [ 'footnote_ref',    __webpack_require__(1440) ],
  [ 'autolink',        __webpack_require__(1441) ],
  [ 'htmltag',         __webpack_require__(1443) ],
  [ 'entity',          __webpack_require__(1445) ]
];

/**
 * Inline Parser class. Note that link validation is stricter
 * in Remarkable than what is specified by CommonMark. If you
 * want to change this you can use a custom validator.
 *
 * @api private
 */

function ParserInline() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  // Can be overridden with a custom validator
  this.validateLink = validateLink;
}

/**
 * Skip a single token by running all rules in validation mode.
 * Returns `true` if any rule reports success.
 *
 * @param  {Object} `state`
 * @api privage
 */

ParserInline.prototype.skipToken = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var pos = state.pos;
  var i, cached_pos;

  if ((cached_pos = state.cacheGet(pos)) > 0) {
    state.pos = cached_pos;
    return;
  }

  for (i = 0; i < len; i++) {
    if (rules[i](state, true)) {
      state.cacheSet(pos, state.pos);
      return;
    }
  }

  state.pos++;
  state.cacheSet(pos, state.pos);
};

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state`
 * @api private
 */

ParserInline.prototype.tokenize = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var end = state.posMax;
  var ok, i;

  while (state.pos < end) {

    // Try all possible rules.
    // On success, the rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true
    for (i = 0; i < len; i++) {
      ok = rules[i](state, false);

      if (ok) {
        break;
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};

/**
 * Parse the given input string.
 *
 * @param  {String} `str`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserInline.prototype.parse = function (str, options, env, outTokens) {
  var state = new StateInline(str, this, options, env, outTokens);
  this.tokenize(state);
};

/**
 * Validate the given `url` by checking for bad protocols.
 *
 * @param  {String} `url`
 * @return {Boolean}
 */

function validateLink(url) {
  var BAD_PROTOCOLS = [ 'vbscript', 'javascript', 'file', 'data' ];
  var str = url.trim().toLowerCase();
  // Care about digital entities "javascript&#x3A;alert(1)"
  str = utils.replaceEntities(str);
  if (str.indexOf(':') !== -1 && BAD_PROTOCOLS.indexOf(str.split(':')[0]) !== -1) {
    return false;
  }
  return true;
}

/**
 * Expose `ParserInline`
 */

module.exports = ParserInline;


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos



// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x5C/* \ */:
    case 0x60/* ` */:
    case 0x2A/* * */:
    case 0x5F/* _ */:
    case 0x5E/* ^ */:
    case 0x5B/* [ */:
    case 0x5D/* ] */:
    case 0x21/* ! */:
    case 0x26/* & */:
    case 0x3C/* < */:
    case 0x3E/* > */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x40/* @ */:
    case 0x7E/* ~ */:
    case 0x2B/* + */:
    case 0x3D/* = */:
    case 0x3A/* : */:
      return true;
    default:
      return false;
  }
}

module.exports = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
};


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Proceess '\n'



module.exports = function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        // Strip out all trailing spaces on this line.
        for (var i = pmax - 2; i >= 0; i--) {
          if (state.pending.charCodeAt(i) !== 0x20) {
            state.pending = state.pending.substring(0, i + 1);
            break;
          }
        }
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push({
          type: 'softbreak',
          level: state.level
        });
      }

    } else {
      state.push({
        type: 'softbreak',
        level: state.level
      });
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

  state.pos = pos;
  return true;
};


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Proceess escaped chars and hardbreaks



var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function(ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


module.exports = function escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
};


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Parse backticks



module.exports = function backticks(state, silent) {
  var start, max, marker, matchStart, matchEnd,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        state.push({
          type: 'code',
          content: state.src.slice(pos, matchStart)
                              .replace(/[ \n]+/g, ' ')
                              .trim(),
          block: false,
          level: state.level
        });
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) { state.pending += marker; }
  state.pos += marker.length;
  return true;
};


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ~~deleted text~~



module.exports = function del(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x7E/* ~ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x7E/* ~ */) { pos++; }
  if (pos > start + 3) {
    // sequence of 4+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x7E/* ~ */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x7E/* ~ */ && lastChar !== 0x7E/* ~ */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '~~'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '~~'
            stack++;
          } // else {
            //  // standalone ' ~~ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'del_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'del_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ++inserted text++



module.exports = function ins(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x2B/* + */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x2B/* + */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x2B/* + */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x2B/* + */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x2B/* + */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x2B/* + */ && lastChar !== 0x2B/* + */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '++'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '++'
            stack++;
          } // else {
            //  // standalone ' ++ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'ins_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'ins_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ==highlighted text==



module.exports = function del(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x3D/* = */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x3D/* = */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x3D/* = */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x3D/* = */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x3D/* = */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x3D/* = */ && lastChar !== 0x3D/* = */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '=='
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '=='
            stack++;
          } // else {
            //  // standalone ' == ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'mark_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'mark_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process *this* and _that_




function isAlphaNum(code) {
  return (code >= 0x30 /* 0 */ && code <= 0x39 /* 9 */) ||
         (code >= 0x41 /* A */ && code <= 0x5A /* Z */) ||
         (code >= 0x61 /* a */ && code <= 0x7A /* z */);
}

// parse sequence of emphasis markers,
// "start" should point at a valid marker
function scanDelims(state, start) {
  var pos = start, lastChar, nextChar, count,
      can_open = true,
      can_close = true,
      max = state.posMax,
      marker = state.src.charCodeAt(start);

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;

  while (pos < max && state.src.charCodeAt(pos) === marker) { pos++; }
  if (pos >= max) { can_open = false; }
  count = pos - start;

  if (count >= 4) {
    // sequence of four or more unescaped markers can't start/end an emphasis
    can_open = can_close = false;
  } else {
    nextChar = pos < max ? state.src.charCodeAt(pos) : -1;

    // check whitespace conditions
    if (nextChar === 0x20 || nextChar === 0x0A) { can_open = false; }
    if (lastChar === 0x20 || lastChar === 0x0A) { can_close = false; }

    if (marker === 0x5F /* _ */) {
      // check if we aren't inside the word
      if (isAlphaNum(lastChar)) { can_open = false; }
      if (isAlphaNum(nextChar)) { can_close = false; }
    }
  }

  return {
    can_open: can_open,
    can_close: can_close,
    delims: count
  };
}

module.exports = function emphasis(state, silent) {
  var startCount,
      count,
      found,
      oldCount,
      newCount,
      stack,
      res,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker !== 0x5F/* _ */ && marker !== 0x2A /* * */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode

  res = scanDelims(state, start);
  startCount = res.delims;
  if (!res.can_open) {
    state.pos += startCount;
    if (!silent) { state.pending += state.src.slice(start, state.pos); }
    return true;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + startCount;
  stack = [ startCount ];

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === marker) {
      res = scanDelims(state, state.pos);
      count = res.delims;
      if (res.can_close) {
        oldCount = stack.pop();
        newCount = count;

        while (oldCount !== newCount) {
          if (newCount < oldCount) {
            stack.push(oldCount - newCount);
            break;
          }

          // assert(newCount > oldCount)
          newCount -= oldCount;

          if (stack.length === 0) { break; }
          state.pos += oldCount;
          oldCount = stack.pop();
        }

        if (stack.length === 0) {
          startCount = oldCount;
          found = true;
          break;
        }
        state.pos += count;
        continue;
      }

      if (res.can_open) { stack.push(count); }
      state.pos += count;
      continue;
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + startCount;

  if (!silent) {
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_open', level: state.level++ });
    }
    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_open', level: state.level++ });
    }

    state.parser.tokenize(state);

    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_close', level: --state.level });
    }
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_close', level: --state.level });
    }
  }

  state.pos = state.posMax + startCount;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ~subscript~



// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

module.exports = function sub(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sub',
      level: state.level,
      content: content.replace(UNESCAPE_RE, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process ^superscript^



// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

module.exports = function sup(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x5E/* ^ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sup',
      level: state.level,
      content: content.replace(UNESCAPE_RE, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process [links](<to> "stuff")



var parseLinkLabel       = __webpack_require__(334);
var parseLinkDestination = __webpack_require__(661);
var parseLinkTitle       = __webpack_require__(663);
var normalizeReference   = __webpack_require__(664);


module.exports = function links(state, silent) {
  var labelStart,
      labelEnd,
      label,
      href,
      title,
      pos,
      ref,
      code,
      isImage = false,
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker === 0x21/* ! */) {
    isImage = true;
    marker = state.src.charCodeAt(++start);
  }

  if (marker !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 1;
  labelEnd = parseLinkLabel(state, start);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    if (parseLinkDestination(state, pos)) {
      href = state.linkContent;
      pos = state.pos;
    } else {
      href = '';
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
      title = state.linkContent;
      pos = state.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //

    // do not allow nested reference links
    if (state.linkLevel > 0) { return false; }

    // [foo]  [bar]
    //      ^^ optional whitespace (can include newlines)
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = start - 1;
      }
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      if (typeof label === 'undefined') {
        pos = labelEnd + 1;
      }
      label = state.src.slice(labelStart, labelEnd);
    }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    if (isImage) {
      state.push({
        type: 'image',
        src: href,
        title: title,
        alt: state.src.substr(labelStart, labelEnd - labelStart),
        level: state.level
      });
    } else {
      state.push({
        type: 'link_open',
        href: href,
        title: title,
        level: state.level++
      });
      state.linkLevel++;
      state.parser.tokenize(state);
      state.linkLevel--;
      state.push({ type: 'link_close', level: --state.level });
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process inline footnotes (^[...])



var parseLinkLabel = __webpack_require__(334);


module.exports = function footnote_inline(state, silent) {
  var labelStart,
      labelEnd,
      footnoteId,
      oldLength,
      max = state.posMax,
      start = state.pos;

  if (start + 2 >= max) { return false; }
  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 2;
  labelEnd = parseLinkLabel(state, start + 1);

  // parser failed to find ']', so it's not a valid note
  if (labelEnd < 0) { return false; }

  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    if (!state.env.footnotes) { state.env.footnotes = {}; }
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }
    footnoteId = state.env.footnotes.list.length;

    state.pos = labelStart;
    state.posMax = labelEnd;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      level: state.level
    });
    state.linkLevel++;
    oldLength = state.tokens.length;
    state.parser.tokenize(state);
    state.env.footnotes.list[footnoteId] = { tokens: state.tokens.splice(oldLength) };
    state.linkLevel--;
  }

  state.pos = labelEnd + 1;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process footnote references ([^...])




module.exports = function footnote_ref(state, silent) {
  var label,
      pos,
      footnoteId,
      footnoteSubId,
      max = state.posMax,
      start = state.pos;

  // should be at least 4 chars - "[^x]"
  if (start + 3 > max) { return false; }

  if (!state.env.footnotes || !state.env.footnotes.refs) { return false; }
  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x0A) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos >= max) { return false; }
  pos++;

  label = state.src.slice(start + 2, pos - 1);
  if (typeof state.env.footnotes.refs[':' + label] === 'undefined') { return false; }

  if (!silent) {
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }

    if (state.env.footnotes.refs[':' + label] < 0) {
      footnoteId = state.env.footnotes.list.length;
      state.env.footnotes.list[footnoteId] = { label: label, count: 0 };
      state.env.footnotes.refs[':' + label] = footnoteId;
    } else {
      footnoteId = state.env.footnotes.refs[':' + label];
    }

    footnoteSubId = state.env.footnotes.list[footnoteId].count;
    state.env.footnotes.list[footnoteId].count++;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      subId: footnoteSubId,
      level: state.level
    });
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process autolinks '<protocol:...>'



var url_schemas   = __webpack_require__(1442);
var normalizeLink = __webpack_require__(662);


/*eslint max-len:0*/
var EMAIL_RE    = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;


module.exports = function autolink(state, silent) {
  var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  tail = state.src.slice(pos);

  if (tail.indexOf('>') < 0) { return false; }

  linkMatch = tail.match(AUTOLINK_RE);

  if (linkMatch) {
    if (url_schemas.indexOf(linkMatch[1].toLowerCase()) < 0) { return false; }

    url = linkMatch[0].slice(1, -1);
    fullUrl = normalizeLink(url);
    if (!state.parser.validateLink(url)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += linkMatch[0].length;
    return true;
  }

  emailMatch = tail.match(EMAIL_RE);

  if (emailMatch) {

    url = emailMatch[0].slice(1, -1);

    fullUrl = normalizeLink('mailto:' + url);
    if (!state.parser.validateLink(fullUrl)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += emailMatch[0].length;
    return true;
  }

  return false;
};


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// List of valid url schemas, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#autolinks




module.exports = [
  'coap',
  'doi',
  'javascript',
  'aaa',
  'aaas',
  'about',
  'acap',
  'cap',
  'cid',
  'crid',
  'data',
  'dav',
  'dict',
  'dns',
  'file',
  'ftp',
  'geo',
  'go',
  'gopher',
  'h323',
  'http',
  'https',
  'iax',
  'icap',
  'im',
  'imap',
  'info',
  'ipp',
  'iris',
  'iris.beep',
  'iris.xpc',
  'iris.xpcs',
  'iris.lwz',
  'ldap',
  'mailto',
  'mid',
  'msrp',
  'msrps',
  'mtqp',
  'mupdate',
  'news',
  'nfs',
  'ni',
  'nih',
  'nntp',
  'opaquelocktoken',
  'pop',
  'pres',
  'rtsp',
  'service',
  'session',
  'shttp',
  'sieve',
  'sip',
  'sips',
  'sms',
  'snmp',
  'soap.beep',
  'soap.beeps',
  'tag',
  'tel',
  'telnet',
  'tftp',
  'thismessage',
  'tn3270',
  'tip',
  'tv',
  'urn',
  'vemmi',
  'ws',
  'wss',
  'xcon',
  'xcon-userid',
  'xmlrpc.beep',
  'xmlrpc.beeps',
  'xmpp',
  'z39.50r',
  'z39.50s',
  'adiumxtra',
  'afp',
  'afs',
  'aim',
  'apt',
  'attachment',
  'aw',
  'beshare',
  'bitcoin',
  'bolo',
  'callto',
  'chrome',
  'chrome-extension',
  'com-eventbrite-attendee',
  'content',
  'cvs',
  'dlna-playsingle',
  'dlna-playcontainer',
  'dtn',
  'dvb',
  'ed2k',
  'facetime',
  'feed',
  'finger',
  'fish',
  'gg',
  'git',
  'gizmoproject',
  'gtalk',
  'hcp',
  'icon',
  'ipn',
  'irc',
  'irc6',
  'ircs',
  'itms',
  'jar',
  'jms',
  'keyparc',
  'lastfm',
  'ldaps',
  'magnet',
  'maps',
  'market',
  'message',
  'mms',
  'ms-help',
  'msnim',
  'mumble',
  'mvn',
  'notes',
  'oid',
  'palm',
  'paparazzi',
  'platform',
  'proxy',
  'psyc',
  'query',
  'res',
  'resource',
  'rmi',
  'rsync',
  'rtmp',
  'secondlife',
  'sftp',
  'sgn',
  'skype',
  'smb',
  'soldat',
  'spotify',
  'ssh',
  'steam',
  'svn',
  'teamspeak',
  'things',
  'udp',
  'unreal',
  'ut2004',
  'ventrilo',
  'view-source',
  'webcal',
  'wtai',
  'wyciwyg',
  'xfire',
  'xri',
  'ymsgr'
];


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html tags




var HTML_TAG_RE = __webpack_require__(1444).HTML_TAG_RE;


function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


module.exports = function htmltag(state, silent) {
  var ch, match, max, pos = state.pos;

  if (!state.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    state.push({
      type: 'htmltag',
      content: state.src.slice(pos, pos + match[0].length),
      level: state.level
    });
  }
  state.pos += match[0].length;
  return true;
};


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Regexps to match html elements




function replace(regex, options) {
  regex = regex.source;
  options = options || '';

  return function self(name, val) {
    if (!name) {
      return new RegExp(regex, options);
    }
    val = val.source || val;
    regex = regex.replace(name, val);
    return self;
  };
}


var attr_name     = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;

var unquoted      = /[^"'=<>`\x00-\x20]+/;
var single_quoted = /'[^']*'/;
var double_quoted = /"[^"]*"/;

/*eslint no-spaced-func:0*/
var attr_value  = replace(/(?:unquoted|single_quoted|double_quoted)/)
                    ('unquoted', unquoted)
                    ('single_quoted', single_quoted)
                    ('double_quoted', double_quoted)
                    ();

var attribute   = replace(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)
                    ('attr_name', attr_name)
                    ('attr_value', attr_value)
                    ();

var open_tag    = replace(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)
                    ('attribute', attribute)
                    ();

var close_tag   = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
var comment     = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
var processing  = /<[?].*?[?]>/;
var declaration = /<![A-Z]+\s+[^>]*>/;
var cdata       = /<!\[CDATA\[[\s\S]*?\]\]>/;

var HTML_TAG_RE = replace(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)
  ('open_tag', open_tag)
  ('close_tag', close_tag)
  ('comment', comment)
  ('processing', processing)
  ('declaration', declaration)
  ('cdata', cdata)
  ();


module.exports.HTML_TAG_RE = HTML_TAG_RE;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



var entities          = __webpack_require__(660);
var has               = __webpack_require__(86).has;
var isValidEntityCode = __webpack_require__(86).isValidEntityCode;
var fromCodePoint     = __webpack_require__(86).fromCodePoint;


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


module.exports = function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        if (has(entities, match[1])) {
          if (!silent) { state.pending += entities[match[1]]; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
};


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Remarkable default options




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'replacements',
        'linkify',
        'smartquotes',
        'references',
        'abbr2',
        'footnote_tail'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'footnote',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph',
        'table'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'del',
        'emphasis',
        'entity',
        'escape',
        'footnote_ref',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Remarkable default options




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes:       '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight:     null,

    maxNesting:    20            // Internal protection, recursion limit
  },

  components: {
    // Don't restrict core/block/inline rules
    core: {},
    block: {},
    inline: {}
  }
};


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Commonmark default options




module.exports = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'abbr2'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AssignmentAvatars = __webpack_require__(666);

var _AssignmentAvatars2 = _interopRequireDefault(_AssignmentAvatars);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _time = __webpack_require__(161);

var _messages = __webpack_require__(21);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestListItemAssignment = function (_Component) {
  (0, _inherits3.default)(QuestListItemAssignment, _Component);

  function QuestListItemAssignment() {
    (0, _classCallCheck3.default)(this, QuestListItemAssignment);
    return (0, _possibleConstructorReturn3.default)(this, (QuestListItemAssignment.__proto__ || (0, _getPrototypeOf2.default)(QuestListItemAssignment)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestListItemAssignment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          assignedBy = _props.assignedBy,
          assignedTo = _props.assignedTo,
          message = _props.message,
          updatedAt = _props.updatedAt,
          clickHandler = _props.clickHandler,
          questIsAssignedToUser = _props.questIsAssignedToUser,
          questIsAssignedByUser = _props.questIsAssignedByUser,
          assignmentType = _props.assignmentType;


      var firstString = questIsAssignedByUser ? '<strong>You</strong>' : (0, _name.getUserDisplayName)(assignedBy);

      var lastString = questIsAssignedToUser ? '<strong>you</strong>' : (0, _name.getUserDisplayName)(assignedTo);

      var fullMessage = assignmentType === 'rejection' ? (0, _name.getUserDisplayName)(assignedBy) + ' returned this quest from Publication Review.' : firstString + ' assigned this quest to ' + lastString + '.';

      return _react2.default.createElement(
        'div',
        { className: 'quest-list-item-assignment', onClick: clickHandler },
        assignedBy && assignedTo && _react2.default.createElement(
          'div',
          { className: 'assignment-top' },
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(_AssignmentAvatars2.default, {
              fromPhotoUrl: assignedBy.photo_url,
              toPhotoUrl: assignedTo.photo_url
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'middle' },
            _react2.default.createElement('div', {
              className: 'assignment-info caption1',
              dangerouslySetInnerHTML: { __html: fullMessage }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement(
              'div',
              { className: 'caption1 date' },
              (0, _time.getDateDisplay)(updatedAt, true),
              (0, _time.getDaysAgoFromMinutes)((0, _time.getDifferenceInMinutesToNow)(updatedAt)) <= 7 && _react2.default.createElement(
                'span',
                null,
                '\xA0',
                _messages.ago
              )
            )
          )
        ),
        message && _react2.default.createElement(
          'div',
          { className: 'assignment-bottom' },
          _react2.default.createElement('div', { className: 'left' }),
          _react2.default.createElement(
            'div',
            { className: 'middle' },
            _react2.default.createElement(
              'div',
              { className: 'caption1 assignment-message' },
              assignmentType === 'rejection' ? _react2.default.createElement(_MarkdownLabel2.default, { value: message }) : message
            )
          )
        )
      );
    }
  }]);
  return QuestListItemAssignment;
}(_react.Component);

exports.default = QuestListItemAssignment;


QuestListItemAssignment.propTypes = {
  assignedBy: _propTypes2.default.object.isRequired,
  assignedTo: _propTypes2.default.object.isRequired,
  message: _propTypes2.default.string,
  updatedAt: _propTypes2.default.number.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  questIsAssignedToUser: _propTypes2.default.bool.isRequired,
  questIsAssignedByUser: _propTypes2.default.bool.isRequired,
  assignmentType: _propTypes2.default.string
};

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTEgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1My4xICg3MjYzMSkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+N0JBRUMyRDUtODQ2RC00OTgzLTlBODktMzNFQTc3OTVGRkJFPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSIwMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1RdWVzdC1DYXJkcy0tLVByaW9yaXR5LUluZGljYXRvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyODEuMDAwMDAwLCAtNTA2LjAwMDAwMCkiIGZpbGw9IiNFMzQzNjMiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTI4MS4wMDA0OCw1MDcuNTA2NTE2IEMxMjgxLjAwMDQ3LDUwNy4zMDE5MjMgMTI4MS4wMDA0NSw1MDcuMDk3MzI5IDEyODEuMDAwNDQsNTA2Ljg5MjczNSBDMTI4MS4wMDA0NCw1MDYuMTkwMDI5IDEyODEuODA0NTUsNTA1Ljc4Mjk2NSAxMjgyLjUzOTI0LDUwNi4xMjA3NDggQzEyODUuMjQyOTYsNTA3LjM2Mzk0MSAxMjg3Ljk0NDQyLDUwOC42MTA2MTQgMTI5MC42NDY4MSw1MDkuODU1OTIgQzEyOTAuOTE5OSw1MDkuOTgxNzYgMTI5MS4xODk0OSw1MTAuMTEzNTY2IDEyOTEuNDY3NSw1MTAuMjMxMjg1IEMxMjkxLjc5NTk4LDUxMC4zNzAzODQgMTI5MS45OTk5NSw1MTAuNTc4NTk4IDEyOTIsNTEwLjg5NDY2OSBDMTI5Mi4wMDAwNSw1MTEuMjEyODUzIDEyOTEuNzgwOTMsNTExLjQwODI2MyAxMjkxLjQ2MDMyLDUxMS41NTQyNDEgQzEyOTAuMjc4NDMsNTEyLjA5MjM2NSAxMjg5LjEwMjE1LDUxMi42MzkyMzIgMTI4Ny45MjM0MSw1MTMuMTgyMjg3IEMxMjg2LjE0MDk0LDUxNC4wMDM0OTkgMTI4NC4zNTg0Nyw1MTQuODI0ODM2IDEyODIuNTc1MzUsNTE1LjY0NTA5NSBDMTI4Mi40NTI2Niw1MTUuNzAxNTMgMTI4Mi4zMzQ5MSw1MTUuNzQyNjcxIDEyODIuMjIyMjIsNTE1Ljc2ODQwOCBMMTI4Mi4yMjIyMiw1MjQuMzc2MTE5IEMxMjgyLjIyMjIyLDUyNC43MjA2NzkgMTI4MS45NDg2Miw1MjUgMTI4MS42MTExMSw1MjUgQzEyODEuMjczNiw1MjUgMTI4MSw1MjQuNzIwNjc5IDEyODEsNTI0LjM3NjExOSBMMTI4MSw1MDcuNTMxMzQzIEMxMjgxLDUwNy41MjMwMjkgMTI4MS4wMDAxNiw1MDcuNTE0NzUyIDEyODEuMDAwNDgsNTA3LjUwNjUxNiBaIiBpZD0iaWNvbl9oaWdoLXByaW9yaXR5Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTEgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1My4xICg3MjYzMSkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+NDgzRkUxRTktRjFBOC00ODM1LUEyRjYtRDgzREJBMzRDNjE0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSIwMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjIuMC1RdWVzdC1DYXJkcy0tLVByaW9yaXR5LUluZGljYXRvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyODEuMDAwMDAwLCAtNzYyLjAwMDAwMCkiIGZpbGw9IiNGRkFFMDAiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTI4MS4wMDA0OCw3NjMuNTA2NTE2IEMxMjgxLjAwMDQ3LDc2My4zMDE5MjMgMTI4MS4wMDA0NSw3NjMuMDk3MzI5IDEyODEuMDAwNDQsNzYyLjg5MjczNSBDMTI4MS4wMDA0NCw3NjIuMTkwMDI5IDEyODEuODA0NTUsNzYxLjc4Mjk2NSAxMjgyLjUzOTI0LDc2Mi4xMjA3NDggQzEyODUuMjQyOTYsNzYzLjM2Mzk0MSAxMjg3Ljk0NDQyLDc2NC42MTA2MTQgMTI5MC42NDY4MSw3NjUuODU1OTIgQzEyOTAuOTE5OSw3NjUuOTgxNzYgMTI5MS4xODk0OSw3NjYuMTEzNTY2IDEyOTEuNDY3NSw3NjYuMjMxMjg1IEMxMjkxLjc5NTk4LDc2Ni4zNzAzODQgMTI5MS45OTk5NSw3NjYuNTc4NTk4IDEyOTIsNzY2Ljg5NDY2OSBDMTI5Mi4wMDAwNSw3NjcuMjEyODUzIDEyOTEuNzgwOTMsNzY3LjQwODI2MyAxMjkxLjQ2MDMyLDc2Ny41NTQyNDEgQzEyOTAuMjc4NDMsNzY4LjA5MjM2NSAxMjg5LjEwMjE1LDc2OC42MzkyMzIgMTI4Ny45MjM0MSw3NjkuMTgyMjg3IEMxMjg2LjE0MDk0LDc3MC4wMDM0OTkgMTI4NC4zNTg0Nyw3NzAuODI0ODM2IDEyODIuNTc1MzUsNzcxLjY0NTA5NSBDMTI4Mi40NTI2Niw3NzEuNzAxNTMgMTI4Mi4zMzQ5MSw3NzEuNzQyNjcxIDEyODIuMjIyMjIsNzcxLjc2ODQwOCBMMTI4Mi4yMjIyMiw3ODAuMzc2MTE5IEMxMjgyLjIyMjIyLDc4MC43MjA2NzkgMTI4MS45NDg2Miw3ODEgMTI4MS42MTExMSw3ODEgQzEyODEuMjczNiw3ODEgMTI4MSw3ODAuNzIwNjc5IDEyODEsNzgwLjM3NjExOSBMMTI4MSw3NjMuNTMxMzQzIEMxMjgxLDc2My41MjMwMjkgMTI4MS4wMDAxNiw3NjMuNTE0NzUyIDEyODEuMDAwNDgsNzYzLjUwNjUxNiBaIiBpZD0iaWNvbl9tZWRpdW0tcHJpb3JpdHkiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestsSearchDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-size: 11px;\n  font-weight: 300;\n  line-height: 16px;\n  padding-top: 8px;\n'], ['\n  color: #666666;\n  font-size: 11px;\n  font-weight: 300;\n  line-height: 16px;\n  padding-top: 8px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: inherit;\n'], ['\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: inherit;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _CobaltHyperlink = __webpack_require__(667);

var _CobaltHyperlink2 = _interopRequireDefault(_CobaltHyperlink);

var _KeywordSearch = __webpack_require__(455);

var _KeywordSearch2 = _interopRequireDefault(_KeywordSearch);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _QuestStatusSelect = __webpack_require__(668);

var _QuestStatusSelect2 = _interopRequireDefault(_QuestStatusSelect);

var _CourseSelect = __webpack_require__(268);

var _CourseSelect2 = _interopRequireDefault(_CourseSelect);

var _WrappedSearchFilter = __webpack_require__(335);

var _WrappedSearchFilter2 = _interopRequireDefault(_WrappedSearchFilter);

var _SingleSearchArea = __webpack_require__(1455);

var _SingleSearchArea2 = _interopRequireDefault(_SingleSearchArea);

var _quests = __webpack_require__(403);

var _questsfilters = __webpack_require__(301);

var _label = __webpack_require__(148);

var _placeholder = __webpack_require__(150);

var _users = __webpack_require__(217);

var _courselevels = __webpack_require__(336);

var _levels = __webpack_require__(269);

var _reviewtracking = __webpack_require__(553);

var _user = __webpack_require__(45);

var _quests2 = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewTrackingStatusDescription = _styledComponents2.default.div.withConfig({
  displayName: 'QuestsSearch__ReviewTrackingStatusDescription',
  componentId: 'sc-1plp9q7-0'
})(_templateObject);

var ClearSearch = (0, _styledComponents2.default)(_CobaltHyperlink2.default).withConfig({
  displayName: 'QuestsSearch__ClearSearch',
  componentId: 'sc-1plp9q7-1'
})(_templateObject2);

var QuestsSearch = function (_Component) {
  (0, _inherits3.default)(QuestsSearch, _Component);

  function QuestsSearch(props) {
    (0, _classCallCheck3.default)(this, QuestsSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestsSearch.__proto__ || (0, _getPrototypeOf2.default)(QuestsSearch)).call(this, props));

    _this.state = {
      keywordSearched: Boolean(_this.props.keywordFilter),
      questStatusSelectActive: _this.props.statusFilters.length > 0 || _this.props.draftFilterSelected,
      // not ideal - need this key to remount children when clearing search options, to clear children states
      key: Math.random()
    };
    _this.onSearchClickBound = _this.onSearchClick.bind(_this);
    _this.onKeywordKeyPressBound = _this.onKeywordKeyPress.bind(_this);
    _this.onKeywordFilterChangeBound = _this.onKeywordFilterChange.bind(_this);
    _this.setStatusFilterBound = _this.setStatusFilter.bind(_this);
    _this.onKeywordSearchClickBound = _this.onKeywordSearchClick.bind(_this);
    _this.onClearKeywordSearchClickBound = _this.onClearKeywordSearchClick.bind(_this);
    _this.keywordSearchInput = _react2.default.createRef();
    _this.statusFilterRef = _react2.default.createRef();
    _this.courseFilterRef = _react2.default.createRef();
    _this.levelFilterRef = _react2.default.createRef();
    _this.onSetCourseFilterBound = _this.onSetCourseFilter.bind(_this);
    _this.setLevelFilterBound = _this.setLevelFilter.bind(_this);
    _this.onSetReviewTrackingFilterBound = _this.onSetReviewTrackingFilter.bind(_this);
    _this.onClearSearchBound = _this.onClearSearch.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestsSearch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          isFetchingUsers = _props.isFetchingUsers,
          tags = _props.tags,
          isFetchingTags = _props.isFetchingTags,
          authorFilters = _props.authorFilters,
          tagFilters = _props.tagFilters,
          draftFilterSelected = _props.draftFilterSelected,
          allStatusChecked = _props.allStatusChecked,
          statusFilters = _props.statusFilters,
          keywordFilter = _props.keywordFilter,
          primarySubjectFilters = _props.primarySubjectFilters,
          isFetchingSubjects = _props.isFetchingSubjects,
          primarySubjects = _props.primarySubjects,
          assignedToFilters = _props.assignedToFilters,
          qdUsers = _props.qdUsers,
          assignedUsers = _props.assignedUsers,
          gradeLevels = _props.gradeLevels,
          isFetchingGrades = _props.isFetchingGrades,
          gradeFilters = _props.gradeFilters,
          intl = _props.intl,
          courses = _props.courses,
          courseFilter = _props.courseFilter,
          levelFilters = _props.levelFilters,
          levels = _props.levels,
          reviewTrackingStatus = _props.reviewTrackingStatus;


      var isDirty = (0, _quests2.questsSearchFiltersAreDirty)(this.props);

      var labelMessages = {
        author: intl.formatMessage(_label.messages.author),
        tags: intl.formatMessage(_label.messages.tags),
        primarySubject: intl.formatMessage(_label.messages.primarySubject),
        assignedTo: intl.formatMessage(_label.messages.assignedTo),
        status: intl.formatMessage(_label.messages.status),
        targetGradeLevel: intl.formatMessage(_label.messages.targetGradeLevel)
      };

      var placeholderMessages = {
        selectAuthors: intl.formatMessage(_placeholder.messages.selectAuthors),
        selectTags: intl.formatMessage(_placeholder.messages.selectTags),
        selectSubject: intl.formatMessage(_placeholder.messages.selectSubject),
        selectColleagues: intl.formatMessage(_placeholder.messages.selectColleagues),
        selectGrades: intl.formatMessage(_placeholder.messages.selectGrades)
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'quests-search',
          style: { position: 'relative' },
          key: this.state.key
        },
        _react2.default.createElement(_KeywordSearch2.default, {
          keywordFilter: keywordFilter,
          keywordSearchRef: this.keywordSearchInput,
          onKeywordKeyPress: this.onKeywordKeyPressBound,
          onKeywordFilterChange: this.onKeywordFilterChangeBound,
          keywordSearched: this.state.keywordSearched,
          onClearKeywordSearchClick: this.onClearKeywordSearchClickBound,
          onKeywordSearchClick: this.onKeywordSearchClickBound
        }),
        isDirty && _react2.default.createElement(
          ClearSearch,
          { onClick: this.onClearSearchBound },
          'Clear All'
        ),
        _react2.default.createElement(
          'div',
          { className: 'filter-by-container' },
          _react2.default.createElement(
            'div',
            { className: 'caption1 filter-by-caption' },
            'Filter by'
          ),
          _react2.default.createElement(
            'div',
            { className: 'area inputs-wrapper' },
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.author,
              area: 'author',
              placeholder: placeholderMessages.selectAuthors,
              values: authorFilters,
              options: (0, _arraySort2.default)(this.mapList(qdUsers), ['sort']),
              filterAction: _questsfilters.setAuthorFilters,
              loading: isFetchingUsers,
              fetchAction: _quests.fetchQuests
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.assignedTo,
              area: 'assigned-to',
              placeholder: placeholderMessages.selectColleagues,
              values: assignedToFilters,
              options: (0, _arraySort2.default)(this.mapList(assignedUsers, ['sort'])),
              filterAction: _questsfilters.setAssignedToFilters,
              loading: isFetchingUsers,
              fetchAction: _quests.fetchQuests
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.tags,
              area: 'tags',
              placeholder: placeholderMessages.selectTags,
              values: tagFilters,
              options: (0, _arraySort2.default)(this.mapList(tags), ['sort']),
              filterAction: _questsfilters.setTagFilters,
              loading: isFetchingTags,
              fetchAction: _quests.fetchQuests
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.primarySubject,
              area: 'subjects',
              placeholder: placeholderMessages.selectSubject,
              values: primarySubjectFilters,
              options: (0, _arraySort2.default)(this.mapList(primarySubjects), ['sort']),
              filterAction: _questsfilters.setPrimarySubjectFilter,
              loading: isFetchingSubjects,
              fetchAction: _quests.fetchQuests
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.targetGradeLevel,
              area: 'grades',
              placeholder: placeholderMessages.selectGrades,
              values: gradeFilters,
              options: (0, _arraySort2.default)(this.mapList(gradeLevels), ['sort']),
              filterAction: _questsfilters.setTargetGradeLevelFilter,
              loading: isFetchingGrades,
              fetchAction: _quests.fetchQuests
            }),
            _react2.default.createElement(
              _WrappedSearchFilter2.default,
              {
                area: 'status',
                active: this.props.statusFilters.length > 0 || this.props.draftFilterSelected,
                label: 'Status',
                wrappedRef: this.statusFilterRef
              },
              _react2.default.createElement(_QuestStatusSelect2.default, {
                statusFilterRef: this.statusFilterRef,
                setStatusFilter: this.setStatusFilterBound,
                draftFilterSelected: draftFilterSelected,
                statusFilters: statusFilters,
                allStatusChecked: allStatusChecked
              })
            ),
            ((0, _user.isOeReviewer)(this.props.user) || (0, _user.isQuestManager)(this.props.user)) && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(_SingleSearchArea2.default, {
                headerClass: 'h5',
                dispatch: dispatch,
                label: 'Review Tracking',
                area: 'review-tracking',
                placeholder: 'Select Review Tracking',
                value: reviewTrackingStatus,
                options: (0, _arraySort2.default)(_reviewtracking.reviewTracking, ['sort']),
                handleSelectChange: this.onSetReviewTrackingFilterBound
              }),
              _react2.default.createElement(
                'div',
                { style: { marginBottom: '16px' } },
                reviewTrackingStatus && _react2.default.createElement(
                  ReviewTrackingStatusDescription,
                  null,
                  _reviewtracking.reviewTracking.find(function (rt) {
                    return rt.id === reviewTrackingStatus.id;
                  }).description
                )
              )
            ),
            courses.length > 0 && _react2.default.createElement(
              _WrappedSearchFilter2.default,
              {
                area: 'courses',
                active: Boolean(this.props.courseFilter),
                label: 'Intended Journey',
                wrappedRef: this.courseFilterRef
              },
              _react2.default.createElement(_CourseSelect2.default, {
                courseFilterRef: this.courseFilterRef,
                course: courseFilter ? courseFilter : null,
                courses: courses,
                onCourseChange: this.onSetCourseFilterBound,
                labelTruncationLength: 99999,
                placeholder: 'Select journey'
              })
            ),
            courseFilter && _react2.default.createElement(
              _WrappedSearchFilter2.default,
              {
                area: 'levels',
                active: this.props.levelFilters.length > 0,
                disabled: levels.length === 0,
                disabledText: 'No levels are available for this journey.',
                label: 'Intended Level',
                wrappedRef: this.levelFilterRef
              },
              _react2.default.createElement(_reactSelect2.default, {
                multi: true,
                ref: this.levelFilterRef,
                searchable: true,
                options: (0, _levels.mapLevels)(levels, 22),
                value: levelFilters,
                onChange: this.setLevelFilterBound,
                placeholder: 'Select level',
                matchProp: 'label'
              })
            )
          )
        )
      );
    }
  }, {
    key: 'onKeywordFilterChange',
    value: function onKeywordFilterChange(e) {
      this.props.dispatch((0, _questsfilters.setKeywordFilter)(e.currentTarget.value));
    }
  }, {
    key: 'onKeywordSearchClick',
    value: function onKeywordSearchClick() {
      this.setState(function () {
        return {
          keywordSearched: true
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onKeywordKeyPress',
    value: function onKeywordKeyPress(e) {
      if (this.props.keywordFilter.length > 0 && (e.which === 13 || e.charCode === 13)) {
        this.onKeywordSearchClickBound();
        this.keywordSearchInput.current.blur();
      }
    }
  }, {
    key: 'onClearKeywordSearchClick',
    value: function onClearKeywordSearchClick() {
      this.props.dispatch((0, _questsfilters.setKeywordFilter)(''));
      this.setState(function () {
        return {
          keywordSearched: false
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onSearchClick',
    value: function onSearchClick() {
      this.props.dispatch((0, _quests.fetchQuests)(1, true));
    }
  }, {
    key: 'setStatusFilter',
    value: function setStatusFilter(status) {
      if (status.value.length === 0) {
        this.props.dispatch((0, _questsfilters.setDraftFilter)(null));
        this.props.dispatch((0, _questsfilters.setStatusFilter)([]));
        this.onSearchClickBound();
      } else if (status.value.indexOf(1) > -1) {
        this.props.dispatch((0, _questsfilters.setDraftFilter)(1));
        this.props.dispatch((0, _questsfilters.setStatusFilter)([]));
        this.onSearchClickBound();
      } else {
        this.props.dispatch((0, _questsfilters.setStatusFilter)(status.value));
        this.props.dispatch((0, _questsfilters.setDraftFilter)(null));
        this.onSearchClickBound();
      }
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.sort ? el.sort : el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'onSetCourseFilter',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _questsfilters.setCourseFilter)(e ? e : null));

              case 2:
                this.onSearchClickBound();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSetCourseFilter(_x) {
        return _ref.apply(this, arguments);
      }

      return onSetCourseFilter;
    }()
  }, {
    key: 'setLevelFilter',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.props.dispatch((0, _questsfilters.setLevelFilter)(event.map(function (e) {
                  return e.value;
                })));
                this.props.dispatch(this.onSearchClickBound);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setLevelFilter(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setLevelFilter;
    }()
  }, {
    key: 'onSetReviewTrackingFilter',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(value) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.dispatch((0, _questsfilters.setReviewTrackingStatus)(value));

              case 2:
                this.props.dispatch(this.onSearchClickBound);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSetReviewTrackingFilter(_x3) {
        return _ref3.apply(this, arguments);
      }

      return onSetReviewTrackingFilter;
    }()
  }, {
    key: 'onClearSearch',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var dispatch;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = this.props.dispatch;
                _context4.next = 3;
                return dispatch((0, _questsfilters.clearSearchFilters)());

              case 3:
                _context4.next = 5;
                return this.setState(function () {
                  return {
                    keywordSearched: false,
                    // not ideal, but much less cumbersome than manually clearing the state of each SearchArea/Select input
                    key: Math.random()
                  };
                });

              case 5:
                dispatch(this.onSearchClickBound);

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onClearSearch() {
        return _ref4.apply(this, arguments);
      }

      return onClearSearch;
    }()
  }]);
  return QuestsSearch;
}(_react.Component);

QuestsSearch.propTypes = {
  dispatch: _propTypes2.default.func,
  qdUsers: _propTypes2.default.array.isRequired,
  assignedUsers: _propTypes2.default.array.isRequired,
  isFetchingUsers: _propTypes2.default.bool,
  tags: _propTypes2.default.array.isRequired,
  isFetchingTags: _propTypes2.default.bool,
  authorFilters: _propTypes2.default.array,
  tagFilters: _propTypes2.default.array,
  statusFilters: _propTypes2.default.array,
  keywordFilter: _propTypes2.default.string,
  draftFilterSelected: _propTypes2.default.bool,
  allStatusChecked: _propTypes2.default.bool,
  primarySubjectFilters: _propTypes2.default.array,
  primarySubjects: _propTypes2.default.array,
  isFetchingSubjects: _propTypes2.default.bool,
  assignedToFilters: _propTypes2.default.array,
  gradeLevels: _propTypes2.default.array,
  isFetchingGrades: _propTypes2.default.bool,
  gradeFilters: _propTypes2.default.array,
  intl: _propTypes2.default.object.isRequired,
  courses: _propTypes2.default.array,
  courseFilter: _propTypes2.default.object,
  levelFilters: _propTypes2.default.array,
  levels: _propTypes2.default.array,
  reviewTrackingStatus: _propTypes2.default.object,
  user: _propTypes2.default.object.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    users: state.users.items,
    qdUsers: (0, _users.getqdUsers)(state),
    assignedUsers: (0, _users.assignedUsers)(state),
    isFetchingUsers: state.users.isFetching,
    tags: state.tags.items,
    isFetchingTags: state.tags.isFetching,
    authorFilters: state.questsfilters.authors_id_in || [],
    tagFilters: state.questsfilters.questtags_id_in || [],
    draftFilterSelected: state.questsfilters.reviewing_compiled_quest_state_null !== null,
    statusFilters: state.questsfilters.reviewing_compiled_quest_state_in || [],
    keywordFilter: state.questsfilters.name_or_description_cont || '',
    allStatusChecked: !state.questsfilters.reviewing_compiled_quest_state_null && state.questsfilters.reviewing_compiled_quest_state_in.length === 0,
    primarySubjects: state.subjects.items,
    primarySubjectFilters: state.questsfilters.quest_subject_id_in || [],
    isFetchingSubjects: state.subjects.isFetching,
    assignedToFilters: state.questsfilters.assigned_to_id_in,
    gradeLevels: state.gradelevels.items,
    isFetchingGrades: state.gradelevels.isFetching,
    gradeFilters: state.questsfilters.grade_levels_id_in,
    courses: state.mockcourses.items,
    courseFilter: state.questsfilters.mock_course_id_in || null,
    levelFilters: state.questsfilters.mock_level_id_in || [],
    levels: (0, _courselevels.courseLevels)(state, state.questsfilters.mock_course_id_in),
    reviewTrackingStatus: state.questsfilters.reviewTrackingStatus,
    user: state.user.user
  };
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(QuestsSearch));
exports.QuestsSearchDisconnected = QuestsSearch; // pure component - for tests

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestStatus = __webpack_require__(453);

var _QuestStatus2 = _interopRequireDefault(_QuestStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestStatusSelectOption = function (_Component) {
  (0, _inherits3.default)(QuestStatusSelectOption, _Component);

  function QuestStatusSelectOption() {
    (0, _classCallCheck3.default)(this, QuestStatusSelectOption);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestStatusSelectOption.__proto__ || (0, _getPrototypeOf2.default)(QuestStatusSelectOption)).call(this));

    _this.handleMouseDownBound = _this.handleMouseDown.bind(_this);
    _this.handleMouseEnterBound = _this.handleMouseEnter.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestStatusSelectOption, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          onMouseDown: this.handleMouseDownBound,
          onMouseEnter: this.handleMouseEnterBound,
          onMouseMove: this.handleMouseMoveBound,
          title: this.props.option.title
        },
        _react2.default.createElement(_QuestStatus2.default, { status: this.props.option.className })
      );
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onSelect(this.props.option, event);
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(event) {
      this.props.onFocus(this.props.option, event);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove(event) {
      if (this.props.isFocused) return;
      this.props.onFocus(this.props.option, event);
    }
  }]);
  return QuestStatusSelectOption;
}(_react.Component);

exports.default = QuestStatusSelectOption;


QuestStatusSelectOption.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  isDisabled: _propTypes2.default.bool,
  isFocused: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  onFocus: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  option: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuestStatus = __webpack_require__(453);

var _QuestStatus2 = _interopRequireDefault(_QuestStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestStatusSelectValue = function QuestStatusSelectValue(props) {
  return _react2.default.createElement(
    'div',
    { className: 'Select-value', title: props.value.title },
    _react2.default.createElement(
      'span',
      { className: 'Select-value-label' },
      _react2.default.createElement(_QuestStatus2.default, { status: props.value.className })
    )
  );
};

QuestStatusSelectValue.propTypes = {
  value: _propTypes2.default.object
};

exports.default = QuestStatusSelectValue;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleSearchArea = function (_Component) {
  (0, _inherits3.default)(SingleSearchArea, _Component);

  function SingleSearchArea(props) {
    (0, _classCallCheck3.default)(this, SingleSearchArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SingleSearchArea.__proto__ || (0, _getPrototypeOf2.default)(SingleSearchArea)).call(this, props));

    _this.state = {
      selectedValue: props.value,
      active: Boolean(props.value)
    };

    _this.onSelectChangeBound = _this.onSelectChange.bind(_this);
    _this.onClickBound = _this.onClick.bind(_this);
    _this.onBlurBound = _this.onBlur.bind(_this);
    _this[props.area] = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(SingleSearchArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          area = _props.area,
          options = _props.options,
          placeholder = _props.placeholder,
          headerClass = _props.headerClass;


      return _react2.default.createElement(
        'div',
        {
          className: 'area ' + area + '-wrapper ' + (this.state.active ? 'active' : ''),
          onMouseDown: this.onClickBound,
          onBlur: this.onBlurBound
        },
        label && _react2.default.createElement(
          'label',
          { className: 'header ' + headerClass },
          label
        ),
        _react2.default.createElement(_reactSelect2.default, {
          ref: this[area],
          clearable: true,
          single: true,
          backspaceRemoves: true,
          options: options,
          value: this.state.selectedValue,
          onChange: this.onSelectChangeBound,
          placeholder: placeholder,
          isLoading: this.props.loading
        })
      );
    }
  }, {
    key: 'onSelectChange',
    value: function onSelectChange(value) {
      this.setState({ selectedValue: value });
      this.props.handleSelectChange(value);
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _this2 = this;

      this.setState(function () {
        return {
          active: true
        };
      });
      if (!this.state.active) {
        setTimeout(function () {
          _this2[_this2.props.area].current.focus();
        }, 100);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (!this.state.selectedValue || this.state.selectedValue.length === 0) {
        this.setState(function () {
          return {
            active: false
          };
        });
      }
    }
  }]);
  return SingleSearchArea;
}(_react.Component);

exports.default = SingleSearchArea;


SingleSearchArea.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.array.isRequired,
  label: _propTypes2.default.string,
  area: _propTypes2.default.string.isRequired,
  handleSelectChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  headerClass: _propTypes2.default.string
};

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestDisconnected = exports.mapStateToProps = undefined;

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouter = __webpack_require__(201);

var _reactIntl = __webpack_require__(16);

var _Quest = __webpack_require__(1457);

var _Quest2 = _interopRequireDefault(_Quest);

var _ReadabilityModal = __webpack_require__(1640);

var _ReadabilityModal2 = _interopRequireDefault(_ReadabilityModal);

var _quest = __webpack_require__(66);

var _confirm = __webpack_require__(1643);

var _router = __webpack_require__(1647);

var _quest2 = __webpack_require__(103);

var _pusher = __webpack_require__(263);

var _users = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestContainer = function (_Component) {
  (0, _inherits3.default)(QuestContainer, _Component);

  function QuestContainer(props) {
    (0, _classCallCheck3.default)(this, QuestContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestContainer.__proto__ || (0, _getPrototypeOf2.default)(QuestContainer)).call(this, props));

    _this.routerWillLeave = _this.routerWillLeave.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _quest.fetchQuest)(this.props.id));
      this.props.dispatch((0, _quest.setQuestSection)((0, _quest2.checkQuestSection)(this.props.section), this.props.activityId, this.props.subsection));
      (0, _router.setAsyncRouteLeaveHook)(this.props.router, this.props.route, this.routerWillLeave);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.id !== this.props.id) {
        this.props.dispatch((0, _quest.fetchQuest)(nextProps.id));
      }

      if (nextProps.section !== this.props.section || nextProps.activityId !== this.props.activityId) {
        this.props.dispatch((0, _quest.setQuestSection)((0, _quest2.checkQuestSection)(nextProps.section), nextProps.activityId));
        if (window.oeQMQuestPusherInstance) {
          (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.section !== this.props.section || prevProps.isEditingQuest !== this.props.isEditingQuest) {
        window.scrollTo(0, 0);
      }
    }

    // https://www.snip2code.com/Snippet/1376044/Async-Route-Leave-Hook
    // http://www.it1me.com/it-answers?id=35275344&ttl=How+to+use+a+custom+component+with+react-router+route+transitions%3F

  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        if (!_this2.props.isEditingQuest && !_this2.props.isEditingComment) {
          // Quest section not being edited - resolve promise and leave
          resolve(true);
        } else {
          // Quest section being edited - ask for confirmation
          (0, _confirm.confirm)('Are you sure', { intl: _this2.props.intl }).then(function (result) {
            // Navigate away confirmed, leave
            resolve(true);
          }, function (result) {
            // Navigate away rejected, don't leave
            resolve(false);
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          isFetching = _props.isFetching,
          isFetchingCompiledQuest = _props.isFetchingCompiledQuest,
          user = _props.user,
          dispatch = _props.dispatch,
          isEditingQuest = _props.isEditingQuest,
          organization = _props.organization,
          isAssigning = _props.isAssigning,
          isUnassigning = _props.isUnassigning,
          users = _props.users,
          assignableUsers = _props.assignableUsers,
          isViewingReadabilityScoresModal = _props.isViewingReadabilityScoresModal,
          viewingReadableScoresSection = _props.viewingReadableScoresSection,
          viewingReadableScoresSubsection = _props.viewingReadableScoresSubsection,
          isFetchingAnalytics = _props.isFetchingAnalytics,
          activityId = _props.activityId,
          isFetchingQuestData = _props.isFetchingQuestData,
          activities = _props.activities;


      var bannerStyle = quest && quest.color ? '#'.concat(quest.color) : '';

      return _react2.default.createElement(
        'div',
        { className: 'quest-container' },
        (isFetching || !quest || isFetchingCompiledQuest || isFetchingAnalytics || isFetchingQuestData) && _react2.default.createElement('div', { className: 'loading' }),
        !isFetching && quest && !isFetchingCompiledQuest && !isFetchingAnalytics && !isFetchingQuestData && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', {
            className: 'banner-image-preview',
            style: { background: bannerStyle }
          }),
          _react2.default.createElement(_Quest2.default, {
            quest: quest,
            dispatch: dispatch,
            isEditingQuest: isEditingQuest,
            user: user,
            organization: organization,
            isAssigning: isAssigning,
            isUnassigning: isUnassigning,
            users: users,
            assignableUsers: assignableUsers,
            socket: this.props.socket,
            activities: activities
          })
        ),
        isViewingReadabilityScoresModal && _react2.default.createElement(_ReadabilityModal2.default, {
          section: viewingReadableScoresSection,
          subsection: viewingReadableScoresSubsection,
          quest: quest,
          dispatch: dispatch,
          activity: activityId ? (0, _quest2.findActivity)(activities, activityId) : null
        })
      );
    }
  }]);
  return QuestContainer;
}(_react.Component);

QuestContainer.propTypes = {
  dispatch: _propTypes2.default.func,
  id: _propTypes2.default.number.isRequired,
  params: _propTypes2.default.object.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  quest: _propTypes2.default.object,
  section: _propTypes2.default.string,
  isFetchingCompiledQuest: _propTypes2.default.bool.isRequired,
  isEditingQuest: _propTypes2.default.bool.isRequired,
  router: _propTypes2.default.object,
  route: _propTypes2.default.object,
  activityId: _propTypes2.default.number,
  subsection: _propTypes2.default.string,
  user: _propTypes2.default.object,
  organization: _propTypes2.default.object,
  isAssigning: _propTypes2.default.bool,
  isUnassigning: _propTypes2.default.bool,
  users: _propTypes2.default.array.isRequired,
  assignableUsers: _propTypes2.default.array,
  viewingReadableScoresSection: _propTypes2.default.string,
  viewingReadableScoresSubsection: _propTypes2.default.string,
  isViewingReadabilityScoresModal: _propTypes2.default.bool,
  intl: _propTypes2.default.object.isRequired,
  isFetchingAnalytics: _propTypes2.default.bool.isRequired,
  socket: _propTypes2.default.object.isRequired,
  isEditingComment: _propTypes2.default.bool,
  isFetchingQuestData: _propTypes2.default.bool.isRequired,
  activities: _propTypes2.default.array.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: parseInt(ownProps.params.id),
    section: ownProps.params.section,
    quest: state.quest.item,
    isFetching: state.quest.isFetching,
    isFetchingCompiledQuest: state.quest.isFetchingCompiledQuest,
    isEditingQuest: state.quest.isEditingQuest,
    activityId: parseInt(ownProps.params.activityId) || state.quest.activityId,
    subsection: state.quest.subsection,
    user: state.user.user,
    organization: state.organization,
    isAssigning: state.quest.isAssigning,
    isUnassigning: state.quest.isUnassigning,
    users: state.users.items,
    assignableUsers: (0, _users.assignableUsers)(state),
    viewingReadableScoresSection: state.quest.viewingReadableScoresSection,
    viewingReadableScoresSubsection: state.quest.viewingReadableScoresSubsection,
    isViewingReadabilityScoresModal: state.modal.isViewingReadabilityScoresModal,
    isFetchingAnalytics: state.quest.isFetchingAnalytics,
    isEditingComment: state.quest.isEditingComment,
    isFetchingQuestData: state.quest.isFetchingQuestData,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(QuestContainer)));
exports.QuestDisconnected = QuestContainer; // pure component - used in tests

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Menu = __webpack_require__(1458);

var _Menu2 = _interopRequireDefault(_Menu);

var _Header = __webpack_require__(1462);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(1463);

var _Body2 = _interopRequireDefault(_Body);

var _AssignmentArea = __webpack_require__(1590);

var _AssignmentArea2 = _interopRequireDefault(_AssignmentArea);

var _AssignmentModal = __webpack_require__(1593);

var _AssignmentModal2 = _interopRequireDefault(_AssignmentModal);

var _UnassignmentModal = __webpack_require__(1635);

var _UnassignmentModal2 = _interopRequireDefault(_UnassignmentModal);

var _ReviewBanner = __webpack_require__(1636);

var _ReviewBanner2 = _interopRequireDefault(_ReviewBanner);

var _assignment = __webpack_require__(241);

var _user = __webpack_require__(45);

var _utils = __webpack_require__(20);

var _review = __webpack_require__(64);

var _assignment2 = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quest = function (_Component) {
  (0, _inherits3.default)(Quest, _Component);

  function Quest(props) {
    (0, _classCallCheck3.default)(this, Quest);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Quest.__proto__ || (0, _getPrototypeOf2.default)(Quest)).call(this, props));

    _this.openAssignmentModalBound = _this.openAssignmentModal.bind(_this);
    _this.openUnassignmentModalBound = _this.openUnassignmentModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Quest, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var dispatch;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = this.props.dispatch;

                dispatch((0, _assignment.assignmentCancelClick)());
                dispatch((0, _assignment.unassignmentCancelClick)());

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          dispatch = _props.dispatch,
          isEditingQuest = _props.isEditingQuest,
          isAssigning = _props.isAssigning,
          user = _props.user,
          organization = _props.organization,
          assignableUsers = _props.assignableUsers,
          isUnassigning = _props.isUnassigning,
          activities = _props.activities;


      var hasAssignments = (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) || !(0, _utils.isNullOrEmpty)(quest.assigned_to) ? 'has-assignments' : '';

      return _react2.default.createElement(
        'div',
        { className: 'quest-view' },
        _react2.default.createElement(_ReviewBanner2.default, { quest: quest }),
        _react2.default.createElement(
          'div',
          { id: 'questContainer' },
          _react2.default.createElement(_Header2.default, { quest: quest }),
          _react2.default.createElement(
            'div',
            { id: 'questBody' },
            _react2.default.createElement(_Body2.default, {
              quest: quest,
              handleAssignClick: this.openAssignmentModalBound
            }),
            _react2.default.createElement(
              'div',
              { className: 'quest-detail-right ' + hasAssignments },
              this.renderAssignmentArea() && _react2.default.createElement(_AssignmentArea2.default, (0, _extends3.default)({}, this.props, {
                handleAssignClick: this.openAssignmentModalBound,
                handleUnassignClick: this.openUnassignmentModalBound,
                questIsAssignedToUser: (0, _assignment2.questIsAssignedToUser)(quest, user),
                isQuestCopyEditorOrQuestAuthorOrQuestManager: (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization)
              })),
              _react2.default.createElement(_Menu2.default, {
                quest: quest,
                dispatch: dispatch,
                isEditingQuest: isEditingQuest,
                activities: activities
              })
            )
          )
        ),
        isAssigning && _react2.default.createElement(_AssignmentModal2.default, {
          dispatch: dispatch,
          quest: quest,
          isQuestCopyEditorOrQuestAuthorOrQuestManager: (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization),
          users: assignableUsers,
          user: user
        }),
        isUnassigning && _react2.default.createElement(_UnassignmentModal2.default, {
          quest: quest,
          dispatch: dispatch,
          questIsAssignedToUser: (0, _assignment2.questIsAssignedToUser)(quest, user)
        })
      );
    }
  }, {
    key: 'openAssignmentModal',
    value: function openAssignmentModal() {
      this.props.dispatch((0, _assignment.assignmentClick)());
    }
  }, {
    key: 'openUnassignmentModal',
    value: function openUnassignmentModal() {
      this.props.dispatch((0, _assignment.unassignmentClick)());
    }
  }, {
    key: 'renderAssignmentArea',
    value: function renderAssignmentArea() {
      var _props2 = this.props,
          quest = _props2.quest,
          user = _props2.user,
          organization = _props2.organization;


      return (!(0, _utils.isNullOrEmpty)(quest.assigned_to) || (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization)) && !(0, _user.isExternalReviewer)(user) && (0, _review.questIsInDraftState)(quest);
    }
  }]);
  return Quest;
}(_react.Component);

exports.default = Quest;


Quest.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  isEditingQuest: _propTypes2.default.bool.isRequired,
  user: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired,
  isAssigning: _propTypes2.default.bool.isRequired,
  users: _propTypes2.default.array.isRequired,
  assignableUsers: _propTypes2.default.array.isRequired,
  isUnassigning: _propTypes2.default.bool.isRequired,
  activities: _propTypes2.default.array.isRequired
};

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _Activities = __webpack_require__(1459);

var _Activities2 = _interopRequireDefault(_Activities);

var _QuestMenuItem = __webpack_require__(1461);

var _QuestMenuItem2 = _interopRequireDefault(_QuestMenuItem);

var _quest = __webpack_require__(103);

var _review = __webpack_require__(64);

var _label = __webpack_require__(148);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function (_PureComponent) {
  (0, _inherits3.default)(Menu, _PureComponent);

  function Menu(props) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          intl = _props.intl,
          activities = _props.activities;


      var basicInfoLabel = intl.formatMessage(_label.messages.basicInfo);
      var topicsAndStandardsLabel = intl.formatMessage(_label.messages.topicsAndStandards);
      var imagesLabel = intl.formatMessage(_label.messages.images);
      var otherInformationLabel = intl.formatMessage(_label.messages.otherInfo);
      var questReviewLabel = intl.formatMessage(_label.messages.questReview);

      return _react2.default.createElement(
        'div',
        { className: 'quest-menu' },
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(_QuestMenuItem2.default, {
            layout: 'basicinformation',
            text: basicInfoLabel,
            isComplete: (0, _quest.isBasicInformationComplete)(quest)
          }),
          _react2.default.createElement(_QuestMenuItem2.default, { layout: 'skills', text: 'Skills' }),
          _react2.default.createElement(_QuestMenuItem2.default, {
            layout: 'topicsandstandards',
            text: topicsAndStandardsLabel
          }),
          _react2.default.createElement(
            'li',
            {
              'data-layout': 'activities',
              id: 'activitiesMenuItem',
              onClick: this.onClickBound
            },
            _react2.default.createElement(
              'div',
              { className: 'label-container' },
              _react2.default.createElement(
                'label',
                null,
                _messages.activitiesMessage
              ),
              _react2.default.createElement('div', { className: 'requiredtool' })
            )
          ),
          activities.length > 0 && _react2.default.createElement(
            'li',
            {
              'data-layout': 'activities',
              className: 'activities-menu-container parent'
            },
            _react2.default.createElement(_Activities2.default, { activities: activities })
          ),
          _react2.default.createElement(_QuestMenuItem2.default, {
            layout: 'images',
            text: 'Image',
            isComplete: (0, _quest.areImagesComplete)(quest)
          }),
          _react2.default.createElement(_QuestMenuItem2.default, {
            layout: 'otherinformation',
            text: otherInformationLabel,
            isComplete: (0, _quest.isOtherInformationComplete)(quest)
          }),
          _react2.default.createElement('div', { className: 'line' }),
          _react2.default.createElement(_QuestMenuItem2.default, {
            layout: 'questreview',
            text: questReviewLabel,
            reviewStatus: (0, _review.getReviewStatus)(quest)
          }),
          _react2.default.createElement(_QuestMenuItem2.default, { layout: 'questhistory', text: 'Quest History' })
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest,
          activities = _props2.activities;

      if (activities.length > 0) {
        // quick and dirty way to default to the first activity when "Activities" header is clicked
        var firstActivityId = activities[0].id;
        document.getElementById(firstActivityId).click();
      } else {
        // handling no activities when Activities menu item clicked
        dispatch((0, _reactRouterRedux.push)('/quest/' + quest.id + '/activities'));
      }
    }
  }]);
  return Menu;
}(_react.PureComponent);

Menu.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  activities: _propTypes2.default.array.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(Menu);

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Activity = __webpack_require__(1460);

var _Activity2 = _interopRequireDefault(_Activity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activities = function (_Component) {
  (0, _inherits3.default)(Activities, _Component);

  function Activities() {
    (0, _classCallCheck3.default)(this, Activities);
    return (0, _possibleConstructorReturn3.default)(this, (Activities.__proto__ || (0, _getPrototypeOf2.default)(Activities)).apply(this, arguments));
  }

  (0, _createClass3.default)(Activities, [{
    key: 'render',
    value: function render() {
      var activities = this.props.activities;

      var activitiesList = activities.map(function (activity, index) {
        return _react2.default.createElement(_Activity2.default, { activity: activity, index: index, key: index });
      });

      return _react2.default.createElement(
        'ul',
        { className: 'activities-list' },
        activitiesList
      );
    }
  }]);
  return Activities;
}(_react.Component);

exports.default = Activities;


Activities.propTypes = {
  activities: _propTypes2.default.array.isRequired
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _CommentCountIndicator = __webpack_require__(669);

var _CommentCountIndicator2 = _interopRequireDefault(_CommentCountIndicator);

var _DraftCommentIndicator = __webpack_require__(670);

var _DraftCommentIndicator2 = _interopRequireDefault(_DraftCommentIndicator);

var _questmenuitem = __webpack_require__(671);

var _contentwarnings = __webpack_require__(167);

var _quest = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activity = function (_Component) {
  (0, _inherits3.default)(Activity, _Component);

  function Activity(props) {
    (0, _classCallCheck3.default)(this, Activity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Activity, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // // Need this because of sorting activities; menu items won't be on DOM
      if (nextProps.activity.activity_order === this.props.activity.activity_order) {
        // Ensures the current activity menu item is highlighted when that activity is being viewed
        var _el = document.getElementById(nextProps.activity.id);
        if (nextProps.questSection === 'activities' && nextProps.activity.id === nextProps.activityId) {
          _el.classList.add('active');
        } else {
          // Remove the highlighting if not actively viewed
          _el.classList.remove('active');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          activity = _props.activity,
          index = _props.index,
          comments = _props.comments,
          draftActivityComments = _props.draftActivityComments;

      var complete = (0, _quest.isActivityComplete)(activity);
      var commentCount = void 0;

      if (comments) {
        commentCount = (0, _questmenuitem.getActivityCommentCount)(comments, activity);
      }

      return _react2.default.createElement(
        'li',
        {
          key: index,
          id: activity.id,
          className: complete ? 'complete' : 'incomplete',
          onClick: this.onClickBound
        },
        _react2.default.createElement(
          'div',
          { className: 'label-container' },
          _react2.default.createElement(
            'label',
            null,
            index + 1,
            '. ',
            activity.name
          ),
          (0, _contentwarnings.activityHasContentWarnings)(activity) && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('div', {
              className: 'generic-content-warning',
              'data-for': 'genericContentWarning',
              'data-tip': 'One or more resources have content warnings'
            }),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'genericContentWarning',
              effect: 'solid',
              offset: { top: -2 }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'draft-comment-indicator-container' },
          draftActivityComments && (0, _questmenuitem.hasActivityDraftComments)(draftActivityComments, activity) && _react2.default.createElement(_DraftCommentIndicator2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'comment-count-indicator-container' },
          commentCount > 0 && _react2.default.createElement(_CommentCountIndicator2.default, { commentCount: commentCount })
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _props2 = this.props,
          activity = _props2.activity,
          dispatch = _props2.dispatch,
          questId = _props2.questId;

      dispatch((0, _reactRouterRedux.push)('/quest/' + questId + '/activities/' + activity.id));
    }
  }]);
  return Activity;
}(_react.Component);

Activity.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  activity: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  comments: _propTypes2.default.array,
  questSection: _propTypes2.default.string,
  activityId: _propTypes2.default.number,
  questId: _propTypes2.default.number,
  draftActivityComments: _propTypes2.default.array
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    comments: state.quest.activityComments,
    questSection: state.quest.section,
    activityId: state.quest.activityId,
    questId: state.quest.item.id,
    draftActivityComments: state.quest.userActivityComments
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Activity);
exports.ActivityDisconnected = Activity; // pure component - used in tests

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestMenuItemDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _CommentCountIndicator = __webpack_require__(669);

var _CommentCountIndicator2 = _interopRequireDefault(_CommentCountIndicator);

var _DraftCommentIndicator = __webpack_require__(670);

var _DraftCommentIndicator2 = _interopRequireDefault(_DraftCommentIndicator);

var _questmenuitem = __webpack_require__(671);

var _contentwarnings = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestMenuItem = function (_Component) {
  (0, _inherits3.default)(QuestMenuItem, _Component);

  function QuestMenuItem(props) {
    (0, _classCallCheck3.default)(this, QuestMenuItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestMenuItem.__proto__ || (0, _getPrototypeOf2.default)(QuestMenuItem)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          comments = _props.comments,
          layout = _props.layout,
          text = _props.text,
          isComplete = _props.isComplete,
          section = _props.section,
          reviewStatus = _props.reviewStatus,
          draftComments = _props.draftComments;

      var commentCount;
      var cssClasses = (0, _questmenuitem.getCssClasses)(section, layout, reviewStatus);

      if (isComplete) {
        cssClasses += ' complete';
      } else if (isComplete !== undefined && !isComplete) {
        cssClasses += ' incomplete';
      }

      if (comments) {
        commentCount = (0, _questmenuitem.getSectionCommentCount)(comments, layout);
      }

      return _react2.default.createElement(
        'li',
        {
          'data-layout': layout,
          className: cssClasses,
          onClick: this.onClickBound
        },
        _react2.default.createElement(
          'div',
          { className: 'label-container' },
          _react2.default.createElement(
            'label',
            null,
            text
          ),
          (0, _questmenuitem.isRequiredSection)(layout) && _react2.default.createElement('div', { className: 'requiredtool' }),
          (0, _contentwarnings.questHasContentWarnings)(this.props.quest) && layout === 'basicinformation' && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('div', {
              className: 'generic-content-warning',
              'data-for': 'genericContentWarningQuest',
              'data-tip': 'This quest contains  content warnings'
            }),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'genericContentWarningQuest',
              effect: 'solid',
              offset: { top: -2 }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'draft-comment-indicator-container' },
          draftComments && (0, _questmenuitem.hasSectionDraftComments)(draftComments, layout) && _react2.default.createElement(_DraftCommentIndicator2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'comment-count-indicator-container' },
          commentCount > 0 && _react2.default.createElement(_CommentCountIndicator2.default, { commentCount: commentCount })
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      var _el = e.currentTarget;
      var layout = _el.getAttribute('data-layout');
      this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.id + '/' + layout));
    }
  }]);
  return QuestMenuItem;
}(_react.Component);

QuestMenuItem.propTypes = {
  comments: _propTypes2.default.array,
  dispatch: _propTypes2.default.func.isRequired,
  layout: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired,
  isComplete: _propTypes2.default.bool,
  reviewStatus: _propTypes2.default.string,
  section: _propTypes2.default.string,
  quest: _propTypes2.default.object,
  draftComments: _propTypes2.default.array
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    comments: state.quest.comments,
    section: state.quest.section,
    quest: state.quest.item,
    draftComments: state.quest.userComments
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuestMenuItem);
exports.QuestMenuItemDisconnected = QuestMenuItem; // pure component - used in tests

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _oeWebCommon = __webpack_require__(117);

var _IntendedCourseLevel = __webpack_require__(665);

var _IntendedCourseLevel2 = _interopRequireDefault(_IntendedCourseLevel);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _PriorityIndicator = __webpack_require__(454);

var _PriorityIndicator2 = _interopRequireDefault(_PriorityIndicator);

var _messages = __webpack_require__(21);

var _review = __webpack_require__(64);

var _quest = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      var quest = this.props.quest;


      return _react2.default.createElement(
        'div',
        { id: 'questHeader' },
        quest.author.split(',').length > 2 && _react2.default.createElement(_reactTooltip2.default, {
          id: 'longAuthorsTooltip',
          effect: 'solid',
          place: 'bottom',
          offset: { bottom: 5 }
        }),
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'averageGradeLevelTooltip',
          effect: 'solid',
          offset: { right: 20, bottom: 15 }
        }),
        _react2.default.createElement(
          'div',
          { className: 'icon-name-section' },
          _react2.default.createElement(_QuestIcon2.default, {
            heightWidth: 100,
            icon_image_url: quest.icon_image_url,
            showTypeIcon: Boolean(quest.type.id),
            questTypeId: quest.type.id,
            questTypeIconSize: 34
          }),
          _react2.default.createElement(
            'div',
            { className: 'info-block' },
            !(0, _review.questIsPublished)(quest) && quest.mock_course && _react2.default.createElement(_IntendedCourseLevel2.default, { quest: quest }),
            _react2.default.createElement(
              'h2',
              { className: 'quest-name' },
              quest.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'author-version-updated-container' },
              _react2.default.createElement(
                'div',
                {
                  className: 'quest-author',
                  'data-for': 'longAuthorsTooltip',
                  'data-tip': quest.author
                },
                (0, _quest.getAuthors)({
                  authors: quest.authors,
                  questId: quest.id
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'version-and-updated' },
                _react2.default.createElement(_oeWebCommon.OEComponents.ElapsedTimeFormatter, {
                  cssClass: 'elapsed-time',
                  time: quest.updated_at,
                  textBefore: 'Last saved'
                }),
                _react2.default.createElement(
                  'span',
                  { className: 'interpunct' },
                  '\u2022'
                ),
                _messages.version,
                '\xA0',
                quest.current_version,
                quest.priority !== 'normal' && _react2.default.createElement(
                  'div',
                  {
                    style: {
                      marginLeft: '15px',
                      display: 'inline-block',
                      verticalAlign: 'bottom'
                    }
                  },
                  _react2.default.createElement(_PriorityIndicator2.default, {
                    priority: quest.priority,
                    questId: quest.id
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Header;
}(_react.Component);

exports.default = Header;


Header.propTypes = {
  quest: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BodyDisconnected = undefined;

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _reactRouterRedux = __webpack_require__(23);

var _Activity = __webpack_require__(1471);

var _Activity2 = _interopRequireDefault(_Activity);

var _BasicInformation = __webpack_require__(1493);

var _BasicInformation2 = _interopRequireDefault(_BasicInformation);

var _Comments = __webpack_require__(1500);

var _Comments2 = _interopRequireDefault(_Comments);

var _Images = __webpack_require__(1505);

var _Images2 = _interopRequireDefault(_Images);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _NoActivities = __webpack_require__(1507);

var _NoActivities2 = _interopRequireDefault(_NoActivities);

var _OtherInformation = __webpack_require__(1508);

var _OtherInformation2 = _interopRequireDefault(_OtherInformation);

var _QuestHistory = __webpack_require__(1509);

var _QuestHistory2 = _interopRequireDefault(_QuestHistory);

var _QuestReview = __webpack_require__(1537);

var _QuestReview2 = _interopRequireDefault(_QuestReview);

var _Skills = __webpack_require__(1563);

var _Skills2 = _interopRequireDefault(_Skills);

var _StudentStats = __webpack_require__(1569);

var _StudentStats2 = _interopRequireDefault(_StudentStats);

var _Topics = __webpack_require__(1572);

var _Topics2 = _interopRequireDefault(_Topics);

var _MultipleEditorsInfo = __webpack_require__(695);

var _MultipleEditorsInfo2 = _interopRequireDefault(_MultipleEditorsInfo);

var _Styled = __webpack_require__(682);

var _Display = __webpack_require__(692);

var _Display2 = _interopRequireDefault(_Display);

var _quest = __webpack_require__(66);

var _logging = __webpack_require__(137);

var _messages = __webpack_require__(21);

var _alert = __webpack_require__(402);

var _multipleeditors = __webpack_require__(341);

var _pusher = __webpack_require__(263);

var _review = __webpack_require__(64);

var _string = __webpack_require__(124);

var _routes = __webpack_require__(235);

var _quest2 = __webpack_require__(103);

var _user = __webpack_require__(45);

var _error = __webpack_require__(464);

var _contentwarnings = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function (_Component) {
  (0, _inherits3.default)(Body, _Component);

  function Body(props) {
    (0, _classCallCheck3.default)(this, Body);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).call(this, props));

    _this.state = {
      quest: props.quest,
      notes: props.notes[0] ? {
        file: props.notes[0],
        description: props.notes[0].description
      } : '',
      presenceChannelModalMessage: {},
      newEditors: []
    };

    _this.onEditClickBound = _this.onEditClick.bind(_this);
    _this.onActualEditClickBound = _this.onActualEditClick.bind(_this);
    _this.onCancelEditClickBound = _this.onCancelEditClick.bind(_this);
    _this.onSaveEditClickBound = _this.onSaveEditClick.bind(_this);
    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.handleNotesUploadBound = _this.handleNotesUpload.bind(_this);
    _this.handleNotesDescriptionChangeBound = _this.handleNotesDescriptionChange.bind(_this);
    _this.handleDeleteNoteBound = _this.handleDeleteNote.bind(_this);
    _this.onCloseModalClickBound = _this.onCloseModalClick.bind(_this);
    _this.handleNotesUploadCancelBound = _this.handleNotesUploadCancel.bind(_this);
    _this.onDeleteQuestClickBound = _this.onDeleteQuestClick.bind(_this);
    _this.onActualDeleteQuestClickBound = _this.onActualDeleteQuestClick.bind(_this);
    _this.hideModalBound = _this.hideModal.bind(_this);
    _this.checkMultipleEditorsBound = _this.checkMultipleEditors.bind(_this);
    _this.editorAddedBound = _this.editorAdded.bind(_this);
    _this.confirmMultipleUsersEditBound = _this.confirmMultipleUsersEdit.bind(_this);
    _this.cancelMultipleUsersEditBound = _this.cancelMultipleUsersEdit.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Body, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _quest.cancelEditQuest)());
      this.editQuestErrorModal = this.refs.editQuestErrorModal;
      this.deleteQuestModal = this.refs.deleteQuestModal.refs.modal;
      this.multipleEditorsWarningModal = this.refs.multipleEditorsWarningModal.refs.modal;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.oeQMQuestPusherInstance) {
        (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence-quest');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.section !== this.props.section) {
        this.setState(function () {
          return {
            quest: nextProps.quest
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          analytics = _props.analytics,
          dispatch = _props.dispatch,
          topicSearchResults = _props.topicSearchResults,
          isSearchingTopics = _props.isSearchingTopics,
          user = _props.user,
          organization = _props.organization,
          isSavingQuest = _props.isSavingQuest,
          error = _props.error,
          activities = _props.activities;


      var section, sectionHeader;
      var isSectionComplete = false;
      var selectedSubsection = this.props.subsection;
      var displayCompleteness = this.props.section === 'basicinformation' || this.props.section === 'activities' || this.props.section === 'images' || this.props.section === 'otherinformation';
      var allowEdit = (0, _review.questIsInDraftState)(quest) && (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization);

      var displayStartEdit = allowEdit && !this.props.isEditingQuest && (this.props.section === 'basicinformation' || this.props.section === 'otherinformation');
      var displayFinishEdit = allowEdit && this.props.isEditingQuest && (this.props.section === 'basicinformation' || this.props.section === 'otherinformation');

      var displayDeleteQuest = allowEdit && this.props.isEditingQuest && this.props.section === 'basicinformation' && ((0, _user.isQuestAuthor)(user, quest, organization) || (0, _user.isQuestManager)(user));

      switch (this.props.section) {
        case 'basicinformation':
          isSectionComplete = (0, _quest2.isBasicInformationComplete)(quest);
          sectionHeader = _messages.basicInformation;
          section = _react2.default.createElement(_BasicInformation2.default, {
            quest: quest,
            handleChange: this.handleChangeBound,
            handleNotesUpload: this.handleNotesUploadBound,
            handleNotesDescriptionChange: this.handleNotesDescriptionChangeBound,
            deleteNote: this.handleDeleteNoteBound,
            dispatch: dispatch,
            handleNotesUploadCancel: this.handleNotesUploadCancelBound
          });
          break;

        case 'skills':
          sectionHeader = 'Skills';
          section = _react2.default.createElement(_Skills2.default, { allowEdit: allowEdit });
          break;

        case 'topicsandstandards':
          sectionHeader = _messages.topicsAndStandards;
          section = _react2.default.createElement(_Topics2.default, {
            quest: quest,
            topics: this.props.topics,
            questId: quest.id,
            dispatch: dispatch,
            topicSearchResults: topicSearchResults,
            isSearching: isSearchingTopics,
            allowEdit: allowEdit
          });
          break;

        case 'activities':
          isSectionComplete = (0, _quest2.areActivitiesComplete)(activities);
          sectionHeader = _messages.activitiesMessage;
          // If there are no activities, don't use the Activity component.
          // By default, it will try to dispatch and load data that it cannot.
          section = activities.length > 0 ? _react2.default.createElement(_Activity2.default, {
            quest: quest,
            activityId: this.props.activityId,
            allowEdit: allowEdit
          }) : _react2.default.createElement(_NoActivities2.default, {
            quest: quest,
            dispatch: dispatch,
            allowEdit: allowEdit
          });
          break;

        case 'images':
          isSectionComplete = (0, _quest2.areImagesComplete)(quest);
          sectionHeader = 'Image';
          section = _react2.default.createElement(_Images2.default, {
            quest: quest,
            allowEdit: allowEdit,
            handleChange: this.handleChangeBound,
            dispatch: dispatch,
            isSavingQuest: isSavingQuest
          });
          break;

        case 'otherinformation':
          isSectionComplete = (0, _quest2.isOtherInformationComplete)(quest);
          sectionHeader = _messages.otherInformation;
          section = _react2.default.createElement(_OtherInformation2.default, {
            quest: quest,
            handleChange: this.handleChangeBound,
            isEditingQuest: this.props.isEditingQuest,
            dispatch: dispatch,
            tags: this.props.tags
          });
          break;

        case 'questreview':
          sectionHeader = _messages.internalReview;
          section = _react2.default.createElement(_QuestReview2.default, { handleAssignClick: this.props.handleAssignClick });
          break;

        case 'questhistory':
          sectionHeader = 'Quest History';
          section = _react2.default.createElement(_QuestHistory2.default, null);
          break;
      }

      if (selectedSubsection) {
        setTimeout(function () {
          document.getElementById('section-' + selectedSubsection).scrollIntoView();
        }, 300);
      }

      var questSectionClass = activities.length === 0 && this.props.section === 'activities' ? 'quest-section empty-activities' : 'quest-section';
      var errorCount = (0, _error.getErrorCount)(error);

      return _react2.default.createElement(
        'div',
        {
          className: 'quest-body-wrapper ' + (this.props.section === 'questhistory' ? 'questhistory' : '')
        },
        quest && analytics && _react2.default.createElement(_StudentStats2.default, {
          stats: analytics,
          multipleVersionsExist: quest.current_version > 1
        }),
        this.props.isEditingQuest && this.presenceChannel && (0, _keys2.default)((0, _multipleeditors.filterCurrentUserFromMembers)(this.presenceChannel.members, this.props.user.id)).length > 0 && _react2.default.createElement(_MultipleEditorsInfo2.default, {
          channel: this.presenceChannel,
          newEditors: this.state.newEditors
        }),
        _react2.default.createElement(
          'div',
          { className: 'qm-view quest-body one' },
          _react2.default.createElement(
            'div',
            { className: 'quest-section-header' },
            _react2.default.createElement(
              _Display2.default,
              { style: { display: 'inline-block' } },
              sectionHeader
            ),
            displayStartEdit && _react2.default.createElement('div', { className: 'edit', onClick: this.onEditClickBound }),
            displayFinishEdit && !this.props.isUploadingNote && _react2.default.createElement(
              'div',
              { className: 'edit-quest-buttons' },
              _react2.default.createElement(
                'div',
                {
                  className: 'button save save-quest edit btn-primary-small ' + (isSavingQuest ? 'disabled' : ''),
                  onClick: this.onSaveEditClickBound
                },
                isSavingQuest ? 'Saving...' : _messages.save
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'button cancel btn-secondary-small ' + (isSavingQuest ? 'disabled' : ''),
                  onClick: this.onCancelEditClickBound
                },
                _messages.cancel
              ),
              error && _react2.default.createElement(
                _Styled.ButtonErrorText,
                { style: { marginLeft: '20px', top: '34px' } },
                'Oops! ' + (errorCount > 1 ? errorCount + ' errors found.' : '1 error found.')
              )
            ),
            displayCompleteness && activities.length > 0 && _react2.default.createElement(
              'div',
              {
                className: isSectionComplete ? 'completeness complete' : 'completeness incomplete'
              },
              _react2.default.createElement(
                'span',
                null,
                isSectionComplete ? _messages.complete : _messages.incomplete
              )
            )
          ),
          _react2.default.createElement('div', { className: 'line' }),
          _react2.default.createElement(
            'div',
            { className: questSectionClass },
            section
          ),
          displayFinishEdit && !this.props.isUploadingNote && this.props.section !== 'otherinformation' && _react2.default.createElement(
            'div',
            { className: 'edit-quest-buttons bottom' },
            _react2.default.createElement(
              'div',
              {
                onClick: this.onSaveEditClickBound,
                className: 'button save save-quest edit btn-primary-small ' + (isSavingQuest ? 'disabled' : '')
              },
              isSavingQuest ? 'Saving...' : _messages.save
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'button cancel btn-secondary-small ' + (isSavingQuest ? 'disabled' : ''),
                onClick: this.onCancelEditClickBound
              },
              _messages.cancel
            ),
            displayDeleteQuest && !quest.published_compiled_quest && _react2.default.createElement(
              'div',
              {
                className: 'button delete btn-destructive-small',
                onClick: this.onDeleteQuestClickBound
              },
              'Delete Quest...'
            ),
            _react2.default.createElement('div', { id: 'placeholder' }),
            error && _react2.default.createElement(
              _Styled.ButtonErrorText,
              { style: { marginLeft: '20px' } },
              'Oops! ' + (errorCount > 1 ? errorCount + ' errors found.' : '1 error found.')
            )
          )
        ),
        (0, _quest2.hideQuestComments)(this.props.section, this.props.activityId) ? null : _react2.default.createElement(_Comments2.default, null),
        _react2.default.createElement(
          _DropModal2.default,
          { ref: 'editQuestErrorModal', className: 'edit-quest-error-modal' },
          _react2.default.createElement(
            'div',
            { className: 'modal-dialog', id: 'errorModal' },
            _react2.default.createElement('div', { className: 'close', onClick: this.onCloseModalClickBound }),
            _react2.default.createElement(
              'ul',
              { className: 'error-list' },
              _react2.default.createElement(
                'li',
                null,
                _messages.nameCantBeBlank
              )
            )
          )
        ),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'deleteQuestModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'deleteQuestModal',
          headingKlass: 'modal-heading warning no-cap',
          headingText: (0, _string.getTruncatedString)({
            val: 'Delete "' + quest.name + '"',
            len: 93,
            appendClosingQuote: true
          }),
          bodyText: 'You\'re about to delete this quest, which will remove it entirely from QuestMaker and cannot be undone.\n          Are you sure you want to proceed?',
          primaryButtonText: 'Yes, Delete',
          secondaryButtonText: 'Cancel, Keep Quest',
          primaryButtonAction: this.onActualDeleteQuestClickBound,
          secondaryButtonAction: this.hideModalBound,
          primaryButtonDestructiveClass: true
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'multipleEditorsWarningModal',
          klass: 'modal multiple-editors-modal',
          modalId: 'multipleEditorsWarningModal',
          headingKlass: 'modal-heading',
          logoKlass: 'logo multiple-editors',
          headingText: 'Edit in Progress',
          bodyText: this.state.presenceChannelModalMessage,
          primaryButtonText: 'Cancel',
          secondaryButtonText: 'Edit Anyway',
          primaryButtonAction: this.cancelMultipleUsersEditBound,
          secondaryButtonAction: this.confirmMultipleUsersEditBound,
          setRawHtmlInBody: true,
          handleNonButtonCancelAction: this.cancelMultipleUsersEditBound
        })
      );
    }
  }, {
    key: 'confirmMultipleUsersEdit',
    value: function confirmMultipleUsersEdit() {
      var _props2 = this.props,
          quest = _props2.quest,
          section = _props2.section,
          dispatch = _props2.dispatch;


      var data = {
        action: 'update',
        section: section,
        quest: {
          id: quest.id,
          name: quest.name
        }
      };
      dispatch((0, _logging.postLoggingInfo)('quest_multiple_editors', data));
      this.onActualEditClick();
    }
  }, {
    key: 'cancelMultipleUsersEdit',
    value: function cancelMultipleUsersEdit() {
      var _props3 = this.props,
          quest = _props3.quest,
          section = _props3.section,
          dispatch = _props3.dispatch;


      if (window.oeQMQuestPusherInstance) {
        (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
      }

      var data = {
        action: 'cancel',
        section: section,
        quest: {
          id: quest.id,
          name: quest.name
        }
      };

      dispatch((0, _logging.postLoggingInfo)('quest_multiple_editors', data));
      this.hideModal();
    }
  }, {
    key: 'editorAdded',
    value: function editorAdded(data) {
      this.setState(function (prevState) {
        return {
          newEditors: prevState.newEditors.concat({
            id: (0, _stringify2.default)(data.id),
            name: data.info.name
          })
        };
      });
    }
  }, {
    key: 'onEditClick',
    value: function onEditClick() {
      if (!(0, _pusher.hasNeededPusherConnection)(window.oeQMQuestPusherInstance)) {
        return this.onActualEditClick();
      }
      this.presenceChannel = window.oeQMQuestPusherInstance.subscribe('presence-quest-' + this.props.quest.id);
      this.presenceChannel.bind('pusher:subscription_succeeded', this.checkMultipleEditorsBound);
      this.presenceChannel.bind('pusher:subscription_failed', this.onActualEditClickBound);
      this.presenceChannel.bind('client-edit', this.editorAddedBound);
    }
  }, {
    key: 'checkMultipleEditors',
    value: function checkMultipleEditors() {
      var _this2 = this;

      // check if anyone else is subscribed to this channel
      if ((0, _keys2.default)(this.presenceChannel.members.members).length > 0 && (0, _keys2.default)(this.presenceChannel.members.members).some(function (m) {
        return JSON.parse(m) !== _this2.props.user.id;
      })) {
        this.setState(function () {
          return {
            presenceChannelModalMessage: (0, _multipleeditors.formatModalWarningMessageProp)(_this2.presenceChannel.members, _this2.props.user.id)
          };
        });
        this.multipleEditorsWarningModal.show();
      } else {
        this.props.dispatch((0, _quest.startEditQuest)());
      }
    }
  }, {
    key: 'onActualEditClick',
    value: function onActualEditClick() {
      var dispatch = this.props.dispatch;

      dispatch((0, _quest.startEditQuest)());
      if (this.presenceChannel) {
        this.presenceChannel.trigger('client-edit', this.presenceChannel.members.me);
      }
      this.multipleEditorsWarningModal.hide();
    }
  }, {
    key: 'onCancelEditClick',
    value: function onCancelEditClick() {
      if (window.oeQMQuestPusherInstance) {
        (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
      }
      this.props.dispatch((0, _quest.cancelEditQuest)());
      this.setState({
        quest: this.props.quest,
        notes: this.props.notes[0] ? {
          file: this.props.notes[0],
          description: this.props.notes[0].description
        } : ''
      });
    }
  }, {
    key: 'onSaveEditClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var quest, drivingQuestionError, learnerGoalError, intl, alertMessage;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                quest = this.state.quest;
                drivingQuestionError = quest.driving_question && quest.driving_question.length > 255;
                learnerGoalError = quest.learner_goal && quest.learner_goal.length > 255;
                intl = this.context.intl;
                alertMessage = intl.formatMessage(_alert.messages.unusualMaterialsLimit);

                if (!(quest.unusual_materials && quest.unusual_materials.length > 1000)) {
                  _context.next = 9;
                  break;
                }

                window.alert(alertMessage);
                _context.next = 27;
                break;

              case 9:
                if (quest.name) {
                  _context.next = 13;
                  break;
                }

                this.editQuestErrorModal.show();
                _context.next = 27;
                break;

              case 13:
                if (!(drivingQuestionError || learnerGoalError || (0, _contentwarnings.contentWarningsSelectedButNoValues)(quest.content_warnings))) {
                  _context.next = 17;
                  break;
                }

                // stringifying this error to simulate server response, to play nice with existing functions
                this.props.dispatch((0, _quest.editQuestDetailsFailure)((0, _stringify2.default)({
                  errors: {
                    driving_question: drivingQuestionError ? ['length error'] : undefined,
                    learner_goal: learnerGoalError ? ['length error'] : undefined,
                    content_warnings: (0, _contentwarnings.contentWarningsSelectedButNoValues)(quest.content_warnings) ? ['content warnings required'] : undefined
                  }
                })));
                _context.next = 27;
                break;

              case 17:
                if (!this.state.notes) {
                  _context.next = 25;
                  break;
                }

                if (!(this.props.notes[0] && this.props.notes[0].id)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 21;
                return this.props.dispatch((0, _quest.editQuestMentorNote)(this.props.quest.id, this.state.notes, this.props.notes[0].id));

              case 21:
                _context.next = 25;
                break;

              case 23:
                _context.next = 25;
                return this.props.dispatch((0, _quest.createQuestMentorNote)(this.props.quest.id, this.state.notes));

              case 25:
                this.props.dispatch((0, _quest.editQuestDetails)(quest));
                if (window.oeQMQuestPusherInstance) {
                  (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
                }

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSaveEditClick() {
        return _ref.apply(this, arguments);
      }

      return onSaveEditClick;
    }()
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({
        quest: (0, _assign2.default)({}, this.state.quest, (0, _defineProperty3.default)({}, event.target.id, event.target.value))
      });
    }
  }, {
    key: 'handleNotesUpload',
    value: function handleNotesUpload(file) {
      this.setState({
        notes: (0, _assign2.default)({}, this.state.notes, {
          file: file
        })
      });
    }
  }, {
    key: 'handleNotesUploadCancel',
    value: function handleNotesUploadCancel() {
      this.setState({
        notes: this.props.notes[0] ? {
          file: this.props.notes[0],
          description: this.props.notes[0].description
        } : ''
      });
    }
  }, {
    key: 'handleNotesDescriptionChange',
    value: function handleNotesDescriptionChange(description) {
      this.setState({
        notes: (0, _assign2.default)({}, this.state.notes, {
          description: description
        })
      });
    }
  }, {
    key: 'handleDeleteNote',
    value: function handleDeleteNote(noteId) {
      this.props.dispatch((0, _quest.deleteNote)(this.props.quest.id, noteId));
      this.setState({ notes: '' });
    }
  }, {
    key: 'onCloseModalClick',
    value: function onCloseModalClick() {
      this.editQuestErrorModal.hide();
    }
  }, {
    key: 'onDeleteQuestClick',
    value: function onDeleteQuestClick() {
      this.deleteQuestModal.show();
    }
  }, {
    key: 'onActualDeleteQuestClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _props4, dispatch, user;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props4 = this.props, dispatch = _props4.dispatch, user = _props4.user;
                _context2.next = 3;
                return dispatch((0, _quest.deleteQuest)(this.props.quest.id));

              case 3:
                _context2.next = 5;
                return this.deleteQuestModal.hide();

              case 5:
                dispatch((0, _reactRouterRedux.push)((0, _routes.getDefaultRoute)(user.organization_roles)));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onActualDeleteQuestClick() {
        return _ref2.apply(this, arguments);
      }

      return onActualDeleteQuestClick;
    }()
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.deleteQuestModal.hide();
      this.multipleEditorsWarningModal.hide();
    }
  }]);
  return Body;
}(_react.Component);

Body.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string.isRequired,
  subsection: _propTypes2.default.string,
  activityId: _propTypes2.default.number,
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  notes: _propTypes2.default.array,
  isUploadingNote: _propTypes2.default.bool.isRequired,
  isEditingQuest: _propTypes2.default.bool.isRequired,
  tags: _propTypes2.default.array.isRequired,
  quests: _propTypes2.default.array.isRequired,
  organization: _propTypes2.default.object.isRequired,
  topics: _propTypes2.default.array.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  analytics: _propTypes2.default.object,
  topicSearchResults: _propTypes2.default.array,
  isSearchingTopics: _propTypes2.default.bool,
  isSavingQuest: _propTypes2.default.bool.isRequired,
  error: _propTypes2.default.object,
  activities: _propTypes2.default.array.isRequired
};

Body.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    section: state.quest.section,
    subsection: state.quest.subsection,
    activityId: state.quest.activityId,
    user: state.user.user,
    notes: state.quest.notes,
    isUploadingNote: state.quest.isUploadingNote,
    isEditingQuest: state.quest.isEditingQuest,
    tags: state.tags.items,
    quests: state.quests.items,
    organization: state.organization,
    topics: state.quest.topics,
    analytics: state.quest.analytics,
    topicSearchResults: state.topics.topicSearchResults,
    isSearchingTopics: state.topics.isSearching,
    isSavingQuest: state.quest.isSavingQuest,
    error: state.quest.error ? (0, _error.parseErrors)(state.quest.error) : null,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Body);
exports.BodyDisconnected = Body; // pure component - used in tests

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _transitionEvents = __webpack_require__(1465);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

var _appendVendorPrefix = __webpack_require__(672);

var _appendVendorPrefix2 = _interopRequireDefault(_appendVendorPrefix);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (animation) {
  var Factory = function (_Component) {
    (0, _inherits3.default)(Factory, _Component);

    function Factory(props) {
      (0, _classCallCheck3.default)(this, Factory);

      var _this = (0, _possibleConstructorReturn3.default)(this, (Factory.__proto__ || (0, _getPrototypeOf2.default)(Factory)).call(this, props));

      _this.state = {
        willHidden: false,
        hidden: true
      };

      _this.hasHidden = _this.hasHidden.bind(_this);
      _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
      _this.leave = _this.leave.bind(_this);
      _this.enter = _this.enter.bind(_this);
      _this.show = _this.show.bind(_this);
      _this.hide = _this.hide.bind(_this);
      _this.toggle = _this.toggle.bind(_this);
      _this.listenKeyboard = _this.listenKeyboard.bind(_this);
      return _this;
    }

    (0, _createClass3.default)(Factory, [{
      key: 'hasHidden',
      value: function hasHidden() {
        return this.state.hidden;
      }
    }, {
      key: 'addTransitionListener',
      value: function addTransitionListener(node, handle) {
        if (node) {
          var endListener = function endListener(e) {
            if (e && e.target !== node) {
              return;
            }
            _transitionEvents2.default.removeEndEventListener(node, endListener);
            handle();
          };
          _transitionEvents2.default.addEndEventListener(node, endListener);
        }
      }
    }, {
      key: 'handleBackdropClick',
      value: function handleBackdropClick() {
        if (this.props.closeOnClick) {
          this.hide('backdrop');
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var hidden = this.hasHidden();
        if (hidden) return null;

        var willHidden = this.state.willHidden;
        var animation = this.props.animation;
        var modalStyle = animation.getModalStyle(willHidden);
        var backdropStyle = animation.getBackdropStyle(willHidden);
        var contentStyle = animation.getContentStyle(willHidden);
        var ref = animation.getRef(willHidden);
        var sharp = animation.getSharp && animation.getSharp(willHidden, this.props.rectStyle);

        // Apply custom style properties
        if (this.props.modalStyle) {
          var prefixedModalStyle = (0, _appendVendorPrefix2.default)(this.props.modalStyle);
          for (var style in prefixedModalStyle) {
            modalStyle[style] = prefixedModalStyle[style];
          }
        }

        if (this.props.backdropStyle) {
          var prefixedBackdropStyle = (0, _appendVendorPrefix2.default)(this.props.backdropStyle);
          for (var _style in prefixedBackdropStyle) {
            backdropStyle[_style] = prefixedBackdropStyle[_style];
          }
        }

        if (this.props.contentStyle) {
          var prefixedContentStyle = (0, _appendVendorPrefix2.default)(this.props.contentStyle);
          for (var _style2 in prefixedContentStyle) {
            contentStyle[_style2] = prefixedContentStyle[_style2];
          }
        }

        var backdrop = this.props.backdrop ? _react2.default.createElement('div', { style: backdropStyle, onClick: this.props.closeOnClick ? this.handleBackdropClick : null }) : undefined;

        if (willHidden) {
          var node = this.refs[ref];
          this.addTransitionListener(node, this.leave);
        }

        return _react2.default.createElement('span', null, _react2.default.createElement('div', { ref: 'modal', style: modalStyle, className: this.props.className }, sharp, _react2.default.createElement('div', { ref: 'content', tabIndex: '-1', style: contentStyle }, this.props.children)), backdrop);
      }
    }, {
      key: 'leave',
      value: function leave() {
        this.setState({
          hidden: true
        });
        this.props.onHide(this.state.hideSource);
      }
    }, {
      key: 'enter',
      value: function enter() {
        var _this2 = this;

        if (this.props.duration >= 0) setTimeout(function () {
          return _this2.hide("timeout");
        }, parseInt(this.props.duration));

        this.props.onShow();
      }
    }, {
      key: 'show',
      value: function show() {
        if (!this.hasHidden()) return;

        this.setState({
          willHidden: false,
          hidden: false
        });

        setTimeout(function () {
          var ref = this.props.animation.getRef();
          var node = this.refs[ref];
          this.addTransitionListener(node, this.enter);
        }.bind(this), 0);
      }
    }, {
      key: 'hide',
      value: function hide(source) {
        if (this.hasHidden()) {
          return;
        }

        this.setState({
          hideSource: source || 'hide',
          willHidden: true
        });
      }
    }, {
      key: 'toggle',
      value: function toggle() {
        if (this.hasHidden()) {
          this.show();
        } else {
          this.hide('toggle');
        }
      }
    }, {
      key: 'listenKeyboard',
      value: function listenKeyboard(event) {
        if (this.props.keyboard && (event.key === 'Escape' || event.keyCode === 27)) {
          this.hide('keyboard');
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('keydown', this.listenKeyboard, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('keydown', this.listenKeyboard, true);
      }
    }]);
    return Factory;
  }(_react.Component);

  ;

  Factory.propTypes = {
    className: _propTypes2.default.string,
    keyboard: _propTypes2.default.bool,
    duration: _propTypes2.default.number,
    onShow: _propTypes2.default.func,
    onHide: _propTypes2.default.func,
    animation: _propTypes2.default.object,
    backdrop: _propTypes2.default.bool,
    closeOnClick: _propTypes2.default.bool,
    modalStyle: _propTypes2.default.object,
    backdropStyle: _propTypes2.default.object,
    contentStyle: _propTypes2.default.object
  };

  Factory.defaultProps = {
    className: '',
    duration: -1,
    onShow: function onShow() {},
    onHide: function onHide() {},
    animation: animation,
    keyboard: true,
    backdrop: true,
    closeOnClick: true,
    modalStyle: {},
    backdropStyle: {},
    contentStyle: {}
  };

  return Factory;
};


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    'transition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'mozTransitionEnd',
    'OTransition': 'oTransitionEnd',
    'msTransition': 'MSTransitionEnd'
  },

  animationend: {
    'animation': 'animationend',
    'WebkitAnimation': 'webkitAnimationEnd',
    'MozAnimation': 'mozAnimationEnd',
    'OAnimation': 'oAnimationEnd',
    'msAnimation': 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (typeof window !== 'undefined') {
  detectEvents();
}


// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

module.exports = {
  addEndEventListener: function(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function(endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function(endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var builtinStyle = __webpack_require__(1467);
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
var domVendorPrefix;

// Helper function to get the proper vendor property name. (transition => WebkitTransition)
module.exports = function(prop, isSupportTest) {

  var vendorProp;
  if (prop in builtinStyle) return prop;

  var UpperProp = prop.charAt(0).toUpperCase() + prop.substr(1);

  if (domVendorPrefix) {

    vendorProp = domVendorPrefix + UpperProp;
    if (vendorProp in builtinStyle) {
      return vendorProp;
    }
  } else {

    for (var i = 0; i < prefixes.length; ++i) {
      vendorProp = prefixes[i] + UpperProp;
      if (vendorProp in builtinStyle) {
        domVendorPrefix = prefixes[i];
        return vendorProp;
      }
    }
  }

  // if support test, not fallback to origin prop name
  if (!isSupportTest) {
    return prop;
  }

}


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = document.createElement('div').style;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var insertRule = __webpack_require__(1469);
var vendorPrefix = __webpack_require__(1470)();
var index = 0;

module.exports = function(keyframes) {
  // random name
  var name = 'anim_' + (++index) + (+new Date);
  var css = "@" + vendorPrefix + "keyframes " + name + " {";

  for (var key in keyframes) {
    css += key + " {";

    for (var property in keyframes[key]) {
      var part = ":" + keyframes[key][property] + ";";
      // We do vendor prefix for every property
      css += vendorPrefix + property + part;
      css += property + part;
    }

    css += "}";
  }

  css += "}";

  insertRule(css);

  return name
}


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extraSheet;

module.exports = function(css) {

  if (!extraSheet) {
    // First time, create an extra stylesheet for adding rules
    extraSheet = document.createElement('style');
    document.getElementsByTagName('head')[0].appendChild(extraSheet);
    // Keep reference to actual StyleSheet object (`styleSheet` for IE < 9)
    extraSheet = extraSheet.sheet || extraSheet.styleSheet;
  }

  var index = (extraSheet.cssRules || extraSheet.rules).length;
  extraSheet.insertRule(css, index);

  return extraSheet;
}


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cssVendorPrefix;

module.exports = function() {

  if (cssVendorPrefix) return cssVendorPrefix;

  var styles = window.getComputedStyle(document.documentElement, '');
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1];

  return cssVendorPrefix = '-' + pre + '-';
}


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityDisconnected = undefined;

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _reactIntl = __webpack_require__(16);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _DraggableListComponent = __webpack_require__(673);

var _DraggableListComponent2 = _interopRequireDefault(_DraggableListComponent);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _Indicator = __webpack_require__(676);

var _Indicator2 = _interopRequireDefault(_Indicator);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _ResourcesList = __webpack_require__(1490);

var _ResourcesList2 = _interopRequireDefault(_ResourcesList);

var _activity = __webpack_require__(240);

var _logging = __webpack_require__(137);

var _modal = __webpack_require__(26);

var _quest = __webpack_require__(103);

var _resources = __webpack_require__(125);

var _orglabels = __webpack_require__(677);

var _messages = __webpack_require__(21);

var _confirm = __webpack_require__(678);

var _multipleeditors = __webpack_require__(341);

var _pusher = __webpack_require__(263);

var _draggableitem = __webpack_require__(680);

var _readability = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activity = function (_Component) {
  (0, _inherits3.default)(Activity, _Component);

  function Activity(props) {
    (0, _classCallCheck3.default)(this, Activity);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Activity.__proto__ || (0, _getPrototypeOf2.default)(Activity)).call(this, props));

    _this.onDeleteActivityClickBound = _this.onDeleteActivityClick.bind(_this);
    _this.onEditActivityClickBound = _this.onEditActivityClick.bind(_this);
    _this.onCreateActivityClickBound = _this.onCreateActivityClick.bind(_this);
    _this.onSortActivitiesClickBound = _this.onSortActivitiesClick.bind(_this);
    _this.onCloseModalClickBound = _this.onCloseModalClick.bind(_this);
    _this.handleReSortActivityBound = _this.handleReSortActivity.bind(_this);
    _this.checkMultipleEditorsBound = _this.checkMultipleEditors.bind(_this);
    _this.onActualEditClickBound = _this.onActualEditClick.bind(_this);
    _this.hideModalBound = _this.hideModal.bind(_this);
    _this.confirmMultipleUsersEditBound = _this.confirmMultipleUsersEdit.bind(_this);
    _this.cancelMultipleUsersEditBound = _this.cancelMultipleUsersEdit.bind(_this);
    _this.onResourceClickBound = _this.onResourceClick.bind(_this);
    _this.state = {
      presenceChannelModalMessage: {}
    };
    return _this;
  }

  (0, _createClass3.default)(Activity, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // this.multipleEditorsWarningModal = this.refs.multipleEditorsWarningModal.refs.modal
      this.sortActivitiesModal = this.refs.sortActivitiesModal;
      if (this.props.activityId) {
        (0, _quest.setActiveMenuItem)(this.props.activityId);
      }
      this.props.dispatch((0, _activity.fetchQuestActivityNotes)(this.props.questId));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.activityId !== this.props.activityId) {
        this.props.dispatch((0, _activity.fetchQuestActivityNotes)(nextProps.questId));
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.activityId) {
        (0, _quest.setActiveMenuItem)(this.props.activityId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          activityId = _props.activityId,
          activityNotes = _props.activityNotes,
          allowEdit = _props.allowEdit,
          dispatch = _props.dispatch,
          currentOrg = _props.currentOrg,
          activities = _props.activities;


      var activityIndex = activities.findIndex(function (activity) {
        return activity.id === activityId;
      });
      var activity = (0, _quest.findActivity)(activities, activityId);
      var resources = activity ? (0, _resources.mapResources)(activity.resources) : '';
      var checkpoint = activity ? activity.checkpoint : '';
      var activityNotesSorted = (0, _arraySort2.default)(activityNotes, ['sort_order']);

      var modalStyle = {
        width: '800px',
        border: '1px solid rgba(0,0,0,0.2)',
        borderRadius: '6px'
      };

      return _react2.default.createElement(
        'div',
        { className: 'activities-list' },
        !activity && _react2.default.createElement('div', { className: 'loading' }),
        activity && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', { className: 'yellow' }),
          _react2.default.createElement(
            'div',
            { className: 'section-inner' },
            _react2.default.createElement(
              'div',
              { className: 'activities-actions' },
              allowEdit && _react2.default.createElement(
                'div',
                {
                  id: 'add-activity',
                  onClick: this.onCreateActivityClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Quest.Activity.AddActivity',
                  defaultMessage: 'Add Activity'
                })
              ),
              allowEdit && activities.length > 1 && _react2.default.createElement(
                'div',
                {
                  id: 'sort-activities',
                  onClick: this.onSortActivitiesClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Quest.Activity.SortActivities',
                  defaultMessage: 'Sort Activities'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'activities' },
              checkpoint && _react2.default.createElement(
                'div',
                { className: 'checkpoint' },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                  id: 'Quest.Activity.Checkpoint',
                  defaultMessage: '&nbsp;&nbsp;&nbsp;&nbsp;Check-in'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'activity-name' },
                _react2.default.createElement(
                  'div',
                  { className: 'name-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { className: 'thename' },
                    activityIndex + 1,
                    '. ',
                    activity.name
                  )
                ),
                allowEdit && _react2.default.createElement('div', {
                  className: 'edit',
                  onClick: this.onEditActivityClickBound
                }),
                allowEdit && _react2.default.createElement(
                  'div',
                  {
                    className: 'trash',
                    onClick: this.onDeleteActivityClickBound
                  },
                  '\xA0'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                (0, _orglabels.activityGoalOrgLabel)(currentOrg),
                _react2.default.createElement('div', { className: 'requiredtool' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                _react2.default.createElement(_MarkdownLabel2.default, {
                  id: 'view-activity-goals',
                  value: activity.goals,
                  additionalCssClasses: 'activity-goals'
                }),
                (0, _readability.hasReadabilityStats)(activity, 'goals') && _react2.default.createElement(_Indicator2.default, {
                  quest: quest,
                  section: 'activity',
                  subsection: 'goals',
                  dispatch: dispatch,
                  scores: (0, _readability.getSectionScores)(activity, 'goals'),
                  readableStatsObject: activity
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.descriptionMessage,
                _react2.default.createElement('div', { className: 'requiredtool' }),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                _react2.default.createElement(_MarkdownLabel2.default, {
                  id: 'view-description',
                  value: activity.description
                }),
                (0, _readability.hasReadabilityStats)(activity, 'description') && _react2.default.createElement(_Indicator2.default, {
                  quest: quest,
                  section: 'activity',
                  subsection: 'description',
                  dispatch: dispatch,
                  scores: (0, _readability.getSectionScores)(activity, 'description'),
                  readableStatsObject: activity
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.requiresArtifact
              ),
              _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                _react2.default.createElement(
                  'label',
                  null,
                  activity.work_product ? _messages.yes : _messages.no
                )
              ),
              activity.work_product && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    'Artifact Type',
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'view-fields' },
                    activity.artifact_type ? _react2.default.createElement(
                      'label',
                      null,
                      activity.artifact_type.name
                    ) : _react2.default.createElement(_NotYetSpecified2.default, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.artifactDescription
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'view-fields' },
                    _react2.default.createElement(_MarkdownLabel2.default, {
                      id: 'artifact-description',
                      value: activity.artifact_description
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.activityResources
              ),
              _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                resources.length === 0 ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(_ResourcesList2.default, {
                  resources: resources,
                  handleResourceClick: this.onResourceClickBound,
                  activity: activity
                })
              ),
              this.hasNotes(activity) && _react2.default.createElement(
                'div',
                { id: 'justForMentors' },
                _react2.default.createElement(
                  'div',
                  { className: 'just-for-mentors-label' },
                  _messages.justFor,
                  '\xA0',
                  _react2.default.createElement(
                    'span',
                    { className: 'label' },
                    _messages.mentors
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.notesForMentors
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'view-fields' },
                  _react2.default.createElement(_MarkdownLabel2.default, {
                    id: 'view-inline-notes',
                    value: activity.inline_notes
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'Quest.Activity.FilesForMentors',
                    defaultMessage: 'Files for Mentors'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'view-fields' },
                  _react2.default.createElement(
                    'div',
                    { id: 'mentorNotesSection' },
                    activityNotes.length > 0 ? _react2.default.createElement(
                      'ul',
                      {
                        className: 'mentor-note-list',
                        id: 'mentorNoteListEl'
                      },
                      activityNotesSorted.map(function (note, index) {
                        return _react2.default.createElement(
                          'li',
                          { key: index },
                          _react2.default.createElement(
                            'div',
                            { className: 'mentor-note-wrapper' },
                            _react2.default.createElement('div', { className: 'icon ' + note.file_type }),
                            _react2.default.createElement(
                              'div',
                              { className: 'name' },
                              _react2.default.createElement(
                                'a',
                                {
                                  target: '=_blank',
                                  rel: 'noreferrer noopener',
                                  href: note.attachment_url
                                },
                                note.attachment_name
                              )
                            ),
                            note.description && _react2.default.createElement(
                              'div',
                              { className: 'description' },
                              note.description
                            )
                          )
                        );
                      })
                    ) : _react2.default.createElement(_NotYetSpecified2.default, null)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.assessmentQuestions
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'view-fields' },
                  _react2.default.createElement(_MarkdownLabel2.default, {
                    id: 'view-mentor-assessment-questions',
                    value: activity.mentor_assessment_questions
                  })
                )
              ),
              _react2.default.createElement(
                _DropModal2.default,
                {
                  ref: 'sortActivitiesModal',
                  className: 'sort-activities-modal',
                  modalStyle: modalStyle
                },
                _react2.default.createElement(
                  'div',
                  { className: 'modal-dialog', id: 'sortActivitiesModal' },
                  _react2.default.createElement('div', {
                    className: 'close',
                    onClick: this.onCloseModalClickBound
                  }),
                  _react2.default.createElement(
                    'div',
                    { id: 'reSortActivities' },
                    _react2.default.createElement(_DraggableListComponent2.default, {
                      list: activities,
                      editListItemPosition: this.handleReSortActivityBound,
                      itemType: 'activity',
                      hideEdit: true,
                      hideDelete: true,
                      hideDescription: true
                    })
                  )
                )
              ),
              _react2.default.createElement(_ModalComponent2.default, {
                ref: 'multipleEditorsWarningModal',
                klass: 'modal multiple-editors-modal',
                modalId: 'multipleEditorsWarningModal',
                headingKlass: 'modal-heading',
                logoKlass: 'logo multiple-editors',
                headingText: 'Edit in Progress',
                bodyText: this.state.presenceChannelModalMessage,
                primaryButtonText: 'Cancel',
                secondaryButtonText: 'Edit Anyway',
                primaryButtonAction: this.cancelMultipleUsersEditBound,
                secondaryButtonAction: this.confirmMultipleUsersEditBound,
                setRawHtmlInBody: true,
                cancelAction: this.cancelMultipleUsersEditBound,
                handleNonButtonCancelAction: this.cancelMultipleUsersEditBound
              })
            )
          )
        )
      );
    }
  }, {
    key: 'hasNotes',
    value: function hasNotes(activity) {
      return activity.inline_notes && activity.inline_notes.length > 0 || activity.mentor_assessment_questions && activity.mentor_assessment_questions.length > 0 || this.props.activityNotes.length > 0;
    }
  }, {
    key: 'onDeleteActivityClick',
    value: function onDeleteActivityClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest,
          activityId = _props2.activityId,
          intl = _props2.intl;

      var intlConfirmation = intl.formatMessage(_confirm.messages.deleteActivity);
      var confirmation = confirm(intlConfirmation);
      if (confirmation) {
        dispatch((0, _activity.deleteActivity)(quest.id, activityId));
      }
    }
  }, {
    key: 'onEditActivityClick',
    value: function onEditActivityClick() {
      if (!(0, _pusher.hasNeededPusherConnection)(window.oeQMQuestPusherInstance)) {
        return this.onActualEditClick();
      }
      this.presenceChannel = window.oeQMQuestPusherInstance.subscribe('presence-activity-' + this.props.activityId);
      this.presenceChannel.bind('pusher:subscription_succeeded', this.checkMultipleEditorsBound);
      this.presenceChannel.bind('pusher:subscription_failed', this.onActualEditClickBound);
    }
  }, {
    key: 'checkMultipleEditors',
    value: function checkMultipleEditors() {
      var _this2 = this;

      // check if anyone else is subscribed to this channel
      if ((0, _keys2.default)(this.presenceChannel.members.members).length > 0 && (0, _keys2.default)(this.presenceChannel.members.members).some(function (m) {
        return JSON.parse(m) !== _this2.props.user.id;
      })) {
        this.setState(function () {
          return {
            presenceChannelModalMessage: (0, _multipleeditors.formatModalWarningMessageProp)(_this2.presenceChannel.members, _this2.props.user.id)
          };
        });
        this.refs.multipleEditorsWarningModal.refs.modal.show();
      } else {
        this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.id + '/activities/' + this.props.activityId + '/edit'));
      }
    }
  }, {
    key: 'onActualEditClick',
    value: function onActualEditClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.id + '/activities/' + this.props.activityId + '/edit'));
      if (this.presenceChannel) {
        this.presenceChannel.trigger('client-edit', this.presenceChannel.members.me);
      }
      this.refs.multipleEditorsWarningModal.refs.modal.hide();
    }
  }, {
    key: 'onCreateActivityClick',
    value: function onCreateActivityClick() {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          quest = _props3.quest;

      dispatch((0, _reactRouterRedux.push)('/quest/' + quest.id + '/activities/add'));
    }
  }, {
    key: 'onSortActivitiesClick',
    value: function onSortActivitiesClick() {
      this.sortActivitiesModal.show();
    }
  }, {
    key: 'onCloseModalClick',
    value: function onCloseModalClick() {
      this.sortActivitiesModal.hide();
    }
  }, {
    key: 'handleReSortActivity',
    value: function handleReSortActivity(activityId, newIndex) {
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          quest = _props4.quest;

      dispatch((0, _activity.editActivityPosition)(quest.id, activityId, newIndex));
      // Find the node and flash orange
      var _el = document.getElementById('activity-' + activityId);
      (0, _draggableitem.flashDraggableItem)(_el);
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.refs.multipleEditorsWarningModal.refs.modal.hide();
    }
  }, {
    key: 'confirmMultipleUsersEdit',
    value: function confirmMultipleUsersEdit() {
      var _props5 = this.props,
          quest = _props5.quest,
          dispatch = _props5.dispatch,
          activityId = _props5.activityId,
          activities = _props5.activities;

      var activity = (0, _quest.findActivity)(activities, activityId);

      var data = {
        action: 'update',
        section: 'activities',
        quest: {
          id: quest.id,
          name: quest.name
        },
        activity: {
          id: activity.id,
          name: activity.name
        }
      };
      dispatch((0, _logging.postLoggingInfo)('quest_multiple_editors', data));

      this.onActualEditClick();
    }
  }, {
    key: 'cancelMultipleUsersEdit',
    value: function cancelMultipleUsersEdit() {
      var _props6 = this.props,
          quest = _props6.quest,
          dispatch = _props6.dispatch,
          activityId = _props6.activityId,
          activities = _props6.activities;


      if (window.oeQMQuestPusherInstance) {
        (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
      }

      var activity = (0, _quest.findActivity)(activities, activityId);

      var data = {
        action: 'cancel',
        section: 'activities',
        quest: {
          id: quest.id,
          name: quest.name
        },
        activity: {
          id: activityId,
          name: activity.name
        }
      };
      dispatch((0, _logging.postLoggingInfo)('quest_multiple_editors', data));
      this.hideModal();
    }
  }, {
    key: 'onVideoViewerOpenClick',
    value: function onVideoViewerOpenClick(resource, activity) {
      var _props7 = this.props,
          quest = _props7.quest,
          activities = _props7.activities;

      this.props.dispatch((0, _modal.showModal)('VIDEO_VIEWER', {
        quest: quest,
        activity: activity,
        resource: resource,
        activities: activities
      }));
    }
  }, {
    key: 'onResourceClick',
    value: function onResourceClick(resource, activity) {
      if ((0, _resources.isYoutubeLink)(resource.url, resource.resource_type)) {
        this.onVideoViewerOpenClick(resource, activity);
      } else {
        window.open(resource.file_url ? resource.file_url : resource.url, '_blank');
      }
    }
  }]);
  return Activity;
}(_react.Component);

Activity.propTypes = {
  dispatch: _propTypes2.default.func,
  quest: _propTypes2.default.object,
  activityId: _propTypes2.default.number,
  questId: _propTypes2.default.number,
  activityNotes: _propTypes2.default.array,
  allowEdit: _propTypes2.default.bool,
  currentOrg: _propTypes2.default.object,
  intl: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  activities: _propTypes2.default.array.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    questId: state.quest.item.id,
    activityId: state.quest.activityId || state.quest.activities[0].id,
    activityNotes: state.quest.activityNotes,
    currentOrg: state.organizations.items.find(function (org) {
      return org.id === parseInt(state.organization.orgId);
    }),
    user: state.user.user,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(Activity));
exports.ActivityDisconnected = Activity; // pure component - used in tests

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(674);

var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(1473));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(270));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(272));

var _inherits2 = _interopRequireDefault(__webpack_require__(273));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(271));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));

var React = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactMotion = __webpack_require__(1475);

var _immutabilityHelper = _interopRequireDefault(__webpack_require__(1483));

var _reactMultiRef = _interopRequireDefault(__webpack_require__(1484));

var _DragHandle = _interopRequireDefault(__webpack_require__(1485));

var _OnUpdate = _interopRequireDefault(__webpack_require__(1486));

var _MoveContainer = _interopRequireDefault(__webpack_require__(1487));

/* eslint react/prop-types: "error" */
var DEFAULT_HEIGHT = {
  natural: 200,
  drag: 30
};

function getScrollSpeed(distance, speed, size) {
  // If distance is zero, then the result is the max speed. Otherwise,
  // the result tapers toward zero as it gets closer to the opposite
  // edge of the region.
  return Math.round(speed - speed / size * distance);
}

var DraggableList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DraggableList, _React$Component);

  function DraggableList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DraggableList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DraggableList).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_itemRefs", new _reactMultiRef.default());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_heights", new Map());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_autoScrollerTimer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_listEl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_listElSetter", function (el) {
      if (el) _this._listEl = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleTouchMove", function (e) {
      e.preventDefault();

      _this._handleMouseMove(e.touches[0]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleMouseMove", function (_ref) {
      var pageY = _ref.pageY,
          clientY = _ref.clientY;
      var _this$props = _this.props,
          padding = _this$props.padding,
          autoScrollMaxSpeed = _this$props.autoScrollMaxSpeed,
          autoScrollRegionSize = _this$props.autoScrollRegionSize;
      var _this$state = _this.state,
          list = _this$state.list,
          dragging = _this$state.dragging,
          lastDrag = _this$state.lastDrag;
      if (!dragging || !lastDrag) return;

      var containerEl = _this._getContainer();

      var dragIndex = _this._getDragIndex();

      var naturalPosition = _this._getDistanceDuringDrag(lastDrag, dragIndex);

      clearInterval(_this._autoScrollerTimer); // If the user has the mouse near the top or bottom of the container and
      // not at the end of the list, then autoscroll.

      if (dragIndex !== 0 && dragIndex !== list.length - 1) {
        var scrollSpeed = 0;
        var containerRect = containerEl && containerEl !== document.body && containerEl.getBoundingClientRect ? containerEl.getBoundingClientRect() : {
          top: 0,
          bottom: Infinity
        }; // Get the lowest of the screen top and the container top.

        var top = Math.max(0, containerRect.top);
        var distanceFromTop = clientY - top;

        if (distanceFromTop > 0 && distanceFromTop < autoScrollRegionSize) {
          scrollSpeed = -1 * getScrollSpeed(distanceFromTop, autoScrollMaxSpeed, autoScrollRegionSize);
        } else {
          // Get the lowest of the screen bottom and the container bottom.
          var bottom = Math.min(window.innerHeight, containerRect.bottom);
          var distanceFromBottom = bottom - clientY;

          if (distanceFromBottom > 0 && distanceFromBottom < autoScrollRegionSize) {
            scrollSpeed = getScrollSpeed(distanceFromBottom, autoScrollMaxSpeed, autoScrollRegionSize);
          }
        }

        if (scrollSpeed !== 0) {
          _this._scrollContainer(scrollSpeed);

          _this._autoScrollerTimer = setTimeout(function () {
            _this._handleMouseMove({
              pageY: pageY + (containerEl === document.body ? scrollSpeed : 0),
              clientY: clientY
            });
          }, 16);
        }
      }

      var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop;
      var mouseY = pageY - lastDrag.mouseOffset + containerScroll;

      if (_this.props.constrainDrag) {
        mouseY = Math.max(mouseY, _this._getDistanceDuringDrag(lastDrag, 0));
        mouseY = Math.min(mouseY, _this._getDistanceDuringDrag(lastDrag, _this.props.list.length - 1));
      }

      var movementFromNatural = mouseY - naturalPosition; // 1 down, -1 up, 0 neither

      var direction = movementFromNatural > 0 ? 1 : movementFromNatural < 0 ? -1 : 0;
      var newIndex = dragIndex;

      if (direction !== 0) {
        var keyFn = _this._getKeyFn();

        var reach = Math.abs(movementFromNatural);

        for (var i = dragIndex + direction; i < list.length && i >= 0; i += direction) {
          var iDragHeight = (_this._heights.get(keyFn(list[i])) || DEFAULT_HEIGHT).drag;
          if (reach < iDragHeight / 2 + padding) break;
          reach -= iDragHeight + padding;
          newIndex = i;
        }
      }

      var newList = list;

      if (newIndex !== dragIndex) {
        newList = (0, _immutabilityHelper.default)(list, {
          $splice: [[dragIndex, 1], [newIndex, 0, list[dragIndex]]]
        });
      }

      _this.setState({
        lastDrag: (0, _objectSpread2.default)({}, lastDrag, {
          mouseY: mouseY
        }),
        list: newList
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_handleMouseUp", function () {
      clearInterval(_this._autoScrollerTimer);
      window.removeEventListener('mouseup', _this._handleMouseUp);
      window.removeEventListener('touchend', _this._handleMouseUp);
      window.removeEventListener('touchmove', _this._handleTouchMove);
      window.removeEventListener('mousemove', _this._handleMouseMove);
      if (document.documentElement) document.documentElement.style.cursor = '';
      _this._lastScrollDelta = 0;
      var onMoveEnd = _this.props.onMoveEnd;
      var _this$state2 = _this.state,
          dragging = _this$state2.dragging,
          lastDrag = _this$state2.lastDrag,
          list = _this$state2.list;

      if (dragging && lastDrag && onMoveEnd) {
        var dragIndex = _this._getDragIndex();

        if (lastDrag.startIndex !== dragIndex) {
          onMoveEnd(list, list[dragIndex], lastDrag.startIndex, dragIndex);
        }
      }

      _this.setState({
        dragging: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_lastScrollDelta", 0);
    _this.state = {
      list: props.list,
      useAbsolutePositioning: false,
      dragging: false,
      lastDrag: null
    };
    return _this;
  }

  (0, _createClass2.default)(DraggableList, [{
    key: "getItemInstance",
    value: function getItemInstance(key) {
      var ref = this._itemRefs.map.get(key);

      if (!ref) throw new Error('key not found');
      return ref.getTemplate();
    } // TODO this React method is deprecated. Investigate and replace with componentDidUpdate.

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$state3 = this.state,
          dragging = _this$state3.dragging,
          lastDrag = _this$state3.lastDrag;
      var list = newProps.list;

      check: if (lastDrag) {
        var newDragIndex;

        try {
          newDragIndex = this._getDragIndex(list);
        } catch (err) {
          dragging = false;
          lastDrag = null;
          break check;
        }

        if (dragging) {
          var currentDragIndex = this._getDragIndex();

          if (currentDragIndex !== newDragIndex) {
            // Let's change the list so that the new drag index will be the same as
            // the current so that the dragged item doesn't jump on the screen.
            list = (0, _immutabilityHelper.default)(list, {
              $splice: [[newDragIndex, 1], [currentDragIndex, 0, list[newDragIndex]]]
            });
          }
        }
      }

      this.setState({
        dragging: dragging,
        lastDrag: lastDrag,
        list: list
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._handleMouseUp();
    }
  }, {
    key: "_handleTouchStart",
    value: function _handleTouchStart(itemKey, pressY, event) {
      event.stopPropagation();

      this._handleStartDrag(itemKey, pressY, event.touches[0].pageY);
    }
  }, {
    key: "_handleMouseDown",
    value: function _handleMouseDown(itemKey, pressY, event) {
      event.preventDefault();

      this._handleStartDrag(itemKey, pressY, event.pageY);
    }
  }, {
    key: "_handleStartDrag",
    value: function _handleStartDrag(itemKey, pressY, pageY) {
      var _this2 = this;

      if (document.documentElement) document.documentElement.style.cursor = 'move';
      window.addEventListener('mouseup', this._handleMouseUp);
      window.addEventListener('touchend', this._handleMouseUp);
      window.addEventListener('touchmove', this._handleTouchMove);
      window.addEventListener('mousemove', this._handleMouseMove); // If an element has focus while we drag around the parent, some browsers
      // try to scroll the parent element to keep the focused element in view.
      // Stop that.

      {
        var listEl = this._listEl;
        if (!listEl) throw new Error('Should not happen');

        if (listEl.contains && document.activeElement && listEl.contains(document.activeElement)) {
          document.activeElement.blur();
        }
      }

      var keyFn = this._getKeyFn();

      if (this._heights.size === 0) {
        this._heights = new Map(this.state.list.map(function (item) {
          var key = keyFn(item);

          var containerRef = _this2._itemRefs.map.get(key);

          var refEl = containerRef ? containerRef.getDOMNode().firstElementChild : null;
          var ref = containerRef ? containerRef.getTemplate() : null;
          var natural = refEl instanceof HTMLElement ? refEl.offsetHeight : DEFAULT_HEIGHT.natural;
          var drag = ref && typeof ref.getDragHeight === 'function' && ref.getDragHeight() || natural;
          return [key, {
            natural: natural,
            drag: drag
          }];
        }));
      }

      var itemIndex = this.state.list.map(keyFn).indexOf(itemKey);
      var startY = pressY == null ? this._getDistance(0, itemIndex, false) : pressY;

      var containerEl = this._getContainer();

      var containerScroll = !containerEl || containerEl === document.body ? 0 : containerEl.scrollTop; // Need to re-render once before we start dragging so that the `y` values
      // are set using the correct _heights and then can animate from there.

      this.forceUpdate(function () {
        _this2.setState({
          useAbsolutePositioning: true,
          dragging: true,
          lastDrag: {
            itemKey: itemKey,
            startIndex: itemIndex,
            startListKeys: _this2.state.list.map(keyFn),
            startY: startY,
            mouseY: startY,
            mouseOffset: pageY - startY + containerScroll
          }
        });
      });
    }
  }, {
    key: "_scrollContainer",
    value: function _scrollContainer(delta) {
      var containerEl = this._getContainer();

      if (!containerEl) return;

      if (window.scrollBy && containerEl === document.body) {
        window.scrollBy(0, delta);
      } else {
        containerEl.scrollTop += delta;
      }
    }
  }, {
    key: "_adjustScrollAtEnd",
    value: function _adjustScrollAtEnd(delta) {
      var frameDelta = Math.round(delta - this._lastScrollDelta);

      this._scrollContainer(frameDelta);

      this._lastScrollDelta += frameDelta;
    }
  }, {
    key: "_getDragIndex",
    value: function _getDragIndex(list, lastDrag) {
      if (!list) list = this.state.list;
      if (!lastDrag) lastDrag = this.state.lastDrag;

      if (!lastDrag) {
        throw new Error('No drag happened');
      }

      var keyFn = this._getKeyFn();

      var _lastDrag = lastDrag,
          itemKey = _lastDrag.itemKey;

      for (var i = 0, len = list.length; i < len; i++) {
        if (keyFn(list[i]) === itemKey) {
          return i;
        }
      }

      throw new Error('Failed to find drag index');
    }
  }, {
    key: "_getDistance",
    value: function _getDistance(start, end, dragging) {
      if (end < start) {
        return -this._getDistance(end, start, dragging);
      }

      var padding = this.props.padding;
      var list = this.state.list;

      var keyFn = this._getKeyFn();

      var distance = 0;

      for (var i = start; i < end; i++) {
        var height = this._heights.get(keyFn(list[i])) || DEFAULT_HEIGHT;
        distance += (dragging ? height.drag : height.natural) + padding;
      }

      return distance;
    }
  }, {
    key: "_getDistanceDuringDrag",
    value: function _getDistanceDuringDrag(lastDrag, index) {
      var keyFn = this._getKeyFn();

      var list = this.state.list;
      var offset = 0;

      if (this._getDragIndex() < lastDrag.startIndex) {
        var dragItemHeight = this._heights.get(lastDrag.itemKey) || DEFAULT_HEIGHT;
        var newCenterHeight = this._heights.get(keyFn(list[lastDrag.startIndex])) || DEFAULT_HEIGHT;
        offset = dragItemHeight.drag - newCenterHeight.drag;
      }

      return lastDrag.startY + offset + this._getDistance(lastDrag.startIndex, index, true);
    }
  }, {
    key: "_getContainer",
    value: function _getContainer() {
      var container = this.props.container;
      return container ? container() : null;
    }
  }, {
    key: "_getKeyFn",
    value: function _getKeyFn() {
      var itemKey = this.props.itemKey;
      return typeof itemKey === 'function' ? itemKey : function (x) {
        return x[itemKey];
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          springConfig = _this$props2.springConfig,
          container = _this$props2.container,
          padding = _this$props2.padding,
          template = _this$props2.template,
          unsetZIndex = _this$props2.unsetZIndex,
          commonProps = _this$props2.commonProps;
      var _this$state4 = this.state,
          list = _this$state4.list,
          dragging = _this$state4.dragging,
          lastDrag = _this$state4.lastDrag,
          useAbsolutePositioning = _this$state4.useAbsolutePositioning;

      var keyFn = this._getKeyFn();

      var anySelected = (0, _reactMotion.spring)(dragging ? 1 : 0, springConfig);
      var children = list.map(function (item, i) {
        var key = keyFn(item);
        var selectedStyle = dragging && lastDrag && lastDrag.itemKey === key ? {
          itemSelected: (0, _reactMotion.spring)(1, springConfig),
          y: lastDrag.mouseY
        } : {
          itemSelected: (0, _reactMotion.spring)(0, springConfig),
          y: (useAbsolutePositioning ? _reactMotion.spring : function (x, ignored) {
            return x;
          })(dragging && lastDrag ? _this3._getDistanceDuringDrag(lastDrag, i) : _this3._getDistance(0, i, false), springConfig)
        };
        var style = (0, _objectSpread2.default)({
          anySelected: anySelected
        }, selectedStyle);

        var makeDragHandle = function makeDragHandle(el, getY) {
          return React.createElement(_DragHandle.default, {
            onMouseDown: function onMouseDown(e) {
              return _this3._handleMouseDown(key, getY(), e);
            },
            onTouchStart: function onTouchStart(e) {
              return _this3._handleTouchStart(key, getY(), e);
            }
          }, el);
        };

        var height = _this3._heights.get(key) || DEFAULT_HEIGHT;
        return React.createElement(_reactMotion.Motion, {
          style: style,
          key: key,
          children: function children(_ref2) {
            var itemSelected = _ref2.itemSelected,
                anySelected = _ref2.anySelected,
                y = _ref2.y;
            return React.createElement(_MoveContainer.default, {
              ref: _this3._itemRefs.ref(key),
              y: useAbsolutePositioning ? y : null,
              template: template,
              padding: padding,
              item: item,
              itemSelected: itemSelected,
              anySelected: anySelected,
              height: height,
              zIndex: unsetZIndex && !useAbsolutePositioning ? 'auto' : lastDrag && lastDrag.itemKey === key ? list.length : i,
              makeDragHandle: makeDragHandle,
              commonProps: commonProps
            });
          }
        });
      });
      var adjustScroll = 0;

      if (!dragging && lastDrag && useAbsolutePositioning) {
        var dragIndex = this._getDragIndex();

        adjustScroll = (0, _reactMotion.spring)(this._getDistance(0, dragIndex, false) - lastDrag.mouseY, springConfig);
      }

      var fullContainerHeight = "".concat(this._getDistance(0, list.length, false), "px");
      return React.createElement("div", {
        style: {
          position: 'relative'
        },
        ref: this._listElSetter
      }, React.createElement(_reactMotion.Motion, {
        style: {
          adjustScroll: adjustScroll,
          anySelected: anySelected
        },
        onRest: function onRest() {
          if (!dragging) {
            _this3._heights.clear();

            _this3.setState({
              useAbsolutePositioning: false
            });
          }
        },
        children: function children(_ref3) {
          var adjustScroll = _ref3.adjustScroll;
          return React.createElement("div", {
            style: {
              display: useAbsolutePositioning ? 'block' : 'none',
              height: useAbsolutePositioning ? fullContainerHeight : '0px'
            }
          }, container && React.createElement(_OnUpdate.default, {
            cb: function cb() {
              if (!dragging && lastDrag && useAbsolutePositioning) {
                _this3._adjustScrollAtEnd(adjustScroll);
              }
            }
          }));
        }
      }), children);
    }
  }]);
  return DraggableList;
}(React.Component);

exports.default = DraggableList;
(0, _defineProperty2.default)(DraggableList, "propTypes", {
  itemKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired,
  template: _propTypes.default.func,
  list: _propTypes.default.array.isRequired,
  onMoveEnd: _propTypes.default.func,
  container: _propTypes.default.func,
  springConfig: _propTypes.default.object,
  constrainDrag: _propTypes.default.bool,
  padding: _propTypes.default.number,
  unsetZIndex: _propTypes.default.bool,
  autoScrollMaxSpeed: _propTypes.default.number.isRequired,
  autoScrollRegionSize: _propTypes.default.number.isRequired,
  commonProps: _propTypes.default.object
});
(0, _defineProperty2.default)(DraggableList, "defaultProps", {
  springConfig: {
    stiffness: 300,
    damping: 50
  },
  padding: 10,
  unsetZIndex: false,
  constrainDrag: false,
  autoScrollMaxSpeed: 15,
  autoScrollRegionSize: 30
});
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(218);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1476);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1478);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1479);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1481);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(675);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(339);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1482);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(459);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(339);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(460);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(461);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(462);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(459);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(339);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(460);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(461);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(462);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(459);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(339);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(460);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1480);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(461);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(462);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(675);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(57);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var toString = Object.prototype.toString
var type = function(obj) {
  return toString.call(obj).slice(8, -1);
}

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (Array.isArray(object)) {
    return assign(object.constructor(object.length), object)
  } else if (type(object) === 'Map') {
    return new Map(object)
  } else if (type(object) === 'Set') {
    return new Set(object)
  } else if (object && typeof object === 'object') {
    var prototype = Object.getPrototypeOf(object);
    return assign(Object.create(prototype), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (typeof spec === 'function') {
      spec = { $apply: spec };
    }

    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey =
          type(object) === 'Map'
            ? update(object.get(key), spec[key])
            : update(object[key], spec[key]);
        var nextObjectValue =
          type(nextObject) === 'Map'
              ? nextObject.get(key)
              : nextObject[key];
        if (!update.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          if (type(nextObject) === 'Map') {
            nextObject.set(key, nextValueForKey);
          } else {
            nextObject[key] = nextValueForKey;
          }
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $toggle: function(targets, nextObject) {
    invariantSpecArray(targets, '$toggle');
    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;

    targets.forEach(function(target) {
      nextObjectCopy[target] = !nextObject[target];
    });

    return nextObjectCopy;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariantSpecArray(value, '$unset');
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $add: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$add');
    invariantSpecArray(value, '$add');
    if (type(nextObject) === 'Map') {
      value.forEach(function(pair) {
        var key = pair[0];
        var value = pair[1];
        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
        nextObject.set(key, value);
      });
    } else {
      value.forEach(function(value) {
        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
        nextObject.add(value);
      });
    }
    return nextObject;
  },
  $remove: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$remove');
    invariantSpecArray(value, '$remove');
    value.forEach(function(key) {
      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
      nextObject.delete(key);
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

var contextForExport = newContext();

module.exports = contextForExport;
module.exports.default = contextForExport;
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  invariantSpecArray(spec[command], command)
}

function invariantSpecArray(spec, command) {
  invariant(
    Array.isArray(spec),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    spec
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}

function invariantMapOrSet(target, command) {
  var typeOfTarget = type(target);
  invariant(
    typeOfTarget === 'Map' || typeOfTarget === 'Set',
    'update(): %s expects a target of type Set or Map; got %s',
    command,
    typeOfTarget
  );
}


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));

var MultiRef =
/*#__PURE__*/
function () {
  function MultiRef() {
    (0, _classCallCheck2.default)(this, MultiRef);
    (0, _defineProperty2.default)(this, "map", new Map());
    (0, _defineProperty2.default)(this, "_refFns", new Map());
  }

  (0, _createClass2.default)(MultiRef, [{
    key: "ref",
    value: function ref(key) {
      var _this = this;

      var refFn = this._refFns.get(key);

      if (!refFn) {
        refFn = function refFn(value) {
          if (value == null) {
            _this._refFns.delete(key);

            _this.map.delete(key);
          } else {
            _this.map.set(key, value);
          }
        };

        this._refFns.set(key, refFn);
      }

      return refFn;
    }
  }]);
  return MultiRef;
}();

exports.default = MultiRef;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJNdWx0aVJlZiIsIk1hcCIsImtleSIsInJlZkZuIiwiX3JlZkZucyIsImdldCIsInZhbHVlIiwiZGVsZXRlIiwibWFwIiwic2V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7SUFJcUJBLFE7Ozs7OytDQUNILElBQUlDLEdBQUosRTttREFFVyxJQUFJQSxHQUFKLEU7Ozs7O3dCQUV2QkMsRyxFQUFrQjtBQUFBOztBQUNwQixVQUFJQyxLQUFnQixHQUFHLEtBQUtDLE9BQUwsQ0FBYUMsR0FBYixDQUFpQkgsR0FBakIsQ0FBdkI7O0FBQ0EsVUFBSSxDQUFDQyxLQUFMLEVBQVk7QUFDVkEsUUFBQUEsS0FBSyxHQUFHLGVBQUFHLEtBQUssRUFBSTtBQUNmLGNBQUlBLEtBQUssSUFBSSxJQUFiLEVBQW1CO0FBQ2pCLFlBQUEsS0FBSSxDQUFDRixPQUFMLENBQWFHLE1BQWIsQ0FBb0JMLEdBQXBCOztBQUNBLFlBQUEsS0FBSSxDQUFDTSxHQUFMLENBQVNELE1BQVQsQ0FBZ0JMLEdBQWhCO0FBQ0QsV0FIRCxNQUdPO0FBQ0wsWUFBQSxLQUFJLENBQUNNLEdBQUwsQ0FBU0MsR0FBVCxDQUFhUCxHQUFiLEVBQWtCSSxLQUFsQjtBQUNEO0FBQ0YsU0FQRDs7QUFRQSxhQUFLRixPQUFMLENBQWFLLEdBQWIsQ0FBaUJQLEdBQWpCLEVBQXNCQyxLQUF0QjtBQUNEOztBQUNELGFBQU9BLEtBQVA7QUFDRCIsInNvdXJjZXNDb250ZW50IjpbIi8qIEBmbG93ICovXG5cbnR5cGUgUmVmRm48Vj4gPSAodmFsdWU6IFZ8bnVsbCkgPT4gbWl4ZWQ7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE11bHRpUmVmPEssVj4ge1xuICBtYXA6IE1hcDxLLFY+ID0gbmV3IE1hcCgpO1xuXG4gIF9yZWZGbnM6IE1hcDxLLFJlZkZuPFY+PiA9IG5ldyBNYXAoKTtcblxuICByZWYoa2V5OiBLKTogUmVmRm48Vj4ge1xuICAgIGxldCByZWZGbjogP1JlZkZuPFY+ID0gdGhpcy5fcmVmRm5zLmdldChrZXkpO1xuICAgIGlmICghcmVmRm4pIHtcbiAgICAgIHJlZkZuID0gdmFsdWUgPT4ge1xuICAgICAgICBpZiAodmFsdWUgPT0gbnVsbCkge1xuICAgICAgICAgIHRoaXMuX3JlZkZucy5kZWxldGUoa2V5KTtcbiAgICAgICAgICB0aGlzLm1hcC5kZWxldGUoa2V5KTtcbiAgICAgICAgfSBlbHNlIHtcbiAgICAgICAgICB0aGlzLm1hcC5zZXQoa2V5LCB2YWx1ZSk7XG4gICAgICAgIH1cbiAgICAgIH07XG4gICAgICB0aGlzLl9yZWZGbnMuc2V0KGtleSwgcmVmRm4pO1xuICAgIH1cbiAgICByZXR1cm4gcmVmRm47XG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(270));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(272));

var _inherits2 = _interopRequireDefault(__webpack_require__(273));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(271));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var DragHandle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DragHandle, _React$Component);

  function DragHandle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DragHandle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DragHandle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onMouseDown", function (e) {
      _this.props.onMouseDown.call(null, e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onTouchStart", function (e) {
      _this.props.onTouchStart.call(null, e);
    });
    return _this;
  }

  (0, _createClass2.default)(DragHandle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.addEventListener('mousedown', this._onMouseDown);
      node.addEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.removeEventListener('mousedown', this._onMouseDown);
      node.removeEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO In next major version remove the need for findDOMNode by using React.cloneElement here.
      // Update documentation to require that the element given to dragHandle is either
      // a native DOM element or forwards its props to one.
      return _react.default.Children.only(this.props.children);
    }
  }]);
  return DragHandle;
}(_react.default.Component);

exports.default = DragHandle;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(270));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(272));

var _inherits2 = _interopRequireDefault(__webpack_require__(273));

var _react = _interopRequireDefault(__webpack_require__(0));

var OnUpdate =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(OnUpdate, _React$Component);

  function OnUpdate() {
    (0, _classCallCheck2.default)(this, OnUpdate);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OnUpdate).apply(this, arguments));
  }

  (0, _createClass2.default)(OnUpdate, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.cb();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return OnUpdate;
}(_react.default.Component);

exports.default = OnUpdate;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9PblVwZGF0ZS5qcyJdLCJuYW1lcyI6WyJPblVwZGF0ZSIsInByb3BzIiwiY2IiLCJSZWFjdCIsIkNvbXBvbmVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBOztJQUtxQkEsUTs7Ozs7Ozs7Ozs7O3lDQUNFO0FBQ25CLFdBQUtDLEtBQUwsQ0FBV0MsRUFBWDtBQUNEOzs7NkJBRWE7QUFDWixhQUFPLElBQVA7QUFDRDs7O0VBUG1DQyxlQUFNQyxTIiwic291cmNlc0NvbnRlbnQiOlsiLyogQGZsb3cgKi9cblxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxudHlwZSBQcm9wcyA9IHtcbiAgY2I6IEZ1bmN0aW9uO1xufTtcbmV4cG9ydCBkZWZhdWx0IGNsYXNzIE9uVXBkYXRlIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50PFByb3BzPiB7XG4gIGNvbXBvbmVudERpZFVwZGF0ZSgpIHtcbiAgICB0aGlzLnByb3BzLmNiKCk7XG4gIH1cblxuICByZW5kZXIoKTogYW55IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxufVxuIl19

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(270));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(272));

var _inherits2 = _interopRequireDefault(__webpack_require__(273));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(271));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));

var _react = _interopRequireDefault(__webpack_require__(0));

var _TemplateContainer = _interopRequireDefault(__webpack_require__(1488));

var MoveContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MoveContainer, _React$Component);

  function MoveContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MoveContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MoveContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateContainer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateContainerSetter", function (cmp) {
      if (cmp) _this._templateContainer = cmp;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_el", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_elSetter", function (el) {
      if (el) _this._el = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_dragHandle", function (el) {
      return _this.props.makeDragHandle(el, function () {
        return _this.props.y;
      });
    });
    return _this;
  }

  (0, _createClass2.default)(MoveContainer, [{
    key: "getDOMNode",
    value: function getDOMNode() {
      return this._el;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._templateContainer.getTemplate();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.y !== nextProps.y || this.props.height !== nextProps.height || this.props.zIndex !== nextProps.zIndex || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          y = _this$props.y,
          padding = _this$props.padding,
          itemSelected = _this$props.itemSelected,
          anySelected = _this$props.anySelected,
          height = _this$props.height,
          zIndex = _this$props.zIndex,
          template = _this$props.template,
          commonProps = _this$props.commonProps;
      return _react.default.createElement("div", {
        ref: this._elSetter,
        style: {
          position: y == null ? 'relative' : 'absolute',
          boxSizing: 'border-box',
          left: '0px',
          right: '0px',
          top: y == null ? '0px' : "".concat(y, "px"),
          marginBottom: "".concat(padding, "px"),
          height: y == null ? 'auto' : "".concat(anySelected * (height.drag - height.natural) + height.natural, "px"),
          zIndex: zIndex
        }
      }, _react.default.createElement(_TemplateContainer.default, {
        ref: this._templateContainerSetter,
        item: item,
        template: template,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: this._dragHandle,
        commonProps: commonProps
      }));
    }
  }]);
  return MoveContainer;
}(_react.default.Component);

exports.default = MoveContainer;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Nb3ZlQ29udGFpbmVyLmpzIl0sIm5hbWVzIjpbIk1vdmVDb250YWluZXIiLCJjbXAiLCJfdGVtcGxhdGVDb250YWluZXIiLCJlbCIsIl9lbCIsInByb3BzIiwibWFrZURyYWdIYW5kbGUiLCJ5IiwiZ2V0VGVtcGxhdGUiLCJuZXh0UHJvcHMiLCJhbnlTZWxlY3RlZCIsIml0ZW1TZWxlY3RlZCIsIml0ZW0iLCJ0ZW1wbGF0ZSIsImhlaWdodCIsInpJbmRleCIsImNvbW1vblByb3BzIiwicGFkZGluZyIsIl9lbFNldHRlciIsInBvc2l0aW9uIiwiYm94U2l6aW5nIiwibGVmdCIsInJpZ2h0IiwidG9wIiwibWFyZ2luQm90dG9tIiwiZHJhZyIsIm5hdHVyYWwiLCJfdGVtcGxhdGVDb250YWluZXJTZXR0ZXIiLCJfZHJhZ0hhbmRsZSIsIlJlYWN0IiwiQ29tcG9uZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBOztBQUNBOztJQWNxQkEsYTs7Ozs7Ozs7Ozs7Ozs7Ozs7O2lKQUVRLFVBQUNDLEdBQUQsRUFBa0I7QUFDM0MsVUFBSUEsR0FBSixFQUFTLE1BQUtDLGtCQUFMLEdBQTBCRCxHQUExQjtBQUNWLEs7O2tJQUVXLFVBQUNFLEVBQUQsRUFBc0I7QUFDaEMsVUFBSUEsRUFBSixFQUFRLE1BQUtDLEdBQUwsR0FBV0QsRUFBWDtBQUNULEs7b0lBcUJ1QixVQUFDQSxFQUFEO0FBQUEsYUFBUSxNQUFLRSxLQUFMLENBQVdDLGNBQVgsQ0FBMEJILEVBQTFCLEVBQThCO0FBQUEsZUFBSSxNQUFLRSxLQUFMLENBQVdFLENBQWY7QUFBQSxPQUE5QixDQUFSO0FBQUEsSzs7Ozs7O2lDQW5CRTtBQUN4QixhQUFPLEtBQUtILEdBQVo7QUFDRDs7O2tDQUVnQjtBQUNmLGFBQU8sS0FBS0Ysa0JBQUwsQ0FBd0JNLFdBQXhCLEVBQVA7QUFDRDs7OzBDQUVxQkMsUyxFQUFrQztBQUN0RCxhQUFPLEtBQUtKLEtBQUwsQ0FBV0ssV0FBWCxLQUEyQkQsU0FBUyxDQUFDQyxXQUFyQyxJQUNMLEtBQUtMLEtBQUwsQ0FBV00sWUFBWCxLQUE0QkYsU0FBUyxDQUFDRSxZQURqQyxJQUVMLEtBQUtOLEtBQUwsQ0FBV08sSUFBWCxLQUFvQkgsU0FBUyxDQUFDRyxJQUZ6QixJQUdMLEtBQUtQLEtBQUwsQ0FBV1EsUUFBWCxLQUF3QkosU0FBUyxDQUFDSSxRQUg3QixJQUlMLEtBQUtSLEtBQUwsQ0FBV0UsQ0FBWCxLQUFpQkUsU0FBUyxDQUFDRixDQUp0QixJQUtMLEtBQUtGLEtBQUwsQ0FBV1MsTUFBWCxLQUFzQkwsU0FBUyxDQUFDSyxNQUwzQixJQU1MLEtBQUtULEtBQUwsQ0FBV1UsTUFBWCxLQUFzQk4sU0FBUyxDQUFDTSxNQU4zQixJQU9MLEtBQUtWLEtBQUwsQ0FBV1csV0FBWCxLQUEyQlAsU0FBUyxDQUFDTyxXQVB2QztBQVFEOzs7NkJBSVE7QUFBQSx3QkFHSCxLQUFLWCxLQUhGO0FBQUEsVUFFTE8sSUFGSyxlQUVMQSxJQUZLO0FBQUEsVUFFQ0wsQ0FGRCxlQUVDQSxDQUZEO0FBQUEsVUFFSVUsT0FGSixlQUVJQSxPQUZKO0FBQUEsVUFFYU4sWUFGYixlQUVhQSxZQUZiO0FBQUEsVUFFMkJELFdBRjNCLGVBRTJCQSxXQUYzQjtBQUFBLFVBRXdDSSxNQUZ4QyxlQUV3Q0EsTUFGeEM7QUFBQSxVQUVnREMsTUFGaEQsZUFFZ0RBLE1BRmhEO0FBQUEsVUFFd0RGLFFBRnhELGVBRXdEQSxRQUZ4RDtBQUFBLFVBRWtFRyxXQUZsRSxlQUVrRUEsV0FGbEU7QUFLUCxhQUNFO0FBQ0UsUUFBQSxHQUFHLEVBQUUsS0FBS0UsU0FEWjtBQUVFLFFBQUEsS0FBSyxFQUFFO0FBQ0xDLFVBQUFBLFFBQVEsRUFBRVosQ0FBQyxJQUFJLElBQUwsR0FBWSxVQUFaLEdBQXlCLFVBRDlCO0FBRUxhLFVBQUFBLFNBQVMsRUFBRSxZQUZOO0FBR0xDLFVBQUFBLElBQUksRUFBRSxLQUhEO0FBSUxDLFVBQUFBLEtBQUssRUFBRSxLQUpGO0FBS0xDLFVBQUFBLEdBQUcsRUFBRWhCLENBQUMsSUFBSSxJQUFMLEdBQVksS0FBWixhQUF1QkEsQ0FBdkIsT0FMQTtBQU1MaUIsVUFBQUEsWUFBWSxZQUFLUCxPQUFMLE9BTlA7QUFPTEgsVUFBQUEsTUFBTSxFQUFFUCxDQUFDLElBQUksSUFBTCxHQUFZLE1BQVosYUFDSEcsV0FBVyxJQUFFSSxNQUFNLENBQUNXLElBQVAsR0FBWVgsTUFBTSxDQUFDWSxPQUFyQixDQUFYLEdBQXlDWixNQUFNLENBQUNZLE9BRDdDLE9BUEg7QUFTTFgsVUFBQUEsTUFBTSxFQUFOQTtBQVRLO0FBRlQsU0FjRSw2QkFBQywwQkFBRDtBQUNFLFFBQUEsR0FBRyxFQUFFLEtBQUtZLHdCQURaO0FBRUUsUUFBQSxJQUFJLEVBQUVmLElBRlI7QUFHRSxRQUFBLFFBQVEsRUFBRUMsUUFIWjtBQUlFLFFBQUEsWUFBWSxFQUFFRixZQUpoQjtBQUtFLFFBQUEsV0FBVyxFQUFFRCxXQUxmO0FBTUUsUUFBQSxVQUFVLEVBQUUsS0FBS2tCLFdBTm5CO0FBT0UsUUFBQSxXQUFXLEVBQUVaO0FBUGYsUUFkRixDQURGO0FBMEJEOzs7RUE5RHdFYSxlQUFNQyxTIiwic291cmNlc0NvbnRlbnQiOlsiLyogQGZsb3cgKi9cblxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBUZW1wbGF0ZUNvbnRhaW5lciBmcm9tICcuL1RlbXBsYXRlQ29udGFpbmVyJztcblxudHlwZSBQcm9wczxJLEMsVD4gPSB7XG4gIGl0ZW06IEk7XG4gIHRlbXBsYXRlOiBDbGFzczxUPjtcbiAgcGFkZGluZzogbnVtYmVyO1xuICB5OiA/bnVtYmVyO1xuICBpdGVtU2VsZWN0ZWQ6IG51bWJlcjtcbiAgYW55U2VsZWN0ZWQ6IG51bWJlcjtcbiAgaGVpZ2h0OiBPYmplY3Q7XG4gIHpJbmRleDogbnVtYmVyfHN0cmluZztcbiAgbWFrZURyYWdIYW5kbGU6IEZ1bmN0aW9uO1xuICBjb21tb25Qcm9wczogQztcbn07XG5leHBvcnQgZGVmYXVsdCBjbGFzcyBNb3ZlQ29udGFpbmVyPEksQyxUOlJlYWN0LkNvbXBvbmVudDxhbnksYW55Pj4gZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQ8UHJvcHM8SSxDLFQ+PiB7XG4gIF90ZW1wbGF0ZUNvbnRhaW5lcjogVGVtcGxhdGVDb250YWluZXI8SSxDLFQ+O1xuICBfdGVtcGxhdGVDb250YWluZXJTZXR0ZXIgPSAoY21wOiA/T2JqZWN0KSA9PiB7XG4gICAgaWYgKGNtcCkgdGhpcy5fdGVtcGxhdGVDb250YWluZXIgPSBjbXA7XG4gIH07XG4gIF9lbDogSFRNTEVsZW1lbnQ7XG4gIF9lbFNldHRlciA9IChlbDogP0hUTUxFbGVtZW50KSA9PiB7XG4gICAgaWYgKGVsKSB0aGlzLl9lbCA9IGVsO1xuICB9O1xuXG4gIGdldERPTU5vZGUoKTogSFRNTEVsZW1lbnQge1xuICAgIHJldHVybiB0aGlzLl9lbDtcbiAgfVxuXG4gIGdldFRlbXBsYXRlKCk6IFQge1xuICAgIHJldHVybiB0aGlzLl90ZW1wbGF0ZUNvbnRhaW5lci5nZXRUZW1wbGF0ZSgpO1xuICB9XG5cbiAgc2hvdWxkQ29tcG9uZW50VXBkYXRlKG5leHRQcm9wczogUHJvcHM8SSxDLFQ+KTogYm9vbGVhbiB7XG4gICAgcmV0dXJuIHRoaXMucHJvcHMuYW55U2VsZWN0ZWQgIT09IG5leHRQcm9wcy5hbnlTZWxlY3RlZCB8fFxuICAgICAgdGhpcy5wcm9wcy5pdGVtU2VsZWN0ZWQgIT09IG5leHRQcm9wcy5pdGVtU2VsZWN0ZWQgfHxcbiAgICAgIHRoaXMucHJvcHMuaXRlbSAhPT0gbmV4dFByb3BzLml0ZW0gfHxcbiAgICAgIHRoaXMucHJvcHMudGVtcGxhdGUgIT09IG5leHRQcm9wcy50ZW1wbGF0ZSB8fFxuICAgICAgdGhpcy5wcm9wcy55ICE9PSBuZXh0UHJvcHMueSB8fFxuICAgICAgdGhpcy5wcm9wcy5oZWlnaHQgIT09IG5leHRQcm9wcy5oZWlnaHQgfHxcbiAgICAgIHRoaXMucHJvcHMuekluZGV4ICE9PSBuZXh0UHJvcHMuekluZGV4IHx8XG4gICAgICB0aGlzLnByb3BzLmNvbW1vblByb3BzICE9PSBuZXh0UHJvcHMuY29tbW9uUHJvcHM7XG4gIH1cblxuICBfZHJhZ0hhbmRsZTogRnVuY3Rpb24gPSAoZWwpID0+IHRoaXMucHJvcHMubWFrZURyYWdIYW5kbGUoZWwsICgpPT50aGlzLnByb3BzLnkpO1xuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7XG4gICAgICBpdGVtLCB5LCBwYWRkaW5nLCBpdGVtU2VsZWN0ZWQsIGFueVNlbGVjdGVkLCBoZWlnaHQsIHpJbmRleCwgdGVtcGxhdGUsIGNvbW1vblByb3BzXG4gICAgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gKFxuICAgICAgPGRpdlxuICAgICAgICByZWY9e3RoaXMuX2VsU2V0dGVyfVxuICAgICAgICBzdHlsZT17e1xuICAgICAgICAgIHBvc2l0aW9uOiB5ID09IG51bGwgPyAncmVsYXRpdmUnIDogJ2Fic29sdXRlJyxcbiAgICAgICAgICBib3hTaXppbmc6ICdib3JkZXItYm94JyxcbiAgICAgICAgICBsZWZ0OiAnMHB4JyxcbiAgICAgICAgICByaWdodDogJzBweCcsXG4gICAgICAgICAgdG9wOiB5ID09IG51bGwgPyAnMHB4JyA6IGAke3l9cHhgLFxuICAgICAgICAgIG1hcmdpbkJvdHRvbTogYCR7cGFkZGluZ31weGAsXG4gICAgICAgICAgaGVpZ2h0OiB5ID09IG51bGwgPyAnYXV0bycgOlxuICAgICAgICAgICAgYCR7YW55U2VsZWN0ZWQqKGhlaWdodC5kcmFnLWhlaWdodC5uYXR1cmFsKStoZWlnaHQubmF0dXJhbH1weGAsXG4gICAgICAgICAgekluZGV4XG4gICAgICAgIH19XG4gICAgICA+XG4gICAgICAgIDxUZW1wbGF0ZUNvbnRhaW5lclxuICAgICAgICAgIHJlZj17dGhpcy5fdGVtcGxhdGVDb250YWluZXJTZXR0ZXJ9XG4gICAgICAgICAgaXRlbT17aXRlbX1cbiAgICAgICAgICB0ZW1wbGF0ZT17dGVtcGxhdGV9XG4gICAgICAgICAgaXRlbVNlbGVjdGVkPXtpdGVtU2VsZWN0ZWR9XG4gICAgICAgICAgYW55U2VsZWN0ZWQ9e2FueVNlbGVjdGVkfVxuICAgICAgICAgIGRyYWdIYW5kbGU9e3RoaXMuX2RyYWdIYW5kbGV9XG4gICAgICAgICAgY29tbW9uUHJvcHM9e2NvbW1vblByb3BzfVxuICAgICAgICAvPlxuICAgICAgPC9kaXY+XG4gICAgKTtcbiAgfVxufVxuIl19

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(219));

var _createClass2 = _interopRequireDefault(__webpack_require__(220));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(270));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(272));

var _inherits2 = _interopRequireDefault(__webpack_require__(273));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(271));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(218));

var _react = _interopRequireDefault(__webpack_require__(0));

var TemplateContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TemplateContainer, _React$Component);

  function TemplateContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TemplateContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TemplateContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_template", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_templateSetter", function (cmp) {
      if (cmp) _this._template = cmp;
    });
    return _this;
  }

  (0, _createClass2.default)(TemplateContainer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._template;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          itemSelected = _this$props.itemSelected,
          anySelected = _this$props.anySelected,
          dragHandle = _this$props.dragHandle,
          commonProps = _this$props.commonProps;
      var Template = this.props.template;
      return _react.default.createElement(Template, {
        ref: this._templateSetter,
        item: item,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandle: dragHandle,
        commonProps: commonProps
      });
    }
  }]);
  return TemplateContainer;
}(_react.default.Component);

exports.default = TemplateContainer;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContentWarningIcon = __webpack_require__(340);

var _ContentWarningIcon2 = _interopRequireDefault(_ContentWarningIcon);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _contentwarnings = __webpack_require__(167);

var _utils = __webpack_require__(20);

var _resources = __webpack_require__(125);

var _string = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Should really separate draggable stuff from item content - use composition

var DraggableItem = function (_Component) {
  (0, _inherits3.default)(DraggableItem, _Component);

  function DraggableItem(props) {
    (0, _classCallCheck3.default)(this, DraggableItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DraggableItem.__proto__ || (0, _getPrototypeOf2.default)(DraggableItem)).call(this, props));

    _this.onEditClickBound = _this.onEditClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DraggableItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          commonProps = _props.commonProps;


      var displayAttr = function displayAttr(item, itemType) {
        var retVal = void 0;
        switch (itemType) {
          case 'note':
            retVal = item.attachment_name;
            break;
          case 'resource':
            retVal = (0, _string.getTruncatedString)({
              val: item.name,
              len: 85
            });
            break;
          case 'activity':
            retVal = item.name;
            break;
        }
        return retVal;
      };

      return _react2.default.createElement(
        'li',
        { className: 'draggable-item', id: commonProps.itemType + '-' + item.id },
        _react2.default.createElement(
          'div',
          { className: commonProps.itemType + '-wrapper', 'data-id': item.id },
          this.props.dragHandle(_react2.default.createElement(
            'div',
            { className: 'dragdrop-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'dragdrop' },
              '\u2630'
            )
          )),
          _react2.default.createElement(
            'div',
            { className: 'info-wrapper' },
            _react2.default.createElement('div', {
              className: 'icon ' + (commonProps.itemType === 'resource' ? item.resource_type : item.file_type)
            }),
            _react2.default.createElement(
              'div',
              { className: 'name' },
              _react2.default.createElement(
                'div',
                { className: 'draggable-item-name-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'draggable-item-name' },
                  displayAttr(item, commonProps.itemType)
                ),
                !commonProps.hideEdit && _react2.default.createElement('div', { className: 'edit', onClick: this.onEditClickBound })
              ),
              !commonProps.hideDelete && _react2.default.createElement('div', { className: 'trash', onClick: commonProps.deleteItem })
            ),
            commonProps.itemType === 'resource' && item.content_warnings && (0, _keys2.default)(item.content_warnings).length > 0 && _react2.default.createElement(
              'div',
              { className: 'content-warnings-list' },
              (0, _contentwarnings.mapContentWarnings)(item.content_warnings).map(function (cw) {
                return _react2.default.createElement(_ContentWarningIcon2.default, {
                  value: cw.value,
                  text: cw.text,
                  abbrev: cw.abbrev,
                  showTooltip: true
                });
              })
            ),
            commonProps.hideDescription || (0, _utils.isNullOrEmpty)(item.description) ? null : commonProps.itemType === 'resource' ? _react2.default.createElement(_MarkdownLabel2.default, {
              additionalCssClasses: 'resource description',
              value: item.description
            }) : _react2.default.createElement(
              'div',
              { className: 'description' },
              item.description
            ),
            commonProps.itemType === 'resource' && item.isResourceIncomplete && _react2.default.createElement(_resources.ResourceIncomplete, null)
          )
        )
      );
    }
  }, {
    key: 'onEditClick',
    value: function onEditClick() {
      var _props2 = this.props,
          item = _props2.item,
          commonProps = _props2.commonProps;

      commonProps.handleEditClick(item);
    }
  }]);
  return DraggableItem;
}(_react.Component);

exports.default = DraggableItem;


DraggableItem.propTypes = {
  item: _propTypes2.default.object.isRequired,
  dragHandle: _propTypes2.default.func.isRequired,
  commonProps: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex-flow: row wrap;\n  margin: 0;\n  padding-bottom: 20px;\n  align-items: flex-start;\n  width: 600px;\n\n  li:nth-child(4n-1),\n  li:nth-child(4n-2) {\n    .header {\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n        #fff center top / 100% no-repeat;\n    }\n  }\n\n  li:nth-child(4n-3),\n  li:nth-child(4n-4) {\n    .header {\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n        #bbb center top / 100% no-repeat;\n    }\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex-flow: row wrap;\n  margin: 0;\n  padding-bottom: 20px;\n  align-items: flex-start;\n  width: 600px;\n\n  li:nth-child(4n-1),\n  li:nth-child(4n-2) {\n    .header {\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n        #fff center top / 100% no-repeat;\n    }\n  }\n\n  li:nth-child(4n-3),\n  li:nth-child(4n-4) {\n    .header {\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n        #bbb center top / 100% no-repeat;\n    }\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ResourceItem = __webpack_require__(1491);

var _ResourceItem2 = _interopRequireDefault(_ResourceItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourcesContainer = _styledComponents2.default.ul.withConfig({
  displayName: 'ResourcesList__ResourcesContainer',
  componentId: 'napc8v-0'
})(_templateObject);

var ResourcesList = function ResourcesList(props) {
  var resources = props.resources.map(function (r) {
    var isClickable = Boolean(r.url || r.file_url);
    return _react2.default.createElement(_ResourceItem2.default, {
      key: r.id,
      resource: r,
      activity: props.activity,
      handleResourceClick: props.handleResourceClick,
      isClickable: isClickable
    });
  });

  return _react2.default.createElement(
    ResourcesContainer,
    null,
    resources
  );
};

ResourcesList.propTypes = {
  resources: _propTypes2.default.array.isRequired,
  handleResourceClick: _propTypes2.default.func.isRequired,
  activity: _propTypes2.default.object.isRequired
};

exports.default = ResourcesList;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  flex-wrap: wrap;\n  width: 48%;\n  margin: 20px 0 0;\n  cursor: ', ';\n  background: #fff;\n  border-radius: 5px;\n  position: relative;\n  z-index: 0;\n\n  a {\n    color: unset;\n    cursor: ', ';\n  }\n\n  .content-warning-icon {\n    height: 27px;\n    width: 27px;\n    margin-left: 7px;\n    display: inline-table;\n\n    .abbrev {\n      font-size: 12px;\n      font-weight: 500;\n      color: #4a4a4a;\n    }\n  }\n\n  &:hover .resource-body {\n    background-color: ', ';\n  }\n\n  label {\n    cursor: ', ';\n  }\n\n  .content-warning-icon {\n    margin: 0 0 0 5px;\n  }\n'], ['\n  flex-wrap: wrap;\n  width: 48%;\n  margin: 20px 0 0;\n  cursor: ', ';\n  background: #fff;\n  border-radius: 5px;\n  position: relative;\n  z-index: 0;\n\n  a {\n    color: unset;\n    cursor: ', ';\n  }\n\n  .content-warning-icon {\n    height: 27px;\n    width: 27px;\n    margin-left: 7px;\n    display: inline-table;\n\n    .abbrev {\n      font-size: 12px;\n      font-weight: 500;\n      color: #4a4a4a;\n    }\n  }\n\n  &:hover .resource-body {\n    background-color: ', ';\n  }\n\n  label {\n    cursor: ', ';\n  }\n\n  .content-warning-icon {\n    margin: 0 0 0 5px;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 70px;\n  background-image: ', ';\n  background-size: 100%;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 70px;\n  background-image: ', ';\n  background-size: 100%;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  padding: 10px 20px 15px;\n  background: #fff;\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  z-index: 1;\n  position: relative;\n'], ['\n  padding: 10px 20px 15px;\n  background: #fff;\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  z-index: 1;\n  position: relative;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  margin: 0;\n  padding: 2%;\n  text-align: left;\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n'], ['\n  width: 100%;\n  margin: 0;\n  padding: 2%;\n  text-align: left;\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  padding-top: 7px;\n  overflow-wrap: break-word;\n  line-height: 1.2 !important;\n\n  label {\n    line-height: unset !important;\n    font-size: unset !important;\n  }\n'], ['\n  padding-top: 7px;\n  overflow-wrap: break-word;\n  line-height: 1.2 !important;\n\n  label {\n    line-height: unset !important;\n    font-size: unset !important;\n  }\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n  background-color: #e9f4f8;\n  padding: 12px 12px 12px;\n  position: relative;\n  bottom: 7px;\n'], ['\n  border-bottom-left-radius: 7px;\n  border-bottom-right-radius: 7px;\n  background-color: #e9f4f8;\n  padding: 12px 12px 12px;\n  position: relative;\n  bottom: 7px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  padding-top: 8px;\n  line-height: 16px;\n'], ['\n  padding-top: 8px;\n  line-height: 16px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ContentWarningIcon = __webpack_require__(340);

var _ContentWarningIcon2 = _interopRequireDefault(_ContentWarningIcon);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(160);

var _Caption4 = _interopRequireDefault(_Caption3);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _resources = __webpack_require__(125);

var _contentwarnings = __webpack_require__(167);

var _time = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourceContainer = _styledComponents2.default.li.withConfig({
  displayName: 'ResourceItem__ResourceContainer',
  componentId: 'sc-12pa5iv-0'
})(_templateObject, function (props) {
  return props.isClickable ? 'pointer' : 'default';
}, function (props) {
  return props.isClickable ? 'pointer' : 'default';
}, function (props) {
  return props.isClickable ? '#F5F5F5' : '#fff';
}, function (props) {
  return props.isClickable ? 'pointer' : 'default';
});

var ResourceHeader = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceItem__ResourceHeader',
  componentId: 'sc-12pa5iv-1'
})(_templateObject2, function (props) {
  return props.thumbnail ? 'linear-gradient(0deg, rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(' + props.thumbnail + ') !important' : 'none';
});

var ResourceBody = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceItem__ResourceBody',
  componentId: 'sc-12pa5iv-2'
})(_templateObject3);

var ResourceContent = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceItem__ResourceContent',
  componentId: 'sc-12pa5iv-3'
})(_templateObject4);

var ResourceDescription = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'ResourceItem__ResourceDescription',
  componentId: 'sc-12pa5iv-4'
})(_templateObject5);

var QMSpecificData = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceItem__QMSpecificData',
  componentId: 'sc-12pa5iv-5'
})(_templateObject6);

var QMSpecificDataRow = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceItem__QMSpecificDataRow',
  componentId: 'sc-12pa5iv-6'
})(_templateObject7);

var ResourceItem = function ResourceItem(props) {
  return _react2.default.createElement(
    ResourceContainer,
    { isClickable: props.isClickable },
    _react2.default.createElement(
      'a',
      {
        onClick: function onClick(e) {
          return props.isClickable ? props.handleResourceClick(props.resource, props.activity) : e.preventDefault();
        }
      },
      _react2.default.createElement(
        ResourceHeader,
        {
          className: 'header',
          thumbnail: props.resource.thumbnail_url
        },
        (0, _resources.getViewResourceIcon)(props.resource.resource_type)
      ),
      _react2.default.createElement(
        ResourceBody,
        { className: 'resource-body' },
        _react2.default.createElement(
          ResourceContent,
          null,
          _react2.default.createElement(
            _H2.default,
            null,
            props.resource.name
          ),
          props.resource.description && props.resource.description.length > 0 && _react2.default.createElement(
            ResourceDescription,
            null,
            _react2.default.createElement(_MarkdownLabel2.default, { value: props.resource.description })
          )
        )
      ),
      ((0, _resources.resourceHasQMSpecificInfo)(props.resource) || props.resource.isResourceIncomplete) && _react2.default.createElement(
        QMSpecificData,
        null,
        props.resource.start_time || props.resource.end_time ? _react2.default.createElement(
          QMSpecificDataRow,
          {
            style: { display: 'flex', alignItems: 'baseline' }
          },
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Start Time:\xA0'
          ),
          props.resource.start_time ? _react2.default.createElement(
            _Caption2.default,
            { style: { marginRight: '18px' } },
            (0, _time.fancyTimeFormat)(props.resource.start_time)
          ) : _react2.default.createElement(
            _Caption2.default,
            { style: { marginRight: '18px' } },
            'No Change'
          ),
          _react2.default.createElement(
            _Caption4.default,
            null,
            'End Time:\xA0'
          ),
          props.resource.end_time ? _react2.default.createElement(
            _Caption2.default,
            { style: { marginRight: '18px' } },
            (0, _time.fancyTimeFormat)(props.resource.end_time)
          ) : _react2.default.createElement(
            _Caption2.default,
            { style: { marginRight: '18px' } },
            'No Change'
          )
        ) : null,
        props.resource.content_warnings && (0, _keys2.default)(props.resource.content_warnings).length > 0 && _react2.default.createElement(
          QMSpecificDataRow,
          null,
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Content Warnings:\xA0',
            (0, _contentwarnings.mapContentWarnings)(props.resource.content_warnings).map(function (cw) {
              return _react2.default.createElement(_ContentWarningIcon2.default, {
                value: cw.value,
                text: cw.text,
                abbrev: cw.abbrev,
                showTooltip: true
              });
            })
          )
        ),
        props.resource.copyright_holder && _react2.default.createElement(
          QMSpecificDataRow,
          null,
          _react2.default.createElement(
            _Caption4.default,
            null,
            'I or someone in my organization made this resource.'
          )
        ),
        props.resource.file_name && props.resource.license_citation && _react2.default.createElement(
          QMSpecificDataRow,
          null,
          _react2.default.createElement(
            _Caption4.default,
            null,
            'Someone outside my organization made this resource.'
          ),
          _react2.default.createElement(
            QMSpecificDataRow,
            null,
            _react2.default.createElement(
              _Caption2.default,
              { style: { wordBreak: 'break-word' } },
              'Citation:\xA0',
              props.resource.license_citation
            )
          )
        ),
        props.resource.isResourceIncomplete && _react2.default.createElement(_resources.ResourceIncomplete, null)
      )
    )
  );
};

ResourceItem.propTypes = {
  resource: _propTypes2.default.object.isRequired,
  handleResourceClick: _propTypes2.default.func.isRequired,
  activity: _propTypes2.default.object.isRequired,
  isClickable: _propTypes2.default.bool.isRequired
};

exports.default = ResourceItem;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(37),m=__webpack_require__(0);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var q=60106,r=60107,u=60108,z=60114,B=60109,aa=60110,ba=60112,D=60113,ca=60120,da=60115,ea=60116,fa=60121,ha=60117,ia=60119,ja=60129,ka=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;q=E("react.portal");r=E("react.fragment");u=E("react.strict_mode");z=E("react.profiler");B=E("react.provider");aa=E("react.context");ba=E("react.forward_ref");D=E("react.suspense");ca=E("react.suspense_list");da=E("react.memo");ea=E("react.lazy");fa=E("react.block");ha=E("react.fundamental");ia=E("react.scope");ja=E("react.debug_trace_mode");ka=E("react.legacy_hidden")}
function F(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case r:return"Fragment";case q:return"Portal";case z:return"Profiler";case u:return"StrictMode";case D:return"Suspense";case ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case aa:return(a.displayName||"Context")+".Consumer";case B:return(a._context.displayName||"Context")+".Provider";case ba:var b=a.render;b=b.displayName||b.name||"";return a.displayName||
(""!==b?"ForwardRef("+b+")":"ForwardRef");case da:return F(a.type);case fa:return F(a._render);case ea:b=a._payload;a=a._init;try{return F(a(b))}catch(c){}}return null}var la=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,ma={};function I(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function na(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return I(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=ma;return b}
for(var J=new Uint16Array(16),K=0;15>K;K++)J[K]=K+1;J[15]=0;var oa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pa=Object.prototype.hasOwnProperty,qa={},ra={};
function sa(a){if(pa.call(ra,a))return!0;if(pa.call(qa,a))return!1;if(oa.test(a))return ra[a]=!0;qa[a]=!0;return!1}function ta(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function ua(a,b,c,d){if(null===b||"undefined"===typeof b||ta(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function M(a,b,c,d,f,h,t){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=h;this.removeEmptyString=t}var N={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){N[a]=new M(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];N[b]=new M(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){N[a]=new M(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){N[a]=new M(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){N[a]=new M(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){N[a]=new M(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){N[a]=new M(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){N[a]=new M(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){N[a]=new M(a,5,!1,a.toLowerCase(),null,!1,!1)});var va=/[\-:]([a-z])/g;function wa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(va,
wa);N[b]=new M(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(va,wa);N[b]=new M(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(va,wa);N[b]=new M(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!1,!1)});
N.xlinkHref=new M("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){N[a]=new M(a,1,!1,a.toLowerCase(),null,!0,!0)});var xa=/["'&<>]/;
function O(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function ya(a,b){var c=N.hasOwnProperty(a)?N[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||ua(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(O(b)+'"')}return sa(a)?a+'="'+(O(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var Aa="function"===typeof Object.is?Object.is:za,P=null,Q=null,R=null,S=!1,T=!1,U=null,V=0;function W(){if(null===P)throw Error(p(321));return P}function Ba(){if(0<V)throw Error(p(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===R?null===Q?(S=!1,Q=R=Ba()):(S=!0,R=Q):null===R.next?(S=!1,R=R.next=Ba()):(S=!0,R=R.next);return R}function Da(a,b,c,d){for(;T;)T=!1,V+=1,R=null,c=a(b,d);Ea();return c}function Ea(){P=null;T=!1;Q=null;V=0;R=U=null}
function Fa(a,b){return"function"===typeof b?b(a):b}function Ga(a,b,c){P=W();R=Ca();if(S){var d=R.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=R.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);R.memoizedState=d;return[d,b]}return[R.memoizedState,b]}a=a===Fa?"function"===typeof b?b():b:void 0!==c?c(b):b;R.memoizedState=a;a=R.queue={last:null,dispatch:null};a=a.dispatch=Ha.bind(null,P,a);return[R.memoizedState,a]}
function Ia(a,b){P=W();R=Ca();b=void 0===b?null:b;if(null!==R){var c=R.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}if(d)return c[0]}}a=a();R.memoizedState=[a,b];return a}function Ha(a,b,c){if(!(25>V))throw Error(p(301));if(a===P)if(T=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ja(){}
var X=null,Ka={readContext:function(a){var b=X.threadID;I(a,b);return a[b]},useContext:function(a){W();var b=X.threadID;I(a,b);return a[b]},useMemo:Ia,useReducer:Ga,useRef:function(a){P=W();R=Ca();var b=R.memoizedState;return null===b?(a={current:a},R.memoizedState=a):b},useState:function(a){return Ga(Fa,a)},useLayoutEffect:function(){},useCallback:function(a,b){return Ia(function(){return a},b)},useImperativeHandle:Ja,useEffect:Ja,useDebugValue:Ja,useDeferredValue:function(a){W();return a},useTransition:function(){W();
return[function(a){a()},!1]},useOpaqueIdentifier:function(){return(X.identifierPrefix||"")+"R:"+(X.uniqueID++).toString(36)},useMutableSource:function(a,b){W();return b(a._source)}},La={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Ma(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Na={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Oa=l({menuitem:!0},Na),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Pa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Pa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Qa=/([A-Z])/g,Ra=/^ms-/,Z=m.Children.toArray,Sa=la.ReactCurrentDispatcher,Ta={listing:!0,pre:!0,textarea:!0},Ua=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Va={},Wa={};function Xa(a){if(void 0===a||null===a)return a;var b="";m.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Ya=Object.prototype.hasOwnProperty,Za={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function $a(a,b){if(void 0===a)throw Error(p(152,F(b)||"Component"));}
function ab(a,b,c){function d(d,h){var e=h.prototype&&h.prototype.isReactComponent,f=na(h,b,c,e),t=[],g=!1,n={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===t)return null},enqueueReplaceState:function(a,c){g=!0;t=[c]},enqueueSetState:function(a,c){if(null===t)return null;t.push(c)}};if(e){if(e=new h(d.props,f,n),"function"===typeof h.getDerivedStateFromProps){var k=h.getDerivedStateFromProps.call(null,d.props,e.state);null!=k&&(e.state=l({},e.state,k))}}else if(P={},e=h(d.props,
f,n),e=Da(h,d.props,e,f),null==e||null==e.render){a=e;$a(a,h);return}e.props=d.props;e.context=f;e.updater=n;n=e.state;void 0===n&&(e.state=n=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof h.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),t.length){n=t;var v=
g;t=null;g=!1;if(v&&1===n.length)e.state=n[0];else{k=v?n[0]:e.state;var H=!0;for(v=v?1:0;v<n.length;v++){var x=n[v];x="function"===typeof x?x.call(e,k,d.props,f):x;null!=x&&(H?(H=!1,k=l({},k,x)):l(k,x))}e.state=k}}else t=null;a=e.render();$a(a,h);if("function"===typeof e.getChildContext&&(d=h.childContextTypes,"object"===typeof d)){var y=e.getChildContext();for(var A in y)if(!(A in d))throw Error(p(108,F(h)||"Unknown",A));}y&&(b=l({},b,y))}for(;m.isValidElement(a);){var f=a,h=f.type;if("function"!==
typeof h)break;d(f,h)}return{child:a,context:b}}
var bb=function(){function a(a,b,f){m.isValidElement(a)?a.type!==r?a=[a]:(a=a.props.children,a=m.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:La.html,children:a,childIndex:0,context:ma,footer:""};var c=J[0];if(0===c){var d=J;c=d.length;var g=2*c;if(!(65536>=g))throw Error(p(304));var e=new Uint16Array(g);e.set(d);J=e;J[0]=c+1;for(d=c;d<g-1;d++)J[d]=d+1;J[g-1]=0}else J[0]=J[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;
this.makeStaticMarkup=b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[];this.uniqueID=0;this.identifierPrefix=f&&f.identifierPrefix||""}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;J[a]=J[0];J[0]=a}};b.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,h=this.threadID;I(c,h);var t=c[h];this.contextStack[b]=c;this.contextValueStack[b]=t;c[h]=a.props.value};b.popProvider=
function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this;var c=Sa.current;Sa.current=Ka;try{for(var h=[""],t=!1;h[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var g=this.threadID;
J[g]=J[0];J[0]=g;break}var e=this.stack[this.stack.length-1];if(t||e.childIndex>=e.children.length){var L=e.footer;""!==L&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===B)this.popProvider(e.type);else if(e.type===D){this.suspenseDepth--;var G=h.pop();if(t){t=!1;var C=e.fallbackFrame;if(!C)throw Error(p(303));this.stack.push(C);h[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else h[this.suspenseDepth]+=
G}h[this.suspenseDepth]+=L}else{var n=e.children[e.childIndex++],k="";try{k+=this.render(n,e.context,e.domNamespace)}catch(v){if(null!=v&&"function"===typeof v.then)throw Error(p(294));throw v;}finally{}h.length<=this.suspenseDepth&&h.push("");h[this.suspenseDepth]+=k}}return h[0]}finally{Sa.current=c,X=b,Ea()}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return O(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+O(f);
this.previousWasTextNode=!0;return O(f)}b=ab(a,b,this.threadID);a=b.child;b=b.context;if(null===a||!1===a)return"";if(!m.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===q)throw Error(p(257));throw Error(p(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ka:case ja:case u:case z:case ca:case r:return a=Z(a.props.children),this.stack.push({type:null,
domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case D:throw Error(p(294));case ia:throw Error(p(343));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case ba:P={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case da:return a=[m.createElement(c.type,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case aa:c=a.type;d=a.props;var g=this.threadID;I(c,g);c=Z(d.children(c[g]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ha:throw Error(p(338));case ea:return c=a.type,d=c._init,c=d(c._payload),a=[m.createElement(c,l({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,
context:b,footer:""}),""}throw Error(p(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===La.html&&Ma(c);if(!Va.hasOwnProperty(c)){if(!Ua.test(c))throw Error(p(65,c));Va[c]=!0}var d=a.props;if("input"===c)d=l({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var g=d.value;if(null==g){g=d.defaultValue;var e=d.children;if(null!=e){if(null!=
g)throw Error(p(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(p(93));e=e[0]}g=""+e}null==g&&(g="")}d=l({},d,{value:void 0,children:""+g})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=l({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var L=Xa(d.children);if(null!=e){var G=null!=d.value?d.value+"":L;g=!1;if(Array.isArray(e))for(var C=0;C<e.length;C++){if(""+e[C]===G){g=!0;break}}else g=""+e===G;d=l({selected:void 0,children:void 0},
d,{selected:g,children:L})}}if(g=d){if(Oa[c]&&(null!=g.children||null!=g.dangerouslySetInnerHTML))throw Error(p(137,c));if(null!=g.dangerouslySetInnerHTML){if(null!=g.children)throw Error(p(60));if(!("object"===typeof g.dangerouslySetInnerHTML&&"__html"in g.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=g.style&&"object"!==typeof g.style)throw Error(p(62));}g=d;e=this.makeStaticMarkup;L=1===this.stack.length;G="<"+a.type;b:if(-1===c.indexOf("-"))C="string"===typeof g.is;else switch(c){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":C=
!1;break b;default:C=!0}for(w in g)if(Ya.call(g,w)){var n=g[w];if(null!=n){if("style"===w){var k=void 0,v="",H="";for(k in n)if(n.hasOwnProperty(k)){var x=0===k.indexOf("--"),y=n[k];if(null!=y){if(x)var A=k;else if(A=k,Wa.hasOwnProperty(A))A=Wa[A];else{var cb=A.replace(Qa,"-$1").toLowerCase().replace(Ra,"-ms-");A=Wa[A]=cb}v+=H+A+":";H=k;x=null==y||"boolean"===typeof y||""===y?"":x||"number"!==typeof y||0===y||Y.hasOwnProperty(H)&&Y[H]?(""+y).trim():y+"px";v+=x;H=";"}}n=v||null}k=null;C?Za.hasOwnProperty(w)||
(k=w,k=sa(k)&&null!=n?k+'="'+(O(n)+'"'):""):k=ya(w,n);k&&(G+=" "+k)}}e||L&&(G+=' data-reactroot=""');var w=G;g="";Na.hasOwnProperty(c)?w+="/>":(w+=">",g="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=O(e);break a}e=null}null!=e?(d=[],Ta.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(w+="\n"),w+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===f?Ma(a):"http://www.w3.org/2000/svg"===
f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:g});this.previousWasTextNode=!1;return w};return a}();exports.renderToNodeStream=function(){throw Error(p(207));};exports.renderToStaticMarkup=function(a,b){a=new bb(a,!0,b);try{return a.read(Infinity)}finally{a.destroy()}};exports.renderToStaticNodeStream=function(){throw Error(p(208));};exports.renderToString=function(a,b){a=new bb(a,!1,b);try{return a.read(Infinity)}finally{a.destroy()}};
exports.version="17.0.0";


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicInformationDisconnected = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _thenby = __webpack_require__(331);

var _thenby2 = _interopRequireDefault(_thenby);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _Indicator = __webpack_require__(676);

var _Indicator2 = _interopRequireDefault(_Indicator);

var _JustForMentors = __webpack_require__(1494);

var _JustForMentors2 = _interopRequireDefault(_JustForMentors);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _LevelSelect = __webpack_require__(1497);

var _LevelSelect2 = _interopRequireDefault(_LevelSelect);

var _CourseSelect = __webpack_require__(268);

var _CourseSelect2 = _interopRequireDefault(_CourseSelect);

var _Styled = __webpack_require__(682);

var _ErrorText = __webpack_require__(304);

var _ErrorText2 = _interopRequireDefault(_ErrorText);

var _QuestTypeIcon = __webpack_require__(586);

var _QuestTypeIcon2 = _interopRequireDefault(_QuestTypeIcon);

var _markdowneditor = __webpack_require__(142);

var _quest = __webpack_require__(103);

var _readability = __webpack_require__(222);

var _messages = __webpack_require__(21);

var _placeholder = __webpack_require__(150);

var _users = __webpack_require__(217);

var _subjects = __webpack_require__(1498);

var _users2 = __webpack_require__(1499);

var _error = __webpack_require__(464);

var _string = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BasicInformation = function (_Component) {
  (0, _inherits3.default)(BasicInformation, _Component);

  function BasicInformation(props) {
    (0, _classCallCheck3.default)(this, BasicInformation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BasicInformation.__proto__ || (0, _getPrototypeOf2.default)(BasicInformation)).call(this, props));

    _this.state = {
      mentorNoteExists: Boolean((0, _quest.findQuestMentorNote)(props.notes)),
      questType: props.quest.type.id,
      intendedCourse: props.quest.mock_course ? _this.formatCourse(props.quest.mock_course) : null,
      intendedLevel: props.quest.mock_level ? _this.formatLevel(props.quest.mock_level) : null
    };

    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.handleMentorNoteChangeBound = _this.handleMentorNoteChange.bind(_this);
    _this.onMentorFileUploadBound = _this.onMentorFileUpload.bind(_this);
    _this.handleMentorFileDescriptionChangeBound = _this.handleMentorFileDescriptionChange.bind(_this);
    _this.onDeleteQuestMentorNoteClickBound = _this.onDeleteQuestMentorNoteClick.bind(_this);
    _this.handleAuthorChangeBound = _this.handleAuthorChange.bind(_this);
    _this.handleSubjectChangeBound = _this.handleSubjectChange.bind(_this);
    _this.handleGroupQuestToggleBound = _this.handleGroupQuestToggle.bind(_this);
    _this.handleGradeLevelChangeBound = _this.handleGradeLevelChange.bind(_this);
    _this.onIntendedCourseChangeBound = _this.onIntendedCourseChange.bind(_this);
    _this.onIntendedLevelChangeBound = _this.onIntendedLevelChange.bind(_this);
    _this.handleManagerChangeBound = _this.handleManagerChange.bind(_this);
    _this.handleDrivingQuestionChangeBound = _this.handleDrivingQuestionChange.bind(_this);
    _this.handleQuestGoalChangeBound = _this.handleQuestGoalChange.bind(_this);
    _this.handleContentWarningsChange = _this.handleContentWarningsChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(BasicInformation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.isEditingQuest && nextProps.isEditingQuest) {
        this.setState(function () {
          return {
            questType: nextProps.quest.type.id
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quest = _props.quest,
          notes = _props.notes,
          isEditingQuest = _props.isEditingQuest,
          subjects = _props.subjects,
          gradeLevels = _props.gradeLevels,
          dispatch = _props.dispatch,
          qdUsers = _props.qdUsers,
          error = _props.error,
          mockCourses = _props.mockCourses,
          questManagerUsers = _props.questManagerUsers;
      var _state = this.state,
          intendedCourse = _state.intendedCourse,
          intendedLevel = _state.intendedLevel;

      var questMentorNote = (0, _quest.findQuestMentorNote)(notes);

      var descriptionOptions = (0, _assign2.default)({}, _markdowneditor.simpleMDEOptions);
      descriptionOptions.initialValue = quest.description;
      descriptionOptions.placeholder = '';
      descriptionOptions.autofocus = false;

      var drivingQuestionOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
      drivingQuestionOptions.initialValue = quest.driving_question;
      drivingQuestionOptions.placeholder = '';
      drivingQuestionOptions.autofocus = false;

      var questGoalOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
      questGoalOptions.initialValue = quest.learner_goal;
      questGoalOptions.placeholder = '';
      questGoalOptions.autofocus = false;

      var questEditors = (0, _quest.getQuestEditors)(quest).map(function (editor) {
        return editor.name;
      });
      var authorsAndQdUsers = (0, _users2.combineQuestUsersWithRoleUsers)(quest.authors, qdUsers);
      var questManagersAndQuestManagerUsers = (0, _users2.combineQuestUsersWithRoleUsers)(quest.managers, questManagerUsers);
      var orgHasQuestManagers = questManagersAndQuestManagerUsers.length > 0;

      return _react2.default.createElement(
        'div',
        { className: 'basic-information' },
        _react2.default.createElement(
          'div',
          { className: 'section-inner' },
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields' },
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _messages.title,
              _react2.default.createElement('div', { className: 'requiredtool' })
            ),
            _react2.default.createElement('input', {
              type: 'text',
              id: 'name',
              defaultValue: quest.name,
              className: 'form-control',
              onChange: this.handleChangeBound
            }),
            error && (0, _error.hasExpectedError)(error, 'name', 'has already been taken') && _react2.default.createElement(
              _ErrorText2.default,
              { style: { marginTop: '3px' } },
              'Sorry, that quest title is in use. Please choose a different title.'
            )
          ),
          isEditingQuest && (orgHasQuestManagers ? _react2.default.createElement(
            'div',
            { className: 'org-has-quest-managers' },
            _react2.default.createElement(
              'div',
              { className: 'title-edit-fields' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.authors,
                _react2.default.createElement('div', { className: 'requiredtool' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(_SearchArea2.default, {
                  dispatch: dispatch,
                  label: '',
                  area: 'author' + (orgHasQuestManagers ? '-with-managers' : ''),
                  placeholder: this.context.intl.formatMessage(_placeholder.messages.selectAuthors),
                  values: quest.author_ids,
                  options: (0, _arraySort2.default)(this.mapList(authorsAndQdUsers), ['sort']),
                  handleChange: this.handleAuthorChangeBound,
                  authorEdit: true
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'title-edit-fields' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Quest Manager'
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(_SearchArea2.default, {
                  dispatch: dispatch,
                  label: '',
                  area: 'managers',
                  placeholder: '',
                  values: quest.managers.length > 0 ? quest.managers[0].id : null,
                  options: (0, _arraySort2.default)(this.mapList(questManagersAndQuestManagerUsers), ['sort']),
                  handleChange: this.handleManagerChangeBound,
                  single: true
                })
              )
            )
          ) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _messages.authors,
              _react2.default.createElement('div', { className: 'requiredtool' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'edit-fields' },
              _react2.default.createElement(_SearchArea2.default, {
                dispatch: dispatch,
                label: '',
                area: 'author' + (orgHasQuestManagers ? '-with-managers' : ''),
                placeholder: this.context.intl.formatMessage(_placeholder.messages.selectAuthors),
                values: quest.author_ids,
                options: (0, _arraySort2.default)(this.mapList(authorsAndQdUsers), ['sort']),
                handleChange: this.handleAuthorChangeBound,
                authorEdit: true
              })
            )
          )),
          !isEditingQuest && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _messages.authors,
              _react2.default.createElement('div', { className: 'requiredtool' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'view-fields' },
              _react2.default.createElement(
                'label',
                { id: 'view-authors' },
                quest.author
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Quest Manager'
            ),
            _react2.default.createElement(
              'div',
              { className: 'view-fields' },
              quest.managers.length > 0 ? _react2.default.createElement(
                'label',
                { id: 'view-managers' },
                quest.managers[0].display_name
              ) : _react2.default.createElement(_NotYetSpecified2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.BasicInfo.Editors',
              defaultMessage: 'Editors'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            questEditors.length > 0 ? _react2.default.createElement(
              'label',
              { id: 'view-editors' },
              (0, _arraySort2.default)(questEditors, ['display_name']).join(', ')
            ) : _react2.default.createElement(_NotYetSpecified2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            'Type',
            _react2.default.createElement('div', { className: 'requiredtool' })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields', id: 'questTypes' },
            this.props.questTypes.map(function (qt) {
              return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement('input', {
                    type: 'radio',
                    id: 'quest_type_id',
                    checked: _this2.state.questType === qt.id,
                    value: qt.id,
                    onClick: _this2.handleChangeBound
                  }),
                  _react2.default.createElement(_QuestTypeIcon2.default, {
                    key: 'quest-type-icon-' + qt.id,
                    id: qt.id
                  }),
                  qt.name
                )
              );
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            quest.type.name ? _react2.default.createElement(
              'label',
              null,
              quest.type.name
            ) : _react2.default.createElement(_NotYetSpecified2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.BasicInfo.DrivingQuestion',
              defaultMessage: 'Driving Question'
            }),
            _react2.default.createElement('div', { className: 'requiredtool' })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields', id: 'driving_question' },
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              options: drivingQuestionOptions,
              onChange: this.handleDrivingQuestionChangeBound
            }),
            error && (0, _error.hasExpectedError)(error, 'driving_question', 'length error') ? _react2.default.createElement(
              _ErrorText2.default,
              { style: { marginTop: '3px' } },
              'Maximum 255 characters'
            ) : _react2.default.createElement(
              _Styled.HelperText,
              null,
              'Maximum 255 characters'
            )
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            _react2.default.createElement(_MarkdownLabel2.default, {
              id: 'view-driving_question',
              value: quest.driving_question
            }),
            (0, _readability.hasReadabilityStats)(quest, 'driving_question') && _react2.default.createElement(_Indicator2.default, {
              quest: quest,
              section: 'quest',
              subsection: 'driving_question',
              dispatch: dispatch,
              scores: (0, _readability.getSectionScores)(quest, 'driving_question'),
              readableStatsObject: quest
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.questGoal
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields', id: 'learner_goal' },
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              options: questGoalOptions,
              onChange: this.handleQuestGoalChangeBound
            }),
            error && (0, _error.hasExpectedError)(error, 'learner_goal', 'length error') ? _react2.default.createElement(
              _ErrorText2.default,
              { style: { marginTop: '3px' } },
              'Maximum 255 characters'
            ) : _react2.default.createElement(
              _Styled.HelperText,
              null,
              'Maximum 255 characters'
            )
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            _react2.default.createElement(_MarkdownLabel2.default, { id: 'view-quest_goal', value: quest.learner_goal })
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.descriptionMessage,
            _react2.default.createElement('div', { className: 'requiredtool' })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields', id: 'description' },
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              options: descriptionOptions,
              onChange: this.handleDescriptionChangeBound
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            _react2.default.createElement(_MarkdownLabel2.default, { id: 'view-description', value: quest.description }),
            (0, _readability.hasReadabilityStats)(quest, 'description') && _react2.default.createElement(_Indicator2.default, {
              quest: quest,
              section: 'quest',
              subsection: 'description',
              dispatch: dispatch,
              scores: (0, _readability.getSectionScores)(quest, 'description'),
              readableStatsObject: quest
            })
          ),
          isEditingQuest ? _react2.default.createElement(
            'div',
            { className: 'intended-course-level-container edit-fields' },
            _react2.default.createElement(
              'div',
              { className: 'intended-course-container' },
              _react2.default.createElement(
                'div',
                {
                  className: 'title ' + (mockCourses.length < 1 ? 'disabled' : '')
                },
                'Intended Journey'
              ),
              _react2.default.createElement(_CourseSelect2.default, {
                course: intendedCourse,
                courses: mockCourses,
                onCourseChange: this.onIntendedCourseChangeBound,
                disabled: mockCourses.length < 1,
                labelTruncationLength: 39
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'intended-level-container' },
              _react2.default.createElement(
                'div',
                {
                  className: 'title ' + (!intendedCourse || intendedCourse && this.getCourseLevels(intendedCourse).length === 0 ? 'disabled' : '')
                },
                'Intended Level'
              ),
              _react2.default.createElement(_LevelSelect2.default, {
                level: intendedLevel,
                levels: intendedCourse ? this.getCourseLevels(intendedCourse) : [],
                onLevelChange: this.onIntendedLevelChangeBound,
                noMockCourses: mockCourses.length === 0,
                intendedCourseHasNoLevels: intendedCourse && this.getCourseLevels(intendedCourse).length === 0,
                course: intendedCourse
              })
            )
          ) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Intended Journey / Level'
            ),
            _react2.default.createElement(
              'div',
              { className: 'view-fields' },
              quest.mock_course ? _react2.default.createElement(
                'label',
                { className: 'intended-course' },
                quest.mock_course.name,
                _react2.default.createElement(
                  'span',
                  null,
                  ' / '
                ),
                quest.mock_level ? (quest.mock_level.mastery ? 'Mastery Level' : 'Level ' + quest.mock_level.number) + ': ' + quest.mock_level.name : 'Level: Not Yet Specified'
              ) : _react2.default.createElement(_NotYetSpecified2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.primarySubject
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields primary-subject' },
            _react2.default.createElement(_SearchArea2.default, {
              dispatch: this.props.dispatch,
              label: '',
              placeholder: '',
              area: 'subject',
              values: quest.subject.id,
              options: subjects.map(function (s) {
                return { label: s.name, value: s.id };
              }),
              handleChange: this.handleSubjectChangeBound,
              single: true
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            quest.subject.name ? _react2.default.createElement(
              'label',
              null,
              quest.subject.name
            ) : _react2.default.createElement(_NotYetSpecified2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.targetGradeLevel
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields' },
            _react2.default.createElement(_SearchArea2.default, {
              dispatch: this.props.dispatch,
              label: '',
              placeholder: '',
              area: 'gradelevel',
              values: quest.grade_levels.map(function (gl) {
                return gl.id;
              }),
              options: (0, _arraySort2.default)(this.formatGradeLevels(gradeLevels), ['sort']),
              handleChange: this.handleGradeLevelChangeBound
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            quest.grade_levels.length > 0 ? _react2.default.createElement(
              'label',
              null,
              quest.grade_levels.sort((0, _thenby2.default)('sort_order')).map(function (gradeLevel) {
                return gradeLevel.name;
              }).join(', ')
            ) : _react2.default.createElement(_NotYetSpecified2.default, null)
          ),
          ((0, _quest.basicInfoHasJustForMentors)(quest, questMentorNote) || isEditingQuest) && _react2.default.createElement(_JustForMentors2.default, {
            quest: quest,
            questMentorNote: questMentorNote,
            isUploadingNote: this.props.isUploadingNote,
            isDeletingNote: this.props.isDeletingNote,
            handleMentorNoteChange: this.handleMentorNoteChangeBound,
            onMentorFileUpload: this.onMentorFileUploadBound,
            handleMentorFileDescriptionChange: this.handleMentorFileDescriptionChangeBound,
            onDeleteQuestMentorNoteClick: this.onDeleteQuestMentorNoteClickBound,
            handleChange: this.handleChangeBound,
            isEditing: isEditingQuest,
            mentorNoteExists: this.state.mentorNoteExists,
            handleContentWarningsChange: this.handleContentWarningsChange,
            error: error
          })
        )
      );
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      if (e.target.id === 'quest_type_id') {
        var value = parseInt(e.target.value);
        this.setState(function () {
          return { questType: value };
        });
      }

      this.props.handleChange(e);
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'description';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }, {
    key: 'handleDrivingQuestionChange',
    value: function handleDrivingQuestionChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'driving_question';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }, {
    key: 'handleQuestGoalChange',
    value: function handleQuestGoalChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'learner_goal';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }, {
    key: 'handleMentorNoteChange',
    value: function handleMentorNoteChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'inline_mentor_notes';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }, {
    key: 'onMentorFileUpload',
    value: function onMentorFileUpload(e) {
      if (e.target.files.length > 0) {
        this.setState(function (state) {
          return { mentorNoteExists: true };
        });
        this.props.handleNotesUpload(e.target.files[0]);
      } else {
        this.setState(function (state) {
          return { mentorNoteExists: false };
        });
        this.props.handleNotesUploadCancel();
      }
    }
  }, {
    key: 'handleMentorFileDescriptionChange',
    value: function handleMentorFileDescriptionChange(e) {
      this.props.handleNotesDescriptionChange(e);
    }
  }, {
    key: 'onDeleteQuestMentorNoteClick',
    value: function onDeleteQuestMentorNoteClick() {
      this.setState(function (state) {
        return { mentorNoteExists: false };
      });
      var note = (0, _quest.findQuestMentorNote)(this.props.notes, 'Quest');
      this.props.deleteNote(note.id);
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'handleAuthorChange',
    value: function handleAuthorChange(values) {
      // Hacky way to format the event id and value so parent's edit function works
      var event = {
        target: {}
      };
      event.target.id = 'ordered_author_ids';
      var idsArray = values.map(function (a) {
        return a.value;
      });
      event.target.value = idsArray;
      this.props.handleChange(event);
    }
  }, {
    key: 'handleManagerChange',
    value: function handleManagerChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      var event = {
        target: {}
      };
      event.target.id = 'manager_ids';
      event.target.value = e ? [e.value] : [];
      this.props.handleChange(event);
    }
  }, {
    key: 'handleSubjectChange',
    value: function handleSubjectChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      var event = {
        target: {}
      };
      event.target.id = 'quest_subject_id';
      event.target.value = e ? e.value : [];
      this.props.handleChange(event);
    }
  }, {
    key: 'handleGroupQuestToggle',
    value: function handleGroupQuestToggle(e) {
      // Need to format yes/no strings from e.target.value to bool
      var event = { target: {} };
      event.target.id = e.target.id;
      event.target.value = e.target.value === 'true';
      this.props.handleChange(event);
    }
  }, {
    key: 'handleGradeLevelChange',
    value: function handleGradeLevelChange(values) {
      // Hacky way to format the event id and value so parent's edit function works
      var event = {
        target: {}
      };
      event.target.id = 'grade_level_ids';
      var idsArray = values.map(function (gl) {
        return gl.value;
      });
      event.target.value = idsArray;
      this.props.handleChange(event);
    }
  }, {
    key: 'formatGradeLevels',
    value: function formatGradeLevels(gl) {
      return gl.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.sort_order
        };
      });
    }
  }, {
    key: 'formatMockCourses',
    value: function formatMockCourses(mc) {
      return mc.map(function (el) {
        return {
          value: el.id,
          id: el.id,
          label: el.name,
          sort: el.name,
          color: el.color,
          style: {
            color: el.color
          }
        };
      });
    }
  }, {
    key: 'onIntendedCourseChange',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value) {
        var event;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState(function (prevState) {
                  return {
                    intendedCourse: value,
                    intendedLevel: value ? prevState.intendedCourse && prevState.intendedCourse.id === value.id ? prevState.intendedLevel : null : null
                  };
                });

              case 2:
                // Hacky way to format the event id and value so parent's edit function works
                event = {
                  target: {}
                };

                event.target.id = 'mock_course_id';
                // handling for potentially cleared course
                event.target.value = value ? value.value : null;
                this.props.handleChange(event);
                // if changing to a different course, nullify mock_level in parent state handler
                if (!this.state.intendedLevel) {
                  this.props.handleChange({
                    target: {
                      id: 'mock_level_id',
                      value: null
                    }
                  });
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onIntendedCourseChange(_x) {
        return _ref.apply(this, arguments);
      }

      return onIntendedCourseChange;
    }()
  }, {
    key: 'onIntendedLevelChange',
    value: function onIntendedLevelChange(value) {
      this.setState(function () {
        return {
          intendedLevel: value
        };
      });

      // Hacky way to format the event id and value so parent's edit function works
      var event = {
        target: {}
      };
      event.target.id = 'mock_level_id';
      event.target.value = value ? value.value : null;
      this.props.handleChange(event);
    }
  }, {
    key: 'getCourseLevels',
    value: function getCourseLevels(course) {
      return this.props.mockCourses.find(function (mc) {
        return mc.id === course.id;
      }).mock_levels;
    }
  }, {
    key: 'formatCourse',
    value: function formatCourse(c) {
      return {
        value: c.id,
        id: c.id,
        label: (0, _string.getTruncatedString)({ val: c.name, len: 39 }),
        sort: c.name,
        color: c.color,
        style: {
          color: '#' + c.color
        }
      };
    }
  }, {
    key: 'formatLevel',
    value: function formatLevel(l) {
      var labelString = (l.mastery ? 'Mastery Level' : l.number) + ': ' + l.name;
      return {
        value: l.id,
        id: l.id,
        sort: l.sort_order,
        label: (0, _string.getTruncatedString)({ val: labelString, len: 42 })
      };
    }
  }, {
    key: 'handleContentWarningsChange',
    value: function handleContentWarningsChange(val) {
      this.props.handleChange({
        target: {
          id: 'content_warnings',
          value: val
        }
      });
    }
  }]);
  return BasicInformation;
}(_react.Component);

BasicInformation.propTypes = {
  notes: _propTypes2.default.array,
  quest: _propTypes2.default.object,
  isEditingQuest: _propTypes2.default.bool,
  handleChange: _propTypes2.default.func,
  handleNotesDescriptionChange: _propTypes2.default.func,
  handleNotesUpload: _propTypes2.default.func,
  deleteNote: _propTypes2.default.func,
  dispatch: _propTypes2.default.func,
  users: _propTypes2.default.array,
  isUploadingNote: _propTypes2.default.bool,
  isDeletingNote: _propTypes2.default.bool,
  subjects: _propTypes2.default.array,
  qdUsers: _propTypes2.default.array,
  gradeLevels: _propTypes2.default.array,
  handleNotesUploadCancel: _propTypes2.default.func,
  error: _propTypes2.default.object,
  mockCourses: _propTypes2.default.array.isRequired,
  questTypes: _propTypes2.default.array,
  questManagerUsers: _propTypes2.default.array,
  organization: _propTypes2.default.object.isRequired
};

BasicInformation.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    notes: state.quest.notes,
    users: state.users.items,
    isEditingQuest: state.quest.isEditingQuest,
    isUploadingNote: state.quest.isUploadingNote,
    isDeletingNote: state.quest.isDeletingNote,
    subjects: (0, _subjects.alphabeticalSubjects)(state),
    qdUsers: (0, _users.getActiveQdUsers)(state),
    gradeLevels: state.gradelevels.items,
    error: state.quest.error ? (0, _error.parseErrors)(state.quest.error) : null,
    mockCourses: state.mockcourses.items,
    questTypes: state.questtypes.items,
    questManagerUsers: (0, _users.questManagers)(state),
    organization: state.organization
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BasicInformation);
exports.BasicInformationDisconnected = BasicInformation; // pure component - used in tests

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JustForMentorsDisconnected = undefined;

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _reactIntl = __webpack_require__(16);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _ContentWarningsEditor = __webpack_require__(463);

var _ContentWarningsEditor2 = _interopRequireDefault(_ContentWarningsEditor);

var _ContentWarningsList = __webpack_require__(1495);

var _ContentWarningsList2 = _interopRequireDefault(_ContentWarningsList);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _ErrorText = __webpack_require__(304);

var _ErrorText2 = _interopRequireDefault(_ErrorText);

var _index = __webpack_require__(20);

var _messages = __webpack_require__(21);

var _placeholder = __webpack_require__(150);

var _contentwarnings = __webpack_require__(167);

var _error = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JustForMentors = function (_Component) {
  (0, _inherits3.default)(JustForMentors, _Component);

  function JustForMentors() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, JustForMentors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = JustForMentors.__proto__ || (0, _getPrototypeOf2.default)(JustForMentors)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hasContentWarnings: (0, _contentwarnings.questHasContentWarnings)(_this.props.quest),
      contentWarnings: _this.props.quest.content_warnings
    }, _this.onToggleContentWarningsClick = function (e) {
      var value = JSON.parse(e.target.value);
      _this.setState(function () {
        return {
          hasContentWarnings: value,
          contentWarnings: {}
        };
      }, function () {
        return _this.props.handleContentWarningsChange(_this.state.contentWarnings);
      });
    }, _this.onSetContentWarningClick = function (e) {
      var name = e.target.name;
      var value = e.target.value;
      var checked = e.target.checked;

      if (!value) {
        // for the 'none' radios/values
        _this.setState(function (state) {
          return {
            contentWarnings: (0, _assign2.default)({}, state.contentWarnings, (0, _defineProperty3.default)({}, name, null))
          };
        }, function () {
          _this.props.handleContentWarningsChange(_this.state.contentWarnings);
        });
        // don't love calling risky_behaviors directly here - should be able to handle other potential new values
      } else if (name !== 'risky_behaviors') {
        if (checked) {
          _this.setState(function (state) {
            return {
              contentWarnings: (0, _assign2.default)({}, state.contentWarnings, (0, _defineProperty3.default)({}, name, { value: value }))
            };
          }, function () {
            _this.props.handleContentWarningsChange(_this.state.contentWarnings);
          });
        } else {
          // Need to handle graphic_content, is only one with a input checkbox for 'none' value
          _this.setState(function (state) {
            return {
              contentWarnings: (0, _assign2.default)({}, state.contentWarnings, (0, _defineProperty3.default)({}, name, null))
            };
          }, function () {
            _this.props.handleContentWarningsChange(_this.state.contentWarnings);
          });
        }
      } else {
        // for the risky_behaviors - need to handle differently
        checked ? _this.setState(function (state) {
          return {
            contentWarnings: (0, _assign2.default)({}, state.contentWarnings, (0, _defineProperty3.default)({}, name, state.contentWarnings[name] ? state.contentWarnings[name].concat({ value: value }) : [{ value: value }]))
          };
        }, function () {
          _this.props.handleContentWarningsChange(_this.state.contentWarnings);
        }) : _this.setState(function (state) {
          return {
            contentWarnings: (0, _assign2.default)({}, state.contentWarnings, (0, _defineProperty3.default)({}, name, state.contentWarnings[name].filter(function (cw) {
              return cw.value !== value;
            })))
          };
        }, function () {
          _this.props.handleContentWarningsChange(_this.state.contentWarnings);
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(JustForMentors, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // this component retains state between edits
      // need to reset the contentWarnings state to prevent "none" content warning radio on if previously selected
      if (!this.props.isEditing && nextProps.isEditing) {
        this.setState(function () {
          return {
            contentWarnings: nextProps.quest.content_warnings
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          questMentorNote = _props.questMentorNote,
          isUploadingNote = _props.isUploadingNote,
          isDeletingNote = _props.isDeletingNote,
          handleMentorNoteChange = _props.handleMentorNoteChange,
          onMentorFileUpload = _props.onMentorFileUpload,
          handleMentorFileDescriptionChange = _props.handleMentorFileDescriptionChange,
          onDeleteQuestMentorNoteClick = _props.onDeleteQuestMentorNoteClick,
          handleChange = _props.handleChange,
          isEditing = _props.isEditing,
          intl = _props.intl,
          mentorNoteExists = _props.mentorNoteExists;


      var justForMentorsOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      justForMentorsOptions.initialValue = quest.inline_mentor_notes;
      justForMentorsOptions.placeholder = intl.formatMessage(_placeholder.messages.giveMentorsBackgroundInfo);
      justForMentorsOptions.autofocus = false;

      var justForMentorsFileNoteOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      justForMentorsFileNoteOptions.initialValue = questMentorNote ? questMentorNote.description : '';
      justForMentorsFileNoteOptions.placeholder = intl.formatMessage(_placeholder.messages.writeABriefDescriptionOfFile);
      justForMentorsFileNoteOptions.autofocus = false;

      return _react2.default.createElement(
        'div',
        { id: 'justForMentors', className: 'quest-level' },
        _react2.default.createElement(
          'div',
          { className: 'just-for-mentors-label' },
          _messages.justFor,
          '\xA0',
          _react2.default.createElement(
            'span',
            { className: 'label' },
            _messages.mentors
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'mentorNoteRegion' },
          !isEditing && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            quest.inline_mentor_notes && quest.inline_mentor_notes.length > 0 && _react2.default.createElement(_MarkdownLabel2.default, {
              id: 'view-inline_mentor_notes',
              value: quest.inline_mentor_notes
            })
          ),
          isEditing && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'edit-fields' },
              _react2.default.createElement(_reactSimplemdeEditor2.default, {
                id: 'inlineMentorNotes',
                options: justForMentorsOptions,
                onChange: handleMentorNoteChange
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'file' },
              !(0, _index.isNullOrEmpty)(questMentorNote) && !isDeletingNote && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'a-title edit-fields' },
                  _messages.uploadedFile
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'a-title edit-fields editting' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'file-name name editting ' + questMentorNote.file_type
                    },
                    _react2.default.createElement(
                      'a',
                      {
                        className: 'editting',
                        href: questMentorNote.attachment_url,
                        target: '_blank'
                      },
                      questMentorNote.attachment_name
                    ),
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'button remove-file edit-fields btn-destructive-small',
                        onClick: onDeleteQuestMentorNoteClick
                      },
                      _messages.remove
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'file-description-wrapper' },
                  _react2.default.createElement('div', { className: 'title edit-fields' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'edit-fields' },
                    _react2.default.createElement(_reactSimplemdeEditor2.default, {
                      id: 'noteFileDescription',
                      options: justForMentorsFileNoteOptions,
                      onChange: handleMentorFileDescriptionChange
                    })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'a-title edit-fields' },
                !questMentorNote ? _messages.uploadAFile : ''
              ),
              (0, _index.isNullOrEmpty)(questMentorNote) && !isUploadingNote && !isDeletingNote && _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement('input', {
                  type: 'file',
                  id: 'mentorNoteFileInput',
                  onChange: onMentorFileUpload
                }),
                mentorNoteExists && _react2.default.createElement(
                  'div',
                  { className: 'file-description-wrapper' },
                  _react2.default.createElement('div', { className: 'title edit-fields' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'edit-fields' },
                    _react2.default.createElement(_reactSimplemdeEditor2.default, {
                      id: 'noteFileDescription',
                      options: justForMentorsFileNoteOptions,
                      onChange: handleMentorFileDescriptionChange
                    })
                  )
                )
              ),
              (isUploadingNote || isDeletingNote) && _react2.default.createElement('div', { className: 'loading' })
            )
          ),
          !isEditing && !(0, _index.isNullOrEmpty)(questMentorNote) && _react2.default.createElement(
            'div',
            { id: 'mentorNoteRegion' },
            _react2.default.createElement(
              'div',
              { className: 'file' },
              _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'file-name name ' + questMentorNote.file_type
                  },
                  _react2.default.createElement(
                    'a',
                    { href: questMentorNote.attachment_url, target: '_blank' },
                    questMentorNote.attachment_name
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              questMentorNote.description && _react2.default.createElement(
                'div',
                { className: 'view-fields' },
                _react2.default.createElement(_MarkdownLabel2.default, { value: questMentorNote.description })
              )
            )
          ),
          isEditing && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Quest Content Warnings'
            ),
            _react2.default.createElement(
              _P2.default,
              null,
              'Let mentors know that this quest contains sensitive topics or materials. \xA0',
              _react2.default.createElement(
                'a',
                {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  href: 'https://questforward.zendesk.com/hc/en-us/articles/360028989832'
                },
                'Learn more'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'content-warnings' },
              _react2.default.createElement('input', {
                id: 'content-warnings-true',
                type: 'radio',
                checked: this.state.hasContentWarnings === true,
                value: true,
                onClick: this.onToggleContentWarningsClick
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'content-warnings-true' },
                'Yes'
              ),
              _react2.default.createElement('input', {
                id: 'content-warnings-false',
                type: 'radio',
                checked: this.state.hasContentWarnings === false,
                value: false,
                onClick: this.onToggleContentWarningsClick
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'content-warnings-false' },
                'No'
              )
            ),
            this.state.hasContentWarnings && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(_ContentWarningsEditor2.default, {
                contentWarnings: this.state.contentWarnings,
                handleContentWarningClick: this.onSetContentWarningClick
              }),
              this.props.error && (0, _error.hasExpectedError)(this.props.error, 'content_warnings', 'content warnings required') && _react2.default.createElement(
                _ErrorText2.default,
                { style: { marginTop: '24px' } },
                'Select one or more content warnings.'
              )
            )
          ),
          !isEditing && (0, _contentwarnings.questHasContentWarnings)(quest) && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              'Quest Content Warnings'
            ),
            _react2.default.createElement(_ContentWarningsList2.default, { contentWarnings: quest.content_warnings })
          )
        )
      );
    }
  }]);
  return JustForMentors;
}(_react.Component);

JustForMentors.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  questMentorNote: _propTypes2.default.object,
  isUploadingNote: _propTypes2.default.bool.isRequired,
  isDeletingNote: _propTypes2.default.bool.isRequired,
  handleMentorNoteChange: _propTypes2.default.func.isRequired,
  onMentorFileUpload: _propTypes2.default.func.isRequired,
  handleMentorFileDescriptionChange: _propTypes2.default.func.isRequired,
  onDeleteQuestMentorNoteClick: _propTypes2.default.func.isRequired,
  handleChange: _propTypes2.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  isEditing: _propTypes2.default.bool.isRequired,
  mentorNoteExists: _propTypes2.default.bool.isRequired,
  handleContentWarningsChange: _propTypes2.default.func.isRequired,
  error: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)(JustForMentors);
exports.JustForMentorsDisconnected = JustForMentors;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _ContentWarningItem = __webpack_require__(1496);

var _ContentWarningItem2 = _interopRequireDefault(_ContentWarningItem);

var _contentwarnings = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWarningsList = function ContentWarningsList(props) {
  var mappedContentWarnings = (0, _contentwarnings.mapContentWarnings)(props.contentWarnings);
  var sortedContentWarnings = (0, _arraySort2.default)(mappedContentWarnings, ['sort_order']);
  var contentWarnings = sortedContentWarnings.map(function (cw) {
    return _react2.default.createElement(_ContentWarningItem2.default, { contentWarning: cw, key: cw.text });
  });
  return _react2.default.createElement(
    'ul',
    null,
    contentWarnings
  );
};

ContentWarningsList.propTypes = {
  contentWarnings: _propTypes2.default.object.isRequired
};

exports.default = ContentWarningsList;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  margin-top: 17px;\n\n  .content-warning-icon {\n    margin-left: 0;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  margin-top: 17px;\n\n  .content-warning-icon {\n    margin-left: 0;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ContentWarningIcon = __webpack_require__(340);

var _ContentWarningIcon2 = _interopRequireDefault(_ContentWarningIcon);

var _P = __webpack_require__(681);

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWarningRow = _styledComponents2.default.li.withConfig({
  displayName: 'ContentWarningItem__ContentWarningRow',
  componentId: 'sc-1jn2yoz-0'
})(_templateObject);

var ContentWarningItem = function ContentWarningItem(_ref) {
  var contentWarning = _ref.contentWarning;
  return _react2.default.createElement(
    ContentWarningRow,
    null,
    _react2.default.createElement(_ContentWarningIcon2.default, {
      value: contentWarning.value,
      text: contentWarning.text,
      abbrev: contentWarning.abbrev
    }),
    _react2.default.createElement(
      _P2.default,
      { style: { color: '#000000' } },
      contentWarning.text
    )
  );
};

ContentWarningItem.propTypes = {
  contentWarning: _propTypes2.default.object.isRequired
};

exports.default = ContentWarningItem;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _levels = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelSelect = function (_Component) {
  (0, _inherits3.default)(LevelSelect, _Component);

  function LevelSelect(props) {
    (0, _classCallCheck3.default)(this, LevelSelect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LevelSelect.__proto__ || (0, _getPrototypeOf2.default)(LevelSelect)).call(this, props));

    _this.state = {
      selectedValue: props.level
    };

    _this.handleSelectChangeBound = _this.handleSelectChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LevelSelect, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.level !== this.props.level) {
        this.setState(function () {
          return {
            selectedValue: nextProps.level
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          levels = _props.levels,
          noMockCourses = _props.noMockCourses,
          intendedCourseHasNoLevels = _props.intendedCourseHasNoLevels,
          course = _props.course;


      var disabled = noMockCourses || intendedCourseHasNoLevels;

      var selectComponent = _react2.default.createElement(_reactSelect2.default, {
        searchable: true,
        options: (0, _levels.mapLevels)(levels, 42),
        value: this.state.selectedValue,
        onChange: this.handleSelectChangeBound,
        placeholder: '',
        disabled: disabled || !course,
        matchProp: 'label',
        style: {
          boxShadow: 'none',
          height: '44px'
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'level-select' },
        disabled && _react2.default.createElement(_reactTooltip2.default, { id: 'levelSelectTooltip' }),
        noMockCourses ? _react2.default.createElement(
          'div',
          {
            'data-for': 'levelSelectTooltip',
            'data-tip': 'No journeys are available.'
          },
          selectComponent
        ) : _react2.default.createElement(
          'div',
          {
            'data-for': 'levelSelectTooltip',
            'data-tip': 'No levels are available for this journey.'
          },
          selectComponent
        )
      );
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(value) {
      this.setState(function () {
        return {
          selectedValue: value
        };
      });
      this.props.onLevelChange(value);
    }
  }]);
  return LevelSelect;
}(_react.Component);

exports.default = LevelSelect;


LevelSelect.propTypes = {
  levels: _propTypes2.default.array.isRequired,
  level: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  onLevelChange: _propTypes2.default.func.isRequired,
  noMockCourses: _propTypes2.default.bool.isRequired,
  intendedCourseHasNoLevels: _propTypes2.default.bool.isRequired,
  course: _propTypes2.default.object
};

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alphabeticalSubjects = undefined;

var _reselect = __webpack_require__(168);

var _thenby = __webpack_require__(331);

var _thenby2 = _interopRequireDefault(_thenby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _alphabeticalSubjects = function _alphabeticalSubjects(state) {
  return state.subjects.items.sort((0, _thenby2.default)('name'));
};

var alphabeticalSubjects = exports.alphabeticalSubjects = (0, _reselect.createSelector)([_alphabeticalSubjects], function (subjects) {
  return subjects;
});

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineQuestUsersWithRoleUsers = combineQuestUsersWithRoleUsers;
// Used to combine data on a quest (like authors) with org users with whatever role
// Needed for populating select options when a quest author is deleted, no longer has that role (for example)
function combineQuestUsersWithRoleUsers(questUsers, users) {
  var combinedUsers = users.concat(questUsers);
  var idPositions = combinedUsers.map(function (user) {
    return user.id;
  });

  return combinedUsers.filter(function (item, pos) {
    return idPositions.indexOf(item.id) === pos;
  });
}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentsDisconnected = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = __webpack_require__(16);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _CommentsList = __webpack_require__(1501);

var _CommentsList2 = _interopRequireDefault(_CommentsList);

var _DraftComment = __webpack_require__(1503);

var _DraftComment2 = _interopRequireDefault(_DraftComment);

var _userdraftcomments = __webpack_require__(1504);

var _comments = __webpack_require__(685);

var _messages = __webpack_require__(21);

var _time = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Comments = function (_Component) {
  (0, _inherits3.default)(Comments, _Component);

  function Comments(props) {
    (0, _classCallCheck3.default)(this, Comments);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Comments.__proto__ || (0, _getPrototypeOf2.default)(Comments)).call(this, props));

    _this.state = {
      showDraftComment: props.userDraftComments.length > 0,
      showingResolvedComments: false,
      isNewDraft: false
    };

    _this.onClickAddCommentBound = _this.onClickAddComment.bind(_this);
    _this.toggleResolvedCommentsBound = _this.toggleResolvedComments.bind(_this);
    _this.cancelDraftClickBound = _this.cancelDraftClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Comments, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.userDraftComments.length > 0) {
        this.setState({ showDraftComment: true, isNewDraft: false });
      } else if (nextProps.userDraftComments.length === 0 && !nextProps.isEditingComment) {
        this.setState({ showDraftComment: false });
      }
      if (this.props.section !== nextProps.section) {
        this.setState({
          showDraftComment: nextProps.userDraftComments.length > 0
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          userDraftComments = _props.userDraftComments,
          comments = _props.comments,
          section = _props.section,
          activityId = _props.activityId;

      var totalSectionCommentCount = (0, _comments.getTotalCommentCount)(comments, section, activityId);
      var unresolvedCommentCount = (0, _comments.getUnresolvedCommentCount)(comments, section, activityId);
      var resolvedComments = (0, _comments.getResolvedComments)(comments, section, activityId);
      var filteredComments = (0, _comments.getFilteredComments)(comments, section, activityId, this.state.showingResolvedComments);

      filteredComments.forEach(function (c) {
        (0, _time.isUnixTimestamp)(c.updated_at) ? c.updated_at_friendly = _moment2.default.unix(c.updated_at).valueOf() : c.updated_at_friendly = (0, _moment2.default)(c.updated_at).valueOf();
      });

      return _react2.default.createElement(
        'div',
        { className: 'comment-section' },
        !this.state.showDraftComment && _react2.default.createElement(
          'div',
          { id: 'addACommentTriggerContainer' },
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { id: 'addACommentTrigger', onClick: this.onClickAddCommentBound },
            _messages.addAComment
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'quest-comments ' + (totalSectionCommentCount > 0 ? '' : 'no-comments')
          },
          this.state.showDraftComment && _react2.default.createElement(_DraftComment2.default, (0, _extends3.default)({
            comment: this.state.isNewDraft ? {
              body: '',
              user: user
            } : userDraftComments[0],
            cancelDraftClick: this.cancelDraftClickBound,
            isNewDraft: this.state.isNewDraft
          }, this.props)),
          _react2.default.createElement(
            'div',
            { className: 'published-comments' },
            totalSectionCommentCount > 0 && _react2.default.createElement(
              'div',
              { id: 'commentCount' },
              _react2.default.createElement(
                'div',
                null,
                unresolvedCommentCount
              ),
              _react2.default.createElement(
                'div',
                { className: 'commenttext' },
                '\xA0',
                _react2.default.createElement(_reactIntl.FormattedPlural, {
                  value: unresolvedCommentCount,
                  one: _messages.commentMessage,
                  other: _messages.commentsMessage
                })
              )
            ),
            resolvedComments.length > 0 && _react2.default.createElement(
              'div',
              { id: 'commentStatusToggle' },
              this.state.showingResolvedComments && _react2.default.createElement(
                'div',
                { onClick: this.toggleResolvedCommentsBound },
                _react2.default.createElement('div', { id: 'toggler' }),
                _react2.default.createElement(
                  'label',
                  { id: 'resolvedCommentCount' },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'Comments.HideComments',
                      defaultMessage: '{hide} {resolvedCount} {resolved} {comments}',
                      values: {
                        hide: _messages.hide,
                        resolvedCount: resolvedComments.length,
                        resolved: _messages.resolved,
                        comments: _react2.default.createElement(_reactIntl.FormattedPlural, {
                          value: resolvedComments.length,
                          one: _messages.commentMessage,
                          other: _messages.commentsMessage
                        })
                      }
                    })
                  )
                )
              ),
              !this.state.showingResolvedComments && _react2.default.createElement(
                'div',
                { onClick: this.toggleResolvedCommentsBound },
                _react2.default.createElement('div', { id: 'toggler', className: 'show' }),
                _react2.default.createElement(
                  'label',
                  { id: 'resolvedCommentCount' },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                      id: 'Comments.ShowComments',
                      defaultMessage: '{show} {resolvedCount} {resolved} {comments}',
                      values: {
                        show: _messages.show,
                        resolvedCount: resolvedComments.length,
                        resolved: _messages.resolved,
                        comments: _react2.default.createElement(_reactIntl.FormattedPlural, {
                          value: resolvedComments.length,
                          one: _messages.commentMessage,
                          other: _messages.commentsMessage
                        })
                      }
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(_CommentsList2.default, {
              comments: (0, _arraySort2.default)(filteredComments, ['updated_at_friendly'], {
                reverse: true
              }),
              showingResolvedComments: this.state.showingResolvedComments,
              user: user,
              quest: this.props.quest,
              section: this.props.section,
              dispatch: this.props.dispatch
            })
          )
        )
      );
    }
  }, {
    key: 'onClickAddComment',
    value: function onClickAddComment() {
      this.setState({
        showDraftComment: !this.state.showDraftComment,
        isNewDraft: true
      });
    }
  }, {
    key: 'toggleResolvedComments',
    value: function toggleResolvedComments() {
      this.setState({
        showingResolvedComments: !this.state.showingResolvedComments
      });
    }
  }, {
    key: 'cancelDraftClick',
    value: function cancelDraftClick() {
      this.setState(function () {
        return {
          showDraftComment: false
        };
      });
    }
  }]);
  return Comments;
}(_react.Component);

Comments.propTypes = {
  dispatch: _propTypes2.default.func,
  quest: _propTypes2.default.object.isRequired,
  resourceId: _propTypes2.default.number,
  activityId: _propTypes2.default.number,
  comments: _propTypes2.default.array,
  section: _propTypes2.default.string,
  user: _propTypes2.default.object,
  userDraftComments: _propTypes2.default.array,
  isEditingComment: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    section: state.quest.section,
    activityId: state.quest.activityId,
    quest: state.quest,
    resourceId: state.quest.section !== 'activities' ? state.quest.item.id : state.quest.activityId,
    comments: state.quest.section !== 'activities' ? state.quest.comments : state.quest.activityComments,
    user: state.user.user,
    userDraftComments: (0, _userdraftcomments.userDraftComments)(state),
    isEditingComment: state.quest.isEditingComment
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Comments);
exports.CommentsDisconnected = Comments; // pure component - used in tests

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PublishedComment = __webpack_require__(1502);

var _PublishedComment2 = _interopRequireDefault(_PublishedComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentsList = function (_Component) {
  (0, _inherits3.default)(CommentsList, _Component);

  function CommentsList() {
    (0, _classCallCheck3.default)(this, CommentsList);
    return (0, _possibleConstructorReturn3.default)(this, (CommentsList.__proto__ || (0, _getPrototypeOf2.default)(CommentsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(CommentsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          quest = _props.quest,
          section = _props.section,
          showingResolvedComments = _props.showingResolvedComments,
          dispatch = _props.dispatch;

      var comments = this.props.comments.map(function (comment, index) {
        // ** hack alert ** - really, really hate the random param but was stuck on the Comment component
        // not re-rendering when the comment.status property was updated when
        // re-opening or resolving comments
        return _react2.default.createElement(_PublishedComment2.default, {
          comment: comment,
          key: index,
          showingResolvedComments: showingResolvedComments,
          random: Math.random(),
          user: user,
          quest: quest,
          section: section,
          dispatch: dispatch
        });
      });

      return _react2.default.createElement(
        'ul',
        { className: 'comments-list' },
        comments
      );
    }
  }]);
  return CommentsList;
}(_react.Component);

exports.default = CommentsList;


CommentsList.propTypes = {
  comments: _propTypes2.default.array.isRequired,
  showingResolvedComments: _propTypes2.default.bool,
  user: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string.isRequired,
  dispatch: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _reactIntl = __webpack_require__(16);

var _oeWebCommon = __webpack_require__(117);

var _CommentLabelDropdown = __webpack_require__(683);

var _CommentLabelDropdown2 = _interopRequireDefault(_CommentLabelDropdown);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _comments = __webpack_require__(303);

var _commentlabels = __webpack_require__(684);

var _commentlabels2 = _interopRequireDefault(_commentlabels);

var _index = __webpack_require__(20);

var _quest = __webpack_require__(103);

var _messages = __webpack_require__(21);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublishedComment = function (_Component) {
  (0, _inherits3.default)(PublishedComment, _Component);

  function PublishedComment(props) {
    (0, _classCallCheck3.default)(this, PublishedComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublishedComment.__proto__ || (0, _getPrototypeOf2.default)(PublishedComment)).call(this, props));

    _this.state = {
      comment: props.comment.body,
      isEditing: false,
      isDirty: false
    };

    _this.onDeleteClickBound = _this.onDeleteClick.bind(_this);
    _this.onCancelClickBound = _this.onCancelClick.bind(_this);
    _this.onEditCommentClickBound = _this.onEditCommentClick.bind(_this);
    _this.onEditClickBound = _this.onEditClick.bind(_this);
    _this.resolveCommentBound = _this.resolveComment.bind(_this);
    _this.openCommentBound = _this.openComment.bind(_this);
    _this.hideModalBound = _this.hideModal.bind(_this);
    _this.onDeleteClickBound = _this.onDeleteClick.bind(_this);
    _this.onActualDeleteClickBound = _this.onActualDeleteClick.bind(_this);
    _this.handleCommentChangeBound = _this.handleCommentChange.bind(_this);
    _this.onLabelChangeBound = _this.onLabelChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PublishedComment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.comment.id !== nextProps.comment.id) {
        this.setState({
          isEditing: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          comment = _props.comment,
          user = _props.user;

      var edited = comment.updated_at !== comment.created_at;
      var cssClass = comment.status === 1 ? 'resolved' : 'open';

      if (this.props.showingResolvedComments) {
        cssClass += ' showanyway';
      }

      if (this.state.isEditing) {
        cssClass += ' isEditing';
      }

      var options = (0, _assign2.default)({}, _index.simpleMDEOptions);
      options.autofocus = true;
      options.initialValue = comment.body;

      return _react2.default.createElement(
        'div',
        { className: 'published-comment' },
        this.state.isEditing && _react2.default.createElement(
          'div',
          { className: 'comment-header' },
          _react2.default.createElement('div', { className: 'comment-icon edit' }),
          _react2.default.createElement(
            'div',
            { className: 'comment-header-text h4' },
            'Edit Comment'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: cssClass },
          _react2.default.createElement(
            'div',
            { className: 'shadow' },
            _react2.default.createElement(
              'div',
              { className: 'comment-body-header' },
              _react2.default.createElement(
                'div',
                { className: 'comment-user-photo' },
                comment.user.photo_url && _react2.default.createElement(
                  'div',
                  { className: 'user-photo-wrapper' },
                  _react2.default.createElement('img', { src: comment.user.photo_url })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'comment-user-info' },
                _react2.default.createElement(
                  _UserName2.default,
                  {
                    activeCertifications: comment.user.active_certifications,
                    userId: 'published-comment-' + comment.id + '-user-' + comment.user.id,
                    rebuild: true
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'comment-user-name' },
                    (0, _name.getUserDisplayName)(comment.user)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'commented-on', style: { marginLeft: '7px' } },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'Comment.CommentedOn',
                    defaultMessage: 'commented on'
                  })
                ),
                !this.state.isEditing && _react2.default.createElement(
                  'div',
                  { className: 'comment-label' },
                  comment.label
                ),
                this.state.isEditing && _react2.default.createElement(
                  'div',
                  { className: 'labels' },
                  _react2.default.createElement(_CommentLabelDropdown2.default, {
                    labels: _commentlabels2.default[this.props.section],
                    selectedValue: comment.label,
                    onChange: this.onLabelChangeBound,
                    type: 'Published'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'comment-date' },
                  _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
                    date: comment.updated_at,
                    includeTime: false
                  }),
                  ' at ',
                  _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: comment.updated_at }),
                  edited ? ' (edited)' : ''
                )
              ),
              comment.status === 1 && _react2.default.createElement(
                'div',
                { className: 'comment-resolve-action resolved' },
                _messages.resolved,
                '\xA0',
                _react2.default.createElement(
                  'div',
                  { className: 'pipechar' },
                  '|'
                ),
                ' ',
                _react2.default.createElement(
                  'div',
                  { className: 'reopen', onClick: this.openCommentBound },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'Comment.Reopen',
                    defaultMessage: 'Re-open'
                  })
                )
              ),
              comment.status !== 1 && _react2.default.createElement(
                'div',
                {
                  className: 'comment-resolve-action unresolved',
                  onClick: this.resolveCommentBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Comment.MarkResolved',
                  defaultMessage: 'Mark Resolved'
                })
              )
            ),
            !this.state.isEditing && _react2.default.createElement(_MarkdownLabel2.default, {
              additionalCssClasses: 'comment-body',
              value: comment.body
            }),
            this.state.isEditing && _react2.default.createElement(
              'div',
              { className: 'edit-comment-area' },
              _react2.default.createElement(_reactSimplemdeEditor2.default, {
                options: options,
                onChange: this.handleCommentChangeBound
              }),
              _react2.default.createElement(
                'div',
                { className: 'actions' },
                _react2.default.createElement(
                  'div',
                  {
                    className: this.state.isDirty && this.state.comment.length > 0 ? 'button save active btn-primary-small' : 'button disabled save btn-primary-small',
                    onClick: this.onEditCommentClickBound
                  },
                  'Post Changes'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'cancel-add', onClick: this.onCancelClickBound },
                  'Cancel'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'notification caption1' },
                'Posting your changes will notify the active quest authors and anyone else that has posted a comment on this section.'
              )
            ),
            !this.state.isEditing && comment.user.id === user.id && _react2.default.createElement(
              'div',
              { className: 'existing-comment-actions' },
              _react2.default.createElement('div', { className: 'edit', onClick: this.onEditClickBound }),
              _react2.default.createElement('div', { className: 'pipe' }),
              _react2.default.createElement('div', { className: 'trash', onClick: this.onDeleteClickBound })
            )
          ),
          _react2.default.createElement(_ModalComponent2.default, {
            ref: 'deleteCommentModal',
            klass: 'modal delete-comment-modal',
            modalId: 'commentDeleteModal',
            headingKlass: 'modal-heading h3',
            logoKlass: 'logo delete-comment',
            headingText: 'Delete comment?',
            bodyText: '',
            primaryButtonText: 'Yes, Delete',
            secondaryButtonText: 'Cancel',
            primaryButtonAction: this.onActualDeleteClickBound,
            secondaryButtonAction: this.hideModalBound
          })
        )
      );
    }
  }, {
    key: 'handleCommentChange',
    value: function handleCommentChange(val) {
      this.setState(function () {
        return {
          comment: val,
          isDirty: true
        };
      });
    }
  }, {
    key: 'onLabelChange',
    value: function onLabelChange() {
      this.setState({ isDirty: true });
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick() {
      this.refs.deleteCommentModal.refs.modal.show();
    }
  }, {
    key: 'onCancelClick',
    value: function onCancelClick() {
      this.setState(function () {
        return {
          isEditing: false,
          isDirty: false
        };
      });
      this.render();
    }
  }, {
    key: 'onEditClick',
    value: function onEditClick() {
      this.setState({ isEditing: true });
    }
  }, {
    key: 'onActualDeleteClick',
    value: function onActualDeleteClick() {
      var _props2 = this.props,
          comment = _props2.comment,
          dispatch = _props2.dispatch;

      dispatch((0, _comments.deleteComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id));
      this.hideModal();
    }
  }, {
    key: 'onEditCommentClick',
    value: function onEditCommentClick() {
      var _props3 = this.props,
          comment = _props3.comment,
          dispatch = _props3.dispatch;

      var labels = document.getElementById('commentLabelPublished');
      var selectedLabel = labels.options[labels.selectedIndex].value;
      dispatch((0, _comments.editComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id, this.state.comment, selectedLabel));
      this.setState({ isEditing: false });
    }
  }, {
    key: 'resolveComment',
    value: function resolveComment() {
      var _props4 = this.props,
          comment = _props4.comment,
          dispatch = _props4.dispatch;

      dispatch((0, _comments.resolveComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id));
    }
  }, {
    key: 'openComment',
    value: function openComment() {
      var _props5 = this.props,
          comment = _props5.comment,
          dispatch = _props5.dispatch;

      dispatch((0, _comments.openComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id));
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.refs.deleteCommentModal.refs.modal.hide();
    }
  }]);
  return PublishedComment;
}(_react.Component);

exports.default = PublishedComment;


PublishedComment.propTypes = {
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object,
  comment: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  showingResolvedComments: _propTypes2.default.bool,
  section: _propTypes2.default.string
};

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _oeWebCommon = __webpack_require__(117);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _CommentLabelDropdown = __webpack_require__(683);

var _CommentLabelDropdown2 = _interopRequireDefault(_CommentLabelDropdown);

var _commentlabels = __webpack_require__(684);

var _commentlabels2 = _interopRequireDefault(_commentlabels);

var _comments = __webpack_require__(303);

var _index = __webpack_require__(20);

var _quest = __webpack_require__(103);

var _name = __webpack_require__(149);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DraftComment = function (_Component) {
  (0, _inherits3.default)(DraftComment, _Component);

  function DraftComment(props) {
    (0, _classCallCheck3.default)(this, DraftComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DraftComment.__proto__ || (0, _getPrototypeOf2.default)(DraftComment)).call(this, props));

    _this.state = {
      comment: props.comment ? props.comment.body : '',
      isDirty: false,
      savedData: props.comment && props.comment.id ? true : false,
      id: props.comment ? props.comment.id : null
    };

    _this.onDeleteClickBound = _this.onDeleteClick.bind(_this);
    _this.hideModalBound = _this.hideModal.bind(_this);
    _this.onActualDeleteClickBound = _this.onActualDeleteClick.bind(_this);
    _this.handleCommentChangeBound = _this.handleCommentChange.bind(_this);
    _this.onLabelChangeBound = _this.onLabelChange.bind(_this);
    _this.saveDraftCommentBound = _this.saveDraftComment.bind(_this);
    _this.onPublishCommentClickBound = _this.onPublishCommentClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DraftComment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.comment.body !== this.props.comment.body || nextProps.comment.id !== this.props.comment.id || nextProps.section !== this.props.section) {
        this.setState(function () {
          return {
            comment: nextProps.comment ? nextProps.comment.body : '',
            id: nextProps.comment ? nextProps.comment.id : null,
            isDirty: false,
            savedData: nextProps.comment && nextProps.comment.id ? true : false
          };
        });
      }
    }

    // To address wonky autoscroll happening when navigating to a quest with a draft comment in basic info

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.isNewDraft) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          comment = _props.comment,
          user = _props.user;


      if (!comment) {
        return null;
      } else {
        var options = (0, _assign2.default)({}, _index.simpleMDEOptions);
        options.autofocus = this.props.isNewDraft;
        options.placeholder = 'Type your comment here.';

        return _react2.default.createElement(
          'li',
          { className: 'draft-comment' },
          _react2.default.createElement(
            'div',
            { className: 'comment-header' },
            _react2.default.createElement('div', { className: 'comment-icon draft' }),
            _react2.default.createElement(
              'div',
              { className: 'comment-header-text h4' },
              'Draft Comment' + (this.state.savedData && !this.state.isDirty ? ' (Saved)' : '')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'shadow' },
            _react2.default.createElement(
              'div',
              { className: 'comment-body-header' },
              _react2.default.createElement(
                'div',
                { className: 'comment-user-photo' },
                _react2.default.createElement(
                  'div',
                  { className: 'user-photo-wrapper' },
                  _react2.default.createElement('img', { src: user.photo.url })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'comment-user-info' },
                _react2.default.createElement(
                  _UserName2.default,
                  {
                    activeCertifications: user.active_certifications,
                    userId: 'draft-comment-' + user.id,
                    rebuild: true
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'comment-user-name' },
                    (0, _name.getUserDisplayName)(user)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'commented-on', style: { marginLeft: '7px' } },
                  'comment on'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'labels' },
                  _react2.default.createElement(_CommentLabelDropdown2.default, {
                    labels: _commentlabels2.default[this.props.section],
                    selectedValue: comment.label,
                    onChange: this.onLabelChangeBound,
                    type: 'Draft'
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'edit-comment-area' },
              _react2.default.createElement(_reactSimplemdeEditor2.default, {
                key: this.state.id,
                value: this.state.comment,
                options: options,
                onChange: this.handleCommentChangeBound
              }),
              _react2.default.createElement(
                'div',
                { className: 'actions' },
                _react2.default.createElement(
                  'div',
                  {
                    className: this.state.comment.trim().length === 0 ? 'button save disabled btn-primary-small' : 'button btn-primary-small save',
                    onClick: this.onPublishCommentClickBound
                  },
                  'Post Comment'
                ),
                _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: this.saveDraftCommentBound,
                      className: !this.state.isDirty || this.state.comment.trim().length === 0 ? 'btn-secondary-small button disabled save-draft' : 'button btn-secondary-small save-draft'
                    },
                    'Save Draft'
                  ),
                  this.state.savedData && _react2.default.createElement(
                    'div',
                    { className: 'save-state-container caption1' },
                    this.state.isDirty ? 'Unsaved changes' : _react2.default.createElement(
                      'span',
                      null,
                      'Last saved ',
                      _react2.default.createElement(_oeWebCommon.OEComponents.ElapsedTimeFormatter, {
                        time: comment.updated_at
                      })
                    )
                  ),
                  _react2.default.createElement('div', {
                    className: 'trash delete-draft-comment',
                    onClick: this.onDeleteClickBound
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'caption1 notification' },
                'Posting your comment will notify the active quest authors and anyone else that has posted a comment on this section. Saving your comment allows you to finish your comment later. Only you can see your saved comments.'
              )
            )
          ),
          _react2.default.createElement(_ModalComponent2.default, {
            ref: 'deleteCommentModal',
            klass: 'modal delete-comment-modal',
            modalId: 'commentDeleteModal',
            headingKlass: 'modal-heading h3',
            logoKlass: 'logo delete-comment',
            headingText: 'Delete comment?',
            bodyText: '',
            primaryButtonText: 'Yes, Delete',
            secondaryButtonText: 'Cancel',
            primaryButtonAction: this.onActualDeleteClickBound,
            secondaryButtonAction: this.hideModalBound
          })
        );
      }
    }
  }, {
    key: 'handleCommentChange',
    value: function handleCommentChange(val) {
      this.setState(function () {
        return {
          comment: val,
          isDirty: true
        };
      });

      this.props.dispatch((0, _comments.isEditingComment)());
    }
  }, {
    key: 'onLabelChange',
    value: function onLabelChange() {
      this.setState({ isDirty: true });
      this.props.dispatch((0, _comments.isEditingComment)());
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick() {
      var comment = this.props.comment;

      if (!comment.id && this.state.comment.trim().length === 0) {
        this.props.cancelDraftClick();
        this.props.dispatch((0, _comments.isNotEditingComment)());
      } else {
        this.refs.deleteCommentModal.refs.modal.show();
      }
    }
  }, {
    key: 'onActualDeleteClick',
    value: function onActualDeleteClick() {
      var _props2 = this.props,
          comment = _props2.comment,
          dispatch = _props2.dispatch;

      if (comment.id) {
        dispatch((0, _comments.deleteComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id, 'draft'));
      } else {
        this.props.dispatch((0, _comments.isNotEditingComment)());
      }
      this.hideModal();
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.refs.deleteCommentModal.refs.modal.hide();
    }
  }, {
    key: 'saveDraftComment',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props3, comment, dispatch, labels, selectedLabel;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props3 = this.props, comment = _props3.comment, dispatch = _props3.dispatch;
                labels = document.getElementById('commentLabelDraft');
                selectedLabel = labels.options[labels.selectedIndex].value;

                if (!this.props.comment.id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return dispatch((0, _comments.editComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id, this.state.comment, selectedLabel, 'draft'));

              case 6:
                _context.next = 10;
                break;

              case 8:
                _context.next = 10;
                return dispatch((0, _comments.postComment)(this.props.resourceId, this.props.section, selectedLabel, this.state.comment));

              case 10:

                this.setState(function () {
                  return {
                    savedData: true,
                    isDirty: false
                  };
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveDraftComment() {
        return _ref.apply(this, arguments);
      }

      return saveDraftComment;
    }()
  }, {
    key: 'onPublishCommentClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _props4, comment, dispatch, labels, selectedLabel;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props4 = this.props, comment = _props4.comment, dispatch = _props4.dispatch;
                labels = document.getElementById('commentLabelDraft');
                selectedLabel = labels.options[labels.selectedIndex].value;

                if (!this.props.comment.id) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return dispatch((0, _comments.editComment)(comment.resource_id, (0, _quest.getCommentResourceType)(comment), comment.id, this.state.comment, selectedLabel, 'draft', true));

              case 6:

                this.setState(function () {
                  return {
                    isDirty: false,
                    savedData: true
                  };
                });
                _context2.next = 10;
                break;

              case 9:
                dispatch((0, _comments.postComment)(this.props.resourceId, this.props.section, selectedLabel, this.state.comment, true));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onPublishCommentClick() {
        return _ref2.apply(this, arguments);
      }

      return onPublishCommentClick;
    }()
  }]);
  return DraftComment;
}(_react.Component);

exports.default = DraftComment;


DraftComment.propTypes = {
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object,
  comment: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string,
  resourceId: _propTypes2.default.number,
  cancelDraftClick: _propTypes2.default.func.isRequired,
  isNewDraft: _propTypes2.default.bool
};

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDraftComments = undefined;

var _reselect = __webpack_require__(168);

var _userDraftComments = function _userDraftComments(state) {
  if (state.quest.section === 'activities') {
    return state.quest.userActivityComments.filter(function (c) {
      return c.resource_id === state.quest.activityId;
    });
  } else {
    return state.quest.userComments.filter(function (c) {
      return c.section === state.quest.section;
    });
  }
};

var userDraftComments = exports.userDraftComments = (0, _reselect.createSelector)([_userDraftComments], function (comments) {
  return comments;
});

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _ImageEditor = __webpack_require__(1506);

var _ImageEditor2 = _interopRequireDefault(_ImageEditor);

var _index = __webpack_require__(20);

var _quest = __webpack_require__(66);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Images = function (_Component) {
  (0, _inherits3.default)(Images, _Component);

  function Images(props) {
    (0, _classCallCheck3.default)(this, Images);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Images.__proto__ || (0, _getPrototypeOf2.default)(Images)).call(this, props));

    _this.state = {
      questImage: props.quest.icon_image_url || '',
      questImageSource: props.quest.icon_image_license_properties.source_url || ''
    };
    _this.onRemoveIconImageClickBound = _this.onRemoveIconImageClick.bind(_this);
    _this.onSaveIconImageClickBound = _this.onSaveIconImageClick.bind(_this);
    _this.onSaveImageSourceClickBound = _this.onSaveImageSourceClick.bind(_this);
    _this.handleIconImageSourceChangeBound = _this.handleIconImageSourceChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Images, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var quest = this.props.quest;


      if (quest.icon_image_url && prevProps.quest.icon_image_url !== quest.icon_image_url) {
        var _el = document.querySelector('.icon-saved');
        _el.classList.add('active');
        setTimeout(function () {
          _el.classList.remove('active');
        }, 3800);
      }

      if (quest.icon_image_url && prevProps.quest.icon_image_license_properties.source_url !== quest.icon_image_license_properties.source_url) {
        var _el2 = document.querySelector('.icon-url-saved');
        _el2.classList.add('active');
        setTimeout(function () {
          _el2.classList.remove('active');
        }, 3800);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          allowEdit = _props.allowEdit;

      var questImageName = (0, _index.getImageNameFromUrl)(quest.icon_image_original_file_name);

      return _react2.default.createElement(
        'div',
        { className: 'images' },
        _react2.default.createElement(
          'div',
          { className: 'quest-image' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.Images.QuestIcon',
                defaultMessage: 'Quest Icon'
              }),
              _react2.default.createElement('div', { className: 'requiredtool' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'subtitle' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.Images.ForBestViewingImage',
                defaultMessage: 'For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                className: !quest.icon_image_url ? 'quest-image' : 'quest-image loaded'
              },
              allowEdit && _react2.default.createElement(
                'div',
                { className: 'addmode' },
                _react2.default.createElement(
                  'div',
                  { className: 'cropper-wrapper icon' },
                  _react2.default.createElement(_ImageEditor2.default, {
                    height: 200,
                    width: 200,
                    borderRadius: 100,
                    handleSaveImage: this.onSaveIconImageClickBound
                  })
                )
              ),
              _react2.default.createElement(
                'label',
                { className: 'image-name' },
                questImageName
              ),
              _react2.default.createElement('img', { id: 'icon', src: quest.icon_image_url }),
              allowEdit && _react2.default.createElement(
                'div',
                { className: 'saved-remove-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'button icon-saved saved' },
                  _messages.saved
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button remove-icon btn-destructive-small ' + (quest.icon_image_url ? 'show' : ''),
                    onClick: this.onRemoveIconImageClickBound
                  },
                  _messages.remove
                )
              ),
              allowEdit && quest.icon_image_url && _react2.default.createElement(
                'div',
                { className: 'source-url-wrapper active' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.sourceOfTheImage
                ),
                _react2.default.createElement('input', {
                  type: 'text',
                  id: 'iconSourceUrl',
                  className: 'copyright-url form-control',
                  defaultValue: quest.icon_image_license_properties.source_url,
                  placeholder: 'http://',
                  onChange: this.handleIconImageSourceChangeBound,
                  accept: 'image/*'
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'button icon-url-saved saved' },
                  _messages.saved
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button save btn-primary-small ' + (this.shouldSaveBeDisabled() ? 'disabled' : ''),
                    id: 'iconSourceSave',
                    onClick: this.onSaveImageSourceClickBound
                  },
                  _messages.save
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'onRemoveIconImageClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _quest.removeIconImage)());

              case 2:
                this.setState(function () {
                  return {
                    questImage: '',
                    questImageSource: ''
                  };
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onRemoveIconImageClick() {
        return _ref.apply(this, arguments);
      }

      return onRemoveIconImageClick;
    }()
  }, {
    key: 'onSaveIconImageClick',
    value: function onSaveIconImageClick(fileName, fileURL) {
      this.props.dispatch((0, _quest.uploadImage)('icon', fileURL, fileName));
    }
  }, {
    key: 'onSaveImageSourceClick',
    value: function onSaveImageSourceClick(e) {
      this.props.dispatch((0, _quest.updateQuestImageSource)(this.state.questImageSource));
    }
  }, {
    key: 'handleIconImageSourceChange',
    value: function handleIconImageSourceChange(e) {
      this.setState({ questImageSource: e.target.value });
    }
  }, {
    key: 'shouldSaveBeDisabled',
    value: function shouldSaveBeDisabled() {
      var questImageSource = this.state.questImageSource;
      var quest = this.props.quest;


      return this.props.isSavingQuest || (quest.icon_image_license_properties.source_url === questImageSource || (0, _keys2.default)(quest.icon_image_license_properties).length === 0) && questImageSource.length === 0;
    }
  }]);
  return Images;
}(_react.Component);

exports.default = Images;


Images.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  allowEdit: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func.isRequired,
  isSavingQuest: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAvatarEditor = __webpack_require__(598);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageEditor = function (_Component) {
  (0, _inherits3.default)(ImageEditor, _Component);

  function ImageEditor(props) {
    (0, _classCallCheck3.default)(this, ImageEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImageEditor.__proto__ || (0, _getPrototypeOf2.default)(ImageEditor)).call(this, props));

    _this.state = {
      fileUrl: '',
      fileName: '',
      scale: 1
    };
    _this.setEditorRefBound = _this.setEditorRef.bind(_this);
    _this.onFileLoadBound = _this.onFileLoad.bind(_this);
    _this.onZoomChangeBound = _this.onZoom.bind(_this);
    _this.handleCancelImageBound = _this.handleCancelImage.bind(_this);
    _this.handleSaveImageBound = _this.handleSaveImage.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ImageEditor, [{
    key: 'setEditorRef',
    value: function setEditorRef(editor) {
      if (editor) this.editor = editor;
    }
  }, {
    key: 'onFileLoad',
    value: function onFileLoad(e) {
      var _this2 = this;

      var reader = new FileReader();
      var fileName = e.target.value.replace(/^.*[\\\/]/, '');
      reader.onload = function (e) {
        _this2.setState({
          fileUrl: e.target.result,
          fileName: fileName
        });
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  }, {
    key: 'onZoom',
    value: function onZoom(e) {
      this.setState({
        scale: e.target.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', {
          className: 'file-input',
          type: 'file',
          onChange: this.onFileLoadBound,
          ref: 'fileUpload'
        }),
        this.state.fileUrl && _react2.default.createElement(
          'div',
          { className: 'image-editor-wrapper' },
          _react2.default.createElement(_reactAvatarEditor2.default, {
            ref: this.setEditorRefBound,
            image: this.state.fileUrl,
            width: this.props.width,
            height: this.props.height,
            borderRadius: this.props.borderRadius,
            border: 0,
            scale: this.state.scale
          }),
          _react2.default.createElement('input', {
            className: 'zoom-slider',
            type: 'range',
            step: '0.01',
            min: '1',
            max: '2',
            name: 'scale',
            defaultValue: '1',
            onChange: this.onZoomChangeBound,
            style: { width: this.props.width }
          }),
          _react2.default.createElement(
            'div',
            { id: 'iconSaveOptions', className: 'active' },
            _react2.default.createElement(
              'div',
              {
                className: 'button btn-primary-small',
                onClick: this.handleSaveImageBound
              },
              'Save'
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'button btn-secondary-small',
                onClick: this.handleCancelImageBound
              },
              'Cancel'
            )
          )
        )
      );
    }
  }, {
    key: 'handleSaveImage',
    value: function handleSaveImage(e) {
      // If you want the image resized to the canvas size (also a HTMLCanvasElement)
      var canvasScaled = this.editor.getImageScaledToCanvas();
      var fileURL = canvasScaled.toDataURL();
      this.props.handleSaveImage(this.state.fileName, fileURL);
      this.setState({
        fileUrl: '',
        fileName: '',
        scale: 1
      });
      this.refs.fileUpload.value = '';
    }
  }, {
    key: 'handleCancelImage',
    value: function handleCancelImage() {
      this.setState({
        fileUrl: '',
        fileName: '',
        scale: 1
      });
      this.refs.fileUpload.value = '';
    }
  }]);
  return ImageEditor;
}(_react.Component);

exports.default = ImageEditor;


ImageEditor.propTypes = {
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  borderRadius: _propTypes2.default.number,
  handleSaveImage: _propTypes2.default.func

  // https://github.com/mosch/react-avatar-editor

};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoActivities = function (_Component) {
  (0, _inherits3.default)(NoActivities, _Component);

  function NoActivities(props) {
    (0, _classCallCheck3.default)(this, NoActivities);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NoActivities.__proto__ || (0, _getPrototypeOf2.default)(NoActivities)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  // Don't love this, but because NoActivies / Activities Menu Label aren't part of the
  // activity component nor activity menu component, need to rig up this menu highlighting separately


  (0, _createClass3.default)(NoActivities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.getElementById('activitiesMenuItem').classList += 'active';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementById('activitiesMenuItem').classList = '';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'no-activities' },
        this.props.allowEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'add-activity', onClick: this.onClickBound },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.NoActivities.AddFirstActivity',
              defaultMessage: 'add the first activity'
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            _messages.atLeastTwoActivities
          )
        ),
        !this.props.allowEdit && _react2.default.createElement(
          'p',
          null,
          _messages.atLeastTwoActivities
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.id + '/activities/add'));
    }
  }]);
  return NoActivities;
}(_react.Component);

exports.default = NoActivities;


NoActivities.propTypes = {
  dispatch: _propTypes2.default.func,
  quest: _propTypes2.default.object,
  allowEdit: _propTypes2.default.bool
};

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _index = __webpack_require__(20);

var _tags = __webpack_require__(300);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherInformation = function (_Component) {
  (0, _inherits3.default)(OtherInformation, _Component);

  function OtherInformation(props) {
    (0, _classCallCheck3.default)(this, OtherInformation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OtherInformation.__proto__ || (0, _getPrototypeOf2.default)(OtherInformation)).call(this, props));

    _this.handleUnusualMaterialsChangeBound = _this.handleUnusualMaterialsChange.bind(_this);
    _this.handleTagChangeBound = _this.handleTagChange.bind(_this);
    _this.handleInspirationAndUnusualCreditsChangeBound = _this.handleInspirationAndUnusualCreditsChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(OtherInformation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // make sure we're getting the newest list of tags when section is mounted
      this.props.dispatch((0, _tags.fetchTags)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // TODO: Not the optimal solution, but if any of the quest tags are updated, refetch the tags
      // will ensure we're getting the latest list including any potentially newly added tags.
      // Ultimately, I'd rather fetch only if we know a new tag was created.
      if (this.props.quest.tags !== nextProps.quest.tags) {
        this.props.dispatch((0, _tags.fetchTags)());
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          isEditingQuest = _props.isEditingQuest;


      var unusualMaterialsOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      unusualMaterialsOptions.initialValue = quest.unusual_materials;
      unusualMaterialsOptions.placeholder = '';
      unusualMaterialsOptions.autofocus = false;

      var inspirationAndAdditionalCreditsOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      inspirationAndAdditionalCreditsOptions.initialValue = quest.inspiration_and_additional_credits;
      inspirationAndAdditionalCreditsOptions.placeholder = '';
      inspirationAndAdditionalCreditsOptions.autofocus = false;

      return _react2.default.createElement(
        'div',
        { className: 'basic-information' },
        _react2.default.createElement(
          'div',
          { className: 'section-inner' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.OtherInformation.UnusualMaterials',
              defaultMessage: 'Unusual Materials'
            })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields' },
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              id: 'unusual_materials',
              options: unusualMaterialsOptions,
              onChange: this.handleUnusualMaterialsChangeBound
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            _react2.default.createElement(_MarkdownLabel2.default, {
              id: 'view-unusual_materials',
              value: quest.unusual_materials
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.tags,
            _react2.default.createElement('div', { className: 'requiredtool' })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields' },
            _react2.default.createElement(_SearchArea2.default, {
              dispatch: this.props.dispatch,
              area: 'tags',
              placeholder: 'Select tags',
              values: this.formatTagsArray(quest.tags),
              options: (0, _arraySort2.default)(this.mapList(this.props.tags), ['sort']),
              handleChange: this.handleTagChangeBound,
              tagEdit: true
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            !quest.tags || quest.tags === '' ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
              'label',
              { id: 'view-tags', className: '' },
              quest.tags
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.OtherInformation.InspirationAndAdditionalCredits',
              defaultMessage: 'Inspiration And Additional Credits'
            })
          ),
          isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'edit-fields' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.OtherInformation.MentionPeople',
                defaultMessage: 'Mention people or materials that have inspired this quest that you want to give credit to.'
              })
            ),
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              id: 'inspiration_and_additional_credits',
              options: inspirationAndAdditionalCreditsOptions,
              onChange: this.handleInspirationAndUnusualCreditsChangeBound
            })
          ),
          !isEditingQuest && _react2.default.createElement(
            'div',
            { className: 'view-fields' },
            _react2.default.createElement(_MarkdownLabel2.default, {
              id: 'view-inspiration_and_additional_credits',
              value: quest.inspiration_and_additional_credits
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'title' },
              _messages.copyrightHolder
            ),
            _react2.default.createElement(
              'label',
              null,
              quest.organization.name
            ),
            _react2.default.createElement('input', {
              type: 'hidden',
              id: 'copyrightHolder',
              value: quest.organization.name
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'creative-commons-section' },
            _react2.default.createElement(
              'div',
              { className: 'title ilb' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.OtherInformation.CreativeCommonsLicense',
                defaultMessage: 'CREATIVE COMMONS LICENSE'
              })
            ),
            _react2.default.createElement(
              'a',
              {
                className: 'ilb creative-commons-header',
                target: '_blank',
                href: 'http://creativecommons.org/licenses/'
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.OtherInformation.CreativeCommonsWebsite',
                defaultMessage: 'Creative Commons Website'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'view-fields' },
              _react2.default.createElement(
                'div',
                { className: 'license-version' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'Quest.OtherInformation.LicenseAndVersion',
                    defaultMessage: 'License and Version'
                  })
                ),
                _react2.default.createElement(
                  'label',
                  { className: 'license-display' },
                  quest.license ? quest.license.name : 'This will be automatically generated.',
                  ' ',
                  quest.license ? ', Version: ' + quest.license.version : ''
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleUnusualMaterialsChange',
    value: function handleUnusualMaterialsChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'unusual_materials';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'formatTagsArray',
    value: function formatTagsArray(tagsString) {
      var tags = this.props.tags;

      var tagsArray = [];
      tagsString.split(', ').forEach(function (t) {
        tags.find(function (tag) {
          if (tag.name === t) {
            tagsArray.push({
              value: tag.id,
              label: tag.name,
              sort: tag.name.trim().toLowerCase()
            });
          }
        });
      });
      return tagsArray;
    }
  }, {
    key: 'handleTagChange',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(values) {
        var event, tagsString;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Hacky way to format the event id and value so parent's edit function works
                event = {
                  target: {}
                };

                event.target.id = 'questtag_list';
                tagsString = values.map(function (t) {
                  return t.label;
                }).join();

                event.target.value = tagsString;

                _context.next = 6;
                return this.props.handleChange(event);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleTagChange(_x) {
        return _ref.apply(this, arguments);
      }

      return handleTagChange;
    }()
  }, {
    key: 'handleInspirationAndUnusualCreditsChange',
    value: function handleInspirationAndUnusualCreditsChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'inspiration_and_additional_credits';
      event.target.value = e;
      this.props.handleChange(event);
    }
  }]);
  return OtherInformation;
}(_react.Component);

exports.default = OtherInformation;


OtherInformation.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  isEditingQuest: _propTypes2.default.bool.isRequired,
  handleChange: _propTypes2.default.func,
  dispatch: _propTypes2.default.func,
  tags: _propTypes2.default.array
};

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestHistoryDisconnected = exports.mapStateToProps = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _quest = __webpack_require__(66);

var _HistoryList = __webpack_require__(1510);

var _HistoryList2 = _interopRequireDefault(_HistoryList);

var _logging = __webpack_require__(137);

var _logging2 = __webpack_require__(688);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestHistory = function (_React$Component) {
  (0, _inherits3.default)(QuestHistory, _React$Component);

  function QuestHistory() {
    (0, _classCallCheck3.default)(this, QuestHistory);
    return (0, _possibleConstructorReturn3.default)(this, (QuestHistory.__proto__ || (0, _getPrototypeOf2.default)(QuestHistory)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestHistory, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var quest = this.props.quest;

      this.props.dispatch((0, _quest.fetchQuestHistory)(1, true));
      var loggingData = (0, _logging2.getQuestEventLoggingData)(quest);
      var data = (0, _assign2.default)({}, loggingData, {
        action: 'view_history'
      });
      this.props.dispatch((0, _logging.postLoggingInfo)('quest', data));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _quest.clearQuestHistory)());
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.isFetchingQuestHistory && this.props.quest_events.length === 0) {
        return _react2.default.createElement('div', { className: 'loading' });
      }
      return _react2.default.createElement(_HistoryList2.default, {
        events: this.props.quest_events,
        dispatch: this.props.dispatch,
        page: this.props.page,
        total: this.props.total,
        isFetchingQuestHistory: this.props.isFetchingQuestHistory,
        quest: this.props.quest
      });
    }
  }]);
  return QuestHistory;
}(_react2.default.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    quest_events: state.quest.quest_events,
    page: state.quest.historyPage,
    total: state.quest.historyTotal,
    isFetchingQuestHistory: state.quest.isFetchingQuestHistory,
    quest: state.quest.item
  };
};

QuestHistory.propTypes = {
  quest_events: _propTypes2.default.array.isRequired,
  page: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  isFetchingQuestHistory: _propTypes2.default.bool.isRequired,
  quest: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuestHistory);
exports.QuestHistoryDisconnected = QuestHistory;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  li:nth-child(even) {\n    background: #ffffff;\n  }\n\n  li:nth-child(odd) {\n    background: #f8f8f8;\n  }\n\n  li.history-item {\n    &:last-child .history-dots {\n      display: none;\n    }\n  }\n'], ['\n  li:nth-child(even) {\n    background: #ffffff;\n  }\n\n  li:nth-child(odd) {\n    background: #f8f8f8;\n  }\n\n  li.history-item {\n    &:last-child .history-dots {\n      display: none;\n    }\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: #f8f8f8;\n  padding: 17px 35px;\n'], ['\n  background: #f8f8f8;\n  padding: 17px 35px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _HistoryItem = __webpack_require__(1511);

var _HistoryItem2 = _interopRequireDefault(_HistoryItem);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _quest = __webpack_require__(66);

var _questhistory = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledHistoryList = _styledComponents2.default.ul.withConfig({
  displayName: 'HistoryList__StyledHistoryList',
  componentId: 't50s34-0'
})(_templateObject);

var NoQuestHistory = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'HistoryList__NoQuestHistory',
  componentId: 't50s34-1'
})(_templateObject2);

var HistoryList = function (_React$Component) {
  (0, _inherits3.default)(HistoryList, _React$Component);

  function HistoryList() {
    (0, _classCallCheck3.default)(this, HistoryList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HistoryList.__proto__ || (0, _getPrototypeOf2.default)(HistoryList)).call(this));

    _this.loadMoreEventsBound = _this.loadMoreEvents.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(HistoryList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          events = _props.events,
          quest = _props.quest;

      var createdBeforeHistoryLogStart = quest.created_at < (0, _moment2.default)('2018-09-11').unix();
      var items = events.length > 0 ? events.map(function (event) {
        return _react2.default.createElement(_HistoryItem2.default, {
          event: event,
          dispatch: _this2.props.dispatch,
          quest: quest,
          hideItem: (0, _questhistory.shouldHideHistoryEvent)(event)
        });
      }) : _react2.default.createElement(
        NoQuestHistory,
        null,
        'Quest History not available prior to 11 September 2018'
      );

      // add "no history prior to..." if quest created before logging start date
      if (events.length > 0 && createdBeforeHistoryLogStart && this.props.total === events.length) {
        items = items.concat(_react2.default.createElement(
          'li',
          { style: { marginBottom: '0', height: '50px' } },
          _react2.default.createElement(
            NoQuestHistory,
            {
              style: { background: 'inherit', padding: '17px 35px 0' }
            },
            'Quest History not available prior to 11 September 2018'
          )
        ));
      }

      return _react2.default.createElement(
        StyledHistoryList,
        null,
        _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
          items: items,
          loadingMore: this.props.isFetchingQuestHistory,
          loadMore: this.loadMoreEventsBound,
          elementIsScrollable: false,
          showLoader: false,
          threshold: 10
        })
      );
    }
  }, {
    key: 'loadMoreEvents',
    value: function loadMoreEvents() {
      // Only load more history events if the size of the history event
      // list is less than the total count from the search call
      if (this.props.events.length < this.props.total) {
        this.props.dispatch((0, _quest.fetchQuestHistory)(this.props.page + 1));
      }
    }
  }]);
  return HistoryList;
}(_react2.default.Component);

HistoryList.propTypes = {
  events: _propTypes2.default.array.isRequired,
  page: _propTypes2.default.number.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  total: _propTypes2.default.number.isRequired,
  isFetchingQuestHistory: _propTypes2.default.bool.isRequired,
  quest: _propTypes2.default.object.isRequired
};

exports.default = HistoryList;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n  margin-bottom: 0 !important;\n  display: flex;\n  flex-direction: column;\n  pointer-events: ', ';\n  cursor: ', ';\n  border-top: ', ';\n  border-bottom: ', ';\n\n  &:hover {\n    border-top: 1px solid #dedfe0;\n    border-bottom: 1px solid #dedfe0;\n  }\n'], ['\n  height: 100%;\n  margin-bottom: 0 !important;\n  display: flex;\n  flex-direction: column;\n  pointer-events: ', ';\n  cursor: ', ';\n  border-top: ', ';\n  border-bottom: ', ';\n\n  &:hover {\n    border-top: 1px solid #dedfe0;\n    border-bottom: 1px solid #dedfe0;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  padding: 0 39px 0 23px !important;\n'], ['\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  padding: 0 39px 0 23px !important;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  width: 15px;\n  height: 9px;\n  transform: ', ';\n  margin-left: 15px;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  width: 15px;\n  height: 9px;\n  transform: ', ';\n  margin-left: 15px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 20px;\n  width: 2px;\n  position: absolute;\n  left: 33px;\n  bottom: -10px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 20px;\n  width: 2px;\n  position: absolute;\n  left: 33px;\n  bottom: -10px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QualityReviewInfo = __webpack_require__(1512);

var _QualityReviewInfo2 = _interopRequireDefault(_QualityReviewInfo);

var _CobaltHyperlink = __webpack_require__(667);

var _CobaltHyperlink2 = _interopRequireDefault(_CobaltHyperlink);

var _icon_collapse = __webpack_require__(1533);

var _icon_collapse2 = _interopRequireDefault(_icon_collapse);

var _TimestampVersion = __webpack_require__(686);

var _TimestampVersion2 = _interopRequireDefault(_TimestampVersion);

var _history_dots = __webpack_require__(1534);

var _history_dots2 = _interopRequireDefault(_history_dots);

var _ActivityEditEventsList = __webpack_require__(1535);

var _ActivityEditEventsList2 = _interopRequireDefault(_ActivityEditEventsList);

var _logging = __webpack_require__(137);

var _logging2 = __webpack_require__(688);

var _questhistory = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledHistoryItem = _styledComponents2.default.li.withConfig({
  displayName: 'HistoryItem__StyledHistoryItem',
  componentId: 'sc-17sam6c-0'
})(_templateObject, function (props) {
  return props.hasMore ? 'auto' : 'none';
}, function (props) {
  return props.hasMore ? 'pointer' : 'none';
}, function (props) {
  return props.expanded ? '1px solid #DEDFE0' : 'none';
}, function (props) {
  return props.expanded ? '1px solid #DEDFE0' : 'none';
});

var IconTextWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HistoryItem__IconTextWrapper',
  componentId: 'sc-17sam6c-1'
})(_templateObject2);

var HistoryItemTop = _styledComponents2.default.div.withConfig({
  displayName: 'HistoryItem__HistoryItemTop',
  componentId: 'sc-17sam6c-2'
})(_templateObject3);

var ExpandCollapseIcon = _styledComponents2.default.div.withConfig({
  displayName: 'HistoryItem__ExpandCollapseIcon',
  componentId: 'sc-17sam6c-3'
})(_templateObject4, _icon_collapse2.default, function (props) {
  return props.expanded ? 'rotate(0deg)' : 'rotate(180deg)';
});

var HistoryDotsIcon = _styledComponents2.default.div.withConfig({
  displayName: 'HistoryItem__HistoryDotsIcon',
  componentId: 'sc-17sam6c-4'
})(_templateObject5, _history_dots2.default);

var HistoryItem = function (_React$Component) {
  (0, _inherits3.default)(HistoryItem, _React$Component);

  function HistoryItem() {
    (0, _classCallCheck3.default)(this, HistoryItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HistoryItem.__proto__ || (0, _getPrototypeOf2.default)(HistoryItem)).call(this));

    _this.state = {
      hovered: false,
      expanded: false
    };

    _this.onHoverBound = _this.onHover.bind(_this);
    _this.onLeaveHoverBound = _this.onLeaveHover.bind(_this);
    _this.onToggleExpandClickBound = _this.onToggleExpandClick.bind(_this);
    _this.ref = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(HistoryItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var event = this.props.event;
      var expanded = this.state.expanded;

      var hasMore = (0, _questhistory.eventExpandable)(event);

      if (this.props.hideItem) {
        return null;
      }
      return _react2.default.createElement(
        StyledHistoryItem,
        {
          onMouseEnter: this.onHoverBound,
          onMouseLeave: this.onLeaveHoverBound,
          onClick: function onClick() {
            return _this2.onToggleExpandClick(hasMore);
          },
          hasMore: hasMore,
          expanded: expanded,
          className: 'history-item',
          innerRef: this.ref
        },
        _react2.default.createElement(
          HistoryItemTop,
          null,
          _react2.default.createElement(
            IconTextWrapper,
            null,
            (0, _questhistory.getHistoryEventText)(event)
          ),
          hasMore && (this.state.hovered || expanded) ? _react2.default.createElement(
            _CobaltHyperlink2.default,
            { style: { display: 'flex', alignItems: 'center' } },
            (expanded ? 'Hide' : 'Show') + ' ' + hasMore.text,
            _react2.default.createElement(ExpandCollapseIcon, { expanded: expanded })
          ) : _react2.default.createElement(_TimestampVersion2.default, { event: event }),
          !expanded && _react2.default.createElement(HistoryDotsIcon, { className: 'history-dots' })
        ),
        expanded && (hasMore.type === 'review' ? _react2.default.createElement(_QualityReviewInfo2.default, { event: event, parentRef: this.ref }) : _react2.default.createElement(_ActivityEditEventsList2.default, {
          changedAttributes: event.metadata.changed_attributes,
          parentRef: this.ref
        }))
      );
    }
  }, {
    key: 'onHover',
    value: function onHover() {
      this.setState(function () {
        return {
          hovered: true
        };
      });
    }
  }, {
    key: 'onLeaveHover',
    value: function onLeaveHover() {
      this.setState(function () {
        return {
          hovered: false
        };
      });
    }
  }, {
    key: 'onToggleExpandClick',
    value: function onToggleExpandClick(hasMore) {
      // !expanded means click is to open; send analytics event
      var _props = this.props,
          event = _props.event,
          quest = _props.quest;

      if (!this.state.expanded) {
        if (hasMore.type === 'activity') {
          var loggingData = (0, _logging2.getQuestEventLoggingData)(quest);
          delete loggingData.manager;
          delete loggingData.quest_type;
          var data = (0, _assign2.default)({}, loggingData, {
            action: 'view_activity_edit'
          });
          this.props.dispatch((0, _logging.postLoggingInfo)('quest', data));
        } else {
          var _loggingData = (0, _logging2.getQuestEventLoggingData)(quest);
          var _data = (0, _assign2.default)({}, _loggingData, {
            action: 'view_review_comments_history',
            history_is_review_approved: event.metadata.approved,
            history_quality_reviewer: (0, _assign2.default)({}, event.metadata.reviewer),
            history_quest_version: event.version
          });
          this.props.dispatch((0, _logging.postLoggingInfo)('quest', _data));
        }
      }
      this.setState(function (state) {
        return {
          expanded: !state.expanded
        };
      });
    }
  }]);
  return HistoryItem;
}(_react2.default.Component);

HistoryItem.propTypes = {
  event: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  hideItem: _propTypes2.default.bool.isRequired
};

exports.default = HistoryItem;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 14px;\n  width: 14px;\n  background-size: 100%;\n  margin-right: 11px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 14px;\n  width: 14px;\n  background-size: 100%;\n  margin-right: 11px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _icon_check_ir_approve = __webpack_require__(1513);

var _icon_check_ir_approve2 = _interopRequireDefault(_icon_check_ir_approve);

var _icon_reject_red_sm = __webpack_require__(1514);

var _icon_reject_red_sm2 = _interopRequireDefault(_icon_reject_red_sm);

var _string = __webpack_require__(124);

var _TimestampVersion = __webpack_require__(686);

var _TimestampVersion2 = _interopRequireDefault(_TimestampVersion);

var _Styled = __webpack_require__(342);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QualityApprovedIcon = _styledComponents2.default.div.withConfig({
  displayName: 'QualityReviewInfo__QualityApprovedIcon',
  componentId: 'sc-1tarjg3-0'
})(_templateObject, _icon_check_ir_approve2.default);

var QualityRejectedIcon = _styledComponents2.default.div.withConfig({
  displayName: 'QualityReviewInfo__QualityRejectedIcon',
  componentId: 'sc-1tarjg3-1'
})(_templateObject, _icon_reject_red_sm2.default);

var ReviewTypeApprovedRejectedWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'QualityReviewInfo__ReviewTypeApprovedRejectedWrapper',
  componentId: 'sc-1tarjg3-2'
})(_templateObject2);

var QualityReviewInfo = function (_React$Component) {
  (0, _inherits3.default)(QualityReviewInfo, _React$Component);

  function QualityReviewInfo(props) {
    (0, _classCallCheck3.default)(this, QualityReviewInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QualityReviewInfo.__proto__ || (0, _getPrototypeOf2.default)(QualityReviewInfo)).call(this, props));

    _this.parentRef = props.parentRef.current;
    return _this;
  }

  (0, _createClass3.default)(QualityReviewInfo, [{
    key: 'render',
    value: function render() {
      var event = this.props.event;

      return _react2.default.createElement(
        _Styled.ExpandedHistoryEventContainer,
        {
          bg: getComputedStyle(this.props.parentRef.current).backgroundColor,
          style: { padding: '26px 39px 26px 80px' },
          comment: true
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'top',
              justifyContent: 'space-between',
              marginBottom: '17px'
            }
          },
          _react2.default.createElement(
            ReviewTypeApprovedRejectedWrapper,
            null,
            event.metadata.approved ? _react2.default.createElement(QualityApprovedIcon, null) : _react2.default.createElement(QualityRejectedIcon, null),
            _react2.default.createElement(
              _H2.default,
              null,
              (0, _string.capitalizeWord)(event.metadata.criteria)
            )
          ),
          _react2.default.createElement(_TimestampVersion2.default, { event: event })
        ),
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '17px' } },
          _react2.default.createElement(_MarkdownLabel2.default, { value: event.comment })
        )
      );
    }
  }]);
  return QualityReviewInfo;
}(_react2.default.Component);

QualityReviewInfo.propTypes = {
  event: _propTypes2.default.object.isRequired,
  parentRef: _propTypes2.default.object.isRequired
};

exports.default = QualityReviewInfo;

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyAKIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogd2lkdGg9IjIzcHgiIGhlaWdodD0iMTlweCI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgIGZpbGw9InJnYigwLCAxODgsIDEyOCkiCiBkPSJNNy41NjIsMTguOTg5IEwwLjUwMSwxMS40NjYgQy0wLjE2OCwxMC43NTQgLTAuMTY4LDkuNTk5IDAuNTAxLDguODg2IEMxLjE3MCw4LjE3NCAyLjI1Myw4LjE3NCAyLjkyMiw4Ljg4NiBMNy41NjIsMTMuODMwIEwyMC4wNTIsMC41MjUgQzIwLjcyMSwtMC4xODggMjEuODA1LC0wLjE4OCAyMi40NzQsMC41MjUgQzIzLjE0MiwxLjIzNyAyMy4xNDIsMi4zOTIgMjIuNDc0LDMuMTA1IEw3LjU2MiwxOC45ODkgWiIvPgo8L3N2Zz4="

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMSAyMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjEgMjEiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiNEQzE0M0M7fTwvc3R5bGU+PHBhdGggY2xhc3M9InN0MCIgZD0iTS42MDQuODQ5Yy0uMjQ1LS4yNC0uNjA3LS4xMTUtLjYwNC4yNDhsLjA3NCA3Ljc1OGMuMDAyLjI0Mi4xMjUuMzYzLjM2Ny4zNmw3LjUyNy0uNDI3Yy4zNjQtLjAwNC40ODEtLjM2OC4yMzctLjYwOGwtMy4xOTctMy4xM2MxLjQ0Mi0xLjM0NyAzLjI1MS0yLjMzNCA1LjQzMy0yLjM1NSA0Ljg0OS0uMDQ2IDguNjUgNC40MDMgNy43MjcgOS4zODMtLjU3NyAzLjAzNi0yLjk3OCA1LjQ4NC02LjAwMyA2LjExOS0zLjc1MS43NjMtNy4xNjUtMS4yNjUtOC42NDktNC4yODItLjEyNi0uNDg0LS42MTMtLjcyMi0xLjA5OC0uNzE3LS45Ny4wMDktMS41NjUgMS4xMDYtMS4xOTQgMS45NTEgMS43MzEgMy40OTkgNS4yNjkgNS44OSA5LjM5MSA1Ljg1MSA2LjQyNS0uMDYxIDExLjQ2MS01LjkyOSAxMC4xODUtMTIuNTg1LS44ODgtNC4xMTQtNC4zMTUtNy40NzUtOC41NjQtOC4xNjItMy41MjEtLjU3My02LjkwNC42NzItOS4wNjMgMy4xMTdsLTIuNTctMi41MjF6IiBpZD0icmVmcmVzaCIvPjwvc3ZnPg=="

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/unassigned.svg";

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1MC4yICg1NTA0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+RTYxOTgxNTktRTBDNC00NDhDLUJEOTktRUI3NUMwMkRDRkVEPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJSZXZpZXctQ29tbWVudHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSI0LjAtTG9uZy1UZXh0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTkyLjAwMDAwMCwgLTk4My4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IkVkaXQtbWFkZS0tLW9uLUdyZXkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4NS4wMDAwMDAsIDk3Ni4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMTMuNSIgY3k9IjEzLjUiIHI9IjEzLjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMC4yMTc4MzMsMTguNjU1NjI5NyBMNy41NTg4MywxOS41NDIwNjA2IEw4LjQ0NDY5NjQzLDE2Ljg4MjQ3NzggTDE1LjUxMTQyNjksOS44MTYwODMwMyBMMTUuOTU0MzUyNSwxMC4yNTkyOTg1IEwxNy4yODM4NDY0LDExLjU4OTIzNDggTDEwLjIxNzgzMywxOC42NTU2Mjk3IFogTTE5LjM0NDE0NDYsOS41Mjk0MjQ4OCBMMTguNDU3NTc2MywxMC40MTU4NTU4IEwxNi42ODQ0MjQ1LDguNjQyNzA0MDMgTDE3LjU3MTAwOCw3Ljc1NjI4ODMzIEMxNy44MTUwODI0LDcuNTEyOTkyMDQgMTguMTEwMTE3LDcuMzkxMDU0IDE4LjQ1NzU3NjMsNy4zOTEwNTQgQzE4LjgwNTczNzUsNy4zOTEwNTQgMTkuMTAwNzg3Miw3LjUxMjk5MjA0IDE5LjM0NDE0NDYsNy43NTYyODgzMyBDMTkuNTg3NTAxOSw3Ljk5OTg1OTI2IDE5LjcwODgyOTYsOC4yOTUyNDQ3IDE5LjcwODgyOTYsOC42NDI3MDQwMyBDMTkuNzA4ODI5Niw4Ljk5MDc1ODQxIDE5LjU4NzUwMTksOS4yODYxNDM4NSAxOS4zNDQxNDQ2LDkuNTI5NDI0ODggWiIgaWQ9IkNvbWJpbmVkLXNoYXBlLTY1IiBmaWxsPSIjOTk5OTk5Ij48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjMgKDY3Mjk3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cCA5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlNob3ctUXVlc3QtSGVyc3RvcnkiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIxLjAtUXVlc3QtSGlyc3RvcnkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODguMDAwMDAwLCAtMjAxNy4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE4OC4wMDAwMDAsIDIwMTcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiI+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgZmlsbD0iI0ZGQUUwMCIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIj48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICA8dGV4dCBpZD0iKyIgZm9udC1mYW1pbHk9IlJvYm90by1MaWdodCwgUm9ib3RvIiBmb250LXNpemU9IjE0LjgxNDgxNDgiIGZvbnQtd2VpZ2h0PSIzMDAiIGxpbmUtc3BhY2luZz0iMTcuNzc3Nzc3OCIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI1LjkyNTkyNTkzIiB5PSIxNC43NDA3NDA3Ij4rPC90c3Bhbj4KICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/review_returned_status_label.svg";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/in_publication_review_status_label.svg";

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTEgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1My4yICg3MjY0MykgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+QjUzRDAyRkQtQzU4Qy00ODQ1LUIzMjktMEE0MDFGMkZBNzU1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJBY3Rpdml0eS1OdW1iZXItb24tUXVlc3QtSGlzdG9yeSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjEuMC1RdWVzdC1IaXN0b3J5LS0tQWN0aXZpdHktTnVtYmVyLC1BZGQsLVNvcnQsLURlbGV0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5Mi4wMDAwMDAsIC02MjMuMDAwMDAwKSIgZmlsbD0iIzk5OTk5OSI+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJfaWNvbl9hZGRlZCIgcG9pbnRzPSIxOTguNTI1MDUgNjI3LjgxMTMyMSAyMDMgNjI3LjgxMTMyMSAyMDMgNjI5Ljc5MjQ1MyAxOTguNTI1MDUgNjI5Ljc5MjQ1MyAxOTguNTI1MDUgNjM1IDE5Ni40NzQ5NSA2MzUgMTk2LjQ3NDk1IDYyOS43OTI0NTMgMTkyIDYyOS43OTI0NTMgMTkyIDYyNy44MTEzMjEgMTk2LjQ3NDk1IDYyNy44MTEzMjEgMTk2LjQ3NDk1IDYyMyAxOTguNTI1MDUgNjIzIj48L3BvbHlnb24+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyAKIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogd2lkdGg9IjEzcHgiIGhlaWdodD0iOHB4Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiAgZmlsbD0icmdiKDAsIDExMiwgMjI0KSIKIGQ9Ik0xMC44MTUsNi45NzkgTDYuNDU1LDIuNjY2IEwyLjA5Niw2Ljk3OSBDMS43NTIsNy4zNTQgMS40MDksNy4zNjIgMS4wNjUsNy4wMDMgQzAuNzIyLDYuNjQ0IDAuNzIyLDYuMjkyIDEuMDY1LDUuOTQ4IEw1Ljk0MCwxLjA3MyBDNi4wNjUsMC45MTcgNi4yMzcsMC44MzggNi40NTUsMC44MzggQzYuNjc1LDAuODM4IDYuODQ3LDAuOTE3IDYuOTcxLDEuMDczIEwxMS44NDcsNS45NDggQzEyLjE5MSw2LjI5MiAxMi4xOTEsNi42NDQgMTEuODQ3LDcuMDAzIEMxMS41MDMsNy4zNjIgMTEuMTYwLDcuMzU0IDEwLjgxNSw2Ljk3OSBMMTAuODE1LDYuOTc5IFoiLz4KPC9zdmc+"

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMnB4IiBoZWlnaHQ9IjE5cHgiIHZpZXdCb3g9IjAgMCAyIDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNTIuMyAoNjcyOTcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkVDRDJEMTdCLUY5NUQtNEY0NC1CRjdFLTEzRDU3OTEyRTU5MjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZyBpZD0iUmV2aWV3LUNvbW1lbnRzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMS4wLVF1YWxpdHktUmV2aWV3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTk3LjAwMDAwMCwgLTQ5NC4wMDAwMDApIiBmaWxsPSIjOTk5OTk5Ij4KICAgICAgICAgICAgPGcgaWQ9Imhpc3RvcnktZG90cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3LjAwMDAwMCwgNDk0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgICAgICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwtNCIgY3g9IjEiIGN5PSIxMi4zNSIgcng9IjEiIHJ5PSIxIj48L2VsbGlwc2U+CiAgICAgICAgICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwtNCIgY3g9IjEiIGN5PSI2LjY1IiByeD0iMSIgcnk9IjEiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgICAgICA8ZWxsaXBzZSBpZD0iT3ZhbC00IiBjeD0iMSIgY3k9IjAuOTUiIHJ4PSIxIiByeT0iMSI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPGVsbGlwc2UgaWQ9Ik92YWwtNCIgY3g9IjEiIGN5PSIxOC4wNSIgcng9IjEiIHJ5PSIxIj48L2VsbGlwc2U+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  .activity-edit-text {\n    border-bottom: 1px solid #dedfe0;\n  }\n\n  li:last-of-type div {\n    border-bottom: none;\n  }\n'], ['\n  .activity-edit-text {\n    border-bottom: 1px solid #dedfe0;\n  }\n\n  li:last-of-type div {\n    border-bottom: none;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Styled = __webpack_require__(342);

var _ActivityEditEventItem = __webpack_require__(1536);

var _ActivityEditEventItem2 = _interopRequireDefault(_ActivityEditEventItem);

var _questhistory = __webpack_require__(465);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityEditEventsContainer = _styledComponents2.default.ul.withConfig({
  displayName: 'ActivityEditEventsList__ActivityEditEventsContainer',
  componentId: 'rk265p-0'
})(_templateObject);

var ActivityEditEventsList = function ActivityEditEventsList(props) {
  var sortedAttributes = (0, _questhistory.sortActivitityEditAttributes)(props.changedAttributes);
  var attributes = sortedAttributes.map(function (attribute) {
    return _react2.default.createElement(_ActivityEditEventItem2.default, { attribute: attribute, key: attribute });
  });
  return _react2.default.createElement(
    _Styled.ExpandedHistoryEventContainer,
    {
      bg: getComputedStyle(props.parentRef.current).backgroundColor,
      style: { padding: '0 58px 0 55px' }
    },
    _react2.default.createElement(
      ActivityEditEventsContainer,
      null,
      attributes
    )
  );
};

ActivityEditEventsList.propTypes = {
  changedAttributes: _propTypes2.default.array.isRequired,
  parentRef: _propTypes2.default.object.isRequired
};

exports.default = ActivityEditEventsList;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 10px;\n  width: 675px;\n  padding: 13px 0;\n  display: flex;\n'], ['\n  margin-left: 10px;\n  width: 675px;\n  padding: 13px 0;\n  display: flex;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 100%;\n  margin: 0 !important;\n  display: flex;\n  display: flex;\n  align-items: center;\n'], ['\n  height: 100%;\n  margin: 0 !important;\n  display: flex;\n  display: flex;\n  align-items: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Styled = __webpack_require__(342);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(160);

var _Caption4 = _interopRequireDefault(_Caption3);

var _activity = __webpack_require__(687);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityEditText = (0, _styledComponents2.default)(_Caption4.default).withConfig({
  displayName: 'ActivityEditEventItem__ActivityEditText',
  componentId: 'sc-1e3837-0'
})(_templateObject);

var StyledActivityEditEventItem = _styledComponents2.default.li.withConfig({
  displayName: 'ActivityEditEventItem__StyledActivityEditEventItem',
  componentId: 'sc-1e3837-1'
})(_templateObject2);

var AcrtivityEditEventItem = function AcrtivityEditEventItem(_ref) {
  var attribute = _ref.attribute;
  return _react2.default.createElement(
    StyledActivityEditEventItem,
    { className: 'activity-edit-item' },
    _react2.default.createElement(_Styled.EditIcon, null),
    _react2.default.createElement(
      ActivityEditText,
      { className: 'activity-edit-text' },
      _activity.activityEditFields[attribute].label,
      _react2.default.createElement(
        _Caption2.default,
        null,
        '\xA0\xA0edited'
      )
    )
  );
};

AcrtivityEditEventItem.propTypes = {
  attribute: _propTypes2.default.string.isRequired
};

exports.default = AcrtivityEditEventItem;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestReviewDisconnected = exports.mapStateToProps = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _InternalReview = __webpack_require__(1538);

var _InternalReview2 = _interopRequireDefault(_InternalReview);

var _QualityReview = __webpack_require__(1548);

var _QualityReview2 = _interopRequireDefault(_QualityReview);

var _review = __webpack_require__(64);

var _assignment = __webpack_require__(138);

var _review2 = __webpack_require__(691);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestReview = function (_Component) {
  (0, _inherits3.default)(QuestReview, _Component);

  function QuestReview() {
    (0, _classCallCheck3.default)(this, QuestReview);
    return (0, _possibleConstructorReturn3.default)(this, (QuestReview.__proto__ || (0, _getPrototypeOf2.default)(QuestReview)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestReview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          quest = _props.quest;


      return _react2.default.createElement(
        'div',
        { className: 'review-section' },
        _react2.default.createElement(_InternalReview2.default, (0, _extends3.default)({
          userCanViewInternalReviewInfo: (0, _review.userCanViewInternalReviewInfo)(user, quest),
          questIsInDraftState: (0, _review.questIsInDraftState)(quest),
          questIsAssignedToUser: (0, _assignment.questIsAssignedToUser)(quest, user)
        }, this.props)),
        _react2.default.createElement(
          'div',
          { className: 'divider-container' },
          _react2.default.createElement('div', { className: 'bottom-white-bar' }),
          _react2.default.createElement('div', { className: 'grey-divider' }),
          _react2.default.createElement('div', { className: 'top-black-bar' })
        ),
        _react2.default.createElement(_QualityReview2.default, this.props)
      );
    }
  }]);
  return QuestReview;
}(_react.Component);

QuestReview.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  currentReviews: _propTypes2.default.array.isRequired,
  isFetchingCompiledQuest: _propTypes2.default.bool,
  isFetchingQuest: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func.isRequired,
  previousReviews: _propTypes2.default.array.isRequired,
  organization: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  approvals: _propTypes2.default.array,
  toQualityReviewModalIsOpen: _propTypes2.default.bool.isRequired,
  isEditingApproval: _propTypes2.default.bool.isRequired,
  isSettingLastApproval: _propTypes2.default.bool.isRequired,
  activities: _propTypes2.default.array.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    quest: state.quest.item,
    user: state.user.user,
    currentReviews: (0, _review2.currentReviewsFilteredForQuestState)(state),
    isFetchingCompiledQuest: state.quest.isFetchingCompiledQuest,
    isFetchingQuest: state.quest.isFetchingQuest,
    previousReviews: state.quest.previousReviews,
    organization: state.organization,
    approvals: state.quest.approvals,
    toQualityReviewModalIsOpen: state.quest.toQualityReviewModalIsOpen,
    isEditingApproval: state.quest.isEditingApproval,
    isSettingLastApproval: state.quest.isSettingLastApproval,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuestReview);
exports.QuestReviewDisconnected = QuestReview; // pure component - used in tests

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _NotQuiteReady = __webpack_require__(1539);

var _NotQuiteReady2 = _interopRequireDefault(_NotQuiteReady);

var _ReviewProcessInfo = __webpack_require__(1540);

var _ReviewProcessInfo2 = _interopRequireDefault(_ReviewProcessInfo);

var _InternalReviewBoxes = __webpack_require__(1541);

var _InternalReviewBoxes2 = _interopRequireDefault(_InternalReviewBoxes);

var _Assignment = __webpack_require__(1547);

var _Assignment2 = _interopRequireDefault(_Assignment);

var _review = __webpack_require__(64);

var _user = __webpack_require__(45);

var _utils = __webpack_require__(20);

var _assignment = __webpack_require__(138);

var _messages = __webpack_require__(21);

var _label = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalReview = function (_Component) {
  (0, _inherits3.default)(InternalReview, _Component);

  function InternalReview(props) {
    (0, _classCallCheck3.default)(this, InternalReview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InternalReview.__proto__ || (0, _getPrototypeOf2.default)(InternalReview)).call(this, props));

    _this.onAssignClickBound = _this.onAssignClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InternalReview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          user = _props.user,
          organization = _props.organization,
          currentReviews = _props.currentReviews,
          userCanViewInternalReviewInfo = _props.userCanViewInternalReviewInfo,
          questIsInDraftState = _props.questIsInDraftState,
          questIsAssignedToUser = _props.questIsAssignedToUser,
          intl = _props.intl,
          activities = _props.activities;


      var rejectedReview = (0, _review.findRejectedReview)(currentReviews);
      var intlReviewType = (0, _review.getIntlReviewTypeWithContext)(rejectedReview, intl, 'sentence');
      var reviewMessage = intl.formatMessage(_label.messages.review);
      var embeddedIntlReview = intl.formatMessage(_label.messages.blankReview, {
        reviewType: intlReviewType,
        review: reviewMessage[0].toUpperCase() + reviewMessage.substr(1)
      });
      var rejectedReviewStrong = _react2.default.createElement(
        'strong',
        null,
        embeddedIntlReview
      );

      return _react2.default.createElement(
        'div',
        { className: 'internal-review-container' },
        this.showRejectionInfo() && _react2.default.createElement(
          'div',
          { className: 'rejected-review-info-container' },
          _react2.default.createElement('div', { className: 'needs-work-icon' }),
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.Review.ThisQuestDidNotPass',
              defaultMessage: 'This quest did not pass the required reviews and needs further changes.'
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.Review.PleaseRead',
              defaultMessage: '{pleaseRead} {strong} {belowToFind}',
              values: {
                pleaseRead: _messages.pleaseRead,
                strong: rejectedReviewStrong,
                belowToFind: _messages.belowToFind
              }
            })
          )
        ),
        !(0, _utils.isNullOrEmpty)(quest.assigned_to) && userCanViewInternalReviewInfo && questIsInDraftState && _react2.default.createElement(_Assignment2.default, {
          quest: quest,
          user: user,
          organization: organization,
          isQuestAuthor: (0, _user.isQuestAuthor)(user, quest, organization),
          questIsAssignedToUser: questIsAssignedToUser,
          questIsAssignedByUser: (0, _assignment.questIsAssignedByUser)(quest, user)
        }),
        _react2.default.createElement(
          'div',
          { className: 'not-assigned-nor-ready' },
          userCanViewInternalReviewInfo && questIsInDraftState && _react2.default.createElement(
            'p',
            { className: 'guidelines' },
            _messages.questsNeedToBeReviewed,
            '\xA0',
            (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && (questIsAssignedToUser || (0, _utils.isNullOrEmpty)(quest.assigned_to)) && _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'InternalReview.WhenYoureReadyForReview',
              defaultMessage: "When you're ready for review, assign this quest to a reviewer in your organization. (Tip: you can assign this quest to a peer to get feedback at any time.)"
            }),
            ((0, _user.isInternalReviewer)(user) || (0, _user.isQuestManager)(user)) && questIsAssignedToUser && _react2.default.createElement(
              'span',
              null,
              '\xA0',
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'InternalReview.IfYoureNotTheBestFit',
                defaultMessage: "If you're not the best fit,"
              }),
              '\xA0',
              _react2.default.createElement(
                'a',
                { onClick: this.onAssignClickBound },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'InternalReview.AssignThisQuest',
                  defaultMessage: 'assign this quest'
                })
              ),
              '\xA0',
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'InternalReview.ToADifferentReviewer',
                defaultMessage: 'to a different reviewer.'
              })
            )
          ),
          userCanViewInternalReviewInfo && !(0, _review.allRequiredFieldsComplete)(quest, activities) && questIsInDraftState && _react2.default.createElement(_NotQuiteReady2.default, null),
          userCanViewInternalReviewInfo && ((0, _review.allRequiredFieldsComplete)(quest, activities) || !(0, _utils.isNullOrEmpty)(quest.reviewing_compiled_quest)) && _react2.default.createElement(_InternalReviewBoxes2.default, {
            user: user,
            quest: quest,
            organization: organization,
            handleAssignClick: this.props.handleAssignClick,
            dispatch: this.props.dispatch,
            approvals: this.props.approvals,
            toQualityReviewModalIsOpen: this.props.toQualityReviewModalIsOpen,
            isEditingApproval: this.props.isEditingApproval,
            isSettingLastApproval: this.props.isSettingLastApproval
          })
        ),
        !userCanViewInternalReviewInfo && _react2.default.createElement(_ReviewProcessInfo2.default, null)
      );
    }
  }, {
    key: 'showRejectionInfo',
    value: function showRejectionInfo() {
      var _props2 = this.props,
          user = _props2.user,
          quest = _props2.quest,
          organization = _props2.organization;

      return quest.reviewing_compiled_quest && quest.reviewing_compiled_quest.state === 'rejected' && (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization);
    }
  }, {
    key: 'onAssignClick',
    value: function onAssignClick() {
      this.props.handleAssignClick();
    }
  }]);
  return InternalReview;
}(_react.Component);

InternalReview.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  currentReviews: _propTypes2.default.array.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  organization: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  approvals: _propTypes2.default.array,
  toQualityReviewModalIsOpen: _propTypes2.default.bool.isRequired,
  userCanViewInternalReviewInfo: _propTypes2.default.bool.isRequired,
  questIsInDraftState: _propTypes2.default.bool.isRequired,
  questIsAssignedToUser: _propTypes2.default.bool.isRequired,
  intl: _propTypes2.default.object.isRequired,
  isEditingApproval: _propTypes2.default.bool.isRequired,
  isSettingLastApproval: _propTypes2.default.bool.isRequired,
  activities: _propTypes2.default.array.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(InternalReview);

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotQuiteReady = function NotQuiteReady() {
  return _react2.default.createElement(
    'div',
    { className: 'not-quite-ready-container' },
    _react2.default.createElement('div', { className: 'icon-not-ready' }),
    _react2.default.createElement(
      'p',
      { className: 'not-quite-ready' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'InternalReview.IsntReady',
        defaultMessage: "This quest isn't ready for internal review yet."
      })
    ),
    _react2.default.createElement(
      'p',
      { className: 'guidance' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'InternalReview.CompleteAllTheRequiredFields',
        defaultMessage: 'Complete all the required fields, then assign this quest to a reviewer in your organization for review.'
      })
    )
  );
};

exports.default = NotQuiteReady;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewProcessInfo = function ReviewProcessInfo() {
  return _react2.default.createElement(
    'div',
    { className: 'not-assigned-nor-author-nor-reviewer' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'p',
        { className: 'guidance' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'InternalReview.WhenThisQuest',
          defaultMessage: 'When this quest is ready for review, it will be evaluated by reviewers within its organization, using three types of criteria:'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'review-type-bold' },
        _messages.experience,
        _react2.default.createElement('div', { className: 'vertical-divider' }),
        _messages.subject,
        _react2.default.createElement('div', { className: 'vertical-divider' }),
        _messages.copy
      )
    ),
    _react2.default.createElement('div', { className: 'arrow' }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'p',
        { className: 'guidance' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'InternalReview.Then,TheQuest',
          defaultMessage: 'Then, the quest will be reviewed by Publication Reviewers to ensure it meets final quality standards.'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'review-type-bold oe' },
        _messages.oeReview
      )
    ),
    _react2.default.createElement('div', { className: 'arrow' }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'p',
        { className: 'guidance' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'InternalReview.WithQualityReview',
          defaultMessage: 'With Publication Review approval, the quest will be published in the Quest! app and will be available to learners and mentors.'
        })
      ),
      _react2.default.createElement('div', { className: 'tablet img' }),
      _react2.default.createElement('div', { className: 'desktop img' })
    )
  );
};

exports.default = ReviewProcessInfo;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InternalReviewBox = __webpack_require__(1542);

var _InternalReviewBox2 = _interopRequireDefault(_InternalReviewBox);

var _messages = __webpack_require__(21);

var _approval = __webpack_require__(1546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalReviewBoxes = function (_Component) {
  (0, _inherits3.default)(InternalReviewBoxes, _Component);

  function InternalReviewBoxes() {
    (0, _classCallCheck3.default)(this, InternalReviewBoxes);
    return (0, _possibleConstructorReturn3.default)(this, (InternalReviewBoxes.__proto__ || (0, _getPrototypeOf2.default)(InternalReviewBoxes)).apply(this, arguments));
  }

  (0, _createClass3.default)(InternalReviewBoxes, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var boxes = [_messages.experience, _messages.subject, _messages.copy].map(function (type, index) {
        return _react2.default.createElement(_InternalReviewBox2.default, (0, _extends3.default)({
          type: type,
          key: index,
          approval: (0, _approval.findApproval)(_this2.props.approvals, type.props.defaultMessage.toLowerCase())
        }, _this2.props));
      });

      return _react2.default.createElement(
        'div',
        { className: 'internal-review-box-container' },
        boxes
      );
    }
  }]);
  return InternalReviewBoxes;
}(_react.Component);

exports.default = InternalReviewBoxes;


InternalReviewBoxes.propTypes = {
  user: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  approvals: _propTypes2.default.array,
  toQualityReviewModalIsOpen: _propTypes2.default.bool.isRequired,
  isEditingApproval: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InternalReviewBox = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reactTextTruncate = __webpack_require__(332);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _oeWebCommon = __webpack_require__(117);

var _ReviewCheckbox = __webpack_require__(1543);

var _ReviewCheckbox2 = _interopRequireDefault(_ReviewCheckbox);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _ToQualityReviewModal = __webpack_require__(1544);

var _ToQualityReviewModal2 = _interopRequireDefault(_ToQualityReviewModal);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _approval = __webpack_require__(559);

var _review = __webpack_require__(159);

var _descriptions = __webpack_require__(1545);

var _messages = __webpack_require__(21);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InternalReviewBox = exports.InternalReviewBox = function (_Component) {
  (0, _inherits3.default)(InternalReviewBox, _Component);

  function InternalReviewBox(props) {
    (0, _classCallCheck3.default)(this, InternalReviewBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InternalReviewBox.__proto__ || (0, _getPrototypeOf2.default)(InternalReviewBox)).call(this, props));

    _this.setApprovedBound = _this.setApproved.bind(_this);
    _this.handleConfirmClickBound = _this.handleConfirmClick.bind(_this);
    _this.handleCancelClickBound = _this.handleCancelClick.bind(_this);
    _this.state = {
      finalApprovalNeeded: false
    };
    return _this;
  }

  (0, _createClass3.default)(InternalReviewBox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _review.closeToQualityReviewModal)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          approval = _props.approval,
          quest = _props.quest,
          toQualityReviewModalIsOpen = _props.toQualityReviewModalIsOpen,
          intl = _props.intl;


      var typeString = type.props.defaultMessage.toLowerCase();
      var description = intl.formatMessage(_descriptions.messages[typeString]);
      var klass = approval ? 'approved' : '';

      return _react2.default.createElement(
        'div',
        { className: 'internal-review-box ' + klass },
        _react2.default.createElement(
          'div',
          { className: 'header' },
          type
        ),
        !approval && _react2.default.createElement(
          'div',
          { className: 'info' },
          description
        ),
        approval && _react2.default.createElement(
          'div',
          { className: 'approval' },
          _react2.default.createElement(
            'div',
            { className: 'approved-by' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'InternalReview.ApprovedBy',
              defaultMessage: 'Approved by:'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'avatar-wrapper' },
            _react2.default.createElement(_UserAvatar2.default, { photoUrl: approval.approved_by.photo_url }),
            _react2.default.createElement(
              'div',
              { className: 'user' },
              _react2.default.createElement(
                _UserName2.default,
                {
                  activeCertifications: approval.approved_by.active_certifications,
                  userId: 'approval-' + type + '-' + approval.approved_by.id,
                  rebuild: true
                },
                _react2.default.createElement(
                  'div',
                  { className: 'name' },
                  _react2.default.createElement(_reactTextTruncate2.default, {
                    line: 2,
                    truncateText: '...',
                    text: (0, _name.getUserDisplayName)(approval.approved_by)
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'role' },
                _messages.reviewer
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'timestamp' },
            _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
              date: approval.created_at,
              includeTime: false
            }),
            ' at ',
            _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: approval.created_at })
          )
        ),
        _react2.default.createElement(_ReviewCheckbox2.default, (0, _extends3.default)({}, this.props, {
          setApproved: this.setApprovedBound,
          approved: Boolean(approval)
        })),
        toQualityReviewModalIsOpen && this.state.finalApprovalNeeded && _react2.default.createElement(_ToQualityReviewModal2.default, {
          quest: quest,
          handleConfirmClick: this.handleConfirmClickBound,
          handleCancelClick: this.handleCancelClickBound,
          criteria: typeString,
          isSettingLastApproval: this.props.isSettingLastApproval
        })
      );
    }
  }, {
    key: 'setApproved',
    value: function setApproved(e) {
      var _props2 = this.props,
          quest = _props2.quest,
          type = _props2.type,
          approval = _props2.approval,
          approvals = _props2.approvals,
          dispatch = _props2.dispatch,
          isEditingApproval = _props2.isEditingApproval;

      if (isEditingApproval) {
        // block the action (click) if one is already in progress
        return e.preventDefault();
      }
      var criteria = type.props.defaultMessage.toLowerCase();
      if (approval) {
        dispatch((0, _approval.deleteApproval)(quest.id, approval.id));
      } else {
        if (approvals.length === 2) {
          this.setState(function () {
            return { finalApprovalNeeded: true };
          });
          dispatch((0, _review.openToQualityReviewModal)());
        } else {
          dispatch((0, _approval.setApproved)(quest.id, criteria));
        }
      }
    }
  }, {
    key: 'handleCancelClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState(function () {
                  return { finalApprovalNeeded: false };
                });

              case 2:
                this.props.dispatch((0, _review.closeToQualityReviewModal)());

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleCancelClick() {
        return _ref.apply(this, arguments);
      }

      return handleCancelClick;
    }()
  }, {
    key: 'handleConfirmClick',
    value: function handleConfirmClick(criteria) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          quest = _props3.quest;

      dispatch((0, _approval.setLastApproval)(quest.id, criteria));
    }
  }]);
  return InternalReviewBox;
}(_react.Component);

InternalReviewBox.propTypes = {
  type: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  approval: _propTypes2.default.object,
  approvals: _propTypes2.default.array,
  toQualityReviewModalIsOpen: _propTypes2.default.bool.isRequired,
  intl: _propTypes2.default.object.isRequired,
  isEditingApproval: _propTypes2.default.bool.isRequired,
  isSettingLastApproval: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(InternalReviewBox);

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

var _user = __webpack_require__(45);

var _assignment = __webpack_require__(138);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewCheckbox = function (_Component) {
  (0, _inherits3.default)(ReviewCheckbox, _Component);

  function ReviewCheckbox() {
    (0, _classCallCheck3.default)(this, ReviewCheckbox);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewCheckbox.__proto__ || (0, _getPrototypeOf2.default)(ReviewCheckbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewCheckbox, [{
    key: 'getClassList',
    value: function getClassList() {
      var _props = this.props,
          quest = _props.quest,
          user = _props.user,
          organization = _props.organization;

      var classList = ['review-checkbox'];
      if ((0, _user.isInternalReviewer)(user) || (0, _user.isQuestManager)(user)) {
        classList.push('reviewer');
      }
      if ((0, _user.isQuestCopyEditorOrQuestAuthor)(user, quest, organization)) {
        classList.push('author');
      }
      if (!(0, _utils.isNullOrEmpty)(quest.reviewing_compiled_quest)) {
        classList.push('not-draft');
      }
      return classList.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          user = _props2.user,
          quest = _props2.quest,
          organization = _props2.organization,
          approved = _props2.approved;

      var klass = this.getClassList();
      var approvedClass = approved ? 'approved' : '';

      return _react2.default.createElement(
        'div',
        { className: klass + ' ' + approvedClass },
        _react2.default.createElement('div', { className: 'checkbox', onClick: this.props.setApproved }),
        _react2.default.createElement('div', {
          className: 'check ' + approvedClass,
          onClick: this.props.setApproved
        }),
        approved && _react2.default.createElement(
          'h2',
          null,
          _messages.approved
        ),
        !approved && function () {
          if ((0, _user.isInternalReviewer)(user) || (0, _user.isQuestManager)(user)) {
            return _react2.default.createElement(
              'h2',
              null,
              _messages.approve
            );
          } else if ((0, _user.isQuestCopyEditorOrQuestAuthor)(user, quest, organization) && ((0, _assignment.questIsAssignedToUser)(quest, user) || (0, _utils.isNullOrEmpty)(quest.assigned_to))) {
            return _react2.default.createElement(
              'div',
              {
                className: 'button btn-secondary-small',
                onClick: _this2.props.handleAssignClick
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ReviewCheckox.AssignToAReviewer',
                defaultMessage: 'Assign to a Reviewer'
              })
            );
          } else {
            return _react2.default.createElement(
              'h2',
              { className: 'not-yet-approved' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ReviewCheckbox.NotYetApproved',
                defaultMessage: 'Not yet Approved'
              })
            );
          }
        }()
      );
    }
  }]);
  return ReviewCheckbox;
}(_react.Component);

exports.default = ReviewCheckbox;


ReviewCheckbox.propTypes = {
  setApproved: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  approved: _propTypes2.default.bool.isRequired,
  type: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _reactIntl = __webpack_require__(16);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToQualityReviewModal = function (_Component) {
  (0, _inherits3.default)(ToQualityReviewModal, _Component);

  function ToQualityReviewModal(props) {
    (0, _classCallCheck3.default)(this, ToQualityReviewModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ToQualityReviewModal.__proto__ || (0, _getPrototypeOf2.default)(ToQualityReviewModal)).call(this, props));

    _this.handleCancelClickBound = _this.handleCancelClick.bind(_this);
    _this.handleConfirmClickBound = _this.handleConfirmClick.bind(_this);
    _this.handleHideBound = _this.handleHide.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ToQualityReviewModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showModal();
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '400px',
        background: '#fff',
        overflow: 'scroll',
        borderRadius: '6px',
        width: '400px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%'
      };
      var _props = this.props,
          quest = _props.quest,
          isSettingLastApproval = _props.isSettingLastApproval;

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'review-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          closeOnClick: false,
          onHide: this.handleHideBound
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'modal-heading' },
            _react2.default.createElement(_QuestIcon2.default, { heightWidth: 54, icon_image_url: quest.icon_image_url }),
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ToQualityReviewModal.Next:QualityReview',
                defaultMessage: 'Next: Publication Review'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-body' },
            _react2.default.createElement(
              'div',
              { className: 'modal-body-text' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ToQualityReviewModal.InternalReviewsAreDone',
                defaultMessage: 'Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.'
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement(
                'div',
                {
                  className: 'button modal-cancel ' + (isSettingLastApproval ? 'disabled' : ''),
                  onClick: this.handleCancelClickBound
                },
                _messages.cancel
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'button modal-confirm ' + (isSettingLastApproval ? 'disabled' : ''),
                  onClick: this.handleConfirmClickBound
                },
                _messages.ok
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.handleCancelClick();
    }
  }, {
    key: 'handleConfirmClick',
    value: function handleConfirmClick() {
      this.props.handleConfirmClick(this.props.criteria);
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      this.refs.modal.show();
    }
  }, {
    key: 'handleHide',
    value: function handleHide() {
      this.props.handleCancelClick();
    }
  }]);
  return ToQualityReviewModal;
}(_react.Component);

exports.default = ToQualityReviewModal;


ToQualityReviewModal.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  handleCancelClick: _propTypes2.default.func.isRequired,
  handleConfirmClick: _propTypes2.default.func.isRequired,
  criteria: _propTypes2.default.string.isRequired,
  isSettingLastApproval: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = undefined;

var _reactIntl = __webpack_require__(16);

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  experience: {
    'id': 'Descriptions.Experience',
    'defaultMessage': 'Each quest must be engaging for the learner, incorporate varying learning strategies, and reflect the Quest Forward vision for quest design.'
  },
  subject: {
    'id': 'Descriptions.Subject',
    'defaultMessage': 'Each quest must fulfill criteria for subject matter, including adequate coverage of applicable sub-topics and interdisciplinary content.'
  },
  copy: {
    'id': 'Descriptions.Copy',
    'defaultMessage': 'Each quest must fulfill criteria for copy, such as proper use of grammar, spelling, and punctuation.'
  }
});

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findApproval = findApproval;
function findApproval(approvals, criteria) {
  return approvals.find(function (approval) {
    return approval.criteria === criteria;
  });
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _oeWebCommon = __webpack_require__(117);

var _AssignmentAvatars = __webpack_require__(666);

var _AssignmentAvatars2 = _interopRequireDefault(_AssignmentAvatars);

var _assignment = __webpack_require__(138);

var _messages = __webpack_require__(21);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Assignment = function (_Component) {
  (0, _inherits3.default)(Assignment, _Component);

  function Assignment(props) {
    (0, _classCallCheck3.default)(this, Assignment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Assignment.__proto__ || (0, _getPrototypeOf2.default)(Assignment)).call(this, props));

    _this.state = {
      messageExpanded: false
    };
    _this.toggleExpandMessageClickBound = _this.toggleExpandMessageClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Assignment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          isQuestAuthor = _props.isQuestAuthor,
          questIsAssignedToUser = _props.questIsAssignedToUser,
          questIsAssignedByUser = _props.questIsAssignedByUser,
          user = _props.user,
          organization = _props.organization;

      var assignedReturned = isQuestAuthor && questIsAssignedToUser ? _messages.returned : _messages.assigned;
      var messageClass = this.state.messageExpanded ? 'expanded' : 'collapsed';

      var intlAssignedMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'Assignment.AssignedReturned',
        defaultMessage: '{user1} {assignedReturned} {user2}.',
        values: {
          user1: questIsAssignedByUser ? _messages.you : (0, _name.getUserDisplayName)(quest.assigned_by),
          assignedReturned: assignedReturned,
          user2: questIsAssignedToUser ? _messages.you : (0, _name.getUserDisplayName)(quest.assigned_to)
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'assignment' },
        _react2.default.createElement(_AssignmentAvatars2.default, {
          fromPhotoUrl: quest.assigned_by.photo_url,
          toPhotoUrl: quest.assigned_to.photo_url
        }),
        _react2.default.createElement(
          'div',
          { className: 'assigned-returned' },
          intlAssignedMessage
        ),
        _react2.default.createElement(_oeWebCommon.OEComponents.ElapsedTimeFormatter, {
          cssClass: 'assigned-time',
          time: quest.assignment_updated_at
        }),
        quest.assignment_message && (0, _assignment.userCanViewAssignmentMessage)(user, quest, organization) && _react2.default.createElement(
          'div',
          { className: 'assignment-message-container ' + messageClass },
          _react2.default.createElement(
            'div',
            { className: 'assignment-message' },
            quest.assignment_message
          ),
          quest.assignment_message && quest.assignment_message.length > 67 && _react2.default.createElement('div', {
            className: 'carat',
            onClick: this.toggleExpandMessageClickBound
          })
        ),
        _react2.default.createElement('div', { className: 'line' })
      );
    }
  }, {
    key: 'toggleExpandMessageClick',
    value: function toggleExpandMessageClick() {
      var _this2 = this;

      this.setState(function (state) {
        return { messageExpanded: !_this2.state.messageExpanded };
      });
    }
  }]);
  return Assignment;
}(_react.Component);

exports.default = Assignment;


Assignment.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  isQuestAuthor: _propTypes2.default.bool.isRequired,
  questIsAssignedToUser: _propTypes2.default.bool.isRequired,
  questIsAssignedByUser: _propTypes2.default.bool.isRequired,
  user: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _ReviewArea = __webpack_require__(1549);

var _ReviewArea2 = _interopRequireDefault(_ReviewArea);

var _Guidelines = __webpack_require__(1562);

var _Guidelines2 = _interopRequireDefault(_Guidelines);

var _Display = __webpack_require__(692);

var _Display2 = _interopRequireDefault(_Display);

var _user = __webpack_require__(45);

var _review = __webpack_require__(64);

var _messages = __webpack_require__(21);

var _label = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QualityReview = function (_Component) {
  (0, _inherits3.default)(QualityReview, _Component);

  function QualityReview() {
    (0, _classCallCheck3.default)(this, QualityReview);
    return (0, _possibleConstructorReturn3.default)(this, (QualityReview.__proto__ || (0, _getPrototypeOf2.default)(QualityReview)).apply(this, arguments));
  }

  (0, _createClass3.default)(QualityReview, [{
    key: 'render',
    value: function render() {
      var intl = this.props.intl;


      var intlReviewTypes = {
        standards: intl.formatMessage(_label.messages.standards),
        final: intl.formatMessage(_label.messages.final)
      };

      return _react2.default.createElement(
        'div',
        { className: 'quality-review-container' },
        _react2.default.createElement(
          _Display2.default,
          null,
          _messages.oeReview
        ),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_Guidelines2.default, null),
        this.canViewQualityReviewAreas() && _react2.default.createElement(
          'div',
          { className: 'quality-reviews' },
          _react2.default.createElement(_ReviewArea2.default, {
            reviewType: 'standards',
            intlReviewType: intlReviewTypes.standards
          }),
          _react2.default.createElement('div', { className: 'line review-divider' }),
          _react2.default.createElement(_ReviewArea2.default, {
            reviewType: 'final',
            intlReviewType: intlReviewTypes.final
          })
        )
      );
    }
  }, {
    key: 'canViewQualityReviewAreas',
    value: function canViewQualityReviewAreas() {
      var _props = this.props,
          user = _props.user,
          quest = _props.quest,
          previousReviews = _props.previousReviews,
          currentReviews = _props.currentReviews,
          organization = _props.organization;

      var reviewStatus = (0, _review.getReviewStatus)(quest);
      if ((0, _user.isExternalReviewer)(user)) {
        return false;
      } else {
        return (0, _review.userCanViewInternalReviewInfo)(user, quest) && (currentReviews.length > 0 || previousReviews.length > 0) || (0, _user.isOeReviewer)(user) && ((0, _review.questIsInQualityReview)(quest) || reviewStatus === 'rejected' || previousReviews.length > 0) || (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && ((0, _review.questIsInRejectedState)(quest) || currentReviews.length > 0);
      }
    }
  }]);
  return QualityReview;
}(_react.Component);

QualityReview.propTypes = {
  quest: _propTypes2.default.object,
  user: _propTypes2.default.object,
  currentReviews: _propTypes2.default.array,
  dispatch: _propTypes2.default.func,
  previousReviews: _propTypes2.default.array,
  organization: _propTypes2.default.object,
  intl: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(QualityReview);

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewAreaDisconnected = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactIntl = __webpack_require__(16);

var _oeWebCommon = __webpack_require__(117);

var _Comment = __webpack_require__(1550);

var _Comment2 = _interopRequireDefault(_Comment);

var _PreviousReviewsList = __webpack_require__(1551);

var _PreviousReviewsList2 = _interopRequireDefault(_PreviousReviewsList);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _quest = __webpack_require__(66);

var _review = __webpack_require__(159);

var _user = __webpack_require__(45);

var _review2 = __webpack_require__(64);

var _messages = __webpack_require__(21);

var _modal = __webpack_require__(470);

var _review3 = __webpack_require__(691);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewArea = function (_Component) {
  (0, _inherits3.default)(ReviewArea, _Component);

  function ReviewArea(props) {
    (0, _classCallCheck3.default)(this, ReviewArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewArea.__proto__ || (0, _getPrototypeOf2.default)(ReviewArea)).call(this, props));

    _this.state = {
      isEditing: _this.isThisReviewActive(props.activeReview) && (0, _review2.isActiveWithThisReviewer)(props.activeReview, props.user)
    };
    _this.hideModalBound = _this.hideModal.bind(_this);
    _this.onBeginReviewClickBound = _this.onBeginReviewClick.bind(_this);
    _this.onCancelClickBound = _this.onCancelClick.bind(_this);
    _this.onActualCancelClickBound = _this.onActualCancelClick.bind(_this);
    _this.onApproveClickBound = _this.onApproveClick.bind(_this);
    _this.onRejectClickBound = _this.onRejectClick.bind(_this);
    _this.onEditApprovalClickBound = _this.onEditApprovalClick.bind(_this);
    _this.onCompleteReviewClickBound = _this.onCompleteReviewClick.bind(_this);
    _this.onActualCompleteReviewClickBound = _this.onActualCompleteReviewClick.bind(_this);
    _this.onRevertToDraftClickBound = _this.onRevertToDraftClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReviewArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.cancelReviewModal = this.refs.cancelReviewModal.refs.modal;
      this.someOeApprovedModal = this.refs.someOeApprovedModal.refs.modal;
      this.readyForPublishModal = this.refs.readyForPublishModal.refs.modal;
      this.someReviewRejectedModal = this.refs.someReviewRejectedModal.refs.modal;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        isEditing: this.isThisReviewActive(nextProps.activeReview) && (0, _review2.isActiveWithThisReviewer)(nextProps.activeReview, nextProps.user)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          reviewType = _props.reviewType,
          activeReview = _props.activeReview,
          quest = _props.quest,
          user = _props.user,
          currentReviews = _props.currentReviews,
          previousReviews = _props.previousReviews,
          intlReviewType = _props.intlReviewType;
      var intl = this.context.intl;

      var review = (0, _review2.findReview)(currentReviews, reviewType);
      var reviewAuthor = review ? review.reviewer.name : '';
      var reviewer = review ? review.reviewer : '';
      var rejectedReview = (0, _review2.findRejectedReview)(currentReviews);
      var filteredReviews = (0, _review2.getFilteredReviews)(previousReviews, reviewType);
      var reviewTypeWithContextInSentence = (0, _review2.getIntlReviewTypeWithContext)(reviewType, intl, 'sentence');

      var modalMessages = {
        header: {
          cancelReview: intl.formatMessage(_modal.headingMessages.cancelReview),
          almostDone: intl.formatMessage(_modal.headingMessages.almostDone),
          returningToQuestDesigner: intl.formatMessage(_modal.headingMessages.returningToQuestDesigner),
          readyForPublish: intl.formatMessage(_modal.headingMessages.readyForPublish)
        },
        body: {
          ifYouCancel: intl.formatMessage(_modal.bodyMessages.ifYouCancel),
          thanksForYourReviewOE: intl.formatMessage(_modal.bodyMessages.thanksForYourReviewOE),
          questNeedsEdits: intl.formatMessage(_modal.bodyMessages.questNeedsEdits),
          passedAllReviews1: intl.formatMessage(_modal.bodyMessages.passedAllReviews1),
          passedAllReviews2: intl.formatMessage(_modal.bodyMessages.passedAllReviews2),
          passedAllReviews3: intl.formatMessage(_modal.bodyMessages.passedAllReviews3)
        },
        button: {
          cancel: intl.formatMessage(_modal.buttonMessages.cancel),
          ok: intl.formatMessage(_modal.buttonMessages.ok),
          yes: intl.formatMessage(_modal.buttonMessages.yes),
          no: intl.formatMessage(_modal.buttonMessages.no),
          publish: intl.formatMessage(_modal.buttonMessages.publish)
        }
      };

      var noReviewMessagesOe = 'This quest has not received {reviewType} review yet.';
      var rejectedClass = !activeReview && rejectedReview === reviewType && quest.reviewing_compiled_quest ? 'rejected' : '';

      return _react2.default.createElement(
        'div',
        { className: 'review-area ' + rejectedClass },
        _react2.default.createElement(
          'div',
          { className: 'review-area-anchor', id: 'section-' + reviewType },
          '\xA0'
        ),
        _react2.default.createElement(
          'div',
          { className: this.getHeaderStyles(review) },
          intlReviewType
        ),
        this.state.isEditing && quest.current_compiled_quest.state !== 'recalled' && _react2.default.createElement(
          'div',
          null,
          activeReview && activeReview.accepted === null ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', {
              className: 'review-action approve',
              title: 'Approve',
              onClick: this.onApproveClickBound
            }),
            _react2.default.createElement('div', {
              className: 'review-action reject',
              title: 'Reject',
              onClick: this.onRejectClickBound
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'approval-status-container' },
            _react2.default.createElement(
              'div',
              { className: 'approval-rejection' },
              review && (review.accepted === true ? _messages.approved : _messages.needsEdits)
            ),
            _react2.default.createElement('div', {
              className: 'edit',
              onClick: this.onEditApprovalClickBound
            })
          ),
          _react2.default.createElement(_Comment2.default, {
            isEditing: this.state.isEditing,
            review: review,
            quest: this.props.quest,
            handleComplete: this.onCompleteReviewClickBound,
            handleCancel: this.onCancelClickBound
          })
        ),
        this.showUnstartedReviewUi(review) && _react2.default.createElement(
          'div',
          null,
          this.showOeReviewAreaNotStartedMessage(review, filteredReviews) && _react2.default.createElement(
            'div',
            { className: 'review-body' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.Review.ReviewArea.ThisQuestHasNotReceived',
              defaultMessage: noReviewMessagesOe,
              values: {
                reviewType: reviewTypeWithContextInSentence.toLowerCase()
              }
            })
          ),
          (0, _user.isOeReviewer)(user) && (0, _review2.questIsInQualityReview)(quest) && _react2.default.createElement(
            'div',
            {
              className: this.isSomeOtherReviewActive() ? 'disabled button' : 'button',
              onClick: this.onBeginReviewClickBound
            },
            _messages.beginReview
          )
        ),
        this.showCompletedReviewUi(review) && _react2.default.createElement(
          'div',
          { className: 'completed-review' },
          _react2.default.createElement(
            'div',
            { className: 'approval-rejection-info' },
            _react2.default.createElement(
              'strong',
              null,
              (0, _review2.getCompletedReviewInfo)(review)
            ),
            '\xA0\xA0',
            _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
              date: review.completed_at,
              includeTime: false
            }),
            ' at ',
            _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: review.completed_at })
          ),
          _react2.default.createElement(
            'div',
            { className: 'completed-review-comment-wrapper' },
            review && review.comment && review.comment.length > 0 && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'completed-review-comment' },
                _react2.default.createElement(_MarkdownLabel2.default, {
                  additionalCssClasses: 'completed-review-comment',
                  value: review.comment
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'reviewer-info-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'user-photo-wrapper' },
                  _react2.default.createElement('img', { src: reviewer.photo_url })
                ),
                _react2.default.createElement(
                  _UserName2.default,
                  {
                    activeCertifications: reviewer.active_certifications,
                    userId: 'current-review-' + reviewType + '-' + reviewer.id,
                    rebuild: true
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'reviewer-name' },
                    reviewer.display_name || reviewer.name
                  )
                )
              )
            ),
            review && (!review.comment || review.comment.length === 0) && _react2.default.createElement(
              'div',
              { className: 'no-review-comment' },
              _react2.default.createElement(
                'div',
                { className: 'user-photo-wrapper' },
                _react2.default.createElement('img', { src: reviewer.photo_url })
              ),
              _react2.default.createElement(
                _UserName2.default,
                {
                  activeCertifications: reviewer.active_certifications,
                  userId: 'current-review-' + reviewType + '-' + reviewer.id,
                  rebuild: true
                },
                _react2.default.createElement(
                  'div',
                  { className: 'reviewer-name' },
                  reviewer.display_name || reviewer.name
                )
              )
            )
          ),
          this.showEditRejectedQuestButton(review) && _react2.default.createElement(
            'div',
            {
              className: 'button revert-to-draft',
              onClick: this.onRevertToDraftClickBound
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Quest.Review.ReviewArea.OKBegin',
              defaultMessage: 'OK, Edit this Quest'
            })
          )
        ),
        (this.showWasActiveWithThisReviewerUi(review) || this.showActiveWithAnotherReviewerUi(review)) && _react2.default.createElement(
          'div',
          { className: 'active-with-another-reviewer' },
          reviewAuthor + ' began this review on ',
          _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
            date: review.created_at,
            includeTime: false
          }),
          ' at ',
          _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: review.created_at }),
          '.'
        ),
        filteredReviews.length > 0 && _react2.default.createElement(_PreviousReviewsList2.default, {
          reviews: filteredReviews,
          previousReviewsNoCurrent: (0, _review2.checkPreviousReviewsNoCurrent)(filteredReviews, review) && (!quest.reviewing_compiled_quest || quest.reviewing_compiled_quest && (!(0, _review2.questIsInQualityReview)(quest) || quest.reviewing_compiled_quest.state === 'submitted' && !(0, _user.isInternalReviewer)(user))),
          reviewType: reviewType
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'cancelReviewModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'cancelReviewModal',
          headingKlass: 'modal-heading alert',
          logoKlass: 'logo alert',
          headingText: modalMessages.header.cancelReview,
          bodyText: modalMessages.body.ifYouCancel,
          primaryButtonText: modalMessages.button.yes,
          secondaryButtonText: modalMessages.button.no,
          primaryButtonAction: this.onActualCancelClickBound,
          secondaryButtonAction: this.hideModalBound
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'someOeApprovedModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'someOeApprovedModal',
          headingKlass: 'modal-heading',
          logoKlass: 'logo',
          headingText: modalMessages.header.almostDone,
          bodyText: modalMessages.body.thanksForYourReviewOE,
          primaryButtonText: modalMessages.button.yes,
          secondaryButtonText: modalMessages.button.cancel,
          primaryButtonAction: this.onActualCompleteReviewClickBound,
          secondaryButtonAction: this.hideModalBound,
          questLogo: true
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'someReviewRejectedModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'someReviewRejectedModal',
          headingKlass: 'modal-heading',
          logoKlass: 'logo reject',
          headingText: modalMessages.header.returningToQuestDesigner,
          bodyText: modalMessages.body.questNeedsEdits,
          primaryButtonText: modalMessages.button.ok,
          secondaryButtonText: modalMessages.button.cancel,
          primaryButtonAction: this.onActualCompleteReviewClickBound,
          secondaryButtonAction: this.hideModalBound
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'readyForPublishModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'readyForPublishModal',
          headingKlass: 'modal-heading success',
          logoKlass: 'logo',
          headingText: modalMessages.header.readyForPublish,
          bodyText: [modalMessages.body.passedAllReviews1, _react2.default.createElement(
            'strong',
            null,
            '\xA0',
            modalMessages.body.passedAllReviews2,
            '\xA0'
          ), modalMessages.body.passedAllReviews3],
          primaryButtonText: modalMessages.button.publish,
          secondaryButtonText: modalMessages.button.cancel,
          primaryButtonAction: this.onActualCompleteReviewClickBound,
          secondaryButtonAction: this.hideModalBound,
          questLogo: true
        })
      );
    }
  }, {
    key: 'showActiveWithAnotherReviewerUi',
    value: function showActiveWithAnotherReviewerUi(review) {
      var _props2 = this.props,
          activeReview = _props2.activeReview,
          user = _props2.user;

      return this.isThisReviewActive(activeReview) && !(0, _review2.isActiveWithThisReviewer)(activeReview, user) && review && !review.completed_at;
    }
  }, {
    key: 'showWasActiveWithThisReviewerUi',
    value: function showWasActiveWithThisReviewerUi(review) {
      var _props3 = this.props,
          activeReview = _props3.activeReview,
          user = _props3.user,
          quest = _props3.quest;

      return this.isThisReviewActive(activeReview) && (0, _review2.isActiveWithThisReviewer)(activeReview, user) && review && !review.completed_at && quest.current_compiled_quest.state === 'recalled';
    }
  }, {
    key: 'showEditRejectedQuestButton',
    value: function showEditRejectedQuestButton(review) {
      var _props4 = this.props,
          user = _props4.user,
          quest = _props4.quest,
          organization = _props4.organization;

      return (0, _user.isQuestCopyEditorOrQuestAuthor)(user, quest, organization) && review.accepted === false && quest.current_compiled_quest.state === 'rejected' && quest.reviewing_compiled_quest;
    }
  }, {
    key: 'showCompletedReviewUi',
    value: function showCompletedReviewUi(review) {
      return !this.state.isEditing && review && review.completed_at;
    }
  }, {
    key: 'showUnstartedReviewUi',
    value: function showUnstartedReviewUi(review) {
      return !this.state.isEditing && this.reviewNotStartedNorCompleted(review) && !this.isActiveWithAnotherReviewer(this.props.activeReview);
    }
  }, {
    key: 'showOeReviewAreaNotStartedMessage',
    value: function showOeReviewAreaNotStartedMessage(review, filteredReviews) {
      var quest = this.props.quest;

      return !review && (filteredReviews.length === 0 || quest.reviewing_compiled_quest && (quest.reviewing_compiled_quest.state === 'platform_review' || quest.reviewing_compiled_quest.state === 'submitted')) || Boolean(quest.current_compiled_quest) && quest.current_compiled_quest.state === 'recalled';
    }
  }, {
    key: 'getHeaderStyles',
    value: function getHeaderStyles(review) {
      var cssClass = 'review-header ';
      if (review && !review.completed) {
        cssClass += (0, _review2.getReviewApprovalStatus)(review);
      }
      return cssClass;
    }
  }, {
    key: 'reviewNotStartedNorCompleted',
    value: function reviewNotStartedNorCompleted(review) {
      return !review || review && !review.completed_at;
    }
  }, {
    key: 'isSomeOtherReviewActive',
    value: function isSomeOtherReviewActive() {
      return this.props.activeReview && this.props.reviewType !== this.props.activeReview.criteria;
    }
  }, {
    key: 'isThisReviewActive',
    value: function isThisReviewActive(activeReview) {
      return activeReview && this.props.reviewType === activeReview.criteria;
    }
  }, {
    key: 'isActiveWithAnotherReviewer',
    value: function isActiveWithAnotherReviewer(activeReview) {
      return this.isThisReviewActive(activeReview) && !(0, _review2.isActiveWithThisReviewer)(activeReview, this.props.user);
    }
  }, {
    key: 'onBeginReviewClick',
    value: function onBeginReviewClick() {
      // setQuestSection is necessary because if a subsection is stored in state, the user will
      // be scrolled to it (example is when coming to Quest detail from the review queue - user may select "Experience"
      // and then decide they want to review "Copy" instead and when they select "Begin Review" they'd be scrolled
      // back to "Experience" - this fixes that issue.
      this.props.dispatch((0, _quest.setQuestSection)('questreview', null, this.props.reviewType));

      this.props.dispatch((0, _review.createCompiledQuestReview)(this.props.quest.id, this.props.quest.reviewing_compiled_quest.id, this.props.reviewType));
      this.setState({
        isEditing: true
      });
    }
  }, {
    key: 'onCancelClick',
    value: function onCancelClick() {
      this.cancelReviewModal.show();
    }
  }, {
    key: 'onActualCancelClick',
    value: function onActualCancelClick() {
      var _props5 = this.props,
          quest = _props5.quest,
          activeReview = _props5.activeReview;

      this.props.dispatch((0, _review.deleteCompiledQuestReview)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id));
      this.setState({
        isEditing: false
      });
      this.cancelReviewModal.hide();
    }
  }, {
    key: 'onApproveClick',
    value: function onApproveClick() {
      var _props6 = this.props,
          quest = _props6.quest,
          activeReview = _props6.activeReview;

      this.props.dispatch((0, _review.approveReviewCriterion)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id));
    }
  }, {
    key: 'onRejectClick',
    value: function onRejectClick() {
      var _props7 = this.props,
          quest = _props7.quest,
          activeReview = _props7.activeReview;

      this.props.dispatch((0, _review.rejectReviewCriterion)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id));
    }
  }, {
    key: 'onEditApprovalClick',
    value: function onEditApprovalClick() {
      var _props8 = this.props,
          quest = _props8.quest,
          activeReview = _props8.activeReview;

      this.props.dispatch((0, _review.nullifyReviewCriterionApproval)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id));
    }
  }, {
    key: 'onCompleteReviewClick',
    value: function onCompleteReviewClick(comment) {
      var _props9 = this.props,
          dispatch = _props9.dispatch,
          currentReviews = _props9.currentReviews,
          quest = _props9.quest,
          reviewType = _props9.reviewType;

      var review = (0, _review2.findReview)(currentReviews, reviewType);
      if (comment) {
        dispatch((0, _review.editReviewComment)(quest.id, quest.reviewing_compiled_quest.id, review.id, comment));
      }

      var totalReviewState = (0, _review2.getTotalReviewState)(currentReviews);
      switch (totalReviewState) {
        case 'someOeApproved':
          this.someOeApprovedModal.show();
          break;
        case 'readyForPublish':
          this.readyForPublishModal.show();
          break;
        case 'rejected':
          this.someReviewRejectedModal.show();
          break;
      }
    }
  }, {
    key: 'onActualCompleteReviewClick',
    value: function onActualCompleteReviewClick() {
      var _props10 = this.props,
          quest = _props10.quest,
          activeReview = _props10.activeReview,
          currentReviews = _props10.currentReviews;

      // Figure out the next review state so the quest and item in quest list can be updated

      var totalReviewState = (0, _review2.getTotalReviewState)(currentReviews);
      var friendlyReviewState = (0, _review2.translateReviewState)(totalReviewState);

      this.props.dispatch((0, _review.completeCompiledQuestReview)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id, friendlyReviewState));

      this.setState({
        isEditing: false
      });

      this.someOeApprovedModal.hide();
      this.readyForPublishModal.hide();
      this.someReviewRejectedModal.hide();
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.cancelReviewModal.hide();
      this.someOeApprovedModal.hide();
      this.readyForPublishModal.hide();
      this.someReviewRejectedModal.hide();
    }
  }, {
    key: 'onRevertToDraftClick',
    value: function onRevertToDraftClick() {
      var _props11 = this.props,
          dispatch = _props11.dispatch,
          quest = _props11.quest;

      dispatch((0, _review.revertQuestToDraft)(quest.id));
    }
  }]);
  return ReviewArea;
}(_react.Component);

ReviewArea.propTypes = {
  reviewType: _propTypes2.default.string.isRequired,
  quest: _propTypes2.default.object,
  dispatch: _propTypes2.default.func,
  currentReviews: _propTypes2.default.array,
  previousReviews: _propTypes2.default.array,
  activeReview: _propTypes2.default.object,
  user: _propTypes2.default.object,
  isFetchingCurrentCompiledQuest: _propTypes2.default.bool,
  intlReviewType: _propTypes2.default.string,
  organization: _propTypes2.default.object
};

ReviewArea.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    quest: state.quest.item,
    user: state.user.user,
    currentReviews: (0, _review3.currentReviewsFilteredForQuestState)(state),
    previousReviews: state.quest.previousReviews,
    activeReview: state.quest.activeReview,
    isFetchingCurrentCompiledQuest: state.quest.isFetchingCurrentCompiledQuest,
    organization: state.organization
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReviewArea);
exports.ReviewAreaDisconnected = ReviewArea; // pure component - used in tests

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommentDisconnected = undefined;

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _review = __webpack_require__(159);

var _index = __webpack_require__(20);

var _messages = __webpack_require__(21);

var _placeholder = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Comment = function (_Component) {
  (0, _inherits3.default)(Comment, _Component);

  function Comment(props) {
    (0, _classCallCheck3.default)(this, Comment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Comment.__proto__ || (0, _getPrototypeOf2.default)(Comment)).call(this, props));

    _this.state = {
      comment: _this.props.review ? _this.props.review.comment : '',
      isEditing: _this.props.isEditing,
      isDirty: false
    };

    _this.handleCommentChangeBound = _this.handleCommentChange.bind(_this);
    _this.onSaveCommentClickBound = _this.onSaveCommentClick.bind(_this);
    _this.handleCompleteBound = _this.handleComplete.bind(_this);
    _this.handleCancelBound = _this.handleCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Comment, [{
    key: 'render',
    value: function render() {
      var review = this.props.review;
      var intl = this.context.intl;

      var comment = review ? review.comment : '';

      var options = (0, _assign2.default)({}, _index.simpleMDEOptions);
      options.initialValue = comment;
      options.autofocus = true;
      options.placeholder = intl.formatMessage(_placeholder.messages.typeYourComment);

      return _react2.default.createElement(
        'div',
        { className: 'shadow' },
        !this.state.isEditing && _react2.default.createElement(_MarkdownLabel2.default, {
          additionalCssClasses: 'comment-body',
          value: comment.body
        }),
        this.state.isEditing && _react2.default.createElement(
          'div',
          { className: 'edit-comment-area' },
          _react2.default.createElement(
            'div',
            { className: 'active-review-comment' },
            this.state.isDirty ? _react2.default.createElement(
              'div',
              {
                id: 'saveCommentButton',
                className: 'button active',
                onClick: this.onSaveCommentClickBound
              },
              _messages.save
            ) : _react2.default.createElement(
              'div',
              {
                id: 'saveCommentButton',
                className: 'button disabled',
                disabled: true
              },
              _messages.save
            ),
            _react2.default.createElement(_reactSimplemdeEditor2.default, {
              options: options,
              onChange: this.handleCommentChangeBound
            }),
            _react2.default.createElement(
              'div',
              { className: 'review-actions' },
              _react2.default.createElement(
                'div',
                {
                  className: this.getDoneButtonStateClass(review),
                  onClick: this.handleCompleteBound
                },
                _messages.submit
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'button cancel',
                  onClick: this.handleCancelBound
                },
                _messages.cancelReview
              )
            )
          )
        )
      );
    }
  }, {
    key: 'getDoneButtonStateClass',
    value: function getDoneButtonStateClass(review) {
      var buttonClass = 'button done ';
      if (review) {
        if (review.accepted === null) {
          buttonClass += 'disabled';
        } else if (review.accepted === false && !this.state.comment) {
          buttonClass += 'disabled';
        }
      }
      return buttonClass;
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      return this.props.handleCancel();
    }
  }, {
    key: 'handleComplete',
    value: function handleComplete(comment) {
      return this.props.handleComplete(this.state.comment);
    }
  }, {
    key: 'onSaveCommentClick',
    value: function onSaveCommentClick() {
      var _props = this.props,
          quest = _props.quest,
          review = _props.review,
          dispatch = _props.dispatch;

      dispatch((0, _review.editReviewComment)(quest.id, quest.reviewing_compiled_quest.id, review.id, this.state.comment));
      this.setState({ isDirty: false });
    }
  }, {
    key: 'handleCommentChange',
    value: function handleCommentChange(val) {
      var review = this.props.review;

      if (val !== review.comment) {
        this.setState({
          isDirty: true,
          comment: val
        });
      }
      // Clicking on the md editor when editor is empty returns an empty string, which causes setState({isDirty: true})
      // This checks to see if editor and saved comment are empty, and if so, keeps isDirty state at false
      if (!val && !review.comment) {
        this.setState({
          isDirty: false
        });
      }
    }
  }]);
  return Comment;
}(_react.Component);

Comment.propTypes = {
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object,
  quest: _propTypes2.default.object.isRequired,
  review: _propTypes2.default.object,
  isEditing: _propTypes2.default.bool,
  handleComplete: _propTypes2.default.func,
  handleCancel: _propTypes2.default.func
};

Comment.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user,
    quest: state.quest.item
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Comment);
exports.CommentDisconnected = Comment; // pure component - used in tests

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactCollapse = __webpack_require__(1552);

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _reactIntl = __webpack_require__(16);

var _PreviousReview = __webpack_require__(1561);

var _PreviousReview2 = _interopRequireDefault(_PreviousReview);

var _review = __webpack_require__(64);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviousReviewsList = function (_Component) {
  (0, _inherits3.default)(PreviousReviewsList, _Component);

  function PreviousReviewsList(props) {
    (0, _classCallCheck3.default)(this, PreviousReviewsList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PreviousReviewsList.__proto__ || (0, _getPrototypeOf2.default)(PreviousReviewsList)).call(this, props));

    _this.state = {
      collapsed: true
    };
    _this.onExpandReviewsClickBound = _this.onExpandReviewsClick.bind(_this);
    _this.onCollapseReviewsClickBound = _this.onCollapseReviewsClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PreviousReviewsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          previousReviewsNoCurrent = _props.previousReviewsNoCurrent,
          reviews = _props.reviews,
          reviewType = _props.reviewType;
      var intl = this.context.intl;

      var reviewsSorted = (0, _arraySort2.default)(reviews, ['completed_at'], {
        reverse: true
      });
      var previousReviewsCount = this.getPreviousReviewsCount();
      var prevReviews = reviewsSorted.map(function (review, index) {
        return _react2.default.createElement(_PreviousReview2.default, {
          review: review,
          key: index,
          previousNoCurrent: previousReviewsNoCurrent
        });
      });
      var intlReviewType = (0, _review.getIntlReviewTypeWithContext)(reviewType, intl, 'sentence');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactCollapse2.default,
          { isOpened: true, keepCollapsedContent: true },
          _react2.default.createElement(
            'ul',
            { className: this.getListClass() },
            prevReviews
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: this.onePreviousNoCurrent() ? 'hide-display-more' : 'more-reviews',
            onClick: this.state.collapsed === true ? this.onExpandReviewsClickBound : this.onCollapseReviewsClickBound
          },
          _react2.default.createElement(
            'div',
            { className: 'more-reviews-text' },
            this.state.collapsed === true && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Quest.Review.PreviousReviewsList.OlderReviews',
                  defaultMessage: '{count} {older} {reviewType} {val}',
                  values: {
                    count: previousReviewsCount,
                    older: _messages.older,
                    reviewType: intlReviewType,
                    val: previousReviewsCount === 1 ? _messages.review : _messages.reviews
                  },
                  r: true
                })
              ),
              _react2.default.createElement('div', { className: 'down-carat' })
            ),
            this.state.collapsed === false && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'up-carat' }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Quest.Review.PreviousReviewsList.HidePrevious',
                  defaultMessage: '{hide} {val}',
                  values: {
                    hide: _messages.hidePrevious,
                    val: previousReviewsCount === 1 ? _messages.review : _messages.reviews
                  }
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'getListClass',
    value: function getListClass() {
      var klass = 'previous-reviews-list';
      if (this.onePreviousNoCurrent()) {
        klass = 'no-current-one-previous';
      } else {
        if (this.state.collapsed === true) {
          klass = 'previous-reviews-list collapsed';
        } else {
          klass = 'previous-reviews-list expanded';
        }
      }

      return klass;
    }
  }, {
    key: 'onePreviousNoCurrent',
    value: function onePreviousNoCurrent() {
      return this.props.reviews.length === 1 && this.props.previousReviewsNoCurrent;
    }
  }, {
    key: 'onExpandReviewsClick',
    value: function onExpandReviewsClick() {
      this.setState({
        collapsed: false
      });
    }
  }, {
    key: 'onCollapseReviewsClick',
    value: function onCollapseReviewsClick() {
      this.setState({
        collapsed: true
      });
    }
  }, {
    key: 'getPreviousReviewsCount',
    value: function getPreviousReviewsCount() {
      var _props2 = this.props,
          previousReviewsNoCurrent = _props2.previousReviewsNoCurrent,
          reviews = _props2.reviews;

      var previousReviewsCount = reviews.length;

      if (previousReviewsNoCurrent) {
        previousReviewsCount -= 1;
      }

      return previousReviewsCount;
    }
  }]);
  return PreviousReviewsList;
}(_react.Component);

exports.default = PreviousReviewsList;


PreviousReviewsList.propTypes = {
  reviews: _propTypes2.default.array.isRequired,
  previousReviewsNoCurrent: _propTypes2.default.bool,
  reviewType: _propTypes2.default.string
};

PreviousReviewsList.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(689),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__(1560),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1554);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1555);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1556);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1558);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(690);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(343);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1559);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(466);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(343);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(467);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(468);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(469);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

var Motion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
    children: _propTypes2['default'].func.isRequired,
    onRest: _propTypes2['default'].func
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  },

  wasAnimating: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyle: null,
  // after checking for unreadPropStyle != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
    var dirty = false;
    var _state = this.state;
    var currentStyle = _state.currentStyle;
    var currentVelocity = _state.currentVelocity;
    var lastIdealStyle = _state.lastIdealStyle;
    var lastIdealVelocity = _state.lastIdealVelocity;

    for (var key in destStyle) {
      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
        continue;
      }

      var styleValue = destStyle[key];
      if (typeof styleValue === 'number') {
        if (!dirty) {
          dirty = true;
          currentStyle = _extends({}, currentStyle);
          currentVelocity = _extends({}, currentVelocity);
          lastIdealStyle = _extends({}, lastIdealStyle);
          lastIdealVelocity = _extends({}, lastIdealVelocity);
        }

        currentStyle[key] = styleValue;
        currentVelocity[key] = 0;
        lastIdealStyle[key] = styleValue;
        lastIdealVelocity[key] = 0;
      }
    }

    if (dirty) {
      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // check if we need to animate in the first place
      var propsStyle = _this.props.style;
      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
        if (_this.wasAnimating && _this.props.onRest) {
          _this.props.onRest();
        }

        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.wasAnimating = false;
        _this.accumulatedTime = 0;
        return;
      }

      _this.wasAnimating = true;

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyle = {};
      var newLastIdealVelocity = {};
      var newCurrentStyle = {};
      var newCurrentVelocity = {};

      for (var key in propsStyle) {
        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
          continue;
        }

        var styleValue = propsStyle[key];
        if (typeof styleValue === 'number') {
          newCurrentStyle[key] = styleValue;
          newCurrentVelocity[key] = 0;
          newLastIdealStyle[key] = styleValue;
          newLastIdealVelocity[key] = 0;
        } else {
          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
          for (var i = 0; i < framesToCatchUp; i++) {
            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            newLastIdealStyleValue = _stepper[0];
            newLastIdealVelocityValue = _stepper[1];
          }

          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

          var nextIdealX = _stepper2[0];
          var nextIdealV = _stepper2[1];

          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
          newLastIdealStyle[key] = newLastIdealStyleValue;
          newLastIdealVelocity[key] = newLastIdealVelocityValue;
        }
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyle: newCurrentStyle,
        currentVelocity: newCurrentVelocity,
        lastIdealStyle: newLastIdealStyle,
        lastIdealVelocity: newLastIdealVelocity
      });

      _this.unreadPropStyle = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = Motion;
module.exports = exports['default'];

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(466);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(343);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(467);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(468);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(469);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = _createReactClass2['default']({
  propTypes: {
    // TOOD: warn against putting a config in here
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
    styles: _propTypes2['default'].func.isRequired,
    children: _propTypes2['default'].func.isRequired
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  },

  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _state = this.state;
    var currentStyles = _state.currentStyles;
    var currentVelocities = _state.currentVelocities;
    var lastIdealStyles = _state.lastIdealStyles;
    var lastIdealVelocities = _state.lastIdealVelocities;

    var someDirty = false;
    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i];
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            someDirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
        }
      }
    }

    if (someDirty) {
      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
    }
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      var destStyles = _this.props.styles(_this.state.lastIdealStyles);

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var newLastIdealStyles = [];
      var newLastIdealVelocities = [];
      var newCurrentStyles = [];
      var newCurrentVelocities = [];

      for (var i = 0; i < destStyles.length; i++) {
        var destStyle = destStyles[i];
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in destStyle) {
          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
            continue;
          }

          var styleValue = destStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _mapToZero = __webpack_require__(466);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(343);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(467);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1557);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(468);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(221);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(469);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(58);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = _createReactClass2['default']({
  propTypes: {
    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
    })),
    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      key: _propTypes2['default'].string.isRequired,
      data: _propTypes2['default'].any,
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
    }))]).isRequired,
    children: _propTypes2['default'].func.isRequired,
    willEnter: _propTypes2['default'].func,
    willLeave: _propTypes2['default'].func,
    didLeave: _propTypes2['default'].func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    };
  },

  getInitialState: function getInitialState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync[0];
    var currentStyles = _mergeAndSync[1];
    var currentVelocities = _mergeAndSync[2];
    var lastIdealStyles = _mergeAndSync[3];
    var lastIdealVelocities = _mergeAndSync[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  },

  unmounting: false,
  animationID: null,
  prevTime: 0,
  accumulatedTime: 0,
  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400
  unreadPropStyles: null,
  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)
  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);

    var mergedPropsStyles = _mergeAndSync2[0];
    var currentStyles = _mergeAndSync2[1];
    var currentVelocities = _mergeAndSync2[2];
    var lastIdealStyles = _mergeAndSync2[3];
    var lastIdealVelocities = _mergeAndSync2[4];

    for (var i = 0; i < unreadPropStyles.length; i++) {
      var unreadPropStyle = unreadPropStyles[i].style;
      var dirty = false;

      for (var key in unreadPropStyle) {
        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
          continue;
        }

        var styleValue = unreadPropStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyles[i] = _extends({}, currentStyles[i]);
            currentVelocities[i] = _extends({}, currentVelocities[i]);
            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            mergedPropsStyles[i] = {
              key: mergedPropsStyles[i].key,
              data: mergedPropsStyles[i].data,
              style: _extends({}, mergedPropsStyles[i].style)
            };
          }
          currentStyles[i][key] = styleValue;
          currentVelocities[i][key] = 0;
          lastIdealStyles[i][key] = styleValue;
          lastIdealVelocities[i][key] = 0;
          mergedPropsStyles[i].style[key] = styleValue;
        }
      }
    }

    // unlike the other 2 components, we can't detect staleness and optionally
    // opt out of setState here. each style object's data might contain new
    // stuff we're not/cannot compare
    this.setState({
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      mergedPropsStyles: mergedPropsStyles,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities
    });
  },

  startAnimationIfNecessary: function startAnimationIfNecessary() {
    var _this = this;

    if (this.unmounting) {
      return;
    }

    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
    // call cb? No, otherwise accidental parent rerender causes cb trigger
    this.animationID = _raf2['default'](function (timestamp) {
      // https://github.com/chenglou/react-motion/pull/420
      // > if execution passes the conditional if (this.unmounting), then
      // executes async defaultRaf and after that component unmounts and after
      // that the callback of defaultRaf is called, then setState will be called
      // on unmounted component.
      if (_this.unmounting) {
        return;
      }

      var propStyles = _this.props.styles;
      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

      // check if we need to animate in the first place
      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.accumulatedTime = 0;
        return;
      }

      var currentTime = timestamp || _performanceNow2['default']();
      var timeDelta = currentTime - _this.prevTime;
      _this.prevTime = currentTime;
      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
      // more than 10 frames? prolly switched browser tab. Restart
      if (_this.accumulatedTime > msPerFrame * 10) {
        _this.accumulatedTime = 0;
      }

      if (_this.accumulatedTime === 0) {
        // no need to cancel animationID here; shouldn't have any in flight
        _this.animationID = null;
        _this.startAnimationIfNecessary();
        return;
      }

      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var newMergedPropsStyles = _mergeAndSync3[0];
      var newCurrentStyles = _mergeAndSync3[1];
      var newCurrentVelocities = _mergeAndSync3[2];
      var newLastIdealStyles = _mergeAndSync3[3];
      var newLastIdealVelocities = _mergeAndSync3[4];

      for (var i = 0; i < newMergedPropsStyles.length; i++) {
        var newMergedPropsStyle = newMergedPropsStyles[i].style;
        var newCurrentStyle = {};
        var newCurrentVelocity = {};
        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};

        for (var key in newMergedPropsStyle) {
          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
            continue;
          }

          var styleValue = newMergedPropsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = newLastIdealStyles[i][key];
            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
            for (var j = 0; j < framesToCatchUp; j++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        newLastIdealStyles[i] = newLastIdealStyle;
        newLastIdealVelocities[i] = newLastIdealVelocity;
        newCurrentStyles[i] = newCurrentStyle;
        newCurrentVelocities[i] = newCurrentVelocity;
      }

      _this.animationID = null;
      // the amount we're looped over above
      _this.accumulatedTime -= framesToCatchUp * msPerFrame;

      _this.setState({
        currentStyles: newCurrentStyles,
        currentVelocities: newCurrentVelocities,
        lastIdealStyles: newLastIdealStyles,
        lastIdealVelocities: newLastIdealVelocities,
        mergedPropsStyles: newMergedPropsStyles
      });

      _this.unreadPropStyles = null;

      _this.startAnimationIfNecessary();
    });
  },

  componentDidMount: function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  },

  render: function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  }
});

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(690);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__(689);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _oeWebCommon = __webpack_require__(117);

var _review = __webpack_require__(64);

var _name = __webpack_require__(149);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviousReview = function (_Component) {
  (0, _inherits3.default)(PreviousReview, _Component);

  function PreviousReview() {
    (0, _classCallCheck3.default)(this, PreviousReview);
    return (0, _possibleConstructorReturn3.default)(this, (PreviousReview.__proto__ || (0, _getPrototypeOf2.default)(PreviousReview)).apply(this, arguments));
  }

  (0, _createClass3.default)(PreviousReview, [{
    key: 'render',
    value: function render() {
      var review = this.props.review;
      var reviewer = review.reviewer,
          criteria = review.criteria;

      var intlReviewType = (0, _review.getIntlReviewType)(criteria);

      return _react2.default.createElement(
        'div',
        { className: this.getPreviousReviewClass() },
        _react2.default.createElement(
          'div',
          {
            className: 'review-header ' + (review && !review.completed ? (0, _review.getReviewApprovalStatus)(review) : '')
          },
          intlReviewType
        ),
        _react2.default.createElement(
          'div',
          { className: 'approval-rejection-info' },
          _react2.default.createElement(
            'strong',
            null,
            (0, _review.getCompletedReviewInfo)(review)
          ),
          '\xA0\xA0',
          _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
            date: review.completed_at,
            includeTime: false
          }),
          ' at ',
          _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: review.completed_at })
        ),
        _react2.default.createElement(
          'div',
          { className: 'completed-review-comment-wrapper' },
          review && review.comment && review.comment.length > 0 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'completed-review-comment' },
              _react2.default.createElement(_MarkdownLabel2.default, {
                additionalCssClasses: 'completed-review-comment',
                value: review.comment
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'reviewer-info-container' },
              _react2.default.createElement(
                'div',
                { className: 'user-photo-wrapper' },
                _react2.default.createElement('img', { src: reviewer.photo_url })
              ),
              _react2.default.createElement(
                _UserName2.default,
                {
                  activeCertifications: reviewer.active_certifications,
                  userId: 'previous-review-' + reviewer.id,
                  rebuild: true
                },
                _react2.default.createElement(
                  'div',
                  { className: 'reviewer-name' },
                  (0, _name.getUserDisplayName)(reviewer)
                )
              )
            )
          ),
          review && (!review.comment || review.comment.length === 0) && _react2.default.createElement(
            'div',
            { className: 'no-review-comment' },
            _react2.default.createElement(
              'div',
              { className: 'user-photo-wrapper' },
              _react2.default.createElement('img', { src: reviewer.photo_url })
            ),
            _react2.default.createElement(
              _UserName2.default,
              {
                activeCertifications: reviewer.active_certifications,
                userId: 'previous-review-' + reviewer.id,
                rebuild: true
              },
              _react2.default.createElement(
                'div',
                { className: 'reviewer-name' },
                (0, _name.getUserDisplayName)(reviewer)
              )
            )
          )
        )
      );
    }
  }, {
    key: 'getPreviousReviewClass',
    value: function getPreviousReviewClass() {
      var cssClass = 'completed-review previous-review';
      this.props.previousNoCurrent ? cssClass += ' previous-no-current' : '';

      return cssClass;
    }
  }]);
  return PreviousReview;
}(_react.Component);

exports.default = PreviousReview;


PreviousReview.propTypes = {
  review: _propTypes2.default.object.isRequired,
  previousNoCurrent: _propTypes2.default.bool
};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Guidelines = function Guidelines() {
  return _react2.default.createElement(
    'p',
    { className: 'guidelines' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'QualityReview.AllQuestsAreEvaluated',
      defaultMessage: '{allQuestsAreEvaluated} {afterTheInternalProcessIsComplete} {usingThe} {guidelines}',
      values: {
        allQuestsAreEvaluated: _messages.allQuestsAreEvaluated,
        afterTheInternalProcessIsComplete: _messages.afterTheInternalProcessIsComplete,
        usingThe: _messages.usingThe,
        guidelines: _react2.default.createElement(
          'a',
          {
            href: 'https://questforward.zendesk.com/hc/en-us/articles/360000115811-Quest-Quality-Review-Guidelines',
            target: '_blank'
          },
          _messages.questQualityReviewGuidelines
        )
      }
    }),
    '.\xA0',
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'QualityReview.UponApproval',
      defaultMessage: 'Upon approval, the quest is published and released to the Quest! app.'
    })
  );
};

exports.default = Guidelines;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillsDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _questskills = __webpack_require__(305);

var _Intro5am = __webpack_require__(693);

var _Intro5am2 = _interopRequireDefault(_Intro5am);

var _SkillAdd = __webpack_require__(1564);

var _SkillAdd2 = _interopRequireDefault(_SkillAdd);

var _SkillsList = __webpack_require__(1566);

var _SkillsList2 = _interopRequireDefault(_SkillsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Skills = function (_React$Component) {
  (0, _inherits3.default)(Skills, _React$Component);

  function Skills() {
    (0, _classCallCheck3.default)(this, Skills);
    return (0, _possibleConstructorReturn3.default)(this, (Skills.__proto__ || (0, _getPrototypeOf2.default)(Skills)).apply(this, arguments));
  }

  (0, _createClass3.default)(Skills, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _questskills.fetchQuestSkills)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          skills = _props.skills,
          isFetching = _props.isFetching,
          dispatch = _props.dispatch,
          allowEdit = _props.allowEdit,
          frameworkSkills = _props.frameworkSkills;


      var skillsIds = skills.map(function (s) {
        return s.framework_skill_id;
      });
      var filteredSkills = frameworkSkills.filter(function (s) {
        return !skillsIds.includes(s.id);
      });

      if (isFetching) {
        return _react2.default.createElement('div', { className: 'loading' });
      }

      return _react2.default.createElement(
        'div',
        { className: 'skills' },
        allowEdit && _react2.default.createElement(_SkillAdd2.default, { dispatch: dispatch, frameworkSkills: filteredSkills }),
        skills.length === 0 ? _react2.default.createElement(
          _Intro5am2.default,
          { style: { margin: '44px auto', textAlign: 'center' } },
          'No skills are linked to this quest.'
        ) : _react2.default.createElement(_SkillsList2.default, {
          skills: skills,
          dispatch: dispatch,
          allowEdit: allowEdit
        })
      );
    }
  }]);
  return Skills;
}(_react2.default.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.quest.isFetchingQuestSkills,
    skills: state.quest.skills,
    frameworkSkills: state.frameworkskills.items
  };
};

Skills.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  skills: _propTypes2.default.array.isRequired,
  allowEdit: _propTypes2.default.bool.isRequired,
  frameworkSkills: _propTypes2.default.array.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Skills);
exports.SkillsDisconnected = Skills;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 92%;\n  border-radius: 7px;\n  background-color: #f5f5f5;\n  padding: 25px 29px;\n  margin-bottom: 26px;\n\n  .Select-menu-outer,\n  .Select-menu {\n    max-height: unset !important;\n  }\n'], ['\n  width: 92%;\n  border-radius: 7px;\n  background-color: #f5f5f5;\n  padding: 25px 29px;\n  margin-bottom: 26px;\n\n  .Select-menu-outer,\n  .Select-menu {\n    max-height: unset !important;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Search = __webpack_require__(1565);

var _Search2 = _interopRequireDefault(_Search);

var _questskills = __webpack_require__(305);

var _animation = __webpack_require__(694);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillsSearchContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SkillAdd__SkillsSearchContainer',
  componentId: 'sc-17ohe1y-0'
})(_templateObject);

var SkillAdd = function (_React$Component) {
  (0, _inherits3.default)(SkillAdd, _React$Component);

  function SkillAdd() {
    (0, _classCallCheck3.default)(this, SkillAdd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SkillAdd.__proto__ || (0, _getPrototypeOf2.default)(SkillAdd)).call(this));

    _this.addQuestSkillBound = _this.addQuestSkill.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SkillAdd, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        SkillsSearchContainer,
        null,
        _react2.default.createElement(_Search2.default, {
          frameworkSkills: this.props.frameworkSkills,
          onSkillSelect: this.addQuestSkillBound
        })
      );
    }
  }, {
    key: 'addQuestSkill',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(skill) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _questskills.addQuestSkill)(skill.id));

              case 2:

                // "flash" animation for newly added skill
                (0, _animation.flashNewItem)({
                  itemId: 'skill-' + skill.id,
                  classToAdd: null,
                  autoscroll: false
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addQuestSkill(_x) {
        return _ref.apply(this, arguments);
      }

      return addQuestSkill;
    }()
  }]);
  return SkillAdd;
}(_react2.default.Component);

SkillAdd.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  frameworkSkills: _propTypes2.default.array.isRequired
};

exports.default = SkillAdd;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search() {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this));

    _this.handleSelectChangeBound = _this.handleSelectChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Search, [{
    key: 'render',
    value: function render() {
      var frameworkSkills = this.props.frameworkSkills;


      return _react2.default.createElement(_reactSelect2.default, {
        searchable: true,
        clearable: true,
        options: this.mapList(frameworkSkills),
        onChange: this.handleSelectChangeBound,
        placeholder: 'Select skills to link.'
      });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(value) {
      this.props.onSkillSelect(value);
    }
  }, {
    key: 'mapList',
    value: function mapList(skills) {
      var values = skills.map(function (skill) {
        return {
          id: skill.id,
          value: skill.id,
          label: skill.name
        };
      });

      return (0, _arraySort2.default)(values, ['label']);
    }
  }]);
  return Search;
}(_react.Component);

exports.default = Search;


Search.propTypes = {
  frameworkSkills: _propTypes2.default.array.isRequired,
  onSkillSelect: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-top: 1px solid #bbbbbb;\n  padding-bottom: 35px !important;\n'], ['\n  border-top: 1px solid #bbbbbb;\n  padding-bottom: 35px !important;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SkillItem = __webpack_require__(1567);

var _SkillItem2 = _interopRequireDefault(_SkillItem);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillsListContainer = _styledComponents2.default.ul.withConfig({
  displayName: 'SkillsList__SkillsListContainer',
  componentId: 'py8our-0'
})(_templateObject);

var SkillsList = function SkillsList(_ref) {
  var skills = _ref.skills,
      dispatch = _ref.dispatch,
      allowEdit = _ref.allowEdit;

  var sortedSkills = (0, _arraySort2.default)(skills, 'name');

  var skillsList = sortedSkills.map(function (s) {
    return _react2.default.createElement(_SkillItem2.default, {
      key: s.skill_framework_id,
      skill: s,
      dispatch: dispatch,
      allowEdit: allowEdit
    });
  });

  return _react2.default.createElement(
    SkillsListContainer,
    null,
    skillsList
  );
};

SkillsList.propTypes = {
  skills: _propTypes2.default.array.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  allowEdit: _propTypes2.default.bool.isRequired
};

exports.default = SkillsList;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding: 12px 30px 12px 0px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #bbbbbb;\n'], ['\n  padding: 12px 30px 12px 0px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #bbbbbb;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  width: 12px;\n  height: 15px;\n  cursor: pointer;\n  margin-left: auto;\n\n  &:hover {\n    background: url(', ') no-repeat;\n  }\n'], ['\n  background: url(', ') no-repeat;\n  width: 12px;\n  height: 15px;\n  cursor: pointer;\n  margin-left: auto;\n\n  &:hover {\n    background: url(', ') no-repeat;\n  }\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 17px;\n  width: 14px;\n  margin-right: 12px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 17px;\n  width: 14px;\n  margin-right: 12px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _icon_delete = __webpack_require__(471);

var _icon_delete2 = _interopRequireDefault(_icon_delete);

var _icon_delete_redhover = __webpack_require__(630);

var _icon_delete_redhover2 = _interopRequireDefault(_icon_delete_redhover);

var _icon_link = __webpack_require__(1568);

var _icon_link2 = _interopRequireDefault(_icon_link);

var _questskills = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillItemContainer = _styledComponents2.default.div.withConfig({
  displayName: 'SkillItem__SkillItemContainer',
  componentId: 'sc-4kgwye-0'
})(_templateObject);

var StyledIconDelete = _styledComponents2.default.div.withConfig({
  displayName: 'SkillItem__StyledIconDelete',
  componentId: 'sc-4kgwye-1'
})(_templateObject2, _icon_delete2.default, _icon_delete_redhover2.default);

var StyledIconLink = _styledComponents2.default.div.withConfig({
  displayName: 'SkillItem__StyledIconLink',
  componentId: 'sc-4kgwye-2'
})(_templateObject3, _icon_link2.default);

var SkillItem = function (_React$Component) {
  (0, _inherits3.default)(SkillItem, _React$Component);

  function SkillItem() {
    (0, _classCallCheck3.default)(this, SkillItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SkillItem.__proto__ || (0, _getPrototypeOf2.default)(SkillItem)).call(this));

    _this.onDeleteClickBound = _this.onDeleteClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SkillItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          skill = _props.skill,
          allowEdit = _props.allowEdit;


      return _react2.default.createElement(
        SkillItemContainer,
        { id: 'skill-' + skill.framework_skill_id },
        _react2.default.createElement(StyledIconLink, null),
        _react2.default.createElement(
          _H2.default,
          { textTruncate: true },
          skill.name
        ),
        allowEdit && _react2.default.createElement(StyledIconDelete, { onClick: this.onDeleteClickBound })
      );
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick() {
      var confirmation = window.confirm('Are you sure you want to remove this skill link?');
      if (confirmation) {
        this.props.dispatch((0, _questskills.deleteQuestSkill)(this.props.skill.framework_skill_id));
      }
    }
  }]);
  return SkillItem;
}(_react2.default.Component);

SkillItem.propTypes = {
  skill: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  allowEdit: _propTypes2.default.bool.isRequired
};

exports.default = SkillItem;

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _StudentStat = __webpack_require__(1570);

var _StudentStat2 = _interopRequireDefault(_StudentStat);

var _utils = __webpack_require__(20);

var _userstats = __webpack_require__(472);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentStats = function StudentStats(props) {
  var hasNoCompletedQuests = !(0, _userstats.hasCompletedQuests)(props.stats);

  return _react2.default.createElement(
    'div',
    {
      className: 'student-stats ' + (props.multipleVersionsExist ? 'multipleVersionsExist' : '')
    },
    _react2.default.createElement(
      'div',
      { className: 'label-wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'label' },
        'student stats'
      ),
      props.multipleVersionsExist && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'publishedStats',
          effect: 'solid',
          offset: { bottom: 8 }
        }),
        _react2.default.createElement(
          'div',
          {
            'data-for': 'publishedStats',
            'data-tip': 'Stats for published versions of this quest',
            className: 'previous-versions'
          },
          'Previous Versions'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'stats-wrapper' },
      _react2.default.createElement(_StudentStat2.default, {
        type: 'average_learner_rating',
        value: (0, _utils.displayNumberRoundedToTenth)(props.stats.average_learner_rating),
        hasNoCompletedQuests: hasNoCompletedQuests,
        formatEmptyWithNA: true,
        multipleVersionsExist: props.multipleVersionsExist
      }),
      _react2.default.createElement('div', { className: 'vertical-divider' }),
      _react2.default.createElement(_StudentStat2.default, {
        type: 'average_learner_effort',
        value: (0, _utils.displayNumberRoundedToTenth)(props.stats.average_learner_effort),
        hasNoCompletedQuests: hasNoCompletedQuests,
        formatEmptyWithNA: true,
        multipleVersionsExist: props.multipleVersionsExist
      }),
      _react2.default.createElement('div', { className: 'vertical-divider' }),
      _react2.default.createElement(_StudentStat2.default, {
        type: 'percent_quests_recommended',
        value: (0, _utils.displayNumberAsPercentage)(props.stats.percent_quests_recommended),
        hasNoCompletedQuests: hasNoCompletedQuests,
        formatEmptyWithNA: true,
        multipleVersionsExist: props.multipleVersionsExist
      }),
      _react2.default.createElement('div', { className: 'vertical-divider' }),
      _react2.default.createElement(_StudentStat2.default, {
        type: 'quests_in_progress_by_learners_count',
        value: (0, _userstats.formatQuestCountDisplay)(props.stats.quests_in_progress_count),
        hasNoCompletedQuests: hasNoCompletedQuests,
        multipleVersionsExist: props.multipleVersionsExist
      }),
      _react2.default.createElement('div', { className: 'vertical-divider' }),
      _react2.default.createElement(_StudentStat2.default, {
        type: 'quests_completed_by_learners_count',
        value: (0, _userstats.formatQuestCountDisplay)(props.stats.quests_completed_count),
        hasNoCompletedQuests: hasNoCompletedQuests,
        multipleVersionsExist: props.multipleVersionsExist
      })
    )
  );
};

StudentStats.propTypes = {
  stats: _propTypes2.default.object.isRequired,
  multipleVersionsExist: _propTypes2.default.bool.isRequired
};

exports.default = StudentStats;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _studentstats = __webpack_require__(1571);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudentStat = function (_Component) {
  (0, _inherits3.default)(StudentStat, _Component);

  function StudentStat(props) {
    (0, _classCallCheck3.default)(this, StudentStat);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StudentStat.__proto__ || (0, _getPrototypeOf2.default)(StudentStat)).call(this, props));

    _this.onHoverBound = _this.onHover.bind(_this);
    _this.state = { hover: false };
    return _this;
  }

  (0, _createClass3.default)(StudentStat, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          hasNoCompletedQuests = _props.hasNoCompletedQuests;

      return _react2.default.createElement(
        'div',
        { className: 'user-stat' },
        _react2.default.createElement(_reactTooltip2.default, {
          id: type + '-tooltip',
          effect: 'solid',
          offset: { bottom: 10 }
        }),
        _react2.default.createElement('div', { className: 'icon ' + type + ' ' + (this.state.hover ? 'hover' : '') }),
        _react2.default.createElement(
          'div',
          {
            className: 'stat-value',
            onMouseEnter: this.onHoverBound,
            onMouseLeave: this.onHoverBound,
            'data-for': type + '-tooltip',
            'data-tip': _studentstats.tooltipText[type]
          },
          hasNoCompletedQuests && this.props.formatEmptyWithNA ? 'N/A' : this.props.value
        )
      );
    }
  }, {
    key: 'onHover',
    value: function onHover() {
      this.setState(function (prevState) {
        return {
          hover: !prevState.hover
        };
      });
    }
  }]);
  return StudentStat;
}(_react.Component);

exports.default = StudentStat;


StudentStat.propTypes = {
  type: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  hasNoCompletedQuests: _propTypes2.default.bool.isRequired,
  formatEmptyWithNA: _propTypes2.default.bool
};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var tooltipText = exports.tooltipText = {
  average_learner_rating: 'Average student rating of this quest (1-5)',
  average_learner_effort: 'Average student effort rating of this quest (1-3)',
  percent_quests_recommended: '% of students that recommend this quest',
  quests_in_progress_by_learners_count: 'Students working on this quest right now',
  quests_completed_by_learners_count: 'This quest completed by students'
};

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TopicAdd = __webpack_require__(1573);

var _TopicAdd2 = _interopRequireDefault(_TopicAdd);

var _List = __webpack_require__(1588);

var _List2 = _interopRequireDefault(_List);

var _Intro5am = __webpack_require__(693);

var _Intro5am2 = _interopRequireDefault(_Intro5am);

var _topics = __webpack_require__(238);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Topics = function (_Component) {
  (0, _inherits3.default)(Topics, _Component);

  function Topics() {
    (0, _classCallCheck3.default)(this, Topics);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Topics.__proto__ || (0, _getPrototypeOf2.default)(Topics)).call(this));

    _this.changeContextBound = _this.changeContext.bind(_this);
    _this.deleteTopicBound = _this.deleteTopic.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Topics, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          topics = _props.topics,
          dispatch = _props.dispatch,
          allowEdit = _props.allowEdit;


      return _react2.default.createElement(
        'div',
        { className: 'topics' },
        allowEdit && _react2.default.createElement(_TopicAdd2.default, {
          questId: this.props.questId,
          dispatch: dispatch,
          topicSearchResults: this.props.topicSearchResults,
          isSearching: this.props.isSearching
        }),
        topics && topics.length > 0 && _react2.default.createElement(
          'div',
          { id: 'questTopicList' },
          _react2.default.createElement(_List2.default, {
            topics: topics,
            hideActions: !allowEdit,
            dispatch: dispatch,
            lines: 3,
            deleteTopic: this.deleteTopicBound,
            changeContext: this.changeContextBound
          })
        ),
        !topics || topics.length === 0 && _react2.default.createElement(
          _Intro5am2.default,
          { style: { margin: '44px auto', textAlign: 'center' } },
          'No topics are linked to this quest.'
        )
      );
    }
  }, {
    key: 'deleteTopic',
    value: function deleteTopic(topicId) {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          questId = _props2.questId;

      var confirmation = confirm('Are you sure you want to remove this topic/standard link?');
      if (confirmation) {
        dispatch((0, _topics.deleteTopic)(questId, topicId));
      }
    }
  }, {
    key: 'changeContext',
    value: function changeContext(topicId, context) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          questId = _props3.questId;

      dispatch((0, _topics.changeTopicContext)(questId, topicId, context));
    }
  }]);
  return Topics;
}(_react.Component);

Topics.propTypes = {
  topics: _propTypes2.default.array,
  dispatch: _propTypes2.default.func.isRequired,
  topicSearchResults: _propTypes2.default.array.isRequired,
  isSearching: _propTypes2.default.bool.isRequired,
  questId: _propTypes2.default.number.isRequired,
  allowEdit: _propTypes2.default.bool.isRequired
};

exports.default = Topics;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Search = __webpack_require__(1574);

var _Search2 = _interopRequireDefault(_Search);

var _topics = __webpack_require__(238);

var _animation = __webpack_require__(694);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicAdd = function (_Component) {
  (0, _inherits3.default)(TopicAdd, _Component);

  function TopicAdd(props) {
    (0, _classCallCheck3.default)(this, TopicAdd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopicAdd.__proto__ || (0, _getPrototypeOf2.default)(TopicAdd)).call(this, props));

    _this.state = {
      newTopicType: ''
    };

    _this.onSelectNewTopicBound = _this.onSelectNewTopic.bind(_this);
    _this.addTopicBound = _this.addTopic.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TopicAdd, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'topic-add' },
        _react2.default.createElement(
          'div',
          { className: 'header-label' },
          'Select the subtopics and standards that align with the content or skills in this quest. Make sure that the quest provides ample opportunity for students to develop content knowledge or skills in the subtopic or standard you select. You may link this quest to multiple subtopics from any number of topic clouds or standard sets.'
        ),
        _react2.default.createElement(
          'div',
          { id: 'addLinkedTopic' },
          _react2.default.createElement(
            'h3',
            null,
            'Link this quest to a topic or standard:'
          ),
          _react2.default.createElement(
            'div',
            { id: 'topicContextSelect' },
            _react2.default.createElement(
              'div',
              { className: 'context-toggle' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                  type: 'radio',
                  id: 'direct',
                  name: 'topiccontext',
                  className: 'form-control context direct',
                  onClick: this.onSelectNewTopicBound
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'direct' },
                  _messages.direct
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', {
                  type: 'radio',
                  id: 'supplemental',
                  name: 'topiccontext',
                  className: 'form-control context supplemental',
                  onClick: this.onSelectNewTopicBound
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'supplemental' },
                  _messages.supplemental
                )
              )
            )
          ),
          this.state.newTopicType && _react2.default.createElement(_Search2.default, {
            searchResults: this.props.topicSearchResults,
            addItem: this.addTopicBound,
            dispatch: this.props.dispatch,
            isSearching: this.props.isSearching,
            searchItems: _topics.searchTopics
          })
        )
      );
    }
  }, {
    key: 'onSelectNewTopic',
    value: function onSelectNewTopic(e) {
      this.setState({
        newTopicType: e.target.id
      });
    }
  }, {
    key: 'addTopic',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(topicId) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _topics.addTopic)(this.props.questId, topicId, this.state.newTopicType));

              case 2:

                // "flash" animation for newly added topic
                (0, _animation.flashNewItem)({
                  itemId: topicId,
                  classToAdd: 'quest-topic editing',
                  autoscroll: true
                });
                // Reset the context radio input and component state
                document.getElementById(this.state.newTopicType).checked = false;
                this.setState(function () {
                  return {
                    newTopicType: ''
                  };
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addTopic(_x) {
        return _ref.apply(this, arguments);
      }

      return addTopic;
    }()
  }]);
  return TopicAdd;
}(_react.Component);

exports.default = TopicAdd;


TopicAdd.propTypes = {
  questId: _propTypes2.default.number,
  dispatch: _propTypes2.default.func,
  topicSearchResults: _propTypes2.default.array,
  isSearching: _propTypes2.default.bool
};

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = __webpack_require__(1575);

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _reactIntl = __webpack_require__(16);

var _SearchItem = __webpack_require__(1587);

var _SearchItem2 = _interopRequireDefault(_SearchItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search(props) {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props));

    _this.onChange = function (event, _ref) {
      var newValue = _ref.newValue;

      var noSuggestions = newValue === '';
      _this.setState({
        value: newValue,
        noSuggestions: noSuggestions
      });
      if (newValue && newValue.length > 2) {
        _this.props.dispatch(_this.props.searchItems(newValue));
      }
    };

    _this.onSuggestionsFetchRequested = function (_ref2) {
      var value = _ref2.value;

      _this.loadSuggestions(value);
    };

    _this.onSuggestionsClearRequested = function () {
      _this.setState({
        suggestions: [],
        noSuggestions: false
      });
    };

    _this.state = {
      value: '',
      suggestions: [],
      noSuggestions: false
    };

    _this.lastRequestId = null;
    _this.selectItemBound = _this.selectItem.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Search, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.searchResults !== nextProps.searchResults && this.state.value.length > 2) {
        this.setState({
          suggestions: nextProps.searchResults,
          noSuggestions: nextProps.searchResults.length === 0
        });
      }
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions(value) {
      var inputValue = value.trim().toLowerCase();
      var inputLength = inputValue.length;
      return inputLength < 3 ? [] : this.props.searchResults;
    }
  }, {
    key: 'getSuggestionValue',
    value: function getSuggestionValue(suggestion) {
      return suggestion.name;
    }
  }, {
    key: 'renderSuggestion',
    value: function renderSuggestion(suggestion) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_SearchItem2.default, { topic: suggestion })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          value = _state.value,
          suggestions = _state.suggestions,
          noSuggestions = _state.noSuggestions;


      var placeholder = 'Search for the topic or standard by typing its name here';

      var inputProps = {
        placeholder: placeholder,
        value: value,
        onChange: this.onChange
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactAutosuggest2.default, {
          suggestions: suggestions,
          onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
          onSuggestionsClearRequested: this.onSuggestionsClearRequested,
          getSuggestionValue: this.getSuggestionValue,
          renderSuggestion: this.renderSuggestion,
          inputProps: inputProps,
          onSuggestionSelected: this.selectItemBound,
          renderInputComponent: this.renderInputComponent
        }),
        noSuggestions && value.length > 2 && !this.props.isSearching && _react2.default.createElement(
          'div',
          { className: 'autocomplete-result', id: 'noMatches' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'ActivityTopics.Search.NoMatches',
            defaultMessage: 'No matches found'
          })
        )
      );
    }
  }, {
    key: 'renderInputComponent',
    value: function renderInputComponent(inputProps) {
      return _react2.default.createElement(
        'div',
        { id: 'topicSearch' },
        _react2.default.createElement(
          'div',
          { className: 'search' },
          _react2.default.createElement(
            'div',
            { className: 'form-control', id: 'topicInput' },
            _react2.default.createElement('input', inputProps)
          )
        )
      );
    }
  }, {
    key: 'loadSuggestions',
    value: function loadSuggestions(value) {
      var _this2 = this;

      // Cancel the previous request
      if (this.lastRequestId !== null) {
        clearTimeout(this.lastRequestId);
      }

      this.lastRequestId = setTimeout(function () {
        _this2.setState({
          suggestions: _this2.getSuggestions(value)
        });
      }, 1000);
    }
  }, {
    key: 'selectItem',
    value: function selectItem(e, _ref3) {
      var suggestion = _ref3.suggestion;

      this.props.addItem(suggestion.id);
      this.setState({
        value: '',
        suggestions: [],
        noSuggestions: false
      });
    }
  }]);
  return Search;
}(_react.Component);

exports.default = Search;


Search.propTypes = {
  searchResults: _propTypes2.default.array,
  addItem: _propTypes2.default.func,
  dispatch: _propTypes2.default.func,
  isSearching: _propTypes2.default.bool,
  searchItems: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1576).default;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(1577);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(1578);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(1586);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqualArrays;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1579).default;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(1580);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(1581);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(1583);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(1584);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }

    // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2.default.object, // Arbitrary container props
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(1582);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(473);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1585);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(473);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(473);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicSearchItem = function TopicSearchItem(_ref) {
  var topic = _ref.topic;
  return _react2.default.createElement(
    'div',
    { className: 'quest-topic autocomplete-result' },
    _react2.default.createElement(
      'div',
      { className: 'cloud-name' },
      topic.topic_cloud.name
    ),
    _react2.default.createElement('span', { className: 'carat' }),
    _react2.default.createElement(
      'div',
      { className: 'parent-name' },
      topic.parent.name
    ),
    _react2.default.createElement(
      'div',
      { className: 'name' },
      topic.name
    )
  );
};

TopicSearchItem.propTypes = {
  topic: _propTypes2.default.object.isRequired
};

exports.default = TopicSearchItem;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1589);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var topics = this.props.topics.map(function (topic, index) {
        return _react2.default.createElement(_Item2.default, {
          topic: topic,
          key: index,
          deleteTopic: this.props.deleteTopic,
          changeContext: this.props.changeContext,
          lines: 3,
          dispatch: this.props.dispatch,
          hideActions: this.props.hideActions
        });
      }, this);

      return _react2.default.createElement(
        'ul',
        {
          style: {
            float: 'left',
            width: '100%',
            padding: '0 0 20px'
          }
        },
        topics
      );
    }
  }]);
  return List;
}(_react.Component);

exports.default = List;


List.propTypes = {
  topics: _propTypes2.default.array.isRequired,
  deleteTopic: _propTypes2.default.func.isRequired,
  changeContext: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  hideActions: _propTypes2.default.bool.isRequired,
  lines: _propTypes2.default.number.isRequired
};

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _reactTextTruncate = __webpack_require__(332);

var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);

var _topicclouds = __webpack_require__(239);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_Component) {
  (0, _inherits3.default)(Item, _Component);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

    _this.state = {
      truncated: true
    };
    _this.onDeleteClickBound = _this.onDeleteClick.bind(_this);
    _this.onChangeContextBound = _this.onChangeContext.bind(_this);
    _this.onTopicClickBound = _this.onTopicClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          topic = _props.topic,
          lines = _props.lines,
          hideActions = _props.hideActions;

      var directContext = topic.context === 'direct';
      var klass = hideActions ? '' : 'editing';

      return _react2.default.createElement(
        'li',
        { className: 'quest-topic ' + klass, id: topic.topic_id },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(
              'div',
              { className: 'cloud-name' },
              topic.topic_cloud.name
            ),
            _react2.default.createElement('span', { className: 'carat' }),
            _react2.default.createElement(
              'div',
              { className: 'parent-name' },
              topic.parent.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'name', onClick: this.onTopicClickBound },
              topic.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'description' },
              this.state.truncated ? _react2.default.createElement(_reactTextTruncate2.default, {
                line: lines,
                truncateText: '...',
                text: topic.description,
                textTruncateChild: _react2.default.createElement(
                  'a',
                  {
                    href: '#',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.setState({ truncated: false });
                    }
                  },
                  '\xA0 ',
                  _messages.more
                )
              }) : topic.description
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right ' + klass },
            hideActions ? _react2.default.createElement(
              'div',
              { className: 'context' },
              topic.context
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'context-toggle' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('input', {
                    type: 'radio',
                    id: 'context-' + topic.topic_id + '-direct',
                    name: 'topiccontext-' + topic.topic_id,
                    className: 'form-control direct',
                    checked: directContext,
                    onChange: this.onChangeContextBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'context-' + topic.topic_id + '-direct' },
                    _messages.direct
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('input', {
                    type: 'radio',
                    id: 'context-' + topic.topic_id + '-supplemental',
                    name: 'topiccontext-' + topic.topic_id,
                    className: 'form-control supplemental',
                    checked: !directContext,
                    onChange: this.onChangeContextBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'context-' + topic.topic_id + '-supplemental' },
                    _messages.supplemental
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'trash',
                  onClick: this.onDeleteClickBound,
                  'data-id': topic.topic_id
                },
                '\xA0'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'onDeleteClick',
    value: function onDeleteClick(e) {
      var topicId = JSON.parse(e.target.dataset.id);
      this.props.deleteTopic(topicId);
    }
  }, {
    key: 'onChangeContext',
    value: function onChangeContext(e) {
      var id = JSON.parse(e.target.name.split('-')[1]);
      var context = e.target.id.split('-')[2];
      this.props.changeContext(id, context);
    }
  }, {
    key: 'onTopicClick',
    value: function onTopicClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          topic = _props2.topic;

      dispatch((0, _reactRouterRedux.push)('/topicclouds'));
      // When navigating directly from a quest or actvity, the default fetching that happens in
      // topicclouds actions and topicclouds container causes errors, e.g. tries to auto fetch first topiccloud,
      // and then first topic for that topiccloud. Here, I'm navigating to that section first, which will load
      // the default (here: bad) data, then, timing the other actions/requests to overwrite those props and render
      // the correct topic cloud and topic. A similar issue exists if the user has no cached data and
      // tries to nav to a quest-linked topic without first visiting the topics section (by header click).
      // TODO: Refactor this and the accompanying actions/container for a more elegant solution
      setTimeout(function () {
        dispatch((0, _topicclouds.fetchTopicCloud)(topic.topic_cloud.id));
      }, 500);
      setTimeout(function () {
        dispatch((0, _topicclouds.fetchTopic)(topic.parent.id));
      }, 1000);
    }
  }]);
  return Item;
}(_react.Component);

exports.default = Item;


Item.propTypes = {
  topic: _propTypes2.default.object,
  deleteTopic: _propTypes2.default.func,
  changeContext: _propTypes2.default.func,
  lines: _propTypes2.default.number,
  dispatch: _propTypes2.default.func,
  hideActions: _propTypes2.default.bool
};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReadyForFeedback = __webpack_require__(1591);

var _ReadyForFeedback2 = _interopRequireDefault(_ReadyForFeedback);

var _AssignedTo = __webpack_require__(1592);

var _AssignedTo2 = _interopRequireDefault(_AssignedTo);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignmentArea = function (_Component) {
  (0, _inherits3.default)(AssignmentArea, _Component);

  function AssignmentArea() {
    (0, _classCallCheck3.default)(this, AssignmentArea);
    return (0, _possibleConstructorReturn3.default)(this, (AssignmentArea.__proto__ || (0, _getPrototypeOf2.default)(AssignmentArea)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssignmentArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleAssignClick = _props.handleAssignClick,
          quest = _props.quest;


      return _react2.default.createElement(
        'div',
        { className: 'assignment-area' },
        this.renderReadyForFeedback() && _react2.default.createElement(_ReadyForFeedback2.default, { handleClick: handleAssignClick }),
        !(0, _utils.isNullOrEmpty)(quest.assigned_to) && _react2.default.createElement(_AssignedTo2.default, this.props),
        _react2.default.createElement('div', { className: 'line' })
      );
    }
  }, {
    key: 'renderReadyForFeedback',
    value: function renderReadyForFeedback() {
      var _props2 = this.props,
          isQuestCopyEditorOrQuestAuthorOrQuestManager = _props2.isQuestCopyEditorOrQuestAuthorOrQuestManager,
          quest = _props2.quest;


      return isQuestCopyEditorOrQuestAuthorOrQuestManager && (0, _utils.isNullOrEmpty)(quest.assigned_to);
    }
  }]);
  return AssignmentArea;
}(_react.Component);

exports.default = AssignmentArea;


AssignmentArea.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  handleAssignClick: _propTypes2.default.func.isRequired,
  questIsAssignedToUser: _propTypes2.default.bool,
  handleUnassignClick: _propTypes2.default.func.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _AssignToButton = __webpack_require__(696);

var _AssignToButton2 = _interopRequireDefault(_AssignToButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadyForFeedback = function (_Component) {
  (0, _inherits3.default)(ReadyForFeedback, _Component);

  function ReadyForFeedback() {
    (0, _classCallCheck3.default)(this, ReadyForFeedback);
    return (0, _possibleConstructorReturn3.default)(this, (ReadyForFeedback.__proto__ || (0, _getPrototypeOf2.default)(ReadyForFeedback)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReadyForFeedback, [{
    key: 'render',
    value: function render() {
      var handleClick = this.props.handleClick;

      return _react2.default.createElement(
        'div',
        { id: 'readyForFeedback' },
        _react2.default.createElement('div', { className: 'ready-for-feedback-img' }),
        _react2.default.createElement(
          'div',
          { className: 'assignment-area-label' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Quest.Review.AssignmentArea.ReadyForFeedback?',
            defaultMessage: 'Ready for feedback?'
          })
        ),
        _react2.default.createElement(_AssignToButton2.default, { handleClick: handleClick })
      );
    }
  }]);
  return ReadyForFeedback;
}(_react.Component);

exports.default = ReadyForFeedback;


ReadyForFeedback.propTypes = {
  handleClick: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _AssignToButton = __webpack_require__(696);

var _AssignToButton2 = _interopRequireDefault(_AssignToButton);

var _UserName = __webpack_require__(140);

var _UserName2 = _interopRequireDefault(_UserName);

var _assignment = __webpack_require__(138);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignedTo = function (_Component) {
  (0, _inherits3.default)(AssignedTo, _Component);

  function AssignedTo() {
    (0, _classCallCheck3.default)(this, AssignedTo);
    return (0, _possibleConstructorReturn3.default)(this, (AssignedTo.__proto__ || (0, _getPrototypeOf2.default)(AssignedTo)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssignedTo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          user = _props.user,
          handleAssignClick = _props.handleAssignClick,
          isQuestCopyEditorOrQuestAuthorOrQuestManager = _props.isQuestCopyEditorOrQuestAuthorOrQuestManager,
          handleUnassignClick = _props.handleUnassignClick;


      return _react2.default.createElement(
        'div',
        { id: 'assignedTo' },
        _react2.default.createElement(
          'div',
          { className: 'assigned-to' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Quest.Review.AssignmentsArea.AssignedTo',
            defaultMessage: 'Assigned to:'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'avatar-wrapper' },
          _react2.default.createElement(_UserAvatar2.default, { photoUrl: quest.assigned_to.photo_url }),
          _react2.default.createElement(
            _UserName2.default,
            {
              activeCertifications: quest.assigned_to.active_certifications,
              userId: 'assigned-to-user-' + quest.assigned_to.id,
              rebuild: true
            },
            _react2.default.createElement(
              'div',
              { className: 'username' },
              (0, _name.getUserDisplayName)(quest.assigned_to)
            )
          )
        ),
        ((0, _assignment.questIsAssignedToUser)(quest, user) || isQuestCopyEditorOrQuestAuthorOrQuestManager) && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(_AssignToButton2.default, { handleClick: handleAssignClick }),
          _react2.default.createElement(
            'div',
            { className: 'unassign link', onClick: handleUnassignClick },
            'Unassign'
          )
        )
      );
    }
  }]);
  return AssignedTo;
}(_react.Component);

exports.default = AssignedTo;


AssignedTo.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object,
  handleAssignClick: _propTypes2.default.func.isRequired,
  handleUnassignClick: _propTypes2.default.func.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _reactIntl = __webpack_require__(16);

var _DropdownList = __webpack_require__(1594);

var _DropdownList2 = _interopRequireDefault(_DropdownList);

var _thenby = __webpack_require__(331);

var _thenby2 = _interopRequireDefault(_thenby);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _placeholder = __webpack_require__(150);

var _messages = __webpack_require__(21);

var _assignment = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssignmentModal = function (_Component) {
  (0, _inherits3.default)(AssignmentModal, _Component);

  function AssignmentModal(props) {
    (0, _classCallCheck3.default)(this, AssignmentModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AssignmentModal.__proto__ || (0, _getPrototypeOf2.default)(AssignmentModal)).call(this, props));

    _this.state = {
      assignedUser: {},
      message: ''
    };
    _this.onMessageChangeBound = _this.onMessageChange.bind(_this);
    _this.onCreateAssignmentClickBound = _this.onCreateAssignmentClick.bind(_this);
    _this.onSetAssignedToUserBound = _this.onSetAssignedToUser.bind(_this);
    _this.closeModalBound = _this.closeModal.bind(_this);
    _this.cancelAssignmentClickBound = _this.cancelAssignmentClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AssignmentModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showModal();
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflow = 'scroll';
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '500px',
        background: '#fff',
        overflow: 'visible',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%',
        borderRadius: '6px'
      };
      var _props = this.props,
          quest = _props.quest,
          users = _props.users,
          isQuestCopyEditorOrQuestAuthorOrQuestManager = _props.isQuestCopyEditorOrQuestAuthorOrQuestManager;
      var intl = this.context.intl;

      var placeholderMessages = {
        selectAPeer: intl.formatMessage(_placeholder.messages.selectAPeer),
        writeThemAMessage: intl.formatMessage(_placeholder.messages.writeThemAMessage)
      };

      var usersOptions = this.mapList(users);

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'assignment-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          closeOnClick: true,
          onHide: this.closeModalBound
        },
        _react2.default.createElement(
          'div',
          { className: 'top' },
          _react2.default.createElement(
            'div',
            { className: 'assignment-icons' },
            _react2.default.createElement(_QuestIcon2.default, { heightWidth: 47, icon_image_url: quest.icon_image_url }),
            _react2.default.createElement('div', { className: 'arrow' }),
            _react2.default.createElement('div', { className: 'smiley' })
          ),
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'AssignmentModal.AssignThisQuest',
              defaultMessage: 'Assign this Quest'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom' },
          isQuestCopyEditorOrQuestAuthorOrQuestManager && _react2.default.createElement(
            'div',
            { className: 'guidance' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'AssignmentModal',
              defaultMessage: "Collaborate on this quest by assigning it to someone in your learning community to review. You can still work on your quest while it's assigned to someone else."
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'assignment-select' },
            _react2.default.createElement(
              'div',
              { className: 'label' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'AssignmentModal.AssignThisQuestTo',
                defaultMessage: 'Assign this quest to:'
              })
            ),
            _react2.default.createElement(_DropdownList2.default, {
              placeholder: placeholderMessages.selectAPeer,
              data: usersOptions,
              textField: 'label',
              valueField: 'id',
              onSelect: this.onSetAssignedToUserBound,
              filter: true
            })
          ),
          _react2.default.createElement('textarea', {
            placeholder: placeholderMessages.writeThemAMessage,
            onChange: this.onMessageChangeBound
          }),
          _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              {
                className: 'button btn-secondary-small modal-cancel',
                onClick: this.cancelAssignmentClickBound
              },
              _messages.cancel
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'button btn-primary-small modal-confirm ' + ((0, _keys2.default)(this.state.assignedUser).length === 0 ? 'disabled' : ''),
                onClick: this.onCreateAssignmentClickBound
              },
              _messages.send
            )
          )
        )
      );
    }
  }, {
    key: 'onSetAssignedToUser',
    value: function onSetAssignedToUser(value) {
      this.setState({ assignedUser: value });
    }
  }, {
    key: 'onMessageChange',
    value: function onMessageChange(e) {
      this.setState({ message: e.currentTarget.value });
    }
  }, {
    key: 'onCreateAssignmentClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _assignment.assignQuestToUser)(this.state.assignedUser.value, this.state.message, this.props.quest.id, this.props.user));

              case 2:
                this.setState({
                  assignedUser: {},
                  message: ''
                });
                this.refs.modal.hide();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCreateAssignmentClick() {
        return _ref.apply(this, arguments);
      }

      return onCreateAssignmentClick;
    }()
  }, {
    key: 'showModal',
    value: function showModal() {
      this.refs.modal.show();
    }
  }, {
    key: 'cancelAssignmentClick',
    value: function cancelAssignmentClick() {
      this.refs.modal.hide();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.props.dispatch((0, _assignment.assignmentCancelClick)());
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      var quest = this.props.quest;

      return arr.map(function (el) {
        var author = false;
        if (quest.author_ids.includes(el.id)) {
          author = true;
        }
        return {
          value: el.id,
          label: el.name,
          sort: el.name.trim().toLowerCase(),
          author: author
        };
      }).sort((0, _thenby2.default)('author', -1).thenBy(this.sortByName));
    }
  }, {
    key: 'sortByName',
    value: function sortByName(a, b) {
      // allows case-insensitive sort
      return a.sort.localeCompare(b.sort);
    }
  }]);
  return AssignmentModal;
}(_react.Component);

exports.default = AssignmentModal;


AssignmentModal.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

AssignmentModal.propTypes = {
  wrapperClass: _propTypes2.default.string,
  dispatch: _propTypes2.default.func.isRequired,
  quest: _propTypes2.default.object.isRequired,
  users: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _activeElement = _interopRequireDefault(__webpack_require__(1595));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _reactComponentManagers = __webpack_require__(474);

var _reactLifecyclesCompat = __webpack_require__(476);

var _uncontrollable = __webpack_require__(1599);

var _Widget = _interopRequireDefault(__webpack_require__(1600));

var _WidgetPicker = _interopRequireDefault(__webpack_require__(1601));

var _Select = _interopRequireDefault(__webpack_require__(1602));

var _Popup = _interopRequireDefault(__webpack_require__(1604));

var _List = _interopRequireDefault(__webpack_require__(1622));

var _AddToListOption = _interopRequireDefault(__webpack_require__(1624));

var _DropdownListInput = _interopRequireDefault(__webpack_require__(1625));

var _messages = __webpack_require__(712);

var Props = _interopRequireWildcard(__webpack_require__(479));

var Filter = _interopRequireWildcard(__webpack_require__(709));

var _focusManager = _interopRequireDefault(__webpack_require__(1626));

var CustomPropTypes = _interopRequireWildcard(__webpack_require__(274));

var _reduceToListState = _interopRequireDefault(__webpack_require__(708));

var _getAccessors = _interopRequireDefault(__webpack_require__(1628));

var _scrollManager = _interopRequireDefault(__webpack_require__(1629));

var _interaction = __webpack_require__(713);

var _widgetHelpers = __webpack_require__(480);

var _dataHelpers = __webpack_require__(275);

var _Icon = __webpack_require__(1634);

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

var CREATE_OPTION = {};
/**
 * ---
 * shortcuts:
 *   - { key: alt + down arrow, label: open dropdown }
 *   - { key: alt + up arrow, label: close dropdown }
 *   - { key: down arrow, label: move focus to next item }
 *   - { key: up arrow, label: move focus to previous item }
 *   - { key: home, label: move focus to first item }
 *   - { key: end, label: move focus to last item }
 *   - { key: enter, label: select focused item }
 *   - { key: ctrl + enter, label: create new option from current searchTerm }
 *   - { key: any key, label: search list for item starting with key }
 * ---
 *
 * A `<select>` replacement for single value lists.
 * @public
 */

var DropdownList = (0, _reactLifecyclesCompat.polyfill)(_class = (_class2 = (_temp = _class3 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownList, _React$Component);

  function DropdownList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleFocusChanged = function (focused) {
      if (!focused) _this.close();
    };

    _initializerDefineProperty(_this, "handleSelect", _descriptor, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_this, "handleCreate", _descriptor2, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_this, "handleClick", _descriptor3, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_this, "handleKeyDown", _descriptor4, _assertThisInitialized(_assertThisInitialized(_this)));

    _initializerDefineProperty(_this, "handleKeyPress", _descriptor5, _assertThisInitialized(_assertThisInitialized(_this)));

    _this.handleInputChange = function (e) {
      _this.search(e.target.value, e, 'input');
    };

    _this.handleAutofillChange = function (e) {
      var data = _this.props.data;
      var filledValue = e.target.value.toLowerCase();
      if (filledValue === '') return void _this.change(null);

      for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var item = _ref;
        var value = (0, _dataHelpers.dataValue)(item);

        if (String(value).toLowerCase() === filledValue || (0, _dataHelpers.dataText)(item).toLowerCase() === filledValue) {
          _this.change(item, e);

          break;
        }
      }
    };

    _this.handleAutofill = function (autofilling) {
      _this.setState({
        autofilling: autofilling
      });
    };

    _this.attachInputRef = function (ref) {
      return _this.inputRef = ref;
    };

    _this.attachFilterRef = function (ref) {
      return _this.filterRef = ref;
    };

    _this.attachListRef = function (ref) {
      return _this.listRef = ref;
    };

    _this.focus = function (target) {
      var _this$props = _this.props,
          filter = _this$props.filter,
          open = _this$props.open;
      var inst = target || (filter && open ? _this.filterRef : _this.inputRef);
      inst = (0, _reactDom.findDOMNode)(inst);
      if (inst && (0, _activeElement.default)() !== inst) inst.focus();
    };

    (0, _reactComponentManagers.autoFocus)(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.inputId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_input');
    _this.listId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox');
    _this.activeId = (0, _widgetHelpers.instanceId)(_assertThisInitialized(_assertThisInitialized(_this)), '_listbox_active_option');
    _this.mounted = (0, _reactComponentManagers.mountManager)(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.timeouts = (0, _reactComponentManagers.timeoutManager)(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleScroll = (0, _scrollManager.default)(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.focusManager = (0, _focusManager.default)(_assertThisInitialized(_assertThisInitialized(_this)), {
      didHandle: _this.handleFocusChanged
    });
    _this.state = {};
    return _this;
  }

  DropdownList.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var open = nextProps.open,
        value = nextProps.value,
        data = nextProps.data,
        messages = nextProps.messages,
        searchTerm = nextProps.searchTerm,
        filter = nextProps.filter,
        minLength = nextProps.minLength,
        caseSensitive = nextProps.caseSensitive;
    var focusedItem = prevState.focusedItem;
    var accessors = (0, _getAccessors.default)(nextProps);
    var valueChanged = value !== prevState.lastValue;
    var initialIdx = valueChanged && accessors.indexOf(data, value);
    if (open) data = Filter.filter(data, {
      filter: filter,
      searchTerm: searchTerm,
      minLength: minLength,
      caseSensitive: caseSensitive,
      textField: accessors.text
    });
    var list = (0, _reduceToListState.default)(data, prevState.list, {
      nextProps: nextProps
    });
    var selectedItem = data[initialIdx];
    var nextFocusedItem = ~data.indexOf(focusedItem) ? focusedItem : data[0];
    return {
      data: data,
      list: list,
      accessors: accessors,
      lastValue: value,
      messages: (0, _messages.getMessages)(messages),
      selectedItem: valueChanged ? list.nextEnabled(selectedItem) : prevState.selectedItem,
      focusedItem: valueChanged || focusedItem === undefined ? list.nextEnabled(selectedItem !== undefined ? selectedItem : nextFocusedItem) : nextFocusedItem
    };
  };

  var _proto = DropdownList.prototype;

  _proto.change = function change(nextValue, originalEvent) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        searchTerm = _this$props2.searchTerm,
        lastValue = _this$props2.value;

    if (!this.state.accessors.matches(nextValue, lastValue)) {
      (0, _widgetHelpers.notify)(onChange, [nextValue, {
        originalEvent: originalEvent,
        lastValue: lastValue,
        searchTerm: searchTerm
      }]);
      this.clearSearch(originalEvent);
      this.close();
    }
  };

  _proto.renderList = function renderList() {
    var _this$props3 = this.props,
        open = _this$props3.open,
        filter = _this$props3.filter,
        data = _this$props3.data,
        searchTerm = _this$props3.searchTerm,
        searchIcon = _this$props3.searchIcon,
        optionComponent = _this$props3.optionComponent,
        itemComponent = _this$props3.itemComponent,
        groupComponent = _this$props3.groupComponent,
        listProps = _this$props3.listProps;
    var _this$state = this.state,
        list = _this$state.list,
        accessors = _this$state.accessors,
        focusedItem = _this$state.focusedItem,
        selectedItem = _this$state.selectedItem,
        messages = _this$state.messages,
        filteredData = _this$state.data;
    var List = this.props.listComponent;
    return _react.default.createElement("div", null, filter && _react.default.createElement(_WidgetPicker.default, {
      className: "rw-filter-input rw-input"
    }, _react.default.createElement("input", {
      "aria-activedescendant": open ? this.activeId : null,
      "aria-autocomplete": "list",
      "aria-controls": open ? this.listId : null,
      value: searchTerm,
      className: "rw-input-reset",
      onChange: this.handleInputChange,
      placeholder: messages.filterPlaceholder(this.props),
      ref: this.attachFilterRef
    }), _react.default.createElement(_Select.default, {
      icon: searchIcon,
      role: "presentation",
      "aria-hidden": "true"
    })), _react.default.createElement(List, _extends({}, listProps, {
      id: this.listId,
      activeId: this.activeId,
      data: filteredData,
      dataState: list.dataState,
      isDisabled: list.isDisabled,
      searchTerm: searchTerm,
      textAccessor: accessors.text,
      valueAccessor: accessors.value,
      itemComponent: itemComponent,
      groupComponent: groupComponent,
      optionComponent: optionComponent,
      selectedItem: selectedItem,
      focusedItem: open ? focusedItem : null,
      onSelect: this.handleSelect,
      onMove: this.handleScroll,
      "aria-live": open && 'polite',
      "aria-labelledby": this.inputId,
      "aria-hidden": !this.props.open,
      ref: this.attachListRef,
      messages: {
        emptyList: data.length ? messages.emptyFilter : messages.emptyList
      }
    })), this.allowCreate() && _react.default.createElement(_AddToListOption.default, {
      id: this.createId,
      searchTerm: searchTerm,
      onSelect: this.handleCreate,
      focused: !focusedItem || focusedItem === CREATE_OPTION
    }, messages.createOption(this.props)));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        className = _this$props4.className,
        tabIndex = _this$props4.tabIndex,
        popupTransition = _this$props4.popupTransition,
        textField = _this$props4.textField,
        data = _this$props4.data,
        busy = _this$props4.busy,
        dropUp = _this$props4.dropUp,
        placeholder = _this$props4.placeholder,
        value = _this$props4.value,
        open = _this$props4.open,
        isRtl = _this$props4.isRtl,
        filter = _this$props4.filter,
        inputProps = _this$props4.inputProps,
        selectIcon = _this$props4.selectIcon,
        busySpinner = _this$props4.busySpinner,
        containerClassName = _this$props4.containerClassName,
        valueComponent = _this$props4.valueComponent;
    var _this$state2 = this.state,
        focused = _this$state2.focused,
        accessors = _this$state2.accessors,
        messages = _this$state2.messages,
        autofilling = _this$state2.autofilling;
    var disabled = this.props.disabled === true;
    var readOnly = this.props.readOnly === true;
    var valueItem = accessors.findOrSelf(data, value);
    var shouldRenderPopup = (0, _widgetHelpers.isFirstFocusedRender)(this);

    var elementProps = _extends(Props.pickElementProps(this), {
      name: undefined,
      role: 'combobox',
      id: this.inputId,
      tabIndex: open && filter ? -1 : tabIndex || 0,
      'aria-owns': this.listId,
      'aria-expanded': !!open,
      'aria-haspopup': true,
      'aria-busy': !!busy,
      'aria-live': !open && 'polite',
      'aria-disabled': disabled,
      'aria-readonly': readOnly
    });

    return _react.default.createElement(_Widget.default, _extends({}, elementProps, {
      open: open,
      isRtl: isRtl,
      dropUp: dropUp,
      focused: focused,
      disabled: disabled,
      readOnly: readOnly,
      autofilling: autofilling,
      onBlur: this.focusManager.handleBlur,
      onFocus: this.focusManager.handleFocus,
      onKeyDown: this.handleKeyDown,
      onKeyPress: this.handleKeyPress,
      className: (0, _classnames.default)(className, 'rw-dropdown-list'),
      ref: this.attachInputRef
    }), _react.default.createElement(_WidgetPicker.default, {
      onClick: this.handleClick,
      className: (0, _classnames.default)(containerClassName, 'rw-widget-input')
    }, _react.default.createElement(_DropdownListInput.default, _extends({}, inputProps, {
      value: valueItem,
      textField: textField,
      name: this.props.name,
      autoComplete: this.props.autoComplete,
      onAutofill: this.handleAutofill,
      onAutofillChange: this.handleAutofillChange,
      placeholder: placeholder,
      valueComponent: valueComponent
    })), _react.default.createElement(_Select.default, {
      busy: busy,
      icon: selectIcon,
      spinner: busySpinner,
      role: "presentational",
      "aria-hidden": "true",
      disabled: disabled || readOnly,
      label: messages.openDropdown(this.props)
    })), shouldRenderPopup && _react.default.createElement(_Popup.default, {
      open: open,
      dropUp: dropUp,
      transition: popupTransition,
      onEntered: function onEntered() {
        return _this2.focus();
      },
      onEntering: function onEntering() {
        return _this2.listRef.forceUpdate();
      }
    }, this.renderList(messages)));
  };

  _proto.findOption = function findOption(character, cb) {
    var _this3 = this;

    var word = ((this._currentWord || '') + character).toLowerCase();
    if (!character) return;
    this._currentWord = word;
    this.timeouts.set('search', function () {
      var list = _this3.state.list;
      var key = _this3.props.open ? 'focusedItem' : 'selectedItem';
      var item = list.next(_this3.state[key], word);

      if (item === _this3.state[key]) {
        item = list.next(null, word);
      }

      _this3._currentWord = '';
      if (item) cb(item);
    }, this.props.delay);
  };

  _proto.clearSearch = function clearSearch(originalEvent) {
    this.search('', originalEvent, 'clear');
  };

  _proto.search = function search(searchTerm, originalEvent, action) {
    if (action === void 0) {
      action = 'input';
    }

    var _this$props5 = this.props,
        onSearch = _this$props5.onSearch,
        lastSearchTerm = _this$props5.searchTerm;
    if (searchTerm !== lastSearchTerm) (0, _widgetHelpers.notify)(onSearch, [searchTerm, {
      action: action,
      lastSearchTerm: lastSearchTerm,
      originalEvent: originalEvent
    }]);
  };

  _proto.open = function open() {
    if (!this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, true);
  };

  _proto.close = function close() {
    if (this.props.open) (0, _widgetHelpers.notify)(this.props.onToggle, false);
  };

  _proto.toggle = function toggle() {
    this.props.open ? this.close() : this.open();
  };

  _proto.allowCreate = function allowCreate() {
    var _this$props6 = this.props,
        searchTerm = _this$props6.searchTerm,
        onCreate = _this$props6.onCreate,
        allowCreate = _this$props6.allowCreate;
    return !!(onCreate && (allowCreate === true || allowCreate === 'onFilter' && searchTerm) && !this.hasExtactMatch());
  };

  _proto.hasExtactMatch = function hasExtactMatch() {
    var _this$props7 = this.props,
        searchTerm = _this$props7.searchTerm,
        caseSensitive = _this$props7.caseSensitive,
        filter = _this$props7.filter;
    var _this$state3 = this.state,
        data = _this$state3.data,
        accessors = _this$state3.accessors;

    var lower = function lower(text) {
      return caseSensitive ? text : text.toLowerCase();
    }; // if there is an exact match on textFields:


    return filter && data.some(function (v) {
      return lower(accessors.text(v)) === lower(searchTerm);
    });
  };

  return DropdownList;
}(_react.default.Component), _class3.propTypes = _extends({}, Filter.propTypes, {
  value: _propTypes.default.any,

  /**
   * @type {function (
   *  dataItems: ?any,
   *  metadata: {
   *    lastValue: ?any,
   *    searchTerm: ?string
   *    originalEvent: SyntheticEvent,
   *  }
   * ): void}
   */
  onChange: _propTypes.default.func,
  open: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  data: _propTypes.default.array,
  valueField: CustomPropTypes.accessor,
  textField: CustomPropTypes.accessor,
  allowCreate: _propTypes.default.oneOf([true, false, 'onFilter']),

  /**
   * A React component for customizing the rendering of the DropdownList
   * value
   */
  valueComponent: CustomPropTypes.elementType,
  itemComponent: CustomPropTypes.elementType,
  listComponent: CustomPropTypes.elementType,
  optionComponent: CustomPropTypes.elementType,
  groupComponent: CustomPropTypes.elementType,
  groupBy: CustomPropTypes.accessor,

  /**
   *
   * @type {(dataItem: ?any, metadata: { originalEvent: SyntheticEvent }) => void}
   */
  onSelect: _propTypes.default.func,
  onCreate: _propTypes.default.func,

  /**
   * @type function(searchTerm: string, metadata: { action, lastSearchTerm, originalEvent? })
   */
  onSearch: _propTypes.default.func,
  searchTerm: _propTypes.default.string,
  busy: _propTypes.default.bool,

  /** Specify the element used to render the select (down arrow) icon. */
  selectIcon: _propTypes.default.node,
  searchIcon: _propTypes.default.node,

  /** Specify the element used to render the busy indicator */
  busySpinner: _propTypes.default.node,
  placeholder: _propTypes.default.string,
  dropUp: _propTypes.default.bool,
  popupTransition: CustomPropTypes.elementType,
  disabled: CustomPropTypes.disabled.acceptsArray,
  readOnly: CustomPropTypes.disabled,

  /** Adds a css class to the input container element. */
  containerClassName: _propTypes.default.string,
  inputProps: _propTypes.default.object,
  listProps: _propTypes.default.object,
  isRtl: _propTypes.default.bool,
  messages: _propTypes.default.shape({
    open: _propTypes.default.string,
    emptyList: CustomPropTypes.message,
    emptyFilter: CustomPropTypes.message,
    filterPlaceholder: _propTypes.default.string,
    createOption: CustomPropTypes.message
  })
}), _class3.defaultProps = {
  data: [],
  delay: 500,
  searchTerm: '',
  allowCreate: false,
  searchIcon: _Icon.search,
  selectIcon: _Icon.caretDown,
  listComponent: _List.default
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "handleSelect", [_interaction.widgetEditable], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (dataItem, originalEvent) {
      if (dataItem === undefined || dataItem === CREATE_OPTION) {
        _this4.handleCreate(_this4.props.searchTerm);

        return;
      }

      (0, _widgetHelpers.notify)(_this4.props.onSelect, [dataItem, {
        originalEvent: originalEvent
      }]);

      _this4.change(dataItem, originalEvent);

      _this4.close();

      _this4.focus(_this4);
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "handleCreate", [_interaction.widgetEditable], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (searchTerm, event) {
      if (searchTerm === void 0) {
        searchTerm = '';
      }

      (0, _widgetHelpers.notify)(_this5.props.onCreate, searchTerm);

      _this5.clearSearch(event);

      _this5.close();

      _this5.focus(_this5);
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "handleClick", [_interaction.widgetEditable], {
  enumerable: true,
  initializer: function initializer() {
    var _this6 = this;

    return function (e) {
      _this6.focus();

      _this6.toggle();

      (0, _widgetHelpers.notify)(_this6.props.onClick, e);
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyDown", [_interaction.widgetEditable], {
  enumerable: true,
  initializer: function initializer() {
    var _this7 = this;

    return function (e) {
      var key = e.key,
          altKey = e.altKey,
          ctrlKey = e.ctrlKey;
      var _this7$props = _this7.props,
          open = _this7$props.open,
          onKeyDown = _this7$props.onKeyDown,
          filter = _this7$props.filter,
          searchTerm = _this7$props.searchTerm;
      var _this7$state = _this7.state,
          focusedItem = _this7$state.focusedItem,
          selectedItem = _this7$state.selectedItem,
          list = _this7$state.list;
      var createIsFocused = focusedItem === CREATE_OPTION;

      var canCreate = _this7.allowCreate();

      (0, _widgetHelpers.notify)(onKeyDown, [e]);

      var closeWithFocus = function closeWithFocus() {
        _this7.close();

        (0, _reactDom.findDOMNode)(_this7).focus();
      };

      var change = function change(item) {
        return item != null && _this7.change(item, e);
      };

      var focusItem = function focusItem(item) {
        return _this7.setState({
          focusedItem: item
        });
      };

      if (e.defaultPrevented) return;

      if (key === 'End') {
        e.preventDefault();
        if (open) focusItem(list.last());else change(list.last());
      } else if (key === 'Home') {
        e.preventDefault();
        if (open) focusItem(list.first());else change(list.first());
      } else if (key === 'Escape' && open) {
        e.preventDefault();
        closeWithFocus();
      } else if (key === 'Enter' && open && ctrlKey && canCreate) {
        e.preventDefault();

        _this7.handleCreate(searchTerm, e);
      } else if ((key === 'Enter' || key === ' ' && !filter) && open) {
        e.preventDefault();

        _this7.handleSelect(focusedItem, e);
      } else if (key === ' ' && !open) {
        e.preventDefault();

        _this7.open();
      } else if (key === 'ArrowDown') {
        e.preventDefault();
        if (altKey) return _this7.open();
        if (!open) change(list.next(selectedItem));
        var next = list.next(focusedItem);
        var creating = createIsFocused || canCreate && focusedItem === next;
        focusItem(creating ? CREATE_OPTION : next);
      } else if (key === 'ArrowUp') {
        e.preventDefault();
        if (altKey) return closeWithFocus();
        if (!open) return change(list.prev(selectedItem));
        focusItem(createIsFocused ? list.last() : list.prev(focusedItem));
      }
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "handleKeyPress", [_interaction.widgetEditable], {
  enumerable: true,
  initializer: function initializer() {
    var _this8 = this;

    return function (e) {
      (0, _widgetHelpers.notify)(_this8.props.onKeyPress, [e]);
      if (e.defaultPrevented) return;
      if (!(_this8.props.filter && _this8.props.open)) _this8.findOption(String.fromCharCode(e.which), function (item) {
        _this8.mounted() && _this8.props.open ? _this8.setState({
          focusedItem: item
        }) : item && _this8.change(item, e);
      });
    };
  }
})), _class2)) || _class;

var _default = (0, _uncontrollable.uncontrollable)(DropdownList, {
  open: 'onToggle',
  value: 'onChange',
  searchTerm: 'onSearch'
}, ['focus']);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(697));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makeAutoFocusable;
exports.PropTypes = void 0;

var _propTypes = __webpack_require__(1);

var _reactDom = __webpack_require__(32);

var _spyOnComponent = _interopRequireDefault(__webpack_require__(344));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypes = {
  autoFocus: _propTypes.bool
};
exports.PropTypes = PropTypes;

function makeAutoFocusable(instance) {
  (0, _spyOnComponent.default)(instance, {
    componentDidMount: function componentDidMount() {
      var autoFocus = this.props.autoFocus;
      if (autoFocus) this.focus ? this.focus() : (0, _reactDom.findDOMNode)(this).focus();
    }
  });
}

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.callFocusEventHandler = callFocusEventHandler;
exports.default = createFocusManager;

var _reactDom = __webpack_require__(32);

var _timeoutManager = _interopRequireDefault(__webpack_require__(698));

var _mountManager = _interopRequireDefault(__webpack_require__(475));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function callFocusEventHandler(inst, focused, e) {
  var handler = inst.props[focused ? 'onFocus' : 'onBlur'];
  handler && handler(e);
}

function createFocusManager(instance, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      willHandle = _ref.willHandle,
      didHandle = _ref.didHandle,
      onChange = _ref.onChange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? function () {
    return !!instance.props.disabled;
  } : _ref$isDisabled;

  var lastFocused;
  var timeouts = (0, _timeoutManager.default)(instance);
  var isMounted = (0, _mountManager.default)(instance);

  function _handleFocus(focused, event) {
    if (event && event.persist) event.persist();
    if (willHandle && willHandle(focused, event) === false) return;
    timeouts.set('focus', function () {
      (0, _reactDom.unstable_batchedUpdates)(function () {
        if (focused !== lastFocused) {
          if (didHandle) didHandle.call(instance, focused, event); // only fire a change when unmounted if its a blur

          if (isMounted() || !focused) {
            lastFocused = focused;
            onChange && onChange(focused, event);
          }
        }
      });
    });
  }

  return {
    handleBlur: function handleBlur(event) {
      if (!isDisabled()) _handleFocus(false, event);
    },
    handleFocus: function handleFocus(event) {
      if (!isDisabled()) _handleFocus(true, event);
    }
  };
}

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.mixin = mixin;
exports.default = mixIntoClass;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function mixin(componentClass, _ref) {
  var propTypes = _ref.propTypes,
      contextTypes = _ref.contextTypes,
      childContextTypes = _ref.childContextTypes,
      getChildContext = _ref.getChildContext,
      protoSpec = _objectWithoutProperties(_ref, ["propTypes", "contextTypes", "childContextTypes", "getChildContext"]);

  if (propTypes) componentClass.propTypes = _extends({}, componentClass.propTypes, propTypes);
  if (contextTypes) componentClass.contextTypes = _extends({}, componentClass.contextTypes, contextTypes);
  if (childContextTypes) componentClass.childContextTypes = _extends({}, componentClass.childContextTypes, childContextTypes);

  if (getChildContext) {
    var baseGCContext = componentClass.prototype.getChildContext;

    componentClass.prototype.getChildContext = function $getChildContext() {
      return _extends({}, baseGCContext && baseGCContext.call(this), getChildContext.call(this));
    };
  }

  _extends(componentClass.prototype, protoSpec);

  return componentClass;
}

function mixIntoClass(spec) {
  return function (componentClass) {
    return mixin(componentClass, spec);
  };
}

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(110);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(57);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/utils.js


var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}
function utils_isProp(props, prop) {
  return props[prop] !== undefined;
}
function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

function utils_canAcceptRef(component) {
  return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}
// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/hook.js



function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




function useUncontrolledProp(propValue, defaultValue, handler) {
  var wasPropRef = Object(react["useRef"])(propValue !== undefined);

  var _useState = Object(react["useState"])(defaultValue),
      stateValue = _useState[0],
      setState = _useState[1];

  var isProp = propValue !== undefined;
  var wasProp = wasPropRef.current;
  wasPropRef.current = isProp;
  /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */

  if (!isProp && wasProp && stateValue !== defaultValue) {
    setState(defaultValue);
  }

  return [isProp ? propValue : stateValue, Object(react["useCallback"])(function (value) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) handler.apply(void 0, [value].concat(args));
    setState(value);
  }, [handler])];
}


function useUncontrolled(props, config) {
  return Object.keys(config).reduce(function (result, fieldName) {
    var _extends2;

    var _ref = result,
        defaultValue = _ref[defaultKey(fieldName)],
        propsValue = _ref[fieldName],
        rest = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, [defaultKey(fieldName), fieldName].map(_toPropertyKey));

    var handlerName = config[fieldName];

    var _useUncontrolledProp = useUncontrolledProp(propsValue, defaultValue, props[handlerName]),
        value = _useUncontrolledProp[0],
        handler = _useUncontrolledProp[1];

    return Object(esm_extends["a" /* default */])({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
  }, props);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(74);

// EXTERNAL MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
var react_lifecycles_compat_es = __webpack_require__(476);

// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/uncontrollable.js



var _jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";




function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var canAcceptRef = utils_canAcceptRef(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(defaultKey);
  !(canAcceptRef || !methods.length) ?  false ? invariant(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : browser_default()(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    Object(inheritsLoose["a" /* default */])(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          if (!_this.unmounted) _this.setState(function (_ref) {
            var _extends2;

            var values = _ref.values;
            return {
              values: Object(esm_extends["a" /* default */])(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
            };
          });
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (methods.length) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      var values = Object.create(null);
      controlledProps.forEach(function (key) {
        values[key] = _this.props[defaultKey(key)];
      });
      _this.state = {
        values: values,
        prevProps: {}
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let setState trigger the update
      return !this._notifying;
    };

    UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
      var values = _ref2.values,
          prevProps = _ref2.prevProps;
      var nextState = {
        values: Object(esm_extends["a" /* default */])(Object.create(null), values),
        prevProps: {}
      };
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        nextState.prevProps[key] = props[key];

        if (!utils_isProp(props, key) && utils_isProp(prevProps, key)) {
          nextState.values[key] = props[defaultKey(key)];
        }
      });
      return nextState;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          innerRef = _this$props2.innerRef,
          props = Object(objectWithoutPropertiesLoose["a" /* default */])(_this$props2, ["innerRef"]);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this2.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
      });
      return react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({}, props, newProps, this.handlers, {
        ref: innerRef || this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(react_default.a.Component);

  Object(react_lifecycles_compat_es["polyfill"])(UncontrolledComponent);
  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Object(esm_extends["a" /* default */])({
    innerRef: function innerRef() {}
  }, uncontrolledPropTypes(controlledValues, displayName));
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _this$inner;

      return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
    };
  });
  var WrappedComponent = UncontrolledComponent;

  if (react_default.a.forwardRef) {
    WrappedComponent = react_default.a.forwardRef(function (props, ref) {
      return react_default.a.createElement(UncontrolledComponent, Object(esm_extends["a" /* default */])({}, props, {
        innerRef: ref,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }));
    });
    WrappedComponent.propTypes = UncontrolledComponent.propTypes;
  }

  WrappedComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  WrappedComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, Object(esm_extends["a" /* default */])({}, controlledValues, additions), nextMethods);
  };

  return WrappedComponent;
}
// CONCATENATED MODULE: ./node_modules/uncontrollable/lib/esm/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useUncontrolled", function() { return useUncontrolled; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "useUncontrolledProp", function() { return useUncontrolledProp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uncontrollable", function() { return uncontrollable; });



/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Widget =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Widget, _React$Component);

  function Widget() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Widget.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        tabIndex = _this$props.tabIndex,
        focused = _this$props.focused,
        open = _this$props.open,
        dropUp = _this$props.dropUp,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        autofilling = _this$props.autofilling,
        _this$props$isRtl = _this$props.isRtl,
        isRtl = _this$props$isRtl === void 0 ? this.context.isRtl : _this$props$isRtl,
        props = _objectWithoutProperties(_this$props, ["className", "tabIndex", "focused", "open", "dropUp", "disabled", "readOnly", "autofilling", "isRtl"]);

    tabIndex = tabIndex != null ? tabIndex : '-1';
    return _react.default.createElement("div", _extends({}, props, {
      tabIndex: tabIndex,
      className: (0, _classnames.default)(className, 'rw-widget', isRtl && 'rw-rtl', disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly', focused && 'rw-state-focus', autofilling && 'rw-webkit-autofill', open && "rw-open" + (dropUp ? '-up' : ''))
    }));
  };

  return Widget;
}(_react.default.Component);

Widget.contextTypes = {
  isRtl: _propTypes.default.bool
};
Widget.propTypes = {
  tabIndex: _propTypes.default.node,
  focused: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  autofilling: _propTypes.default.bool,
  open: _propTypes.default.bool,
  dropUp: _propTypes.default.bool,
  isRtl: _propTypes.default.bool
};
var _default = Widget;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var WidgetPicker =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(WidgetPicker, _React$Component);

  function WidgetPicker() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = WidgetPicker.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        open = _this$props.open,
        dropUp = _this$props.dropUp,
        className = _this$props.className,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        focused = _this$props.focused,
        props = _objectWithoutProperties(_this$props, ["open", "dropUp", "className", "disabled", "readOnly", "focused"]);

    var openClass = "rw-open" + (dropUp ? '-up' : '');
    return _react.default.createElement("div", _extends({}, props, {
      className: (0, _classnames.default)(className, 'rw-widget-picker', 'rw-widget-container', open && openClass, disabled && 'rw-state-disabled', readOnly && 'rw-state-readonly', focused && 'rw-state-focus')
    }));
  };

  return WidgetPicker;
}(_react.default.Component);

WidgetPicker.propTypes = {
  tabIndex: _propTypes.default.node,
  focused: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  open: _propTypes.default.bool,
  dropUp: _propTypes.default.bool,
  picker: _propTypes.default.bool
};
var _default = WidgetPicker;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _Button = _interopRequireDefault(__webpack_require__(1603));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Select =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Select.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        bordered = _this$props.bordered,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, ["className", "bordered", "children"]);

    return _react.default.createElement("span", {
      className: (0, _classnames.default)(className, 'rw-select', bordered && 'rw-select-bordered')
    }, children ? _react.default.Children.map(children, function (child) {
      return child && _react.default.cloneElement(child, {
        variant: 'select'
      });
    }) : _react.default.createElement(_Button.default, _extends({}, props, {
      variant: "select"
    })));
  };

  return Select;
}(_react.default.Component);

Select.propTypes = {
  bordered: _propTypes.default.bool
};
var _default = Select;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(76));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Loading = function Loading() {
  return _react.default.createElement("span", {
    "aria-hidden": "true",
    className: "rw-i rw-loading"
  });
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        label = _this$props.label,
        icon = _this$props.icon,
        busy = _this$props.busy,
        active = _this$props.active,
        children = _this$props.children,
        _this$props$variant = _this$props.variant,
        variant = _this$props$variant === void 0 ? 'primary' : _this$props$variant,
        _this$props$spinner = _this$props.spinner,
        spinner = _this$props$spinner === void 0 ? _react.default.createElement(Loading, null) : _this$props$spinner,
        _this$props$component = _this$props.component,
        Tag = _this$props$component === void 0 ? 'button' : _this$props$component,
        props = _objectWithoutProperties(_this$props, ["className", "disabled", "label", "icon", "busy", "active", "children", "variant", "spinner", "component"]);

    var type = props.type;
    if (Tag === 'button') type = type || 'button';
    return _react.default.createElement(Tag, _extends({}, props, {
      tabIndex: "-1",
      title: label,
      type: type,
      disabled: disabled,
      "aria-disabled": disabled,
      "aria-label": label,
      className: (0, _classnames.default)(className, 'rw-btn', active && !disabled && 'rw-state-active', variant && 'rw-btn-' + variant)
    }), busy ? spinner : icon, children);
  };

  return Button;
}(_react.default.Component);

Button.propTypes = {
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  icon: _propTypes.default.node,
  busy: _propTypes.default.bool,
  active: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['primary', 'select']),
  component: _propTypes.default.any,
  spinner: _propTypes.default.node
};
var _default = Button;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _SlideDownTransition = _interopRequireDefault(__webpack_require__(1605));

var _PropTypes = __webpack_require__(274);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var StaticContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(StaticContainer, _React$Component);

  function StaticContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = StaticContainer.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(_ref) {
    var shouldUpdate = _ref.shouldUpdate;
    return !!shouldUpdate;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, ["className", "children"]);

    delete props.shouldUpdate;
    return (0, _react.cloneElement)(children, _extends({}, props, {
      className: (0, _classnames.default)(className, children.props.className, 'rw-popup')
    }));
  };

  return StaticContainer;
}(_react.default.Component);

StaticContainer.propTypes = {
  shouldUpdate: function shouldUpdate() {}
};

var Popup =
/*#__PURE__*/
function (_React$Component2) {
  _inheritsLoose(Popup, _React$Component2);

  function Popup() {
    return _React$Component2.apply(this, arguments) || this;
  }

  var _proto2 = Popup.prototype;

  _proto2.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        dropUp = _this$props2.dropUp,
        open = _this$props2.open,
        Transition = _this$props2.transition,
        props = _objectWithoutProperties(_this$props2, ["className", "dropUp", "open", "transition"]);

    return _react.default.createElement(Transition, _extends({}, props, {
      in: open,
      dropUp: dropUp,
      className: (0, _classnames.default)(className, 'rw-popup-container')
    }), _react.default.createElement(StaticContainer, {
      shouldUpdate: open
    }, _react.default.Children.only(this.props.children)));
  };

  return Popup;
}(_react.default.Component);

Popup.defaultProps = {
  open: false,
  transition: _SlideDownTransition.default
};
Popup.propTypes = {
  open: _propTypes.default.bool,
  dropUp: _propTypes.default.bool,
  onEntering: _propTypes.default.func,
  onEntered: _propTypes.default.func,
  transition: _PropTypes.elementType
};
var _default = Popup;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _events = _interopRequireDefault(__webpack_require__(1606));

var _style = _interopRequireDefault(__webpack_require__(703));

var _height = _interopRequireDefault(__webpack_require__(477));

var _properties = __webpack_require__(705);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireWildcard(__webpack_require__(1615));

var _transitionClasses;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var transitionClasses = (_transitionClasses = {}, _transitionClasses[_Transition.ENTERING] = 'rw-popup-transition-entering', _transitionClasses[_Transition.EXITING] = 'rw-popup-transition-exiting', _transitionClasses[_Transition.EXITED] = 'rw-popup-transition-exited', _transitionClasses);
var propTypes = {
  in: _propTypes.default.bool.isRequired,
  dropUp: _propTypes.default.bool,
  onEntering: _propTypes.default.func,
  onEntered: _propTypes.default.func
};

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.transitionDuration);
  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

var SlideDownTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SlideDownTransition, _React$Component);

  function SlideDownTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.setContainerHeight = function (elem) {
      elem.style.height = _this.getHeight() + 'px';
    };

    _this.clearContainerHeight = function (elem) {
      elem.style.height = '';
    };

    _this.handleEntered = function (elem) {
      _this.clearContainerHeight(elem);

      if (_this.props.onEntered) _this.props.onEntered();
    };

    _this.handleEntering = function () {
      if (_this.props.onEntering) _this.props.onEntering();
    };

    _this.handleTransitionEnd = function (node, done) {
      var duration = parseDuration(node.lastChild) || 0;

      var handler = function handler() {
        _events.default.off(node, _properties.transitionEnd, handler, false);

        done();
      };

      setTimeout(handler, duration * 1.5);

      _events.default.on(node, _properties.transitionEnd, handler, false);
    };

    _this.attachRef = function (ref) {
      return _this.element = ref;
    };

    return _this;
  }

  var _proto = SlideDownTransition.prototype;

  _proto.getHeight = function getHeight() {
    var container = this.element;
    var content = container.firstChild;
    var margin = parseInt((0, _style.default)(content, 'margin-top'), 10) + parseInt((0, _style.default)(content, 'margin-bottom'), 10);
    var old = container.style.display;
    var height;
    container.style.display = 'block';
    height = ((0, _height.default)(content) || 0) + (isNaN(margin) ? 0 : margin);
    container.style.display = old;
    return height;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        dropUp = _this$props.dropUp;
    return _react.default.createElement(_Transition.default, {
      appear: true,
      in: this.props.in,
      timeout: 5000,
      onEnter: this.setContainerHeight,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered,
      onExit: this.setContainerHeight,
      onExited: this.clearContainerHeight,
      addEndListener: this.handleTransitionEnd
    }, function (status, innerProps) {
      return _react.default.createElement("div", _extends({}, innerProps, {
        ref: _this2.attachRef,
        className: (0, _classnames.default)(className, dropUp && 'rw-dropup', transitionClasses[status])
      }), _react.default.createElement("div", {
        className: "rw-popup-transition"
      }, children));
    });
  };

  return SlideDownTransition;
}(_react.default.Component);

SlideDownTransition.propTypes = propTypes;
var _default = SlideDownTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(699));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(700));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1607));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1608));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(701));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(702));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var _on = _interopRequireDefault(__webpack_require__(699));

var _off = _interopRequireDefault(__webpack_require__(700));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1611));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(704));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(32));

var _reactLifecyclesCompat = __webpack_require__(476);

var _PropTypes = __webpack_require__(1616);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(1618);

var _createChainableTypeChecker = __webpack_require__(707);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1619);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setNumber = setNumber;
exports.setDate = setDate;
exports.date = exports.number = void 0;

var _invariant = _interopRequireDefault(__webpack_require__(57));

var _ = __webpack_require__(478);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localePropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]);

var REQUIRED_NUMBER_FORMATS = ['default'];
var REQUIRED_DATE_FORMATS = ['default', 'date', 'time', 'header', 'footer', 'weekday', 'dayOfMonth', 'month', 'year', 'decade', 'century'];

var _numberLocalizer = createWrapper('NumberPicker');

var number = {
  propType: function propType() {
    var _numberLocalizer2;

    return (_numberLocalizer2 = _numberLocalizer).propType.apply(_numberLocalizer2, arguments);
  },
  getFormat: function getFormat(key, format) {
    return format || _numberLocalizer.formats[key];
  },
  parse: function parse() {
    var _numberLocalizer3;

    return (_numberLocalizer3 = _numberLocalizer).parse.apply(_numberLocalizer3, arguments);
  },
  format: function format() {
    var _numberLocalizer4;

    return (_numberLocalizer4 = _numberLocalizer).format.apply(_numberLocalizer4, arguments);
  },
  decimalChar: function decimalChar() {
    var _numberLocalizer5;

    return (_numberLocalizer5 = _numberLocalizer).decimalChar.apply(_numberLocalizer5, arguments);
  },
  precision: function precision() {
    var _numberLocalizer6;

    return (_numberLocalizer6 = _numberLocalizer).precision.apply(_numberLocalizer6, arguments);
  }
};
exports.number = number;

function setNumber(_ref) {
  var format = _ref.format,
      _parse = _ref.parse,
      formats = _ref.formats,
      _ref$propType = _ref.propType,
      propType = _ref$propType === void 0 ? localePropType : _ref$propType,
      _ref$decimalChar = _ref.decimalChar,
      decimalChar = _ref$decimalChar === void 0 ? function () {
    return '.';
  } : _ref$decimalChar,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? function () {
    return null;
  } : _ref$precision;
  checkFormats(REQUIRED_NUMBER_FORMATS, formats);
  _numberLocalizer = {
    formats: formats,
    precision: precision,
    decimalChar: decimalChar,
    propType: propType,
    format: wrapFormat(format),
    parse: function parse(value, culture, format) {
      var result = _parse.call(this, value, culture, format);

      !(result == null || typeof result === 'number') ?  false ? (0, _invariant.default)(false, 'number localizer `parse(..)` must return a number, null, or undefined') : invariant(false) : void 0;
      return result;
    }
  };
}

var _dateLocalizer = createWrapper('DateTimePicker');

var date = {
  propType: function propType() {
    var _dateLocalizer2;

    return (_dateLocalizer2 = _dateLocalizer).propType.apply(_dateLocalizer2, arguments);
  },
  getFormat: function getFormat(key, format) {
    return format || _dateLocalizer.formats[key];
  },
  parse: function parse() {
    var _dateLocalizer3;

    return (_dateLocalizer3 = _dateLocalizer).parse.apply(_dateLocalizer3, arguments);
  },
  format: function format() {
    var _dateLocalizer4;

    return (_dateLocalizer4 = _dateLocalizer).format.apply(_dateLocalizer4, arguments);
  },
  firstOfWeek: function firstOfWeek() {
    var _dateLocalizer5;

    return (_dateLocalizer5 = _dateLocalizer).firstOfWeek.apply(_dateLocalizer5, arguments);
  }
};
exports.date = date;

function setDate(_ref2) {
  var formats = _ref2.formats,
      format = _ref2.format,
      _parse2 = _ref2.parse,
      firstOfWeek = _ref2.firstOfWeek,
      _ref2$propType = _ref2.propType,
      propType = _ref2$propType === void 0 ? localePropType : _ref2$propType;
  checkFormats(REQUIRED_DATE_FORMATS, formats);
  _dateLocalizer = {
    formats: formats,
    propType: propType,
    firstOfWeek: firstOfWeek,
    format: wrapFormat(format),
    parse: function parse(value, format, culture) {
      var result = _parse2.call(this, value, format, culture);

      !(result == null || result instanceof Date && !isNaN(result.getTime())) ?  false ? (0, _invariant.default)(false, 'date localizer `parse(..)` must return a valid Date, null, or undefined') : invariant(false) : void 0;
      return result;
    }
  };
}

var wrapFormat = function wrapFormat(formatter) {
  return function (value, format, culture) {
    var result = typeof format === 'function' ? format(value, culture, this) : formatter.call(this, value, format, culture);
    !(result == null || typeof result === 'string') ?  false ? (0, _invariant.default)(false, '`localizer format(..)` must return a string, null, or undefined') : invariant(false) : void 0;
    return result;
  };
};

function checkFormats(required, formats) {
  if (false) required.forEach(function (f) {
    return !(0, _.has)(formats, f) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'localizer missing required format: `%s`', f) : invariant(false) : void 0;
  });
}

function createWrapper() {
  var dummy = {};

  if (false) {
    ['formats', 'parse', 'format', 'firstOfWeek', 'precision', 'propType'].forEach(function (name) {
      return Object.defineProperty(dummy, name, {
        enumerable: true,
        get: function get() {
          throw new Error('[React Widgets] You are attempting to use a widget that requires localization ' + '(Calendar, DateTimePicker, NumberPicker). ' + 'However there is no localizer set. Please configure a localizer. \n\n' + 'see http://jquense.github.io/react-widgets/docs/#/i18n for more info.');
        }
      });
    });
  }

  return dummy;
}

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var CustomPropTypes = _interopRequireWildcard(__webpack_require__(274));

var Props = _interopRequireWildcard(__webpack_require__(479));

var _widgetHelpers = __webpack_require__(480);

var _reduceToListState = __webpack_require__(708);

var _Listbox = _interopRequireDefault(__webpack_require__(710));

var _ListOption = _interopRequireDefault(__webpack_require__(711));

var _ListOptionGroup = _interopRequireDefault(__webpack_require__(1623));

var _messages = __webpack_require__(712);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var EMPTY_DATA_STATE = {};
var propTypes = {
  data: _propTypes.default.array,
  dataState: _propTypes.default.shape({
    sortedKeys: _propTypes.default.array,
    groups: _propTypes.default.object,
    data: _propTypes.default.array,
    sequentialData: _propTypes.default.array
  }),
  valueAccessor: CustomPropTypes.accessor,
  textAccessor: CustomPropTypes.accessor,
  onSelect: _propTypes.default.func,
  onMove: _propTypes.default.func,
  activeId: _propTypes.default.string,
  itemComponent: CustomPropTypes.elementType,
  groupComponent: CustomPropTypes.elementType,
  optionComponent: CustomPropTypes.elementType,
  renderItem: _propTypes.default.func,
  renderGroup: _propTypes.default.func,
  focusedItem: _propTypes.default.any,
  selectedItem: _propTypes.default.any,
  searchTerm: _propTypes.default.string,
  isDisabled: _propTypes.default.func.isRequired,
  messages: _propTypes.default.shape({
    emptyList: _propTypes.default.func.isRequired
  })
};
var defaultProps = {
  onSelect: function onSelect() {},
  data: [],
  dataState: EMPTY_DATA_STATE,
  optionComponent: _ListOption.default
};

var List =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(List, _React$Component);

  function List() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderItem = function (_ref) {
      var item = _ref.item,
          rest = _objectWithoutProperties(_ref, ["item"]);

      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          renderItem = _this$props.renderItem,
          textAccessor = _this$props.textAccessor,
          valueAccessor = _this$props.valueAccessor;
      var Component = _this.props.itemComponent;

      if (renderItem) {
        return renderItem(_extends({
          item: item
        }, rest));
      } else if (Component) {
        return _react.default.createElement(Component, _extends({
          item: item,
          value: valueAccessor(item),
          text: textAccessor(item),
          disabled: isDisabled(item)
        }, rest));
      }

      return textAccessor(item);
    };

    _this.renderGroup = function (group) {
      var _this$props2 = _this.props,
          renderGroup = _this$props2.renderGroup,
          Component = _this$props2.groupComponent;

      if (renderGroup) {
        return renderGroup({
          group: group
        });
      } else if (Component) {
        return _react.default.createElement(Component, {
          item: group
        });
      }

      return group;
    };

    return _this;
  }

  var _proto = List.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.move();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.move();
  };

  _proto.mapItems = function mapItems(fn) {
    var _this$props3 = this.props,
        data = _this$props3.data,
        dataState = _this$props3.dataState;
    var sortedKeys = dataState.sortedKeys,
        groups = dataState.groups;
    if (!groups) return data.map(function (item, idx) {
      return fn(item, idx, false);
    });
    var idx = -1;
    return sortedKeys.reduce(function (items, key) {
      var group = groups[key];
      return items.concat(fn(key, idx, true), group.map(function (item) {
        return fn(item, ++idx, false);
      }));
    }, []);
  };

  _proto.move = function move() {
    var _this$props4 = this.props,
        focusedItem = _this$props4.focusedItem,
        onMove = _this$props4.onMove,
        data = _this$props4.data,
        dataState = _this$props4.dataState;
    var list = (0, _reactDom.findDOMNode)(this);
    var idx = renderedIndexOf(focusedItem, list, data, dataState);
    var selectedItem = list.children[idx];
    if (selectedItem) (0, _widgetHelpers.notify)(onMove, [selectedItem, list, focusedItem]);
  };

  _proto.renderOption = function renderOption(item, index) {
    var _this$props5 = this.props,
        activeId = _this$props5.activeId,
        focusedItem = _this$props5.focusedItem,
        selectedItem = _this$props5.selectedItem,
        onSelect = _this$props5.onSelect,
        isDisabled = _this$props5.isDisabled,
        searchTerm = _this$props5.searchTerm,
        Option = _this$props5.optionComponent;
    var isFocused = focusedItem === item;
    return _react.default.createElement(Option, {
      dataItem: item,
      key: 'item_' + index,
      index: index,
      activeId: activeId,
      focused: isFocused,
      onSelect: onSelect,
      disabled: isDisabled(item),
      selected: selectedItem === item
    }, this.renderItem({
      item: item,
      index: index,
      searchTerm: searchTerm
    }));
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props6 = this.props,
        className = _this$props6.className,
        messages = _this$props6.messages;
    var elementProps = Props.pickElementProps(this);

    var _getMessages = (0, _messages.getMessages)(messages),
        emptyList = _getMessages.emptyList;

    return _react.default.createElement(_Listbox.default, _extends({}, elementProps, {
      className: className,
      emptyListMessage: emptyList(this.props)
    }), this.mapItems(function (item, idx, isHeader) {
      return isHeader ? _react.default.createElement(_ListOptionGroup.default, {
        key: 'group_' + item,
        group: item
      }, _this2.renderGroup(item)) : _this2.renderOption(item, idx);
    }));
  };

  return List;
}(_react.default.Component);

List.getDataState = _reduceToListState.defaultGetDataState;

function renderedIndexOf(item, list, data, dataState) {
  var groups = dataState.groups,
      sortedKeys = dataState.sortedKeys;
  if (!groups) return data.indexOf(item);
  var runningIdx = -1;
  var idx = -1;
  sortedKeys.some(function (group) {
    var itemIdx = groups[group].indexOf(item);
    runningIdx++;

    if (itemIdx !== -1) {
      idx = runningIdx + itemIdx + 1;
      return true;
    }

    runningIdx += groups[group].length;
  });
  return idx;
}

List.propTypes = propTypes;
List.defaultProps = defaultProps;
var _default = List;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes.default.string,
  component: _propTypes.default.string
};

function ListOptionGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'li' : _ref$component;
  var Tag = component;
  return _react.default.createElement(Tag, {
    tabIndex: "-1",
    role: "separator",
    className: (0, _classnames.default)(className, 'rw-list-optgroup')
  }, children);
}

ListOptionGroup.propTypes = propTypes;
var _default = ListOptionGroup;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Listbox = _interopRequireDefault(__webpack_require__(710));

var _ListOption = _interopRequireDefault(__webpack_require__(711));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var propTypes = {
  searchTerm: PropTypes.string,
  focused: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  activeId: PropTypes.string
};

function AddToListOption(_ref) {
  var searchTerm = _ref.searchTerm,
      onSelect = _ref.onSelect,
      focused = _ref.focused,
      children = _ref.children,
      activeId = _ref.activeId,
      props = _objectWithoutProperties(_ref, ["searchTerm", "onSelect", "focused", "children", "activeId"]);

  return _react.default.createElement(_Listbox.default, _extends({}, props, {
    className: "rw-list-option-create"
  }), _react.default.createElement(_ListOption.default, {
    onSelect: onSelect,
    focused: focused,
    activeId: activeId,
    dataItem: searchTerm
  }, children));
}

AddToListOption.propTypes = propTypes;
var _default = AddToListOption;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(76));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var CustomPropTypes = _interopRequireWildcard(__webpack_require__(274));

var _dataHelpers = __webpack_require__(275);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DropdownListInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(DropdownListInput, _React$Component);

  function DropdownListInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      autofilling: false
    };

    _this.handleAutofillDetect = function (_ref) {
      var animationName = _ref.animationName;
      var autofilling;
      if (animationName === 'react-widgets-autofill-start') autofilling = true;else if (animationName === 'react-widgets-autofill-cancel') autofilling = false;else return;

      _this.setState({
        autofilling: autofilling
      });

      _this.props.onAutofill(autofilling);
    };

    _this.handleAutofill = function (e) {
      _this.setState({
        autofilling: false
      });

      _this.props.onAutofillChange(e);
    };

    return _this;
  }

  var _proto = DropdownListInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        textField = _this$props.textField,
        autoComplete = _this$props.autoComplete,
        Component = _this$props.valueComponent;
    var autofilling = this.state.autofilling;
    var child = null;

    if (!autofilling && autoComplete !== 'off') {
      child = !value && placeholder ? _react.default.createElement("span", {
        className: "rw-placeholder"
      }, placeholder) : Component ? _react.default.createElement(Component, {
        item: value
      }) : (0, _dataHelpers.dataText)(value, textField);
    }

    var val = (0, _dataHelpers.dataValue)(value, textField);
    return _react.default.createElement("div", {
      className: "rw-input rw-dropdown-list-input"
    }, autoComplete !== 'off' && _react.default.createElement("input", {
      tabIndex: "-1",
      name: name,
      value: val == null ? '' : val,
      autoComplete: autoComplete,
      onChange: this.handleAutofill,
      onAnimationStart: this.handleAutofillDetect,
      className: (0, _classnames.default)('rw-dropdown-list-autofill rw-detect-autofill', !autofilling && 'rw-sr')
    }), child);
  };

  return DropdownListInput;
}(_react.default.Component);

DropdownListInput.propTypes = {
  value: _propTypes.default.any,
  placeholder: _propTypes.default.string,
  name: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  textField: CustomPropTypes.accessor,
  valueComponent: CustomPropTypes.elementType,
  onAutofill: _propTypes.default.func.isRequired,
  onAutofillChange: _propTypes.default.func.isRequired
};
var _default = DropdownListInput;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createFocusManager;

var _reactComponentManagers = __webpack_require__(474);

var _interaction = __webpack_require__(713);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createFocusManager(inst, options) {
  var _didHandle = options.didHandle;
  return (0, _reactComponentManagers.focusManager)(inst, _extends({}, options, {
    onChange: function onChange(focused) {
      inst.setState({
        focused: focused
      });
    },
    isDisabled: function isDisabled() {
      return inst.props.disabled === true || (0, _interaction.isInDisabledFieldset)(inst);
    },
    didHandle: function didHandle(focused, event) {
      var handler = this.props[focused ? 'onFocus' : 'onBlur'];
      handler && handler(event);
      if (_didHandle && !event.isWidgetDefaultPrevented) _didHandle(focused, event);
    }
  }));
}

module.exports = exports["default"];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = matches;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(702));

var matchesCache;

function matches(node, selector) {
  if (!matchesCache && _inDOM.default) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
    matchesCache = nativeMatch ? function (node, selector) {
      return nativeMatch.call(node, selector);
    } : ie8MatchesSelector;
  }

  return matchesCache ? matchesCache(node, selector) : null;
}

function ie8MatchesSelector(node, selector) {
  var matches = (0, _querySelectorAll.default)(node.document || node.ownerDocument, selector),
      i = 0;

  while (matches[i] && matches[i] !== node) {
    i++;
  }

  return !!matches[i];
}

module.exports = exports["default"];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createAccessors;

var helpers = _interopRequireWildcard(__webpack_require__(275));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function createAccessors(_ref) {
  var textField = _ref.textField,
      valueField = _ref.valueField;
  return {
    text: function text(item) {
      return helpers.dataText(item, textField);
    },
    value: function value(item) {
      return helpers.dataValue(item, valueField);
    },
    indexOf: function indexOf(data, item) {
      return helpers.dataIndexOf(data, item, valueField);
    },
    matches: function matches(a, b) {
      return helpers.valueMatcher(a, b, valueField);
    },
    findOrSelf: function findOrSelf(data, item) {
      return helpers.dataItem(data, item, valueField);
    },
    includes: function includes(data, item) {
      return helpers.dataIndexOf(data, item, valueField) !== -1;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createScrollManager;

var _scrollTo = _interopRequireDefault(__webpack_require__(1630));

var _reactComponentManagers = __webpack_require__(474);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createScrollManager(inst, getScrollParent) {
  if (getScrollParent === void 0) {
    getScrollParent = function getScrollParent(list) {
      return list.parentNode;
    };
  }

  var isMounted = (0, _reactComponentManagers.mountManager)(inst);
  var currentFocused, currentVisible, cancelScroll;

  function handleScroll(selected, list, nextFocused) {
    if (!isMounted()) return;
    var lastVisible = currentVisible;
    var lastItem = currentFocused;
    var shown, changed;
    currentVisible = !(!list.offsetWidth || !list.offsetHeight);
    currentFocused = nextFocused;
    changed = lastItem !== nextFocused;
    shown = currentVisible && !lastVisible;

    if (shown || currentVisible && changed) {
      if (this.props.onMove) this.props.onMove(selected, list, nextFocused);else {
        cancelScroll && cancelScroll();
        cancelScroll = (0, _scrollTo.default)(selected, false && getScrollParent(list));
      }
    }
  }

  return handleScroll.bind(inst);
}

module.exports = exports["default"];

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = scrollTo;

var _offset = _interopRequireDefault(__webpack_require__(706));

var _height = _interopRequireDefault(__webpack_require__(477));

var _scrollParent = _interopRequireDefault(__webpack_require__(1631));

var _scrollTop = _interopRequireDefault(__webpack_require__(1632));

var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(1633));

var _isWindow = _interopRequireDefault(__webpack_require__(345));

function scrollTo(selected, scrollParent) {
  var offset = (0, _offset.default)(selected);
  var poff = {
    top: 0,
    left: 0
  };
  var list, listScrollTop, selectedTop, isWin;
  var selectedHeight, listHeight, bottom;
  if (!selected) return;
  list = scrollParent || (0, _scrollParent.default)(selected);
  isWin = (0, _isWindow.default)(list);
  listScrollTop = (0, _scrollTop.default)(list);
  listHeight = (0, _height.default)(list, true);
  isWin = (0, _isWindow.default)(list);
  if (!isWin) poff = (0, _offset.default)(list);
  offset = {
    top: offset.top - poff.top,
    left: offset.left - poff.left,
    height: offset.height,
    width: offset.width
  };
  selectedHeight = offset.height;
  selectedTop = offset.top + (isWin ? 0 : listScrollTop);
  bottom = selectedTop + selectedHeight;
  listScrollTop = listScrollTop > selectedTop ? selectedTop : bottom > listScrollTop + listHeight ? bottom - listHeight : listScrollTop;
  var id = (0, _requestAnimationFrame.default)(function () {
    return (0, _scrollTop.default)(list, listScrollTop);
  });
  return function () {
    return _requestAnimationFrame.default.cancel(id);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = scrollPrarent;

var _style = _interopRequireDefault(__webpack_require__(703));

var _height = _interopRequireDefault(__webpack_require__(477));

function scrollPrarent(node) {
  var position = (0, _style.default)(node, 'position'),
      excludeStatic = position === 'absolute',
      ownerDoc = node.ownerDocument;
  if (position === 'fixed') return ownerDoc || document;

  while ((node = node.parentNode) && node.nodeType !== 9) {
    var isStatic = excludeStatic && (0, _style.default)(node, 'position') === 'static',
        style = (0, _style.default)(node, 'overflow') + (0, _style.default)(node, 'overflow-y') + (0, _style.default)(node, 'overflow-x');
    if (isStatic) continue;
    if (/(auto|scroll)/.test(style) && (0, _height.default)(node) < node.scrollHeight) return node;
  }

  return document;
}

module.exports = exports["default"];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(345));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(191));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.search = exports.clock = exports.calendar = exports.chevronLeft = exports.chevronRight = exports.caretDown = exports.caretUp = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  icon: _propTypes.default.string.isRequired
};

var Icon = function Icon(_ref) {
  var icon = _ref.icon;
  return _react.default.createElement("span", {
    "aria-hidden": "true",
    className: "rw-i rw-i-" + icon
  });
};

Icon.propTypes = propTypes;

var caretUp = _react.default.createElement(Icon, {
  icon: "caret-up"
});

exports.caretUp = caretUp;

var caretDown = _react.default.createElement(Icon, {
  icon: "caret-down"
});

exports.caretDown = caretDown;

var chevronRight = _react.default.createElement(Icon, {
  icon: "chevron-right"
});

exports.chevronRight = chevronRight;

var chevronLeft = _react.default.createElement(Icon, {
  icon: "chevron-left"
});

exports.chevronLeft = chevronLeft;

var calendar = _react.default.createElement(Icon, {
  icon: "calendar"
});

exports.calendar = calendar;

var clock = _react.default.createElement(Icon, {
  icon: "clock-o"
});

exports.clock = clock;

var search = _react.default.createElement(Icon, {
  icon: "search"
});

exports.search = search;
var _default = Icon;
exports.default = _default;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _assignment = __webpack_require__(241);

var _name = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnassignmentModal = function (_Component) {
  (0, _inherits3.default)(UnassignmentModal, _Component);

  function UnassignmentModal(props) {
    (0, _classCallCheck3.default)(this, UnassignmentModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UnassignmentModal.__proto__ || (0, _getPrototypeOf2.default)(UnassignmentModal)).call(this, props));

    _this.onUnassignmentClickBound = _this.onUnassignmentClick.bind(_this);
    _this.closeModalBound = _this.closeModal.bind(_this);
    _this.cancelUnassignmentClickBound = _this.cancelUnassignmentClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UnassignmentModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showModal();
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflow = 'scroll';
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '500px',
        background: '#fff',
        overflow: 'visible',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%',
        borderRadius: '6px'
      };
      var quest = this.props.quest;


      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'unassignment-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          closeOnClick: true,
          onHide: this.closeModalBound
        },
        quest.assigned_to ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'top' },
            _react2.default.createElement(
              'div',
              { className: 'assignment-icons' },
              _react2.default.createElement(_QuestIcon2.default, {
                icon_image_url: quest.icon_image_url,
                heightWidth: 47
              }),
              _react2.default.createElement('div', { className: 'cross-img' }),
              _react2.default.createElement(_UserAvatar2.default, { photoUrl: quest.assigned_to.photo_url })
            ),
            _react2.default.createElement(
              'h1',
              null,
              'Unassign this Quest?'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom' },
            _react2.default.createElement(
              'div',
              { className: 'guidance' },
              _react2.default.createElement(
                'div',
                null,
                'You are about to unassign this quest from',
                ' ',
                (0, _name.getUserDisplayName)(quest.assigned_to),
                '.'
              ),
              _react2.default.createElement(
                'div',
                null,
                'Are you sure you want to do this?'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'actions' },
              _react2.default.createElement(
                'div',
                {
                  className: 'button btn-secondary-small modal-cancel',
                  onClick: this.cancelUnassignmentClickBound
                },
                'Cancel'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'button btn-primary-small modal-confirm unassign',
                  onClick: this.onUnassignmentClickBound
                },
                'Unassign'
              )
            )
          )
        ) : null
      );
    }
  }, {
    key: 'onUnassignmentClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _assignment.unassignQuestFromUser)(this.props.quest.id, this.props.questIsAssignedToUser, this.props.quest.current_quest_assignment_id));

              case 2:
                this.refs.modal.hide();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onUnassignmentClick() {
        return _ref.apply(this, arguments);
      }

      return onUnassignmentClick;
    }()
  }, {
    key: 'showModal',
    value: function showModal() {
      this.refs.modal.show();
    }
  }, {
    key: 'cancelUnassignmentClick',
    value: function cancelUnassignmentClick() {
      this.refs.modal.hide();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.props.dispatch((0, _assignment.unassignmentCancelClick)());
    }
  }]);
  return UnassignmentModal;
}(_react.Component);

exports.default = UnassignmentModal;


UnassignmentModal.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  quest: _propTypes2.default.object.isRequired,
  questIsAssignedToUser: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewBannerDisconnected = undefined;

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactIntl = __webpack_require__(16);

var _StatusText = __webpack_require__(1637);

var _StatusText2 = _interopRequireDefault(_StatusText);

var _ReviewStatusIndicators = __webpack_require__(1638);

var _ReviewStatusIndicators2 = _interopRequireDefault(_ReviewStatusIndicators);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _review = __webpack_require__(159);

var _review2 = __webpack_require__(64);

var _user = __webpack_require__(45);

var _messages = __webpack_require__(21);

var _modal = __webpack_require__(470);

var _assignment = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewBanner = function (_Component) {
  (0, _inherits3.default)(ReviewBanner, _Component);

  function ReviewBanner(props) {
    (0, _classCallCheck3.default)(this, ReviewBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewBanner.__proto__ || (0, _getPrototypeOf2.default)(ReviewBanner)).call(this, props));

    _this.onStopReviewClickBound = _this.onStopReviewClick.bind(_this);
    _this.onActualStopReviewClickBound = _this.onActualStopReviewClick.bind(_this);
    _this.onCancelReviewClickBound = _this.onCancelReviewClick.bind(_this);
    _this.onActualCancelClickBound = _this.onActualCancelClick.bind(_this);
    _this.onEditQuestClickBound = _this.onEditQuestClick.bind(_this);
    _this.onEditPublishedQuestClickBound = _this.onEditPublishedQuestClick.bind(_this);
    _this.onActualEditPublishedQuestClickBound = _this.onActualEditPublishedQuestClick.bind(_this);
    _this.hideModalBound = _this.hideModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReviewBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.stopReviewModal = this.refs.stopReviewModal.refs.modal;
      this.cancelReviewModal = this.refs.cancelReviewModal.refs.modal;
      this.editPublishedQuestModal = this.refs.editPublishedQuestModal.refs.modal;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          user = _props.user,
          activeReview = _props.activeReview,
          organization = _props.organization,
          approvals = _props.approvals,
          activities = _props.activities;
      var intl = this.context.intl;

      var reviewStatus = (0, _review2.getReviewStatus)(quest);
      var friendlyStatus = (0, _review2.getFriendlyStatus)(reviewStatus);

      var modalMessages = {
        header: {
          reviewInProgress: intl.formatMessage(_modal.headingMessages.reviewInProgress),
          thisQuestIsPublished: intl.formatMessage(_modal.headingMessages.thisQuestIsPublished),
          cancelReview: intl.formatMessage(_modal.headingMessages.cancelReview)
        },
        body: {
          ifYouStop1: intl.formatMessage(_modal.bodyMessages.ifYouStop1),
          ifYouStop2: intl.formatMessage(_modal.bodyMessages.ifYouStop2),
          ifYouStop3: intl.formatMessage(_modal.bodyMessages.ifYouStop3),
          toEditThisQuest: intl.formatMessage(_modal.bodyMessages.toEditThisQuest),
          ifYouCancel: intl.formatMessage(_modal.bodyMessages.ifYouCancel)
        },
        button: {
          yes: intl.formatMessage(_modal.buttonMessages.yes),
          ok: intl.formatMessage(_modal.buttonMessages.ok),
          cancel: intl.formatMessage(_modal.buttonMessages.cancel),
          no: intl.formatMessage(_modal.buttonMessages.no)
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'review-banner ' + reviewStatus },
        _react2.default.createElement(
          'div',
          {
            className: 'left ' + (this.showBlackBanner() ? 'right-is-active' : '')
          },
          _react2.default.createElement(
            'div',
            { className: 'status' },
            friendlyStatus
          ),
          _react2.default.createElement(
            'div',
            { className: 'pointer-container' },
            _react2.default.createElement('div', { className: 'pointer' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'right ' + (this.showBlackBanner() ? 'active' : '') },
          this.showReviewStatusIndicators() && _react2.default.createElement(_ReviewStatusIndicators2.default, (0, _extends3.default)({}, this.props, {
            reviewStatus: reviewStatus
          })),
          _react2.default.createElement(_StatusText2.default, {
            quest: quest,
            approvals: approvals,
            currentCompiledQuest: quest.current_compiled_quest ? quest.current_compiled_quest : '',
            canSubmitForReview: (0, _review2.canSubmitForReview)(user, quest, organization, activities),
            isQuestCopyEditorOrQuestAuthorOrQuestManager: (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization),
            questIsInRejectedState: (0, _review2.questIsInRejectedState)(quest),
            questIsInQualityReview: (0, _review2.questIsInQualityReview)(quest),
            questHasAssignment: (0, _assignment.questHasAssignment)(quest),
            canSubmitButNotReady: (0, _review2.canSubmitButNotReady)(user, quest, organization, activities),
            questInDraftAfterRejection: (0, _review2.questInDraftAfterRejection)(quest)
          }),
          (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && quest.reviewing_compiled_quest && quest.reviewing_compiled_quest.state === 'rejected' && _react2.default.createElement(
            'div',
            {
              className: 'quest-action button edit-quest',
              onClick: this.onEditQuestClickBound
            },
            _messages.editQuest
          ),
          (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && quest.reviewing_compiled_quest && quest.reviewing_compiled_quest.state === 'published' && _react2.default.createElement(
            'div',
            {
              className: 'quest-action button btn-secondary-dark',
              onClick: this.onEditPublishedQuestClickBound
            },
            _messages.editQuest
          ),
          (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && this.qdCanStopReview() && _react2.default.createElement(
            'div',
            {
              className: 'sequestered-action-container',
              onClick: this.onStopReviewClickBound
            },
            _react2.default.createElement('div', { className: 'x-action' }),
            _react2.default.createElement(
              'div',
              { className: 'sequestered-action-text' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'Quest.ReviewBanner.StopReview',
                defaultMessage: 'Stop Review'
              })
            )
          ),
          (0, _review2.isActiveWithThisReviewer)(activeReview, user) && _react2.default.createElement(
            'div',
            {
              className: 'sequestered-action-container',
              onClick: this.onCancelReviewClickBound
            },
            _react2.default.createElement('div', { className: 'x-action' }),
            _react2.default.createElement(
              'div',
              { className: 'sequestered-action-text' },
              _messages.cancelReview
            )
          )
        ),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'stopReviewModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'stopReviewModal',
          headingKlass: 'modal-heading alert',
          logoKlass: 'logo alert',
          headingText: modalMessages.header.reviewInProgress,
          bodyText: [modalMessages.body.ifYouStop1, _react2.default.createElement(
            'strong',
            null,
            '\xA0',
            modalMessages.body.ifYouStop2,
            '\xA0'
          ), modalMessages.body.ifYouStop3],
          primaryButtonText: modalMessages.button.ok,
          secondaryButtonText: modalMessages.button.cancel,
          primaryButtonAction: this.onActualStopReviewClickBound,
          secondaryButtonAction: this.hideModalBound
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'cancelReviewModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'cancelReviewModal',
          headingKlass: 'modal-heading alert',
          logoKlass: 'logo alert',
          headingText: modalMessages.header.cancelReview,
          bodyText: modalMessages.body.ifYouCancel,
          primaryButtonText: modalMessages.button.yes,
          secondaryButtonText: modalMessages.button.no,
          primaryButtonAction: this.onActualCancelClickBound,
          secondaryButtonAction: this.hideModalBound
        }),
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'editPublishedQuestModal',
          quest: quest,
          klass: 'review-modal modal',
          modalId: 'editPublishedQuestModal',
          headingKlass: 'modal-heading no-cap alert',
          logoKlass: 'logo alert',
          headingText: modalMessages.header.thisQuestIsPublished,
          bodyText: [modalMessages.body.toEditThisQuest, _react2.default.createElement(
            'span',
            null,
            ' '
          ), _react2.default.createElement(
            'a',
            { href: 'mailto:support@opportunityeducation.org?', target: '_top' },
            'support@opportunityeducation.org'
          ), '.)'],
          primaryButtonText: modalMessages.button.ok,
          secondaryButtonText: modalMessages.button.cancel,
          primaryButtonAction: this.onActualEditPublishedQuestClickBound,
          secondaryButtonAction: this.hideModalBound
        })
      );
    }
  }, {
    key: 'onEditPublishedQuestClick',
    value: function onEditPublishedQuestClick() {
      this.editPublishedQuestModal.show();
    }
  }, {
    key: 'onActualEditPublishedQuestClick',
    value: function onActualEditPublishedQuestClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest;

      dispatch((0, _review.revertQuestToDraft)(quest.id, true));
      this.editPublishedQuestModal.hide();
    }
  }, {
    key: 'onEditQuestClick',
    value: function onEditQuestClick() {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          quest = _props3.quest;

      dispatch((0, _review.revertQuestToDraft)(quest.id));
    }
  }, {
    key: 'showReviewStatusIndicators',
    value: function showReviewStatusIndicators() {
      var _props4 = this.props,
          user = _props4.user,
          quest = _props4.quest,
          approvals = _props4.approvals,
          organization = _props4.organization,
          activities = _props4.activities;


      var reviewState = (0, _review2.getReviewStatus)(quest);
      var retVal = false;
      if (((0, _user.isInternalReviewer)(user) || (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization)) && reviewState === 'draft' && approvals.length > 0 && (0, _review2.allRequiredFieldsComplete)(quest, activities)) {
        retVal = true;
      } else if ((0, _user.isOeReviewer)(user) && (0, _review2.questIsInQualityReview)(quest)) {
        retVal = true;
      } else if ((0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && (0, _review2.questIsInRejectedState)(quest)) {
        retVal = true;
      }

      return retVal;
    }
  }, {
    key: 'showBlackBanner',
    value: function showBlackBanner() {
      var _props5 = this.props,
          user = _props5.user,
          quest = _props5.quest,
          organization = _props5.organization,
          approvals = _props5.approvals,
          activities = _props5.activities;

      var currentReviewState = (0, _review2.getReviewStatus)(quest);
      var retVal = false;
      if ((0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization)) {
        retVal = true;
      } else if ((0, _user.isInternalReviewer)(user) && currentReviewState === 'draft' && approvals.length > 0 && (0, _review2.allRequiredFieldsComplete)(quest, activities)) {
        retVal = true;
      } else if ((0, _user.isOeReviewer)(user) && (0, _review2.questIsInQualityReview)(quest)) {
        retVal = true;
      } else if (currentReviewState === 'published') {
        retVal = true;
      }

      return retVal;
    }
  }, {
    key: 'qdCanStopReview',
    value: function qdCanStopReview() {
      return (0, _review2.questIsInQualityReview)(this.props.quest);
    }
  }, {
    key: 'onStopReviewClick',
    value: function onStopReviewClick() {
      this.stopReviewModal.show();
    }
  }, {
    key: 'onActualStopReviewClick',
    value: function onActualStopReviewClick() {
      this.props.dispatch((0, _review.stopReview)(this.props.quest.id, this.props.quest.reviewing_compiled_quest.id));
      this.stopReviewModal.hide();
    }
  }, {
    key: 'onCancelReviewClick',
    value: function onCancelReviewClick() {
      this.cancelReviewModal.show();
    }
  }, {
    key: 'onActualCancelClick',
    value: function onActualCancelClick() {
      var _props6 = this.props,
          quest = _props6.quest,
          activeReview = _props6.activeReview;

      this.props.dispatch((0, _review.deleteCompiledQuestReview)(quest.id, quest.reviewing_compiled_quest.id, activeReview.id));
      this.cancelReviewModal.hide();
    }
  }, {
    key: 'onActualSubmitForReviewClick',
    value: function onActualSubmitForReviewClick() {
      this.props.dispatch((0, _review.createCompiledQuest)(this.props.quest.id));
      this.submitForReviewModal.hide();
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.stopReviewModal.hide();
      this.cancelReviewModal.hide();
      this.editPublishedQuestModal.hide();
    }
  }]);
  return ReviewBanner;
}(_react.Component);

ReviewBanner.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func,
  activeReview: _propTypes2.default.object,
  previousReviews: _propTypes2.default.array.isRequired,
  currentReviews: _propTypes2.default.array.isRequired,
  organization: _propTypes2.default.object.isRequired,
  approvals: _propTypes2.default.array,
  activities: _propTypes2.default.array.isRequired
};

ReviewBanner.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user,
    activeReview: state.quest.activeReview,
    previousReviews: state.quest.previousReviews,
    currentReviews: state.quest.currentReviews,
    organization: state.organization,
    approvals: state.quest.approvals,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReviewBanner);
exports.ReviewBannerDisconnected = ReviewBanner; // pure component - used in tests

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _oeWebCommon = __webpack_require__(117);

var _review = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusText = function (_Component) {
  (0, _inherits3.default)(StatusText, _Component);

  function StatusText() {
    (0, _classCallCheck3.default)(this, StatusText);
    return (0, _possibleConstructorReturn3.default)(this, (StatusText.__proto__ || (0, _getPrototypeOf2.default)(StatusText)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatusText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          approvals = _props.approvals,
          canSubmitForReview = _props.canSubmitForReview,
          isQuestCopyEditorOrQuestAuthorOrQuestManager = _props.isQuestCopyEditorOrQuestAuthorOrQuestManager,
          questIsInRejectedState = _props.questIsInRejectedState,
          questIsInQualityReview = _props.questIsInQualityReview,
          questHasAssignment = _props.questHasAssignment,
          canSubmitButNotReady = _props.canSubmitButNotReady,
          questInDraftAfterRejection = _props.questInDraftAfterRejection;


      var allCompleteNoApprovalsNoAssignment = canSubmitForReview && !questInDraftAfterRejection && approvals.length === 0 && !questHasAssignment;
      var notReadyNoApprovlsNoAssignment = canSubmitButNotReady && !questInDraftAfterRejection && !questHasAssignment;
      var allCompleteAfterRejection = canSubmitForReview && questInDraftAfterRejection && approvals.length === 0 && !questHasAssignment;
      var notAllCompleteAfterRejection = canSubmitButNotReady && questInDraftAfterRejection && !questHasAssignment;
      var inQualityReview = isQuestCopyEditorOrQuestAuthorOrQuestManager && questIsInQualityReview;
      var questIsRejected = isQuestCopyEditorOrQuestAuthorOrQuestManager && questIsInRejectedState;

      var primaryText = '';
      var secondaryText = '';
      var content = void 0;
      // Need to hide the assignment message if there are current approvals, but not when the quest isn't ready for reviews
      if (questHasAssignment && (approvals.length === 0 || approvals.length !== 0 && canSubmitButNotReady)) {
        primaryText = 'This quest is assigned to a reviewer and is not approved yet.';
        secondaryText = 'Keep an eye on it for feedback.';
      } else if (allCompleteNoApprovalsNoAssignment) {
        primaryText = 'All the required fields are now complete.';
        secondaryText = 'When ready, assign this quest to a Reviewer.';
      } else if (notReadyNoApprovlsNoAssignment) {
        primaryText = "What's next?";
        secondaryText = 'Complete all required fields, including at least 1 activity. You may also assign this quest to a peer to get early feedback.';
      } else if (allCompleteAfterRejection) {
        primaryText = 'Make the changes you discussed with your Reviewer.';
        secondaryText = 'When ready, assign this quest to a Reviewer again.';
      } else if (notAllCompleteAfterRejection) {
        primaryText = 'Complete all required fields.';
        secondaryText = 'When ready, assign this quest to a Reviewer again.';
      }

      if ((0, _review.questIsPublished)(quest)) {
        content = _react2.default.createElement(
          'div',
          null,
          'Published on ',
          _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
            date: quest.published_compiled_quest.published_at,
            includeTime: false
          }),
          ' at ',
          _react2.default.createElement(_oeWebCommon.OEComponents.Time, {
            time: quest.published_compiled_quest.published_at
          })
        );
      } else if (inQualityReview) {
        content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'primary' },
            'Internal reviews are complete. Onward!'
          ),
          _react2.default.createElement(
            'div',
            { className: 'tertiary' },
            'This quest moved on to Publication Review on ',
            _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
              date: quest.reviewing_compiled_quest.created_at,
              includeTime: false
            }),
            ' at ',
            _react2.default.createElement(_oeWebCommon.OEComponents.Time, {
              time: quest.reviewing_compiled_quest.created_at
            }),
            '.'
          )
        );
      } else if (questIsRejected) {
        content = _react2.default.createElement(
          'div',
          null,
          'This quest needs edits before it can move on.'
        );
      } else {
        content = this.renderText(primaryText, secondaryText);
      }

      return _react2.default.createElement(
        'div',
        { className: 'review-status-text' },
        content
      );
    }
  }, {
    key: 'renderText',
    value: function renderText(primary, secondary) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'primary' },
          primary
        ),
        _react2.default.createElement(
          'div',
          { className: 'tertiary' },
          secondary
        )
      );
    }
  }]);
  return StatusText;
}(_react.Component);

exports.default = StatusText;


StatusText.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  approvals: _propTypes2.default.array.isRequired,
  canSubmitForReview: _propTypes2.default.bool.isRequired,
  questIsInRejectedState: _propTypes2.default.bool.isRequired,
  questIsInQualityReview: _propTypes2.default.bool.isRequired,
  questHasAssignment: _propTypes2.default.bool.isRequired,
  canSubmitButNotReady: _propTypes2.default.bool.isRequired,
  questInDraftAfterRejection: _propTypes2.default.bool.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReviewStatusIndicator = __webpack_require__(1639);

var _ReviewStatusIndicator2 = _interopRequireDefault(_ReviewStatusIndicator);

var _user = __webpack_require__(45);

var _review = __webpack_require__(64);

var _label = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewStatusIndicators = function (_Component) {
  (0, _inherits3.default)(ReviewStatusIndicators, _Component);

  function ReviewStatusIndicators() {
    (0, _classCallCheck3.default)(this, ReviewStatusIndicators);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewStatusIndicators.__proto__ || (0, _getPrototypeOf2.default)(ReviewStatusIndicators)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewStatusIndicators, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentReviews = _props.currentReviews,
          reviewStatus = _props.reviewStatus,
          approvals = _props.approvals,
          user = _props.user,
          quest = _props.quest;
      var intl = this.context.intl;


      var intlReviewTypes = {
        standards: intl.formatMessage(_label.messages.standards),
        final: intl.formatMessage(_label.messages.final),
        experience: intl.formatMessage(_label.messages.experience),
        subject: intl.formatMessage(_label.messages.subject),
        copy: intl.formatMessage(_label.messages.copy)
      };

      return _react2.default.createElement(
        'div',
        { id: 'reviewStatusIndicatorContainer' },
        this.showInternalReviewStatusIndicators() && _react2.default.createElement(
          'div',
          { className: 'internal-review-status-indicators' },
          ['experience', 'subject', 'copy'].map(function (type, index) {
            return _react2.default.createElement(_ReviewStatusIndicator2.default, {
              reviewType: type,
              reviewStatus: reviewStatus,
              currentReviews: approvals,
              intlReviewType: intlReviewTypes[type],
              user: user,
              key: index,
              quest: quest
            });
          })
        ),
        this.showOeReviewStatusIndicators() && _react2.default.createElement(
          'div',
          { className: 'oe-review-status-indicators' },
          ['standards', 'final'].map(function (type, index) {
            return _react2.default.createElement(_ReviewStatusIndicator2.default, {
              reviewType: type,
              reviewStatus: reviewStatus,
              currentReviews: currentReviews,
              intlReviewType: intlReviewTypes[type],
              user: user,
              key: index,
              quest: quest
            });
          })
        )
      );
    }
  }, {
    key: 'showInternalReviewStatusIndicators',
    value: function showInternalReviewStatusIndicators() {
      var _props2 = this.props,
          user = _props2.user,
          quest = _props2.quest,
          organization = _props2.organization,
          approvals = _props2.approvals,
          reviewStatus = _props2.reviewStatus;

      return ((0, _user.isInternalReviewer)(user) || (0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization)) && reviewStatus === 'draft' && approvals.length > 0;
    }
  }, {
    key: 'showOeReviewStatusIndicators',
    value: function showOeReviewStatusIndicators() {
      var _props3 = this.props,
          user = _props3.user,
          quest = _props3.quest,
          reviewStatus = _props3.reviewStatus,
          currentReviews = _props3.currentReviews,
          organization = _props3.organization;

      var rejectedReview = (0, _review.findRejectedReview)(currentReviews);
      var retVal = false;
      if ((0, _user.isOeReviewer)(user, quest) && (0, _review.questIsInQualityReview)(quest)) {
        retVal = true;
      } else if ((0, _user.isQuestCopyEditorOrQuestAuthorOrQuestManager)(user, quest, organization) && reviewStatus === 'rejected' && ['standards', 'final'].includes(rejectedReview)) {
        retVal = true;
      }
      return retVal;
    }
  }]);
  return ReviewStatusIndicators;
}(_react.Component);

exports.default = ReviewStatusIndicators;


ReviewStatusIndicators.propTypes = {
  reviewStatus: _propTypes2.default.string,
  user: _propTypes2.default.object.isRequired,
  currentReviews: _propTypes2.default.array,
  quest: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object.isRequired,
  approvals: _propTypes2.default.array
};

ReviewStatusIndicators.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _review = __webpack_require__(64);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewStatusIndicator = function (_Component) {
  (0, _inherits3.default)(ReviewStatusIndicator, _Component);

  function ReviewStatusIndicator() {
    (0, _classCallCheck3.default)(this, ReviewStatusIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewStatusIndicator.__proto__ || (0, _getPrototypeOf2.default)(ReviewStatusIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewStatusIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reviewType = _props.reviewType,
          currentReviews = _props.currentReviews,
          user = _props.user,
          quest = _props.quest;

      var review = (0, _review.findReview)(currentReviews, reviewType);

      return _react2.default.createElement(
        'div',
        { className: this.getCssClasses(review, user, quest) },
        this.props.intlReviewType
      );
    }
  }, {
    key: 'getCssClasses',
    value: function getCssClasses(review, user, quest) {
      var cssClasses = 'review-status-indicator';
      if (!review || review.accepted === null) {
        cssClasses += ' no-review';
      } else if (review.accepted === true || Boolean(review.approved_by) === true) {
        cssClasses += ' accepted';
      } else if (review.accepted === false) {
        cssClasses += ' rejected';
      }

      if (this.props.reviewStatus === 'rejected') {
        if (!review || review.accepted === true) {
          cssClasses += ' dimmed-review-label';
        }
      }

      if ((0, _review.questIsInRejectedState)(quest) && !(0, _user.isInternalReviewer)(user)) {
        if (!review || review.accepted === true) {
          cssClasses += ' hidden-review-label';
        }
      }
      return cssClasses;
    }
  }]);
  return ReviewStatusIndicator;
}(_react.Component);

exports.default = ReviewStatusIndicator;


ReviewStatusIndicator.propTypes = {
  reviewType: _propTypes2.default.string.isRequired,
  currentReviews: _propTypes2.default.array,
  reviewStatus: _propTypes2.default.string.isRequired,
  intlReviewType: _propTypes2.default.string.isRequired,
  approvals: _propTypes2.default.array,
  user: _propTypes2.default.object.isRequired,
  quest: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _Sentiment = __webpack_require__(1641);

var _Sentiment2 = _interopRequireDefault(_Sentiment);

var _GradeLevelScores = __webpack_require__(1642);

var _GradeLevelScores2 = _interopRequireDefault(_GradeLevelScores);

var _modal = __webpack_require__(26);

var _messages = __webpack_require__(21);

var _utils = __webpack_require__(20);

var _readability = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadabilityModal = function (_Component) {
  (0, _inherits3.default)(ReadabilityModal, _Component);

  function ReadabilityModal() {
    (0, _classCallCheck3.default)(this, ReadabilityModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReadabilityModal.__proto__ || (0, _getPrototypeOf2.default)(ReadabilityModal)).call(this));

    _this.closeModalBound = _this.closeModal.bind(_this);
    _this.onClickToCloseModalBound = _this.onClickToCloseModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReadabilityModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showModal();
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflow = 'scroll';
      this.props.dispatch((0, _modal.isNotViewingReadabilityScoresModal)());
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '712px',
        minHeight: '375px',
        background: '#fff',
        overflow: 'visible',
        borderRadius: '5px',
        padding: '13px 24px 40px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%',
        outline: 'none'
      };

      var _props = this.props,
          quest = _props.quest,
          section = _props.section,
          subsection = _props.subsection,
          activity = _props.activity;

      var readableObject = section === 'activity' ? activity : quest;
      var scores = (0, _readability.getSectionScores)(readableObject, subsection);

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'readability-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          closeOnClick: true,
          onHide: this.closeModalBound
        },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'top' },
            _react2.default.createElement(
              'div',
              { className: 'header-container' },
              _react2.default.createElement(
                'div',
                { className: 'header' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'ReadabilityModal.Readability',
                  defaultMessage: 'Readability'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'section' },
                section.concat(' ').concat(subsection.replace(/_/g, ' '))
              )
            ),
            _react2.default.createElement('div', {
              className: 'close-icon',
              onClick: this.onClickToCloseModalBound
            })
          ),
          _react2.default.createElement('div', { className: 'line' }),
          _react2.default.createElement(
            'div',
            { className: 'bottom' },
            _react2.default.createElement(
              'div',
              { className: 'left' },
              _react2.default.createElement(
                'div',
                { className: 'average-grade-level' },
                _react2.default.createElement('div', { className: 'book-icon' }),
                _react2.default.createElement(
                  'div',
                  { className: 'grade-level-container' },
                  _react2.default.createElement(
                    'div',
                    { className: 'score' },
                    (0, _utils.isNullOrEmpty)(scores.stats.average_grade_level) ? _react2.default.createElement(
                      'span',
                      null,
                      '\u2014'
                    ) : scores.stats.average_grade_level
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'readability-label' },
                    _messages.averageGradeLevel
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'average-grade-name' },
                (0, _utils.isNullOrEmpty)(scores.stats.average_grade_level_label) ? this.renderNotAvailable() : (0, _readability.getDisplayAverageGradeLevelLabel)(scores.stats.average_grade_level_label)
              ),
              scores.stats.average_grade_level_scores && _react2.default.createElement(_GradeLevelScores2.default, {
                gradeLevelScores: scores.stats.average_grade_level_scores
              }),
              _react2.default.createElement(
                'div',
                { className: 'link' },
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'https://readable.io/' },
                  'Learn more'
                ),
                ' ',
                'about these scores.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'right' },
              _react2.default.createElement(_Sentiment2.default, {
                sentiment: scores.stats.sentiment,
                klass: scores.stats.sentiment ? (0, _utils.getClassNameFromText)(scores.stats.sentiment) : 'no-score',
                renderNotAvailable: this.renderNotAvailable()
              }),
              _react2.default.createElement(
                'div',
                { className: 'reading-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'score' },
                  (0, _utils.isNullOrEmpty)(scores.stats.reading_time) ? _react2.default.createElement(
                    'span',
                    null,
                    '\u2014'
                  ) : (0, _readability.formatReadingTime)(scores.stats.reading_time)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'readability-label' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ReadabilityModal.ReadingTime',
                    defaultMessage: 'Reading Time'
                  })
                ),
                (0, _utils.isNullOrEmpty)(scores.stats.reading_time) && this.renderNotAvailable()
              ),
              _react2.default.createElement(
                'div',
                { className: 'longest-sentence-container' },
                _react2.default.createElement(
                  'div',
                  { className: 'score' },
                  (0, _utils.isNullOrEmpty)(scores.stats.longest_sentence_words) ? _react2.default.createElement(
                    'span',
                    null,
                    '\u2014'
                  ) : (0, _readability.parseLongestSentenceWordCount)(scores.stats.longest_sentence_words).wordCount
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'readability-label' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ReadabilityModal.LongestSentenceByWordCount',
                    defaultMessage: 'Longest Sentence by Word Count'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'longest-sentence' },
                  (0, _utils.isNullOrEmpty)(scores.stats.longest_sentence_words) ? this.renderNotAvailable() : (0, _readability.parseLongestSentenceWordCount)(scores.stats.longest_sentence_words).longestSentence
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderNotAvailable',
    value: function renderNotAvailable() {
      return _react2.default.createElement(
        'div',
        { className: 'not-available' },
        _messages.thisDataIsNotCurrentlyAvailable
      );
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      this.refs.modal.show();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.props.dispatch((0, _modal.isNotViewingReadabilityScoresModal)());
    }
  }, {
    key: 'onClickToCloseModal',
    value: function onClickToCloseModal() {
      this.refs.modal.hide();
    }
  }]);
  return ReadabilityModal;
}(_react.Component);

exports.default = ReadabilityModal;


ReadabilityModal.propTypes = {
  quest: _propTypes2.default.object.isRequired,
  section: _propTypes2.default.string.isRequired,
  subsection: _propTypes2.default.string.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  activity: _propTypes2.default.object
};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _readability = __webpack_require__(222);

var _utils = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sentiment = function Sentiment(props) {
  return _react2.default.createElement(
    'div',
    { className: 'sentiment ' + props.klass },
    _react2.default.createElement(
      'div',
      { className: 'sentiment-marker-container' },
      _react2.default.createElement(
        'div',
        { className: 'sentiment-marker' },
        _react2.default.createElement(
          'div',
          { className: 'sentiment-label' },
          (0, _utils.isNullOrEmpty)(props.sentiment) ? props.renderNotAvailable : (0, _readability.getDisplaySentimentLabel)(props.sentiment)
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'sentiment-score-container' },
      _react2.default.createElement(
        'div',
        { className: 'sentiment-score-bar' },
        _react2.default.createElement(
          'div',
          { className: 'sentiment-score-bar-value-container' },
          _react2.default.createElement('div', { className: 'sentiment-score-bar-value' })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'label negative' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'Readability.Sentiment.Negative',
          defaultMessage: 'Negative'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'label positive' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'Readability.Sentiment.Positive',
          defaultMessage: 'Positive'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'readability-label' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'Readability.Sentiment.Sentiment',
          defaultMessage: 'Sentiment'
        })
      )
    )
  );
};

Sentiment.propTypes = {
  sentiment: _propTypes2.default.string,
  klass: _propTypes2.default.string.isRequired,
  renderNotAvailable: _propTypes2.default.object.isRequired
};

exports.default = Sentiment;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _readability = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GradeLevelScores = function GradeLevelScores(props) {
  return _react2.default.createElement(
    'div',
    { className: 'grade-level-scores' },
    props.gradeLevelScores.map(function (score, i) {
      var key = (0, _keys2.default)(score)[0];
      return _react2.default.createElement(
        'div',
        { className: 'grade-level-score', key: i },
        _react2.default.createElement(
          'div',
          { className: 'label' },
          (0, _readability.formatGradeLevelLabels)(key)
        ),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(
          'div',
          {
            className: 'value ' + ((0, _readability.isMaxOrMinGradeLevel)(score[key], props.gradeLevelScores) ? 'bold' : '')
          },
          score[key]
        )
      );
    })
  );
};

GradeLevelScores.propTypes = {
  gradeLevelScores: _propTypes2.default.array.isRequired
};

exports.default = GradeLevelScores;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

exports.confirm = confirm;

var _reactConfirm = __webpack_require__(714);

var _Confirmation = __webpack_require__(1646);

var _Confirmation2 = _interopRequireDefault(_Confirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConfirmation = (0, _reactConfirm.createConfirmation)(_Confirmation2.default);

function confirm(confirmation) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return defaultConfirmation((0, _assign2.default)({ confirmation: confirmation }, options));
}

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var confirmable = function confirmable(Component) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

      _this.state = {
        show: true
      };
      return _this;
    }

    _createClass(_class, [{
      key: 'dismiss',
      value: function dismiss() {
        var _this2 = this;

        this.setState({
          show: false
        }, function () {
          _this2.props.dispose();
        });
      }
    }, {
      key: 'cancel',
      value: function cancel(value) {
        var _this3 = this;

        this.setState({
          show: false
        }, function () {
          _this3.props.reject(value);
        });
      }
    }, {
      key: 'proceed',
      value: function proceed(value) {
        var _this4 = this;

        this.setState({
          show: false
        }, function () {
          _this4.props.resolve(value);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({ proceed: this.proceed.bind(this), cancel: this.cancel.bind(this), dismiss: this.dismiss.bind(this), show: this.state.show }, this.props));
      }
    }]);

    return _class;
  }(_react2.default.Component);
};

exports.default = confirmable;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createConfirmation = function createConfirmation(Component) {
  var unmountDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var mountingNode = arguments[2];

  return function (props) {
    var wrapper = (mountingNode || document.body).appendChild(document.createElement('div'));

    var promise = new Promise(function (resolve, reject) {
      try {
        _reactDom2.default.render(_react2.default.createElement(Component, _extends({
          reject: reject,
          resolve: resolve,
          dispose: dispose
        }, props)), wrapper);
      } catch (e) {
        console.error(e);
        throw e;
      }
    });

    function dispose() {
      setTimeout(function () {
        _reactDom2.default.unmountComponentAtNode(wrapper);
        setTimeout(function () {
          if (document.body.contains(wrapper)) {
            document.body.removeChild(wrapper);
          }
        });
      }, unmountDelay);
    }

    return promise.then(function (result) {
      dispose();
      return result;
    }, function (result) {
      dispose();
      return Promise.reject(result);
    });
  };
};

exports.default = createConfirmation;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalComponent = __webpack_require__(190);

var _ModalComponent2 = _interopRequireDefault(_ModalComponent);

var _reactConfirm = __webpack_require__(714);

var _modal = __webpack_require__(470);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Confirmation = function (_React$Component) {
  (0, _inherits3.default)(Confirmation, _React$Component);

  function Confirmation(props) {
    (0, _classCallCheck3.default)(this, Confirmation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Confirmation.__proto__ || (0, _getPrototypeOf2.default)(Confirmation)).call(this, props));

    _this.handleProceed = _this.handleProceed.bind(_this);
    _this.handleDismiss = _this.handleDismiss.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Confirmation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.modal.refs.modal.show();
    }

    // Adding to built-in prop to get modal animation

  }, {
    key: 'handleProceed',
    value: function handleProceed() {
      this.props.proceed();
      this.refs.modal.refs.modal.hide();
    }

    // Adding to built-in prop to get modal animation

  }, {
    key: 'handleDismiss',
    value: function handleDismiss() {
      this.props.dismiss();
      this.refs.modal.refs.modal.hide();
    }

    // Adding to built-in prop to get modal animation

  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.props.cancel();
      this.refs.modal.refs.modal.hide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          intl = _props.intl;


      var intlHeading = intl.formatMessage(_modal.headingMessages.wait);
      var intlBody = intl.formatMessage(_modal.bodyMessages.youreLeaving);
      var intlPrimaryButton = intl.formatMessage(_modal.buttonMessages.leaveAnyway);
      var intlSecondaryButton = intl.formatMessage(_modal.buttonMessages.cancel);

      return _react2.default.createElement(
        'div',
        { className: 'modal' },
        _react2.default.createElement(_ModalComponent2.default, {
          ref: 'modal',
          show: show,
          onHide: this.handleDismiss,
          klass: 'modal lose-progress-modal',
          modalId: 'leaveProgressModal',
          logoKlass: 'logo alert',
          headingKlass: 'modal-heading alert no-cap',
          headingText: intlHeading,
          bodyText: intlBody,
          primaryButtonText: intlPrimaryButton,
          secondaryButtonText: intlSecondaryButton,
          primaryButtonAction: this.handleProceed,
          secondaryButtonAction: this.handleCancel
        })
      );
    }
  }]);
  return Confirmation;
}(_react2.default.Component);

Confirmation.propTypes = {
  confirmation: _propTypes2.default.string,
  show: _propTypes2.default.bool,
  proceed: _propTypes2.default.func, // called when ok button is clicked.
  cancel: _propTypes2.default.func, // called when cancel button is clicked.
  dismiss: _propTypes2.default.func, // called when backdrop is clicked or escaped.
  intl: _propTypes2.default.object
};

exports.default = (0, _reactConfirm.confirmable)(Confirmation);

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAsyncRouteLeaveHook = setAsyncRouteLeaveHook;
function setAsyncRouteLeaveHook(router, route, hook) {
  var withinHook = false;
  var finalResult = void 0;
  var finalResultSet = false;

  router.setRouteLeaveHook(route, function (nextLocation) {
    withinHook = true;
    if (!finalResultSet) {
      hook(nextLocation).then(function (result) {
        finalResult = result;
        finalResultSet = true;
        if (!withinHook && nextLocation) {
          // Re-schedule the navigation
          router.push(nextLocation);
        }
      });
    }

    var result = finalResultSet ? finalResult : false;
    withinHook = false;
    finalResult = undefined;
    finalResultSet = false;
    return result;
  });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResetPasswordDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _ButtonA = __webpack_require__(244);

var _ButtonA2 = _interopRequireDefault(_ButtonA);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _InputHint = __webpack_require__(654);

var _InputHint2 = _interopRequireDefault(_InputHint);

var _JustifyCenter = __webpack_require__(265);

var _JustifyCenter2 = _interopRequireDefault(_JustifyCenter);

var _PasswordField = __webpack_require__(448);

var _PasswordField2 = _interopRequireDefault(_PasswordField);

var _TextButton = __webpack_require__(266);

var _TextButton2 = _interopRequireDefault(_TextButton);

var _ErrorMessage = __webpack_require__(715);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _AuthWrapper = __webpack_require__(264);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _resetpassword = __webpack_require__(560);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = function (_Component) {
  (0, _inherits3.default)(ResetPassword, _Component);

  function ResetPassword(props) {
    (0, _classCallCheck3.default)(this, ResetPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResetPassword.__proto__ || (0, _getPrototypeOf2.default)(ResetPassword)).call(this, props));

    _this.state = {
      password: ''
    };

    _this.handlePasswordChangeBound = _this.handlePasswordChange.bind(_this);
    _this.onResetPasswordClickBound = _this.onResetPasswordClick.bind(_this);
    _this.shouldButtonBeDisabledBound = _this.shouldButtonBeDisabled.bind(_this);
    _this.onReturnToLoginClickBound = _this.onReturnToLoginClick.bind(_this);
    _this.onTryAgainClickBound = _this.onTryAgainClick.bind(_this);
    _this.checkForSubmitBound = _this.checkForSubmit.bind(_this);
    _this.handleFormSubmitBound = _this.handleFormSubmit.bind(_this);

    window.scrollTo(0, 0);
    return _this;
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          success = _props.success,
          failure = _props.failure;

      return _react2.default.createElement(
        _AuthWrapper2.default,
        null,
        !isLoading && !failure && !success && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            _react2.default.createElement(
              _H2.default,
              { style: { marginBottom: '35px' } },
              'Create a New Password'
            )
          ),
          _react2.default.createElement(
            'form',
            { style: { textAlign: 'left' } },
            _react2.default.createElement(_PasswordField2.default, {
              label: 'New Password',
              onChange: this.handlePasswordChangeBound,
              onKeyPress: this.checkForSubmitBound,
              style: { marginBottom: '44px' },
              tooltipId: 'password'
            }),
            _react2.default.createElement(
              _InputHint2.default,
              {
                style: {
                  position: 'relative',
                  bottom: '40px',
                  left: '13px',
                  textAlign: 'left'
                }
              },
              'Minimum 8 characters'
            ),
            _react2.default.createElement(
              _JustifyCenter2.default,
              null,
              _react2.default.createElement(
                _ButtonA2.default,
                {
                  type: 'submit',
                  onClick: this.onResetPasswordClickBound,
                  disabled: this.shouldButtonBeDisabledBound(),
                  style: { marginBottom: '26px', width: 'unset' }
                },
                'Create Password'
              )
            )
          ),
          _react2.default.createElement(
            _TextButton2.default,
            {
              style: { marginTop: 'auto' },
              onClick: this.onReturnToLoginClickBound,
              fontSize: '13px'
            },
            'Return to Login'
          )
        ),
        !isLoading && !success && failure && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            _react2.default.createElement(
              _ErrorMessage2.default,
              { style: { marginBottom: '30px' } },
              'Password Change Unsuccessful'
            ),
            _react2.default.createElement(
              _P2.default,
              { style: { marginBottom: '53px' } },
              'Something went wrong. Please try changing your password again.'
            ),
            _react2.default.createElement(
              _ButtonA2.default,
              {
                style: {
                  padding: '0 21px',
                  marginBottom: '20px',
                  width: 'unset'
                },
                onClick: this.onTryAgainClickBound
              },
              'Return to Forgot Password'
            )
          ),
          _react2.default.createElement(
            _TextButton2.default,
            {
              style: { marginTop: 'auto', width: 'unset' },
              onClick: this.onReturnToLoginClickBound
            },
            'Return to Login'
          )
        ),
        !isLoading && success && !failure && _react2.default.createElement(
          _JustifyCenter2.default,
          null,
          _react2.default.createElement(
            _H2.default,
            { style: { marginBottom: '35px' } },
            'Password Changed!'
          ),
          _react2.default.createElement(
            _P2.default,
            { style: { marginBottom: '35px' } },
            'You can now use your new password to log in.'
          ),
          _react2.default.createElement(
            _ButtonA2.default,
            {
              style: { marginBottom: '29px', width: 'unset' },
              onClick: this.onReturnToLoginClickBound
            },
            'Return to Login'
          )
        ),
        isLoading && _react2.default.createElement('div', { className: 'loading', style: { minHeight: '250px' } })
      );
    }
  }, {
    key: 'checkForSubmit',
    value: function checkForSubmit(e) {
      if (!this.shouldButtonBeDisabled() && (e.which === 13 || e.keyCode === 13)) {
        this.onResetPasswordClick(e);
      }
    }
  }, {
    key: 'handlePasswordChange',
    value: function handlePasswordChange(e) {
      this.setState({ password: e.target.value.trim() });
    }
  }, {
    key: 'shouldButtonBeDisabled',
    value: function shouldButtonBeDisabled() {
      return this.state.password.length < 8;
    }
  }, {
    key: 'onResetPasswordClick',
    value: function onResetPasswordClick(e) {
      e.preventDefault();
      if (!this.shouldButtonBeDisabled()) {
        this.props.dispatch((0, _resetpassword.resetPassword)(this.props.params.token, this.state.password));
      }
    }
  }, {
    key: 'onReturnToLoginClick',
    value: function onReturnToLoginClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/login'));
    }
  }, {
    key: 'onTryAgainClick',
    value: function onTryAgainClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/forgotpassword'));
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      return false;
    }
  }]);
  return ResetPassword;
}(_react.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isLoading: state.resetpassword.isLoading,
    failure: state.resetpassword.failure,
    success: state.resetpassword.success
  };
};

ResetPassword.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.object,
  isLoading: _propTypes2.default.bool.isRequired,
  failure: _propTypes2.default.bool.isRequired,
  success: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResetPassword);
exports.ResetPasswordDisconnected = ResetPassword; // pure component - used in tests

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnlockAccountDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _JustifyCenter = __webpack_require__(265);

var _JustifyCenter2 = _interopRequireDefault(_JustifyCenter);

var _TextButton = __webpack_require__(266);

var _TextButton2 = _interopRequireDefault(_TextButton);

var _AuthWrapper = __webpack_require__(264);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _unlockaccount = __webpack_require__(561);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnlockAccount = function (_Component) {
  (0, _inherits3.default)(UnlockAccount, _Component);

  function UnlockAccount(props) {
    (0, _classCallCheck3.default)(this, UnlockAccount);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UnlockAccount.__proto__ || (0, _getPrototypeOf2.default)(UnlockAccount)).call(this, props));

    _this.onReturnToLoginClickBound = _this.onReturnToLoginClick.bind(_this);

    window.scrollTo(0, 0);
    return _this;
  }

  (0, _createClass3.default)(UnlockAccount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _unlockaccount.unlockAccount)(this.props.params.token));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          success = _props.success,
          unlockErrorStatusText = _props.unlockErrorStatusText;

      return _react2.default.createElement(
        _AuthWrapper2.default,
        null,
        _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            _JustifyCenter2.default,
            null,
            success && _react2.default.createElement(
              _H2.default,
              { style: { marginBottom: '35px' } },
              'Account Unlocked!'
            )
          ),
          _react2.default.createElement(
            'p',
            {
              style: { margin: '30px 0', fontSize: '16px', textAlign: 'center' },
              className: 'unlock-account-message'
            },
            success ? 'You can now use your username and password to login.' : unlockErrorStatusText
          ),
          _react2.default.createElement(
            _TextButton2.default,
            {
              style: { marginTop: 'auto', paddingBottom: '60px' },
              onClick: this.onReturnToLoginClickBound,
              fontSize: '13px'
            },
            'Return to Login'
          )
        )
      );
    }
  }, {
    key: 'onReturnToLoginClick',
    value: function onReturnToLoginClick() {
      this.props.dispatch((0, _reactRouterRedux.push)('/login'));
    }
  }]);
  return UnlockAccount;
}(_react.Component);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    unlockErrorStatusText: state.unlockaccount.unlockErrorStatusText,
    failure: state.unlockaccount.failure,
    success: state.unlockaccount.success
  };
};

UnlockAccount.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.object,
  unlockErrorStatusText: _propTypes2.default.string,
  failure: _propTypes2.default.bool.isRequired,
  success: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UnlockAccount);
exports.UnlockAccountDisconnected = UnlockAccount; // pure component - used in tests

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _List = __webpack_require__(1651);

var _List2 = _interopRequireDefault(_List);

var _SearchFilters = __webpack_require__(1655);

var _SearchFilters2 = _interopRequireDefault(_SearchFilters);

var _ComplexQuestsSort = __webpack_require__(1656);

var _ComplexQuestsSort2 = _interopRequireDefault(_ComplexQuestsSort);

var _reviewqueue = __webpack_require__(405);

var _reviewqueuefilters = __webpack_require__(302);

var _user = __webpack_require__(45);

var _messages = __webpack_require__(21);

var _users = __webpack_require__(217);

var _courselevels = __webpack_require__(336);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewQueueContainer = function (_Component) {
  (0, _inherits3.default)(ReviewQueueContainer, _Component);

  function ReviewQueueContainer(props) {
    (0, _classCallCheck3.default)(this, ReviewQueueContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewQueueContainer.__proto__ || (0, _getPrototypeOf2.default)(ReviewQueueContainer)).call(this, props));

    _this.loadMoreQuestsBound = _this.loadMoreQuests.bind(_this);
    _this.onChangeSortDirectionClickBound = _this.onChangeSortDirectionClick.bind(_this);
    _this.onChangeSortTypeClickBound = _this.onChangeSortTypeClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReviewQueueContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Redirect external reviewer so they don't see quests in this review queue
      if ((0, _user.isExternalReviewer)(this.props.user)) {
        this.props.dispatch((0, _reactRouterRedux.push)('/quests'));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _reviewqueue.fetchReviewQueue)(1, true));
      this.props.dispatch((0, _reviewqueue.fetchReviewQueueCounts)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.orgId !== this.props.orgId) {
        setTimeout(function () {
          _this2.props.dispatch((0, _reviewqueue.fetchReviewQueue)(1, true));
          _this2.props.dispatch((0, _reviewqueue.fetchReviewQueueCounts)());
        }, 100);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          isFetching = _props.isFetching,
          quests = _props.quests,
          sortType = _props.sortType,
          sortOrder = _props.sortOrder,
          user = _props.user;


      return _react2.default.createElement(
        'div',
        { className: 'review-queue-container' },
        _react2.default.createElement(
          'div',
          { className: 'review-queue-menu platform' },
          _react2.default.createElement(_SearchFilters2.default, (0, _extends3.default)({}, this.props, {
            onStandardsFilterClick: this.onStandardsFilterClickBound,
            onFinalFilterClick: this.onFinalFilterClickBound
          }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'review-queue-body' },
          isFetching && quests && quests.length === 0 && _react2.default.createElement('div', { className: 'loading' }),
          quests && quests.length > 0 && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'review-queue-list-header' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'ReviewQueue.QuestsIn',
                  defaultMessage: 'Quests in'
                }),
                ' ',
                _messages.oeReview
              ),
              _react2.default.createElement(_ComplexQuestsSort2.default, {
                activeProperty: sortType,
                activeDirection: sortOrder,
                handleChangeSortDirectionClick: this.onChangeSortDirectionClickBound,
                handleChangeSortTypeClick: this.onChangeSortTypeClickBound,
                options: [{
                  label: 'Priority',
                  value: 'quest_priority'
                }, {
                  label: 'Wait Time',
                  value: 'created_at'
                }]
              })
            ),
            _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
              items: _react2.default.createElement(_List2.default, {
                quests: quests,
                user: user,
                dispatch: dispatch
              }),
              loadMore: this.loadMoreQuestsBound,
              loadingMore: isFetching,
              elementIsScrollable: false,
              showLoader: false
            })
          ),
          !isFetching && (!quests || quests.length === 0) && _react2.default.createElement(
            'div',
            { className: 'empty-queue-wrapper' },
            _react2.default.createElement('div', { className: 'icon' }),
            _react2.default.createElement(
              'label',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ReviewQueue.NoQuestsToReview',
                defaultMessage: 'No quests to review right now.'
              })
            )
          )
        )
      );
    }
  }, {
    key: 'loadMoreQuests',
    value: function loadMoreQuests() {
      // Only load more quests if the size of the quest list is less than the totalquest count from the search call
      if (this.props.quests.length < this.props.questsTotal) {
        this.props.dispatch((0, _reviewqueue.fetchReviewQueue)(this.props.page + 1, false));
      }
    }
  }, {
    key: 'onChangeSortDirectionClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props2, dispatch, sortOrder, newSortOrder;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, dispatch = _props2.dispatch, sortOrder = _props2.sortOrder;
                // send the opposite of whatever is currently in state

                newSortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
                _context.next = 4;
                return dispatch((0, _reviewqueuefilters.setReviewQueueSortOrder)(newSortOrder));

              case 4:
                dispatch((0, _reviewqueue.fetchReviewQueue)(1, true));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onChangeSortDirectionClick() {
        return _ref.apply(this, arguments);
      }

      return onChangeSortDirectionClick;
    }()
  }, {
    key: 'onChangeSortTypeClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(value) {
        var dispatch;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch = this.props.dispatch;
                _context2.next = 3;
                return dispatch((0, _reviewqueuefilters.setReviewQueueSortType)(value));

              case 3:
                dispatch((0, _reviewqueue.fetchReviewQueue)(1, true));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onChangeSortTypeClick(_x) {
        return _ref2.apply(this, arguments);
      }

      return onChangeSortTypeClick;
    }()
  }]);
  return ReviewQueueContainer;
}(_react.Component);

ReviewQueueContainer.propTypes = {
  isFetching: _propTypes2.default.bool.isRequired,
  quests: _propTypes2.default.array,
  sortType: _propTypes2.default.string.isRequired,
  sortOrder: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  orgId: _propTypes2.default.number,
  authorsFilter: _propTypes2.default.array,
  keywordFilter: _propTypes2.default.string,
  qdUsers: _propTypes2.default.array,
  levelFilters: _propTypes2.default.array,
  needStandardsReview: _propTypes2.default.bool.isRequired,
  needFinalReview: _propTypes2.default.bool.isRequired,
  needStandardsCount: _propTypes2.default.number,
  needFinalCount: _propTypes2.default.number,
  totalCount: _propTypes2.default.number,
  questsTotal: _propTypes2.default.number,
  page: _propTypes2.default.number,
  courses: _propTypes2.default.array,
  courseFilter: _propTypes2.default.object,
  gradeLevels: _propTypes2.default.array.isRequired,
  gradeFilters: _propTypes2.default.array.isRequired,
  isFetchingGrades: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.reviewqueue.isFetching,
    quests: state.reviewqueue.items,
    user: state.user.user,
    orgId: state.organization.orgId,
    authorsFilter: state.reviewqueuefilters.authors_id_in,
    keywordFilter: state.reviewqueuefilters.name_or_description_cont,
    qdUsers: (0, _users.getqdUsers)(state),
    sortType: state.reviewqueuefilters.sort_type,
    sortOrder: state.reviewqueuefilters.sort_order,
    needStandardsReview: state.reviewqueuefilters.need_standards_review,
    needFinalReview: state.reviewqueuefilters.need_final_review,
    needStandardsCount: state.reviewqueue.needStandardsCount,
    needFinalCount: state.reviewqueue.needFinalCount,
    totalCount: state.reviewqueue.totalCount,
    questsTotal: state.reviewqueue.total,
    page: state.reviewqueue.page,
    courses: state.mockcourses.items,
    courseFilter: state.reviewqueuefilters.mock_course_id_in,
    levelFilters: state.reviewqueuefilters.mock_level_id_in || [],
    levels: (0, _courselevels.courseLevels)(state, state.reviewqueuefilters.mock_course_id_in),
    gradeLevels: state.gradelevels.items,
    gradeFilters: state.reviewqueuefilters.grade_levels_id_in,
    isFetchingGrades: state.gradelevels.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReviewQueueContainer);

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1652);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewQueueList = function (_Component) {
  (0, _inherits3.default)(ReviewQueueList, _Component);

  function ReviewQueueList() {
    (0, _classCallCheck3.default)(this, ReviewQueueList);
    return (0, _possibleConstructorReturn3.default)(this, (ReviewQueueList.__proto__ || (0, _getPrototypeOf2.default)(ReviewQueueList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReviewQueueList, [{
    key: 'render',
    value: function render() {
      var quests = this.props.quests.map(function (quest, index) {
        return _react2.default.createElement(_Item2.default, {
          quest: quest,
          key: index,
          user: this.props.user,
          dispatch: this.props.dispatch
        });
      }, this);

      return _react2.default.createElement(
        'div',
        { className: 'review-queue-list' },
        _react2.default.createElement(
          'ul',
          null,
          quests
        )
      );
    }
  }]);
  return ReviewQueueList;
}(_react.Component);

ReviewQueueList.propTypes = {
  quests: _propTypes2.default.array,
  user: _propTypes2.default.object,
  dispatch: _propTypes2.default.func
};

exports.default = ReviewQueueList;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: 10px;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 10px;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestListItem = __webpack_require__(451);

var _QuestListItem2 = _interopRequireDefault(_QuestListItem);

var _InProgress = __webpack_require__(1653);

var _InProgress2 = _interopRequireDefault(_InProgress);

var _PriorityIndicator = __webpack_require__(454);

var _PriorityIndicator2 = _interopRequireDefault(_PriorityIndicator);

var _quest = __webpack_require__(66);

var _logging = __webpack_require__(137);

var _time = __webpack_require__(161);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriorityIndicatorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Item__PriorityIndicatorContainer',
  componentId: 'sc-1q3ax9k-0'
})(_templateObject);

var ReviewQueueItem = function (_Component) {
  (0, _inherits3.default)(ReviewQueueItem, _Component);

  function ReviewQueueItem(props) {
    (0, _classCallCheck3.default)(this, ReviewQueueItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewQueueItem.__proto__ || (0, _getPrototypeOf2.default)(ReviewQueueItem)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    _this.highlightQuestNameBound = _this.highlightQuestName.bind(_this);
    _this.unhighlightQuestNameBound = _this.unhighlightQuestName.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReviewQueueItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          user = _props.user,
          dispatch = _props.dispatch;

      var userHasPreviouslyReviewed = quest.reviewer_ids.indexOf(user.id) > -1;
      var isOeReviewer = user.organization_roles.indexOf('qm_platform_review') > -1;
      var cssExperience = this.getSubreviewCssClasses('experience');
      var cssSubject = this.getSubreviewCssClasses('subject');
      var cssCopy = this.getSubreviewCssClasses('copy');
      var cssStandards = this.getSubreviewCssClasses('standards');
      var cssFinal = this.getSubreviewCssClasses('final');

      // ul tag below is a hack because QuestListItem component is an li
      return _react2.default.createElement(
        'li',
        { id: 'review-item-' + quest.id },
        this.containsOpenSubreviewByAnotherUser() && _react2.default.createElement('div', {
          className: 'locked-overlay',
          onClick: this.onClickBound,
          onMouseOver: this.highlightQuestNameBound,
          onMouseOut: this.unhighlightQuestNameBound
        }),
        userHasPreviouslyReviewed && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('div', {
            className: 'previously-reviewed',
            'data-id': quest.id,
            onMouseOver: this.onPreviouslyReviewedMouseOver,
            onMouseOut: this.onPreviouslyReviewedMouseOut
          }),
          _react2.default.createElement(
            'div',
            { className: 'previously-reviewed-info', id: quest.id },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'ReviewQueue.Flagged',
              defaultMessage: 'We flagged this quest because you reviewed it in the past.'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'quest-info' },
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(_QuestListItem2.default, {
              quest: this.props.quest,
              clickHandler: this.onClickBound,
              isCompiledQuest: true,
              dispatch: dispatch,
              user: user,
              iconHeightWidth: 36
            })
          )
        ),
        !isOeReviewer && _react2.default.createElement(
          'div',
          {
            className: cssExperience,
            onClick: this.onClickBound,
            'data-object': 'experience'
          },
          cssExperience.indexOf('in-progress') === -1 && _react2.default.createElement(
            'label',
            null,
            _messages.experience
          ),
          cssExperience.indexOf('in-progress') > -1 && _react2.default.createElement(_InProgress2.default, { review: this.getReviewOfType('experience') })
        ),
        !isOeReviewer && _react2.default.createElement(
          'div',
          {
            className: cssSubject,
            onClick: this.onClickBound,
            'data-object': 'subject'
          },
          cssSubject.indexOf('in-progress') === -1 && _react2.default.createElement(
            'label',
            null,
            _messages.subject
          ),
          cssSubject.indexOf('in-progress') > -1 && _react2.default.createElement(_InProgress2.default, { review: this.getReviewOfType('subject') })
        ),
        !isOeReviewer && _react2.default.createElement(
          'div',
          {
            className: cssCopy,
            onClick: this.onClickBound,
            'data-object': 'copy'
          },
          cssCopy.indexOf('in-progress') === -1 && _react2.default.createElement(
            'label',
            null,
            _messages.copy
          ),
          cssCopy.indexOf('in-progress') > -1 && _react2.default.createElement(_InProgress2.default, { review: this.getReviewOfType('copy') })
        ),
        isOeReviewer && _react2.default.createElement(
          'div',
          {
            className: cssStandards,
            onClick: this.onClickBound,
            'data-object': 'standards'
          },
          cssStandards.indexOf('in-progress') === -1 && _react2.default.createElement(
            'label',
            null,
            _messages.standards
          ),
          cssStandards.indexOf('in-progress') > -1 && _react2.default.createElement(_InProgress2.default, { review: this.getReviewOfType('standards') })
        ),
        isOeReviewer && _react2.default.createElement(
          'div',
          {
            className: cssFinal,
            onClick: this.onClickBound,
            'data-object': 'final'
          },
          cssFinal.indexOf('in-progress') === -1 && _react2.default.createElement(
            'label',
            null,
            _messages.final
          ),
          cssFinal.indexOf('in-progress') > -1 && _react2.default.createElement(_InProgress2.default, { review: this.getReviewOfType('final') })
        ),
        _react2.default.createElement(
          'div',
          { className: 'review-info' },
          quest.priority !== 'normal' && _react2.default.createElement(
            PriorityIndicatorContainer,
            null,
            _react2.default.createElement(_PriorityIndicator2.default, {
              priority: quest.priority,
              questId: quest.id,
              small: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'round' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Round', defaultMessage: 'Round' }),
            ' ',
            quest.build
          ),
          _react2.default.createElement(
            'div',
            { className: 'waiting' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Waiting', defaultMessage: 'Waiting' }),
            ' ',
            _react2.default.createElement('br', null),
            (0, _time.getDateDisplay)(quest.state_updated_at)
          )
        )
      );
    }
  }, {
    key: 'containsOpenSubreviewByAnotherUser',
    value: function containsOpenSubreviewByAnotherUser() {
      var retval = false;

      this.props.quest.reviews.forEach(function (review) {
        if (review.created_at && !review.completed_at) {
          retval = true;
        }
      });

      return retval;
    }
  }, {
    key: 'getSubreviewCssClasses',
    value: function getSubreviewCssClasses(subreviewType) {
      var existingReview = this.getReviewOfType(subreviewType);
      var cssClasses = subreviewType;

      if (existingReview && existingReview.completed_at) {
        cssClasses += ' completed';
      } else if (existingReview && !existingReview.completed_at) {
        cssClasses += ' in-progress';
      } else {
        cssClasses += ' not-started';
      }

      return cssClasses;
    }
  }, {
    key: 'getReviewOfType',
    value: function getReviewOfType(type) {
      return this.props.quest.reviews.find(function (review) {
        return review.criteria === type;
      });
    }
  }, {
    key: 'highlightQuestName',
    value: function highlightQuestName() {
      document.querySelector('#review-item-' + this.props.quest.id).querySelector('.name').classList.add('active');
    }
  }, {
    key: 'unhighlightQuestName',
    value: function unhighlightQuestName() {
      document.querySelector('#review-item-' + this.props.quest.id).querySelector('.name').classList.remove('active');
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      e.preventDefault();
      var isOeReviewer = this.props.user.organization_roles.indexOf('qm_platform_review') > -1;

      this.props.dispatch((0, _quest.setQuestSection)('questreview', null, e.currentTarget.dataset.object));
      this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.quest_id + '/questreview'));

      var clickTarget = e.currentTarget.dataset.object ? e.currentTarget.dataset.object : (isOeReviewer ? 'oe' : 'internal') + 'queue_quest_name';

      this.props.dispatch((0, _logging.postLoggingInfo)('review_queue', {
        action: 'click',
        click_target: clickTarget
      }));
    }
  }, {
    key: 'onPreviouslyReviewedMouseOver',
    value: function onPreviouslyReviewedMouseOver(e) {
      document.getElementById(e.currentTarget.dataset.id).classList.add('active');
    }
  }, {
    key: 'onPreviouslyReviewedMouseOut',
    value: function onPreviouslyReviewedMouseOut(e) {
      document.getElementById(e.currentTarget.dataset.id).classList.remove('active');
    }
  }]);
  return ReviewQueueItem;
}(_react.Component);

exports.default = ReviewQueueItem;


ReviewQueueItem.propTypes = {
  quest: _propTypes2.default.object,
  user: _propTypes2.default.object,
  dispatch: _propTypes2.default.func
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TypingIndicator = __webpack_require__(1654);

var _TypingIndicator2 = _interopRequireDefault(_TypingIndicator);

var _oeWebCommon = __webpack_require__(117);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InProgress = function (_Component) {
  (0, _inherits3.default)(InProgress, _Component);

  function InProgress() {
    (0, _classCallCheck3.default)(this, InProgress);
    return (0, _possibleConstructorReturn3.default)(this, (InProgress.__proto__ || (0, _getPrototypeOf2.default)(InProgress)).apply(this, arguments));
  }

  (0, _createClass3.default)(InProgress, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'in-progress-container' },
        _react2.default.createElement('img', { src: this.props.review.reviewer.photo_url }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_TypingIndicator2.default, null),
        _react2.default.createElement(
          'h5',
          null,
          _messages.inProgress
        ),
        _react2.default.createElement(
          'div',
          { className: 'since' },
          'Since ',
          _react2.default.createElement(_oeWebCommon.OEComponents.DateFormatter, {
            date: this.props.review.created_at,
            includeTime: false,
            abbreviateMonth: true
          }),
          ' at ',
          _react2.default.createElement(_oeWebCommon.OEComponents.Time, { time: this.props.review.created_at })
        )
      );
    }
  }]);
  return InProgress;
}(_react.Component);

InProgress.propTypes = {
  dispatch: _propTypes2.default.func,
  users: _propTypes2.default.array,
  review: _propTypes2.default.object
};

exports.default = InProgress;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypingIndicator = function (_Component) {
  (0, _inherits3.default)(TypingIndicator, _Component);

  function TypingIndicator() {
    (0, _classCallCheck3.default)(this, TypingIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (TypingIndicator.__proto__ || (0, _getPrototypeOf2.default)(TypingIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(TypingIndicator, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "typing-indicator" },
        _react2.default.createElement("span", null),
        _react2.default.createElement("span", null),
        _react2.default.createElement("span", null)
      );
    }
  }]);
  return TypingIndicator;
}(_react.Component);

exports.default = TypingIndicator;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _KeywordSearch = __webpack_require__(455);

var _KeywordSearch2 = _interopRequireDefault(_KeywordSearch);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _WrappedSearchFilter = __webpack_require__(335);

var _WrappedSearchFilter2 = _interopRequireDefault(_WrappedSearchFilter);

var _CourseSelect = __webpack_require__(268);

var _CourseSelect2 = _interopRequireDefault(_CourseSelect);

var _label = __webpack_require__(148);

var _placeholder = __webpack_require__(150);

var _reviewqueuefilters = __webpack_require__(302);

var _reviewqueue = __webpack_require__(405);

var _levels = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFilters = function (_Component) {
  (0, _inherits3.default)(SearchFilters, _Component);

  function SearchFilters(props) {
    (0, _classCallCheck3.default)(this, SearchFilters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchFilters.__proto__ || (0, _getPrototypeOf2.default)(SearchFilters)).call(this, props));

    _this.state = {
      keywordSearched: false
    };
    _this.onSearchClickBound = _this.onSearchClick.bind(_this);
    _this.onKeywordKeyPressBound = _this.onKeywordKeyPress.bind(_this);
    _this.onKeywordFilterChangeBound = _this.onKeywordFilterChange.bind(_this);
    _this.onKeywordSearchClickBound = _this.onKeywordSearchClick.bind(_this);
    _this.onClearKeywordSearchClickBound = _this.onClearKeywordSearchClick.bind(_this);
    _this.onStandardsFilterClickBound = _this.onStandardsFilterClick.bind(_this);
    _this.onFinalFilterClickBound = _this.onFinalFilterClick.bind(_this);
    _this.onAllReviewsClickBound = _this.onAllReviewsClick.bind(_this);
    _this.onSetCourseFilterBound = _this.onSetCourseFilter.bind(_this);
    _this.setLevelFilterBound = _this.setLevelFilter.bind(_this);
    _this.keywordSearchInput = _react2.default.createRef();
    _this.courseFilterRef = _react2.default.createRef();
    _this.levelFilterRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(SearchFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          qdUsers = _props.qdUsers,
          dispatch = _props.dispatch,
          intl = _props.intl,
          keywordFilter = _props.keywordFilter,
          needFinalCount = _props.needFinalCount,
          needStandardsCount = _props.needStandardsCount,
          totalCount = _props.totalCount,
          needStandardsReview = _props.needStandardsReview,
          needFinalReview = _props.needFinalReview,
          authorsFilter = _props.authorsFilter,
          courseFilter = _props.courseFilter,
          courses = _props.courses,
          levels = _props.levels,
          gradeLevels = _props.gradeLevels,
          gradeFilters = _props.gradeFilters,
          isFetchingGrades = _props.isFetchingGrades;

      var intlMessages = {
        authorLabel: intl.formatMessage(_label.messages.author),
        authorPlaceholder: intl.formatMessage(_placeholder.messages.selectAuthors),
        titlePlaceholder: intl.formatMessage(_placeholder.messages.enterTitle),
        targetGradeLevel: intl.formatMessage(_label.messages.targetGradeLevel),
        selectGrades: intl.formatMessage(_placeholder.messages.selectGrades)
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'search-filters quests-search',
          style: { paddingTop: '30px' }
        },
        _react2.default.createElement(_KeywordSearch2.default, {
          keywordFilter: keywordFilter,
          keywordSearchRef: this.keywordSearchInput,
          onKeywordKeyPress: this.onKeywordKeyPressBound,
          onKeywordFilterChange: this.onKeywordFilterChangeBound,
          keywordSearched: this.state.keywordSearched,
          onClearKeywordSearchClick: this.onClearKeywordSearchClickBound,
          onKeywordSearchClick: this.onKeywordSearchClickBound
        }),
        _react2.default.createElement(
          'div',
          { className: 'caption1', style: { marginBottom: '24px' } },
          'Filter by'
        ),
        _react2.default.createElement(
          'div',
          { className: 'radio-wrapper' },
          _react2.default.createElement('input', {
            type: 'radio',
            id: 'all-reviews',
            checked: !needStandardsReview && !needFinalReview,
            onClick: this.onAllReviewsClickBound
          }),
          _react2.default.createElement(
            'label',
            {
              htmlFor: 'all-reviews',
              className: 'h5 ' + (!needStandardsReview && !needFinalReview ? 'active' : '')
            },
            'All Reviews (' + totalCount + ')'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'radio-wrapper' },
          _react2.default.createElement('input', {
            type: 'radio',
            id: 'need-standards-review',
            checked: needStandardsReview && !needFinalReview,
            onClick: this.onStandardsFilterClickBound
          }),
          _react2.default.createElement(
            'label',
            {
              htmlFor: 'need-standards-review',
              className: 'h5 ' + (needStandardsReview && !needFinalReview ? 'active' : '')
            },
            'Need Standards Review (' + needStandardsCount + ')'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'radio-wrapper' },
          _react2.default.createElement('input', {
            type: 'radio',
            id: 'need-final-review',
            checked: !needStandardsReview && needFinalReview,
            onClick: this.onFinalFilterClickBound
          }),
          _react2.default.createElement(
            'label',
            {
              htmlFor: 'need-final-review',
              className: 'h5 ' + (!needStandardsReview && needFinalReview ? 'active' : '')
            },
            'Need Final Review (' + needFinalCount + ')'
          )
        ),
        _react2.default.createElement('div', { className: 'horizontal-divider' }),
        _react2.default.createElement(
          'div',
          { className: 'area inputs-wrapper' },
          _react2.default.createElement(_SearchArea2.default, {
            dispatch: dispatch,
            label: intlMessages.authorLabel,
            area: 'author',
            placeholder: intlMessages.authorPlaceholder,
            options: (0, _arraySort2.default)(this.mapList(qdUsers), ['sort']),
            values: authorsFilter,
            headerClass: 'h5',
            filterAction: _reviewqueuefilters.setAuthorsFilter,
            fetchAction: _reviewqueue.fetchReviewQueue
          }),
          _react2.default.createElement(_SearchArea2.default, {
            headerClass: 'h5',
            dispatch: dispatch,
            label: intlMessages.targetGradeLevel,
            area: 'grades',
            placeholder: intlMessages.selectGrades,
            values: gradeFilters,
            options: (0, _arraySort2.default)(this.mapList(gradeLevels), ['sort']),
            filterAction: _reviewqueuefilters.setTargetGradeLevelFilter,
            loading: isFetchingGrades,
            fetchAction: _reviewqueue.fetchReviewQueue
          }),
          courses.length > 0 && _react2.default.createElement(
            _WrappedSearchFilter2.default,
            {
              area: 'courses',
              active: Boolean(courseFilter),
              label: 'Intended Journey',
              wrappedRef: this.courseFilterRef
            },
            _react2.default.createElement(_CourseSelect2.default, {
              courseFilterRef: this.courseFilterRef,
              course: courseFilter ? courseFilter : null,
              courses: courses,
              onCourseChange: this.onSetCourseFilterBound,
              labelTruncationLength: 99999,
              placeholder: 'Select journey'
            })
          ),
          courseFilter && _react2.default.createElement(
            _WrappedSearchFilter2.default,
            {
              area: 'levels',
              active: this.props.levelFilters.length > 0,
              disabled: levels.length === 0,
              disabledText: 'No levels are available for this journey.',
              label: 'Intended Level',
              wrappedRef: this.levelFilterRef
            },
            _react2.default.createElement(_reactSelect2.default, {
              multi: true,
              ref: this.levelFilterRef,
              searchable: true,
              options: (0, _levels.mapLevels)(levels, 22),
              value: this.props.levelFilters,
              onChange: this.setLevelFilterBound,
              placeholder: 'Select level',
              matchProp: 'label'
            })
          )
        )
      );
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.sort ? el.sort : el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'onKeywordFilterChange',
    value: function onKeywordFilterChange(e) {
      this.props.dispatch((0, _reviewqueuefilters.setKeywordFilter)(e.currentTarget.value));
    }
  }, {
    key: 'onKeywordSearchClick',
    value: function onKeywordSearchClick() {
      this.setState(function () {
        return {
          keywordSearched: true
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onKeywordKeyPress',
    value: function onKeywordKeyPress(e) {
      if (this.props.keywordFilter.length > 0 && (e.which === 13 || e.charCode === 13)) {
        this.onKeywordSearchClickBound();
        this.keywordSearchInput.current.blur();
      }
    }
  }, {
    key: 'onClearKeywordSearchClick',
    value: function onClearKeywordSearchClick() {
      this.props.dispatch((0, _reviewqueuefilters.setKeywordFilter)(''));
      this.setState(function () {
        return {
          keywordSearched: false
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onSearchClick',
    value: function onSearchClick() {
      this.props.dispatch((0, _reviewqueue.fetchReviewQueue)(1, true));
    }
  }, {
    key: 'onStandardsFilterClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _reviewqueuefilters.setNeedStandardsFilter)());

              case 2:
                this.onSearchClick();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onStandardsFilterClick() {
        return _ref.apply(this, arguments);
      }

      return onStandardsFilterClick;
    }()
  }, {
    key: 'onFinalFilterClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.dispatch((0, _reviewqueuefilters.setNeedFinalFilter)());

              case 2:
                this.onSearchClick();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onFinalFilterClick() {
        return _ref2.apply(this, arguments);
      }

      return onFinalFilterClick;
    }()
  }, {
    key: 'onAllReviewsClick',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.dispatch((0, _reviewqueuefilters.setAllReviewsFilter)());

              case 2:
                this.onSearchClick();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onAllReviewsClick() {
        return _ref3.apply(this, arguments);
      }

      return onAllReviewsClick;
    }()
  }, {
    key: 'onSetCourseFilter',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(e) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.dispatch((0, _reviewqueuefilters.setCourseFilter)(e ? e : null));

              case 2:
                this.onSearchClickBound();

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onSetCourseFilter(_x) {
        return _ref4.apply(this, arguments);
      }

      return onSetCourseFilter;
    }()
  }, {
    key: 'setLevelFilter',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(event) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.props.dispatch((0, _reviewqueuefilters.setLevelFilter)(event.map(function (e) {
                  return e.value;
                })));
                this.props.dispatch(this.onSearchClickBound);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setLevelFilter(_x2) {
        return _ref5.apply(this, arguments);
      }

      return setLevelFilter;
    }()
  }]);
  return SearchFilters;
}(_react.Component);

SearchFilters.propTypes = {
  qdUsers: _propTypes2.default.array,
  dispatch: _propTypes2.default.func,
  intl: _propTypes2.default.object,
  keywordFilter: _propTypes2.default.string,
  authorsFilter: _propTypes2.default.array,
  needStandardsCount: _propTypes2.default.number,
  needFinalCount: _propTypes2.default.number,
  totalCount: _propTypes2.default.number,
  needStandardsReview: _propTypes2.default.bool.isRequired,
  needFinalReview: _propTypes2.default.bool.isRequired,
  quests: _propTypes2.default.array,
  courses: _propTypes2.default.array,
  courseFilter: _propTypes2.default.object,
  levelFilters: _propTypes2.default.array,
  levels: _propTypes2.default.array,
  gradeFilters: _propTypes2.default.array.isRequired,
  gradeLevels: _propTypes2.default.array.isRequired,
  isFetchingGrades: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(SearchFilters);

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 14px;\n\n  * {\n    transition: 0.3s all;\n  }\n'], ['\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 14px;\n\n  * {\n    transition: 0.3s all;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  text-transform: uppercase;\n  cursor: pointer;\n  display: flex;\n\n  &:hover {\n    cursor: pointer;\n    color: black;\n  }\n'], ['\n  text-transform: uppercase;\n  cursor: pointer;\n  display: flex;\n\n  &:hover {\n    cursor: pointer;\n    color: black;\n  }\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 17px;\n  width: 18px;\n  transform: ', ';\n\n  &:hover {\n    background: url(', ') no-repeat;\n    cursor: pointer;\n  }\n'], ['\n  background: url(', ') no-repeat;\n  height: 17px;\n  width: 18px;\n  transform: ', ';\n\n  &:hover {\n    background: url(', ') no-repeat;\n    cursor: pointer;\n  }\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  display: ', ';\n  flex-direction: column;\n  justify-content: space-around;\n  box-sizing: border-box;\n  padding: 10px 19px;\n  position: absolute;\n  height: 77px;\n  width: 153px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  z-index: 21;\n  top: 24px;\n  left: -7px;\n'], ['\n  display: ', ';\n  flex-direction: column;\n  justify-content: space-around;\n  box-sizing: border-box;\n  padding: 10px 19px;\n  position: absolute;\n  height: 77px;\n  width: 153px;\n  border-radius: 3px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  z-index: 21;\n  top: 24px;\n  left: -7px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  cursor: ', ';\n  color: ', ';\n'], ['\n  cursor: ', ';\n  color: ', ';\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  height: 5px;\n  width: 9px;\n  margin: 5px 24px 0 8px;\n'], ['\n  background: url(', ') no-repeat;\n  height: 5px;\n  width: 9px;\n  margin: 5px 24px 0 8px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Caption = __webpack_require__(716);

var _Caption2 = _interopRequireDefault(_Caption);

var _Input = __webpack_require__(311);

var _Input2 = _interopRequireDefault(_Input);

var _icon_arrow_sort_ascending = __webpack_require__(1657);

var _icon_arrow_sort_ascending2 = _interopRequireDefault(_icon_arrow_sort_ascending);

var _icon_arrow_sort_ascending_hover = __webpack_require__(1658);

var _icon_arrow_sort_ascending_hover2 = _interopRequireDefault(_icon_arrow_sort_ascending_hover);

var _dropdown_triangle = __webpack_require__(1659);

var _dropdown_triangle2 = _interopRequireDefault(_dropdown_triangle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComplexQuestsSortContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ComplexQuestsSort__ComplexQuestsSortContainer',
  componentId: 'sc-129w8ds-0'
})(_templateObject);

var InnerContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ComplexQuestsSort__InnerContainer',
  componentId: 'sc-129w8ds-1'
})(_templateObject2);

var ActiveSortText = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'ComplexQuestsSort__ActiveSortText',
  componentId: 'sc-129w8ds-2'
})(_templateObject3);

var ActiveSortArrow = _styledComponents2.default.div.withConfig({
  displayName: 'ComplexQuestsSort__ActiveSortArrow',
  componentId: 'sc-129w8ds-3'
})(_templateObject4, _icon_arrow_sort_ascending2.default, function (props) {
  return props.activeDirection === 'desc' ? 'rotate(180deg)' : 'none';
}, _icon_arrow_sort_ascending_hover2.default);

var SortOptionsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ComplexQuestsSort__SortOptionsContainer',
  componentId: 'sc-129w8ds-4'
})(_templateObject5, function (props) {
  return props.visible ? 'flex' : 'none';
});

var SortOption = (0, _styledComponents2.default)(_Input2.default).withConfig({
  displayName: 'ComplexQuestsSort__SortOption',
  componentId: 'sc-129w8ds-5'
})(_templateObject6, function (props) {
  return props.visible ? 'pointer' : 'default';
}, function (props) {
  return props.active ? '#000000' : '#808080';
});

var DropdownTriangle = _styledComponents2.default.div.withConfig({
  displayName: 'ComplexQuestsSort__DropdownTriangle',
  componentId: 'sc-129w8ds-6'
})(_templateObject7, _dropdown_triangle2.default);

var ComplexQuestsSort = function (_React$Component) {
  (0, _inherits3.default)(ComplexQuestsSort, _React$Component);

  function ComplexQuestsSort() {
    (0, _classCallCheck3.default)(this, ComplexQuestsSort);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComplexQuestsSort.__proto__ || (0, _getPrototypeOf2.default)(ComplexQuestsSort)).call(this));

    _this.state = {
      optionsVisible: false
    };

    _this.optionsRef = _react2.default.createRef();
    _this.onShowOptionsBound = _this.onShowOptions.bind(_this);
    _this.onHideOptionsBound = _this.onHideOptions.bind(_this);
    _this.onActiveSortTextClickBound = _this.onActiveSortTextClick.bind(_this);
    _this.onSortTypeClickBound = _this.onSortTypeClick.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ComplexQuestsSort, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        ComplexQuestsSortContainer,
        null,
        _react2.default.createElement(
          InnerContainer,
          null,
          _react2.default.createElement(
            ActiveSortText,
            { onClick: this.onActiveSortTextClickBound },
            this.getActivePropertyText(),
            _react2.default.createElement(DropdownTriangle, null)
          ),
          _react2.default.createElement(
            SortOptionsContainer,
            {
              innerRef: this.optionsRef,
              visible: this.state.optionsVisible
            },
            this.props.options.map(function (o) {
              return _react2.default.createElement(
                SortOption,
                {
                  visible: _this2.state.optionsVisible,
                  key: o.value,
                  active: _this2.props.activeProperty === o.value,
                  onClick: _this2.onSortTypeClickBound,
                  'data-value': o.value
                },
                o.label
              );
            })
          ),
          _react2.default.createElement(ActiveSortArrow, {
            activeDirection: this.props.activeDirection,
            onClick: function onClick() {
              return _this2.props.handleChangeSortDirectionClick();
            }
          })
        )
      );
    }
  }, {
    key: 'onShowOptions',
    value: function onShowOptions() {
      this.setState(function () {
        return {
          optionsVisible: true
        };
      });
    }
  }, {
    key: 'onHideOptions',
    value: function onHideOptions() {
      this.setState(function () {
        return {
          optionsVisible: false
        };
      });
    }
  }, {
    key: 'getActivePropertyText',
    value: function getActivePropertyText() {
      var _this3 = this;

      return this.props.options.find(function (o) {
        return o.value === _this3.props.activeProperty;
      }).label;
    }
  }, {
    key: 'onActiveSortTextClick',
    value: function onActiveSortTextClick() {
      this.setState(function (state) {
        return {
          optionsVisible: !state.optionsVisible
        };
      });
    }
  }, {
    key: 'onSortTypeClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.handleChangeSortTypeClick(event.target.dataset.value);

              case 2:
                this.setState(function () {
                  return {
                    optionsVisible: false
                  };
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSortTypeClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onSortTypeClick;
    }()
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      if (this.state.optionsVisible && this.optionsRef && this.optionsRef.current && !this.optionsRef.current.contains(event.target)) {
        this.setState(function () {
          return {
            optionsVisible: false
          };
        });
      }
    }
  }]);
  return ComplexQuestsSort;
}(_react2.default.Component);

ComplexQuestsSort.propTypes = {
  activeProperty: _propTypes2.default.string.isRequired,
  options: _propTypes2.default.array.isRequired,
  activeDirection: _propTypes2.default.string.isRequired,
  handleChangeSortDirectionClick: _propTypes2.default.func.isRequired,
  handleChangeSortTypeClick: _propTypes2.default.func.isRequired
};

exports.default = ComplexQuestsSort;

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyAKIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogd2lkdGg9IjE0cHgiIGhlaWdodD0iMTVweCI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgIGZpbGw9InJnYigyNDcsIDE5MCwgNykiCiBkPSJNMC4yNzksOC4xNjEgTDAuMjc5LDguMTYxIEMwLjYzOCw4LjUyNiAxLjIxOSw4LjUyNiAxLjU3OCw4LjE2MiBMNi4wNzgsMy41OTEgTDYuMDc4LDE0LjA2NSBDNi4wNzgsMTQuNTgxIDYuNDg5LDE1LjAwMCA2Ljk5NiwxNS4wMDAgTDcuMDAxLDE1LjAwMCBDNy41MDgsMTUuMDAwIDcuOTIwLDE0LjU4MSA3LjkyMCwxNC4wNjUgTDcuOTIwLDMuNTkxIEwxMi40MTEsOC4xNjkgQzEyLjc2OSw4LjUzNSAxMy4zNTIsOC41MzUgMTMuNzExLDguMTY5IEwxMy43MTgsOC4xNjEgQzE0LjA3Nyw3Ljc5NiAxNC4wNzcsNy4yMDQgMTMuNzE4LDYuODM5IEw2Ljk5OCwtMC4wMDAgTDAuMjc5LDYuODM5IEMtMC4wODAsNy4yMDQgLTAuMDgwLDcuNzk2IDAuMjc5LDguMTYxIFoiLz4KPC9zdmc+"

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyAKIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogd2lkdGg9IjE0cHgiIGhlaWdodD0iMTVweCI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgIGZpbGw9InJnYig2OCwgNjgsIDY4KSIKIGQ9Ik0wLjI3OSw4LjE2MSBMMC4yNzksOC4xNjEgQzAuNjM4LDguNTI2IDEuMjE5LDguNTI2IDEuNTc4LDguMTYyIEw2LjA3OCwzLjU5MSBMNi4wNzgsMTQuMDY1IEM2LjA3OCwxNC41ODEgNi40ODksMTUuMDAwIDYuOTk2LDE1LjAwMCBMNy4wMDEsMTUuMDAwIEM3LjUwOCwxNS4wMDAgNy45MjAsMTQuNTgxIDcuOTIwLDE0LjA2NSBMNy45MjAsMy41OTEgTDEyLjQxMSw4LjE2OSBDMTIuNzY5LDguNTM1IDEzLjM1Miw4LjUzNSAxMy43MTEsOC4xNjkgTDEzLjcxOCw4LjE2MSBDMTQuMDc3LDcuNzk2IDE0LjA3Nyw3LjIwNCAxMy43MTgsNi44MzkgTDYuOTk4LC0wLjAwMCBMMC4yNzksNi44MzkgQy0wLjA4MCw3LjIwNCAtMC4wODAsNy43OTYgMC4yNzksOC4xNjEgWiIvPgo8L3N2Zz4="

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOXB4IiBoZWlnaHQ9IjVweCIgdmlld0JveD0iMCAwIDkgNSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBza2V0Y2h0b29sIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5BREM3RUNBQS05NzE1LTRCNzAtOEEzNy1BNEExNEExRjBGNjM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IjAyIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMy4wLVFSLVF1ZXVlLS0tUHJpb3JpdHktSW5kaWNhdG9yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI3NS4wMDAwMDAsIC03MS4wMDAwMDApIiBmaWxsPSIjOUI5QjlCIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkRyb3Bkb3duLVRyaWFuZ2xlLSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI3OS41MDAwMDAsIDczLjUwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMTI3OS41MDAwMDAsIC03My41MDAwMDApICIgcG9pbnRzPSIxMjc5LjUgNzEgMTI4NCA3NiAxMjc1IDc2Ij48L3BvbHlnb24+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopicCloudsDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

var _topicclouds = __webpack_require__(239);

var _List = __webpack_require__(1661);

var _List2 = _interopRequireDefault(_List);

var _List3 = __webpack_require__(1663);

var _List4 = _interopRequireDefault(_List3);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicCloudsContainer = function (_Component) {
  (0, _inherits3.default)(TopicCloudsContainer, _Component);

  function TopicCloudsContainer(props) {
    (0, _classCallCheck3.default)(this, TopicCloudsContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopicCloudsContainer.__proto__ || (0, _getPrototypeOf2.default)(TopicCloudsContainer)).call(this, props));

    _this.onTopicCloudChangeBound = _this.onTopicCloudChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(TopicCloudsContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.topicClouds.length === 0) {
        this.props.dispatch((0, _topicclouds.fetchTopicClouds)());
      } else {
        this.props.dispatch((0, _topicclouds.fetchTopicCloud)(this.props.currentTopicCloud ? this.props.currentTopicCloud.id : this.props.topicClouds[0].id));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _topicclouds.clearCurrentTopicCloud)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentTopicCloud = _props.currentTopicCloud,
          currentTopic = _props.currentTopic,
          topicClouds = _props.topicClouds,
          isFetchingTopicClouds = _props.isFetchingTopicClouds,
          isFetchingTopic = _props.isFetchingTopic,
          dispatch = _props.dispatch,
          user = _props.user;


      var topicCloudsOptionTags = topicClouds.map(function (tc, index) {
        return _react2.default.createElement(
          'option',
          { value: tc.id, key: index },
          tc.name
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'topic-clouds' },
        isFetchingTopicClouds && _react2.default.createElement('div', { className: 'loading' }),
        topicClouds && topicClouds.length > 0 && _react2.default.createElement(
          'div',
          { className: 'topic-clouds-container' },
          _react2.default.createElement(
            'div',
            { className: 'left' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                { className: 'select-topic-cloud' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'Topics.SelectATopicCloud',
                  defaultMessage: 'Select A Topic Cloud'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { id: 'topicCloudDropdown' },
                _react2.default.createElement(
                  'select',
                  {
                    className: 'aDropdown',
                    id: 'topicClouds',
                    defaultValue: currentTopicCloud ? currentTopicCloud.id : undefined,
                    onChange: this.onTopicCloudChangeBound
                  },
                  topicCloudsOptionTags
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { id: 'topicCloudTopics' },
              _react2.default.createElement(_List2.default, {
                topics: currentTopicCloud ? currentTopicCloud.topics : [],
                currentTopic: currentTopic,
                dispatch: dispatch,
                user: user
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement(
              'div',
              { className: 'topic-container' },
              _react2.default.createElement(
                'div',
                { id: 'topicDetail' },
                isFetchingTopic && _react2.default.createElement('div', { className: 'loading' }),
                !isFetchingTopic && currentTopic && currentTopicCloud && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    null,
                    currentTopicCloud.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'topic-header' },
                    _react2.default.createElement(
                      'h2',
                      null,
                      currentTopic.name
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'description' },
                      currentTopic.description
                    ),
                    !(0, _user.isExternalReviewer)(user) && _react2.default.createElement(
                      'div',
                      { className: 'stats' },
                      _react2.default.createElement(
                        'div',
                        { className: 'count' },
                        _react2.default.createElement(
                          'span',
                          null,
                          currentTopic.stats.descendants_quests_count ? currentTopic.stats.descendants_quests_count : '0',
                          ' ',
                          'QUESTS'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'count' },
                        _react2.default.createElement(
                          'span',
                          null,
                          currentTopic.subtopics.length,
                          ' ',
                          _messages.subtopics
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_List4.default, {
                    dispatch: dispatch,
                    subtopics: currentTopic.subtopics,
                    user: user
                  })
                )
              )
            )
          )
        ),
        !isFetchingTopicClouds && topicClouds && topicClouds.length === 0 && _react2.default.createElement(
          'div',
          { className: 'topic-clouds-container empty' },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Topics.NoTopicsExistYet',
              defaultMessage: 'No topics exist yet!'
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Topics.WhenOrgCreatesTopics',
              defaultMessage: "When your organization creates topics that coordinate with quests, they'll appear here."
            })
          )
        )
      );
    }
  }, {
    key: 'onTopicCloudChange',
    value: function onTopicCloudChange(e) {
      var selectedTopicCloudId = e.currentTarget.options[e.currentTarget.selectedIndex].value;
      this.props.dispatch((0, _topicclouds.fetchTopicCloud)(selectedTopicCloudId));
    }
  }]);
  return TopicCloudsContainer;
}(_react.Component);

TopicCloudsContainer.propTypes = {
  currentTopic: _propTypes2.default.object,
  currentTopicCloud: _propTypes2.default.object,
  topicClouds: _propTypes2.default.array,
  isFetchingTopicClouds: _propTypes2.default.bool,
  isFetchingTopic: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    currentTopic: state.topicclouds.currentTopic,
    currentTopicCloud: state.topicclouds.currentTopicCloud,
    topicClouds: state.topicclouds.items,
    isFetchingTopicClouds: state.topicclouds.isFetchingTopicClouds,
    isFetchingTopic: state.topicclouds.isFetchingTopic,
    user: state.user.user
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TopicCloudsContainer);
exports.TopicCloudsDisconnected = TopicCloudsContainer;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1662);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicCloudList = function (_PureComponent) {
  (0, _inherits3.default)(TopicCloudList, _PureComponent);

  function TopicCloudList() {
    (0, _classCallCheck3.default)(this, TopicCloudList);
    return (0, _possibleConstructorReturn3.default)(this, (TopicCloudList.__proto__ || (0, _getPrototypeOf2.default)(TopicCloudList)).apply(this, arguments));
  }

  (0, _createClass3.default)(TopicCloudList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          topics = _props.topics,
          currentTopic = _props.currentTopic,
          user = _props.user;

      var topicsList = topics.map(function (topic, index) {
        return _react2.default.createElement(_Item2.default, {
          topic: topic,
          isSelected: currentTopic ? currentTopic.id === topic.id : false,
          key: index,
          dispatch: dispatch,
          user: user
        });
      });

      return _react2.default.createElement(
        'ul',
        null,
        topicsList
      );
    }
  }]);
  return TopicCloudList;
}(_react.PureComponent);

exports.default = TopicCloudList;


TopicCloudList.propTypes = {
  dispatch: _propTypes2.default.func,
  topics: _propTypes2.default.array,
  currentTopic: _propTypes2.default.object,
  user: _propTypes2.default.object
};

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _topicclouds = __webpack_require__(239);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_PureComponent) {
  (0, _inherits3.default)(Item, _PureComponent);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

    _this.onClickBound = _this.onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          topic = _props.topic,
          isSelected = _props.isSelected,
          user = _props.user;


      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'div',
          {
            className: 'topic ' + (isSelected ? 'selected' : ''),
            title: topic.name,
            'data-topicid': topic.id,
            onClick: this.onClickBound
          },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            topic.name
          ),
          !(0, _user.isExternalReviewer)(user) && _react2.default.createElement(
            'div',
            { className: 'count' },
            _react2.default.createElement(
              'span',
              null,
              topic.stats.descendants_quests_count ? topic.stats.descendants_quests_count : '0'
            )
          )
        )
      );
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      this.props.dispatch((0, _topicclouds.fetchTopic)(e.currentTarget.dataset.topicid));

      var topics = document.querySelectorAll('#topicCloudTopics .topic');
      var arrTopics = [].concat((0, _toConsumableArray3.default)(topics)); // spread operator allows us to forEach these DOM elements
      arrTopics.forEach(function (el) {
        el.classList.remove('selected');
      });

      e.currentTarget.classList.add('selected');
    }
  }]);
  return Item;
}(_react.PureComponent);

exports.default = Item;


Item.propTypes = {
  dispatch: _propTypes2.default.func,
  topic: _propTypes2.default.object,
  isSelected: _propTypes2.default.bool,
  user: _propTypes2.default.object
};

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1664);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubTopicList = function (_PureComponent) {
  (0, _inherits3.default)(SubTopicList, _PureComponent);

  function SubTopicList() {
    (0, _classCallCheck3.default)(this, SubTopicList);
    return (0, _possibleConstructorReturn3.default)(this, (SubTopicList.__proto__ || (0, _getPrototypeOf2.default)(SubTopicList)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubTopicList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          subtopics = _props.subtopics,
          user = _props.user;

      var subTopicList = subtopics.map(function (subtopic, index) {
        return _react2.default.createElement(_Item2.default, { subtopic: subtopic, key: index, dispatch: dispatch, user: user });
      });

      return _react2.default.createElement(
        'ul',
        null,
        subTopicList
      );
    }
  }]);
  return SubTopicList;
}(_react.PureComponent);

exports.default = SubTopicList;


SubTopicList.propTypes = {
  dispatch: _propTypes2.default.func,
  subtopics: _propTypes2.default.array,
  user: _propTypes2.default.object
};

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _List = __webpack_require__(1665);

var _List2 = _interopRequireDefault(_List);

var _user = __webpack_require__(45);

var _quests = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_Component) {
  (0, _inherits3.default)(Item, _Component);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

    _this.state = {
      showAllQuests: false
    };
    _this.onShowMoreClickBound = _this.onShowMoreClick.bind(_this);
    _this.onHideClickBound = _this.onHideClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          subtopic = _props.subtopic,
          dispatch = _props.dispatch,
          user = _props.user;


      var quests = subtopic.quests;
      if ((0, _user.isExternalReviewer)(user)) {
        quests = (0, _quests.filterQuestsForExternalReviewer)(quests);
      }

      return _react2.default.createElement(
        'li',
        { className: 'subtopic-detail' },
        _react2.default.createElement(
          'h3',
          null,
          subtopic.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'description' },
          subtopic.description
        ),
        quests.length > 0 && _react2.default.createElement(
          'div',
          { className: 'quest-count' },
          _react2.default.createElement(
            'div',
            { className: 'thecount' },
            quests.length,
            ' ',
            _react2.default.createElement(_reactIntl.FormattedPlural, {
              value: quests.length,
              one: 'QUEST',
              other: 'QUESTS'
            })
          )
        ),
        quests.length === 0 && _react2.default.createElement(
          'div',
          { className: 'no-quests' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'Topics.NoQuestsLinkedYet',
            defaultMessage: 'No quests are linked to this subtopic yet.'
          })
        ),
        _react2.default.createElement(
          'ul',
          { className: 'quests' },
          _react2.default.createElement(_List2.default, {
            quests: quests,
            showAllQuests: this.state.showAllQuests,
            dispatch: dispatch
          })
        ),
        quests.length > 5 && _react2.default.createElement(
          'div',
          null,
          !this.state.showAllQuests && _react2.default.createElement(
            'div',
            { className: 'showmore', onClick: this.onShowMoreClickBound },
            'Show ',
            quests.length - 5,
            ' More',
            ' ',
            _react2.default.createElement(_reactIntl.FormattedPlural, {
              value: quests.length - 5,
              one: 'Quest',
              other: 'Quests'
            }),
            '...'
          ),
          this.state.showAllQuests && _react2.default.createElement(
            'div',
            { className: 'hideextra', onClick: this.onHideClickBound },
            'Hide ',
            quests.length - 5,
            ' ',
            _react2.default.createElement(_reactIntl.FormattedPlural, {
              value: quests.length - 5,
              one: 'Quest',
              other: 'Quests'
            }),
            '...'
          )
        )
      );
    }
  }, {
    key: 'onHideClick',
    value: function onHideClick() {
      this.setState({
        showAllQuests: false
      });
    }
  }, {
    key: 'onShowMoreClick',
    value: function onShowMoreClick() {
      this.setState({
        showAllQuests: true
      });
    }
  }]);
  return Item;
}(_react.Component);

exports.default = Item;


Item.propTypes = {
  dispatch: _propTypes2.default.func,
  subtopic: _propTypes2.default.object,
  user: _propTypes2.default.object
};

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _Item = __webpack_require__(1666);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestList = function (_Component) {
  (0, _inherits3.default)(QuestList, _Component);

  function QuestList() {
    (0, _classCallCheck3.default)(this, QuestList);
    return (0, _possibleConstructorReturn3.default)(this, (QuestList.__proto__ || (0, _getPrototypeOf2.default)(QuestList)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuestList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          quests = _props.quests,
          showAllQuests = _props.showAllQuests;

      var questsSorted = (0, _arraySort2.default)(quests, ['name']);

      var questList = questsSorted.map(function (quest, index) {
        return _react2.default.createElement(_Item2.default, {
          quest: quest,
          showAllQuests: showAllQuests,
          position: index,
          key: index,
          dispatch: dispatch
        });
      });

      return _react2.default.createElement(
        'ul',
        null,
        questList
      );
    }
  }]);
  return QuestList;
}(_react.Component);

exports.default = QuestList;


QuestList.propTypes = {
  dispatch: _propTypes2.default.func,
  quests: _propTypes2.default.array,
  showAllQuests: _propTypes2.default.bool
};

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(23);

var _QuestIcon = __webpack_require__(162);

var _QuestIcon2 = _interopRequireDefault(_QuestIcon);

var _quest = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Item = function (_Component) {
  (0, _inherits3.default)(Item, _Component);

  function Item(props) {
    (0, _classCallCheck3.default)(this, Item);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Item.__proto__ || (0, _getPrototypeOf2.default)(Item)).call(this, props));

    _this.onClickQuestBound = _this.onClickQuest.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quest = _props.quest,
          position = _props.position,
          showAllQuests = _props.showAllQuests;


      return _react2.default.createElement(
        'li',
        { className: '' + (position > 4 && !showAllQuests ? 'hiddenitem' : '') },
        _react2.default.createElement(
          'div',
          { className: 'status-wrapper' },
          _react2.default.createElement('div', { className: 'status-marker ' + quest.status })
        ),
        _react2.default.createElement(_QuestIcon2.default, {
          heightWidth: 40,
          icon_image_url: quest.icon_image_url,
          handleClick: this.onClickQuestBound,
          dataId: quest.id
        }),
        _react2.default.createElement(
          'div',
          { className: 'info' },
          _react2.default.createElement(
            'div',
            {
              className: 'name',
              'data-id': quest.id,
              onClick: this.onClickQuestBound
            },
            quest.name
          ),
          _react2.default.createElement(
            'div',
            { className: 'author' },
            'by ',
            quest.author,
            ' ',
            _react2.default.createElement(
              'span',
              null,
              '\u25CF'
            ),
            ' ',
            quest.organization_name
          )
        )
      );
    }
  }, {
    key: 'onClickQuest',
    value: function onClickQuest() {
      this.props.dispatch((0, _quest.setQuestSection)('basicinformation'));
      this.props.dispatch((0, _reactRouterRedux.push)('/quest/' + this.props.quest.id + '/basicinformation'));
    }
  }]);
  return Item;
}(_react.Component);

exports.default = Item;


Item.propTypes = {
  dispatch: _propTypes2.default.func,
  quest: _propTypes2.default.object,
  position: _propTypes2.default.number,
  showAllQuests: _propTypes2.default.bool
};

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _reactIntl = __webpack_require__(16);

var _AddResource = __webpack_require__(1668);

var _AddResource2 = _interopRequireDefault(_AddResource);

var _UploadMentorFile = __webpack_require__(1669);

var _UploadMentorFile2 = _interopRequireDefault(_UploadMentorFile);

var _EditMentorFile = __webpack_require__(1670);

var _EditMentorFile2 = _interopRequireDefault(_EditMentorFile);

var _EditResource = __webpack_require__(1671);

var _EditResource2 = _interopRequireDefault(_EditResource);

var _DraggableListComponent = __webpack_require__(673);

var _DraggableListComponent2 = _interopRequireDefault(_DraggableListComponent);

var _MultipleEditorsInfo = __webpack_require__(695);

var _MultipleEditorsInfo2 = _interopRequireDefault(_MultipleEditorsInfo);

var _quest = __webpack_require__(66);

var _activity = __webpack_require__(1672);

var _activity2 = __webpack_require__(240);

var _resource = __webpack_require__(557);

var _logging = __webpack_require__(137);

var _quest2 = __webpack_require__(103);

var _resources = __webpack_require__(125);

var _orglabels = __webpack_require__(677);

var _index = __webpack_require__(20);

var _messages = __webpack_require__(21);

var _confirm = __webpack_require__(678);

var _alert = __webpack_require__(402);

var _placeholder = __webpack_require__(150);

var _multipleeditors = __webpack_require__(341);

var _pusher = __webpack_require__(263);

var _draggableitem = __webpack_require__(680);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityEditContainer = function (_Component) {
  (0, _inherits3.default)(ActivityEditContainer, _Component);

  function ActivityEditContainer(props) {
    (0, _classCallCheck3.default)(this, ActivityEditContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityEditContainer.__proto__ || (0, _getPrototypeOf2.default)(ActivityEditContainer)).call(this, props));

    _this.state = {
      activity: props.currentActivity,
      noteToEdit: '',
      resourceToEdit: '',
      newEditors: [],
      artifactType: props.currentActivity.artifact_type ? props.currentActivity.artifact_type.id : null,
      isEditingResource: false,
      uploadedResourceFile: '',
      isAddingResource: false
    };

    _this.onReturnToQuestClickBound = _this.onReturnToQuestClick.bind(_this);
    _this.onAddResourceClickBound = _this.onAddResourceClick.bind(_this);
    _this.onSaveActivityClickBound = _this.onSaveActivityClick.bind(_this);
    _this.onCancelActivityEditClickBound = _this.onCancelActivityEditClick.bind(_this);
    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.handleCheckpointYesClickBound = _this.handleCheckpointYesClick.bind(_this);
    _this.handleCheckpointNoClickBound = _this.handleCheckpointNoClick.bind(_this);
    _this.handleWorkproductYesClickBound = _this.handleWorkproductYesClick.bind(_this);
    _this.handleWorkproductNoClickBound = _this.handleWorkproductNoClick.bind(_this);
    _this.handleInlineNoteChangeBound = _this.handleInlineNoteChange.bind(_this);
    _this.handleAssessmentQuestionsChangeBound = _this.handleAssessmentQuestionsChange.bind(_this);
    _this.onUploadMentorFileClickBound = _this.onUploadMentorFileClick.bind(_this);
    _this.onDeleteNoteClickBound = _this.onDeleteNoteClick.bind(_this);
    _this.onSaveMentorFileUploadClickBound = _this.onSaveMentorFileUploadClick.bind(_this);
    _this.closeModalBound = _this.closeModal.bind(_this);
    _this.handleEditNoteClickBound = _this.handleEditNoteClick.bind(_this);
    _this.editMentorNoteBound = _this.editMentorNote.bind(_this);
    _this.onEditActivityNotePositionBound = _this.onEditActivityNotePosition.bind(_this);
    _this.onDeleteResourceClickBound = _this.onDeleteResourceClick.bind(_this);
    _this.handleEditResourceClickBound = _this.handleEditResourceClick.bind(_this);
    _this.onEditActivityResourcePositionBound = _this.onEditActivityResourcePosition.bind(_this);
    _this.editResourceBound = _this.editResource.bind(_this);
    _this.removeResourceFileBound = _this.removeResourceFile.bind(_this);
    _this.handleArtifactDescriptionChangeBound = _this.handleArtifactDescriptionChange.bind(_this);
    _this.editorAddedBound = _this.editorAdded.bind(_this);
    _this.patchFileUploadInfoBound = _this.patchFileUploadInfo.bind(_this);
    _this.deleteShellResourceBound = _this.deleteShellResource.bind(_this);
    _this.stopEditResourceBound = _this.stopEditResource.bind(_this);
    _this.startFileUploadAnalyticsBound = _this.startFileUploadAnalytics.bind(_this);
    _this.cancelFileUploadAnalyticsBound = _this.cancelFileUploadAnalytics.bind(_this);
    _this.fileUploadCompleteAnalyticsBound = _this.fileUploadCompleteAnalytics.bind(_this);
    _this.removeResourceFileAnalyticsBound = _this.removeResourceFileAnalytics.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ActivityEditContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.presenceChannel = window.oeQMQuestPusherInstance && window.oeQMQuestPusherInstance.channel('presence-activity-' + this.props.id) ? window.oeQMQuestPusherInstance.channel('presence-activity-' + this.props.id) : null;
      if (this.presenceChannel) {
        this.presenceChannel.bind('client-edit', this.editorAddedBound);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Wait for the save/edit action to finish before closing the modal
      if (this.props.isUploadingNote && !nextProps.isUploadingNote) {
        this.closeModal();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (window.oeQMQuestPusherInstance) {
        (0, _pusher.unsubscribeFromAllChannelsWithPrefix)(window.oeQMQuestPusherInstance, 'presence');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quest = _props.quest,
          id = _props.id,
          notes = _props.notes,
          isUploadingNote = _props.isUploadingNote,
          dispatch = _props.dispatch,
          currentOrg = _props.currentOrg,
          activities = _props.activities;


      var activity = quest ? (0, _quest2.findActivity)(activities, id) : '';

      var descriptionOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      descriptionOptions.initialValue = activity ? activity.description : '';
      descriptionOptions.placeholder = '';
      descriptionOptions.autofocus = false;

      var mentorNoteOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      mentorNoteOptions.initialValue = activity ? activity.inline_notes : '';
      mentorNoteOptions.placeholder = '';
      mentorNoteOptions.autofocus = false;

      var mentorAssessmentQuestionsOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      mentorAssessmentQuestionsOptions.initialValue = activity ? activity.mentor_assessment_questions : '';
      mentorAssessmentQuestionsOptions.placeholder = '';
      mentorAssessmentQuestionsOptions.autofocus = false;

      var artifactDescriptionOptions = (0, _assign2.default)({}, _index.simpleMDEOptions);
      artifactDescriptionOptions.initialValue = activity ? activity.artifact_description : '';
      artifactDescriptionOptions.placeholder = this.context.intl.formatMessage(_placeholder.messages.artifactDescription);
      artifactDescriptionOptions.autofocus = false;

      var mappedResources = activity.resources.length > 0 ? (0, _resources.mapResources)(activity.resources) : [];

      return !activity ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
        'div',
        { className: 'activity-edit-container' },
        _react2.default.createElement(
          'div',
          { id: 'activityActions' },
          _react2.default.createElement(
            'div',
            { className: 'nav-to-quest' },
            _react2.default.createElement(
              'h5',
              { onClick: this.onReturnToQuestClickBound },
              '< Return to ' + (quest ? quest.name : 'Quest')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'header-title' },
            this.presenceChannel && (0, _keys2.default)((0, _multipleeditors.filterCurrentUserFromMembers)(this.presenceChannel.members, this.props.user.id)).length > 0 && _react2.default.createElement(_MultipleEditorsInfo2.default, {
              channel: this.presenceChannel,
              newEditors: this.state.newEditors
            }),
            _react2.default.createElement(
              'h2',
              null,
              activity.name
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'top' },
            _react2.default.createElement(
              'div',
              {
                className: 'button save btn-primary',
                onClick: this.onSaveActivityClickBound
              },
              _messages.save
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'button cancel btn-secondary',
                onClick: this.onCancelActivityEditClickBound
              },
              _messages.cancel
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'activityContainer' },
          _react2.default.createElement(
            'div',
            { id: 'accordion', className: 'qm-view' },
            _react2.default.createElement(
              'div',
              { className: 'quest-section one' },
              _react2.default.createElement(
                'div',
                { className: 'section-inner' },
                _react2.default.createElement(
                  'div',
                  { className: 'edit-fields' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.title,
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  _react2.default.createElement('input', {
                    type: 'text',
                    id: 'name',
                    defaultValue: activity.name,
                    className: 'form-control',
                    onChange: this.handleChangeBound
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  (0, _orglabels.activityGoalOrgLabel)(currentOrg),
                  _react2.default.createElement('div', { className: 'requiredtool' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'edit-fields' },
                  _react2.default.createElement('input', {
                    type: 'text',
                    id: 'goals',
                    className: 'form-control',
                    defaultValue: activity.goals,
                    onChange: this.handleChangeBound
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.descriptionMessage,
                  _react2.default.createElement('div', { className: 'requiredtool' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'edit-fields' },
                  _react2.default.createElement(_reactSimplemdeEditor2.default, {
                    options: descriptionOptions,
                    onChange: this.handleDescriptionChangeBound
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title checkpoint' },
                  _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'ActivityEdit.Checkpoint?',
                    defaultMessage: 'Check-in?'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'edit-fields padded' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', {
                      type: 'radio',
                      id: 'checkpoint',
                      name: 'checkpoint',
                      className: 'form-control',
                      checked: this.state.activity.checkpoint,
                      value: true,
                      onChange: this.handleCheckpointYesClickBound
                    }),
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'checkpoint' },
                      _messages.yes
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', {
                      type: 'radio',
                      id: 'checkpoint',
                      name: 'checkpoint',
                      className: 'form-control',
                      checked: !this.state.activity.checkpoint,
                      value: false,
                      onChange: this.handleCheckpointNoClickBound
                    }),
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'checkpoint' },
                      _messages.no
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'title requires-resource' },
                  _messages.requiresArtifact
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'edit-fields padded',
                    style: { position: 'relative' }
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'artifact-toggle' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('input', {
                        type: 'radio',
                        id: 'work_product',
                        name: 'work_product',
                        className: 'form-control',
                        checked: this.state.activity.work_product,
                        value: true,
                        onChange: this.handleWorkproductYesClickBound
                      }),
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'work_product' },
                        _messages.yes
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('input', {
                        type: 'radio',
                        id: 'work_product',
                        name: 'work_product',
                        className: 'form-control',
                        checked: !this.state.activity.work_product,
                        value: false,
                        onChange: this.handleWorkproductNoClickBound
                      }),
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'work_product' },
                        _messages.no
                      )
                    )
                  ),
                  this.state.activity.work_product && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'artifact-type' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        'Artifact Type',
                        _react2.default.createElement('div', { className: 'requiredtool' })
                      ),
                      this.props.artifactTypes.map(function (at) {
                        return _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'label',
                            { style: { marginBottom: '0' } },
                            _react2.default.createElement('input', {
                              key: at.id,
                              type: 'radio',
                              id: 'artifact_type_id',
                              checked: _this2.state.artifactType === at.id,
                              value: at.id,
                              onClick: _this2.handleChangeBound
                            }),
                            at.name
                          )
                        );
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'artifact-description' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        _messages.artifactDescription
                      ),
                      _react2.default.createElement(_reactSimplemdeEditor2.default, {
                        options: artifactDescriptionOptions,
                        onChange: this.handleArtifactDescriptionChangeBound
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'resource-list' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.activityResources
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'add-resource ' + (this.props.isCreatingActivityResource || this.state.isAddingResource ? 'disabled' : ''),
                      onClick: this.onAddResourceClickBound
                    },
                    _messages.addResource,
                    (this.props.isCreatingActivityResource || this.state.isAddingResource) && _react2.default.createElement('div', {
                      className: 'loading',
                      style: {
                        marginLeft: '10px',
                        height: '17px',
                        width: '17px',
                        backgroundSize: '100%',
                        minHeight: 'unset',
                        display: 'inline-block',
                        verticalAlign: 'text-bottom'
                      }
                    })
                  ),
                  this.state.isAddingResource && _react2.default.createElement(_AddResource2.default, {
                    ref: 'addResourceModal',
                    organization: currentOrg,
                    resourceId: this.state.resourceToEdit,
                    patchFileUploadInfo: this.patchFileUploadInfoBound,
                    editResource: this.editResourceBound,
                    deleteResource: this.deleteShellResourceBound,
                    removeResourceFile: this.removeResourceFileBound,
                    uploadedResourceFile: this.state.uploadedResourceFile,
                    stopEditResource: this.stopEditResourceBound,
                    questId: quest.id,
                    activityId: id,
                    token: this.props.token,
                    onUploadFileStart: this.startFileUploadAnalyticsBound,
                    onUploadFileAbort: this.cancelFileUploadAnalyticsBound,
                    onUploadComplete: this.fileUploadCompleteAnalyticsBound
                  }),
                  this.state.isEditingResource && _react2.default.createElement(_EditResource2.default, {
                    ref: 'editResourceModal',
                    editResource: this.editResourceBound,
                    stopEditResource: this.stopEditResourceBound,
                    organization: currentOrg,
                    removeResourceFile: this.removeResourceFileBound,
                    patchFileUploadInfo: this.patchFileUploadInfoBound,
                    questId: quest.id,
                    activityId: id,
                    resourceId: this.state.resourceToEdit,
                    token: this.props.token,
                    uploadedResourceFile: this.state.uploadedResourceFile,
                    onUploadFileStart: this.startFileUploadAnalyticsBound,
                    onUploadFileAbort: this.cancelFileUploadAnalyticsBound,
                    onUploadComplete: this.fileUploadCompleteAnalyticsBound
                  }),
                  _react2.default.createElement(
                    'div',
                    { id: 'resources-list-section' },
                    _react2.default.createElement(_DraggableListComponent2.default, {
                      list: mappedResources,
                      deleteItem: this.onDeleteResourceClickBound,
                      handleEditClick: this.handleEditResourceClickBound,
                      dispatch: dispatch,
                      editListItemPosition: this.onEditActivityResourcePositionBound,
                      itemType: 'resource'
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { id: 'justForMentors' },
                  _react2.default.createElement(
                    'label',
                    { className: 'just-for-mentors-label' },
                    _messages.justFor,
                    '\xA0',
                    _react2.default.createElement(
                      'span',
                      { className: 'label' },
                      _messages.mentors
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'edit-fields' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      _messages.notesForMentors
                    ),
                    _react2.default.createElement(_reactSimplemdeEditor2.default, {
                      options: mentorNoteOptions,
                      onChange: this.handleInlineNoteChangeBound
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'edit-fields' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title', id: 'mentorNoteFileUploadTitle' },
                      _messages.uploadFileForMentors
                    ),
                    _react2.default.createElement(
                      'div',
                      { id: 'mentorNotesSection' },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'add-mentor-note',
                          onClick: this.onUploadMentorFileClickBound
                        },
                        notes.length > 0 ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                          id: 'ActivityEdit.AddAnotherFile',
                          defaultMessage: 'Add another file'
                        }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                          id: 'ActivityEdit.AddAFileToHelpMentors',
                          defaultMessage: 'Add a file to help mentors with this activity'
                        })
                      ),
                      _react2.default.createElement(_UploadMentorFile2.default, {
                        ref: 'addMentorFileModal',
                        closeModal: this.closeModalBound,
                        saveMentorNote: this.onSaveMentorFileUploadClickBound,
                        isUploadingNote: isUploadingNote
                      }),
                      _react2.default.createElement(_EditMentorFile2.default, {
                        ref: 'editMentorNoteModal',
                        closeModal: this.closeModalBound,
                        note: this.state.noteToEdit,
                        editMentorNote: this.editMentorNoteBound,
                        isUploadingNote: isUploadingNote
                      }),
                      _react2.default.createElement(_DraggableListComponent2.default, {
                        list: notes,
                        deleteItem: this.onDeleteNoteClickBound,
                        handleEditClick: this.handleEditNoteClickBound,
                        dispatch: dispatch,
                        editListItemPosition: this.onEditActivityNotePositionBound,
                        itemType: 'note'
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'title', style: { marginTop: '40px' } },
                    _messages.assessmentQuestions
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'edit-fields' },
                    _react2.default.createElement(_reactSimplemdeEditor2.default, {
                      options: mentorAssessmentQuestionsOptions,
                      onChange: this.handleAssessmentQuestionsChangeBound
                    })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom' },
            _react2.default.createElement(
              'div',
              {
                className: 'button save btn-primary',
                onClick: this.onSaveActivityClickBound
              },
              _messages.save
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'button cancel btn-secondary',
                onClick: this.onCancelActivityEditClickBound
              },
              _messages.cancel
            )
          )
        )
      );
    }
  }, {
    key: 'editorAdded',
    value: function editorAdded(data) {
      this.setState(function (prevState) {
        return {
          newEditors: prevState.newEditors.concat({
            id: (0, _stringify2.default)(data.id),
            name: data.info.name
          })
        };
      });
    }
  }, {
    key: 'onReturnToQuestClick',
    value: function onReturnToQuestClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest,
          id = _props2.id;

      dispatch((0, _reactRouterRedux.push)('/quest/' + quest.id + '/activities/' + id));
      dispatch((0, _quest.setQuestSection)('activities', id));
    }
  }, {
    key: 'onAddResourceClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props3, dispatch, quest, currentActivity, newResourceName;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props3 = this.props, dispatch = _props3.dispatch, quest = _props3.quest, currentActivity = _props3.currentActivity;
                newResourceName = currentActivity.resources.length === 0 ? 'Resource 1' : 'Resource ' + (currentActivity.resources.length + 1);
                _context.next = 4;
                return dispatch((0, _resource.createActivityResource)(quest.id, currentActivity, newResourceName));

              case 4:
                this.setState(function () {
                  return {
                    resourceToEdit: currentActivity.resources[0].id,
                    isAddingResource: true
                  };
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onAddResourceClick() {
        return _ref.apply(this, arguments);
      }

      return onAddResourceClick;
    }()
  }, {
    key: 'onUploadMentorFileClick',
    value: function onUploadMentorFileClick() {
      this.refs.addMentorFileModal.refs.modal.show();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.refs.addMentorFileModal.refs.modal.hide();
      this.refs.editMentorNoteModal.refs.modal.hide();
    }
  }, {
    key: 'onSaveActivityClick',
    value: function onSaveActivityClick() {
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          quest = _props4.quest,
          id = _props4.id;

      var intlAlert = this.context.intl.formatMessage(_alert.messages.nameCantBeBlank);
      if (this.state.activity.name.length < 1) {
        alert(intlAlert);
      } else {
        dispatch((0, _activity2.editActivityDetails)(quest.id, id, this.state.activity));
      }
    }
  }, {
    key: 'onCancelActivityEditClick',
    value: function onCancelActivityEditClick() {
      var _props5 = this.props,
          dispatch = _props5.dispatch,
          quest = _props5.quest,
          id = _props5.id;

      dispatch((0, _reactRouterRedux.push)('/quest/' + quest.id + '/activities/' + id));
      dispatch((0, _quest.setQuestSection)('activities', id));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      if (event.target.id === 'artifact_type_id') {
        var value = parseInt(event.target.value);
        this.setState(function () {
          return { artifactType: value };
        });
      }

      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, (0, _defineProperty3.default)({}, event.target.id, event.target.value))
      });
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(val) {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          description: val
        })
      });
    }
  }, {
    key: 'handleArtifactDescriptionChange',
    value: function handleArtifactDescriptionChange(val) {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          artifact_description: val
        })
      });
    }
  }, {
    key: 'handleCheckpointYesClick',
    value: function handleCheckpointYesClick() {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          checkpoint: true
        })
      });
    }
  }, {
    key: 'handleCheckpointNoClick',
    value: function handleCheckpointNoClick() {
      // User should be alerted if they're requiring an artifact/workproduct but selecting no checkpoint
      var intlAlert = this.context.intl.formatMessage(_alert.messages.stronglyRecommendArtifact);
      if (this.state.activity.work_product) {
        alert(intlAlert);
      }
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          checkpoint: false
        })
      });
    }
  }, {
    key: 'handleWorkproductYesClick',
    value: function handleWorkproductYesClick() {
      // Defaulting checkpoint to 'yes' if artifact required
      document.getElementById('checkpoint').checked = true;
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          checkpoint: true,
          work_product: true
        })
      });
    }
  }, {
    key: 'handleWorkproductNoClick',
    value: function handleWorkproductNoClick() {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          work_product: false,
          artifact_description: null,
          artifact_type: null,
          artifact_type_id: null
        }),
        artifactType: null
      });
    }
  }, {
    key: 'handleInlineNoteChange',
    value: function handleInlineNoteChange(val) {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          inline_notes: val
        })
      });
    }
  }, {
    key: 'handleAssessmentQuestionsChange',
    value: function handleAssessmentQuestionsChange(val) {
      this.setState({
        activity: (0, _assign2.default)({}, this.state.activity, {
          mentor_assessment_questions: val
        })
      });
    }
  }, {
    key: 'onDeleteNoteClick',
    value: function onDeleteNoteClick(e) {
      var _props6 = this.props,
          dispatch = _props6.dispatch,
          id = _props6.id,
          quest = _props6.quest;
      // Need to locate the note clicked

      var noteId = parseInt(e.target.parentNode.parentNode.parentNode.dataset.id);
      var intlConfirmation = this.context.intl.formatMessage(_confirm.messages.deleteMentorNote);
      var confirmation = confirm(intlConfirmation);
      if (confirmation) {
        dispatch((0, _activity2.deleteActivityMentorNote)(quest.id, id, noteId));
      }
    }
  }, {
    key: 'onSaveMentorFileUploadClick',
    value: function onSaveMentorFileUploadClick(noteArgs) {
      var _props7 = this.props,
          dispatch = _props7.dispatch,
          id = _props7.id,
          quest = _props7.quest;

      dispatch((0, _activity2.createQuestActivityNote)(quest.id, id, noteArgs));
    }
  }, {
    key: 'handleEditNoteClick',
    value: function handleEditNoteClick(note) {
      this.setState({
        noteToEdit: note
      });
      this.refs.editMentorNoteModal.refs.modal.show();
    }
  }, {
    key: 'editMentorNote',
    value: function editMentorNote(noteId, description) {
      var _props8 = this.props,
          dispatch = _props8.dispatch,
          quest = _props8.quest,
          id = _props8.id;

      dispatch((0, _activity2.editQuestActivityNote)(quest.id, id, noteId, description));
    }
  }, {
    key: 'onEditActivityNotePosition',
    value: function onEditActivityNotePosition(noteId, newIndex) {
      var _props9 = this.props,
          dispatch = _props9.dispatch,
          quest = _props9.quest,
          id = _props9.id;

      dispatch((0, _activity2.editQuestActivityNotePosition)(quest.id, id, noteId, newIndex));
      // Find the node and flash orange
      var _el = document.getElementById('note-' + noteId);
      (0, _draggableitem.flashDraggableItem)(_el);
    }
  }, {
    key: 'onDeleteResourceClick',
    value: function onDeleteResourceClick(e) {
      var _props10 = this.props,
          dispatch = _props10.dispatch,
          quest = _props10.quest,
          id = _props10.id;
      // find the resource

      var resourceId = parseInt(e.target.parentNode.parentNode.parentNode.dataset.id);
      var intlConfirmation = this.context.intl.formatMessage(_confirm.messages.deleteResource);
      var confirmation = confirm(intlConfirmation);
      if (confirmation) {
        dispatch((0, _resource.deleteActivityResource)(quest.id, id, resourceId));
      }
    }
  }, {
    key: 'onEditActivityResourcePosition',
    value: function onEditActivityResourcePosition(resourceId, newIndex) {
      var _props11 = this.props,
          dispatch = _props11.dispatch,
          quest = _props11.quest,
          id = _props11.id;

      dispatch((0, _resource.editActivityResourcePosition)(quest.id, id, resourceId, newIndex));
      // Find the node and flash orange
      var _el = document.getElementById('resource-' + resourceId);
      (0, _draggableitem.flashDraggableItem)(_el);
    }
  }, {
    key: 'editResource',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(resource, newResource) {
        var _props12, dispatch, quest, id;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props12 = this.props, dispatch = _props12.dispatch, quest = _props12.quest, id = _props12.id;
                _context2.next = 3;
                return dispatch((0, _resource.editActivityResource)(quest.id, id, resource, newResource));

              case 3:
                this.setState(function () {
                  return {
                    isAddingResource: false,
                    isEditingResource: false,
                    resourceToEdit: null,
                    uploadedResourceFile: ''
                  };
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editResource(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return editResource;
    }()
  }, {
    key: 'removeResourceFile',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(resource, source) {
        var _props13, dispatch, quest, id;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props13 = this.props, dispatch = _props13.dispatch, quest = _props13.quest, id = _props13.id;
                _context3.next = 3;
                return dispatch((0, _resource.removeActivityResourceFile)(quest.id, id, resource));

              case 3:
                this.setState(function () {
                  return {
                    uploadedResourceFile: ''
                  };
                });
                this.removeResourceFileAnalytics(resource, source);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeResourceFile(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return removeResourceFile;
    }()
  }, {
    key: 'patchFileUploadInfo',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(fileProps) {
        var _props14, dispatch, quest, id, resourceId;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props14 = this.props, dispatch = _props14.dispatch, quest = _props14.quest, id = _props14.id;
                resourceId = this.state.resourceToEdit;
                _context4.prev = 2;
                _context4.next = 5;
                return dispatch((0, _resource.patchActivityResourceFileInfo)(quest.id, id, resourceId, fileProps));

              case 5:
                this.setState(function () {
                  return {
                    uploadedResourceFile: fileProps.original_file_name
                  };
                });
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);
                throw new Error(_context4.t0);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function patchFileUploadInfo(_x5) {
        return _ref4.apply(this, arguments);
      }

      return patchFileUploadInfo;
    }()
  }, {
    key: 'deleteShellResource',
    value: function deleteShellResource(resourceId) {
      var _props15 = this.props,
          dispatch = _props15.dispatch,
          quest = _props15.quest,
          id = _props15.id;

      dispatch((0, _resource.deleteActivityResource)(quest.id, id, resourceId, true));
      this.setState(function () {
        return {
          isAddingResource: false
        };
      });
    }
  }, {
    key: 'handleEditResourceClick',
    value: function handleEditResourceClick(resource) {
      this.setState(function () {
        return {
          isEditingResource: true,
          resourceToEdit: resource.id
        };
      });
    }
  }, {
    key: 'stopEditResource',
    value: function stopEditResource() {
      this.setState(function () {
        return {
          isAddingResource: false,
          isEditingResource: false,
          resourceToEdit: null,
          uploadedResourceFile: ''
        };
      });
    }
  }, {
    key: 'startFileUploadAnalytics',
    value: function startFileUploadAnalytics(resource, file) {
      var data = this.getResourceLoggingInfo(resource);
      data = (0, _assign2.default)({}, data, {
        action: 'start_file_upload',
        resource: (0, _assign2.default)({}, data.resource, {
          filename: file.name,
          filesize: file.size
        })
      });

      this.props.dispatch((0, _logging.postLoggingInfo)('track_resource', data));
    }
  }, {
    key: 'cancelFileUploadAnalytics',
    value: function cancelFileUploadAnalytics(resource, file, source) {
      var data = this.getResourceLoggingInfo(resource);
      data = (0, _assign2.default)({}, data, {
        action: 'cancel_file_upload',
        resource: (0, _assign2.default)({}, data.resource, {
          filename: file.name,
          filesize: file.size
        }),
        source: source
      });

      this.props.dispatch((0, _logging.postLoggingInfo)('track_resource', data));
    }
  }, {
    key: 'fileUploadCompleteAnalytics',
    value: function fileUploadCompleteAnalytics(resource, file, uploadTime) {
      var data = this.getResourceLoggingInfo(resource);
      data = (0, _assign2.default)({}, data, {
        action: 'upload_file',
        resource: (0, _assign2.default)({}, data.resource, {
          filename: file.name,
          filesize: file.size,
          time_to_upload_in_seconds: uploadTime
        })
      });

      this.props.dispatch((0, _logging.postLoggingInfo)('track_resource', data));
    }
  }, {
    key: 'removeResourceFileAnalytics',
    value: function removeResourceFileAnalytics(resource, source) {
      var data = this.getResourceLoggingInfo(resource);
      data = (0, _assign2.default)({}, data, {
        resource: (0, _assign2.default)({}, data.resource, {
          filename: resource.fileName
        }),
        source: source,
        action: 'remove_file'
      });

      this.props.dispatch((0, _logging.postLoggingInfo)('track_resource', data));
    }
  }, {
    key: 'getResourceLoggingInfo',
    value: function getResourceLoggingInfo(resource) {
      var _props16 = this.props,
          quest = _props16.quest,
          id = _props16.id,
          activities = _props16.activities;

      var activity = quest ? (0, _quest2.findActivity)(activities, id) : '';
      var currentActivityNumber = activities.findIndex(function (a) {
        return a.id === activity.id;
      }) + 1;
      var data = {
        action: 'remove_file',
        quest: {
          id: quest.id,
          name: quest.name
        },
        activity: {
          id: activity.id,
          name: activity.name,
          number: currentActivityNumber
        },
        resource: {
          id: resource.id,
          name: resource.resourceName,
          format: resource.resourceType
        }
      };
      return data;
    }
  }]);
  return ActivityEditContainer;
}(_react.Component);

ActivityEditContainer.propTypes = {
  id: _propTypes2.default.number.isRequired,
  quest: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  activityId: _propTypes2.default.number.isRequired,
  notes: _propTypes2.default.array,
  isUploadingNote: _propTypes2.default.bool,
  currentOrg: _propTypes2.default.object.isRequired,
  user: _propTypes2.default.object.isRequired,
  artifactTypes: _propTypes2.default.array.isRequired,
  currentActivity: _propTypes2.default.object.isRequired,
  isCreatingActivityResource: _propTypes2.default.bool.isRequired,
  token: _propTypes2.default.string.isRequired,
  activities: _propTypes2.default.array.isRequired
};

ActivityEditContainer.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    id: parseInt(ownProps.params.activityId),
    quest: state.quest.item,
    notes: state.quest.activityNotes,
    isUploadingNote: state.quest.isUploadingNote,
    currentOrg: state.organizations.items.find(function (org) {
      return org.id === parseInt(state.organization.orgId);
    }),
    user: state.user.user,
    artifactTypes: state.artifacttypes.items,
    currentActivity: (0, _activity.currentActivity)(state),
    isCreatingActivityResource: state.quest.isCreatingActivityResource,
    token: state.user.token,
    activities: state.quest.activities
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivityEditContainer);

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _truncateMiddle = __webpack_require__(321);

var _truncateMiddle2 = _interopRequireDefault(_truncateMiddle);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _ContentWarningsEditor = __webpack_require__(463);

var _ContentWarningsEditor2 = _interopRequireDefault(_ContentWarningsEditor);

var _S3Uploader = __webpack_require__(435);

var _S3Uploader2 = _interopRequireDefault(_S3Uploader);

var _YoutubeTrimmer = __webpack_require__(717);

var _YoutubeTrimmer2 = _interopRequireDefault(_YoutubeTrimmer);

var _API = __webpack_require__(718);

var _activityedit = __webpack_require__(434);

var _messages = __webpack_require__(21);

var _markdowneditor = __webpack_require__(142);

var _resources = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddResource = function (_Component) {
  (0, _inherits3.default)(AddResource, _Component);

  function AddResource(props) {
    (0, _classCallCheck3.default)(this, AddResource);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddResource.__proto__ || (0, _getPrototypeOf2.default)(AddResource)).call(this, props));

    _this.state = {
      id: props.resourceId,
      resourceName: '',
      resourceDescription: '',
      resourceType: 'audio',
      format: 'url',
      url: '',
      fileName: '',
      citation: '',
      attributionSelection: '',
      errorsExist: false,
      fileRemoved: false,
      hasContentWarnings: false,
      content_warnings: {},
      presignedUrl: {},
      isUploadingFile: false,
      startMinutes: null,
      startSeconds: null,
      endMinutes: null,
      endSeconds: null
    };

    _this.handleChangeFormatToUrlBound = _this.handleChangeFormatToUrl.bind(_this);
    _this.handleChangeFormatToFileBound = _this.handleChangeFormatToFile.bind(_this);
    _this.onSaveResourceClickBound = _this.onSaveResourceClick.bind(_this);
    _this.onCancelClickBound = _this.onCancelClick.bind(_this);
    _this.onAttributionClickBound = _this.onAttributionClick.bind(_this);
    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.onToggleContentWarningsClickBound = _this.onToggleContentWarningsClick.bind(_this);
    _this.onSetContentWarningClickBound = _this.onSetContentWarningClick.bind(_this);
    _this.onResourceTypeChangeBound = _this.onResourceTypeChange.bind(_this);
    _this.onRemoveFileClickBound = _this.onRemoveFileClick.bind(_this);
    _this.renderHasFileBound = _this.renderHasFile.bind(_this);
    _this.onUploadFileStartBound = _this.onUploadFileStart.bind(_this);
    _this.onUploadFileEndBound = _this.onUploadFileEnd.bind(_this);
    _this.onUploadAbortBound = _this.onUploadAbort.bind(_this);
    _this.onUploadCompleteBound = _this.onUploadComplete.bind(_this);
    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.onSetYoutubeStartTimeMinutesBound = _this.onSetYoutubeStartTimeMinutes.bind(_this);
    _this.onSetYoutubeStartTimeSecondsBound = _this.onSetYoutubeStartTimeSeconds.bind(_this);
    _this.onSetYoutubeEndTimeMinutesBound = _this.onSetYoutubeEndTimeMinutes.bind(_this);
    _this.onSetYoutubeEndTimeSecondsBound = _this.onSetYoutubeEndTimeSeconds.bind(_this);
    _this.S3UploaderRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(AddResource, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var resource;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _API.fetchActivityResource)(this.props.organization.id, this.props.questId, this.props.activityId, this.props.resourceId, this.props.token);

              case 2:
                resource = _context.sent;


                this.refs.modal.show();
                document.getElementsByTagName('html')[0].style.overflow = 'hidden';

                this.setState(function () {
                  return {
                    id: resource.id,
                    resourceName: resource.name,
                    presignedUrl: resource.presigned_url,
                    uniqueFilename: resource.unique_upload_file_name
                  };
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.uploadedResourceFile !== this.props.uploadedResourceFile) {
        this.setState(function () {
          return {
            fileName: nextProps.uploadedResourceFile
          };
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflow = 'scroll';
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '880px',
        background: '#fff',
        overflow: 'scroll',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%'
      };

      var _state = this.state,
          resourceName = _state.resourceName,
          resourceType = _state.resourceType,
          format = _state.format,
          url = _state.url,
          fileName = _state.fileName,
          attributionSelection = _state.attributionSelection,
          errorsExist = _state.errorsExist,
          file = _state.file,
          hasContentWarnings = _state.hasContentWarnings,
          content_warnings = _state.content_warnings;
      var organization = this.props.organization;


      var descriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
      descriptionOptions.initialValue = '';
      descriptionOptions.placeholder = '';
      descriptionOptions.autofocus = false;

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'edit-activity-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          onHide: this.onCancelClickBound,
          keyboard: false,
          closeOnClick: false
        },
        _react2.default.createElement(
          'div',
          { className: 'modal-dialog', id: 'addResourceModal' },
          _react2.default.createElement(
            'form',
            { id: 'frmResource', onSubmit: function onSubmit(e) {
                return e.preventDefault();
              } },
            _react2.default.createElement(
              'div',
              { className: 'qm-view' },
              _react2.default.createElement(
                'h2',
                null,
                _react2.default.createElement('span', { className: 'action' }),
                _messages.addResource
              ),
              _react2.default.createElement(
                'p',
                null,
                _messages.credibleResource,
                '\xA0',
                _react2.default.createElement(
                  'a',
                  {
                    href: 'https://questforward.zendesk.com/hc/en-us/sections/115000870051-Resources-in-Quest-Design',
                    target: '_blank'
                  },
                  _messages.helpCenter
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.name,
                _react2.default.createElement('div', { className: 'requiredtool' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement('input', {
                  type: 'text',
                  name: 'resource_name',
                  id: 'resourceName',
                  className: 'form-control',
                  onChange: this.handleChangeBound,
                  defaultValue: resourceName
                }),
                errorsExist && resourceName.length === 0 && _react2.default.createElement(
                  'label',
                  { className: 'error-text' },
                  _messages.fieldRequired
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.resourceDescriptionMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields', id: 'resourceDescription' },
                _react2.default.createElement(_reactSimplemdeEditor2.default, {
                  options: descriptionOptions,
                  onChange: this.handleDescriptionChangeBound
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.resourceTypeMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'url-selector' },
                  _react2.default.createElement(
                    'select',
                    {
                      id: 'resourceType',
                      className: 'aDropdown',
                      onChange: this.onResourceTypeChangeBound
                    },
                    _react2.default.createElement(
                      'option',
                      { value: 'audio' },
                      'Audio'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'document' },
                      'Document'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'game_app' },
                      'App'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'image' },
                      'Image'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'presentation' },
                      'Presentation'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'video' },
                      'Video'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'web' },
                      'Web'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'simulation' },
                      'Simulation'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.formatMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'url-selector' },
                  _react2.default.createElement('input', {
                    id: 'url_selector_url',
                    name: 'url_selector',
                    type: 'radio',
                    value: 'url',
                    checked: format === 'url',
                    onChange: this.handleChangeFormatToUrlBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'url_selector_url' },
                    _messages.link
                  ),
                  _react2.default.createElement('input', {
                    id: 'url_selector_file',
                    name: 'url_selector',
                    type: 'radio',
                    value: 'file',
                    checked: format === 'file',
                    onChange: this.handleChangeFormatToFileBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'url_selector_file' },
                    _messages.fileMessage
                  )
                )
              ),
              format === 'url' && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'form-group toggle-field url' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.urlMessage,
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  _react2.default.createElement('input', {
                    id: 'url',
                    name: 'url',
                    type: 'text',
                    className: 'form-control',
                    onChange: this.handleChangeBound
                  }),
                  errorsExist && !url && _react2.default.createElement(
                    'label',
                    {
                      id: 'resourceName-error',
                      className: 'error-text',
                      htmlFor: 'resourceName',
                      style: { display: 'inline-block' }
                    },
                    _messages.fieldRequired
                  ),
                  errorsExist && !(0, _activityedit.isValidLink)(url) && url && url.length > 0 && _react2.default.createElement(
                    'label',
                    {
                      id: 'resourceName-error',
                      className: 'error-text',
                      htmlFor: 'resourceName',
                      style: { display: 'inline-block' }
                    },
                    _messages.urlInvalid
                  ),
                  (0, _resources.isYoutubeLink)(url, resourceType) && _react2.default.createElement(_YoutubeTrimmer2.default, {
                    setStartTimeMinutes: this.onSetYoutubeStartTimeMinutesBound,
                    setStartTimeSeconds: this.onSetYoutubeStartTimeSecondsBound,
                    setEndTimeMinutes: this.onSetYoutubeEndTimeMinutesBound,
                    setEndTimeSeconds: this.onSetYoutubeEndTimeSecondsBound
                  })
                ),
                url && url.length > 0 && _react2.default.createElement(
                  'div',
                  { className: 'form-group active', id: 'urlAttribution' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.attribution
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'attribution-selection' },
                    _react2.default.createElement(
                      'div',
                      { className: 'selector' },
                      _react2.default.createElement('input', {
                        type: 'checkbox',
                        name: 'attributionSelection',
                        id: 'myorg',
                        onChange: this.onAttributionClickBound,
                        checked: attributionSelection === 'myorg'
                      }),
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'myorg' },
                        _messages.attributionInsideOrg
                      )
                    )
                  ),
                  attributionSelection === 'myorg' && _react2.default.createElement(
                    'div',
                    { id: 'insideOrganization' },
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _messages.copyrightHolder
                      ),
                      ':',
                      ' ',
                      organization.name
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _messages.license
                      ),
                      ':\xA0',
                      _messages.attributionAndNoncommercial
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement('div', { className: 'check' }),
                      ' ',
                      _react2.default.createElement(
                        'div',
                        { className: 'done' },
                        _messages.youreDone
                      )
                    )
                  )
                )
              ),
              format === 'file' && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'form-group toggle-field file' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.resourceFile,
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  (!fileName || this.state.isUploadingFile) && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_S3Uploader2.default, {
                      ref: this.S3UploaderRef,
                      presignedUrl: this.state.presignedUrl,
                      uniqueFilename: this.state.uniqueFilename,
                      patchFileUploadInfo: this.props.patchFileUploadInfo,
                      resourceType: resourceType,
                      resourceId: this.state.id,
                      uploadStartHandler: this.onUploadFileStartBound,
                      uploadEndHandler: this.onUploadFileEndBound,
                      uploadAbortHandler: this.onUploadAbortBound,
                      uploadCompleteHandler: this.onUploadCompleteBound
                    }),
                    errorsExist && !file && _react2.default.createElement(
                      'label',
                      {
                        id: 'file-error',
                        className: 'error-text',
                        htmlFor: 'file'
                      },
                      _messages.fieldRequired
                    )
                  )
                ),
                fileName ? this.renderHasFileBound() : ''
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Content Warnings'
              ),
              _react2.default.createElement(
                'p',
                { className: 'content-warnings-link' },
                'Let mentors know that this resource may contain objectionable content. \xA0',
                _react2.default.createElement(
                  'a',
                  {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: 'https://questforward.zendesk.com/hc/en-us/articles/115003486072-Understanding-OE-s-Quality-Review-Guideline#contentwarnings'
                  },
                  'Learn more'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-warnings' },
                  _react2.default.createElement('input', {
                    id: 'content-warnings-true',
                    type: 'radio',
                    checked: hasContentWarnings === true,
                    value: true,
                    onClick: this.onToggleContentWarningsClickBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'content-warnings-true' },
                    'Yes'
                  ),
                  _react2.default.createElement('input', {
                    id: 'content-warnings-false',
                    type: 'radio',
                    checked: hasContentWarnings === false,
                    value: false,
                    onClick: this.onToggleContentWarningsClickBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'content-warnings-false' },
                    'No'
                  )
                )
              ),
              hasContentWarnings && _react2.default.createElement(_ContentWarningsEditor2.default, {
                contentWarnings: content_warnings,
                handleContentWarningClick: this.onSetContentWarningClickBound
              }),
              errorsExist && (0, _activityedit.isMissingContentWarnings)(this.state) && _react2.default.createElement(
                'label',
                {
                  id: 'content_warningsError',
                  className: 'error-text',
                  style: { display: 'inline-block' }
                },
                'Select one or more content warnings.'
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button save-resource btn-primary ' + (this.state.isUploadingFile ? 'disable' : ''),
                    onClick: this.onSaveResourceClickBound
                  },
                  this.state.isUploadingFile ? 'Upload in Progress' : _messages.save
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button cancel-add-resource btn-secondary',
                    onClick: this.onCancelClickBound
                  },
                  _messages.cancel
                ),
                _react2.default.createElement('div', { className: 'placeholder' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderHasFile',
    value: function renderHasFile() {
      var _state2 = this.state,
          resourceType = _state2.resourceType,
          attributionSelection = _state2.attributionSelection,
          fileName = _state2.fileName,
          errorsExist = _state2.errorsExist,
          citation = _state2.citation;
      var organization = this.props.organization;

      return _react2.default.createElement(
        'div',
        null,
        fileName && _react2.default.createElement(
          'div',
          { className: 'image-preview quest-image' },
          _react2.default.createElement(
            'div',
            { className: 'name ' + resourceType },
            (0, _truncateMiddle2.default)(fileName, 40, 40, '...')
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'button remove-file btn-destructive-small',
              onClick: this.onRemoveFileClickBound
            },
            'Remove'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group active', id: 'attribution' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.attribution
          ),
          _react2.default.createElement('div', { className: 'requiredtool' }),
          _react2.default.createElement(
            'div',
            { className: 'attribution-selection' },
            _react2.default.createElement(
              'div',
              { className: 'selector' },
              _react2.default.createElement('input', {
                type: 'radio',
                name: 'attributionSelection',
                id: 'myorg',
                onChange: this.onAttributionClickBound,
                checked: attributionSelection === 'myorg'
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'myorg' },
                _messages.attributionInsideOrg
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'selector' },
              _react2.default.createElement('input', {
                type: 'radio',
                name: 'attributionSelection',
                id: 'outsideorg',
                onChange: this.onAttributionClickBound,
                checked: attributionSelection === 'outsideorg'
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'outsideorg' },
                _messages.attributionOutsideOrg
              )
            ),
            errorsExist && !attributionSelection && _react2.default.createElement(
              'label',
              {
                id: 'attributionSelection-error',
                className: 'error-text',
                htmlFor: 'attributionSelection'
              },
              _messages.fieldRequired
            ),
            attributionSelection === 'myorg' && _react2.default.createElement(
              'div',
              { id: 'insideOrganization' },
              _react2.default.createElement('hr', null),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.copyrightHolder
                ),
                ': ',
                organization.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.license
                ),
                ':\xA0',
                _messages.attributionAndNoncommercial
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement('div', { className: 'check' }),
                ' ',
                _react2.default.createElement(
                  'div',
                  { className: 'done' },
                  _messages.youreDone
                )
              )
            ),
            attributionSelection === 'outsideorg' && _react2.default.createElement(
              'div',
              { id: 'outsideOrganization' },
              _react2.default.createElement('hr', null),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.provideCitation,
                  _react2.default.createElement('div', { className: 'requiredtool' })
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('textarea', {
                  className: 'form-control',
                  id: 'citation',
                  name: 'citation',
                  placeholder: 'Type your citation here.',
                  onChange: this.handleChangeBound
                }),
                errorsExist && !citation && _react2.default.createElement(
                  'label',
                  {
                    id: 'resourceName-error',
                    className: 'error-text',
                    htmlFor: 'resourceName'
                  },
                  _messages.fieldRequired
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleChangeFormatToUrl',
    value: function handleChangeFormatToUrl() {
      if (this.state.fileName && this.state.fileName.length > 0 || this.state.isUploadingFile) {
        var confirmation = window.confirm('Changing resource type to “Link” will remove your existing resource file. Are you sure you want to continue?');
        if (confirmation) {
          if (this.state.isUploadingFile) {
            // abort request, send data for analytics
            this.S3UploaderRef.current.abortRequest('link');
          } else {
            // send callback/data for analytics
            this.props.removeResourceFile(this.state, 'link');
          }
          this.setState({
            format: 'url',
            file: '',
            fileName: '',
            attributionSelection: '',
            citation: ''
          });
        }
      } else {
        this.setState({
          format: 'url',
          file: '',
          fileName: '',
          attributionSelection: '',
          citation: ''
        });
      }
    }
  }, {
    key: 'handleChangeFormatToFile',
    value: function handleChangeFormatToFile() {
      this.setState({
        format: 'file',
        url: '',
        attributionSelection: '',
        startMinutes: null,
        startSeconds: null,
        endMinutes: null,
        endSeconds: null
      });
    }
  }, {
    key: 'onSaveResourceClick',
    value: function onSaveResourceClick() {
      if (!this.state.resourceName || (0, _activityedit.isMissingLinkData)(this.state) || (0, _activityedit.isMissingFileData)(this.state) || (0, _activityedit.isMissingContentWarnings)(this.state)) {
        this.setState({
          errorsExist: true
        });
      } else {
        this.props.editResource(this.state, true);
      }
    }
  }, {
    key: 'onCancelClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var confirmation;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                confirmation = window.confirm('Are you sure you want to cancel? All unsaved work will be lost.');

                if (!confirmation) {
                  _context2.next = 8;
                  break;
                }

                if (!this.state.isUploadingFile) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return this.S3UploaderRef.current.abortRequest('cancel');

              case 5:
                _context2.next = 7;
                return this.props.deleteResource(this.state.id);

              case 7:
                this.props.stopEditResource();

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onCancelClick() {
        return _ref2.apply(this, arguments);
      }

      return onCancelClick;
    }()
  }, {
    key: 'onAttributionClick',
    value: function onAttributionClick(e) {
      // for when URL attribution is unchecked
      if (!e.target.checked) {
        this.setState({
          attributionSelection: ''
        });
      } else {
        this.setState({
          attributionSelection: e.target.id
        });
      }
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'resourceDescription';
      event.target.value = e;
      this.handleChange(event);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState((0, _defineProperty3.default)({}, e.target.id, e.target.value));
    }
  }, {
    key: 'onToggleContentWarningsClick',
    value: function onToggleContentWarningsClick(e) {
      var value = JSON.parse(e.target.value);
      this.setState(function () {
        return {
          hasContentWarnings: value,
          content_warnings: {}
        };
      });
    }
  }, {
    key: 'onSetContentWarningClick',
    value: function onSetContentWarningClick(e) {
      var name = e.target.name;
      var value = e.target.value;
      var checked = e.target.checked;

      if (!value) {
        // for the 'none' radios/values
        this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, null))
          };
        });
        // don't love calling risky_behaviors directly here - should be able to handle other potential new values
      } else if (name !== 'risky_behaviors') {
        if (checked) {
          this.setState(function (state) {
            return {
              content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, { value: value }))
            };
          });
        } else {
          // Need to handle graphic_content, is only one with a input checkbox for 'none' value
          this.setState(function (state) {
            return {
              content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, null))
            };
          });
        }
      } else {
        // for the risky_behaviors - need to handle differently
        checked ? this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, state.content_warnings[name] ? state.content_warnings[name].concat({ value: value }) : [{ value: value }]))
          };
        }) : this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, state.content_warnings[name].filter(function (cw) {
              return cw.value !== value;
            })))
          };
        });
      }
    }
  }, {
    key: 'onResourceTypeChange',
    value: function onResourceTypeChange(e) {
      this.handleChangeBound(e);
    }
  }, {
    key: 'onRemoveFileClick',
    value: function onRemoveFileClick() {
      var confirmation = window.confirm('Are you sure you want to delete this resource file?');
      if (confirmation) {
        this.setState(function () {
          return {
            file: '',
            fileName: '',
            attributionSelection: '',
            citation: '',
            fileRemoved: true
          };
        });
        this.props.removeResourceFile(this.state, 'remove');
      }
    }
  }, {
    key: 'onUploadFileStart',
    value: function onUploadFileStart(file) {
      // send resource and file info to parent analytics method
      this.props.onUploadFileStart(this.state, file);
      this.setState(function () {
        return {
          isUploadingFile: true
        };
      });
    }
  }, {
    key: 'onUploadFileEnd',
    value: function onUploadFileEnd() {
      this.setState(function () {
        return {
          isUploadingFile: false
        };
      });
    }
  }, {
    key: 'onUploadAbort',
    value: function onUploadAbort(_ref3) {
      var file = _ref3.file,
          source = _ref3.source;

      this.setState(function () {
        return {
          isUploadingFile: false
        };
      });
      // send resource, file, and source to parent analytics method
      this.props.onUploadFileAbort(this.state, file, source);
    }
  }, {
    key: 'onUploadComplete',
    value: function onUploadComplete(_ref4) {
      var file = _ref4.file,
          elapsedTime = _ref4.elapsedTime;

      this.props.onUploadComplete(this.state, file, elapsedTime);
    }
  }, {
    key: 'onSetYoutubeStartTimeMinutes',
    value: function onSetYoutubeStartTimeMinutes(minutes) {
      this.setState(function (state) {
        return {
          startMinutes: minutes
        };
      });
    }
  }, {
    key: 'onSetYoutubeStartTimeSeconds',
    value: function onSetYoutubeStartTimeSeconds(seconds) {
      this.setState(function (state) {
        return {
          startSeconds: seconds
        };
      });
    }
  }, {
    key: 'onSetYoutubeEndTimeMinutes',
    value: function onSetYoutubeEndTimeMinutes(minutes) {
      this.setState(function (state) {
        return {
          endMinutes: minutes
        };
      });
    }
  }, {
    key: 'onSetYoutubeEndTimeSeconds',
    value: function onSetYoutubeEndTimeSeconds(seconds) {
      this.setState(function (state) {
        return {
          endSeconds: seconds
        };
      });
    }
  }]);
  return AddResource;
}(_react.Component); /* eslint-disable camelcase */


exports.default = AddResource;


AddResource.propTypes = {
  removeResourceFile: _propTypes2.default.func.isRequired,
  organization: _propTypes2.default.object,
  patchFileUploadInfo: _propTypes2.default.func.isRequired,
  editResource: _propTypes2.default.func.isRequired,
  deleteResource: _propTypes2.default.func.isRequired,
  uploadedResourceFile: _propTypes2.default.string,
  stopEditResource: _propTypes2.default.func.isRequired,
  questId: _propTypes2.default.number.isRequired,
  activityId: _propTypes2.default.number.isRequired,
  resourceId: _propTypes2.default.number.isRequired,
  token: _propTypes2.default.string.isRequired,
  onUploadFileStart: _propTypes2.default.func.isRequired,
  onUploadFileAbort: _propTypes2.default.func.isRequired,
  onUploadComplete: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadMentorFile = function (_Component) {
  (0, _inherits3.default)(UploadMentorFile, _Component);

  function UploadMentorFile(props) {
    (0, _classCallCheck3.default)(this, UploadMentorFile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UploadMentorFile.__proto__ || (0, _getPrototypeOf2.default)(UploadMentorFile)).call(this, props));

    _this.state = {
      file: '',
      description: ''
    };

    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.handleFileUploadBound = _this.handleFileUpload.bind(_this);
    _this.saveNoteBound = _this.saveNote.bind(_this);
    _this.handleCancelBound = _this.handleCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UploadMentorFile, [{
    key: 'render',
    value: function render() {
      var isUploadingNote = this.props.isUploadingNote;


      var modalStyle = {
        width: '880px',
        background: '#fff',
        overflow: 'scroll',
        top: '240px',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%'
      };

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'edit-activity-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle
        },
        _react2.default.createElement(
          'form',
          { id: 'frmMentorNote' },
          _react2.default.createElement(
            'div',
            { className: 'qm-view' },
            _react2.default.createElement(
              'h2',
              null,
              _messages.uploadFileForMentors
            ),
            isUploadingNote ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'form-group file' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.uploadAFile,
                  _react2.default.createElement('div', { className: 'requiredtool' })
                ),
                _react2.default.createElement('input', {
                  type: 'file',
                  id: 'mentorNoteFileInput',
                  onChange: this.handleFileUploadBound
                }),
                _react2.default.createElement(
                  'label',
                  { className: 'file-type-warning' },
                  _messages.videoTypeWarning
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.fileDescription
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement('input', {
                  type: 'text',
                  name: 'description',
                  id: 'description',
                  className: 'form-control',
                  placeholder: 'Write a brief description of this file (optional)',
                  onChange: this.handleDescriptionChangeBound
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom' },
                _react2.default.createElement('div', { className: 'placeholder' }),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button btn-primary save-mentor-note ' + (this.state.file ? '' : 'disabled'),
                    onClick: this.saveNoteBound
                  },
                  _messages.saveFile
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button btn-secondary cancel-add-mentor-note',
                    onClick: this.handleCancelBound
                  },
                  _messages.cancel
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(e) {
      this.setState({
        description: e.target.value
      });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.setState({
        file: '',
        description: ''
      });
      this.props.closeModal();
    }
  }, {
    key: 'handleFileUpload',
    value: function handleFileUpload(e) {
      this.setState({
        file: e.target.files[0]
      });
    }
  }, {
    key: 'saveNote',
    value: function saveNote() {
      this.props.saveMentorNote(this.state);
      this.setState({
        file: '',
        description: ''
      });
    }
  }]);
  return UploadMentorFile;
}(_react.Component);

exports.default = UploadMentorFile;


UploadMentorFile.propTypes = {
  closeModal: _propTypes2.default.func,
  saveMentorNote: _propTypes2.default.func,
  isUploadingNote: _propTypes2.default.bool
};

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _reactIntl = __webpack_require__(16);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditMentorFile = function (_Component) {
  (0, _inherits3.default)(EditMentorFile, _Component);

  function EditMentorFile(props) {
    (0, _classCallCheck3.default)(this, EditMentorFile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EditMentorFile.__proto__ || (0, _getPrototypeOf2.default)(EditMentorFile)).call(this, props));

    _this.state = {
      name: props.note ? props.note.attachment_name : '',
      url: props.note ? props.note.attachment_url : '',
      description: props.note ? props.note.description : '',
      fileType: props.note ? props.note.file_type : '',
      id: props.note ? props.note.id : ''
    };

    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.saveNoteBound = _this.saveNote.bind(_this);
    _this.handleCancelBound = _this.handleCancel.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EditMentorFile, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.note !== this.props.note) {
        this.setState({
          name: nextProps.note.attachment_name,
          url: nextProps.note.attachment_url,
          description: nextProps.note.description,
          fileType: nextProps.note.file_type,
          id: nextProps.note.id
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          name = _state.name,
          url = _state.url,
          description = _state.description,
          fileType = _state.fileType;


      var modalStyle = {
        width: '880px',
        background: '#fff',
        overflow: 'scroll',
        top: '240px',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%'
      };

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'edit-activity-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle
        },
        _react2.default.createElement(
          'form',
          { id: 'frmMentorNote' },
          _react2.default.createElement(
            'div',
            { className: 'qm-view' },
            _react2.default.createElement(
              'h2',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'ActivityEdit.EditMentorFile',
                defaultMessage: 'Edit a File For Mentors'
              })
            ),
            this.props.isUploadingNote ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'form-group file' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  _messages.uploadedFile,
                  _react2.default.createElement('div', { className: 'requiredtool' })
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('div', { className: 'icon ' + fileType }),
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    _react2.default.createElement(
                      'a',
                      { href: url, target: '_blank' },
                      name
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.fileDescription
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement('input', {
                  type: 'text',
                  name: 'description',
                  id: 'description',
                  className: 'form-control',
                  placeholder: 'Write a brief description of this file (optional)',
                  onChange: this.handleDescriptionChangeBound,
                  value: description
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom' },
                _react2.default.createElement('div', { className: 'placeholder' }),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button btn-primary save-mentor-note',
                    onClick: this.saveNoteBound
                  },
                  _messages.saveFile
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button btn-secondary cancel-add-mentor-note',
                    onClick: this.handleCancelBound
                  },
                  _messages.cancel
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(e) {
      this.setState({
        description: e.target.value
      });
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.props.closeModal();
    }
  }, {
    key: 'saveNote',
    value: function saveNote() {
      this.props.editMentorNote(this.state.id, this.state.description);
    }
  }]);
  return EditMentorFile;
}(_react.Component);

exports.default = EditMentorFile;


EditMentorFile.propTypes = {
  closeModal: _propTypes2.default.func,
  note: _propTypes2.default.object,
  editMentorNote: _propTypes2.default.func,
  isUploadingNote: _propTypes2.default.bool
};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(204);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = __webpack_require__(48);

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropModal = __webpack_require__(118);

var _DropModal2 = _interopRequireDefault(_DropModal);

var _truncateMiddle = __webpack_require__(321);

var _truncateMiddle2 = _interopRequireDefault(_truncateMiddle);

var _reactSimplemdeEditor = __webpack_require__(128);

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

var _ContentWarningsEditor = __webpack_require__(463);

var _ContentWarningsEditor2 = _interopRequireDefault(_ContentWarningsEditor);

var _S3Uploader = __webpack_require__(435);

var _S3Uploader2 = _interopRequireDefault(_S3Uploader);

var _YoutubeTrimmer = __webpack_require__(717);

var _YoutubeTrimmer2 = _interopRequireDefault(_YoutubeTrimmer);

var _API = __webpack_require__(718);

var _activityedit = __webpack_require__(434);

var _messages = __webpack_require__(21);

var _markdowneditor = __webpack_require__(142);

var _resources = __webpack_require__(125);

var _time = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Really need to combine this and the AddResource Components, they are basically the same.
/* eslint-disable camelcase */
var EditResource = function (_Component) {
  (0, _inherits3.default)(EditResource, _Component);

  function EditResource(props) {
    (0, _classCallCheck3.default)(this, EditResource);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EditResource.__proto__ || (0, _getPrototypeOf2.default)(EditResource)).call(this, props));

    _this.state = {
      id: props.resourceId,
      resourceName: '',
      resourceDescription: '',
      resourceType: '',
      format: '',
      url: '',
      fileName: '',
      citation: '',
      attributionSelection: '',
      errorsExist: false,
      fileRemoved: false,
      hasContentWarnings: false,
      content_warnings: {},
      presignedUrl: {},
      isUploadingFile: false,
      startMinutes: null,
      startSeconds: null,
      endMinutes: null,
      endSeconds: null,
      fileToRemove: null,
      fileToPatch: null
    };

    _this.handleChangeFormatToUrlBound = _this.handleChangeFormatToUrl.bind(_this);
    _this.handleChangeFormatToFileBound = _this.handleChangeFormatToFile.bind(_this);
    _this.onSaveResourceClickBound = _this.onSaveResourceClick.bind(_this);
    _this.onCancelClickBound = _this.onCancelClick.bind(_this);
    _this.onAttributionClickBound = _this.onAttributionClick.bind(_this);
    _this.handleChangeBound = _this.handleChange.bind(_this);
    _this.handleHideBound = _this.handleHide.bind(_this);
    _this.onRemoveFileClickBound = _this.onRemoveFileClick.bind(_this);
    _this.onToggleContentWarningsClickBound = _this.onToggleContentWarningsClick.bind(_this);
    _this.onSetContentWarningClickBound = _this.onSetContentWarningClick.bind(_this);
    _this.onResourceTypeChangeBound = _this.onResourceTypeChange.bind(_this);
    _this.renderHasFileBound = _this.renderHasFile.bind(_this);
    _this.setPatchFileUploadInfoBound = _this.setPatchFileUploadInfo.bind(_this);
    _this.onUploadFileStartBound = _this.onUploadFileStart.bind(_this);
    _this.onUploadFileEndBound = _this.onUploadFileEnd.bind(_this);
    _this.onUploadAbortBound = _this.onUploadAbort.bind(_this);
    _this.onUploadCompleteBound = _this.onUploadComplete.bind(_this);
    _this.handleDescriptionChangeBound = _this.handleDescriptionChange.bind(_this);
    _this.onSetYoutubeStartTimeMinutesBound = _this.onSetYoutubeStartTimeMinutes.bind(_this);
    _this.onSetYoutubeStartTimeSecondsBound = _this.onSetYoutubeStartTimeSeconds.bind(_this);
    _this.onSetYoutubeEndTimeMinutesBound = _this.onSetYoutubeEndTimeMinutes.bind(_this);
    _this.onSetYoutubeEndTimeSecondsBound = _this.onSetYoutubeEndTimeSeconds.bind(_this);
    _this.S3UploaderRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(EditResource, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var resource;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _API.fetchActivityResource)(this.props.organization.id, this.props.questId, this.props.activityId, this.props.resourceId, this.props.token);

              case 2:
                resource = _context.sent;


                this.refs.modal.show();
                document.getElementsByTagName('html')[0].style.overflow = 'hidden';

                this.setState(function () {
                  return {
                    id: resource.id,
                    resourceName: resource.name,
                    resourceDescription: resource.description,
                    resourceType: resource.resource_type,
                    format: resource.file_name ? 'file' : 'url',
                    url: resource.url,
                    fileName: resource.file_name,
                    citation: resource.license_citation,
                    attributionSelection: resource.license_id ? 'myorg' : 'outsideorg',
                    hasContentWarnings: (0, _keys2.default)(resource.content_warnings).length !== 0,
                    content_warnings: resource.content_warnings,
                    presignedUrl: resource.presigned_url,
                    startMinutes: resource.start_time ? (0, _time.getMinutesFromSeconds)(resource.start_time) : null,
                    startSeconds: resource.start_time ? (0, _time.getRemainingSecondsFromTotalTime)(resource.start_time) : null,
                    endMinutes: resource.end_time ? (0, _time.getMinutesFromSeconds)(resource.end_time) : null,
                    endSeconds: resource.end_time ? (0, _time.getRemainingSecondsFromTotalTime)(resource.end_time) : null,
                    uniqueFilename: resource.unique_upload_file_name
                  };
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.uploadedResourceFile !== this.props.uploadedResourceFile) {
        this.setState(function () {
          return {
            fileName: nextProps.uploadedResourceFile
          };
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflow = 'scroll';
    }
  }, {
    key: 'render',
    value: function render() {
      var modalStyle = {
        maxHeight: 'calc(100% - 100px)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '880px',
        background: '#fff',
        overflow: 'scroll',
        borderRadius: '6px'
      };

      var contentStyle = {
        backgroundColor: '#fff',
        height: '100%'
      };

      var _state = this.state,
          resourceName = _state.resourceName,
          resourceDescription = _state.resourceDescription,
          resourceType = _state.resourceType,
          format = _state.format,
          url = _state.url,
          fileName = _state.fileName,
          errorsExist = _state.errorsExist,
          fileRemoved = _state.fileRemoved,
          file = _state.file,
          hasContentWarnings = _state.hasContentWarnings,
          content_warnings = _state.content_warnings,
          attributionSelection = _state.attributionSelection;
      var organization = this.props.organization;


      var descriptionOptions = (0, _assign2.default)({}, _markdowneditor.italicsOnlyMDEOptions);
      // descriptionOptions.initialValue = resourceDescription
      // descriptionOptions.placeholder = resourceDescription
      descriptionOptions.autofocus = false;

      return _react2.default.createElement(
        _DropModal2.default,
        {
          ref: 'modal',
          className: 'edit-activity-modal',
          modalStyle: modalStyle,
          contentStyle: contentStyle,
          onHide: this.handleHideBound,
          keyboard: false,
          closeOnClick: false
        },
        _react2.default.createElement(
          'div',
          { className: 'modal-dialog', id: 'EditResourceModal' },
          _react2.default.createElement(
            'form',
            { id: 'frmResource', onSubmit: function onSubmit(e) {
                return e.preventDefault();
              } },
            _react2.default.createElement(
              'div',
              { className: 'qm-view' },
              _react2.default.createElement(
                'h2',
                null,
                _react2.default.createElement('span', { className: 'action' }),
                'Edit Resource'
              ),
              _react2.default.createElement(
                'p',
                null,
                _messages.credibleResource,
                '\xA0',
                _react2.default.createElement(
                  'a',
                  {
                    href: 'https://questforward.zendesk.com/hc/en-us/sections/115000870051-Resources-in-Quest-Design',
                    target: '_blank'
                  },
                  _messages.helpCenter
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.name,
                _react2.default.createElement('div', { className: 'requiredtool' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement('input', {
                  type: 'text',
                  name: 'resource_name',
                  id: 'resourceName',
                  className: 'form-control',
                  onChange: this.handleChangeBound,
                  defaultValue: resourceName
                }),
                errorsExist && resourceName.length === 0 && _react2.default.createElement(
                  'label',
                  { className: 'error-text' },
                  _messages.fieldRequired
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.resourceDescriptionMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields', id: 'resourceDescription' },
                _react2.default.createElement(_reactSimplemdeEditor2.default, {
                  value: resourceDescription,
                  options: descriptionOptions,
                  onChange: this.handleDescriptionChangeBound
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.resourceTypeMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'url-selector' },
                  _react2.default.createElement(
                    'select',
                    {
                      id: 'resourceType',
                      className: 'aDropdown',
                      onChange: this.onResourceTypeChangeBound,
                      value: resourceType
                    },
                    _react2.default.createElement(
                      'option',
                      { value: 'audio' },
                      'Audio'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'document' },
                      'Document'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'game_app' },
                      'App'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'image' },
                      'Image'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'presentation' },
                      'Presentation'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'video' },
                      'Video'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'web' },
                      'Web'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: 'simulation' },
                      'Simulation'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _messages.formatMessage
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'url-selector' },
                  _react2.default.createElement('input', {
                    id: 'url_selector_url',
                    name: 'url_selector',
                    type: 'radio',
                    value: 'url',
                    checked: format === 'url',
                    onChange: this.handleChangeFormatToUrlBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'url_selector_url' },
                    _messages.link
                  ),
                  _react2.default.createElement('input', {
                    id: 'url_selector_file',
                    name: 'url_selector',
                    type: 'radio',
                    value: 'file',
                    checked: format === 'file',
                    onChange: this.handleChangeFormatToFileBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'url_selector_file' },
                    _messages.fileMessage
                  )
                )
              ),
              format === 'url' && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'form-group toggle-field url' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.urlMessage,
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  _react2.default.createElement('input', {
                    id: 'url',
                    name: 'url',
                    type: 'text',
                    className: 'form-control',
                    value: url,
                    onChange: this.handleChangeBound
                  }),
                  errorsExist && !url && _react2.default.createElement(
                    'label',
                    {
                      id: 'resourceName-error',
                      className: 'error-text',
                      htmlFor: 'resourceName',
                      style: { display: 'inline-block' }
                    },
                    _messages.fieldRequired
                  ),
                  errorsExist && !(0, _activityedit.isValidLink)(url) && url && url.length > 0 && _react2.default.createElement(
                    'label',
                    {
                      id: 'resourceName-error',
                      className: 'error-text',
                      htmlFor: 'resourceName',
                      style: { display: 'inline-block' }
                    },
                    _messages.urlInvalid
                  ),
                  (0, _resources.isYoutubeLink)(url, resourceType) && _react2.default.createElement(_YoutubeTrimmer2.default, {
                    setStartTimeMinutes: this.onSetYoutubeStartTimeMinutesBound,
                    setStartTimeSeconds: this.onSetYoutubeStartTimeSecondsBound,
                    setEndTimeMinutes: this.onSetYoutubeEndTimeMinutesBound,
                    setEndTimeSeconds: this.onSetYoutubeEndTimeSecondsBound,
                    startTimeMinutes: this.state.startMinutes,
                    startTimeSeconds: this.state.startSeconds,
                    endTimeMinutes: this.state.endMinutes,
                    endTimeSeconds: this.state.endSeconds
                  })
                ),
                url && url.length > 0 && _react2.default.createElement(
                  'div',
                  { className: 'form-group active', id: 'urlAttribution' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.attribution
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'attribution-selection' },
                    _react2.default.createElement(
                      'div',
                      { className: 'selector' },
                      _react2.default.createElement('input', {
                        type: 'checkbox',
                        name: 'attributionSelection',
                        id: 'myorg',
                        onChange: this.onAttributionClickBound,
                        checked: attributionSelection === 'myorg'
                      }),
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'myorg' },
                        _messages.attributionInsideOrg
                      )
                    )
                  ),
                  attributionSelection === 'myorg' && _react2.default.createElement(
                    'div',
                    { id: 'insideOrganization' },
                    _react2.default.createElement('hr', null),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _messages.copyrightHolder
                      ),
                      ':',
                      ' ',
                      organization.name
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        _messages.license
                      ),
                      ':\xA0',
                      _messages.attributionAndNoncommercial
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'wrap' },
                      _react2.default.createElement('div', { className: 'check' }),
                      ' ',
                      _react2.default.createElement(
                        'div',
                        { className: 'done' },
                        _messages.youreDone
                      )
                    )
                  )
                )
              ),
              format === 'file' && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'form-group toggle-field file' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    _messages.resourceFile,
                    _react2.default.createElement('div', { className: 'requiredtool' })
                  ),
                  (!fileName || this.state.isUploadingFile) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_S3Uploader2.default, {
                      ref: this.S3UploaderRef,
                      presignedUrl: this.state.presignedUrl,
                      patchFileUploadInfo: this.setPatchFileUploadInfoBound,
                      resourceType: resourceType,
                      resourceId: this.state.id,
                      uploadStartHandler: this.onUploadFileStartBound,
                      uploadEndHandler: this.onUploadFileEndBound,
                      uploadAbortHandler: this.onUploadAbortBound,
                      uploadCompleteHandler: this.onUploadCompleteBound,
                      uniqueFilename: this.state.uniqueFilename
                    }),
                    errorsExist && fileRemoved && !file && _react2.default.createElement(
                      'label',
                      {
                        id: 'file-error',
                        className: 'error-text',
                        htmlFor: 'file'
                      },
                      _messages.fieldRequired
                    )
                  )
                ),
                fileName ? this.renderHasFileBound() : ''
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Content Warnings'
              ),
              _react2.default.createElement(
                'p',
                { className: 'content-warnings-link' },
                'Let mentors know that this resource may contain objectionable content. \xA0',
                _react2.default.createElement(
                  'a',
                  {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    href: 'https://questforward.zendesk.com/hc/en-us/articles/115003486072-Understanding-OE-s-Quality-Review-Guideline#contentwarnings'
                  },
                  'Learn more'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'edit-fields' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-warnings' },
                  _react2.default.createElement('input', {
                    id: 'content-warnings-true',
                    type: 'radio',
                    checked: hasContentWarnings === true,
                    value: true,
                    onClick: this.onToggleContentWarningsClickBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'content-warnings-true' },
                    'Yes'
                  ),
                  _react2.default.createElement('input', {
                    id: 'content-warnings-false',
                    type: 'radio',
                    checked: hasContentWarnings === false,
                    value: false,
                    onClick: this.onToggleContentWarningsClickBound
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'content-warnings-false' },
                    'No'
                  )
                )
              ),
              hasContentWarnings && _react2.default.createElement(_ContentWarningsEditor2.default, {
                contentWarnings: content_warnings,
                handleContentWarningClick: this.onSetContentWarningClickBound
              }),
              errorsExist && (0, _activityedit.isMissingContentWarnings)(this.state) && _react2.default.createElement(
                'label',
                {
                  id: 'content_warningsError',
                  className: 'error-text',
                  style: { display: 'inline-block' }
                },
                'Select one or more content warnings.'
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button save-resource btn-primary ' + (this.state.isUploadingFile ? 'disable' : ''),
                    onClick: this.onSaveResourceClickBound
                  },
                  this.state.isUploadingFile ? 'Upload in Progress' : _messages.save
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'button cancel-add-resource btn-secondary',
                    onClick: this.onCancelClickBound
                  },
                  _messages.cancel
                ),
                _react2.default.createElement('div', { className: 'placeholder' })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderHasFile',
    value: function renderHasFile() {
      var _state2 = this.state,
          resourceType = _state2.resourceType,
          attributionSelection = _state2.attributionSelection,
          fileName = _state2.fileName,
          errorsExist = _state2.errorsExist,
          citation = _state2.citation;
      var organization = this.props.organization;


      return _react2.default.createElement(
        'div',
        null,
        fileName && _react2.default.createElement(
          'div',
          { className: 'image-preview quest-image' },
          _react2.default.createElement(
            'div',
            { className: 'name ' + resourceType },
            (0, _truncateMiddle2.default)(fileName, 40, 40, '...')
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'button remove-file btn-destructive-small',
              onClick: this.onRemoveFileClickBound
            },
            _messages.remove
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group active', id: 'attribution' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _messages.attribution
          ),
          _react2.default.createElement('div', { className: 'requiredtool' }),
          _react2.default.createElement(
            'div',
            { className: 'attribution-selection' },
            _react2.default.createElement(
              'div',
              { className: 'selector' },
              _react2.default.createElement('input', {
                type: 'radio',
                name: 'attributionSelection',
                id: 'myorg',
                onChange: this.onAttributionClickBound,
                checked: attributionSelection === 'myorg'
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'myorg' },
                _messages.attributionInsideOrg
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'selector' },
              _react2.default.createElement('input', {
                type: 'radio',
                name: 'attributionSelection',
                id: 'outsideorg',
                onChange: this.onAttributionClickBound,
                checked: attributionSelection === 'outsideorg'
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'outsideorg' },
                _messages.attributionOutsideOrg
              )
            ),
            errorsExist && !attributionSelection && _react2.default.createElement(
              'label',
              {
                id: 'attributionSelection-error',
                className: 'error-text',
                htmlFor: 'attributionSelection'
              },
              _messages.fieldRequired
            ),
            attributionSelection === 'myorg' && _react2.default.createElement(
              'div',
              { id: 'insideOrganization' },
              _react2.default.createElement('hr', null),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.copyrightHolder
                ),
                ': ',
                organization.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.license
                ),
                ':\xA0',
                _messages.attributionAndNoncommercial
              ),
              _react2.default.createElement(
                'div',
                { className: 'wrap' },
                _react2.default.createElement('div', { className: 'check' }),
                ' ',
                _react2.default.createElement(
                  'div',
                  { className: 'done' },
                  _messages.youreDone
                )
              )
            ),
            attributionSelection === 'outsideorg' && _react2.default.createElement(
              'div',
              { id: 'outsideOrganization' },
              _react2.default.createElement('hr', null),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  _messages.provideCitation,
                  _react2.default.createElement('div', { className: 'requiredtool' })
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('textarea', {
                  className: 'form-control',
                  id: 'citation',
                  name: 'citation',
                  placeholder: 'Type your citation here.',
                  onChange: this.handleChangeBound,
                  defaultValue: citation !== 'null' ? citation : ''
                }),
                errorsExist && !citation && _react2.default.createElement(
                  'label',
                  {
                    id: 'resourceName-error',
                    className: 'error-text',
                    htmlFor: 'resourceName',
                    style: { display: 'inline-block' }
                  },
                  _messages.fieldRequired
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'handleDescriptionChange',
    value: function handleDescriptionChange(e) {
      // Hacky way to format the event id and value so parent's edit function works
      // The markdown editor makes this trickier than with a standard textfield
      var event = {
        target: {}
      };
      event.target.id = 'resourceDescription';
      event.target.value = e;
      this.handleChange(event);
    }
  }, {
    key: 'handleChangeFormatToUrl',
    value: function handleChangeFormatToUrl() {
      if (this.state.fileName && this.state.fileName.length > 0 || this.state.isUploadingFile) {
        var confirmation = window.confirm('Changing resource type to “Link” will remove your existing resource file. Are you sure you want to continue?');
        if (confirmation) {
          if (this.state.isUploadingFile) {
            // abort request
            this.S3UploaderRef.current.abortRequest('link');
          }
          this.setState(function (state) {
            return {
              format: 'url',
              file: '',
              fileName: '',
              attributionSelection: '',
              citation: '',
              fileRemoved: true,
              fileToRemove: state
            };
          });
        }
      } else {
        this.setState({
          format: 'url',
          file: '',
          fileName: '',
          attributionSelection: '',
          citation: ''
        });
      }
    }
  }, {
    key: 'handleChangeFormatToFile',
    value: function handleChangeFormatToFile() {
      this.setState({
        format: 'file',
        url: '',
        fileRemoved: true,
        attributionSelection: '',
        startMinutes: null,
        startSeconds: null,
        endMinutes: null,
        endSeconds: null
      });
    }
  }, {
    key: 'onSaveResourceClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.state.resourceName || (0, _activityedit.isMissingLinkData)(this.state) || (0, _activityedit.isMissingFileData)(this.state) || (0, _activityedit.isMissingContentWarnings)(this.state))) {
                  _context2.next = 4;
                  break;
                }

                this.setState({
                  errorsExist: true
                });
                _context2.next = 13;
                break;

              case 4:
                if (!this.state.fileToRemove) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return this.props.removeResourceFile(this.state.fileToRemove, 'remove');

              case 7:
                if (!this.state.fileToPatch) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return this.props.patchFileUploadInfo(this.state.fileToPatch);

              case 10:
                _context2.next = 12;
                return this.props.editResource(this.state);

              case 12:
                this.handleHide();

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSaveResourceClick() {
        return _ref2.apply(this, arguments);
      }

      return onSaveResourceClick;
    }()
  }, {
    key: 'onCancelClick',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var confirmation;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.state.isUploadingFile) {
                  _context3.next = 8;
                  break;
                }

                confirmation = window.confirm('Are you sure you want to cancel? All unsaved work will be lost.');

                if (!confirmation) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return this.S3UploaderRef.current.abortRequest('cancel');

              case 5:
                this.handleHide();

              case 6:
                _context3.next = 9;
                break;

              case 8:
                this.handleHide();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onCancelClick() {
        return _ref3.apply(this, arguments);
      }

      return onCancelClick;
    }()
  }, {
    key: 'onAttributionClick',
    value: function onAttributionClick(e) {
      // for when URL attribution is unchecked
      if (!e.target.checked) {
        this.setState({
          attributionSelection: ''
        });
      } else {
        this.setState({
          attributionSelection: e.target.id
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState((0, _defineProperty3.default)({}, e.target.id, e.target.value));
    }
  }, {
    key: 'handleHide',
    value: function handleHide() {
      this.props.stopEditResource();
    }
  }, {
    key: 'onRemoveFileClick',
    value: function onRemoveFileClick() {
      var confirmation = window.confirm('Are you sure you want to delete this resource file?');
      if (confirmation) {
        this.setState(function (state) {
          return {
            file: '',
            fileName: '',
            attributionSelection: '',
            citation: '',
            fileRemoved: true,
            fileToRemove: state
          };
        });
      }
    }
  }, {
    key: 'onToggleContentWarningsClick',
    value: function onToggleContentWarningsClick(e) {
      var value = JSON.parse(e.target.value);
      this.setState(function (state) {
        return {
          hasContentWarnings: value,
          content_warnings: {}
        };
      });
    }
  }, {
    key: 'onSetContentWarningClick',
    value: function onSetContentWarningClick(e) {
      var name = e.target.name;
      var value = e.target.value;
      var checked = e.target.checked;

      if (!value) {
        // for the 'none' radios/values
        this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, null))
          };
        });
        // don't love calling risky_behaviors directly here - should be able to handle other potential new values
      } else if (name !== 'risky_behaviors') {
        if (checked) {
          this.setState(function (state) {
            return {
              content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, { value: value }))
            };
          });
        } else {
          // Need to handle graphic_content, is only one with a input checkbox for 'none' value
          this.setState(function (state) {
            return {
              content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, null))
            };
          });
        }
      } else {
        // for the risky_behaviors - need to handle differently
        checked ? this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, state.content_warnings[name] ? state.content_warnings[name].concat({ value: value }) : [{ value: value }]))
          };
        }) : this.setState(function (state) {
          return {
            content_warnings: (0, _assign2.default)({}, state.content_warnings, (0, _defineProperty3.default)({}, name, state.content_warnings[name].filter(function (cw) {
              return cw.value !== value;
            })))
          };
        });
      }
    }
  }, {
    key: 'onResourceTypeChange',
    value: function onResourceTypeChange(e) {
      this.handleChangeBound(e);
    }
  }, {
    key: 'setPatchFileUploadInfo',
    value: function setPatchFileUploadInfo(file) {
      this.setState(function () {
        return {
          fileToPatch: file,
          fileName: file.original_file_name
        };
      });
    }
  }, {
    key: 'onUploadFileStart',
    value: function onUploadFileStart(file) {
      // send resource and file info to parent analytics method
      this.props.onUploadFileStart(this.state, file);
      this.setState(function () {
        return {
          isUploadingFile: true
        };
      });
    }
  }, {
    key: 'onUploadFileEnd',
    value: function onUploadFileEnd() {
      this.setState(function () {
        return {
          isUploadingFile: false
        };
      });
    }
  }, {
    key: 'onUploadAbort',
    value: function onUploadAbort(_ref4) {
      var file = _ref4.file,
          source = _ref4.source;

      this.setState(function () {
        return {
          isUploadingFile: false
        };
      });
      // send resource, file, and source to parent analytics method
      this.props.onUploadFileAbort(this.state, file, source);
    }
  }, {
    key: 'onUploadComplete',
    value: function onUploadComplete(_ref5) {
      var file = _ref5.file,
          elapsedTime = _ref5.elapsedTime;

      this.props.onUploadComplete(this.state, file, elapsedTime);
    }
  }, {
    key: 'onSetYoutubeStartTimeMinutes',
    value: function onSetYoutubeStartTimeMinutes(minutes) {
      this.setState(function () {
        return {
          startMinutes: minutes
        };
      });
    }
  }, {
    key: 'onSetYoutubeStartTimeSeconds',
    value: function onSetYoutubeStartTimeSeconds(seconds) {
      this.setState(function () {
        return {
          startSeconds: seconds
        };
      });
    }
  }, {
    key: 'onSetYoutubeEndTimeMinutes',
    value: function onSetYoutubeEndTimeMinutes(minutes) {
      this.setState(function () {
        return {
          endMinutes: minutes
        };
      });
    }
  }, {
    key: 'onSetYoutubeEndTimeSeconds',
    value: function onSetYoutubeEndTimeSeconds(seconds) {
      this.setState(function () {
        return {
          endSeconds: seconds
        };
      });
    }
  }]);
  return EditResource;
}(_react.Component);

exports.default = EditResource;


EditResource.propTypes = {
  editResource: _propTypes2.default.func,
  organization: _propTypes2.default.object,
  removeResourceFile: _propTypes2.default.func,
  patchFileUploadInfo: _propTypes2.default.func.isRequired,
  stopEditResource: _propTypes2.default.func.isRequired,
  questId: _propTypes2.default.number.isRequired,
  activityId: _propTypes2.default.number.isRequired,
  resourceId: _propTypes2.default.number.isRequired,
  token: _propTypes2.default.string.isRequired,
  uploadedResourceFile: _propTypes2.default.string,
  onUploadFileStart: _propTypes2.default.func.isRequired,
  onUploadFileAbort: _propTypes2.default.func.isRequired,
  onUploadComplete: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentActivity = undefined;

var _reselect = __webpack_require__(168);

var _currentActivity = function _currentActivity(state) {
  var activityIndex = state.quest.activities.findIndex(function (activity) {
    return activity.id === state.quest.activityId;
  });
  return state.quest.activities[activityIndex];
};

var currentActivity = exports.currentActivity = (0, _reselect.createSelector)([_currentActivity], function (activity) {
  return activity;
});

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityAddContainerDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _reactIntl = __webpack_require__(16);

var _quest = __webpack_require__(66);

var _activity = __webpack_require__(240);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivityAddContainer = function (_Component) {
  (0, _inherits3.default)(ActivityAddContainer, _Component);

  function ActivityAddContainer(props) {
    (0, _classCallCheck3.default)(this, ActivityAddContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivityAddContainer.__proto__ || (0, _getPrototypeOf2.default)(ActivityAddContainer)).call(this, props));

    _this.state = {
      name: ''
    };
    _this.handleNameChangeBound = _this.handleNameChange.bind(_this);
    _this.onCancelClickBound = _this.onCancelClick.bind(_this);
    _this.onCreateActivityClickBound = _this.onCreateActivityClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ActivityAddContainer, [{
    key: 'render',
    value: function render() {
      var isLoading = this.props.isLoading;

      return _react2.default.createElement(
        'div',
        { className: 'row activityadd' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label left', htmlFor: 'activity_name' },
            _messages.name
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement('input', {
              className: 'form-control',
              id: 'activity_name',
              name: 'activity_name',
              type: 'text',
              onChange: this.handleNameChangeBound
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label left', htmlFor: 'activity_name' },
            '\xA0'
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            !isLoading && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                {
                  className: 'button add btn-primary',
                  onClick: this.onCreateActivityClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'ActivityAdd.CreateActivity',
                  defaultMessage: 'Create Activity'
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'button canceladd btn-secondary',
                  onClick: this.onCancelClickBound
                },
                _messages.cancel
              )
            ),
            isLoading && _react2.default.createElement('div', { className: 'loading' })
          )
        )
      );
    }
  }, {
    key: 'handleNameChange',
    value: function handleNameChange(e) {
      this.setState({ name: e.target.value });
    }
  }, {
    key: 'onCancelClick',
    value: function onCancelClick() {
      var _props = this.props,
          dispatch = _props.dispatch,
          quest = _props.quest,
          activityId = _props.activityId;

      dispatch((0, _quest.setQuestSection)('activities', activityId));
      dispatch((0, _reactRouterRedux.push)('/quest/' + quest.id + '/activities/' + activityId));
    }
  }, {
    key: 'onCreateActivityClick',
    value: function onCreateActivityClick() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          quest = _props2.quest;

      dispatch((0, _activity.createActivity)(quest.id, this.state.name));
    }
  }]);
  return ActivityAddContainer;
}(_react.Component);

ActivityAddContainer.propTypes = {
  quest: _propTypes2.default.object,
  activityId: _propTypes2.default.number,
  dispatch: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    quest: state.quest.item,
    activityId: state.quest.activityId,
    isLoading: state.quest.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivityAddContainer);
exports.ActivityAddContainerDisconnected = ActivityAddContainer;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestsAddContainerDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactIntl = __webpack_require__(16);

var _quest = __webpack_require__(66);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestsAddContainer = function (_Component) {
  (0, _inherits3.default)(QuestsAddContainer, _Component);

  function QuestsAddContainer(props) {
    (0, _classCallCheck3.default)(this, QuestsAddContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuestsAddContainer.__proto__ || (0, _getPrototypeOf2.default)(QuestsAddContainer)).call(this, props));

    _this.state = {
      name: '',
      errorsExist: false
    };
    _this.handleNameChangeBound = _this.handleNameChange.bind(_this);
    _this.onCreateQuestClickBound = _this.onCreateQuestClick.bind(_this);
    _this.checkForSubmitBound = _this.checkForSubmit.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuestsAddContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'row questadd' },
        _react2.default.createElement(
          'div',
          { className: 'form-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label left', htmlFor: 'activity_name' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'QuestsAdd.QuestTitle',
              defaultMessage: 'Quest Title'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'right' },
            _react2.default.createElement('input', {
              className: 'form-control',
              id: 'activity_name',
              name: 'activity_name',
              type: 'text',
              onChange: this.handleNameChangeBound,
              onKeyPress: this.checkForSubmitBound
            }),
            this.state.errorsExist && !this.state.name && _react2.default.createElement(
              'label',
              {
                id: 'quest_name-error',
                className: 'error',
                htmlFor: 'quest_name'
              },
              _messages.fieldRequired
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '30px' } },
              !this.props.isFetching ? _react2.default.createElement(
                'div',
                {
                  className: 'button add btn-primary',
                  onClick: this.onCreateQuestClickBound
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'QuestsAdd.CreateQuest',
                  defaultMessage: 'Create Quest'
                })
              ) : _react2.default.createElement('div', { className: 'loading' })
            )
          )
        )
      );
    }
  }, {
    key: 'checkForSubmit',
    value: function checkForSubmit(e) {
      if (e.which === 13 || e.keyCode === 13) {
        this.onCreateQuestClick();
      }
    }
  }, {
    key: 'handleNameChange',
    value: function handleNameChange(e) {
      this.setState({ name: e.target.value });
    }
  }, {
    key: 'onCreateQuestClick',
    value: function onCreateQuestClick() {
      if (!this.state.name) {
        this.setState({ errorsExist: true });
      } else {
        var dispatch = this.props.dispatch;

        dispatch((0, _quest.createQuest)(this.state.name.trim(), this.context.intl));
      }
    }
  }]);
  return QuestsAddContainer;
}(_react.Component);

QuestsAddContainer.propTypes = {
  isFetching: _propTypes2.default.bool.isRequired,
  dispatch: _propTypes2.default.func.isRequired
};

QuestsAddContainer.contextTypes = {
  intl: _propTypes2.default.object.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.quest.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QuestsAddContainer);
exports.QuestsAddContainerDisconnected = QuestsAddContainer; // Pure component for testing

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound() {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotFound, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "not-found" },
        _react2.default.createElement(
          "h2",
          null,
          "Oops!"
        ),
        _react2.default.createElement("br", null),
        _react2.default.createElement(
          "h2",
          null,
          "We weren't able to find what you were looking for."
        )
      );
    }
  }]);
  return NotFound;
}(_react.Component);

exports.default = NotFound;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function (_Component) {
  (0, _inherits3.default)(Error, _Component);

  function Error() {
    (0, _classCallCheck3.default)(this, Error);
    return (0, _possibleConstructorReturn3.default)(this, (Error.__proto__ || (0, _getPrototypeOf2.default)(Error)).apply(this, arguments));
  }

  (0, _createClass3.default)(Error, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "not-found" },
        _react2.default.createElement(
          "h2",
          null,
          "Oops!"
        ),
        _react2.default.createElement("br", null),
        _react2.default.createElement(
          "h2",
          null,
          "We ran into an error processing your request. Please try again."
        )
      );
    }
  }]);
  return Error;
}(_react.Component);

exports.default = Error;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueueContainerDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(90);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _HeaderLockup = __webpack_require__(337);

var _HeaderLockup2 = _interopRequireDefault(_HeaderLockup);

var _NoQuestsAssignedToYou = __webpack_require__(719);

var _NoQuestsAssignedToYou2 = _interopRequireDefault(_NoQuestsAssignedToYou);

var _Quests = __webpack_require__(450);

var _Quests2 = _interopRequireDefault(_Quests);

var _NoQuestsMatchYourSearch = __webpack_require__(458);

var _NoQuestsMatchYourSearch2 = _interopRequireDefault(_NoQuestsMatchYourSearch);

var _QuestsSearchResultsCount = __webpack_require__(456);

var _QuestsSearchResultsCount2 = _interopRequireDefault(_QuestsSearchResultsCount);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _SearchFilters = __webpack_require__(1678);

var _SearchFilters2 = _interopRequireDefault(_SearchFilters);

var _Sort = __webpack_require__(720);

var _Sort2 = _interopRequireDefault(_Sort);

var _queue = __webpack_require__(404);

var _user = __webpack_require__(73);

var _courselevels = __webpack_require__(336);

var _organization = __webpack_require__(338);

var _users = __webpack_require__(217);

var _user2 = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueueContainer = function (_Component) {
  (0, _inherits3.default)(QueueContainer, _Component);

  function QueueContainer(props) {
    (0, _classCallCheck3.default)(this, QueueContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QueueContainer.__proto__ || (0, _getPrototypeOf2.default)(QueueContainer)).call(this, props));

    _this.loadMoreQuestsBound = _this.loadMoreQuests.bind(_this);
    _this.handleSortClickBound = _this.handleSortClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QueueContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _queue.fetchUserAssignments)(1, true));
      this.props.dispatch((0, _user.getUserData)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.orgId !== this.props.orgId) {
        setTimeout(function () {
          _this2.props.dispatch((0, _queue.fetchUserAssignments)(1, true));
          _this2.props.dispatch((0, _user.getUserData)());
        }, 100);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          isFetching = _props.isFetching,
          quests = _props.quests,
          user = _props.user,
          sort = _props.sort,
          stats = _props.stats,
          total = _props.total,
          organization = _props.organization;


      return _react2.default.createElement(
        'div',
        { className: 'queue-container' },
        _react2.default.createElement(_HeaderLockup2.default, {
          avatarComponent: _react2.default.createElement(_UserAvatar2.default, { photoUrl: user.photo.url }),
          organization: organization,
          section: 'Quests Assigned to Me'
        }),
        _react2.default.createElement(
          'div',
          { className: 'queue-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'queue-menu' },
            _react2.default.createElement(_SearchFilters2.default, (0, _extends3.default)({}, this.props, {
              isQuestManager: (0, _user2.isQuestManager)(user)
            }))
          ),
          _react2.default.createElement(
            'div',
            { className: 'queue-body' },
            !isFetching && quests && quests.length > 0 && _react2.default.createElement(_QuestsSearchResultsCount2.default, { totalQuests: total }),
            (isFetching || quests && quests.length > 0) && _react2.default.createElement(_Sort2.default, {
              sort: sort,
              onClick: this.handleSortClickBound,
              desc: 'assignment_updated_at desc',
              asc: 'assignment_updated_at asc'
            }),
            quests && quests.length > 0 && _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
              items: _react2.default.createElement(_Quests2.default, {
                quests: quests,
                dispatch: dispatch,
                user: user,
                iconHeightWidth: 82
              }),
              loadMore: this.loadMoreQuestsBound,
              loadingMore: isFetching,
              elementIsScrollable: false,
              showLoader: false
            }),
            !isFetching && stats && stats.assigned_quests_count === 0 && _react2.default.createElement(_NoQuestsAssignedToYou2.default, null),
            !isFetching && quests && quests.length === 0 && stats && stats.assigned_quests_count > 0 && _react2.default.createElement(_NoQuestsMatchYourSearch2.default, { text: 'No quests assigned to you match your search.' }),
            isFetching && quests && quests.length === 0 && _react2.default.createElement('div', { className: 'loading' })
          )
        )
      );
    }
  }, {
    key: 'loadMoreQuests',
    value: function loadMoreQuests() {
      // Only load more quests if the size of the quest list is less than the totalquest count from the search call
      if (this.props.quests.length < this.props.total) {
        this.props.dispatch((0, _queue.fetchUserAssignments)(this.props.page + 1, false));
      }
    }
  }, {
    key: 'handleSortClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var dispatch;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = this.props.dispatch;
                _context.next = 3;
                return dispatch((0, _queue.setSort)(e.currentTarget.dataset.ref));

              case 3:
                dispatch((0, _queue.fetchUserAssignments)(1, true));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSortClick(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSortClick;
    }()
  }]);
  return QueueContainer;
}(_react.Component);

QueueContainer.propTypes = {
  isFetching: _propTypes2.default.bool,
  quests: _propTypes2.default.array,
  user: _propTypes2.default.object,
  dispatch: _propTypes2.default.func,
  orgId: _propTypes2.default.number,
  authorsFilter: _propTypes2.default.array,
  titleFilter: _propTypes2.default.string,
  qdUsers: _propTypes2.default.array,
  sort: _propTypes2.default.string.isRequired,
  page: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired,
  stats: _propTypes2.default.object.isRequired,
  organization: _propTypes2.default.object,
  draftFilterSelected: _propTypes2.default.bool,
  statusFilters: _propTypes2.default.array,
  allStatusChecked: _propTypes2.default.bool,
  keywordFilter: _propTypes2.default.string.isRequired,
  gradeLevels: _propTypes2.default.array.isRequired,
  gradeFilters: _propTypes2.default.array.isRequired,
  isFetchingGrades: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.queue.isFetching,
    quests: state.queue.items,
    user: state.user.user,
    orgId: state.organization.orgId,
    authorsFilter: state.queuefilters.authors_id_in,
    titleFilter: state.queuefilters.name_or_description_cont,
    qdUsers: (0, _users.getqdUsers)(state),
    sort: state.queue.sort,
    page: state.queue.page,
    total: state.queue.total,
    stats: state.user.stats,
    organization: (0, _organization.currentOrg)(state),
    draftFilterSelected: state.queuefilters.reviewing_compiled_quest_state_null !== null,
    statusFilters: state.queuefilters.reviewing_compiled_quest_state_in || [],
    keywordFilter: state.queuefilters.name_or_description_cont || '',
    allStatusChecked: !state.queuefilters.reviewing_compiled_quest_state_null && state.queuefilters.reviewing_compiled_quest_state_in.length === 0,
    courses: state.mockcourses.items,
    courseFilter: state.queuefilters.mock_course_id_in,
    levelFilters: state.queuefilters.mock_level_id_in || [],
    levels: (0, _courselevels.courseLevels)(state, state.queuefilters.mock_course_id_in),
    gradeLevels: state.gradelevels.items,
    gradeFilters: state.queuefilters.grade_levels_id_in,
    isFetchingGrades: state.gradelevels.isFetching
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(QueueContainer);
exports.QueueContainerDisconnected = QueueContainer; // pure component for testing

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFilters = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _QuestStatusSelect = __webpack_require__(668);

var _QuestStatusSelect2 = _interopRequireDefault(_QuestStatusSelect);

var _KeywordSearch = __webpack_require__(455);

var _KeywordSearch2 = _interopRequireDefault(_KeywordSearch);

var _WrappedSearchFilter = __webpack_require__(335);

var _WrappedSearchFilter2 = _interopRequireDefault(_WrappedSearchFilter);

var _CourseSelect = __webpack_require__(268);

var _CourseSelect2 = _interopRequireDefault(_CourseSelect);

var _queuefilters = __webpack_require__(396);

var _queue = __webpack_require__(404);

var _label = __webpack_require__(148);

var _placeholder = __webpack_require__(150);

var _levels = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFilters = exports.SearchFilters = function (_Component) {
  (0, _inherits3.default)(SearchFilters, _Component);

  function SearchFilters(props) {
    (0, _classCallCheck3.default)(this, SearchFilters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchFilters.__proto__ || (0, _getPrototypeOf2.default)(SearchFilters)).call(this, props));

    _this.onSearchClickBound = _this.onSearchClick.bind(_this);
    _this.onKeywordKeyPressBound = _this.onKeywordKeyPress.bind(_this);
    _this.setStatusFilterBound = _this.setStatusFilter.bind(_this);
    _this.onKeywordKeyPressBound = _this.onKeywordKeyPress.bind(_this);
    _this.onKeywordFilterChangeBound = _this.onKeywordFilterChange.bind(_this);
    _this.onKeywordSearchClickBound = _this.onKeywordSearchClick.bind(_this);
    _this.onClearKeywordSearchClickBound = _this.onClearKeywordSearchClick.bind(_this);
    _this.keywordSearchInput = _react2.default.createRef();
    _this.state = {
      keywordSearched: false
    };
    _this.keywordSearchInput = _react2.default.createRef();
    _this.statusFilterRef = _react2.default.createRef();
    _this.courseFilterRef = _react2.default.createRef();
    _this.levelFilterRef = _react2.default.createRef();
    _this.onSetCourseFilterBound = _this.onSetCourseFilter.bind(_this);
    _this.setLevelFilterBound = _this.setLevelFilter.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SearchFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          qdUsers = _props.qdUsers,
          dispatch = _props.dispatch,
          keywordFilter = _props.keywordFilter,
          authorsFilter = _props.authorsFilter,
          intl = _props.intl,
          draftFilterSelected = _props.draftFilterSelected,
          allStatusChecked = _props.allStatusChecked,
          statusFilters = _props.statusFilters,
          courseFilter = _props.courseFilter,
          courses = _props.courses,
          levels = _props.levels,
          gradeFilters = _props.gradeFilters,
          gradeLevels = _props.gradeLevels,
          isFetchingGrades = _props.isFetchingGrades;

      var intlMessages = {
        authorLabel: intl.formatMessage(_label.messages.author),
        authorPlaceholder: intl.formatMessage(_placeholder.messages.selectAuthors),
        titlePlaceholder: intl.formatMessage(_placeholder.messages.enterTitle),
        targetGradeLevel: intl.formatMessage(_label.messages.targetGradeLevel),
        selectGrades: intl.formatMessage(_placeholder.messages.selectGrades)
      };
      return _react2.default.createElement(
        'div',
        { className: 'search-filters quests-search' },
        _react2.default.createElement(_KeywordSearch2.default, {
          keywordFilter: keywordFilter,
          keywordSearchRef: this.keywordSearchInput,
          onKeywordKeyPress: this.onKeywordKeyPressBound,
          onKeywordFilterChange: this.onKeywordFilterChangeBound,
          keywordSearched: this.state.keywordSearched,
          onClearKeywordSearchClick: this.onClearKeywordSearchClickBound,
          onKeywordSearchClick: this.onKeywordSearchClickBound
        }),
        _react2.default.createElement(
          'div',
          { className: 'caption1', style: { marginBottom: '24px' } },
          'Filter by'
        ),
        _react2.default.createElement(
          'div',
          { className: 'area inputs-wrapper' },
          _react2.default.createElement(_SearchArea2.default, {
            headerClass: 'h5',
            dispatch: dispatch,
            label: intlMessages.authorLabel,
            area: 'author',
            placeholder: intlMessages.authorPlaceholder,
            options: (0, _arraySort2.default)(this.mapList(qdUsers), ['sort']),
            filterAction: _queuefilters.setAuthorsFilter,
            values: authorsFilter,
            fetchAction: _queue.fetchUserAssignments
          }),
          _react2.default.createElement(_SearchArea2.default, {
            headerClass: 'h5',
            dispatch: dispatch,
            label: intlMessages.targetGradeLevel,
            area: 'grades',
            placeholder: intlMessages.selectGrades,
            values: gradeFilters,
            options: (0, _arraySort2.default)(this.mapList(gradeLevels), ['sort']),
            filterAction: _queuefilters.setTargetGradeLevelFilter,
            loading: isFetchingGrades,
            fetchAction: _queue.fetchUserAssignments
          }),
          this.props.isQuestManager && _react2.default.createElement(
            _WrappedSearchFilter2.default,
            {
              area: 'status',
              active: this.props.statusFilters.length > 0 || this.props.draftFilterSelected,
              label: 'Status',
              wrappedRef: this.statusFilterRef
            },
            _react2.default.createElement(_QuestStatusSelect2.default, {
              statusFilterRef: this.statusFilterRef,
              setStatusFilter: this.setStatusFilterBound,
              draftFilterSelected: draftFilterSelected,
              statusFilters: statusFilters,
              allStatusChecked: allStatusChecked,
              dropdownValues: ['allQuests', 'draft', 'reviewReturned']
            })
          ),
          courses.length > 0 && _react2.default.createElement(
            _WrappedSearchFilter2.default,
            {
              area: 'courses',
              active: Boolean(courseFilter),
              label: 'Intended Journey',
              wrappedRef: this.courseFilterRef
            },
            _react2.default.createElement(_CourseSelect2.default, {
              courseFilterRef: this.courseFilterRef,
              course: courseFilter ? courseFilter : null,
              courses: courses,
              onCourseChange: this.onSetCourseFilterBound,
              labelTruncationLength: 999999,
              placeholder: 'Select journey'
            })
          ),
          courseFilter && _react2.default.createElement(
            _WrappedSearchFilter2.default,
            {
              area: 'levels',
              active: this.props.levelFilters.length > 0,
              disabled: levels.length === 0,
              disabledText: 'No levels are available for this journey.',
              label: 'Intended Level',
              wrappedRef: this.levelFilterRef
            },
            _react2.default.createElement(_reactSelect2.default, {
              multi: true,
              ref: this.levelFilterRef,
              searchable: true,
              options: (0, _levels.mapLevels)(levels, 22),
              value: this.props.levelFilters,
              onChange: this.setLevelFilterBound,
              placeholder: 'Select level',
              matchProp: 'label'
            })
          )
        )
      );
    }
  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.sort ? el.sort : el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'onKeywordFilterChange',
    value: function onKeywordFilterChange(e) {
      this.props.dispatch((0, _queuefilters.setKeywordFilter)(e.currentTarget.value));
    }
  }, {
    key: 'onKeywordSearchClick',
    value: function onKeywordSearchClick() {
      this.setState(function () {
        return {
          keywordSearched: true
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onKeywordKeyPress',
    value: function onKeywordKeyPress(e) {
      if (this.props.keywordFilter.length > 0 && (e.which === 13 || e.charCode === 13)) {
        this.onKeywordSearchClickBound();
        this.keywordSearchInput.current.blur();
      }
    }
  }, {
    key: 'onClearKeywordSearchClick',
    value: function onClearKeywordSearchClick() {
      this.props.dispatch((0, _queuefilters.setKeywordFilter)(''));
      this.setState(function () {
        return {
          keywordSearched: false
        };
      });
      this.onSearchClickBound();
    }
  }, {
    key: 'onSearchClick',
    value: function onSearchClick() {
      this.props.dispatch((0, _queue.fetchUserAssignments)(1, true));
    }
  }, {
    key: 'setStatusFilter',
    value: function setStatusFilter(status) {
      if (status.value.length === 0) {
        this.props.dispatch((0, _queuefilters.setDraftFilter)(null));
        this.props.dispatch((0, _queuefilters.setStatusFilter)([]));
        this.onSearchClickBound();
      } else if (status.value.indexOf(1) > -1) {
        this.props.dispatch((0, _queuefilters.setDraftFilter)(1));
        this.props.dispatch((0, _queuefilters.setStatusFilter)([]));
        this.onSearchClickBound();
      } else {
        this.props.dispatch((0, _queuefilters.setStatusFilter)(status.value));
        this.props.dispatch((0, _queuefilters.setDraftFilter)(null));
        this.onSearchClickBound();
      }
    }
  }, {
    key: 'onSetCourseFilter',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _queuefilters.setCourseFilter)(e ? e : null));

              case 2:
                this.onSearchClickBound();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSetCourseFilter(_x) {
        return _ref.apply(this, arguments);
      }

      return onSetCourseFilter;
    }()
  }, {
    key: 'setLevelFilter',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.props.dispatch((0, _queuefilters.setLevelFilter)(event.map(function (e) {
                  return e.value;
                })));
                this.props.dispatch(this.onSearchClickBound);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setLevelFilter(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setLevelFilter;
    }()
  }]);
  return SearchFilters;
}(_react.Component);

SearchFilters.propTypes = {
  keywordFilter: _propTypes2.default.string,
  qdUsers: _propTypes2.default.array,
  dispatch: _propTypes2.default.func,
  authorsFilter: _propTypes2.default.array,
  intl: _propTypes2.default.object.isRequired,
  draftFilterSelected: _propTypes2.default.bool,
  statusFilters: _propTypes2.default.array,
  allStatusChecked: _propTypes2.default.bool,
  isQuestManager: _propTypes2.default.bool.isRequired,
  courses: _propTypes2.default.array,
  courseFilter: _propTypes2.default.object,
  levelFilters: _propTypes2.default.array,
  levels: _propTypes2.default.array,
  gradeFilters: _propTypes2.default.array.isRequired,
  gradeLevels: _propTypes2.default.array.isRequired,
  isFetchingGrades: _propTypes2.default.bool.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(SearchFilters);

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyQuestsDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _DesignANewQuest = __webpack_require__(457);

var _DesignANewQuest2 = _interopRequireDefault(_DesignANewQuest);

var _UserAvatar = __webpack_require__(139);

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _MyQuests = __webpack_require__(1680);

var _MyQuests2 = _interopRequireDefault(_MyQuests);

var _UserStats = __webpack_require__(1684);

var _UserStats2 = _interopRequireDefault(_UserStats);

var _HeaderLockup = __webpack_require__(337);

var _HeaderLockup2 = _interopRequireDefault(_HeaderLockup);

var _user = __webpack_require__(73);

var _myquests = __webpack_require__(298);

var _myquestsfilters = __webpack_require__(394);

var _organization = __webpack_require__(338);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyQuests = function (_Component) {
  (0, _inherits3.default)(MyQuests, _Component);

  function MyQuests(props) {
    (0, _classCallCheck3.default)(this, MyQuests);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyQuests.__proto__ || (0, _getPrototypeOf2.default)(MyQuests)).call(this, props));

    _this.addQuestBound = _this.addQuest.bind(_this);
    _this.onAssignedToMeClickBound = _this.onAssignedToMeClick.bind(_this);
    _this.onDraftsClickBound = _this.onDraftsClick.bind(_this);
    _this.onInQualityReviewClickBound = _this.onInQualityReviewClick.bind(_this);
    _this.onPublishedClickBound = _this.onPublishedClick.bind(_this);
    _this.onSortClickBound = _this.onSortClick.bind(_this);
    _this.fetchQuestsBound = _this.fetchQuests.bind(_this);
    _this.onSearchChangeBound = _this.onSearchChange.bind(_this);
    _this.onSearchClickBound = _this.onSearchClick.bind(_this);
    _this.onClearTitleFilterClickBound = _this.onClearTitleFilterClick.bind(_this);
    _this.onKeyPressBound = _this.onKeyPress.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MyQuests, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _user.getUserData)());
      this.fetchQuests(1, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.orgId !== this.props.orgId) {
        this.fetchQuests(1, true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          filter = _props.filter,
          isLoadingUserData = _props.isLoadingUserData,
          sort = _props.sort,
          isLoadingQuests = _props.isLoadingQuests,
          dispatch = _props.dispatch,
          quests = _props.quests,
          keywordFilter = _props.keywordFilter,
          page = _props.page,
          total = _props.total,
          organization = _props.organization;


      return _react2.default.createElement(
        'div',
        { className: 'myquests-container' },
        _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(_HeaderLockup2.default, {
            avatarComponent: _react2.default.createElement(_UserAvatar2.default, { photoUrl: user.user.photo.url }),
            organization: organization,
            section: 'My Quests'
          }),
          _react2.default.createElement(_DesignANewQuest2.default, { addQuest: this.addQuestBound })
        ),
        !isLoadingUserData && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'myquests-left' },
            _react2.default.createElement(_UserStats2.default, { stats: user.stats })
          ),
          _react2.default.createElement(
            'div',
            { className: 'myquests-main' },
            _react2.default.createElement(_MyQuests2.default, {
              quests: quests,
              stats: user.stats,
              filter: filter,
              sort: sort,
              isLoading: isLoadingQuests,
              handleSortClick: this.onSortClickBound,
              handleAssignmentsClick: this.onAssignedToMeClickBound,
              handleDraftsClick: this.onDraftsClickBound,
              handleInQualityReviewClick: this.onInQualityReviewClickBound,
              handlePublishedClick: this.onPublishedClickBound,
              fetchQuests: this.fetchQuestsBound,
              dispatch: dispatch,
              user: user.user,
              handleSearchChange: this.onSearchChangeBound,
              handleSearchClick: this.onSearchClickBound,
              keywordFilter: keywordFilter,
              clearTitleFilter: this.onClearTitleFilterClickBound,
              handleKeyPress: this.onKeyPressBound,
              page: page,
              total: total,
              addQuest: this.addQuestBound
            })
          )
        ),
        isLoadingUserData && _react2.default.createElement('div', { className: 'loading' })
      );
    }
  }, {
    key: 'addQuest',
    value: function addQuest() {
      this.props.dispatch((0, _reactRouterRedux.push)('/quests/add'));
    }
  }, {
    key: 'onAssignedToMeClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props2, dispatch, user;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, dispatch = _props2.dispatch, user = _props2.user;
                _context.next = 3;
                return dispatch((0, _myquests.setMyQuestsFilter)('assignments'));

              case 3:
                _context.next = 5;
                return dispatch((0, _myquestsfilters.setDraftFilter)([]));

              case 5:
                _context.next = 7;
                return dispatch((0, _myquestsfilters.setStatusFilter)([]));

              case 7:
                _context.next = 9;
                return dispatch((0, _myquestsfilters.setAuthorFilter)([]));

              case 9:
                _context.next = 11;
                return dispatch((0, _myquestsfilters.setAssignedToFilter)([user.user.id]));

              case 11:
                _context.next = 13;
                return dispatch((0, _myquestsfilters.setKeywordFilter)(''));

              case 13:
                this.fetchQuests(1, true);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onAssignedToMeClick() {
        return _ref.apply(this, arguments);
      }

      return onAssignedToMeClick;
    }()
  }, {
    key: 'onDraftsClick',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var _props3, dispatch, user;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props3 = this.props, dispatch = _props3.dispatch, user = _props3.user;
                _context2.next = 3;
                return dispatch((0, _myquests.setMyQuestsFilter)('drafts'));

              case 3:
                _context2.next = 5;
                return dispatch((0, _myquestsfilters.setDraftFilter)([2]));

              case 5:
                _context2.next = 7;
                return dispatch((0, _myquestsfilters.setStatusFilter)([]));

              case 7:
                _context2.next = 9;
                return dispatch((0, _myquestsfilters.setAuthorFilter)([user.user.id]));

              case 9:
                _context2.next = 11;
                return dispatch((0, _myquestsfilters.setAssignedToFilter)([]));

              case 11:
                _context2.next = 13;
                return dispatch((0, _myquestsfilters.setKeywordFilter)(''));

              case 13:
                this.fetchQuests(1, true);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onDraftsClick() {
        return _ref2.apply(this, arguments);
      }

      return onDraftsClick;
    }()
  }, {
    key: 'onInQualityReviewClick',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var _props4, dispatch, user;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props4 = this.props, dispatch = _props4.dispatch, user = _props4.user;
                _context3.next = 3;
                return dispatch((0, _myquests.setMyQuestsFilter)('inQualityReview'));

              case 3:
                _context3.next = 5;
                return dispatch((0, _myquestsfilters.setDraftFilter)([]));

              case 5:
                _context3.next = 7;
                return dispatch((0, _myquestsfilters.setStatusFilter)([0, 4]));

              case 7:
                _context3.next = 9;
                return dispatch((0, _myquestsfilters.setAuthorFilter)([user.user.id]));

              case 9:
                _context3.next = 11;
                return dispatch((0, _myquestsfilters.setAssignedToFilter)([]));

              case 11:
                _context3.next = 13;
                return dispatch((0, _myquestsfilters.setKeywordFilter)(''));

              case 13:
                this.fetchQuests(1, true);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onInQualityReviewClick() {
        return _ref3.apply(this, arguments);
      }

      return onInQualityReviewClick;
    }()
  }, {
    key: 'onPublishedClick',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _props5, dispatch, user;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props5 = this.props, dispatch = _props5.dispatch, user = _props5.user;
                _context4.next = 3;
                return dispatch((0, _myquests.setMyQuestsFilter)('published'));

              case 3:
                _context4.next = 5;
                return dispatch((0, _myquestsfilters.setDraftFilter)([]));

              case 5:
                _context4.next = 7;
                return dispatch((0, _myquestsfilters.setStatusFilter)([5]));

              case 7:
                _context4.next = 9;
                return dispatch((0, _myquestsfilters.setAuthorFilter)([user.user.id]));

              case 9:
                _context4.next = 11;
                return dispatch((0, _myquestsfilters.setAssignedToFilter)([]));

              case 11:
                this.fetchQuests(1, true);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPublishedClick() {
        return _ref4.apply(this, arguments);
      }

      return onPublishedClick;
    }()
  }, {
    key: 'onSortClick',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(e) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.props.dispatch((0, _myquests.setMyQuestsSort)(e.currentTarget.dataset.ref));

              case 2:
                this.fetchQuests(1, true);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onSortClick(_x) {
        return _ref5.apply(this, arguments);
      }

      return onSortClick;
    }()
  }, {
    key: 'fetchQuests',
    value: function fetchQuests(page, clearQuests) {
      this.props.dispatch((0, _myquests.fetchMyQuests)(page, clearQuests));
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange(event) {
      this.props.dispatch((0, _myquestsfilters.setKeywordFilter)(event.target.value));
    }
  }, {
    key: 'onSearchClick',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(keywordFilter) {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.props.dispatch((0, _myquestsfilters.setKeywordFilter)(keywordFilter));

              case 2:
                this.fetchQuests(1, true);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onSearchClick(_x2) {
        return _ref6.apply(this, arguments);
      }

      return onSearchClick;
    }()
  }, {
    key: 'onClearTitleFilterClick',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.props.dispatch((0, _myquestsfilters.setKeywordFilter)(''));

              case 2:
                document.getElementById('myQuestsTitleFilter').value = '';
                this.fetchQuests(1, true);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onClearTitleFilterClick() {
        return _ref7.apply(this, arguments);
      }

      return onClearTitleFilterClick;
    }()
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e, keywordFilter) {
      if (e.which === 13 || e.charCode === 13) {
        this.onSearchClick(keywordFilter);
      }
    }
  }]);
  return MyQuests;
}(_react.Component);

MyQuests.propTypes = {
  user: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  isLoadingQuests: _propTypes2.default.bool.isRequired,
  filter: _propTypes2.default.string.isRequired,
  isLoadingUserData: _propTypes2.default.bool.isRequired,
  sort: _propTypes2.default.string.isRequired,
  quests: _propTypes2.default.array,
  keywordFilter: _propTypes2.default.string,
  page: _propTypes2.default.number,
  total: _propTypes2.default.number,
  orgId: _propTypes2.default.number,
  organization: _propTypes2.default.object
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    isLoadingQuests: state.myquests.isFetchingQuests,
    filter: state.myquests.filter,
    isLoadingUserData: state.user.isLoading,
    sort: state.myquests.sort,
    quests: state.myquests.quests,
    keywordFilter: state.myquestsfilters.name_or_description_cont,
    page: state.myquests.page,
    total: state.myquests.total,
    orgId: state.organization.orgId,
    organization: (0, _organization.currentOrg)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MyQuests);
exports.MyQuestsDisconnected = MyQuests;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(16);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _HeaderTab = __webpack_require__(1681);

var _HeaderTab2 = _interopRequireDefault(_HeaderTab);

var _Quests = __webpack_require__(450);

var _Quests2 = _interopRequireDefault(_Quests);

var _PublishedQuests = __webpack_require__(1682);

var _PublishedQuests2 = _interopRequireDefault(_PublishedQuests);

var _NoQuests = __webpack_require__(1683);

var _NoQuests2 = _interopRequireDefault(_NoQuests);

var _Sort = __webpack_require__(720);

var _Sort2 = _interopRequireDefault(_Sort);

var _messages = __webpack_require__(21);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyQuests = function (_Component) {
  (0, _inherits3.default)(MyQuests, _Component);

  function MyQuests(props) {
    (0, _classCallCheck3.default)(this, MyQuests);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyQuests.__proto__ || (0, _getPrototypeOf2.default)(MyQuests)).call(this, props));

    _this.loadMoreQuestsBound = _this.loadMoreQuests.bind(_this);
    _this.handleSearchClickBound = _this.handleSearchClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MyQuests, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          quests = _props.quests,
          stats = _props.stats,
          isLoading = _props.isLoading,
          filter = _props.filter,
          sort = _props.sort,
          handleAssignmentsClick = _props.handleAssignmentsClick,
          handleDraftsClick = _props.handleDraftsClick,
          handleInQualityReviewClick = _props.handleInQualityReviewClick,
          handlePublishedClick = _props.handlePublishedClick,
          handleSortClick = _props.handleSortClick,
          dispatch = _props.dispatch,
          user = _props.user,
          handleSearchChange = _props.handleSearchChange,
          keywordFilter = _props.keywordFilter,
          clearTitleFilter = _props.clearTitleFilter,
          handleKeyPress = _props.handleKeyPress,
          page = _props.page,
          total = _props.total,
          fetchQuests = _props.fetchQuests;


      return _react2.default.createElement(
        'div',
        { className: 'myquests' },
        _react2.default.createElement(
          'div',
          { className: 'header-tabs' },
          !(0, _user.isQuestManager)(user) && _react2.default.createElement(_HeaderTab2.default, {
            intlLabel: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'MyQuests.MyQuests.AssignedToMe',
              defaultMessage: 'Assigned to Me'
            }),
            klass: 'assigned-to-me-filter filter ' + (filter === 'assignments' ? 'active' : ''),
            clickHandler: handleAssignmentsClick,
            count: stats.assigned_quests_count
          }),
          _react2.default.createElement(_HeaderTab2.default, {
            intlLabel: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'MyQuests.MyQuests.Drafts',
              defaultMessage: 'Draft'
            }),
            klass: 'drafts-filter filter ' + (filter === 'drafts' ? 'active' : ''),
            clickHandler: handleDraftsClick,
            count: stats.draft_quests_count + stats.rejected_quests_count
          }),
          _react2.default.createElement(_HeaderTab2.default, {
            intlLabel: _messages.inQualityReview,
            klass: 'in-quality-review-filter filter ' + (filter === 'inQualityReview' ? 'active' : ''),
            clickHandler: handleInQualityReviewClick,
            count: stats.in_review_quests_count
          }),
          _react2.default.createElement(_HeaderTab2.default, {
            intlLabel: _messages.published,
            klass: 'published-filter filter ' + (filter === 'published' ? 'active' : ''),
            clickHandler: handlePublishedClick,
            count: stats.published_quests_count
          }),
          _react2.default.createElement(_Sort2.default, {
            sort: sort,
            onClick: handleSortClick,
            desc: 'updated_at desc',
            asc: 'updated_at asc'
          })
        ),
        _react2.default.createElement(
          'div',
          { id: 'quests-list', className: filter + '-quests' },
          filter !== 'published' && isLoading && quests.length === 0 && _react2.default.createElement('div', { className: 'loading' }),
          filter === 'published' && _react2.default.createElement(_PublishedQuests2.default, {
            quests: quests,
            handleSearchChange: handleSearchChange,
            handleSearchClick: this.handleSearchClickBound,
            dispatch: dispatch,
            keywordFilter: keywordFilter,
            clearTitleFilter: clearTitleFilter,
            isLoading: isLoading,
            handleKeyPress: handleKeyPress,
            page: page,
            total: total,
            fetchQuests: fetchQuests,
            stats: stats,
            user: user
          }),
          filter !== 'published' && quests && quests.length > 0 && _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
            items: _react2.default.createElement(_Quests2.default, {
              quests: quests,
              dispatch: dispatch,
              user: user,
              navToSection: filter === 'inQualityReview' ? 'questreview' : '',
              iconHeightWidth: 82
            }),
            loadMore: this.loadMoreQuestsBound,
            loadingMore: isLoading,
            elementIsScrollable: false,
            showLoader: false
          }),
          this.renderNoQuests() && _react2.default.createElement(_NoQuests2.default, { section: filter, addQuest: this.props.addQuest })
        )
      );
    }
  }, {
    key: 'loadMoreQuests',
    value: function loadMoreQuests() {
      // Only load more quests if the size of the quest list is less than the totalquest count from the search call
      if (this.props.quests.length < this.props.total) {
        this.props.fetchQuests(this.props.page + 1, false);
      }
    }
  }, {
    key: 'renderNoQuests',
    value: function renderNoQuests() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          quests = _props2.quests,
          filter = _props2.filter,
          keywordFilter = _props2.keywordFilter;

      return !isLoading && quests.length === 0 && (filter !== 'published' || filter === 'published' && keywordFilter.length === 0);
    }
  }, {
    key: 'handleSearchClick',
    value: function handleSearchClick(value) {
      this.props.handleSearchClick(value);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e, value) {
      this.props.handleKeyPress(e, value);
    }
  }]);
  return MyQuests;
}(_react.Component);

exports.default = MyQuests;


MyQuests.propTypes = {
  quests: _propTypes2.default.array,
  stats: _propTypes2.default.object,
  isLoading: _propTypes2.default.bool.isRequired,
  filter: _propTypes2.default.string.isRequired,
  sort: _propTypes2.default.string.isRequired,
  handleAssignmentsClick: _propTypes2.default.func,
  handleDraftsClick: _propTypes2.default.func,
  handleInQualityReviewClick: _propTypes2.default.func,
  handlePublishedClick: _propTypes2.default.func,
  handleSortClick: _propTypes2.default.func,
  fetchQuests: _propTypes2.default.func.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object.isRequired,
  handleSearchChange: _propTypes2.default.func.isRequired,
  handleSearchClick: _propTypes2.default.func.isRequired,
  keywordFilter: _propTypes2.default.string,
  clearTitleFilter: _propTypes2.default.func.isRequired,
  handleKeyPress: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.number,
  total: _propTypes2.default.number,
  addQuest: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderTab = function HeaderTab(props) {
  var formattedAssignedQuestsCount = props.count > 999 ? '999+' : props.count;

  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'a',
      { className: props.klass, onClick: props.clickHandler },
      _react2.default.createElement(
        'div',
        { className: 'header-tab-label' },
        props.intlLabel
      ),
      props.count >= 0 && _react2.default.createElement(
        'div',
        { className: 'count' },
        formattedAssignedQuestsCount
      )
    )
  );
};

HeaderTab.propTypes = {
  intlLabel: _propTypes2.default.element.isRequired,
  klass: _propTypes2.default.string.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  count: _propTypes2.default.number
};

exports.default = HeaderTab;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxInfiniteScrollSf = __webpack_require__(215);

var _reduxInfiniteScrollSf2 = _interopRequireDefault(_reduxInfiniteScrollSf);

var _QuestListItem = __webpack_require__(451);

var _QuestListItem2 = _interopRequireDefault(_QuestListItem);

var _QuestsSearchResultsCount = __webpack_require__(456);

var _QuestsSearchResultsCount2 = _interopRequireDefault(_QuestsSearchResultsCount);

var _messages = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublishedQuests = function (_Component) {
  (0, _inherits3.default)(PublishedQuests, _Component);

  function PublishedQuests(props) {
    (0, _classCallCheck3.default)(this, PublishedQuests);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PublishedQuests.__proto__ || (0, _getPrototypeOf2.default)(PublishedQuests)).call(this, props));

    _this.loadMoreQuestsBound = _this.loadMoreQuests.bind(_this);
    _this.onKeyChangeBound = _this.onKeyChange.bind(_this);
    _this.handleSearchClickBound = _this.handleSearchClick.bind(_this);
    _this.onKeyPressBound = _this.onKeyPress.bind(_this);
    _this.state = {
      keywordFilter: ''
    };
    return _this;
  }

  (0, _createClass3.default)(PublishedQuests, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          clearTitleFilter = _props.clearTitleFilter,
          isLoading = _props.isLoading,
          keywordFilter = _props.keywordFilter,
          total = _props.total,
          stats = _props.stats,
          user = _props.user;

      var quests = this.props.quests.map(function (quest, index) {
        return _react2.default.createElement(_QuestListItem2.default, {
          quest: quest,
          key: index,
          dispatch: dispatch,
          iconHeightWidth: 82,
          user: user
        });
      });

      return _react2.default.createElement(
        'div',
        { className: 'published-quests' },
        stats && stats.published_quests_count > 0 && _react2.default.createElement(
          'div',
          { className: 'search-container' },
          _react2.default.createElement('input', {
            id: 'myQuestsTitleFilter',
            type: 'text',
            placeholder: 'Search your published quests by title',
            onChange: this.onKeyChangeBound,
            defaultValue: keywordFilter,
            onKeyPress: this.onKeyPressBound
          }),
          Boolean(keywordFilter) && _react2.default.createElement('div', { className: 'clear-title-filter', onClick: clearTitleFilter }),
          _react2.default.createElement(
            'div',
            { className: 'button', onClick: this.handleSearchClickBound },
            _messages.search
          )
        ),
        !isLoading && keywordFilter.length > 0 && _react2.default.createElement(_QuestsSearchResultsCount2.default, { totalQuests: total }),
        quests && quests.length > 0 && _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(_reduxInfiniteScrollSf2.default, {
            items: quests,
            loadMore: this.loadMoreQuestsBound,
            loadingMore: isLoading,
            elementIsScrollable: false,
            showLoader: false
          })
        ),
        isLoading && quests.length === 0 && _react2.default.createElement('div', { className: 'loading' })
      );
    }
  }, {
    key: 'loadMoreQuests',
    value: function loadMoreQuests() {
      // Only load more quests if the size of the quest list is less than the totalquest count from the search call
      if (this.props.quests.length < this.props.total) {
        this.props.fetchQuests(this.props.page + 1, false);
      }
    }
  }, {
    key: 'onKeyChange',
    value: function onKeyChange(e) {
      this.setState({
        keywordFilter: e.target.value
      });
    }
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      this.props.handleKeyPress(e, this.state.keywordFilter);
    }
  }, {
    key: 'handleSearchClick',
    value: function handleSearchClick() {
      this.props.handleSearchClick(this.state.keywordFilter);
    }
  }]);
  return PublishedQuests;
}(_react.Component);

exports.default = PublishedQuests;


PublishedQuests.propTypes = {
  handleSearchChange: _propTypes2.default.func.isRequired,
  handleSearchClick: _propTypes2.default.func.isRequired,
  quests: _propTypes2.default.array,
  dispatch: _propTypes2.default.func.isRequired,
  keywordFilter: _propTypes2.default.string,
  clearTitleFilter: _propTypes2.default.func.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  handleKeyPress: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.number,
  total: _propTypes2.default.number,
  fetchQuests: _propTypes2.default.func.isRequired,
  stats: _propTypes2.default.object,
  user: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NoQuestsAssignedToYou = __webpack_require__(719);

var _NoQuestsAssignedToYou2 = _interopRequireDefault(_NoQuestsAssignedToYou);

var _DesignANewQuest = __webpack_require__(457);

var _DesignANewQuest2 = _interopRequireDefault(_DesignANewQuest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoQuests = function (_Component) {
  (0, _inherits3.default)(NoQuests, _Component);

  function NoQuests() {
    (0, _classCallCheck3.default)(this, NoQuests);
    return (0, _possibleConstructorReturn3.default)(this, (NoQuests.__proto__ || (0, _getPrototypeOf2.default)(NoQuests)).apply(this, arguments));
  }

  (0, _createClass3.default)(NoQuests, [{
    key: 'render',
    value: function render() {
      var section = this.props.section;

      return _react2.default.createElement(
        'div',
        { className: 'no-quests ' + section },
        this.renderContent()
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var section = this.props.section;

      var retVal = null;

      switch (section) {
        case 'assignments':
          {
            retVal = _react2.default.createElement(_NoQuestsAssignedToYou2.default, null);
            break;
          }
        case 'drafts':
          {
            retVal = _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                'You have no quests in draft yet. Click on'
              ),
              _react2.default.createElement(_DesignANewQuest2.default, { addQuest: this.props.addQuest }),
              _react2.default.createElement(
                'span',
                null,
                'to begin!'
              )
            );
            break;
          }
        case 'inQualityReview':
          {
            retVal = _react2.default.createElement(
              'span',
              null,
              'You have no quests in publication review yet. Keep working!'
            );
            break;
          }
        case 'published':
          {
            retVal = _react2.default.createElement(
              'span',
              null,
              'You have no published quests yet. Keep working!'
            );
            break;
          }
      }

      return retVal;
    }
  }]);
  return NoQuests;
}(_react.Component);

exports.default = NoQuests;


NoQuests.propTypes = {
  section: _propTypes2.default.string.isRequired,
  addQuest: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserStat = __webpack_require__(1685);

var _UserStat2 = _interopRequireDefault(_UserStat);

var _utils = __webpack_require__(20);

var _userstats = __webpack_require__(472);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserStats = function (_Component) {
  (0, _inherits3.default)(UserStats, _Component);

  function UserStats() {
    (0, _classCallCheck3.default)(this, UserStats);
    return (0, _possibleConstructorReturn3.default)(this, (UserStats.__proto__ || (0, _getPrototypeOf2.default)(UserStats)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserStats, [{
    key: 'render',
    value: function render() {
      var stats = this.props.stats;

      var hasNoCompletedQuests = !(0, _userstats.hasCompletedQuests)(stats);

      return _react2.default.createElement(
        'div',
        { className: 'user-stats' },
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_UserStat2.default, {
          type: 'average_learner_rating',
          value: (0, _utils.displayNumberRoundedToTenth)(stats.average_learner_rating),
          hasNoCompletedQuests: hasNoCompletedQuests
        }),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_UserStat2.default, {
          type: 'average_learner_effort',
          value: (0, _utils.displayNumberRoundedToTenth)(stats.average_learner_effort),
          hasNoCompletedQuests: hasNoCompletedQuests
        }),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_UserStat2.default, {
          type: 'percent_quests_recommended',
          value: (0, _utils.displayNumberAsPercentage)(stats.percent_quests_recommended),
          hasNoCompletedQuests: hasNoCompletedQuests
        }),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_UserStat2.default, {
          type: 'quests_in_progress_by_learners_count',
          value: (0, _userstats.formatQuestCountDisplay)(stats.quests_in_progress_by_learners_count)
        }),
        _react2.default.createElement('div', { className: 'line' }),
        _react2.default.createElement(_UserStat2.default, {
          type: 'quests_completed_by_learners_count',
          value: (0, _userstats.formatQuestCountDisplay)(stats.quests_completed_by_learners_count)
        })
      );
    }
  }]);
  return UserStats;
}(_react.Component);

exports.default = UserStats;


UserStats.propTypes = {
  stats: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _userstats = __webpack_require__(472);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserStat = function UserStat(props) {
  return _react2.default.createElement(
    'div',
    { className: 'user-stat' },
    _react2.default.createElement(_reactTooltip2.default, {
      id: props.type + '-tooltip',
      effect: 'solid',
      offset: { bottom: 35 }
    }),
    _react2.default.createElement('div', { className: 'icon ' + props.type }),
    _react2.default.createElement(
      'div',
      {
        className: 'stat-value',
        'data-for': props.type + '-tooltip',
        'data-tip': _userstats.tooltipText[props.type]
      },
      props.hasNoCompletedQuests ? 'N/A' : props.value
    ),
    _react2.default.createElement(
      'div',
      { className: 'stat-description-container' },
      _react2.default.createElement(
        'div',
        { className: 'stat-description' },
        _userstats.descriptions[props.type]
      )
    )
  );
};

UserStat.propTypes = {
  type: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  hasNoCompletedQuests: _propTypes2.default.bool
};

exports.default = UserStat;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductionStatusDisconnected = exports.mapStateToProps = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  flex: 0;\n  height: fit-content;\n  position: relative;\n'], ['\n  flex: 0;\n  height: fit-content;\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n'], ['\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = __webpack_require__(14);

var _SearchFilters = __webpack_require__(1687);

var _SearchFilters2 = _interopRequireDefault(_SearchFilters);

var _Body = __webpack_require__(1688);

var _Body2 = _interopRequireDefault(_Body);

var _HeaderLockup = __webpack_require__(337);

var _HeaderLockup2 = _interopRequireDefault(_HeaderLockup);

var _OrgAvatar = __webpack_require__(409);

var _OrgAvatar2 = _interopRequireDefault(_OrgAvatar);

var _organization = __webpack_require__(338);

var _productionstatus = __webpack_require__(236);

var _productionstatus2 = __webpack_require__(1700);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ProductionStatus__FiltersContainer',
  componentId: 'cr9b8n-0'
})(_templateObject);

var LevelsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ProductionStatus__LevelsContainer',
  componentId: 'cr9b8n-1'
})(_templateObject2);

var ProductionStatus = function (_React$Component) {
  (0, _inherits3.default)(ProductionStatus, _React$Component);

  function ProductionStatus() {
    (0, _classCallCheck3.default)(this, ProductionStatus);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductionStatus.__proto__ || (0, _getPrototypeOf2.default)(ProductionStatus)).call(this));

    _this.navigateToAllQuestsBound = _this.navigateToAllQuests.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ProductionStatus, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.dispatch((0, _productionstatus.fetchProductionStatusCounts)());
      this.props.dispatch((0, _productionstatus.postViewInfoToLogging)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          organization = _props.organization,
          productionStatusStats = _props.productionStatusStats,
          totalCounts = _props.totalCounts;

      return _react2.default.createElement(
        'div',
        { className: 'production-status' },
        _react2.default.createElement(_HeaderLockup2.default, {
          organization: organization,
          section: 'Production Status',
          avatarComponent: _react2.default.createElement(_OrgAvatar2.default, { organization: organization })
        }),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          _react2.default.createElement(
            FiltersContainer,
            null,
            _react2.default.createElement(_SearchFilters2.default, null)
          ),
          _react2.default.createElement(
            LevelsContainer,
            null,
            this.props.isFetchingCounts || !totalCounts || productionStatusStats.length === 0 ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(_Body2.default, {
              productionStatusStats: productionStatusStats,
              totalCounts: totalCounts,
              dispatch: this.props.dispatch,
              hasActiveFilters: this.props.hasActiveFilters,
              clickHandler: this.navigateToAllQuestsBound,
              levelFilters: this.props.levelFilters
            })
          )
        )
      );
    }
  }, {
    key: 'navigateToAllQuests',
    value: function navigateToAllQuests(options) {
      this.props.dispatch((0, _productionstatus.setAllQuestsFiltersAndNavigate)(options));
    }
  }]);
  return ProductionStatus;
}(_react2.default.Component);

ProductionStatus.propTypes = {
  organization: _propTypes2.default.object,
  dispatch: _propTypes2.default.func.isRequired,
  productionStatusStats: _propTypes2.default.array.isRequired,
  totalCounts: _propTypes2.default.object,
  isFetchingCounts: _propTypes2.default.bool.isRequired,
  hasActiveFilters: _propTypes2.default.bool.isRequired,
  levelFilters: _propTypes2.default.array.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    organization: (0, _organization.currentOrg)(state),
    list: state.productionstatus.list,
    courses: state.mockcourses.items,
    productionStatusStats: (0, _productionstatus2.getProuductionStatusStats)(state),
    totalCounts: state.productionstatus.totalCounts,
    isFetchingCounts: state.productionstatus.isFetchingCounts,
    hasActiveFilters: (0, _productionstatus2.hasActiveFilters)(state),
    levelFilters: state.productionstatusfilters.mock_level_id_in || []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ProductionStatus);
exports.ProductionStatusDisconnected = ProductionStatus;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchFiltersDisconnected = exports.mapStateToProps = undefined;

var _regenerator = __webpack_require__(17);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(18);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactIntl = __webpack_require__(16);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _SearchArea = __webpack_require__(216);

var _SearchArea2 = _interopRequireDefault(_SearchArea);

var _CourseSelect = __webpack_require__(268);

var _CourseSelect2 = _interopRequireDefault(_CourseSelect);

var _WrappedSearchFilter = __webpack_require__(335);

var _WrappedSearchFilter2 = _interopRequireDefault(_WrappedSearchFilter);

var _productionstatus = __webpack_require__(236);

var _productionstatusfilters = __webpack_require__(397);

var _label = __webpack_require__(148);

var _placeholder = __webpack_require__(150);

var _users = __webpack_require__(217);

var _courselevels = __webpack_require__(336);

var _levels = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFilters = function (_Component) {
  (0, _inherits3.default)(SearchFilters, _Component);

  function SearchFilters(props) {
    (0, _classCallCheck3.default)(this, SearchFilters);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchFilters.__proto__ || (0, _getPrototypeOf2.default)(SearchFilters)).call(this, props));

    _this.onSearchClickBound = _this.onSearchClick.bind(_this);
    _this.courseFilterRef = _react2.default.createRef();
    _this.levelFilterRef = _react2.default.createRef();
    _this.onSetCourseFilterBound = _this.onSetCourseFilter.bind(_this);
    _this.setLevelFilterBound = _this.setLevelFilter.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SearchFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          isFetchingUsers = _props.isFetchingUsers,
          tags = _props.tags,
          isFetchingTags = _props.isFetchingTags,
          authorFilters = _props.authorFilters,
          tagFilters = _props.tagFilters,
          primarySubjectFilters = _props.primarySubjectFilters,
          isFetchingSubjects = _props.isFetchingSubjects,
          primarySubjects = _props.primarySubjects,
          assignedToFilters = _props.assignedToFilters,
          qdUsers = _props.qdUsers,
          assignedUsers = _props.assignedUsers,
          gradeLevels = _props.gradeLevels,
          isFetchingGrades = _props.isFetchingGrades,
          gradeFilters = _props.gradeFilters,
          intl = _props.intl,
          courses = _props.courses,
          courseFilter = _props.courseFilter,
          levelFilters = _props.levelFilters,
          levels = _props.levels;


      var labelMessages = {
        author: intl.formatMessage(_label.messages.author),
        tags: intl.formatMessage(_label.messages.tags),
        primarySubject: intl.formatMessage(_label.messages.primarySubject),
        assignedTo: intl.formatMessage(_label.messages.assignedTo),
        status: intl.formatMessage(_label.messages.status),
        targetGradeLevel: intl.formatMessage(_label.messages.targetGradeLevel)
      };

      var placeholderMessages = {
        selectAuthors: intl.formatMessage(_placeholder.messages.selectAuthors),
        selectTags: intl.formatMessage(_placeholder.messages.selectTags),
        selectSubject: intl.formatMessage(_placeholder.messages.selectSubject),
        selectColleagues: intl.formatMessage(_placeholder.messages.selectColleagues),
        selectGrades: intl.formatMessage(_placeholder.messages.selectGrades)
      };

      return _react2.default.createElement(
        'div',
        { className: 'quests-search' },
        _react2.default.createElement(
          'div',
          { className: 'filter-by-container' },
          _react2.default.createElement(
            'div',
            { className: 'caption1 filter-by-caption' },
            'Filter by'
          ),
          _react2.default.createElement(
            'div',
            { className: 'area inputs-wrapper' },
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.author,
              area: 'author',
              placeholder: placeholderMessages.selectAuthors,
              values: authorFilters,
              options: (0, _arraySort2.default)(this.mapList(qdUsers), ['sort']),
              filterAction: _productionstatusfilters.setAuthorsFilter,
              loading: isFetchingUsers,
              fetchAction: _productionstatus.fetchProductionStatusCounts
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.assignedTo,
              area: 'assigned-to',
              placeholder: placeholderMessages.selectColleagues,
              values: assignedToFilters,
              options: (0, _arraySort2.default)(this.mapList(assignedUsers), ['sort']),
              filterAction: _productionstatusfilters.setAssignedToFilters,
              loading: isFetchingUsers,
              fetchAction: _productionstatus.fetchProductionStatusCounts
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.tags,
              area: 'tags',
              placeholder: placeholderMessages.selectTags,
              values: tagFilters,
              options: (0, _arraySort2.default)(this.mapList(tags), ['sort']),
              filterAction: _productionstatusfilters.setTagFilters,
              loading: isFetchingTags,
              fetchAction: _productionstatus.fetchProductionStatusCounts
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.primarySubject,
              area: 'subjects',
              placeholder: placeholderMessages.selectSubject,
              values: primarySubjectFilters,
              options: (0, _arraySort2.default)(this.mapList(primarySubjects), ['sort']),
              filterAction: _productionstatusfilters.setPrimarySubjectFilter,
              loading: isFetchingSubjects,
              fetchAction: _productionstatus.fetchProductionStatusCounts
            }),
            _react2.default.createElement(_SearchArea2.default, {
              headerClass: 'h5',
              dispatch: dispatch,
              label: labelMessages.targetGradeLevel,
              area: 'grades',
              placeholder: placeholderMessages.selectGrades,
              values: gradeFilters,
              options: (0, _arraySort2.default)(this.mapList(gradeLevels), ['sort']),
              filterAction: _productionstatusfilters.setTargetGradeLevelFilter,
              loading: isFetchingGrades,
              fetchAction: _productionstatus.fetchProductionStatusCounts
            }),
            courses.length > 0 && _react2.default.createElement(
              _WrappedSearchFilter2.default,
              {
                area: 'courses',
                active: Boolean(this.props.courseFilter),
                label: 'Intended Journey',
                wrappedRef: this.courseFilterRef
              },
              _react2.default.createElement(_CourseSelect2.default, {
                courseFilterRef: this.courseFilterRef,
                course: courseFilter ? courseFilter : null,
                courses: courses,
                onCourseChange: this.onSetCourseFilterBound,
                labelTruncationLength: 99999,
                placeholder: 'Select journey'
              })
            ),
            courseFilter && _react2.default.createElement(
              _WrappedSearchFilter2.default,
              {
                area: 'levels',
                active: this.props.levelFilters.length > 0,
                disabled: levels.length === 0,
                disabledText: 'No levels are available for this journey.',
                label: 'Intended Level',
                wrappedRef: this.levelFilterRef
              },
              _react2.default.createElement(_reactSelect2.default, {
                multi: true,
                ref: this.levelFilterRef,
                searchable: true,
                options: (0, _levels.mapLevels)(levels, 22),
                value: levelFilters,
                onChange: this.setLevelFilterBound,
                placeholder: 'Select level',
                matchProp: 'label'
              })
            )
          )
        )
      );
    }
  }, {
    key: 'onSearchClick',
    value: function onSearchClick() {
      this.props.dispatch((0, _productionstatus.fetchProductionStatusCounts)(1, true));
    }

    // TODO: similar method in other components. use a util

  }, {
    key: 'mapList',
    value: function mapList(arr) {
      return arr.map(function (el) {
        return {
          value: el.id,
          label: el.name,
          sort: el.sort ? el.sort : el.name.trim().toLowerCase()
        };
      });
    }
  }, {
    key: 'onSetCourseFilter',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.dispatch((0, _productionstatusfilters.setCourseFilter)(e ? e : null));

              case 2:
                this.onSearchClickBound();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSetCourseFilter(_x) {
        return _ref.apply(this, arguments);
      }

      return onSetCourseFilter;
    }()
  }, {
    key: 'setLevelFilter',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.props.dispatch((0, _productionstatusfilters.setLevelFilter)(event.map(function (e) {
                  return e.value;
                })));
                this.props.dispatch(this.onSearchClickBound);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setLevelFilter(_x2) {
        return _ref2.apply(this, arguments);
      }

      return setLevelFilter;
    }()
  }]);
  return SearchFilters;
}(_react.Component);

SearchFilters.propTypes = {
  dispatch: _propTypes2.default.func,
  qdUsers: _propTypes2.default.array.isRequired,
  assignedUsers: _propTypes2.default.array.isRequired,
  isFetchingUsers: _propTypes2.default.bool,
  tags: _propTypes2.default.array.isRequired,
  isFetchingTags: _propTypes2.default.bool,
  authorFilters: _propTypes2.default.array,
  tagFilters: _propTypes2.default.array,
  statusFilters: _propTypes2.default.array,
  primarySubjectFilters: _propTypes2.default.array,
  primarySubjects: _propTypes2.default.array,
  isFetchingSubjects: _propTypes2.default.bool,
  assignedToFilters: _propTypes2.default.array,
  gradeLevels: _propTypes2.default.array,
  isFetchingGrades: _propTypes2.default.bool,
  gradeFilters: _propTypes2.default.array,
  intl: _propTypes2.default.object.isRequired,
  courses: _propTypes2.default.array,
  courseFilter: _propTypes2.default.object,
  levelFilters: _propTypes2.default.array,
  levels: _propTypes2.default.array
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    users: state.users.items,
    qdUsers: (0, _users.getqdUsers)(state),
    assignedUsers: (0, _users.assignedUsers)(state),
    isFetchingUsers: state.users.isFetching,
    tags: state.tags.items,
    isFetchingTags: state.tags.isFetching,
    authorFilters: state.productionstatusfilters.authors_id_in || [],
    tagFilters: state.productionstatusfilters.questtags_id_in || [],
    draftFilterSelected: state.productionstatusfilters.reviewing_compiled_quest_state_null !== null,
    primarySubjects: state.subjects.items,
    primarySubjectFilters: state.productionstatusfilters.quest_subject_id_in || [],
    isFetchingSubjects: state.subjects.isFetching,
    assignedToFilters: state.productionstatusfilters.assigned_to_id_in,
    gradeLevels: state.gradelevels.items,
    isFetchingGrades: state.gradelevels.isFetching,
    gradeFilters: state.productionstatusfilters.grade_levels_id_in,
    courses: state.mockcourses.items,
    courseFilter: state.productionstatusfilters.mock_course_id_in || null,
    levelFilters: state.productionstatusfilters.mock_level_id_in || [],
    levels: (0, _courselevels.courseLevels)(state, state.productionstatusfilters.mock_course_id_in)
  };
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)(SearchFilters));
exports.SearchFiltersDisconnected = SearchFilters; // pure component - for tests

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Courses = __webpack_require__(1689);

var _Courses2 = _interopRequireDefault(_Courses);

var _TotalsSection = __webpack_require__(1697);

var _TotalsSection2 = _interopRequireDefault(_TotalsSection);

var _Caption = __webpack_require__(716);

var _Caption2 = _interopRequireDefault(_Caption);

var _NoQuestsMatchYourSearch = __webpack_require__(458);

var _NoQuestsMatchYourSearch2 = _interopRequireDefault(_NoQuestsMatchYourSearch);

var _productionstatus = __webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body(props) {
  return props.hasActiveFilters && (0, _productionstatus.hasNoQuests)(props.productionStatusStats) ? _react2.default.createElement(_NoQuestsMatchYourSearch2.default, { text: 'No quests match your search.' }) : _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_TotalsSection2.default, { totalCounts: props.totalCounts }),
    _react2.default.createElement(
      'div',
      { style: { marginBottom: '15px' } },
      _react2.default.createElement(
        _Caption2.default,
        { style: { marginLeft: '21px', display: 'inline-block' } },
        'Intended Journeys'
      ),
      _react2.default.createElement(
        _Caption2.default,
        { style: { marginLeft: '101px', display: 'inline-block' } },
        'Total Quests'
      )
    ),
    _react2.default.createElement(_Courses2.default, {
      productionStatusStats: props.productionStatusStats,
      dispatch: props.dispatch,
      hasActiveFilters: props.hasActiveFilters,
      clickHandler: props.clickHandler,
      levelFilters: props.levelFilters
    })
  );
};

Body.propTypes = {
  productionStatusStats: _propTypes2.default.array.isRequired,
  totalCounts: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  hasActiveFilters: _propTypes2.default.bool.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  levelFilters: _propTypes2.default.array.isRequired
};

exports.default = Body;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 866px;\n  border-radius: 7px;\n  background-color: #f8f8f8;\n  overflow: hidden;\n\n  > li:nth-child(odd) {\n    background-color: #ffffff;\n  }\n\n  > li:first-of-type {\n    border-radius: 7px 7px 0 0;\n  }\n\n  > li:last-of-type {\n    border-radius: 0 0 7px 7px;\n  }\n'], ['\n  width: 866px;\n  border-radius: 7px;\n  background-color: #f8f8f8;\n  overflow: hidden;\n\n  > li:nth-child(odd) {\n    background-color: #ffffff;\n  }\n\n  > li:first-of-type {\n    border-radius: 7px 7px 0 0;\n  }\n\n  > li:last-of-type {\n    border-radius: 0 0 7px 7px;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Course = __webpack_require__(1690);

var _Course2 = _interopRequireDefault(_Course);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoursesContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Courses__CoursesContainer',
  componentId: 'sc-1izm0ux-0'
})(_templateObject);

var Courses = function Courses(props) {
  var filteredStats = props.productionStatusStats;
  if (props.hasActiveFilters) {
    filteredStats = filteredStats.filter(function (s) {
      return s.total_count > 0;
    });
  }
  var courses = filteredStats.map(function (item) {
    return _react2.default.createElement(_Course2.default, {
      key: 'course-' + item.course_id,
      course: item,
      dispatch: props.dispatch,
      clickHandler: props.clickHandler,
      levelFilters: props.levelFilters
    });
  });

  return _react2.default.createElement(
    CoursesContainer,
    null,
    courses
  );
};

Courses.propTypes = {
  productionStatusStats: _propTypes2.default.array.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  hasActiveFilters: _propTypes2.default.bool.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  levelFilters: _propTypes2.default.array.isRequired
};

exports.default = Courses;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  height: 73px;\n'], ['\n  display: flex;\n  align-items: center;\n  height: 73px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  flex: 0 0 72px;\n  padding-bottom: 10px;\n  flex-direction: column;\n  margin-right: 10px;\n  box-sizing: border-box;\n  max-width: 72px;\n'], ['\n  flex: 0 0 72px;\n  padding-bottom: 10px;\n  flex-direction: column;\n  margin-right: 10px;\n  box-sizing: border-box;\n  max-width: 72px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  right: 28px;\n  top: 58px;\n'], ['\n  position: absolute;\n  right: 28px;\n  top: 58px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  justify-content: center;\n  flex-direction: column;\n  flex: 0 0 232px;\n  padding: 0 9px 0 22px;\n'], ['\n  justify-content: center;\n  flex-direction: column;\n  flex: 0 0 232px;\n  padding: 0 9px 0 22px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  font-weight: ', ';\n'], ['\n  font-weight: ', ';\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  border-top: ', ';\n  border-bottom: ', ';\n\n  &:first-of-type {\n    border-top: none;\n  }\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n'], ['\n  position: relative;\n  border-top: ', ';\n  border-bottom: ', ';\n\n  &:first-of-type {\n    border-top: none;\n  }\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  white-space: nowrap;\n'], ['\n  white-space: nowrap;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Levels = __webpack_require__(1691);

var _Levels2 = _interopRequireDefault(_Levels);

var _StatusCountBar = __webpack_require__(481);

var _StatusCountBar2 = _interopRequireDefault(_StatusCountBar);

var _Styled = __webpack_require__(721);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(1694);

var _Caption4 = _interopRequireDefault(_Caption3);

var _Caption5 = __webpack_require__(1695);

var _Caption6 = _interopRequireDefault(_Caption5);

var _H = __webpack_require__(61);

var _H2 = _interopRequireDefault(_H);

var _Intro = __webpack_require__(1696);

var _Intro2 = _interopRequireDefault(_Intro);

var _P = __webpack_require__(681);

var _P2 = _interopRequireDefault(_P);

var _string = __webpack_require__(124);

var _numbers = __webpack_require__(482);

var _productionstatus = __webpack_require__(236);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Course__CourseWrapper',
  componentId: 'sc-19c64sb-0'
})(_templateObject);

var StatsCountWrapper = (0, _styledComponents2.default)(_Styled.TotalContainer).withConfig({
  displayName: 'Course__StatsCountWrapper',
  componentId: 'sc-19c64sb-1'
})(_templateObject2);

var StatusCountBarContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Course__StatusCountBarContainer',
  componentId: 'sc-19c64sb-2'
})(_templateObject3);

var StyledNameContainer = (0, _styledComponents2.default)(_Styled.NameContainer).withConfig({
  displayName: 'Course__StyledNameContainer',
  componentId: 'sc-19c64sb-3'
})(_templateObject4);

var StyledCaption1 = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'Course__StyledCaption1',
  componentId: 'sc-19c64sb-4'
})(_templateObject5, function (props) {
  return props.bold ? '500' : '300';
});

var CourseRow = _styledComponents2.default.li.withConfig({
  displayName: 'Course__CourseRow',
  componentId: 'sc-19c64sb-5'
})(_templateObject6, function (props) {
  return props.expanded ? '1px solid #DEDFE0' : 'none';
}, function (props) {
  return props.expanded ? '1px solid #DEDFE0' : 'none';
});

var StyledCaption5 = (0, _styledComponents2.default)(_Caption6.default).withConfig({
  displayName: 'Course__StyledCaption5',
  componentId: 'sc-19c64sb-6'
})(_templateObject7);

var Course = function (_React$Component) {
  (0, _inherits3.default)(Course, _React$Component);

  function Course() {
    (0, _classCallCheck3.default)(this, Course);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Course.__proto__ || (0, _getPrototypeOf2.default)(Course)).call(this));

    _this.state = {
      expanded: false,
      hovered: false
    };

    _this.onCourseClickBound = _this.onCourseClick.bind(_this);
    _this.onCourseHoverBound = _this.onCourseHover.bind(_this);
    _this.onCourseLeaveHoverBound = _this.onCourseLeaveHover.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Course, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          course = _props.course,
          clickHandler = _props.clickHandler;


      return _react2.default.createElement(
        CourseRow,
        { expanded: this.state.expanded },
        _react2.default.createElement(
          CourseWrapper,
          null,
          _react2.default.createElement(
            StyledNameContainer,
            {
              style: { paddingLeft: '21px' },
              onClick: this.onCourseClickBound,
              onMouseEnter: this.onCourseHoverBound,
              onMouseLeave: this.onCourseLeaveHoverBound,
              onFocus: this.onCourseHoverBound,
              onBlur: this.onCourseLeaveHoverBound
            },
            _react2.default.createElement(
              _Caption4.default,
              {
                style: {
                  color: '#' + course.color,
                  backgroundColor: 'unset'
                }
              },
              (0, _string.getTruncatedString)({
                val: course.course_name,
                len: 50
              })
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              _react2.default.createElement(
                StyledCaption1,
                { bold: this.state.expanded || this.state.hovered },
                course.course_levels.length + ' Levels'
              ),
              (this.state.hovered || this.state.expanded) && _react2.default.createElement('div', {
                className: 'expand-arrow ' + (this.state.expanded ? 'expanded' : '')
              })
            )
          ),
          _react2.default.createElement(
            _Styled.TotalContainer,
            {
              style: { marginRight: '8px' },
              onClick: function onClick() {
                return clickHandler({
                  course: course
                });
              }
            },
            _react2.default.createElement(
              _H2.default,
              null,
              (0, _numbers.formatNumberForThreeDigits)(course.total_count)
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              onClick: function onClick() {
                return clickHandler({
                  status: 'draft',
                  course: course
                });
              }
            },
            _react2.default.createElement(
              _Intro2.default,
              null,
              (0, _numbers.formatNumberForThreeDigits)(course.draft_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              null,
              'Draft'
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              onClick: function onClick() {
                return clickHandler({
                  status: 'exp/sub',
                  course: course
                });
              }
            },
            _react2.default.createElement(
              _P2.default,
              { style: { paddingTop: '10px' } },
              (0, _numbers.formatNumberForThreeDigits)(course.internal_review_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              { style: { paddingTop: '1px' } },
              'Experience/Subject'
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              onClick: function onClick() {
                return clickHandler({
                  status: 'copy edit',
                  course: course
                });
              }
            },
            _react2.default.createElement(
              _P2.default,
              { style: { paddingTop: '10px' } },
              (0, _numbers.formatNumberForThreeDigits)(course.copy_edit_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              { style: { paddingTop: '1px' } },
              'Copy Edit'
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              onClick: function onClick() {
                return clickHandler({
                  status: 'review returned',
                  course: course
                });
              },
              style: { marginRight: '22px' }
            },
            _react2.default.createElement(
              _Intro2.default,
              null,
              (0, _numbers.formatNumberForThreeDigits)(course.rejected_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              null,
              'Review Returned'
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              onClick: function onClick() {
                return clickHandler({
                  status: 'quality review',
                  course: course
                });
              },
              style: { marginRight: '22px' }
            },
            _react2.default.createElement(
              _Intro2.default,
              null,
              (0, _numbers.formatNumberForThreeDigits)(course.quality_review_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              null,
              'Publication Review'
            )
          ),
          _react2.default.createElement(
            StatsCountWrapper,
            {
              style: { marginRight: '13px' },
              onClick: function onClick() {
                return clickHandler({
                  status: 'published',
                  course: course
                });
              }
            },
            _react2.default.createElement(
              _Intro2.default,
              null,
              (0, _numbers.formatNumberForThreeDigits)(course.published_count)
            ),
            _react2.default.createElement(
              StyledCaption5,
              null,
              'Published'
            )
          )
        ),
        _react2.default.createElement(
          StatusCountBarContainer,
          null,
          _react2.default.createElement(_StatusCountBar2.default, {
            draftCount: course.draft_count,
            rejectedCount: course.rejected_count,
            qualityReviewCount: course.quality_review_count,
            publishedCount: course.published_count,
            totalCount: course.total_count,
            width: 480,
            height: 8
          })
        ),
        this.state.expanded && _react2.default.createElement(_Levels2.default, {
          course: course,
          levels: course.course_levels,
          color: course.color,
          clickHandler: clickHandler,
          levelFilters: this.props.levelFilters
        })
      );
    }
  }, {
    key: 'onCourseClick',
    value: function onCourseClick() {
      // if current state is !expanded, log analytics event
      if (!this.state.expanded) {
        this.props.dispatch((0, _productionstatus.logLevelsExpandClick)(this.props.course));
      }
      this.setState(function (state) {
        return {
          expanded: !state.expanded
        };
      });
    }
  }, {
    key: 'onCourseHover',
    value: function onCourseHover() {
      this.setState(function (state) {
        return {
          hovered: true
        };
      });
    }
  }, {
    key: 'onCourseLeaveHover',
    value: function onCourseLeaveHover() {
      this.setState(function (state) {
        return {
          hovered: false
        };
      });
    }
  }]);
  return Course;
}(_react2.default.Component);

Course.propTypes = {
  course: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  levelFilters: _propTypes2.default.array.isRequired
};

exports.default = Course;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background-color: inherit;\n  width: 866px;\n  padding: 21px 0;\n  border-top: 1px solid #dedfe0;\n'], ['\n  background-color: inherit;\n  width: 866px;\n  padding: 21px 0;\n  border-top: 1px solid #dedfe0;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Level = __webpack_require__(1692);

var _Level2 = _interopRequireDefault(_Level);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Levels__LevelsContainer',
  componentId: 'sc-1vmeyjc-0'
})(_templateObject);

var Levels = function Levels(props) {
  var filteredLevels = props.levels;
  if (props.levelFilters.length > 0) {
    filteredLevels = filteredLevels.filter(function (l) {
      return props.levelFilters.includes(l.mock_level_id);
    });
  }
  var list = filteredLevels.map(function (item) {
    return _react2.default.createElement(_Level2.default, {
      key: 'level-' + item.mock_level_id,
      level: item,
      color: props.color,
      course: props.course,
      clickHandler: props.clickHandler
    });
  });

  return _react2.default.createElement(
    LevelsContainer,
    null,
    list
  );
};

Levels.propTypes = {
  levels: _propTypes2.default.array.isRequired,
  color: _propTypes2.default.string.isRequired,
  course: _propTypes2.default.object.isRequired,
  clickHandler: _propTypes2.default.func.isRequired,
  levelFilters: _propTypes2.default.array.isRequired
};

exports.default = Levels;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  height: 70px;\n  position: relative;\n'], ['\n  display: flex;\n  align-items: center;\n  height: 70px;\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  right: 41px;\n  top: 42px;\n'], ['\n  position: absolute;\n  right: 41px;\n  top: 42px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  align-items: center;\n  flex: 0 0 209px;\n  padding: 0 15px 0 38px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  align-items: center;\n  flex: 0 0 209px;\n  padding: 0 15px 0 38px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  padding-bottom: 22px;\n'], ['\n  padding-bottom: 22px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 18px;\n  max-width: 63px;\n'], ['\n  margin-right: 18px;\n  max-width: 63px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  color: black;\n  padding-left: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n'], ['\n  color: black;\n  padding-left: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  color: black;\n  padding-bottom: 22px;\n'], ['\n  color: black;\n  padding-bottom: 22px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LevelIcon = __webpack_require__(1693);

var _LevelIcon2 = _interopRequireDefault(_LevelIcon);

var _StatusCountBar = __webpack_require__(481);

var _StatusCountBar2 = _interopRequireDefault(_StatusCountBar);

var _Styled = __webpack_require__(721);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _P = __webpack_require__(315);

var _P2 = _interopRequireDefault(_P);

var _numbers = __webpack_require__(482);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelWrapper = _styledComponents2.default.li.withConfig({
  displayName: 'Level__LevelWrapper',
  componentId: 'gwl7y4-0'
})(_templateObject);

var StatusCountBarContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Level__StatusCountBarContainer',
  componentId: 'gwl7y4-1'
})(_templateObject2);

var StyledLevelNameContainer = (0, _styledComponents2.default)(_Styled.NameContainer).withConfig({
  displayName: 'Level__StyledLevelNameContainer',
  componentId: 'gwl7y4-2'
})(_templateObject3);

var StyledP1 = (0, _styledComponents2.default)(_P2.default).withConfig({
  displayName: 'Level__StyledP1',
  componentId: 'gwl7y4-3'
})(_templateObject4);

var StyledTotalContainer = (0, _styledComponents2.default)(_Styled.TotalContainer).withConfig({
  displayName: 'Level__StyledTotalContainer',
  componentId: 'gwl7y4-4'
})(_templateObject5);

var StyledCaption1 = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'Level__StyledCaption1',
  componentId: 'gwl7y4-5'
})(_templateObject6);

var DraftSubStatusCounts = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'Level__DraftSubStatusCounts',
  componentId: 'gwl7y4-6'
})(_templateObject7);

var Level = function Level(props) {
  return _react2.default.createElement(
    LevelWrapper,
    null,
    _react2.default.createElement(
      StyledLevelNameContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(_LevelIcon2.default, props),
      _react2.default.createElement(
        StyledCaption1,
        null,
        props.level.name
      )
    ),
    _react2.default.createElement(
      _Styled.TotalContainer,
      {
        style: { marginRight: '13px' },
        onClick: function onClick() {
          return props.clickHandler({
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(
        _H2.default,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.total_count)
      )
    ),
    _react2.default.createElement(
      StyledTotalContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            status: 'draft',
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(
        StyledP1,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.draft_count)
      )
    ),
    _react2.default.createElement(
      StyledTotalContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            status: 'exp/sub',
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(
        DraftSubStatusCounts,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.internal_review_count)
      )
    ),
    _react2.default.createElement(
      StyledTotalContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            status: 'copy edit',
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(
        DraftSubStatusCounts,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.copy_edit_count)
      )
    ),
    _react2.default.createElement(
      StyledTotalContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            status: 'review returned',
            course: props.course,
            level: props.level
          });
        },
        style: { marginRight: '33px' }
      },
      _react2.default.createElement(
        StyledP1,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.rejected_count)
      )
    ),
    _react2.default.createElement(
      StyledTotalContainer,
      {
        onClick: function onClick() {
          return props.clickHandler({
            status: 'quality review',
            course: props.course,
            level: props.level
          });
        },
        style: { marginRight: '27px' }
      },
      _react2.default.createElement(
        StyledP1,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.quality_review_count)
      )
    ),
    _react2.default.createElement(
      _Styled.TotalContainer,
      {
        style: { marginRight: '19px' },
        onClick: function onClick() {
          return props.clickHandler({
            status: 'published',
            course: props.course,
            level: props.level
          });
        }
      },
      _react2.default.createElement(
        StyledP1,
        null,
        (0, _numbers.formatNumberForThreeDigits)(props.level.published_count)
      )
    ),
    _react2.default.createElement(
      StatusCountBarContainer,
      null,
      _react2.default.createElement(_StatusCountBar2.default, {
        draftCount: props.level.draft_count,
        rejectedCount: props.level.rejected_count,
        qualityReviewCount: props.level.quality_review_count,
        publishedCount: props.level.published_count,
        totalCount: props.level.total_count,
        width: 460,
        height: 7
      })
    )
  );
};

Level.propTypes = {
  level: _propTypes2.default.object.isRequired,
  color: _propTypes2.default.string.isRequired,
  course: _propTypes2.default.object.isRequired,
  clickHandler: _propTypes2.default.func.isRequired
};

exports.default = Level;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  flex: 0 0 39px;\n  border-radius: 5.6px;\n  display: inline-block;\n  line-height: 39px;\n'], ['\n  flex: 0 0 39px;\n  border-radius: 5.6px;\n  display: inline-block;\n  line-height: 39px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  height: 10px;\n  background-color: ', ';\n  border-radius: 5.6px 5.6px 0 0;\n'], ['\n  width: 100%;\n  height: 10px;\n  background-color: ', ';\n  border-radius: 5.6px 5.6px 0 0;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: white;\n  box-sizing: border-box;\n  height: 28px;\n  width: 100%;\n  border: 1.12px solid #dedfe0;\n  border-top: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0 0 5.6px 5.6px;\n'], ['\n  background: white;\n  box-sizing: border-box;\n  height: 28px;\n  width: 100%;\n  border: 1.12px solid #dedfe0;\n  border-top: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0 0 5.6px 5.6px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _P = __webpack_require__(315);

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelIconContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LevelIcon__LevelIconContainer',
  componentId: 'sc-13uibjt-0'
})(_templateObject);

var LevelIconTop = _styledComponents2.default.div.withConfig({
  displayName: 'LevelIcon__LevelIconTop',
  componentId: 'sc-13uibjt-1'
})(_templateObject2, function (props) {
  return '#' + props.color;
});

var LevelIconBody = _styledComponents2.default.div.withConfig({
  displayName: 'LevelIcon__LevelIconBody',
  componentId: 'sc-13uibjt-2'
})(_templateObject3);

var LevelIcon = function LevelIcon(_ref) {
  var color = _ref.color,
      level = _ref.level;
  return _react2.default.createElement(
    LevelIconContainer,
    null,
    _react2.default.createElement(LevelIconTop, { color: color }),
    _react2.default.createElement(
      LevelIconBody,
      null,
      _react2.default.createElement(
        _P2.default,
        null,
        level.number
      )
    )
  );
};

LevelIcon.propTypes = {
  level: _propTypes2.default.object.isRequired,
  color: _propTypes2.default.string.isRequired
};

exports.default = LevelIcon;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 5px;\n  background-color: #c0c7c7;\n'], ['\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 5px;\n  background-color: #c0c7c7;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption2 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption2',
  componentId: 'sc-5v83lj-0'
})(_templateObject);

exports.default = Caption2;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #666666;\n  font-size: 11px;\n  font-weight: 300;\n'], ['\n  color: #666666;\n  font-size: 11px;\n  font-weight: 300;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption5 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption5',
  componentId: 'zubxsm-0'
})(_templateObject);

exports.default = Caption5;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #000000;\n  font-size: 22px;\n'], ['\n  color: #000000;\n  font-size: 22px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intro2 = _styledComponents2.default.div.withConfig({
  displayName: 'Intro2',
  componentId: 'nxbojw-0'
})(_templateObject);

exports.default = Intro2;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  width: 620px;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 42px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: 620px;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 42px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  bottom: -27px;\n  white-space: nowrap;\n  pointer-events: none;\n'], ['\n  position: absolute;\n  bottom: -27px;\n  white-space: nowrap;\n  pointer-events: none;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 262px;\n  padding-right: 17px;\n  border-radius: 5px;\n  justify-content: space-between;\n  background-color: rgba(0, 0, 0, 0.05);\n  flex-direction: row;\n'], ['\n  width: 262px;\n  padding-right: 17px;\n  border-radius: 5px;\n  justify-content: space-between;\n  background-color: rgba(0, 0, 0, 0.05);\n  flex-direction: row;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  color: #ffffff;\n  display: inline-block;\n'], ['\n  color: #ffffff;\n  display: inline-block;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  display: inline-block;\n  color: #ffffff;\n  margin-left: 3px;\n'], ['\n  display: inline-block;\n  color: #ffffff;\n  margin-left: 3px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _TotalBox = __webpack_require__(1698);

var _TotalBox2 = _interopRequireDefault(_TotalBox);

var _StatusCountBar = __webpack_require__(481);

var _StatusCountBar2 = _interopRequireDefault(_StatusCountBar);

var _H = __webpack_require__(1699);

var _H2 = _interopRequireDefault(_H);

var _H3 = __webpack_require__(61);

var _H4 = _interopRequireDefault(_H3);

var _H5 = __webpack_require__(85);

var _H6 = _interopRequireDefault(_H5);

var _P = __webpack_require__(315);

var _P2 = _interopRequireDefault(_P);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _numbers = __webpack_require__(482);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalTotalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TotalsSection__TotalTotalContainer',
  componentId: 'sc-14kosj7-0'
})(_templateObject);

var OtherTotalsContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TotalsSection__OtherTotalsContainer',
  componentId: 'sc-14kosj7-1'
})(_templateObject2);

var OtherTotalContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TotalsSection__OtherTotalContainer',
  componentId: 'sc-14kosj7-2'
})(_templateObject3);

var StyledCaption1 = (0, _styledComponents2.default)(_Caption2.default).withConfig({
  displayName: 'TotalsSection__StyledCaption1',
  componentId: 'sc-14kosj7-3'
})(_templateObject4);

var DraftTotalsContainer = (0, _styledComponents2.default)(OtherTotalContainer).withConfig({
  displayName: 'TotalsSection__DraftTotalsContainer',
  componentId: 'sc-14kosj7-4'
})(_templateObject5);

var SubDraftStatusTotalLabel = (0, _styledComponents2.default)(_P2.default).withConfig({
  displayName: 'TotalsSection__SubDraftStatusTotalLabel',
  componentId: 'sc-14kosj7-5'
})(_templateObject6);

var SubDraftStatusTotalAsterisk = (0, _styledComponents2.default)(_H6.default).withConfig({
  displayName: 'TotalsSection__SubDraftStatusTotalAsterisk',
  componentId: 'sc-14kosj7-6'
})(_templateObject7);

var TotalsSection = function TotalsSection(_ref) {
  var totalCounts = _ref.totalCounts;
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', width: '100%' } },
    _react2.default.createElement(
      'div',
      { style: { paddingRight: '110px' } },
      _react2.default.createElement(
        _H4.default,
        {
          style: {
            paddingBottom: '10px',
            color: '#444444'
          }
        },
        'Total Quests'
      ),
      _react2.default.createElement(
        TotalTotalContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          null,
          (0, _numbers.formatNumberForThreeDigits)(totalCounts.totalTotal)
        )
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        OtherTotalsContainer,
        null,
        _react2.default.createElement(
          DraftTotalsContainer,
          null,
          _react2.default.createElement(
            _TotalBox2.default,
            {
              background: '#999999',
              tooltipId: 'draft-total-tootlip',
              tooltipText: _react2.default.createElement(
                'span',
                null,
                'Number of quests currently in Draft. This includes those considered to be in Experience/Subject',
                _react2.default.createElement(
                  'sup',
                  null,
                  '*'
                ),
                ' and Copy Edit',
                _react2.default.createElement(
                  'sup',
                  null,
                  '*'
                ),
                '.'
              )
            },
            _react2.default.createElement(
              _H4.default,
              { style: { color: 'white' } },
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.draftTotal)
            ),
            _react2.default.createElement(
              StyledCaption1,
              null,
              'Draft'
            )
          ),
          _react2.default.createElement(
            _TotalBox2.default,
            {
              background: '#999999',
              small: true,
              tooltipId: 'experience-subject-total-tootlip',
              tooltipText: _react2.default.createElement(
                'span',
                null,
                '*\xA0Number of quests currently assigned to a quest manager with Experience and/or Subject not checked as complete.'
              )
            },
            _react2.default.createElement(
              SubDraftStatusTotalLabel,
              null,
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.internalReviewTotal),
              _react2.default.createElement(
                SubDraftStatusTotalAsterisk,
                null,
                _react2.default.createElement(
                  'sup',
                  null,
                  '*'
                )
              )
            ),
            _react2.default.createElement(
              StyledCaption1,
              { style: { bottom: '-38px' } },
              'Experience/Subject\xA0',
              _react2.default.createElement(
                'sup',
                null,
                '*'
              )
            )
          ),
          _react2.default.createElement(
            _TotalBox2.default,
            {
              background: '#999999',
              small: true,
              tooltipId: 'copy-edit-total-tootlip',
              tooltipText: _react2.default.createElement(
                'span',
                null,
                '*\xA0Number of quests that have Experience and Subject checked as complete with only Copy remaining.'
              )
            },
            _react2.default.createElement(
              SubDraftStatusTotalLabel,
              null,
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.copyEditTotal),
              _react2.default.createElement(
                SubDraftStatusTotalAsterisk,
                null,
                _react2.default.createElement(
                  'sup',
                  null,
                  '*'
                )
              )
            ),
            _react2.default.createElement(
              StyledCaption1,
              { style: { bottom: '-38px' } },
              'Copy Edit\xA0',
              _react2.default.createElement(
                'sup',
                null,
                '*'
              )
            )
          )
        ),
        _react2.default.createElement(
          OtherTotalContainer,
          null,
          _react2.default.createElement(
            _TotalBox2.default,
            {
              style: { marginLeft: '30px' },
              background: 'repeating-linear-gradient(45deg, #999999, #999999 5px, black 6px, black 6px)'
            },
            _react2.default.createElement(
              _H4.default,
              { style: { color: 'white' } },
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.rejectedTotal)
            ),
            _react2.default.createElement(
              StyledCaption1,
              null,
              'Review Returned'
            )
          )
        ),
        _react2.default.createElement(
          OtherTotalContainer,
          null,
          _react2.default.createElement(
            _TotalBox2.default,
            { style: { marginLeft: '30px' }, background: '#000000' },
            _react2.default.createElement(
              _H4.default,
              { style: { color: 'white' } },
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.qualityReviewTotal)
            ),
            _react2.default.createElement(
              StyledCaption1,
              null,
              'Publication Review'
            )
          )
        ),
        _react2.default.createElement(
          OtherTotalContainer,
          null,
          _react2.default.createElement(
            _TotalBox2.default,
            { style: { marginLeft: '30px' }, background: '#00bc80' },
            _react2.default.createElement(
              _H4.default,
              { style: { color: 'white' } },
              (0, _numbers.formatNumberForThreeDigits)(totalCounts.publishedTotal)
            ),
            _react2.default.createElement(
              StyledCaption1,
              null,
              'Published'
            )
          )
        )
      ),
      _react2.default.createElement(_StatusCountBar2.default, {
        draftCount: totalCounts.draftTotal,
        rejectedCount: totalCounts.rejectedTotal,
        qualityReviewCount: totalCounts.qualityReviewTotal,
        publishedCount: totalCounts.publishedTotal,
        totalCount: totalCounts.totalTotal,
        width: 621,
        height: 10
      })
    )
  );
};

TotalsSection.propTypes = {
  totalCounts: _propTypes2.default.object.isRequired
};

exports.default = TotalsSection;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(4);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(5);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: ', ';\n  width: ', ';\n  border-radius: 5px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n'], ['\n  height: ', ';\n  width: ', ';\n  border-radius: 5px;\n  background: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: 244px;\n'], ['\n  width: 244px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(679);

var _server2 = _interopRequireDefault(_server);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TotalBoxContainer = _styledComponents2.default.div.withConfig({
  displayName: 'TotalBox__TotalBoxContainer',
  componentId: 'sc-1wgyvyw-0'
})(_templateObject, function (props) {
  return props.small ? '43px' : '66px';
}, function (props) {
  return props.small ? '43px' : '66px';
}, function (props) {
  return props.background;
});

var StyledTooltip = (0, _styledComponents2.default)(_reactTooltip2.default).withConfig({
  displayName: 'TotalBox__StyledTooltip',
  componentId: 'sc-1wgyvyw-1'
})(_templateObject2);

var TotalBox = function (_React$Component) {
  (0, _inherits3.default)(TotalBox, _React$Component);

  function TotalBox() {
    (0, _classCallCheck3.default)(this, TotalBox);
    return (0, _possibleConstructorReturn3.default)(this, (TotalBox.__proto__ || (0, _getPrototypeOf2.default)(TotalBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(TotalBox, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        TotalBoxContainer,
        {
          background: this.props.background,
          small: this.props.small,
          style: this.props.style,
          'data-for': this.props.tooltipId,
          'data-tip': _server2.default.renderToStaticMarkup(this.props.tooltipText),
          'data-html': true
        },
        _react2.default.createElement(StyledTooltip, { id: this.props.tooltipId, effect: 'solid' }),
        this.props.children
      );
    }
  }]);
  return TotalBox;
}(_react2.default.Component);

TotalBox.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  background: _propTypes2.default.string.isRequired,
  small: _propTypes2.default.bool,
  tooltipId: _propTypes2.default.string,
  tooltipText: _propTypes2.default.string,
  style: _propTypes2.default.symbol
};

exports.default = TotalBox;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: #263746;\n  font-size: 34px;\n  font-weight: 500;\n'], ['\n  color: #263746;\n  font-size: 34px;\n  font-weight: 500;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H1 = _styledComponents2.default.div.withConfig({
  displayName: 'H1',
  componentId: 'sc-3bdoir-0'
})(_templateObject);

exports.default = H1;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasActiveFilters = exports.getProuductionStatusStats = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _reselect = __webpack_require__(168);

var _productionstatus = __webpack_require__(401);

var _productionstatusfilters = __webpack_require__(554);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getProuductionStatusStats = function _getProuductionStatusStats(state) {
  // get all the levels with stats (an array of level objects)
  var productionStatusLevels = state.productionstatus.items;
  // filter out all the courses that have no levels and iterate through each mock course
  return state.mockcourses.items.filter(function (mc) {
    return mc.mock_levels.length > 0;
  }).map(function (mc) {
    // for each mock course, map through each of their levels and find all the associated ones from the production status endpoint
    var courseLevels = mc.mock_levels.map(function (l) {
      var associatedProductionStatusLevel = productionStatusLevels.find(function (psl) {
        return psl.mock_level_id === l.id;
      });
      // need to see if we found an associated level. if so, add the other data, and pass in all the other data. if not, construct one with zero counts and add the other data
      return associatedProductionStatusLevel ? (0, _assign2.default)({}, associatedProductionStatusLevel, {
        name: l.name,
        number: l.number,
        sort_order: l.sort_order,
        master: l.mastery
      }) : {
        name: l.name,
        mock_level_id: l.id,
        number: l.number,
        draft_count: 0,
        published_count: 0,
        quality_review_count: 0,
        rejected_count: 0,
        total_count: 0,
        internal_review_count: 0,
        copy_edit_count: 0,
        sort_order: l.sort_order,
        master: l.mastery
      };
    });
    // return the formatted course with all levels counts and levels
    return {
      course_name: mc.name,
      course_id: mc.id,
      color: mc.color,
      course_levels: courseLevels,
      total_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('total_count'), 0),
      published_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('published_count'), 0),
      quality_review_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('quality_review_count'), 0),
      rejected_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('rejected_count'), 0),
      draft_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('draft_count'), 0),
      internal_review_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('internal_review_count'), 0),
      copy_edit_count: courseLevels.reduce((0, _productionstatus.getAttrCount)('copy_edit_count'), 0)
    };
  });
};

var _hasActiveFilters = function _hasActiveFilters(state) {
  return (0, _stringify2.default)(_productionstatusfilters.initialState) !== (0, _stringify2.default)(state.productionstatusfilters);
};

var getProuductionStatusStats = exports.getProuductionStatusStats = (0, _reselect.createSelector)([_getProuductionStatusStats], function (productionStatusCounts) {
  return productionStatusCounts;
});

var hasActiveFilters = exports.hasActiveFilters = (0, _reselect.createSelector)([_hasActiveFilters], function (retVal) {
  return retVal;
});

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  height: 63vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  position: relative;\n  height: 63vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: #808080;\n  font-family: Roboto;\n  font-size: 22px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 29px;\n  text-align: center;\n  padding-top: 25px;\n'], ['\n  color: #808080;\n  font-family: Roboto;\n  font-size: 22px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 29px;\n  text-align: center;\n  padding-top: 25px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  align-self: flex-end;\n  margin-right: 180px;\n  width: 103px;\n  height: 136px;\n'], ['\n  align-self: flex-end;\n  margin-right: 180px;\n  width: 103px;\n  height: 136px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _Header = __webpack_require__(1702);

var _Header2 = _interopRequireDefault(_Header);

var _useFetchData2 = __webpack_require__(1704);

var _useFetchData3 = _interopRequireDefault(_useFetchData2);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Arrow = __webpack_require__(1705);

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Courses = __webpack_require__(1706);

var _Courses2 = _interopRequireDefault(_Courses);

var _mycourses = __webpack_require__(234);

var _ResponsiveContainer = __webpack_require__(727);

var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);

var _useFetchOrgFlags2 = __webpack_require__(1712);

var _useFetchOrgFlags3 = _interopRequireDefault(_useFetchOrgFlags2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoCoursesBlock = _styledComponents2.default.div.withConfig({
  displayName: 'MyCourses__NoCoursesBlock',
  componentId: 'sc-1ar6lcv-0'
})(_templateObject);

var NoCoursesMessage = _styledComponents2.default.p.withConfig({
  displayName: 'MyCourses__NoCoursesMessage',
  componentId: 'sc-1ar6lcv-1'
})(_templateObject2);

var ArrowIcon = _styledComponents2.default.img.attrs({
  src: _Arrow2.default
}).withConfig({
  displayName: 'MyCourses__ArrowIcon',
  componentId: 'sc-1ar6lcv-2'
})(_templateObject3);

var MyCourses = function MyCourses(_ref) {
  var user = _ref.user,
      frameworkSubjects = _ref.frameworkSubjects,
      gradeLevels = _ref.gradeLevels,
      organization = _ref.organization,
      selectedAcademicYearGlobally = _ref.selectedAcademicYearGlobally;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(selectedAcademicYearGlobally !== null ? selectedAcademicYearGlobally : {}),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      selectedAcademicYear = _useState2[0],
      setSelectedAcademicYear = _useState2[1];

  var _useFetchData = (0, _useFetchData3.default)(organization.orgId, user.token, selectedAcademicYear.id),
      isDataLoading = _useFetchData.isDataLoading,
      academicYears = _useFetchData.academicYears,
      mentorMasterCourses = _useFetchData.mentorMasterCourses;

  var _useFetchOrgFlags = (0, _useFetchOrgFlags3.default)(organization.orgId, user.token),
      isLoadingOrgFlags = _useFetchOrgFlags.isLoadingOrgFlags,
      orgFlags = _useFetchOrgFlags.orgFlags;

  (0, _react.useEffect)(function () {
    if (academicYears !== undefined) {
      var sortedAcademicYear = (0, _arraySort2.default)(academicYears, 'sort_order');
      dispatch((0, _mycourses.setSelectedAcademicYearGlobally)(sortedAcademicYear[0]));
      setSelectedAcademicYear(sortedAcademicYear[0]);
    }
  }, [academicYears]);

  var handleSelectedAcademicYearChange = function handleSelectedAcademicYearChange(e) {
    if (e.id !== selectedAcademicYear.id) {
      dispatch((0, _mycourses.setSelectedAcademicYearGlobally)(e));
      setSelectedAcademicYear(e);
    }
  };

  return isDataLoading ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
    _ResponsiveContainer2.default,
    null,
    _react2.default.createElement(_Header2.default, {
      dispatch: dispatch,
      user: user,
      academicYears: academicYears,
      selectedAcademicYear: academicYears !== undefined && selectedAcademicYear,
      handleSelectedAcademicYearChange: handleSelectedAcademicYearChange,
      frameworkSubjects: frameworkSubjects,
      gradeLevels: gradeLevels,
      organization: organization,
      orgFlags: orgFlags
    }),
    mentorMasterCourses !== undefined && mentorMasterCourses.length ? _react2.default.createElement(_Courses2.default, {
      mentorMasterCourses: mentorMasterCourses,
      academicYears: academicYears,
      selectedAcademicYearId: selectedAcademicYear.id,
      gradeLevels: gradeLevels,
      orgFlags: orgFlags
    }) : _react2.default.createElement(
      NoCoursesBlock,
      null,
      _react2.default.createElement(ArrowIcon, null),
      _react2.default.createElement(
        NoCoursesMessage,
        null,
        'You haven\u2019t created any courses for this academic year. ',
        _react2.default.createElement('br', null),
        'Tap here to create a new course!'
      )
    )
  );
};

MyCourses.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object.isRequired,
  frameworkSubjects: _propTypes2.default.array.isRequired,
  gradeLevels: _propTypes2.default.array.isRequired,
  organization: _propTypes2.default.object.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user,
    frameworkSubjects: state.frameworksubjects.items,
    gradeLevels: state.gradelevels.items,
    organization: state.organization,
    selectedAcademicYearGlobally: state.mycourses.selectedAcademicYearGlobally
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _withApiData2.default)(MyCourses));

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  margin: 58px 0;\n  justify-content: space-between;\n  align-items: center;\n'], ['\n  display: flex;\n  margin: 58px 0;\n  justify-content: space-between;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 60px;\n  height: 60px;\n  border-radius: 5px;\n  margin-right: 18px;\n'], ['\n  width: 60px;\n  height: 60px;\n  border-radius: 5px;\n  margin-right: 18px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  height: 40px;\n  width: 182px;\n  color: #263746;\n  font-size: 34px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 40px;\n  margin: 0;\n'], ['\n  height: 40px;\n  width: 182px;\n  color: #263746;\n  font-size: 34px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 40px;\n  margin: 0;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  height: 21px;\n  margin: 0;\n  color: #444444;\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 20.8px;\n  text-align: left;\n'], ['\n  height: 21px;\n  margin: 0;\n  color: #444444;\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 20.8px;\n  text-align: left;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  margin-right: 31px;\n  width: 245px;\n'], ['\n  margin-right: 31px;\n  width: 245px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _AcademicYearSelect = __webpack_require__(1703);

var _AcademicYearSelect2 = _interopRequireDefault(_AcademicYearSelect);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _modal = __webpack_require__(26);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Header__HeaderContainer',
  componentId: 'sc-1qz5ruf-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Header__FlexContainer',
  componentId: 'sc-1qz5ruf-1'
})(_templateObject2);

var UserAvatarImage = _styledComponents2.default.img.attrs({
  src: function src(props) {
    return props.userAvatar;
  }
}).withConfig({
  displayName: 'Header__UserAvatarImage',
  componentId: 'sc-1qz5ruf-2'
})(_templateObject3);

var HeaderText = _styledComponents2.default.h1.withConfig({
  displayName: 'Header__HeaderText',
  componentId: 'sc-1qz5ruf-3'
})(_templateObject4);

var UserOrganizationName = _styledComponents2.default.p.withConfig({
  displayName: 'Header__UserOrganizationName',
  componentId: 'sc-1qz5ruf-4'
})(_templateObject5);

var AcademicYearSelectionBlock = _styledComponents2.default.div.withConfig({
  displayName: 'Header__AcademicYearSelectionBlock',
  componentId: 'sc-1qz5ruf-5'
})(_templateObject6);

var Header = function Header(_ref) {
  var dispatch = _ref.dispatch,
      user = _ref.user,
      organization = _ref.organization,
      academicYears = _ref.academicYears,
      selectedAcademicYear = _ref.selectedAcademicYear,
      handleSelectedAcademicYearChange = _ref.handleSelectedAcademicYearChange,
      frameworkSubjects = _ref.frameworkSubjects,
      gradeLevels = _ref.gradeLevels,
      orgFlags = _ref.orgFlags;

  var handleModalOpen = function handleModalOpen() {
    dispatch((0, _modal.showModal)('STARTER_COURSE_MODAL', {
      dispatch: dispatch,
      user: user,
      organization: organization,
      academicYears: academicYears,
      frameworkSubjects: frameworkSubjects,
      gradeLevels: gradeLevels,
      selectedAcademicYearId: selectedAcademicYear.id,
      orgFlags: orgFlags
    }));
  };

  return _react2.default.createElement(
    HeaderContainer,
    null,
    _react2.default.createElement(
      FlexContainer,
      null,
      _react2.default.createElement(UserAvatarImage, { userAvatar: user.photo.url, alt: 'user-avatar' }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          HeaderText,
          null,
          'My Courses'
        ),
        _react2.default.createElement(
          UserOrganizationName,
          null,
          user.org_name
        )
      )
    ),
    _react2.default.createElement(
      FlexContainer,
      null,
      _react2.default.createElement(
        AcademicYearSelectionBlock,
        { className: 'academic-year-select' },
        _react2.default.createElement(_AcademicYearSelect2.default, {
          academicYears: academicYears,
          handleSelectedAcademicYearChange: handleSelectedAcademicYearChange,
          selectedAcademicYear: selectedAcademicYear
        })
      ),
      _react2.default.createElement(_Button2.default, {
        handleClick: handleModalOpen,
        width: '211px',
        title: '+ Create a New Course',
        buttonColor: _colors2.default.oeYellow,
        borderColor: _colors2.default.oeYellow,
        hoverBackground: _colors2.default.charcoal4,
        hoverColor: _colors2.default.white
      })
    )
  );
};

Header.propTypes = {
  dispatch: _propTypes2.default.func,
  user: _propTypes2.default.object,
  frameworkSubjects: _propTypes2.default.array.isRequired,
  gradeLevels: _propTypes2.default.array.isRequired
};

exports.default = Header;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AcademicYearSelect = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AcademicYearSelect = exports.AcademicYearSelect = function AcademicYearSelect(_ref) {
  var _ref$academicYears = _ref.academicYears,
      academicYears = _ref$academicYears === undefined ? [] : _ref$academicYears,
      handleSelectedAcademicYearChange = _ref.handleSelectedAcademicYearChange,
      selectedAcademicYear = _ref.selectedAcademicYear;

  var mapList = function mapList(AY) {
    return (0, _arraySort2.default)(AY.map(function (ay) {
      return {
        label: ay.name,
        name: ay.name,
        id: ay.id,
        sort_order: ay.sort_order
      };
    })).filter(function (el) {
      return el !== false;
    });
  };

  var mappedAcademicYears = mapList(academicYears);

  return _react2.default.createElement(_reactSelect2.default, {
    options: mappedAcademicYears,
    value: mappedAcademicYears.find(function (st) {
      return st.id === selectedAcademicYear.id;
    }),
    onChange: handleSelectedAcademicYearChange,
    clearable: false,
    className: 'course-builder-select',
    searchable: false
  });
};

AcademicYearSelect.propTypes = {
  academicYears: _propTypes2.default.array.isRequired,
  handleSelectedAcademicYearChange: _propTypes2.default.func.isRequired,
  selectedAcademicYear: _propTypes2.default.object
};

exports.default = AcademicYearSelect;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactQuery = __webpack_require__(34);

var _API = __webpack_require__(98);

exports.default = function (orgId, token, selectedAcademicYearId) {
  var _useQuery = (0, _reactQuery.useQuery)(['academic-years'], function () {
    return (0, _API.fetchAcademicYears)(orgId, token);
  }, {
    refetchOnWindowFocus: false
  }),
      isLoadingAcademicYears = _useQuery.isLoading,
      academicYears = _useQuery.data;

  var _useQuery2 = (0, _reactQuery.useQuery)(['mentor-master-courses-' + selectedAcademicYearId], function () {
    return (0, _API.fetchMentorMasterCourses)(orgId, token, selectedAcademicYearId);
  }, {
    refetchOnWindowFocus: false,
    enabled: !!selectedAcademicYearId
  }),
      isLoadingMentorMasterCourses = _useQuery2.isLoading,
      mentorMasterCourses = _useQuery2.data;

  var isDataLoading = isLoadingAcademicYears || isLoadingMentorMasterCourses;

  return {
    isDataLoading: isDataLoading,
    academicYears: academicYears,
    mentorMasterCourses: mentorMasterCourses
  };
};

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAzIiBoZWlnaHQ9IjEzNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNOTYuNi43bC03LjcgMTMuNiA2IC4zLS4xLjRjLTUuNyA0OS42LTQwLjYgOTMuNi05MyAxMTlsLTEuNi44LjggMS44QzU1IDExMSA5MSA2NiA5Ni44IDE1LjJ2LS41bDYgLjNMOTYuNy43eiIgZmlsbD0iI0JCQiIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo="

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Courses = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _Course = __webpack_require__(1707);

var _Course2 = _interopRequireDefault(_Course);

var _reactRedux = __webpack_require__(14);

var _mycourses = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Courses = exports.Courses = function Courses(_ref) {
  var mentorMasterCourses = _ref.mentorMasterCourses,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      gradeLevels = _ref.gradeLevels,
      orgFlags = _ref.orgFlags;

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _mycourses.clearExpandedLevels)());
  }, []);

  mentorMasterCourses.forEach(function (mm) {
    return mm.name_sort = mm.name.toUpperCase();
  });
  return _react2.default.createElement(
    'ol',
    { className: 'activity-courses' },
    (0, _arraySort2.default)(mentorMasterCourses, ['grade_level_id', 'name_sort']).map(function (mmc) {
      return _react2.default.createElement(_Course2.default, {
        activityCourse: mmc,
        academicYears: academicYears,
        key: mmc.id,
        selectedAcademicYearId: selectedAcademicYearId,
        gradeLevels: gradeLevels,
        orgFlags: orgFlags
      });
    })
  );
};

Courses.propTypes = {
  mentorMasterCourses: _propTypes2.default.array.isRequired,
  academicYears: _propTypes2.default.array.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  justAddedCourses: _propTypes2.default.array
};

exports.default = Courses;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Course = undefined;

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  height: auto;\n  border-radius: 4px;\n  background-color: ', ';\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  margin: 20px 0;\n  padding: 10px 0 10px 20px;\n  cursor: ', ';\n'], ['\n  height: auto;\n  border-radius: 4px;\n  background-color: ', ';\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n  margin: 20px 0;\n  padding: 10px 0 10px 20px;\n  cursor: ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactQuery = __webpack_require__(34);

var _reactRedux = __webpack_require__(14);

var _reactDnd = __webpack_require__(143);

var _reactDndHtml5Backend = __webpack_require__(314);

var _immutabilityHelper = __webpack_require__(313);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _CourseHeader = __webpack_require__(1708);

var _CourseHeader2 = _interopRequireDefault(_CourseHeader);

var _modal = __webpack_require__(26);

var _JourneyRow = __webpack_require__(1711);

var _JourneyRow2 = _interopRequireDefault(_JourneyRow);

var _API = __webpack_require__(98);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _useIsExpanded = __webpack_require__(726);

var _mycourses = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseContainer = _styledComponents2.default.li.withConfig({
  displayName: 'Course__CourseContainer',
  componentId: 'sc-1n3psxq-0'
})(_templateObject, _colors2.default.white, function (props) {
  return props.clickable ? 'pointer' : 'default';
});

var Course = exports.Course = function Course(_ref) {
  var apiData = _ref.apiData,
      activityCourse = _ref.activityCourse,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId,
      gradeLevels = _ref.gradeLevels,
      orgFlags = _ref.orgFlags;

  var dispatch = (0, _reactRedux.useDispatch)();

  var canCollapse = activityCourse.courses_count > 0;
  var isExpanded = (0, _useIsExpanded.useIsCourseExpanded)(activityCourse);
  var shouldShowJourneys = isExpanded || !canCollapse;

  var _useQuery = (0, _reactQuery.useQuery)(['activity-course-journeys-' + activityCourse.id], function () {
    return (0, _API.fetchActivityCourseJourneys)(apiData.orgId, apiData.token, activityCourse.id);
  }, {
    refetchOnWindowFocus: false,
    enabled: shouldShowJourneys
  }),
      journeys = _useQuery.data,
      fetchJourneys = _useQuery.refetch;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      journeysState = _useState2[0],
      setJourneysState = _useState2[1];

  (0, _react.useEffect)(function () {
    if (journeysState !== journeys) {
      setJourneysState((0, _arraySort2.default)(journeys, 'master_course_course.sort_order'));
    }
  }, [journeys]);

  var moveCard = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
    var journeysCopy = [].concat((0, _toConsumableArray3.default)(journeysState));
    var dragCard = journeysCopy[dragIndex];
    setJourneysState((0, _immutabilityHelper2.default)(journeysCopy, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
    }));
  }, [journeysState]);

  var renderCard = function renderCard(journey, index) {
    return _react2.default.createElement(_JourneyRow2.default, {
      activityCourse: activityCourse,
      key: index,
      index: index,
      journey: journey,
      moveCard: moveCard,
      id: journey.id,
      selectedAcademicYearId: selectedAcademicYearId
    });
  };

  var handleDisplayJourneysList = function handleDisplayJourneysList() {
    var isShown = shouldShowJourneys;
    if (!isShown) {
      fetchJourneys();
    }
    dispatch((0, _mycourses.setCourseIsExpanded)(activityCourse.id, !isShown));
  };

  var handleDisplayJourneysListOnCreation = function handleDisplayJourneysListOnCreation() {
    var isShown = shouldShowJourneys;
    if (!isShown) {
      fetchJourneys();
    }
    dispatch((0, _mycourses.setCourseIsExpanded)(activityCourse.id, true));
  };
  var handleJourneyCreationModal = function handleJourneyCreationModal() {
    dispatch((0, _modal.showModal)('STARTER_JOURNEY_MODAL', {
      gradeLevels: gradeLevels,
      activityCourse: activityCourse,
      academicYears: academicYears,
      selectedAcademicYearId: selectedAcademicYearId,
      handleDisplayJourneysListOnCreation: handleDisplayJourneysListOnCreation,
      orgFlags: orgFlags
    }));
  };

  return _react2.default.createElement(
    CourseContainer,
    {
      onClick: function onClick(e) {
        return typeof e.target.className === 'string' && (e.target.className.includes('CourseHeader') || e.target.className.includes('Course__CourseContainer') || e.target.className.includes('H5')) && handleDisplayJourneysList(e);
      },
      clickable: canCollapse,
      className: 'activity-course'
    },
    _react2.default.createElement(_CourseHeader2.default, {
      activityCourse: activityCourse,
      academicYears: academicYears,
      selectedAcademicYearId: selectedAcademicYearId
    }),
    _react2.default.createElement(
      _reactDnd.DndProvider,
      { backend: _reactDndHtml5Backend.HTML5Backend },
      shouldShowJourneys && _react2.default.createElement(
        'div',
        null,
        journeysState !== null && _react2.default.createElement(
          'div',
          null,
          journeysState.map(function (journey, i) {
            return renderCard(journey, i);
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '10px 0' } },
          _react2.default.createElement(_Button2.default, {
            handleClick: handleJourneyCreationModal,
            width: '136px',
            title: '+ Add Journey',
            buttonColor: _colors2.default.white,
            borderColor: _colors2.default.aluminum,
            hoverBackground: _colors2.default.charcoal4,
            hoverColor: _colors2.default.white
          })
        )
      )
    )
  );
};

Course.propTypes = {
  activityCourse: _propTypes2.default.object.isRequired,
  academicYears: _propTypes2.default.array.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  justAddedCourse: _propTypes2.default.object
};

exports.default = (0, _withApiData2.default)(Course);

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CourseHeader = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  align-items: center;\n  align-content: center;\n  display: flex;\n  flex: ', ';\n'], ['\n  align-items: center;\n  align-content: center;\n  display: flex;\n  flex: ', ';\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: 10px;\n  margin-right: 30px;\n'], ['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 22px;\n  margin-left: 10px;\n  margin-right: 30px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _MenuButton = __webpack_require__(1709);

var _MenuButton2 = _interopRequireDefault(_MenuButton);

var _ProgressBar = __webpack_require__(723);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _Caption = __webpack_require__(160);

var _Caption2 = _interopRequireDefault(_Caption);

var _util = __webpack_require__(114);

var _GradeElement = __webpack_require__(309);

var _GradeElement2 = _interopRequireDefault(_GradeElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseHeaderContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CourseHeader__CourseHeaderContainer',
  componentId: 'sc-1hr4w5o-0'
})(_templateObject);

var CourseInfo = _styledComponents2.default.div.withConfig({
  displayName: 'CourseHeader__CourseInfo',
  componentId: 'sc-1hr4w5o-1'
})(_templateObject2, function (props) {
  return props.grow && '1';
});

var CourseNameElement = _styledComponents2.default.h3.withConfig({
  displayName: 'CourseHeader__CourseNameElement',
  componentId: 'sc-1hr4w5o-2'
})(_templateObject3, function (props) {
  return props.color;
});

var CourseHeader = exports.CourseHeader = function CourseHeader(_ref) {
  var activityCourse = _ref.activityCourse,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId;

  var frameworkSubjects = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworksubjects.items;
  });
  var frameworkSubjectName = frameworkSubjects.find(function (fs) {
    return fs.id === activityCourse.framework_subject_id;
  }).name;

  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });
  var gradeLevel = gradeLevels.find(function (gl) {
    return gl.id === activityCourse.grade_level_id;
  });

  return _react2.default.createElement(
    CourseHeaderContainer,
    null,
    _react2.default.createElement(
      CourseInfo,
      { grow: true },
      _react2.default.createElement(_GradeElement2.default, {
        name: gradeLevel.name,
        abbreviation: gradeLevel.abbreviation
      }),
      _react2.default.createElement(
        CourseNameElement,
        { color: (0, _util.cleanHexCode)(activityCourse.color) },
        activityCourse.name
      )
    ),
    _react2.default.createElement(
      CourseInfo,
      { grow: true },
      _react2.default.createElement(
        _H2.default,
        { style: { width: '45px', paddingRight: '30px' } },
        activityCourse.abbreviation
      ),
      _react2.default.createElement(
        _H2.default,
        null,
        frameworkSubjectName
      )
    ),
    _react2.default.createElement(
      CourseInfo,
      { style: { justifyContent: 'flex-end' } },
      _react2.default.createElement(
        _H2.default,
        null,
        _react2.default.createElement(
          'span',
          { style: { paddingRight: '10px' } },
          activityCourse.courses_count
        ),
        'Journeys'
      ),
      _react2.default.createElement(_ProgressBar2.default, {
        progress: activityCourse.courses_count > 0 ? activityCourse.enrollment_ready_courses_count / activityCourse.courses_count * 100 : 0
      }),
      _react2.default.createElement(_MenuButton2.default, {
        activityCourse: activityCourse,
        journeyQuantity: activityCourse.courses_count,
        academicYears: academicYears,
        selectedAcademicYearId: selectedAcademicYearId
      })
    )
  );
};

CourseHeader.propTypes = {
  activityCourse: _propTypes2.default.object.isRequired,
  academicYears: _propTypes2.default.array.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired
};

exports.default = CourseHeader;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _modal = __webpack_require__(26);

var _API = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButton = __webpack_require__(165).default;
var Menu = __webpack_require__(330).default;
var MenuItem = __webpack_require__(262).default;
var MoreVertIcon = __webpack_require__(722).default;


var options = ['Edit Details', 'Delete'];

var ITEM_HEIGHT = 48;

var MenuButton = function MenuButton(_ref) {
  var apiData = _ref.apiData,
      activityCourse = _ref.activityCourse,
      journeyQuantity = _ref.journeyQuantity,
      academicYears = _ref.academicYears,
      selectedAcademicYearId = _ref.selectedAcademicYearId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });
  var gradeLevel = gradeLevels.find(function (gl) {
    return gl.id === activityCourse.grade_level_id;
  });

  var queryClient = (0, _reactQuery.useQueryClient)();
  var deleteMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        id = _ref2.id;
    return (0, _API.deleteMentorActivityCourse)(apiData, id);
  });

  var onDeleteClick = function onDeleteClick(apiData, id) {
    deleteMutation.mutate({
      apiData: apiData,
      id: id
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
        queryClient.invalidateQueries('cloneable-master-courses');
      }
    });
  };

  var _React$useState = _react2.default.useState(null),
      _React$useState2 = (0, _slicedToArray3.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose(option) {
    if (option === 'Delete') {
      if (journeyQuantity === 0) {
        dispatch((0, _modal.showModal)('CLOSE_MODAL', {
          activityCourse: activityCourse,
          gradeLevel: gradeLevel,
          description: 'Are you sure you want to delete this course ?',
          supportiveText: 'Once deleted, this cannot be undone.',
          deleteFunction: function deleteFunction() {
            return onDeleteClick(apiData, activityCourse.id);
          }
        }));
      } else {
        dispatch((0, _modal.showModal)('INFORMATIVE_MODAL', {
          activityCourse: activityCourse,
          description: 'All journeys in this course must be deleted before you can delete the course.',
          gradeLevel: gradeLevel
        }));
      }
    }

    if (option === 'Edit Details') {
      dispatch((0, _modal.showModal)('EDIT_COURSE_MODAL', {
        activityCourse: activityCourse,
        apiData: apiData,
        academicYears: academicYears,
        selectedAcademicYearId: selectedAcademicYearId
      }));
    }

    setAnchorEl(null);
  };

  return _react2.default.createElement(
    'div',
    { className: 'menu-button' },
    _react2.default.createElement(
      IconButton,
      {
        'aria-label': 'more',
        'aria-controls': 'long-menu',
        'aria-haspopup': 'true',
        onClick: handleClick,
        style: { width: '48px' }
      },
      _react2.default.createElement(MoreVertIcon, null)
    ),
    _react2.default.createElement(
      Menu,
      {
        id: 'long-menu',
        anchorEl: anchorEl,
        keepMounted: true,
        open: open,
        onClose: handleClose,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch'
          }
        }
      },
      options.map(function (option) {
        return _react2.default.createElement(
          MenuItem,
          {
            key: option,
            onClick: function onClick() {
              return handleClose(option);
            }
          },
          option
        );
      })
    )
  );
};

MenuButton.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  journeyQuantity: _propTypes2.default.number.isRequired,
  academicYears: _propTypes2.default.array.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(MenuButton);

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = __webpack_require__(440);

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: 11px 0;\n  background: none;\n'], ['\n  margin: 11px 0;\n  background: none;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0 10px 22px;\n  margin: 0 2.5%;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n  flex: 1;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0 10px 22px;\n  margin: 0 2.5%;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n  flex: 1;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 19px;\n  height: 9px;\n'], ['\n  width: 19px;\n  height: 9px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(143);

var _reactRouterRedux = __webpack_require__(23);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _PublishLabel = __webpack_require__(724);

var _PublishLabel2 = _interopRequireDefault(_PublishLabel);

var _modal = __webpack_require__(26);

var _convertToRomanNumerals = __webpack_require__(310);

var _SortOrder = __webpack_require__(249);

var _SortOrder2 = _interopRequireDefault(_SortOrder);

var _EditOrDeleteMenuButton = __webpack_require__(483);

var _EditOrDeleteMenuButton2 = _interopRequireDefault(_EditOrDeleteMenuButton);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _ItemTypes = __webpack_require__(248);

var _API = __webpack_require__(246);

var _util = __webpack_require__(114);

var _FixedAlignmentBox = __webpack_require__(725);

var _FixedAlignmentBox2 = _interopRequireDefault(_FixedAlignmentBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyRow__JourneyContainer',
  componentId: 'sc-15y2r0o-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyRow__FlexContainer',
  componentId: 'sc-15y2r0o-1'
})(_templateObject2);

var JourneyInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyRow__JourneyInfoContainer',
  componentId: 'sc-15y2r0o-2'
})(_templateObject3);

var SortIcon = _styledComponents2.default.img.attrs({
  src: _SortOrder2.default
}).withConfig({
  displayName: 'JourneyRow__SortIcon',
  componentId: 'sc-15y2r0o-3'
})(_templateObject4);

var JourneyRow = function JourneyRow(_ref) {
  var apiData = _ref.apiData,
      activityCourse = _ref.activityCourse,
      index = _ref.index,
      journey = _ref.journey,
      moveCard = _ref.moveCard,
      id = _ref.id,
      selectedAcademicYearId = _ref.selectedAcademicYearId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });
  var gradeLevel = gradeLevels.find(function (gl) {
    return gl.id === activityCourse.grade_level_id;
  });

  var ref = (0, _react.useRef)(null);

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: _ItemTypes.ItemTypes.JOURNEY_ROW,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover: function hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      var dragIndex = item.index;
      var hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      var hoverBoundingRect = ref.current.getBoundingClientRect();

      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      var clientOffset = monitor.getClientOffset();

      var hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: function drop(item) {
      var index = item.index - 1 === -1 ? 0 : item.index;
      (0, _API.reorderActivityCourseJourney)(apiData, activityCourseId, journey.id, index);
    }
  }),
      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: _ItemTypes.ItemTypes.JOURNEY_ROW,
    item: function item() {
      return { id: id, index: index };
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
      drag = _useDrag2[1];

  drag(drop(ref));

  var activityCourseId = activityCourse.id;

  var deleteMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        activityCourseId = _ref2.activityCourseId,
        journeyId = _ref2.journeyId;
    return (0, _API.deleteActivityCourseJourney)(apiData, activityCourseId, journeyId);
  });

  var onDeleteClick = function onDeleteClick(apiData, activityCourseId, journeyId) {
    deleteMutation.mutate({
      apiData: apiData,
      activityCourseId: activityCourseId,
      journeyId: journeyId
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('activity-course-journeys-' + activityCourseId);
        queryClient.invalidateQueries('mentor-master-courses-' + selectedAcademicYearId);
        queryClient.invalidateQueries('cloneable-journeys-' + selectedAcademicYearId);
      }
    });
  };

  var titleInfo = {
    color: activityCourse.color,
    name: activityCourse.name,
    abbreviation: activityCourse.abbreviation,
    journeyName: journey.name,
    journeyIndex: journey.master_course_course.index + 1
  };

  var handleClick = function handleClick(e) {
    dispatch((0, _reactRouterRedux.push)('/mycourses/' + activityCourse.id + '/journey/' + journey.id));
    e.stopPropagation();
  };

  var handleClose = function handleClose(option) {
    if (option === 'Delete') {
      if (journey.marked_ready_for_enrollment_at === null) {
        dispatch((0, _modal.showModal)('CLOSE_MODAL', {
          activityCourse: titleInfo,
          gradeLevel: gradeLevel,
          description: 'Are you sure you want to delete this journey?',
          supportiveText: 'This action cannot be undone.',
          isOptionalTextExist: true,
          optionalText: 'All' + (journey.quests_count > 0 ? ' ' + journey.quests_count : '') + ' activities will be permanently deleted.',
          deleteFunction: function deleteFunction() {
            return onDeleteClick(apiData, activityCourse.id, journey.id);
          }
        }));
      } else {
        // TODO: fix what is displayed here
        dispatch((0, _modal.showModal)('INFORMATIVE_MODAL', {
          activityCourse: activityCourse,
          description: 'This journey has already been published, and so cannot be deleted.',
          gradeLevel: gradeLevel
        }));
      }
    }

    if (option === 'Edit Details') {
      dispatch((0, _modal.showModal)('EDIT_JOURNEY_MODAL', {
        apiData: apiData,
        activityCourseId: activityCourseId,
        journeyId: journey.id
      }));
    }
  };

  return _react2.default.createElement(
    'div',
    { ref: ref, style: { boxShadow: 'none' } },
    _react2.default.createElement(
      JourneyContainer,
      null,
      _react2.default.createElement(
        FlexContainer,
        null,
        _react2.default.createElement(SortIcon, null),
        _react2.default.createElement(
          JourneyInfoContainer,
          null,
          _react2.default.createElement(
            _H2.default,
            {
              style: { flex: '30%', color: (0, _util.cleanHexCode)(activityCourse.color) },
              onClick: handleClick
            },
            _react2.default.createElement(
              'span',
              null,
              (0, _convertToRomanNumerals.convertToRomanNumerals)(index + 1),
              '. '
            ),
            journey.name
          ),
          _react2.default.createElement(
            _FixedAlignmentBox2.default,
            {
              justify: 'flex-end',
              width: '80px',
              marginRight: '25px'
            },
            _react2.default.createElement(
              _P2.default,
              {
                onClick: handleClick
              },
              _react2.default.createElement(
                'span',
                null,
                journey.levels_count,
                ' '
              ),
              'Levels'
            )
          ),
          _react2.default.createElement(
            _FixedAlignmentBox2.default,
            {
              justify: 'flex-end',
              width: '100px',
              marginRight: '90px'
            },
            _react2.default.createElement(
              _P2.default,
              {
                onClick: handleClick
              },
              _react2.default.createElement(
                'span',
                null,
                journey.quests_count,
                ' '
              ),
              'Activities'
            )
          ),
          _react2.default.createElement(
            _FixedAlignmentBox2.default,
            { justify: 'center', width: '86px',
              onClick: handleClick
            },
            _react2.default.createElement(_PublishLabel2.default, {
              isPublished: !!journey.marked_ready_for_enrollment_at
            })
          ),
          _react2.default.createElement(_EditOrDeleteMenuButton2.default, {
            options: !!journey.marked_ready_for_enrollment_at ? ['Edit Details'] : ['Edit Details', 'Delete'],
            handleChosenOption: handleClose
          })
        )
      )
    )
  );
};

JourneyRow.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  journey: _propTypes2.default.object.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  moveCard: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(JourneyRow);

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactQuery = __webpack_require__(34);

var _API = __webpack_require__(98);

exports.default = function (orgId, token) {
  var _useQuery = (0, _reactQuery.useQuery)(['org-flags'], function () {
    return (0, _API.fetchOrgFlags)(orgId, token);
  }, {
    refetchOnWindowFocus: false
  }),
      isLoadingOrgFlags = _useQuery.isLoading,
      orgFlags = _useQuery.data;

  return {
    isLoadingOrgFlags: isLoadingOrgFlags,
    orgFlags: orgFlags
  };
};

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requireAuthentication = requireAuthentication;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _user = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function requireAuthentication(Component) {
  var AuthenticatedComponent = function AuthenticatedComponent(props) {
    var dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(function () {
      if (!sessionStorage.getItem('oef-token')) {
        dispatch((0, _user.logoutAndRedirect)(false, true));
      }

      window.scrollTo(0, 0);
    });

    return _react2.default.createElement(
      'div',
      null,
      props.isAuthenticated === true ? _react2.default.createElement(Component, props) : null
    );
  };

  AuthenticatedComponent.propTypes = {
    isAuthenticated: _propTypes2.default.bool.isRequired,
    location: _propTypes2.default.object.isRequired,
    history: _propTypes2.default.object.isRequired,
    policiesToAccept: _propTypes2.default.string
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      token: state.user.token,
      userName: state.user.userName,
      isAuthenticated: state.user.isAuthenticated
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(AuthenticatedComponent);
}

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapUnauthenticatedComponent = wrapUnauthenticatedComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _user = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapUnauthenticatedComponent(WrappedComponent) {
  var UnauthenticatedComponent = function UnauthenticatedComponent(props) {
    var dispatch = (0, _reactRedux.useDispatch)();

    (0, _react.useEffect)(function () {
      if (sessionStorage.getItem('oef-token') && !sessionStorage.getItem('password')) {
        dispatch((0, _user.redirectAuthenticatedUser)());
      }
    });

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(WrappedComponent, props),
      _react2.default.createElement(
        'div',
        { className: 'oe-container' },
        _react2.default.createElement('div', {
          className: 'oe-logo',
          onClick: function onClick() {
            return window.open('https://www.opportunityeducation.org/');
          }
        })
      )
    );
  };

  UnauthenticatedComponent.propTypes = {
    location: _propTypes2.default.object.isRequired
  };

  return (0, _reactRedux.connect)()(UnauthenticatedComponent);
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restrictAccess = restrictAccess;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _routes = __webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function restrictAccess(Component) {
  var RestrictUserAccess = function RestrictUserAccess(props) {
    var dispatch = (0, _reactRedux.useDispatch)();

    var allowAccess = function allowAccess() {
      var user = props.user,
          route = props.route;

      return user && (0, _routes.allowAccessToRoute)(user, route.path);
    };

    (0, _react.useEffect)(function () {
      if (!allowAccess()) {
        dispatch((0, _reactRouterRedux.push)('/notfound'));
      }
    });

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      allowAccess() ? _react2.default.createElement(Component, props) : null
    );
  };

  RestrictUserAccess.propTypes = {
    user: _propTypes2.default.object,
    route: _propTypes2.default.object
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      user: state.user.user
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(RestrictUserAccess);
}

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restrictRole = restrictRole;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactRouterRedux = __webpack_require__(23);

var _user = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function restrictRole(Component) {
  var RoleRequiredComponent = function RoleRequiredComponent(props) {
    var dispatch = (0, _reactRedux.useDispatch)();

    var allowAccess = function allowAccess() {
      var user = props.user,
          route = props.route;

      return route.path === 'quests/add' && (0, _user.isQuestDesigner)(user) || route.path === 'reviewqueue' && ((0, _user.isInternalReviewer)(user) || (0, _user.isOeReviewer)(user)) || route.path.includes('activities/add') && ((0, _user.isQuestDesigner)(user) || (0, _user.isQuestCopyEditor)(user) || (0, _user.isQuestManager)(user));
    };

    (0, _react.useEffect)(function () {
      if (!allowAccess()) {
        dispatch((0, _reactRouterRedux.push)('/quests'));
      }
    });

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(Component, props)
    );
  };

  RoleRequiredComponent.propTypes = {
    user: _propTypes2.default.object,
    route: _propTypes2.default.object.isRequired
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      user: state.user.user
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(RoleRequiredComponent);
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.JourneyDetails = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 34px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 45.6px;\n  margin-right: 14px;\n  margin-top: 0;\n'], ['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 34px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 45.6px;\n  margin-right: 14px;\n  margin-top: 0;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-bottom: 8px;\n'], ['\n  color: ', ';\n  font-size: 11px;\n  letter-spacing: 0;\n  line-height: 16px;\n  margin-bottom: 8px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-bottom: 33px;\n  max-width: 70%;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 19px;\n  margin-bottom: 33px;\n  max-width: 70%;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  max-width: 800px;\n  cursor: pointer;\n\n  label {\n    cursor: pointer;\n  }\n'], ['\n  max-width: 800px;\n  cursor: pointer;\n\n  label {\n    cursor: pointer;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactRouterRedux = __webpack_require__(23);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _API = __webpack_require__(246);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _modal = __webpack_require__(26);

var _convertToRomanNumerals = __webpack_require__(310);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _API2 = __webpack_require__(247);

var _LevelRow = __webpack_require__(1718);

var _LevelRow2 = _interopRequireDefault(_LevelRow);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _util = __webpack_require__(114);

var _ResponsiveContainer = __webpack_require__(727);

var _ResponsiveContainer2 = _interopRequireDefault(_ResponsiveContainer);

var _BackButton = __webpack_require__(728);

var _BackButton2 = _interopRequireDefault(_BackButton);

var _GradeElement = __webpack_require__(309);

var _GradeElement2 = _interopRequireDefault(_GradeElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyDetails__FlexContainer',
  componentId: 'sc-1bxzom0-0'
})(_templateObject);

var Title = _styledComponents2.default.h1.withConfig({
  displayName: 'JourneyDetails__Title',
  componentId: 'sc-1bxzom0-1'
})(_templateObject2, function (props) {
  return props.color;
});

var Description = _styledComponents2.default.h3.withConfig({
  displayName: 'JourneyDetails__Description',
  componentId: 'sc-1bxzom0-2'
})(_templateObject3, _colors2.default.dove);

var JourneyDescriptionText = _styledComponents2.default.p.withConfig({
  displayName: 'JourneyDetails__JourneyDescriptionText',
  componentId: 'sc-1bxzom0-3'
})(_templateObject4, function (props) {
  return props.hasDescription ? _colors2.default.charcoal4 : _colors2.default.silver;
});

var ClickableDescriptionSection = _styledComponents2.default.div.withConfig({
  displayName: 'JourneyDetails__ClickableDescriptionSection',
  componentId: 'sc-1bxzom0-4'
})(_templateObject5);

var JourneyDetails = exports.JourneyDetails = function JourneyDetails(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      journeyId = _ref.journeyId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var mouseOver = function mouseOver() {
    setIsHovered(true);
  };

  var mouseOut = function mouseOut() {
    setIsHovered(false);
  };

  var journey = (0, _reactQuery.useQuery)(['activity-course-journey-' + journeyId], function () {
    return (0, _API.fetchActivityCourseJourney)(apiData.orgId, apiData.token, activityCourseId, journeyId);
  }, {
    refetchOnWindowFocus: false
  });

  var activityCourse = (0, _reactQuery.useQuery)(['activity-course-' + activityCourseId], function () {
    return (0, _API.fetchActivityCourse)(apiData.orgId, apiData.token, activityCourseId);
  }, {
    refetchOnWindowFocus: false
  });

  var _useQuery = (0, _reactQuery.useQuery)(['journey-levels-' + journeyId], function () {
    return (0, _API2.fetchJourneyLevels)(apiData, activityCourseId, journeyId);
  }, {
    refetchOnWindowFocus: false,
    initialData: []
  }),
      isLevelsLoading = _useQuery.isLoading,
      levels = _useQuery.data;

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      gradeLevelAbbreviation = _useState4[0],
      setGradeLevelAbbreviation = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      gradeName = _useState6[0],
      setGradeName = _useState6[1];

  (0, _react.useEffect)(function () {
    if (!activityCourse.isLoading && !!activityCourse.data) {
      var gl = gradeLevels.find(function (gl) {
        return gl.id === activityCourse.data.grade_level_id;
      });
      setGradeLevelAbbreviation(gl.abbreviation);
      setGradeName(gl.name);
    }
  }, [journey, gradeLevelAbbreviation]);

  var handleOpenEditModal = function handleOpenEditModal() {
    dispatch((0, _modal.showModal)('EDIT_JOURNEY_MODAL', {
      apiData: apiData,
      activityCourseId: activityCourseId,
      journeyId: journeyId
    }));
  };

  var handleLevelCreationModal = function handleLevelCreationModal() {
    dispatch((0, _modal.showModal)('CREATE_OR_EDIT_LEVEL_MODAL', {
      activityCourseId: activityCourseId,
      journeyId: journeyId,
      isCreateLevel: true
    }));
  };

  var listOfLevels = !isLevelsLoading && (0, _arraySort2.default)(levels, 'sort_order').map(function (level, index) {
    return _react2.default.createElement(_LevelRow2.default, {
      key: 'level-' + level.id,
      activityCourseId: activityCourseId,
      journeyId: !!journey.data && journey.data.id,
      isReadyForEnrollment: !!journey.data && !!journey.data.marked_ready_for_enrollment_at,
      level: level,
      color: !!activityCourse.data && (0, _util.cleanHexCode)(activityCourse.data.color),
      levels: levels,
      courseId: activityCourseId,
      sequenceNumber: index + 1
    });
  });

  var levelWithoutQuests = levels.find(function (l) {
    return l.quests_count === 0;
  });
  var questsCount = levels.map(function (l) {
    return l.quests_count;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);
  var questsInDraftCount = levels.map(function (l) {
    return l.quests_in_draft_count;
  }).reduce(function (a, b) {
    return a + b;
  }, 0);

  var isJourneyPublishable = !levelWithoutQuests && questsCount > 0 && questsInDraftCount === 0;

  return _react2.default.createElement(
    _ResponsiveContainer2.default,
    null,
    journey.isLoading || activityCourse.isLoading || gradeLevelAbbreviation === '' ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(_BackButton2.default, {
        backToWhere: 'Courses',
        onClick: function onClick() {
          return dispatch((0, _reactRouterRedux.push)('/mycourses'));
        }
      }),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          FlexContainer,
          { style: {
              alignItems: 'flex-start',
              marginTop: '55px'
            } },
          _react2.default.createElement(
            'div',
            { style: { width: '70%' } },
            _react2.default.createElement(
              FlexContainer,
              {
                style: {
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  cursor: 'pointer'
                },
                onClick: handleOpenEditModal,
                onMouseOver: mouseOver,
                onMouseOut: mouseOut
              },
              _react2.default.createElement(_GradeElement2.default, { large: true,
                name: gradeName,
                abbreviation: gradeLevelAbbreviation,
                style: { marginRight: '14px' }
              }),
              _react2.default.createElement(
                Title,
                { color: (0, _util.cleanHexCode)(activityCourse.data.color) },
                activityCourse.data.abbreviation + ': ' + (0, _convertToRomanNumerals.convertToRomanNumerals)(journey.data.master_course_course.index + 1) + ' ' + journey.data.name
              ),
              _react2.default.createElement(
                'div',
                { style: { marginTop: '2%' } },
                _react2.default.createElement(
                  'svg',
                  {
                    width: '18',
                    height: '18',
                    xmlns: 'http://www.w3.org/2000/svg'
                  },
                  _react2.default.createElement('path', {
                    d: 'M11.829 3.6l2.7 2.7L4.114 16.714 0 18l1.414-3.986L11.83 3.6zM17.42.579c.772.771.772 1.928 0 2.571l-1.414 1.414-2.571-2.571L14.85.579c.771-.772 1.929-.772 2.571 0z',
                    fill: isHovered ? _colors2.default.cobalt : _colors2.default.aluminum,
                    fillRule: 'nonzero'
                  })
                )
              )
            )
          ),
          !journey.data.marked_ready_for_enrollment_at ? _react2.default.createElement(
            'div',
            {
              'data-for': 'publishJourneyTooltip',
              'data-tip': !isLevelsLoading && levels.length > 0 ? 'Please publish all activities prior to publishing this journey.' : 'At least one level and one activity are required prior to publishing.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '184px',
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              title: 'Publish Journey',
              couldSaveData: isJourneyPublishable,
              shouldShowTooltipAndDisableButton: !isJourneyPublishable,
              handleClick: isJourneyPublishable ? function () {
                dispatch((0, _modal.showModal)('PUBLISH_JOURNEY_MODAL', {
                  activityCourseId: activityCourseId,
                  journeyId: journeyId
                }));
              } : null
            }),
            !isJourneyPublishable && _react2.default.createElement(_reactTooltip2.default, {
              id: 'publishJourneyTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          ) : _react2.default.createElement(
            FlexContainer,
            {
              style: {
                flexDirection: 'column',
                alignItems: 'flex-end'
              }
            },
            _react2.default.createElement(
              _H2.default,
              { style: { color: _colors2.default.jade } },
              'Published'
            ),
            _react2.default.createElement(
              _Caption2.default,
              null,
              _moment2.default.unix(journey.data.marked_ready_for_enrollment_at).format('DD MMMM YYYY').toString()
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            ClickableDescriptionSection,
            {
              onClick: handleOpenEditModal,
              onMouseOver: mouseOver,
              onMouseOut: mouseOut
            },
            _react2.default.createElement(
              Description,
              null,
              'Journey Description'
            ),
            _react2.default.createElement(
              'div',
              { className: 'view-fields' },
              journey.data.description.length === 0 ? _react2.default.createElement(
                JourneyDescriptionText,
                {
                  hasDescription: journey.data.description.length > 0
                },
                _react2.default.createElement(_NotYetSpecified2.default, null)
              ) : _react2.default.createElement(_MarkdownLabel2.default, {
                value: journey.data.description,
                additionalCssClasses: 'view-journey-description'
              })
            )
          ),
          _react2.default.createElement(
            Description,
            null,
            'Levels / Activities'
          ),
          _react2.default.createElement(
            'div',
            null,
            listOfLevels
          ),
          !!journey.data && !journey.data.marked_ready_for_enrollment_at && _react2.default.createElement(
            'div',
            { style: { marginTop: '15px' } },
            _react2.default.createElement(_Button2.default, {
              handleClick: handleLevelCreationModal,
              width: '136px',
              title: '+ Add Level',
              buttonColor: _colors2.default.smoke,
              borderColor: _colors2.default.aluminum,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white
            })
          )
        )
      )
    )
  );
};

JourneyDetails.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.string.isRequired,
  journeyId: _propTypes2.default.string.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    activityCourseId: ownProps.params.courseId,
    journeyId: ownProps.params.journeyId
  };
};

exports.default = (0, _withApiData2.default)((0, _reactRedux.connect)(mapStateToProps)(JourneyDetails));

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: 11px 0;\n  padding: 10px 22px;\n  border-radius: 7px;\n  border: 1px solid ', ';\n  background-color: ', ';\n  cursor: pointer;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n'], ['\n  margin: 11px 0;\n  padding: 10px 22px;\n  border-radius: 7px;\n  border: 1px solid ', ';\n  background-color: ', ';\n  cursor: pointer;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  width: 25px;\n  height: 25px;\n  box-shadow: 0 1px 2px 0 rgba(143, 143, 143, 0.35);\n  border: 0.7px solid ', ';\n  background-color: ', ';\n  border-radius: 3.5px;\n  margin-right: 15px;\n'], ['\n  position: relative;\n  width: 25px;\n  height: 25px;\n  box-shadow: 0 1px 2px 0 rgba(143, 143, 143, 0.35);\n  border: 0.7px solid ', ';\n  background-color: ', ';\n  border-radius: 3.5px;\n  margin-right: 15px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  border-top-left-radius: 2.5px;\n  border-top-right-radius: 2.5px;\n  width: 25px;\n  height: 8px;\n  background-color: ', ';\n'], ['\n  position: absolute;\n  border-top-left-radius: 2.5px;\n  border-top-right-radius: 2.5px;\n  width: 25px;\n  height: 8px;\n  background-color: ', ';\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  padding-left: ', ';\n  padding-top: 5px;\n'], ['\n  position: absolute;\n  padding-left: ', ';\n  padding-top: 5px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 15px;\n  width: 25px;\n  position: absolute;\n  z-index: 11;\n  margin-top: 12px;\n  border-bottom-left-radius: 2.8px;\n  border-bottom-right-radius: 2.8px;\n'], ['\n  background-image: url(', ');\n  height: 15px;\n  width: 25px;\n  position: absolute;\n  z-index: 11;\n  margin-top: 12px;\n  border-bottom-left-radius: 2.8px;\n  border-bottom-right-radius: 2.8px;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 25px;\n  width: 30px;\n  margin-right: 11px;\n  position: absolute;\n  z-index: 10;\n  margin-left: -5px;\n  border-bottom-left-radius: 11px;\n'], ['\n  background-image: url(', ');\n  height: 25px;\n  width: 30px;\n  margin-right: 11px;\n  position: absolute;\n  z-index: 10;\n  margin-left: -5px;\n  border-bottom-left-radius: 11px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _immutabilityHelper = __webpack_require__(313);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _reactDnd = __webpack_require__(143);

var _reactDndHtml5Backend = __webpack_require__(314);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _EditOrDeleteMenuButton = __webpack_require__(483);

var _EditOrDeleteMenuButton2 = _interopRequireDefault(_EditOrDeleteMenuButton);

var _ProgressBar = __webpack_require__(723);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _modal = __webpack_require__(26);

var _API = __webpack_require__(247);

var _clouds = __webpack_require__(1719);

var _clouds2 = _interopRequireDefault(_clouds);

var _mountain = __webpack_require__(1720);

var _mountain2 = _interopRequireDefault(_mountain);

var _API2 = __webpack_require__(99);

var _ActivityRow = __webpack_require__(1721);

var _ActivityRow2 = _interopRequireDefault(_ActivityRow);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _util = __webpack_require__(114);

var _useIsExpanded = __webpack_require__(726);

var _mycourses = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LevelContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__LevelContainer',
  componentId: 'sc-11v4866-0'
})(_templateObject, _colors2.default.ash, _colors2.default.white);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__FlexContainer',
  componentId: 'sc-11v4866-1'
})(_templateObject2);

var LevelInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__LevelInfoContainer',
  componentId: 'sc-11v4866-2'
})(_templateObject3);

var LevelIconContainer = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__LevelIconContainer',
  componentId: 'sc-11v4866-3'
})(_templateObject4, _colors2.default.ash, function (props) {
  return props.isMastery ? _colors2.default.amber : _colors2.default.white;
});

var LevelIconHeader = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__LevelIconHeader',
  componentId: 'sc-11v4866-4'
})(_templateObject5, function (props) {
  return props.color;
});

var LevelNumber = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__LevelNumber',
  componentId: 'sc-11v4866-5'
})(_templateObject6, function (props) {
  return props.isTwoDigitNumber ? '4px' : '8px';
});

var Clouds = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__Clouds',
  componentId: 'sc-11v4866-6'
})(_templateObject7, _clouds2.default);

var Mountain = _styledComponents2.default.div.withConfig({
  displayName: 'LevelRow__Mountain',
  componentId: 'sc-11v4866-7'
})(_templateObject8, _mountain2.default);

var LevelRow = function LevelRow(_ref) {
  var apiData = _ref.apiData,
      activityCourseId = _ref.activityCourseId,
      isReadyForEnrollment = _ref.isReadyForEnrollment,
      journeyId = _ref.journeyId,
      level = _ref.level,
      color = _ref.color,
      levels = _ref.levels,
      courseId = _ref.courseId,
      sequenceNumber = _ref.sequenceNumber;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      detailedLevelInfo = _useState2[0],
      setDetailedLevelInfo = _useState2[1];

  var shouldShowActivities = (0, _useIsExpanded.useIsLevelExpanded)(level);

  var _useQuery = (0, _reactQuery.useQuery)(['journey-level-' + level.id], function () {
    return (0, _API.fetchJourneyLevel)(apiData, activityCourseId, journeyId, level.id);
  }, {
    refetchOnWindowFocus: false,
    enabled: shouldShowActivities
  }),
      levelData = _useQuery.data,
      fetchLevelDetails = _useQuery.refetch;

  var _useQuery2 = (0, _reactQuery.useQuery)(['level-activities-' + level.id], function () {
    return (0, _API2.fetchLevelActivities)(apiData, level.id);
  }, {
    refetchOnWindowFocus: false,
    initialData: [],
    enabled: shouldShowActivities
  }),
      activities = _useQuery2.data,
      fetchActivities = _useQuery2.refetch;

  (0, _react.useEffect)(function () {
    if (!!level.just_created) {
      dispatch((0, _mycourses.setLevelIsExpanded)(level.id, true));
      fetchLevelDetails();
      fetchActivities();
    }
  }, []);

  (0, _react.useEffect)(function () {
    if (!!level.just_created) {
      dispatch((0, _mycourses.setLevelIsExpanded)(level.id, true));
    }
  }, [level.just_created]);

  (0, _react.useEffect)(function () {
    if (!!levelData && levelData !== detailedLevelInfo) {
      setDetailedLevelInfo(levelData);
    }
  }, [levelData]);

  (0, _react.useEffect)(function () {
    if (activitiesState !== activities) {
      setActivitiesState((0, _arraySort2.default)(activities, 'sort_order'));
    }
  }, [activities]);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      activitiesState = _useState4[0],
      setActivitiesState = _useState4[1];

  var moveCard = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
    var activitiesStateCopy = [].concat((0, _toConsumableArray3.default)(activitiesState));
    var dragCard = activitiesStateCopy[dragIndex];
    setActivitiesState((0, _immutabilityHelper2.default)(activitiesStateCopy, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
    }));
  }, [activitiesState]);

  var handleActivityCreationModal = function handleActivityCreationModal() {
    dispatch((0, _modal.showModal)('CREATE_ACTIVITY_MODAL', {
      activityCourseId: activityCourseId,
      journeyId: journeyId,
      levelId: level.id
    }));
  };

  var handleClickToDisplayActivityList = function handleClickToDisplayActivityList(e) {
    var isShown = shouldShowActivities;
    if (!isShown) {
      fetchLevelDetails();
      fetchActivities();
    }

    dispatch((0, _mycourses.setLevelIsExpanded)(level.id, !isShown));
  };

  var deleteMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        activityCourseId = _ref2.activityCourseId,
        journeyId = _ref2.journeyId,
        levelId = _ref2.levelId;
    return (0, _API.deleteJourneyLevel)(apiData, activityCourseId, journeyId, levelId);
  });

  var onDeleteClick = function onDeleteClick(apiData, activityCourseId, journeyId) {
    deleteMutation.mutate({
      apiData: apiData,
      activityCourseId: activityCourseId,
      journeyId: journeyId,
      levelId: level.id
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('journey-levels-' + journeyId);
      }
    });
  };

  var handleChosenOption = function handleChosenOption(option) {
    if (option === 'Delete') {
      if (!isReadyForEnrollment) {
        dispatch((0, _modal.showModal)('CLOSE_MODAL', {
          description: 'Are you sure you want to delete this level and all of its contents?',
          supportiveText: 'Once deleted, this cannot be undone.',
          isOptionalTextExist: false,
          deleteFunction: function deleteFunction() {
            return onDeleteClick(apiData, activityCourseId, journeyId, level.id);
          }
        }));
      } else {
        dispatch((0, _modal.showModal)('INFORMATIVE_MODAL', {
          description: 'This level cannot be deleted.',
          supportiveText: 'Once a journey is published, it’s levels cannot be deleted.'
        }));
      }
    }

    if (option === 'Edit Details') {
      fetchLevelDetails().then(function (levelInfo) {
        dispatch((0, _modal.showModal)('CREATE_OR_EDIT_LEVEL_MODAL', {
          apiData: apiData,
          activityCourseId: activityCourseId,
          journeyId: journeyId,
          isCreateLevel: false,
          level: level,
          description: levelInfo.data.description
        }));
      });
    }

    if (option === 'Sort Order') {
      dispatch((0, _modal.showModal)('SORT_LEVEL_ORDER_MODAL', {
        apiData: apiData,
        activityCourseId: activityCourseId,
        journeyId: journeyId,
        levels: levels
      }));
    }
  };

  var listOfActivities = activities !== undefined && activitiesState !== null && activitiesState.map(function (activity, index) {
    return _react2.default.createElement(_ActivityRow2.default, {
      key: 'activity-' + activity.id,
      activity: activity,
      levelId: level.id,
      levels: levels,
      journeyId: journeyId,
      courseId: courseId,
      moveCard: moveCard,
      index: index,
      id: activity.id,
      isReadyForEnrollment: isReadyForEnrollment
    });
  });

  return _react2.default.createElement(
    LevelContainer,
    {
      id: 'level-id-' + level.id,
      onClick: function onClick(e) {
        return typeof e.target.className === 'string' && (e.target.className.includes('LevelRow') || e.target.className.includes('ac-level-name') || e.target.className.includes('H5') || e.target.className.includes('ProgressBar')) && handleClickToDisplayActivityList();
      }
    },
    _react2.default.createElement(
      LevelInfoContainer,
      null,
      _react2.default.createElement(
        FlexContainer,
        null,
        _react2.default.createElement(
          LevelIconContainer,
          { isMastery: level.mastery },
          level.mastery ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(Mountain, null),
            _react2.default.createElement(Clouds, null)
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(LevelIconHeader, { color: (0, _util.cleanHexCode)(color) }),
            _react2.default.createElement(
              LevelNumber,
              { isTwoDigitNumber: sequenceNumber >= 10 },
              sequenceNumber
            )
          )
        ),
        _react2.default.createElement(
          _H2.default,
          { style: { flex: '30%' } },
          _react2.default.createElement(
            'span',
            { className: 'ac-level-name' },
            level.name
          )
        )
      ),
      _react2.default.createElement(
        FlexContainer,
        null,
        _react2.default.createElement(
          _H2.default,
          { style: { flex: '20%' } },
          _react2.default.createElement(
            'span',
            {
              style: { marginRight: '5px' },
              className: 'ac-level-activities-quantity'
            },
            level.quests_count || 0
          ),
          'Activities'
        ),
        _react2.default.createElement(_ProgressBar2.default, {
          progress: level.quests_count > 0 ? (level.quests_count - level.quests_in_draft_count) / level.quests_count * 100 : 0,
          progressBarWidth: '108px'
        }),
        _react2.default.createElement(_EditOrDeleteMenuButton2.default, {
          options: isReadyForEnrollment ? ['Edit Details'] : ['Edit Details', 'Delete', 'Sort Order'],
          handleChosenOption: handleChosenOption
        })
      )
    ),
    shouldShowActivities && _react2.default.createElement(
      'div',
      {
        style: {
          marginTop: '5px',
          marginBottom: '15px'
        }
      },
      !!levelData && detailedLevelInfo !== {} && _react2.default.createElement(
        _P2.default,
        { style: { maxWidth: '800px' } },
        _react2.default.createElement(_MarkdownLabel2.default, { value: detailedLevelInfo.description })
      ),
      _react2.default.createElement(
        _reactDnd.DndProvider,
        { backend: _reactDndHtml5Backend.HTML5Backend },
        _react2.default.createElement(
          'div',
          null,
          listOfActivities
        )
      ),
      !isReadyForEnrollment && _react2.default.createElement(_Button2.default, {
        handleClick: handleActivityCreationModal,
        width: '128px',
        title: '+ Add Activity',
        buttonColor: _colors2.default.white,
        borderColor: _colors2.default.aluminum,
        hoverBackground: _colors2.default.charcoal4,
        hoverColor: _colors2.default.white
      })
    )
  );
};

LevelRow.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourseId: _propTypes2.default.string.isRequired,
  courseId: _propTypes2.default.string.isRequired,
  journeyId: _propTypes2.default.number.isRequired,
  isReadyForEnrollment: _propTypes2.default.bool.isRequired,
  level: _propTypes2.default.object.isRequired,
  color: _propTypes2.default.string.isRequired,
  levels: _propTypes2.default.array.isRequired,
  sequenceNumber: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(LevelRow);

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDQ1IDE4Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIzNC43NSUiIHgyPSI1OS4zJSIgeTE9Ijg5Ljg5NSUiIHkyPSIyOS44OTMlIj48c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkZGIi8+PHN0b3Agb2Zmc2V0PSI1OCUiIHN0b3AtY29sb3I9IiNGREZFRkYiLz48c3RvcCBvZmZzZXQ9Ijc5JSIgc3RvcC1jb2xvcj0iI0Y2RjhGRCIvPjxzdG9wIG9mZnNldD0iOTQlIiBzdG9wLWNvbG9yPSIjRUJFRkZBIi8+PHN0b3Agb2Zmc2V0PSI5OSUiIHN0b3AtY29sb3I9IiNFNEVBRjgiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjU5LjA0OSUiIHgyPSI0Ni45MyUiIHkxPSI4NS40ODElIiB5Mj0iMzcuOTYxJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI0ZGRiIvPjxzdG9wIG9mZnNldD0iNTklIiBzdG9wLWNvbG9yPSIjRkRGRUZGIi8+PHN0b3Agb2Zmc2V0PSI4MCUiIHN0b3AtY29sb3I9IiNGNkY4RkQiLz48c3RvcCBvZmZzZXQ9Ijk1JSIgc3RvcC1jb2xvcj0iI0VCRUZGQSIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iI0U0RUFGOCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Ik0wIDE3LjMwOGM4Ljg3OC40MzQgMTQuOTUzLjMwMSAxOC4yMjUtLjM5NyAxLjA4Ny0uMjMyIDEuNTUxLTEuMDE2IDEuMzkyLTIuMzUzLS4wNjgtMi40MDUtMi4xMS00LjMtNC41NjItNC4yMzQtLjQ4My4wMTMtLjk2MS4xMDMtMS40MTQuMjY3di0uMTM2Yy4wMDItMi4yNjEtMS44NjUtNC4wOTctNC4xNzEtNC4wOTktLjY4NC0uMDAxLTEuMzU4LjE2NC0xLjk2My40NzgtLjAzNy0yLjcxLTIuMzA3LTQuODc3LTUuMDctNC44NDEtLjg1Ny4wMTEtMS42OTYuMjM4LTIuNDM4LjY1OXYxNC42NTV6Ii8+PHBhdGggZmlsbD0idXJsKCNiKSIgZD0iTTQ0LjgxOCAxNy42ODd2LTE3LjU3NmMtMi44ODEuMzk4LTUuMjc4IDIuMzc0LTYuMTc0IDUuMDg4LTIuOTQ3LS44MTQtNi4wMDkuODctNi44MzkgMy43NjFsLS4wNTUuMjA5Yy0xLjk0OS0xLjM3NC00LjY2NS0uOTM4LTYuMDY2Ljk3My0uMzA2LjQxNy0uNTMyLjg4NS0uNjY4IDEuMzgyLTEuNjY0LTEuMzcxLTQuMTQ3LTEuMTYtNS41NDUuNDczLS42LjctLjkyNiAxLjU4Ni0uOTIyIDIuNXYzLjIwMWwyNi4yNjktLjAxMXoiLz48L2c+PC9zdmc+"

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: 11px 0;\n  background: none;\n'], ['\n  margin: 11px 0;\n  background: none;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  padding: ', ';\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  padding: ', ';\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 19px;\n  height: 9px;\n  margin-right: 15px;\n'], ['\n  width: 19px;\n  height: 9px;\n  margin-right: 15px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  width: 32px;\n  height: 32px;\n  background-color: ', ';\n  border-radius: 4px;\n  border: 0.5px solid ', ';\n  margin-right: 15px;\n  position: relative;\n'], ['\n  width: 32px;\n  height: 32px;\n  background-color: ', ';\n  border-radius: 4px;\n  border: 0.5px solid ', ';\n  margin-right: 15px;\n  position: relative;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(143);

var _reactRouterRedux = __webpack_require__(23);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _PublishLabel = __webpack_require__(724);

var _PublishLabel2 = _interopRequireDefault(_PublishLabel);

var _modal = __webpack_require__(26);

var _ItemTypes = __webpack_require__(248);

var _SortOrder = __webpack_require__(249);

var _SortOrder2 = _interopRequireDefault(_SortOrder);

var _EditOrDeleteMenuButton = __webpack_require__(483);

var _EditOrDeleteMenuButton2 = _interopRequireDefault(_EditOrDeleteMenuButton);

var _P = __webpack_require__(75);

var _P2 = _interopRequireDefault(_P);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _API = __webpack_require__(99);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _FixedAlignmentBox = __webpack_require__(725);

var _FixedAlignmentBox2 = _interopRequireDefault(_FixedAlignmentBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneyContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityRow__JourneyContainer',
  componentId: 'm05hwq-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityRow__FlexContainer',
  componentId: 'm05hwq-1'
})(_templateObject2);

var JourneyInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityRow__JourneyInfoContainer',
  componentId: 'm05hwq-2'
})(_templateObject3, function (props) {
  return props.hasKebab ? '4px 10px' : '10px 22px 10px 10px';
});

var SortIcon = _styledComponents2.default.img.attrs({
  src: _SortOrder2.default
}).withConfig({
  displayName: 'ActivityRow__SortIcon',
  componentId: 'm05hwq-3'
})(_templateObject4);

var ActivityIconContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityRow__ActivityIconContainer',
  componentId: 'm05hwq-4'
})(_templateObject5, _colors2.default.ash, _colors2.default.rock);

var ActivityRow = function ActivityRow(_ref) {
  var apiData = _ref.apiData,
      activity = _ref.activity,
      levelId = _ref.levelId,
      levels = _ref.levels,
      journeyId = _ref.journeyId,
      courseId = _ref.courseId,
      moveCard = _ref.moveCard,
      index = _ref.index,
      id = _ref.id,
      handleShouldExpandLevel = _ref.handleShouldExpandLevel,
      isReadyForEnrollment = _ref.isReadyForEnrollment;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var ref = (0, _react.useRef)(null);

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: _ItemTypes.ItemTypes.ACTIVITY_ROW,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover: function hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      var dragIndex = item.index;
      var hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      var hoverBoundingRect = ref.current.getBoundingClientRect();
      // Get vertical middle
      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      var clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      var hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
    drop: function drop(item) {
      var index = item.index - 1 === -1 ? 0 : item.index;
      (0, _API.reorderActivities)(apiData, levelId, id, index);
    }
  }),
      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
      handlerId = _useDrop2[0].handlerId,
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: _ItemTypes.ItemTypes.ACTIVITY_ROW,
    item: function item() {
      return { id: id, index: index };
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  var deleteMutation = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityId = _ref2.activityId;
    return (0, _API.deleteLevelActivity)(apiData, levelId, activityId);
  });
  var onDeleteClick = function onDeleteClick(apiData, levelId, activityId) {
    deleteMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityId: activityId
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('level-activities-' + levelId);
        queryClient.invalidateQueries('journey-levels-' + journeyId);
      }
    });
  };

  var handleClick = function handleClick(e) {
    dispatch((0, _reactRouterRedux.push)('/mycourses/' + courseId + '/journey/' + journeyId + '/level/' + levelId + '/activityQuest/' + activity.id));
    e.stopPropagation();
  };

  var handleClose = function handleClose(option) {
    if (option === 'Delete') {
      dispatch((0, _modal.showModal)('CLOSE_MODAL', {
        description: 'Are you sure you want to delete this activity?',
        supportiveText: 'Once deleted, this cannot be undone.',
        isOptionalTextExist: false,
        deleteFunction: function deleteFunction() {
          return onDeleteClick(apiData, levelId, activity.id);
        }
      }));
    }

    if (option === 'Level Placement') {
      dispatch((0, _modal.showModal)('CHANGE_LEVEL_FOR_ACTIVITY_MODAL', {
        levels: levels,
        currentLevelId: levelId,
        activityQuestId: activity.id,
        activityQuestName: activity.name,
        handleShouldExpandLevel: handleShouldExpandLevel,
        courseId: courseId,
        journeyId: journeyId
      }));
    }
  };

  return _react2.default.createElement(
    'div',
    { style: { boxShadow: 'none' }, ref: !isReadyForEnrollment ? ref : null },
    _react2.default.createElement(
      JourneyContainer,
      null,
      _react2.default.createElement(
        FlexContainer,
        null,
        !isReadyForEnrollment && _react2.default.createElement(SortIcon, null),
        _react2.default.createElement(
          JourneyInfoContainer,
          { hasKebab: !isReadyForEnrollment },
          _react2.default.createElement(
            ActivityIconContainer,
            null,
            activity.icon_image_url !== null && _react2.default.createElement('img', {
              src: activity.icon_image_url,
              style: {
                width: '32px',
                height: '32px',
                position: 'absolute'
              }
            })
          ),
          _react2.default.createElement(
            _H2.default,
            {
              style: { flex: '30%' },
              onClick: handleClick
            },
            activity.name
          ),
          _react2.default.createElement(
            _P2.default,
            {
              style: { marginRight: '15px' },
              onClick: handleClick
            },
            _react2.default.createElement(
              'span',
              null,
              'Last saved: '
            ),
            _moment2.default.unix(activity.updated_at).format('DD MMMM YYYY').toString()
          ),
          _react2.default.createElement(
            _FixedAlignmentBox2.default,
            { justify: 'center', width: '86px',
              onClick: handleClick
            },
            _react2.default.createElement(_PublishLabel2.default, { isPublished: !activity.in_draft })
          ),
          !isReadyForEnrollment && _react2.default.createElement(_EditOrDeleteMenuButton2.default, {
            options: ['Delete', 'Level Placement'],
            handleChosenOption: handleClose
          })
        )
      )
    )
  );
};

ActivityRow.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activity: _propTypes2.default.object.isRequired,
  levelId: _propTypes2.default.number.isRequired,
  levels: _propTypes2.default.array.isRequired,
  courseId: _propTypes2.default.string.isRequired,
  moveCard: _propTypes2.default.func.isRequired,
  index: _propTypes2.default.number.isRequired,
  id: _propTypes2.default.number.isRequired,
  handleShouldExpandLevel: _propTypes2.default.func.isRequired,
  isReadyForEnrollment: _propTypes2.default.bool
};

exports.default = (0, _withApiData2.default)(ActivityRow);

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjcwMiA1LjJINC4zMDVMNy4xOSAyLjIyYTEuMzE4IDEuMzE4IDAgMDAwLTEuODM5IDEuMjI2IDEuMjI2IDAgMDAtMS43MzYtLjA0bC0uMDQxLjA0LTUuMDM4IDUuMmExLjMxNiAxLjMxNiAwIDAwMCAxLjgzOGw1LjAzOCA1LjJhMS4yMjYgMS4yMjYgMCAwMDEuNzc2IDAgMS4zMTYgMS4zMTYgMCAwMDAtMS44MzhsLTIuODg0LTIuOThoMTAuMzk3YTEuMyAxLjMgMCAwMC4wMDEtMi42MDIiIGZpbGw9IiNCQkIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjcwMiA1LjJINC4zMDVMNy4xOSAyLjIyYTEuMzE4IDEuMzE4IDAgMDAwLTEuODM5IDEuMjI2IDEuMjI2IDAgMDAtMS43MzYtLjA0bC0uMDQxLjA0LTUuMDM4IDUuMmExLjMxNiAxLjMxNiAwIDAwMCAxLjgzOGw1LjAzOCA1LjJhMS4yMjYgMS4yMjYgMCAwMDEuNzc2IDAgMS4zMTYgMS4zMTYgMCAwMDAtMS44MzhsLTIuODg0LTIuOThoMTAuMzk3YTEuMyAxLjMgMCAwMC4wMDEtMi42MDIiIGZpbGw9IiM2NjYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.ActivityDetails = undefined;

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 820px;\n  margin: auto;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 820px;\n  margin: auto;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  margin-top: 55px;\n  margin-bottom: 18px;\n'], ['\n  width: 100%;\n  margin-top: 55px;\n  margin-bottom: 18px;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  box-sizing: border-box;\n  padding: 24px;\n  border-radius: 4px;\n  ', ';\n'], ['\n  width: 100%;\n  box-sizing: border-box;\n  padding: 24px;\n  border-radius: 4px;\n  ', ';\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  height: 52px;\n  width: 52px;\n  background-color: #D8D8D8;\n  box-shadow: 0 0 0 1.3px #979797;\n  margin: 1.3px;\n  margin-right: 15px;\n  border-radius: 6.5px;\n  cursor: ', ';\n'], ['\n  height: 52px;\n  width: 52px;\n  background-color: #D8D8D8;\n  box-shadow: 0 0 0 1.3px #979797;\n  margin: 1.3px;\n  margin-right: 15px;\n  border-radius: 6.5px;\n  cursor: ', ';\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 23px;\n  width: 23px;\n  background-repeat: no-repeat;\n  margin-right: 11px;\n  margin-left: 18px;\n  margin-top: 16px;\n'], ['\n  background-image: url(', ');\n  height: 23px;\n  width: 23px;\n  background-repeat: no-repeat;\n  margin-right: 11px;\n  margin-left: 18px;\n  margin-top: 16px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background-color: #000;\n  opacity: 0.4;\n  width: 52px;\n  height: 52px;\n  position: absolute;\n  border-radius: 6.5px;\n'], ['\n  background-color: #000;\n  opacity: 0.4;\n  width: 52px;\n  height: 52px;\n  position: absolute;\n  border-radius: 6.5px;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 27pxpx;\n  margin: 0 14px 0 0;\n'], ['\n  color: ', ';\n  font-family: Montserrat, sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 27pxpx;\n  margin: 0 14px 0 0;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactRouterRedux = __webpack_require__(23);

var _moment = __webpack_require__(112);

var _moment2 = _interopRequireDefault(_moment);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _modal = __webpack_require__(26);

var _convertToRomanNumerals = __webpack_require__(310);

var _EditWhite = __webpack_require__(1725);

var _EditWhite2 = _interopRequireDefault(_EditWhite);

var _API = __webpack_require__(99);

var _Caption = __webpack_require__(67);

var _Caption2 = _interopRequireDefault(_Caption);

var _Caption3 = __webpack_require__(1726);

var _Caption4 = _interopRequireDefault(_Caption3);

var _H = __webpack_require__(85);

var _H2 = _interopRequireDefault(_H);

var _EditActivityDetails = __webpack_require__(1727);

var _EditActivityDetails2 = _interopRequireDefault(_EditActivityDetails);

var _ReadOnlyActivityData = __webpack_require__(1733);

var _ReadOnlyActivityData2 = _interopRequireDefault(_ReadOnlyActivityData);

var _API2 = __webpack_require__(246);

var _API3 = __webpack_require__(247);

var _util = __webpack_require__(114);

var _BackButton = __webpack_require__(728);

var _BackButton2 = _interopRequireDefault(_BackButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__PageContainer',
  componentId: 'sc-14b6csc-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__FlexContainer',
  componentId: 'sc-14b6csc-1'
})(_templateObject2);

var HeaderContainer = (0, _styledComponents2.default)(FlexContainer).withConfig({
  displayName: 'ActivityDetails__HeaderContainer',
  componentId: 'sc-14b6csc-2'
})(_templateObject3);

var ActivityContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__ActivityContainer',
  componentId: 'sc-14b6csc-3'
})(_templateObject4, function (props) {
  return !props.isEditing && 'background-color: ' + _colors2.default.white;
});

var ImageContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__ImageContainer',
  componentId: 'sc-14b6csc-4'
})(_templateObject5, function (props) {
  return props.isEditable ? 'pointer' : 'default';
});

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__EditIcon',
  componentId: 'sc-14b6csc-5'
})(_templateObject6, _EditWhite2.default);

var HoveredBackground = _styledComponents2.default.div.withConfig({
  displayName: 'ActivityDetails__HoveredBackground',
  componentId: 'sc-14b6csc-6'
})(_templateObject7);

var Title = _styledComponents2.default.h2.withConfig({
  displayName: 'ActivityDetails__Title',
  componentId: 'sc-14b6csc-7'
})(_templateObject8, _colors2.default.victoria);

var ActivityDetails = exports.ActivityDetails = function ActivityDetails(_ref) {
  var apiData = _ref.apiData,
      courseId = _ref.courseId,
      journeyId = _ref.journeyId,
      levelId = _ref.levelId,
      activityQuestId = _ref.activityQuestId;

  var dispatch = (0, _reactRedux.useDispatch)();
  var gradeLevels = (0, _reactRedux.useSelector)(function (state) {
    return state.gradelevels.items;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var navigationPathname = (0, _reactRedux.useSelector)(function (state) {
    return state.navigation.currentPath;
  });
  var isEdit = navigationPathname.split('/')[9] === 'edit';

  var _useQuery = (0, _reactQuery.useQuery)(['activity-course-' + courseId], function () {
    return (0, _API2.fetchActivityCourse)(apiData.orgId, apiData.token, courseId);
  }, {
    refetchOnWindowFocus: false
  }),
      isActivityCourseLoading = _useQuery.isLoading,
      activityCourse = _useQuery.data;

  var _useQuery2 = (0, _reactQuery.useQuery)(['activity-course-journey-' + journeyId], function () {
    return (0, _API2.fetchActivityCourseJourney)(apiData.orgId, apiData.token, courseId, journeyId);
  }, {
    refetchOnWindowFocus: false
  }),
      isJourneyLoading = _useQuery2.isLoading,
      journey = _useQuery2.data;

  var _useState3 = (0, _react.useState)(isEdit),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      isEditLink = _useState4[0],
      setIsEditLink = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      isEditingActivity = _useState6[0],
      setIsEditingActivity = _useState6[1];

  var _useQuery3 = (0, _reactQuery.useQuery)(['activity-' + activityQuestId], function () {
    return (0, _API.fetchSingleActivity)(apiData, levelId, activityQuestId);
  }, {
    refetchOnWindowFocus: false
  }),
      isActivityLoading = _useQuery3.isLoading,
      activity = _useQuery3.data;

  var _useQuery4 = (0, _reactQuery.useQuery)(['mentorFiles-' + activityQuestId], function () {
    return (0, _API.fetchMentorFiles)(apiData, levelId, activityQuestId);
  }, {
    refetchOnWindowFocus: false
  }),
      isMentorFilesLoading = _useQuery4.isLoading,
      mentorFiles = _useQuery4.data;

  var _useQuery5 = (0, _reactQuery.useQuery)(['resources-' + activityQuestId], function () {
    return (0, _API.fetchResources)(apiData, levelId, activityQuestId);
  }, {
    refetchOnWindowFocus: false
  }),
      isResourcesLoading = _useQuery5.isLoading,
      resources = _useQuery5.data;

  var _useQuery6 = (0, _reactQuery.useQuery)(['linked-skills-' + activityQuestId], function () {
    return (0, _API.fetchLinkedSkills)(apiData, levelId, activityQuestId);
  }, {
    refetchOnWindowFocus: false
  }),
      isLinkedSkillsLoading = _useQuery6.isLoading,
      linkedSkills = _useQuery6.data;

  var _useQuery7 = (0, _reactQuery.useQuery)(['journey-level-' + levelId], function () {
    return (0, _API3.fetchJourneyLevel)(apiData, courseId, journeyId, levelId);
  }, {
    refetchOnWindowFocus: false
  }),
      isLevelDataLoading = _useQuery7.isLoading,
      levelData = _useQuery7.data;

  var handleCloseEditMode = function handleCloseEditMode() {
    setIsEditLink(false);
    setIsEditingActivity(false);
  };

  var onReturnToDraft = function onReturnToDraft() {
    setIsEditingActivity(true);
  };

  var handleEditClick = function handleEditClick() {
    if (activity.in_draft) {
      setIsEditingActivity(true);
    } else {
      dispatch((0, _modal.showModal)('EDIT_PUBLISHED_ACTIVITY_MODAL', {
        levelId: levelId,
        activityQuestId: activityQuestId,
        onReturnToDraft: onReturnToDraft
      }));
    }
  };

  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _modal.hideModal)());
    };
  }, []);

  var isStringValueSet = function isStringValueSet(value) {
    return !!value && value.trim().length > 0;
  };

  var isActivityPublishable = !isActivityLoading && activity.in_draft && isStringValueSet(activity.icon_image_url) && isStringValueSet(activity.name) && isStringValueSet(activity.driving_question) && isStringValueSet(activity.goals) && isStringValueSet(activity.description) && isStringValueSet(activity.goals) && (activity.checkpoint === true && activity.work_product === true ? !!activity.artifact_description && !!activity.artifact_type_id : true);

  var gradeLevel = !!activityCourse && gradeLevels.find(function (gl) {
    return gl.id === activityCourse.grade_level_id;
  });

  var isEditing = isEditLink || isEditingActivity;

  (0, _react.useLayoutEffect)(function () {
    if (isEditing) {
      document.querySelector('#side-nav').classList.add('hidden');

      return function () {
        var sideNav = document.querySelector('#side-nav');
        if (sideNav) {
          sideNav.classList.remove('hidden');
        }
      };
    } else {
      window.scrollTo(0, 0);
    }
  }, [isEditing]);

  return _react2.default.createElement(
    'div',
    null,
    isActivityLoading || isJourneyLoading || isActivityCourseLoading || isLevelDataLoading || isMentorFilesLoading || isResourcesLoading ? _react2.default.createElement('div', { className: 'loading' }) : _react2.default.createElement(
      _react2.default.Fragment,
      null,
      !isEditing && _react2.default.createElement(_BackButton2.default, {
        backToWhere: 'Journey',
        onClick: function onClick() {
          return dispatch((0, _reactRouterRedux.push)('/mycourses/' + courseId + '/journey/' + journeyId));
        }
      }),
      _react2.default.createElement(
        PageContainer,
        null,
        _react2.default.createElement(
          HeaderContainer,
          null,
          _react2.default.createElement(
            FlexContainer,
            null,
            _react2.default.createElement(
              ImageContainer,
              {
                isEditable: activity.in_draft,
                onClick: activity.in_draft ? function () {
                  return dispatch((0, _modal.showModal)('ADD_OR_REMOVE_ACTIVITY_ICON_MODAL', {
                    apiData: apiData,
                    levelId: levelId,
                    activityQuestId: activityQuestId,
                    activity: activity
                  }));
                } : null
              },
              activity.icon_image_url === null ? _react2.default.createElement(EditIcon, null) : _react2.default.createElement(
                'div',
                {
                  style: {
                    width: '52px',
                    height: '52px',
                    position: 'relative'
                  },
                  onMouseEnter: function onMouseEnter() {
                    return setIsHovered(true);
                  },
                  onMouseLeave: function onMouseLeave() {
                    return setIsHovered(false);
                  }
                },
                activity.in_draft && isHovered && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(HoveredBackground, null),
                  _react2.default.createElement(
                    'div',
                    {
                      style: {
                        position: 'absolute',
                        marginLeft: '15px',
                        marginTop: '16px'
                      }
                    },
                    _react2.default.createElement(
                      'svg',
                      {
                        width: '25',
                        height: '25',
                        xmlns: 'http://www.w3.org/2000/svg'
                      },
                      _react2.default.createElement('path', {
                        d: 'M11.829 3.6l2.7 2.7L4.114 16.714 0 18l1.414-3.986L11.83 3.6zM17.42.579c.772.771.772 1.928 0 2.571l-1.414 1.414-2.571-2.571L14.85.579c.771-.772 1.929-.772 2.571 0z',
                        fill: '#ffffff',
                        'fill-rule': 'nonzero'
                      })
                    )
                  )
                ),
                _react2.default.createElement('img', {
                  src: activity.icon_image_url,
                  style: {
                    width: '52px',
                    height: '52px',
                    borderRadius: '6.5px'
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Caption4.default,
                {
                  style: { color: (0, _util.cleanHexCode)(activityCourse.color) }
                },
                _react2.default.createElement(
                  'span',
                  { style: { marginRight: '10px' } },
                  activityCourse.abbreviation + ' / ' + gradeLevel.abbreviation + ': '
                ),
                _react2.default.createElement(
                  'span',
                  { style: { marginRight: '10px' } },
                  (0, _convertToRomanNumerals.convertToRomanNumerals)(journey.master_course_course.index + 1) + '. ' + journey.name
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  levelData.name
                )
              ),
              _react2.default.createElement(
                Title,
                null,
                activity.name
              )
            )
          ),
          !isEditing ? activity.in_draft ? _react2.default.createElement(
            'div',
            {
              'data-for': 'publishActivityTooltip',
              'data-tip': 'Please enter all required fields prior to publishing this activity.'
            },
            _react2.default.createElement(_Button2.default, {
              width: '184px',
              title: 'Publish Activity',
              buttonColor: _colors2.default.oeYellow,
              borderColor: _colors2.default.oeYellow,
              hoverBackground: _colors2.default.charcoal4,
              hoverColor: _colors2.default.white,
              shouldShowTooltip: true,
              shouldShowTooltipAndDisableButton: !isActivityPublishable,
              handleClick: isActivityPublishable ? function () {
                dispatch((0, _modal.showModal)('PUBLISH_ACTIVITY_MODAL', {
                  levelId: levelId,
                  activityQuestId: activityQuestId,
                  onPublish: handleCloseEditMode
                }));
              } : null
            }),
            !isActivityPublishable && _react2.default.createElement(_reactTooltip2.default, {
              id: 'publishActivityTooltip',
              place: 'bottom',
              effect: 'solid',
              className: 'activityCourseTooltip'
            })
          ) : _react2.default.createElement(
            FlexContainer,
            {
              style: {
                flexDirection: 'column',
                alignItems: 'flex-end'
              }
            },
            _react2.default.createElement(
              _H2.default,
              { style: { color: _colors2.default.jade } },
              'Published'
            ),
            _react2.default.createElement(
              _Caption2.default,
              null,
              _moment2.default.unix(activity.last_published_at).format('DD MMMM YYYY').toString()
            )
          ) : null
        ),
        _react2.default.createElement(
          ActivityContainer,
          { isEditing: isEditing },
          !isEditing ? _react2.default.createElement(_ReadOnlyActivityData2.default, {
            activity: activity,
            mentorFiles: mentorFiles,
            resources: (0, _arraySort2.default)(resources, 'sort_order'),
            linkedSkills: linkedSkills,
            handleClick: handleEditClick,
            isDraft: activity.in_draft
          }) : _react2.default.createElement(_EditActivityDetails2.default, {
            activity: activity,
            mentorFiles: mentorFiles,
            resources: resources,
            linkedSkills: linkedSkills,
            activityName: activity.name,
            activityId: activityQuestId,
            levelId: levelId,
            handleCloseEditMode: handleCloseEditMode,
            isEditLink: isEditLink
          })
        )
      )
    )
  );
};

ActivityDetails.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  courseId: _propTypes2.default.string.isRequired,
  journeyId: _propTypes2.default.string.isRequired,
  levelId: _propTypes2.default.string.isRequired,
  activityQuestId: _propTypes2.default.string.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    courseId: ownProps.params.courseId,
    journeyId: ownProps.params.journeyId,
    levelId: ownProps.params.levelId,
    activityQuestId: ownProps.params.activityQuestId
  };
};

exports.default = (0, _withApiData2.default)((0, _reactRedux.connect)(mapStateToProps)(ActivityDetails));

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjgyOSAzLjZsMi43IDIuN0w0LjExNCAxNi43MTQgMCAxOGwxLjQxNC0zLjk4NkwxMS44MyAzLjZ6TTE3LjQyLjU3OWMuNzcyLjc3MS43NzIgMS45MjggMCAyLjU3MWwtMS40MTQgMS40MTQtMi41NzEtMi41NzFMMTQuODUuNTc5Yy43NzEtLjc3MiAxLjkyOS0uNzcyIDIuNTcxIDB6IiBmaWxsPSIjZmZmZmZmIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 13px;\n'], ['\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 13px;\n']);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caption6 = _styledComponents2.default.div.withConfig({
  displayName: 'Caption6',
  componentId: 'xbdr61-0'
})(_templateObject);

exports.default = Caption6;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(156);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-content: center;\n  align-items: flex-start;\n  justify-content: flex-end;\n  ', ';\n'], ['\n  display: flex;\n  align-content: center;\n  align-items: flex-start;\n  justify-content: flex-end;\n  ', ';\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactQuery = __webpack_require__(34);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _immutabilityHelper = __webpack_require__(313);

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _reactDnd = __webpack_require__(143);

var _reactDndHtml5Backend = __webpack_require__(314);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _TextInputComponent = __webpack_require__(127);

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _MarginRight = __webpack_require__(78);

var _MarginRight2 = _interopRequireDefault(_MarginRight);

var _CancelButton = __webpack_require__(77);

var _CancelButton2 = _interopRequireDefault(_CancelButton);

var _Button = __webpack_require__(42);

var _Button2 = _interopRequireDefault(_Button);

var _SelectorComponent = __webpack_require__(245);

var _SelectorComponent2 = _interopRequireDefault(_SelectorComponent);

var _API = __webpack_require__(99);

var _getTheActivityTypeFunction = __webpack_require__(729);

var _ErrorMessage = __webpack_require__(715);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _modal = __webpack_require__(26);

var _MentorFileRow = __webpack_require__(1728);

var _MentorFileRow2 = _interopRequireDefault(_MentorFileRow);

var _ResourceRow = __webpack_require__(1729);

var _ResourceRow2 = _interopRequireDefault(_ResourceRow);

var _markdowneditor = __webpack_require__(142);

var _EditLinkedSkills = __webpack_require__(1730);

var _EditLinkedSkills2 = _interopRequireDefault(_EditLinkedSkills);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorButtonsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'EditActivityDetails__EditorButtonsWrapper',
  componentId: 'sc-10e3nxy-0'
})(_templateObject, function (props) {
  return props.top ? '\n    position: absolute;\n    top: 62px;\n    right: 0;\n  ' : '\n    margin-top: 30px;\n  ';
});

var activityTypeOptions = [{
  id: 1,
  name: 'Artifact Required / Check-in',
  label: 'Artifact Required / Check-in',
  sort_order: 0
}, { id: 2, name: 'Check-in Only', label: 'Check-in Only', sort_order: 1 }, { id: 3, name: 'No Check-in', label: 'No Check-in', sort_order: 2 }];

var EditorButtons = function EditorButtons(_ref) {
  var handleCloseEditMode = _ref.handleCloseEditMode,
      handleSaveEditedActivity = _ref.handleSaveEditedActivity,
      errorQuantity = _ref.errorQuantity,
      top = _ref.top;
  return _react2.default.createElement(
    EditorButtonsWrapper,
    { top: top },
    _react2.default.createElement(
      _MarginRight2.default,
      null,
      _react2.default.createElement(_CancelButton2.default, {
        handleClick: handleCloseEditMode,
        title: 'Cancel',
        width: '104px'
      })
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_Button2.default, {
        width: '125px',
        title: 'Save Draft',
        handleClick: handleSaveEditedActivity,
        buttonColor: _colors2.default.oeYellow,
        borderColor: _colors2.default.oeYellow,
        hoverBackground: _colors2.default.charcoal4,
        hoverColor: _colors2.default.white,
        couldSaveData: errorQuantity === 0,
        shouldShowTooltipAndDisableButton: true
      }),
      errorQuantity > 0 && _react2.default.createElement(
        _ErrorMessage2.default,
        null,
        'Oops! ',
        errorQuantity,
        ' errors found.'
      )
    )
  );
};

var EditActivityDetails = function EditActivityDetails(_ref2) {
  var apiData = _ref2.apiData,
      activity = _ref2.activity,
      _ref2$mentorFiles = _ref2.mentorFiles,
      mentorFiles = _ref2$mentorFiles === undefined ? [] : _ref2$mentorFiles,
      _ref2$resources = _ref2.resources,
      resources = _ref2$resources === undefined ? [] : _ref2$resources,
      _ref2$linkedSkills = _ref2.linkedSkills,
      passedLinkedSkills = _ref2$linkedSkills === undefined ? [] : _ref2$linkedSkills,
      levelId = _ref2.levelId,
      handleCloseEditMode = _ref2.handleCloseEditMode;

  var dispatch = (0, _reactRedux.useDispatch)();

  var queryClient = (0, _reactQuery.useQueryClient)();
  var artifactTypes = (0, _reactRedux.useSelector)(function (state) {
    return state.artifacttypes.items;
  });
  var artifactType = !!activity && artifactTypes.find(function (at) {
    return at.id === activity.artifact_type_id;
  });

  var _useState = (0, _react.useState)(activity.name),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      activityNameState = _useState2[0],
      setActivityName = _useState2[1];

  var handleActivityName = function handleActivityName(e) {
    setActivityName(e.target.value);
  };

  var _useState3 = (0, _react.useState)((0, _getTheActivityTypeFunction.getTheActivityType)(activity)),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedActivityType = _useState4[0],
      setSelectedActivityType = _useState4[1];

  var handleSelectedActivityType = function handleSelectedActivityType(e) {
    if (e.id !== 1) {
      setArtifactDescription(null);
      setSelectedArtifactType(null);
    }
    setSelectedActivityType(e);
  };

  var _useState5 = (0, _react.useState)(activity.artifact_type_id !== null ? artifactType : null),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      selectedArtifactType = _useState6[0],
      setSelectedArtifactType = _useState6[1];

  var handleSelectedArtifactType = function handleSelectedArtifactType(e) {
    setSelectedArtifactType(e);
  };

  var _useState7 = (0, _react.useState)(activity.artifact_description !== null ? activity.artifact_description : null),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      artifactDescription = _useState8[0],
      setArtifactDescription = _useState8[1];

  var handleArtifactDescription = function handleArtifactDescription(e) {
    setArtifactDescription(e.target.value);
  };

  var _useState9 = (0, _react.useState)(activity.driving_question !== null ? activity.driving_question : null),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      drivingQuestion = _useState10[0],
      setDrivingQuestion = _useState10[1];

  var handleDrivingQuestion = function handleDrivingQuestion(e) {
    setDrivingQuestion(e.target.value);
  };

  var _useState11 = (0, _react.useState)(activity.goals !== null ? activity.goals : null),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      activityGoals = _useState12[0],
      setActivityGoals = _useState12[1];

  var handleActivityGoals = function handleActivityGoals(e) {
    setActivityGoals(e.target.value);
  };

  var _useState13 = (0, _react.useState)(passedLinkedSkills),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      linkedSkills = _useState14[0],
      setLinkedSkills = _useState14[1];

  var _useState15 = (0, _react.useState)(activity.description !== null ? activity.description : null),
      _useState16 = (0, _slicedToArray3.default)(_useState15, 2),
      activityDescription = _useState16[0],
      setActivityDescription = _useState16[1];

  var handleActivityDescription = function handleActivityDescription(e) {
    var event = {
      target: {}
    };
    event.target.id = 'activity-details';
    event.target.value = e;

    setActivityDescription(event.target.value);
  };

  var _useState17 = (0, _react.useState)(activity.mentor_notes !== null ? activity.mentor_notes : null),
      _useState18 = (0, _slicedToArray3.default)(_useState17, 2),
      mentorNotes = _useState18[0],
      setMentorNotes = _useState18[1];

  var handleMentorNotes = function handleMentorNotes(e) {
    var event = {
      target: {}
    };
    event.target.id = 'activity-details';
    event.target.value = e;

    setMentorNotes(event.target.value);
  };

  var _useState19 = (0, _react.useState)(activity.mentor_assessment_questions !== null ? activity.mentor_assessment_questions : null),
      _useState20 = (0, _slicedToArray3.default)(_useState19, 2),
      mentorAssessmentQuestions = _useState20[0],
      setMentorAssessmentQuestions = _useState20[1];

  var handleMentorAssessmentQuestions = function handleMentorAssessmentQuestions(e) {
    var event = {
      target: {}
    };
    event.target.id = 'activity-details';
    event.target.value = e;

    setMentorAssessmentQuestions(event.target.value);
  };

  var editActivityMutation = (0, _reactQuery.useMutation)(function (_ref3) {
    var apiData = _ref3.apiData,
        levelId = _ref3.levelId,
        updatedActivityData = _ref3.updatedActivityData;
    return (0, _API.editLevelActivity)(apiData, levelId, updatedActivityData);
  });

  // saves linked skills and updates the ordering of the skills if needed
  var saveLinkedSkills = function saveLinkedSkills() {
    return new _promise2.default(function (resolve) {
      var toDelete = [];
      var toAdd = [];
      // traverse skills backward
      var i = passedLinkedSkills.length - 1;
      var j = linkedSkills.length - 1;
      // always step through the old list (which is what's currently on the BE)
      for (; i >= 0 && j >= 0; i--) {
        if (passedLinkedSkills[i].framework_skill_id === linkedSkills[j].framework_skill_id) {
          // there's no discrepancy here, we can step through the new list as well
          j--;
        } else {
          // there is a discrepancy, this means that either
          // passedLinkedSkills[i] was deleted OR
          // it was moved higher in the ordering, and we have to delete and re-add later
          toDelete.push(passedLinkedSkills[i]);
        }
      }
      // if we have leftover in passedLinkedSkills, that means we already matched
      // everything in linkedSkills, so what's left isn't there and must be deleted
      for (; i >= 0; i--) {
        toDelete.push(passedLinkedSkills[i]);
      } // anything leftover in linkedSkills wasn't matched in passedLinkedSkills,
      // either because it didn't exist or it was in the wrong spot and got added
      // to toDelete. Either way we need to add it
      for (; j >= 0; j--) {
        toAdd.push(linkedSkills[j]);
      } // delete, make a promise to wait for all deletions to finish
      var deletionPromise = _promise2.default.all(toDelete.map(function (s) {
        return (0, _API.deleteLinkedSkill)(apiData, levelId, activity.id, s.framework_skill_id);
      }));
      // add sequentially, waiting for previous add (or deletion) to finish
      toAdd.reduce(function (prev, curr) {
        return (// prev is a promise, curr is a skill
          prev.then(function () {
            return (// chain the promises
              (0, _API.addLinkedSkill)(apiData, levelId, activity.id, curr.framework_skill_id)
            );
          })
        );
      }, deletionPromise // initial thing to wait for is all the deletions
      ).then(
      // invalidate queries only after all modifications are done
      function () {
        return queryClient.invalidateQueries('linked-skills-' + activity.id);
      }).then(function () {
        return resolve();
      });
    });
  };

  var handleSaveEditedActivity = function handleSaveEditedActivity() {
    var linkedSkillsPromise = saveLinkedSkills();

    var updatedActivityData = {
      id: activity.id,
      name: activityNameState,
      description: activityDescription,
      driving_question: drivingQuestion,
      goals: activityGoals,
      artifact_description: selectedActivityType === null ? null : selectedActivityType.id !== 1 && artifactDescription === null ? null : artifactDescription,
      artifact_type_id: selectedActivityType === null ? null : selectedArtifactType === null ? null : selectedArtifactType.id,
      checkpoint: selectedActivityType !== null ? selectedActivityType.label === 'Check-in Only' || selectedActivityType.label === 'Artifact Required / Check-in' : false,
      work_product: selectedActivityType !== null ? selectedActivityType.label === 'Artifact Required / Check-in' : false,
      mentor_notes: mentorNotes,
      mentor_assessment_questions: mentorAssessmentQuestions
    };

    var activityEditPromise = new _promise2.default(function (resolve) {
      return editActivityMutation.mutate({
        apiData: apiData,
        levelId: levelId,
        updatedActivityData: updatedActivityData
      }, {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries('activity-' + activity.id);
          queryClient.invalidateQueries('mentorFiles-' + activity.id);
          queryClient.invalidateQueries('resources-' + activity.id);

          resolve();
        }
      });
    });

    _promise2.default.all([activityEditPromise, linkedSkillsPromise]).then(function () {
      return handleCloseEditMode();
    });
  };

  var _useState21 = (0, _react.useState)(mentorFiles),
      _useState22 = (0, _slicedToArray3.default)(_useState21, 2),
      mentorFilesState = _useState22[0],
      setMentorFilesState = _useState22[1];

  (0, _react.useEffect)(function () {
    if (mentorFilesState !== mentorFiles) {
      setMentorFilesState((0, _arraySort2.default)(mentorFiles, 'sort_order'));
    }
  }, [mentorFiles]);

  var moveMentorFileCard = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
    var mentorFilesStateCopy = [].concat((0, _toConsumableArray3.default)(mentorFilesState));
    var dragCard = mentorFilesStateCopy[dragIndex];
    setMentorFilesState((0, _immutabilityHelper2.default)(mentorFilesStateCopy, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
    }));
  }, [mentorFilesState]);

  var listOfMentorFiles = mentorFilesState.map(function (mentorFile, index) {
    return _react2.default.createElement(_MentorFileRow2.default, {
      activityQuestId: activity.id,
      levelId: levelId,
      mentorFile: mentorFile,
      index: index,
      moveCard: moveMentorFileCard,
      id: mentorFile.id,
      isEditActivity: true
    });
  });

  var _useState23 = (0, _react.useState)(resources),
      _useState24 = (0, _slicedToArray3.default)(_useState23, 2),
      resourcesState = _useState24[0],
      setResourcesState = _useState24[1];

  (0, _react.useEffect)(function () {
    if (resourcesState !== resources) {
      setResourcesState((0, _arraySort2.default)(resources, 'sort_order'));
    }
  }, [resources]);

  var moveResourcesCard = (0, _react.useCallback)(function (dragIndex, hoverIndex) {
    var resourcesStateCopy = [].concat((0, _toConsumableArray3.default)(resourcesState));
    var dragCard = resourcesStateCopy[dragIndex];

    setResourcesState((0, _immutabilityHelper2.default)(resourcesStateCopy, {
      $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]]
    }));
  }, [resourcesState]);

  var listOfResources = resourcesState.map(function (resource, index) {
    return _react2.default.createElement(_ResourceRow2.default, {
      activityQuestId: activity.id,
      levelId: levelId,
      resource: resource,
      index: index,
      moveCard: moveResourcesCard,
      id: resource.id
    });
  });

  var _useState25 = (0, _react.useState)(0),
      _useState26 = (0, _slicedToArray3.default)(_useState25, 2),
      errorQuantity = _useState26[0],
      setErrorQuantity = _useState26[1];

  (0, _react.useEffect)(function () {
    var errors = [!activityNameState, drivingQuestion && drivingQuestion.length > 255, activityGoals && activityGoals.length > 255];
    var count = errors.filter(function (b) {
      return b;
    }).length;
    setErrorQuantity(count);
  });

  var markdownOptions = function markdownOptions(type, value) {
    var descriptionOptions = (0, _assign2.default)({}, _markdowneditor.simpleMDEOptions);
    descriptionOptions.initialValue = value;
    descriptionOptions.placeholder = type;
    descriptionOptions.autofocus = false;
    return descriptionOptions;
  };

  var createMutation = (0, _reactQuery.useMutation)(function (_ref4) {
    var apiData = _ref4.apiData,
        levelId = _ref4.levelId,
        activityQuestId = _ref4.activityQuestId,
        resourceName = _ref4.resourceName;
    return (0, _API.createResource)(apiData, levelId, activityQuestId, resourceName);
  });
  var handleCreateResourceAndShowModal = function handleCreateResourceAndShowModal() {
    createMutation.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activity.id,
      resourceName: 'Resource ' + (resources.length + 1)
    }, {
      onSuccess: function onSuccess(data) {
        dispatch((0, _modal.showModal)('ADD_RESOURCE_MODAL', {
          levelId: levelId,
          activityQuestId: activity.id,
          resource: data,
          resourceName: 'Resource ' + (resources.length + 1),
          resourceId: data.id
        }));
      }
    });
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { width: '50%', marginTop: '-20px' } },
      _react2.default.createElement(_TextInputComponent2.default, {
        title: 'Activity Name',
        placeholder: 'Activity Name',
        value: activityNameState,
        handleEnteredTextValue: handleActivityName,
        shouldDisplayAsteriskSymbol: true,
        textColor: _colors2.default.victoria,
        isError: !activityNameState,
        errorMessage: 'Name can’t be blank.'
      }),
      _react2.default.createElement(_SelectorComponent2.default, {
        placeholder: 'Activity Type',
        handleSelectedValueChange: handleSelectedActivityType,
        selectedValue: selectedActivityType,
        options: activityTypeOptions,
        shouldDisplayAsterisk: true,
        textColor: _colors2.default.victoria
      }),
      selectedActivityType !== null && selectedActivityType.id === 1 && _react2.default.createElement(_SelectorComponent2.default, {
        placeholder: 'Artifact Type',
        handleSelectedValueChange: handleSelectedArtifactType,
        selectedValue: selectedArtifactType,
        options: artifactTypes,
        shouldDisplayAsterisk: true,
        textColor: _colors2.default.victoria
      })
    ),
    selectedActivityType !== null && selectedActivityType.id === 1 && _react2.default.createElement(_TextInputComponent2.default, {
      title: 'Artifact Description',
      placeholder: 'Artifact Description',
      hintText: 'The artifact description is a short, succinct sentence or phrase that clearly describes the artifact students will create to demonstrate their knowledge and skills. It should not instruct students, but rather act as a point of reference.',
      handleEnteredTextValue: handleArtifactDescription,
      value: artifactDescription,
      shouldDisplayAsteriskSymbol: true,
      textColor: _colors2.default.victoria
    }),
    _react2.default.createElement(_TextInputComponent2.default, {
      title: 'Driving Question',
      placeholder: 'Driving Question',
      hintText: 'An open-ended question that frames the activity that students are about to explore, collaborate, and reflect on.',
      handleEnteredTextValue: handleDrivingQuestion,
      value: drivingQuestion,
      shouldDisplayAsteriskSymbol: true,
      textColor: _colors2.default.victoria,
      isError: drivingQuestion !== null && drivingQuestion.length > 255,
      errorMessage: 'Maximum 255 characters.'
    }),
    _react2.default.createElement(_TextInputComponent2.default, {
      title: 'Activity Goals',
      placeholder: 'Activity Goals',
      hintText: 'A brief statement written for students that clearly expresses an activity\u2019s purpose and drives the rest of the activity.',
      handleEnteredTextValue: handleActivityGoals,
      value: activityGoals,
      shouldDisplayAsteriskSymbol: true,
      textColor: _colors2.default.victoria,
      isError: activityGoals !== null && activityGoals.length > 255,
      errorMessage: 'Maximum 255 characters.'
    }),
    _react2.default.createElement(_EditLinkedSkills2.default, {
      linkedSkills: linkedSkills,
      setLinkedSkills: setLinkedSkills
    }),
    _react2.default.createElement(_TextInputComponent2.default, {
      title: 'Activity Description',
      placeholder: 'Activity Description',
      hintText: 'Provide information for students to guide their exploration and help them complete the activity.\n        This description should not do teaching or give away key takeaways',
      handleEnteredTextValue: handleActivityDescription,
      value: activityDescription,
      shouldDisplayAsteriskSymbol: true,
      shouldBeTextarea: true,
      textColor: _colors2.default.victoria,
      options: markdownOptions('Activity Description', activityDescription)
    }),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Activity Resources'
      ),
      _react2.default.createElement(_Button2.default, {
        handleClick: handleCreateResourceAndShowModal,
        small: true,
        title: '+ Add Resource',
        buttonColor: _colors2.default.siteBackground,
        borderColor: _colors2.default.rock,
        hoverBackground: _colors2.default.charcoal4,
        hoverColor: _colors2.default.white
      }),
      _react2.default.createElement(
        _reactDnd.DndProvider,
        { backend: _reactDndHtml5Backend.HTML5Backend },
        listOfResources
      )
    ),
    _react2.default.createElement(
      'div',
      {
        style: {
          border: '1px ' + _colors2.default.rock + ' solid',
          borderRadius: '5px',
          padding: '18px',
          marginTop: '15px'
        }
      },
      _react2.default.createElement(
        _H2.default,
        { dove: true },
        'Mentor Prep'
      ),
      _react2.default.createElement(
        'div',
        { style: { marginTop: '-6px' } },
        _react2.default.createElement(_TextInputComponent2.default, {
          title: 'Mentor Notes (Optional)',
          placeholder: 'Mentor Notes',
          handleEnteredTextValue: handleMentorNotes,
          value: mentorNotes,
          shouldDisplayAsteriskSymbol: false,
          shouldBeTextarea: true,
          textColor: _colors2.default.victoria,
          options: markdownOptions('Mentor Notes', mentorNotes)
        })
      ),
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Mentor Files (Optional)'
      ),
      _react2.default.createElement(_Button2.default, {
        handleClick: function handleClick() {
          return dispatch((0, _modal.showModal)('ADD_OR_EDIT_MENTOR_FILE', {
            levelId: levelId,
            activityQuestId: activity.id,
            isEditing: false
          }));
        },
        small: true,
        title: '+ Add File',
        buttonColor: _colors2.default.siteBackground,
        borderColor: _colors2.default.rock,
        hoverBackground: _colors2.default.charcoal4,
        hoverColor: _colors2.default.white
      }),
      _react2.default.createElement(
        _reactDnd.DndProvider,
        { backend: _reactDndHtml5Backend.HTML5Backend },
        listOfMentorFiles
      ),
      _react2.default.createElement(_TextInputComponent2.default, {
        title: 'Assessment Questions (Optional)',
        placeholder: 'Assessment Questions',
        handleEnteredTextValue: handleMentorAssessmentQuestions,
        value: mentorAssessmentQuestions,
        shouldDisplayAsteriskSymbol: false,
        shouldBeTextarea: true,
        textColor: _colors2.default.victoria,
        options: markdownOptions('Assessment Questions', mentorAssessmentQuestions)
      })
    ),
    _react2.default.createElement(EditorButtons, {
      handleCloseEditMode: handleCloseEditMode,
      handleSaveEditedActivity: handleSaveEditedActivity,
      errorQuantity: errorQuantity
    }),
    _react2.default.createElement(EditorButtons, {
      handleCloseEditMode: handleCloseEditMode,
      handleSaveEditedActivity: handleSaveEditedActivity,
      errorQuantity: errorQuantity,
      top: true
    })
  );
};

EditActivityDetails.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activity: _propTypes2.default.object.isRequired,
  mentorFiles: _propTypes2.default.array.isRequired,
  handleCloseEditMode: _propTypes2.default.func,
  levelId: _propTypes2.default.number.isRequired
};

exports.default = (0, _withApiData2.default)(EditActivityDetails);

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: 11px 0;\n  background: none;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n'], ['\n  margin: 11px 0;\n  background: none;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 22px;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 22px;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n'], ['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n'], ['\n  color: ', ';\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0 0 10px 100px;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0 0 10px 100px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 14px;\n  cursor: pointer;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 14px;\n  cursor: pointer;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 17px;\n  width: 14px;\n  cursor: pointer;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 17px;\n  width: 14px;\n  cursor: pointer;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(143);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _API = __webpack_require__(99);

var _modal = __webpack_require__(26);

var _ItemTypes = __webpack_require__(248);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _FileTypeIcon = __webpack_require__(322);

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

var _SortOrder = __webpack_require__(249);

var _SortOrder2 = _interopRequireDefault(_SortOrder);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _edit = __webpack_require__(730);

var _edit2 = _interopRequireDefault(_edit);

var _icon_delete = __webpack_require__(471);

var _icon_delete2 = _interopRequireDefault(_icon_delete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MentorFileContainer = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__MentorFileContainer',
  componentId: 'sc-1vynkzs-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__FlexContainer',
  componentId: 'sc-1vynkzs-1'
})(_templateObject2);

var MentorFileInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__MentorFileInfoContainer',
  componentId: 'sc-1vynkzs-2'
})(_templateObject3);

var SortIcon = _styledComponents2.default.img.attrs({
  src: _SortOrder2.default
}).withConfig({
  displayName: 'MentorFileRow__SortIcon',
  componentId: 'sc-1vynkzs-3'
})(_templateObject4);

var FileName = _styledComponents2.default.a.withConfig({
  displayName: 'MentorFileRow__FileName',
  componentId: 'sc-1vynkzs-4'
})(_templateObject5, _colors2.default.charcoal4);

var FileDescription = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__FileDescription',
  componentId: 'sc-1vynkzs-5'
})(_templateObject6, _colors2.default.black);

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__EditIcon',
  componentId: 'sc-1vynkzs-6'
})(_templateObject7, _edit2.default);

var DeleteIcon = _styledComponents2.default.div.withConfig({
  displayName: 'MentorFileRow__DeleteIcon',
  componentId: 'sc-1vynkzs-7'
})(_templateObject8, _icon_delete2.default);

var MentorFileRow = function MentorFileRow(_ref) {
  var apiData = _ref.apiData,
      activityQuestId = _ref.activityQuestId,
      levelId = _ref.levelId,
      mentorFile = _ref.mentorFile,
      index = _ref.index,
      moveCard = _ref.moveCard,
      id = _ref.id;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var ref = (0, _react.useRef)(null);

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: _ItemTypes.ItemTypes.MENTOR_FILE_ROW,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover: function hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      var dragIndex = item.index;
      var hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      var hoverBoundingRect = ref.current.getBoundingClientRect();

      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      var clientOffset = monitor.getClientOffset();

      var hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: function drop(item) {
      var index = item.index - 1 === -1 ? 0 : item.index;
      (0, _API.reorderMentorFile)(apiData, levelId, activityQuestId, id, index);
    }
  }),
      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: _ItemTypes.ItemTypes.MENTOR_FILE_ROW,
    item: function item() {
      return { id: id, index: index };
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
      drag = _useDrag2[1];

  drag(drop(ref));

  var mentorFileId = mentorFile.id;
  var createMutationOnDeleteDescription = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        mentorFileId = _ref2.mentorFileId;
    return (0, _API.deleteMentorFile)(apiData, levelId, activityQuestId, mentorFileId);
  });

  var handleDeleteMentorFile = function handleDeleteMentorFile() {
    createMutationOnDeleteDescription.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      mentorFileId: mentorFileId
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('mentorFiles-' + activityQuestId);
      }
    });
  };

  return _react2.default.createElement(
    'div',
    { ref: ref, style: { boxShadow: 'none' } },
    _react2.default.createElement(
      MentorFileContainer,
      null,
      _react2.default.createElement(
        FlexContainer,
        null,
        _react2.default.createElement(
          MentorFileInfoContainer,
          null,
          _react2.default.createElement(
            _FlexAlignCenter2.default,
            null,
            _react2.default.createElement(SortIcon, null),
            _react2.default.createElement(_FileTypeIcon2.default, { type: mentorFile.file_type }),
            _react2.default.createElement(
              FileName,
              {
                style: { color: _colors2.default.charcoal4 },
                href: mentorFile.attachment_url,
                target: '_blank'
              },
              mentorFile.original_file_name
            ),
            _react2.default.createElement(EditIcon, {
              style: { marginLeft: '15px' },
              onClick: function onClick() {
                return dispatch((0, _modal.showModal)('ADD_OR_EDIT_MENTOR_FILE', {
                  levelId: levelId,
                  activityQuestId: activityQuestId,
                  mentorFile: mentorFile,
                  isEditing: true
                }));
              }
            })
          ),
          _react2.default.createElement(DeleteIcon, { onClick: handleDeleteMentorFile })
        )
      ),
      mentorFile.description.length !== 0 && _react2.default.createElement(
        FileDescription,
        null,
        mentorFile.description
      )
    )
  );
};

MentorFileRow.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  journey: _propTypes2.default.object.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  moveCard: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(MentorFileRow);

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: 11px 0;\n  background: none;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n'], ['\n  margin: 11px 0;\n  background: none;\n  border: 1px solid #dedfe0;\n  border-radius: 4px;\n  background-color: #ffffff;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 22px;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 22px;\n  flex: 90%;\n  align-content: center;\n  align-items: center;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n'], ['\n  width: 19px;\n  height: 9px;\n  margin-right: 18px;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n'], ['\n  color: ', ';\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0 0 10px 100px;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 0 0 10px 100px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 14px;\n  cursor: pointer;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 14px;\n  width: 14px;\n  cursor: pointer;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 17px;\n  width: 14px;\n  cursor: pointer;\n'], ['\n  background: url(', ') no-repeat;\n  background-size: 100%;\n  height: 17px;\n  width: 14px;\n  cursor: pointer;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(14);

var _reactQuery = __webpack_require__(34);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(143);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _withApiData = __webpack_require__(39);

var _withApiData2 = _interopRequireDefault(_withApiData);

var _API = __webpack_require__(99);

var _modal = __webpack_require__(26);

var _ItemTypes = __webpack_require__(248);

var _SortOrder = __webpack_require__(249);

var _SortOrder2 = _interopRequireDefault(_SortOrder);

var _FileTypeIcon = __webpack_require__(322);

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _edit = __webpack_require__(730);

var _edit2 = _interopRequireDefault(_edit);

var _icon_delete = __webpack_require__(471);

var _icon_delete2 = _interopRequireDefault(_icon_delete);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourceContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__ResourceContainer',
  componentId: 'i23dk5-0'
})(_templateObject);

var FlexContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__FlexContainer',
  componentId: 'i23dk5-1'
})(_templateObject2);

var MentorFileInfoContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__MentorFileInfoContainer',
  componentId: 'i23dk5-2'
})(_templateObject3);

var SortIcon = _styledComponents2.default.img.attrs({
  src: _SortOrder2.default
}).withConfig({
  displayName: 'ResourceRow__SortIcon',
  componentId: 'i23dk5-3'
})(_templateObject4);

var FileName = _styledComponents2.default.a.withConfig({
  displayName: 'ResourceRow__FileName',
  componentId: 'i23dk5-4'
})(_templateObject5, _colors2.default.charcoal4);

var FileDescription = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__FileDescription',
  componentId: 'i23dk5-5'
})(_templateObject6, _colors2.default.black);

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__EditIcon',
  componentId: 'i23dk5-6'
})(_templateObject7, _edit2.default);

var DeleteIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceRow__DeleteIcon',
  componentId: 'i23dk5-7'
})(_templateObject8, _icon_delete2.default);

var ResourceRow = function ResourceRow(_ref) {
  var apiData = _ref.apiData,
      activityQuestId = _ref.activityQuestId,
      levelId = _ref.levelId,
      resource = _ref.resource,
      index = _ref.index,
      moveCard = _ref.moveCard,
      id = _ref.id;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryClient = (0, _reactQuery.useQueryClient)();

  var ref = (0, _react.useRef)(null);

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: _ItemTypes.ItemTypes.RESOURCE_ROW,
    collect: function collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      };
    },
    hover: function hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      var dragIndex = item.index;
      var hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      var hoverBoundingRect = ref.current.getBoundingClientRect();

      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      var clientOffset = monitor.getClientOffset();

      var hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: function drop(item) {
      var index = item.index - 1 === -1 ? 0 : item.index;
      (0, _API.reorderResources)(apiData, levelId, activityQuestId, id, index);
    }
  }),
      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: _ItemTypes.ItemTypes.RESOURCE_ROW,
    item: function item() {
      return { id: id, index: index };
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
      drag = _useDrag2[1];

  drag(drop(ref));

  var deleteResource = (0, _reactQuery.useMutation)(function (_ref2) {
    var apiData = _ref2.apiData,
        levelId = _ref2.levelId,
        activityQuestId = _ref2.activityQuestId,
        resourceId = _ref2.resourceId;
    return (0, _API.deleteExistingResource)(apiData, levelId, activityQuestId, resourceId);
  });

  var handleDeleteResource = function handleDeleteResource() {
    deleteResource.mutate({
      apiData: apiData,
      levelId: levelId,
      activityQuestId: activityQuestId,
      resourceId: resource.id
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries('resources-' + activityQuestId);
      }
    });
  };

  return _react2.default.createElement(
    'div',
    { ref: ref, style: { boxShadow: 'none' } },
    _react2.default.createElement(
      ResourceContainer,
      null,
      _react2.default.createElement(
        FlexContainer,
        null,
        _react2.default.createElement(
          MentorFileInfoContainer,
          null,
          _react2.default.createElement(
            _FlexAlignCenter2.default,
            null,
            _react2.default.createElement(SortIcon, null),
            _react2.default.createElement(_FileTypeIcon2.default, { type: resource.resource_type }),
            _react2.default.createElement(
              FileName,
              {
                style: { color: _colors2.default.charcoal4 },
                href: resource.file_url === null ? resource.url : resource.file_url,
                target: '_blank'
              },
              resource.name
            ),
            _react2.default.createElement(EditIcon, {
              style: { marginLeft: '15px' },
              onClick: function onClick() {
                return dispatch((0, _modal.showModal)('EDIT_RESOURCE_MODAL', {
                  levelId: levelId,
                  activityQuestId: activityQuestId,
                  resourceId: resource.id
                }));
              }
            })
          ),
          _react2.default.createElement(DeleteIcon, {
            onClick: function onClick() {
              return dispatch((0, _modal.showModal)('DELETE_RESOURCE_MODAL', {
                levelId: levelId,
                activityQuestId: activityQuestId,
                resourceId: resource.id,
                handleDeleteResource: handleDeleteResource
              }));
            }
          })
        )
      ),
      resource.description !== null && _react2.default.createElement(
        FileDescription,
        null,
        _react2.default.createElement(_MarkdownLabel2.default, { value: resource.description })
      )
    )
  );
};

ResourceRow.propTypes = {
  apiData: _propTypes2.default.object.isRequired,
  activityCourse: _propTypes2.default.object.isRequired,
  index: _propTypes2.default.number.isRequired,
  resource: _propTypes2.default.object.isRequired,
  selectedAcademicYearId: _propTypes2.default.number.isRequired,
  moveCard: _propTypes2.default.func.isRequired
};

exports.default = (0, _withApiData2.default)(ResourceRow);

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(80);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ', ';\n  padding: 14px 0;\n'], ['\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ', ';\n  padding: 14px 0;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  width: 13px;\n  height: 13px;\n  margin-right: 12px;\n  cursor: pointer;\n\n  &:hover {\n    background-image: url(', ');\n  }\n'], ['\n  background-image: url(', ');\n  width: 13px;\n  height: 13px;\n  margin-right: 12px;\n  cursor: pointer;\n\n  &:hover {\n    background-image: url(', ');\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactSelect = __webpack_require__(68);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _reactRedux = __webpack_require__(14);

var _Input = __webpack_require__(311);

var _Input2 = _interopRequireDefault(_Input);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _InputHint = __webpack_require__(595);

var _InputHint2 = _interopRequireDefault(_InputHint);

var _icon_cross_gray = __webpack_require__(1731);

var _icon_cross_gray2 = _interopRequireDefault(_icon_cross_gray);

var _icon_cross_red = __webpack_require__(1732);

var _icon_cross_red2 = _interopRequireDefault(_icon_cross_red);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SkillLi = _styledComponents2.default.li.withConfig({
  displayName: 'EditLinkedSkills__SkillLi',
  componentId: 'sxjpid-0'
})(_templateObject, _colors2.default.silver);

var RemoveIcon = _styledComponents2.default.div.withConfig({
  displayName: 'EditLinkedSkills__RemoveIcon',
  componentId: 'sxjpid-1'
})(_templateObject2, _icon_cross_gray2.default, _icon_cross_red2.default);

var EditLinkedSkills = function EditLinkedSkills(_ref) {
  var linkedSkills = _ref.linkedSkills,
      setLinkedSkills = _ref.setLinkedSkills;

  var frameworkSkills = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworkskills.items;
  });
  var frameworkSkillGroups = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworkskills.skillGroups;
  });

  var skills = linkedSkills.map(function (s) {
    return frameworkSkills.find(function (fs) {
      return fs.id === s.framework_skill_id;
    });
  });

  var addLinkedSkill = function addLinkedSkill(skill) {
    return setLinkedSkills(function (ss) {
      return [{ framework_skill_id: skill.value }].concat((0, _toConsumableArray3.default)(ss));
    });
  };

  var removeLinkedSkill = function removeLinkedSkill(skill) {
    return setLinkedSkills(function (ss) {
      return ss.filter(function (s) {
        return s.framework_skill_id !== skill.id;
      });
    });
  };

  var getGroupName = function getGroupName(skill) {
    return frameworkSkillGroups.find(function (fsg) {
      return fsg.id === skill.framework_skill_group_id;
    }).name;
  };

  var options = frameworkSkills.filter(function (fs) {
    return !skills.some(function (s) {
      return s.id === fs.id;
    });
  }) // exclude already selected skills
  .map(function (fs) {
    var groupName = getGroupName(fs);
    return (0, _assign2.default)({}, fs, {
      groupName: groupName,
      value: fs.id,
      label: groupName + ': ' + fs.name
    });
  });
  (0, _arraySort2.default)(options, ['groupName', 'name']);

  var TargetSkillItem = function TargetSkillItem(_ref2) {
    var skill = _ref2.skill;
    return _react2.default.createElement(
      SkillLi,
      null,
      _react2.default.createElement(
        _Input2.default,
        null,
        getGroupName(skill),
        ': ',
        skill.name
      ),
      _react2.default.createElement(RemoveIcon, { onClick: function onClick() {
          return removeLinkedSkill(skill);
        } })
    );
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Learning Skills (Strongly Recommended)'
    ),
    _react2.default.createElement(_reactSelect2.default, {
      className: 'course-builder-select',
      searchable: true,
      clearable: true,
      options: options,
      onChange: addLinkedSkill,
      placeholder: 'Select targeted Learning Skill(s).'
    }),
    _react2.default.createElement(
      _InputHint2.default,
      null,
      'Select targeted Learning Skill(s).  Note: Focus skills are applied in Quest! Web after enrollement.'
    ),
    _react2.default.createElement(
      'ul',
      { style: { marginTop: '5px' } },
      skills.map(function (skill) {
        return _react2.default.createElement(TargetSkillItem, { key: skill.id, skill: skill });
      })
    )
  );
};

exports.default = EditLinkedSkills;

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MjJDQTAxQUItNzExRS00NTg1LUIzOUEtMTAxMkYyNEQ1QzVEPC90aXRsZT4KICAgIDxnIGlkPSIwMS1RTS1MaW5rLVNraWxscyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjEuMC1FZGl0LS0tTGluay1MZWFybmluZy1Ta2lsbHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDc4LjAwMDAwMCwgLTE2NzQuMDAwMDAwKSIgZmlsbD0iIzY2NjY2NiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEwODguODkxMDgsMTY3NC43NTY2MyBDMTA4OS4yODQ5LDE2NzQuNDUzNTggMTA4OS44NTE5OCwxNjc0LjQ4NDE2IDEwOTAuMjEwNjUsMTY3NC44NDY0NiBDMTA5MC41OTkyMSwxNjc1LjIzODk0IDEwOTAuNTk2MDMsMTY3NS44NzIwOSAxMDkwLjIwMzU0LDE2NzYuMjYwNjUgTDEwOTAuMjAzNTQsMTY3Ni4yNjA2NSBMMTA4NS45MjEsMTY4MC41IEwxMDkwLjIwMzU0LDE2ODQuNzM5MzUgQzEwOTAuNTk2MDMsMTY4NS4xMjc5MSAxMDkwLjU5OTIxLDE2ODUuNzYxMDYgMTA5MC4yMTA2NSwxNjg2LjE1MzU0IEMxMDg5Ljg1MTk4LDE2ODYuNTE1ODQgMTA4OS4yODQ5LDE2ODYuNTQ2NDIgMTA4OC44OTEwOCwxNjg2LjI0MzM3IEwxMDg4Ljc5NjQ2LDE2ODYuMTYwNjUgTDEwODQuNSwxNjgxLjkwNiBMMTA4MC4yMDM1NCwxNjg2LjE2MDY1IEwxMDgwLjEwODkyLDE2ODYuMjQzMzcgQzEwNzkuNzE1MSwxNjg2LjU0NjQyIDEwNzkuMTQ4MDIsMTY4Ni41MTU4NCAxMDc4Ljc4OTM1LDE2ODYuMTUzNTQgQzEwNzguNDAwNzksMTY4NS43NjEwNiAxMDc4LjQwMzk3LDE2ODUuMTI3OTEgMTA3OC43OTY0NiwxNjg0LjczOTM1IEwxMDc4Ljc5NjQ2LDE2ODQuNzM5MzUgTDEwODMuMDc4LDE2ODAuNSBMMTA3OC43OTY0NiwxNjc2LjI2MDY1IEMxMDc4LjQwMzk3LDE2NzUuODcyMDkgMTA3OC40MDA3OSwxNjc1LjIzODk0IDEwNzguNzg5MzUsMTY3NC44NDY0NiBDMTA3OS4xNDgwMiwxNjc0LjQ4NDE2IDEwNzkuNzE1MSwxNjc0LjQ1MzU4IDEwODAuMTA4OTIsMTY3NC43NTY2MyBMMTA4MC4yMDM1NCwxNjc0LjgzOTM1IEwxMDg0LjUsMTY3OS4wOTMgTDEwODguNzk2NDYsMTY3NC44MzkzNSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MjJDQTAxQUItNzExRS00NTg1LUIzOUEtMTAxMkYyNEQ1QzVEPC90aXRsZT4KICAgIDxnIGlkPSIwMS1RTS1MaW5rLVNraWxscyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjEuMC1FZGl0LS0tTGluay1MZWFybmluZy1Ta2lsbHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDc4LjAwMDAwMCwgLTE2NzQuMDAwMDAwKSIgZmlsbD0iI0RDMTQzQyIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTEwODguODkxMDgsMTY3NC43NTY2MyBDMTA4OS4yODQ5LDE2NzQuNDUzNTggMTA4OS44NTE5OCwxNjc0LjQ4NDE2IDEwOTAuMjEwNjUsMTY3NC44NDY0NiBDMTA5MC41OTkyMSwxNjc1LjIzODk0IDEwOTAuNTk2MDMsMTY3NS44NzIwOSAxMDkwLjIwMzU0LDE2NzYuMjYwNjUgTDEwOTAuMjAzNTQsMTY3Ni4yNjA2NSBMMTA4NS45MjEsMTY4MC41IEwxMDkwLjIwMzU0LDE2ODQuNzM5MzUgQzEwOTAuNTk2MDMsMTY4NS4xMjc5MSAxMDkwLjU5OTIxLDE2ODUuNzYxMDYgMTA5MC4yMTA2NSwxNjg2LjE1MzU0IEMxMDg5Ljg1MTk4LDE2ODYuNTE1ODQgMTA4OS4yODQ5LDE2ODYuNTQ2NDIgMTA4OC44OTEwOCwxNjg2LjI0MzM3IEwxMDg4Ljc5NjQ2LDE2ODYuMTYwNjUgTDEwODQuNSwxNjgxLjkwNiBMMTA4MC4yMDM1NCwxNjg2LjE2MDY1IEwxMDgwLjEwODkyLDE2ODYuMjQzMzcgQzEwNzkuNzE1MSwxNjg2LjU0NjQyIDEwNzkuMTQ4MDIsMTY4Ni41MTU4NCAxMDc4Ljc4OTM1LDE2ODYuMTUzNTQgQzEwNzguNDAwNzksMTY4NS43NjEwNiAxMDc4LjQwMzk3LDE2ODUuMTI3OTEgMTA3OC43OTY0NiwxNjg0LjczOTM1IEwxMDc4Ljc5NjQ2LDE2ODQuNzM5MzUgTDEwODMuMDc4LDE2ODAuNSBMMTA3OC43OTY0NiwxNjc2LjI2MDY1IEMxMDc4LjQwMzk3LDE2NzUuODcyMDkgMTA3OC40MDA3OSwxNjc1LjIzODk0IDEwNzguNzg5MzUsMTY3NC44NDY0NiBDMTA3OS4xNDgwMiwxNjc0LjQ4NDE2IDEwNzkuNzE1MSwxNjc0LjQ1MzU4IDEwODAuMTA4OTIsMTY3NC43NTY2MyBMMTA4MC4yMDM1NCwxNjc0LjgzOTM1IEwxMDg0LjUsMTY3OS4wOTMgTDEwODguNzk2NDYsMTY3NC44MzkzNSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  padding-left: 3px;\n'], ['\n  color: ', ';\n  padding-left: 3px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 23px;\n  width: 23px;\n  background-repeat: no-repeat;\n  margin-left: 10px;\n  margin-bottom: 10px;\n'], ['\n  background-image: url(', ');\n  height: 23px;\n  width: 23px;\n  background-repeat: no-repeat;\n  margin-left: 10px;\n  margin-bottom: 10px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 27px;\n  width: 27px;\n  margin-right: 11px;\n  background-repeat: no-repeat;\n'], ['\n  background-image: url(', ');\n  height: 27px;\n  width: 27px;\n  margin-right: 11px;\n  background-repeat: no-repeat;\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n  background-image: url(', ');\n  height: 27px;\n  width: 27px;\n  background-repeat: no-repeat;\n'], ['\n  background-image: url(', ');\n  height: 27px;\n  width: 27px;\n  background-repeat: no-repeat;\n']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  letter-spacing: 0;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  letter-spacing: 0;\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 21px;\n']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 7px 0 15px 42px;\n'], ['\n  color: ', ';\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 0;\n  line-height: 18px;\n  margin: 7px 0 15px 42px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = __webpack_require__(14);

var _arraySort = __webpack_require__(38);

var _arraySort2 = _interopRequireDefault(_arraySort);

var _InputLabel = __webpack_require__(163);

var _InputLabel2 = _interopRequireDefault(_InputLabel);

var _NotYetSpecified = __webpack_require__(166);

var _NotYetSpecified2 = _interopRequireDefault(_NotYetSpecified);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _Edit = __webpack_require__(629);

var _Edit2 = _interopRequireDefault(_Edit);

var _EditGray = __webpack_require__(1734);

var _EditGray2 = _interopRequireDefault(_EditGray);

var _Icon_Artifact = __webpack_require__(1735);

var _Icon_Artifact2 = _interopRequireDefault(_Icon_Artifact);

var _CheckIn = __webpack_require__(1736);

var _CheckIn2 = _interopRequireDefault(_CheckIn);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getTheActivityTypeFunction = __webpack_require__(729);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

var _FlexAlignCenter = __webpack_require__(141);

var _FlexAlignCenter2 = _interopRequireDefault(_FlexAlignCenter);

var _FileTypeIcon = __webpack_require__(322);

var _FileTypeIcon2 = _interopRequireDefault(_FileTypeIcon);

var _ResourceCard = __webpack_require__(1737);

var _ResourceCard2 = _interopRequireDefault(_ResourceCard);

var _LinkedSkillsReadOnly = __webpack_require__(1738);

var _LinkedSkillsReadOnly2 = _interopRequireDefault(_LinkedSkillsReadOnly);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsteriskSymbol = _styledComponents2.default.span.withConfig({
  displayName: 'ReadOnlyActivityData__AsteriskSymbol',
  componentId: 'sc-2s6y3x-0'
})(_templateObject, _colors2.default.crimson);

var EditIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ReadOnlyActivityData__EditIcon',
  componentId: 'sc-2s6y3x-1'
})(_templateObject2, function (props) {
  return props.gray ? _EditGray2.default : _Edit2.default;
});

var ArtifactIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ReadOnlyActivityData__ArtifactIcon',
  componentId: 'sc-2s6y3x-2'
})(_templateObject3, _Icon_Artifact2.default);

var CheckInIcon = _styledComponents2.default.div.withConfig({
  displayName: 'ReadOnlyActivityData__CheckInIcon',
  componentId: 'sc-2s6y3x-3'
})(_templateObject4, _CheckIn2.default);

var Text = _styledComponents2.default.div.withConfig({
  displayName: 'ReadOnlyActivityData__Text',
  componentId: 'sc-2s6y3x-4'
})(_templateObject5, _colors2.default.victoria);

var FileName = _styledComponents2.default.a.withConfig({
  displayName: 'ReadOnlyActivityData__FileName',
  componentId: 'sc-2s6y3x-5'
})(_templateObject6, _colors2.default.cobalt);

var FileDescription = _styledComponents2.default.div.withConfig({
  displayName: 'ReadOnlyActivityData__FileDescription',
  componentId: 'sc-2s6y3x-6'
})(_templateObject7, _colors2.default.black);

var ReadOnlyActivityData = function ReadOnlyActivityData(_ref) {
  var activity = _ref.activity,
      _ref$mentorFiles = _ref.mentorFiles,
      mentorFiles = _ref$mentorFiles === undefined ? [] : _ref$mentorFiles,
      _ref$resources = _ref.resources,
      resources = _ref$resources === undefined ? [] : _ref$resources,
      _ref$linkedSkills = _ref.linkedSkills,
      linkedSkills = _ref$linkedSkills === undefined ? [] : _ref$linkedSkills,
      handleClick = _ref.handleClick,
      isDraft = _ref.isDraft;

  var artifactTypes = (0, _reactRedux.useSelector)(function (state) {
    return state.artifacttypes.items;
  });
  var activityType = (0, _getTheActivityTypeFunction.getTheActivityType)(activity).label;

  var displayActivityTypeIcon = function displayActivityTypeIcon(activityType) {
    var iconWithText = void 0;
    switch (activityType) {
      case 'Artifact Required / Check-in':
        {
          iconWithText = _react2.default.createElement(
            _FlexAlignCenter2.default,
            null,
            _react2.default.createElement(ArtifactIcon, null),
            ' Artifact Required',
            _react2.default.createElement(
              'span',
              { style: { marginLeft: '11px' } },
              '/'
            ),
            _react2.default.createElement(CheckInIcon, { style: { marginLeft: '11px' } }),
            ' Check-in'
          );
          break;
        }
      case 'Check-in Only':
        {
          iconWithText = _react2.default.createElement(
            _FlexAlignCenter2.default,
            null,
            _react2.default.createElement(CheckInIcon, null),
            'Check-in Only'
          );
          break;
        }
      case 'No Check-in':
        {
          break;
        }
    }
    return iconWithText;
  };

  var listOfMentorFiles = (0, _arraySort2.default)(mentorFiles, 'sort_order').map(function (mentorFile) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _FlexAlignCenter2.default,
        { key: mentorFile.id },
        _react2.default.createElement(_FileTypeIcon2.default, { type: mentorFile.file_type }),
        _react2.default.createElement(
          FileName,
          { href: mentorFile.attachment_url, target: '_blank' },
          mentorFile.original_file_name
        )
      ),
      _react2.default.createElement(
        FileDescription,
        null,
        mentorFile.description
      )
    );
  });

  var evenResources = (0, _arraySort2.default)(resources, 'sort_order').filter(function (resource, index) {
    return index % 2 === 0;
  });
  var oddResources = (0, _arraySort2.default)(resources, 'sort_order').filter(function (resource, index) {
    return index % 2 !== 0;
  });

  var listOfEvenResources = evenResources.map(function (resource) {
    return _react2.default.createElement(_ResourceCard2.default, { resource: resource });
  });

  var listOfOddResources = oddResources.map(function (resource) {
    return _react2.default.createElement(_ResourceCard2.default, { resource: resource });
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: { cursor: 'pointer', float: 'right' } },
      _react2.default.createElement(EditIcon, { onClick: handleClick, gray: !isDraft })
    ),
    _react2.default.createElement(
      _FlexAlignCenter2.default,
      null,
      displayActivityTypeIcon(activityType)
    ),
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Driving Question',
      _react2.default.createElement(
        AsteriskSymbol,
        null,
        '*'
      )
    ),
    !activity.driving_question ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
      Text,
      null,
      activity.driving_question
    ),
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Activity Goals',
      _react2.default.createElement(
        AsteriskSymbol,
        null,
        '*'
      )
    ),
    !activity.goals ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
      Text,
      null,
      activity.goals
    ),
    activity.work_product && activity.checkpoint && _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Artifact Type',
        _react2.default.createElement(
          AsteriskSymbol,
          null,
          '*'
        )
      ),
      !activity.artifact_type_id ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
        Text,
        null,
        artifactTypes.find(function (at) {
          return at.id === activity.artifact_type_id;
        }).name
      ),
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Artifact Description',
        _react2.default.createElement(
          AsteriskSymbol,
          null,
          '*'
        )
      ),
      !activity.artifact_description ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
        Text,
        null,
        activity.artifact_description !== null && activity.artifact_description
      )
    ),
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Learning Skills (Strongly Recommended)'
    ),
    linkedSkills.length > 0 ? _react2.default.createElement(_LinkedSkillsReadOnly2.default, { linkedSkills: linkedSkills }) : _react2.default.createElement(_NotYetSpecified2.default, null),
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Description',
      _react2.default.createElement(
        AsteriskSymbol,
        null,
        '*'
      )
    ),
    !activity.description ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
      Text,
      null,
      _react2.default.createElement(_MarkdownLabel2.default, { value: activity.description })
    ),
    _react2.default.createElement(
      _InputLabel2.default,
      null,
      'Activity Resources'
    ),
    resources.length > 0 ? _react2.default.createElement(
      'div',
      {
        style: {
          display: 'flex',
          width: '80%',
          alignItems: 'flex-start',
          marginTop: '10px'
        }
      },
      _react2.default.createElement(
        'div',
        {
          style: { display: 'flex', flexDirection: 'column', width: '50%' }
        },
        listOfEvenResources
      ),
      _react2.default.createElement(
        'div',
        {
          style: { display: 'flex', flexDirection: 'column', width: '50%' }
        },
        listOfOddResources
      )
    ) : _react2.default.createElement(_NotYetSpecified2.default, null),
    _react2.default.createElement(
      'div',
      {
        id: 'mentorNoteRegion',
        style: {
          backgroundColor: _colors2.default.smoke,
          borderRadius: '5px',
          padding: '18px',
          marginTop: '15px'
        }
      },
      _react2.default.createElement(
        _InputLabel2.default,
        { style: { marginTop: '0' } },
        'Mentor Notes'
      ),
      !activity.mentor_notes ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
        Text,
        null,
        _react2.default.createElement(_MarkdownLabel2.default, { value: activity.mentor_notes })
      ),
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Mentor Files'
      ),
      mentorFiles.length === 0 ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
        'div',
        { style: { marginTop: '15px' } },
        listOfMentorFiles
      ),
      _react2.default.createElement(
        _InputLabel2.default,
        null,
        'Assessment Questions'
      ),
      !activity.mentor_assessment_questions ? _react2.default.createElement(_NotYetSpecified2.default, null) : _react2.default.createElement(
        'div',
        { style: { marginBottom: '-4px' } },
        _react2.default.createElement(
          Text,
          null,
          _react2.default.createElement(_MarkdownLabel2.default, { value: activity.mentor_assessment_questions })
        )
      )
    )
  );
};

ReadOnlyActivityData.propTypes = {
  activity: _propTypes2.default.object.isRequired,
  mentorFiles: _propTypes2.default.array.isRequired,
  resources: _propTypes2.default.array.isRequired,
  handleClick: _propTypes2.default.func,
  isDraft: _propTypes2.default.bool.isRequired
};

exports.default = ReadOnlyActivityData;

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjgyOSAzLjZsMi43IDIuN0w0LjExNCAxNi43MTQgMCAxOGwxLjQxNC0zLjk4NkwxMS44MyAzLjZ6TTE3LjQyLjU3OWMuNzcyLjc3MS43NzIgMS45MjggMCAyLjU3MWwtMS40MTQgMS40MTQtMi41NzEtMi41NzFMMTQuODUuNTc5Yy43NzEtLjc3MiAxLjkyOS0uNzcyIDIuNTcxIDB6IiBmaWxsPSIjOTk5OTk5IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4="

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjEuOTYgMjQuNDQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO30uY2xzLTJ7Y2xpcC1wYXRoOnVybCgjY2xpcC1wYXRoKTt9LmNscy0ze2ZpbGw6I2Y2ODgzMjt9PC9zdHlsZT48Y2xpcFBhdGggaWQ9ImNsaXAtcGF0aCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMjEuOTYiIGhlaWdodD0iMjQuNDQiLz48L2NsaXBQYXRoPjwvZGVmcz48dGl0bGU+UXVlc3QgRGV0YWlsPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxnIGlkPSJRdWVzdF9EZXRhaWwiIGRhdGEtbmFtZT0iUXVlc3QgRGV0YWlsIj48ZyBjbGFzcz0iY2xzLTIiPjxnIGNsYXNzPSJjbHMtMiI+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMjAuNDgsNSwxMi40Ni40YTMsMywwLDAsMC0zLDBMMS40OCw1QTMsMywwLDAsMCwwLDcuNTl2OS4yNmEzLDMsMCwwLDAsMS40OCwyLjU2TDkuNSwyNGEzLDMsMCwwLDAsMywwbDgtNC42M0EzLDMsMCwwLDAsMjIsMTYuODVWNy41OUEzLDMsMCwwLDAsMjAuNDgsNU0xMC41Myw5LjEzYS41Mi41MiwwLDAsMS0uNDMuNTIsMi43MywyLjczLDAsMCwwLDAsNS4zOC41Mi41MiwwLDAsMSwuNDMuNTJ2MS42OWEuNTIuNTIsMCwwLDEtLjUyLjUySDkuOTVhNS40Niw1LjQ2LDAsMCwxLDAtMTAuODUuNTIuNTIsMCwwLDEsLjU4LjUyWk0xNiwxNi45MmEuNTIuNTIsMCwwLDEtLjUyLjUySDE0LjJhLjUyLjUyLDAsMCwxLS41Mi0uNTJ2LS4wOWE1LjQyLDUuNDIsMCwwLDEtMS43MS44bC0uMTQsMGEuNTMuNTMsMCwwLDEtLjUyLS41MlYxNS4zNGEuNTIuNTIsMCwwLDEsLjMyLS40OCwyLjczLDIuNzMsMCwwLDAsMC01LC41Mi41MiwwLDAsMS0uMzItLjQ4VjcuNTdBLjUyLjUyLDAsMCwxLDEyLDcuMDdhNS40LDUuNCwwLDAsMSwxLjcxLjc5VjcuNjhhLjUyLjUyLDAsMCwxLC41Mi0uNTJoMS4zYS41Mi41MiwwLDAsMSwuNTIuNTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIi8+PC9nPjwvZz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjgzNCA4Ljg3NmwtMS41NS0zLjAzMyAxLjU1LTMuMDM0YTEuMDM0IDEuMDM0IDAgMDAwLTEuMTI0Yy0uMjIxLS4zMzctLjY2NC0uNTYxLS45OTYtLjU2MUgyLjIxM0MyLjIxMy40NDkgMS42NiAwIDEuMTA3IDAgLjU1MyAwIDAgLjQ1IDAgMS4xMjR2MTcuNzUyQzAgMTkuNTUxLjU1MyAyMCAxLjEwNyAyMGMuNTUzIDAgMS4xMDYtLjU2MiAxLjEwNi0xLjEyNHYtOC4zMTRoMTAuNTE0Yy40NDMgMCAuNzc1LS4yMjUuOTk2LS41NjIuMjIyLS4zMzcuMjIyLS43ODcuMTExLTEuMTI0eiIgZmlsbD0iIzRFNkM4NCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  background: none;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  height: auto;\n  background: ', ';\n  margin-right: 20px;\n  margin-bottom: 20px;\n  cursor: pointer;\n'], ['\n  background: none;\n  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);\n  border-radius: 5px;\n  height: auto;\n  background: ', ';\n  margin-right: 20px;\n  margin-bottom: 20px;\n  cursor: pointer;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  height: 85px;\n  width: 100%;\n  margin-bottom: 10px;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  background-image: ', ';\n  background-size: 100%;\n}\n\n'], ['\n  height: 85px;\n  width: 100%;\n  margin-bottom: 10px;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  background-image: ', ';\n  background-size: 100%;\n}\n\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n    center top / 100% no-repeat rgb(255, 255, 255);\n  height: 85px;\n  width: 100%;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n'], ['\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),\n    center top / 100% no-repeat rgb(255, 255, 255);\n  height: 85px;\n  width: 100%;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = __webpack_require__(22);

var _colors2 = _interopRequireDefault(_colors);

var _H = __webpack_require__(111);

var _H2 = _interopRequireDefault(_H);

var _resources = __webpack_require__(125);

var _MarkdownLabel = __webpack_require__(63);

var _MarkdownLabel2 = _interopRequireDefault(_MarkdownLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResourceContainerCard = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceCard__ResourceContainerCard',
  componentId: 'sc-1wuwluc-0'
})(_templateObject, _colors2.default.white);

var ResourceImage = _styledComponents2.default.img.withConfig({
  displayName: 'ResourceCard__ResourceImage',
  componentId: 'sc-1wuwluc-1'
})(_templateObject2, function (props) {
  return 'linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(' + props.image + ') !important';
});

var ImagePlaceholder = _styledComponents2.default.div.withConfig({
  displayName: 'ResourceCard__ImagePlaceholder',
  componentId: 'sc-1wuwluc-2'
})(_templateObject3);

var ResourceCard = function ResourceCard(_ref) {
  var resource = _ref.resource;

  var isClickable = Boolean(resource.url || resource.file_url);

  var handleResourceClick = function handleResourceClick() {
    window.open(resource.file_url ? resource.file_url : resource.url, '_blank');
  };

  return _react2.default.createElement(
    ResourceContainerCard,
    { onClick: isClickable && handleResourceClick },
    _react2.default.createElement(
      'div',
      { style: { height: '70px', position: 'relative' } },
      _react2.default.createElement(
        'a',
        null,
        resource.resource_type !== null && _react2.default.createElement(
          'div',
          {
            style: { position: 'absolute', width: '100%', height: '85px' }
          },
          _react2.default.createElement(
            'div',
            { style: { margin: '6% 42%' } },
            (0, _resources.getViewResourceIcon)(resource.resource_type)
          )
        )
      ),
      resource.thumbnail_url === null ? _react2.default.createElement(ImagePlaceholder, null) : _react2.default.createElement(ResourceImage, { image: resource.thumbnail_url })
    ),
    _react2.default.createElement(
      'div',
      { style: { padding: '25px' } },
      _react2.default.createElement(
        _H2.default,
        { style: { marginBottom: '10px' } },
        resource.name
      ),
      resource.description !== null && _react2.default.createElement(_MarkdownLabel2.default, { value: resource.description })
    )
  );
};

ResourceCard.propTypes = {
  resource: _propTypes2.default.object.isRequired
};

exports.default = ResourceCard;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(15);

var _assign2 = _interopRequireDefault(_assign);

var _taggedTemplateLiteral2 = __webpack_require__(8);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  align-items: center;\n\n  img {\n    padding: 4px;\n    margin-right: 5px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n\n  img {\n    padding: 4px;\n    margin-right: 5px;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(9);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRedux = __webpack_require__(14);

var _Input = __webpack_require__(311);

var _Input2 = _interopRequireDefault(_Input);

var _icon_analyze = __webpack_require__(1739);

var _icon_analyze2 = _interopRequireDefault(_icon_analyze);

var _icon_communicate = __webpack_require__(1740);

var _icon_communicate2 = _interopRequireDefault(_icon_communicate);

var _icon_explore = __webpack_require__(1741);

var _icon_explore2 = _interopRequireDefault(_icon_explore);

var _icon_reason = __webpack_require__(1742);

var _icon_reason2 = _interopRequireDefault(_icon_reason);

var _icon_reflect = __webpack_require__(1743);

var _icon_reflect2 = _interopRequireDefault(_icon_reflect);

var _icon_skill_generic = __webpack_require__(1744);

var _icon_skill_generic2 = _interopRequireDefault(_icon_skill_generic);

var _reactTooltip = __webpack_require__(25);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconForGroup = function getIconForGroup(groupId) {
  switch (groupId) {
    case 1:
      return _icon_reflect2.default;
    case 2:
      return _icon_communicate2.default;
    case 3:
      return _icon_reason2.default;
    case 4:
      return _icon_analyze2.default;
    case 5:
      return _icon_explore2.default;
    default:
      return _icon_skill_generic2.default;
  }
};

var SkillLi = _styledComponents2.default.li.withConfig({
  displayName: 'LinkedSkillsReadOnly__SkillLi',
  componentId: 'd4cxy8-0'
})(_templateObject);

var LinkedSkillsReadonly = function LinkedSkillsReadonly(_ref) {
  var linkedSkills = _ref.linkedSkills;

  var frameworkSkills = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworkskills.items;
  });
  var frameworkSkillGroups = (0, _reactRedux.useSelector)(function (state) {
    return state.frameworkskills.skillGroups;
  });

  var namedSkills = linkedSkills.map(function (skill) {
    var fs = frameworkSkills.find(function (fs) {
      return fs.id === skill.framework_skill_id;
    });
    return (0, _assign2.default)({}, fs, {
      group: frameworkSkillGroups.find(function (fsg) {
        return fsg.id === fs.framework_skill_group_id;
      })
    });
  });

  return _react2.default.createElement(
    'ul',
    null,
    namedSkills.map(function (skill) {
      return _react2.default.createElement(
        SkillLi,
        { key: skill.id },
        _react2.default.createElement('img', {
          alt: skill.group.name,
          src: getIconForGroup(skill.group.id),
          'data-tip': skill.group.name,
          'data-for': 'skill-group-tooltip-' + skill.id
        }),
        _react2.default.createElement(
          _Input2.default,
          null,
          skill.group.name,
          ': ',
          skill.name
        ),
        _react2.default.createElement(_reactTooltip2.default, {
          id: 'skill-group-tooltip-' + skill.id,
          effect: 'solid'
        })
      );
    })
  );
};

exports.default = LinkedSkillsReadonly;

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+QTFCMzQxMjQtODVDOC00NDQxLThDMzYtNjQyMTQyQzRCOUEyPC90aXRsZT4KICAgIDxnIGlkPSIwMS0tLUkxIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtOC1Db3B5LTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yLjAwMDAwMCwgLTIuMDAwMDAwKSIgZmlsbD0iIzAwNkNGMCI+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weS0xMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDAwMDAwLCAxNS4wMDAwMDApIHJvdGF0ZSgtMzE1LjAwMDAwMCkgdHJhbnNsYXRlKC0xNS4wMDAwMDAsIC0xNS4wMDAwMDApICIgeD0iNC45OTk5OTk2MiIgeT0iNC45OTk5OTk2MiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMy45NTMxMjUiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJzY2FsZSgwLjc1KSB0cmFuc2xhdGUoOC44MzMzLCA4LjMzMzMpIj4KICAgICAgICAgICAgPGcgaWQ9IjEuMC0oTSktTXktQ291cnNlcy0tLUZvY3VzLVNraWxscyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ5Ni4wMDAwMDAsIC02MzMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iaWNvbl9BbmFseXplLUNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDk1Ljk5OTk5NiwgNjMzLjMwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLjU5MzY3ODU3LDEuOTQ4MDE3ODYgQzMuNTE4Njk2NDMsMi44NzMgMi43NDQ1ODkyOSwzLjU5OTQ0NjQzIDEuNzk5ODc1LDMuNTk5NDQ2NDMgQzAuODA1OTgyMTQzLDMuNTk5NDQ2NDMgMi4yNzM3MzY3NWUtMTMsMi43OTQzNzUgMi4yNzM3MzY3NWUtMTMsMS43OTk4NzUgQzIuMjczNzM2NzVlLTEzLDAuODA1OTgyMTQzIDAuODA1OTgyMTQzLC0xLjEzNjg2ODM4ZS0xMyAxLjc5OTg3NSwtMS4xMzY4NjgzOGUtMTMgQzIuNzQ0NTg5MjksLTEuMTM2ODY4MzhlLTEzIDMuNTE4Njk2NDMsMC43MjczNTcxNDMgMy41OTM2Nzg1NywxLjY1MjMzOTI5IEwzLjU5OTc1LDEuNzk5ODc1IEwzLjU5MzY3ODU3LDEuOTQ4MDE3ODYgWiIgaWQ9IkZpbGwtMSIgZmlsbD0iIzkwQzNGNCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi4zODY4NDY0LDEuOTQ4MDE3ODYgQzE2LjMxMTg2NDMsMi44NzMgMTUuNTM3NzU3MSwzLjU5OTQ0NjQzIDE0LjU5MzA0MjksMy41OTk0NDY0MyBDMTMuNTk5MTUsMy41OTk0NDY0MyAxMi43OTMxNjc5LDIuNzk0Mzc1IDEyLjc5MzE2NzksMS43OTk4NzUgQzEyLjc5MzE2NzksMC44MDU5ODIxNDMgMTMuNTk5MTUsLTEuMTM2ODY4MzhlLTEzIDE0LjU5MzA0MjksLTEuMTM2ODY4MzhlLTEzIEMxNS41Mzc3NTcxLC0xLjEzNjg2ODM4ZS0xMyAxNi4zMTE4NjQzLDAuNzI3MzU3MTQzIDE2LjM4Njg0NjQsMS42NTIzMzkyOSBMMTYuMzkyOTE3OSwxLjc5OTg3NSBMMTYuMzg2ODQ2NCwxLjk0ODAxNzg2IFoiIGlkPSJGaWxsLTMiIGZpbGw9IiM5MEMzRjQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAuMDA0MDE0MywxLjk0ODAxNzg2IEM5LjkyOTAzMjE0LDIuODczIDkuMTU0OTI1LDMuNTk5NDQ2NDMgOC4yMTAyMTA3MSwzLjU5OTQ0NjQzIEM3LjIxNjMxNzg2LDMuNTk5NDQ2NDMgNi40MTAzMzU3MSwyLjc5NDM3NSA2LjQxMDMzNTcxLDEuNzk5ODc1IEM2LjQxMDMzNTcxLDAuODA1OTgyMTQzIDcuMjE2MzE3ODYsLTEuMTM2ODY4MzhlLTEzIDguMjEwMjEwNzEsLTEuMTM2ODY4MzhlLTEzIEM5LjE1NDkyNSwtMS4xMzY4NjgzOGUtMTMgOS45MjkwMzIxNCwwLjcyNzM1NzE0MyAxMC4wMDQwMTQzLDEuNjUyMzM5MjkgTDEwLjAxMDA4NTcsMS43OTk4NzUgTDEwLjAwNDAxNDMsMS45NDgwMTc4NiBaIiBpZD0iRmlsbC01IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE2LjM4Njg0NjQsOC4zNTk1OTgyMSBDMTYuMzExODY0Myw5LjI4NDU4MDM2IDE1LjUzNzc1NzEsMTAuMDExMDI2OCAxNC41OTMwNDI5LDEwLjAxMTAyNjggQzEzLjU5OTE1LDEwLjAxMTAyNjggMTIuNzkzMTY3OSw5LjIwNTk1NTM2IDEyLjc5MzE2NzksOC4yMTE0NTUzNiBDMTIuNzkzMTY3OSw3LjIxNzU2MjUgMTMuNTk5MTUsNi40MTE1ODAzNiAxNC41OTMwNDI5LDYuNDExNTgwMzYgQzE1LjUzNzc1NzEsNi40MTE1ODAzNiAxNi4zMTE4NjQzLDcuMTM4OTM3NSAxNi4zODY4NDY0LDguMDYzOTE5NjQgTDE2LjM5MjkxNzksOC4yMTE0NTUzNiBMMTYuMzg2ODQ2NCw4LjM1OTU5ODIxIFoiIGlkPSJGaWxsLTciIGZpbGw9IiM5MEMzRjQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS45OTAyNjI1LDguMzU5NTk4MjEgQzkuOTE1MjgwMzYsOS4yODQ1ODAzNiA5LjE0MTE3MzIxLDEwLjAxMTAyNjggOC4xOTY0NTg5MywxMC4wMTEwMjY4IEM3LjIwMjU2NjA3LDEwLjAxMTAyNjggNi4zOTY1ODM5Myw5LjIwNTk1NTM2IDYuMzk2NTgzOTMsOC4yMTE0NTUzNiBDNi4zOTY1ODM5Myw3LjIxNzU2MjUgNy4yMDI1NjYwNyw2LjQxMTU4MDM2IDguMTk2NDU4OTMsNi40MTE1ODAzNiBDOS4xNDExNzMyMSw2LjQxMTU4MDM2IDkuOTE1MjgwMzYsNy4xMzg5Mzc1IDkuOTkwMjYyNSw4LjA2MzkxOTY0IEw5Ljk5NjMzMzkzLDguMjExNDU1MzYgTDkuOTkwMjYyNSw4LjM1OTU5ODIxIFoiIGlkPSJGaWxsLTkiIGZpbGw9IiM5MEMzRjQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMy42MDc0MzAzNiw4LjM1OTU5ODIxIEMzLjUzMjQ0ODIxLDkuMjg0NTgwMzYgMi43NTgzNDEwNywxMC4wMTEwMjY4IDEuODEzNjI2NzksMTAuMDExMDI2OCBDMC44MTk3MzM5MjksMTAuMDExMDI2OCAwLjAxMzc1MTc4NTcsOS4yMDU5NTUzNiAwLjAxMzc1MTc4NTcsOC4yMTE0NTUzNiBDMC4wMTM3NTE3ODU3LDcuMjE3NTYyNSAwLjgxOTczMzkyOSw2LjQxMTU4MDM2IDEuODEzNjI2NzksNi40MTE1ODAzNiBDMi43NTgzNDEwNyw2LjQxMTU4MDM2IDMuNTMyNDQ4MjEsNy4xMzg5Mzc1IDMuNjA3NDMwMzYsOC4wNjM5MTk2NCBMMy42MTM1MDE3OSw4LjIxMTQ1NTM2IEwzLjYwNzQzMDM2LDguMzU5NTk4MjEgWiIgaWQ9IkZpbGwtMTEiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMy41OTM2Nzg1NywxNC43NzExNzg2IEMzLjUxODY5NjQzLDE1LjY5NjE2MDcgMi43NDQ1ODkyOSwxNi40MjI2MDcxIDEuNzk5ODc1LDE2LjQyMjYwNzEgQzAuODA1OTgyMTQzLDE2LjQyMjYwNzEgMS41NjU0MTQ0NmUtMTMsMTUuNjE3NTM1NyAxLjU2NTQxNDQ2ZS0xMywxNC42MjMwMzU3IEMxLjU2NTQxNDQ2ZS0xMywxMy42MjkxNDI5IDAuODA1OTgyMTQzLDEyLjgyMzE2MDcgMS43OTk4NzUsMTIuODIzMTYwNyBDMi43NDQ1ODkyOSwxMi44MjMxNjA3IDMuNTE4Njk2NDMsMTMuNTUwNTE3OSAzLjU5MzY3ODU3LDE0LjQ3NTUgTDMuNTk5NzUsMTQuNjIzMDM1NyBMMy41OTM2Nzg1NywxNC43NzExNzg2IFoiIGlkPSJGaWxsLTEzIiBmaWxsPSIjOTBDM0Y0Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE2LjM4Njg0NjQsMTQuNzcxMTc4NiBDMTYuMzExODY0MywxNS42OTYxNjA3IDE1LjUzNzc1NzEsMTYuNDIyNjA3MSAxNC41OTMwNDI5LDE2LjQyMjYwNzEgQzEzLjU5OTE1LDE2LjQyMjYwNzEgMTIuNzkzMTY3OSwxNS42MTc1MzU3IDEyLjc5MzE2NzksMTQuNjIzMDM1NyBDMTIuNzkzMTY3OSwxMy42MjkxNDI5IDEzLjU5OTE1LDEyLjgyMzE2MDcgMTQuNTkzMDQyOSwxMi44MjMxNjA3IEMxNS41Mzc3NTcxLDEyLjgyMzE2MDcgMTYuMzExODY0MywxMy41NTA1MTc5IDE2LjM4Njg0NjQsMTQuNDc1NSBMMTYuMzkyOTE3OSwxNC42MjMwMzU3IEwxNi4zODY4NDY0LDE0Ljc3MTE3ODYgWiIgaWQ9IkZpbGwtMTUiIGZpbGw9IiM5MEMzRjQiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTAuMDA0MDE0MywxNC43NzExNzg2IEM5LjkyOTAzMjE0LDE1LjY5NjE2MDcgOS4xNTQ5MjUsMTYuNDIyNjA3MSA4LjIxMDIxMDcxLDE2LjQyMjYwNzEgQzcuMjE2MzE3ODYsMTYuNDIyNjA3MSA2LjQxMDMzNTcxLDE1LjYxNzUzNTcgNi40MTAzMzU3MSwxNC42MjMwMzU3IEM2LjQxMDMzNTcxLDEzLjYyOTE0MjkgNy4yMTYzMTc4NiwxMi44MjMxNjA3IDguMjEwMjEwNzEsMTIuODIzMTYwNyBDOS4xNTQ5MjUsMTIuODIzMTYwNyA5LjkyOTAzMjE0LDEzLjU1MDUxNzkgMTAuMDA0MDE0MywxNC40NzU1IEwxMC4wMTAwODU3LDE0LjYyMzAzNTcgTDEwLjAwNDAxNDMsMTQuNzcxMTc4NiBaIiBpZD0iRmlsbC0xNyIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01Ljk5NDk2NjY4LDMuMDQ2MTk0NjYgTDYuMTMyMzQxNzksMy4yNDIxNDIzOCBDNi4yNTU0NDY5MiwzLjQxNzczNTgzIDYuNDAwNDk1MDcsMy41NzcxMDcyNCA2LjU2MzUzNzEzLDMuNzE2MzI2NTIgTDYuNzMyNDMwODksMy44NDg2ODI4NiBMNi45MjI4ODU0NSwzLjk4NTQxMzU2IEw0LjE1Nzc1NjM2LDYuNzc1NDAxMzggTDQuMDE1LDYuNjM0IEwzLjg1Mjg2ODAyLDYuNzUwNzM3NDIgQzMuNzg1NTUwNjgsNi42NTYzNDA1OCAzLjcxMjU3MTYsNi41NjcxNTk3NyAzLjYzNDIzMzk5LDYuNDgzNzMxIEwzLjUxMjc0NjYxLDYuMzYyOTY4ODggTDMuMzgzOTExNTUsNi4yNTE3NDE5NCBMMy4yNDgyNjcwNyw2LjE0OTQ2OTU4IEwzLjA1NDYyMDE4LDYuMDEzMjY1MzUgTDUuOTk0OTY2NjgsMy4wNDYxOTQ2NiBaIiBpZD0iUGF0aCIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTMuOTg3Njk3NzksOS40ODM3MzE4NyBMNi43NjcxMTA2NCwxMi4yNjMxNDQ3IEw2LjYyNSwxMi40MDQgTDYuNzQxNTI3MjcsMTIuNTY3NjA0NiBDNi41NjY0NTg0OCwxMi42OTE5OSA2LjQwNzk0MDI5LDEyLjgzODAzNzYgNi4yNjk5ODUwNywxMy4wMDE3NTMxIEw2LjEzOTAzMjc3LDEzLjE3MTIxMDEgTDYuMDAyMDU5NSwxMy4zNjQ4ODYxIEwzLjA1MDMzMjksMTAuNDEzMTU5NSBMMy4yNDQ3NDQ3LDEwLjI3NjMwNzcgQzMuMzM5Njc3NTMsMTAuMjA5NDgxOSAzLjQyOTEwNzA0LDEwLjEzNzQ3MjggMy41MTIxNDU1MiwxMC4wNjA3ODA2IEMzLjU5NTY2MTQ2LDkuOTgzMjAzNTQgMy42NzM3Njc4NSw5LjkwMDA1MjQ3IDMuNzQ2MTY4MDcsOS44MTE4MTk0NyBMMy44NTA0NTE2Nyw5LjY3NTcyMDA0IEwzLjk4NzY5Nzc5LDkuNDgzNzMxODcgWiIgaWQ9IlBhdGgiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iU2tpbGxHcm91cCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwLTgtQ29weS00IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4wMDAwMDAsIC0yLjAwMDAwMCkiIGZpbGw9IiMwMDZDRjAiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHktMTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjAwMDAwMCwgMTUuMDAwMDAwKSByb3RhdGUoLTMxNS4wMDAwMDApIHRyYW5zbGF0ZSgtMTUuMDAwMDAwLCAtMTUuMDAwMDAwKSAiIHg9IjQuOTk5OTk5NjIiIHk9IjQuOTk5OTk5NjIiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjMuOTUzMTI1Ij48L3JlY3Q+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports = {"AcceptPolcicyModal.ByUsing":"By using the OE QuestMaker app, you agree to our policies,\n                  including the End User Agreement, Privacy Policy, and\n                  the Terms and Conditions.","AcceptPolicyModal.Agree":"AGREE","AcceptPolicyModal.AgreeToOe":"AGREE TO OE POLICIES","AcceptPolicyModal.AreYouSure":"Are you sure you want to decline?","AcceptPolicyModal.ToUse":"To use the OE QuestMaker app, you must agree to these terms. Close this window to review the terms\n                  again, or click \"Agree to OE Policies\" to accept all of the terms now.","AcceptPolicyModal.ViewOurPolicies":"View our policies","AcceptPolicyModal.YesIAmDeclining":"YES, I AM DECLINING","Account.CurrentPasswordIsIncorrect":"Current password is incorrect.","Account.Minimum8Characters":"Minimum 8 characters","Account.YouUpdatedYourPassword":"You updated your password.","Activities":"Activities","Activity":"Activity","Activity.ActivityResources":"Activity Resources","Activity.AssessmentQuestions":"Assessment Questions for Mentors","Activity.Goals":"Activity Goals","Activity.NotesForMentors":"Notes for Mentors","Activity.RequiresArtifact":"Requires Artifact?","ActivityAdd.CreateActivity":"Create Activity","ActivityEdit.AddAFileToHelpMentors":"Add a file to help mentors with this activity","ActivityEdit.AddAnotherFile":"Add another file","ActivityEdit.AddResource":"Add Resource","ActivityEdit.ArtifactDescription":"Artifact Description","ActivityEdit.Checkpoint?":"Check-in?","ActivityEdit.DeleteMentorNote":"Delete this mentor note?","ActivityEdit.DeleteResource":"Delete this resource?","ActivityEdit.EditMentorFile":"Edit a File For Mentors","ActivityEdit.UploadAFile":"Upload a file","ActivityEdit.UploadFile":"Upload a file","ActivityEdit.UploadMentorFile":"Upload a File For Mentors","ActivityResource.AddResource":"Add Resource","ActivityResource.Credible":"Is this resource credible and high-quality? For more information on selecting good resources see the","ActivityResource.Description":"Resource Description","ActivityResource.EditResource":"Edit Resource","ActivityResource.ProvideCitation":"Provide a citation for this resource:","ActivityResource.ResourceFile":"Resource File","ActivityResource.Type":"Resource Type","ActivityTopics.Search.NoMatches":"No matches found","AddAComment":"Add A Comment","AfterTheInternalProcessIsComplete":"after the internal process is complete","Ago":"ago","Alert.NameCantBeBlank":"Name can't be blank.","Alert.QuestTitleTaken":"Quest title has already been taken.","Alert.StronglyRecommendArtifact":"We strongly recommend an Artifact activity also be a Check-in to ensure Learners get good feedback.","Alert.UnusualMaterialsLimit":"Unusual Materials cannot exceed 1000 characters.","AllQuestsAreEvaluated":"All quests are evaluated by the publication review team","Approve":"Approve","Approved":"Approved","AssignedThisQuest":"assigned this quest to","AssignedTo":"Assigned to","Assignment.AssignedReturned":"{user1} {assignedReturned} {user2}.","Assignment.AssignedThisQuestToYou":"assigned this quest to you.","AssignmentModal":"Collaborate on this quest by assigning it to someone in your learning community to review. You can still work on your quest while it's assigned to someone else.","AssignmentModal.AssignThisQuest":"Assign this Quest","AssignmentModal.AssignThisQuestTo":"Assign this quest to:","Attribution":"Attribution","Attribution.InsideOrg":"I or someone in my organization made this resource.","Attribution.OutsideOrg":"Someone outside my organization made this resource.","AttributionAndNoncommercial":"Attribution + Noncommercial","Authors":"Authors","AverageGradeLevel":"Average Grade Level","BasicInformation":"Basic Information","BeganThisReviewOn":"began this review on","BeginReview":"Begin Review","BelowToFind":"below to find out what this quest needs to move forward.","By":"by","Cancel":"Cancel","CancelReview":"Cancel Review","Citation":"Citation","ClickToHidePassword":"Click to hide password","ClickToShowPassword":"Click to show password","Comment":"Comment","Comment.CommentedOn":"commented on","Comment.MarkResolved":"Mark Resolved","Comment.Reopen":"Re-open","Comments":"Comments","Comments.HideComments":"{hide} {resolvedCount} {resolved} {comments}","Comments.ShowComments":"{show} {resolvedCount} {resolved} {comments}","Complete":"Complete","Copy":"Copy","CopyEditor":"Copy Editor","CopyrightHolder":"Copyright Holder","Day":"day","DayDateDisplay":"{val} {day}","Days":"days","Description":"Description","Descriptions.Copy":"Each quest must fulfill criteria for copy, such as proper use of grammar, spelling, and punctuation.","Descriptions.Experience":"Each quest must be engaging for the learner, incorporate varying learning strategies, and reflect the Quest Forward vision for quest design.","Descriptions.Subject":"Each quest must fulfill criteria for subject matter, including adequate coverage of applicable sub-topics and interdisciplinary content.","DesignedBy":"Designed by","Direct":"Direct","Draft":"Draft","DropdownValues.AllQuests":"All quests","DropdownValues.Draft":"Draft","DropdownValues.InQualityReview":"In Quality Review","DropdownValues.Published":"Published","DropdownValues.ReviewReturned":"Review Returned","EditQuest":"Edit Quest","Edited":"(edited)","Email":"Email","Experience":"Experience","ExperienceReview":"experience","ExternalReviewer":"External Reviewer","FieldRequired":"This field is required.","File":"File","FileDescription":"File Description","Final":"Final","Footer.copyright":"&copy; 2017 Opportunity Education. All rights reserved.","Footer.ourpolicies":"Our Policies","ForBestViewing":"For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb","ForgotPassword.DontWorry":"Don't worry, it happens to the best of us. Enter your email to receive a reset password link.","ForgotPassword.EmailPasswordLink":"Email Password Link","ForgotPassword.ForgotYourPassword":"Forgot your password?","ForgotPassword.IfTheEmailDoesNot":"If the email does not arrive soon, check your spam folder.","ForgotPassword.ItWasSentFrom":"It was sent from","ForgotPassword.ItWasSentFromOefngl":"{itWasSentFrom} {email}","ForgotPassword.PleaseCheckYourEmail":"Please check your email!","ForgotPassword.PleaseEnterValid":"Please enter a valid email address.","ForgotPassword.ReturnToLogin":"Return to Login","ForgotPassword.WeSentYouASecret":"We sent you a secret link to reset your password.","ForgotYourPassword":"Forgot your password?","Format":"Format","Header.AddQuest":"Add Quest","Header.HelpCenterText":"Troubleshooting, tips, and guidance for creating effective quests","Header.OurQuests":"Our Quests","Header.SignOut":"Sign Out","Hide":"Hide","HidePrevous":"Hide Previous","Home.MyQuests":"My Quests","Home.MyQuests.AssignedToMe":"Assigned to Me","Home.MyQuests.Drafts":"Draft","HourAbbr":"hr","HourDateDisplay":"{val} {hour}","HoursAbbr":"hrs","Images":"Images","InProgress":"In Progress","InQualityReview":"In Publication Review","Incomplete":"Incomplete","InternalReview":"Internal Review","InternalReview.ApprovedBy":"Approved by:","InternalReview.AssignThisQuest":"assign this quest","InternalReview.CompleteAllTheRequiredFields":"Complete all the required fields, then assign this quest to a reviewer in your organization for review.","InternalReview.IfYoureNotTheBestFit":"If you're not the best fit,","InternalReview.IsntReady":"This quest isn't ready for internal review yet.","InternalReview.QuestsNeedToBeReviewed":"Quests need to be reviewed by members of your organization for experience, subject matter, and quality of copy before they can move forward.","InternalReview.Then,TheQuest":"Then, the quest will be reviewed by Publication Reviewers to ensure it meets final quality standards.","InternalReview.ToADifferentReviewer":"to a different reviewer.","InternalReview.WhenThisQuest":"When this quest is ready for review, it will be evaluated by reviewers within its organization, using three types of criteria:","InternalReview.WhenYoureReadyForReview":"When you're ready for review, assign this quest to a reviewer in your organization. (Tip: you can assign this quest to a peer to get feedback at any time.)","InternalReview.WithQualityReview":"With Publication Review approval, the quest will be published in the Quest! app and will be available to learners and mentors.","InternalReviewInProgress":"Internal Review in Progress","InternalReviewer":"Internal Reviewer","JustFor":"Just For","Label.AssignedTo":"Assigned To","Label.Author":"Author","Label.AuthorOrganization":"Author Organization","Label.BasicInfo":"Basic Information","Label.BlankReview":"{reviewType} {review}","Label.Copy":"Copy","Label.Experience":"Experience","Label.ExperienceReview":"Experience","Label.Final":"Final","Label.Images":"Images","Label.OtherInfo":"Other Information","Label.PrimarySubject":"Primary Subject","Label.QuestReview":"Quest Review","Label.Review":"review","Label.Standards":"Standards","Label.StandardsReview":"Standards","Label.Status":"Status","Label.Subject":"Subject","Label.SubjectReview":"Subject","Label.Tags":"Tags","Label.TargetGradeLevel":"Target Grade","Label.TopicsAndStandards":"Topics & Standards","LastSaved":"Last saved on","License":"License","Link":"Link","Login.Oops!":"Oops! Your username or password was incorrect.","Login.WelcomeBack":"Welcome Back!","Match":"match","Matches":"matches","Mentors":"MENTORS","MinuteDateDisplay":"{val} {minute}","MinutesAbbr":"min","Modal.Body.IfYouCancel":"If you cancel now, your review will be deleted, so another reviewer can have a fresh start. However, any comments you left throughout the quest will remain. Are you sure you want to cancel?","Modal.Body.IfYouStop1":"If you stop this review, this quest will be revoked from the reviewer and returned to the","Modal.Body.IfYouStop2":"Draft","Modal.Body.IfYouStop3":"state. When it's submitted for review again, you will have to start the review process from the beginning.","Modal.Body.InternalReviewsDone":"Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.","Modal.Body.PassedAllReviews1":"This quest has passed all the necessary reviews. Tap","Modal.Body.PassedAllReviews2":"Publish","Modal.Body.PassedAllReviews3":"below to make it available to learners and mentors in Quest!.","Modal.Body.QuestNeedsEdits":"Thanks for your review! This quest needs edits, so it will be returned to the quest designer now.","Modal.Body.ThanksForYourReviewOE":"Thanks for your review! This quest will now return to the Publication Review queue so it can move into the final phase of review.","Modal.Body.ToEditThisQuest":"To edit this quest, a new draft version of the quest will be created for you to work on. The published version of the quest will remain in use by students and mentors. (If you need to remove the published version from circulation, please contact the Quest Forward team at,","Modal.Body.YoureLeaving":"You're leaving an area that you were editing. Are you sure you want to leave? If so, your unsaved work will be lost.","Modal.Body.questOneStepCloser":"Thanks! Your quest is one step closer to eager learners. It will now be reviewed by members of your organization for experience, subject, and copy.","Modal.Button.Cancel":"Cancel","Modal.Button.LeaveAnyway":"Leave anyway","Modal.Button.No":"No","Modal.Button.OK":"OK","Modal.Button.Publish":"Publish","Modal.Button.Yes":"Yes","Modal.Heading.AlmostDone":"Almost Done!","Modal.Heading.CancelReview":"Cancel your review?","Modal.Heading.ReadyForPublish":"Ready for Publishing","Modal.Heading.ReturningToQuestDesigner":"Returning to Quest Designer","Modal.Heading.ReviewInProgress":"Review in Progress","Modal.Heading.ThisQuestIsPublished":"This quest is published","Modal.Heading.Wait":"Wait! You're about to lose some work.","More":"more","MyQuests.MyQuests.AssignedToMe":"Assigned to Me","MyQuests.MyQuests.Drafts":"Draft","MyQuests.NewestAtTop":"NEWEST AT TOP","MyQuests.OldestAtTop":"OLDEST AT TOP","Name":"Name","NameCantBeBlank":"Name can't be blank","Need":"Need","Needs":"Needs","NeedsEdits":"Needs Edits","NewPassword":"New Password","Newest":"Newest","No":"No","NoAssignments":"No quests are assigned to you right now.","None":"None","OEReview":"Publication Review","OeReviewer":"Publication Reviewer","Ok":"OK","Older":"older","Optional":"Optional","OtherInformation":"Other Information","OtherQuests":"Other Quests","Password":"Password","PasswordsDoNotMatch":"Passwords do not match.","Photo":"Photo","Placeholder.ArtifactDescription":"Describe what learners will do and why and which skills and knowledge should be demonstrated.","Placeholder.EnterTitle":"Enter all or part of a quest title","Placeholder.GiveMentorsBackgroundInfo":"Give mentors some background information or tips for this quest","Placeholder.Http":"http://","Placeholder.SearchForTheQuest":"Search for the quest by name here","Placeholder.SelectAPeer":"Select a peer...","Placeholder.SelectAuthors":"Select authors","Placeholder.SelectColleagues":"Select colleagues","Placeholder.SelectGrades":"Select grades","Placeholder.SelectSubject":"Select subjects","Placeholder.SelectTags":"Select tags","Placeholder.TypeYourCitation":"Type your citation here.","Placeholder.TypeYourComment":"Type your comment here.","Placeholder.WriteThemAMessage":"Write them a message...","Placeholder.writeABriefDescriptionOfFile":"Write a brief description of this file (optional)","PleaseReadThe":"Please read the","Policies.Agree":"AGREE TO OE POLICIES","Policies.Decline":"DECLINE","Policies.OurPolicies":"Our Policies","Policies.ThankYouForYourInterest":"Thank you for your interest in our products and services. To use\n              our apps, you must agree to the terms below. Please read them\n              carefully and click \"Agree to OE Policies\" to confirm your\n              agreement to these terms.","PrimarySubject":"Primary Subject","Published":"Published","PublishedQuests.YouHaveNone":"You have no published quests yet. Keep working!","Publisher":"Publisher","QualityReview.AllQuestsAreEvaluated":"{allQuestsAreEvaluated} {afterTheInternalProcessIsComplete} {usingThe} {guidelines}","QualityReview.UponApproval":"Upon approval, the quest is published and released to the Quest! app.","Quest":"quest","Quest.Activity.AddActivity":"Add Activity","Quest.Activity.Checkpoint":"&nbsp;&nbsp;&nbsp;&nbsp;Check-in","Quest.Activity.DeleteActivity":"Are you sure you want to delete this activity?","Quest.Activity.FilesForMentors":"Files for Mentors","Quest.Activity.SortActivities":"Sort Activities","Quest.BasicInfo.DrivingQuestion":"Driving Question","Quest.BasicInfo.Editors":"Editors","Quest.BasicInfo.GroupQuest":"Group Quest?","Quest.Header.LastUpdated":"Last Updated","Quest.Images.ForBestViewingImage":"For best viewing, please use a square image (png format) no larger than 200x200 pixels and file size no larger than 500 kb","Quest.Images.QuestIcon":"Quest Icon","Quest.NoActivities.AddFirstActivity":"add the first activity","Quest.NoActivities.AtLeastTwoActivities":"At least one activity is required to publish your quest!","Quest.OtherInformation.CreativeCommonsLicense":"CREATIVE COMMONS LICENSE","Quest.OtherInformation.CreativeCommonsWebsite":"Creative Commons Website","Quest.OtherInformation.InspirationAndAdditionalCredits":"Inspiration And Additional Credits","Quest.OtherInformation.LicenseAndVersion":"License and Version","Quest.OtherInformation.MentionPeople":"Mention people or materials that have inspired this quest that you want to give credit to.","Quest.OtherInformation.UnusualMaterials":"Unusual Materials","Quest.RelatedQuest.Recommended":"Recommended","Quest.RelatedQuests.AddRelatedQuest":"Add Related Quest","Quest.RelatedQuests.AddRelatedQuests":"Add related quests. Mark them as 'recommended' if learners should do them prior to this quest. Mark them as 'You might also like...' if learners might want to do them after this quest.","Quest.RelatedQuests.NotRelated":"This quest is not related to any other quests.","Quest.Review.AssignmentArea.AssignThisQuestTo":"Assign this quest to...","Quest.Review.AssignmentArea.ReadyForFeedback?":"Ready for feedback?","Quest.Review.AssignmentsArea.AssignedTo":"Assigned to:","Quest.Review.PleaseRead":"{pleaseRead} {strong} {belowToFind}","Quest.Review.PreviousReviewsList.HidePrevious":"{hide} {val}","Quest.Review.PreviousReviewsList.OlderReviews":"{count} {older} {reviewType} {val}","Quest.Review.ReviewArea.OKBegin":"OK, Edit this Quest","Quest.Review.ReviewArea.ThisQuestHasNotReceived":"This quest has not received {reviewType} review yet.","Quest.Review.StatusText.AllTheRequiredFieldsAreComplete":"All the required fields are now complete.","Quest.Review.StatusText.CompleteAllRequired":"Complete all required fields, including at least 1 activity. You may also assign this quest to a peer to get early feedback.","Quest.Review.StatusText.CompleteAllTheRequiredFields":"Complete all required fields.","Quest.Review.StatusText.InternalReviewsAreComplete":"Internal reviews are complete. Onward!","Quest.Review.StatusText.MakeTheChangesYouDiscussed":"Make the changes you discussed with your Reviewer.","Quest.Review.StatusText.PublishedOn":"Published on","Quest.Review.StatusText.ThisQuestMovedOnToQuality":"This quest moved on to Quality Review on","Quest.Review.StatusText.ThisQuestNeedsEditsBefore":"This quest needs edits before it can move on.","Quest.Review.StatusText.WhatsNext":"What's next?","Quest.Review.StatusText.WhenReadyAssign":"When ready, assign this quest to a Reviewer.","Quest.Review.StatusText.WhenReadyAssignAgain":"When ready, assign this quest to a Reviewer again.","Quest.Review.ThisQuestDidNotPass":"This quest did not pass the required reviews and needs further changes.","Quest.ReviewBanner.StopReview":"Stop Review","Quest.Topics.TheList":"The list of subtopics are ones rolled up from the activities","QuestDesigner":"Quest Designer","QuestGoal":"Quest Goal","QuestQualityReviewGuidelines":"Quest Publication Review Guidelines","QuestReview":"Quest Review","Quests":"Quests","Quests.DesignANewQuest":"Design a New Quest","Quests.OrgsQuests":"{org}'s {quests}","Quests.QuestsFound":"{totalQuests} {quests} {match} {yourSearch}.","QuestsAdd.CreateQuest":"Create Quest","QuestsAdd.QuestTitle":"Quest Title","QuestsSearch.Status":"Status","Queue.LongestWait":"Longest Wait","Queue.NoQuests":"No quests assigned to you match this search.","Readability.CollegeOrUniversityGraduateOrAbove":"College or University Graduate or above","Readability.Indicator.Updating":"Update Scores","Readability.Negative":"Negative","Readability.Neutral":"Neutral","Readability.NeutralModeratelyNegative":"Neutral (Moderately Negative)","Readability.NeutralModeratelyPostive":"Neutral (Moderately Positive)","Readability.NeutralSlightlyNegative":"Neutral (Slightly Negative)","Readability.NeutralSlightlyPositive":"Neutral (Slightly Positive)","Readability.Positive":"Positive","Readability.PostsecondaryUndergraduateUniversity":"Postsecondary/Undergraduate University","Readability.PrimaryElementarySchool":"Primary/Elementary School","Readability.PrimaryMiddleSchool":"Primary/Middle School","Readability.SecondaryHighSchool":"Secondary/High School","Readability.Sentiment.Negative":"Negative","Readability.Sentiment.Positive":"Positive","Readability.Sentiment.Sentiment":"Sentiment","ReadabilityModal.LongestSentenceByWordCount":"Longest Sentence by Word Count","ReadabilityModal.Readability":"Readability","ReadabilityModal.ReadingTime":"Reading Time","Remove":"Remove","ResetPassword.PasswordChanged!":"Password changed!","ResetPassword.YouCanNow":"You can now use your new password to log in.","Resolved":"Resolved","ReturnedThisQuest":"returned this quest to","Review":"Review","ReviewCheckbox.NotYetApproved":"Not yet Approved","ReviewCheckox.AssignToAReviewer":"Assign to a Reviewer","ReviewQueue.Flagged":"We flagged this quest because you reviewed it in the past.","ReviewQueue.MenuItem":"{need} {filter} {review}","ReviewQueue.NoQuestsToReview":"No quests to review right now.","ReviewQueue.QuestsIn":"Quests in","ReviewReturned":"Review Returned","Reviewer":"Reviewer","Reviews":"Reviews","Round":"Round","Save":"Save","SaveFile":"Save File","Saved":"Saved","Search":"Search","Send":"Send","Show":"Show","SignIn":"Sign In","Since":"Since","SourceOfTheImage":"source of the image (url)","SpecificObjective":"Specific Objective","Standards":"Standards","StandardsReview":"standards","Subject":"Subject","SubjectReview":"subject","Submit":"Submit","SubmitForReview":"Submit for Review","SubmitForReviewAgain":"Submit for Review Again","Subtopics":"SUBTOPICS","Supplemental":"Supplemental","Tags":"Tags","TargetGradeLevel":"Target Grade","TargetedFor":"Targeted for","ThisDataIsNotCurrentlyAvailable":"This data is not currently available.","Title":"Title","ToQualityReviewModal.InternalReviewsAreDone":"Internal reviews are done! Your review was the last one needed from your organization. Now, the quest will move on to Publication Review.","ToQualityReviewModal.Next:QualityReview":"Next: Publication Review","Topics.NoQuestsLinkedYet":"No quests are linked to this subtopic yet.","Topics.NoTopicsExistYet":"No topics exist yet!","Topics.SelectATopicCloud":"Select A Topic Cloud","Topics.WhenOrgCreatesTopics":"When your organization creates topics that coordinate with quests, they'll appear here.","TopicsAndStandards":"Topics & Standards","URL":"URL","URLInvalid":"URL is invalid. Please ensure the URL contains either http:// or https://.","UnauthenticatedComponent.Copyright":"&copy; {year} Opportunity Education. All rights reserved.","UploadedFile":"Uploaded File","UsingThe":"using the","Version":"Version","VideoTypeWarning":"Videos must be .3gp, .mp4, .mkv, or .webm.","Waiting":"Waiting","Yes":"Yes","You":"You","YouMayAlsoLike":"You May Also Like...","YourSearch":"your search","YoureDone":"You're done!","on":"on"}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports = {"AcceptPolcicyModal.ByUsing":"Al usar la aplicación QuestMaker de OE, Ud. acepta nuestras políticas, incluyendo el Contrato de licencia de usuario, la Política de privacidad, y los Términos y condiciones.","AcceptPolicyModal.Agree":"ACEPTO","AcceptPolicyModal.AgreeToOe":"Acepto las políticas de OE","AcceptPolicyModal.AreYouSure":"¿Estás seguro de que no quieres aceptar?","AcceptPolicyModal.ToUse":"Para usar la aplicación QuestMaker, debe Ud. aceptar estos términos. Cierre esta ventanilla para volver a verlos, o haga clic en \"Acepto las políticas de OE\" para aceptar todos los términos ahora.","AcceptPolicyModal.ViewOurPolicies":"Ver nuestras políticas","AcceptPolicyModal.YesIAmDeclining":"NO ACEPTO","Account.CurrentPasswordIsIncorrect":"La contraseña actual está incorrecta.","Account.Minimum8Characters":"Mínimo de ocho caracteres","Account.YouUpdatedYourPassword":"Actualizó su contraseña.","Activities":" Actividades","Activity":" Actividad","Activity.ActivityResources":"Recursos de la Actividad","Activity.AssessmentQuestions":"Preguntas de evaluación para los tutores","Activity.Goals":"Objetivo de la actividad","Activity.NotesForMentors":"Notas para los tutores","Activity.RequiresArtifact":"¿SE REQUIERE UN PRODUCTO DE TRABAJO?","ActivityAdd.CreateActivity":"Crear actividad","ActivityEdit.AddAFileToHelpMentors":"Añada un archivo para ayudarles a los tutores con esta actividad.","ActivityEdit.AddAnotherFile":"Añadir otro archivo.","ActivityEdit.AddResource":"Añadir un recurso","ActivityEdit.ArtifactDescription":"Descripción del producto de trabajo","ActivityEdit.Checkpoint?":"¿Punto para conversar?","ActivityEdit.DeleteMentorNote":"¿Borrar esta nota para tutores?","ActivityEdit.DeleteResource":"¿Borrar este recurso?","ActivityEdit.EditMentorFile":"Editar un archivo para los tutores","ActivityEdit.UploadAFile":"Subir un archivo","ActivityEdit.UploadFile":"Subir un archivo","ActivityEdit.UploadMentorFile":"Subir un archivo para los tutores","ActivityResource.AddResource":"Añadir un recurso","ActivityResource.Credible":"¿Es verídico y de alta calidad este recurso? Para más información acerca de cómo seleccionar buenos recursos mire el ","ActivityResource.Description":"Descripción del Recurso","ActivityResource.EditResource":"Editar Recurso","ActivityResource.ProvideCitation":"Citar este recurso:","ActivityResource.ResourceFile":"El Archivo del Recurso","ActivityResource.Type":"Tipo de Recurso","ActivityTopics.Search.NoMatches":"No se encontraron resultados.","AddAComment":"Agregar un comentario","AfterTheInternalProcessIsComplete":"después del proceso de revisión interna","Ago":"hace","Alert.NameCantBeBlank":"El nombre no puede estar en blanco.","Alert.QuestTitleTaken":"Ya existe un quest con este nombre.","Alert.StronglyRecommendArtifact":"Recomendamos que una actividad con producto de trabajo sea también un punto para conversar para asegurar que los estudiantes reciban buena retroalimentación.","Alert.UnusualMaterialsLimit":"Los materiales inusuales no pueden exceder 1000 caracteres.","AllQuestsAreEvaluated":"Todos los quests son evaluados por el equipo de revisión de calidad","Approve":"Aprobar","Approved":"Aprobado","AssignedThisQuest":"le asignó este quest a","AssignedTo":"Asignado a","Assignment.AssignedReturned":"{user} {assignedReturned} {you}.","Assignment.AssignedThisQuestToYou":"le asignó este quest.","AssignmentModal":"Colabore con alguien de su organización en este quest. Asígneselo a alguien para que lo revise, y aún podrá trabajar en el quest mientras que esté asignado a alguien más.","AssignmentModal.AssignThisQuest":"Asignar este quest","AssignmentModal.AssignThisQuestTo":"Asignar este quest a:","Attribution":"Reconocimiento","Attribution.InsideOrg":"Yo creé o alguien de mi organización creó este recurso.","Attribution.OutsideOrg":"Alguien que no es de mi organización creó este recurso.","AttributionAndNoncommercial":"Reconocimiento + NoComercial","Authors":"Autores","AverageGradeLevel":"Average Grade Level","BasicInformation":"Información Básica","BeganThisReviewOn":"empezó a revisar este quest el","BeginReview":"Empezar Revisione","BelowToFind":"para ver qué cambios necesita este quest para seguir adelante.","By":"por","Cancel":"Cancelar","CancelReview":"Cancelar Revisión","Citation":"Cita","ClickToHidePassword":"Ocultar contraseña","ClickToShowPassword":"Mostrar contraseña","Comment":"Comentario","Comment.CommentedOn":"comentar sobre","Comment.MarkResolved":"Marcar como resuelto","Comment.Reopen":"Reabrir","Comments":"Comentarios","Comments.HideComments":"{hide} {resolvedCount} {comments} {resolved}","Comments.ShowComments":"{show} {resolvedCount} {comments} {resolved}","Complete":"Completo","Copy":"Editorial","CopyEditor":"Editor de copia","CopyrightHolder":"Derechos de autor","Day":"día","DayDateDisplay":"{val} {day}","Days":"días","Description":"Descripción","Descriptions.Copy":"Cada quest debe cumplir con criterios de gramática, ortografía, sintaxis, y puntuación.","Descriptions.Experience":"Cada quest debe ser una experiencia interactiva para el estudiante, usando los Principios de NGL y varias estrategias de aprendizaje. Lea los principios aquí.","Descriptions.Subject":"Cada quest debe cumplir con criterios de temática, incluyendo una cobertura adecuada de los subtemas y de contenido interdisciplinario.","DesignedBy":"Diseñado por","Direct":"Directo","Draft":"Borrador","DropdownValues.AllQuests":"Todos","DropdownValues.Draft":"Borrador","DropdownValues.InQualityReview":"En revisión de calidad","DropdownValues.Published":"Publicado","DropdownValues.ReviewReturned":"Revisión devuelta","EditQuest":"Editar Quest","Edited":"(editado)","Email":"Correo electrónico","Experience":"Experiencia","ExperienceReview":"de experiencia","ExternalReviewer":"Revisor externo","FieldRequired":"Este campo es obligatorio.","File":"Archivo","FileDescription":"Descripción del archivo","Final":"Final","Footer.copyright":"&copy; 2017 Opportunity Education. Todos los derechos reservados.","Footer.ourpolicies":"Nuestras Políticas","ForBestViewing":"Para una mejor calidad de imagen, suba una imagen cuadrada (formato png) cuyas dimensiones no sean más de 200x200 píxeles y cuyo tamaño como archivo sea menos de 500 kb.","ForgotPassword.DontWorry":"No se preocupe, nos pasa a todos. Ingrese su correo para recibir un enlace para restablecer su contraseña.","ForgotPassword.EmailPasswordLink":"Mandar enlace para la contraseña","ForgotPassword.ForgotYourPassword":"¿Se le olvidó su contraseña?","ForgotPassword.IfTheEmailDoesNot":"Si el correo no llega pronto, cheque su correo no deseado.","ForgotPassword.ItWasSentFrom":"Fue mandado por","ForgotPassword.ItWasSentFromOefngl":"{itWasSentFrom} {email}","ForgotPassword.Oops":"En este momento no podemos cambiar su contraseña.","ForgotPassword.PleaseCheckYourEmail":"¡Por favor cheque su correo!","ForgotPassword.PleaseEnterValid":"Favor de ingresar un correo electrónico válido.","ForgotPassword.PleaseTryAgain":"Por favor vuelva a intentar.","ForgotPassword.ReturnToLogin":"Regresar a la página de ingreso","ForgotPassword.SomethingWentWrong":"Hubo un error en cambiar su contraseña.","ForgotPassword.TryAgain":"Vuelva a intentar","ForgotPassword.WeSentYouASecret":"Le mandamos un enlace secreto a su correo para que reestablezca su contraseña.","ForgotYourPassword":"¿Olvidaste tu contraseña?","Format":"Formato","Header.AddQuest":"Crear un quest","Header.AllQuests":"Todos Quests","Header.HelpCenterText":"Solución de problemas, sugerencias, y guías para crear quests y viajes efectivos","Header.MyQuests":"My Quests","Header.OurQuests":"Nuestros quests","Header.ProductionStatus":"Production Status","Header.Queue":"Índice","Header.Reviews":"Revisiones","Header.SignOut":"Cerrar sesión","Header.Topics":"Temas","Hide":"Ocultar","HidePrevous":"Ocultar anteriores","Home.MyQuests":"My Quests","Home.MyQuests.AssignedToMe":"Assigned to Me","Home.MyQuests.Drafts":"Draft","HourAbbr":"hr","HourDateDisplay":"{val} {hour}","HoursAbbr":"hrs","Images":"Imágenes","InProgress":"En progreso","InQualityReview":"En revisión de calidad","Incomplete":"Incompleto","InternalReview":"Revisión Interna","InternalReview.ApprovedBy":"Aprobado por:","InternalReview.AssignThisQuest":"asignar el quest","InternalReview.CompleteAllTheRequiredFields":"Complete todos los campos requeridos y luego asigne el quest a un evaluador interno dentro de su organización.","InternalReview.IfYoureNotTheBestFit":"Ud. puede","InternalReview.IsntReady":"Este quest aún no está listo para revisión interna.","InternalReview.QuestsNeedToBeReviewed":"Los quests deben ser evaluados por miembros de su organización en las áreas de experiencia, temática, y gramática.","InternalReview.Then,TheQuest":"Then, the quest will be reviewed by Quality Reviewers to ensure it meets final acceptability guidelines and quality standards.","InternalReview.ToADifferentReviewer":" a otro evaluador si es necesario.","InternalReview.WhenThisQuest":"Cuando este quest esté listo para revisiones, será evaluado por miembros dentro de la misma organización usando tres criterios:","InternalReview.WhenYoureReadyForReview":"Cuando esté listo para las evaluaciones, asigne el quest a un evaluador de su organización. (Puede asignar el quest a un colega para recibir retroalimentación en cualquier momento.)","InternalReview.WithQualityReview":"Con la aprobación de la Revisión de Calidad, el quest será publicado en la aplicación Quest!™ y se hará disponible para los estudiantes y tutores.","InternalReviewInProgress":"Revisión Interna en Progreso","InternalReviewer":"Evaluador/a interno/a","JustFor":"Sólo para","Label.AssignedTo":"Asignado a","Label.Author":"Autor","Label.AuthorOrganization":"Organización Autora","Label.BasicInfo":"Información Básica","Label.BlankReview":"{review} {reviewType}","Label.Copy":"editorial","Label.Experience":"experiencia","Label.ExperienceReview":"de experiencia","Label.Final":"final","Label.Images":"Imágenes","Label.OtherInfo":"Otra Información","Label.PrimarySubject":"Tema principal","Label.QuestReview":"Revisión de Quest","Label.Review":"revisión","Label.Standards":"estándares","Label.StandardsReview":"de estándares","Label.Status":"Estatus","Label.Subject":"temática","Label.SubjectReview":"de temática","Label.Tags":"Etiquetas","Label.TargetGradeLevel":"Grado Escolar","Label.TopicsAndStandards":"Temas y Estándares","LastSaved":"Guardado el","License":"Licencia","Link":"Enlace","Login.Oops!":"¡Uy! Su usuario o contraseña está incorrecta.","Login.WelcomeBack":"¡Hola!","Match":"coincide","Matches":"coinciden","Mentors":"TUTORES","MinuteDateDisplay":"{val} {minute}","MinutesAbbr":"min","Modal.Body.IfYouCancel":"Si cancela ahora, su revisión se borrará para que otro/a evaluador/a pueda empezar de nuevo. Sin embargo, cualquier comentario que haya dejado en el quest permanecerá. ¿Seguro/a de que quiere cancelar su revisión?","Modal.Body.IfYouStop1":"Si detiene esta revisión, el quest será revocado y regresará al estado de","Modal.Body.IfYouStop2":"Borrador.","Modal.Body.IfYouStop3":"Cuando se vuelva a someter a revisión, tendrá Ud. que empezar el proceso de revisión desde el principio.","Modal.Body.InternalReviewsDone":"¡Se terminaron las revisiones internas! Su revisión era la última de su organización que se necesitaba. Ahora, el quest continuará a la revisión final de Calidad.","Modal.Body.PassedAllReviews1":"Este quest ha pasado todas las etapas de revisión necesarias. Toque","Modal.Body.PassedAllReviews2":"Publicar","Modal.Body.PassedAllReviews3":"para hacerlo disponible a los alumnos y tutores en la aplicación Quest!.","Modal.Body.QuestNeedsEdits":"¡Gracias por su revisión! Este quest necesita ser editado, así que ahora regresará al autor.","Modal.Body.ThanksForYourReviewOE":"¡Gracias por su revisión! Ahora regresará el quest a la lista de espera para que pueda continuar a la etapa final de revisiones.","Modal.Body.ToEditThisQuest":"Para editar este quest, se creará una versión borrador que Ud. podrá editar. \nLa versión publicada del quest permanecerá en el catálogo para estudiantes y tutores. \n(Si necesita retirar la versión publicada,  \nfavor de mandar un correo al equipo de NGL: ","Modal.Body.YoureLeaving":"Está por salir de un area que estaba editando. ¿Está seguro de que se quiere salir? Su trabajo sin guardar se perderá.","Modal.Body.questOneStepCloser":"¡Gracias! Su quest se va acercando a estudiantes ansiosos por aprender. Ahora lo revisarán miembros de su organización para evaluar la experiencia, temática, y editorial.","Modal.Button.Cancel":"Cancelar","Modal.Button.LeaveAnyway":"Sí, me quiero salir","Modal.Button.No":"No","Modal.Button.OK":"OK","Modal.Button.Publish":"Publicar","Modal.Button.Yes":"Sí","Modal.Heading.AlmostDone":"¡Casi termina!","Modal.Heading.CancelReview":"¿Cancelar su revisión?","Modal.Heading.ReadyForPublish":"Listo para publicar","Modal.Heading.ReturningToQuestDesigner":"Regresando al/ a la autor/a del quest.","Modal.Heading.ReviewInProgress":"Revisión en progreso","Modal.Heading.ThisQuestIsPublished":"Este quest está publicado","Modal.Heading.Wait":"¡Espere! Está a punto de perder su trabajo.","More":"más","MyQuests.MyQuests.AssignedToMe":"Assigned to Me","MyQuests.MyQuests.Drafts":"Draft","MyQuests.NewestAtTop":"NEWEST AT TOP","MyQuests.OldestAtTop":"OLDEST AT TOP","Name":"Recurso","NameCantBeBlank":"El nombre no puede estar en blanco.","Need":"Necesitan","Needs":"Necesita","NeedsEdits":"Ser Editado","NewPassword":"Nueva contraseña","Newest":"Más reciente","No":"No","NoAssignments":"No quests are assigned to you right now.","None":"Ninguna","OEReview":"Revisión de Calidad","OeReviewer":"Evaluador/a de Calidad","Ok":"OK","Older":"anteriores","Optional":"Opcional","OtherInformation":"Otra Información","OtherQuests":"Otros Quests","Password":"Contraseña","PasswordsDoNotMatch":"Passwords do not match.","Photo":"Foto","Placeholder.ArtifactDescription":"Describa lo que harán los estudiantes y por qué, y cuáles habilidades y conocimientos deberían demostrar aquí.","Placeholder.EnterTitle":"Escriba el nombre de un quest","Placeholder.GiveMentorsBackgroundInfo":"De información contextual o pistas para ayudar al tutor con este quest","Placeholder.Http":"http://","Placeholder.SearchForTheQuest":"Busque el quest usando el nombre del quest aquí","Placeholder.SelectAPeer":"Seleccione un(a) colega...","Placeholder.SelectAuthors":"Seleccionar autores","Placeholder.SelectColleagues":"Seleccionar colegas","Placeholder.SelectGrades":"Seleccionar años escolares","Placeholder.SelectSubject":"Seleccionar temas","Placeholder.SelectTags":"Seleccionar etiquetas","Placeholder.TypeYourCitation":"Escriba aquí la cita.","Placeholder.TypeYourComment":"Escriba aquí su comentario.","Placeholder.WriteThemAMessage":"Escríbale un mensaje...","Placeholder.writeABriefDescriptionOfFile":"Escriba una breve descripción de este archivo (opcional)","PleaseReadThe":"Favor de leer ","Policies.Agree":"Acepto las políticas de OE","Policies.Decline":"NO ACEPTO","Policies.OurPolicies":"Nuestras Políticas","Policies.ThankYouForYourInterest":"Gracias por tu interés en nuestros productos y servicios. Para usar nuestras aplicaciones, debes aceptar los términos indicados aquí. Favor de leerlos y hacer click o tocar 'Acepto' para confirmar que aceptas los términos.","PrimarySubject":"Tema principal","Published":"Publicado","PublishedQuests.YouHaveNone":"You have no published quests yet. Keep working!","Publisher":"Editor/a","QualityReview.AllQuestsAreEvaluated":"{allQuestsAreEvaluated} {usingThe} {guidelines}, {afterTheInternalProcessIsComplete}","QualityReview.UponApproval":"Una vez aprobados, los quests son publicados y aparecen en la aplicación Quest!.","Quest":"quest","Quest.Activity.AddActivity":"Añadir una Actividad","Quest.Activity.Checkpoint":"&nbsp;&nbsp;&nbsp;&nbsp;Punto para conversar","Quest.Activity.DeleteActivity":"¿Está seguro/a de que quiere borrar esta actividad?","Quest.Activity.FilesForMentors":"Archivos para tutores","Quest.Activity.SortActivities":"Ordenar las Actividades","Quest.BasicInfo.DrivingQuestion":"Pregunta guía","Quest.BasicInfo.Editors":"Editores","Quest.BasicInfo.GroupQuest":"¿Quest grupal?","Quest.Header.LastUpdated":"Última actualización","Quest.Images.ForBestViewingImage":"Para una mejor calidad de imagen, suba una imagen cuadrada (formato png) cuyas dimensiones no sean más de 200x200 píxeles y cuyo tamaño como archivo sea menos de 500 kb.","Quest.Images.QuestIcon":"Foto del quest","Quest.NoActivities.AddFirstActivity":"agregue la prima actividad","Quest.NoActivities.AtLeastTwoActivities":"Se requieren por lo menos dos actividades para publicar el quest.","Quest.OtherInformation.CreativeCommonsLicense":"CREATIVE COMMONS LICENSE","Quest.OtherInformation.CreativeCommonsWebsite":"sitio web de Creative Commons","Quest.OtherInformation.InspirationAndAdditionalCredits":"Inspiración y créditos adicionales","Quest.OtherInformation.LicenseAndVersion":"Licencia + Versión","Quest.OtherInformation.MentionPeople":"Si hay personas o materiales que han inspirado este quest y a las que quiere acreditar, menciónelas aquí.","Quest.OtherInformation.UnusualMaterials":"Materiales inusuales","Quest.RelatedQuest.Recommended":"Recomendado","Quest.RelatedQuests.AddRelatedQuest":"Añadir un Quest Relacionado","Quest.RelatedQuests.AddRelatedQuests":"Añadir quests relacionados. Márquelos como ‘recomendado’ si los estudiantes los deben hacer antes de este quest y como ‘también te puede gustar...' si los estudiantes los pueden hacer después.","Quest.RelatedQuests.NotRelated":"Este quest no está relacionado con ningún otro quest.","Quest.Review.AssignmentArea.AssignThisQuestTo":"Asignar este quest a...","Quest.Review.AssignmentArea.ReadyForFeedback?":"¿Listo/a para retroalimentación?","Quest.Review.AssignmentsArea.AssignedTo":"Asignado a:","Quest.Review.PleaseRead":"{pleaseRead} {strong} {belowToFind}","Quest.Review.PreviousReviewsList.HidePrevious":"Ocultar anteriores","Quest.Review.PreviousReviewsList.OlderReviews":"{count} {older} {val} {reviewType}","Quest.Review.ReviewArea.OKBegin":"OK, editar este quest","Quest.Review.ReviewArea.ThisQuestHasNotReceived":"Este quest no ha sido evaluado para la revisión {reviewType}.","Quest.Review.StatusText.AllTheRequiredFieldsAreComplete":"Todos los campos requeridos están completos.","Quest.Review.StatusText.CompleteAllRequired":"Complete todos los campos requeridos y luego asigne el quest a un evaluador interno dentro de su organización.","Quest.Review.StatusText.CompleteAllTheRequiredFields":"Complete todos los campos requeridos.","Quest.Review.StatusText.InternalReviewsAreComplete":"Las revisiones internas están completas. ¡Adelante!","Quest.Review.StatusText.MakeTheChangesYouDiscussed":"Haga los cambios que discutió con su evaluador/a.","Quest.Review.StatusText.PublishedOn":"Publicado el","Quest.Review.StatusText.ThisQuestMovedOnToQuality":"Este quest pasó a la Revisión de Calidad el","Quest.Review.StatusText.ThisQuestNeedsEditsBefore":"Este quest necesita ser editado antes de que pueda continuar.","Quest.Review.StatusText.WhatsNext":"¿Qué sigue?","Quest.Review.StatusText.WhenReadyAssign":"Cuando esté listo, asigne este quest a un/a evaluador/a.","Quest.Review.StatusText.WhenReadyAssignAgain":"Cuando esté listo, asigne este quest a un/a evaluador/a de nuevo.","Quest.Review.ThisQuestDidNotPass":"Este quest no pasó las etapas requeridas de revisión y necesita algunos cambios.","Quest.ReviewBanner.StopReview":"Detener revisión","Quest.Topics.TheList":"Los subtemas en esta lista vienen de las actividades de los quests.","QuestDesigner":"Diseñador/a de quests","QuestGoal":"Quest Goal","QuestQualityReviewGuidelines":"Guía de Revisión de Calidad","QuestReview":"Revisión de Quest","Quests":"Quests","Quests.DesignANewQuest":"Diseñar un nuevo quest.","Quests.OrgsQuests":"{quests} de {org}","Quests.QuestsFound":"{totalQuests} {questsFound}","QuestsAdd.CreateQuest":"Crear quest","QuestsAdd.QuestTitle":"Título del quest","QuestsSearch.Status":"Estatus","Queue.LongestWait":"Espera más larga","Queue.NoQuests":"Ningún quest asignado a Ud. cumple con esta búsqueda.","Readability.CollegeOrUniversityGraduateOrAbove":"College or University Graduate or above","Readability.Indicator.Updating":"Update Scores","Readability.Negative":"Negative","Readability.Neutral":"Neutral","Readability.NeutralModeratelyNegative":"Neutral (Moderately Negative)","Readability.NeutralModeratelyPostive":"Neutral (Moderately Positive)","Readability.NeutralSlightlyNegative":"Neutral (Slightly Negative)","Readability.NeutralSlightlyPositive":"Neutral (Slightly Positive)","Readability.Positive":"Positive","Readability.PostsecondaryUndergraduateUniversity":"Postsecondary/Undergraduate University","Readability.PrimaryElementarySchool":"Primary/Elementary School","Readability.PrimaryMiddleSchool":"Primary/Middle School","Readability.SecondaryHighSchool":"Secondary/High School","Readability.Sentiment.Negative":"Negative","Readability.Sentiment.Positive":"Positive","Readability.Sentiment.Sentiment":"Sentiment","ReadabilityModal.LongestSentenceByWordCount":"Longest Sentence by Word Count","ReadabilityModal.Readability":"Readability","ReadabilityModal.ReadingTime":"Reading Time","Remove":"Quitar","ResetPassword.Create":"Cree una nueva contraseña","ResetPassword.PasswordChanged!":"¡Contraseña cambiada!","ResetPassword.YouCanNow":"Ahora puede usar su nueva contraseña para ingresar.","ResetPassword.YourPasswordMust":"Su contraseña debe contener por lo menos 8 caracteres.","Resolved":"Resuelto","ReturnedThisQuest":"regresó este quest a","Review":"revisión","ReviewCheckbox.NotYetApproved":"Aún no ha sido aprobado","ReviewCheckox.AssignToAReviewer":"Asignar a un/a evaluador/a","ReviewQueue.Flagged":"Marcamos este quest porque Ud. lo revisó previamente.","ReviewQueue.MenuItem":"{need} {review} {filter}","ReviewQueue.NoQuestsToReview":"No hay quests esperando revisión por ahora.","ReviewQueue.QuestsIn":"Quests en","ReviewReturned":"Revisión devuelta","Reviewer":"Evaluador/a","Reviews":"Revisiones","Round":"Ronda","Save":"Guardar","SaveFile":"Guardar","Saved":"¡Guardado!","Search":"Buscar","Send":"Mandar","Show":"Mostrar mas","SignIn":"Iniciar Sesión","Since":"desde","SourceOfTheImage":"fuente de la imagen (enlace)","SpecificObjective":"Specific Objective","Standards":"Estándares","StandardsReview":"de estándares","Subject":"Temática","SubjectReview":"temática","Submit":"Someter","SubmitForReview":"Someter a revisión","SubmitForReviewAgain":"Someter a revisión de nuevo","Subtopics":"SUBTEMAS","Supplemental":"Suplementario","Tags":"Etiquetas","TargetGradeLevel":"Grado escolar","TargetedFor":"Grado escolar:","ThisDataIsNotCurrentlyAvailable":"This data is not currently available.","Title":"Título","ToQualityReviewModal.InternalReviewsAreDone":"¡Se terminaron las revisiones internas! Su revisión era la última de su organización que se necesitaba. Ahora, el quest continuará a la revisión de calidad.","ToQualityReviewModal.Next:QualityReview":"Siguiente etapa: Revisión de Calidad","Topics.NoQuestsLinkedYet":"Todavía no hay quests vinculados a este subtema.","Topics.NoTopicsExistYet":"¡Todavía no existen temas!","Topics.SelectATopicCloud":"Seleccione una nube temática","Topics.WhenOrgCreatesTopics":"Cuando su organización cree temas coordinados con quests, aparecerán aquí.","TopicsAndStandards":"Temas y estándares","URL":"Enlace","URLInvalid":"El enlace no es válido. Favor de asegurar que el enlace contenga o http:// o https://.","UnauthenticatedComponent.Copyright":"&copy; {year} Opportunity Education. Todos los derechos reservados.","UploadedFile":"Cargar un archivo","UsingThe":"usando la","Version":"Versión","VideoTypeWarning":"El formato del video debe ser .3gp, .mp4, .mkv, o .webm","Waiting":"Esperando","Yes":"Sí","You":"Ud.","YouMayAlsoLike":"También te puede gustar...","YourSearch":"con su búsqueda","YoureDone":"¡Listo!","on":"el"}

/***/ })
],[731]);


// WEBPACK FOOTER //
// main.f9172cb09c9325e71c39.js